import * as React$37 from 'react';
import React__default$4, { useContext, forwardRef, useCallback, useState, useRef, useEffect, useMemo } from 'react';
import require$$11 from 'react/jsx-runtime';
import require$$2$1 from 'react-dom';
import { useHistory, useRouteMatch, Route, Switch as Switch$4 } from 'react-router-dom';
import { RichUtils, Editor as Editor$5, ContentBlock, genKey, ContentState, EditorState } from 'draft-js';
import 'draft-js/dist/Draft.css';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$2(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __awaiter$2(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var Accordion$3 = {};

var interopRequireDefault$1 = {exports: {}};

(function (module) {
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(interopRequireDefault$1));

var Accordion$2 = {};

var _extends$19 = {exports: {}};

(function (module) {
function _extends() {
  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(_extends$19));

var objectWithoutPropertiesLoose = {exports: {}};

(function (module) {
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(objectWithoutPropertiesLoose));

var reactIs$6 = {exports: {}};

var reactIs_production$1 = {};

/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var REACT_ELEMENT_TYPE$1 = Symbol.for("react.transitional.element"),
  REACT_PORTAL_TYPE$1 = Symbol.for("react.portal"),
  REACT_FRAGMENT_TYPE$1 = Symbol.for("react.fragment"),
  REACT_STRICT_MODE_TYPE$1 = Symbol.for("react.strict_mode"),
  REACT_PROFILER_TYPE$1 = Symbol.for("react.profiler"),
  REACT_CONSUMER_TYPE$1 = Symbol.for("react.consumer"),
  REACT_CONTEXT_TYPE$1 = Symbol.for("react.context"),
  REACT_FORWARD_REF_TYPE$1 = Symbol.for("react.forward_ref"),
  REACT_SUSPENSE_TYPE$1 = Symbol.for("react.suspense"),
  REACT_SUSPENSE_LIST_TYPE$1 = Symbol.for("react.suspense_list"),
  REACT_MEMO_TYPE$1 = Symbol.for("react.memo"),
  REACT_LAZY_TYPE$1 = Symbol.for("react.lazy"),
  REACT_VIEW_TRANSITION_TYPE$1 = Symbol.for("react.view_transition"),
  REACT_CLIENT_REFERENCE$1 = Symbol.for("react.client.reference");
function typeOf$2(object) {
  if ("object" === typeof object && null !== object) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE$1:
        switch (((object = object.type), object)) {
          case REACT_FRAGMENT_TYPE$1:
          case REACT_PROFILER_TYPE$1:
          case REACT_STRICT_MODE_TYPE$1:
          case REACT_SUSPENSE_TYPE$1:
          case REACT_SUSPENSE_LIST_TYPE$1:
          case REACT_VIEW_TRANSITION_TYPE$1:
            return object;
          default:
            switch (((object = object && object.$$typeof), object)) {
              case REACT_CONTEXT_TYPE$1:
              case REACT_FORWARD_REF_TYPE$1:
              case REACT_LAZY_TYPE$1:
              case REACT_MEMO_TYPE$1:
                return object;
              case REACT_CONSUMER_TYPE$1:
                return object;
              default:
                return $$typeof;
            }
        }
      case REACT_PORTAL_TYPE$1:
        return $$typeof;
    }
  }
}
reactIs_production$1.ContextConsumer = REACT_CONSUMER_TYPE$1;
reactIs_production$1.ContextProvider = REACT_CONTEXT_TYPE$1;
reactIs_production$1.Element = REACT_ELEMENT_TYPE$1;
reactIs_production$1.ForwardRef = REACT_FORWARD_REF_TYPE$1;
reactIs_production$1.Fragment = REACT_FRAGMENT_TYPE$1;
reactIs_production$1.Lazy = REACT_LAZY_TYPE$1;
reactIs_production$1.Memo = REACT_MEMO_TYPE$1;
reactIs_production$1.Portal = REACT_PORTAL_TYPE$1;
reactIs_production$1.Profiler = REACT_PROFILER_TYPE$1;
reactIs_production$1.StrictMode = REACT_STRICT_MODE_TYPE$1;
reactIs_production$1.Suspense = REACT_SUSPENSE_TYPE$1;
reactIs_production$1.SuspenseList = REACT_SUSPENSE_LIST_TYPE$1;
reactIs_production$1.isContextConsumer = function (object) {
  return typeOf$2(object) === REACT_CONSUMER_TYPE$1;
};
reactIs_production$1.isContextProvider = function (object) {
  return typeOf$2(object) === REACT_CONTEXT_TYPE$1;
};
reactIs_production$1.isElement = function (object) {
  return (
    "object" === typeof object &&
    null !== object &&
    object.$$typeof === REACT_ELEMENT_TYPE$1
  );
};
reactIs_production$1.isForwardRef = function (object) {
  return typeOf$2(object) === REACT_FORWARD_REF_TYPE$1;
};
reactIs_production$1.isFragment = function (object) {
  return typeOf$2(object) === REACT_FRAGMENT_TYPE$1;
};
reactIs_production$1.isLazy = function (object) {
  return typeOf$2(object) === REACT_LAZY_TYPE$1;
};
reactIs_production$1.isMemo = function (object) {
  return typeOf$2(object) === REACT_MEMO_TYPE$1;
};
reactIs_production$1.isPortal = function (object) {
  return typeOf$2(object) === REACT_PORTAL_TYPE$1;
};
reactIs_production$1.isProfiler = function (object) {
  return typeOf$2(object) === REACT_PROFILER_TYPE$1;
};
reactIs_production$1.isStrictMode = function (object) {
  return typeOf$2(object) === REACT_STRICT_MODE_TYPE$1;
};
reactIs_production$1.isSuspense = function (object) {
  return typeOf$2(object) === REACT_SUSPENSE_TYPE$1;
};
reactIs_production$1.isSuspenseList = function (object) {
  return typeOf$2(object) === REACT_SUSPENSE_LIST_TYPE$1;
};
reactIs_production$1.isValidElementType = function (type) {
  return "string" === typeof type ||
    "function" === typeof type ||
    type === REACT_FRAGMENT_TYPE$1 ||
    type === REACT_PROFILER_TYPE$1 ||
    type === REACT_STRICT_MODE_TYPE$1 ||
    type === REACT_SUSPENSE_TYPE$1 ||
    type === REACT_SUSPENSE_LIST_TYPE$1 ||
    ("object" === typeof type &&
      null !== type &&
      (type.$$typeof === REACT_LAZY_TYPE$1 ||
        type.$$typeof === REACT_MEMO_TYPE$1 ||
        type.$$typeof === REACT_CONTEXT_TYPE$1 ||
        type.$$typeof === REACT_CONSUMER_TYPE$1 ||
        type.$$typeof === REACT_FORWARD_REF_TYPE$1 ||
        type.$$typeof === REACT_CLIENT_REFERENCE$1 ||
        void 0 !== type.getModuleId))
    ? !0
    : !1;
};
reactIs_production$1.typeOf = typeOf$2;

var reactIs_development$5 = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" !== process.env.NODE_ENV &&
  (function () {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (((object = object.type), object)) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
              case REACT_VIEW_TRANSITION_TYPE:
                return object;
              default:
                switch (((object = object && object.$$typeof), object)) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
      REACT_PORTAL_TYPE = Symbol.for("react.portal"),
      REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
      REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
      REACT_PROFILER_TYPE = Symbol.for("react.profiler"),
      REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
      REACT_CONTEXT_TYPE = Symbol.for("react.context"),
      REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
      REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
      REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
      REACT_MEMO_TYPE = Symbol.for("react.memo"),
      REACT_LAZY_TYPE = Symbol.for("react.lazy"),
      REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"),
      REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    reactIs_development$5.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development$5.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development$5.Element = REACT_ELEMENT_TYPE;
    reactIs_development$5.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development$5.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development$5.Lazy = REACT_LAZY_TYPE;
    reactIs_development$5.Memo = REACT_MEMO_TYPE;
    reactIs_development$5.Portal = REACT_PORTAL_TYPE;
    reactIs_development$5.Profiler = REACT_PROFILER_TYPE;
    reactIs_development$5.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development$5.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development$5.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development$5.isContextConsumer = function (object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development$5.isContextProvider = function (object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development$5.isElement = function (object) {
      return (
        "object" === typeof object &&
        null !== object &&
        object.$$typeof === REACT_ELEMENT_TYPE
      );
    };
    reactIs_development$5.isForwardRef = function (object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development$5.isFragment = function (object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development$5.isLazy = function (object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development$5.isMemo = function (object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development$5.isPortal = function (object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development$5.isProfiler = function (object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development$5.isStrictMode = function (object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development$5.isSuspense = function (object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development$5.isSuspenseList = function (object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development$5.isValidElementType = function (type) {
      return "string" === typeof type ||
        "function" === typeof type ||
        type === REACT_FRAGMENT_TYPE ||
        type === REACT_PROFILER_TYPE ||
        type === REACT_STRICT_MODE_TYPE ||
        type === REACT_SUSPENSE_TYPE ||
        type === REACT_SUSPENSE_LIST_TYPE ||
        ("object" === typeof type &&
          null !== type &&
          (type.$$typeof === REACT_LAZY_TYPE ||
            type.$$typeof === REACT_MEMO_TYPE ||
            type.$$typeof === REACT_CONTEXT_TYPE ||
            type.$$typeof === REACT_CONSUMER_TYPE ||
            type.$$typeof === REACT_FORWARD_REF_TYPE ||
            type.$$typeof === REACT_CLIENT_REFERENCE ||
            void 0 !== type.getModuleId))
        ? !0
        : !1;
    };
    reactIs_development$5.typeOf = typeOf;
  })();

if (process.env.NODE_ENV === 'production') {
  reactIs$6.exports = reactIs_production$1;
} else {
  reactIs$6.exports = reactIs_development$5;
}

var propTypes = {exports: {}};

var reactIs$5 = {exports: {}};

var reactIs_production_min$3 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$3="function"===typeof Symbol&&Symbol.for,c$4=b$3?Symbol.for("react.element"):60103,d$3=b$3?Symbol.for("react.portal"):60106,e$4=b$3?Symbol.for("react.fragment"):60107,f$3=b$3?Symbol.for("react.strict_mode"):60108,g$3=b$3?Symbol.for("react.profiler"):60114,h$3=b$3?Symbol.for("react.provider"):60109,k$4=b$3?Symbol.for("react.context"):60110,l$3=b$3?Symbol.for("react.async_mode"):60111,m$3=b$3?Symbol.for("react.concurrent_mode"):60111,n$3=b$3?Symbol.for("react.forward_ref"):60112,p$3=b$3?Symbol.for("react.suspense"):60113,q$3=b$3?
Symbol.for("react.suspense_list"):60120,r$3=b$3?Symbol.for("react.memo"):60115,t$2=b$3?Symbol.for("react.lazy"):60116,v$3=b$3?Symbol.for("react.block"):60121,w$2=b$3?Symbol.for("react.fundamental"):60117,x$4=b$3?Symbol.for("react.responder"):60118,y$3=b$3?Symbol.for("react.scope"):60119;
function z$2(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$4:switch(a=a.type,a){case l$3:case m$3:case e$4:case g$3:case f$3:case p$3:return a;default:switch(a=a&&a.$$typeof,a){case k$4:case n$3:case t$2:case r$3:case h$3:return a;default:return u}}case d$3:return u}}}function A$3(a){return z$2(a)===m$3}reactIs_production_min$3.AsyncMode=l$3;reactIs_production_min$3.ConcurrentMode=m$3;reactIs_production_min$3.ContextConsumer=k$4;reactIs_production_min$3.ContextProvider=h$3;reactIs_production_min$3.Element=c$4;reactIs_production_min$3.ForwardRef=n$3;reactIs_production_min$3.Fragment=e$4;reactIs_production_min$3.Lazy=t$2;reactIs_production_min$3.Memo=r$3;reactIs_production_min$3.Portal=d$3;
reactIs_production_min$3.Profiler=g$3;reactIs_production_min$3.StrictMode=f$3;reactIs_production_min$3.Suspense=p$3;reactIs_production_min$3.isAsyncMode=function(a){return A$3(a)||z$2(a)===l$3};reactIs_production_min$3.isConcurrentMode=A$3;reactIs_production_min$3.isContextConsumer=function(a){return z$2(a)===k$4};reactIs_production_min$3.isContextProvider=function(a){return z$2(a)===h$3};reactIs_production_min$3.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$4};reactIs_production_min$3.isForwardRef=function(a){return z$2(a)===n$3};reactIs_production_min$3.isFragment=function(a){return z$2(a)===e$4};reactIs_production_min$3.isLazy=function(a){return z$2(a)===t$2};
reactIs_production_min$3.isMemo=function(a){return z$2(a)===r$3};reactIs_production_min$3.isPortal=function(a){return z$2(a)===d$3};reactIs_production_min$3.isProfiler=function(a){return z$2(a)===g$3};reactIs_production_min$3.isStrictMode=function(a){return z$2(a)===f$3};reactIs_production_min$3.isSuspense=function(a){return z$2(a)===p$3};
reactIs_production_min$3.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$4||a===m$3||a===g$3||a===f$3||a===p$3||a===q$3||"object"===typeof a&&null!==a&&(a.$$typeof===t$2||a.$$typeof===r$3||a.$$typeof===h$3||a.$$typeof===k$4||a.$$typeof===n$3||a.$$typeof===w$2||a.$$typeof===x$4||a.$$typeof===y$3||a.$$typeof===v$3)};reactIs_production_min$3.typeOf=z$2;

var reactIs_development$4 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$4.AsyncMode = AsyncMode;
reactIs_development$4.ConcurrentMode = ConcurrentMode;
reactIs_development$4.ContextConsumer = ContextConsumer;
reactIs_development$4.ContextProvider = ContextProvider;
reactIs_development$4.Element = Element;
reactIs_development$4.ForwardRef = ForwardRef;
reactIs_development$4.Fragment = Fragment;
reactIs_development$4.Lazy = Lazy;
reactIs_development$4.Memo = Memo;
reactIs_development$4.Portal = Portal;
reactIs_development$4.Profiler = Profiler;
reactIs_development$4.StrictMode = StrictMode;
reactIs_development$4.Suspense = Suspense;
reactIs_development$4.isAsyncMode = isAsyncMode;
reactIs_development$4.isConcurrentMode = isConcurrentMode;
reactIs_development$4.isContextConsumer = isContextConsumer;
reactIs_development$4.isContextProvider = isContextProvider;
reactIs_development$4.isElement = isElement;
reactIs_development$4.isForwardRef = isForwardRef;
reactIs_development$4.isFragment = isFragment;
reactIs_development$4.isLazy = isLazy;
reactIs_development$4.isMemo = isMemo;
reactIs_development$4.isPortal = isPortal;
reactIs_development$4.isProfiler = isProfiler;
reactIs_development$4.isStrictMode = isStrictMode;
reactIs_development$4.isSuspense = isSuspense;
reactIs_development$4.isValidElementType = isValidElementType;
reactIs_development$4.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$5.exports = reactIs_production_min$3;
} else {
  reactIs$5.exports = reactIs_development$4;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$2 = Object.getOwnPropertySymbols;
var hasOwnProperty$f = Object.prototype.hasOwnProperty;
var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign$1 = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$f.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$2) {
			symbols = getOwnPropertySymbols$2(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable$1.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has$2;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs$5.exports;
var assign$3 = objectAssign$1;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var has = has$2;
var checkPropTypes = checkPropTypes_1;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign$3({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$5.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var clsx = {exports: {}};

function r$2(e){var o,t,f="";if("string"==typeof e||"number"==typeof e)f+=e;else if("object"==typeof e)if(Array.isArray(e)){var n=e.length;for(o=0;o<n;o++)e[o]&&(t=r$2(e[o]))&&(f&&(f+=" "),f+=t);}else for(t in e)e[t]&&(f&&(f+=" "),f+=t);return f}function e$3(){for(var e,o,t=0,f="",n=arguments.length;t<n;t++)(e=arguments[t])&&(o=r$2(e))&&(f&&(f+=" "),f+=o);return f}clsx.exports=e$3,clsx.exports.clsx=e$3;

var chainPropTypes$2 = {};

var chainPropTypes$1 = {};

Object.defineProperty(chainPropTypes$1, "__esModule", {
  value: true
});
chainPropTypes$1.default = chainPropTypes;
function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }
  return function validate(...args) {
    return propType1(...args) || propType2(...args);
  };
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _chainPropTypes.default;
  }
});
var _chainPropTypes = _interopRequireDefault(chainPropTypes$1);
}(chainPropTypes$2));

var composeClasses$2 = {};

var composeClasses$1 = {};

Object.defineProperty(composeClasses$1, "__esModule", {
  value: true
});
composeClasses$1.default = composeClasses;
function composeClasses(slots, getUtilityClass, classes = undefined) {
  const output = {};
  Object.keys(slots).forEach(
  // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        const utilityClass = getUtilityClass(key);
        if (utilityClass !== '') {
          acc.push(utilityClass);
        }
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }
      }
      return acc;
    }, []).join(' ');
  });
  return output;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _composeClasses.default;
  }
});
var _composeClasses = _interopRequireDefault(composeClasses$1);
}(composeClasses$2));

var zeroStyled = {};

var useThemeProps$4 = {};

var useThemeProps$3 = {};

var useThemeProps$2 = {};

var getThemeProps$2 = {};

var resolveProps$2 = {};

var resolveProps$1 = {};

var _interopRequireDefault$a0 = interopRequireDefault$1.exports;
Object.defineProperty(resolveProps$1, "__esModule", {
  value: true
});
resolveProps$1.default = resolveProps;
var _extends2$2Q = _interopRequireDefault$a0(_extends$19.exports);
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  const output = (0, _extends2$2Q.default)({}, props);
  Object.keys(defaultProps).forEach(propName => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = (0, _extends2$2Q.default)({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        // Reduce the iteration if the slot props is empty
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        // Reduce the iteration if the default slot props is empty
        output[propName] = slotProps;
      } else {
        output[propName] = (0, _extends2$2Q.default)({}, slotProps);
        Object.keys(defaultSlotProps).forEach(slotPropName => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _resolveProps.default;
  }
});
var _resolveProps = _interopRequireDefault(resolveProps$1);
}(resolveProps$2));

var _interopRequireDefault$9$ = interopRequireDefault$1.exports;
Object.defineProperty(getThemeProps$2, "__esModule", {
  value: true
});
getThemeProps$2.default = getThemeProps$1;
var _resolveProps$3 = _interopRequireDefault$9$(resolveProps$2);
function getThemeProps$1(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return (0, _resolveProps$3.default)(theme.components[name].defaultProps, props);
}

var useTheme$8 = {};

var createTheme$4 = {};

var createTheme$3 = {};

var deepmerge$2 = {};

var deepmerge$1 = {};

var _interopRequireDefault$9_ = interopRequireDefault$1.exports;
Object.defineProperty(deepmerge$1, "__esModule", {
  value: true
});
deepmerge$1.default = deepmerge;
deepmerge$1.isPlainObject = isPlainObject$5;
var _extends2$2P = _interopRequireDefault$9_(_extends$19.exports);
var React$36 = _interopRequireWildcard$4C(React__default$4);
function _getRequireWildcardCache$4l(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4l = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4C(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4l(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject$5(item) {
  if (typeof item !== 'object' || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if ( /*#__PURE__*/React$36.isValidElement(source) || !isPlainObject$5(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach(key => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? (0, _extends2$2P.default)({}, target) : target;
  if (isPlainObject$5(target) && isPlainObject$5(source)) {
    Object.keys(source).forEach(key => {
      if ( /*#__PURE__*/React$36.isValidElement(source[key])) {
        output[key] = source[key];
      } else if (isPlainObject$5(source[key]) &&
      // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject$5(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject$5(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _deepmerge.default;
  }
});
var _deepmerge = _interopRequireWildcard(deepmerge$1);
Object.keys(_deepmerge).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _deepmerge[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _deepmerge[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(deepmerge$2));

var createBreakpoints$1 = {};

var _interopRequireDefault$9Z = interopRequireDefault$1.exports;
Object.defineProperty(createBreakpoints$1, "__esModule", {
  value: true
});
createBreakpoints$1.breakpointKeys = void 0;
createBreakpoints$1.default = createBreakpoints;
var _objectWithoutPropertiesLoose2$2p = _interopRequireDefault$9Z(objectWithoutPropertiesLoose.exports);
var _extends2$2O = _interopRequireDefault$9Z(_extends$19.exports);
const _excluded$2T = ["values", "unit", "step"];
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
createBreakpoints$1.breakpointKeys = ['xs', 'sm', 'md', 'lg', 'xl'];
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return (0, _extends2$2O.default)({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },
      unit = 'px',
      step = 5
    } = breakpoints,
    other = (0, _objectWithoutPropertiesLoose2$2p.default)(breakpoints, _excluded$2T);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return (0, _extends2$2O.default)({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

var shape$1 = {};

Object.defineProperty(shape$1, "__esModule", {
  value: true
});
shape$1.default = void 0;
const shape = {
  borderRadius: 4
};
shape$1.default = shape;

var createSpacing$1 = {};

var spacing$1 = {};

var responsivePropType$1 = {};

var _interopRequireDefault$9Y = interopRequireDefault$1.exports;
Object.defineProperty(responsivePropType$1, "__esModule", {
  value: true
});
responsivePropType$1.default = void 0;
var _propTypes$3b = _interopRequireDefault$9Y(propTypes.exports);
const responsivePropType = process.env.NODE_ENV !== 'production' ? _propTypes$3b.default.oneOfType([_propTypes$3b.default.number, _propTypes$3b.default.string, _propTypes$3b.default.object, _propTypes$3b.default.array]) : {};
responsivePropType$1.default = responsivePropType;

var breakpoints$1 = {};

var merge$7 = {};

var _interopRequireDefault$9X = interopRequireDefault$1.exports;
Object.defineProperty(merge$7, "__esModule", {
  value: true
});
merge$7.default = void 0;
var _deepmerge$f = _interopRequireDefault$9X(deepmerge$2);
function merge$6(acc, item) {
  if (!item) {
    return acc;
  }
  return (0, _deepmerge$f.default)(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}
merge$7.default = merge$6;

var _interopRequireDefault$9W = interopRequireDefault$1.exports;
Object.defineProperty(breakpoints$1, "__esModule", {
  value: true
});
breakpoints$1.computeBreakpointsBase = computeBreakpointsBase;
breakpoints$1.createEmptyBreakpointObject = createEmptyBreakpointObject;
breakpoints$1.default = void 0;
breakpoints$1.handleBreakpoints = handleBreakpoints;
breakpoints$1.mergeBreakpointsInOrder = mergeBreakpointsInOrder;
breakpoints$1.removeUnusedBreakpoints = removeUnusedBreakpoints;
breakpoints$1.resolveBreakpointValues = resolveBreakpointValues;
breakpoints$1.values = void 0;
var _extends2$2N = _interopRequireDefault$9W(_extends$19.exports);
var _propTypes$3a = _interopRequireDefault$9W(propTypes.exports);
var _deepmerge$e = _interopRequireDefault$9W(deepmerge$2);
var _merge$h = _interopRequireDefault$9W(merge$7);
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = breakpoints$1.values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function breakpoints(styleFunction) {
  // false positive
  // eslint-disable-next-line react/function-component-definition
  const newStyleFunction = props => {
    const theme = props.theme || {};
    const base = styleFunction(props);
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    const extended = themeBreakpoints.keys.reduce((acc, key) => {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction((0, _extends2$2N.default)({
          theme
        }, props[key]));
      }
      return acc;
    }, null);
    return (0, _merge$h.default)(base, extended);
  };
  newStyleFunction.propTypes = process.env.NODE_ENV !== 'production' ? (0, _extends2$2N.default)({}, styleFunction.propTypes, {
    xs: _propTypes$3a.default.object,
    sm: _propTypes$3a.default.object,
    md: _propTypes$3a.default.object,
    lg: _propTypes$3a.default.object,
    xl: _propTypes$3a.default.object
  }) : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl', ...styleFunction.filterProps];
  return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
  const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  const mergedOutput = [emptyBreakpoints, ...styles].reduce((prev, next) => (0, _deepmerge$e.default)(prev, next), {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}

// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (typeof breakpointValues !== 'object') {
    return {};
  }
  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(breakpoint => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }
  return base;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);
  if (keys.length === 0) {
    return breakpointValues;
  }
  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}
breakpoints$1.default = breakpoints;

var style$12 = {};

var capitalize$4 = {};

var capitalize$3 = {};

var formatMuiErrorMessage$2 = {};

var formatMuiErrorMessage$1 = {};

Object.defineProperty(formatMuiErrorMessage$1, "__esModule", {
  value: true
});
formatMuiErrorMessage$1.default = formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe if we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;
  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _formatMuiErrorMessage.default;
  }
});
var _formatMuiErrorMessage = _interopRequireDefault(formatMuiErrorMessage$1);
}(formatMuiErrorMessage$2));

var _interopRequireDefault$9V = interopRequireDefault$1.exports;
Object.defineProperty(capitalize$3, "__esModule", {
  value: true
});
capitalize$3.default = capitalize$2;
var _formatMuiErrorMessage2$a = _interopRequireDefault$9V(formatMuiErrorMessage$2);
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize$2(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`capitalize(string)\` expects a string argument.` : (0, _formatMuiErrorMessage2$a.default)(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _capitalize.default;
  }
});
var _capitalize = _interopRequireDefault(capitalize$3);
}(capitalize$4));

var _interopRequireDefault$9U = interopRequireDefault$1.exports;
Object.defineProperty(style$12, "__esModule", {
  value: true
});
style$12.default = void 0;
style$12.getPath = getPath$2;
style$12.getStyleValue = getStyleValue$1;
var _capitalize$P = _interopRequireDefault$9U(capitalize$4);
var _responsivePropType$3 = _interopRequireDefault$9U(responsivePropType$1);
var _breakpoints$6 = breakpoints$1;
function getPath$2(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue$1(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath$2(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style$11(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath$2(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue$1(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue$1(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalize$P.default)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0, _breakpoints$6.handleBreakpoints)(props, propValue, styleFromPropValue);
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? {
    [prop]: _responsivePropType$3.default
  } : {};
  fn.filterProps = [prop];
  return fn;
}
style$12.default = style$11;

var memoize$5 = {};

Object.defineProperty(memoize$5, "__esModule", {
  value: true
});
memoize$5.default = memoize$4;
function memoize$4(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

var _interopRequireDefault$9T = interopRequireDefault$1.exports;
Object.defineProperty(spacing$1, "__esModule", {
  value: true
});
spacing$1.createUnarySpacing = createUnarySpacing;
spacing$1.createUnaryUnit = createUnaryUnit;
spacing$1.default = void 0;
spacing$1.getStyleFromPropValue = getStyleFromPropValue;
spacing$1.getValue = getValue$3;
spacing$1.margin = margin;
spacing$1.marginKeys = void 0;
spacing$1.padding = padding;
spacing$1.paddingKeys = void 0;
var _responsivePropType$2 = _interopRequireDefault$9T(responsivePropType$1);
var _breakpoints$5 = breakpoints$1;
var _style$a = style$12;
var _merge$g = _interopRequireDefault$9T(merge$7);
var _memoize$1 = _interopRequireDefault$9T(memoize$5);
const properties$1 = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = (0, _memoize$1.default)(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split('');
  const property = properties$1[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = spacing$1.marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = spacing$1.paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = (0, _style$a.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        }
      }
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (process.env.NODE_ENV !== 'production') {
        if (!Number.isInteger(abs)) {
          console.error([`MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`].join('\n'));
        } else if (abs > themeSpacing.length - 1) {
          console.error([`MUI: The value provided (${abs}) overflows.`, `The supported values are: ${JSON.stringify(themeSpacing)}.`, `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`].join('\n'));
        }
      }
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (process.env.NODE_ENV !== 'production') {
    console.error([`MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`, 'It should be a number, an array or a function.'].join('\n'));
  }
  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue$3(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue$3(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return (0, _breakpoints$5.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function style$10(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(_merge$g.default, {});
}
function margin(props) {
  return style$10(props, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== 'production' ? marginKeys.reduce((obj, key) => {
  obj[key] = _responsivePropType$2.default;
  return obj;
}, {}) : {};
margin.filterProps = marginKeys;
function padding(props) {
  return style$10(props, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== 'production' ? paddingKeys.reduce((obj, key) => {
  obj[key] = _responsivePropType$2.default;
  return obj;
}, {}) : {};
padding.filterProps = paddingKeys;
function spacing(props) {
  return style$10(props, spacingKeys);
}
spacing.propTypes = process.env.NODE_ENV !== 'production' ? spacingKeys.reduce((obj, key) => {
  obj[key] = _responsivePropType$2.default;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;
spacing$1.default = spacing;

Object.defineProperty(createSpacing$1, "__esModule", {
  value: true
});
createSpacing$1.default = createSpacing;
var _spacing$5 = spacing$1;
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.

function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }

  // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://m2.material.io/design/layout/understanding-layout.html
  const transform = (0, _spacing$5.createUnarySpacing)({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (process.env.NODE_ENV !== 'production') {
      if (!(argsInput.length <= 4)) {
        console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
      }
    }
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}

var styleFunctionSx$2 = {};

var defaultSxConfig$1 = {};

var borders$1 = {};

var compose$8 = {};

var _interopRequireDefault$9S = interopRequireDefault$1.exports;
Object.defineProperty(compose$8, "__esModule", {
  value: true
});
compose$8.default = void 0;
var _merge$f = _interopRequireDefault$9S(merge$7);
function compose$7(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return (0, _merge$f.default)(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes = process.env.NODE_ENV !== 'production' ? styles.reduce((acc, style) => Object.assign(acc, style.propTypes), {}) : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}
compose$8.default = compose$7;

var _interopRequireDefault$9R = interopRequireDefault$1.exports;
Object.defineProperty(borders$1, "__esModule", {
  value: true
});
borders$1.borderTopColor = borders$1.borderTop = borders$1.borderRightColor = borders$1.borderRight = borders$1.borderRadius = borders$1.borderLeftColor = borders$1.borderLeft = borders$1.borderColor = borders$1.borderBottomColor = borders$1.borderBottom = borders$1.border = void 0;
borders$1.borderTransform = borderTransform;
borders$1.outlineColor = borders$1.outline = borders$1.default = void 0;
var _responsivePropType$1 = _interopRequireDefault$9R(responsivePropType$1);
var _style$9 = _interopRequireDefault$9R(style$12);
var _compose$8 = _interopRequireDefault$9R(compose$8);
var _spacing$4 = spacing$1;
var _breakpoints$4 = breakpoints$1;
function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
  return (0, _style$9.default)({
    prop,
    themeKey: 'borders',
    transform
  });
}
const border = borders$1.border = createBorderStyle('border', borderTransform);
const borderTop = borders$1.borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = borders$1.borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = borders$1.borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = borders$1.borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = borders$1.borderColor = createBorderStyle('borderColor');
const borderTopColor = borders$1.borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = borders$1.borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = borders$1.borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = borders$1.borderLeftColor = createBorderStyle('borderLeftColor');
const outline = borders$1.outline = createBorderStyle('outline', borderTransform);
const outlineColor = borders$1.outlineColor = createBorderStyle('outlineColor');

// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = (0, _spacing$4.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    const styleFromPropValue = propValue => ({
      borderRadius: (0, _spacing$4.getValue)(transformer, propValue)
    });
    return (0, _breakpoints$4.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borders$1.borderRadius = borderRadius;
borderRadius.propTypes = process.env.NODE_ENV !== 'production' ? {
  borderRadius: _responsivePropType$1.default
} : {};
borderRadius.filterProps = ['borderRadius'];
const borders = (0, _compose$8.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
borders$1.default = borders;

var cssGrid = {};

var _interopRequireDefault$9Q = interopRequireDefault$1.exports;
Object.defineProperty(cssGrid, "__esModule", {
  value: true
});
cssGrid.rowGap = cssGrid.gridTemplateRows = cssGrid.gridTemplateColumns = cssGrid.gridTemplateAreas = cssGrid.gridRow = cssGrid.gridColumn = cssGrid.gridAutoRows = cssGrid.gridAutoFlow = cssGrid.gridAutoColumns = cssGrid.gridArea = cssGrid.gap = cssGrid.default = cssGrid.columnGap = void 0;
var _style$8 = _interopRequireDefault$9Q(style$12);
var _compose$7 = _interopRequireDefault$9Q(compose$8);
var _spacing$3 = spacing$1;
var _breakpoints$3 = breakpoints$1;
var _responsivePropType = _interopRequireDefault$9Q(responsivePropType$1);
// false positive
// eslint-disable-next-line react/function-component-definition
const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = (0, _spacing$3.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
    const styleFromPropValue = propValue => ({
      gap: (0, _spacing$3.getValue)(transformer, propValue)
    });
    return (0, _breakpoints$3.handleBreakpoints)(props, props.gap, styleFromPropValue);
  }
  return null;
};
cssGrid.gap = gap;
gap.propTypes = process.env.NODE_ENV !== 'production' ? {
  gap: _responsivePropType.default
} : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = (0, _spacing$3.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
    const styleFromPropValue = propValue => ({
      columnGap: (0, _spacing$3.getValue)(transformer, propValue)
    });
    return (0, _breakpoints$3.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
cssGrid.columnGap = columnGap;
columnGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  columnGap: _responsivePropType.default
} : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = (0, _spacing$3.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
    const styleFromPropValue = propValue => ({
      rowGap: (0, _spacing$3.getValue)(transformer, propValue)
    });
    return (0, _breakpoints$3.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
cssGrid.rowGap = rowGap;
rowGap.propTypes = process.env.NODE_ENV !== 'production' ? {
  rowGap: _responsivePropType.default
} : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = cssGrid.gridColumn = (0, _style$8.default)({
  prop: 'gridColumn'
});
const gridRow = cssGrid.gridRow = (0, _style$8.default)({
  prop: 'gridRow'
});
const gridAutoFlow = cssGrid.gridAutoFlow = (0, _style$8.default)({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = cssGrid.gridAutoColumns = (0, _style$8.default)({
  prop: 'gridAutoColumns'
});
const gridAutoRows = cssGrid.gridAutoRows = (0, _style$8.default)({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = cssGrid.gridTemplateColumns = (0, _style$8.default)({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = cssGrid.gridTemplateRows = (0, _style$8.default)({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = cssGrid.gridTemplateAreas = (0, _style$8.default)({
  prop: 'gridTemplateAreas'
});
const gridArea = cssGrid.gridArea = (0, _style$8.default)({
  prop: 'gridArea'
});
const grid = (0, _compose$7.default)(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
cssGrid.default = grid;

var palette$1 = {};

var _interopRequireDefault$9P = interopRequireDefault$1.exports;
Object.defineProperty(palette$1, "__esModule", {
  value: true
});
palette$1.default = palette$1.color = palette$1.bgcolor = palette$1.backgroundColor = void 0;
palette$1.paletteTransform = paletteTransform;
var _style$7 = _interopRequireDefault$9P(style$12);
var _compose$6 = _interopRequireDefault$9P(compose$8);
function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color$d = palette$1.color = (0, _style$7.default)({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = palette$1.bgcolor = (0, _style$7.default)({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = palette$1.backgroundColor = (0, _style$7.default)({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const palette = (0, _compose$6.default)(color$d, bgcolor, backgroundColor);
palette$1.default = palette;

var sizing$1 = {};

var _interopRequireDefault$9O = interopRequireDefault$1.exports;
Object.defineProperty(sizing$1, "__esModule", {
  value: true
});
sizing$1.sizeWidth = sizing$1.sizeHeight = sizing$1.minWidth = sizing$1.minHeight = sizing$1.maxWidth = sizing$1.maxHeight = sizing$1.height = sizing$1.default = sizing$1.boxSizing = void 0;
sizing$1.sizingTransform = sizingTransform;
sizing$1.width = void 0;
var _style$6 = _interopRequireDefault$9O(style$12);
var _compose$5 = _interopRequireDefault$9O(compose$8);
var _breakpoints$2 = breakpoints$1;
function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = sizing$1.width = (0, _style$6.default)({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || _breakpoints$2.values[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return (0, _breakpoints$2.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
sizing$1.maxWidth = maxWidth;
maxWidth.filterProps = ['maxWidth'];
const minWidth = sizing$1.minWidth = (0, _style$6.default)({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = sizing$1.height = (0, _style$6.default)({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = sizing$1.maxHeight = (0, _style$6.default)({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = sizing$1.minHeight = (0, _style$6.default)({
  prop: 'minHeight',
  transform: sizingTransform
});
sizing$1.sizeWidth = (0, _style$6.default)({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
sizing$1.sizeHeight = (0, _style$6.default)({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = sizing$1.boxSizing = (0, _style$6.default)({
  prop: 'boxSizing'
});
const sizing = (0, _compose$5.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
sizing$1.default = sizing;

Object.defineProperty(defaultSxConfig$1, "__esModule", {
  value: true
});
defaultSxConfig$1.default = void 0;
var _spacing$2 = spacing$1;
var _borders$1 = borders$1;
var _cssGrid$1 = cssGrid;
var _palette$1 = palette$1;
var _sizing$1 = sizing$1;
const defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: _borders$1.borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: _borders$1.borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: _borders$1.borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: _borders$1.borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: _borders$1.borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  outline: {
    themeKey: 'borders',
    transform: _borders$1.borderTransform
  },
  outlineColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: _borders$1.borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: _palette$1.paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: _palette$1.paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: _palette$1.paletteTransform
  },
  // spacing
  p: {
    style: _spacing$2.padding
  },
  pt: {
    style: _spacing$2.padding
  },
  pr: {
    style: _spacing$2.padding
  },
  pb: {
    style: _spacing$2.padding
  },
  pl: {
    style: _spacing$2.padding
  },
  px: {
    style: _spacing$2.padding
  },
  py: {
    style: _spacing$2.padding
  },
  padding: {
    style: _spacing$2.padding
  },
  paddingTop: {
    style: _spacing$2.padding
  },
  paddingRight: {
    style: _spacing$2.padding
  },
  paddingBottom: {
    style: _spacing$2.padding
  },
  paddingLeft: {
    style: _spacing$2.padding
  },
  paddingX: {
    style: _spacing$2.padding
  },
  paddingY: {
    style: _spacing$2.padding
  },
  paddingInline: {
    style: _spacing$2.padding
  },
  paddingInlineStart: {
    style: _spacing$2.padding
  },
  paddingInlineEnd: {
    style: _spacing$2.padding
  },
  paddingBlock: {
    style: _spacing$2.padding
  },
  paddingBlockStart: {
    style: _spacing$2.padding
  },
  paddingBlockEnd: {
    style: _spacing$2.padding
  },
  m: {
    style: _spacing$2.margin
  },
  mt: {
    style: _spacing$2.margin
  },
  mr: {
    style: _spacing$2.margin
  },
  mb: {
    style: _spacing$2.margin
  },
  ml: {
    style: _spacing$2.margin
  },
  mx: {
    style: _spacing$2.margin
  },
  my: {
    style: _spacing$2.margin
  },
  margin: {
    style: _spacing$2.margin
  },
  marginTop: {
    style: _spacing$2.margin
  },
  marginRight: {
    style: _spacing$2.margin
  },
  marginBottom: {
    style: _spacing$2.margin
  },
  marginLeft: {
    style: _spacing$2.margin
  },
  marginX: {
    style: _spacing$2.margin
  },
  marginY: {
    style: _spacing$2.margin
  },
  marginInline: {
    style: _spacing$2.margin
  },
  marginInlineStart: {
    style: _spacing$2.margin
  },
  marginInlineEnd: {
    style: _spacing$2.margin
  },
  marginBlock: {
    style: _spacing$2.margin
  },
  marginBlockStart: {
    style: _spacing$2.margin
  },
  marginBlockEnd: {
    style: _spacing$2.margin
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: value => ({
      '@media print': {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: _cssGrid$1.gap
  },
  rowGap: {
    style: _cssGrid$1.rowGap
  },
  columnGap: {
    style: _cssGrid$1.columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: _sizing$1.sizingTransform
  },
  maxWidth: {
    style: _sizing$1.maxWidth
  },
  minWidth: {
    transform: _sizing$1.sizingTransform
  },
  height: {
    transform: _sizing$1.sizingTransform
  },
  maxHeight: {
    transform: _sizing$1.sizingTransform
  },
  minHeight: {
    transform: _sizing$1.sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};
defaultSxConfig$1.default = defaultSxConfig;

var _interopRequireDefault$9N = interopRequireDefault$1.exports;
Object.defineProperty(styleFunctionSx$2, "__esModule", {
  value: true
});
styleFunctionSx$2.default = void 0;
styleFunctionSx$2.unstable_createStyleFunctionSx = unstable_createStyleFunctionSx;
var _capitalize$O = _interopRequireDefault$9N(capitalize$4);
var _merge$e = _interopRequireDefault$9N(merge$7);
var _style$5 = style$12;
var _breakpoints$1 = breakpoints$1;
var _defaultSxConfig$2 = _interopRequireDefault$9N(defaultSxConfig$1);
function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style
    } = options;
    if (val == null) {
      return null;
    }

    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && val === 'inherit') {
      return {
        [prop]: val
      };
    }
    const themeMapping = (0, _style$5.getPath)(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    const styleFromPropValue = propValueFinal => {
      let value = (0, _style$5.getStyleValue)(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = (0, _style$5.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalize$O.default)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0, _breakpoints$1.handleBreakpoints)(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {},
      nested
    } = props || {};
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : _defaultSxConfig$2.default;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = (0, _breakpoints$1.createEmptyBreakpointObject)(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (config[styleKey]) {
              css = (0, _merge$e.default)(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = (0, _breakpoints$1.handleBreakpoints)({
                theme
              }, value, x => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme,
                  nested: true
                });
              } else {
                css = (0, _merge$e.default)(css, breakpointsValues);
              }
            }
          } else {
            css = (0, _merge$e.default)(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      if (!nested && theme.modularCssLayers) {
        return {
          '@layer sx': (0, _breakpoints$1.removeUnusedBreakpoints)(breakpointsKeys, css)
        };
      }
      return (0, _breakpoints$1.removeUnusedBreakpoints)(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
const styleFunctionSx$1 = unstable_createStyleFunctionSx();
styleFunctionSx$1.filterProps = ['sx'];
styleFunctionSx$2.default = styleFunctionSx$1;

var applyStyles$3 = {};

Object.defineProperty(applyStyles$3, "__esModule", {
  value: true
});
applyStyles$3.default = applyStyles$2;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */
function applyStyles$2(key, styles) {
  // @ts-expect-error this is 'any' type
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
    // If CssVarsProvider is used as a provider,
    // returns '* :where([data-mui-color-scheme="light|dark"]) &'
    const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
    return {
      [selector]: styles
    };
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}

var _interopRequireDefault$9M = interopRequireDefault$1.exports;
Object.defineProperty(createTheme$3, "__esModule", {
  value: true
});
createTheme$3.default = void 0;
var _extends2$2M = _interopRequireDefault$9M(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2o = _interopRequireDefault$9M(objectWithoutPropertiesLoose.exports);
var _deepmerge$d = _interopRequireDefault$9M(deepmerge$2);
var _createBreakpoints = _interopRequireDefault$9M(createBreakpoints$1);
var _shape = _interopRequireDefault$9M(shape$1);
var _createSpacing = _interopRequireDefault$9M(createSpacing$1);
var _styleFunctionSx$9 = _interopRequireDefault$9M(styleFunctionSx$2);
var _defaultSxConfig$1 = _interopRequireDefault$9M(defaultSxConfig$1);
var _applyStyles = _interopRequireDefault$9M(applyStyles$3);
const _excluded$2S = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$2(options = {}, ...args) {
  const {
      breakpoints: breakpointsInput = {},
      palette: paletteInput = {},
      spacing: spacingInput,
      shape: shapeInput = {}
    } = options,
    other = (0, _objectWithoutPropertiesLoose2$2o.default)(options, _excluded$2S);
  const breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  const spacing = (0, _createSpacing.default)(spacingInput);
  let muiTheme = (0, _deepmerge$d.default)({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: (0, _extends2$2M.default)({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: (0, _extends2$2M.default)({}, _shape.default, shapeInput)
  }, other);
  muiTheme.applyStyles = _applyStyles.default;
  muiTheme = args.reduce((acc, argument) => (0, _deepmerge$d.default)(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = (0, _extends2$2M.default)({}, _defaultSxConfig$1.default, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return (0, _styleFunctionSx$9.default)({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
createTheme$3.default = createTheme$2;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _createTheme.default;
  }
});
Object.defineProperty(exports, "private_createBreakpoints", {
  enumerable: true,
  get: function () {
    return _createBreakpoints.default;
  }
});
Object.defineProperty(exports, "unstable_applyStyles", {
  enumerable: true,
  get: function () {
    return _applyStyles.default;
  }
});
var _createTheme = _interopRequireDefault(createTheme$3);
var _createBreakpoints = _interopRequireDefault(createBreakpoints$1);
var _applyStyles = _interopRequireDefault(applyStyles$3);
}(createTheme$4));

var useThemeWithoutDefault = {};

var node$3 = {};

function _extends$18() {
  return _extends$18 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$18.apply(null, arguments);
}

var isDevelopment$3 = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment$3 : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT$1 = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';
var LAYER = '@layer';

/**
 * @param {number}
 * @return {number}
 */
var abs$1 = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {object}
 * @return {object}
 */
var assign$2 = Object.assign;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash$2 (value, length) {
	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match$1l (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line$1 = 1;
var column = 1;
var length$2 = 0;
var position$2 = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node$2 (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line$1, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function copy$2 (root, props) {
	return assign$2(node$2('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position$2 > 0 ? charat(characters, --position$2) : 0;

	if (column--, character === 10)
		column = 1, line$1--;

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position$2 < length$2 ? charat(characters, position$2++) : 0;

	if (column++, character === 10)
		column = 1, line$1++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position$2)
}

/**
 * @return {number}
 */
function caret () {
	return position$2
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice$4 (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line$1 = column = 1, length$2 = strlen(characters = value), position$2 = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice$4(position$2 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice$4(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position$2
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character);
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position$2
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice$4(index, position$2 - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier$1 (index) {
	while (!token(peek()))
		next();

	return slice$4(index, position$2)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse$5('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse$5 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && charat(characters, length - 1) == 58) {
					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1;
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7);
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse$5(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse$5(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse$5(characters, reference, reference, reference, [''], children, 0, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				if (variable < 1)
					if (character == 123)
						--variable;
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = length = strlen(type = characters += identifier$1(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs$1(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node$2(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node$2(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node$2(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize$3(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice$4(begin, position$2);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position$2 - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function prefix$1(value, length) {
  switch (hash$2(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT$1 + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT$1 + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT$1 + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT$1 + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT$1 + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT$1 + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT$1 + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT$1 + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT$1 + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT$1 + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT$1 + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT$1 + 'box-' + replace(value, '-grow', '') + WEBKIT$1 + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT$1 + replace(value, /([^-])(transform)/g, '$1' + WEBKIT$1 + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT$1 + '$1'), /(image-set)/, WEBKIT$1 + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT$1 + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT$1 + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT$1 + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT$1 + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT$1 + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix$1(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT$1) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT$1 + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT$1 + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT$1 + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT$1 + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT$1 + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT$1 + value + MS + value + value;
  }

  return value;
}

var prefixer$2 = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix$1(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy$2(element, {
        value: replace(element.value, '@', '@' + WEBKIT$1)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match$1l(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy$2(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy$2(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT$1 + 'input-$1')]
            }), copy$2(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy$2(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [prefixer$2];

var createCache = function createCache(options) {
  var key = options.key;

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var emotionCache_browser_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': createCache
});

var reactIs$4 = {exports: {}};

var reactIs_production_min$2 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2="function"===typeof Symbol&&Symbol.for,c$3=b$2?Symbol.for("react.element"):60103,d$2=b$2?Symbol.for("react.portal"):60106,e$2=b$2?Symbol.for("react.fragment"):60107,f$2=b$2?Symbol.for("react.strict_mode"):60108,g$2=b$2?Symbol.for("react.profiler"):60114,h$2=b$2?Symbol.for("react.provider"):60109,k$3=b$2?Symbol.for("react.context"):60110,l$2=b$2?Symbol.for("react.async_mode"):60111,m$2=b$2?Symbol.for("react.concurrent_mode"):60111,n$2=b$2?Symbol.for("react.forward_ref"):60112,p$2=b$2?Symbol.for("react.suspense"):60113,q$2=b$2?
Symbol.for("react.suspense_list"):60120,r$1=b$2?Symbol.for("react.memo"):60115,t$1=b$2?Symbol.for("react.lazy"):60116,v$2=b$2?Symbol.for("react.block"):60121,w$1=b$2?Symbol.for("react.fundamental"):60117,x$3=b$2?Symbol.for("react.responder"):60118,y$2=b$2?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$3:switch(a=a.type,a){case l$2:case m$2:case e$2:case g$2:case f$2:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$3:case n$2:case t$1:case r$1:case h$2:return a;default:return u}}case d$2:return u}}}function A$2(a){return z$1(a)===m$2}reactIs_production_min$2.AsyncMode=l$2;reactIs_production_min$2.ConcurrentMode=m$2;reactIs_production_min$2.ContextConsumer=k$3;reactIs_production_min$2.ContextProvider=h$2;reactIs_production_min$2.Element=c$3;reactIs_production_min$2.ForwardRef=n$2;reactIs_production_min$2.Fragment=e$2;reactIs_production_min$2.Lazy=t$1;reactIs_production_min$2.Memo=r$1;reactIs_production_min$2.Portal=d$2;
reactIs_production_min$2.Profiler=g$2;reactIs_production_min$2.StrictMode=f$2;reactIs_production_min$2.Suspense=p$2;reactIs_production_min$2.isAsyncMode=function(a){return A$2(a)||z$1(a)===l$2};reactIs_production_min$2.isConcurrentMode=A$2;reactIs_production_min$2.isContextConsumer=function(a){return z$1(a)===k$3};reactIs_production_min$2.isContextProvider=function(a){return z$1(a)===h$2};reactIs_production_min$2.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$3};reactIs_production_min$2.isForwardRef=function(a){return z$1(a)===n$2};reactIs_production_min$2.isFragment=function(a){return z$1(a)===e$2};reactIs_production_min$2.isLazy=function(a){return z$1(a)===t$1};
reactIs_production_min$2.isMemo=function(a){return z$1(a)===r$1};reactIs_production_min$2.isPortal=function(a){return z$1(a)===d$2};reactIs_production_min$2.isProfiler=function(a){return z$1(a)===g$2};reactIs_production_min$2.isStrictMode=function(a){return z$1(a)===f$2};reactIs_production_min$2.isSuspense=function(a){return z$1(a)===p$2};
reactIs_production_min$2.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e$2||a===m$2||a===g$2||a===f$2||a===p$2||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$1||a.$$typeof===h$2||a.$$typeof===k$3||a.$$typeof===n$2||a.$$typeof===w$1||a.$$typeof===x$3||a.$$typeof===y$2||a.$$typeof===v$2)};reactIs_production_min$2.typeOf=z$1;

var reactIs_development$3 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$3.AsyncMode = AsyncMode;
reactIs_development$3.ConcurrentMode = ConcurrentMode;
reactIs_development$3.ContextConsumer = ContextConsumer;
reactIs_development$3.ContextProvider = ContextProvider;
reactIs_development$3.Element = Element;
reactIs_development$3.ForwardRef = ForwardRef;
reactIs_development$3.Fragment = Fragment;
reactIs_development$3.Lazy = Lazy;
reactIs_development$3.Memo = Memo;
reactIs_development$3.Portal = Portal;
reactIs_development$3.Profiler = Profiler;
reactIs_development$3.StrictMode = StrictMode;
reactIs_development$3.Suspense = Suspense;
reactIs_development$3.isAsyncMode = isAsyncMode;
reactIs_development$3.isConcurrentMode = isConcurrentMode;
reactIs_development$3.isContextConsumer = isContextConsumer;
reactIs_development$3.isContextProvider = isContextProvider;
reactIs_development$3.isElement = isElement;
reactIs_development$3.isForwardRef = isForwardRef;
reactIs_development$3.isFragment = isFragment;
reactIs_development$3.isLazy = isLazy;
reactIs_development$3.isMemo = isMemo;
reactIs_development$3.isPortal = isPortal;
reactIs_development$3.isProfiler = isProfiler;
reactIs_development$3.isStrictMode = isStrictMode;
reactIs_development$3.isSuspense = isSuspense;
reactIs_development$3.isValidElementType = isValidElementType;
reactIs_development$3.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$4.exports = reactIs_production_min$2;
} else {
  reactIs$4.exports = reactIs_development$3;
}

var reactIs$3 = reactIs$4.exports;

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS$1 = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS$1 = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$3.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$3.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs$3.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS$1;
}

var defineProperty$4 = Object.defineProperty;
var getOwnPropertyNames$1 = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var getPrototypeOf$1 = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics$2(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf$1(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics$2(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames$1(sourceComponent);

    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS$1[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor$1(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$4(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics$2;

// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks

var hoistNonReactStatics$1 = (function (targetComponent, sourceComponent) {
  return hoistNonReactStatics_cjs(targetComponent, sourceComponent);
});

var isBrowser = true;

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var isDevelopment$2 = false;

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$3(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";
          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  if (registered == null) {
    return asString;
  }

  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment$2) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

var emotionSerialize_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  serializeStyles: serializeStyles
});

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React$37['useInsertion' + 'Effect'] ? React$37['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || React$37.useLayoutEffect;

var isDevelopment$1 = false;

var EmotionCacheContext = /* #__PURE__ */React$37.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  return /*#__PURE__*/forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext$2 = /* #__PURE__ */React$37.createContext({});

var useTheme$7 = function useTheme() {
  return React$37.useContext(ThemeContext$2);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    return mergedTheme;
  }

  return _extends$18({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
});
var ThemeProvider$a = function ThemeProvider(props) {
  var theme = React$37.useContext(ThemeContext$2);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/React$37.createElement(ThemeContext$2.Provider, {
    value: theme
  }, props.children);
};
function withTheme$2(Component) {
  var componentName = Component.displayName || Component.name || 'Component';
  var WithTheme = /*#__PURE__*/React$37.forwardRef(function render(props, ref) {
    var theme = React$37.useContext(ThemeContext$2);
    return /*#__PURE__*/React$37.createElement(Component, _extends$18({
      theme: theme,
      ref: ref
    }, props));
  });
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics$1(WithTheme, Component);
}

var hasOwn$1 = {}.hasOwnProperty;

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {

  var newProps = {};

  for (var _key in props) {
    if (hasOwn$1.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }

  newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

  return newProps;
};

var Insertion$2 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, React$37.useContext(ThemeContext$2));

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var _key2 in props) {
    if (hasOwn$1.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && (!isDevelopment$1 )) {
      newProps[_key2] = props[_key2];
    }
  }

  newProps.className = className;

  if (ref) {
    newProps.ref = ref;
  }

  return /*#__PURE__*/React$37.createElement(React$37.Fragment, null, /*#__PURE__*/React$37.createElement(Insertion$2, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React$37.createElement(WrappedComponent, newProps));
});

var Emotion$1 = Emotion;

var jsx = function jsx(type, props) {
  // eslint-disable-next-line prefer-rest-params
  var args = arguments;

  if (props == null || !hasOwn$1.call(props, 'css')) {
    return React$37.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }

  return React$37.createElement.apply(null, createElementArgArray);
};

(function (_jsx) {
  var JSX;

  (function (_JSX) {})(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));

// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global$2 = /* #__PURE__ */withEmotionCache(function (props, cache) {

  var styles = props.styles;
  var serialized = serializeStyles([styles], undefined, React$37.useContext(ThemeContext$2));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = React$37.useRef();
  useInsertionEffectWithLayoutFallback(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false;
    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  useInsertionEffectWithLayoutFallback(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}

var classnames$2 = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge$5(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && isDevelopment$1) {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && isDevelopment$1) {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge$5(cache.registered, css, classnames$2(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React$37.useContext(ThemeContext$2)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React$37.createElement(React$37.Fragment, null, /*#__PURE__*/React$37.createElement(Insertion$1, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

var emotionReact_browser_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ClassNames: ClassNames,
  Global: Global$2,
  get createElement () { return jsx; },
  css: css,
  get jsx () { return jsx; },
  keyframes: keyframes,
  CacheProvider: CacheProvider,
  ThemeContext: ThemeContext$2,
  ThemeProvider: ThemeProvider$a,
  __unsafe_useEmotionCache: __unsafe_useEmotionCache,
  useTheme: useTheme$7,
  withEmotionCache: withEmotionCache,
  withTheme: withTheme$2
});

// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize$3(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var isDevelopment = false;

var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled$2 = function createStyled(tag, options) {

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      // eslint-disable-next-line prefer-spread
      styles.push.apply(styles, args);
    } else {
      var templateStringsArr = args[0];

      styles.push(templateStringsArr[0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {

        styles.push(args[i], templateStringsArr[i]);
      }
    }

    var Styled = withEmotionCache(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = React$37.useContext(ThemeContext$2);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if (finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;

      if (ref) {
        newProps.ref = ref;
      }

      return /*#__PURE__*/React$37.createElement(React$37.Fragment, null, /*#__PURE__*/React$37.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/React$37.createElement(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && isDevelopment) {
          return 'NO_COMPONENT_SELECTOR';
        }

        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      var newStyled = createStyled(nextTag, _extends$18({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      }));
      return newStyled.apply(void 0, styles);
    };

    return Styled;
  };
};

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// bind it to avoid mutating the original function
var styled$3 = createStyled$2.bind(null);
tags.forEach(function (tagName) {
  styled$3[tagName] = styled$3(tagName);
});

var emotionStyled_browser_esm = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': styled$3
});

var require$$1$2 = /*@__PURE__*/getAugmentedNamespace(emotionStyled_browser_esm);

var require$$2 = /*@__PURE__*/getAugmentedNamespace(emotionSerialize_esm);

var require$$3 = /*@__PURE__*/getAugmentedNamespace(emotionReact_browser_esm);

var StyledEngineProvider$2 = {};

var StyledEngineProvider$1 = {};

var require$$4$2 = /*@__PURE__*/getAugmentedNamespace(emotionCache_browser_esm);

var _interopRequireDefault$9L = interopRequireDefault$1.exports;
Object.defineProperty(StyledEngineProvider$1, "__esModule", {
  value: true
});
StyledEngineProvider$1.default = StyledEngineProvider;
var React$35 = _interopRequireWildcard$4B(React__default$4);
var _propTypes$39 = _interopRequireDefault$9L(propTypes.exports);
var _react2$12 = require$$3;
var _cache = _interopRequireDefault$9L(require$$4$2);
var _jsxRuntime$2W = require$$11;
function _getRequireWildcardCache$4k(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4k = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4B(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4k(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// prepend: true moves MUI styles to the top of the <head> so they're loaded first.
// It allows developers to easily override MUI styles with other styling solutions, like CSS modules.
function getCache(injectFirst, enableCssLayer) {
  const emotionCache = (0, _cache.default)({
    key: 'css',
    prepend: injectFirst
  });
  if (enableCssLayer) {
    const prevInsert = emotionCache.insert;
    emotionCache.insert = (...args) => {
      if (!args[1].styles.match(/^@layer\s+[^{]*$/)) {
        // avoid nested @layer
        args[1].styles = `@layer mui {${args[1].styles}}`;
      }
      return prevInsert(...args);
    };
  }
  return emotionCache;
}
const cacheMap = new Map();
function StyledEngineProvider(props) {
  const {
    injectFirst,
    enableCssLayer,
    children
  } = props;
  const cache = React$35.useMemo(() => {
    const cacheKey = `${injectFirst}-${enableCssLayer}`;
    if (typeof document === 'object' && cacheMap.has(cacheKey)) {
      return cacheMap.get(cacheKey);
    }
    const fresh = getCache(injectFirst, enableCssLayer);
    cacheMap.set(cacheKey, fresh);
    return fresh;
  }, [injectFirst, enableCssLayer]);
  if (injectFirst || enableCssLayer) {
    return /*#__PURE__*/(0, _jsxRuntime$2W.jsx)(_react2$12.CacheProvider, {
      value: cache,
      children: children
    });
  }
  return children;
}
process.env.NODE_ENV !== "production" ? StyledEngineProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: _propTypes$39.default.node,
  /**
   * If true, MUI styles are wrapped in CSS `@layer mui` rule.
   * It helps to override MUI styles when using CSS Modules, Tailwind CSS, plain CSS, or any other styling solution.
   */
  enableCssLayer: _propTypes$39.default.bool,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: _propTypes$39.default.bool
} : void 0;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _StyledEngineProvider.default;
  }
});
var _StyledEngineProvider = _interopRequireDefault(StyledEngineProvider$1);
}(StyledEngineProvider$2));

var GlobalStyles$8 = {};

var GlobalStyles$7 = {};

var _interopRequireDefault$9K = interopRequireDefault$1.exports;
Object.defineProperty(GlobalStyles$7, "__esModule", {
  value: true
});
GlobalStyles$7.default = GlobalStyles$6;
_interopRequireWildcard$4A(React__default$4);
var _propTypes$38 = _interopRequireDefault$9K(propTypes.exports);
var _react2$11 = require$$3;
var _jsxRuntime$2V = require$$11;
function _getRequireWildcardCache$4j(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4j = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4A(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4j(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function isEmpty$4(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles$6(props) {
  const {
    styles,
    defaultTheme = {}
  } = props;
  const globalStyles = typeof styles === 'function' ? themeInput => styles(isEmpty$4(themeInput) ? defaultTheme : themeInput) : styles;
  return /*#__PURE__*/(0, _jsxRuntime$2V.jsx)(_react2$11.Global, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles$6.propTypes = {
  defaultTheme: _propTypes$38.default.object,
  styles: _propTypes$38.default.oneOfType([_propTypes$38.default.array, _propTypes$38.default.string, _propTypes$38.default.object, _propTypes$38.default.func])
} : void 0;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _GlobalStyles.default;
  }
});
var _GlobalStyles = _interopRequireDefault(GlobalStyles$7);
}(GlobalStyles$8));

/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {
'use client';

/* eslint-disable no-underscore-dangle */
var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GlobalStyles", {
  enumerable: true,
  get: function () {
    return _GlobalStyles.default;
  }
});
Object.defineProperty(exports, "StyledEngineProvider", {
  enumerable: true,
  get: function () {
    return _StyledEngineProvider.default;
  }
});
Object.defineProperty(exports, "ThemeContext", {
  enumerable: true,
  get: function () {
    return _react.ThemeContext;
  }
});
Object.defineProperty(exports, "css", {
  enumerable: true,
  get: function () {
    return _react.css;
  }
});
exports.default = styled;
exports.internal_processStyles = void 0;
exports.internal_serializeStyles = internal_serializeStyles;
Object.defineProperty(exports, "keyframes", {
  enumerable: true,
  get: function () {
    return _react.keyframes;
  }
});
var _styled = _interopRequireDefault(require$$1$2);
var _serialize = require$$2;
var _react = require$$3;
var _StyledEngineProvider = _interopRequireDefault(StyledEngineProvider$2);
var _GlobalStyles = _interopRequireDefault(GlobalStyles$8);
function styled(tag, options) {
  const stylesFactory = (0, _styled.default)(tag, options);
  if (process.env.NODE_ENV !== 'production') {
    return (...styles) => {
      const component = typeof tag === 'string' ? `"${tag}"` : 'component';
      if (styles.length === 0) {
        console.error([`MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join('\n'));
      } else if (styles.some(style => style === undefined)) {
        console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
      }
      return stylesFactory(...styles);
    };
  }
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};

// Emotion only accepts an array, but we want to avoid allocations
exports.internal_processStyles = internal_processStyles;
const wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function internal_serializeStyles(styles) {
  wrapper[0] = styles;
  return (0, _serialize.serializeStyles)(wrapper);
}
}(node$3));

Object.defineProperty(useThemeWithoutDefault, "__esModule", {
  value: true
});
useThemeWithoutDefault.default = void 0;
var React$34 = _interopRequireWildcard$4z(React__default$4);
var _styledEngine$5 = node$3;
function _getRequireWildcardCache$4i(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4i = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4z(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4i(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme$6(defaultTheme = null) {
  const contextTheme = React$34.useContext(_styledEngine$5.ThemeContext);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
useThemeWithoutDefault.default = useTheme$6;

var _interopRequireDefault$9J = interopRequireDefault$1.exports;
Object.defineProperty(useTheme$8, "__esModule", {
  value: true
});
useTheme$8.systemDefaultTheme = useTheme$8.default = void 0;
var _createTheme$8 = _interopRequireDefault$9J(createTheme$4);
var _useThemeWithoutDefault$4 = _interopRequireDefault$9J(useThemeWithoutDefault);
const systemDefaultTheme$1 = useTheme$8.systemDefaultTheme = (0, _createTheme$8.default)();
function useTheme$5(defaultTheme = systemDefaultTheme$1) {
  return (0, _useThemeWithoutDefault$4.default)(defaultTheme);
}
useTheme$8.default = useTheme$5;

var _interopRequireDefault$9I = interopRequireDefault$1.exports;
Object.defineProperty(useThemeProps$2, "__esModule", {
  value: true
});
useThemeProps$2.default = useThemeProps$1;
var _getThemeProps = _interopRequireDefault$9I(getThemeProps$2);
var _useTheme$j = _interopRequireDefault$9I(useTheme$8);
function useThemeProps$1({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = (0, _useTheme$j.default)(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = (0, _getThemeProps.default)({
    theme,
    name,
    props
  });
  return mergedProps;
}

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useThemeProps.default;
  }
});
Object.defineProperty(exports, "getThemeProps", {
  enumerable: true,
  get: function () {
    return _getThemeProps.default;
  }
});
var _useThemeProps = _interopRequireDefault(useThemeProps$2);
var _getThemeProps = _interopRequireDefault(getThemeProps$2);
}(useThemeProps$3));

var defaultTheme$7 = {};

var createTheme$1 = {};

var styleFunctionSx = {};

var extendSxProp$1 = {};

var _interopRequireDefault$9H = interopRequireDefault$1.exports;
Object.defineProperty(extendSxProp$1, "__esModule", {
  value: true
});
extendSxProp$1.default = extendSxProp;
var _extends2$2L = _interopRequireDefault$9H(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2n = _interopRequireDefault$9H(objectWithoutPropertiesLoose.exports);
var _deepmerge$c = deepmerge$2;
var _defaultSxConfig = _interopRequireDefault$9H(defaultSxConfig$1);
const _excluded$2R = ["sx"];
const splitProps = props => {
  var _props$theme$unstable, _props$theme;
  const result = {
    systemProps: {},
    otherProps: {}
  };
  const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : _defaultSxConfig.default;
  Object.keys(props).forEach(prop => {
    if (config[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};
function extendSxProp(props) {
  const {
      sx: inSx
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$2n.default)(props, _excluded$2R);
  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;
  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);
      if (!(0, _deepmerge$c.isPlainObject)(result)) {
        return systemProps;
      }
      return (0, _extends2$2L.default)({}, systemProps, result);
    };
  } else {
    finalSx = (0, _extends2$2L.default)({}, systemProps, inSx);
  }
  return (0, _extends2$2L.default)({}, otherProps, {
    sx: finalSx
  });
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _styleFunctionSx.default;
  }
});
Object.defineProperty(exports, "extendSxProp", {
  enumerable: true,
  get: function () {
    return _extendSxProp.default;
  }
});
Object.defineProperty(exports, "unstable_createStyleFunctionSx", {
  enumerable: true,
  get: function () {
    return _styleFunctionSx.unstable_createStyleFunctionSx;
  }
});
Object.defineProperty(exports, "unstable_defaultSxConfig", {
  enumerable: true,
  get: function () {
    return _defaultSxConfig.default;
  }
});
var _styleFunctionSx = _interopRequireWildcard(styleFunctionSx$2);
var _extendSxProp = _interopRequireDefault(extendSxProp$1);
var _defaultSxConfig = _interopRequireDefault(defaultSxConfig$1);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(styleFunctionSx));

var generateUtilityClass$3 = {};

var generateUtilityClass$2 = {};

var ClassNameGenerator$2 = {};

var ClassNameGenerator$1 = {};

Object.defineProperty(ClassNameGenerator$1, "__esModule", {
  value: true
});
ClassNameGenerator$1.default = void 0;
const defaultGenerator = componentName => componentName;
const createClassNameGenerator = () => {
  let generate = defaultGenerator;
  return {
    configure(generator) {
      generate = generator;
    },
    generate(componentName) {
      return generate(componentName);
    },
    reset() {
      generate = defaultGenerator;
    }
  };
};
const ClassNameGenerator = createClassNameGenerator();
ClassNameGenerator$1.default = ClassNameGenerator;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ClassNameGenerator.default;
  }
});
var _ClassNameGenerator = _interopRequireDefault(ClassNameGenerator$1);
}(ClassNameGenerator$2));

var _interopRequireDefault$9G = interopRequireDefault$1.exports;
Object.defineProperty(generateUtilityClass$2, "__esModule", {
  value: true
});
generateUtilityClass$2.default = generateUtilityClass$1;
generateUtilityClass$2.globalStateClasses = void 0;
generateUtilityClass$2.isGlobalState = isGlobalState;
var _ClassNameGenerator$1 = _interopRequireDefault$9G(ClassNameGenerator$2);
const globalStateClasses = generateUtilityClass$2.globalStateClasses = {
  active: 'active',
  checked: 'checked',
  completed: 'completed',
  disabled: 'disabled',
  error: 'error',
  expanded: 'expanded',
  focused: 'focused',
  focusVisible: 'focusVisible',
  open: 'open',
  readOnly: 'readOnly',
  required: 'required',
  selected: 'selected'
};
function generateUtilityClass$1(componentName, slot, globalStatePrefix = 'Mui') {
  const globalStateClass = globalStateClasses[slot];
  return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${_ClassNameGenerator$1.default.generate(componentName)}-${slot}`;
}
function isGlobalState(slot) {
  return globalStateClasses[slot] !== undefined;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _generateUtilityClass.default;
  }
});
var _generateUtilityClass = _interopRequireWildcard(generateUtilityClass$2);
Object.keys(_generateUtilityClass).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _generateUtilityClass[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _generateUtilityClass[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(generateUtilityClass$3));

var createMixins$1 = {};

var _interopRequireDefault$9F = interopRequireDefault$1.exports;
Object.defineProperty(createMixins$1, "__esModule", {
  value: true
});
createMixins$1.default = createMixins;
var _extends2$2K = _interopRequireDefault$9F(_extends$19.exports);
function createMixins(breakpoints, mixins) {
  return (0, _extends2$2K.default)({
    toolbar: {
      minHeight: 56,
      [breakpoints.up('xs')]: {
        '@media (orientation: landscape)': {
          minHeight: 48
        }
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}

var createPalette$1 = {};

var colorManipulator = {};

var clamp$5 = {};

var clamp$4 = {};

Object.defineProperty(clamp$4, "__esModule", {
  value: true
});
clamp$4.default = void 0;
function clamp$3(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
  return Math.max(min, Math.min(val, max));
}
clamp$4.default = clamp$3;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _clamp.default;
  }
});
var _clamp = _interopRequireDefault(clamp$4);
}(clamp$5));

var _interopRequireDefault$9E = interopRequireDefault$1.exports;
Object.defineProperty(colorManipulator, "__esModule", {
  value: true
});
colorManipulator.alpha = alpha$3;
colorManipulator.blend = blend;
colorManipulator.colorChannel = void 0;
colorManipulator.darken = darken;
colorManipulator.decomposeColor = decomposeColor;
colorManipulator.emphasize = emphasize;
colorManipulator.getContrastRatio = getContrastRatio;
colorManipulator.getLuminance = getLuminance;
colorManipulator.hexToRgb = hexToRgb$2;
colorManipulator.hslToRgb = hslToRgb;
colorManipulator.lighten = lighten;
colorManipulator.private_safeAlpha = private_safeAlpha;
colorManipulator.private_safeColorChannel = void 0;
colorManipulator.private_safeDarken = private_safeDarken;
colorManipulator.private_safeEmphasize = private_safeEmphasize;
colorManipulator.private_safeLighten = private_safeLighten;
colorManipulator.recomposeColor = recomposeColor;
colorManipulator.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2$9 = _interopRequireDefault$9E(formatMuiErrorMessage$2);
var _clamp$2 = _interopRequireDefault$9E(clamp$5);
/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper(value, min = 0, max = 1) {
  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    }
  }
  return (0, _clamp$2.default)(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb$2(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb$2(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _formatMuiErrorMessage2$9.default)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _formatMuiErrorMessage2$9.default)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
colorManipulator.colorChannel = colorChannel;
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
colorManipulator.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha$3(color, value) {
  color = decomposeColor(color);
  value = clampWrapper(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha$3(color, value);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return emphasize(color, coefficient);
  } catch (error) {
    if (warning && process.env.NODE_ENV !== 'production') {
      console.warn(warning);
    }
    return color;
  }
}

/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */
function blend(background, overlay, opacity, gamma = 1.0) {
  const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
  const backgroundColor = decomposeColor(background);
  const overlayColor = decomposeColor(overlay);
  const rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: 'rgb',
    values: rgb
  });
}

var common$2 = {};

Object.defineProperty(common$2, "__esModule", {
  value: true
});
common$2.default = void 0;
const common$1 = {
  black: '#000',
  white: '#fff'
};
common$2.default = common$1;

var grey$1 = {};

Object.defineProperty(grey$1, "__esModule", {
  value: true
});
grey$1.default = void 0;
const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
grey$1.default = grey;

var purple$1 = {};

Object.defineProperty(purple$1, "__esModule", {
  value: true
});
purple$1.default = void 0;
const purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
purple$1.default = purple;

var red$1 = {};

Object.defineProperty(red$1, "__esModule", {
  value: true
});
red$1.default = void 0;
const red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
red$1.default = red;

var orange$1 = {};

Object.defineProperty(orange$1, "__esModule", {
  value: true
});
orange$1.default = void 0;
const orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
orange$1.default = orange;

var blue$1 = {};

Object.defineProperty(blue$1, "__esModule", {
  value: true
});
blue$1.default = void 0;
const blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
blue$1.default = blue;

var lightBlue$1 = {};

Object.defineProperty(lightBlue$1, "__esModule", {
  value: true
});
lightBlue$1.default = void 0;
const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
lightBlue$1.default = lightBlue;

var green$1 = {};

Object.defineProperty(green$1, "__esModule", {
  value: true
});
green$1.default = void 0;
const green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
green$1.default = green;

var _interopRequireDefault$9D = interopRequireDefault$1.exports;
Object.defineProperty(createPalette$1, "__esModule", {
  value: true
});
createPalette$1.dark = void 0;
createPalette$1.default = createPalette;
createPalette$1.light = void 0;
var _extends2$2J = _interopRequireDefault$9D(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2m = _interopRequireDefault$9D(objectWithoutPropertiesLoose.exports);
var _formatMuiErrorMessage2$8 = _interopRequireDefault$9D(formatMuiErrorMessage$2);
var _deepmerge$b = _interopRequireDefault$9D(deepmerge$2);
var _colorManipulator$o = colorManipulator;
var _common$p = _interopRequireDefault$9D(common$2);
var _grey = _interopRequireDefault$9D(grey$1);
var _purple = _interopRequireDefault$9D(purple$1);
var _red = _interopRequireDefault$9D(red$1);
var _orange = _interopRequireDefault$9D(orange$1);
var _blue = _interopRequireDefault$9D(blue$1);
var _lightBlue = _interopRequireDefault$9D(lightBlue$1);
var _green = _interopRequireDefault$9D(green$1);
const _excluded$2Q = ["mode", "contrastThreshold", "tonalOffset"];
const light = createPalette$1.light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common$p.default.white,
    default: _common$p.default.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = createPalette$1.dark = {
  text: {
    primary: _common$p.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: _common$p.default.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator$o.lighten)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator$o.darken)(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: _blue.default[200],
      light: _blue.default[50],
      dark: _blue.default[400]
    };
  }
  return {
    main: _blue.default[700],
    light: _blue.default[400],
    dark: _blue.default[800]
  };
}
function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: _purple.default[200],
      light: _purple.default[50],
      dark: _purple.default[400]
    };
  }
  return {
    main: _purple.default[500],
    light: _purple.default[300],
    dark: _purple.default[700]
  };
}
function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: _red.default[500],
      light: _red.default[300],
      dark: _red.default[700]
    };
  }
  return {
    main: _red.default[700],
    light: _red.default[400],
    dark: _red.default[800]
  };
}
function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: _lightBlue.default[400],
      light: _lightBlue.default[300],
      dark: _lightBlue.default[700]
    };
  }
  return {
    main: _lightBlue.default[700],
    light: _lightBlue.default[500],
    dark: _lightBlue.default[900]
  };
}
function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: _green.default[400],
      light: _green.default[300],
      dark: _green.default[700]
    };
  }
  return {
    main: _green.default[800],
    light: _green.default[500],
    dark: _green.default[900]
  };
}
function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: _orange.default[400],
      light: _orange.default[300],
      dark: _orange.default[700]
    };
  }
  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: _orange.default[500],
    dark: _orange.default[900]
  };
}
function createPalette(palette) {
  const {
      mode = 'light',
      contrastThreshold = 3,
      tonalOffset = 0.2
    } = palette,
    other = (0, _objectWithoutPropertiesLoose2$2m.default)(palette, _excluded$2Q);
  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode);

  // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
  function getContrastText(background) {
    const contrastText = (0, _colorManipulator$o.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== 'production') {
      const contrast = (0, _colorManipulator$o.getContrastRatio)(background, contrastText);
      if (contrast < 3) {
        console.error([`MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`, 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }
    return contrastText;
  }
  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = (0, _extends2$2J.default)({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.hasOwnProperty('main')) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.` : (0, _formatMuiErrorMessage2$8.default)(11, name ? ` (${name})` : '', mainShade));
    }
    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : (0, _formatMuiErrorMessage2$8.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  const modes = {
    dark,
    light
  };
  if (process.env.NODE_ENV !== 'production') {
    if (!modes[mode]) {
      console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    }
  }
  const paletteOutput = (0, _deepmerge$b.default)((0, _extends2$2J.default)({
    // A collection of common colors.
    common: (0, _extends2$2J.default)({}, _common$p.default),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: _grey.default,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}

var createTypography$1 = {};

var _interopRequireDefault$9C = interopRequireDefault$1.exports;
Object.defineProperty(createTypography$1, "__esModule", {
  value: true
});
createTypography$1.default = createTypography;
var _extends2$2I = _interopRequireDefault$9C(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2l = _interopRequireDefault$9C(objectWithoutPropertiesLoose.exports);
var _deepmerge$a = _interopRequireDefault$9C(deepmerge$2);
const _excluded$2P = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round$3(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */
function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
    {
      fontFamily = defaultFontFamily,
      // The default font size of the Material Specification.
      fontSize = 14,
      // px
      fontWeightLight = 300,
      fontWeightRegular = 400,
      fontWeightMedium = 500,
      fontWeightBold = 700,
      // Tell MUI what's the font-size on the html element.
      // 16px is the default font-size used by browsers.
      htmlFontSize = 16,
      // Apply the CSS properties to all the variants.
      allVariants,
      pxToRem: pxToRem2
    } = _ref,
    other = (0, _objectWithoutPropertiesLoose2$2l.default)(_ref, _excluded$2P);
  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('MUI: `fontSize` is required to be a number.');
    }
    if (typeof htmlFontSize !== 'number') {
      console.error('MUI: `htmlFontSize` is required to be a number.');
    }
  }
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => (0, _extends2$2I.default)({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round$3(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: 'inherit',
      fontWeight: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit'
    }
  };
  return (0, _deepmerge$a.default)((0, _extends2$2I.default)({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep
  });
}

var shadows$2 = {};

Object.defineProperty(shadows$2, "__esModule", {
  value: true
});
shadows$2.default = void 0;
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
}

// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows$1 = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
shadows$2.default = shadows$1;

var createTransitions$1 = {};

var _interopRequireDefault$9B = interopRequireDefault$1.exports;
Object.defineProperty(createTransitions$1, "__esModule", {
  value: true
});
createTransitions$1.default = createTransitions;
createTransitions$1.easing = createTransitions$1.duration = void 0;
var _objectWithoutPropertiesLoose2$2k = _interopRequireDefault$9B(objectWithoutPropertiesLoose.exports);
var _extends2$2H = _interopRequireDefault$9B(_extends$19.exports);
const _excluded$2O = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing$1 = createTransitions$1.easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const duration$1 = createTransitions$1.duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }
  const constant = height / 36;

  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = (0, _extends2$2H.default)({}, easing$1, inputTransitions.easing);
  const mergedDuration = (0, _extends2$2H.default)({}, duration$1, inputTransitions.duration);
  const create = (props = ['all'], options = {}) => {
    const {
        duration: durationOption = mergedDuration.standard,
        easing: easingOption = mergedEasing.easeInOut,
        delay = 0
      } = options,
      other = (0, _objectWithoutPropertiesLoose2$2k.default)(options, _excluded$2O);
    if (process.env.NODE_ENV !== 'production') {
      const isString = value => typeof value === 'string';
      // IE11 support, replace with Number.isNaN
      // eslint-disable-next-line no-restricted-globals
      const isNumber = value => !isNaN(parseFloat(value));
      if (!isString(props) && !Array.isArray(props)) {
        console.error('MUI: Argument "props" must be a string or Array.');
      }
      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
      }
      if (!isString(easingOption)) {
        console.error('MUI: Argument "easing" must be a string.');
      }
      if (!isNumber(delay) && !isString(delay)) {
        console.error('MUI: Argument "delay" must be a number or a string.');
      }
      if (typeof options !== 'object') {
        console.error(['MUI: Secong argument of transition.create must be an object.', "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join('\n'));
      }
      if (Object.keys(other).length !== 0) {
        console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(',')}].`);
      }
    }
    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };
  return (0, _extends2$2H.default)({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}

var zIndex$2 = {};

Object.defineProperty(zIndex$2, "__esModule", {
  value: true
});
zIndex$2.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex$1 = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
zIndex$2.default = zIndex$1;

var _interopRequireDefault$9A = interopRequireDefault$1.exports;
Object.defineProperty(createTheme$1, "__esModule", {
  value: true
});
createTheme$1.createMuiTheme = createMuiTheme;
createTheme$1.default = void 0;
var _extends2$2G = _interopRequireDefault$9A(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2j = _interopRequireDefault$9A(objectWithoutPropertiesLoose.exports);
var _formatMuiErrorMessage2$7 = _interopRequireDefault$9A(formatMuiErrorMessage$2);
var _deepmerge$9 = _interopRequireDefault$9A(deepmerge$2);
var _styleFunctionSx$8 = _interopRequireWildcard$4y(styleFunctionSx);
var _createTheme$7 = _interopRequireDefault$9A(createTheme$4);
var _generateUtilityClass$1Z = _interopRequireDefault$9A(generateUtilityClass$3);
var _createMixins = _interopRequireDefault$9A(createMixins$1);
var _createPalette = _interopRequireDefault$9A(createPalette$1);
var _createTypography$1 = _interopRequireDefault$9A(createTypography$1);
var _shadows$1 = _interopRequireDefault$9A(shadows$2);
var _createTransitions$1 = _interopRequireDefault$9A(createTransitions$1);
var _zIndex = _interopRequireDefault$9A(zIndex$2);
const _excluded$2N = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function _getRequireWildcardCache$4h(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4h = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4y(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4h(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function createTheme(options = {}, ...args) {
  const {
      mixins: mixinsInput = {},
      palette: paletteInput = {},
      transitions: transitionsInput = {},
      typography: typographyInput = {}
    } = options,
    other = (0, _objectWithoutPropertiesLoose2$2j.default)(options, _excluded$2N);
  if (options.vars) {
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`vars\` is a private field used for CSS variables support.
Please use another name.` : (0, _formatMuiErrorMessage2$7.default)(18));
  }
  const palette = (0, _createPalette.default)(paletteInput);
  const systemTheme = (0, _createTheme$7.default)(options);
  let muiTheme = (0, _deepmerge$9.default)(systemTheme, {
    mixins: (0, _createMixins.default)(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: _shadows$1.default.slice(),
    typography: (0, _createTypography$1.default)(palette, typographyInput),
    transitions: (0, _createTransitions$1.default)(transitionsInput),
    zIndex: (0, _extends2$2G.default)({}, _zIndex.default)
  });
  muiTheme = (0, _deepmerge$9.default)(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => (0, _deepmerge$9.default)(acc, argument), muiTheme);
  if (process.env.NODE_ENV !== 'production') {
    // TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
    const stateClasses = ['active', 'checked', 'completed', 'disabled', 'error', 'expanded', 'focused', 'focusVisible', 'required', 'selected'];
    const traverse = (node, component) => {
      let key;

      // eslint-disable-next-line guard-for-in, no-restricted-syntax
      for (key in node) {
        const child = node[key];
        if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            const stateClass = (0, _generateUtilityClass$1Z.default)('', key);
            console.error([`MUI: The \`${component}\` component increases ` + `the CSS specificity of the \`${key}\` internal state.`, 'You can not override it like this: ', JSON.stringify(node, null, 2), '', `Instead, you need to use the '&.${stateClass}' syntax:`, JSON.stringify({
              root: {
                [`&.${stateClass}`]: child
              }
            }, null, 2), '', 'https://mui.com/r/state-classes-guide'].join('\n'));
          }
          // Remove the style to prevent global conflicts.
          node[key] = {};
        }
      }
    };
    Object.keys(muiTheme.components).forEach(component => {
      const styleOverrides = muiTheme.components[component].styleOverrides;
      if (styleOverrides && component.indexOf('Mui') === 0) {
        traverse(styleOverrides, component);
      }
    });
  }
  muiTheme.unstable_sxConfig = (0, _extends2$2G.default)({}, _styleFunctionSx$8.unstable_defaultSxConfig, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return (0, _styleFunctionSx$8.default)({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
let warnedOnce$1 = false;
function createMuiTheme(...args) {
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnce$1) {
      warnedOnce$1 = true;
      console.error(['MUI: the createMuiTheme function was renamed to createTheme.', '', "You should use `import { createTheme } from '@mui/material/styles'`"].join('\n'));
    }
  }
  return createTheme(...args);
}
createTheme$1.default = createTheme;

var _interopRequireDefault$9z = interopRequireDefault$1.exports;
Object.defineProperty(defaultTheme$7, "__esModule", {
  value: true
});
defaultTheme$7.default = void 0;
var _createTheme$6 = _interopRequireDefault$9z(createTheme$1);
const defaultTheme$6 = (0, _createTheme$6.default)();
defaultTheme$7.default = defaultTheme$6;

var identifier = {};

Object.defineProperty(identifier, "__esModule", {
  value: true
});
identifier.default = void 0;
identifier.default = '$$material';

var _interopRequireDefault$9y = interopRequireDefault$1.exports;
Object.defineProperty(useThemeProps$4, "__esModule", {
  value: true
});
useThemeProps$4.default = useThemeProps;
var _useThemeProps$5 = _interopRequireDefault$9y(useThemeProps$3);
var _defaultTheme$2 = _interopRequireDefault$9y(defaultTheme$7);
var _identifier$5 = _interopRequireDefault$9y(identifier);
function useThemeProps({
  props,
  name
}) {
  return (0, _useThemeProps$5.default)({
    props,
    name,
    defaultTheme: _defaultTheme$2.default,
    themeId: _identifier$5.default
  });
}

var styled$2 = {};

var createStyled$1 = {};

var getDisplayName$3 = {};

var getDisplayName$2 = {};

var reactIs$2 = {exports: {}};

var reactIs_production = {};

/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
  REACT_PORTAL_TYPE = Symbol.for("react.portal"),
  REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
  REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
  REACT_PROFILER_TYPE = Symbol.for("react.profiler"),
  REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
  REACT_CONTEXT_TYPE = Symbol.for("react.context"),
  REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
  REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
  REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
  REACT_MEMO_TYPE = Symbol.for("react.memo"),
  REACT_LAZY_TYPE = Symbol.for("react.lazy"),
  REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"),
  REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf$1(object) {
  if ("object" === typeof object && null !== object) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        switch (((object = object.type), object)) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
          case REACT_VIEW_TRANSITION_TYPE:
            return object;
          default:
            switch (((object = object && object.$$typeof), object)) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
                return object;
              case REACT_CONSUMER_TYPE:
                return object;
              default:
                return $$typeof;
            }
        }
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }
}
reactIs_production.ContextConsumer = REACT_CONSUMER_TYPE;
reactIs_production.ContextProvider = REACT_CONTEXT_TYPE;
reactIs_production.Element = REACT_ELEMENT_TYPE;
reactIs_production.ForwardRef = REACT_FORWARD_REF_TYPE;
reactIs_production.Fragment = REACT_FRAGMENT_TYPE;
reactIs_production.Lazy = REACT_LAZY_TYPE;
reactIs_production.Memo = REACT_MEMO_TYPE;
reactIs_production.Portal = REACT_PORTAL_TYPE;
reactIs_production.Profiler = REACT_PROFILER_TYPE;
reactIs_production.StrictMode = REACT_STRICT_MODE_TYPE;
reactIs_production.Suspense = REACT_SUSPENSE_TYPE;
reactIs_production.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
reactIs_production.isContextConsumer = function (object) {
  return typeOf$1(object) === REACT_CONSUMER_TYPE;
};
reactIs_production.isContextProvider = function (object) {
  return typeOf$1(object) === REACT_CONTEXT_TYPE;
};
reactIs_production.isElement = function (object) {
  return (
    "object" === typeof object &&
    null !== object &&
    object.$$typeof === REACT_ELEMENT_TYPE
  );
};
reactIs_production.isForwardRef = function (object) {
  return typeOf$1(object) === REACT_FORWARD_REF_TYPE;
};
reactIs_production.isFragment = function (object) {
  return typeOf$1(object) === REACT_FRAGMENT_TYPE;
};
reactIs_production.isLazy = function (object) {
  return typeOf$1(object) === REACT_LAZY_TYPE;
};
reactIs_production.isMemo = function (object) {
  return typeOf$1(object) === REACT_MEMO_TYPE;
};
reactIs_production.isPortal = function (object) {
  return typeOf$1(object) === REACT_PORTAL_TYPE;
};
reactIs_production.isProfiler = function (object) {
  return typeOf$1(object) === REACT_PROFILER_TYPE;
};
reactIs_production.isStrictMode = function (object) {
  return typeOf$1(object) === REACT_STRICT_MODE_TYPE;
};
reactIs_production.isSuspense = function (object) {
  return typeOf$1(object) === REACT_SUSPENSE_TYPE;
};
reactIs_production.isSuspenseList = function (object) {
  return typeOf$1(object) === REACT_SUSPENSE_LIST_TYPE;
};
reactIs_production.isValidElementType = function (type) {
  return "string" === typeof type ||
    "function" === typeof type ||
    type === REACT_FRAGMENT_TYPE ||
    type === REACT_PROFILER_TYPE ||
    type === REACT_STRICT_MODE_TYPE ||
    type === REACT_SUSPENSE_TYPE ||
    type === REACT_SUSPENSE_LIST_TYPE ||
    ("object" === typeof type &&
      null !== type &&
      (type.$$typeof === REACT_LAZY_TYPE ||
        type.$$typeof === REACT_MEMO_TYPE ||
        type.$$typeof === REACT_CONTEXT_TYPE ||
        type.$$typeof === REACT_CONSUMER_TYPE ||
        type.$$typeof === REACT_FORWARD_REF_TYPE ||
        type.$$typeof === REACT_CLIENT_REFERENCE ||
        void 0 !== type.getModuleId))
    ? !0
    : !1;
};
reactIs_production.typeOf = typeOf$1;

var reactIs_development$2 = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" !== process.env.NODE_ENV &&
  (function () {
    function typeOf(object) {
      if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            switch (((object = object.type), object)) {
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
              case REACT_SUSPENSE_LIST_TYPE:
              case REACT_VIEW_TRANSITION_TYPE:
                return object;
              default:
                switch (((object = object && object.$$typeof), object)) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                    return object;
                  case REACT_CONSUMER_TYPE:
                    return object;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
      REACT_PORTAL_TYPE = Symbol.for("react.portal"),
      REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
      REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
      REACT_PROFILER_TYPE = Symbol.for("react.profiler"),
      REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
      REACT_CONTEXT_TYPE = Symbol.for("react.context"),
      REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
      REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
      REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
      REACT_MEMO_TYPE = Symbol.for("react.memo"),
      REACT_LAZY_TYPE = Symbol.for("react.lazy"),
      REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"),
      REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    reactIs_development$2.ContextConsumer = REACT_CONSUMER_TYPE;
    reactIs_development$2.ContextProvider = REACT_CONTEXT_TYPE;
    reactIs_development$2.Element = REACT_ELEMENT_TYPE;
    reactIs_development$2.ForwardRef = REACT_FORWARD_REF_TYPE;
    reactIs_development$2.Fragment = REACT_FRAGMENT_TYPE;
    reactIs_development$2.Lazy = REACT_LAZY_TYPE;
    reactIs_development$2.Memo = REACT_MEMO_TYPE;
    reactIs_development$2.Portal = REACT_PORTAL_TYPE;
    reactIs_development$2.Profiler = REACT_PROFILER_TYPE;
    reactIs_development$2.StrictMode = REACT_STRICT_MODE_TYPE;
    reactIs_development$2.Suspense = REACT_SUSPENSE_TYPE;
    reactIs_development$2.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    reactIs_development$2.isContextConsumer = function (object) {
      return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    reactIs_development$2.isContextProvider = function (object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    reactIs_development$2.isElement = function (object) {
      return (
        "object" === typeof object &&
        null !== object &&
        object.$$typeof === REACT_ELEMENT_TYPE
      );
    };
    reactIs_development$2.isForwardRef = function (object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    reactIs_development$2.isFragment = function (object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    reactIs_development$2.isLazy = function (object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    };
    reactIs_development$2.isMemo = function (object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    };
    reactIs_development$2.isPortal = function (object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    };
    reactIs_development$2.isProfiler = function (object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    };
    reactIs_development$2.isStrictMode = function (object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    reactIs_development$2.isSuspense = function (object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    reactIs_development$2.isSuspenseList = function (object) {
      return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    reactIs_development$2.isValidElementType = function (type) {
      return "string" === typeof type ||
        "function" === typeof type ||
        type === REACT_FRAGMENT_TYPE ||
        type === REACT_PROFILER_TYPE ||
        type === REACT_STRICT_MODE_TYPE ||
        type === REACT_SUSPENSE_TYPE ||
        type === REACT_SUSPENSE_LIST_TYPE ||
        ("object" === typeof type &&
          null !== type &&
          (type.$$typeof === REACT_LAZY_TYPE ||
            type.$$typeof === REACT_MEMO_TYPE ||
            type.$$typeof === REACT_CONTEXT_TYPE ||
            type.$$typeof === REACT_CONSUMER_TYPE ||
            type.$$typeof === REACT_FORWARD_REF_TYPE ||
            type.$$typeof === REACT_CLIENT_REFERENCE ||
            void 0 !== type.getModuleId))
        ? !0
        : !1;
    };
    reactIs_development$2.typeOf = typeOf;
  })();

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = reactIs_production;
} else {
  reactIs$2.exports = reactIs_development$2;
}

Object.defineProperty(getDisplayName$2, "__esModule", {
  value: true
});
getDisplayName$2.default = getDisplayName$1;
getDisplayName$2.getFunctionName = getFunctionName;
var _reactIs$c = reactIs$2.exports;
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  const match = `${fn}`.match(fnNameMatchRegex);
  const name = match && match[1];
  return name || '';
}
function getFunctionComponentName(Component, fallback = '') {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}

/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE11 support
 */
function getDisplayName$1(Component) {
  if (Component == null) {
    return undefined;
  }
  if (typeof Component === 'string') {
    return Component;
  }
  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
  if (typeof Component === 'object') {
    switch (Component.$$typeof) {
      case _reactIs$c.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');
      case _reactIs$c.Memo:
        return getWrappedName(Component, Component.type, 'memo');
      default:
        return undefined;
    }
  }
  return undefined;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _getDisplayName.default;
  }
});
var _getDisplayName = _interopRequireWildcard(getDisplayName$2);
Object.keys(_getDisplayName).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getDisplayName[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getDisplayName[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(getDisplayName$3));

var _interopRequireDefault$9x = interopRequireDefault$1.exports;
Object.defineProperty(createStyled$1, "__esModule", {
  value: true
});
createStyled$1.default = createStyled;
createStyled$1.shouldForwardProp = shouldForwardProp;
createStyled$1.systemDefaultTheme = void 0;
var _extends2$2F = _interopRequireDefault$9x(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2i = _interopRequireDefault$9x(objectWithoutPropertiesLoose.exports);
var _styledEngine$4 = _interopRequireWildcard$4x(node$3);
var _deepmerge$8 = deepmerge$2;
var _capitalize$N = _interopRequireDefault$9x(capitalize$4);
var _getDisplayName$1 = _interopRequireDefault$9x(getDisplayName$3);
var _createTheme$5 = _interopRequireDefault$9x(createTheme$4);
var _styleFunctionSx$7 = _interopRequireDefault$9x(styleFunctionSx);
const _excluded$2M = ["ownerState"],
  _excluded2$q = ["variants"],
  _excluded3$4 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
/* eslint-disable no-underscore-dangle */
function _getRequireWildcardCache$4g(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4g = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4x(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4g(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function isEmpty$3(obj) {
  return Object.keys(obj).length === 0;
}

// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
  return typeof tag === 'string' &&
  // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96;
}

// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function shallowLayer(serialized, layerName) {
  if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
  ) {
    serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
  }
  return serialized;
}
const systemDefaultTheme = createStyled$1.systemDefaultTheme = (0, _createTheme$5.default)();
const lowercaseFirstLetter$1 = string => {
  if (!string) {
    return string;
  }
  return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({
  defaultTheme,
  theme,
  themeId
}) {
  return isEmpty$3(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
  if (!slot) {
    return null;
  }
  return (props, styles) => styles[slot];
}
function processStyleArg(callableStyle, _ref, layerName) {
  let {
      ownerState
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2$2i.default)(_ref, _excluded$2M);
  const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, _extends2$2F.default)({
    ownerState
  }, props)) : callableStyle;
  if (Array.isArray(resolvedStylesArg)) {
    return resolvedStylesArg.flatMap(resolvedStyle => processStyleArg(resolvedStyle, (0, _extends2$2F.default)({
      ownerState
    }, props), layerName));
  }
  if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
    const {
        variants = []
      } = resolvedStylesArg,
      otherStyles = (0, _objectWithoutPropertiesLoose2$2i.default)(resolvedStylesArg, _excluded2$q);
    let result = otherStyles;
    variants.forEach(variant => {
      let isMatch = true;
      if (typeof variant.props === 'function') {
        isMatch = variant.props((0, _extends2$2F.default)({
          ownerState
        }, props, ownerState));
      } else {
        Object.keys(variant.props).forEach(key => {
          if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) {
            isMatch = false;
          }
        });
      }
      if (isMatch) {
        if (!Array.isArray(result)) {
          result = [result];
        }
        const variantStyle = typeof variant.style === 'function' ? variant.style((0, _extends2$2F.default)({
          ownerState
        }, props, ownerState)) : variant.style;
        result.push(layerName ? shallowLayer((0, _styledEngine$4.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
      }
    });
    return result;
  }
  return layerName ? shallowLayer((0, _styledEngine$4.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function createStyled(input = {}) {
  const {
    themeId,
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  const systemSx = props => {
    return (0, _styleFunctionSx$7.default)((0, _extends2$2F.default)({}, props, {
      theme: resolveTheme((0, _extends2$2F.default)({}, props, {
        defaultTheme,
        themeId
      }))
    }));
  };
  systemSx.__mui_systemSx = true;
  return (tag, inputOptions = {}) => {
    // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
    (0, _styledEngine$4.internal_processStyles)(tag, styles => styles.filter(style => !(style != null && style.__mui_systemSx)));
    const {
        name: componentName,
        slot: componentSlot,
        skipVariantsResolver: inputSkipVariantsResolver,
        skipSx: inputSkipSx,
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter$1(componentSlot))
      } = inputOptions,
      options = (0, _objectWithoutPropertiesLoose2$2i.default)(inputOptions, _excluded3$4);
    const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';

    // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver :
    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
    const skipSx = inputSkipSx || false;
    let label;
    if (process.env.NODE_ENV !== 'production') {
      if (componentName) {
        // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${lowercaseFirstLetter$1(componentSlot || 'Root')}`;
      }
    }
    let shouldForwardPropOption = shouldForwardProp;

    // TODO v6: remove `Root` in the next major release
    // For more details: https://github.com/mui/material-ui/pull/37908
    if (componentSlot === 'Root' || componentSlot === 'root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    } else if (isStringTag(tag)) {
      // for string (html) tag, preserve the behavior in emotion & styled-components.
      shouldForwardPropOption = undefined;
    }
    const defaultStyledResolver = (0, _styledEngine$4.default)(tag, (0, _extends2$2F.default)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));
    const transformStyleArg = stylesArg => {
      // On the server Emotion doesn't use React.forwardRef for creating components, so the created
      // component stays as a function. This condition makes sure that we do not interpolate functions
      // which are basically components used as a selectors.
      if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge$8.isPlainObject)(stylesArg)) {
        return props => {
          const theme = resolveTheme({
            theme: props.theme,
            defaultTheme,
            themeId
          });
          return processStyleArg(stylesArg, (0, _extends2$2F.default)({}, props, {
            theme
          }), theme.modularCssLayers ? layerName : undefined);
        };
      }
      return stylesArg;
    };
    const muiStyledResolver = (styleArg, ...expressions) => {
      let transformedStyleArg = transformStyleArg(styleArg);
      const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = resolveTheme((0, _extends2$2F.default)({}, props, {
            defaultTheme,
            themeId
          }));
          if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) {
            return null;
          }
          const styleOverrides = theme.components[componentName].styleOverrides;
          const resolvedStyleOverrides = {};
          // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
          Object.entries(styleOverrides).forEach(([slotKey, slotStyle]) => {
            resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extends2$2F.default)({}, props, {
              theme
            }), theme.modularCssLayers ? 'theme' : undefined);
          });
          return overridesResolver(props, resolvedStyleOverrides);
        });
      }
      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          var _theme$components;
          const theme = resolveTheme((0, _extends2$2F.default)({}, props, {
            defaultTheme,
            themeId
          }));
          const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
          return processStyleArg({
            variants: themeVariants
          }, (0, _extends2$2F.default)({}, props, {
            theme
          }), theme.modularCssLayers ? 'theme' : undefined);
        });
      }
      if (!skipSx) {
        expressionsWithDefaultTheme.push(systemSx);
      }
      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill('');
        // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      }
      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
      if (process.env.NODE_ENV !== 'production') {
        let displayName;
        if (componentName) {
          displayName = `${componentName}${(0, _capitalize$N.default)(componentSlot || '')}`;
        }
        if (displayName === undefined) {
          displayName = `Styled(${(0, _getDisplayName$1.default)(tag)})`;
        }
        Component.displayName = displayName;
      }
      if (tag.muiName) {
        Component.muiName = tag.muiName;
      }
      return Component;
    };
    if (defaultStyledResolver.withConfig) {
      muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
    }
    return muiStyledResolver;
  };
}

var rootShouldForwardProp$1 = {};

var slotShouldForwardProp$1 = {};

Object.defineProperty(slotShouldForwardProp$1, "__esModule", {
  value: true
});
slotShouldForwardProp$1.default = void 0;
// copied from @mui/system/createStyled
function slotShouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
slotShouldForwardProp$1.default = slotShouldForwardProp;

var _interopRequireDefault$9w = interopRequireDefault$1.exports;
Object.defineProperty(rootShouldForwardProp$1, "__esModule", {
  value: true
});
rootShouldForwardProp$1.default = void 0;
var _slotShouldForwardProp$1 = _interopRequireDefault$9w(slotShouldForwardProp$1);
const rootShouldForwardProp = prop => (0, _slotShouldForwardProp$1.default)(prop) && prop !== 'classes';
rootShouldForwardProp$1.default = rootShouldForwardProp;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "rootShouldForwardProp", {
  enumerable: true,
  get: function () {
    return _rootShouldForwardProp.default;
  }
});
Object.defineProperty(exports, "slotShouldForwardProp", {
  enumerable: true,
  get: function () {
    return _slotShouldForwardProp.default;
  }
});
var _createStyled = _interopRequireDefault(createStyled$1);
var _defaultTheme = _interopRequireDefault(defaultTheme$7);
var _identifier = _interopRequireDefault(identifier);
var _rootShouldForwardProp = _interopRequireDefault(rootShouldForwardProp$1);
var _slotShouldForwardProp = _interopRequireDefault(slotShouldForwardProp$1);
const styled = (0, _createStyled.default)({
  themeId: _identifier.default,
  defaultTheme: _defaultTheme.default,
  rootShouldForwardProp: _rootShouldForwardProp.default
});
exports.default = styled;
}(styled$2));

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUseThemeProps = createUseThemeProps;
Object.defineProperty(exports, "styled", {
  enumerable: true,
  get: function () {
    return _styled.default;
  }
});
var _useThemeProps = _interopRequireDefault(useThemeProps$4);
var _styled = _interopRequireDefault(styled$2);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function createUseThemeProps(name) {
  return _useThemeProps.default;
}
}(zeroStyled));

var DefaultPropsProvider$5 = {};

var DefaultPropsProvider$4 = {};

var DefaultPropsProvider$3 = {};

var DefaultPropsProvider$2 = {};

var _interopRequireDefault$9v = interopRequireDefault$1.exports;
Object.defineProperty(DefaultPropsProvider$2, "__esModule", {
  value: true
});
DefaultPropsProvider$2.default = void 0;
DefaultPropsProvider$2.useDefaultProps = useDefaultProps$1;
var React$33 = _interopRequireWildcard$4w(React__default$4);
var _propTypes$37 = _interopRequireDefault$9v(propTypes.exports);
var _resolveProps$2 = _interopRequireDefault$9v(resolveProps$2);
var _jsxRuntime$2U = require$$11;
function _getRequireWildcardCache$4f(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4f = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4w(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4f(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PropsContext = /*#__PURE__*/React$33.createContext(undefined);
function DefaultPropsProvider$1({
  value,
  children
}) {
  return /*#__PURE__*/(0, _jsxRuntime$2U.jsx)(PropsContext.Provider, {
    value: value,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? DefaultPropsProvider$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: _propTypes$37.default.node,
  /**
   * @ignore
   */
  value: _propTypes$37.default.object
} : void 0;
function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name]) {
    return props;
  }
  const config = theme.components[name];
  if (config.defaultProps) {
    // compatible with v5 signature
    return (0, _resolveProps$2.default)(config.defaultProps, props);
  }
  if (!config.styleOverrides && !config.variants) {
    // v6 signature, no property 'defaultProps'
    return (0, _resolveProps$2.default)(config, props);
  }
  return props;
}
function useDefaultProps$1({
  props,
  name
}) {
  const ctx = React$33.useContext(PropsContext);
  return getThemeProps({
    props,
    name,
    theme: {
      components: ctx
    }
  });
}
DefaultPropsProvider$2.default = DefaultPropsProvider$1;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _DefaultPropsProvider.default;
  }
});
Object.defineProperty(exports, "useDefaultProps", {
  enumerable: true,
  get: function () {
    return _DefaultPropsProvider.useDefaultProps;
  }
});
var _DefaultPropsProvider = _interopRequireWildcard(DefaultPropsProvider$2);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(DefaultPropsProvider$3));

var _interopRequireDefault$9u = interopRequireDefault$1.exports;
Object.defineProperty(DefaultPropsProvider$4, "__esModule", {
  value: true
});
DefaultPropsProvider$4.default = void 0;
DefaultPropsProvider$4.useDefaultProps = useDefaultProps;
var _extends2$2E = _interopRequireDefault$9u(_extends$19.exports);
_interopRequireWildcard$4v(React__default$4);
var _propTypes$36 = _interopRequireDefault$9u(propTypes.exports);
var _DefaultPropsProvider$1R = _interopRequireWildcard$4v(DefaultPropsProvider$3);
var _jsxRuntime$2T = require$$11;
function _getRequireWildcardCache$4e(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4e = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4v(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4e(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function DefaultPropsProvider(props) {
  return /*#__PURE__*/(0, _jsxRuntime$2T.jsx)(_DefaultPropsProvider$1R.default, (0, _extends2$2E.default)({}, props));
}
process.env.NODE_ENV !== "production" ? DefaultPropsProvider.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: _propTypes$36.default.node,
  /**
   * @ignore
   */
  value: _propTypes$36.default.object.isRequired
} : void 0;
DefaultPropsProvider$4.default = DefaultPropsProvider;
function useDefaultProps(params) {
  return (0, _DefaultPropsProvider$1R.useDefaultProps)(params);
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _DefaultPropsProvider.default;
  }
});
Object.defineProperty(exports, "useDefaultProps", {
  enumerable: true,
  get: function () {
    return _DefaultPropsProvider.useDefaultProps;
  }
});
var _DefaultPropsProvider = _interopRequireWildcard(DefaultPropsProvider$4);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(DefaultPropsProvider$5));

var Collapse$2 = {};

var Collapse$1 = {};

var cjs$4 = {};

var CSSTransition = {exports: {}};

var addClass = {exports: {}};

var hasClass = {exports: {}};

(function (module, exports) {

exports.__esModule = true;
exports.default = hasClass;

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];
}(hasClass, hasClass.exports));

(function (module, exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(hasClass.exports);

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

module.exports = exports["default"];
}(addClass, addClass.exports));

var removeClass = {exports: {}};

(function (module, exports) {

exports.__esModule = true;
exports.default = removeClass;

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

module.exports = exports["default"];
}(removeClass, removeClass.exports));

var Transition$1 = {};

var config$3 = {exports: {}};

(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;
var _default = {
  disabled: false
};
exports.default = _default;
module.exports = exports.default;
}(config$3, config$3.exports));

var PropTypes$4 = {};

PropTypes$4.__esModule = true;
PropTypes$4.classNamesShape = PropTypes$4.timeoutsShape = void 0;

var _propTypes$35 = _interopRequireDefault$9t(propTypes.exports);

function _interopRequireDefault$9t(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape = process.env.NODE_ENV !== 'production' ? _propTypes$35.default.oneOfType([_propTypes$35.default.number, _propTypes$35.default.shape({
  enter: _propTypes$35.default.number,
  exit: _propTypes$35.default.number,
  appear: _propTypes$35.default.number
}).isRequired]) : null;
PropTypes$4.timeoutsShape = timeoutsShape;
var classNamesShape = process.env.NODE_ENV !== 'production' ? _propTypes$35.default.oneOfType([_propTypes$35.default.string, _propTypes$35.default.shape({
  enter: _propTypes$35.default.string,
  exit: _propTypes$35.default.string,
  active: _propTypes$35.default.string
}), _propTypes$35.default.shape({
  enter: _propTypes$35.default.string,
  enterDone: _propTypes$35.default.string,
  enterActive: _propTypes$35.default.string,
  exit: _propTypes$35.default.string,
  exitDone: _propTypes$35.default.string,
  exitActive: _propTypes$35.default.string
})]) : null;
PropTypes$4.classNamesShape = classNamesShape;

var TransitionGroupContext = {exports: {}};

(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(React__default$4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createContext(null);

exports.default = _default;
module.exports = exports.default;
}(TransitionGroupContext, TransitionGroupContext.exports));

var reflow$1 = {};

reflow$1.__esModule = true;
reflow$1.forceReflow = void 0;

var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};

reflow$1.forceReflow = forceReflow;

Transition$1.__esModule = true;
Transition$1.default = Transition$1.EXITING = Transition$1.ENTERED = Transition$1.ENTERING = Transition$1.EXITED = Transition$1.UNMOUNTED = void 0;

var _propTypes$34 = _interopRequireDefault$9s(propTypes.exports);

var _react$23 = _interopRequireDefault$9s(React__default$4);

var _reactDom$2 = _interopRequireDefault$9s(require$$2$1);

var _config$1 = _interopRequireDefault$9s(config$3.exports);

var _PropTypes = PropTypes$4;

var _TransitionGroupContext$1 = _interopRequireDefault$9s(TransitionGroupContext.exports);

var _reflow = reflow$1;

function _interopRequireDefault$9s(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose$u(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
Transition$1.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
Transition$1.EXITED = EXITED;
var ENTERING = 'entering';
Transition$1.ENTERING = ENTERING;
var ENTERED = 'entered';
Transition$1.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

Transition$1.EXITING = EXITING;

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$1(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom$2.default.findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
          // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
          // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.

          if (node) (0, _reflow.forceReflow)(node);
        }

        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [_reactDom$2.default.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || _config$1.default.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : _reactDom$2.default.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || _config$1.default.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : _reactDom$2.default.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$u(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      _react$23.default.createElement(_TransitionGroupContext$1.default.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : _react$23.default.cloneElement(_react$23.default.Children.only(children), childProps))
    );
  };

  return Transition;
}(_react$23.default.Component);

Transition.contextType = _TransitionGroupContext$1.default;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: _propTypes$34.default.shape({
    current: typeof Element === 'undefined' ? _propTypes$34.default.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return _propTypes$34.default.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: _propTypes$34.default.oneOfType([_propTypes$34.default.func.isRequired, _propTypes$34.default.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: _propTypes$34.default.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: _propTypes$34.default.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: _propTypes$34.default.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: _propTypes$34.default.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: _propTypes$34.default.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: _propTypes$34.default.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: _propTypes$34.default.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: _propTypes$34.default.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: _propTypes$34.default.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: _propTypes$34.default.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: _propTypes$34.default.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: _propTypes$34.default.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: _propTypes$34.default.func
} : {}; // Name the function so it is clearer in the documentation

function noop$6() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$6,
  onEntering: noop$6,
  onEntered: noop$6,
  onExit: noop$6,
  onExiting: noop$6,
  onExited: noop$6
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var _default$1F = Transition;
Transition$1.default = _default$1F;

(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(propTypes.exports);

var _addClass2 = _interopRequireDefault(addClass.exports);

var _removeClass = _interopRequireDefault(removeClass.exports);

var _react = _interopRequireDefault(React__default$4);

var _Transition = _interopRequireDefault(Transition$1);

var _PropTypes = PropTypes$4;

var _reflow = reflow$1;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};

var removeClass$1 = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      if (node) (0, _reflow.forceReflow)(node);
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

    return /*#__PURE__*/_react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: _propTypes.default.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: _propTypes.default.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: _propTypes.default.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: _propTypes.default.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: _propTypes.default.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: _propTypes.default.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports.default;
}(CSSTransition, CSSTransition.exports));

var ReplaceTransition = {exports: {}};

var TransitionGroup = {exports: {}};

var ChildMapping = {};

ChildMapping.__esModule = true;
ChildMapping.getChildMapping = getChildMapping;
ChildMapping.mergeChildMappings = mergeChildMappings;
ChildMapping.getInitialChildMapping = getInitialChildMapping;
ChildMapping.getNextChildMapping = getNextChildMapping;

var _react$22 = React__default$4;

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react$22.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react$22.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react$22.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react$22.isValidElement)(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react$22.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react$22.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react$22.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react$22.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react$22.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(propTypes.exports);

var _react = _interopRequireDefault(React__default$4);

var _TransitionGroupContext = _interopRequireDefault(TransitionGroupContext.exports);

var _ChildMapping = ChildMapping;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/_react.default.createElement(_TransitionGroupContext.default.Provider, {
      value: contextValue
    }, /*#__PURE__*/_react.default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;
var _default = TransitionGroup;
exports.default = _default;
module.exports = exports.default;
}(TransitionGroup, TransitionGroup.exports));

(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(propTypes.exports);

var _react = _interopRequireDefault(React__default$4);

var _reactDom = _interopRequireDefault(require$$2$1);

var _TransitionGroup = _interopRequireDefault(TransitionGroup.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : _reactDom.default.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/_react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports.default;
}(ReplaceTransition, ReplaceTransition.exports));

var SwitchTransition$1 = {};

SwitchTransition$1.__esModule = true;
SwitchTransition$1.default = SwitchTransition$1.modes = void 0;

var _react$21 = _interopRequireDefault$9r(React__default$4);

var _propTypes$33 = _interopRequireDefault$9r(propTypes.exports);

var _Transition$1 = Transition$1;

var _TransitionGroupContext = _interopRequireDefault$9r(TransitionGroupContext.exports);

var _leaveRenders, _enterRenders;

function _interopRequireDefault$9r(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (_react$21.default.isValidElement(oldChildren) && _react$21.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};
SwitchTransition$1.modes = modes;

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return _react$21.default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(_Transition$1.ENTERING, null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, _react$21.default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(_Transition$1.ENTERING);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return _react$21.default.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(_Transition$1.ENTERED, _react$21.default.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [_react$21.default.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(_Transition$1.ENTERED, _react$21.default.cloneElement(children, {
        in: true
      }));
    })
  }), _react$21.default.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: _Transition$1.ENTERED,
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === _Transition$1.ENTERING && props.mode === modes.in) {
      return {
        status: _Transition$1.ENTERING
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: _Transition$1.EXITING
      };
    }

    return {
      current: _react$21.default.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case _Transition$1.ENTERING:
        component = enterRenders[mode](data);
        break;

      case _Transition$1.EXITING:
        component = leaveRenders[mode](data);
        break;

      case _Transition$1.ENTERED:
        component = current;
    }

    return /*#__PURE__*/_react$21.default.createElement(_TransitionGroupContext.default.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(_react$21.default.Component);

SwitchTransition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: _propTypes$33.default.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: _propTypes$33.default.oneOfType([_propTypes$33.default.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
var _default$1E = SwitchTransition;
SwitchTransition$1.default = _default$1E;

cjs$4.__esModule = true;
cjs$4.config = cjs$4.Transition = cjs$4.TransitionGroup = cjs$4.SwitchTransition = cjs$4.ReplaceTransition = cjs$4.CSSTransition = void 0;

var _CSSTransition = _interopRequireDefault$9q(CSSTransition.exports);

cjs$4.CSSTransition = _CSSTransition.default;

var _ReplaceTransition = _interopRequireDefault$9q(ReplaceTransition.exports);

cjs$4.ReplaceTransition = _ReplaceTransition.default;

var _SwitchTransition = _interopRequireDefault$9q(SwitchTransition$1);

cjs$4.SwitchTransition = _SwitchTransition.default;

var _TransitionGroup = _interopRequireDefault$9q(TransitionGroup.exports);

cjs$4.TransitionGroup = _TransitionGroup.default;

var _Transition = _interopRequireDefault$9q(Transition$1);

cjs$4.Transition = _Transition.default;

var _config = _interopRequireDefault$9q(config$3.exports);

cjs$4.config = _config.default;

function _interopRequireDefault$9q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useTimeout$2 = {};

var useTimeout$1 = {};

var useLazyRef$2 = {};

Object.defineProperty(useLazyRef$2, "__esModule", {
  value: true
});
useLazyRef$2.default = useLazyRef$1;
var React$32 = _interopRequireWildcard$4u(React__default$4);
function _getRequireWildcardCache$4d(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4d = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4u(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4d(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UNINITIALIZED = {};

/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */
function useLazyRef$1(init, initArg) {
  const ref = React$32.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init(initArg);
  }
  return ref;
}

var useOnMount$2 = {};

Object.defineProperty(useOnMount$2, "__esModule", {
  value: true
});
useOnMount$2.default = useOnMount$1;
var React$31 = _interopRequireWildcard$4t(React__default$4);
function _getRequireWildcardCache$4c(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4c = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4t(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4c(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EMPTY = [];

/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */
function useOnMount$1(fn) {
  /* eslint-disable react-hooks/exhaustive-deps */
  React$31.useEffect(fn, EMPTY);
  /* eslint-enable react-hooks/exhaustive-deps */
}

var _interopRequireDefault$9p = interopRequireDefault$1.exports;
Object.defineProperty(useTimeout$1, "__esModule", {
  value: true
});
useTimeout$1.Timeout = void 0;
useTimeout$1.default = useTimeout;
var _useLazyRef = _interopRequireDefault$9p(useLazyRef$2);
var _useOnMount = _interopRequireDefault$9p(useOnMount$2);
class Timeout {
  constructor() {
    this.currentId = null;
    this.clear = () => {
      if (this.currentId !== null) {
        clearTimeout(this.currentId);
        this.currentId = null;
      }
    };
    this.disposeEffect = () => {
      return this.clear;
    };
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(delay, fn) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = null;
      fn();
    }, delay);
  }
}
useTimeout$1.Timeout = Timeout;
function useTimeout() {
  const timeout = (0, _useLazyRef.default)(Timeout.create).current;
  (0, _useOnMount.default)(timeout.disposeEffect);
  return timeout;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Timeout", {
  enumerable: true,
  get: function () {
    return _useTimeout.Timeout;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useTimeout.default;
  }
});
var _useTimeout = _interopRequireWildcard(useTimeout$1);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(useTimeout$2));

var elementTypeAcceptingRef$2 = {};

var elementTypeAcceptingRef$1 = {};

var _interopRequireDefault$9o = interopRequireDefault$1.exports;
Object.defineProperty(elementTypeAcceptingRef$1, "__esModule", {
  value: true
});
elementTypeAcceptingRef$1.default = void 0;
var _propTypes$32 = _interopRequireDefault$9o(propTypes.exports);
var _chainPropTypes$e = _interopRequireDefault$9o(chainPropTypes$2);
function isClassComponent$1(elementType) {
  // elementType.prototype?.isReactComponent
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null ||
  // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === 'undefined') {
    return null;
  }
  let warningHint;

  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */
  if (typeof propValue === 'function' && !isClassComponent$1(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }
  if (warningHint !== undefined) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }
  return null;
}
elementTypeAcceptingRef$1.default = (0, _chainPropTypes$e.default)(_propTypes$32.default.elementType, elementTypeAcceptingRef);

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _elementTypeAcceptingRef.default;
  }
});
var _elementTypeAcceptingRef = _interopRequireDefault(elementTypeAcceptingRef$1);
}(elementTypeAcceptingRef$2));

var utils$8 = {};

Object.defineProperty(utils$8, "__esModule", {
  value: true
});
utils$8.getTransitionProps = getTransitionProps;
utils$8.reflow = void 0;
const reflow = node => node.scrollTop;
utils$8.reflow = reflow;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;
  const {
    timeout,
    easing,
    style = {}
  } = props;
  return {
    duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
    delay: style.transitionDelay
  };
}

var useTheme$4 = {};

var system = {};

var GlobalStyles$5 = {};

var GlobalStyles$4 = {};

var _interopRequireDefault$9n = interopRequireDefault$1.exports;
Object.defineProperty(GlobalStyles$4, "__esModule", {
  value: true
});
GlobalStyles$4.default = void 0;
_interopRequireWildcard$4s(React__default$4);
var _propTypes$31 = _interopRequireDefault$9n(propTypes.exports);
var _styledEngine$3 = node$3;
var _useTheme$i = _interopRequireDefault$9n(useTheme$8);
var _jsxRuntime$2S = require$$11;
function _getRequireWildcardCache$4b(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4b = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4s(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4b(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function wrapGlobalLayer(styles) {
  const serialized = (0, _styledEngine$3.internal_serializeStyles)(styles);
  if (styles !== serialized && serialized.styles) {
    if (!serialized.styles.match(/^@layer\s+[^{]*$/)) {
      // If the styles are not already wrapped in a layer, wrap them in a global layer.
      serialized.styles = `@layer global{${serialized.styles}}`;
    }
    return serialized;
  }
  return styles;
}
function GlobalStyles$3({
  styles,
  themeId,
  defaultTheme = {}
}) {
  const upperTheme = (0, _useTheme$i.default)(defaultTheme);
  const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
  let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
  if (resolvedTheme.modularCssLayers) {
    if (Array.isArray(globalStyles)) {
      globalStyles = globalStyles.map(styleArg => {
        if (typeof styleArg === 'function') {
          return wrapGlobalLayer(styleArg(resolvedTheme));
        }
        return wrapGlobalLayer(styleArg);
      });
    } else {
      globalStyles = wrapGlobalLayer(globalStyles);
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime$2S.jsx)(_styledEngine$3.GlobalStyles, {
    styles: globalStyles
  });
}
process.env.NODE_ENV !== "production" ? GlobalStyles$3.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: _propTypes$31.default.object,
  /**
   * @ignore
   */
  styles: _propTypes$31.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$31.default.array, _propTypes$31.default.func, _propTypes$31.default.number, _propTypes$31.default.object, _propTypes$31.default.string, _propTypes$31.default.bool]),
  /**
   * @ignore
   */
  themeId: _propTypes$31.default.string
} : void 0;
GlobalStyles$4.default = GlobalStyles$3;

(function (exports) {
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _GlobalStyles.default;
  }
});
var _GlobalStyles = _interopRequireWildcard(GlobalStyles$4);
Object.keys(_GlobalStyles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _GlobalStyles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GlobalStyles[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(GlobalStyles$5));

var display = {};

var _interopRequireDefault$9m = interopRequireDefault$1.exports;
Object.defineProperty(display, "__esModule", {
  value: true
});
display.whiteSpace = display.visibility = display.textOverflow = display.overflow = display.displayRaw = display.displayPrint = display.default = void 0;
var _style$4 = _interopRequireDefault$9m(style$12);
var _compose$4 = _interopRequireDefault$9m(compose$8);
const displayPrint = display.displayPrint = (0, _style$4.default)({
  prop: 'displayPrint',
  cssProperty: false,
  transform: value => ({
    '@media print': {
      display: value
    }
  })
});
const displayRaw = display.displayRaw = (0, _style$4.default)({
  prop: 'display'
});
const overflow = display.overflow = (0, _style$4.default)({
  prop: 'overflow'
});
const textOverflow = display.textOverflow = (0, _style$4.default)({
  prop: 'textOverflow'
});
const visibility = display.visibility = (0, _style$4.default)({
  prop: 'visibility'
});
const whiteSpace = display.whiteSpace = (0, _style$4.default)({
  prop: 'whiteSpace'
});
display.default = (0, _compose$4.default)(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);

var flexbox$1 = {};

var _interopRequireDefault$9l = interopRequireDefault$1.exports;
Object.defineProperty(flexbox$1, "__esModule", {
  value: true
});
flexbox$1.order = flexbox$1.justifySelf = flexbox$1.justifyItems = flexbox$1.justifyContent = flexbox$1.flexWrap = flexbox$1.flexShrink = flexbox$1.flexGrow = flexbox$1.flexDirection = flexbox$1.flexBasis = flexbox$1.flex = flexbox$1.default = flexbox$1.alignSelf = flexbox$1.alignItems = flexbox$1.alignContent = void 0;
var _style$3 = _interopRequireDefault$9l(style$12);
var _compose$3 = _interopRequireDefault$9l(compose$8);
const flexBasis = flexbox$1.flexBasis = (0, _style$3.default)({
  prop: 'flexBasis'
});
const flexDirection = flexbox$1.flexDirection = (0, _style$3.default)({
  prop: 'flexDirection'
});
const flexWrap = flexbox$1.flexWrap = (0, _style$3.default)({
  prop: 'flexWrap'
});
const justifyContent = flexbox$1.justifyContent = (0, _style$3.default)({
  prop: 'justifyContent'
});
const alignItems = flexbox$1.alignItems = (0, _style$3.default)({
  prop: 'alignItems'
});
const alignContent = flexbox$1.alignContent = (0, _style$3.default)({
  prop: 'alignContent'
});
const order$2 = flexbox$1.order = (0, _style$3.default)({
  prop: 'order'
});
const flex = flexbox$1.flex = (0, _style$3.default)({
  prop: 'flex'
});
const flexGrow = flexbox$1.flexGrow = (0, _style$3.default)({
  prop: 'flexGrow'
});
const flexShrink = flexbox$1.flexShrink = (0, _style$3.default)({
  prop: 'flexShrink'
});
const alignSelf = flexbox$1.alignSelf = (0, _style$3.default)({
  prop: 'alignSelf'
});
const justifyItems = flexbox$1.justifyItems = (0, _style$3.default)({
  prop: 'justifyItems'
});
const justifySelf = flexbox$1.justifySelf = (0, _style$3.default)({
  prop: 'justifySelf'
});
const flexbox = (0, _compose$3.default)(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order$2, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
flexbox$1.default = flexbox;

var positions = {};

var _interopRequireDefault$9k = interopRequireDefault$1.exports;
Object.defineProperty(positions, "__esModule", {
  value: true
});
positions.zIndex = positions.top = positions.right = positions.position = positions.left = positions.default = positions.bottom = void 0;
var _style$2 = _interopRequireDefault$9k(style$12);
var _compose$2 = _interopRequireDefault$9k(compose$8);
const position$1 = positions.position = (0, _style$2.default)({
  prop: 'position'
});
const zIndex = positions.zIndex = (0, _style$2.default)({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
const top$1 = positions.top = (0, _style$2.default)({
  prop: 'top'
});
const right$1 = positions.right = (0, _style$2.default)({
  prop: 'right'
});
const bottom$1 = positions.bottom = (0, _style$2.default)({
  prop: 'bottom'
});
const left$1 = positions.left = (0, _style$2.default)({
  prop: 'left'
});
positions.default = (0, _compose$2.default)(position$1, zIndex, top$1, right$1, bottom$1, left$1);

var shadows = {};

var _interopRequireDefault$9j = interopRequireDefault$1.exports;
Object.defineProperty(shadows, "__esModule", {
  value: true
});
shadows.default = void 0;
var _style$1 = _interopRequireDefault$9j(style$12);
const boxShadow = (0, _style$1.default)({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
shadows.default = boxShadow;

var typography$1 = {};

var _interopRequireDefault$9i = interopRequireDefault$1.exports;
Object.defineProperty(typography$1, "__esModule", {
  value: true
});
typography$1.typographyVariant = typography$1.textTransform = typography$1.textAlign = typography$1.lineHeight = typography$1.letterSpacing = typography$1.fontWeight = typography$1.fontStyle = typography$1.fontSize = typography$1.fontFamily = typography$1.default = void 0;
var _style = _interopRequireDefault$9i(style$12);
var _compose$1 = _interopRequireDefault$9i(compose$8);
const fontFamily = typography$1.fontFamily = (0, _style.default)({
  prop: 'fontFamily',
  themeKey: 'typography'
});
const fontSize = typography$1.fontSize = (0, _style.default)({
  prop: 'fontSize',
  themeKey: 'typography'
});
const fontStyle = typography$1.fontStyle = (0, _style.default)({
  prop: 'fontStyle',
  themeKey: 'typography'
});
const fontWeight = typography$1.fontWeight = (0, _style.default)({
  prop: 'fontWeight',
  themeKey: 'typography'
});
const letterSpacing = typography$1.letterSpacing = (0, _style.default)({
  prop: 'letterSpacing'
});
const textTransform = typography$1.textTransform = (0, _style.default)({
  prop: 'textTransform'
});
const lineHeight = typography$1.lineHeight = (0, _style.default)({
  prop: 'lineHeight'
});
const textAlign = typography$1.textAlign = (0, _style.default)({
  prop: 'textAlign'
});
const typographyVariant = typography$1.typographyVariant = (0, _style.default)({
  prop: 'typography',
  cssProperty: false,
  themeKey: 'typography'
});
const typography = (0, _compose$1.default)(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign, textTransform);
typography$1.default = typography;

var getThemeValue$1 = {};

var _interopRequireDefault$9h = interopRequireDefault$1.exports;
Object.defineProperty(getThemeValue$1, "__esModule", {
  value: true
});
getThemeValue$1.styleFunctionMapping = getThemeValue$1.propToStyleFunction = getThemeValue$1.default = void 0;
var _borders = _interopRequireDefault$9h(borders$1);
var _display = _interopRequireDefault$9h(display);
var _flexbox = _interopRequireDefault$9h(flexbox$1);
var _cssGrid = _interopRequireDefault$9h(cssGrid);
var _positions = _interopRequireDefault$9h(positions);
var _palette = _interopRequireDefault$9h(palette$1);
var _shadows = _interopRequireDefault$9h(shadows);
var _sizing = _interopRequireDefault$9h(sizing$1);
var _spacing$1 = _interopRequireDefault$9h(spacing$1);
var _typography = _interopRequireDefault$9h(typography$1);
const filterPropsMapping = {
  borders: _borders.default.filterProps,
  display: _display.default.filterProps,
  flexbox: _flexbox.default.filterProps,
  grid: _cssGrid.default.filterProps,
  positions: _positions.default.filterProps,
  palette: _palette.default.filterProps,
  shadows: _shadows.default.filterProps,
  sizing: _sizing.default.filterProps,
  spacing: _spacing$1.default.filterProps,
  typography: _typography.default.filterProps
};
const styleFunctionMapping = getThemeValue$1.styleFunctionMapping = {
  borders: _borders.default,
  display: _display.default,
  flexbox: _flexbox.default,
  grid: _cssGrid.default,
  positions: _positions.default,
  palette: _palette.default,
  shadows: _shadows.default,
  sizing: _sizing.default,
  spacing: _spacing$1.default,
  typography: _typography.default
};
const propToStyleFunction = getThemeValue$1.propToStyleFunction = Object.keys(filterPropsMapping).reduce((acc, styleFnName) => {
  filterPropsMapping[styleFnName].forEach(propName => {
    acc[propName] = styleFunctionMapping[styleFnName];
  });
  return acc;
}, {});
function getThemeValue(prop, value, theme) {
  const inputProps = {
    [prop]: value,
    theme
  };
  const styleFunction = propToStyleFunction[prop];
  return styleFunction ? styleFunction(inputProps) : {
    [prop]: value
  };
}
getThemeValue$1.default = getThemeValue;

var Box$6 = {};

var Box$5 = {};

var createBox$1 = {};

var _interopRequireDefault$9g = interopRequireDefault$1.exports;
Object.defineProperty(createBox$1, "__esModule", {
  value: true
});
createBox$1.default = createBox;
var _extends2$2D = _interopRequireDefault$9g(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2h = _interopRequireDefault$9g(objectWithoutPropertiesLoose.exports);
var React$30 = _interopRequireWildcard$4r(React__default$4);
var _clsx$2r = _interopRequireDefault$9g(clsx.exports);
var _styledEngine$2 = _interopRequireDefault$9g(node$3);
var _styleFunctionSx$6 = _interopRequireWildcard$4r(styleFunctionSx);
var _useTheme$h = _interopRequireDefault$9g(useTheme$8);
var _jsxRuntime$2R = require$$11;
const _excluded$2L = ["className", "component"];
function _getRequireWildcardCache$4a(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4a = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4r(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$4a(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function createBox(options = {}) {
  const {
    themeId,
    defaultTheme,
    defaultClassName = 'MuiBox-root',
    generateClassName
  } = options;
  const BoxRoot = (0, _styledEngine$2.default)('div', {
    shouldForwardProp: prop => prop !== 'theme' && prop !== 'sx' && prop !== 'as'
  })(_styleFunctionSx$6.default);
  const Box = /*#__PURE__*/React$30.forwardRef(function Box(inProps, ref) {
    const theme = (0, _useTheme$h.default)(defaultTheme);
    const _extendSxProp = (0, _styleFunctionSx$6.extendSxProp)(inProps),
      {
        className,
        component = 'div'
      } = _extendSxProp,
      other = (0, _objectWithoutPropertiesLoose2$2h.default)(_extendSxProp, _excluded$2L);
    return /*#__PURE__*/(0, _jsxRuntime$2R.jsx)(BoxRoot, (0, _extends2$2D.default)({
      as: component,
      ref: ref,
      className: (0, _clsx$2r.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
      theme: themeId ? theme[themeId] || theme : theme
    }, other));
  });
  return Box;
}

var boxClasses$3 = {};

var generateUtilityClasses$3 = {};

var generateUtilityClasses$2 = {};

var _interopRequireDefault$9f = interopRequireDefault$1.exports;
Object.defineProperty(generateUtilityClasses$2, "__esModule", {
  value: true
});
generateUtilityClasses$2.default = generateUtilityClasses$1;
var _generateUtilityClass$1Y = _interopRequireDefault$9f(generateUtilityClass$3);
function generateUtilityClasses$1(componentName, slots, globalStatePrefix = 'Mui') {
  const result = {};
  slots.forEach(slot => {
    result[slot] = (0, _generateUtilityClass$1Y.default)(componentName, slot, globalStatePrefix);
  });
  return result;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _generateUtilityClasses.default;
  }
});
var _generateUtilityClasses = _interopRequireDefault(generateUtilityClasses$2);
}(generateUtilityClasses$3));

var _interopRequireDefault$9e = interopRequireDefault$1.exports;
Object.defineProperty(boxClasses$3, "__esModule", {
  value: true
});
boxClasses$3.default = void 0;
var _generateUtilityClasses$1W = _interopRequireDefault$9e(generateUtilityClasses$3);
const boxClasses$2 = (0, _generateUtilityClasses$1W.default)('MuiBox', ['root']);
boxClasses$3.default = boxClasses$2;

var _interopRequireDefault$9d = interopRequireDefault$1.exports;
Object.defineProperty(Box$5, "__esModule", {
  value: true
});
Box$5.default = void 0;
var _propTypes$30 = _interopRequireDefault$9d(propTypes.exports);
var _ClassNameGenerator = _interopRequireDefault$9d(ClassNameGenerator$2);
var _createBox = _interopRequireDefault$9d(createBox$1);
var _boxClasses$1 = _interopRequireDefault$9d(boxClasses$3);
const Box$4 = (0, _createBox.default)({
  defaultClassName: _boxClasses$1.default.root,
  generateClassName: _ClassNameGenerator.default.generate
});
process.env.NODE_ENV !== "production" ? Box$4.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: _propTypes$30.default.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$30.default.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$30.default.oneOfType([_propTypes$30.default.arrayOf(_propTypes$30.default.oneOfType([_propTypes$30.default.func, _propTypes$30.default.object, _propTypes$30.default.bool])), _propTypes$30.default.func, _propTypes$30.default.object])
} : void 0;
Box$5.default = Box$4;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  boxClasses: true
};
Object.defineProperty(exports, "boxClasses", {
  enumerable: true,
  get: function () {
    return _boxClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Box.default;
  }
});
var _Box = _interopRequireDefault(Box$5);
var _boxClasses = _interopRequireWildcard(boxClasses$3);
Object.keys(_boxClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _boxClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _boxClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Box$6));

var styled$1 = {};

var _interopRequireDefault$9c = interopRequireDefault$1.exports;
Object.defineProperty(styled$1, "__esModule", {
  value: true
});
styled$1.default = void 0;
var _createStyled = _interopRequireDefault$9c(createStyled$1);
const styled = (0, _createStyled.default)();
styled$1.default = styled;

var useMediaQuery$4 = {};

var useMediaQuery$3 = {};

var useEnhancedEffect$3 = {};

var useEnhancedEffect$2 = {};

Object.defineProperty(useEnhancedEffect$2, "__esModule", {
  value: true
});
useEnhancedEffect$2.default = void 0;
var React$2$ = _interopRequireWildcard$4q(React__default$4);
function _getRequireWildcardCache$49(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$49 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4q(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$49(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */
const useEnhancedEffect$1 = typeof window !== 'undefined' ? React$2$.useLayoutEffect : React$2$.useEffect;
useEnhancedEffect$2.default = useEnhancedEffect$1;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useEnhancedEffect.default;
  }
});
var _useEnhancedEffect = _interopRequireDefault(useEnhancedEffect$2);
}(useEnhancedEffect$3));

var _interopRequireDefault$9b = interopRequireDefault$1.exports;
Object.defineProperty(useMediaQuery$3, "__esModule", {
  value: true
});
useMediaQuery$3.default = useMediaQuery$2;
var React$2_ = _interopRequireWildcard$4p(React__default$4);
var _useEnhancedEffect$a = _interopRequireDefault$9b(useEnhancedEffect$3);
var _useThemeProps$4 = useThemeProps$3;
var _useThemeWithoutDefault$3 = _interopRequireDefault$9b(useThemeWithoutDefault);
function _getRequireWildcardCache$48(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$48 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4p(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$48(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */

/**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */

function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const [match, setMatch] = React$2_.useState(() => {
    if (noSsr && matchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }

    // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.
    return defaultMatches;
  });
  (0, _useEnhancedEffect$a.default)(() => {
    let active = true;
    if (!matchMedia) {
      return undefined;
    }
    const queryList = matchMedia(query);
    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    // TODO: Use `addEventListener` once support for Safari < 14 is dropped
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia]);
  return match;
}

// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = React$2_['useSyncExternalStore' + ''];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
  const getDefaultSnapshot = React$2_.useCallback(() => defaultMatches, [defaultMatches]);
  const getServerSnapshot = React$2_.useMemo(() => {
    if (noSsr && matchMedia) {
      return () => matchMedia(query).matches;
    }
    if (ssrMatchMedia !== null) {
      const {
        matches
      } = ssrMatchMedia(query);
      return () => matches;
    }
    return getDefaultSnapshot;
  }, [getDefaultSnapshot, query, ssrMatchMedia, noSsr, matchMedia]);
  const [getSnapshot, subscribe] = React$2_.useMemo(() => {
    if (matchMedia === null) {
      return [getDefaultSnapshot, () => () => {}];
    }
    const mediaQueryList = matchMedia(query);
    return [() => mediaQueryList.matches, notify => {
      // TODO: Use `addEventListener` once support for Safari < 14 is dropped
      mediaQueryList.addListener(notify);
      return () => {
        mediaQueryList.removeListener(notify);
      };
    }];
  }, [getDefaultSnapshot, matchMedia, query]);
  const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  return match;
}
function useMediaQuery$2(queryInput, options = {}) {
  const theme = (0, _useThemeWithoutDefault$3.default)();
  // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    ssrMatchMedia = null,
    noSsr = false
  } = (0, _useThemeProps$4.getThemeProps)({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });
  if (process.env.NODE_ENV !== 'production') {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['MUI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }
  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, '');

  // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
  const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
  const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2_.useDebugValue({
      query,
      match
    });
  }
  return match;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useMediaQuery.default;
  }
});
var _useMediaQuery = _interopRequireWildcard(useMediaQuery$3);
Object.keys(_useMediaQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useMediaQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useMediaQuery[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(useMediaQuery$4));

var ThemeProvider$9 = {};

var ThemeProvider$8 = {};

var node$1 = {};

var ThemeProvider$7 = {};

var ThemeProvider$6 = {};

var utils$7 = {};

var elementAcceptingRef$2 = {};

var elementAcceptingRef$1 = {};

var _interopRequireDefault$9a = interopRequireDefault$1.exports;
Object.defineProperty(elementAcceptingRef$1, "__esModule", {
  value: true
});
elementAcceptingRef$1.default = void 0;
var _propTypes$2$ = _interopRequireDefault$9a(propTypes.exports);
var _chainPropTypes$d = _interopRequireDefault$9a(chainPropTypes$2);
function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  const {
    prototype = {}
  } = elementType;
  return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
  const element = props[propName];
  const safePropName = propFullName || propName;
  if (element == null ||
  // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window === 'undefined') {
    return null;
  }
  let warningHint;
  const elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */
  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }
  if (warningHint !== undefined) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }
  return null;
}
const elementAcceptingRef = (0, _chainPropTypes$d.default)(_propTypes$2$.default.element, acceptingRef);
elementAcceptingRef.isRequired = (0, _chainPropTypes$d.default)(_propTypes$2$.default.element.isRequired, acceptingRef);
elementAcceptingRef$1.default = elementAcceptingRef;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _elementAcceptingRef.default;
  }
});
var _elementAcceptingRef = _interopRequireDefault(elementAcceptingRef$1);
}(elementAcceptingRef$2));

var exactProp$2 = {};

var exactProp$1 = {};

var _interopRequireDefault$99 = interopRequireDefault$1.exports;
Object.defineProperty(exactProp$1, "__esModule", {
  value: true
});
exactProp$1.default = exactProp;
var _extends2$2C = _interopRequireDefault$99(_extends$19.exports);
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.

const specialProperty = 'exact-prop: \u200b';
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }
  return (0, _extends2$2C.default)({}, propTypes, {
    [specialProperty]: props => {
      const unsupportedProps = Object.keys(props).filter(prop => !propTypes.hasOwnProperty(prop));
      if (unsupportedProps.length > 0) {
        return new Error(`The following props are not supported: ${unsupportedProps.map(prop => `\`${prop}\``).join(', ')}. Please remove them.`);
      }
      return null;
    }
  });
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _exactProp.default;
  }
});
var _exactProp = _interopRequireDefault(exactProp$1);
}(exactProp$2));

var HTMLElementType$2 = {};

var HTMLElementType$1 = {};

Object.defineProperty(HTMLElementType$1, "__esModule", {
  value: true
});
HTMLElementType$1.default = HTMLElementType;
function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  const propValue = props[propName];
  const safePropName = propFullName || propName;
  if (propValue == null) {
    return null;
  }
  if (propValue && propValue.nodeType !== 1) {
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an HTMLElement.`);
  }
  return null;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _HTMLElementType.default;
  }
});
var _HTMLElementType = _interopRequireDefault(HTMLElementType$1);
}(HTMLElementType$2));

var ponyfillGlobal$1 = {};

var ponyfillGlobal = {};

Object.defineProperty(ponyfillGlobal, "__esModule", {
  value: true
});
ponyfillGlobal.default = void 0;
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
ponyfillGlobal.default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ponyfillGlobal.default;
  }
});
var _ponyfillGlobal = _interopRequireDefault(ponyfillGlobal);
}(ponyfillGlobal$1));

var refType$2 = {};

var refType$1 = {};

var _interopRequireDefault$98 = interopRequireDefault$1.exports;
Object.defineProperty(refType$1, "__esModule", {
  value: true
});
refType$1.default = void 0;
var _propTypes$2_ = _interopRequireDefault$98(propTypes.exports);
const refType = _propTypes$2_.default.oneOfType([_propTypes$2_.default.func, _propTypes$2_.default.object]);
refType$1.default = refType;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _refType.default;
  }
});
var _refType = _interopRequireDefault(refType$1);
}(refType$2));

var createChainedFunction$3 = {};

var createChainedFunction$2 = {};

Object.defineProperty(createChainedFunction$2, "__esModule", {
  value: true
});
createChainedFunction$2.default = createChainedFunction$1;
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction$1(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }
    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _createChainedFunction.default;
  }
});
var _createChainedFunction = _interopRequireDefault(createChainedFunction$2);
}(createChainedFunction$3));

var debounce$6 = {};

var debounce$5 = {};

Object.defineProperty(debounce$5, "__esModule", {
  value: true
});
debounce$5.default = debounce$4;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce$4(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      // @ts-ignore
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _debounce.default;
  }
});
var _debounce = _interopRequireWildcard(debounce$5);
Object.keys(_debounce).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _debounce[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _debounce[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(debounce$6));

var deprecatedPropType$3 = {};

var deprecatedPropType$2 = {};

Object.defineProperty(deprecatedPropType$2, "__esModule", {
  value: true
});
deprecatedPropType$2.default = deprecatedPropType$1;
function deprecatedPropType$1(validator, reason) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }
  return (props, propName, componentName, location, propFullName) => {
    const componentNameSafe = componentName || '<<anonymous>>';
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') {
      return new Error(`The ${location} \`${propFullNameSafe}\` of ` + `\`${componentNameSafe}\` is deprecated. ${reason}`);
    }
    return null;
  };
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _deprecatedPropType.default;
  }
});
var _deprecatedPropType = _interopRequireDefault(deprecatedPropType$2);
}(deprecatedPropType$3));

var isMuiElement$3 = {};

var isMuiElement$2 = {};

Object.defineProperty(isMuiElement$2, "__esModule", {
  value: true
});
isMuiElement$2.default = isMuiElement$1;
var React$2Z = _interopRequireWildcard$4o(React__default$4);
function _getRequireWildcardCache$47(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$47 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4o(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$47(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function isMuiElement$1(element, muiNames) {
  var _muiName, _element$type;
  return /*#__PURE__*/React$2Z.isValidElement(element) && muiNames.indexOf( // For server components `muiName` is avaialble in element.type._payload.value.muiName
  // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
  // eslint-disable-next-line no-underscore-dangle
  (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _isMuiElement.default;
  }
});
var _isMuiElement = _interopRequireDefault(isMuiElement$2);
}(isMuiElement$3));

var ownerDocument$3 = {};

var ownerDocument$2 = {};

Object.defineProperty(ownerDocument$2, "__esModule", {
  value: true
});
ownerDocument$2.default = ownerDocument$1;
function ownerDocument$1(node) {
  return node && node.ownerDocument || document;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ownerDocument.default;
  }
});
var _ownerDocument = _interopRequireDefault(ownerDocument$2);
}(ownerDocument$3));

var ownerWindow$3 = {};

var ownerWindow$2 = {};

var _interopRequireDefault$97 = interopRequireDefault$1.exports;
Object.defineProperty(ownerWindow$2, "__esModule", {
  value: true
});
ownerWindow$2.default = ownerWindow$1;
var _ownerDocument$6 = _interopRequireDefault$97(ownerDocument$3);
function ownerWindow$1(node) {
  const doc = (0, _ownerDocument$6.default)(node);
  return doc.defaultView || window;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ownerWindow.default;
  }
});
var _ownerWindow = _interopRequireDefault(ownerWindow$2);
}(ownerWindow$3));

var requirePropFactory$3 = {};

var requirePropFactory$2 = {};

var _interopRequireDefault$96 = interopRequireDefault$1.exports;
Object.defineProperty(requirePropFactory$2, "__esModule", {
  value: true
});
requirePropFactory$2.default = requirePropFactory$1;
var _extends2$2B = _interopRequireDefault$96(_extends$19.exports);
function requirePropFactory$1(componentNameInError, Component) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }

  // eslint-disable-next-line react/forbid-foreign-prop-types
  const prevPropTypes = Component ? (0, _extends2$2B.default)({}, Component.propTypes) : null;
  const requireProp = requiredProp => (props, propName, componentName, location, propFullName, ...args) => {
    const propFullNameSafe = propFullName || propName;
    const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
    if (defaultTypeChecker) {
      const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
      if (typeCheckerResult) {
        return typeCheckerResult;
      }
    }
    if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
      return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
    }
    return null;
  };
  return requireProp;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _requirePropFactory.default;
  }
});
var _requirePropFactory = _interopRequireDefault(requirePropFactory$2);
}(requirePropFactory$3));

var setRef$3 = {};

var setRef$2 = {};

Object.defineProperty(setRef$2, "__esModule", {
  value: true
});
setRef$2.default = setRef$1;
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef$1(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _setRef.default;
  }
});
var _setRef = _interopRequireDefault(setRef$2);
}(setRef$3));

var useId$3 = {};

var useId$2 = {};

Object.defineProperty(useId$2, "__esModule", {
  value: true
});
useId$2.default = useId$1;
var React$2Y = _interopRequireWildcard$4n(React__default$4);
function _getRequireWildcardCache$46(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$46 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4n(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$46(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = React$2Y.useState(idOverride);
  const id = idOverride || defaultId;
  React$2Y.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}

// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = React$2Y['useId'.toString()];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */
function useId$1(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
  return useGlobalId(idOverride);
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useId.default;
  }
});
var _useId = _interopRequireDefault(useId$2);
}(useId$3));

var unsupportedProp$3 = {};

var unsupportedProp$2 = {};

Object.defineProperty(unsupportedProp$2, "__esModule", {
  value: true
});
unsupportedProp$2.default = unsupportedProp$1;
function unsupportedProp$1(props, propName, componentName, location, propFullName) {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  const propFullNameSafe = propFullName || propName;
  if (typeof props[propName] !== 'undefined') {
    return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
  }
  return null;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _unsupportedProp.default;
  }
});
var _unsupportedProp = _interopRequireDefault(unsupportedProp$2);
}(unsupportedProp$3));

var useControlled$3 = {};

var useControlled$2 = {};

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
Object.defineProperty(useControlled$2, "__esModule", {
  value: true
});
useControlled$2.default = useControlled$1;
var React$2X = _interopRequireWildcard$4m(React__default$4);
function _getRequireWildcardCache$45(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$45 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4m(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$45(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useControlled$1({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = React$2X.useRef(controlled !== undefined);
  const [valueState, setValue] = React$2X.useState(defaultProp);
  const value = isControlled ? controlled : valueState;
  if (process.env.NODE_ENV !== 'production') {
    React$2X.useEffect(() => {
      if (isControlled !== (controlled !== undefined)) {
        console.error([`MUI: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of ${name} to be ${isControlled ? 'un' : ''}controlled.`, 'Elements should not switch from uncontrolled to controlled (or vice versa).', `Decide between using a controlled or uncontrolled ${name} ` + 'element for the lifetime of the component.', "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [state, name, controlled]);
    const {
      current: defaultValue
    } = React$2X.useRef(defaultProp);
    React$2X.useEffect(() => {
      if (!isControlled && !Object.is(defaultValue, defaultProp)) {
        console.error([`MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. ` + `To suppress this warning opt to use a controlled ${name}.`].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }
  const setValueIfUncontrolled = React$2X.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useControlled.default;
  }
});
var _useControlled = _interopRequireDefault(useControlled$2);
}(useControlled$3));

var useEventCallback$3 = {};

var useEventCallback$2 = {};

var _interopRequireDefault$95 = interopRequireDefault$1.exports;
Object.defineProperty(useEventCallback$2, "__esModule", {
  value: true
});
useEventCallback$2.default = void 0;
var React$2W = _interopRequireWildcard$4l(React__default$4);
var _useEnhancedEffect$9 = _interopRequireDefault$95(useEnhancedEffect$3);
function _getRequireWildcardCache$44(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$44 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4l(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$44(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */

function useEventCallback$1(fn) {
  const ref = React$2W.useRef(fn);
  (0, _useEnhancedEffect$9.default)(() => {
    ref.current = fn;
  });
  return React$2W.useRef((...args) =>
  // @ts-expect-error hide `this`
  (0, ref.current)(...args)).current;
}
useEventCallback$2.default = useEventCallback$1;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useEventCallback.default;
  }
});
var _useEventCallback = _interopRequireDefault(useEventCallback$2);
}(useEventCallback$3));

var useForkRef$3 = {};

var useForkRef$2 = {};

var _interopRequireDefault$94 = interopRequireDefault$1.exports;
Object.defineProperty(useForkRef$2, "__esModule", {
  value: true
});
useForkRef$2.default = useForkRef$1;
var React$2V = _interopRequireWildcard$4k(React__default$4);
var _setRef$1 = _interopRequireDefault$94(setRef$3);
function _getRequireWildcardCache$43(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$43 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4k(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$43(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useForkRef$1(...refs) {
  /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return React$2V.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return instance => {
      refs.forEach(ref => {
        (0, _setRef$1.default)(ref, instance);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useForkRef.default;
  }
});
var _useForkRef = _interopRequireDefault(useForkRef$2);
}(useForkRef$3));

var useLazyRef = {};

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useLazyRef.default;
  }
});
var _useLazyRef = _interopRequireDefault(useLazyRef$2);
}(useLazyRef));

var useOnMount = {};

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useOnMount.default;
  }
});
var _useOnMount = _interopRequireDefault(useOnMount$2);
}(useOnMount));

var useIsFocusVisible$3 = {};

var useIsFocusVisible$2 = {};

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
Object.defineProperty(useIsFocusVisible$2, "__esModule", {
  value: true
});
useIsFocusVisible$2.default = useIsFocusVisible$1;
useIsFocusVisible$2.teardown = teardown;
var React$2U = _interopRequireWildcard$4j(React__default$4);
var _useTimeout$5 = useTimeout$1;
function _getRequireWildcardCache$42(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$42 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4j(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$42(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new _useTimeout$5.Timeout();
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};

/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */
function focusTriggersKeyboardModality(node) {
  const {
    type,
    tagName
  } = node;
  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}

/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}

/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
  const {
    target
  } = event;
  try {
    return target.matches(':focus-visible');
  } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  }

  // No need for validFocusTarget check. The user does that by attaching it to
  // focusable events only.
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible$1() {
  const ref = React$2U.useCallback(node => {
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = React$2U.useRef(false);

  /**
   * Should be called if a blur event is fired
   */
  function handleBlurVisible() {
    // checking against potential state variable does not suffice if we focus and blur synchronously.
    // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
    // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
    // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
    // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
    if (isFocusVisibleRef.current) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      hadFocusVisibleRecentlyTimeout.start(100, () => {
        hadFocusVisibleRecently = false;
      });
      isFocusVisibleRef.current = false;
      return true;
    }
    return false;
  }

  /**
   * Should be called if a blur event is fired
   */
  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }
    return false;
  }
  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useIsFocusVisible.default;
  }
});
var _useIsFocusVisible = _interopRequireWildcard(useIsFocusVisible$2);
Object.keys(_useIsFocusVisible).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useIsFocusVisible[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useIsFocusVisible[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(useIsFocusVisible$3));

var getScrollbarSize$3 = {};

var getScrollbarSize$2 = {};

Object.defineProperty(getScrollbarSize$2, "__esModule", {
  value: true
});
getScrollbarSize$2.default = getScrollbarSize$1;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize$1(doc) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _getScrollbarSize.default;
  }
});
var _getScrollbarSize = _interopRequireDefault(getScrollbarSize$2);
}(getScrollbarSize$3));

var scrollLeft$2 = {};

var scrollLeft$1 = {};

Object.defineProperty(scrollLeft$1, "__esModule", {
  value: true
});
scrollLeft$1.detectScrollType = detectScrollType;
scrollLeft$1.getNormalizedScrollLeft = getNormalizedScrollLeft;
// Source from https://github.com/alitaheri/normalize-scroll-left
let cachedType;

/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */
function detectScrollType() {
  if (cachedType) {
    return cachedType;
  }
  const dummy = document.createElement('div');
  const container = document.createElement('div');
  container.style.width = '10px';
  container.style.height = '1px';
  dummy.appendChild(container);
  dummy.dir = 'rtl';
  dummy.style.fontSize = '14px';
  dummy.style.width = '4px';
  dummy.style.height = '1px';
  dummy.style.position = 'absolute';
  dummy.style.top = '-1000px';
  dummy.style.overflow = 'scroll';
  document.body.appendChild(dummy);
  cachedType = 'reverse';
  if (dummy.scrollLeft > 0) {
    cachedType = 'default';
  } else {
    dummy.scrollLeft = 1;
    if (dummy.scrollLeft === 0) {
      cachedType = 'negative';
    }
  }
  document.body.removeChild(dummy);
  return cachedType;
}

// Based on https://stackoverflow.com/a/24394376
function getNormalizedScrollLeft(element, direction) {
  const scrollLeft = element.scrollLeft;

  // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
  if (direction !== 'rtl') {
    return scrollLeft;
  }
  const type = detectScrollType();
  switch (type) {
    case 'negative':
      return element.scrollWidth - element.clientWidth + scrollLeft;
    case 'reverse':
      return element.scrollWidth - element.clientWidth - scrollLeft;
    default:
      return scrollLeft;
  }
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _scrollLeft = scrollLeft$1;
Object.keys(_scrollLeft).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _scrollLeft[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _scrollLeft[key];
    }
  });
});
}(scrollLeft$2));

var usePreviousProps$2 = {};

var usePreviousProps$1 = {};

Object.defineProperty(usePreviousProps$1, "__esModule", {
  value: true
});
usePreviousProps$1.default = void 0;
var React$2T = _interopRequireWildcard$4i(React__default$4);
function _getRequireWildcardCache$41(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$41 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4i(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$41(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const usePreviousProps = value => {
  const ref = React$2T.useRef({});
  React$2T.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
usePreviousProps$1.default = usePreviousProps;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _usePreviousProps.default;
  }
});
var _usePreviousProps = _interopRequireDefault(usePreviousProps$1);
}(usePreviousProps$2));

var getValidReactChildren$2 = {};

var getValidReactChildren$1 = {};

Object.defineProperty(getValidReactChildren$1, "__esModule", {
  value: true
});
getValidReactChildren$1.default = getValidReactChildren;
var React$2S = _interopRequireWildcard$4h(React__default$4);
function _getRequireWildcardCache$40(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$40 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4h(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$40(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Gets only the valid children of a component,
 * and ignores any nullish or falsy child.
 *
 * @param children the children
 */
function getValidReactChildren(children) {
  return React$2S.Children.toArray(children).filter(child => /*#__PURE__*/React$2S.isValidElement(child));
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _getValidReactChildren.default;
  }
});
var _getValidReactChildren = _interopRequireDefault(getValidReactChildren$1);
}(getValidReactChildren$2));

var visuallyHidden$2 = {};

var visuallyHidden$1 = {};

Object.defineProperty(visuallyHidden$1, "__esModule", {
  value: true
});
visuallyHidden$1.default = void 0;
const visuallyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px'
};
visuallyHidden$1.default = visuallyHidden;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _visuallyHidden.default;
  }
});
var _visuallyHidden = _interopRequireDefault(visuallyHidden$1);
}(visuallyHidden$2));

var integerPropType$1 = {};

var integerPropType = {};

Object.defineProperty(integerPropType, "__esModule", {
  value: true
});
integerPropType.default = void 0;
integerPropType.getTypeByValue = getTypeByValue;
function getTypeByValue(value) {
  const valueType = typeof value;
  switch (valueType) {
    case 'number':
      if (Number.isNaN(value)) {
        return 'NaN';
      }
      if (!Number.isFinite(value)) {
        return 'Infinity';
      }
      if (value !== Math.floor(value)) {
        return 'float';
      }
      return 'number';
    case 'object':
      if (value === null) {
        return 'null';
      }
      return value.constructor.name;
    default:
      return valueType;
  }
}

// IE 11 support
function ponyfillIsInteger(x) {
  // eslint-disable-next-line no-restricted-globals
  return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(props, propName, componentName, location) {
  const propValue = props[propName];
  if (propValue == null || !isInteger(propValue)) {
    const propType = getTypeByValue(propValue);
    return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
  }
  return null;
}
function validator(props, propName, ...other) {
  const propValue = props[propName];
  if (propValue === undefined) {
    return null;
  }
  return requiredInteger(props, propName, ...other);
}
function validatorNoop() {
  return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
integerPropType.default = process.env.NODE_ENV === 'production' ? validatorNoop : validator;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _integerPropType.default;
  }
});
var _integerPropType = _interopRequireWildcard(integerPropType);
Object.keys(_integerPropType).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _integerPropType[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _integerPropType[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(integerPropType$1));

var useSlotProps$2 = {};

var useSlotProps$1 = {};

var appendOwnerState$2 = {};

var appendOwnerState$1 = {};

var isHostComponent$2 = {};

var isHostComponent$1 = {};

Object.defineProperty(isHostComponent$1, "__esModule", {
  value: true
});
isHostComponent$1.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}
isHostComponent$1.default = isHostComponent;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _isHostComponent.default;
  }
});
var _isHostComponent = _interopRequireDefault(isHostComponent$1);
}(isHostComponent$2));

var _interopRequireDefault$93 = interopRequireDefault$1.exports;
Object.defineProperty(appendOwnerState$1, "__esModule", {
  value: true
});
appendOwnerState$1.default = void 0;
var _extends2$2A = _interopRequireDefault$93(_extends$19.exports);
var _isHostComponent$6 = _interopRequireDefault$93(isHostComponent$2);
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */

/**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */
function appendOwnerState(elementType, otherProps, ownerState) {
  if (elementType === undefined || (0, _isHostComponent$6.default)(elementType)) {
    return otherProps;
  }
  return (0, _extends2$2A.default)({}, otherProps, {
    ownerState: (0, _extends2$2A.default)({}, otherProps.ownerState, ownerState)
  });
}
appendOwnerState$1.default = appendOwnerState;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _appendOwnerState.default;
  }
});
var _appendOwnerState = _interopRequireDefault(appendOwnerState$1);
}(appendOwnerState$2));

var mergeSlotProps$2 = {};

var mergeSlotProps$1 = {};

var extractEventHandlers$2 = {};

var extractEventHandlers$1 = {};

Object.defineProperty(extractEventHandlers$1, "__esModule", {
  value: true
});
extractEventHandlers$1.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */
function extractEventHandlers(object, excludeKeys = []) {
  if (object === undefined) {
    return {};
  }
  const result = {};
  Object.keys(object).filter(prop => prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}
extractEventHandlers$1.default = extractEventHandlers;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _extractEventHandlers.default;
  }
});
var _extractEventHandlers = _interopRequireDefault(extractEventHandlers$1);
}(extractEventHandlers$2));

var omitEventHandlers$2 = {};

var omitEventHandlers$1 = {};

Object.defineProperty(omitEventHandlers$1, "__esModule", {
  value: true
});
omitEventHandlers$1.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */
function omitEventHandlers(object) {
  if (object === undefined) {
    return {};
  }
  const result = {};
  Object.keys(object).filter(prop => !(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach(prop => {
    result[prop] = object[prop];
  });
  return result;
}
omitEventHandlers$1.default = omitEventHandlers;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _omitEventHandlers.default;
  }
});
var _omitEventHandlers = _interopRequireDefault(omitEventHandlers$1);
}(omitEventHandlers$2));

var _interopRequireDefault$92 = interopRequireDefault$1.exports;
Object.defineProperty(mergeSlotProps$1, "__esModule", {
  value: true
});
mergeSlotProps$1.default = void 0;
var _extends2$2z = _interopRequireDefault$92(_extends$19.exports);
var _clsx$2q = _interopRequireDefault$92(clsx.exports);
var _extractEventHandlers$3 = _interopRequireDefault$92(extractEventHandlers$2);
var _omitEventHandlers = _interopRequireDefault$92(omitEventHandlers$2);
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */
function mergeSlotProps(parameters) {
  const {
    getSlotProps,
    additionalProps,
    externalSlotProps,
    externalForwardedProps,
    className
  } = parameters;
  if (!getSlotProps) {
    // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
    // so we can simply merge all the props without having to worry about extracting event handlers.
    const joinedClasses = (0, _clsx$2q.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, _extends2$2z.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, _extends2$2z.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
    if (joinedClasses.length > 0) {
      props.className = joinedClasses;
    }
    if (Object.keys(mergedStyle).length > 0) {
      props.style = mergedStyle;
    }
    return {
      props,
      internalRef: undefined
    };
  }

  // In this case, getSlotProps is responsible for calling the external event handlers.
  // We don't need to include them in the merged props because of this.

  const eventHandlers = (0, _extractEventHandlers$3.default)((0, _extends2$2z.default)({}, externalForwardedProps, externalSlotProps));
  const componentsPropsWithoutEventHandlers = (0, _omitEventHandlers.default)(externalSlotProps);
  const otherPropsWithoutEventHandlers = (0, _omitEventHandlers.default)(externalForwardedProps);
  const internalSlotProps = getSlotProps(eventHandlers);

  // The order of classes is important here.
  // Emotion (that we use in libraries consuming Base UI) depends on this order
  // to properly override style. It requires the most important classes to be last
  // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
  const joinedClasses = (0, _clsx$2q.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
  const mergedStyle = (0, _extends2$2z.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
  const props = (0, _extends2$2z.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
  if (joinedClasses.length > 0) {
    props.className = joinedClasses;
  }
  if (Object.keys(mergedStyle).length > 0) {
    props.style = mergedStyle;
  }
  return {
    props,
    internalRef: internalSlotProps.ref
  };
}
mergeSlotProps$1.default = mergeSlotProps;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _mergeSlotProps.default;
  }
});
var _mergeSlotProps = _interopRequireDefault(mergeSlotProps$1);
}(mergeSlotProps$2));

var resolveComponentProps$2 = {};

var resolveComponentProps$1 = {};

Object.defineProperty(resolveComponentProps$1, "__esModule", {
  value: true
});
resolveComponentProps$1.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */
function resolveComponentProps(componentProps, ownerState, slotState) {
  if (typeof componentProps === 'function') {
    return componentProps(ownerState, slotState);
  }
  return componentProps;
}
resolveComponentProps$1.default = resolveComponentProps;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _resolveComponentProps.default;
  }
});
var _resolveComponentProps = _interopRequireDefault(resolveComponentProps$1);
}(resolveComponentProps$2));

var _interopRequireDefault$91 = interopRequireDefault$1.exports;
Object.defineProperty(useSlotProps$1, "__esModule", {
  value: true
});
useSlotProps$1.default = void 0;
var _extends2$2y = _interopRequireDefault$91(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2g = _interopRequireDefault$91(objectWithoutPropertiesLoose.exports);
var _useForkRef$l = _interopRequireDefault$91(useForkRef$3);
var _appendOwnerState$2 = _interopRequireDefault$91(appendOwnerState$2);
var _mergeSlotProps = _interopRequireDefault$91(mergeSlotProps$2);
var _resolveComponentProps$1 = _interopRequireDefault$91(resolveComponentProps$2);
const _excluded$2K = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */
function useSlotProps(parameters) {
  var _parameters$additiona;
  const {
      elementType,
      externalSlotProps,
      ownerState,
      skipResolvingSlotProps = false
    } = parameters,
    rest = (0, _objectWithoutPropertiesLoose2$2g.default)(parameters, _excluded$2K);
  const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, _resolveComponentProps$1.default)(externalSlotProps, ownerState);
  const {
    props: mergedProps,
    internalRef
  } = (0, _mergeSlotProps.default)((0, _extends2$2y.default)({}, rest, {
    externalSlotProps: resolvedComponentsProps
  }));
  const ref = (0, _useForkRef$l.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
  const props = (0, _appendOwnerState$2.default)(elementType, (0, _extends2$2y.default)({}, mergedProps, {
    ref
  }), ownerState);
  return props;
}
useSlotProps$1.default = useSlotProps;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useSlotProps.default;
  }
});
var _useSlotProps = _interopRequireDefault(useSlotProps$1);
}(useSlotProps$2));

var getReactElementRef$2 = {};

var getReactElementRef$1 = {};

Object.defineProperty(getReactElementRef$1, "__esModule", {
  value: true
});
getReactElementRef$1.default = getReactElementRef;
var React$2R = _interopRequireWildcard$4g(React__default$4);
function _getRequireWildcardCache$3$(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3$ = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4g(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3$(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Returns the ref of a React element handling differences between React 19 and older versions.
 * It will throw runtime error if the element is not a valid React element.
 *
 * @param element React.ReactElement
 * @returns React.Ref<any> | null
 */
function getReactElementRef(element) {
  // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
  if (parseInt(React$2R.version, 10) >= 19) {
    var _element$props;
    return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
  }
  // @ts-expect-error element.ref is not included in the ReactElement type
  // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
  return (element == null ? void 0 : element.ref) || null;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _getReactElementRef.default;
  }
});
var _getReactElementRef = _interopRequireDefault(getReactElementRef$1);
}(getReactElementRef$2));

var types$1 = {};

Object.defineProperty(types$1, "__esModule", {
  value: true
});

/**
 * @mui/utils v5.17.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  chainPropTypes: true,
  deepmerge: true,
  isPlainObject: true,
  elementAcceptingRef: true,
  elementTypeAcceptingRef: true,
  exactProp: true,
  formatMuiErrorMessage: true,
  getDisplayName: true,
  HTMLElementType: true,
  ponyfillGlobal: true,
  refType: true,
  unstable_capitalize: true,
  unstable_createChainedFunction: true,
  unstable_debounce: true,
  unstable_deprecatedPropType: true,
  unstable_isMuiElement: true,
  unstable_ownerDocument: true,
  unstable_ownerWindow: true,
  unstable_requirePropFactory: true,
  unstable_setRef: true,
  unstable_useEnhancedEffect: true,
  unstable_useId: true,
  unstable_unsupportedProp: true,
  unstable_useControlled: true,
  unstable_useEventCallback: true,
  unstable_useForkRef: true,
  unstable_useLazyRef: true,
  unstable_useTimeout: true,
  unstable_Timeout: true,
  unstable_useOnMount: true,
  unstable_useIsFocusVisible: true,
  unstable_getScrollbarSize: true,
  unstable_detectScrollType: true,
  unstable_getNormalizedScrollLeft: true,
  usePreviousProps: true,
  getValidReactChildren: true,
  visuallyHidden: true,
  integerPropType: true,
  internal_resolveProps: true,
  unstable_composeClasses: true,
  unstable_generateUtilityClass: true,
  unstable_isGlobalState: true,
  unstable_generateUtilityClasses: true,
  unstable_ClassNameGenerator: true,
  clamp: true,
  unstable_useSlotProps: true,
  unstable_resolveComponentProps: true,
  unstable_extractEventHandlers: true,
  unstable_getReactElementRef: true
};
Object.defineProperty(exports, "HTMLElementType", {
  enumerable: true,
  get: function () {
    return _HTMLElementType.default;
  }
});
Object.defineProperty(exports, "chainPropTypes", {
  enumerable: true,
  get: function () {
    return _chainPropTypes.default;
  }
});
Object.defineProperty(exports, "clamp", {
  enumerable: true,
  get: function () {
    return _clamp.default;
  }
});
Object.defineProperty(exports, "deepmerge", {
  enumerable: true,
  get: function () {
    return _deepmerge.default;
  }
});
Object.defineProperty(exports, "elementAcceptingRef", {
  enumerable: true,
  get: function () {
    return _elementAcceptingRef.default;
  }
});
Object.defineProperty(exports, "elementTypeAcceptingRef", {
  enumerable: true,
  get: function () {
    return _elementTypeAcceptingRef.default;
  }
});
Object.defineProperty(exports, "exactProp", {
  enumerable: true,
  get: function () {
    return _exactProp.default;
  }
});
Object.defineProperty(exports, "formatMuiErrorMessage", {
  enumerable: true,
  get: function () {
    return _formatMuiErrorMessage.default;
  }
});
Object.defineProperty(exports, "getDisplayName", {
  enumerable: true,
  get: function () {
    return _getDisplayName.default;
  }
});
Object.defineProperty(exports, "getValidReactChildren", {
  enumerable: true,
  get: function () {
    return _getValidReactChildren.default;
  }
});
Object.defineProperty(exports, "integerPropType", {
  enumerable: true,
  get: function () {
    return _integerPropType.default;
  }
});
Object.defineProperty(exports, "internal_resolveProps", {
  enumerable: true,
  get: function () {
    return _resolveProps.default;
  }
});
Object.defineProperty(exports, "isPlainObject", {
  enumerable: true,
  get: function () {
    return _deepmerge.isPlainObject;
  }
});
Object.defineProperty(exports, "ponyfillGlobal", {
  enumerable: true,
  get: function () {
    return _ponyfillGlobal.default;
  }
});
Object.defineProperty(exports, "refType", {
  enumerable: true,
  get: function () {
    return _refType.default;
  }
});
Object.defineProperty(exports, "unstable_ClassNameGenerator", {
  enumerable: true,
  get: function () {
    return _ClassNameGenerator.default;
  }
});
Object.defineProperty(exports, "unstable_Timeout", {
  enumerable: true,
  get: function () {
    return _useTimeout.Timeout;
  }
});
Object.defineProperty(exports, "unstable_capitalize", {
  enumerable: true,
  get: function () {
    return _capitalize.default;
  }
});
Object.defineProperty(exports, "unstable_composeClasses", {
  enumerable: true,
  get: function () {
    return _composeClasses.default;
  }
});
Object.defineProperty(exports, "unstable_createChainedFunction", {
  enumerable: true,
  get: function () {
    return _createChainedFunction.default;
  }
});
Object.defineProperty(exports, "unstable_debounce", {
  enumerable: true,
  get: function () {
    return _debounce.default;
  }
});
Object.defineProperty(exports, "unstable_deprecatedPropType", {
  enumerable: true,
  get: function () {
    return _deprecatedPropType.default;
  }
});
Object.defineProperty(exports, "unstable_detectScrollType", {
  enumerable: true,
  get: function () {
    return _scrollLeft.detectScrollType;
  }
});
Object.defineProperty(exports, "unstable_extractEventHandlers", {
  enumerable: true,
  get: function () {
    return _extractEventHandlers.default;
  }
});
Object.defineProperty(exports, "unstable_generateUtilityClass", {
  enumerable: true,
  get: function () {
    return _generateUtilityClass.default;
  }
});
Object.defineProperty(exports, "unstable_generateUtilityClasses", {
  enumerable: true,
  get: function () {
    return _generateUtilityClasses.default;
  }
});
Object.defineProperty(exports, "unstable_getNormalizedScrollLeft", {
  enumerable: true,
  get: function () {
    return _scrollLeft.getNormalizedScrollLeft;
  }
});
Object.defineProperty(exports, "unstable_getReactElementRef", {
  enumerable: true,
  get: function () {
    return _getReactElementRef.default;
  }
});
Object.defineProperty(exports, "unstable_getScrollbarSize", {
  enumerable: true,
  get: function () {
    return _getScrollbarSize.default;
  }
});
Object.defineProperty(exports, "unstable_isGlobalState", {
  enumerable: true,
  get: function () {
    return _generateUtilityClass.isGlobalState;
  }
});
Object.defineProperty(exports, "unstable_isMuiElement", {
  enumerable: true,
  get: function () {
    return _isMuiElement.default;
  }
});
Object.defineProperty(exports, "unstable_ownerDocument", {
  enumerable: true,
  get: function () {
    return _ownerDocument.default;
  }
});
Object.defineProperty(exports, "unstable_ownerWindow", {
  enumerable: true,
  get: function () {
    return _ownerWindow.default;
  }
});
Object.defineProperty(exports, "unstable_requirePropFactory", {
  enumerable: true,
  get: function () {
    return _requirePropFactory.default;
  }
});
Object.defineProperty(exports, "unstable_resolveComponentProps", {
  enumerable: true,
  get: function () {
    return _resolveComponentProps.default;
  }
});
Object.defineProperty(exports, "unstable_setRef", {
  enumerable: true,
  get: function () {
    return _setRef.default;
  }
});
Object.defineProperty(exports, "unstable_unsupportedProp", {
  enumerable: true,
  get: function () {
    return _unsupportedProp.default;
  }
});
Object.defineProperty(exports, "unstable_useControlled", {
  enumerable: true,
  get: function () {
    return _useControlled.default;
  }
});
Object.defineProperty(exports, "unstable_useEnhancedEffect", {
  enumerable: true,
  get: function () {
    return _useEnhancedEffect.default;
  }
});
Object.defineProperty(exports, "unstable_useEventCallback", {
  enumerable: true,
  get: function () {
    return _useEventCallback.default;
  }
});
Object.defineProperty(exports, "unstable_useForkRef", {
  enumerable: true,
  get: function () {
    return _useForkRef.default;
  }
});
Object.defineProperty(exports, "unstable_useId", {
  enumerable: true,
  get: function () {
    return _useId.default;
  }
});
Object.defineProperty(exports, "unstable_useIsFocusVisible", {
  enumerable: true,
  get: function () {
    return _useIsFocusVisible.default;
  }
});
Object.defineProperty(exports, "unstable_useLazyRef", {
  enumerable: true,
  get: function () {
    return _useLazyRef.default;
  }
});
Object.defineProperty(exports, "unstable_useOnMount", {
  enumerable: true,
  get: function () {
    return _useOnMount.default;
  }
});
Object.defineProperty(exports, "unstable_useSlotProps", {
  enumerable: true,
  get: function () {
    return _useSlotProps.default;
  }
});
Object.defineProperty(exports, "unstable_useTimeout", {
  enumerable: true,
  get: function () {
    return _useTimeout.default;
  }
});
Object.defineProperty(exports, "usePreviousProps", {
  enumerable: true,
  get: function () {
    return _usePreviousProps.default;
  }
});
Object.defineProperty(exports, "visuallyHidden", {
  enumerable: true,
  get: function () {
    return _visuallyHidden.default;
  }
});
var _chainPropTypes = _interopRequireDefault(chainPropTypes$2);
var _deepmerge = _interopRequireWildcard(deepmerge$2);
var _elementAcceptingRef = _interopRequireDefault(elementAcceptingRef$2);
var _elementTypeAcceptingRef = _interopRequireDefault(elementTypeAcceptingRef$2);
var _exactProp = _interopRequireDefault(exactProp$2);
var _formatMuiErrorMessage = _interopRequireDefault(formatMuiErrorMessage$2);
var _getDisplayName = _interopRequireDefault(getDisplayName$3);
var _HTMLElementType = _interopRequireDefault(HTMLElementType$2);
var _ponyfillGlobal = _interopRequireDefault(ponyfillGlobal$1);
var _refType = _interopRequireDefault(refType$2);
var _capitalize = _interopRequireDefault(capitalize$4);
var _createChainedFunction = _interopRequireDefault(createChainedFunction$3);
var _debounce = _interopRequireDefault(debounce$6);
var _deprecatedPropType = _interopRequireDefault(deprecatedPropType$3);
var _isMuiElement = _interopRequireDefault(isMuiElement$3);
var _ownerDocument = _interopRequireDefault(ownerDocument$3);
var _ownerWindow = _interopRequireDefault(ownerWindow$3);
var _requirePropFactory = _interopRequireDefault(requirePropFactory$3);
var _setRef = _interopRequireDefault(setRef$3);
var _useEnhancedEffect = _interopRequireDefault(useEnhancedEffect$3);
var _useId = _interopRequireDefault(useId$3);
var _unsupportedProp = _interopRequireDefault(unsupportedProp$3);
var _useControlled = _interopRequireDefault(useControlled$3);
var _useEventCallback = _interopRequireDefault(useEventCallback$3);
var _useForkRef = _interopRequireDefault(useForkRef$3);
var _useLazyRef = _interopRequireDefault(useLazyRef);
var _useTimeout = _interopRequireWildcard(useTimeout$2);
var _useOnMount = _interopRequireDefault(useOnMount);
var _useIsFocusVisible = _interopRequireDefault(useIsFocusVisible$3);
var _getScrollbarSize = _interopRequireDefault(getScrollbarSize$3);
var _scrollLeft = scrollLeft$2;
var _usePreviousProps = _interopRequireDefault(usePreviousProps$2);
var _getValidReactChildren = _interopRequireDefault(getValidReactChildren$2);
var _visuallyHidden = _interopRequireDefault(visuallyHidden$2);
var _integerPropType = _interopRequireDefault(integerPropType$1);
var _resolveProps = _interopRequireDefault(resolveProps$2);
var _composeClasses = _interopRequireDefault(composeClasses$2);
var _generateUtilityClass = _interopRequireWildcard(generateUtilityClass$3);
Object.keys(_generateUtilityClass).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _generateUtilityClass[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _generateUtilityClass[key];
    }
  });
});
var _generateUtilityClasses = _interopRequireDefault(generateUtilityClasses$3);
var _ClassNameGenerator = _interopRequireDefault(ClassNameGenerator$2);
var _clamp = _interopRequireDefault(clamp$5);
var _useSlotProps = _interopRequireDefault(useSlotProps$2);
var _resolveComponentProps = _interopRequireDefault(resolveComponentProps$2);
var _extractEventHandlers = _interopRequireDefault(extractEventHandlers$2);
var _getReactElementRef = _interopRequireDefault(getReactElementRef$2);
var _types = types$1;
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(utils$7));

var ThemeContext$1 = {};

Object.defineProperty(ThemeContext$1, "__esModule", {
  value: true
});
ThemeContext$1.default = void 0;
var React$2Q = _interopRequireWildcard$4f(React__default$4);
function _getRequireWildcardCache$3_(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3_ = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4f(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3_(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ThemeContext = /*#__PURE__*/React$2Q.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}
ThemeContext$1.default = ThemeContext;

var useTheme$3 = {};

var useTheme$2 = {};

var _interopRequireDefault$90 = interopRequireDefault$1.exports;
Object.defineProperty(useTheme$2, "__esModule", {
  value: true
});
useTheme$2.default = useTheme$1;
var React$2P = _interopRequireWildcard$4e(React__default$4);
var _ThemeContext$1 = _interopRequireDefault$90(ThemeContext$1);
function _getRequireWildcardCache$3Z(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3Z = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4e(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3Z(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useTheme$1() {
  const theme = React$2P.useContext(_ThemeContext$1.default);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2P.useDebugValue(theme);
  }
  return theme;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useTheme.default;
  }
});
var _useTheme = _interopRequireDefault(useTheme$2);
}(useTheme$3));

var nested = {};

Object.defineProperty(nested, "__esModule", {
  value: true
});
nested.default = void 0;
const hasSymbol = typeof Symbol === 'function' && Symbol.for;
nested.default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

var _interopRequireDefault$8$ = interopRequireDefault$1.exports;
Object.defineProperty(ThemeProvider$6, "__esModule", {
  value: true
});
ThemeProvider$6.default = void 0;
var _extends2$2x = _interopRequireDefault$8$(_extends$19.exports);
var React$2O = _interopRequireWildcard$4d(React__default$4);
var _propTypes$2Z = _interopRequireDefault$8$(propTypes.exports);
var _utils$V = utils$7;
var _ThemeContext = _interopRequireDefault$8$(ThemeContext$1);
var _useTheme$g = _interopRequireDefault$8$(useTheme$3);
var _nested = _interopRequireDefault$8$(nested);
var _jsxRuntime$2Q = require$$11;
function _getRequireWildcardCache$3Y(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3Y = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4d(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3Y(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// To support composition of theme.
function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    const mergedTheme = localTheme(outerTheme);
    if (process.env.NODE_ENV !== 'production') {
      if (!mergedTheme) {
        console.error(['MUI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }
    return mergedTheme;
  }
  return (0, _extends2$2x.default)({}, outerTheme, localTheme);
}

/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
function ThemeProvider$5(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = (0, _useTheme$g.default)();
  if (process.env.NODE_ENV !== 'production') {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }
  const theme = React$2O.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
    if (output != null) {
      output[_nested.default] = outerTheme !== null;
    }
    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/(0, _jsxRuntime$2Q.jsx)(_ThemeContext.default.Provider, {
    value: theme,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$5.propTypes = {
  /**
   * Your component tree.
   */
  children: _propTypes$2Z.default.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: _propTypes$2Z.default.oneOfType([_propTypes$2Z.default.object, _propTypes$2Z.default.func]).isRequired
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$5.propTypes = (0, _utils$V.exactProp)(ThemeProvider$5.propTypes) : void 0;
}
ThemeProvider$6.default = ThemeProvider$5;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ThemeProvider.default;
  }
});
Object.defineProperty(exports, "unstable_nested", {
  enumerable: true,
  get: function () {
    return _nested.default;
  }
});
var _ThemeProvider = _interopRequireDefault(ThemeProvider$6);
var _nested = _interopRequireDefault(nested);
}(ThemeProvider$7));

/**
 * @mui/private-theming v5.17.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ThemeProvider: true,
  useTheme: true
};
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function () {
    return _ThemeProvider.default;
  }
});
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function () {
    return _useTheme.default;
  }
});
var _ThemeProvider = _interopRequireWildcard(ThemeProvider$7);
Object.keys(_ThemeProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ThemeProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ThemeProvider[key];
    }
  });
});
var _useTheme = _interopRequireDefault(useTheme$3);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(node$1));

var RtlProvider$1 = {};

var _interopRequireDefault$8_ = interopRequireDefault$1.exports;
Object.defineProperty(RtlProvider$1, "__esModule", {
  value: true
});
RtlProvider$1.useRtl = RtlProvider$1.default = void 0;
var _extends2$2w = _interopRequireDefault$8_(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2f = _interopRequireDefault$8_(objectWithoutPropertiesLoose.exports);
var React$2N = _interopRequireWildcard$4c(React__default$4);
var _propTypes$2Y = _interopRequireDefault$8_(propTypes.exports);
var _jsxRuntime$2P = require$$11;
const _excluded$2J = ["value"];
function _getRequireWildcardCache$3X(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3X = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4c(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3X(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RtlContext = /*#__PURE__*/React$2N.createContext();
function RtlProvider(_ref) {
  let {
      value
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2$2f.default)(_ref, _excluded$2J);
  return /*#__PURE__*/(0, _jsxRuntime$2P.jsx)(RtlContext.Provider, (0, _extends2$2w.default)({
    value: value != null ? value : true
  }, props));
}
process.env.NODE_ENV !== "production" ? RtlProvider.propTypes = {
  children: _propTypes$2Y.default.node,
  value: _propTypes$2Y.default.bool
} : void 0;
const useRtl = () => {
  const value = React$2N.useContext(RtlContext);
  return value != null ? value : false;
};
RtlProvider$1.useRtl = useRtl;
RtlProvider$1.default = RtlProvider;

var useLayerOrder$1 = {};

var _interopRequireDefault$8Z = interopRequireDefault$1.exports;
Object.defineProperty(useLayerOrder$1, "__esModule", {
  value: true
});
useLayerOrder$1.default = useLayerOrder;
_interopRequireWildcard$4b(React__default$4);
var _useEnhancedEffect$8 = _interopRequireDefault$8Z(useEnhancedEffect$3);
var _useId$7 = _interopRequireDefault$8Z(useId$3);
var _GlobalStyles$2 = _interopRequireDefault$8Z(GlobalStyles$5);
var _useThemeWithoutDefault$2 = _interopRequireDefault$8Z(useThemeWithoutDefault);
var _jsxRuntime$2O = require$$11;
function _getRequireWildcardCache$3W(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3W = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4b(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3W(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */function useLayerOrder(theme) {
  const upperTheme = (0, _useThemeWithoutDefault$2.default)();
  const id = (0, _useId$7.default)() || '';
  const {
    modularCssLayers
  } = theme;
  let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
  if (!modularCssLayers || upperTheme !== null) {
    // skip this hook if upper theme exists.
    layerOrder = '';
  } else if (typeof modularCssLayers === 'string') {
    layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
  } else {
    layerOrder = `@layer ${layerOrder};`;
  }
  (0, _useEnhancedEffect$8.default)(() => {
    const head = document.querySelector('head');
    if (!head) {
      return;
    }
    const firstChild = head.firstChild;
    if (layerOrder) {
      var _firstChild$hasAttrib;
      // Only insert if first child doesn't have data-mui-layer-order attribute
      if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) {
        return;
      }
      const styleElement = document.createElement('style');
      styleElement.setAttribute('data-mui-layer-order', id);
      styleElement.textContent = layerOrder;
      head.prepend(styleElement);
    } else {
      var _head$querySelector;
      (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
    }
  }, [layerOrder, id]);
  if (!layerOrder) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime$2O.jsx)(_GlobalStyles$2.default, {
    styles: layerOrder
  });
}

var _interopRequireDefault$8Y = interopRequireDefault$1.exports;
Object.defineProperty(ThemeProvider$8, "__esModule", {
  value: true
});
ThemeProvider$8.default = void 0;
var _extends2$2v = _interopRequireDefault$8Y(_extends$19.exports);
var React$2M = _interopRequireWildcard$4a(React__default$4);
var _propTypes$2X = _interopRequireDefault$8Y(propTypes.exports);
var _privateTheming$1 = node$1;
var _exactProp$1 = _interopRequireDefault$8Y(exactProp$2);
var _styledEngine$1 = node$3;
var _useThemeWithoutDefault$1 = _interopRequireDefault$8Y(useThemeWithoutDefault);
var _RtlProvider$a = _interopRequireDefault$8Y(RtlProvider$1);
var _DefaultPropsProvider$1Q = _interopRequireDefault$8Y(DefaultPropsProvider$3);
var _useLayerOrder = _interopRequireDefault$8Y(useLayerOrder$1);
var _jsxRuntime$2N = require$$11;
function _getRequireWildcardCache$3V(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3V = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4a(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3V(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
  return React$2M.useMemo(() => {
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    if (typeof localTheme === 'function') {
      const mergedTheme = localTheme(resolvedTheme);
      const result = themeId ? (0, _extends2$2v.default)({}, upperTheme, {
        [themeId]: mergedTheme
      }) : mergedTheme;
      // must return a function for the private theme to NOT merge with the upper theme.
      // see the test case "use provided theme from a callback" in ThemeProvider.test.js
      if (isPrivate) {
        return () => result;
      }
      return result;
    }
    return themeId ? (0, _extends2$2v.default)({}, upperTheme, {
      [themeId]: localTheme
    }) : (0, _extends2$2v.default)({}, upperTheme, localTheme);
  }, [themeId, upperTheme, localTheme, isPrivate]);
}

/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */
function ThemeProvider$4(props) {
  const {
    children,
    theme: localTheme,
    themeId
  } = props;
  const upperTheme = (0, _useThemeWithoutDefault$1.default)(EMPTY_THEME);
  const upperPrivateTheme = (0, _privateTheming$1.useTheme)() || EMPTY_THEME;
  if (process.env.NODE_ENV !== 'production') {
    if (upperTheme === null && typeof localTheme === 'function' || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === 'function') {
      console.error(['MUI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }
  const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
  const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
  const rtlValue = engineTheme.direction === 'rtl';
  const layerOrder = (0, _useLayerOrder.default)(engineTheme);
  return /*#__PURE__*/(0, _jsxRuntime$2N.jsx)(_privateTheming$1.ThemeProvider, {
    theme: privateTheme,
    children: /*#__PURE__*/(0, _jsxRuntime$2N.jsx)(_styledEngine$1.ThemeContext.Provider, {
      value: engineTheme,
      children: /*#__PURE__*/(0, _jsxRuntime$2N.jsx)(_RtlProvider$a.default, {
        value: rtlValue,
        children: /*#__PURE__*/(0, _jsxRuntime$2N.jsxs)(_DefaultPropsProvider$1Q.default, {
          value: engineTheme == null ? void 0 : engineTheme.components,
          children: [layerOrder, children]
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" ? ThemeProvider$4.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: _propTypes$2X.default.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: _propTypes$2X.default.oneOfType([_propTypes$2X.default.func, _propTypes$2X.default.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: _propTypes$2X.default.string
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? ThemeProvider$4.propTypes = (0, _exactProp$1.default)(ThemeProvider$4.propTypes) : void 0;
}
ThemeProvider$8.default = ThemeProvider$4;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ThemeProvider.default;
  }
});
var _ThemeProvider = _interopRequireDefault(ThemeProvider$8);
}(ThemeProvider$9));

var createCssVarsProvider$1 = {};

var InitColorSchemeScript$3 = {};

Object.defineProperty(InitColorSchemeScript$3, "__esModule", {
  value: true
});
InitColorSchemeScript$3.DEFAULT_MODE_STORAGE_KEY = InitColorSchemeScript$3.DEFAULT_COLOR_SCHEME_STORAGE_KEY = InitColorSchemeScript$3.DEFAULT_ATTRIBUTE = void 0;
InitColorSchemeScript$3.default = InitColorSchemeScript$2;
_interopRequireWildcard$49(React__default$4);
var _jsxRuntime$2M = require$$11;
function _getRequireWildcardCache$3U(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3U = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$49(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3U(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Split this component for RSC import
 */

const DEFAULT_MODE_STORAGE_KEY = InitColorSchemeScript$3.DEFAULT_MODE_STORAGE_KEY = 'mode';
const DEFAULT_COLOR_SCHEME_STORAGE_KEY = InitColorSchemeScript$3.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const DEFAULT_ATTRIBUTE = InitColorSchemeScript$3.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function InitColorSchemeScript$2(options) {
  const {
    defaultMode = 'light',
    defaultLightColorScheme = 'light',
    defaultDarkColorScheme = 'dark',
    modeStorageKey = DEFAULT_MODE_STORAGE_KEY,
    colorSchemeStorageKey = DEFAULT_COLOR_SCHEME_STORAGE_KEY,
    attribute = DEFAULT_ATTRIBUTE,
    colorSchemeNode = 'document.documentElement',
    nonce
  } = options || {};
  return /*#__PURE__*/(0, _jsxRuntime$2M.jsx)("script", {
    suppressHydrationWarning: true,
    nonce: typeof window === 'undefined' ? nonce : ''
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  var mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  var colorScheme = '';
  if (mode === 'system') {
    // handle system mode
    var mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
    } else {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
    }
  }
  if (mode === 'light') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  }
  if (mode === 'dark') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  }
  if (colorScheme) {
    ${colorSchemeNode}.setAttribute('${attribute}', colorScheme);
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}

var useCurrentColorScheme$1 = {};

var _interopRequireDefault$8X = interopRequireDefault$1.exports;
Object.defineProperty(useCurrentColorScheme$1, "__esModule", {
  value: true
});
useCurrentColorScheme$1.default = useCurrentColorScheme;
useCurrentColorScheme$1.getColorScheme = getColorScheme;
useCurrentColorScheme$1.getSystemMode = getSystemMode;
var _extends2$2u = _interopRequireDefault$8X(_extends$19.exports);
var React$2L = _interopRequireWildcard$48(React__default$4);
var _InitColorSchemeScript$3 = InitColorSchemeScript$3;
function _getRequireWildcardCache$3T(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3T = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$48(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3T(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getSystemMode(mode) {
  if (typeof window !== 'undefined' && mode === 'system') {
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      return 'dark';
    }
    return 'light';
  }
  return undefined;
}
function processState(state, callback) {
  if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') {
    return callback('light');
  }
  if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') {
    return callback('dark');
  }
  return undefined;
}
function getColorScheme(state) {
  return processState(state, mode => {
    if (mode === 'light') {
      return state.lightColorScheme;
    }
    if (mode === 'dark') {
      return state.darkColorScheme;
    }
    return undefined;
  });
}
function initializeValue(key, defaultValue) {
  if (typeof window === 'undefined') {
    return undefined;
  }
  let value;
  try {
    value = localStorage.getItem(key) || undefined;
    if (!value) {
      // the first time that user enters the site.
      localStorage.setItem(key, defaultValue);
    }
  } catch (e) {
    // Unsupported
  }
  return value || defaultValue;
}
function useCurrentColorScheme(options) {
  const {
    defaultMode = 'light',
    defaultLightColorScheme,
    defaultDarkColorScheme,
    supportedColorSchemes = [],
    modeStorageKey = _InitColorSchemeScript$3.DEFAULT_MODE_STORAGE_KEY,
    colorSchemeStorageKey = _InitColorSchemeScript$3.DEFAULT_COLOR_SCHEME_STORAGE_KEY,
    storageWindow = typeof window === 'undefined' ? undefined : window
  } = options;
  const joinedColorSchemes = supportedColorSchemes.join(',');
  const [state, setState] = React$2L.useState(() => {
    const initialMode = initializeValue(modeStorageKey, defaultMode);
    const lightColorScheme = initializeValue(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
    const darkColorScheme = initializeValue(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
    return {
      mode: initialMode,
      systemMode: getSystemMode(initialMode),
      lightColorScheme,
      darkColorScheme
    };
  });
  const colorScheme = getColorScheme(state);
  const setMode = React$2L.useCallback(mode => {
    setState(currentState => {
      if (mode === currentState.mode) {
        // do nothing if mode does not change
        return currentState;
      }
      const newMode = mode != null ? mode : defaultMode;
      try {
        localStorage.setItem(modeStorageKey, newMode);
      } catch (e) {
        // Unsupported
      }
      return (0, _extends2$2u.default)({}, currentState, {
        mode: newMode,
        systemMode: getSystemMode(newMode)
      });
    });
  }, [modeStorageKey, defaultMode]);
  const setColorScheme = React$2L.useCallback(value => {
    if (!value) {
      setState(currentState => {
        try {
          localStorage.setItem(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
          localStorage.setItem(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
        } catch (e) {
          // Unsupported
        }
        return (0, _extends2$2u.default)({}, currentState, {
          lightColorScheme: defaultLightColorScheme,
          darkColorScheme: defaultDarkColorScheme
        });
      });
    } else if (typeof value === 'string') {
      if (value && !joinedColorSchemes.includes(value)) {
        console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
      } else {
        setState(currentState => {
          const newState = (0, _extends2$2u.default)({}, currentState);
          processState(currentState, mode => {
            try {
              localStorage.setItem(`${colorSchemeStorageKey}-${mode}`, value);
            } catch (e) {
              // Unsupported
            }
            if (mode === 'light') {
              newState.lightColorScheme = value;
            }
            if (mode === 'dark') {
              newState.darkColorScheme = value;
            }
          });
          return newState;
        });
      }
    } else {
      setState(currentState => {
        const newState = (0, _extends2$2u.default)({}, currentState);
        const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
        const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
        if (newLightColorScheme) {
          if (!joinedColorSchemes.includes(newLightColorScheme)) {
            console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
          } else {
            newState.lightColorScheme = newLightColorScheme;
            try {
              localStorage.setItem(`${colorSchemeStorageKey}-light`, newLightColorScheme);
            } catch (error) {
              // Unsupported
            }
          }
        }
        if (newDarkColorScheme) {
          if (!joinedColorSchemes.includes(newDarkColorScheme)) {
            console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
          } else {
            newState.darkColorScheme = newDarkColorScheme;
            try {
              localStorage.setItem(`${colorSchemeStorageKey}-dark`, newDarkColorScheme);
            } catch (error) {
              // Unsupported
            }
          }
        }
        return newState;
      });
    }
  }, [joinedColorSchemes, colorSchemeStorageKey, defaultLightColorScheme, defaultDarkColorScheme]);
  const handleMediaQuery = React$2L.useCallback(event => {
    if (state.mode === 'system') {
      setState(currentState => {
        const systemMode = event != null && event.matches ? 'dark' : 'light';

        // Early exit, nothing changed.
        if (currentState.systemMode === systemMode) {
          return currentState;
        }
        return (0, _extends2$2u.default)({}, currentState, {
          systemMode
        });
      });
    }
  }, [state.mode]);

  // Ref hack to avoid adding handleMediaQuery as a dep
  const mediaListener = React$2L.useRef(handleMediaQuery);
  mediaListener.current = handleMediaQuery;
  React$2L.useEffect(() => {
    const handler = (...args) => mediaListener.current(...args);

    // Always listen to System preference
    const media = window.matchMedia('(prefers-color-scheme: dark)');

    // Intentionally use deprecated listener methods to support iOS & old browsers
    media.addListener(handler);
    handler(media);
    return () => {
      media.removeListener(handler);
    };
  }, []);

  // Handle when localStorage has changed
  React$2L.useEffect(() => {
    if (storageWindow) {
      const handleStorage = event => {
        const value = event.newValue;
        if (typeof event.key === 'string' && event.key.startsWith(colorSchemeStorageKey) && (!value || joinedColorSchemes.match(value))) {
          // If the key is deleted, value will be null then reset color scheme to the default one.
          if (event.key.endsWith('light')) {
            setColorScheme({
              light: value
            });
          }
          if (event.key.endsWith('dark')) {
            setColorScheme({
              dark: value
            });
          }
        }
        if (event.key === modeStorageKey && (!value || ['light', 'dark', 'system'].includes(value))) {
          setMode(value || defaultMode);
        }
      };
      // For syncing color-scheme changes between iframes
      storageWindow.addEventListener('storage', handleStorage);
      return () => {
        storageWindow.removeEventListener('storage', handleStorage);
      };
    }
    return undefined;
  }, [setColorScheme, setMode, modeStorageKey, colorSchemeStorageKey, joinedColorSchemes, defaultMode, storageWindow]);
  return (0, _extends2$2u.default)({}, state, {
    colorScheme,
    setMode,
    setColorScheme
  });
}

var _interopRequireDefault$8W = interopRequireDefault$1.exports;
Object.defineProperty(createCssVarsProvider$1, "__esModule", {
  value: true
});
createCssVarsProvider$1.DISABLE_CSS_TRANSITION = void 0;
createCssVarsProvider$1.default = createCssVarsProvider;
var _extends2$2t = _interopRequireDefault$8W(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2e = _interopRequireDefault$8W(objectWithoutPropertiesLoose.exports);
var _formatMuiErrorMessage2$6 = _interopRequireDefault$8W(formatMuiErrorMessage$2);
var React$2K = _interopRequireWildcard$47(React__default$4);
var _propTypes$2W = _interopRequireDefault$8W(propTypes.exports);
var _deepmerge$7 = _interopRequireDefault$8W(deepmerge$2);
var _styledEngine = node$3;
var _privateTheming = node$1;
var _ThemeProvider = _interopRequireDefault$8W(ThemeProvider$9);
var _InitColorSchemeScript$2 = _interopRequireWildcard$47(InitColorSchemeScript$3);
var _useCurrentColorScheme = _interopRequireDefault$8W(useCurrentColorScheme$1);
var _jsxRuntime$2L = require$$11;
const _excluded$2I = ["colorSchemes", "components", "generateCssVars", "cssVarPrefix"];
function _getRequireWildcardCache$3S(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3S = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$47(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3S(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DISABLE_CSS_TRANSITION = createCssVarsProvider$1.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function createCssVarsProvider(options) {
  const {
    themeId,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: defaultTheme = {},
    attribute: defaultAttribute = _InitColorSchemeScript$2.DEFAULT_ATTRIBUTE,
    modeStorageKey: defaultModeStorageKey = _InitColorSchemeScript$2.DEFAULT_MODE_STORAGE_KEY,
    colorSchemeStorageKey: defaultColorSchemeStorageKey = _InitColorSchemeScript$2.DEFAULT_COLOR_SCHEME_STORAGE_KEY,
    defaultMode: designSystemMode = 'light',
    defaultColorScheme: designSystemColorScheme,
    disableTransitionOnChange: designSystemTransitionOnChange = false,
    resolveTheme,
    excludeVariablesFromRoot
  } = options;
  if (!defaultTheme.colorSchemes || typeof designSystemColorScheme === 'string' && !defaultTheme.colorSchemes[designSystemColorScheme] || typeof designSystemColorScheme === 'object' && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.light] || typeof designSystemColorScheme === 'object' && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.dark]) {
    console.error(`MUI: \`${designSystemColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
  }
  const ColorSchemeContext = /*#__PURE__*/React$2K.createContext(undefined);
  if (process.env.NODE_ENV !== 'production') {
    ColorSchemeContext.displayName = 'ColorSchemeContext';
  }
  const useColorScheme = () => {
    const value = React$2K.useContext(ColorSchemeContext);
    if (!value) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: \`useColorScheme\` must be called under <CssVarsProvider />` : (0, _formatMuiErrorMessage2$6.default)(19));
    }
    return value;
  };
  function CssVarsProvider(props) {
    const {
      children,
      theme: themeProp = defaultTheme,
      modeStorageKey = defaultModeStorageKey,
      colorSchemeStorageKey = defaultColorSchemeStorageKey,
      attribute = defaultAttribute,
      defaultMode = designSystemMode,
      defaultColorScheme = designSystemColorScheme,
      disableTransitionOnChange = designSystemTransitionOnChange,
      storageWindow = typeof window === 'undefined' ? undefined : window,
      documentNode = typeof document === 'undefined' ? undefined : document,
      colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement,
      colorSchemeSelector = ':root',
      disableNestedContext = false,
      disableStyleSheetGeneration = false
    } = props;
    const hasMounted = React$2K.useRef(false);
    const upperTheme = (0, _privateTheming.useTheme)();
    const ctx = React$2K.useContext(ColorSchemeContext);
    const nested = !!ctx && !disableNestedContext;
    const scopedTheme = themeProp[themeId];
    const _ref = scopedTheme || themeProp,
      {
        colorSchemes = {},
        components = {},
        generateCssVars = () => ({
          vars: {},
          css: {}
        }),
        cssVarPrefix
      } = _ref,
      restThemeProp = (0, _objectWithoutPropertiesLoose2$2e.default)(_ref, _excluded$2I);
    const allColorSchemes = Object.keys(colorSchemes);
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;

    // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
    const {
      mode: stateMode,
      setMode,
      systemMode,
      lightColorScheme,
      darkColorScheme,
      colorScheme: stateColorScheme,
      setColorScheme
    } = (0, _useCurrentColorScheme.default)({
      supportedColorSchemes: allColorSchemes,
      defaultLightColorScheme,
      defaultDarkColorScheme,
      modeStorageKey,
      colorSchemeStorageKey,
      defaultMode,
      storageWindow
    });
    let mode = stateMode;
    let colorScheme = stateColorScheme;
    if (nested) {
      mode = ctx.mode;
      colorScheme = ctx.colorScheme;
    }
    const calculatedMode = (() => {
      if (mode) {
        return mode;
      }
      // This scope occurs on the server
      if (defaultMode === 'system') {
        return designSystemMode;
      }
      return defaultMode;
    })();
    const calculatedColorScheme = (() => {
      if (!colorScheme) {
        // This scope occurs on the server
        if (calculatedMode === 'dark') {
          return defaultDarkColorScheme;
        }
        // use light color scheme, if default mode is 'light' | 'system'
        return defaultLightColorScheme;
      }
      return colorScheme;
    })();

    // 2. Create CSS variables and store them in objects (to be generated in stylesheets in the final step)
    const {
      css: rootCss,
      vars: rootVars
    } = generateCssVars();

    // 3. Start composing the theme object
    const theme = (0, _extends2$2t.default)({}, restThemeProp, {
      components,
      colorSchemes,
      cssVarPrefix,
      vars: rootVars,
      getColorSchemeSelector: targetColorScheme => `[${attribute}="${targetColorScheme}"] &`
    });

    // 4. Create color CSS variables and store them in objects (to be generated in stylesheets in the final step)
    //    The default color scheme stylesheet is constructed to have the least CSS specificity.
    //    The other color schemes uses selector, default as data attribute, to increase the CSS specificity so that they can override the default color scheme stylesheet.
    const defaultColorSchemeStyleSheet = {};
    const otherColorSchemesStyleSheet = {};
    Object.entries(colorSchemes).forEach(([key, scheme]) => {
      const {
        css,
        vars
      } = generateCssVars(key);
      theme.vars = (0, _deepmerge$7.default)(theme.vars, vars);
      if (key === calculatedColorScheme) {
        // 4.1 Merge the selected color scheme to the theme
        Object.keys(scheme).forEach(schemeKey => {
          if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') {
            // shallow merge the 1st level structure of the theme.
            theme[schemeKey] = (0, _extends2$2t.default)({}, theme[schemeKey], scheme[schemeKey]);
          } else {
            theme[schemeKey] = scheme[schemeKey];
          }
        });
        if (theme.palette) {
          theme.palette.colorScheme = key;
        }
      }
      const resolvedDefaultColorScheme = (() => {
        if (typeof defaultColorScheme === 'string') {
          return defaultColorScheme;
        }
        if (defaultMode === 'dark') {
          return defaultColorScheme.dark;
        }
        return defaultColorScheme.light;
      })();
      if (key === resolvedDefaultColorScheme) {
        if (excludeVariablesFromRoot) {
          const excludedVariables = {};
          excludeVariablesFromRoot(cssVarPrefix).forEach(cssVar => {
            excludedVariables[cssVar] = css[cssVar];
            delete css[cssVar];
          });
          defaultColorSchemeStyleSheet[`[${attribute}="${key}"]`] = excludedVariables;
        }
        defaultColorSchemeStyleSheet[`${colorSchemeSelector}, [${attribute}="${key}"]`] = css;
      } else {
        otherColorSchemesStyleSheet[`${colorSchemeSelector === ':root' ? '' : colorSchemeSelector}[${attribute}="${key}"]`] = css;
      }
    });
    theme.vars = (0, _deepmerge$7.default)(theme.vars, rootVars);

    // 5. Declaring effects
    // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
    React$2K.useEffect(() => {
      if (colorScheme && colorSchemeNode) {
        // attaches attribute to <html> because the css variables are attached to :root (html)
        colorSchemeNode.setAttribute(attribute, colorScheme);
      }
    }, [colorScheme, attribute, colorSchemeNode]);

    // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
    // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
    React$2K.useEffect(() => {
      let timer;
      if (disableTransitionOnChange && hasMounted.current && documentNode) {
        const css = documentNode.createElement('style');
        css.appendChild(documentNode.createTextNode(DISABLE_CSS_TRANSITION));
        documentNode.head.appendChild(css);

        // Force browser repaint
        (() => window.getComputedStyle(documentNode.body))();
        timer = setTimeout(() => {
          documentNode.head.removeChild(css);
        }, 1);
      }
      return () => {
        clearTimeout(timer);
      };
    }, [colorScheme, disableTransitionOnChange, documentNode]);
    React$2K.useEffect(() => {
      hasMounted.current = true;
      return () => {
        hasMounted.current = false;
      };
    }, []);
    const contextValue = React$2K.useMemo(() => ({
      allColorSchemes,
      colorScheme,
      darkColorScheme,
      lightColorScheme,
      mode,
      setColorScheme,
      setMode,
      systemMode
    }), [allColorSchemes, colorScheme, darkColorScheme, lightColorScheme, mode, setColorScheme, setMode, systemMode]);
    let shouldGenerateStyleSheet = true;
    if (disableStyleSheetGeneration || nested && (upperTheme == null ? void 0 : upperTheme.cssVarPrefix) === cssVarPrefix) {
      shouldGenerateStyleSheet = false;
    }
    const element = /*#__PURE__*/(0, _jsxRuntime$2L.jsxs)(React$2K.Fragment, {
      children: [shouldGenerateStyleSheet && /*#__PURE__*/(0, _jsxRuntime$2L.jsxs)(React$2K.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime$2L.jsx)(_styledEngine.GlobalStyles, {
          styles: {
            [colorSchemeSelector]: rootCss
          }
        }), /*#__PURE__*/(0, _jsxRuntime$2L.jsx)(_styledEngine.GlobalStyles, {
          styles: defaultColorSchemeStyleSheet
        }), /*#__PURE__*/(0, _jsxRuntime$2L.jsx)(_styledEngine.GlobalStyles, {
          styles: otherColorSchemesStyleSheet
        })]
      }), /*#__PURE__*/(0, _jsxRuntime$2L.jsx)(_ThemeProvider.default, {
        themeId: scopedTheme ? themeId : undefined,
        theme: resolveTheme ? resolveTheme(theme) : theme,
        children: children
      })]
    });
    if (nested) {
      return element;
    }
    return /*#__PURE__*/(0, _jsxRuntime$2L.jsx)(ColorSchemeContext.Provider, {
      value: contextValue,
      children: element
    });
  }
  process.env.NODE_ENV !== "production" ? CssVarsProvider.propTypes = {
    /**
     * The body attribute name to attach colorScheme.
     */
    attribute: _propTypes$2W.default.string,
    /**
     * The component tree.
     */
    children: _propTypes$2W.default.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: _propTypes$2W.default.any,
    /**
     * The CSS selector for attaching the generated custom properties
     */
    colorSchemeSelector: _propTypes$2W.default.string,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: _propTypes$2W.default.string,
    /**
     * The initial color scheme used.
     */
    defaultColorScheme: _propTypes$2W.default.oneOfType([_propTypes$2W.default.string, _propTypes$2W.default.object]),
    /**
     * The initial mode used.
     */
    defaultMode: _propTypes$2W.default.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: _propTypes$2W.default.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: _propTypes$2W.default.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: _propTypes$2W.default.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: _propTypes$2W.default.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: _propTypes$2W.default.string,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: _propTypes$2W.default.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: _propTypes$2W.default.object
  } : void 0;
  const defaultLightColorScheme = typeof designSystemColorScheme === 'string' ? designSystemColorScheme : designSystemColorScheme.light;
  const defaultDarkColorScheme = typeof designSystemColorScheme === 'string' ? designSystemColorScheme : designSystemColorScheme.dark;
  const getInitColorSchemeScript = params => (0, _InitColorSchemeScript$2.default)((0, _extends2$2t.default)({
    attribute: defaultAttribute,
    colorSchemeStorageKey: defaultColorSchemeStorageKey,
    defaultMode: designSystemMode,
    defaultLightColorScheme,
    defaultDarkColorScheme,
    modeStorageKey: defaultModeStorageKey
  }, params));
  return {
    CssVarsProvider,
    useColorScheme,
    getInitColorSchemeScript
  };
}

var createGetCssVar$2 = {};

Object.defineProperty(createGetCssVar$2, "__esModule", {
  value: true
});
createGetCssVar$2.default = createGetCssVar$1;
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */
function createGetCssVar$1(prefix = '') {
  function appendVar(...vars) {
    if (!vars.length) {
      return '';
    }
    const value = vars[0];
    if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) {
      return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
    }
    return `, ${value}`;
  }

  // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
  const getCssVar = (field, ...fallbacks) => {
    return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
  };
  return getCssVar;
}

var cssVarsParser$1 = {};

Object.defineProperty(cssVarsParser$1, "__esModule", {
  value: true
});
cssVarsParser$1.assignNestedKeys = void 0;
cssVarsParser$1.default = cssVarsParser;
cssVarsParser$1.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */
const assignNestedKeys = (obj, keys, value, arrayKeys = []) => {
  let temp = obj;
  keys.forEach((k, index) => {
    if (index === keys.length - 1) {
      if (Array.isArray(temp)) {
        temp[Number(k)] = value;
      } else if (temp && typeof temp === 'object') {
        temp[k] = value;
      }
    } else if (temp && typeof temp === 'object') {
      if (!temp[k]) {
        temp[k] = arrayKeys.includes(k) ? [] : {};
      }
      temp = temp[k];
    }
  });
};

/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */
cssVarsParser$1.assignNestedKeys = assignNestedKeys;
const walkObjectDeep = (obj, callback, shouldSkipPaths) => {
  function recurse(object, parentKeys = [], arrayKeys = []) {
    Object.entries(object).forEach(([key, value]) => {
      if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([...parentKeys, key])) {
        if (value !== undefined && value !== null) {
          if (typeof value === 'object' && Object.keys(value).length > 0) {
            recurse(value, [...parentKeys, key], Array.isArray(value) ? [...arrayKeys, key] : arrayKeys);
          } else {
            callback([...parentKeys, key], value, arrayKeys);
          }
        }
      }
    });
  }
  recurse(obj);
};
cssVarsParser$1.walkObjectDeep = walkObjectDeep;
const getCssValue = (keys, value) => {
  if (typeof value === 'number') {
    if (['lineHeight', 'fontWeight', 'opacity', 'zIndex'].some(prop => keys.includes(prop))) {
      // CSS property that are unitless
      return value;
    }
    const lastKey = keys[keys.length - 1];
    if (lastKey.toLowerCase().indexOf('opacity') >= 0) {
      // opacity values are unitless
      return value;
    }
    return `${value}px`;
  }
  return value;
};

/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */
function cssVarsParser(theme, options) {
  const {
    prefix,
    shouldSkipGeneratingVar
  } = options || {};
  const css = {};
  const vars = {};
  const varsWithDefaults = {};
  walkObjectDeep(theme, (keys, value, arrayKeys) => {
    if (typeof value === 'string' || typeof value === 'number') {
      if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
        // only create css & var if `shouldSkipGeneratingVar` return false
        const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
        Object.assign(css, {
          [cssVar]: getCssValue(keys, value)
        });
        assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
        assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${value})`, arrayKeys);
      }
    }
  }, keys => keys[0] === 'vars' // skip 'vars/*' paths
  );
  return {
    css,
    vars,
    varsWithDefaults
  };
}

var prepareCssVars$1 = {};

var toPropertyKey$1 = {exports: {}};

var _typeof$15 = {exports: {}};

(function (module) {
function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(_typeof$15));

var toPrimitive$1 = {exports: {}};

(function (module) {
var _typeof = _typeof$15.exports["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(toPrimitive$1));

(function (module) {
var _typeof = _typeof$15.exports["default"];
var toPrimitive = toPrimitive$1.exports;
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(toPropertyKey$1));

var _interopRequireDefault$8V = interopRequireDefault$1.exports;
Object.defineProperty(prepareCssVars$1, "__esModule", {
  value: true
});
prepareCssVars$1.default = void 0;
var _extends2$2s = _interopRequireDefault$8V(_extends$19.exports);
var _toPropertyKey2 = _interopRequireDefault$8V(toPropertyKey$1.exports);
var _objectWithoutPropertiesLoose2$2d = _interopRequireDefault$8V(objectWithoutPropertiesLoose.exports);
var _deepmerge$6 = _interopRequireDefault$8V(deepmerge$2);
var _cssVarsParser = _interopRequireDefault$8V(cssVarsParser$1);
const _excluded$2H = ["colorSchemes", "components", "defaultColorScheme"];
function prepareCssVars(theme, parserConfig) {
  // @ts-ignore - ignore components do not exist
  const {
      colorSchemes = {},
      defaultColorScheme = 'light'
    } = theme,
    otherTheme = (0, _objectWithoutPropertiesLoose2$2d.default)(theme, _excluded$2H);
  const {
    vars: rootVars,
    css: rootCss,
    varsWithDefaults: rootVarsWithDefaults
  } = (0, _cssVarsParser.default)(otherTheme, parserConfig);
  let themeVars = rootVarsWithDefaults;
  const colorSchemesMap = {};
  const {
      [defaultColorScheme]: light
    } = colorSchemes,
    otherColorSchemes = (0, _objectWithoutPropertiesLoose2$2d.default)(colorSchemes, [defaultColorScheme].map(_toPropertyKey2.default));
  Object.entries(otherColorSchemes || {}).forEach(([key, scheme]) => {
    const {
      vars,
      css,
      varsWithDefaults
    } = (0, _cssVarsParser.default)(scheme, parserConfig);
    themeVars = (0, _deepmerge$6.default)(themeVars, varsWithDefaults);
    colorSchemesMap[key] = {
      css,
      vars
    };
  });
  if (light) {
    // default color scheme vars should be merged last to set as default
    const {
      css,
      vars,
      varsWithDefaults
    } = (0, _cssVarsParser.default)(light, parserConfig);
    themeVars = (0, _deepmerge$6.default)(themeVars, varsWithDefaults);
    colorSchemesMap[defaultColorScheme] = {
      css,
      vars
    };
  }
  const generateCssVars = colorScheme => {
    var _parserConfig$getSele2;
    if (!colorScheme) {
      var _parserConfig$getSele;
      const css = (0, _extends2$2s.default)({}, rootCss);
      return {
        css,
        vars: rootVars,
        selector: (parserConfig == null || (_parserConfig$getSele = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele.call(parserConfig, colorScheme, css)) || ':root'
      };
    }
    const css = (0, _extends2$2s.default)({}, colorSchemesMap[colorScheme].css);
    return {
      css,
      vars: colorSchemesMap[colorScheme].vars,
      selector: (parserConfig == null || (_parserConfig$getSele2 = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele2.call(parserConfig, colorScheme, css)) || ':root'
    };
  };
  return {
    vars: themeVars,
    generateCssVars
  };
}
prepareCssVars$1.default = prepareCssVars;

var createCssVarsTheme$1 = {};

var _interopRequireDefault$8U = interopRequireDefault$1.exports;
Object.defineProperty(createCssVarsTheme$1, "__esModule", {
  value: true
});
createCssVarsTheme$1.default = void 0;
var _extends2$2r = _interopRequireDefault$8U(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2c = _interopRequireDefault$8U(objectWithoutPropertiesLoose.exports);
var _prepareCssVars = _interopRequireDefault$8U(prepareCssVars$1);
const _excluded$2G = ["cssVarPrefix", "shouldSkipGeneratingVar"];
function createCssVarsTheme(theme) {
  const {
      cssVarPrefix,
      shouldSkipGeneratingVar
    } = theme,
    otherTheme = (0, _objectWithoutPropertiesLoose2$2c.default)(theme, _excluded$2G);
  return (0, _extends2$2r.default)({}, theme, (0, _prepareCssVars.default)(otherTheme, {
    prefix: cssVarPrefix,
    shouldSkipGeneratingVar
  }));
}
createCssVarsTheme$1.default = createCssVarsTheme;

var version$3 = {};

Object.defineProperty(version$3, "__esModule", {
  value: true
});
version$3.version = version$3.preReleaseNumber = version$3.preReleaseLabel = version$3.patch = version$3.minor = version$3.major = version$3.default = void 0;
const version$2 = version$3.version = "5.18.0";
version$3.major = Number("5");
version$3.minor = Number("18");
version$3.patch = Number("0");
version$3.preReleaseLabel = null;
version$3.preReleaseNumber = Number(undefined) || null;
version$3.default = version$2;

var createContainer$1 = {};

var _interopRequireDefault$8T = interopRequireDefault$1.exports;
Object.defineProperty(createContainer$1, "__esModule", {
  value: true
});
createContainer$1.default = createContainer;
var _objectWithoutPropertiesLoose2$2b = _interopRequireDefault$8T(objectWithoutPropertiesLoose.exports);
var _extends2$2q = _interopRequireDefault$8T(_extends$19.exports);
var React$2J = _interopRequireWildcard$46(React__default$4);
var _propTypes$2V = _interopRequireDefault$8T(propTypes.exports);
var _clsx$2p = _interopRequireDefault$8T(clsx.exports);
var _generateUtilityClass$1X = _interopRequireDefault$8T(generateUtilityClass$3);
var _composeClasses$1Q = _interopRequireDefault$8T(composeClasses$2);
var _capitalize$M = _interopRequireDefault$8T(capitalize$4);
var _useThemeProps$3 = _interopRequireDefault$8T(useThemeProps$3);
var _styled$1J = _interopRequireDefault$8T(styled$1);
var _createTheme$4 = _interopRequireDefault$8T(createTheme$4);
var _jsxRuntime$2K = require$$11;
const _excluded$2F = ["className", "component", "disableGutters", "fixed", "maxWidth", "classes"];
function _getRequireWildcardCache$3R(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3R = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$46(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3R(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultTheme$5 = (0, _createTheme$4.default)();
const defaultCreateStyledComponent$2 = (0, _styled$1J.default)('div', {
  name: 'MuiContainer',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`maxWidth${(0, _capitalize$M.default)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
  }
});
const useThemePropsDefault$2 = inProps => (0, _useThemeProps$3.default)({
  props: inProps,
  name: 'MuiContainer',
  defaultTheme: defaultTheme$5
});
const useUtilityClasses$1P = (ownerState, componentName) => {
  const getContainerUtilityClass = slot => {
    return (0, _generateUtilityClass$1X.default)(componentName, slot);
  };
  const {
    classes,
    fixed,
    disableGutters,
    maxWidth
  } = ownerState;
  const slots = {
    root: ['root', maxWidth && `maxWidth${(0, _capitalize$M.default)(String(maxWidth))}`, fixed && 'fixed', disableGutters && 'disableGutters']
  };
  return (0, _composeClasses$1Q.default)(slots, getContainerUtilityClass, classes);
};
function createContainer(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent$2,
    useThemeProps = useThemePropsDefault$2,
    componentName = 'MuiContainer'
  } = options;
  const ContainerRoot = createStyledComponent(({
    theme,
    ownerState
  }) => (0, _extends2$2q.default)({
    width: '100%',
    marginLeft: 'auto',
    boxSizing: 'border-box',
    marginRight: 'auto',
    display: 'block'
  }, !ownerState.disableGutters && {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }
  }), ({
    theme,
    ownerState
  }) => ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey) => {
    const breakpoint = breakpointValueKey;
    const value = theme.breakpoints.values[breakpoint];
    if (value !== 0) {
      // @ts-ignore
      acc[theme.breakpoints.up(breakpoint)] = {
        maxWidth: `${value}${theme.breakpoints.unit}`
      };
    }
    return acc;
  }, {}), ({
    theme,
    ownerState
  }) => (0, _extends2$2q.default)({}, ownerState.maxWidth === 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up('xs')]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }
  }, ownerState.maxWidth &&
  // @ts-ignore module augmentation fails if custom breakpoints are used
  ownerState.maxWidth !== 'xs' && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [theme.breakpoints.up(ownerState.maxWidth)]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
    }
  }));
  const Container = /*#__PURE__*/React$2J.forwardRef(function Container(inProps, ref) {
    const props = useThemeProps(inProps);
    const {
        className,
        component = 'div',
        disableGutters = false,
        fixed = false,
        maxWidth = 'lg'
      } = props,
      other = (0, _objectWithoutPropertiesLoose2$2b.default)(props, _excluded$2F);
    const ownerState = (0, _extends2$2q.default)({}, props, {
      component,
      disableGutters,
      fixed,
      maxWidth
    });

    // @ts-ignore module augmentation fails if custom breakpoints are used
    const classes = useUtilityClasses$1P(ownerState, componentName);
    return (
      /*#__PURE__*/
      // @ts-ignore theme is injected by the styled util
      (0, _jsxRuntime$2K.jsx)(ContainerRoot, (0, _extends2$2q.default)({
        as: component
        // @ts-ignore module augmentation fails if custom breakpoints are used
        ,
        ownerState: ownerState,
        className: (0, _clsx$2p.default)(classes.root, className),
        ref: ref
      }, other))
    );
  });
  process.env.NODE_ENV !== "production" ? Container.propTypes /* remove-proptypes */ = {
    children: _propTypes$2V.default.node,
    classes: _propTypes$2V.default.object,
    className: _propTypes$2V.default.string,
    component: _propTypes$2V.default.elementType,
    disableGutters: _propTypes$2V.default.bool,
    fixed: _propTypes$2V.default.bool,
    maxWidth: _propTypes$2V.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2V.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]), _propTypes$2V.default.string]),
    sx: _propTypes$2V.default.oneOfType([_propTypes$2V.default.arrayOf(_propTypes$2V.default.oneOfType([_propTypes$2V.default.func, _propTypes$2V.default.object, _propTypes$2V.default.bool])), _propTypes$2V.default.func, _propTypes$2V.default.object])
  } : void 0;
  return Container;
}

var Container$5 = {};

var Container$4 = {};

var _interopRequireDefault$8S = interopRequireDefault$1.exports;
Object.defineProperty(Container$4, "__esModule", {
  value: true
});
Container$4.default = void 0;
var _propTypes$2U = _interopRequireDefault$8S(propTypes.exports);
var _createContainer = _interopRequireDefault$8S(createContainer$1);
/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */
const Container$3 = (0, _createContainer.default)();
process.env.NODE_ENV !== "production" ? Container$3.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: _propTypes$2U.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2U.default.object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2U.default.elementType,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: _propTypes$2U.default.bool,
  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */
  fixed: _propTypes$2U.default.bool,
  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */
  maxWidth: _propTypes$2U.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2U.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]), _propTypes$2U.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2U.default.oneOfType([_propTypes$2U.default.arrayOf(_propTypes$2U.default.oneOfType([_propTypes$2U.default.func, _propTypes$2U.default.object, _propTypes$2U.default.bool])), _propTypes$2U.default.func, _propTypes$2U.default.object])
} : void 0;
Container$4.default = Container$3;

var containerClasses$3 = {};

var _interopRequireDefault$8R = interopRequireDefault$1.exports;
Object.defineProperty(containerClasses$3, "__esModule", {
  value: true
});
containerClasses$3.default = void 0;
containerClasses$3.getContainerUtilityClass = getContainerUtilityClass$1;
var _generateUtilityClasses$1V = _interopRequireDefault$8R(generateUtilityClasses$3);
var _generateUtilityClass$1W = _interopRequireDefault$8R(generateUtilityClass$3);
function getContainerUtilityClass$1(slot) {
  return (0, _generateUtilityClass$1W.default)('MuiContainer', slot);
}
const containerClasses$2 = (0, _generateUtilityClasses$1V.default)('MuiContainer', ['root', 'disableGutters', 'fixed', 'maxWidthXs', 'maxWidthSm', 'maxWidthMd', 'maxWidthLg', 'maxWidthXl']);
containerClasses$3.default = containerClasses$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  containerClasses: true
};
Object.defineProperty(exports, "containerClasses", {
  enumerable: true,
  get: function () {
    return _containerClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Container.default;
  }
});
var _Container = _interopRequireDefault(Container$4);
var _containerClasses = _interopRequireWildcard(containerClasses$3);
Object.keys(_containerClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _containerClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _containerClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Container$5));

var Grid$4 = {};

var createGrid$1 = {};

var gridGenerator = {};

var traverseBreakpoints$1 = {};

Object.defineProperty(traverseBreakpoints$1, "__esModule", {
  value: true
});
traverseBreakpoints$1.traverseBreakpoints = traverseBreakpoints$1.filterBreakpointKeys = void 0;
const filterBreakpointKeys = (breakpointsKeys, responsiveKeys) => breakpointsKeys.filter(key => responsiveKeys.includes(key));
traverseBreakpoints$1.filterBreakpointKeys = filterBreakpointKeys;
const traverseBreakpoints = (breakpoints, responsive, iterator) => {
  const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.

  if (Array.isArray(responsive)) {
    responsive.forEach((breakpointValue, index) => {
      iterator((responsiveStyles, style) => {
        if (index <= breakpoints.keys.length - 1) {
          if (index === 0) {
            Object.assign(responsiveStyles, style);
          } else {
            responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
          }
        }
      }, breakpointValue);
    });
  } else if (responsive && typeof responsive === 'object') {
    // prevent null
    // responsive could be a very big object, pick the smallest responsive values

    const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
    keys.forEach(key => {
      if (breakpoints.keys.indexOf(key) !== -1) {
        // @ts-ignore already checked that responsive is an object
        const breakpointValue = responsive[key];
        if (breakpointValue !== undefined) {
          iterator((responsiveStyles, style) => {
            if (smallestBreakpoint === key) {
              Object.assign(responsiveStyles, style);
            } else {
              responsiveStyles[breakpoints.up(key)] = style;
            }
          }, breakpointValue);
        }
      }
    });
  } else if (typeof responsive === 'number' || typeof responsive === 'string') {
    iterator((responsiveStyles, style) => {
      Object.assign(responsiveStyles, style);
    }, responsive);
  }
};
traverseBreakpoints$1.traverseBreakpoints = traverseBreakpoints;

var _interopRequireDefault$8Q = interopRequireDefault$1.exports;
Object.defineProperty(gridGenerator, "__esModule", {
  value: true
});
gridGenerator.generateSpacingClassNames = gridGenerator.generateSizeClassNames = gridGenerator.generateGridStyles = gridGenerator.generateGridSizeStyles = gridGenerator.generateGridRowSpacingStyles = gridGenerator.generateGridOffsetStyles = gridGenerator.generateGridDirectionStyles = gridGenerator.generateGridColumnsStyles = gridGenerator.generateGridColumnSpacingStyles = gridGenerator.generateDirectionClasses = void 0;
var _extends2$2p = _interopRequireDefault$8Q(_extends$19.exports);
var _traverseBreakpoints = traverseBreakpoints$1;
function appendLevel(level) {
  if (!level) {
    return '';
  }
  return `Level${level}`;
}
function isNestedContainer(ownerState) {
  return ownerState.unstable_level > 0 && ownerState.container;
}
function createGetSelfSpacing(ownerState) {
  return function getSelfSpacing(axis) {
    return `var(--Grid-${axis}Spacing${appendLevel(ownerState.unstable_level)})`;
  };
}
function createGetParentSpacing(ownerState) {
  return function getParentSpacing(axis) {
    if (ownerState.unstable_level === 0) {
      return `var(--Grid-${axis}Spacing)`;
    }
    return `var(--Grid-${axis}Spacing${appendLevel(ownerState.unstable_level - 1)})`;
  };
}
function getParentColumns(ownerState) {
  if (ownerState.unstable_level === 0) {
    return `var(--Grid-columns)`;
  }
  return `var(--Grid-columns${appendLevel(ownerState.unstable_level - 1)})`;
}
const generateGridSizeStyles = ({
  theme,
  ownerState
}) => {
  const getSelfSpacing = createGetSelfSpacing(ownerState);
  const styles = {};
  (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.gridSize, (appendStyle, value) => {
    let style = {};
    if (value === true) {
      style = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
    }
    if (value === 'auto') {
      style = {
        flexBasis: 'auto',
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: 'none',
        width: 'auto'
      };
    }
    if (typeof value === 'number') {
      style = {
        flexGrow: 0,
        flexBasis: 'auto',
        width: `calc(100% * ${value} / ${getParentColumns(ownerState)}${isNestedContainer(ownerState) ? ` + ${getSelfSpacing('column')}` : ''})`
      };
    }
    appendStyle(styles, style);
  });
  return styles;
};
gridGenerator.generateGridSizeStyles = generateGridSizeStyles;
const generateGridOffsetStyles = ({
  theme,
  ownerState
}) => {
  const styles = {};
  (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.gridOffset, (appendStyle, value) => {
    let style = {};
    if (value === 'auto') {
      style = {
        marginLeft: 'auto'
      };
    }
    if (typeof value === 'number') {
      style = {
        marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / ${getParentColumns(ownerState)})`
      };
    }
    appendStyle(styles, style);
  });
  return styles;
};
gridGenerator.generateGridOffsetStyles = generateGridOffsetStyles;
const generateGridColumnsStyles = ({
  theme,
  ownerState
}) => {
  if (!ownerState.container) {
    return {};
  }
  const styles = isNestedContainer(ownerState) ? {
    [`--Grid-columns${appendLevel(ownerState.unstable_level)}`]: getParentColumns(ownerState)
  } : {
    '--Grid-columns': 12
  };
  (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value) => {
    appendStyle(styles, {
      [`--Grid-columns${appendLevel(ownerState.unstable_level)}`]: value
    });
  });
  return styles;
};
gridGenerator.generateGridColumnsStyles = generateGridColumnsStyles;
const generateGridRowSpacingStyles = ({
  theme,
  ownerState
}) => {
  if (!ownerState.container) {
    return {};
  }
  const getParentSpacing = createGetParentSpacing(ownerState);
  const styles = isNestedContainer(ownerState) ? {
    // Set the default spacing as its parent spacing.
    // It will be overridden if spacing props are provided
    [`--Grid-rowSpacing${appendLevel(ownerState.unstable_level)}`]: getParentSpacing('row')
  } : {};
  (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value) => {
    var _theme$spacing;
    appendStyle(styles, {
      [`--Grid-rowSpacing${appendLevel(ownerState.unstable_level)}`]: typeof value === 'string' ? value : (_theme$spacing = theme.spacing) == null ? void 0 : _theme$spacing.call(theme, value)
    });
  });
  return styles;
};
gridGenerator.generateGridRowSpacingStyles = generateGridRowSpacingStyles;
const generateGridColumnSpacingStyles = ({
  theme,
  ownerState
}) => {
  if (!ownerState.container) {
    return {};
  }
  const getParentSpacing = createGetParentSpacing(ownerState);
  const styles = isNestedContainer(ownerState) ? {
    // Set the default spacing as its parent spacing.
    // It will be overridden if spacing props are provided
    [`--Grid-columnSpacing${appendLevel(ownerState.unstable_level)}`]: getParentSpacing('column')
  } : {};
  (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value) => {
    var _theme$spacing2;
    appendStyle(styles, {
      [`--Grid-columnSpacing${appendLevel(ownerState.unstable_level)}`]: typeof value === 'string' ? value : (_theme$spacing2 = theme.spacing) == null ? void 0 : _theme$spacing2.call(theme, value)
    });
  });
  return styles;
};
gridGenerator.generateGridColumnSpacingStyles = generateGridColumnSpacingStyles;
const generateGridDirectionStyles = ({
  theme,
  ownerState
}) => {
  if (!ownerState.container) {
    return {};
  }
  const styles = {};
  (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value) => {
    appendStyle(styles, {
      flexDirection: value
    });
  });
  return styles;
};
gridGenerator.generateGridDirectionStyles = generateGridDirectionStyles;
const generateGridStyles = ({
  ownerState
}) => {
  const getSelfSpacing = createGetSelfSpacing(ownerState);
  const getParentSpacing = createGetParentSpacing(ownerState);
  return (0, _extends2$2p.default)({
    minWidth: 0,
    boxSizing: 'border-box'
  }, ownerState.container && (0, _extends2$2p.default)({
    display: 'flex',
    flexWrap: 'wrap'
  }, ownerState.wrap && ownerState.wrap !== 'wrap' && {
    flexWrap: ownerState.wrap
  }, {
    margin: `calc(${getSelfSpacing('row')} / -2) calc(${getSelfSpacing('column')} / -2)`
  }, ownerState.disableEqualOverflow && {
    margin: `calc(${getSelfSpacing('row')} * -1) 0px 0px calc(${getSelfSpacing('column')} * -1)`
  }), (!ownerState.container || isNestedContainer(ownerState)) && (0, _extends2$2p.default)({
    padding: `calc(${getParentSpacing('row')} / 2) calc(${getParentSpacing('column')} / 2)`
  }, (ownerState.disableEqualOverflow || ownerState.parentDisableEqualOverflow) && {
    padding: `${getParentSpacing('row')} 0px 0px ${getParentSpacing('column')}`
  }));
};
gridGenerator.generateGridStyles = generateGridStyles;
const generateSizeClassNames = gridSize => {
  const classNames = [];
  Object.entries(gridSize).forEach(([key, value]) => {
    if (value !== false && value !== undefined) {
      classNames.push(`grid-${key}-${String(value)}`);
    }
  });
  return classNames;
};
gridGenerator.generateSizeClassNames = generateSizeClassNames;
const generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs') => {
  function isValidSpacing(val) {
    if (val === undefined) {
      return false;
    }
    return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
  }
  if (isValidSpacing(spacing)) {
    return [`spacing-${smallestBreakpoint}-${String(spacing)}`];
  }
  if (typeof spacing === 'object' && !Array.isArray(spacing)) {
    const classNames = [];
    Object.entries(spacing).forEach(([key, value]) => {
      if (isValidSpacing(value)) {
        classNames.push(`spacing-${key}-${String(value)}`);
      }
    });
    return classNames;
  }
  return [];
};
gridGenerator.generateSpacingClassNames = generateSpacingClassNames;
const generateDirectionClasses = direction => {
  if (direction === undefined) {
    return [];
  }
  if (typeof direction === 'object') {
    return Object.entries(direction).map(([key, value]) => `direction-${key}-${value}`);
  }
  return [`direction-xs-${String(direction)}`];
};
gridGenerator.generateDirectionClasses = generateDirectionClasses;

var _interopRequireDefault$8P = interopRequireDefault$1.exports;
Object.defineProperty(createGrid$1, "__esModule", {
  value: true
});
createGrid$1.default = createGrid;
var _extends2$2o = _interopRequireDefault$8P(_extends$19.exports);
var _objectWithoutPropertiesLoose2$2a = _interopRequireDefault$8P(objectWithoutPropertiesLoose.exports);
var React$2I = _interopRequireWildcard$45(React__default$4);
var _propTypes$2T = _interopRequireDefault$8P(propTypes.exports);
var _clsx$2o = _interopRequireDefault$8P(clsx.exports);
var _isMuiElement$6 = _interopRequireDefault$8P(isMuiElement$3);
var _generateUtilityClass$1V = _interopRequireDefault$8P(generateUtilityClass$3);
var _composeClasses$1P = _interopRequireDefault$8P(composeClasses$2);
var _styled$1I = _interopRequireDefault$8P(styled$1);
var _useThemeProps$2 = _interopRequireDefault$8P(useThemeProps$3);
var _useTheme$f = _interopRequireDefault$8P(useTheme$8);
var _styleFunctionSx$5 = styleFunctionSx;
var _createTheme$3 = _interopRequireDefault$8P(createTheme$4);
var _gridGenerator = gridGenerator;
var _jsxRuntime$2J = require$$11;
const _excluded$2E = ["className", "children", "columns", "container", "component", "direction", "wrap", "spacing", "rowSpacing", "columnSpacing", "disableEqualOverflow", "unstable_level"];
function _getRequireWildcardCache$3Q(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3Q = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$45(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3Q(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultTheme$4 = (0, _createTheme$3.default)();

// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent$1 = (0, _styled$1I.default)('div', {
  name: 'MuiGrid',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
});
function useThemePropsDefault$1(props) {
  return (0, _useThemeProps$2.default)({
    props,
    name: 'MuiGrid',
    defaultTheme: defaultTheme$4
  });
}
function createGrid(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent$1,
    useThemeProps = useThemePropsDefault$1,
    componentName = 'MuiGrid'
  } = options;
  const GridOverflowContext = /*#__PURE__*/React$2I.createContext(undefined);
  if (process.env.NODE_ENV !== 'production') {
    GridOverflowContext.displayName = 'GridOverflowContext';
  }
  const useUtilityClasses = (ownerState, theme) => {
    const {
      container,
      direction,
      spacing,
      wrap,
      gridSize
    } = ownerState;
    const slots = {
      root: ['root', container && 'container', wrap !== 'wrap' && `wrap-xs-${String(wrap)}`, ...(0, _gridGenerator.generateDirectionClasses)(direction), ...(0, _gridGenerator.generateSizeClassNames)(gridSize), ...(container ? (0, _gridGenerator.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : [])]
    };
    return (0, _composeClasses$1P.default)(slots, slot => (0, _generateUtilityClass$1V.default)(componentName, slot), {});
  };
  const GridRoot = createStyledComponent(_gridGenerator.generateGridColumnsStyles, _gridGenerator.generateGridColumnSpacingStyles, _gridGenerator.generateGridRowSpacingStyles, _gridGenerator.generateGridSizeStyles, _gridGenerator.generateGridDirectionStyles, _gridGenerator.generateGridStyles, _gridGenerator.generateGridOffsetStyles);
  const Grid = /*#__PURE__*/React$2I.forwardRef(function Grid(inProps, ref) {
    var _inProps$columns, _inProps$spacing, _ref, _inProps$rowSpacing, _ref2, _inProps$columnSpacin, _ref3, _disableEqualOverflow;
    const theme = (0, _useTheme$f.default)();
    const themeProps = useThemeProps(inProps);
    const props = (0, _styleFunctionSx$5.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
    const overflow = React$2I.useContext(GridOverflowContext);
    const {
        className,
        children,
        columns: columnsProp = 12,
        container = false,
        component = 'div',
        direction = 'row',
        wrap = 'wrap',
        spacing: spacingProp = 0,
        rowSpacing: rowSpacingProp = spacingProp,
        columnSpacing: columnSpacingProp = spacingProp,
        disableEqualOverflow: themeDisableEqualOverflow,
        unstable_level: level = 0
      } = props,
      rest = (0, _objectWithoutPropertiesLoose2$2a.default)(props, _excluded$2E);
    // Because `disableEqualOverflow` can be set from the theme's defaultProps, the **nested** grid should look at the instance props instead.
    let disableEqualOverflow = themeDisableEqualOverflow;
    if (level && themeDisableEqualOverflow !== undefined) {
      disableEqualOverflow = inProps.disableEqualOverflow;
    }
    // collect breakpoints related props because they can be customized from the theme.
    const gridSize = {};
    const gridOffset = {};
    const other = {};
    Object.entries(rest).forEach(([key, val]) => {
      if (theme.breakpoints.values[key] !== undefined) {
        gridSize[key] = val;
      } else if (theme.breakpoints.values[key.replace('Offset', '')] !== undefined) {
        gridOffset[key.replace('Offset', '')] = val;
      } else {
        other[key] = val;
      }
    });
    const columns = (_inProps$columns = inProps.columns) != null ? _inProps$columns : level ? undefined : columnsProp;
    const spacing = (_inProps$spacing = inProps.spacing) != null ? _inProps$spacing : level ? undefined : spacingProp;
    const rowSpacing = (_ref = (_inProps$rowSpacing = inProps.rowSpacing) != null ? _inProps$rowSpacing : inProps.spacing) != null ? _ref : level ? undefined : rowSpacingProp;
    const columnSpacing = (_ref2 = (_inProps$columnSpacin = inProps.columnSpacing) != null ? _inProps$columnSpacin : inProps.spacing) != null ? _ref2 : level ? undefined : columnSpacingProp;
    const ownerState = (0, _extends2$2o.default)({}, props, {
      level,
      columns,
      container,
      direction,
      wrap,
      spacing,
      rowSpacing,
      columnSpacing,
      gridSize,
      gridOffset,
      disableEqualOverflow: (_ref3 = (_disableEqualOverflow = disableEqualOverflow) != null ? _disableEqualOverflow : overflow) != null ? _ref3 : false,
      // use context value if exists.
      parentDisableEqualOverflow: overflow // for nested grid
    });
    const classes = useUtilityClasses(ownerState, theme);
    let result = /*#__PURE__*/(0, _jsxRuntime$2J.jsx)(GridRoot, (0, _extends2$2o.default)({
      ref: ref,
      as: component,
      ownerState: ownerState,
      className: (0, _clsx$2o.default)(classes.root, className)
    }, other, {
      children: React$2I.Children.map(children, child => {
        if ( /*#__PURE__*/React$2I.isValidElement(child) && (0, _isMuiElement$6.default)(child, ['Grid'])) {
          var _unstable_level, _child$props;
          return /*#__PURE__*/React$2I.cloneElement(child, {
            unstable_level: (_unstable_level = (_child$props = child.props) == null ? void 0 : _child$props.unstable_level) != null ? _unstable_level : level + 1
          });
        }
        return child;
      })
    }));
    if (disableEqualOverflow !== undefined && disableEqualOverflow !== (overflow != null ? overflow : false)) {
      // There are 2 possibilities that should wrap with the GridOverflowContext to communicate with the nested grids:
      // 1. It is the root grid with `disableEqualOverflow`.
      // 2. It is a nested grid with different `disableEqualOverflow` from the context.
      result = /*#__PURE__*/(0, _jsxRuntime$2J.jsx)(GridOverflowContext.Provider, {
        value: disableEqualOverflow,
        children: result
      });
    }
    return result;
  });
  process.env.NODE_ENV !== "production" ? Grid.propTypes /* remove-proptypes */ = {
    children: _propTypes$2T.default.node,
    className: _propTypes$2T.default.string,
    columns: _propTypes$2T.default.oneOfType([_propTypes$2T.default.arrayOf(_propTypes$2T.default.number), _propTypes$2T.default.number, _propTypes$2T.default.object]),
    columnSpacing: _propTypes$2T.default.oneOfType([_propTypes$2T.default.arrayOf(_propTypes$2T.default.oneOfType([_propTypes$2T.default.number, _propTypes$2T.default.string])), _propTypes$2T.default.number, _propTypes$2T.default.object, _propTypes$2T.default.string]),
    component: _propTypes$2T.default.elementType,
    container: _propTypes$2T.default.bool,
    direction: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), _propTypes$2T.default.arrayOf(_propTypes$2T.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), _propTypes$2T.default.object]),
    disableEqualOverflow: _propTypes$2T.default.bool,
    lg: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number, _propTypes$2T.default.bool]),
    lgOffset: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number]),
    md: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number, _propTypes$2T.default.bool]),
    mdOffset: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number]),
    rowSpacing: _propTypes$2T.default.oneOfType([_propTypes$2T.default.arrayOf(_propTypes$2T.default.oneOfType([_propTypes$2T.default.number, _propTypes$2T.default.string])), _propTypes$2T.default.number, _propTypes$2T.default.object, _propTypes$2T.default.string]),
    sm: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number, _propTypes$2T.default.bool]),
    smOffset: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number]),
    spacing: _propTypes$2T.default.oneOfType([_propTypes$2T.default.arrayOf(_propTypes$2T.default.oneOfType([_propTypes$2T.default.number, _propTypes$2T.default.string])), _propTypes$2T.default.number, _propTypes$2T.default.object, _propTypes$2T.default.string]),
    sx: _propTypes$2T.default.oneOfType([_propTypes$2T.default.arrayOf(_propTypes$2T.default.oneOfType([_propTypes$2T.default.func, _propTypes$2T.default.object, _propTypes$2T.default.bool])), _propTypes$2T.default.func, _propTypes$2T.default.object]),
    wrap: _propTypes$2T.default.oneOf(['nowrap', 'wrap-reverse', 'wrap']),
    xl: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number, _propTypes$2T.default.bool]),
    xlOffset: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number]),
    xs: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number, _propTypes$2T.default.bool]),
    xsOffset: _propTypes$2T.default.oneOfType([_propTypes$2T.default.oneOf(['auto']), _propTypes$2T.default.number])
  } : void 0;

  // @ts-ignore internal logic for nested grid
  Grid.muiName = 'Grid';
  return Grid;
}

var _interopRequireDefault$8O = interopRequireDefault$1.exports;
Object.defineProperty(Grid$4, "__esModule", {
  value: true
});
Grid$4.default = void 0;
var _propTypes$2S = _interopRequireDefault$8O(propTypes.exports);
var _createGrid = _interopRequireDefault$8O(createGrid$1);
/**
 *
 * Demos:
 *
 * - [Grid (Joy UI)](https://mui.com/joy-ui/react-grid/)
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */
const Grid$3 = (0, _createGrid.default)();
process.env.NODE_ENV !== "production" ? Grid$3.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2S.default.node,
  /**
   * The number of columns.
   * @default 12
   */
  columns: _propTypes$2S.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2S.default.arrayOf(_propTypes$2S.default.number), _propTypes$2S.default.number, _propTypes$2S.default.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: _propTypes$2S.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2S.default.arrayOf(_propTypes$2S.default.oneOfType([_propTypes$2S.default.number, _propTypes$2S.default.string])), _propTypes$2S.default.number, _propTypes$2S.default.object, _propTypes$2S.default.string]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: _propTypes$2S.default.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: _propTypes$2S.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2S.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), _propTypes$2S.default.arrayOf(_propTypes$2S.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), _propTypes$2S.default.object]),
  /**
   * If `true`, the negative margin and padding are apply only to the top and left sides of the grid.
   */
  disableEqualOverflow: _propTypes$2S.default.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number, _propTypes$2S.default.bool]),
  /**
   * If a number, it sets the margin-left equals to the number of columns the grid item uses.
   * If 'auto', the grid item push itself to the right-end of the container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lgOffset: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number, _propTypes$2S.default.bool]),
  /**
   * If a number, it sets the margin-left equals to the number of columns the grid item uses.
   * If 'auto', the grid item push itself to the right-end of the container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   */
  mdOffset: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: _propTypes$2S.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2S.default.arrayOf(_propTypes$2S.default.oneOfType([_propTypes$2S.default.number, _propTypes$2S.default.string])), _propTypes$2S.default.number, _propTypes$2S.default.object, _propTypes$2S.default.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number, _propTypes$2S.default.bool]),
  /**
   * If a number, it sets the margin-left equals to the number of columns the grid item uses.
   * If 'auto', the grid item push itself to the right-end of the container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   */
  smOffset: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: _propTypes$2S.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2S.default.arrayOf(_propTypes$2S.default.oneOfType([_propTypes$2S.default.number, _propTypes$2S.default.string])), _propTypes$2S.default.number, _propTypes$2S.default.object, _propTypes$2S.default.string]),
  /**
   * @ignore
   */
  sx: _propTypes$2S.default.oneOfType([_propTypes$2S.default.arrayOf(_propTypes$2S.default.oneOfType([_propTypes$2S.default.func, _propTypes$2S.default.object, _propTypes$2S.default.bool])), _propTypes$2S.default.func, _propTypes$2S.default.object]),
  /**
   * @internal
   * The level of the grid starts from `0`
   * and increases when the grid nests inside another grid regardless of container or item.
   *
   * ```js
   * <Grid> // level 0
   *   <Grid> // level 1
   *     <Grid> // level 2
   *   <Grid> // level 1
   * ```
   *
   * Only consecutive grid is considered nesting.
   * A grid container will start at `0` if there are non-Grid element above it.
   *
   * ```js
   * <Grid> // level 0
   *   <div>
   *     <Grid> // level 0
   *       <Grid> // level 1
   * ```
   */
  unstable_level: _propTypes$2S.default.number,
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: _propTypes$2S.default.oneOf(['nowrap', 'wrap-reverse', 'wrap']),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number, _propTypes$2S.default.bool]),
  /**
   * If a number, it sets the margin-left equals to the number of columns the grid item uses.
   * If 'auto', the grid item push itself to the right-end of the container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   */
  xlOffset: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number, _propTypes$2S.default.bool]),
  /**
   * If a number, it sets the margin-left equals to the number of columns the grid item uses.
   * If 'auto', the grid item push itself to the right-end of the container.
   * The value is applied for the `xs` breakpoint and wider screens if not overridden.
   */
  xsOffset: _propTypes$2S.default.oneOfType([_propTypes$2S.default.oneOf(['auto']), _propTypes$2S.default.number])
} : void 0;
Grid$4.default = Grid$3;

var Unstable_Grid = {};

var GridProps = {};

Object.defineProperty(GridProps, "__esModule", {
  value: true
});

var gridClasses$3 = {};

var _interopRequireDefault$8N = interopRequireDefault$1.exports;
Object.defineProperty(gridClasses$3, "__esModule", {
  value: true
});
gridClasses$3.default = void 0;
gridClasses$3.getGridUtilityClass = getGridUtilityClass$1;
var _generateUtilityClasses$1U = _interopRequireDefault$8N(generateUtilityClasses$3);
var _generateUtilityClass$1U = _interopRequireDefault$8N(generateUtilityClass$3);
function getGridUtilityClass$1(slot) {
  return (0, _generateUtilityClass$1U.default)('MuiGrid', slot);
}
const SPACINGS$3 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const DIRECTIONS$2 = ['column-reverse', 'column', 'row-reverse', 'row'];
const WRAPS$2 = ['nowrap', 'wrap-reverse', 'wrap'];
const GRID_SIZES$2 = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const gridClasses$2 = (0, _generateUtilityClasses$1U.default)('MuiGrid', ['root', 'container', 'item',
// spacings
...SPACINGS$3.map(spacing => `spacing-xs-${spacing}`),
// direction values
...DIRECTIONS$2.map(direction => `direction-xs-${direction}`),
// wrap values
...WRAPS$2.map(wrap => `wrap-xs-${wrap}`),
// grid sizes for all breakpoints
...GRID_SIZES$2.map(size => `grid-xs-${size}`), ...GRID_SIZES$2.map(size => `grid-sm-${size}`), ...GRID_SIZES$2.map(size => `grid-md-${size}`), ...GRID_SIZES$2.map(size => `grid-lg-${size}`), ...GRID_SIZES$2.map(size => `grid-xl-${size}`)]);
gridClasses$3.default = gridClasses$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createGrid: true,
  gridClasses: true,
  unstable_traverseBreakpoints: true
};
Object.defineProperty(exports, "createGrid", {
  enumerable: true,
  get: function () {
    return _createGrid.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Grid.default;
  }
});
Object.defineProperty(exports, "gridClasses", {
  enumerable: true,
  get: function () {
    return _gridClasses.default;
  }
});
Object.defineProperty(exports, "unstable_traverseBreakpoints", {
  enumerable: true,
  get: function () {
    return _traverseBreakpoints.traverseBreakpoints;
  }
});
var _Grid = _interopRequireDefault(Grid$4);
var _createGrid = _interopRequireDefault(createGrid$1);
var _GridProps = GridProps;
Object.keys(_GridProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _GridProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GridProps[key];
    }
  });
});
var _gridClasses = _interopRequireWildcard(gridClasses$3);
Object.keys(_gridClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _gridClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _gridClasses[key];
    }
  });
});
var _traverseBreakpoints = traverseBreakpoints$1;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Unstable_Grid));

var Stack$a = {};

var createStack$1 = {};

var _interopRequireDefault$8M = interopRequireDefault$1.exports;
Object.defineProperty(createStack$1, "__esModule", {
  value: true
});
createStack$1.default = createStack;
createStack$1.style = void 0;
var _objectWithoutPropertiesLoose2$29 = _interopRequireDefault$8M(objectWithoutPropertiesLoose.exports);
var _extends2$2n = _interopRequireDefault$8M(_extends$19.exports);
var React$2H = _interopRequireWildcard$44(React__default$4);
var _propTypes$2R = _interopRequireDefault$8M(propTypes.exports);
var _clsx$2n = _interopRequireDefault$8M(clsx.exports);
var _deepmerge$5 = _interopRequireDefault$8M(deepmerge$2);
var _generateUtilityClass$1T = _interopRequireDefault$8M(generateUtilityClass$3);
var _composeClasses$1O = _interopRequireDefault$8M(composeClasses$2);
var _styled$1H = _interopRequireDefault$8M(styled$1);
var _useThemeProps$1 = _interopRequireDefault$8M(useThemeProps$3);
var _styleFunctionSx$4 = styleFunctionSx;
var _createTheme$2 = _interopRequireDefault$8M(createTheme$4);
var _breakpoints = breakpoints$1;
var _spacing = spacing$1;
var _jsxRuntime$2I = require$$11;
const _excluded$2D = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"];
function _getRequireWildcardCache$3P(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3P = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$44(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3P(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultTheme$3 = (0, _createTheme$2.default)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0, _styled$1H.default)('div', {
  name: 'MuiStack',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
});
function useThemePropsDefault(props) {
  return (0, _useThemeProps$1.default)({
    props,
    name: 'MuiStack',
    defaultTheme: defaultTheme$3
  });
}

/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */
function joinChildren(children, separator) {
  const childrenArray = React$2H.Children.toArray(children).filter(Boolean);
  return childrenArray.reduce((output, child, index) => {
    output.push(child);
    if (index < childrenArray.length - 1) {
      output.push( /*#__PURE__*/React$2H.cloneElement(separator, {
        key: `separator-${index}`
      }));
    }
    return output;
  }, []);
}
const getSideFromDirection = direction => {
  return {
    row: 'Left',
    'row-reverse': 'Right',
    column: 'Top',
    'column-reverse': 'Bottom'
  }[direction];
};
const style$$ = ({
  ownerState,
  theme
}) => {
  let styles = (0, _extends2$2n.default)({
    display: 'flex',
    flexDirection: 'column'
  }, (0, _breakpoints.handleBreakpoints)({
    theme
  }, (0, _breakpoints.resolveBreakpointValues)({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  }), propValue => ({
    flexDirection: propValue
  })));
  if (ownerState.spacing) {
    const transformer = (0, _spacing.createUnarySpacing)(theme);
    const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint) => {
      if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) {
        acc[breakpoint] = true;
      }
      return acc;
    }, {});
    const directionValues = (0, _breakpoints.resolveBreakpointValues)({
      values: ownerState.direction,
      base
    });
    const spacingValues = (0, _breakpoints.resolveBreakpointValues)({
      values: ownerState.spacing,
      base
    });
    if (typeof directionValues === 'object') {
      Object.keys(directionValues).forEach((breakpoint, index, breakpoints) => {
        const directionValue = directionValues[breakpoint];
        if (!directionValue) {
          const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
          directionValues[breakpoint] = previousDirectionValue;
        }
      });
    }
    const styleFromPropValue = (propValue, breakpoint) => {
      if (ownerState.useFlexGap) {
        return {
          gap: (0, _spacing.getValue)(transformer, propValue)
        };
      }
      return {
        // The useFlexGap={false} implement relies on each child to give up control of the margin.
        // We need to reset the margin to avoid double spacing.
        '& > :not(style):not(style)': {
          margin: 0
        },
        '& > :not(style) ~ :not(style)': {
          [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, _spacing.getValue)(transformer, propValue)
        }
      };
    };
    styles = (0, _deepmerge$5.default)(styles, (0, _breakpoints.handleBreakpoints)({
      theme
    }, spacingValues, styleFromPropValue));
  }
  styles = (0, _breakpoints.mergeBreakpointsInOrder)(theme.breakpoints, styles);
  return styles;
};
createStack$1.style = style$$;
function createStack(options = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent,
    useThemeProps = useThemePropsDefault,
    componentName = 'MuiStack'
  } = options;
  const useUtilityClasses = () => {
    const slots = {
      root: ['root']
    };
    return (0, _composeClasses$1O.default)(slots, slot => (0, _generateUtilityClass$1T.default)(componentName, slot), {});
  };
  const StackRoot = createStyledComponent(style$$);
  const Stack = /*#__PURE__*/React$2H.forwardRef(function Grid(inProps, ref) {
    const themeProps = useThemeProps(inProps);
    const props = (0, _styleFunctionSx$4.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
    const {
        component = 'div',
        direction = 'column',
        spacing = 0,
        divider,
        children,
        className,
        useFlexGap = false
      } = props,
      other = (0, _objectWithoutPropertiesLoose2$29.default)(props, _excluded$2D);
    const ownerState = {
      direction,
      spacing,
      useFlexGap
    };
    const classes = useUtilityClasses();
    return /*#__PURE__*/(0, _jsxRuntime$2I.jsx)(StackRoot, (0, _extends2$2n.default)({
      as: component,
      ownerState: ownerState,
      ref: ref,
      className: (0, _clsx$2n.default)(classes.root, className)
    }, other, {
      children: divider ? joinChildren(children, divider) : children
    }));
  });
  process.env.NODE_ENV !== "production" ? Stack.propTypes /* remove-proptypes */ = {
    children: _propTypes$2R.default.node,
    direction: _propTypes$2R.default.oneOfType([_propTypes$2R.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), _propTypes$2R.default.arrayOf(_propTypes$2R.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), _propTypes$2R.default.object]),
    divider: _propTypes$2R.default.node,
    spacing: _propTypes$2R.default.oneOfType([_propTypes$2R.default.arrayOf(_propTypes$2R.default.oneOfType([_propTypes$2R.default.number, _propTypes$2R.default.string])), _propTypes$2R.default.number, _propTypes$2R.default.object, _propTypes$2R.default.string]),
    sx: _propTypes$2R.default.oneOfType([_propTypes$2R.default.arrayOf(_propTypes$2R.default.oneOfType([_propTypes$2R.default.func, _propTypes$2R.default.object, _propTypes$2R.default.bool])), _propTypes$2R.default.func, _propTypes$2R.default.object])
  } : void 0;
  return Stack;
}

var _interopRequireDefault$8L = interopRequireDefault$1.exports;
Object.defineProperty(Stack$a, "__esModule", {
  value: true
});
Stack$a.default = void 0;
var _propTypes$2Q = _interopRequireDefault$8L(propTypes.exports);
var _createStack = _interopRequireDefault$8L(createStack$1);
/**
 *
 * Demos:
 *
 * - [Stack (Joy UI)](https://mui.com/joy-ui/react-stack/)
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */
const Stack$9 = (0, _createStack.default)();
process.env.NODE_ENV !== "production" ? Stack$9.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2Q.default.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2Q.default.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: _propTypes$2Q.default.oneOfType([_propTypes$2Q.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), _propTypes$2Q.default.arrayOf(_propTypes$2Q.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), _propTypes$2Q.default.object]),
  /**
   * Add an element between each child.
   */
  divider: _propTypes$2Q.default.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: _propTypes$2Q.default.oneOfType([_propTypes$2Q.default.arrayOf(_propTypes$2Q.default.oneOfType([_propTypes$2Q.default.number, _propTypes$2Q.default.string])), _propTypes$2Q.default.number, _propTypes$2Q.default.object, _propTypes$2Q.default.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2Q.default.oneOfType([_propTypes$2Q.default.arrayOf(_propTypes$2Q.default.oneOfType([_propTypes$2Q.default.func, _propTypes$2Q.default.object, _propTypes$2Q.default.bool])), _propTypes$2Q.default.func, _propTypes$2Q.default.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the theme's default props configuration.
   * @default false
   */
  useFlexGap: _propTypes$2Q.default.bool
} : void 0;
Stack$a.default = Stack$9;

var Stack$8 = {};

var StackProps = {};

Object.defineProperty(StackProps, "__esModule", {
  value: true
});

var stackClasses$3 = {};

var _interopRequireDefault$8K = interopRequireDefault$1.exports;
Object.defineProperty(stackClasses$3, "__esModule", {
  value: true
});
stackClasses$3.default = void 0;
stackClasses$3.getStackUtilityClass = getStackUtilityClass$1;
var _generateUtilityClasses$1T = _interopRequireDefault$8K(generateUtilityClasses$3);
var _generateUtilityClass$1S = _interopRequireDefault$8K(generateUtilityClass$3);
function getStackUtilityClass$1(slot) {
  return (0, _generateUtilityClass$1S.default)('MuiStack', slot);
}
const stackClasses$2 = (0, _generateUtilityClasses$1T.default)('MuiStack', ['root']);
stackClasses$3.default = stackClasses$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createStack: true,
  stackClasses: true
};
Object.defineProperty(exports, "createStack", {
  enumerable: true,
  get: function () {
    return _createStack.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Stack.default;
  }
});
Object.defineProperty(exports, "stackClasses", {
  enumerable: true,
  get: function () {
    return _stackClasses.default;
  }
});
var _Stack = _interopRequireDefault(Stack$a);
var _createStack = _interopRequireDefault(createStack$1);
var _StackProps = StackProps;
Object.keys(_StackProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StackProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StackProps[key];
    }
  });
});
var _stackClasses = _interopRequireWildcard(stackClasses$3);
Object.keys(_stackClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _stackClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _stackClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Stack$8));

/**
 * @mui/system v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  experimental_sx: true,
  css: true,
  keyframes: true,
  StyledEngineProvider: true,
  GlobalStyles: true,
  borders: true,
  breakpoints: true,
  handleBreakpoints: true,
  mergeBreakpointsInOrder: true,
  unstable_resolveBreakpointValues: true,
  compose: true,
  display: true,
  flexbox: true,
  grid: true,
  palette: true,
  positions: true,
  shadows: true,
  sizing: true,
  spacing: true,
  style: true,
  getPath: true,
  getStyleValue: true,
  typography: true,
  unstable_styleFunctionSx: true,
  unstable_createStyleFunctionSx: true,
  unstable_extendSxProp: true,
  unstable_defaultSxConfig: true,
  unstable_getThemeValue: true,
  Box: true,
  createBox: true,
  createStyled: true,
  styled: true,
  createTheme: true,
  createBreakpoints: true,
  createSpacing: true,
  shape: true,
  useThemeProps: true,
  getThemeProps: true,
  useTheme: true,
  useThemeWithoutDefault: true,
  useMediaQuery: true,
  ThemeProvider: true,
  unstable_createCssVarsProvider: true,
  unstable_createGetCssVar: true,
  unstable_cssVarsParser: true,
  unstable_prepareCssVars: true,
  unstable_createCssVarsTheme: true,
  responsivePropType: true,
  RtlProvider: true,
  createContainer: true,
  Container: true,
  Unstable_Grid: true,
  Stack: true
};
Object.defineProperty(exports, "Box", {
  enumerable: true,
  get: function () {
    return _Box.default;
  }
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function () {
    return _Container.default;
  }
});
Object.defineProperty(exports, "GlobalStyles", {
  enumerable: true,
  get: function () {
    return _GlobalStyles.default;
  }
});
Object.defineProperty(exports, "RtlProvider", {
  enumerable: true,
  get: function () {
    return _RtlProvider.default;
  }
});
Object.defineProperty(exports, "Stack", {
  enumerable: true,
  get: function () {
    return _Stack.default;
  }
});
Object.defineProperty(exports, "StyledEngineProvider", {
  enumerable: true,
  get: function () {
    return _styledEngine.StyledEngineProvider;
  }
});
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function () {
    return _ThemeProvider.default;
  }
});
Object.defineProperty(exports, "Unstable_Grid", {
  enumerable: true,
  get: function () {
    return _Grid.default;
  }
});
Object.defineProperty(exports, "borders", {
  enumerable: true,
  get: function () {
    return _borders.default;
  }
});
Object.defineProperty(exports, "breakpoints", {
  enumerable: true,
  get: function () {
    return _breakpoints.default;
  }
});
Object.defineProperty(exports, "compose", {
  enumerable: true,
  get: function () {
    return _compose.default;
  }
});
Object.defineProperty(exports, "createBox", {
  enumerable: true,
  get: function () {
    return _createBox.default;
  }
});
Object.defineProperty(exports, "createBreakpoints", {
  enumerable: true,
  get: function () {
    return _createBreakpoints.default;
  }
});
Object.defineProperty(exports, "createContainer", {
  enumerable: true,
  get: function () {
    return _createContainer.default;
  }
});
Object.defineProperty(exports, "createSpacing", {
  enumerable: true,
  get: function () {
    return _createSpacing.default;
  }
});
Object.defineProperty(exports, "createStyled", {
  enumerable: true,
  get: function () {
    return _createStyled.default;
  }
});
Object.defineProperty(exports, "createTheme", {
  enumerable: true,
  get: function () {
    return _createTheme.default;
  }
});
Object.defineProperty(exports, "css", {
  enumerable: true,
  get: function () {
    return _styledEngine.css;
  }
});
Object.defineProperty(exports, "display", {
  enumerable: true,
  get: function () {
    return _display.default;
  }
});
exports.experimental_sx = experimental_sx;
Object.defineProperty(exports, "flexbox", {
  enumerable: true,
  get: function () {
    return _flexbox.default;
  }
});
Object.defineProperty(exports, "getPath", {
  enumerable: true,
  get: function () {
    return _style.getPath;
  }
});
Object.defineProperty(exports, "getStyleValue", {
  enumerable: true,
  get: function () {
    return _style.getStyleValue;
  }
});
Object.defineProperty(exports, "getThemeProps", {
  enumerable: true,
  get: function () {
    return _useThemeProps.getThemeProps;
  }
});
Object.defineProperty(exports, "grid", {
  enumerable: true,
  get: function () {
    return _cssGrid.default;
  }
});
Object.defineProperty(exports, "handleBreakpoints", {
  enumerable: true,
  get: function () {
    return _breakpoints.handleBreakpoints;
  }
});
Object.defineProperty(exports, "keyframes", {
  enumerable: true,
  get: function () {
    return _styledEngine.keyframes;
  }
});
Object.defineProperty(exports, "mergeBreakpointsInOrder", {
  enumerable: true,
  get: function () {
    return _breakpoints.mergeBreakpointsInOrder;
  }
});
Object.defineProperty(exports, "palette", {
  enumerable: true,
  get: function () {
    return _palette.default;
  }
});
Object.defineProperty(exports, "positions", {
  enumerable: true,
  get: function () {
    return _positions.default;
  }
});
Object.defineProperty(exports, "responsivePropType", {
  enumerable: true,
  get: function () {
    return _responsivePropType.default;
  }
});
Object.defineProperty(exports, "shadows", {
  enumerable: true,
  get: function () {
    return _shadows.default;
  }
});
Object.defineProperty(exports, "shape", {
  enumerable: true,
  get: function () {
    return _shape.default;
  }
});
Object.defineProperty(exports, "sizing", {
  enumerable: true,
  get: function () {
    return _sizing.default;
  }
});
Object.defineProperty(exports, "spacing", {
  enumerable: true,
  get: function () {
    return _spacing.default;
  }
});
Object.defineProperty(exports, "style", {
  enumerable: true,
  get: function () {
    return _style.default;
  }
});
Object.defineProperty(exports, "styled", {
  enumerable: true,
  get: function () {
    return _styled.default;
  }
});
Object.defineProperty(exports, "typography", {
  enumerable: true,
  get: function () {
    return _typography.default;
  }
});
Object.defineProperty(exports, "unstable_createCssVarsProvider", {
  enumerable: true,
  get: function () {
    return _createCssVarsProvider.default;
  }
});
Object.defineProperty(exports, "unstable_createCssVarsTheme", {
  enumerable: true,
  get: function () {
    return _createCssVarsTheme.default;
  }
});
Object.defineProperty(exports, "unstable_createGetCssVar", {
  enumerable: true,
  get: function () {
    return _createGetCssVar.default;
  }
});
Object.defineProperty(exports, "unstable_createStyleFunctionSx", {
  enumerable: true,
  get: function () {
    return _styleFunctionSx.unstable_createStyleFunctionSx;
  }
});
Object.defineProperty(exports, "unstable_cssVarsParser", {
  enumerable: true,
  get: function () {
    return _cssVarsParser.default;
  }
});
Object.defineProperty(exports, "unstable_defaultSxConfig", {
  enumerable: true,
  get: function () {
    return _styleFunctionSx.unstable_defaultSxConfig;
  }
});
Object.defineProperty(exports, "unstable_extendSxProp", {
  enumerable: true,
  get: function () {
    return _styleFunctionSx.extendSxProp;
  }
});
Object.defineProperty(exports, "unstable_getThemeValue", {
  enumerable: true,
  get: function () {
    return _getThemeValue.default;
  }
});
Object.defineProperty(exports, "unstable_prepareCssVars", {
  enumerable: true,
  get: function () {
    return _prepareCssVars.default;
  }
});
Object.defineProperty(exports, "unstable_resolveBreakpointValues", {
  enumerable: true,
  get: function () {
    return _breakpoints.resolveBreakpointValues;
  }
});
Object.defineProperty(exports, "unstable_styleFunctionSx", {
  enumerable: true,
  get: function () {
    return _styleFunctionSx.default;
  }
});
Object.defineProperty(exports, "useMediaQuery", {
  enumerable: true,
  get: function () {
    return _useMediaQuery.default;
  }
});
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function () {
    return _useTheme.default;
  }
});
Object.defineProperty(exports, "useThemeProps", {
  enumerable: true,
  get: function () {
    return _useThemeProps.default;
  }
});
Object.defineProperty(exports, "useThemeWithoutDefault", {
  enumerable: true,
  get: function () {
    return _useThemeWithoutDefault.default;
  }
});
var _formatMuiErrorMessage2 = _interopRequireDefault(formatMuiErrorMessage$2);
var _styledEngine = node$3;
var _GlobalStyles = _interopRequireDefault(GlobalStyles$5);
var _borders = _interopRequireWildcard(borders$1);
Object.keys(_borders).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _borders[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _borders[key];
    }
  });
});
var _breakpoints = _interopRequireWildcard(breakpoints$1);
var _compose = _interopRequireDefault(compose$8);
var _display = _interopRequireDefault(display);
var _flexbox = _interopRequireWildcard(flexbox$1);
Object.keys(_flexbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _flexbox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _flexbox[key];
    }
  });
});
var _cssGrid = _interopRequireWildcard(cssGrid);
Object.keys(_cssGrid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _cssGrid[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cssGrid[key];
    }
  });
});
var _palette = _interopRequireWildcard(palette$1);
Object.keys(_palette).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _palette[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _palette[key];
    }
  });
});
var _positions = _interopRequireWildcard(positions);
Object.keys(_positions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _positions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _positions[key];
    }
  });
});
var _shadows = _interopRequireDefault(shadows);
var _sizing = _interopRequireWildcard(sizing$1);
Object.keys(_sizing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _sizing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sizing[key];
    }
  });
});
var _spacing = _interopRequireWildcard(spacing$1);
Object.keys(_spacing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _spacing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _spacing[key];
    }
  });
});
var _style = _interopRequireWildcard(style$12);
var _typography = _interopRequireWildcard(typography$1);
Object.keys(_typography).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _typography[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _typography[key];
    }
  });
});
var _styleFunctionSx = _interopRequireWildcard(styleFunctionSx);
var _getThemeValue = _interopRequireDefault(getThemeValue$1);
var _Box = _interopRequireDefault(Box$6);
var _createBox = _interopRequireDefault(createBox$1);
var _createStyled = _interopRequireWildcard(createStyled$1);
Object.keys(_createStyled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createStyled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createStyled[key];
    }
  });
});
var _styled = _interopRequireDefault(styled$1);
var _createTheme = _interopRequireDefault(createTheme$4);
var _createBreakpoints = _interopRequireDefault(createBreakpoints$1);
var _createSpacing = _interopRequireDefault(createSpacing$1);
var _shape = _interopRequireDefault(shape$1);
var _useThemeProps = _interopRequireWildcard(useThemeProps$3);
var _useTheme = _interopRequireDefault(useTheme$8);
var _useThemeWithoutDefault = _interopRequireDefault(useThemeWithoutDefault);
var _useMediaQuery = _interopRequireDefault(useMediaQuery$4);
var _colorManipulator = colorManipulator;
Object.keys(_colorManipulator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _colorManipulator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _colorManipulator[key];
    }
  });
});
var _ThemeProvider = _interopRequireDefault(ThemeProvider$9);
var _createCssVarsProvider = _interopRequireDefault(createCssVarsProvider$1);
var _createGetCssVar = _interopRequireDefault(createGetCssVar$2);
var _cssVarsParser = _interopRequireDefault(cssVarsParser$1);
var _prepareCssVars = _interopRequireDefault(prepareCssVars$1);
var _createCssVarsTheme = _interopRequireDefault(createCssVarsTheme$1);
var _responsivePropType = _interopRequireDefault(responsivePropType$1);
var _RtlProvider = _interopRequireWildcard(RtlProvider$1);
Object.keys(_RtlProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _RtlProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RtlProvider[key];
    }
  });
});
var _version = version$3;
Object.keys(_version).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _version[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _version[key];
    }
  });
});
var _createContainer = _interopRequireDefault(createContainer$1);
var _Container = _interopRequireWildcard(Container$5);
Object.keys(_Container).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Container[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Container[key];
    }
  });
});
var _Grid = _interopRequireDefault(Grid$4);
var _Unstable_Grid = Unstable_Grid;
Object.keys(_Unstable_Grid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Unstable_Grid[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Unstable_Grid[key];
    }
  });
});
var _Stack = _interopRequireDefault(Stack$a);
var _Stack2 = Stack$8;
Object.keys(_Stack2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Stack2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Stack2[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
function experimental_sx() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`experimental_sx\` has been moved to \`theme.unstable_sx\`.For more details, see https://github.com/mui/material-ui/pull/35150.` : (0, _formatMuiErrorMessage2.default)(20));
}

/** ----------------- */
/** Layout components */
}(system));

var _interopRequireDefault$8J = interopRequireDefault$1.exports;
Object.defineProperty(useTheme$4, "__esModule", {
  value: true
});
useTheme$4.default = useTheme;
var React$2G = _interopRequireWildcard$43(React__default$4);
var _system$e = system;
var _defaultTheme$1 = _interopRequireDefault$8J(defaultTheme$7);
var _identifier$4 = _interopRequireDefault$8J(identifier);
function _getRequireWildcardCache$3O(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3O = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$43(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3O(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useTheme() {
  const theme = (0, _system$e.useTheme)(_defaultTheme$1.default);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2G.useDebugValue(theme);
  }
  return theme[_identifier$4.default] || theme;
}

var utils$6 = {};

var capitalize$1 = {};

var _interopRequireDefault$8I = interopRequireDefault$1.exports;
Object.defineProperty(capitalize$1, "__esModule", {
  value: true
});
capitalize$1.default = void 0;
var _capitalize$L = _interopRequireDefault$8I(capitalize$4);
capitalize$1.default = _capitalize$L.default;

var createChainedFunction = {};

var _interopRequireDefault$8H = interopRequireDefault$1.exports;
Object.defineProperty(createChainedFunction, "__esModule", {
  value: true
});
createChainedFunction.default = void 0;
var _createChainedFunction$1 = _interopRequireDefault$8H(createChainedFunction$3);
createChainedFunction.default = _createChainedFunction$1.default;

var createSvgIcon$2 = {};

var SvgIcon$3 = {};

var SvgIcon$2 = {};

var svgIconClasses$1 = {};

var _interopRequireDefault$8G = interopRequireDefault$1.exports;
Object.defineProperty(svgIconClasses$1, "__esModule", {
  value: true
});
svgIconClasses$1.default = void 0;
svgIconClasses$1.getSvgIconUtilityClass = getSvgIconUtilityClass;
var _generateUtilityClasses$1S = _interopRequireDefault$8G(generateUtilityClasses$3);
var _generateUtilityClass$1R = _interopRequireDefault$8G(generateUtilityClass$3);
function getSvgIconUtilityClass(slot) {
  return (0, _generateUtilityClass$1R.default)('MuiSvgIcon', slot);
}
const svgIconClasses = (0, _generateUtilityClasses$1S.default)('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);
svgIconClasses$1.default = svgIconClasses;

var _interopRequireDefault$8F = interopRequireDefault$1.exports;
Object.defineProperty(SvgIcon$2, "__esModule", {
  value: true
});
SvgIcon$2.default = void 0;
var _extends2$2m = _interopRequireDefault$8F(_extends$19.exports);
var _objectWithoutPropertiesLoose2$28 = _interopRequireDefault$8F(objectWithoutPropertiesLoose.exports);
var React$2F = _interopRequireWildcard$42(React__default$4);
var _propTypes$2P = _interopRequireDefault$8F(propTypes.exports);
var _clsx$2m = _interopRequireDefault$8F(clsx.exports);
var _composeClasses$1N = _interopRequireDefault$8F(composeClasses$2);
var _capitalize$K = _interopRequireDefault$8F(capitalize$1);
var _DefaultPropsProvider$1P = DefaultPropsProvider$5;
var _styled$1G = _interopRequireDefault$8F(styled$2);
var _svgIconClasses = svgIconClasses$1;
var _jsxRuntime$2H = require$$11;
const _excluded$2C = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"];
function _getRequireWildcardCache$3N(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3N = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$42(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3N(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1O = ownerState => {
  const {
    color,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ['root', color !== 'inherit' && `color${(0, _capitalize$K.default)(color)}`, `fontSize${(0, _capitalize$K.default)(fontSize)}`]
  };
  return (0, _composeClasses$1N.default)(slots, _svgIconClasses.getSvgIconUtilityClass, classes);
};
const SvgIconRoot = (0, _styled$1G.default)('svg', {
  name: 'MuiSvgIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'inherit' && styles[`color${(0, _capitalize$K.default)(ownerState.color)}`], styles[`fontSize${(0, _capitalize$K.default)(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
  return {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
    flexShrink: 0,
    transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
      duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
    }),
    fontSize: {
      inherit: 'inherit',
      small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
      medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
      large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
    }[ownerState.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : {
      action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
      disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
      inherit: undefined
    }[ownerState.color]
  };
});
const SvgIcon$1 = /*#__PURE__*/React$2F.forwardRef(function SvgIcon(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1P.useDefaultProps)({
    props: inProps,
    name: 'MuiSvgIcon'
  });
  const {
      children,
      className,
      color = 'inherit',
      component = 'svg',
      fontSize = 'medium',
      htmlColor,
      inheritViewBox = false,
      titleAccess,
      viewBox = '0 0 24 24'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$28.default)(props, _excluded$2C);
  const hasSvgAsChild = /*#__PURE__*/React$2F.isValidElement(children) && children.type === 'svg';
  const ownerState = (0, _extends2$2m.default)({}, props, {
    color,
    component,
    fontSize,
    instanceFontSize: inProps.fontSize,
    inheritViewBox,
    viewBox,
    hasSvgAsChild
  });
  const more = {};
  if (!inheritViewBox) {
    more.viewBox = viewBox;
  }
  const classes = useUtilityClasses$1O(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2H.jsxs)(SvgIconRoot, (0, _extends2$2m.default)({
    as: component,
    className: (0, _clsx$2m.default)(classes.root, className),
    focusable: "false",
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, more, other, hasSvgAsChild && children.props, {
    ownerState: ownerState,
    children: [hasSvgAsChild ? children.props.children : children, titleAccess ? /*#__PURE__*/(0, _jsxRuntime$2H.jsx)("title", {
      children: titleAccess
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? SvgIcon$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes$2P.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2P.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2P.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: _propTypes$2P.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2P.default.oneOf(['inherit', 'action', 'disabled', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$2P.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2P.default.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: _propTypes$2P.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2P.default.oneOf(['inherit', 'large', 'medium', 'small']), _propTypes$2P.default.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: _propTypes$2P.default.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: _propTypes$2P.default.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: _propTypes$2P.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2P.default.oneOfType([_propTypes$2P.default.arrayOf(_propTypes$2P.default.oneOfType([_propTypes$2P.default.func, _propTypes$2P.default.object, _propTypes$2P.default.bool])), _propTypes$2P.default.func, _propTypes$2P.default.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes$2P.default.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: _propTypes$2P.default.string
} : void 0;
SvgIcon$1.muiName = 'SvgIcon';
SvgIcon$2.default = SvgIcon$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  svgIconClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SvgIcon.default;
  }
});
Object.defineProperty(exports, "svgIconClasses", {
  enumerable: true,
  get: function () {
    return _svgIconClasses.default;
  }
});
var _SvgIcon = _interopRequireDefault(SvgIcon$2);
var _svgIconClasses = _interopRequireWildcard(svgIconClasses$1);
Object.keys(_svgIconClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _svgIconClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _svgIconClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(SvgIcon$3));

var SvgIcon = /*@__PURE__*/getDefaultExportFromCjs$1(SvgIcon$3);

var _interopRequireDefault$8E = interopRequireDefault$1.exports;
Object.defineProperty(createSvgIcon$2, "__esModule", {
  value: true
});
createSvgIcon$2.default = createSvgIcon$1;
var _extends2$2l = _interopRequireDefault$8E(_extends$19.exports);
var React$2E = _interopRequireWildcard$41(React__default$4);
var _SvgIcon$1 = _interopRequireDefault$8E(SvgIcon$3);
var _jsxRuntime$2G = require$$11;
function _getRequireWildcardCache$3M(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3M = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$41(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3M(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Private module reserved for @mui packages.
 */function createSvgIcon$1(path, displayName) {
  function Component(props, ref) {
    return /*#__PURE__*/(0, _jsxRuntime$2G.jsx)(_SvgIcon$1.default, (0, _extends2$2l.default)({
      "data-testid": `${displayName}Icon`,
      ref: ref
    }, props, {
      children: path
    }));
  }
  if (process.env.NODE_ENV !== 'production') {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = `${displayName}Icon`;
  }
  Component.muiName = _SvgIcon$1.default.muiName;
  return /*#__PURE__*/React$2E.memo( /*#__PURE__*/React$2E.forwardRef(Component));
}

var debounce$3 = {};

var _interopRequireDefault$8D = interopRequireDefault$1.exports;
Object.defineProperty(debounce$3, "__esModule", {
  value: true
});
debounce$3.default = void 0;
var _debounce$5 = _interopRequireDefault$8D(debounce$6);
debounce$3.default = _debounce$5.default;

var deprecatedPropType = {};

var _interopRequireDefault$8C = interopRequireDefault$1.exports;
Object.defineProperty(deprecatedPropType, "__esModule", {
  value: true
});
deprecatedPropType.default = void 0;
var _deprecatedPropType = _interopRequireDefault$8C(deprecatedPropType$3);
deprecatedPropType.default = _deprecatedPropType.default;

var isMuiElement = {};

var _interopRequireDefault$8B = interopRequireDefault$1.exports;
Object.defineProperty(isMuiElement, "__esModule", {
  value: true
});
isMuiElement.default = void 0;
var _isMuiElement$5 = _interopRequireDefault$8B(isMuiElement$3);
isMuiElement.default = _isMuiElement$5.default;

var ownerDocument = {};

var _interopRequireDefault$8A = interopRequireDefault$1.exports;
Object.defineProperty(ownerDocument, "__esModule", {
  value: true
});
ownerDocument.default = void 0;
var _ownerDocument$5 = _interopRequireDefault$8A(ownerDocument$3);
ownerDocument.default = _ownerDocument$5.default;

var ownerWindow = {};

var _interopRequireDefault$8z = interopRequireDefault$1.exports;
Object.defineProperty(ownerWindow, "__esModule", {
  value: true
});
ownerWindow.default = void 0;
var _ownerWindow$3 = _interopRequireDefault$8z(ownerWindow$3);
ownerWindow.default = _ownerWindow$3.default;

var requirePropFactory = {};

var _interopRequireDefault$8y = interopRequireDefault$1.exports;
Object.defineProperty(requirePropFactory, "__esModule", {
  value: true
});
requirePropFactory.default = void 0;
var _requirePropFactory$1 = _interopRequireDefault$8y(requirePropFactory$3);
requirePropFactory.default = _requirePropFactory$1.default;

var setRef = {};

var _interopRequireDefault$8x = interopRequireDefault$1.exports;
Object.defineProperty(setRef, "__esModule", {
  value: true
});
setRef.default = void 0;
var _setRef = _interopRequireDefault$8x(setRef$3);
setRef.default = _setRef.default;

var useEnhancedEffect = {};

var _interopRequireDefault$8w = interopRequireDefault$1.exports;
Object.defineProperty(useEnhancedEffect, "__esModule", {
  value: true
});
useEnhancedEffect.default = void 0;
var _useEnhancedEffect$7 = _interopRequireDefault$8w(useEnhancedEffect$3);
useEnhancedEffect.default = _useEnhancedEffect$7.default;

var useId = {};

var _interopRequireDefault$8v = interopRequireDefault$1.exports;
Object.defineProperty(useId, "__esModule", {
  value: true
});
useId.default = void 0;
var _useId$6 = _interopRequireDefault$8v(useId$3);
useId.default = _useId$6.default;

var unsupportedProp = {};

var _interopRequireDefault$8u = interopRequireDefault$1.exports;
Object.defineProperty(unsupportedProp, "__esModule", {
  value: true
});
unsupportedProp.default = void 0;
var _unsupportedProp$3 = _interopRequireDefault$8u(unsupportedProp$3);
unsupportedProp.default = _unsupportedProp$3.default;

var useControlled = {};

var _interopRequireDefault$8t = interopRequireDefault$1.exports;
Object.defineProperty(useControlled, "__esModule", {
  value: true
});
useControlled.default = void 0;
var _useControlled$7 = _interopRequireDefault$8t(useControlled$3);
useControlled.default = _useControlled$7.default;

var useEventCallback = {};

var _interopRequireDefault$8s = interopRequireDefault$1.exports;
Object.defineProperty(useEventCallback, "__esModule", {
  value: true
});
useEventCallback.default = void 0;
var _useEventCallback$4 = _interopRequireDefault$8s(useEventCallback$3);
useEventCallback.default = _useEventCallback$4.default;

var useForkRef = {};

var _interopRequireDefault$8r = interopRequireDefault$1.exports;
Object.defineProperty(useForkRef, "__esModule", {
  value: true
});
useForkRef.default = void 0;
var _useForkRef$k = _interopRequireDefault$8r(useForkRef$3);
useForkRef.default = _useForkRef$k.default;

var useIsFocusVisible = {};

var _interopRequireDefault$8q = interopRequireDefault$1.exports;
Object.defineProperty(useIsFocusVisible, "__esModule", {
  value: true
});
useIsFocusVisible.default = void 0;
var _useIsFocusVisible$3 = _interopRequireDefault$8q(useIsFocusVisible$3);
useIsFocusVisible.default = _useIsFocusVisible$3.default;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "capitalize", {
  enumerable: true,
  get: function () {
    return _capitalize.default;
  }
});
Object.defineProperty(exports, "createChainedFunction", {
  enumerable: true,
  get: function () {
    return _createChainedFunction.default;
  }
});
Object.defineProperty(exports, "createSvgIcon", {
  enumerable: true,
  get: function () {
    return _createSvgIcon.default;
  }
});
Object.defineProperty(exports, "debounce", {
  enumerable: true,
  get: function () {
    return _debounce.default;
  }
});
Object.defineProperty(exports, "deprecatedPropType", {
  enumerable: true,
  get: function () {
    return _deprecatedPropType.default;
  }
});
Object.defineProperty(exports, "isMuiElement", {
  enumerable: true,
  get: function () {
    return _isMuiElement.default;
  }
});
Object.defineProperty(exports, "ownerDocument", {
  enumerable: true,
  get: function () {
    return _ownerDocument.default;
  }
});
Object.defineProperty(exports, "ownerWindow", {
  enumerable: true,
  get: function () {
    return _ownerWindow.default;
  }
});
Object.defineProperty(exports, "requirePropFactory", {
  enumerable: true,
  get: function () {
    return _requirePropFactory.default;
  }
});
Object.defineProperty(exports, "setRef", {
  enumerable: true,
  get: function () {
    return _setRef.default;
  }
});
exports.unstable_ClassNameGenerator = void 0;
Object.defineProperty(exports, "unstable_useEnhancedEffect", {
  enumerable: true,
  get: function () {
    return _useEnhancedEffect.default;
  }
});
Object.defineProperty(exports, "unstable_useId", {
  enumerable: true,
  get: function () {
    return _useId.default;
  }
});
Object.defineProperty(exports, "unsupportedProp", {
  enumerable: true,
  get: function () {
    return _unsupportedProp.default;
  }
});
Object.defineProperty(exports, "useControlled", {
  enumerable: true,
  get: function () {
    return _useControlled.default;
  }
});
Object.defineProperty(exports, "useEventCallback", {
  enumerable: true,
  get: function () {
    return _useEventCallback.default;
  }
});
Object.defineProperty(exports, "useForkRef", {
  enumerable: true,
  get: function () {
    return _useForkRef.default;
  }
});
Object.defineProperty(exports, "useIsFocusVisible", {
  enumerable: true,
  get: function () {
    return _useIsFocusVisible.default;
  }
});
var _utils = utils$7;
var _capitalize = _interopRequireDefault(capitalize$1);
var _createChainedFunction = _interopRequireDefault(createChainedFunction);
var _createSvgIcon = _interopRequireDefault(createSvgIcon$2);
var _debounce = _interopRequireDefault(debounce$3);
var _deprecatedPropType = _interopRequireDefault(deprecatedPropType);
var _isMuiElement = _interopRequireDefault(isMuiElement);
var _ownerDocument = _interopRequireDefault(ownerDocument);
var _ownerWindow = _interopRequireDefault(ownerWindow);
var _requirePropFactory = _interopRequireDefault(requirePropFactory);
var _setRef = _interopRequireDefault(setRef);
var _useEnhancedEffect = _interopRequireDefault(useEnhancedEffect);
var _useId = _interopRequireDefault(useId);
var _unsupportedProp = _interopRequireDefault(unsupportedProp);
var _useControlled = _interopRequireDefault(useControlled);
var _useEventCallback = _interopRequireDefault(useEventCallback);
var _useForkRef = _interopRequireDefault(useForkRef);
var _useIsFocusVisible = _interopRequireDefault(useIsFocusVisible);
// TODO: remove this export once ClassNameGenerator is stable
// eslint-disable-next-line @typescript-eslint/naming-convention
exports.unstable_ClassNameGenerator = {
  configure: generator => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(['MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.', '', "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", '', 'The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401', '', 'The updated documentation: https://mui.com/guides/classname-generator/'].join('\n'));
    }
    _utils.unstable_ClassNameGenerator.configure(generator);
  }
};
}(utils$6));

var collapseClasses$1 = {};

var _interopRequireDefault$8p = interopRequireDefault$1.exports;
Object.defineProperty(collapseClasses$1, "__esModule", {
  value: true
});
collapseClasses$1.default = void 0;
collapseClasses$1.getCollapseUtilityClass = getCollapseUtilityClass;
var _generateUtilityClasses$1R = _interopRequireDefault$8p(generateUtilityClasses$3);
var _generateUtilityClass$1Q = _interopRequireDefault$8p(generateUtilityClass$3);
function getCollapseUtilityClass(slot) {
  return (0, _generateUtilityClass$1Q.default)('MuiCollapse', slot);
}
const collapseClasses = (0, _generateUtilityClasses$1R.default)('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);
collapseClasses$1.default = collapseClasses;

var _interopRequireDefault$8o = interopRequireDefault$1.exports;
Object.defineProperty(Collapse$1, "__esModule", {
  value: true
});
Collapse$1.default = void 0;
var _objectWithoutPropertiesLoose2$27 = _interopRequireDefault$8o(objectWithoutPropertiesLoose.exports);
var _extends2$2k = _interopRequireDefault$8o(_extends$19.exports);
var React$2D = _interopRequireWildcard$40(React__default$4);
var _clsx$2l = _interopRequireDefault$8o(clsx.exports);
var _propTypes$2O = _interopRequireDefault$8o(propTypes.exports);
var _reactTransitionGroup$7 = cjs$4;
var _useTimeout$4 = _interopRequireDefault$8o(useTimeout$2);
var _elementTypeAcceptingRef$6 = _interopRequireDefault$8o(elementTypeAcceptingRef$2);
var _composeClasses$1M = _interopRequireDefault$8o(composeClasses$2);
var _styled$1F = _interopRequireDefault$8o(styled$2);
var _DefaultPropsProvider$1O = DefaultPropsProvider$5;
var _createTransitions = createTransitions$1;
var _utils$U = utils$8;
var _useTheme$e = _interopRequireDefault$8o(useTheme$4);
var _utils2$1 = utils$6;
var _collapseClasses = collapseClasses$1;
var _jsxRuntime$2F = require$$11;
const _excluded$2B = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"];
function _getRequireWildcardCache$3L(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3L = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$40(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3L(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1N = ownerState => {
  const {
    orientation,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${orientation}`],
    entered: ['entered'],
    hidden: ['hidden'],
    wrapper: ['wrapper', `${orientation}`],
    wrapperInner: ['wrapperInner', `${orientation}`]
  };
  return (0, _composeClasses$1M.default)(slots, _collapseClasses.getCollapseUtilityClass, classes);
};
const CollapseRoot = (0, _styled$1F.default)('div', {
  name: 'MuiCollapse',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.state === 'entered' && styles.entered, ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$2k.default)({
  height: 0,
  overflow: 'hidden',
  transition: theme.transitions.create('height')
}, ownerState.orientation === 'horizontal' && {
  height: 'auto',
  width: 0,
  transition: theme.transitions.create('width')
}, ownerState.state === 'entered' && (0, _extends2$2k.default)({
  height: 'auto',
  overflow: 'visible'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto'
}), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
  visibility: 'hidden'
}));
const CollapseWrapper = (0, _styled$1F.default)('div', {
  name: 'MuiCollapse',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => styles.wrapper
})(({
  ownerState
}) => (0, _extends2$2k.default)({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: 'flex',
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));
const CollapseWrapperInner = (0, _styled$1F.default)('div', {
  name: 'MuiCollapse',
  slot: 'WrapperInner',
  overridesResolver: (props, styles) => styles.wrapperInner
})(({
  ownerState
}) => (0, _extends2$2k.default)({
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));

/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Collapse = /*#__PURE__*/React$2D.forwardRef(function Collapse(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1O.useDefaultProps)({
    props: inProps,
    name: 'MuiCollapse'
  });
  const {
      addEndListener,
      children,
      className,
      collapsedSize: collapsedSizeProp = '0px',
      component,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      orientation = 'vertical',
      style,
      timeout = _createTransitions.duration.standard,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = _reactTransitionGroup$7.Transition
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$27.default)(props, _excluded$2B);
  const ownerState = (0, _extends2$2k.default)({}, props, {
    orientation,
    collapsedSize: collapsedSizeProp
  });
  const classes = useUtilityClasses$1N(ownerState);
  const theme = (0, _useTheme$e.default)();
  const timer = (0, _useTimeout$4.default)();
  const wrapperRef = React$2D.useRef(null);
  const autoTransitionDuration = React$2D.useRef();
  const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
  const isHorizontal = orientation === 'horizontal';
  const size = isHorizontal ? 'width' : 'height';
  const nodeRef = React$2D.useRef(null);
  const handleRef = (0, _utils2$1.useForkRef)(ref, nodeRef);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const getWrapperSize = () => wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    if (wrapperRef.current && isHorizontal) {
      // Set absolute position to get the size of collapsed content
      wrapperRef.current.style.position = 'absolute';
    }
    node.style[size] = collapsedSize;
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const wrapperSize = getWrapperSize();
    if (wrapperRef.current && isHorizontal) {
      // After the size is read reset the position back to default
      wrapperRef.current.style.position = '';
    }
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = (0, _utils$U.getTransitionProps)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    if (timeout === 'auto') {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style[size] = `${wrapperSize}px`;
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback((node, isAppearing) => {
    node.style[size] = 'auto';
    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  const handleExit = normalizedTransitionCallback(node => {
    node.style[size] = `${getWrapperSize()}px`;
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleExiting = normalizedTransitionCallback(node => {
    const wrapperSize = getWrapperSize();
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = (0, _utils$U.getTransitionProps)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    if (timeout === 'auto') {
      // TODO: rename getAutoHeightDuration to something more generic (width support)
      // Actually it just calculates animation duration based on size
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }
    node.style[size] = collapsedSize;
    node.style.transitionTimingFunction = transitionTimingFunction;
    if (onExiting) {
      onExiting(node);
    }
  });
  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.start(autoTransitionDuration.current || 0, next);
    }
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime$2F.jsx)(TransitionComponent, (0, _extends2$2k.default)({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => /*#__PURE__*/(0, _jsxRuntime$2F.jsx)(CollapseRoot, (0, _extends2$2k.default)({
      as: component,
      className: (0, _clsx$2l.default)(classes.root, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedSize === '0px' && classes.hidden
      }[state]),
      style: (0, _extends2$2k.default)({
        [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
      }, style),
      ref: handleRef
    }, childProps, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: (0, _extends2$2k.default)({}, ownerState, {
        state
      }),
      children: /*#__PURE__*/(0, _jsxRuntime$2F.jsx)(CollapseWrapper, {
        ownerState: (0, _extends2$2k.default)({}, ownerState, {
          state
        }),
        className: classes.wrapper,
        ref: wrapperRef,
        children: /*#__PURE__*/(0, _jsxRuntime$2F.jsx)(CollapseWrapperInner, {
          ownerState: (0, _extends2$2k.default)({}, ownerState, {
            state
          }),
          className: classes.wrapperInner,
          children: children
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Collapse.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: _propTypes$2O.default.func,
  /**
   * The content node to be collapsed.
   */
  children: _propTypes$2O.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2O.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2O.default.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: _propTypes$2O.default.oneOfType([_propTypes$2O.default.number, _propTypes$2O.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _elementTypeAcceptingRef$6.default,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: _propTypes$2O.default.oneOfType([_propTypes$2O.default.shape({
    enter: _propTypes$2O.default.string,
    exit: _propTypes$2O.default.string
  }), _propTypes$2O.default.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes$2O.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes$2O.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes$2O.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes$2O.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes$2O.default.func,
  /**
   * @ignore
   */
  onExited: _propTypes$2O.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes$2O.default.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: _propTypes$2O.default.oneOf(['horizontal', 'vertical']),
  /**
   * @ignore
   */
  style: _propTypes$2O.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2O.default.oneOfType([_propTypes$2O.default.arrayOf(_propTypes$2O.default.oneOfType([_propTypes$2O.default.func, _propTypes$2O.default.object, _propTypes$2O.default.bool])), _propTypes$2O.default.func, _propTypes$2O.default.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: _propTypes$2O.default.oneOfType([_propTypes$2O.default.oneOf(['auto']), _propTypes$2O.default.number, _propTypes$2O.default.shape({
    appear: _propTypes$2O.default.number,
    enter: _propTypes$2O.default.number,
    exit: _propTypes$2O.default.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
Collapse$1.default = Collapse;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  collapseClasses: true
};
Object.defineProperty(exports, "collapseClasses", {
  enumerable: true,
  get: function () {
    return _collapseClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Collapse.default;
  }
});
var _Collapse = _interopRequireDefault(Collapse$1);
var _collapseClasses = _interopRequireWildcard(collapseClasses$1);
Object.keys(_collapseClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _collapseClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _collapseClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Collapse$2));

var Paper$3 = {};

var Paper$2 = {};

var getOverlayAlpha$1 = {};

Object.defineProperty(getOverlayAlpha$1, "__esModule", {
  value: true
});
getOverlayAlpha$1.default = void 0;
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const getOverlayAlpha = elevation => {
  let alphaValue;
  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }
  return (alphaValue / 100).toFixed(2);
};
getOverlayAlpha$1.default = getOverlayAlpha;

var paperClasses$1 = {};

var _interopRequireDefault$8n = interopRequireDefault$1.exports;
Object.defineProperty(paperClasses$1, "__esModule", {
  value: true
});
paperClasses$1.default = void 0;
paperClasses$1.getPaperUtilityClass = getPaperUtilityClass;
var _generateUtilityClasses$1Q = _interopRequireDefault$8n(generateUtilityClasses$3);
var _generateUtilityClass$1P = _interopRequireDefault$8n(generateUtilityClass$3);
function getPaperUtilityClass(slot) {
  return (0, _generateUtilityClass$1P.default)('MuiPaper', slot);
}
const paperClasses = (0, _generateUtilityClasses$1Q.default)('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);
paperClasses$1.default = paperClasses;

var _interopRequireDefault$8m = interopRequireDefault$1.exports;
Object.defineProperty(Paper$2, "__esModule", {
  value: true
});
Paper$2.default = void 0;
var _objectWithoutPropertiesLoose2$26 = _interopRequireDefault$8m(objectWithoutPropertiesLoose.exports);
var _extends2$2j = _interopRequireDefault$8m(_extends$19.exports);
var React$2C = _interopRequireWildcard$3$(React__default$4);
var _propTypes$2N = _interopRequireDefault$8m(propTypes.exports);
var _clsx$2k = _interopRequireDefault$8m(clsx.exports);
var _integerPropType$a = _interopRequireDefault$8m(integerPropType$1);
var _chainPropTypes$c = _interopRequireDefault$8m(chainPropTypes$2);
var _composeClasses$1L = _interopRequireDefault$8m(composeClasses$2);
var _colorManipulator$n = colorManipulator;
var _styled$1E = _interopRequireDefault$8m(styled$2);
var _getOverlayAlpha$1 = _interopRequireDefault$8m(getOverlayAlpha$1);
var _DefaultPropsProvider$1N = DefaultPropsProvider$5;
var _useTheme$d = _interopRequireDefault$8m(useTheme$4);
var _paperClasses = paperClasses$1;
var _jsxRuntime$2E = require$$11;
const _excluded$2A = ["className", "component", "elevation", "square", "variant"];
function _getRequireWildcardCache$3K(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3K = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3$(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3K(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1M = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return (0, _composeClasses$1L.default)(slots, _paperClasses.getPaperUtilityClass, classes);
};
const PaperRoot = (0, _styled$1E.default)('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$vars$overlays;
  return (0, _extends2$2j.default)({
    backgroundColor: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    transition: theme.transitions.create('box-shadow')
  }, !ownerState.square && {
    borderRadius: theme.shape.borderRadius
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${(theme.vars || theme).palette.divider}`
  }, ownerState.variant === 'elevation' && (0, _extends2$2j.default)({
    boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
  }, !theme.vars && theme.palette.mode === 'dark' && {
    backgroundImage: `linear-gradient(${(0, _colorManipulator$n.alpha)('#fff', (0, _getOverlayAlpha$1.default)(ownerState.elevation))}, ${(0, _colorManipulator$n.alpha)('#fff', (0, _getOverlayAlpha$1.default)(ownerState.elevation))})`
  }, theme.vars && {
    backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
  }));
});
const Paper$1 = /*#__PURE__*/React$2C.forwardRef(function Paper(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1N.useDefaultProps)({
    props: inProps,
    name: 'MuiPaper'
  });
  const {
      className,
      component = 'div',
      elevation = 1,
      square = false,
      variant = 'elevation'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$26.default)(props, _excluded$2A);
  const ownerState = (0, _extends2$2j.default)({}, props, {
    component,
    elevation,
    square,
    variant
  });
  const classes = useUtilityClasses$1M(ownerState);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const theme = (0, _useTheme$d.default)();
    if (theme.shadows[elevation] === undefined) {
      console.error([`MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${elevation}]\` is defined.`].join('\n'));
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime$2E.jsx)(PaperRoot, (0, _extends2$2j.default)({
    as: component,
    ownerState: ownerState,
    className: (0, _clsx$2k.default)(classes.root, className),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Paper$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2N.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2N.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2N.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2N.default.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: (0, _chainPropTypes$c.default)(_integerPropType$a.default, props => {
    const {
      elevation,
      variant
    } = props;
    if (elevation > 0 && variant === 'outlined') {
      return new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
    }
    return null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: _propTypes$2N.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2N.default.oneOfType([_propTypes$2N.default.arrayOf(_propTypes$2N.default.oneOfType([_propTypes$2N.default.func, _propTypes$2N.default.object, _propTypes$2N.default.bool])), _propTypes$2N.default.func, _propTypes$2N.default.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: _propTypes$2N.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2N.default.oneOf(['elevation', 'outlined']), _propTypes$2N.default.string])
} : void 0;
Paper$2.default = Paper$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  paperClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Paper.default;
  }
});
Object.defineProperty(exports, "paperClasses", {
  enumerable: true,
  get: function () {
    return _paperClasses.default;
  }
});
var _Paper = _interopRequireDefault(Paper$2);
var _paperClasses = _interopRequireWildcard(paperClasses$1);
Object.keys(_paperClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _paperClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _paperClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Paper$3));

var Paper = /*@__PURE__*/getDefaultExportFromCjs$1(Paper$3);

var AccordionContext$1 = {};

Object.defineProperty(AccordionContext$1, "__esModule", {
  value: true
});
AccordionContext$1.default = void 0;
var React$2B = _interopRequireWildcard$3_(React__default$4);
function _getRequireWildcardCache$3J(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3J = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3_(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3J(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */
const AccordionContext = /*#__PURE__*/React$2B.createContext({});
if (process.env.NODE_ENV !== 'production') {
  AccordionContext.displayName = 'AccordionContext';
}
AccordionContext$1.default = AccordionContext;

var useSlot$1 = {};

var _interopRequireDefault$8l = interopRequireDefault$1.exports;
Object.defineProperty(useSlot$1, "__esModule", {
  value: true
});
useSlot$1.default = useSlot;
var _extends2$2i = _interopRequireDefault$8l(_extends$19.exports);
var _objectWithoutPropertiesLoose2$25 = _interopRequireDefault$8l(objectWithoutPropertiesLoose.exports);
var _useForkRef$j = _interopRequireDefault$8l(useForkRef$3);
var _appendOwnerState$1 = _interopRequireDefault$8l(appendOwnerState$2);
var _resolveComponentProps = _interopRequireDefault$8l(resolveComponentProps$2);
var _mergeSlotProps2 = _interopRequireDefault$8l(mergeSlotProps$2);
const _excluded$2z = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"],
  _excluded2$p = ["component", "slots", "slotProps"],
  _excluded3$3 = ["component"];
/**
 * An internal function to create a Material UI slot.
 *
 * This is an advanced version of Base UI `useSlotProps` because Material UI allows leaf component to be customized via `component` prop
 * while Base UI does not need to support leaf component customization.
 *
 * @param {string} name: name of the slot
 * @param {object} parameters
 * @returns {[Slot, slotProps]} The slot's React component and the slot's props
 *
 * Note: the returned slot's props
 * - will never contain `component` prop.
 * - might contain `as` prop.
 */
function useSlot(
/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */
name, parameters) {
  const {
      className,
      elementType: initialElementType,
      ownerState,
      externalForwardedProps,
      getSlotOwnerState,
      internalForwardedProps
    } = parameters,
    useSlotPropsParams = (0, _objectWithoutPropertiesLoose2$25.default)(parameters, _excluded$2z);
  const {
      component: rootComponent,
      slots = {
        [name]: undefined
      },
      slotProps = {
        [name]: undefined
      }
    } = externalForwardedProps,
    other = (0, _objectWithoutPropertiesLoose2$25.default)(externalForwardedProps, _excluded2$p);
  const elementType = slots[name] || initialElementType;

  // `slotProps[name]` can be a callback that receives the component's ownerState.
  // `resolvedComponentsProps` is always a plain object.
  const resolvedComponentsProps = (0, _resolveComponentProps.default)(slotProps[name], ownerState);
  const _mergeSlotProps = (0, _mergeSlotProps2.default)((0, _extends2$2i.default)({
      className
    }, useSlotPropsParams, {
      externalForwardedProps: name === 'root' ? other : undefined,
      externalSlotProps: resolvedComponentsProps
    })),
    {
      props: {
        component: slotComponent
      },
      internalRef
    } = _mergeSlotProps,
    mergedProps = (0, _objectWithoutPropertiesLoose2$25.default)(_mergeSlotProps.props, _excluded3$3);
  const ref = (0, _useForkRef$j.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
  const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
  const finalOwnerState = (0, _extends2$2i.default)({}, ownerState, slotOwnerState);
  const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
  const props = (0, _appendOwnerState$1.default)(elementType, (0, _extends2$2i.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
    as: LeafComponent
  }, {
    ref
  }), finalOwnerState);
  Object.keys(slotOwnerState).forEach(propName => {
    delete props[propName];
  });
  return [elementType, props];
}

var accordionClasses$1 = {};

var _interopRequireDefault$8k = interopRequireDefault$1.exports;
Object.defineProperty(accordionClasses$1, "__esModule", {
  value: true
});
accordionClasses$1.default = void 0;
accordionClasses$1.getAccordionUtilityClass = getAccordionUtilityClass;
var _generateUtilityClasses$1P = _interopRequireDefault$8k(generateUtilityClasses$3);
var _generateUtilityClass$1O = _interopRequireDefault$8k(generateUtilityClass$3);
function getAccordionUtilityClass(slot) {
  return (0, _generateUtilityClass$1O.default)('MuiAccordion', slot);
}
const accordionClasses = (0, _generateUtilityClasses$1P.default)('MuiAccordion', ['root', 'rounded', 'expanded', 'disabled', 'gutters', 'region']);
accordionClasses$1.default = accordionClasses;

var _interopRequireDefault$8j = interopRequireDefault$1.exports;
Object.defineProperty(Accordion$2, "__esModule", {
  value: true
});
Accordion$2.default = void 0;
var _extends2$2h = _interopRequireDefault$8j(_extends$19.exports);
var _objectWithoutPropertiesLoose2$24 = _interopRequireDefault$8j(objectWithoutPropertiesLoose.exports);
var React$2A = _interopRequireWildcard$3Z(React__default$4);
var _reactIs$b = reactIs$6.exports;
var _propTypes$2M = _interopRequireDefault$8j(propTypes.exports);
var _clsx$2j = _interopRequireDefault$8j(clsx.exports);
var _chainPropTypes$b = _interopRequireDefault$8j(chainPropTypes$2);
var _composeClasses$1K = _interopRequireDefault$8j(composeClasses$2);
var _zeroStyled$9 = zeroStyled;
var _DefaultPropsProvider$1M = DefaultPropsProvider$5;
var _Collapse$1 = _interopRequireDefault$8j(Collapse$2);
var _Paper$8 = _interopRequireDefault$8j(Paper$3);
var _AccordionContext$1 = _interopRequireDefault$8j(AccordionContext$1);
var _useControlled$6 = _interopRequireDefault$8j(useControlled);
var _useSlot$2 = _interopRequireDefault$8j(useSlot$1);
var _accordionClasses = _interopRequireWildcard$3Z(accordionClasses$1);
var _jsxRuntime$2D = require$$11;
const _excluded$2y = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"];
function _getRequireWildcardCache$3I(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3I = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3Z(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3I(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1L = ownerState => {
  const {
    classes,
    square,
    expanded,
    disabled,
    disableGutters
  } = ownerState;
  const slots = {
    root: ['root', !square && 'rounded', expanded && 'expanded', disabled && 'disabled', !disableGutters && 'gutters'],
    region: ['region']
  };
  return (0, _composeClasses$1K.default)(slots, _accordionClasses.getAccordionUtilityClass, classes);
};
const AccordionRoot = (0, _zeroStyled$9.styled)(_Paper$8.default, {
  name: 'MuiAccordion',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_accordionClasses.default.region}`]: styles.region
    }, styles.root, !ownerState.square && styles.rounded, !ownerState.disableGutters && styles.gutters];
  }
})(({
  theme
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    position: 'relative',
    transition: theme.transitions.create(['margin'], transition),
    overflowAnchor: 'none',
    // Keep the same scrolling position
    '&::before': {
      position: 'absolute',
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (theme.vars || theme).palette.divider,
      transition: theme.transitions.create(['opacity', 'background-color'], transition)
    },
    '&:first-of-type': {
      '&::before': {
        display: 'none'
      }
    },
    [`&.${_accordionClasses.default.expanded}`]: {
      '&::before': {
        opacity: 0
      },
      '&:first-of-type': {
        marginTop: 0
      },
      '&:last-of-type': {
        marginBottom: 0
      },
      '& + &': {
        '&::before': {
          display: 'none'
        }
      }
    },
    [`&.${_accordionClasses.default.disabled}`]: {
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    }
  };
}, ({
  theme
}) => ({
  variants: [{
    props: props => !props.square,
    style: {
      borderRadius: 0,
      '&:first-of-type': {
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
      },
      '&:last-of-type': {
        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: props => !props.disableGutters,
    style: {
      [`&.${_accordionClasses.default.expanded}`]: {
        margin: '16px 0'
      }
    }
  }]
}));
const Accordion$1 = /*#__PURE__*/React$2A.forwardRef(function Accordion(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1M.useDefaultProps)({
    props: inProps,
    name: 'MuiAccordion'
  });
  const {
      children: childrenProp,
      className,
      defaultExpanded = false,
      disabled = false,
      disableGutters = false,
      expanded: expandedProp,
      onChange,
      square = false,
      slots = {},
      slotProps = {},
      TransitionComponent: TransitionComponentProp,
      TransitionProps: TransitionPropsProp
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$24.default)(props, _excluded$2y);
  const [expanded, setExpandedState] = (0, _useControlled$6.default)({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion',
    state: 'expanded'
  });
  const handleChange = React$2A.useCallback(event => {
    setExpandedState(!expanded);
    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);
  const [summary, ...children] = React$2A.Children.toArray(childrenProp);
  const contextValue = React$2A.useMemo(() => ({
    expanded,
    disabled,
    disableGutters,
    toggle: handleChange
  }), [expanded, disabled, disableGutters, handleChange]);
  const ownerState = (0, _extends2$2h.default)({}, props, {
    square,
    disabled,
    disableGutters,
    expanded
  });
  const classes = useUtilityClasses$1L(ownerState);
  const backwardCompatibleSlots = (0, _extends2$2h.default)({
    transition: TransitionComponentProp
  }, slots);
  const backwardCompatibleSlotProps = (0, _extends2$2h.default)({
    transition: TransitionPropsProp
  }, slotProps);
  const [TransitionSlot, transitionProps] = (0, _useSlot$2.default)('transition', {
    elementType: _Collapse$1.default,
    externalForwardedProps: {
      slots: backwardCompatibleSlots,
      slotProps: backwardCompatibleSlotProps
    },
    ownerState
  });
  return /*#__PURE__*/(0, _jsxRuntime$2D.jsxs)(AccordionRoot, (0, _extends2$2h.default)({
    className: (0, _clsx$2j.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState,
    square: square
  }, other, {
    children: [/*#__PURE__*/(0, _jsxRuntime$2D.jsx)(_AccordionContext$1.default.Provider, {
      value: contextValue,
      children: summary
    }), /*#__PURE__*/(0, _jsxRuntime$2D.jsx)(TransitionSlot, (0, _extends2$2h.default)({
      in: expanded,
      timeout: "auto"
    }, transitionProps, {
      children: /*#__PURE__*/(0, _jsxRuntime$2D.jsx)("div", {
        "aria-labelledby": summary.props.id,
        id: summary.props['aria-controls'],
        role: "region",
        className: classes.region,
        children: children
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? Accordion$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: (0, _chainPropTypes$b.default)(_propTypes$2M.default.node.isRequired, props => {
    const summary = React$2A.Children.toArray(props.children)[0];
    if ((0, _reactIs$b.isFragment)(summary)) {
      return new Error("MUI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }
    if (! /*#__PURE__*/React$2A.isValidElement(summary)) {
      return new Error('MUI: Expected the first child of Accordion to be a valid element.');
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2M.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2M.default.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: _propTypes$2M.default.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$2M.default.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: _propTypes$2M.default.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: _propTypes$2M.default.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: _propTypes$2M.default.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: _propTypes$2M.default.shape({
    transition: _propTypes$2M.default.oneOfType([_propTypes$2M.default.func, _propTypes$2M.default.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: _propTypes$2M.default.shape({
    transition: _propTypes$2M.default.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: _propTypes$2M.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2M.default.oneOfType([_propTypes$2M.default.arrayOf(_propTypes$2M.default.oneOfType([_propTypes$2M.default.func, _propTypes$2M.default.object, _propTypes$2M.default.bool])), _propTypes$2M.default.func, _propTypes$2M.default.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionComponent: _propTypes$2M.default.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionProps: _propTypes$2M.default.object
} : void 0;
Accordion$2.default = Accordion$1;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  accordionClasses: true
};
Object.defineProperty(exports, "accordionClasses", {
  enumerable: true,
  get: function () {
    return _accordionClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Accordion.default;
  }
});
var _Accordion = _interopRequireDefault(Accordion$2);
var _accordionClasses = _interopRequireWildcard(accordionClasses$1);
Object.keys(_accordionClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _accordionClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _accordionClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Accordion$3));

var AccordionBasic = /*@__PURE__*/getDefaultExportFromCjs$1(Accordion$3);

var AccordionSummary$3 = {};

var AccordionSummary$2 = {};

var ButtonBase$2 = {};

var ButtonBase$1 = {};

var TouchRipple$1 = {};

var Ripple$2 = {};

var _interopRequireDefault$8i = interopRequireDefault$1.exports;
Object.defineProperty(Ripple$2, "__esModule", {
  value: true
});
Ripple$2.default = void 0;
var React$2z = _interopRequireWildcard$3Y(React__default$4);
var _propTypes$2L = _interopRequireDefault$8i(propTypes.exports);
var _clsx$2i = _interopRequireDefault$8i(clsx.exports);
var _jsxRuntime$2C = require$$11;
function _getRequireWildcardCache$3H(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3H = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3Y(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3H(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */function Ripple$1(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout
  } = props;
  const [leaving, setLeaving] = React$2z.useState(false);
  const rippleClassName = (0, _clsx$2i.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = (0, _clsx$2i.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  if (!inProp && !leaving) {
    setLeaving(true);
  }
  React$2z.useEffect(() => {
    if (!inProp && onExited != null) {
      // react-transition-group#onExited
      const timeoutId = setTimeout(onExited, timeout);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return undefined;
  }, [onExited, inProp, timeout]);
  return /*#__PURE__*/(0, _jsxRuntime$2C.jsx)("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /*#__PURE__*/(0, _jsxRuntime$2C.jsx)("span", {
      className: childClassName
    })
  });
}
process.env.NODE_ENV !== "production" ? Ripple$1.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2L.default.object.isRequired,
  className: _propTypes$2L.default.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: _propTypes$2L.default.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: _propTypes$2L.default.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: _propTypes$2L.default.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: _propTypes$2L.default.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: _propTypes$2L.default.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: _propTypes$2L.default.number,
  /**
   * exit delay
   */
  timeout: _propTypes$2L.default.number.isRequired
} : void 0;
Ripple$2.default = Ripple$1;

var touchRippleClasses$1 = {};

var _interopRequireDefault$8h = interopRequireDefault$1.exports;
Object.defineProperty(touchRippleClasses$1, "__esModule", {
  value: true
});
touchRippleClasses$1.default = void 0;
touchRippleClasses$1.getTouchRippleUtilityClass = getTouchRippleUtilityClass;
var _generateUtilityClasses$1O = _interopRequireDefault$8h(generateUtilityClasses$3);
var _generateUtilityClass$1N = _interopRequireDefault$8h(generateUtilityClass$3);
function getTouchRippleUtilityClass(slot) {
  return (0, _generateUtilityClass$1N.default)('MuiTouchRipple', slot);
}
const touchRippleClasses = (0, _generateUtilityClasses$1O.default)('MuiTouchRipple', ['root', 'ripple', 'rippleVisible', 'ripplePulsate', 'child', 'childLeaving', 'childPulsate']);
touchRippleClasses$1.default = touchRippleClasses;

var _interopRequireDefault$8g = interopRequireDefault$1.exports;
Object.defineProperty(TouchRipple$1, "__esModule", {
  value: true
});
TouchRipple$1.default = TouchRipple$1.TouchRippleRoot = TouchRipple$1.TouchRippleRipple = TouchRipple$1.DELAY_RIPPLE = void 0;
var _extends2$2g = _interopRequireDefault$8g(_extends$19.exports);
var _objectWithoutPropertiesLoose2$23 = _interopRequireDefault$8g(objectWithoutPropertiesLoose.exports);
var React$2y = _interopRequireWildcard$3X(React__default$4);
var _propTypes$2K = _interopRequireDefault$8g(propTypes.exports);
var _reactTransitionGroup$6 = cjs$4;
var _clsx$2h = _interopRequireDefault$8g(clsx.exports);
var _system$d = system;
var _useTimeout$3 = _interopRequireDefault$8g(useTimeout$2);
var _styled$1D = _interopRequireDefault$8g(styled$2);
var _DefaultPropsProvider$1L = DefaultPropsProvider$5;
var _Ripple$4 = _interopRequireDefault$8g(Ripple$2);
var _touchRippleClasses = _interopRequireDefault$8g(touchRippleClasses$1);
var _jsxRuntime$2B = require$$11;
const _excluded$2x = ["center", "classes", "className"];
function _getRequireWildcardCache$3G(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3G = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3X(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3G(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DURATION = 550;
const DELAY_RIPPLE = TouchRipple$1.DELAY_RIPPLE = 80;
const enterKeyframe = (0, _system$d.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const exitKeyframe = (0, _system$d.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const pulsateKeyframe = (0, _system$d.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const TouchRippleRoot = TouchRipple$1.TouchRippleRoot = (0, _styled$1D.default)('span', {
  name: 'MuiTouchRipple',
  slot: 'Root'
})({
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: 'inherit'
});

// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const TouchRippleRipple = TouchRipple$1.TouchRippleRipple = (0, _styled$1D.default)(_Ripple$4.default, {
  name: 'MuiTouchRipple',
  slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${_touchRippleClasses.default.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${enterKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme
}) => theme.transitions.easing.easeInOut};
  }

  &.${_touchRippleClasses.default.ripplePulsate} {
    animation-duration: ${({
  theme
}) => theme.transitions.duration.shorter}ms;
  }

  & .${_touchRippleClasses.default.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${_touchRippleClasses.default.childLeaving} {
    opacity: 0;
    animation-name: ${exitKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme
}) => theme.transitions.easing.easeInOut};
  }

  & .${_touchRippleClasses.default.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme
}) => theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;

/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */
const TouchRipple = /*#__PURE__*/React$2y.forwardRef(function TouchRipple(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1L.useDefaultProps)({
    props: inProps,
    name: 'MuiTouchRipple'
  });
  const {
      center: centerProp = false,
      classes = {},
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$23.default)(props, _excluded$2x);
  const [ripples, setRipples] = React$2y.useState([]);
  const nextKey = React$2y.useRef(0);
  const rippleCallback = React$2y.useRef(null);
  React$2y.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]);

  // Used to filter out mouse emulated events on mobile.
  const ignoringMouseDown = React$2y.useRef(false);
  // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.
  const startTimer = (0, _useTimeout$3.default)();

  // This is the hook called once the previous timeout is ready.
  const startTimerCommit = React$2y.useRef(null);
  const container = React$2y.useRef(null);
  const startCommit = React$2y.useCallback(params => {
    const {
      pulsate,
      rippleX,
      rippleY,
      rippleSize,
      cb
    } = params;
    setRipples(oldRipples => [...oldRipples, /*#__PURE__*/(0, _jsxRuntime$2B.jsx)(TouchRippleRipple, {
      classes: {
        ripple: (0, _clsx$2h.default)(classes.ripple, _touchRippleClasses.default.ripple),
        rippleVisible: (0, _clsx$2h.default)(classes.rippleVisible, _touchRippleClasses.default.rippleVisible),
        ripplePulsate: (0, _clsx$2h.default)(classes.ripplePulsate, _touchRippleClasses.default.ripplePulsate),
        child: (0, _clsx$2h.default)(classes.child, _touchRippleClasses.default.child),
        childLeaving: (0, _clsx$2h.default)(classes.childLeaving, _touchRippleClasses.default.childLeaving),
        childPulsate: (0, _clsx$2h.default)(classes.childPulsate, _touchRippleClasses.default.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate,
      rippleX: rippleX,
      rippleY: rippleY,
      rippleSize: rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  const start = React$2y.useCallback((event = {}, options = {}, cb = () => {}) => {
    const {
      pulsate = false,
      center = centerProp || options.pulsate,
      fakeElement = false // For test purposes
    } = options;
    if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }
    if ((event == null ? void 0 : event.type) === 'touchstart') {
      ignoringMouseDown.current = true;
    }
    const element = fakeElement ? null : container.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };

    // Get the size of the ripple
    let rippleX;
    let rippleY;
    let rippleSize;
    if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }
    if (center) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);

      // For some reason the animation is broken on Mobile Chrome if the size is even.
      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }

    // Touche devices
    if (event != null && event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = () => {
          startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        };
        // Delay the execution of the ripple effect.
        // We have to make a tradeoff with this delay value.
        startTimer.start(DELAY_RIPPLE, () => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        });
      }
    } else {
      startCommit({
        pulsate,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit, startTimer]);
  const pulsate = React$2y.useCallback(() => {
    start({}, {
      pulsate: true
    });
  }, [start]);
  const stop = React$2y.useCallback((event, cb) => {
    startTimer.clear();

    // The touch interaction occurs too quickly.
    // We still want to show ripple effect.
    if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.start(0, () => {
        stop(event, cb);
      });
      return;
    }
    startTimerCommit.current = null;
    setRipples(oldRipples => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }
      return oldRipples;
    });
    rippleCallback.current = cb;
  }, [startTimer]);
  React$2y.useImperativeHandle(ref, () => ({
    pulsate,
    start,
    stop
  }), [pulsate, start, stop]);
  return /*#__PURE__*/(0, _jsxRuntime$2B.jsx)(TouchRippleRoot, (0, _extends2$2g.default)({
    className: (0, _clsx$2h.default)(_touchRippleClasses.default.root, classes.root, className),
    ref: container
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$2B.jsx)(_reactTransitionGroup$6.TransitionGroup, {
      component: null,
      exit: true,
      children: ripples
    })
  }));
});
process.env.NODE_ENV !== "production" ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: _propTypes$2K.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2K.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2K.default.string
} : void 0;
TouchRipple$1.default = TouchRipple;

var buttonBaseClasses$1 = {};

var _interopRequireDefault$8f = interopRequireDefault$1.exports;
Object.defineProperty(buttonBaseClasses$1, "__esModule", {
  value: true
});
buttonBaseClasses$1.default = void 0;
buttonBaseClasses$1.getButtonBaseUtilityClass = getButtonBaseUtilityClass;
var _generateUtilityClasses$1N = _interopRequireDefault$8f(generateUtilityClasses$3);
var _generateUtilityClass$1M = _interopRequireDefault$8f(generateUtilityClass$3);
function getButtonBaseUtilityClass(slot) {
  return (0, _generateUtilityClass$1M.default)('MuiButtonBase', slot);
}
const buttonBaseClasses = (0, _generateUtilityClasses$1N.default)('MuiButtonBase', ['root', 'disabled', 'focusVisible']);
buttonBaseClasses$1.default = buttonBaseClasses;

var _interopRequireDefault$8e = interopRequireDefault$1.exports;
Object.defineProperty(ButtonBase$1, "__esModule", {
  value: true
});
ButtonBase$1.default = ButtonBase$1.ButtonBaseRoot = void 0;
var _extends2$2f = _interopRequireDefault$8e(_extends$19.exports);
var _objectWithoutPropertiesLoose2$22 = _interopRequireDefault$8e(objectWithoutPropertiesLoose.exports);
var React$2x = _interopRequireWildcard$3W(React__default$4);
var _propTypes$2J = _interopRequireDefault$8e(propTypes.exports);
var _clsx$2g = _interopRequireDefault$8e(clsx.exports);
var _refType$f = _interopRequireDefault$8e(refType$2);
var _elementTypeAcceptingRef$5 = _interopRequireDefault$8e(elementTypeAcceptingRef$2);
var _composeClasses$1J = _interopRequireDefault$8e(composeClasses$2);
var _styled$1C = _interopRequireDefault$8e(styled$2);
var _DefaultPropsProvider$1K = DefaultPropsProvider$5;
var _useForkRef$i = _interopRequireDefault$8e(useForkRef);
var _useEventCallback$3 = _interopRequireDefault$8e(useEventCallback);
var _useIsFocusVisible$2 = _interopRequireDefault$8e(useIsFocusVisible);
var _TouchRipple = _interopRequireDefault$8e(TouchRipple$1);
var _buttonBaseClasses = _interopRequireWildcard$3W(buttonBaseClasses$1);
var _jsxRuntime$2A = require$$11;
const _excluded$2w = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"];
function _getRequireWildcardCache$3F(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3F = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3W(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3F(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1K = ownerState => {
  const {
    disabled,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', focusVisible && 'focusVisible']
  };
  const composedClasses = (0, _composeClasses$1J.default)(slots, _buttonBaseClasses.getButtonBaseUtilityClass, classes);
  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }
  return composedClasses;
};
const ButtonBaseRoot = ButtonBase$1.ButtonBaseRoot = (0, _styled$1C.default)('button', {
  name: 'MuiButtonBase',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  WebkitTapHighlightColor: 'transparent',
  backgroundColor: 'transparent',
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: 'pointer',
  userSelect: 'none',
  verticalAlign: 'middle',
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  textDecoration: 'none',
  // So we take precedent over the style of a native <a /> element.
  color: 'inherit',
  '&::-moz-focus-inner': {
    borderStyle: 'none' // Remove Firefox dotted outline.
  },
  [`&.${_buttonBaseClasses.default.disabled}`]: {
    pointerEvents: 'none',
    // Disable link interactions
    cursor: 'default'
  },
  '@media print': {
    colorAdjust: 'exact'
  }
});

/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */
const ButtonBase = /*#__PURE__*/React$2x.forwardRef(function ButtonBase(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1K.useDefaultProps)({
    props: inProps,
    name: 'MuiButtonBase'
  });
  const {
      action,
      centerRipple = false,
      children,
      className,
      component = 'button',
      disabled = false,
      disableRipple = false,
      disableTouchRipple = false,
      focusRipple = false,
      LinkComponent = 'a',
      onBlur,
      onClick,
      onContextMenu,
      onDragLeave,
      onFocus,
      onFocusVisible,
      onKeyDown,
      onKeyUp,
      onMouseDown,
      onMouseLeave,
      onMouseUp,
      onTouchEnd,
      onTouchMove,
      onTouchStart,
      tabIndex = 0,
      TouchRippleProps,
      touchRippleRef,
      type
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$22.default)(props, _excluded$2w);
  const buttonRef = React$2x.useRef(null);
  const rippleRef = React$2x.useRef(null);
  const handleRippleRef = (0, _useForkRef$i.default)(rippleRef, touchRippleRef);
  const {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: focusVisibleRef
  } = (0, _useIsFocusVisible$2.default)();
  const [focusVisible, setFocusVisible] = React$2x.useState(false);
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  React$2x.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  const [mountedState, setMountedState] = React$2x.useState(false);
  React$2x.useEffect(() => {
    setMountedState(true);
  }, []);
  const enableTouchRipple = mountedState && !disableRipple && !disabled;
  React$2x.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple && mountedState) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible, mountedState]);
  function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
    return (0, _useEventCallback$3.default)(event => {
      if (eventCallback) {
        eventCallback(event);
      }
      const ignore = skipRippleAction;
      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }
      return true;
    });
  }
  const handleMouseDown = useRippleHandler('start', onMouseDown);
  const handleContextMenu = useRippleHandler('stop', onContextMenu);
  const handleDragLeave = useRippleHandler('stop', onDragLeave);
  const handleMouseUp = useRippleHandler('stop', onMouseUp);
  const handleMouseLeave = useRippleHandler('stop', event => {
    if (focusVisible) {
      event.preventDefault();
    }
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  const handleTouchStart = useRippleHandler('start', onTouchStart);
  const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  const handleTouchMove = useRippleHandler('stop', onTouchMove);
  const handleBlur = useRippleHandler('stop', event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  }, false);
  const handleFocus = (0, _useEventCallback$3.default)(event => {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }
    if (onFocus) {
      onFocus(event);
    }
  });
  const isNonNativeButton = () => {
    const button = buttonRef.current;
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };

  /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */
  const keydownRef = React$2x.useRef(false);
  const handleKeyDown = (0, _useEventCallback$3.default)(event => {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      rippleRef.current.stop(event, () => {
        rippleRef.current.start(event);
      });
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }

    // Keyboard accessibility for non interactive elements
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();
      if (onClick) {
        onClick(event);
      }
    }
  });
  const handleKeyUp = (0, _useEventCallback$3.default)(event => {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      rippleRef.current.stop(event, () => {
        rippleRef.current.pulsate(event);
      });
    }
    if (onKeyUp) {
      onKeyUp(event);
    }

    // Keyboard accessibility for non interactive elements
    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  let ComponentProp = component;
  if (ComponentProp === 'button' && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }
  const buttonProps = {};
  if (ComponentProp === 'button') {
    buttonProps.type = type === undefined ? 'button' : type;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = 'button';
    }
    if (disabled) {
      buttonProps['aria-disabled'] = disabled;
    }
  }
  const handleRef = (0, _useForkRef$i.default)(ref, focusVisibleRef, buttonRef);
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2x.useEffect(() => {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['MUI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }
  const ownerState = (0, _extends2$2f.default)({}, props, {
    centerRipple,
    component,
    disabled,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  });
  const classes = useUtilityClasses$1K(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2A.jsxs)(ButtonBaseRoot, (0, _extends2$2f.default)({
    as: ComponentProp,
    className: (0, _clsx$2g.default)(classes.root, className),
    ownerState: ownerState,
    onBlur: handleBlur,
    onClick: onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type: type
  }, buttonProps, other, {
    children: [children, enableTouchRipple ?
    /*#__PURE__*/
    /* TouchRipple is only needed client-side, x2 boost on the server. */
    (0, _jsxRuntime$2A.jsx)(_TouchRipple.default, (0, _extends2$2f.default)({
      ref: handleRippleRef,
      center: centerRipple
    }, TouchRippleProps)) : null]
  }));
});
process.env.NODE_ENV !== "production" ? ButtonBase.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: _refType$f.default,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: _propTypes$2J.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes$2J.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2J.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2J.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _elementTypeAcceptingRef$5.default,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$2J.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: _propTypes$2J.default.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: _propTypes$2J.default.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: _propTypes$2J.default.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: _propTypes$2J.default.string,
  /**
   * @ignore
   */
  href: _propTypes$2J.default /* @typescript-to-proptypes-ignore */.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: _propTypes$2J.default.elementType,
  /**
   * @ignore
   */
  onBlur: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onContextMenu: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onDragLeave: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes$2J.default.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onMouseDown: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onMouseUp: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onTouchEnd: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onTouchMove: _propTypes$2J.default.func,
  /**
   * @ignore
   */
  onTouchStart: _propTypes$2J.default.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2J.default.oneOfType([_propTypes$2J.default.arrayOf(_propTypes$2J.default.oneOfType([_propTypes$2J.default.func, _propTypes$2J.default.object, _propTypes$2J.default.bool])), _propTypes$2J.default.func, _propTypes$2J.default.object]),
  /**
   * @default 0
   */
  tabIndex: _propTypes$2J.default.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: _propTypes$2J.default.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: _propTypes$2J.default.oneOfType([_propTypes$2J.default.func, _propTypes$2J.default.shape({
    current: _propTypes$2J.default.shape({
      pulsate: _propTypes$2J.default.func.isRequired,
      start: _propTypes$2J.default.func.isRequired,
      stop: _propTypes$2J.default.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: _propTypes$2J.default.oneOfType([_propTypes$2J.default.oneOf(['button', 'reset', 'submit']), _propTypes$2J.default.string])
} : void 0;
ButtonBase$1.default = ButtonBase;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  buttonBaseClasses: true,
  touchRippleClasses: true
};
Object.defineProperty(exports, "buttonBaseClasses", {
  enumerable: true,
  get: function () {
    return _buttonBaseClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ButtonBase.default;
  }
});
Object.defineProperty(exports, "touchRippleClasses", {
  enumerable: true,
  get: function () {
    return _touchRippleClasses.default;
  }
});
var _ButtonBase = _interopRequireDefault(ButtonBase$1);
var _buttonBaseClasses = _interopRequireWildcard(buttonBaseClasses$1);
Object.keys(_buttonBaseClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _buttonBaseClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _buttonBaseClasses[key];
    }
  });
});
var _touchRippleClasses = _interopRequireWildcard(touchRippleClasses$1);
Object.keys(_touchRippleClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _touchRippleClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _touchRippleClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ButtonBase$2));

var accordionSummaryClasses$1 = {};

var _interopRequireDefault$8d = interopRequireDefault$1.exports;
Object.defineProperty(accordionSummaryClasses$1, "__esModule", {
  value: true
});
accordionSummaryClasses$1.default = void 0;
accordionSummaryClasses$1.getAccordionSummaryUtilityClass = getAccordionSummaryUtilityClass;
var _generateUtilityClasses$1M = _interopRequireDefault$8d(generateUtilityClasses$3);
var _generateUtilityClass$1L = _interopRequireDefault$8d(generateUtilityClass$3);
function getAccordionSummaryUtilityClass(slot) {
  return (0, _generateUtilityClass$1L.default)('MuiAccordionSummary', slot);
}
const accordionSummaryClasses = (0, _generateUtilityClasses$1M.default)('MuiAccordionSummary', ['root', 'expanded', 'focusVisible', 'disabled', 'gutters', 'contentGutters', 'content', 'expandIconWrapper']);
accordionSummaryClasses$1.default = accordionSummaryClasses;

var _interopRequireDefault$8c = interopRequireDefault$1.exports;
Object.defineProperty(AccordionSummary$2, "__esModule", {
  value: true
});
AccordionSummary$2.default = void 0;
var _extends2$2e = _interopRequireDefault$8c(_extends$19.exports);
var _objectWithoutPropertiesLoose2$21 = _interopRequireDefault$8c(objectWithoutPropertiesLoose.exports);
var React$2w = _interopRequireWildcard$3V(React__default$4);
var _propTypes$2I = _interopRequireDefault$8c(propTypes.exports);
var _clsx$2f = _interopRequireDefault$8c(clsx.exports);
var _composeClasses$1I = _interopRequireDefault$8c(composeClasses$2);
var _zeroStyled$8 = zeroStyled;
var _DefaultPropsProvider$1J = DefaultPropsProvider$5;
var _ButtonBase$h = _interopRequireDefault$8c(ButtonBase$2);
var _AccordionContext = _interopRequireDefault$8c(AccordionContext$1);
var _accordionSummaryClasses = _interopRequireWildcard$3V(accordionSummaryClasses$1);
var _jsxRuntime$2z = require$$11;
const _excluded$2v = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"];
function _getRequireWildcardCache$3E(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3E = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3V(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3E(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1J = ownerState => {
  const {
    classes,
    expanded,
    disabled,
    disableGutters
  } = ownerState;
  const slots = {
    root: ['root', expanded && 'expanded', disabled && 'disabled', !disableGutters && 'gutters'],
    focusVisible: ['focusVisible'],
    content: ['content', expanded && 'expanded', !disableGutters && 'contentGutters'],
    expandIconWrapper: ['expandIconWrapper', expanded && 'expanded']
  };
  return (0, _composeClasses$1I.default)(slots, _accordionSummaryClasses.getAccordionSummaryUtilityClass, classes);
};
const AccordionSummaryRoot = (0, _zeroStyled$8.styled)(_ButtonBase$h.default, {
  name: 'MuiAccordionSummary',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  const transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    display: 'flex',
    minHeight: 48,
    padding: theme.spacing(0, 2),
    transition: theme.transitions.create(['min-height', 'background-color'], transition),
    [`&.${_accordionSummaryClasses.default.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette.action.focus
    },
    [`&.${_accordionSummaryClasses.default.disabled}`]: {
      opacity: (theme.vars || theme).palette.action.disabledOpacity
    },
    [`&:hover:not(.${_accordionSummaryClasses.default.disabled})`]: {
      cursor: 'pointer'
    },
    variants: [{
      props: props => !props.disableGutters,
      style: {
        [`&.${_accordionSummaryClasses.default.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
});
const AccordionSummaryContent = (0, _zeroStyled$8.styled)('div', {
  name: 'MuiAccordionSummary',
  slot: 'Content',
  overridesResolver: (props, styles) => styles.content
})(({
  theme
}) => ({
  display: 'flex',
  flexGrow: 1,
  margin: '12px 0',
  variants: [{
    props: props => !props.disableGutters,
    style: {
      transition: theme.transitions.create(['margin'], {
        duration: theme.transitions.duration.shortest
      }),
      [`&.${_accordionSummaryClasses.default.expanded}`]: {
        margin: '20px 0'
      }
    }
  }]
}));
const AccordionSummaryExpandIconWrapper = (0, _zeroStyled$8.styled)('div', {
  name: 'MuiAccordionSummary',
  slot: 'ExpandIconWrapper',
  overridesResolver: (props, styles) => styles.expandIconWrapper
})(({
  theme
}) => ({
  display: 'flex',
  color: (theme.vars || theme).palette.action.active,
  transform: 'rotate(0deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${_accordionSummaryClasses.default.expanded}`]: {
    transform: 'rotate(180deg)'
  }
}));
const AccordionSummary$1 = /*#__PURE__*/React$2w.forwardRef(function AccordionSummary(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1J.useDefaultProps)({
    props: inProps,
    name: 'MuiAccordionSummary'
  });
  const {
      children,
      className,
      expandIcon,
      focusVisibleClassName,
      onClick
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$21.default)(props, _excluded$2v);
  const {
    disabled = false,
    disableGutters,
    expanded,
    toggle
  } = React$2w.useContext(_AccordionContext.default);
  const handleChange = event => {
    if (toggle) {
      toggle(event);
    }
    if (onClick) {
      onClick(event);
    }
  };
  const ownerState = (0, _extends2$2e.default)({}, props, {
    expanded,
    disabled,
    disableGutters
  });
  const classes = useUtilityClasses$1J(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2z.jsxs)(AccordionSummaryRoot, (0, _extends2$2e.default)({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: (0, _clsx$2f.default)(classes.root, className),
    focusVisibleClassName: (0, _clsx$2f.default)(classes.focusVisible, focusVisibleClassName),
    onClick: handleChange,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/(0, _jsxRuntime$2z.jsx)(AccordionSummaryContent, {
      className: classes.content,
      ownerState: ownerState,
      children: children
    }), expandIcon && /*#__PURE__*/(0, _jsxRuntime$2z.jsx)(AccordionSummaryExpandIconWrapper, {
      className: classes.expandIconWrapper,
      ownerState: ownerState,
      children: expandIcon
    })]
  }));
});
process.env.NODE_ENV !== "production" ? AccordionSummary$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2I.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2I.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2I.default.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: _propTypes$2I.default.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: _propTypes$2I.default.string,
  /**
   * @ignore
   */
  onClick: _propTypes$2I.default.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2I.default.oneOfType([_propTypes$2I.default.arrayOf(_propTypes$2I.default.oneOfType([_propTypes$2I.default.func, _propTypes$2I.default.object, _propTypes$2I.default.bool])), _propTypes$2I.default.func, _propTypes$2I.default.object])
} : void 0;
AccordionSummary$2.default = AccordionSummary$1;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  accordionSummaryClasses: true
};
Object.defineProperty(exports, "accordionSummaryClasses", {
  enumerable: true,
  get: function () {
    return _accordionSummaryClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _AccordionSummary.default;
  }
});
var _AccordionSummary = _interopRequireDefault(AccordionSummary$2);
var _accordionSummaryClasses = _interopRequireWildcard(accordionSummaryClasses$1);
Object.keys(_accordionSummaryClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _accordionSummaryClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _accordionSummaryClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(AccordionSummary$3));

var AccordionSummary = /*@__PURE__*/getDefaultExportFromCjs$1(AccordionSummary$3);

var AccordionDetails$3 = {};

var AccordionDetails$2 = {};

var accordionDetailsClasses$1 = {};

var _interopRequireDefault$8b = interopRequireDefault$1.exports;
Object.defineProperty(accordionDetailsClasses$1, "__esModule", {
  value: true
});
accordionDetailsClasses$1.default = void 0;
accordionDetailsClasses$1.getAccordionDetailsUtilityClass = getAccordionDetailsUtilityClass;
var _generateUtilityClasses$1L = _interopRequireDefault$8b(generateUtilityClasses$3);
var _generateUtilityClass$1K = _interopRequireDefault$8b(generateUtilityClass$3);
function getAccordionDetailsUtilityClass(slot) {
  return (0, _generateUtilityClass$1K.default)('MuiAccordionDetails', slot);
}
const accordionDetailsClasses = (0, _generateUtilityClasses$1L.default)('MuiAccordionDetails', ['root']);
accordionDetailsClasses$1.default = accordionDetailsClasses;

var _interopRequireDefault$8a = interopRequireDefault$1.exports;
Object.defineProperty(AccordionDetails$2, "__esModule", {
  value: true
});
AccordionDetails$2.default = void 0;
var _extends2$2d = _interopRequireDefault$8a(_extends$19.exports);
var _objectWithoutPropertiesLoose2$20 = _interopRequireDefault$8a(objectWithoutPropertiesLoose.exports);
var React$2v = _interopRequireWildcard$3U(React__default$4);
var _propTypes$2H = _interopRequireDefault$8a(propTypes.exports);
var _clsx$2e = _interopRequireDefault$8a(clsx.exports);
var _composeClasses$1H = _interopRequireDefault$8a(composeClasses$2);
var _zeroStyled$7 = zeroStyled;
var _DefaultPropsProvider$1I = DefaultPropsProvider$5;
var _accordionDetailsClasses = accordionDetailsClasses$1;
var _jsxRuntime$2y = require$$11;
const _excluded$2u = ["className"];
function _getRequireWildcardCache$3D(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3D = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3U(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3D(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1I = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$1H.default)(slots, _accordionDetailsClasses.getAccordionDetailsUtilityClass, classes);
};
const AccordionDetailsRoot = (0, _zeroStyled$7.styled)('div', {
  name: 'MuiAccordionDetails',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  padding: theme.spacing(1, 2, 2)
}));
const AccordionDetails$1 = /*#__PURE__*/React$2v.forwardRef(function AccordionDetails(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1I.useDefaultProps)({
    props: inProps,
    name: 'MuiAccordionDetails'
  });
  const {
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$20.default)(props, _excluded$2u);
  const ownerState = props;
  const classes = useUtilityClasses$1I(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2y.jsx)(AccordionDetailsRoot, (0, _extends2$2d.default)({
    className: (0, _clsx$2e.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? AccordionDetails$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2H.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2H.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2H.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2H.default.oneOfType([_propTypes$2H.default.arrayOf(_propTypes$2H.default.oneOfType([_propTypes$2H.default.func, _propTypes$2H.default.object, _propTypes$2H.default.bool])), _propTypes$2H.default.func, _propTypes$2H.default.object])
} : void 0;
AccordionDetails$2.default = AccordionDetails$1;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  accordionDetailsClasses: true
};
Object.defineProperty(exports, "accordionDetailsClasses", {
  enumerable: true,
  get: function () {
    return _accordionDetailsClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _AccordionDetails.default;
  }
});
var _AccordionDetails = _interopRequireDefault(AccordionDetails$2);
var _accordionDetailsClasses = _interopRequireWildcard(accordionDetailsClasses$1);
Object.keys(_accordionDetailsClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _accordionDetailsClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _accordionDetailsClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(AccordionDetails$3));

var AccordionDetails = /*@__PURE__*/getDefaultExportFromCjs$1(AccordionDetails$3);

var Typography$3 = {};

var Typography$2 = {};

var typographyClasses$1 = {};

var _interopRequireDefault$89 = interopRequireDefault$1.exports;
Object.defineProperty(typographyClasses$1, "__esModule", {
  value: true
});
typographyClasses$1.default = void 0;
typographyClasses$1.getTypographyUtilityClass = getTypographyUtilityClass;
var _generateUtilityClasses$1K = _interopRequireDefault$89(generateUtilityClasses$3);
var _generateUtilityClass$1J = _interopRequireDefault$89(generateUtilityClass$3);
function getTypographyUtilityClass(slot) {
  return (0, _generateUtilityClass$1J.default)('MuiTypography', slot);
}
const typographyClasses = (0, _generateUtilityClasses$1K.default)('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);
typographyClasses$1.default = typographyClasses;

var _interopRequireDefault$88 = interopRequireDefault$1.exports;
Object.defineProperty(Typography$2, "__esModule", {
  value: true
});
Typography$2.default = Typography$2.TypographyRoot = void 0;
var _objectWithoutPropertiesLoose2$1$ = _interopRequireDefault$88(objectWithoutPropertiesLoose.exports);
var _extends2$2c = _interopRequireDefault$88(_extends$19.exports);
var React$2u = _interopRequireWildcard$3T(React__default$4);
var _propTypes$2G = _interopRequireDefault$88(propTypes.exports);
var _clsx$2d = _interopRequireDefault$88(clsx.exports);
var _styleFunctionSx$3 = styleFunctionSx;
var _composeClasses$1G = _interopRequireDefault$88(composeClasses$2);
var _styled$1B = _interopRequireDefault$88(styled$2);
var _DefaultPropsProvider$1H = DefaultPropsProvider$5;
var _capitalize$J = _interopRequireDefault$88(capitalize$1);
var _typographyClasses = typographyClasses$1;
var _jsxRuntime$2x = require$$11;
const _excluded$2t = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];
function _getRequireWildcardCache$3C(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3C = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3T(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3C(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1H = ownerState => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, ownerState.align !== 'inherit' && `align${(0, _capitalize$J.default)(align)}`, gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
  };
  return (0, _composeClasses$1G.default)(slots, _typographyClasses.getTypographyUtilityClass, classes);
};
const TypographyRoot = Typography$2.TypographyRoot = (0, _styled$1B.default)('span', {
  name: 'MuiTypography',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles[`align${(0, _capitalize$J.default)(ownerState.align)}`], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$2c.default)({
  margin: 0
}, ownerState.variant === 'inherit' && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: 'inherit'
}, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, ownerState.gutterBottom && {
  marginBottom: '0.35em'
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  inherit: 'p'
};

// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const colorTransformations$1 = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
const transformDeprecatedColors$1 = color => {
  return colorTransformations$1[color] || color;
};
const Typography$1 = /*#__PURE__*/React$2u.forwardRef(function Typography(inProps, ref) {
  const themeProps = (0, _DefaultPropsProvider$1H.useDefaultProps)({
    props: inProps,
    name: 'MuiTypography'
  });
  const color = transformDeprecatedColors$1(themeProps.color);
  const props = (0, _styleFunctionSx$3.extendSxProp)((0, _extends2$2c.default)({}, themeProps, {
    color
  }));
  const {
      align = 'inherit',
      className,
      component,
      gutterBottom = false,
      noWrap = false,
      paragraph = false,
      variant = 'body1',
      variantMapping = defaultVariantMapping
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1$.default)(props, _excluded$2t);
  const ownerState = (0, _extends2$2c.default)({}, props, {
    align,
    color,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });
  const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  const classes = useUtilityClasses$1H(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2x.jsx)(TypographyRoot, (0, _extends2$2c.default)({
    as: Component,
    ref: ref,
    ownerState: ownerState,
    className: (0, _clsx$2d.default)(classes.root, className)
  }, other));
});
process.env.NODE_ENV !== "production" ? Typography$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: _propTypes$2G.default.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  /**
   * The content of the component.
   */
  children: _propTypes$2G.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2G.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2G.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2G.default.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: _propTypes$2G.default.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: _propTypes$2G.default.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: _propTypes$2G.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2G.default.oneOfType([_propTypes$2G.default.arrayOf(_propTypes$2G.default.oneOfType([_propTypes$2G.default.func, _propTypes$2G.default.object, _propTypes$2G.default.bool])), _propTypes$2G.default.func, _propTypes$2G.default.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: _propTypes$2G.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2G.default.oneOf(['body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'overline', 'subtitle1', 'subtitle2']), _propTypes$2G.default.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: _propTypes$2G.default /* @typescript-to-proptypes-ignore */.object
} : void 0;
Typography$2.default = Typography$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  typographyClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Typography.default;
  }
});
Object.defineProperty(exports, "typographyClasses", {
  enumerable: true,
  get: function () {
    return _typographyClasses.default;
  }
});
var _Typography = _interopRequireDefault(Typography$2);
var _typographyClasses = _interopRequireWildcard(typographyClasses$1);
Object.keys(_typographyClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _typographyClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _typographyClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Typography$3));

var Typography = /*@__PURE__*/getDefaultExportFromCjs$1(Typography$3);

var ExpandMore = {};

var createSvgIcon = {};

(function (exports) {
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _utils.createSvgIcon;
  }
});
var _utils = utils$6;
}(createSvgIcon));

var _interopRequireDefault$87 = interopRequireDefault$1.exports;
Object.defineProperty(ExpandMore, "__esModule", {
  value: true
});
var default_1$1 = ExpandMore.default = void 0;
var _createSvgIcon$q = _interopRequireDefault$87(createSvgIcon);
var _jsxRuntime$2w = require$$11;
default_1$1 = ExpandMore.default = (0, _createSvgIcon$q.default)( /*#__PURE__*/(0, _jsxRuntime$2w.jsx)("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

const Accordion = (_a) => {
    var { children, title, disableExpandIcon } = _a, props = __rest$2(_a, ["children", "title", "disableExpandIcon"]);
    return (React__default$4.createElement(AccordionBasic, Object.assign({}, props),
        React__default$4.createElement(AccordionSummary, { expandIcon: !disableExpandIcon && React__default$4.createElement(default_1$1, null) }, typeof title === "string" ? React__default$4.createElement(Typography, null, title) : title),
        React__default$4.createElement(AccordionDetails, null,
            React__default$4.createElement("div", null, children))));
};

var button = {};

var lib$7 = {};

var ThemeProvider$3 = {};

var themrShape = {};

themrShape.__esModule = true;

var _propTypes$2F = propTypes.exports;

var _propTypes2$u = _interopRequireDefault$86(_propTypes$2F);

function _interopRequireDefault$86(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

themrShape.default = _propTypes2$u.default.shape({
  theme: _propTypes2$u.default.object.isRequired
});

ThemeProvider$3.__esModule = true;
ThemeProvider$3.default = undefined;

var _class, _temp;

var _react$20 = React__default$4;

var _propTypes$2E = propTypes.exports;

var _propTypes2$t = _interopRequireDefault$85(_propTypes$2E);

var _themrShape = themrShape;

var _themrShape2 = _interopRequireDefault$85(_themrShape);

function _interopRequireDefault$85(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$Z(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$O(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$O(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ThemeProvider$2 = (_temp = _class = function (_Component) {
  _inherits$O(ThemeProvider, _Component);

  function ThemeProvider() {
    _classCallCheck$Z(this, ThemeProvider);

    return _possibleConstructorReturn$O(this, _Component.apply(this, arguments));
  }

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    return {
      themr: {
        theme: this.props.theme
      }
    };
  };

  ThemeProvider.prototype.render = function render() {
    return _react$20.Children.only(this.props.children);
  };

  return ThemeProvider;
}(_react$20.Component), _class.propTypes = {
  children: _propTypes2$t.default.element.isRequired,
  theme: _propTypes2$t.default.object.isRequired
}, _class.defaultProps = {
  theme: {}
}, _class.childContextTypes = {
  themr: _themrShape2.default.isRequired
}, _temp);
ThemeProvider$3.default = ThemeProvider$2;

var themr = {};

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant$1 = function(condition, format, a, b, c, d, e, f) {
  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var browser = invariant$1;

themr.__esModule = true;

var _typeof$14 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

themr.themeable = themeable;

var _react$1$ = React__default$4;

var _react2$10 = _interopRequireDefault$84(_react$1$);

var _propTypes$2D = propTypes.exports;

var _propTypes2$s = _interopRequireDefault$84(_propTypes$2D);

var _hoistNonReactStatics = hoistNonReactStatics;

var _hoistNonReactStatics2 = _interopRequireDefault$84(_hoistNonReactStatics);

var _invariant = browser;

var _invariant2 = _interopRequireDefault$84(_invariant);

function _interopRequireDefault$84(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$E(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$Y(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$N(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$N(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @typedef {Object.<string, TReactCSSThemrTheme>} TReactCSSThemrTheme
 */

/**
 * @typedef {{}} TReactCSSThemrOptions
 * @property {String|Boolean} [composeTheme=COMPOSE_DEEPLY]
 */

var COMPOSE_DEEPLY = 'deeply';
var COMPOSE_SOFTLY = 'softly';
var DONT_COMPOSE = false;

var DEFAULT_OPTIONS$2 = {
  composeTheme: COMPOSE_DEEPLY,
  mapThemrProps: defaultMapThemrProps
};

var THEMR_CONFIG = typeof Symbol !== 'undefined' ? Symbol('THEMR_CONFIG') : '__REACT_CSS_THEMR_CONFIG__';

/**
 * Themr decorator
 * @param {String|Number|Symbol} componentName - Component name
 * @param {TReactCSSThemrTheme} [localTheme] - Base theme
 * @param {{}} [options] - Themr options
 * @returns {function(ThemedComponent:Function):Function} - ThemedComponent
 */

themr.default = function (componentName, localTheme) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return function (ThemedComponent) {
    var _class, _temp;

    var _DEFAULT_OPTIONS$opti = _extends$17({}, DEFAULT_OPTIONS$2, options),
        optionComposeTheme = _DEFAULT_OPTIONS$opti.composeTheme,
        optionMapThemrProps = _DEFAULT_OPTIONS$opti.mapThemrProps;

    validateComposeOption(optionComposeTheme);

    var config = ThemedComponent[THEMR_CONFIG];
    if (config && config.componentName === componentName) {
      config.localTheme = themeable(config.localTheme, localTheme);
      return ThemedComponent;
    }

    config = {
      componentName: componentName,
      localTheme: localTheme
    };

    /**
     * @property {{wrappedInstance: *}} refs
     */
    var Themed = (_temp = _class = function (_Component) {
      _inherits$N(Themed, _Component);

      function Themed() {
        _classCallCheck$Y(this, Themed);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn$N(this, _Component.call.apply(_Component, [this].concat(args)));

        _this.theme_ = _this.calcTheme(_this.props);
        return _this;
      }

      Themed.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2.default)(true, 'DEPRECATED: To access the wrapped instance, you have to pass ' + '{ innerRef: fn } and retrieve with a callback ref style.');

        return this.refs.wrappedInstance;
      };

      Themed.prototype.getNamespacedTheme = function getNamespacedTheme(props) {
        var themeNamespace = props.themeNamespace,
            theme = props.theme;

        if (!themeNamespace) return theme;
        if (themeNamespace && !theme) throw new Error('Invalid themeNamespace use in react-css-themr. ' + 'themeNamespace prop should be used only with theme prop.');

        return Object.keys(theme).filter(function (key) {
          return key.startsWith(themeNamespace);
        }).reduce(function (result, key) {
          var _extends2;

          return _extends$17({}, result, (_extends2 = {}, _extends2[removeNamespace$1(key, themeNamespace)] = theme[key], _extends2));
        }, {});
      };

      Themed.prototype.getThemeNotComposed = function getThemeNotComposed(props) {
        if (props.theme) return this.getNamespacedTheme(props);
        if (config.localTheme) return config.localTheme;
        return this.getContextTheme();
      };

      Themed.prototype.getContextTheme = function getContextTheme() {
        return this.context.themr ? this.context.themr.theme[config.componentName] : {};
      };

      Themed.prototype.getTheme = function getTheme(props) {
        return props.composeTheme === COMPOSE_SOFTLY ? _extends$17({}, this.getContextTheme(), config.localTheme, this.getNamespacedTheme(props)) : themeable(themeable(this.getContextTheme(), config.localTheme), this.getNamespacedTheme(props));
      };

      Themed.prototype.calcTheme = function calcTheme(props) {
        var composeTheme = props.composeTheme;

        return composeTheme ? this.getTheme(props) : this.getThemeNotComposed(props);
      };

      Themed.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (nextProps.composeTheme !== this.props.composeTheme || nextProps.theme !== this.props.theme || nextProps.themeNamespace !== this.props.themeNamespace) {
          this.theme_ = this.calcTheme(nextProps);
        }
      };

      Themed.prototype.render = function render() {
        return _react2$10.default.createElement(ThemedComponent, this.props.mapThemrProps(this.props, this.theme_));
      };

      return Themed;
    }(_react$1$.Component), _class.displayName = 'Themed' + ThemedComponent.name, _class.contextTypes = {
      themr: _propTypes2$s.default.object
    }, _class.propTypes = _extends$17({}, ThemedComponent.propTypes, {
      composeTheme: _propTypes2$s.default.oneOf([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE]),
      innerRef: _propTypes2$s.default.func,
      theme: _propTypes2$s.default.object,
      themeNamespace: _propTypes2$s.default.string,
      mapThemrProps: _propTypes2$s.default.func
    }), _class.defaultProps = _extends$17({}, ThemedComponent.defaultProps, {
      composeTheme: optionComposeTheme,
      mapThemrProps: optionMapThemrProps
    }), _temp);


    Themed[THEMR_CONFIG] = config;

    return (0, _hoistNonReactStatics2.default)(Themed, ThemedComponent);
  };
};

/**
 * Merges passed themes by concatenating string keys and processing nested themes
 *
 * @param {...TReactCSSThemrTheme} themes - Themes
 * @returns {TReactCSSThemrTheme} - Resulting theme
 */


function themeable() {
  for (var _len2 = arguments.length, themes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    themes[_key2] = arguments[_key2];
  }

  return themes.reduce(function (acc, theme) {
    return merge$4(acc, theme);
  }, {});
}

/**
 * @param {TReactCSSThemrTheme} [original] - Original theme
 * @param {TReactCSSThemrTheme} [mixin] - Mixin theme
 * @returns {TReactCSSThemrTheme} - resulting theme
 */
function merge$4() {
  var original = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  //make a copy to avoid mutations of nested objects
  //also strip all functions injected by isomorphic-style-loader
  var result = Object.keys(original).reduce(function (acc, key) {
    var value = original[key];
    if (typeof value !== 'function') {
      acc[key] = value;
    }
    return acc;
  }, {});

  //traverse mixin keys and merge them to resulting theme
  Object.keys(mixin).forEach(function (key) {
    //there's no need to set any defaults here
    var originalValue = result[key];
    var mixinValue = mixin[key];

    switch (typeof mixinValue === 'undefined' ? 'undefined' : _typeof$14(mixinValue)) {
      case 'object':
        {
          //possibly nested theme object
          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof$14(originalValue)) {
            case 'object':
              {
                //exactly nested theme object - go recursive
                result[key] = merge$4(originalValue, mixinValue);
                break;
              }

            case 'undefined':
              {
                //original does not contain this nested key - just take it as is
                result[key] = mixinValue;
                break;
              }

            default:
              {
                //can't merge an object with a non-object
                throw new Error('You are merging object ' + key + ' with a non-object ' + originalValue);
              }
          }
          break;
        }

      case 'undefined': //fallthrough - handles accidentally unset values which may come from props
      case 'function':
        {
          //this handles issue when isomorphic-style-loader addes helper functions to css-module
          break; //just skip
        }

      default:
        {
          //plain values
          switch (typeof originalValue === 'undefined' ? 'undefined' : _typeof$14(originalValue)) {
            case 'object':
              {
                //can't merge a non-object with an object
                throw new Error('You are merging non-object ' + mixinValue + ' with an object ' + key);
              }

            case 'undefined':
              {
                //mixin key is new to original theme - take it as is
                result[key] = mixinValue;
                break;
              }
            case 'function':
              {
                //this handles issue when isomorphic-style-loader addes helper functions to css-module
                break; //just skip
              }

            default:
              {
                //finally we can merge
                result[key] = originalValue.split(' ').concat(mixinValue.split(' ')).filter(function (item, pos, self) {
                  return self.indexOf(item) === pos && item !== '';
                }).join(' ');
                break;
              }
          }
          break;
        }
    }
  });

  return result;
}

/**
 * Validates compose option
 *
 * @param {String|Boolean} composeTheme - Compose them option
 * @throws
 * @returns {undefined}
 */
function validateComposeOption(composeTheme) {
  if ([COMPOSE_DEEPLY, COMPOSE_SOFTLY, DONT_COMPOSE].indexOf(composeTheme) === -1) {
    throw new Error('Invalid composeTheme option for react-css-themr. Valid composition options are ' + COMPOSE_DEEPLY + ', ' + COMPOSE_SOFTLY + ' and ' + DONT_COMPOSE + '. The given option was ' + composeTheme);
  }
}

/**
 * Removes namespace from key
 *
 * @param {String} key - Key
 * @param {String} themeNamespace - Theme namespace
 * @returns {String} - Key
 */
function removeNamespace$1(key, themeNamespace) {
  var capitalized = key.substr(themeNamespace.length);
  return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
}

/**
 * Maps props and theme to an object that will be used to pass down props to the
 * decorated component.
 *
 * @param {Object} ownProps - All props given to the decorated component
 * @param {Object} theme - Calculated then that should be passed down
 * @returns {Object} - Props that will be passed down to the decorated component
 */
function defaultMapThemrProps(ownProps, theme) {
  ownProps.composeTheme;
      var innerRef = ownProps.innerRef;
      ownProps.themeNamespace;
      ownProps.mapThemrProps;
      var rest = _objectWithoutProperties$E(ownProps, ['composeTheme', 'innerRef', 'themeNamespace', 'mapThemrProps']);

  return _extends$17({}, rest, {
    ref: innerRef,
    theme: theme
  });
}

(function (exports) {

exports.__esModule = true;

var _ThemeProvider = ThemeProvider$3;

Object.defineProperty(exports, 'ThemeProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ThemeProvider).default;
  }
});

var _themr = themr;

Object.defineProperty(exports, 'themr', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_themr).default;
  }
});
Object.defineProperty(exports, 'themeable', {
  enumerable: true,
  get: function get() {
    return _themr.themeable;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
}(lib$7));

var identifiers = {};

Object.defineProperty(identifiers, "__esModule", {
  value: true
});
identifiers.APP_BAR = 'RTAppBar';
identifiers.AUTOCOMPLETE = 'RTAutocomplete';
identifiers.AVATAR = 'RTAvatar';
identifiers.BUTTON = 'RTButton';
identifiers.CARD = 'RTCard';
identifiers.CHIP = 'RTChip';
identifiers.CHECKBOX = 'RTCheckbox';
identifiers.DATE_PICKER = 'RTDatePicker';
identifiers.DIALOG = 'RTDialog';
identifiers.DRAWER = 'RTDrawer';
identifiers.DROPDOWN = 'RTDropdown';
identifiers.INPUT = 'RTInput';
identifiers.LAYOUT = 'RTLayout';
identifiers.LINK = 'RTLink';
identifiers.LIST = 'RTList';
identifiers.MENU = 'RTMenu';
identifiers.NAVIGATION = 'RTNavigation';
identifiers.OVERLAY = 'RTOverlay';
identifiers.PROGRESS_BAR = 'RTProgressBar';
identifiers.RADIO = 'RTRadio';
identifiers.RIPPLE = 'RTRipple';
identifiers.SLIDER = 'RTSlider';
identifiers.SNACKBAR = 'RTSnackbar';
identifiers.SWITCH = 'RTSwitch';
identifiers.TABLE = 'RTTable';
identifiers.TABS = 'RTTabs';
identifiers.TOOLTIP = 'RTTooltip';
identifiers.TIME_PICKER = 'RTTimePicker';

var Button$6 = {};

var classnames$1 = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames$1));

var classNames$1 = classnames$1.exports;

var FontIcon$2 = {};

Object.defineProperty(FontIcon$2, "__esModule", {
  value: true
});
FontIcon$2.FontIcon = undefined;

var _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1_ = React__default$4;

var _react2$$ = _interopRequireDefault$83(_react$1_);

var _propTypes$2C = propTypes.exports;

var _propTypes2$r = _interopRequireDefault$83(_propTypes$2C);

var _classnames$1 = classnames$1.exports;

var _classnames2$5 = _interopRequireDefault$83(_classnames$1);

function _interopRequireDefault$83(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$D(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FontIcon$1 = function FontIcon(_ref) {
  var alt = _ref.alt,
      children = _ref.children,
      className = _ref.className;
      _ref.theme;
      var value = _ref.value,
      other = _objectWithoutProperties$D(_ref, ['alt', 'children', 'className', 'theme', 'value']);

  return (// eslint-disable-line
    _react2$$.default.createElement(
      'span',
      _extends$16({
        'data-react-toolbox': 'font-icon',
        'aria-label': alt,
        className: (0, _classnames2$5.default)({ 'material-icons': typeof value === 'string' || typeof children === 'string' }, className)
      }, other),
      value,
      children
    )
  );
};

FontIcon$1.propTypes = {
  alt: _propTypes2$r.default.string,
  children: _propTypes2$r.default.node,
  className: _propTypes2$r.default.string,
  theme: _propTypes2$r.default.object, // eslint-disable-line
  value: _propTypes2$r.default.oneOfType([_propTypes2$r.default.string, _propTypes2$r.default.element])
};

FontIcon$1.defaultProps = {
  alt: '',
  className: ''
};

FontIcon$2.default = FontIcon$1;
FontIcon$2.FontIcon = FontIcon$1;

var Ripple = {};

var _isPlaceholder$3 = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};

var _isPlaceholder$2 = _isPlaceholder$3;


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
var _curry1$6 = function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder$2(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
};

var _curry1$5 = _curry1$6;
var _isPlaceholder$1 = _isPlaceholder$3;


/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
var _curry2$4 = function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder$1(a) ? f2
             : _curry1$5(function(_b) { return fn(a, _b); });
      default:
        return _isPlaceholder$1(a) && _isPlaceholder$1(b) ? f2
             : _isPlaceholder$1(a) ? _curry1$5(function(_a) { return fn(_a, b); })
             : _isPlaceholder$1(b) ? _curry1$5(function(_b) { return fn(a, _b); })
             : fn(a, b);
    }
  };
};

var _curry2$3 = _curry2$4;


/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */
var dissoc = _curry2$3(function dissoc(prop, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  delete result[prop];
  return result;
});

var events = {};

var _has$2 = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};

var _has$1 = _has$2;


var _isArguments$1 = (function() {
  var toString = Object.prototype.toString;
  return toString.call(arguments) === '[object Arguments]' ?
    function _isArguments(x) { return toString.call(x) === '[object Arguments]'; } :
    function _isArguments(x) { return _has$1('callee', x); };
}());

var _curry1$4 = _curry1$6;
var _has = _has$2;
var _isArguments = _isArguments$1;


/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var keys$8 = (function() {
  // cover IE < 9 keys issues
  var hasEnumBug = !({toString: null}).propertyIsEnumerable('toString');
  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString',
                            'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
  // Safari bug
  var hasArgsEnumBug = (function() {
    return arguments.propertyIsEnumerable('length');
  }());

  var contains = function contains(list, item) {
    var idx = 0;
    while (idx < list.length) {
      if (list[idx] === item) {
        return true;
      }
      idx += 1;
    }
    return false;
  };

  return typeof Object.keys === 'function' && !hasArgsEnumBug ?
    _curry1$4(function keys(obj) {
      return Object(obj) !== obj ? [] : Object.keys(obj);
    }) :
    _curry1$4(function keys(obj) {
      if (Object(obj) !== obj) {
        return [];
      }
      var prop, nIdx;
      var ks = [];
      var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
      for (prop in obj) {
        if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
          ks[ks.length] = prop;
        }
      }
      if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while (nIdx >= 0) {
          prop = nonEnumerableProps[nIdx];
          if (_has(prop, obj) && !contains(ks, prop)) {
            ks[ks.length] = prop;
          }
          nIdx -= 1;
        }
      }
      return ks;
    });
}());

Object.defineProperty(events, "__esModule", {
  value: true
});

var _keys$1 = keys$8;

var _keys2$1 = _interopRequireDefault$82(_keys$1);

function _interopRequireDefault$82(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

events.default = {
  getMousePosition: function getMousePosition(event) {
    return {
      x: event.pageX - (window.scrollX || window.pageXOffset),
      y: event.pageY - (window.scrollY || window.pageYOffset)
    };
  },
  getTouchPosition: function getTouchPosition(event) {
    return {
      x: event.touches[0].pageX - (window.scrollX || window.pageXOffset),
      y: event.touches[0].pageY - (window.scrollY || window.pageYOffset)
    };
  },
  pauseEvent: function pauseEvent(event) {
    event.stopPropagation();
    event.preventDefault();
  },
  addEventsToDocument: function addEventsToDocument(eventMap) {
    Object.keys(eventMap).forEach(function (key) {
      document.addEventListener(key, eventMap[key], false);
    });
  },
  removeEventsFromDocument: function removeEventsFromDocument(eventMap) {
    Object.keys(eventMap).forEach(function (key) {
      document.removeEventListener(key, eventMap[key], false);
    });
  },
  targetIsDescendant: function targetIsDescendant(event, parent) {
    var node = event.target;
    while (node !== null) {
      if (node === parent) return true;
      node = node.parentNode;
    }
    return false;
  },
  addEventListenerOnTransitionEnded: function addEventListenerOnTransitionEnded(element, fn) {
    var eventName = transitionEventNamesFor(element);
    if (!eventName) return false;
    element.addEventListener(eventName, fn);
    return true;
  },
  removeEventListenerOnTransitionEnded: function removeEventListenerOnTransitionEnded(element, fn) {
    var eventName = transitionEventNamesFor(element);
    if (!eventName) return false;
    element.removeEventListener(eventName, fn);
    return true;
  }
};


var TRANSITIONS = {
  transition: 'transitionend',
  OTransition: 'oTransitionEnd',
  MozTransition: 'transitionend',
  WebkitTransition: 'webkitTransitionEnd'
};

function transitionEventNamesFor(element) {
  return (0, _keys2$1.default)(TRANSITIONS).reduce(function (result, transition) {
    return !result && element && element.style[transition] !== undefined ? TRANSITIONS[transition] : result;
  }, null);
}

var prefixer$1 = {};

Object.defineProperty(prefixer$1, "__esModule", {
  value: true
});
var WEBKIT = 'Webkit';
var MICROSOFT = 'Ms';

var properties = {
  transform: [WEBKIT, MICROSOFT]
};

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.substr(1);
}

function getPrefixes(property, value) {
  return properties[property].reduce(function (acc, item) {
    acc['' + item + capitalize(property)] = value; // eslint-disable-line no-param-reassign
    return acc;
  }, {});
}

function addPrefixesTo(style, property, value) {
  var vendor = getPrefixes(property, value);
  for (var prefix in vendor) {
    // eslint-disable-line no-restricted-syntax
    if ({}.hasOwnProperty.call(vendor, prefix)) {
      style[prefix] = vendor[prefix]; // eslint-disable-line no-param-reassign
    }
  }

  return style;
}

function prefixer(style) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _style = defaultValue;
  for (var property in style) {
    // eslint-disable-line no-restricted-syntax
    if ({}.hasOwnProperty.call(style, property)) {
      _style[property] = style[property];
      if (properties[property]) {
        addPrefixesTo(_style, property, style[property]);
      }
    }
  }

  return _style;
}

prefixer$1.default = prefixer;

Object.defineProperty(Ripple, "__esModule", {
  value: true
});

var _createClass$V = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1Z = React__default$4;

var _react2$_ = _interopRequireDefault$81(_react$1Z);

var _propTypes$2B = propTypes.exports;

var _propTypes2$q = _interopRequireDefault$81(_propTypes$2B);

var _reactDom$1 = require$$2$1;

var _reactDom2 = _interopRequireDefault$81(_reactDom$1);

var _classnames2$4 = classnames$1.exports;

var _classnames3$3 = _interopRequireDefault$81(_classnames2$4);

var _reactCssThemr$8 = lib$7;

var _dissoc = dissoc;

var _dissoc2 = _interopRequireDefault$81(_dissoc);

var _identifiers$8 = identifiers;

var _events = events;

var _events2 = _interopRequireDefault$81(_events);

var _prefixer = prefixer$1;

var _prefixer2 = _interopRequireDefault$81(_prefixer);

function _interopRequireDefault$81(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty$15(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$X(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$M(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$M(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties$C(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaults = {
  centered: false,
  className: '',
  multiple: true,
  passthrough: true,
  spread: 2,
  theme: {}
};

var rippleFactory = function rippleFactory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaults$options = _extends$15({}, defaults, options),
      defaultCentered = _defaults$options.centered,
      defaultClassName = _defaults$options.className,
      defaultMultiple = _defaults$options.multiple,
      defaultPassthrough = _defaults$options.passthrough,
      defaultSpread = _defaults$options.spread,
      defaultTheme = _defaults$options.theme,
      props = _objectWithoutProperties$C(_defaults$options, ['centered', 'className', 'multiple', 'passthrough', 'spread', 'theme']);

  return function (ComposedComponent) {
    var RippledComponent = function (_Component) {
      _inherits$M(RippledComponent, _Component);

      function RippledComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck$X(this, RippledComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn$M(this, (_ref = RippledComponent.__proto__ || Object.getPrototypeOf(RippledComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          ripples: {}
        }, _this.rippleNodes = {}, _this.doRipple = function () {
          return !_this.props.disabled && _this.props.ripple;
        }, _this.handleMouseDown = function (event) {
          if (_this.props.onMouseDown) _this.props.onMouseDown(event);
          if (_this.doRipple()) {
            var _events$getMousePosit = _events2.default.getMousePosition(event),
                x = _events$getMousePosit.x,
                y = _events$getMousePosit.y;

            _this.animateRipple(x, y, false);
          }
        }, _this.handleTouchStart = function (event) {
          if (_this.props.onTouchStart) _this.props.onTouchStart(event);
          if (_this.doRipple()) {
            var _events$getTouchPosit = _events2.default.getTouchPosition(event),
                x = _events$getTouchPosit.x,
                y = _events$getTouchPosit.y;

            _this.animateRipple(x, y, true);
          }
        }, _temp), _possibleConstructorReturn$M(_this, _ret);
      }

      _createClass$V(RippledComponent, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
          // If a new ripple was just added, add a remove event listener to its animation
          if (Object.keys(prevState.ripples).length < Object.keys(this.state.ripples).length) {
            this.addRippleRemoveEventListener(this.getLastKey());
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this2 = this;

          // Remove document event listeners for ripple if they still exists
          Object.keys(this.state.ripples).forEach(function (key) {
            _this2.state.ripples[key].endRipple();
          });
        }

        /**
         * Find out a descriptor object for the ripple element being created depending on
         * the position where the it was triggered and the component's dimensions.
         *
         * @param {Number} x Coordinate x in the viewport where ripple was triggered
         * @param {Number} y Coordinate y in the viewport where ripple was triggered
         * @return {Object} Descriptor element including position and size of the element
         */

      }, {
        key: 'getDescriptor',
        value: function getDescriptor(x, y) {
          var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this).getBoundingClientRect(),
              left = _ReactDOM$findDOMNode.left,
              top = _ReactDOM$findDOMNode.top,
              height = _ReactDOM$findDOMNode.height,
              width = _ReactDOM$findDOMNode.width;

          var _props = this.props,
              centered = _props.rippleCentered,
              spread = _props.rippleSpread;

          return {
            left: centered ? 0 : x - left - width / 2,
            top: centered ? 0 : y - top - height / 2,
            width: width * spread
          };
        }

        /**
         * Increments and internal counter and returns the next value as a string. It
         * is used to assign key references to new ripple elements.
         *
         * @return {String} Key to be assigned to a ripple.
         */

      }, {
        key: 'getNextKey',
        value: function getNextKey() {
          this.currentCount = this.currentCount ? this.currentCount + 1 : 1;
          return 'ripple' + this.currentCount;
        }

        /**
         * Return the last generated key for a ripple element. When there is only one ripple
         * and to get the reference when a ripple was just created.
         *
         * @return {String} The last generated ripple key.
         */

      }, {
        key: 'getLastKey',
        value: function getLastKey() {
          return 'ripple' + this.currentCount;
        }

        /**
         * Variable to store the ripple references
         */

      }, {
        key: 'rippleShouldTrigger',


        /**
         * Determine if a ripple should start depending if its a touch event. For mobile both
         * touchStart and mouseDown are launched so in case is touch we should always trigger
         * but if its not we should check if a touch was already triggered to decide.
         *
         * @param {Boolean} isTouch True in case a touch event triggered the ripple false otherwise.
         * @return {Boolean} True in case the ripple should trigger or false if it shouldn't.
         */
        value: function rippleShouldTrigger(isTouch) {
          var shouldStart = isTouch ? true : !this.touchCache;
          this.touchCache = isTouch;
          return shouldStart;
        }

        /**
         * Start a ripple animation on an specific point with touch or mouse events. First
         * decides if the animation should trigger. If the ripple is multiple or there is no
         * ripple present, it creates a new key. If it's a simple ripple and already exists,
         * it just restarts the current ripple. The animation happens in two state changes
         * to allow triggering via css.
         *
         * @param {Number} x Coordinate X on the screen where animation should start
         * @param {Number} y Coordinate Y on the screen where animation should start
         * @param {Boolean} isTouch Use events from touch or mouse.
         */

      }, {
        key: 'animateRipple',
        value: function animateRipple(x, y, isTouch) {
          var _this3 = this;

          if (this.rippleShouldTrigger(isTouch)) {
            var _getDescriptor = this.getDescriptor(x, y),
                top = _getDescriptor.top,
                left = _getDescriptor.left,
                width = _getDescriptor.width;

            var noRipplesActive = Object.keys(this.state.ripples).length === 0;
            var key = this.props.rippleMultiple || noRipplesActive ? this.getNextKey() : this.getLastKey();
            var endRipple = this.addRippleDeactivateEventListener(isTouch, key);
            var initialState = { active: false, restarting: true, top: top, left: left, width: width, endRipple: endRipple };
            var runningState = { active: true, restarting: false };
            var ripples = _extends$15({}, this.state.ripples, _defineProperty$15({}, key, initialState));
            this.setState({ ripples: ripples }, function () {
              if (_this3.rippleNodes[key]) _this3.rippleNodes[key].offsetWidth; // eslint-disable-line
              _this3.setState({ ripples: _extends$15({}, _this3.state.ripples, _defineProperty$15({}, key, Object.assign({}, _this3.state.ripples[key], runningState))) });
            });
          }
        }

        /**
         * Add an event listener to the reference with given key so when the animation transition
         * ends we can be sure that it finished and it can be safely removed from the state.
         * This function is called whenever a new ripple is added to the component.
         *
         * @param {String} rippleKey Is the key of the ripple to add the event.
         */

      }, {
        key: 'addRippleRemoveEventListener',
        value: function addRippleRemoveEventListener(rippleKey) {
          var self = this;
          var rippleNode = this.rippleNodes[rippleKey];
          _events2.default.addEventListenerOnTransitionEnded(rippleNode, function onOpacityEnd(e) {
            if (e.propertyName === 'opacity') {
              if (self.props.onRippleEnded) self.props.onRippleEnded(e);
              _events2.default.removeEventListenerOnTransitionEnded(self.rippleNodes[rippleKey], onOpacityEnd);
              // self.rippleNodes = dissoc(rippleKey, self.rippleNodes);
              delete self.rippleNodes[rippleKey];
              self.setState({ ripples: (0, _dissoc2.default)(rippleKey, self.state.ripples) });
            }
          });
        }

        /**
         * Add an event listener to the document needed to deactivate a ripple and make it dissappear.
         * Deactivation can happen with a touchend or mouseup depending on the trigger type. The
         * ending function is created from a factory function and returned.
         *
         * @param {Boolean} isTouch True in case the trigger was a touch event false otherwise.
         * @param {String} rippleKey It's a key to identify the ripple that should be deactivated.
         * @return {Function} Callback function that deactivates the ripple and removes the listener
         */

      }, {
        key: 'addRippleDeactivateEventListener',
        value: function addRippleDeactivateEventListener(isTouch, rippleKey) {
          var eventType = isTouch ? 'touchend' : 'mouseup';
          var endRipple = this.createRippleDeactivateCallback(eventType, rippleKey);
          document.addEventListener(eventType, endRipple);
          return endRipple;
        }

        /**
         * Generates a function that can be called to deactivate a ripple and remove its finishing
         * event listener. If is generated because we need to store it to be called on unmount in case
         * the ripple is still running.
         *
         * @param {String} eventType Is the event type that can be touchend or mouseup
         * @param {String} rippleKey Is the key representing the ripple
         * @return {Function} Callback function that deactivates the ripple and removes the listener
         */

      }, {
        key: 'createRippleDeactivateCallback',
        value: function createRippleDeactivateCallback(eventType, rippleKey) {
          var self = this;
          return function endRipple() {
            document.removeEventListener(eventType, endRipple);
            self.setState({ ripples: _extends$15({}, self.state.ripples, _defineProperty$15({}, rippleKey, Object.assign({}, self.state.ripples[rippleKey], { active: false }))) });
          };
        }
      }, {
        key: 'renderRipple',
        value: function renderRipple(key, className, _ref2) {
          var _classnames,
              _this4 = this;

          var active = _ref2.active,
              left = _ref2.left,
              restarting = _ref2.restarting,
              top = _ref2.top,
              width = _ref2.width;

          var scale = restarting ? 0 : 1;
          var transform = 'translate3d(' + (-width / 2 + left) + 'px, ' + (-width / 2 + top) + 'px, 0) scale(' + scale + ')';
          var _className = (0, _classnames3$3.default)(this.props.theme.ripple, (_classnames = {}, _defineProperty$15(_classnames, this.props.theme.rippleActive, active), _defineProperty$15(_classnames, this.props.theme.rippleRestarting, restarting), _classnames), className);
          return _react2$_.default.createElement(
            'span',
            _extends$15({ key: key, 'data-react-toolbox': 'ripple', className: this.props.theme.rippleWrapper }, props),
            _react2$_.default.createElement('span', {
              className: _className,
              ref: function ref(node) {
                if (node) _this4.rippleNodes[key] = node;
              },
              style: (0, _prefixer2.default)({ transform: transform }, { width: width, height: width })
            })
          );
        }
      }, {
        key: 'render',
        value: function render() {
          var _this5 = this;

          var _props2 = this.props,
              children = _props2.children,
              disabled = _props2.disabled,
              ripple = _props2.ripple;
              _props2.onRippleEnded;
              _props2.rippleCentered;
              var rippleClassName = _props2.rippleClassName;
              _props2.rippleMultiple;
              _props2.rippleSpread;
              var theme = _props2.theme,
              other = _objectWithoutProperties$C(_props2, ['children', 'disabled', 'ripple', 'onRippleEnded', 'rippleCentered', 'rippleClassName', 'rippleMultiple', 'rippleSpread', 'theme']);

          var ripples = this.state.ripples;

          var childRipples = Object.keys(ripples).map(function (key) {
            return _this5.renderRipple(key, rippleClassName, ripples[key]);
          });
          var childProps = _extends$15({
            onMouseDown: this.handleMouseDown,
            onTouchStart: this.handleTouchStart
          }, other);
          var finalProps = defaultPassthrough ? _extends$15({}, childProps, { theme: theme, disabled: disabled }) : childProps;

          return !ripple ? _react2$_.default.createElement(ComposedComponent, finalProps, children) : _react2$_.default.createElement(ComposedComponent, finalProps, [children, childRipples]);
        }
      }]);

      return RippledComponent;
    }(_react$1Z.Component);

    RippledComponent.propTypes = {
      children: _propTypes2$q.default.node,
      disabled: _propTypes2$q.default.bool,
      onMouseDown: _propTypes2$q.default.func,
      onRippleEnded: _propTypes2$q.default.func,
      onTouchStart: _propTypes2$q.default.func,
      ripple: _propTypes2$q.default.bool,
      rippleCentered: _propTypes2$q.default.bool,
      rippleClassName: _propTypes2$q.default.string,
      rippleMultiple: _propTypes2$q.default.bool,
      rippleSpread: _propTypes2$q.default.number,
      theme: _propTypes2$q.default.shape({
        ripple: _propTypes2$q.default.string,
        rippleActive: _propTypes2$q.default.string,
        rippleRestarting: _propTypes2$q.default.string,
        rippleWrapper: _propTypes2$q.default.string
      })
    };
    RippledComponent.defaultProps = {
      disabled: false,
      ripple: true,
      rippleCentered: defaultCentered,
      rippleClassName: defaultClassName,
      rippleMultiple: defaultMultiple,
      rippleSpread: defaultSpread
    };


    return (0, _reactCssThemr$8.themr)(_identifiers$8.RIPPLE, defaultTheme)(RippledComponent);
  };
};

Ripple.default = rippleFactory;

Object.defineProperty(Button$6, "__esModule", {
  value: true
});
Button$6.Button = Button$6.buttonFactory = undefined;

var _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$U = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1Y = React__default$4;

var _react2$Z = _interopRequireDefault$80(_react$1Y);

var _propTypes$2A = propTypes.exports;

var _propTypes2$p = _interopRequireDefault$80(_propTypes$2A);

var _classnames2$3 = classnames$1.exports;

var _classnames3$2 = _interopRequireDefault$80(_classnames2$3);

var _reactCssThemr$7 = lib$7;

var _identifiers$7 = identifiers;

var _FontIcon$8 = FontIcon$2;

var _FontIcon2$4 = _interopRequireDefault$80(_FontIcon$8);

var _Ripple$3 = Ripple;

var _Ripple2$3 = _interopRequireDefault$80(_Ripple$3);

function _interopRequireDefault$80(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty$14(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$B(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$W(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$L(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$L(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory$4 = function factory(ripple, FontIcon) {
  var Button = function (_Component) {
    _inherits$L(Button, _Component);

    function Button() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$W(this, Button);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$L(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
        if (_this.props.primary) return 'primary';
        if (_this.props.accent) return 'accent';
        return 'neutral';
      }, _this.getShape = function () {
        if (_this.props.raised) return 'raised';
        if (_this.props.floating) return 'floating';
        return 'flat';
      }, _this.handleMouseUp = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
      }, _this.handleMouseLeave = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
      }, _temp), _possibleConstructorReturn$L(_this, _ret);
    }

    _createClass$U(Button, [{
      key: 'render',
      value: function render() {
        var _classnames,
            _this2 = this;

        var _props = this.props;
            _props.accent;
            var children = _props.children,
            className = _props.className;
            _props.flat;
            _props.floating;
            var href = _props.href,
            icon = _props.icon,
            inverse = _props.inverse,
            label = _props.label,
            mini = _props.mini,
            neutral = _props.neutral;
            _props.primary;
            _props.raised;
            var theme = _props.theme,
            type = _props.type,
            others = _objectWithoutProperties$B(_props, ['accent', 'children', 'className', 'flat', 'floating', 'href', 'icon', 'inverse', 'label', 'mini', 'neutral', 'primary', 'raised', 'theme', 'type']);

        var element = href ? 'a' : 'button';
        var level = this.getLevel();
        var shape = this.getShape();
        var mouseEvents = {
          onMouseUp: this.handleMouseUp,
          onMouseLeave: this.handleMouseLeave
        };

        var classes = (0, _classnames3$2.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty$14(_classnames, theme[level], neutral), _defineProperty$14(_classnames, theme.mini, mini), _defineProperty$14(_classnames, theme.inverse, inverse), _classnames), className);

        var props = _extends$14({}, others, mouseEvents, {
          href: href,
          ref: function ref(node) {
            _this2.buttonNode = node;
          },
          className: classes,
          disabled: this.props.disabled,
          type: !href ? type : null,
          'data-react-toolbox': 'button'
        });

        var buttonElement = _react2$Z.default.createElement(element, props, icon ? _react2$Z.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, label, children);

        return others.onMouseEnter && this.props.disabled ? _react2$Z.default.createElement(
          'span',
          mouseEvents,
          buttonElement
        ) : buttonElement;
      }
    }]);

    return Button;
  }(_react$1Y.Component);

  Button.propTypes = {
    accent: _propTypes2$p.default.bool,
    children: _propTypes2$p.default.node,
    className: _propTypes2$p.default.string,
    disabled: _propTypes2$p.default.bool,
    flat: _propTypes2$p.default.bool,
    floating: _propTypes2$p.default.bool,
    href: _propTypes2$p.default.string,
    icon: _propTypes2$p.default.oneOfType([_propTypes2$p.default.string, _propTypes2$p.default.element]),
    inverse: _propTypes2$p.default.bool,
    label: _propTypes2$p.default.string,
    mini: _propTypes2$p.default.bool,
    neutral: _propTypes2$p.default.bool,
    onMouseLeave: _propTypes2$p.default.func,
    onMouseUp: _propTypes2$p.default.func,
    primary: _propTypes2$p.default.bool,
    raised: _propTypes2$p.default.bool,
    theme: _propTypes2$p.default.shape({
      accent: _propTypes2$p.default.string,
      button: _propTypes2$p.default.string,
      flat: _propTypes2$p.default.string,
      floating: _propTypes2$p.default.string,
      icon: _propTypes2$p.default.string,
      inverse: _propTypes2$p.default.string,
      mini: _propTypes2$p.default.string,
      neutral: _propTypes2$p.default.string,
      primary: _propTypes2$p.default.string,
      raised: _propTypes2$p.default.string,
      rippleWrapper: _propTypes2$p.default.string,
      toggle: _propTypes2$p.default.string
    }),
    type: _propTypes2$p.default.string
  };
  Button.defaultProps = {
    accent: false,
    className: '',
    flat: false,
    floating: false,
    mini: false,
    neutral: true,
    primary: false,
    raised: false,
    type: 'button'
  };


  return ripple(Button);
};

var Button$5 = factory$4((0, _Ripple2$3.default)({ centered: false }), _FontIcon2$4.default);
Button$6.default = (0, _reactCssThemr$7.themr)(_identifiers$7.BUTTON)(Button$5);
Button$6.buttonFactory = factory$4;
Button$6.Button = Button$5;

var BrowseButton$2 = {};

Object.defineProperty(BrowseButton$2, "__esModule", {
  value: true
});
BrowseButton$2.BrowseButton = BrowseButton$2.browseButtonFactory = undefined;

var _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$T = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1X = React__default$4;

var _react2$Y = _interopRequireDefault$7$(_react$1X);

var _propTypes$2z = propTypes.exports;

var _propTypes2$o = _interopRequireDefault$7$(_propTypes$2z);

var _classnames2$2 = classnames$1.exports;

var _classnames3$1 = _interopRequireDefault$7$(_classnames2$2);

var _reactCssThemr$6 = lib$7;

var _identifiers$6 = identifiers;

var _FontIcon$7 = FontIcon$2;

var _FontIcon2$3 = _interopRequireDefault$7$(_FontIcon$7);

var _Ripple$2 = Ripple;

var _Ripple2$2 = _interopRequireDefault$7$(_Ripple$2);

function _interopRequireDefault$7$(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty$13(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$A(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$V(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$K(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$K(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory$3 = function factory(ripple, FontIcon) {
  var SimpleBrowseButton = function (_Component) {
    _inherits$K(SimpleBrowseButton, _Component);

    function SimpleBrowseButton() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$V(this, SimpleBrowseButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$K(this, (_ref = SimpleBrowseButton.__proto__ || Object.getPrototypeOf(SimpleBrowseButton)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
        if (_this.props.primary) return 'primary';
        if (_this.props.accent) return 'accent';
        return 'neutral';
      }, _this.getShape = function () {
        if (_this.props.raised) return 'raised';
        if (_this.props.floating) return 'floating';
        return 'flat';
      }, _this.handleMouseUp = function (event) {
        _this.labelNode.blur();
        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
      }, _this.handleMouseLeave = function (event) {
        _this.labelNode.blur();
        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
      }, _this.handleFileChange = function (event) {
        if (_this.props.onChange) _this.props.onChange(event);
      }, _temp), _possibleConstructorReturn$K(_this, _ret);
    }

    _createClass$T(SimpleBrowseButton, [{
      key: 'render',
      value: function render() {
        var _classnames,
            _this2 = this;

        var _props = this.props;
            _props.accent;
            var accept = _props.accept,
            children = _props.children,
            className = _props.className;
            _props.flat;
            _props.floating;
            var icon = _props.icon,
            inverse = _props.inverse,
            label = _props.label,
            mini = _props.mini,
            multiple = _props.multiple,
            neutral = _props.neutral;
            _props.primary;
            _props.raised;
            var theme = _props.theme,
            others = _objectWithoutProperties$A(_props, ['accent', 'accept', 'children', 'className', 'flat', 'floating', 'icon', 'inverse', 'label', 'mini', 'multiple', 'neutral', 'primary', 'raised', 'theme']);

        var element = 'label';
        var level = this.getLevel();
        var shape = this.getShape();

        var classes = (0, _classnames3$1.default)(theme.button, [theme[shape]], (_classnames = {}, _defineProperty$13(_classnames, theme[level], neutral), _defineProperty$13(_classnames, theme.mini, mini), _defineProperty$13(_classnames, theme.inverse, inverse), _classnames), className);

        var props = _extends$13({}, others, {
          ref: function ref(node) {
            _this2.labelNode = node;
          },
          onChange: null,
          className: classes,
          disabled: this.props.disabled,
          onMouseUp: this.handleMouseUp,
          onMouseLeave: this.handleMouseLeave,
          'data-react-toolbox': 'label'
        });

        return _react2$Y.default.createElement(element, props, icon ? _react2$Y.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null, _react2$Y.default.createElement(
          'span',
          null,
          label
        ), _react2$Y.default.createElement('input', {
          className: classes,
          type: 'file',
          accept: accept,
          multiple: multiple,
          onChange: this.handleFileChange
        }), children);
      }
    }]);

    return SimpleBrowseButton;
  }(_react$1X.Component);

  SimpleBrowseButton.propTypes = {
    accent: _propTypes2$o.default.bool,
    accept: _propTypes2$o.default.string,
    children: _propTypes2$o.default.node,
    className: _propTypes2$o.default.string,
    disabled: _propTypes2$o.default.bool,
    flat: _propTypes2$o.default.bool,
    floating: _propTypes2$o.default.bool,
    icon: _propTypes2$o.default.oneOfType([_propTypes2$o.default.string, _propTypes2$o.default.element]),
    inverse: _propTypes2$o.default.bool,
    label: _propTypes2$o.default.string,
    mini: _propTypes2$o.default.bool,
    multiple: _propTypes2$o.default.bool,
    neutral: _propTypes2$o.default.bool,
    onChange: _propTypes2$o.default.func,
    onMouseLeave: _propTypes2$o.default.func,
    onMouseUp: _propTypes2$o.default.func,
    primary: _propTypes2$o.default.bool,
    raised: _propTypes2$o.default.bool,
    theme: _propTypes2$o.default.shape({
      accent: _propTypes2$o.default.string,
      button: _propTypes2$o.default.string,
      flat: _propTypes2$o.default.string,
      floating: _propTypes2$o.default.string,
      icon: _propTypes2$o.default.string,
      inverse: _propTypes2$o.default.string,
      mini: _propTypes2$o.default.string,
      neutral: _propTypes2$o.default.string,
      primary: _propTypes2$o.default.string,
      raised: _propTypes2$o.default.string,
      rippleWrapper: _propTypes2$o.default.string,
      toggle: _propTypes2$o.default.string
    }),
    type: _propTypes2$o.default.string
  };
  SimpleBrowseButton.defaultProps = {
    accent: false,
    accept: '*/*',
    className: '',
    flat: false,
    floating: false,
    mini: false,
    multiple: false,
    neutral: true,
    primary: false,
    raised: false
  };


  return ripple(SimpleBrowseButton);
};

var BrowseButton$1 = factory$3((0, _Ripple2$2.default)({ centered: false }), _FontIcon2$3.default);
BrowseButton$2.default = (0, _reactCssThemr$6.themr)(_identifiers$6.BUTTON)(BrowseButton$1);
BrowseButton$2.browseButtonFactory = factory$3;
BrowseButton$2.BrowseButton = BrowseButton$1;

var IconButton$7 = {};

Object.defineProperty(IconButton$7, "__esModule", {
  value: true
});
IconButton$7.IconButton = IconButton$7.iconButtonFactory = undefined;

var _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$S = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1W = React__default$4;

var _react2$X = _interopRequireDefault$7_(_react$1W);

var _propTypes$2y = propTypes.exports;

var _propTypes2$n = _interopRequireDefault$7_(_propTypes$2y);

var _classnames2$1 = classnames$1.exports;

var _classnames3 = _interopRequireDefault$7_(_classnames2$1);

var _reactCssThemr$5 = lib$7;

var _identifiers$5 = identifiers;

var _FontIcon$6 = FontIcon$2;

var _FontIcon2$2 = _interopRequireDefault$7_(_FontIcon$6);

var _Ripple$1 = Ripple;

var _Ripple2$1 = _interopRequireDefault$7_(_Ripple$1);

function _interopRequireDefault$7_(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty$12(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$z(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$U(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$J(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$J(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory$2 = function factory(ripple, FontIcon) {
  var IconButton = function (_Component) {
    _inherits$J(IconButton, _Component);

    function IconButton() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$U(this, IconButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$J(this, (_ref = IconButton.__proto__ || Object.getPrototypeOf(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.getLevel = function () {
        if (_this.props.primary) return 'primary';
        if (_this.props.accent) return 'accent';
        return 'neutral';
      }, _this.handleMouseUp = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseUp) _this.props.onMouseUp(event);
      }, _this.handleMouseLeave = function (event) {
        _this.buttonNode.blur();
        if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
      }, _temp), _possibleConstructorReturn$J(_this, _ret);
    }

    _createClass$S(IconButton, [{
      key: 'render',
      value: function render() {
        var _classnames,
            _this2 = this;

        var _props = this.props;
            _props.accent;
            var children = _props.children,
            className = _props.className,
            href = _props.href,
            icon = _props.icon,
            inverse = _props.inverse,
            neutral = _props.neutral;
            _props.primary;
            var theme = _props.theme,
            type = _props.type,
            others = _objectWithoutProperties$z(_props, ['accent', 'children', 'className', 'href', 'icon', 'inverse', 'neutral', 'primary', 'theme', 'type']);

        var element = href ? 'a' : 'button';
        var level = this.getLevel();
        var classes = (0, _classnames3.default)([theme.toggle], (_classnames = {}, _defineProperty$12(_classnames, theme[level], neutral), _defineProperty$12(_classnames, theme.inverse, inverse), _classnames), className);

        var props = _extends$12({}, others, {
          href: href,
          ref: function ref(node) {
            _this2.buttonNode = node;
          },
          className: classes,
          disabled: this.props.disabled,
          onMouseUp: this.handleMouseUp,
          onMouseLeave: this.handleMouseLeave,
          type: !href ? type : null,
          'data-react-toolbox': 'button'
        });

        var iconElement = typeof icon === 'string' ? _react2$X.default.createElement(FontIcon, { className: theme.icon, value: icon }) : icon;

        return _react2$X.default.createElement(element, props, icon && iconElement, children);
      }
    }]);

    return IconButton;
  }(_react$1W.Component);

  IconButton.propTypes = {
    accent: _propTypes2$n.default.bool,
    children: _propTypes2$n.default.node,
    className: _propTypes2$n.default.string,
    disabled: _propTypes2$n.default.bool,
    href: _propTypes2$n.default.string,
    icon: _propTypes2$n.default.oneOfType([_propTypes2$n.default.string, _propTypes2$n.default.element]),
    inverse: _propTypes2$n.default.bool,
    neutral: _propTypes2$n.default.bool,
    onMouseLeave: _propTypes2$n.default.func,
    onMouseUp: _propTypes2$n.default.func,
    primary: _propTypes2$n.default.bool,
    theme: _propTypes2$n.default.shape({
      accent: _propTypes2$n.default.string,
      button: _propTypes2$n.default.string,
      flat: _propTypes2$n.default.string,
      floating: _propTypes2$n.default.string,
      icon: _propTypes2$n.default.string,
      inverse: _propTypes2$n.default.string,
      mini: _propTypes2$n.default.string,
      neutral: _propTypes2$n.default.string,
      primary: _propTypes2$n.default.string,
      raised: _propTypes2$n.default.string,
      rippleWrapper: _propTypes2$n.default.string,
      toggle: _propTypes2$n.default.string
    }),
    type: _propTypes2$n.default.string
  };
  IconButton.defaultProps = {
    accent: false,
    className: '',
    neutral: true,
    primary: false,
    type: 'button'
  };


  return ripple(IconButton);
};

var IconButton$6 = factory$2((0, _Ripple2$1.default)({ centered: true }), _FontIcon2$2.default);
IconButton$7.default = (0, _reactCssThemr$5.themr)(_identifiers$5.BUTTON)(IconButton$6);
IconButton$7.iconButtonFactory = factory$2;
IconButton$7.IconButton = IconButton$6;

var ripple = {};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1v = ":root {\n  --color-divider: var(--palette-grey-200);\n  --color-background: var(--color-white);\n  --color-text: var(--palette-grey-900);\n  --color-text-secondary: var(--palette-grey-600);\n\n  --color-primary: var(--palette-indigo-500);\n  --color-primary-dark: var(--palette-indigo-700);\n  --color-accent: var(--palette-pink-a200);\n  --color-accent-dark: var(--palette-pink-700);\n  --color-primary-contrast: var(--color-dark-contrast);\n  --color-accent-contrast: var(--color-dark-contrast);\n\n  --unit: 10px;\n\n  --preferred-font: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  --font-size: calc(1.6 * var(--unit));\n  --font-size-tiny: calc(1.2 * var(--unit));\n  --font-size-small: calc(1.4 * var(--unit));\n  --font-size-normal: var(--font-size);\n  --font-size-big: calc(1.8 * var(--unit));\n  --font-weight-thin: 300;\n  --font-weight-normal: 400;\n  --font-weight-semi-bold: 500;\n  --font-weight-bold: 700;\n\n  --shadow-2p:\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-3p:\n    0 3px 4px 0 rgba(0, 0, 0, 0.14),\n    0 3px 3px -2px rgba(0, 0, 0, 0.2),\n    0 1px 8px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-4p:\n    0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12),\n    0 2px 4px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-6p:\n    0 6px 10px 0 rgba(0, 0, 0, 0.14),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-8p:\n    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12),\n    0 5px 5px -3px rgba(0, 0, 0, 0.2);\n\n  --shadow-16p:\n    0 16px 24px 2px rgba(0, 0, 0, 0.14),\n    0 6px 30px 5px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba(0, 0, 0, 0.2);\n\n  --shadow-key-umbra-opacity: 0.2;\n  --shadow-key-penumbra-opacity: 0.14;\n  --shadow-ambient-shadow-opacity: 0.12;\n\n  --zdepth-shadow-1: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);\n  --zdepth-shadow-2: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-3: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-4: 0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22);\n  --zdepth-shadow-5: 0 19px 60px rgba(0, 0, 0, 0.3), 0 15px 20px rgba(0, 0, 0, 0.22);\n\n  --animation-duration: 0.35s;\n  --animation-delay: calc(var(--animation-duration) / 5);\n  --animation-curve-fast-out-slow-in: cubic-bezier(0.4, 0, 0.2, 1);\n  --animation-curve-linear-out-slow-in: cubic-bezier(0, 0, 0.2, 1);\n  --animation-curve-fast-out-linear-in: cubic-bezier(0.4, 0, 1, 1);\n  --animation-curve-default: var(--animation-curve-fast-out-slow-in);\n\n  --z-index-highest: 300;\n  --z-index-higher: 200;\n  --z-index-high: 100;\n  --z-index-normal: 1;\n  --z-index-low: -100;\n  --z-index-lower: -200\n}\n:root {\n  --ripple-duration: 800ms;\n  --ripple-final-opacity: 0.3;\n  --ripple-size: calc(15 * var(--unit));\n}\n.theme_rippleWrapper__M-wG1 {\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--z-index-normal);\n}\n.theme_ripple__pKSMq {\n  background-color: currentColor;\n  border-radius: 50%;\n  left: 50%;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform-origin: 50% 50%;\n  transition-duration: var(--ripple-duration);\n  z-index: var(--z-index-high)\n}\n.theme_ripple__pKSMq.theme_rippleRestarting__-ebMd {\n  opacity: var(--ripple-final-opacity);\n  transition-property: none;\n}\n.theme_ripple__pKSMq.theme_rippleActive__JUave {\n  opacity: var(--ripple-final-opacity);\n  transition-property: transform;\n}\n.theme_ripple__pKSMq:not(.theme_rippleActive__JUave):not(.theme_rippleRestarting__-ebMd) {\n  opacity: 0;\n  transition-property: opacity, transform;\n}\n";
var theme$8 = {"rippleWrapper":"theme_rippleWrapper__M-wG1","ripple":"theme_ripple__pKSMq","rippleRestarting":"theme_rippleRestarting__-ebMd","rippleActive":"theme_rippleActive__JUave"};
var stylesheet$3=":root {\n  --color-divider: var(--palette-grey-200);\n  --color-background: var(--color-white);\n  --color-text: var(--palette-grey-900);\n  --color-text-secondary: var(--palette-grey-600);\n\n  --color-primary: var(--palette-indigo-500);\n  --color-primary-dark: var(--palette-indigo-700);\n  --color-accent: var(--palette-pink-a200);\n  --color-accent-dark: var(--palette-pink-700);\n  --color-primary-contrast: var(--color-dark-contrast);\n  --color-accent-contrast: var(--color-dark-contrast);\n\n  --unit: 10px;\n\n  --preferred-font: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  --font-size: calc(1.6 * var(--unit));\n  --font-size-tiny: calc(1.2 * var(--unit));\n  --font-size-small: calc(1.4 * var(--unit));\n  --font-size-normal: var(--font-size);\n  --font-size-big: calc(1.8 * var(--unit));\n  --font-weight-thin: 300;\n  --font-weight-normal: 400;\n  --font-weight-semi-bold: 500;\n  --font-weight-bold: 700;\n\n  --shadow-2p:\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-3p:\n    0 3px 4px 0 rgba(0, 0, 0, 0.14),\n    0 3px 3px -2px rgba(0, 0, 0, 0.2),\n    0 1px 8px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-4p:\n    0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12),\n    0 2px 4px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-6p:\n    0 6px 10px 0 rgba(0, 0, 0, 0.14),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-8p:\n    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12),\n    0 5px 5px -3px rgba(0, 0, 0, 0.2);\n\n  --shadow-16p:\n    0 16px 24px 2px rgba(0, 0, 0, 0.14),\n    0 6px 30px 5px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba(0, 0, 0, 0.2);\n\n  --shadow-key-umbra-opacity: 0.2;\n  --shadow-key-penumbra-opacity: 0.14;\n  --shadow-ambient-shadow-opacity: 0.12;\n\n  --zdepth-shadow-1: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);\n  --zdepth-shadow-2: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-3: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-4: 0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22);\n  --zdepth-shadow-5: 0 19px 60px rgba(0, 0, 0, 0.3), 0 15px 20px rgba(0, 0, 0, 0.22);\n\n  --animation-duration: 0.35s;\n  --animation-delay: calc(var(--animation-duration) / 5);\n  --animation-curve-fast-out-slow-in: cubic-bezier(0.4, 0, 0.2, 1);\n  --animation-curve-linear-out-slow-in: cubic-bezier(0, 0, 0.2, 1);\n  --animation-curve-fast-out-linear-in: cubic-bezier(0.4, 0, 1, 1);\n  --animation-curve-default: var(--animation-curve-fast-out-slow-in);\n\n  --z-index-highest: 300;\n  --z-index-higher: 200;\n  --z-index-high: 100;\n  --z-index-normal: 1;\n  --z-index-low: -100;\n  --z-index-lower: -200\n}\n:root {\n  --ripple-duration: 800ms;\n  --ripple-final-opacity: 0.3;\n  --ripple-size: calc(15 * var(--unit));\n}\n.theme_rippleWrapper__M-wG1 {\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--z-index-normal);\n}\n.theme_ripple__pKSMq {\n  background-color: currentColor;\n  border-radius: 50%;\n  left: 50%;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform-origin: 50% 50%;\n  transition-duration: var(--ripple-duration);\n  z-index: var(--z-index-high)\n}\n.theme_ripple__pKSMq.theme_rippleRestarting__-ebMd {\n  opacity: var(--ripple-final-opacity);\n  transition-property: none;\n}\n.theme_ripple__pKSMq.theme_rippleActive__JUave {\n  opacity: var(--ripple-final-opacity);\n  transition-property: transform;\n}\n.theme_ripple__pKSMq:not(.theme_rippleActive__JUave):not(.theme_rippleRestarting__-ebMd) {\n  opacity: 0;\n  transition-property: opacity, transform;\n}\n";
styleInject(css_248z$1v);

var theme$9 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': theme$8,
  stylesheet: stylesheet$3
});

var require$$1$1 = /*@__PURE__*/getAugmentedNamespace(theme$9);

Object.defineProperty(ripple, "__esModule", {
  value: true
});

var _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Ripple = Ripple;

var _Ripple2 = _interopRequireDefault$7Z(_Ripple);

var _theme$4 = require$$1$1;

var _theme2$3 = _interopRequireDefault$7Z(_theme$4);

function _interopRequireDefault$7Z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ripple.default = function (options) {
  return (0, _Ripple2.default)(_extends$11({}, options, { theme: _theme2$3.default }));
};

var css_248z$1u = ":root {\n  --palette-red-50: rgb(255, 235, 238);\n  --palette-red-100: rgb(255, 205, 210);\n  --palette-red-200: rgb(239, 154, 154);\n  --palette-red-300: rgb(229, 115, 115);\n  --palette-red-400: rgb(239, 83, 80);\n  --palette-red-500: rgb(244, 67, 54);\n  --palette-red-600: rgb(229, 57, 53);\n  --palette-red-700: rgb(211, 47, 47);\n  --palette-red-800: rgb(198, 40, 40);\n  --palette-red-900: rgb(183, 28, 28);\n  --palette-red-a100: rgb(255, 138, 128);\n  --palette-red-a200: rgb(255, 82, 82);\n  --palette-red-a400: rgb(255, 23, 68);\n  --palette-red-a700: rgb(213, 0, 0);\n\n  --palette-pink-50: rgb(252, 228, 236);\n  --palette-pink-100: rgb(248, 187, 208);\n  --palette-pink-200: rgb(244, 143, 177);\n  --palette-pink-300: rgb(240, 98, 146);\n  --palette-pink-400: rgb(236, 64, 122);\n  --palette-pink-500: rgb(233, 30, 99);\n  --palette-pink-600: rgb(216, 27, 96);\n  --palette-pink-700: rgb(194, 24, 91);\n  --palette-pink-800: rgb(173, 20, 87);\n  --palette-pink-900: rgb(136, 14, 79);\n  --palette-pink-a100: rgb(255, 128, 171);\n  --palette-pink-a200: rgb(255, 64, 129);\n  --palette-pink-a400: rgb(245, 0, 87);\n  --palette-pink-a700: rgb(197, 17, 98);\n\n  --palette-purple-50: rgb(243, 229, 245);\n  --palette-purple-100: rgb(225, 190, 231);\n  --palette-purple-200: rgb(206, 147, 216);\n  --palette-purple-300: rgb(186, 104, 200);\n  --palette-purple-400: rgb(171, 71, 188);\n  --palette-purple-500: rgb(156, 39, 176);\n  --palette-purple-600: rgb(142, 36, 170);\n  --palette-purple-700: rgb(123, 31, 162);\n  --palette-purple-800: rgb(106, 27, 154);\n  --palette-purple-900: rgb(74, 20, 140);\n  --palette-purple-a100: rgb(234, 128, 252);\n  --palette-purple-a200: rgb(224, 64, 251);\n  --palette-purple-a400: rgb(213, 0, 249);\n  --palette-purple-a700: rgb(170, 0, 255);\n\n  --palette-deep-purple-50: rgb(237, 231, 246);\n  --palette-deep-purple-100: rgb(209, 196, 233);\n  --palette-deep-purple-200: rgb(179, 157, 219);\n  --palette-deep-purple-300: rgb(149, 117, 205);\n  --palette-deep-purple-400: rgb(126, 87, 194);\n  --palette-deep-purple-500: rgb(103, 58, 183);\n  --palette-deep-purple-600: rgb(94, 53, 177);\n  --palette-deep-purple-700: rgb(81, 45, 168);\n  --palette-deep-purple-800: rgb(69, 39, 160);\n  --palette-deep-purple-900: rgb(49, 27, 146);\n  --palette-deep-purple-a100: rgb(179, 136, 255);\n  --palette-deep-purple-a200: rgb(124, 77, 255);\n  --palette-deep-purple-a400: rgb(101, 31, 255);\n  --palette-deep-purple-a700: rgb(98, 0, 234);\n\n  --palette-indigo-50: rgb(232, 234, 246);\n  --palette-indigo-100: rgb(197, 202, 233);\n  --palette-indigo-200: rgb(159, 168, 218);\n  --palette-indigo-300: rgb(121, 134, 203);\n  --palette-indigo-400: rgb(92, 107, 192);\n  --palette-indigo-500: rgb(63, 81, 181);\n  --palette-indigo-600: rgb(57, 73, 171);\n  --palette-indigo-700: rgb(48, 63, 159);\n  --palette-indigo-800: rgb(40, 53, 147);\n  --palette-indigo-900: rgb(26, 35, 126);\n  --palette-indigo-a100: rgb(140, 158, 255);\n  --palette-indigo-a200: rgb(83, 109, 254);\n  --palette-indigo-a400: rgb(61, 90, 254);\n  --palette-indigo-a700: rgb(48, 79, 254);\n\n  --palette-blue-50: rgb(227, 242, 253);\n  --palette-blue-100: rgb(187, 222, 251);\n  --palette-blue-200: rgb(144, 202, 249);\n  --palette-blue-300: rgb(100, 181, 246);\n  --palette-blue-400: rgb(66, 165, 245);\n  --palette-blue-500: rgb(33, 150, 243);\n  --palette-blue-600: rgb(30, 136, 229);\n  --palette-blue-700: rgb(25, 118, 210);\n  --palette-blue-800: rgb(21, 101, 192);\n  --palette-blue-900: rgb(13, 71, 161);\n  --palette-blue-a100: rgb(130, 177, 255);\n  --palette-blue-a200: rgb(68, 138, 255);\n  --palette-blue-a400: rgb(41, 121, 255);\n  --palette-blue-a700: rgb(41, 98, 255);\n\n  --palette-light-blue-50: rgb(225, 245, 254);\n  --palette-light-blue-100: rgb(179, 229, 252);\n  --palette-light-blue-200: rgb(129, 212, 250);\n  --palette-light-blue-300: rgb(79, 195, 247);\n  --palette-light-blue-400: rgb(41, 182, 246);\n  --palette-light-blue-500: rgb(3, 169, 244);\n  --palette-light-blue-600: rgb(3, 155, 229);\n  --palette-light-blue-700: rgb(2, 136, 209);\n  --palette-light-blue-800: rgb(2, 119, 189);\n  --palette-light-blue-900: rgb(1, 87, 155);\n  --palette-light-blue-a100: rgb(128, 216, 255);\n  --palette-light-blue-a200: rgb(64, 196, 255);\n  --palette-light-blue-a400: rgb(0, 176, 255);\n  --palette-light-blue-a700: rgb(0, 145, 234);\n\n  --palette-cyan-50: rgb(224, 247, 250);\n  --palette-cyan-100: rgb(178, 235, 242);\n  --palette-cyan-200: rgb(128, 222, 234);\n  --palette-cyan-300: rgb(77, 208, 225);\n  --palette-cyan-400: rgb(38, 198, 218);\n  --palette-cyan-500: rgb(0, 188, 212);\n  --palette-cyan-600: rgb(0, 172, 193);\n  --palette-cyan-700: rgb(0, 151, 167);\n  --palette-cyan-800: rgb(0, 131, 143);\n  --palette-cyan-900: rgb(0, 96, 100);\n  --palette-cyan-a100: rgb(132, 255, 255);\n  --palette-cyan-a200: rgb(24, 255, 255);\n  --palette-cyan-a400: rgb(0, 229, 255);\n  --palette-cyan-a700: rgb(0, 184, 212);\n\n  --palette-teal-50: rgb(224, 242, 241);\n  --palette-teal-100: rgb(178, 223, 219);\n  --palette-teal-200: rgb(128, 203, 196);\n  --palette-teal-300: rgb(77, 182, 172);\n  --palette-teal-400: rgb(38, 166, 154);\n  --palette-teal-500: rgb(0, 150, 136);\n  --palette-teal-600: rgb(0, 137, 123);\n  --palette-teal-700: rgb(0, 121, 107);\n  --palette-teal-800: rgb(0, 105, 92);\n  --palette-teal-900: rgb(0, 77, 64);\n  --palette-teal-a100: rgb(167, 255, 235);\n  --palette-teal-a200: rgb(100, 255, 218);\n  --palette-teal-a400: rgb(29, 233, 182);\n  --palette-teal-a700: rgb(0, 191, 165);\n\n  --palette-green-50: rgb(232, 245, 233);\n  --palette-green-100: rgb(200, 230, 201);\n  --palette-green-200: rgb(165, 214, 167);\n  --palette-green-300: rgb(129, 199, 132);\n  --palette-green-400: rgb(102, 187, 106);\n  --palette-green-500: rgb(76, 175, 80);\n  --palette-green-600: rgb(67, 160, 71);\n  --palette-green-700: rgb(56, 142, 60);\n  --palette-green-800: rgb(46, 125, 50);\n  --palette-green-900: rgb(27, 94, 32);\n  --palette-green-a100: rgb(185, 246, 202);\n  --palette-green-a200: rgb(105, 240, 174);\n  --palette-green-a400: rgb(0, 230, 118);\n  --palette-green-a700: rgb(0, 200, 83);\n\n  --palette-light-green-50: rgb(241, 248, 233);\n  --palette-light-green-100: rgb(220, 237, 200);\n  --palette-light-green-200: rgb(197, 225, 165);\n  --palette-light-green-300: rgb(174, 213, 129);\n  --palette-light-green-400: rgb(156, 204, 101);\n  --palette-light-green-500: rgb(139, 195, 74);\n  --palette-light-green-600: rgb(124, 179, 66);\n  --palette-light-green-700: rgb(104, 159, 56);\n  --palette-light-green-800: rgb(85, 139, 47);\n  --palette-light-green-900: rgb(51, 105, 30);\n  --palette-light-green-a100: rgb(204, 255, 144);\n  --palette-light-green-a200: rgb(178, 255, 89);\n  --palette-light-green-a400: rgb(118, 255, 3);\n  --palette-light-green-a700: rgb(100, 221, 23);\n\n  --palette-lime-50: rgb(249, 251, 231);\n  --palette-lime-100: rgb(240, 244, 195);\n  --palette-lime-200: rgb(230, 238, 156);\n  --palette-lime-300: rgb(220, 231, 117);\n  --palette-lime-400: rgb(212, 225, 87);\n  --palette-lime-500: rgb(205, 220, 57);\n  --palette-lime-600: rgb(192, 202, 51);\n  --palette-lime-700: rgb(175, 180, 43);\n  --palette-lime-800: rgb(158, 157, 36);\n  --palette-lime-900: rgb(130, 119, 23);\n  --palette-lime-a100: rgb(244, 255, 129);\n  --palette-lime-a200: rgb(238, 255, 65);\n  --palette-lime-a400: rgb(198, 255, 0);\n  --palette-lime-a700: rgb(174, 234, 0);\n\n  --palette-yellow-50: rgb(255, 253, 231);\n  --palette-yellow-100: rgb(255, 249, 196);\n  --palette-yellow-200: rgb(255, 245, 157);\n  --palette-yellow-300: rgb(255, 241, 118);\n  --palette-yellow-400: rgb(255, 238, 88);\n  --palette-yellow-500: rgb(255, 235, 59);\n  --palette-yellow-600: rgb(253, 216, 53);\n  --palette-yellow-700: rgb(251, 192, 45);\n  --palette-yellow-800: rgb(249, 168, 37);\n  --palette-yellow-900: rgb(245, 127, 23);\n  --palette-yellow-a100: rgb(255, 255, 141);\n  --palette-yellow-a200: rgb(255, 255, 0);\n  --palette-yellow-a400: rgb(255, 234, 0);\n  --palette-yellow-a700: rgb(255, 214, 0);\n\n  --palette-amber-50: rgb(255, 248, 225);\n  --palette-amber-100: rgb(255, 236, 179);\n  --palette-amber-200: rgb(255, 224, 130);\n  --palette-amber-300: rgb(255, 213, 79);\n  --palette-amber-400: rgb(255, 202, 40);\n  --palette-amber-500: rgb(255, 193, 7);\n  --palette-amber-600: rgb(255, 179, 0);\n  --palette-amber-700: rgb(255, 160, 0);\n  --palette-amber-800: rgb(255, 143, 0);\n  --palette-amber-900: rgb(255, 111, 0);\n  --palette-amber-a100: rgb(255, 229, 127);\n  --palette-amber-a200: rgb(255, 215, 64);\n  --palette-amber-a400: rgb(255, 196, 0);\n  --palette-amber-a700: rgb(255, 171, 0);\n\n  --palette-orange-50: rgb(255, 243, 224);\n  --palette-orange-100: rgb(255, 224, 178);\n  --palette-orange-200: rgb(255, 204, 128);\n  --palette-orange-300: rgb(255, 183, 77);\n  --palette-orange-400: rgb(255, 167, 38);\n  --palette-orange-500: rgb(255, 152, 0);\n  --palette-orange-600: rgb(251, 140, 0);\n  --palette-orange-700: rgb(245, 124, 0);\n  --palette-orange-800: rgb(239, 108, 0);\n  --palette-orange-900: rgb(230, 81, 0);\n  --palette-orange-a100: rgb(255, 209, 128);\n  --palette-orange-a200: rgb(255, 171, 64);\n  --palette-orange-a400: rgb(255, 145, 0);\n  --palette-orange-a700: rgb(255, 109, 0);\n\n  --palette-deep-orange-50: rgb(251, 233, 231);\n  --palette-deep-orange-100: rgb(255, 204, 188);\n  --palette-deep-orange-200: rgb(255, 171, 145);\n  --palette-deep-orange-300: rgb(255, 138, 101);\n  --palette-deep-orange-400: rgb(255, 112, 67);\n  --palette-deep-orange-500: rgb(255, 87, 34);\n  --palette-deep-orange-600: rgb(244, 81, 30);\n  --palette-deep-orange-700: rgb(230, 74, 25);\n  --palette-deep-orange-800: rgb(216, 67, 21);\n  --palette-deep-orange-900: rgb(191, 54, 12);\n  --palette-deep-orange-a100: rgb(255, 158, 128);\n  --palette-deep-orange-a200: rgb(255, 110, 64);\n  --palette-deep-orange-a400: rgb(255, 61, 0);\n  --palette-deep-orange-a700: rgb(221, 44, 0);\n\n  --palette-brown-50: rgb(239, 235, 233);\n  --palette-brown-100: rgb(215, 204, 200);\n  --palette-brown-200: rgb(188, 170, 164);\n  --palette-brown-300: rgb(161, 136, 127);\n  --palette-brown-400: rgb(141, 110, 99);\n  --palette-brown-500: rgb(121, 85, 72);\n  --palette-brown-600: rgb(109, 76, 65);\n  --palette-brown-700: rgb(93, 64, 55);\n  --palette-brown-800: rgb(78, 52, 46);\n  --palette-brown-900: rgb(62, 39, 35);\n\n  --palette-grey-50: rgb(250, 250, 250);\n  --palette-grey-100: rgb(245, 245, 245);\n  --palette-grey-200: rgb(238, 238, 238);\n  --palette-grey-300: rgb(224, 224, 224);\n  --palette-grey-400: rgb(189, 189, 189);\n  --palette-grey-500: rgb(158, 158, 158);\n  --palette-grey-600: rgb(117, 117, 117);\n  --palette-grey-700: rgb(97, 97, 97);\n  --palette-grey-800: rgb(66, 66, 66);\n  --palette-grey-900: rgb(33, 33, 33);\n\n  --palette-blue-grey-50: rgb(236, 239, 241);\n  --palette-blue-grey-100: rgb(207, 216, 220);\n  --palette-blue-grey-200: rgb(176, 190, 197);\n  --palette-blue-grey-300: rgb(144, 164, 174);\n  --palette-blue-grey-400: rgb(120, 144, 156);\n  --palette-blue-grey-500: rgb(96, 125, 139);\n  --palette-blue-grey-600: rgb(84, 110, 122);\n  --palette-blue-grey-700: rgb(69, 90, 100);\n  --palette-blue-grey-800: rgb(55, 71, 79);\n  --palette-blue-grey-900: rgb(38, 50, 56);\n\n  --color-black: rgb(0, 0, 0);\n  --color-white: rgb(255, 255, 255);\n  --color-dark-contrast: var(--color-white);\n  --color-light-contrast: var(--color-black);\n}\n:root {\n  --color-divider: var(--palette-grey-200);\n  --color-background: var(--color-white);\n  --color-text: var(--palette-grey-900);\n  --color-text-secondary: var(--palette-grey-600);\n\n  --color-primary: var(--palette-indigo-500);\n  --color-primary-dark: var(--palette-indigo-700);\n  --color-accent: var(--palette-pink-a200);\n  --color-accent-dark: var(--palette-pink-700);\n  --color-primary-contrast: var(--color-dark-contrast);\n  --color-accent-contrast: var(--color-dark-contrast);\n\n  --unit: 10px;\n\n  --preferred-font: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  --font-size: calc(1.6 * var(--unit));\n  --font-size-tiny: calc(1.2 * var(--unit));\n  --font-size-small: calc(1.4 * var(--unit));\n  --font-size-normal: var(--font-size);\n  --font-size-big: calc(1.8 * var(--unit));\n  --font-weight-thin: 300;\n  --font-weight-normal: 400;\n  --font-weight-semi-bold: 500;\n  --font-weight-bold: 700;\n\n  --shadow-2p:\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-3p:\n    0 3px 4px 0 rgba(0, 0, 0, 0.14),\n    0 3px 3px -2px rgba(0, 0, 0, 0.2),\n    0 1px 8px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-4p:\n    0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12),\n    0 2px 4px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-6p:\n    0 6px 10px 0 rgba(0, 0, 0, 0.14),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-8p:\n    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12),\n    0 5px 5px -3px rgba(0, 0, 0, 0.2);\n\n  --shadow-16p:\n    0 16px 24px 2px rgba(0, 0, 0, 0.14),\n    0 6px 30px 5px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba(0, 0, 0, 0.2);\n\n  --shadow-key-umbra-opacity: 0.2;\n  --shadow-key-penumbra-opacity: 0.14;\n  --shadow-ambient-shadow-opacity: 0.12;\n\n  --zdepth-shadow-1: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);\n  --zdepth-shadow-2: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-3: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-4: 0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22);\n  --zdepth-shadow-5: 0 19px 60px rgba(0, 0, 0, 0.3), 0 15px 20px rgba(0, 0, 0, 0.22);\n\n  --animation-duration: 0.35s;\n  --animation-delay: calc(var(--animation-duration) / 5);\n  --animation-curve-fast-out-slow-in: cubic-bezier(0.4, 0, 0.2, 1);\n  --animation-curve-linear-out-slow-in: cubic-bezier(0, 0, 0.2, 1);\n  --animation-curve-fast-out-linear-in: cubic-bezier(0.4, 0, 1, 1);\n  --animation-curve-default: var(--animation-curve-fast-out-slow-in);\n\n  --z-index-highest: 300;\n  --z-index-higher: 200;\n  --z-index-high: 100;\n  --z-index-normal: 1;\n  --z-index-low: -100;\n  --z-index-lower: -200\n}\n:root {\n  --button-border-radius: calc(0.2 * var(--unit));\n  --button-height: calc(3.6 * var(--unit));\n  --button-toggle-font-size: calc(2 * var(--unit));\n  --button-primary-color: var(--color-primary);\n  --button-primary-color-hover: color(var(--color-primary) a(20%));\n  --button-primary-color-contrast: var(--color-primary-contrast);\n  --button-accent-color-contrast: var(--color-primary-contrast);\n  --button-accent-color-hover: color(var(--color-accent) a(20%));\n  --button-accent-color: var(--color-accent);\n  --button-neutral-color: var(--color-white);\n  --button-neutral-color-contrast: var(--palette-grey-900);\n  --button-neutral-color-hover: color(var(--palette-grey-900) a(20%));\n  --button-floating-font-size: calc(2.4 * var(--unit));\n  --button-floating-height: calc(5.6 * var(--unit));\n  --button-floating-mini-height: calc(4 * var(--unit));\n  --button-floating-mini-font-size: calc(var(--button-floating-mini-height) / 2.25);\n  --button-disabled-text-color: color(var(--color-black) a(26%));\n  --button-disabled-background-color: color(var(--color-black) a(12%));\n  --button-disabled-text-color-inverse: color(var(--color-black) a(54%));\n  --button-disabled-background-inverse: color(var(--color-black) a(8%));\n  --button-squared-icon-margin: calc(0.6 * var(--unit));\n  --button-squared-min-width: calc(9 * var(--unit));\n  --button-squared-padding: 0 calc(1.2 * var(--unit));\n}\n.theme_button__RXqbE {\n  align-content: center;\n  align-items: center;\n  border: 0;\n  cursor: pointer;\n  display: inline-block;\n  flex-direction: row;\n  font-size: calc(1.4 * var(--unit));\n  font-weight: 500;\n  height: var(--button-height);\n  justify-content: center;\n  letter-spacing: 0;\n  line-height: var(--button-height);\n  outline: none;\n  padding: 0;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition:\n    box-shadow 0.2s var(--animation-curve-fast-out-linear-in),\n    background-color 0.2s var(--animation-curve-default),\n    color 0.2s var(--animation-curve-default);\n  white-space: nowrap;\n    box-sizing: border-box;\n    font-family: var(--preferred-font);\n    -webkit-font-smoothing: antialiased;\n    font-smoothing: antialiased;\n    text-size-adjust: 100%\n}\n.theme_button__RXqbE *,\n    .theme_button__RXqbE *::after,\n    .theme_button__RXqbE *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme_button__RXqbE > input {\n  height: 0.1px;\n  margin: 0;\n  opacity: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 0.1px;\n  z-index: 0;\n}\n.theme_button__RXqbE::-moz-focus-inner {\n  border: 0;\n}\n.theme_button__RXqbE > span:not([data-react-toolbox='tooltip']) {\n  display: inline-block;\n  line-height: var(--button-height);\n  vertical-align: middle;\n}\n.theme_button__RXqbE > svg {\n  display: inline-block;\n  fill: currentColor;\n  font-size: 120%;\n  height: var(--button-height);\n  vertical-align: top;\n  width: 1em;\n}\n.theme_button__RXqbE > * {\n  pointer-events: none;\n}\n.theme_button__RXqbE > .theme_rippleWrapper__0x4Qs {\n  overflow: hidden;\n}\n.theme_button__RXqbE[disabled] {\n  color: var(--button-disabled-text-color);\n  cursor: auto;\n  pointer-events: none;\n}\n.theme_squared__Svxfq {\n  border-radius: var(--button-border-radius);\n  min-width: var(--button-squared-min-width);\n  padding: var(--button-squared-padding)\n}\n.theme_squared__Svxfq .theme_icon__H0mOt {\n  font-size: 120%;\n  margin-right: var(--button-squared-icon-margin);\n  vertical-align: middle;\n}\n.theme_squared__Svxfq > svg {\n  margin-right: calc(0.5 * var(--unit));\n}\n.theme_solid__88aYH[disabled] {\n  background-color: var(--button-disabled-background-color);\n  box-shadow: var(--shadow-2p);\n}\n.theme_solid__88aYH:active {\n  box-shadow: var(--shadow-2p);\n}\n.theme_solid__88aYH:focus:not(:active) {\n  box-shadow:\n      0 0 8px rgba(0, 0, 0, 0.18),\n      0 8px 16px rgba(0, 0, 0, 0.36);\n}\n.theme_raised__jjLh2 {\n  box-shadow: var(--shadow-2p);\n}\n.theme_flat__JgQRq {\n  background: transparent;\n}\n.theme_floating__Vg02W {\n  border-radius: 50%;\n  box-shadow:\n    0 1px 1.5px 0 rgba(0, 0, 0, 0.12),\n    0 1px 1px 0 rgba(0, 0, 0, 0.24);\n  font-size: var(--button-floating-font-size);\n  height: var(--button-floating-height);\n  width: var(--button-floating-height)\n}\n.theme_floating__Vg02W .theme_icon__H0mOt:not([data-react-toolbox='tooltip']) {\n  line-height: var(--button-floating-height);\n}\n.theme_floating__Vg02W > .theme_rippleWrapper__0x4Qs {\n  border-radius: 50%;\n}\n.theme_floating__Vg02W.theme_mini__Fjw-9 {\n  font-size: var(--button-floating-mini-font-size);\n  height: var(--button-floating-mini-height);\n  width: var(--button-floating-mini-height);\n}\n.theme_floating__Vg02W.theme_mini__Fjw-9 .theme_icon__H0mOt {\n  line-height: var(--button-floating-mini-height);\n}\n.theme_toggle__q6r9m {\n  background: transparent;\n  border-radius: 50%;\n  vertical-align: middle;\n  width: var(--button-height)\n}\n.theme_toggle__q6r9m > .theme_icon__H0mOt,\n  .theme_toggle__q6r9m svg {\n  font-size: var(--button-toggle-font-size);\n  line-height: var(--button-height);\n  vertical-align: top;\n}\n.theme_toggle__q6r9m > .theme_rippleWrapper__0x4Qs {\n  border-radius: 50%;\n}\n.theme_primary__jWDlF:not([disabled]).theme_raised__jjLh2,\n  .theme_primary__jWDlF:not([disabled]).theme_floating__Vg02W {\n  background: var(--button-primary-color);\n  color: var(--button-primary-color-contrast);\n}\n.theme_primary__jWDlF:not([disabled]).theme_flat__JgQRq,\n  .theme_primary__jWDlF:not([disabled]).theme_toggle__q6r9m {\n  color: var(--button-primary-color);\n}\n.theme_primary__jWDlF:not([disabled]).theme_flat__JgQRq:focus:not(:active), .theme_primary__jWDlF:not([disabled]).theme_toggle__q6r9m:focus:not(:active) {\n  background: var(--button-primary-color-hover);\n}\n.theme_primary__jWDlF:not([disabled]).theme_flat__JgQRq:hover {\n  background: var(--button-primary-color-hover);\n}\n.theme_accent__m-4Lt:not([disabled]).theme_raised__jjLh2,\n  .theme_accent__m-4Lt:not([disabled]).theme_floating__Vg02W {\n  background: var(--button-accent-color);\n  color: var(--button-accent-color-contrast);\n}\n.theme_accent__m-4Lt:not([disabled]).theme_flat__JgQRq,\n  .theme_accent__m-4Lt:not([disabled]).theme_toggle__q6r9m {\n  color: var(--button-accent-color);\n}\n.theme_accent__m-4Lt:not([disabled]).theme_flat__JgQRq:focus:not(:active), .theme_accent__m-4Lt:not([disabled]).theme_toggle__q6r9m:focus:not(:active) {\n  background: var(--button-accent-color-hover);\n}\n.theme_accent__m-4Lt:not([disabled]).theme_flat__JgQRq:hover {\n  background: var(--button-accent-color-hover);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_raised__jjLh2,\n  .theme_neutral__d8DLT:not([disabled]).theme_floating__Vg02W {\n  background-color: var(--button-neutral-color);\n  color: var(--button-neutral-color-contrast);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_flat__JgQRq,\n  .theme_neutral__d8DLT:not([disabled]).theme_toggle__q6r9m {\n  color: var(--button-neutral-color-contrast);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_flat__JgQRq:focus:not(:active), .theme_neutral__d8DLT:not([disabled]).theme_toggle__q6r9m:focus:not(:active) {\n  background: var(--button-neutral-color-hover);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_flat__JgQRq:hover {\n  background: var(--button-neutral-color-hover);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_raised__jjLh2,\n    .theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_floating__Vg02W {\n  background-color: var(--button-neutral-color-contrast);\n  color: var(--button-neutral-color);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_flat__JgQRq,\n    .theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_toggle__q6r9m {\n  color: var(--button-neutral-color);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_flat__JgQRq:focus:not(:active), .theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_toggle__q6r9m:focus:not(:active) {\n  background: var(--button-neutral-color-hover);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_flat__JgQRq:hover {\n  background: var(--button-neutral-color-hover);\n}\n.theme_neutral__d8DLT.theme_inverse__6ARs8[disabled] {\n  background-color: var(--button-disabled-background-inverse);\n  color: var(--button-disabled-text-color-inverse);\n}\n";
var theme$6 = {"button":"theme_button__RXqbE","rippleWrapper":"theme_rippleWrapper__0x4Qs","squared":"theme_squared__Svxfq","icon":"theme_icon__H0mOt","solid":"theme_solid__88aYH","raised":"theme_raised__jjLh2 theme_button__RXqbE theme_squared__Svxfq theme_solid__88aYH","flat":"theme_flat__JgQRq theme_button__RXqbE theme_squared__Svxfq","floating":"theme_floating__Vg02W theme_button__RXqbE theme_solid__88aYH","mini":"theme_mini__Fjw-9","toggle":"theme_toggle__q6r9m theme_button__RXqbE","primary":"theme_primary__jWDlF","accent":"theme_accent__m-4Lt","neutral":"theme_neutral__d8DLT","inverse":"theme_inverse__6ARs8"};
var stylesheet$2=":root {\n  --palette-red-50: rgb(255, 235, 238);\n  --palette-red-100: rgb(255, 205, 210);\n  --palette-red-200: rgb(239, 154, 154);\n  --palette-red-300: rgb(229, 115, 115);\n  --palette-red-400: rgb(239, 83, 80);\n  --palette-red-500: rgb(244, 67, 54);\n  --palette-red-600: rgb(229, 57, 53);\n  --palette-red-700: rgb(211, 47, 47);\n  --palette-red-800: rgb(198, 40, 40);\n  --palette-red-900: rgb(183, 28, 28);\n  --palette-red-a100: rgb(255, 138, 128);\n  --palette-red-a200: rgb(255, 82, 82);\n  --palette-red-a400: rgb(255, 23, 68);\n  --palette-red-a700: rgb(213, 0, 0);\n\n  --palette-pink-50: rgb(252, 228, 236);\n  --palette-pink-100: rgb(248, 187, 208);\n  --palette-pink-200: rgb(244, 143, 177);\n  --palette-pink-300: rgb(240, 98, 146);\n  --palette-pink-400: rgb(236, 64, 122);\n  --palette-pink-500: rgb(233, 30, 99);\n  --palette-pink-600: rgb(216, 27, 96);\n  --palette-pink-700: rgb(194, 24, 91);\n  --palette-pink-800: rgb(173, 20, 87);\n  --palette-pink-900: rgb(136, 14, 79);\n  --palette-pink-a100: rgb(255, 128, 171);\n  --palette-pink-a200: rgb(255, 64, 129);\n  --palette-pink-a400: rgb(245, 0, 87);\n  --palette-pink-a700: rgb(197, 17, 98);\n\n  --palette-purple-50: rgb(243, 229, 245);\n  --palette-purple-100: rgb(225, 190, 231);\n  --palette-purple-200: rgb(206, 147, 216);\n  --palette-purple-300: rgb(186, 104, 200);\n  --palette-purple-400: rgb(171, 71, 188);\n  --palette-purple-500: rgb(156, 39, 176);\n  --palette-purple-600: rgb(142, 36, 170);\n  --palette-purple-700: rgb(123, 31, 162);\n  --palette-purple-800: rgb(106, 27, 154);\n  --palette-purple-900: rgb(74, 20, 140);\n  --palette-purple-a100: rgb(234, 128, 252);\n  --palette-purple-a200: rgb(224, 64, 251);\n  --palette-purple-a400: rgb(213, 0, 249);\n  --palette-purple-a700: rgb(170, 0, 255);\n\n  --palette-deep-purple-50: rgb(237, 231, 246);\n  --palette-deep-purple-100: rgb(209, 196, 233);\n  --palette-deep-purple-200: rgb(179, 157, 219);\n  --palette-deep-purple-300: rgb(149, 117, 205);\n  --palette-deep-purple-400: rgb(126, 87, 194);\n  --palette-deep-purple-500: rgb(103, 58, 183);\n  --palette-deep-purple-600: rgb(94, 53, 177);\n  --palette-deep-purple-700: rgb(81, 45, 168);\n  --palette-deep-purple-800: rgb(69, 39, 160);\n  --palette-deep-purple-900: rgb(49, 27, 146);\n  --palette-deep-purple-a100: rgb(179, 136, 255);\n  --palette-deep-purple-a200: rgb(124, 77, 255);\n  --palette-deep-purple-a400: rgb(101, 31, 255);\n  --palette-deep-purple-a700: rgb(98, 0, 234);\n\n  --palette-indigo-50: rgb(232, 234, 246);\n  --palette-indigo-100: rgb(197, 202, 233);\n  --palette-indigo-200: rgb(159, 168, 218);\n  --palette-indigo-300: rgb(121, 134, 203);\n  --palette-indigo-400: rgb(92, 107, 192);\n  --palette-indigo-500: rgb(63, 81, 181);\n  --palette-indigo-600: rgb(57, 73, 171);\n  --palette-indigo-700: rgb(48, 63, 159);\n  --palette-indigo-800: rgb(40, 53, 147);\n  --palette-indigo-900: rgb(26, 35, 126);\n  --palette-indigo-a100: rgb(140, 158, 255);\n  --palette-indigo-a200: rgb(83, 109, 254);\n  --palette-indigo-a400: rgb(61, 90, 254);\n  --palette-indigo-a700: rgb(48, 79, 254);\n\n  --palette-blue-50: rgb(227, 242, 253);\n  --palette-blue-100: rgb(187, 222, 251);\n  --palette-blue-200: rgb(144, 202, 249);\n  --palette-blue-300: rgb(100, 181, 246);\n  --palette-blue-400: rgb(66, 165, 245);\n  --palette-blue-500: rgb(33, 150, 243);\n  --palette-blue-600: rgb(30, 136, 229);\n  --palette-blue-700: rgb(25, 118, 210);\n  --palette-blue-800: rgb(21, 101, 192);\n  --palette-blue-900: rgb(13, 71, 161);\n  --palette-blue-a100: rgb(130, 177, 255);\n  --palette-blue-a200: rgb(68, 138, 255);\n  --palette-blue-a400: rgb(41, 121, 255);\n  --palette-blue-a700: rgb(41, 98, 255);\n\n  --palette-light-blue-50: rgb(225, 245, 254);\n  --palette-light-blue-100: rgb(179, 229, 252);\n  --palette-light-blue-200: rgb(129, 212, 250);\n  --palette-light-blue-300: rgb(79, 195, 247);\n  --palette-light-blue-400: rgb(41, 182, 246);\n  --palette-light-blue-500: rgb(3, 169, 244);\n  --palette-light-blue-600: rgb(3, 155, 229);\n  --palette-light-blue-700: rgb(2, 136, 209);\n  --palette-light-blue-800: rgb(2, 119, 189);\n  --palette-light-blue-900: rgb(1, 87, 155);\n  --palette-light-blue-a100: rgb(128, 216, 255);\n  --palette-light-blue-a200: rgb(64, 196, 255);\n  --palette-light-blue-a400: rgb(0, 176, 255);\n  --palette-light-blue-a700: rgb(0, 145, 234);\n\n  --palette-cyan-50: rgb(224, 247, 250);\n  --palette-cyan-100: rgb(178, 235, 242);\n  --palette-cyan-200: rgb(128, 222, 234);\n  --palette-cyan-300: rgb(77, 208, 225);\n  --palette-cyan-400: rgb(38, 198, 218);\n  --palette-cyan-500: rgb(0, 188, 212);\n  --palette-cyan-600: rgb(0, 172, 193);\n  --palette-cyan-700: rgb(0, 151, 167);\n  --palette-cyan-800: rgb(0, 131, 143);\n  --palette-cyan-900: rgb(0, 96, 100);\n  --palette-cyan-a100: rgb(132, 255, 255);\n  --palette-cyan-a200: rgb(24, 255, 255);\n  --palette-cyan-a400: rgb(0, 229, 255);\n  --palette-cyan-a700: rgb(0, 184, 212);\n\n  --palette-teal-50: rgb(224, 242, 241);\n  --palette-teal-100: rgb(178, 223, 219);\n  --palette-teal-200: rgb(128, 203, 196);\n  --palette-teal-300: rgb(77, 182, 172);\n  --palette-teal-400: rgb(38, 166, 154);\n  --palette-teal-500: rgb(0, 150, 136);\n  --palette-teal-600: rgb(0, 137, 123);\n  --palette-teal-700: rgb(0, 121, 107);\n  --palette-teal-800: rgb(0, 105, 92);\n  --palette-teal-900: rgb(0, 77, 64);\n  --palette-teal-a100: rgb(167, 255, 235);\n  --palette-teal-a200: rgb(100, 255, 218);\n  --palette-teal-a400: rgb(29, 233, 182);\n  --palette-teal-a700: rgb(0, 191, 165);\n\n  --palette-green-50: rgb(232, 245, 233);\n  --palette-green-100: rgb(200, 230, 201);\n  --palette-green-200: rgb(165, 214, 167);\n  --palette-green-300: rgb(129, 199, 132);\n  --palette-green-400: rgb(102, 187, 106);\n  --palette-green-500: rgb(76, 175, 80);\n  --palette-green-600: rgb(67, 160, 71);\n  --palette-green-700: rgb(56, 142, 60);\n  --palette-green-800: rgb(46, 125, 50);\n  --palette-green-900: rgb(27, 94, 32);\n  --palette-green-a100: rgb(185, 246, 202);\n  --palette-green-a200: rgb(105, 240, 174);\n  --palette-green-a400: rgb(0, 230, 118);\n  --palette-green-a700: rgb(0, 200, 83);\n\n  --palette-light-green-50: rgb(241, 248, 233);\n  --palette-light-green-100: rgb(220, 237, 200);\n  --palette-light-green-200: rgb(197, 225, 165);\n  --palette-light-green-300: rgb(174, 213, 129);\n  --palette-light-green-400: rgb(156, 204, 101);\n  --palette-light-green-500: rgb(139, 195, 74);\n  --palette-light-green-600: rgb(124, 179, 66);\n  --palette-light-green-700: rgb(104, 159, 56);\n  --palette-light-green-800: rgb(85, 139, 47);\n  --palette-light-green-900: rgb(51, 105, 30);\n  --palette-light-green-a100: rgb(204, 255, 144);\n  --palette-light-green-a200: rgb(178, 255, 89);\n  --palette-light-green-a400: rgb(118, 255, 3);\n  --palette-light-green-a700: rgb(100, 221, 23);\n\n  --palette-lime-50: rgb(249, 251, 231);\n  --palette-lime-100: rgb(240, 244, 195);\n  --palette-lime-200: rgb(230, 238, 156);\n  --palette-lime-300: rgb(220, 231, 117);\n  --palette-lime-400: rgb(212, 225, 87);\n  --palette-lime-500: rgb(205, 220, 57);\n  --palette-lime-600: rgb(192, 202, 51);\n  --palette-lime-700: rgb(175, 180, 43);\n  --palette-lime-800: rgb(158, 157, 36);\n  --palette-lime-900: rgb(130, 119, 23);\n  --palette-lime-a100: rgb(244, 255, 129);\n  --palette-lime-a200: rgb(238, 255, 65);\n  --palette-lime-a400: rgb(198, 255, 0);\n  --palette-lime-a700: rgb(174, 234, 0);\n\n  --palette-yellow-50: rgb(255, 253, 231);\n  --palette-yellow-100: rgb(255, 249, 196);\n  --palette-yellow-200: rgb(255, 245, 157);\n  --palette-yellow-300: rgb(255, 241, 118);\n  --palette-yellow-400: rgb(255, 238, 88);\n  --palette-yellow-500: rgb(255, 235, 59);\n  --palette-yellow-600: rgb(253, 216, 53);\n  --palette-yellow-700: rgb(251, 192, 45);\n  --palette-yellow-800: rgb(249, 168, 37);\n  --palette-yellow-900: rgb(245, 127, 23);\n  --palette-yellow-a100: rgb(255, 255, 141);\n  --palette-yellow-a200: rgb(255, 255, 0);\n  --palette-yellow-a400: rgb(255, 234, 0);\n  --palette-yellow-a700: rgb(255, 214, 0);\n\n  --palette-amber-50: rgb(255, 248, 225);\n  --palette-amber-100: rgb(255, 236, 179);\n  --palette-amber-200: rgb(255, 224, 130);\n  --palette-amber-300: rgb(255, 213, 79);\n  --palette-amber-400: rgb(255, 202, 40);\n  --palette-amber-500: rgb(255, 193, 7);\n  --palette-amber-600: rgb(255, 179, 0);\n  --palette-amber-700: rgb(255, 160, 0);\n  --palette-amber-800: rgb(255, 143, 0);\n  --palette-amber-900: rgb(255, 111, 0);\n  --palette-amber-a100: rgb(255, 229, 127);\n  --palette-amber-a200: rgb(255, 215, 64);\n  --palette-amber-a400: rgb(255, 196, 0);\n  --palette-amber-a700: rgb(255, 171, 0);\n\n  --palette-orange-50: rgb(255, 243, 224);\n  --palette-orange-100: rgb(255, 224, 178);\n  --palette-orange-200: rgb(255, 204, 128);\n  --palette-orange-300: rgb(255, 183, 77);\n  --palette-orange-400: rgb(255, 167, 38);\n  --palette-orange-500: rgb(255, 152, 0);\n  --palette-orange-600: rgb(251, 140, 0);\n  --palette-orange-700: rgb(245, 124, 0);\n  --palette-orange-800: rgb(239, 108, 0);\n  --palette-orange-900: rgb(230, 81, 0);\n  --palette-orange-a100: rgb(255, 209, 128);\n  --palette-orange-a200: rgb(255, 171, 64);\n  --palette-orange-a400: rgb(255, 145, 0);\n  --palette-orange-a700: rgb(255, 109, 0);\n\n  --palette-deep-orange-50: rgb(251, 233, 231);\n  --palette-deep-orange-100: rgb(255, 204, 188);\n  --palette-deep-orange-200: rgb(255, 171, 145);\n  --palette-deep-orange-300: rgb(255, 138, 101);\n  --palette-deep-orange-400: rgb(255, 112, 67);\n  --palette-deep-orange-500: rgb(255, 87, 34);\n  --palette-deep-orange-600: rgb(244, 81, 30);\n  --palette-deep-orange-700: rgb(230, 74, 25);\n  --palette-deep-orange-800: rgb(216, 67, 21);\n  --palette-deep-orange-900: rgb(191, 54, 12);\n  --palette-deep-orange-a100: rgb(255, 158, 128);\n  --palette-deep-orange-a200: rgb(255, 110, 64);\n  --palette-deep-orange-a400: rgb(255, 61, 0);\n  --palette-deep-orange-a700: rgb(221, 44, 0);\n\n  --palette-brown-50: rgb(239, 235, 233);\n  --palette-brown-100: rgb(215, 204, 200);\n  --palette-brown-200: rgb(188, 170, 164);\n  --palette-brown-300: rgb(161, 136, 127);\n  --palette-brown-400: rgb(141, 110, 99);\n  --palette-brown-500: rgb(121, 85, 72);\n  --palette-brown-600: rgb(109, 76, 65);\n  --palette-brown-700: rgb(93, 64, 55);\n  --palette-brown-800: rgb(78, 52, 46);\n  --palette-brown-900: rgb(62, 39, 35);\n\n  --palette-grey-50: rgb(250, 250, 250);\n  --palette-grey-100: rgb(245, 245, 245);\n  --palette-grey-200: rgb(238, 238, 238);\n  --palette-grey-300: rgb(224, 224, 224);\n  --palette-grey-400: rgb(189, 189, 189);\n  --palette-grey-500: rgb(158, 158, 158);\n  --palette-grey-600: rgb(117, 117, 117);\n  --palette-grey-700: rgb(97, 97, 97);\n  --palette-grey-800: rgb(66, 66, 66);\n  --palette-grey-900: rgb(33, 33, 33);\n\n  --palette-blue-grey-50: rgb(236, 239, 241);\n  --palette-blue-grey-100: rgb(207, 216, 220);\n  --palette-blue-grey-200: rgb(176, 190, 197);\n  --palette-blue-grey-300: rgb(144, 164, 174);\n  --palette-blue-grey-400: rgb(120, 144, 156);\n  --palette-blue-grey-500: rgb(96, 125, 139);\n  --palette-blue-grey-600: rgb(84, 110, 122);\n  --palette-blue-grey-700: rgb(69, 90, 100);\n  --palette-blue-grey-800: rgb(55, 71, 79);\n  --palette-blue-grey-900: rgb(38, 50, 56);\n\n  --color-black: rgb(0, 0, 0);\n  --color-white: rgb(255, 255, 255);\n  --color-dark-contrast: var(--color-white);\n  --color-light-contrast: var(--color-black);\n}\n:root {\n  --color-divider: var(--palette-grey-200);\n  --color-background: var(--color-white);\n  --color-text: var(--palette-grey-900);\n  --color-text-secondary: var(--palette-grey-600);\n\n  --color-primary: var(--palette-indigo-500);\n  --color-primary-dark: var(--palette-indigo-700);\n  --color-accent: var(--palette-pink-a200);\n  --color-accent-dark: var(--palette-pink-700);\n  --color-primary-contrast: var(--color-dark-contrast);\n  --color-accent-contrast: var(--color-dark-contrast);\n\n  --unit: 10px;\n\n  --preferred-font: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  --font-size: calc(1.6 * var(--unit));\n  --font-size-tiny: calc(1.2 * var(--unit));\n  --font-size-small: calc(1.4 * var(--unit));\n  --font-size-normal: var(--font-size);\n  --font-size-big: calc(1.8 * var(--unit));\n  --font-weight-thin: 300;\n  --font-weight-normal: 400;\n  --font-weight-semi-bold: 500;\n  --font-weight-bold: 700;\n\n  --shadow-2p:\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-3p:\n    0 3px 4px 0 rgba(0, 0, 0, 0.14),\n    0 3px 3px -2px rgba(0, 0, 0, 0.2),\n    0 1px 8px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-4p:\n    0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12),\n    0 2px 4px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-6p:\n    0 6px 10px 0 rgba(0, 0, 0, 0.14),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-8p:\n    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12),\n    0 5px 5px -3px rgba(0, 0, 0, 0.2);\n\n  --shadow-16p:\n    0 16px 24px 2px rgba(0, 0, 0, 0.14),\n    0 6px 30px 5px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba(0, 0, 0, 0.2);\n\n  --shadow-key-umbra-opacity: 0.2;\n  --shadow-key-penumbra-opacity: 0.14;\n  --shadow-ambient-shadow-opacity: 0.12;\n\n  --zdepth-shadow-1: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);\n  --zdepth-shadow-2: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-3: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-4: 0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22);\n  --zdepth-shadow-5: 0 19px 60px rgba(0, 0, 0, 0.3), 0 15px 20px rgba(0, 0, 0, 0.22);\n\n  --animation-duration: 0.35s;\n  --animation-delay: calc(var(--animation-duration) / 5);\n  --animation-curve-fast-out-slow-in: cubic-bezier(0.4, 0, 0.2, 1);\n  --animation-curve-linear-out-slow-in: cubic-bezier(0, 0, 0.2, 1);\n  --animation-curve-fast-out-linear-in: cubic-bezier(0.4, 0, 1, 1);\n  --animation-curve-default: var(--animation-curve-fast-out-slow-in);\n\n  --z-index-highest: 300;\n  --z-index-higher: 200;\n  --z-index-high: 100;\n  --z-index-normal: 1;\n  --z-index-low: -100;\n  --z-index-lower: -200\n}\n:root {\n  --button-border-radius: calc(0.2 * var(--unit));\n  --button-height: calc(3.6 * var(--unit));\n  --button-toggle-font-size: calc(2 * var(--unit));\n  --button-primary-color: var(--color-primary);\n  --button-primary-color-hover: color(var(--color-primary) a(20%));\n  --button-primary-color-contrast: var(--color-primary-contrast);\n  --button-accent-color-contrast: var(--color-primary-contrast);\n  --button-accent-color-hover: color(var(--color-accent) a(20%));\n  --button-accent-color: var(--color-accent);\n  --button-neutral-color: var(--color-white);\n  --button-neutral-color-contrast: var(--palette-grey-900);\n  --button-neutral-color-hover: color(var(--palette-grey-900) a(20%));\n  --button-floating-font-size: calc(2.4 * var(--unit));\n  --button-floating-height: calc(5.6 * var(--unit));\n  --button-floating-mini-height: calc(4 * var(--unit));\n  --button-floating-mini-font-size: calc(var(--button-floating-mini-height) / 2.25);\n  --button-disabled-text-color: color(var(--color-black) a(26%));\n  --button-disabled-background-color: color(var(--color-black) a(12%));\n  --button-disabled-text-color-inverse: color(var(--color-black) a(54%));\n  --button-disabled-background-inverse: color(var(--color-black) a(8%));\n  --button-squared-icon-margin: calc(0.6 * var(--unit));\n  --button-squared-min-width: calc(9 * var(--unit));\n  --button-squared-padding: 0 calc(1.2 * var(--unit));\n}\n.theme_button__RXqbE {\n  align-content: center;\n  align-items: center;\n  border: 0;\n  cursor: pointer;\n  display: inline-block;\n  flex-direction: row;\n  font-size: calc(1.4 * var(--unit));\n  font-weight: 500;\n  height: var(--button-height);\n  justify-content: center;\n  letter-spacing: 0;\n  line-height: var(--button-height);\n  outline: none;\n  padding: 0;\n  position: relative;\n  text-align: center;\n  text-decoration: none;\n  text-transform: uppercase;\n  transition:\n    box-shadow 0.2s var(--animation-curve-fast-out-linear-in),\n    background-color 0.2s var(--animation-curve-default),\n    color 0.2s var(--animation-curve-default);\n  white-space: nowrap;\n    box-sizing: border-box;\n    font-family: var(--preferred-font);\n    -webkit-font-smoothing: antialiased;\n    font-smoothing: antialiased;\n    text-size-adjust: 100%\n}\n.theme_button__RXqbE *,\n    .theme_button__RXqbE *::after,\n    .theme_button__RXqbE *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme_button__RXqbE > input {\n  height: 0.1px;\n  margin: 0;\n  opacity: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 0.1px;\n  z-index: 0;\n}\n.theme_button__RXqbE::-moz-focus-inner {\n  border: 0;\n}\n.theme_button__RXqbE > span:not([data-react-toolbox='tooltip']) {\n  display: inline-block;\n  line-height: var(--button-height);\n  vertical-align: middle;\n}\n.theme_button__RXqbE > svg {\n  display: inline-block;\n  fill: currentColor;\n  font-size: 120%;\n  height: var(--button-height);\n  vertical-align: top;\n  width: 1em;\n}\n.theme_button__RXqbE > * {\n  pointer-events: none;\n}\n.theme_button__RXqbE > .theme_rippleWrapper__0x4Qs {\n  overflow: hidden;\n}\n.theme_button__RXqbE[disabled] {\n  color: var(--button-disabled-text-color);\n  cursor: auto;\n  pointer-events: none;\n}\n.theme_squared__Svxfq {\n  border-radius: var(--button-border-radius);\n  min-width: var(--button-squared-min-width);\n  padding: var(--button-squared-padding)\n}\n.theme_squared__Svxfq .theme_icon__H0mOt {\n  font-size: 120%;\n  margin-right: var(--button-squared-icon-margin);\n  vertical-align: middle;\n}\n.theme_squared__Svxfq > svg {\n  margin-right: calc(0.5 * var(--unit));\n}\n.theme_solid__88aYH[disabled] {\n  background-color: var(--button-disabled-background-color);\n  box-shadow: var(--shadow-2p);\n}\n.theme_solid__88aYH:active {\n  box-shadow: var(--shadow-2p);\n}\n.theme_solid__88aYH:focus:not(:active) {\n  box-shadow:\n      0 0 8px rgba(0, 0, 0, 0.18),\n      0 8px 16px rgba(0, 0, 0, 0.36);\n}\n.theme_raised__jjLh2 {\n  box-shadow: var(--shadow-2p);\n}\n.theme_flat__JgQRq {\n  background: transparent;\n}\n.theme_floating__Vg02W {\n  border-radius: 50%;\n  box-shadow:\n    0 1px 1.5px 0 rgba(0, 0, 0, 0.12),\n    0 1px 1px 0 rgba(0, 0, 0, 0.24);\n  font-size: var(--button-floating-font-size);\n  height: var(--button-floating-height);\n  width: var(--button-floating-height)\n}\n.theme_floating__Vg02W .theme_icon__H0mOt:not([data-react-toolbox='tooltip']) {\n  line-height: var(--button-floating-height);\n}\n.theme_floating__Vg02W > .theme_rippleWrapper__0x4Qs {\n  border-radius: 50%;\n}\n.theme_floating__Vg02W.theme_mini__Fjw-9 {\n  font-size: var(--button-floating-mini-font-size);\n  height: var(--button-floating-mini-height);\n  width: var(--button-floating-mini-height);\n}\n.theme_floating__Vg02W.theme_mini__Fjw-9 .theme_icon__H0mOt {\n  line-height: var(--button-floating-mini-height);\n}\n.theme_toggle__q6r9m {\n  background: transparent;\n  border-radius: 50%;\n  vertical-align: middle;\n  width: var(--button-height)\n}\n.theme_toggle__q6r9m > .theme_icon__H0mOt,\n  .theme_toggle__q6r9m svg {\n  font-size: var(--button-toggle-font-size);\n  line-height: var(--button-height);\n  vertical-align: top;\n}\n.theme_toggle__q6r9m > .theme_rippleWrapper__0x4Qs {\n  border-radius: 50%;\n}\n.theme_primary__jWDlF:not([disabled]).theme_raised__jjLh2,\n  .theme_primary__jWDlF:not([disabled]).theme_floating__Vg02W {\n  background: var(--button-primary-color);\n  color: var(--button-primary-color-contrast);\n}\n.theme_primary__jWDlF:not([disabled]).theme_flat__JgQRq,\n  .theme_primary__jWDlF:not([disabled]).theme_toggle__q6r9m {\n  color: var(--button-primary-color);\n}\n.theme_primary__jWDlF:not([disabled]).theme_flat__JgQRq:focus:not(:active), .theme_primary__jWDlF:not([disabled]).theme_toggle__q6r9m:focus:not(:active) {\n  background: var(--button-primary-color-hover);\n}\n.theme_primary__jWDlF:not([disabled]).theme_flat__JgQRq:hover {\n  background: var(--button-primary-color-hover);\n}\n.theme_accent__m-4Lt:not([disabled]).theme_raised__jjLh2,\n  .theme_accent__m-4Lt:not([disabled]).theme_floating__Vg02W {\n  background: var(--button-accent-color);\n  color: var(--button-accent-color-contrast);\n}\n.theme_accent__m-4Lt:not([disabled]).theme_flat__JgQRq,\n  .theme_accent__m-4Lt:not([disabled]).theme_toggle__q6r9m {\n  color: var(--button-accent-color);\n}\n.theme_accent__m-4Lt:not([disabled]).theme_flat__JgQRq:focus:not(:active), .theme_accent__m-4Lt:not([disabled]).theme_toggle__q6r9m:focus:not(:active) {\n  background: var(--button-accent-color-hover);\n}\n.theme_accent__m-4Lt:not([disabled]).theme_flat__JgQRq:hover {\n  background: var(--button-accent-color-hover);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_raised__jjLh2,\n  .theme_neutral__d8DLT:not([disabled]).theme_floating__Vg02W {\n  background-color: var(--button-neutral-color);\n  color: var(--button-neutral-color-contrast);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_flat__JgQRq,\n  .theme_neutral__d8DLT:not([disabled]).theme_toggle__q6r9m {\n  color: var(--button-neutral-color-contrast);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_flat__JgQRq:focus:not(:active), .theme_neutral__d8DLT:not([disabled]).theme_toggle__q6r9m:focus:not(:active) {\n  background: var(--button-neutral-color-hover);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_flat__JgQRq:hover {\n  background: var(--button-neutral-color-hover);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_raised__jjLh2,\n    .theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_floating__Vg02W {\n  background-color: var(--button-neutral-color-contrast);\n  color: var(--button-neutral-color);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_flat__JgQRq,\n    .theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_toggle__q6r9m {\n  color: var(--button-neutral-color);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_flat__JgQRq:focus:not(:active), .theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_toggle__q6r9m:focus:not(:active) {\n  background: var(--button-neutral-color-hover);\n}\n.theme_neutral__d8DLT:not([disabled]).theme_inverse__6ARs8.theme_flat__JgQRq:hover {\n  background: var(--button-neutral-color-hover);\n}\n.theme_neutral__d8DLT.theme_inverse__6ARs8[disabled] {\n  background-color: var(--button-disabled-background-inverse);\n  color: var(--button-disabled-text-color-inverse);\n}\n";
styleInject(css_248z$1u);

var theme$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': theme$6,
  stylesheet: stylesheet$2
});

var require$$7 = /*@__PURE__*/getAugmentedNamespace(theme$7);

Object.defineProperty(button, "__esModule", {
  value: true
});
button.BrowseButton = IconButton_1$1 = button.IconButton = Button_1 = button.Button = undefined;

var _reactCssThemr$4 = lib$7;

var _identifiers$4 = identifiers;

var _Button = Button$6;

var _BrowseButton = BrowseButton$2;

var _IconButton$2 = IconButton$7;

var _FontIcon$5 = FontIcon$2;

var _ripple = ripple;

var _ripple2 = _interopRequireDefault$7Y(_ripple);

var _theme$3 = require$$7;

var _theme2$2 = _interopRequireDefault$7Y(_theme$3);

function _interopRequireDefault$7Y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button$4 = (0, _Button.buttonFactory)((0, _ripple2.default)({ centered: false }), _FontIcon$5.FontIcon);
var IconButton$5 = (0, _IconButton$2.iconButtonFactory)((0, _ripple2.default)({ centered: true }), _FontIcon$5.FontIcon);
var BrowseButton = (0, _BrowseButton.browseButtonFactory)((0, _ripple2.default)({ centered: false }), _FontIcon$5.FontIcon);
var ThemedButton = (0, _reactCssThemr$4.themr)(_identifiers$4.BUTTON, _theme2$2.default)(Button$4);
var ThemedIconButton = (0, _reactCssThemr$4.themr)(_identifiers$4.BUTTON, _theme2$2.default)(IconButton$5);
var ThemedBrowseButton = (0, _reactCssThemr$4.themr)(_identifiers$4.BUTTON, _theme2$2.default)(BrowseButton);

button.default = ThemedButton;
var Button_1 = button.Button = ThemedButton;
var IconButton_1$1 = button.IconButton = ThemedIconButton;
button.BrowseButton = ThemedBrowseButton;

var css_248z$1t = ".DelimiterWarning_help__uaMw- {\n  padding: 0 1em;\n  border: 1px solid #3e3e3e;\n  background-color: #e5e5e5;\n  color: #3e3e3e;\n  border-radius: 2px;\n}\n.DelimiterWarning_help__uaMw- em {\n  color: #e84296;\n}";
var style$_ = {"help":"DelimiterWarning_help__uaMw-"};
styleInject(css_248z$1t);

const DelimiterWarning = props => {
    const { values } = props;
    return (React__default$4.createElement("div", { className: style$_.help },
        React__default$4.createElement("p", null, "We noticed you are using a comma, which aren\u2019t allowed in utterances. We are going to assume you are using it as a delimiter and split up the utterances."),
        React__default$4.createElement("p", null, "This will generate the following utterances:"),
        React__default$4.createElement("ul", { style: { listStyle: "none" } }, values.map((utterance, i) => {
            return React__default$4.createElement("li", { key: i }, utterance);
        })),
        React__default$4.createElement("p", null, "If that's not correct, please remove the commas and continue")));
};

var css_248z$1s = ".style_tooltip__yProa {\n  position: relative;\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz {\n  line-height: 1em;\n  font-size: 13px;\n  font-weight: normal;\n  visibility: hidden;\n  background-color: #333;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px;\n  position: absolute;\n  z-index: 10000;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s;\n  white-space: nowrap;\n  min-width: auto;\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz.style_top__OeGzo {\n  bottom: 100%;\n  margin-bottom: 4px;\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz.style_bottom__kv2ub {\n  top: 100%;\n  margin-top: 4px;\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz.style_left__zDeNn {\n  top: 50%;\n  transform: translateY(-50%);\n  left: calc(-50% - 4px);\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz.style_right__-iCka {\n  top: 50%;\n  transform: translateY(-50%);\n  left: calc(100% + 4px);\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz .style_arrow__NPsyZ {\n  content: \"\";\n  position: absolute;\n  border-width: 5px;\n  border-style: solid;\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz .style_arrow__NPsyZ.style_top__OeGzo {\n  top: 100%;\n  left: 50%;\n  border-color: #555 transparent transparent transparent;\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz .style_arrow__NPsyZ.style_bottom__kv2ub {\n  bottom: 100%;\n  left: 50%;\n  border-color: #555 transparent transparent transparent;\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz .style_arrow__NPsyZ.style_right__-iCka {\n  right: 100%;\n  top: 50%;\n  border-color: transparent #555 transparent transparent;\n}\n.style_tooltip__yProa .style_tooltipContent__efNBz .style_arrow__NPsyZ.style_left__zDeNn {\n  left: 100%;\n  top: 50%;\n  border-color: transparent transparent transparent #555;\n}\n.style_tooltip__yProa:hover .style_tooltipContent__efNBz, .style_tooltip__yProa.style_open__lH1sT .style_tooltipContent__efNBz {\n  visibility: visible;\n  opacity: 1;\n}";
var styles$v = {"tooltip":"style_tooltip__yProa","tooltipContent":"style_tooltipContent__efNBz","top":"style_top__OeGzo","bottom":"style_bottom__kv2ub","left":"style_left__zDeNn","right":"style_right__-iCka","arrow":"style_arrow__NPsyZ","open":"style_open__lH1sT"};
styleInject(css_248z$1s);

const Tooltip$5 = ({ children, content, align = "bottom", arrow = false, open = false, style, className, }) => {
    const tooltipClasses = classNames$1(styles$v.tooltip, {
        [styles$v.open]: open, // Shows tooltip when `open` is true
    });
    const contentClasses = classNames$1(styles$v.tooltipContent, {
        [styles$v[align]]: true, // Adds positional class (top, bottom, left, right)
    });
    const arrowClasses = classNames$1(styles$v.arrow, {
        [styles$v[align]]: true, // Adds arrow direction based on align prop
    });
    if (!content) {
        return React__default$4.createElement(React__default$4.Fragment, null, children); // If no content, just render the children
    }
    return (React__default$4.createElement("div", { className: classNames$1(tooltipClasses, className), style: Object.assign({}, style) },
        children,
        " ",
        React__default$4.createElement("span", { className: contentClasses },
            content,
            " ",
            arrow && React__default$4.createElement("span", { className: arrowClasses }),
            " ")));
};

var node = {};

var colors$1 = {};

var pink$1 = {};

Object.defineProperty(pink$1, "__esModule", {
  value: true
});
pink$1.default = void 0;
const pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
pink$1.default = pink;

var deepPurple$1 = {};

Object.defineProperty(deepPurple$1, "__esModule", {
  value: true
});
deepPurple$1.default = void 0;
const deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};
deepPurple$1.default = deepPurple;

var indigo$1 = {};

Object.defineProperty(indigo$1, "__esModule", {
  value: true
});
indigo$1.default = void 0;
const indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
indigo$1.default = indigo;

var cyan$1 = {};

Object.defineProperty(cyan$1, "__esModule", {
  value: true
});
cyan$1.default = void 0;
const cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};
cyan$1.default = cyan;

var teal$1 = {};

Object.defineProperty(teal$1, "__esModule", {
  value: true
});
teal$1.default = void 0;
const teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};
teal$1.default = teal;

var lightGreen$1 = {};

Object.defineProperty(lightGreen$1, "__esModule", {
  value: true
});
lightGreen$1.default = void 0;
const lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};
lightGreen$1.default = lightGreen;

var lime$1 = {};

Object.defineProperty(lime$1, "__esModule", {
  value: true
});
lime$1.default = void 0;
const lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};
lime$1.default = lime;

var yellow$1 = {};

Object.defineProperty(yellow$1, "__esModule", {
  value: true
});
yellow$1.default = void 0;
const yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};
yellow$1.default = yellow;

var amber$1 = {};

Object.defineProperty(amber$1, "__esModule", {
  value: true
});
amber$1.default = void 0;
const amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
amber$1.default = amber;

var deepOrange$1 = {};

Object.defineProperty(deepOrange$1, "__esModule", {
  value: true
});
deepOrange$1.default = void 0;
const deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};
deepOrange$1.default = deepOrange;

var brown$1 = {};

Object.defineProperty(brown$1, "__esModule", {
  value: true
});
brown$1.default = void 0;
const brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};
brown$1.default = brown;

var blueGrey$1 = {};

Object.defineProperty(blueGrey$1, "__esModule", {
  value: true
});
blueGrey$1.default = void 0;
const blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};
blueGrey$1.default = blueGrey;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "amber", {
  enumerable: true,
  get: function () {
    return _amber.default;
  }
});
Object.defineProperty(exports, "blue", {
  enumerable: true,
  get: function () {
    return _blue.default;
  }
});
Object.defineProperty(exports, "blueGrey", {
  enumerable: true,
  get: function () {
    return _blueGrey.default;
  }
});
Object.defineProperty(exports, "brown", {
  enumerable: true,
  get: function () {
    return _brown.default;
  }
});
Object.defineProperty(exports, "common", {
  enumerable: true,
  get: function () {
    return _common.default;
  }
});
Object.defineProperty(exports, "cyan", {
  enumerable: true,
  get: function () {
    return _cyan.default;
  }
});
Object.defineProperty(exports, "deepOrange", {
  enumerable: true,
  get: function () {
    return _deepOrange.default;
  }
});
Object.defineProperty(exports, "deepPurple", {
  enumerable: true,
  get: function () {
    return _deepPurple.default;
  }
});
Object.defineProperty(exports, "green", {
  enumerable: true,
  get: function () {
    return _green.default;
  }
});
Object.defineProperty(exports, "grey", {
  enumerable: true,
  get: function () {
    return _grey.default;
  }
});
Object.defineProperty(exports, "indigo", {
  enumerable: true,
  get: function () {
    return _indigo.default;
  }
});
Object.defineProperty(exports, "lightBlue", {
  enumerable: true,
  get: function () {
    return _lightBlue.default;
  }
});
Object.defineProperty(exports, "lightGreen", {
  enumerable: true,
  get: function () {
    return _lightGreen.default;
  }
});
Object.defineProperty(exports, "lime", {
  enumerable: true,
  get: function () {
    return _lime.default;
  }
});
Object.defineProperty(exports, "orange", {
  enumerable: true,
  get: function () {
    return _orange.default;
  }
});
Object.defineProperty(exports, "pink", {
  enumerable: true,
  get: function () {
    return _pink.default;
  }
});
Object.defineProperty(exports, "purple", {
  enumerable: true,
  get: function () {
    return _purple.default;
  }
});
Object.defineProperty(exports, "red", {
  enumerable: true,
  get: function () {
    return _red.default;
  }
});
Object.defineProperty(exports, "teal", {
  enumerable: true,
  get: function () {
    return _teal.default;
  }
});
Object.defineProperty(exports, "yellow", {
  enumerable: true,
  get: function () {
    return _yellow.default;
  }
});
var _common = _interopRequireDefault(common$2);
var _red = _interopRequireDefault(red$1);
var _pink = _interopRequireDefault(pink$1);
var _purple = _interopRequireDefault(purple$1);
var _deepPurple = _interopRequireDefault(deepPurple$1);
var _indigo = _interopRequireDefault(indigo$1);
var _blue = _interopRequireDefault(blue$1);
var _lightBlue = _interopRequireDefault(lightBlue$1);
var _cyan = _interopRequireDefault(cyan$1);
var _teal = _interopRequireDefault(teal$1);
var _green = _interopRequireDefault(green$1);
var _lightGreen = _interopRequireDefault(lightGreen$1);
var _lime = _interopRequireDefault(lime$1);
var _yellow = _interopRequireDefault(yellow$1);
var _amber = _interopRequireDefault(amber$1);
var _orange = _interopRequireDefault(orange$1);
var _deepOrange = _interopRequireDefault(deepOrange$1);
var _brown = _interopRequireDefault(brown$1);
var _grey = _interopRequireDefault(grey$1);
var _blueGrey = _interopRequireDefault(blueGrey$1);
}(colors$1));

var styles$u = {};

var adaptV4Theme$1 = {};

var _interopRequireDefault$7X = interopRequireDefault$1.exports;
Object.defineProperty(adaptV4Theme$1, "__esModule", {
  value: true
});
adaptV4Theme$1.default = adaptV4Theme;
var _extends2$2b = _interopRequireDefault$7X(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1_ = _interopRequireDefault$7X(objectWithoutPropertiesLoose.exports);
var _system$c = system;
const _excluded$2s = ["defaultProps", "mixins", "overrides", "palette", "props", "styleOverrides"],
  _excluded2$o = ["type", "mode"];
function adaptV4Theme(inputTheme) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(['MUI: adaptV4Theme() is deprecated.', 'Follow the upgrade guide on https://mui.com/r/migration-v4#theme.'].join('\n'));
  }
  const {
      defaultProps = {},
      mixins = {},
      overrides = {},
      palette = {},
      props = {},
      styleOverrides = {}
    } = inputTheme,
    other = (0, _objectWithoutPropertiesLoose2$1_.default)(inputTheme, _excluded$2s);
  const theme = (0, _extends2$2b.default)({}, other, {
    components: {}
  });

  // default props
  Object.keys(defaultProps).forEach(component => {
    const componentValue = theme.components[component] || {};
    componentValue.defaultProps = defaultProps[component];
    theme.components[component] = componentValue;
  });
  Object.keys(props).forEach(component => {
    const componentValue = theme.components[component] || {};
    componentValue.defaultProps = props[component];
    theme.components[component] = componentValue;
  });

  // CSS overrides
  Object.keys(styleOverrides).forEach(component => {
    const componentValue = theme.components[component] || {};
    componentValue.styleOverrides = styleOverrides[component];
    theme.components[component] = componentValue;
  });
  Object.keys(overrides).forEach(component => {
    const componentValue = theme.components[component] || {};
    componentValue.styleOverrides = overrides[component];
    theme.components[component] = componentValue;
  });

  // theme.spacing
  theme.spacing = (0, _system$c.createSpacing)(inputTheme.spacing);

  // theme.mixins.gutters
  const breakpoints = (0, _system$c.createBreakpoints)(inputTheme.breakpoints || {});
  const spacing = theme.spacing;
  theme.mixins = (0, _extends2$2b.default)({
    gutters: (styles = {}) => {
      return (0, _extends2$2b.default)({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, {
        [breakpoints.up('sm')]: (0, _extends2$2b.default)({
          paddingLeft: spacing(3),
          paddingRight: spacing(3)
        }, styles[breakpoints.up('sm')])
      });
    }
  }, mixins);
  const {
      type: typeInput,
      mode: modeInput
    } = palette,
    paletteRest = (0, _objectWithoutPropertiesLoose2$1_.default)(palette, _excluded2$o);
  const finalMode = modeInput || typeInput || 'light';
  theme.palette = (0, _extends2$2b.default)({
    // theme.palette.text.hint
    text: {
      hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
    },
    mode: finalMode,
    type: finalMode
  }, paletteRest);
  return theme;
}

var createMuiStrictModeTheme$1 = {};

var _interopRequireDefault$7W = interopRequireDefault$1.exports;
Object.defineProperty(createMuiStrictModeTheme$1, "__esModule", {
  value: true
});
createMuiStrictModeTheme$1.default = createMuiStrictModeTheme;
var _deepmerge$4 = _interopRequireDefault$7W(deepmerge$2);
var _createTheme$1 = _interopRequireDefault$7W(createTheme$1);
function createMuiStrictModeTheme(options, ...args) {
  return (0, _createTheme$1.default)((0, _deepmerge$4.default)({
    unstable_strictMode: true
  }, options), ...args);
}

var createStyles$1 = {};

Object.defineProperty(createStyles$1, "__esModule", {
  value: true
});
createStyles$1.default = createStyles;
let warnedOnce = false;

// To remove in v6
function createStyles(styles) {
  if (!warnedOnce) {
    console.warn(['MUI: createStyles from @mui/material/styles is deprecated.', 'Please use @mui/styles/createStyles'].join('\n'));
    warnedOnce = true;
  }
  return styles;
}

var cssUtils = {};

Object.defineProperty(cssUtils, "__esModule", {
  value: true
});
cssUtils.alignProperty = alignProperty;
cssUtils.convertLength = convertLength;
cssUtils.fontGrid = fontGrid;
cssUtils.getUnit = getUnit;
cssUtils.isUnitless = isUnitless;
cssUtils.responsiveProperty = responsiveProperty;
cssUtils.toUnitless = toUnitless;
function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
}

// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}

// Emulate the sass function "unitless"
function toUnitless(length) {
  return parseFloat(length);
}

// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function convertLength(baseFontSize) {
  return (length, toUnit) => {
    const fromUnit = getUnit(length);

    // Optimize for cases where `from` and `to` units are accidentally the same.
    if (fromUnit === toUnit) {
      return length;
    }

    // Convert input length to pixels.
    let pxLength = toUnitless(length);
    if (fromUnit !== 'px') {
      if (fromUnit === 'em') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === 'rem') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      }
    }

    // Convert length in pixels to the output unit
    let outputLength = pxLength;
    if (toUnit !== 'px') {
      if (toUnit === 'em') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === 'rem') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }
    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty({
  size,
  grid
}) {
  const sizeBelow = size - size % grid;
  const sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}

// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function fontGrid({
  lineHeight,
  pixels,
  htmlFontSize
}) {
  return pixels / (lineHeight * htmlFontSize);
}

/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */
function responsiveProperty({
  cssProperty,
  min,
  max,
  unit = 'rem',
  breakpoints = [600, 900, 1200],
  transform = null
}) {
  const output = {
    [cssProperty]: `${min}${unit}`
  };
  const factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(breakpoint => {
    let value = min + factor * breakpoint;
    if (transform !== null) {
      value = transform(value);
    }
    output[`@media (min-width:${breakpoint}px)`] = {
      [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
    };
  });
  return output;
}

var responsiveFontSizes$1 = {};

var _interopRequireDefault$7V = interopRequireDefault$1.exports;
Object.defineProperty(responsiveFontSizes$1, "__esModule", {
  value: true
});
responsiveFontSizes$1.default = responsiveFontSizes;
var _extends2$2a = _interopRequireDefault$7V(_extends$19.exports);
var _formatMuiErrorMessage2$5 = _interopRequireDefault$7V(formatMuiErrorMessage$2);
var _cssUtils = cssUtils;
function responsiveFontSizes(themeInput, options = {}) {
  const {
    breakpoints = ['sm', 'md', 'lg'],
    disableAlign = false,
    factor = 2,
    variants = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline']
  } = options;
  const theme = (0, _extends2$2a.default)({}, themeInput);
  theme.typography = (0, _extends2$2a.default)({}, theme.typography);
  const typography = theme.typography;

  // Convert between CSS lengths e.g. em->px or px->rem
  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
  const convert = (0, _cssUtils.convertLength)(typography.htmlFontSize);
  const breakpointValues = breakpoints.map(x => theme.breakpoints.values[x]);
  variants.forEach(variant => {
    const style = typography[variant];
    if (!style) {
      return;
    }
    const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
    if (remFontSize <= 1) {
      return;
    }
    const maxFontSize = remFontSize;
    const minFontSize = 1 + (maxFontSize - 1) / factor;
    let {
      lineHeight
    } = style;
    if (!(0, _cssUtils.isUnitless)(lineHeight) && !disableAlign) {
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported non-unitless line height with grid alignment.
Use unitless line heights instead.` : (0, _formatMuiErrorMessage2$5.default)(6));
    }
    if (!(0, _cssUtils.isUnitless)(lineHeight)) {
      // make it unitless
      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
    }
    let transform = null;
    if (!disableAlign) {
      transform = value => (0, _cssUtils.alignProperty)({
        size: value,
        grid: (0, _cssUtils.fontGrid)({
          pixels: 4,
          lineHeight,
          htmlFontSize: typography.htmlFontSize
        })
      });
    }
    typography[variant] = (0, _extends2$2a.default)({}, style, (0, _cssUtils.responsiveProperty)({
      cssProperty: 'fontSize',
      min: minFontSize,
      max: maxFontSize,
      unit: 'rem',
      breakpoints: breakpointValues,
      transform
    }));
  });
  return theme;
}

var ThemeProvider$1 = {};

var _interopRequireDefault$7U = interopRequireDefault$1.exports;
Object.defineProperty(ThemeProvider$1, "__esModule", {
  value: true
});
ThemeProvider$1.default = ThemeProvider;
var _extends2$29 = _interopRequireDefault$7U(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1Z = _interopRequireDefault$7U(objectWithoutPropertiesLoose.exports);
_interopRequireWildcard$3S(React__default$4);
var _propTypes$2x = _interopRequireDefault$7U(propTypes.exports);
var _system$b = system;
var _identifier$3 = _interopRequireDefault$7U(identifier);
var _jsxRuntime$2v = require$$11;
const _excluded$2r = ["theme"];
function _getRequireWildcardCache$3B(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3B = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3S(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3B(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ThemeProvider(_ref) {
  let {
      theme: themeInput
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2$1Z.default)(_ref, _excluded$2r);
  const scopedTheme = themeInput[_identifier$3.default];
  return /*#__PURE__*/(0, _jsxRuntime$2v.jsx)(_system$b.ThemeProvider, (0, _extends2$29.default)({}, props, {
    themeId: scopedTheme ? _identifier$3.default : undefined,
    theme: scopedTheme || themeInput
  }));
}
process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: _propTypes$2x.default.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: _propTypes$2x.default.oneOfType([_propTypes$2x.default.object, _propTypes$2x.default.func]).isRequired
} : void 0;

var makeStyles$1 = {};

var _interopRequireDefault$7T = interopRequireDefault$1.exports;
Object.defineProperty(makeStyles$1, "__esModule", {
  value: true
});
makeStyles$1.default = makeStyles;
var _formatMuiErrorMessage2$4 = _interopRequireDefault$7T(formatMuiErrorMessage$2);
function makeStyles() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: makeStyles is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : (0, _formatMuiErrorMessage2$4.default)(14));
}

var withStyles$1 = {};

var _interopRequireDefault$7S = interopRequireDefault$1.exports;
Object.defineProperty(withStyles$1, "__esModule", {
  value: true
});
withStyles$1.default = withStyles;
var _formatMuiErrorMessage2$3 = _interopRequireDefault$7S(formatMuiErrorMessage$2);
function withStyles() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: withStyles is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : (0, _formatMuiErrorMessage2$3.default)(15));
}

var withTheme$1 = {};

var _interopRequireDefault$7R = interopRequireDefault$1.exports;
Object.defineProperty(withTheme$1, "__esModule", {
  value: true
});
withTheme$1.default = withTheme;
var _formatMuiErrorMessage2$2 = _interopRequireDefault$7R(formatMuiErrorMessage$2);
function withTheme() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: withTheme is no longer exported from @mui/material/styles.
You have to import it from @mui/styles.
See https://mui.com/r/migration-v4/#mui-material-styles for more details.` : (0, _formatMuiErrorMessage2$2.default)(16));
}

var CssVarsProvider$1 = {};

var experimental_extendTheme = {};

var shouldSkipGeneratingVar$1 = {};

Object.defineProperty(shouldSkipGeneratingVar$1, "__esModule", {
  value: true
});
shouldSkipGeneratingVar$1.default = shouldSkipGeneratingVar;
function shouldSkipGeneratingVar(keys) {
  var _keys$;
  return !!keys[0].match(/(cssVarPrefix|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) ||
  // ends with sxConfig
  keys[0] === 'palette' && !!((_keys$ = keys[1]) != null && _keys$.match(/(mode|contrastThreshold|tonalOffset)/));
}

var _interopRequireDefault$7Q = interopRequireDefault$1.exports;
Object.defineProperty(experimental_extendTheme, "__esModule", {
  value: true
});
experimental_extendTheme.createGetCssVar = void 0;
experimental_extendTheme.default = extendTheme;
var _extends2$28 = _interopRequireDefault$7Q(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1Y = _interopRequireDefault$7Q(objectWithoutPropertiesLoose.exports);
var _deepmerge$3 = _interopRequireDefault$7Q(deepmerge$2);
var _system$a = system;
var _styleFunctionSx$2 = _interopRequireWildcard$3R(styleFunctionSx);
var _colorManipulator$m = colorManipulator;
var _shouldSkipGeneratingVar = _interopRequireDefault$7Q(shouldSkipGeneratingVar$1);
var _createTheme = _interopRequireDefault$7Q(createTheme$1);
var _getOverlayAlpha = _interopRequireDefault$7Q(getOverlayAlpha$1);
const _excluded$2q = ["colorSchemes", "cssVarPrefix", "shouldSkipGeneratingVar"],
  _excluded2$n = ["palette"];
function _getRequireWildcardCache$3A(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3A = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3R(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3A(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultDarkOverlays = [...Array(25)].map((_, index) => {
  if (index === 0) {
    return undefined;
  }
  const overlay = (0, _getOverlayAlpha.default)(index);
  return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function assignNode(obj, keys) {
  keys.forEach(k => {
    if (!obj[k]) {
      obj[k] = {};
    }
  });
}
function setColor(obj, key, defaultValue) {
  if (!obj[key] && defaultValue) {
    obj[key] = defaultValue;
  }
}
function toRgb(color) {
  if (!color || !color.startsWith('hsl')) {
    return color;
  }
  return (0, _colorManipulator$m.hslToRgb)(color);
}
function setColorChannel(obj, key) {
  if (!(`${key}Channel` in obj)) {
    // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, _colorManipulator$m.private_safeColorChannel)(toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
  }
}
const silent = fn => {
  try {
    return fn();
  } catch (error) {
    // ignore error
  }
  return undefined;
};
const createGetCssVar = (cssVarPrefix = 'mui') => (0, _system$a.unstable_createGetCssVar)(cssVarPrefix);
experimental_extendTheme.createGetCssVar = createGetCssVar;
function extendTheme(options = {}, ...args) {
  var _colorSchemesInput$li, _colorSchemesInput$da, _colorSchemesInput$li2, _colorSchemesInput$li3, _colorSchemesInput$da2, _colorSchemesInput$da3;
  const {
      colorSchemes: colorSchemesInput = {},
      cssVarPrefix = 'mui',
      shouldSkipGeneratingVar = _shouldSkipGeneratingVar.default
    } = options,
    input = (0, _objectWithoutPropertiesLoose2$1Y.default)(options, _excluded$2q);
  const getCssVar = createGetCssVar(cssVarPrefix);
  const _createThemeWithoutVa = (0, _createTheme.default)((0, _extends2$28.default)({}, input, colorSchemesInput.light && {
      palette: (_colorSchemesInput$li = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li.palette
    })),
    {
      palette: lightPalette
    } = _createThemeWithoutVa,
    muiTheme = (0, _objectWithoutPropertiesLoose2$1Y.default)(_createThemeWithoutVa, _excluded2$n);
  const {
    palette: darkPalette
  } = (0, _createTheme.default)({
    palette: (0, _extends2$28.default)({
      mode: 'dark'
    }, (_colorSchemesInput$da = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da.palette)
  });
  let theme = (0, _extends2$28.default)({}, muiTheme, {
    cssVarPrefix,
    getCssVar,
    colorSchemes: (0, _extends2$28.default)({}, colorSchemesInput, {
      light: (0, _extends2$28.default)({}, colorSchemesInput.light, {
        palette: lightPalette,
        opacity: (0, _extends2$28.default)({
          inputPlaceholder: 0.42,
          inputUnderline: 0.42,
          switchTrackDisabled: 0.12,
          switchTrack: 0.38
        }, (_colorSchemesInput$li2 = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li2.opacity),
        overlays: ((_colorSchemesInput$li3 = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li3.overlays) || []
      }),
      dark: (0, _extends2$28.default)({}, colorSchemesInput.dark, {
        palette: darkPalette,
        opacity: (0, _extends2$28.default)({
          inputPlaceholder: 0.5,
          inputUnderline: 0.7,
          switchTrackDisabled: 0.2,
          switchTrack: 0.3
        }, (_colorSchemesInput$da2 = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da2.opacity),
        overlays: ((_colorSchemesInput$da3 = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da3.overlays) || defaultDarkOverlays
      })
    })
  });
  Object.keys(theme.colorSchemes).forEach(key => {
    const palette = theme.colorSchemes[key].palette;
    const setCssVarColor = cssVar => {
      const tokens = cssVar.split('-');
      const color = tokens[1];
      const colorToken = tokens[2];
      return getCssVar(cssVar, palette[color][colorToken]);
    };

    // attach black & white channels to common node
    if (key === 'light') {
      setColor(palette.common, 'background', '#fff');
      setColor(palette.common, 'onBackground', '#000');
    } else {
      setColor(palette.common, 'background', '#000');
      setColor(palette.common, 'onBackground', '#fff');
    }

    // assign component variables
    assignNode(palette, ['Alert', 'AppBar', 'Avatar', 'Button', 'Chip', 'FilledInput', 'LinearProgress', 'Skeleton', 'Slider', 'SnackbarContent', 'SpeedDialAction', 'StepConnector', 'StepContent', 'Switch', 'TableCell', 'Tooltip']);
    if (key === 'light') {
      setColor(palette.Alert, 'errorColor', (0, _colorManipulator$m.private_safeDarken)(palette.error.light, 0.6));
      setColor(palette.Alert, 'infoColor', (0, _colorManipulator$m.private_safeDarken)(palette.info.light, 0.6));
      setColor(palette.Alert, 'successColor', (0, _colorManipulator$m.private_safeDarken)(palette.success.light, 0.6));
      setColor(palette.Alert, 'warningColor', (0, _colorManipulator$m.private_safeDarken)(palette.warning.light, 0.6));
      setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
      setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
      setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
      setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
      setColor(palette.Alert, 'errorFilledColor', silent(() => lightPalette.getContrastText(palette.error.main)));
      setColor(palette.Alert, 'infoFilledColor', silent(() => lightPalette.getContrastText(palette.info.main)));
      setColor(palette.Alert, 'successFilledColor', silent(() => lightPalette.getContrastText(palette.success.main)));
      setColor(palette.Alert, 'warningFilledColor', silent(() => lightPalette.getContrastText(palette.warning.main)));
      setColor(palette.Alert, 'errorStandardBg', (0, _colorManipulator$m.private_safeLighten)(palette.error.light, 0.9));
      setColor(palette.Alert, 'infoStandardBg', (0, _colorManipulator$m.private_safeLighten)(palette.info.light, 0.9));
      setColor(palette.Alert, 'successStandardBg', (0, _colorManipulator$m.private_safeLighten)(palette.success.light, 0.9));
      setColor(palette.Alert, 'warningStandardBg', (0, _colorManipulator$m.private_safeLighten)(palette.warning.light, 0.9));
      setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
      setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
      setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
      setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
      setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
      setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
      setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
      setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
      setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
      setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
      setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
      setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
      setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
      setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
      setColor(palette.LinearProgress, 'primaryBg', (0, _colorManipulator$m.private_safeLighten)(palette.primary.main, 0.62));
      setColor(palette.LinearProgress, 'secondaryBg', (0, _colorManipulator$m.private_safeLighten)(palette.secondary.main, 0.62));
      setColor(palette.LinearProgress, 'errorBg', (0, _colorManipulator$m.private_safeLighten)(palette.error.main, 0.62));
      setColor(palette.LinearProgress, 'infoBg', (0, _colorManipulator$m.private_safeLighten)(palette.info.main, 0.62));
      setColor(palette.LinearProgress, 'successBg', (0, _colorManipulator$m.private_safeLighten)(palette.success.main, 0.62));
      setColor(palette.LinearProgress, 'warningBg', (0, _colorManipulator$m.private_safeLighten)(palette.warning.main, 0.62));
      setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
      setColor(palette.Slider, 'primaryTrack', (0, _colorManipulator$m.private_safeLighten)(palette.primary.main, 0.62));
      setColor(palette.Slider, 'secondaryTrack', (0, _colorManipulator$m.private_safeLighten)(palette.secondary.main, 0.62));
      setColor(palette.Slider, 'errorTrack', (0, _colorManipulator$m.private_safeLighten)(palette.error.main, 0.62));
      setColor(palette.Slider, 'infoTrack', (0, _colorManipulator$m.private_safeLighten)(palette.info.main, 0.62));
      setColor(palette.Slider, 'successTrack', (0, _colorManipulator$m.private_safeLighten)(palette.success.main, 0.62));
      setColor(palette.Slider, 'warningTrack', (0, _colorManipulator$m.private_safeLighten)(palette.warning.main, 0.62));
      const snackbarContentBackground = (0, _colorManipulator$m.private_safeEmphasize)(palette.background.default, 0.8);
      setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
      setColor(palette.SnackbarContent, 'color', silent(() => lightPalette.getContrastText(snackbarContentBackground)));
      setColor(palette.SpeedDialAction, 'fabHoverBg', (0, _colorManipulator$m.private_safeEmphasize)(palette.background.paper, 0.15));
      setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
      setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
      setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
      setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
      setColor(palette.Switch, 'primaryDisabledColor', (0, _colorManipulator$m.private_safeLighten)(palette.primary.main, 0.62));
      setColor(palette.Switch, 'secondaryDisabledColor', (0, _colorManipulator$m.private_safeLighten)(palette.secondary.main, 0.62));
      setColor(palette.Switch, 'errorDisabledColor', (0, _colorManipulator$m.private_safeLighten)(palette.error.main, 0.62));
      setColor(palette.Switch, 'infoDisabledColor', (0, _colorManipulator$m.private_safeLighten)(palette.info.main, 0.62));
      setColor(palette.Switch, 'successDisabledColor', (0, _colorManipulator$m.private_safeLighten)(palette.success.main, 0.62));
      setColor(palette.Switch, 'warningDisabledColor', (0, _colorManipulator$m.private_safeLighten)(palette.warning.main, 0.62));
      setColor(palette.TableCell, 'border', (0, _colorManipulator$m.private_safeLighten)((0, _colorManipulator$m.private_safeAlpha)(palette.divider, 1), 0.88));
      setColor(palette.Tooltip, 'bg', (0, _colorManipulator$m.private_safeAlpha)(palette.grey[700], 0.92));
    } else {
      setColor(palette.Alert, 'errorColor', (0, _colorManipulator$m.private_safeLighten)(palette.error.light, 0.6));
      setColor(palette.Alert, 'infoColor', (0, _colorManipulator$m.private_safeLighten)(palette.info.light, 0.6));
      setColor(palette.Alert, 'successColor', (0, _colorManipulator$m.private_safeLighten)(palette.success.light, 0.6));
      setColor(palette.Alert, 'warningColor', (0, _colorManipulator$m.private_safeLighten)(palette.warning.light, 0.6));
      setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
      setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
      setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
      setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
      setColor(palette.Alert, 'errorFilledColor', silent(() => darkPalette.getContrastText(palette.error.dark)));
      setColor(palette.Alert, 'infoFilledColor', silent(() => darkPalette.getContrastText(palette.info.dark)));
      setColor(palette.Alert, 'successFilledColor', silent(() => darkPalette.getContrastText(palette.success.dark)));
      setColor(palette.Alert, 'warningFilledColor', silent(() => darkPalette.getContrastText(palette.warning.dark)));
      setColor(palette.Alert, 'errorStandardBg', (0, _colorManipulator$m.private_safeDarken)(palette.error.light, 0.9));
      setColor(palette.Alert, 'infoStandardBg', (0, _colorManipulator$m.private_safeDarken)(palette.info.light, 0.9));
      setColor(palette.Alert, 'successStandardBg', (0, _colorManipulator$m.private_safeDarken)(palette.success.light, 0.9));
      setColor(palette.Alert, 'warningStandardBg', (0, _colorManipulator$m.private_safeDarken)(palette.warning.light, 0.9));
      setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
      setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
      setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
      setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
      setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
      setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
      setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
      setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
      setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
      setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
      setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
      setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
      setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
      setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
      setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
      setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
      setColor(palette.LinearProgress, 'primaryBg', (0, _colorManipulator$m.private_safeDarken)(palette.primary.main, 0.5));
      setColor(palette.LinearProgress, 'secondaryBg', (0, _colorManipulator$m.private_safeDarken)(palette.secondary.main, 0.5));
      setColor(palette.LinearProgress, 'errorBg', (0, _colorManipulator$m.private_safeDarken)(palette.error.main, 0.5));
      setColor(palette.LinearProgress, 'infoBg', (0, _colorManipulator$m.private_safeDarken)(palette.info.main, 0.5));
      setColor(palette.LinearProgress, 'successBg', (0, _colorManipulator$m.private_safeDarken)(palette.success.main, 0.5));
      setColor(palette.LinearProgress, 'warningBg', (0, _colorManipulator$m.private_safeDarken)(palette.warning.main, 0.5));
      setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
      setColor(palette.Slider, 'primaryTrack', (0, _colorManipulator$m.private_safeDarken)(palette.primary.main, 0.5));
      setColor(palette.Slider, 'secondaryTrack', (0, _colorManipulator$m.private_safeDarken)(palette.secondary.main, 0.5));
      setColor(palette.Slider, 'errorTrack', (0, _colorManipulator$m.private_safeDarken)(palette.error.main, 0.5));
      setColor(palette.Slider, 'infoTrack', (0, _colorManipulator$m.private_safeDarken)(palette.info.main, 0.5));
      setColor(palette.Slider, 'successTrack', (0, _colorManipulator$m.private_safeDarken)(palette.success.main, 0.5));
      setColor(palette.Slider, 'warningTrack', (0, _colorManipulator$m.private_safeDarken)(palette.warning.main, 0.5));
      const snackbarContentBackground = (0, _colorManipulator$m.private_safeEmphasize)(palette.background.default, 0.98);
      setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
      setColor(palette.SnackbarContent, 'color', silent(() => darkPalette.getContrastText(snackbarContentBackground)));
      setColor(palette.SpeedDialAction, 'fabHoverBg', (0, _colorManipulator$m.private_safeEmphasize)(palette.background.paper, 0.15));
      setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
      setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
      setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
      setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
      setColor(palette.Switch, 'primaryDisabledColor', (0, _colorManipulator$m.private_safeDarken)(palette.primary.main, 0.55));
      setColor(palette.Switch, 'secondaryDisabledColor', (0, _colorManipulator$m.private_safeDarken)(palette.secondary.main, 0.55));
      setColor(palette.Switch, 'errorDisabledColor', (0, _colorManipulator$m.private_safeDarken)(palette.error.main, 0.55));
      setColor(palette.Switch, 'infoDisabledColor', (0, _colorManipulator$m.private_safeDarken)(palette.info.main, 0.55));
      setColor(palette.Switch, 'successDisabledColor', (0, _colorManipulator$m.private_safeDarken)(palette.success.main, 0.55));
      setColor(palette.Switch, 'warningDisabledColor', (0, _colorManipulator$m.private_safeDarken)(palette.warning.main, 0.55));
      setColor(palette.TableCell, 'border', (0, _colorManipulator$m.private_safeDarken)((0, _colorManipulator$m.private_safeAlpha)(palette.divider, 1), 0.68));
      setColor(palette.Tooltip, 'bg', (0, _colorManipulator$m.private_safeAlpha)(palette.grey[700], 0.92));
    }

    // MUI X - DataGrid needs this token.
    setColorChannel(palette.background, 'default');

    // added for consistency with the `background.default` token
    setColorChannel(palette.background, 'paper');
    setColorChannel(palette.common, 'background');
    setColorChannel(palette.common, 'onBackground');
    setColorChannel(palette, 'divider');
    Object.keys(palette).forEach(color => {
      const colors = palette[color];

      // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.

      if (colors && typeof colors === 'object') {
        // Silent the error for custom palettes.
        if (colors.main) {
          setColor(palette[color], 'mainChannel', (0, _colorManipulator$m.private_safeColorChannel)(toRgb(colors.main)));
        }
        if (colors.light) {
          setColor(palette[color], 'lightChannel', (0, _colorManipulator$m.private_safeColorChannel)(toRgb(colors.light)));
        }
        if (colors.dark) {
          setColor(palette[color], 'darkChannel', (0, _colorManipulator$m.private_safeColorChannel)(toRgb(colors.dark)));
        }
        if (colors.contrastText) {
          setColor(palette[color], 'contrastTextChannel', (0, _colorManipulator$m.private_safeColorChannel)(toRgb(colors.contrastText)));
        }
        if (color === 'text') {
          // Text colors: text.primary, text.secondary
          setColorChannel(palette[color], 'primary');
          setColorChannel(palette[color], 'secondary');
        }
        if (color === 'action') {
          // Action colors: action.active, action.selected
          if (colors.active) {
            setColorChannel(palette[color], 'active');
          }
          if (colors.selected) {
            setColorChannel(palette[color], 'selected');
          }
        }
      }
    });
  });
  theme = args.reduce((acc, argument) => (0, _deepmerge$3.default)(acc, argument), theme);
  const parserConfig = {
    prefix: cssVarPrefix,
    shouldSkipGeneratingVar
  };
  const {
    vars: themeVars,
    generateCssVars
  } = (0, _system$a.unstable_prepareCssVars)(theme, parserConfig);
  theme.vars = themeVars;
  theme.generateCssVars = generateCssVars;
  theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
  theme.unstable_sxConfig = (0, _extends2$28.default)({}, _styleFunctionSx$2.unstable_defaultSxConfig, input == null ? void 0 : input.unstable_sxConfig);
  theme.unstable_sx = function sx(props) {
    return (0, _styleFunctionSx$2.default)({
      sx: props,
      theme: this
    });
  };
  return theme;
}

var excludeVariablesFromRoot$1 = {};

Object.defineProperty(excludeVariablesFromRoot$1, "__esModule", {
  value: true
});
excludeVariablesFromRoot$1.default = void 0;
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultMode="dark"`
 */
const excludeVariablesFromRoot = cssVarPrefix => [...[...Array(24)].map((_, index) => `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index + 1}`), `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`, `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`];
excludeVariablesFromRoot$1.default = excludeVariablesFromRoot;

var InitColorSchemeScript$1 = {};

var InitColorSchemeScript = {};

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _InitColorSchemeScript.default;
  }
});
var _InitColorSchemeScript = _interopRequireDefault(InitColorSchemeScript$3);
}(InitColorSchemeScript));

var _interopRequireDefault$7P = interopRequireDefault$1.exports;
Object.defineProperty(InitColorSchemeScript$1, "__esModule", {
  value: true
});
InitColorSchemeScript$1.defaultConfig = InitColorSchemeScript$1.default = void 0;
var _extends2$27 = _interopRequireDefault$7P(_extends$19.exports);
_interopRequireWildcard$3Q(React__default$4);
var _InitColorSchemeScript$1 = _interopRequireDefault$7P(InitColorSchemeScript);
var _jsxRuntime$2u = require$$11;
function _getRequireWildcardCache$3z(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3z = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3Q(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3z(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultConfig = InitColorSchemeScript$1.defaultConfig = {
  attribute: 'data-mui-color-scheme',
  colorSchemeStorageKey: 'mui-color-scheme',
  defaultLightColorScheme: 'light',
  defaultDarkColorScheme: 'dark',
  modeStorageKey: 'mui-mode'
};
InitColorSchemeScript$1.default = function InitColorSchemeScript(props) {
  return /*#__PURE__*/(0, _jsxRuntime$2u.jsx)(_InitColorSchemeScript$1.default, (0, _extends2$27.default)({}, defaultConfig, props));
};

// do not remove the following import (https://github.com/microsoft/TypeScript/issues/29808#issuecomment-1320713018)
/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-ignore
var _interopRequireDefault$7O = interopRequireDefault$1.exports;
Object.defineProperty(CssVarsProvider$1, "__esModule", {
  value: true
});
CssVarsProvider$1.useColorScheme = CssVarsProvider$1.getInitColorSchemeScript = CssVarsProvider$1.Experimental_CssVarsProvider = void 0;
var _extends2$26 = _interopRequireDefault$7O(_extends$19.exports);
var _system$9 = system;
var _styleFunctionSx$1 = _interopRequireDefault$7O(styleFunctionSx);
var _experimental_extendTheme = _interopRequireDefault$7O(experimental_extendTheme);
var _createTypography = _interopRequireDefault$7O(createTypography$1);
var _excludeVariablesFromRoot = _interopRequireDefault$7O(excludeVariablesFromRoot$1);
var _identifier$2 = _interopRequireDefault$7O(identifier);
var _InitColorSchemeScript = InitColorSchemeScript$1;
const defaultTheme$2 = (0, _experimental_extendTheme.default)();
const {
  CssVarsProvider,
  useColorScheme,
  getInitColorSchemeScript: getInitColorSchemeScriptSystem
} = (0, _system$9.unstable_createCssVarsProvider)({
  themeId: _identifier$2.default,
  theme: defaultTheme$2,
  attribute: _InitColorSchemeScript.defaultConfig.attribute,
  colorSchemeStorageKey: _InitColorSchemeScript.defaultConfig.colorSchemeStorageKey,
  modeStorageKey: _InitColorSchemeScript.defaultConfig.modeStorageKey,
  defaultColorScheme: {
    light: _InitColorSchemeScript.defaultConfig.defaultLightColorScheme,
    dark: _InitColorSchemeScript.defaultConfig.defaultDarkColorScheme
  },
  resolveTheme: theme => {
    const newTheme = (0, _extends2$26.default)({}, theme, {
      typography: (0, _createTypography.default)(theme.palette, theme.typography)
    });
    newTheme.unstable_sx = function sx(props) {
      return (0, _styleFunctionSx$1.default)({
        sx: props,
        theme: this
      });
    };
    return newTheme;
  },
  excludeVariablesFromRoot: _excludeVariablesFromRoot.default
});

/**
 * @deprecated Use `InitColorSchemeScript` instead
 * ```diff
 * - import { getInitColorSchemeScript } from '@mui/material/styles';
 * + import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';
 *
 * - getInitColorSchemeScript();
 * + <InitColorSchemeScript />;
 * ```
 */
CssVarsProvider$1.useColorScheme = useColorScheme;
CssVarsProvider$1.Experimental_CssVarsProvider = CssVarsProvider;
CssVarsProvider$1.getInitColorSchemeScript = getInitColorSchemeScriptSystem;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  experimental_sx: true,
  THEME_ID: true,
  adaptV4Theme: true,
  hexToRgb: true,
  rgbToHex: true,
  hslToRgb: true,
  decomposeColor: true,
  recomposeColor: true,
  getContrastRatio: true,
  getLuminance: true,
  emphasize: true,
  alpha: true,
  darken: true,
  lighten: true,
  css: true,
  keyframes: true,
  StyledEngineProvider: true,
  createTheme: true,
  createMuiTheme: true,
  unstable_createMuiStrictModeTheme: true,
  createStyles: true,
  unstable_getUnit: true,
  unstable_toUnitless: true,
  responsiveFontSizes: true,
  duration: true,
  easing: true,
  useTheme: true,
  useThemeProps: true,
  styled: true,
  experimentalStyled: true,
  ThemeProvider: true,
  makeStyles: true,
  withStyles: true,
  withTheme: true,
  experimental_extendTheme: true,
  getOverlayAlpha: true,
  shouldSkipGeneratingVar: true,
  private_createTypography: true,
  private_createMixins: true,
  private_excludeVariablesFromRoot: true
};
Object.defineProperty(exports, "StyledEngineProvider", {
  enumerable: true,
  get: function () {
    return _system.StyledEngineProvider;
  }
});
Object.defineProperty(exports, "THEME_ID", {
  enumerable: true,
  get: function () {
    return _identifier.default;
  }
});
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function () {
    return _ThemeProvider.default;
  }
});
Object.defineProperty(exports, "adaptV4Theme", {
  enumerable: true,
  get: function () {
    return _adaptV4Theme.default;
  }
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function () {
    return _system.alpha;
  }
});
Object.defineProperty(exports, "createMuiTheme", {
  enumerable: true,
  get: function () {
    return _createTheme.createMuiTheme;
  }
});
Object.defineProperty(exports, "createStyles", {
  enumerable: true,
  get: function () {
    return _createStyles.default;
  }
});
Object.defineProperty(exports, "createTheme", {
  enumerable: true,
  get: function () {
    return _createTheme.default;
  }
});
Object.defineProperty(exports, "css", {
  enumerable: true,
  get: function () {
    return _system.css;
  }
});
Object.defineProperty(exports, "darken", {
  enumerable: true,
  get: function () {
    return _system.darken;
  }
});
Object.defineProperty(exports, "decomposeColor", {
  enumerable: true,
  get: function () {
    return _system.decomposeColor;
  }
});
Object.defineProperty(exports, "duration", {
  enumerable: true,
  get: function () {
    return _createTransitions.duration;
  }
});
Object.defineProperty(exports, "easing", {
  enumerable: true,
  get: function () {
    return _createTransitions.easing;
  }
});
Object.defineProperty(exports, "emphasize", {
  enumerable: true,
  get: function () {
    return _system.emphasize;
  }
});
Object.defineProperty(exports, "experimentalStyled", {
  enumerable: true,
  get: function () {
    return _styled.default;
  }
});
Object.defineProperty(exports, "experimental_extendTheme", {
  enumerable: true,
  get: function () {
    return _experimental_extendTheme.default;
  }
});
exports.experimental_sx = experimental_sx;
Object.defineProperty(exports, "getContrastRatio", {
  enumerable: true,
  get: function () {
    return _system.getContrastRatio;
  }
});
Object.defineProperty(exports, "getLuminance", {
  enumerable: true,
  get: function () {
    return _system.getLuminance;
  }
});
Object.defineProperty(exports, "getOverlayAlpha", {
  enumerable: true,
  get: function () {
    return _getOverlayAlpha.default;
  }
});
Object.defineProperty(exports, "hexToRgb", {
  enumerable: true,
  get: function () {
    return _system.hexToRgb;
  }
});
Object.defineProperty(exports, "hslToRgb", {
  enumerable: true,
  get: function () {
    return _system.hslToRgb;
  }
});
Object.defineProperty(exports, "keyframes", {
  enumerable: true,
  get: function () {
    return _system.keyframes;
  }
});
Object.defineProperty(exports, "lighten", {
  enumerable: true,
  get: function () {
    return _system.lighten;
  }
});
Object.defineProperty(exports, "makeStyles", {
  enumerable: true,
  get: function () {
    return _makeStyles.default;
  }
});
Object.defineProperty(exports, "private_createMixins", {
  enumerable: true,
  get: function () {
    return _createMixins.default;
  }
});
Object.defineProperty(exports, "private_createTypography", {
  enumerable: true,
  get: function () {
    return _createTypography.default;
  }
});
Object.defineProperty(exports, "private_excludeVariablesFromRoot", {
  enumerable: true,
  get: function () {
    return _excludeVariablesFromRoot.default;
  }
});
Object.defineProperty(exports, "recomposeColor", {
  enumerable: true,
  get: function () {
    return _system.recomposeColor;
  }
});
Object.defineProperty(exports, "responsiveFontSizes", {
  enumerable: true,
  get: function () {
    return _responsiveFontSizes.default;
  }
});
Object.defineProperty(exports, "rgbToHex", {
  enumerable: true,
  get: function () {
    return _system.rgbToHex;
  }
});
Object.defineProperty(exports, "shouldSkipGeneratingVar", {
  enumerable: true,
  get: function () {
    return _shouldSkipGeneratingVar.default;
  }
});
Object.defineProperty(exports, "styled", {
  enumerable: true,
  get: function () {
    return _styled.default;
  }
});
Object.defineProperty(exports, "unstable_createMuiStrictModeTheme", {
  enumerable: true,
  get: function () {
    return _createMuiStrictModeTheme.default;
  }
});
Object.defineProperty(exports, "unstable_getUnit", {
  enumerable: true,
  get: function () {
    return _cssUtils.getUnit;
  }
});
Object.defineProperty(exports, "unstable_toUnitless", {
  enumerable: true,
  get: function () {
    return _cssUtils.toUnitless;
  }
});
Object.defineProperty(exports, "useTheme", {
  enumerable: true,
  get: function () {
    return _useTheme.default;
  }
});
Object.defineProperty(exports, "useThemeProps", {
  enumerable: true,
  get: function () {
    return _useThemeProps.default;
  }
});
Object.defineProperty(exports, "withStyles", {
  enumerable: true,
  get: function () {
    return _withStyles.default;
  }
});
Object.defineProperty(exports, "withTheme", {
  enumerable: true,
  get: function () {
    return _withTheme.default;
  }
});
var _formatMuiErrorMessage2 = _interopRequireDefault(formatMuiErrorMessage$2);
var _identifier = _interopRequireDefault(identifier);
var _adaptV4Theme = _interopRequireDefault(adaptV4Theme$1);
var _system = system;
var _createTheme = _interopRequireWildcard(createTheme$1);
var _createMuiStrictModeTheme = _interopRequireDefault(createMuiStrictModeTheme$1);
var _createStyles = _interopRequireDefault(createStyles$1);
var _cssUtils = cssUtils;
var _responsiveFontSizes = _interopRequireDefault(responsiveFontSizes$1);
var _createTransitions = createTransitions$1;
var _useTheme = _interopRequireDefault(useTheme$4);
var _useThemeProps = _interopRequireDefault(useThemeProps$4);
var _styled = _interopRequireDefault(styled$2);
var _ThemeProvider = _interopRequireDefault(ThemeProvider$1);
var _makeStyles = _interopRequireDefault(makeStyles$1);
var _withStyles = _interopRequireDefault(withStyles$1);
var _withTheme = _interopRequireDefault(withTheme$1);
var _CssVarsProvider = CssVarsProvider$1;
Object.keys(_CssVarsProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CssVarsProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CssVarsProvider[key];
    }
  });
});
var _experimental_extendTheme = _interopRequireDefault(experimental_extendTheme);
var _getOverlayAlpha = _interopRequireDefault(getOverlayAlpha$1);
var _shouldSkipGeneratingVar = _interopRequireDefault(shouldSkipGeneratingVar$1);
var _createTypography = _interopRequireDefault(createTypography$1);
var _createMixins = _interopRequireDefault(createMixins$1);
var _excludeVariablesFromRoot = _interopRequireDefault(excludeVariablesFromRoot$1);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
function experimental_sx() {
  throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`experimental_sx\` has been moved to \`theme.unstable_sx\`.For more details, see https://github.com/mui/material-ui/pull/35150.` : (0, _formatMuiErrorMessage2.default)(20));
}

// The legacy utilities from @mui/styles
// These are just empty functions that throws when invoked

// Private methods for creating parts of the theme
}(styles$u));

var AccordionActions$2 = {};

var AccordionActions$1 = {};

var accordionActionsClasses$1 = {};

var _interopRequireDefault$7N = interopRequireDefault$1.exports;
Object.defineProperty(accordionActionsClasses$1, "__esModule", {
  value: true
});
accordionActionsClasses$1.default = void 0;
accordionActionsClasses$1.getAccordionActionsUtilityClass = getAccordionActionsUtilityClass;
var _generateUtilityClasses$1J = _interopRequireDefault$7N(generateUtilityClasses$3);
var _generateUtilityClass$1I = _interopRequireDefault$7N(generateUtilityClass$3);
function getAccordionActionsUtilityClass(slot) {
  return (0, _generateUtilityClass$1I.default)('MuiAccordionActions', slot);
}
const accordionActionsClasses = (0, _generateUtilityClasses$1J.default)('MuiAccordionActions', ['root', 'spacing']);
accordionActionsClasses$1.default = accordionActionsClasses;

var _interopRequireDefault$7M = interopRequireDefault$1.exports;
Object.defineProperty(AccordionActions$1, "__esModule", {
  value: true
});
AccordionActions$1.default = void 0;
var _extends2$25 = _interopRequireDefault$7M(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1X = _interopRequireDefault$7M(objectWithoutPropertiesLoose.exports);
var React$2t = _interopRequireWildcard$3P(React__default$4);
var _propTypes$2w = _interopRequireDefault$7M(propTypes.exports);
var _clsx$2c = _interopRequireDefault$7M(clsx.exports);
var _composeClasses$1F = _interopRequireDefault$7M(composeClasses$2);
var _zeroStyled$6 = zeroStyled;
var _DefaultPropsProvider$1G = DefaultPropsProvider$5;
var _accordionActionsClasses = accordionActionsClasses$1;
var _jsxRuntime$2t = require$$11;
const _excluded$2p = ["className", "disableSpacing"];
function _getRequireWildcardCache$3y(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3y = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3P(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3y(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1G = ownerState => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ['root', !disableSpacing && 'spacing']
  };
  return (0, _composeClasses$1F.default)(slots, _accordionActionsClasses.getAccordionActionsUtilityClass, classes);
};
const AccordionActionsRoot = (0, _zeroStyled$6.styled)('div', {
  name: 'MuiAccordionActions',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableSpacing && styles.spacing];
  }
})({
  display: 'flex',
  alignItems: 'center',
  padding: 8,
  justifyContent: 'flex-end',
  variants: [{
    props: props => !props.disableSpacing,
    style: {
      '& > :not(style) ~ :not(style)': {
        marginLeft: 8
      }
    }
  }]
});
const AccordionActions = /*#__PURE__*/React$2t.forwardRef(function AccordionActions(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1G.useDefaultProps)({
    props: inProps,
    name: 'MuiAccordionActions'
  });
  const {
      className,
      disableSpacing = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1X.default)(props, _excluded$2p);
  const ownerState = (0, _extends2$25.default)({}, props, {
    disableSpacing
  });
  const classes = useUtilityClasses$1G(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2t.jsx)(AccordionActionsRoot, (0, _extends2$25.default)({
    className: (0, _clsx$2c.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? AccordionActions.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2w.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2w.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2w.default.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: _propTypes$2w.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2w.default.oneOfType([_propTypes$2w.default.arrayOf(_propTypes$2w.default.oneOfType([_propTypes$2w.default.func, _propTypes$2w.default.object, _propTypes$2w.default.bool])), _propTypes$2w.default.func, _propTypes$2w.default.object])
} : void 0;
AccordionActions$1.default = AccordionActions;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  accordionActionsClasses: true
};
Object.defineProperty(exports, "accordionActionsClasses", {
  enumerable: true,
  get: function () {
    return _accordionActionsClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _AccordionActions.default;
  }
});
var _AccordionActions = _interopRequireDefault(AccordionActions$1);
var _accordionActionsClasses = _interopRequireWildcard(accordionActionsClasses$1);
Object.keys(_accordionActionsClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _accordionActionsClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _accordionActionsClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(AccordionActions$2));

var Alert$3 = {};

var Alert$2 = {};

var alertClasses$1 = {};

var _interopRequireDefault$7L = interopRequireDefault$1.exports;
Object.defineProperty(alertClasses$1, "__esModule", {
  value: true
});
alertClasses$1.default = void 0;
alertClasses$1.getAlertUtilityClass = getAlertUtilityClass;
var _generateUtilityClasses$1I = _interopRequireDefault$7L(generateUtilityClasses$3);
var _generateUtilityClass$1H = _interopRequireDefault$7L(generateUtilityClass$3);
function getAlertUtilityClass(slot) {
  return (0, _generateUtilityClass$1H.default)('MuiAlert', slot);
}
const alertClasses = (0, _generateUtilityClasses$1I.default)('MuiAlert', ['root', 'action', 'icon', 'message', 'filled', 'colorSuccess', 'colorInfo', 'colorWarning', 'colorError', 'filledSuccess', 'filledInfo', 'filledWarning', 'filledError', 'outlined', 'outlinedSuccess', 'outlinedInfo', 'outlinedWarning', 'outlinedError', 'standard', 'standardSuccess', 'standardInfo', 'standardWarning', 'standardError']);
alertClasses$1.default = alertClasses;

var IconButton$4 = {};

var IconButton$3 = {};

var iconButtonClasses$1 = {};

var _interopRequireDefault$7K = interopRequireDefault$1.exports;
Object.defineProperty(iconButtonClasses$1, "__esModule", {
  value: true
});
iconButtonClasses$1.default = void 0;
iconButtonClasses$1.getIconButtonUtilityClass = getIconButtonUtilityClass;
var _generateUtilityClasses$1H = _interopRequireDefault$7K(generateUtilityClasses$3);
var _generateUtilityClass$1G = _interopRequireDefault$7K(generateUtilityClass$3);
function getIconButtonUtilityClass(slot) {
  return (0, _generateUtilityClass$1G.default)('MuiIconButton', slot);
}
const iconButtonClasses = (0, _generateUtilityClasses$1H.default)('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
iconButtonClasses$1.default = iconButtonClasses;

var _interopRequireDefault$7J = interopRequireDefault$1.exports;
Object.defineProperty(IconButton$3, "__esModule", {
  value: true
});
IconButton$3.default = void 0;
var _objectWithoutPropertiesLoose2$1W = _interopRequireDefault$7J(objectWithoutPropertiesLoose.exports);
var _extends2$24 = _interopRequireDefault$7J(_extends$19.exports);
var React$2s = _interopRequireWildcard$3O(React__default$4);
var _propTypes$2v = _interopRequireDefault$7J(propTypes.exports);
var _clsx$2b = _interopRequireDefault$7J(clsx.exports);
var _chainPropTypes$a = _interopRequireDefault$7J(chainPropTypes$2);
var _composeClasses$1E = _interopRequireDefault$7J(composeClasses$2);
var _colorManipulator$l = colorManipulator;
var _styled$1A = _interopRequireDefault$7J(styled$2);
var _DefaultPropsProvider$1F = DefaultPropsProvider$5;
var _ButtonBase$g = _interopRequireDefault$7J(ButtonBase$2);
var _capitalize$I = _interopRequireDefault$7J(capitalize$1);
var _iconButtonClasses = _interopRequireWildcard$3O(iconButtonClasses$1);
var _jsxRuntime$2s = require$$11;
const _excluded$2o = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];
function _getRequireWildcardCache$3x(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3x = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3O(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3x(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1F = ownerState => {
  const {
    classes,
    disabled,
    color,
    edge,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && `color${(0, _capitalize$I.default)(color)}`, edge && `edge${(0, _capitalize$I.default)(edge)}`, `size${(0, _capitalize$I.default)(size)}`]
  };
  return (0, _composeClasses$1E.default)(slots, _iconButtonClasses.getIconButtonUtilityClass, classes);
};
const IconButtonRoot = (0, _styled$1A.default)(_ButtonBase$g.default, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${(0, _capitalize$I.default)(ownerState.color)}`], ownerState.edge && styles[`edge${(0, _capitalize$I.default)(ownerState.edge)}`], styles[`size${(0, _capitalize$I.default)(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$24.default)({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: (theme.vars || theme).palette.action.active,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  })
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$l.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}), ({
  theme,
  ownerState
}) => {
  var _palette;
  const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
  return (0, _extends2$24.default)({}, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, _extends2$24.default)({
    color: palette == null ? void 0 : palette.main
  }, !ownerState.disableRipple && {
    '&:hover': (0, _extends2$24.default)({}, palette && {
      backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$l.alpha)(palette.main, theme.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    })
  }), ownerState.size === 'small' && {
    padding: 5,
    fontSize: theme.typography.pxToRem(18)
  }, ownerState.size === 'large' && {
    padding: 12,
    fontSize: theme.typography.pxToRem(28)
  }, {
    [`&.${_iconButtonClasses.default.disabled}`]: {
      backgroundColor: 'transparent',
      color: (theme.vars || theme).palette.action.disabled
    }
  });
});

/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */
const IconButton$2 = /*#__PURE__*/React$2s.forwardRef(function IconButton(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1F.useDefaultProps)({
    props: inProps,
    name: 'MuiIconButton'
  });
  const {
      edge = false,
      children,
      className,
      color = 'default',
      disabled = false,
      disableFocusRipple = false,
      size = 'medium'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1W.default)(props, _excluded$2o);
  const ownerState = (0, _extends2$24.default)({}, props, {
    edge,
    color,
    disabled,
    disableFocusRipple,
    size
  });
  const classes = useUtilityClasses$1F(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2s.jsx)(IconButtonRoot, (0, _extends2$24.default)({
    className: (0, _clsx$2b.default)(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other, {
    ownerState: ownerState,
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? IconButton$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: (0, _chainPropTypes$a.default)(_propTypes$2v.default.node, props => {
    const found = React$2s.Children.toArray(props.children).some(child => /*#__PURE__*/React$2s.isValidElement(child) && child.props.onClick);
    if (found) {
      return new Error(['MUI: You are providing an onClick event listener to a child of a button element.', 'Prefer applying it to the IconButton directly.', 'This guarantees that the whole <button> will be responsive to click events.'].join('\n'));
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2v.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2v.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: _propTypes$2v.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2v.default.oneOf(['inherit', 'default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$2v.default.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$2v.default.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: _propTypes$2v.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: _propTypes$2v.default.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: _propTypes$2v.default.oneOf(['end', 'start', false]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: _propTypes$2v.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2v.default.oneOf(['small', 'medium', 'large']), _propTypes$2v.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2v.default.oneOfType([_propTypes$2v.default.arrayOf(_propTypes$2v.default.oneOfType([_propTypes$2v.default.func, _propTypes$2v.default.object, _propTypes$2v.default.bool])), _propTypes$2v.default.func, _propTypes$2v.default.object])
} : void 0;
IconButton$3.default = IconButton$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  iconButtonClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _IconButton.default;
  }
});
Object.defineProperty(exports, "iconButtonClasses", {
  enumerable: true,
  get: function () {
    return _iconButtonClasses.default;
  }
});
var _IconButton = _interopRequireDefault(IconButton$3);
var _iconButtonClasses = _interopRequireWildcard(iconButtonClasses$1);
Object.keys(_iconButtonClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _iconButtonClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _iconButtonClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(IconButton$4));

var SuccessOutlined = {};

var _interopRequireDefault$7I = interopRequireDefault$1.exports;
Object.defineProperty(SuccessOutlined, "__esModule", {
  value: true
});
SuccessOutlined.default = void 0;
_interopRequireWildcard$3N(React__default$4);
var _createSvgIcon$p = _interopRequireDefault$7I(createSvgIcon$2);
var _jsxRuntime$2r = require$$11;
function _getRequireWildcardCache$3w(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3w = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3N(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3w(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
SuccessOutlined.default = (0, _createSvgIcon$p.default)( /*#__PURE__*/(0, _jsxRuntime$2r.jsx)("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

var ReportProblemOutlined = {};

var _interopRequireDefault$7H = interopRequireDefault$1.exports;
Object.defineProperty(ReportProblemOutlined, "__esModule", {
  value: true
});
ReportProblemOutlined.default = void 0;
_interopRequireWildcard$3M(React__default$4);
var _createSvgIcon$o = _interopRequireDefault$7H(createSvgIcon$2);
var _jsxRuntime$2q = require$$11;
function _getRequireWildcardCache$3v(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3v = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3M(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3v(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
ReportProblemOutlined.default = (0, _createSvgIcon$o.default)( /*#__PURE__*/(0, _jsxRuntime$2q.jsx)("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

var ErrorOutline = {};

var _interopRequireDefault$7G = interopRequireDefault$1.exports;
Object.defineProperty(ErrorOutline, "__esModule", {
  value: true
});
ErrorOutline.default = void 0;
_interopRequireWildcard$3L(React__default$4);
var _createSvgIcon$n = _interopRequireDefault$7G(createSvgIcon$2);
var _jsxRuntime$2p = require$$11;
function _getRequireWildcardCache$3u(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3u = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3L(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3u(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
ErrorOutline.default = (0, _createSvgIcon$n.default)( /*#__PURE__*/(0, _jsxRuntime$2p.jsx)("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

var InfoOutlined = {};

var _interopRequireDefault$7F = interopRequireDefault$1.exports;
Object.defineProperty(InfoOutlined, "__esModule", {
  value: true
});
InfoOutlined.default = void 0;
_interopRequireWildcard$3K(React__default$4);
var _createSvgIcon$m = _interopRequireDefault$7F(createSvgIcon$2);
var _jsxRuntime$2o = require$$11;
function _getRequireWildcardCache$3t(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3t = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3K(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3t(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
InfoOutlined.default = (0, _createSvgIcon$m.default)( /*#__PURE__*/(0, _jsxRuntime$2o.jsx)("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

var Close = {};

var _interopRequireDefault$7E = interopRequireDefault$1.exports;
Object.defineProperty(Close, "__esModule", {
  value: true
});
Close.default = void 0;
_interopRequireWildcard$3J(React__default$4);
var _createSvgIcon$l = _interopRequireDefault$7E(createSvgIcon$2);
var _jsxRuntime$2n = require$$11;
function _getRequireWildcardCache$3s(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3s = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3J(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3s(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */
Close.default = (0, _createSvgIcon$l.default)( /*#__PURE__*/(0, _jsxRuntime$2n.jsx)("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

var _interopRequireDefault$7D = interopRequireDefault$1.exports;
Object.defineProperty(Alert$2, "__esModule", {
  value: true
});
Alert$2.default = void 0;
var _objectWithoutPropertiesLoose2$1V = _interopRequireDefault$7D(objectWithoutPropertiesLoose.exports);
var _extends2$23 = _interopRequireDefault$7D(_extends$19.exports);
var React$2r = _interopRequireWildcard$3I(React__default$4);
var _propTypes$2u = _interopRequireDefault$7D(propTypes.exports);
var _clsx$2a = _interopRequireDefault$7D(clsx.exports);
var _composeClasses$1D = _interopRequireDefault$7D(composeClasses$2);
var _colorManipulator$k = colorManipulator;
var _zeroStyled$5 = zeroStyled;
var _DefaultPropsProvider$1E = DefaultPropsProvider$5;
var _useSlot$1 = _interopRequireDefault$7D(useSlot$1);
var _capitalize$H = _interopRequireDefault$7D(capitalize$1);
var _Paper$7 = _interopRequireDefault$7D(Paper$3);
var _alertClasses = _interopRequireWildcard$3I(alertClasses$1);
var _IconButton$1 = _interopRequireDefault$7D(IconButton$4);
var _SuccessOutlined = _interopRequireDefault$7D(SuccessOutlined);
var _ReportProblemOutlined = _interopRequireDefault$7D(ReportProblemOutlined);
var _ErrorOutline = _interopRequireDefault$7D(ErrorOutline);
var _InfoOutlined = _interopRequireDefault$7D(InfoOutlined);
var _Close = _interopRequireDefault$7D(Close);
var _jsxRuntime$2m = require$$11;
const _excluded$2n = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"];
function _getRequireWildcardCache$3r(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3r = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3I(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3r(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1E = ownerState => {
  const {
    variant,
    color,
    severity,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `color${(0, _capitalize$H.default)(color || severity)}`, `${variant}${(0, _capitalize$H.default)(color || severity)}`, `${variant}`],
    icon: ['icon'],
    message: ['message'],
    action: ['action']
  };
  return (0, _composeClasses$1D.default)(slots, _alertClasses.getAlertUtilityClass, classes);
};
const AlertRoot = (0, _zeroStyled$5.styled)(_Paper$7.default, {
  name: 'MuiAlert',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${(0, _capitalize$H.default)(ownerState.color || ownerState.severity)}`]];
  }
})(({
  theme
}) => {
  const getColor = theme.palette.mode === 'light' ? _colorManipulator$k.darken : _colorManipulator$k.lighten;
  const getBackgroundColor = theme.palette.mode === 'light' ? _colorManipulator$k.lighten : _colorManipulator$k.darken;
  return (0, _extends2$23.default)({}, theme.typography.body2, {
    backgroundColor: 'transparent',
    display: 'flex',
    padding: '6px 16px',
    variants: [...Object.entries(theme.palette).filter(([, value]) => value.main && value.light).map(([color]) => ({
      props: {
        colorSeverity: color,
        variant: 'standard'
      },
      style: {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
        [`& .${_alertClasses.default.icon}`]: theme.vars ? {
          color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
          color: theme.palette[color].main
        }
      }
    })), ...Object.entries(theme.palette).filter(([, value]) => value.main && value.light).map(([color]) => ({
      props: {
        colorSeverity: color,
        variant: 'outlined'
      },
      style: {
        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
        [`& .${_alertClasses.default.icon}`]: theme.vars ? {
          color: theme.vars.palette.Alert[`${color}IconColor`]
        } : {
          color: theme.palette[color].main
        }
      }
    })), ...Object.entries(theme.palette).filter(([, value]) => value.main && value.dark).map(([color]) => ({
      props: {
        colorSeverity: color,
        variant: 'filled'
      },
      style: (0, _extends2$23.default)({
        fontWeight: theme.typography.fontWeightMedium
      }, theme.vars ? {
        color: theme.vars.palette.Alert[`${color}FilledColor`],
        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
      } : {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
        color: theme.palette.getContrastText(theme.palette[color].main)
      })
    }))]
  });
});
const AlertIcon = (0, _zeroStyled$5.styled)('div', {
  name: 'MuiAlert',
  slot: 'Icon',
  overridesResolver: (props, styles) => styles.icon
})({
  marginRight: 12,
  padding: '7px 0',
  display: 'flex',
  fontSize: 22,
  opacity: 0.9
});
const AlertMessage = (0, _zeroStyled$5.styled)('div', {
  name: 'MuiAlert',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0',
  minWidth: 0,
  overflow: 'auto'
});
const AlertAction = (0, _zeroStyled$5.styled)('div', {
  name: 'MuiAlert',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '4px 0 0 16px',
  marginLeft: 'auto',
  marginRight: -8
});
const defaultIconMapping = {
  success: /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(_SuccessOutlined.default, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(_ReportProblemOutlined.default, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(_ErrorOutline.default, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(_InfoOutlined.default, {
    fontSize: "inherit"
  })
};
const Alert$1 = /*#__PURE__*/React$2r.forwardRef(function Alert(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1E.useDefaultProps)({
    props: inProps,
    name: 'MuiAlert'
  });
  const {
      action,
      children,
      className,
      closeText = 'Close',
      color,
      components = {},
      componentsProps = {},
      icon,
      iconMapping = defaultIconMapping,
      onClose,
      role = 'alert',
      severity = 'success',
      slotProps = {},
      slots = {},
      variant = 'standard'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1V.default)(props, _excluded$2n);
  const ownerState = (0, _extends2$23.default)({}, props, {
    color,
    severity,
    variant,
    colorSeverity: color || severity
  });
  const classes = useUtilityClasses$1E(ownerState);
  const externalForwardedProps = {
    slots: (0, _extends2$23.default)({
      closeButton: components.CloseButton,
      closeIcon: components.CloseIcon
    }, slots),
    slotProps: (0, _extends2$23.default)({}, componentsProps, slotProps)
  };
  const [CloseButtonSlot, closeButtonProps] = (0, _useSlot$1.default)('closeButton', {
    elementType: _IconButton$1.default,
    externalForwardedProps,
    ownerState
  });
  const [CloseIconSlot, closeIconProps] = (0, _useSlot$1.default)('closeIcon', {
    elementType: _Close.default,
    externalForwardedProps,
    ownerState
  });
  return /*#__PURE__*/(0, _jsxRuntime$2m.jsxs)(AlertRoot, (0, _extends2$23.default)({
    role: role,
    elevation: 0,
    ownerState: ownerState,
    className: (0, _clsx$2a.default)(classes.root, className),
    ref: ref
  }, other, {
    children: [icon !== false ? /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(AlertIcon, {
      ownerState: ownerState,
      className: classes.icon,
      children: icon || iconMapping[severity] || defaultIconMapping[severity]
    }) : null, /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(AlertMessage, {
      ownerState: ownerState,
      className: classes.message,
      children: children
    }), action != null ? /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: action
    }) : null, action == null && onClose ? /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(CloseButtonSlot, (0, _extends2$23.default)({
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose
      }, closeButtonProps, {
        children: /*#__PURE__*/(0, _jsxRuntime$2m.jsx)(CloseIconSlot, (0, _extends2$23.default)({
          fontSize: "small"
        }, closeIconProps))
      }))
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? Alert$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: _propTypes$2u.default.node,
  /**
   * The content of the component.
   */
  children: _propTypes$2u.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2u.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2u.default.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: _propTypes$2u.default.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: _propTypes$2u.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2u.default.oneOf(['error', 'info', 'success', 'warning']), _propTypes$2u.default.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: _propTypes$2u.default.shape({
    CloseButton: _propTypes$2u.default.elementType,
    CloseIcon: _propTypes$2u.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: _propTypes$2u.default.shape({
    closeButton: _propTypes$2u.default.object,
    closeIcon: _propTypes$2u.default.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: _propTypes$2u.default.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: _propTypes$2u.default.shape({
    error: _propTypes$2u.default.node,
    info: _propTypes$2u.default.node,
    success: _propTypes$2u.default.node,
    warning: _propTypes$2u.default.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: _propTypes$2u.default.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: _propTypes$2u.default.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: _propTypes$2u.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2u.default.oneOf(['error', 'info', 'success', 'warning']), _propTypes$2u.default.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: _propTypes$2u.default.shape({
    closeButton: _propTypes$2u.default.oneOfType([_propTypes$2u.default.func, _propTypes$2u.default.object]),
    closeIcon: _propTypes$2u.default.oneOfType([_propTypes$2u.default.func, _propTypes$2u.default.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: _propTypes$2u.default.shape({
    closeButton: _propTypes$2u.default.elementType,
    closeIcon: _propTypes$2u.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2u.default.oneOfType([_propTypes$2u.default.arrayOf(_propTypes$2u.default.oneOfType([_propTypes$2u.default.func, _propTypes$2u.default.object, _propTypes$2u.default.bool])), _propTypes$2u.default.func, _propTypes$2u.default.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: _propTypes$2u.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2u.default.oneOf(['filled', 'outlined', 'standard']), _propTypes$2u.default.string])
} : void 0;
Alert$2.default = Alert$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  alertClasses: true
};
Object.defineProperty(exports, "alertClasses", {
  enumerable: true,
  get: function () {
    return _alertClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Alert.default;
  }
});
var _Alert = _interopRequireDefault(Alert$2);
var _alertClasses = _interopRequireWildcard(alertClasses$1);
Object.keys(_alertClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _alertClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _alertClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Alert$3));

var MuiAlert = /*@__PURE__*/getDefaultExportFromCjs$1(Alert$3);

var AlertTitle$2 = {};

var AlertTitle$1 = {};

var alertTitleClasses$1 = {};

var _interopRequireDefault$7C = interopRequireDefault$1.exports;
Object.defineProperty(alertTitleClasses$1, "__esModule", {
  value: true
});
alertTitleClasses$1.default = void 0;
alertTitleClasses$1.getAlertTitleUtilityClass = getAlertTitleUtilityClass;
var _generateUtilityClasses$1G = _interopRequireDefault$7C(generateUtilityClasses$3);
var _generateUtilityClass$1F = _interopRequireDefault$7C(generateUtilityClass$3);
function getAlertTitleUtilityClass(slot) {
  return (0, _generateUtilityClass$1F.default)('MuiAlertTitle', slot);
}
const alertTitleClasses = (0, _generateUtilityClasses$1G.default)('MuiAlertTitle', ['root']);
alertTitleClasses$1.default = alertTitleClasses;

var _interopRequireDefault$7B = interopRequireDefault$1.exports;
Object.defineProperty(AlertTitle$1, "__esModule", {
  value: true
});
AlertTitle$1.default = void 0;
var _extends2$22 = _interopRequireDefault$7B(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1U = _interopRequireDefault$7B(objectWithoutPropertiesLoose.exports);
var React$2q = _interopRequireWildcard$3H(React__default$4);
var _propTypes$2t = _interopRequireDefault$7B(propTypes.exports);
var _clsx$29 = _interopRequireDefault$7B(clsx.exports);
var _composeClasses$1C = _interopRequireDefault$7B(composeClasses$2);
var _zeroStyled$4 = zeroStyled;
var _DefaultPropsProvider$1D = DefaultPropsProvider$5;
var _Typography$8 = _interopRequireDefault$7B(Typography$3);
var _alertTitleClasses = alertTitleClasses$1;
var _jsxRuntime$2l = require$$11;
const _excluded$2m = ["className"];
function _getRequireWildcardCache$3q(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3q = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3H(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3q(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1D = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$1C.default)(slots, _alertTitleClasses.getAlertTitleUtilityClass, classes);
};
const AlertTitleRoot = (0, _zeroStyled$4.styled)(_Typography$8.default, {
  name: 'MuiAlertTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  return {
    fontWeight: theme.typography.fontWeightMedium,
    marginTop: -2
  };
});
const AlertTitle = /*#__PURE__*/React$2q.forwardRef(function AlertTitle(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1D.useDefaultProps)({
    props: inProps,
    name: 'MuiAlertTitle'
  });
  const {
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1U.default)(props, _excluded$2m);
  const ownerState = props;
  const classes = useUtilityClasses$1D(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2l.jsx)(AlertTitleRoot, (0, _extends2$22.default)({
    gutterBottom: true,
    component: "div",
    ownerState: ownerState,
    ref: ref,
    className: (0, _clsx$29.default)(classes.root, className)
  }, other));
});
process.env.NODE_ENV !== "production" ? AlertTitle.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2t.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2t.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2t.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2t.default.oneOfType([_propTypes$2t.default.arrayOf(_propTypes$2t.default.oneOfType([_propTypes$2t.default.func, _propTypes$2t.default.object, _propTypes$2t.default.bool])), _propTypes$2t.default.func, _propTypes$2t.default.object])
} : void 0;
AlertTitle$1.default = AlertTitle;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  alertTitleClasses: true
};
Object.defineProperty(exports, "alertTitleClasses", {
  enumerable: true,
  get: function () {
    return _alertTitleClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _AlertTitle.default;
  }
});
var _AlertTitle = _interopRequireDefault(AlertTitle$1);
var _alertTitleClasses = _interopRequireWildcard(alertTitleClasses$1);
Object.keys(_alertTitleClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _alertTitleClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _alertTitleClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(AlertTitle$2));

var AppBar$2 = {};

var AppBar$1 = {};

var appBarClasses$1 = {};

var _interopRequireDefault$7A = interopRequireDefault$1.exports;
Object.defineProperty(appBarClasses$1, "__esModule", {
  value: true
});
appBarClasses$1.default = void 0;
appBarClasses$1.getAppBarUtilityClass = getAppBarUtilityClass;
var _generateUtilityClasses$1F = _interopRequireDefault$7A(generateUtilityClasses$3);
var _generateUtilityClass$1E = _interopRequireDefault$7A(generateUtilityClass$3);
function getAppBarUtilityClass(slot) {
  return (0, _generateUtilityClass$1E.default)('MuiAppBar', slot);
}
const appBarClasses = (0, _generateUtilityClasses$1F.default)('MuiAppBar', ['root', 'positionFixed', 'positionAbsolute', 'positionSticky', 'positionStatic', 'positionRelative', 'colorDefault', 'colorPrimary', 'colorSecondary', 'colorInherit', 'colorTransparent', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning']);
appBarClasses$1.default = appBarClasses;

var _interopRequireDefault$7z = interopRequireDefault$1.exports;
Object.defineProperty(AppBar$1, "__esModule", {
  value: true
});
AppBar$1.default = void 0;
var _objectWithoutPropertiesLoose2$1T = _interopRequireDefault$7z(objectWithoutPropertiesLoose.exports);
var _extends2$21 = _interopRequireDefault$7z(_extends$19.exports);
var React$2p = _interopRequireWildcard$3G(React__default$4);
var _propTypes$2s = _interopRequireDefault$7z(propTypes.exports);
var _clsx$28 = _interopRequireDefault$7z(clsx.exports);
var _composeClasses$1B = _interopRequireDefault$7z(composeClasses$2);
var _styled$1z = _interopRequireDefault$7z(styled$2);
var _DefaultPropsProvider$1C = DefaultPropsProvider$5;
var _capitalize$G = _interopRequireDefault$7z(capitalize$1);
var _Paper$6 = _interopRequireDefault$7z(Paper$3);
var _appBarClasses = appBarClasses$1;
var _jsxRuntime$2k = require$$11;
const _excluded$2l = ["className", "color", "enableColorOnDark", "position"];
function _getRequireWildcardCache$3p(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3p = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3G(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3p(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1C = ownerState => {
  const {
    color,
    position,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `color${(0, _capitalize$G.default)(color)}`, `position${(0, _capitalize$G.default)(position)}`]
  };
  return (0, _composeClasses$1B.default)(slots, _appBarClasses.getAppBarUtilityClass, classes);
};

// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const joinVars = (var1, var2) => var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const AppBarRoot = (0, _styled$1z.default)(_Paper$6.default, {
  name: 'MuiAppBar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`position${(0, _capitalize$G.default)(ownerState.position)}`], styles[`color${(0, _capitalize$G.default)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return (0, _extends2$21.default)({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    boxSizing: 'border-box',
    // Prevent padding issue with the Modal and fixed positioned AppBar.
    flexShrink: 0
  }, ownerState.position === 'fixed' && {
    position: 'fixed',
    zIndex: (theme.vars || theme).zIndex.appBar,
    top: 0,
    left: 'auto',
    right: 0,
    '@media print': {
      // Prevent the app bar to be visible on each printed page.
      position: 'absolute'
    }
  }, ownerState.position === 'absolute' && {
    position: 'absolute',
    zIndex: (theme.vars || theme).zIndex.appBar,
    top: 0,
    left: 'auto',
    right: 0
  }, ownerState.position === 'sticky' && {
    // ⚠️ sticky is not supported by IE11.
    position: 'sticky',
    zIndex: (theme.vars || theme).zIndex.appBar,
    top: 0,
    left: 'auto',
    right: 0
  }, ownerState.position === 'static' && {
    position: 'static'
  }, ownerState.position === 'relative' && {
    position: 'relative'
  }, !theme.vars && (0, _extends2$21.default)({}, ownerState.color === 'default' && {
    backgroundColor: backgroundColorDefault,
    color: theme.palette.getContrastText(backgroundColorDefault)
  }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
    backgroundColor: theme.palette[ownerState.color].main,
    color: theme.palette[ownerState.color].contrastText
  }, ownerState.color === 'inherit' && {
    color: 'inherit'
  }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
    backgroundColor: null,
    color: null
  }, ownerState.color === 'transparent' && (0, _extends2$21.default)({
    backgroundColor: 'transparent',
    color: 'inherit'
  }, theme.palette.mode === 'dark' && {
    backgroundImage: 'none'
  })), theme.vars && (0, _extends2$21.default)({}, ownerState.color === 'default' && {
    '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
    '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
  }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
    '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
    '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
  }, !['inherit', 'transparent'].includes(ownerState.color) && {
    backgroundColor: 'var(--AppBar-background)'
  }, {
    color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
  }, ownerState.color === 'transparent' && {
    backgroundImage: 'none',
    backgroundColor: 'transparent',
    color: 'inherit'
  }));
});
const AppBar = /*#__PURE__*/React$2p.forwardRef(function AppBar(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1C.useDefaultProps)({
    props: inProps,
    name: 'MuiAppBar'
  });
  const {
      className,
      color = 'primary',
      enableColorOnDark = false,
      position = 'fixed'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1T.default)(props, _excluded$2l);
  const ownerState = (0, _extends2$21.default)({}, props, {
    color,
    position,
    enableColorOnDark
  });
  const classes = useUtilityClasses$1C(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2k.jsx)(AppBarRoot, (0, _extends2$21.default)({
    square: true,
    component: "header",
    ownerState: ownerState,
    elevation: 4,
    className: (0, _clsx$28.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? AppBar.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2s.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2s.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2s.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$2s.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2s.default.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent', 'error', 'info', 'success', 'warning']), _propTypes$2s.default.string]),
  /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */
  enableColorOnDark: _propTypes$2s.default.bool,
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */
  position: _propTypes$2s.default.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2s.default.oneOfType([_propTypes$2s.default.arrayOf(_propTypes$2s.default.oneOfType([_propTypes$2s.default.func, _propTypes$2s.default.object, _propTypes$2s.default.bool])), _propTypes$2s.default.func, _propTypes$2s.default.object])
} : void 0;
AppBar$1.default = AppBar;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  appBarClasses: true
};
Object.defineProperty(exports, "appBarClasses", {
  enumerable: true,
  get: function () {
    return _appBarClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _AppBar.default;
  }
});
var _AppBar = _interopRequireDefault(AppBar$1);
var _appBarClasses = _interopRequireWildcard(appBarClasses$1);
Object.keys(_appBarClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _appBarClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _appBarClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(AppBar$2));

var Autocomplete$1 = {};

var Autocomplete = {};

var useAutocomplete$2 = {};

var useAutocomplete$1 = {};

/* eslint-disable no-constant-condition */
var _interopRequireDefault$7y = interopRequireDefault$1.exports;
Object.defineProperty(useAutocomplete$1, "__esModule", {
  value: true
});
useAutocomplete$1.createFilterOptions = createFilterOptions;
useAutocomplete$1.default = void 0;
var _extends2$20 = _interopRequireDefault$7y(_extends$19.exports);
var React$2o = _interopRequireWildcard$3F(React__default$4);
var _utils$T = utils$7;
function _getRequireWildcardCache$3o(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3o = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3F(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3o(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function createFilterOptions(config = {}) {
  const {
    ignoreAccents = true,
    ignoreCase = true,
    limit,
    matchFrom = 'any',
    stringify,
    trim = false
  } = config;
  return (options, {
    inputValue,
    getOptionLabel
  }) => {
    let input = trim ? inputValue.trim() : inputValue;
    if (ignoreCase) {
      input = input.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
    }
    const filteredOptions = !input ? options : options.filter(option => {
      let candidate = (stringify || getOptionLabel)(option);
      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }
      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }
      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  };
}

// To replace with .findIndex() once we stop IE11 support.
function findIndex$3(array, comp) {
  for (let i = 0; i < array.length; i += 1) {
    if (comp(array[i])) {
      return i;
    }
  }
  return -1;
}
const defaultFilterOptions = createFilterOptions();

// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const pageSize = 5;
const defaultIsActiveElementInListbox = listboxRef => {
  var _listboxRef$current$p;
  return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const MULTIPLE_DEFAULT_VALUE = [];
function useAutocomplete(props) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = defaultIsActiveElementInListbox,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui',
    autoComplete = false,
    autoHighlight = false,
    autoSelect = false,
    blurOnSelect = false,
    clearOnBlur = !props.freeSolo,
    clearOnEscape = false,
    componentName = 'useAutocomplete',
    defaultValue = props.multiple ? MULTIPLE_DEFAULT_VALUE : null,
    disableClearable = false,
    disableCloseOnSelect = false,
    disabled: disabledProp,
    disabledItemsFocusable = false,
    disableListWrap = false,
    filterOptions = defaultFilterOptions,
    filterSelectedOptions = false,
    freeSolo = false,
    getOptionDisabled,
    getOptionKey,
    getOptionLabel: getOptionLabelProp = option => {
      var _option$label;
      return (_option$label = option.label) != null ? _option$label : option;
    },
    groupBy,
    handleHomeEndKeys = !props.freeSolo,
    id: idProp,
    includeInputInList = false,
    inputValue: inputValueProp,
    isOptionEqualToValue = (option, value) => option === value,
    multiple = false,
    onChange,
    onClose,
    onHighlightChange,
    onInputChange,
    onOpen,
    open: openProp,
    openOnFocus = false,
    options,
    readOnly = false,
    selectOnFocus = !props.freeSolo,
    value: valueProp
  } = props;
  const id = (0, _utils$T.unstable_useId)(idProp);
  let getOptionLabel = getOptionLabelProp;
  getOptionLabel = option => {
    const optionLabel = getOptionLabelProp(option);
    if (typeof optionLabel !== 'string') {
      if (process.env.NODE_ENV !== 'production') {
        const erroneousReturn = optionLabel === undefined ? 'undefined' : `${typeof optionLabel} (${optionLabel})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${componentName} returned ${erroneousReturn} instead of a string for ${JSON.stringify(option)}.`);
      }
      return String(optionLabel);
    }
    return optionLabel;
  };
  const ignoreFocus = React$2o.useRef(false);
  const firstFocus = React$2o.useRef(true);
  const inputRef = React$2o.useRef(null);
  const listboxRef = React$2o.useRef(null);
  const [anchorEl, setAnchorEl] = React$2o.useState(null);
  const [focusedTag, setFocusedTag] = React$2o.useState(-1);
  const defaultHighlighted = autoHighlight ? 0 : -1;
  const highlightedIndexRef = React$2o.useRef(defaultHighlighted);
  const [value, setValueState] = (0, _utils$T.unstable_useControlled)({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  });
  const [inputValue, setInputValueState] = (0, _utils$T.unstable_useControlled)({
    controlled: inputValueProp,
    default: '',
    name: componentName,
    state: 'inputValue'
  });
  const [focused, setFocused] = React$2o.useState(false);
  const resetInputValue = React$2o.useCallback((event, newValue) => {
    // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
    // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
    const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
    if (!isOptionSelected && !clearOnBlur) {
      return;
    }
    let newInputValue;
    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      const optionLabel = getOptionLabel(newValue);
      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }
    if (inputValue === newInputValue) {
      return;
    }
    setInputValueState(newInputValue);
    if (onInputChange) {
      onInputChange(event, newInputValue, 'reset');
    }
  }, [getOptionLabel, inputValue, multiple, onInputChange, setInputValueState, clearOnBlur, value]);
  const [open, setOpenState] = (0, _utils$T.unstable_useControlled)({
    controlled: openProp,
    default: false,
    name: componentName,
    state: 'open'
  });
  const [inputPristine, setInputPristine] = React$2o.useState(true);
  const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  const popupOpen = open && !readOnly;
  const filteredOptions = popupOpen ? filterOptions(options.filter(option => {
    if (filterSelectedOptions && (multiple ? value : [value]).some(value2 => value2 !== null && isOptionEqualToValue(option, value2))) {
      return false;
    }
    return true;
  }),
  // we use the empty string to manipulate `filterOptions` to not filter any options
  // i.e. the filter predicate always returns true
  {
    inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
    getOptionLabel
  }) : [];
  const previousProps = (0, _utils$T.usePreviousProps)({
    filteredOptions,
    value,
    inputValue
  });
  React$2o.useEffect(() => {
    const valueChange = value !== previousProps.value;
    if (focused && !valueChange) {
      return;
    }

    // Only reset the input's value when freeSolo if the component's value changes.
    if (freeSolo && !valueChange) {
      return;
    }
    resetInputValue(null, value);
  }, [value, resetInputValue, focused, previousProps.value, freeSolo]);
  const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
  if (process.env.NODE_ENV !== 'production') {
    if (value !== null && !freeSolo && options.length > 0) {
      const missingValue = (multiple ? value : [value]).filter(value2 => !options.some(option => isOptionEqualToValue(option, value2)));
      if (missingValue.length > 0) {
        console.warn([`MUI: The value provided to ${componentName} is invalid.`, `None of the options match with \`${missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0])}\`.`, 'You can use the `isOptionEqualToValue` prop to customize the equality test.'].join('\n'));
      }
    }
  }
  const focusTag = (0, _utils$T.unstable_useEventCallback)(tagToFocus => {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    }
  });

  // Ensure the focusedTag is never inconsistent
  React$2o.useEffect(() => {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);
  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index < 0 || index >= filteredOptions.length) {
      return -1;
    }
    let nextFocus = index;
    while (true) {
      const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);

      // Same logic as MenuList.js
      const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
      if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) {
        // The next option is available
        return nextFocus;
      }

      // The next option is disabled, move to the next element.
      // with looped index
      if (direction === 'next') {
        nextFocus = (nextFocus + 1) % filteredOptions.length;
      } else {
        nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
      }

      // We end up with initial index, that means we don't have available options.
      // All of them are disabled
      if (nextFocus === index) {
        return -1;
      }
    }
  }
  const setHighlightedIndex = (0, _utils$T.unstable_useEventCallback)(({
    event,
    index,
    reason = 'auto'
  }) => {
    highlightedIndexRef.current = index;

    // does the index exist?
    if (index === -1) {
      inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
    }
    if (onHighlightChange) {
      onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
    }
    if (!listboxRef.current) {
      return;
    }
    const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
    if (prev) {
      prev.classList.remove(`${unstable_classNamePrefix}-focused`);
      prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
    }
    let listboxNode = listboxRef.current;
    if (listboxRef.current.getAttribute('role') !== 'listbox') {
      listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
    }

    // "No results"
    if (!listboxNode) {
      return;
    }
    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }
    const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
    if (!option) {
      return;
    }
    option.classList.add(`${unstable_classNamePrefix}-focused`);
    if (reason === 'keyboard') {
      option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
    }

    // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
    // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
      const element = option;
      const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      const elementBottom = element.offsetTop + element.offsetHeight;
      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  const changeHighlightedIndex = (0, _utils$T.unstable_useEventCallback)(({
    event,
    diff,
    direction = 'next',
    reason = 'auto'
  }) => {
    if (!popupOpen) {
      return;
    }
    const getNextIndex = () => {
      const maxIndex = filteredOptions.length - 1;
      if (diff === 'reset') {
        return defaultHighlighted;
      }
      if (diff === 'start') {
        return 0;
      }
      if (diff === 'end') {
        return maxIndex;
      }
      const newIndex = highlightedIndexRef.current + diff;
      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }
        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }
        return maxIndex;
      }
      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }
        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }
        return 0;
      }
      return newIndex;
    };
    const nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex({
      index: nextIndex,
      reason,
      event
    });

    // Sync the content of the input with the highlighted option.
    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        const option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option;

        // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.
        const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  const getPreviousHighlightedOptionIndex = () => {
    const isSameValue = (value1, value2) => {
      const label1 = value1 ? getOptionLabel(value1) : '';
      const label2 = value2 ? getOptionLabel(value2) : '';
      return label1 === label2;
    };
    if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i) => getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
      const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
      if (previousHighlightedOption) {
        return findIndex$3(filteredOptions, option => {
          return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
        });
      }
    }
    return -1;
  };
  const syncHighlightedIndex = React$2o.useCallback(() => {
    if (!popupOpen) {
      return;
    }

    // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
    // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
    const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
    if (previousHighlightedOptionIndex !== -1) {
      highlightedIndexRef.current = previousHighlightedOptionIndex;
      return;
    }
    const valueItem = multiple ? value[0] : value;

    // The popup is empty, reset
    if (filteredOptions.length === 0 || valueItem == null) {
      changeHighlightedIndex({
        diff: 'reset'
      });
      return;
    }
    if (!listboxRef.current) {
      return;
    }

    // Synchronize the value with the highlighted index
    if (valueItem != null) {
      const currentOption = filteredOptions[highlightedIndexRef.current];

      // Keep the current highlighted index if possible
      if (multiple && currentOption && findIndex$3(value, val => isOptionEqualToValue(currentOption, val)) !== -1) {
        return;
      }
      const itemIndex = findIndex$3(filteredOptions, optionItem => isOptionEqualToValue(optionItem, valueItem));
      if (itemIndex === -1) {
        changeHighlightedIndex({
          diff: 'reset'
        });
      } else {
        setHighlightedIndex({
          index: itemIndex
        });
      }
      return;
    }

    // Prevent the highlighted index to leak outside the boundaries.
    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex({
        index: filteredOptions.length - 1
      });
      return;
    }

    // Restore the focus to the previous index.
    setHighlightedIndex({
      index: highlightedIndexRef.current
    });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
  // Only sync the highlighted index when the option switch between empty and not
  filteredOptions.length,
  // Don't sync the highlighted index with the value when multiple
  // eslint-disable-next-line react-hooks/exhaustive-deps
  multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
  const handleListboxRef = (0, _utils$T.unstable_useEventCallback)(node => {
    (0, _utils$T.unstable_setRef)(listboxRef, node);
    if (!node) {
      return;
    }
    syncHighlightedIndex();
  });
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2o.useEffect(() => {
      if (!inputRef.current || inputRef.current.nodeName !== 'INPUT') {
        if (inputRef.current && inputRef.current.nodeName === 'TEXTAREA') {
          console.warn([`A textarea element was provided to ${componentName} where input was expected.`, `This is not a supported scenario but it may work under certain conditions.`, `A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).`, `Make sure to test keyboard navigation and add custom event handlers if necessary.`].join('\n'));
        } else {
          console.error([`MUI: Unable to find the input element. It was resolved to ${inputRef.current} while an HTMLInputElement was expected.`, `Instead, ${componentName} expects an input element.`, '', componentName === 'useAutocomplete' ? 'Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed.' : 'Make sure you have customized the input component correctly.'].join('\n'));
        }
      }
    }, [componentName]);
  }
  React$2o.useEffect(() => {
    syncHighlightedIndex();
  }, [syncHighlightedIndex]);
  const handleOpen = event => {
    if (open) {
      return;
    }
    setOpenState(true);
    setInputPristine(true);
    if (onOpen) {
      onOpen(event);
    }
  };
  const handleClose = (event, reason) => {
    if (!open) {
      return;
    }
    setOpenState(false);
    if (onClose) {
      onClose(event, reason);
    }
  };
  const handleValue = (event, newValue, reason, details) => {
    if (multiple) {
      if (value.length === newValue.length && value.every((val, i) => val === newValue[i])) {
        return;
      }
    } else if (value === newValue) {
      return;
    }
    if (onChange) {
      onChange(event, newValue, reason, details);
    }
    setValueState(newValue);
  };
  const isTouch = React$2o.useRef(false);
  const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options') => {
    let reason = reasonProp;
    let newValue = option;
    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      if (process.env.NODE_ENV !== 'production') {
        const matches = newValue.filter(val => isOptionEqualToValue(option, val));
        if (matches.length > 1) {
          console.error([`MUI: The \`isOptionEqualToValue\` method of ${componentName} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${matches.length} matches.`].join('\n'));
        }
      }
      const itemIndex = findIndex$3(newValue, valueItem => isOptionEqualToValue(option, valueItem));
      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== 'freeSolo') {
        newValue.splice(itemIndex, 1);
        reason = 'removeOption';
      }
    }
    resetInputValue(event, newValue);
    handleValue(event, newValue, reason, {
      option
    });
    if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) {
      handleClose(event, reason);
    }
    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
      inputRef.current.blur();
    }
  };
  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }
    let nextFocus = index;
    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }
      const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);

      // Same logic as MenuList.js
      if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }
  const handleFocusTag = (event, direction) => {
    if (!multiple) {
      return;
    }
    if (inputValue === '') {
      handleClose(event, 'toggleInput');
    }
    let nextTag = focusedTag;
    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;
      if (nextTag < 0) {
        nextTag = 0;
      }
      if (nextTag === value.length) {
        nextTag = -1;
      }
    }
    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };
  const handleClear = event => {
    ignoreFocus.current = true;
    setInputValueState('');
    if (onInputChange) {
      onInputChange(event, '', 'clear');
    }
    handleValue(event, multiple ? [] : null, 'clear');
  };
  const handleKeyDown = other => event => {
    if (other.onKeyDown) {
      other.onKeyDown(event);
    }
    if (event.defaultMuiPrevented) {
      return;
    }
    if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
      setFocusedTag(-1);
      focusTag(-1);
    }

    // Wait until IME is settled.
    if (event.which !== 229) {
      switch (event.key) {
        case 'Home':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'start',
              direction: 'next',
              reason: 'keyboard',
              event
            });
          }
          break;
        case 'End':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'end',
              direction: 'previous',
              reason: 'keyboard',
              event
            });
          }
          break;
        case 'PageUp':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: -pageSize,
            direction: 'previous',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'PageDown':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: pageSize,
            direction: 'next',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'ArrowDown':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: 1,
            direction: 'next',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'ArrowUp':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: -1,
            direction: 'previous',
            reason: 'keyboard',
            event
          });
          handleOpen(event);
          break;
        case 'ArrowLeft':
          handleFocusTag(event, 'previous');
          break;
        case 'ArrowRight':
          handleFocusTag(event, 'next');
          break;
        case 'Enter':
          if (highlightedIndexRef.current !== -1 && popupOpen) {
            const option = filteredOptions[highlightedIndexRef.current];
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;

            // Avoid early form validation, let the end-users continue filling the form.
            event.preventDefault();
            if (disabled) {
              return;
            }
            selectNewValue(event, option, 'selectOption');

            // Move the selection to the end.
            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
            if (multiple) {
              // Allow people to add new values before they submit the form.
              event.preventDefault();
            }
            selectNewValue(event, inputValue, 'createOption', 'freeSolo');
          }
          break;
        case 'Escape':
          if (popupOpen) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault();
            // Avoid the Modal to handle the event.
            event.stopPropagation();
            handleClose(event, 'escape');
          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault();
            // Avoid the Modal to handle the event.
            event.stopPropagation();
            handleClear(event);
          }
          break;
        case 'Backspace':
          // Remove the value on the left of the "cursor"
          if (multiple && !readOnly && inputValue === '' && value.length > 0) {
            const index = focusedTag === -1 ? value.length - 1 : focusedTag;
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
              option: value[index]
            });
          }
          break;
        case 'Delete':
          // Remove the value on the right of the "cursor"
          if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
            const index = focusedTag;
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
              option: value[index]
            });
          }
          break;
      }
    }
  };
  const handleFocus = event => {
    setFocused(true);
    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };
  const handleBlur = event => {
    // Ignore the event when using the scrollbar with IE11
    if (unstable_isActiveElementInListbox(listboxRef)) {
      inputRef.current.focus();
      return;
    }
    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;
    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
    } else if (autoSelect && freeSolo && inputValue !== '') {
      selectNewValue(event, inputValue, 'blur', 'freeSolo');
    } else if (clearOnBlur) {
      resetInputValue(event, value);
    }
    handleClose(event, 'blur');
  };
  const handleInputChange = event => {
    const newValue = event.target.value;
    if (inputValue !== newValue) {
      setInputValueState(newValue);
      setInputPristine(false);
      if (onInputChange) {
        onInputChange(event, newValue, 'input');
      }
    }
    if (newValue === '') {
      if (!disableClearable && !multiple) {
        handleValue(event, null, 'clear');
      }
    } else {
      handleOpen(event);
    }
  };
  const handleOptionMouseMove = event => {
    const index = Number(event.currentTarget.getAttribute('data-option-index'));
    if (highlightedIndexRef.current !== index) {
      setHighlightedIndex({
        event,
        index,
        reason: 'mouse'
      });
    }
  };
  const handleOptionTouchStart = event => {
    setHighlightedIndex({
      event,
      index: Number(event.currentTarget.getAttribute('data-option-index')),
      reason: 'touch'
    });
    isTouch.current = true;
  };
  const handleOptionClick = event => {
    const index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index], 'selectOption');
    isTouch.current = false;
  };
  const handleTagDelete = index => event => {
    const newValue = value.slice();
    newValue.splice(index, 1);
    handleValue(event, newValue, 'removeOption', {
      option: value[index]
    });
  };
  const handlePopupIndicator = event => {
    if (open) {
      handleClose(event, 'toggleInput');
    } else {
      handleOpen(event);
    }
  };

  // Prevent input blur when interacting with the combobox
  const handleMouseDown = event => {
    // Prevent focusing the input if click is anywhere outside the Autocomplete
    if (!event.currentTarget.contains(event.target)) {
      return;
    }
    if (event.target.getAttribute('id') !== id) {
      event.preventDefault();
    }
  };

  // Focus the input when interacting with the combobox
  const handleClick = event => {
    // Prevent focusing the input if click is anywhere outside the Autocomplete
    if (!event.currentTarget.contains(event.target)) {
      return;
    }
    inputRef.current.focus();
    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }
    firstFocus.current = false;
  };
  const handleInputMouseDown = event => {
    if (!disabledProp && (inputValue === '' || !open)) {
      handlePopupIndicator(event);
    }
  };
  let dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  let groupedOptions = filteredOptions;
  if (groupBy) {
    // used to keep track of key and indexes in the result array
    const indexBy = new Map();
    let warn = false;
    groupedOptions = filteredOptions.reduce((acc, option, index) => {
      const group = groupBy(option);
      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          if (indexBy.get(group) && !warn) {
            console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${componentName} returns duplicated headers.`, 'You can solve the issue by sorting the options with the output of `groupBy`.');
            warn = true;
          }
          indexBy.set(group, true);
        }
        acc.push({
          key: index,
          index,
          group,
          options: [option]
        });
      }
      return acc;
    }, []);
  }
  if (disabledProp && focused) {
    handleBlur();
  }
  return {
    getRootProps: (other = {}) => (0, _extends2$20.default)({
      'aria-owns': listboxAvailable ? `${id}-listbox` : null
    }, other, {
      onKeyDown: handleKeyDown(other),
      onMouseDown: handleMouseDown,
      onClick: handleClick
    }),
    getInputLabelProps: () => ({
      id: `${id}-label`,
      htmlFor: id
    }),
    getInputProps: () => ({
      id,
      value: inputValue,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onChange: handleInputChange,
      onMouseDown: handleInputMouseDown,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      'aria-activedescendant': popupOpen ? '' : null,
      'aria-autocomplete': autoComplete ? 'both' : 'list',
      'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
      'aria-expanded': listboxAvailable,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: 'off',
      ref: inputRef,
      autoCapitalize: 'none',
      spellCheck: 'false',
      role: 'combobox',
      disabled: disabledProp
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: 'button',
      onClick: handleClear
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: 'button',
      onClick: handlePopupIndicator
    }),
    getTagProps: ({
      index
    }) => (0, _extends2$20.default)({
      key: index,
      'data-tag-index': index,
      tabIndex: -1
    }, !readOnly && {
      onDelete: handleTagDelete(index)
    }),
    getListboxProps: () => ({
      role: 'listbox',
      id: `${id}-listbox`,
      'aria-labelledby': `${id}-label`,
      ref: handleListboxRef,
      onMouseDown: event => {
        // Prevent blur
        event.preventDefault();
      }
    }),
    getOptionProps: ({
      index,
      option
    }) => {
      var _getOptionKey;
      const selected = (multiple ? value : [value]).some(value2 => value2 != null && isOptionEqualToValue(option, value2));
      const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
        tabIndex: -1,
        role: 'option',
        id: `${id}-option-${index}`,
        onMouseMove: handleOptionMouseMove,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id,
    inputValue,
    value,
    dirty,
    expanded: popupOpen && anchorEl,
    popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl,
    setAnchorEl,
    focusedTag,
    groupedOptions
  };
}
useAutocomplete$1.default = useAutocomplete;

(function (exports) {
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createFilterOptions", {
  enumerable: true,
  get: function () {
    return _useAutocomplete.createFilterOptions;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useAutocomplete.default;
  }
});
var _useAutocomplete = _interopRequireWildcard(useAutocomplete$1);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(useAutocomplete$2));

var Popper$3 = {};

var Popper$2 = {};

var BasePopper = {};

var popper$1 = {};

/**
 * @popperjs/core v2.11.8 - MIT License
 */

Object.defineProperty(popper$1, '__esModule', { value: true });

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement$1(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

var max$7 = Math.max;
var min$7 = Math.min;
var round$2 = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement$1(element)) {
    scaleX = element.offsetWidth > 0 ? round$2(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$2(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement$1(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$2(rect.width) / element.offsetWidth || 1;
  var scaleY = round$2(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement$1(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement$1(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement$1(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement$1(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function order$1(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order$1(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$2(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$7(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$7(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max$7(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$7(rect.top, accRect.top);
    accRect.right = min$7(rect.right, accRect.right);
    accRect.bottom = min$7(rect.bottom, accRect.bottom);
    accRect.left = max$7(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

var DEFAULT_OPTIONS$1 = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS$1 : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS$1, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$2(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var passive = {
  passive: true
};

function effect$2(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect$2,
  data: {}
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$2(x * dpr) / dpr || 0,
    y: round$2(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement$1(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$1(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement$1(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$1,
  requires: ['computeStyles']
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function within(min$1, value, max$1) {
  return max$7(min$1, min$7(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$7(min$1, tetherMin) : min$1, offset, tether ? max$7(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

var defaultModifiers$1 = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];
var createPopper$1 = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers$1
}); // eslint-disable-next-line import/no-unused-modules

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

popper$1.applyStyles = applyStyles$1;
popper$1.arrow = arrow$1;
popper$1.computeStyles = computeStyles$1;
popper$1.createPopper = createPopper;
popper$1.createPopperLite = createPopper$1;
popper$1.defaultModifiers = defaultModifiers;
popper$1.detectOverflow = detectOverflow;
popper$1.eventListeners = eventListeners;
popper$1.flip = flip$1;
popper$1.hide = hide$1;
popper$1.offset = offset$1;
popper$1.popperGenerator = popperGenerator;
popper$1.popperOffsets = popperOffsets$1;
popper$1.preventOverflow = preventOverflow$1;

var Portal$2 = {};

var Portal$1 = {};

var _interopRequireDefault$7x = interopRequireDefault$1.exports;
Object.defineProperty(Portal$1, "__esModule", {
  value: true
});
Portal$1.default = void 0;
var React$2n = _interopRequireWildcard$3E(React__default$4);
var ReactDOM$1 = _interopRequireWildcard$3E(require$$2$1);
var _propTypes$2r = _interopRequireDefault$7x(propTypes.exports);
var _utils$S = utils$7;
var _jsxRuntime$2j = require$$11;
function _getRequireWildcardCache$3n(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3n = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3E(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3n(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getContainer$1(container) {
  return typeof container === 'function' ? container() : container;
}

/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */
const Portal = /*#__PURE__*/React$2n.forwardRef(function Portal(props, forwardedRef) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = React$2n.useState(null);
  const handleRef = (0, _utils$S.unstable_useForkRef)( /*#__PURE__*/React$2n.isValidElement(children) ? (0, _utils$S.unstable_getReactElementRef)(children) : null, forwardedRef);
  (0, _utils$S.unstable_useEnhancedEffect)(() => {
    if (!disablePortal) {
      setMountNode(getContainer$1(container) || document.body);
    }
  }, [container, disablePortal]);
  (0, _utils$S.unstable_useEnhancedEffect)(() => {
    if (mountNode && !disablePortal) {
      (0, _utils$S.unstable_setRef)(forwardedRef, mountNode);
      return () => {
        (0, _utils$S.unstable_setRef)(forwardedRef, null);
      };
    }
    return undefined;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if ( /*#__PURE__*/React$2n.isValidElement(children)) {
      const newProps = {
        ref: handleRef
      };
      return /*#__PURE__*/React$2n.cloneElement(children, newProps);
    }
    return /*#__PURE__*/(0, _jsxRuntime$2j.jsx)(React$2n.Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime$2j.jsx)(React$2n.Fragment, {
    children: mountNode ? /*#__PURE__*/ReactDOM$1.createPortal(children, mountNode) : mountNode
  });
});
process.env.NODE_ENV !== "production" ? Portal.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: _propTypes$2r.default.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes$2r.default /* @typescript-to-proptypes-ignore */.oneOfType([_utils$S.HTMLElementType, _propTypes$2r.default.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: _propTypes$2r.default.bool
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = (0, _utils$S.exactProp)(Portal.propTypes);
}
Portal$1.default = Portal;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Portal.default;
  }
});
var _Portal = _interopRequireDefault(Portal$1);
}(Portal$2));

var popperClasses$1 = {};

var _interopRequireDefault$7w = interopRequireDefault$1.exports;
Object.defineProperty(popperClasses$1, "__esModule", {
  value: true
});
popperClasses$1.default = void 0;
popperClasses$1.getPopperUtilityClass = getPopperUtilityClass;
var _generateUtilityClasses$1E = _interopRequireDefault$7w(generateUtilityClasses$3);
var _generateUtilityClass$1D = _interopRequireDefault$7w(generateUtilityClass$3);
function getPopperUtilityClass(slot) {
  return (0, _generateUtilityClass$1D.default)('MuiPopper', slot);
}
const popperClasses = (0, _generateUtilityClasses$1E.default)('MuiPopper', ['root']);
popperClasses$1.default = popperClasses;

var _interopRequireDefault$7v = interopRequireDefault$1.exports;
Object.defineProperty(BasePopper, "__esModule", {
  value: true
});
BasePopper.default = void 0;
var _extends2$1$ = _interopRequireDefault$7v(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1S = _interopRequireDefault$7v(objectWithoutPropertiesLoose.exports);
var React$2m = _interopRequireWildcard$3D(React__default$4);
var _utils$R = utils$7;
var _core = popper$1;
var _propTypes$2q = _interopRequireDefault$7v(propTypes.exports);
var _composeClasses$1A = _interopRequireDefault$7v(composeClasses$2);
var _useSlotProps$8 = _interopRequireDefault$7v(useSlotProps$2);
var _Portal$1 = _interopRequireDefault$7v(Portal$2);
var _popperClasses = popperClasses$1;
var _jsxRuntime$2i = require$$11;
const _excluded$2k = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"],
  _excluded2$m = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function _getRequireWildcardCache$3m(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3m = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3D(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3m(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function flipPlacement(placement, direction) {
  if (direction === 'ltr') {
    return placement;
  }
  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';
    case 'bottom-start':
      return 'bottom-end';
    case 'top-end':
      return 'top-start';
    case 'top-start':
      return 'top-end';
    default:
      return placement;
  }
}
function resolveAnchorEl$1(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function isHTMLElement(element) {
  return element.nodeType !== undefined;
}
function isVirtualElement(element) {
  return !isHTMLElement(element);
}
const useUtilityClasses$1B = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$1A.default)(slots, _popperClasses.getPopperUtilityClass, classes);
};
const defaultPopperOptions = {};
const PopperTooltip = /*#__PURE__*/React$2m.forwardRef(function PopperTooltip(props, forwardedRef) {
  var _slots$root;
  const {
      anchorEl,
      children,
      direction,
      disablePortal,
      modifiers,
      open,
      placement: initialPlacement,
      popperOptions,
      popperRef: popperRefProp,
      slotProps = {},
      slots = {},
      TransitionProps
      // @ts-ignore internal logic
      // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1S.default)(props, _excluded$2k);
  const tooltipRef = React$2m.useRef(null);
  const ownRef = (0, _utils$R.unstable_useForkRef)(tooltipRef, forwardedRef);
  const popperRef = React$2m.useRef(null);
  const handlePopperRef = (0, _utils$R.unstable_useForkRef)(popperRef, popperRefProp);
  const handlePopperRefRef = React$2m.useRef(handlePopperRef);
  (0, _utils$R.unstable_useEnhancedEffect)(() => {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  React$2m.useImperativeHandle(popperRefProp, () => popperRef.current, []);
  const rtlPlacement = flipPlacement(initialPlacement, direction);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */
  const [placement, setPlacement] = React$2m.useState(rtlPlacement);
  const [resolvedAnchorElement, setResolvedAnchorElement] = React$2m.useState(resolveAnchorEl$1(anchorEl));
  React$2m.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  React$2m.useEffect(() => {
    if (anchorEl) {
      setResolvedAnchorElement(resolveAnchorEl$1(anchorEl));
    }
  }, [anchorEl]);
  (0, _utils$R.unstable_useEnhancedEffect)(() => {
    if (!resolvedAnchorElement || !open) {
      return undefined;
    }
    const handlePopperUpdate = data => {
      setPlacement(data.placement);
    };
    if (process.env.NODE_ENV !== 'production') {
      if (resolvedAnchorElement && isHTMLElement(resolvedAnchorElement) && resolvedAnchorElement.nodeType === 1) {
        const box = resolvedAnchorElement.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }
    let popperModifiers = [{
      name: 'preventOverflow',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'flip',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'onUpdate',
      enabled: true,
      phase: 'afterWrite',
      fn: ({
        state
      }) => {
        handlePopperUpdate(state);
      }
    }];
    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }
    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }
    const popper = (0, _core.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, _extends2$1$.default)({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: popperModifiers
    }));
    handlePopperRefRef.current(popper);
    return () => {
      popper.destroy();
      handlePopperRefRef.current(null);
    };
  }, [resolvedAnchorElement, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
  const childProps = {
    placement: placement
  };
  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }
  const classes = useUtilityClasses$1B(props);
  const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
  const rootProps = (0, _useSlotProps$8.default)({
    elementType: Root,
    externalSlotProps: slotProps.root,
    externalForwardedProps: other,
    additionalProps: {
      role: 'tooltip',
      ref: ownRef
    },
    ownerState: props,
    className: classes.root
  });
  return /*#__PURE__*/(0, _jsxRuntime$2i.jsx)(Root, (0, _extends2$1$.default)({}, rootProps, {
    children: typeof children === 'function' ? children(childProps) : children
  }));
});

/**
 * @ignore - internal component.
 */
const Popper$1 = /*#__PURE__*/React$2m.forwardRef(function Popper(props, forwardedRef) {
  const {
      anchorEl,
      children,
      container: containerProp,
      direction = 'ltr',
      disablePortal = false,
      keepMounted = false,
      modifiers,
      open,
      placement = 'bottom',
      popperOptions = defaultPopperOptions,
      popperRef,
      style,
      transition = false,
      slotProps = {},
      slots = {}
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1S.default)(props, _excluded2$m);
  const [exited, setExited] = React$2m.useState(true);
  const handleEnter = () => {
    setExited(false);
  };
  const handleExited = () => {
    setExited(true);
  };
  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container
  let container;
  if (containerProp) {
    container = containerProp;
  } else if (anchorEl) {
    const resolvedAnchorEl = resolveAnchorEl$1(anchorEl);
    container = resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) ? (0, _utils$R.unstable_ownerDocument)(resolvedAnchorEl).body : (0, _utils$R.unstable_ownerDocument)(null).body;
  }
  const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
  const transitionProps = transition ? {
    in: open,
    onEnter: handleEnter,
    onExited: handleExited
  } : undefined;
  return /*#__PURE__*/(0, _jsxRuntime$2i.jsx)(_Portal$1.default, {
    disablePortal: disablePortal,
    container: container,
    children: /*#__PURE__*/(0, _jsxRuntime$2i.jsx)(PopperTooltip, (0, _extends2$1$.default)({
      anchorEl: anchorEl,
      direction: direction,
      disablePortal: disablePortal,
      modifiers: modifiers,
      ref: forwardedRef,
      open: transition ? !exited : open,
      placement: placement,
      popperOptions: popperOptions,
      popperRef: popperRef,
      slotProps: slotProps,
      slots: slots
    }, other, {
      style: (0, _extends2$1$.default)({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: 'fixed',
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display
      }, style),
      TransitionProps: transitionProps,
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? Popper$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: (0, _utils$R.chainPropTypes)(_propTypes$2q.default.oneOfType([_utils$R.HTMLElementType, _propTypes$2q.default.object, _propTypes$2q.default.func]), props => {
    if (props.open) {
      const resolvedAnchorEl = resolveAnchorEl$1(props.anchorEl);
      if (resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== 'function' || isVirtualElement(resolvedAnchorEl) && resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) {
        return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a virtualElement ', '(https://popper.js.org/docs/v2/virtual-elements/).'].join('\n'));
      }
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: _propTypes$2q.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2q.default.node, _propTypes$2q.default.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes$2q.default /* @typescript-to-proptypes-ignore */.oneOfType([_utils$R.HTMLElementType, _propTypes$2q.default.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: _propTypes$2q.default.oneOf(['ltr', 'rtl']),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: _propTypes$2q.default.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: _propTypes$2q.default.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: _propTypes$2q.default.arrayOf(_propTypes$2q.default.shape({
    data: _propTypes$2q.default.object,
    effect: _propTypes$2q.default.func,
    enabled: _propTypes$2q.default.bool,
    fn: _propTypes$2q.default.func,
    name: _propTypes$2q.default.any,
    options: _propTypes$2q.default.object,
    phase: _propTypes$2q.default.oneOf(['afterMain', 'afterRead', 'afterWrite', 'beforeMain', 'beforeRead', 'beforeWrite', 'main', 'read', 'write']),
    requires: _propTypes$2q.default.arrayOf(_propTypes$2q.default.string),
    requiresIfExists: _propTypes$2q.default.arrayOf(_propTypes$2q.default.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$2q.default.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: _propTypes$2q.default.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: _propTypes$2q.default.shape({
    modifiers: _propTypes$2q.default.array,
    onFirstUpdate: _propTypes$2q.default.func,
    placement: _propTypes$2q.default.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
    strategy: _propTypes$2q.default.oneOf(['absolute', 'fixed'])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: _utils$R.refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: _propTypes$2q.default.shape({
    root: _propTypes$2q.default.oneOfType([_propTypes$2q.default.func, _propTypes$2q.default.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: _propTypes$2q.default.shape({
    root: _propTypes$2q.default.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: _propTypes$2q.default.bool
} : void 0;
BasePopper.default = Popper$1;

var _interopRequireDefault$7u = interopRequireDefault$1.exports;
Object.defineProperty(Popper$2, "__esModule", {
  value: true
});
Popper$2.default = void 0;
var _extends2$1_ = _interopRequireDefault$7u(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1R = _interopRequireDefault$7u(objectWithoutPropertiesLoose.exports);
var _useThemeWithoutDefault = _interopRequireDefault$7u(useThemeWithoutDefault);
var _refType$e = _interopRequireDefault$7u(refType$2);
var _HTMLElementType$4 = _interopRequireDefault$7u(HTMLElementType$2);
var _propTypes$2p = _interopRequireDefault$7u(propTypes.exports);
var React$2l = _interopRequireWildcard$3C(React__default$4);
var _BasePopper = _interopRequireDefault$7u(BasePopper);
var _styles$6 = styles$u;
var _DefaultPropsProvider$1B = DefaultPropsProvider$5;
var _jsxRuntime$2h = require$$11;
const _excluded$2j = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"];
function _getRequireWildcardCache$3l(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3l = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3C(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3l(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PopperRoot = (0, _styles$6.styled)(_BasePopper.default, {
  name: 'MuiPopper',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});

/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */
const Popper = /*#__PURE__*/React$2l.forwardRef(function Popper(inProps, ref) {
  var _slots$root;
  const theme = (0, _useThemeWithoutDefault.default)();
  const props = (0, _DefaultPropsProvider$1B.useDefaultProps)({
    props: inProps,
    name: 'MuiPopper'
  });
  const {
      anchorEl,
      component,
      components,
      componentsProps,
      container,
      disablePortal,
      keepMounted,
      modifiers,
      open,
      placement,
      popperOptions,
      popperRef,
      transition,
      slots,
      slotProps
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1R.default)(props, _excluded$2j);
  const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
  const otherProps = (0, _extends2$1_.default)({
    anchorEl,
    container,
    disablePortal,
    keepMounted,
    modifiers,
    open,
    placement,
    popperOptions,
    popperRef,
    transition
  }, other);
  return /*#__PURE__*/(0, _jsxRuntime$2h.jsx)(PopperRoot, (0, _extends2$1_.default)({
    as: component,
    direction: theme == null ? void 0 : theme.direction,
    slots: {
      root: RootComponent
    },
    slotProps: slotProps != null ? slotProps : componentsProps
  }, otherProps, {
    ref: ref
  }));
});
process.env.NODE_ENV !== "production" ? Popper.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: _propTypes$2p.default /* @typescript-to-proptypes-ignore */.oneOfType([_HTMLElementType$4.default, _propTypes$2p.default.object, _propTypes$2p.default.func]),
  /**
   * Popper render function or node.
   */
  children: _propTypes$2p.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2p.default.node, _propTypes$2p.default.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2p.default.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: _propTypes$2p.default.shape({
    Root: _propTypes$2p.default.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: _propTypes$2p.default.shape({
    root: _propTypes$2p.default.oneOfType([_propTypes$2p.default.func, _propTypes$2p.default.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes$2p.default /* @typescript-to-proptypes-ignore */.oneOfType([_HTMLElementType$4.default, _propTypes$2p.default.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: _propTypes$2p.default.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: _propTypes$2p.default.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: _propTypes$2p.default.arrayOf(_propTypes$2p.default.shape({
    data: _propTypes$2p.default.object,
    effect: _propTypes$2p.default.func,
    enabled: _propTypes$2p.default.bool,
    fn: _propTypes$2p.default.func,
    name: _propTypes$2p.default.any,
    options: _propTypes$2p.default.object,
    phase: _propTypes$2p.default.oneOf(['afterMain', 'afterRead', 'afterWrite', 'beforeMain', 'beforeRead', 'beforeWrite', 'main', 'read', 'write']),
    requires: _propTypes$2p.default.arrayOf(_propTypes$2p.default.string),
    requiresIfExists: _propTypes$2p.default.arrayOf(_propTypes$2p.default.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$2p.default.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: _propTypes$2p.default.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: _propTypes$2p.default.shape({
    modifiers: _propTypes$2p.default.array,
    onFirstUpdate: _propTypes$2p.default.func,
    placement: _propTypes$2p.default.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
    strategy: _propTypes$2p.default.oneOf(['absolute', 'fixed'])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: _refType$e.default,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: _propTypes$2p.default.shape({
    root: _propTypes$2p.default.oneOfType([_propTypes$2p.default.func, _propTypes$2p.default.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: _propTypes$2p.default.shape({
    root: _propTypes$2p.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2p.default.oneOfType([_propTypes$2p.default.arrayOf(_propTypes$2p.default.oneOfType([_propTypes$2p.default.func, _propTypes$2p.default.object, _propTypes$2p.default.bool])), _propTypes$2p.default.func, _propTypes$2p.default.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: _propTypes$2p.default.bool
} : void 0;
Popper$2.default = Popper;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Popper.default;
  }
});
var _Popper = _interopRequireDefault(Popper$2);
var _popperClasses = popperClasses$1;
Object.keys(_popperClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _popperClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _popperClasses[key];
    }
  });
});
}(Popper$3));

var ListSubheader$2 = {};

var ListSubheader$1 = {};

var listSubheaderClasses$1 = {};

var _interopRequireDefault$7t = interopRequireDefault$1.exports;
Object.defineProperty(listSubheaderClasses$1, "__esModule", {
  value: true
});
listSubheaderClasses$1.default = void 0;
listSubheaderClasses$1.getListSubheaderUtilityClass = getListSubheaderUtilityClass;
var _generateUtilityClasses$1D = _interopRequireDefault$7t(generateUtilityClasses$3);
var _generateUtilityClass$1C = _interopRequireDefault$7t(generateUtilityClass$3);
function getListSubheaderUtilityClass(slot) {
  return (0, _generateUtilityClass$1C.default)('MuiListSubheader', slot);
}
const listSubheaderClasses = (0, _generateUtilityClasses$1D.default)('MuiListSubheader', ['root', 'colorPrimary', 'colorInherit', 'gutters', 'inset', 'sticky']);
listSubheaderClasses$1.default = listSubheaderClasses;

var _interopRequireDefault$7s = interopRequireDefault$1.exports;
Object.defineProperty(ListSubheader$1, "__esModule", {
  value: true
});
ListSubheader$1.default = void 0;
var _objectWithoutPropertiesLoose2$1Q = _interopRequireDefault$7s(objectWithoutPropertiesLoose.exports);
var _extends2$1Z = _interopRequireDefault$7s(_extends$19.exports);
var React$2k = _interopRequireWildcard$3B(React__default$4);
var _propTypes$2o = _interopRequireDefault$7s(propTypes.exports);
var _clsx$27 = _interopRequireDefault$7s(clsx.exports);
var _composeClasses$1z = _interopRequireDefault$7s(composeClasses$2);
var _styled$1y = _interopRequireDefault$7s(styled$2);
var _DefaultPropsProvider$1A = DefaultPropsProvider$5;
var _capitalize$F = _interopRequireDefault$7s(capitalize$1);
var _listSubheaderClasses = listSubheaderClasses$1;
var _jsxRuntime$2g = require$$11;
const _excluded$2i = ["className", "color", "component", "disableGutters", "disableSticky", "inset"];
function _getRequireWildcardCache$3k(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3k = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3B(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3k(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1A = ownerState => {
  const {
    classes,
    color,
    disableGutters,
    inset,
    disableSticky
  } = ownerState;
  const slots = {
    root: ['root', color !== 'default' && `color${(0, _capitalize$F.default)(color)}`, !disableGutters && 'gutters', inset && 'inset', !disableSticky && 'sticky']
  };
  return (0, _composeClasses$1z.default)(slots, _listSubheaderClasses.getListSubheaderUtilityClass, classes);
};
const ListSubheaderRoot = (0, _styled$1y.default)('li', {
  name: 'MuiListSubheader',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${(0, _capitalize$F.default)(ownerState.color)}`], !ownerState.disableGutters && styles.gutters, ownerState.inset && styles.inset, !ownerState.disableSticky && styles.sticky];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1Z.default)({
  boxSizing: 'border-box',
  lineHeight: '48px',
  listStyle: 'none',
  color: (theme.vars || theme).palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(14)
}, ownerState.color === 'primary' && {
  color: (theme.vars || theme).palette.primary.main
}, ownerState.color === 'inherit' && {
  color: 'inherit'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.inset && {
  paddingLeft: 72
}, !ownerState.disableSticky && {
  position: 'sticky',
  top: 0,
  zIndex: 1,
  backgroundColor: (theme.vars || theme).palette.background.paper
}));
const ListSubheader = /*#__PURE__*/React$2k.forwardRef(function ListSubheader(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1A.useDefaultProps)({
    props: inProps,
    name: 'MuiListSubheader'
  });
  const {
      className,
      color = 'default',
      component = 'li',
      disableGutters = false,
      disableSticky = false,
      inset = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1Q.default)(props, _excluded$2i);
  const ownerState = (0, _extends2$1Z.default)({}, props, {
    color,
    component,
    disableGutters,
    disableSticky,
    inset
  });
  const classes = useUtilityClasses$1A(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$2g.jsx)(ListSubheaderRoot, (0, _extends2$1Z.default)({
    as: component,
    className: (0, _clsx$27.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
ListSubheader.muiSkipListHighlight = true;
process.env.NODE_ENV !== "production" ? ListSubheader.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2o.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2o.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2o.default.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: _propTypes$2o.default.oneOf(['default', 'inherit', 'primary']),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2o.default.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: _propTypes$2o.default.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: _propTypes$2o.default.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: _propTypes$2o.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2o.default.oneOfType([_propTypes$2o.default.arrayOf(_propTypes$2o.default.oneOfType([_propTypes$2o.default.func, _propTypes$2o.default.object, _propTypes$2o.default.bool])), _propTypes$2o.default.func, _propTypes$2o.default.object])
} : void 0;
ListSubheader$1.default = ListSubheader;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  listSubheaderClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ListSubheader.default;
  }
});
Object.defineProperty(exports, "listSubheaderClasses", {
  enumerable: true,
  get: function () {
    return _listSubheaderClasses.default;
  }
});
var _ListSubheader = _interopRequireDefault(ListSubheader$1);
var _listSubheaderClasses = _interopRequireWildcard(listSubheaderClasses$1);
Object.keys(_listSubheaderClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _listSubheaderClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _listSubheaderClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ListSubheader$2));

var Chip$3 = {};

var Chip$2 = {};

var Cancel = {};

var _interopRequireDefault$7r = interopRequireDefault$1.exports;
Object.defineProperty(Cancel, "__esModule", {
  value: true
});
Cancel.default = void 0;
_interopRequireWildcard$3A(React__default$4);
var _createSvgIcon$k = _interopRequireDefault$7r(createSvgIcon$2);
var _jsxRuntime$2f = require$$11;
function _getRequireWildcardCache$3j(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3j = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3A(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3j(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
Cancel.default = (0, _createSvgIcon$k.default)( /*#__PURE__*/(0, _jsxRuntime$2f.jsx)("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

var chipClasses$1 = {};

var _interopRequireDefault$7q = interopRequireDefault$1.exports;
Object.defineProperty(chipClasses$1, "__esModule", {
  value: true
});
chipClasses$1.default = void 0;
chipClasses$1.getChipUtilityClass = getChipUtilityClass;
var _generateUtilityClasses$1C = _interopRequireDefault$7q(generateUtilityClasses$3);
var _generateUtilityClass$1B = _interopRequireDefault$7q(generateUtilityClass$3);
function getChipUtilityClass(slot) {
  return (0, _generateUtilityClass$1B.default)('MuiChip', slot);
}
const chipClasses = (0, _generateUtilityClasses$1C.default)('MuiChip', ['root', 'sizeSmall', 'sizeMedium', 'colorError', 'colorInfo', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorWarning', 'disabled', 'clickable', 'clickableColorPrimary', 'clickableColorSecondary', 'deletable', 'deletableColorPrimary', 'deletableColorSecondary', 'outlined', 'filled', 'outlinedPrimary', 'outlinedSecondary', 'filledPrimary', 'filledSecondary', 'avatar', 'avatarSmall', 'avatarMedium', 'avatarColorPrimary', 'avatarColorSecondary', 'icon', 'iconSmall', 'iconMedium', 'iconColorPrimary', 'iconColorSecondary', 'label', 'labelSmall', 'labelMedium', 'deleteIcon', 'deleteIconSmall', 'deleteIconMedium', 'deleteIconColorPrimary', 'deleteIconColorSecondary', 'deleteIconOutlinedColorPrimary', 'deleteIconOutlinedColorSecondary', 'deleteIconFilledColorPrimary', 'deleteIconFilledColorSecondary', 'focusVisible']);
chipClasses$1.default = chipClasses;

var _interopRequireDefault$7p = interopRequireDefault$1.exports;
Object.defineProperty(Chip$2, "__esModule", {
  value: true
});
Chip$2.default = void 0;
var _objectWithoutPropertiesLoose2$1P = _interopRequireDefault$7p(objectWithoutPropertiesLoose.exports);
var _extends2$1Y = _interopRequireDefault$7p(_extends$19.exports);
var React$2j = _interopRequireWildcard$3z(React__default$4);
var _propTypes$2n = _interopRequireDefault$7p(propTypes.exports);
var _clsx$26 = _interopRequireDefault$7p(clsx.exports);
var _composeClasses$1y = _interopRequireDefault$7p(composeClasses$2);
var _colorManipulator$j = colorManipulator;
var _Cancel = _interopRequireDefault$7p(Cancel);
var _useForkRef$h = _interopRequireDefault$7p(useForkRef);
var _unsupportedProp$2 = _interopRequireDefault$7p(unsupportedProp);
var _capitalize$E = _interopRequireDefault$7p(capitalize$1);
var _ButtonBase$f = _interopRequireDefault$7p(ButtonBase$2);
var _DefaultPropsProvider$1z = DefaultPropsProvider$5;
var _styled$1x = _interopRequireDefault$7p(styled$2);
var _chipClasses = _interopRequireWildcard$3z(chipClasses$1);
var _jsxRuntime$2e = require$$11;
const _excluded$2h = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"];
function _getRequireWildcardCache$3i(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3i = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3z(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3i(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1z = ownerState => {
  const {
    classes,
    disabled,
    size,
    color,
    iconColor,
    onDelete,
    clickable,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant, disabled && 'disabled', `size${(0, _capitalize$E.default)(size)}`, `color${(0, _capitalize$E.default)(color)}`, clickable && 'clickable', clickable && `clickableColor${(0, _capitalize$E.default)(color)}`, onDelete && 'deletable', onDelete && `deletableColor${(0, _capitalize$E.default)(color)}`, `${variant}${(0, _capitalize$E.default)(color)}`],
    label: ['label', `label${(0, _capitalize$E.default)(size)}`],
    avatar: ['avatar', `avatar${(0, _capitalize$E.default)(size)}`, `avatarColor${(0, _capitalize$E.default)(color)}`],
    icon: ['icon', `icon${(0, _capitalize$E.default)(size)}`, `iconColor${(0, _capitalize$E.default)(iconColor)}`],
    deleteIcon: ['deleteIcon', `deleteIcon${(0, _capitalize$E.default)(size)}`, `deleteIconColor${(0, _capitalize$E.default)(color)}`, `deleteIcon${(0, _capitalize$E.default)(variant)}Color${(0, _capitalize$E.default)(color)}`]
  };
  return (0, _composeClasses$1y.default)(slots, _chipClasses.getChipUtilityClass, classes);
};
const ChipRoot = (0, _styled$1x.default)('div', {
  name: 'MuiChip',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      color,
      iconColor,
      clickable,
      onDelete,
      size,
      variant
    } = ownerState;
    return [{
      [`& .${_chipClasses.default.avatar}`]: styles.avatar
    }, {
      [`& .${_chipClasses.default.avatar}`]: styles[`avatar${(0, _capitalize$E.default)(size)}`]
    }, {
      [`& .${_chipClasses.default.avatar}`]: styles[`avatarColor${(0, _capitalize$E.default)(color)}`]
    }, {
      [`& .${_chipClasses.default.icon}`]: styles.icon
    }, {
      [`& .${_chipClasses.default.icon}`]: styles[`icon${(0, _capitalize$E.default)(size)}`]
    }, {
      [`& .${_chipClasses.default.icon}`]: styles[`iconColor${(0, _capitalize$E.default)(iconColor)}`]
    }, {
      [`& .${_chipClasses.default.deleteIcon}`]: styles.deleteIcon
    }, {
      [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, _capitalize$E.default)(size)}`]
    }, {
      [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIconColor${(0, _capitalize$E.default)(color)}`]
    }, {
      [`& .${_chipClasses.default.deleteIcon}`]: styles[`deleteIcon${(0, _capitalize$E.default)(variant)}Color${(0, _capitalize$E.default)(color)}`]
    }, styles.root, styles[`size${(0, _capitalize$E.default)(size)}`], styles[`color${(0, _capitalize$E.default)(color)}`], clickable && styles.clickable, clickable && color !== 'default' && styles[`clickableColor${(0, _capitalize$E.default)(color)})`], onDelete && styles.deletable, onDelete && color !== 'default' && styles[`deletableColor${(0, _capitalize$E.default)(color)}`], styles[variant], styles[`${variant}${(0, _capitalize$E.default)(color)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
  return (0, _extends2$1Y.default)({
    maxWidth: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    color: (theme.vars || theme).palette.text.primary,
    backgroundColor: (theme.vars || theme).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['background-color', 'box-shadow']),
    // reset cursor explicitly in case ButtonBase is used
    cursor: 'unset',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: 'none',
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    [`&.${_chipClasses.default.disabled}`]: {
      opacity: (theme.vars || theme).palette.action.disabledOpacity,
      pointerEvents: 'none'
    },
    [`& .${_chipClasses.default.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
      fontSize: theme.typography.pxToRem(12)
    },
    [`& .${_chipClasses.default.avatarColorPrimary}`]: {
      color: (theme.vars || theme).palette.primary.contrastText,
      backgroundColor: (theme.vars || theme).palette.primary.dark
    },
    [`& .${_chipClasses.default.avatarColorSecondary}`]: {
      color: (theme.vars || theme).palette.secondary.contrastText,
      backgroundColor: (theme.vars || theme).palette.secondary.dark
    },
    [`& .${_chipClasses.default.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: theme.typography.pxToRem(10)
    },
    [`& .${_chipClasses.default.icon}`]: (0, _extends2$1Y.default)({
      marginLeft: 5,
      marginRight: -6
    }, ownerState.size === 'small' && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, ownerState.iconColor === ownerState.color && (0, _extends2$1Y.default)({
      color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
    }, ownerState.color !== 'default' && {
      color: 'inherit'
    })),
    [`& .${_chipClasses.default.deleteIcon}`]: (0, _extends2$1Y.default)({
      WebkitTapHighlightColor: 'transparent',
      color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, _colorManipulator$j.alpha)(theme.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, _colorManipulator$j.alpha)(theme.palette.text.primary, 0.4)
      }
    }, ownerState.size === 'small' && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, ownerState.color !== 'default' && {
      color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, _colorManipulator$j.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
      '&:hover, &:active': {
        color: (theme.vars || theme).palette[ownerState.color].contrastText
      }
    })
  }, ownerState.size === 'small' && {
    height: 24
  }, ownerState.color !== 'default' && {
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
    color: (theme.vars || theme).palette[ownerState.color].contrastText
  }, ownerState.onDelete && {
    [`&.${_chipClasses.default.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator$j.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  }, ownerState.onDelete && ownerState.color !== 'default' && {
    [`&.${_chipClasses.default.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
    }
  });
}, ({
  theme,
  ownerState
}) => (0, _extends2$1Y.default)({}, ownerState.clickable && {
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator$j.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
  },
  [`&.${_chipClasses.default.focusVisible}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator$j.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
  },
  '&:active': {
    boxShadow: (theme.vars || theme).shadows[1]
  }
}, ownerState.clickable && ownerState.color !== 'default' && {
  [`&:hover, &.${_chipClasses.default.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
  }
}), ({
  theme,
  ownerState
}) => (0, _extends2$1Y.default)({}, ownerState.variant === 'outlined' && {
  backgroundColor: 'transparent',
  border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
  [`&.${_chipClasses.default.clickable}:hover`]: {
    backgroundColor: (theme.vars || theme).palette.action.hover
  },
  [`&.${_chipClasses.default.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`& .${_chipClasses.default.avatar}`]: {
    marginLeft: 4
  },
  [`& .${_chipClasses.default.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${_chipClasses.default.icon}`]: {
    marginLeft: 4
  },
  [`& .${_chipClasses.default.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${_chipClasses.default.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${_chipClasses.default.deleteIconSmall}`]: {
    marginRight: 3
  }
}, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
  color: (theme.vars || theme).palette[ownerState.color].main,
  border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, _colorManipulator$j.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
  [`&.${_chipClasses.default.clickable}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$j.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
  },
  [`&.${_chipClasses.default.focusVisible}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _colorManipulator$j.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
  },
  [`& .${_chipClasses.default.deleteIcon}`]: {
    color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, _colorManipulator$j.alpha)(theme.palette[ownerState.color].main, 0.7),
    '&:hover, &:active': {
      color: (theme.vars || theme).palette[ownerState.color].main
    }
  }
}));
const ChipLabel = (0, _styled$1x.default)('span', {
  name: 'MuiChip',
  slot: 'Label',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      size
    } = ownerState;
    return [styles.label, styles[`label${(0, _capitalize$E.default)(size)}`]];
  }
})(({
  ownerState
}) => (0, _extends2$1Y.default)({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: 'nowrap'
}, ownerState.variant === 'outlined' && {
  paddingLeft: 11,
  paddingRight: 11
}, ownerState.size === 'small' && {
  paddingLeft: 8,
  paddingRight: 8
}, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
  paddingLeft: 7,
  paddingRight: 7
}));
function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}

/**
 * Chips represent complex entities in small blocks, such as a contact.
 */
const Chip$1 = /*#__PURE__*/React$2j.forwardRef(function Chip(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1z.useDefaultProps)({
    props: inProps,
    name: 'MuiChip'
  });
  const {
      avatar: avatarProp,
      className,
      clickable: clickableProp,
      color = 'default',
      component: ComponentProp,
      deleteIcon: deleteIconProp,
      disabled = false,
      icon: iconProp,
      label,
      onClick,
      onDelete,
      onKeyDown,
      onKeyUp,
      size = 'medium',
      variant = 'filled',
      tabIndex,
      skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1P.default)(props, _excluded$2h);
  const chipRef = React$2j.useRef(null);
  const handleRef = (0, _useForkRef$h.default)(chipRef, ref);
  const handleDeleteIconClick = event => {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();
    if (onDelete) {
      onDelete(event);
    }
  };
  const handleKeyDown = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // Will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  const handleKeyUp = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }
    if (onKeyUp) {
      onKeyUp(event);
    }
  };
  const clickable = clickableProp !== false && onClick ? true : clickableProp;
  const component = clickable || onDelete ? _ButtonBase$f.default : ComponentProp || 'div';
  const ownerState = (0, _extends2$1Y.default)({}, props, {
    component,
    disabled,
    size,
    color,
    iconColor: /*#__PURE__*/React$2j.isValidElement(iconProp) ? iconProp.props.color || color : color,
    onDelete: !!onDelete,
    clickable,
    variant
  });
  const classes = useUtilityClasses$1z(ownerState);
  const moreProps = component === _ButtonBase$f.default ? (0, _extends2$1Y.default)({
    component: ComponentProp || 'div',
    focusVisibleClassName: classes.focusVisible
  }, onDelete && {
    disableRipple: true
  }) : {};
  let deleteIcon = null;
  if (onDelete) {
    deleteIcon = deleteIconProp && /*#__PURE__*/React$2j.isValidElement(deleteIconProp) ? ( /*#__PURE__*/React$2j.cloneElement(deleteIconProp, {
      className: (0, _clsx$26.default)(deleteIconProp.props.className, classes.deleteIcon),
      onClick: handleDeleteIconClick
    })) : /*#__PURE__*/(0, _jsxRuntime$2e.jsx)(_Cancel.default, {
      className: (0, _clsx$26.default)(classes.deleteIcon),
      onClick: handleDeleteIconClick
    });
  }
  let avatar = null;
  if (avatarProp && /*#__PURE__*/React$2j.isValidElement(avatarProp)) {
    avatar = /*#__PURE__*/React$2j.cloneElement(avatarProp, {
      className: (0, _clsx$26.default)(classes.avatar, avatarProp.props.className)
    });
  }
  let icon = null;
  if (iconProp && /*#__PURE__*/React$2j.isValidElement(iconProp)) {
    icon = /*#__PURE__*/React$2j.cloneElement(iconProp, {
      className: (0, _clsx$26.default)(classes.icon, iconProp.props.className)
    });
  }
  if (process.env.NODE_ENV !== 'production') {
    if (avatar && icon) {
      console.error('MUI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime$2e.jsxs)(ChipRoot, (0, _extends2$1Y.default)({
    as: component,
    className: (0, _clsx$26.default)(classes.root, className),
    disabled: clickable && disabled ? true : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef,
    tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
    ownerState: ownerState
  }, moreProps, other, {
    children: [avatar || icon, /*#__PURE__*/(0, _jsxRuntime$2e.jsx)(ChipLabel, {
      className: (0, _clsx$26.default)(classes.label),
      ownerState: ownerState,
      children: label
    }), deleteIcon]
  }));
});
process.env.NODE_ENV !== "production" ? Chip$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: _propTypes$2n.default.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: _unsupportedProp$2.default,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2n.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2n.default.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: _propTypes$2n.default.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: _propTypes$2n.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2n.default.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$2n.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2n.default.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: _propTypes$2n.default.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$2n.default.bool,
  /**
   * Icon element.
   */
  icon: _propTypes$2n.default.element,
  /**
   * The content of the component.
   */
  label: _propTypes$2n.default.node,
  /**
   * @ignore
   */
  onClick: _propTypes$2n.default.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: _propTypes$2n.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes$2n.default.func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes$2n.default.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: _propTypes$2n.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2n.default.oneOf(['medium', 'small']), _propTypes$2n.default.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: _propTypes$2n.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2n.default.oneOfType([_propTypes$2n.default.arrayOf(_propTypes$2n.default.oneOfType([_propTypes$2n.default.func, _propTypes$2n.default.object, _propTypes$2n.default.bool])), _propTypes$2n.default.func, _propTypes$2n.default.object]),
  /**
   * @ignore
   */
  tabIndex: _propTypes$2n.default.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: _propTypes$2n.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2n.default.oneOf(['filled', 'outlined']), _propTypes$2n.default.string])
} : void 0;
Chip$2.default = Chip$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  chipClasses: true
};
Object.defineProperty(exports, "chipClasses", {
  enumerable: true,
  get: function () {
    return _chipClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Chip.default;
  }
});
var _Chip = _interopRequireDefault(Chip$2);
var _chipClasses = _interopRequireWildcard(chipClasses$1);
Object.keys(_chipClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _chipClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _chipClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Chip$3));

var Chip = /*@__PURE__*/getDefaultExportFromCjs$1(Chip$3);

var inputClasses$1 = {};

var InputBase$3 = {};

var InputBase$2 = {};

var TextareaAutosize$2 = {};

var TextareaAutosize$1 = {};

var _interopRequireDefault$7o = interopRequireDefault$1.exports;
Object.defineProperty(TextareaAutosize$1, "__esModule", {
  value: true
});
TextareaAutosize$1.default = void 0;
var _extends2$1X = _interopRequireDefault$7o(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1O = _interopRequireDefault$7o(objectWithoutPropertiesLoose.exports);
var React$2i = _interopRequireWildcard$3y(React__default$4);
var _propTypes$2m = _interopRequireDefault$7o(propTypes.exports);
var _utils$Q = utils$7;
var _jsxRuntime$2d = require$$11;
const _excluded$2g = ["onChange", "maxRows", "minRows", "style", "value"];
function _getRequireWildcardCache$3h(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3h = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3y(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3h(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getStyleValue(value) {
  return parseInt(value, 10) || 0;
}
const styles$t = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
function isEmpty$2(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}

/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */
const TextareaAutosize = /*#__PURE__*/React$2i.forwardRef(function TextareaAutosize(props, forwardedRef) {
  const {
      onChange,
      maxRows,
      minRows = 1,
      style,
      value
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1O.default)(props, _excluded$2g);
  const {
    current: isControlled
  } = React$2i.useRef(value != null);
  const inputRef = React$2i.useRef(null);
  const handleRef = (0, _utils$Q.unstable_useForkRef)(forwardedRef, inputRef);
  const heightRef = React$2i.useRef(null);
  const shadowRef = React$2i.useRef(null);
  const calculateTextareaStyles = React$2i.useCallback(() => {
    const input = inputRef.current;
    const containerWindow = (0, _utils$Q.unstable_ownerWindow)(input);
    const computedStyle = containerWindow.getComputedStyle(input);

    // If input's width is shrunk and it's not visible, don't sync height.
    if (computedStyle.width === '0px') {
      return {
        outerHeightStyle: 0,
        overflowing: false
      };
    }
    const inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';
    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }
    const boxSizing = computedStyle.boxSizing;
    const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
    const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);

    // The height of the inner content
    const innerHeight = inputShallow.scrollHeight;

    // Measure height of a textarea with a single row
    inputShallow.value = 'x';
    const singleRowHeight = inputShallow.scrollHeight;

    // The height of the outer content
    let outerHeight = innerHeight;
    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }
    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }
    outerHeight = Math.max(outerHeight, singleRowHeight);

    // Take the box sizing into account for applying this value as a style.
    const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
    return {
      outerHeightStyle,
      overflowing
    };
  }, [maxRows, minRows, props.placeholder]);
  const syncHeight = React$2i.useCallback(() => {
    const textareaStyles = calculateTextareaStyles();
    if (isEmpty$2(textareaStyles)) {
      return;
    }
    const outerHeightStyle = textareaStyles.outerHeightStyle;
    const input = inputRef.current;
    if (heightRef.current !== outerHeightStyle) {
      heightRef.current = outerHeightStyle;
      input.style.height = `${outerHeightStyle}px`;
    }
    input.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
  }, [calculateTextareaStyles]);
  (0, _utils$Q.unstable_useEnhancedEffect)(() => {
    const handleResize = () => {
      syncHeight();
    };
    // Workaround a "ResizeObserver loop completed with undelivered notifications" error
    // in test.
    // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
    // Also see https://github.com/mui/mui-x/issues/8733
    let rAF;
    const rAFHandleResize = () => {
      cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(() => {
        handleResize();
      });
    };
    const debounceHandleResize = (0, _utils$Q.unstable_debounce)(handleResize);
    const input = inputRef.current;
    const containerWindow = (0, _utils$Q.unstable_ownerWindow)(input);
    containerWindow.addEventListener('resize', debounceHandleResize);
    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(process.env.NODE_ENV === 'test' ? rAFHandleResize : handleResize);
      resizeObserver.observe(input);
    }
    return () => {
      debounceHandleResize.clear();
      cancelAnimationFrame(rAF);
      containerWindow.removeEventListener('resize', debounceHandleResize);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [calculateTextareaStyles, syncHeight]);
  (0, _utils$Q.unstable_useEnhancedEffect)(() => {
    syncHeight();
  });
  const handleChange = event => {
    if (!isControlled) {
      syncHeight();
    }
    if (onChange) {
      onChange(event);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime$2d.jsxs)(React$2i.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime$2d.jsx)("textarea", (0, _extends2$1X.default)({
      value: value,
      onChange: handleChange,
      ref: handleRef
      // Apply the rows prop to get a "correct" first SSR paint
      ,
      rows: minRows,
      style: style
    }, other)), /*#__PURE__*/(0, _jsxRuntime$2d.jsx)("textarea", {
      "aria-hidden": true,
      className: props.className,
      readOnly: true,
      ref: shadowRef,
      tabIndex: -1,
      style: (0, _extends2$1X.default)({}, styles$t.shadow, style, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" ? TextareaAutosize.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: _propTypes$2m.default.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: _propTypes$2m.default.oneOfType([_propTypes$2m.default.number, _propTypes$2m.default.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: _propTypes$2m.default.oneOfType([_propTypes$2m.default.number, _propTypes$2m.default.string]),
  /**
   * @ignore
   */
  onChange: _propTypes$2m.default.func,
  /**
   * @ignore
   */
  placeholder: _propTypes$2m.default.string,
  /**
   * @ignore
   */
  style: _propTypes$2m.default.object,
  /**
   * @ignore
   */
  value: _propTypes$2m.default.oneOfType([_propTypes$2m.default.arrayOf(_propTypes$2m.default.string), _propTypes$2m.default.number, _propTypes$2m.default.string])
} : void 0;
TextareaAutosize$1.default = TextareaAutosize;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TextareaAutosize.default;
  }
});
var _TextareaAutosize = _interopRequireDefault(TextareaAutosize$1);
}(TextareaAutosize$2));

var formControlState$1 = {};

Object.defineProperty(formControlState$1, "__esModule", {
  value: true
});
formControlState$1.default = formControlState;
function formControlState({
  props,
  states,
  muiFormControl
}) {
  return states.reduce((acc, state) => {
    acc[state] = props[state];
    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }
    return acc;
  }, {});
}

var FormControlContext$1 = {};

Object.defineProperty(FormControlContext$1, "__esModule", {
  value: true
});
FormControlContext$1.default = void 0;
var React$2h = _interopRequireWildcard$3x(React__default$4);
function _getRequireWildcardCache$3g(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3g = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3x(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3g(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const FormControlContext = /*#__PURE__*/React$2h.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}
FormControlContext$1.default = FormControlContext;

var useFormControl$1 = {};

var _interopRequireDefault$7n = interopRequireDefault$1.exports;
Object.defineProperty(useFormControl$1, "__esModule", {
  value: true
});
useFormControl$1.default = useFormControl;
var React$2g = _interopRequireWildcard$3w(React__default$4);
var _FormControlContext$3 = _interopRequireDefault$7n(FormControlContext$1);
function _getRequireWildcardCache$3f(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3f = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3w(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3f(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useFormControl() {
  return React$2g.useContext(_FormControlContext$3.default);
}

var GlobalStyles$2 = {};

var GlobalStyles$1 = {};

var _interopRequireDefault$7m = interopRequireDefault$1.exports;
Object.defineProperty(GlobalStyles$1, "__esModule", {
  value: true
});
GlobalStyles$1.default = void 0;
var _extends2$1W = _interopRequireDefault$7m(_extends$19.exports);
_interopRequireWildcard$3v(React__default$4);
var _propTypes$2l = _interopRequireDefault$7m(propTypes.exports);
var _system$8 = system;
var _defaultTheme = _interopRequireDefault$7m(defaultTheme$7);
var _identifier$1 = _interopRequireDefault$7m(identifier);
var _jsxRuntime$2c = require$$11;
function _getRequireWildcardCache$3e(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3e = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3v(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3e(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function GlobalStyles(props) {
  return /*#__PURE__*/(0, _jsxRuntime$2c.jsx)(_system$8.GlobalStyles, (0, _extends2$1W.default)({}, props, {
    defaultTheme: _defaultTheme.default,
    themeId: _identifier$1.default
  }));
}
process.env.NODE_ENV !== "production" ? GlobalStyles.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: _propTypes$2l.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2l.default.array, _propTypes$2l.default.func, _propTypes$2l.default.number, _propTypes$2l.default.object, _propTypes$2l.default.string, _propTypes$2l.default.bool])
} : void 0;
GlobalStyles$1.default = GlobalStyles;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _GlobalStyles.default;
  }
});
var _GlobalStyles = _interopRequireDefault(GlobalStyles$1);
}(GlobalStyles$2));

var utils$5 = {};

Object.defineProperty(utils$5, "__esModule", {
  value: true
});
utils$5.hasValue = hasValue;
utils$5.isAdornedStart = isAdornedStart;
utils$5.isFilled = isFilled;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
}

// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isFilled(obj, SSR = false) {
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}

// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function isAdornedStart(obj) {
  return obj.startAdornment;
}

var inputBaseClasses$1 = {};

var _interopRequireDefault$7l = interopRequireDefault$1.exports;
Object.defineProperty(inputBaseClasses$1, "__esModule", {
  value: true
});
inputBaseClasses$1.default = void 0;
inputBaseClasses$1.getInputBaseUtilityClass = getInputBaseUtilityClass;
var _generateUtilityClasses$1B = _interopRequireDefault$7l(generateUtilityClasses$3);
var _generateUtilityClass$1A = _interopRequireDefault$7l(generateUtilityClass$3);
function getInputBaseUtilityClass(slot) {
  return (0, _generateUtilityClass$1A.default)('MuiInputBase', slot);
}
const inputBaseClasses = (0, _generateUtilityClasses$1B.default)('MuiInputBase', ['root', 'formControl', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'colorSecondary', 'fullWidth', 'hiddenLabel', 'readOnly', 'input', 'inputSizeSmall', 'inputMultiline', 'inputTypeSearch', 'inputAdornedStart', 'inputAdornedEnd', 'inputHiddenLabel']);
inputBaseClasses$1.default = inputBaseClasses;

var _interopRequireDefault$7k = interopRequireDefault$1.exports;
Object.defineProperty(InputBase$2, "__esModule", {
  value: true
});
InputBase$2.rootOverridesResolver = InputBase$2.inputOverridesResolver = InputBase$2.default = InputBase$2.InputBaseRoot = InputBase$2.InputBaseComponent = void 0;
var _objectWithoutPropertiesLoose2$1N = _interopRequireDefault$7k(objectWithoutPropertiesLoose.exports);
var _extends2$1V = _interopRequireDefault$7k(_extends$19.exports);
var _formatMuiErrorMessage2$1 = _interopRequireDefault$7k(formatMuiErrorMessage$2);
var React$2f = _interopRequireWildcard$3u(React__default$4);
var _propTypes$2k = _interopRequireDefault$7k(propTypes.exports);
var _clsx$25 = _interopRequireDefault$7k(clsx.exports);
var _elementTypeAcceptingRef$4 = _interopRequireDefault$7k(elementTypeAcceptingRef$2);
var _refType$d = _interopRequireDefault$7k(refType$2);
var _composeClasses$1x = _interopRequireDefault$7k(composeClasses$2);
var _isHostComponent$5 = _interopRequireDefault$7k(isHostComponent$2);
var _TextareaAutosize = _interopRequireDefault$7k(TextareaAutosize$2);
var _formControlState$8 = _interopRequireDefault$7k(formControlState$1);
var _FormControlContext$2 = _interopRequireDefault$7k(FormControlContext$1);
var _useFormControl$9 = _interopRequireDefault$7k(useFormControl$1);
var _styled$1w = _interopRequireDefault$7k(styled$2);
var _DefaultPropsProvider$1y = DefaultPropsProvider$5;
var _capitalize$D = _interopRequireDefault$7k(capitalize$1);
var _useForkRef$g = _interopRequireDefault$7k(useForkRef);
var _useEnhancedEffect$6 = _interopRequireDefault$7k(useEnhancedEffect);
var _GlobalStyles$1 = _interopRequireDefault$7k(GlobalStyles$2);
var _utils$P = utils$5;
var _inputBaseClasses = _interopRequireWildcard$3u(inputBaseClasses$1);
var _jsxRuntime$2b = require$$11;
const _excluded$2f = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"];
function _getRequireWildcardCache$3d(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3d = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3u(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3d(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const rootOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.formControl && styles.formControl, ownerState.startAdornment && styles.adornedStart, ownerState.endAdornment && styles.adornedEnd, ownerState.error && styles.error, ownerState.size === 'small' && styles.sizeSmall, ownerState.multiline && styles.multiline, ownerState.color && styles[`color${(0, _capitalize$D.default)(ownerState.color)}`], ownerState.fullWidth && styles.fullWidth, ownerState.hiddenLabel && styles.hiddenLabel];
};
InputBase$2.rootOverridesResolver = rootOverridesResolver;
const inputOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.input, ownerState.size === 'small' && styles.inputSizeSmall, ownerState.multiline && styles.inputMultiline, ownerState.type === 'search' && styles.inputTypeSearch, ownerState.startAdornment && styles.inputAdornedStart, ownerState.endAdornment && styles.inputAdornedEnd, ownerState.hiddenLabel && styles.inputHiddenLabel];
};
InputBase$2.inputOverridesResolver = inputOverridesResolver;
const useUtilityClasses$1y = ownerState => {
  const {
    classes,
    color,
    disabled,
    error,
    endAdornment,
    focused,
    formControl,
    fullWidth,
    hiddenLabel,
    multiline,
    readOnly,
    size,
    startAdornment,
    type
  } = ownerState;
  const slots = {
    root: ['root', `color${(0, _capitalize$D.default)(color)}`, disabled && 'disabled', error && 'error', fullWidth && 'fullWidth', focused && 'focused', formControl && 'formControl', size && size !== 'medium' && `size${(0, _capitalize$D.default)(size)}`, multiline && 'multiline', startAdornment && 'adornedStart', endAdornment && 'adornedEnd', hiddenLabel && 'hiddenLabel', readOnly && 'readOnly'],
    input: ['input', disabled && 'disabled', type === 'search' && 'inputTypeSearch', multiline && 'inputMultiline', size === 'small' && 'inputSizeSmall', hiddenLabel && 'inputHiddenLabel', startAdornment && 'inputAdornedStart', endAdornment && 'inputAdornedEnd', readOnly && 'readOnly']
  };
  return (0, _composeClasses$1x.default)(slots, _inputBaseClasses.getInputBaseUtilityClass, classes);
};
const InputBaseRoot = InputBase$2.InputBaseRoot = (0, _styled$1w.default)('div', {
  name: 'MuiInputBase',
  slot: 'Root',
  overridesResolver: rootOverridesResolver
})(({
  theme,
  ownerState
}) => (0, _extends2$1V.default)({}, theme.typography.body1, {
  color: (theme.vars || theme).palette.text.primary,
  lineHeight: '1.4375em',
  // 23px
  boxSizing: 'border-box',
  // Prevent padding issue with fullWidth.
  position: 'relative',
  cursor: 'text',
  display: 'inline-flex',
  alignItems: 'center',
  [`&.${_inputBaseClasses.default.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled,
    cursor: 'default'
  }
}, ownerState.multiline && (0, _extends2$1V.default)({
  padding: '4px 0 5px'
}, ownerState.size === 'small' && {
  paddingTop: 1
}), ownerState.fullWidth && {
  width: '100%'
}));
const InputBaseComponent = InputBase$2.InputBaseComponent = (0, _styled$1w.default)('input', {
  name: 'MuiInputBase',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  const placeholder = (0, _extends2$1V.default)({
    color: 'currentColor'
  }, theme.vars ? {
    opacity: theme.vars.opacity.inputPlaceholder
  } : {
    opacity: light ? 0.42 : 0.5
  }, {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  });
  const placeholderHidden = {
    opacity: '0 !important'
  };
  const placeholderVisible = theme.vars ? {
    opacity: theme.vars.opacity.inputPlaceholder
  } : {
    opacity: light ? 0.42 : 0.5
  };
  return (0, _extends2$1V.default)({
    font: 'inherit',
    letterSpacing: 'inherit',
    color: 'currentColor',
    padding: '4px 0 5px',
    border: 0,
    boxSizing: 'content-box',
    background: 'none',
    height: '1.4375em',
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: 'transparent',
    display: 'block',
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: '100%',
    // Fix IE11 width issue
    animationName: 'mui-auto-fill-cancel',
    animationDuration: '10ms',
    '&::-webkit-input-placeholder': placeholder,
    '&::-moz-placeholder': placeholder,
    // Firefox 19+
    '&:-ms-input-placeholder': placeholder,
    // IE11
    '&::-ms-input-placeholder': placeholder,
    // Edge
    '&:focus': {
      outline: 0
    },
    // Reset Firefox invalid required input style
    '&:invalid': {
      boxShadow: 'none'
    },
    '&::-webkit-search-decoration': {
      // Remove the padding when type=search.
      WebkitAppearance: 'none'
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${_inputBaseClasses.default.formControl} &`]: {
      '&::-webkit-input-placeholder': placeholderHidden,
      '&::-moz-placeholder': placeholderHidden,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholderHidden,
      // IE11
      '&::-ms-input-placeholder': placeholderHidden,
      // Edge
      '&:focus::-webkit-input-placeholder': placeholderVisible,
      '&:focus::-moz-placeholder': placeholderVisible,
      // Firefox 19+
      '&:focus:-ms-input-placeholder': placeholderVisible,
      // IE11
      '&:focus::-ms-input-placeholder': placeholderVisible // Edge
    },
    [`&.${_inputBaseClasses.default.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
    },
    '&:-webkit-autofill': {
      animationDuration: '5000s',
      animationName: 'mui-auto-fill'
    }
  }, ownerState.size === 'small' && {
    paddingTop: 1
  }, ownerState.multiline && {
    height: 'auto',
    resize: 'none',
    padding: 0,
    paddingTop: 0
  }, ownerState.type === 'search' && {
    // Improve type search style.
    MozAppearance: 'textfield'
  });
});
const inputGlobalStyles = /*#__PURE__*/(0, _jsxRuntime$2b.jsx)(_GlobalStyles$1.default, {
  styles: {
    '@keyframes mui-auto-fill': {
      from: {
        display: 'block'
      }
    },
    '@keyframes mui-auto-fill-cancel': {
      from: {
        display: 'block'
      }
    }
  }
});

/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */
const InputBase$1 = /*#__PURE__*/React$2f.forwardRef(function InputBase(inProps, ref) {
  var _slotProps$input;
  const props = (0, _DefaultPropsProvider$1y.useDefaultProps)({
    props: inProps,
    name: 'MuiInputBase'
  });
  const {
      'aria-describedby': ariaDescribedby,
      autoComplete,
      autoFocus,
      className,
      components = {},
      componentsProps = {},
      defaultValue,
      disabled,
      disableInjectingGlobalStyles,
      endAdornment,
      fullWidth = false,
      id,
      inputComponent = 'input',
      inputProps: inputPropsProp = {},
      inputRef: inputRefProp,
      maxRows,
      minRows,
      multiline = false,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      onKeyDown,
      onKeyUp,
      placeholder,
      readOnly,
      renderSuffix,
      rows,
      slotProps = {},
      slots = {},
      startAdornment,
      type = 'text',
      value: valueProp
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1N.default)(props, _excluded$2f);
  const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
  const {
    current: isControlled
  } = React$2f.useRef(value != null);
  const inputRef = React$2f.useRef();
  const handleInputRefWarning = React$2f.useCallback(instance => {
    if (process.env.NODE_ENV !== 'production') {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['MUI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `ref` prop.', 'Make sure the `ref` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  const handleInputRef = (0, _useForkRef$g.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
  const [focused, setFocused] = React$2f.useState(false);
  const muiFormControl = (0, _useFormControl$9.default)();
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$2f.useEffect(() => {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }
      return undefined;
    }, [muiFormControl]);
  }
  const fcs = (0, _formControlState$8.default)({
    props,
    muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'size', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused;

  // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.
  React$2f.useEffect(() => {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);
      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  const onFilled = muiFormControl && muiFormControl.onFilled;
  const onEmpty = muiFormControl && muiFormControl.onEmpty;
  const checkDirty = React$2f.useCallback(obj => {
    if ((0, _utils$P.isFilled)(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  (0, _useEnhancedEffect$6.default)(() => {
    if (isControlled) {
      checkDirty({
        value
      });
    }
  }, [value, checkDirty, isControlled]);
  const handleFocus = event => {
    // Fix a bug with IE11 where the focus/blur events are triggered
    // while the component is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }
    if (onFocus) {
      onFocus(event);
    }
    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };
  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }
    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };
  const handleChange = (event, ...args) => {
    if (!isControlled) {
      const element = event.target || inputRef.current;
      if (element == null) {
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Expected valid input target. Did you use a custom \`inputComponent\` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info.` : (0, _formatMuiErrorMessage2$1.default)(1));
      }
      checkDirty({
        value: element.value
      });
    }
    if (inputPropsProp.onChange) {
      inputPropsProp.onChange(event, ...args);
    }

    // Perform in the willUpdate
    if (onChange) {
      onChange(event, ...args);
    }
  };

  // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).
  React$2f.useEffect(() => {
    checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClick = event => {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }
    if (onClick) {
      onClick(event);
    }
  };
  let InputComponent = inputComponent;
  let inputProps = inputPropsProp;
  if (multiline && InputComponent === 'input') {
    if (rows) {
      if (process.env.NODE_ENV !== 'production') {
        if (minRows || maxRows) {
          console.warn('MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.');
        }
      }
      inputProps = (0, _extends2$1V.default)({
        type: undefined,
        minRows: rows,
        maxRows: rows
      }, inputProps);
    } else {
      inputProps = (0, _extends2$1V.default)({
        type: undefined,
        maxRows,
        minRows
      }, inputProps);
    }
    InputComponent = _TextareaAutosize.default;
  }
  const handleAutoFill = event => {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };
  React$2f.useEffect(() => {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  const ownerState = (0, _extends2$1V.default)({}, props, {
    color: fcs.color || 'primary',
    disabled: fcs.disabled,
    endAdornment,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    startAdornment,
    type
  });
  const classes = useUtilityClasses$1y(ownerState);
  const Root = slots.root || components.Root || InputBaseRoot;
  const rootProps = slotProps.root || componentsProps.root || {};
  const Input = slots.input || components.Input || InputBaseComponent;
  inputProps = (0, _extends2$1V.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
  return /*#__PURE__*/(0, _jsxRuntime$2b.jsxs)(React$2f.Fragment, {
    children: [!disableInjectingGlobalStyles && inputGlobalStyles, /*#__PURE__*/(0, _jsxRuntime$2b.jsxs)(Root, (0, _extends2$1V.default)({}, rootProps, !(0, _isHostComponent$5.default)(Root) && {
      ownerState: (0, _extends2$1V.default)({}, ownerState, rootProps.ownerState)
    }, {
      ref: ref,
      onClick: handleClick
    }, other, {
      className: (0, _clsx$25.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
      children: [startAdornment, /*#__PURE__*/(0, _jsxRuntime$2b.jsx)(_FormControlContext$2.default.Provider, {
        value: null,
        children: /*#__PURE__*/(0, _jsxRuntime$2b.jsx)(Input, (0, _extends2$1V.default)({
          ownerState: ownerState,
          "aria-invalid": fcs.error,
          "aria-describedby": ariaDescribedby,
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          defaultValue: defaultValue,
          disabled: fcs.disabled,
          id: id,
          onAnimationStart: handleAutoFill,
          name: name,
          placeholder: placeholder,
          readOnly: readOnly,
          required: fcs.required,
          rows: rows,
          value: value,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          type: type
        }, inputProps, !(0, _isHostComponent$5.default)(Input) && {
          as: InputComponent,
          ownerState: (0, _extends2$1V.default)({}, ownerState, inputProps.ownerState)
        }, {
          ref: handleInputRef,
          className: (0, _clsx$25.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
          onBlur: handleBlur,
          onChange: handleChange,
          onFocus: handleFocus
        }))
      }), endAdornment, renderSuffix ? renderSuffix((0, _extends2$1V.default)({}, fcs, {
        startAdornment
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" ? InputBase$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  'aria-describedby': _propTypes$2k.default.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _propTypes$2k.default.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: _propTypes$2k.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2k.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2k.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: _propTypes$2k.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2k.default.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$2k.default.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$2k.default.shape({
    Input: _propTypes$2k.default.elementType,
    Root: _propTypes$2k.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: _propTypes$2k.default.shape({
    input: _propTypes$2k.default.object,
    root: _propTypes$2k.default.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes$2k.default.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: _propTypes$2k.default.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: _propTypes$2k.default.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes$2k.default.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: _propTypes$2k.default.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$2k.default.bool,
  /**
   * The id of the `input` element.
   */
  id: _propTypes$2k.default.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: _elementTypeAcceptingRef$4.default,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: _propTypes$2k.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType$d.default,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: _propTypes$2k.default.oneOf(['dense', 'none']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _propTypes$2k.default.oneOfType([_propTypes$2k.default.number, _propTypes$2k.default.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: _propTypes$2k.default.oneOfType([_propTypes$2k.default.number, _propTypes$2k.default.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: _propTypes$2k.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes$2k.default.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: _propTypes$2k.default.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes$2k.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes$2k.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes$2k.default.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: _propTypes$2k.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes$2k.default.func,
  /**
   * @ignore
   */
  onKeyUp: _propTypes$2k.default.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: _propTypes$2k.default.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes$2k.default.bool,
  /**
   * @ignore
   */
  renderSuffix: _propTypes$2k.default.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: _propTypes$2k.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes$2k.default.oneOfType([_propTypes$2k.default.number, _propTypes$2k.default.string]),
  /**
   * The size of the component.
   */
  size: _propTypes$2k.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2k.default.oneOf(['medium', 'small']), _propTypes$2k.default.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: _propTypes$2k.default.shape({
    input: _propTypes$2k.default.object,
    root: _propTypes$2k.default.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: _propTypes$2k.default.shape({
    input: _propTypes$2k.default.elementType,
    root: _propTypes$2k.default.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes$2k.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2k.default.oneOfType([_propTypes$2k.default.arrayOf(_propTypes$2k.default.oneOfType([_propTypes$2k.default.func, _propTypes$2k.default.object, _propTypes$2k.default.bool])), _propTypes$2k.default.func, _propTypes$2k.default.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: _propTypes$2k.default.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _propTypes$2k.default.any
} : void 0;
InputBase$2.default = InputBase$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  inputBaseClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _InputBase.default;
  }
});
Object.defineProperty(exports, "inputBaseClasses", {
  enumerable: true,
  get: function () {
    return _inputBaseClasses.default;
  }
});
var _InputBase = _interopRequireDefault(InputBase$2);
var _inputBaseClasses = _interopRequireWildcard(inputBaseClasses$1);
Object.keys(_inputBaseClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _inputBaseClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _inputBaseClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(InputBase$3));

var _interopRequireDefault$7j = interopRequireDefault$1.exports;
Object.defineProperty(inputClasses$1, "__esModule", {
  value: true
});
inputClasses$1.default = void 0;
inputClasses$1.getInputUtilityClass = getInputUtilityClass;
var _extends2$1U = _interopRequireDefault$7j(_extends$19.exports);
var _generateUtilityClasses$1A = _interopRequireDefault$7j(generateUtilityClasses$3);
var _generateUtilityClass$1z = _interopRequireDefault$7j(generateUtilityClass$3);
var _InputBase$6 = InputBase$3;
function getInputUtilityClass(slot) {
  return (0, _generateUtilityClass$1z.default)('MuiInput', slot);
}
const inputClasses = (0, _extends2$1U.default)({}, _InputBase$6.inputBaseClasses, (0, _generateUtilityClasses$1A.default)('MuiInput', ['root', 'underline', 'input']));
inputClasses$1.default = inputClasses;

var outlinedInputClasses$1 = {};

var _interopRequireDefault$7i = interopRequireDefault$1.exports;
Object.defineProperty(outlinedInputClasses$1, "__esModule", {
  value: true
});
outlinedInputClasses$1.default = void 0;
outlinedInputClasses$1.getOutlinedInputUtilityClass = getOutlinedInputUtilityClass;
var _extends2$1T = _interopRequireDefault$7i(_extends$19.exports);
var _generateUtilityClasses$1z = _interopRequireDefault$7i(generateUtilityClasses$3);
var _generateUtilityClass$1y = _interopRequireDefault$7i(generateUtilityClass$3);
var _InputBase$5 = InputBase$3;
function getOutlinedInputUtilityClass(slot) {
  return (0, _generateUtilityClass$1y.default)('MuiOutlinedInput', slot);
}
const outlinedInputClasses = (0, _extends2$1T.default)({}, _InputBase$5.inputBaseClasses, (0, _generateUtilityClasses$1z.default)('MuiOutlinedInput', ['root', 'notchedOutline', 'input']));
outlinedInputClasses$1.default = outlinedInputClasses;

var filledInputClasses$1 = {};

var _interopRequireDefault$7h = interopRequireDefault$1.exports;
Object.defineProperty(filledInputClasses$1, "__esModule", {
  value: true
});
filledInputClasses$1.default = void 0;
filledInputClasses$1.getFilledInputUtilityClass = getFilledInputUtilityClass;
var _extends2$1S = _interopRequireDefault$7h(_extends$19.exports);
var _generateUtilityClasses$1y = _interopRequireDefault$7h(generateUtilityClasses$3);
var _generateUtilityClass$1x = _interopRequireDefault$7h(generateUtilityClass$3);
var _InputBase$4 = InputBase$3;
function getFilledInputUtilityClass(slot) {
  return (0, _generateUtilityClass$1x.default)('MuiFilledInput', slot);
}
const filledInputClasses = (0, _extends2$1S.default)({}, _InputBase$4.inputBaseClasses, (0, _generateUtilityClasses$1y.default)('MuiFilledInput', ['root', 'underline', 'input']));
filledInputClasses$1.default = filledInputClasses;

var ArrowDropDown = {};

var _interopRequireDefault$7g = interopRequireDefault$1.exports;
Object.defineProperty(ArrowDropDown, "__esModule", {
  value: true
});
ArrowDropDown.default = void 0;
_interopRequireWildcard$3t(React__default$4);
var _createSvgIcon$j = _interopRequireDefault$7g(createSvgIcon$2);
var _jsxRuntime$2a = require$$11;
function _getRequireWildcardCache$3c(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3c = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3t(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3c(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
ArrowDropDown.default = (0, _createSvgIcon$j.default)( /*#__PURE__*/(0, _jsxRuntime$2a.jsx)("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

var autocompleteClasses$1 = {};

var _interopRequireDefault$7f = interopRequireDefault$1.exports;
Object.defineProperty(autocompleteClasses$1, "__esModule", {
  value: true
});
autocompleteClasses$1.default = void 0;
autocompleteClasses$1.getAutocompleteUtilityClass = getAutocompleteUtilityClass;
var _generateUtilityClasses$1x = _interopRequireDefault$7f(generateUtilityClasses$3);
var _generateUtilityClass$1w = _interopRequireDefault$7f(generateUtilityClass$3);
function getAutocompleteUtilityClass(slot) {
  return (0, _generateUtilityClass$1w.default)('MuiAutocomplete', slot);
}
const autocompleteClasses = (0, _generateUtilityClasses$1x.default)('MuiAutocomplete', ['root', 'expanded', 'fullWidth', 'focused', 'focusVisible', 'tag', 'tagSizeSmall', 'tagSizeMedium', 'hasPopupIcon', 'hasClearIcon', 'inputRoot', 'input', 'inputFocused', 'endAdornment', 'clearIndicator', 'popupIndicator', 'popupIndicatorOpen', 'popper', 'popperDisablePortal', 'paper', 'listbox', 'loading', 'noOptions', 'option', 'groupLabel', 'groupUl']);
autocompleteClasses$1.default = autocompleteClasses;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createFilterOptions", {
  enumerable: true,
  get: function () {
    return _useAutocomplete.createFilterOptions;
  }
});
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(objectWithoutPropertiesLoose.exports);
var _extends2 = _interopRequireDefault(_extends$19.exports);
var React = _interopRequireWildcard(React__default$4);
var _propTypes = _interopRequireDefault(propTypes.exports);
var _clsx = _interopRequireDefault(clsx.exports);
var _integerPropType = _interopRequireDefault(integerPropType$1);
var _chainPropTypes = _interopRequireDefault(chainPropTypes$2);
var _composeClasses = _interopRequireDefault(composeClasses$2);
var _colorManipulator = colorManipulator;
var _useAutocomplete = _interopRequireWildcard(useAutocomplete$2);
var _Popper = _interopRequireDefault(Popper$3);
var _ListSubheader = _interopRequireDefault(ListSubheader$2);
var _Paper = _interopRequireDefault(Paper$3);
var _IconButton = _interopRequireDefault(IconButton$4);
var _Chip = _interopRequireDefault(Chip$3);
var _inputClasses = _interopRequireDefault(inputClasses$1);
var _inputBaseClasses = _interopRequireDefault(inputBaseClasses$1);
var _outlinedInputClasses = _interopRequireDefault(outlinedInputClasses$1);
var _filledInputClasses = _interopRequireDefault(filledInputClasses$1);
var _Close = _interopRequireDefault(Close);
var _ArrowDropDown = _interopRequireDefault(ArrowDropDown);
var _zeroStyled = zeroStyled;
var _DefaultPropsProvider = DefaultPropsProvider$5;
var _autocompleteClasses = _interopRequireWildcard(autocompleteClasses$1);
var _capitalize = _interopRequireDefault(capitalize$1);
var _useForkRef = _interopRequireDefault(useForkRef);
var _jsxRuntime = require$$11;
var _ClearIcon, _ArrowDropDownIcon;
const _excluded = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"],
  _excluded2 = ["ref"],
  _excluded3 = ["key"],
  _excluded4 = ["key"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses = ownerState => {
  const {
    classes,
    disablePortal,
    expanded,
    focused,
    fullWidth,
    hasClearIcon,
    hasPopupIcon,
    inputFocused,
    popupOpen,
    size
  } = ownerState;
  const slots = {
    root: ['root', expanded && 'expanded', focused && 'focused', fullWidth && 'fullWidth', hasClearIcon && 'hasClearIcon', hasPopupIcon && 'hasPopupIcon'],
    inputRoot: ['inputRoot'],
    input: ['input', inputFocused && 'inputFocused'],
    tag: ['tag', `tagSize${(0, _capitalize.default)(size)}`],
    endAdornment: ['endAdornment'],
    clearIndicator: ['clearIndicator'],
    popupIndicator: ['popupIndicator', popupOpen && 'popupIndicatorOpen'],
    popper: ['popper', disablePortal && 'popperDisablePortal'],
    paper: ['paper'],
    listbox: ['listbox'],
    loading: ['loading'],
    noOptions: ['noOptions'],
    option: ['option'],
    groupLabel: ['groupLabel'],
    groupUl: ['groupUl']
  };
  return (0, _composeClasses.default)(slots, _autocompleteClasses.getAutocompleteUtilityClass, classes);
};
const AutocompleteRoot = (0, _zeroStyled.styled)('div', {
  name: 'MuiAutocomplete',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      fullWidth,
      hasClearIcon,
      hasPopupIcon,
      inputFocused,
      size
    } = ownerState;
    return [{
      [`& .${_autocompleteClasses.default.tag}`]: styles.tag
    }, {
      [`& .${_autocompleteClasses.default.tag}`]: styles[`tagSize${(0, _capitalize.default)(size)}`]
    }, {
      [`& .${_autocompleteClasses.default.inputRoot}`]: styles.inputRoot
    }, {
      [`& .${_autocompleteClasses.default.input}`]: styles.input
    }, {
      [`& .${_autocompleteClasses.default.input}`]: inputFocused && styles.inputFocused
    }, styles.root, fullWidth && styles.fullWidth, hasPopupIcon && styles.hasPopupIcon, hasClearIcon && styles.hasClearIcon];
  }
})({
  [`&.${_autocompleteClasses.default.focused} .${_autocompleteClasses.default.clearIndicator}`]: {
    visibility: 'visible'
  },
  /* Avoid double tap issue on iOS */
  '@media (pointer: fine)': {
    [`&:hover .${_autocompleteClasses.default.clearIndicator}`]: {
      visibility: 'visible'
    }
  },
  [`& .${_autocompleteClasses.default.tag}`]: {
    margin: 3,
    maxWidth: 'calc(100% - 6px)'
  },
  [`& .${_autocompleteClasses.default.inputRoot}`]: {
    [`.${_autocompleteClasses.default.hasPopupIcon}&, .${_autocompleteClasses.default.hasClearIcon}&`]: {
      paddingRight: 26 + 4
    },
    [`.${_autocompleteClasses.default.hasPopupIcon}.${_autocompleteClasses.default.hasClearIcon}&`]: {
      paddingRight: 52 + 4
    },
    [`& .${_autocompleteClasses.default.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${_inputClasses.default.root}`]: {
    paddingBottom: 1,
    '& .MuiInput-input': {
      padding: '4px 4px 4px 0px'
    }
  },
  [`& .${_inputClasses.default.root}.${_inputBaseClasses.default.sizeSmall}`]: {
    [`& .${_inputClasses.default.input}`]: {
      padding: '2px 4px 3px 0'
    }
  },
  [`& .${_outlinedInputClasses.default.root}`]: {
    padding: 9,
    [`.${_autocompleteClasses.default.hasPopupIcon}&, .${_autocompleteClasses.default.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${_autocompleteClasses.default.hasPopupIcon}.${_autocompleteClasses.default.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${_autocompleteClasses.default.input}`]: {
      padding: '7.5px 4px 7.5px 5px'
    },
    [`& .${_autocompleteClasses.default.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${_outlinedInputClasses.default.root}.${_inputBaseClasses.default.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${_autocompleteClasses.default.input}`]: {
      padding: '2.5px 4px 2.5px 8px'
    }
  },
  [`& .${_filledInputClasses.default.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${_autocompleteClasses.default.hasPopupIcon}&, .${_autocompleteClasses.default.hasClearIcon}&`]: {
      paddingRight: 26 + 4 + 9
    },
    [`.${_autocompleteClasses.default.hasPopupIcon}.${_autocompleteClasses.default.hasClearIcon}&`]: {
      paddingRight: 52 + 4 + 9
    },
    [`& .${_filledInputClasses.default.input}`]: {
      padding: '7px 4px'
    },
    [`& .${_autocompleteClasses.default.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${_filledInputClasses.default.root}.${_inputBaseClasses.default.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${_filledInputClasses.default.input}`]: {
      padding: '2.5px 4px'
    }
  },
  [`& .${_inputBaseClasses.default.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${_filledInputClasses.default.root}.${_inputBaseClasses.default.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${_autocompleteClasses.default.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${_filledInputClasses.default.root}.${_inputBaseClasses.default.hiddenLabel}.${_inputBaseClasses.default.sizeSmall}`]: {
    [`& .${_autocompleteClasses.default.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${_autocompleteClasses.default.input}`]: {
    flexGrow: 1,
    textOverflow: 'ellipsis',
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: true
    },
    style: {
      width: '100%'
    }
  }, {
    props: {
      size: 'small'
    },
    style: {
      [`& .${_autocompleteClasses.default.tag}`]: {
        margin: 2,
        maxWidth: 'calc(100% - 4px)'
      }
    }
  }, {
    props: {
      inputFocused: true
    },
    style: {
      [`& .${_autocompleteClasses.default.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: true
    },
    style: {
      [`& .${_autocompleteClasses.default.inputRoot}`]: {
        flexWrap: 'wrap'
      }
    }
  }]
});
const AutocompleteEndAdornment = (0, _zeroStyled.styled)('div', {
  name: 'MuiAutocomplete',
  slot: 'EndAdornment',
  overridesResolver: (props, styles) => styles.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translate(0, -50%)'
});
const AutocompleteClearIndicator = (0, _zeroStyled.styled)(_IconButton.default, {
  name: 'MuiAutocomplete',
  slot: 'ClearIndicator',
  overridesResolver: (props, styles) => styles.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: 'hidden'
});
const AutocompletePopupIndicator = (0, _zeroStyled.styled)(_IconButton.default, {
  name: 'MuiAutocomplete',
  slot: 'PopupIndicator',
  overridesResolver: ({
    ownerState
  }, styles) => (0, _extends2.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: true
    },
    style: {
      transform: 'rotate(180deg)'
    }
  }]
});
const AutocompletePopper = (0, _zeroStyled.styled)(_Popper.default, {
  name: 'MuiAutocomplete',
  slot: 'Popper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_autocompleteClasses.default.option}`]: styles.option
    }, styles.popper, ownerState.disablePortal && styles.popperDisablePortal];
  }
})(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.modal,
  variants: [{
    props: {
      disablePortal: true
    },
    style: {
      position: 'absolute'
    }
  }]
}));
const AutocompletePaper = (0, _zeroStyled.styled)(_Paper.default, {
  name: 'MuiAutocomplete',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})(({
  theme
}) => (0, _extends2.default)({}, theme.typography.body1, {
  overflow: 'auto'
}));
const AutocompleteLoading = (0, _zeroStyled.styled)('div', {
  name: 'MuiAutocomplete',
  slot: 'Loading',
  overridesResolver: (props, styles) => styles.loading
})(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  padding: '14px 16px'
}));
const AutocompleteNoOptions = (0, _zeroStyled.styled)('div', {
  name: 'MuiAutocomplete',
  slot: 'NoOptions',
  overridesResolver: (props, styles) => styles.noOptions
})(({
  theme
}) => ({
  color: (theme.vars || theme).palette.text.secondary,
  padding: '14px 16px'
}));
const AutocompleteListbox = (0, _zeroStyled.styled)('div', {
  name: 'MuiAutocomplete',
  slot: 'Listbox',
  overridesResolver: (props, styles) => styles.listbox
})(({
  theme
}) => ({
  listStyle: 'none',
  margin: 0,
  padding: '8px 0',
  maxHeight: '40vh',
  overflow: 'auto',
  position: 'relative',
  [`& .${_autocompleteClasses.default.option}`]: {
    minHeight: 48,
    display: 'flex',
    overflow: 'hidden',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    paddingTop: 6,
    boxSizing: 'border-box',
    outline: '0',
    WebkitTapHighlightColor: 'transparent',
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [theme.breakpoints.up('sm')]: {
      minHeight: 'auto'
    },
    [`&.${_autocompleteClasses.default.focused}`]: {
      backgroundColor: (theme.vars || theme).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (theme.vars || theme).palette.action.disabledOpacity,
      pointerEvents: 'none'
    },
    [`&.${_autocompleteClasses.default.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      [`&.${_autocompleteClasses.default.focused}`]: {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: (theme.vars || theme).palette.action.selected
        }
      },
      [`&.${_autocompleteClasses.default.focusVisible}`]: {
        backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
      }
    }
  }
}));
const AutocompleteGroupLabel = (0, _zeroStyled.styled)(_ListSubheader.default, {
  name: 'MuiAutocomplete',
  slot: 'GroupLabel',
  overridesResolver: (props, styles) => styles.groupLabel
})(({
  theme
}) => ({
  backgroundColor: (theme.vars || theme).palette.background.paper,
  top: -8
}));
const AutocompleteGroupUl = (0, _zeroStyled.styled)('ul', {
  name: 'MuiAutocomplete',
  slot: 'GroupUl',
  overridesResolver: (props, styles) => styles.groupUl
})({
  padding: 0,
  [`& .${_autocompleteClasses.default.option}`]: {
    paddingLeft: 24
  }
});
const Autocomplete = /*#__PURE__*/React.forwardRef(function Autocomplete(inProps, ref) {
  var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
  const props = (0, _DefaultPropsProvider.useDefaultProps)({
    props: inProps,
    name: 'MuiAutocomplete'
  });

  /* eslint-disable @typescript-eslint/no-unused-vars */
  const {
      autoComplete = false,
      autoHighlight = false,
      autoSelect = false,
      blurOnSelect = false,
      ChipProps,
      className,
      clearIcon = _ClearIcon || (_ClearIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close.default, {
        fontSize: "small"
      })),
      clearOnBlur = !props.freeSolo,
      clearOnEscape = false,
      clearText = 'Clear',
      closeText = 'Close',
      componentsProps = {},
      defaultValue = props.multiple ? [] : null,
      disableClearable = false,
      disableCloseOnSelect = false,
      disabled = false,
      disabledItemsFocusable = false,
      disableListWrap = false,
      disablePortal = false,
      filterSelectedOptions = false,
      forcePopupIcon = 'auto',
      freeSolo = false,
      fullWidth = false,
      getLimitTagsText = more => `+${more}`,
      getOptionLabel: getOptionLabelProp,
      groupBy,
      handleHomeEndKeys = !props.freeSolo,
      includeInputInList = false,
      limitTags = -1,
      ListboxComponent = 'ul',
      ListboxProps,
      loading = false,
      loadingText = 'Loading…',
      multiple = false,
      noOptionsText = 'No options',
      openOnFocus = false,
      openText = 'Open',
      PaperComponent = _Paper.default,
      PopperComponent = _Popper.default,
      popupIcon = _ArrowDropDownIcon || (_ArrowDropDownIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowDropDown.default, {})),
      readOnly = false,
      renderGroup: renderGroupProp,
      renderInput,
      renderOption: renderOptionProp,
      renderTags,
      selectOnFocus = !props.freeSolo,
      size = 'medium',
      slotProps = {}
    } = props,
    other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  /* eslint-enable @typescript-eslint/no-unused-vars */

  const {
    getRootProps,
    getInputProps,
    getInputLabelProps,
    getPopupIndicatorProps,
    getClearProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    value,
    dirty,
    expanded,
    id,
    popupOpen,
    focused,
    focusedTag,
    anchorEl,
    setAnchorEl,
    inputValue,
    groupedOptions
  } = (0, _useAutocomplete.default)((0, _extends2.default)({}, props, {
    componentName: 'Autocomplete'
  }));
  const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
  const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  const {
    onMouseDown: handleInputMouseDown
  } = getInputProps();
  const {
    ref: externalListboxRef
  } = ListboxProps != null ? ListboxProps : {};
  const _getListboxProps = getListboxProps(),
    {
      ref: listboxRef
    } = _getListboxProps,
    otherListboxProps = (0, _objectWithoutPropertiesLoose2.default)(_getListboxProps, _excluded2);
  const combinedListboxRef = (0, _useForkRef.default)(listboxRef, externalListboxRef);
  const defaultGetOptionLabel = option => {
    var _option$label;
    return (_option$label = option.label) != null ? _option$label : option;
  };
  const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;

  // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
  const ownerState = (0, _extends2.default)({}, props, {
    disablePortal,
    expanded,
    focused,
    fullWidth,
    getOptionLabel,
    hasClearIcon,
    hasPopupIcon,
    inputFocused: focusedTag === -1,
    popupOpen,
    size
  });
  const classes = useUtilityClasses(ownerState);
  let startAdornment;
  if (multiple && value.length > 0) {
    const getCustomizedTagProps = params => (0, _extends2.default)({
      className: classes.tag,
      disabled
    }, getTagProps(params));
    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
    } else {
      startAdornment = value.map((option, index) => {
        const _getCustomizedTagProp = getCustomizedTagProps({
            index
          }),
          {
            key
          } = _getCustomizedTagProp,
          customTagProps = (0, _objectWithoutPropertiesLoose2.default)(_getCustomizedTagProp, _excluded3);
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, (0, _extends2.default)({
          label: getOptionLabel(option),
          size: size
        }, customTagProps, ChipProps), key);
      });
    }
  }
  if (limitTags > -1 && Array.isArray(startAdornment)) {
    const more = startAdornment.length - limitTags;
    if (!focused && more > 0) {
      startAdornment = startAdornment.splice(0, limitTags);
      startAdornment.push( /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: classes.tag,
        children: getLimitTagsText(more)
      }, startAdornment.length));
    }
  }
  const defaultRenderGroup = params => /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(AutocompleteGroupLabel, {
      className: classes.groupLabel,
      ownerState: ownerState,
      component: "div",
      children: params.group
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(AutocompleteGroupUl, {
      className: classes.groupUl,
      ownerState: ownerState,
      children: params.children
    })]
  }, params.key);
  const renderGroup = renderGroupProp || defaultRenderGroup;
  const defaultRenderOption = (props2, option) => {
    // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
    const {
        key
      } = props2,
      otherProps = (0, _objectWithoutPropertiesLoose2.default)(props2, _excluded4);
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", (0, _extends2.default)({}, otherProps, {
      children: getOptionLabel(option)
    }), key);
  };
  const renderOption = renderOptionProp || defaultRenderOption;
  const renderListOption = (option, index) => {
    const optionProps = getOptionProps({
      option,
      index
    });
    return renderOption((0, _extends2.default)({}, optionProps, {
      className: classes.option
    }), option, {
      selected: optionProps['aria-selected'],
      index,
      inputValue
    }, ownerState);
  };
  const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
  const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
  const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
  const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(AutocompleteRoot, (0, _extends2.default)({
      ref: ref,
      className: (0, _clsx.default)(classes.root, className),
      ownerState: ownerState
    }, getRootProps(other), {
      children: renderInput({
        id,
        disabled,
        fullWidth: true,
        size: size === 'small' ? 'small' : undefined,
        InputLabelProps: getInputLabelProps(),
        InputProps: (0, _extends2.default)({
          ref: setAnchorEl,
          className: classes.inputRoot,
          startAdornment,
          onClick: event => {
            if (event.target === event.currentTarget) {
              handleInputMouseDown(event);
            }
          }
        }, (hasClearIcon || hasPopupIcon) && {
          endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsxs)(AutocompleteEndAdornment, {
            className: classes.endAdornment,
            ownerState: ownerState,
            children: [hasClearIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(AutocompleteClearIndicator, (0, _extends2.default)({}, getClearProps(), {
              "aria-label": clearText,
              title: clearText,
              ownerState: ownerState
            }, clearIndicatorSlotProps, {
              className: (0, _clsx.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
              children: clearIcon
            })) : null, hasPopupIcon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(AutocompletePopupIndicator, (0, _extends2.default)({}, getPopupIndicatorProps(), {
              disabled: disabled,
              "aria-label": popupOpen ? closeText : openText,
              title: popupOpen ? closeText : openText,
              ownerState: ownerState
            }, popupIndicatorSlotProps, {
              className: (0, _clsx.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
              children: popupIcon
            })) : null]
          })
        }),
        inputProps: (0, _extends2.default)({
          className: classes.input,
          disabled,
          readOnly
        }, getInputProps())
      })
    })), anchorEl ? /*#__PURE__*/(0, _jsxRuntime.jsx)(AutocompletePopper, (0, _extends2.default)({
      as: PopperComponent,
      disablePortal: disablePortal,
      style: {
        width: anchorEl ? anchorEl.clientWidth : null
      },
      ownerState: ownerState,
      role: "presentation",
      anchorEl: anchorEl,
      open: popupOpen
    }, popperSlotProps, {
      className: (0, _clsx.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(AutocompletePaper, (0, _extends2.default)({
        ownerState: ownerState,
        as: PaperComponent
      }, paperSlotProps, {
        className: (0, _clsx.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
        children: [loading && groupedOptions.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(AutocompleteLoading, {
          className: classes.loading,
          ownerState: ownerState,
          children: loadingText
        }) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(AutocompleteNoOptions, {
          className: classes.noOptions,
          ownerState: ownerState,
          role: "presentation",
          onMouseDown: event => {
            // Prevent input blur when interacting with the "no options" content
            event.preventDefault();
          },
          children: noOptionsText
        }) : null, groupedOptions.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(AutocompleteListbox, (0, _extends2.default)({
          as: ListboxComponent,
          className: classes.listbox,
          ownerState: ownerState
        }, otherListboxProps, ListboxProps, {
          ref: combinedListboxRef,
          children: groupedOptions.map((option, index) => {
            if (groupBy) {
              return renderGroup({
                key: option.key,
                group: option.group,
                children: option.options.map((option2, index2) => renderListOption(option2, option.index + index2))
              });
            }
            return renderListOption(option, index);
          })
        })) : null]
      }))
    })) : null]
  });
});
process.env.NODE_ENV !== "production" ? Autocomplete.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: _propTypes.default.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: _propTypes.default.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: _propTypes.default.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: _propTypes.default.oneOfType([_propTypes.default.oneOf(['mouse', 'touch']), _propTypes.default.bool]),
  /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */
  ChipProps: _propTypes.default.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: _propTypes.default.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: _propTypes.default.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: _propTypes.default.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: _propTypes.default.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: _propTypes.default.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: _propTypes.default.shape({
    clearIndicator: _propTypes.default.object,
    paper: _propTypes.default.object,
    popper: _propTypes.default.object,
    popupIndicator: _propTypes.default.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: (0, _chainPropTypes.default)(_propTypes.default.any, props => {
    if (props.multiple && props.defaultValue !== undefined && !Array.isArray(props.defaultValue)) {
      return new Error(['MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.', `However, ${props.defaultValue} was provided.`].join('\n'));
    }
    return null;
  }),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: _propTypes.default.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: _propTypes.default.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes.default.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: _propTypes.default.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: _propTypes.default.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: _propTypes.default.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: _propTypes.default.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: _propTypes.default.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: _propTypes.default.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes.default.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: _propTypes.default.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: _propTypes.default.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: _propTypes.default.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: _propTypes.default.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: _propTypes.default.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: _propTypes.default.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: _propTypes.default.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: _propTypes.default.bool,
  /**
   * The input value.
   */
  inputValue: _propTypes.default.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: _propTypes.default.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: _integerPropType.default,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   */
  ListboxComponent: _propTypes.default.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: _propTypes.default.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: _propTypes.default.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: _propTypes.default.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: _propTypes.default.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: _propTypes.default.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: _propTypes.default.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: _propTypes.default.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: _propTypes.default.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: _propTypes.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: _propTypes.default.func,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes.default.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: _propTypes.default.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: _propTypes.default.string,
  /**
   * Array of options.
   */
  options: _propTypes.default.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   */
  PaperComponent: _propTypes.default.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   */
  PopperComponent: _propTypes.default.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: _propTypes.default.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: _propTypes.default.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: _propTypes.default.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: _propTypes.default.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: _propTypes.default.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: _propTypes.default.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: _propTypes.default.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: _propTypes.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes.default.oneOf(['small', 'medium']), _propTypes.default.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: _propTypes.default.shape({
    clearIndicator: _propTypes.default.object,
    paper: _propTypes.default.object,
    popper: _propTypes.default.object,
    popupIndicator: _propTypes.default.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: (0, _chainPropTypes.default)(_propTypes.default.any, props => {
    if (props.multiple && props.value !== undefined && !Array.isArray(props.value)) {
      return new Error(['MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.', `However, ${props.value} was provided.`].join('\n'));
    }
    return null;
  })
} : void 0;
exports.default = Autocomplete;
}(Autocomplete));

(function (exports) {
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createFilterOptions: true,
  autocompleteClasses: true
};
Object.defineProperty(exports, "autocompleteClasses", {
  enumerable: true,
  get: function () {
    return _autocompleteClasses.default;
  }
});
Object.defineProperty(exports, "createFilterOptions", {
  enumerable: true,
  get: function () {
    return _Autocomplete.createFilterOptions;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Autocomplete.default;
  }
});
var _Autocomplete = _interopRequireWildcard(Autocomplete);
var _autocompleteClasses = _interopRequireWildcard(autocompleteClasses$1);
Object.keys(_autocompleteClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _autocompleteClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _autocompleteClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Autocomplete$1));

var Avatar$7 = {};

var Avatar$6 = {};

var Person = {};

var _interopRequireDefault$7e = interopRequireDefault$1.exports;
Object.defineProperty(Person, "__esModule", {
  value: true
});
Person.default = void 0;
_interopRequireWildcard$3s(React__default$4);
var _createSvgIcon$i = _interopRequireDefault$7e(createSvgIcon$2);
var _jsxRuntime$29 = require$$11;
function _getRequireWildcardCache$3b(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3b = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3s(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3b(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
Person.default = (0, _createSvgIcon$i.default)( /*#__PURE__*/(0, _jsxRuntime$29.jsx)("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');

var avatarClasses$1 = {};

var _interopRequireDefault$7d = interopRequireDefault$1.exports;
Object.defineProperty(avatarClasses$1, "__esModule", {
  value: true
});
avatarClasses$1.default = void 0;
avatarClasses$1.getAvatarUtilityClass = getAvatarUtilityClass;
var _generateUtilityClasses$1w = _interopRequireDefault$7d(generateUtilityClasses$3);
var _generateUtilityClass$1v = _interopRequireDefault$7d(generateUtilityClass$3);
function getAvatarUtilityClass(slot) {
  return (0, _generateUtilityClass$1v.default)('MuiAvatar', slot);
}
const avatarClasses = (0, _generateUtilityClasses$1w.default)('MuiAvatar', ['root', 'colorDefault', 'circular', 'rounded', 'square', 'img', 'fallback']);
avatarClasses$1.default = avatarClasses;

var _interopRequireDefault$7c = interopRequireDefault$1.exports;
Object.defineProperty(Avatar$6, "__esModule", {
  value: true
});
Avatar$6.default = void 0;
var _objectWithoutPropertiesLoose2$1M = _interopRequireDefault$7c(objectWithoutPropertiesLoose.exports);
var _extends2$1R = _interopRequireDefault$7c(_extends$19.exports);
var React$2e = _interopRequireWildcard$3r(React__default$4);
var _propTypes$2j = _interopRequireDefault$7c(propTypes.exports);
var _clsx$24 = _interopRequireDefault$7c(clsx.exports);
var _composeClasses$1w = _interopRequireDefault$7c(composeClasses$2);
var _zeroStyled$3 = zeroStyled;
var _DefaultPropsProvider$1x = DefaultPropsProvider$5;
var _Person = _interopRequireDefault$7c(Person);
var _avatarClasses = avatarClasses$1;
var _useSlot = _interopRequireDefault$7c(useSlot$1);
var _jsxRuntime$28 = require$$11;
const _excluded$2e = ["alt", "children", "className", "component", "slots", "slotProps", "imgProps", "sizes", "src", "srcSet", "variant"];
function _getRequireWildcardCache$3a(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3a = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3r(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$3a(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1x = ownerState => {
  const {
    classes,
    variant,
    colorDefault
  } = ownerState;
  const slots = {
    root: ['root', variant, colorDefault && 'colorDefault'],
    img: ['img'],
    fallback: ['fallback']
  };
  return (0, _composeClasses$1w.default)(slots, _avatarClasses.getAvatarUtilityClass, classes);
};
const AvatarRoot = (0, _zeroStyled$3.styled)('div', {
  name: 'MuiAvatar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.colorDefault && styles.colorDefault];
  }
})(({
  theme
}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: '50%',
  overflow: 'hidden',
  userSelect: 'none',
  variants: [{
    props: {
      variant: 'rounded'
    },
    style: {
      borderRadius: (theme.vars || theme).shape.borderRadius
    }
  }, {
    props: {
      variant: 'square'
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: true
    },
    style: (0, _extends2$1R.default)({
      color: (theme.vars || theme).palette.background.default
    }, theme.vars ? {
      backgroundColor: theme.vars.palette.Avatar.defaultBg
    } : (0, _extends2$1R.default)({
      backgroundColor: theme.palette.grey[400]
    }, theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[600]
    })))
  }]
}));
const AvatarImg = (0, _zeroStyled$3.styled)('img', {
  name: 'MuiAvatar',
  slot: 'Img',
  overridesResolver: (props, styles) => styles.img
})({
  width: '100%',
  height: '100%',
  textAlign: 'center',
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: 'cover',
  // Hide alt text.
  color: 'transparent',
  // Hide the image broken icon, only works on Chrome.
  textIndent: 10000
});
const AvatarFallback = (0, _zeroStyled$3.styled)(_Person.default, {
  name: 'MuiAvatar',
  slot: 'Fallback',
  overridesResolver: (props, styles) => styles.fallback
})({
  width: '75%',
  height: '75%'
});
function useLoaded({
  crossOrigin,
  referrerPolicy,
  src,
  srcSet
}) {
  const [loaded, setLoaded] = React$2e.useState(false);
  React$2e.useEffect(() => {
    if (!src && !srcSet) {
      return undefined;
    }
    setLoaded(false);
    let active = true;
    const image = new Image();
    image.onload = () => {
      if (!active) {
        return;
      }
      setLoaded('loaded');
    };
    image.onerror = () => {
      if (!active) {
        return;
      }
      setLoaded('error');
    };
    image.crossOrigin = crossOrigin;
    image.referrerPolicy = referrerPolicy;
    image.src = src;
    if (srcSet) {
      image.srcset = srcSet;
    }
    return () => {
      active = false;
    };
  }, [crossOrigin, referrerPolicy, src, srcSet]);
  return loaded;
}
const Avatar$5 = /*#__PURE__*/React$2e.forwardRef(function Avatar(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1x.useDefaultProps)({
    props: inProps,
    name: 'MuiAvatar'
  });
  const {
      alt,
      children: childrenProp,
      className,
      component = 'div',
      slots = {},
      slotProps = {},
      imgProps,
      sizes,
      src,
      srcSet,
      variant = 'circular'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1M.default)(props, _excluded$2e);
  let children = null;

  // Use a hook instead of onError on the img element to support server-side rendering.
  const loaded = useLoaded((0, _extends2$1R.default)({}, imgProps, {
    src,
    srcSet
  }));
  const hasImg = src || srcSet;
  const hasImgNotFailing = hasImg && loaded !== 'error';
  const ownerState = (0, _extends2$1R.default)({}, props, {
    colorDefault: !hasImgNotFailing,
    component,
    variant
  });
  const classes = useUtilityClasses$1x(ownerState);
  const [ImgSlot, imgSlotProps] = (0, _useSlot.default)('img', {
    className: classes.img,
    elementType: AvatarImg,
    externalForwardedProps: {
      slots,
      slotProps: {
        img: (0, _extends2$1R.default)({}, imgProps, slotProps.img)
      }
    },
    additionalProps: {
      alt,
      src,
      srcSet,
      sizes
    },
    ownerState
  });
  if (hasImgNotFailing) {
    children = /*#__PURE__*/(0, _jsxRuntime$28.jsx)(ImgSlot, (0, _extends2$1R.default)({}, imgSlotProps));
    // We only render valid children, non valid children are rendered with a fallback
    // We consider that invalid children are all falsy values, except 0, which is valid.
  } else if (!!childrenProp || childrenProp === 0) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/(0, _jsxRuntime$28.jsx)(AvatarFallback, {
      ownerState: ownerState,
      className: classes.fallback
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime$28.jsx)(AvatarRoot, (0, _extends2$1R.default)({
    as: component,
    ownerState: ownerState,
    className: (0, _clsx$24.default)(classes.root, className),
    ref: ref
  }, other, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? Avatar$5.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: _propTypes$2j.default.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: _propTypes$2j.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2j.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2j.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2j.default.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  imgProps: _propTypes$2j.default.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: _propTypes$2j.default.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: _propTypes$2j.default.shape({
    img: _propTypes$2j.default.oneOfType([_propTypes$2j.default.func, _propTypes$2j.default.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: _propTypes$2j.default.shape({
    img: _propTypes$2j.default.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: _propTypes$2j.default.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: _propTypes$2j.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2j.default.oneOfType([_propTypes$2j.default.arrayOf(_propTypes$2j.default.oneOfType([_propTypes$2j.default.func, _propTypes$2j.default.object, _propTypes$2j.default.bool])), _propTypes$2j.default.func, _propTypes$2j.default.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: _propTypes$2j.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2j.default.oneOf(['circular', 'rounded', 'square']), _propTypes$2j.default.string])
} : void 0;
Avatar$6.default = Avatar$5;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  avatarClasses: true
};
Object.defineProperty(exports, "avatarClasses", {
  enumerable: true,
  get: function () {
    return _avatarClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Avatar.default;
  }
});
var _Avatar = _interopRequireDefault(Avatar$6);
var _avatarClasses = _interopRequireWildcard(avatarClasses$1);
Object.keys(_avatarClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _avatarClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _avatarClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Avatar$7));

var AvatarMui = /*@__PURE__*/getDefaultExportFromCjs$1(Avatar$7);

var AvatarGroup$2 = {};

var AvatarGroup$1 = {};

var avatarGroupClasses$1 = {};

var _interopRequireDefault$7b = interopRequireDefault$1.exports;
Object.defineProperty(avatarGroupClasses$1, "__esModule", {
  value: true
});
avatarGroupClasses$1.default = void 0;
avatarGroupClasses$1.getAvatarGroupUtilityClass = getAvatarGroupUtilityClass;
var _generateUtilityClasses$1v = _interopRequireDefault$7b(generateUtilityClasses$3);
var _generateUtilityClass$1u = _interopRequireDefault$7b(generateUtilityClass$3);
function getAvatarGroupUtilityClass(slot) {
  return (0, _generateUtilityClass$1u.default)('MuiAvatarGroup', slot);
}
const avatarGroupClasses = (0, _generateUtilityClasses$1v.default)('MuiAvatarGroup', ['root', 'avatar']);
avatarGroupClasses$1.default = avatarGroupClasses;

var _interopRequireDefault$7a = interopRequireDefault$1.exports;
Object.defineProperty(AvatarGroup$1, "__esModule", {
  value: true
});
AvatarGroup$1.default = void 0;
var _objectWithoutPropertiesLoose2$1L = _interopRequireDefault$7a(objectWithoutPropertiesLoose.exports);
var _extends2$1Q = _interopRequireDefault$7a(_extends$19.exports);
var React$2d = _interopRequireWildcard$3q(React__default$4);
var _propTypes$2i = _interopRequireDefault$7a(propTypes.exports);
var _reactIs$a = reactIs$6.exports;
var _clsx$23 = _interopRequireDefault$7a(clsx.exports);
var _chainPropTypes$9 = _interopRequireDefault$7a(chainPropTypes$2);
var _composeClasses$1v = _interopRequireDefault$7a(composeClasses$2);
var _styled$1v = _interopRequireDefault$7a(styled$2);
var _DefaultPropsProvider$1w = DefaultPropsProvider$5;
var _Avatar$1 = _interopRequireWildcard$3q(Avatar$7);
var _avatarGroupClasses = _interopRequireWildcard$3q(avatarGroupClasses$1);
var _jsxRuntime$27 = require$$11;
const _excluded$2d = ["children", "className", "component", "componentsProps", "max", "renderSurplus", "slotProps", "spacing", "total", "variant"];
function _getRequireWildcardCache$39(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$39 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3q(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$39(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SPACINGS$2 = {
  small: -16,
  medium: null
};
const useUtilityClasses$1w = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    avatar: ['avatar']
  };
  return (0, _composeClasses$1v.default)(slots, _avatarGroupClasses.getAvatarGroupUtilityClass, classes);
};
const AvatarGroupRoot = (0, _styled$1v.default)('div', {
  name: 'MuiAvatarGroup',
  slot: 'Root',
  overridesResolver: (props, styles) => (0, _extends2$1Q.default)({
    [`& .${_avatarGroupClasses.default.avatar}`]: styles.avatar
  }, styles.root)
})(({
  theme,
  ownerState
}) => {
  const marginValue = ownerState.spacing && SPACINGS$2[ownerState.spacing] !== undefined ? SPACINGS$2[ownerState.spacing] : -ownerState.spacing;
  return {
    [`& .${_Avatar$1.avatarClasses.root}`]: {
      border: `2px solid ${(theme.vars || theme).palette.background.default}`,
      boxSizing: 'content-box',
      marginLeft: marginValue != null ? marginValue : -8,
      '&:last-child': {
        marginLeft: 0
      }
    },
    display: 'flex',
    flexDirection: 'row-reverse'
  };
});
const AvatarGroup = /*#__PURE__*/React$2d.forwardRef(function AvatarGroup(inProps, ref) {
  var _slotProps$additional;
  const props = (0, _DefaultPropsProvider$1w.useDefaultProps)({
    props: inProps,
    name: 'MuiAvatarGroup'
  });
  const {
      children: childrenProp,
      className,
      component = 'div',
      componentsProps = {},
      max = 5,
      renderSurplus,
      slotProps = {},
      spacing = 'medium',
      total,
      variant = 'circular'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1L.default)(props, _excluded$2d);
  let clampedMax = max < 2 ? 2 : max;
  const ownerState = (0, _extends2$1Q.default)({}, props, {
    max,
    spacing,
    component,
    variant
  });
  const classes = useUtilityClasses$1w(ownerState);
  const children = React$2d.Children.toArray(childrenProp).filter(child => {
    if (process.env.NODE_ENV !== 'production') {
      if ((0, _reactIs$a.isFragment)(child)) {
        console.error(["MUI: The AvatarGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    return /*#__PURE__*/React$2d.isValidElement(child);
  });
  const totalAvatars = total || children.length;
  if (totalAvatars === clampedMax) {
    clampedMax += 1;
  }
  clampedMax = Math.min(totalAvatars + 1, clampedMax);
  const maxAvatars = Math.min(children.length, clampedMax - 1);
  const extraAvatars = Math.max(totalAvatars - clampedMax, totalAvatars - maxAvatars, 0);
  const extraAvatarsElement = renderSurplus ? renderSurplus(extraAvatars) : `+${extraAvatars}`;
  const additionalAvatarSlotProps = (_slotProps$additional = slotProps.additionalAvatar) != null ? _slotProps$additional : componentsProps.additionalAvatar;
  return /*#__PURE__*/(0, _jsxRuntime$27.jsxs)(AvatarGroupRoot, (0, _extends2$1Q.default)({
    as: component,
    ownerState: ownerState,
    className: (0, _clsx$23.default)(classes.root, className),
    ref: ref
  }, other, {
    children: [extraAvatars ? /*#__PURE__*/(0, _jsxRuntime$27.jsx)(_Avatar$1.default, (0, _extends2$1Q.default)({
      variant: variant
    }, additionalAvatarSlotProps, {
      className: (0, _clsx$23.default)(classes.avatar, additionalAvatarSlotProps == null ? void 0 : additionalAvatarSlotProps.className),
      children: extraAvatarsElement
    })) : null, children.slice(0, maxAvatars).reverse().map(child => {
      return /*#__PURE__*/React$2d.cloneElement(child, {
        className: (0, _clsx$23.default)(child.props.className, classes.avatar),
        variant: child.props.variant || variant
      });
    })]
  }));
});
process.env.NODE_ENV !== "production" ? AvatarGroup.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The avatars to stack.
   */
  children: _propTypes$2i.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2i.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2i.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2i.default.elementType,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: _propTypes$2i.default.shape({
    additionalAvatar: _propTypes$2i.default.object
  }),
  /**
   * Max avatars to show before +x.
   * @default 5
   */
  max: (0, _chainPropTypes$9.default)(_propTypes$2i.default.number, props => {
    if (props.max < 2) {
      return new Error(['MUI: The prop `max` should be equal to 2 or above.', 'A value below is clamped to 2.'].join('\n'));
    }
    return null;
  }),
  /**
   * custom renderer of extraAvatars
   * @param {number} surplus number of extra avatars
   * @returns {React.ReactNode} custom element to display
   */
  renderSurplus: _propTypes$2i.default.func,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: _propTypes$2i.default.shape({
    additionalAvatar: _propTypes$2i.default.object
  }),
  /**
   * Spacing between avatars.
   * @default 'medium'
   */
  spacing: _propTypes$2i.default.oneOfType([_propTypes$2i.default.oneOf(['medium', 'small']), _propTypes$2i.default.number]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2i.default.oneOfType([_propTypes$2i.default.arrayOf(_propTypes$2i.default.oneOfType([_propTypes$2i.default.func, _propTypes$2i.default.object, _propTypes$2i.default.bool])), _propTypes$2i.default.func, _propTypes$2i.default.object]),
  /**
   * The total number of avatars. Used for calculating the number of extra avatars.
   * @default children.length
   */
  total: _propTypes$2i.default.number,
  /**
   * The variant to use.
   * @default 'circular'
   */
  variant: _propTypes$2i.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2i.default.oneOf(['circular', 'rounded', 'square']), _propTypes$2i.default.string])
} : void 0;
AvatarGroup$1.default = AvatarGroup;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  avatarGroupClasses: true
};
Object.defineProperty(exports, "avatarGroupClasses", {
  enumerable: true,
  get: function () {
    return _avatarGroupClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _AvatarGroup.default;
  }
});
var _AvatarGroup = _interopRequireDefault(AvatarGroup$1);
var _avatarGroupClasses = _interopRequireWildcard(avatarGroupClasses$1);
Object.keys(_avatarGroupClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _avatarGroupClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _avatarGroupClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(AvatarGroup$2));

var Backdrop$2 = {};

var Backdrop$1 = {};

var Fade$2 = {};

var Fade$1 = {};

var _interopRequireDefault$79 = interopRequireDefault$1.exports;
Object.defineProperty(Fade$1, "__esModule", {
  value: true
});
Fade$1.default = void 0;
var _extends2$1P = _interopRequireDefault$79(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1K = _interopRequireDefault$79(objectWithoutPropertiesLoose.exports);
var React$2c = _interopRequireWildcard$3p(React__default$4);
var _propTypes$2h = _interopRequireDefault$79(propTypes.exports);
var _reactTransitionGroup$5 = cjs$4;
var _elementAcceptingRef$5 = _interopRequireDefault$79(elementAcceptingRef$2);
var _getReactElementRef$6 = _interopRequireDefault$79(getReactElementRef$2);
var _useTheme$c = _interopRequireDefault$79(useTheme$4);
var _utils$O = utils$8;
var _useForkRef$f = _interopRequireDefault$79(useForkRef);
var _jsxRuntime$26 = require$$11;
const _excluded$2c = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function _getRequireWildcardCache$38(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$38 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3p(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$38(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const styles$s = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};

/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Fade = /*#__PURE__*/React$2c.forwardRef(function Fade(props, ref) {
  const theme = (0, _useTheme$c.default)();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = _reactTransitionGroup$5.Transition
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1K.default)(props, _excluded$2c);
  const nodeRef = React$2c.useRef(null);
  const handleRef = (0, _useForkRef$f.default)(nodeRef, (0, _getReactElementRef$6.default)(children), ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    (0, _utils$O.reflow)(node); // So the animation always start from the start.

    const transitionProps = (0, _utils$O.getTransitionProps)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0, _utils$O.getTransitionProps)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime$26.jsx)(TransitionComponent, (0, _extends2$1P.default)({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef ,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$2c.cloneElement(children, (0, _extends2$1P.default)({
        style: (0, _extends2$1P.default)({
          opacity: 0,
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles$s[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Fade.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: _propTypes$2h.default.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: _propTypes$2h.default.bool,
  /**
   * A single child content element.
   */
  children: _elementAcceptingRef$5.default.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: _propTypes$2h.default.oneOfType([_propTypes$2h.default.shape({
    enter: _propTypes$2h.default.string,
    exit: _propTypes$2h.default.string
  }), _propTypes$2h.default.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes$2h.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes$2h.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes$2h.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes$2h.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes$2h.default.func,
  /**
   * @ignore
   */
  onExited: _propTypes$2h.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes$2h.default.func,
  /**
   * @ignore
   */
  style: _propTypes$2h.default.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: _propTypes$2h.default.oneOfType([_propTypes$2h.default.number, _propTypes$2h.default.shape({
    appear: _propTypes$2h.default.number,
    enter: _propTypes$2h.default.number,
    exit: _propTypes$2h.default.number
  })])
} : void 0;
Fade$1.default = Fade;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Fade.default;
  }
});
var _Fade = _interopRequireDefault(Fade$1);
}(Fade$2));

var backdropClasses$1 = {};

var _interopRequireDefault$78 = interopRequireDefault$1.exports;
Object.defineProperty(backdropClasses$1, "__esModule", {
  value: true
});
backdropClasses$1.default = void 0;
backdropClasses$1.getBackdropUtilityClass = getBackdropUtilityClass;
var _generateUtilityClasses$1u = _interopRequireDefault$78(generateUtilityClasses$3);
var _generateUtilityClass$1t = _interopRequireDefault$78(generateUtilityClass$3);
function getBackdropUtilityClass(slot) {
  return (0, _generateUtilityClass$1t.default)('MuiBackdrop', slot);
}
const backdropClasses = (0, _generateUtilityClasses$1u.default)('MuiBackdrop', ['root', 'invisible']);
backdropClasses$1.default = backdropClasses;

var _interopRequireDefault$77 = interopRequireDefault$1.exports;
Object.defineProperty(Backdrop$1, "__esModule", {
  value: true
});
Backdrop$1.default = void 0;
var _objectWithoutPropertiesLoose2$1J = _interopRequireDefault$77(objectWithoutPropertiesLoose.exports);
var _extends2$1O = _interopRequireDefault$77(_extends$19.exports);
var React$2b = _interopRequireWildcard$3o(React__default$4);
var _propTypes$2g = _interopRequireDefault$77(propTypes.exports);
var _clsx$22 = _interopRequireDefault$77(clsx.exports);
var _composeClasses$1u = _interopRequireDefault$77(composeClasses$2);
var _styled$1u = _interopRequireDefault$77(styled$2);
var _DefaultPropsProvider$1v = DefaultPropsProvider$5;
var _Fade$1 = _interopRequireDefault$77(Fade$2);
var _backdropClasses = backdropClasses$1;
var _jsxRuntime$25 = require$$11;
const _excluded$2b = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"];
function _getRequireWildcardCache$37(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$37 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3o(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$37(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1v = ownerState => {
  const {
    classes,
    invisible
  } = ownerState;
  const slots = {
    root: ['root', invisible && 'invisible']
  };
  return (0, _composeClasses$1u.default)(slots, _backdropClasses.getBackdropUtilityClass, classes);
};
const BackdropRoot = (0, _styled$1u.default)('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})(({
  ownerState
}) => (0, _extends2$1O.default)({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitTapHighlightColor: 'transparent'
}, ownerState.invisible && {
  backgroundColor: 'transparent'
}));
const Backdrop = /*#__PURE__*/React$2b.forwardRef(function Backdrop(inProps, ref) {
  var _slotProps$root, _ref, _slots$root;
  const props = (0, _DefaultPropsProvider$1v.useDefaultProps)({
    props: inProps,
    name: 'MuiBackdrop'
  });
  const {
      children,
      className,
      component = 'div',
      components = {},
      componentsProps = {},
      invisible = false,
      open,
      slotProps = {},
      slots = {},
      TransitionComponent = _Fade$1.default,
      transitionDuration
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1J.default)(props, _excluded$2b);
  const ownerState = (0, _extends2$1O.default)({}, props, {
    component,
    invisible
  });
  const classes = useUtilityClasses$1v(ownerState);
  const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
  return /*#__PURE__*/(0, _jsxRuntime$25.jsx)(TransitionComponent, (0, _extends2$1O.default)({
    in: open,
    timeout: transitionDuration
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$25.jsx)(BackdropRoot, (0, _extends2$1O.default)({
      "aria-hidden": true
    }, rootSlotProps, {
      as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
      className: (0, _clsx$22.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
      ownerState: (0, _extends2$1O.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
      classes: classes,
      ref: ref,
      children: children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Backdrop.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2g.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2g.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2g.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2g.default.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$2g.default.shape({
    Root: _propTypes$2g.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: _propTypes$2g.default.shape({
    root: _propTypes$2g.default.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: _propTypes$2g.default.bool,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$2g.default.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: _propTypes$2g.default.shape({
    root: _propTypes$2g.default.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: _propTypes$2g.default.shape({
    root: _propTypes$2g.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2g.default.oneOfType([_propTypes$2g.default.arrayOf(_propTypes$2g.default.oneOfType([_propTypes$2g.default.func, _propTypes$2g.default.object, _propTypes$2g.default.bool])), _propTypes$2g.default.func, _propTypes$2g.default.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: _propTypes$2g.default.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: _propTypes$2g.default.oneOfType([_propTypes$2g.default.number, _propTypes$2g.default.shape({
    appear: _propTypes$2g.default.number,
    enter: _propTypes$2g.default.number,
    exit: _propTypes$2g.default.number
  })])
} : void 0;
Backdrop$1.default = Backdrop;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  backdropClasses: true
};
Object.defineProperty(exports, "backdropClasses", {
  enumerable: true,
  get: function () {
    return _backdropClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Backdrop.default;
  }
});
var _Backdrop = _interopRequireDefault(Backdrop$1);
var _backdropClasses = _interopRequireWildcard(backdropClasses$1);
Object.keys(_backdropClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _backdropClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _backdropClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Backdrop$2));

var Badge$2 = {};

var Badge$1 = {};

var useBadge$1 = {};

Object.defineProperty(useBadge$1, "__esModule", {
  value: true
});
useBadge$1.default = void 0;
var _utils$N = utils$7;
/**
 *
 * Demos:
 *
 * - [Badge](https://next.mui.com/base-ui/react-badge/#hook)
 *
 * API:
 *
 * - [useBadge API](https://next.mui.com/base-ui/react-badge/hooks-api/#use-badge)
 */
function useBadge(parameters) {
  const {
    badgeContent: badgeContentProp,
    invisible: invisibleProp = false,
    max: maxProp = 99,
    showZero = false
  } = parameters;
  const prevProps = (0, _utils$N.usePreviousProps)({
    badgeContent: badgeContentProp,
    max: maxProp
  });
  let invisible = invisibleProp;
  if (invisibleProp === false && badgeContentProp === 0 && !showZero) {
    invisible = true;
  }
  const {
    badgeContent,
    max = maxProp
  } = invisible ? prevProps : parameters;
  const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
  return {
    badgeContent,
    invisible,
    max,
    displayValue
  };
}
useBadge$1.default = useBadge;

var badgeClasses$1 = {};

var _interopRequireDefault$76 = interopRequireDefault$1.exports;
Object.defineProperty(badgeClasses$1, "__esModule", {
  value: true
});
badgeClasses$1.default = void 0;
badgeClasses$1.getBadgeUtilityClass = getBadgeUtilityClass;
var _generateUtilityClasses$1t = _interopRequireDefault$76(generateUtilityClasses$3);
var _generateUtilityClass$1s = _interopRequireDefault$76(generateUtilityClass$3);
function getBadgeUtilityClass(slot) {
  return (0, _generateUtilityClass$1s.default)('MuiBadge', slot);
}
const badgeClasses = (0, _generateUtilityClasses$1t.default)('MuiBadge', ['root', 'badge', 'dot', 'standard', 'anchorOriginTopRight', 'anchorOriginBottomRight', 'anchorOriginTopLeft', 'anchorOriginBottomLeft', 'invisible', 'colorError', 'colorInfo', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorWarning', 'overlapRectangular', 'overlapCircular',
// TODO: v6 remove the overlap value from these class keys
'anchorOriginTopLeftCircular', 'anchorOriginTopLeftRectangular', 'anchorOriginTopRightCircular', 'anchorOriginTopRightRectangular', 'anchorOriginBottomLeftCircular', 'anchorOriginBottomLeftRectangular', 'anchorOriginBottomRightCircular', 'anchorOriginBottomRightRectangular']);
badgeClasses$1.default = badgeClasses;

var _interopRequireDefault$75 = interopRequireDefault$1.exports;
Object.defineProperty(Badge$1, "__esModule", {
  value: true
});
Badge$1.default = void 0;
var _extends2$1N = _interopRequireDefault$75(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1I = _interopRequireDefault$75(objectWithoutPropertiesLoose.exports);
var React$2a = _interopRequireWildcard$3n(React__default$4);
var _propTypes$2f = _interopRequireDefault$75(propTypes.exports);
var _clsx$21 = _interopRequireDefault$75(clsx.exports);
var _usePreviousProps = _interopRequireDefault$75(usePreviousProps$2);
var _composeClasses$1t = _interopRequireDefault$75(composeClasses$2);
var _useSlotProps$7 = _interopRequireDefault$75(useSlotProps$2);
var _useBadge = _interopRequireDefault$75(useBadge$1);
var _zeroStyled$2 = zeroStyled;
var _DefaultPropsProvider$1u = DefaultPropsProvider$5;
var _capitalize$C = _interopRequireDefault$75(capitalize$1);
var _badgeClasses = _interopRequireWildcard$3n(badgeClasses$1);
var _jsxRuntime$24 = require$$11;
const _excluded$2a = ["anchorOrigin", "className", "classes", "component", "components", "componentsProps", "children", "overlap", "color", "invisible", "max", "badgeContent", "slots", "slotProps", "showZero", "variant"];
function _getRequireWildcardCache$36(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$36 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3n(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$36(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RADIUS_STANDARD = 10;
const RADIUS_DOT = 4;
const useUtilityClasses$1u = ownerState => {
  const {
    color,
    anchorOrigin,
    invisible,
    overlap,
    variant,
    classes = {}
  } = ownerState;
  const slots = {
    root: ['root'],
    badge: ['badge', variant, invisible && 'invisible', `anchorOrigin${(0, _capitalize$C.default)(anchorOrigin.vertical)}${(0, _capitalize$C.default)(anchorOrigin.horizontal)}`, `anchorOrigin${(0, _capitalize$C.default)(anchorOrigin.vertical)}${(0, _capitalize$C.default)(anchorOrigin.horizontal)}${(0, _capitalize$C.default)(overlap)}`, `overlap${(0, _capitalize$C.default)(overlap)}`, color !== 'default' && `color${(0, _capitalize$C.default)(color)}`]
  };
  return (0, _composeClasses$1t.default)(slots, _badgeClasses.getBadgeUtilityClass, classes);
};
const BadgeRoot = (0, _zeroStyled$2.styled)('span', {
  name: 'MuiBadge',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  position: 'relative',
  display: 'inline-flex',
  // For correct alignment with the text.
  verticalAlign: 'middle',
  flexShrink: 0
});
const BadgeBadge = (0, _zeroStyled$2.styled)('span', {
  name: 'MuiBadge',
  slot: 'Badge',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.badge, styles[ownerState.variant], styles[`anchorOrigin${(0, _capitalize$C.default)(ownerState.anchorOrigin.vertical)}${(0, _capitalize$C.default)(ownerState.anchorOrigin.horizontal)}${(0, _capitalize$C.default)(ownerState.overlap)}`], ownerState.color !== 'default' && styles[`color${(0, _capitalize$C.default)(ownerState.color)}`], ownerState.invisible && styles.invisible];
  }
})(({
  theme
}) => {
  var _theme$vars;
  return {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    boxSizing: 'border-box',
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(12),
    minWidth: RADIUS_STANDARD * 2,
    lineHeight: 1,
    padding: '0 6px',
    height: RADIUS_STANDARD * 2,
    borderRadius: RADIUS_STANDARD,
    zIndex: 1,
    // Render the badge on top of potential ripples.
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    variants: [...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter(key => {
      var _theme$vars2, _theme$vars3;
      return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main && ((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette[key].contrastText;
    }).map(color => ({
      props: {
        color
      },
      style: {
        backgroundColor: (theme.vars || theme).palette[color].main,
        color: (theme.vars || theme).palette[color].contrastText
      }
    })), {
      props: {
        variant: 'dot'
      },
      style: {
        borderRadius: RADIUS_DOT,
        height: RADIUS_DOT * 2,
        minWidth: RADIUS_DOT * 2,
        padding: 0
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
      style: {
        top: 0,
        right: 0,
        transform: 'scale(1) translate(50%, -50%)',
        transformOrigin: '100% 0%',
        [`&.${_badgeClasses.default.invisible}`]: {
          transform: 'scale(0) translate(50%, -50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
      style: {
        bottom: 0,
        right: 0,
        transform: 'scale(1) translate(50%, 50%)',
        transformOrigin: '100% 100%',
        [`&.${_badgeClasses.default.invisible}`]: {
          transform: 'scale(0) translate(50%, 50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
      style: {
        top: 0,
        left: 0,
        transform: 'scale(1) translate(-50%, -50%)',
        transformOrigin: '0% 0%',
        [`&.${_badgeClasses.default.invisible}`]: {
          transform: 'scale(0) translate(-50%, -50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
      style: {
        bottom: 0,
        left: 0,
        transform: 'scale(1) translate(-50%, 50%)',
        transformOrigin: '0% 100%',
        [`&.${_badgeClasses.default.invisible}`]: {
          transform: 'scale(0) translate(-50%, 50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
      style: {
        top: '14%',
        right: '14%',
        transform: 'scale(1) translate(50%, -50%)',
        transformOrigin: '100% 0%',
        [`&.${_badgeClasses.default.invisible}`]: {
          transform: 'scale(0) translate(50%, -50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
      style: {
        bottom: '14%',
        right: '14%',
        transform: 'scale(1) translate(50%, 50%)',
        transformOrigin: '100% 100%',
        [`&.${_badgeClasses.default.invisible}`]: {
          transform: 'scale(0) translate(50%, 50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
      style: {
        top: '14%',
        left: '14%',
        transform: 'scale(1) translate(-50%, -50%)',
        transformOrigin: '0% 0%',
        [`&.${_badgeClasses.default.invisible}`]: {
          transform: 'scale(0) translate(-50%, -50%)'
        }
      }
    }, {
      props: ({
        ownerState
      }) => ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
      style: {
        bottom: '14%',
        left: '14%',
        transform: 'scale(1) translate(-50%, 50%)',
        transformOrigin: '0% 100%',
        [`&.${_badgeClasses.default.invisible}`]: {
          transform: 'scale(0) translate(-50%, 50%)'
        }
      }
    }, {
      props: {
        invisible: true
      },
      style: {
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.leavingScreen
        })
      }
    }]
  };
});
const Badge = /*#__PURE__*/React$2a.forwardRef(function Badge(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
  const props = (0, _DefaultPropsProvider$1u.useDefaultProps)({
    props: inProps,
    name: 'MuiBadge'
  });
  const {
      anchorOrigin: anchorOriginProp = {
        vertical: 'top',
        horizontal: 'right'
      },
      className,
      component,
      components = {},
      componentsProps = {},
      children,
      overlap: overlapProp = 'rectangular',
      color: colorProp = 'default',
      invisible: invisibleProp = false,
      max: maxProp = 99,
      badgeContent: badgeContentProp,
      slots,
      slotProps,
      showZero = false,
      variant: variantProp = 'standard'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1I.default)(props, _excluded$2a);
  const {
    badgeContent,
    invisible: invisibleFromHook,
    max,
    displayValue: displayValueFromHook
  } = (0, _useBadge.default)({
    max: maxProp,
    invisible: invisibleProp,
    badgeContent: badgeContentProp,
    showZero
  });
  const prevProps = (0, _usePreviousProps.default)({
    anchorOrigin: anchorOriginProp,
    color: colorProp,
    overlap: overlapProp,
    variant: variantProp,
    badgeContent: badgeContentProp
  });
  const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
  const {
    color = colorProp,
    overlap = overlapProp,
    anchorOrigin = anchorOriginProp,
    variant = variantProp
  } = invisible ? prevProps : props;
  const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
  const ownerState = (0, _extends2$1N.default)({}, props, {
    badgeContent,
    invisible,
    max,
    displayValue,
    showZero,
    anchorOrigin,
    color,
    overlap,
    variant
  });
  const classes = useUtilityClasses$1u(ownerState);

  // support both `slots` and `components` for backward compatibility
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : BadgeRoot;
  const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : BadgeBadge;
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
  const rootProps = (0, _useSlotProps$7.default)({
    elementType: RootSlot,
    externalSlotProps: rootSlotProps,
    externalForwardedProps: other,
    additionalProps: {
      ref,
      as: component
    },
    ownerState,
    className: (0, _clsx$21.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
  });
  const badgeProps = (0, _useSlotProps$7.default)({
    elementType: BadgeSlot,
    externalSlotProps: badgeSlotProps,
    ownerState,
    className: (0, _clsx$21.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
  });
  return /*#__PURE__*/(0, _jsxRuntime$24.jsxs)(RootSlot, (0, _extends2$1N.default)({}, rootProps, {
    children: [children, /*#__PURE__*/(0, _jsxRuntime$24.jsx)(BadgeSlot, (0, _extends2$1N.default)({}, badgeProps, {
      children: displayValue
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? Badge.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: _propTypes$2f.default.shape({
    horizontal: _propTypes$2f.default.oneOf(['left', 'right']).isRequired,
    vertical: _propTypes$2f.default.oneOf(['bottom', 'top']).isRequired
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: _propTypes$2f.default.node,
  /**
   * The badge will be added relative to this node.
   */
  children: _propTypes$2f.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2f.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2f.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: _propTypes$2f.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2f.default.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$2f.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2f.default.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$2f.default.shape({
    Badge: _propTypes$2f.default.elementType,
    Root: _propTypes$2f.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: _propTypes$2f.default.shape({
    badge: _propTypes$2f.default.oneOfType([_propTypes$2f.default.func, _propTypes$2f.default.object]),
    root: _propTypes$2f.default.oneOfType([_propTypes$2f.default.func, _propTypes$2f.default.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: _propTypes$2f.default.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: _propTypes$2f.default.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: _propTypes$2f.default.oneOf(['circular', 'rectangular']),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: _propTypes$2f.default.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: _propTypes$2f.default.shape({
    badge: _propTypes$2f.default.oneOfType([_propTypes$2f.default.func, _propTypes$2f.default.object]),
    root: _propTypes$2f.default.oneOfType([_propTypes$2f.default.func, _propTypes$2f.default.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: _propTypes$2f.default.shape({
    badge: _propTypes$2f.default.elementType,
    root: _propTypes$2f.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2f.default.oneOfType([_propTypes$2f.default.arrayOf(_propTypes$2f.default.oneOfType([_propTypes$2f.default.func, _propTypes$2f.default.object, _propTypes$2f.default.bool])), _propTypes$2f.default.func, _propTypes$2f.default.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: _propTypes$2f.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$2f.default.oneOf(['dot', 'standard']), _propTypes$2f.default.string])
} : void 0;
Badge$1.default = Badge;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  badgeClasses: true
};
Object.defineProperty(exports, "badgeClasses", {
  enumerable: true,
  get: function () {
    return _badgeClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Badge.default;
  }
});
var _Badge = _interopRequireDefault(Badge$1);
var _badgeClasses = _interopRequireWildcard(badgeClasses$1);
Object.keys(_badgeClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _badgeClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _badgeClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Badge$2));

var BottomNavigation$2 = {};

var BottomNavigation$1 = {};

var bottomNavigationClasses$1 = {};

var _interopRequireDefault$74 = interopRequireDefault$1.exports;
Object.defineProperty(bottomNavigationClasses$1, "__esModule", {
  value: true
});
bottomNavigationClasses$1.default = void 0;
bottomNavigationClasses$1.getBottomNavigationUtilityClass = getBottomNavigationUtilityClass;
var _generateUtilityClasses$1s = _interopRequireDefault$74(generateUtilityClasses$3);
var _generateUtilityClass$1r = _interopRequireDefault$74(generateUtilityClass$3);
function getBottomNavigationUtilityClass(slot) {
  return (0, _generateUtilityClass$1r.default)('MuiBottomNavigation', slot);
}
const bottomNavigationClasses = (0, _generateUtilityClasses$1s.default)('MuiBottomNavigation', ['root']);
bottomNavigationClasses$1.default = bottomNavigationClasses;

var _interopRequireDefault$73 = interopRequireDefault$1.exports;
Object.defineProperty(BottomNavigation$1, "__esModule", {
  value: true
});
BottomNavigation$1.default = void 0;
var _extends2$1M = _interopRequireDefault$73(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1H = _interopRequireDefault$73(objectWithoutPropertiesLoose.exports);
var React$29 = _interopRequireWildcard$3m(React__default$4);
var _reactIs$9 = reactIs$6.exports;
var _propTypes$2e = _interopRequireDefault$73(propTypes.exports);
var _clsx$20 = _interopRequireDefault$73(clsx.exports);
var _composeClasses$1s = _interopRequireDefault$73(composeClasses$2);
var _styled$1t = _interopRequireDefault$73(styled$2);
var _DefaultPropsProvider$1t = DefaultPropsProvider$5;
var _bottomNavigationClasses = bottomNavigationClasses$1;
var _jsxRuntime$23 = require$$11;
const _excluded$29 = ["children", "className", "component", "onChange", "showLabels", "value"];
function _getRequireWildcardCache$35(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$35 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3m(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$35(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1t = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$1s.default)(slots, _bottomNavigationClasses.getBottomNavigationUtilityClass, classes);
};
const BottomNavigationRoot = (0, _styled$1t.default)('div', {
  name: 'MuiBottomNavigation',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  height: 56,
  backgroundColor: (theme.vars || theme).palette.background.paper
}));
const BottomNavigation = /*#__PURE__*/React$29.forwardRef(function BottomNavigation(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1t.useDefaultProps)({
    props: inProps,
    name: 'MuiBottomNavigation'
  });
  const {
      children,
      className,
      component = 'div',
      onChange,
      showLabels = false,
      value
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1H.default)(props, _excluded$29);
  const ownerState = (0, _extends2$1M.default)({}, props, {
    component,
    showLabels
  });
  const classes = useUtilityClasses$1t(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$23.jsx)(BottomNavigationRoot, (0, _extends2$1M.default)({
    as: component,
    className: (0, _clsx$20.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: React$29.Children.map(children, (child, childIndex) => {
      if (! /*#__PURE__*/React$29.isValidElement(child)) {
        return null;
      }
      if (process.env.NODE_ENV !== 'production') {
        if ((0, _reactIs$9.isFragment)(child)) {
          console.error(["MUI: The BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
        }
      }
      const childValue = child.props.value === undefined ? childIndex : child.props.value;
      return /*#__PURE__*/React$29.cloneElement(child, {
        selected: childValue === value,
        showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
        value: childValue,
        onChange
      });
    })
  }));
});
process.env.NODE_ENV !== "production" ? BottomNavigation.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2e.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2e.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2e.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2e.default.elementType,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child.
   */
  onChange: _propTypes$2e.default.func,
  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   * @default false
   */
  showLabels: _propTypes$2e.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2e.default.oneOfType([_propTypes$2e.default.arrayOf(_propTypes$2e.default.oneOfType([_propTypes$2e.default.func, _propTypes$2e.default.object, _propTypes$2e.default.bool])), _propTypes$2e.default.func, _propTypes$2e.default.object]),
  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: _propTypes$2e.default.any
} : void 0;
BottomNavigation$1.default = BottomNavigation;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  bottomNavigationClasses: true
};
Object.defineProperty(exports, "bottomNavigationClasses", {
  enumerable: true,
  get: function () {
    return _bottomNavigationClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _BottomNavigation.default;
  }
});
var _BottomNavigation = _interopRequireDefault(BottomNavigation$1);
var _bottomNavigationClasses = _interopRequireWildcard(bottomNavigationClasses$1);
Object.keys(_bottomNavigationClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _bottomNavigationClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _bottomNavigationClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(BottomNavigation$2));

var BottomNavigationAction$2 = {};

var BottomNavigationAction$1 = {};

var bottomNavigationActionClasses$1 = {};

var _interopRequireDefault$72 = interopRequireDefault$1.exports;
Object.defineProperty(bottomNavigationActionClasses$1, "__esModule", {
  value: true
});
bottomNavigationActionClasses$1.default = void 0;
bottomNavigationActionClasses$1.getBottomNavigationActionUtilityClass = getBottomNavigationActionUtilityClass;
var _generateUtilityClasses$1r = _interopRequireDefault$72(generateUtilityClasses$3);
var _generateUtilityClass$1q = _interopRequireDefault$72(generateUtilityClass$3);
function getBottomNavigationActionUtilityClass(slot) {
  return (0, _generateUtilityClass$1q.default)('MuiBottomNavigationAction', slot);
}
const bottomNavigationActionClasses = (0, _generateUtilityClasses$1r.default)('MuiBottomNavigationAction', ['root', 'iconOnly', 'selected', 'label']);
bottomNavigationActionClasses$1.default = bottomNavigationActionClasses;

var _interopRequireDefault$71 = interopRequireDefault$1.exports;
Object.defineProperty(BottomNavigationAction$1, "__esModule", {
  value: true
});
BottomNavigationAction$1.default = void 0;
var _objectWithoutPropertiesLoose2$1G = _interopRequireDefault$71(objectWithoutPropertiesLoose.exports);
var _extends2$1L = _interopRequireDefault$71(_extends$19.exports);
var React$28 = _interopRequireWildcard$3l(React__default$4);
var _propTypes$2d = _interopRequireDefault$71(propTypes.exports);
var _clsx$1$ = _interopRequireDefault$71(clsx.exports);
var _composeClasses$1r = _interopRequireDefault$71(composeClasses$2);
var _styled$1s = _interopRequireDefault$71(styled$2);
var _DefaultPropsProvider$1s = DefaultPropsProvider$5;
var _ButtonBase$e = _interopRequireDefault$71(ButtonBase$2);
var _unsupportedProp$1 = _interopRequireDefault$71(unsupportedProp);
var _bottomNavigationActionClasses = _interopRequireWildcard$3l(bottomNavigationActionClasses$1);
var _jsxRuntime$22 = require$$11;
const _excluded$28 = ["className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"];
function _getRequireWildcardCache$34(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$34 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3l(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$34(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1s = ownerState => {
  const {
    classes,
    showLabel,
    selected
  } = ownerState;
  const slots = {
    root: ['root', !showLabel && !selected && 'iconOnly', selected && 'selected'],
    label: ['label', !showLabel && !selected && 'iconOnly', selected && 'selected']
  };
  return (0, _composeClasses$1r.default)(slots, _bottomNavigationActionClasses.getBottomNavigationActionUtilityClass, classes);
};
const BottomNavigationActionRoot = (0, _styled$1s.default)(_ButtonBase$e.default, {
  name: 'MuiBottomNavigationAction',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.showLabel && !ownerState.selected && styles.iconOnly];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1L.default)({
  transition: theme.transitions.create(['color', 'padding-top'], {
    duration: theme.transitions.duration.short
  }),
  padding: '0px 12px',
  minWidth: 80,
  maxWidth: 168,
  color: (theme.vars || theme).palette.text.secondary,
  flexDirection: 'column',
  flex: '1'
}, !ownerState.showLabel && !ownerState.selected && {
  paddingTop: 14
}, !ownerState.showLabel && !ownerState.selected && !ownerState.label && {
  paddingTop: 0
}, {
  [`&.${_bottomNavigationActionClasses.default.selected}`]: {
    color: (theme.vars || theme).palette.primary.main
  }
}));
const BottomNavigationActionLabel = (0, _styled$1s.default)('span', {
  name: 'MuiBottomNavigationAction',
  slot: 'Label',
  overridesResolver: (props, styles) => styles.label
})(({
  theme,
  ownerState
}) => (0, _extends2$1L.default)({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(12),
  opacity: 1,
  transition: 'font-size 0.2s, opacity 0.2s',
  transitionDelay: '0.1s'
}, !ownerState.showLabel && !ownerState.selected && {
  opacity: 0,
  transitionDelay: '0s'
}, {
  [`&.${_bottomNavigationActionClasses.default.selected}`]: {
    fontSize: theme.typography.pxToRem(14)
  }
}));
const BottomNavigationAction = /*#__PURE__*/React$28.forwardRef(function BottomNavigationAction(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1s.useDefaultProps)({
    props: inProps,
    name: 'MuiBottomNavigationAction'
  });
  const {
      className,
      icon,
      label,
      onChange,
      onClick
      // eslint-disable-next-line react/prop-types -- private, always overridden by BottomNavigation
      ,

      value
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1G.default)(props, _excluded$28);
  const ownerState = props;
  const classes = useUtilityClasses$1s(ownerState);
  const handleChange = event => {
    if (onChange) {
      onChange(event, value);
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime$22.jsxs)(BottomNavigationActionRoot, (0, _extends2$1L.default)({
    ref: ref,
    className: (0, _clsx$1$.default)(classes.root, className),
    focusRipple: true,
    onClick: handleChange,
    ownerState: ownerState
  }, other, {
    children: [icon, /*#__PURE__*/(0, _jsxRuntime$22.jsx)(BottomNavigationActionLabel, {
      className: classes.label,
      ownerState: ownerState,
      children: label
    })]
  }));
});
process.env.NODE_ENV !== "production" ? BottomNavigationAction.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: _unsupportedProp$1.default,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2d.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2d.default.string,
  /**
   * The icon to display.
   */
  icon: _propTypes$2d.default.node,
  /**
   * The label element.
   */
  label: _propTypes$2d.default.node,
  /**
   * @ignore
   */
  onChange: _propTypes$2d.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes$2d.default.func,
  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   *
   * The prop defaults to the value (`false`) inherited from the parent BottomNavigation component.
   */
  showLabel: _propTypes$2d.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2d.default.oneOfType([_propTypes$2d.default.arrayOf(_propTypes$2d.default.oneOfType([_propTypes$2d.default.func, _propTypes$2d.default.object, _propTypes$2d.default.bool])), _propTypes$2d.default.func, _propTypes$2d.default.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes$2d.default.any
} : void 0;
BottomNavigationAction$1.default = BottomNavigationAction;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  bottomNavigationActionClasses: true
};
Object.defineProperty(exports, "bottomNavigationActionClasses", {
  enumerable: true,
  get: function () {
    return _bottomNavigationActionClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _BottomNavigationAction.default;
  }
});
var _BottomNavigationAction = _interopRequireDefault(BottomNavigationAction$1);
var _bottomNavigationActionClasses = _interopRequireWildcard(bottomNavigationActionClasses$1);
Object.keys(_bottomNavigationActionClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _bottomNavigationActionClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _bottomNavigationActionClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(BottomNavigationAction$2));

var Box$3 = {};

var Box$2 = {};

var className = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "unstable_ClassNameGenerator", {
  enumerable: true,
  get: function () {
    return _utils.unstable_ClassNameGenerator;
  }
});
var _utils = utils$7;
}(className));

var boxClasses$1 = {};

var _interopRequireDefault$70 = interopRequireDefault$1.exports;
Object.defineProperty(boxClasses$1, "__esModule", {
  value: true
});
boxClasses$1.default = void 0;
var _generateUtilityClasses$1q = _interopRequireDefault$70(generateUtilityClasses$3);
const boxClasses = (0, _generateUtilityClasses$1q.default)('MuiBox', ['root']);
boxClasses$1.default = boxClasses;

var _interopRequireDefault$6$ = interopRequireDefault$1.exports;
Object.defineProperty(Box$2, "__esModule", {
  value: true
});
Box$2.default = void 0;
var _system$7 = system;
var _propTypes$2c = _interopRequireDefault$6$(propTypes.exports);
var _className = className;
var _styles$5 = styles$u;
var _identifier = _interopRequireDefault$6$(identifier);
var _boxClasses = _interopRequireDefault$6$(boxClasses$1);
const defaultTheme$1 = (0, _styles$5.createTheme)();
const Box$1 = (0, _system$7.createBox)({
  themeId: _identifier.default,
  defaultTheme: defaultTheme$1,
  defaultClassName: _boxClasses.default.root,
  generateClassName: _className.unstable_ClassNameGenerator.generate
});
process.env.NODE_ENV !== "production" ? Box$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: _propTypes$2c.default.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2c.default.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2c.default.oneOfType([_propTypes$2c.default.arrayOf(_propTypes$2c.default.oneOfType([_propTypes$2c.default.func, _propTypes$2c.default.object, _propTypes$2c.default.bool])), _propTypes$2c.default.func, _propTypes$2c.default.object])
} : void 0;
Box$2.default = Box$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  boxClasses: true
};
Object.defineProperty(exports, "boxClasses", {
  enumerable: true,
  get: function () {
    return _boxClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Box.default;
  }
});
var _Box = _interopRequireDefault(Box$2);
var _boxClasses = _interopRequireWildcard(boxClasses$1);
Object.keys(_boxClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _boxClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _boxClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Box$3));

var Box = /*@__PURE__*/getDefaultExportFromCjs$1(Box$3);

var Breadcrumbs$3 = {};

var Breadcrumbs$2 = {};

var BreadcrumbCollapsed$1 = {};

var MoreHoriz = {};

var _interopRequireDefault$6_ = interopRequireDefault$1.exports;
Object.defineProperty(MoreHoriz, "__esModule", {
  value: true
});
MoreHoriz.default = void 0;
_interopRequireWildcard$3k(React__default$4);
var _createSvgIcon$h = _interopRequireDefault$6_(createSvgIcon$2);
var _jsxRuntime$21 = require$$11;
function _getRequireWildcardCache$33(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$33 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3k(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$33(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
MoreHoriz.default = (0, _createSvgIcon$h.default)( /*#__PURE__*/(0, _jsxRuntime$21.jsx)("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');

var _interopRequireDefault$6Z = interopRequireDefault$1.exports;
Object.defineProperty(BreadcrumbCollapsed$1, "__esModule", {
  value: true
});
BreadcrumbCollapsed$1.default = void 0;
var _objectWithoutPropertiesLoose2$1F = _interopRequireDefault$6Z(objectWithoutPropertiesLoose.exports);
var _extends2$1K = _interopRequireDefault$6Z(_extends$19.exports);
_interopRequireWildcard$3j(React__default$4);
var _propTypes$2b = _interopRequireDefault$6Z(propTypes.exports);
var _colorManipulator$i = colorManipulator;
var _styled$1r = _interopRequireDefault$6Z(styled$2);
var _MoreHoriz = _interopRequireDefault$6Z(MoreHoriz);
var _ButtonBase$d = _interopRequireDefault$6Z(ButtonBase$2);
var _jsxRuntime$20 = require$$11;
const _excluded$27 = ["slots", "slotProps"];
function _getRequireWildcardCache$32(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$32 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3j(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$32(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BreadcrumbCollapsedButton = (0, _styled$1r.default)(_ButtonBase$d.default)(({
  theme
}) => (0, _extends2$1K.default)({
  display: 'flex',
  marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
  marginRight: `calc(${theme.spacing(1)} * 0.5)`
}, theme.palette.mode === 'light' ? {
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.grey[700]
} : {
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.grey[100]
}, {
  borderRadius: 2,
  '&:hover, &:focus': (0, _extends2$1K.default)({}, theme.palette.mode === 'light' ? {
    backgroundColor: theme.palette.grey[200]
  } : {
    backgroundColor: theme.palette.grey[600]
  }),
  '&:active': (0, _extends2$1K.default)({
    boxShadow: theme.shadows[0]
  }, theme.palette.mode === 'light' ? {
    backgroundColor: (0, _colorManipulator$i.emphasize)(theme.palette.grey[200], 0.12)
  } : {
    backgroundColor: (0, _colorManipulator$i.emphasize)(theme.palette.grey[600], 0.12)
  })
}));
const BreadcrumbCollapsedIcon = (0, _styled$1r.default)(_MoreHoriz.default)({
  width: 24,
  height: 16
});

/**
 * @ignore - internal component.
 */
function BreadcrumbCollapsed(props) {
  const {
      slots = {},
      slotProps = {}
    } = props,
    otherProps = (0, _objectWithoutPropertiesLoose2$1F.default)(props, _excluded$27);
  const ownerState = props;
  return /*#__PURE__*/(0, _jsxRuntime$20.jsx)("li", {
    children: /*#__PURE__*/(0, _jsxRuntime$20.jsx)(BreadcrumbCollapsedButton, (0, _extends2$1K.default)({
      focusRipple: true
    }, otherProps, {
      ownerState: ownerState,
      children: /*#__PURE__*/(0, _jsxRuntime$20.jsx)(BreadcrumbCollapsedIcon, (0, _extends2$1K.default)({
        as: slots.CollapsedIcon,
        ownerState: ownerState
      }, slotProps.collapsedIcon))
    }))
  });
}
process.env.NODE_ENV !== "production" ? BreadcrumbCollapsed.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: _propTypes$2b.default.shape({
    collapsedIcon: _propTypes$2b.default.oneOfType([_propTypes$2b.default.func, _propTypes$2b.default.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: _propTypes$2b.default.shape({
    CollapsedIcon: _propTypes$2b.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2b.default.object
} : void 0;
BreadcrumbCollapsed$1.default = BreadcrumbCollapsed;

var breadcrumbsClasses$1 = {};

var _interopRequireDefault$6Y = interopRequireDefault$1.exports;
Object.defineProperty(breadcrumbsClasses$1, "__esModule", {
  value: true
});
breadcrumbsClasses$1.default = void 0;
breadcrumbsClasses$1.getBreadcrumbsUtilityClass = getBreadcrumbsUtilityClass;
var _generateUtilityClasses$1p = _interopRequireDefault$6Y(generateUtilityClasses$3);
var _generateUtilityClass$1p = _interopRequireDefault$6Y(generateUtilityClass$3);
function getBreadcrumbsUtilityClass(slot) {
  return (0, _generateUtilityClass$1p.default)('MuiBreadcrumbs', slot);
}
const breadcrumbsClasses = (0, _generateUtilityClasses$1p.default)('MuiBreadcrumbs', ['root', 'ol', 'li', 'separator']);
breadcrumbsClasses$1.default = breadcrumbsClasses;

var _interopRequireDefault$6X = interopRequireDefault$1.exports;
Object.defineProperty(Breadcrumbs$2, "__esModule", {
  value: true
});
Breadcrumbs$2.default = void 0;
var _extends2$1J = _interopRequireDefault$6X(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1E = _interopRequireDefault$6X(objectWithoutPropertiesLoose.exports);
var React$27 = _interopRequireWildcard$3i(React__default$4);
var _reactIs$8 = reactIs$6.exports;
var _propTypes$2a = _interopRequireDefault$6X(propTypes.exports);
var _clsx$1_ = _interopRequireDefault$6X(clsx.exports);
var _integerPropType$9 = _interopRequireDefault$6X(integerPropType$1);
var _composeClasses$1q = _interopRequireDefault$6X(composeClasses$2);
var _useSlotProps$6 = _interopRequireDefault$6X(useSlotProps$2);
var _styled$1q = _interopRequireDefault$6X(styled$2);
var _DefaultPropsProvider$1r = DefaultPropsProvider$5;
var _Typography$7 = _interopRequireDefault$6X(Typography$3);
var _BreadcrumbCollapsed = _interopRequireDefault$6X(BreadcrumbCollapsed$1);
var _breadcrumbsClasses = _interopRequireWildcard$3i(breadcrumbsClasses$1);
var _jsxRuntime$1$ = require$$11;
const _excluded$26 = ["children", "className", "component", "slots", "slotProps", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"];
function _getRequireWildcardCache$31(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$31 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3i(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$31(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1r = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    li: ['li'],
    ol: ['ol'],
    separator: ['separator']
  };
  return (0, _composeClasses$1q.default)(slots, _breadcrumbsClasses.getBreadcrumbsUtilityClass, classes);
};
const BreadcrumbsRoot = (0, _styled$1q.default)(_Typography$7.default, {
  name: 'MuiBreadcrumbs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [{
      [`& .${_breadcrumbsClasses.default.li}`]: styles.li
    }, styles.root];
  }
})({});
const BreadcrumbsOl = (0, _styled$1q.default)('ol', {
  name: 'MuiBreadcrumbs',
  slot: 'Ol',
  overridesResolver: (props, styles) => styles.ol
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
const BreadcrumbsSeparator = (0, _styled$1q.default)('li', {
  name: 'MuiBreadcrumbs',
  slot: 'Separator',
  overridesResolver: (props, styles) => styles.separator
})({
  display: 'flex',
  userSelect: 'none',
  marginLeft: 8,
  marginRight: 8
});
function insertSeparators(items, className, separator, ownerState) {
  return items.reduce((acc, current, index) => {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/(0, _jsxRuntime$1$.jsx)(BreadcrumbsSeparator, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        children: separator
      }, `separator-${index}`));
    } else {
      acc.push(current);
    }
    return acc;
  }, []);
}
const Breadcrumbs$1 = /*#__PURE__*/React$27.forwardRef(function Breadcrumbs(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1r.useDefaultProps)({
    props: inProps,
    name: 'MuiBreadcrumbs'
  });
  const {
      children,
      className,
      component = 'nav',
      slots = {},
      slotProps = {},
      expandText = 'Show path',
      itemsAfterCollapse = 1,
      itemsBeforeCollapse = 1,
      maxItems = 8,
      separator = '/'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1E.default)(props, _excluded$26);
  const [expanded, setExpanded] = React$27.useState(false);
  const ownerState = (0, _extends2$1J.default)({}, props, {
    component,
    expanded,
    expandText,
    itemsAfterCollapse,
    itemsBeforeCollapse,
    maxItems,
    separator
  });
  const classes = useUtilityClasses$1r(ownerState);
  const collapsedIconSlotProps = (0, _useSlotProps$6.default)({
    elementType: slots.CollapsedIcon,
    externalSlotProps: slotProps.collapsedIcon,
    ownerState
  });
  const listRef = React$27.useRef(null);
  const renderItemsBeforeAndAfter = allItems => {
    const handleClickExpand = () => {
      setExpanded(true);

      // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.
      // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
      // By moving it to some link/button at least we have some announcement.
      const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
      if (focusable) {
        focusable.focus();
      }
    };

    // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem
    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(['MUI: You have provided an invalid combination of props to the Breadcrumbs.', `itemsAfterCollapse={${itemsAfterCollapse}} + itemsBeforeCollapse={${itemsBeforeCollapse}} >= maxItems={${maxItems}}`].join('\n'));
      }
      return allItems;
    }
    return [...allItems.slice(0, itemsBeforeCollapse), /*#__PURE__*/(0, _jsxRuntime$1$.jsx)(_BreadcrumbCollapsed.default, {
      "aria-label": expandText,
      slots: {
        CollapsedIcon: slots.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: collapsedIconSlotProps
      },
      onClick: handleClickExpand
    }, "ellipsis"), ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)];
  };
  const allItems = React$27.Children.toArray(children).filter(child => {
    if (process.env.NODE_ENV !== 'production') {
      if ((0, _reactIs$8.isFragment)(child)) {
        console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    return /*#__PURE__*/React$27.isValidElement(child);
  }).map((child, index) => /*#__PURE__*/(0, _jsxRuntime$1$.jsx)("li", {
    className: classes.li,
    children: child
  }, `child-${index}`));
  return /*#__PURE__*/(0, _jsxRuntime$1$.jsx)(BreadcrumbsRoot, (0, _extends2$1J.default)({
    ref: ref,
    component: component,
    color: "text.secondary",
    className: (0, _clsx$1_.default)(classes.root, className),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$1$.jsx)(BreadcrumbsOl, {
      className: classes.ol,
      ref: listRef,
      ownerState: ownerState,
      children: insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
    })
  }));
});
process.env.NODE_ENV !== "production" ? Breadcrumbs$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$2a.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$2a.default.object,
  /**
   * @ignore
   */
  className: _propTypes$2a.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$2a.default.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: _propTypes$2a.default.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: _integerPropType$9.default,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: _integerPropType$9.default,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: _integerPropType$9.default,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: _propTypes$2a.default.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: _propTypes$2a.default.shape({
    collapsedIcon: _propTypes$2a.default.oneOfType([_propTypes$2a.default.func, _propTypes$2a.default.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: _propTypes$2a.default.shape({
    CollapsedIcon: _propTypes$2a.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$2a.default.oneOfType([_propTypes$2a.default.arrayOf(_propTypes$2a.default.oneOfType([_propTypes$2a.default.func, _propTypes$2a.default.object, _propTypes$2a.default.bool])), _propTypes$2a.default.func, _propTypes$2a.default.object])
} : void 0;
Breadcrumbs$2.default = Breadcrumbs$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  breadcrumbsClasses: true
};
Object.defineProperty(exports, "breadcrumbsClasses", {
  enumerable: true,
  get: function () {
    return _breadcrumbsClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Breadcrumbs.default;
  }
});
var _Breadcrumbs = _interopRequireDefault(Breadcrumbs$2);
var _breadcrumbsClasses = _interopRequireWildcard(breadcrumbsClasses$1);
Object.keys(_breadcrumbsClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _breadcrumbsClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _breadcrumbsClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Breadcrumbs$3));

var Button$3 = {};

var Button$2 = {};

var buttonClasses$1 = {};

var _interopRequireDefault$6W = interopRequireDefault$1.exports;
Object.defineProperty(buttonClasses$1, "__esModule", {
  value: true
});
buttonClasses$1.default = void 0;
buttonClasses$1.getButtonUtilityClass = getButtonUtilityClass;
var _generateUtilityClasses$1o = _interopRequireDefault$6W(generateUtilityClasses$3);
var _generateUtilityClass$1o = _interopRequireDefault$6W(generateUtilityClass$3);
function getButtonUtilityClass(slot) {
  return (0, _generateUtilityClass$1o.default)('MuiButton', slot);
}
const buttonClasses = (0, _generateUtilityClasses$1o.default)('MuiButton', ['root', 'text', 'textInherit', 'textPrimary', 'textSecondary', 'textSuccess', 'textError', 'textInfo', 'textWarning', 'outlined', 'outlinedInherit', 'outlinedPrimary', 'outlinedSecondary', 'outlinedSuccess', 'outlinedError', 'outlinedInfo', 'outlinedWarning', 'contained', 'containedInherit', 'containedPrimary', 'containedSecondary', 'containedSuccess', 'containedError', 'containedInfo', 'containedWarning', 'disableElevation', 'focusVisible', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'colorSuccess', 'colorError', 'colorInfo', 'colorWarning', 'textSizeSmall', 'textSizeMedium', 'textSizeLarge', 'outlinedSizeSmall', 'outlinedSizeMedium', 'outlinedSizeLarge', 'containedSizeSmall', 'containedSizeMedium', 'containedSizeLarge', 'sizeMedium', 'sizeSmall', 'sizeLarge', 'fullWidth', 'startIcon', 'endIcon', 'icon', 'iconSizeSmall', 'iconSizeMedium', 'iconSizeLarge']);
buttonClasses$1.default = buttonClasses;

var ButtonGroupContext$1 = {};

Object.defineProperty(ButtonGroupContext$1, "__esModule", {
  value: true
});
ButtonGroupContext$1.default = void 0;
var React$26 = _interopRequireWildcard$3h(React__default$4);
function _getRequireWildcardCache$30(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$30 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3h(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$30(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const ButtonGroupContext = /*#__PURE__*/React$26.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ButtonGroupContext.displayName = 'ButtonGroupContext';
}
ButtonGroupContext$1.default = ButtonGroupContext;

var ButtonGroupButtonContext$1 = {};

Object.defineProperty(ButtonGroupButtonContext$1, "__esModule", {
  value: true
});
ButtonGroupButtonContext$1.default = void 0;
var React$25 = _interopRequireWildcard$3g(React__default$4);
function _getRequireWildcardCache$2$(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2$ = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3g(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2$(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const ButtonGroupButtonContext = /*#__PURE__*/React$25.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ButtonGroupButtonContext.displayName = 'ButtonGroupButtonContext';
}
ButtonGroupButtonContext$1.default = ButtonGroupButtonContext;

var _interopRequireDefault$6V = interopRequireDefault$1.exports;
Object.defineProperty(Button$2, "__esModule", {
  value: true
});
Button$2.default = void 0;
var _objectWithoutPropertiesLoose2$1D = _interopRequireDefault$6V(objectWithoutPropertiesLoose.exports);
var _extends2$1I = _interopRequireDefault$6V(_extends$19.exports);
var React$24 = _interopRequireWildcard$3f(React__default$4);
var _propTypes$29 = _interopRequireDefault$6V(propTypes.exports);
var _clsx$1Z = _interopRequireDefault$6V(clsx.exports);
var _resolveProps$1 = _interopRequireDefault$6V(resolveProps$2);
var _composeClasses$1p = _interopRequireDefault$6V(composeClasses$2);
var _colorManipulator$h = colorManipulator;
var _styled$1p = _interopRequireWildcard$3f(styled$2);
var _DefaultPropsProvider$1q = DefaultPropsProvider$5;
var _ButtonBase$c = _interopRequireDefault$6V(ButtonBase$2);
var _capitalize$B = _interopRequireDefault$6V(capitalize$1);
var _buttonClasses = _interopRequireWildcard$3f(buttonClasses$1);
var _ButtonGroupContext$1 = _interopRequireDefault$6V(ButtonGroupContext$1);
var _ButtonGroupButtonContext$1 = _interopRequireDefault$6V(ButtonGroupButtonContext$1);
var _jsxRuntime$1_ = require$$11;
const _excluded$25 = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"];
function _getRequireWildcardCache$2_(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2_ = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3f(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2_(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1q = ownerState => {
  const {
    color,
    disableElevation,
    fullWidth,
    size,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, `${variant}${(0, _capitalize$B.default)(color)}`, `size${(0, _capitalize$B.default)(size)}`, `${variant}Size${(0, _capitalize$B.default)(size)}`, `color${(0, _capitalize$B.default)(color)}`, disableElevation && 'disableElevation', fullWidth && 'fullWidth'],
    label: ['label'],
    startIcon: ['icon', 'startIcon', `iconSize${(0, _capitalize$B.default)(size)}`],
    endIcon: ['icon', 'endIcon', `iconSize${(0, _capitalize$B.default)(size)}`]
  };
  const composedClasses = (0, _composeClasses$1p.default)(slots, _buttonClasses.getButtonUtilityClass, classes);
  return (0, _extends2$1I.default)({}, classes, composedClasses);
};
const commonIconStyles = ownerState => (0, _extends2$1I.default)({}, ownerState.size === 'small' && {
  '& > *:nth-of-type(1)': {
    fontSize: 18
  }
}, ownerState.size === 'medium' && {
  '& > *:nth-of-type(1)': {
    fontSize: 20
  }
}, ownerState.size === 'large' && {
  '& > *:nth-of-type(1)': {
    fontSize: 22
  }
});
const ButtonRoot = (0, _styled$1p.default)(_ButtonBase$c.default, {
  shouldForwardProp: prop => (0, _styled$1p.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${(0, _capitalize$B.default)(ownerState.color)}`], styles[`size${(0, _capitalize$B.default)(ownerState.size)}`], styles[`${ownerState.variant}Size${(0, _capitalize$B.default)(ownerState.size)}`], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disableElevation && styles.disableElevation, ownerState.fullWidth && styles.fullWidth];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$palette$getCon, _theme$palette;
  const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
  const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
  return (0, _extends2$1I.default)({}, theme.typography.button, {
    minWidth: 64,
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
      duration: theme.transitions.duration.short
    }),
    '&:hover': (0, _extends2$1I.default)({
      textDecoration: 'none',
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$h.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$h.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
      border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$h.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }, ownerState.variant === 'contained' && {
      backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
      boxShadow: (theme.vars || theme).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: (theme.vars || theme).shadows[2],
        backgroundColor: (theme.vars || theme).palette.grey[300]
      }
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
      }
    }),
    '&:active': (0, _extends2$1I.default)({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[8]
    }),
    [`&.${_buttonClasses.default.focusVisible}`]: (0, _extends2$1I.default)({}, ownerState.variant === 'contained' && {
      boxShadow: (theme.vars || theme).shadows[6]
    }),
    [`&.${_buttonClasses.default.disabled}`]: (0, _extends2$1I.default)({
      color: (theme.vars || theme).palette.action.disabled
    }, ownerState.variant === 'outlined' && {
      border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
    }, ownerState.variant === 'contained' && {
      color: (theme.vars || theme).palette.action.disabled,
      boxShadow: (theme.vars || theme).shadows[0],
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    })
  }, ownerState.variant === 'text' && {
    padding: '6px 8px'
  }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.variant === 'outlined' && {
    padding: '5px 15px',
    border: '1px solid currentColor'
  }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].main,
    border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, _colorManipulator$h.alpha)(theme.palette[ownerState.color].main, 0.5)}`
  }, ownerState.variant === 'contained' && {
    color: theme.vars ?
    // this is safe because grey does not change between default light/dark mode
    theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
    backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
    boxShadow: (theme.vars || theme).shadows[2]
  }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
    color: (theme.vars || theme).palette[ownerState.color].contrastText,
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
  }, ownerState.color === 'inherit' && {
    color: 'inherit',
    borderColor: 'currentColor'
  }, ownerState.size === 'small' && ownerState.variant === 'text' && {
    padding: '4px 5px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'text' && {
    padding: '8px 11px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
    padding: '3px 9px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
    padding: '7px 21px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
    padding: '4px 10px',
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
    padding: '8px 22px',
    fontSize: theme.typography.pxToRem(15)
  }, ownerState.fullWidth && {
    width: '100%'
  });
}, ({
  ownerState
}) => ownerState.disableElevation && {
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none'
  },
  [`&.${_buttonClasses.default.focusVisible}`]: {
    boxShadow: 'none'
  },
  '&:active': {
    boxShadow: 'none'
  },
  [`&.${_buttonClasses.default.disabled}`]: {
    boxShadow: 'none'
  }
});
const ButtonStartIcon = (0, _styled$1p.default)('span', {
  name: 'MuiButton',
  slot: 'StartIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.startIcon, styles[`iconSize${(0, _capitalize$B.default)(ownerState.size)}`]];
  }
})(({
  ownerState
}) => (0, _extends2$1I.default)({
  display: 'inherit',
  marginRight: 8,
  marginLeft: -4
}, ownerState.size === 'small' && {
  marginLeft: -2
}, commonIconStyles(ownerState)));
const ButtonEndIcon = (0, _styled$1p.default)('span', {
  name: 'MuiButton',
  slot: 'EndIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.endIcon, styles[`iconSize${(0, _capitalize$B.default)(ownerState.size)}`]];
  }
})(({
  ownerState
}) => (0, _extends2$1I.default)({
  display: 'inherit',
  marginRight: -4,
  marginLeft: 8
}, ownerState.size === 'small' && {
  marginRight: -2
}, commonIconStyles(ownerState)));
const Button$1 = /*#__PURE__*/React$24.forwardRef(function Button(inProps, ref) {
  // props priority: `inProps` > `contextProps` > `themeDefaultProps`
  const contextProps = React$24.useContext(_ButtonGroupContext$1.default);
  const buttonGroupButtonContextPositionClassName = React$24.useContext(_ButtonGroupButtonContext$1.default);
  const resolvedProps = (0, _resolveProps$1.default)(contextProps, inProps);
  const props = (0, _DefaultPropsProvider$1q.useDefaultProps)({
    props: resolvedProps,
    name: 'MuiButton'
  });
  const {
      children,
      color = 'primary',
      component = 'button',
      className,
      disabled = false,
      disableElevation = false,
      disableFocusRipple = false,
      endIcon: endIconProp,
      focusVisibleClassName,
      fullWidth = false,
      size = 'medium',
      startIcon: startIconProp,
      type,
      variant = 'text'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1D.default)(props, _excluded$25);
  const ownerState = (0, _extends2$1I.default)({}, props, {
    color,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    fullWidth,
    size,
    type,
    variant
  });
  const classes = useUtilityClasses$1q(ownerState);
  const startIcon = startIconProp && /*#__PURE__*/(0, _jsxRuntime$1_.jsx)(ButtonStartIcon, {
    className: classes.startIcon,
    ownerState: ownerState,
    children: startIconProp
  });
  const endIcon = endIconProp && /*#__PURE__*/(0, _jsxRuntime$1_.jsx)(ButtonEndIcon, {
    className: classes.endIcon,
    ownerState: ownerState,
    children: endIconProp
  });
  const positionClassName = buttonGroupButtonContextPositionClassName || '';
  return /*#__PURE__*/(0, _jsxRuntime$1_.jsxs)(ButtonRoot, (0, _extends2$1I.default)({
    ownerState: ownerState,
    className: (0, _clsx$1Z.default)(contextProps.className, classes.root, className, positionClassName),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _clsx$1Z.default)(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other, {
    classes: classes,
    children: [startIcon, children, endIcon]
  }));
});
process.env.NODE_ENV !== "production" ? Button$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$29.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$29.default.object,
  /**
   * @ignore
   */
  className: _propTypes$29.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$29.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$29.default.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning']), _propTypes$29.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$29.default.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$29.default.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: _propTypes$29.default.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: _propTypes$29.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: _propTypes$29.default.bool,
  /**
   * Element placed after the children.
   */
  endIcon: _propTypes$29.default.node,
  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes$29.default.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$29.default.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes$29.default.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: _propTypes$29.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$29.default.oneOf(['small', 'medium', 'large']), _propTypes$29.default.string]),
  /**
   * Element placed before the children.
   */
  startIcon: _propTypes$29.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$29.default.oneOfType([_propTypes$29.default.arrayOf(_propTypes$29.default.oneOfType([_propTypes$29.default.func, _propTypes$29.default.object, _propTypes$29.default.bool])), _propTypes$29.default.func, _propTypes$29.default.object]),
  /**
   * @ignore
   */
  type: _propTypes$29.default.oneOfType([_propTypes$29.default.oneOf(['button', 'reset', 'submit']), _propTypes$29.default.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: _propTypes$29.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$29.default.oneOf(['contained', 'outlined', 'text']), _propTypes$29.default.string])
} : void 0;
Button$2.default = Button$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  buttonClasses: true
};
Object.defineProperty(exports, "buttonClasses", {
  enumerable: true,
  get: function () {
    return _buttonClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Button.default;
  }
});
var _Button = _interopRequireDefault(Button$2);
var _buttonClasses = _interopRequireWildcard(buttonClasses$1);
Object.keys(_buttonClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _buttonClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _buttonClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Button$3));

var MuiButton = /*@__PURE__*/getDefaultExportFromCjs$1(Button$3);

var ButtonGroup$3 = {};

var ButtonGroup$2 = {};

var buttonGroupClasses$1 = {};

var _interopRequireDefault$6U = interopRequireDefault$1.exports;
Object.defineProperty(buttonGroupClasses$1, "__esModule", {
  value: true
});
buttonGroupClasses$1.default = void 0;
buttonGroupClasses$1.getButtonGroupUtilityClass = getButtonGroupUtilityClass;
var _generateUtilityClasses$1n = _interopRequireDefault$6U(generateUtilityClasses$3);
var _generateUtilityClass$1n = _interopRequireDefault$6U(generateUtilityClass$3);
function getButtonGroupUtilityClass(slot) {
  return (0, _generateUtilityClass$1n.default)('MuiButtonGroup', slot);
}
const buttonGroupClasses = (0, _generateUtilityClasses$1n.default)('MuiButtonGroup', ['root', 'contained', 'outlined', 'text', 'disableElevation', 'disabled', 'firstButton', 'fullWidth', 'vertical', 'grouped', 'groupedHorizontal', 'groupedVertical', 'groupedText', 'groupedTextHorizontal', 'groupedTextVertical', 'groupedTextPrimary', 'groupedTextSecondary', 'groupedOutlined', 'groupedOutlinedHorizontal', 'groupedOutlinedVertical', 'groupedOutlinedPrimary', 'groupedOutlinedSecondary', 'groupedContained', 'groupedContainedHorizontal', 'groupedContainedVertical', 'groupedContainedPrimary', 'groupedContainedSecondary', 'lastButton', 'middleButton']);
buttonGroupClasses$1.default = buttonGroupClasses;

var _interopRequireDefault$6T = interopRequireDefault$1.exports;
Object.defineProperty(ButtonGroup$2, "__esModule", {
  value: true
});
ButtonGroup$2.default = void 0;
var _objectWithoutPropertiesLoose2$1C = _interopRequireDefault$6T(objectWithoutPropertiesLoose.exports);
var _extends2$1H = _interopRequireDefault$6T(_extends$19.exports);
var React$23 = _interopRequireWildcard$3e(React__default$4);
var _propTypes$28 = _interopRequireDefault$6T(propTypes.exports);
var _clsx$1Y = _interopRequireDefault$6T(clsx.exports);
var _composeClasses$1o = _interopRequireDefault$6T(composeClasses$2);
var _colorManipulator$g = colorManipulator;
var _getValidReactChildren$1 = _interopRequireDefault$6T(getValidReactChildren$2);
var _capitalize$A = _interopRequireDefault$6T(capitalize$1);
var _styled$1o = _interopRequireDefault$6T(styled$2);
var _DefaultPropsProvider$1p = DefaultPropsProvider$5;
var _buttonGroupClasses = _interopRequireWildcard$3e(buttonGroupClasses$1);
var _ButtonGroupContext = _interopRequireDefault$6T(ButtonGroupContext$1);
var _ButtonGroupButtonContext = _interopRequireDefault$6T(ButtonGroupButtonContext$1);
var _jsxRuntime$1Z = require$$11;
const _excluded$24 = ["children", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"];
function _getRequireWildcardCache$2Z(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2Z = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3e(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2Z(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const overridesResolver$6 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [{
    [`& .${_buttonGroupClasses.default.grouped}`]: styles.grouped
  }, {
    [`& .${_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize$A.default)(ownerState.orientation)}`]
  }, {
    [`& .${_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize$A.default)(ownerState.variant)}`]
  }, {
    [`& .${_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize$A.default)(ownerState.variant)}${(0, _capitalize$A.default)(ownerState.orientation)}`]
  }, {
    [`& .${_buttonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize$A.default)(ownerState.variant)}${(0, _capitalize$A.default)(ownerState.color)}`]
  }, {
    [`& .${_buttonGroupClasses.default.firstButton}`]: styles.firstButton
  }, {
    [`& .${_buttonGroupClasses.default.lastButton}`]: styles.lastButton
  }, {
    [`& .${_buttonGroupClasses.default.middleButton}`]: styles.middleButton
  }, styles.root, styles[ownerState.variant], ownerState.disableElevation === true && styles.disableElevation, ownerState.fullWidth && styles.fullWidth, ownerState.orientation === 'vertical' && styles.vertical];
};
const useUtilityClasses$1p = ownerState => {
  const {
    classes,
    color,
    disabled,
    disableElevation,
    fullWidth,
    orientation,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant, orientation === 'vertical' && 'vertical', fullWidth && 'fullWidth', disableElevation && 'disableElevation'],
    grouped: ['grouped', `grouped${(0, _capitalize$A.default)(orientation)}`, `grouped${(0, _capitalize$A.default)(variant)}`, `grouped${(0, _capitalize$A.default)(variant)}${(0, _capitalize$A.default)(orientation)}`, `grouped${(0, _capitalize$A.default)(variant)}${(0, _capitalize$A.default)(color)}`, disabled && 'disabled'],
    firstButton: ['firstButton'],
    lastButton: ['lastButton'],
    middleButton: ['middleButton']
  };
  return (0, _composeClasses$1o.default)(slots, _buttonGroupClasses.getButtonGroupUtilityClass, classes);
};
const ButtonGroupRoot = (0, _styled$1o.default)('div', {
  name: 'MuiButtonGroup',
  slot: 'Root',
  overridesResolver: overridesResolver$6
})(({
  theme,
  ownerState
}) => (0, _extends2$1H.default)({
  display: 'inline-flex',
  borderRadius: (theme.vars || theme).shape.borderRadius
}, ownerState.variant === 'contained' && {
  boxShadow: (theme.vars || theme).shadows[2]
}, ownerState.disableElevation && {
  boxShadow: 'none'
}, ownerState.fullWidth && {
  width: '100%'
}, ownerState.orientation === 'vertical' && {
  flexDirection: 'column'
}, {
  [`& .${_buttonGroupClasses.default.grouped}`]: (0, _extends2$1H.default)({
    minWidth: 40,
    '&:hover': (0, _extends2$1H.default)({}, ownerState.variant === 'contained' && {
      boxShadow: 'none'
    })
  }, ownerState.variant === 'contained' && {
    boxShadow: 'none'
  }),
  [`& .${_buttonGroupClasses.default.firstButton},& .${_buttonGroupClasses.default.middleButton}`]: (0, _extends2$1H.default)({}, ownerState.orientation === 'horizontal' && {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }, ownerState.orientation === 'vertical' && {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0
  }, ownerState.variant === 'text' && ownerState.orientation === 'horizontal' && {
    borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
    [`&.${_buttonGroupClasses.default.disabled}`]: {
      borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
    }
  }, ownerState.variant === 'text' && ownerState.orientation === 'vertical' && {
    borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
    [`&.${_buttonGroupClasses.default.disabled}`]: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
    }
  }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
    borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, _colorManipulator$g.alpha)(theme.palette[ownerState.color].main, 0.5)
  }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
    borderRightColor: 'transparent'
  }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
    borderBottomColor: 'transparent'
  }, ownerState.variant === 'contained' && ownerState.orientation === 'horizontal' && {
    borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
    [`&.${_buttonGroupClasses.default.disabled}`]: {
      borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
    }
  }, ownerState.variant === 'contained' && ownerState.orientation === 'vertical' && {
    borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
    [`&.${_buttonGroupClasses.default.disabled}`]: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
    }
  }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
    borderColor: (theme.vars || theme).palette[ownerState.color].dark
  }, {
    '&:hover': (0, _extends2$1H.default)({}, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
      borderRightColor: 'currentColor'
    }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
      borderBottomColor: 'currentColor'
    })
  }),
  [`& .${_buttonGroupClasses.default.lastButton},& .${_buttonGroupClasses.default.middleButton}`]: (0, _extends2$1H.default)({}, ownerState.orientation === 'horizontal' && {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }, ownerState.orientation === 'vertical' && {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0
  }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
    marginLeft: -1
  }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
    marginTop: -1
  })
}));
const ButtonGroup$1 = /*#__PURE__*/React$23.forwardRef(function ButtonGroup(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1p.useDefaultProps)({
    props: inProps,
    name: 'MuiButtonGroup'
  });
  const {
      children,
      className,
      color = 'primary',
      component = 'div',
      disabled = false,
      disableElevation = false,
      disableFocusRipple = false,
      disableRipple = false,
      fullWidth = false,
      orientation = 'horizontal',
      size = 'medium',
      variant = 'outlined'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1C.default)(props, _excluded$24);
  const ownerState = (0, _extends2$1H.default)({}, props, {
    color,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    disableRipple,
    fullWidth,
    orientation,
    size,
    variant
  });
  const classes = useUtilityClasses$1p(ownerState);
  const context = React$23.useMemo(() => ({
    className: classes.grouped,
    color,
    disabled,
    disableElevation,
    disableFocusRipple,
    disableRipple,
    fullWidth,
    size,
    variant
  }), [color, disabled, disableElevation, disableFocusRipple, disableRipple, fullWidth, size, variant, classes.grouped]);
  const validChildren = (0, _getValidReactChildren$1.default)(children);
  const childrenCount = validChildren.length;
  const getButtonPositionClassName = index => {
    const isFirstButton = index === 0;
    const isLastButton = index === childrenCount - 1;
    if (isFirstButton && isLastButton) {
      return '';
    }
    if (isFirstButton) {
      return classes.firstButton;
    }
    if (isLastButton) {
      return classes.lastButton;
    }
    return classes.middleButton;
  };
  return /*#__PURE__*/(0, _jsxRuntime$1Z.jsx)(ButtonGroupRoot, (0, _extends2$1H.default)({
    as: component,
    role: "group",
    className: (0, _clsx$1Y.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$1Z.jsx)(_ButtonGroupContext.default.Provider, {
      value: context,
      children: validChildren.map((child, index) => {
        return /*#__PURE__*/(0, _jsxRuntime$1Z.jsx)(_ButtonGroupButtonContext.default.Provider, {
          value: getButtonPositionClassName(index),
          children: child
        }, index);
      })
    })
  }));
});
process.env.NODE_ENV !== "production" ? ButtonGroup$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$28.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$28.default.object,
  /**
   * @ignore
   */
  className: _propTypes$28.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$28.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$28.default.oneOf(['inherit', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$28.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$28.default.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$28.default.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: _propTypes$28.default.bool,
  /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: _propTypes$28.default.bool,
  /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */
  disableRipple: _propTypes$28.default.bool,
  /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$28.default.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: _propTypes$28.default.oneOf(['horizontal', 'vertical']),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: _propTypes$28.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$28.default.oneOf(['small', 'medium', 'large']), _propTypes$28.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$28.default.oneOfType([_propTypes$28.default.arrayOf(_propTypes$28.default.oneOfType([_propTypes$28.default.func, _propTypes$28.default.object, _propTypes$28.default.bool])), _propTypes$28.default.func, _propTypes$28.default.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: _propTypes$28.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$28.default.oneOf(['contained', 'outlined', 'text']), _propTypes$28.default.string])
} : void 0;
ButtonGroup$2.default = ButtonGroup$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  buttonGroupClasses: true,
  ButtonGroupContext: true,
  ButtonGroupButtonContext: true
};
Object.defineProperty(exports, "ButtonGroupButtonContext", {
  enumerable: true,
  get: function () {
    return _ButtonGroupButtonContext.default;
  }
});
Object.defineProperty(exports, "ButtonGroupContext", {
  enumerable: true,
  get: function () {
    return _ButtonGroupContext.default;
  }
});
Object.defineProperty(exports, "buttonGroupClasses", {
  enumerable: true,
  get: function () {
    return _buttonGroupClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ButtonGroup.default;
  }
});
var _ButtonGroup = _interopRequireDefault(ButtonGroup$2);
var _buttonGroupClasses = _interopRequireWildcard(buttonGroupClasses$1);
Object.keys(_buttonGroupClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _buttonGroupClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _buttonGroupClasses[key];
    }
  });
});
var _ButtonGroupContext = _interopRequireDefault(ButtonGroupContext$1);
var _ButtonGroupButtonContext = _interopRequireDefault(ButtonGroupButtonContext$1);
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ButtonGroup$3));

var Card$4 = {};

var Card$3 = {};

var cardClasses$1 = {};

var _interopRequireDefault$6S = interopRequireDefault$1.exports;
Object.defineProperty(cardClasses$1, "__esModule", {
  value: true
});
cardClasses$1.default = void 0;
cardClasses$1.getCardUtilityClass = getCardUtilityClass;
var _generateUtilityClasses$1m = _interopRequireDefault$6S(generateUtilityClasses$3);
var _generateUtilityClass$1m = _interopRequireDefault$6S(generateUtilityClass$3);
function getCardUtilityClass(slot) {
  return (0, _generateUtilityClass$1m.default)('MuiCard', slot);
}
const cardClasses = (0, _generateUtilityClasses$1m.default)('MuiCard', ['root']);
cardClasses$1.default = cardClasses;

var _interopRequireDefault$6R = interopRequireDefault$1.exports;
Object.defineProperty(Card$3, "__esModule", {
  value: true
});
Card$3.default = void 0;
var _extends2$1G = _interopRequireDefault$6R(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1B = _interopRequireDefault$6R(objectWithoutPropertiesLoose.exports);
var React$22 = _interopRequireWildcard$3d(React__default$4);
var _propTypes$27 = _interopRequireDefault$6R(propTypes.exports);
var _clsx$1X = _interopRequireDefault$6R(clsx.exports);
var _chainPropTypes$8 = _interopRequireDefault$6R(chainPropTypes$2);
var _composeClasses$1n = _interopRequireDefault$6R(composeClasses$2);
var _styled$1n = _interopRequireDefault$6R(styled$2);
var _DefaultPropsProvider$1o = DefaultPropsProvider$5;
var _Paper$5 = _interopRequireDefault$6R(Paper$3);
var _cardClasses = cardClasses$1;
var _jsxRuntime$1Y = require$$11;
const _excluded$23 = ["className", "raised"];
function _getRequireWildcardCache$2Y(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2Y = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3d(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2Y(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1o = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$1n.default)(slots, _cardClasses.getCardUtilityClass, classes);
};
const CardRoot = (0, _styled$1n.default)(_Paper$5.default, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card$2 = /*#__PURE__*/React$22.forwardRef(function Card(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1o.useDefaultProps)({
    props: inProps,
    name: 'MuiCard'
  });
  const {
      className,
      raised = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1B.default)(props, _excluded$23);
  const ownerState = (0, _extends2$1G.default)({}, props, {
    raised
  });
  const classes = useUtilityClasses$1o(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1Y.jsx)(CardRoot, (0, _extends2$1G.default)({
    className: (0, _clsx$1X.default)(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? Card$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$27.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$27.default.object,
  /**
   * @ignore
   */
  className: _propTypes$27.default.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: (0, _chainPropTypes$8.default)(_propTypes$27.default.bool, props => {
    if (props.raised && props.variant === 'outlined') {
      return new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.');
    }
    return null;
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$27.default.oneOfType([_propTypes$27.default.arrayOf(_propTypes$27.default.oneOfType([_propTypes$27.default.func, _propTypes$27.default.object, _propTypes$27.default.bool])), _propTypes$27.default.func, _propTypes$27.default.object])
} : void 0;
Card$3.default = Card$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  cardClasses: true
};
Object.defineProperty(exports, "cardClasses", {
  enumerable: true,
  get: function () {
    return _cardClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Card.default;
  }
});
var _Card = _interopRequireDefault(Card$3);
var _cardClasses = _interopRequireWildcard(cardClasses$1);
Object.keys(_cardClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _cardClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cardClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Card$4));

var CardActionArea$2 = {};

var CardActionArea$1 = {};

var cardActionAreaClasses$1 = {};

var _interopRequireDefault$6Q = interopRequireDefault$1.exports;
Object.defineProperty(cardActionAreaClasses$1, "__esModule", {
  value: true
});
cardActionAreaClasses$1.default = void 0;
cardActionAreaClasses$1.getCardActionAreaUtilityClass = getCardActionAreaUtilityClass;
var _generateUtilityClasses$1l = _interopRequireDefault$6Q(generateUtilityClasses$3);
var _generateUtilityClass$1l = _interopRequireDefault$6Q(generateUtilityClass$3);
function getCardActionAreaUtilityClass(slot) {
  return (0, _generateUtilityClass$1l.default)('MuiCardActionArea', slot);
}
const cardActionAreaClasses = (0, _generateUtilityClasses$1l.default)('MuiCardActionArea', ['root', 'focusVisible', 'focusHighlight']);
cardActionAreaClasses$1.default = cardActionAreaClasses;

var _interopRequireDefault$6P = interopRequireDefault$1.exports;
Object.defineProperty(CardActionArea$1, "__esModule", {
  value: true
});
CardActionArea$1.default = void 0;
var _extends2$1F = _interopRequireDefault$6P(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1A = _interopRequireDefault$6P(objectWithoutPropertiesLoose.exports);
var React$21 = _interopRequireWildcard$3c(React__default$4);
var _propTypes$26 = _interopRequireDefault$6P(propTypes.exports);
var _clsx$1W = _interopRequireDefault$6P(clsx.exports);
var _composeClasses$1m = _interopRequireDefault$6P(composeClasses$2);
var _DefaultPropsProvider$1n = DefaultPropsProvider$5;
var _styled$1m = _interopRequireDefault$6P(styled$2);
var _cardActionAreaClasses = _interopRequireWildcard$3c(cardActionAreaClasses$1);
var _ButtonBase$b = _interopRequireDefault$6P(ButtonBase$2);
var _jsxRuntime$1X = require$$11;
const _excluded$22 = ["children", "className", "focusVisibleClassName"];
function _getRequireWildcardCache$2X(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2X = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3c(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2X(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1n = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    focusHighlight: ['focusHighlight']
  };
  return (0, _composeClasses$1m.default)(slots, _cardActionAreaClasses.getCardActionAreaUtilityClass, classes);
};
const CardActionAreaRoot = (0, _styled$1m.default)(_ButtonBase$b.default, {
  name: 'MuiCardActionArea',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  display: 'block',
  textAlign: 'inherit',
  borderRadius: 'inherit',
  // for Safari to work https://github.com/mui/material-ui/issues/36285.
  width: '100%',
  [`&:hover .${_cardActionAreaClasses.default.focusHighlight}`]: {
    opacity: (theme.vars || theme).palette.action.hoverOpacity,
    '@media (hover: none)': {
      opacity: 0
    }
  },
  [`&.${_cardActionAreaClasses.default.focusVisible} .${_cardActionAreaClasses.default.focusHighlight}`]: {
    opacity: (theme.vars || theme).palette.action.focusOpacity
  }
}));
const CardActionAreaFocusHighlight = (0, _styled$1m.default)('span', {
  name: 'MuiCardActionArea',
  slot: 'FocusHighlight',
  overridesResolver: (props, styles) => styles.focusHighlight
})(({
  theme
}) => ({
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: 'inherit',
  opacity: 0,
  backgroundColor: 'currentcolor',
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.short
  })
}));
const CardActionArea = /*#__PURE__*/React$21.forwardRef(function CardActionArea(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1n.useDefaultProps)({
    props: inProps,
    name: 'MuiCardActionArea'
  });
  const {
      children,
      className,
      focusVisibleClassName
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1A.default)(props, _excluded$22);
  const ownerState = props;
  const classes = useUtilityClasses$1n(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1X.jsxs)(CardActionAreaRoot, (0, _extends2$1F.default)({
    className: (0, _clsx$1W.default)(classes.root, className),
    focusVisibleClassName: (0, _clsx$1W.default)(focusVisibleClassName, classes.focusVisible),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [children, /*#__PURE__*/(0, _jsxRuntime$1X.jsx)(CardActionAreaFocusHighlight, {
      className: classes.focusHighlight,
      ownerState: ownerState
    })]
  }));
});
process.env.NODE_ENV !== "production" ? CardActionArea.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$26.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$26.default.object,
  /**
   * @ignore
   */
  className: _propTypes$26.default.string,
  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes$26.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$26.default.oneOfType([_propTypes$26.default.arrayOf(_propTypes$26.default.oneOfType([_propTypes$26.default.func, _propTypes$26.default.object, _propTypes$26.default.bool])), _propTypes$26.default.func, _propTypes$26.default.object])
} : void 0;
CardActionArea$1.default = CardActionArea;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  cardActionAreaClasses: true
};
Object.defineProperty(exports, "cardActionAreaClasses", {
  enumerable: true,
  get: function () {
    return _cardActionAreaClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CardActionArea.default;
  }
});
var _CardActionArea = _interopRequireDefault(CardActionArea$1);
var _cardActionAreaClasses = _interopRequireWildcard(cardActionAreaClasses$1);
Object.keys(_cardActionAreaClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _cardActionAreaClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cardActionAreaClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(CardActionArea$2));

var CardActions$3 = {};

var CardActions$2 = {};

var cardActionsClasses$1 = {};

var _interopRequireDefault$6O = interopRequireDefault$1.exports;
Object.defineProperty(cardActionsClasses$1, "__esModule", {
  value: true
});
cardActionsClasses$1.default = void 0;
cardActionsClasses$1.getCardActionsUtilityClass = getCardActionsUtilityClass;
var _generateUtilityClasses$1k = _interopRequireDefault$6O(generateUtilityClasses$3);
var _generateUtilityClass$1k = _interopRequireDefault$6O(generateUtilityClass$3);
function getCardActionsUtilityClass(slot) {
  return (0, _generateUtilityClass$1k.default)('MuiCardActions', slot);
}
const cardActionsClasses = (0, _generateUtilityClasses$1k.default)('MuiCardActions', ['root', 'spacing']);
cardActionsClasses$1.default = cardActionsClasses;

var _interopRequireDefault$6N = interopRequireDefault$1.exports;
Object.defineProperty(CardActions$2, "__esModule", {
  value: true
});
CardActions$2.default = void 0;
var _objectWithoutPropertiesLoose2$1z = _interopRequireDefault$6N(objectWithoutPropertiesLoose.exports);
var _extends2$1E = _interopRequireDefault$6N(_extends$19.exports);
var React$20 = _interopRequireWildcard$3b(React__default$4);
var _propTypes$25 = _interopRequireDefault$6N(propTypes.exports);
var _clsx$1V = _interopRequireDefault$6N(clsx.exports);
var _composeClasses$1l = _interopRequireDefault$6N(composeClasses$2);
var _styled$1l = _interopRequireDefault$6N(styled$2);
var _DefaultPropsProvider$1m = DefaultPropsProvider$5;
var _cardActionsClasses = cardActionsClasses$1;
var _jsxRuntime$1W = require$$11;
const _excluded$21 = ["disableSpacing", "className"];
function _getRequireWildcardCache$2W(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2W = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3b(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2W(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1m = ownerState => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ['root', !disableSpacing && 'spacing']
  };
  return (0, _composeClasses$1l.default)(slots, _cardActionsClasses.getCardActionsUtilityClass, classes);
};
const CardActionsRoot = (0, _styled$1l.default)('div', {
  name: 'MuiCardActions',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableSpacing && styles.spacing];
  }
})(({
  ownerState
}) => (0, _extends2$1E.default)({
  display: 'flex',
  alignItems: 'center',
  padding: 8
}, !ownerState.disableSpacing && {
  '& > :not(style) ~ :not(style)': {
    marginLeft: 8
  }
}));
const CardActions$1 = /*#__PURE__*/React$20.forwardRef(function CardActions(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1m.useDefaultProps)({
    props: inProps,
    name: 'MuiCardActions'
  });
  const {
      disableSpacing = false,
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1z.default)(props, _excluded$21);
  const ownerState = (0, _extends2$1E.default)({}, props, {
    disableSpacing
  });
  const classes = useUtilityClasses$1m(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1W.jsx)(CardActionsRoot, (0, _extends2$1E.default)({
    className: (0, _clsx$1V.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? CardActions$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$25.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$25.default.object,
  /**
   * @ignore
   */
  className: _propTypes$25.default.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: _propTypes$25.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$25.default.oneOfType([_propTypes$25.default.arrayOf(_propTypes$25.default.oneOfType([_propTypes$25.default.func, _propTypes$25.default.object, _propTypes$25.default.bool])), _propTypes$25.default.func, _propTypes$25.default.object])
} : void 0;
CardActions$2.default = CardActions$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  cardActionsClasses: true
};
Object.defineProperty(exports, "cardActionsClasses", {
  enumerable: true,
  get: function () {
    return _cardActionsClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CardActions.default;
  }
});
var _CardActions = _interopRequireDefault(CardActions$2);
var _cardActionsClasses = _interopRequireWildcard(cardActionsClasses$1);
Object.keys(_cardActionsClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _cardActionsClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cardActionsClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(CardActions$3));

var CardContent$2 = {};

var CardContent$1 = {};

var cardContentClasses$1 = {};

var _interopRequireDefault$6M = interopRequireDefault$1.exports;
Object.defineProperty(cardContentClasses$1, "__esModule", {
  value: true
});
cardContentClasses$1.default = void 0;
cardContentClasses$1.getCardContentUtilityClass = getCardContentUtilityClass;
var _generateUtilityClasses$1j = _interopRequireDefault$6M(generateUtilityClasses$3);
var _generateUtilityClass$1j = _interopRequireDefault$6M(generateUtilityClass$3);
function getCardContentUtilityClass(slot) {
  return (0, _generateUtilityClass$1j.default)('MuiCardContent', slot);
}
const cardContentClasses = (0, _generateUtilityClasses$1j.default)('MuiCardContent', ['root']);
cardContentClasses$1.default = cardContentClasses;

var _interopRequireDefault$6L = interopRequireDefault$1.exports;
Object.defineProperty(CardContent$1, "__esModule", {
  value: true
});
CardContent$1.default = void 0;
var _extends2$1D = _interopRequireDefault$6L(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1y = _interopRequireDefault$6L(objectWithoutPropertiesLoose.exports);
var React$1$ = _interopRequireWildcard$3a(React__default$4);
var _propTypes$24 = _interopRequireDefault$6L(propTypes.exports);
var _clsx$1U = _interopRequireDefault$6L(clsx.exports);
var _composeClasses$1k = _interopRequireDefault$6L(composeClasses$2);
var _styled$1k = _interopRequireDefault$6L(styled$2);
var _DefaultPropsProvider$1l = DefaultPropsProvider$5;
var _cardContentClasses = cardContentClasses$1;
var _jsxRuntime$1V = require$$11;
const _excluded$20 = ["className", "component"];
function _getRequireWildcardCache$2V(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2V = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3a(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2V(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1l = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$1k.default)(slots, _cardContentClasses.getCardContentUtilityClass, classes);
};
const CardContentRoot = (0, _styled$1k.default)('div', {
  name: 'MuiCardContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  };
});
const CardContent = /*#__PURE__*/React$1$.forwardRef(function CardContent(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1l.useDefaultProps)({
    props: inProps,
    name: 'MuiCardContent'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1y.default)(props, _excluded$20);
  const ownerState = (0, _extends2$1D.default)({}, props, {
    component
  });
  const classes = useUtilityClasses$1l(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1V.jsx)(CardContentRoot, (0, _extends2$1D.default)({
    as: component,
    className: (0, _clsx$1U.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? CardContent.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$24.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$24.default.object,
  /**
   * @ignore
   */
  className: _propTypes$24.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$24.default.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$24.default.oneOfType([_propTypes$24.default.arrayOf(_propTypes$24.default.oneOfType([_propTypes$24.default.func, _propTypes$24.default.object, _propTypes$24.default.bool])), _propTypes$24.default.func, _propTypes$24.default.object])
} : void 0;
CardContent$1.default = CardContent;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  cardContentClasses: true
};
Object.defineProperty(exports, "cardContentClasses", {
  enumerable: true,
  get: function () {
    return _cardContentClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CardContent.default;
  }
});
var _CardContent = _interopRequireDefault(CardContent$1);
var _cardContentClasses = _interopRequireWildcard(cardContentClasses$1);
Object.keys(_cardContentClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _cardContentClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cardContentClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(CardContent$2));

var CardHeader$2 = {};

var CardHeader$1 = {};

var cardHeaderClasses$1 = {};

var _interopRequireDefault$6K = interopRequireDefault$1.exports;
Object.defineProperty(cardHeaderClasses$1, "__esModule", {
  value: true
});
cardHeaderClasses$1.default = void 0;
cardHeaderClasses$1.getCardHeaderUtilityClass = getCardHeaderUtilityClass;
var _generateUtilityClasses$1i = _interopRequireDefault$6K(generateUtilityClasses$3);
var _generateUtilityClass$1i = _interopRequireDefault$6K(generateUtilityClass$3);
function getCardHeaderUtilityClass(slot) {
  return (0, _generateUtilityClass$1i.default)('MuiCardHeader', slot);
}
const cardHeaderClasses = (0, _generateUtilityClasses$1i.default)('MuiCardHeader', ['root', 'avatar', 'action', 'content', 'title', 'subheader']);
cardHeaderClasses$1.default = cardHeaderClasses;

var _interopRequireDefault$6J = interopRequireDefault$1.exports;
Object.defineProperty(CardHeader$1, "__esModule", {
  value: true
});
CardHeader$1.default = void 0;
var _objectWithoutPropertiesLoose2$1x = _interopRequireDefault$6J(objectWithoutPropertiesLoose.exports);
var _extends2$1C = _interopRequireDefault$6J(_extends$19.exports);
var React$1_ = _interopRequireWildcard$39(React__default$4);
var _propTypes$23 = _interopRequireDefault$6J(propTypes.exports);
var _clsx$1T = _interopRequireDefault$6J(clsx.exports);
var _composeClasses$1j = _interopRequireDefault$6J(composeClasses$2);
var _Typography$6 = _interopRequireDefault$6J(Typography$3);
var _DefaultPropsProvider$1k = DefaultPropsProvider$5;
var _styled$1j = _interopRequireDefault$6J(styled$2);
var _cardHeaderClasses = _interopRequireWildcard$39(cardHeaderClasses$1);
var _jsxRuntime$1U = require$$11;
const _excluded$1$ = ["action", "avatar", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"];
function _getRequireWildcardCache$2U(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2U = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$39(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2U(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1k = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    avatar: ['avatar'],
    action: ['action'],
    content: ['content'],
    title: ['title'],
    subheader: ['subheader']
  };
  return (0, _composeClasses$1j.default)(slots, _cardHeaderClasses.getCardHeaderUtilityClass, classes);
};
const CardHeaderRoot = (0, _styled$1j.default)('div', {
  name: 'MuiCardHeader',
  slot: 'Root',
  overridesResolver: (props, styles) => (0, _extends2$1C.default)({
    [`& .${_cardHeaderClasses.default.title}`]: styles.title,
    [`& .${_cardHeaderClasses.default.subheader}`]: styles.subheader
  }, styles.root)
})({
  display: 'flex',
  alignItems: 'center',
  padding: 16
});
const CardHeaderAvatar = (0, _styled$1j.default)('div', {
  name: 'MuiCardHeader',
  slot: 'Avatar',
  overridesResolver: (props, styles) => styles.avatar
})({
  display: 'flex',
  flex: '0 0 auto',
  marginRight: 16
});
const CardHeaderAction = (0, _styled$1j.default)('div', {
  name: 'MuiCardHeader',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  flex: '0 0 auto',
  alignSelf: 'flex-start',
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
});
const CardHeaderContent = (0, _styled$1j.default)('div', {
  name: 'MuiCardHeader',
  slot: 'Content',
  overridesResolver: (props, styles) => styles.content
})({
  flex: '1 1 auto'
});
const CardHeader = /*#__PURE__*/React$1_.forwardRef(function CardHeader(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1k.useDefaultProps)({
    props: inProps,
    name: 'MuiCardHeader'
  });
  const {
      action,
      avatar,
      className,
      component = 'div',
      disableTypography = false,
      subheader: subheaderProp,
      subheaderTypographyProps,
      title: titleProp,
      titleTypographyProps
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1x.default)(props, _excluded$1$);
  const ownerState = (0, _extends2$1C.default)({}, props, {
    component,
    disableTypography
  });
  const classes = useUtilityClasses$1k(ownerState);
  let title = titleProp;
  if (title != null && title.type !== _Typography$6.default && !disableTypography) {
    title = /*#__PURE__*/(0, _jsxRuntime$1U.jsx)(_Typography$6.default, (0, _extends2$1C.default)({
      variant: avatar ? 'body2' : 'h5',
      className: classes.title,
      component: "span",
      display: "block"
    }, titleTypographyProps, {
      children: title
    }));
  }
  let subheader = subheaderProp;
  if (subheader != null && subheader.type !== _Typography$6.default && !disableTypography) {
    subheader = /*#__PURE__*/(0, _jsxRuntime$1U.jsx)(_Typography$6.default, (0, _extends2$1C.default)({
      variant: avatar ? 'body2' : 'body1',
      className: classes.subheader,
      color: "text.secondary",
      component: "span",
      display: "block"
    }, subheaderTypographyProps, {
      children: subheader
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime$1U.jsxs)(CardHeaderRoot, (0, _extends2$1C.default)({
    className: (0, _clsx$1T.default)(classes.root, className),
    as: component,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [avatar && /*#__PURE__*/(0, _jsxRuntime$1U.jsx)(CardHeaderAvatar, {
      className: classes.avatar,
      ownerState: ownerState,
      children: avatar
    }), /*#__PURE__*/(0, _jsxRuntime$1U.jsxs)(CardHeaderContent, {
      className: classes.content,
      ownerState: ownerState,
      children: [title, subheader]
    }), action && /*#__PURE__*/(0, _jsxRuntime$1U.jsx)(CardHeaderAction, {
      className: classes.action,
      ownerState: ownerState,
      children: action
    })]
  }));
});
process.env.NODE_ENV !== "production" ? CardHeader.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display in the card header.
   */
  action: _propTypes$23.default.node,
  /**
   * The Avatar element to display.
   */
  avatar: _propTypes$23.default.node,
  /**
   * @ignore
   */
  children: _propTypes$23.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$23.default.object,
  /**
   * @ignore
   */
  className: _propTypes$23.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$23.default.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: _propTypes$23.default.bool,
  /**
   * The content of the component.
   */
  subheader: _propTypes$23.default.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: _propTypes$23.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$23.default.oneOfType([_propTypes$23.default.arrayOf(_propTypes$23.default.oneOfType([_propTypes$23.default.func, _propTypes$23.default.object, _propTypes$23.default.bool])), _propTypes$23.default.func, _propTypes$23.default.object]),
  /**
   * The content of the component.
   */
  title: _propTypes$23.default.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: _propTypes$23.default.object
} : void 0;
CardHeader$1.default = CardHeader;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  cardHeaderClasses: true
};
Object.defineProperty(exports, "cardHeaderClasses", {
  enumerable: true,
  get: function () {
    return _cardHeaderClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CardHeader.default;
  }
});
var _CardHeader = _interopRequireDefault(CardHeader$1);
var _cardHeaderClasses = _interopRequireWildcard(cardHeaderClasses$1);
Object.keys(_cardHeaderClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _cardHeaderClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cardHeaderClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(CardHeader$2));

var CardMedia$2 = {};

var CardMedia$1 = {};

var cardMediaClasses$1 = {};

var _interopRequireDefault$6I = interopRequireDefault$1.exports;
Object.defineProperty(cardMediaClasses$1, "__esModule", {
  value: true
});
cardMediaClasses$1.default = void 0;
cardMediaClasses$1.getCardMediaUtilityClass = getCardMediaUtilityClass;
var _generateUtilityClasses$1h = _interopRequireDefault$6I(generateUtilityClasses$3);
var _generateUtilityClass$1h = _interopRequireDefault$6I(generateUtilityClass$3);
function getCardMediaUtilityClass(slot) {
  return (0, _generateUtilityClass$1h.default)('MuiCardMedia', slot);
}
const cardMediaClasses = (0, _generateUtilityClasses$1h.default)('MuiCardMedia', ['root', 'media', 'img']);
cardMediaClasses$1.default = cardMediaClasses;

var _interopRequireDefault$6H = interopRequireDefault$1.exports;
Object.defineProperty(CardMedia$1, "__esModule", {
  value: true
});
CardMedia$1.default = void 0;
var _objectWithoutPropertiesLoose2$1w = _interopRequireDefault$6H(objectWithoutPropertiesLoose.exports);
var _extends2$1B = _interopRequireDefault$6H(_extends$19.exports);
var React$1Z = _interopRequireWildcard$38(React__default$4);
var _propTypes$22 = _interopRequireDefault$6H(propTypes.exports);
var _clsx$1S = _interopRequireDefault$6H(clsx.exports);
var _chainPropTypes$7 = _interopRequireDefault$6H(chainPropTypes$2);
var _composeClasses$1i = _interopRequireDefault$6H(composeClasses$2);
var _DefaultPropsProvider$1j = DefaultPropsProvider$5;
var _styled$1i = _interopRequireDefault$6H(styled$2);
var _cardMediaClasses = cardMediaClasses$1;
var _jsxRuntime$1T = require$$11;
const _excluded$1_ = ["children", "className", "component", "image", "src", "style"];
function _getRequireWildcardCache$2T(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2T = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$38(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2T(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1j = ownerState => {
  const {
    classes,
    isMediaComponent,
    isImageComponent
  } = ownerState;
  const slots = {
    root: ['root', isMediaComponent && 'media', isImageComponent && 'img']
  };
  return (0, _composeClasses$1i.default)(slots, _cardMediaClasses.getCardMediaUtilityClass, classes);
};
const CardMediaRoot = (0, _styled$1i.default)('div', {
  name: 'MuiCardMedia',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      isMediaComponent,
      isImageComponent
    } = ownerState;
    return [styles.root, isMediaComponent && styles.media, isImageComponent && styles.img];
  }
})(({
  ownerState
}) => (0, _extends2$1B.default)({
  display: 'block',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center'
}, ownerState.isMediaComponent && {
  width: '100%'
}, ownerState.isImageComponent && {
  // ⚠️ object-fit is not supported by IE11.
  objectFit: 'cover'
}));
const MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
const IMAGE_COMPONENTS = ['picture', 'img'];
const CardMedia = /*#__PURE__*/React$1Z.forwardRef(function CardMedia(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1j.useDefaultProps)({
    props: inProps,
    name: 'MuiCardMedia'
  });
  const {
      children,
      className,
      component = 'div',
      image,
      src,
      style
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1w.default)(props, _excluded$1_);
  const isMediaComponent = MEDIA_COMPONENTS.indexOf(component) !== -1;
  const composedStyle = !isMediaComponent && image ? (0, _extends2$1B.default)({
    backgroundImage: `url("${image}")`
  }, style) : style;
  const ownerState = (0, _extends2$1B.default)({}, props, {
    component,
    isMediaComponent,
    isImageComponent: IMAGE_COMPONENTS.indexOf(component) !== -1
  });
  const classes = useUtilityClasses$1j(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1T.jsx)(CardMediaRoot, (0, _extends2$1B.default)({
    className: (0, _clsx$1S.default)(classes.root, className),
    as: component,
    role: !isMediaComponent && image ? 'img' : undefined,
    ref: ref,
    style: composedStyle,
    ownerState: ownerState,
    src: isMediaComponent ? image || src : undefined
  }, other, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? CardMedia.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: (0, _chainPropTypes$7.default)(_propTypes$22.default.node, props => {
    if (!props.children && !props.image && !props.src && !props.component) {
      return new Error('MUI: Either `children`, `image`, `src` or `component` prop must be specified.');
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$22.default.object,
  /**
   * @ignore
   */
  className: _propTypes$22.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$22.default.elementType,
  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: _propTypes$22.default.string,
  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: _propTypes$22.default.string,
  /**
   * @ignore
   */
  style: _propTypes$22.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$22.default.oneOfType([_propTypes$22.default.arrayOf(_propTypes$22.default.oneOfType([_propTypes$22.default.func, _propTypes$22.default.object, _propTypes$22.default.bool])), _propTypes$22.default.func, _propTypes$22.default.object])
} : void 0;
CardMedia$1.default = CardMedia;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  cardMediaClasses: true
};
Object.defineProperty(exports, "cardMediaClasses", {
  enumerable: true,
  get: function () {
    return _cardMediaClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CardMedia.default;
  }
});
var _CardMedia = _interopRequireDefault(CardMedia$1);
var _cardMediaClasses = _interopRequireWildcard(cardMediaClasses$1);
Object.keys(_cardMediaClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _cardMediaClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cardMediaClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(CardMedia$2));

var Checkbox$3 = {};

var Checkbox$2 = {};

var SwitchBase$1 = {};

var switchBaseClasses$1 = {};

var _interopRequireDefault$6G = interopRequireDefault$1.exports;
Object.defineProperty(switchBaseClasses$1, "__esModule", {
  value: true
});
switchBaseClasses$1.default = void 0;
switchBaseClasses$1.getSwitchBaseUtilityClass = getSwitchBaseUtilityClass;
var _generateUtilityClasses$1g = _interopRequireDefault$6G(generateUtilityClasses$3);
var _generateUtilityClass$1g = _interopRequireDefault$6G(generateUtilityClass$3);
function getSwitchBaseUtilityClass(slot) {
  return (0, _generateUtilityClass$1g.default)('PrivateSwitchBase', slot);
}
const switchBaseClasses = (0, _generateUtilityClasses$1g.default)('PrivateSwitchBase', ['root', 'checked', 'disabled', 'input', 'edgeStart', 'edgeEnd']);
switchBaseClasses$1.default = switchBaseClasses;

var _interopRequireDefault$6F = interopRequireDefault$1.exports;
Object.defineProperty(SwitchBase$1, "__esModule", {
  value: true
});
SwitchBase$1.default = void 0;
var _objectWithoutPropertiesLoose2$1v = _interopRequireDefault$6F(objectWithoutPropertiesLoose.exports);
var _extends2$1A = _interopRequireDefault$6F(_extends$19.exports);
var React$1Y = _interopRequireWildcard$37(React__default$4);
var _propTypes$21 = _interopRequireDefault$6F(propTypes.exports);
var _clsx$1R = _interopRequireDefault$6F(clsx.exports);
var _refType$c = _interopRequireDefault$6F(refType$2);
var _composeClasses$1h = _interopRequireDefault$6F(composeClasses$2);
var _capitalize$z = _interopRequireDefault$6F(capitalize$1);
var _styled$1h = _interopRequireWildcard$37(styled$2);
var _useControlled$5 = _interopRequireDefault$6F(useControlled);
var _useFormControl$8 = _interopRequireDefault$6F(useFormControl$1);
var _ButtonBase$a = _interopRequireDefault$6F(ButtonBase$2);
var _switchBaseClasses = switchBaseClasses$1;
var _jsxRuntime$1S = require$$11;
const _excluded$1Z = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"];
function _getRequireWildcardCache$2S(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2S = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$37(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2S(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1i = ownerState => {
  const {
    classes,
    checked,
    disabled,
    edge
  } = ownerState;
  const slots = {
    root: ['root', checked && 'checked', disabled && 'disabled', edge && `edge${(0, _capitalize$z.default)(edge)}`],
    input: ['input']
  };
  return (0, _composeClasses$1h.default)(slots, _switchBaseClasses.getSwitchBaseUtilityClass, classes);
};
const SwitchBaseRoot = (0, _styled$1h.default)(_ButtonBase$a.default)(({
  ownerState
}) => (0, _extends2$1A.default)({
  padding: 9,
  borderRadius: '50%'
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}));
const SwitchBaseInput = (0, _styled$1h.default)('input', {
  shouldForwardProp: _styled$1h.rootShouldForwardProp
})({
  cursor: 'inherit',
  position: 'absolute',
  opacity: 0,
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
});

/**
 * @ignore - internal component.
 */
const SwitchBase = /*#__PURE__*/React$1Y.forwardRef(function SwitchBase(props, ref) {
  const {
      autoFocus,
      checked: checkedProp,
      checkedIcon,
      className,
      defaultChecked,
      disabled: disabledProp,
      disableFocusRipple = false,
      edge = false,
      icon,
      id,
      inputProps,
      inputRef,
      name,
      onBlur,
      onChange,
      onFocus,
      readOnly,
      required = false,
      tabIndex,
      type,
      value
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1v.default)(props, _excluded$1Z);
  const [checked, setCheckedState] = (0, _useControlled$5.default)({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  });
  const muiFormControl = (0, _useFormControl$8.default)();
  const handleFocus = event => {
    if (onFocus) {
      onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };
  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };
  const handleInputChange = event => {
    // Workaround for https://github.com/facebook/react/issues/9023
    if (event.nativeEvent.defaultPrevented) {
      return;
    }
    const newChecked = event.target.checked;
    setCheckedState(newChecked);
    if (onChange) {
      // TODO v6: remove the second argument.
      onChange(event, newChecked);
    }
  };
  let disabled = disabledProp;
  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }
  const hasLabelFor = type === 'checkbox' || type === 'radio';
  const ownerState = (0, _extends2$1A.default)({}, props, {
    checked,
    disabled,
    disableFocusRipple,
    edge
  });
  const classes = useUtilityClasses$1i(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1S.jsxs)(SwitchBaseRoot, (0, _extends2$1A.default)({
    component: "span",
    className: (0, _clsx$1R.default)(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/(0, _jsxRuntime$1S.jsx)(SwitchBaseInput, (0, _extends2$1A.default)({
      autoFocus: autoFocus,
      checked: checkedProp,
      defaultChecked: defaultChecked,
      className: classes.input,
      disabled: disabled,
      id: hasLabelFor ? id : undefined,
      name: name,
      onChange: handleInputChange,
      readOnly: readOnly,
      ref: inputRef,
      required: required,
      ownerState: ownerState,
      tabIndex: tabIndex,
      type: type
    }, type === 'checkbox' && value === undefined ? {} : {
      value
    }, inputProps)), checked ? checkedIcon : icon]
  }));
});

// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
process.env.NODE_ENV !== "production" ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: _propTypes$21.default.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes$21.default.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes$21.default.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$21.default.object,
  /**
   * @ignore
   */
  className: _propTypes$21.default.string,
  /**
   * @ignore
   */
  defaultChecked: _propTypes$21.default.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: _propTypes$21.default.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: _propTypes$21.default.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: _propTypes$21.default.oneOf(['end', 'start', false]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes$21.default.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: _propTypes$21.default.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _propTypes$21.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType$c.default,
  /*
   * @ignore
   */
  name: _propTypes$21.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes$21.default.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: _propTypes$21.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes$21.default.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes$21.default.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: _propTypes$21.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$21.default.object,
  /**
   * @ignore
   */
  tabIndex: _propTypes$21.default.oneOfType([_propTypes$21.default.number, _propTypes$21.default.string]),
  /**
   * The input component prop `type`.
   */
  type: _propTypes$21.default.string.isRequired,
  /**
   * The value of the component.
   */
  value: _propTypes$21.default.any
} : void 0;
SwitchBase$1.default = SwitchBase;

var CheckBoxOutlineBlank = {};

var _interopRequireDefault$6E = interopRequireDefault$1.exports;
Object.defineProperty(CheckBoxOutlineBlank, "__esModule", {
  value: true
});
CheckBoxOutlineBlank.default = void 0;
_interopRequireWildcard$36(React__default$4);
var _createSvgIcon$g = _interopRequireDefault$6E(createSvgIcon$2);
var _jsxRuntime$1R = require$$11;
function _getRequireWildcardCache$2R(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2R = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$36(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2R(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
CheckBoxOutlineBlank.default = (0, _createSvgIcon$g.default)( /*#__PURE__*/(0, _jsxRuntime$1R.jsx)("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

var CheckBox = {};

var _interopRequireDefault$6D = interopRequireDefault$1.exports;
Object.defineProperty(CheckBox, "__esModule", {
  value: true
});
CheckBox.default = void 0;
_interopRequireWildcard$35(React__default$4);
var _createSvgIcon$f = _interopRequireDefault$6D(createSvgIcon$2);
var _jsxRuntime$1Q = require$$11;
function _getRequireWildcardCache$2Q(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2Q = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$35(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2Q(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
CheckBox.default = (0, _createSvgIcon$f.default)( /*#__PURE__*/(0, _jsxRuntime$1Q.jsx)("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

var IndeterminateCheckBox = {};

var _interopRequireDefault$6C = interopRequireDefault$1.exports;
Object.defineProperty(IndeterminateCheckBox, "__esModule", {
  value: true
});
IndeterminateCheckBox.default = void 0;
_interopRequireWildcard$34(React__default$4);
var _createSvgIcon$e = _interopRequireDefault$6C(createSvgIcon$2);
var _jsxRuntime$1P = require$$11;
function _getRequireWildcardCache$2P(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2P = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$34(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2P(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
IndeterminateCheckBox.default = (0, _createSvgIcon$e.default)( /*#__PURE__*/(0, _jsxRuntime$1P.jsx)("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

var checkboxClasses$1 = {};

var _interopRequireDefault$6B = interopRequireDefault$1.exports;
Object.defineProperty(checkboxClasses$1, "__esModule", {
  value: true
});
checkboxClasses$1.default = void 0;
checkboxClasses$1.getCheckboxUtilityClass = getCheckboxUtilityClass;
var _generateUtilityClasses$1f = _interopRequireDefault$6B(generateUtilityClasses$3);
var _generateUtilityClass$1f = _interopRequireDefault$6B(generateUtilityClass$3);
function getCheckboxUtilityClass(slot) {
  return (0, _generateUtilityClass$1f.default)('MuiCheckbox', slot);
}
const checkboxClasses = (0, _generateUtilityClasses$1f.default)('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium']);
checkboxClasses$1.default = checkboxClasses;

var _interopRequireDefault$6A = interopRequireDefault$1.exports;
Object.defineProperty(Checkbox$2, "__esModule", {
  value: true
});
Checkbox$2.default = void 0;
var _objectWithoutPropertiesLoose2$1u = _interopRequireDefault$6A(objectWithoutPropertiesLoose.exports);
var _extends2$1z = _interopRequireDefault$6A(_extends$19.exports);
var React$1X = _interopRequireWildcard$33(React__default$4);
var _propTypes$20 = _interopRequireDefault$6A(propTypes.exports);
var _clsx$1Q = _interopRequireDefault$6A(clsx.exports);
var _refType$b = _interopRequireDefault$6A(refType$2);
var _composeClasses$1g = _interopRequireDefault$6A(composeClasses$2);
var _colorManipulator$f = colorManipulator;
var _SwitchBase$2 = _interopRequireDefault$6A(SwitchBase$1);
var _CheckBoxOutlineBlank = _interopRequireDefault$6A(CheckBoxOutlineBlank);
var _CheckBox = _interopRequireDefault$6A(CheckBox);
var _IndeterminateCheckBox = _interopRequireDefault$6A(IndeterminateCheckBox);
var _capitalize$y = _interopRequireDefault$6A(capitalize$1);
var _DefaultPropsProvider$1i = DefaultPropsProvider$5;
var _styled$1g = _interopRequireWildcard$33(styled$2);
var _checkboxClasses = _interopRequireWildcard$33(checkboxClasses$1);
var _jsxRuntime$1O = require$$11;
const _excluded$1Y = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"];
function _getRequireWildcardCache$2O(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2O = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$33(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2O(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1h = ownerState => {
  const {
    classes,
    indeterminate,
    color,
    size
  } = ownerState;
  const slots = {
    root: ['root', indeterminate && 'indeterminate', `color${(0, _capitalize$y.default)(color)}`, `size${(0, _capitalize$y.default)(size)}`]
  };
  const composedClasses = (0, _composeClasses$1g.default)(slots, _checkboxClasses.getCheckboxUtilityClass, classes);
  return (0, _extends2$1z.default)({}, classes, composedClasses);
};
const CheckboxRoot = (0, _styled$1g.default)(_SwitchBase$2.default, {
  shouldForwardProp: prop => (0, _styled$1g.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiCheckbox',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.indeterminate && styles.indeterminate, styles[`size${(0, _capitalize$y.default)(ownerState.size)}`], ownerState.color !== 'default' && styles[`color${(0, _capitalize$y.default)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1z.default)({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$f.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${_checkboxClasses.default.checked}, &.${_checkboxClasses.default.indeterminate}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${_checkboxClasses.default.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));
const defaultCheckedIcon$1 = /*#__PURE__*/(0, _jsxRuntime$1O.jsx)(_CheckBox.default, {});
const defaultIcon$2 = /*#__PURE__*/(0, _jsxRuntime$1O.jsx)(_CheckBoxOutlineBlank.default, {});
const defaultIndeterminateIcon = /*#__PURE__*/(0, _jsxRuntime$1O.jsx)(_IndeterminateCheckBox.default, {});
const Checkbox$1 = /*#__PURE__*/React$1X.forwardRef(function Checkbox(inProps, ref) {
  var _icon$props$fontSize, _indeterminateIcon$pr;
  const props = (0, _DefaultPropsProvider$1i.useDefaultProps)({
    props: inProps,
    name: 'MuiCheckbox'
  });
  const {
      checkedIcon = defaultCheckedIcon$1,
      color = 'primary',
      icon: iconProp = defaultIcon$2,
      indeterminate = false,
      indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
      inputProps,
      size = 'medium',
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1u.default)(props, _excluded$1Y);
  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  const ownerState = (0, _extends2$1z.default)({}, props, {
    color,
    indeterminate,
    size
  });
  const classes = useUtilityClasses$1h(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1O.jsx)(CheckboxRoot, (0, _extends2$1z.default)({
    type: "checkbox",
    inputProps: (0, _extends2$1z.default)({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/React$1X.cloneElement(icon, {
      fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
    }),
    checkedIcon: /*#__PURE__*/React$1X.cloneElement(indeterminateIcon, {
      fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
    }),
    ownerState: ownerState,
    ref: ref,
    className: (0, _clsx$1Q.default)(classes.root, className)
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? Checkbox$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes$20.default.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: _propTypes$20.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$20.default.object,
  /**
   * @ignore
   */
  className: _propTypes$20.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$20.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$20.default.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$20.default.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: _propTypes$20.default.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$20.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: _propTypes$20.default.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: _propTypes$20.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes$20.default.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: _propTypes$20.default.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: _propTypes$20.default.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _propTypes$20.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType$b.default,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: _propTypes$20.default.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: _propTypes$20.default.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: _propTypes$20.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$20.default.oneOf(['medium', 'small']), _propTypes$20.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$20.default.oneOfType([_propTypes$20.default.arrayOf(_propTypes$20.default.oneOfType([_propTypes$20.default.func, _propTypes$20.default.object, _propTypes$20.default.bool])), _propTypes$20.default.func, _propTypes$20.default.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: _propTypes$20.default.any
} : void 0;
Checkbox$2.default = Checkbox$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  checkboxClasses: true
};
Object.defineProperty(exports, "checkboxClasses", {
  enumerable: true,
  get: function () {
    return _checkboxClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Checkbox.default;
  }
});
var _Checkbox = _interopRequireDefault(Checkbox$2);
var _checkboxClasses = _interopRequireWildcard(checkboxClasses$1);
Object.keys(_checkboxClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _checkboxClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _checkboxClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Checkbox$3));

var CircularProgress$4 = {};

var CircularProgress$3 = {};

var circularProgressClasses$1 = {};

var _interopRequireDefault$6z = interopRequireDefault$1.exports;
Object.defineProperty(circularProgressClasses$1, "__esModule", {
  value: true
});
circularProgressClasses$1.default = void 0;
circularProgressClasses$1.getCircularProgressUtilityClass = getCircularProgressUtilityClass;
var _generateUtilityClasses$1e = _interopRequireDefault$6z(generateUtilityClasses$3);
var _generateUtilityClass$1e = _interopRequireDefault$6z(generateUtilityClass$3);
function getCircularProgressUtilityClass(slot) {
  return (0, _generateUtilityClass$1e.default)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0, _generateUtilityClasses$1e.default)('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);
circularProgressClasses$1.default = circularProgressClasses;

var _interopRequireDefault$6y = interopRequireDefault$1.exports;
Object.defineProperty(CircularProgress$3, "__esModule", {
  value: true
});
CircularProgress$3.default = void 0;
var _objectWithoutPropertiesLoose2$1t = _interopRequireDefault$6y(objectWithoutPropertiesLoose.exports);
var _extends2$1y = _interopRequireDefault$6y(_extends$19.exports);
var React$1W = _interopRequireWildcard$32(React__default$4);
var _propTypes$1$ = _interopRequireDefault$6y(propTypes.exports);
var _clsx$1P = _interopRequireDefault$6y(clsx.exports);
var _chainPropTypes$6 = _interopRequireDefault$6y(chainPropTypes$2);
var _composeClasses$1f = _interopRequireDefault$6y(composeClasses$2);
var _system$6 = system;
var _capitalize$x = _interopRequireDefault$6y(capitalize$1);
var _DefaultPropsProvider$1h = DefaultPropsProvider$5;
var _styled$1f = _interopRequireDefault$6y(styled$2);
var _circularProgressClasses = circularProgressClasses$1;
var _jsxRuntime$1N = require$$11;
const _excluded$1X = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
function _getRequireWildcardCache$2N(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2N = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$32(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2N(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SIZE$1 = 44;
const circularRotateKeyframe = (0, _system$6.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const circularDashKeyframe = (0, _system$6.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`;
const useUtilityClasses$1g = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${(0, _capitalize$x.default)(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${(0, _capitalize$x.default)(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return (0, _composeClasses$1f.default)(slots, _circularProgressClasses.getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = (0, _styled$1f.default)('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${(0, _capitalize$x.default)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => (0, _extends2$1y.default)({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: (theme.vars || theme).palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && (0, _system$6.css)`
      animation: ${circularRotateKeyframe} 1.4s linear infinite;
    `);
const CircularProgressSVG = (0, _styled$1f.default)('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered
});
const CircularProgressCircle = (0, _styled$1f.default)('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${(0, _capitalize$x.default)(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => (0, _extends2$1y.default)({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, _system$6.css)`
      animation: ${circularDashKeyframe} 1.4s ease-in-out infinite;
    `);

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const CircularProgress$2 = /*#__PURE__*/React$1W.forwardRef(function CircularProgress(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1h.useDefaultProps)({
    props: inProps,
    name: 'MuiCircularProgress'
  });
  const {
      className,
      color = 'primary',
      disableShrink = false,
      size = 40,
      style,
      thickness = 3.6,
      value = 0,
      variant = 'indeterminate'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1t.default)(props, _excluded$1X);
  const ownerState = (0, _extends2$1y.default)({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });
  const classes = useUtilityClasses$1g(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE$1 - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }
  return /*#__PURE__*/(0, _jsxRuntime$1N.jsx)(CircularProgressRoot, (0, _extends2$1y.default)({
    className: (0, _clsx$1P.default)(classes.root, className),
    style: (0, _extends2$1y.default)({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$1N.jsx)(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE$1 / 2} ${SIZE$1 / 2} ${SIZE$1} ${SIZE$1}`,
      children: /*#__PURE__*/(0, _jsxRuntime$1N.jsx)(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE$1,
        cy: SIZE$1,
        r: (SIZE$1 - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
process.env.NODE_ENV !== "production" ? CircularProgress$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1$.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1$.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$1$.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1$.default.oneOf(['inherit', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$1$.default.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: (0, _chainPropTypes$6.default)(_propTypes$1$.default.bool, props => {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('MUI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }
    return null;
  }),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: _propTypes$1$.default.oneOfType([_propTypes$1$.default.number, _propTypes$1$.default.string]),
  /**
   * @ignore
   */
  style: _propTypes$1$.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1$.default.oneOfType([_propTypes$1$.default.arrayOf(_propTypes$1$.default.oneOfType([_propTypes$1$.default.func, _propTypes$1$.default.object, _propTypes$1$.default.bool])), _propTypes$1$.default.func, _propTypes$1$.default.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: _propTypes$1$.default.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: _propTypes$1$.default.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: _propTypes$1$.default.oneOf(['determinate', 'indeterminate'])
} : void 0;
CircularProgress$3.default = CircularProgress$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  circularProgressClasses: true
};
Object.defineProperty(exports, "circularProgressClasses", {
  enumerable: true,
  get: function () {
    return _circularProgressClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CircularProgress.default;
  }
});
var _CircularProgress = _interopRequireDefault(CircularProgress$3);
var _circularProgressClasses = _interopRequireWildcard(circularProgressClasses$1);
Object.keys(_circularProgressClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _circularProgressClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _circularProgressClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(CircularProgress$4));

var CircularProgress$1 = /*@__PURE__*/getDefaultExportFromCjs$1(CircularProgress$4);

var ClickAwayListener$2 = {};

var ClickAwayListener$1 = {};

var _interopRequireDefault$6x = interopRequireDefault$1.exports;
Object.defineProperty(ClickAwayListener$1, "__esModule", {
  value: true
});
ClickAwayListener$1.ClickAwayListener = ClickAwayListener;
var React$1V = _interopRequireWildcard$31(React__default$4);
var _propTypes$1_ = _interopRequireDefault$6x(propTypes.exports);
var _utils$M = utils$7;
var _getReactElementRef$5 = _interopRequireDefault$6x(getReactElementRef$2);
var _jsxRuntime$1M = require$$11;
function _getRequireWildcardCache$2M(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2M = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$31(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2M(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}
function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */
function ClickAwayListener(props) {
  const {
    children,
    disableReactTree = false,
    mouseEvent = 'onClick',
    onClickAway,
    touchEvent = 'onTouchEnd'
  } = props;
  const movedRef = React$1V.useRef(false);
  const nodeRef = React$1V.useRef(null);
  const activatedRef = React$1V.useRef(false);
  const syntheticEventRef = React$1V.useRef(false);
  React$1V.useEffect(() => {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(() => {
      activatedRef.current = true;
    }, 0);
    return () => {
      activatedRef.current = false;
    };
  }, []);
  const handleRef = (0, _utils$M.unstable_useForkRef)((0, _getReactElementRef$5.default)(children), nodeRef);

  // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviors like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.
  const handleClickAway = (0, _utils$M.unstable_useEventCallback)(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = (0, _utils$M.unstable_ownerDocument)(nodeRef.current);

    // 1. IE11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.
    if (!activatedRef.current || !nodeRef.current || 'clientX' in event && clickedRootScrollbar(event, doc)) {
      return;
    }

    // Do not act if user performed touchmove
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    let insideDOM;

    // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target) || nodeRef.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target);
    }
    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  });

  // Keep track of mouse/touch events that bubbled up through the portal.
  const createHandleSynthetic = handlerName => event => {
    syntheticEventRef.current = true;
    const childrenPropsHandler = children.props[handlerName];
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  const childrenProps = {
    ref: handleRef
  };
  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }
  React$1V.useEffect(() => {
    if (touchEvent !== false) {
      const mappedTouchEvent = mapEventPropToEvent(touchEvent);
      const doc = (0, _utils$M.unstable_ownerDocument)(nodeRef.current);
      const handleTouchMove = () => {
        movedRef.current = true;
      };
      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return () => {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }
    return undefined;
  }, [handleClickAway, touchEvent]);
  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }
  React$1V.useEffect(() => {
    if (mouseEvent !== false) {
      const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      const doc = (0, _utils$M.unstable_ownerDocument)(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return () => {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }
    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/(0, _jsxRuntime$1M.jsx)(React$1V.Fragment, {
    children: /*#__PURE__*/React$1V.cloneElement(children, childrenProps)
  });
}
process.env.NODE_ENV !== "production" ? ClickAwayListener.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: _utils$M.elementAcceptingRef.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: _propTypes$1_.default.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: _propTypes$1_.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', 'onPointerDown', 'onPointerUp', false]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: _propTypes$1_.default.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: _propTypes$1_.default.oneOf(['onTouchEnd', 'onTouchStart', false])
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  ClickAwayListener['propTypes' + ''] = (0, _utils$M.exactProp)(ClickAwayListener.propTypes);
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ClickAwayListener.ClickAwayListener;
  }
});
var _ClickAwayListener = ClickAwayListener$1;
}(ClickAwayListener$2));

var Container$2 = {};

var Container$1 = {};

var _interopRequireDefault$6w = interopRequireDefault$1.exports;
Object.defineProperty(Container$1, "__esModule", {
  value: true
});
Container$1.default = void 0;
var _propTypes$1Z = _interopRequireDefault$6w(propTypes.exports);
var _system$5 = system;
var _capitalize$w = _interopRequireDefault$6w(capitalize$1);
var _styled$1e = _interopRequireDefault$6w(styled$2);
var _DefaultPropsProvider$1g = DefaultPropsProvider$5;
const Container = (0, _system$5.createContainer)({
  createStyledComponent: (0, _styled$1e.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles) => {
      const {
        ownerState
      } = props;
      return [styles.root, styles[`maxWidth${(0, _capitalize$w.default)(String(ownerState.maxWidth))}`], ownerState.fixed && styles.fixed, ownerState.disableGutters && styles.disableGutters];
    }
  }),
  useThemeProps: inProps => (0, _DefaultPropsProvider$1g.useDefaultProps)({
    props: inProps,
    name: 'MuiContainer'
  })
});
process.env.NODE_ENV !== "production" ? Container.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: _propTypes$1Z.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1Z.default.object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1Z.default.elementType,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: _propTypes$1Z.default.bool,
  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */
  fixed: _propTypes$1Z.default.bool,
  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */
  maxWidth: _propTypes$1Z.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1Z.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]), _propTypes$1Z.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1Z.default.oneOfType([_propTypes$1Z.default.arrayOf(_propTypes$1Z.default.oneOfType([_propTypes$1Z.default.func, _propTypes$1Z.default.object, _propTypes$1Z.default.bool])), _propTypes$1Z.default.func, _propTypes$1Z.default.object])
} : void 0;
Container$1.default = Container;

var containerClasses$1 = {};

var _interopRequireDefault$6v = interopRequireDefault$1.exports;
Object.defineProperty(containerClasses$1, "__esModule", {
  value: true
});
containerClasses$1.default = void 0;
containerClasses$1.getContainerUtilityClass = getContainerUtilityClass;
var _generateUtilityClasses$1d = _interopRequireDefault$6v(generateUtilityClasses$3);
var _generateUtilityClass$1d = _interopRequireDefault$6v(generateUtilityClass$3);
function getContainerUtilityClass(slot) {
  return (0, _generateUtilityClass$1d.default)('MuiContainer', slot);
}
const containerClasses = (0, _generateUtilityClasses$1d.default)('MuiContainer', ['root', 'disableGutters', 'fixed', 'maxWidthXs', 'maxWidthSm', 'maxWidthMd', 'maxWidthLg', 'maxWidthXl']);
containerClasses$1.default = containerClasses;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  containerClasses: true
};
Object.defineProperty(exports, "containerClasses", {
  enumerable: true,
  get: function () {
    return _containerClasses.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Container.default;
  }
});
var _Container = _interopRequireDefault(Container$1);
var _containerClasses = _interopRequireWildcard(containerClasses$1);
Object.keys(_containerClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _containerClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _containerClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Container$2));

var CssBaseline$2 = {};

var CssBaseline$1 = {};

var _interopRequireDefault$6u = interopRequireDefault$1.exports;
Object.defineProperty(CssBaseline$1, "__esModule", {
  value: true
});
CssBaseline$1.styles = CssBaseline$1.html = CssBaseline$1.default = CssBaseline$1.body = void 0;
var _extends2$1x = _interopRequireDefault$6u(_extends$19.exports);
var React$1U = _interopRequireWildcard$30(React__default$4);
var _propTypes$1Y = _interopRequireDefault$6u(propTypes.exports);
var _DefaultPropsProvider$1f = DefaultPropsProvider$5;
var _GlobalStyles = _interopRequireDefault$6u(GlobalStyles$2);
var _jsxRuntime$1L = require$$11;
function _getRequireWildcardCache$2L(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2L = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$30(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2L(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const html = (theme, enableColorScheme) => (0, _extends2$1x.default)({
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  MozOsxFontSmoothing: 'grayscale',
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box',
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: '100%'
}, enableColorScheme && !theme.vars && {
  colorScheme: theme.palette.mode
});
CssBaseline$1.html = html;
const body = theme => (0, _extends2$1x.default)({
  color: (theme.vars || theme).palette.text.primary
}, theme.typography.body1, {
  backgroundColor: (theme.vars || theme).palette.background.default,
  '@media print': {
    // Save printer ink.
    backgroundColor: (theme.vars || theme).palette.common.white
  }
});
CssBaseline$1.body = body;
const styles$r = (theme, enableColorScheme = false) => {
  var _theme$components;
  const colorSchemeStyles = {};
  if (enableColorScheme && theme.colorSchemes) {
    Object.entries(theme.colorSchemes).forEach(([key, scheme]) => {
      var _scheme$palette;
      colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
        colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
      };
    });
  }
  let defaultStyles = (0, _extends2$1x.default)({
    html: html(theme, enableColorScheme),
    '*, *::before, *::after': {
      boxSizing: 'inherit'
    },
    'strong, b': {
      fontWeight: theme.typography.fontWeightBold
    },
    body: (0, _extends2$1x.default)({
      margin: 0
    }, body(theme), {
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      '&::backdrop': {
        backgroundColor: (theme.vars || theme).palette.background.default
      }
    })
  }, colorSchemeStyles);
  const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
  if (themeOverrides) {
    defaultStyles = [defaultStyles, themeOverrides];
  }
  return defaultStyles;
};

/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */
CssBaseline$1.styles = styles$r;
function CssBaseline(inProps) {
  const props = (0, _DefaultPropsProvider$1f.useDefaultProps)({
    props: inProps,
    name: 'MuiCssBaseline'
  });
  const {
    children,
    enableColorScheme = false
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime$1L.jsxs)(React$1U.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime$1L.jsx)(_GlobalStyles.default, {
      styles: theme => styles$r(theme, enableColorScheme)
    }), children]
  });
}
process.env.NODE_ENV !== "production" ? CssBaseline.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: _propTypes$1Y.default.node,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */
  enableColorScheme: _propTypes$1Y.default.bool
} : void 0;
CssBaseline$1.default = CssBaseline;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _CssBaseline.default;
  }
});
var _CssBaseline = _interopRequireDefault(CssBaseline$1);
}(CssBaseline$2));

var darkScrollbar$1 = {};

Object.defineProperty(darkScrollbar$1, "__esModule", {
  value: true
});
darkScrollbar$1.default = darkScrollbar;
// track, thumb and active are derived from macOS 10.15.7
const scrollBar = {
  track: '#2b2b2b',
  thumb: '#6b6b6b',
  active: '#959595'
};
function darkScrollbar(options = scrollBar) {
  return {
    scrollbarColor: `${options.thumb} ${options.track}`,
    '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
      backgroundColor: options.track
    },
    '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
      borderRadius: 8,
      backgroundColor: options.thumb,
      minHeight: 24,
      border: `3px solid ${options.track}`
    },
    '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
      backgroundColor: options.active
    },
    '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
      backgroundColor: options.active
    },
    '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
      backgroundColor: options.active
    },
    '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
      backgroundColor: options.track
    }
  };
}

var Dialog$4 = {};

var Dialog$3 = {};

var Modal$2 = {};

var ModalManager$1 = {};

Object.defineProperty(ModalManager$1, "__esModule", {
  value: true
});
ModalManager$1.ModalManager = void 0;
ModalManager$1.ariaHidden = ariaHidden;
var _utils$L = utils$7;
// Is a vertical scrollbar displayed?
function isOverflowing(container) {
  const doc = (0, _utils$L.unstable_ownerDocument)(container);
  if (doc.body === container) {
    return (0, _utils$L.unstable_ownerWindow)(container).innerWidth > doc.documentElement.clientWidth;
  }
  return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
  if (show) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
}
function getPaddingRight(element) {
  return parseInt((0, _utils$L.unstable_ownerWindow)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
  // The forbidden HTML tags are the ones from ARIA specification that
  // can be children of body and can't have aria-hidden attribute.
  // cf. https://www.w3.org/TR/html-aria/#docconformance
  const forbiddenTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE', 'LINK', 'MAP', 'META', 'NOSCRIPT', 'PICTURE', 'COL', 'COLGROUP', 'PARAM', 'SLOT', 'SOURCE', 'TRACK'];
  const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
  const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
  return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  [].forEach.call(container.children, element => {
    const isNotExcludedElement = blacklist.indexOf(element) === -1;
    const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
    if (isNotExcludedElement && isNotForbiddenElement) {
      ariaHidden(element, show);
    }
  });
}
function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index) => {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}
function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;
  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      const scrollbarSize = (0, _utils$L.unstable_getScrollbarSize)((0, _utils$L.unstable_ownerDocument)(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: 'padding-right',
        el: container
      });
      // Use computed style, here to get the real padding to add our scrollbar width.
      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;

      // .mui-fixed is a global helper.
      const fixedElements = (0, _utils$L.unstable_ownerDocument)(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedElements, element => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: 'padding-right',
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    }
    let scrollContainer;
    if (container.parentNode instanceof DocumentFragment) {
      scrollContainer = (0, _utils$L.unstable_ownerDocument)(container).body;
    } else {
      // Support html overflow-y: auto for scroll stability between pages
      // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
      const parent = container.parentElement;
      const containerWindow = (0, _utils$L.unstable_ownerWindow)(container);
      scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
    }

    // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.
    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: 'overflow',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: 'overflow-x',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: 'overflow-y',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }
  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property
    }) => {
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };
  return restore;
}
function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, element => {
    if (element.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
class ModalManager {
  constructor() {
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }
  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);
    if (modalIndex !== -1) {
      return modalIndex;
    }
    modalIndex = this.modals.length;
    this.modals.push(modal);

    // If the modal we are adding is already in the DOM.
    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }
    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, item => item.container === container);
    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }
    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }
  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }
  remove(modal, ariaHiddenState = true) {
    const modalIndex = this.modals.indexOf(modal);
    if (modalIndex === -1) {
      return modalIndex;
    }
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1);

    // If that was the last modal in a container, clean up the container.
    if (containerInfo.modals.length === 0) {
      // The modal might be closed before it had the chance to be mounted in the DOM.
      if (containerInfo.restore) {
        containerInfo.restore();
      }
      if (modal.modalRef) {
        // In case the modal wasn't in the DOM yet.
        ariaHidden(modal.modalRef, ariaHiddenState);
      }
      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      // Otherwise make sure the next top modal is visible to a screen reader.
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
      // as soon as a modal is adding its modalRef is undefined. it can't set
      // aria-hidden because the dom element doesn't exist either
      // when modal was unmounted before modalRef gets null
      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }
    return modalIndex;
  }
  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }
}
ModalManager$1.ModalManager = ModalManager;

var Modal$1 = {};

var Unstable_TrapFocus = {};

var FocusTrap$1 = {};

/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */
var _interopRequireDefault$6t = interopRequireDefault$1.exports;
Object.defineProperty(FocusTrap$1, "__esModule", {
  value: true
});
FocusTrap$1.default = void 0;
var React$1T = _interopRequireWildcard$2$(React__default$4);
var _propTypes$1X = _interopRequireDefault$6t(propTypes.exports);
var _utils$K = utils$7;
var _jsxRuntime$1K = require$$11;
function _getRequireWildcardCache$2K(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2K = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2$(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2K(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Inspired by https://github.com/focus-trap/tabbable
const candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');
function getTabIndex(node) {
  const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  }

  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.
  if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }
  return node.tabIndex;
}
function isNonTabbableRadio(node) {
  if (node.tagName !== 'INPUT' || node.type !== 'radio') {
    return false;
  }
  if (!node.name) {
    return false;
  }
  const getRadio = selector => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
  let roving = getRadio(`[name="${node.name}"]:checked`);
  if (!roving) {
    roving = getRadio(`[name="${node.name}"]`);
  }
  return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
    return false;
  }
  return true;
}
function defaultGetTabbable(root) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
    const nodeTabIndex = getTabIndex(node);
    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
      return;
    }
    if (nodeTabIndex === 0) {
      regularTabNodes.push(node);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node: node
      });
    }
  });
  return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map(a => a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
  return true;
}

/**
 * @ignore - internal component.
 */
function FocusTrap(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open
  } = props;
  const ignoreNextEnforceFocus = React$1T.useRef(false);
  const sentinelStart = React$1T.useRef(null);
  const sentinelEnd = React$1T.useRef(null);
  const nodeToRestore = React$1T.useRef(null);
  const reactFocusEventTarget = React$1T.useRef(null);
  // This variable is useful when disableAutoFocus is true.
  // It waits for the active element to move into the component to activate.
  const activated = React$1T.useRef(false);
  const rootRef = React$1T.useRef(null);
  const handleRef = (0, _utils$K.unstable_useForkRef)((0, _utils$K.unstable_getReactElementRef)(children), rootRef);
  const lastKeydown = React$1T.useRef(null);
  React$1T.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  React$1T.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    const doc = (0, _utils$K.unstable_ownerDocument)(rootRef.current);
    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(['MUI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }
        rootRef.current.setAttribute('tabIndex', '-1');
      }
      if (activated.current) {
        rootRef.current.focus();
      }
    }
    return () => {
      // restoreLastFocus()
      if (!disableRestoreFocus) {
        // In IE11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE11 have a focus method.
        // Once IE11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }
        nodeToRestore.current = null;
      }
    };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  React$1T.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }
    const doc = (0, _utils$K.unstable_ownerDocument)(rootRef.current);
    const loopFocus = nativeEvent => {
      lastKeydown.current = nativeEvent;
      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
        return;
      }

      // Make sure the next tab starts from the right place.
      // doc.activeElement refers to the origin.
      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;
        if (sentinelEnd.current) {
          sentinelEnd.current.focus();
        }
      }
    };
    const contain = () => {
      const rootElement = rootRef.current;

      // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.
      if (rootElement === null) {
        return;
      }
      if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      // The focus is already inside
      if (rootElement.contains(doc.activeElement)) {
        return;
      }

      // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
      if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) {
        return;
      }

      // if the focus event is not coming from inside the children's react tree, reset the refs
      if (doc.activeElement !== reactFocusEventTarget.current) {
        reactFocusEventTarget.current = null;
      } else if (reactFocusEventTarget.current !== null) {
        return;
      }
      if (!activated.current) {
        return;
      }
      let tabbable = [];
      if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
        tabbable = getTabbable(rootRef.current);
      }

      // one of the sentinel nodes was focused, so move the focus
      // to the first/last tabbable element inside the focus trap
      if (tabbable.length > 0) {
        var _lastKeydown$current, _lastKeydown$current2;
        const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
        const focusNext = tabbable[0];
        const focusPrevious = tabbable[tabbable.length - 1];
        if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        }
        // no tabbable elements in the trap focus or the focus was outside of the focus trap
      } else {
        rootElement.focus();
      }
    };
    doc.addEventListener('focusin', contain);
    doc.addEventListener('keydown', loopFocus, true);

    // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
    // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    // Instead, we can look if the active element was restored on the BODY element.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
    const interval = setInterval(() => {
      if (doc.activeElement && doc.activeElement.tagName === 'BODY') {
        contain();
      }
    }, 50);
    return () => {
      clearInterval(interval);
      doc.removeEventListener('focusin', contain);
      doc.removeEventListener('keydown', loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);
  const onFocus = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
    reactFocusEventTarget.current = event.target;
    const childrenPropsHandler = children.props.onFocus;
    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };
  const handleFocusSentinel = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }
    activated.current = true;
  };
  return /*#__PURE__*/(0, _jsxRuntime$1K.jsxs)(React$1T.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime$1K.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-testid": "sentinelStart"
    }), /*#__PURE__*/React$1T.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /*#__PURE__*/(0, _jsxRuntime$1K.jsx)("div", {
      tabIndex: open ? 0 : -1,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" ? FocusTrap.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: _utils$K.elementAcceptingRef,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: _propTypes$1X.default.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: _propTypes$1X.default.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: _propTypes$1X.default.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: _propTypes$1X.default.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: _propTypes$1X.default.func,
  /**
   * If `true`, focus is locked.
   */
  open: _propTypes$1X.default.bool.isRequired
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  FocusTrap['propTypes' + ''] = (0, _utils$K.exactProp)(FocusTrap.propTypes);
}
FocusTrap$1.default = FocusTrap;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FocusTrap.default;
  }
});
var _FocusTrap = _interopRequireDefault(FocusTrap$1);
}(Unstable_TrapFocus));

var useModal$1 = {};

var _interopRequireDefault$6s = interopRequireDefault$1.exports;
Object.defineProperty(useModal$1, "__esModule", {
  value: true
});
useModal$1.default = void 0;
var _extends2$1w = _interopRequireDefault$6s(_extends$19.exports);
var React$1S = _interopRequireWildcard$2_(React__default$4);
var _utils$J = utils$7;
var _extractEventHandlers$2 = _interopRequireDefault$6s(extractEventHandlers$2);
var _ModalManager = ModalManager$1;
function _getRequireWildcardCache$2J(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2J = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2_(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2J(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}
function getHasTransition(children) {
  return children ? children.props.hasOwnProperty('in') : false;
}

// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const defaultManager = new _ModalManager.ModalManager();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */
function useModal(parameters) {
  const {
    container,
    disableEscapeKeyDown = false,
    disableScrollLock = false,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = defaultManager,
    closeAfterTransition = false,
    onTransitionEnter,
    onTransitionExited,
    children,
    onClose,
    open,
    rootRef
  } = parameters;

  // @ts-ignore internal logic
  const modal = React$1S.useRef({});
  const mountNodeRef = React$1S.useRef(null);
  const modalRef = React$1S.useRef(null);
  const handleRef = (0, _utils$J.unstable_useForkRef)(modalRef, rootRef);
  const [exited, setExited] = React$1S.useState(!open);
  const hasTransition = getHasTransition(children);
  let ariaHiddenProp = true;
  if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) {
    ariaHiddenProp = false;
  }
  const getDoc = () => (0, _utils$J.unstable_ownerDocument)(mountNodeRef.current);
  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mount = mountNodeRef.current;
    return modal.current;
  };
  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    });

    // Fix a bug on Chrome where the scroll isn't initially 0.
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  };
  const handleOpen = (0, _utils$J.unstable_useEventCallback)(() => {
    const resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer);

    // The element was already mounted.
    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = React$1S.useCallback(() => manager.isTopModal(getModal()), [manager]);
  const handlePortalRef = (0, _utils$J.unstable_useEventCallback)(node => {
    mountNodeRef.current = node;
    if (!node) {
      return;
    }
    if (open && isTopModal()) {
      handleMounted();
    } else if (modalRef.current) {
      (0, _ModalManager.ariaHidden)(modalRef.current, ariaHiddenProp);
    }
  });
  const handleClose = React$1S.useCallback(() => {
    manager.remove(getModal(), ariaHiddenProp);
  }, [ariaHiddenProp, manager]);
  React$1S.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  React$1S.useEffect(() => {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
  const createHandleKeyDown = otherHandlers => event => {
    var _otherHandlers$onKeyD;
    (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);

    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || event.which === 229 ||
    // Wait until IME is settled.
    !isTopModal()) {
      return;
    }
    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();
      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };
  const createHandleBackdropClick = otherHandlers => event => {
    var _otherHandlers$onClic;
    (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
    if (event.target !== event.currentTarget) {
      return;
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const getRootProps = (otherHandlers = {}) => {
    const propsEventHandlers = (0, _extractEventHandlers$2.default)(parameters);

    // The custom event handlers shouldn't be spread on the root element
    delete propsEventHandlers.onTransitionEnter;
    delete propsEventHandlers.onTransitionExited;
    const externalEventHandlers = (0, _extends2$1w.default)({}, propsEventHandlers, otherHandlers);
    return (0, _extends2$1w.default)({
      role: 'presentation'
    }, externalEventHandlers, {
      onKeyDown: createHandleKeyDown(externalEventHandlers),
      ref: handleRef
    });
  };
  const getBackdropProps = (otherHandlers = {}) => {
    const externalEventHandlers = otherHandlers;
    return (0, _extends2$1w.default)({
      'aria-hidden': true
    }, externalEventHandlers, {
      onClick: createHandleBackdropClick(externalEventHandlers),
      open
    });
  };
  const getTransitionProps = () => {
    const handleEnter = () => {
      setExited(false);
      if (onTransitionEnter) {
        onTransitionEnter();
      }
    };
    const handleExited = () => {
      setExited(true);
      if (onTransitionExited) {
        onTransitionExited();
      }
      if (closeAfterTransition) {
        handleClose();
      }
    };
    return {
      onEnter: (0, _utils$J.unstable_createChainedFunction)(handleEnter, children == null ? void 0 : children.props.onEnter),
      onExited: (0, _utils$J.unstable_createChainedFunction)(handleExited, children == null ? void 0 : children.props.onExited)
    };
  };
  return {
    getRootProps,
    getBackdropProps,
    getTransitionProps,
    rootRef: handleRef,
    portalRef: handlePortalRef,
    isTopModal,
    exited,
    hasTransition
  };
}
useModal$1.default = useModal;

var modalClasses$1 = {};

var _interopRequireDefault$6r = interopRequireDefault$1.exports;
Object.defineProperty(modalClasses$1, "__esModule", {
  value: true
});
modalClasses$1.default = void 0;
modalClasses$1.getModalUtilityClass = getModalUtilityClass;
var _generateUtilityClasses$1c = _interopRequireDefault$6r(generateUtilityClasses$3);
var _generateUtilityClass$1c = _interopRequireDefault$6r(generateUtilityClass$3);
function getModalUtilityClass(slot) {
  return (0, _generateUtilityClass$1c.default)('MuiModal', slot);
}
const modalClasses = (0, _generateUtilityClasses$1c.default)('MuiModal', ['root', 'hidden', 'backdrop']);
modalClasses$1.default = modalClasses;

var _interopRequireDefault$6q = interopRequireDefault$1.exports;
Object.defineProperty(Modal$1, "__esModule", {
  value: true
});
Modal$1.default = void 0;
var _objectWithoutPropertiesLoose2$1s = _interopRequireDefault$6q(objectWithoutPropertiesLoose.exports);
var _extends2$1v = _interopRequireDefault$6q(_extends$19.exports);
var React$1R = _interopRequireWildcard$2Z(React__default$4);
var _propTypes$1W = _interopRequireDefault$6q(propTypes.exports);
var _clsx$1O = _interopRequireDefault$6q(clsx.exports);
var _HTMLElementType$3 = _interopRequireDefault$6q(HTMLElementType$2);
var _elementAcceptingRef$4 = _interopRequireDefault$6q(elementAcceptingRef$2);
var _composeClasses$1e = _interopRequireDefault$6q(composeClasses$2);
var _useSlotProps$5 = _interopRequireDefault$6q(useSlotProps$2);
var _Unstable_TrapFocus = _interopRequireDefault$6q(Unstable_TrapFocus);
var _Portal = _interopRequireDefault$6q(Portal$2);
var _styled$1d = _interopRequireDefault$6q(styled$2);
var _DefaultPropsProvider$1e = DefaultPropsProvider$5;
var _Backdrop$1 = _interopRequireDefault$6q(Backdrop$2);
var _useModal = _interopRequireDefault$6q(useModal$1);
var _modalClasses = modalClasses$1;
var _jsxRuntime$1J = require$$11;
const _excluded$1W = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"];
function _getRequireWildcardCache$2I(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2I = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2Z(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2I(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1f = ownerState => {
  const {
    open,
    exited,
    classes
  } = ownerState;
  const slots = {
    root: ['root', !open && exited && 'hidden'],
    backdrop: ['backdrop']
  };
  return (0, _composeClasses$1e.default)(slots, _modalClasses.getModalUtilityClass, classes);
};
const ModalRoot = (0, _styled$1d.default)('div', {
  name: 'MuiModal',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1v.default)({
  position: 'fixed',
  zIndex: (theme.vars || theme).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !ownerState.open && ownerState.exited && {
  visibility: 'hidden'
}));
const ModalBackdrop = (0, _styled$1d.default)(_Backdrop$1.default, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: (props, styles) => {
    return styles.backdrop;
  }
})({
  zIndex: -1
});

/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */
const Modal = /*#__PURE__*/React$1R.forwardRef(function Modal(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
  const props = (0, _DefaultPropsProvider$1e.useDefaultProps)({
    name: 'MuiModal',
    props: inProps
  });
  const {
      BackdropComponent = ModalBackdrop,
      BackdropProps,
      className,
      closeAfterTransition = false,
      children,
      container,
      component,
      components = {},
      componentsProps = {},
      disableAutoFocus = false,
      disableEnforceFocus = false,
      disableEscapeKeyDown = false,
      disablePortal = false,
      disableRestoreFocus = false,
      disableScrollLock = false,
      hideBackdrop = false,
      keepMounted = false,
      onBackdropClick,
      open,
      slotProps,
      slots
      // eslint-disable-next-line react/prop-types
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1s.default)(props, _excluded$1W);
  const propsWithDefaults = (0, _extends2$1v.default)({}, props, {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  });
  const {
    getRootProps,
    getBackdropProps,
    getTransitionProps,
    portalRef,
    isTopModal,
    exited,
    hasTransition
  } = (0, _useModal.default)((0, _extends2$1v.default)({}, propsWithDefaults, {
    rootRef: ref
  }));
  const ownerState = (0, _extends2$1v.default)({}, propsWithDefaults, {
    exited
  });
  const classes = useUtilityClasses$1f(ownerState);
  const childProps = {};
  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = '-1';
  }

  // It's a Transition like component
  if (hasTransition) {
    const {
      onEnter,
      onExited
    } = getTransitionProps();
    childProps.onEnter = onEnter;
    childProps.onExited = onExited;
  }
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : ModalRoot;
  const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
  const rootProps = (0, _useSlotProps$5.default)({
    elementType: RootSlot,
    externalSlotProps: rootSlotProps,
    externalForwardedProps: other,
    getSlotProps: getRootProps,
    additionalProps: {
      ref,
      as: component
    },
    ownerState,
    className: (0, _clsx$1O.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
  });
  const backdropProps = (0, _useSlotProps$5.default)({
    elementType: BackdropSlot,
    externalSlotProps: backdropSlotProps,
    additionalProps: BackdropProps,
    getSlotProps: otherHandlers => {
      return getBackdropProps((0, _extends2$1v.default)({}, otherHandlers, {
        onClick: e => {
          if (onBackdropClick) {
            onBackdropClick(e);
          }
          if (otherHandlers != null && otherHandlers.onClick) {
            otherHandlers.onClick(e);
          }
        }
      }));
    },
    className: (0, _clsx$1O.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
    ownerState
  });
  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime$1J.jsx)(_Portal.default, {
    ref: portalRef,
    container: container,
    disablePortal: disablePortal,
    children: /*#__PURE__*/(0, _jsxRuntime$1J.jsxs)(RootSlot, (0, _extends2$1v.default)({}, rootProps, {
      children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/(0, _jsxRuntime$1J.jsx)(BackdropSlot, (0, _extends2$1v.default)({}, backdropProps)) : null, /*#__PURE__*/(0, _jsxRuntime$1J.jsx)(_Unstable_TrapFocus.default, {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        isEnabled: isTopModal,
        open: open,
        children: /*#__PURE__*/React$1R.cloneElement(children, childProps)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" ? Modal.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: _propTypes$1W.default.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: _propTypes$1W.default.object,
  /**
   * A single child content element.
   */
  children: _elementAcceptingRef$4.default.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1W.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1W.default.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: _propTypes$1W.default.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1W.default.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$1W.default.shape({
    Backdrop: _propTypes$1W.default.elementType,
    Root: _propTypes$1W.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: _propTypes$1W.default.shape({
    backdrop: _propTypes$1W.default.oneOfType([_propTypes$1W.default.func, _propTypes$1W.default.object]),
    root: _propTypes$1W.default.oneOfType([_propTypes$1W.default.func, _propTypes$1W.default.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes$1W.default /* @typescript-to-proptypes-ignore */.oneOfType([_HTMLElementType$3.default, _propTypes$1W.default.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: _propTypes$1W.default.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: _propTypes$1W.default.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: _propTypes$1W.default.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: _propTypes$1W.default.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: _propTypes$1W.default.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: _propTypes$1W.default.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: _propTypes$1W.default.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: _propTypes$1W.default.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: _propTypes$1W.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: _propTypes$1W.default.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: _propTypes$1W.default.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: _propTypes$1W.default.func,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$1W.default.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: _propTypes$1W.default.shape({
    backdrop: _propTypes$1W.default.oneOfType([_propTypes$1W.default.func, _propTypes$1W.default.object]),
    root: _propTypes$1W.default.oneOfType([_propTypes$1W.default.func, _propTypes$1W.default.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: _propTypes$1W.default.shape({
    backdrop: _propTypes$1W.default.elementType,
    root: _propTypes$1W.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1W.default.oneOfType([_propTypes$1W.default.arrayOf(_propTypes$1W.default.oneOfType([_propTypes$1W.default.func, _propTypes$1W.default.object, _propTypes$1W.default.bool])), _propTypes$1W.default.func, _propTypes$1W.default.object])
} : void 0;
Modal$1.default = Modal;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ModalManager: true,
  modalClasses: true
};
Object.defineProperty(exports, "ModalManager", {
  enumerable: true,
  get: function () {
    return _ModalManager.ModalManager;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "modalClasses", {
  enumerable: true,
  get: function () {
    return _modalClasses.default;
  }
});
var _ModalManager = ModalManager$1;
var _Modal = _interopRequireDefault(Modal$1);
var _modalClasses = _interopRequireWildcard(modalClasses$1);
Object.keys(_modalClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _modalClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _modalClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Modal$2));

var dialogClasses$1 = {};

var _interopRequireDefault$6p = interopRequireDefault$1.exports;
Object.defineProperty(dialogClasses$1, "__esModule", {
  value: true
});
dialogClasses$1.default = void 0;
dialogClasses$1.getDialogUtilityClass = getDialogUtilityClass;
var _generateUtilityClasses$1b = _interopRequireDefault$6p(generateUtilityClasses$3);
var _generateUtilityClass$1b = _interopRequireDefault$6p(generateUtilityClass$3);
function getDialogUtilityClass(slot) {
  return (0, _generateUtilityClass$1b.default)('MuiDialog', slot);
}
const dialogClasses = (0, _generateUtilityClasses$1b.default)('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
dialogClasses$1.default = dialogClasses;

var DialogContext$1 = {};

Object.defineProperty(DialogContext$1, "__esModule", {
  value: true
});
DialogContext$1.default = void 0;
var React$1Q = _interopRequireWildcard$2Y(React__default$4);
function _getRequireWildcardCache$2H(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2H = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2Y(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2H(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DialogContext = /*#__PURE__*/React$1Q.createContext({});
if (process.env.NODE_ENV !== 'production') {
  DialogContext.displayName = 'DialogContext';
}
DialogContext$1.default = DialogContext;

var _interopRequireDefault$6o = interopRequireDefault$1.exports;
Object.defineProperty(Dialog$3, "__esModule", {
  value: true
});
Dialog$3.default = void 0;
var _objectWithoutPropertiesLoose2$1r = _interopRequireDefault$6o(objectWithoutPropertiesLoose.exports);
var _extends2$1u = _interopRequireDefault$6o(_extends$19.exports);
var React$1P = _interopRequireWildcard$2X(React__default$4);
var _propTypes$1V = _interopRequireDefault$6o(propTypes.exports);
var _clsx$1N = _interopRequireDefault$6o(clsx.exports);
var _composeClasses$1d = _interopRequireDefault$6o(composeClasses$2);
var _useId$5 = _interopRequireDefault$6o(useId$3);
var _capitalize$v = _interopRequireDefault$6o(capitalize$1);
var _Modal$2 = _interopRequireDefault$6o(Modal$2);
var _Fade = _interopRequireDefault$6o(Fade$2);
var _Paper$4 = _interopRequireDefault$6o(Paper$3);
var _DefaultPropsProvider$1d = DefaultPropsProvider$5;
var _styled$1c = _interopRequireDefault$6o(styled$2);
var _dialogClasses = _interopRequireWildcard$2X(dialogClasses$1);
var _DialogContext$1 = _interopRequireDefault$6o(DialogContext$1);
var _Backdrop = _interopRequireDefault$6o(Backdrop$2);
var _useTheme$b = _interopRequireDefault$6o(useTheme$4);
var _jsxRuntime$1I = require$$11;
const _excluded$1V = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
function _getRequireWildcardCache$2G(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2G = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2X(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2G(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DialogBackdrop = (0, _styled$1c.default)(_Backdrop.default, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});
const useUtilityClasses$1e = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${(0, _capitalize$v.default)(scroll)}`],
    paper: ['paper', `paperScroll${(0, _capitalize$v.default)(scroll)}`, `paperWidth${(0, _capitalize$v.default)(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return (0, _composeClasses$1d.default)(slots, _dialogClasses.getDialogUtilityClass, classes);
};
const DialogRoot = (0, _styled$1c.default)(_Modal$2.default, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = (0, _styled$1c.default)('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${(0, _capitalize$v.default)(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => (0, _extends2$1u.default)({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&::after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = (0, _styled$1c.default)(_Paper$4.default, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${(0, _capitalize$v.default)(ownerState.scroll)}`], styles[`paperWidth${(0, _capitalize$v.default)(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1u.default)({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11
}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
  [`&.${_dialogClasses.default.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${_dialogClasses.default.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${_dialogClasses.default.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));

/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
const Dialog$2 = /*#__PURE__*/React$1P.forwardRef(function Dialog(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1d.useDefaultProps)({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = (0, _useTheme$b.default)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      'aria-describedby': ariaDescribedby,
      'aria-labelledby': ariaLabelledbyProp,
      BackdropComponent,
      BackdropProps,
      children,
      className,
      disableEscapeKeyDown = false,
      fullScreen = false,
      fullWidth = false,
      maxWidth = 'sm',
      onBackdropClick,
      onClick,
      onClose,
      open,
      PaperComponent = _Paper$4.default,
      PaperProps = {},
      scroll = 'paper',
      TransitionComponent = _Fade.default,
      transitionDuration = defaultTransitionDuration,
      TransitionProps
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1r.default)(props, _excluded$1V);
  const ownerState = (0, _extends2$1u.default)({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });
  const classes = useUtilityClasses$1e(ownerState);
  const backdropClick = React$1P.useRef();
  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };
  const handleBackdropClick = event => {
    if (onClick) {
      onClick(event);
    }

    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }
    backdropClick.current = null;
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const ariaLabelledby = (0, _useId$5.default)(ariaLabelledbyProp);
  const dialogContextValue = React$1P.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/(0, _jsxRuntime$1I.jsx)(DialogRoot, (0, _extends2$1u.default)({
    className: (0, _clsx$1N.default)(classes.root, className),
    closeAfterTransition: true,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: (0, _extends2$1u.default)({
        transitionDuration,
        as: BackdropComponent
      }, BackdropProps)
    },
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$1I.jsx)(TransitionComponent, (0, _extends2$1u.default)({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/(0, _jsxRuntime$1I.jsx)(DialogContainer, {
        className: (0, _clsx$1N.default)(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/(0, _jsxRuntime$1I.jsx)(DialogPaper, (0, _extends2$1u.default)({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: (0, _clsx$1N.default)(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/(0, _jsxRuntime$1I.jsx)(_DialogContext$1.default.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Dialog$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  'aria-describedby': _propTypes$1V.default.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  'aria-labelledby': _propTypes$1V.default.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: _propTypes$1V.default.elementType,
  /**
   * @ignore
   */
  BackdropProps: _propTypes$1V.default.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: _propTypes$1V.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1V.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1V.default.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: _propTypes$1V.default.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: _propTypes$1V.default.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: _propTypes$1V.default.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: _propTypes$1V.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1V.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]), _propTypes$1V.default.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: _propTypes$1V.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes$1V.default.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: _propTypes$1V.default.func,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$1V.default.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: _propTypes$1V.default.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: _propTypes$1V.default.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: _propTypes$1V.default.oneOf(['body', 'paper']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1V.default.oneOfType([_propTypes$1V.default.arrayOf(_propTypes$1V.default.oneOfType([_propTypes$1V.default.func, _propTypes$1V.default.object, _propTypes$1V.default.bool])), _propTypes$1V.default.func, _propTypes$1V.default.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: _propTypes$1V.default.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: _propTypes$1V.default.oneOfType([_propTypes$1V.default.number, _propTypes$1V.default.shape({
    appear: _propTypes$1V.default.number,
    enter: _propTypes$1V.default.number,
    exit: _propTypes$1V.default.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: _propTypes$1V.default.object
} : void 0;
Dialog$3.default = Dialog$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  dialogClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Dialog.default;
  }
});
Object.defineProperty(exports, "dialogClasses", {
  enumerable: true,
  get: function () {
    return _dialogClasses.default;
  }
});
var _Dialog = _interopRequireDefault(Dialog$3);
var _dialogClasses = _interopRequireWildcard(dialogClasses$1);
Object.keys(_dialogClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dialogClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dialogClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Dialog$4));

var Dialog$1 = /*@__PURE__*/getDefaultExportFromCjs$1(Dialog$4);

var DialogActions$3 = {};

var DialogActions$2 = {};

var dialogActionsClasses$1 = {};

var _interopRequireDefault$6n = interopRequireDefault$1.exports;
Object.defineProperty(dialogActionsClasses$1, "__esModule", {
  value: true
});
dialogActionsClasses$1.default = void 0;
dialogActionsClasses$1.getDialogActionsUtilityClass = getDialogActionsUtilityClass;
var _generateUtilityClasses$1a = _interopRequireDefault$6n(generateUtilityClasses$3);
var _generateUtilityClass$1a = _interopRequireDefault$6n(generateUtilityClass$3);
function getDialogActionsUtilityClass(slot) {
  return (0, _generateUtilityClass$1a.default)('MuiDialogActions', slot);
}
const dialogActionsClasses = (0, _generateUtilityClasses$1a.default)('MuiDialogActions', ['root', 'spacing']);
dialogActionsClasses$1.default = dialogActionsClasses;

var _interopRequireDefault$6m = interopRequireDefault$1.exports;
Object.defineProperty(DialogActions$2, "__esModule", {
  value: true
});
DialogActions$2.default = void 0;
var _objectWithoutPropertiesLoose2$1q = _interopRequireDefault$6m(objectWithoutPropertiesLoose.exports);
var _extends2$1t = _interopRequireDefault$6m(_extends$19.exports);
var React$1O = _interopRequireWildcard$2W(React__default$4);
var _propTypes$1U = _interopRequireDefault$6m(propTypes.exports);
var _clsx$1M = _interopRequireDefault$6m(clsx.exports);
var _composeClasses$1c = _interopRequireDefault$6m(composeClasses$2);
var _styled$1b = _interopRequireDefault$6m(styled$2);
var _DefaultPropsProvider$1c = DefaultPropsProvider$5;
var _dialogActionsClasses = dialogActionsClasses$1;
var _jsxRuntime$1H = require$$11;
const _excluded$1U = ["className", "disableSpacing"];
function _getRequireWildcardCache$2F(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2F = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2W(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2F(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1d = ownerState => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ['root', !disableSpacing && 'spacing']
  };
  return (0, _composeClasses$1c.default)(slots, _dialogActionsClasses.getDialogActionsUtilityClass, classes);
};
const DialogActionsRoot = (0, _styled$1b.default)('div', {
  name: 'MuiDialogActions',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableSpacing && styles.spacing];
  }
})(({
  ownerState
}) => (0, _extends2$1t.default)({
  display: 'flex',
  alignItems: 'center',
  padding: 8,
  justifyContent: 'flex-end',
  flex: '0 0 auto'
}, !ownerState.disableSpacing && {
  '& > :not(style) ~ :not(style)': {
    marginLeft: 8
  }
}));
const DialogActions$1 = /*#__PURE__*/React$1O.forwardRef(function DialogActions(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1c.useDefaultProps)({
    props: inProps,
    name: 'MuiDialogActions'
  });
  const {
      className,
      disableSpacing = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1q.default)(props, _excluded$1U);
  const ownerState = (0, _extends2$1t.default)({}, props, {
    disableSpacing
  });
  const classes = useUtilityClasses$1d(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1H.jsx)(DialogActionsRoot, (0, _extends2$1t.default)({
    className: (0, _clsx$1M.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogActions$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1U.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1U.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1U.default.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: _propTypes$1U.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1U.default.oneOfType([_propTypes$1U.default.arrayOf(_propTypes$1U.default.oneOfType([_propTypes$1U.default.func, _propTypes$1U.default.object, _propTypes$1U.default.bool])), _propTypes$1U.default.func, _propTypes$1U.default.object])
} : void 0;
DialogActions$2.default = DialogActions$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  dialogActionsClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _DialogActions.default;
  }
});
Object.defineProperty(exports, "dialogActionsClasses", {
  enumerable: true,
  get: function () {
    return _dialogActionsClasses.default;
  }
});
var _DialogActions = _interopRequireDefault(DialogActions$2);
var _dialogActionsClasses = _interopRequireWildcard(dialogActionsClasses$1);
Object.keys(_dialogActionsClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dialogActionsClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dialogActionsClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(DialogActions$3));

var DialogActions = /*@__PURE__*/getDefaultExportFromCjs$1(DialogActions$3);

var DialogContent$3 = {};

var DialogContent$2 = {};

var dialogContentClasses$1 = {};

var _interopRequireDefault$6l = interopRequireDefault$1.exports;
Object.defineProperty(dialogContentClasses$1, "__esModule", {
  value: true
});
dialogContentClasses$1.default = void 0;
dialogContentClasses$1.getDialogContentUtilityClass = getDialogContentUtilityClass;
var _generateUtilityClasses$19 = _interopRequireDefault$6l(generateUtilityClasses$3);
var _generateUtilityClass$19 = _interopRequireDefault$6l(generateUtilityClass$3);
function getDialogContentUtilityClass(slot) {
  return (0, _generateUtilityClass$19.default)('MuiDialogContent', slot);
}
const dialogContentClasses = (0, _generateUtilityClasses$19.default)('MuiDialogContent', ['root', 'dividers']);
dialogContentClasses$1.default = dialogContentClasses;

var dialogTitleClasses$1 = {};

var _interopRequireDefault$6k = interopRequireDefault$1.exports;
Object.defineProperty(dialogTitleClasses$1, "__esModule", {
  value: true
});
dialogTitleClasses$1.default = void 0;
dialogTitleClasses$1.getDialogTitleUtilityClass = getDialogTitleUtilityClass;
var _generateUtilityClasses$18 = _interopRequireDefault$6k(generateUtilityClasses$3);
var _generateUtilityClass$18 = _interopRequireDefault$6k(generateUtilityClass$3);
function getDialogTitleUtilityClass(slot) {
  return (0, _generateUtilityClass$18.default)('MuiDialogTitle', slot);
}
const dialogTitleClasses = (0, _generateUtilityClasses$18.default)('MuiDialogTitle', ['root']);
dialogTitleClasses$1.default = dialogTitleClasses;

var _interopRequireDefault$6j = interopRequireDefault$1.exports;
Object.defineProperty(DialogContent$2, "__esModule", {
  value: true
});
DialogContent$2.default = void 0;
var _objectWithoutPropertiesLoose2$1p = _interopRequireDefault$6j(objectWithoutPropertiesLoose.exports);
var _extends2$1s = _interopRequireDefault$6j(_extends$19.exports);
var React$1N = _interopRequireWildcard$2V(React__default$4);
var _propTypes$1T = _interopRequireDefault$6j(propTypes.exports);
var _clsx$1L = _interopRequireDefault$6j(clsx.exports);
var _composeClasses$1b = _interopRequireDefault$6j(composeClasses$2);
var _styled$1a = _interopRequireDefault$6j(styled$2);
var _DefaultPropsProvider$1b = DefaultPropsProvider$5;
var _dialogContentClasses = dialogContentClasses$1;
var _dialogTitleClasses$1 = _interopRequireDefault$6j(dialogTitleClasses$1);
var _jsxRuntime$1G = require$$11;
const _excluded$1T = ["className", "dividers"];
function _getRequireWildcardCache$2E(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2E = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2V(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2E(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1c = ownerState => {
  const {
    classes,
    dividers
  } = ownerState;
  const slots = {
    root: ['root', dividers && 'dividers']
  };
  return (0, _composeClasses$1b.default)(slots, _dialogContentClasses.getDialogContentUtilityClass, classes);
};
const DialogContentRoot = (0, _styled$1a.default)('div', {
  name: 'MuiDialogContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dividers && styles.dividers];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1s.default)({
  flex: '1 1 auto',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
  padding: '20px 24px'
}, ownerState.dividers ? {
  padding: '16px 24px',
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
} : {
  [`.${_dialogTitleClasses$1.default.root} + &`]: {
    paddingTop: 0
  }
}));
const DialogContent$1 = /*#__PURE__*/React$1N.forwardRef(function DialogContent(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1b.useDefaultProps)({
    props: inProps,
    name: 'MuiDialogContent'
  });
  const {
      className,
      dividers = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1p.default)(props, _excluded$1T);
  const ownerState = (0, _extends2$1s.default)({}, props, {
    dividers
  });
  const classes = useUtilityClasses$1c(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1G.jsx)(DialogContentRoot, (0, _extends2$1s.default)({
    className: (0, _clsx$1L.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogContent$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1T.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1T.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1T.default.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: _propTypes$1T.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1T.default.oneOfType([_propTypes$1T.default.arrayOf(_propTypes$1T.default.oneOfType([_propTypes$1T.default.func, _propTypes$1T.default.object, _propTypes$1T.default.bool])), _propTypes$1T.default.func, _propTypes$1T.default.object])
} : void 0;
DialogContent$2.default = DialogContent$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  dialogContentClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _DialogContent.default;
  }
});
Object.defineProperty(exports, "dialogContentClasses", {
  enumerable: true,
  get: function () {
    return _dialogContentClasses.default;
  }
});
var _DialogContent = _interopRequireDefault(DialogContent$2);
var _dialogContentClasses = _interopRequireWildcard(dialogContentClasses$1);
Object.keys(_dialogContentClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dialogContentClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dialogContentClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(DialogContent$3));

var DialogContent = /*@__PURE__*/getDefaultExportFromCjs$1(DialogContent$3);

var DialogContentText$2 = {};

var DialogContentText$1 = {};

var dialogContentTextClasses$1 = {};

var _interopRequireDefault$6i = interopRequireDefault$1.exports;
Object.defineProperty(dialogContentTextClasses$1, "__esModule", {
  value: true
});
dialogContentTextClasses$1.default = void 0;
dialogContentTextClasses$1.getDialogContentTextUtilityClass = getDialogContentTextUtilityClass;
var _generateUtilityClasses$17 = _interopRequireDefault$6i(generateUtilityClasses$3);
var _generateUtilityClass$17 = _interopRequireDefault$6i(generateUtilityClass$3);
function getDialogContentTextUtilityClass(slot) {
  return (0, _generateUtilityClass$17.default)('MuiDialogContentText', slot);
}
const dialogContentTextClasses = (0, _generateUtilityClasses$17.default)('MuiDialogContentText', ['root']);
dialogContentTextClasses$1.default = dialogContentTextClasses;

var _interopRequireDefault$6h = interopRequireDefault$1.exports;
Object.defineProperty(DialogContentText$1, "__esModule", {
  value: true
});
DialogContentText$1.default = void 0;
var _objectWithoutPropertiesLoose2$1o = _interopRequireDefault$6h(objectWithoutPropertiesLoose.exports);
var _extends2$1r = _interopRequireDefault$6h(_extends$19.exports);
var React$1M = _interopRequireWildcard$2U(React__default$4);
var _propTypes$1S = _interopRequireDefault$6h(propTypes.exports);
var _clsx$1K = _interopRequireDefault$6h(clsx.exports);
var _composeClasses$1a = _interopRequireDefault$6h(composeClasses$2);
var _styled$19 = _interopRequireWildcard$2U(styled$2);
var _DefaultPropsProvider$1a = DefaultPropsProvider$5;
var _Typography$5 = _interopRequireDefault$6h(Typography$3);
var _dialogContentTextClasses = dialogContentTextClasses$1;
var _jsxRuntime$1F = require$$11;
const _excluded$1S = ["children", "className"];
function _getRequireWildcardCache$2D(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2D = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2U(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2D(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1b = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  const composedClasses = (0, _composeClasses$1a.default)(slots, _dialogContentTextClasses.getDialogContentTextUtilityClass, classes);
  return (0, _extends2$1r.default)({}, classes, composedClasses);
};
const DialogContentTextRoot = (0, _styled$19.default)(_Typography$5.default, {
  shouldForwardProp: prop => (0, _styled$19.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiDialogContentText',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const DialogContentText = /*#__PURE__*/React$1M.forwardRef(function DialogContentText(inProps, ref) {
  const props = (0, _DefaultPropsProvider$1a.useDefaultProps)({
    props: inProps,
    name: 'MuiDialogContentText'
  });
  const {
      className
    } = props,
    ownerState = (0, _objectWithoutPropertiesLoose2$1o.default)(props, _excluded$1S);
  const classes = useUtilityClasses$1b(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1F.jsx)(DialogContentTextRoot, (0, _extends2$1r.default)({
    component: "p",
    variant: "body1",
    color: "text.secondary",
    ref: ref,
    ownerState: ownerState,
    className: (0, _clsx$1K.default)(classes.root, className)
  }, props, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? DialogContentText.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1S.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1S.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1S.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1S.default.oneOfType([_propTypes$1S.default.arrayOf(_propTypes$1S.default.oneOfType([_propTypes$1S.default.func, _propTypes$1S.default.object, _propTypes$1S.default.bool])), _propTypes$1S.default.func, _propTypes$1S.default.object])
} : void 0;
DialogContentText$1.default = DialogContentText;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  dialogContentTextClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _DialogContentText.default;
  }
});
Object.defineProperty(exports, "dialogContentTextClasses", {
  enumerable: true,
  get: function () {
    return _dialogContentTextClasses.default;
  }
});
var _DialogContentText = _interopRequireDefault(DialogContentText$1);
var _dialogContentTextClasses = _interopRequireWildcard(dialogContentTextClasses$1);
Object.keys(_dialogContentTextClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dialogContentTextClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dialogContentTextClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(DialogContentText$2));

var DialogTitle$3 = {};

var DialogTitle$2 = {};

var _interopRequireDefault$6g = interopRequireDefault$1.exports;
Object.defineProperty(DialogTitle$2, "__esModule", {
  value: true
});
DialogTitle$2.default = void 0;
var _extends2$1q = _interopRequireDefault$6g(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1n = _interopRequireDefault$6g(objectWithoutPropertiesLoose.exports);
var React$1L = _interopRequireWildcard$2T(React__default$4);
var _propTypes$1R = _interopRequireDefault$6g(propTypes.exports);
var _clsx$1J = _interopRequireDefault$6g(clsx.exports);
var _composeClasses$19 = _interopRequireDefault$6g(composeClasses$2);
var _Typography$4 = _interopRequireDefault$6g(Typography$3);
var _styled$18 = _interopRequireDefault$6g(styled$2);
var _DefaultPropsProvider$19 = DefaultPropsProvider$5;
var _dialogTitleClasses = dialogTitleClasses$1;
var _DialogContext = _interopRequireDefault$6g(DialogContext$1);
var _jsxRuntime$1E = require$$11;
const _excluded$1R = ["className", "id"];
function _getRequireWildcardCache$2C(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2C = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2T(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2C(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1a = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$19.default)(slots, _dialogTitleClasses.getDialogTitleUtilityClass, classes);
};
const DialogTitleRoot = (0, _styled$18.default)(_Typography$4.default, {
  name: 'MuiDialogTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  padding: '16px 24px',
  flex: '0 0 auto'
});
const DialogTitle$1 = /*#__PURE__*/React$1L.forwardRef(function DialogTitle(inProps, ref) {
  const props = (0, _DefaultPropsProvider$19.useDefaultProps)({
    props: inProps,
    name: 'MuiDialogTitle'
  });
  const {
      className,
      id: idProp
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1n.default)(props, _excluded$1R);
  const ownerState = props;
  const classes = useUtilityClasses$1a(ownerState);
  const {
    titleId = idProp
  } = React$1L.useContext(_DialogContext.default);
  return /*#__PURE__*/(0, _jsxRuntime$1E.jsx)(DialogTitleRoot, (0, _extends2$1q.default)({
    component: "h2",
    className: (0, _clsx$1J.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref,
    variant: "h6",
    id: idProp != null ? idProp : titleId
  }, other));
});
process.env.NODE_ENV !== "production" ? DialogTitle$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1R.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1R.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1R.default.string,
  /**
   * @ignore
   */
  id: _propTypes$1R.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1R.default.oneOfType([_propTypes$1R.default.arrayOf(_propTypes$1R.default.oneOfType([_propTypes$1R.default.func, _propTypes$1R.default.object, _propTypes$1R.default.bool])), _propTypes$1R.default.func, _propTypes$1R.default.object])
} : void 0;
DialogTitle$2.default = DialogTitle$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  dialogTitleClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _DialogTitle.default;
  }
});
Object.defineProperty(exports, "dialogTitleClasses", {
  enumerable: true,
  get: function () {
    return _dialogTitleClasses.default;
  }
});
var _DialogTitle = _interopRequireDefault(DialogTitle$2);
var _dialogTitleClasses = _interopRequireWildcard(dialogTitleClasses$1);
Object.keys(_dialogTitleClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dialogTitleClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dialogTitleClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(DialogTitle$3));

var DialogTitle = /*@__PURE__*/getDefaultExportFromCjs$1(DialogTitle$3);

var Divider$3 = {};

var Divider$2 = {};

var dividerClasses$1 = {};

var _interopRequireDefault$6f = interopRequireDefault$1.exports;
Object.defineProperty(dividerClasses$1, "__esModule", {
  value: true
});
dividerClasses$1.default = void 0;
dividerClasses$1.getDividerUtilityClass = getDividerUtilityClass;
var _generateUtilityClasses$16 = _interopRequireDefault$6f(generateUtilityClasses$3);
var _generateUtilityClass$16 = _interopRequireDefault$6f(generateUtilityClass$3);
function getDividerUtilityClass(slot) {
  return (0, _generateUtilityClass$16.default)('MuiDivider', slot);
}
const dividerClasses = (0, _generateUtilityClasses$16.default)('MuiDivider', ['root', 'absolute', 'fullWidth', 'inset', 'middle', 'flexItem', 'light', 'vertical', 'withChildren', 'withChildrenVertical', 'textAlignRight', 'textAlignLeft', 'wrapper', 'wrapperVertical']);
dividerClasses$1.default = dividerClasses;

var _interopRequireDefault$6e = interopRequireDefault$1.exports;
Object.defineProperty(Divider$2, "__esModule", {
  value: true
});
Divider$2.default = void 0;
var _objectWithoutPropertiesLoose2$1m = _interopRequireDefault$6e(objectWithoutPropertiesLoose.exports);
var _extends2$1p = _interopRequireDefault$6e(_extends$19.exports);
var React$1K = _interopRequireWildcard$2S(React__default$4);
var _propTypes$1Q = _interopRequireDefault$6e(propTypes.exports);
var _clsx$1I = _interopRequireDefault$6e(clsx.exports);
var _composeClasses$18 = _interopRequireDefault$6e(composeClasses$2);
var _colorManipulator$e = colorManipulator;
var _styled$17 = _interopRequireDefault$6e(styled$2);
var _DefaultPropsProvider$18 = DefaultPropsProvider$5;
var _dividerClasses = dividerClasses$1;
var _jsxRuntime$1D = require$$11;
const _excluded$1Q = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"];
function _getRequireWildcardCache$2B(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2B = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2S(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2B(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$19 = ownerState => {
  const {
    absolute,
    children,
    classes,
    flexItem,
    light,
    orientation,
    textAlign,
    variant
  } = ownerState;
  const slots = {
    root: ['root', absolute && 'absolute', variant, light && 'light', orientation === 'vertical' && 'vertical', flexItem && 'flexItem', children && 'withChildren', children && orientation === 'vertical' && 'withChildrenVertical', textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight', textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'],
    wrapper: ['wrapper', orientation === 'vertical' && 'wrapperVertical']
  };
  return (0, _composeClasses$18.default)(slots, _dividerClasses.getDividerUtilityClass, classes);
};
const DividerRoot = (0, _styled$17.default)('div', {
  name: 'MuiDivider',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.absolute && styles.absolute, styles[ownerState.variant], ownerState.light && styles.light, ownerState.orientation === 'vertical' && styles.vertical, ownerState.flexItem && styles.flexItem, ownerState.children && styles.withChildren, ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1p.default)({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: 'solid',
  borderColor: (theme.vars || theme).palette.divider,
  borderBottomWidth: 'thin'
}, ownerState.absolute && {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%'
}, ownerState.light && {
  borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, _colorManipulator$e.alpha)(theme.palette.divider, 0.08)
}, ownerState.variant === 'inset' && {
  marginLeft: 72
}, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2)
}, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1)
}, ownerState.orientation === 'vertical' && {
  height: '100%',
  borderBottomWidth: 0,
  borderRightWidth: 'thin'
}, ownerState.flexItem && {
  alignSelf: 'stretch',
  height: 'auto'
}), ({
  ownerState
}) => (0, _extends2$1p.default)({}, ownerState.children && {
  display: 'flex',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  border: 0,
  borderTopStyle: 'solid',
  borderLeftStyle: 'solid',
  '&::before, &::after': {
    content: '""',
    alignSelf: 'center'
  }
}), ({
  theme,
  ownerState
}) => (0, _extends2$1p.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
  '&::before, &::after': {
    width: '100%',
    borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
    borderTopStyle: 'inherit'
  }
}), ({
  theme,
  ownerState
}) => (0, _extends2$1p.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
  flexDirection: 'column',
  '&::before, &::after': {
    height: '100%',
    borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
    borderLeftStyle: 'inherit'
  }
}), ({
  ownerState
}) => (0, _extends2$1p.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '90%'
  },
  '&::after': {
    width: '10%'
  }
}, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '10%'
  },
  '&::after': {
    width: '90%'
  }
}));
const DividerWrapper = (0, _styled$17.default)('span', {
  name: 'MuiDivider',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.wrapper, ownerState.orientation === 'vertical' && styles.wrapperVertical];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1p.default)({
  display: 'inline-block',
  paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
  paddingRight: `calc(${theme.spacing(1)} * 1.2)`
}, ownerState.orientation === 'vertical' && {
  paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
}));
const Divider$1 = /*#__PURE__*/React$1K.forwardRef(function Divider(inProps, ref) {
  const props = (0, _DefaultPropsProvider$18.useDefaultProps)({
    props: inProps,
    name: 'MuiDivider'
  });
  const {
      absolute = false,
      children,
      className,
      component = children ? 'div' : 'hr',
      flexItem = false,
      light = false,
      orientation = 'horizontal',
      role = component !== 'hr' ? 'separator' : undefined,
      textAlign = 'center',
      variant = 'fullWidth'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1m.default)(props, _excluded$1Q);
  const ownerState = (0, _extends2$1p.default)({}, props, {
    absolute,
    component,
    flexItem,
    light,
    orientation,
    role,
    textAlign,
    variant
  });
  const classes = useUtilityClasses$19(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1D.jsx)(DividerRoot, (0, _extends2$1p.default)({
    as: component,
    className: (0, _clsx$1I.default)(classes.root, className),
    role: role,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children ? /*#__PURE__*/(0, _jsxRuntime$1D.jsx)(DividerWrapper, {
      className: classes.wrapper,
      ownerState: ownerState,
      children: children
    }) : null
  }));
});

/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */
Divider$1.muiSkipListHighlight = true;
process.env.NODE_ENV !== "production" ? Divider$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: _propTypes$1Q.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes$1Q.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1Q.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1Q.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1Q.default.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: _propTypes$1Q.default.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  light: _propTypes$1Q.default.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: _propTypes$1Q.default.oneOf(['horizontal', 'vertical']),
  /**
   * @ignore
   */
  role: _propTypes$1Q.default /* @typescript-to-proptypes-ignore */.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1Q.default.oneOfType([_propTypes$1Q.default.arrayOf(_propTypes$1Q.default.oneOfType([_propTypes$1Q.default.func, _propTypes$1Q.default.object, _propTypes$1Q.default.bool])), _propTypes$1Q.default.func, _propTypes$1Q.default.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: _propTypes$1Q.default.oneOf(['center', 'left', 'right']),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: _propTypes$1Q.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1Q.default.oneOf(['fullWidth', 'inset', 'middle']), _propTypes$1Q.default.string])
} : void 0;
Divider$2.default = Divider$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  dividerClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Divider.default;
  }
});
Object.defineProperty(exports, "dividerClasses", {
  enumerable: true,
  get: function () {
    return _dividerClasses.default;
  }
});
var _Divider = _interopRequireDefault(Divider$2);
var _dividerClasses = _interopRequireWildcard(dividerClasses$1);
Object.keys(_dividerClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dividerClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dividerClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Divider$3));

var Drawer$2 = {};

var Drawer$1 = {};

var Slide$2 = {};

var Slide$1 = {};

var _interopRequireDefault$6d = interopRequireDefault$1.exports;
Object.defineProperty(Slide$1, "__esModule", {
  value: true
});
Slide$1.default = void 0;
Slide$1.setTranslateValue = setTranslateValue;
var _extends2$1o = _interopRequireDefault$6d(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1l = _interopRequireDefault$6d(objectWithoutPropertiesLoose.exports);
var React$1J = _interopRequireWildcard$2R(React__default$4);
var _propTypes$1P = _interopRequireDefault$6d(propTypes.exports);
var _reactTransitionGroup$4 = cjs$4;
var _chainPropTypes$5 = _interopRequireDefault$6d(chainPropTypes$2);
var _HTMLElementType$2 = _interopRequireDefault$6d(HTMLElementType$2);
var _elementAcceptingRef$3 = _interopRequireDefault$6d(elementAcceptingRef$2);
var _getReactElementRef$4 = _interopRequireDefault$6d(getReactElementRef$2);
var _debounce$4 = _interopRequireDefault$6d(debounce$3);
var _useForkRef$e = _interopRequireDefault$6d(useForkRef);
var _useTheme$a = _interopRequireDefault$6d(useTheme$4);
var _utils$I = utils$8;
var _utils2 = utils$6;
var _jsxRuntime$1C = require$$11;
const _excluded$1P = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]; // Translate the node so it can't be seen on the screen.
// Later, we're going to translate the node back to its original location with `none`.
function _getRequireWildcardCache$2A(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2A = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2R(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2A(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getTranslateValue(direction, node, resolvedContainer) {
  const rect = node.getBoundingClientRect();
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = (0, _utils2.ownerWindow)(node);
  let transform;
  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    const computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }
  let offsetX = 0;
  let offsetY = 0;
  if (transform && transform !== 'none' && typeof transform === 'string') {
    const transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }
  if (direction === 'left') {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }
    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }
  if (direction === 'right') {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }
    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }
  if (direction === 'up') {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }
    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  }

  // direction === 'down'
  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }
  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function setTranslateValue(direction, node, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform = getTranslateValue(direction, node, resolvedContainer);
  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}

/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Slide = /*#__PURE__*/React$1J.forwardRef(function Slide(props, ref) {
  const theme = (0, _useTheme$a.default)();
  const defaultEasing = {
    enter: theme.transitions.easing.easeOut,
    exit: theme.transitions.easing.sharp
  };
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      container: containerProp,
      direction = 'down',
      easing: easingProp = defaultEasing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = _reactTransitionGroup$4.Transition
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1l.default)(props, _excluded$1P);
  const childrenRef = React$1J.useRef(null);
  const handleRef = (0, _useForkRef$e.default)((0, _getReactElementRef$4.default)(children), childrenRef, ref);
  const normalizedTransitionCallback = callback => isAppearing => {
    if (callback) {
      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (isAppearing === undefined) {
        callback(childrenRef.current);
      } else {
        callback(childrenRef.current, isAppearing);
      }
    }
  };
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    setTranslateValue(direction, node, containerProp);
    (0, _utils$I.reflow)(node);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const transitionProps = (0, _utils$I.getTransitionProps)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2$1o.default)({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', (0, _extends2$1o.default)({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0, _utils$I.getTransitionProps)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(node => {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';
    if (onExited) {
      onExited(node);
    }
  });
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };
  const updatePosition = React$1J.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  React$1J.useEffect(() => {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }
    const handleResize = (0, _debounce$4.default)(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = (0, _utils2.ownerWindow)(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  React$1J.useEffect(() => {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/(0, _jsxRuntime$1C.jsx)(TransitionComponent, (0, _extends2$1o.default)({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    in: inProp,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$1J.cloneElement(children, (0, _extends2$1o.default)({
        ref: handleRef,
        style: (0, _extends2$1o.default)({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, children.props.style)
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Slide.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: _propTypes$1P.default.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: _propTypes$1P.default.bool,
  /**
   * A single child content element.
   */
  children: _elementAcceptingRef$3.default.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: (0, _chainPropTypes$5.default)(_propTypes$1P.default.oneOfType([_HTMLElementType$2.default, _propTypes$1P.default.func]), props => {
    if (props.open) {
      const resolvedContainer = resolveContainer(props.container);
      if (resolvedContainer && resolvedContainer.nodeType === 1) {
        const box = resolvedContainer.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `container` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedContainer || typeof resolvedContainer.getBoundingClientRect !== 'function' || resolvedContainer.contextElement != null && resolvedContainer.contextElement.nodeType !== 1) {
        return new Error(['MUI: The `container` prop provided to the component is invalid.', 'It should be an HTML element instance.'].join('\n'));
      }
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: _propTypes$1P.default.oneOf(['down', 'left', 'right', 'up']),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: _propTypes$1P.default.oneOfType([_propTypes$1P.default.shape({
    enter: _propTypes$1P.default.string,
    exit: _propTypes$1P.default.string
  }), _propTypes$1P.default.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes$1P.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes$1P.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes$1P.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes$1P.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes$1P.default.func,
  /**
   * @ignore
   */
  onExited: _propTypes$1P.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes$1P.default.func,
  /**
   * @ignore
   */
  style: _propTypes$1P.default.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: _propTypes$1P.default.oneOfType([_propTypes$1P.default.number, _propTypes$1P.default.shape({
    appear: _propTypes$1P.default.number,
    enter: _propTypes$1P.default.number,
    exit: _propTypes$1P.default.number
  })])
} : void 0;
Slide$1.default = Slide;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Slide.default;
  }
});
var _Slide = _interopRequireDefault(Slide$1);
}(Slide$2));

var drawerClasses$1 = {};

var _interopRequireDefault$6c = interopRequireDefault$1.exports;
Object.defineProperty(drawerClasses$1, "__esModule", {
  value: true
});
drawerClasses$1.default = void 0;
drawerClasses$1.getDrawerUtilityClass = getDrawerUtilityClass;
var _generateUtilityClasses$15 = _interopRequireDefault$6c(generateUtilityClasses$3);
var _generateUtilityClass$15 = _interopRequireDefault$6c(generateUtilityClass$3);
function getDrawerUtilityClass(slot) {
  return (0, _generateUtilityClass$15.default)('MuiDrawer', slot);
}
const drawerClasses = (0, _generateUtilityClasses$15.default)('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);
drawerClasses$1.default = drawerClasses;

var _interopRequireDefault$6b = interopRequireDefault$1.exports;
Object.defineProperty(Drawer$1, "__esModule", {
  value: true
});
Drawer$1.default = void 0;
Drawer$1.getAnchor = getAnchor;
Drawer$1.isHorizontal = isHorizontal;
var _objectWithoutPropertiesLoose2$1k = _interopRequireDefault$6b(objectWithoutPropertiesLoose.exports);
var _extends2$1n = _interopRequireDefault$6b(_extends$19.exports);
var React$1I = _interopRequireWildcard$2Q(React__default$4);
var _propTypes$1O = _interopRequireDefault$6b(propTypes.exports);
var _clsx$1H = _interopRequireDefault$6b(clsx.exports);
var _integerPropType$8 = _interopRequireDefault$6b(integerPropType$1);
var _composeClasses$17 = _interopRequireDefault$6b(composeClasses$2);
var _RtlProvider$9 = RtlProvider$1;
var _Modal$1 = _interopRequireDefault$6b(Modal$2);
var _Slide = _interopRequireDefault$6b(Slide$2);
var _Paper$3 = _interopRequireDefault$6b(Paper$3);
var _capitalize$u = _interopRequireDefault$6b(capitalize$1);
var _useTheme$9 = _interopRequireDefault$6b(useTheme$4);
var _DefaultPropsProvider$17 = DefaultPropsProvider$5;
var _styled$16 = _interopRequireWildcard$2Q(styled$2);
var _drawerClasses = drawerClasses$1;
var _jsxRuntime$1B = require$$11;
const _excluded$1O = ["BackdropProps"],
  _excluded2$l = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];
function _getRequireWildcardCache$2z(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2z = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2Q(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2z(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const overridesResolver$5 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};
const useUtilityClasses$18 = ownerState => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', `paperAnchor${(0, _capitalize$u.default)(anchor)}`, variant !== 'temporary' && `paperAnchorDocked${(0, _capitalize$u.default)(anchor)}`]
  };
  return (0, _composeClasses$17.default)(slots, _drawerClasses.getDrawerUtilityClass, classes);
};
const DrawerRoot = (0, _styled$16.default)(_Modal$1.default, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver: overridesResolver$5
})(({
  theme
}) => ({
  zIndex: (theme.vars || theme).zIndex.drawer
}));
const DrawerDockedRoot = (0, _styled$16.default)('div', {
  shouldForwardProp: _styled$16.rootShouldForwardProp,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver: overridesResolver$5
})({
  flex: '0 0 auto'
});
const DrawerPaper = (0, _styled$16.default)(_Paper$3.default, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`paperAnchor${(0, _capitalize$u.default)(ownerState.anchor)}`], ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, _capitalize$u.default)(ownerState.anchor)}`]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1n.default)({
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: '1 0 auto',
  zIndex: (theme.vars || theme).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  // temporary style
  position: 'fixed',
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, ownerState.anchor === 'left' && {
  left: 0
}, ownerState.anchor === 'top' && {
  top: 0,
  left: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'right' && {
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  left: 0,
  bottom: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
  borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
  borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
}, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
}));
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor({
  direction
}, anchor) {
  return direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}

/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */
const Drawer = /*#__PURE__*/React$1I.forwardRef(function Drawer(inProps, ref) {
  const props = (0, _DefaultPropsProvider$17.useDefaultProps)({
    props: inProps,
    name: 'MuiDrawer'
  });
  const theme = (0, _useTheme$9.default)();
  const isRtl = (0, _RtlProvider$9.useRtl)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      anchor: anchorProp = 'left',
      BackdropProps,
      children,
      className,
      elevation = 16,
      hideBackdrop = false,
      ModalProps: {
        BackdropProps: BackdropPropsProp
      } = {},
      onClose,
      open = false,
      PaperProps = {},
      SlideProps,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = _Slide.default,
      transitionDuration = defaultTransitionDuration,
      variant = 'temporary'
    } = props,
    ModalProps = (0, _objectWithoutPropertiesLoose2$1k.default)(props.ModalProps, _excluded$1O),
    other = (0, _objectWithoutPropertiesLoose2$1k.default)(props, _excluded2$l);

  // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.
  const mounted = React$1I.useRef(false);
  React$1I.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchorInvariant = getAnchor({
    direction: isRtl ? 'rtl' : 'ltr'
  }, anchorProp);
  const anchor = anchorProp;
  const ownerState = (0, _extends2$1n.default)({}, props, {
    anchor,
    elevation,
    open,
    variant
  }, other);
  const classes = useUtilityClasses$18(ownerState);
  const drawer = /*#__PURE__*/(0, _jsxRuntime$1B.jsx)(DrawerPaper, (0, _extends2$1n.default)({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: (0, _clsx$1H.default)(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));
  if (variant === 'permanent') {
    return /*#__PURE__*/(0, _jsxRuntime$1B.jsx)(DrawerDockedRoot, (0, _extends2$1n.default)({
      className: (0, _clsx$1H.default)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }
  const slidingDrawer = /*#__PURE__*/(0, _jsxRuntime$1B.jsx)(TransitionComponent, (0, _extends2$1n.default)({
    in: open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));
  if (variant === 'persistent') {
    return /*#__PURE__*/(0, _jsxRuntime$1B.jsx)(DrawerDockedRoot, (0, _extends2$1n.default)({
      className: (0, _clsx$1H.default)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  }

  // variant === temporary
  return /*#__PURE__*/(0, _jsxRuntime$1B.jsx)(DrawerRoot, (0, _extends2$1n.default)({
    BackdropProps: (0, _extends2$1n.default)({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    className: (0, _clsx$1H.default)(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
process.env.NODE_ENV !== "production" ? Drawer.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: _propTypes$1O.default.oneOf(['bottom', 'left', 'right', 'top']),
  /**
   * @ignore
   */
  BackdropProps: _propTypes$1O.default.object,
  /**
   * The content of the component.
   */
  children: _propTypes$1O.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1O.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1O.default.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: _integerPropType$8.default,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: _propTypes$1O.default.bool,
  /**
   * Props applied to the [`Modal`](/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: _propTypes$1O.default.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: _propTypes$1O.default.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: _propTypes$1O.default.bool,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: _propTypes$1O.default.object,
  /**
   * Props applied to the [`Slide`](/material-ui/api/slide/) element.
   */
  SlideProps: _propTypes$1O.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1O.default.oneOfType([_propTypes$1O.default.arrayOf(_propTypes$1O.default.oneOfType([_propTypes$1O.default.func, _propTypes$1O.default.object, _propTypes$1O.default.bool])), _propTypes$1O.default.func, _propTypes$1O.default.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: _propTypes$1O.default.oneOfType([_propTypes$1O.default.number, _propTypes$1O.default.shape({
    appear: _propTypes$1O.default.number,
    enter: _propTypes$1O.default.number,
    exit: _propTypes$1O.default.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: _propTypes$1O.default.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
Drawer$1.default = Drawer;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  drawerClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Drawer.default;
  }
});
Object.defineProperty(exports, "drawerClasses", {
  enumerable: true,
  get: function () {
    return _drawerClasses.default;
  }
});
var _Drawer = _interopRequireDefault(Drawer$1);
var _drawerClasses = _interopRequireWildcard(drawerClasses$1);
Object.keys(_drawerClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _drawerClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _drawerClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Drawer$2));

var Fab$2 = {};

var Fab$1 = {};

var fabClasses$1 = {};

var _interopRequireDefault$6a = interopRequireDefault$1.exports;
Object.defineProperty(fabClasses$1, "__esModule", {
  value: true
});
fabClasses$1.default = void 0;
fabClasses$1.getFabUtilityClass = getFabUtilityClass;
var _generateUtilityClasses$14 = _interopRequireDefault$6a(generateUtilityClasses$3);
var _generateUtilityClass$14 = _interopRequireDefault$6a(generateUtilityClass$3);
function getFabUtilityClass(slot) {
  return (0, _generateUtilityClass$14.default)('MuiFab', slot);
}
const fabClasses = (0, _generateUtilityClasses$14.default)('MuiFab', ['root', 'primary', 'secondary', 'extended', 'circular', 'focusVisible', 'disabled', 'colorInherit', 'sizeSmall', 'sizeMedium', 'sizeLarge', 'info', 'error', 'warning', 'success']);
fabClasses$1.default = fabClasses;

var _interopRequireDefault$69 = interopRequireDefault$1.exports;
Object.defineProperty(Fab$1, "__esModule", {
  value: true
});
Fab$1.default = void 0;
var _objectWithoutPropertiesLoose2$1j = _interopRequireDefault$69(objectWithoutPropertiesLoose.exports);
var _extends2$1m = _interopRequireDefault$69(_extends$19.exports);
var React$1H = _interopRequireWildcard$2P(React__default$4);
var _propTypes$1N = _interopRequireDefault$69(propTypes.exports);
var _clsx$1G = _interopRequireDefault$69(clsx.exports);
var _composeClasses$16 = _interopRequireDefault$69(composeClasses$2);
var _ButtonBase$9 = _interopRequireDefault$69(ButtonBase$2);
var _capitalize$t = _interopRequireDefault$69(capitalize$1);
var _DefaultPropsProvider$16 = DefaultPropsProvider$5;
var _fabClasses = _interopRequireWildcard$2P(fabClasses$1);
var _styled$15 = _interopRequireWildcard$2P(styled$2);
var _jsxRuntime$1A = require$$11;
const _excluded$1N = ["children", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"];
function _getRequireWildcardCache$2y(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2y = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2P(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2y(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$17 = ownerState => {
  const {
    color,
    variant,
    classes,
    size
  } = ownerState;
  const slots = {
    root: ['root', variant, `size${(0, _capitalize$t.default)(size)}`, color === 'inherit' ? 'colorInherit' : color]
  };
  const composedClasses = (0, _composeClasses$16.default)(slots, _fabClasses.getFabUtilityClass, classes);
  return (0, _extends2$1m.default)({}, classes, composedClasses);
};
const FabRoot = (0, _styled$15.default)(_ButtonBase$9.default, {
  name: 'MuiFab',
  slot: 'Root',
  shouldForwardProp: prop => (0, _styled$15.rootShouldForwardProp)(prop) || prop === 'classes',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`size${(0, _capitalize$t.default)(ownerState.size)}`], ownerState.color === 'inherit' && styles.colorInherit, styles[(0, _capitalize$t.default)(ownerState.size)], styles[ownerState.color]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$palette$getCon, _theme$palette;
  return (0, _extends2$1m.default)({}, theme.typography.button, {
    minHeight: 36,
    transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color'], {
      duration: theme.transitions.duration.short
    }),
    borderRadius: '50%',
    padding: 0,
    minWidth: 0,
    width: 56,
    height: 56,
    zIndex: (theme.vars || theme).zIndex.fab,
    boxShadow: (theme.vars || theme).shadows[6],
    '&:active': {
      boxShadow: (theme.vars || theme).shadows[12]
    },
    color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
    backgroundColor: (theme.vars || theme).palette.grey[300],
    '&:hover': {
      backgroundColor: (theme.vars || theme).palette.grey.A100,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: (theme.vars || theme).palette.grey[300]
      },
      textDecoration: 'none'
    },
    [`&.${_fabClasses.default.focusVisible}`]: {
      boxShadow: (theme.vars || theme).shadows[6]
    }
  }, ownerState.size === 'small' && {
    width: 40,
    height: 40
  }, ownerState.size === 'medium' && {
    width: 48,
    height: 48
  }, ownerState.variant === 'extended' && {
    borderRadius: 48 / 2,
    padding: '0 16px',
    width: 'auto',
    minHeight: 'auto',
    minWidth: 48,
    height: 48
  }, ownerState.variant === 'extended' && ownerState.size === 'small' && {
    width: 'auto',
    padding: '0 8px',
    borderRadius: 34 / 2,
    minWidth: 34,
    height: 34
  }, ownerState.variant === 'extended' && ownerState.size === 'medium' && {
    width: 'auto',
    padding: '0 16px',
    borderRadius: 40 / 2,
    minWidth: 40,
    height: 40
  }, ownerState.color === 'inherit' && {
    color: 'inherit'
  });
}, ({
  theme,
  ownerState
}) => (0, _extends2$1m.default)({}, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (theme.vars || theme).palette[ownerState.color] != null && {
  color: (theme.vars || theme).palette[ownerState.color].contrastText,
  backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
  '&:hover': {
    backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }
  }
}), ({
  theme
}) => ({
  [`&.${_fabClasses.default.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled,
    boxShadow: (theme.vars || theme).shadows[0],
    backgroundColor: (theme.vars || theme).palette.action.disabledBackground
  }
}));
const Fab = /*#__PURE__*/React$1H.forwardRef(function Fab(inProps, ref) {
  const props = (0, _DefaultPropsProvider$16.useDefaultProps)({
    props: inProps,
    name: 'MuiFab'
  });
  const {
      children,
      className,
      color = 'default',
      component = 'button',
      disabled = false,
      disableFocusRipple = false,
      focusVisibleClassName,
      size = 'large',
      variant = 'circular'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1j.default)(props, _excluded$1N);
  const ownerState = (0, _extends2$1m.default)({}, props, {
    color,
    component,
    disabled,
    disableFocusRipple,
    size,
    variant
  });
  const classes = useUtilityClasses$17(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1A.jsx)(FabRoot, (0, _extends2$1m.default)({
    className: (0, _clsx$1G.default)(classes.root, className),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0, _clsx$1G.default)(classes.focusVisible, focusVisibleClassName),
    ownerState: ownerState,
    ref: ref
  }, other, {
    classes: classes,
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? Fab.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1N.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1N.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1N.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: _propTypes$1N.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1N.default.oneOf(['default', 'error', 'info', 'inherit', 'primary', 'secondary', 'success', 'warning']), _propTypes$1N.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1N.default.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$1N.default.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: _propTypes$1N.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   */
  disableRipple: _propTypes$1N.default.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes$1N.default.string,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: _propTypes$1N.default.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'large'
   */
  size: _propTypes$1N.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1N.default.oneOf(['small', 'medium', 'large']), _propTypes$1N.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1N.default.oneOfType([_propTypes$1N.default.arrayOf(_propTypes$1N.default.oneOfType([_propTypes$1N.default.func, _propTypes$1N.default.object, _propTypes$1N.default.bool])), _propTypes$1N.default.func, _propTypes$1N.default.object]),
  /**
   * The variant to use.
   * @default 'circular'
   */
  variant: _propTypes$1N.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1N.default.oneOf(['circular', 'extended']), _propTypes$1N.default.string])
} : void 0;
Fab$1.default = Fab;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  fabClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Fab.default;
  }
});
Object.defineProperty(exports, "fabClasses", {
  enumerable: true,
  get: function () {
    return _fabClasses.default;
  }
});
var _Fab = _interopRequireDefault(Fab$1);
var _fabClasses = _interopRequireWildcard(fabClasses$1);
Object.keys(_fabClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _fabClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fabClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Fab$2));

var FilledInput$2 = {};

var FilledInput$1 = {};

var _interopRequireDefault$68 = interopRequireDefault$1.exports;
Object.defineProperty(FilledInput$1, "__esModule", {
  value: true
});
FilledInput$1.default = void 0;
var _objectWithoutPropertiesLoose2$1i = _interopRequireDefault$68(objectWithoutPropertiesLoose.exports);
var _extends2$1l = _interopRequireDefault$68(_extends$19.exports);
var React$1G = _interopRequireWildcard$2O(React__default$4);
var _deepmerge$2 = _interopRequireDefault$68(deepmerge$2);
var _refType$a = _interopRequireDefault$68(refType$2);
var _propTypes$1M = _interopRequireDefault$68(propTypes.exports);
var _composeClasses$15 = _interopRequireDefault$68(composeClasses$2);
var _InputBase$3 = _interopRequireDefault$68(InputBase$3);
var _styled$14 = _interopRequireWildcard$2O(styled$2);
var _DefaultPropsProvider$15 = DefaultPropsProvider$5;
var _filledInputClasses = _interopRequireWildcard$2O(filledInputClasses$1);
var _InputBase2$2 = InputBase$2;
var _jsxRuntime$1z = require$$11;
const _excluded$1M = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"];
function _getRequireWildcardCache$2x(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2x = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2O(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2x(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$16 = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = (0, _composeClasses$15.default)(slots, _filledInputClasses.getFilledInputUtilityClass, classes);
  return (0, _extends2$1l.default)({}, classes, composedClasses);
};
const FilledInputRoot = (0, _styled$14.default)(_InputBase2$2.InputBaseRoot, {
  shouldForwardProp: prop => (0, _styled$14.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiFilledInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...(0, _InputBase2$2.rootOverridesResolver)(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  var _palette;
  const light = theme.palette.mode === 'light';
  const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
  const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
  const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
  return (0, _extends2$1l.default)({
    position: 'relative',
    backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
    borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
    borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut
    }),
    '&:hover': {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
      }
    },
    [`&.${_filledInputClasses.default.focused}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
    },
    [`&.${_filledInputClasses.default.disabled}`]: {
      backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
    }
  }, !ownerState.disableUnderline && {
    '&::after': {
      borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },
    [`&.${_filledInputClasses.default.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: 'scaleX(1) translateX(0)'
    },
    [`&.${_filledInputClasses.default.error}`]: {
      '&::before, &::after': {
        borderBottomColor: (theme.vars || theme).palette.error.main
      }
    },
    '&::before': {
      borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },
    [`&:hover:not(.${_filledInputClasses.default.disabled}, .${_filledInputClasses.default.error}):before`]: {
      borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
    },
    [`&.${_filledInputClasses.default.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  }, ownerState.startAdornment && {
    paddingLeft: 12
  }, ownerState.endAdornment && {
    paddingRight: 12
  }, ownerState.multiline && (0, _extends2$1l.default)({
    padding: '25px 12px 8px'
  }, ownerState.size === 'small' && {
    paddingTop: 21,
    paddingBottom: 4
  }, ownerState.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, ownerState.hiddenLabel && ownerState.size === 'small' && {
    paddingTop: 8,
    paddingBottom: 9
  }));
});
const FilledInputInput = (0, _styled$14.default)(_InputBase2$2.InputBaseComponent, {
  name: 'MuiFilledInput',
  slot: 'Input',
  overridesResolver: _InputBase2$2.inputOverridesResolver
})(({
  theme,
  ownerState
}) => (0, _extends2$1l.default)({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !theme.vars && {
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  }
}, theme.vars && {
  '&:-webkit-autofill': {
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  },
  [theme.getColorSchemeSelector('dark')]: {
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #266798 inset',
      WebkitTextFillColor: '#fff',
      caretColor: '#fff'
    }
  }
}, ownerState.size === 'small' && {
  paddingTop: 21,
  paddingBottom: 4
}, ownerState.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}, ownerState.hiddenLabel && ownerState.size === 'small' && {
  paddingTop: 8,
  paddingBottom: 9
}, ownerState.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
}));
const FilledInput = /*#__PURE__*/React$1G.forwardRef(function FilledInput(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$input;
  const props = (0, _DefaultPropsProvider$15.useDefaultProps)({
    props: inProps,
    name: 'MuiFilledInput'
  });
  const {
      components = {},
      componentsProps: componentsPropsProp,
      fullWidth = false,
      // declare here to prevent spreading to DOM
      inputComponent = 'input',
      multiline = false,
      slotProps,
      slots = {},
      type = 'text'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1i.default)(props, _excluded$1M);
  const ownerState = (0, _extends2$1l.default)({}, props, {
    fullWidth,
    inputComponent,
    multiline,
    type
  });
  const classes = useUtilityClasses$16(props);
  const filledInputComponentsProps = {
    root: {
      ownerState
    },
    input: {
      ownerState
    }
  };
  const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, _deepmerge$2.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
  const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : FilledInputRoot;
  const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : FilledInputInput;
  return /*#__PURE__*/(0, _jsxRuntime$1z.jsx)(_InputBase$3.default, (0, _extends2$1l.default)({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    componentsProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? FilledInput.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _propTypes$1M.default.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: _propTypes$1M.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1M.default.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: _propTypes$1M.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1M.default.oneOf(['primary', 'secondary']), _propTypes$1M.default.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$1M.default.shape({
    Input: _propTypes$1M.default.elementType,
    Root: _propTypes$1M.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: _propTypes$1M.default.shape({
    input: _propTypes$1M.default.object,
    root: _propTypes$1M.default.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes$1M.default.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: _propTypes$1M.default.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: _propTypes$1M.default.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes$1M.default.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: _propTypes$1M.default.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$1M.default.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: _propTypes$1M.default.bool,
  /**
   * The id of the `input` element.
   */
  id: _propTypes$1M.default.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: _propTypes$1M.default.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: _propTypes$1M.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType$a.default,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: _propTypes$1M.default.oneOf(['dense', 'none']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _propTypes$1M.default.oneOfType([_propTypes$1M.default.number, _propTypes$1M.default.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: _propTypes$1M.default.oneOfType([_propTypes$1M.default.number, _propTypes$1M.default.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: _propTypes$1M.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes$1M.default.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes$1M.default.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: _propTypes$1M.default.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes$1M.default.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: _propTypes$1M.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes$1M.default.oneOfType([_propTypes$1M.default.number, _propTypes$1M.default.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: _propTypes$1M.default.shape({
    input: _propTypes$1M.default.object,
    root: _propTypes$1M.default.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: _propTypes$1M.default.shape({
    input: _propTypes$1M.default.elementType,
    root: _propTypes$1M.default.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes$1M.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1M.default.oneOfType([_propTypes$1M.default.arrayOf(_propTypes$1M.default.oneOfType([_propTypes$1M.default.func, _propTypes$1M.default.object, _propTypes$1M.default.bool])), _propTypes$1M.default.func, _propTypes$1M.default.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: _propTypes$1M.default.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _propTypes$1M.default.any
} : void 0;
FilledInput.muiName = 'Input';
FilledInput$1.default = FilledInput;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  filledInputClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FilledInput.default;
  }
});
Object.defineProperty(exports, "filledInputClasses", {
  enumerable: true,
  get: function () {
    return _filledInputClasses.default;
  }
});
var _FilledInput = _interopRequireDefault(FilledInput$1);
var _filledInputClasses = _interopRequireWildcard(filledInputClasses$1);
Object.keys(_filledInputClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _filledInputClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _filledInputClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(FilledInput$2));

var FormControl$3 = {};

var FormControl$2 = {};

var formControlClasses$1 = {};

var _interopRequireDefault$67 = interopRequireDefault$1.exports;
Object.defineProperty(formControlClasses$1, "__esModule", {
  value: true
});
formControlClasses$1.default = void 0;
formControlClasses$1.getFormControlUtilityClasses = getFormControlUtilityClasses;
var _generateUtilityClasses$13 = _interopRequireDefault$67(generateUtilityClasses$3);
var _generateUtilityClass$13 = _interopRequireDefault$67(generateUtilityClass$3);
function getFormControlUtilityClasses(slot) {
  return (0, _generateUtilityClass$13.default)('MuiFormControl', slot);
}
const formControlClasses = (0, _generateUtilityClasses$13.default)('MuiFormControl', ['root', 'marginNone', 'marginNormal', 'marginDense', 'fullWidth', 'disabled']);
formControlClasses$1.default = formControlClasses;

var _interopRequireDefault$66 = interopRequireDefault$1.exports;
Object.defineProperty(FormControl$2, "__esModule", {
  value: true
});
FormControl$2.default = void 0;
var _objectWithoutPropertiesLoose2$1h = _interopRequireDefault$66(objectWithoutPropertiesLoose.exports);
var _extends2$1k = _interopRequireDefault$66(_extends$19.exports);
var React$1F = _interopRequireWildcard$2N(React__default$4);
var _propTypes$1L = _interopRequireDefault$66(propTypes.exports);
var _clsx$1F = _interopRequireDefault$66(clsx.exports);
var _composeClasses$14 = _interopRequireDefault$66(composeClasses$2);
var _DefaultPropsProvider$14 = DefaultPropsProvider$5;
var _styled$13 = _interopRequireDefault$66(styled$2);
var _utils$H = utils$5;
var _capitalize$s = _interopRequireDefault$66(capitalize$1);
var _isMuiElement$4 = _interopRequireDefault$66(isMuiElement);
var _FormControlContext$1 = _interopRequireDefault$66(FormControlContext$1);
var _formControlClasses = formControlClasses$1;
var _jsxRuntime$1y = require$$11;
const _excluded$1L = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"];
function _getRequireWildcardCache$2w(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2w = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2N(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2w(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$15 = ownerState => {
  const {
    classes,
    margin,
    fullWidth
  } = ownerState;
  const slots = {
    root: ['root', margin !== 'none' && `margin${(0, _capitalize$s.default)(margin)}`, fullWidth && 'fullWidth']
  };
  return (0, _composeClasses$14.default)(slots, _formControlClasses.getFormControlUtilityClasses, classes);
};
const FormControlRoot = (0, _styled$13.default)('div', {
  name: 'MuiFormControl',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return (0, _extends2$1k.default)({}, styles.root, styles[`margin${(0, _capitalize$s.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
  }
})(({
  ownerState
}) => (0, _extends2$1k.default)({
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: 'top'
}, ownerState.margin === 'normal' && {
  marginTop: 16,
  marginBottom: 8
}, ownerState.margin === 'dense' && {
  marginTop: 8,
  marginBottom: 4
}, ownerState.fullWidth && {
  width: '100%'
}));

/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */
const FormControl$1 = /*#__PURE__*/React$1F.forwardRef(function FormControl(inProps, ref) {
  const props = (0, _DefaultPropsProvider$14.useDefaultProps)({
    props: inProps,
    name: 'MuiFormControl'
  });
  const {
      children,
      className,
      color = 'primary',
      component = 'div',
      disabled = false,
      error = false,
      focused: visuallyFocused,
      fullWidth = false,
      hiddenLabel = false,
      margin = 'none',
      required = false,
      size = 'medium',
      variant = 'outlined'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1h.default)(props, _excluded$1L);
  const ownerState = (0, _extends2$1k.default)({}, props, {
    color,
    component,
    disabled,
    error,
    fullWidth,
    hiddenLabel,
    margin,
    required,
    size,
    variant
  });
  const classes = useUtilityClasses$15(ownerState);
  const [adornedStart, setAdornedStart] = React$1F.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialAdornedStart = false;
    if (children) {
      React$1F.Children.forEach(children, child => {
        if (!(0, _isMuiElement$4.default)(child, ['Input', 'Select'])) {
          return;
        }
        const input = (0, _isMuiElement$4.default)(child, ['Select']) ? child.props.input : child;
        if (input && (0, _utils$H.isAdornedStart)(input.props)) {
          initialAdornedStart = true;
        }
      });
    }
    return initialAdornedStart;
  });
  const [filled, setFilled] = React$1F.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialFilled = false;
    if (children) {
      React$1F.Children.forEach(children, child => {
        if (!(0, _isMuiElement$4.default)(child, ['Input', 'Select'])) {
          return;
        }
        if ((0, _utils$H.isFilled)(child.props, true) || (0, _utils$H.isFilled)(child.props.inputProps, true)) {
          initialFilled = true;
        }
      });
    }
    return initialFilled;
  });
  const [focusedState, setFocused] = React$1F.useState(false);
  if (disabled && focusedState) {
    setFocused(false);
  }
  const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
  let registerEffect;
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const registeredInput = React$1F.useRef(false);
    registerEffect = () => {
      if (registeredInput.current) {
        console.error(['MUI: There are multiple `InputBase` components inside a FormControl.', 'This creates visual inconsistencies, only use one `InputBase`.'].join('\n'));
      }
      registeredInput.current = true;
      return () => {
        registeredInput.current = false;
      };
    };
  }
  const childContext = React$1F.useMemo(() => {
    return {
      adornedStart,
      setAdornedStart,
      color,
      disabled,
      error,
      filled,
      focused,
      fullWidth,
      hiddenLabel,
      size,
      onBlur: () => {
        setFocused(false);
      },
      onEmpty: () => {
        setFilled(false);
      },
      onFilled: () => {
        setFilled(true);
      },
      onFocus: () => {
        setFocused(true);
      },
      registerEffect,
      required,
      variant
    };
  }, [adornedStart, color, disabled, error, filled, focused, fullWidth, hiddenLabel, registerEffect, required, size, variant]);
  return /*#__PURE__*/(0, _jsxRuntime$1y.jsx)(_FormControlContext$1.default.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0, _jsxRuntime$1y.jsx)(FormControlRoot, (0, _extends2$1k.default)({
      as: component,
      ownerState: ownerState,
      className: (0, _clsx$1F.default)(classes.root, className),
      ref: ref
    }, other, {
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? FormControl$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1L.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1L.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1L.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$1L.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1L.default.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$1L.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1L.default.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: _propTypes$1L.default.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: _propTypes$1L.default.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: _propTypes$1L.default.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$1L.default.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: _propTypes$1L.default.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: _propTypes$1L.default.oneOf(['dense', 'none', 'normal']),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: _propTypes$1L.default.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: _propTypes$1L.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1L.default.oneOf(['medium', 'small']), _propTypes$1L.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1L.default.oneOfType([_propTypes$1L.default.arrayOf(_propTypes$1L.default.oneOfType([_propTypes$1L.default.func, _propTypes$1L.default.object, _propTypes$1L.default.bool])), _propTypes$1L.default.func, _propTypes$1L.default.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: _propTypes$1L.default.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
FormControl$2.default = FormControl$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useFormControl: true,
  formControlClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FormControl.default;
  }
});
Object.defineProperty(exports, "formControlClasses", {
  enumerable: true,
  get: function () {
    return _formControlClasses.default;
  }
});
Object.defineProperty(exports, "useFormControl", {
  enumerable: true,
  get: function () {
    return _useFormControl.default;
  }
});
var _FormControl = _interopRequireDefault(FormControl$2);
var _useFormControl = _interopRequireDefault(useFormControl$1);
var _formControlClasses = _interopRequireWildcard(formControlClasses$1);
Object.keys(_formControlClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formControlClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formControlClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(FormControl$3));

var FormControl = /*@__PURE__*/getDefaultExportFromCjs$1(FormControl$3);

var FormControlLabel$2 = {};

var FormControlLabel$1 = {};

var Stack$7 = {};

var Stack$6 = {};

var _interopRequireDefault$65 = interopRequireDefault$1.exports;
Object.defineProperty(Stack$6, "__esModule", {
  value: true
});
Stack$6.default = void 0;
var _propTypes$1K = _interopRequireDefault$65(propTypes.exports);
var _system$4 = system;
var _styled$12 = _interopRequireDefault$65(styled$2);
var _DefaultPropsProvider$13 = DefaultPropsProvider$5;
const Stack$5 = (0, _system$4.createStack)({
  createStyledComponent: (0, _styled$12.default)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles) => styles.root
  }),
  useThemeProps: inProps => (0, _DefaultPropsProvider$13.useDefaultProps)({
    props: inProps,
    name: 'MuiStack'
  })
});
process.env.NODE_ENV !== "production" ? Stack$5.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1K.default.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1K.default.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: _propTypes$1K.default.oneOfType([_propTypes$1K.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), _propTypes$1K.default.arrayOf(_propTypes$1K.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), _propTypes$1K.default.object]),
  /**
   * Add an element between each child.
   */
  divider: _propTypes$1K.default.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: _propTypes$1K.default.oneOfType([_propTypes$1K.default.arrayOf(_propTypes$1K.default.oneOfType([_propTypes$1K.default.number, _propTypes$1K.default.string])), _propTypes$1K.default.number, _propTypes$1K.default.object, _propTypes$1K.default.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1K.default.oneOfType([_propTypes$1K.default.arrayOf(_propTypes$1K.default.oneOfType([_propTypes$1K.default.func, _propTypes$1K.default.object, _propTypes$1K.default.bool])), _propTypes$1K.default.func, _propTypes$1K.default.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: _propTypes$1K.default.bool
} : void 0;
Stack$6.default = Stack$5;

var stackClasses$1 = {};

var _interopRequireDefault$64 = interopRequireDefault$1.exports;
Object.defineProperty(stackClasses$1, "__esModule", {
  value: true
});
stackClasses$1.default = void 0;
stackClasses$1.getStackUtilityClass = getStackUtilityClass;
var _generateUtilityClasses$12 = _interopRequireDefault$64(generateUtilityClasses$3);
var _generateUtilityClass$12 = _interopRequireDefault$64(generateUtilityClass$3);
function getStackUtilityClass(slot) {
  return (0, _generateUtilityClass$12.default)('MuiStack', slot);
}
const stackClasses = (0, _generateUtilityClasses$12.default)('MuiStack', ['root']);
stackClasses$1.default = stackClasses;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Stack.default;
  }
});
Object.defineProperty(exports, "stackClasses", {
  enumerable: true,
  get: function () {
    return _stackClasses.default;
  }
});
var _Stack = _interopRequireDefault(Stack$6);
var _stackClasses = _interopRequireDefault(stackClasses$1);
}(Stack$7));

var formControlLabelClasses$1 = {};

var _interopRequireDefault$63 = interopRequireDefault$1.exports;
Object.defineProperty(formControlLabelClasses$1, "__esModule", {
  value: true
});
formControlLabelClasses$1.default = void 0;
formControlLabelClasses$1.getFormControlLabelUtilityClasses = getFormControlLabelUtilityClasses;
var _generateUtilityClasses$11 = _interopRequireDefault$63(generateUtilityClasses$3);
var _generateUtilityClass$11 = _interopRequireDefault$63(generateUtilityClass$3);
function getFormControlLabelUtilityClasses(slot) {
  return (0, _generateUtilityClass$11.default)('MuiFormControlLabel', slot);
}
const formControlLabelClasses = (0, _generateUtilityClasses$11.default)('MuiFormControlLabel', ['root', 'labelPlacementStart', 'labelPlacementTop', 'labelPlacementBottom', 'disabled', 'label', 'error', 'required', 'asterisk']);
formControlLabelClasses$1.default = formControlLabelClasses;

var _interopRequireDefault$62 = interopRequireDefault$1.exports;
Object.defineProperty(FormControlLabel$1, "__esModule", {
  value: true
});
FormControlLabel$1.default = FormControlLabel$1.FormControlLabelRoot = void 0;
var _objectWithoutPropertiesLoose2$1g = _interopRequireDefault$62(objectWithoutPropertiesLoose.exports);
var _extends2$1j = _interopRequireDefault$62(_extends$19.exports);
var React$1E = _interopRequireWildcard$2M(React__default$4);
var _propTypes$1J = _interopRequireDefault$62(propTypes.exports);
var _clsx$1E = _interopRequireDefault$62(clsx.exports);
var _refType$9 = _interopRequireDefault$62(refType$2);
var _composeClasses$13 = _interopRequireDefault$62(composeClasses$2);
var _FormControl$1 = FormControl$3;
var _Stack$1 = _interopRequireDefault$62(Stack$7);
var _Typography$3 = _interopRequireDefault$62(Typography$3);
var _capitalize$r = _interopRequireDefault$62(capitalize$1);
var _styled$11 = _interopRequireDefault$62(styled$2);
var _DefaultPropsProvider$12 = DefaultPropsProvider$5;
var _formControlLabelClasses = _interopRequireWildcard$2M(formControlLabelClasses$1);
var _formControlState$7 = _interopRequireDefault$62(formControlState$1);
var _jsxRuntime$1x = require$$11;
const _excluded$1K = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"];
function _getRequireWildcardCache$2v(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2v = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2M(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2v(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$14 = ownerState => {
  const {
    classes,
    disabled,
    labelPlacement,
    error,
    required
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', `labelPlacement${(0, _capitalize$r.default)(labelPlacement)}`, error && 'error', required && 'required'],
    label: ['label', disabled && 'disabled'],
    asterisk: ['asterisk', error && 'error']
  };
  return (0, _composeClasses$13.default)(slots, _formControlLabelClasses.getFormControlLabelUtilityClasses, classes);
};
const FormControlLabelRoot = FormControlLabel$1.FormControlLabelRoot = (0, _styled$11.default)('label', {
  name: 'MuiFormControlLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_formControlLabelClasses.default.label}`]: styles.label
    }, styles.root, styles[`labelPlacement${(0, _capitalize$r.default)(ownerState.labelPlacement)}`]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1j.default)({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  // For correct alignment with the text.
  verticalAlign: 'middle',
  WebkitTapHighlightColor: 'transparent',
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${_formControlLabelClasses.default.disabled}`]: {
    cursor: 'default'
  }
}, ownerState.labelPlacement === 'start' && {
  flexDirection: 'row-reverse',
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, ownerState.labelPlacement === 'top' && {
  flexDirection: 'column-reverse',
  marginLeft: 16
}, ownerState.labelPlacement === 'bottom' && {
  flexDirection: 'column',
  marginLeft: 16
}, {
  [`& .${_formControlLabelClasses.default.label}`]: {
    [`&.${_formControlLabelClasses.default.disabled}`]: {
      color: (theme.vars || theme).palette.text.disabled
    }
  }
}));
const AsteriskComponent$1 = (0, _styled$11.default)('span', {
  name: 'MuiFormControlLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})(({
  theme
}) => ({
  [`&.${_formControlLabelClasses.default.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));

/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */
const FormControlLabel = /*#__PURE__*/React$1E.forwardRef(function FormControlLabel(inProps, ref) {
  var _ref, _slotProps$typography;
  const props = (0, _DefaultPropsProvider$12.useDefaultProps)({
    props: inProps,
    name: 'MuiFormControlLabel'
  });
  const {
      className,
      componentsProps = {},
      control,
      disabled: disabledProp,
      disableTypography,
      label: labelProp,
      labelPlacement = 'end',
      required: requiredProp,
      slotProps = {}
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1g.default)(props, _excluded$1K);
  const muiFormControl = (0, _FormControl$1.useFormControl)();
  const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
  const required = requiredProp != null ? requiredProp : control.props.required;
  const controlProps = {
    disabled,
    required
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(key => {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  const fcs = (0, _formControlState$7.default)({
    props,
    muiFormControl,
    states: ['error']
  });
  const ownerState = (0, _extends2$1j.default)({}, props, {
    disabled,
    labelPlacement,
    required,
    error: fcs.error
  });
  const classes = useUtilityClasses$14(ownerState);
  const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
  let label = labelProp;
  if (label != null && label.type !== _Typography$3.default && !disableTypography) {
    label = /*#__PURE__*/(0, _jsxRuntime$1x.jsx)(_Typography$3.default, (0, _extends2$1j.default)({
      component: "span"
    }, typographySlotProps, {
      className: (0, _clsx$1E.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
      children: label
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime$1x.jsxs)(FormControlLabelRoot, (0, _extends2$1j.default)({
    className: (0, _clsx$1E.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/React$1E.cloneElement(control, controlProps), required ? /*#__PURE__*/(0, _jsxRuntime$1x.jsxs)(_Stack$1.default, {
      display: "block",
      children: [label, /*#__PURE__*/(0, _jsxRuntime$1x.jsxs)(AsteriskComponent$1, {
        ownerState: ownerState,
        "aria-hidden": true,
        className: classes.asterisk,
        children: ["\u2009", '*']
      })]
    }) : label]
  }));
});
process.env.NODE_ENV !== "production" ? FormControlLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: _propTypes$1J.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1J.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1J.default.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: _propTypes$1J.default.shape({
    typography: _propTypes$1J.default.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: _propTypes$1J.default.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: _propTypes$1J.default.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: _propTypes$1J.default.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType$9.default,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: _propTypes$1J.default.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: _propTypes$1J.default.oneOf(['bottom', 'end', 'start', 'top']),
  /**
   * @ignore
   */
  name: _propTypes$1J.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: _propTypes$1J.default.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: _propTypes$1J.default.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: _propTypes$1J.default.shape({
    typography: _propTypes$1J.default.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1J.default.oneOfType([_propTypes$1J.default.arrayOf(_propTypes$1J.default.oneOfType([_propTypes$1J.default.func, _propTypes$1J.default.object, _propTypes$1J.default.bool])), _propTypes$1J.default.func, _propTypes$1J.default.object]),
  /**
   * The value of the component.
   */
  value: _propTypes$1J.default.any
} : void 0;
FormControlLabel$1.default = FormControlLabel;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  formControlLabelClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FormControlLabel.default;
  }
});
Object.defineProperty(exports, "formControlLabelClasses", {
  enumerable: true,
  get: function () {
    return _formControlLabelClasses.default;
  }
});
var _FormControlLabel = _interopRequireDefault(FormControlLabel$1);
var _formControlLabelClasses = _interopRequireWildcard(formControlLabelClasses$1);
Object.keys(_formControlLabelClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formControlLabelClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formControlLabelClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(FormControlLabel$2));

var FormGroup$2 = {};

var FormGroup$1 = {};

var formGroupClasses$1 = {};

var _interopRequireDefault$61 = interopRequireDefault$1.exports;
Object.defineProperty(formGroupClasses$1, "__esModule", {
  value: true
});
formGroupClasses$1.default = void 0;
formGroupClasses$1.getFormGroupUtilityClass = getFormGroupUtilityClass;
var _generateUtilityClasses$10 = _interopRequireDefault$61(generateUtilityClasses$3);
var _generateUtilityClass$10 = _interopRequireDefault$61(generateUtilityClass$3);
function getFormGroupUtilityClass(slot) {
  return (0, _generateUtilityClass$10.default)('MuiFormGroup', slot);
}
const formGroupClasses = (0, _generateUtilityClasses$10.default)('MuiFormGroup', ['root', 'row', 'error']);
formGroupClasses$1.default = formGroupClasses;

var _interopRequireDefault$60 = interopRequireDefault$1.exports;
Object.defineProperty(FormGroup$1, "__esModule", {
  value: true
});
FormGroup$1.default = void 0;
var _objectWithoutPropertiesLoose2$1f = _interopRequireDefault$60(objectWithoutPropertiesLoose.exports);
var _extends2$1i = _interopRequireDefault$60(_extends$19.exports);
var React$1D = _interopRequireWildcard$2L(React__default$4);
var _propTypes$1I = _interopRequireDefault$60(propTypes.exports);
var _clsx$1D = _interopRequireDefault$60(clsx.exports);
var _composeClasses$12 = _interopRequireDefault$60(composeClasses$2);
var _styled$10 = _interopRequireDefault$60(styled$2);
var _DefaultPropsProvider$11 = DefaultPropsProvider$5;
var _formGroupClasses = formGroupClasses$1;
var _useFormControl$7 = _interopRequireDefault$60(useFormControl$1);
var _formControlState$6 = _interopRequireDefault$60(formControlState$1);
var _jsxRuntime$1w = require$$11;
const _excluded$1J = ["className", "row"];
function _getRequireWildcardCache$2u(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2u = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2L(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2u(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$13 = ownerState => {
  const {
    classes,
    row,
    error
  } = ownerState;
  const slots = {
    root: ['root', row && 'row', error && 'error']
  };
  return (0, _composeClasses$12.default)(slots, _formGroupClasses.getFormGroupUtilityClass, classes);
};
const FormGroupRoot = (0, _styled$10.default)('div', {
  name: 'MuiFormGroup',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.row && styles.row];
  }
})(({
  ownerState
}) => (0, _extends2$1i.default)({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap'
}, ownerState.row && {
  flexDirection: 'row'
}));

/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */
const FormGroup = /*#__PURE__*/React$1D.forwardRef(function FormGroup(inProps, ref) {
  const props = (0, _DefaultPropsProvider$11.useDefaultProps)({
    props: inProps,
    name: 'MuiFormGroup'
  });
  const {
      className,
      row = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1f.default)(props, _excluded$1J);
  const muiFormControl = (0, _useFormControl$7.default)();
  const fcs = (0, _formControlState$6.default)({
    props,
    muiFormControl,
    states: ['error']
  });
  const ownerState = (0, _extends2$1i.default)({}, props, {
    row,
    error: fcs.error
  });
  const classes = useUtilityClasses$13(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1w.jsx)(FormGroupRoot, (0, _extends2$1i.default)({
    className: (0, _clsx$1D.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? FormGroup.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1I.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1I.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1I.default.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: _propTypes$1I.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1I.default.oneOfType([_propTypes$1I.default.arrayOf(_propTypes$1I.default.oneOfType([_propTypes$1I.default.func, _propTypes$1I.default.object, _propTypes$1I.default.bool])), _propTypes$1I.default.func, _propTypes$1I.default.object])
} : void 0;
FormGroup$1.default = FormGroup;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  formGroupClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FormGroup.default;
  }
});
Object.defineProperty(exports, "formGroupClasses", {
  enumerable: true,
  get: function () {
    return _formGroupClasses.default;
  }
});
var _FormGroup = _interopRequireDefault(FormGroup$1);
var _formGroupClasses = _interopRequireWildcard(formGroupClasses$1);
Object.keys(_formGroupClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formGroupClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formGroupClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(FormGroup$2));

var FormHelperText$2 = {};

var FormHelperText$1 = {};

var formHelperTextClasses$1 = {};

var _interopRequireDefault$5$ = interopRequireDefault$1.exports;
Object.defineProperty(formHelperTextClasses$1, "__esModule", {
  value: true
});
formHelperTextClasses$1.default = void 0;
formHelperTextClasses$1.getFormHelperTextUtilityClasses = getFormHelperTextUtilityClasses;
var _generateUtilityClasses$$ = _interopRequireDefault$5$(generateUtilityClasses$3);
var _generateUtilityClass$$ = _interopRequireDefault$5$(generateUtilityClass$3);
function getFormHelperTextUtilityClasses(slot) {
  return (0, _generateUtilityClass$$.default)('MuiFormHelperText', slot);
}
const formHelperTextClasses = (0, _generateUtilityClasses$$.default)('MuiFormHelperText', ['root', 'error', 'disabled', 'sizeSmall', 'sizeMedium', 'contained', 'focused', 'filled', 'required']);
formHelperTextClasses$1.default = formHelperTextClasses;

var _interopRequireDefault$5_ = interopRequireDefault$1.exports;
Object.defineProperty(FormHelperText$1, "__esModule", {
  value: true
});
FormHelperText$1.default = void 0;
var _objectWithoutPropertiesLoose2$1e = _interopRequireDefault$5_(objectWithoutPropertiesLoose.exports);
var _extends2$1h = _interopRequireDefault$5_(_extends$19.exports);
var React$1C = _interopRequireWildcard$2K(React__default$4);
var _propTypes$1H = _interopRequireDefault$5_(propTypes.exports);
var _clsx$1C = _interopRequireDefault$5_(clsx.exports);
var _composeClasses$11 = _interopRequireDefault$5_(composeClasses$2);
var _formControlState$5 = _interopRequireDefault$5_(formControlState$1);
var _useFormControl$6 = _interopRequireDefault$5_(useFormControl$1);
var _styled$$ = _interopRequireDefault$5_(styled$2);
var _capitalize$q = _interopRequireDefault$5_(capitalize$1);
var _formHelperTextClasses = _interopRequireWildcard$2K(formHelperTextClasses$1);
var _DefaultPropsProvider$10 = DefaultPropsProvider$5;
var _jsxRuntime$1v = require$$11;
var _span$3;
const _excluded$1I = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"];
function _getRequireWildcardCache$2t(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2t = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2K(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2t(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$12 = ownerState => {
  const {
    classes,
    contained,
    size,
    disabled,
    error,
    filled,
    focused,
    required
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', error && 'error', size && `size${(0, _capitalize$q.default)(size)}`, contained && 'contained', focused && 'focused', filled && 'filled', required && 'required']
  };
  return (0, _composeClasses$11.default)(slots, _formHelperTextClasses.getFormHelperTextUtilityClasses, classes);
};
const FormHelperTextRoot = (0, _styled$$.default)('p', {
  name: 'MuiFormHelperText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.size && styles[`size${(0, _capitalize$q.default)(ownerState.size)}`], ownerState.contained && styles.contained, ownerState.filled && styles.filled];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1h.default)({
  color: (theme.vars || theme).palette.text.secondary
}, theme.typography.caption, {
  textAlign: 'left',
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${_formHelperTextClasses.default.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${_formHelperTextClasses.default.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}, ownerState.size === 'small' && {
  marginTop: 4
}, ownerState.contained && {
  marginLeft: 14,
  marginRight: 14
}));
const FormHelperText = /*#__PURE__*/React$1C.forwardRef(function FormHelperText(inProps, ref) {
  const props = (0, _DefaultPropsProvider$10.useDefaultProps)({
    props: inProps,
    name: 'MuiFormHelperText'
  });
  const {
      children,
      className,
      component = 'p'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1e.default)(props, _excluded$1I);
  const muiFormControl = (0, _useFormControl$6.default)();
  const fcs = (0, _formControlState$5.default)({
    props,
    muiFormControl,
    states: ['variant', 'size', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  const ownerState = (0, _extends2$1h.default)({}, props, {
    component,
    contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
    variant: fcs.variant,
    size: fcs.size,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });
  const classes = useUtilityClasses$12(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1v.jsx)(FormHelperTextRoot, (0, _extends2$1h.default)({
    as: component,
    ownerState: ownerState,
    className: (0, _clsx$1C.default)(classes.root, className),
    ref: ref
  }, other, {
    children: children === ' ' ? // notranslate needed while Google Translate will not fix zero-width space issue
    _span$3 || (_span$3 = /*#__PURE__*/(0, _jsxRuntime$1v.jsx)("span", {
      className: "notranslate",
      children: "\u200B"
    })) : children
  }));
});
process.env.NODE_ENV !== "production" ? FormHelperText.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: _propTypes$1H.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1H.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1H.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1H.default.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: _propTypes$1H.default.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: _propTypes$1H.default.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: _propTypes$1H.default.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: _propTypes$1H.default.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes$1H.default.oneOf(['dense']),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: _propTypes$1H.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1H.default.oneOfType([_propTypes$1H.default.arrayOf(_propTypes$1H.default.oneOfType([_propTypes$1H.default.func, _propTypes$1H.default.object, _propTypes$1H.default.bool])), _propTypes$1H.default.func, _propTypes$1H.default.object]),
  /**
   * The variant to use.
   */
  variant: _propTypes$1H.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1H.default.oneOf(['filled', 'outlined', 'standard']), _propTypes$1H.default.string])
} : void 0;
FormHelperText$1.default = FormHelperText;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  formHelperTextClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FormHelperText.default;
  }
});
Object.defineProperty(exports, "formHelperTextClasses", {
  enumerable: true,
  get: function () {
    return _formHelperTextClasses.default;
  }
});
var _FormHelperText = _interopRequireDefault(FormHelperText$1);
var _formHelperTextClasses = _interopRequireWildcard(formHelperTextClasses$1);
Object.keys(_formHelperTextClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formHelperTextClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formHelperTextClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(FormHelperText$2));

var FormLabel$3 = {};

var FormLabel$2 = {};

var formLabelClasses$1 = {};

var _interopRequireDefault$5Z = interopRequireDefault$1.exports;
Object.defineProperty(formLabelClasses$1, "__esModule", {
  value: true
});
formLabelClasses$1.default = void 0;
formLabelClasses$1.getFormLabelUtilityClasses = getFormLabelUtilityClasses;
var _generateUtilityClasses$_ = _interopRequireDefault$5Z(generateUtilityClasses$3);
var _generateUtilityClass$_ = _interopRequireDefault$5Z(generateUtilityClass$3);
function getFormLabelUtilityClasses(slot) {
  return (0, _generateUtilityClass$_.default)('MuiFormLabel', slot);
}
const formLabelClasses = (0, _generateUtilityClasses$_.default)('MuiFormLabel', ['root', 'colorSecondary', 'focused', 'disabled', 'error', 'filled', 'required', 'asterisk']);
formLabelClasses$1.default = formLabelClasses;

var _interopRequireDefault$5Y = interopRequireDefault$1.exports;
Object.defineProperty(FormLabel$2, "__esModule", {
  value: true
});
FormLabel$2.default = FormLabel$2.FormLabelRoot = void 0;
var _objectWithoutPropertiesLoose2$1d = _interopRequireDefault$5Y(objectWithoutPropertiesLoose.exports);
var _extends2$1g = _interopRequireDefault$5Y(_extends$19.exports);
var React$1B = _interopRequireWildcard$2J(React__default$4);
var _propTypes$1G = _interopRequireDefault$5Y(propTypes.exports);
var _clsx$1B = _interopRequireDefault$5Y(clsx.exports);
var _composeClasses$10 = _interopRequireDefault$5Y(composeClasses$2);
var _formControlState$4 = _interopRequireDefault$5Y(formControlState$1);
var _useFormControl$5 = _interopRequireDefault$5Y(useFormControl$1);
var _capitalize$p = _interopRequireDefault$5Y(capitalize$1);
var _DefaultPropsProvider$$ = DefaultPropsProvider$5;
var _styled$_ = _interopRequireDefault$5Y(styled$2);
var _formLabelClasses = _interopRequireWildcard$2J(formLabelClasses$1);
var _jsxRuntime$1u = require$$11;
const _excluded$1H = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"];
function _getRequireWildcardCache$2s(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2s = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2J(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2s(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$11 = ownerState => {
  const {
    classes,
    color,
    focused,
    disabled,
    error,
    filled,
    required
  } = ownerState;
  const slots = {
    root: ['root', `color${(0, _capitalize$p.default)(color)}`, disabled && 'disabled', error && 'error', filled && 'filled', focused && 'focused', required && 'required'],
    asterisk: ['asterisk', error && 'error']
  };
  return (0, _composeClasses$10.default)(slots, _formLabelClasses.getFormLabelUtilityClasses, classes);
};
const FormLabelRoot = FormLabel$2.FormLabelRoot = (0, _styled$_.default)('label', {
  name: 'MuiFormLabel',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return (0, _extends2$1g.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$1g.default)({
  color: (theme.vars || theme).palette.text.secondary
}, theme.typography.body1, {
  lineHeight: '1.4375em',
  padding: 0,
  position: 'relative',
  [`&.${_formLabelClasses.default.focused}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${_formLabelClasses.default.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  },
  [`&.${_formLabelClasses.default.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const AsteriskComponent = (0, _styled$_.default)('span', {
  name: 'MuiFormLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})(({
  theme
}) => ({
  [`&.${_formLabelClasses.default.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const FormLabel$1 = /*#__PURE__*/React$1B.forwardRef(function FormLabel(inProps, ref) {
  const props = (0, _DefaultPropsProvider$$.useDefaultProps)({
    props: inProps,
    name: 'MuiFormLabel'
  });
  const {
      children,
      className,
      component = 'label'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1d.default)(props, _excluded$1H);
  const muiFormControl = (0, _useFormControl$5.default)();
  const fcs = (0, _formControlState$4.default)({
    props,
    muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  const ownerState = (0, _extends2$1g.default)({}, props, {
    color: fcs.color || 'primary',
    component,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });
  const classes = useUtilityClasses$11(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1u.jsxs)(FormLabelRoot, (0, _extends2$1g.default)({
    as: component,
    ownerState: ownerState,
    className: (0, _clsx$1B.default)(classes.root, className),
    ref: ref
  }, other, {
    children: [children, fcs.required && /*#__PURE__*/(0, _jsxRuntime$1u.jsxs)(AsteriskComponent, {
      ownerState: ownerState,
      "aria-hidden": true,
      className: classes.asterisk,
      children: ["\u2009", '*']
    })]
  }));
});
process.env.NODE_ENV !== "production" ? FormLabel$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1G.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1G.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1G.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: _propTypes$1G.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1G.default.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']), _propTypes$1G.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1G.default.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: _propTypes$1G.default.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: _propTypes$1G.default.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: _propTypes$1G.default.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: _propTypes$1G.default.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: _propTypes$1G.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1G.default.oneOfType([_propTypes$1G.default.arrayOf(_propTypes$1G.default.oneOfType([_propTypes$1G.default.func, _propTypes$1G.default.object, _propTypes$1G.default.bool])), _propTypes$1G.default.func, _propTypes$1G.default.object])
} : void 0;
FormLabel$2.default = FormLabel$1;

(function (exports) {
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  formLabelClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _FormLabel.default;
  }
});
Object.defineProperty(exports, "formLabelClasses", {
  enumerable: true,
  get: function () {
    return _formLabelClasses.default;
  }
});
var _FormLabel = _interopRequireWildcard(FormLabel$2);
Object.keys(_FormLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormLabel[key];
    }
  });
});
var _formLabelClasses = _interopRequireWildcard(formLabelClasses$1);
Object.keys(_formLabelClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _formLabelClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formLabelClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(FormLabel$3));

var FormLabel = /*@__PURE__*/getDefaultExportFromCjs$1(FormLabel$3);

var Grid$2 = {};

var Grid$1 = {};

var GridContext$1 = {};

Object.defineProperty(GridContext$1, "__esModule", {
  value: true
});
GridContext$1.default = void 0;
var React$1A = _interopRequireWildcard$2I(React__default$4);
function _getRequireWildcardCache$2r(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2r = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2I(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2r(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const GridContext = /*#__PURE__*/React$1A.createContext();
if (process.env.NODE_ENV !== 'production') {
  GridContext.displayName = 'GridContext';
}
GridContext$1.default = GridContext;

var gridClasses$1 = {};

var _interopRequireDefault$5X = interopRequireDefault$1.exports;
Object.defineProperty(gridClasses$1, "__esModule", {
  value: true
});
gridClasses$1.default = void 0;
gridClasses$1.getGridUtilityClass = getGridUtilityClass;
var _generateUtilityClasses$Z = _interopRequireDefault$5X(generateUtilityClasses$3);
var _generateUtilityClass$Z = _interopRequireDefault$5X(generateUtilityClass$3);
function getGridUtilityClass(slot) {
  return (0, _generateUtilityClass$Z.default)('MuiGrid', slot);
}
const SPACINGS$1 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const DIRECTIONS$1 = ['column-reverse', 'column', 'row-reverse', 'row'];
const WRAPS$1 = ['nowrap', 'wrap-reverse', 'wrap'];
const GRID_SIZES$1 = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const gridClasses = (0, _generateUtilityClasses$Z.default)('MuiGrid', ['root', 'container', 'item', 'zeroMinWidth',
// spacings
...SPACINGS$1.map(spacing => `spacing-xs-${spacing}`),
// direction values
...DIRECTIONS$1.map(direction => `direction-xs-${direction}`),
// wrap values
...WRAPS$1.map(wrap => `wrap-xs-${wrap}`),
// grid sizes for all breakpoints
...GRID_SIZES$1.map(size => `grid-xs-${size}`), ...GRID_SIZES$1.map(size => `grid-sm-${size}`), ...GRID_SIZES$1.map(size => `grid-md-${size}`), ...GRID_SIZES$1.map(size => `grid-lg-${size}`), ...GRID_SIZES$1.map(size => `grid-xl-${size}`)]);
gridClasses$1.default = gridClasses;

// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
var _interopRequireDefault$5W = interopRequireDefault$1.exports;
Object.defineProperty(Grid$1, "__esModule", {
  value: true
});
Grid$1.default = void 0;
Grid$1.generateColumnGap = generateColumnGap;
Grid$1.generateDirection = generateDirection;
Grid$1.generateGrid = generateGrid;
Grid$1.generateRowGap = generateRowGap;
Grid$1.resolveSpacingClasses = resolveSpacingClasses;
Grid$1.resolveSpacingStyles = resolveSpacingStyles;
var _objectWithoutPropertiesLoose2$1c = _interopRequireDefault$5W(objectWithoutPropertiesLoose.exports);
var _extends2$1f = _interopRequireDefault$5W(_extends$19.exports);
var React$1z = _interopRequireWildcard$2H(React__default$4);
var _propTypes$1F = _interopRequireDefault$5W(propTypes.exports);
var _clsx$1A = _interopRequireDefault$5W(clsx.exports);
var _system$3 = system;
var _styleFunctionSx = styleFunctionSx;
var _composeClasses$$ = _interopRequireDefault$5W(composeClasses$2);
var _requirePropFactory = _interopRequireDefault$5W(requirePropFactory);
var _styled$Z = _interopRequireDefault$5W(styled$2);
var _DefaultPropsProvider$_ = DefaultPropsProvider$5;
var _useTheme$8 = _interopRequireDefault$5W(useTheme$4);
var _GridContext = _interopRequireDefault$5W(GridContext$1);
var _gridClasses = _interopRequireWildcard$2H(gridClasses$1);
var _jsxRuntime$1t = require$$11;
const _excluded$1G = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "rowSpacing", "spacing", "wrap", "zeroMinWidth"];
function _getRequireWildcardCache$2q(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2q = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2H(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2q(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getOffset(val) {
  const parse = parseFloat(val);
  return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function generateGrid({
  theme,
  ownerState
}) {
  let size;
  return theme.breakpoints.keys.reduce((globalStyles, breakpoint) => {
    // Use side effect over immutability for better performance.
    let styles = {};
    if (ownerState[breakpoint]) {
      size = ownerState[breakpoint];
    }
    if (!size) {
      return globalStyles;
    }
    if (size === true) {
      // For the auto layouting
      styles = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
    } else if (size === 'auto') {
      styles = {
        flexBasis: 'auto',
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: 'none',
        width: 'auto'
      };
    } else {
      const columnsBreakpointValues = (0, _system$3.unstable_resolveBreakpointValues)({
        values: ownerState.columns,
        breakpoints: theme.breakpoints.values
      });
      const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
      if (columnValue === undefined || columnValue === null) {
        return globalStyles;
      }
      // Keep 7 significant numbers.
      const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
      let more = {};
      if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
        const themeSpacing = theme.spacing(ownerState.columnSpacing);
        if (themeSpacing !== '0px') {
          const fullWidth = `calc(${width} + ${getOffset(themeSpacing)})`;
          more = {
            flexBasis: fullWidth,
            maxWidth: fullWidth
          };
        }
      }

      // Close to the bootstrap implementation:
      // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
      styles = (0, _extends2$1f.default)({
        flexBasis: width,
        flexGrow: 0,
        maxWidth: width
      }, more);
    }

    // No need for a media query for the first size.
    if (theme.breakpoints.values[breakpoint] === 0) {
      Object.assign(globalStyles, styles);
    } else {
      globalStyles[theme.breakpoints.up(breakpoint)] = styles;
    }
    return globalStyles;
  }, {});
}
function generateDirection({
  theme,
  ownerState
}) {
  const directionValues = (0, _system$3.unstable_resolveBreakpointValues)({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  });
  return (0, _system$3.handleBreakpoints)({
    theme
  }, directionValues, propValue => {
    const output = {
      flexDirection: propValue
    };
    if (propValue.indexOf('column') === 0) {
      output[`& > .${_gridClasses.default.item}`] = {
        maxWidth: 'none'
      };
    }
    return output;
  });
}

/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */
function extractZeroValueBreakpointKeys({
  breakpoints,
  values
}) {
  let nonZeroKey = '';
  Object.keys(values).forEach(key => {
    if (nonZeroKey !== '') {
      return;
    }
    if (values[key] !== 0) {
      nonZeroKey = key;
    }
  });
  const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b) => {
    return breakpoints[a] - breakpoints[b];
  });
  return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function generateRowGap({
  theme,
  ownerState
}) {
  const {
    container,
    rowSpacing
  } = ownerState;
  let styles = {};
  if (container && rowSpacing !== 0) {
    const rowSpacingValues = (0, _system$3.unstable_resolveBreakpointValues)({
      values: rowSpacing,
      breakpoints: theme.breakpoints.values
    });
    let zeroValueBreakpointKeys;
    if (typeof rowSpacingValues === 'object') {
      zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
        breakpoints: theme.breakpoints.values,
        values: rowSpacingValues
      });
    }
    styles = (0, _system$3.handleBreakpoints)({
      theme
    }, rowSpacingValues, (propValue, breakpoint) => {
      var _zeroValueBreakpointK;
      const themeSpacing = theme.spacing(propValue);
      if (themeSpacing !== '0px') {
        return {
          marginTop: `-${getOffset(themeSpacing)}`,
          [`& > .${_gridClasses.default.item}`]: {
            paddingTop: getOffset(themeSpacing)
          }
        };
      }
      if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) {
        return {};
      }
      return {
        marginTop: 0,
        [`& > .${_gridClasses.default.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return styles;
}
function generateColumnGap({
  theme,
  ownerState
}) {
  const {
    container,
    columnSpacing
  } = ownerState;
  let styles = {};
  if (container && columnSpacing !== 0) {
    const columnSpacingValues = (0, _system$3.unstable_resolveBreakpointValues)({
      values: columnSpacing,
      breakpoints: theme.breakpoints.values
    });
    let zeroValueBreakpointKeys;
    if (typeof columnSpacingValues === 'object') {
      zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
        breakpoints: theme.breakpoints.values,
        values: columnSpacingValues
      });
    }
    styles = (0, _system$3.handleBreakpoints)({
      theme
    }, columnSpacingValues, (propValue, breakpoint) => {
      var _zeroValueBreakpointK2;
      const themeSpacing = theme.spacing(propValue);
      if (themeSpacing !== '0px') {
        return {
          width: `calc(100% + ${getOffset(themeSpacing)})`,
          marginLeft: `-${getOffset(themeSpacing)}`,
          [`& > .${_gridClasses.default.item}`]: {
            paddingLeft: getOffset(themeSpacing)
          }
        };
      }
      if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) {
        return {};
      }
      return {
        width: '100%',
        marginLeft: 0,
        [`& > .${_gridClasses.default.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return styles;
}
function resolveSpacingStyles(spacing, breakpoints, styles = {}) {
  // undefined/null or `spacing` <= 0
  if (!spacing || spacing <= 0) {
    return [];
  }
  // in case of string/number `spacing`
  if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') {
    return [styles[`spacing-xs-${String(spacing)}`]];
  }
  // in case of object `spacing`
  const spacingStyles = [];
  breakpoints.forEach(breakpoint => {
    const value = spacing[breakpoint];
    if (Number(value) > 0) {
      spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    }
  });
  return spacingStyles;
}

// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const GridRoot = (0, _styled$Z.default)('div', {
  name: 'MuiGrid',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      container,
      direction,
      item,
      spacing,
      wrap,
      zeroMinWidth,
      breakpoints
    } = ownerState;
    let spacingStyles = [];

    // in case of grid item
    if (container) {
      spacingStyles = resolveSpacingStyles(spacing, breakpoints, styles);
    }
    const breakpointsStyles = [];
    breakpoints.forEach(breakpoint => {
      const value = ownerState[breakpoint];
      if (value) {
        breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
      }
    });
    return [styles.root, container && styles.container, item && styles.item, zeroMinWidth && styles.zeroMinWidth, ...spacingStyles, direction !== 'row' && styles[`direction-xs-${String(direction)}`], wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`], ...breakpointsStyles];
  }
})(({
  ownerState
}) => (0, _extends2$1f.default)({
  boxSizing: 'border-box'
}, ownerState.container && {
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%'
}, ownerState.item && {
  margin: 0 // For instance, it's useful when used with a `figure` element.
}, ownerState.zeroMinWidth && {
  minWidth: 0
}, ownerState.wrap !== 'wrap' && {
  flexWrap: ownerState.wrap
}), generateDirection, generateRowGap, generateColumnGap, generateGrid);
function resolveSpacingClasses(spacing, breakpoints) {
  // undefined/null or `spacing` <= 0
  if (!spacing || spacing <= 0) {
    return [];
  }
  // in case of string/number `spacing`
  if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') {
    return [`spacing-xs-${String(spacing)}`];
  }
  // in case of object `spacing`
  const classes = [];
  breakpoints.forEach(breakpoint => {
    const value = spacing[breakpoint];
    if (Number(value) > 0) {
      const className = `spacing-${breakpoint}-${String(value)}`;
      classes.push(className);
    }
  });
  return classes;
}
const useUtilityClasses$10 = ownerState => {
  const {
    classes,
    container,
    direction,
    item,
    spacing,
    wrap,
    zeroMinWidth,
    breakpoints
  } = ownerState;
  let spacingClasses = [];

  // in case of grid item
  if (container) {
    spacingClasses = resolveSpacingClasses(spacing, breakpoints);
  }
  const breakpointsClasses = [];
  breakpoints.forEach(breakpoint => {
    const value = ownerState[breakpoint];
    if (value) {
      breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    }
  });
  const slots = {
    root: ['root', container && 'container', item && 'item', zeroMinWidth && 'zeroMinWidth', ...spacingClasses, direction !== 'row' && `direction-xs-${String(direction)}`, wrap !== 'wrap' && `wrap-xs-${String(wrap)}`, ...breakpointsClasses]
  };
  return (0, _composeClasses$$.default)(slots, _gridClasses.getGridUtilityClass, classes);
};
const Grid = /*#__PURE__*/React$1z.forwardRef(function Grid(inProps, ref) {
  const themeProps = (0, _DefaultPropsProvider$_.useDefaultProps)({
    props: inProps,
    name: 'MuiGrid'
  });
  const {
    breakpoints
  } = (0, _useTheme$8.default)();
  const props = (0, _styleFunctionSx.extendSxProp)(themeProps);
  const {
      className,
      columns: columnsProp,
      columnSpacing: columnSpacingProp,
      component = 'div',
      container = false,
      direction = 'row',
      item = false,
      rowSpacing: rowSpacingProp,
      spacing = 0,
      wrap = 'wrap',
      zeroMinWidth = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1c.default)(props, _excluded$1G);
  const rowSpacing = rowSpacingProp || spacing;
  const columnSpacing = columnSpacingProp || spacing;
  const columnsContext = React$1z.useContext(_GridContext.default);

  // columns set with default breakpoint unit of 12
  const columns = container ? columnsProp || 12 : columnsContext;
  const breakpointsValues = {};
  const otherFiltered = (0, _extends2$1f.default)({}, other);
  breakpoints.keys.forEach(breakpoint => {
    if (other[breakpoint] != null) {
      breakpointsValues[breakpoint] = other[breakpoint];
      delete otherFiltered[breakpoint];
    }
  });
  const ownerState = (0, _extends2$1f.default)({}, props, {
    columns,
    container,
    direction,
    item,
    rowSpacing,
    columnSpacing,
    wrap,
    zeroMinWidth,
    spacing
  }, breakpointsValues, {
    breakpoints: breakpoints.keys
  });
  const classes = useUtilityClasses$10(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1t.jsx)(_GridContext.default.Provider, {
    value: columns,
    children: /*#__PURE__*/(0, _jsxRuntime$1t.jsx)(GridRoot, (0, _extends2$1f.default)({
      ownerState: ownerState,
      className: (0, _clsx$1A.default)(classes.root, className),
      as: component,
      ref: ref
    }, otherFiltered))
  });
});
process.env.NODE_ENV !== "production" ? Grid.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1F.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1F.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1F.default.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: _propTypes$1F.default.oneOfType([_propTypes$1F.default.arrayOf(_propTypes$1F.default.number), _propTypes$1F.default.number, _propTypes$1F.default.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: _propTypes$1F.default.oneOfType([_propTypes$1F.default.arrayOf(_propTypes$1F.default.oneOfType([_propTypes$1F.default.number, _propTypes$1F.default.string])), _propTypes$1F.default.number, _propTypes$1F.default.object, _propTypes$1F.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1F.default.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: _propTypes$1F.default.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: _propTypes$1F.default.oneOfType([_propTypes$1F.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row']), _propTypes$1F.default.arrayOf(_propTypes$1F.default.oneOf(['column-reverse', 'column', 'row-reverse', 'row'])), _propTypes$1F.default.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: _propTypes$1F.default.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: _propTypes$1F.default.oneOfType([_propTypes$1F.default.oneOf(['auto']), _propTypes$1F.default.number, _propTypes$1F.default.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: _propTypes$1F.default.oneOfType([_propTypes$1F.default.oneOf(['auto']), _propTypes$1F.default.number, _propTypes$1F.default.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: _propTypes$1F.default.oneOfType([_propTypes$1F.default.arrayOf(_propTypes$1F.default.oneOfType([_propTypes$1F.default.number, _propTypes$1F.default.string])), _propTypes$1F.default.number, _propTypes$1F.default.object, _propTypes$1F.default.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: _propTypes$1F.default.oneOfType([_propTypes$1F.default.oneOf(['auto']), _propTypes$1F.default.number, _propTypes$1F.default.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: _propTypes$1F.default.oneOfType([_propTypes$1F.default.arrayOf(_propTypes$1F.default.oneOfType([_propTypes$1F.default.number, _propTypes$1F.default.string])), _propTypes$1F.default.number, _propTypes$1F.default.object, _propTypes$1F.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1F.default.oneOfType([_propTypes$1F.default.arrayOf(_propTypes$1F.default.oneOfType([_propTypes$1F.default.func, _propTypes$1F.default.object, _propTypes$1F.default.bool])), _propTypes$1F.default.func, _propTypes$1F.default.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: _propTypes$1F.default.oneOf(['nowrap', 'wrap-reverse', 'wrap']),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: _propTypes$1F.default.oneOfType([_propTypes$1F.default.oneOf(['auto']), _propTypes$1F.default.number, _propTypes$1F.default.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: _propTypes$1F.default.oneOfType([_propTypes$1F.default.oneOf(['auto']), _propTypes$1F.default.number, _propTypes$1F.default.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: _propTypes$1F.default.bool
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  const requireProp = (0, _requirePropFactory.default)('Grid', Grid);
  // eslint-disable-next-line no-useless-concat
  Grid['propTypes' + ''] = (0, _extends2$1f.default)({}, Grid.propTypes, {
    direction: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('item')
  });
}
Grid$1.default = Grid;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  gridClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Grid.default;
  }
});
Object.defineProperty(exports, "gridClasses", {
  enumerable: true,
  get: function () {
    return _gridClasses.default;
  }
});
var _Grid = _interopRequireDefault(Grid$1);
var _gridClasses = _interopRequireWildcard(gridClasses$1);
Object.keys(_gridClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _gridClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _gridClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Grid$2));

var Unstable_Grid2 = {};

var Grid2$1 = {};

var _interopRequireDefault$5V = interopRequireDefault$1.exports;
Object.defineProperty(Grid2$1, "__esModule", {
  value: true
});
Grid2$1.default = void 0;
var _propTypes$1E = _interopRequireDefault$5V(propTypes.exports);
var _Unstable_Grid = Unstable_Grid;
var _styles$4 = styles$u;
var _DefaultPropsProvider$Z = DefaultPropsProvider$5;
const Grid2 = (0, _Unstable_Grid.createGrid)({
  createStyledComponent: (0, _styles$4.styled)('div', {
    name: 'MuiGrid2',
    slot: 'Root',
    overridesResolver: (props, styles) => styles.root
  }),
  componentName: 'MuiGrid2',
  useThemeProps: inProps => (0, _DefaultPropsProvider$Z.useDefaultProps)({
    props: inProps,
    name: 'MuiGrid2'
  })
});
process.env.NODE_ENV !== "production" ? Grid2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1E.default.node,
  /**
   * @ignore
   */
  sx: _propTypes$1E.default.oneOfType([_propTypes$1E.default.arrayOf(_propTypes$1E.default.oneOfType([_propTypes$1E.default.func, _propTypes$1E.default.object, _propTypes$1E.default.bool])), _propTypes$1E.default.func, _propTypes$1E.default.object])
} : void 0;
Grid2$1.default = Grid2;

var Grid2Props = {};

Object.defineProperty(Grid2Props, "__esModule", {
  value: true
});

var grid2Classes$1 = {};

var _interopRequireDefault$5U = interopRequireDefault$1.exports;
Object.defineProperty(grid2Classes$1, "__esModule", {
  value: true
});
grid2Classes$1.default = void 0;
grid2Classes$1.getGrid2UtilityClass = getGrid2UtilityClass;
var _generateUtilityClasses$Y = _interopRequireDefault$5U(generateUtilityClasses$3);
var _generateUtilityClass$Y = _interopRequireDefault$5U(generateUtilityClass$3);
function getGrid2UtilityClass(slot) {
  return (0, _generateUtilityClass$Y.default)('MuiGrid2', slot);
}
const SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const DIRECTIONS = ['column-reverse', 'column', 'row-reverse', 'row'];
const WRAPS = ['nowrap', 'wrap-reverse', 'wrap'];
const GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const grid2Classes = (0, _generateUtilityClasses$Y.default)('MuiGrid2', ['root', 'container', 'item', 'zeroMinWidth',
// spacings
...SPACINGS.map(spacing => `spacing-xs-${spacing}`),
// direction values
...DIRECTIONS.map(direction => `direction-xs-${direction}`),
// wrap values
...WRAPS.map(wrap => `wrap-xs-${wrap}`),
// grid sizes for all breakpoints
...GRID_SIZES.map(size => `grid-xs-${size}`), ...GRID_SIZES.map(size => `grid-sm-${size}`), ...GRID_SIZES.map(size => `grid-md-${size}`), ...GRID_SIZES.map(size => `grid-lg-${size}`), ...GRID_SIZES.map(size => `grid-xl-${size}`)]);
grid2Classes$1.default = grid2Classes;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  grid2Classes: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Grid.default;
  }
});
Object.defineProperty(exports, "grid2Classes", {
  enumerable: true,
  get: function () {
    return _grid2Classes.default;
  }
});
var _Grid = _interopRequireDefault(Grid2$1);
var _Grid2Props = Grid2Props;
Object.keys(_Grid2Props).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Grid2Props[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Grid2Props[key];
    }
  });
});
var _grid2Classes = _interopRequireWildcard(grid2Classes$1);
Object.keys(_grid2Classes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _grid2Classes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _grid2Classes[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Unstable_Grid2));

var Grow$2 = {};

var Grow$1 = {};

var _interopRequireDefault$5T = interopRequireDefault$1.exports;
Object.defineProperty(Grow$1, "__esModule", {
  value: true
});
Grow$1.default = void 0;
var _extends2$1e = _interopRequireDefault$5T(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1b = _interopRequireDefault$5T(objectWithoutPropertiesLoose.exports);
var React$1y = _interopRequireWildcard$2G(React__default$4);
var _propTypes$1D = _interopRequireDefault$5T(propTypes.exports);
var _useTimeout$2 = _interopRequireDefault$5T(useTimeout$2);
var _elementAcceptingRef$2 = _interopRequireDefault$5T(elementAcceptingRef$2);
var _getReactElementRef$3 = _interopRequireDefault$5T(getReactElementRef$2);
var _reactTransitionGroup$3 = cjs$4;
var _useTheme$7 = _interopRequireDefault$5T(useTheme$4);
var _utils$G = utils$8;
var _useForkRef$d = _interopRequireDefault$5T(useForkRef);
var _jsxRuntime$1s = require$$11;
const _excluded$1F = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function _getRequireWildcardCache$2p(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2p = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2G(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2p(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getScale(value) {
  return `scale(${value}, ${value ** 2})`;
}
const styles$q = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};

/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */
const isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);

/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Grow = /*#__PURE__*/React$1y.forwardRef(function Grow(props, ref) {
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = 'auto',
      // eslint-disable-next-line react/prop-types
      TransitionComponent = _reactTransitionGroup$3.Transition
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1b.default)(props, _excluded$1F);
  const timer = (0, _useTimeout$2.default)();
  const autoTimeout = React$1y.useRef();
  const theme = (0, _useTheme$7.default)();
  const nodeRef = React$1y.useRef(null);
  const handleRef = (0, _useForkRef$d.default)(nodeRef, (0, _getReactElementRef$3.default)(children), ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    (0, _utils$G.reflow)(node); // So the animation always start from the start.

    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = (0, _utils$G.getTransitionProps)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    let duration;
    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay,
      easing: transitionTimingFunction
    })].join(',');
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = (0, _utils$G.getTransitionProps)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    let duration;
    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: isWebKit154 ? duration : duration * 0.666,
      delay: isWebKit154 ? delay : delay || duration * 0.333,
      easing: transitionTimingFunction
    })].join(',');
    node.style.opacity = 0;
    node.style.transform = getScale(0.75);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.start(autoTimeout.current || 0, next);
    }
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime$1s.jsx)(TransitionComponent, (0, _extends2$1e.default)({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$1y.cloneElement(children, (0, _extends2$1e.default)({
        style: (0, _extends2$1e.default)({
          opacity: 0,
          transform: getScale(0.75),
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles$q[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Grow.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: _propTypes$1D.default.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: _propTypes$1D.default.bool,
  /**
   * A single child content element.
   */
  children: _elementAcceptingRef$2.default.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: _propTypes$1D.default.oneOfType([_propTypes$1D.default.shape({
    enter: _propTypes$1D.default.string,
    exit: _propTypes$1D.default.string
  }), _propTypes$1D.default.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes$1D.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes$1D.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes$1D.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes$1D.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes$1D.default.func,
  /**
   * @ignore
   */
  onExited: _propTypes$1D.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes$1D.default.func,
  /**
   * @ignore
   */
  style: _propTypes$1D.default.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: _propTypes$1D.default.oneOfType([_propTypes$1D.default.oneOf(['auto']), _propTypes$1D.default.number, _propTypes$1D.default.shape({
    appear: _propTypes$1D.default.number,
    enter: _propTypes$1D.default.number,
    exit: _propTypes$1D.default.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
Grow$1.default = Grow;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Grow.default;
  }
});
var _Grow = _interopRequireDefault(Grow$1);
}(Grow$2));

var Hidden$2 = {};

var Hidden$1 = {};

var HiddenJs$1 = {};

var withWidth$1 = {};

var useMediaQuery$1 = {};

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useMediaQuery.default;
  }
});
var _useMediaQuery = _interopRequireDefault(useMediaQuery$4);
}(useMediaQuery$1));

var _interopRequireDefault$5S = interopRequireDefault$1.exports;
Object.defineProperty(withWidth$1, "__esModule", {
  value: true
});
withWidth$1.isWidthUp = withWidth$1.isWidthDown = withWidth$1.default = void 0;
var _extends2$1d = _interopRequireDefault$5S(_extends$19.exports);
var _objectWithoutPropertiesLoose2$1a = _interopRequireDefault$5S(objectWithoutPropertiesLoose.exports);
var React$1x = _interopRequireWildcard$2F(React__default$4);
var _propTypes$1C = _interopRequireDefault$5S(propTypes.exports);
var _getDisplayName = _interopRequireDefault$5S(getDisplayName$3);
var _useThemeProps = useThemeProps$3;
var _useTheme$6 = _interopRequireDefault$5S(useTheme$4);
var _useEnhancedEffect$5 = _interopRequireDefault$5S(useEnhancedEffect);
var _useMediaQuery = _interopRequireDefault$5S(useMediaQuery$1);
var _jsxRuntime$1r = require$$11;
const _excluded$1E = ["initialWidth", "width"];
function _getRequireWildcardCache$2o(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2o = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2F(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2o(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const breakpointKeys = ['xs', 'sm', 'md', 'lg', 'xl'];

// By default, returns true if screen width is the same or greater than the given breakpoint.
const isWidthUp = (breakpoint, width, inclusive = true) => {
  if (inclusive) {
    return breakpointKeys.indexOf(breakpoint) <= breakpointKeys.indexOf(width);
  }
  return breakpointKeys.indexOf(breakpoint) < breakpointKeys.indexOf(width);
};

// By default, returns true if screen width is less than the given breakpoint.
withWidth$1.isWidthUp = isWidthUp;
const isWidthDown = (breakpoint, width, inclusive = false) => {
  if (inclusive) {
    return breakpointKeys.indexOf(width) <= breakpointKeys.indexOf(breakpoint);
  }
  return breakpointKeys.indexOf(width) < breakpointKeys.indexOf(breakpoint);
};
withWidth$1.isWidthDown = isWidthDown;
const withWidth = (options = {}) => Component => {
  const {
    withTheme: withThemeOption = false,
    noSSR = false,
    initialWidth: initialWidthOption
  } = options;
  function WithWidth(props) {
    const contextTheme = (0, _useTheme$6.default)();
    const theme = props.theme || contextTheme;
    const _getThemeProps = (0, _useThemeProps.getThemeProps)({
        theme,
        name: 'MuiWithWidth',
        props
      }),
      {
        initialWidth,
        width
      } = _getThemeProps,
      other = (0, _objectWithoutPropertiesLoose2$1a.default)(_getThemeProps, _excluded$1E);
    const [mountedState, setMountedState] = React$1x.useState(false);
    (0, _useEnhancedEffect$5.default)(() => {
      setMountedState(true);
    }, []);

    /**
     * innerWidth |xs      sm      md      lg      xl
     *            |-------|-------|-------|-------|------>
     * width      |  xs   |  sm   |  md   |  lg   |  xl
     */
    const keys = theme.breakpoints.keys.slice().reverse();
    const widthComputed = keys.reduce((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = (0, _useMediaQuery.default)(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null);
    const more = (0, _extends2$1d.default)({
      width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
    }, withThemeOption ? {
      theme
    } : {}, other);

    // When rendering the component on the server,
    // we have no idea about the client browser screen width.
    // In order to prevent blinks and help the reconciliation of the React tree
    // we are not rendering the child component.
    //
    // An alternative is to use the `initialWidth` property.
    if (more.width === undefined) {
      return null;
    }
    return /*#__PURE__*/(0, _jsxRuntime$1r.jsx)(Component, (0, _extends2$1d.default)({}, more));
  }
  process.env.NODE_ENV !== "production" ? WithWidth.propTypes = {
    /**
     * As `window.innerWidth` is unavailable on the server,
     * we default to rendering an empty component during the first mount.
     * You might want to use a heuristic to approximate
     * the screen width of the client browser screen width.
     *
     * For instance, you could be using the user-agent or the client-hints.
     * https://caniuse.com/#search=client%20hint
     */
    initialWidth: _propTypes$1C.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    /**
     * @ignore
     */
    theme: _propTypes$1C.default.object,
    /**
     * Bypass the width calculation logic.
     */
    width: _propTypes$1C.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
  } : void 0;
  if (process.env.NODE_ENV !== 'production') {
    WithWidth.displayName = `WithWidth(${(0, _getDisplayName.default)(Component)})`;
  }
  return WithWidth;
};
withWidth$1.default = withWidth;

var _interopRequireDefault$5R = interopRequireDefault$1.exports;
Object.defineProperty(HiddenJs$1, "__esModule", {
  value: true
});
HiddenJs$1.default = void 0;
var React$1w = _interopRequireWildcard$2E(React__default$4);
var _propTypes$1B = _interopRequireDefault$5R(propTypes.exports);
var _exactProp = _interopRequireDefault$5R(exactProp$2);
var _withWidth = _interopRequireWildcard$2E(withWidth$1);
var _useTheme$5 = _interopRequireDefault$5R(useTheme$4);
var _jsxRuntime$1q = require$$11;
function _getRequireWildcardCache$2n(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2n = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2E(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2n(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */function HiddenJs(props) {
  const {
    children,
    only,
    width
  } = props;
  const theme = (0, _useTheme$5.default)();
  let visible = true;

  // `only` check is faster to get out sooner if used.
  if (only) {
    if (Array.isArray(only)) {
      for (let i = 0; i < only.length; i += 1) {
        const breakpoint = only[i];
        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  }

  // Allow `only` to be combined with other props. If already hidden, no need to check others.
  if (visible) {
    // determine visibility based on the smallest size up
    for (let i = 0; i < theme.breakpoints.keys.length; i += 1) {
      const breakpoint = theme.breakpoints.keys[i];
      const breakpointUp = props[`${breakpoint}Up`];
      const breakpointDown = props[`${breakpoint}Down`];
      if (breakpointUp && (0, _withWidth.isWidthUp)(breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime$1q.jsx)(React$1w.Fragment, {
    children: children
  });
}
process.env.NODE_ENV !== "production" ? HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes$1B.default.node,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  lgDown: _propTypes$1B.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  lgUp: _propTypes$1B.default.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  mdDown: _propTypes$1B.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  mdUp: _propTypes$1B.default.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes$1B.default.oneOfType([_propTypes$1B.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes$1B.default.arrayOf(_propTypes$1B.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  smDown: _propTypes$1B.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  smUp: _propTypes$1B.default.bool,
  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: _propTypes$1B.default.string.isRequired,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xlDown: _propTypes$1B.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xlUp: _propTypes$1B.default.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xsDown: _propTypes$1B.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  xsUp: _propTypes$1B.default.bool
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? HiddenJs.propTypes = (0, _exactProp.default)(HiddenJs.propTypes) : void 0;
}
HiddenJs$1.default = (0, _withWidth.default)()(HiddenJs);

var HiddenCss$1 = {};

var hiddenCssClasses$1 = {};

var _interopRequireDefault$5Q = interopRequireDefault$1.exports;
Object.defineProperty(hiddenCssClasses$1, "__esModule", {
  value: true
});
hiddenCssClasses$1.default = void 0;
hiddenCssClasses$1.getHiddenCssUtilityClass = getHiddenCssUtilityClass;
var _generateUtilityClasses$X = _interopRequireDefault$5Q(generateUtilityClasses$3);
var _generateUtilityClass$X = _interopRequireDefault$5Q(generateUtilityClass$3);
function getHiddenCssUtilityClass(slot) {
  return (0, _generateUtilityClass$X.default)('PrivateHiddenCss', slot);
}
const hiddenCssClasses = (0, _generateUtilityClasses$X.default)('PrivateHiddenCss', ['root', 'xlDown', 'xlUp', 'onlyXl', 'lgDown', 'lgUp', 'onlyLg', 'mdDown', 'mdUp', 'onlyMd', 'smDown', 'smUp', 'onlySm', 'xsDown', 'xsUp', 'onlyXs']);
hiddenCssClasses$1.default = hiddenCssClasses;

var _interopRequireDefault$5P = interopRequireDefault$1.exports;
Object.defineProperty(HiddenCss$1, "__esModule", {
  value: true
});
HiddenCss$1.default = void 0;
var _objectWithoutPropertiesLoose2$19 = _interopRequireDefault$5P(objectWithoutPropertiesLoose.exports);
var _extends2$1c = _interopRequireDefault$5P(_extends$19.exports);
_interopRequireWildcard$2D(React__default$4);
var _clsx$1z = _interopRequireDefault$5P(clsx.exports);
var _propTypes$1A = _interopRequireDefault$5P(propTypes.exports);
var _composeClasses$_ = _interopRequireDefault$5P(composeClasses$2);
var _capitalize$o = _interopRequireDefault$5P(capitalize$1);
var _styled$Y = _interopRequireDefault$5P(styled$2);
var _useTheme$4 = _interopRequireDefault$5P(useTheme$4);
var _hiddenCssClasses = hiddenCssClasses$1;
var _jsxRuntime$1p = require$$11;
const _excluded$1D = ["children", "className", "only"];
function _getRequireWildcardCache$2m(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2m = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2D(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2m(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$$ = ownerState => {
  const {
    classes,
    breakpoints
  } = ownerState;
  const slots = {
    root: ['root', ...breakpoints.map(({
      breakpoint,
      dir
    }) => {
      return dir === 'only' ? `${dir}${(0, _capitalize$o.default)(breakpoint)}` : `${breakpoint}${(0, _capitalize$o.default)(dir)}`;
    })]
  };
  return (0, _composeClasses$_.default)(slots, _hiddenCssClasses.getHiddenCssUtilityClass, classes);
};
const HiddenCssRoot = (0, _styled$Y.default)('div', {
  name: 'PrivateHiddenCss',
  slot: 'Root'
})(({
  theme,
  ownerState
}) => {
  const hidden = {
    display: 'none'
  };
  return (0, _extends2$1c.default)({}, ownerState.breakpoints.map(({
    breakpoint,
    dir
  }) => {
    if (dir === 'only') {
      return {
        [theme.breakpoints.only(breakpoint)]: hidden
      };
    }
    return dir === 'up' ? {
      [theme.breakpoints.up(breakpoint)]: hidden
    } : {
      [theme.breakpoints.down(breakpoint)]: hidden
    };
  }).reduce((r, o) => {
    Object.keys(o).forEach(k => {
      r[k] = o[k];
    });
    return r;
  }, {}));
});

/**
 * @ignore - internal component.
 */
function HiddenCss(props) {
  const {
      children,
      className,
      only
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$19.default)(props, _excluded$1D);
  const theme = (0, _useTheme$4.default)();
  if (process.env.NODE_ENV !== 'production') {
    const unknownProps = Object.keys(other).filter(propName => {
      const isUndeclaredBreakpoint = !theme.breakpoints.keys.some(breakpoint => {
        return `${breakpoint}Up` === propName || `${breakpoint}Down` === propName;
      });
      return !['classes', 'theme', 'isRtl', 'sx'].includes(propName) && isUndeclaredBreakpoint;
    });
    if (unknownProps.length > 0) {
      console.error(`MUI: Unsupported props received by \`<Hidden implementation="css" />\`: ${unknownProps.join(', ')}. Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?`);
    }
  }
  const breakpoints = [];
  for (let i = 0; i < theme.breakpoints.keys.length; i += 1) {
    const breakpoint = theme.breakpoints.keys[i];
    const breakpointUp = other[`${breakpoint}Up`];
    const breakpointDown = other[`${breakpoint}Down`];
    if (breakpointUp) {
      breakpoints.push({
        breakpoint,
        dir: 'up'
      });
    }
    if (breakpointDown) {
      breakpoints.push({
        breakpoint,
        dir: 'down'
      });
    }
  }
  if (only) {
    const onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(breakpoint => {
      breakpoints.push({
        breakpoint,
        dir: 'only'
      });
    });
  }
  const ownerState = (0, _extends2$1c.default)({}, props, {
    breakpoints
  });
  const classes = useUtilityClasses$$(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1p.jsx)(HiddenCssRoot, {
    className: (0, _clsx$1z.default)(classes.root, className),
    ownerState: ownerState,
    children: children
  });
}
process.env.NODE_ENV !== "production" ? HiddenCss.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes$1A.default.node,
  /**
   * @ignore
   */
  className: _propTypes$1A.default.string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: _propTypes$1A.default.oneOf(['js', 'css']),
  /**
   * If `true`, screens this size and down are hidden.
   */
  lgDown: _propTypes$1A.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  lgUp: _propTypes$1A.default.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  mdDown: _propTypes$1A.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  mdUp: _propTypes$1A.default.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes$1A.default.oneOfType([_propTypes$1A.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes$1A.default.arrayOf(_propTypes$1A.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
  /**
   * If `true`, screens this size and down are hidden.
   */
  smDown: _propTypes$1A.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  smUp: _propTypes$1A.default.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  xlDown: _propTypes$1A.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  xlUp: _propTypes$1A.default.bool,
  /**
   * If `true`, screens this size and down are hidden.
   */
  xsDown: _propTypes$1A.default.bool,
  /**
   * If `true`, screens this size and up are hidden.
   */
  xsUp: _propTypes$1A.default.bool
} : void 0;
HiddenCss$1.default = HiddenCss;

var _interopRequireDefault$5O = interopRequireDefault$1.exports;
Object.defineProperty(Hidden$1, "__esModule", {
  value: true
});
Hidden$1.default = void 0;
var _extends2$1b = _interopRequireDefault$5O(_extends$19.exports);
var _objectWithoutPropertiesLoose2$18 = _interopRequireDefault$5O(objectWithoutPropertiesLoose.exports);
_interopRequireWildcard$2C(React__default$4);
var _propTypes$1z = _interopRequireDefault$5O(propTypes.exports);
var _HiddenJs = _interopRequireDefault$5O(HiddenJs$1);
var _HiddenCss = _interopRequireDefault$5O(HiddenCss$1);
var _jsxRuntime$1o = require$$11;
const _excluded$1C = ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"];
/**
 * Responsively hides children based on the selected implementation.
 *
 * @deprecated The Hidden component was deprecated in Material UI v5. To learn more, see [the Hidden section](/material-ui/migration/v5-component-changes/#hidden) of the migration docs.
 */
function _getRequireWildcardCache$2l(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2l = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2C(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2l(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Hidden(props) {
  const {
      implementation = 'js',
      lgDown = false,
      lgUp = false,
      mdDown = false,
      mdUp = false,
      smDown = false,
      smUp = false,
      xlDown = false,
      xlUp = false,
      xsDown = false,
      xsUp = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$18.default)(props, _excluded$1C);
  if (implementation === 'js') {
    return /*#__PURE__*/(0, _jsxRuntime$1o.jsx)(_HiddenJs.default, (0, _extends2$1b.default)({
      lgDown: lgDown,
      lgUp: lgUp,
      mdDown: mdDown,
      mdUp: mdUp,
      smDown: smDown,
      smUp: smUp,
      xlDown: xlDown,
      xlUp: xlUp,
      xsDown: xsDown,
      xsUp: xsUp
    }, other));
  }
  return /*#__PURE__*/(0, _jsxRuntime$1o.jsx)(_HiddenCss.default, (0, _extends2$1b.default)({
    lgDown: lgDown,
    lgUp: lgUp,
    mdDown: mdDown,
    mdUp: mdUp,
    smDown: smDown,
    smUp: smUp,
    xlDown: xlDown,
    xlUp: xlUp,
    xsDown: xsDown,
    xsUp: xsUp
  }, other));
}
process.env.NODE_ENV !== "production" ? Hidden.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1z.default.node,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   * @default 'js'
   */
  implementation: _propTypes$1z.default.oneOf(['css', 'js']),
  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use a heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: _propTypes$1z.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  lgDown: _propTypes$1z.default.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  lgUp: _propTypes$1z.default.bool,
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  mdDown: _propTypes$1z.default.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  mdUp: _propTypes$1z.default.bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: _propTypes$1z.default.oneOfType([_propTypes$1z.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes$1z.default.arrayOf(_propTypes$1z.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired)]),
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  smDown: _propTypes$1z.default.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  smUp: _propTypes$1z.default.bool,
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  xlDown: _propTypes$1z.default.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  xlUp: _propTypes$1z.default.bool,
  /**
   * If `true`, component is hidden on screens below (but not including) this size.
   * @default false
   */
  xsDown: _propTypes$1z.default.bool,
  /**
   * If `true`, component is hidden on screens this size and above.
   * @default false
   */
  xsUp: _propTypes$1z.default.bool
} : void 0;
Hidden$1.default = Hidden;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Hidden.default;
  }
});
var _Hidden = _interopRequireDefault(Hidden$1);
}(Hidden$2));

var Icon$4 = {};

var Icon$3 = {};

var iconClasses$1 = {};

var _interopRequireDefault$5N = interopRequireDefault$1.exports;
Object.defineProperty(iconClasses$1, "__esModule", {
  value: true
});
iconClasses$1.default = void 0;
iconClasses$1.getIconUtilityClass = getIconUtilityClass;
var _generateUtilityClasses$W = _interopRequireDefault$5N(generateUtilityClasses$3);
var _generateUtilityClass$W = _interopRequireDefault$5N(generateUtilityClass$3);
function getIconUtilityClass(slot) {
  return (0, _generateUtilityClass$W.default)('MuiIcon', slot);
}
const iconClasses = (0, _generateUtilityClasses$W.default)('MuiIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);
iconClasses$1.default = iconClasses;

var _interopRequireDefault$5M = interopRequireDefault$1.exports;
Object.defineProperty(Icon$3, "__esModule", {
  value: true
});
Icon$3.default = void 0;
var _extends2$1a = _interopRequireDefault$5M(_extends$19.exports);
var _objectWithoutPropertiesLoose2$17 = _interopRequireDefault$5M(objectWithoutPropertiesLoose.exports);
var React$1v = _interopRequireWildcard$2B(React__default$4);
var _propTypes$1y = _interopRequireDefault$5M(propTypes.exports);
var _clsx$1y = _interopRequireDefault$5M(clsx.exports);
var _composeClasses$Z = _interopRequireDefault$5M(composeClasses$2);
var _styled$X = _interopRequireDefault$5M(styled$2);
var _DefaultPropsProvider$Y = DefaultPropsProvider$5;
var _capitalize$n = _interopRequireDefault$5M(capitalize$1);
var _iconClasses = iconClasses$1;
var _jsxRuntime$1n = require$$11;
const _excluded$1B = ["baseClassName", "className", "color", "component", "fontSize"];
function _getRequireWildcardCache$2k(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2k = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2B(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2k(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$_ = ownerState => {
  const {
    color,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ['root', color !== 'inherit' && `color${(0, _capitalize$n.default)(color)}`, `fontSize${(0, _capitalize$n.default)(fontSize)}`]
  };
  return (0, _composeClasses$Z.default)(slots, _iconClasses.getIconUtilityClass, classes);
};
const IconRoot = (0, _styled$X.default)('span', {
  name: 'MuiIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'inherit' && styles[`color${(0, _capitalize$n.default)(ownerState.color)}`], styles[`fontSize${(0, _capitalize$n.default)(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => ({
  userSelect: 'none',
  width: '1em',
  height: '1em',
  // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
  // To remove at some point.
  overflow: 'hidden',
  display: 'inline-block',
  // allow overflow hidden to take action
  textAlign: 'center',
  // support non-square icon
  flexShrink: 0,
  fontSize: {
    inherit: 'inherit',
    small: theme.typography.pxToRem(20),
    medium: theme.typography.pxToRem(24),
    large: theme.typography.pxToRem(36)
  }[ownerState.fontSize],
  // TODO v5 deprecate, v6 remove for sx
  color: {
    primary: (theme.vars || theme).palette.primary.main,
    secondary: (theme.vars || theme).palette.secondary.main,
    info: (theme.vars || theme).palette.info.main,
    success: (theme.vars || theme).palette.success.main,
    warning: (theme.vars || theme).palette.warning.main,
    action: (theme.vars || theme).palette.action.active,
    error: (theme.vars || theme).palette.error.main,
    disabled: (theme.vars || theme).palette.action.disabled,
    inherit: undefined
  }[ownerState.color]
}));
const Icon$2 = /*#__PURE__*/React$1v.forwardRef(function Icon(inProps, ref) {
  const props = (0, _DefaultPropsProvider$Y.useDefaultProps)({
    props: inProps,
    name: 'MuiIcon'
  });
  const {
      baseClassName = 'material-icons',
      className,
      color = 'inherit',
      component: Component = 'span',
      fontSize = 'medium'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$17.default)(props, _excluded$1B);
  const ownerState = (0, _extends2$1a.default)({}, props, {
    baseClassName,
    color,
    component: Component,
    fontSize
  });
  const classes = useUtilityClasses$_(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1n.jsx)(IconRoot, (0, _extends2$1a.default)({
    as: Component,
    className: (0, _clsx$1y.default)(baseClassName,
    // Prevent the translation of the text content.
    // The font relies on the exact text content to render the icon.
    'notranslate', classes.root, className),
    ownerState: ownerState,
    "aria-hidden": true,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? Icon$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The base class applied to the icon. Defaults to 'material-icons', but can be changed to any
   * other base class that suits the icon font you're using (for example material-icons-rounded, fas, etc).
   * @default 'material-icons'
   */
  baseClassName: _propTypes$1y.default.string,
  /**
   * The name of the icon font ligature.
   */
  children: _propTypes$1y.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1y.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1y.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'inherit'
   */
  color: _propTypes$1y.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1y.default.oneOf(['inherit', 'action', 'disabled', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$1y.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1y.default.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: _propTypes$1y.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1y.default.oneOf(['inherit', 'large', 'medium', 'small']), _propTypes$1y.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1y.default.oneOfType([_propTypes$1y.default.arrayOf(_propTypes$1y.default.oneOfType([_propTypes$1y.default.func, _propTypes$1y.default.object, _propTypes$1y.default.bool])), _propTypes$1y.default.func, _propTypes$1y.default.object])
} : void 0;
Icon$2.muiName = 'Icon';
Icon$3.default = Icon$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  iconClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Icon.default;
  }
});
Object.defineProperty(exports, "iconClasses", {
  enumerable: true,
  get: function () {
    return _iconClasses.default;
  }
});
var _Icon = _interopRequireDefault(Icon$3);
var _iconClasses = _interopRequireWildcard(iconClasses$1);
Object.keys(_iconClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _iconClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _iconClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Icon$4));

var MuiIcon = /*@__PURE__*/getDefaultExportFromCjs$1(Icon$4);

var ImageList$2 = {};

var ImageList$1 = {};

var imageListClasses$1 = {};

var _interopRequireDefault$5L = interopRequireDefault$1.exports;
Object.defineProperty(imageListClasses$1, "__esModule", {
  value: true
});
imageListClasses$1.default = void 0;
imageListClasses$1.getImageListUtilityClass = getImageListUtilityClass;
var _generateUtilityClasses$V = _interopRequireDefault$5L(generateUtilityClasses$3);
var _generateUtilityClass$V = _interopRequireDefault$5L(generateUtilityClass$3);
function getImageListUtilityClass(slot) {
  return (0, _generateUtilityClass$V.default)('MuiImageList', slot);
}
const imageListClasses = (0, _generateUtilityClasses$V.default)('MuiImageList', ['root', 'masonry', 'quilted', 'standard', 'woven']);
imageListClasses$1.default = imageListClasses;

var ImageListContext$1 = {};

Object.defineProperty(ImageListContext$1, "__esModule", {
  value: true
});
ImageListContext$1.default = void 0;
var React$1u = _interopRequireWildcard$2A(React__default$4);
function _getRequireWildcardCache$2j(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2j = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2A(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2j(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */
const ImageListContext = /*#__PURE__*/React$1u.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ImageListContext.displayName = 'ImageListContext';
}
ImageListContext$1.default = ImageListContext;

var _interopRequireDefault$5K = interopRequireDefault$1.exports;
Object.defineProperty(ImageList$1, "__esModule", {
  value: true
});
ImageList$1.default = void 0;
var _objectWithoutPropertiesLoose2$16 = _interopRequireDefault$5K(objectWithoutPropertiesLoose.exports);
var _extends2$19 = _interopRequireDefault$5K(_extends$19.exports);
var _composeClasses$Y = _interopRequireDefault$5K(composeClasses$2);
var _integerPropType$7 = _interopRequireDefault$5K(integerPropType$1);
var _clsx$1x = _interopRequireDefault$5K(clsx.exports);
var _propTypes$1x = _interopRequireDefault$5K(propTypes.exports);
var React$1t = _interopRequireWildcard$2z(React__default$4);
var _styled$W = _interopRequireDefault$5K(styled$2);
var _DefaultPropsProvider$X = DefaultPropsProvider$5;
var _imageListClasses = imageListClasses$1;
var _ImageListContext$1 = _interopRequireDefault$5K(ImageListContext$1);
var _jsxRuntime$1m = require$$11;
const _excluded$1A = ["children", "className", "cols", "component", "rowHeight", "gap", "style", "variant"];
function _getRequireWildcardCache$2i(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2i = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2z(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2i(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$Z = ownerState => {
  const {
    classes,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant]
  };
  return (0, _composeClasses$Y.default)(slots, _imageListClasses.getImageListUtilityClass, classes);
};
const ImageListRoot = (0, _styled$W.default)('ul', {
  name: 'MuiImageList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant]];
  }
})(({
  ownerState
}) => {
  return (0, _extends2$19.default)({
    display: 'grid',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
  }, ownerState.variant === 'masonry' && {
    display: 'block'
  });
});
const ImageList = /*#__PURE__*/React$1t.forwardRef(function ImageList(inProps, ref) {
  const props = (0, _DefaultPropsProvider$X.useDefaultProps)({
    props: inProps,
    name: 'MuiImageList'
  });
  const {
      children,
      className,
      cols = 2,
      component = 'ul',
      rowHeight = 'auto',
      gap = 4,
      style: styleProp,
      variant = 'standard'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$16.default)(props, _excluded$1A);
  const contextValue = React$1t.useMemo(() => ({
    rowHeight,
    gap,
    variant
  }), [rowHeight, gap, variant]);
  React$1t.useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      // Detect Internet Explorer 8+
      if (document !== undefined && 'objectFit' in document.documentElement.style === false) {
        console.error(['MUI: ImageList v5+ no longer natively supports Internet Explorer.', 'Use v4 of this component instead, or polyfill CSS object-fit.'].join('\n'));
      }
    }
  }, []);
  const style = variant === 'masonry' ? (0, _extends2$19.default)({
    columnCount: cols,
    columnGap: gap
  }, styleProp) : (0, _extends2$19.default)({
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gap
  }, styleProp);
  const ownerState = (0, _extends2$19.default)({}, props, {
    component,
    gap,
    rowHeight,
    variant
  });
  const classes = useUtilityClasses$Z(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1m.jsx)(ImageListRoot, (0, _extends2$19.default)({
    as: component,
    className: (0, _clsx$1x.default)(classes.root, classes[variant], className),
    ref: ref,
    style: style,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$1m.jsx)(_ImageListContext$1.default.Provider, {
      value: contextValue,
      children: children
    })
  }));
});
process.env.NODE_ENV !== "production" ? ImageList.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `ImageListItem`s.
   */
  children: _propTypes$1x.default /* @typescript-to-proptypes-ignore */.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1x.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1x.default.string,
  /**
   * Number of columns.
   * @default 2
   */
  cols: _integerPropType$7.default,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1x.default.elementType,
  /**
   * The gap between items in px.
   * @default 4
   */
  gap: _propTypes$1x.default.number,
  /**
   * The height of one row in px.
   * @default 'auto'
   */
  rowHeight: _propTypes$1x.default.oneOfType([_propTypes$1x.default.oneOf(['auto']), _propTypes$1x.default.number]),
  /**
   * @ignore
   */
  style: _propTypes$1x.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1x.default.oneOfType([_propTypes$1x.default.arrayOf(_propTypes$1x.default.oneOfType([_propTypes$1x.default.func, _propTypes$1x.default.object, _propTypes$1x.default.bool])), _propTypes$1x.default.func, _propTypes$1x.default.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: _propTypes$1x.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1x.default.oneOf(['masonry', 'quilted', 'standard', 'woven']), _propTypes$1x.default.string])
} : void 0;
ImageList$1.default = ImageList;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  imageListClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ImageList.default;
  }
});
Object.defineProperty(exports, "imageListClasses", {
  enumerable: true,
  get: function () {
    return _imageListClasses.default;
  }
});
var _ImageList = _interopRequireDefault(ImageList$1);
var _imageListClasses = _interopRequireWildcard(imageListClasses$1);
Object.keys(_imageListClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _imageListClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _imageListClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ImageList$2));

var ImageListItem$2 = {};

var ImageListItem$1 = {};

var imageListItemClasses$1 = {};

var _interopRequireDefault$5J = interopRequireDefault$1.exports;
Object.defineProperty(imageListItemClasses$1, "__esModule", {
  value: true
});
imageListItemClasses$1.default = void 0;
imageListItemClasses$1.getImageListItemUtilityClass = getImageListItemUtilityClass;
var _generateUtilityClasses$U = _interopRequireDefault$5J(generateUtilityClasses$3);
var _generateUtilityClass$U = _interopRequireDefault$5J(generateUtilityClass$3);
function getImageListItemUtilityClass(slot) {
  return (0, _generateUtilityClass$U.default)('MuiImageListItem', slot);
}
const imageListItemClasses = (0, _generateUtilityClasses$U.default)('MuiImageListItem', ['root', 'img', 'standard', 'woven', 'masonry', 'quilted']);
imageListItemClasses$1.default = imageListItemClasses;

var _interopRequireDefault$5I = interopRequireDefault$1.exports;
Object.defineProperty(ImageListItem$1, "__esModule", {
  value: true
});
ImageListItem$1.default = void 0;
var _objectWithoutPropertiesLoose2$15 = _interopRequireDefault$5I(objectWithoutPropertiesLoose.exports);
var _extends2$18 = _interopRequireDefault$5I(_extends$19.exports);
var _composeClasses$X = _interopRequireDefault$5I(composeClasses$2);
var _integerPropType$6 = _interopRequireDefault$5I(integerPropType$1);
var _clsx$1w = _interopRequireDefault$5I(clsx.exports);
var _propTypes$1w = _interopRequireDefault$5I(propTypes.exports);
var React$1s = _interopRequireWildcard$2y(React__default$4);
var _reactIs$7 = reactIs$6.exports;
var _ImageListContext = _interopRequireDefault$5I(ImageListContext$1);
var _styled$V = _interopRequireDefault$5I(styled$2);
var _DefaultPropsProvider$W = DefaultPropsProvider$5;
var _isMuiElement$3 = _interopRequireDefault$5I(isMuiElement);
var _imageListItemClasses = _interopRequireWildcard$2y(imageListItemClasses$1);
var _jsxRuntime$1l = require$$11;
const _excluded$1z = ["children", "className", "cols", "component", "rows", "style"];
function _getRequireWildcardCache$2h(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2h = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2y(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2h(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$Y = ownerState => {
  const {
    classes,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant],
    img: ['img']
  };
  return (0, _composeClasses$X.default)(slots, _imageListItemClasses.getImageListItemUtilityClass, classes);
};
const ImageListItemRoot = (0, _styled$V.default)('li', {
  name: 'MuiImageListItem',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_imageListItemClasses.default.img}`]: styles.img
    }, styles.root, styles[ownerState.variant]];
  }
})(({
  ownerState
}) => (0, _extends2$18.default)({
  display: 'block',
  position: 'relative'
}, ownerState.variant === 'standard' && {
  // For titlebar under list item
  display: 'flex',
  flexDirection: 'column'
}, ownerState.variant === 'woven' && {
  height: '100%',
  alignSelf: 'center',
  '&:nth-of-type(even)': {
    height: '70%'
  }
}, {
  [`& .${_imageListItemClasses.default.img}`]: (0, _extends2$18.default)({
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    display: 'block'
  }, ownerState.variant === 'standard' && {
    height: 'auto',
    flexGrow: 1
  })
}));
const ImageListItem = /*#__PURE__*/React$1s.forwardRef(function ImageListItem(inProps, ref) {
  const props = (0, _DefaultPropsProvider$W.useDefaultProps)({
    props: inProps,
    name: 'MuiImageListItem'
  });

  // TODO: - Use jsdoc @default?: "cols rows default values are for docs only"
  const {
      children,
      className,
      cols = 1,
      component = 'li',
      rows = 1,
      style
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$15.default)(props, _excluded$1z);
  const {
    rowHeight = 'auto',
    gap,
    variant
  } = React$1s.useContext(_ImageListContext.default);
  let height = 'auto';
  if (variant === 'woven') {
    height = undefined;
  } else if (rowHeight !== 'auto') {
    height = rowHeight * rows + gap * (rows - 1);
  }
  const ownerState = (0, _extends2$18.default)({}, props, {
    cols,
    component,
    gap,
    rowHeight,
    rows,
    variant
  });
  const classes = useUtilityClasses$Y(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1l.jsx)(ImageListItemRoot, (0, _extends2$18.default)({
    as: component,
    className: (0, _clsx$1w.default)(classes.root, classes[variant], className),
    ref: ref,
    style: (0, _extends2$18.default)({
      height,
      gridColumnEnd: variant !== 'masonry' ? `span ${cols}` : undefined,
      gridRowEnd: variant !== 'masonry' ? `span ${rows}` : undefined,
      marginBottom: variant === 'masonry' ? gap : undefined,
      breakInside: variant === 'masonry' ? 'avoid' : undefined
    }, style),
    ownerState: ownerState
  }, other, {
    children: React$1s.Children.map(children, child => {
      if (! /*#__PURE__*/React$1s.isValidElement(child)) {
        return null;
      }
      if (process.env.NODE_ENV !== 'production') {
        if ((0, _reactIs$7.isFragment)(child)) {
          console.error(["MUI: The ImageListItem component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
        }
      }
      if (child.type === 'img' || (0, _isMuiElement$3.default)(child, ['Image'])) {
        return /*#__PURE__*/React$1s.cloneElement(child, {
          className: (0, _clsx$1w.default)(classes.img, child.props.className)
        });
      }
      return child;
    })
  }));
});
process.env.NODE_ENV !== "production" ? ImageListItem.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `<img>`.
   */
  children: _propTypes$1w.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1w.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1w.default.string,
  /**
   * Width of the item in number of grid columns.
   * @default 1
   */
  cols: _integerPropType$6.default,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1w.default.elementType,
  /**
   * Height of the item in number of grid rows.
   * @default 1
   */
  rows: _integerPropType$6.default,
  /**
   * @ignore
   */
  style: _propTypes$1w.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1w.default.oneOfType([_propTypes$1w.default.arrayOf(_propTypes$1w.default.oneOfType([_propTypes$1w.default.func, _propTypes$1w.default.object, _propTypes$1w.default.bool])), _propTypes$1w.default.func, _propTypes$1w.default.object])
} : void 0;
ImageListItem$1.default = ImageListItem;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  imageListItemClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ImageListItem.default;
  }
});
Object.defineProperty(exports, "imageListItemClasses", {
  enumerable: true,
  get: function () {
    return _imageListItemClasses.default;
  }
});
var _ImageListItem = _interopRequireDefault(ImageListItem$1);
var _imageListItemClasses = _interopRequireWildcard(imageListItemClasses$1);
Object.keys(_imageListItemClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _imageListItemClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _imageListItemClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ImageListItem$2));

var ImageListItemBar$2 = {};

var ImageListItemBar$1 = {};

var imageListItemBarClasses$1 = {};

var _interopRequireDefault$5H = interopRequireDefault$1.exports;
Object.defineProperty(imageListItemBarClasses$1, "__esModule", {
  value: true
});
imageListItemBarClasses$1.default = void 0;
imageListItemBarClasses$1.getImageListItemBarUtilityClass = getImageListItemBarUtilityClass;
var _generateUtilityClasses$T = _interopRequireDefault$5H(generateUtilityClasses$3);
var _generateUtilityClass$T = _interopRequireDefault$5H(generateUtilityClass$3);
function getImageListItemBarUtilityClass(slot) {
  return (0, _generateUtilityClass$T.default)('MuiImageListItemBar', slot);
}
const imageListItemBarClasses = (0, _generateUtilityClasses$T.default)('MuiImageListItemBar', ['root', 'positionBottom', 'positionTop', 'positionBelow', 'titleWrap', 'titleWrapBottom', 'titleWrapTop', 'titleWrapBelow', 'titleWrapActionPosLeft', 'titleWrapActionPosRight', 'title', 'subtitle', 'actionIcon', 'actionIconActionPosLeft', 'actionIconActionPosRight']);
imageListItemBarClasses$1.default = imageListItemBarClasses;

var _interopRequireDefault$5G = interopRequireDefault$1.exports;
Object.defineProperty(ImageListItemBar$1, "__esModule", {
  value: true
});
ImageListItemBar$1.default = void 0;
var _objectWithoutPropertiesLoose2$14 = _interopRequireDefault$5G(objectWithoutPropertiesLoose.exports);
var _extends2$17 = _interopRequireDefault$5G(_extends$19.exports);
var _composeClasses$W = _interopRequireDefault$5G(composeClasses$2);
var _clsx$1v = _interopRequireDefault$5G(clsx.exports);
var _propTypes$1v = _interopRequireDefault$5G(propTypes.exports);
var React$1r = _interopRequireWildcard$2x(React__default$4);
var _styled$U = _interopRequireDefault$5G(styled$2);
var _DefaultPropsProvider$V = DefaultPropsProvider$5;
var _capitalize$m = _interopRequireDefault$5G(capitalize$1);
var _imageListItemBarClasses = imageListItemBarClasses$1;
var _jsxRuntime$1k = require$$11;
const _excluded$1y = ["actionIcon", "actionPosition", "className", "subtitle", "title", "position"];
function _getRequireWildcardCache$2g(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2g = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2x(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2g(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$X = ownerState => {
  const {
    classes,
    position,
    actionIcon,
    actionPosition
  } = ownerState;
  const slots = {
    root: ['root', `position${(0, _capitalize$m.default)(position)}`],
    titleWrap: ['titleWrap', `titleWrap${(0, _capitalize$m.default)(position)}`, actionIcon && `titleWrapActionPos${(0, _capitalize$m.default)(actionPosition)}`],
    title: ['title'],
    subtitle: ['subtitle'],
    actionIcon: ['actionIcon', `actionIconActionPos${(0, _capitalize$m.default)(actionPosition)}`]
  };
  return (0, _composeClasses$W.default)(slots, _imageListItemBarClasses.getImageListItemBarUtilityClass, classes);
};
const ImageListItemBarRoot = (0, _styled$U.default)('div', {
  name: 'MuiImageListItemBar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`position${(0, _capitalize$m.default)(ownerState.position)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  return (0, _extends2$17.default)({
    position: 'absolute',
    left: 0,
    right: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    fontFamily: theme.typography.fontFamily
  }, ownerState.position === 'bottom' && {
    bottom: 0
  }, ownerState.position === 'top' && {
    top: 0
  }, ownerState.position === 'below' && {
    position: 'relative',
    background: 'transparent',
    alignItems: 'normal'
  });
});
const ImageListItemBarTitleWrap = (0, _styled$U.default)('div', {
  name: 'MuiImageListItemBar',
  slot: 'TitleWrap',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.titleWrap, styles[`titleWrap${(0, _capitalize$m.default)(ownerState.position)}`], ownerState.actionIcon && styles[`titleWrapActionPos${(0, _capitalize$m.default)(ownerState.actionPosition)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  return (0, _extends2$17.default)({
    flexGrow: 1,
    padding: '12px 16px',
    color: (theme.vars || theme).palette.common.white,
    overflow: 'hidden'
  }, ownerState.position === 'below' && {
    padding: '6px 0 12px',
    color: 'inherit'
  }, ownerState.actionIcon && ownerState.actionPosition === 'left' && {
    paddingLeft: 0
  }, ownerState.actionIcon && ownerState.actionPosition === 'right' && {
    paddingRight: 0
  });
});
const ImageListItemBarTitle = (0, _styled$U.default)('div', {
  name: 'MuiImageListItemBar',
  slot: 'Title',
  overridesResolver: (props, styles) => styles.title
})(({
  theme
}) => {
  return {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: '24px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
});
const ImageListItemBarSubtitle = (0, _styled$U.default)('div', {
  name: 'MuiImageListItemBar',
  slot: 'Subtitle',
  overridesResolver: (props, styles) => styles.subtitle
})(({
  theme
}) => {
  return {
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
});
const ImageListItemBarActionIcon = (0, _styled$U.default)('div', {
  name: 'MuiImageListItemBar',
  slot: 'ActionIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.actionIcon, styles[`actionIconActionPos${(0, _capitalize$m.default)(ownerState.actionPosition)}`]];
  }
})(({
  ownerState
}) => {
  return (0, _extends2$17.default)({}, ownerState.actionPosition === 'left' && {
    order: -1
  });
});
const ImageListItemBar = /*#__PURE__*/React$1r.forwardRef(function ImageListItemBar(inProps, ref) {
  const props = (0, _DefaultPropsProvider$V.useDefaultProps)({
    props: inProps,
    name: 'MuiImageListItemBar'
  });
  const {
      actionIcon,
      actionPosition = 'right',
      className,
      subtitle,
      title,
      position = 'bottom'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$14.default)(props, _excluded$1y);
  const ownerState = (0, _extends2$17.default)({}, props, {
    position,
    actionPosition
  });
  const classes = useUtilityClasses$X(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1k.jsxs)(ImageListItemBarRoot, (0, _extends2$17.default)({
    ownerState: ownerState,
    className: (0, _clsx$1v.default)(classes.root, className),
    ref: ref
  }, other, {
    children: [/*#__PURE__*/(0, _jsxRuntime$1k.jsxs)(ImageListItemBarTitleWrap, {
      ownerState: ownerState,
      className: classes.titleWrap,
      children: [/*#__PURE__*/(0, _jsxRuntime$1k.jsx)(ImageListItemBarTitle, {
        className: classes.title,
        children: title
      }), subtitle ? /*#__PURE__*/(0, _jsxRuntime$1k.jsx)(ImageListItemBarSubtitle, {
        className: classes.subtitle,
        children: subtitle
      }) : null]
    }), actionIcon ? /*#__PURE__*/(0, _jsxRuntime$1k.jsx)(ImageListItemBarActionIcon, {
      ownerState: ownerState,
      className: classes.actionIcon,
      children: actionIcon
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? ImageListItemBar.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the item itself).
   */
  actionIcon: _propTypes$1v.default.node,
  /**
   * Position of secondary action IconButton.
   * @default 'right'
   */
  actionPosition: _propTypes$1v.default.oneOf(['left', 'right']),
  /**
   * @ignore
   */
  children: _propTypes$1v.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1v.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1v.default.string,
  /**
   * Position of the title bar.
   * @default 'bottom'
   */
  position: _propTypes$1v.default.oneOf(['below', 'bottom', 'top']),
  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: _propTypes$1v.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1v.default.oneOfType([_propTypes$1v.default.arrayOf(_propTypes$1v.default.oneOfType([_propTypes$1v.default.func, _propTypes$1v.default.object, _propTypes$1v.default.bool])), _propTypes$1v.default.func, _propTypes$1v.default.object]),
  /**
   * Title to be displayed.
   */
  title: _propTypes$1v.default.node
} : void 0;
ImageListItemBar$1.default = ImageListItemBar;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  imageListItemBarClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ImageListItemBar.default;
  }
});
Object.defineProperty(exports, "imageListItemBarClasses", {
  enumerable: true,
  get: function () {
    return _imageListItemBarClasses.default;
  }
});
var _ImageListItemBar = _interopRequireDefault(ImageListItemBar$1);
var _imageListItemBarClasses = _interopRequireWildcard(imageListItemBarClasses$1);
Object.keys(_imageListItemBarClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _imageListItemBarClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _imageListItemBarClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ImageListItemBar$2));

var Input$7 = {};

var Input$6 = {};

var _interopRequireDefault$5F = interopRequireDefault$1.exports;
Object.defineProperty(Input$6, "__esModule", {
  value: true
});
Input$6.default = void 0;
var _objectWithoutPropertiesLoose2$13 = _interopRequireDefault$5F(objectWithoutPropertiesLoose.exports);
var _extends2$16 = _interopRequireDefault$5F(_extends$19.exports);
var React$1q = _interopRequireWildcard$2w(React__default$4);
var _propTypes$1u = _interopRequireDefault$5F(propTypes.exports);
var _composeClasses$V = _interopRequireDefault$5F(composeClasses$2);
var _deepmerge$1 = _interopRequireDefault$5F(deepmerge$2);
var _refType$8 = _interopRequireDefault$5F(refType$2);
var _InputBase$2 = _interopRequireDefault$5F(InputBase$3);
var _styled$T = _interopRequireWildcard$2w(styled$2);
var _DefaultPropsProvider$U = DefaultPropsProvider$5;
var _inputClasses = _interopRequireWildcard$2w(inputClasses$1);
var _InputBase2$1 = InputBase$2;
var _jsxRuntime$1j = require$$11;
const _excluded$1x = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"];
function _getRequireWildcardCache$2f(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2f = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2w(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2f(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$W = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = (0, _composeClasses$V.default)(slots, _inputClasses.getInputUtilityClass, classes);
  return (0, _extends2$16.default)({}, classes, composedClasses);
};
const InputRoot = (0, _styled$T.default)(_InputBase2$1.InputBaseRoot, {
  shouldForwardProp: prop => (0, _styled$T.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...(0, _InputBase2$1.rootOverridesResolver)(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  if (theme.vars) {
    bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
  }
  return (0, _extends2$16.default)({
    position: 'relative'
  }, ownerState.formControl && {
    'label + &': {
      marginTop: 16
    }
  }, !ownerState.disableUnderline && {
    '&::after': {
      borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },
    [`&.${_inputClasses.default.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: 'scaleX(1) translateX(0)'
    },
    [`&.${_inputClasses.default.error}`]: {
      '&::before, &::after': {
        borderBottomColor: (theme.vars || theme).palette.error.main
      }
    },
    '&::before': {
      borderBottom: `1px solid ${bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.
    },
    [`&:hover:not(.${_inputClasses.default.disabled}, .${_inputClasses.default.error}):before`]: {
      borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        borderBottom: `1px solid ${bottomLineColor}`
      }
    },
    [`&.${_inputClasses.default.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  });
});
const InputInput = (0, _styled$T.default)(_InputBase2$1.InputBaseComponent, {
  name: 'MuiInput',
  slot: 'Input',
  overridesResolver: _InputBase2$1.inputOverridesResolver
})({});
const Input$5 = /*#__PURE__*/React$1q.forwardRef(function Input(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$input;
  const props = (0, _DefaultPropsProvider$U.useDefaultProps)({
    props: inProps,
    name: 'MuiInput'
  });
  const {
      disableUnderline,
      components = {},
      componentsProps: componentsPropsProp,
      fullWidth = false,
      inputComponent = 'input',
      multiline = false,
      slotProps,
      slots = {},
      type = 'text'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$13.default)(props, _excluded$1x);
  const classes = useUtilityClasses$W(props);
  const ownerState = {
    disableUnderline
  };
  const inputComponentsProps = {
    root: {
      ownerState
    }
  };
  const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, _deepmerge$1.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
  const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : InputRoot;
  const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : InputInput;
  return /*#__PURE__*/(0, _jsxRuntime$1j.jsx)(_InputBase$2.default, (0, _extends2$16.default)({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    slotProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? Input$5.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _propTypes$1u.default.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: _propTypes$1u.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1u.default.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: _propTypes$1u.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1u.default.oneOf(['primary', 'secondary']), _propTypes$1u.default.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$1u.default.shape({
    Input: _propTypes$1u.default.elementType,
    Root: _propTypes$1u.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: _propTypes$1u.default.shape({
    input: _propTypes$1u.default.object,
    root: _propTypes$1u.default.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes$1u.default.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: _propTypes$1u.default.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: _propTypes$1u.default.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes$1u.default.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: _propTypes$1u.default.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$1u.default.bool,
  /**
   * The id of the `input` element.
   */
  id: _propTypes$1u.default.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: _propTypes$1u.default.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: _propTypes$1u.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType$8.default,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: _propTypes$1u.default.oneOf(['dense', 'none']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _propTypes$1u.default.oneOfType([_propTypes$1u.default.number, _propTypes$1u.default.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: _propTypes$1u.default.oneOfType([_propTypes$1u.default.number, _propTypes$1u.default.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: _propTypes$1u.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes$1u.default.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes$1u.default.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: _propTypes$1u.default.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes$1u.default.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: _propTypes$1u.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes$1u.default.oneOfType([_propTypes$1u.default.number, _propTypes$1u.default.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: _propTypes$1u.default.shape({
    input: _propTypes$1u.default.object,
    root: _propTypes$1u.default.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: _propTypes$1u.default.shape({
    input: _propTypes$1u.default.elementType,
    root: _propTypes$1u.default.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes$1u.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1u.default.oneOfType([_propTypes$1u.default.arrayOf(_propTypes$1u.default.oneOfType([_propTypes$1u.default.func, _propTypes$1u.default.object, _propTypes$1u.default.bool])), _propTypes$1u.default.func, _propTypes$1u.default.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: _propTypes$1u.default.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _propTypes$1u.default.any
} : void 0;
Input$5.muiName = 'Input';
Input$6.default = Input$5;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  inputClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Input.default;
  }
});
Object.defineProperty(exports, "inputClasses", {
  enumerable: true,
  get: function () {
    return _inputClasses.default;
  }
});
var _Input = _interopRequireDefault(Input$6);
var _inputClasses = _interopRequireWildcard(inputClasses$1);
Object.keys(_inputClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _inputClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _inputClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Input$7));

var InputAdornment$4 = {};

var InputAdornment$3 = {};

var inputAdornmentClasses$1 = {};

var _interopRequireDefault$5E = interopRequireDefault$1.exports;
Object.defineProperty(inputAdornmentClasses$1, "__esModule", {
  value: true
});
inputAdornmentClasses$1.default = void 0;
inputAdornmentClasses$1.getInputAdornmentUtilityClass = getInputAdornmentUtilityClass;
var _generateUtilityClasses$S = _interopRequireDefault$5E(generateUtilityClasses$3);
var _generateUtilityClass$S = _interopRequireDefault$5E(generateUtilityClass$3);
function getInputAdornmentUtilityClass(slot) {
  return (0, _generateUtilityClass$S.default)('MuiInputAdornment', slot);
}
const inputAdornmentClasses = (0, _generateUtilityClasses$S.default)('MuiInputAdornment', ['root', 'filled', 'standard', 'outlined', 'positionStart', 'positionEnd', 'disablePointerEvents', 'hiddenLabel', 'sizeSmall']);
inputAdornmentClasses$1.default = inputAdornmentClasses;

var _interopRequireDefault$5D = interopRequireDefault$1.exports;
Object.defineProperty(InputAdornment$3, "__esModule", {
  value: true
});
InputAdornment$3.default = void 0;
var _objectWithoutPropertiesLoose2$12 = _interopRequireDefault$5D(objectWithoutPropertiesLoose.exports);
var _extends2$15 = _interopRequireDefault$5D(_extends$19.exports);
var React$1p = _interopRequireWildcard$2v(React__default$4);
var _propTypes$1t = _interopRequireDefault$5D(propTypes.exports);
var _clsx$1u = _interopRequireDefault$5D(clsx.exports);
var _composeClasses$U = _interopRequireDefault$5D(composeClasses$2);
var _capitalize$l = _interopRequireDefault$5D(capitalize$1);
var _Typography$2 = _interopRequireDefault$5D(Typography$3);
var _FormControlContext = _interopRequireDefault$5D(FormControlContext$1);
var _useFormControl$4 = _interopRequireDefault$5D(useFormControl$1);
var _styled$S = _interopRequireDefault$5D(styled$2);
var _inputAdornmentClasses = _interopRequireWildcard$2v(inputAdornmentClasses$1);
var _DefaultPropsProvider$T = DefaultPropsProvider$5;
var _jsxRuntime$1i = require$$11;
var _span$2;
const _excluded$1w = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];
function _getRequireWildcardCache$2e(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2e = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2v(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2e(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const overridesResolver$4 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, styles[`position${(0, _capitalize$l.default)(ownerState.position)}`], ownerState.disablePointerEvents === true && styles.disablePointerEvents, styles[ownerState.variant]];
};
const useUtilityClasses$V = ownerState => {
  const {
    classes,
    disablePointerEvents,
    hiddenLabel,
    position,
    size,
    variant
  } = ownerState;
  const slots = {
    root: ['root', disablePointerEvents && 'disablePointerEvents', position && `position${(0, _capitalize$l.default)(position)}`, variant, hiddenLabel && 'hiddenLabel', size && `size${(0, _capitalize$l.default)(size)}`]
  };
  return (0, _composeClasses$U.default)(slots, _inputAdornmentClasses.getInputAdornmentUtilityClass, classes);
};
const InputAdornmentRoot = (0, _styled$S.default)('div', {
  name: 'MuiInputAdornment',
  slot: 'Root',
  overridesResolver: overridesResolver$4
})(({
  theme,
  ownerState
}) => (0, _extends2$15.default)({
  display: 'flex',
  height: '0.01em',
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: '2em',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  color: (theme.vars || theme).palette.action.active
}, ownerState.variant === 'filled' && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${_inputAdornmentClasses.default.positionStart}&:not(.${_inputAdornmentClasses.default.hiddenLabel})`]: {
    marginTop: 16
  }
}, ownerState.position === 'start' && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, ownerState.position === 'end' && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, ownerState.disablePointerEvents === true && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: 'none'
}));
const InputAdornment$2 = /*#__PURE__*/React$1p.forwardRef(function InputAdornment(inProps, ref) {
  const props = (0, _DefaultPropsProvider$T.useDefaultProps)({
    props: inProps,
    name: 'MuiInputAdornment'
  });
  const {
      children,
      className,
      component = 'div',
      disablePointerEvents = false,
      disableTypography = false,
      position,
      variant: variantProp
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$12.default)(props, _excluded$1w);
  const muiFormControl = (0, _useFormControl$4.default)() || {};
  let variant = variantProp;
  if (variantProp && muiFormControl.variant) {
    if (process.env.NODE_ENV !== 'production') {
      if (variantProp === muiFormControl.variant) {
        console.error('MUI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }
  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }
  const ownerState = (0, _extends2$15.default)({}, props, {
    hiddenLabel: muiFormControl.hiddenLabel,
    size: muiFormControl.size,
    disablePointerEvents,
    position,
    variant
  });
  const classes = useUtilityClasses$V(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1i.jsx)(_FormControlContext.default.Provider, {
    value: null,
    children: /*#__PURE__*/(0, _jsxRuntime$1i.jsx)(InputAdornmentRoot, (0, _extends2$15.default)({
      as: component,
      ownerState: ownerState,
      className: (0, _clsx$1u.default)(classes.root, className),
      ref: ref
    }, other, {
      children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/(0, _jsxRuntime$1i.jsx)(_Typography$2.default, {
        color: "text.secondary",
        children: children
      }) : /*#__PURE__*/(0, _jsxRuntime$1i.jsxs)(React$1p.Fragment, {
        children: [position === 'start' ? ( /* notranslate needed while Google Translate will not fix zero-width space issue */_span$2 || (_span$2 = /*#__PURE__*/(0, _jsxRuntime$1i.jsx)("span", {
          className: "notranslate",
          children: "\u200B"
        }))) : null, children]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" ? InputAdornment$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: _propTypes$1t.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1t.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1t.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1t.default.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: _propTypes$1t.default.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: _propTypes$1t.default.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: _propTypes$1t.default.oneOf(['end', 'start']).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1t.default.oneOfType([_propTypes$1t.default.arrayOf(_propTypes$1t.default.oneOfType([_propTypes$1t.default.func, _propTypes$1t.default.object, _propTypes$1t.default.bool])), _propTypes$1t.default.func, _propTypes$1t.default.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: _propTypes$1t.default.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
InputAdornment$3.default = InputAdornment$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  inputAdornmentClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _InputAdornment.default;
  }
});
Object.defineProperty(exports, "inputAdornmentClasses", {
  enumerable: true,
  get: function () {
    return _inputAdornmentClasses.default;
  }
});
var _InputAdornment = _interopRequireDefault(InputAdornment$3);
var _inputAdornmentClasses = _interopRequireWildcard(inputAdornmentClasses$1);
Object.keys(_inputAdornmentClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _inputAdornmentClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _inputAdornmentClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(InputAdornment$4));

var InputAdornment$1 = /*@__PURE__*/getDefaultExportFromCjs$1(InputAdornment$4);

var InputLabel$4 = {};

var InputLabel$3 = {};

var inputLabelClasses$1 = {};

var _interopRequireDefault$5C = interopRequireDefault$1.exports;
Object.defineProperty(inputLabelClasses$1, "__esModule", {
  value: true
});
inputLabelClasses$1.default = void 0;
inputLabelClasses$1.getInputLabelUtilityClasses = getInputLabelUtilityClasses;
var _generateUtilityClasses$R = _interopRequireDefault$5C(generateUtilityClasses$3);
var _generateUtilityClass$R = _interopRequireDefault$5C(generateUtilityClass$3);
function getInputLabelUtilityClasses(slot) {
  return (0, _generateUtilityClass$R.default)('MuiInputLabel', slot);
}
const inputLabelClasses = (0, _generateUtilityClasses$R.default)('MuiInputLabel', ['root', 'focused', 'disabled', 'error', 'required', 'asterisk', 'formControl', 'sizeSmall', 'shrink', 'animated', 'standard', 'filled', 'outlined']);
inputLabelClasses$1.default = inputLabelClasses;

var _interopRequireDefault$5B = interopRequireDefault$1.exports;
Object.defineProperty(InputLabel$3, "__esModule", {
  value: true
});
InputLabel$3.default = void 0;
var _objectWithoutPropertiesLoose2$11 = _interopRequireDefault$5B(objectWithoutPropertiesLoose.exports);
var _extends2$14 = _interopRequireDefault$5B(_extends$19.exports);
var React$1o = _interopRequireWildcard$2u(React__default$4);
var _propTypes$1s = _interopRequireDefault$5B(propTypes.exports);
var _composeClasses$T = _interopRequireDefault$5B(composeClasses$2);
var _clsx$1t = _interopRequireDefault$5B(clsx.exports);
var _formControlState$3 = _interopRequireDefault$5B(formControlState$1);
var _useFormControl$3 = _interopRequireDefault$5B(useFormControl$1);
var _FormLabel = _interopRequireWildcard$2u(FormLabel$3);
var _DefaultPropsProvider$S = DefaultPropsProvider$5;
var _capitalize$k = _interopRequireDefault$5B(capitalize$1);
var _styled$R = _interopRequireWildcard$2u(styled$2);
var _inputLabelClasses = inputLabelClasses$1;
var _jsxRuntime$1h = require$$11;
const _excluded$1v = ["disableAnimation", "margin", "shrink", "variant", "className"];
function _getRequireWildcardCache$2d(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2d = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2u(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2d(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$U = ownerState => {
  const {
    classes,
    formControl,
    size,
    shrink,
    disableAnimation,
    variant,
    required
  } = ownerState;
  const slots = {
    root: ['root', formControl && 'formControl', !disableAnimation && 'animated', shrink && 'shrink', size && size !== 'normal' && `size${(0, _capitalize$k.default)(size)}`, variant],
    asterisk: [required && 'asterisk']
  };
  const composedClasses = (0, _composeClasses$T.default)(slots, _inputLabelClasses.getInputLabelUtilityClasses, classes);
  return (0, _extends2$14.default)({}, classes, composedClasses);
};
const InputLabelRoot = (0, _styled$R.default)(_FormLabel.default, {
  shouldForwardProp: prop => (0, _styled$R.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiInputLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_FormLabel.formLabelClasses.asterisk}`]: styles.asterisk
    }, styles.root, ownerState.formControl && styles.formControl, ownerState.size === 'small' && styles.sizeSmall, ownerState.shrink && styles.shrink, !ownerState.disableAnimation && styles.animated, ownerState.focused && styles.focused, styles[ownerState.variant]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$14.default)({
  display: 'block',
  transformOrigin: 'top left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%'
}, ownerState.formControl && {
  position: 'absolute',
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: 'translate(0, 20px) scale(1)'
}, ownerState.size === 'small' && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: 'translate(0, 17px) scale(1)'
}, ownerState.shrink && {
  transform: 'translate(0, -1.5px) scale(0.75)',
  transformOrigin: 'top left',
  maxWidth: '133%'
}, !ownerState.disableAnimation && {
  transition: theme.transitions.create(['color', 'transform', 'max-width'], {
    duration: theme.transitions.duration.shorter,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.variant === 'filled' && (0, _extends2$14.default)({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(12px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 13px) scale(1)'
}, ownerState.shrink && (0, _extends2$14.default)({
  userSelect: 'none',
  pointerEvents: 'auto',
  transform: 'translate(12px, 7px) scale(0.75)',
  maxWidth: 'calc(133% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 4px) scale(0.75)'
})), ownerState.variant === 'outlined' && (0, _extends2$14.default)({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(14px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(14px, 9px) scale(1)'
}, ownerState.shrink && {
  userSelect: 'none',
  pointerEvents: 'auto',
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: 'calc(133% - 32px)',
  transform: 'translate(14px, -9px) scale(0.75)'
})));
const InputLabel$2 = /*#__PURE__*/React$1o.forwardRef(function InputLabel(inProps, ref) {
  const props = (0, _DefaultPropsProvider$S.useDefaultProps)({
    name: 'MuiInputLabel',
    props: inProps
  });
  const {
      disableAnimation = false,
      shrink: shrinkProp,
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$11.default)(props, _excluded$1v);
  const muiFormControl = (0, _useFormControl$3.default)();
  let shrink = shrinkProp;
  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }
  const fcs = (0, _formControlState$3.default)({
    props,
    muiFormControl,
    states: ['size', 'variant', 'required', 'focused']
  });
  const ownerState = (0, _extends2$14.default)({}, props, {
    disableAnimation,
    formControl: muiFormControl,
    shrink,
    size: fcs.size,
    variant: fcs.variant,
    required: fcs.required,
    focused: fcs.focused
  });
  const classes = useUtilityClasses$U(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1h.jsx)(InputLabelRoot, (0, _extends2$14.default)({
    "data-shrink": shrink,
    ownerState: ownerState,
    ref: ref,
    className: (0, _clsx$1t.default)(classes.root, className)
  }, other, {
    classes: classes
  }));
});
process.env.NODE_ENV !== "production" ? InputLabel$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1s.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1s.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1s.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: _propTypes$1s.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1s.default.oneOf(['error', 'info', 'primary', 'secondary', 'success', 'warning']), _propTypes$1s.default.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: _propTypes$1s.default.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: _propTypes$1s.default.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: _propTypes$1s.default.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: _propTypes$1s.default.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: _propTypes$1s.default.oneOf(['dense']),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: _propTypes$1s.default.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: _propTypes$1s.default.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: _propTypes$1s.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1s.default.oneOf(['normal', 'small']), _propTypes$1s.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1s.default.oneOfType([_propTypes$1s.default.arrayOf(_propTypes$1s.default.oneOfType([_propTypes$1s.default.func, _propTypes$1s.default.object, _propTypes$1s.default.bool])), _propTypes$1s.default.func, _propTypes$1s.default.object]),
  /**
   * The variant to use.
   */
  variant: _propTypes$1s.default.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
InputLabel$3.default = InputLabel$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  inputLabelClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _InputLabel.default;
  }
});
Object.defineProperty(exports, "inputLabelClasses", {
  enumerable: true,
  get: function () {
    return _inputLabelClasses.default;
  }
});
var _InputLabel = _interopRequireDefault(InputLabel$3);
var _inputLabelClasses = _interopRequireWildcard(inputLabelClasses$1);
Object.keys(_inputLabelClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _inputLabelClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _inputLabelClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(InputLabel$4));

var InputLabel$1 = /*@__PURE__*/getDefaultExportFromCjs$1(InputLabel$4);

var LinearProgress$2 = {};

var LinearProgress$1 = {};

var linearProgressClasses$1 = {};

var _interopRequireDefault$5A = interopRequireDefault$1.exports;
Object.defineProperty(linearProgressClasses$1, "__esModule", {
  value: true
});
linearProgressClasses$1.default = void 0;
linearProgressClasses$1.getLinearProgressUtilityClass = getLinearProgressUtilityClass;
var _generateUtilityClasses$Q = _interopRequireDefault$5A(generateUtilityClasses$3);
var _generateUtilityClass$Q = _interopRequireDefault$5A(generateUtilityClass$3);
function getLinearProgressUtilityClass(slot) {
  return (0, _generateUtilityClass$Q.default)('MuiLinearProgress', slot);
}
const linearProgressClasses = (0, _generateUtilityClasses$Q.default)('MuiLinearProgress', ['root', 'colorPrimary', 'colorSecondary', 'determinate', 'indeterminate', 'buffer', 'query', 'dashed', 'dashedColorPrimary', 'dashedColorSecondary', 'bar', 'barColorPrimary', 'barColorSecondary', 'bar1Indeterminate', 'bar1Determinate', 'bar1Buffer', 'bar2Indeterminate', 'bar2Buffer']);
linearProgressClasses$1.default = linearProgressClasses;

var _interopRequireDefault$5z = interopRequireDefault$1.exports;
Object.defineProperty(LinearProgress$1, "__esModule", {
  value: true
});
LinearProgress$1.default = void 0;
var _objectWithoutPropertiesLoose2$10 = _interopRequireDefault$5z(objectWithoutPropertiesLoose.exports);
var _extends2$13 = _interopRequireDefault$5z(_extends$19.exports);
var React$1n = _interopRequireWildcard$2t(React__default$4);
var _propTypes$1r = _interopRequireDefault$5z(propTypes.exports);
var _clsx$1s = _interopRequireDefault$5z(clsx.exports);
var _composeClasses$S = _interopRequireDefault$5z(composeClasses$2);
var _system$2 = system;
var _colorManipulator$d = colorManipulator;
var _RtlProvider$8 = RtlProvider$1;
var _capitalize$j = _interopRequireDefault$5z(capitalize$1);
var _styled$Q = _interopRequireDefault$5z(styled$2);
var _DefaultPropsProvider$R = DefaultPropsProvider$5;
var _linearProgressClasses = linearProgressClasses$1;
var _jsxRuntime$1g = require$$11;
const _excluded$1u = ["className", "color", "value", "valueBuffer", "variant"];
function _getRequireWildcardCache$2c(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2c = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2t(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2c(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TRANSITION_DURATION = 4; // seconds
const indeterminate1Keyframe = (0, _system$2.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
const indeterminate2Keyframe = (0, _system$2.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const bufferKeyframe = (0, _system$2.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const useUtilityClasses$T = ownerState => {
  const {
    classes,
    variant,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${(0, _capitalize$j.default)(color)}`, variant],
    dashed: ['dashed', `dashedColor${(0, _capitalize$j.default)(color)}`],
    bar1: ['bar', `barColor${(0, _capitalize$j.default)(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate', variant === 'determinate' && 'bar1Determinate', variant === 'buffer' && 'bar1Buffer'],
    bar2: ['bar', variant !== 'buffer' && `barColor${(0, _capitalize$j.default)(color)}`, variant === 'buffer' && `color${(0, _capitalize$j.default)(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate', variant === 'buffer' && 'bar2Buffer']
  };
  return (0, _composeClasses$S.default)(slots, _linearProgressClasses.getLinearProgressUtilityClass, classes);
};
const getColorShade = (theme, color) => {
  if (color === 'inherit') {
    return 'currentColor';
  }
  if (theme.vars) {
    return theme.vars.palette.LinearProgress[`${color}Bg`];
  }
  return theme.palette.mode === 'light' ? (0, _colorManipulator$d.lighten)(theme.palette[color].main, 0.62) : (0, _colorManipulator$d.darken)(theme.palette[color].main, 0.5);
};
const LinearProgressRoot = (0, _styled$Q.default)('span', {
  name: 'MuiLinearProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${(0, _capitalize$j.default)(ownerState.color)}`], styles[ownerState.variant]];
  }
})(({
  ownerState,
  theme
}) => (0, _extends2$13.default)({
  position: 'relative',
  overflow: 'hidden',
  display: 'block',
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  '@media print': {
    colorAdjust: 'exact'
  },
  backgroundColor: getColorShade(theme, ownerState.color)
}, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
  backgroundColor: 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'currentColor',
    opacity: 0.3
  }
}, ownerState.variant === 'buffer' && {
  backgroundColor: 'transparent'
}, ownerState.variant === 'query' && {
  transform: 'rotate(180deg)'
}));
const LinearProgressDashed = (0, _styled$Q.default)('span', {
  name: 'MuiLinearProgress',
  slot: 'Dashed',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.dashed, styles[`dashedColor${(0, _capitalize$j.default)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => {
  const backgroundColor = getColorShade(theme, ownerState.color);
  return (0, _extends2$13.default)({
    position: 'absolute',
    marginTop: 0,
    height: '100%',
    width: '100%'
  }, ownerState.color === 'inherit' && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
    backgroundSize: '10px 10px',
    backgroundPosition: '0 -23px'
  });
}, (0, _system$2.css)`
    animation: ${bufferKeyframe} 3s infinite linear;
  `);
const LinearProgressBar1 = (0, _styled$Q.default)('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar1',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${(0, _capitalize$j.default)(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate, ownerState.variant === 'determinate' && styles.bar1Determinate, ownerState.variant === 'buffer' && styles.bar1Buffer];
  }
})(({
  ownerState,
  theme
}) => (0, _extends2$13.default)({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left',
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
}, ownerState.variant === 'determinate' && {
  transition: `transform .${TRANSITION_DURATION}s linear`
}, ownerState.variant === 'buffer' && {
  zIndex: 1,
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, _system$2.css)`
      width: auto;
      animation: ${indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `);
const LinearProgressBar2 = (0, _styled$Q.default)('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar2',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${(0, _capitalize$j.default)(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate, ownerState.variant === 'buffer' && styles.bar2Buffer];
  }
})(({
  ownerState,
  theme
}) => (0, _extends2$13.default)({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left'
}, ownerState.variant !== 'buffer' && {
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
}, ownerState.color === 'inherit' && {
  opacity: 0.3
}, ownerState.variant === 'buffer' && {
  backgroundColor: getColorShade(theme, ownerState.color),
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, _system$2.css)`
      width: auto;
      animation: ${indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `);

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const LinearProgress = /*#__PURE__*/React$1n.forwardRef(function LinearProgress(inProps, ref) {
  const props = (0, _DefaultPropsProvider$R.useDefaultProps)({
    props: inProps,
    name: 'MuiLinearProgress'
  });
  const {
      className,
      color = 'primary',
      value,
      valueBuffer,
      variant = 'indeterminate'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$10.default)(props, _excluded$1u);
  const ownerState = (0, _extends2$13.default)({}, props, {
    color,
    variant
  });
  const classes = useUtilityClasses$T(ownerState);
  const isRtl = (0, _RtlProvider$8.useRtl)();
  const rootProps = {};
  const inlineStyles = {
    bar1: {},
    bar2: {}
  };
  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      let transform = value - 100;
      if (isRtl) {
        transform = -transform;
      }
      inlineStyles.bar1.transform = `translateX(${transform}%)`;
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }
  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      let transform = (valueBuffer || 0) - 100;
      if (isRtl) {
        transform = -transform;
      }
      inlineStyles.bar2.transform = `translateX(${transform}%)`;
    } else if (process.env.NODE_ENV !== 'production') {
      console.error('MUI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime$1g.jsxs)(LinearProgressRoot, (0, _extends2$13.default)({
    className: (0, _clsx$1s.default)(classes.root, className),
    ownerState: ownerState,
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other, {
    children: [variant === 'buffer' ? /*#__PURE__*/(0, _jsxRuntime$1g.jsx)(LinearProgressDashed, {
      className: classes.dashed,
      ownerState: ownerState
    }) : null, /*#__PURE__*/(0, _jsxRuntime$1g.jsx)(LinearProgressBar1, {
      className: classes.bar1,
      ownerState: ownerState,
      style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/(0, _jsxRuntime$1g.jsx)(LinearProgressBar2, {
      className: classes.bar2,
      ownerState: ownerState,
      style: inlineStyles.bar2
    })]
  }));
});
process.env.NODE_ENV !== "production" ? LinearProgress.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1r.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1r.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$1r.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1r.default.oneOf(['inherit', 'primary', 'secondary']), _propTypes$1r.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1r.default.oneOfType([_propTypes$1r.default.arrayOf(_propTypes$1r.default.oneOfType([_propTypes$1r.default.func, _propTypes$1r.default.object, _propTypes$1r.default.bool])), _propTypes$1r.default.func, _propTypes$1r.default.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes$1r.default.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes$1r.default.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: _propTypes$1r.default.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
LinearProgress$1.default = LinearProgress;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  linearProgressClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _LinearProgress.default;
  }
});
Object.defineProperty(exports, "linearProgressClasses", {
  enumerable: true,
  get: function () {
    return _linearProgressClasses.default;
  }
});
var _LinearProgress = _interopRequireDefault(LinearProgress$1);
var _linearProgressClasses = _interopRequireWildcard(linearProgressClasses$1);
Object.keys(_linearProgressClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _linearProgressClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _linearProgressClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(LinearProgress$2));

var Link$3 = {};

var Link$2 = {};

var linkClasses$1 = {};

var _interopRequireDefault$5y = interopRequireDefault$1.exports;
Object.defineProperty(linkClasses$1, "__esModule", {
  value: true
});
linkClasses$1.default = void 0;
linkClasses$1.getLinkUtilityClass = getLinkUtilityClass;
var _generateUtilityClasses$P = _interopRequireDefault$5y(generateUtilityClasses$3);
var _generateUtilityClass$P = _interopRequireDefault$5y(generateUtilityClass$3);
function getLinkUtilityClass(slot) {
  return (0, _generateUtilityClass$P.default)('MuiLink', slot);
}
const linkClasses = (0, _generateUtilityClasses$P.default)('MuiLink', ['root', 'underlineNone', 'underlineHover', 'underlineAlways', 'button', 'focusVisible']);
linkClasses$1.default = linkClasses;

var getTextDecoration$1 = {};

Object.defineProperty(getTextDecoration$1, "__esModule", {
  value: true
});
getTextDecoration$1.default = getTextDecoration$1.colorTransformations = void 0;
var _system$1 = system;
var _colorManipulator$c = colorManipulator;
const colorTransformations = getTextDecoration$1.colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};
const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};
const getTextDecoration = ({
  theme,
  ownerState
}) => {
  const transformedColor = transformDeprecatedColors(ownerState.color);
  const color = (0, _system$1.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
  const channelColor = (0, _system$1.getPath)(theme, `palette.${transformedColor}Channel`);
  if ('vars' in theme && channelColor) {
    return `rgba(${channelColor} / 0.4)`;
  }
  return (0, _colorManipulator$c.alpha)(color, 0.4);
};
getTextDecoration$1.default = getTextDecoration;

var _interopRequireDefault$5x = interopRequireDefault$1.exports;
Object.defineProperty(Link$2, "__esModule", {
  value: true
});
Link$2.default = void 0;
var _objectWithoutPropertiesLoose2$$ = _interopRequireDefault$5x(objectWithoutPropertiesLoose.exports);
var _extends2$12 = _interopRequireDefault$5x(_extends$19.exports);
var React$1m = _interopRequireWildcard$2s(React__default$4);
var _propTypes$1q = _interopRequireDefault$5x(propTypes.exports);
var _clsx$1r = _interopRequireDefault$5x(clsx.exports);
var _elementTypeAcceptingRef$3 = _interopRequireDefault$5x(elementTypeAcceptingRef$2);
var _composeClasses$R = _interopRequireDefault$5x(composeClasses$2);
var _capitalize$i = _interopRequireDefault$5x(capitalize$1);
var _styled$P = _interopRequireDefault$5x(styled$2);
var _DefaultPropsProvider$Q = DefaultPropsProvider$5;
var _useIsFocusVisible$1 = _interopRequireDefault$5x(useIsFocusVisible);
var _useForkRef$c = _interopRequireDefault$5x(useForkRef);
var _Typography$1 = _interopRequireDefault$5x(Typography$3);
var _linkClasses = _interopRequireWildcard$2s(linkClasses$1);
var _getTextDecoration = _interopRequireWildcard$2s(getTextDecoration$1);
var _jsxRuntime$1f = require$$11;
const _excluded$1t = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"];
function _getRequireWildcardCache$2b(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2b = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2s(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2b(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$S = ownerState => {
  const {
    classes,
    component,
    focusVisible,
    underline
  } = ownerState;
  const slots = {
    root: ['root', `underline${(0, _capitalize$i.default)(underline)}`, component === 'button' && 'button', focusVisible && 'focusVisible']
  };
  return (0, _composeClasses$R.default)(slots, _linkClasses.getLinkUtilityClass, classes);
};
const LinkRoot = (0, _styled$P.default)(_Typography$1.default, {
  name: 'MuiLink',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`underline${(0, _capitalize$i.default)(ownerState.underline)}`], ownerState.component === 'button' && styles.button];
  }
})(({
  theme,
  ownerState
}) => {
  return (0, _extends2$12.default)({}, ownerState.underline === 'none' && {
    textDecoration: 'none'
  }, ownerState.underline === 'hover' && {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }, ownerState.underline === 'always' && (0, _extends2$12.default)({
    textDecoration: 'underline'
  }, ownerState.color !== 'inherit' && {
    textDecorationColor: (0, _getTextDecoration.default)({
      theme,
      ownerState
    })
  }, {
    '&:hover': {
      textDecorationColor: 'inherit'
    }
  }), ownerState.component === 'button' && {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${_linkClasses.default.focusVisible}`]: {
      outline: 'auto'
    }
  });
});
const Link$1 = /*#__PURE__*/React$1m.forwardRef(function Link(inProps, ref) {
  const props = (0, _DefaultPropsProvider$Q.useDefaultProps)({
    props: inProps,
    name: 'MuiLink'
  });
  const {
      className,
      color = 'primary',
      component = 'a',
      onBlur,
      onFocus,
      TypographyClasses,
      underline = 'always',
      variant = 'inherit',
      sx
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$$.default)(props, _excluded$1t);
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0, _useIsFocusVisible$1.default)();
  const [focusVisible, setFocusVisible] = React$1m.useState(false);
  const handlerRef = (0, _useForkRef$c.default)(ref, focusVisibleRef);
  const handleBlur = event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  };
  const handleFocus = event => {
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  const ownerState = (0, _extends2$12.default)({}, props, {
    color,
    component,
    focusVisible,
    underline,
    variant
  });
  const classes = useUtilityClasses$S(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1f.jsx)(LinkRoot, (0, _extends2$12.default)({
    color: color,
    className: (0, _clsx$1r.default)(classes.root, className),
    classes: TypographyClasses,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    ownerState: ownerState,
    variant: variant,
    sx: [...(!Object.keys(_getTextDecoration.colorTransformations).includes(color) ? [{
      color
    }] : []), ...(Array.isArray(sx) ? sx : [sx])]
  }, other));
});
process.env.NODE_ENV !== "production" ? Link$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1q.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1q.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1q.default.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: _propTypes$1q.default /* @typescript-to-proptypes-ignore */.any,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _elementTypeAcceptingRef$3.default,
  /**
   * @ignore
   */
  onBlur: _propTypes$1q.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes$1q.default.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1q.default.oneOfType([_propTypes$1q.default.arrayOf(_propTypes$1q.default.oneOfType([_propTypes$1q.default.func, _propTypes$1q.default.object, _propTypes$1q.default.bool])), _propTypes$1q.default.func, _propTypes$1q.default.object]),
  /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */
  TypographyClasses: _propTypes$1q.default.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: _propTypes$1q.default.oneOf(['always', 'hover', 'none']),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: _propTypes$1q.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$1q.default.oneOf(['body1', 'body2', 'button', 'caption', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'inherit', 'overline', 'subtitle1', 'subtitle2']), _propTypes$1q.default.string])
} : void 0;
Link$2.default = Link$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  linkClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Link.default;
  }
});
Object.defineProperty(exports, "linkClasses", {
  enumerable: true,
  get: function () {
    return _linkClasses.default;
  }
});
var _Link = _interopRequireDefault(Link$2);
var _linkClasses = _interopRequireWildcard(linkClasses$1);
Object.keys(_linkClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _linkClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _linkClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Link$3));

var List$3 = {};

var List$2 = {};

var ListContext$1 = {};

Object.defineProperty(ListContext$1, "__esModule", {
  value: true
});
ListContext$1.default = void 0;
var React$1l = _interopRequireWildcard$2r(React__default$4);
function _getRequireWildcardCache$2a(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2a = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2r(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$2a(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const ListContext = /*#__PURE__*/React$1l.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ListContext.displayName = 'ListContext';
}
ListContext$1.default = ListContext;

var listClasses$1 = {};

var _interopRequireDefault$5w = interopRequireDefault$1.exports;
Object.defineProperty(listClasses$1, "__esModule", {
  value: true
});
listClasses$1.default = void 0;
listClasses$1.getListUtilityClass = getListUtilityClass;
var _generateUtilityClasses$O = _interopRequireDefault$5w(generateUtilityClasses$3);
var _generateUtilityClass$O = _interopRequireDefault$5w(generateUtilityClass$3);
function getListUtilityClass(slot) {
  return (0, _generateUtilityClass$O.default)('MuiList', slot);
}
const listClasses = (0, _generateUtilityClasses$O.default)('MuiList', ['root', 'padding', 'dense', 'subheader']);
listClasses$1.default = listClasses;

var _interopRequireDefault$5v = interopRequireDefault$1.exports;
Object.defineProperty(List$2, "__esModule", {
  value: true
});
List$2.default = void 0;
var _objectWithoutPropertiesLoose2$_ = _interopRequireDefault$5v(objectWithoutPropertiesLoose.exports);
var _extends2$11 = _interopRequireDefault$5v(_extends$19.exports);
var React$1k = _interopRequireWildcard$2q(React__default$4);
var _propTypes$1p = _interopRequireDefault$5v(propTypes.exports);
var _clsx$1q = _interopRequireDefault$5v(clsx.exports);
var _composeClasses$Q = _interopRequireDefault$5v(composeClasses$2);
var _styled$O = _interopRequireDefault$5v(styled$2);
var _DefaultPropsProvider$P = DefaultPropsProvider$5;
var _ListContext$7 = _interopRequireDefault$5v(ListContext$1);
var _listClasses = listClasses$1;
var _jsxRuntime$1e = require$$11;
const _excluded$1s = ["children", "className", "component", "dense", "disablePadding", "subheader"];
function _getRequireWildcardCache$29(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$29 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2q(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$29(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$R = ownerState => {
  const {
    classes,
    disablePadding,
    dense,
    subheader
  } = ownerState;
  const slots = {
    root: ['root', !disablePadding && 'padding', dense && 'dense', subheader && 'subheader']
  };
  return (0, _composeClasses$Q.default)(slots, _listClasses.getListUtilityClass, classes);
};
const ListRoot = (0, _styled$O.default)('ul', {
  name: 'MuiList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disablePadding && styles.padding, ownerState.dense && styles.dense, ownerState.subheader && styles.subheader];
  }
})(({
  ownerState
}) => (0, _extends2$11.default)({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  position: 'relative'
}, !ownerState.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.subheader && {
  paddingTop: 0
}));
const List$1 = /*#__PURE__*/React$1k.forwardRef(function List(inProps, ref) {
  const props = (0, _DefaultPropsProvider$P.useDefaultProps)({
    props: inProps,
    name: 'MuiList'
  });
  const {
      children,
      className,
      component = 'ul',
      dense = false,
      disablePadding = false,
      subheader
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$_.default)(props, _excluded$1s);
  const context = React$1k.useMemo(() => ({
    dense
  }), [dense]);
  const ownerState = (0, _extends2$11.default)({}, props, {
    component,
    dense,
    disablePadding
  });
  const classes = useUtilityClasses$R(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1e.jsx)(_ListContext$7.default.Provider, {
    value: context,
    children: /*#__PURE__*/(0, _jsxRuntime$1e.jsxs)(ListRoot, (0, _extends2$11.default)({
      as: component,
      className: (0, _clsx$1q.default)(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [subheader, children]
    }))
  });
});
process.env.NODE_ENV !== "production" ? List$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$1p.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1p.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1p.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1p.default.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: _propTypes$1p.default.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: _propTypes$1p.default.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes$1p.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1p.default.oneOfType([_propTypes$1p.default.arrayOf(_propTypes$1p.default.oneOfType([_propTypes$1p.default.func, _propTypes$1p.default.object, _propTypes$1p.default.bool])), _propTypes$1p.default.func, _propTypes$1p.default.object])
} : void 0;
List$2.default = List$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  listClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _List.default;
  }
});
Object.defineProperty(exports, "listClasses", {
  enumerable: true,
  get: function () {
    return _listClasses.default;
  }
});
var _List = _interopRequireDefault(List$2);
var _listClasses = _interopRequireWildcard(listClasses$1);
Object.keys(_listClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _listClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _listClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(List$3));

var ListItem$3 = {};

var ListItem$2 = {};

var listItemClasses$1 = {};

var _interopRequireDefault$5u = interopRequireDefault$1.exports;
Object.defineProperty(listItemClasses$1, "__esModule", {
  value: true
});
listItemClasses$1.default = void 0;
listItemClasses$1.getListItemUtilityClass = getListItemUtilityClass;
var _generateUtilityClasses$N = _interopRequireDefault$5u(generateUtilityClasses$3);
var _generateUtilityClass$N = _interopRequireDefault$5u(generateUtilityClass$3);
function getListItemUtilityClass(slot) {
  return (0, _generateUtilityClass$N.default)('MuiListItem', slot);
}
const listItemClasses = (0, _generateUtilityClasses$N.default)('MuiListItem', ['root', 'container', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'padding', 'button', 'secondaryAction', 'selected']);
listItemClasses$1.default = listItemClasses;

var ListItemButton$2 = {};

var ListItemButton$1 = {};

var listItemButtonClasses$1 = {};

var _interopRequireDefault$5t = interopRequireDefault$1.exports;
Object.defineProperty(listItemButtonClasses$1, "__esModule", {
  value: true
});
listItemButtonClasses$1.default = void 0;
listItemButtonClasses$1.getListItemButtonUtilityClass = getListItemButtonUtilityClass;
var _generateUtilityClasses$M = _interopRequireDefault$5t(generateUtilityClasses$3);
var _generateUtilityClass$M = _interopRequireDefault$5t(generateUtilityClass$3);
function getListItemButtonUtilityClass(slot) {
  return (0, _generateUtilityClass$M.default)('MuiListItemButton', slot);
}
const listItemButtonClasses = (0, _generateUtilityClasses$M.default)('MuiListItemButton', ['root', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'selected']);
listItemButtonClasses$1.default = listItemButtonClasses;

var _interopRequireDefault$5s = interopRequireDefault$1.exports;
Object.defineProperty(ListItemButton$1, "__esModule", {
  value: true
});
ListItemButton$1.overridesResolver = ListItemButton$1.default = void 0;
var _objectWithoutPropertiesLoose2$Z = _interopRequireDefault$5s(objectWithoutPropertiesLoose.exports);
var _extends2$10 = _interopRequireDefault$5s(_extends$19.exports);
var React$1j = _interopRequireWildcard$2p(React__default$4);
var _propTypes$1o = _interopRequireDefault$5s(propTypes.exports);
var _clsx$1p = _interopRequireDefault$5s(clsx.exports);
var _composeClasses$P = _interopRequireDefault$5s(composeClasses$2);
var _colorManipulator$b = colorManipulator;
var _styled$N = _interopRequireWildcard$2p(styled$2);
var _DefaultPropsProvider$O = DefaultPropsProvider$5;
var _ButtonBase$8 = _interopRequireDefault$5s(ButtonBase$2);
var _useEnhancedEffect$4 = _interopRequireDefault$5s(useEnhancedEffect);
var _useForkRef$b = _interopRequireDefault$5s(useForkRef);
var _ListContext$6 = _interopRequireDefault$5s(ListContext$1);
var _listItemButtonClasses = _interopRequireWildcard$2p(listItemButtonClasses$1);
var _jsxRuntime$1d = require$$11;
const _excluded$1r = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected", "className"];
function _getRequireWildcardCache$28(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$28 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2p(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$28(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const overridesResolver$3 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};
ListItemButton$1.overridesResolver = overridesResolver$3;
const useUtilityClasses$Q = ownerState => {
  const {
    alignItems,
    classes,
    dense,
    disabled,
    disableGutters,
    divider,
    selected
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', divider && 'divider', disabled && 'disabled', alignItems === 'flex-start' && 'alignItemsFlexStart', selected && 'selected']
  };
  const composedClasses = (0, _composeClasses$P.default)(slots, _listItemButtonClasses.getListItemButtonUtilityClass, classes);
  return (0, _extends2$10.default)({}, classes, composedClasses);
};
const ListItemButtonRoot = (0, _styled$N.default)(_ButtonBase$8.default, {
  shouldForwardProp: prop => (0, _styled$N.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiListItemButton',
  slot: 'Root',
  overridesResolver: overridesResolver$3
})(({
  theme,
  ownerState
}) => (0, _extends2$10.default)({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  minWidth: 0,
  boxSizing: 'border-box',
  textAlign: 'left',
  paddingTop: 8,
  paddingBottom: 8,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${_listItemButtonClasses.default.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator$b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${_listItemButtonClasses.default.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator$b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${_listItemButtonClasses.default.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator$b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator$b.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${_listItemButtonClasses.default.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${_listItemButtonClasses.default.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, ownerState.alignItems === 'flex-start' && {
  alignItems: 'flex-start'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.dense && {
  paddingTop: 4,
  paddingBottom: 4
}));
const ListItemButton = /*#__PURE__*/React$1j.forwardRef(function ListItemButton(inProps, ref) {
  const props = (0, _DefaultPropsProvider$O.useDefaultProps)({
    props: inProps,
    name: 'MuiListItemButton'
  });
  const {
      alignItems = 'center',
      autoFocus = false,
      component = 'div',
      children,
      dense = false,
      disableGutters = false,
      divider = false,
      focusVisibleClassName,
      selected = false,
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$Z.default)(props, _excluded$1r);
  const context = React$1j.useContext(_ListContext$6.default);
  const childContext = React$1j.useMemo(() => ({
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  }), [alignItems, context.dense, dense, disableGutters]);
  const listItemRef = React$1j.useRef(null);
  (0, _useEnhancedEffect$4.default)(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('MUI: Unable to set focus to a ListItemButton whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  const ownerState = (0, _extends2$10.default)({}, props, {
    alignItems,
    dense: childContext.dense,
    disableGutters,
    divider,
    selected
  });
  const classes = useUtilityClasses$Q(ownerState);
  const handleRef = (0, _useForkRef$b.default)(listItemRef, ref);
  return /*#__PURE__*/(0, _jsxRuntime$1d.jsx)(_ListContext$6.default.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0, _jsxRuntime$1d.jsx)(ListItemButtonRoot, (0, _extends2$10.default)({
      ref: handleRef,
      href: other.href || other.to
      // `ButtonBase` processes `href` or `to` if `component` is set to 'button'
      ,
      component: (other.href || other.to) && component === 'div' ? 'button' : component,
      focusVisibleClassName: (0, _clsx$1p.default)(classes.focusVisible, focusVisibleClassName),
      ownerState: ownerState,
      className: (0, _clsx$1p.default)(classes.root, className)
    }, other, {
      classes: classes,
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? ListItemButton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: _propTypes$1o.default.oneOf(['center', 'flex-start']),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: _propTypes$1o.default.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: _propTypes$1o.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1o.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1o.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1o.default.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: _propTypes$1o.default.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$1o.default.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: _propTypes$1o.default.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: _propTypes$1o.default.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: _propTypes$1o.default.string,
  /**
   * @ignore
   */
  href: _propTypes$1o.default.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: _propTypes$1o.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1o.default.oneOfType([_propTypes$1o.default.arrayOf(_propTypes$1o.default.oneOfType([_propTypes$1o.default.func, _propTypes$1o.default.object, _propTypes$1o.default.bool])), _propTypes$1o.default.func, _propTypes$1o.default.object])
} : void 0;
ListItemButton$1.default = ListItemButton;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  listItemButtonClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ListItemButton.default;
  }
});
Object.defineProperty(exports, "listItemButtonClasses", {
  enumerable: true,
  get: function () {
    return _listItemButtonClasses.default;
  }
});
var _ListItemButton = _interopRequireDefault(ListItemButton$1);
var _listItemButtonClasses = _interopRequireWildcard(listItemButtonClasses$1);
Object.keys(_listItemButtonClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _listItemButtonClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _listItemButtonClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ListItemButton$2));

var ListItemSecondaryAction$2 = {};

var ListItemSecondaryAction$1 = {};

var listItemSecondaryActionClasses$1 = {};

var _interopRequireDefault$5r = interopRequireDefault$1.exports;
Object.defineProperty(listItemSecondaryActionClasses$1, "__esModule", {
  value: true
});
listItemSecondaryActionClasses$1.default = void 0;
listItemSecondaryActionClasses$1.getListItemSecondaryActionClassesUtilityClass = getListItemSecondaryActionClassesUtilityClass;
var _generateUtilityClasses$L = _interopRequireDefault$5r(generateUtilityClasses$3);
var _generateUtilityClass$L = _interopRequireDefault$5r(generateUtilityClass$3);
function getListItemSecondaryActionClassesUtilityClass(slot) {
  return (0, _generateUtilityClass$L.default)('MuiListItemSecondaryAction', slot);
}
const listItemSecondaryActionClasses = (0, _generateUtilityClasses$L.default)('MuiListItemSecondaryAction', ['root', 'disableGutters']);
listItemSecondaryActionClasses$1.default = listItemSecondaryActionClasses;

var _interopRequireDefault$5q = interopRequireDefault$1.exports;
Object.defineProperty(ListItemSecondaryAction$1, "__esModule", {
  value: true
});
ListItemSecondaryAction$1.default = void 0;
var _objectWithoutPropertiesLoose2$Y = _interopRequireDefault$5q(objectWithoutPropertiesLoose.exports);
var _extends2$$ = _interopRequireDefault$5q(_extends$19.exports);
var React$1i = _interopRequireWildcard$2o(React__default$4);
var _propTypes$1n = _interopRequireDefault$5q(propTypes.exports);
var _clsx$1o = _interopRequireDefault$5q(clsx.exports);
var _composeClasses$O = _interopRequireDefault$5q(composeClasses$2);
var _styled$M = _interopRequireDefault$5q(styled$2);
var _DefaultPropsProvider$N = DefaultPropsProvider$5;
var _ListContext$5 = _interopRequireDefault$5q(ListContext$1);
var _listItemSecondaryActionClasses = listItemSecondaryActionClasses$1;
var _jsxRuntime$1c = require$$11;
const _excluded$1q = ["className"];
function _getRequireWildcardCache$27(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$27 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2o(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$27(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$P = ownerState => {
  const {
    disableGutters,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disableGutters && 'disableGutters']
  };
  return (0, _composeClasses$O.default)(slots, _listItemSecondaryActionClasses.getListItemSecondaryActionClassesUtilityClass, classes);
};
const ListItemSecondaryActionRoot = (0, _styled$M.default)('div', {
  name: 'MuiListItemSecondaryAction',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.disableGutters && styles.disableGutters];
  }
})(({
  ownerState
}) => (0, _extends2$$.default)({
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)'
}, ownerState.disableGutters && {
  right: 0
}));

/**
 * Must be used as the last child of ListItem to function properly.
 */
const ListItemSecondaryAction = /*#__PURE__*/React$1i.forwardRef(function ListItemSecondaryAction(inProps, ref) {
  const props = (0, _DefaultPropsProvider$N.useDefaultProps)({
    props: inProps,
    name: 'MuiListItemSecondaryAction'
  });
  const {
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$Y.default)(props, _excluded$1q);
  const context = React$1i.useContext(_ListContext$5.default);
  const ownerState = (0, _extends2$$.default)({}, props, {
    disableGutters: context.disableGutters
  });
  const classes = useUtilityClasses$P(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1c.jsx)(ListItemSecondaryActionRoot, (0, _extends2$$.default)({
    className: (0, _clsx$1o.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListItemSecondaryAction.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: _propTypes$1n.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1n.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1n.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1n.default.oneOfType([_propTypes$1n.default.arrayOf(_propTypes$1n.default.oneOfType([_propTypes$1n.default.func, _propTypes$1n.default.object, _propTypes$1n.default.bool])), _propTypes$1n.default.func, _propTypes$1n.default.object])
} : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
ListItemSecondaryAction$1.default = ListItemSecondaryAction;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  listItemSecondaryActionClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ListItemSecondaryAction.default;
  }
});
Object.defineProperty(exports, "listItemSecondaryActionClasses", {
  enumerable: true,
  get: function () {
    return _listItemSecondaryActionClasses.default;
  }
});
var _ListItemSecondaryAction = _interopRequireDefault(ListItemSecondaryAction$1);
var _listItemSecondaryActionClasses = _interopRequireWildcard(listItemSecondaryActionClasses$1);
Object.keys(_listItemSecondaryActionClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _listItemSecondaryActionClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _listItemSecondaryActionClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ListItemSecondaryAction$2));

var _interopRequireDefault$5p = interopRequireDefault$1.exports;
Object.defineProperty(ListItem$2, "__esModule", {
  value: true
});
ListItem$2.overridesResolver = ListItem$2.default = ListItem$2.ListItemRoot = void 0;
var _objectWithoutPropertiesLoose2$X = _interopRequireDefault$5p(objectWithoutPropertiesLoose.exports);
var _extends2$_ = _interopRequireDefault$5p(_extends$19.exports);
var React$1h = _interopRequireWildcard$2n(React__default$4);
var _propTypes$1m = _interopRequireDefault$5p(propTypes.exports);
var _clsx$1n = _interopRequireDefault$5p(clsx.exports);
var _composeClasses$N = _interopRequireDefault$5p(composeClasses$2);
var _elementTypeAcceptingRef$2 = _interopRequireDefault$5p(elementTypeAcceptingRef$2);
var _chainPropTypes$4 = _interopRequireDefault$5p(chainPropTypes$2);
var _colorManipulator$a = colorManipulator;
var _isHostComponent$4 = _interopRequireDefault$5p(isHostComponent$2);
var _styled$L = _interopRequireDefault$5p(styled$2);
var _DefaultPropsProvider$M = DefaultPropsProvider$5;
var _ButtonBase$7 = _interopRequireDefault$5p(ButtonBase$2);
var _isMuiElement$2 = _interopRequireDefault$5p(isMuiElement);
var _useEnhancedEffect$3 = _interopRequireDefault$5p(useEnhancedEffect);
var _useForkRef$a = _interopRequireDefault$5p(useForkRef);
var _ListContext$4 = _interopRequireDefault$5p(ListContext$1);
var _listItemClasses = _interopRequireWildcard$2n(listItemClasses$1);
var _ListItemButton = ListItemButton$2;
var _ListItemSecondaryAction = _interopRequireDefault$5p(ListItemSecondaryAction$2);
var _jsxRuntime$1b = require$$11;
const _excluded$1p = ["className"],
  _excluded2$k = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"];
function _getRequireWildcardCache$26(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$26 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2n(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$26(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const overridesResolver$2 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters, !ownerState.disablePadding && styles.padding, ownerState.button && styles.button, ownerState.hasSecondaryAction && styles.secondaryAction];
};
ListItem$2.overridesResolver = overridesResolver$2;
const useUtilityClasses$O = ownerState => {
  const {
    alignItems,
    button,
    classes,
    dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', !disablePadding && 'padding', divider && 'divider', disabled && 'disabled', button && 'button', alignItems === 'flex-start' && 'alignItemsFlexStart', hasSecondaryAction && 'secondaryAction', selected && 'selected'],
    container: ['container']
  };
  return (0, _composeClasses$N.default)(slots, _listItemClasses.getListItemUtilityClass, classes);
};
const ListItemRoot = ListItem$2.ListItemRoot = (0, _styled$L.default)('div', {
  name: 'MuiListItem',
  slot: 'Root',
  overridesResolver: overridesResolver$2
})(({
  theme,
  ownerState
}) => (0, _extends2$_.default)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  width: '100%',
  boxSizing: 'border-box',
  textAlign: 'left'
}, !ownerState.disablePadding && (0, _extends2$_.default)({
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!ownerState.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!ownerState.secondaryAction && {
  [`& > .${_ListItemButton.listItemButtonClasses.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${_listItemClasses.default.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${_listItemClasses.default.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator$a.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${_listItemClasses.default.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator$a.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${_listItemClasses.default.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }
}, ownerState.alignItems === 'flex-start' && {
  alignItems: 'flex-start'
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, ownerState.button && {
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${_listItemClasses.default.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator$a.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator$a.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  }
}, ownerState.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}));
const ListItemContainer = (0, _styled$L.default)('li', {
  name: 'MuiListItem',
  slot: 'Container',
  overridesResolver: (props, styles) => styles.container
})({
  position: 'relative'
});

/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */
const ListItem$1 = /*#__PURE__*/React$1h.forwardRef(function ListItem(inProps, ref) {
  const props = (0, _DefaultPropsProvider$M.useDefaultProps)({
    props: inProps,
    name: 'MuiListItem'
  });
  const {
      alignItems = 'center',
      autoFocus = false,
      button = false,
      children: childrenProp,
      className,
      component: componentProp,
      components = {},
      componentsProps = {},
      ContainerComponent = 'li',
      ContainerProps: {
        className: ContainerClassName
      } = {},
      dense = false,
      disabled = false,
      disableGutters = false,
      disablePadding = false,
      divider = false,
      focusVisibleClassName,
      secondaryAction,
      selected = false,
      slotProps = {},
      slots = {}
    } = props,
    ContainerProps = (0, _objectWithoutPropertiesLoose2$X.default)(props.ContainerProps, _excluded$1p),
    other = (0, _objectWithoutPropertiesLoose2$X.default)(props, _excluded2$k);
  const context = React$1h.useContext(_ListContext$4.default);
  const childContext = React$1h.useMemo(() => ({
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  }), [alignItems, context.dense, dense, disableGutters]);
  const listItemRef = React$1h.useRef(null);
  (0, _useEnhancedEffect$3.default)(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('MUI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  const children = React$1h.Children.toArray(childrenProp);

  // v4 implementation, deprecated in v5, will be removed in v6
  const hasSecondaryAction = children.length && (0, _isMuiElement$2.default)(children[children.length - 1], ['ListItemSecondaryAction']);
  const ownerState = (0, _extends2$_.default)({}, props, {
    alignItems,
    autoFocus,
    button,
    dense: childContext.dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  });
  const classes = useUtilityClasses$O(ownerState);
  const handleRef = (0, _useForkRef$a.default)(listItemRef, ref);
  const Root = slots.root || components.Root || ListItemRoot;
  const rootProps = slotProps.root || componentsProps.root || {};
  const componentProps = (0, _extends2$_.default)({
    className: (0, _clsx$1n.default)(classes.root, rootProps.className, className),
    disabled
  }, other);
  let Component = componentProp || 'li';
  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = (0, _clsx$1n.default)(_listItemClasses.default.focusVisible, focusVisibleClassName);
    Component = _ButtonBase$7.default;
  }

  // v4 implementation, deprecated in v5, will be removed in v6
  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component;

    // Avoid nesting of li > li.
    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }
    return /*#__PURE__*/(0, _jsxRuntime$1b.jsx)(_ListContext$4.default.Provider, {
      value: childContext,
      children: /*#__PURE__*/(0, _jsxRuntime$1b.jsxs)(ListItemContainer, (0, _extends2$_.default)({
        as: ContainerComponent,
        className: (0, _clsx$1n.default)(classes.container, ContainerClassName),
        ref: handleRef,
        ownerState: ownerState
      }, ContainerProps, {
        children: [/*#__PURE__*/(0, _jsxRuntime$1b.jsx)(Root, (0, _extends2$_.default)({}, rootProps, !(0, _isHostComponent$4.default)(Root) && {
          as: Component,
          ownerState: (0, _extends2$_.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
          children: children
        })), children.pop()]
      }))
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime$1b.jsx)(_ListContext$4.default.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0, _jsxRuntime$1b.jsxs)(Root, (0, _extends2$_.default)({}, rootProps, {
      as: Component,
      ref: handleRef
    }, !(0, _isHostComponent$4.default)(Root) && {
      ownerState: (0, _extends2$_.default)({}, ownerState, rootProps.ownerState)
    }, componentProps, {
      children: [children, secondaryAction && /*#__PURE__*/(0, _jsxRuntime$1b.jsx)(_ListItemSecondaryAction.default, {
        children: secondaryAction
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" ? ListItem$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: _propTypes$1m.default.oneOf(['center', 'flex-start']),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: _propTypes$1m.default.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: _propTypes$1m.default.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: (0, _chainPropTypes$4.default)(_propTypes$1m.default.node, props => {
    const children = React$1h.Children.toArray(props.children);

    // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
    let secondaryActionIndex = -1;
    for (let i = children.length - 1; i >= 0; i -= 1) {
      const child = children[i];
      if ((0, _isMuiElement$2.default)(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    }

    //  is ListItemSecondaryAction the last child of ListItem
    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('MUI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }
    return null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1m.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1m.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1m.default.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$1m.default.shape({
    Root: _propTypes$1m.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: _propTypes$1m.default.shape({
    root: _propTypes$1m.default.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: _elementTypeAcceptingRef$2.default,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: _propTypes$1m.default.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: _propTypes$1m.default.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: _propTypes$1m.default.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: _propTypes$1m.default.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: _propTypes$1m.default.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: _propTypes$1m.default.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: _propTypes$1m.default.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: _propTypes$1m.default.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: _propTypes$1m.default.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: _propTypes$1m.default.shape({
    root: _propTypes$1m.default.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: _propTypes$1m.default.shape({
    root: _propTypes$1m.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1m.default.oneOfType([_propTypes$1m.default.arrayOf(_propTypes$1m.default.oneOfType([_propTypes$1m.default.func, _propTypes$1m.default.object, _propTypes$1m.default.bool])), _propTypes$1m.default.func, _propTypes$1m.default.object])
} : void 0;
ListItem$2.default = ListItem$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  listItemClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ListItem.default;
  }
});
Object.defineProperty(exports, "listItemClasses", {
  enumerable: true,
  get: function () {
    return _listItemClasses.default;
  }
});
var _ListItem = _interopRequireDefault(ListItem$2);
var _listItemClasses = _interopRequireWildcard(listItemClasses$1);
Object.keys(_listItemClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _listItemClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _listItemClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ListItem$3));

var ListItemAvatar$2 = {};

var ListItemAvatar$1 = {};

var listItemAvatarClasses$1 = {};

var _interopRequireDefault$5o = interopRequireDefault$1.exports;
Object.defineProperty(listItemAvatarClasses$1, "__esModule", {
  value: true
});
listItemAvatarClasses$1.default = void 0;
listItemAvatarClasses$1.getListItemAvatarUtilityClass = getListItemAvatarUtilityClass;
var _generateUtilityClasses$K = _interopRequireDefault$5o(generateUtilityClasses$3);
var _generateUtilityClass$K = _interopRequireDefault$5o(generateUtilityClass$3);
function getListItemAvatarUtilityClass(slot) {
  return (0, _generateUtilityClass$K.default)('MuiListItemAvatar', slot);
}
const listItemAvatarClasses = (0, _generateUtilityClasses$K.default)('MuiListItemAvatar', ['root', 'alignItemsFlexStart']);
listItemAvatarClasses$1.default = listItemAvatarClasses;

var _interopRequireDefault$5n = interopRequireDefault$1.exports;
Object.defineProperty(ListItemAvatar$1, "__esModule", {
  value: true
});
ListItemAvatar$1.default = void 0;
var _objectWithoutPropertiesLoose2$W = _interopRequireDefault$5n(objectWithoutPropertiesLoose.exports);
var _extends2$Z = _interopRequireDefault$5n(_extends$19.exports);
var React$1g = _interopRequireWildcard$2m(React__default$4);
var _propTypes$1l = _interopRequireDefault$5n(propTypes.exports);
var _clsx$1m = _interopRequireDefault$5n(clsx.exports);
var _composeClasses$M = _interopRequireDefault$5n(composeClasses$2);
var _ListContext$3 = _interopRequireDefault$5n(ListContext$1);
var _styled$K = _interopRequireDefault$5n(styled$2);
var _DefaultPropsProvider$L = DefaultPropsProvider$5;
var _listItemAvatarClasses = listItemAvatarClasses$1;
var _jsxRuntime$1a = require$$11;
const _excluded$1o = ["className"];
function _getRequireWildcardCache$25(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$25 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2m(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$25(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$N = ownerState => {
  const {
    alignItems,
    classes
  } = ownerState;
  const slots = {
    root: ['root', alignItems === 'flex-start' && 'alignItemsFlexStart']
  };
  return (0, _composeClasses$M.default)(slots, _listItemAvatarClasses.getListItemAvatarUtilityClass, classes);
};
const ListItemAvatarRoot = (0, _styled$K.default)('div', {
  name: 'MuiListItemAvatar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart];
  }
})(({
  ownerState
}) => (0, _extends2$Z.default)({
  minWidth: 56,
  flexShrink: 0
}, ownerState.alignItems === 'flex-start' && {
  marginTop: 8
}));

/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */
const ListItemAvatar = /*#__PURE__*/React$1g.forwardRef(function ListItemAvatar(inProps, ref) {
  const props = (0, _DefaultPropsProvider$L.useDefaultProps)({
    props: inProps,
    name: 'MuiListItemAvatar'
  });
  const {
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$W.default)(props, _excluded$1o);
  const context = React$1g.useContext(_ListContext$3.default);
  const ownerState = (0, _extends2$Z.default)({}, props, {
    alignItems: context.alignItems
  });
  const classes = useUtilityClasses$N(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$1a.jsx)(ListItemAvatarRoot, (0, _extends2$Z.default)({
    className: (0, _clsx$1m.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListItemAvatar.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `Avatar`.
   */
  children: _propTypes$1l.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1l.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1l.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1l.default.oneOfType([_propTypes$1l.default.arrayOf(_propTypes$1l.default.oneOfType([_propTypes$1l.default.func, _propTypes$1l.default.object, _propTypes$1l.default.bool])), _propTypes$1l.default.func, _propTypes$1l.default.object])
} : void 0;
ListItemAvatar$1.default = ListItemAvatar;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  listItemAvatarClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ListItemAvatar.default;
  }
});
Object.defineProperty(exports, "listItemAvatarClasses", {
  enumerable: true,
  get: function () {
    return _listItemAvatarClasses.default;
  }
});
var _ListItemAvatar = _interopRequireDefault(ListItemAvatar$1);
var _listItemAvatarClasses = _interopRequireWildcard(listItemAvatarClasses$1);
Object.keys(_listItemAvatarClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _listItemAvatarClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _listItemAvatarClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ListItemAvatar$2));

var ListItemIcon$2 = {};

var ListItemIcon$1 = {};

var listItemIconClasses$1 = {};

var _interopRequireDefault$5m = interopRequireDefault$1.exports;
Object.defineProperty(listItemIconClasses$1, "__esModule", {
  value: true
});
listItemIconClasses$1.default = void 0;
listItemIconClasses$1.getListItemIconUtilityClass = getListItemIconUtilityClass;
var _generateUtilityClasses$J = _interopRequireDefault$5m(generateUtilityClasses$3);
var _generateUtilityClass$J = _interopRequireDefault$5m(generateUtilityClass$3);
function getListItemIconUtilityClass(slot) {
  return (0, _generateUtilityClass$J.default)('MuiListItemIcon', slot);
}
const listItemIconClasses = (0, _generateUtilityClasses$J.default)('MuiListItemIcon', ['root', 'alignItemsFlexStart']);
listItemIconClasses$1.default = listItemIconClasses;

var _interopRequireDefault$5l = interopRequireDefault$1.exports;
Object.defineProperty(ListItemIcon$1, "__esModule", {
  value: true
});
ListItemIcon$1.default = void 0;
var _objectWithoutPropertiesLoose2$V = _interopRequireDefault$5l(objectWithoutPropertiesLoose.exports);
var _extends2$Y = _interopRequireDefault$5l(_extends$19.exports);
var React$1f = _interopRequireWildcard$2l(React__default$4);
var _propTypes$1k = _interopRequireDefault$5l(propTypes.exports);
var _clsx$1l = _interopRequireDefault$5l(clsx.exports);
var _composeClasses$L = _interopRequireDefault$5l(composeClasses$2);
var _styled$J = _interopRequireDefault$5l(styled$2);
var _DefaultPropsProvider$K = DefaultPropsProvider$5;
var _listItemIconClasses = listItemIconClasses$1;
var _ListContext$2 = _interopRequireDefault$5l(ListContext$1);
var _jsxRuntime$19 = require$$11;
const _excluded$1n = ["className"];
function _getRequireWildcardCache$24(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$24 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2l(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$24(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$M = ownerState => {
  const {
    alignItems,
    classes
  } = ownerState;
  const slots = {
    root: ['root', alignItems === 'flex-start' && 'alignItemsFlexStart']
  };
  return (0, _composeClasses$L.default)(slots, _listItemIconClasses.getListItemIconUtilityClass, classes);
};
const ListItemIconRoot = (0, _styled$J.default)('div', {
  name: 'MuiListItemIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$Y.default)({
  minWidth: 56,
  color: (theme.vars || theme).palette.action.active,
  flexShrink: 0,
  display: 'inline-flex'
}, ownerState.alignItems === 'flex-start' && {
  marginTop: 8
}));

/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */
const ListItemIcon = /*#__PURE__*/React$1f.forwardRef(function ListItemIcon(inProps, ref) {
  const props = (0, _DefaultPropsProvider$K.useDefaultProps)({
    props: inProps,
    name: 'MuiListItemIcon'
  });
  const {
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$V.default)(props, _excluded$1n);
  const context = React$1f.useContext(_ListContext$2.default);
  const ownerState = (0, _extends2$Y.default)({}, props, {
    alignItems: context.alignItems
  });
  const classes = useUtilityClasses$M(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$19.jsx)(ListItemIconRoot, (0, _extends2$Y.default)({
    className: (0, _clsx$1l.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? ListItemIcon.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: _propTypes$1k.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1k.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1k.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1k.default.oneOfType([_propTypes$1k.default.arrayOf(_propTypes$1k.default.oneOfType([_propTypes$1k.default.func, _propTypes$1k.default.object, _propTypes$1k.default.bool])), _propTypes$1k.default.func, _propTypes$1k.default.object])
} : void 0;
ListItemIcon$1.default = ListItemIcon;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  listItemIconClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ListItemIcon.default;
  }
});
Object.defineProperty(exports, "listItemIconClasses", {
  enumerable: true,
  get: function () {
    return _listItemIconClasses.default;
  }
});
var _ListItemIcon = _interopRequireDefault(ListItemIcon$1);
var _listItemIconClasses = _interopRequireWildcard(listItemIconClasses$1);
Object.keys(_listItemIconClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _listItemIconClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _listItemIconClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ListItemIcon$2));

var ListItemText$2 = {};

var ListItemText$1 = {};

var listItemTextClasses$1 = {};

var _interopRequireDefault$5k = interopRequireDefault$1.exports;
Object.defineProperty(listItemTextClasses$1, "__esModule", {
  value: true
});
listItemTextClasses$1.default = void 0;
listItemTextClasses$1.getListItemTextUtilityClass = getListItemTextUtilityClass;
var _generateUtilityClasses$I = _interopRequireDefault$5k(generateUtilityClasses$3);
var _generateUtilityClass$I = _interopRequireDefault$5k(generateUtilityClass$3);
function getListItemTextUtilityClass(slot) {
  return (0, _generateUtilityClass$I.default)('MuiListItemText', slot);
}
const listItemTextClasses = (0, _generateUtilityClasses$I.default)('MuiListItemText', ['root', 'multiline', 'dense', 'inset', 'primary', 'secondary']);
listItemTextClasses$1.default = listItemTextClasses;

var _interopRequireDefault$5j = interopRequireDefault$1.exports;
Object.defineProperty(ListItemText$1, "__esModule", {
  value: true
});
ListItemText$1.default = void 0;
var _objectWithoutPropertiesLoose2$U = _interopRequireDefault$5j(objectWithoutPropertiesLoose.exports);
var _extends2$X = _interopRequireDefault$5j(_extends$19.exports);
var React$1e = _interopRequireWildcard$2k(React__default$4);
var _propTypes$1j = _interopRequireDefault$5j(propTypes.exports);
var _clsx$1k = _interopRequireDefault$5j(clsx.exports);
var _composeClasses$K = _interopRequireDefault$5j(composeClasses$2);
var _Typography = _interopRequireDefault$5j(Typography$3);
var _ListContext$1 = _interopRequireDefault$5j(ListContext$1);
var _DefaultPropsProvider$J = DefaultPropsProvider$5;
var _styled$I = _interopRequireDefault$5j(styled$2);
var _listItemTextClasses = _interopRequireWildcard$2k(listItemTextClasses$1);
var _jsxRuntime$18 = require$$11;
const _excluded$1m = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"];
function _getRequireWildcardCache$23(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$23 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2k(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$23(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$L = ownerState => {
  const {
    classes,
    inset,
    primary,
    secondary,
    dense
  } = ownerState;
  const slots = {
    root: ['root', inset && 'inset', dense && 'dense', primary && secondary && 'multiline'],
    primary: ['primary'],
    secondary: ['secondary']
  };
  return (0, _composeClasses$K.default)(slots, _listItemTextClasses.getListItemTextUtilityClass, classes);
};
const ListItemTextRoot = (0, _styled$I.default)('div', {
  name: 'MuiListItemText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_listItemTextClasses.default.primary}`]: styles.primary
    }, {
      [`& .${_listItemTextClasses.default.secondary}`]: styles.secondary
    }, styles.root, ownerState.inset && styles.inset, ownerState.primary && ownerState.secondary && styles.multiline, ownerState.dense && styles.dense];
  }
})(({
  ownerState
}) => (0, _extends2$X.default)({
  flex: '1 1 auto',
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, ownerState.primary && ownerState.secondary && {
  marginTop: 6,
  marginBottom: 6
}, ownerState.inset && {
  paddingLeft: 56
}));
const ListItemText = /*#__PURE__*/React$1e.forwardRef(function ListItemText(inProps, ref) {
  const props = (0, _DefaultPropsProvider$J.useDefaultProps)({
    props: inProps,
    name: 'MuiListItemText'
  });
  const {
      children,
      className,
      disableTypography = false,
      inset = false,
      primary: primaryProp,
      primaryTypographyProps,
      secondary: secondaryProp,
      secondaryTypographyProps
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$U.default)(props, _excluded$1m);
  const {
    dense
  } = React$1e.useContext(_ListContext$1.default);
  let primary = primaryProp != null ? primaryProp : children;
  let secondary = secondaryProp;
  const ownerState = (0, _extends2$X.default)({}, props, {
    disableTypography,
    inset,
    primary: !!primary,
    secondary: !!secondary,
    dense
  });
  const classes = useUtilityClasses$L(ownerState);
  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
    primary = /*#__PURE__*/(0, _jsxRuntime$18.jsx)(_Typography.default, (0, _extends2$X.default)({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
      display: "block"
    }, primaryTypographyProps, {
      children: primary
    }));
  }
  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
    secondary = /*#__PURE__*/(0, _jsxRuntime$18.jsx)(_Typography.default, (0, _extends2$X.default)({
      variant: "body2",
      className: classes.secondary,
      color: "text.secondary",
      display: "block"
    }, secondaryTypographyProps, {
      children: secondary
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime$18.jsxs)(ListItemTextRoot, (0, _extends2$X.default)({
    className: (0, _clsx$1k.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [primary, secondary]
  }));
});
process.env.NODE_ENV !== "production" ? ListItemText.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: _propTypes$1j.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1j.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1j.default.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: _propTypes$1j.default.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: _propTypes$1j.default.bool,
  /**
   * The main content element.
   */
  primary: _propTypes$1j.default.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: _propTypes$1j.default.object,
  /**
   * The secondary content element.
   */
  secondary: _propTypes$1j.default.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: _propTypes$1j.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1j.default.oneOfType([_propTypes$1j.default.arrayOf(_propTypes$1j.default.oneOfType([_propTypes$1j.default.func, _propTypes$1j.default.object, _propTypes$1j.default.bool])), _propTypes$1j.default.func, _propTypes$1j.default.object])
} : void 0;
ListItemText$1.default = ListItemText;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  listItemTextClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ListItemText.default;
  }
});
Object.defineProperty(exports, "listItemTextClasses", {
  enumerable: true,
  get: function () {
    return _listItemTextClasses.default;
  }
});
var _ListItemText = _interopRequireDefault(ListItemText$1);
var _listItemTextClasses = _interopRequireWildcard(listItemTextClasses$1);
Object.keys(_listItemTextClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _listItemTextClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _listItemTextClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ListItemText$2));

var Menu$2 = {};

var Menu$1 = {};

var MenuList$2 = {};

var MenuList$1 = {};

var getScrollbarSize = {};

var _interopRequireDefault$5i = interopRequireDefault$1.exports;
Object.defineProperty(getScrollbarSize, "__esModule", {
  value: true
});
getScrollbarSize.default = void 0;
var _getScrollbarSize$1 = _interopRequireDefault$5i(getScrollbarSize$3);
getScrollbarSize.default = _getScrollbarSize$1.default;

var _interopRequireDefault$5h = interopRequireDefault$1.exports;
Object.defineProperty(MenuList$1, "__esModule", {
  value: true
});
MenuList$1.default = void 0;
var _extends2$W = _interopRequireDefault$5h(_extends$19.exports);
var _objectWithoutPropertiesLoose2$T = _interopRequireDefault$5h(objectWithoutPropertiesLoose.exports);
var React$1d = _interopRequireWildcard$2j(React__default$4);
var _reactIs$6 = reactIs$6.exports;
var _propTypes$1i = _interopRequireDefault$5h(propTypes.exports);
var _ownerDocument$4 = _interopRequireDefault$5h(ownerDocument);
var _List = _interopRequireDefault$5h(List$3);
var _getScrollbarSize = _interopRequireDefault$5h(getScrollbarSize);
var _useForkRef$9 = _interopRequireDefault$5h(useForkRef);
var _useEnhancedEffect$2 = _interopRequireDefault$5h(useEnhancedEffect);
var _jsxRuntime$17 = require$$11;
const _excluded$1l = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function _getRequireWildcardCache$22(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$22 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2j(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$22(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function nextItem$1(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }
  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }
  return disableListWrap ? null : list.firstChild;
}
function previousItem$1(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }
  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }
  return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }
  let text = nextFocus.innerText;
  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }
  text = text.trim().toLowerCase();
  if (text.length === 0) {
    return false;
  }
  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }
  return text.indexOf(textCriteria.keys.join('')) === 0;
}
function moveFocus$1(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }
      wrappedOnce = true;
    }

    // Same logic as useAutocomplete.js
    const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return true;
    }
  }
  return false;
}

/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */
const MenuList = /*#__PURE__*/React$1d.forwardRef(function MenuList(props, ref) {
  const {
      // private
      // eslint-disable-next-line react/prop-types
      actions,
      autoFocus = false,
      autoFocusItem = false,
      children,
      className,
      disabledItemsFocusable = false,
      disableListWrap = false,
      onKeyDown,
      variant = 'selectedMenu'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$T.default)(props, _excluded$1l);
  const listRef = React$1d.useRef(null);
  const textCriteriaRef = React$1d.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  (0, _useEnhancedEffect$2.default)(() => {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  React$1d.useImperativeHandle(actions, () => ({
    adjustStyleForScrollbar: (containerElement, {
      direction
    }) => {
      // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.
      const noExplicitWidth = !listRef.current.style.width;
      if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
        const scrollbarSize = `${(0, _getScrollbarSize.default)((0, _ownerDocument$4.default)(containerElement))}px`;
        listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
        listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
      }
      return listRef.current;
    }
  }), []);
  const handleKeyDown = event => {
    const list = listRef.current;
    const key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */
    const currentFocus = (0, _ownerDocument$4.default)(list).activeElement;
    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus$1(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem$1);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus$1(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem$1);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus$1(list, null, disableListWrap, disabledItemsFocusable, nextItem$1);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus$1(list, null, disableListWrap, disabledItemsFocusable, previousItem$1);
    } else if (key.length === 1) {
      const criteria = textCriteriaRef.current;
      const lowerKey = key.toLowerCase();
      const currTime = performance.now();
      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }
      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus$1(list, currentFocus, false, disabledItemsFocusable, nextItem$1, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  const handleRef = (0, _useForkRef$9.default)(listRef, ref);

  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */
  let activeItemIndex = -1;
  // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback
  React$1d.Children.forEach(children, (child, index) => {
    if (! /*#__PURE__*/React$1d.isValidElement(child)) {
      if (activeItemIndex === index) {
        activeItemIndex += 1;
        if (activeItemIndex >= children.length) {
          // there are no focusable items within the list.
          activeItemIndex = -1;
        }
      }
      return;
    }
    if (process.env.NODE_ENV !== 'production') {
      if ((0, _reactIs$6.isFragment)(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
    if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
      activeItemIndex += 1;
      if (activeItemIndex >= children.length) {
        // there are no focusable items within the list.
        activeItemIndex = -1;
      }
    }
  });
  const items = React$1d.Children.map(children, (child, index) => {
    if (index === activeItemIndex) {
      const newChildProps = {};
      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }
      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }
      return /*#__PURE__*/React$1d.cloneElement(child, newChildProps);
    }
    return child;
  });
  return /*#__PURE__*/(0, _jsxRuntime$17.jsx)(_List.default, (0, _extends2$W.default)({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other, {
    children: items
  }));
});
process.env.NODE_ENV !== "production" ? MenuList.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: _propTypes$1i.default.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: _propTypes$1i.default.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: _propTypes$1i.default.node,
  /**
   * @ignore
   */
  className: _propTypes$1i.default.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: _propTypes$1i.default.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: _propTypes$1i.default.bool,
  /**
   * @ignore
   */
  onKeyDown: _propTypes$1i.default.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: _propTypes$1i.default.oneOf(['menu', 'selectedMenu'])
} : void 0;
MenuList$1.default = MenuList;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _MenuList.default;
  }
});
var _MenuList = _interopRequireDefault(MenuList$1);
}(MenuList$2));

var Popover$2 = {};

var Popover$1 = {};

var popoverClasses$1 = {};

var _interopRequireDefault$5g = interopRequireDefault$1.exports;
Object.defineProperty(popoverClasses$1, "__esModule", {
  value: true
});
popoverClasses$1.default = void 0;
popoverClasses$1.getPopoverUtilityClass = getPopoverUtilityClass;
var _generateUtilityClasses$H = _interopRequireDefault$5g(generateUtilityClasses$3);
var _generateUtilityClass$H = _interopRequireDefault$5g(generateUtilityClass$3);
function getPopoverUtilityClass(slot) {
  return (0, _generateUtilityClass$H.default)('MuiPopover', slot);
}
const popoverClasses = (0, _generateUtilityClasses$H.default)('MuiPopover', ['root', 'paper']);
popoverClasses$1.default = popoverClasses;

var _interopRequireDefault$5f = interopRequireDefault$1.exports;
Object.defineProperty(Popover$1, "__esModule", {
  value: true
});
Popover$1.default = Popover$1.PopoverRoot = Popover$1.PopoverPaper = void 0;
Popover$1.getOffsetLeft = getOffsetLeft;
Popover$1.getOffsetTop = getOffsetTop;
var _extends2$V = _interopRequireDefault$5f(_extends$19.exports);
var _objectWithoutPropertiesLoose2$S = _interopRequireDefault$5f(objectWithoutPropertiesLoose.exports);
var React$1c = _interopRequireWildcard$2i(React__default$4);
var _propTypes$1h = _interopRequireDefault$5f(propTypes.exports);
var _clsx$1j = _interopRequireDefault$5f(clsx.exports);
var _composeClasses$J = _interopRequireDefault$5f(composeClasses$2);
var _HTMLElementType$1 = _interopRequireDefault$5f(HTMLElementType$2);
var _refType$7 = _interopRequireDefault$5f(refType$2);
var _elementTypeAcceptingRef$1 = _interopRequireDefault$5f(elementTypeAcceptingRef$2);
var _integerPropType$5 = _interopRequireDefault$5f(integerPropType$1);
var _chainPropTypes$3 = _interopRequireDefault$5f(chainPropTypes$2);
var _useSlotProps2 = _interopRequireDefault$5f(useSlotProps$2);
var _isHostComponent$3 = _interopRequireDefault$5f(isHostComponent$2);
var _styled$H = _interopRequireDefault$5f(styled$2);
var _DefaultPropsProvider$I = DefaultPropsProvider$5;
var _debounce$3 = _interopRequireDefault$5f(debounce$3);
var _ownerDocument$3 = _interopRequireDefault$5f(ownerDocument);
var _ownerWindow$2 = _interopRequireDefault$5f(ownerWindow);
var _useForkRef$8 = _interopRequireDefault$5f(useForkRef);
var _Grow$2 = _interopRequireDefault$5f(Grow$2);
var _Modal = _interopRequireDefault$5f(Modal$2);
var _Paper$2 = _interopRequireDefault$5f(Paper$3);
var _popoverClasses = popoverClasses$1;
var _jsxRuntime$16 = require$$11;
const _excluded$1k = ["onEntering"],
  _excluded2$j = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"],
  _excluded3$2 = ["slotProps"];
function _getRequireWildcardCache$21(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$21 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2i(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$21(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getOffsetTop(rect, vertical) {
  let offset = 0;
  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }
  return offset;
}
function getOffsetLeft(rect, horizontal) {
  let offset = 0;
  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }
  return offset;
}
function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(n => typeof n === 'number' ? `${n}px` : n).join(' ');
}
function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const useUtilityClasses$K = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper']
  };
  return (0, _composeClasses$J.default)(slots, _popoverClasses.getPopoverUtilityClass, classes);
};
const PopoverRoot = Popover$1.PopoverRoot = (0, _styled$H.default)(_Modal.default, {
  name: 'MuiPopover',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const PopoverPaper = Popover$1.PopoverPaper = (0, _styled$H.default)(_Paper$2.default, {
  name: 'MuiPopover',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  position: 'absolute',
  overflowY: 'auto',
  overflowX: 'hidden',
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: 'calc(100% - 32px)',
  maxHeight: 'calc(100% - 32px)',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Popover = /*#__PURE__*/React$1c.forwardRef(function Popover(inProps, ref) {
  var _slotProps$paper, _slots$root, _slots$paper;
  const props = (0, _DefaultPropsProvider$I.useDefaultProps)({
    props: inProps,
    name: 'MuiPopover'
  });
  const {
      action,
      anchorEl,
      anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
      },
      anchorPosition,
      anchorReference = 'anchorEl',
      children,
      className,
      container: containerProp,
      elevation = 8,
      marginThreshold = 16,
      open,
      PaperProps: PaperPropsProp = {},
      slots,
      slotProps,
      transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
      },
      TransitionComponent = _Grow$2.default,
      transitionDuration: transitionDurationProp = 'auto',
      TransitionProps: {
        onEntering
      } = {},
      disableScrollLock = false
    } = props,
    TransitionProps = (0, _objectWithoutPropertiesLoose2$S.default)(props.TransitionProps, _excluded$1k),
    other = (0, _objectWithoutPropertiesLoose2$S.default)(props, _excluded2$j);
  const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
  const paperRef = React$1c.useRef();
  const handlePaperRef = (0, _useForkRef$8.default)(paperRef, externalPaperSlotProps.ref);
  const ownerState = (0, _extends2$V.default)({}, props, {
    anchorOrigin,
    anchorReference,
    elevation,
    marginThreshold,
    externalPaperSlotProps,
    transformOrigin,
    TransitionComponent,
    transitionDuration: transitionDurationProp,
    TransitionProps
  });
  const classes = useUtilityClasses$K(ownerState);

  // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)
  const getAnchorOffset = React$1c.useCallback(() => {
    if (anchorReference === 'anchorPosition') {
      if (process.env.NODE_ENV !== 'production') {
        if (!anchorPosition) {
          console.error('MUI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }
      return anchorPosition;
    }
    const resolvedAnchorEl = resolveAnchorEl(anchorEl);

    // If an anchor element wasn't provided, just use the parent body element of this Popover
    const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocument$3.default)(paperRef.current).body;
    const anchorRect = anchorElement.getBoundingClientRect();
    if (process.env.NODE_ENV !== 'production') {
      const box = anchorElement.getBoundingClientRect();
      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]);

  // Returns the base transform origin using the element
  const getTransformOrigin = React$1c.useCallback(elemRect => {
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  const getPositioningStyle = React$1c.useCallback(element => {
    const elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };

    // Get the transform origin point on the element itself
    const elemTransformOrigin = getTransformOrigin(elemRect);
    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    }

    // Get the offset of the anchoring element
    const anchorOffset = getAnchorOffset();

    // Calculate element positioning
    let top = anchorOffset.top - elemTransformOrigin.vertical;
    let left = anchorOffset.left - elemTransformOrigin.horizontal;
    const bottom = top + elemRect.height;
    const right = left + elemRect.width;

    // Use the parent window of the anchorEl if provided
    const containerWindow = (0, _ownerWindow$2.default)(resolveAnchorEl(anchorEl));

    // Window thresholds taking required margin into account
    const heightThreshold = containerWindow.innerHeight - marginThreshold;
    const widthThreshold = containerWindow.innerWidth - marginThreshold;

    // Check if the vertical axis needs shifting
    if (marginThreshold !== null && top < marginThreshold) {
      const diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (marginThreshold !== null && bottom > heightThreshold) {
      const diff = bottom - heightThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    }
    if (process.env.NODE_ENV !== 'production') {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['MUI: The popover component is too tall.', `Some part of it can not be seen on the screen (${elemRect.height - heightThreshold}px).`, 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    }

    // Check if the horizontal axis needs shifting
    if (marginThreshold !== null && left < marginThreshold) {
      const diff = left - marginThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    } else if (right > widthThreshold) {
      const diff = right - widthThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    }
    return {
      top: `${Math.round(top)}px`,
      left: `${Math.round(left)}px`,
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
  const [isPositioned, setIsPositioned] = React$1c.useState(open);
  const setPositioningStyles = React$1c.useCallback(() => {
    const element = paperRef.current;
    if (!element) {
      return;
    }
    const positioning = getPositioningStyle(element);
    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }
    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }
    element.style.transformOrigin = positioning.transformOrigin;
    setIsPositioned(true);
  }, [getPositioningStyle]);
  React$1c.useEffect(() => {
    if (disableScrollLock) {
      window.addEventListener('scroll', setPositioningStyles);
    }
    return () => window.removeEventListener('scroll', setPositioningStyles);
  }, [anchorEl, disableScrollLock, setPositioningStyles]);
  const handleEntering = (element, isAppearing) => {
    if (onEntering) {
      onEntering(element, isAppearing);
    }
    setPositioningStyles();
  };
  const handleExited = () => {
    setIsPositioned(false);
  };
  React$1c.useEffect(() => {
    if (open) {
      setPositioningStyles();
    }
  });
  React$1c.useImperativeHandle(action, () => open ? {
    updatePosition: () => {
      setPositioningStyles();
    }
  } : null, [open, setPositioningStyles]);
  React$1c.useEffect(() => {
    if (!open) {
      return undefined;
    }
    const handleResize = (0, _debounce$3.default)(() => {
      setPositioningStyles();
    });
    const containerWindow = (0, _ownerWindow$2.default)(anchorEl);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [anchorEl, open, setPositioningStyles]);
  let transitionDuration = transitionDurationProp;
  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container
  const container = containerProp || (anchorEl ? (0, _ownerDocument$3.default)(resolveAnchorEl(anchorEl)).body : undefined);
  const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : PopoverRoot;
  const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : PopoverPaper;
  const paperProps = (0, _useSlotProps2.default)({
    elementType: PaperSlot,
    externalSlotProps: (0, _extends2$V.default)({}, externalPaperSlotProps, {
      style: isPositioned ? externalPaperSlotProps.style : (0, _extends2$V.default)({}, externalPaperSlotProps.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation,
      ref: handlePaperRef
    },
    ownerState,
    className: (0, _clsx$1j.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
  });
  const _useSlotProps = (0, _useSlotProps2.default)({
      elementType: RootSlot,
      externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
      externalForwardedProps: other,
      additionalProps: {
        ref,
        slotProps: {
          backdrop: {
            invisible: true
          }
        },
        container,
        open
      },
      ownerState,
      className: (0, _clsx$1j.default)(classes.root, className)
    }),
    {
      slotProps: rootSlotPropsProp
    } = _useSlotProps,
    rootProps = (0, _objectWithoutPropertiesLoose2$S.default)(_useSlotProps, _excluded3$2);
  return /*#__PURE__*/(0, _jsxRuntime$16.jsx)(RootSlot, (0, _extends2$V.default)({}, rootProps, !(0, _isHostComponent$3.default)(RootSlot) && {
    slotProps: rootSlotPropsProp,
    disableScrollLock
  }, {
    children: /*#__PURE__*/(0, _jsxRuntime$16.jsx)(TransitionComponent, (0, _extends2$V.default)({
      appear: true,
      in: open,
      onEntering: handleEntering,
      onExited: handleExited,
      timeout: transitionDuration
    }, TransitionProps, {
      children: /*#__PURE__*/(0, _jsxRuntime$16.jsx)(PaperSlot, (0, _extends2$V.default)({}, paperProps, {
        children: children
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Popover.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: _refType$7.default,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: (0, _chainPropTypes$3.default)(_propTypes$1h.default.oneOfType([_HTMLElementType$1.default, _propTypes$1h.default.func]), props => {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      const resolvedAnchorEl = resolveAnchorEl(props.anchorEl);
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        const box = resolvedAnchorEl.getBoundingClientRect();
        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['MUI: The `anchorEl` prop provided to the component is invalid.', `It should be an Element or PopoverVirtualElement instance but it's \`${resolvedAnchorEl}\` instead.`].join('\n'));
      }
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: _propTypes$1h.default.shape({
    horizontal: _propTypes$1h.default.oneOfType([_propTypes$1h.default.oneOf(['center', 'left', 'right']), _propTypes$1h.default.number]).isRequired,
    vertical: _propTypes$1h.default.oneOfType([_propTypes$1h.default.oneOf(['bottom', 'center', 'top']), _propTypes$1h.default.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: _propTypes$1h.default.shape({
    left: _propTypes$1h.default.number.isRequired,
    top: _propTypes$1h.default.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: _propTypes$1h.default.oneOf(['anchorEl', 'anchorPosition', 'none']),
  /**
   * The content of the component.
   */
  children: _propTypes$1h.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1h.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1h.default.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: _propTypes$1h.default /* @typescript-to-proptypes-ignore */.oneOfType([_HTMLElementType$1.default, _propTypes$1h.default.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: _propTypes$1h.default.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: _integerPropType$5.default,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: _propTypes$1h.default.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: _propTypes$1h.default.func,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$1h.default.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: _propTypes$1h.default /* @typescript-to-proptypes-ignore */.shape({
    component: _elementTypeAcceptingRef$1.default
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: _propTypes$1h.default.shape({
    paper: _propTypes$1h.default.oneOfType([_propTypes$1h.default.func, _propTypes$1h.default.object]),
    root: _propTypes$1h.default.oneOfType([_propTypes$1h.default.func, _propTypes$1h.default.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: _propTypes$1h.default.shape({
    paper: _propTypes$1h.default.elementType,
    root: _propTypes$1h.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1h.default.oneOfType([_propTypes$1h.default.arrayOf(_propTypes$1h.default.oneOfType([_propTypes$1h.default.func, _propTypes$1h.default.object, _propTypes$1h.default.bool])), _propTypes$1h.default.func, _propTypes$1h.default.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: _propTypes$1h.default.shape({
    horizontal: _propTypes$1h.default.oneOfType([_propTypes$1h.default.oneOf(['center', 'left', 'right']), _propTypes$1h.default.number]).isRequired,
    vertical: _propTypes$1h.default.oneOfType([_propTypes$1h.default.oneOf(['bottom', 'center', 'top']), _propTypes$1h.default.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: _propTypes$1h.default.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: _propTypes$1h.default.oneOfType([_propTypes$1h.default.oneOf(['auto']), _propTypes$1h.default.number, _propTypes$1h.default.shape({
    appear: _propTypes$1h.default.number,
    enter: _propTypes$1h.default.number,
    exit: _propTypes$1h.default.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: _propTypes$1h.default.object
} : void 0;
Popover$1.default = Popover;

(function (exports) {
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  popoverClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Popover.default;
  }
});
Object.defineProperty(exports, "popoverClasses", {
  enumerable: true,
  get: function () {
    return _popoverClasses.default;
  }
});
var _Popover = _interopRequireWildcard(Popover$1);
Object.keys(_Popover).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Popover[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Popover[key];
    }
  });
});
var _popoverClasses = _interopRequireWildcard(popoverClasses$1);
Object.keys(_popoverClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _popoverClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _popoverClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Popover$2));

var menuClasses$1 = {};

var _interopRequireDefault$5e = interopRequireDefault$1.exports;
Object.defineProperty(menuClasses$1, "__esModule", {
  value: true
});
menuClasses$1.default = void 0;
menuClasses$1.getMenuUtilityClass = getMenuUtilityClass;
var _generateUtilityClasses$G = _interopRequireDefault$5e(generateUtilityClasses$3);
var _generateUtilityClass$G = _interopRequireDefault$5e(generateUtilityClass$3);
function getMenuUtilityClass(slot) {
  return (0, _generateUtilityClass$G.default)('MuiMenu', slot);
}
const menuClasses = (0, _generateUtilityClasses$G.default)('MuiMenu', ['root', 'paper', 'list']);
menuClasses$1.default = menuClasses;

var _interopRequireDefault$5d = interopRequireDefault$1.exports;
Object.defineProperty(Menu$1, "__esModule", {
  value: true
});
Menu$1.default = Menu$1.MenuPaper = void 0;
var _extends2$U = _interopRequireDefault$5d(_extends$19.exports);
var _objectWithoutPropertiesLoose2$R = _interopRequireDefault$5d(objectWithoutPropertiesLoose.exports);
var React$1b = _interopRequireWildcard$2h(React__default$4);
var _reactIs$5 = reactIs$6.exports;
var _propTypes$1g = _interopRequireDefault$5d(propTypes.exports);
var _clsx$1i = _interopRequireDefault$5d(clsx.exports);
var _composeClasses$I = _interopRequireDefault$5d(composeClasses$2);
var _HTMLElementType = _interopRequireDefault$5d(HTMLElementType$2);
var _RtlProvider$7 = RtlProvider$1;
var _useSlotProps$4 = _interopRequireDefault$5d(useSlotProps$2);
var _MenuList = _interopRequireDefault$5d(MenuList$2);
var _Popover = _interopRequireWildcard$2h(Popover$2);
var _styled$G = _interopRequireWildcard$2h(styled$2);
var _DefaultPropsProvider$H = DefaultPropsProvider$5;
var _menuClasses = menuClasses$1;
var _jsxRuntime$15 = require$$11;
const _excluded$1j = ["onEntering"],
  _excluded2$i = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"];
function _getRequireWildcardCache$20(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$20 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2h(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$20(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
const LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
const useUtilityClasses$J = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper'],
    list: ['list']
  };
  return (0, _composeClasses$I.default)(slots, _menuClasses.getMenuUtilityClass, classes);
};
const MenuRoot = (0, _styled$G.default)(_Popover.default, {
  shouldForwardProp: prop => (0, _styled$G.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiMenu',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const MenuPaper = Menu$1.MenuPaper = (0, _styled$G.default)(_Popover.PopoverPaper, {
  name: 'MuiMenu',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: 'calc(100% - 96px)',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch'
});
const MenuMenuList = (0, _styled$G.default)(_MenuList.default, {
  name: 'MuiMenu',
  slot: 'List',
  overridesResolver: (props, styles) => styles.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Menu = /*#__PURE__*/React$1b.forwardRef(function Menu(inProps, ref) {
  var _slots$paper, _slotProps$paper;
  const props = (0, _DefaultPropsProvider$H.useDefaultProps)({
    props: inProps,
    name: 'MuiMenu'
  });
  const {
      autoFocus = true,
      children,
      className,
      disableAutoFocusItem = false,
      MenuListProps = {},
      onClose,
      open,
      PaperProps = {},
      PopoverClasses,
      transitionDuration = 'auto',
      TransitionProps: {
        onEntering
      } = {},
      variant = 'selectedMenu',
      slots = {},
      slotProps = {}
    } = props,
    TransitionProps = (0, _objectWithoutPropertiesLoose2$R.default)(props.TransitionProps, _excluded$1j),
    other = (0, _objectWithoutPropertiesLoose2$R.default)(props, _excluded2$i);
  const isRtl = (0, _RtlProvider$7.useRtl)();
  const ownerState = (0, _extends2$U.default)({}, props, {
    autoFocus,
    disableAutoFocusItem,
    MenuListProps,
    onEntering,
    PaperProps,
    transitionDuration,
    TransitionProps,
    variant
  });
  const classes = useUtilityClasses$J(ownerState);
  const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  const menuListActionsRef = React$1b.useRef(null);
  const handleEntering = (element, isAppearing) => {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, {
        direction: isRtl ? 'rtl' : 'ltr'
      });
    }
    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };
  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault();
      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };

  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */
  let activeItemIndex = -1;
  // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback
  React$1b.Children.map(children, (child, index) => {
    if (! /*#__PURE__*/React$1b.isValidElement(child)) {
      return;
    }
    if (process.env.NODE_ENV !== 'production') {
      if ((0, _reactIs$5.isFragment)(child)) {
        console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : MenuPaper;
  const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
  const rootSlotProps = (0, _useSlotProps$4.default)({
    elementType: slots.root,
    externalSlotProps: slotProps.root,
    ownerState,
    className: [classes.root, className]
  });
  const paperSlotProps = (0, _useSlotProps$4.default)({
    elementType: PaperSlot,
    externalSlotProps: paperExternalSlotProps,
    ownerState,
    className: classes.paper
  });
  return /*#__PURE__*/(0, _jsxRuntime$15.jsx)(MenuRoot, (0, _extends2$U.default)({
    onClose: onClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: isRtl ? 'right' : 'left'
    },
    transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      paper: PaperSlot,
      root: slots.root
    },
    slotProps: {
      root: rootSlotProps,
      paper: paperSlotProps
    },
    open: open,
    ref: ref,
    transitionDuration: transitionDuration,
    TransitionProps: (0, _extends2$U.default)({
      onEntering: handleEntering
    }, TransitionProps),
    ownerState: ownerState
  }, other, {
    classes: PopoverClasses,
    children: /*#__PURE__*/(0, _jsxRuntime$15.jsx)(MenuMenuList, (0, _extends2$U.default)({
      onKeyDown: handleListKeyDown,
      actions: menuListActionsRef,
      autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
      autoFocusItem: autoFocusItem,
      variant: variant
    }, MenuListProps, {
      className: (0, _clsx$1i.default)(classes.list, MenuListProps.className),
      children: children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Menu.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: _propTypes$1g.default /* @typescript-to-proptypes-ignore */.oneOfType([_HTMLElementType.default, _propTypes$1g.default.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: _propTypes$1g.default.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: _propTypes$1g.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1g.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1g.default.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: _propTypes$1g.default.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: _propTypes$1g.default.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: _propTypes$1g.default.func,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$1g.default.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: _propTypes$1g.default.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: _propTypes$1g.default.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: _propTypes$1g.default.shape({
    paper: _propTypes$1g.default.oneOfType([_propTypes$1g.default.func, _propTypes$1g.default.object]),
    root: _propTypes$1g.default.oneOfType([_propTypes$1g.default.func, _propTypes$1g.default.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: _propTypes$1g.default.shape({
    paper: _propTypes$1g.default.elementType,
    root: _propTypes$1g.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1g.default.oneOfType([_propTypes$1g.default.arrayOf(_propTypes$1g.default.oneOfType([_propTypes$1g.default.func, _propTypes$1g.default.object, _propTypes$1g.default.bool])), _propTypes$1g.default.func, _propTypes$1g.default.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: _propTypes$1g.default.oneOfType([_propTypes$1g.default.oneOf(['auto']), _propTypes$1g.default.number, _propTypes$1g.default.shape({
    appear: _propTypes$1g.default.number,
    enter: _propTypes$1g.default.number,
    exit: _propTypes$1g.default.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: _propTypes$1g.default.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: _propTypes$1g.default.oneOf(['menu', 'selectedMenu'])
} : void 0;
Menu$1.default = Menu;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  menuClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Menu.default;
  }
});
Object.defineProperty(exports, "menuClasses", {
  enumerable: true,
  get: function () {
    return _menuClasses.default;
  }
});
var _Menu = _interopRequireDefault(Menu$1);
var _menuClasses = _interopRequireWildcard(menuClasses$1);
Object.keys(_menuClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _menuClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _menuClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Menu$2));

var MenuItem$3 = {};

var MenuItem$2 = {};

var menuItemClasses$1 = {};

var _interopRequireDefault$5c = interopRequireDefault$1.exports;
Object.defineProperty(menuItemClasses$1, "__esModule", {
  value: true
});
menuItemClasses$1.default = void 0;
menuItemClasses$1.getMenuItemUtilityClass = getMenuItemUtilityClass;
var _generateUtilityClasses$F = _interopRequireDefault$5c(generateUtilityClasses$3);
var _generateUtilityClass$F = _interopRequireDefault$5c(generateUtilityClass$3);
function getMenuItemUtilityClass(slot) {
  return (0, _generateUtilityClass$F.default)('MuiMenuItem', slot);
}
const menuItemClasses = (0, _generateUtilityClasses$F.default)('MuiMenuItem', ['root', 'focusVisible', 'dense', 'disabled', 'divider', 'gutters', 'selected']);
menuItemClasses$1.default = menuItemClasses;

var _interopRequireDefault$5b = interopRequireDefault$1.exports;
Object.defineProperty(MenuItem$2, "__esModule", {
  value: true
});
MenuItem$2.overridesResolver = MenuItem$2.default = void 0;
var _objectWithoutPropertiesLoose2$Q = _interopRequireDefault$5b(objectWithoutPropertiesLoose.exports);
var _extends2$T = _interopRequireDefault$5b(_extends$19.exports);
var React$1a = _interopRequireWildcard$2g(React__default$4);
var _propTypes$1f = _interopRequireDefault$5b(propTypes.exports);
var _clsx$1h = _interopRequireDefault$5b(clsx.exports);
var _composeClasses$H = _interopRequireDefault$5b(composeClasses$2);
var _colorManipulator$9 = colorManipulator;
var _styled$F = _interopRequireWildcard$2g(styled$2);
var _DefaultPropsProvider$G = DefaultPropsProvider$5;
var _ListContext = _interopRequireDefault$5b(ListContext$1);
var _ButtonBase$6 = _interopRequireDefault$5b(ButtonBase$2);
var _useEnhancedEffect$1 = _interopRequireDefault$5b(useEnhancedEffect);
var _useForkRef$7 = _interopRequireDefault$5b(useForkRef);
var _Divider = Divider$3;
var _ListItemIcon = ListItemIcon$2;
var _ListItemText = ListItemText$2;
var _menuItemClasses = _interopRequireWildcard$2g(menuItemClasses$1);
var _jsxRuntime$14 = require$$11;
const _excluded$1i = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"];
function _getRequireWildcardCache$1$(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1$ = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2g(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1$(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const overridesResolver$1 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};
MenuItem$2.overridesResolver = overridesResolver$1;
const useUtilityClasses$I = ownerState => {
  const {
    disabled,
    dense,
    divider,
    disableGutters,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', disabled && 'disabled', !disableGutters && 'gutters', divider && 'divider', selected && 'selected']
  };
  const composedClasses = (0, _composeClasses$H.default)(slots, _menuItemClasses.getMenuItemUtilityClass, classes);
  return (0, _extends2$T.default)({}, classes, composedClasses);
};
const MenuItemRoot = (0, _styled$F.default)(_ButtonBase$6.default, {
  shouldForwardProp: prop => (0, _styled$F.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiMenuItem',
  slot: 'Root',
  overridesResolver: overridesResolver$1
})(({
  theme,
  ownerState
}) => (0, _extends2$T.default)({}, theme.typography.body1, {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: 'border-box',
  whiteSpace: 'nowrap'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.divider && {
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
  backgroundClip: 'padding-box'
}, {
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${_menuItemClasses.default.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator$9.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${_menuItemClasses.default.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator$9.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${_menuItemClasses.default.selected}:hover`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator$9.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator$9.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${_menuItemClasses.default.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${_menuItemClasses.default.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  },
  [`& + .${_Divider.dividerClasses.root}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  [`& + .${_Divider.dividerClasses.inset}`]: {
    marginLeft: 52
  },
  [`& .${_ListItemText.listItemTextClasses.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${_ListItemText.listItemTextClasses.inset}`]: {
    paddingLeft: 36
  },
  [`& .${_ListItemIcon.listItemIconClasses.root}`]: {
    minWidth: 36
  }
}, !ownerState.dense && {
  [theme.breakpoints.up('sm')]: {
    minHeight: 'auto'
  }
}, ownerState.dense && (0, _extends2$T.default)({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, theme.typography.body2, {
  [`& .${_ListItemIcon.listItemIconClasses.root} svg`]: {
    fontSize: '1.25rem'
  }
})));
const MenuItem$1 = /*#__PURE__*/React$1a.forwardRef(function MenuItem(inProps, ref) {
  const props = (0, _DefaultPropsProvider$G.useDefaultProps)({
    props: inProps,
    name: 'MuiMenuItem'
  });
  const {
      autoFocus = false,
      component = 'li',
      dense = false,
      divider = false,
      disableGutters = false,
      focusVisibleClassName,
      role = 'menuitem',
      tabIndex: tabIndexProp,
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$Q.default)(props, _excluded$1i);
  const context = React$1a.useContext(_ListContext.default);
  const childContext = React$1a.useMemo(() => ({
    dense: dense || context.dense || false,
    disableGutters
  }), [context.dense, dense, disableGutters]);
  const menuItemRef = React$1a.useRef(null);
  (0, _useEnhancedEffect$1.default)(() => {
    if (autoFocus) {
      if (menuItemRef.current) {
        menuItemRef.current.focus();
      } else if (process.env.NODE_ENV !== 'production') {
        console.error('MUI: Unable to set focus to a MenuItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  const ownerState = (0, _extends2$T.default)({}, props, {
    dense: childContext.dense,
    divider,
    disableGutters
  });
  const classes = useUtilityClasses$I(props);
  const handleRef = (0, _useForkRef$7.default)(menuItemRef, ref);
  let tabIndex;
  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }
  return /*#__PURE__*/(0, _jsxRuntime$14.jsx)(_ListContext.default.Provider, {
    value: childContext,
    children: /*#__PURE__*/(0, _jsxRuntime$14.jsx)(MenuItemRoot, (0, _extends2$T.default)({
      ref: handleRef,
      role: role,
      tabIndex: tabIndex,
      component: component,
      focusVisibleClassName: (0, _clsx$1h.default)(classes.focusVisible, focusVisibleClassName),
      className: (0, _clsx$1h.default)(classes.root, className)
    }, other, {
      ownerState: ownerState,
      classes: classes
    }))
  });
});
process.env.NODE_ENV !== "production" ? MenuItem$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: _propTypes$1f.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes$1f.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1f.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1f.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$1f.default.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: _propTypes$1f.default.bool,
  /**
   * @ignore
   */
  disabled: _propTypes$1f.default.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: _propTypes$1f.default.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: _propTypes$1f.default.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: _propTypes$1f.default.string,
  /**
   * @ignore
   */
  role: _propTypes$1f.default /* @typescript-to-proptypes-ignore */.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: _propTypes$1f.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1f.default.oneOfType([_propTypes$1f.default.arrayOf(_propTypes$1f.default.oneOfType([_propTypes$1f.default.func, _propTypes$1f.default.object, _propTypes$1f.default.bool])), _propTypes$1f.default.func, _propTypes$1f.default.object]),
  /**
   * @default 0
   */
  tabIndex: _propTypes$1f.default.number
} : void 0;
MenuItem$2.default = MenuItem$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  menuItemClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _MenuItem.default;
  }
});
Object.defineProperty(exports, "menuItemClasses", {
  enumerable: true,
  get: function () {
    return _menuItemClasses.default;
  }
});
var _MenuItem = _interopRequireDefault(MenuItem$2);
var _menuItemClasses = _interopRequireWildcard(menuItemClasses$1);
Object.keys(_menuItemClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _menuItemClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _menuItemClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(MenuItem$3));

var MenuItem = /*@__PURE__*/getDefaultExportFromCjs$1(MenuItem$3);

var MobileStepper$2 = {};

var MobileStepper$1 = {};

var mobileStepperClasses$1 = {};

var _interopRequireDefault$5a = interopRequireDefault$1.exports;
Object.defineProperty(mobileStepperClasses$1, "__esModule", {
  value: true
});
mobileStepperClasses$1.default = void 0;
mobileStepperClasses$1.getMobileStepperUtilityClass = getMobileStepperUtilityClass;
var _generateUtilityClasses$E = _interopRequireDefault$5a(generateUtilityClasses$3);
var _generateUtilityClass$E = _interopRequireDefault$5a(generateUtilityClass$3);
function getMobileStepperUtilityClass(slot) {
  return (0, _generateUtilityClass$E.default)('MuiMobileStepper', slot);
}
const mobileStepperClasses = (0, _generateUtilityClasses$E.default)('MuiMobileStepper', ['root', 'positionBottom', 'positionTop', 'positionStatic', 'dots', 'dot', 'dotActive', 'progress']);
mobileStepperClasses$1.default = mobileStepperClasses;

var _interopRequireDefault$59 = interopRequireDefault$1.exports;
Object.defineProperty(MobileStepper$1, "__esModule", {
  value: true
});
MobileStepper$1.default = void 0;
var _objectWithoutPropertiesLoose2$P = _interopRequireDefault$59(objectWithoutPropertiesLoose.exports);
var _extends2$S = _interopRequireDefault$59(_extends$19.exports);
var React$19 = _interopRequireWildcard$2f(React__default$4);
var _propTypes$1e = _interopRequireDefault$59(propTypes.exports);
var _clsx$1g = _interopRequireDefault$59(clsx.exports);
var _integerPropType$4 = _interopRequireDefault$59(integerPropType$1);
var _composeClasses$G = _interopRequireDefault$59(composeClasses$2);
var _Paper$1 = _interopRequireDefault$59(Paper$3);
var _capitalize$h = _interopRequireDefault$59(capitalize$1);
var _LinearProgress = _interopRequireDefault$59(LinearProgress$2);
var _DefaultPropsProvider$F = DefaultPropsProvider$5;
var _styled$E = _interopRequireWildcard$2f(styled$2);
var _mobileStepperClasses = mobileStepperClasses$1;
var _jsxRuntime$13 = require$$11;
const _excluded$1h = ["activeStep", "backButton", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"];
function _getRequireWildcardCache$1_(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1_ = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2f(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1_(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$H = ownerState => {
  const {
    classes,
    position
  } = ownerState;
  const slots = {
    root: ['root', `position${(0, _capitalize$h.default)(position)}`],
    dots: ['dots'],
    dot: ['dot'],
    dotActive: ['dotActive'],
    progress: ['progress']
  };
  return (0, _composeClasses$G.default)(slots, _mobileStepperClasses.getMobileStepperUtilityClass, classes);
};
const MobileStepperRoot = (0, _styled$E.default)(_Paper$1.default, {
  name: 'MuiMobileStepper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`position${(0, _capitalize$h.default)(ownerState.position)}`]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$S.default)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  background: (theme.vars || theme).palette.background.default,
  padding: 8
}, ownerState.position === 'bottom' && {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: (theme.vars || theme).zIndex.mobileStepper
}, ownerState.position === 'top' && {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: (theme.vars || theme).zIndex.mobileStepper
}));
const MobileStepperDots = (0, _styled$E.default)('div', {
  name: 'MuiMobileStepper',
  slot: 'Dots',
  overridesResolver: (props, styles) => styles.dots
})(({
  ownerState
}) => (0, _extends2$S.default)({}, ownerState.variant === 'dots' && {
  display: 'flex',
  flexDirection: 'row'
}));
const MobileStepperDot = (0, _styled$E.default)('div', {
  name: 'MuiMobileStepper',
  slot: 'Dot',
  shouldForwardProp: prop => (0, _styled$E.slotShouldForwardProp)(prop) && prop !== 'dotActive',
  overridesResolver: (props, styles) => {
    const {
      dotActive
    } = props;
    return [styles.dot, dotActive && styles.dotActive];
  }
})(({
  theme,
  ownerState,
  dotActive
}) => (0, _extends2$S.default)({}, ownerState.variant === 'dots' && (0, _extends2$S.default)({
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  backgroundColor: (theme.vars || theme).palette.action.disabled,
  borderRadius: '50%',
  width: 8,
  height: 8,
  margin: '0 2px'
}, dotActive && {
  backgroundColor: (theme.vars || theme).palette.primary.main
})));
const MobileStepperProgress = (0, _styled$E.default)(_LinearProgress.default, {
  name: 'MuiMobileStepper',
  slot: 'Progress',
  overridesResolver: (props, styles) => styles.progress
})(({
  ownerState
}) => (0, _extends2$S.default)({}, ownerState.variant === 'progress' && {
  width: '50%'
}));
const MobileStepper = /*#__PURE__*/React$19.forwardRef(function MobileStepper(inProps, ref) {
  const props = (0, _DefaultPropsProvider$F.useDefaultProps)({
    props: inProps,
    name: 'MuiMobileStepper'
  });
  const {
      activeStep = 0,
      backButton,
      className,
      LinearProgressProps,
      nextButton,
      position = 'bottom',
      steps,
      variant = 'dots'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$P.default)(props, _excluded$1h);
  const ownerState = (0, _extends2$S.default)({}, props, {
    activeStep,
    position,
    variant
  });
  let value;
  if (variant === 'progress') {
    if (steps === 1) {
      value = 100;
    } else {
      value = Math.ceil(activeStep / (steps - 1) * 100);
    }
  }
  const classes = useUtilityClasses$H(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$13.jsxs)(MobileStepperRoot, (0, _extends2$S.default)({
    square: true,
    elevation: 0,
    className: (0, _clsx$1g.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [backButton, variant === 'text' && /*#__PURE__*/(0, _jsxRuntime$13.jsxs)(React$19.Fragment, {
      children: [activeStep + 1, " / ", steps]
    }), variant === 'dots' && /*#__PURE__*/(0, _jsxRuntime$13.jsx)(MobileStepperDots, {
      ownerState: ownerState,
      className: classes.dots,
      children: [...new Array(steps)].map((_, index) => /*#__PURE__*/(0, _jsxRuntime$13.jsx)(MobileStepperDot, {
        className: (0, _clsx$1g.default)(classes.dot, index === activeStep && classes.dotActive),
        ownerState: ownerState,
        dotActive: index === activeStep
      }, index))
    }), variant === 'progress' && /*#__PURE__*/(0, _jsxRuntime$13.jsx)(MobileStepperProgress, (0, _extends2$S.default)({
      ownerState: ownerState,
      className: classes.progress,
      variant: "determinate",
      value: value
    }, LinearProgressProps)), nextButton]
  }));
});
process.env.NODE_ENV !== "production" ? MobileStepper.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   * @default 0
   */
  activeStep: _integerPropType$4.default,
  /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */
  backButton: _propTypes$1e.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1e.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1e.default.string,
  /**
   * Props applied to the `LinearProgress` element.
   */
  LinearProgressProps: _propTypes$1e.default.object,
  /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */
  nextButton: _propTypes$1e.default.node,
  /**
   * Set the positioning type.
   * @default 'bottom'
   */
  position: _propTypes$1e.default.oneOf(['bottom', 'static', 'top']),
  /**
   * The total steps.
   */
  steps: _integerPropType$4.default.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1e.default.oneOfType([_propTypes$1e.default.arrayOf(_propTypes$1e.default.oneOfType([_propTypes$1e.default.func, _propTypes$1e.default.object, _propTypes$1e.default.bool])), _propTypes$1e.default.func, _propTypes$1e.default.object]),
  /**
   * The variant to use.
   * @default 'dots'
   */
  variant: _propTypes$1e.default.oneOf(['dots', 'progress', 'text'])
} : void 0;
MobileStepper$1.default = MobileStepper;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  mobileStepperClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _MobileStepper.default;
  }
});
Object.defineProperty(exports, "mobileStepperClasses", {
  enumerable: true,
  get: function () {
    return _mobileStepperClasses.default;
  }
});
var _MobileStepper = _interopRequireDefault(MobileStepper$1);
var _mobileStepperClasses = _interopRequireWildcard(mobileStepperClasses$1);
Object.keys(_mobileStepperClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _mobileStepperClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mobileStepperClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(MobileStepper$2));

var NativeSelect$2 = {};

var NativeSelect$1 = {};

var NativeSelectInput$1 = {};

var nativeSelectClasses$1 = {};

var _interopRequireDefault$58 = interopRequireDefault$1.exports;
Object.defineProperty(nativeSelectClasses$1, "__esModule", {
  value: true
});
nativeSelectClasses$1.default = void 0;
nativeSelectClasses$1.getNativeSelectUtilityClasses = getNativeSelectUtilityClasses;
var _generateUtilityClasses$D = _interopRequireDefault$58(generateUtilityClasses$3);
var _generateUtilityClass$D = _interopRequireDefault$58(generateUtilityClass$3);
function getNativeSelectUtilityClasses(slot) {
  return (0, _generateUtilityClass$D.default)('MuiNativeSelect', slot);
}
const nativeSelectClasses = (0, _generateUtilityClasses$D.default)('MuiNativeSelect', ['root', 'select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput', 'error']);
nativeSelectClasses$1.default = nativeSelectClasses;

var _interopRequireDefault$57 = interopRequireDefault$1.exports;
Object.defineProperty(NativeSelectInput$1, "__esModule", {
  value: true
});
NativeSelectInput$1.nativeSelectSelectStyles = NativeSelectInput$1.nativeSelectIconStyles = NativeSelectInput$1.default = void 0;
var _objectWithoutPropertiesLoose2$O = _interopRequireDefault$57(objectWithoutPropertiesLoose.exports);
var _extends2$R = _interopRequireDefault$57(_extends$19.exports);
var React$18 = _interopRequireWildcard$2e(React__default$4);
var _propTypes$1d = _interopRequireDefault$57(propTypes.exports);
var _clsx$1f = _interopRequireDefault$57(clsx.exports);
var _refType$6 = _interopRequireDefault$57(refType$2);
var _composeClasses$F = _interopRequireDefault$57(composeClasses$2);
var _capitalize$g = _interopRequireDefault$57(capitalize$1);
var _nativeSelectClasses$1 = _interopRequireWildcard$2e(nativeSelectClasses$1);
var _styled$D = _interopRequireWildcard$2e(styled$2);
var _jsxRuntime$12 = require$$11;
const _excluded$1g = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"];
function _getRequireWildcardCache$1Z(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1Z = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2e(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1Z(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$G = ownerState => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open,
    error
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled', multiple && 'multiple', error && 'error'],
    icon: ['icon', `icon${(0, _capitalize$g.default)(variant)}`, open && 'iconOpen', disabled && 'disabled']
  };
  return (0, _composeClasses$F.default)(slots, _nativeSelectClasses$1.getNativeSelectUtilityClasses, classes);
};
const nativeSelectSelectStyles = ({
  ownerState,
  theme
}) => (0, _extends2$R.default)({
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: 'none',
  borderRadius: 0,
  // Reset
  cursor: 'pointer',
  '&:focus': (0, _extends2$R.default)({}, theme.vars ? {
    backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
  }, {
    borderRadius: 0 // Reset Chrome style
  }),
  // Remove IE11 arrow
  '&::-ms-expand': {
    display: 'none'
  },
  [`&.${_nativeSelectClasses$1.default.disabled}`]: {
    cursor: 'default'
  },
  '&[multiple]': {
    height: 'auto'
  },
  '&:not([multiple]) option, &:not([multiple]) optgroup': {
    backgroundColor: (theme.vars || theme).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  '&&&': {
    paddingRight: 24,
    minWidth: 16 // So it doesn't collapse.
  }
}, ownerState.variant === 'filled' && {
  '&&&': {
    paddingRight: 32
  }
}, ownerState.variant === 'outlined' && {
  borderRadius: (theme.vars || theme).shape.borderRadius,
  '&:focus': {
    borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
  },
  '&&&': {
    paddingRight: 32
  }
});
NativeSelectInput$1.nativeSelectSelectStyles = nativeSelectSelectStyles;
const NativeSelectSelect = (0, _styled$D.default)('select', {
  name: 'MuiNativeSelect',
  slot: 'Select',
  shouldForwardProp: _styled$D.rootShouldForwardProp,
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.select, styles[ownerState.variant], ownerState.error && styles.error, {
      [`&.${_nativeSelectClasses$1.default.multiple}`]: styles.multiple
    }];
  }
})(nativeSelectSelectStyles);
const nativeSelectIconStyles = ({
  ownerState,
  theme
}) => (0, _extends2$R.default)({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: 'absolute',
  right: 0,
  top: 'calc(50% - .5em)',
  // Center vertically, height is 1em
  pointerEvents: 'none',
  // Don't block pointer events on the select under the icon.
  color: (theme.vars || theme).palette.action.active,
  [`&.${_nativeSelectClasses$1.default.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}, ownerState.open && {
  transform: 'rotate(180deg)'
}, ownerState.variant === 'filled' && {
  right: 7
}, ownerState.variant === 'outlined' && {
  right: 7
});
NativeSelectInput$1.nativeSelectIconStyles = nativeSelectIconStyles;
const NativeSelectIcon = (0, _styled$D.default)('svg', {
  name: 'MuiNativeSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${(0, _capitalize$g.default)(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(nativeSelectIconStyles);

/**
 * @ignore - internal component.
 */
const NativeSelectInput = /*#__PURE__*/React$18.forwardRef(function NativeSelectInput(props, ref) {
  const {
      className,
      disabled,
      error,
      IconComponent,
      inputRef,
      variant = 'standard'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$O.default)(props, _excluded$1g);
  const ownerState = (0, _extends2$R.default)({}, props, {
    disabled,
    variant,
    error
  });
  const classes = useUtilityClasses$G(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$12.jsxs)(React$18.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime$12.jsx)(NativeSelectSelect, (0, _extends2$R.default)({
      ownerState: ownerState,
      className: (0, _clsx$1f.default)(classes.select, className),
      disabled: disabled,
      ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/(0, _jsxRuntime$12.jsx)(NativeSelectIcon, {
      as: IconComponent,
      ownerState: ownerState,
      className: classes.icon
    })]
  });
});
process.env.NODE_ENV !== "production" ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes$1d.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1d.default.object,
  /**
   * The CSS class name of the select element.
   */
  className: _propTypes$1d.default.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: _propTypes$1d.default.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: _propTypes$1d.default.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes$1d.default.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: _refType$6.default,
  /**
   * @ignore
   */
  multiple: _propTypes$1d.default.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes$1d.default.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes$1d.default.func,
  /**
   * The input value.
   */
  value: _propTypes$1d.default.any,
  /**
   * The variant to use.
   */
  variant: _propTypes$1d.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
NativeSelectInput$1.default = NativeSelectInput;

var _interopRequireDefault$56 = interopRequireDefault$1.exports;
Object.defineProperty(NativeSelect$1, "__esModule", {
  value: true
});
NativeSelect$1.default = void 0;
var _extends2$Q = _interopRequireDefault$56(_extends$19.exports);
var _objectWithoutPropertiesLoose2$N = _interopRequireDefault$56(objectWithoutPropertiesLoose.exports);
var React$17 = _interopRequireWildcard$2d(React__default$4);
var _clsx$1e = _interopRequireDefault$56(clsx.exports);
var _propTypes$1c = _interopRequireDefault$56(propTypes.exports);
var _composeClasses$E = _interopRequireDefault$56(composeClasses$2);
var _NativeSelectInput$2 = _interopRequireDefault$56(NativeSelectInput$1);
var _formControlState$2 = _interopRequireDefault$56(formControlState$1);
var _useFormControl$2 = _interopRequireDefault$56(useFormControl$1);
var _ArrowDropDown$1 = _interopRequireDefault$56(ArrowDropDown);
var _Input$3 = _interopRequireDefault$56(Input$7);
var _DefaultPropsProvider$E = DefaultPropsProvider$5;
var _nativeSelectClasses = nativeSelectClasses$1;
var _jsxRuntime$11 = require$$11;
const _excluded$1f = ["className", "children", "classes", "IconComponent", "input", "inputProps", "variant"],
  _excluded2$h = ["root"];
function _getRequireWildcardCache$1Y(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1Y = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2d(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1Y(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$F = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$E.default)(slots, _nativeSelectClasses.getNativeSelectUtilityClasses, classes);
};
const defaultInput = /*#__PURE__*/(0, _jsxRuntime$11.jsx)(_Input$3.default, {});
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */
const NativeSelect = /*#__PURE__*/React$17.forwardRef(function NativeSelect(inProps, ref) {
  const props = (0, _DefaultPropsProvider$E.useDefaultProps)({
    name: 'MuiNativeSelect',
    props: inProps
  });
  const {
      className,
      children,
      classes: classesProp = {},
      IconComponent = _ArrowDropDown$1.default,
      input = defaultInput,
      inputProps
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$N.default)(props, _excluded$1f);
  const muiFormControl = (0, _useFormControl$2.default)();
  const fcs = (0, _formControlState$2.default)({
    props,
    muiFormControl,
    states: ['variant']
  });
  const ownerState = (0, _extends2$Q.default)({}, props, {
    classes: classesProp
  });
  const classes = useUtilityClasses$F(ownerState);
  const otherClasses = (0, _objectWithoutPropertiesLoose2$N.default)(classesProp, _excluded2$h);
  return /*#__PURE__*/(0, _jsxRuntime$11.jsx)(React$17.Fragment, {
    children: /*#__PURE__*/React$17.cloneElement(input, (0, _extends2$Q.default)({
      // Most of the logic is implemented in `NativeSelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: _NativeSelectInput$2.default,
      inputProps: (0, _extends2$Q.default)({
        children,
        classes: otherClasses,
        IconComponent,
        variant: fcs.variant,
        type: undefined
      }, inputProps, input ? input.props.inputProps : {}),
      ref
    }, other, {
      className: (0, _clsx$1e.default)(classes.root, input.props.className, className)
    }))
  });
});
process.env.NODE_ENV !== "production" ? NativeSelect.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: _propTypes$1c.default.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: _propTypes$1c.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1c.default.string,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: _propTypes$1c.default.elementType,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   * @default <Input />
   */
  input: _propTypes$1c.default.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select#attributes) applied to the `select` element.
   */
  inputProps: _propTypes$1c.default.object,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {React.ChangeEvent<HTMLSelectElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes$1c.default.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$1c.default.oneOfType([_propTypes$1c.default.arrayOf(_propTypes$1c.default.oneOfType([_propTypes$1c.default.func, _propTypes$1c.default.object, _propTypes$1c.default.bool])), _propTypes$1c.default.func, _propTypes$1c.default.object]),
  /**
   * The `input` value. The DOM API casts this to a string.
   */
  value: _propTypes$1c.default.any,
  /**
   * The variant to use.
   */
  variant: _propTypes$1c.default.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
NativeSelect.muiName = 'Select';
NativeSelect$1.default = NativeSelect;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  nativeSelectClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _NativeSelect.default;
  }
});
Object.defineProperty(exports, "nativeSelectClasses", {
  enumerable: true,
  get: function () {
    return _nativeSelectClasses.default;
  }
});
var _NativeSelect = _interopRequireDefault(NativeSelect$1);
var _nativeSelectClasses = _interopRequireWildcard(nativeSelectClasses$1);
Object.keys(_nativeSelectClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _nativeSelectClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _nativeSelectClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(NativeSelect$2));

var NoSsr$2 = {};

var NoSsr$1 = {};

var _interopRequireDefault$55 = interopRequireDefault$1.exports;
Object.defineProperty(NoSsr$1, "__esModule", {
  value: true
});
NoSsr$1.default = void 0;
var React$16 = _interopRequireWildcard$2c(React__default$4);
var _propTypes$1b = _interopRequireDefault$55(propTypes.exports);
var _utils$F = utils$7;
var _jsxRuntime$10 = require$$11;
function _getRequireWildcardCache$1X(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1X = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2c(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1X(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 *
 * *   Escape hatch for broken dependencies not supporting SSR.
 * *   Improve the time-to-first paint on the client by only rendering above the fold.
 * *   Reduce the rendering time on the server.
 * *   Under too heavy server load, you can turn on service degradation.
 *
 * Demos:
 *
 * - [No SSR](https://mui.com/material-ui/react-no-ssr/)
 *
 * API:
 *
 * - [NoSsr API](https://mui.com/material-ui/api/no-ssr/)
 */
function NoSsr(props) {
  const {
    children,
    defer = false,
    fallback = null
  } = props;
  const [mountedState, setMountedState] = React$16.useState(false);
  (0, _utils$F.unstable_useEnhancedEffect)(() => {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);
  React$16.useEffect(() => {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]);

  // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
  return /*#__PURE__*/(0, _jsxRuntime$10.jsx)(React$16.Fragment, {
    children: mountedState ? children : fallback
  });
}
process.env.NODE_ENV !== "production" ? NoSsr.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: _propTypes$1b.default.node,
  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   * @default false
   */
  defer: _propTypes$1b.default.bool,
  /**
   * The fallback content to display.
   * @default null
   */
  fallback: _propTypes$1b.default.node
} : void 0;
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  NoSsr['propTypes' + ''] = (0, _utils$F.exactProp)(NoSsr.propTypes);
}
NoSsr$1.default = NoSsr;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _NoSsr.default;
  }
});
var _NoSsr = _interopRequireDefault(NoSsr$1);
}(NoSsr$2));

var OutlinedInput$3 = {};

var OutlinedInput$2 = {};

var NotchedOutline$1 = {};

var _interopRequireDefault$54 = interopRequireDefault$1.exports;
Object.defineProperty(NotchedOutline$1, "__esModule", {
  value: true
});
NotchedOutline$1.default = NotchedOutline;
var _objectWithoutPropertiesLoose2$M = _interopRequireDefault$54(objectWithoutPropertiesLoose.exports);
var _extends2$P = _interopRequireDefault$54(_extends$19.exports);
_interopRequireWildcard$2b(React__default$4);
var _propTypes$1a = _interopRequireDefault$54(propTypes.exports);
var _styled$C = _interopRequireWildcard$2b(styled$2);
var _jsxRuntime$$ = require$$11;
var _span$1;
const _excluded$1e = ["children", "classes", "className", "label", "notched"];
function _getRequireWildcardCache$1W(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1W = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2b(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1W(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NotchedOutlineRoot$1 = (0, _styled$C.default)('fieldset', {
  shouldForwardProp: _styled$C.rootShouldForwardProp
})({
  textAlign: 'left',
  position: 'absolute',
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: '0 8px',
  pointerEvents: 'none',
  borderRadius: 'inherit',
  borderStyle: 'solid',
  borderWidth: 1,
  overflow: 'hidden',
  minWidth: '0%'
});
const NotchedOutlineLegend = (0, _styled$C.default)('legend', {
  shouldForwardProp: _styled$C.rootShouldForwardProp
})(({
  ownerState,
  theme
}) => (0, _extends2$P.default)({
  float: 'unset',
  // Fix conflict with bootstrap
  width: 'auto',
  // Fix conflict with bootstrap
  overflow: 'hidden'
}, !ownerState.withLabel && {
  padding: 0,
  lineHeight: '11px',
  // sync with `height` in `legend` styles
  transition: theme.transitions.create('width', {
    duration: 150,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.withLabel && (0, _extends2$P.default)({
  display: 'block',
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: '0.75em',
  visibility: 'hidden',
  maxWidth: 0.01,
  transition: theme.transitions.create('max-width', {
    duration: 50,
    easing: theme.transitions.easing.easeOut
  }),
  whiteSpace: 'nowrap',
  '& > span': {
    paddingLeft: 5,
    paddingRight: 5,
    display: 'inline-block',
    opacity: 0,
    visibility: 'visible'
  }
}, ownerState.notched && {
  maxWidth: '100%',
  transition: theme.transitions.create('max-width', {
    duration: 100,
    easing: theme.transitions.easing.easeOut,
    delay: 50
  })
})));

/**
 * @ignore - internal component.
 */
function NotchedOutline(props) {
  const {
      className,
      label,
      notched
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$M.default)(props, _excluded$1e);
  const withLabel = label != null && label !== '';
  const ownerState = (0, _extends2$P.default)({}, props, {
    notched,
    withLabel
  });
  return /*#__PURE__*/(0, _jsxRuntime$$.jsx)(NotchedOutlineRoot$1, (0, _extends2$P.default)({
    "aria-hidden": true,
    className: className,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$$.jsx)(NotchedOutlineLegend, {
      ownerState: ownerState,
      children: withLabel ? /*#__PURE__*/(0, _jsxRuntime$$.jsx)("span", {
        children: label
      }) : // notranslate needed while Google Translate will not fix zero-width space issue
      _span$1 || (_span$1 = /*#__PURE__*/(0, _jsxRuntime$$.jsx)("span", {
        className: "notranslate",
        children: "\u200B"
      }))
    })
  }));
}
process.env.NODE_ENV !== "production" ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes$1a.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$1a.default.object,
  /**
   * @ignore
   */
  className: _propTypes$1a.default.string,
  /**
   * The label.
   */
  label: _propTypes$1a.default.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: _propTypes$1a.default.bool.isRequired,
  /**
   * @ignore
   */
  style: _propTypes$1a.default.object
} : void 0;

var _interopRequireDefault$53 = interopRequireDefault$1.exports;
Object.defineProperty(OutlinedInput$2, "__esModule", {
  value: true
});
OutlinedInput$2.default = void 0;
var _objectWithoutPropertiesLoose2$L = _interopRequireDefault$53(objectWithoutPropertiesLoose.exports);
var _extends2$O = _interopRequireDefault$53(_extends$19.exports);
var React$15 = _interopRequireWildcard$2a(React__default$4);
var _propTypes$19 = _interopRequireDefault$53(propTypes.exports);
var _refType$5 = _interopRequireDefault$53(refType$2);
var _composeClasses$D = _interopRequireDefault$53(composeClasses$2);
var _NotchedOutline = _interopRequireDefault$53(NotchedOutline$1);
var _useFormControl$1 = _interopRequireDefault$53(useFormControl$1);
var _formControlState$1 = _interopRequireDefault$53(formControlState$1);
var _styled$B = _interopRequireWildcard$2a(styled$2);
var _outlinedInputClasses = _interopRequireWildcard$2a(outlinedInputClasses$1);
var _InputBase$1 = _interopRequireWildcard$2a(InputBase$2);
var _DefaultPropsProvider$D = DefaultPropsProvider$5;
var _jsxRuntime$_ = require$$11;
const _excluded$1d = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"];
function _getRequireWildcardCache$1V(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1V = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2a(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1V(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$E = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    notchedOutline: ['notchedOutline'],
    input: ['input']
  };
  const composedClasses = (0, _composeClasses$D.default)(slots, _outlinedInputClasses.getOutlinedInputUtilityClass, classes);
  return (0, _extends2$O.default)({}, classes, composedClasses);
};
const OutlinedInputRoot = (0, _styled$B.default)(_InputBase$1.InputBaseRoot, {
  shouldForwardProp: prop => (0, _styled$B.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiOutlinedInput',
  slot: 'Root',
  overridesResolver: _InputBase$1.rootOverridesResolver
})(({
  theme,
  ownerState
}) => {
  const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return (0, _extends2$O.default)({
    position: 'relative',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    [`&:hover .${_outlinedInputClasses.default.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      [`&:hover .${_outlinedInputClasses.default.notchedOutline}`]: {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
      }
    },
    [`&.${_outlinedInputClasses.default.focused} .${_outlinedInputClasses.default.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette[ownerState.color].main,
      borderWidth: 2
    },
    [`&.${_outlinedInputClasses.default.error} .${_outlinedInputClasses.default.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.error.main
    },
    [`&.${_outlinedInputClasses.default.disabled} .${_outlinedInputClasses.default.notchedOutline}`]: {
      borderColor: (theme.vars || theme).palette.action.disabled
    }
  }, ownerState.startAdornment && {
    paddingLeft: 14
  }, ownerState.endAdornment && {
    paddingRight: 14
  }, ownerState.multiline && (0, _extends2$O.default)({
    padding: '16.5px 14px'
  }, ownerState.size === 'small' && {
    padding: '8.5px 14px'
  }));
});
const NotchedOutlineRoot = (0, _styled$B.default)(_NotchedOutline.default, {
  name: 'MuiOutlinedInput',
  slot: 'NotchedOutline',
  overridesResolver: (props, styles) => styles.notchedOutline
})(({
  theme
}) => {
  const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
  };
});
const OutlinedInputInput = (0, _styled$B.default)(_InputBase$1.InputBaseComponent, {
  name: 'MuiOutlinedInput',
  slot: 'Input',
  overridesResolver: _InputBase$1.inputOverridesResolver
})(({
  theme,
  ownerState
}) => (0, _extends2$O.default)({
  padding: '16.5px 14px'
}, !theme.vars && {
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderRadius: 'inherit'
  }
}, theme.vars && {
  '&:-webkit-autofill': {
    borderRadius: 'inherit'
  },
  [theme.getColorSchemeSelector('dark')]: {
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #266798 inset',
      WebkitTextFillColor: '#fff',
      caretColor: '#fff'
    }
  }
}, ownerState.size === 'small' && {
  padding: '8.5px 14px'
}, ownerState.multiline && {
  padding: 0
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}));
const OutlinedInput$1 = /*#__PURE__*/React$15.forwardRef(function OutlinedInput(inProps, ref) {
  var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
  const props = (0, _DefaultPropsProvider$D.useDefaultProps)({
    props: inProps,
    name: 'MuiOutlinedInput'
  });
  const {
      components = {},
      fullWidth = false,
      inputComponent = 'input',
      label,
      multiline = false,
      notched,
      slots = {},
      type = 'text'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$L.default)(props, _excluded$1d);
  const classes = useUtilityClasses$E(props);
  const muiFormControl = (0, _useFormControl$1.default)();
  const fcs = (0, _formControlState$1.default)({
    props,
    muiFormControl,
    states: ['color', 'disabled', 'error', 'focused', 'hiddenLabel', 'size', 'required']
  });
  const ownerState = (0, _extends2$O.default)({}, props, {
    color: fcs.color || 'primary',
    disabled: fcs.disabled,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    type
  });
  const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : OutlinedInputRoot;
  const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : OutlinedInputInput;
  return /*#__PURE__*/(0, _jsxRuntime$_.jsx)(_InputBase$1.default, (0, _extends2$O.default)({
    slots: {
      root: RootSlot,
      input: InputSlot
    },
    renderSuffix: state => /*#__PURE__*/(0, _jsxRuntime$_.jsx)(NotchedOutlineRoot, {
      ownerState: ownerState,
      className: classes.notchedOutline,
      label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/(0, _jsxRuntime$_.jsxs)(React$15.Fragment, {
        children: [label, "\u2009", '*']
      })) : label,
      notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: (0, _extends2$O.default)({}, classes, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" ? OutlinedInput$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _propTypes$19.default.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: _propTypes$19.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$19.default.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: _propTypes$19.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$19.default.oneOf(['primary', 'secondary']), _propTypes$19.default.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$19.default.shape({
    Input: _propTypes$19.default.elementType,
    Root: _propTypes$19.default.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes$19.default.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: _propTypes$19.default.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: _propTypes$19.default.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: _propTypes$19.default.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$19.default.bool,
  /**
   * The id of the `input` element.
   */
  id: _propTypes$19.default.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: _propTypes$19.default.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: _propTypes$19.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType$5.default,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: _propTypes$19.default.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: _propTypes$19.default.oneOf(['dense', 'none']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _propTypes$19.default.oneOfType([_propTypes$19.default.number, _propTypes$19.default.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: _propTypes$19.default.oneOfType([_propTypes$19.default.number, _propTypes$19.default.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: _propTypes$19.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes$19.default.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: _propTypes$19.default.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes$19.default.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: _propTypes$19.default.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: _propTypes$19.default.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: _propTypes$19.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes$19.default.oneOfType([_propTypes$19.default.number, _propTypes$19.default.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: _propTypes$19.default.shape({
    input: _propTypes$19.default.elementType,
    root: _propTypes$19.default.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: _propTypes$19.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$19.default.oneOfType([_propTypes$19.default.arrayOf(_propTypes$19.default.oneOfType([_propTypes$19.default.func, _propTypes$19.default.object, _propTypes$19.default.bool])), _propTypes$19.default.func, _propTypes$19.default.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: _propTypes$19.default.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _propTypes$19.default.any
} : void 0;
OutlinedInput$1.muiName = 'Input';
OutlinedInput$2.default = OutlinedInput$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  outlinedInputClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _OutlinedInput.default;
  }
});
Object.defineProperty(exports, "outlinedInputClasses", {
  enumerable: true,
  get: function () {
    return _outlinedInputClasses.default;
  }
});
var _OutlinedInput = _interopRequireDefault(OutlinedInput$2);
var _outlinedInputClasses = _interopRequireWildcard(outlinedInputClasses$1);
Object.keys(_outlinedInputClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _outlinedInputClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _outlinedInputClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(OutlinedInput$3));

var OutlinedInput = /*@__PURE__*/getDefaultExportFromCjs$1(OutlinedInput$3);

var Pagination$2 = {};

var Pagination$1 = {};

var paginationClasses$1 = {};

var _interopRequireDefault$52 = interopRequireDefault$1.exports;
Object.defineProperty(paginationClasses$1, "__esModule", {
  value: true
});
paginationClasses$1.default = void 0;
paginationClasses$1.getPaginationUtilityClass = getPaginationUtilityClass;
var _generateUtilityClasses$C = _interopRequireDefault$52(generateUtilityClasses$3);
var _generateUtilityClass$C = _interopRequireDefault$52(generateUtilityClass$3);
function getPaginationUtilityClass(slot) {
  return (0, _generateUtilityClass$C.default)('MuiPagination', slot);
}
const paginationClasses = (0, _generateUtilityClasses$C.default)('MuiPagination', ['root', 'ul', 'outlined', 'text']);
paginationClasses$1.default = paginationClasses;

var usePagination$2 = {};

var usePagination$1 = {};

var _interopRequireDefault$51 = interopRequireDefault$1.exports;
Object.defineProperty(usePagination$1, "__esModule", {
  value: true
});
usePagination$1.default = usePagination;
var _extends2$N = _interopRequireDefault$51(_extends$19.exports);
var _objectWithoutPropertiesLoose2$K = _interopRequireDefault$51(objectWithoutPropertiesLoose.exports);
var _useControlled$4 = _interopRequireDefault$51(useControlled$3);
const _excluded$1c = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function usePagination(props = {}) {
  // keep default values in sync with @default tags in Pagination.propTypes
  const {
      boundaryCount = 1,
      componentName = 'usePagination',
      count = 1,
      defaultPage = 1,
      disabled = false,
      hideNextButton = false,
      hidePrevButton = false,
      onChange: handleChange,
      page: pageProp,
      showFirstButton = false,
      showLastButton = false,
      siblingCount = 1
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$K.default)(props, _excluded$1c);
  const [page, setPageState] = (0, _useControlled$4.default)({
    controlled: pageProp,
    default: defaultPage,
    name: componentName,
    state: 'page'
  });
  const handleClick = (event, value) => {
    if (!pageProp) {
      setPageState(value);
    }
    if (handleChange) {
      handleChange(event, value);
    }
  };

  // https://dev.to/namirsab/comment/2050
  const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({
      length
    }, (_, i) => start + i);
  };
  const startPages = range(1, Math.min(boundaryCount, count));
  const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
  const siblingsStart = Math.max(Math.min(
  // Natural start
  page - siblingCount,
  // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 1),
  // Greater than startPages
  boundaryCount + 2);
  const siblingsEnd = Math.min(Math.max(
  // Natural end
  page + siblingCount,
  // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 2),
  // Less than endPages
  endPages.length > 0 ? endPages[0] - 2 : count - 1);

  // Basic list of items to render
  // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
  const itemList = [...(showFirstButton ? ['first'] : []), ...(hidePrevButton ? [] : ['previous']), ...startPages,
  // Start ellipsis
  // eslint-disable-next-line no-nested-ternary
  ...(siblingsStart > boundaryCount + 2 ? ['start-ellipsis'] : boundaryCount + 1 < count - boundaryCount ? [boundaryCount + 1] : []),
  // Sibling pages
  ...range(siblingsStart, siblingsEnd),
  // End ellipsis
  // eslint-disable-next-line no-nested-ternary
  ...(siblingsEnd < count - boundaryCount - 1 ? ['end-ellipsis'] : count - boundaryCount > boundaryCount ? [count - boundaryCount] : []), ...endPages, ...(hideNextButton ? [] : ['next']), ...(showLastButton ? ['last'] : [])];

  // Map the button type to its page number
  const buttonPage = type => {
    switch (type) {
      case 'first':
        return 1;
      case 'previous':
        return page - 1;
      case 'next':
        return page + 1;
      case 'last':
        return count;
      default:
        return null;
    }
  };

  // Convert the basic item list to PaginationItem props objects
  const items = itemList.map(item => {
    return typeof item === 'number' ? {
      onClick: event => {
        handleClick(event, item);
      },
      type: 'page',
      page: item,
      selected: item === page,
      disabled,
      'aria-current': item === page ? 'true' : undefined
    } : {
      onClick: event => {
        handleClick(event, buttonPage(item));
      },
      type: item,
      page: buttonPage(item),
      selected: false,
      disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
    };
  });
  return (0, _extends2$N.default)({
    items
  }, other);
}

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _usePagination.default;
  }
});
var _usePagination = _interopRequireDefault(usePagination$1);
}(usePagination$2));

var PaginationItem$2 = {};

var PaginationItem$1 = {};

var paginationItemClasses$1 = {};

var _interopRequireDefault$50 = interopRequireDefault$1.exports;
Object.defineProperty(paginationItemClasses$1, "__esModule", {
  value: true
});
paginationItemClasses$1.default = void 0;
paginationItemClasses$1.getPaginationItemUtilityClass = getPaginationItemUtilityClass;
var _generateUtilityClasses$B = _interopRequireDefault$50(generateUtilityClasses$3);
var _generateUtilityClass$B = _interopRequireDefault$50(generateUtilityClass$3);
function getPaginationItemUtilityClass(slot) {
  return (0, _generateUtilityClass$B.default)('MuiPaginationItem', slot);
}
const paginationItemClasses = (0, _generateUtilityClasses$B.default)('MuiPaginationItem', ['root', 'page', 'sizeSmall', 'sizeLarge', 'text', 'textPrimary', 'textSecondary', 'outlined', 'outlinedPrimary', 'outlinedSecondary', 'rounded', 'ellipsis', 'firstLast', 'previousNext', 'focusVisible', 'disabled', 'selected', 'icon', 'colorPrimary', 'colorSecondary']);
paginationItemClasses$1.default = paginationItemClasses;

var FirstPage = {};

var _interopRequireDefault$4$ = interopRequireDefault$1.exports;
Object.defineProperty(FirstPage, "__esModule", {
  value: true
});
FirstPage.default = void 0;
_interopRequireWildcard$29(React__default$4);
var _createSvgIcon$d = _interopRequireDefault$4$(createSvgIcon$2);
var _jsxRuntime$Z = require$$11;
function _getRequireWildcardCache$1U(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1U = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$29(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1U(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
FirstPage.default = (0, _createSvgIcon$d.default)( /*#__PURE__*/(0, _jsxRuntime$Z.jsx)("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

var LastPage = {};

var _interopRequireDefault$4_ = interopRequireDefault$1.exports;
Object.defineProperty(LastPage, "__esModule", {
  value: true
});
LastPage.default = void 0;
_interopRequireWildcard$28(React__default$4);
var _createSvgIcon$c = _interopRequireDefault$4_(createSvgIcon$2);
var _jsxRuntime$Y = require$$11;
function _getRequireWildcardCache$1T(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1T = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$28(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1T(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
LastPage.default = (0, _createSvgIcon$c.default)( /*#__PURE__*/(0, _jsxRuntime$Y.jsx)("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

var NavigateBefore = {};

var _interopRequireDefault$4Z = interopRequireDefault$1.exports;
Object.defineProperty(NavigateBefore, "__esModule", {
  value: true
});
NavigateBefore.default = void 0;
_interopRequireWildcard$27(React__default$4);
var _createSvgIcon$b = _interopRequireDefault$4Z(createSvgIcon$2);
var _jsxRuntime$X = require$$11;
function _getRequireWildcardCache$1S(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1S = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$27(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1S(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
NavigateBefore.default = (0, _createSvgIcon$b.default)( /*#__PURE__*/(0, _jsxRuntime$X.jsx)("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

var NavigateNext = {};

var _interopRequireDefault$4Y = interopRequireDefault$1.exports;
Object.defineProperty(NavigateNext, "__esModule", {
  value: true
});
NavigateNext.default = void 0;
_interopRequireWildcard$26(React__default$4);
var _createSvgIcon$a = _interopRequireDefault$4Y(createSvgIcon$2);
var _jsxRuntime$W = require$$11;
function _getRequireWildcardCache$1R(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1R = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$26(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1R(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
NavigateNext.default = (0, _createSvgIcon$a.default)( /*#__PURE__*/(0, _jsxRuntime$W.jsx)("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

var _interopRequireDefault$4X = interopRequireDefault$1.exports;
Object.defineProperty(PaginationItem$1, "__esModule", {
  value: true
});
PaginationItem$1.default = void 0;
var _objectWithoutPropertiesLoose2$J = _interopRequireDefault$4X(objectWithoutPropertiesLoose.exports);
var _extends2$M = _interopRequireDefault$4X(_extends$19.exports);
var React$14 = _interopRequireWildcard$25(React__default$4);
var _propTypes$18 = _interopRequireDefault$4X(propTypes.exports);
var _clsx$1d = _interopRequireDefault$4X(clsx.exports);
var _composeClasses$C = _interopRequireDefault$4X(composeClasses$2);
var _colorManipulator$8 = colorManipulator;
var _RtlProvider$6 = RtlProvider$1;
var _DefaultPropsProvider$C = DefaultPropsProvider$5;
var _paginationItemClasses = _interopRequireWildcard$25(paginationItemClasses$1);
var _ButtonBase$5 = _interopRequireDefault$4X(ButtonBase$2);
var _capitalize$f = _interopRequireDefault$4X(capitalize$1);
var _FirstPage$1 = _interopRequireDefault$4X(FirstPage);
var _LastPage$1 = _interopRequireDefault$4X(LastPage);
var _NavigateBefore = _interopRequireDefault$4X(NavigateBefore);
var _NavigateNext = _interopRequireDefault$4X(NavigateNext);
var _styled$A = _interopRequireDefault$4X(styled$2);
var _jsxRuntime$V = require$$11;
const _excluded$1b = ["className", "color", "component", "components", "disabled", "page", "selected", "shape", "size", "slots", "type", "variant"];
function _getRequireWildcardCache$1Q(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1Q = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$25(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1Q(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, styles[ownerState.variant], styles[`size${(0, _capitalize$f.default)(ownerState.size)}`], ownerState.variant === 'text' && styles[`text${(0, _capitalize$f.default)(ownerState.color)}`], ownerState.variant === 'outlined' && styles[`outlined${(0, _capitalize$f.default)(ownerState.color)}`], ownerState.shape === 'rounded' && styles.rounded, ownerState.type === 'page' && styles.page, (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis, (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext, (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast];
};
const useUtilityClasses$D = ownerState => {
  const {
    classes,
    color,
    disabled,
    selected,
    size,
    shape,
    type,
    variant
  } = ownerState;
  const slots = {
    root: ['root', `size${(0, _capitalize$f.default)(size)}`, variant, shape, color !== 'standard' && `color${(0, _capitalize$f.default)(color)}`, color !== 'standard' && `${variant}${(0, _capitalize$f.default)(color)}`, disabled && 'disabled', selected && 'selected', {
      page: 'page',
      first: 'firstLast',
      last: 'firstLast',
      'start-ellipsis': 'ellipsis',
      'end-ellipsis': 'ellipsis',
      previous: 'previousNext',
      next: 'previousNext'
    }[type]],
    icon: ['icon']
  };
  return (0, _composeClasses$C.default)(slots, _paginationItemClasses.getPaginationItemUtilityClass, classes);
};
const PaginationItemEllipsis = (0, _styled$A.default)('div', {
  name: 'MuiPaginationItem',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0, _extends2$M.default)({}, theme.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: 'center',
  boxSizing: 'border-box',
  minWidth: 32,
  padding: '0 6px',
  margin: '0 3px',
  color: (theme.vars || theme).palette.text.primary,
  height: 'auto',
  [`&.${_paginationItemClasses.default.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }
}, ownerState.size === 'small' && {
  minWidth: 26,
  borderRadius: 26 / 2,
  margin: '0 1px',
  padding: '0 4px'
}, ownerState.size === 'large' && {
  minWidth: 40,
  borderRadius: 40 / 2,
  padding: '0 10px',
  fontSize: theme.typography.pxToRem(15)
}));
const PaginationItemPage = (0, _styled$A.default)(_ButtonBase$5.default, {
  name: 'MuiPaginationItem',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0, _extends2$M.default)({}, theme.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: 'center',
  boxSizing: 'border-box',
  minWidth: 32,
  height: 32,
  padding: '0 6px',
  margin: '0 3px',
  color: (theme.vars || theme).palette.text.primary,
  [`&.${_paginationItemClasses.default.focusVisible}`]: {
    backgroundColor: (theme.vars || theme).palette.action.focus
  },
  [`&.${_paginationItemClasses.default.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  },
  transition: theme.transitions.create(['color', 'background-color'], {
    duration: theme.transitions.duration.short
  }),
  '&:hover': {
    backgroundColor: (theme.vars || theme).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${_paginationItemClasses.default.selected}`]: {
    backgroundColor: (theme.vars || theme).palette.action.selected,
    '&:hover': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator$8.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: (theme.vars || theme).palette.action.selected
      }
    },
    [`&.${_paginationItemClasses.default.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator$8.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    },
    [`&.${_paginationItemClasses.default.disabled}`]: {
      opacity: 1,
      color: (theme.vars || theme).palette.action.disabled,
      backgroundColor: (theme.vars || theme).palette.action.selected
    }
  }
}, ownerState.size === 'small' && {
  minWidth: 26,
  height: 26,
  borderRadius: 26 / 2,
  margin: '0 1px',
  padding: '0 4px'
}, ownerState.size === 'large' && {
  minWidth: 40,
  height: 40,
  borderRadius: 40 / 2,
  padding: '0 10px',
  fontSize: theme.typography.pxToRem(15)
}, ownerState.shape === 'rounded' && {
  borderRadius: (theme.vars || theme).shape.borderRadius
}), ({
  theme,
  ownerState
}) => (0, _extends2$M.default)({}, ownerState.variant === 'text' && {
  [`&.${_paginationItemClasses.default.selected}`]: (0, _extends2$M.default)({}, ownerState.color !== 'standard' && {
    color: (theme.vars || theme).palette[ownerState.color].contrastText,
    backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
    '&:hover': {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
      }
    },
    [`&.${_paginationItemClasses.default.focusVisible}`]: {
      backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
    }
  }, {
    [`&.${_paginationItemClasses.default.disabled}`]: {
      color: (theme.vars || theme).palette.action.disabled
    }
  })
}, ownerState.variant === 'outlined' && {
  border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
  [`&.${_paginationItemClasses.default.selected}`]: (0, _extends2$M.default)({}, ownerState.color !== 'standard' && {
    color: (theme.vars || theme).palette[ownerState.color].main,
    border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, _colorManipulator$8.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, _colorManipulator$8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
    '&:hover': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator$8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    [`&.${_paginationItemClasses.default.focusVisible}`]: {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator$8.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
    }
  }, {
    [`&.${_paginationItemClasses.default.disabled}`]: {
      borderColor: (theme.vars || theme).palette.action.disabledBackground,
      color: (theme.vars || theme).palette.action.disabled
    }
  })
}));
const PaginationItemPageIcon = (0, _styled$A.default)('div', {
  name: 'MuiPaginationItem',
  slot: 'Icon',
  overridesResolver: (props, styles) => styles.icon
})(({
  theme,
  ownerState
}) => (0, _extends2$M.default)({
  fontSize: theme.typography.pxToRem(20),
  margin: '0 -8px'
}, ownerState.size === 'small' && {
  fontSize: theme.typography.pxToRem(18)
}, ownerState.size === 'large' && {
  fontSize: theme.typography.pxToRem(22)
}));
const PaginationItem = /*#__PURE__*/React$14.forwardRef(function PaginationItem(inProps, ref) {
  const props = (0, _DefaultPropsProvider$C.useDefaultProps)({
    props: inProps,
    name: 'MuiPaginationItem'
  });
  const {
      className,
      color = 'standard',
      component,
      components = {},
      disabled = false,
      page,
      selected = false,
      shape = 'circular',
      size = 'medium',
      slots = {},
      type = 'page',
      variant = 'text'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$J.default)(props, _excluded$1b);
  const ownerState = (0, _extends2$M.default)({}, props, {
    color,
    disabled,
    selected,
    shape,
    size,
    type,
    variant
  });
  const isRtl = (0, _RtlProvider$6.useRtl)();
  const classes = useUtilityClasses$D(ownerState);
  const normalizedIcons = isRtl ? {
    previous: slots.next || components.next || _NavigateNext.default,
    next: slots.previous || components.previous || _NavigateBefore.default,
    last: slots.first || components.first || _FirstPage$1.default,
    first: slots.last || components.last || _LastPage$1.default
  } : {
    previous: slots.previous || components.previous || _NavigateBefore.default,
    next: slots.next || components.next || _NavigateNext.default,
    first: slots.first || components.first || _FirstPage$1.default,
    last: slots.last || components.last || _LastPage$1.default
  };
  const Icon = normalizedIcons[type];
  return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/(0, _jsxRuntime$V.jsx)(PaginationItemEllipsis, {
    ref: ref,
    ownerState: ownerState,
    className: (0, _clsx$1d.default)(classes.root, className),
    children: "\u2026"
  }) : /*#__PURE__*/(0, _jsxRuntime$V.jsxs)(PaginationItemPage, (0, _extends2$M.default)({
    ref: ref,
    ownerState: ownerState,
    component: component,
    disabled: disabled,
    className: (0, _clsx$1d.default)(classes.root, className)
  }, other, {
    children: [type === 'page' && page, Icon ? /*#__PURE__*/(0, _jsxRuntime$V.jsx)(PaginationItemPageIcon, {
      as: Icon,
      ownerState: ownerState,
      className: classes.icon
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? PaginationItem.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: _propTypes$18.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$18.default.object,
  /**
   * @ignore
   */
  className: _propTypes$18.default.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: _propTypes$18.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$18.default.oneOf(['primary', 'secondary', 'standard']), _propTypes$18.default.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$18.default.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$18.default.shape({
    first: _propTypes$18.default.elementType,
    last: _propTypes$18.default.elementType,
    next: _propTypes$18.default.elementType,
    previous: _propTypes$18.default.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$18.default.bool,
  /**
   * The current page number.
   */
  page: _propTypes$18.default.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: _propTypes$18.default.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: _propTypes$18.default.oneOf(['circular', 'rounded']),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: _propTypes$18.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$18.default.oneOf(['small', 'medium', 'large']), _propTypes$18.default.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: _propTypes$18.default.shape({
    first: _propTypes$18.default.elementType,
    last: _propTypes$18.default.elementType,
    next: _propTypes$18.default.elementType,
    previous: _propTypes$18.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$18.default.oneOfType([_propTypes$18.default.arrayOf(_propTypes$18.default.oneOfType([_propTypes$18.default.func, _propTypes$18.default.object, _propTypes$18.default.bool])), _propTypes$18.default.func, _propTypes$18.default.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: _propTypes$18.default.oneOf(['end-ellipsis', 'first', 'last', 'next', 'page', 'previous', 'start-ellipsis']),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: _propTypes$18.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$18.default.oneOf(['outlined', 'text']), _propTypes$18.default.string])
} : void 0;
PaginationItem$1.default = PaginationItem;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  paginationItemClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _PaginationItem.default;
  }
});
Object.defineProperty(exports, "paginationItemClasses", {
  enumerable: true,
  get: function () {
    return _paginationItemClasses.default;
  }
});
var _PaginationItem = _interopRequireDefault(PaginationItem$1);
var _paginationItemClasses = _interopRequireWildcard(paginationItemClasses$1);
Object.keys(_paginationItemClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _paginationItemClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _paginationItemClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(PaginationItem$2));

var _interopRequireDefault$4W = interopRequireDefault$1.exports;
Object.defineProperty(Pagination$1, "__esModule", {
  value: true
});
Pagination$1.default = void 0;
var _extends2$L = _interopRequireDefault$4W(_extends$19.exports);
var _objectWithoutPropertiesLoose2$I = _interopRequireDefault$4W(objectWithoutPropertiesLoose.exports);
var React$13 = _interopRequireWildcard$24(React__default$4);
var _propTypes$17 = _interopRequireDefault$4W(propTypes.exports);
var _clsx$1c = _interopRequireDefault$4W(clsx.exports);
var _composeClasses$B = _interopRequireDefault$4W(composeClasses$2);
var _integerPropType$3 = _interopRequireDefault$4W(integerPropType$1);
var _DefaultPropsProvider$B = DefaultPropsProvider$5;
var _paginationClasses = paginationClasses$1;
var _usePagination = _interopRequireDefault$4W(usePagination$2);
var _PaginationItem = _interopRequireDefault$4W(PaginationItem$2);
var _styled$z = _interopRequireDefault$4W(styled$2);
var _jsxRuntime$U = require$$11;
const _excluded$1a = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"];
function _getRequireWildcardCache$1P(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1P = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$24(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1P(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$C = ownerState => {
  const {
    classes,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant],
    ul: ['ul']
  };
  return (0, _composeClasses$B.default)(slots, _paginationClasses.getPaginationUtilityClass, classes);
};
const PaginationRoot = (0, _styled$z.default)('nav', {
  name: 'MuiPagination',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant]];
  }
})({});
const PaginationUl = (0, _styled$z.default)('ul', {
  name: 'MuiPagination',
  slot: 'Ul',
  overridesResolver: (props, styles) => styles.ul
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});
function defaultGetAriaLabel$1(type, page, selected) {
  if (type === 'page') {
    return `${selected ? '' : 'Go to '}page ${page}`;
  }
  return `Go to ${type} page`;
}
const Pagination = /*#__PURE__*/React$13.forwardRef(function Pagination(inProps, ref) {
  const props = (0, _DefaultPropsProvider$B.useDefaultProps)({
    props: inProps,
    name: 'MuiPagination'
  });
  const {
      boundaryCount = 1,
      className,
      color = 'standard',
      count = 1,
      defaultPage = 1,
      disabled = false,
      getItemAriaLabel = defaultGetAriaLabel$1,
      hideNextButton = false,
      hidePrevButton = false,
      renderItem = item => /*#__PURE__*/(0, _jsxRuntime$U.jsx)(_PaginationItem.default, (0, _extends2$L.default)({}, item)),
      shape = 'circular',
      showFirstButton = false,
      showLastButton = false,
      siblingCount = 1,
      size = 'medium',
      variant = 'text'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$I.default)(props, _excluded$1a);
  const {
    items
  } = (0, _usePagination.default)((0, _extends2$L.default)({}, props, {
    componentName: 'Pagination'
  }));
  const ownerState = (0, _extends2$L.default)({}, props, {
    boundaryCount,
    color,
    count,
    defaultPage,
    disabled,
    getItemAriaLabel,
    hideNextButton,
    hidePrevButton,
    renderItem,
    shape,
    showFirstButton,
    showLastButton,
    siblingCount,
    size,
    variant
  });
  const classes = useUtilityClasses$C(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$U.jsx)(PaginationRoot, (0, _extends2$L.default)({
    "aria-label": "pagination navigation",
    className: (0, _clsx$1c.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$U.jsx)(PaginationUl, {
      className: classes.ul,
      ownerState: ownerState,
      children: items.map((item, index) => /*#__PURE__*/(0, _jsxRuntime$U.jsx)("li", {
        children: renderItem((0, _extends2$L.default)({}, item, {
          color,
          'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
          shape,
          size,
          variant
        }))
      }, index))
    })
  }));
});

// @default tags synced with default values from usePagination

process.env.NODE_ENV !== "production" ? Pagination.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: _integerPropType$3.default,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$17.default.object,
  /**
   * @ignore
   */
  className: _propTypes$17.default.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: _propTypes$17.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$17.default.oneOf(['primary', 'secondary', 'standard']), _propTypes$17.default.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: _integerPropType$3.default,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: _integerPropType$3.default,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$17.default.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: _propTypes$17.default.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: _propTypes$17.default.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: _propTypes$17.default.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: _propTypes$17.default.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: _integerPropType$3.default,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: _propTypes$17.default.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: _propTypes$17.default.oneOf(['circular', 'rounded']),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: _propTypes$17.default.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: _propTypes$17.default.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: _integerPropType$3.default,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: _propTypes$17.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$17.default.oneOf(['small', 'medium', 'large']), _propTypes$17.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$17.default.oneOfType([_propTypes$17.default.arrayOf(_propTypes$17.default.oneOfType([_propTypes$17.default.func, _propTypes$17.default.object, _propTypes$17.default.bool])), _propTypes$17.default.func, _propTypes$17.default.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: _propTypes$17.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$17.default.oneOf(['outlined', 'text']), _propTypes$17.default.string])
} : void 0;
Pagination$1.default = Pagination;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  paginationClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Pagination.default;
  }
});
Object.defineProperty(exports, "paginationClasses", {
  enumerable: true,
  get: function () {
    return _paginationClasses.default;
  }
});
var _Pagination = _interopRequireDefault(Pagination$1);
var _paginationClasses = _interopRequireWildcard(paginationClasses$1);
Object.keys(_paginationClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _paginationClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _paginationClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Pagination$2));

var Radio$2 = {};

var Radio$1 = {};

var RadioButtonIcon$1 = {};

var RadioButtonUnchecked = {};

var _interopRequireDefault$4V = interopRequireDefault$1.exports;
Object.defineProperty(RadioButtonUnchecked, "__esModule", {
  value: true
});
RadioButtonUnchecked.default = void 0;
_interopRequireWildcard$23(React__default$4);
var _createSvgIcon$9 = _interopRequireDefault$4V(createSvgIcon$2);
var _jsxRuntime$T = require$$11;
function _getRequireWildcardCache$1O(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1O = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$23(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1O(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
RadioButtonUnchecked.default = (0, _createSvgIcon$9.default)( /*#__PURE__*/(0, _jsxRuntime$T.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

var RadioButtonChecked = {};

var _interopRequireDefault$4U = interopRequireDefault$1.exports;
Object.defineProperty(RadioButtonChecked, "__esModule", {
  value: true
});
RadioButtonChecked.default = void 0;
_interopRequireWildcard$22(React__default$4);
var _createSvgIcon$8 = _interopRequireDefault$4U(createSvgIcon$2);
var _jsxRuntime$S = require$$11;
function _getRequireWildcardCache$1N(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1N = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$22(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1N(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
RadioButtonChecked.default = (0, _createSvgIcon$8.default)( /*#__PURE__*/(0, _jsxRuntime$S.jsx)("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

var _interopRequireDefault$4T = interopRequireDefault$1.exports;
Object.defineProperty(RadioButtonIcon$1, "__esModule", {
  value: true
});
RadioButtonIcon$1.default = void 0;
var _extends2$K = _interopRequireDefault$4T(_extends$19.exports);
_interopRequireWildcard$21(React__default$4);
var _propTypes$16 = _interopRequireDefault$4T(propTypes.exports);
var _RadioButtonUnchecked = _interopRequireDefault$4T(RadioButtonUnchecked);
var _RadioButtonChecked = _interopRequireDefault$4T(RadioButtonChecked);
var _styled$y = _interopRequireWildcard$21(styled$2);
var _jsxRuntime$R = require$$11;
function _getRequireWildcardCache$1M(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1M = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$21(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1M(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RadioButtonIconRoot = (0, _styled$y.default)('span', {
  shouldForwardProp: _styled$y.rootShouldForwardProp
})({
  position: 'relative',
  display: 'flex'
});
const RadioButtonIconBackground = (0, _styled$y.default)(_RadioButtonUnchecked.default)({
  // Scale applied to prevent dot misalignment in Safari
  transform: 'scale(1)'
});
const RadioButtonIconDot = (0, _styled$y.default)(_RadioButtonChecked.default)(({
  theme,
  ownerState
}) => (0, _extends2$K.default)({
  left: 0,
  position: 'absolute',
  transform: 'scale(0)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.shortest
  })
}, ownerState.checked && {
  transform: 'scale(1)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.shortest
  })
}));

/**
 * @ignore - internal component.
 */
function RadioButtonIcon(props) {
  const {
    checked = false,
    classes = {},
    fontSize
  } = props;
  const ownerState = (0, _extends2$K.default)({}, props, {
    checked
  });
  return /*#__PURE__*/(0, _jsxRuntime$R.jsxs)(RadioButtonIconRoot, {
    className: classes.root,
    ownerState: ownerState,
    children: [/*#__PURE__*/(0, _jsxRuntime$R.jsx)(RadioButtonIconBackground, {
      fontSize: fontSize,
      className: classes.background,
      ownerState: ownerState
    }), /*#__PURE__*/(0, _jsxRuntime$R.jsx)(RadioButtonIconDot, {
      fontSize: fontSize,
      className: classes.dot,
      ownerState: ownerState
    })]
  });
}
process.env.NODE_ENV !== "production" ? RadioButtonIcon.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes$16.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$16.default.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: _propTypes$16.default.oneOf(['small', 'medium'])
} : void 0;
RadioButtonIcon$1.default = RadioButtonIcon;

var useRadioGroup$1 = {};

var RadioGroupContext$1 = {};

Object.defineProperty(RadioGroupContext$1, "__esModule", {
  value: true
});
RadioGroupContext$1.default = void 0;
var React$12 = _interopRequireWildcard$20(React__default$4);
function _getRequireWildcardCache$1L(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1L = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$20(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1L(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const RadioGroupContext = /*#__PURE__*/React$12.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  RadioGroupContext.displayName = 'RadioGroupContext';
}
RadioGroupContext$1.default = RadioGroupContext;

var _interopRequireDefault$4S = interopRequireDefault$1.exports;
Object.defineProperty(useRadioGroup$1, "__esModule", {
  value: true
});
useRadioGroup$1.default = useRadioGroup;
var React$11 = _interopRequireWildcard$1$(React__default$4);
var _RadioGroupContext$1 = _interopRequireDefault$4S(RadioGroupContext$1);
function _getRequireWildcardCache$1K(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1K = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1$(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1K(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function useRadioGroup() {
  return React$11.useContext(_RadioGroupContext$1.default);
}

var radioClasses$1 = {};

var _interopRequireDefault$4R = interopRequireDefault$1.exports;
Object.defineProperty(radioClasses$1, "__esModule", {
  value: true
});
radioClasses$1.default = void 0;
radioClasses$1.getRadioUtilityClass = getRadioUtilityClass;
var _generateUtilityClasses$A = _interopRequireDefault$4R(generateUtilityClasses$3);
var _generateUtilityClass$A = _interopRequireDefault$4R(generateUtilityClass$3);
function getRadioUtilityClass(slot) {
  return (0, _generateUtilityClass$A.default)('MuiRadio', slot);
}
const radioClasses = (0, _generateUtilityClasses$A.default)('MuiRadio', ['root', 'checked', 'disabled', 'colorPrimary', 'colorSecondary', 'sizeSmall']);
radioClasses$1.default = radioClasses;

var _interopRequireDefault$4Q = interopRequireDefault$1.exports;
Object.defineProperty(Radio$1, "__esModule", {
  value: true
});
Radio$1.default = void 0;
var _objectWithoutPropertiesLoose2$H = _interopRequireDefault$4Q(objectWithoutPropertiesLoose.exports);
var _extends2$J = _interopRequireDefault$4Q(_extends$19.exports);
var React$10 = _interopRequireWildcard$1_(React__default$4);
var _propTypes$15 = _interopRequireDefault$4Q(propTypes.exports);
var _clsx$1b = _interopRequireDefault$4Q(clsx.exports);
var _refType$4 = _interopRequireDefault$4Q(refType$2);
var _composeClasses$A = _interopRequireDefault$4Q(composeClasses$2);
var _colorManipulator$7 = colorManipulator;
var _SwitchBase$1 = _interopRequireDefault$4Q(SwitchBase$1);
var _DefaultPropsProvider$A = DefaultPropsProvider$5;
var _RadioButtonIcon = _interopRequireDefault$4Q(RadioButtonIcon$1);
var _capitalize$e = _interopRequireDefault$4Q(capitalize$1);
var _createChainedFunction = _interopRequireDefault$4Q(createChainedFunction);
var _useRadioGroup = _interopRequireDefault$4Q(useRadioGroup$1);
var _radioClasses = _interopRequireWildcard$1_(radioClasses$1);
var _styled$x = _interopRequireWildcard$1_(styled$2);
var _jsxRuntime$Q = require$$11;
const _excluded$19 = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"];
function _getRequireWildcardCache$1J(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1J = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1_(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1J(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$B = ownerState => {
  const {
    classes,
    color,
    size
  } = ownerState;
  const slots = {
    root: ['root', `color${(0, _capitalize$e.default)(color)}`, size !== 'medium' && `size${(0, _capitalize$e.default)(size)}`]
  };
  return (0, _extends2$J.default)({}, classes, (0, _composeClasses$A.default)(slots, _radioClasses.getRadioUtilityClass, classes));
};
const RadioRoot = (0, _styled$x.default)(_SwitchBase$1.default, {
  shouldForwardProp: prop => (0, _styled$x.rootShouldForwardProp)(prop) || prop === 'classes',
  name: 'MuiRadio',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.size !== 'medium' && styles[`size${(0, _capitalize$e.default)(ownerState.size)}`], styles[`color${(0, _capitalize$e.default)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$J.default)({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$7.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${_radioClasses.default.checked}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  }
}, {
  [`&.${_radioClasses.default.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));
function areEqualValues$1(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(a) === String(b);
}
const defaultCheckedIcon = /*#__PURE__*/(0, _jsxRuntime$Q.jsx)(_RadioButtonIcon.default, {
  checked: true
});
const defaultIcon$1 = /*#__PURE__*/(0, _jsxRuntime$Q.jsx)(_RadioButtonIcon.default, {});
const Radio = /*#__PURE__*/React$10.forwardRef(function Radio(inProps, ref) {
  var _defaultIcon$props$fo, _defaultCheckedIcon$p;
  const props = (0, _DefaultPropsProvider$A.useDefaultProps)({
    props: inProps,
    name: 'MuiRadio'
  });
  const {
      checked: checkedProp,
      checkedIcon = defaultCheckedIcon,
      color = 'primary',
      icon = defaultIcon$1,
      name: nameProp,
      onChange: onChangeProp,
      size = 'medium',
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$H.default)(props, _excluded$19);
  const ownerState = (0, _extends2$J.default)({}, props, {
    color,
    size
  });
  const classes = useUtilityClasses$B(ownerState);
  const radioGroup = (0, _useRadioGroup.default)();
  let checked = checkedProp;
  const onChange = (0, _createChainedFunction.default)(onChangeProp, radioGroup && radioGroup.onChange);
  let name = nameProp;
  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = areEqualValues$1(radioGroup.value, props.value);
    }
    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime$Q.jsx)(RadioRoot, (0, _extends2$J.default)({
    type: "radio",
    icon: /*#__PURE__*/React$10.cloneElement(icon, {
      fontSize: (_defaultIcon$props$fo = defaultIcon$1.props.fontSize) != null ? _defaultIcon$props$fo : size
    }),
    checkedIcon: /*#__PURE__*/React$10.cloneElement(checkedIcon, {
      fontSize: (_defaultCheckedIcon$p = defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
    }),
    ownerState: ownerState,
    classes: classes,
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref,
    className: (0, _clsx$1b.default)(classes.root, className)
  }, other));
});
process.env.NODE_ENV !== "production" ? Radio.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes$15.default.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: _propTypes$15.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$15.default.object,
  /**
   * @ignore
   */
  className: _propTypes$15.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$15.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$15.default.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$15.default.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: _propTypes$15.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: _propTypes$15.default.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: _propTypes$15.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes$15.default.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _propTypes$15.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType$4.default,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes$15.default.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: _propTypes$15.default.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: _propTypes$15.default.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: _propTypes$15.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$15.default.oneOf(['medium', 'small']), _propTypes$15.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$15.default.oneOfType([_propTypes$15.default.arrayOf(_propTypes$15.default.oneOfType([_propTypes$15.default.func, _propTypes$15.default.object, _propTypes$15.default.bool])), _propTypes$15.default.func, _propTypes$15.default.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: _propTypes$15.default.any
} : void 0;
Radio$1.default = Radio;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  radioClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Radio.default;
  }
});
Object.defineProperty(exports, "radioClasses", {
  enumerable: true,
  get: function () {
    return _radioClasses.default;
  }
});
var _Radio = _interopRequireDefault(Radio$1);
var _radioClasses = _interopRequireWildcard(radioClasses$1);
Object.keys(_radioClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _radioClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _radioClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Radio$2));

var RadioGroup$2 = {};

var RadioGroup$1 = {};

var radioGroupClasses$1 = {};

var _interopRequireDefault$4P = interopRequireDefault$1.exports;
Object.defineProperty(radioGroupClasses$1, "__esModule", {
  value: true
});
radioGroupClasses$1.default = void 0;
radioGroupClasses$1.getRadioGroupUtilityClass = getRadioGroupUtilityClass;
var _generateUtilityClasses$z = _interopRequireDefault$4P(generateUtilityClasses$3);
var _generateUtilityClass$z = _interopRequireDefault$4P(generateUtilityClass$3);
function getRadioGroupUtilityClass(slot) {
  return (0, _generateUtilityClass$z.default)('MuiRadioGroup', slot);
}
const radioGroupClasses = (0, _generateUtilityClasses$z.default)('MuiRadioGroup', ['root', 'row', 'error']);
radioGroupClasses$1.default = radioGroupClasses;

var _interopRequireDefault$4O = interopRequireDefault$1.exports;
Object.defineProperty(RadioGroup$1, "__esModule", {
  value: true
});
RadioGroup$1.default = void 0;
var _extends2$I = _interopRequireDefault$4O(_extends$19.exports);
var _objectWithoutPropertiesLoose2$G = _interopRequireDefault$4O(objectWithoutPropertiesLoose.exports);
var React$$ = _interopRequireWildcard$1Z(React__default$4);
var _propTypes$14 = _interopRequireDefault$4O(propTypes.exports);
var _clsx$1a = _interopRequireDefault$4O(clsx.exports);
var _composeClasses$z = _interopRequireDefault$4O(composeClasses$2);
var _FormGroup = _interopRequireDefault$4O(FormGroup$2);
var _radioGroupClasses = radioGroupClasses$1;
var _useForkRef$6 = _interopRequireDefault$4O(useForkRef);
var _useControlled$3 = _interopRequireDefault$4O(useControlled);
var _RadioGroupContext = _interopRequireDefault$4O(RadioGroupContext$1);
var _useId$4 = _interopRequireDefault$4O(useId);
var _jsxRuntime$P = require$$11;
const _excluded$18 = ["actions", "children", "className", "defaultValue", "name", "onChange", "value"];
function _getRequireWildcardCache$1I(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1I = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1Z(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1I(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$A = props => {
  const {
    classes,
    row,
    error
  } = props;
  const slots = {
    root: ['root', row && 'row', error && 'error']
  };
  return (0, _composeClasses$z.default)(slots, _radioGroupClasses.getRadioGroupUtilityClass, classes);
};
const RadioGroup = /*#__PURE__*/React$$.forwardRef(function RadioGroup(props, ref) {
  const {
      // private
      // eslint-disable-next-line react/prop-types
      actions,
      children,
      className,
      defaultValue,
      name: nameProp,
      onChange,
      value: valueProp
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$G.default)(props, _excluded$18);
  const rootRef = React$$.useRef(null);
  const classes = useUtilityClasses$A(props);
  const [value, setValueState] = (0, _useControlled$3.default)({
    controlled: valueProp,
    default: defaultValue,
    name: 'RadioGroup'
  });
  React$$.useImperativeHandle(actions, () => ({
    focus: () => {
      let input = rootRef.current.querySelector('input:not(:disabled):checked');
      if (!input) {
        input = rootRef.current.querySelector('input:not(:disabled)');
      }
      if (input) {
        input.focus();
      }
    }
  }), []);
  const handleRef = (0, _useForkRef$6.default)(ref, rootRef);
  const name = (0, _useId$4.default)(nameProp);
  const contextValue = React$$.useMemo(() => ({
    name,
    onChange(event) {
      setValueState(event.target.value);
      if (onChange) {
        onChange(event, event.target.value);
      }
    },
    value
  }), [name, onChange, setValueState, value]);
  return /*#__PURE__*/(0, _jsxRuntime$P.jsx)(_RadioGroupContext.default.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0, _jsxRuntime$P.jsx)(_FormGroup.default, (0, _extends2$I.default)({
      role: "radiogroup",
      ref: handleRef,
      className: (0, _clsx$1a.default)(classes.root, className)
    }, other, {
      children: children
    }))
  });
});
process.env.NODE_ENV !== "production" ? RadioGroup.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$14.default.node,
  /**
   * @ignore
   */
  className: _propTypes$14.default.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes$14.default.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: _propTypes$14.default.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes$14.default.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: _propTypes$14.default.any
} : void 0;
RadioGroup$1.default = RadioGroup;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useRadioGroup: true,
  radioGroupClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _RadioGroup.default;
  }
});
Object.defineProperty(exports, "radioGroupClasses", {
  enumerable: true,
  get: function () {
    return _radioGroupClasses.default;
  }
});
Object.defineProperty(exports, "useRadioGroup", {
  enumerable: true,
  get: function () {
    return _useRadioGroup.default;
  }
});
var _RadioGroup = _interopRequireDefault(RadioGroup$1);
var _useRadioGroup = _interopRequireDefault(useRadioGroup$1);
var _radioGroupClasses = _interopRequireWildcard(radioGroupClasses$1);
Object.keys(_radioGroupClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _radioGroupClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _radioGroupClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(RadioGroup$2));

var Rating$3 = {};

var Rating$2 = {};

var Star = {};

var _interopRequireDefault$4N = interopRequireDefault$1.exports;
Object.defineProperty(Star, "__esModule", {
  value: true
});
Star.default = void 0;
_interopRequireWildcard$1Y(React__default$4);
var _createSvgIcon$7 = _interopRequireDefault$4N(createSvgIcon$2);
var _jsxRuntime$O = require$$11;
function _getRequireWildcardCache$1H(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1H = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1Y(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1H(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
Star.default = (0, _createSvgIcon$7.default)( /*#__PURE__*/(0, _jsxRuntime$O.jsx)("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

var StarBorder = {};

var _interopRequireDefault$4M = interopRequireDefault$1.exports;
Object.defineProperty(StarBorder, "__esModule", {
  value: true
});
StarBorder.default = void 0;
_interopRequireWildcard$1X(React__default$4);
var _createSvgIcon$6 = _interopRequireDefault$4M(createSvgIcon$2);
var _jsxRuntime$N = require$$11;
function _getRequireWildcardCache$1G(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1G = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1X(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1G(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
StarBorder.default = (0, _createSvgIcon$6.default)( /*#__PURE__*/(0, _jsxRuntime$N.jsx)("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarBorder');

var ratingClasses$1 = {};

var _interopRequireDefault$4L = interopRequireDefault$1.exports;
Object.defineProperty(ratingClasses$1, "__esModule", {
  value: true
});
ratingClasses$1.default = void 0;
ratingClasses$1.getRatingUtilityClass = getRatingUtilityClass;
var _generateUtilityClasses$y = _interopRequireDefault$4L(generateUtilityClasses$3);
var _generateUtilityClass$y = _interopRequireDefault$4L(generateUtilityClass$3);
function getRatingUtilityClass(slot) {
  return (0, _generateUtilityClass$y.default)('MuiRating', slot);
}
const ratingClasses = (0, _generateUtilityClasses$y.default)('MuiRating', ['root', 'sizeSmall', 'sizeMedium', 'sizeLarge', 'readOnly', 'disabled', 'focusVisible', 'visuallyHidden', 'pristine', 'label', 'labelEmptyValueActive', 'icon', 'iconEmpty', 'iconFilled', 'iconHover', 'iconFocus', 'iconActive', 'decimal']);
ratingClasses$1.default = ratingClasses;

var _interopRequireDefault$4K = interopRequireDefault$1.exports;
Object.defineProperty(Rating$2, "__esModule", {
  value: true
});
Rating$2.default = void 0;
var _objectWithoutPropertiesLoose2$F = _interopRequireDefault$4K(objectWithoutPropertiesLoose.exports);
var _extends2$H = _interopRequireDefault$4K(_extends$19.exports);
var React$_ = _interopRequireWildcard$1W(React__default$4);
var _propTypes$13 = _interopRequireDefault$4K(propTypes.exports);
var _clsx$19 = _interopRequireDefault$4K(clsx.exports);
var _clamp$1 = _interopRequireDefault$4K(clamp$5);
var _visuallyHidden = _interopRequireDefault$4K(visuallyHidden$2);
var _chainPropTypes$2 = _interopRequireDefault$4K(chainPropTypes$2);
var _composeClasses$y = _interopRequireDefault$4K(composeClasses$2);
var _RtlProvider$5 = RtlProvider$1;
var _utils$E = utils$6;
var _Star = _interopRequireDefault$4K(Star);
var _StarBorder = _interopRequireDefault$4K(StarBorder);
var _DefaultPropsProvider$z = DefaultPropsProvider$5;
var _styled$w = _interopRequireWildcard$1W(styled$2);
var _ratingClasses = _interopRequireWildcard$1W(ratingClasses$1);
var _jsxRuntime$M = require$$11;
const _excluded$17 = ["value"],
  _excluded2$g = ["className", "defaultValue", "disabled", "emptyIcon", "emptyLabelText", "getLabelText", "highlightSelectedOnly", "icon", "IconContainerComponent", "max", "name", "onChange", "onChangeActive", "onMouseLeave", "onMouseMove", "precision", "readOnly", "size", "value"];
function _getRequireWildcardCache$1F(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1F = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1W(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1F(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getDecimalPrecision$1(num) {
  const decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}
function roundValueToPrecision(value, precision) {
  if (value == null) {
    return value;
  }
  const nearest = Math.round(value / precision) * precision;
  return Number(nearest.toFixed(getDecimalPrecision$1(precision)));
}
const useUtilityClasses$z = ownerState => {
  const {
    classes,
    size,
    readOnly,
    disabled,
    emptyValueFocused,
    focusVisible
  } = ownerState;
  const slots = {
    root: ['root', `size${(0, _utils$E.capitalize)(size)}`, disabled && 'disabled', focusVisible && 'focusVisible', readOnly && 'readOnly'],
    label: ['label', 'pristine'],
    labelEmptyValue: [emptyValueFocused && 'labelEmptyValueActive'],
    icon: ['icon'],
    iconEmpty: ['iconEmpty'],
    iconFilled: ['iconFilled'],
    iconHover: ['iconHover'],
    iconFocus: ['iconFocus'],
    iconActive: ['iconActive'],
    decimal: ['decimal'],
    visuallyHidden: ['visuallyHidden']
  };
  return (0, _composeClasses$y.default)(slots, _ratingClasses.getRatingUtilityClass, classes);
};
const RatingRoot = (0, _styled$w.default)('span', {
  name: 'MuiRating',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_ratingClasses.default.visuallyHidden}`]: styles.visuallyHidden
    }, styles.root, styles[`size${(0, _utils$E.capitalize)(ownerState.size)}`], ownerState.readOnly && styles.readOnly];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$H.default)({
  display: 'inline-flex',
  // Required to position the pristine input absolutely
  position: 'relative',
  fontSize: theme.typography.pxToRem(24),
  color: '#faaf00',
  cursor: 'pointer',
  textAlign: 'left',
  width: 'min-content',
  WebkitTapHighlightColor: 'transparent',
  [`&.${_ratingClasses.default.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity,
    pointerEvents: 'none'
  },
  [`&.${_ratingClasses.default.focusVisible} .${_ratingClasses.default.iconActive}`]: {
    outline: '1px solid #999'
  },
  [`& .${_ratingClasses.default.visuallyHidden}`]: _visuallyHidden.default
}, ownerState.size === 'small' && {
  fontSize: theme.typography.pxToRem(18)
}, ownerState.size === 'large' && {
  fontSize: theme.typography.pxToRem(30)
}, ownerState.readOnly && {
  pointerEvents: 'none'
}));
const RatingLabel = (0, _styled$w.default)('label', {
  name: 'MuiRating',
  slot: 'Label',
  overridesResolver: ({
    ownerState
  }, styles) => [styles.label, ownerState.emptyValueFocused && styles.labelEmptyValueActive]
})(({
  ownerState
}) => (0, _extends2$H.default)({
  cursor: 'inherit'
}, ownerState.emptyValueFocused && {
  top: 0,
  bottom: 0,
  position: 'absolute',
  outline: '1px solid #999',
  width: '100%'
}));
const RatingIcon = (0, _styled$w.default)('span', {
  name: 'MuiRating',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.iconEmpty && styles.iconEmpty, ownerState.iconFilled && styles.iconFilled, ownerState.iconHover && styles.iconHover, ownerState.iconFocus && styles.iconFocus, ownerState.iconActive && styles.iconActive];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$H.default)({
  // Fit wrapper to actual icon size.
  display: 'flex',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  }),
  // Fix mouseLeave issue.
  // https://github.com/facebook/react/issues/4492
  pointerEvents: 'none'
}, ownerState.iconActive && {
  transform: 'scale(1.2)'
}, ownerState.iconEmpty && {
  color: (theme.vars || theme).palette.action.disabled
}));
const RatingDecimal = (0, _styled$w.default)('span', {
  name: 'MuiRating',
  slot: 'Decimal',
  shouldForwardProp: prop => (0, _styled$w.slotShouldForwardProp)(prop) && prop !== 'iconActive',
  overridesResolver: (props, styles) => {
    const {
      iconActive
    } = props;
    return [styles.decimal, iconActive && styles.iconActive];
  }
})(({
  iconActive
}) => (0, _extends2$H.default)({
  position: 'relative'
}, iconActive && {
  transform: 'scale(1.2)'
}));
function IconContainer(props) {
  const other = (0, _objectWithoutPropertiesLoose2$F.default)(props, _excluded$17);
  return /*#__PURE__*/(0, _jsxRuntime$M.jsx)("span", (0, _extends2$H.default)({}, other));
}
process.env.NODE_ENV !== "production" ? IconContainer.propTypes = {
  value: _propTypes$13.default.number.isRequired
} : void 0;
function RatingItem(props) {
  const {
    classes,
    disabled,
    emptyIcon,
    focus,
    getLabelText,
    highlightSelectedOnly,
    hover,
    icon,
    IconContainerComponent,
    isActive,
    itemValue,
    labelProps,
    name,
    onBlur,
    onChange,
    onClick,
    onFocus,
    readOnly,
    ownerState,
    ratingValue,
    ratingValueRounded
  } = props;
  const isFilled = highlightSelectedOnly ? itemValue === ratingValue : itemValue <= ratingValue;
  const isHovered = itemValue <= hover;
  const isFocused = itemValue <= focus;
  const isChecked = itemValue === ratingValueRounded;
  const id = (0, _utils$E.unstable_useId)();
  const container = /*#__PURE__*/(0, _jsxRuntime$M.jsx)(RatingIcon, {
    as: IconContainerComponent,
    value: itemValue,
    className: (0, _clsx$19.default)(classes.icon, isFilled ? classes.iconFilled : classes.iconEmpty, isHovered && classes.iconHover, isFocused && classes.iconFocus, isActive && classes.iconActive),
    ownerState: (0, _extends2$H.default)({}, ownerState, {
      iconEmpty: !isFilled,
      iconFilled: isFilled,
      iconHover: isHovered,
      iconFocus: isFocused,
      iconActive: isActive
    }),
    children: emptyIcon && !isFilled ? emptyIcon : icon
  });
  if (readOnly) {
    return /*#__PURE__*/(0, _jsxRuntime$M.jsx)("span", (0, _extends2$H.default)({}, labelProps, {
      children: container
    }));
  }
  return /*#__PURE__*/(0, _jsxRuntime$M.jsxs)(React$_.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime$M.jsxs)(RatingLabel, (0, _extends2$H.default)({
      ownerState: (0, _extends2$H.default)({}, ownerState, {
        emptyValueFocused: undefined
      }),
      htmlFor: id
    }, labelProps, {
      children: [container, /*#__PURE__*/(0, _jsxRuntime$M.jsx)("span", {
        className: classes.visuallyHidden,
        children: getLabelText(itemValue)
      })]
    })), /*#__PURE__*/(0, _jsxRuntime$M.jsx)("input", {
      className: classes.visuallyHidden,
      onFocus: onFocus,
      onBlur: onBlur,
      onChange: onChange,
      onClick: onClick,
      disabled: disabled,
      value: itemValue,
      id: id,
      type: "radio",
      name: name,
      checked: isChecked
    })]
  });
}
process.env.NODE_ENV !== "production" ? RatingItem.propTypes = {
  classes: _propTypes$13.default.object.isRequired,
  disabled: _propTypes$13.default.bool.isRequired,
  emptyIcon: _propTypes$13.default.node,
  focus: _propTypes$13.default.number.isRequired,
  getLabelText: _propTypes$13.default.func.isRequired,
  highlightSelectedOnly: _propTypes$13.default.bool.isRequired,
  hover: _propTypes$13.default.number.isRequired,
  icon: _propTypes$13.default.node,
  IconContainerComponent: _propTypes$13.default.elementType.isRequired,
  isActive: _propTypes$13.default.bool.isRequired,
  itemValue: _propTypes$13.default.number.isRequired,
  labelProps: _propTypes$13.default.object,
  name: _propTypes$13.default.string,
  onBlur: _propTypes$13.default.func.isRequired,
  onChange: _propTypes$13.default.func.isRequired,
  onClick: _propTypes$13.default.func.isRequired,
  onFocus: _propTypes$13.default.func.isRequired,
  ownerState: _propTypes$13.default.object.isRequired,
  ratingValue: _propTypes$13.default.number,
  ratingValueRounded: _propTypes$13.default.number,
  readOnly: _propTypes$13.default.bool.isRequired
} : void 0;
const defaultIcon = /*#__PURE__*/(0, _jsxRuntime$M.jsx)(_Star.default, {
  fontSize: "inherit"
});
const defaultEmptyIcon = /*#__PURE__*/(0, _jsxRuntime$M.jsx)(_StarBorder.default, {
  fontSize: "inherit"
});
function defaultLabelText(value) {
  return `${value} Star${value !== 1 ? 's' : ''}`;
}
const Rating$1 = /*#__PURE__*/React$_.forwardRef(function Rating(inProps, ref) {
  const props = (0, _DefaultPropsProvider$z.useDefaultProps)({
    name: 'MuiRating',
    props: inProps
  });
  const {
      className,
      defaultValue = null,
      disabled = false,
      emptyIcon = defaultEmptyIcon,
      emptyLabelText = 'Empty',
      getLabelText = defaultLabelText,
      highlightSelectedOnly = false,
      icon = defaultIcon,
      IconContainerComponent = IconContainer,
      max = 5,
      name: nameProp,
      onChange,
      onChangeActive,
      onMouseLeave,
      onMouseMove,
      precision = 1,
      readOnly = false,
      size = 'medium',
      value: valueProp
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$F.default)(props, _excluded2$g);
  const name = (0, _utils$E.unstable_useId)(nameProp);
  const [valueDerived, setValueState] = (0, _utils$E.useControlled)({
    controlled: valueProp,
    default: defaultValue,
    name: 'Rating'
  });
  const valueRounded = roundValueToPrecision(valueDerived, precision);
  const isRtl = (0, _RtlProvider$5.useRtl)();
  const [{
    hover,
    focus
  }, setState] = React$_.useState({
    hover: -1,
    focus: -1
  });
  let value = valueRounded;
  if (hover !== -1) {
    value = hover;
  }
  if (focus !== -1) {
    value = focus;
  }
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0, _utils$E.useIsFocusVisible)();
  const [focusVisible, setFocusVisible] = React$_.useState(false);
  const rootRef = React$_.useRef();
  const handleRef = (0, _utils$E.useForkRef)(focusVisibleRef, rootRef, ref);
  const handleMouseMove = event => {
    if (onMouseMove) {
      onMouseMove(event);
    }
    const rootNode = rootRef.current;
    const {
      right,
      left,
      width: containerWidth
    } = rootNode.getBoundingClientRect();
    let percent;
    if (isRtl) {
      percent = (right - event.clientX) / containerWidth;
    } else {
      percent = (event.clientX - left) / containerWidth;
    }
    let newHover = roundValueToPrecision(max * percent + precision / 2, precision);
    newHover = (0, _clamp$1.default)(newHover, precision, max);
    setState(prev => prev.hover === newHover && prev.focus === newHover ? prev : {
      hover: newHover,
      focus: newHover
    });
    setFocusVisible(false);
    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };
  const handleMouseLeave = event => {
    if (onMouseLeave) {
      onMouseLeave(event);
    }
    const newHover = -1;
    setState({
      hover: newHover,
      focus: newHover
    });
    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };
  const handleChange = event => {
    let newValue = event.target.value === '' ? null : parseFloat(event.target.value);

    // Give mouse priority over keyboard
    // Fix https://github.com/mui/material-ui/issues/22827
    if (hover !== -1) {
      newValue = hover;
    }
    setValueState(newValue);
    if (onChange) {
      onChange(event, newValue);
    }
  };
  const handleClear = event => {
    // Ignore keyboard events
    // https://github.com/facebook/react/issues/7407
    if (event.clientX === 0 && event.clientY === 0) {
      return;
    }
    setState({
      hover: -1,
      focus: -1
    });
    setValueState(null);
    if (onChange && parseFloat(event.target.value) === valueRounded) {
      onChange(event, null);
    }
  };
  const handleFocus = event => {
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
    }
    const newFocus = parseFloat(event.target.value);
    setState(prev => ({
      hover: prev.hover,
      focus: newFocus
    }));
  };
  const handleBlur = event => {
    if (hover !== -1) {
      return;
    }
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }
    const newFocus = -1;
    setState(prev => ({
      hover: prev.hover,
      focus: newFocus
    }));
  };
  const [emptyValueFocused, setEmptyValueFocused] = React$_.useState(false);
  const ownerState = (0, _extends2$H.default)({}, props, {
    defaultValue,
    disabled,
    emptyIcon,
    emptyLabelText,
    emptyValueFocused,
    focusVisible,
    getLabelText,
    icon,
    IconContainerComponent,
    max,
    precision,
    readOnly,
    size
  });
  const classes = useUtilityClasses$z(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$M.jsxs)(RatingRoot, (0, _extends2$H.default)({
    ref: handleRef,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    className: (0, _clsx$19.default)(classes.root, className, readOnly && 'MuiRating-readOnly'),
    ownerState: ownerState,
    role: readOnly ? 'img' : null,
    "aria-label": readOnly ? getLabelText(value) : null
  }, other, {
    children: [Array.from(new Array(max)).map((_, index) => {
      const itemValue = index + 1;
      const ratingItemProps = {
        classes,
        disabled,
        emptyIcon,
        focus,
        getLabelText,
        highlightSelectedOnly,
        hover,
        icon,
        IconContainerComponent,
        name,
        onBlur: handleBlur,
        onChange: handleChange,
        onClick: handleClear,
        onFocus: handleFocus,
        ratingValue: value,
        ratingValueRounded: valueRounded,
        readOnly,
        ownerState
      };
      const isActive = itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1);
      if (precision < 1) {
        const items = Array.from(new Array(1 / precision));
        return /*#__PURE__*/(0, _jsxRuntime$M.jsx)(RatingDecimal, {
          className: (0, _clsx$19.default)(classes.decimal, isActive && classes.iconActive),
          ownerState: ownerState,
          iconActive: isActive,
          children: items.map(($, indexDecimal) => {
            const itemDecimalValue = roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
            return /*#__PURE__*/(0, _jsxRuntime$M.jsx)(RatingItem, (0, _extends2$H.default)({}, ratingItemProps, {
              // The icon is already displayed as active
              isActive: false,
              itemValue: itemDecimalValue,
              labelProps: {
                style: items.length - 1 === indexDecimal ? {} : {
                  width: itemDecimalValue === value ? `${(indexDecimal + 1) * precision * 100}%` : '0%',
                  overflow: 'hidden',
                  position: 'absolute'
                }
              }
            }), itemDecimalValue);
          })
        }, itemValue);
      }
      return /*#__PURE__*/(0, _jsxRuntime$M.jsx)(RatingItem, (0, _extends2$H.default)({}, ratingItemProps, {
        isActive: isActive,
        itemValue: itemValue
      }), itemValue);
    }), !readOnly && !disabled && /*#__PURE__*/(0, _jsxRuntime$M.jsxs)(RatingLabel, {
      className: (0, _clsx$19.default)(classes.label, classes.labelEmptyValue),
      ownerState: ownerState,
      children: [/*#__PURE__*/(0, _jsxRuntime$M.jsx)("input", {
        className: classes.visuallyHidden,
        value: "",
        id: `${name}-empty`,
        type: "radio",
        name: name,
        checked: valueRounded == null,
        onFocus: () => setEmptyValueFocused(true),
        onBlur: () => setEmptyValueFocused(false),
        onChange: handleChange
      }), /*#__PURE__*/(0, _jsxRuntime$M.jsx)("span", {
        className: classes.visuallyHidden,
        children: emptyLabelText
      })]
    })]
  }));
});
process.env.NODE_ENV !== "production" ? Rating$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$13.default.object,
  /**
   * @ignore
   */
  className: _propTypes$13.default.string,
  /**
   * The default value. Use when the component is not controlled.
   * @default null
   */
  defaultValue: _propTypes$13.default.number,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$13.default.bool,
  /**
   * The icon to display when empty.
   * @default <StarBorder fontSize="inherit" />
   */
  emptyIcon: _propTypes$13.default.node,
  /**
   * The label read when the rating input is empty.
   * @default 'Empty'
   */
  emptyLabelText: _propTypes$13.default.node,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {number} value The rating label's value to format.
   * @returns {string}
   * @default function defaultLabelText(value) {
   *   return `${value} Star${value !== 1 ? 's' : ''}`;
   * }
   */
  getLabelText: _propTypes$13.default.func,
  /**
   * If `true`, only the selected icon will be highlighted.
   * @default false
   */
  highlightSelectedOnly: _propTypes$13.default.bool,
  /**
   * The icon to display.
   * @default <Star fontSize="inherit" />
   */
  icon: _propTypes$13.default.node,
  /**
   * The component containing the icon.
   * @default function IconContainer(props) {
   *   const { value, ...other } = props;
   *   return <span {...other} />;
   * }
   */
  IconContainerComponent: _propTypes$13.default.elementType,
  /**
   * Maximum rating.
   * @default 5
   */
  max: _propTypes$13.default.number,
  /**
   * The name attribute of the radio `input` elements.
   * This input `name` should be unique within the page.
   * Being unique within a form is insufficient since the `name` is used to generated IDs.
   */
  name: _propTypes$13.default.string,
  /**
   * Callback fired when the value changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number|null} value The new value.
   */
  onChange: _propTypes$13.default.func,
  /**
   * Callback function that is fired when the hover state changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChangeActive: _propTypes$13.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes$13.default.func,
  /**
   * @ignore
   */
  onMouseMove: _propTypes$13.default.func,
  /**
   * The minimum increment value change allowed.
   * @default 1
   */
  precision: (0, _chainPropTypes$2.default)(_propTypes$13.default.number, props => {
    if (props.precision < 0.1) {
      return new Error(['MUI: The prop `precision` should be above 0.1.', 'A value below this limit has an imperceptible impact.'].join('\n'));
    }
    return null;
  }),
  /**
   * Removes all hover effects and pointer events.
   * @default false
   */
  readOnly: _propTypes$13.default.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: _propTypes$13.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$13.default.oneOf(['small', 'medium', 'large']), _propTypes$13.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$13.default.oneOfType([_propTypes$13.default.arrayOf(_propTypes$13.default.oneOfType([_propTypes$13.default.func, _propTypes$13.default.object, _propTypes$13.default.bool])), _propTypes$13.default.func, _propTypes$13.default.object]),
  /**
   * The rating value.
   */
  value: _propTypes$13.default.number
} : void 0;
Rating$2.default = Rating$1;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ratingClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Rating.default;
  }
});
Object.defineProperty(exports, "ratingClasses", {
  enumerable: true,
  get: function () {
    return _ratingClasses.default;
  }
});
var _Rating = _interopRequireDefault(Rating$2);
var _ratingClasses = _interopRequireWildcard(ratingClasses$1);
Object.keys(_ratingClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ratingClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ratingClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Rating$3));

var RatingMUI = /*@__PURE__*/getDefaultExportFromCjs$1(Rating$3);

var ScopedCssBaseline$2 = {};

var ScopedCssBaseline$1 = {};

var scopedCssBaselineClasses$1 = {};

var _interopRequireDefault$4J = interopRequireDefault$1.exports;
Object.defineProperty(scopedCssBaselineClasses$1, "__esModule", {
  value: true
});
scopedCssBaselineClasses$1.default = void 0;
scopedCssBaselineClasses$1.getScopedCssBaselineUtilityClass = getScopedCssBaselineUtilityClass;
var _generateUtilityClasses$x = _interopRequireDefault$4J(generateUtilityClasses$3);
var _generateUtilityClass$x = _interopRequireDefault$4J(generateUtilityClass$3);
function getScopedCssBaselineUtilityClass(slot) {
  return (0, _generateUtilityClass$x.default)('MuiScopedCssBaseline', slot);
}
const scopedCssBaselineClasses = (0, _generateUtilityClasses$x.default)('MuiScopedCssBaseline', ['root']);
scopedCssBaselineClasses$1.default = scopedCssBaselineClasses;

var _interopRequireDefault$4I = interopRequireDefault$1.exports;
Object.defineProperty(ScopedCssBaseline$1, "__esModule", {
  value: true
});
ScopedCssBaseline$1.default = void 0;
var _objectWithoutPropertiesLoose2$E = _interopRequireDefault$4I(objectWithoutPropertiesLoose.exports);
var _extends2$G = _interopRequireDefault$4I(_extends$19.exports);
var React$Z = _interopRequireWildcard$1V(React__default$4);
var _propTypes$12 = _interopRequireDefault$4I(propTypes.exports);
var _clsx$18 = _interopRequireDefault$4I(clsx.exports);
var _composeClasses$x = _interopRequireDefault$4I(composeClasses$2);
var _DefaultPropsProvider$y = DefaultPropsProvider$5;
var _styled$v = _interopRequireDefault$4I(styled$2);
var _CssBaseline = CssBaseline$1;
var _scopedCssBaselineClasses = scopedCssBaselineClasses$1;
var _jsxRuntime$L = require$$11;
const _excluded$16 = ["className", "component", "enableColorScheme"];
function _getRequireWildcardCache$1E(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1E = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1V(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1E(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$y = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$x.default)(slots, _scopedCssBaselineClasses.getScopedCssBaselineUtilityClass, classes);
};
const ScopedCssBaselineRoot = (0, _styled$v.default)('div', {
  name: 'MuiScopedCssBaseline',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme,
  ownerState
}) => {
  const colorSchemeStyles = {};
  if (ownerState.enableColorScheme && theme.colorSchemes) {
    Object.entries(theme.colorSchemes).forEach(([key, scheme]) => {
      var _scheme$palette;
      colorSchemeStyles[`&${theme.getColorSchemeSelector(key).replace(/\s*&/, '')}`] = {
        colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
      };
    });
  }
  return (0, _extends2$G.default)({}, (0, _CssBaseline.html)(theme, ownerState.enableColorScheme), (0, _CssBaseline.body)(theme), {
    '& *, & *::before, & *::after': {
      boxSizing: 'inherit'
    },
    '& strong, & b': {
      fontWeight: theme.typography.fontWeightBold
    }
  }, colorSchemeStyles);
});
const ScopedCssBaseline = /*#__PURE__*/React$Z.forwardRef(function ScopedCssBaseline(inProps, ref) {
  const props = (0, _DefaultPropsProvider$y.useDefaultProps)({
    props: inProps,
    name: 'MuiScopedCssBaseline'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$E.default)(props, _excluded$16);
  const ownerState = (0, _extends2$G.default)({}, props, {
    component
  });
  const classes = useUtilityClasses$y(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$L.jsx)(ScopedCssBaselineRoot, (0, _extends2$G.default)({
    as: component,
    className: (0, _clsx$18.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? ScopedCssBaseline.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$12.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$12.default.object,
  /**
   * @ignore
   */
  className: _propTypes$12.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$12.default.elementType,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   */
  enableColorScheme: _propTypes$12.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$12.default.oneOfType([_propTypes$12.default.arrayOf(_propTypes$12.default.oneOfType([_propTypes$12.default.func, _propTypes$12.default.object, _propTypes$12.default.bool])), _propTypes$12.default.func, _propTypes$12.default.object])
} : void 0;
ScopedCssBaseline$1.default = ScopedCssBaseline;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  scopedCssBaselineClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ScopedCssBaseline.default;
  }
});
Object.defineProperty(exports, "scopedCssBaselineClasses", {
  enumerable: true,
  get: function () {
    return _scopedCssBaselineClasses.default;
  }
});
var _ScopedCssBaseline = _interopRequireDefault(ScopedCssBaseline$1);
var _scopedCssBaselineClasses = _interopRequireWildcard(scopedCssBaselineClasses$1);
Object.keys(_scopedCssBaselineClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _scopedCssBaselineClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _scopedCssBaselineClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ScopedCssBaseline$2));

var Select$4 = {};

var Select$3 = {};

var SelectInput$1 = {};

var selectClasses$1 = {};

var _interopRequireDefault$4H = interopRequireDefault$1.exports;
Object.defineProperty(selectClasses$1, "__esModule", {
  value: true
});
selectClasses$1.default = void 0;
selectClasses$1.getSelectUtilityClasses = getSelectUtilityClasses;
var _generateUtilityClasses$w = _interopRequireDefault$4H(generateUtilityClasses$3);
var _generateUtilityClass$w = _interopRequireDefault$4H(generateUtilityClass$3);
function getSelectUtilityClasses(slot) {
  return (0, _generateUtilityClass$w.default)('MuiSelect', slot);
}
const selectClasses = (0, _generateUtilityClasses$w.default)('MuiSelect', ['root', 'select', 'multiple', 'filled', 'outlined', 'standard', 'disabled', 'focused', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput', 'error']);
selectClasses$1.default = selectClasses;

var _interopRequireDefault$4G = interopRequireDefault$1.exports;
Object.defineProperty(SelectInput$1, "__esModule", {
  value: true
});
SelectInput$1.default = void 0;
var _extends2$F = _interopRequireDefault$4G(_extends$19.exports);
var _objectWithoutPropertiesLoose2$D = _interopRequireDefault$4G(objectWithoutPropertiesLoose.exports);
var _formatMuiErrorMessage2 = _interopRequireDefault$4G(formatMuiErrorMessage$2);
var React$Y = _interopRequireWildcard$1U(React__default$4);
var _reactIs$4 = reactIs$6.exports;
var _propTypes$11 = _interopRequireDefault$4G(propTypes.exports);
var _clsx$17 = _interopRequireDefault$4G(clsx.exports);
var _composeClasses$w = _interopRequireDefault$4G(composeClasses$2);
var _useId$3 = _interopRequireDefault$4G(useId$3);
var _refType$3 = _interopRequireDefault$4G(refType$2);
var _ownerDocument$2 = _interopRequireDefault$4G(ownerDocument);
var _capitalize$d = _interopRequireDefault$4G(capitalize$1);
var _Menu = _interopRequireDefault$4G(Menu$1);
var _NativeSelectInput$1 = NativeSelectInput$1;
var _utils$D = utils$5;
var _styled$u = _interopRequireWildcard$1U(styled$2);
var _useForkRef$5 = _interopRequireDefault$4G(useForkRef);
var _useControlled$2 = _interopRequireDefault$4G(useControlled);
var _selectClasses = _interopRequireWildcard$1U(selectClasses$1);
var _jsxRuntime$K = require$$11;
var _span;
const _excluded$15 = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"];
function _getRequireWildcardCache$1D(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1D = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1U(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1D(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SelectSelect = (0, _styled$u.default)('div', {
  name: 'MuiSelect',
  slot: 'Select',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [
    // Win specificity over the input base
    {
      [`&.${_selectClasses.default.select}`]: styles.select
    }, {
      [`&.${_selectClasses.default.select}`]: styles[ownerState.variant]
    }, {
      [`&.${_selectClasses.default.error}`]: styles.error
    }, {
      [`&.${_selectClasses.default.multiple}`]: styles.multiple
    }];
  }
})(_NativeSelectInput$1.nativeSelectSelectStyles, {
  // Win specificity over the input base
  [`&.${_selectClasses.default.select}`]: {
    height: 'auto',
    // Resets for multiple select with chips
    minHeight: '1.4375em',
    // Required for select\text-field height consistency
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
});
const SelectIcon = (0, _styled$u.default)('svg', {
  name: 'MuiSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${(0, _capitalize$d.default)(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(_NativeSelectInput$1.nativeSelectIconStyles);
const SelectNativeInput = (0, _styled$u.default)('input', {
  shouldForwardProp: prop => (0, _styled$u.slotShouldForwardProp)(prop) && prop !== 'classes',
  name: 'MuiSelect',
  slot: 'NativeInput',
  overridesResolver: (props, styles) => styles.nativeInput
})({
  bottom: 0,
  left: 0,
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  width: '100%',
  boxSizing: 'border-box'
});
function areEqualValues(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(a) === String(b);
}
function isEmpty$1(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
const useUtilityClasses$x = ownerState => {
  const {
    classes,
    variant,
    disabled,
    multiple,
    open,
    error
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled', multiple && 'multiple', error && 'error'],
    icon: ['icon', `icon${(0, _capitalize$d.default)(variant)}`, open && 'iconOpen', disabled && 'disabled'],
    nativeInput: ['nativeInput']
  };
  return (0, _composeClasses$w.default)(slots, _selectClasses.getSelectUtilityClasses, classes);
};

/**
 * @ignore - internal component.
 */
const SelectInput = /*#__PURE__*/React$Y.forwardRef(function SelectInput(props, ref) {
  var _MenuProps$slotProps;
  const {
      'aria-describedby': ariaDescribedby,
      'aria-label': ariaLabel,
      autoFocus,
      autoWidth,
      children,
      className,
      defaultOpen,
      defaultValue,
      disabled,
      displayEmpty,
      error = false,
      IconComponent,
      inputRef: inputRefProp,
      labelId,
      MenuProps = {},
      multiple,
      name,
      onBlur,
      onChange,
      onClose,
      onFocus,
      onOpen,
      open: openProp,
      readOnly,
      renderValue,
      SelectDisplayProps = {},
      tabIndex: tabIndexProp
      // catching `type` from Input which makes no sense for SelectInput
      ,

      value: valueProp,
      variant = 'standard'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$D.default)(props, _excluded$15);
  const [value, setValueState] = (0, _useControlled$2.default)({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  });
  const [openState, setOpenState] = (0, _useControlled$2.default)({
    controlled: openProp,
    default: defaultOpen,
    name: 'Select'
  });
  const inputRef = React$Y.useRef(null);
  const displayRef = React$Y.useRef(null);
  const [displayNode, setDisplayNode] = React$Y.useState(null);
  const {
    current: isOpenControlled
  } = React$Y.useRef(openProp != null);
  const [menuMinWidthState, setMenuMinWidthState] = React$Y.useState();
  const handleRef = (0, _useForkRef$5.default)(ref, inputRefProp);
  const handleDisplayRef = React$Y.useCallback(node => {
    displayRef.current = node;
    if (node) {
      setDisplayNode(node);
    }
  }, []);
  const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
  React$Y.useImperativeHandle(handleRef, () => ({
    focus: () => {
      displayRef.current.focus();
    },
    node: inputRef.current,
    value
  }), [value]);

  // Resize menu on `defaultOpen` automatic toggle.
  React$Y.useEffect(() => {
    if (defaultOpen && openState && displayNode && !isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
      displayRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayNode, autoWidth]);
  // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
  // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
  React$Y.useEffect(() => {
    if (autoFocus) {
      displayRef.current.focus();
    }
  }, [autoFocus]);
  React$Y.useEffect(() => {
    if (!labelId) {
      return undefined;
    }
    const label = (0, _ownerDocument$2.default)(displayRef.current).getElementById(labelId);
    if (label) {
      const handler = () => {
        if (getSelection().isCollapsed) {
          displayRef.current.focus();
        }
      };
      label.addEventListener('click', handler);
      return () => {
        label.removeEventListener('click', handler);
      };
    }
    return undefined;
  }, [labelId]);
  const update = (open, event) => {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }
    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
      setOpenState(open);
    }
  };
  const handleMouseDown = event => {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    }
    // Hijack the default focus behavior.
    event.preventDefault();
    displayRef.current.focus();
    update(true, event);
  };
  const handleClose = event => {
    update(false, event);
  };
  const childrenArray = React$Y.Children.toArray(children);

  // Support autofill.
  const handleChange = event => {
    const child = childrenArray.find(childItem => childItem.props.value === event.target.value);
    if (child === undefined) {
      return;
    }
    setValueState(child.props.value);
    if (onChange) {
      onChange(event, child);
    }
  };
  const handleItemClick = child => event => {
    let newValue;

    // We use the tabindex attribute to signal the available options.
    if (!event.currentTarget.hasAttribute('tabindex')) {
      return;
    }
    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      const itemIndex = value.indexOf(child.props.value);
      if (itemIndex === -1) {
        newValue.push(child.props.value);
      } else {
        newValue.splice(itemIndex, 1);
      }
    } else {
      newValue = child.props.value;
    }
    if (child.props.onClick) {
      child.props.onClick(event);
    }
    if (value !== newValue) {
      setValueState(newValue);
      if (onChange) {
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
          writable: true,
          value: {
            value: newValue,
            name
          }
        });
        onChange(clonedEvent, child);
      }
    }
    if (!multiple) {
      update(false, event);
    }
  };
  const handleKeyDown = event => {
    if (!readOnly) {
      const validKeys = [' ', 'ArrowUp', 'ArrowDown',
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      'Enter'];
      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };
  const open = displayNode !== null && openState;
  const handleBlur = event => {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      // Preact support, target is read only property on a native event.
      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value,
          name
        }
      });
      onBlur(event);
    }
  };
  delete other['aria-invalid'];
  let display;
  let displaySingle;
  const displayMultiple = [];
  let computeDisplay = false;
  let foundMatch = false;

  // No need to display any value if the field is empty.
  if ((0, _utils$D.isFilled)({
    value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }
  const items = childrenArray.map(child => {
    if (! /*#__PURE__*/React$Y.isValidElement(child)) {
      return null;
    }
    if (process.env.NODE_ENV !== 'production') {
      if ((0, _reactIs$4.isFragment)(child)) {
        console.error(["MUI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    let selected;
    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`value\` prop must be an array when using the \`Select\` component with \`multiple\`.` : (0, _formatMuiErrorMessage2.default)(2));
      }
      selected = value.some(v => areEqualValues(v, child.props.value));
      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);
      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }
    if (selected) {
      foundMatch = true;
    }
    return /*#__PURE__*/React$Y.cloneElement(child, {
      'aria-selected': selected ? 'true' : 'false',
      onClick: handleItemClick(child),
      onKeyUp: event => {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }
        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.
    });
  });
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$Y.useEffect(() => {
      if (!foundMatch && !multiple && value !== '') {
        const values = childrenArray.map(child => child.props.value);
        console.warn([`MUI: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ''}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${values.filter(x => x != null).map(x => `\`${x}\``).join(', ') || '""'}.`].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }
  if (computeDisplay) {
    if (multiple) {
      if (displayMultiple.length === 0) {
        display = null;
      } else {
        display = displayMultiple.reduce((output, child, index) => {
          output.push(child);
          if (index < displayMultiple.length - 1) {
            output.push(', ');
          }
          return output;
        }, []);
      }
    } else {
      display = displaySingle;
    }
  }

  // Avoid performing a layout computation in the render method.
  let menuMinWidth = menuMinWidthState;
  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = anchorElement.clientWidth;
  }
  let tabIndex;
  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }
  const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
  const ownerState = (0, _extends2$F.default)({}, props, {
    variant,
    value,
    open,
    error
  });
  const classes = useUtilityClasses$x(ownerState);
  const paperProps = (0, _extends2$F.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
  const listboxId = (0, _useId$3.default)();
  return /*#__PURE__*/(0, _jsxRuntime$K.jsxs)(React$Y.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime$K.jsx)(SelectSelect, (0, _extends2$F.default)({
      ref: handleDisplayRef,
      tabIndex: tabIndex,
      role: "combobox",
      "aria-controls": listboxId,
      "aria-disabled": disabled ? 'true' : undefined,
      "aria-expanded": open ? 'true' : 'false',
      "aria-haspopup": "listbox",
      "aria-label": ariaLabel,
      "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
      "aria-describedby": ariaDescribedby,
      onKeyDown: handleKeyDown,
      onMouseDown: disabled || readOnly ? null : handleMouseDown,
      onBlur: handleBlur,
      onFocus: onFocus
    }, SelectDisplayProps, {
      ownerState: ownerState,
      className: (0, _clsx$17.default)(SelectDisplayProps.className, classes.select, className)
      // The id is required for proper a11y
      ,
      id: buttonId,
      children: isEmpty$1(display) ? // notranslate needed while Google Translate will not fix zero-width space issue
      _span || (_span = /*#__PURE__*/(0, _jsxRuntime$K.jsx)("span", {
        className: "notranslate",
        children: "\u200B"
      })) : display
    })), /*#__PURE__*/(0, _jsxRuntime$K.jsx)(SelectNativeInput, (0, _extends2$F.default)({
      "aria-invalid": error,
      value: Array.isArray(value) ? value.join(',') : value,
      name: name,
      ref: inputRef,
      "aria-hidden": true,
      onChange: handleChange,
      tabIndex: -1,
      disabled: disabled,
      className: classes.nativeInput,
      autoFocus: autoFocus,
      ownerState: ownerState
    }, other)), /*#__PURE__*/(0, _jsxRuntime$K.jsx)(SelectIcon, {
      as: IconComponent,
      className: classes.icon,
      ownerState: ownerState
    }), /*#__PURE__*/(0, _jsxRuntime$K.jsx)(_Menu.default, (0, _extends2$F.default)({
      id: `menu-${name || ''}`,
      anchorEl: anchorElement,
      open: open,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }, MenuProps, {
      MenuListProps: (0, _extends2$F.default)({
        'aria-labelledby': labelId,
        role: 'listbox',
        'aria-multiselectable': multiple ? 'true' : undefined,
        disableListWrap: true,
        id: listboxId
      }, MenuProps.MenuListProps),
      slotProps: (0, _extends2$F.default)({}, MenuProps.slotProps, {
        paper: (0, _extends2$F.default)({}, paperProps, {
          style: (0, _extends2$F.default)({
            minWidth: menuMinWidth
          }, paperProps != null ? paperProps.style : null)
        })
      }),
      children: items
    }))]
  });
});
process.env.NODE_ENV !== "production" ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  'aria-describedby': _propTypes$11.default.string,
  /**
   * @ignore
   */
  'aria-label': _propTypes$11.default.string,
  /**
   * @ignore
   */
  autoFocus: _propTypes$11.default.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: _propTypes$11.default.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: _propTypes$11.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$11.default.object,
  /**
   * The CSS class name of the select element.
   */
  className: _propTypes$11.default.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: _propTypes$11.default.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes$11.default.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: _propTypes$11.default.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: _propTypes$11.default.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: _propTypes$11.default.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: _propTypes$11.default.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: _refType$3.default,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: _propTypes$11.default.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: _propTypes$11.default.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: _propTypes$11.default.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: _propTypes$11.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes$11.default.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: _propTypes$11.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes$11.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes$11.default.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: _propTypes$11.default.func,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$11.default.bool,
  /**
   * @ignore
   */
  readOnly: _propTypes$11.default.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: _propTypes$11.default.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes$11.default.object,
  /**
   * @ignore
   */
  tabIndex: _propTypes$11.default.oneOfType([_propTypes$11.default.number, _propTypes$11.default.string]),
  /**
   * @ignore
   */
  type: _propTypes$11.default.any,
  /**
   * The input value.
   */
  value: _propTypes$11.default.any,
  /**
   * The variant to use.
   */
  variant: _propTypes$11.default.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
SelectInput$1.default = SelectInput;

var _interopRequireDefault$4F = interopRequireDefault$1.exports;
Object.defineProperty(Select$3, "__esModule", {
  value: true
});
Select$3.default = void 0;
var _extends2$E = _interopRequireDefault$4F(_extends$19.exports);
var _objectWithoutPropertiesLoose2$C = _interopRequireDefault$4F(objectWithoutPropertiesLoose.exports);
var React$X = _interopRequireWildcard$1T(React__default$4);
var _propTypes$10 = _interopRequireDefault$4F(propTypes.exports);
var _clsx$16 = _interopRequireDefault$4F(clsx.exports);
var _deepmerge = _interopRequireDefault$4F(deepmerge$2);
var _getReactElementRef$2 = _interopRequireDefault$4F(getReactElementRef$2);
var _SelectInput = _interopRequireDefault$4F(SelectInput$1);
var _formControlState = _interopRequireDefault$4F(formControlState$1);
var _useFormControl = _interopRequireDefault$4F(useFormControl$1);
var _ArrowDropDown = _interopRequireDefault$4F(ArrowDropDown);
var _Input$2 = _interopRequireDefault$4F(Input$7);
var _NativeSelectInput = _interopRequireDefault$4F(NativeSelectInput$1);
var _FilledInput$1 = _interopRequireDefault$4F(FilledInput$2);
var _OutlinedInput$1 = _interopRequireDefault$4F(OutlinedInput$3);
var _DefaultPropsProvider$x = DefaultPropsProvider$5;
var _useForkRef$4 = _interopRequireDefault$4F(useForkRef);
var _styled$t = _interopRequireWildcard$1T(styled$2);
var _jsxRuntime$J = require$$11;
const _excluded$14 = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"],
  _excluded2$f = ["root"];
function _getRequireWildcardCache$1C(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1C = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1T(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1C(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$w = ownerState => {
  const {
    classes
  } = ownerState;
  return classes;
};
const styledRootConfig = {
  name: 'MuiSelect',
  overridesResolver: (props, styles) => styles.root,
  shouldForwardProp: prop => (0, _styled$t.rootShouldForwardProp)(prop) && prop !== 'variant',
  slot: 'Root'
};
const StyledInput = (0, _styled$t.default)(_Input$2.default, styledRootConfig)('');
const StyledOutlinedInput = (0, _styled$t.default)(_OutlinedInput$1.default, styledRootConfig)('');
const StyledFilledInput = (0, _styled$t.default)(_FilledInput$1.default, styledRootConfig)('');
const Select$2 = /*#__PURE__*/React$X.forwardRef(function Select(inProps, ref) {
  const props = (0, _DefaultPropsProvider$x.useDefaultProps)({
    name: 'MuiSelect',
    props: inProps
  });
  const {
      autoWidth = false,
      children,
      classes: classesProp = {},
      className,
      defaultOpen = false,
      displayEmpty = false,
      IconComponent = _ArrowDropDown.default,
      id,
      input,
      inputProps,
      label,
      labelId,
      MenuProps,
      multiple = false,
      native = false,
      onClose,
      onOpen,
      open,
      renderValue,
      SelectDisplayProps,
      variant: variantProp = 'outlined'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$C.default)(props, _excluded$14);
  const inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
  const muiFormControl = (0, _useFormControl.default)();
  const fcs = (0, _formControlState.default)({
    props,
    muiFormControl,
    states: ['variant', 'error']
  });
  const variant = fcs.variant || variantProp;
  const ownerState = (0, _extends2$E.default)({}, props, {
    variant,
    classes: classesProp
  });
  const classes = useUtilityClasses$w(ownerState);
  const restOfClasses = (0, _objectWithoutPropertiesLoose2$C.default)(classes, _excluded2$f);
  const InputComponent = input || {
    standard: /*#__PURE__*/(0, _jsxRuntime$J.jsx)(StyledInput, {
      ownerState: ownerState
    }),
    outlined: /*#__PURE__*/(0, _jsxRuntime$J.jsx)(StyledOutlinedInput, {
      label: label,
      ownerState: ownerState
    }),
    filled: /*#__PURE__*/(0, _jsxRuntime$J.jsx)(StyledFilledInput, {
      ownerState: ownerState
    })
  }[variant];
  const inputComponentRef = (0, _useForkRef$4.default)(ref, (0, _getReactElementRef$2.default)(InputComponent));
  return /*#__PURE__*/(0, _jsxRuntime$J.jsx)(React$X.Fragment, {
    children: /*#__PURE__*/React$X.cloneElement(InputComponent, (0, _extends2$E.default)({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent,
      inputProps: (0, _extends2$E.default)({
        children,
        error: fcs.error,
        IconComponent,
        variant,
        type: undefined,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple
      }, native ? {
        id
      } : {
        autoWidth,
        defaultOpen,
        displayEmpty,
        labelId,
        MenuProps,
        onClose,
        onOpen,
        open,
        renderValue,
        SelectDisplayProps: (0, _extends2$E.default)({
          id
        }, SelectDisplayProps)
      }, inputProps, {
        classes: inputProps ? (0, _deepmerge.default)(restOfClasses, inputProps.classes) : restOfClasses
      }, input ? input.props.inputProps : {})
    }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
      notched: true
    } : {}, {
      ref: inputComponentRef,
      className: (0, _clsx$16.default)(InputComponent.props.className, className, classes.root)
    }, !input && {
      variant
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? Select$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: _propTypes$10.default.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: _propTypes$10.default.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: _propTypes$10.default.object,
  /**
   * @ignore
   */
  className: _propTypes$10.default.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: _propTypes$10.default.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes$10.default.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: _propTypes$10.default.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: _propTypes$10.default.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: _propTypes$10.default.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: _propTypes$10.default.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: _propTypes$10.default.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: _propTypes$10.default.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: _propTypes$10.default.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: _propTypes$10.default.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: _propTypes$10.default.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: _propTypes$10.default.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: _propTypes$10.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes$10.default.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: _propTypes$10.default.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: _propTypes$10.default.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: _propTypes$10.default.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: _propTypes$10.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$10.default.oneOfType([_propTypes$10.default.arrayOf(_propTypes$10.default.oneOfType([_propTypes$10.default.func, _propTypes$10.default.object, _propTypes$10.default.bool])), _propTypes$10.default.func, _propTypes$10.default.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: _propTypes$10.default.oneOfType([_propTypes$10.default.oneOf(['']), _propTypes$10.default.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: _propTypes$10.default.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select$2.muiName = 'Select';
Select$3.default = Select$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  selectClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Select.default;
  }
});
Object.defineProperty(exports, "selectClasses", {
  enumerable: true,
  get: function () {
    return _selectClasses.default;
  }
});
var _Select = _interopRequireDefault(Select$3);
var _selectClasses = _interopRequireWildcard(selectClasses$1);
Object.keys(_selectClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _selectClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _selectClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Select$4));

var Select$1 = /*@__PURE__*/getDefaultExportFromCjs$1(Select$4);

var Skeleton$2 = {};

var Skeleton$1 = {};

var skeletonClasses$1 = {};

var _interopRequireDefault$4E = interopRequireDefault$1.exports;
Object.defineProperty(skeletonClasses$1, "__esModule", {
  value: true
});
skeletonClasses$1.default = void 0;
skeletonClasses$1.getSkeletonUtilityClass = getSkeletonUtilityClass;
var _generateUtilityClasses$v = _interopRequireDefault$4E(generateUtilityClasses$3);
var _generateUtilityClass$v = _interopRequireDefault$4E(generateUtilityClass$3);
function getSkeletonUtilityClass(slot) {
  return (0, _generateUtilityClass$v.default)('MuiSkeleton', slot);
}
const skeletonClasses = (0, _generateUtilityClasses$v.default)('MuiSkeleton', ['root', 'text', 'rectangular', 'rounded', 'circular', 'pulse', 'wave', 'withChildren', 'fitContent', 'heightAuto']);
skeletonClasses$1.default = skeletonClasses;

var _interopRequireDefault$4D = interopRequireDefault$1.exports;
Object.defineProperty(Skeleton$1, "__esModule", {
  value: true
});
Skeleton$1.default = void 0;
var _objectWithoutPropertiesLoose2$B = _interopRequireDefault$4D(objectWithoutPropertiesLoose.exports);
var _extends2$D = _interopRequireDefault$4D(_extends$19.exports);
var React$W = _interopRequireWildcard$1S(React__default$4);
var _clsx$15 = _interopRequireDefault$4D(clsx.exports);
var _propTypes$$ = _interopRequireDefault$4D(propTypes.exports);
var _system = system;
var _composeClasses$v = _interopRequireDefault$4D(composeClasses$2);
var _styles$3 = styles$u;
var _styled$s = _interopRequireDefault$4D(styled$2);
var _DefaultPropsProvider$w = DefaultPropsProvider$5;
var _skeletonClasses = skeletonClasses$1;
var _jsxRuntime$I = require$$11;
const _excluded$13 = ["animation", "className", "component", "height", "style", "variant", "width"];
function _getRequireWildcardCache$1B(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1B = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1S(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1B(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$v = ownerState => {
  const {
    classes,
    variant,
    animation,
    hasChildren,
    width,
    height
  } = ownerState;
  const slots = {
    root: ['root', variant, animation, hasChildren && 'withChildren', hasChildren && !width && 'fitContent', hasChildren && !height && 'heightAuto']
  };
  return (0, _composeClasses$v.default)(slots, _skeletonClasses.getSkeletonUtilityClass, classes);
};
const pulseKeyframe = (0, _system.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const waveKeyframe = (0, _system.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
const SkeletonRoot = (0, _styled$s.default)('span', {
  name: 'MuiSkeleton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.animation !== false && styles[ownerState.animation], ownerState.hasChildren && styles.withChildren, ownerState.hasChildren && !ownerState.width && styles.fitContent, ownerState.hasChildren && !ownerState.height && styles.heightAuto];
  }
})(({
  theme,
  ownerState
}) => {
  const radiusUnit = (0, _styles$3.unstable_getUnit)(theme.shape.borderRadius) || 'px';
  const radiusValue = (0, _styles$3.unstable_toUnitless)(theme.shape.borderRadius);
  return (0, _extends2$D.default)({
    display: 'block',
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, _styles$3.alpha)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
    height: '1.2em'
  }, ownerState.variant === 'text' && {
    marginTop: 0,
    marginBottom: 0,
    height: 'auto',
    transformOrigin: '0 55%',
    transform: 'scale(1, 0.60)',
    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
    '&:empty:before': {
      content: '"\\00a0"'
    }
  }, ownerState.variant === 'circular' && {
    borderRadius: '50%'
  }, ownerState.variant === 'rounded' && {
    borderRadius: (theme.vars || theme).shape.borderRadius
  }, ownerState.hasChildren && {
    '& > *': {
      visibility: 'hidden'
    }
  }, ownerState.hasChildren && !ownerState.width && {
    maxWidth: 'fit-content'
  }, ownerState.hasChildren && !ownerState.height && {
    height: 'auto'
  });
}, ({
  ownerState
}) => ownerState.animation === 'pulse' && (0, _system.css)`
      animation: ${pulseKeyframe} 2s ease-in-out 0.5s infinite;
    `, ({
  ownerState,
  theme
}) => ownerState.animation === 'wave' && (0, _system.css)`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${waveKeyframe} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${(theme.vars || theme).palette.action.hover},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `);
const Skeleton = /*#__PURE__*/React$W.forwardRef(function Skeleton(inProps, ref) {
  const props = (0, _DefaultPropsProvider$w.useDefaultProps)({
    props: inProps,
    name: 'MuiSkeleton'
  });
  const {
      animation = 'pulse',
      className,
      component = 'span',
      height,
      style,
      variant = 'text',
      width
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$B.default)(props, _excluded$13);
  const ownerState = (0, _extends2$D.default)({}, props, {
    animation,
    component,
    variant,
    hasChildren: Boolean(other.children)
  });
  const classes = useUtilityClasses$v(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$I.jsx)(SkeletonRoot, (0, _extends2$D.default)({
    as: component,
    ref: ref,
    className: (0, _clsx$15.default)(classes.root, className),
    ownerState: ownerState
  }, other, {
    style: (0, _extends2$D.default)({
      width,
      height
    }, style)
  }));
});
process.env.NODE_ENV !== "production" ? Skeleton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: _propTypes$$.default.oneOf(['pulse', 'wave', false]),
  /**
   * Optional children to infer width and height from.
   */
  children: _propTypes$$.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$$.default.object,
  /**
   * @ignore
   */
  className: _propTypes$$.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$$.default.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: _propTypes$$.default.oneOfType([_propTypes$$.default.number, _propTypes$$.default.string]),
  /**
   * @ignore
   */
  style: _propTypes$$.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$$.default.oneOfType([_propTypes$$.default.arrayOf(_propTypes$$.default.oneOfType([_propTypes$$.default.func, _propTypes$$.default.object, _propTypes$$.default.bool])), _propTypes$$.default.func, _propTypes$$.default.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: _propTypes$$.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$$.default.oneOf(['circular', 'rectangular', 'rounded', 'text']), _propTypes$$.default.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: _propTypes$$.default.oneOfType([_propTypes$$.default.number, _propTypes$$.default.string])
} : void 0;
Skeleton$1.default = Skeleton;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  skeletonClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Skeleton.default;
  }
});
Object.defineProperty(exports, "skeletonClasses", {
  enumerable: true,
  get: function () {
    return _skeletonClasses.default;
  }
});
var _Skeleton = _interopRequireDefault(Skeleton$1);
var _skeletonClasses = _interopRequireWildcard(skeletonClasses$1);
Object.keys(_skeletonClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _skeletonClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _skeletonClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Skeleton$2));

var Slider$4 = {};

var Slider$3 = {};

var useSlider$1 = {};

var areArraysEqual$2 = {};

Object.defineProperty(areArraysEqual$2, "__esModule", {
  value: true
});
areArraysEqual$2.default = void 0;
function areArraysEqual$1(array1, array2, itemComparer = (a, b) => a === b) {
  return array1.length === array2.length && array1.every((value, index) => itemComparer(value, array2[index]));
}
areArraysEqual$2.default = areArraysEqual$1;

var _interopRequireDefault$4C = interopRequireDefault$1.exports;
Object.defineProperty(useSlider$1, "__esModule", {
  value: true
});
useSlider$1.Identity = void 0;
useSlider$1.useSlider = useSlider;
useSlider$1.valueToPercent = valueToPercent;
var _extends2$C = _interopRequireDefault$4C(_extends$19.exports);
var React$V = _interopRequireWildcard$1R(React__default$4);
var _utils$C = utils$7;
var _extractEventHandlers$1 = _interopRequireDefault$4C(extractEventHandlers$2);
var _areArraysEqual = _interopRequireDefault$4C(areArraysEqual$2);
function _getRequireWildcardCache$1A(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1A = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1R(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1A(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const INTENTIONAL_DRAG_COUNT_THRESHOLD = 2;
function asc(a, b) {
  return a - b;
}
function findClosest(values, currentValue) {
  var _values$reduce;
  const {
    index: closestIndex
  } = (_values$reduce = values.reduce((acc, value, index) => {
    const distance = Math.abs(currentValue - value);
    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance,
        index
      };
    }
    return acc;
  }, null)) != null ? _values$reduce : {};
  return closestIndex;
}
function trackFinger(event, touchId) {
  // The event is TouchEvent
  if (touchId.current !== undefined && event.changedTouches) {
    const touchEvent = event;
    for (let i = 0; i < touchEvent.changedTouches.length; i += 1) {
      const touch = touchEvent.changedTouches[i];
      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }
    return false;
  }

  // The event is MouseEvent
  return {
    x: event.clientX,
    y: event.clientY
  };
}
function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}
function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}
function getDecimalPrecision(num) {
  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
  if (Math.abs(num) < 1) {
    const parts = num.toExponential().split('e-');
    const matissaDecimalPart = parts[0].split('.')[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }
  const decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}
function roundValueToStep(value, step, min) {
  const nearest = Math.round((value - min) / step) * step + min;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}
function setValueIndex({
  values,
  newValue,
  index
}) {
  const output = values.slice();
  output[index] = newValue;
  return output.sort(asc);
}
function focusThumb({
  sliderRef,
  activeIndex,
  setActive
}) {
  var _sliderRef$current, _doc$activeElement;
  const doc = (0, _utils$C.unstable_ownerDocument)(sliderRef.current);
  if (!((_sliderRef$current = sliderRef.current) != null && _sliderRef$current.contains(doc.activeElement)) || Number(doc == null || (_doc$activeElement = doc.activeElement) == null ? void 0 : _doc$activeElement.getAttribute('data-index')) !== activeIndex) {
    var _sliderRef$current2;
    (_sliderRef$current2 = sliderRef.current) == null || _sliderRef$current2.querySelector(`[type="range"][data-index="${activeIndex}"]`).focus();
  }
  if (setActive) {
    setActive(activeIndex);
  }
}
function areValuesEqual(newValue, oldValue) {
  if (typeof newValue === 'number' && typeof oldValue === 'number') {
    return newValue === oldValue;
  }
  if (typeof newValue === 'object' && typeof oldValue === 'object') {
    return (0, _areArraysEqual.default)(newValue, oldValue);
  }
  return false;
}
const axisProps = {
  horizontal: {
    offset: percent => ({
      left: `${percent}%`
    }),
    leap: percent => ({
      width: `${percent}%`
    })
  },
  'horizontal-reverse': {
    offset: percent => ({
      right: `${percent}%`
    }),
    leap: percent => ({
      width: `${percent}%`
    })
  },
  vertical: {
    offset: percent => ({
      bottom: `${percent}%`
    }),
    leap: percent => ({
      height: `${percent}%`
    })
  }
};
const Identity$1 = x => x;

// TODO: remove support for Safari < 13.
// https://caniuse.com/#search=touch-action
//
// Safari, on iOS, supports touch action since v13.
// Over 80% of the iOS phones are compatible
// in August 2020.
// Utilizing the CSS.supports method to check if touch-action is supported.
// Since CSS.supports is supported on all but Edge@12 and IE and touch-action
// is supported on both Edge@12 and IE if CSS.supports is not available that means that
// touch-action will be supported
useSlider$1.Identity = Identity$1;
let cachedSupportsTouchActionNone;
function doesSupportTouchActionNone() {
  if (cachedSupportsTouchActionNone === undefined) {
    if (typeof CSS !== 'undefined' && typeof CSS.supports === 'function') {
      cachedSupportsTouchActionNone = CSS.supports('touch-action', 'none');
    } else {
      cachedSupportsTouchActionNone = true;
    }
  }
  return cachedSupportsTouchActionNone;
}
/**
 *
 * Demos:
 *
 * - [Slider](https://mui.com/base-ui/react-slider/#hook)
 *
 * API:
 *
 * - [useSlider API](https://mui.com/base-ui/react-slider/hooks-api/#use-slider)
 */
function useSlider(parameters) {
  const {
    'aria-labelledby': ariaLabelledby,
    defaultValue,
    disabled = false,
    disableSwap = false,
    isRtl = false,
    marks: marksProp = false,
    max = 100,
    min = 0,
    name,
    onChange,
    onChangeCommitted,
    orientation = 'horizontal',
    rootRef: ref,
    scale = Identity$1,
    step = 1,
    shiftStep = 10,
    tabIndex,
    value: valueProp
  } = parameters;
  const touchId = React$V.useRef(undefined);
  // We can't use the :active browser pseudo-classes.
  // - The active state isn't triggered when clicking on the rail.
  // - The active state isn't transferred when inversing a range slider.
  const [active, setActive] = React$V.useState(-1);
  const [open, setOpen] = React$V.useState(-1);
  const [dragging, setDragging] = React$V.useState(false);
  const moveCount = React$V.useRef(0);
  const [valueDerived, setValueState] = (0, _utils$C.unstable_useControlled)({
    controlled: valueProp,
    default: defaultValue != null ? defaultValue : min,
    name: 'Slider'
  });
  const handleChange = onChange && ((event, value, thumbIndex) => {
    // Redefine target to allow name and value to be read.
    // This allows seamless integration with the most popular form libraries.
    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
    // Clone the event to not override `target` of the original event.
    const nativeEvent = event.nativeEvent || event;
    // @ts-ignore The nativeEvent is function, not object
    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
    Object.defineProperty(clonedEvent, 'target', {
      writable: true,
      value: {
        value,
        name
      }
    });
    onChange(clonedEvent, value, thumbIndex);
  });
  const range = Array.isArray(valueDerived);
  let values = range ? valueDerived.slice().sort(asc) : [valueDerived];
  values = values.map(value => value == null ? min : (0, _utils$C.clamp)(value, min, max));
  const marks = marksProp === true && step !== null ? [...Array(Math.floor((max - min) / step) + 1)].map((_, index) => ({
    value: min + step * index
  })) : marksProp || [];
  const marksValues = marks.map(mark => mark.value);
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0, _utils$C.unstable_useIsFocusVisible)();
  const [focusedThumbIndex, setFocusedThumbIndex] = React$V.useState(-1);
  const sliderRef = React$V.useRef(null);
  const handleFocusRef = (0, _utils$C.unstable_useForkRef)(focusVisibleRef, sliderRef);
  const handleRef = (0, _utils$C.unstable_useForkRef)(ref, handleFocusRef);
  const createHandleHiddenInputFocus = otherHandlers => event => {
    var _otherHandlers$onFocu;
    const index = Number(event.currentTarget.getAttribute('data-index'));
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setFocusedThumbIndex(index);
    }
    setOpen(index);
    otherHandlers == null || (_otherHandlers$onFocu = otherHandlers.onFocus) == null || _otherHandlers$onFocu.call(otherHandlers, event);
  };
  const createHandleHiddenInputBlur = otherHandlers => event => {
    var _otherHandlers$onBlur;
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setFocusedThumbIndex(-1);
    }
    setOpen(-1);
    otherHandlers == null || (_otherHandlers$onBlur = otherHandlers.onBlur) == null || _otherHandlers$onBlur.call(otherHandlers, event);
  };
  const changeValue = (event, valueInput) => {
    const index = Number(event.currentTarget.getAttribute('data-index'));
    const value = values[index];
    const marksIndex = marksValues.indexOf(value);
    let newValue = valueInput;
    if (marks && step == null) {
      const maxMarksValue = marksValues[marksValues.length - 1];
      if (newValue > maxMarksValue) {
        newValue = maxMarksValue;
      } else if (newValue < marksValues[0]) {
        newValue = marksValues[0];
      } else {
        newValue = newValue < value ? marksValues[marksIndex - 1] : marksValues[marksIndex + 1];
      }
    }
    newValue = (0, _utils$C.clamp)(newValue, min, max);
    if (range) {
      // Bound the new value to the thumb's neighbours.
      if (disableSwap) {
        newValue = (0, _utils$C.clamp)(newValue, values[index - 1] || -Infinity, values[index + 1] || Infinity);
      }
      const previousValue = newValue;
      newValue = setValueIndex({
        values,
        newValue,
        index
      });
      let activeIndex = index;

      // Potentially swap the index if needed.
      if (!disableSwap) {
        activeIndex = newValue.indexOf(previousValue);
      }
      focusThumb({
        sliderRef,
        activeIndex
      });
    }
    setValueState(newValue);
    setFocusedThumbIndex(index);
    if (handleChange && !areValuesEqual(newValue, valueDerived)) {
      handleChange(event, newValue, index);
    }
    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
  };
  const createHandleHiddenInputKeyDown = otherHandlers => event => {
    var _otherHandlers$onKeyD;
    // The Shift + Up/Down keyboard shortcuts for moving the slider makes sense to be supported
    // only if the step is defined. If the step is null, this means tha the marks are used for specifying the valid values.
    if (step !== null) {
      const index = Number(event.currentTarget.getAttribute('data-index'));
      const value = values[index];
      let newValue = null;
      if ((event.key === 'ArrowLeft' || event.key === 'ArrowDown') && event.shiftKey || event.key === 'PageDown') {
        newValue = Math.max(value - shiftStep, min);
      } else if ((event.key === 'ArrowRight' || event.key === 'ArrowUp') && event.shiftKey || event.key === 'PageUp') {
        newValue = Math.min(value + shiftStep, max);
      }
      if (newValue !== null) {
        changeValue(event, newValue);
        event.preventDefault();
      }
    }
    otherHandlers == null || (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
  };
  (0, _utils$C.unstable_useEnhancedEffect)(() => {
    if (disabled && sliderRef.current.contains(document.activeElement)) {
      var _document$activeEleme;
      // This is necessary because Firefox and Safari will keep focus
      // on a disabled element:
      // https://codesandbox.io/p/sandbox/mui-pr-22247-forked-h151h?file=/src/App.js
      // @ts-ignore
      (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur();
    }
  }, [disabled]);
  if (disabled && active !== -1) {
    setActive(-1);
  }
  if (disabled && focusedThumbIndex !== -1) {
    setFocusedThumbIndex(-1);
  }
  const createHandleHiddenInputChange = otherHandlers => event => {
    var _otherHandlers$onChan;
    (_otherHandlers$onChan = otherHandlers.onChange) == null || _otherHandlers$onChan.call(otherHandlers, event);
    // @ts-ignore
    changeValue(event, event.target.valueAsNumber);
  };
  const previousIndex = React$V.useRef(undefined);
  let axis = orientation;
  if (isRtl && orientation === 'horizontal') {
    axis += '-reverse';
  }
  const getFingerNewValue = ({
    finger,
    move = false
  }) => {
    const {
      current: slider
    } = sliderRef;
    const {
      width,
      height,
      bottom,
      left
    } = slider.getBoundingClientRect();
    let percent;
    if (axis.indexOf('vertical') === 0) {
      percent = (bottom - finger.y) / height;
    } else {
      percent = (finger.x - left) / width;
    }
    if (axis.indexOf('-reverse') !== -1) {
      percent = 1 - percent;
    }
    let newValue;
    newValue = percentToValue(percent, min, max);
    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    } else {
      const closestIndex = findClosest(marksValues, newValue);
      newValue = marksValues[closestIndex];
    }
    newValue = (0, _utils$C.clamp)(newValue, min, max);
    let activeIndex = 0;
    if (range) {
      if (!move) {
        activeIndex = findClosest(values, newValue);
      } else {
        activeIndex = previousIndex.current;
      }

      // Bound the new value to the thumb's neighbours.
      if (disableSwap) {
        newValue = (0, _utils$C.clamp)(newValue, values[activeIndex - 1] || -Infinity, values[activeIndex + 1] || Infinity);
      }
      const previousValue = newValue;
      newValue = setValueIndex({
        values,
        newValue,
        index: activeIndex
      });

      // Potentially swap the index if needed.
      if (!(disableSwap && move)) {
        activeIndex = newValue.indexOf(previousValue);
        previousIndex.current = activeIndex;
      }
    }
    return {
      newValue,
      activeIndex
    };
  };
  const handleTouchMove = (0, _utils$C.unstable_useEventCallback)(nativeEvent => {
    const finger = trackFinger(nativeEvent, touchId);
    if (!finger) {
      return;
    }
    moveCount.current += 1;

    // Cancel move in case some other element consumed a mouseup event and it was not fired.
    // @ts-ignore buttons doesn't not exists on touch event
    if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      handleTouchEnd(nativeEvent);
      return;
    }
    const {
      newValue,
      activeIndex
    } = getFingerNewValue({
      finger,
      move: true
    });
    focusThumb({
      sliderRef,
      activeIndex,
      setActive
    });
    setValueState(newValue);
    if (!dragging && moveCount.current > INTENTIONAL_DRAG_COUNT_THRESHOLD) {
      setDragging(true);
    }
    if (handleChange && !areValuesEqual(newValue, valueDerived)) {
      handleChange(nativeEvent, newValue, activeIndex);
    }
  });
  const handleTouchEnd = (0, _utils$C.unstable_useEventCallback)(nativeEvent => {
    const finger = trackFinger(nativeEvent, touchId);
    setDragging(false);
    if (!finger) {
      return;
    }
    const {
      newValue
    } = getFingerNewValue({
      finger,
      move: true
    });
    setActive(-1);
    if (nativeEvent.type === 'touchend') {
      setOpen(-1);
    }
    if (onChangeCommitted) {
      onChangeCommitted(nativeEvent, newValue);
    }
    touchId.current = undefined;

    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    stopListening();
  });
  const handleTouchStart = (0, _utils$C.unstable_useEventCallback)(nativeEvent => {
    if (disabled) {
      return;
    }
    // If touch-action: none; is not supported we need to prevent the scroll manually.
    if (!doesSupportTouchActionNone()) {
      nativeEvent.preventDefault();
    }
    const touch = nativeEvent.changedTouches[0];
    if (touch != null) {
      // A number that uniquely identifies the current finger in the touch session.
      touchId.current = touch.identifier;
    }
    const finger = trackFinger(nativeEvent, touchId);
    if (finger !== false) {
      const {
        newValue,
        activeIndex
      } = getFingerNewValue({
        finger
      });
      focusThumb({
        sliderRef,
        activeIndex,
        setActive
      });
      setValueState(newValue);
      if (handleChange && !areValuesEqual(newValue, valueDerived)) {
        handleChange(nativeEvent, newValue, activeIndex);
      }
    }
    moveCount.current = 0;
    const doc = (0, _utils$C.unstable_ownerDocument)(sliderRef.current);
    doc.addEventListener('touchmove', handleTouchMove, {
      passive: true
    });
    doc.addEventListener('touchend', handleTouchEnd, {
      passive: true
    });
  });
  const stopListening = React$V.useCallback(() => {
    const doc = (0, _utils$C.unstable_ownerDocument)(sliderRef.current);
    doc.removeEventListener('mousemove', handleTouchMove);
    doc.removeEventListener('mouseup', handleTouchEnd);
    doc.removeEventListener('touchmove', handleTouchMove);
    doc.removeEventListener('touchend', handleTouchEnd);
  }, [handleTouchEnd, handleTouchMove]);
  React$V.useEffect(() => {
    const {
      current: slider
    } = sliderRef;
    slider.addEventListener('touchstart', handleTouchStart, {
      passive: doesSupportTouchActionNone()
    });
    return () => {
      slider.removeEventListener('touchstart', handleTouchStart);
      stopListening();
    };
  }, [stopListening, handleTouchStart]);
  React$V.useEffect(() => {
    if (disabled) {
      stopListening();
    }
  }, [disabled, stopListening]);
  const createHandleMouseDown = otherHandlers => event => {
    var _otherHandlers$onMous;
    (_otherHandlers$onMous = otherHandlers.onMouseDown) == null || _otherHandlers$onMous.call(otherHandlers, event);
    if (disabled) {
      return;
    }
    if (event.defaultPrevented) {
      return;
    }

    // Only handle left clicks
    if (event.button !== 0) {
      return;
    }

    // Avoid text selection
    event.preventDefault();
    const finger = trackFinger(event, touchId);
    if (finger !== false) {
      const {
        newValue,
        activeIndex
      } = getFingerNewValue({
        finger
      });
      focusThumb({
        sliderRef,
        activeIndex,
        setActive
      });
      setValueState(newValue);
      if (handleChange && !areValuesEqual(newValue, valueDerived)) {
        handleChange(event, newValue, activeIndex);
      }
    }
    moveCount.current = 0;
    const doc = (0, _utils$C.unstable_ownerDocument)(sliderRef.current);
    doc.addEventListener('mousemove', handleTouchMove, {
      passive: true
    });
    doc.addEventListener('mouseup', handleTouchEnd);
  };
  const trackOffset = valueToPercent(range ? values[0] : min, min, max);
  const trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
  const getRootProps = (externalProps = {}) => {
    const externalHandlers = (0, _extractEventHandlers$1.default)(externalProps);
    const ownEventHandlers = {
      onMouseDown: createHandleMouseDown(externalHandlers || {})
    };
    const mergedEventHandlers = (0, _extends2$C.default)({}, externalHandlers, ownEventHandlers);
    return (0, _extends2$C.default)({}, externalProps, {
      ref: handleRef
    }, mergedEventHandlers);
  };
  const createHandleMouseOver = otherHandlers => event => {
    var _otherHandlers$onMous2;
    (_otherHandlers$onMous2 = otherHandlers.onMouseOver) == null || _otherHandlers$onMous2.call(otherHandlers, event);
    const index = Number(event.currentTarget.getAttribute('data-index'));
    setOpen(index);
  };
  const createHandleMouseLeave = otherHandlers => event => {
    var _otherHandlers$onMous3;
    (_otherHandlers$onMous3 = otherHandlers.onMouseLeave) == null || _otherHandlers$onMous3.call(otherHandlers, event);
    setOpen(-1);
  };
  const getThumbProps = (externalProps = {}) => {
    const externalHandlers = (0, _extractEventHandlers$1.default)(externalProps);
    const ownEventHandlers = {
      onMouseOver: createHandleMouseOver(externalHandlers || {}),
      onMouseLeave: createHandleMouseLeave(externalHandlers || {})
    };
    return (0, _extends2$C.default)({}, externalProps, externalHandlers, ownEventHandlers);
  };
  const getThumbStyle = index => {
    return {
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: active !== -1 && active !== index ? 'none' : undefined
    };
  };
  const getHiddenInputProps = (externalProps = {}) => {
    var _parameters$step;
    const externalHandlers = (0, _extractEventHandlers$1.default)(externalProps);
    const ownEventHandlers = {
      onChange: createHandleHiddenInputChange(externalHandlers || {}),
      onFocus: createHandleHiddenInputFocus(externalHandlers || {}),
      onBlur: createHandleHiddenInputBlur(externalHandlers || {}),
      onKeyDown: createHandleHiddenInputKeyDown(externalHandlers || {})
    };
    const mergedEventHandlers = (0, _extends2$C.default)({}, externalHandlers, ownEventHandlers);
    return (0, _extends2$C.default)({
      tabIndex,
      'aria-labelledby': ariaLabelledby,
      'aria-orientation': orientation,
      'aria-valuemax': scale(max),
      'aria-valuemin': scale(min),
      name,
      type: 'range',
      min: parameters.min,
      max: parameters.max,
      step: parameters.step === null && parameters.marks ? 'any' : (_parameters$step = parameters.step) != null ? _parameters$step : undefined,
      disabled
    }, externalProps, mergedEventHandlers, {
      style: (0, _extends2$C.default)({}, _utils$C.visuallyHidden, {
        direction: isRtl ? 'rtl' : 'ltr',
        // So that VoiceOver's focus indicator matches the thumb's dimensions
        width: '100%',
        height: '100%'
      })
    });
  };
  return {
    active,
    axis: axis,
    axisProps,
    dragging,
    focusedThumbIndex,
    getHiddenInputProps,
    getRootProps,
    getThumbProps,
    marks: marks,
    open,
    range,
    rootRef: handleRef,
    trackLeap,
    trackOffset,
    values,
    getThumbStyle
  };
}

var shouldSpreadAdditionalProps$1 = {};

var _interopRequireDefault$4B = interopRequireDefault$1.exports;
Object.defineProperty(shouldSpreadAdditionalProps$1, "__esModule", {
  value: true
});
shouldSpreadAdditionalProps$1.default = void 0;
var _isHostComponent$2 = _interopRequireDefault$4B(isHostComponent$2);
const shouldSpreadAdditionalProps = Slot => {
  return !Slot || !(0, _isHostComponent$2.default)(Slot);
};
shouldSpreadAdditionalProps$1.default = shouldSpreadAdditionalProps;

var SliderValueLabel$2 = {};

var sliderClasses$1 = {};

var _interopRequireDefault$4A = interopRequireDefault$1.exports;
Object.defineProperty(sliderClasses$1, "__esModule", {
  value: true
});
sliderClasses$1.default = void 0;
sliderClasses$1.getSliderUtilityClass = getSliderUtilityClass;
var _generateUtilityClasses$u = _interopRequireDefault$4A(generateUtilityClasses$3);
var _generateUtilityClass$u = _interopRequireDefault$4A(generateUtilityClass$3);
function getSliderUtilityClass(slot) {
  return (0, _generateUtilityClass$u.default)('MuiSlider', slot);
}
const sliderClasses = (0, _generateUtilityClasses$u.default)('MuiSlider', ['root', 'active', 'colorPrimary', 'colorSecondary', 'colorError', 'colorInfo', 'colorSuccess', 'colorWarning', 'disabled', 'dragging', 'focusVisible', 'mark', 'markActive', 'marked', 'markLabel', 'markLabelActive', 'rail', 'sizeSmall', 'thumb', 'thumbColorPrimary', 'thumbColorSecondary', 'thumbColorError', 'thumbColorSuccess', 'thumbColorInfo', 'thumbColorWarning', 'track', 'trackInverted', 'trackFalse', 'thumbSizeSmall', 'valueLabel', 'valueLabelOpen', 'valueLabelCircle', 'valueLabelLabel', 'vertical']);
sliderClasses$1.default = sliderClasses;

var _interopRequireDefault$4z = interopRequireDefault$1.exports;
Object.defineProperty(SliderValueLabel$2, "__esModule", {
  value: true
});
SliderValueLabel$2.default = SliderValueLabel$1;
var React$U = _interopRequireWildcard$1Q(React__default$4);
var _propTypes$_ = _interopRequireDefault$4z(propTypes.exports);
var _clsx$14 = _interopRequireDefault$4z(clsx.exports);
var _sliderClasses$1 = _interopRequireDefault$4z(sliderClasses$1);
var _jsxRuntime$H = require$$11;
function _getRequireWildcardCache$1z(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1z = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1Q(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1z(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useValueLabelClasses = props => {
  const {
    open
  } = props;
  const utilityClasses = {
    offset: (0, _clsx$14.default)(open && _sliderClasses$1.default.valueLabelOpen),
    circle: _sliderClasses$1.default.valueLabelCircle,
    label: _sliderClasses$1.default.valueLabelLabel
  };
  return utilityClasses;
};

/**
 * @ignore - internal component.
 */
function SliderValueLabel$1(props) {
  const {
    children,
    className,
    value
  } = props;
  const classes = useValueLabelClasses(props);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React$U.cloneElement(children, {
    className: (0, _clsx$14.default)(children.props.className)
  }, /*#__PURE__*/(0, _jsxRuntime$H.jsxs)(React$U.Fragment, {
    children: [children.props.children, /*#__PURE__*/(0, _jsxRuntime$H.jsx)("span", {
      className: (0, _clsx$14.default)(classes.offset, className),
      "aria-hidden": true,
      children: /*#__PURE__*/(0, _jsxRuntime$H.jsx)("span", {
        className: classes.circle,
        children: /*#__PURE__*/(0, _jsxRuntime$H.jsx)("span", {
          className: classes.label,
          children: value
        })
      })
    })]
  }));
}
process.env.NODE_ENV !== "production" ? SliderValueLabel$1.propTypes = {
  children: _propTypes$_.default.element.isRequired,
  className: _propTypes$_.default.string,
  value: _propTypes$_.default.node
} : void 0;

var _interopRequireDefault$4y = interopRequireDefault$1.exports;
Object.defineProperty(Slider$3, "__esModule", {
  value: true
});
Slider$3.default = Slider$3.SliderValueLabel = Slider$3.SliderTrack = Slider$3.SliderThumb = Slider$3.SliderRoot = Slider$3.SliderRail = Slider$3.SliderMarkLabel = Slider$3.SliderMark = void 0;
var _objectWithoutPropertiesLoose2$A = _interopRequireDefault$4y(objectWithoutPropertiesLoose.exports);
var _extends2$B = _interopRequireDefault$4y(_extends$19.exports);
var React$T = _interopRequireWildcard$1P(React__default$4);
var _propTypes$Z = _interopRequireDefault$4y(propTypes.exports);
var _clsx$13 = _interopRequireDefault$4y(clsx.exports);
var _chainPropTypes$1 = _interopRequireDefault$4y(chainPropTypes$2);
var _composeClasses$u = _interopRequireDefault$4y(composeClasses$2);
var _colorManipulator$6 = colorManipulator;
var _RtlProvider$4 = RtlProvider$1;
var _useSlotProps$3 = _interopRequireDefault$4y(useSlotProps$2);
var _isHostComponent$1 = _interopRequireDefault$4y(isHostComponent$2);
var _useSlider = useSlider$1;
var _zeroStyled$1 = zeroStyled;
var _DefaultPropsProvider$v = DefaultPropsProvider$5;
var _slotShouldForwardProp = _interopRequireDefault$4y(slotShouldForwardProp$1);
var _shouldSpreadAdditionalProps = _interopRequireDefault$4y(shouldSpreadAdditionalProps$1);
var _capitalize$c = _interopRequireDefault$4y(capitalize$1);
var _SliderValueLabel = _interopRequireDefault$4y(SliderValueLabel$2);
var _sliderClasses = _interopRequireWildcard$1P(sliderClasses$1);
var _jsxRuntime$G = require$$11;
const _excluded$12 = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "shiftStep", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];
function _getRequireWildcardCache$1y(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1y = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1P(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1y(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Identity(x) {
  return x;
}
const SliderRoot = Slider$3.SliderRoot = (0, _zeroStyled$1.styled)('span', {
  name: 'MuiSlider',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${(0, _capitalize$c.default)(ownerState.color)}`], ownerState.size !== 'medium' && styles[`size${(0, _capitalize$c.default)(ownerState.size)}`], ownerState.marked && styles.marked, ownerState.orientation === 'vertical' && styles.vertical, ownerState.track === 'inverted' && styles.trackInverted, ownerState.track === false && styles.trackFalse];
  }
})(({
  theme
}) => {
  var _theme$vars;
  return {
    borderRadius: 12,
    boxSizing: 'content-box',
    display: 'inline-block',
    position: 'relative',
    cursor: 'pointer',
    touchAction: 'none',
    WebkitTapHighlightColor: 'transparent',
    '@media print': {
      colorAdjust: 'exact'
    },
    [`&.${_sliderClasses.default.disabled}`]: {
      pointerEvents: 'none',
      cursor: 'default',
      color: (theme.vars || theme).palette.grey[400]
    },
    [`&.${_sliderClasses.default.dragging}`]: {
      [`& .${_sliderClasses.default.thumb}, & .${_sliderClasses.default.track}`]: {
        transition: 'none'
      }
    },
    variants: [...Object.keys(((_theme$vars = theme.vars) != null ? _theme$vars : theme).palette).filter(key => {
      var _theme$vars2;
      return ((_theme$vars2 = theme.vars) != null ? _theme$vars2 : theme).palette[key].main;
    }).map(color => ({
      props: {
        color
      },
      style: {
        color: (theme.vars || theme).palette[color].main
      }
    })), {
      props: {
        orientation: 'horizontal'
      },
      style: {
        height: 4,
        width: '100%',
        padding: '13px 0',
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        '@media (pointer: coarse)': {
          // Reach 42px touch target, about ~8mm on screen.
          padding: '20px 0'
        }
      }
    }, {
      props: {
        orientation: 'horizontal',
        size: 'small'
      },
      style: {
        height: 2
      }
    }, {
      props: {
        orientation: 'horizontal',
        marked: true
      },
      style: {
        marginBottom: 20
      }
    }, {
      props: {
        orientation: 'vertical'
      },
      style: {
        height: '100%',
        width: 4,
        padding: '0 13px',
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        '@media (pointer: coarse)': {
          // Reach 42px touch target, about ~8mm on screen.
          padding: '0 20px'
        }
      }
    }, {
      props: {
        orientation: 'vertical',
        size: 'small'
      },
      style: {
        width: 2
      }
    }, {
      props: {
        orientation: 'vertical',
        marked: true
      },
      style: {
        marginRight: 44
      }
    }]
  };
});
const SliderRail = Slider$3.SliderRail = (0, _zeroStyled$1.styled)('span', {
  name: 'MuiSlider',
  slot: 'Rail',
  overridesResolver: (props, styles) => styles.rail
})({
  display: 'block',
  position: 'absolute',
  borderRadius: 'inherit',
  backgroundColor: 'currentColor',
  opacity: 0.38,
  variants: [{
    props: {
      orientation: 'horizontal'
    },
    style: {
      width: '100%',
      height: 'inherit',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  }, {
    props: {
      orientation: 'vertical'
    },
    style: {
      height: '100%',
      width: 'inherit',
      left: '50%',
      transform: 'translateX(-50%)'
    }
  }, {
    props: {
      track: 'inverted'
    },
    style: {
      opacity: 1
    }
  }]
});
const SliderTrack = Slider$3.SliderTrack = (0, _zeroStyled$1.styled)('span', {
  name: 'MuiSlider',
  slot: 'Track',
  overridesResolver: (props, styles) => styles.track
})(({
  theme
}) => {
  var _theme$vars3;
  return {
    display: 'block',
    position: 'absolute',
    borderRadius: 'inherit',
    border: '1px solid currentColor',
    backgroundColor: 'currentColor',
    transition: theme.transitions.create(['left', 'width', 'bottom', 'height'], {
      duration: theme.transitions.duration.shortest
    }),
    variants: [{
      props: {
        size: 'small'
      },
      style: {
        border: 'none'
      }
    }, {
      props: {
        orientation: 'horizontal'
      },
      style: {
        height: 'inherit',
        top: '50%',
        transform: 'translateY(-50%)'
      }
    }, {
      props: {
        orientation: 'vertical'
      },
      style: {
        width: 'inherit',
        left: '50%',
        transform: 'translateX(-50%)'
      }
    }, {
      props: {
        track: false
      },
      style: {
        display: 'none'
      }
    }, ...Object.keys(((_theme$vars3 = theme.vars) != null ? _theme$vars3 : theme).palette).filter(key => {
      var _theme$vars4;
      return ((_theme$vars4 = theme.vars) != null ? _theme$vars4 : theme).palette[key].main;
    }).map(color => ({
      props: {
        color,
        track: 'inverted'
      },
      style: (0, _extends2$B.default)({}, theme.vars ? {
        backgroundColor: theme.vars.palette.Slider[`${color}Track`],
        borderColor: theme.vars.palette.Slider[`${color}Track`]
      } : (0, _extends2$B.default)({
        backgroundColor: (0, _colorManipulator$6.lighten)(theme.palette[color].main, 0.62),
        borderColor: (0, _colorManipulator$6.lighten)(theme.palette[color].main, 0.62)
      }, theme.applyStyles('dark', {
        backgroundColor: (0, _colorManipulator$6.darken)(theme.palette[color].main, 0.5)
      }), theme.applyStyles('dark', {
        borderColor: (0, _colorManipulator$6.darken)(theme.palette[color].main, 0.5)
      })))
    }))]
  };
});
const SliderThumb = Slider$3.SliderThumb = (0, _zeroStyled$1.styled)('span', {
  name: 'MuiSlider',
  slot: 'Thumb',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.thumb, styles[`thumbColor${(0, _capitalize$c.default)(ownerState.color)}`], ownerState.size !== 'medium' && styles[`thumbSize${(0, _capitalize$c.default)(ownerState.size)}`]];
  }
})(({
  theme
}) => {
  var _theme$vars5;
  return {
    position: 'absolute',
    width: 20,
    height: 20,
    boxSizing: 'border-box',
    borderRadius: '50%',
    outline: 0,
    backgroundColor: 'currentColor',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: theme.transitions.create(['box-shadow', 'left', 'bottom'], {
      duration: theme.transitions.duration.shortest
    }),
    '&::before': {
      position: 'absolute',
      content: '""',
      borderRadius: 'inherit',
      width: '100%',
      height: '100%',
      boxShadow: (theme.vars || theme).shadows[2]
    },
    '&::after': {
      position: 'absolute',
      content: '""',
      borderRadius: '50%',
      // 42px is the hit target
      width: 42,
      height: 42,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    [`&.${_sliderClasses.default.disabled}`]: {
      '&:hover': {
        boxShadow: 'none'
      }
    },
    variants: [{
      props: {
        size: 'small'
      },
      style: {
        width: 12,
        height: 12,
        '&::before': {
          boxShadow: 'none'
        }
      }
    }, {
      props: {
        orientation: 'horizontal'
      },
      style: {
        top: '50%',
        transform: 'translate(-50%, -50%)'
      }
    }, {
      props: {
        orientation: 'vertical'
      },
      style: {
        left: '50%',
        transform: 'translate(-50%, 50%)'
      }
    }, ...Object.keys(((_theme$vars5 = theme.vars) != null ? _theme$vars5 : theme).palette).filter(key => {
      var _theme$vars6;
      return ((_theme$vars6 = theme.vars) != null ? _theme$vars6 : theme).palette[key].main;
    }).map(color => ({
      props: {
        color
      },
      style: {
        [`&:hover, &.${_sliderClasses.default.focusVisible}`]: (0, _extends2$B.default)({}, theme.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${(0, _colorManipulator$6.alpha)(theme.palette[color].main, 0.16)}`
        }, {
          '@media (hover: none)': {
            boxShadow: 'none'
          }
        }),
        [`&.${_sliderClasses.default.active}`]: (0, _extends2$B.default)({}, theme.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${theme.vars.palette[color].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${(0, _colorManipulator$6.alpha)(theme.palette[color].main, 0.16)}`
        })
      }
    }))]
  };
});
const SliderValueLabel = Slider$3.SliderValueLabel = (0, _zeroStyled$1.styled)(_SliderValueLabel.default, {
  name: 'MuiSlider',
  slot: 'ValueLabel',
  overridesResolver: (props, styles) => styles.valueLabel
})(({
  theme
}) => (0, _extends2$B.default)({
  zIndex: 1,
  whiteSpace: 'nowrap'
}, theme.typography.body2, {
  fontWeight: 500,
  transition: theme.transitions.create(['transform'], {
    duration: theme.transitions.duration.shortest
  }),
  position: 'absolute',
  backgroundColor: (theme.vars || theme).palette.grey[600],
  borderRadius: 2,
  color: (theme.vars || theme).palette.common.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0.25rem 0.75rem',
  variants: [{
    props: {
      orientation: 'horizontal'
    },
    style: {
      transform: 'translateY(-100%) scale(0)',
      top: '-10px',
      transformOrigin: 'bottom center',
      '&::before': {
        position: 'absolute',
        content: '""',
        width: 8,
        height: 8,
        transform: 'translate(-50%, 50%) rotate(45deg)',
        backgroundColor: 'inherit',
        bottom: 0,
        left: '50%'
      },
      [`&.${_sliderClasses.default.valueLabelOpen}`]: {
        transform: 'translateY(-100%) scale(1)'
      }
    }
  }, {
    props: {
      orientation: 'vertical'
    },
    style: {
      transform: 'translateY(-50%) scale(0)',
      right: '30px',
      top: '50%',
      transformOrigin: 'right center',
      '&::before': {
        position: 'absolute',
        content: '""',
        width: 8,
        height: 8,
        transform: 'translate(-50%, -50%) rotate(45deg)',
        backgroundColor: 'inherit',
        right: -8,
        top: '50%'
      },
      [`&.${_sliderClasses.default.valueLabelOpen}`]: {
        transform: 'translateY(-50%) scale(1)'
      }
    }
  }, {
    props: {
      size: 'small'
    },
    style: {
      fontSize: theme.typography.pxToRem(12),
      padding: '0.25rem 0.5rem'
    }
  }, {
    props: {
      orientation: 'vertical',
      size: 'small'
    },
    style: {
      right: '20px'
    }
  }]
}));
const SliderMark = Slider$3.SliderMark = (0, _zeroStyled$1.styled)('span', {
  name: 'MuiSlider',
  slot: 'Mark',
  shouldForwardProp: prop => (0, _slotShouldForwardProp.default)(prop) && prop !== 'markActive',
  overridesResolver: (props, styles) => {
    const {
      markActive
    } = props;
    return [styles.mark, markActive && styles.markActive];
  }
})(({
  theme
}) => ({
  position: 'absolute',
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: 'currentColor',
  variants: [{
    props: {
      orientation: 'horizontal'
    },
    style: {
      top: '50%',
      transform: 'translate(-1px, -50%)'
    }
  }, {
    props: {
      orientation: 'vertical'
    },
    style: {
      left: '50%',
      transform: 'translate(-50%, 1px)'
    }
  }, {
    props: {
      markActive: true
    },
    style: {
      backgroundColor: (theme.vars || theme).palette.background.paper,
      opacity: 0.8
    }
  }]
}));
const SliderMarkLabel = Slider$3.SliderMarkLabel = (0, _zeroStyled$1.styled)('span', {
  name: 'MuiSlider',
  slot: 'MarkLabel',
  shouldForwardProp: prop => (0, _slotShouldForwardProp.default)(prop) && prop !== 'markLabelActive',
  overridesResolver: (props, styles) => styles.markLabel
})(({
  theme
}) => (0, _extends2$B.default)({}, theme.typography.body2, {
  color: (theme.vars || theme).palette.text.secondary,
  position: 'absolute',
  whiteSpace: 'nowrap',
  variants: [{
    props: {
      orientation: 'horizontal'
    },
    style: {
      top: 30,
      transform: 'translateX(-50%)',
      '@media (pointer: coarse)': {
        top: 40
      }
    }
  }, {
    props: {
      orientation: 'vertical'
    },
    style: {
      left: 36,
      transform: 'translateY(50%)',
      '@media (pointer: coarse)': {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: true
    },
    style: {
      color: (theme.vars || theme).palette.text.primary
    }
  }]
}));
const useUtilityClasses$u = ownerState => {
  const {
    disabled,
    dragging,
    marked,
    orientation,
    track,
    classes,
    color,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', dragging && 'dragging', marked && 'marked', orientation === 'vertical' && 'vertical', track === 'inverted' && 'trackInverted', track === false && 'trackFalse', color && `color${(0, _capitalize$c.default)(color)}`, size && `size${(0, _capitalize$c.default)(size)}`],
    rail: ['rail'],
    track: ['track'],
    mark: ['mark'],
    markActive: ['markActive'],
    markLabel: ['markLabel'],
    markLabelActive: ['markLabelActive'],
    valueLabel: ['valueLabel'],
    thumb: ['thumb', disabled && 'disabled', size && `thumbSize${(0, _capitalize$c.default)(size)}`, color && `thumbColor${(0, _capitalize$c.default)(color)}`],
    active: ['active'],
    disabled: ['disabled'],
    focusVisible: ['focusVisible']
  };
  return (0, _composeClasses$u.default)(slots, _sliderClasses.getSliderUtilityClass, classes);
};
const Forward = ({
  children
}) => children;
const Slider$2 = /*#__PURE__*/React$T.forwardRef(function Slider(inputProps, ref) {
  var _ref, _slots$root, _ref2, _slots$rail, _ref3, _slots$track, _ref4, _slots$thumb, _ref5, _slots$valueLabel, _ref6, _slots$mark, _ref7, _slots$markLabel, _ref8, _slots$input, _slotProps$root, _slotProps$rail, _slotProps$track, _slotProps$thumb, _slotProps$valueLabel, _slotProps$mark, _slotProps$markLabel, _slotProps$input;
  const props = (0, _DefaultPropsProvider$v.useDefaultProps)({
    props: inputProps,
    name: 'MuiSlider'
  });
  const isRtl = (0, _RtlProvider$4.useRtl)();
  const {
      'aria-label': ariaLabel,
      'aria-valuetext': ariaValuetext,
      'aria-labelledby': ariaLabelledby,
      // eslint-disable-next-line react/prop-types
      component = 'span',
      components = {},
      componentsProps = {},
      color = 'primary',
      classes: classesProp,
      className,
      disableSwap = false,
      disabled = false,
      getAriaLabel,
      getAriaValueText,
      marks: marksProp = false,
      max = 100,
      min = 0,
      orientation = 'horizontal',
      shiftStep = 10,
      size = 'medium',
      step = 1,
      scale = Identity,
      slotProps,
      slots,
      track = 'normal',
      valueLabelDisplay = 'off',
      valueLabelFormat = Identity
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$A.default)(props, _excluded$12);
  const ownerState = (0, _extends2$B.default)({}, props, {
    isRtl,
    max,
    min,
    classes: classesProp,
    disabled,
    disableSwap,
    orientation,
    marks: marksProp,
    color,
    size,
    step,
    shiftStep,
    scale,
    track,
    valueLabelDisplay,
    valueLabelFormat
  });
  const {
    axisProps,
    getRootProps,
    getHiddenInputProps,
    getThumbProps,
    open,
    active,
    axis,
    focusedThumbIndex,
    range,
    dragging,
    marks,
    values,
    trackOffset,
    trackLeap,
    getThumbStyle
  } = (0, _useSlider.useSlider)((0, _extends2$B.default)({}, ownerState, {
    rootRef: ref
  }));
  ownerState.marked = marks.length > 0 && marks.some(mark => mark.label);
  ownerState.dragging = dragging;
  ownerState.focusedThumbIndex = focusedThumbIndex;
  const classes = useUtilityClasses$u(ownerState);

  // support both `slots` and `components` for backward compatibility
  const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : SliderRoot;
  const RailSlot = (_ref2 = (_slots$rail = slots == null ? void 0 : slots.rail) != null ? _slots$rail : components.Rail) != null ? _ref2 : SliderRail;
  const TrackSlot = (_ref3 = (_slots$track = slots == null ? void 0 : slots.track) != null ? _slots$track : components.Track) != null ? _ref3 : SliderTrack;
  const ThumbSlot = (_ref4 = (_slots$thumb = slots == null ? void 0 : slots.thumb) != null ? _slots$thumb : components.Thumb) != null ? _ref4 : SliderThumb;
  const ValueLabelSlot = (_ref5 = (_slots$valueLabel = slots == null ? void 0 : slots.valueLabel) != null ? _slots$valueLabel : components.ValueLabel) != null ? _ref5 : SliderValueLabel;
  const MarkSlot = (_ref6 = (_slots$mark = slots == null ? void 0 : slots.mark) != null ? _slots$mark : components.Mark) != null ? _ref6 : SliderMark;
  const MarkLabelSlot = (_ref7 = (_slots$markLabel = slots == null ? void 0 : slots.markLabel) != null ? _slots$markLabel : components.MarkLabel) != null ? _ref7 : SliderMarkLabel;
  const InputSlot = (_ref8 = (_slots$input = slots == null ? void 0 : slots.input) != null ? _slots$input : components.Input) != null ? _ref8 : 'input';
  const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
  const railSlotProps = (_slotProps$rail = slotProps == null ? void 0 : slotProps.rail) != null ? _slotProps$rail : componentsProps.rail;
  const trackSlotProps = (_slotProps$track = slotProps == null ? void 0 : slotProps.track) != null ? _slotProps$track : componentsProps.track;
  const thumbSlotProps = (_slotProps$thumb = slotProps == null ? void 0 : slotProps.thumb) != null ? _slotProps$thumb : componentsProps.thumb;
  const valueLabelSlotProps = (_slotProps$valueLabel = slotProps == null ? void 0 : slotProps.valueLabel) != null ? _slotProps$valueLabel : componentsProps.valueLabel;
  const markSlotProps = (_slotProps$mark = slotProps == null ? void 0 : slotProps.mark) != null ? _slotProps$mark : componentsProps.mark;
  const markLabelSlotProps = (_slotProps$markLabel = slotProps == null ? void 0 : slotProps.markLabel) != null ? _slotProps$markLabel : componentsProps.markLabel;
  const inputSlotProps = (_slotProps$input = slotProps == null ? void 0 : slotProps.input) != null ? _slotProps$input : componentsProps.input;
  const rootProps = (0, _useSlotProps$3.default)({
    elementType: RootSlot,
    getSlotProps: getRootProps,
    externalSlotProps: rootSlotProps,
    externalForwardedProps: other,
    additionalProps: (0, _extends2$B.default)({}, (0, _shouldSpreadAdditionalProps.default)(RootSlot) && {
      as: component
    }),
    ownerState: (0, _extends2$B.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
    className: [classes.root, className]
  });
  const railProps = (0, _useSlotProps$3.default)({
    elementType: RailSlot,
    externalSlotProps: railSlotProps,
    ownerState,
    className: classes.rail
  });
  const trackProps = (0, _useSlotProps$3.default)({
    elementType: TrackSlot,
    externalSlotProps: trackSlotProps,
    additionalProps: {
      style: (0, _extends2$B.default)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap))
    },
    ownerState: (0, _extends2$B.default)({}, ownerState, trackSlotProps == null ? void 0 : trackSlotProps.ownerState),
    className: classes.track
  });
  const thumbProps = (0, _useSlotProps$3.default)({
    elementType: ThumbSlot,
    getSlotProps: getThumbProps,
    externalSlotProps: thumbSlotProps,
    ownerState: (0, _extends2$B.default)({}, ownerState, thumbSlotProps == null ? void 0 : thumbSlotProps.ownerState),
    className: classes.thumb
  });
  const valueLabelProps = (0, _useSlotProps$3.default)({
    elementType: ValueLabelSlot,
    externalSlotProps: valueLabelSlotProps,
    ownerState: (0, _extends2$B.default)({}, ownerState, valueLabelSlotProps == null ? void 0 : valueLabelSlotProps.ownerState),
    className: classes.valueLabel
  });
  const markProps = (0, _useSlotProps$3.default)({
    elementType: MarkSlot,
    externalSlotProps: markSlotProps,
    ownerState,
    className: classes.mark
  });
  const markLabelProps = (0, _useSlotProps$3.default)({
    elementType: MarkLabelSlot,
    externalSlotProps: markLabelSlotProps,
    ownerState,
    className: classes.markLabel
  });
  const inputSliderProps = (0, _useSlotProps$3.default)({
    elementType: InputSlot,
    getSlotProps: getHiddenInputProps,
    externalSlotProps: inputSlotProps,
    ownerState
  });
  return /*#__PURE__*/(0, _jsxRuntime$G.jsxs)(RootSlot, (0, _extends2$B.default)({}, rootProps, {
    children: [/*#__PURE__*/(0, _jsxRuntime$G.jsx)(RailSlot, (0, _extends2$B.default)({}, railProps)), /*#__PURE__*/(0, _jsxRuntime$G.jsx)(TrackSlot, (0, _extends2$B.default)({}, trackProps)), marks.filter(mark => mark.value >= min && mark.value <= max).map((mark, index) => {
      const percent = (0, _useSlider.valueToPercent)(mark.value, min, max);
      const style = axisProps[axis].offset(percent);
      let markActive;
      if (track === false) {
        markActive = values.indexOf(mark.value) !== -1;
      } else {
        markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
      }
      return /*#__PURE__*/(0, _jsxRuntime$G.jsxs)(React$T.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime$G.jsx)(MarkSlot, (0, _extends2$B.default)({
          "data-index": index
        }, markProps, !(0, _isHostComponent$1.default)(MarkSlot) && {
          markActive
        }, {
          style: (0, _extends2$B.default)({}, style, markProps.style),
          className: (0, _clsx$13.default)(markProps.className, markActive && classes.markActive)
        })), mark.label != null ? /*#__PURE__*/(0, _jsxRuntime$G.jsx)(MarkLabelSlot, (0, _extends2$B.default)({
          "aria-hidden": true,
          "data-index": index
        }, markLabelProps, !(0, _isHostComponent$1.default)(MarkLabelSlot) && {
          markLabelActive: markActive
        }, {
          style: (0, _extends2$B.default)({}, style, markLabelProps.style),
          className: (0, _clsx$13.default)(classes.markLabel, markLabelProps.className, markActive && classes.markLabelActive),
          children: mark.label
        })) : null]
      }, index);
    }), values.map((value, index) => {
      const percent = (0, _useSlider.valueToPercent)(value, min, max);
      const style = axisProps[axis].offset(percent);
      const ValueLabelComponent = valueLabelDisplay === 'off' ? Forward : ValueLabelSlot;
      return (
        /*#__PURE__*/
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        (0, _jsxRuntime$G.jsx)(ValueLabelComponent, (0, _extends2$B.default)({}, !(0, _isHostComponent$1.default)(ValueLabelComponent) && {
          valueLabelFormat,
          valueLabelDisplay,
          value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
          index,
          open: open === index || active === index || valueLabelDisplay === 'on',
          disabled
        }, valueLabelProps, {
          children: /*#__PURE__*/(0, _jsxRuntime$G.jsx)(ThumbSlot, (0, _extends2$B.default)({
            "data-index": index
          }, thumbProps, {
            className: (0, _clsx$13.default)(classes.thumb, thumbProps.className, active === index && classes.active, focusedThumbIndex === index && classes.focusVisible),
            style: (0, _extends2$B.default)({}, style, getThumbStyle(index), thumbProps.style),
            children: /*#__PURE__*/(0, _jsxRuntime$G.jsx)(InputSlot, (0, _extends2$B.default)({
              "data-index": index,
              "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
              "aria-valuenow": scale(value),
              "aria-labelledby": ariaLabelledby,
              "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
              value: values[index]
            }, inputSliderProps))
          }))
        }), index)
      );
    })]
  }));
});
process.env.NODE_ENV !== "production" ? Slider$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  'aria-label': (0, _chainPropTypes$1.default)(_propTypes$Z.default.string, props => {
    const range = Array.isArray(props.value || props.defaultValue);
    if (range && props['aria-label'] != null) {
      return new Error('MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
    }
    return null;
  }),
  /**
   * The id of the element containing a label for the slider.
   */
  'aria-labelledby': _propTypes$Z.default.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  'aria-valuetext': (0, _chainPropTypes$1.default)(_propTypes$Z.default.string, props => {
    const range = Array.isArray(props.value || props.defaultValue);
    if (range && props['aria-valuetext'] != null) {
      return new Error('MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
    }
    return null;
  }),
  /**
   * @ignore
   */
  children: _propTypes$Z.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$Z.default.object,
  /**
   * @ignore
   */
  className: _propTypes$Z.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$Z.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$Z.default.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$Z.default.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: _propTypes$Z.default.shape({
    Input: _propTypes$Z.default.elementType,
    Mark: _propTypes$Z.default.elementType,
    MarkLabel: _propTypes$Z.default.elementType,
    Rail: _propTypes$Z.default.elementType,
    Root: _propTypes$Z.default.elementType,
    Thumb: _propTypes$Z.default.elementType,
    Track: _propTypes$Z.default.elementType,
    ValueLabel: _propTypes$Z.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: _propTypes$Z.default.shape({
    input: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    mark: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    markLabel: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    rail: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    root: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    thumb: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    track: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    valueLabel: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.shape({
      children: _propTypes$Z.default.element,
      className: _propTypes$Z.default.string,
      open: _propTypes$Z.default.bool,
      style: _propTypes$Z.default.object,
      value: _propTypes$Z.default.number,
      valueLabelDisplay: _propTypes$Z.default.oneOf(['auto', 'off', 'on'])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes$Z.default.oneOfType([_propTypes$Z.default.arrayOf(_propTypes$Z.default.number), _propTypes$Z.default.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$Z.default.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: _propTypes$Z.default.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: _propTypes$Z.default.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: _propTypes$Z.default.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: _propTypes$Z.default.oneOfType([_propTypes$Z.default.arrayOf(_propTypes$Z.default.shape({
    label: _propTypes$Z.default.node,
    value: _propTypes$Z.default.number.isRequired
  })), _propTypes$Z.default.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: _propTypes$Z.default.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: _propTypes$Z.default.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: _propTypes$Z.default.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: _propTypes$Z.default.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: _propTypes$Z.default.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: _propTypes$Z.default.oneOf(['horizontal', 'vertical']),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: _propTypes$Z.default.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: _propTypes$Z.default.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: _propTypes$Z.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$Z.default.oneOf(['small', 'medium']), _propTypes$Z.default.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: _propTypes$Z.default.shape({
    input: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    mark: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    markLabel: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    rail: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    root: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    thumb: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    track: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object]),
    valueLabel: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.shape({
      children: _propTypes$Z.default.element,
      className: _propTypes$Z.default.string,
      open: _propTypes$Z.default.bool,
      style: _propTypes$Z.default.object,
      value: _propTypes$Z.default.number,
      valueLabelDisplay: _propTypes$Z.default.oneOf(['auto', 'off', 'on'])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: _propTypes$Z.default.shape({
    input: _propTypes$Z.default.elementType,
    mark: _propTypes$Z.default.elementType,
    markLabel: _propTypes$Z.default.elementType,
    rail: _propTypes$Z.default.elementType,
    root: _propTypes$Z.default.elementType,
    thumb: _propTypes$Z.default.elementType,
    track: _propTypes$Z.default.elementType,
    valueLabel: _propTypes$Z.default.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: _propTypes$Z.default.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$Z.default.oneOfType([_propTypes$Z.default.arrayOf(_propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.object, _propTypes$Z.default.bool])), _propTypes$Z.default.func, _propTypes$Z.default.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: _propTypes$Z.default.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: _propTypes$Z.default.oneOf(['inverted', 'normal', false]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: _propTypes$Z.default.oneOfType([_propTypes$Z.default.arrayOf(_propTypes$Z.default.number), _propTypes$Z.default.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: _propTypes$Z.default.oneOf(['auto', 'off', 'on']),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: _propTypes$Z.default.oneOfType([_propTypes$Z.default.func, _propTypes$Z.default.string])
} : void 0;
Slider$3.default = Slider$2;

(function (exports) {
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  sliderClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Slider.default;
  }
});
Object.defineProperty(exports, "sliderClasses", {
  enumerable: true,
  get: function () {
    return _sliderClasses.default;
  }
});
var _Slider = _interopRequireWildcard(Slider$3);
Object.keys(_Slider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Slider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Slider[key];
    }
  });
});
var _sliderClasses = _interopRequireWildcard(sliderClasses$1);
Object.keys(_sliderClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _sliderClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sliderClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Slider$4));

var Snackbar$3 = {};

var Snackbar$2 = {};

var useSnackbar$1 = {};

var _interopRequireDefault$4x = interopRequireDefault$1.exports;
Object.defineProperty(useSnackbar$1, "__esModule", {
  value: true
});
useSnackbar$1.default = void 0;
var _extends2$A = _interopRequireDefault$4x(_extends$19.exports);
var React$S = _interopRequireWildcard$1O(React__default$4);
var _utils$B = utils$7;
var _extractEventHandlers = _interopRequireDefault$4x(extractEventHandlers$2);
function _getRequireWildcardCache$1x(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1x = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1O(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1x(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */
function useSnackbar(parameters = {}) {
  const {
    autoHideDuration = null,
    disableWindowBlurListener = false,
    onClose,
    open,
    resumeHideDuration
  } = parameters;
  const timerAutoHide = (0, _utils$B.unstable_useTimeout)();
  React$S.useEffect(() => {
    if (!open) {
      return undefined;
    }

    /**
     * @param {KeyboardEvent} nativeEvent
     */
    function handleKeyDown(nativeEvent) {
      if (!nativeEvent.defaultPrevented) {
        // IE11, Edge (prior to using Blink?) use 'Esc'
        if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
          // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
          onClose == null || onClose(nativeEvent, 'escapeKeyDown');
        }
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, onClose]);
  const handleClose = (0, _utils$B.unstable_useEventCallback)((event, reason) => {
    onClose == null || onClose(event, reason);
  });
  const setAutoHideTimer = (0, _utils$B.unstable_useEventCallback)(autoHideDurationParam => {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }
    timerAutoHide.start(autoHideDurationParam, () => {
      handleClose(null, 'timeout');
    });
  });
  React$S.useEffect(() => {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }
    return timerAutoHide.clear;
  }, [open, autoHideDuration, setAutoHideTimer, timerAutoHide]);
  const handleClickAway = event => {
    onClose == null || onClose(event, 'clickaway');
  };

  // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.
  const handlePause = timerAutoHide.clear;

  // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.
  const handleResume = React$S.useCallback(() => {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
  const createHandleBlur = otherHandlers => event => {
    const onBlurCallback = otherHandlers.onBlur;
    onBlurCallback == null || onBlurCallback(event);
    handleResume();
  };
  const createHandleFocus = otherHandlers => event => {
    const onFocusCallback = otherHandlers.onFocus;
    onFocusCallback == null || onFocusCallback(event);
    handlePause();
  };
  const createMouseEnter = otherHandlers => event => {
    const onMouseEnterCallback = otherHandlers.onMouseEnter;
    onMouseEnterCallback == null || onMouseEnterCallback(event);
    handlePause();
  };
  const createMouseLeave = otherHandlers => event => {
    const onMouseLeaveCallback = otherHandlers.onMouseLeave;
    onMouseLeaveCallback == null || onMouseLeaveCallback(event);
    handleResume();
  };
  React$S.useEffect(() => {
    // TODO: window global should be refactored here
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return () => {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }
    return undefined;
  }, [disableWindowBlurListener, open, handleResume, handlePause]);
  const getRootProps = (externalProps = {}) => {
    const externalEventHandlers = (0, _extends2$A.default)({}, (0, _extractEventHandlers.default)(parameters), (0, _extractEventHandlers.default)(externalProps));
    return (0, _extends2$A.default)({
      // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
      // See https://github.com/mui/material-ui/issues/29080
      role: 'presentation'
    }, externalProps, externalEventHandlers, {
      onBlur: createHandleBlur(externalEventHandlers),
      onFocus: createHandleFocus(externalEventHandlers),
      onMouseEnter: createMouseEnter(externalEventHandlers),
      onMouseLeave: createMouseLeave(externalEventHandlers)
    });
  };
  return {
    getRootProps,
    onClickAway: handleClickAway
  };
}
useSnackbar$1.default = useSnackbar;

var SnackbarContent$2 = {};

var SnackbarContent$1 = {};

var snackbarContentClasses$1 = {};

var _interopRequireDefault$4w = interopRequireDefault$1.exports;
Object.defineProperty(snackbarContentClasses$1, "__esModule", {
  value: true
});
snackbarContentClasses$1.default = void 0;
snackbarContentClasses$1.getSnackbarContentUtilityClass = getSnackbarContentUtilityClass;
var _generateUtilityClasses$t = _interopRequireDefault$4w(generateUtilityClasses$3);
var _generateUtilityClass$t = _interopRequireDefault$4w(generateUtilityClass$3);
function getSnackbarContentUtilityClass(slot) {
  return (0, _generateUtilityClass$t.default)('MuiSnackbarContent', slot);
}
const snackbarContentClasses = (0, _generateUtilityClasses$t.default)('MuiSnackbarContent', ['root', 'message', 'action']);
snackbarContentClasses$1.default = snackbarContentClasses;

var _interopRequireDefault$4v = interopRequireDefault$1.exports;
Object.defineProperty(SnackbarContent$1, "__esModule", {
  value: true
});
SnackbarContent$1.default = void 0;
var _objectWithoutPropertiesLoose2$z = _interopRequireDefault$4v(objectWithoutPropertiesLoose.exports);
var _extends2$z = _interopRequireDefault$4v(_extends$19.exports);
var React$R = _interopRequireWildcard$1N(React__default$4);
var _propTypes$Y = _interopRequireDefault$4v(propTypes.exports);
var _clsx$12 = _interopRequireDefault$4v(clsx.exports);
var _composeClasses$t = _interopRequireDefault$4v(composeClasses$2);
var _colorManipulator$5 = colorManipulator;
var _styled$r = _interopRequireDefault$4v(styled$2);
var _DefaultPropsProvider$u = DefaultPropsProvider$5;
var _Paper = _interopRequireDefault$4v(Paper$3);
var _snackbarContentClasses = snackbarContentClasses$1;
var _jsxRuntime$F = require$$11;
const _excluded$11 = ["action", "className", "message", "role"];
function _getRequireWildcardCache$1w(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1w = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1N(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1w(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$t = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    action: ['action'],
    message: ['message']
  };
  return (0, _composeClasses$t.default)(slots, _snackbarContentClasses.getSnackbarContentUtilityClass, classes);
};
const SnackbarContentRoot = (0, _styled$r.default)(_Paper.default, {
  name: 'MuiSnackbarContent',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => {
  const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
  const backgroundColor = (0, _colorManipulator$5.emphasize)(theme.palette.background.default, emphasis);
  return (0, _extends2$z.default)({}, theme.typography.body2, {
    color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
    backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '6px 16px',
    borderRadius: (theme.vars || theme).shape.borderRadius,
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      flexGrow: 'initial',
      minWidth: 288
    }
  });
});
const SnackbarContentMessage = (0, _styled$r.default)('div', {
  name: 'MuiSnackbarContent',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0'
});
const SnackbarContentAction = (0, _styled$r.default)('div', {
  name: 'MuiSnackbarContent',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
  paddingLeft: 16,
  marginRight: -8
});
const SnackbarContent = /*#__PURE__*/React$R.forwardRef(function SnackbarContent(inProps, ref) {
  const props = (0, _DefaultPropsProvider$u.useDefaultProps)({
    props: inProps,
    name: 'MuiSnackbarContent'
  });
  const {
      action,
      className,
      message,
      role = 'alert'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$z.default)(props, _excluded$11);
  const ownerState = props;
  const classes = useUtilityClasses$t(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$F.jsxs)(SnackbarContentRoot, (0, _extends2$z.default)({
    role: role,
    square: true,
    elevation: 6,
    className: (0, _clsx$12.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/(0, _jsxRuntime$F.jsx)(SnackbarContentMessage, {
      className: classes.message,
      ownerState: ownerState,
      children: message
    }), action ? /*#__PURE__*/(0, _jsxRuntime$F.jsx)(SnackbarContentAction, {
      className: classes.action,
      ownerState: ownerState,
      children: action
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" ? SnackbarContent.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: _propTypes$Y.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$Y.default.object,
  /**
   * @ignore
   */
  className: _propTypes$Y.default.string,
  /**
   * The message to display.
   */
  message: _propTypes$Y.default.node,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: _propTypes$Y.default /* @typescript-to-proptypes-ignore */.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$Y.default.oneOfType([_propTypes$Y.default.arrayOf(_propTypes$Y.default.oneOfType([_propTypes$Y.default.func, _propTypes$Y.default.object, _propTypes$Y.default.bool])), _propTypes$Y.default.func, _propTypes$Y.default.object])
} : void 0;
SnackbarContent$1.default = SnackbarContent;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  snackbarContentClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SnackbarContent.default;
  }
});
Object.defineProperty(exports, "snackbarContentClasses", {
  enumerable: true,
  get: function () {
    return _snackbarContentClasses.default;
  }
});
var _SnackbarContent = _interopRequireDefault(SnackbarContent$1);
var _snackbarContentClasses = _interopRequireWildcard(snackbarContentClasses$1);
Object.keys(_snackbarContentClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _snackbarContentClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _snackbarContentClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(SnackbarContent$2));

var snackbarClasses$1 = {};

var _interopRequireDefault$4u = interopRequireDefault$1.exports;
Object.defineProperty(snackbarClasses$1, "__esModule", {
  value: true
});
snackbarClasses$1.default = void 0;
snackbarClasses$1.getSnackbarUtilityClass = getSnackbarUtilityClass;
var _generateUtilityClasses$s = _interopRequireDefault$4u(generateUtilityClasses$3);
var _generateUtilityClass$s = _interopRequireDefault$4u(generateUtilityClass$3);
function getSnackbarUtilityClass(slot) {
  return (0, _generateUtilityClass$s.default)('MuiSnackbar', slot);
}
const snackbarClasses = (0, _generateUtilityClasses$s.default)('MuiSnackbar', ['root', 'anchorOriginTopCenter', 'anchorOriginBottomCenter', 'anchorOriginTopRight', 'anchorOriginBottomRight', 'anchorOriginTopLeft', 'anchorOriginBottomLeft']);
snackbarClasses$1.default = snackbarClasses;

var _interopRequireDefault$4t = interopRequireDefault$1.exports;
Object.defineProperty(Snackbar$2, "__esModule", {
  value: true
});
Snackbar$2.default = void 0;
var _objectWithoutPropertiesLoose2$y = _interopRequireDefault$4t(objectWithoutPropertiesLoose.exports);
var _extends2$y = _interopRequireDefault$4t(_extends$19.exports);
var React$Q = _interopRequireWildcard$1M(React__default$4);
var _propTypes$X = _interopRequireDefault$4t(propTypes.exports);
var _composeClasses$s = _interopRequireDefault$4t(composeClasses$2);
var _useSlotProps$2 = _interopRequireDefault$4t(useSlotProps$2);
var _useSnackbar = _interopRequireDefault$4t(useSnackbar$1);
var _ClickAwayListener = _interopRequireDefault$4t(ClickAwayListener$2);
var _styles$2 = styles$u;
var _DefaultPropsProvider$t = DefaultPropsProvider$5;
var _capitalize$b = _interopRequireDefault$4t(capitalize$1);
var _Grow$1 = _interopRequireDefault$4t(Grow$2);
var _SnackbarContent = _interopRequireDefault$4t(SnackbarContent$2);
var _snackbarClasses = snackbarClasses$1;
var _jsxRuntime$E = require$$11;
const _excluded$10 = ["onEnter", "onExited"],
  _excluded2$e = ["action", "anchorOrigin", "autoHideDuration", "children", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onBlur", "onClose", "onFocus", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"];
function _getRequireWildcardCache$1v(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1v = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1M(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1v(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$s = ownerState => {
  const {
    classes,
    anchorOrigin
  } = ownerState;
  const slots = {
    root: ['root', `anchorOrigin${(0, _capitalize$b.default)(anchorOrigin.vertical)}${(0, _capitalize$b.default)(anchorOrigin.horizontal)}`]
  };
  return (0, _composeClasses$s.default)(slots, _snackbarClasses.getSnackbarUtilityClass, classes);
};
const SnackbarRoot = (0, _styles$2.styled)('div', {
  name: 'MuiSnackbar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`anchorOrigin${(0, _capitalize$b.default)(ownerState.anchorOrigin.vertical)}${(0, _capitalize$b.default)(ownerState.anchorOrigin.horizontal)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return (0, _extends2$y.default)({
    zIndex: (theme.vars || theme).zIndex.snackbar,
    position: 'fixed',
    display: 'flex',
    left: 8,
    right: 8,
    justifyContent: 'center',
    alignItems: 'center'
  }, ownerState.anchorOrigin.vertical === 'top' ? {
    top: 8
  } : {
    bottom: 8
  }, ownerState.anchorOrigin.horizontal === 'left' && {
    justifyContent: 'flex-start'
  }, ownerState.anchorOrigin.horizontal === 'right' && {
    justifyContent: 'flex-end'
  }, {
    [theme.breakpoints.up('sm')]: (0, _extends2$y.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
      top: 24
    } : {
      bottom: 24
    }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
      left: 24,
      right: 'auto'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
      right: 24,
      left: 'auto'
    })
  });
});
const Snackbar$1 = /*#__PURE__*/React$Q.forwardRef(function Snackbar(inProps, ref) {
  const props = (0, _DefaultPropsProvider$t.useDefaultProps)({
    props: inProps,
    name: 'MuiSnackbar'
  });
  const theme = (0, _styles$2.useTheme)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      action,
      anchorOrigin: {
        vertical,
        horizontal
      } = {
        vertical: 'bottom',
        horizontal: 'left'
      },
      autoHideDuration = null,
      children,
      className,
      ClickAwayListenerProps,
      ContentProps,
      disableWindowBlurListener = false,
      message,
      open,
      TransitionComponent = _Grow$1.default,
      transitionDuration = defaultTransitionDuration,
      TransitionProps: {
        onEnter,
        onExited
      } = {}
    } = props,
    TransitionProps = (0, _objectWithoutPropertiesLoose2$y.default)(props.TransitionProps, _excluded$10),
    other = (0, _objectWithoutPropertiesLoose2$y.default)(props, _excluded2$e);
  const ownerState = (0, _extends2$y.default)({}, props, {
    anchorOrigin: {
      vertical,
      horizontal
    },
    autoHideDuration,
    disableWindowBlurListener,
    TransitionComponent,
    transitionDuration
  });
  const classes = useUtilityClasses$s(ownerState);
  const {
    getRootProps,
    onClickAway
  } = (0, _useSnackbar.default)((0, _extends2$y.default)({}, ownerState));
  const [exited, setExited] = React$Q.useState(true);
  const rootProps = (0, _useSlotProps$2.default)({
    elementType: SnackbarRoot,
    getSlotProps: getRootProps,
    externalForwardedProps: other,
    ownerState,
    additionalProps: {
      ref
    },
    className: [classes.root, className]
  });
  const handleExited = node => {
    setExited(true);
    if (onExited) {
      onExited(node);
    }
  };
  const handleEnter = (node, isAppearing) => {
    setExited(false);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  // So we only render active snackbars.
  if (!open && exited) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime$E.jsx)(_ClickAwayListener.default, (0, _extends2$y.default)({
    onClickAway: onClickAway
  }, ClickAwayListenerProps, {
    children: /*#__PURE__*/(0, _jsxRuntime$E.jsx)(SnackbarRoot, (0, _extends2$y.default)({}, rootProps, {
      children: /*#__PURE__*/(0, _jsxRuntime$E.jsx)(TransitionComponent, (0, _extends2$y.default)({
        appear: true,
        in: open,
        timeout: transitionDuration,
        direction: vertical === 'top' ? 'down' : 'up',
        onEnter: handleEnter,
        onExited: handleExited
      }, TransitionProps, {
        children: children || /*#__PURE__*/(0, _jsxRuntime$E.jsx)(_SnackbarContent.default, (0, _extends2$y.default)({
          message: message,
          action: action
        }, ContentProps))
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" ? Snackbar$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: _propTypes$X.default.node,
  /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */
  anchorOrigin: _propTypes$X.default.shape({
    horizontal: _propTypes$X.default.oneOf(['center', 'left', 'right']).isRequired,
    vertical: _propTypes$X.default.oneOf(['bottom', 'top']).isRequired
  }),
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */
  autoHideDuration: _propTypes$X.default.number,
  /**
   * Replace the `SnackbarContent` component.
   */
  children: _propTypes$X.default.element,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$X.default.object,
  /**
   * @ignore
   */
  className: _propTypes$X.default.string,
  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: _propTypes$X.default.object,
  /**
   * Props applied to the [`SnackbarContent`](/material-ui/api/snackbar-content/) element.
   */
  ContentProps: _propTypes$X.default.object,
  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */
  disableWindowBlurListener: _propTypes$X.default.bool,
  /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */
  key: () => null,
  /**
   * The message to display.
   */
  message: _propTypes$X.default.node,
  /**
   * @ignore
   */
  onBlur: _propTypes$X.default.func,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */
  onClose: _propTypes$X.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes$X.default.func,
  /**
   * @ignore
   */
  onMouseEnter: _propTypes$X.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes$X.default.func,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$X.default.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: _propTypes$X.default.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$X.default.oneOfType([_propTypes$X.default.arrayOf(_propTypes$X.default.oneOfType([_propTypes$X.default.func, _propTypes$X.default.object, _propTypes$X.default.bool])), _propTypes$X.default.func, _propTypes$X.default.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: _propTypes$X.default.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: _propTypes$X.default.oneOfType([_propTypes$X.default.number, _propTypes$X.default.shape({
    appear: _propTypes$X.default.number,
    enter: _propTypes$X.default.number,
    exit: _propTypes$X.default.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: _propTypes$X.default.object
} : void 0;
Snackbar$2.default = Snackbar$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  snackbarClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Snackbar.default;
  }
});
Object.defineProperty(exports, "snackbarClasses", {
  enumerable: true,
  get: function () {
    return _snackbarClasses.default;
  }
});
var _Snackbar = _interopRequireDefault(Snackbar$2);
var _snackbarClasses = _interopRequireWildcard(snackbarClasses$1);
Object.keys(_snackbarClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _snackbarClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _snackbarClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Snackbar$3));

var Snackbar = /*@__PURE__*/getDefaultExportFromCjs$1(Snackbar$3);

var SpeedDial$2 = {};

var SpeedDial$1 = {};

var Zoom$2 = {};

var Zoom$1 = {};

var _interopRequireDefault$4s = interopRequireDefault$1.exports;
Object.defineProperty(Zoom$1, "__esModule", {
  value: true
});
Zoom$1.default = void 0;
var _extends2$x = _interopRequireDefault$4s(_extends$19.exports);
var _objectWithoutPropertiesLoose2$x = _interopRequireDefault$4s(objectWithoutPropertiesLoose.exports);
var React$P = _interopRequireWildcard$1L(React__default$4);
var _propTypes$W = _interopRequireDefault$4s(propTypes.exports);
var _reactTransitionGroup$2 = cjs$4;
var _elementAcceptingRef$1 = _interopRequireDefault$4s(elementAcceptingRef$2);
var _getReactElementRef$1 = _interopRequireDefault$4s(getReactElementRef$2);
var _useTheme$3 = _interopRequireDefault$4s(useTheme$4);
var _utils$A = utils$8;
var _useForkRef$3 = _interopRequireDefault$4s(useForkRef);
var _jsxRuntime$D = require$$11;
const _excluded$$ = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function _getRequireWildcardCache$1u(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1u = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1L(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1u(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const styles$p = {
  entering: {
    transform: 'none'
  },
  entered: {
    transform: 'none'
  }
};

/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/material-ui/react-button/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
const Zoom = /*#__PURE__*/React$P.forwardRef(function Zoom(props, ref) {
  const theme = (0, _useTheme$3.default)();
  const defaultTimeout = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      addEndListener,
      appear = true,
      children,
      easing,
      in: inProp,
      onEnter,
      onEntered,
      onEntering,
      onExit,
      onExited,
      onExiting,
      style,
      timeout = defaultTimeout,
      // eslint-disable-next-line react/prop-types
      TransitionComponent = _reactTransitionGroup$2.Transition
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$x.default)(props, _excluded$$);
  const nodeRef = React$P.useRef(null);
  const handleRef = (0, _useForkRef$3.default)(nodeRef, (0, _getReactElementRef$1.default)(children), ref);
  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current;

      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };
  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    (0, _utils$A.reflow)(node); // So the animation always start from the start.

    const transitionProps = (0, _utils$A.getTransitionProps)({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0, _utils$A.getTransitionProps)({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime$D.jsx)(TransitionComponent, (0, _extends2$x.default)({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/React$P.cloneElement(children, (0, _extends2$x.default)({
        style: (0, _extends2$x.default)({
          transform: 'scale(0)',
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles$p[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
process.env.NODE_ENV !== "production" ? Zoom.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: _propTypes$W.default.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: _propTypes$W.default.bool,
  /**
   * A single child content element.
   */
  children: _elementAcceptingRef$1.default.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: _propTypes$W.default.oneOfType([_propTypes$W.default.shape({
    enter: _propTypes$W.default.string,
    exit: _propTypes$W.default.string
  }), _propTypes$W.default.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: _propTypes$W.default.bool,
  /**
   * @ignore
   */
  onEnter: _propTypes$W.default.func,
  /**
   * @ignore
   */
  onEntered: _propTypes$W.default.func,
  /**
   * @ignore
   */
  onEntering: _propTypes$W.default.func,
  /**
   * @ignore
   */
  onExit: _propTypes$W.default.func,
  /**
   * @ignore
   */
  onExited: _propTypes$W.default.func,
  /**
   * @ignore
   */
  onExiting: _propTypes$W.default.func,
  /**
   * @ignore
   */
  style: _propTypes$W.default.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: _propTypes$W.default.oneOfType([_propTypes$W.default.number, _propTypes$W.default.shape({
    appear: _propTypes$W.default.number,
    enter: _propTypes$W.default.number,
    exit: _propTypes$W.default.number
  })])
} : void 0;
Zoom$1.default = Zoom;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Zoom.default;
  }
});
var _Zoom = _interopRequireDefault(Zoom$1);
}(Zoom$2));

var speedDialClasses$1 = {};

var _interopRequireDefault$4r = interopRequireDefault$1.exports;
Object.defineProperty(speedDialClasses$1, "__esModule", {
  value: true
});
speedDialClasses$1.default = void 0;
speedDialClasses$1.getSpeedDialUtilityClass = getSpeedDialUtilityClass;
var _generateUtilityClasses$r = _interopRequireDefault$4r(generateUtilityClasses$3);
var _generateUtilityClass$r = _interopRequireDefault$4r(generateUtilityClass$3);
function getSpeedDialUtilityClass(slot) {
  return (0, _generateUtilityClass$r.default)('MuiSpeedDial', slot);
}
const speedDialClasses = (0, _generateUtilityClasses$r.default)('MuiSpeedDial', ['root', 'fab', 'directionUp', 'directionDown', 'directionLeft', 'directionRight', 'actions', 'actionsClosed']);
speedDialClasses$1.default = speedDialClasses;

var _interopRequireDefault$4q = interopRequireDefault$1.exports;
Object.defineProperty(SpeedDial$1, "__esModule", {
  value: true
});
SpeedDial$1.default = void 0;
var _objectWithoutPropertiesLoose2$w = _interopRequireDefault$4q(objectWithoutPropertiesLoose.exports);
var _extends2$w = _interopRequireDefault$4q(_extends$19.exports);
var React$O = _interopRequireWildcard$1K(React__default$4);
var _reactIs$3 = reactIs$6.exports;
var _propTypes$V = _interopRequireDefault$4q(propTypes.exports);
var _clsx$11 = _interopRequireDefault$4q(clsx.exports);
var _composeClasses$r = _interopRequireDefault$4q(composeClasses$2);
var _useTimeout$1 = _interopRequireDefault$4q(useTimeout$2);
var _clamp = _interopRequireDefault$4q(clamp$5);
var _styled$q = _interopRequireDefault$4q(styled$2);
var _DefaultPropsProvider$s = DefaultPropsProvider$5;
var _useTheme$2 = _interopRequireDefault$4q(useTheme$4);
var _Zoom = _interopRequireDefault$4q(Zoom$2);
var _Fab$1 = _interopRequireDefault$4q(Fab$2);
var _capitalize$a = _interopRequireDefault$4q(capitalize$1);
var _isMuiElement$1 = _interopRequireDefault$4q(isMuiElement);
var _useForkRef$2 = _interopRequireDefault$4q(useForkRef);
var _useControlled$1 = _interopRequireDefault$4q(useControlled);
var _speedDialClasses = _interopRequireWildcard$1K(speedDialClasses$1);
var _jsxRuntime$C = require$$11;
const _excluded$_ = ["ref"],
  _excluded2$d = ["ariaLabel", "FabProps", "children", "className", "direction", "hidden", "icon", "onBlur", "onClose", "onFocus", "onKeyDown", "onMouseEnter", "onMouseLeave", "onOpen", "open", "openIcon", "TransitionComponent", "transitionDuration", "TransitionProps"],
  _excluded3$1 = ["ref"];
function _getRequireWildcardCache$1t(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1t = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1K(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1t(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$r = ownerState => {
  const {
    classes,
    open,
    direction
  } = ownerState;
  const slots = {
    root: ['root', `direction${(0, _capitalize$a.default)(direction)}`],
    fab: ['fab'],
    actions: ['actions', !open && 'actionsClosed']
  };
  return (0, _composeClasses$r.default)(slots, _speedDialClasses.getSpeedDialUtilityClass, classes);
};
function getOrientation(direction) {
  if (direction === 'up' || direction === 'down') {
    return 'vertical';
  }
  if (direction === 'right' || direction === 'left') {
    return 'horizontal';
  }
  return undefined;
}
const dialRadius = 32;
const spacingActions = 16;
const SpeedDialRoot = (0, _styled$q.default)('div', {
  name: 'MuiSpeedDial',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`direction${(0, _capitalize$a.default)(ownerState.direction)}`]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$w.default)({
  zIndex: (theme.vars || theme).zIndex.speedDial,
  display: 'flex',
  alignItems: 'center',
  pointerEvents: 'none'
}, ownerState.direction === 'up' && {
  flexDirection: 'column-reverse',
  [`& .${_speedDialClasses.default.actions}`]: {
    flexDirection: 'column-reverse',
    marginBottom: -dialRadius,
    paddingBottom: spacingActions + dialRadius
  }
}, ownerState.direction === 'down' && {
  flexDirection: 'column',
  [`& .${_speedDialClasses.default.actions}`]: {
    flexDirection: 'column',
    marginTop: -dialRadius,
    paddingTop: spacingActions + dialRadius
  }
}, ownerState.direction === 'left' && {
  flexDirection: 'row-reverse',
  [`& .${_speedDialClasses.default.actions}`]: {
    flexDirection: 'row-reverse',
    marginRight: -dialRadius,
    paddingRight: spacingActions + dialRadius
  }
}, ownerState.direction === 'right' && {
  flexDirection: 'row',
  [`& .${_speedDialClasses.default.actions}`]: {
    flexDirection: 'row',
    marginLeft: -dialRadius,
    paddingLeft: spacingActions + dialRadius
  }
}));
const SpeedDialFab = (0, _styled$q.default)(_Fab$1.default, {
  name: 'MuiSpeedDial',
  slot: 'Fab',
  overridesResolver: (props, styles) => styles.fab
})(() => ({
  pointerEvents: 'auto'
}));
const SpeedDialActions = (0, _styled$q.default)('div', {
  name: 'MuiSpeedDial',
  slot: 'Actions',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.actions, !ownerState.open && styles.actionsClosed];
  }
})(({
  ownerState
}) => (0, _extends2$w.default)({
  display: 'flex',
  pointerEvents: 'auto'
}, !ownerState.open && {
  transition: 'top 0s linear 0.2s',
  pointerEvents: 'none'
}));
const SpeedDial = /*#__PURE__*/React$O.forwardRef(function SpeedDial(inProps, ref) {
  const props = (0, _DefaultPropsProvider$s.useDefaultProps)({
    props: inProps,
    name: 'MuiSpeedDial'
  });
  const theme = (0, _useTheme$2.default)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      ariaLabel,
      FabProps: {
        ref: origDialButtonRef
      } = {},
      children: childrenProp,
      className,
      direction = 'up',
      hidden = false,
      icon,
      onBlur,
      onClose,
      onFocus,
      onKeyDown,
      onMouseEnter,
      onMouseLeave,
      onOpen,
      open: openProp,
      TransitionComponent = _Zoom.default,
      transitionDuration = defaultTransitionDuration,
      TransitionProps
    } = props,
    FabProps = (0, _objectWithoutPropertiesLoose2$w.default)(props.FabProps, _excluded$_),
    other = (0, _objectWithoutPropertiesLoose2$w.default)(props, _excluded2$d);
  const [open, setOpenState] = (0, _useControlled$1.default)({
    controlled: openProp,
    default: false,
    name: 'SpeedDial',
    state: 'open'
  });
  const ownerState = (0, _extends2$w.default)({}, props, {
    open,
    direction
  });
  const classes = useUtilityClasses$r(ownerState);
  const eventTimer = (0, _useTimeout$1.default)();

  /**
   * an index in actions.current
   */
  const focusedAction = React$O.useRef(0);

  /**
   * pressing this key while the focus is on a child SpeedDialAction focuses
   * the next SpeedDialAction.
   * It is equal to the first arrow key pressed while focus is on the SpeedDial
   * that is not orthogonal to the direction.
   * @type {utils.ArrowKey?}
   */
  const nextItemArrowKey = React$O.useRef();

  /**
   * refs to the Button that have an action associated to them in this SpeedDial
   * [Fab, ...(SpeedDialActions > Button)]
   * @type {HTMLButtonElement[]}
   */
  const actions = React$O.useRef([]);
  actions.current = [actions.current[0]];
  const handleOwnFabRef = React$O.useCallback(fabFef => {
    actions.current[0] = fabFef;
  }, []);
  const handleFabRef = (0, _useForkRef$2.default)(origDialButtonRef, handleOwnFabRef);

  /**
   * creates a ref callback for the Button in a SpeedDialAction
   * Is called before the original ref callback for Button that was set in buttonProps
   *
   * @param dialActionIndex {number}
   * @param origButtonRef {React.RefObject?}
   */
  const createHandleSpeedDialActionButtonRef = (dialActionIndex, origButtonRef) => {
    return buttonRef => {
      actions.current[dialActionIndex + 1] = buttonRef;
      if (origButtonRef) {
        origButtonRef(buttonRef);
      }
    };
  };
  const handleKeyDown = event => {
    if (onKeyDown) {
      onKeyDown(event);
    }
    const key = event.key.replace('Arrow', '').toLowerCase();
    const {
      current: nextItemArrowKeyCurrent = key
    } = nextItemArrowKey;
    if (event.key === 'Escape') {
      setOpenState(false);
      actions.current[0].focus();
      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
      return;
    }
    if (getOrientation(key) === getOrientation(nextItemArrowKeyCurrent) && getOrientation(key) !== undefined) {
      event.preventDefault();
      const actionStep = key === nextItemArrowKeyCurrent ? 1 : -1;

      // stay within array indices
      const nextAction = (0, _clamp.default)(focusedAction.current + actionStep, 0, actions.current.length - 1);
      actions.current[nextAction].focus();
      focusedAction.current = nextAction;
      nextItemArrowKey.current = nextItemArrowKeyCurrent;
    }
  };
  React$O.useEffect(() => {
    // actions were closed while navigation state was not reset
    if (!open) {
      focusedAction.current = 0;
      nextItemArrowKey.current = undefined;
    }
  }, [open]);
  const handleClose = event => {
    if (event.type === 'mouseleave' && onMouseLeave) {
      onMouseLeave(event);
    }
    if (event.type === 'blur' && onBlur) {
      onBlur(event);
    }
    eventTimer.clear();
    if (event.type === 'blur') {
      eventTimer.start(0, () => {
        setOpenState(false);
        if (onClose) {
          onClose(event, 'blur');
        }
      });
    } else {
      setOpenState(false);
      if (onClose) {
        onClose(event, 'mouseLeave');
      }
    }
  };
  const handleClick = event => {
    if (FabProps.onClick) {
      FabProps.onClick(event);
    }
    eventTimer.clear();
    if (open) {
      setOpenState(false);
      if (onClose) {
        onClose(event, 'toggle');
      }
    } else {
      setOpenState(true);
      if (onOpen) {
        onOpen(event, 'toggle');
      }
    }
  };
  const handleOpen = event => {
    if (event.type === 'mouseenter' && onMouseEnter) {
      onMouseEnter(event);
    }
    if (event.type === 'focus' && onFocus) {
      onFocus(event);
    }

    // When moving the focus between two items,
    // a chain if blur and focus event is triggered.
    // We only handle the last event.
    eventTimer.clear();
    if (!open) {
      // Wait for a future focus or click event
      eventTimer.start(0, () => {
        setOpenState(true);
        if (onOpen) {
          const eventMap = {
            focus: 'focus',
            mouseenter: 'mouseEnter'
          };
          onOpen(event, eventMap[event.type]);
        }
      });
    }
  };

  // Filter the label for valid id characters.
  const id = ariaLabel.replace(/^[^a-z]+|[^\w:.-]+/gi, '');
  const allItems = React$O.Children.toArray(childrenProp).filter(child => {
    if (process.env.NODE_ENV !== 'production') {
      if ((0, _reactIs$3.isFragment)(child)) {
        console.error(["MUI: The SpeedDial component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    return /*#__PURE__*/React$O.isValidElement(child);
  });
  const children = allItems.map((child, index) => {
    const _child$props = child.props,
      {
        FabProps: {
          ref: origButtonRef
        } = {},
        tooltipPlacement: tooltipPlacementProp
      } = _child$props,
      ChildFabProps = (0, _objectWithoutPropertiesLoose2$w.default)(_child$props.FabProps, _excluded3$1);
    const tooltipPlacement = tooltipPlacementProp || (getOrientation(direction) === 'vertical' ? 'left' : 'top');
    return /*#__PURE__*/React$O.cloneElement(child, {
      FabProps: (0, _extends2$w.default)({}, ChildFabProps, {
        ref: createHandleSpeedDialActionButtonRef(index, origButtonRef)
      }),
      delay: 30 * (open ? index : allItems.length - index),
      open,
      tooltipPlacement,
      id: `${id}-action-${index}`
    });
  });
  return /*#__PURE__*/(0, _jsxRuntime$C.jsxs)(SpeedDialRoot, (0, _extends2$w.default)({
    className: (0, _clsx$11.default)(classes.root, className),
    ref: ref,
    role: "presentation",
    onKeyDown: handleKeyDown,
    onBlur: handleClose,
    onFocus: handleOpen,
    onMouseEnter: handleOpen,
    onMouseLeave: handleClose,
    ownerState: ownerState
  }, other, {
    children: [/*#__PURE__*/(0, _jsxRuntime$C.jsx)(TransitionComponent, (0, _extends2$w.default)({
      in: !hidden,
      timeout: transitionDuration,
      unmountOnExit: true
    }, TransitionProps, {
      children: /*#__PURE__*/(0, _jsxRuntime$C.jsx)(SpeedDialFab, (0, _extends2$w.default)({
        color: "primary",
        "aria-label": ariaLabel,
        "aria-haspopup": "true",
        "aria-expanded": open,
        "aria-controls": `${id}-actions`
      }, FabProps, {
        onClick: handleClick,
        className: (0, _clsx$11.default)(classes.fab, FabProps.className),
        ref: handleFabRef,
        ownerState: ownerState,
        children: /*#__PURE__*/React$O.isValidElement(icon) && (0, _isMuiElement$1.default)(icon, ['SpeedDialIcon']) ? /*#__PURE__*/React$O.cloneElement(icon, {
          open
        }) : icon
      }))
    })), /*#__PURE__*/(0, _jsxRuntime$C.jsx)(SpeedDialActions, {
      id: `${id}-actions`,
      role: "menu",
      "aria-orientation": getOrientation(direction),
      className: (0, _clsx$11.default)(classes.actions, !open && classes.actionsClosed),
      ownerState: ownerState,
      children: children
    })]
  }));
});
process.env.NODE_ENV !== "production" ? SpeedDial.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The aria-label of the button element.
   * Also used to provide the `id` for the `SpeedDial` element and its children.
   */
  ariaLabel: _propTypes$V.default.string.isRequired,
  /**
   * SpeedDialActions to display when the SpeedDial is `open`.
   */
  children: _propTypes$V.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$V.default.object,
  /**
   * @ignore
   */
  className: _propTypes$V.default.string,
  /**
   * The direction the actions open relative to the floating action button.
   * @default 'up'
   */
  direction: _propTypes$V.default.oneOf(['down', 'left', 'right', 'up']),
  /**
   * Props applied to the [`Fab`](/material-ui/api/fab/) element.
   * @default {}
   */
  FabProps: _propTypes$V.default.object,
  /**
   * If `true`, the SpeedDial is hidden.
   * @default false
   */
  hidden: _propTypes$V.default.bool,
  /**
   * The icon to display in the SpeedDial Fab. The `SpeedDialIcon` component
   * provides a default Icon with animation.
   */
  icon: _propTypes$V.default.node,
  /**
   * @ignore
   */
  onBlur: _propTypes$V.default.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"blur"`, `"mouseLeave"`, `"escapeKeyDown"`.
   */
  onClose: _propTypes$V.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes$V.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes$V.default.func,
  /**
   * @ignore
   */
  onMouseEnter: _propTypes$V.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes$V.default.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggle"`, `"focus"`, `"mouseEnter"`.
   */
  onOpen: _propTypes$V.default.func,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$V.default.bool,
  /**
   * The icon to display in the SpeedDial Fab when the SpeedDial is open.
   */
  openIcon: _propTypes$V.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$V.default.oneOfType([_propTypes$V.default.arrayOf(_propTypes$V.default.oneOfType([_propTypes$V.default.func, _propTypes$V.default.object, _propTypes$V.default.bool])), _propTypes$V.default.func, _propTypes$V.default.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Zoom
   */
  TransitionComponent: _propTypes$V.default.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: _propTypes$V.default.oneOfType([_propTypes$V.default.number, _propTypes$V.default.shape({
    appear: _propTypes$V.default.number,
    enter: _propTypes$V.default.number,
    exit: _propTypes$V.default.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: _propTypes$V.default.object
} : void 0;
SpeedDial$1.default = SpeedDial;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  speedDialClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SpeedDial.default;
  }
});
Object.defineProperty(exports, "speedDialClasses", {
  enumerable: true,
  get: function () {
    return _speedDialClasses.default;
  }
});
var _SpeedDial = _interopRequireDefault(SpeedDial$1);
var _speedDialClasses = _interopRequireWildcard(speedDialClasses$1);
Object.keys(_speedDialClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _speedDialClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _speedDialClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(SpeedDial$2));

var SpeedDialAction$2 = {};

var SpeedDialAction$1 = {};

var Tooltip$4 = {};

var Tooltip$3 = {};

var tooltipClasses$1 = {};

var _interopRequireDefault$4p = interopRequireDefault$1.exports;
Object.defineProperty(tooltipClasses$1, "__esModule", {
  value: true
});
tooltipClasses$1.default = void 0;
tooltipClasses$1.getTooltipUtilityClass = getTooltipUtilityClass;
var _generateUtilityClasses$q = _interopRequireDefault$4p(generateUtilityClasses$3);
var _generateUtilityClass$q = _interopRequireDefault$4p(generateUtilityClass$3);
function getTooltipUtilityClass(slot) {
  return (0, _generateUtilityClass$q.default)('MuiTooltip', slot);
}
const tooltipClasses = (0, _generateUtilityClasses$q.default)('MuiTooltip', ['popper', 'popperInteractive', 'popperArrow', 'popperClose', 'tooltip', 'tooltipArrow', 'touch', 'tooltipPlacementLeft', 'tooltipPlacementRight', 'tooltipPlacementTop', 'tooltipPlacementBottom', 'arrow']);
tooltipClasses$1.default = tooltipClasses;

var _interopRequireDefault$4o = interopRequireDefault$1.exports;
Object.defineProperty(Tooltip$3, "__esModule", {
  value: true
});
Tooltip$3.default = void 0;
Tooltip$3.testReset = testReset;
var _objectWithoutPropertiesLoose2$v = _interopRequireDefault$4o(objectWithoutPropertiesLoose.exports);
var _extends2$v = _interopRequireDefault$4o(_extends$19.exports);
var React$N = _interopRequireWildcard$1J(React__default$4);
var _propTypes$U = _interopRequireDefault$4o(propTypes.exports);
var _clsx$10 = _interopRequireDefault$4o(clsx.exports);
var _useTimeout = _interopRequireWildcard$1J(useTimeout$2);
var _elementAcceptingRef = _interopRequireDefault$4o(elementAcceptingRef$2);
var _composeClasses$q = _interopRequireDefault$4o(composeClasses$2);
var _colorManipulator$4 = colorManipulator;
var _RtlProvider$3 = RtlProvider$1;
var _appendOwnerState = _interopRequireDefault$4o(appendOwnerState$2);
var _getReactElementRef = _interopRequireDefault$4o(getReactElementRef$2);
var _styles$1 = styles$u;
var _DefaultPropsProvider$r = DefaultPropsProvider$5;
var _capitalize$9 = _interopRequireDefault$4o(capitalize$1);
var _Grow = _interopRequireDefault$4o(Grow$2);
var _Popper = _interopRequireDefault$4o(Popper$3);
var _useEventCallback$2 = _interopRequireDefault$4o(useEventCallback);
var _useForkRef$1 = _interopRequireDefault$4o(useForkRef);
var _useId$2 = _interopRequireDefault$4o(useId);
var _useIsFocusVisible = _interopRequireDefault$4o(useIsFocusVisible);
var _useControlled = _interopRequireDefault$4o(useControlled);
var _tooltipClasses = _interopRequireWildcard$1J(tooltipClasses$1);
var _jsxRuntime$B = require$$11;
const _excluded$Z = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function _getRequireWildcardCache$1s(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1s = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1J(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1s(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses$q = ownerState => {
  const {
    classes,
    disableInteractive,
    arrow,
    touch,
    placement
  } = ownerState;
  const slots = {
    popper: ['popper', !disableInteractive && 'popperInteractive', arrow && 'popperArrow'],
    tooltip: ['tooltip', arrow && 'tooltipArrow', touch && 'touch', `tooltipPlacement${(0, _capitalize$9.default)(placement.split('-')[0])}`],
    arrow: ['arrow']
  };
  return (0, _composeClasses$q.default)(slots, _tooltipClasses.getTooltipUtilityClass, classes);
};
const TooltipPopper = (0, _styles$1.styled)(_Popper.default, {
  name: 'MuiTooltip',
  slot: 'Popper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.popper, !ownerState.disableInteractive && styles.popperInteractive, ownerState.arrow && styles.popperArrow, !ownerState.open && styles.popperClose];
  }
})(({
  theme,
  ownerState,
  open
}) => (0, _extends2$v.default)({
  zIndex: (theme.vars || theme).zIndex.tooltip,
  pointerEvents: 'none'
}, !ownerState.disableInteractive && {
  pointerEvents: 'auto'
}, !open && {
  pointerEvents: 'none'
}, ownerState.arrow && {
  [`&[data-popper-placement*="bottom"] .${_tooltipClasses.default.arrow}`]: {
    top: 0,
    marginTop: '-0.71em',
    '&::before': {
      transformOrigin: '0 100%'
    }
  },
  [`&[data-popper-placement*="top"] .${_tooltipClasses.default.arrow}`]: {
    bottom: 0,
    marginBottom: '-0.71em',
    '&::before': {
      transformOrigin: '100% 0'
    }
  },
  [`&[data-popper-placement*="right"] .${_tooltipClasses.default.arrow}`]: (0, _extends2$v.default)({}, !ownerState.isRtl ? {
    left: 0,
    marginLeft: '-0.71em'
  } : {
    right: 0,
    marginRight: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '100% 100%'
    }
  }),
  [`&[data-popper-placement*="left"] .${_tooltipClasses.default.arrow}`]: (0, _extends2$v.default)({}, !ownerState.isRtl ? {
    right: 0,
    marginRight: '-0.71em'
  } : {
    left: 0,
    marginLeft: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '0 0'
    }
  })
}));
const TooltipTooltip = (0, _styles$1.styled)('div', {
  name: 'MuiTooltip',
  slot: 'Tooltip',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.tooltip, ownerState.touch && styles.touch, ownerState.arrow && styles.tooltipArrow, styles[`tooltipPlacement${(0, _capitalize$9.default)(ownerState.placement.split('-')[0])}`]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$v.default)({
  backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _colorManipulator$4.alpha)(theme.palette.grey[700], 0.92),
  borderRadius: (theme.vars || theme).shape.borderRadius,
  color: (theme.vars || theme).palette.common.white,
  fontFamily: theme.typography.fontFamily,
  padding: '4px 8px',
  fontSize: theme.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: 'break-word',
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.arrow && {
  position: 'relative',
  margin: 0
}, ownerState.touch && {
  padding: '8px 16px',
  fontSize: theme.typography.pxToRem(14),
  lineHeight: `${round$1(16 / 14)}em`,
  fontWeight: theme.typography.fontWeightRegular
}, {
  [`.${_tooltipClasses.default.popper}[data-popper-placement*="left"] &`]: (0, _extends2$v.default)({
    transformOrigin: 'right center'
  }, !ownerState.isRtl ? (0, _extends2$v.default)({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  }) : (0, _extends2$v.default)({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  })),
  [`.${_tooltipClasses.default.popper}[data-popper-placement*="right"] &`]: (0, _extends2$v.default)({
    transformOrigin: 'left center'
  }, !ownerState.isRtl ? (0, _extends2$v.default)({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  }) : (0, _extends2$v.default)({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  })),
  [`.${_tooltipClasses.default.popper}[data-popper-placement*="top"] &`]: (0, _extends2$v.default)({
    transformOrigin: 'center bottom',
    marginBottom: '14px'
  }, ownerState.touch && {
    marginBottom: '24px'
  }),
  [`.${_tooltipClasses.default.popper}[data-popper-placement*="bottom"] &`]: (0, _extends2$v.default)({
    transformOrigin: 'center top',
    marginTop: '14px'
  }, ownerState.touch && {
    marginTop: '24px'
  })
}));
const TooltipArrow = (0, _styles$1.styled)('span', {
  name: 'MuiTooltip',
  slot: 'Arrow',
  overridesResolver: (props, styles) => styles.arrow
})(({
  theme
}) => ({
  overflow: 'hidden',
  position: 'absolute',
  width: '1em',
  height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */,
  boxSizing: 'border-box',
  color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _colorManipulator$4.alpha)(theme.palette.grey[700], 0.9),
  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: 'currentColor',
    transform: 'rotate(45deg)'
  }
}));
let hystersisOpen = false;
const hystersisTimer = new _useTimeout.Timeout();
let cursorPosition = {
  x: 0,
  y: 0
};
function testReset() {
  hystersisOpen = false;
  hystersisTimer.clear();
}
function composeEventHandler(handler, eventHandler) {
  return (event, ...params) => {
    if (eventHandler) {
      eventHandler(event, ...params);
    }
    handler(event, ...params);
  };
}

// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const Tooltip$2 = /*#__PURE__*/React$N.forwardRef(function Tooltip(inProps, ref) {
  var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
  const props = (0, _DefaultPropsProvider$r.useDefaultProps)({
    props: inProps,
    name: 'MuiTooltip'
  });
  const {
      arrow = false,
      children: childrenProp,
      components = {},
      componentsProps = {},
      describeChild = false,
      disableFocusListener = false,
      disableHoverListener = false,
      disableInteractive: disableInteractiveProp = false,
      disableTouchListener = false,
      enterDelay = 100,
      enterNextDelay = 0,
      enterTouchDelay = 700,
      followCursor = false,
      id: idProp,
      leaveDelay = 0,
      leaveTouchDelay = 1500,
      onClose,
      onOpen,
      open: openProp,
      placement = 'bottom',
      PopperComponent: PopperComponentProp,
      PopperProps = {},
      slotProps = {},
      slots = {},
      title,
      TransitionComponent: TransitionComponentProp = _Grow.default,
      TransitionProps
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$v.default)(props, _excluded$Z);

  // to prevent runtime errors, developers will need to provide a child as a React element anyway.
  const children = /*#__PURE__*/React$N.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/(0, _jsxRuntime$B.jsx)("span", {
    children: childrenProp
  });
  const theme = (0, _styles$1.useTheme)();
  const isRtl = (0, _RtlProvider$3.useRtl)();
  const [childNode, setChildNode] = React$N.useState();
  const [arrowRef, setArrowRef] = React$N.useState(null);
  const ignoreNonTouchEvents = React$N.useRef(false);
  const disableInteractive = disableInteractiveProp || followCursor;
  const closeTimer = (0, _useTimeout.default)();
  const enterTimer = (0, _useTimeout.default)();
  const leaveTimer = (0, _useTimeout.default)();
  const touchTimer = (0, _useTimeout.default)();
  const [openState, setOpenState] = (0, _useControlled.default)({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  });
  let open = openState;
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {
      current: isControlled
    } = React$N.useRef(openProp !== undefined);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$N.useEffect(() => {
      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
        console.error(['MUI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
      }
    }, [title, childNode, isControlled]);
  }
  const id = (0, _useId$2.default)(idProp);
  const prevUserSelect = React$N.useRef();
  const stopTouchInteraction = (0, _useEventCallback$2.default)(() => {
    if (prevUserSelect.current !== undefined) {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      prevUserSelect.current = undefined;
    }
    touchTimer.clear();
  });
  React$N.useEffect(() => stopTouchInteraction, [stopTouchInteraction]);
  const handleOpen = event => {
    hystersisTimer.clear();
    hystersisOpen = true;

    // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
    setOpenState(true);
    if (onOpen && !open) {
      onOpen(event);
    }
  };
  const handleClose = (0, _useEventCallback$2.default)(
  /**
   * @param {React.SyntheticEvent | Event} event
   */
  event => {
    hystersisTimer.start(800 + leaveDelay, () => {
      hystersisOpen = false;
    });
    setOpenState(false);
    if (onClose && open) {
      onClose(event);
    }
    closeTimer.start(theme.transitions.duration.shortest, () => {
      ignoreNonTouchEvents.current = false;
    });
  });
  const handleMouseOver = event => {
    if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
      return;
    }

    // Remove the title ahead of time.
    // We don't want to wait for the next render commit.
    // We would risk displaying two tooltips at the same time (native + this one).
    if (childNode) {
      childNode.removeAttribute('title');
    }
    enterTimer.clear();
    leaveTimer.clear();
    if (enterDelay || hystersisOpen && enterNextDelay) {
      enterTimer.start(hystersisOpen ? enterNextDelay : enterDelay, () => {
        handleOpen(event);
      });
    } else {
      handleOpen(event);
    }
  };
  const handleMouseLeave = event => {
    enterTimer.clear();
    leaveTimer.start(leaveDelay, () => {
      handleClose(event);
    });
  };
  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = (0, _useIsFocusVisible.default)();
  // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
  // We just need to re-render the Tooltip if the focus-visible state changes.
  const [, setChildIsFocusVisible] = React$N.useState(false);
  const handleBlur = event => {
    handleBlurVisible(event);
    if (isFocusVisibleRef.current === false) {
      setChildIsFocusVisible(false);
      handleMouseLeave(event);
    }
  };
  const handleFocus = event => {
    // Workaround for https://github.com/facebook/react/issues/7769
    // The autoFocus of React might trigger the event before the componentDidMount.
    // We need to account for this eventuality.
    if (!childNode) {
      setChildNode(event.currentTarget);
    }
    handleFocusVisible(event);
    if (isFocusVisibleRef.current === true) {
      setChildIsFocusVisible(true);
      handleMouseOver(event);
    }
  };
  const detectTouchStart = event => {
    ignoreNonTouchEvents.current = true;
    const childrenProps = children.props;
    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };
  const handleTouchStart = event => {
    detectTouchStart(event);
    leaveTimer.clear();
    closeTimer.clear();
    stopTouchInteraction();
    prevUserSelect.current = document.body.style.WebkitUserSelect;
    // Prevent iOS text selection on long-tap.
    document.body.style.WebkitUserSelect = 'none';
    touchTimer.start(enterTouchDelay, () => {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      handleMouseOver(event);
    });
  };
  const handleTouchEnd = event => {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }
    stopTouchInteraction();
    leaveTimer.start(leaveTouchDelay, () => {
      handleClose(event);
    });
  };
  React$N.useEffect(() => {
    if (!open) {
      return undefined;
    }

    /**
     * @param {KeyboardEvent} nativeEvent
     */
    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        handleClose(nativeEvent);
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleClose, open]);
  const handleRef = (0, _useForkRef$1.default)((0, _getReactElementRef.default)(children), focusVisibleRef, setChildNode, ref);

  // There is no point in displaying an empty tooltip.
  // So we exclude all falsy values, except 0, which is valid.
  if (!title && title !== 0) {
    open = false;
  }
  const popperRef = React$N.useRef();
  const handleMouseMove = event => {
    const childrenProps = children.props;
    if (childrenProps.onMouseMove) {
      childrenProps.onMouseMove(event);
    }
    cursorPosition = {
      x: event.clientX,
      y: event.clientY
    };
    if (popperRef.current) {
      popperRef.current.update();
    }
  };
  const nameOrDescProps = {};
  const titleIsString = typeof title === 'string';
  if (describeChild) {
    nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
    nameOrDescProps['aria-describedby'] = open ? id : null;
  } else {
    nameOrDescProps['aria-label'] = titleIsString ? title : null;
    nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
  }
  const childrenProps = (0, _extends2$v.default)({}, nameOrDescProps, other, children.props, {
    className: (0, _clsx$10.default)(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  }, followCursor ? {
    onMouseMove: handleMouseMove
  } : {});
  if (process.env.NODE_ENV !== 'production') {
    childrenProps['data-mui-internal-clone-element'] = true;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    React$N.useEffect(() => {
      if (childNode && !childNode.getAttribute('data-mui-internal-clone-element')) {
        console.error(['MUI: The `children` component of the Tooltip is not forwarding its props correctly.', 'Please make sure that props are spread on the same element that the ref is applied to.'].join('\n'));
      }
    }, [childNode]);
  }
  const interactiveWrapperListeners = {};
  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }
  if (!disableHoverListener) {
    childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
    childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
    if (!disableInteractive) {
      interactiveWrapperListeners.onMouseOver = handleMouseOver;
      interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
    }
  }
  if (!disableFocusListener) {
    childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
    childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
    if (!disableInteractive) {
      interactiveWrapperListeners.onFocus = handleFocus;
      interactiveWrapperListeners.onBlur = handleBlur;
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    if (children.props.title) {
      console.error(['MUI: You have provided a `title` prop to the child of <Tooltip />.', `Remove this title prop \`${children.props.title}\` or the Tooltip component.`].join('\n'));
    }
  }
  const popperOptions = React$N.useMemo(() => {
    var _PopperProps$popperOp;
    let tooltipModifiers = [{
      name: 'arrow',
      enabled: Boolean(arrowRef),
      options: {
        element: arrowRef,
        padding: 4
      }
    }];
    if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) {
      tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
    }
    return (0, _extends2$v.default)({}, PopperProps.popperOptions, {
      modifiers: tooltipModifiers
    });
  }, [arrowRef, PopperProps]);
  const ownerState = (0, _extends2$v.default)({}, props, {
    isRtl,
    arrow,
    disableInteractive,
    placement,
    PopperComponentProp,
    touch: ignoreNonTouchEvents.current
  });
  const classes = useUtilityClasses$q(ownerState);
  const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : TooltipPopper;
  const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : _Grow.default;
  const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : TooltipTooltip;
  const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : TooltipArrow;
  const popperProps = (0, _appendOwnerState.default)(PopperComponent, (0, _extends2$v.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
    className: (0, _clsx$10.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
  }), ownerState);
  const transitionProps = (0, _appendOwnerState.default)(TransitionComponent, (0, _extends2$v.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
  const tooltipProps = (0, _appendOwnerState.default)(TooltipComponent, (0, _extends2$v.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
    className: (0, _clsx$10.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
  }), ownerState);
  const tooltipArrowProps = (0, _appendOwnerState.default)(ArrowComponent, (0, _extends2$v.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
    className: (0, _clsx$10.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
  }), ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$B.jsxs)(React$N.Fragment, {
    children: [/*#__PURE__*/React$N.cloneElement(children, childrenProps), /*#__PURE__*/(0, _jsxRuntime$B.jsx)(PopperComponent, (0, _extends2$v.default)({
      as: PopperComponentProp != null ? PopperComponentProp : _Popper.default,
      placement: placement,
      anchorEl: followCursor ? {
        getBoundingClientRect: () => ({
          top: cursorPosition.y,
          left: cursorPosition.x,
          right: cursorPosition.x,
          bottom: cursorPosition.y,
          width: 0,
          height: 0
        })
      } : childNode,
      popperRef: popperRef,
      open: childNode ? open : false,
      id: id,
      transition: true
    }, interactiveWrapperListeners, popperProps, {
      popperOptions: popperOptions,
      children: ({
        TransitionProps: TransitionPropsInner
      }) => /*#__PURE__*/(0, _jsxRuntime$B.jsx)(TransitionComponent, (0, _extends2$v.default)({
        timeout: theme.transitions.duration.shorter
      }, TransitionPropsInner, transitionProps, {
        children: /*#__PURE__*/(0, _jsxRuntime$B.jsxs)(TooltipComponent, (0, _extends2$v.default)({}, tooltipProps, {
          children: [title, arrow ? /*#__PURE__*/(0, _jsxRuntime$B.jsx)(ArrowComponent, (0, _extends2$v.default)({}, tooltipArrowProps, {
            ref: setArrowRef
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" ? Tooltip$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: _propTypes$U.default.bool,
  /**
   * Tooltip reference element.
   */
  children: _elementAcceptingRef.default.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$U.default.object,
  /**
   * @ignore
   */
  className: _propTypes$U.default.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: _propTypes$U.default.shape({
    Arrow: _propTypes$U.default.elementType,
    Popper: _propTypes$U.default.elementType,
    Tooltip: _propTypes$U.default.elementType,
    Transition: _propTypes$U.default.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: _propTypes$U.default.shape({
    arrow: _propTypes$U.default.object,
    popper: _propTypes$U.default.object,
    tooltip: _propTypes$U.default.object,
    transition: _propTypes$U.default.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: _propTypes$U.default.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: _propTypes$U.default.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: _propTypes$U.default.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: _propTypes$U.default.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: _propTypes$U.default.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: _propTypes$U.default.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: _propTypes$U.default.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: _propTypes$U.default.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: _propTypes$U.default.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: _propTypes$U.default.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: _propTypes$U.default.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: _propTypes$U.default.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: _propTypes$U.default.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: _propTypes$U.default.func,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$U.default.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: _propTypes$U.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: _propTypes$U.default.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: _propTypes$U.default.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: _propTypes$U.default.shape({
    arrow: _propTypes$U.default.object,
    popper: _propTypes$U.default.object,
    tooltip: _propTypes$U.default.object,
    transition: _propTypes$U.default.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: _propTypes$U.default.shape({
    arrow: _propTypes$U.default.elementType,
    popper: _propTypes$U.default.elementType,
    tooltip: _propTypes$U.default.elementType,
    transition: _propTypes$U.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$U.default.oneOfType([_propTypes$U.default.arrayOf(_propTypes$U.default.oneOfType([_propTypes$U.default.func, _propTypes$U.default.object, _propTypes$U.default.bool])), _propTypes$U.default.func, _propTypes$U.default.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: _propTypes$U.default.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: _propTypes$U.default.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: _propTypes$U.default.object
} : void 0;
Tooltip$3.default = Tooltip$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tooltipClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Tooltip.default;
  }
});
Object.defineProperty(exports, "tooltipClasses", {
  enumerable: true,
  get: function () {
    return _tooltipClasses.default;
  }
});
var _Tooltip = _interopRequireDefault(Tooltip$3);
var _tooltipClasses = _interopRequireWildcard(tooltipClasses$1);
Object.keys(_tooltipClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tooltipClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tooltipClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Tooltip$4));

var speedDialActionClasses$1 = {};

var _interopRequireDefault$4n = interopRequireDefault$1.exports;
Object.defineProperty(speedDialActionClasses$1, "__esModule", {
  value: true
});
speedDialActionClasses$1.default = void 0;
speedDialActionClasses$1.getSpeedDialActionUtilityClass = getSpeedDialActionUtilityClass;
var _generateUtilityClasses$p = _interopRequireDefault$4n(generateUtilityClasses$3);
var _generateUtilityClass$p = _interopRequireDefault$4n(generateUtilityClass$3);
function getSpeedDialActionUtilityClass(slot) {
  return (0, _generateUtilityClass$p.default)('MuiSpeedDialAction', slot);
}
const speedDialActionClasses = (0, _generateUtilityClasses$p.default)('MuiSpeedDialAction', ['fab', 'fabClosed', 'staticTooltip', 'staticTooltipClosed', 'staticTooltipLabel', 'tooltipPlacementLeft', 'tooltipPlacementRight']);
speedDialActionClasses$1.default = speedDialActionClasses;

// @inheritedComponent Tooltip
var _interopRequireDefault$4m = interopRequireDefault$1.exports;
Object.defineProperty(SpeedDialAction$1, "__esModule", {
  value: true
});
SpeedDialAction$1.default = void 0;
var _objectWithoutPropertiesLoose2$u = _interopRequireDefault$4m(objectWithoutPropertiesLoose.exports);
var _extends2$u = _interopRequireDefault$4m(_extends$19.exports);
var React$M = _interopRequireWildcard$1I(React__default$4);
var _propTypes$T = _interopRequireDefault$4m(propTypes.exports);
var _clsx$$ = _interopRequireDefault$4m(clsx.exports);
var _composeClasses$p = _interopRequireDefault$4m(composeClasses$2);
var _colorManipulator$3 = colorManipulator;
var _styled$p = _interopRequireDefault$4m(styled$2);
var _DefaultPropsProvider$q = DefaultPropsProvider$5;
var _Fab = _interopRequireDefault$4m(Fab$2);
var _Tooltip$4 = _interopRequireDefault$4m(Tooltip$4);
var _capitalize$8 = _interopRequireDefault$4m(capitalize$1);
var _speedDialActionClasses = _interopRequireWildcard$1I(speedDialActionClasses$1);
var _jsxRuntime$A = require$$11;
const _excluded$Y = ["className", "delay", "FabProps", "icon", "id", "open", "TooltipClasses", "tooltipOpen", "tooltipPlacement", "tooltipTitle"];
function _getRequireWildcardCache$1r(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1r = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1I(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1r(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$p = ownerState => {
  const {
    open,
    tooltipPlacement,
    classes
  } = ownerState;
  const slots = {
    fab: ['fab', !open && 'fabClosed'],
    staticTooltip: ['staticTooltip', `tooltipPlacement${(0, _capitalize$8.default)(tooltipPlacement)}`, !open && 'staticTooltipClosed'],
    staticTooltipLabel: ['staticTooltipLabel']
  };
  return (0, _composeClasses$p.default)(slots, _speedDialActionClasses.getSpeedDialActionUtilityClass, classes);
};
const SpeedDialActionFab = (0, _styled$p.default)(_Fab.default, {
  name: 'MuiSpeedDialAction',
  slot: 'Fab',
  skipVariantsResolver: false,
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.fab, !ownerState.open && styles.fabClosed];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$u.default)({
  margin: 8,
  color: (theme.vars || theme).palette.text.secondary,
  backgroundColor: (theme.vars || theme).palette.background.paper,
  '&:hover': {
    backgroundColor: theme.vars ? theme.vars.palette.SpeedDialAction.fabHoverBg : (0, _colorManipulator$3.emphasize)(theme.palette.background.paper, 0.15)
  },
  transition: `${theme.transitions.create('transform', {
    duration: theme.transitions.duration.shorter
  })}, opacity 0.8s`,
  opacity: 1
}, !ownerState.open && {
  opacity: 0,
  transform: 'scale(0)'
}));
const SpeedDialActionStaticTooltip = (0, _styled$p.default)('span', {
  name: 'MuiSpeedDialAction',
  slot: 'StaticTooltip',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.staticTooltip, !ownerState.open && styles.staticTooltipClosed, styles[`tooltipPlacement${(0, _capitalize$8.default)(ownerState.tooltipPlacement)}`]];
  }
})(({
  theme,
  ownerState
}) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  [`& .${_speedDialActionClasses.default.staticTooltipLabel}`]: (0, _extends2$u.default)({
    transition: theme.transitions.create(['transform', 'opacity'], {
      duration: theme.transitions.duration.shorter
    }),
    opacity: 1
  }, !ownerState.open && {
    opacity: 0,
    transform: 'scale(0.5)'
  }, ownerState.tooltipPlacement === 'left' && {
    transformOrigin: '100% 50%',
    right: '100%',
    marginRight: 8
  }, ownerState.tooltipPlacement === 'right' && {
    transformOrigin: '0% 50%',
    left: '100%',
    marginLeft: 8
  })
}));
const SpeedDialActionStaticTooltipLabel = (0, _styled$p.default)('span', {
  name: 'MuiSpeedDialAction',
  slot: 'StaticTooltipLabel',
  overridesResolver: (props, styles) => styles.staticTooltipLabel
})(({
  theme
}) => (0, _extends2$u.default)({
  position: 'absolute'
}, theme.typography.body1, {
  backgroundColor: (theme.vars || theme).palette.background.paper,
  borderRadius: (theme.vars || theme).shape.borderRadius,
  boxShadow: (theme.vars || theme).shadows[1],
  color: (theme.vars || theme).palette.text.secondary,
  padding: '4px 16px',
  wordBreak: 'keep-all'
}));
const SpeedDialAction = /*#__PURE__*/React$M.forwardRef(function SpeedDialAction(inProps, ref) {
  const props = (0, _DefaultPropsProvider$q.useDefaultProps)({
    props: inProps,
    name: 'MuiSpeedDialAction'
  });
  const {
      className,
      delay = 0,
      FabProps = {},
      icon,
      id,
      open,
      TooltipClasses,
      tooltipOpen: tooltipOpenProp = false,
      tooltipPlacement = 'left',
      tooltipTitle
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$u.default)(props, _excluded$Y);
  const ownerState = (0, _extends2$u.default)({}, props, {
    tooltipPlacement
  });
  const classes = useUtilityClasses$p(ownerState);
  const [tooltipOpen, setTooltipOpen] = React$M.useState(tooltipOpenProp);
  const handleTooltipClose = () => {
    setTooltipOpen(false);
  };
  const handleTooltipOpen = () => {
    setTooltipOpen(true);
  };
  const transitionStyle = {
    transitionDelay: `${delay}ms`
  };
  const fab = /*#__PURE__*/(0, _jsxRuntime$A.jsx)(SpeedDialActionFab, (0, _extends2$u.default)({
    size: "small",
    className: (0, _clsx$$.default)(classes.fab, className),
    tabIndex: -1,
    role: "menuitem",
    ownerState: ownerState
  }, FabProps, {
    style: (0, _extends2$u.default)({}, transitionStyle, FabProps.style),
    children: icon
  }));
  if (tooltipOpenProp) {
    return /*#__PURE__*/(0, _jsxRuntime$A.jsxs)(SpeedDialActionStaticTooltip, (0, _extends2$u.default)({
      id: id,
      ref: ref,
      className: classes.staticTooltip,
      ownerState: ownerState
    }, other, {
      children: [/*#__PURE__*/(0, _jsxRuntime$A.jsx)(SpeedDialActionStaticTooltipLabel, {
        style: transitionStyle,
        id: `${id}-label`,
        className: classes.staticTooltipLabel,
        ownerState: ownerState,
        children: tooltipTitle
      }), /*#__PURE__*/React$M.cloneElement(fab, {
        'aria-labelledby': `${id}-label`
      })]
    }));
  }
  if (!open && tooltipOpen) {
    setTooltipOpen(false);
  }
  return /*#__PURE__*/(0, _jsxRuntime$A.jsx)(_Tooltip$4.default, (0, _extends2$u.default)({
    id: id,
    ref: ref,
    title: tooltipTitle,
    placement: tooltipPlacement,
    onClose: handleTooltipClose,
    onOpen: handleTooltipOpen,
    open: open && tooltipOpen,
    classes: TooltipClasses
  }, other, {
    children: fab
  }));
});
process.env.NODE_ENV !== "production" ? SpeedDialAction.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$T.default.object,
  /**
   * @ignore
   */
  className: _propTypes$T.default.string,
  /**
   * Adds a transition delay, to allow a series of SpeedDialActions to be animated.
   * @default 0
   */
  delay: _propTypes$T.default.number,
  /**
   * Props applied to the [`Fab`](/material-ui/api/fab/) component.
   * @default {}
   */
  FabProps: _propTypes$T.default.object,
  /**
   * The icon to display in the SpeedDial Fab.
   */
  icon: _propTypes$T.default.node,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: _propTypes$T.default.string,
  /**
   * If `true`, the component is shown.
   */
  open: _propTypes$T.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$T.default.oneOfType([_propTypes$T.default.arrayOf(_propTypes$T.default.oneOfType([_propTypes$T.default.func, _propTypes$T.default.object, _propTypes$T.default.bool])), _propTypes$T.default.func, _propTypes$T.default.object]),
  /**
   * `classes` prop applied to the [`Tooltip`](/material-ui/api/tooltip/) element.
   */
  TooltipClasses: _propTypes$T.default.object,
  /**
   * Make the tooltip always visible when the SpeedDial is open.
   * @default false
   */
  tooltipOpen: _propTypes$T.default.bool,
  /**
   * Placement of the tooltip.
   * @default 'left'
   */
  tooltipPlacement: _propTypes$T.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  /**
   * Label to display in the tooltip.
   */
  tooltipTitle: _propTypes$T.default.node
} : void 0;
SpeedDialAction$1.default = SpeedDialAction;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  speedDialActionClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SpeedDialAction.default;
  }
});
Object.defineProperty(exports, "speedDialActionClasses", {
  enumerable: true,
  get: function () {
    return _speedDialActionClasses.default;
  }
});
var _SpeedDialAction = _interopRequireDefault(SpeedDialAction$1);
var _speedDialActionClasses = _interopRequireWildcard(speedDialActionClasses$1);
Object.keys(_speedDialActionClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _speedDialActionClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _speedDialActionClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(SpeedDialAction$2));

var SpeedDialIcon$2 = {};

var SpeedDialIcon$1 = {};

var Add = {};

Object.defineProperty(Add, "__esModule", {
  value: true
});
Add.default = void 0;
_interopRequireWildcard$1H(React__default$4);
var _utils$z = utils$6;
var _jsxRuntime$z = require$$11;
function _getRequireWildcardCache$1q(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1q = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1H(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1q(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
Add.default = (0, _utils$z.createSvgIcon)( /*#__PURE__*/(0, _jsxRuntime$z.jsx)("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');

var speedDialIconClasses$1 = {};

var _interopRequireDefault$4l = interopRequireDefault$1.exports;
Object.defineProperty(speedDialIconClasses$1, "__esModule", {
  value: true
});
speedDialIconClasses$1.default = void 0;
speedDialIconClasses$1.getSpeedDialIconUtilityClass = getSpeedDialIconUtilityClass;
var _generateUtilityClasses$o = _interopRequireDefault$4l(generateUtilityClasses$3);
var _generateUtilityClass$o = _interopRequireDefault$4l(generateUtilityClass$3);
function getSpeedDialIconUtilityClass(slot) {
  return (0, _generateUtilityClass$o.default)('MuiSpeedDialIcon', slot);
}
const speedDialIconClasses = (0, _generateUtilityClasses$o.default)('MuiSpeedDialIcon', ['root', 'icon', 'iconOpen', 'iconWithOpenIconOpen', 'openIcon', 'openIconOpen']);
speedDialIconClasses$1.default = speedDialIconClasses;

var _interopRequireDefault$4k = interopRequireDefault$1.exports;
Object.defineProperty(SpeedDialIcon$1, "__esModule", {
  value: true
});
SpeedDialIcon$1.default = void 0;
var _objectWithoutPropertiesLoose2$t = _interopRequireDefault$4k(objectWithoutPropertiesLoose.exports);
var _extends2$t = _interopRequireDefault$4k(_extends$19.exports);
var React$L = _interopRequireWildcard$1G(React__default$4);
var _propTypes$S = _interopRequireDefault$4k(propTypes.exports);
var _clsx$_ = _interopRequireDefault$4k(clsx.exports);
var _composeClasses$o = _interopRequireDefault$4k(composeClasses$2);
var _styled$o = _interopRequireDefault$4k(styled$2);
var _DefaultPropsProvider$p = DefaultPropsProvider$5;
var _Add = _interopRequireDefault$4k(Add);
var _speedDialIconClasses = _interopRequireWildcard$1G(speedDialIconClasses$1);
var _jsxRuntime$y = require$$11;
const _excluded$X = ["className", "icon", "open", "openIcon"];
function _getRequireWildcardCache$1p(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1p = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1G(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1p(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$o = ownerState => {
  const {
    classes,
    open,
    openIcon
  } = ownerState;
  const slots = {
    root: ['root'],
    icon: ['icon', open && 'iconOpen', openIcon && open && 'iconWithOpenIconOpen'],
    openIcon: ['openIcon', open && 'openIconOpen']
  };
  return (0, _composeClasses$o.default)(slots, _speedDialIconClasses.getSpeedDialIconUtilityClass, classes);
};
const SpeedDialIconRoot = (0, _styled$o.default)('span', {
  name: 'MuiSpeedDialIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_speedDialIconClasses.default.icon}`]: styles.icon
    }, {
      [`& .${_speedDialIconClasses.default.icon}`]: ownerState.open && styles.iconOpen
    }, {
      [`& .${_speedDialIconClasses.default.icon}`]: ownerState.open && ownerState.openIcon && styles.iconWithOpenIconOpen
    }, {
      [`& .${_speedDialIconClasses.default.openIcon}`]: styles.openIcon
    }, {
      [`& .${_speedDialIconClasses.default.openIcon}`]: ownerState.open && styles.openIconOpen
    }, styles.root];
  }
})(({
  theme,
  ownerState
}) => ({
  height: 24,
  [`& .${_speedDialIconClasses.default.icon}`]: (0, _extends2$t.default)({
    transition: theme.transitions.create(['transform', 'opacity'], {
      duration: theme.transitions.duration.short
    })
  }, ownerState.open && (0, _extends2$t.default)({
    transform: 'rotate(45deg)'
  }, ownerState.openIcon && {
    opacity: 0
  })),
  [`& .${_speedDialIconClasses.default.openIcon}`]: (0, _extends2$t.default)({
    position: 'absolute',
    transition: theme.transitions.create(['transform', 'opacity'], {
      duration: theme.transitions.duration.short
    }),
    opacity: 0,
    transform: 'rotate(-45deg)'
  }, ownerState.open && {
    transform: 'rotate(0deg)',
    opacity: 1
  })
}));
const SpeedDialIcon = /*#__PURE__*/React$L.forwardRef(function SpeedDialIcon(inProps, ref) {
  const props = (0, _DefaultPropsProvider$p.useDefaultProps)({
    props: inProps,
    name: 'MuiSpeedDialIcon'
  });
  const {
      className,
      icon: iconProp,
      openIcon: openIconProp
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$t.default)(props, _excluded$X);
  const ownerState = props;
  const classes = useUtilityClasses$o(ownerState);
  function formatIcon(icon, newClassName) {
    if ( /*#__PURE__*/React$L.isValidElement(icon)) {
      return /*#__PURE__*/React$L.cloneElement(icon, {
        className: newClassName
      });
    }
    return icon;
  }
  return /*#__PURE__*/(0, _jsxRuntime$y.jsxs)(SpeedDialIconRoot, (0, _extends2$t.default)({
    className: (0, _clsx$_.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [openIconProp ? formatIcon(openIconProp, classes.openIcon) : null, iconProp ? formatIcon(iconProp, classes.icon) : /*#__PURE__*/(0, _jsxRuntime$y.jsx)(_Add.default, {
      className: classes.icon
    })]
  }));
});
process.env.NODE_ENV !== "production" ? SpeedDialIcon.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$S.default.object,
  /**
   * @ignore
   */
  className: _propTypes$S.default.string,
  /**
   * The icon to display.
   */
  icon: _propTypes$S.default.node,
  /**
   * @ignore
   * If `true`, the component is shown.
   */
  open: _propTypes$S.default.bool,
  /**
   * The icon to display in the SpeedDial Floating Action Button when the SpeedDial is open.
   */
  openIcon: _propTypes$S.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$S.default.oneOfType([_propTypes$S.default.arrayOf(_propTypes$S.default.oneOfType([_propTypes$S.default.func, _propTypes$S.default.object, _propTypes$S.default.bool])), _propTypes$S.default.func, _propTypes$S.default.object])
} : void 0;
SpeedDialIcon.muiName = 'SpeedDialIcon';
SpeedDialIcon$1.default = SpeedDialIcon;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  speedDialIconClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SpeedDialIcon.default;
  }
});
Object.defineProperty(exports, "speedDialIconClasses", {
  enumerable: true,
  get: function () {
    return _speedDialIconClasses.default;
  }
});
var _SpeedDialIcon = _interopRequireDefault(SpeedDialIcon$1);
var _speedDialIconClasses = _interopRequireWildcard(speedDialIconClasses$1);
Object.keys(_speedDialIconClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _speedDialIconClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _speedDialIconClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(SpeedDialIcon$2));

var Step$4 = {};

var Step$3 = {};

var StepperContext$1 = {};

Object.defineProperty(StepperContext$1, "__esModule", {
  value: true
});
StepperContext$1.default = void 0;
StepperContext$1.useStepperContext = useStepperContext;
var React$K = _interopRequireWildcard$1F(React__default$4);
function _getRequireWildcardCache$1o(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1o = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1F(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1o(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Provides information about the current step in Stepper.
 */
const StepperContext = /*#__PURE__*/React$K.createContext({});
if (process.env.NODE_ENV !== 'production') {
  StepperContext.displayName = 'StepperContext';
}

/**
 * Returns the current StepperContext or an empty object if no StepperContext
 * has been defined in the component tree.
 */
function useStepperContext() {
  return React$K.useContext(StepperContext);
}
StepperContext$1.default = StepperContext;

var StepContext$1 = {};

Object.defineProperty(StepContext$1, "__esModule", {
  value: true
});
StepContext$1.default = void 0;
StepContext$1.useStepContext = useStepContext;
var React$J = _interopRequireWildcard$1E(React__default$4);
function _getRequireWildcardCache$1n(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1n = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1E(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1n(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Provides information about the current step in Stepper.
 */
const StepContext = /*#__PURE__*/React$J.createContext({});
if (process.env.NODE_ENV !== 'production') {
  StepContext.displayName = 'StepContext';
}

/**
 * Returns the current StepContext or an empty object if no StepContext
 * has been defined in the component tree.
 */
function useStepContext() {
  return React$J.useContext(StepContext);
}
StepContext$1.default = StepContext;

var stepClasses$1 = {};

var _interopRequireDefault$4j = interopRequireDefault$1.exports;
Object.defineProperty(stepClasses$1, "__esModule", {
  value: true
});
stepClasses$1.default = void 0;
stepClasses$1.getStepUtilityClass = getStepUtilityClass;
var _generateUtilityClasses$n = _interopRequireDefault$4j(generateUtilityClasses$3);
var _generateUtilityClass$n = _interopRequireDefault$4j(generateUtilityClass$3);
function getStepUtilityClass(slot) {
  return (0, _generateUtilityClass$n.default)('MuiStep', slot);
}
const stepClasses = (0, _generateUtilityClasses$n.default)('MuiStep', ['root', 'horizontal', 'vertical', 'alternativeLabel', 'completed']);
stepClasses$1.default = stepClasses;

var _interopRequireDefault$4i = interopRequireDefault$1.exports;
Object.defineProperty(Step$3, "__esModule", {
  value: true
});
Step$3.default = void 0;
var _objectWithoutPropertiesLoose2$s = _interopRequireDefault$4i(objectWithoutPropertiesLoose.exports);
var _extends2$s = _interopRequireDefault$4i(_extends$19.exports);
var React$I = _interopRequireWildcard$1D(React__default$4);
var _propTypes$R = _interopRequireDefault$4i(propTypes.exports);
var _clsx$Z = _interopRequireDefault$4i(clsx.exports);
var _integerPropType$2 = _interopRequireDefault$4i(integerPropType$1);
var _composeClasses$n = _interopRequireDefault$4i(composeClasses$2);
var _StepperContext$5 = _interopRequireDefault$4i(StepperContext$1);
var _StepContext$4 = _interopRequireDefault$4i(StepContext$1);
var _DefaultPropsProvider$o = DefaultPropsProvider$5;
var _styled$n = _interopRequireDefault$4i(styled$2);
var _stepClasses = stepClasses$1;
var _jsxRuntime$x = require$$11;
const _excluded$W = ["active", "children", "className", "component", "completed", "disabled", "expanded", "index", "last"];
function _getRequireWildcardCache$1m(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1m = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1D(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1m(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$n = ownerState => {
  const {
    classes,
    orientation,
    alternativeLabel,
    completed
  } = ownerState;
  const slots = {
    root: ['root', orientation, alternativeLabel && 'alternativeLabel', completed && 'completed']
  };
  return (0, _composeClasses$n.default)(slots, _stepClasses.getStepUtilityClass, classes);
};
const StepRoot = (0, _styled$n.default)('div', {
  name: 'MuiStep',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.completed && styles.completed];
  }
})(({
  ownerState
}) => (0, _extends2$s.default)({}, ownerState.orientation === 'horizontal' && {
  paddingLeft: 8,
  paddingRight: 8
}, ownerState.alternativeLabel && {
  flex: 1,
  position: 'relative'
}));
const Step$2 = /*#__PURE__*/React$I.forwardRef(function Step(inProps, ref) {
  const props = (0, _DefaultPropsProvider$o.useDefaultProps)({
    props: inProps,
    name: 'MuiStep'
  });
  const {
      active: activeProp,
      children,
      className,
      component = 'div',
      completed: completedProp,
      disabled: disabledProp,
      expanded = false,
      index,
      last
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$s.default)(props, _excluded$W);
  const {
    activeStep,
    connector,
    alternativeLabel,
    orientation,
    nonLinear
  } = React$I.useContext(_StepperContext$5.default);
  let [active = false, completed = false, disabled = false] = [activeProp, completedProp, disabledProp];
  if (activeStep === index) {
    active = activeProp !== undefined ? activeProp : true;
  } else if (!nonLinear && activeStep > index) {
    completed = completedProp !== undefined ? completedProp : true;
  } else if (!nonLinear && activeStep < index) {
    disabled = disabledProp !== undefined ? disabledProp : true;
  }
  const contextValue = React$I.useMemo(() => ({
    index,
    last,
    expanded,
    icon: index + 1,
    active,
    completed,
    disabled
  }), [index, last, expanded, active, completed, disabled]);
  const ownerState = (0, _extends2$s.default)({}, props, {
    active,
    orientation,
    alternativeLabel,
    completed,
    disabled,
    expanded,
    component
  });
  const classes = useUtilityClasses$n(ownerState);
  const newChildren = /*#__PURE__*/(0, _jsxRuntime$x.jsxs)(StepRoot, (0, _extends2$s.default)({
    as: component,
    className: (0, _clsx$Z.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [connector && alternativeLabel && index !== 0 ? connector : null, children]
  }));
  return /*#__PURE__*/(0, _jsxRuntime$x.jsx)(_StepContext$4.default.Provider, {
    value: contextValue,
    children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/(0, _jsxRuntime$x.jsxs)(React$I.Fragment, {
      children: [connector, newChildren]
    }) : newChildren
  });
});
process.env.NODE_ENV !== "production" ? Step$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: _propTypes$R.default.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: _propTypes$R.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$R.default.object,
  /**
   * @ignore
   */
  className: _propTypes$R.default.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: _propTypes$R.default.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$R.default.elementType,
  /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: _propTypes$R.default.bool,
  /**
   * Expand the step.
   * @default false
   */
  expanded: _propTypes$R.default.bool,
  /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  index: _integerPropType$2.default,
  /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  last: _propTypes$R.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$R.default.oneOfType([_propTypes$R.default.arrayOf(_propTypes$R.default.oneOfType([_propTypes$R.default.func, _propTypes$R.default.object, _propTypes$R.default.bool])), _propTypes$R.default.func, _propTypes$R.default.object])
} : void 0;
Step$3.default = Step$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  stepClasses: true,
  StepContext: true
};
Object.defineProperty(exports, "StepContext", {
  enumerable: true,
  get: function () {
    return _StepContext.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Step.default;
  }
});
Object.defineProperty(exports, "stepClasses", {
  enumerable: true,
  get: function () {
    return _stepClasses.default;
  }
});
var _Step = _interopRequireDefault(Step$3);
var _stepClasses = _interopRequireWildcard(stepClasses$1);
Object.keys(_stepClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _stepClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _stepClasses[key];
    }
  });
});
var _StepContext = _interopRequireWildcard(StepContext$1);
Object.keys(_StepContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StepContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StepContext[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Step$4));

var StepButton$2 = {};

var StepButton$1 = {};

var StepLabel$2 = {};

var StepLabel$1 = {};

var StepIcon$2 = {};

var StepIcon$1 = {};

var CheckCircle = {};

var _interopRequireDefault$4h = interopRequireDefault$1.exports;
Object.defineProperty(CheckCircle, "__esModule", {
  value: true
});
CheckCircle.default = void 0;
_interopRequireWildcard$1C(React__default$4);
var _createSvgIcon$5 = _interopRequireDefault$4h(createSvgIcon$2);
var _jsxRuntime$w = require$$11;
function _getRequireWildcardCache$1l(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1l = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1C(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1l(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
CheckCircle.default = (0, _createSvgIcon$5.default)( /*#__PURE__*/(0, _jsxRuntime$w.jsx)("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');

var Warning = {};

var _interopRequireDefault$4g = interopRequireDefault$1.exports;
Object.defineProperty(Warning, "__esModule", {
  value: true
});
Warning.default = void 0;
_interopRequireWildcard$1B(React__default$4);
var _createSvgIcon$4 = _interopRequireDefault$4g(createSvgIcon$2);
var _jsxRuntime$v = require$$11;
function _getRequireWildcardCache$1k(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1k = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1B(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1k(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
Warning.default = (0, _createSvgIcon$4.default)( /*#__PURE__*/(0, _jsxRuntime$v.jsx)("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');

var stepIconClasses$1 = {};

var _interopRequireDefault$4f = interopRequireDefault$1.exports;
Object.defineProperty(stepIconClasses$1, "__esModule", {
  value: true
});
stepIconClasses$1.default = void 0;
stepIconClasses$1.getStepIconUtilityClass = getStepIconUtilityClass;
var _generateUtilityClasses$m = _interopRequireDefault$4f(generateUtilityClasses$3);
var _generateUtilityClass$m = _interopRequireDefault$4f(generateUtilityClass$3);
function getStepIconUtilityClass(slot) {
  return (0, _generateUtilityClass$m.default)('MuiStepIcon', slot);
}
const stepIconClasses = (0, _generateUtilityClasses$m.default)('MuiStepIcon', ['root', 'active', 'completed', 'error', 'text']);
stepIconClasses$1.default = stepIconClasses;

var _interopRequireDefault$4e = interopRequireDefault$1.exports;
Object.defineProperty(StepIcon$1, "__esModule", {
  value: true
});
StepIcon$1.default = void 0;
var _extends2$r = _interopRequireDefault$4e(_extends$19.exports);
var _objectWithoutPropertiesLoose2$r = _interopRequireDefault$4e(objectWithoutPropertiesLoose.exports);
var React$H = _interopRequireWildcard$1A(React__default$4);
var _propTypes$Q = _interopRequireDefault$4e(propTypes.exports);
var _clsx$Y = _interopRequireDefault$4e(clsx.exports);
var _composeClasses$m = _interopRequireDefault$4e(composeClasses$2);
var _styled$m = _interopRequireDefault$4e(styled$2);
var _DefaultPropsProvider$n = DefaultPropsProvider$5;
var _CheckCircle = _interopRequireDefault$4e(CheckCircle);
var _Warning = _interopRequireDefault$4e(Warning);
var _SvgIcon = _interopRequireDefault$4e(SvgIcon$3);
var _stepIconClasses = _interopRequireWildcard$1A(stepIconClasses$1);
var _jsxRuntime$u = require$$11;
var _circle$1;
const _excluded$V = ["active", "className", "completed", "error", "icon"];
function _getRequireWildcardCache$1j(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1j = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1A(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1j(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$m = ownerState => {
  const {
    classes,
    active,
    completed,
    error
  } = ownerState;
  const slots = {
    root: ['root', active && 'active', completed && 'completed', error && 'error'],
    text: ['text']
  };
  return (0, _composeClasses$m.default)(slots, _stepIconClasses.getStepIconUtilityClass, classes);
};
const StepIconRoot = (0, _styled$m.default)(_SvgIcon.default, {
  name: 'MuiStepIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  display: 'block',
  transition: theme.transitions.create('color', {
    duration: theme.transitions.duration.shortest
  }),
  color: (theme.vars || theme).palette.text.disabled,
  [`&.${_stepIconClasses.default.completed}`]: {
    color: (theme.vars || theme).palette.primary.main
  },
  [`&.${_stepIconClasses.default.active}`]: {
    color: (theme.vars || theme).palette.primary.main
  },
  [`&.${_stepIconClasses.default.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const StepIconText = (0, _styled$m.default)('text', {
  name: 'MuiStepIcon',
  slot: 'Text',
  overridesResolver: (props, styles) => styles.text
})(({
  theme
}) => ({
  fill: (theme.vars || theme).palette.primary.contrastText,
  fontSize: theme.typography.caption.fontSize,
  fontFamily: theme.typography.fontFamily
}));
const StepIcon = /*#__PURE__*/React$H.forwardRef(function StepIcon(inProps, ref) {
  const props = (0, _DefaultPropsProvider$n.useDefaultProps)({
    props: inProps,
    name: 'MuiStepIcon'
  });
  const {
      active = false,
      className: classNameProp,
      completed = false,
      error = false,
      icon
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$r.default)(props, _excluded$V);
  const ownerState = (0, _extends2$r.default)({}, props, {
    active,
    completed,
    error
  });
  const classes = useUtilityClasses$m(ownerState);
  if (typeof icon === 'number' || typeof icon === 'string') {
    const className = (0, _clsx$Y.default)(classNameProp, classes.root);
    if (error) {
      return /*#__PURE__*/(0, _jsxRuntime$u.jsx)(StepIconRoot, (0, _extends2$r.default)({
        as: _Warning.default,
        className: className,
        ref: ref,
        ownerState: ownerState
      }, other));
    }
    if (completed) {
      return /*#__PURE__*/(0, _jsxRuntime$u.jsx)(StepIconRoot, (0, _extends2$r.default)({
        as: _CheckCircle.default,
        className: className,
        ref: ref,
        ownerState: ownerState
      }, other));
    }
    return /*#__PURE__*/(0, _jsxRuntime$u.jsxs)(StepIconRoot, (0, _extends2$r.default)({
      className: className,
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [_circle$1 || (_circle$1 = /*#__PURE__*/(0, _jsxRuntime$u.jsx)("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /*#__PURE__*/(0, _jsxRuntime$u.jsx)(StepIconText, {
        className: classes.text,
        x: "12",
        y: "12",
        textAnchor: "middle",
        dominantBaseline: "central",
        ownerState: ownerState,
        children: icon
      })]
    }));
  }
  return icon;
});
process.env.NODE_ENV !== "production" ? StepIcon.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Whether this step is active.
   * @default false
   */
  active: _propTypes$Q.default.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$Q.default.object,
  /**
   * @ignore
   */
  className: _propTypes$Q.default.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: _propTypes$Q.default.bool,
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: _propTypes$Q.default.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: _propTypes$Q.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$Q.default.oneOfType([_propTypes$Q.default.arrayOf(_propTypes$Q.default.oneOfType([_propTypes$Q.default.func, _propTypes$Q.default.object, _propTypes$Q.default.bool])), _propTypes$Q.default.func, _propTypes$Q.default.object])
} : void 0;
StepIcon$1.default = StepIcon;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  stepIconClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _StepIcon.default;
  }
});
Object.defineProperty(exports, "stepIconClasses", {
  enumerable: true,
  get: function () {
    return _stepIconClasses.default;
  }
});
var _StepIcon = _interopRequireDefault(StepIcon$1);
var _stepIconClasses = _interopRequireWildcard(stepIconClasses$1);
Object.keys(_stepIconClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _stepIconClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _stepIconClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(StepIcon$2));

var stepLabelClasses$1 = {};

var _interopRequireDefault$4d = interopRequireDefault$1.exports;
Object.defineProperty(stepLabelClasses$1, "__esModule", {
  value: true
});
stepLabelClasses$1.default = void 0;
stepLabelClasses$1.getStepLabelUtilityClass = getStepLabelUtilityClass;
var _generateUtilityClasses$l = _interopRequireDefault$4d(generateUtilityClasses$3);
var _generateUtilityClass$l = _interopRequireDefault$4d(generateUtilityClass$3);
function getStepLabelUtilityClass(slot) {
  return (0, _generateUtilityClass$l.default)('MuiStepLabel', slot);
}
const stepLabelClasses = (0, _generateUtilityClasses$l.default)('MuiStepLabel', ['root', 'horizontal', 'vertical', 'label', 'active', 'completed', 'error', 'disabled', 'iconContainer', 'alternativeLabel', 'labelContainer']);
stepLabelClasses$1.default = stepLabelClasses;

var _interopRequireDefault$4c = interopRequireDefault$1.exports;
Object.defineProperty(StepLabel$1, "__esModule", {
  value: true
});
StepLabel$1.default = void 0;
var _objectWithoutPropertiesLoose2$q = _interopRequireDefault$4c(objectWithoutPropertiesLoose.exports);
var _extends2$q = _interopRequireDefault$4c(_extends$19.exports);
var React$G = _interopRequireWildcard$1z(React__default$4);
var _propTypes$P = _interopRequireDefault$4c(propTypes.exports);
var _clsx$X = _interopRequireDefault$4c(clsx.exports);
var _composeClasses$l = _interopRequireDefault$4c(composeClasses$2);
var _styled$l = _interopRequireDefault$4c(styled$2);
var _DefaultPropsProvider$m = DefaultPropsProvider$5;
var _StepIcon = _interopRequireDefault$4c(StepIcon$2);
var _StepperContext$4 = _interopRequireDefault$4c(StepperContext$1);
var _StepContext$3 = _interopRequireDefault$4c(StepContext$1);
var _stepLabelClasses = _interopRequireWildcard$1z(stepLabelClasses$1);
var _jsxRuntime$t = require$$11;
const _excluded$U = ["children", "className", "componentsProps", "error", "icon", "optional", "slotProps", "StepIconComponent", "StepIconProps"];
function _getRequireWildcardCache$1i(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1i = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1z(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1i(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$l = ownerState => {
  const {
    classes,
    orientation,
    active,
    completed,
    error,
    disabled,
    alternativeLabel
  } = ownerState;
  const slots = {
    root: ['root', orientation, error && 'error', disabled && 'disabled', alternativeLabel && 'alternativeLabel'],
    label: ['label', active && 'active', completed && 'completed', error && 'error', disabled && 'disabled', alternativeLabel && 'alternativeLabel'],
    iconContainer: ['iconContainer', active && 'active', completed && 'completed', error && 'error', disabled && 'disabled', alternativeLabel && 'alternativeLabel'],
    labelContainer: ['labelContainer', alternativeLabel && 'alternativeLabel']
  };
  return (0, _composeClasses$l.default)(slots, _stepLabelClasses.getStepLabelUtilityClass, classes);
};
const StepLabelRoot = (0, _styled$l.default)('span', {
  name: 'MuiStepLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation]];
  }
})(({
  ownerState
}) => (0, _extends2$q.default)({
  display: 'flex',
  alignItems: 'center',
  [`&.${_stepLabelClasses.default.alternativeLabel}`]: {
    flexDirection: 'column'
  },
  [`&.${_stepLabelClasses.default.disabled}`]: {
    cursor: 'default'
  }
}, ownerState.orientation === 'vertical' && {
  textAlign: 'left',
  padding: '8px 0'
}));
const StepLabelLabel = (0, _styled$l.default)('span', {
  name: 'MuiStepLabel',
  slot: 'Label',
  overridesResolver: (props, styles) => styles.label
})(({
  theme
}) => (0, _extends2$q.default)({}, theme.typography.body2, {
  display: 'block',
  transition: theme.transitions.create('color', {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${_stepLabelClasses.default.active}`]: {
    color: (theme.vars || theme).palette.text.primary,
    fontWeight: 500
  },
  [`&.${_stepLabelClasses.default.completed}`]: {
    color: (theme.vars || theme).palette.text.primary,
    fontWeight: 500
  },
  [`&.${_stepLabelClasses.default.alternativeLabel}`]: {
    marginTop: 16
  },
  [`&.${_stepLabelClasses.default.error}`]: {
    color: (theme.vars || theme).palette.error.main
  }
}));
const StepLabelIconContainer = (0, _styled$l.default)('span', {
  name: 'MuiStepLabel',
  slot: 'IconContainer',
  overridesResolver: (props, styles) => styles.iconContainer
})(() => ({
  flexShrink: 0,
  // Fix IE11 issue
  display: 'flex',
  paddingRight: 8,
  [`&.${_stepLabelClasses.default.alternativeLabel}`]: {
    paddingRight: 0
  }
}));
const StepLabelLabelContainer = (0, _styled$l.default)('span', {
  name: 'MuiStepLabel',
  slot: 'LabelContainer',
  overridesResolver: (props, styles) => styles.labelContainer
})(({
  theme
}) => ({
  width: '100%',
  color: (theme.vars || theme).palette.text.secondary,
  [`&.${_stepLabelClasses.default.alternativeLabel}`]: {
    textAlign: 'center'
  }
}));
const StepLabel = /*#__PURE__*/React$G.forwardRef(function StepLabel(inProps, ref) {
  var _slotProps$label;
  const props = (0, _DefaultPropsProvider$m.useDefaultProps)({
    props: inProps,
    name: 'MuiStepLabel'
  });
  const {
      children,
      className,
      componentsProps = {},
      error = false,
      icon: iconProp,
      optional,
      slotProps = {},
      StepIconComponent: StepIconComponentProp,
      StepIconProps
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$q.default)(props, _excluded$U);
  const {
    alternativeLabel,
    orientation
  } = React$G.useContext(_StepperContext$4.default);
  const {
    active,
    disabled,
    completed,
    icon: iconContext
  } = React$G.useContext(_StepContext$3.default);
  const icon = iconProp || iconContext;
  let StepIconComponent = StepIconComponentProp;
  if (icon && !StepIconComponent) {
    StepIconComponent = _StepIcon.default;
  }
  const ownerState = (0, _extends2$q.default)({}, props, {
    active,
    alternativeLabel,
    completed,
    disabled,
    error,
    orientation
  });
  const classes = useUtilityClasses$l(ownerState);
  const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
  return /*#__PURE__*/(0, _jsxRuntime$t.jsxs)(StepLabelRoot, (0, _extends2$q.default)({
    className: (0, _clsx$X.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [icon || StepIconComponent ? /*#__PURE__*/(0, _jsxRuntime$t.jsx)(StepLabelIconContainer, {
      className: classes.iconContainer,
      ownerState: ownerState,
      children: /*#__PURE__*/(0, _jsxRuntime$t.jsx)(StepIconComponent, (0, _extends2$q.default)({
        completed: completed,
        active: active,
        error: error,
        icon: icon
      }, StepIconProps))
    }) : null, /*#__PURE__*/(0, _jsxRuntime$t.jsxs)(StepLabelLabelContainer, {
      className: classes.labelContainer,
      ownerState: ownerState,
      children: [children ? /*#__PURE__*/(0, _jsxRuntime$t.jsx)(StepLabelLabel, (0, _extends2$q.default)({
        ownerState: ownerState
      }, labelSlotProps, {
        className: (0, _clsx$X.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
        children: children
      })) : null, optional]
    })]
  }));
});
process.env.NODE_ENV !== "production" ? StepLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: _propTypes$P.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$P.default.object,
  /**
   * @ignore
   */
  className: _propTypes$P.default.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: _propTypes$P.default.shape({
    label: _propTypes$P.default.object
  }),
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: _propTypes$P.default.bool,
  /**
   * Override the default label of the step icon.
   */
  icon: _propTypes$P.default.node,
  /**
   * The optional node to display.
   */
  optional: _propTypes$P.default.node,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: _propTypes$P.default.shape({
    label: _propTypes$P.default.object
  }),
  /**
   * The component to render in place of the [`StepIcon`](/material-ui/api/step-icon/).
   */
  StepIconComponent: _propTypes$P.default.elementType,
  /**
   * Props applied to the [`StepIcon`](/material-ui/api/step-icon/) element.
   */
  StepIconProps: _propTypes$P.default.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$P.default.oneOfType([_propTypes$P.default.arrayOf(_propTypes$P.default.oneOfType([_propTypes$P.default.func, _propTypes$P.default.object, _propTypes$P.default.bool])), _propTypes$P.default.func, _propTypes$P.default.object])
} : void 0;
StepLabel.muiName = 'StepLabel';
StepLabel$1.default = StepLabel;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  stepLabelClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _StepLabel.default;
  }
});
Object.defineProperty(exports, "stepLabelClasses", {
  enumerable: true,
  get: function () {
    return _stepLabelClasses.default;
  }
});
var _StepLabel = _interopRequireDefault(StepLabel$1);
var _stepLabelClasses = _interopRequireWildcard(stepLabelClasses$1);
Object.keys(_stepLabelClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _stepLabelClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _stepLabelClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(StepLabel$2));

var stepButtonClasses$1 = {};

var _interopRequireDefault$4b = interopRequireDefault$1.exports;
Object.defineProperty(stepButtonClasses$1, "__esModule", {
  value: true
});
stepButtonClasses$1.default = void 0;
stepButtonClasses$1.getStepButtonUtilityClass = getStepButtonUtilityClass;
var _generateUtilityClasses$k = _interopRequireDefault$4b(generateUtilityClasses$3);
var _generateUtilityClass$k = _interopRequireDefault$4b(generateUtilityClass$3);
function getStepButtonUtilityClass(slot) {
  return (0, _generateUtilityClass$k.default)('MuiStepButton', slot);
}
const stepButtonClasses = (0, _generateUtilityClasses$k.default)('MuiStepButton', ['root', 'horizontal', 'vertical', 'touchRipple']);
stepButtonClasses$1.default = stepButtonClasses;

var _interopRequireDefault$4a = interopRequireDefault$1.exports;
Object.defineProperty(StepButton$1, "__esModule", {
  value: true
});
StepButton$1.default = void 0;
var _objectWithoutPropertiesLoose2$p = _interopRequireDefault$4a(objectWithoutPropertiesLoose.exports);
var _extends2$p = _interopRequireDefault$4a(_extends$19.exports);
var React$F = _interopRequireWildcard$1y(React__default$4);
var _propTypes$O = _interopRequireDefault$4a(propTypes.exports);
var _clsx$W = _interopRequireDefault$4a(clsx.exports);
var _composeClasses$k = _interopRequireDefault$4a(composeClasses$2);
var _styled$k = _interopRequireDefault$4a(styled$2);
var _DefaultPropsProvider$l = DefaultPropsProvider$5;
var _ButtonBase$4 = _interopRequireDefault$4a(ButtonBase$2);
var _StepLabel = _interopRequireDefault$4a(StepLabel$2);
var _isMuiElement = _interopRequireDefault$4a(isMuiElement);
var _StepperContext$3 = _interopRequireDefault$4a(StepperContext$1);
var _StepContext$2 = _interopRequireDefault$4a(StepContext$1);
var _stepButtonClasses = _interopRequireWildcard$1y(stepButtonClasses$1);
var _jsxRuntime$s = require$$11;
const _excluded$T = ["children", "className", "icon", "optional"];
function _getRequireWildcardCache$1h(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1h = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1y(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1h(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$k = ownerState => {
  const {
    classes,
    orientation
  } = ownerState;
  const slots = {
    root: ['root', orientation],
    touchRipple: ['touchRipple']
  };
  return (0, _composeClasses$k.default)(slots, _stepButtonClasses.getStepButtonUtilityClass, classes);
};
const StepButtonRoot = (0, _styled$k.default)(_ButtonBase$4.default, {
  name: 'MuiStepButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_stepButtonClasses.default.touchRipple}`]: styles.touchRipple
    }, styles.root, styles[ownerState.orientation]];
  }
})(({
  ownerState
}) => (0, _extends2$p.default)({
  width: '100%',
  padding: '24px 16px',
  margin: '-24px -16px',
  boxSizing: 'content-box'
}, ownerState.orientation === 'vertical' && {
  justifyContent: 'flex-start',
  padding: '8px',
  margin: '-8px'
}, {
  [`& .${_stepButtonClasses.default.touchRipple}`]: {
    color: 'rgba(0, 0, 0, 0.3)'
  }
}));
const StepButton = /*#__PURE__*/React$F.forwardRef(function StepButton(inProps, ref) {
  const props = (0, _DefaultPropsProvider$l.useDefaultProps)({
    props: inProps,
    name: 'MuiStepButton'
  });
  const {
      children,
      className,
      icon,
      optional
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$p.default)(props, _excluded$T);
  const {
    disabled,
    active
  } = React$F.useContext(_StepContext$2.default);
  const {
    orientation
  } = React$F.useContext(_StepperContext$3.default);
  const ownerState = (0, _extends2$p.default)({}, props, {
    orientation
  });
  const classes = useUtilityClasses$k(ownerState);
  const childProps = {
    icon,
    optional
  };
  const child = (0, _isMuiElement.default)(children, ['StepLabel']) ? ( /*#__PURE__*/React$F.cloneElement(children, childProps)) : /*#__PURE__*/(0, _jsxRuntime$s.jsx)(_StepLabel.default, (0, _extends2$p.default)({}, childProps, {
    children: children
  }));
  return /*#__PURE__*/(0, _jsxRuntime$s.jsx)(StepButtonRoot, (0, _extends2$p.default)({
    focusRipple: true,
    disabled: disabled,
    TouchRippleProps: {
      className: classes.touchRipple
    },
    className: (0, _clsx$W.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState,
    "aria-current": active ? 'step' : undefined
  }, other, {
    children: child
  }));
});
process.env.NODE_ENV !== "production" ? StepButton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: _propTypes$O.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$O.default.object,
  /**
   * @ignore
   */
  className: _propTypes$O.default.string,
  /**
   * The icon displayed by the step label.
   */
  icon: _propTypes$O.default.node,
  /**
   * The optional node to display.
   */
  optional: _propTypes$O.default.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$O.default.oneOfType([_propTypes$O.default.arrayOf(_propTypes$O.default.oneOfType([_propTypes$O.default.func, _propTypes$O.default.object, _propTypes$O.default.bool])), _propTypes$O.default.func, _propTypes$O.default.object])
} : void 0;
StepButton$1.default = StepButton;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  stepButtonClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _StepButton.default;
  }
});
Object.defineProperty(exports, "stepButtonClasses", {
  enumerable: true,
  get: function () {
    return _stepButtonClasses.default;
  }
});
var _StepButton = _interopRequireDefault(StepButton$1);
var _stepButtonClasses = _interopRequireWildcard(stepButtonClasses$1);
Object.keys(_stepButtonClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _stepButtonClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _stepButtonClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(StepButton$2));

var StepConnector$2 = {};

var StepConnector$1 = {};

var stepConnectorClasses$1 = {};

var _interopRequireDefault$49 = interopRequireDefault$1.exports;
Object.defineProperty(stepConnectorClasses$1, "__esModule", {
  value: true
});
stepConnectorClasses$1.default = void 0;
stepConnectorClasses$1.getStepConnectorUtilityClass = getStepConnectorUtilityClass;
var _generateUtilityClasses$j = _interopRequireDefault$49(generateUtilityClasses$3);
var _generateUtilityClass$j = _interopRequireDefault$49(generateUtilityClass$3);
function getStepConnectorUtilityClass(slot) {
  return (0, _generateUtilityClass$j.default)('MuiStepConnector', slot);
}
const stepConnectorClasses = (0, _generateUtilityClasses$j.default)('MuiStepConnector', ['root', 'horizontal', 'vertical', 'alternativeLabel', 'active', 'completed', 'disabled', 'line', 'lineHorizontal', 'lineVertical']);
stepConnectorClasses$1.default = stepConnectorClasses;

var _interopRequireDefault$48 = interopRequireDefault$1.exports;
Object.defineProperty(StepConnector$1, "__esModule", {
  value: true
});
StepConnector$1.default = void 0;
var _objectWithoutPropertiesLoose2$o = _interopRequireDefault$48(objectWithoutPropertiesLoose.exports);
var _extends2$o = _interopRequireDefault$48(_extends$19.exports);
var React$E = _interopRequireWildcard$1x(React__default$4);
var _propTypes$N = _interopRequireDefault$48(propTypes.exports);
var _clsx$V = _interopRequireDefault$48(clsx.exports);
var _composeClasses$j = _interopRequireDefault$48(composeClasses$2);
var _capitalize$7 = _interopRequireDefault$48(capitalize$1);
var _styled$j = _interopRequireDefault$48(styled$2);
var _DefaultPropsProvider$k = DefaultPropsProvider$5;
var _StepperContext$2 = _interopRequireDefault$48(StepperContext$1);
var _StepContext$1 = _interopRequireDefault$48(StepContext$1);
var _stepConnectorClasses = stepConnectorClasses$1;
var _jsxRuntime$r = require$$11;
const _excluded$S = ["className"];
function _getRequireWildcardCache$1g(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1g = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1x(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1g(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$j = ownerState => {
  const {
    classes,
    orientation,
    alternativeLabel,
    active,
    completed,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', orientation, alternativeLabel && 'alternativeLabel', active && 'active', completed && 'completed', disabled && 'disabled'],
    line: ['line', `line${(0, _capitalize$7.default)(orientation)}`]
  };
  return (0, _composeClasses$j.default)(slots, _stepConnectorClasses.getStepConnectorUtilityClass, classes);
};
const StepConnectorRoot = (0, _styled$j.default)('div', {
  name: 'MuiStepConnector',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.completed && styles.completed];
  }
})(({
  ownerState
}) => (0, _extends2$o.default)({
  flex: '1 1 auto'
}, ownerState.orientation === 'vertical' && {
  marginLeft: 12 // half icon
}, ownerState.alternativeLabel && {
  position: 'absolute',
  top: 8 + 4,
  left: 'calc(-50% + 20px)',
  right: 'calc(50% + 20px)'
}));
const StepConnectorLine = (0, _styled$j.default)('span', {
  name: 'MuiStepConnector',
  slot: 'Line',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.line, styles[`line${(0, _capitalize$7.default)(ownerState.orientation)}`]];
  }
})(({
  ownerState,
  theme
}) => {
  const borderColor = theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
  return (0, _extends2$o.default)({
    display: 'block',
    borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
  }, ownerState.orientation === 'horizontal' && {
    borderTopStyle: 'solid',
    borderTopWidth: 1
  }, ownerState.orientation === 'vertical' && {
    borderLeftStyle: 'solid',
    borderLeftWidth: 1,
    minHeight: 24
  });
});
const StepConnector = /*#__PURE__*/React$E.forwardRef(function StepConnector(inProps, ref) {
  const props = (0, _DefaultPropsProvider$k.useDefaultProps)({
    props: inProps,
    name: 'MuiStepConnector'
  });
  const {
      className
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$o.default)(props, _excluded$S);
  const {
    alternativeLabel,
    orientation = 'horizontal'
  } = React$E.useContext(_StepperContext$2.default);
  const {
    active,
    disabled,
    completed
  } = React$E.useContext(_StepContext$1.default);
  const ownerState = (0, _extends2$o.default)({}, props, {
    alternativeLabel,
    orientation,
    active,
    completed,
    disabled
  });
  const classes = useUtilityClasses$j(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$r.jsx)(StepConnectorRoot, (0, _extends2$o.default)({
    className: (0, _clsx$V.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$r.jsx)(StepConnectorLine, {
      className: classes.line,
      ownerState: ownerState
    })
  }));
});
process.env.NODE_ENV !== "production" ? StepConnector.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$N.default.object,
  /**
   * @ignore
   */
  className: _propTypes$N.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$N.default.oneOfType([_propTypes$N.default.arrayOf(_propTypes$N.default.oneOfType([_propTypes$N.default.func, _propTypes$N.default.object, _propTypes$N.default.bool])), _propTypes$N.default.func, _propTypes$N.default.object])
} : void 0;
StepConnector$1.default = StepConnector;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  stepConnectorClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _StepConnector.default;
  }
});
Object.defineProperty(exports, "stepConnectorClasses", {
  enumerable: true,
  get: function () {
    return _stepConnectorClasses.default;
  }
});
var _StepConnector = _interopRequireDefault(StepConnector$1);
var _stepConnectorClasses = _interopRequireWildcard(stepConnectorClasses$1);
Object.keys(_stepConnectorClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _stepConnectorClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _stepConnectorClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(StepConnector$2));

var StepContent$2 = {};

var StepContent$1 = {};

var stepContentClasses$1 = {};

var _interopRequireDefault$47 = interopRequireDefault$1.exports;
Object.defineProperty(stepContentClasses$1, "__esModule", {
  value: true
});
stepContentClasses$1.default = void 0;
stepContentClasses$1.getStepContentUtilityClass = getStepContentUtilityClass;
var _generateUtilityClasses$i = _interopRequireDefault$47(generateUtilityClasses$3);
var _generateUtilityClass$i = _interopRequireDefault$47(generateUtilityClass$3);
function getStepContentUtilityClass(slot) {
  return (0, _generateUtilityClass$i.default)('MuiStepContent', slot);
}
const stepContentClasses = (0, _generateUtilityClasses$i.default)('MuiStepContent', ['root', 'last', 'transition']);
stepContentClasses$1.default = stepContentClasses;

var _interopRequireDefault$46 = interopRequireDefault$1.exports;
Object.defineProperty(StepContent$1, "__esModule", {
  value: true
});
StepContent$1.default = void 0;
var _objectWithoutPropertiesLoose2$n = _interopRequireDefault$46(objectWithoutPropertiesLoose.exports);
var _extends2$n = _interopRequireDefault$46(_extends$19.exports);
var React$D = _interopRequireWildcard$1w(React__default$4);
var _propTypes$M = _interopRequireDefault$46(propTypes.exports);
var _clsx$U = _interopRequireDefault$46(clsx.exports);
var _composeClasses$i = _interopRequireDefault$46(composeClasses$2);
var _styled$i = _interopRequireDefault$46(styled$2);
var _DefaultPropsProvider$j = DefaultPropsProvider$5;
var _Collapse = _interopRequireDefault$46(Collapse$2);
var _StepperContext$1 = _interopRequireDefault$46(StepperContext$1);
var _StepContext = _interopRequireDefault$46(StepContext$1);
var _stepContentClasses = stepContentClasses$1;
var _jsxRuntime$q = require$$11;
const _excluded$R = ["children", "className", "TransitionComponent", "transitionDuration", "TransitionProps"];
function _getRequireWildcardCache$1f(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1f = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1w(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1f(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$i = ownerState => {
  const {
    classes,
    last
  } = ownerState;
  const slots = {
    root: ['root', last && 'last'],
    transition: ['transition']
  };
  return (0, _composeClasses$i.default)(slots, _stepContentClasses.getStepContentUtilityClass, classes);
};
const StepContentRoot = (0, _styled$i.default)('div', {
  name: 'MuiStepContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.last && styles.last];
  }
})(({
  ownerState,
  theme
}) => (0, _extends2$n.default)({
  marginLeft: 12,
  // half icon
  paddingLeft: 8 + 12,
  // margin + half icon
  paddingRight: 8,
  borderLeft: theme.vars ? `1px solid ${theme.vars.palette.StepContent.border}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]}`
}, ownerState.last && {
  borderLeft: 'none'
}));
const StepContentTransition = (0, _styled$i.default)(_Collapse.default, {
  name: 'MuiStepContent',
  slot: 'Transition',
  overridesResolver: (props, styles) => styles.transition
})({});
const StepContent = /*#__PURE__*/React$D.forwardRef(function StepContent(inProps, ref) {
  const props = (0, _DefaultPropsProvider$j.useDefaultProps)({
    props: inProps,
    name: 'MuiStepContent'
  });
  const {
      children,
      className,
      TransitionComponent = _Collapse.default,
      transitionDuration: transitionDurationProp = 'auto',
      TransitionProps
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$n.default)(props, _excluded$R);
  const {
    orientation
  } = React$D.useContext(_StepperContext$1.default);
  const {
    active,
    last,
    expanded
  } = React$D.useContext(_StepContext.default);
  const ownerState = (0, _extends2$n.default)({}, props, {
    last
  });
  const classes = useUtilityClasses$i(ownerState);
  if (process.env.NODE_ENV !== 'production') {
    if (orientation !== 'vertical') {
      console.error('MUI: <StepContent /> is only designed for use with the vertical stepper.');
    }
  }
  let transitionDuration = transitionDurationProp;
  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }
  return /*#__PURE__*/(0, _jsxRuntime$q.jsx)(StepContentRoot, (0, _extends2$n.default)({
    className: (0, _clsx$U.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$q.jsx)(StepContentTransition, (0, _extends2$n.default)({
      as: TransitionComponent,
      in: active || expanded,
      className: classes.transition,
      ownerState: ownerState,
      timeout: transitionDuration,
      unmountOnExit: true
    }, TransitionProps, {
      children: children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? StepContent.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$M.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$M.default.object,
  /**
   * @ignore
   */
  className: _propTypes$M.default.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$M.default.oneOfType([_propTypes$M.default.arrayOf(_propTypes$M.default.oneOfType([_propTypes$M.default.func, _propTypes$M.default.object, _propTypes$M.default.bool])), _propTypes$M.default.func, _propTypes$M.default.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Collapse
   */
  TransitionComponent: _propTypes$M.default.elementType,
  /**
   * Adjust the duration of the content expand transition.
   * Passed as a prop to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: _propTypes$M.default.oneOfType([_propTypes$M.default.oneOf(['auto']), _propTypes$M.default.number, _propTypes$M.default.shape({
    appear: _propTypes$M.default.number,
    enter: _propTypes$M.default.number,
    exit: _propTypes$M.default.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: _propTypes$M.default.object
} : void 0;
StepContent$1.default = StepContent;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  stepContentClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _StepContent.default;
  }
});
Object.defineProperty(exports, "stepContentClasses", {
  enumerable: true,
  get: function () {
    return _stepContentClasses.default;
  }
});
var _StepContent = _interopRequireDefault(StepContent$1);
var _stepContentClasses = _interopRequireWildcard(stepContentClasses$1);
Object.keys(_stepContentClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _stepContentClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _stepContentClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(StepContent$2));

var Stepper$3 = {};

var Stepper$2 = {};

var stepperClasses$1 = {};

var _interopRequireDefault$45 = interopRequireDefault$1.exports;
Object.defineProperty(stepperClasses$1, "__esModule", {
  value: true
});
stepperClasses$1.default = void 0;
stepperClasses$1.getStepperUtilityClass = getStepperUtilityClass;
var _generateUtilityClasses$h = _interopRequireDefault$45(generateUtilityClasses$3);
var _generateUtilityClass$h = _interopRequireDefault$45(generateUtilityClass$3);
function getStepperUtilityClass(slot) {
  return (0, _generateUtilityClass$h.default)('MuiStepper', slot);
}
const stepperClasses = (0, _generateUtilityClasses$h.default)('MuiStepper', ['root', 'horizontal', 'vertical', 'nonLinear', 'alternativeLabel']);
stepperClasses$1.default = stepperClasses;

var _interopRequireDefault$44 = interopRequireDefault$1.exports;
Object.defineProperty(Stepper$2, "__esModule", {
  value: true
});
Stepper$2.default = void 0;
var _objectWithoutPropertiesLoose2$m = _interopRequireDefault$44(objectWithoutPropertiesLoose.exports);
var _extends2$m = _interopRequireDefault$44(_extends$19.exports);
var React$C = _interopRequireWildcard$1v(React__default$4);
var _propTypes$L = _interopRequireDefault$44(propTypes.exports);
var _clsx$T = _interopRequireDefault$44(clsx.exports);
var _integerPropType$1 = _interopRequireDefault$44(integerPropType$1);
var _composeClasses$h = _interopRequireDefault$44(composeClasses$2);
var _DefaultPropsProvider$i = DefaultPropsProvider$5;
var _styled$h = _interopRequireDefault$44(styled$2);
var _stepperClasses = stepperClasses$1;
var _StepConnector = _interopRequireDefault$44(StepConnector$2);
var _StepperContext = _interopRequireDefault$44(StepperContext$1);
var _jsxRuntime$p = require$$11;
const _excluded$Q = ["activeStep", "alternativeLabel", "children", "className", "component", "connector", "nonLinear", "orientation"];
function _getRequireWildcardCache$1e(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1e = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1v(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1e(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$h = ownerState => {
  const {
    orientation,
    nonLinear,
    alternativeLabel,
    classes
  } = ownerState;
  const slots = {
    root: ['root', orientation, nonLinear && 'nonLinear', alternativeLabel && 'alternativeLabel']
  };
  return (0, _composeClasses$h.default)(slots, _stepperClasses.getStepperUtilityClass, classes);
};
const StepperRoot = (0, _styled$h.default)('div', {
  name: 'MuiStepper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.nonLinear && styles.nonLinear];
  }
})(({
  ownerState
}) => (0, _extends2$m.default)({
  display: 'flex'
}, ownerState.orientation === 'horizontal' && {
  flexDirection: 'row',
  alignItems: 'center'
}, ownerState.orientation === 'vertical' && {
  flexDirection: 'column'
}, ownerState.alternativeLabel && {
  alignItems: 'flex-start'
}));
const defaultConnector = /*#__PURE__*/(0, _jsxRuntime$p.jsx)(_StepConnector.default, {});
const Stepper$1 = /*#__PURE__*/React$C.forwardRef(function Stepper(inProps, ref) {
  const props = (0, _DefaultPropsProvider$i.useDefaultProps)({
    props: inProps,
    name: 'MuiStepper'
  });
  const {
      activeStep = 0,
      alternativeLabel = false,
      children,
      className,
      component = 'div',
      connector = defaultConnector,
      nonLinear = false,
      orientation = 'horizontal'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$m.default)(props, _excluded$Q);
  const ownerState = (0, _extends2$m.default)({}, props, {
    nonLinear,
    alternativeLabel,
    orientation,
    component
  });
  const classes = useUtilityClasses$h(ownerState);
  const childrenArray = React$C.Children.toArray(children).filter(Boolean);
  const steps = childrenArray.map((step, index) => {
    return /*#__PURE__*/React$C.cloneElement(step, (0, _extends2$m.default)({
      index,
      last: index + 1 === childrenArray.length
    }, step.props));
  });
  const contextValue = React$C.useMemo(() => ({
    activeStep,
    alternativeLabel,
    connector,
    nonLinear,
    orientation
  }), [activeStep, alternativeLabel, connector, nonLinear, orientation]);
  return /*#__PURE__*/(0, _jsxRuntime$p.jsx)(_StepperContext.default.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0, _jsxRuntime$p.jsx)(StepperRoot, (0, _extends2$m.default)({
      as: component,
      ownerState: ownerState,
      className: (0, _clsx$T.default)(classes.root, className),
      ref: ref
    }, other, {
      children: steps
    }))
  });
});
process.env.NODE_ENV !== "production" ? Stepper$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */
  activeStep: _integerPropType$1.default,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */
  alternativeLabel: _propTypes$L.default.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: _propTypes$L.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$L.default.object,
  /**
   * @ignore
   */
  className: _propTypes$L.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$L.default.elementType,
  /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */
  connector: _propTypes$L.default.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */
  nonLinear: _propTypes$L.default.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: _propTypes$L.default.oneOf(['horizontal', 'vertical']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$L.default.oneOfType([_propTypes$L.default.arrayOf(_propTypes$L.default.oneOfType([_propTypes$L.default.func, _propTypes$L.default.object, _propTypes$L.default.bool])), _propTypes$L.default.func, _propTypes$L.default.object])
} : void 0;
Stepper$2.default = Stepper$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  stepperClasses: true,
  StepperContext: true
};
Object.defineProperty(exports, "StepperContext", {
  enumerable: true,
  get: function () {
    return _StepperContext.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Stepper.default;
  }
});
Object.defineProperty(exports, "stepperClasses", {
  enumerable: true,
  get: function () {
    return _stepperClasses.default;
  }
});
var _Stepper = _interopRequireDefault(Stepper$2);
var _stepperClasses = _interopRequireWildcard(stepperClasses$1);
Object.keys(_stepperClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _stepperClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _stepperClasses[key];
    }
  });
});
var _StepperContext = _interopRequireWildcard(StepperContext$1);
Object.keys(_StepperContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StepperContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StepperContext[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Stepper$3));

var SwipeableDrawer$2 = {};

var SwipeableDrawer$1 = {};

var SwipeArea$1 = {};

var _interopRequireDefault$43 = interopRequireDefault$1.exports;
Object.defineProperty(SwipeArea$1, "__esModule", {
  value: true
});
SwipeArea$1.default = void 0;
var _objectWithoutPropertiesLoose2$l = _interopRequireDefault$43(objectWithoutPropertiesLoose.exports);
var _extends2$l = _interopRequireDefault$43(_extends$19.exports);
var React$B = _interopRequireWildcard$1u(React__default$4);
var _propTypes$K = _interopRequireDefault$43(propTypes.exports);
var _clsx$S = _interopRequireDefault$43(clsx.exports);
var _styled$g = _interopRequireWildcard$1u(styled$2);
var _capitalize$6 = _interopRequireDefault$43(capitalize$1);
var _Drawer$1 = Drawer$1;
var _jsxRuntime$o = require$$11;
const _excluded$P = ["anchor", "classes", "className", "width", "style"];
function _getRequireWildcardCache$1d(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1d = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1u(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1d(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SwipeAreaRoot = (0, _styled$g.default)('div', {
  shouldForwardProp: _styled$g.rootShouldForwardProp
})(({
  theme,
  ownerState
}) => (0, _extends2$l.default)({
  position: 'fixed',
  top: 0,
  left: 0,
  bottom: 0,
  zIndex: theme.zIndex.drawer - 1
}, ownerState.anchor === 'left' && {
  right: 'auto'
}, ownerState.anchor === 'right' && {
  left: 'auto',
  right: 0
}, ownerState.anchor === 'top' && {
  bottom: 'auto',
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  bottom: 0,
  right: 0
}));

/**
 * @ignore - internal component.
 */
const SwipeArea = /*#__PURE__*/React$B.forwardRef(function SwipeArea(props, ref) {
  const {
      anchor,
      classes = {},
      className,
      width,
      style
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$l.default)(props, _excluded$P);
  const ownerState = props;
  return /*#__PURE__*/(0, _jsxRuntime$o.jsx)(SwipeAreaRoot, (0, _extends2$l.default)({
    className: (0, _clsx$S.default)('PrivateSwipeArea-root', classes.root, classes[`anchor${(0, _capitalize$6.default)(anchor)}`], className),
    ref: ref,
    style: (0, _extends2$l.default)({
      [(0, _Drawer$1.isHorizontal)(anchor) ? 'width' : 'height']: width
    }, style),
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? SwipeArea.propTypes = {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: _propTypes$K.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,
  /**
   * @ignore
   */
  classes: _propTypes$K.default.object,
  /**
   * @ignore
   */
  className: _propTypes$K.default.string,
  /**
   * @ignore
   */
  style: _propTypes$K.default.object,
  /**
   * The width of the left most (or right most) area in `px` where the
   * drawer can be swiped open from.
   */
  width: _propTypes$K.default.number.isRequired
} : void 0;
SwipeArea$1.default = SwipeArea;

var _interopRequireDefault$42 = interopRequireDefault$1.exports;
Object.defineProperty(SwipeableDrawer$1, "__esModule", {
  value: true
});
SwipeableDrawer$1.default = void 0;
SwipeableDrawer$1.reset = reset$1;
var _extends2$k = _interopRequireDefault$42(_extends$19.exports);
var _objectWithoutPropertiesLoose2$k = _interopRequireDefault$42(objectWithoutPropertiesLoose.exports);
var React$A = _interopRequireWildcard$1t(React__default$4);
var ReactDOM = _interopRequireWildcard$1t(require$$2$1);
var _propTypes$J = _interopRequireDefault$42(propTypes.exports);
var _elementTypeAcceptingRef = _interopRequireDefault$42(elementTypeAcceptingRef$2);
var _NoSsr = _interopRequireDefault$42(NoSsr$2);
var _DefaultPropsProvider$h = DefaultPropsProvider$5;
var _Drawer = _interopRequireWildcard$1t(Drawer$1);
var _useForkRef = _interopRequireDefault$42(useForkRef);
var _ownerDocument$1 = _interopRequireDefault$42(ownerDocument);
var _ownerWindow$1 = _interopRequireDefault$42(ownerWindow);
var _useEventCallback$1 = _interopRequireDefault$42(useEventCallback);
var _useEnhancedEffect = _interopRequireDefault$42(useEnhancedEffect);
var _useTheme$1 = _interopRequireDefault$42(useTheme$4);
var _utils$y = utils$8;
var _SwipeArea = _interopRequireDefault$42(SwipeArea$1);
var _jsxRuntime$n = require$$11;
const _excluded$O = ["BackdropProps"],
  _excluded2$c = ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "allowSwipeInChildren", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]; // This value is closed to what browsers are using internally to
// trigger a native scroll.
function _getRequireWildcardCache$1c(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1c = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1t(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1c(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UNCERTAINTY_THRESHOLD = 3; // px

// This is the part of the drawer displayed on touch start.
const DRAG_STARTED_SIGNAL = 20; // px

// We can only have one instance at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
let claimedSwipeInstance = null;

// Exported for test purposes.
function reset$1() {
  claimedSwipeInstance = null;
}
function calculateCurrentX(anchor, touches, doc) {
  return anchor === 'right' ? doc.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}
function calculateCurrentY(anchor, touches, containerWindow) {
  return anchor === 'bottom' ? containerWindow.innerHeight - touches[0].clientY : touches[0].clientY;
}
function getMaxTranslate(horizontalSwipe, paperInstance) {
  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}
function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}

/**
 * @param {Element | null} element
 * @param {Element} rootNode
 */
function getDomTreeShapes(element, rootNode) {
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
  const domTreeShapes = [];
  while (element && element !== rootNode.parentElement) {
    const style = (0, _ownerWindow$1.default)(rootNode).getComputedStyle(element);
    if (
    // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' ||
    // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') ; else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push(element);
    }
    element = element.parentElement;
  }
  return domTreeShapes;
}

/**
 * @param {object} param0
 * @param {ReturnType<getDomTreeShapes>} param0.domTreeShapes
 */
function computeHasNativeHandler({
  domTreeShapes,
  start,
  current,
  anchor
}) {
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
  const axisProperties = {
    scrollPosition: {
      x: 'scrollLeft',
      y: 'scrollTop'
    },
    scrollLength: {
      x: 'scrollWidth',
      y: 'scrollHeight'
    },
    clientLength: {
      x: 'clientWidth',
      y: 'clientHeight'
    }
  };
  return domTreeShapes.some(shape => {
    // Determine if we are going backward or forward.
    let goingForward = current >= start;
    if (anchor === 'top' || anchor === 'left') {
      goingForward = !goingForward;
    }
    const axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
    const scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
    const areNotAtStart = scrollPosition > 0;
    const areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      return true;
    }
    return false;
  });
}
const iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
const SwipeableDrawer = /*#__PURE__*/React$A.forwardRef(function SwipeableDrawer(inProps, ref) {
  const props = (0, _DefaultPropsProvider$h.useDefaultProps)({
    name: 'MuiSwipeableDrawer',
    props: inProps
  });
  const theme = (0, _useTheme$1.default)();
  const transitionDurationDefault = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      anchor = 'left',
      disableBackdropTransition = false,
      disableDiscovery = false,
      disableSwipeToOpen = iOS,
      hideBackdrop,
      hysteresis = 0.52,
      allowSwipeInChildren = false,
      minFlingVelocity = 450,
      ModalProps: {
        BackdropProps
      } = {},
      onClose,
      onOpen,
      open = false,
      PaperProps = {},
      SwipeAreaProps,
      swipeAreaWidth = 20,
      transitionDuration = transitionDurationDefault,
      variant = 'temporary' // Mobile first.
    } = props,
    ModalPropsProp = (0, _objectWithoutPropertiesLoose2$k.default)(props.ModalProps, _excluded$O),
    other = (0, _objectWithoutPropertiesLoose2$k.default)(props, _excluded2$c);
  const [maybeSwiping, setMaybeSwiping] = React$A.useState(false);
  const swipeInstance = React$A.useRef({
    isSwiping: null
  });
  const swipeAreaRef = React$A.useRef();
  const backdropRef = React$A.useRef();
  const paperRef = React$A.useRef();
  const handleRef = (0, _useForkRef.default)(PaperProps.ref, paperRef);
  const touchDetected = React$A.useRef(false);

  // Ref for transition duration based on / to match swipe speed
  const calculatedDurationRef = React$A.useRef();

  // Use a ref so the open value used is always up to date inside useCallback.
  (0, _useEnhancedEffect.default)(() => {
    calculatedDurationRef.current = null;
  }, [open]);
  const setPosition = React$A.useCallback((translate, options = {}) => {
    const {
      mode = null,
      changeTransition = true
    } = options;
    const anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
    const rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
    const horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
    const transform = horizontalSwipe ? `translate(${rtlTranslateMultiplier * translate}px, 0)` : `translate(0, ${rtlTranslateMultiplier * translate}px)`;
    const drawerStyle = paperRef.current.style;
    drawerStyle.webkitTransform = transform;
    drawerStyle.transform = transform;
    let transition = '';
    if (mode) {
      transition = theme.transitions.create('all', (0, _utils$y.getTransitionProps)({
        easing: undefined,
        style: undefined,
        timeout: transitionDuration
      }, {
        mode
      }));
    }
    if (changeTransition) {
      drawerStyle.webkitTransition = transition;
      drawerStyle.transition = transition;
    }
    if (!disableBackdropTransition && !hideBackdrop) {
      const backdropStyle = backdropRef.current.style;
      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);
      if (changeTransition) {
        backdropStyle.webkitTransition = transition;
        backdropStyle.transition = transition;
      }
    }
  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
  const handleBodyTouchEnd = (0, _useEventCallback$1.default)(nativeEvent => {
    if (!touchDetected.current) {
      return;
    }
    claimedSwipeInstance = null;
    touchDetected.current = false;
    ReactDOM.flushSync(() => {
      setMaybeSwiping(false);
    });

    // The swipe wasn't started.
    if (!swipeInstance.current.isSwiping) {
      swipeInstance.current.isSwiping = null;
      return;
    }
    swipeInstance.current.isSwiping = null;
    const anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
    const horizontal = (0, _Drawer.isHorizontal)(anchor);
    let current;
    if (horizontal) {
      current = calculateCurrentX(anchorRtl, nativeEvent.changedTouches, (0, _ownerDocument$1.default)(nativeEvent.currentTarget));
    } else {
      current = calculateCurrentY(anchorRtl, nativeEvent.changedTouches, (0, _ownerWindow$1.default)(nativeEvent.currentTarget));
    }
    const startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
    const maxTranslate = getMaxTranslate(horizontal, paperRef.current);
    const currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
    const translateRatio = currentTranslate / maxTranslate;
    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
      // Calculate transition duration to match swipe speed
      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
    }
    if (open) {
      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
        onClose();
      } else {
        // Reset the position, the swipe was aborted.
        setPosition(0, {
          mode: 'exit'
        });
      }
      return;
    }
    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
      onOpen();
    } else {
      // Reset the position, the swipe was aborted.
      setPosition(getMaxTranslate(horizontal, paperRef.current), {
        mode: 'enter'
      });
    }
  });
  const startMaybeSwiping = (force = false) => {
    if (!maybeSwiping) {
      // on Safari Mobile, if you want to be able to have the 'click' event fired on child elements, nothing in the DOM can be changed.
      // this is because Safari Mobile will not fire any mouse events (still fires touch though) if the DOM changes during mousemove.
      // so do this change on first touchmove instead of touchstart
      if (force || !(disableDiscovery && allowSwipeInChildren)) {
        ReactDOM.flushSync(() => {
          setMaybeSwiping(true);
        });
      }
      const horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
      if (!open && paperRef.current) {
        // The ref may be null when a parent component updates while swiping.
        setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 15 : -DRAG_STARTED_SIGNAL), {
          changeTransition: false
        });
      }
      swipeInstance.current.velocity = 0;
      swipeInstance.current.lastTime = null;
      swipeInstance.current.lastTranslate = null;
      swipeInstance.current.paperHit = false;
      touchDetected.current = true;
    }
  };
  const handleBodyTouchMove = (0, _useEventCallback$1.default)(nativeEvent => {
    // the ref may be null when a parent component updates while swiping
    if (!paperRef.current || !touchDetected.current) {
      return;
    }

    // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
    if (claimedSwipeInstance !== null && claimedSwipeInstance !== swipeInstance.current) {
      return;
    }
    startMaybeSwiping(true);
    const anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
    const horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
    const currentX = calculateCurrentX(anchorRtl, nativeEvent.touches, (0, _ownerDocument$1.default)(nativeEvent.currentTarget));
    const currentY = calculateCurrentY(anchorRtl, nativeEvent.touches, (0, _ownerWindow$1.default)(nativeEvent.currentTarget));
    if (open && paperRef.current.contains(nativeEvent.target) && claimedSwipeInstance === null) {
      const domTreeShapes = getDomTreeShapes(nativeEvent.target, paperRef.current);
      const hasNativeHandler = computeHasNativeHandler({
        domTreeShapes,
        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
        current: horizontalSwipe ? currentX : currentY,
        anchor
      });
      if (hasNativeHandler) {
        claimedSwipeInstance = true;
        return;
      }
      claimedSwipeInstance = swipeInstance.current;
    }

    // We don't know yet.
    if (swipeInstance.current.isSwiping == null) {
      const dx = Math.abs(currentX - swipeInstance.current.startX);
      const dy = Math.abs(currentY - swipeInstance.current.startY);
      const definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;
      if (definitelySwiping && nativeEvent.cancelable) {
        nativeEvent.preventDefault();
      }
      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
        swipeInstance.current.isSwiping = definitelySwiping;
        if (!definitelySwiping) {
          handleBodyTouchEnd(nativeEvent);
          return;
        }

        // Shift the starting point.
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;

        // Compensate for the part of the drawer displayed on touch start.
        if (!disableDiscovery && !open) {
          if (horizontalSwipe) {
            swipeInstance.current.startX -= DRAG_STARTED_SIGNAL;
          } else {
            swipeInstance.current.startY -= DRAG_STARTED_SIGNAL;
          }
        }
      }
    }
    if (!swipeInstance.current.isSwiping) {
      return;
    }
    const maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
    let startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
    if (open && !swipeInstance.current.paperHit) {
      startLocation = Math.min(startLocation, maxTranslate);
    }
    const translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
    if (open) {
      if (!swipeInstance.current.paperHit) {
        const paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
        if (paperHit) {
          swipeInstance.current.paperHit = true;
          swipeInstance.current.startX = currentX;
          swipeInstance.current.startY = currentY;
        } else {
          return;
        }
      } else if (translate === 0) {
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
      }
    }
    if (swipeInstance.current.lastTranslate === null) {
      swipeInstance.current.lastTranslate = translate;
      swipeInstance.current.lastTime = performance.now() + 1;
    }
    const velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3;

    // Low Pass filter.
    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
    swipeInstance.current.lastTranslate = translate;
    swipeInstance.current.lastTime = performance.now();

    // We are swiping, let's prevent the scroll event on iOS.
    if (nativeEvent.cancelable) {
      nativeEvent.preventDefault();
    }
    setPosition(translate);
  });
  const handleBodyTouchStart = (0, _useEventCallback$1.default)(nativeEvent => {
    // We are not supposed to handle this touch move.
    // Example of use case: ignore the event if there is a Slider.
    if (nativeEvent.defaultPrevented) {
      return;
    }

    // We can only have one node at the time claiming ownership for handling the swipe.
    if (nativeEvent.defaultMuiPrevented) {
      return;
    }

    // At least one element clogs the drawer interaction zone.
    if (open && (hideBackdrop || !backdropRef.current.contains(nativeEvent.target)) && !paperRef.current.contains(nativeEvent.target)) {
      return;
    }
    const anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
    const horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
    const currentX = calculateCurrentX(anchorRtl, nativeEvent.touches, (0, _ownerDocument$1.default)(nativeEvent.currentTarget));
    const currentY = calculateCurrentY(anchorRtl, nativeEvent.touches, (0, _ownerWindow$1.default)(nativeEvent.currentTarget));
    if (!open) {
      var _paperRef$current;
      // logic for if swipe should be ignored:
      // if disableSwipeToOpen
      // if target != swipeArea, and target is not a child of paper ref
      // if is a child of paper ref, and `allowSwipeInChildren` does not allow it
      if (disableSwipeToOpen || !(nativeEvent.target === swipeAreaRef.current || (_paperRef$current = paperRef.current) != null && _paperRef$current.contains(nativeEvent.target) && (typeof allowSwipeInChildren === 'function' ? allowSwipeInChildren(nativeEvent, swipeAreaRef.current, paperRef.current) : allowSwipeInChildren))) {
        return;
      }
      if (horizontalSwipe) {
        if (currentX > swipeAreaWidth) {
          return;
        }
      } else if (currentY > swipeAreaWidth) {
        return;
      }
    }
    nativeEvent.defaultMuiPrevented = true;
    claimedSwipeInstance = null;
    swipeInstance.current.startX = currentX;
    swipeInstance.current.startY = currentY;
    startMaybeSwiping();
  });
  React$A.useEffect(() => {
    if (variant === 'temporary') {
      const doc = (0, _ownerDocument$1.default)(paperRef.current);
      doc.addEventListener('touchstart', handleBodyTouchStart);
      // A blocking listener prevents Firefox's navbar to auto-hide on scroll.
      // It only needs to prevent scrolling on the drawer's content when open.
      // When closed, the overlay prevents scrolling.
      doc.addEventListener('touchmove', handleBodyTouchMove, {
        passive: !open
      });
      doc.addEventListener('touchend', handleBodyTouchEnd);
      return () => {
        doc.removeEventListener('touchstart', handleBodyTouchStart);
        doc.removeEventListener('touchmove', handleBodyTouchMove, {
          passive: !open
        });
        doc.removeEventListener('touchend', handleBodyTouchEnd);
      };
    }
    return undefined;
  }, [variant, open, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
  React$A.useEffect(() => () => {
    // We need to release the lock.
    if (claimedSwipeInstance === swipeInstance.current) {
      claimedSwipeInstance = null;
    }
  }, []);
  React$A.useEffect(() => {
    if (!open) {
      setMaybeSwiping(false);
    }
  }, [open]);
  return /*#__PURE__*/(0, _jsxRuntime$n.jsxs)(React$A.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime$n.jsx)(_Drawer.default, (0, _extends2$k.default)({
      open: variant === 'temporary' && maybeSwiping ? true : open,
      variant: variant,
      ModalProps: (0, _extends2$k.default)({
        BackdropProps: (0, _extends2$k.default)({}, BackdropProps, {
          ref: backdropRef
        })
      }, variant === 'temporary' && {
        keepMounted: true
      }, ModalPropsProp),
      hideBackdrop: hideBackdrop,
      PaperProps: (0, _extends2$k.default)({}, PaperProps, {
        style: (0, _extends2$k.default)({
          pointerEvents: variant === 'temporary' && !open && !allowSwipeInChildren ? 'none' : ''
        }, PaperProps.style),
        ref: handleRef
      }),
      anchor: anchor,
      transitionDuration: calculatedDurationRef.current || transitionDuration,
      onClose: onClose,
      ref: ref
    }, other)), !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/(0, _jsxRuntime$n.jsx)(_NoSsr.default, {
      children: /*#__PURE__*/(0, _jsxRuntime$n.jsx)(_SwipeArea.default, (0, _extends2$k.default)({
        anchor: anchor,
        ref: swipeAreaRef,
        width: swipeAreaWidth
      }, SwipeAreaProps))
    })]
  });
});
process.env.NODE_ENV !== "production" ? SwipeableDrawer.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If set to true, the swipe event will open the drawer even if the user begins the swipe on one of the drawer's children.
   * This can be useful in scenarios where the drawer is partially visible.
   * You can customize it further with a callback that determines which children the user can drag over to open the drawer
   * (for example, to ignore other elements that handle touch move events, like sliders).
   *
   * @param {TouchEvent} event The 'touchstart' event
   * @param {HTMLDivElement} swipeArea The swipe area element
   * @param {HTMLDivElement} paper The drawer's paper element
   *
   * @default false
   */
  allowSwipeInChildren: _propTypes$J.default.oneOfType([_propTypes$J.default.func, _propTypes$J.default.bool]),
  /**
   * @ignore
   */
  anchor: _propTypes$J.default.oneOf(['bottom', 'left', 'right', 'top']),
  /**
   * The content of the component.
   */
  children: _propTypes$J.default.node,
  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   * @default false
   */
  disableBackdropTransition: _propTypes$J.default.bool,
  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   * @default false
   */
  disableDiscovery: _propTypes$J.default.bool,
  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   * @default typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)
   */
  disableSwipeToOpen: _propTypes$J.default.bool,
  /**
   * @ignore
   */
  hideBackdrop: _propTypes$J.default.bool,
  /**
   * Affects how far the drawer must be opened/closed to change its state.
   * Specified as percent (0-1) of the width of the drawer
   * @default 0.52
   */
  hysteresis: _propTypes$J.default.number,
  /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   * @default 450
   */
  minFlingVelocity: _propTypes$J.default.number,
  /**
   * @ignore
   */
  ModalProps: _propTypes$J.default /* @typescript-to-proptypes-ignore */.shape({
    BackdropProps: _propTypes$J.default.shape({
      component: _elementTypeAcceptingRef.default
    })
  }),
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */
  onClose: _propTypes$J.default.func.isRequired,
  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {React.SyntheticEvent<{}>} event The event source of the callback.
   */
  onOpen: _propTypes$J.default.func.isRequired,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: _propTypes$J.default.bool,
  /**
   * @ignore
   */
  PaperProps: _propTypes$J.default /* @typescript-to-proptypes-ignore */.shape({
    component: _elementTypeAcceptingRef.default,
    style: _propTypes$J.default.object
  }),
  /**
   * The element is used to intercept the touch events on the edge.
   */
  SwipeAreaProps: _propTypes$J.default.object,
  /**
   * The width of the left most (or right most) area in `px` that
   * the drawer can be swiped open from.
   * @default 20
   */
  swipeAreaWidth: _propTypes$J.default.number,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: _propTypes$J.default.oneOfType([_propTypes$J.default.number, _propTypes$J.default.shape({
    appear: _propTypes$J.default.number,
    enter: _propTypes$J.default.number,
    exit: _propTypes$J.default.number
  })]),
  /**
   * @ignore
   */
  variant: _propTypes$J.default.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
SwipeableDrawer$1.default = SwipeableDrawer;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SwipeableDrawer.default;
  }
});
var _SwipeableDrawer = _interopRequireDefault(SwipeableDrawer$1);
}(SwipeableDrawer$2));

var Switch$3 = {};

var Switch$2 = {};

var switchClasses$1 = {};

var _interopRequireDefault$41 = interopRequireDefault$1.exports;
Object.defineProperty(switchClasses$1, "__esModule", {
  value: true
});
switchClasses$1.default = void 0;
switchClasses$1.getSwitchUtilityClass = getSwitchUtilityClass;
var _generateUtilityClasses$g = _interopRequireDefault$41(generateUtilityClasses$3);
var _generateUtilityClass$g = _interopRequireDefault$41(generateUtilityClass$3);
function getSwitchUtilityClass(slot) {
  return (0, _generateUtilityClass$g.default)('MuiSwitch', slot);
}
const switchClasses = (0, _generateUtilityClasses$g.default)('MuiSwitch', ['root', 'edgeStart', 'edgeEnd', 'switchBase', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium', 'checked', 'disabled', 'input', 'thumb', 'track']);
switchClasses$1.default = switchClasses;

// @inheritedComponent IconButton
var _interopRequireDefault$40 = interopRequireDefault$1.exports;
Object.defineProperty(Switch$2, "__esModule", {
  value: true
});
Switch$2.default = void 0;
var _objectWithoutPropertiesLoose2$j = _interopRequireDefault$40(objectWithoutPropertiesLoose.exports);
var _extends2$j = _interopRequireDefault$40(_extends$19.exports);
var React$z = _interopRequireWildcard$1s(React__default$4);
var _propTypes$I = _interopRequireDefault$40(propTypes.exports);
var _clsx$R = _interopRequireDefault$40(clsx.exports);
var _refType$2 = _interopRequireDefault$40(refType$2);
var _composeClasses$g = _interopRequireDefault$40(composeClasses$2);
var _colorManipulator$2 = colorManipulator;
var _capitalize$5 = _interopRequireDefault$40(capitalize$1);
var _SwitchBase = _interopRequireDefault$40(SwitchBase$1);
var _zeroStyled = zeroStyled;
var _DefaultPropsProvider$g = DefaultPropsProvider$5;
var _switchClasses = _interopRequireWildcard$1s(switchClasses$1);
var _jsxRuntime$m = require$$11;
const _excluded$N = ["className", "color", "edge", "size", "sx"];
function _getRequireWildcardCache$1b(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1b = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1s(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1b(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$g = ownerState => {
  const {
    classes,
    edge,
    size,
    color,
    checked,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', edge && `edge${(0, _capitalize$5.default)(edge)}`, `size${(0, _capitalize$5.default)(size)}`],
    switchBase: ['switchBase', `color${(0, _capitalize$5.default)(color)}`, checked && 'checked', disabled && 'disabled'],
    thumb: ['thumb'],
    track: ['track'],
    input: ['input']
  };
  const composedClasses = (0, _composeClasses$g.default)(slots, _switchClasses.getSwitchUtilityClass, classes);
  return (0, _extends2$j.default)({}, classes, composedClasses);
};
const SwitchRoot = (0, _zeroStyled.styled)('span', {
  name: 'MuiSwitch',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.edge && styles[`edge${(0, _capitalize$5.default)(ownerState.edge)}`], styles[`size${(0, _capitalize$5.default)(ownerState.size)}`]];
  }
})({
  display: 'inline-flex',
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: 'hidden',
  padding: 12,
  boxSizing: 'border-box',
  position: 'relative',
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: 'middle',
  // For correct alignment with the text.
  '@media print': {
    colorAdjust: 'exact'
  },
  variants: [{
    props: {
      edge: 'start'
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: 'end'
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: 'small'
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${_switchClasses.default.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${_switchClasses.default.switchBase}`]: {
        padding: 4,
        [`&.${_switchClasses.default.checked}`]: {
          transform: 'translateX(16px)'
        }
      }
    }
  }]
});
const SwitchSwitchBase = (0, _zeroStyled.styled)(_SwitchBase.default, {
  name: 'MuiSwitch',
  slot: 'SwitchBase',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.switchBase, {
      [`& .${_switchClasses.default.input}`]: styles.input
    }, ownerState.color !== 'default' && styles[`color${(0, _capitalize$5.default)(ownerState.color)}`]];
  }
})(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
  transition: theme.transitions.create(['left', 'transform'], {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${_switchClasses.default.checked}`]: {
    transform: 'translateX(20px)'
  },
  [`&.${_switchClasses.default.disabled}`]: {
    color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
  },
  [`&.${_switchClasses.default.checked} + .${_switchClasses.default.track}`]: {
    opacity: 0.5
  },
  [`&.${_switchClasses.default.disabled} + .${_switchClasses.default.track}`]: {
    opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
  },
  [`& .${_switchClasses.default.input}`]: {
    left: '-100%',
    width: '300%'
  }
}), ({
  theme
}) => ({
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$2.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  variants: [...Object.entries(theme.palette).filter(([, value]) => value.main && value.light) // check all the used fields in the style below
  .map(([color]) => ({
    props: {
      color
    },
    style: {
      [`&.${_switchClasses.default.checked}`]: {
        color: (theme.vars || theme).palette[color].main,
        '&:hover': {
          backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator$2.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        [`&.${_switchClasses.default.disabled}`]: {
          color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, _colorManipulator$2.lighten)(theme.palette[color].main, 0.62) : (0, _colorManipulator$2.darken)(theme.palette[color].main, 0.55)}`
        }
      },
      [`&.${_switchClasses.default.checked} + .${_switchClasses.default.track}`]: {
        backgroundColor: (theme.vars || theme).palette[color].main
      }
    }
  }))]
}));
const SwitchTrack = (0, _zeroStyled.styled)('span', {
  name: 'MuiSwitch',
  slot: 'Track',
  overridesResolver: (props, styles) => styles.track
})(({
  theme
}) => ({
  height: '100%',
  width: '100%',
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: theme.transitions.create(['opacity', 'background-color'], {
    duration: theme.transitions.duration.shortest
  }),
  backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
  opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
}));
const SwitchThumb = (0, _zeroStyled.styled)('span', {
  name: 'MuiSwitch',
  slot: 'Thumb',
  overridesResolver: (props, styles) => styles.thumb
})(({
  theme
}) => ({
  boxShadow: (theme.vars || theme).shadows[1],
  backgroundColor: 'currentColor',
  width: 20,
  height: 20,
  borderRadius: '50%'
}));
const Switch$1 = /*#__PURE__*/React$z.forwardRef(function Switch(inProps, ref) {
  const props = (0, _DefaultPropsProvider$g.useDefaultProps)({
    props: inProps,
    name: 'MuiSwitch'
  });
  const {
      className,
      color = 'primary',
      edge = false,
      size = 'medium',
      sx
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$j.default)(props, _excluded$N);
  const ownerState = (0, _extends2$j.default)({}, props, {
    color,
    edge,
    size
  });
  const classes = useUtilityClasses$g(ownerState);
  const icon = /*#__PURE__*/(0, _jsxRuntime$m.jsx)(SwitchThumb, {
    className: classes.thumb,
    ownerState: ownerState
  });
  return /*#__PURE__*/(0, _jsxRuntime$m.jsxs)(SwitchRoot, {
    className: (0, _clsx$R.default)(classes.root, className),
    sx: sx,
    ownerState: ownerState,
    children: [/*#__PURE__*/(0, _jsxRuntime$m.jsx)(SwitchSwitchBase, (0, _extends2$j.default)({
      type: "checkbox",
      icon: icon,
      checkedIcon: icon,
      ref: ref,
      ownerState: ownerState
    }, other, {
      classes: (0, _extends2$j.default)({}, classes, {
        root: classes.switchBase
      })
    })), /*#__PURE__*/(0, _jsxRuntime$m.jsx)(SwitchTrack, {
      className: classes.track,
      ownerState: ownerState
    })]
  });
});
process.env.NODE_ENV !== "production" ? Switch$1.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: _propTypes$I.default.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: _propTypes$I.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$I.default.object,
  /**
   * @ignore
   */
  className: _propTypes$I.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$I.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$I.default.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$I.default.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: _propTypes$I.default.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: _propTypes$I.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: _propTypes$I.default.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: _propTypes$I.default.oneOf(['end', 'start', false]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: _propTypes$I.default.node,
  /**
   * The id of the `input` element.
   */
  id: _propTypes$I.default.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _propTypes$I.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType$2.default,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: _propTypes$I.default.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: _propTypes$I.default.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: _propTypes$I.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$I.default.oneOf(['medium', 'small']), _propTypes$I.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$I.default.oneOfType([_propTypes$I.default.arrayOf(_propTypes$I.default.oneOfType([_propTypes$I.default.func, _propTypes$I.default.object, _propTypes$I.default.bool])), _propTypes$I.default.func, _propTypes$I.default.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: _propTypes$I.default.any
} : void 0;
Switch$2.default = Switch$1;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  switchClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Switch.default;
  }
});
Object.defineProperty(exports, "switchClasses", {
  enumerable: true,
  get: function () {
    return _switchClasses.default;
  }
});
var _Switch = _interopRequireDefault(Switch$2);
var _switchClasses = _interopRequireWildcard(switchClasses$1);
Object.keys(_switchClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _switchClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _switchClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Switch$3));

var Tab$2 = {};

var Tab$1 = {};

var tabClasses$1 = {};

var _interopRequireDefault$3$ = interopRequireDefault$1.exports;
Object.defineProperty(tabClasses$1, "__esModule", {
  value: true
});
tabClasses$1.default = void 0;
tabClasses$1.getTabUtilityClass = getTabUtilityClass;
var _generateUtilityClasses$f = _interopRequireDefault$3$(generateUtilityClasses$3);
var _generateUtilityClass$f = _interopRequireDefault$3$(generateUtilityClass$3);
function getTabUtilityClass(slot) {
  return (0, _generateUtilityClass$f.default)('MuiTab', slot);
}
const tabClasses = (0, _generateUtilityClasses$f.default)('MuiTab', ['root', 'labelIcon', 'textColorInherit', 'textColorPrimary', 'textColorSecondary', 'selected', 'disabled', 'fullWidth', 'wrapped', 'iconWrapper']);
tabClasses$1.default = tabClasses;

var _interopRequireDefault$3_ = interopRequireDefault$1.exports;
Object.defineProperty(Tab$1, "__esModule", {
  value: true
});
Tab$1.default = void 0;
var _objectWithoutPropertiesLoose2$i = _interopRequireDefault$3_(objectWithoutPropertiesLoose.exports);
var _extends2$i = _interopRequireDefault$3_(_extends$19.exports);
var React$y = _interopRequireWildcard$1r(React__default$4);
var _propTypes$H = _interopRequireDefault$3_(propTypes.exports);
var _clsx$Q = _interopRequireDefault$3_(clsx.exports);
var _composeClasses$f = _interopRequireDefault$3_(composeClasses$2);
var _ButtonBase$3 = _interopRequireDefault$3_(ButtonBase$2);
var _capitalize$4 = _interopRequireDefault$3_(capitalize$1);
var _DefaultPropsProvider$f = DefaultPropsProvider$5;
var _styled$f = _interopRequireDefault$3_(styled$2);
var _unsupportedProp = _interopRequireDefault$3_(unsupportedProp);
var _tabClasses = _interopRequireWildcard$1r(tabClasses$1);
var _jsxRuntime$l = require$$11;
const _excluded$M = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"];
function _getRequireWildcardCache$1a(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1a = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1r(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$1a(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$f = ownerState => {
  const {
    classes,
    textColor,
    fullWidth,
    wrapped,
    icon,
    label,
    selected,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', icon && label && 'labelIcon', `textColor${(0, _capitalize$4.default)(textColor)}`, fullWidth && 'fullWidth', wrapped && 'wrapped', selected && 'selected', disabled && 'disabled'],
    iconWrapper: ['iconWrapper']
  };
  return (0, _composeClasses$f.default)(slots, _tabClasses.getTabUtilityClass, classes);
};
const TabRoot = (0, _styled$f.default)(_ButtonBase$3.default, {
  name: 'MuiTab',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.label && ownerState.icon && styles.labelIcon, styles[`textColor${(0, _capitalize$4.default)(ownerState.textColor)}`], ownerState.fullWidth && styles.fullWidth, ownerState.wrapped && styles.wrapped, {
      [`& .${_tabClasses.default.iconWrapper}`]: styles.iconWrapper
    }];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$i.default)({}, theme.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: 'relative',
  minHeight: 48,
  flexShrink: 0,
  padding: '12px 16px',
  overflow: 'hidden',
  whiteSpace: 'normal',
  textAlign: 'center'
}, ownerState.label && {
  flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
}, {
  lineHeight: 1.25
}, ownerState.icon && ownerState.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${_tabClasses.default.iconWrapper}`]: (0, _extends2$i.default)({}, ownerState.iconPosition === 'top' && {
    marginBottom: 6
  }, ownerState.iconPosition === 'bottom' && {
    marginTop: 6
  }, ownerState.iconPosition === 'start' && {
    marginRight: theme.spacing(1)
  }, ownerState.iconPosition === 'end' && {
    marginLeft: theme.spacing(1)
  })
}, ownerState.textColor === 'inherit' && {
  color: 'inherit',
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${_tabClasses.default.selected}`]: {
    opacity: 1
  },
  [`&.${_tabClasses.default.disabled}`]: {
    opacity: (theme.vars || theme).palette.action.disabledOpacity
  }
}, ownerState.textColor === 'primary' && {
  color: (theme.vars || theme).palette.text.secondary,
  [`&.${_tabClasses.default.selected}`]: {
    color: (theme.vars || theme).palette.primary.main
  },
  [`&.${_tabClasses.default.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  }
}, ownerState.textColor === 'secondary' && {
  color: (theme.vars || theme).palette.text.secondary,
  [`&.${_tabClasses.default.selected}`]: {
    color: (theme.vars || theme).palette.secondary.main
  },
  [`&.${_tabClasses.default.disabled}`]: {
    color: (theme.vars || theme).palette.text.disabled
  }
}, ownerState.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: 'none'
}, ownerState.wrapped && {
  fontSize: theme.typography.pxToRem(12)
}));
const Tab = /*#__PURE__*/React$y.forwardRef(function Tab(inProps, ref) {
  const props = (0, _DefaultPropsProvider$f.useDefaultProps)({
    props: inProps,
    name: 'MuiTab'
  });
  const {
      className,
      disabled = false,
      disableFocusRipple = false,
      // eslint-disable-next-line react/prop-types
      fullWidth,
      icon: iconProp,
      iconPosition = 'top',
      // eslint-disable-next-line react/prop-types
      indicator,
      label,
      onChange,
      onClick,
      onFocus,
      // eslint-disable-next-line react/prop-types
      selected,
      // eslint-disable-next-line react/prop-types
      selectionFollowsFocus,
      // eslint-disable-next-line react/prop-types
      textColor = 'inherit',
      value,
      wrapped = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$i.default)(props, _excluded$M);
  const ownerState = (0, _extends2$i.default)({}, props, {
    disabled,
    disableFocusRipple,
    selected,
    icon: !!iconProp,
    iconPosition,
    label: !!label,
    fullWidth,
    textColor,
    wrapped
  });
  const classes = useUtilityClasses$f(ownerState);
  const icon = iconProp && label && /*#__PURE__*/React$y.isValidElement(iconProp) ? /*#__PURE__*/React$y.cloneElement(iconProp, {
    className: (0, _clsx$Q.default)(classes.iconWrapper, iconProp.props.className)
  }) : iconProp;
  const handleClick = event => {
    if (!selected && onChange) {
      onChange(event, value);
    }
    if (onClick) {
      onClick(event);
    }
  };
  const handleFocus = event => {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event, value);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime$l.jsxs)(TabRoot, (0, _extends2$i.default)({
    focusRipple: !disableFocusRipple,
    className: (0, _clsx$Q.default)(classes.root, className),
    ref: ref,
    role: "tab",
    "aria-selected": selected,
    disabled: disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    ownerState: ownerState,
    tabIndex: selected ? 0 : -1
  }, other, {
    children: [iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/(0, _jsxRuntime$l.jsxs)(React$y.Fragment, {
      children: [icon, label]
    }) : /*#__PURE__*/(0, _jsxRuntime$l.jsxs)(React$y.Fragment, {
      children: [label, icon]
    }), indicator]
  }));
});
process.env.NODE_ENV !== "production" ? Tab.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: _unsupportedProp.default,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$H.default.object,
  /**
   * @ignore
   */
  className: _propTypes$H.default.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$H.default.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: _propTypes$H.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: _propTypes$H.default.bool,
  /**
   * The icon to display.
   */
  icon: _propTypes$H.default.oneOfType([_propTypes$H.default.element, _propTypes$H.default.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: _propTypes$H.default.oneOf(['bottom', 'end', 'start', 'top']),
  /**
   * The label element.
   */
  label: _propTypes$H.default.node,
  /**
   * @ignore
   */
  onChange: _propTypes$H.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes$H.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes$H.default.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$H.default.oneOfType([_propTypes$H.default.arrayOf(_propTypes$H.default.oneOfType([_propTypes$H.default.func, _propTypes$H.default.object, _propTypes$H.default.bool])), _propTypes$H.default.func, _propTypes$H.default.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes$H.default.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: _propTypes$H.default.bool
} : void 0;
Tab$1.default = Tab;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tabClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Tab.default;
  }
});
Object.defineProperty(exports, "tabClasses", {
  enumerable: true,
  get: function () {
    return _tabClasses.default;
  }
});
var _Tab = _interopRequireDefault(Tab$1);
var _tabClasses = _interopRequireWildcard(tabClasses$1);
Object.keys(_tabClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tabClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tabClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Tab$2));

var index$e = /*@__PURE__*/getDefaultExportFromCjs$1(Tab$2);

var Table$4 = {};

var Table$3 = {};

var TableContext$1 = {};

Object.defineProperty(TableContext$1, "__esModule", {
  value: true
});
TableContext$1.default = void 0;
var React$x = _interopRequireWildcard$1q(React__default$4);
function _getRequireWildcardCache$19(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$19 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1q(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$19(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const TableContext = /*#__PURE__*/React$x.createContext();
if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}
TableContext$1.default = TableContext;

var tableClasses$1 = {};

var _interopRequireDefault$3Z = interopRequireDefault$1.exports;
Object.defineProperty(tableClasses$1, "__esModule", {
  value: true
});
tableClasses$1.default = void 0;
tableClasses$1.getTableUtilityClass = getTableUtilityClass;
var _generateUtilityClasses$e = _interopRequireDefault$3Z(generateUtilityClasses$3);
var _generateUtilityClass$e = _interopRequireDefault$3Z(generateUtilityClass$3);
function getTableUtilityClass(slot) {
  return (0, _generateUtilityClass$e.default)('MuiTable', slot);
}
const tableClasses = (0, _generateUtilityClasses$e.default)('MuiTable', ['root', 'stickyHeader']);
tableClasses$1.default = tableClasses;

var _interopRequireDefault$3Y = interopRequireDefault$1.exports;
Object.defineProperty(Table$3, "__esModule", {
  value: true
});
Table$3.default = void 0;
var _objectWithoutPropertiesLoose2$h = _interopRequireDefault$3Y(objectWithoutPropertiesLoose.exports);
var _extends2$h = _interopRequireDefault$3Y(_extends$19.exports);
var React$w = _interopRequireWildcard$1p(React__default$4);
var _propTypes$G = _interopRequireDefault$3Y(propTypes.exports);
var _clsx$P = _interopRequireDefault$3Y(clsx.exports);
var _composeClasses$e = _interopRequireDefault$3Y(composeClasses$2);
var _TableContext$1 = _interopRequireDefault$3Y(TableContext$1);
var _DefaultPropsProvider$e = DefaultPropsProvider$5;
var _styled$e = _interopRequireDefault$3Y(styled$2);
var _tableClasses = tableClasses$1;
var _jsxRuntime$k = require$$11;
const _excluded$L = ["className", "component", "padding", "size", "stickyHeader"];
function _getRequireWildcardCache$18(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$18 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1p(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$18(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$e = ownerState => {
  const {
    classes,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', stickyHeader && 'stickyHeader']
  };
  return (0, _composeClasses$e.default)(slots, _tableClasses.getTableUtilityClass, classes);
};
const TableRoot = (0, _styled$e.default)('table', {
  name: 'MuiTable',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$h.default)({
  display: 'table',
  width: '100%',
  borderCollapse: 'collapse',
  borderSpacing: 0,
  '& caption': (0, _extends2$h.default)({}, theme.typography.body2, {
    padding: theme.spacing(2),
    color: (theme.vars || theme).palette.text.secondary,
    textAlign: 'left',
    captionSide: 'bottom'
  })
}, ownerState.stickyHeader && {
  borderCollapse: 'separate'
}));
const defaultComponent$4 = 'table';
const Table$2 = /*#__PURE__*/React$w.forwardRef(function Table(inProps, ref) {
  const props = (0, _DefaultPropsProvider$e.useDefaultProps)({
    props: inProps,
    name: 'MuiTable'
  });
  const {
      className,
      component = defaultComponent$4,
      padding = 'normal',
      size = 'medium',
      stickyHeader = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$h.default)(props, _excluded$L);
  const ownerState = (0, _extends2$h.default)({}, props, {
    component,
    padding,
    size,
    stickyHeader
  });
  const classes = useUtilityClasses$e(ownerState);
  const table = React$w.useMemo(() => ({
    padding,
    size,
    stickyHeader
  }), [padding, size, stickyHeader]);
  return /*#__PURE__*/(0, _jsxRuntime$k.jsx)(_TableContext$1.default.Provider, {
    value: table,
    children: /*#__PURE__*/(0, _jsxRuntime$k.jsx)(TableRoot, (0, _extends2$h.default)({
      as: component,
      role: component === defaultComponent$4 ? null : 'table',
      ref: ref,
      className: (0, _clsx$P.default)(classes.root, className),
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? Table$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: _propTypes$G.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$G.default.object,
  /**
   * @ignore
   */
  className: _propTypes$G.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$G.default.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: _propTypes$G.default.oneOf(['checkbox', 'none', 'normal']),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: _propTypes$G.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$G.default.oneOf(['medium', 'small']), _propTypes$G.default.string]),
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: _propTypes$G.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$G.default.oneOfType([_propTypes$G.default.arrayOf(_propTypes$G.default.oneOfType([_propTypes$G.default.func, _propTypes$G.default.object, _propTypes$G.default.bool])), _propTypes$G.default.func, _propTypes$G.default.object])
} : void 0;
Table$3.default = Table$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tableClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Table.default;
  }
});
Object.defineProperty(exports, "tableClasses", {
  enumerable: true,
  get: function () {
    return _tableClasses.default;
  }
});
var _Table = _interopRequireDefault(Table$3);
var _tableClasses = _interopRequireWildcard(tableClasses$1);
Object.keys(_tableClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tableClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tableClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Table$4));

var Table$1 = /*@__PURE__*/getDefaultExportFromCjs$1(Table$4);

var TableBody$4 = {};

var TableBody$3 = {};

var Tablelvl2Context$1 = {};

Object.defineProperty(Tablelvl2Context$1, "__esModule", {
  value: true
});
Tablelvl2Context$1.default = void 0;
var React$v = _interopRequireWildcard$1o(React__default$4);
function _getRequireWildcardCache$17(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$17 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1o(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$17(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const Tablelvl2Context = /*#__PURE__*/React$v.createContext();
if (process.env.NODE_ENV !== 'production') {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}
Tablelvl2Context$1.default = Tablelvl2Context;

var tableBodyClasses$1 = {};

var _interopRequireDefault$3X = interopRequireDefault$1.exports;
Object.defineProperty(tableBodyClasses$1, "__esModule", {
  value: true
});
tableBodyClasses$1.default = void 0;
tableBodyClasses$1.getTableBodyUtilityClass = getTableBodyUtilityClass;
var _generateUtilityClasses$d = _interopRequireDefault$3X(generateUtilityClasses$3);
var _generateUtilityClass$d = _interopRequireDefault$3X(generateUtilityClass$3);
function getTableBodyUtilityClass(slot) {
  return (0, _generateUtilityClass$d.default)('MuiTableBody', slot);
}
const tableBodyClasses = (0, _generateUtilityClasses$d.default)('MuiTableBody', ['root']);
tableBodyClasses$1.default = tableBodyClasses;

var _interopRequireDefault$3W = interopRequireDefault$1.exports;
Object.defineProperty(TableBody$3, "__esModule", {
  value: true
});
TableBody$3.default = void 0;
var _extends2$g = _interopRequireDefault$3W(_extends$19.exports);
var _objectWithoutPropertiesLoose2$g = _interopRequireDefault$3W(objectWithoutPropertiesLoose.exports);
var React$u = _interopRequireWildcard$1n(React__default$4);
var _propTypes$F = _interopRequireDefault$3W(propTypes.exports);
var _clsx$O = _interopRequireDefault$3W(clsx.exports);
var _composeClasses$d = _interopRequireDefault$3W(composeClasses$2);
var _Tablelvl2Context$4 = _interopRequireDefault$3W(Tablelvl2Context$1);
var _DefaultPropsProvider$d = DefaultPropsProvider$5;
var _styled$d = _interopRequireDefault$3W(styled$2);
var _tableBodyClasses = tableBodyClasses$1;
var _jsxRuntime$j = require$$11;
const _excluded$K = ["className", "component"];
function _getRequireWildcardCache$16(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$16 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1n(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$16(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$d = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$d.default)(slots, _tableBodyClasses.getTableBodyUtilityClass, classes);
};
const TableBodyRoot = (0, _styled$d.default)('tbody', {
  name: 'MuiTableBody',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-row-group'
});
const tablelvl2$2 = {
  variant: 'body'
};
const defaultComponent$3 = 'tbody';
const TableBody$2 = /*#__PURE__*/React$u.forwardRef(function TableBody(inProps, ref) {
  const props = (0, _DefaultPropsProvider$d.useDefaultProps)({
    props: inProps,
    name: 'MuiTableBody'
  });
  const {
      className,
      component = defaultComponent$3
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$g.default)(props, _excluded$K);
  const ownerState = (0, _extends2$g.default)({}, props, {
    component
  });
  const classes = useUtilityClasses$d(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$j.jsx)(_Tablelvl2Context$4.default.Provider, {
    value: tablelvl2$2,
    children: /*#__PURE__*/(0, _jsxRuntime$j.jsx)(TableBodyRoot, (0, _extends2$g.default)({
      className: (0, _clsx$O.default)(classes.root, className),
      as: component,
      ref: ref,
      role: component === defaultComponent$3 ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? TableBody$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes$F.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$F.default.object,
  /**
   * @ignore
   */
  className: _propTypes$F.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$F.default.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$F.default.oneOfType([_propTypes$F.default.arrayOf(_propTypes$F.default.oneOfType([_propTypes$F.default.func, _propTypes$F.default.object, _propTypes$F.default.bool])), _propTypes$F.default.func, _propTypes$F.default.object])
} : void 0;
TableBody$3.default = TableBody$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tableBodyClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TableBody.default;
  }
});
Object.defineProperty(exports, "tableBodyClasses", {
  enumerable: true,
  get: function () {
    return _tableBodyClasses.default;
  }
});
var _TableBody = _interopRequireDefault(TableBody$3);
var _tableBodyClasses = _interopRequireWildcard(tableBodyClasses$1);
Object.keys(_tableBodyClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tableBodyClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tableBodyClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TableBody$4));

var TableBody$1 = /*@__PURE__*/getDefaultExportFromCjs$1(TableBody$4);

var TableCell$4 = {};

var TableCell$3 = {};

var tableCellClasses$1 = {};

var _interopRequireDefault$3V = interopRequireDefault$1.exports;
Object.defineProperty(tableCellClasses$1, "__esModule", {
  value: true
});
tableCellClasses$1.default = void 0;
tableCellClasses$1.getTableCellUtilityClass = getTableCellUtilityClass;
var _generateUtilityClasses$c = _interopRequireDefault$3V(generateUtilityClasses$3);
var _generateUtilityClass$c = _interopRequireDefault$3V(generateUtilityClass$3);
function getTableCellUtilityClass(slot) {
  return (0, _generateUtilityClass$c.default)('MuiTableCell', slot);
}
const tableCellClasses = (0, _generateUtilityClasses$c.default)('MuiTableCell', ['root', 'head', 'body', 'footer', 'sizeSmall', 'sizeMedium', 'paddingCheckbox', 'paddingNone', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'stickyHeader']);
tableCellClasses$1.default = tableCellClasses;

var _interopRequireDefault$3U = interopRequireDefault$1.exports;
Object.defineProperty(TableCell$3, "__esModule", {
  value: true
});
TableCell$3.default = void 0;
var _objectWithoutPropertiesLoose2$f = _interopRequireDefault$3U(objectWithoutPropertiesLoose.exports);
var _extends2$f = _interopRequireDefault$3U(_extends$19.exports);
var React$t = _interopRequireWildcard$1m(React__default$4);
var _propTypes$E = _interopRequireDefault$3U(propTypes.exports);
var _clsx$N = _interopRequireDefault$3U(clsx.exports);
var _composeClasses$c = _interopRequireDefault$3U(composeClasses$2);
var _colorManipulator$1 = colorManipulator;
var _capitalize$3 = _interopRequireDefault$3U(capitalize$1);
var _TableContext = _interopRequireDefault$3U(TableContext$1);
var _Tablelvl2Context$3 = _interopRequireDefault$3U(Tablelvl2Context$1);
var _DefaultPropsProvider$c = DefaultPropsProvider$5;
var _styled$c = _interopRequireDefault$3U(styled$2);
var _tableCellClasses = _interopRequireWildcard$1m(tableCellClasses$1);
var _jsxRuntime$i = require$$11;
const _excluded$J = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"];
function _getRequireWildcardCache$15(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$15 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1m(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$15(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$c = ownerState => {
  const {
    classes,
    variant,
    align,
    padding,
    size,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', variant, stickyHeader && 'stickyHeader', align !== 'inherit' && `align${(0, _capitalize$3.default)(align)}`, padding !== 'normal' && `padding${(0, _capitalize$3.default)(padding)}`, `size${(0, _capitalize$3.default)(size)}`]
  };
  return (0, _composeClasses$c.default)(slots, _tableCellClasses.getTableCellUtilityClass, classes);
};
const TableCellRoot = (0, _styled$c.default)('td', {
  name: 'MuiTableCell',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`size${(0, _capitalize$3.default)(ownerState.size)}`], ownerState.padding !== 'normal' && styles[`padding${(0, _capitalize$3.default)(ownerState.padding)}`], ownerState.align !== 'inherit' && styles[`align${(0, _capitalize$3.default)(ownerState.align)}`], ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$f.default)({}, theme.typography.body2, {
  display: 'table-cell',
  verticalAlign: 'inherit',
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, _colorManipulator$1.lighten)((0, _colorManipulator$1.alpha)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator$1.darken)((0, _colorManipulator$1.alpha)(theme.palette.divider, 1), 0.68)}`,
  textAlign: 'left',
  padding: 16
}, ownerState.variant === 'head' && {
  color: (theme.vars || theme).palette.text.primary,
  lineHeight: theme.typography.pxToRem(24),
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.variant === 'body' && {
  color: (theme.vars || theme).palette.text.primary
}, ownerState.variant === 'footer' && {
  color: (theme.vars || theme).palette.text.secondary,
  lineHeight: theme.typography.pxToRem(21),
  fontSize: theme.typography.pxToRem(12)
}, ownerState.size === 'small' && {
  padding: '6px 16px',
  [`&.${_tableCellClasses.default.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: '0 12px 0 16px',
    '& > *': {
      padding: 0
    }
  }
}, ownerState.padding === 'checkbox' && {
  width: 48,
  // prevent the checkbox column from growing
  padding: '0 0 0 4px'
}, ownerState.padding === 'none' && {
  padding: 0
}, ownerState.align === 'left' && {
  textAlign: 'left'
}, ownerState.align === 'center' && {
  textAlign: 'center'
}, ownerState.align === 'right' && {
  textAlign: 'right',
  flexDirection: 'row-reverse'
}, ownerState.align === 'justify' && {
  textAlign: 'justify'
}, ownerState.stickyHeader && {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: (theme.vars || theme).palette.background.default
}));

/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */
const TableCell$2 = /*#__PURE__*/React$t.forwardRef(function TableCell(inProps, ref) {
  const props = (0, _DefaultPropsProvider$c.useDefaultProps)({
    props: inProps,
    name: 'MuiTableCell'
  });
  const {
      align = 'inherit',
      className,
      component: componentProp,
      padding: paddingProp,
      scope: scopeProp,
      size: sizeProp,
      sortDirection,
      variant: variantProp
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$f.default)(props, _excluded$J);
  const table = React$t.useContext(_TableContext.default);
  const tablelvl2 = React$t.useContext(_Tablelvl2Context$3.default);
  const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  let component;
  if (componentProp) {
    component = componentProp;
  } else {
    component = isHeadCell ? 'th' : 'td';
  }
  let scope = scopeProp;
  // scope is not a valid attribute for <td/> elements.
  // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
  if (component === 'td') {
    scope = undefined;
  } else if (!scope && isHeadCell) {
    scope = 'col';
  }
  const variant = variantProp || tablelvl2 && tablelvl2.variant;
  const ownerState = (0, _extends2$f.default)({}, props, {
    align,
    component,
    padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
    size: sizeProp || (table && table.size ? table.size : 'medium'),
    sortDirection,
    stickyHeader: variant === 'head' && table && table.stickyHeader,
    variant
  });
  const classes = useUtilityClasses$c(ownerState);
  let ariaSort = null;
  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }
  return /*#__PURE__*/(0, _jsxRuntime$i.jsx)(TableCellRoot, (0, _extends2$f.default)({
    as: component,
    ref: ref,
    className: (0, _clsx$N.default)(classes.root, className),
    "aria-sort": ariaSort,
    scope: scope,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? TableCell$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: _propTypes$E.default.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  /**
   * The content of the component.
   */
  children: _propTypes$E.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$E.default.object,
  /**
   * @ignore
   */
  className: _propTypes$E.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$E.default.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: _propTypes$E.default.oneOf(['checkbox', 'none', 'normal']),
  /**
   * Set scope attribute.
   */
  scope: _propTypes$E.default.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: _propTypes$E.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$E.default.oneOf(['medium', 'small']), _propTypes$E.default.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: _propTypes$E.default.oneOf(['asc', 'desc', false]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$E.default.oneOfType([_propTypes$E.default.arrayOf(_propTypes$E.default.oneOfType([_propTypes$E.default.func, _propTypes$E.default.object, _propTypes$E.default.bool])), _propTypes$E.default.func, _propTypes$E.default.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: _propTypes$E.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$E.default.oneOf(['body', 'footer', 'head']), _propTypes$E.default.string])
} : void 0;
TableCell$3.default = TableCell$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tableCellClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TableCell.default;
  }
});
Object.defineProperty(exports, "tableCellClasses", {
  enumerable: true,
  get: function () {
    return _tableCellClasses.default;
  }
});
var _TableCell = _interopRequireDefault(TableCell$3);
var _tableCellClasses = _interopRequireWildcard(tableCellClasses$1);
Object.keys(_tableCellClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tableCellClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tableCellClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TableCell$4));

var TableCell$1 = /*@__PURE__*/getDefaultExportFromCjs$1(TableCell$4);

var TableContainer$4 = {};

var TableContainer$3 = {};

var tableContainerClasses$1 = {};

var _interopRequireDefault$3T = interopRequireDefault$1.exports;
Object.defineProperty(tableContainerClasses$1, "__esModule", {
  value: true
});
tableContainerClasses$1.default = void 0;
tableContainerClasses$1.getTableContainerUtilityClass = getTableContainerUtilityClass;
var _generateUtilityClasses$b = _interopRequireDefault$3T(generateUtilityClasses$3);
var _generateUtilityClass$b = _interopRequireDefault$3T(generateUtilityClass$3);
function getTableContainerUtilityClass(slot) {
  return (0, _generateUtilityClass$b.default)('MuiTableContainer', slot);
}
const tableContainerClasses = (0, _generateUtilityClasses$b.default)('MuiTableContainer', ['root']);
tableContainerClasses$1.default = tableContainerClasses;

var _interopRequireDefault$3S = interopRequireDefault$1.exports;
Object.defineProperty(TableContainer$3, "__esModule", {
  value: true
});
TableContainer$3.default = void 0;
var _extends2$e = _interopRequireDefault$3S(_extends$19.exports);
var _objectWithoutPropertiesLoose2$e = _interopRequireDefault$3S(objectWithoutPropertiesLoose.exports);
var React$s = _interopRequireWildcard$1l(React__default$4);
var _propTypes$D = _interopRequireDefault$3S(propTypes.exports);
var _clsx$M = _interopRequireDefault$3S(clsx.exports);
var _composeClasses$b = _interopRequireDefault$3S(composeClasses$2);
var _DefaultPropsProvider$b = DefaultPropsProvider$5;
var _styled$b = _interopRequireDefault$3S(styled$2);
var _tableContainerClasses = tableContainerClasses$1;
var _jsxRuntime$h = require$$11;
const _excluded$I = ["className", "component"];
function _getRequireWildcardCache$14(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$14 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1l(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$14(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$b = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$b.default)(slots, _tableContainerClasses.getTableContainerUtilityClass, classes);
};
const TableContainerRoot = (0, _styled$b.default)('div', {
  name: 'MuiTableContainer',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  width: '100%',
  overflowX: 'auto'
});
const TableContainer$2 = /*#__PURE__*/React$s.forwardRef(function TableContainer(inProps, ref) {
  const props = (0, _DefaultPropsProvider$b.useDefaultProps)({
    props: inProps,
    name: 'MuiTableContainer'
  });
  const {
      className,
      component = 'div'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$e.default)(props, _excluded$I);
  const ownerState = (0, _extends2$e.default)({}, props, {
    component
  });
  const classes = useUtilityClasses$b(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$h.jsx)(TableContainerRoot, (0, _extends2$e.default)({
    ref: ref,
    as: component,
    className: (0, _clsx$M.default)(classes.root, className),
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? TableContainer$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Table`.
   */
  children: _propTypes$D.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$D.default.object,
  /**
   * @ignore
   */
  className: _propTypes$D.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$D.default.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$D.default.oneOfType([_propTypes$D.default.arrayOf(_propTypes$D.default.oneOfType([_propTypes$D.default.func, _propTypes$D.default.object, _propTypes$D.default.bool])), _propTypes$D.default.func, _propTypes$D.default.object])
} : void 0;
TableContainer$3.default = TableContainer$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tableContainerClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TableContainer.default;
  }
});
Object.defineProperty(exports, "tableContainerClasses", {
  enumerable: true,
  get: function () {
    return _tableContainerClasses.default;
  }
});
var _TableContainer = _interopRequireDefault(TableContainer$3);
var _tableContainerClasses = _interopRequireWildcard(tableContainerClasses$1);
Object.keys(_tableContainerClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tableContainerClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tableContainerClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TableContainer$4));

var TableContainer$1 = /*@__PURE__*/getDefaultExportFromCjs$1(TableContainer$4);

var TableFooter$2 = {};

var TableFooter$1 = {};

var tableFooterClasses$1 = {};

var _interopRequireDefault$3R = interopRequireDefault$1.exports;
Object.defineProperty(tableFooterClasses$1, "__esModule", {
  value: true
});
tableFooterClasses$1.default = void 0;
tableFooterClasses$1.getTableFooterUtilityClass = getTableFooterUtilityClass;
var _generateUtilityClasses$a = _interopRequireDefault$3R(generateUtilityClasses$3);
var _generateUtilityClass$a = _interopRequireDefault$3R(generateUtilityClass$3);
function getTableFooterUtilityClass(slot) {
  return (0, _generateUtilityClass$a.default)('MuiTableFooter', slot);
}
const tableFooterClasses = (0, _generateUtilityClasses$a.default)('MuiTableFooter', ['root']);
tableFooterClasses$1.default = tableFooterClasses;

var _interopRequireDefault$3Q = interopRequireDefault$1.exports;
Object.defineProperty(TableFooter$1, "__esModule", {
  value: true
});
TableFooter$1.default = void 0;
var _extends2$d = _interopRequireDefault$3Q(_extends$19.exports);
var _objectWithoutPropertiesLoose2$d = _interopRequireDefault$3Q(objectWithoutPropertiesLoose.exports);
var React$r = _interopRequireWildcard$1k(React__default$4);
var _propTypes$C = _interopRequireDefault$3Q(propTypes.exports);
var _clsx$L = _interopRequireDefault$3Q(clsx.exports);
var _composeClasses$a = _interopRequireDefault$3Q(composeClasses$2);
var _Tablelvl2Context$2 = _interopRequireDefault$3Q(Tablelvl2Context$1);
var _DefaultPropsProvider$a = DefaultPropsProvider$5;
var _styled$a = _interopRequireDefault$3Q(styled$2);
var _tableFooterClasses = tableFooterClasses$1;
var _jsxRuntime$g = require$$11;
const _excluded$H = ["className", "component"];
function _getRequireWildcardCache$13(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$13 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1k(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$13(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$a = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$a.default)(slots, _tableFooterClasses.getTableFooterUtilityClass, classes);
};
const TableFooterRoot = (0, _styled$a.default)('tfoot', {
  name: 'MuiTableFooter',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-footer-group'
});
const tablelvl2$1 = {
  variant: 'footer'
};
const defaultComponent$2 = 'tfoot';
const TableFooter = /*#__PURE__*/React$r.forwardRef(function TableFooter(inProps, ref) {
  const props = (0, _DefaultPropsProvider$a.useDefaultProps)({
    props: inProps,
    name: 'MuiTableFooter'
  });
  const {
      className,
      component = defaultComponent$2
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$d.default)(props, _excluded$H);
  const ownerState = (0, _extends2$d.default)({}, props, {
    component
  });
  const classes = useUtilityClasses$a(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$g.jsx)(_Tablelvl2Context$2.default.Provider, {
    value: tablelvl2$1,
    children: /*#__PURE__*/(0, _jsxRuntime$g.jsx)(TableFooterRoot, (0, _extends2$d.default)({
      as: component,
      className: (0, _clsx$L.default)(classes.root, className),
      ref: ref,
      role: component === defaultComponent$2 ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? TableFooter.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes$C.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$C.default.object,
  /**
   * @ignore
   */
  className: _propTypes$C.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$C.default.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$C.default.oneOfType([_propTypes$C.default.arrayOf(_propTypes$C.default.oneOfType([_propTypes$C.default.func, _propTypes$C.default.object, _propTypes$C.default.bool])), _propTypes$C.default.func, _propTypes$C.default.object])
} : void 0;
TableFooter$1.default = TableFooter;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tableFooterClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TableFooter.default;
  }
});
Object.defineProperty(exports, "tableFooterClasses", {
  enumerable: true,
  get: function () {
    return _tableFooterClasses.default;
  }
});
var _TableFooter = _interopRequireDefault(TableFooter$1);
var _tableFooterClasses = _interopRequireWildcard(tableFooterClasses$1);
Object.keys(_tableFooterClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tableFooterClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tableFooterClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TableFooter$2));

var TableHead$4 = {};

var TableHead$3 = {};

var tableHeadClasses$1 = {};

var _interopRequireDefault$3P = interopRequireDefault$1.exports;
Object.defineProperty(tableHeadClasses$1, "__esModule", {
  value: true
});
tableHeadClasses$1.default = void 0;
tableHeadClasses$1.getTableHeadUtilityClass = getTableHeadUtilityClass;
var _generateUtilityClasses$9 = _interopRequireDefault$3P(generateUtilityClasses$3);
var _generateUtilityClass$9 = _interopRequireDefault$3P(generateUtilityClass$3);
function getTableHeadUtilityClass(slot) {
  return (0, _generateUtilityClass$9.default)('MuiTableHead', slot);
}
const tableHeadClasses = (0, _generateUtilityClasses$9.default)('MuiTableHead', ['root']);
tableHeadClasses$1.default = tableHeadClasses;

var _interopRequireDefault$3O = interopRequireDefault$1.exports;
Object.defineProperty(TableHead$3, "__esModule", {
  value: true
});
TableHead$3.default = void 0;
var _extends2$c = _interopRequireDefault$3O(_extends$19.exports);
var _objectWithoutPropertiesLoose2$c = _interopRequireDefault$3O(objectWithoutPropertiesLoose.exports);
var React$q = _interopRequireWildcard$1j(React__default$4);
var _propTypes$B = _interopRequireDefault$3O(propTypes.exports);
var _clsx$K = _interopRequireDefault$3O(clsx.exports);
var _composeClasses$9 = _interopRequireDefault$3O(composeClasses$2);
var _Tablelvl2Context$1 = _interopRequireDefault$3O(Tablelvl2Context$1);
var _DefaultPropsProvider$9 = DefaultPropsProvider$5;
var _styled$9 = _interopRequireDefault$3O(styled$2);
var _tableHeadClasses = tableHeadClasses$1;
var _jsxRuntime$f = require$$11;
const _excluded$G = ["className", "component"];
function _getRequireWildcardCache$12(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$12 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1j(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$12(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$9 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$9.default)(slots, _tableHeadClasses.getTableHeadUtilityClass, classes);
};
const TableHeadRoot = (0, _styled$9.default)('thead', {
  name: 'MuiTableHead',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-header-group'
});
const tablelvl2 = {
  variant: 'head'
};
const defaultComponent$1 = 'thead';
const TableHead$2 = /*#__PURE__*/React$q.forwardRef(function TableHead(inProps, ref) {
  const props = (0, _DefaultPropsProvider$9.useDefaultProps)({
    props: inProps,
    name: 'MuiTableHead'
  });
  const {
      className,
      component = defaultComponent$1
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$c.default)(props, _excluded$G);
  const ownerState = (0, _extends2$c.default)({}, props, {
    component
  });
  const classes = useUtilityClasses$9(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$f.jsx)(_Tablelvl2Context$1.default.Provider, {
    value: tablelvl2,
    children: /*#__PURE__*/(0, _jsxRuntime$f.jsx)(TableHeadRoot, (0, _extends2$c.default)({
      as: component,
      className: (0, _clsx$K.default)(classes.root, className),
      ref: ref,
      role: component === defaultComponent$1 ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
process.env.NODE_ENV !== "production" ? TableHead$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: _propTypes$B.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$B.default.object,
  /**
   * @ignore
   */
  className: _propTypes$B.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$B.default.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$B.default.oneOfType([_propTypes$B.default.arrayOf(_propTypes$B.default.oneOfType([_propTypes$B.default.func, _propTypes$B.default.object, _propTypes$B.default.bool])), _propTypes$B.default.func, _propTypes$B.default.object])
} : void 0;
TableHead$3.default = TableHead$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tableHeadClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TableHead.default;
  }
});
Object.defineProperty(exports, "tableHeadClasses", {
  enumerable: true,
  get: function () {
    return _tableHeadClasses.default;
  }
});
var _TableHead = _interopRequireDefault(TableHead$3);
var _tableHeadClasses = _interopRequireWildcard(tableHeadClasses$1);
Object.keys(_tableHeadClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tableHeadClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tableHeadClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TableHead$4));

var TableHead$1 = /*@__PURE__*/getDefaultExportFromCjs$1(TableHead$4);

var TablePagination$2 = {};

var TablePagination$1 = {};

var Toolbar$2 = {};

var Toolbar$1 = {};

var toolbarClasses$1 = {};

var _interopRequireDefault$3N = interopRequireDefault$1.exports;
Object.defineProperty(toolbarClasses$1, "__esModule", {
  value: true
});
toolbarClasses$1.default = void 0;
toolbarClasses$1.getToolbarUtilityClass = getToolbarUtilityClass;
var _generateUtilityClasses$8 = _interopRequireDefault$3N(generateUtilityClasses$3);
var _generateUtilityClass$8 = _interopRequireDefault$3N(generateUtilityClass$3);
function getToolbarUtilityClass(slot) {
  return (0, _generateUtilityClass$8.default)('MuiToolbar', slot);
}
const toolbarClasses = (0, _generateUtilityClasses$8.default)('MuiToolbar', ['root', 'gutters', 'regular', 'dense']);
toolbarClasses$1.default = toolbarClasses;

var _interopRequireDefault$3M = interopRequireDefault$1.exports;
Object.defineProperty(Toolbar$1, "__esModule", {
  value: true
});
Toolbar$1.default = void 0;
var _objectWithoutPropertiesLoose2$b = _interopRequireDefault$3M(objectWithoutPropertiesLoose.exports);
var _extends2$b = _interopRequireDefault$3M(_extends$19.exports);
var React$p = _interopRequireWildcard$1i(React__default$4);
var _propTypes$A = _interopRequireDefault$3M(propTypes.exports);
var _clsx$J = _interopRequireDefault$3M(clsx.exports);
var _composeClasses$8 = _interopRequireDefault$3M(composeClasses$2);
var _DefaultPropsProvider$8 = DefaultPropsProvider$5;
var _styled$8 = _interopRequireDefault$3M(styled$2);
var _toolbarClasses = toolbarClasses$1;
var _jsxRuntime$e = require$$11;
const _excluded$F = ["className", "component", "disableGutters", "variant"];
function _getRequireWildcardCache$11(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$11 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1i(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$11(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$8 = ownerState => {
  const {
    classes,
    disableGutters,
    variant
  } = ownerState;
  const slots = {
    root: ['root', !disableGutters && 'gutters', variant]
  };
  return (0, _composeClasses$8.default)(slots, _toolbarClasses.getToolbarUtilityClass, classes);
};
const ToolbarRoot = (0, _styled$8.default)('div', {
  name: 'MuiToolbar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableGutters && styles.gutters, styles[ownerState.variant]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$b.default)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center'
}, !ownerState.disableGutters && {
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  }
}, ownerState.variant === 'dense' && {
  minHeight: 48
}), ({
  theme,
  ownerState
}) => ownerState.variant === 'regular' && theme.mixins.toolbar);
const Toolbar = /*#__PURE__*/React$p.forwardRef(function Toolbar(inProps, ref) {
  const props = (0, _DefaultPropsProvider$8.useDefaultProps)({
    props: inProps,
    name: 'MuiToolbar'
  });
  const {
      className,
      component = 'div',
      disableGutters = false,
      variant = 'regular'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$b.default)(props, _excluded$F);
  const ownerState = (0, _extends2$b.default)({}, props, {
    component,
    disableGutters,
    variant
  });
  const classes = useUtilityClasses$8(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$e.jsx)(ToolbarRoot, (0, _extends2$b.default)({
    as: component,
    className: (0, _clsx$J.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? Toolbar.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: _propTypes$A.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$A.default.object,
  /**
   * @ignore
   */
  className: _propTypes$A.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$A.default.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: _propTypes$A.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$A.default.oneOfType([_propTypes$A.default.arrayOf(_propTypes$A.default.oneOfType([_propTypes$A.default.func, _propTypes$A.default.object, _propTypes$A.default.bool])), _propTypes$A.default.func, _propTypes$A.default.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: _propTypes$A.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$A.default.oneOf(['dense', 'regular']), _propTypes$A.default.string])
} : void 0;
Toolbar$1.default = Toolbar;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  toolbarClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Toolbar.default;
  }
});
Object.defineProperty(exports, "toolbarClasses", {
  enumerable: true,
  get: function () {
    return _toolbarClasses.default;
  }
});
var _Toolbar = _interopRequireDefault(Toolbar$1);
var _toolbarClasses = _interopRequireWildcard(toolbarClasses$1);
Object.keys(_toolbarClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _toolbarClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _toolbarClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Toolbar$2));

var TablePaginationActions$1 = {};

var KeyboardArrowLeft = {};

var _interopRequireDefault$3L = interopRequireDefault$1.exports;
Object.defineProperty(KeyboardArrowLeft, "__esModule", {
  value: true
});
KeyboardArrowLeft.default = void 0;
_interopRequireWildcard$1h(React__default$4);
var _createSvgIcon$3 = _interopRequireDefault$3L(createSvgIcon$2);
var _jsxRuntime$d = require$$11;
function _getRequireWildcardCache$10(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$10 = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1h(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$10(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
KeyboardArrowLeft.default = (0, _createSvgIcon$3.default)( /*#__PURE__*/(0, _jsxRuntime$d.jsx)("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

var KeyboardArrowRight = {};

var _interopRequireDefault$3K = interopRequireDefault$1.exports;
Object.defineProperty(KeyboardArrowRight, "__esModule", {
  value: true
});
KeyboardArrowRight.default = void 0;
_interopRequireWildcard$1g(React__default$4);
var _createSvgIcon$2 = _interopRequireDefault$3K(createSvgIcon$2);
var _jsxRuntime$c = require$$11;
function _getRequireWildcardCache$$(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$$ = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1g(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$$(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
KeyboardArrowRight.default = (0, _createSvgIcon$2.default)( /*#__PURE__*/(0, _jsxRuntime$c.jsx)("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

var _interopRequireDefault$3J = interopRequireDefault$1.exports;
Object.defineProperty(TablePaginationActions$1, "__esModule", {
  value: true
});
TablePaginationActions$1.default = void 0;
var _extends2$a = _interopRequireDefault$3J(_extends$19.exports);
var _objectWithoutPropertiesLoose2$a = _interopRequireDefault$3J(objectWithoutPropertiesLoose.exports);
var React$o = _interopRequireWildcard$1f(React__default$4);
var _propTypes$z = _interopRequireDefault$3J(propTypes.exports);
var _RtlProvider$2 = RtlProvider$1;
var _KeyboardArrowLeft$1 = _interopRequireDefault$3J(KeyboardArrowLeft);
var _KeyboardArrowRight$1 = _interopRequireDefault$3J(KeyboardArrowRight);
var _IconButton = _interopRequireDefault$3J(IconButton$4);
var _LastPage = _interopRequireDefault$3J(LastPage);
var _FirstPage = _interopRequireDefault$3J(FirstPage);
var _jsxRuntime$b = require$$11;
const _excluded$E = ["backIconButtonProps", "count", "disabled", "getItemAriaLabel", "nextIconButtonProps", "onPageChange", "page", "rowsPerPage", "showFirstButton", "showLastButton", "slots", "slotProps"];
/**
 * @ignore - internal component.
 */
function _getRequireWildcardCache$_(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$_ = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1f(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$_(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TablePaginationActions = /*#__PURE__*/React$o.forwardRef(function TablePaginationActions(props, ref) {
  var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
  const {
      backIconButtonProps,
      count,
      disabled = false,
      getItemAriaLabel,
      nextIconButtonProps,
      onPageChange,
      page,
      rowsPerPage,
      showFirstButton,
      showLastButton,
      slots = {},
      slotProps = {}
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$a.default)(props, _excluded$E);
  const isRtl = (0, _RtlProvider$2.useRtl)();
  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = event => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = event => {
    onPageChange(event, page + 1);
  };
  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : _IconButton.default;
  const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : _IconButton.default;
  const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : _IconButton.default;
  const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : _IconButton.default;
  const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : _FirstPage.default;
  const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : _LastPage.default;
  const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : _KeyboardArrowRight$1.default;
  const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : _KeyboardArrowLeft$1.default;
  const FirstButtonSlot = isRtl ? LastButton : FirstButton;
  const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
  const NextButtonSlot = isRtl ? PreviousButton : NextButton;
  const LastButtonSlot = isRtl ? FirstButton : LastButton;
  const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
  const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
  const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
  const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
  return /*#__PURE__*/(0, _jsxRuntime$b.jsxs)("div", (0, _extends2$a.default)({
    ref: ref
  }, other, {
    children: [showFirstButton && /*#__PURE__*/(0, _jsxRuntime$b.jsx)(FirstButtonSlot, (0, _extends2$a.default)({
      onClick: handleFirstPageButtonClick,
      disabled: disabled || page === 0,
      "aria-label": getItemAriaLabel('first', page),
      title: getItemAriaLabel('first', page)
    }, firstButtonSlotProps, {
      children: isRtl ? /*#__PURE__*/(0, _jsxRuntime$b.jsx)(LastButtonIcon, (0, _extends2$a.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/(0, _jsxRuntime$b.jsx)(FirstButtonIcon, (0, _extends2$a.default)({}, slotProps.firstButtonIcon))
    })), /*#__PURE__*/(0, _jsxRuntime$b.jsx)(PreviousButtonSlot, (0, _extends2$a.default)({
      onClick: handleBackButtonClick,
      disabled: disabled || page === 0,
      color: "inherit",
      "aria-label": getItemAriaLabel('previous', page),
      title: getItemAriaLabel('previous', page)
    }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
      children: isRtl ? /*#__PURE__*/(0, _jsxRuntime$b.jsx)(NextButtonIcon, (0, _extends2$a.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/(0, _jsxRuntime$b.jsx)(PreviousButtonIcon, (0, _extends2$a.default)({}, slotProps.previousButtonIcon))
    })), /*#__PURE__*/(0, _jsxRuntime$b.jsx)(NextButtonSlot, (0, _extends2$a.default)({
      onClick: handleNextButtonClick,
      disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
      color: "inherit",
      "aria-label": getItemAriaLabel('next', page),
      title: getItemAriaLabel('next', page)
    }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
      children: isRtl ? /*#__PURE__*/(0, _jsxRuntime$b.jsx)(PreviousButtonIcon, (0, _extends2$a.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/(0, _jsxRuntime$b.jsx)(NextButtonIcon, (0, _extends2$a.default)({}, slotProps.nextButtonIcon))
    })), showLastButton && /*#__PURE__*/(0, _jsxRuntime$b.jsx)(LastButtonSlot, (0, _extends2$a.default)({
      onClick: handleLastPageButtonClick,
      disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
      "aria-label": getItemAriaLabel('last', page),
      title: getItemAriaLabel('last', page)
    }, lastButtonSlotProps, {
      children: isRtl ? /*#__PURE__*/(0, _jsxRuntime$b.jsx)(FirstButtonIcon, (0, _extends2$a.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/(0, _jsxRuntime$b.jsx)(LastButtonIcon, (0, _extends2$a.default)({}, slotProps.lastButtonIcon))
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? TablePaginationActions.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: _propTypes$z.default.object,
  /**
   * The total number of rows.
   */
  count: _propTypes$z.default.number.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$z.default.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: _propTypes$z.default.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: _propTypes$z.default.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: _propTypes$z.default.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: _propTypes$z.default.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes$z.default.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: _propTypes$z.default.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: _propTypes$z.default.bool.isRequired,
  /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */
  slotProps: _propTypes$z.default.shape({
    firstButton: _propTypes$z.default.object,
    firstButtonIcon: _propTypes$z.default.object,
    lastButton: _propTypes$z.default.object,
    lastButtonIcon: _propTypes$z.default.object,
    nextButton: _propTypes$z.default.object,
    nextButtonIcon: _propTypes$z.default.object,
    previousButton: _propTypes$z.default.object,
    previousButtonIcon: _propTypes$z.default.object
  }),
  /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: _propTypes$z.default.shape({
    firstButton: _propTypes$z.default.elementType,
    firstButtonIcon: _propTypes$z.default.elementType,
    lastButton: _propTypes$z.default.elementType,
    lastButtonIcon: _propTypes$z.default.elementType,
    nextButton: _propTypes$z.default.elementType,
    nextButtonIcon: _propTypes$z.default.elementType,
    previousButton: _propTypes$z.default.elementType,
    previousButtonIcon: _propTypes$z.default.elementType
  })
} : void 0;
TablePaginationActions$1.default = TablePaginationActions;

var tablePaginationClasses$1 = {};

var _interopRequireDefault$3I = interopRequireDefault$1.exports;
Object.defineProperty(tablePaginationClasses$1, "__esModule", {
  value: true
});
tablePaginationClasses$1.default = void 0;
tablePaginationClasses$1.getTablePaginationUtilityClass = getTablePaginationUtilityClass;
var _generateUtilityClasses$7 = _interopRequireDefault$3I(generateUtilityClasses$3);
var _generateUtilityClass$7 = _interopRequireDefault$3I(generateUtilityClass$3);
function getTablePaginationUtilityClass(slot) {
  return (0, _generateUtilityClass$7.default)('MuiTablePagination', slot);
}
const tablePaginationClasses = (0, _generateUtilityClasses$7.default)('MuiTablePagination', ['root', 'toolbar', 'spacer', 'selectLabel', 'selectRoot', 'select', 'selectIcon', 'input', 'menuItem', 'displayedRows', 'actions']);
tablePaginationClasses$1.default = tablePaginationClasses;

var _interopRequireDefault$3H = interopRequireDefault$1.exports;
Object.defineProperty(TablePagination$1, "__esModule", {
  value: true
});
TablePagination$1.default = void 0;
var _objectWithoutPropertiesLoose2$9 = _interopRequireDefault$3H(objectWithoutPropertiesLoose.exports);
var _extends2$9 = _interopRequireDefault$3H(_extends$19.exports);
var _react$1V = _interopRequireWildcard$1e(React__default$4);
var React$n = _react$1V;
var _propTypes$y = _interopRequireDefault$3H(propTypes.exports);
var _clsx$I = _interopRequireDefault$3H(clsx.exports);
var _integerPropType = _interopRequireDefault$3H(integerPropType$1);
var _chainPropTypes = _interopRequireDefault$3H(chainPropTypes$2);
var _composeClasses$7 = _interopRequireDefault$3H(composeClasses$2);
var _isHostComponent = _interopRequireDefault$3H(isHostComponent$2);
var _styled$7 = _interopRequireDefault$3H(styled$2);
var _DefaultPropsProvider$7 = DefaultPropsProvider$5;
var _InputBase2 = _interopRequireDefault$3H(InputBase$3);
var _MenuItem = _interopRequireDefault$3H(MenuItem$3);
var _Select$1 = _interopRequireDefault$3H(Select$4);
var _TableCell = _interopRequireDefault$3H(TableCell$4);
var _Toolbar = _interopRequireDefault$3H(Toolbar$2);
var _TablePaginationActions = _interopRequireDefault$3H(TablePaginationActions$1);
var _useId$1 = _interopRequireDefault$3H(useId);
var _tablePaginationClasses = _interopRequireWildcard$1e(tablePaginationClasses$1);
var _jsxRuntime$a = require$$11;
var _InputBase;
const _excluded$D = ["ActionsComponent", "backIconButtonProps", "className", "colSpan", "component", "count", "disabled", "getItemAriaLabel", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onPageChange", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps", "showFirstButton", "showLastButton", "slotProps", "slots"];
function _getRequireWildcardCache$Z(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$Z = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1e(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$Z(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TablePaginationRoot = (0, _styled$7.default)(_TableCell.default, {
  name: 'MuiTablePagination',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  overflow: 'auto',
  color: (theme.vars || theme).palette.text.primary,
  fontSize: theme.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  '&:last-child': {
    padding: 0
  }
}));
const TablePaginationToolbar = (0, _styled$7.default)(_Toolbar.default, {
  name: 'MuiTablePagination',
  slot: 'Toolbar',
  overridesResolver: (props, styles) => (0, _extends2$9.default)({
    [`& .${_tablePaginationClasses.default.actions}`]: styles.actions
  }, styles.toolbar)
})(({
  theme
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [theme.breakpoints.up('sm')]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${_tablePaginationClasses.default.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
}));
const TablePaginationSpacer = (0, _styled$7.default)('div', {
  name: 'MuiTablePagination',
  slot: 'Spacer',
  overridesResolver: (props, styles) => styles.spacer
})({
  flex: '1 1 100%'
});
const TablePaginationSelectLabel = (0, _styled$7.default)('p', {
  name: 'MuiTablePagination',
  slot: 'SelectLabel',
  overridesResolver: (props, styles) => styles.selectLabel
})(({
  theme
}) => (0, _extends2$9.default)({}, theme.typography.body2, {
  flexShrink: 0
}));
const TablePaginationSelect = (0, _styled$7.default)(_Select$1.default, {
  name: 'MuiTablePagination',
  slot: 'Select',
  overridesResolver: (props, styles) => (0, _extends2$9.default)({
    [`& .${_tablePaginationClasses.default.selectIcon}`]: styles.selectIcon,
    [`& .${_tablePaginationClasses.default.select}`]: styles.select
  }, styles.input, styles.selectRoot)
})({
  color: 'inherit',
  fontSize: 'inherit',
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${_tablePaginationClasses.default.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: 'right',
    textAlignLast: 'right' // Align <select> on Chrome.
  }
});
const TablePaginationMenuItem = (0, _styled$7.default)(_MenuItem.default, {
  name: 'MuiTablePagination',
  slot: 'MenuItem',
  overridesResolver: (props, styles) => styles.menuItem
})({});
const TablePaginationDisplayedRows = (0, _styled$7.default)('p', {
  name: 'MuiTablePagination',
  slot: 'DisplayedRows',
  overridesResolver: (props, styles) => styles.displayedRows
})(({
  theme
}) => (0, _extends2$9.default)({}, theme.typography.body2, {
  flexShrink: 0
}));
function defaultLabelDisplayedRows({
  from,
  to,
  count
}) {
  return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function defaultGetAriaLabel(type) {
  return `Go to ${type} page`;
}
const useUtilityClasses$7 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    toolbar: ['toolbar'],
    spacer: ['spacer'],
    selectLabel: ['selectLabel'],
    select: ['select'],
    input: ['input'],
    selectIcon: ['selectIcon'],
    menuItem: ['menuItem'],
    displayedRows: ['displayedRows'],
    actions: ['actions']
  };
  return (0, _composeClasses$7.default)(slots, _tablePaginationClasses.getTablePaginationUtilityClass, classes);
};

/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */
const TablePagination = /*#__PURE__*/React$n.forwardRef(function TablePagination(inProps, ref) {
  var _slotProps$select;
  const props = (0, _DefaultPropsProvider$7.useDefaultProps)({
    props: inProps,
    name: 'MuiTablePagination'
  });
  const {
      ActionsComponent = _TablePaginationActions.default,
      backIconButtonProps,
      className,
      colSpan: colSpanProp,
      component = _TableCell.default,
      count,
      disabled = false,
      getItemAriaLabel = defaultGetAriaLabel,
      labelDisplayedRows = defaultLabelDisplayedRows,
      labelRowsPerPage = 'Rows per page:',
      nextIconButtonProps,
      onPageChange,
      onRowsPerPageChange,
      page,
      rowsPerPage,
      rowsPerPageOptions = [10, 25, 50, 100],
      SelectProps = {},
      showFirstButton = false,
      showLastButton = false,
      slotProps = {},
      slots = {}
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$9.default)(props, _excluded$D);
  const ownerState = props;
  const classes = useUtilityClasses$7(ownerState);
  const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
  const MenuItemComponent = selectProps.native ? 'option' : TablePaginationMenuItem;
  let colSpan;
  if (component === _TableCell.default || component === 'td') {
    colSpan = colSpanProp || 1000; // col-span over everything
  }
  const selectId = (0, _useId$1.default)(selectProps.id);
  const labelId = (0, _useId$1.default)(selectProps.labelId);
  const getLabelDisplayedRowsTo = () => {
    if (count === -1) {
      return (page + 1) * rowsPerPage;
    }
    return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
  };
  return /*#__PURE__*/(0, _jsxRuntime$a.jsx)(TablePaginationRoot, (0, _extends2$9.default)({
    colSpan: colSpan,
    ref: ref,
    as: component,
    ownerState: ownerState,
    className: (0, _clsx$I.default)(classes.root, className)
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$a.jsxs)(TablePaginationToolbar, {
      className: classes.toolbar,
      children: [/*#__PURE__*/(0, _jsxRuntime$a.jsx)(TablePaginationSpacer, {
        className: classes.spacer
      }), rowsPerPageOptions.length > 1 && /*#__PURE__*/(0, _jsxRuntime$a.jsx)(TablePaginationSelectLabel, {
        className: classes.selectLabel,
        id: labelId,
        children: labelRowsPerPage
      }), rowsPerPageOptions.length > 1 && /*#__PURE__*/(0, _jsxRuntime$a.jsx)(TablePaginationSelect, (0, _extends2$9.default)({
        variant: "standard"
      }, !selectProps.variant && {
        input: _InputBase || (_InputBase = /*#__PURE__*/(0, _jsxRuntime$a.jsx)(_InputBase2.default, {}))
      }, {
        value: rowsPerPage,
        onChange: onRowsPerPageChange,
        id: selectId,
        labelId: labelId
      }, selectProps, {
        classes: (0, _extends2$9.default)({}, selectProps.classes, {
          // TODO v5 remove `classes.input`
          root: (0, _clsx$I.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
          select: (0, _clsx$I.default)(classes.select, (selectProps.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: (0, _clsx$I.default)(classes.selectIcon, (selectProps.classes || {}).icon)
        }),
        disabled: disabled,
        children: rowsPerPageOptions.map(rowsPerPageOption => /*#__PURE__*/(0, _react$1V.createElement)(MenuItemComponent, (0, _extends2$9.default)({}, !(0, _isHostComponent.default)(MenuItemComponent) && {
          ownerState
        }, {
          className: classes.menuItem,
          key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
          value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
      })), /*#__PURE__*/(0, _jsxRuntime$a.jsx)(TablePaginationDisplayedRows, {
        className: classes.displayedRows,
        children: labelDisplayedRows({
          from: count === 0 ? 0 : page * rowsPerPage + 1,
          to: getLabelDisplayedRowsTo(),
          count: count === -1 ? -1 : count,
          page
        })
      }), /*#__PURE__*/(0, _jsxRuntime$a.jsx)(ActionsComponent, {
        className: classes.actions,
        backIconButtonProps: backIconButtonProps,
        count: count,
        nextIconButtonProps: nextIconButtonProps,
        onPageChange: onPageChange,
        page: page,
        rowsPerPage: rowsPerPage,
        showFirstButton: showFirstButton,
        showLastButton: showLastButton,
        slotProps: slotProps.actions,
        slots: slots.actions,
        getItemAriaLabel: getItemAriaLabel,
        disabled: disabled
      })]
    })
  }));
});
process.env.NODE_ENV !== "production" ? TablePagination.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: _propTypes$y.default.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */
  backIconButtonProps: _propTypes$y.default.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$y.default.object,
  /**
   * @ignore
   */
  className: _propTypes$y.default.string,
  /**
   * @ignore
   */
  colSpan: _propTypes$y.default.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$y.default.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: _integerPropType.default.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$y.default.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: _propTypes$y.default.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: _propTypes$y.default.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: _propTypes$y.default.node,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */
  nextIconButtonProps: _propTypes$y.default.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: _propTypes$y.default.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: _propTypes$y.default.func,
  /**
   * The zero-based index of the current page.
   */
  page: (0, _chainPropTypes.default)(_integerPropType.default.isRequired, props => {
    const {
      count,
      page,
      rowsPerPage
    } = props;
    if (count === -1) {
      return null;
    }
    const newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
    if (page < 0 || page > newLastPage) {
      return new Error('MUI: The page prop of a TablePagination is out of range ' + `(0 to ${newLastPage}, but page is ${page}).`);
    }
    return null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: _integerPropType.default.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: _propTypes$y.default.arrayOf(_propTypes$y.default.oneOfType([_propTypes$y.default.number, _propTypes$y.default.shape({
    label: _propTypes$y.default.string.isRequired,
    value: _propTypes$y.default.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */
  SelectProps: _propTypes$y.default.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: _propTypes$y.default.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: _propTypes$y.default.bool,
  /**
   * The props used for each slot inside the TablePagination.
   * @default {}
   */
  slotProps: _propTypes$y.default.shape({
    actions: _propTypes$y.default.shape({
      firstButton: _propTypes$y.default.object,
      firstButtonIcon: _propTypes$y.default.object,
      lastButton: _propTypes$y.default.object,
      lastButtonIcon: _propTypes$y.default.object,
      nextButton: _propTypes$y.default.object,
      nextButtonIcon: _propTypes$y.default.object,
      previousButton: _propTypes$y.default.object,
      previousButtonIcon: _propTypes$y.default.object
    }),
    select: _propTypes$y.default.object
  }),
  /**
   * The components used for each slot inside the TablePagination.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: _propTypes$y.default.shape({
    actions: _propTypes$y.default.shape({
      firstButton: _propTypes$y.default.elementType,
      firstButtonIcon: _propTypes$y.default.elementType,
      lastButton: _propTypes$y.default.elementType,
      lastButtonIcon: _propTypes$y.default.elementType,
      nextButton: _propTypes$y.default.elementType,
      nextButtonIcon: _propTypes$y.default.elementType,
      previousButton: _propTypes$y.default.elementType,
      previousButtonIcon: _propTypes$y.default.elementType
    })
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$y.default.oneOfType([_propTypes$y.default.arrayOf(_propTypes$y.default.oneOfType([_propTypes$y.default.func, _propTypes$y.default.object, _propTypes$y.default.bool])), _propTypes$y.default.func, _propTypes$y.default.object])
} : void 0;
TablePagination$1.default = TablePagination;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tablePaginationClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TablePagination.default;
  }
});
Object.defineProperty(exports, "tablePaginationClasses", {
  enumerable: true,
  get: function () {
    return _tablePaginationClasses.default;
  }
});
var _TablePagination = _interopRequireDefault(TablePagination$1);
var _tablePaginationClasses = _interopRequireWildcard(tablePaginationClasses$1);
Object.keys(_tablePaginationClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tablePaginationClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tablePaginationClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TablePagination$2));

var TableRow$4 = {};

var TableRow$3 = {};

var tableRowClasses$1 = {};

var _interopRequireDefault$3G = interopRequireDefault$1.exports;
Object.defineProperty(tableRowClasses$1, "__esModule", {
  value: true
});
tableRowClasses$1.default = void 0;
tableRowClasses$1.getTableRowUtilityClass = getTableRowUtilityClass;
var _generateUtilityClasses$6 = _interopRequireDefault$3G(generateUtilityClasses$3);
var _generateUtilityClass$6 = _interopRequireDefault$3G(generateUtilityClass$3);
function getTableRowUtilityClass(slot) {
  return (0, _generateUtilityClass$6.default)('MuiTableRow', slot);
}
const tableRowClasses = (0, _generateUtilityClasses$6.default)('MuiTableRow', ['root', 'selected', 'hover', 'head', 'footer']);
tableRowClasses$1.default = tableRowClasses;

var _interopRequireDefault$3F = interopRequireDefault$1.exports;
Object.defineProperty(TableRow$3, "__esModule", {
  value: true
});
TableRow$3.default = void 0;
var _extends2$8 = _interopRequireDefault$3F(_extends$19.exports);
var _objectWithoutPropertiesLoose2$8 = _interopRequireDefault$3F(objectWithoutPropertiesLoose.exports);
var React$m = _interopRequireWildcard$1d(React__default$4);
var _propTypes$x = _interopRequireDefault$3F(propTypes.exports);
var _clsx$H = _interopRequireDefault$3F(clsx.exports);
var _composeClasses$6 = _interopRequireDefault$3F(composeClasses$2);
var _colorManipulator = colorManipulator;
var _Tablelvl2Context = _interopRequireDefault$3F(Tablelvl2Context$1);
var _DefaultPropsProvider$6 = DefaultPropsProvider$5;
var _styled$6 = _interopRequireDefault$3F(styled$2);
var _tableRowClasses = _interopRequireWildcard$1d(tableRowClasses$1);
var _jsxRuntime$9 = require$$11;
const _excluded$C = ["className", "component", "hover", "selected"];
function _getRequireWildcardCache$Y(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$Y = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1d(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$Y(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$6 = ownerState => {
  const {
    classes,
    selected,
    hover,
    head,
    footer
  } = ownerState;
  const slots = {
    root: ['root', selected && 'selected', hover && 'hover', head && 'head', footer && 'footer']
  };
  return (0, _composeClasses$6.default)(slots, _tableRowClasses.getTableRowUtilityClass, classes);
};
const TableRowRoot = (0, _styled$6.default)('tr', {
  name: 'MuiTableRow',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.head && styles.head, ownerState.footer && styles.footer];
  }
})(({
  theme
}) => ({
  color: 'inherit',
  display: 'table-row',
  verticalAlign: 'middle',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${_tableRowClasses.default.hover}:hover`]: {
    backgroundColor: (theme.vars || theme).palette.action.hover
  },
  [`&.${_tableRowClasses.default.selected}`]: {
    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    '&:hover': {
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
    }
  }
}));
const defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */
const TableRow$2 = /*#__PURE__*/React$m.forwardRef(function TableRow(inProps, ref) {
  const props = (0, _DefaultPropsProvider$6.useDefaultProps)({
    props: inProps,
    name: 'MuiTableRow'
  });
  const {
      className,
      component = defaultComponent,
      hover = false,
      selected = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$8.default)(props, _excluded$C);
  const tablelvl2 = React$m.useContext(_Tablelvl2Context.default);
  const ownerState = (0, _extends2$8.default)({}, props, {
    component,
    hover,
    selected,
    head: tablelvl2 && tablelvl2.variant === 'head',
    footer: tablelvl2 && tablelvl2.variant === 'footer'
  });
  const classes = useUtilityClasses$6(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$9.jsx)(TableRowRoot, (0, _extends2$8.default)({
    as: component,
    ref: ref,
    className: (0, _clsx$H.default)(classes.root, className),
    role: component === defaultComponent ? null : 'row',
    ownerState: ownerState
  }, other));
});
process.env.NODE_ENV !== "production" ? TableRow$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: _propTypes$x.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$x.default.object,
  /**
   * @ignore
   */
  className: _propTypes$x.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$x.default.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: _propTypes$x.default.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: _propTypes$x.default.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$x.default.oneOfType([_propTypes$x.default.arrayOf(_propTypes$x.default.oneOfType([_propTypes$x.default.func, _propTypes$x.default.object, _propTypes$x.default.bool])), _propTypes$x.default.func, _propTypes$x.default.object])
} : void 0;
TableRow$3.default = TableRow$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tableRowClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TableRow.default;
  }
});
Object.defineProperty(exports, "tableRowClasses", {
  enumerable: true,
  get: function () {
    return _tableRowClasses.default;
  }
});
var _TableRow = _interopRequireDefault(TableRow$3);
var _tableRowClasses = _interopRequireWildcard(tableRowClasses$1);
Object.keys(_tableRowClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tableRowClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tableRowClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TableRow$4));

var TableRow$1 = /*@__PURE__*/getDefaultExportFromCjs$1(TableRow$4);

var TableSortLabel$2 = {};

var TableSortLabel$1 = {};

var ArrowDownward = {};

var _interopRequireDefault$3E = interopRequireDefault$1.exports;
Object.defineProperty(ArrowDownward, "__esModule", {
  value: true
});
ArrowDownward.default = void 0;
_interopRequireWildcard$1c(React__default$4);
var _createSvgIcon$1 = _interopRequireDefault$3E(createSvgIcon$2);
var _jsxRuntime$8 = require$$11;
function _getRequireWildcardCache$X(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$X = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1c(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$X(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
ArrowDownward.default = (0, _createSvgIcon$1.default)( /*#__PURE__*/(0, _jsxRuntime$8.jsx)("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

var tableSortLabelClasses$1 = {};

var _interopRequireDefault$3D = interopRequireDefault$1.exports;
Object.defineProperty(tableSortLabelClasses$1, "__esModule", {
  value: true
});
tableSortLabelClasses$1.default = void 0;
tableSortLabelClasses$1.getTableSortLabelUtilityClass = getTableSortLabelUtilityClass;
var _generateUtilityClasses$5 = _interopRequireDefault$3D(generateUtilityClasses$3);
var _generateUtilityClass$5 = _interopRequireDefault$3D(generateUtilityClass$3);
function getTableSortLabelUtilityClass(slot) {
  return (0, _generateUtilityClass$5.default)('MuiTableSortLabel', slot);
}
const tableSortLabelClasses = (0, _generateUtilityClasses$5.default)('MuiTableSortLabel', ['root', 'active', 'icon', 'iconDirectionDesc', 'iconDirectionAsc']);
tableSortLabelClasses$1.default = tableSortLabelClasses;

var _interopRequireDefault$3C = interopRequireDefault$1.exports;
Object.defineProperty(TableSortLabel$1, "__esModule", {
  value: true
});
TableSortLabel$1.default = void 0;
var _objectWithoutPropertiesLoose2$7 = _interopRequireDefault$3C(objectWithoutPropertiesLoose.exports);
var _extends2$7 = _interopRequireDefault$3C(_extends$19.exports);
var _composeClasses$5 = _interopRequireDefault$3C(composeClasses$2);
var _clsx$G = _interopRequireDefault$3C(clsx.exports);
var _propTypes$w = _interopRequireDefault$3C(propTypes.exports);
var React$l = _interopRequireWildcard$1b(React__default$4);
var _ButtonBase$2 = _interopRequireDefault$3C(ButtonBase$2);
var _ArrowDownward = _interopRequireDefault$3C(ArrowDownward);
var _styled$5 = _interopRequireDefault$3C(styled$2);
var _DefaultPropsProvider$5 = DefaultPropsProvider$5;
var _capitalize$2 = _interopRequireDefault$3C(capitalize$1);
var _tableSortLabelClasses = _interopRequireWildcard$1b(tableSortLabelClasses$1);
var _jsxRuntime$7 = require$$11;
const _excluded$B = ["active", "children", "className", "direction", "hideSortIcon", "IconComponent"];
function _getRequireWildcardCache$W(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$W = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1b(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$W(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$5 = ownerState => {
  const {
    classes,
    direction,
    active
  } = ownerState;
  const slots = {
    root: ['root', active && 'active'],
    icon: ['icon', `iconDirection${(0, _capitalize$2.default)(direction)}`]
  };
  return (0, _composeClasses$5.default)(slots, _tableSortLabelClasses.getTableSortLabelUtilityClass, classes);
};
const TableSortLabelRoot = (0, _styled$5.default)(_ButtonBase$2.default, {
  name: 'MuiTableSortLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.active && styles.active];
  }
})(({
  theme
}) => ({
  cursor: 'pointer',
  display: 'inline-flex',
  justifyContent: 'flex-start',
  flexDirection: 'inherit',
  alignItems: 'center',
  '&:focus': {
    color: (theme.vars || theme).palette.text.secondary
  },
  '&:hover': {
    color: (theme.vars || theme).palette.text.secondary,
    [`& .${_tableSortLabelClasses.default.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${_tableSortLabelClasses.default.active}`]: {
    color: (theme.vars || theme).palette.text.primary,
    [`& .${_tableSortLabelClasses.default.icon}`]: {
      opacity: 1,
      color: (theme.vars || theme).palette.text.secondary
    }
  }
}));
const TableSortLabelIcon = (0, _styled$5.default)('span', {
  name: 'MuiTableSortLabel',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, styles[`iconDirection${(0, _capitalize$2.default)(ownerState.direction)}`]];
  }
})(({
  theme,
  ownerState
}) => (0, _extends2$7.default)({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: theme.transitions.create(['opacity', 'transform'], {
    duration: theme.transitions.duration.shorter
  }),
  userSelect: 'none'
}, ownerState.direction === 'desc' && {
  transform: 'rotate(0deg)'
}, ownerState.direction === 'asc' && {
  transform: 'rotate(180deg)'
}));

/**
 * A button based label for placing inside `TableCell` for column sorting.
 */
const TableSortLabel = /*#__PURE__*/React$l.forwardRef(function TableSortLabel(inProps, ref) {
  const props = (0, _DefaultPropsProvider$5.useDefaultProps)({
    props: inProps,
    name: 'MuiTableSortLabel'
  });
  const {
      active = false,
      children,
      className,
      direction = 'asc',
      hideSortIcon = false,
      IconComponent = _ArrowDownward.default
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$7.default)(props, _excluded$B);
  const ownerState = (0, _extends2$7.default)({}, props, {
    active,
    direction,
    hideSortIcon,
    IconComponent
  });
  const classes = useUtilityClasses$5(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime$7.jsxs)(TableSortLabelRoot, (0, _extends2$7.default)({
    className: (0, _clsx$G.default)(classes.root, className),
    component: "span",
    disableRipple: true,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [children, hideSortIcon && !active ? null : /*#__PURE__*/(0, _jsxRuntime$7.jsx)(TableSortLabelIcon, {
      as: IconComponent,
      className: (0, _clsx$G.default)(classes.icon),
      ownerState: ownerState
    })]
  }));
});
process.env.NODE_ENV !== "production" ? TableSortLabel.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */
  active: _propTypes$w.default.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: _propTypes$w.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$w.default.object,
  /**
   * @ignore
   */
  className: _propTypes$w.default.string,
  /**
   * The current sort direction.
   * @default 'asc'
   */
  direction: _propTypes$w.default.oneOf(['asc', 'desc']),
  /**
   * Hide sort icon when active is false.
   * @default false
   */
  hideSortIcon: _propTypes$w.default.bool,
  /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */
  IconComponent: _propTypes$w.default.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$w.default.oneOfType([_propTypes$w.default.arrayOf(_propTypes$w.default.oneOfType([_propTypes$w.default.func, _propTypes$w.default.object, _propTypes$w.default.bool])), _propTypes$w.default.func, _propTypes$w.default.object])
} : void 0;
TableSortLabel$1.default = TableSortLabel;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tableSortLabelClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TableSortLabel.default;
  }
});
Object.defineProperty(exports, "tableSortLabelClasses", {
  enumerable: true,
  get: function () {
    return _tableSortLabelClasses.default;
  }
});
var _TableSortLabel = _interopRequireDefault(TableSortLabel$1);
var _tableSortLabelClasses = _interopRequireWildcard(tableSortLabelClasses$1);
Object.keys(_tableSortLabelClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tableSortLabelClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tableSortLabelClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TableSortLabel$2));

var Tabs$2 = {};

var Tabs$1 = {};

var scrollLeft = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "detectScrollType", {
  enumerable: true,
  get: function () {
    return _utils.unstable_detectScrollType;
  }
});
Object.defineProperty(exports, "getNormalizedScrollLeft", {
  enumerable: true,
  get: function () {
    return _utils.unstable_getNormalizedScrollLeft;
  }
});
var _utils = utils$7;
}(scrollLeft));

var animate$1 = {};

Object.defineProperty(animate$1, "__esModule", {
  value: true
});
animate$1.default = animate;
function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function animate(property, element, to, options = {}, cb = () => {}) {
  const {
    ease = easeInOutSin,
    duration = 300 // standard
  } = options;
  let start = null;
  const from = element[property];
  let cancelled = false;
  const cancel = () => {
    cancelled = true;
  };
  const step = timestamp => {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }
    if (start === null) {
      start = timestamp;
    }
    const time = Math.min(1, (timestamp - start) / duration);
    element[property] = ease(time) * (to - from) + from;
    if (time >= 1) {
      requestAnimationFrame(() => {
        cb(null);
      });
      return;
    }
    requestAnimationFrame(step);
  };
  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }
  requestAnimationFrame(step);
  return cancel;
}

var ScrollbarSize$1 = {};

var _interopRequireDefault$3B = interopRequireDefault$1.exports;
Object.defineProperty(ScrollbarSize$1, "__esModule", {
  value: true
});
ScrollbarSize$1.default = ScrollbarSize;
var _extends2$6 = _interopRequireDefault$3B(_extends$19.exports);
var _objectWithoutPropertiesLoose2$6 = _interopRequireDefault$3B(objectWithoutPropertiesLoose.exports);
var React$k = _interopRequireWildcard$1a(React__default$4);
var _propTypes$v = _interopRequireDefault$3B(propTypes.exports);
var _debounce$2 = _interopRequireDefault$3B(debounce$3);
var _utils$x = utils$6;
var _jsxRuntime$6 = require$$11;
const _excluded$A = ["onChange"];
function _getRequireWildcardCache$V(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$V = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1a(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$V(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const styles$o = {
  width: 99,
  height: 99,
  position: 'absolute',
  top: -9999,
  overflow: 'scroll'
};

/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */
function ScrollbarSize(props) {
  const {
      onChange
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$6.default)(props, _excluded$A);
  const scrollbarHeight = React$k.useRef();
  const nodeRef = React$k.useRef(null);
  const setMeasurements = () => {
    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
  };
  (0, _utils$x.unstable_useEnhancedEffect)(() => {
    const handleResize = (0, _debounce$2.default)(() => {
      const prevHeight = scrollbarHeight.current;
      setMeasurements();
      if (prevHeight !== scrollbarHeight.current) {
        onChange(scrollbarHeight.current);
      }
    });
    const containerWindow = (0, _utils$x.ownerWindow)(nodeRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [onChange]);
  React$k.useEffect(() => {
    setMeasurements();
    onChange(scrollbarHeight.current);
  }, [onChange]);
  return /*#__PURE__*/(0, _jsxRuntime$6.jsx)("div", (0, _extends2$6.default)({
    style: styles$o
  }, other, {
    ref: nodeRef
  }));
}
process.env.NODE_ENV !== "production" ? ScrollbarSize.propTypes = {
  onChange: _propTypes$v.default.func.isRequired
} : void 0;

var TabScrollButton$2 = {};

var TabScrollButton$1 = {};

var tabScrollButtonClasses$1 = {};

var _interopRequireDefault$3A = interopRequireDefault$1.exports;
Object.defineProperty(tabScrollButtonClasses$1, "__esModule", {
  value: true
});
tabScrollButtonClasses$1.default = void 0;
tabScrollButtonClasses$1.getTabScrollButtonUtilityClass = getTabScrollButtonUtilityClass;
var _generateUtilityClasses$4 = _interopRequireDefault$3A(generateUtilityClasses$3);
var _generateUtilityClass$4 = _interopRequireDefault$3A(generateUtilityClass$3);
function getTabScrollButtonUtilityClass(slot) {
  return (0, _generateUtilityClass$4.default)('MuiTabScrollButton', slot);
}
const tabScrollButtonClasses = (0, _generateUtilityClasses$4.default)('MuiTabScrollButton', ['root', 'vertical', 'horizontal', 'disabled']);
tabScrollButtonClasses$1.default = tabScrollButtonClasses;

/* eslint-disable jsx-a11y/aria-role */
var _interopRequireDefault$3z = interopRequireDefault$1.exports;
Object.defineProperty(TabScrollButton$1, "__esModule", {
  value: true
});
TabScrollButton$1.default = void 0;
var _objectWithoutPropertiesLoose2$5 = _interopRequireDefault$3z(objectWithoutPropertiesLoose.exports);
var _extends2$5 = _interopRequireDefault$3z(_extends$19.exports);
var React$j = _interopRequireWildcard$19(React__default$4);
var _propTypes$u = _interopRequireDefault$3z(propTypes.exports);
var _clsx$F = _interopRequireDefault$3z(clsx.exports);
var _composeClasses$4 = _interopRequireDefault$3z(composeClasses$2);
var _RtlProvider$1 = RtlProvider$1;
var _useSlotProps$1 = _interopRequireDefault$3z(useSlotProps$2);
var _KeyboardArrowLeft = _interopRequireDefault$3z(KeyboardArrowLeft);
var _KeyboardArrowRight = _interopRequireDefault$3z(KeyboardArrowRight);
var _ButtonBase$1 = _interopRequireDefault$3z(ButtonBase$2);
var _DefaultPropsProvider$4 = DefaultPropsProvider$5;
var _styled$4 = _interopRequireDefault$3z(styled$2);
var _tabScrollButtonClasses = _interopRequireWildcard$19(tabScrollButtonClasses$1);
var _jsxRuntime$5 = require$$11;
const _excluded$z = ["className", "slots", "slotProps", "direction", "orientation", "disabled"];
function _getRequireWildcardCache$U(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$U = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$19(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$U(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$4 = ownerState => {
  const {
    classes,
    orientation,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', orientation, disabled && 'disabled']
  };
  return (0, _composeClasses$4.default)(slots, _tabScrollButtonClasses.getTabScrollButtonUtilityClass, classes);
};
const TabScrollButtonRoot = (0, _styled$4.default)(_ButtonBase$1.default, {
  name: 'MuiTabScrollButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.orientation && styles[ownerState.orientation]];
  }
})(({
  ownerState
}) => (0, _extends2$5.default)({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${_tabScrollButtonClasses.default.disabled}`]: {
    opacity: 0
  }
}, ownerState.orientation === 'vertical' && {
  width: '100%',
  height: 40,
  '& svg': {
    transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
  }
}));
const TabScrollButton = /*#__PURE__*/React$j.forwardRef(function TabScrollButton(inProps, ref) {
  var _slots$StartScrollBut, _slots$EndScrollButto;
  const props = (0, _DefaultPropsProvider$4.useDefaultProps)({
    props: inProps,
    name: 'MuiTabScrollButton'
  });
  const {
      className,
      slots = {},
      slotProps = {},
      direction
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$5.default)(props, _excluded$z);
  const isRtl = (0, _RtlProvider$1.useRtl)();
  const ownerState = (0, _extends2$5.default)({
    isRtl
  }, props);
  const classes = useUtilityClasses$4(ownerState);
  const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : _KeyboardArrowLeft.default;
  const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : _KeyboardArrowRight.default;
  const startButtonIconProps = (0, _useSlotProps$1.default)({
    elementType: StartButtonIcon,
    externalSlotProps: slotProps.startScrollButtonIcon,
    additionalProps: {
      fontSize: 'small'
    },
    ownerState
  });
  const endButtonIconProps = (0, _useSlotProps$1.default)({
    elementType: EndButtonIcon,
    externalSlotProps: slotProps.endScrollButtonIcon,
    additionalProps: {
      fontSize: 'small'
    },
    ownerState
  });
  return /*#__PURE__*/(0, _jsxRuntime$5.jsx)(TabScrollButtonRoot, (0, _extends2$5.default)({
    component: "div",
    className: (0, _clsx$F.default)(classes.root, className),
    ref: ref,
    role: null,
    ownerState: ownerState,
    tabIndex: null
  }, other, {
    children: direction === 'left' ? /*#__PURE__*/(0, _jsxRuntime$5.jsx)(StartButtonIcon, (0, _extends2$5.default)({}, startButtonIconProps)) : /*#__PURE__*/(0, _jsxRuntime$5.jsx)(EndButtonIcon, (0, _extends2$5.default)({}, endButtonIconProps))
  }));
});
process.env.NODE_ENV !== "production" ? TabScrollButton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$u.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$u.default.object,
  /**
   * @ignore
   */
  className: _propTypes$u.default.string,
  /**
   * The direction the button should indicate.
   */
  direction: _propTypes$u.default.oneOf(['left', 'right']).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$u.default.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: _propTypes$u.default.oneOf(['horizontal', 'vertical']).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: _propTypes$u.default.shape({
    endScrollButtonIcon: _propTypes$u.default.oneOfType([_propTypes$u.default.func, _propTypes$u.default.object]),
    startScrollButtonIcon: _propTypes$u.default.oneOfType([_propTypes$u.default.func, _propTypes$u.default.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: _propTypes$u.default.shape({
    EndScrollButtonIcon: _propTypes$u.default.elementType,
    StartScrollButtonIcon: _propTypes$u.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$u.default.oneOfType([_propTypes$u.default.arrayOf(_propTypes$u.default.oneOfType([_propTypes$u.default.func, _propTypes$u.default.object, _propTypes$u.default.bool])), _propTypes$u.default.func, _propTypes$u.default.object])
} : void 0;
TabScrollButton$1.default = TabScrollButton;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tabScrollButtonClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TabScrollButton.default;
  }
});
Object.defineProperty(exports, "tabScrollButtonClasses", {
  enumerable: true,
  get: function () {
    return _tabScrollButtonClasses.default;
  }
});
var _TabScrollButton = _interopRequireDefault(TabScrollButton$1);
var _tabScrollButtonClasses = _interopRequireWildcard(tabScrollButtonClasses$1);
Object.keys(_tabScrollButtonClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tabScrollButtonClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tabScrollButtonClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TabScrollButton$2));

var tabsClasses$1 = {};

var _interopRequireDefault$3y = interopRequireDefault$1.exports;
Object.defineProperty(tabsClasses$1, "__esModule", {
  value: true
});
tabsClasses$1.default = void 0;
tabsClasses$1.getTabsUtilityClass = getTabsUtilityClass;
var _generateUtilityClasses$3 = _interopRequireDefault$3y(generateUtilityClasses$3);
var _generateUtilityClass$3 = _interopRequireDefault$3y(generateUtilityClass$3);
function getTabsUtilityClass(slot) {
  return (0, _generateUtilityClass$3.default)('MuiTabs', slot);
}
const tabsClasses = (0, _generateUtilityClasses$3.default)('MuiTabs', ['root', 'vertical', 'flexContainer', 'flexContainerVertical', 'centered', 'scroller', 'fixed', 'scrollableX', 'scrollableY', 'hideScrollbar', 'scrollButtons', 'scrollButtonsHideMobile', 'indicator']);
tabsClasses$1.default = tabsClasses;

var _interopRequireDefault$3x = interopRequireDefault$1.exports;
Object.defineProperty(Tabs$1, "__esModule", {
  value: true
});
Tabs$1.default = void 0;
var _objectWithoutPropertiesLoose2$4 = _interopRequireDefault$3x(objectWithoutPropertiesLoose.exports);
var _extends2$4 = _interopRequireDefault$3x(_extends$19.exports);
var React$i = _interopRequireWildcard$18(React__default$4);
var _reactIs$2 = reactIs$6.exports;
var _propTypes$t = _interopRequireDefault$3x(propTypes.exports);
var _clsx$E = _interopRequireDefault$3x(clsx.exports);
var _refType$1 = _interopRequireDefault$3x(refType$2);
var _composeClasses$3 = _interopRequireDefault$3x(composeClasses$2);
var _RtlProvider = RtlProvider$1;
var _useSlotProps = _interopRequireDefault$3x(useSlotProps$2);
var _styled$3 = _interopRequireDefault$3x(styled$2);
var _DefaultPropsProvider$3 = DefaultPropsProvider$5;
var _useTheme = _interopRequireDefault$3x(useTheme$4);
var _debounce$1 = _interopRequireDefault$3x(debounce$3);
var _scrollLeft = scrollLeft;
var _animate = _interopRequireDefault$3x(animate$1);
var _ScrollbarSize = _interopRequireDefault$3x(ScrollbarSize$1);
var _TabScrollButton = _interopRequireDefault$3x(TabScrollButton$2);
var _useEventCallback = _interopRequireDefault$3x(useEventCallback);
var _tabsClasses = _interopRequireWildcard$18(tabsClasses$1);
var _ownerDocument = _interopRequireDefault$3x(ownerDocument);
var _ownerWindow = _interopRequireDefault$3x(ownerWindow);
var _jsxRuntime$4 = require$$11;
const _excluded$y = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"];
function _getRequireWildcardCache$T(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$T = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$18(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$T(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const nextItem = (list, item) => {
  if (list === item) {
    return list.firstChild;
  }
  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }
  return list.firstChild;
};
const previousItem = (list, item) => {
  if (list === item) {
    return list.lastChild;
  }
  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }
  return list.lastChild;
};
const moveFocus = (list, currentFocus, traversalFunction) => {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list, currentFocus);
  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }
      wrappedOnce = true;
    }

    // Same logic as useAutocomplete.js
    const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
    if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus);
    } else {
      nextFocus.focus();
      return;
    }
  }
};
const useUtilityClasses$3 = ownerState => {
  const {
    vertical,
    fixed,
    hideScrollbar,
    scrollableX,
    scrollableY,
    centered,
    scrollButtonsHideMobile,
    classes
  } = ownerState;
  const slots = {
    root: ['root', vertical && 'vertical'],
    scroller: ['scroller', fixed && 'fixed', hideScrollbar && 'hideScrollbar', scrollableX && 'scrollableX', scrollableY && 'scrollableY'],
    flexContainer: ['flexContainer', vertical && 'flexContainerVertical', centered && 'centered'],
    indicator: ['indicator'],
    scrollButtons: ['scrollButtons', scrollButtonsHideMobile && 'scrollButtonsHideMobile'],
    scrollableX: [scrollableX && 'scrollableX'],
    hideScrollbar: [hideScrollbar && 'hideScrollbar']
  };
  return (0, _composeClasses$3.default)(slots, _tabsClasses.getTabsUtilityClass, classes);
};
const TabsRoot = (0, _styled$3.default)('div', {
  name: 'MuiTabs',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_tabsClasses.default.scrollButtons}`]: styles.scrollButtons
    }, {
      [`& .${_tabsClasses.default.scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
    }, styles.root, ownerState.vertical && styles.vertical];
  }
})(({
  ownerState,
  theme
}) => (0, _extends2$4.default)({
  overflow: 'hidden',
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  display: 'flex'
}, ownerState.vertical && {
  flexDirection: 'column'
}, ownerState.scrollButtonsHideMobile && {
  [`& .${_tabsClasses.default.scrollButtons}`]: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}));
const TabsScroller = (0, _styled$3.default)('div', {
  name: 'MuiTabs',
  slot: 'Scroller',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.scroller, ownerState.fixed && styles.fixed, ownerState.hideScrollbar && styles.hideScrollbar, ownerState.scrollableX && styles.scrollableX, ownerState.scrollableY && styles.scrollableY];
  }
})(({
  ownerState
}) => (0, _extends2$4.default)({
  position: 'relative',
  display: 'inline-block',
  flex: '1 1 auto',
  whiteSpace: 'nowrap'
}, ownerState.fixed && {
  overflowX: 'hidden',
  width: '100%'
}, ownerState.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: 'none',
  // Firefox
  '&::-webkit-scrollbar': {
    display: 'none' // Safari + Chrome
  }
}, ownerState.scrollableX && {
  overflowX: 'auto',
  overflowY: 'hidden'
}, ownerState.scrollableY && {
  overflowY: 'auto',
  overflowX: 'hidden'
}));
const FlexContainer = (0, _styled$3.default)('div', {
  name: 'MuiTabs',
  slot: 'FlexContainer',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.flexContainer, ownerState.vertical && styles.flexContainerVertical, ownerState.centered && styles.centered];
  }
})(({
  ownerState
}) => (0, _extends2$4.default)({
  display: 'flex'
}, ownerState.vertical && {
  flexDirection: 'column'
}, ownerState.centered && {
  justifyContent: 'center'
}));
const TabsIndicator = (0, _styled$3.default)('span', {
  name: 'MuiTabs',
  slot: 'Indicator',
  overridesResolver: (props, styles) => styles.indicator
})(({
  ownerState,
  theme
}) => (0, _extends2$4.default)({
  position: 'absolute',
  height: 2,
  bottom: 0,
  width: '100%',
  transition: theme.transitions.create()
}, ownerState.indicatorColor === 'primary' && {
  backgroundColor: (theme.vars || theme).palette.primary.main
}, ownerState.indicatorColor === 'secondary' && {
  backgroundColor: (theme.vars || theme).palette.secondary.main
}, ownerState.vertical && {
  height: '100%',
  width: 2,
  right: 0
}));
const TabsScrollbarSize = (0, _styled$3.default)(_ScrollbarSize.default)({
  overflowX: 'auto',
  overflowY: 'hidden',
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: 'none',
  // Firefox
  '&::-webkit-scrollbar': {
    display: 'none' // Safari + Chrome
  }
});
const defaultIndicatorStyle = {};
let warnedOnceTabPresent = false;
const Tabs = /*#__PURE__*/React$i.forwardRef(function Tabs(inProps, ref) {
  const props = (0, _DefaultPropsProvider$3.useDefaultProps)({
    props: inProps,
    name: 'MuiTabs'
  });
  const theme = (0, _useTheme.default)();
  const isRtl = (0, _RtlProvider.useRtl)();
  const {
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      action,
      centered = false,
      children: childrenProp,
      className,
      component = 'div',
      allowScrollButtonsMobile = false,
      indicatorColor = 'primary',
      onChange,
      orientation = 'horizontal',
      ScrollButtonComponent = _TabScrollButton.default,
      scrollButtons = 'auto',
      selectionFollowsFocus,
      slots = {},
      slotProps = {},
      TabIndicatorProps = {},
      TabScrollButtonProps = {},
      textColor = 'primary',
      value,
      variant = 'standard',
      visibleScrollbar = false
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$4.default)(props, _excluded$y);
  const scrollable = variant === 'scrollable';
  const vertical = orientation === 'vertical';
  const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
  const start = vertical ? 'top' : 'left';
  const end = vertical ? 'bottom' : 'right';
  const clientSize = vertical ? 'clientHeight' : 'clientWidth';
  const size = vertical ? 'height' : 'width';
  const ownerState = (0, _extends2$4.default)({}, props, {
    component,
    allowScrollButtonsMobile,
    indicatorColor,
    orientation,
    vertical,
    scrollButtons,
    textColor,
    variant,
    visibleScrollbar,
    fixed: !scrollable,
    hideScrollbar: scrollable && !visibleScrollbar,
    scrollableX: scrollable && !vertical,
    scrollableY: scrollable && vertical,
    centered: centered && !scrollable,
    scrollButtonsHideMobile: !allowScrollButtonsMobile
  });
  const classes = useUtilityClasses$3(ownerState);
  const startScrollButtonIconProps = (0, _useSlotProps.default)({
    elementType: slots.StartScrollButtonIcon,
    externalSlotProps: slotProps.startScrollButtonIcon,
    ownerState
  });
  const endScrollButtonIconProps = (0, _useSlotProps.default)({
    elementType: slots.EndScrollButtonIcon,
    externalSlotProps: slotProps.endScrollButtonIcon,
    ownerState
  });
  if (process.env.NODE_ENV !== 'production') {
    if (centered && scrollable) {
      console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
    }
  }
  const [mounted, setMounted] = React$i.useState(false);
  const [indicatorStyle, setIndicatorStyle] = React$i.useState(defaultIndicatorStyle);
  const [displayStartScroll, setDisplayStartScroll] = React$i.useState(false);
  const [displayEndScroll, setDisplayEndScroll] = React$i.useState(false);
  const [updateScrollObserver, setUpdateScrollObserver] = React$i.useState(false);
  const [scrollerStyle, setScrollerStyle] = React$i.useState({
    overflow: 'hidden',
    scrollbarWidth: 0
  });
  const valueToIndex = new Map();
  const tabsRef = React$i.useRef(null);
  const tabListRef = React$i.useRef(null);
  const getTabsMeta = () => {
    const tabsNode = tabsRef.current;
    let tabsMeta;
    if (tabsNode) {
      const rect = tabsNode.getBoundingClientRect();
      // create a new object with ClientRect class props + scrollLeft
      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollTop: tabsNode.scrollTop,
        scrollLeftNormalized: (0, _scrollLeft.getNormalizedScrollLeft)(tabsNode, isRtl ? 'rtl' : 'ltr'),
        scrollWidth: tabsNode.scrollWidth,
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
    }
    let tabMeta;
    if (tabsNode && value !== false) {
      const children = tabListRef.current.children;
      if (children.length > 0) {
        const tab = children[valueToIndex.get(value)];
        if (process.env.NODE_ENV !== 'production') {
          if (!tab) {
            console.error([`MUI: The \`value\` provided to the Tabs component is invalid.`, `None of the Tabs' children match with "${value}".`, valueToIndex.keys ? `You can provide one of the following values: ${Array.from(valueToIndex.keys()).join(', ')}.` : null].join('\n'));
          }
        }
        tabMeta = tab ? tab.getBoundingClientRect() : null;
        if (process.env.NODE_ENV !== 'production') {
          if (process.env.NODE_ENV !== 'test' && !warnedOnceTabPresent && tabMeta && tabMeta.width === 0 && tabMeta.height === 0 &&
          // if the whole Tabs component is hidden, don't warn
          tabsMeta.clientWidth !== 0) {
            tabsMeta = null;
            console.error(['MUI: The `value` provided to the Tabs component is invalid.', `The Tab with this \`value\` ("${value}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join('\n'));
            warnedOnceTabPresent = true;
          }
        }
      }
    }
    return {
      tabsMeta,
      tabMeta
    };
  };
  const updateIndicatorState = (0, _useEventCallback.default)(() => {
    const {
      tabsMeta,
      tabMeta
    } = getTabsMeta();
    let startValue = 0;
    let startIndicator;
    if (vertical) {
      startIndicator = 'top';
      if (tabMeta && tabsMeta) {
        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
      }
    } else {
      startIndicator = isRtl ? 'right' : 'left';
      if (tabMeta && tabsMeta) {
        const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
      }
    }
    const newIndicatorStyle = {
      [startIndicator]: startValue,
      // May be wrong until the font is loaded.
      [size]: tabMeta ? tabMeta[size] : 0
    };

    // IE11 support, replace with Number.isNaN
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) {
      setIndicatorStyle(newIndicatorStyle);
    } else {
      const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
      const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
      if (dStart >= 1 || dSize >= 1) {
        setIndicatorStyle(newIndicatorStyle);
      }
    }
  });
  const scroll = (scrollValue, {
    animation = true
  } = {}) => {
    if (animation) {
      (0, _animate.default)(scrollStart, tabsRef.current, scrollValue, {
        duration: theme.transitions.duration.standard
      });
    } else {
      tabsRef.current[scrollStart] = scrollValue;
    }
  };
  const moveTabsScroll = delta => {
    let scrollValue = tabsRef.current[scrollStart];
    if (vertical) {
      scrollValue += delta;
    } else {
      scrollValue += delta * (isRtl ? -1 : 1);
      // Fix for Edge
      scrollValue *= isRtl && (0, _scrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
    }
    scroll(scrollValue);
  };
  const getScrollSize = () => {
    const containerSize = tabsRef.current[clientSize];
    let totalSize = 0;
    const children = Array.from(tabListRef.current.children);
    for (let i = 0; i < children.length; i += 1) {
      const tab = children[i];
      if (totalSize + tab[clientSize] > containerSize) {
        // If the first item is longer than the container size, then only scroll
        // by the container size.
        if (i === 0) {
          totalSize = containerSize;
        }
        break;
      }
      totalSize += tab[clientSize];
    }
    return totalSize;
  };
  const handleStartScrollClick = () => {
    moveTabsScroll(-1 * getScrollSize());
  };
  const handleEndScrollClick = () => {
    moveTabsScroll(getScrollSize());
  };

  // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
  // with CSS improves.
  const handleScrollbarSizeChange = React$i.useCallback(scrollbarWidth => {
    setScrollerStyle({
      overflow: null,
      scrollbarWidth
    });
  }, []);
  const getConditionalElements = () => {
    const conditionalElements = {};
    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/(0, _jsxRuntime$4.jsx)(TabsScrollbarSize, {
      onChange: handleScrollbarSizeChange,
      className: (0, _clsx$E.default)(classes.scrollableX, classes.hideScrollbar)
    }) : null;
    const scrollButtonsActive = displayStartScroll || displayEndScroll;
    const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/(0, _jsxRuntime$4.jsx)(ScrollButtonComponent, (0, _extends2$4.default)({
      slots: {
        StartScrollButtonIcon: slots.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: startScrollButtonIconProps
      },
      orientation: orientation,
      direction: isRtl ? 'right' : 'left',
      onClick: handleStartScrollClick,
      disabled: !displayStartScroll
    }, TabScrollButtonProps, {
      className: (0, _clsx$E.default)(classes.scrollButtons, TabScrollButtonProps.className)
    })) : null;
    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/(0, _jsxRuntime$4.jsx)(ScrollButtonComponent, (0, _extends2$4.default)({
      slots: {
        EndScrollButtonIcon: slots.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: endScrollButtonIconProps
      },
      orientation: orientation,
      direction: isRtl ? 'left' : 'right',
      onClick: handleEndScrollClick,
      disabled: !displayEndScroll
    }, TabScrollButtonProps, {
      className: (0, _clsx$E.default)(classes.scrollButtons, TabScrollButtonProps.className)
    })) : null;
    return conditionalElements;
  };
  const scrollSelectedIntoView = (0, _useEventCallback.default)(animation => {
    const {
      tabsMeta,
      tabMeta
    } = getTabsMeta();
    if (!tabMeta || !tabsMeta) {
      return;
    }
    if (tabMeta[start] < tabsMeta[start]) {
      // left side of button is out of view
      const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
      scroll(nextScrollStart, {
        animation
      });
    } else if (tabMeta[end] > tabsMeta[end]) {
      // right side of button is out of view
      const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
      scroll(nextScrollStart, {
        animation
      });
    }
  });
  const updateScrollButtonState = (0, _useEventCallback.default)(() => {
    if (scrollable && scrollButtons !== false) {
      setUpdateScrollObserver(!updateScrollObserver);
    }
  });
  React$i.useEffect(() => {
    const handleResize = (0, _debounce$1.default)(() => {
      // If the Tabs component is replaced by Suspense with a fallback, the last
      // ResizeObserver's handler that runs because of the change in the layout is trying to
      // access a dom node that is no longer there (as the fallback component is being shown instead).
      // See https://github.com/mui/material-ui/issues/33276
      // TODO: Add tests that will ensure the component is not failing when
      // replaced by Suspense with a fallback, once React is updated to version 18
      if (tabsRef.current) {
        updateIndicatorState();
      }
    });
    let resizeObserver;

    /**
     * @type {MutationCallback}
     */
    const handleMutation = records => {
      records.forEach(record => {
        record.removedNodes.forEach(item => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
        });
        record.addedNodes.forEach(item => {
          var _resizeObserver2;
          (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
        });
      });
      handleResize();
      updateScrollButtonState();
    };
    const win = (0, _ownerWindow.default)(tabsRef.current);
    win.addEventListener('resize', handleResize);
    let mutationObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(handleResize);
      Array.from(tabListRef.current.children).forEach(child => {
        resizeObserver.observe(child);
      });
    }
    if (typeof MutationObserver !== 'undefined') {
      mutationObserver = new MutationObserver(handleMutation);
      mutationObserver.observe(tabListRef.current, {
        childList: true
      });
    }
    return () => {
      var _mutationObserver, _resizeObserver3;
      handleResize.clear();
      win.removeEventListener('resize', handleResize);
      (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
      (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
    };
  }, [updateIndicatorState, updateScrollButtonState]);

  /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */
  React$i.useEffect(() => {
    const tabListChildren = Array.from(tabListRef.current.children);
    const length = tabListChildren.length;
    if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
      const firstTab = tabListChildren[0];
      const lastTab = tabListChildren[length - 1];
      const observerOptions = {
        root: tabsRef.current,
        threshold: 0.99
      };
      const handleScrollButtonStart = entries => {
        setDisplayStartScroll(!entries[0].isIntersecting);
      };
      const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
      firstObserver.observe(firstTab);
      const handleScrollButtonEnd = entries => {
        setDisplayEndScroll(!entries[0].isIntersecting);
      };
      const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
      lastObserver.observe(lastTab);
      return () => {
        firstObserver.disconnect();
        lastObserver.disconnect();
      };
    }
    return undefined;
  }, [scrollable, scrollButtons, updateScrollObserver, childrenProp == null ? void 0 : childrenProp.length]);
  React$i.useEffect(() => {
    setMounted(true);
  }, []);
  React$i.useEffect(() => {
    updateIndicatorState();
  });
  React$i.useEffect(() => {
    // Don't animate on the first render.
    scrollSelectedIntoView(defaultIndicatorStyle !== indicatorStyle);
  }, [scrollSelectedIntoView, indicatorStyle]);
  React$i.useImperativeHandle(action, () => ({
    updateIndicator: updateIndicatorState,
    updateScrollButtons: updateScrollButtonState
  }), [updateIndicatorState, updateScrollButtonState]);
  const indicator = /*#__PURE__*/(0, _jsxRuntime$4.jsx)(TabsIndicator, (0, _extends2$4.default)({}, TabIndicatorProps, {
    className: (0, _clsx$E.default)(classes.indicator, TabIndicatorProps.className),
    ownerState: ownerState,
    style: (0, _extends2$4.default)({}, indicatorStyle, TabIndicatorProps.style)
  }));
  let childIndex = 0;
  const children = React$i.Children.map(childrenProp, child => {
    if (! /*#__PURE__*/React$i.isValidElement(child)) {
      return null;
    }
    if (process.env.NODE_ENV !== 'production') {
      if ((0, _reactIs$2.isFragment)(child)) {
        console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }
    const childValue = child.props.value === undefined ? childIndex : child.props.value;
    valueToIndex.set(childValue, childIndex);
    const selected = childValue === value;
    childIndex += 1;
    return /*#__PURE__*/React$i.cloneElement(child, (0, _extends2$4.default)({
      fullWidth: variant === 'fullWidth',
      indicator: selected && !mounted && indicator,
      selected,
      selectionFollowsFocus,
      onChange,
      textColor,
      value: childValue
    }, childIndex === 1 && value === false && !child.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  });
  const handleKeyDown = event => {
    const list = tabListRef.current;
    const currentFocus = (0, _ownerDocument.default)(list).activeElement;
    // Keyboard navigation assumes that [role="tab"] are siblings
    // though we might warn in the future about nested, interactive elements
    // as a a11y violation
    const role = currentFocus.getAttribute('role');
    if (role !== 'tab') {
      return;
    }
    let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
    let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
    if (orientation === 'horizontal' && isRtl) {
      // swap previousItemKey with nextItemKey
      previousItemKey = 'ArrowRight';
      nextItemKey = 'ArrowLeft';
    }
    switch (event.key) {
      case previousItemKey:
        event.preventDefault();
        moveFocus(list, currentFocus, previousItem);
        break;
      case nextItemKey:
        event.preventDefault();
        moveFocus(list, currentFocus, nextItem);
        break;
      case 'Home':
        event.preventDefault();
        moveFocus(list, null, nextItem);
        break;
      case 'End':
        event.preventDefault();
        moveFocus(list, null, previousItem);
        break;
    }
  };
  const conditionalElements = getConditionalElements();
  return /*#__PURE__*/(0, _jsxRuntime$4.jsxs)(TabsRoot, (0, _extends2$4.default)({
    className: (0, _clsx$E.default)(classes.root, className),
    ownerState: ownerState,
    ref: ref,
    as: component
  }, other, {
    children: [conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/(0, _jsxRuntime$4.jsxs)(TabsScroller, {
      className: classes.scroller,
      ownerState: ownerState,
      style: {
        overflow: scrollerStyle.overflow,
        [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
      },
      ref: tabsRef,
      children: [/*#__PURE__*/(0, _jsxRuntime$4.jsx)(FlexContainer, {
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
        className: classes.flexContainer,
        ownerState: ownerState,
        onKeyDown: handleKeyDown,
        ref: tabListRef,
        role: "tablist",
        children: children
      }), mounted && indicator]
    }), conditionalElements.scrollButtonEnd]
  }));
});
process.env.NODE_ENV !== "production" ? Tabs.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _refType$1.default,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: _propTypes$t.default.bool,
  /**
   * The label for the Tabs as a string.
   */
  'aria-label': _propTypes$t.default.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  'aria-labelledby': _propTypes$t.default.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: _propTypes$t.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes$t.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$t.default.object,
  /**
   * @ignore
   */
  className: _propTypes$t.default.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: _propTypes$t.default.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: _propTypes$t.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$t.default.oneOf(['primary', 'secondary']), _propTypes$t.default.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: _propTypes$t.default.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: _propTypes$t.default.oneOf(['horizontal', 'vertical']),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: _propTypes$t.default.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: _propTypes$t.default /* @typescript-to-proptypes-ignore */.oneOf(['auto', false, true]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: _propTypes$t.default.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: _propTypes$t.default.shape({
    endScrollButtonIcon: _propTypes$t.default.oneOfType([_propTypes$t.default.func, _propTypes$t.default.object]),
    startScrollButtonIcon: _propTypes$t.default.oneOfType([_propTypes$t.default.func, _propTypes$t.default.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: _propTypes$t.default.shape({
    EndScrollButtonIcon: _propTypes$t.default.elementType,
    StartScrollButtonIcon: _propTypes$t.default.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$t.default.oneOfType([_propTypes$t.default.arrayOf(_propTypes$t.default.oneOfType([_propTypes$t.default.func, _propTypes$t.default.object, _propTypes$t.default.bool])), _propTypes$t.default.func, _propTypes$t.default.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: _propTypes$t.default.object,
  /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: _propTypes$t.default.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: _propTypes$t.default.oneOf(['inherit', 'primary', 'secondary']),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: _propTypes$t.default.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: _propTypes$t.default.oneOf(['fullWidth', 'scrollable', 'standard']),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: _propTypes$t.default.bool
} : void 0;
Tabs$1.default = Tabs;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  tabsClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Tabs.default;
  }
});
Object.defineProperty(exports, "tabsClasses", {
  enumerable: true,
  get: function () {
    return _tabsClasses.default;
  }
});
var _Tabs = _interopRequireDefault(Tabs$1);
var _tabsClasses = _interopRequireWildcard(tabsClasses$1);
Object.keys(_tabsClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _tabsClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tabsClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(Tabs$2));

var index$d = /*@__PURE__*/getDefaultExportFromCjs$1(Tabs$2);

var TextField$4 = {};

var TextField$3 = {};

var textFieldClasses$1 = {};

var _interopRequireDefault$3w = interopRequireDefault$1.exports;
Object.defineProperty(textFieldClasses$1, "__esModule", {
  value: true
});
textFieldClasses$1.default = void 0;
textFieldClasses$1.getTextFieldUtilityClass = getTextFieldUtilityClass;
var _generateUtilityClasses$2 = _interopRequireDefault$3w(generateUtilityClasses$3);
var _generateUtilityClass$2 = _interopRequireDefault$3w(generateUtilityClass$3);
function getTextFieldUtilityClass(slot) {
  return (0, _generateUtilityClass$2.default)('MuiTextField', slot);
}
const textFieldClasses = (0, _generateUtilityClasses$2.default)('MuiTextField', ['root']);
textFieldClasses$1.default = textFieldClasses;

var _interopRequireDefault$3v = interopRequireDefault$1.exports;
Object.defineProperty(TextField$3, "__esModule", {
  value: true
});
TextField$3.default = void 0;
var _extends2$3 = _interopRequireDefault$3v(_extends$19.exports);
var _objectWithoutPropertiesLoose2$3 = _interopRequireDefault$3v(objectWithoutPropertiesLoose.exports);
var React$h = _interopRequireWildcard$17(React__default$4);
var _propTypes$s = _interopRequireDefault$3v(propTypes.exports);
var _clsx$D = _interopRequireDefault$3v(clsx.exports);
var _composeClasses$2 = _interopRequireDefault$3v(composeClasses$2);
var _useId = _interopRequireDefault$3v(useId$3);
var _refType = _interopRequireDefault$3v(refType$2);
var _styled$2 = _interopRequireDefault$3v(styled$2);
var _DefaultPropsProvider$2 = DefaultPropsProvider$5;
var _Input$1 = _interopRequireDefault$3v(Input$7);
var _FilledInput = _interopRequireDefault$3v(FilledInput$2);
var _OutlinedInput = _interopRequireDefault$3v(OutlinedInput$3);
var _InputLabel = _interopRequireDefault$3v(InputLabel$4);
var _FormControl = _interopRequireDefault$3v(FormControl$3);
var _FormHelperText = _interopRequireDefault$3v(FormHelperText$2);
var _Select = _interopRequireDefault$3v(Select$4);
var _textFieldClasses = textFieldClasses$1;
var _jsxRuntime$3 = require$$11;
const _excluded$x = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"];
function _getRequireWildcardCache$S(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$S = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$17(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$S(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const variantComponent = {
  standard: _Input$1.default,
  filled: _FilledInput.default,
  outlined: _OutlinedInput.default
};
const useUtilityClasses$2 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0, _composeClasses$2.default)(slots, _textFieldClasses.getTextFieldUtilityClass, classes);
};
const TextFieldRoot = (0, _styled$2.default)(_FormControl.default, {
  name: 'MuiTextField',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});

/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */
const TextField$2 = /*#__PURE__*/React$h.forwardRef(function TextField(inProps, ref) {
  const props = (0, _DefaultPropsProvider$2.useDefaultProps)({
    props: inProps,
    name: 'MuiTextField'
  });
  const {
      autoComplete,
      autoFocus = false,
      children,
      className,
      color = 'primary',
      defaultValue,
      disabled = false,
      error = false,
      FormHelperTextProps,
      fullWidth = false,
      helperText,
      id: idOverride,
      InputLabelProps,
      inputProps,
      InputProps,
      inputRef,
      label,
      maxRows,
      minRows,
      multiline = false,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      required = false,
      rows,
      select = false,
      SelectProps,
      type,
      value,
      variant = 'outlined'
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$3.default)(props, _excluded$x);
  const ownerState = (0, _extends2$3.default)({}, props, {
    autoFocus,
    color,
    disabled,
    error,
    fullWidth,
    multiline,
    required,
    select,
    variant
  });
  const classes = useUtilityClasses$2(ownerState);
  if (process.env.NODE_ENV !== 'production') {
    if (select && !children) {
      console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }
  const InputMore = {};
  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }
    InputMore.label = label;
  }
  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }
    InputMore['aria-describedby'] = undefined;
  }
  const id = (0, _useId.default)(idOverride);
  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputLabelId = label && id ? `${id}-label` : undefined;
  const InputComponent = variantComponent[variant];
  const InputElement = /*#__PURE__*/(0, _jsxRuntime$3.jsx)(InputComponent, (0, _extends2$3.default)({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/(0, _jsxRuntime$3.jsxs)(TextFieldRoot, (0, _extends2$3.default)({
    className: (0, _clsx$D.default)(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    ref: ref,
    required: required,
    color: color,
    variant: variant,
    ownerState: ownerState
  }, other, {
    children: [label != null && label !== '' && /*#__PURE__*/(0, _jsxRuntime$3.jsx)(_InputLabel.default, (0, _extends2$3.default)({
      htmlFor: id,
      id: inputLabelId
    }, InputLabelProps, {
      children: label
    })), select ? /*#__PURE__*/(0, _jsxRuntime$3.jsx)(_Select.default, (0, _extends2$3.default)({
      "aria-describedby": helperTextId,
      id: id,
      labelId: inputLabelId,
      value: value,
      input: InputElement
    }, SelectProps, {
      children: children
    })) : InputElement, helperText && /*#__PURE__*/(0, _jsxRuntime$3.jsx)(_FormHelperText.default, (0, _extends2$3.default)({
      id: helperTextId
    }, FormHelperTextProps, {
      children: helperText
    }))]
  }));
});
process.env.NODE_ENV !== "production" ? TextField$2.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: _propTypes$s.default.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: _propTypes$s.default.bool,
  /**
   * @ignore
   */
  children: _propTypes$s.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$s.default.object,
  /**
   * @ignore
   */
  className: _propTypes$s.default.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: _propTypes$s.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$s.default.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$s.default.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: _propTypes$s.default.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$s.default.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: _propTypes$s.default.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: _propTypes$s.default.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$s.default.bool,
  /**
   * The helper text content.
   */
  helperText: _propTypes$s.default.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: _propTypes$s.default.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: _propTypes$s.default.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: _propTypes$s.default.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: _propTypes$s.default.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: _refType.default,
  /**
   * The label content.
   */
  label: _propTypes$s.default.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: _propTypes$s.default.oneOf(['dense', 'none', 'normal']),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: _propTypes$s.default.oneOfType([_propTypes$s.default.number, _propTypes$s.default.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: _propTypes$s.default.oneOfType([_propTypes$s.default.number, _propTypes$s.default.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: _propTypes$s.default.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: _propTypes$s.default.string,
  /**
   * @ignore
   */
  onBlur: _propTypes$s.default.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: _propTypes$s.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes$s.default.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: _propTypes$s.default.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: _propTypes$s.default.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: _propTypes$s.default.oneOfType([_propTypes$s.default.number, _propTypes$s.default.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: _propTypes$s.default.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: _propTypes$s.default.object,
  /**
   * The size of the component.
   */
  size: _propTypes$s.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$s.default.oneOf(['medium', 'small']), _propTypes$s.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$s.default.oneOfType([_propTypes$s.default.arrayOf(_propTypes$s.default.oneOfType([_propTypes$s.default.func, _propTypes$s.default.object, _propTypes$s.default.bool])), _propTypes$s.default.func, _propTypes$s.default.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: _propTypes$s.default /* @typescript-to-proptypes-ignore */.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: _propTypes$s.default.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: _propTypes$s.default.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
TextField$3.default = TextField$2;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  textFieldClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _TextField.default;
  }
});
Object.defineProperty(exports, "textFieldClasses", {
  enumerable: true,
  get: function () {
    return _textFieldClasses.default;
  }
});
var _TextField = _interopRequireDefault(TextField$3);
var _textFieldClasses = _interopRequireWildcard(textFieldClasses$1);
Object.keys(_textFieldClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _textFieldClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _textFieldClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(TextField$4));

var TextField$1 = /*@__PURE__*/getDefaultExportFromCjs$1(TextField$4);

var ToggleButton$2 = {};

var ToggleButton$1 = {};

var toggleButtonClasses$1 = {};

var _interopRequireDefault$3u = interopRequireDefault$1.exports;
Object.defineProperty(toggleButtonClasses$1, "__esModule", {
  value: true
});
toggleButtonClasses$1.default = void 0;
toggleButtonClasses$1.getToggleButtonUtilityClass = getToggleButtonUtilityClass;
var _generateUtilityClasses$1 = _interopRequireDefault$3u(generateUtilityClasses$3);
var _generateUtilityClass$1 = _interopRequireDefault$3u(generateUtilityClass$3);
function getToggleButtonUtilityClass(slot) {
  return (0, _generateUtilityClass$1.default)('MuiToggleButton', slot);
}
const toggleButtonClasses = (0, _generateUtilityClasses$1.default)('MuiToggleButton', ['root', 'disabled', 'selected', 'standard', 'primary', 'secondary', 'sizeSmall', 'sizeMedium', 'sizeLarge', 'fullWidth']);
toggleButtonClasses$1.default = toggleButtonClasses;

var ToggleButtonGroupContext$1 = {};

Object.defineProperty(ToggleButtonGroupContext$1, "__esModule", {
  value: true
});
ToggleButtonGroupContext$1.default = void 0;
var React$g = _interopRequireWildcard$16(React__default$4);
function _getRequireWildcardCache$R(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$R = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$16(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$R(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const ToggleButtonGroupContext = /*#__PURE__*/React$g.createContext({});
if (process.env.NODE_ENV !== 'production') {
  ToggleButtonGroupContext.displayName = 'ToggleButtonGroupContext';
}
ToggleButtonGroupContext$1.default = ToggleButtonGroupContext;

var ToggleButtonGroupButtonContext$1 = {};

Object.defineProperty(ToggleButtonGroupButtonContext$1, "__esModule", {
  value: true
});
ToggleButtonGroupButtonContext$1.default = void 0;
var React$f = _interopRequireWildcard$15(React__default$4);
function _getRequireWildcardCache$Q(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$Q = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$15(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$Q(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @ignore - internal component.
 */
const ToggleButtonGroupButtonContext = /*#__PURE__*/React$f.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  ToggleButtonGroupButtonContext.displayName = 'ToggleButtonGroupButtonContext';
}
ToggleButtonGroupButtonContext$1.default = ToggleButtonGroupButtonContext;

var isValueSelected$1 = {};

Object.defineProperty(isValueSelected$1, "__esModule", {
  value: true
});
isValueSelected$1.default = isValueSelected;
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function isValueSelected(value, candidate) {
  if (candidate === undefined || value === undefined) {
    return false;
  }
  if (Array.isArray(candidate)) {
    return candidate.indexOf(value) >= 0;
  }
  return value === candidate;
}

// @inheritedComponent ButtonBase
var _interopRequireDefault$3t = interopRequireDefault$1.exports;
Object.defineProperty(ToggleButton$1, "__esModule", {
  value: true
});
ToggleButton$1.default = void 0;
var _objectWithoutPropertiesLoose2$2 = _interopRequireDefault$3t(objectWithoutPropertiesLoose.exports);
var _extends2$2 = _interopRequireDefault$3t(_extends$19.exports);
var React$e = _interopRequireWildcard$14(React__default$4);
var _propTypes$r = _interopRequireDefault$3t(propTypes.exports);
var _clsx$C = _interopRequireDefault$3t(clsx.exports);
var _resolveProps = _interopRequireDefault$3t(resolveProps$2);
var _composeClasses$1 = _interopRequireDefault$3t(composeClasses$2);
var _styles = styles$u;
var _ButtonBase = _interopRequireDefault$3t(ButtonBase$2);
var _capitalize$1 = _interopRequireDefault$3t(capitalize$1);
var _DefaultPropsProvider$1 = DefaultPropsProvider$5;
var _styled$1 = _interopRequireDefault$3t(styled$2);
var _toggleButtonClasses$1 = _interopRequireWildcard$14(toggleButtonClasses$1);
var _ToggleButtonGroupContext$1 = _interopRequireDefault$3t(ToggleButtonGroupContext$1);
var _ToggleButtonGroupButtonContext$1 = _interopRequireDefault$3t(ToggleButtonGroupButtonContext$1);
var _isValueSelected = _interopRequireDefault$3t(isValueSelected$1);
var _jsxRuntime$2 = require$$11;
const _excluded$w = ["value"],
  _excluded2$b = ["children", "className", "color", "disabled", "disableFocusRipple", "fullWidth", "onChange", "onClick", "selected", "size", "value"];
function _getRequireWildcardCache$P(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$P = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$14(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$P(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses$1 = ownerState => {
  const {
    classes,
    fullWidth,
    selected,
    disabled,
    size,
    color
  } = ownerState;
  const slots = {
    root: ['root', selected && 'selected', disabled && 'disabled', fullWidth && 'fullWidth', `size${(0, _capitalize$1.default)(size)}`, color]
  };
  return (0, _composeClasses$1.default)(slots, _toggleButtonClasses$1.getToggleButtonUtilityClass, classes);
};
const ToggleButtonRoot = (0, _styled$1.default)(_ButtonBase.default, {
  name: 'MuiToggleButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`size${(0, _capitalize$1.default)(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  let selectedColor = ownerState.color === 'standard' ? theme.palette.text.primary : theme.palette[ownerState.color].main;
  let selectedColorChannel;
  if (theme.vars) {
    selectedColor = ownerState.color === 'standard' ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
    selectedColorChannel = ownerState.color === 'standard' ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
  }
  return (0, _extends2$2.default)({}, theme.typography.button, {
    borderRadius: (theme.vars || theme).shape.borderRadius,
    padding: 11,
    border: `1px solid ${(theme.vars || theme).palette.divider}`,
    color: (theme.vars || theme).palette.action.active
  }, ownerState.fullWidth && {
    width: '100%'
  }, {
    [`&.${_toggleButtonClasses$1.default.disabled}`]: {
      color: (theme.vars || theme).palette.action.disabled,
      border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
    },
    '&:hover': {
      textDecoration: 'none',
      // Reset on mouse devices
      backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    [`&.${_toggleButtonClasses$1.default.selected}`]: {
      color: selectedColor,
      backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _styles.alpha)(selectedColor, theme.palette.action.selectedOpacity),
      '&:hover': {
        backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _styles.alpha)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _styles.alpha)(selectedColor, theme.palette.action.selectedOpacity)
        }
      }
    }
  }, ownerState.size === 'small' && {
    padding: 7,
    fontSize: theme.typography.pxToRem(13)
  }, ownerState.size === 'large' && {
    padding: 15,
    fontSize: theme.typography.pxToRem(15)
  });
});
const ToggleButton = /*#__PURE__*/React$e.forwardRef(function ToggleButton(inProps, ref) {
  // props priority: `inProps` > `contextProps` > `themeDefaultProps`
  const _React$useContext = React$e.useContext(_ToggleButtonGroupContext$1.default),
    {
      value: contextValue
    } = _React$useContext,
    contextProps = (0, _objectWithoutPropertiesLoose2$2.default)(_React$useContext, _excluded$w);
  const toggleButtonGroupButtonContextPositionClassName = React$e.useContext(_ToggleButtonGroupButtonContext$1.default);
  const resolvedProps = (0, _resolveProps.default)((0, _extends2$2.default)({}, contextProps, {
    selected: (0, _isValueSelected.default)(inProps.value, contextValue)
  }), inProps);
  const props = (0, _DefaultPropsProvider$1.useDefaultProps)({
    props: resolvedProps,
    name: 'MuiToggleButton'
  });
  const {
      children,
      className,
      color = 'standard',
      disabled = false,
      disableFocusRipple = false,
      fullWidth = false,
      onChange,
      onClick,
      selected,
      size = 'medium',
      value
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$2.default)(props, _excluded2$b);
  const ownerState = (0, _extends2$2.default)({}, props, {
    color,
    disabled,
    disableFocusRipple,
    fullWidth,
    size
  });
  const classes = useUtilityClasses$1(ownerState);
  const handleChange = event => {
    if (onClick) {
      onClick(event, value);
      if (event.defaultPrevented) {
        return;
      }
    }
    if (onChange) {
      onChange(event, value);
    }
  };
  const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
  return /*#__PURE__*/(0, _jsxRuntime$2.jsx)(ToggleButtonRoot, (0, _extends2$2.default)({
    className: (0, _clsx$C.default)(contextProps.className, classes.root, className, positionClassName),
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    ref: ref,
    onClick: handleChange,
    onChange: onChange,
    value: value,
    ownerState: ownerState,
    "aria-pressed": selected
  }, other, {
    children: children
  }));
});
process.env.NODE_ENV !== "production" ? ToggleButton.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$r.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$r.default.object,
  /**
   * @ignore
   */
  className: _propTypes$r.default.string,
  /**
   * The color of the button when it is in an active state.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: _propTypes$r.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$r.default.oneOf(['standard', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$r.default.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: _propTypes$r.default.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: _propTypes$r.default.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: _propTypes$r.default.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$r.default.bool,
  /**
   * Callback fired when the state changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onChange: _propTypes$r.default.func,
  /**
   * Callback fired when the button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onClick: _propTypes$r.default.func,
  /**
   * If `true`, the button is rendered in an active state.
   */
  selected: _propTypes$r.default.bool,
  /**
   * The size of the component.
   * The prop defaults to the value inherited from the parent ToggleButtonGroup component.
   * @default 'medium'
   */
  size: _propTypes$r.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$r.default.oneOf(['small', 'medium', 'large']), _propTypes$r.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$r.default.oneOfType([_propTypes$r.default.arrayOf(_propTypes$r.default.oneOfType([_propTypes$r.default.func, _propTypes$r.default.object, _propTypes$r.default.bool])), _propTypes$r.default.func, _propTypes$r.default.object]),
  /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */
  value: _propTypes$r.default /* @typescript-to-proptypes-ignore */.any.isRequired
} : void 0;
ToggleButton$1.default = ToggleButton;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  toggleButtonClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ToggleButton.default;
  }
});
Object.defineProperty(exports, "toggleButtonClasses", {
  enumerable: true,
  get: function () {
    return _toggleButtonClasses.default;
  }
});
var _ToggleButton = _interopRequireDefault(ToggleButton$1);
var _toggleButtonClasses = _interopRequireWildcard(toggleButtonClasses$1);
Object.keys(_toggleButtonClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _toggleButtonClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _toggleButtonClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ToggleButton$2));

var ToggleButtonGroup$2 = {};

var ToggleButtonGroup$1 = {};

var toggleButtonGroupClasses$1 = {};

var _interopRequireDefault$3s = interopRequireDefault$1.exports;
Object.defineProperty(toggleButtonGroupClasses$1, "__esModule", {
  value: true
});
toggleButtonGroupClasses$1.default = void 0;
toggleButtonGroupClasses$1.getToggleButtonGroupUtilityClass = getToggleButtonGroupUtilityClass;
var _generateUtilityClasses = _interopRequireDefault$3s(generateUtilityClasses$3);
var _generateUtilityClass = _interopRequireDefault$3s(generateUtilityClass$3);
function getToggleButtonGroupUtilityClass(slot) {
  return (0, _generateUtilityClass.default)('MuiToggleButtonGroup', slot);
}
const toggleButtonGroupClasses = (0, _generateUtilityClasses.default)('MuiToggleButtonGroup', ['root', 'selected', 'horizontal', 'vertical', 'disabled', 'grouped', 'groupedHorizontal', 'groupedVertical', 'fullWidth', 'firstButton', 'lastButton', 'middleButton']);
toggleButtonGroupClasses$1.default = toggleButtonGroupClasses;

var _interopRequireDefault$3r = interopRequireDefault$1.exports;
Object.defineProperty(ToggleButtonGroup$1, "__esModule", {
  value: true
});
ToggleButtonGroup$1.default = void 0;
var _objectWithoutPropertiesLoose2$1 = _interopRequireDefault$3r(objectWithoutPropertiesLoose.exports);
var _extends2$1 = _interopRequireDefault$3r(_extends$19.exports);
var React$d = _interopRequireWildcard$13(React__default$4);
var _reactIs$1 = reactIs$6.exports;
var _propTypes$q = _interopRequireDefault$3r(propTypes.exports);
var _clsx$B = _interopRequireDefault$3r(clsx.exports);
var _composeClasses = _interopRequireDefault$3r(composeClasses$2);
var _getValidReactChildren = _interopRequireDefault$3r(getValidReactChildren$2);
var _styled = _interopRequireDefault$3r(styled$2);
var _DefaultPropsProvider = DefaultPropsProvider$5;
var _capitalize = _interopRequireDefault$3r(capitalize$1);
var _toggleButtonGroupClasses = _interopRequireWildcard$13(toggleButtonGroupClasses$1);
var _ToggleButtonGroupContext = _interopRequireDefault$3r(ToggleButtonGroupContext$1);
var _ToggleButtonGroupButtonContext = _interopRequireDefault$3r(ToggleButtonGroupButtonContext$1);
var _toggleButtonClasses = _interopRequireDefault$3r(toggleButtonClasses$1);
var _jsxRuntime$1 = require$$11;
const _excluded$v = ["children", "className", "color", "disabled", "exclusive", "fullWidth", "onChange", "orientation", "size", "value"];
function _getRequireWildcardCache$O(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$O = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$13(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$O(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useUtilityClasses = ownerState => {
  const {
    classes,
    orientation,
    fullWidth,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', orientation === 'vertical' && 'vertical', fullWidth && 'fullWidth'],
    grouped: ['grouped', `grouped${(0, _capitalize.default)(orientation)}`, disabled && 'disabled'],
    firstButton: ['firstButton'],
    lastButton: ['lastButton'],
    middleButton: ['middleButton']
  };
  return (0, _composeClasses.default)(slots, _toggleButtonGroupClasses.getToggleButtonGroupUtilityClass, classes);
};
const ToggleButtonGroupRoot = (0, _styled.default)('div', {
  name: 'MuiToggleButtonGroup',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${_toggleButtonGroupClasses.default.grouped}`]: styles.grouped
    }, {
      [`& .${_toggleButtonGroupClasses.default.grouped}`]: styles[`grouped${(0, _capitalize.default)(ownerState.orientation)}`]
    }, {
      [`& .${_toggleButtonGroupClasses.default.firstButton}`]: styles.firstButton
    }, {
      [`& .${_toggleButtonGroupClasses.default.lastButton}`]: styles.lastButton
    }, {
      [`& .${_toggleButtonGroupClasses.default.middleButton}`]: styles.middleButton
    }, styles.root, ownerState.orientation === 'vertical' && styles.vertical, ownerState.fullWidth && styles.fullWidth];
  }
})(({
  ownerState,
  theme
}) => (0, _extends2$1.default)({
  display: 'inline-flex',
  borderRadius: (theme.vars || theme).shape.borderRadius
}, ownerState.orientation === 'vertical' && {
  flexDirection: 'column'
}, ownerState.fullWidth && {
  width: '100%'
}, {
  [`& .${_toggleButtonGroupClasses.default.grouped}`]: (0, _extends2$1.default)({}, ownerState.orientation === 'horizontal' ? {
    [`&.${_toggleButtonGroupClasses.default.selected} + .${_toggleButtonGroupClasses.default.grouped}.${_toggleButtonGroupClasses.default.selected}`]: {
      borderLeft: 0,
      marginLeft: 0
    }
  } : {
    [`&.${_toggleButtonGroupClasses.default.selected} + .${_toggleButtonGroupClasses.default.grouped}.${_toggleButtonGroupClasses.default.selected}`]: {
      borderTop: 0,
      marginTop: 0
    }
  })
}, ownerState.orientation === 'horizontal' ? {
  [`& .${_toggleButtonGroupClasses.default.firstButton},& .${_toggleButtonGroupClasses.default.middleButton}`]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  [`& .${_toggleButtonGroupClasses.default.lastButton},& .${_toggleButtonGroupClasses.default.middleButton}`]: {
    marginLeft: -1,
    borderLeft: '1px solid transparent',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }
} : {
  [`& .${_toggleButtonGroupClasses.default.firstButton},& .${_toggleButtonGroupClasses.default.middleButton}`]: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  [`& .${_toggleButtonGroupClasses.default.lastButton},& .${_toggleButtonGroupClasses.default.middleButton}`]: {
    marginTop: -1,
    borderTop: '1px solid transparent',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0
  }
}, ownerState.orientation === 'horizontal' ? {
  [`& .${_toggleButtonGroupClasses.default.lastButton}.${_toggleButtonClasses.default.disabled},& .${_toggleButtonGroupClasses.default.middleButton}.${_toggleButtonClasses.default.disabled}`]: {
    borderLeft: '1px solid transparent'
  }
} : {
  [`& .${_toggleButtonGroupClasses.default.lastButton}.${_toggleButtonClasses.default.disabled},& .${_toggleButtonGroupClasses.default.middleButton}.${_toggleButtonClasses.default.disabled}`]: {
    borderTop: '1px solid transparent'
  }
}));
const ToggleButtonGroup = /*#__PURE__*/React$d.forwardRef(function ToggleButtonGroup(inProps, ref) {
  const props = (0, _DefaultPropsProvider.useDefaultProps)({
    props: inProps,
    name: 'MuiToggleButtonGroup'
  });
  const {
      children,
      className,
      color = 'standard',
      disabled = false,
      exclusive = false,
      fullWidth = false,
      onChange,
      orientation = 'horizontal',
      size = 'medium',
      value
    } = props,
    other = (0, _objectWithoutPropertiesLoose2$1.default)(props, _excluded$v);
  const ownerState = (0, _extends2$1.default)({}, props, {
    disabled,
    fullWidth,
    orientation,
    size
  });
  const classes = useUtilityClasses(ownerState);
  const handleChange = React$d.useCallback((event, buttonValue) => {
    if (!onChange) {
      return;
    }
    const index = value && value.indexOf(buttonValue);
    let newValue;
    if (value && index >= 0) {
      newValue = value.slice();
      newValue.splice(index, 1);
    } else {
      newValue = value ? value.concat(buttonValue) : [buttonValue];
    }
    onChange(event, newValue);
  }, [onChange, value]);
  const handleExclusiveChange = React$d.useCallback((event, buttonValue) => {
    if (!onChange) {
      return;
    }
    onChange(event, value === buttonValue ? null : buttonValue);
  }, [onChange, value]);
  const context = React$d.useMemo(() => ({
    className: classes.grouped,
    onChange: exclusive ? handleExclusiveChange : handleChange,
    value,
    size,
    fullWidth,
    color,
    disabled
  }), [classes.grouped, exclusive, handleExclusiveChange, handleChange, value, size, fullWidth, color, disabled]);
  const validChildren = (0, _getValidReactChildren.default)(children);
  const childrenCount = validChildren.length;
  const getButtonPositionClassName = index => {
    const isFirstButton = index === 0;
    const isLastButton = index === childrenCount - 1;
    if (isFirstButton && isLastButton) {
      return '';
    }
    if (isFirstButton) {
      return classes.firstButton;
    }
    if (isLastButton) {
      return classes.lastButton;
    }
    return classes.middleButton;
  };
  return /*#__PURE__*/(0, _jsxRuntime$1.jsx)(ToggleButtonGroupRoot, (0, _extends2$1.default)({
    role: "group",
    className: (0, _clsx$B.default)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0, _jsxRuntime$1.jsx)(_ToggleButtonGroupContext.default.Provider, {
      value: context,
      children: validChildren.map((child, index) => {
        if (process.env.NODE_ENV !== 'production') {
          if ((0, _reactIs$1.isFragment)(child)) {
            console.error(["MUI: The ToggleButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
          }
        }
        return /*#__PURE__*/(0, _jsxRuntime$1.jsx)(_ToggleButtonGroupButtonContext.default.Provider, {
          value: getButtonPositionClassName(index),
          children: child
        }, index);
      })
    })
  }));
});
process.env.NODE_ENV !== "production" ? ToggleButtonGroup.propTypes /* remove-proptypes */ = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: _propTypes$q.default.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes$q.default.object,
  /**
   * @ignore
   */
  className: _propTypes$q.default.string,
  /**
   * The color of the button when it is selected.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: _propTypes$q.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$q.default.oneOf(['standard', 'primary', 'secondary', 'error', 'info', 'success', 'warning']), _propTypes$q.default.string]),
  /**
   * If `true`, the component is disabled. This implies that all ToggleButton children will be disabled.
   * @default false
   */
  disabled: _propTypes$q.default.bool,
  /**
   * If `true`, only allow one of the child ToggleButton values to be selected.
   * @default false
   */
  exclusive: _propTypes$q.default.bool,
  /**
   * If `true`, the button group will take up the full width of its container.
   * @default false
   */
  fullWidth: _propTypes$q.default.bool,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected buttons. When `exclusive` is true
   * this is a single value; when false an array of selected values. If no value
   * is selected and `exclusive` is true the value is null; when false an empty array.
   */
  onChange: _propTypes$q.default.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: _propTypes$q.default.oneOf(['horizontal', 'vertical']),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: _propTypes$q.default /* @typescript-to-proptypes-ignore */.oneOfType([_propTypes$q.default.oneOf(['small', 'medium', 'large']), _propTypes$q.default.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes$q.default.oneOfType([_propTypes$q.default.arrayOf(_propTypes$q.default.oneOfType([_propTypes$q.default.func, _propTypes$q.default.object, _propTypes$q.default.bool])), _propTypes$q.default.func, _propTypes$q.default.object]),
  /**
   * The currently selected value within the group or an array of selected
   * values when `exclusive` is false.
   *
   * The value must have reference equality with the option in order to be selected.
   */
  value: _propTypes$q.default.any
} : void 0;
ToggleButtonGroup$1.default = ToggleButtonGroup;

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  toggleButtonGroupClasses: true
};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ToggleButtonGroup.default;
  }
});
Object.defineProperty(exports, "toggleButtonGroupClasses", {
  enumerable: true,
  get: function () {
    return _toggleButtonGroupClasses.default;
  }
});
var _ToggleButtonGroup = _interopRequireDefault(ToggleButtonGroup$1);
var _toggleButtonGroupClasses = _interopRequireWildcard(toggleButtonGroupClasses$1);
Object.keys(_toggleButtonGroupClasses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _toggleButtonGroupClasses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _toggleButtonGroupClasses[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(ToggleButtonGroup$2));

var useScrollTrigger$2 = {};

var useScrollTrigger$1 = {};

var _interopRequireDefault$3q = interopRequireDefault$1.exports;
Object.defineProperty(useScrollTrigger$1, "__esModule", {
  value: true
});
useScrollTrigger$1.default = useScrollTrigger;
var _extends2 = _interopRequireDefault$3q(_extends$19.exports);
var _objectWithoutPropertiesLoose2 = _interopRequireDefault$3q(objectWithoutPropertiesLoose.exports);
var React$c = _interopRequireWildcard$12(React__default$4);
const _excluded$u = ["getTrigger", "target"];
function _getRequireWildcardCache$N(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$N = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard$12(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$N(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function defaultTrigger(store, options) {
  const {
    disableHysteresis = false,
    threshold = 100,
    target
  } = options;
  const previous = store.current;
  if (target) {
    // Get vertical scroll
    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
  }
  if (!disableHysteresis && previous !== undefined) {
    if (store.current < previous) {
      return false;
    }
  }
  return store.current > threshold;
}
const defaultTarget = typeof window !== 'undefined' ? window : null;
function useScrollTrigger(options = {}) {
  const {
      getTrigger = defaultTrigger,
      target = defaultTarget
    } = options,
    other = (0, _objectWithoutPropertiesLoose2.default)(options, _excluded$u);
  const store = React$c.useRef();
  const [trigger, setTrigger] = React$c.useState(() => getTrigger(store, other));
  React$c.useEffect(() => {
    const handleScroll = () => {
      setTrigger(getTrigger(store, (0, _extends2.default)({
        target
      }, other)));
    };
    handleScroll(); // Re-evaluate trigger when dependencies change
    target.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      target.removeEventListener('scroll', handleScroll, {
        passive: true
      });
    };
    // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, getTrigger, JSON.stringify(other)]);
  return trigger;
}

(function (exports) {
'use client';

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _useScrollTrigger.default;
  }
});
var _useScrollTrigger = _interopRequireDefault(useScrollTrigger$1);
}(useScrollTrigger$2));

var generateUtilityClass = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _utils.unstable_generateUtilityClass;
  }
});
var _utils = utils$7;
}(generateUtilityClass));

var generateUtilityClasses = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _utils.unstable_generateUtilityClasses;
  }
});
var _utils = utils$7;
}(generateUtilityClasses));

var version$1 = {};

Object.defineProperty(version$1, "__esModule", {
  value: true
});
version$1.version = version$1.preReleaseNumber = version$1.preReleaseLabel = version$1.patch = version$1.minor = version$1.major = version$1.default = void 0;
const version = version$1.version = "5.16.14";
version$1.major = Number("5");
version$1.minor = Number("16");
version$1.patch = Number("14");
version$1.preReleaseLabel = null;
version$1.preReleaseNumber = Number(undefined) || null;
version$1.default = version;

/**
 * @mui/material v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  colors: true,
  Accordion: true,
  AccordionActions: true,
  AccordionDetails: true,
  AccordionSummary: true,
  Alert: true,
  AlertTitle: true,
  AppBar: true,
  Autocomplete: true,
  Avatar: true,
  AvatarGroup: true,
  Backdrop: true,
  Badge: true,
  BottomNavigation: true,
  BottomNavigationAction: true,
  Box: true,
  Breadcrumbs: true,
  Button: true,
  ButtonBase: true,
  ButtonGroup: true,
  Card: true,
  CardActionArea: true,
  CardActions: true,
  CardContent: true,
  CardHeader: true,
  CardMedia: true,
  Checkbox: true,
  Chip: true,
  CircularProgress: true,
  ClickAwayListener: true,
  Collapse: true,
  Container: true,
  CssBaseline: true,
  darkScrollbar: true,
  Dialog: true,
  DialogActions: true,
  DialogContent: true,
  DialogContentText: true,
  DialogTitle: true,
  Divider: true,
  Drawer: true,
  Fab: true,
  Fade: true,
  FilledInput: true,
  FormControl: true,
  FormControlLabel: true,
  FormGroup: true,
  FormHelperText: true,
  FormLabel: true,
  Grid: true,
  Unstable_Grid2: true,
  Grow: true,
  Hidden: true,
  Icon: true,
  IconButton: true,
  ImageList: true,
  ImageListItem: true,
  ImageListItemBar: true,
  Input: true,
  InputAdornment: true,
  InputBase: true,
  InputLabel: true,
  LinearProgress: true,
  Link: true,
  List: true,
  ListItem: true,
  ListItemAvatar: true,
  ListItemButton: true,
  ListItemIcon: true,
  ListItemSecondaryAction: true,
  ListItemText: true,
  ListSubheader: true,
  Menu: true,
  MenuItem: true,
  MenuList: true,
  MobileStepper: true,
  Modal: true,
  NativeSelect: true,
  NoSsr: true,
  OutlinedInput: true,
  Pagination: true,
  PaginationItem: true,
  Paper: true,
  Popover: true,
  Popper: true,
  Portal: true,
  Radio: true,
  RadioGroup: true,
  Rating: true,
  ScopedCssBaseline: true,
  Select: true,
  Skeleton: true,
  Slide: true,
  Slider: true,
  Snackbar: true,
  SnackbarContent: true,
  SpeedDial: true,
  SpeedDialAction: true,
  SpeedDialIcon: true,
  Stack: true,
  Step: true,
  StepButton: true,
  StepConnector: true,
  StepContent: true,
  StepIcon: true,
  StepLabel: true,
  Stepper: true,
  SvgIcon: true,
  SwipeableDrawer: true,
  Switch: true,
  Tab: true,
  Table: true,
  TableBody: true,
  TableCell: true,
  TableContainer: true,
  TableFooter: true,
  TableHead: true,
  TablePagination: true,
  TableRow: true,
  TableSortLabel: true,
  Tabs: true,
  TabScrollButton: true,
  TextField: true,
  TextareaAutosize: true,
  ToggleButton: true,
  ToggleButtonGroup: true,
  Toolbar: true,
  Tooltip: true,
  Typography: true,
  useMediaQuery: true,
  usePagination: true,
  useScrollTrigger: true,
  Zoom: true,
  useAutocomplete: true,
  GlobalStyles: true,
  unstable_composeClasses: true,
  generateUtilityClass: true,
  generateUtilityClasses: true,
  Unstable_TrapFocus: true
};
Object.defineProperty(exports, "Accordion", {
  enumerable: true,
  get: function () {
    return _Accordion.default;
  }
});
Object.defineProperty(exports, "AccordionActions", {
  enumerable: true,
  get: function () {
    return _AccordionActions.default;
  }
});
Object.defineProperty(exports, "AccordionDetails", {
  enumerable: true,
  get: function () {
    return _AccordionDetails.default;
  }
});
Object.defineProperty(exports, "AccordionSummary", {
  enumerable: true,
  get: function () {
    return _AccordionSummary.default;
  }
});
Object.defineProperty(exports, "Alert", {
  enumerable: true,
  get: function () {
    return _Alert.default;
  }
});
Object.defineProperty(exports, "AlertTitle", {
  enumerable: true,
  get: function () {
    return _AlertTitle.default;
  }
});
Object.defineProperty(exports, "AppBar", {
  enumerable: true,
  get: function () {
    return _AppBar.default;
  }
});
Object.defineProperty(exports, "Autocomplete", {
  enumerable: true,
  get: function () {
    return _Autocomplete.default;
  }
});
Object.defineProperty(exports, "Avatar", {
  enumerable: true,
  get: function () {
    return _Avatar.default;
  }
});
Object.defineProperty(exports, "AvatarGroup", {
  enumerable: true,
  get: function () {
    return _AvatarGroup.default;
  }
});
Object.defineProperty(exports, "Backdrop", {
  enumerable: true,
  get: function () {
    return _Backdrop.default;
  }
});
Object.defineProperty(exports, "Badge", {
  enumerable: true,
  get: function () {
    return _Badge.default;
  }
});
Object.defineProperty(exports, "BottomNavigation", {
  enumerable: true,
  get: function () {
    return _BottomNavigation.default;
  }
});
Object.defineProperty(exports, "BottomNavigationAction", {
  enumerable: true,
  get: function () {
    return _BottomNavigationAction.default;
  }
});
Object.defineProperty(exports, "Box", {
  enumerable: true,
  get: function () {
    return _Box.default;
  }
});
Object.defineProperty(exports, "Breadcrumbs", {
  enumerable: true,
  get: function () {
    return _Breadcrumbs.default;
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function () {
    return _Button.default;
  }
});
Object.defineProperty(exports, "ButtonBase", {
  enumerable: true,
  get: function () {
    return _ButtonBase.default;
  }
});
Object.defineProperty(exports, "ButtonGroup", {
  enumerable: true,
  get: function () {
    return _ButtonGroup.default;
  }
});
Object.defineProperty(exports, "Card", {
  enumerable: true,
  get: function () {
    return _Card.default;
  }
});
Object.defineProperty(exports, "CardActionArea", {
  enumerable: true,
  get: function () {
    return _CardActionArea.default;
  }
});
Object.defineProperty(exports, "CardActions", {
  enumerable: true,
  get: function () {
    return _CardActions.default;
  }
});
Object.defineProperty(exports, "CardContent", {
  enumerable: true,
  get: function () {
    return _CardContent.default;
  }
});
Object.defineProperty(exports, "CardHeader", {
  enumerable: true,
  get: function () {
    return _CardHeader.default;
  }
});
Object.defineProperty(exports, "CardMedia", {
  enumerable: true,
  get: function () {
    return _CardMedia.default;
  }
});
Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function () {
    return _Checkbox.default;
  }
});
Object.defineProperty(exports, "Chip", {
  enumerable: true,
  get: function () {
    return _Chip.default;
  }
});
Object.defineProperty(exports, "CircularProgress", {
  enumerable: true,
  get: function () {
    return _CircularProgress.default;
  }
});
Object.defineProperty(exports, "ClickAwayListener", {
  enumerable: true,
  get: function () {
    return _ClickAwayListener.default;
  }
});
Object.defineProperty(exports, "Collapse", {
  enumerable: true,
  get: function () {
    return _Collapse.default;
  }
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function () {
    return _Container.default;
  }
});
Object.defineProperty(exports, "CssBaseline", {
  enumerable: true,
  get: function () {
    return _CssBaseline.default;
  }
});
Object.defineProperty(exports, "Dialog", {
  enumerable: true,
  get: function () {
    return _Dialog.default;
  }
});
Object.defineProperty(exports, "DialogActions", {
  enumerable: true,
  get: function () {
    return _DialogActions.default;
  }
});
Object.defineProperty(exports, "DialogContent", {
  enumerable: true,
  get: function () {
    return _DialogContent.default;
  }
});
Object.defineProperty(exports, "DialogContentText", {
  enumerable: true,
  get: function () {
    return _DialogContentText.default;
  }
});
Object.defineProperty(exports, "DialogTitle", {
  enumerable: true,
  get: function () {
    return _DialogTitle.default;
  }
});
Object.defineProperty(exports, "Divider", {
  enumerable: true,
  get: function () {
    return _Divider.default;
  }
});
Object.defineProperty(exports, "Drawer", {
  enumerable: true,
  get: function () {
    return _Drawer.default;
  }
});
Object.defineProperty(exports, "Fab", {
  enumerable: true,
  get: function () {
    return _Fab.default;
  }
});
Object.defineProperty(exports, "Fade", {
  enumerable: true,
  get: function () {
    return _Fade.default;
  }
});
Object.defineProperty(exports, "FilledInput", {
  enumerable: true,
  get: function () {
    return _FilledInput.default;
  }
});
Object.defineProperty(exports, "FormControl", {
  enumerable: true,
  get: function () {
    return _FormControl.default;
  }
});
Object.defineProperty(exports, "FormControlLabel", {
  enumerable: true,
  get: function () {
    return _FormControlLabel.default;
  }
});
Object.defineProperty(exports, "FormGroup", {
  enumerable: true,
  get: function () {
    return _FormGroup.default;
  }
});
Object.defineProperty(exports, "FormHelperText", {
  enumerable: true,
  get: function () {
    return _FormHelperText.default;
  }
});
Object.defineProperty(exports, "FormLabel", {
  enumerable: true,
  get: function () {
    return _FormLabel.default;
  }
});
Object.defineProperty(exports, "GlobalStyles", {
  enumerable: true,
  get: function () {
    return _GlobalStyles.default;
  }
});
Object.defineProperty(exports, "Grid", {
  enumerable: true,
  get: function () {
    return _Grid.default;
  }
});
Object.defineProperty(exports, "Grow", {
  enumerable: true,
  get: function () {
    return _Grow.default;
  }
});
Object.defineProperty(exports, "Hidden", {
  enumerable: true,
  get: function () {
    return _Hidden.default;
  }
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function () {
    return _Icon.default;
  }
});
Object.defineProperty(exports, "IconButton", {
  enumerable: true,
  get: function () {
    return _IconButton.default;
  }
});
Object.defineProperty(exports, "ImageList", {
  enumerable: true,
  get: function () {
    return _ImageList.default;
  }
});
Object.defineProperty(exports, "ImageListItem", {
  enumerable: true,
  get: function () {
    return _ImageListItem.default;
  }
});
Object.defineProperty(exports, "ImageListItemBar", {
  enumerable: true,
  get: function () {
    return _ImageListItemBar.default;
  }
});
Object.defineProperty(exports, "Input", {
  enumerable: true,
  get: function () {
    return _Input.default;
  }
});
Object.defineProperty(exports, "InputAdornment", {
  enumerable: true,
  get: function () {
    return _InputAdornment.default;
  }
});
Object.defineProperty(exports, "InputBase", {
  enumerable: true,
  get: function () {
    return _InputBase.default;
  }
});
Object.defineProperty(exports, "InputLabel", {
  enumerable: true,
  get: function () {
    return _InputLabel.default;
  }
});
Object.defineProperty(exports, "LinearProgress", {
  enumerable: true,
  get: function () {
    return _LinearProgress.default;
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function () {
    return _Link.default;
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function () {
    return _List.default;
  }
});
Object.defineProperty(exports, "ListItem", {
  enumerable: true,
  get: function () {
    return _ListItem.default;
  }
});
Object.defineProperty(exports, "ListItemAvatar", {
  enumerable: true,
  get: function () {
    return _ListItemAvatar.default;
  }
});
Object.defineProperty(exports, "ListItemButton", {
  enumerable: true,
  get: function () {
    return _ListItemButton.default;
  }
});
Object.defineProperty(exports, "ListItemIcon", {
  enumerable: true,
  get: function () {
    return _ListItemIcon.default;
  }
});
Object.defineProperty(exports, "ListItemSecondaryAction", {
  enumerable: true,
  get: function () {
    return _ListItemSecondaryAction.default;
  }
});
Object.defineProperty(exports, "ListItemText", {
  enumerable: true,
  get: function () {
    return _ListItemText.default;
  }
});
Object.defineProperty(exports, "ListSubheader", {
  enumerable: true,
  get: function () {
    return _ListSubheader.default;
  }
});
Object.defineProperty(exports, "Menu", {
  enumerable: true,
  get: function () {
    return _Menu.default;
  }
});
Object.defineProperty(exports, "MenuItem", {
  enumerable: true,
  get: function () {
    return _MenuItem.default;
  }
});
Object.defineProperty(exports, "MenuList", {
  enumerable: true,
  get: function () {
    return _MenuList.default;
  }
});
Object.defineProperty(exports, "MobileStepper", {
  enumerable: true,
  get: function () {
    return _MobileStepper.default;
  }
});
Object.defineProperty(exports, "Modal", {
  enumerable: true,
  get: function () {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "NativeSelect", {
  enumerable: true,
  get: function () {
    return _NativeSelect.default;
  }
});
Object.defineProperty(exports, "NoSsr", {
  enumerable: true,
  get: function () {
    return _NoSsr.default;
  }
});
Object.defineProperty(exports, "OutlinedInput", {
  enumerable: true,
  get: function () {
    return _OutlinedInput.default;
  }
});
Object.defineProperty(exports, "Pagination", {
  enumerable: true,
  get: function () {
    return _Pagination.default;
  }
});
Object.defineProperty(exports, "PaginationItem", {
  enumerable: true,
  get: function () {
    return _PaginationItem.default;
  }
});
Object.defineProperty(exports, "Paper", {
  enumerable: true,
  get: function () {
    return _Paper.default;
  }
});
Object.defineProperty(exports, "Popover", {
  enumerable: true,
  get: function () {
    return _Popover.default;
  }
});
Object.defineProperty(exports, "Popper", {
  enumerable: true,
  get: function () {
    return _Popper.default;
  }
});
Object.defineProperty(exports, "Portal", {
  enumerable: true,
  get: function () {
    return _Portal.default;
  }
});
Object.defineProperty(exports, "Radio", {
  enumerable: true,
  get: function () {
    return _Radio.default;
  }
});
Object.defineProperty(exports, "RadioGroup", {
  enumerable: true,
  get: function () {
    return _RadioGroup.default;
  }
});
Object.defineProperty(exports, "Rating", {
  enumerable: true,
  get: function () {
    return _Rating.default;
  }
});
Object.defineProperty(exports, "ScopedCssBaseline", {
  enumerable: true,
  get: function () {
    return _ScopedCssBaseline.default;
  }
});
Object.defineProperty(exports, "Select", {
  enumerable: true,
  get: function () {
    return _Select.default;
  }
});
Object.defineProperty(exports, "Skeleton", {
  enumerable: true,
  get: function () {
    return _Skeleton.default;
  }
});
Object.defineProperty(exports, "Slide", {
  enumerable: true,
  get: function () {
    return _Slide.default;
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function () {
    return _Slider.default;
  }
});
Object.defineProperty(exports, "Snackbar", {
  enumerable: true,
  get: function () {
    return _Snackbar.default;
  }
});
Object.defineProperty(exports, "SnackbarContent", {
  enumerable: true,
  get: function () {
    return _SnackbarContent.default;
  }
});
Object.defineProperty(exports, "SpeedDial", {
  enumerable: true,
  get: function () {
    return _SpeedDial.default;
  }
});
Object.defineProperty(exports, "SpeedDialAction", {
  enumerable: true,
  get: function () {
    return _SpeedDialAction.default;
  }
});
Object.defineProperty(exports, "SpeedDialIcon", {
  enumerable: true,
  get: function () {
    return _SpeedDialIcon.default;
  }
});
Object.defineProperty(exports, "Stack", {
  enumerable: true,
  get: function () {
    return _Stack.default;
  }
});
Object.defineProperty(exports, "Step", {
  enumerable: true,
  get: function () {
    return _Step.default;
  }
});
Object.defineProperty(exports, "StepButton", {
  enumerable: true,
  get: function () {
    return _StepButton.default;
  }
});
Object.defineProperty(exports, "StepConnector", {
  enumerable: true,
  get: function () {
    return _StepConnector.default;
  }
});
Object.defineProperty(exports, "StepContent", {
  enumerable: true,
  get: function () {
    return _StepContent.default;
  }
});
Object.defineProperty(exports, "StepIcon", {
  enumerable: true,
  get: function () {
    return _StepIcon.default;
  }
});
Object.defineProperty(exports, "StepLabel", {
  enumerable: true,
  get: function () {
    return _StepLabel.default;
  }
});
Object.defineProperty(exports, "Stepper", {
  enumerable: true,
  get: function () {
    return _Stepper.default;
  }
});
Object.defineProperty(exports, "SvgIcon", {
  enumerable: true,
  get: function () {
    return _SvgIcon.default;
  }
});
Object.defineProperty(exports, "SwipeableDrawer", {
  enumerable: true,
  get: function () {
    return _SwipeableDrawer.default;
  }
});
Object.defineProperty(exports, "Switch", {
  enumerable: true,
  get: function () {
    return _Switch.default;
  }
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function () {
    return _Tab.default;
  }
});
Object.defineProperty(exports, "TabScrollButton", {
  enumerable: true,
  get: function () {
    return _TabScrollButton.default;
  }
});
Object.defineProperty(exports, "Table", {
  enumerable: true,
  get: function () {
    return _Table.default;
  }
});
Object.defineProperty(exports, "TableBody", {
  enumerable: true,
  get: function () {
    return _TableBody.default;
  }
});
Object.defineProperty(exports, "TableCell", {
  enumerable: true,
  get: function () {
    return _TableCell.default;
  }
});
Object.defineProperty(exports, "TableContainer", {
  enumerable: true,
  get: function () {
    return _TableContainer.default;
  }
});
Object.defineProperty(exports, "TableFooter", {
  enumerable: true,
  get: function () {
    return _TableFooter.default;
  }
});
Object.defineProperty(exports, "TableHead", {
  enumerable: true,
  get: function () {
    return _TableHead.default;
  }
});
Object.defineProperty(exports, "TablePagination", {
  enumerable: true,
  get: function () {
    return _TablePagination.default;
  }
});
Object.defineProperty(exports, "TableRow", {
  enumerable: true,
  get: function () {
    return _TableRow.default;
  }
});
Object.defineProperty(exports, "TableSortLabel", {
  enumerable: true,
  get: function () {
    return _TableSortLabel.default;
  }
});
Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function () {
    return _Tabs.default;
  }
});
Object.defineProperty(exports, "TextField", {
  enumerable: true,
  get: function () {
    return _TextField.default;
  }
});
Object.defineProperty(exports, "TextareaAutosize", {
  enumerable: true,
  get: function () {
    return _TextareaAutosize.default;
  }
});
Object.defineProperty(exports, "ToggleButton", {
  enumerable: true,
  get: function () {
    return _ToggleButton.default;
  }
});
Object.defineProperty(exports, "ToggleButtonGroup", {
  enumerable: true,
  get: function () {
    return _ToggleButtonGroup.default;
  }
});
Object.defineProperty(exports, "Toolbar", {
  enumerable: true,
  get: function () {
    return _Toolbar.default;
  }
});
Object.defineProperty(exports, "Tooltip", {
  enumerable: true,
  get: function () {
    return _Tooltip.default;
  }
});
Object.defineProperty(exports, "Typography", {
  enumerable: true,
  get: function () {
    return _Typography.default;
  }
});
Object.defineProperty(exports, "Unstable_Grid2", {
  enumerable: true,
  get: function () {
    return _Unstable_Grid.default;
  }
});
Object.defineProperty(exports, "Unstable_TrapFocus", {
  enumerable: true,
  get: function () {
    return _Unstable_TrapFocus.default;
  }
});
Object.defineProperty(exports, "Zoom", {
  enumerable: true,
  get: function () {
    return _Zoom.default;
  }
});
exports.colors = void 0;
Object.defineProperty(exports, "darkScrollbar", {
  enumerable: true,
  get: function () {
    return _darkScrollbar.default;
  }
});
Object.defineProperty(exports, "generateUtilityClass", {
  enumerable: true,
  get: function () {
    return _generateUtilityClass.default;
  }
});
Object.defineProperty(exports, "generateUtilityClasses", {
  enumerable: true,
  get: function () {
    return _generateUtilityClasses.default;
  }
});
Object.defineProperty(exports, "unstable_composeClasses", {
  enumerable: true,
  get: function () {
    return _utils2.unstable_composeClasses;
  }
});
Object.defineProperty(exports, "useAutocomplete", {
  enumerable: true,
  get: function () {
    return _useAutocomplete.default;
  }
});
Object.defineProperty(exports, "useMediaQuery", {
  enumerable: true,
  get: function () {
    return _useMediaQuery.default;
  }
});
Object.defineProperty(exports, "usePagination", {
  enumerable: true,
  get: function () {
    return _usePagination.default;
  }
});
Object.defineProperty(exports, "useScrollTrigger", {
  enumerable: true,
  get: function () {
    return _useScrollTrigger.default;
  }
});
var colors = _interopRequireWildcard(colors$1);
exports.colors = colors;
var _styles = styles$u;
Object.keys(_styles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _styles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _styles[key];
    }
  });
});
var _utils = utils$6;
Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _utils[key];
    }
  });
});
var _Accordion = _interopRequireWildcard(Accordion$3);
Object.keys(_Accordion).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Accordion[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Accordion[key];
    }
  });
});
var _AccordionActions = _interopRequireWildcard(AccordionActions$2);
Object.keys(_AccordionActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AccordionActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AccordionActions[key];
    }
  });
});
var _AccordionDetails = _interopRequireWildcard(AccordionDetails$3);
Object.keys(_AccordionDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AccordionDetails[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AccordionDetails[key];
    }
  });
});
var _AccordionSummary = _interopRequireWildcard(AccordionSummary$3);
Object.keys(_AccordionSummary).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AccordionSummary[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AccordionSummary[key];
    }
  });
});
var _Alert = _interopRequireWildcard(Alert$3);
Object.keys(_Alert).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Alert[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Alert[key];
    }
  });
});
var _AlertTitle = _interopRequireWildcard(AlertTitle$2);
Object.keys(_AlertTitle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AlertTitle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AlertTitle[key];
    }
  });
});
var _AppBar = _interopRequireWildcard(AppBar$2);
Object.keys(_AppBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AppBar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AppBar[key];
    }
  });
});
var _Autocomplete = _interopRequireWildcard(Autocomplete$1);
Object.keys(_Autocomplete).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Autocomplete[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Autocomplete[key];
    }
  });
});
var _Avatar = _interopRequireWildcard(Avatar$7);
Object.keys(_Avatar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Avatar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Avatar[key];
    }
  });
});
var _AvatarGroup = _interopRequireWildcard(AvatarGroup$2);
Object.keys(_AvatarGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AvatarGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AvatarGroup[key];
    }
  });
});
var _Backdrop = _interopRequireWildcard(Backdrop$2);
Object.keys(_Backdrop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Backdrop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Backdrop[key];
    }
  });
});
var _Badge = _interopRequireWildcard(Badge$2);
Object.keys(_Badge).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Badge[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Badge[key];
    }
  });
});
var _BottomNavigation = _interopRequireWildcard(BottomNavigation$2);
Object.keys(_BottomNavigation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _BottomNavigation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BottomNavigation[key];
    }
  });
});
var _BottomNavigationAction = _interopRequireWildcard(BottomNavigationAction$2);
Object.keys(_BottomNavigationAction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _BottomNavigationAction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BottomNavigationAction[key];
    }
  });
});
var _Box = _interopRequireWildcard(Box$3);
Object.keys(_Box).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Box[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Box[key];
    }
  });
});
var _Breadcrumbs = _interopRequireWildcard(Breadcrumbs$3);
Object.keys(_Breadcrumbs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Breadcrumbs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Breadcrumbs[key];
    }
  });
});
var _Button = _interopRequireWildcard(Button$3);
Object.keys(_Button).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Button[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Button[key];
    }
  });
});
var _ButtonBase = _interopRequireWildcard(ButtonBase$2);
Object.keys(_ButtonBase).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ButtonBase[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ButtonBase[key];
    }
  });
});
var _ButtonGroup = _interopRequireWildcard(ButtonGroup$3);
Object.keys(_ButtonGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ButtonGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ButtonGroup[key];
    }
  });
});
var _Card = _interopRequireWildcard(Card$4);
Object.keys(_Card).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Card[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Card[key];
    }
  });
});
var _CardActionArea = _interopRequireWildcard(CardActionArea$2);
Object.keys(_CardActionArea).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CardActionArea[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CardActionArea[key];
    }
  });
});
var _CardActions = _interopRequireWildcard(CardActions$3);
Object.keys(_CardActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CardActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CardActions[key];
    }
  });
});
var _CardContent = _interopRequireWildcard(CardContent$2);
Object.keys(_CardContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CardContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CardContent[key];
    }
  });
});
var _CardHeader = _interopRequireWildcard(CardHeader$2);
Object.keys(_CardHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CardHeader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CardHeader[key];
    }
  });
});
var _CardMedia = _interopRequireWildcard(CardMedia$2);
Object.keys(_CardMedia).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CardMedia[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CardMedia[key];
    }
  });
});
var _Checkbox = _interopRequireWildcard(Checkbox$3);
Object.keys(_Checkbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Checkbox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Checkbox[key];
    }
  });
});
var _Chip = _interopRequireWildcard(Chip$3);
Object.keys(_Chip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Chip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Chip[key];
    }
  });
});
var _CircularProgress = _interopRequireWildcard(CircularProgress$4);
Object.keys(_CircularProgress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CircularProgress[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CircularProgress[key];
    }
  });
});
var _ClickAwayListener = _interopRequireWildcard(ClickAwayListener$2);
Object.keys(_ClickAwayListener).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ClickAwayListener[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ClickAwayListener[key];
    }
  });
});
var _Collapse = _interopRequireWildcard(Collapse$2);
Object.keys(_Collapse).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Collapse[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Collapse[key];
    }
  });
});
var _Container = _interopRequireWildcard(Container$2);
Object.keys(_Container).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Container[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Container[key];
    }
  });
});
var _CssBaseline = _interopRequireWildcard(CssBaseline$2);
Object.keys(_CssBaseline).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CssBaseline[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CssBaseline[key];
    }
  });
});
var _darkScrollbar = _interopRequireWildcard(darkScrollbar$1);
Object.keys(_darkScrollbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _darkScrollbar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _darkScrollbar[key];
    }
  });
});
var _Dialog = _interopRequireWildcard(Dialog$4);
Object.keys(_Dialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Dialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Dialog[key];
    }
  });
});
var _DialogActions = _interopRequireWildcard(DialogActions$3);
Object.keys(_DialogActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DialogActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DialogActions[key];
    }
  });
});
var _DialogContent = _interopRequireWildcard(DialogContent$3);
Object.keys(_DialogContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DialogContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DialogContent[key];
    }
  });
});
var _DialogContentText = _interopRequireWildcard(DialogContentText$2);
Object.keys(_DialogContentText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DialogContentText[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DialogContentText[key];
    }
  });
});
var _DialogTitle = _interopRequireWildcard(DialogTitle$3);
Object.keys(_DialogTitle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DialogTitle[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DialogTitle[key];
    }
  });
});
var _Divider = _interopRequireWildcard(Divider$3);
Object.keys(_Divider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Divider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Divider[key];
    }
  });
});
var _Drawer = _interopRequireWildcard(Drawer$2);
Object.keys(_Drawer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Drawer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Drawer[key];
    }
  });
});
var _Fab = _interopRequireWildcard(Fab$2);
Object.keys(_Fab).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Fab[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Fab[key];
    }
  });
});
var _Fade = _interopRequireWildcard(Fade$2);
Object.keys(_Fade).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Fade[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Fade[key];
    }
  });
});
var _FilledInput = _interopRequireWildcard(FilledInput$2);
Object.keys(_FilledInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FilledInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FilledInput[key];
    }
  });
});
var _FormControl = _interopRequireWildcard(FormControl$3);
Object.keys(_FormControl).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormControl[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormControl[key];
    }
  });
});
var _FormControlLabel = _interopRequireWildcard(FormControlLabel$2);
Object.keys(_FormControlLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormControlLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormControlLabel[key];
    }
  });
});
var _FormGroup = _interopRequireWildcard(FormGroup$2);
Object.keys(_FormGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormGroup[key];
    }
  });
});
var _FormHelperText = _interopRequireWildcard(FormHelperText$2);
Object.keys(_FormHelperText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormHelperText[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormHelperText[key];
    }
  });
});
var _FormLabel = _interopRequireWildcard(FormLabel$3);
Object.keys(_FormLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FormLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormLabel[key];
    }
  });
});
var _Grid = _interopRequireWildcard(Grid$2);
Object.keys(_Grid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Grid[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Grid[key];
    }
  });
});
var _Unstable_Grid = _interopRequireWildcard(Unstable_Grid2);
Object.keys(_Unstable_Grid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Unstable_Grid[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Unstable_Grid[key];
    }
  });
});
var _Grow = _interopRequireWildcard(Grow$2);
Object.keys(_Grow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Grow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Grow[key];
    }
  });
});
var _Hidden = _interopRequireWildcard(Hidden$2);
Object.keys(_Hidden).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Hidden[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Hidden[key];
    }
  });
});
var _Icon = _interopRequireWildcard(Icon$4);
Object.keys(_Icon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Icon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Icon[key];
    }
  });
});
var _IconButton = _interopRequireWildcard(IconButton$4);
Object.keys(_IconButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _IconButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _IconButton[key];
    }
  });
});
var _ImageList = _interopRequireWildcard(ImageList$2);
Object.keys(_ImageList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ImageList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ImageList[key];
    }
  });
});
var _ImageListItem = _interopRequireWildcard(ImageListItem$2);
Object.keys(_ImageListItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ImageListItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ImageListItem[key];
    }
  });
});
var _ImageListItemBar = _interopRequireWildcard(ImageListItemBar$2);
Object.keys(_ImageListItemBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ImageListItemBar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ImageListItemBar[key];
    }
  });
});
var _Input = _interopRequireWildcard(Input$7);
Object.keys(_Input).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Input[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Input[key];
    }
  });
});
var _InputAdornment = _interopRequireWildcard(InputAdornment$4);
Object.keys(_InputAdornment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _InputAdornment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InputAdornment[key];
    }
  });
});
var _InputBase = _interopRequireWildcard(InputBase$3);
Object.keys(_InputBase).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _InputBase[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InputBase[key];
    }
  });
});
var _InputLabel = _interopRequireWildcard(InputLabel$4);
Object.keys(_InputLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _InputLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _InputLabel[key];
    }
  });
});
var _LinearProgress = _interopRequireWildcard(LinearProgress$2);
Object.keys(_LinearProgress).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _LinearProgress[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LinearProgress[key];
    }
  });
});
var _Link = _interopRequireWildcard(Link$3);
Object.keys(_Link).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Link[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Link[key];
    }
  });
});
var _List = _interopRequireWildcard(List$3);
Object.keys(_List).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _List[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _List[key];
    }
  });
});
var _ListItem = _interopRequireWildcard(ListItem$3);
Object.keys(_ListItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListItem[key];
    }
  });
});
var _ListItemAvatar = _interopRequireWildcard(ListItemAvatar$2);
Object.keys(_ListItemAvatar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListItemAvatar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListItemAvatar[key];
    }
  });
});
var _ListItemButton = _interopRequireWildcard(ListItemButton$2);
Object.keys(_ListItemButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListItemButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListItemButton[key];
    }
  });
});
var _ListItemIcon = _interopRequireWildcard(ListItemIcon$2);
Object.keys(_ListItemIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListItemIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListItemIcon[key];
    }
  });
});
var _ListItemSecondaryAction = _interopRequireWildcard(ListItemSecondaryAction$2);
Object.keys(_ListItemSecondaryAction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListItemSecondaryAction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListItemSecondaryAction[key];
    }
  });
});
var _ListItemText = _interopRequireWildcard(ListItemText$2);
Object.keys(_ListItemText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListItemText[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListItemText[key];
    }
  });
});
var _ListSubheader = _interopRequireWildcard(ListSubheader$2);
Object.keys(_ListSubheader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListSubheader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListSubheader[key];
    }
  });
});
var _Menu = _interopRequireWildcard(Menu$2);
Object.keys(_Menu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Menu[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Menu[key];
    }
  });
});
var _MenuItem = _interopRequireWildcard(MenuItem$3);
Object.keys(_MenuItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MenuItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MenuItem[key];
    }
  });
});
var _MenuList = _interopRequireWildcard(MenuList$2);
Object.keys(_MenuList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MenuList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MenuList[key];
    }
  });
});
var _MobileStepper = _interopRequireWildcard(MobileStepper$2);
Object.keys(_MobileStepper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MobileStepper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MobileStepper[key];
    }
  });
});
var _Modal = _interopRequireWildcard(Modal$2);
Object.keys(_Modal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Modal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Modal[key];
    }
  });
});
var _NativeSelect = _interopRequireWildcard(NativeSelect$2);
Object.keys(_NativeSelect).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NativeSelect[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NativeSelect[key];
    }
  });
});
var _NoSsr = _interopRequireWildcard(NoSsr$2);
Object.keys(_NoSsr).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NoSsr[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NoSsr[key];
    }
  });
});
var _OutlinedInput = _interopRequireWildcard(OutlinedInput$3);
Object.keys(_OutlinedInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _OutlinedInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OutlinedInput[key];
    }
  });
});
var _Pagination = _interopRequireWildcard(Pagination$2);
Object.keys(_Pagination).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Pagination[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Pagination[key];
    }
  });
});
var _PaginationItem = _interopRequireWildcard(PaginationItem$2);
Object.keys(_PaginationItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PaginationItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PaginationItem[key];
    }
  });
});
var _Paper = _interopRequireWildcard(Paper$3);
Object.keys(_Paper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Paper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Paper[key];
    }
  });
});
var _Popover = _interopRequireWildcard(Popover$2);
Object.keys(_Popover).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Popover[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Popover[key];
    }
  });
});
var _Popper = _interopRequireWildcard(Popper$3);
Object.keys(_Popper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Popper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Popper[key];
    }
  });
});
var _Portal = _interopRequireWildcard(Portal$2);
Object.keys(_Portal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Portal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Portal[key];
    }
  });
});
var _Radio = _interopRequireWildcard(Radio$2);
Object.keys(_Radio).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Radio[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Radio[key];
    }
  });
});
var _RadioGroup = _interopRequireWildcard(RadioGroup$2);
Object.keys(_RadioGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _RadioGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _RadioGroup[key];
    }
  });
});
var _Rating = _interopRequireWildcard(Rating$3);
Object.keys(_Rating).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Rating[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Rating[key];
    }
  });
});
var _ScopedCssBaseline = _interopRequireWildcard(ScopedCssBaseline$2);
Object.keys(_ScopedCssBaseline).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ScopedCssBaseline[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ScopedCssBaseline[key];
    }
  });
});
var _Select = _interopRequireWildcard(Select$4);
Object.keys(_Select).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Select[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Select[key];
    }
  });
});
var _Skeleton = _interopRequireWildcard(Skeleton$2);
Object.keys(_Skeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Skeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Skeleton[key];
    }
  });
});
var _Slide = _interopRequireWildcard(Slide$2);
Object.keys(_Slide).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Slide[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Slide[key];
    }
  });
});
var _Slider = _interopRequireWildcard(Slider$4);
Object.keys(_Slider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Slider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Slider[key];
    }
  });
});
var _Snackbar = _interopRequireWildcard(Snackbar$3);
Object.keys(_Snackbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Snackbar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Snackbar[key];
    }
  });
});
var _SnackbarContent = _interopRequireWildcard(SnackbarContent$2);
Object.keys(_SnackbarContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SnackbarContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SnackbarContent[key];
    }
  });
});
var _SpeedDial = _interopRequireWildcard(SpeedDial$2);
Object.keys(_SpeedDial).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SpeedDial[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SpeedDial[key];
    }
  });
});
var _SpeedDialAction = _interopRequireWildcard(SpeedDialAction$2);
Object.keys(_SpeedDialAction).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SpeedDialAction[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SpeedDialAction[key];
    }
  });
});
var _SpeedDialIcon = _interopRequireWildcard(SpeedDialIcon$2);
Object.keys(_SpeedDialIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SpeedDialIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SpeedDialIcon[key];
    }
  });
});
var _Stack = _interopRequireWildcard(Stack$7);
Object.keys(_Stack).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Stack[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Stack[key];
    }
  });
});
var _Step = _interopRequireWildcard(Step$4);
Object.keys(_Step).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Step[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Step[key];
    }
  });
});
var _StepButton = _interopRequireWildcard(StepButton$2);
Object.keys(_StepButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StepButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StepButton[key];
    }
  });
});
var _StepConnector = _interopRequireWildcard(StepConnector$2);
Object.keys(_StepConnector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StepConnector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StepConnector[key];
    }
  });
});
var _StepContent = _interopRequireWildcard(StepContent$2);
Object.keys(_StepContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StepContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StepContent[key];
    }
  });
});
var _StepIcon = _interopRequireWildcard(StepIcon$2);
Object.keys(_StepIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StepIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StepIcon[key];
    }
  });
});
var _StepLabel = _interopRequireWildcard(StepLabel$2);
Object.keys(_StepLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StepLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _StepLabel[key];
    }
  });
});
var _Stepper = _interopRequireWildcard(Stepper$3);
Object.keys(_Stepper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Stepper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Stepper[key];
    }
  });
});
var _SvgIcon = _interopRequireWildcard(SvgIcon$3);
Object.keys(_SvgIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SvgIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SvgIcon[key];
    }
  });
});
var _SwipeableDrawer = _interopRequireWildcard(SwipeableDrawer$2);
Object.keys(_SwipeableDrawer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SwipeableDrawer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SwipeableDrawer[key];
    }
  });
});
var _Switch = _interopRequireWildcard(Switch$3);
Object.keys(_Switch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Switch[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Switch[key];
    }
  });
});
var _Tab = _interopRequireWildcard(Tab$2);
Object.keys(_Tab).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Tab[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Tab[key];
    }
  });
});
var _Table = _interopRequireWildcard(Table$4);
Object.keys(_Table).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Table[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Table[key];
    }
  });
});
var _TableBody = _interopRequireWildcard(TableBody$4);
Object.keys(_TableBody).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TableBody[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TableBody[key];
    }
  });
});
var _TableCell = _interopRequireWildcard(TableCell$4);
Object.keys(_TableCell).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TableCell[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TableCell[key];
    }
  });
});
var _TableContainer = _interopRequireWildcard(TableContainer$4);
Object.keys(_TableContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TableContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TableContainer[key];
    }
  });
});
var _TableFooter = _interopRequireWildcard(TableFooter$2);
Object.keys(_TableFooter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TableFooter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TableFooter[key];
    }
  });
});
var _TableHead = _interopRequireWildcard(TableHead$4);
Object.keys(_TableHead).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TableHead[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TableHead[key];
    }
  });
});
var _TablePagination = _interopRequireWildcard(TablePagination$2);
Object.keys(_TablePagination).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TablePagination[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TablePagination[key];
    }
  });
});
var _TableRow = _interopRequireWildcard(TableRow$4);
Object.keys(_TableRow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TableRow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TableRow[key];
    }
  });
});
var _TableSortLabel = _interopRequireWildcard(TableSortLabel$2);
Object.keys(_TableSortLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TableSortLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TableSortLabel[key];
    }
  });
});
var _Tabs = _interopRequireWildcard(Tabs$2);
Object.keys(_Tabs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Tabs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Tabs[key];
    }
  });
});
var _TabScrollButton = _interopRequireWildcard(TabScrollButton$2);
Object.keys(_TabScrollButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TabScrollButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TabScrollButton[key];
    }
  });
});
var _TextField = _interopRequireWildcard(TextField$4);
Object.keys(_TextField).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TextField[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TextField[key];
    }
  });
});
var _TextareaAutosize = _interopRequireWildcard(TextareaAutosize$2);
Object.keys(_TextareaAutosize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TextareaAutosize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TextareaAutosize[key];
    }
  });
});
var _ToggleButton = _interopRequireWildcard(ToggleButton$2);
Object.keys(_ToggleButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ToggleButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ToggleButton[key];
    }
  });
});
var _ToggleButtonGroup = _interopRequireWildcard(ToggleButtonGroup$2);
Object.keys(_ToggleButtonGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ToggleButtonGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ToggleButtonGroup[key];
    }
  });
});
var _Toolbar = _interopRequireWildcard(Toolbar$2);
Object.keys(_Toolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Toolbar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Toolbar[key];
    }
  });
});
var _Tooltip = _interopRequireWildcard(Tooltip$4);
Object.keys(_Tooltip).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Tooltip[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Tooltip[key];
    }
  });
});
var _Typography = _interopRequireWildcard(Typography$3);
Object.keys(_Typography).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Typography[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Typography[key];
    }
  });
});
var _useMediaQuery = _interopRequireWildcard(useMediaQuery$1);
Object.keys(_useMediaQuery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useMediaQuery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useMediaQuery[key];
    }
  });
});
var _usePagination = _interopRequireWildcard(usePagination$2);
Object.keys(_usePagination).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _usePagination[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _usePagination[key];
    }
  });
});
var _useScrollTrigger = _interopRequireWildcard(useScrollTrigger$2);
Object.keys(_useScrollTrigger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useScrollTrigger[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useScrollTrigger[key];
    }
  });
});
var _Zoom = _interopRequireWildcard(Zoom$2);
Object.keys(_Zoom).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Zoom[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Zoom[key];
    }
  });
});
var _useAutocomplete = _interopRequireDefault(useAutocomplete$2);
var _GlobalStyles = _interopRequireWildcard(GlobalStyles$2);
Object.keys(_GlobalStyles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _GlobalStyles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GlobalStyles[key];
    }
  });
});
var _utils2 = utils$7;
var _generateUtilityClass = _interopRequireWildcard(generateUtilityClass);
Object.keys(_generateUtilityClass).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _generateUtilityClass[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _generateUtilityClass[key];
    }
  });
});
var _generateUtilityClasses = _interopRequireDefault(generateUtilityClasses);
var _Unstable_TrapFocus = _interopRequireDefault(Unstable_TrapFocus);
var _version = version$1;
Object.keys(_version).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _version[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _version[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
}(node));

var css_248z$1r = ".AddTextInput_wrap__EjfZN {\n  display: flex;\n  flex-direction: column;\n}\n\n.AddTextInput_input__zZ8R0 {\n  display: flex;\n  align-items: center;\n}\n.AddTextInput_input__zZ8R0 > div {\n  flex: 1 1 auto;\n}\n.AddTextInput_input__zZ8R0 > button {\n  flex: 0 0 auto;\n}";
var style$Z = {"wrap":"AddTextInput_wrap__EjfZN","input":"AddTextInput_input__zZ8R0"};
styleInject(css_248z$1r);

const StyledTextField$1 = styles$u.styled(node.TextField)({
    ' .MuiInput-underline:after': {
        borderBottomColor: '#677389',
        borderBottom: '3px solid #677389'
    },
    '&:hover .MuiInput-underline:before': {
        borderBottom: '3px solid #677389'
    },
    '& label.Mui-focused': {
        color: '#334561',
    },
    '& .MuiInput-underline:before': {
        borderBottom: "none"
    },
    '&:hover .MuiInput-underline:hover:before': {
        borderBottom: 'none',
    },
    ' .MuiInputBase-root': {
        paddingLeft: 5,
        borderRadius: 0,
    },
    '&.MuiTextField-root': {
        borderRadius: 0,
        background: "transparent"
    }
});
/**
 * Input to add text (strings) to a list of strings
 *
 * @param props
 */
const AddTextInput = ({ value, title, multiple, tooltip, addSuggestion, onTextAdded: onPhraseAdded }) => {
    const isEmptyishString = (stringToTest) => {
        // if the string is undefined
        if (typeof stringToTest === "undefined") {
            // consider it emptyish
            return true;
        }
        return stringToTest.replace(/\s/g, "").length === 0;
    };
    const splitByDelimiter = useCallback((text) => {
        if (isEmptyishString(text)) {
            return [];
        }
        return text
            .split(/[\r\n,]+/)
            .filter((utterance) => {
            if (!isEmptyishString(utterance)) {
                return !!utterance;
            }
            return false;
        })
            .map(utterance => {
            return utterance.trim();
        });
    }, []);
    const labelText = title ? title : "Add Phrase";
    const tooltipText = tooltip ? tooltip : "Tip: Press Enter to add phrase.";
    const [mutableValue, setMutableValue] = useState(value);
    const addUtterance = useCallback(() => {
        if (!isEmptyishString(addSuggestion ? value : mutableValue)) {
            const rawUtterances = addSuggestion ? value : mutableValue;
            const cleanedUtterances = multiple
                ? splitByDelimiter(rawUtterances).filter(utterance => typeof utterance === 'string')
                : [rawUtterances.trim()];
            setMutableValue("");
            onPhraseAdded(cleanedUtterances);
        }
    }, [addSuggestion, value, mutableValue, multiple, splitByDelimiter, onPhraseAdded]);
    const handleChange = useCallback((event) => {
        if (addSuggestion) {
            onPhraseAdded([event.target.value]);
        }
        else {
            setMutableValue(event.target.value);
        }
    }, [addSuggestion, onPhraseAdded]);
    const handleKeyPress = useCallback((event) => {
        if (event && event.hasOwnProperty("key") && event.key === "Enter") {
            event.preventDefault();
            addUtterance();
        }
    }, [addUtterance]);
    const renderDelimiterWarning = () => {
        if (!multiple) {
            return;
        }
        // Only render for commas as it might be unexpected
        if (addSuggestion ? value : mutableValue && addSuggestion ? value === null || value === void 0 ? void 0 : value.includes(",") : mutableValue === null || mutableValue === void 0 ? void 0 : mutableValue.includes(",")) {
            const utterancesArray = splitByDelimiter(addSuggestion ? value : mutableValue);
            return React__default$4.createElement(DelimiterWarning, { values: utterancesArray });
        }
        return React__default$4.createElement(React__default$4.Fragment, null);
    };
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement("div", { className: style$Z.wrap },
            React__default$4.createElement("div", { className: style$Z.input },
                React__default$4.createElement(Tooltip$5, { content: tooltipText },
                    React__default$4.createElement(StyledTextField$1, { multiline: true, label: labelText, onChange: handleChange, onKeyDown: handleKeyPress, value: addSuggestion ? value : mutableValue, className: "utterance-builder", variant: "standard", fullWidth: true })),
                React__default$4.createElement(IconButton_1$1, { disabled: isEmptyishString(addSuggestion ? value : mutableValue), icon: "add_circle_outline", onClick: addUtterance })),
            renderDelimiterWarning())));
};

const Alert = (_a) => {
    var { handleClose, open, text, severity = "info" } = _a, props = __rest$2(_a, ["handleClose", "open", "text", "severity"]);
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement(Snackbar, { open: open, autoHideDuration: 3000, onClose: handleClose, anchorOrigin: { vertical: 'top', horizontal: 'right' } },
            React__default$4.createElement(MuiAlert, Object.assign({}, props, { onClose: handleClose, severity: severity, sx: { width: '100%', backgroundColor: severity }, variant: "filled" }), text))));
};

var css_248z$1q = ".style_container__PxEvc {\n  position: relative;\n  width: 172px;\n  text-align: center;\n}\n\n.style_image__w1bQm {\n  position: absolute;\n  width: 149px;\n  z-index: 1;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 12px;\n  border-radius: 50%;\n}\n\n.style_frame__r2kjQ {\n  z-index: 2;\n  position: relative;\n}";
var style$Y = {"container":"style_container__PxEvc","image":"style_image__w1bQm","frame":"style_frame__r2kjQ"};
styleInject(css_248z$1q);

const AlexaAppIcon = ({ appIconURL }) => {
    return (React__default$4.createElement("div", { className: style$Y.container },
        React__default$4.createElement("img", { src: appIconURL, className: style$Y.image, alt: "application icon" }),
        React__default$4.createElement("svg", { width: "174", height: "210", viewBox: "0 0 174 210", xmlns: "http://www.w3.org/2000/svg", className: style$Y.frame },
            React__default$4.createElement("g", { id: "Page-1", fill: "none", fillRule: "evenodd" },
                React__default$4.createElement("path", { d: "M60.0214472,168.683321 C25.740402,157.36715 1,125.07279 1,87 C1,39.5035115 39.5035115,1 87,1 C134.496488,1 173,39.5035115 173,87 C173,104.509413 167.767364,120.796679 158.780544,134.383345 L159,134.256836 C139.777669,164.996745 110.115072,189.895571 70.012207,208.953314 C70.012207,209 70.012207,192.793457 70.012207,179.979004 C68.8423641,175.324503 65.5121116,171.559276 60.0214495,168.683322 Z M86.5,160 C127.092929,160 160,127.092929 160,86.5 C160,45.9070709 127.092929,13 86.5,13 C45.9070709,13 13,45.9070709 13,86.5 C13,127.092929 45.9070709,160 86.5,160 Z", id: "Combined-Shape", stroke: "#ACACAC", strokeWidth: "2", fill: "#EBEBEB" })))));
};

const Icon = (_a) => {
    var { iconName, value } = _a, props = __rest$2(_a, ["iconName", "value"]);
    return React__default$4.createElement(MuiIcon, Object.assign({}, props), iconName || value);
};
var Icon$1 = React__default$4.memo(Icon);

const style$X = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};
const AlexaIcon = () => {
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement("img", { style: style$X, src: "../Images/actions-on-google-logo.svg", alt: "Amazon Alexa Logo" }),
        React__default$4.createElement(SvgIcon, { style: style$X },
            React__default$4.createElement("svg", { width: "80px", height: "80px", viewBox: "0 0 80 80", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
                React__default$4.createElement("defs", null,
                    React__default$4.createElement("linearGradient", { x1: "0%", y1: "100%", x2: "100%", y2: "0%", id: "linearGradient-1" },
                        React__default$4.createElement("stop", { "stop-color": "#70222b", offset: "0%" }),
                        React__default$4.createElement("stop", { "stop-color": "#c9856b", offset: "100%" }))),
                React__default$4.createElement("g", { id: "Icon-Architecture/64/Arch_Amazon-Lex_64", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
                    React__default$4.createElement("g", { id: "Icon-Architecture-BG/64/Machine-Learning", fill: "url(#linearGradient-1)" },
                        React__default$4.createElement("rect", { id: "Rectangle", x: "0", y: "0", width: "80", height: "80" })),
                    React__default$4.createElement("path", { d: "M47.217,46.0740345 C47.217,46.4338378 47.359,46.772826 47.615,47.0265716 C48.129,47.5370363 49.025,47.5370363 49.538,47.0265716 C49.795,46.772826 49.937,46.4338378 49.937,46.0740345 C49.937,45.7142313 49.795,45.375243 49.538,45.1214975 C49.281,44.8667607 48.94,44.7260112 48.576,44.7260112 C48.213,44.7260112 47.872,44.8667607 47.615,45.1205063 C47.359,45.375243 47.217,45.7142313 47.217,46.0740345 L47.217,46.0740345 Z M46.201,48.4281194 C45.567,47.7997026 45.217,46.9631352 45.217,46.0740345 C45.217,45.1849339 45.567,44.3483664 46.201,43.7189585 C47.469,42.4611338 49.683,42.4611338 50.952,43.7199497 C51.587,44.3483664 51.937,45.1849339 51.937,46.0740345 C51.937,46.9631352 51.587,47.7997026 50.952,48.4291106 C50.318,49.0575274 49.474,49.4034539 48.576,49.4034539 C47.679,49.4034539 46.835,49.0575274 46.201,48.4281194 L46.201,48.4281194 Z M42.297,45.7697381 L42.704,48.3240441 L44.523,48.2497045 C44.809,48.2407838 45.073,48.3448591 45.272,48.5401243 L46.085,49.3489383 C46.282,49.5442034 46.388,49.8118257 46.376,50.0883687 L46.303,51.8943235 L48.879,52.2987305 L49.365,50.5780184 C49.442,50.3094049 49.629,50.0844039 49.882,49.9595136 L50.942,49.4351721 C51.189,49.3122641 51.477,49.2973962 51.736,49.3925508 L53.417,50.0100644 L54.602,47.7065304 L53.097,46.7133544 C52.866,46.5607106 52.709,46.3198506 52.664,46.0472723 L52.477,44.9073996 C52.432,44.632839 52.505,44.3523312 52.679,44.1332774 L53.807,42.7188441 L51.962,40.8910831 L50.538,42.0081583 C50.317,42.180626 50.038,42.2529831 49.755,42.2093706 L48.608,42.0230262 C48.334,41.9784225 48.092,41.8228051 47.938,41.5938394 L46.933,40.1011017 L44.609,41.2736838 L45.232,42.9378979 C45.328,43.1956082 45.313,43.481072 45.189,43.726888 L44.658,44.7755709 C44.531,45.0253517 44.306,45.2107049 44.034,45.2870268 L42.297,45.7697381 Z M40.868,49.5055469 L40.183,45.2087225 C40.103,44.7121345 40.411,44.2363616 40.9,44.0995768 L43.068,43.4959399 L43.205,43.2243529 L42.424,41.1359079 C42.247,40.6640997 42.455,40.1367847 42.907,39.907819 L46.818,37.9343525 C47.273,37.7063779 47.821,37.8491098 48.104,38.2673935 L49.361,40.1357935 L49.643,40.1823796 L51.418,38.7887614 C51.817,38.4755442 52.386,38.5082536 52.746,38.8650833 L55.85,41.9407571 C56.208,42.2956044 56.241,42.861576 55.928,43.2560711 L54.522,45.0194045 L54.569,45.3028859 L56.452,46.5458427 C56.874,46.8243681 57.019,47.3734894 56.788,47.8215089 L54.794,51.6960848 C54.564,52.1450955 54.031,52.3492814 53.556,52.1748313 L51.446,51.4007091 L51.172,51.5365026 L50.565,53.683428 C50.443,54.1165796 50.044,54.4069994 49.603,54.4069994 C49.551,54.4069994 49.498,54.4030346 49.446,54.395105 L45.112,53.714155 C44.611,53.6348595 44.248,53.1967519 44.269,52.6942168 L44.361,50.4412337 L44.166,50.2479509 L41.897,50.3411231 C41.442,50.3579734 40.947,50.0031261 40.868,49.5055469 L40.868,49.5055469 Z M65,35.8151805 L32,35.8062598 L32,56.6124052 L48,56.6213259 C48.515,56.6213259 48.965,56.8027143 49.379,57.1763943 L56,63.4536236 L56,58.6037132 C56,57.4182456 56.804,56.6213259 58,56.6213259 L64.991,56.6213259 L65,35.8151805 Z M67,35.8062598 L67,56.6213259 C67,57.788952 66.178,58.6037132 65,58.6037132 L58.009,58.6037132 L58,64.4259845 C58,65.0504365 57.63,65.6154169 57.057,65.8671801 C56.854,65.9563875 56.638,66 56.423,66 C56.039,66 55.66,65.8592505 55.364,65.5936106 L48.015,58.6255194 L32,58.6037132 C30.804,58.6037132 30,57.8067935 30,56.6213259 L30,35.8062598 C30,34.343258 30.524,33.8238725 32,33.8238725 L65,33.8238725 C66.179,33.8278373 67,34.6425985 67,35.8062598 L67,35.8062598 Z M36,30.8502916 L40,30.8502916 L40,28.8679044 L36,28.8679044 L36,30.8502916 Z M19,30.8502916 L34,30.8502916 L34,28.8679044 L19,28.8679044 L19,30.8502916 Z M32,25.8943235 L43,25.8943235 L43,23.9119363 L32,23.9119363 L32,25.8943235 Z M19,25.8943235 L28,25.8943235 L28,23.9119363 L19,23.9119363 L19,25.8943235 Z M39,20.9383554 L43,20.9383554 L43,18.9559681 L39,18.9559681 L39,20.9383554 Z M19,20.9383554 L37,20.9383554 L37,18.9559681 L19,18.9559681 L19,20.9383554 Z M27.276,37.1057146 L28.725,38.4725706 L22.703,44.7398879 C22.336,45.0659906 21.909,45.2285464 21.496,45.2285464 C21.28,45.2285464 21.069,45.1849339 20.87,45.0967176 C20.334,44.85784 20,44.3364721 20,43.7358088 L20,37.7965766 L16,37.788647 C14.822,37.788647 14,36.9738859 14,35.8062598 L14,15.9823873 C14,14.8147612 14.822,14 16,14 L46,14 C47.215,14 48,14.778087 48,15.9823873 L48,30.8502916 L46,30.8502916 L46,15.9823873 L16.008,15.9823873 L16,35.7983302 L20,35.8062598 C21.178,35.8062598 22,36.6210209 22,37.788647 L22,42.6018833 L27.276,37.1057146 Z", id: "Amazon-Lex-Icon_64_Squid", fill: "#FFFFFF" }))))));
};

const InitialIcon = props => {
    const defaultStyles = {
        borderRadius: "50%",
        fontSize: "15pt",
        lineHeight: "38px",
        margin: 0,
        textAlign: "center"
    };
    const myStyle = Object.assign({}, defaultStyles, props.style);
    return React__default$4.createElement("p", { style: myStyle }, getInitials(props.name));
};
function getInitials(name) {
    if (!name) {
        return "NA";
    }
    const split = name.split(" ");
    let returnName = "";
    if (split.length === 1) {
        // Retrieve the first and second letter of the name;
        const useName = split[0];
        returnName = useName.charAt(0);
        if (useName.length > 1) {
            returnName = returnName + useName.charAt(1);
        }
    }
    else {
        returnName = split[0].charAt(0) + split[split.length - 1].charAt(0);
    }
    return returnName.toUpperCase();
}

const defaultProps$5 = {
    color: "#e94949",
    size: "20px",
};
const style$W = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};
const ErrorIcon = (props) => {
    const mergedProps = Object.assign(Object.assign({}, defaultProps$5), props);
    const { size, color } = mergedProps;
    const outsideProps = {};
    if (size) {
        outsideProps.width = size;
        outsideProps.height = size;
    }
    return (React__default$4.createElement("span", { style: style$W },
        React__default$4.createElement("svg", Object.assign({}, outsideProps, { fill: color, xmlns: "http://www.w3.org/2000/svg", version: "1.1", x: "0px", y: "0px", viewBox: "0 0 96 96", style: { enableBackground: "new 0 0 96 96" } }),
            React__default$4.createElement("switch", null,
                React__default$4.createElement("foreignObject", { requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/", x: "0", y: "0", width: "1", height: "1" }),
                React__default$4.createElement("g", null,
                    React__default$4.createElement("g", null,
                        React__default$4.createElement("g", null,
                            React__default$4.createElement("path", { style: { fill: color }, d: "M48,4C23.7,4,4,23.7,4,48s19.7,44,44,44s44-19.7,44-44S72.3,4,48,4z M48,84c-19.9,0-36-16.1-36-36s16.1-36,36-36      s36,16.1,36,36S67.9,84,48,84z" }),
                            React__default$4.createElement("path", { style: {
                                    fill: color,
                                    stroke: color,
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: 10,
                                    strokeWidth: 6
                                }, d: "M48,57c2.2,0,4-1.8,4-4V30c0-2.2-1.8-4-4-4s-4,1.8-4,4v23C44,55.2,45.8,57,48,57z" }),
                            React__default$4.createElement("circle", { style: {
                                    fill: color,
                                    stroke: color,
                                    strokeLinejoin: "round",
                                    strokeMiterlimit: 10,
                                    strokeWidth: 4
                                }, cx: "48", cy: "66.3", r: "5" }))))))));
};

const defaultProps$4 = {
    color: "#00A6DE",
    size: "20px"
};
const style$V = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};
const CheckmarkIcon = props => {
    const mergedProps = Object.assign(Object.assign({}, defaultProps$4), props);
    const { size, color } = mergedProps;
    const outsideProps = {};
    if (size) {
        outsideProps.width = size;
        outsideProps.height = size;
    }
    return (React__default$4.createElement("span", { style: style$V },
        React__default$4.createElement("svg", Object.assign({}, outsideProps, { fill: color, version: "1.1", x: "0px", y: "0px", viewBox: "0 0 100 100" }),
            React__default$4.createElement("g", { transform: "translate(0,-952.36218)" },
                React__default$4.createElement("path", { fill: color, fillOpacity: "1", stroke: "none", visibility: "visible", display: "inline", overflow: "visible", style: {
                        baselineShift: "baseline",
                        color: "#000000",
                        direction: "ltr",
                        msBlockProgression: "tb",
                        textIndent: 0,
                        textTransform: "none"
                    }, d: "m 75.889252,977.3292 a 8.0008,8.0008 0 0 0 -5.5,2.4375 c -9.0282,9.04775 -19.3274,19.32305 -28.8126,28.8125 l -12.4062,-10.31245 a 8.0008,8.0008 0 1 0 -10.25,12.28115 l 18,15 a 8.0008,8.0008 0 0 0 10.7812,-0.5 c 10.6539,-10.6767 23.3205,-23.2973 34,-33.99995 a 8.0008,8.0008 0 0 0 -5.8124,-13.71875 z" })))));
};

const Avatar$4 = (_a) => {
    var { src, alt, children, userName } = _a, props = __rest$2(_a, ["src", "alt", "children", "userName"]);
    return (React__default$4.createElement(AvatarMui, Object.assign({}, props, { alt: alt, src: src }),
        userName,
        children,
        !src || !userName && React__default$4.createElement(Icon$1, { iconName: 'person' })));
};

const Link = props => {
    const { href, onClick } = props;
    const history = useHistory();
    const handleClick = useCallback((ev) => {
        if (onClick) {
            onClick(ev);
        }
        if (href === null || href === void 0 ? void 0 : href.startsWith("/")) {
            ev.preventDefault();
            history.push(href);
            return false;
        }
    }, [href, onClick, history]);
    return (React__default$4.createElement("a", { href: href, className: props.className, onClick: handleClick }, props.children));
};

var css_248z$1p = ".Breadcrumbs_list__-DKfW {\n  display: flex;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.Breadcrumbs_item__Q-uwQ {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n}\n.Breadcrumbs_item__Q-uwQ:not(:last-child)::after {\n  content: \">\";\n  margin: 0 8px;\n  color: var(--text-color, #000);\n}\n\n.Breadcrumbs_link__K7Nfu, .Breadcrumbs_link__K7Nfu:visited, .Breadcrumbs_link__K7Nfu:active, .Breadcrumbs_link__K7Nfu:link {\n  padding: 12px 0;\n}\n.Breadcrumbs_link__K7Nfu.Breadcrumbs_active__8abe-, .Breadcrumbs_link__K7Nfu:visited.Breadcrumbs_active__8abe-, .Breadcrumbs_link__K7Nfu:active.Breadcrumbs_active__8abe-, .Breadcrumbs_link__K7Nfu:link.Breadcrumbs_active__8abe- {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 14px;\n  line-height: 17px;\n  font-weight: 800;\n  color: var(--menubar-item-active-color, #3295d2);\n  text-decoration: underline;\n}\n.Breadcrumbs_link__K7Nfu.Breadcrumbs_inactive__Vsxk3, .Breadcrumbs_link__K7Nfu:visited.Breadcrumbs_inactive__Vsxk3, .Breadcrumbs_link__K7Nfu:active.Breadcrumbs_inactive__Vsxk3, .Breadcrumbs_link__K7Nfu:link.Breadcrumbs_inactive__Vsxk3 {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 14px;\n  line-height: 17px;\n  font-weight: 500;\n  color: var(--menubar-item-inactive-color, var(--text-color, #000));\n}";
var style$U = {"list":"Breadcrumbs_list__-DKfW","item":"Breadcrumbs_item__Q-uwQ","link":"Breadcrumbs_link__K7Nfu","active":"Breadcrumbs_active__8abe-","inactive":"Breadcrumbs_inactive__Vsxk3"};
styleInject(css_248z$1p);

const BreadcrumbsInner = props => {
    return (React__default$4.createElement("nav", null,
        React__default$4.createElement("ol", { className: style$U.list }, props.items.map((item, index) => React__default$4.createElement("li", { key: index, className: style$U.item },
            React__default$4.createElement(Link, { href: item.url, className: style$U.link + " " + (style$U.inactive) }, item.label))))));
};
const Breadcrumbs = React__default$4.memo(BreadcrumbsInner);

var css_248z$1o = ".MockBrowserForm-module_browserFrame__rB89j {\n  max-width: 48rem;\n  margin: auto;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.MockBrowserForm-module_topBar__Pxu-d {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n}\n@media (max-width: 768px) {\n  .MockBrowserForm-module_topBar__Pxu-d {\n    display: none;\n  }\n}\n\n.MockBrowserForm-module_flexRow__lFELv {\n  display: flex;\n  justify-content: space-between;\n}\n@media (max-width: 768px) {\n  .MockBrowserForm-module_flexRow__lFELv {\n    display: none;\n  }\n}\n\n.MockBrowserForm-module_macControls__LiDFX {\n  display: flex;\n  gap: 0.5rem;\n  padding-right: 4px;\n}\n\n.MockBrowserForm-module_macClose__kJLov,\n.MockBrowserForm-module_macMinimize__MePdu,\n.MockBrowserForm-module_macMaximize__Jn8LQ {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n}\n\n.MockBrowserForm-module_macClose__kJLov {\n  background-color: red;\n}\n\n.MockBrowserForm-module_macMinimize__MePdu {\n  background-color: yellow;\n}\n\n.MockBrowserForm-module_macMaximize__Jn8LQ {\n  background-color: green;\n}\n\n.MockBrowserForm-module_urlInput__njTcs {\n  flex-grow: 1;\n  padding: 0.3rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  color: lightslategray;\n}\n\n.MockBrowserForm-module_windowControls__xdl9d {\n  display: flex;\n  gap: 0.5rem;\n  color: white;\n}\n\n.MockBrowserForm-module_contentWrapper__K2qvn {\n  display: flex;\n  flex-direction: column;\n  min-height: 400px;\n}\n\n.MockBrowserForm-module_topBand__l2b7M {\n  display: flex;\n  align-items: center;\n  align-items: center;\n  justify-content: center;\n  padding: 0.5rem;\n}\n\n.MockBrowserForm-module_logo__Jrk-q {\n  height: 32px;\n  margin-right: 0.5rem;\n}\n\n.MockBrowserForm-module_businessName__33NHh {\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: white;\n}\n\n.MockBrowserForm-module_middleSection__vTwOg {\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.MockBrowserForm-module_fakeForm__JVMFB {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 80%;\n  max-width: 300px;\n}\n\n.MockBrowserForm-module_formTitle__Kh1-W {\n  font-size: 1.25rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  margin-top: 0rem;\n  margin-left: auto;\n}\n\n.MockBrowserForm-module_formDescription__oqLa5 {\n  font-size: 0.875rem;\n  color: #666;\n}\n\n.MockBrowserForm-module_formFields__i-yJp {\n  margin-top: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.MockBrowserForm-module_formField__EotlQ {\n  height: 32px;\n  background: #ddd;\n  border-radius: 4px;\n}\n\n.MockBrowserForm-module_shortField__EIHaw {\n  width: 75%;\n}\n\n.MockBrowserForm-module_mockCalendar__zdX5G {\n  width: 90%;\n  max-width: 300px;\n  background: white;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  margin: 20px 5px;\n}\n@media (max-width: 600px) {\n  .MockBrowserForm-module_mockCalendar__zdX5G {\n    margin: 2px 2px;\n  }\n}\n\n.MockBrowserForm-module_calendarHeader__gERkW {\n  font-size: 1rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n}\n@media (max-width: 600px) {\n  .MockBrowserForm-module_calendarHeader__gERkW {\n    display: none;\n  }\n}\n\n.MockBrowserForm-module_calendarGrid__j1lRF {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 5px;\n}\n\n.MockBrowserForm-module_calendarDay__BBbU4 {\n  width: 100%;\n  aspect-ratio: 1;\n  /* Keeps squares for all date cells */\n  background: #ddd;\n  border-radius: 4px;\n}\n\n.MockBrowserForm-module_selected__ACIKg {\n  background: lightgreen !important;\n}\n\n.MockBrowserForm-module_weekend__3eRCz {\n  background: lightcoral !important;\n}\n\n.MockBrowserForm-module_pastDate__WF-FL {\n  background: darkgray !important;\n}\n\n.MockBrowserForm-module_notAvailable__C1EWB {\n  background: orange !important;\n}\n\n.MockBrowserForm-module_submitButton__hIx9V {\n  width: 100%;\n  background: #999;\n  color: white;\n  border: none;\n  padding: 0.5rem;\n  margin-top: 1rem;\n  border-radius: 4px;\n  cursor: not-allowed;\n}\n@media (max-width: 600px) {\n  .MockBrowserForm-module_submitButton__hIx9V {\n    display: none;\n  }\n}\n\n.MockBrowserForm-module_footer__soN-b {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 48px;\n}\n\n.MockBrowserForm-module_footerText__YIfrW {\n  color: white;\n  font-size: 0.875rem;\n}";
var styles$n = {"browserFrame":"MockBrowserForm-module_browserFrame__rB89j","topBar":"MockBrowserForm-module_topBar__Pxu-d","flexRow":"MockBrowserForm-module_flexRow__lFELv","macControls":"MockBrowserForm-module_macControls__LiDFX","macClose":"MockBrowserForm-module_macClose__kJLov","macMinimize":"MockBrowserForm-module_macMinimize__MePdu","macMaximize":"MockBrowserForm-module_macMaximize__Jn8LQ","urlInput":"MockBrowserForm-module_urlInput__njTcs","windowControls":"MockBrowserForm-module_windowControls__xdl9d","contentWrapper":"MockBrowserForm-module_contentWrapper__K2qvn","topBand":"MockBrowserForm-module_topBand__l2b7M","logo":"MockBrowserForm-module_logo__Jrk-q","businessName":"MockBrowserForm-module_businessName__33NHh","middleSection":"MockBrowserForm-module_middleSection__vTwOg","fakeForm":"MockBrowserForm-module_fakeForm__JVMFB","formTitle":"MockBrowserForm-module_formTitle__Kh1-W","formDescription":"MockBrowserForm-module_formDescription__oqLa5","formFields":"MockBrowserForm-module_formFields__i-yJp","formField":"MockBrowserForm-module_formField__EotlQ","shortField":"MockBrowserForm-module_shortField__EIHaw","mockCalendar":"MockBrowserForm-module_mockCalendar__zdX5G","calendarHeader":"MockBrowserForm-module_calendarHeader__gERkW","calendarGrid":"MockBrowserForm-module_calendarGrid__j1lRF","calendarDay":"MockBrowserForm-module_calendarDay__BBbU4","selected":"MockBrowserForm-module_selected__ACIKg","weekend":"MockBrowserForm-module_weekend__3eRCz","pastDate":"MockBrowserForm-module_pastDate__WF-FL","notAvailable":"MockBrowserForm-module_notAvailable__C1EWB","submitButton":"MockBrowserForm-module_submitButton__hIx9V","footer":"MockBrowserForm-module_footer__soN-b","footerText":"MockBrowserForm-module_footerText__YIfrW"};
styleInject(css_248z$1o);

const padZero = (str, len = 2) => {
    const zeros = new Array(len).join("0");
    return (zeros + str).slice(-len);
};
const invertColor = (hex, bw) => {
    if (hex.indexOf("#") === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error("Invalid HEX color.");
    }
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
    }
    // pad each with zeros and return
    return "#" + padZero((255 - r).toString(16)) + padZero((255 - g).toString(16)) + padZero((255 - b).toString(16));
};

const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
    useEffect(() => {
        const mediaQuery = window.matchMedia(query);
        const handler = (event) => setMatches(event.matches);
        mediaQuery.addEventListener("change", handler);
        return () => mediaQuery.removeEventListener("change", handler);
    }, [query]);
    return matches;
};
/**
 * A Mock browser with mock form or calendar as the contents.
 */
const MockBrowserForm = ({ headerColor = "#282c34", middleColor = "#f0f0f0", footerColor = "#282c34", browserFrameColor, businessName, logoUrl, overrideIsMac, overrideDisplayUrl, formTitle, browserUrl, type = "form", }) => {
    const isMac = useMediaQuery("(macintosh|mac os x)");
    const showMacControls = typeof overrideIsMac === "boolean" ? overrideIsMac : isMac;
    const [url, setUrl] = useState(browserUrl || "//contact");
    const [isValidLogoUrl, setIsValidLogoUrl] = useState(logoUrl ? true : false);
    const imgRef = useRef(null);
    useEffect(() => {
        if (!logoUrl) {
            // no logo, nothing to validate
            return;
        }
        const checkImageValidity = () => {
            if (imgRef.current && imgRef.current.complete) {
                const { naturalWidth, naturalHeight } = imgRef.current;
                if (naturalWidth === 16 &&
                    naturalHeight === 16 &&
                    logoUrl.includes("google.com/s2/favicons") &&
                    /[?&]sz=(\d+)/.test(logoUrl) &&
                    parseInt(logoUrl.match(/[?&]sz=(\d+)/)[1]) > 16) {
                    setIsValidLogoUrl(false);
                }
            }
        };
        if (imgRef.current) {
            if (imgRef.current.complete) {
                checkImageValidity();
            }
            else {
                imgRef.current.onload = checkImageValidity;
                imgRef.current.onerror = () => setIsValidLogoUrl(false);
            }
        }
    }, [logoUrl]);
    const company = businessName || "My Company";
    const footerText = `© ${new Date().getFullYear()} ${company}`;
    if (!browserFrameColor) {
        browserFrameColor = headerColor;
    }
    if (!formTitle) {
        formTitle = "Schedule Visit";
    }
    let buttonColor = "#fff";
    try {
        buttonColor = invertColor(browserFrameColor, true);
    }
    catch (e) {
        /* don't care  */
    }
    let headerTextColor = "#fff";
    try {
        headerTextColor = invertColor(headerColor, true);
    }
    catch (e) {
        /* don't care  */
    }
    // total days is dependent on screen width
    const screenWidth = window.innerWidth;
    const totalDays = screenWidth < 800 ? 26 : 34;
    const currentDay = 10;
    // pick a couple of week days to be unavailable
    const notAvailableDays = [];
    const [selectedDate] = useState(currentDay); // Change this to any date you want to "select"
    return (React__default$4.createElement("div", { className: styles$n.browserFrame, style: { backgroundColor: browserFrameColor, border: `3px solid ${browserFrameColor}` } },
        React__default$4.createElement("div", { className: classNames$1(styles$n.topBar, styles$n.flexRow), style: { backgroundColor: browserFrameColor, display: overrideDisplayUrl ? "flex" : undefined } },
            showMacControls ? (React__default$4.createElement("div", { className: styles$n.macControls },
                React__default$4.createElement("div", { className: styles$n.macClose }),
                React__default$4.createElement("div", { className: styles$n.macMinimize }),
                React__default$4.createElement("div", { className: styles$n.macMaximize }))) : (React__default$4.createElement("div", { className: styles$n.flexGrow })),
            React__default$4.createElement("input", { type: "text", value: url, onChange: (e) => setUrl(e.target.value), className: styles$n.urlInput }),
            !showMacControls && (React__default$4.createElement("div", { style: { color: buttonColor }, className: styles$n.windowControls },
                React__default$4.createElement("span", { className: "material-icons" }, "minimize"),
                React__default$4.createElement("span", { className: "material-icons" }, "fullscreen"),
                React__default$4.createElement("span", { className: "material-icons" }, "close")))),
        React__default$4.createElement("div", { className: styles$n.contentWrapper },
            React__default$4.createElement("div", { className: styles$n.topBand, style: { backgroundColor: headerColor } },
                logoUrl && isValidLogoUrl && (React__default$4.createElement("img", { ref: imgRef, src: logoUrl, alt: "Logo", className: styles$n.logo, onError: () => setIsValidLogoUrl(false) })),
                businessName && !isValidLogoUrl && (React__default$4.createElement("span", { style: { color: headerTextColor }, className: styles$n.businessName }, businessName))),
            React__default$4.createElement("div", { className: styles$n.middleSection, style: { backgroundColor: middleColor } },
                type === "form" && (React__default$4.createElement("div", { className: styles$n.fakeForm },
                    React__default$4.createElement("h3", { className: styles$n.formTitle }, formTitle),
                    React__default$4.createElement("div", { className: styles$n.formFields },
                        React__default$4.createElement("div", { className: styles$n.formField }),
                        React__default$4.createElement("div", { className: styles$n.formField }),
                        React__default$4.createElement("div", { className: classNames$1(styles$n.formField, styles$n.shortField) })),
                    React__default$4.createElement("button", { className: styles$n.submitButton, disabled: true }, "Submit"))),
                type === "calendar" && (React__default$4.createElement("div", { className: styles$n.mockCalendar },
                    React__default$4.createElement("h3", { className: styles$n.formTitle }, formTitle),
                    React__default$4.createElement("h3", { className: styles$n.calendarHeader }, new Date().toLocaleString("default", { month: "long" })),
                    React__default$4.createElement("div", { className: styles$n.calendarGrid }, [...Array(totalDays)].map((_, index) => {
                        const dayOfWeek = index % 7; // 0 (Sunday) to 6 (Saturday)
                        const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
                        const notAvailable = notAvailableDays.includes(index);
                        const isInPast = index < currentDay;
                        return (React__default$4.createElement("div", { key: index, className: classNames$1(styles$n.calendarDay, {
                                [styles$n.weekend]: isWeekend,
                                [styles$n.pastDate]: isInPast && !isWeekend,
                                [styles$n.notAvailable]: notAvailable,
                                [styles$n.selected]: index === selectedDate,
                            }) }));
                    })),
                    React__default$4.createElement("button", { className: styles$n.submitButton, disabled: true }, "Schedule")))),
            React__default$4.createElement("div", { className: styles$n.footer, style: { backgroundColor: footerColor } },
                React__default$4.createElement("span", { className: styles$n.footerText }, footerText)))));
};

const useGetProperties = (variation) => {
    const [buttonProps, setButtonProps] = useState({});
    useEffect(() => {
        switch (variation) {
            default:
            case "default":
                setButtonProps(Object.assign(Object.assign({}, buttonProps), { variant: "contained", disableElevation: true }));
                break;
            case "primary":
                setButtonProps(Object.assign(Object.assign({}, buttonProps), { variant: "contained", style: { backgroundColor: "#1aa7dc" } }));
                break;
            case "secondary":
                setButtonProps(Object.assign(Object.assign({}, buttonProps), { variant: "outlined", color: "primary" }));
                break;
            case "flat":
                setButtonProps(Object.assign(Object.assign({}, buttonProps), { variant: "text" }));
        }
        // This causes an error:  Warning: Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [variation]);
    return buttonProps;
};

const InnerButton = (_a) => {
    var { variation = "primary", label, icon, leftIcon, rightIcon, children, loading = false, disabled } = _a, props = __rest$2(_a, ["variation", "label", "icon", "leftIcon", "rightIcon", "children", "loading", "disabled"]);
    const buttonProps = useGetProperties(variation);
    // weird styling around here with startIcon
    return (React__default$4.createElement(MuiButton, Object.assign({ startIcon: !loading && leftIcon && React__default$4.createElement(Icon$1, { iconName: leftIcon }), endIcon: !loading && rightIcon && React__default$4.createElement(Icon$1, { iconName: rightIcon }) }, buttonProps, { disabled: disabled || loading }, props),
        loading && (React__default$4.createElement(CircularProgress$1, { size: 20, sx: {
                marginRight: label || children ? 1 : 0,
                color: "inherit",
            } })),
        label || props.title,
        " ",
        children,
        !loading && icon && React__default$4.createElement(Icon$1, { iconName: icon })));
};
const Button = React__default$4.memo(InnerButton);

var css_248z$1n = ".style_wrap__075qM {\n  box-sizing: border-box;\n  display: inline-block;\n  padding: 1em;\n  margin-right: -4px;\n  vertical-align: top;\n  width: 100%;\n}\n@media screen and (min-width: 768px) and (max-width: 1023px) {\n  .style_wrap__075qM {\n    width: 50%;\n  }\n}\n@media screen and (min-width: 1024px) {\n  .style_wrap__075qM {\n    width: 33.33333%;\n  }\n}\n\n.style_card__UsdUU {\n  cursor: pointer;\n  text-align: center;\n}\n\n.style_textAvatar__aZJLf {\n  color: rgba(14, 34, 68, 0.75);\n  display: inline-block;\n  font-size: 4em;\n  position: relative;\n}\n.style_textAvatar__aZJLf > p {\n  font-weight: bold;\n  font-size: 3em;\n  left: 50%;\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.style_avatarWrap__e8--Z {\n  border: 1px solid #bebebe;\n  border-radius: 50%;\n  overflow: hidden;\n  height: 250px;\n  line-height: 250px;\n  margin: 0 auto;\n  position: relative;\n  text-align: center;\n  width: 250px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n.style_avatarWrap__e8--Z img {\n  flex: 0 1 auto;\n  object-fit: contain;\n  overflow: hidden;\n}\n\n.style_label__-quu- {\n  margin-left: 8px;\n  font-size: 32px;\n  white-space: nowrap;\n}";
var cardStyle = {"wrap":"style_wrap__075qM","card":"style_card__UsdUU","textAvatar":"style_textAvatar__aZJLf","avatarWrap":"style_avatarWrap__e8--Z","label":"style_label__-quu-"};
styleInject(css_248z$1n);

/**
 * Simple card for rendering an image and title, used for displaying Apps and Orgs in card
 * list format.
 *
 * @param props
 */
const Card$1 = ({ icon, title, label, onClick, className, style }) => {
    const renderAvatar = (icon) => {
        if (!icon) {
            return (React__default$4.createElement("div", { className: cardStyle.textAvatar },
                React__default$4.createElement("p", null, title.substr(0, 2))));
        }
        else if (typeof icon === "string") {
            return React__default$4.createElement("img", { className: cardStyle.icon, src: icon, alt: `icon for ${title}` });
        }
        else {
            return icon;
        }
    };
    const wrapClassName = className ? `${cardStyle.wrap} ${className}` : cardStyle.wrap;
    return (React__default$4.createElement("div", { className: wrapClassName, style: style },
        React__default$4.createElement("div", { className: cardStyle.card, onClick: onClick },
            React__default$4.createElement("div", { className: cardStyle.avatarWrap },
                renderAvatar(icon),
                label && React__default$4.createElement("span", { className: cardStyle.label }, label)),
            React__default$4.createElement("h4", null, title))));
};

/**
 * Generic Card wrapper component for Material-UI Card.
 * Provides compatibility with react-toolbox Card API.
 */
const Card = (_a) => {
    var { children, className } = _a, props = __rest$2(_a, ["children", "className"]);
    return (React__default$4.createElement(node.Card, Object.assign({ className: className }, props), children));
};

/**
 * CardTitle wrapper component for Material-UI CardHeader.
 * Provides compatibility with react-toolbox CardTitle API.
 *
 * Handles string avatars by wrapping them in an Avatar component,
 * which is the expected behavior from react-toolbox.
 */
const CardTitle = ({ avatar, title, subtitle, className }) => {
    // Handle string avatars by wrapping in Avatar component
    const avatarElement = typeof avatar === 'string'
        ? React__default$4.createElement(node.Avatar, { src: avatar })
        : avatar;
    return (React__default$4.createElement(node.CardHeader, { avatar: avatarElement, title: title, subheader: subtitle, className: className }));
};

/**
 * CardText wrapper component for Material-UI CardContent.
 * Provides compatibility with react-toolbox CardText API.
 */
const CardText = ({ children, className }) => {
    return (React__default$4.createElement(node.CardContent, { className: className }, children));
};

/**
 * CardActions wrapper component for Material-UI CardActions.
 * Provides compatibility with react-toolbox CardActions API.
 */
const CardActions = ({ children, className }) => {
    return (React__default$4.createElement(node.CardActions, { className: className }, children));
};

var css_248z$1m = ".CarouselStyles-module_carousel__KPd1f {\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n}\n\n.CarouselStyles-module_carouselInner__Ro-PM {\n  display: flex;\n  width: 100%;\n}\n\n.CarouselStyles-module_carouselItem__KgPYz {\n  flex: 1 0 100%;\n  box-sizing: border-box;\n}\n\n.CarouselStyles-module_carouselArrow__kc37G {\n  position: absolute;\n  top: 50%;\n  left: 100%;\n  transform: translate(-50%, -50%);\n  font-size: 24px;\n  color: #333;\n  background: rgba(255, 255, 255, 0.8);\n  padding: 10px 10px;\n  border-radius: 50%;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);\n  transition: color 0.3s ease, background 0.3s ease;\n  z-index: 2;\n}\n\n.CarouselStyles-module_carouselArrow__kc37G:hover {\n  color: white;\n  background: #007bff;\n}";
var styles$m = {"carousel":"CarouselStyles-module_carousel__KPd1f","carouselInner":"CarouselStyles-module_carouselInner__Ro-PM","carouselItem":"CarouselStyles-module_carouselItem__KgPYz","carouselArrow":"CarouselStyles-module_carouselArrow__kc37G"};
styleInject(css_248z$1m);

/**
 * A simple carousel component that cycles through its children
 *
 * @param {CarouselProps} props - The props for the Carousel component
 * @returns {JSX.Element} The Carousel component
 */
const Carousel$1 = ({ interval = 3000, children, showTransition, transitionElement = "➡️", transitionSpeed = 0.5, }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const childrenCount = React__default$4.Children.count(children);
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % childrenCount);
        }, interval);
        return () => clearInterval(timer);
    }, [interval, childrenCount]);
    return (React__default$4.createElement("div", { className: styles$m.carousel },
        React__default$4.createElement("div", { className: styles$m.carouselInner, style: {
                transform: `translateX(-${currentIndex * 100}%)`,
                transition: `transform ${transitionSpeed}s ease-in-out`,
            } }, React__default$4.Children.map(children, (child, index) => (React__default$4.createElement(React__default$4.Fragment, null,
            React__default$4.createElement("div", { className: styles$m.carouselItem, style: { minWidth: "100%" } }, child),
            showTransition && React__default$4.createElement("div", { className: styles$m.carouselArrow }, transitionElement)))))));
};

var lib$6 = {};

var exports = {};

var Provider = {};

var interopRequireWildcard = {exports: {}};

(function (module) {
var _typeof = _typeof$15.exports["default"];
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (module.exports = _interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        "default": e
      };
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;
}(interopRequireWildcard));

var Context = {};

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports["default"];

exports.__esModule = true;
exports["default"] = exports.ReactReduxContext = void 0;

var _react = _interopRequireDefault(React__default$4);

var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);

exports.ReactReduxContext = ReactReduxContext;

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

var _default = ReactReduxContext;
exports["default"] = _default;
}(Context));

var Subscription = {};

var batch$1 = {};

batch$1.__esModule = true;
batch$1.setBatch = batch$1.getBatch = void 0;

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings


batch$1.setBatch = setBatch;

var getBatch = function getBatch() {
  return batch;
};

batch$1.getBatch = getBatch;

Subscription.__esModule = true;
Subscription.createSubscription = createSubscription;

var _batch = batch$1;

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
  var batch = (0, _batch.getBatch)();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};

function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

var useIsomorphicLayoutEffect$1 = {};

useIsomorphicLayoutEffect$1.__esModule = true;
useIsomorphicLayoutEffect$1.useIsomorphicLayoutEffect = void 0;

var _react$1U = React__default$4;

// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react$1U.useLayoutEffect : _react$1U.useEffect;
useIsomorphicLayoutEffect$1.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports["default"];

var _interopRequireWildcard = interopRequireWildcard.exports["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(React__default$4);

var _propTypes = _interopRequireDefault(propTypes.exports);

var _Context = Context;

var _Subscription = Subscription;

var _useIsomorphicLayoutEffect = useIsomorphicLayoutEffect$1;

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0, _react.useMemo)(function () {
    var subscription = (0, _Subscription.createSubscription)(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0, _react.useMemo)(function () {
    return store.getState();
  }, [store]);
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || _Context.ReactReduxContext;
  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (process.env.NODE_ENV !== 'production') {
  Provider.propTypes = {
    store: _propTypes["default"].shape({
      subscribe: _propTypes["default"].func.isRequired,
      dispatch: _propTypes["default"].func.isRequired,
      getState: _propTypes["default"].func.isRequired
    }),
    context: _propTypes["default"].object,
    children: _propTypes["default"].any
  };
}

var _default = Provider;
exports["default"] = _default;
}(Provider));

var connectAdvanced = {};

var reactIs$1 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1=60103,c$2=60106,d$1=60107,e$1=60108,f$1=60114,g$1=60109,h$1=60110,k$2=60112,l$1=60113,m$1=60120,n$1=60115,p$1=60116,q$1=60121,r=60122,u$1=60117,v$1=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x$2=Symbol.for;b$1=x$2("react.element");c$2=x$2("react.portal");d$1=x$2("react.fragment");e$1=x$2("react.strict_mode");f$1=x$2("react.profiler");g$1=x$2("react.provider");h$1=x$2("react.context");k$2=x$2("react.forward_ref");l$1=x$2("react.suspense");m$1=x$2("react.suspense_list");n$1=x$2("react.memo");p$1=x$2("react.lazy");q$1=x$2("react.block");r=x$2("react.server.block");u$1=x$2("react.fundamental");v$1=x$2("react.debug_trace_mode");w=x$2("react.legacy_hidden");}
function y$1(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b$1:switch(a=a.type,a){case d$1:case f$1:case e$1:case l$1:case m$1:return a;default:switch(a=a&&a.$$typeof,a){case h$1:case k$2:case p$1:case n$1:case g$1:return a;default:return t}}case c$2:return t}}}var z=g$1,A$1=b$1,B$1=k$2,C$1=d$1,D$1=p$1,E$1=n$1,F=c$2,G=f$1,H=e$1,I=l$1;reactIs_production_min$1.ContextConsumer=h$1;reactIs_production_min$1.ContextProvider=z;reactIs_production_min$1.Element=A$1;reactIs_production_min$1.ForwardRef=B$1;reactIs_production_min$1.Fragment=C$1;reactIs_production_min$1.Lazy=D$1;reactIs_production_min$1.Memo=E$1;reactIs_production_min$1.Portal=F;reactIs_production_min$1.Profiler=G;reactIs_production_min$1.StrictMode=H;
reactIs_production_min$1.Suspense=I;reactIs_production_min$1.isAsyncMode=function(){return !1};reactIs_production_min$1.isConcurrentMode=function(){return !1};reactIs_production_min$1.isContextConsumer=function(a){return y$1(a)===h$1};reactIs_production_min$1.isContextProvider=function(a){return y$1(a)===g$1};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$1};reactIs_production_min$1.isForwardRef=function(a){return y$1(a)===k$2};reactIs_production_min$1.isFragment=function(a){return y$1(a)===d$1};reactIs_production_min$1.isLazy=function(a){return y$1(a)===p$1};reactIs_production_min$1.isMemo=function(a){return y$1(a)===n$1};
reactIs_production_min$1.isPortal=function(a){return y$1(a)===c$2};reactIs_production_min$1.isProfiler=function(a){return y$1(a)===f$1};reactIs_production_min$1.isStrictMode=function(a){return y$1(a)===e$1};reactIs_production_min$1.isSuspense=function(a){return y$1(a)===l$1};reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$1||a===f$1||a===v$1||a===e$1||a===l$1||a===m$1||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p$1||a.$$typeof===n$1||a.$$typeof===g$1||a.$$typeof===h$1||a.$$typeof===k$2||a.$$typeof===u$1||a.$$typeof===q$1||a[0]===r)?!0:!1};
reactIs_production_min$1.typeOf=y$1;

var reactIs_development$1 = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development$1.ContextConsumer = ContextConsumer;
reactIs_development$1.ContextProvider = ContextProvider;
reactIs_development$1.Element = Element;
reactIs_development$1.ForwardRef = ForwardRef;
reactIs_development$1.Fragment = Fragment;
reactIs_development$1.Lazy = Lazy;
reactIs_development$1.Memo = Memo;
reactIs_development$1.Portal = Portal;
reactIs_development$1.Profiler = Profiler;
reactIs_development$1.StrictMode = StrictMode;
reactIs_development$1.Suspense = Suspense;
reactIs_development$1.isAsyncMode = isAsyncMode;
reactIs_development$1.isConcurrentMode = isConcurrentMode;
reactIs_development$1.isContextConsumer = isContextConsumer;
reactIs_development$1.isContextProvider = isContextProvider;
reactIs_development$1.isElement = isElement;
reactIs_development$1.isForwardRef = isForwardRef;
reactIs_development$1.isFragment = isFragment;
reactIs_development$1.isLazy = isLazy;
reactIs_development$1.isMemo = isMemo;
reactIs_development$1.isPortal = isPortal;
reactIs_development$1.isProfiler = isProfiler;
reactIs_development$1.isStrictMode = isStrictMode;
reactIs_development$1.isSuspense = isSuspense;
reactIs_development$1.isValidElementType = isValidElementType;
reactIs_development$1.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs$1.exports = reactIs_production_min$1;
} else {
  reactIs$1.exports = reactIs_development$1;
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports["default"];

var _interopRequireWildcard = interopRequireWildcard.exports["default"];

exports.__esModule = true;
exports["default"] = connectAdvanced;

var _extends2 = _interopRequireDefault(_extends$19.exports);

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(objectWithoutPropertiesLoose.exports);

var _hoistNonReactStatics = _interopRequireDefault(hoistNonReactStatics_cjs);

var _react = _interopRequireWildcard(React__default$4);

var _reactIs = reactIs$1.exports;

var _Subscription = Subscription;

var _useIsomorphicLayoutEffect = useIsomorphicLayoutEffect$1;

var _Context = Context;

var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];
// Define some constant arrays just to avoid re-creating these
var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);

  if (process.env.NODE_ENV !== 'production') {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production' && !(0, _reactIs.isValidElementType)(WrappedComponent)) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);
    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });
    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0, _react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded2);
        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0, _react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (process.env.NODE_ENV !== 'production' && !didStoreComeFromProps && !didStoreComeFromContext) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0, _react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0, _react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = (0, _Subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0, _react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0, _extends2["default"])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0, _react.useRef)();
      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0, _react.useRef)();
      var renderIsScheduled = (0, _react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0, _react.useMemo)(function () {
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0, _react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
          reactReduxForwardedRef: ref
        }));
      });

      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
    }

    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
  };
}
}(connectAdvanced));

var connect = {};

var shallowEqual$2 = {};

(function (exports) {

exports.__esModule = true;
exports["default"] = shallowEqual;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
}(shallowEqual$2));

var mapDispatchToProps = {};

var bindActionCreators = {};

(function (exports) {

exports.__esModule = true;
exports["default"] = bindActionCreators;

function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
}(bindActionCreators));

var wrapMapToProps = {};

var verifyPlainObject = {};

var isPlainObject$4 = {};

(function (exports) {

exports.__esModule = true;
exports["default"] = isPlainObject;

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}
}(isPlainObject$4));

var warning = {};

(function (exports) {

exports.__esModule = true;
exports["default"] = warning;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}
}(warning));

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports["default"];

exports.__esModule = true;
exports["default"] = verifyPlainObject;

var _isPlainObject = _interopRequireDefault(isPlainObject$4);

var _warning = _interopRequireDefault(warning);

function verifyPlainObject(value, displayName, methodName) {
  if (!(0, _isPlainObject["default"])(value)) {
    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}
}(verifyPlainObject));

var _interopRequireDefault$3p = interopRequireDefault$1.exports["default"];

wrapMapToProps.__esModule = true;
wrapMapToProps.getDependsOnOwnProps = getDependsOnOwnProps;
wrapMapToProps.wrapMapToPropsConstant = wrapMapToPropsConstant;
wrapMapToProps.wrapMapToPropsFunc = wrapMapToPropsFunc;

var _verifyPlainObject = _interopRequireDefault$3p(verifyPlainObject);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..


function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//


function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') (0, _verifyPlainObject["default"])(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports["default"];

exports.__esModule = true;
exports["default"] = void 0;
exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;

var _bindActionCreators = _interopRequireDefault(bindActionCreators);

var _wrapMapToProps = wrapMapToProps;

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
    return (0, _bindActionCreators["default"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
exports["default"] = _default;
}(mapDispatchToProps));

var mapStateToProps = {};

(function (exports) {

exports.__esModule = true;
exports["default"] = void 0;
exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;

var _wrapMapToProps = wrapMapToProps;

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
    return {};
  }) : undefined;
}

var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
exports["default"] = _default;
}(mapStateToProps));

var mergeProps = {};

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports["default"];

exports.__esModule = true;
exports["default"] = void 0;
exports.defaultMergeProps = defaultMergeProps;
exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
exports.wrapMergePropsFunc = wrapMergePropsFunc;

var _extends2 = _interopRequireDefault(_extends$19.exports);

var _verifyPlainObject = _interopRequireDefault(verifyPlainObject);

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
exports["default"] = _default;
}(mergeProps));

var selectorFactory = {};

var verifySubselectors = {};

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports["default"];

exports.__esModule = true;
exports["default"] = verifySubselectors;

var _warning = _interopRequireDefault(warning);

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}
}(verifySubselectors));

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports["default"];

exports.__esModule = true;
exports["default"] = finalPropsSelectorFactory;
exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(objectWithoutPropertiesLoose.exports);

var _verifySubselectors = _interopRequireDefault(verifySubselectors);

var _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.


function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);
  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
}(selectorFactory));

(function (exports) {

var _interopRequireDefault = interopRequireDefault$1.exports["default"];

exports.__esModule = true;
exports.createConnect = createConnect;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(_extends$19.exports);

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(objectWithoutPropertiesLoose.exports);

var _connectAdvanced = _interopRequireDefault(connectAdvanced);

var _shallowEqual = _interopRequireDefault(shallowEqual$2);

var _mapDispatchToProps = _interopRequireDefault(mapDispatchToProps);

var _mapStateToProps = _interopRequireDefault(mapStateToProps);

var _mergeProps = _interopRequireDefault(mergeProps);

var _selectorFactory = _interopRequireDefault(selectorFactory);

var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];

/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */
function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, _excluded);
    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0, _extends2["default"])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}

var _default = /*#__PURE__*/createConnect();

exports["default"] = _default;
}(connect));

var useDispatch$1 = {};

var useStore$1 = {};

var useReduxContext$1 = {};

useReduxContext$1.__esModule = true;
useReduxContext$1.useReduxContext = useReduxContext;

var _react$1T = React__default$4;

var _Context$4 = Context;

/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */
function useReduxContext() {
  var contextValue = (0, _react$1T.useContext)(_Context$4.ReactReduxContext);

  if (process.env.NODE_ENV !== 'production' && !contextValue) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

useStore$1.__esModule = true;
useStore$1.createStoreHook = createStoreHook;
useStore$1.useStore = void 0;

var _react$1S = React__default$4;

var _Context$3 = Context;

var _useReduxContext2$1 = useReduxContext$1;

/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */
function createStoreHook(context) {
  if (context === void 0) {
    context = _Context$3.ReactReduxContext;
  }

  var useReduxContext = context === _Context$3.ReactReduxContext ? _useReduxContext2$1.useReduxContext : function () {
    return (0, _react$1S.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */


var useStore = /*#__PURE__*/createStoreHook();
useStore$1.useStore = useStore;

useDispatch$1.__esModule = true;
useDispatch$1.createDispatchHook = createDispatchHook;
useDispatch$1.useDispatch = void 0;

var _Context$2 = Context;

var _useStore$1 = useStore$1;

/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */
function createDispatchHook(context) {
  if (context === void 0) {
    context = _Context$2.ReactReduxContext;
  }

  var useStore = context === _Context$2.ReactReduxContext ? _useStore$1.useStore : (0, _useStore$1.createStoreHook)(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */


var useDispatch = /*#__PURE__*/createDispatchHook();
useDispatch$1.useDispatch = useDispatch;

var useSelector$1 = {};

useSelector$1.__esModule = true;
useSelector$1.createSelectorHook = createSelectorHook;
useSelector$1.useSelector = void 0;

var _react$1R = React__default$4;

var _useReduxContext2 = useReduxContext$1;

var _Subscription = Subscription;

var _useIsomorphicLayoutEffect = useIsomorphicLayoutEffect$1;

var _Context$1 = Context;

var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0, _react$1R.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0, _react$1R.useMemo)(function () {
    return (0, _Subscription.createSubscription)(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0, _react$1R.useRef)();
  var latestSelector = (0, _react$1R.useRef)();
  var latestStoreState = (0, _react$1R.useRef)();
  var latestSelectedState = (0, _react$1R.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = _Context$1.ReactReduxContext;
  }

  var useReduxContext = context === _Context$1.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
    return (0, _react$1R.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!selector) {
        throw new Error("You must pass a selector to useSelector");
      }

      if (typeof selector !== 'function') {
        throw new Error("You must pass a function as a selector to useSelector");
      }

      if (typeof equalityFn !== 'function') {
        throw new Error("You must pass a function as an equality function to useSelector");
      }
    }

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0, _react$1R.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */


var useSelector = /*#__PURE__*/createSelectorHook();
useSelector$1.useSelector = useSelector;

var _interopRequireDefault$3o = interopRequireDefault$1.exports["default"];

exports.__esModule = true;

var _Provider = _interopRequireDefault$3o(Provider);

exports.Provider = _Provider["default"];

var _connectAdvanced = _interopRequireDefault$3o(connectAdvanced);

exports.connectAdvanced = _connectAdvanced["default"];

var _Context = Context;

exports.ReactReduxContext = _Context.ReactReduxContext;

var _connect = _interopRequireDefault$3o(connect);

exports.connect = _connect["default"];

var _useDispatch = useDispatch$1;

exports.useDispatch = _useDispatch.useDispatch;
exports.createDispatchHook = _useDispatch.createDispatchHook;

var _useSelector = useSelector$1;

exports.useSelector = _useSelector.useSelector;
exports.createSelectorHook = _useSelector.createSelectorHook;

var _useStore = useStore$1;

exports.useStore = _useStore.useStore;
exports.createStoreHook = _useStore.createStoreHook;

var _shallowEqual = _interopRequireDefault$3o(shallowEqual$2);

exports.shallowEqual = _shallowEqual["default"];

var reactBatchedUpdates = {};

reactBatchedUpdates.__esModule = true;
reactBatchedUpdates.unstable_batchedUpdates = void 0;

var _reactDom = require$$2$1;

reactBatchedUpdates.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

(function (exports$1) {

exports$1.__esModule = true;
var _exportNames = {
  batch: true
};

var _exports = exports;

Object.keys(_exports).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports$1 && exports$1[key] === _exports[key]) return;
  exports$1[key] = _exports[key];
});

var _reactBatchedUpdates = reactBatchedUpdates;

exports$1.batch = _reactBatchedUpdates.unstable_batchedUpdates;

var _batch = batch$1;

// Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);
}(lib$6));

var require$$1 = React__default$4;
var require$$0 = require$$11;
var reactRedux = lib$6;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof commonjsGlobal$1 !== 'undefined' ? commonjsGlobal$1 : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var lib$5 = {};

var ActionBar$1 = {};

Object.defineProperty(ActionBar$1, "__esModule", { value: true });
ActionBar$1.isActionBarChatButton = isActionBarChatButton;
ActionBar$1.isActionBarFormButton = isActionBarFormButton;
ActionBar$1.isActionBarScheduleButton = isActionBarScheduleButton;
ActionBar$1.isActionBarPhoneButton = isActionBarPhoneButton;
ActionBar$1.isActionBarUrlButton = isActionBarUrlButton;
ActionBar$1.isActionBarEmailButton = isActionBarEmailButton;
ActionBar$1.isActionBarHelpButton = isActionBarHelpButton;
ActionBar$1.isActionBarPaymentButton = isActionBarPaymentButton;
/**
 * Type guard for ActionBarChatButton
 */
function isActionBarChatButton(button) {
    return button.type === "chat";
}
/**
 * Type guard for ActionBarFormButton
 */
function isActionBarFormButton(button) {
    return button.type === "form";
}
/**
 * Type guard for ActionBarScheduleButton
 */
function isActionBarScheduleButton(button) {
    return button.type === "schedule";
}
/**
 * Type guard for ActionBarPhoneButton
 */
function isActionBarPhoneButton(button) {
    return button.type === "phone";
}
/**
 * Type guard for ActionBarUrlButton
 */
function isActionBarUrlButton(button) {
    return button.type === "url";
}
/**
 * Type guard for ActionBarEmailButton
 */
function isActionBarEmailButton(button) {
    return button.type === "email";
}
/**
 * Type guard for ActionBarHelpButton
 */
function isActionBarHelpButton(button) {
    return button.type === "help";
}
/**
 * Type guard for ActionBarPaymentButton
 */
function isActionBarPaymentButton(button) {
    return button.type === "payment";
}

var ChannelData = {};

Object.defineProperty(ChannelData, "__esModule", { value: true });

var Constants$1 = {};

Object.defineProperty(Constants$1, "__esModule", { value: true });
Constants$1.CHAT_WIDGET_CHANNEL = void 0;
Constants$1.CHAT_WIDGET_CHANNEL = "chat-widget";

var Types = {};

/*! Copyright (c) 2021, XAPPmedia */
Object.defineProperty(Types, "__esModule", { value: true });

var UserInfo = {};

Object.defineProperty(UserInfo, "__esModule", { value: true });

var WidgetEnv = {};

Object.defineProperty(WidgetEnv, "__esModule", { value: true });

var WidgetTheme = {};

Object.defineProperty(WidgetTheme, "__esModule", { value: true });

var guards = {};

Object.defineProperty(guards, "__esModule", { value: true });
guards.isStaticImageMenuItem = isStaticImageMenuItem;
guards.isStaticTextMenuItem = isStaticTextMenuItem;
guards.isStandardMenuItem = isStandardMenuItem;
guards.isOpenURLMenuItem = isOpenURLMenuItem;
function isStaticImageMenuItem(item) {
    return !!item && !!item.imageUrl;
}
function isStaticTextMenuItem(item) {
    return !!item && !!item.body;
}
function isStandardMenuItem(item) {
    return !!item && !!item.label;
}
function isOpenURLMenuItem(item) {
    return !!item && !!item.url;
}

(function (exports$1) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports$1) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports$1, p)) __createBinding(exports$1, m, p);
	};
	Object.defineProperty(exports$1, "__esModule", { value: true });
	/*! Copyright (c) 2021, XAPPmedia */
	__exportStar(ActionBar$1, exports$1);
	__exportStar(ChannelData, exports$1);
	__exportStar(Constants$1, exports$1);
	__exportStar(Types, exports$1);
	__exportStar(UserInfo, exports$1);
	__exportStar(WidgetEnv, exports$1);
	__exportStar(WidgetTheme, exports$1);
	__exportStar(guards, exports$1);
	
} (lib$5));

var ChatIcon = function () { return (require$$0.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: require$$0.jsx("path", { d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" }) })); };
var FormIcon = function () { return (require$$0.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: require$$0.jsx("path", { d: "M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6zm2-6h8v2H8v-2zm0-3h8v2H8v-2zm0 6h5v2H8v-2z" }) })); };
var ScheduleIcon = function () { return (require$$0.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: require$$0.jsx("path", { d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zM9 14H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm-8 4H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2z" }) })); };
var PhoneIcon = function () { return (require$$0.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: require$$0.jsx("path", { d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" }) })); };
var LinkIcon = function () { return (require$$0.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: require$$0.jsx("path", { d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z" }) })); };
var EmailIcon = function () { return (require$$0.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: require$$0.jsx("path", { d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" }) })); };
var HelpIcon = function () { return (require$$0.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: require$$0.jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" }) })); };
var PaymentIcon = function () { return (require$$0.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: require$$0.jsx("path", { d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" }) })); };
// Default fallback icon for unsupported types
var DefaultIcon = function () { return (require$$0.jsx("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", children: require$$0.jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" }) })); };
var iconComponents = {
    chat: ChatIcon,
    form: FormIcon,
    calendar: ScheduleIcon, // GraphQL schema uses "calendar"
    schedule: ScheduleIcon, // Keep "schedule" for backwards compatibility
    phone: PhoneIcon,
    link: LinkIcon, // GraphQL schema uses "link"
    url: LinkIcon, // Keep "url" for backwards compatibility
    email: EmailIcon,
    help: HelpIcon,
    payment: PaymentIcon,
    // "custom" type is handled via iconUrl, no need for a component
};
var ActionBarIcon = function (_a) {
    var type = _a.type, icon = _a.icon, iconUrl = _a.iconUrl, className = _a.className;
    if (iconUrl) {
        return (require$$0.jsx("div", { className: className, children: require$$0.jsx("img", { src: iconUrl, alt: "".concat(icon || type, " icon") }) }));
    }
    // Use explicit icon override if provided, otherwise fall back to type
    var iconType = icon || type;
    var IconComponent = iconComponents[iconType] || DefaultIcon;
    return (require$$0.jsx("div", { className: className, children: require$$0.jsx(IconComponent, {}) }));
};

/**
 * Allowed URL protocols for security. Prevents javascript: and other potentially dangerous protocols.
 */
var ALLOWED_PROTOCOLS = ["http:", "https:", "tel:", "mailto:"];
/**
 * Validates a URL to ensure it uses an allowed protocol.
 * Returns true if the URL is safe to navigate to.
 */
function isValidUrl(url) {
    try {
        var parsed = new URL(url, window.location.href);
        return ALLOWED_PROTOCOLS.includes(parsed.protocol);
    }
    catch (_a) {
        // Invalid URL
        return false;
    }
}
/**
 * Safely navigates to a URL after validation.
 * Returns false if the URL was invalid and navigation was blocked.
 */
function safeNavigate(url, target, windowOptions) {
    if (!isValidUrl(url)) {
        console.warn("[ActionBar] Blocked navigation to unsafe URL:", url);
        return false;
    }
    if (target === "sameWindow") {
        window.location.href = url;
    }
    else if (target === "newWindow" && windowOptions) {
        var features = "width=".concat(windowOptions.width || 600, ",height=").concat(windowOptions.height || 400);
        window.open(url, "_blank", features);
    }
    else {
        // newTab (default)
        window.open(url, "_blank", "noopener,noreferrer");
    }
    return true;
}
var defaultLabels = {
    chat: "Chat",
    form: "Contact",
    schedule: "Book",
    phone: "Call",
    url: "Link",
    email: "Email",
    help: "Help",
    payment: "Pay",
};
var ActionBarButton = function (_a) {
    var _b;
    var button = _a.button, chatActive = _a.chatActive, onChatClick = _a.onChatClick, onChatMinimize = _a.onChatMinimize, onFormClick = _a.onFormClick, isMobile = _a.isMobile;
    var handleClick = require$$1.useCallback(function () {
        if (lib$5.isActionBarChatButton(button)) {
            // Toggle chat: if active, minimize; if not active, open
            if (chatActive) {
                onChatMinimize();
            }
            else {
                onChatClick();
            }
        }
        else if (lib$5.isActionBarFormButton(button) || lib$5.isActionBarScheduleButton(button)) {
            // Both form and schedule buttons open the form widget modal
            onFormClick(button);
        }
        else if (lib$5.isActionBarPhoneButton(button)) {
            // Phone: Use tel: link
            var phoneNumber = button.phoneNumber.replace(/\s/g, "");
            window.location.href = "tel:".concat(phoneNumber);
        }
        else if (lib$5.isActionBarUrlButton(button)) {
            // URL: Open according to target (with validation)
            var url = button.url, _a = button.target, target = _a === void 0 ? "newTab" : _a, windowOptions = button.windowOptions;
            safeNavigate(url, target, windowOptions);
        }
        else if (lib$5.isActionBarEmailButton(button)) {
            // Email: Build mailto: link with optional subject and body
            var emailAddress = button.emailAddress, subject = button.subject, body = button.body;
            var mailto = "mailto:".concat(emailAddress);
            var params = [];
            if (subject) {
                params.push("subject=".concat(encodeURIComponent(subject)));
            }
            if (body) {
                params.push("body=".concat(encodeURIComponent(body)));
            }
            if (params.length > 0) {
                mailto += "?".concat(params.join("&"));
            }
            window.location.href = mailto;
        }
        else if (lib$5.isActionBarHelpButton(button)) {
            // Help: Open URL according to target (with validation)
            var url = button.url, _b = button.target, target = _b === void 0 ? "newTab" : _b;
            safeNavigate(url, target);
        }
        else if (lib$5.isActionBarPaymentButton(button)) {
            // Payment: Open URL according to target (with validation)
            var url = button.url, _c = button.target, target = _c === void 0 ? "newTab" : _c;
            safeNavigate(url, target);
        }
    }, [button, chatActive, onChatClick, onChatMinimize, onFormClick]);
    // Handle visibility
    var visibility = button.visibility || "all";
    if (visibility === "mobile-only" && !isMobile) {
        return null;
    }
    if (visibility === "desktop-only" && isMobile) {
        return null;
    }
    var ariaLabel = button.label || defaultLabels[button.type] || button.type;
    var tabIndex = (_b = button.tabIndex) !== null && _b !== void 0 ? _b : 0;
    // Chat button shows active state when chat is open
    var isActive = lib$5.isActionBarChatButton(button) && chatActive;
    var buttonClassName = [
        "xapp-action-bar__button",
        isActive ? "xapp-action-bar__button--active" : "",
    ].filter(Boolean).join(" ");
    return (require$$0.jsxs("button", { className: buttonClassName, onClick: handleClick, "aria-label": ariaLabel, "aria-pressed": isActive, tabIndex: tabIndex, children: [require$$0.jsx(ActionBarIcon, { type: button.type, icon: button.icon, iconUrl: button.iconUrl, className: "xapp-action-bar__icon" }), button.label && (require$$0.jsx("span", { className: "xapp-action-bar__label", children: button.label }))] }));
};

/**
 * CTA banner for ActionBar - a full-width rectangular banner that appears
 * above the action bar to prompt users to engage with chat.
 */
var ActionBarCta = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var config = _a.config, isMobile = _a.isMobile, onClick = _a.onClick, onDismiss = _a.onDismiss, hasUserInteracted = _a.hasUserInteracted;
    var _m = require$$1.useState(false), isVisible = _m[0], setIsVisible = _m[1];
    var _o = require$$1.useState(false), isAnimating = _o[0], setIsAnimating = _o[1];
    var _p = require$$1.useState(false), isDismissed = _p[0], setIsDismissed = _p[1];
    // For mobile overrides: null means "explicitly disabled", undefined means "use desktop default"
    var mobileMessage = isMobile ? (_b = config.mobile) === null || _b === void 0 ? void 0 : _b.message : undefined;
    var message = mobileMessage !== undefined ? mobileMessage : config.message;
    var delay = isMobile && ((_c = config.mobile) === null || _c === void 0 ? void 0 : _c.delay) !== undefined ? config.mobile.delay : ((_d = config.delay) !== null && _d !== void 0 ? _d : 0);
    var mobileTimeout = isMobile ? (_e = config.mobile) === null || _e === void 0 ? void 0 : _e.timeout : undefined;
    var timeout = mobileTimeout !== undefined ? mobileTimeout : config.timeout;
    var mobileAnimation = isMobile ? (_f = config.mobile) === null || _f === void 0 ? void 0 : _f.animation : undefined;
    var animation = mobileAnimation !== undefined ? mobileAnimation : config.animation;
    var animationDelay = isMobile && ((_g = config.mobile) === null || _g === void 0 ? void 0 : _g.animationDelay) !== undefined
        ? config.mobile.animationDelay
        : ((_h = config.animationDelay) !== null && _h !== void 0 ? _h : delay);
    var animationTimeout = isMobile && ((_j = config.mobile) === null || _j === void 0 ? void 0 : _j.animationTimeout) !== undefined
        ? config.mobile.animationTimeout
        : config.animationTimeout;
    var dismissible = isMobile && ((_k = config.mobile) === null || _k === void 0 ? void 0 : _k.dismissible) !== undefined
        ? config.mobile.dismissible
        : ((_l = config.dismissible) !== null && _l !== void 0 ? _l : true);
    // Show CTA after delay
    require$$1.useEffect(function () {
        if (!message || hasUserInteracted || isDismissed) {
            setIsVisible(false);
            return undefined;
        }
        var showTimer = setTimeout(function () {
            setIsVisible(true);
        }, delay);
        return function () { return clearTimeout(showTimer); };
    }, [message, delay, hasUserInteracted, isDismissed]);
    // Hide CTA after timeout
    require$$1.useEffect(function () {
        if (!isVisible || !timeout) {
            return undefined;
        }
        var hideTimer = setTimeout(function () {
            setIsVisible(false);
        }, timeout);
        return function () { return clearTimeout(hideTimer); };
    }, [isVisible, timeout]);
    // Start animation after animationDelay
    require$$1.useEffect(function () {
        if (!animation || hasUserInteracted || isDismissed) {
            setIsAnimating(false);
            return undefined;
        }
        var animateTimer = setTimeout(function () {
            setIsAnimating(true);
        }, animationDelay);
        return function () { return clearTimeout(animateTimer); };
    }, [animation, animationDelay, hasUserInteracted, isDismissed]);
    // Stop animation after animationTimeout
    require$$1.useEffect(function () {
        if (!isAnimating || !animationTimeout) {
            return undefined;
        }
        var stopTimer = setTimeout(function () {
            setIsAnimating(false);
        }, animationTimeout);
        return function () { return clearTimeout(stopTimer); };
    }, [isAnimating, animationTimeout]);
    var handleClick = function () {
        onClick();
        setIsVisible(false);
    };
    var handleDismiss = function (e) {
        e.stopPropagation();
        setIsDismissed(true);
        setIsVisible(false);
        onDismiss();
    };
    if (!isVisible || !message) {
        return null;
    }
    var animationClass = isAnimating && animation ? "xapp-action-bar-cta--".concat(animation) : "";
    return (require$$0.jsxs("div", { className: "xapp-action-bar-cta ".concat(animationClass), onClick: handleClick, role: "button", tabIndex: 0, "aria-label": message, onKeyDown: function (e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleClick();
            }
        }, children: [require$$0.jsx("span", { className: "xapp-action-bar-cta__message", children: message }), dismissible && (require$$0.jsx("button", { className: "xapp-action-bar-cta__dismiss", onClick: handleDismiss, "aria-label": "Dismiss", type: "button", children: require$$0.jsx("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: require$$0.jsx("path", { d: "M13 1L1 13M1 1L13 13", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }) }))] }));
};

var DEFAULT_MOBILE_BREAKPOINT = 768;
var RESIZE_DEBOUNCE_MS = 150;
var ActionBar = function (_a) {
    var _b, _c, _d;
    var config = _a.config, visible = _a.visible, chatDisabled = _a.chatDisabled, _e = _a.hasUserInteracted, hasUserInteracted = _e === void 0 ? false : _e, onChatClick = _a.onChatClick, onChatMinimize = _a.onChatMinimize, onFormClick = _a.onFormClick, onCtaDismiss = _a.onCtaDismiss;
    var _f = require$$1.useState(false), isMobile = _f[0], setIsMobile = _f[1];
    var mobileBreakpoint = (_b = config.mobileBreakpoint) !== null && _b !== void 0 ? _b : DEFAULT_MOBILE_BREAKPOINT;
    var position = (_c = config.position) !== null && _c !== void 0 ? _c : "right";
    var resizeTimeoutRef = require$$1.useRef(null);
    // Debounced resize handler
    var handleResize = require$$1.useCallback(function () {
        if (resizeTimeoutRef.current) {
            window.clearTimeout(resizeTimeoutRef.current);
        }
        resizeTimeoutRef.current = window.setTimeout(function () {
            setIsMobile(window.innerWidth <= mobileBreakpoint);
        }, RESIZE_DEBOUNCE_MS);
    }, [mobileBreakpoint]);
    require$$1.useEffect(function () {
        // Initial check (immediate, not debounced)
        setIsMobile(window.innerWidth <= mobileBreakpoint);
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
            if (resizeTimeoutRef.current) {
                window.clearTimeout(resizeTimeoutRef.current);
            }
        };
    }, [mobileBreakpoint, handleResize]);
    // Filter out chat buttons if chat is disabled
    var filteredButtons = chatDisabled
        ? config.buttons.filter(function (button) { return !lib$5.isActionBarChatButton(button); })
        : config.buttons;
    // Build class names - ActionBar stays visible even when chat is open
    var classNames = [
        "xapp-action-bar",
        "xapp-action-bar--".concat(position),
        isMobile ? "xapp-action-bar--mobile" : "xapp-action-bar--desktop",
    ]
        .filter(Boolean)
        .join(" ");
    // Determine if CTA should be shown:
    // - Must have CTA config with a message
    // - Chat must not be visible (user hasn't opened it)
    // - Chat must not be disabled
    var hasChatButton = config.buttons.some(lib$5.isActionBarChatButton);
    var showCta = ((_d = config.cta) === null || _d === void 0 ? void 0 : _d.message) && !visible && !chatDisabled && hasChatButton;
    var handleCtaClick = function () {
        onChatClick();
    };
    var handleCtaDismiss = function () {
        onCtaDismiss === null || onCtaDismiss === void 0 ? void 0 : onCtaDismiss();
    };
    return (require$$0.jsxs("div", { className: classNames, role: "toolbar", "aria-label": "Chat actions", children: [showCta && (require$$0.jsx("div", { className: "xapp-action-bar-cta-wrapper", children: require$$0.jsx(ActionBarCta, { config: config.cta, isMobile: isMobile, onClick: handleCtaClick, onDismiss: handleCtaDismiss, hasUserInteracted: hasUserInteracted }) })), require$$0.jsx("div", { className: "xapp-action-bar__buttons", children: filteredButtons.map(function (button) { return (require$$0.jsx(ActionBarButton, { button: button, chatActive: visible, onChatClick: onChatClick, onChatMinimize: onChatMinimize, onFormClick: onFormClick, isMobile: isMobile }, button.id)); }) })] }));
};

var ActionButton = function (_a) {
    var label = _a.label, disable = _a.disable, type = _a.type, addClass = _a.addClass, onClick = _a.onClick;
    function handleClick(ev) {
        ev.stopPropagation();
        if (onClick) {
            onClick(label);
        }
    }
    return (require$$0.jsx("button", { disabled: disable, type: type, className: "action-button ".concat(addClass), onClick: handleClick, children: label }));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$1(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray$1(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/*! Copyright (c) 2021, XAPPmedia */
function insertSorted(array, obj, comparer) {
    if (!array.length) {
        array.push(obj);
        return array;
    }
    // Handle single-element array case
    if (array.length === 1) {
        var comp = comparer(obj, array[0]);
        if (comp === 0) {
            if (obj === array[0]) {
                return array; // Same object reference, skip duplicate
            }
            // Same comparison value but different object - insert after
            array.push(obj);
            return array;
        }
        if (comp < 0) {
            array.unshift(obj);
        }
        else {
            array.push(obj);
        }
        return array;
    }
    var leftIndex = 0;
    var rightIndex = array.length - 1;
    while ((rightIndex - leftIndex) > 0) {
        var left = array[leftIndex];
        var right = array[rightIndex];
        var compLeft = comparer(obj, left);
        // Allow items with equal comparison values (e.g., same timestamp) to be inserted.
        // Only skip if it's the exact same object reference.
        if (compLeft === 0) {
            if (obj === left) {
                return array; // Same object reference, skip duplicate
            }
            // Same comparison value but different object - insert after this position
            array.splice(leftIndex + 1, 0, obj);
            return array;
        }
        if (compLeft < 0) {
            array.splice(leftIndex, 0, obj);
            return array;
        }
        var compRight = comparer(obj, right);
        if (compRight === 0) {
            if (obj === right) {
                return array; // Same object reference, skip duplicate
            }
            // Same comparison value but different object - insert after this position
            array.splice(rightIndex + 1, 0, obj);
            return array;
        }
        if (compRight > 0) {
            array.splice(rightIndex + 1, 0, obj);
            return array;
        }
        if (rightIndex - leftIndex <= 1) {
            break;
        }
        var centerIndex = Math.floor((leftIndex + rightIndex) / 2);
        var center = array[centerIndex];
        var comp = comparer(center, obj);
        // Check for same object reference at center
        if (comp === 0 && obj === center) {
            return array; // Same object reference, skip duplicate
        }
        if (comp <= 0) {
            leftIndex = centerIndex;
            continue;
        }
        if (comp > 0) {
            rightIndex = centerIndex;
            continue;
        }
    }
    array.splice(leftIndex + 1, 0, obj);
    return array;
}

/**
 * Agent is determined if the provided nick string starts with `agent:`.
 *
 * This returns false if the nick string is falsey (undefined or "") or does not start with "agent:"
 * @param nick
 * @returns
 */
function isAgent(nick) {
    if (!nick) {
        return false;
    }
    return nick.startsWith("agent:");
}

function useIsMounted$1() {
    var ref = require$$1.useRef(false);
    require$$1.useEffect(function () {
        ref.current = true;
        return function () {
            ref.current = false;
        };
    }, []);
    return require$$1.useCallback(function () { return ref.current; }, []);
}

var RetryOptions = /** @class */ (function () {
    function RetryOptions() {
        this.retries = 5;
        this.timeout = 1000;
        this.log = false;
    }
    return RetryOptions;
}());
var RetryRequest = /** @class */ (function () {
    function RetryRequest(options) {
        if (options) {
            this.options = Object.assign(new RetryOptions(), options);
        }
    }
    /**
     * Fetch with retry and timeout
     *
     * Help from https://stackoverflow.com/a/66499718
     * @param executor
     * @param options
     * @returns
     */
    RetryRequest.prototype.fetch = function (executor, options) {
        return __awaiter$1(this, void 0, void 0, function () {
            var controller_1, timeoutId, response, e_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!options) {
                            options = this.options;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 5]);
                        controller_1 = new AbortController();
                        timeoutId = setTimeout(function () {
                            controller_1.abort();
                        }, options.timeout);
                        return [4 /*yield*/, executor(controller_1.signal)];
                    case 2:
                        response = _a.sent();
                        clearTimeout(timeoutId);
                        return [2 /*return*/, response];
                    case 3:
                        e_1 = _a.sent();
                        if (options.retries === 1 || options.retries < 1) {
                            // Failed
                            throw (e_1);
                        }
                        return [4 /*yield*/, this.fetch(executor, {
                                timeout: options.timeout,
                                retries: options.retries - 1
                            })];
                    case 4: 
                    // decrement the retries
                    return [2 /*return*/, _a.sent()];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return RetryRequest;
}());

/**
 * Get a display date of a specific point in time based on the current time.
 *
 * @param date
 * @returns
 */
function getTimeAgo(date) {
    var now = new Date();
    var diffInSeconds = Math.floor((now.valueOf() - date.valueOf()) / 1000);
    if (diffInSeconds < 1) {
        return "now";
    }
    if (diffInSeconds < 60) {
        return "".concat(diffInSeconds, " seconds ago");
    }
    var diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
        return "".concat(diffInMinutes, " minutes ago");
    }
    var diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
        return "".concat(diffInHours, " hours ago");
    }
    // If more than 24 hours ago, return the full date and time
    return date.toLocaleString();
}

/*! Copyright (c) 2024, XAPPmedia */
var FORM_WIDGET_SCRIPT_ID = "xapp-form-js";
var FORM_WIDGET_BASE_URL = "https://form.xapp.ai/xapp-form-widget.js";
/** Default retry configuration */
var DEFAULT_MAX_RETRIES = 3;
var DEFAULT_RETRY_DELAY_MS = 1000;
/**
 * Builds the form-widget script URL with the provided key
 */
function getFormWidgetScriptUrl(key) {
    return "".concat(FORM_WIDGET_BASE_URL, "?key=").concat(encodeURIComponent(key));
}
/**
 * Checks if the form-widget script is already loaded on the page.
 * Checks both by ID and by src URL to handle various installation methods.
 */
function isFormWidgetScriptLoaded(key) {
    // Check by standard form-widget ID
    if (document.getElementById(FORM_WIDGET_SCRIPT_ID)) {
        return true;
    }
    // Check by src URL if key is provided
    if (key) {
        var scriptUrl = getFormWidgetScriptUrl(key);
        var scripts = document.querySelectorAll("script[src]");
        for (var i = 0; i < scripts.length; i++) {
            var src = scripts[i].getAttribute("src");
            if (src && (src === scriptUrl || src.startsWith(FORM_WIDGET_BASE_URL))) {
                return true;
            }
        }
    }
    return false;
}
/**
 * Removes any failed script elements to allow retry
 */
function removeFailedScript() {
    var existingScript = document.getElementById(FORM_WIDGET_SCRIPT_ID);
    if (existingScript) {
        existingScript.remove();
    }
}
/**
 * Delays execution for a specified number of milliseconds
 */
function delay(ms) {
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
/**
 * Attempts to load the script once
 */
function attemptScriptLoad(key) {
    return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.id = FORM_WIDGET_SCRIPT_ID;
        script.src = getFormWidgetScriptUrl(key);
        script.async = true;
        script.onload = function () {
            resolve();
        };
        script.onerror = function () {
            reject(new Error("Failed to load form-widget script: ".concat(script.src)));
        };
        document.head.appendChild(script);
    });
}
/**
 * Injects the form-widget script into the page with retry logic.
 * Returns a promise that resolves when the script is loaded.
 * Does nothing if the script is already loaded.
 *
 * @param key The form widget key
 * @param maxRetries Maximum number of retry attempts (default: 3)
 * @param retryDelayMs Delay between retries in milliseconds (default: 1000)
 */
function loadFormWidgetScript(key_1) {
    return __awaiter$1(this, arguments, void 0, function (key, maxRetries, retryDelayMs) {
        var lastError, attempt, error_1;
        if (maxRetries === void 0) { maxRetries = DEFAULT_MAX_RETRIES; }
        if (retryDelayMs === void 0) { retryDelayMs = DEFAULT_RETRY_DELAY_MS; }
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Check if already loaded
                    if (isFormWidgetScriptLoaded(key)) {
                        return [2 /*return*/];
                    }
                    attempt = 0;
                    _a.label = 1;
                case 1:
                    if (!(attempt <= maxRetries)) return [3 /*break*/, 8];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 6, , 7]);
                    if (!(attempt > 0)) return [3 /*break*/, 4];
                    removeFailedScript();
                    console.log("[chat-widget] Retrying form-widget script load (attempt ".concat(attempt + 1, "/").concat(maxRetries + 1, ")"));
                    return [4 /*yield*/, delay(retryDelayMs)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [4 /*yield*/, attemptScriptLoad(key)];
                case 5:
                    _a.sent();
                    return [2 /*return*/]; // Success
                case 6:
                    error_1 = _a.sent();
                    lastError = error_1;
                    if (attempt === maxRetries) {
                        console.error("[chat-widget] Failed to load form-widget script after all retries:", error_1);
                    }
                    return [3 /*break*/, 7];
                case 7:
                    attempt++;
                    return [3 /*break*/, 1];
                case 8: throw lastError || new Error("Failed to load form-widget script");
            }
        });
    });
}
/**
 * Pre-loads the form-widget script if a key is provided.
 * This is a fire-and-forget operation - errors are logged but not thrown.
 */
function preloadFormWidgetScript(key) {
    if (!key) {
        return;
    }
    loadFormWidgetScript(key).catch(function (error) {
        console.warn("[chat-widget] Failed to preload form-widget script:", error);
    });
}
/**
 * Checks if the form-widget control API is available
 */
function isFormWidgetReady() {
    var _a;
    return typeof ((_a = window.xafwControl) === null || _a === void 0 ? void 0 : _a.openForm) === "function";
}
/**
 * Opens the form widget if it's available.
 * Returns true if the form was opened, false otherwise.
 *
 * @param options Optional configuration for opening the form
 */
function openFormWidget(options) {
    if (isFormWidgetReady()) {
        window.xafwControl.openForm(options);
        return true;
    }
    return false;
}
/**
 * Attempts to open the form widget, waiting for it to be ready if necessary.
 * Useful when the script is still loading.
 *
 * @param options Optional configuration for opening the form
 * @param maxAttempts Maximum number of attempts to check for readiness
 * @param intervalMs Time between attempts in milliseconds
 */
function openFormWidgetWhenReady(options, maxAttempts, intervalMs) {
    if (maxAttempts === void 0) { maxAttempts = 20; }
    if (intervalMs === void 0) { intervalMs = 100; }
    return new Promise(function (resolve) {
        // Try immediately first
        if (openFormWidget(options)) {
            resolve(true);
            return;
        }
        var attempts = 0;
        var checkInterval = setInterval(function () {
            attempts++;
            if (openFormWidget(options)) {
                clearInterval(checkInterval);
                resolve(true);
                return;
            }
            if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                console.warn("[chat-widget] Form widget not ready after waiting");
                resolve(false);
            }
        }, intervalMs);
    });
}

var EMAIL_REGEX = "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$";
// Initialize log level from localStorage on module load
var STORAGE_KEY = 'xaLogLevel';
var storedLogLevel = localStorage.getItem(STORAGE_KEY);
// Define property with getter/setter to persist to localStorage
// Only define the property if it hasn't been defined yet
if (!Object.getOwnPropertyDescriptor(window, "xaLogLevel")) {
    Object.defineProperty(window, "xaLogLevel", {
        // Use a private property to avoid infinite recursion in the getter/setter
        get: function () {
            return this._xaLogLevel;
        },
        set: function (value) {
            this._xaLogLevel = value;
            if (value) {
                localStorage.setItem(STORAGE_KEY, value);
            }
            else {
                localStorage.removeItem(STORAGE_KEY);
            }
        },
        configurable: true,
        // enumerable: true makes property visible in Object.keys() and for...in loops
        // This is useful for debugging to see window.xaLogLevel in console inspection
        enumerable: true
    });
}
// Restore from localStorage if available
// Note: We don't check !window.xaLogLevel because the getter returns undefined initially,
// making such a check redundant on fresh loads
if (storedLogLevel) {
    window.xaLogLevel = storedLogLevel;
}
// Create a namespaced API on window.xapp for easier access
if (typeof window !== 'undefined') {
    window.xapp = window.xapp || {};
    window.xapp.setLogLevel = function (level) {
        if (level === 'off') {
            window.xaLogLevel = null;
            console.log('Log level set to: off (logs disabled)');
        }
        else {
            window.xaLogLevel = level;
            console.log("Log level set to: ".concat(level));
        }
    };
    window.xapp.getLogLevel = function () {
        return window.xaLogLevel || 'off';
    };
}
// Returns current timestamp
function getCurrentDateString() {
    return (new Date()).toISOString() + " ::";
}
function log$3() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (window.xaLogLevel === "debug") {
        console.log.apply(console, __spreadArray$1([getCurrentDateString()], args, false));
    }
}
function err() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray$1([getCurrentDateString()], args, false));
}
var logOnce = function (key) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var map = {};
    if (!map[key]) {
        map[key] = true;
        log$3.apply(void 0, args);
    }
};

var defaultServerUrl = "";
var defaultWidgetButtonWidth = "48";
var defaultMobileWidgetButtonWidth = "30";
var defaultNonMobileScreenWidth = "400";
var scheduleWidgetUrl = "ScheduleButton";
var ChatConfigContext = require$$1.createContext(null);
function useWidgetEnv() {
    var ctx = require$$1.useContext(ChatConfigContext);
    return ctx === null || ctx === void 0 ? void 0 : ctx.env;
}
function getServerConfig(env) {
    if (env === null || env === void 0 ? void 0 : env.connection) {
        return env.connection;
    }
    return {
        serverUrl: env === null || env === void 0 ? void 0 : env.serverUrl,
        accountKey: env === null || env === void 0 ? void 0 : env.accountKey,
        type: (env === null || env === void 0 ? void 0 : env.direct) ? "direct" : "websocket",
    };
}
function useServerConfig(env, nonce) {
    var connection = getServerConfig(env);
    var accountKey = connection.accountKey, serverUrl = connection.serverUrl, type = connection.type, timeout = connection.timeout, backgroundSleepDelay = connection.backgroundSleepDelay, mcp = connection.mcp;
    return require$$1.useMemo(function () { return ({
        accountKey: accountKey,
        serverUrl: serverUrl,
        timeout: timeout,
        type: type,
        nonce: nonce,
        backgroundSleepDelay: backgroundSleepDelay,
        mcp: mcp,
    }); }, [accountKey, serverUrl, timeout, type, nonce, backgroundSleepDelay, mcp]);
}
function useConnectionInfo(env) {
    var nonce = reactRedux.useSelector(function (state) { return state.connection.nonce; });
    log$3("nonce from Redux: ".concat(nonce));
    return useServerConfig(env, nonce);
}

var Avatar$3 = function (props) {
    var _a, _b, _c, _d, _e;
    var style = {};
    var child;
    var entity = props.entity;
    var chatConfig = require$$1.useContext(ChatConfigContext);
    var avatarPath = entity === null || entity === void 0 ? void 0 : entity.avatarPath;
    if (!avatarPath) {
        var avatarImage = GenerateAvatar({
            initials: (entity === null || entity === void 0 ? void 0 : entity.displayName) ? entity.displayName.slice(0, 2) : "?",
            backgroundColor: (_b = (_a = chatConfig === null || chatConfig === void 0 ? void 0 : chatConfig.env) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.primaryColor,
            size: 36,
        });
        avatarPath = avatarImage.src;
    }
    var agentAva = entity && isAgent(entity.nick);
    if (agentAva) {
        style.backgroundImage = "url('".concat(avatarPath, "')");
        style.backgroundColor = "none";
    }
    else {
        child = getVisitorSvg();
    }
    var hasImage = !!style.backgroundImage || !!child;
    // Show AI badge if configured and the entity is an AI
    var showAiBadge = ((_e = (_d = (_c = chatConfig === null || chatConfig === void 0 ? void 0 : chatConfig.env) === null || _c === void 0 ? void 0 : _c.connection) === null || _d === void 0 ? void 0 : _d.mcp) === null || _e === void 0 ? void 0 : _e.showAiBadge) && (entity === null || entity === void 0 ? void 0 : entity.isAI);
    return (require$$0.jsxs("div", { className: "avatar ".concat(agentAva ? "avatar--agent" : "avatar--visitor", " ").concat(!hasImage ? "avatar--empty" : ""), style: style, title: entity ? entity.display_name : "Agent", children: [child, showAiBadge && require$$0.jsx("span", { className: "avatar__ai-badge", children: "AI" })] }));
};
/**
 * Generates an SVG based on the
 * @returns
 */
function getVisitorSvg() {
    return (require$$0.jsx("svg", { width: "16", height: "19", viewBox: "0 0 16 19", style: { margin: "0 auto", display: "block" }, children: require$$0.jsx("path", { d: "M11.5 5c0-1.933-1.567-3.5-3.5-3.5S4.5 3.067 4.5 5 6.067 8.5 8 8.5s3.5-1.567 3.5-3.5zM3 5c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5zM1.955 17.294c.21-.642.504-1.285.898-1.88C3.963 13.74 5.615 12.75 8 12.75c2.385 0 4.038.99 5.147 2.664.394.595.69 1.238.898 1.88.124.382.19.672.214.822.063.41.447.69.856.625.41-.063.69-.447.625-.856-.034-.225-.118-.59-.27-1.053-.247-.763-.598-1.527-1.073-2.244C13.024 12.51 10.917 11.25 8 11.25c-2.916 0-5.024 1.26-6.397 3.336-.475.717-.826 1.48-1.074 2.245-.152.463-.236.83-.27 1.054-.065.41.215.793.624.857.41.065.793-.215.857-.624.025-.15.09-.44.215-.822z", fill: "#FFF", fillRule: "evenodd" }) }));
}
function GenerateAvatar(props) {
    var initials = (props === null || props === void 0 ? void 0 : props.initials) || "?";
    var size = (props === null || props === void 0 ? void 0 : props.size) || 40;
    var backgroundColor = (props === null || props === void 0 ? void 0 : props.backgroundColor) || "#007bff";
    var textColor = (props === null || props === void 0 ? void 0 : props.textColor) || "#ffffff";
    var image = require$$1.useMemo(function () {
        return generateImage(initials, size, backgroundColor, textColor);
    }, [initials, size, backgroundColor, textColor]);
    return image;
}
function generateImage(initials, size, backgroundColor, textColor) {
    var canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    var context = canvas.getContext("2d");
    // Draw background
    context.fillStyle = backgroundColor;
    context.fillRect(0, 0, size, size);
    // Draw text
    context.fillStyle = textColor;
    context.font = "".concat(size / 2, "px Arial");
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.fillText(initials, size / 2, size / 2);
    // Create image
    var image = new Image();
    image.src = canvas.toDataURL();
    return image;
}

function isChatServerActionLink(arg) {
    return arg.hasOwnProperty("label");
}
function getChatServerActionLinkLabel(arg) {
    if (isChatServerActionLink(arg)) {
        return arg.label;
    }
    return arg;
}
function getItemUrl(item) {
    return item.url || item.imageActionUrl;
}

var useChatDispatch = function () { return reactRedux.useDispatch(); };

var OptionalLink = function (props) {
    var chatDispatch = useChatDispatch();
    var visuals = reactRedux.useSelector(function (state) { return state.visuals; });
    var url = props.url, className = props.className, onOpen = props.onOpen;
    var handleOpenUrl = require$$1.useCallback(function () {
        if (onOpen) {
            onOpen(url, chatDispatch, visuals);
        }
    }, [url, onOpen]);
    if (url) {
        return (require$$0.jsx("div", { onClick: handleOpenUrl, className: className, children: props.children }));
    }
    else {
        return (require$$0.jsx("div", { onClick: props.onClick, className: className, children: props.children }));
    }
};

var ActionItem = function (props) {
    var _a;
    var item = props.item, onButtonClick = props.onButtonClick, onExecute = props.onExecute;
    var singleButton = ((_a = item.buttons) === null || _a === void 0 ? void 0 : _a.length) === 1;
    var handleClick = require$$1.useCallback(function () {
        var _a;
        var btns = (_a = item.buttons) === null || _a === void 0 ? void 0 : _a.length;
        // If there is only one button, it takes precedent
        // and the whole thing is the button
        if (btns === 1) {
            onButtonClick(item.buttons[0]);
        }
        else {
            onExecute(item.title, item.token);
        }
    }, [item, onExecute, onButtonClick]);
    var className = "xappw-chat-action-item ".concat(singleButton ? "xappw-chat-action-item--action" : "", " ").concat(props.className);
    return (require$$0.jsx(OptionalLink, { className: className, url: getItemUrl(item), onClick: handleClick, onOpen: props.onOpenUrl, children: props.children }));
};

var ChatImage = function (props) {
    var cleanUrl = props.imageUrl.replace(/'/g, "%27");
    var content = (require$$0.jsx("div", { className: "chat-card-img__content", style: { backgroundImage: "url(".concat(cleanUrl, ")") } }));
    if (!props.imageActionUrl) {
        return require$$0.jsx("div", { className: "chat-card-img", children: content });
    }
    else {
        return (require$$0.jsx("a", { href: props.imageActionUrl, "aria-label": "read more", target: "_blank", rel: "noopener noreferrer", className: "chat-card-img", children: content }));
    }
};

var ActionItemImage = function (props) {
    var _a;
    var item = props.item;
    var singleButton = ((_a = item.buttons) === null || _a === void 0 ? void 0 : _a.length) === 1;
    var itemUrl = getItemUrl(item);
    if (item.imageUrl) {
        var imageActionUrl = !singleButton ? item.imageActionUrl : null;
        return (require$$0.jsx("div", { className: props.className, children: require$$0.jsx(ChatImage, { imageUrl: item.imageUrl, imageActionUrl: !itemUrl && imageActionUrl }) }));
    }
    else if (props.emptyImageVisible) {
        return require$$0.jsx("div", { className: props.className });
    }
    return require$$0.jsx(require$$0.Fragment, {});
};

var ChatActionButtonInner = function (props) {
    var button = props.button, onClick = props.onClick;
    var handleButton = require$$1.useCallback(function () {
        onClick(button);
    }, [button, onClick]);
    return require$$0.jsx(ActionButton, { onClick: handleButton, addClass: "button-card", label: button.label });
};
var ChatActionButton = require$$1.memo(ChatActionButtonInner);

var ChatActionButtonsInner = function (props) {
    return (require$$0.jsx("div", { className: "buttons-container " + (props.className || ""), children: props.buttons.map(function (button, i) {
            return require$$0.jsx(ChatActionButton, { button: button, onClick: props.onClick }, i);
        }) }));
};
var ChatActionButtons = require$$1.memo(ChatActionButtonsInner);

var CarouselItem = function (props) {
    var _a;
    var item = props.item;
    return (require$$0.jsx(ActionItem, { className: "chat-list-item-container", item: item, onButtonClick: props.onButtonClick, onExecute: props.onExecute, onOpenUrl: props.onOpenUrl, children: require$$0.jsxs("div", { className: "chat-list-item", children: [require$$0.jsx(ActionItemImage, { item: item, className: "chat-list-item__img", emptyImageVisible: props.emptyImageVisible }), item.title && (require$$0.jsx("div", { className: "chat-list-item__title", children: require$$0.jsx("span", { children: item.title }) })), item.subTitle && (require$$0.jsx("div", { className: "chat-list-item__subtitle", children: require$$0.jsx("span", { children: item.subTitle }) })), !!((_a = item.buttons) === null || _a === void 0 ? void 0 : _a.length) && (require$$0.jsx(ChatActionButtons, { className: "chat-list-item__actions", buttons: item.buttons, onClick: props.onButtonClick }))] }) }));
};

function getLeftArrowSvg() {
    return (require$$0.jsx("svg", { viewBox: "-5 -18 10 36", children: require$$0.jsx("path", { d: "M 2.5 -15 L -2.5 0 L 2.5 15", stroke: "currentColor", strokeLinecap: "square", strokeWidth: "4px", fill: "none" }) }));
}
var ChevronLeft = function (props) {
    return (require$$0.jsx("button", { onClick: props.onClick, className: "xa-chevron", children: getLeftArrowSvg() }));
};

function getRightArrowSvg() {
    return (require$$0.jsx("svg", { viewBox: "-5 -18 10 36", children: require$$0.jsx("path", { d: "M -2.5 -15 L 2.5 0 L -2.5 15", stroke: "currentColor", strokeLinecap: "square", strokeWidth: "4px", fill: "none" }) }));
}
var ChevronRight = function (props) {
    return (require$$0.jsx("button", { onClick: props.onClick, className: "xa-chevron", children: getRightArrowSvg() }));
};

var Carousel = function (props) {
    var listRef = require$$1.useRef(null);
    var _a = require$$1.useState(0), visibleIndex = _a[0], setSetVisibleIndex = _a[1];
    function scrollMe(direction) {
        var _a, _b;
        var scrollArea = listRef.current;
        if (scrollArea) {
            var items = scrollArea.getElementsByClassName("xappw-carousel-items__item");
            var noOfItems = items.length;
            var newVisibleIndex = visibleIndex;
            // check the boundaries
            if (direction === 1) {
                if (visibleIndex < noOfItems - 1) {
                    newVisibleIndex++;
                }
            }
            else {
                if (visibleIndex > 0) {
                    newVisibleIndex--;
                }
            }
            var leftOffset = 0;
            // tslint:disable-next-line:prefer-for-of
            for (var index = 0; index < items.length; index++) {
                if (index === newVisibleIndex) {
                    break;
                }
                leftOffset += (_b = (_a = items.item(index)) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
            }
            scrollArea.scrollLeft = leftOffset;
            setSetVisibleIndex(newVisibleIndex);
        }
    }
    var hasOnlyOneItem = props.list.items.length === 1;
    var hasImage = props.list.items.some(function (item) { return item.imageUrl; });
    var listItems = props.list.items.map(function (item, itemIndex) {
        return (require$$0.jsx("div", { className: "xappw-carousel-items__item", children: require$$0.jsx(CarouselItem, { item: item, emptyImageVisible: hasImage, onExecute: props.onExecute, onButtonClick: props.onButtonClick, onOpenUrl: props.onOpenUrl }) }, "item-key-".concat(itemIndex)));
    });
    return (require$$0.jsxs("div", { className: "xappw-carousel", children: [!hasOnlyOneItem && (require$$0.jsx("div", { className: "xappw-carousel__prev", children: require$$0.jsx(ChevronLeft, { onClick: function () { return scrollMe(-1); } }) })), require$$0.jsx("div", { ref: listRef, className: "xappw-carousel-items ".concat(hasOnlyOneItem ? "xappw-carousel-items--one-item" : ""), children: listItems }), !hasOnlyOneItem && (require$$0.jsx("div", { className: "xappw-carousel__next", children: require$$0.jsx(ChevronRight, { onClick: function () { return scrollMe(1); } }) }))] }));
};

function useDimensions() {
    var ref = require$$1.useRef(null);
    var _a = require$$1.useState(), dimensions = _a[0], setDimensions = _a[1];
    require$$1.useLayoutEffect(function () {
        var _a, _b;
        setDimensions((_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.toJSON());
    }, []);
    return [ref, dimensions];
}

function add$1$1(left, right) {
    return { x: left.x + right.x, y: left.y + right.y };
}
function sub$1$1(left, right) {
    return { x: left.x - right.x, y: left.y - right.y };
}
function mul(val, k) {
    return { x: val.x * k, y: val.y * k };
}
function len(vec) {
    return Math.sqrt(vec.x * vec.x + vec.y * vec.y);
}
function resize(vec, length) {
    var currentLength = len(vec);
    if (!currentLength) {
        return vec;
    }
    return mul(vec, length / currentLength);
}
function rotateZ(vec, angle) {
    var rad = (angle * Math.PI) / 180;
    var ca = Math.cos(rad);
    var sa = Math.sin(rad);
    var resx = vec.x * ca + vec.y * sa;
    var resy = vec.y * ca - vec.x * sa;
    return { x: resx, y: resy };
}
function intersectLineEllipsis(ellipsis, line) {
    var lineStartRel = sub$1$1(line.start, ellipsis.center);
    var sx = lineStartRel.x;
    var sy = lineStartRel.y;
    var kx = line.direction.x;
    var ky = line.direction.y;
    var rx = ellipsis.radius.x;
    var ry = ellipsis.radius.y;
    var rx2 = rx * rx;
    var ry2 = ry * ry;
    var a = (kx * kx) / rx2 + (ky * ky) / ry2;
    var b = (2 * kx * sx) / rx2 + (2 * ky * sy) / ry2;
    var c = (sx * sx) / rx2 + (sy * sy) / ry2 - 1;
    var d2 = b * b - 4 * a * c;
    if (d2 >= 0) {
        var d = Math.sqrt(d2);
        var t1 = (-b - d) / (2 * a);
        var t2 = (-b + d) / (2 * a);
        if (t1 > 0 && t2 > 0) {
            return add$1$1(line.start, mul(line.direction, Math.min(t1, t2)));
        }
        if (t1 > 0) {
            return add$1$1(line.start, mul(line.direction, t1));
        }
        if (t2 > 0) {
            return add$1$1(line.start, mul(line.direction, t2));
        }
    }
    return line.start;
}
function getTailSvgPath$1(props, viewport) {
    var baseAngleRad = (props.direction * Math.PI) / 180;
    var radius = { x: props.width / 2, y: props.height / 2 };
    var center = { x: viewport.x / 2, y: viewport.y / 2 };
    var intersectionRel = {
        x: radius.x * Math.cos(baseAngleRad),
        y: radius.y * Math.sin(baseAngleRad),
    };
    var farRel = resize(intersectionRel, len(intersectionRel) + props.length);
    var far = add$1$1(farRel, center);
    var direction = sub$1$1(intersectionRel, farRel);
    var angle = props.angle;
    var leftDirection = rotateZ(direction, angle / 2);
    var rightDirection = rotateZ(direction, -angle / 2);
    var ellipsis = {
        center: center,
        radius: radius,
    };
    var left = intersectLineEllipsis(ellipsis, {
        start: far,
        direction: leftDirection,
    });
    var right = intersectLineEllipsis(ellipsis, {
        start: far,
        direction: rightDirection,
    });
    return "m ".concat(far.x, " ").concat(far.y, " L ").concat(left.x, " ").concat(left.y, " L ").concat(right.x, " ").concat(right.y, " z");
}
var CtaBubbleTail = function (props) {
    var _a, _b;
    var _c = useDimensions(), ref = _c[0], rect = _c[1];
    var viewPort = { x: (_a = rect === null || rect === void 0 ? void 0 : rect.width) !== null && _a !== void 0 ? _a : 0, y: (_b = rect === null || rect === void 0 ? void 0 : rect.height) !== null && _b !== void 0 ? _b : 0 };
    return (require$$0.jsx("div", { ref: ref, className: "cta-bubble__tail", children: require$$0.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 ".concat(viewPort.x, " ").concat(viewPort.y), children: require$$0.jsx("path", { d: getTailSvgPath$1(props, viewPort), fill: "currentColor" }) }) }));
};
var CtaBubble = function (props) {
    var _a, _b, _c, _d;
    var _e = useDimensions(), ref = _e[0], rect = _e[1];
    var animate = props.animate || false;
    var animation = animate && props.buttonAnimation === "bounce" ? "bounce" : "none";
    var handleDismiss = function (e) {
        e.stopPropagation();
        if (props.onDismiss) {
            props.onDismiss();
        }
    };
    console.log("Returning CTABubble with message: ", props.children);
    return (require$$0.jsxs("div", { ref: ref, style: {
            border: props.borderStyle ? "solid" : "none",
            borderWidth: ((_a = props.borderStyle) === null || _a === void 0 ? void 0 : _a.width) || "0px",
            borderColor: ((_b = props.borderStyle) === null || _b === void 0 ? void 0 : _b.color) || "transparent",
            animation: "".concat(animation, " 1s infinite"),
        }, className: "cta-bubble", onClick: props.onClick, children: [require$$0.jsx(CtaBubbleTail, { width: (_c = rect === null || rect === void 0 ? void 0 : rect.width) !== null && _c !== void 0 ? _c : 0, height: (_d = rect === null || rect === void 0 ? void 0 : rect.height) !== null && _d !== void 0 ? _d : 0, direction: 60, angle: 45, length: 16 }), require$$0.jsx("div", { className: "cta-bubble__content", children: props.children }), props.dismissible && (require$$0.jsx("button", { className: "cta-bubble__dismiss", onClick: handleDismiss, "aria-label": "Dismiss", children: require$$0.jsx("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: require$$0.jsx("path", { d: "M11 1L1 11M1 1L11 11", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }) }))] }));
};

var CtaBubbleContainer = function (props) {
    var visible = props.visible, timeout = props.timeout, delay = props.delay, animate = props.animate, buttonAnimation = props.buttonAnimation, dismissible = props.dismissible, onClick = props.onClick, onDismiss = props.onDismiss, children = props.children;
    // Debug: Log all props received
    log$3("[CtaBubbleContainer] Props received:", {
        visible: visible,
        timeout: timeout,
        delay: delay,
        animate: animate,
        buttonAnimation: buttonAnimation,
        dismissible: dismissible,
        hasOnClick: !!onClick,
        hasOnDismiss: !!onDismiss,
        hasChildren: !!children,
        childrenContent: children,
    });
    var startTime = require$$1.useMemo(function () {
        var time = visible ? new Date().valueOf() : undefined;
        log$3("[CtaBubbleContainer] StartTime calculated: visible=".concat(visible, ", startTime=").concat(time));
        return time;
    }, [visible]);
    var _a = require$$1.useState(false), showBubble = _a[0], setShowBubble = _a[1];
    log$3("[CtaBubbleContainer] Current state: showBubble=".concat(showBubble));
    require$$1.useEffect(function () {
        log$3("[CtaBubbleContainer] useEffect triggered with:", {
            startTime: startTime,
            startTimeExists: !!startTime,
            timeout: timeout,
            timeoutType: typeof timeout,
            delay: delay,
            delayType: typeof delay,
            visible: visible,
        });
        var hideTimer = null;
        var delayTimer = null;
        var isMounted = true;
        if (startTime) {
            var actualDelay_1 = delay || 0;
            log$3("[CtaBubbleContainer] Timer setup: actualDelay=".concat(actualDelay_1, "ms (from delay=").concat(delay, ")"));
            delayTimer = setTimeout(function () {
                log$3("[CtaBubbleContainer] Delay timer fired after ".concat(actualDelay_1, "ms, isMounted=").concat(isMounted));
                if (isMounted) {
                    log$3("[CtaBubbleContainer] Component still mounted, setting showBubble=true");
                    setShowBubble(true);
                    if (typeof timeout === "number") {
                        log$3("[CtaBubbleContainer] Hide timer setup: will hide after ".concat(timeout, "ms"));
                        hideTimer = setTimeout(function () {
                            log$3("[CtaBubbleContainer] Hide timer fired after ".concat(timeout, "ms, isMounted=").concat(isMounted));
                            if (isMounted) {
                                log$3("[CtaBubbleContainer] Component still mounted, setting showBubble=false");
                                setShowBubble(false);
                            }
                            else {
                                log$3("[CtaBubbleContainer] Component unmounted, skipping hide");
                            }
                        }, timeout);
                    }
                    else {
                        log$3("[CtaBubbleContainer] No hide timer set (timeout=".concat(timeout, ", type=").concat(typeof timeout, ")"));
                    }
                }
                else {
                    log$3("[CtaBubbleContainer] Component unmounted before delay timer, not showing bubble");
                }
            }, actualDelay_1);
        }
        else {
            log$3("[CtaBubbleContainer] No startTime, skipping timer setup");
        }
        return function () {
            log$3("[CtaBubbleContainer] Cleanup triggered, unmounting component");
            isMounted = false;
            if (hideTimer) {
                log$3("[CtaBubbleContainer] Clearing hide timer");
                clearTimeout(hideTimer);
            }
            if (delayTimer) {
                log$3("[CtaBubbleContainer] Clearing delay timer");
                clearTimeout(delayTimer);
            }
        };
    }, [startTime, timeout, delay, visible]);
    var handleDismiss = function () {
        log$3("[CtaBubbleContainer] handleDismiss called, setting showBubble=false");
        setShowBubble(false);
        if (onDismiss) {
            log$3("[CtaBubbleContainer] Calling onDismiss callback");
            onDismiss();
        }
    };
    // Final render decision
    var shouldRender = visible && showBubble;
    log$3("[CtaBubbleContainer] Render decision: visible=".concat(visible, ", showBubble=").concat(showBubble, ", shouldRender=").concat(shouldRender));
    return (require$$0.jsx(require$$0.Fragment, { children: visible && showBubble && (require$$0.jsx(CtaBubble, { onClick: onClick, animate: animate, buttonAnimation: buttonAnimation, dismissible: dismissible, onDismiss: handleDismiss, children: children })) }));
};

var ChatButton = function (_a) {
    var _b;
    var onClick = _a.onClick, addClass = _a.addClass, config = _a.config, visible = _a.visible, borderStyle = _a.borderStyle, imageUrl = _a.imageUrl, hasInteracted = _a.hasInteracted, onCtaDismiss = _a.onCtaDismiss;
    var _c = require$$1.useState(defaultWidgetButtonWidth), buttonWidth = _c[0], setButtonWidth = _c[1];
    var _d = require$$1.useState(false), animate = _d[0], setAnimate = _d[1];
    var mobileWidth = ((_b = config === null || config === void 0 ? void 0 : config.mobile) === null || _b === void 0 ? void 0 : _b.applyAtLessThanWidth) || defaultNonMobileScreenWidth;
    // Determines mobile or normal
    var getConfigToApply = function () {
        var screenWidth = window.innerWidth;
        if (screenWidth <= parseInt(mobileWidth, 10) && (config === null || config === void 0 ? void 0 : config.mobile)) {
            return config.mobile;
        }
        else {
            return config;
        }
    };
    var configToApply = getConfigToApply();
    require$$1.useEffect(function () {
        var _a;
        var delayTimer;
        var timeoutTimer;
        // Don't animate if user has already interacted
        if (hasInteracted) {
            setAnimate(false);
            return function () { }; // Return empty cleanup function
        }
        // Use animationDelay if provided, otherwise fall back to delay for backwards compatibility
        var animationDelayToUse = (_a = configToApply === null || configToApply === void 0 ? void 0 : configToApply.animationDelay) !== null && _a !== void 0 ? _a : configToApply === null || configToApply === void 0 ? void 0 : configToApply.delay;
        if (animationDelayToUse) {
            // Set a delay for the animation to start
            delayTimer = setTimeout(function () {
                setAnimate(true);
                if (configToApply.animationTimeout) {
                    // Stop the animation after the specified timeout
                    timeoutTimer = setTimeout(function () {
                        setAnimate(false);
                    }, configToApply.animationTimeout);
                }
            }, animationDelayToUse);
        }
        else if (configToApply === null || configToApply === void 0 ? void 0 : configToApply.animationTimeout) {
            // Start animation immediately and set a timeout to stop it
            setAnimate(true);
            timeoutTimer = setTimeout(function () {
                setAnimate(false);
            }, configToApply.animationTimeout);
        }
        else if (configToApply === null || configToApply === void 0 ? void 0 : configToApply.animation) {
            // No delay or timeout, start animation immediately
            setAnimate(true);
        }
        return function () {
            // Clear timers on unmount or when dependencies change
            if (delayTimer)
                clearTimeout(delayTimer);
            if (timeoutTimer)
                clearTimeout(timeoutTimer);
        };
    }, [configToApply, setAnimate, hasInteracted]);
    var animation = animate && !hasInteracted ? (configToApply === null || configToApply === void 0 ? void 0 : configToApply.animation) || "wiggle" : "none";
    require$$1.useEffect(function () {
        var handleResize = function () {
            var screenWidth = window.innerWidth;
            var newButtonWidth = screenWidth < parseInt(mobileWidth, 10)
                ? defaultMobileWidgetButtonWidth
                : defaultWidgetButtonWidth;
            setButtonWidth(newButtonWidth);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, [mobileWidth]);
    var maxSvgSize = 22;
    var svgSize = Math.min(maxSvgSize, (+buttonWidth / +defaultWidgetButtonWidth) * maxSvgSize);
    return (require$$0.jsxs("button", { "aria-label": "open chat", className: "xapp-chat-button ".concat(addClass || "").trim(), onClick: onClick, children: [require$$0.jsx("div", { id: "xapp-widget-button", className: "xapp-chat-button__btn", style: {
                    width: "".concat(buttonWidth, "px"),
                    height: "".concat(buttonWidth, "px"),
                    borderRadius: "".concat(+buttonWidth / 2, "px"),
                    border: borderStyle && borderStyle.width ? "solid" : "none",
                    borderWidth: (borderStyle === null || borderStyle === void 0 ? void 0 : borderStyle.width) || "0px",
                    borderColor: (borderStyle === null || borderStyle === void 0 ? void 0 : borderStyle.color) || "transparent",
                    animation: "".concat(animation, " 1s infinite"),
                }, children: imageUrl ? (
                // Display image from URL
                require$$0.jsx("img", { src: imageUrl, alt: "Chat Icon" })) : (
                // Fallback to default SVG
                require$$0.jsx("svg", { width: svgSize, height: svgSize, viewBox: "0 0 22 22", children: require$$0.jsx("path", { d: "M13 22l-4-6H2c-1.11-.043-2-.935-2-2V2C0 .89.89 0 2 0h18c1.11 0 2 .892 2 2v12c0 1.067-.89 1.957-2 2h-3l-4 6zm3-8h4c-.005.3-.01-12 0-12-.01.004-18 .006-18 0 .005.006 0 12 0 12h8l3 5 3-5z", fill: "#FFF", fillRule: "evenodd" }) })) }), configToApply && configToApply.message && !hasInteracted && (require$$0.jsx("div", { className: "xapp-chat-button__cta", children: require$$0.jsx(CtaBubbleContainer, { timeout: configToApply === null || configToApply === void 0 ? void 0 : configToApply.timeout, delay: configToApply === null || configToApply === void 0 ? void 0 : configToApply.delay, animate: animate, buttonAnimation: animation, dismissible: configToApply === null || configToApply === void 0 ? void 0 : configToApply.dismissible, visible: !visible /** Why is this !visible */, onDismiss: onCtaDismiss, children: configToApply === null || configToApply === void 0 ? void 0 : configToApply.message }) }))] }));
};

var ChatCard = function (props) {
    var _a;
    var card = props.card;
    var title;
    var image;
    var content;
    if (card.imageUrl) {
        image = (require$$0.jsx("div", { className: "chat-card-container__img", children: require$$0.jsx(ChatImage, { imageUrl: card.imageUrl, imageActionUrl: card.imageActionUrl }) }));
    }
    if (card.title) {
        title = (require$$0.jsx("div", { className: "chat-card-title", children: require$$0.jsx("span", { children: card.title }) }));
    }
    if (card.content) {
        content = (require$$0.jsx("div", { className: "chat-card-sub-title", children: require$$0.jsx("span", { children: card.content }) }));
    }
    return (require$$0.jsxs("div", { className: "chat-card-container", children: [image, title, content, !!((_a = card.buttons) === null || _a === void 0 ? void 0 : _a.length) && (require$$0.jsx(ChatActionButtons, { buttons: card.buttons, onClick: props.onButtonClick }))] }));
};

var ChatChip = function (props) {
    var option = props.option;
    var className = option.actionUrl
        ? "chat-chip chat-chip-link"
        : "chat-chip";
    return (require$$0.jsx("div", { onClick: function () { return props === null || props === void 0 ? void 0 : props.onClick(option); }, className: className, children: require$$0.jsx("span", { children: typeof option === "object" ? option.label : option }) }));
};

/**
 * Render option list. We just follow the order.
 */
var ChatChips = function (props) {
    return (require$$0.jsx("div", { className: "chat-chips", children: props.options.map(function (option, i) {
            return require$$0.jsx(ChatChip, { onClick: props.onOptionClick, option: option }, i);
        }) }));
};

var defaultBehavior = {
    type: "newWindow"
};
function resolveUrlPolicy(url, config) {
    if (config.policies) {
        for (var _i = 0, _a = config.policies; _i < _a.length; _i++) {
            var policy = _a[_i];
            try {
                var re = new RegExp(policy.pattern, "gi");
                if (re.test(url)) {
                    return policy.behavior;
                }
            }
            catch (_b) {
            }
        }
    }
    return config.defaultBehavior || defaultBehavior;
}

// compile time full switch-case verification
function throwBadKind$1(x) {
    throw new Error("Unknown kind " + x);
}

function setVisualStatus(status) {
    return {
        type: "visual_status",
        detail: {
            status: status,
            timestamp: new Date().getTime()
        }
    };
}

function execute(url, dispatch, visuals, behavior) {
    var _a, _b;
    if (!dispatch || !visuals) {
        throw new Error("OpenUrl: No dispatch and/or visual.");
    }
    if (url === scheduleWidgetUrl) {
        // It's actually toggle
        var toggleForm = (_a = window.xafwControl) === null || _a === void 0 ? void 0 : _a.openForm;
        if (!toggleForm) {
            err("Cannot find toggleForm! Update form widget!");
            return;
        }
        var isFormActive = false;
        var formStatus = (_b = window.xafwControl) === null || _b === void 0 ? void 0 : _b.formStatus;
        if (formStatus) {
            var formVisuals = formStatus();
            isFormActive = formVisuals.active;
        }
        else {
            err("Cannot find formStatus! Update form widget!");
        }
        // If form is active and we are here, then both widgets are active. Do nothing. Let the user X out the widgets.
        if (!isFormActive) {
            toggleForm();
            if (visuals.opened) {
                dispatch(setVisualStatus({
                    opened: false
                }));
            }
        }
        return;
    }
    // Attempt to add query string to the url
    // if the query string already exists, it will not be added
    try {
        var urlObj = new URL(url);
        var params = new URLSearchParams(urlObj.search);
        // look for utm_source, if it doesn't exist, add it
        if (!params.has("utm_source")) {
            params.append("utm_source", "xapp");
        }
        // now add the query string back to the url
        urlObj.search = params.toString();
        // and finally, update the url
        url = urlObj.toString();
    }
    catch (_) {
        // do nothing
    }
    var type = behavior.type;
    switch (type) {
        case "newWindow":
            if (visuals.opened) {
                dispatch(setVisualStatus({
                    opened: false
                }));
            }
            window.open(url, "callout-option", "toolbar=0,status=0,width=".concat(behavior.width || 1000, ",height=").concat(behavior.height || 700));
            break;
        case "newTab":
            if (visuals.opened) {
                dispatch(setVisualStatus({
                    opened: false
                }));
            }
            window.open(url, "_blank");
            break;
        case "sameWindow":
            if (!visuals.opened) {
                dispatch(setVisualStatus({
                    opened: true
                }));
            }
            window.open(url, "_self");
            break;
        default:
            throwBadKind$1(type);
    }
}
function useOpenUrlCallback() {
    var env = useWidgetEnv();
    return require$$1.useCallback(function (url, dispatch, visuals, behavior) {
        if (!behavior) {
            behavior = (env === null || env === void 0 ? void 0 : env.urls) ? resolveUrlPolicy(url, env.urls) : defaultBehavior;
        }
        execute(url, dispatch, visuals, behavior);
    }, [env]);
}

function writeMessage(msg, user, timestamp) {
    return {
        type: "synthetic",
        detail: {
            type: "write_msg",
            user: user,
            msg: msg,
            timestamp: timestamp !== undefined ? timestamp : +new Date()
        }
    };
}

function executeAction(text, meta) {
    return function (chatServer) { return function (dispatch, getState) {
        // add in attributes from meta
        var attributes = getState().attributes;
        attributes = __assign$1(__assign$1({}, attributes), { currentUrl: window.location.href });
        var _a = meta || {}, token = _a.token, rest = __rest$1(_a, ["token"]);
        attributes = __assign$1(__assign$1({}, attributes), rest);
        // Add user message to Redux BEFORE sending to server
        // to ensure it appears above the bot's streaming response
        var visitor = getState().visitor;
        var userMsgTimestamp = +new Date();
        dispatch(writeMessage({
            text: !token ? text : "".concat(text, " (from the list)"),
        }, visitor, userMsgTimestamp));
        chatServer.sendChatMsg({ text: text, token: token, attributes: attributes }, function (err) {
            if (err) {
                log$3("Error sending message", err);
                return;
            }
        });
    }; };
}

/**
 * This is not used anymore. It was part of the handshake with the legacy "chat server"
 *
 * @param token
 * @returns
 */
function receiveToken(token) {
    return {
        type: "receiveToken",
        detail: {
            token: token,
            timestamp: +new Date(),
            type: "receiveToken",
            user: undefined
        }
    };
}

function sendChatRating(rating) {
    return function (chatServer) { return function () {
        chatServer.sendChatRating(rating);
    }; };
}

function sendFile(file) {
    return function (chatServer) { return function (dispatch, getState) {
        var state = getState();
        // Don't allow visitor to send file if offline
        if (state.accountStatus === "offline" && !state.isChatting)
            return;
        // Generate attachment object for local echo
        var attachment = {
            mimeType: file.type,
            name: file.name,
            size: file.size,
            url: window.URL.createObjectURL(file)
        };
        chatServer.sendFile(file, function (err) {
            if (err) {
                log$3("Error sending file", err);
                return;
            }
        });
        dispatch({
            type: "synthetic",
            detail: {
                type: "visitor.send.file",
                attachment: attachment,
                user: {
                    nick: "",
                },
                attributes: { currentUrl: window.location.href },
                timestamp: +new Date()
            }
        });
    }; };
}

function sendGreeting(PRECHAT_FORM_ENABLED) {
    if (PRECHAT_FORM_ENABLED === void 0) { PRECHAT_FORM_ENABLED = false; }
    return function (chatServer) { return function (dispatch, getState) {
        if (!PRECHAT_FORM_ENABLED) {
            var state = getState();
            if (!state.connection.greetingRequested) {
                log$3("sending greeting");
                // Send nothing to get the greeting content
                chatServer.sendChatMsg({ text: undefined, attributes: { isGreeting: true } }, function (err2) {
                    if (err2) {
                        log$3("Error sending message");
                    }
                    dispatch({
                        type: "sendGreeting",
                        detail: undefined
                    });
                });
            }
        }
    }; };
}

function sendMessage(msg) {
    return function (chatServer) { return function (dispatch, getState) {
        var state = getState();
        // Don't allow visitor to send message if offline
        if (state.accountStatus === "offline" && !state.isChatting)
            return;
        // Write user message to Redux before server send so it appears above streaming response
        if (msg.msg) {
            dispatch(writeMessage(msg.msg, state.visitor, +new Date()));
        }
        chatServer.sendChatMsgRequest(msg, function () { });
    }; };
}

function sendOfflineMsg(data) {
    return function (chatServer) { return function () {
        chatServer.sendOfflineMsg(data, function (err) {
            if (err) {
                log$3(err);
            }
        });
    }; };
}

function sendTyping(typing) {
    return function (chatServer) { return function () {
        chatServer.sendTyping(typing);
    }; };
}

function sendVisitorInfo(msg, sessionId) {
    return function (chatServer) { return function () {
        chatServer.setVisitorInfo(msg, sessionId, function (err) {
            if (err) {
                log$3(err);
            }
        });
    }; };
}

function setAccountStatus(status) {
    return {
        type: "account_status",
        detail: {
            status: status,
            timestamp: +new Date()
        }
    };
}

function setConnectionStatus(status) {
    return {
        type: "connection_update",
        detail: {
            status: status,
            timestamp: +new Date()
        }
    };
}

function sendBargeIn(agentName) {
    return function (chatServer) { return function () {
        chatServer.bargeIn(agentName, function (err) {
            if (err) {
                log$3(err);
            }
        });
    }; };
}

function sendBargeOut() {
    return function (chatServer) { return function () {
        chatServer.bargeOut(function (err) {
            if (err) {
                log$3(err);
            }
        });
    }; };
}

function reset() {
    return {
        type: "reset"
    };
}

function displayWsButton(params) {
    return {
        type: "ws_button_display",
        detail: {
            id: params.id,
            text: params.text,
            pressBehavior: params.pressBehavior,
            isPressed: params.isPressed,
            isDismissing: params.isDismissing,
            timestamp: +new Date()
        }
    };
}

function dismissWsButton(id) {
    return {
        type: "ws_button_dismiss",
        detail: {
            id: id,
            timestamp: +new Date()
        }
    };
}

var LogChat = /** @class */ (function () {
    function LogChat(inner) {
        this.inner = inner;
    }
    LogChat.prototype.bargeOut = function (cb) {
        log$3("CLIENT: bargeOut");
        this.inner.bargeOut(cb);
    };
    LogChat.prototype.bargeIn = function (agentName, cb) {
        log$3("CLIENT: bargeIn: ".concat(agentName));
        this.inner.bargeIn(agentName, cb);
    };
    LogChat.prototype.init = function (dispatch) {
        this.inner.init(dispatch);
    };
    LogChat.prototype.sendOfflineMsg = function (message, cb) {
        log$3("CLIENT: sendOfflineMsg: ".concat(JSON.stringify(message)));
        this.inner.sendOfflineMsg(message, cb);
    };
    LogChat.prototype.sendChatMsg = function (message, cb) {
        log$3("CLIENT: sendChatMsg: ".concat(JSON.stringify(message)));
        this.inner.sendChatMsg(message, cb);
    };
    LogChat.prototype.sendChatMsgRequest = function (message, cb) {
        log$3("CLIENT: sendChatMsgRequest: ".concat(JSON.stringify(message)));
        this.inner.sendChatMsgRequest(message, cb);
    };
    LogChat.prototype.sendTyping = function (isTyping) {
        log$3("CLIENT: sendTyping: ".concat(JSON.stringify(isTyping)));
        this.inner.sendTyping(isTyping);
    };
    LogChat.prototype.setVisitorInfo = function (visitorInfo, sessionId, cb) {
        log$3("CLIENT: setVisitorInfo: ".concat(JSON.stringify(visitorInfo), " session id: ").concat(sessionId));
        this.inner.setVisitorInfo(visitorInfo, sessionId, cb);
    };
    LogChat.prototype.sendChatRating = function (rating) {
        log$3("CLIENT: sendChatRating: ".concat(JSON.stringify(rating)));
        this.inner.sendChatRating(rating);
    };
    LogChat.prototype.sendFile = function (file, cb) {
        log$3("CLIENT: sendFile: ".concat(JSON.stringify(file)));
        this.inner.sendFile(file, cb);
    };
    LogChat.prototype.markAsRead = function () {
        log$3("CLIENT: markAsRead:");
        this.inner.markAsRead();
    };
    LogChat.prototype.flush = function () {
        log$3("CLIENT: flush:");
        this.inner.flush();
    };
    LogChat.prototype.dispose = function () {
        log$3("CLIENT: dispose:");
        this.inner.dispose();
    };
    LogChat.prototype.sleep = function () {
        log$3("CLIENT: sleep:");
        this.inner.sleep();
    };
    LogChat.prototype.wakeup = function () {
        log$3("CLIENT: wakeup:");
        this.inner.wakeup();
    };
    LogChat.prototype.sendButtonPressed = function (buttonId) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                log$3("CLIENT: sendButtonPressed: ".concat(buttonId));
                if (this.inner.sendButtonPressed) {
                    return [2 /*return*/, this.inner.sendButtonPressed(buttonId)];
                }
                return [2 /*return*/];
            });
        });
    };
    LogChat.prototype.notifyDisconnecting = function () {
        log$3("CLIENT: notifyDisconnecting:");
        if (this.inner.notifyDisconnecting) {
            this.inner.notifyDisconnecting();
        }
    };
    return LogChat;
}());

var jsxRuntime = require$$0;
var react = require$$1;

var IconButton$1 = function (props) {
    var Icon = props.icon;
    return (jsxRuntime.jsx("div", { tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, className: "xapp-search-icon-button ".concat(props.className || ""), onClick: props.onClick, children: jsxRuntime.jsx("div", { className: "xapp-search-icon-button__content", children: jsxRuntime.jsx(Icon, {}) }) }));
};

// compile time full switch-case verification
function throwBadKind(x) {
    throw new Error("Unknown kind " + x);
}

var RichTextBoldSpan = function (props) {
    var format = props.format, text = props.text;
    return (jsxRuntime.jsx("span", { "data-rich-text-type": "bold", className: "xapp-search-rich-text-bold-span", children: text.substring(format.start, format.end) }));
};

var RichTextInputSpan = function (props) {
    var format = props.format, text = props.text, readOnly = props.readOnly, onClick = props.onClick;
    var defaultValue = format.text || text.substring(format.start, format.end);
    var _a = react.useState(defaultValue), value = _a[0], setValue = _a[1];
    var handleChange = react.useCallback(function (ev) {
        setValue(ev.target.value);
    }, []);
    var handleClick = react.useCallback(function (ev) {
        if (onClick) {
            var res = onClick(format);
            if (res === false) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        }
    }, [onClick, format]);
    if (readOnly) {
        return (jsxRuntime.jsx("span", { className: "xapp-search-rich-text-input-span xapp-search-rich-text-input-span--readonly", onClick: handleClick, children: defaultValue }));
    }
    return (jsxRuntime.jsx("input", { type: "text", value: value, className: "xapp-search-rich-text-input-span", "data-rich-text-type": "inputText", onChange: handleChange, onClick: handleClick, readOnly: readOnly }));
};

var RichTextNormalSpan = function (props) {
    var format = props.format, text = props.text;
    return (jsxRuntime.jsx("span", { "data-rich-text-type": "normal", className: "xapp-search-rich-text-normal-span", children: text.substring(format.start, format.end) }));
};

var RichTextSpan = function (props) {
    var format = props.format, text = props.text, readOnly = props.readOnly, onClick = props.onClick;
    var type = format.type;
    switch (type) {
        case "normal":
            return jsxRuntime.jsx(RichTextNormalSpan, { text: text, format: format, readOnly: readOnly });
        case "bold":
            return jsxRuntime.jsx(RichTextBoldSpan, { text: text, format: format, readOnly: readOnly });
        case "inputText":
            return (jsxRuntime.jsx(RichTextInputSpan, { text: text, format: format, readOnly: readOnly, onClick: onClick }));
        default:
            throwBadKind(type);
    }
};

function cleanRichTextValue(value) {
    var text = value.text, formats = value.formats;
    var newFormats = [];
    for (var _i = 0, formats_1 = formats; _i < formats_1.length; _i++) {
        var format = formats_1[_i];
        var type = format.type;
        switch (type) {
            case "normal":
                continue;
            case "inputText":
                newFormats.push(format);
                break;
            case "bold":
                if (newFormats.length > 0) {
                    var prev = newFormats[newFormats.length - 1];
                    if (prev.type === type && prev.end === format.start) {
                        newFormats.pop();
                        newFormats.push({
                            type: type,
                            start: prev.start,
                            end: format.end
                        });
                    }
                }
                else {
                    newFormats.push(format);
                }
                break;
        }
    }
    return {
        text: text,
        formats: newFormats
    };
}

function extendFormat(formats, length) {
    var res = [];
    var walkerIndex = 0;
    for (var _i = 0, formats_1 = formats; _i < formats_1.length; _i++) {
        var format = formats_1[_i];
        var start = format.start, end = format.end, type = format.type, text = format.text;
        if (walkerIndex < start) {
            res.push({
                type: "normal",
                start: walkerIndex,
                end: start
            });
        }
        res.push({
            type: type,
            start: start,
            end: end,
            text: text
        });
        walkerIndex = end;
    }
    if (walkerIndex < length) {
        res.push({
            type: "normal",
            start: walkerIndex,
            end: length
        });
    }
    return res;
}

function parseContent(node) {
    var children = node.childNodes;
    var formats = [];
    var text = "";
    children.forEach(function (child) {
        if (child.nodeType === Node.ELEMENT_NODE) {
            var node_1 = child;
            var innerText = node_1.tagName === "INPUT" ? node_1.value : node_1.innerText;
            var type = node_1.dataset.richTextType;
            formats.push({
                type: type,
                start: text.length,
                end: text.length + innerText.length,
            });
            text += innerText;
        }
        if (child.nodeType === Node.TEXT_NODE) {
            var node_2 = child;
            var innerText = node_2.nodeValue;
            if (innerText) {
                formats.push({
                    type: "normal",
                    start: text.length,
                    end: text.length + innerText.length,
                });
                text += innerText;
            }
        }
    });
    return cleanRichTextValue({
        text: text,
        formats: formats,
    });
}
function cleanContent(node) {
    var _a;
    var trash = [];
    var raw = node.childNodes;
    for (var i = 0; i < raw.length; i++) {
        var c = raw.item(i);
        if ((c === null || c === void 0 ? void 0 : c.nodeType) === Node.TEXT_NODE) {
            trash.push(c);
        }
    }
    for (var _i = 0, trash_1 = trash; _i < trash_1.length; _i++) {
        var c = trash_1[_i];
        try {
            (_a = c.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(c);
        }
        catch (_b) { }
    }
}
var RichText = function (props) {
    var value = props.value, className = props.className, readOnly = props.readOnly, onInput = props.onInput, onChange = props.onChange, onSpanClick = props.onSpanClick;
    var formatsRaw = value.formats, text = value.text;
    var formats = react.useMemo(function () { return extendFormat(formatsRaw, text.length); }, [formatsRaw, text.length]);
    var handleInput = react.useCallback(function (ev) {
        var target = ev.currentTarget;
        var newValue = parseContent(target);
        if (onInput) {
            onInput(newValue);
        }
    }, [onInput]);
    var handleBlur = react.useCallback(function (ev) {
        var target = ev.currentTarget;
        var newValue = parseContent(target);
        cleanContent(target);
        if (onChange) {
            onChange(newValue);
        }
    }, [onChange]);
    return (jsxRuntime.jsx("div", { id: props.id, className: "xapp-search-rich-text ".concat(className || ""), contentEditable: !readOnly, suppressContentEditableWarning: true, onInput: handleInput, onBlur: handleBlur, onKeyDown: props.onKeyDown, children: formats.map(function (format, index) { return (jsxRuntime.jsx(RichTextSpan, { format: format, text: text, readOnly: readOnly, onClick: onSpanClick }, index)); }) }));
};

var RichInput = function (props) {
    var id = props.id, value = props.value, type = props.type, autoFocus = props.autoFocus, spellCheck = props.spellCheck, tabIndex = props.tabIndex, maxLength = props.maxLength, onChange = props.onChange, onInput = props.onInput, onKeyDown = props.onKeyDown, onSearch = props.onSearch;
    var rich = value.formats.some(function (f) { return f.type === "inputText"; });
    var handleChange = react.useCallback(function (ev) {
        if (onChange) {
            onChange({
                text: ev.target.value,
                formats: [],
            });
        }
    }, [onChange]);
    var handleRichChange = react.useCallback(function (val) {
        if (onChange) {
            onChange(val);
        }
    }, [onChange]);
    var handleInput = react.useCallback(function (ev) {
        if (onInput) {
            onInput({
                text: ev.target.value,
                formats: [],
            });
        }
    }, [onInput]);
    var handleRichInput = react.useCallback(function (val) {
        if (onInput) {
            onInput(val);
        }
    }, [onInput]);
    var handleKeyDown = react.useCallback(function (event) {
        if (onKeyDown) {
            onKeyDown(event);
        }
    }, [onKeyDown]);
    var inputRef = react.useRef(null);
    var inputNode = inputRef.current;
    react.useEffect(function () {
        if (inputNode && onSearch) {
            var handler_1 = function (ev) {
                var target = ev.target;
                if (target) {
                    onSearch({
                        text: target.value,
                        formats: [],
                    });
                }
            };
            inputNode.addEventListener("search", handler_1);
            return function () {
                inputNode.removeEventListener("search", handler_1);
            };
        }
        return undefined;
    }, [inputNode, onSearch]);
    return (jsxRuntime.jsx("div", { className: "xappw-rich-input ".concat(props.className), children: rich ? (jsxRuntime.jsx(RichText, { id: id, value: value, onChange: handleRichChange, onInput: handleRichInput, onKeyDown: handleKeyDown, className: "xappw-rich-input__input ".concat(props.className, "__input") })) : (jsxRuntime.jsx("input", { id: id, ref: inputRef, type: type, value: value.text, autoComplete: "off", autoFocus: autoFocus, placeholder: props.placeholder, spellCheck: spellCheck, tabIndex: tabIndex ? Number(tabIndex) : 0, maxLength: maxLength, className: "xappw-rich-input__input ".concat(props.className, "__input"), onFocus: props.onFocus, onChange: handleChange, onInput: handleInput, onKeyDown: handleKeyDown })) }));
};

var SuggestionsGroupHeading = function (props) {
    return jsxRuntime.jsx("div", { className: "xappw-suggestions-group-heading", children: props.label });
};

function getScrollContainer(node) {
    var walker = node;
    while (walker && !walker.classList.contains("xapp-search-result__suggestions")) {
        walker = walker.parentElement;
    }
    return walker || undefined;
}
var SuggestionsItem = function (props) {
    var data = props.data, current = props.current, ActionsComponent = props.actions, onClick = props.onClick, onHover = props.onHover, onSpanClick = props.onSpanClick;
    var handleClick = react.useCallback(function () {
        onClick(data);
    }, [data, onClick]);
    var handleHover = react.useCallback(function () {
        if (onHover) {
            onHover(data);
        }
    }, [data, onHover]);
    var handleSpanClick = react.useCallback(function (span) {
        if (onSpanClick) {
            return onSpanClick(data, span);
        }
        return undefined;
    }, [onSpanClick, data]);
    var ref = react.useRef(null);
    react.useEffect(function () {
        var node = ref.current;
        if (current && node) {
            var scrollContainer = getScrollContainer(node);
            if (scrollContainer) {
                var scrollBox = scrollContainer.getBoundingClientRect();
                var nodeBox = node.getBoundingClientRect();
                var maxTop = Math.max(scrollBox.top, nodeBox.top);
                var minBottom = Math.min(scrollBox.bottom, nodeBox.bottom);
                var visibleHeight = minBottom - maxTop;
                var actualHeight = nodeBox.height;
                if (visibleHeight < actualHeight * 0.99) {
                    node.scrollIntoView({ behavior: "smooth" });
                }
            }
        }
    }, [current]);
    return (jsxRuntime.jsxs("div", { ref: ref, className: "xappw-suggestions-item ".concat(current ? "xappw-suggestions-item--current" : ""), onClick: handleClick, onMouseEnter: handleHover, children: [jsxRuntime.jsx(RichText, { value: data, className: "xappw-suggestions-item__texts", readOnly: true, onSpanClick: handleSpanClick }), ActionsComponent && (jsxRuntime.jsx("div", { className: "xappw-suggestions-item__actions", children: jsxRuntime.jsx(ActionsComponent, { data: data, current: current }) }))] }));
};

var SuggestionsGroup = function (props) {
    var group = props.group, currentIndex = props.currentIndex, itemActions = props.itemActions;
    var heading = group.heading, items = group.items;
    return (jsxRuntime.jsxs("div", { className: "xappw-suggestions-group", children: [jsxRuntime.jsx("div", { className: "xappw-suggestions-group__heading", children: jsxRuntime.jsx(SuggestionsGroupHeading, { label: heading }) }), jsxRuntime.jsx("div", { className: "xappw-suggestions-group__items", children: items.map(function (item, itemIndex) { return (jsxRuntime.jsx(SuggestionsItem, { data: item, current: currentIndex === itemIndex, actions: itemActions, onClick: props.onItemClick, onHover: props.onItemHover, onSpanClick: props.onSpanClick }, itemIndex)); }) })] }));
};

function getItemsLength(result) {
    return result.reduce(function (prev, cur) { return prev + cur.items.length; }, 0);
}

var SuggestionsList = function (props) {
    var suggestions = props.suggestions, itemActions = props.itemActions, className = props.className;
    var length = react.useMemo(function () {
        if (suggestions) {
            return getItemsLength(suggestions);
        }
        return 0;
    }, [suggestions]);
    var currentIndex = length >= 0 ? props.index : NaN;
    var indexWalker = 0;
    return (jsxRuntime.jsx("div", { className: "xappw-suggestions-list ".concat(className || ""), children: suggestions === null || suggestions === void 0 ? void 0 : suggestions.map(function (group, index) {
            var res = (jsxRuntime.jsx(SuggestionsGroup, { group: group, currentIndex: currentIndex - indexWalker, itemActions: itemActions, onItemClick: props.onItemClick, onItemHover: props.onItemHover, onSpanClick: props.onSpanClick }, index));
            indexWalker += group.items.length;
            return res;
        }) }));
};

function findItemByIndex(groups, index) {
    if (index >= 0) {
        for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
            var group = groups_1[_i];
            for (var _a = 0, _b = group.items; _a < _b.length; _a++) {
                var item = _b[_a];
                if (index <= 0) {
                    return item;
                }
                index--;
            }
        }
    }
    return undefined;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var order = ["FAQ", "INTENT", "HISTORICAL"];
var ordersMap = order.reduce(function (prev, cur, index) {
    prev[cur] = index;
    return prev;
}, {});
function compareSuggestionItems(left, right, direction) {
    return direction * (ordersMap[right.type] - ordersMap[left.type]);
}
function sortSuggestionItems(items, direction) {
    return __spreadArray([], items).sort(function (left, right) { return compareSuggestionItems(left, right, direction); });
}

function parseSuggestionsFormat(format) {
    var types = Object.keys(format);
    var type = types[0];
    var item = format[type];
    if (!item) {
        throw new Error();
    }
    return {
        type: type,
        start: item.start,
        end: item.end,
    };
}
function parseSuggestionsFormats(formats) {
    return formats.map(parseSuggestionsFormat);
}
function parseSuggestionsResponseItem(item) {
    return {
        text: item.suggestion,
        content: item.answer,
        formats: parseSuggestionsFormats(item.format),
        type: item.type,
    };
}
function getHeading(type) {
    switch (type) {
        case "FAQ":
            return "FAQs";
        case "INTENT":
            return "Suggestions";
        case "HISTORICAL":
            return "Suggestions";
        default:
            return type;
    }
}
function parseSuggestionsResponse(response, direction) {
    if (direction === void 0) { direction = 1; }
    if (!response) {
        return undefined;
    }
    var items = sortSuggestionItems(response.suggestions, direction);
    return items.reduce(function (result, current) {
        var mappedItem = parseSuggestionsResponseItem(current);
        if (result.length) {
            var prevGroup = result[result.length - 1];
            if (prevGroup.heading === getHeading(current.type)) {
                prevGroup.items.push(mappedItem);
                return result;
            }
        }
        result.push({
            heading: getHeading(current.type),
            items: [mappedItem],
        });
        return result;
    }, []);
}

/**
 * Append the provided query params to the URL
 *
 * It will overwrite existing params on the URL if there are conflicts
 * @param url
 * @param params
 */
function addQueryParametersToURL(url, params) {
    var existingParams = new URL(url).searchParams;
    params.forEach(function (value, key) {
        existingParams.append(key, value);
    });
    var newUrl = new URL(url);
    newUrl.search = existingParams.toString();
    return newUrl;
}

var defaultOptions$2 = {};
function noop$1$1() {
}
function useJsonFetch(url, options) {
    if (options === void 0) { options = defaultOptions$2; }
    var _a = react.useState({
        state: "paused"
    }), value = _a[0], setValue = _a[1];
    var pause = options.pause;
    react.useEffect(function () {
        if (pause) {
            setValue({
                state: "paused"
            });
            return noop$1$1;
        }
        var controller = new AbortController();
        var signal = controller.signal;
        var mounted = true;
        (function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, json, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 4, , 5]);
                            setValue({
                                state: "fetching"
                            });
                            return [4 /*yield*/, fetch(url, { signal: signal })];
                        case 1:
                            response = _a.sent();
                            if (!mounted) return [3 /*break*/, 3];
                            return [4 /*yield*/, response.json()];
                        case 2:
                            json = _a.sent();
                            if (response.ok) {
                                setValue({
                                    state: "success",
                                    data: json
                                });
                            }
                            else {
                                setValue({
                                    state: "error",
                                    error: json
                                });
                            }
                            _a.label = 3;
                        case 3: return [3 /*break*/, 5];
                        case 4:
                            e_1 = _a.sent();
                            if (e_1.name === "AbortError") {
                                setValue({
                                    state: "paused"
                                });
                                return [2 /*return*/];
                            }
                            throw e_1;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        })();
        return function () {
            mounted = false;
            controller.abort();
        };
    }, [url, pause]);
    return value;
}

function useSuggestionsFetch$1(options) {
    var baseUrl = options.url, context = options.context, query = options.query;
    var url = react.useMemo(function () {
        if (!baseUrl) {
            return undefined;
        }
        var params = new URLSearchParams();
        params.append("size", "5");
        params.append("queryText", query);
        if (context === null || context === void 0 ? void 0 : context.length) {
            params.append("activeContexts", context.join(","));
        }
        return addQueryParametersToURL(baseUrl, params);
    }, [query, context, baseUrl]);
    var response = useJsonFetch(url ? "".concat(url.toString()) : "", {
        pause: !query || !baseUrl
    });
    return response;
}

/**
 * Quicker configurable uuid
 *
 * @export
 * @returns {string}
 */
function uuid() {
    var d = new Date().getTime();
    var newUuid = "xxxxxxxx-xxxx-65xx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        /* tslint:disable:no-magic-numbers */
        /* tslint:disable:no-bitwise */
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        /* tslint:enable:no-magic-numbers */
        /* tslint:disable:no-bitwise */
    });
    return newUuid;
}

var IconButton_1 = IconButton$1;
var RichInput_1 = RichInput;
var SuggestionsList_1 = SuggestionsList;
var findItemByIndex_1 = findItemByIndex;
var getItemsLength_1 = getItemsLength;
var parseSuggestionsResponse_1 = parseSuggestionsResponse;
var useSuggestionsFetch_1 = useSuggestionsFetch$1;
var uuid_1 = uuid;

var cjs$3 = {};

var fetch$1 = {};

var parse$3 = {};

Object.defineProperty(parse$3, "__esModule", { value: true });
parse$3.getMessages = parse$3.getLines = parse$3.getBytes = void 0;
async function getBytes(stream, onChunk) {
    const reader = stream.getReader();
    let result;
    while (!(result = await reader.read()).done) {
        onChunk(result.value);
    }
}
parse$3.getBytes = getBytes;
function getLines(onLine) {
    let buffer;
    let position;
    let fieldLength;
    let discardTrailingNewline = false;
    return function onChunk(arr) {
        if (buffer === undefined) {
            buffer = arr;
            position = 0;
            fieldLength = -1;
        }
        else {
            buffer = concat(buffer, arr);
        }
        const bufLength = buffer.length;
        let lineStart = 0;
        while (position < bufLength) {
            if (discardTrailingNewline) {
                if (buffer[position] === 10) {
                    lineStart = ++position;
                }
                discardTrailingNewline = false;
            }
            let lineEnd = -1;
            for (; position < bufLength && lineEnd === -1; ++position) {
                switch (buffer[position]) {
                    case 58:
                        if (fieldLength === -1) {
                            fieldLength = position - lineStart;
                        }
                        break;
                    case 13:
                        discardTrailingNewline = true;
                    case 10:
                        lineEnd = position;
                        break;
                }
            }
            if (lineEnd === -1) {
                break;
            }
            onLine(buffer.subarray(lineStart, lineEnd), fieldLength);
            lineStart = position;
            fieldLength = -1;
        }
        if (lineStart === bufLength) {
            buffer = undefined;
        }
        else if (lineStart !== 0) {
            buffer = buffer.subarray(lineStart);
            position -= lineStart;
        }
    };
}
parse$3.getLines = getLines;
function getMessages(onId, onRetry, onMessage) {
    let message = newMessage();
    const decoder = new TextDecoder();
    return function onLine(line, fieldLength) {
        if (line.length === 0) {
            onMessage === null || onMessage === void 0 ? void 0 : onMessage(message);
            message = newMessage();
        }
        else if (fieldLength > 0) {
            const field = decoder.decode(line.subarray(0, fieldLength));
            const valueOffset = fieldLength + (line[fieldLength + 1] === 32 ? 2 : 1);
            const value = decoder.decode(line.subarray(valueOffset));
            switch (field) {
                case 'data':
                    message.data = message.data
                        ? message.data + '\n' + value
                        : value;
                    break;
                case 'event':
                    message.event = value;
                    break;
                case 'id':
                    onId(message.id = value);
                    break;
                case 'retry':
                    const retry = parseInt(value, 10);
                    if (!isNaN(retry)) {
                        onRetry(message.retry = retry);
                    }
                    break;
            }
        }
    };
}
parse$3.getMessages = getMessages;
function concat(a, b) {
    const res = new Uint8Array(a.length + b.length);
    res.set(a);
    res.set(b, a.length);
    return res;
}
function newMessage() {
    return {
        data: '',
        event: '',
        id: '',
        retry: undefined,
    };
}

(function (exports$1) {
	var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	};
	Object.defineProperty(exports$1, "__esModule", { value: true });
	exports$1.fetchEventSource = exports$1.EventStreamContentType = void 0;
	const parse_1 = parse$3;
	exports$1.EventStreamContentType = 'text/event-stream';
	const DefaultRetryInterval = 1000;
	const LastEventId = 'last-event-id';
	function fetchEventSource(input, _a) {
	    var { signal: inputSignal, headers: inputHeaders, onopen: inputOnOpen, onmessage, onclose, onerror, openWhenHidden, fetch: inputFetch } = _a, rest = __rest(_a, ["signal", "headers", "onopen", "onmessage", "onclose", "onerror", "openWhenHidden", "fetch"]);
	    return new Promise((resolve, reject) => {
	        const headers = Object.assign({}, inputHeaders);
	        if (!headers.accept) {
	            headers.accept = exports$1.EventStreamContentType;
	        }
	        let curRequestController;
	        function onVisibilityChange() {
	            curRequestController.abort();
	            if (!document.hidden) {
	                create();
	            }
	        }
	        if (!openWhenHidden) {
	            document.addEventListener('visibilitychange', onVisibilityChange);
	        }
	        let retryInterval = DefaultRetryInterval;
	        let retryTimer = 0;
	        function dispose() {
	            document.removeEventListener('visibilitychange', onVisibilityChange);
	            window.clearTimeout(retryTimer);
	            curRequestController.abort();
	        }
	        inputSignal === null || inputSignal === void 0 ? void 0 : inputSignal.addEventListener('abort', () => {
	            dispose();
	            resolve();
	        });
	        const fetch = inputFetch !== null && inputFetch !== void 0 ? inputFetch : window.fetch;
	        const onopen = inputOnOpen !== null && inputOnOpen !== void 0 ? inputOnOpen : defaultOnOpen;
	        async function create() {
	            var _a;
	            curRequestController = new AbortController();
	            try {
	                const response = await fetch(input, Object.assign(Object.assign({}, rest), { headers, signal: curRequestController.signal }));
	                await onopen(response);
	                await parse_1.getBytes(response.body, parse_1.getLines(parse_1.getMessages(id => {
	                    if (id) {
	                        headers[LastEventId] = id;
	                    }
	                    else {
	                        delete headers[LastEventId];
	                    }
	                }, retry => {
	                    retryInterval = retry;
	                }, onmessage)));
	                onclose === null || onclose === void 0 ? void 0 : onclose();
	                dispose();
	                resolve();
	            }
	            catch (err) {
	                if (!curRequestController.signal.aborted) {
	                    try {
	                        const interval = (_a = onerror === null || onerror === void 0 ? void 0 : onerror(err)) !== null && _a !== void 0 ? _a : retryInterval;
	                        window.clearTimeout(retryTimer);
	                        retryTimer = window.setTimeout(create, interval);
	                    }
	                    catch (innerErr) {
	                        dispose();
	                        reject(innerErr);
	                    }
	                }
	            }
	        }
	        create();
	    });
	}
	exports$1.fetchEventSource = fetchEventSource;
	function defaultOnOpen(response) {
	    const contentType = response.headers.get('content-type');
	    if (!(contentType === null || contentType === void 0 ? void 0 : contentType.startsWith(exports$1.EventStreamContentType))) {
	        throw new Error(`Expected content-type to be ${exports$1.EventStreamContentType}, Actual: ${contentType}`);
	    }
	}
	
} (fetch$1));

(function (exports$1) {
	Object.defineProperty(exports$1, "__esModule", { value: true });
	exports$1.EventStreamContentType = exports$1.fetchEventSource = void 0;
	var fetch_1 = fetch$1;
	Object.defineProperty(exports$1, "fetchEventSource", { enumerable: true, get: function () { return fetch_1.fetchEventSource; } });
	Object.defineProperty(exports$1, "EventStreamContentType", { enumerable: true, get: function () { return fetch_1.EventStreamContentType; } });
	
} (cjs$3));

/**
 * Default configuration messages
 * @returns
 */
function getConfigurableMessages() {
    return {
        items: [
            {
                delay: 5,
                //eslint-disable-next-line
                text: "We are having trouble communicating with the assistant right now. Re-trying in ${sec} seconds...",
            },
            {
                delay: 5,
                //eslint-disable-next-line
                text: "We are still having trouble communicating with the assistant right now. Re-trying in ${sec} seconds...",
            },
            {
                delay: 0,
                text: "Sorry, we cannot communicate with the assistant right now. Please check your connection or try again later.",
            },
        ],
    };
}
function getConfigurableMessagesConfig(messages) {
    var items = messages.items;
    // First one is silent, keeps the same message
    var config = [{ retry: 0, delay: 10, text: "" }];
    if (Array.isArray(items) && items.length > 0) {
        for (var i = 0; i < items.length; i++) {
            config.push({ retry: i + 1, delay: items[i].delay, text: items[i].text });
        }
    }
    return config;
}

function setSessionId(sessionId) {
    return {
        type: "session_id",
        detail: {
            sessionId: sessionId,
            timestamp: new Date().getTime()
        }
    };
}

// Endpoint path constants
var HOMEOWNER_ENDPOINT_PATH = "/chat/stream";
var BUSINESS_OWNER_ENDPOINT_PATH = "/api/chat/stream";
// Default retry configuration for MCP connections
var DEFAULT_MCP_RETRY_CONFIG = [
    { retry: 0, delay: 0, text: "" }, // Initial attempt (silent)
    { retry: 1, delay: 3, text: "Having trouble connecting. Retrying in ${sec} seconds..." },
    { retry: 2, delay: 5, text: "Still having trouble. Retrying in ${sec} seconds..." },
    { retry: 0, delay: 0, text: "Unable to connect to the assistant. Please try again later." }, // Final failure
];
// Streaming throttle configuration
// Average reading speed is ~250 words/min (~20 chars/sec). We go slightly faster.
var STREAM_CHARS_PER_TICK = 3; // Characters to display per tick
var STREAM_TICK_INTERVAL_MS = 30; // Milliseconds between ticks (~100 chars/sec)
/**
 * Storage keys for MCP session persistence.
 * Uses localStorage directly (not Redux) for MCP-specific data.
 */
var MCP_STORAGE_KEYS = {
    USER_ID: "xapp_mcp_userId",
    SESSION_ID: "xapp_mcp_sessionId",
};
/**
 * Gets the platform string, preferring the modern userAgentData API.
 * Falls back to the deprecated navigator.platform for older browsers.
 */
function getPlatform() {
    // Modern API (Chrome 90+, Edge 90+, Opera 76+)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var userAgentData = navigator.userAgentData;
    if (userAgentData === null || userAgentData === void 0 ? void 0 : userAgentData.platform) {
        return userAgentData.platform;
    }
    // Fallback for older browsers (deprecated but widely supported)
    return navigator.platform || undefined;
}
/**
 * Collects non-invasive device/browser fingerprint data.
 * This helps the server identify returning users without requiring login.
 *
 * PRIVACY NOTE: Only basic, non-identifying browser characteristics are collected.
 * This data cannot be used to personally identify individual users.
 */
function getFingerprint() {
    if (typeof window === "undefined") {
        return {};
    }
    return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        screenResolution: "".concat(window.screen.width, "x").concat(window.screen.height),
        platform: getPlatform(),
        colorDepth: window.screen.colorDepth,
        touchSupport: "ontouchstart" in window || navigator.maxTouchPoints > 0,
    };
}
/**
 * Retrieves stored MCP identity from localStorage.
 */
function getStoredIdentity() {
    if (typeof window === "undefined" || !window.localStorage) {
        return {};
    }
    try {
        return {
            userId: localStorage.getItem(MCP_STORAGE_KEYS.USER_ID) || undefined,
            sessionId: localStorage.getItem(MCP_STORAGE_KEYS.SESSION_ID) || undefined,
        };
    }
    catch (_a) {
        // localStorage may be unavailable (private browsing, etc.)
        return {};
    }
}
/**
 * Stores MCP identity to localStorage.
 */
function storeIdentity(userId, sessionId) {
    if (typeof window === "undefined" || !window.localStorage) {
        return;
    }
    try {
        if (userId) {
            localStorage.setItem(MCP_STORAGE_KEYS.USER_ID, userId);
        }
        if (sessionId) {
            localStorage.setItem(MCP_STORAGE_KEYS.SESSION_ID, sessionId);
        }
    }
    catch (_a) {
        // localStorage may be unavailable
    }
}
/**
 * Clears stored MCP session (but preserves userId for returning user identification).
 * Optionally clears the stored lastSeq for the given sessionId.
 */
function clearStoredSession(sessionId) {
    if (typeof window === "undefined" || !window.localStorage) {
        return;
    }
    try {
        localStorage.removeItem(MCP_STORAGE_KEYS.SESSION_ID);
        if (sessionId) {
            clearStoredLastSeq(sessionId);
        }
    }
    catch (_a) {
        // localStorage may be unavailable
    }
}
/**
 * Retrieves stored lastSeq from sessionStorage for replay on reconnect.
 * Uses sessionStorage (not localStorage) because seq is ephemeral to the browser tab.
 */
function getStoredLastSeq(sessionId) {
    if (typeof window === "undefined" || !window.sessionStorage) {
        return undefined;
    }
    try {
        var stored = sessionStorage.getItem("xapp_mcp_lastSeq_".concat(sessionId));
        return stored ? parseInt(stored, 10) : undefined;
    }
    catch (_a) {
        return undefined;
    }
}
/**
 * Persists lastSeq to sessionStorage for replay on reconnect.
 */
function storeLastSeq(sessionId, seq) {
    if (typeof window === "undefined" || !window.sessionStorage) {
        return;
    }
    try {
        sessionStorage.setItem("xapp_mcp_lastSeq_".concat(sessionId), String(seq));
    }
    catch (_a) {
        // sessionStorage may be unavailable
    }
}
/**
 * Clears stored lastSeq from sessionStorage.
 */
function clearStoredLastSeq(sessionId) {
    if (typeof window === "undefined" || !window.sessionStorage) {
        return;
    }
    try {
        sessionStorage.removeItem("xapp_mcp_lastSeq_".concat(sessionId));
    }
    catch (_a) {
        // sessionStorage may be unavailable
    }
}
/**
 * Gets the current page context from browser globals.
 * If an override is provided, uses that instead (useful for testing).
 *
 * PRIVACY NOTE: Query strings are stripped from URLs by default as they
 * may contain sensitive data (tokens, PII). Only origin + pathname are sent.
 */
function getPageContext(override) {
    var localTime = new Date().toISOString();
    // If override provided, merge with defaults (override wins)
    // Overrides are typically for testing and may include full URLs
    if (override && Object.keys(override).length > 0) {
        log$3("[getPageContext] Using override: ".concat(JSON.stringify(override)));
        return {
            url: override.url,
            path: override.path,
            title: override.title,
            referrer: override.referrer,
            localTime: localTime,
        };
    }
    if (typeof window === "undefined") {
        return { localTime: localTime };
    }
    // Strip query strings from URL for privacy (may contain tokens/PII)
    var urlWithoutQuery = window.location.origin + window.location.pathname;
    // Strip query strings from referrer as well
    var referrerWithoutQuery;
    if (document.referrer) {
        try {
            var refUrl = new URL(document.referrer);
            referrerWithoutQuery = refUrl.origin + refUrl.pathname;
        }
        catch (_a) {
            // Invalid referrer URL, skip it
            referrerWithoutQuery = undefined;
        }
    }
    return {
        url: urlWithoutQuery,
        path: window.location.pathname,
        title: document.title || undefined,
        referrer: referrerWithoutQuery,
        localTime: localTime,
    };
}
var MCPChat = /** @class */ (function () {
    function MCPChat(config, options) {
        this._userId = "";
        this._sessionId = "";
        this._accessToken = "";
        this._attributes = {};
        // Streaming throttle state
        this.streamBuffer = "";
        // New session initialization state
        this.isInitializingSession = false;
        // Session validation state (silent handshake - no stream dispatch)
        this.isValidatingSession = false;
        // Tool call tracking for debug mode
        this.currentToolCalls = [];
        // TODO: isReplaying and lastSeq are tracked for future replay support.
        // Wire up replay requests in wakeup() once the server endpoint supports it.
        this.isReplaying = false;
        // True when userId was assigned by the server (via connected SSE event),
        // meaning it should not be overwritten by the default client fingerprint.
        this.userIdIsServerAssigned = false;
        this.config = config;
        this.options = options;
        this.configurableMessages = options === null || options === void 0 ? void 0 : options.configurableMessages;
        this.isNewSession = false;
        this.hooks = options === null || options === void 0 ? void 0 : options.hooks;
        // Validate business_owner mode requires authToken
        var mode = config.mode || "homeowner";
        if (mode === "business_owner" && !config.authToken) {
            throw new Error("authToken is required for business_owner mode");
        }
        // Load stored identity from localStorage
        var storedIdentity = getStoredIdentity();
        if (storedIdentity.userId) {
            this._userId = storedIdentity.userId;
            this.userIdIsServerAssigned = true;
            log$3("[MCPChat] Loaded stored userId: ".concat(this._userId));
        }
        if (storedIdentity.sessionId) {
            this._sessionId = storedIdentity.sessionId;
            log$3("[MCPChat] Loaded stored sessionId: ".concat(this._sessionId));
        }
        // Config-provided sessionId takes precedence
        if (config.sessionId) {
            this._sessionId = config.sessionId;
        }
        // Load lastSeq from sessionStorage for replay on reconnect
        if (this._sessionId) {
            this.lastSeq = getStoredLastSeq(this._sessionId);
            if (this.lastSeq !== undefined) {
                log$3("[MCPChat] Loaded stored lastSeq: ".concat(this.lastSeq));
            }
        }
    }
    MCPChat.prototype.init = function (dispatch) {
        this.dispatch = dispatch;
        var mode = this.config.mode || "homeowner";
        log$3("MCPChat initialized with mode: ".concat(mode));
        // Warn if not using HTTPS with authentication
        if (mode === "business_owner" && !this.config.serverUrl.startsWith("https://")) {
            err("WARNING: Using non-HTTPS URL with authentication tokens. This is insecure in production.");
        }
        this.setConnectionStatus("online");
        this.setAccountStatus("online");
        // Dispatch bot joined early so it appears before the greeting.
        // getBot() is config-derived (uses options.bot), so it's safe to call before setVisitorInfo.
        this.userJoined(this.getBot(undefined));
        // Returning user with existing session - validate session silently
        // New user without session - initialize new session to get greeting
        if (this._sessionId) {
            this.validateSession();
        }
        else {
            this.initializeNewSession();
        }
    };
    /**
     * Validates an existing session with the server ("Silent Handshake").
     * Called when widget reopens with a stored sessionId.
     *
     * The server will respond with:
     * - "connected" event if session is valid
     * - "session_expired" event if session is gone (triggers initializeNewSession)
     *
     * This is lightweight - no LLM call, just a quick DB check to:
     * - Validate session before user tries to send a message
     * - Update lastActivityAt in persistent session
     * - Confirm userId is still valid
     */
    MCPChat.prototype.validateSession = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var endpoint, error_1;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = this.getEndpoint();
                        log$3("Validating existing session at ".concat(endpoint, ", sessionId: ").concat(this._sessionId));
                        this.isValidatingSession = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.performSSERequest(this.buildRequestPayload({ resumeSession: true }))];
                    case 2:
                        _a.sent();
                        log$3("Session validation complete");
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        err("Failed to validate session: ".concat(error_1));
                        // If validation fails (network error, etc.), clear session and start fresh
                        clearStoredSession(this._sessionId);
                        this._sessionId = "";
                        this.lastSeq = undefined;
                        this.initializeNewSession();
                        return [3 /*break*/, 5];
                    case 4:
                        this.isValidatingSession = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Builds the common request payload with identity and context.
     */
    MCPChat.prototype.buildRequestPayload = function (additionalData) {
        if (additionalData === void 0) { additionalData = {}; }
        return __assign$1({ 
            // Identity - server generates these, we just send back what we have
            userId: this._userId || undefined, sessionId: this._sessionId || undefined, 
            // Fingerprint for user identification (can be disabled for privacy)
            fingerprint: this.config.disableFingerprinting ? undefined : getFingerprint(), 
            // Page context
            pageContext: getPageContext(this.config.pageContextOverride), 
            // Client timestamp for latency measurement and clock drift detection
            clientTime: new Date().toISOString() }, additionalData);
    };
    /**
     * Initializes a new session by calling the endpoint with { newSession: true }.
     * This returns a greeting message and session ID without making an LLM call.
     */
    MCPChat.prototype.initializeNewSession = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var endpoint, error_2;
            var _this = this;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Prevent multiple concurrent initialization requests
                        if (this.isInitializingSession) {
                            log$3("New session initialization already in progress, skipping");
                            return [2 /*return*/];
                        }
                        endpoint = this.getEndpoint();
                        log$3("Initializing new session at ".concat(endpoint));
                        this.isInitializingSession = true;
                        // Create a promise that resolves when initialization completes
                        this.sessionInitPromise = new Promise(function (resolve) {
                            _this.resolveSessionInit = resolve;
                        });
                        this.typing();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.performSSERequest(this.buildRequestPayload({ newSession: true, generateGreeting: true }))];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        err("Failed to initialize new session: ".concat(error_2));
                        this.stopTyping();
                        this.setConnectionStatus("offline");
                        // Show a failure message but don't block - user can still try sending messages
                        this.sendFailureMessage(0, 0, this.getErrorMessage(error_2));
                        return [3 /*break*/, 5];
                    case 4:
                        this.isInitializingSession = false;
                        // Resolve the promise so any waiting postMessage calls can proceed
                        if (this.resolveSessionInit) {
                            this.resolveSessionInit();
                            this.resolveSessionInit = undefined;
                        }
                        this.sessionInitPromise = undefined;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    MCPChat.prototype.setConnectionStatus = function (status) {
        log$3("SERVER: connection_update: ".concat(JSON.stringify(status)));
        this.dispatch(setConnectionStatus(status));
    };
    MCPChat.prototype.setAccountStatus = function (status) {
        log$3("SERVER: account_status: ".concat(JSON.stringify(status)));
        this.dispatch(setAccountStatus(status));
    };
    MCPChat.prototype.getEndpoint = function () {
        // Normalize serverUrl to remove trailing slashes
        var serverUrl = this.config.serverUrl.replace(/\/+$/, "");
        var mode = this.config.mode || "homeowner";
        if (mode === "business_owner") {
            return "".concat(serverUrl).concat(BUSINESS_OWNER_ENDPOINT_PATH);
        }
        // homeowner mode - serverUrl should already include appId
        return "".concat(serverUrl).concat(HOMEOWNER_ENDPOINT_PATH);
    };
    MCPChat.prototype.sendNewMessage = function (msg, user) {
        log$3("SERVER: new message: ".concat(JSON.stringify(msg)));
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.msg",
                user: user || this.getBot(undefined),
                msg: msg,
                timestamp: +new Date(),
            },
        });
    };
    MCPChat.prototype.userJoined = function (user) {
        log$3("SERVER: user joined: ".concat(JSON.stringify(user)));
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.memberjoin",
                user: user,
                timestamp: +new Date(),
            },
        });
    };
    MCPChat.prototype.typing = function () {
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.typing",
                user: this.getBot(undefined),
                typing: true,
                timestamp: +new Date(),
            },
        });
    };
    MCPChat.prototype.stopTyping = function () {
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.typing",
                user: this.getBot(undefined),
                typing: false,
                timestamp: +new Date(),
            },
        });
    };
    MCPChat.prototype.sendFailureMessage = function (retry, delay, text) {
        this.stopTyping();
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.failureMsg",
                user: this.getBot(undefined),
                failureMsg: {
                    retry: retry,
                    delay: delay,
                    text: text,
                },
                timestamp: +new Date(),
            },
        });
    };
    /**
     * Gets the retry configuration, using custom config if provided or defaults.
     */
    MCPChat.prototype.getRetryConfig = function () {
        var _a, _b;
        if (((_b = (_a = this.configurableMessages) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            return getConfigurableMessagesConfig(this.configurableMessages);
        }
        return DEFAULT_MCP_RETRY_CONFIG;
    };
    /**
     * Delays execution for the specified number of seconds.
     */
    MCPChat.prototype.delay = function (seconds) {
        return new Promise(function (resolve) { return setTimeout(resolve, seconds * 1000); });
    };
    /**
     * Determines a user-friendly error message based on the error type.
     */
    MCPChat.prototype.getErrorMessage = function (error, statusCode) {
        // Auth errors
        if (statusCode === 401) {
            return "Authentication failed. Please check your credentials.";
        }
        if (statusCode === 403) {
            return "Access denied. You don't have permission to access this resource.";
        }
        // Server errors
        if (statusCode && statusCode >= 500) {
            return "The server is experiencing issues. Please try again later.";
        }
        // Not found (likely wrong appId or endpoint)
        if (statusCode === 404) {
            return "Service not found. Please check your configuration.";
        }
        // Network errors
        if (error instanceof TypeError && (error.message.includes("fetch") || error.message.includes("network"))) {
            return "Unable to connect to the server. Please check your internet connection.";
        }
        // Connection refused / server down
        if (error instanceof Error) {
            var msg = error.message.toLowerCase();
            if (msg.includes("failed to fetch") || msg.includes("network") || msg.includes("econnrefused")) {
                return "Unable to reach the server. Please try again later.";
            }
        }
        // Generic fallback
        return "Something went wrong. Please try again.";
    };
    MCPChat.prototype.dispatchStreamStart = function (messageId) {
        var bot = this.getBot(undefined);
        var streamTimestamp = +new Date();
        log$3("[dispatchStreamStart] Stream started: ".concat(messageId, ", timestamp: ").concat(streamTimestamp));
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.stream.start",
                user: bot,
                messageId: messageId,
                timestamp: streamTimestamp,
            },
        });
    };
    MCPChat.prototype.dispatchStreamChunk = function (messageId, text) {
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.stream.chunk",
                user: this.getBot(undefined),
                messageId: messageId,
                text: text,
                timestamp: +new Date(),
            },
        });
    };
    MCPChat.prototype.dispatchStreamEnd = function (messageId, fullMessage, toolCalls) {
        log$3("Stream ended: ".concat(messageId));
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.stream.end",
                user: this.getBot(undefined),
                messageId: messageId,
                msg: fullMessage,
                toolCalls: toolCalls,
                timestamp: +new Date(),
            },
        });
    };
    MCPChat.prototype.dispatchToolStart = function (params) {
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.stream.tool_start",
                user: this.getBot(undefined),
                messageId: params.messageId,
                toolName: params.toolName,
                toolCallId: params.toolCallId,
                displayName: params.displayName,
                label: params.label,
                hidden: params.hidden,
                toolInput: params.toolInput,
                timestamp: +new Date(),
            },
        });
    };
    MCPChat.prototype.dispatchToolEnd = function (params) {
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.stream.tool_end",
                user: this.getBot(undefined),
                messageId: params.messageId,
                toolName: params.toolName,
                toolCallId: params.toolCallId,
                displayName: params.displayName,
                label: params.label,
                hidden: params.hidden,
                toolResult: params.toolResult,
                toolError: params.toolError,
                timestamp: +new Date(),
            },
        });
    };
    /**
     * Starts the throttled streaming for a message.
     * Text will be dispatched at a readable pace.
     */
    MCPChat.prototype.startStreamThrottle = function (messageId) {
        var _this = this;
        this.streamBuffer = "";
        this.streamingMessageIdForThrottle = messageId;
        // Clear any existing timer and visibility handler
        if (this.streamThrottleTimer) {
            clearInterval(this.streamThrottleTimer);
        }
        if (this.visibilityHandler) {
            document.removeEventListener("visibilitychange", this.visibilityHandler);
        }
        // Start interval to dispatch buffered text
        this.streamThrottleTimer = setInterval(function () {
            if (_this.streamBuffer.length > 0 && _this.streamingMessageIdForThrottle) {
                var charsToSend = Math.min(STREAM_CHARS_PER_TICK, _this.streamBuffer.length);
                var textToDispatch = _this.streamBuffer.slice(0, charsToSend);
                _this.streamBuffer = _this.streamBuffer.slice(charsToSend);
                _this.dispatchStreamChunk(_this.streamingMessageIdForThrottle, textToDispatch);
            }
        }, STREAM_TICK_INTERVAL_MS);
        // Handle tab visibility changes - flush buffer when tab becomes visible
        this.visibilityHandler = function () {
            if (document.visibilityState === "visible") {
                log$3("[Visibility] Tab became visible, buffer length: ".concat(_this.streamBuffer.length, ", messageId: ").concat(_this.streamingMessageIdForThrottle));
                if (_this.streamBuffer.length > 0 && _this.streamingMessageIdForThrottle) {
                    // Dispatch all buffered text immediately when tab becomes visible
                    log$3("[Visibility] Flushing ".concat(_this.streamBuffer.length, " chars to UI"));
                    _this.dispatchStreamChunk(_this.streamingMessageIdForThrottle, _this.streamBuffer);
                    _this.streamBuffer = "";
                }
            }
            else {
                log$3("[Visibility] Tab hidden");
            }
        };
        document.addEventListener("visibilitychange", this.visibilityHandler);
    };
    /**
     * Adds text to the stream buffer for throttled dispatch.
     */
    MCPChat.prototype.bufferStreamText = function (text) {
        this.streamBuffer += text;
    };
    /**
     * Flushes any remaining buffered text and stops the throttle timer.
     * Returns a promise that resolves when all buffered text has been dispatched.
     */
    MCPChat.prototype.flushStreamBuffer = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var waitCount, maxWait;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.streamBuffer.length > 0 && this.streamingMessageIdForThrottle)) return [3 /*break*/, 5];
                        if (!(document.visibilityState === "hidden")) return [3 /*break*/, 1];
                        log$3("[flushStreamBuffer] Tab hidden, dispatching remaining ".concat(this.streamBuffer.length, " chars immediately"));
                        this.dispatchStreamChunk(this.streamingMessageIdForThrottle, this.streamBuffer);
                        this.streamBuffer = "";
                        return [3 /*break*/, 5];
                    case 1:
                        waitCount = 0;
                        maxWait = 100;
                        _a.label = 2;
                    case 2:
                        if (!(this.streamBuffer.length > 0 && waitCount < maxWait)) return [3 /*break*/, 4];
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, STREAM_TICK_INTERVAL_MS); })];
                    case 3:
                        _a.sent();
                        waitCount++;
                        return [3 /*break*/, 2];
                    case 4:
                        // If still has content after timeout, flush it
                        if (this.streamBuffer.length > 0 && this.streamingMessageIdForThrottle) {
                            log$3("[flushStreamBuffer] Timeout waiting for buffer, dispatching remaining ".concat(this.streamBuffer.length, " chars"));
                            this.dispatchStreamChunk(this.streamingMessageIdForThrottle, this.streamBuffer);
                            this.streamBuffer = "";
                        }
                        _a.label = 5;
                    case 5:
                        // Stop the throttle timer
                        if (this.streamThrottleTimer) {
                            clearInterval(this.streamThrottleTimer);
                            this.streamThrottleTimer = undefined;
                        }
                        if (this.visibilityHandler) {
                            document.removeEventListener("visibilitychange", this.visibilityHandler);
                            this.visibilityHandler = undefined;
                        }
                        this.streamingMessageIdForThrottle = undefined;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Immediately stops throttling and clears the buffer (used on abort/error).
     */
    MCPChat.prototype.stopStreamThrottle = function () {
        if (this.streamThrottleTimer) {
            clearInterval(this.streamThrottleTimer);
            this.streamThrottleTimer = undefined;
        }
        if (this.visibilityHandler) {
            document.removeEventListener("visibilitychange", this.visibilityHandler);
            this.visibilityHandler = undefined;
        }
        this.streamBuffer = "";
        this.streamingMessageIdForThrottle = undefined;
    };
    MCPChat.prototype.sendOfflineMsg = function (_, cb) {
        cb();
    };
    MCPChat.prototype.sendChatMsg = function (message, cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, this.sendChatMsgRequest({
                        msg: message,
                        timestamp: new Date().getTime(),
                        agent: false,
                        user: undefined,
                        type: "msg",
                    }, cb)];
            });
        });
    };
    MCPChat.prototype.bargeOut = function (_) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                throw new Error("bargeOut is not supported in MCP mode");
            });
        });
    };
    MCPChat.prototype.bargeIn = function (_agentName, __) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                throw new Error("bargeIn is not supported in MCP mode");
            });
        });
    };
    /**
     * Ensures a nick has the "agent:" prefix required for agent message detection.
     */
    MCPChat.prototype.ensureAgentNick = function (nick) {
        if (!nick)
            return "agent:robot";
        if (nick.startsWith("agent:"))
            return nick;
        return "agent:".concat(nick);
    };
    MCPChat.prototype.getBot = function (user) {
        var _a;
        var bot = (_a = this.options) === null || _a === void 0 ? void 0 : _a.bot;
        if (!user) {
            // Ensure bot nick has agent: prefix and mark as AI
            var defaultBot = bot || { nick: "agent:robot", displayName: "Assistant" };
            return __assign$1(__assign$1({}, defaultBot), { nick: this.ensureAgentNick(defaultBot.nick), isAI: true });
        }
        if (user.displayName && user.nick && user.avatarPath) {
            return __assign$1(__assign$1({}, user), { nick: this.ensureAgentNick(user.nick), isAI: true });
        }
        return __assign$1(__assign$1({}, user), { nick: this.ensureAgentNick(user.nick || (bot === null || bot === void 0 ? void 0 : bot.nick)), displayName: user.displayName || (bot === null || bot === void 0 ? void 0 : bot.displayName) || "Assistant", avatarPath: user.avatarPath || (bot === null || bot === void 0 ? void 0 : bot.avatarPath), isAI: true });
    };
    MCPChat.prototype.sendChatMsgRequest = function (serviceRequest, cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            var error_3;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.postMessage(serviceRequest)];
                    case 1:
                        _a.sent();
                        cb();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        cb(error_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MCPChat.prototype.postMessage = function (message) {
        return __awaiter$1(this, void 0, void 0, function () {
            var trimmedText, timeout, result, retryConfig, messageText, success, attempt, isLastAttempt, config, error_4, statusCode, errorMessage, statusCode_1, errorMessage, nextConfig, nextConfig;
            var _a, _b, _c;
            return __generator$1(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        trimmedText = ((_b = (_a = message.msg) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.trim()) || "";
                        if (!trimmedText) {
                            log$3("Ignoring empty message");
                            return [2 /*return*/];
                        }
                        if (!(this.isInitializingSession && this.sessionInitPromise)) return [3 /*break*/, 2];
                        log$3("Waiting for session initialization to complete before sending message...");
                        timeout = new Promise(function (resolve) {
                            return setTimeout(function () { return resolve("timeout"); }, 10000);
                        });
                        return [4 /*yield*/, Promise.race([this.sessionInitPromise, timeout])];
                    case 1:
                        result = _d.sent();
                        if (result === "timeout" || this.isInitializingSession) {
                            err("Session initialization timed out");
                            this.sendFailureMessage(0, 0, "Chat is not ready. Please try again.");
                            return [2 /*return*/];
                        }
                        _d.label = 2;
                    case 2:
                        retryConfig = this.getRetryConfig();
                        messageText = ((_c = message.msg) === null || _c === void 0 ? void 0 : _c.text) || "";
                        success = false;
                        attempt = 0;
                        _d.label = 3;
                    case 3:
                        if (!(attempt < retryConfig.length)) return [3 /*break*/, 14];
                        isLastAttempt = attempt === retryConfig.length - 1;
                        config = retryConfig[attempt];
                        log$3("MCP attempt ".concat(attempt + 1, "/").concat(retryConfig.length, " for message: ").concat(messageText));
                        // Start typing indicator
                        this.typing();
                        _d.label = 4;
                    case 4:
                        _d.trys.push([4, 6, , 13]);
                        return [4 /*yield*/, this.attemptSSERequest(message)];
                    case 5:
                        _d.sent();
                        success = true;
                        return [3 /*break*/, 14]; // Success - exit retry loop
                    case 6:
                        error_4 = _d.sent();
                        this.stopTyping();
                        statusCode = error_4 === null || error_4 === void 0 ? void 0 : error_4.statusCode;
                        err("MCP attempt ".concat(attempt + 1, " failed: ").concat(error_4, ", statusCode: ").concat(statusCode));
                        log$3("[postMessage] Error details:", { error: error_4, statusCode: statusCode, messageText: messageText, sessionId: this._sessionId });
                        // Don't retry on 4xx client errors - these won't succeed on retry
                        if (statusCode && statusCode >= 400 && statusCode < 500) {
                            log$3("Client error ".concat(statusCode, ", not retrying"));
                            errorMessage = this.getErrorMessage(error_4, statusCode);
                            this.sendFailureMessage(0, 0, errorMessage);
                            return [2 /*return*/];
                        }
                        // Set offline status
                        this.setConnectionStatus("offline");
                        if (!isLastAttempt) return [3 /*break*/, 7];
                        statusCode_1 = error_4 === null || error_4 === void 0 ? void 0 : error_4.statusCode;
                        errorMessage = config.text || this.getErrorMessage(error_4, statusCode_1);
                        this.sendFailureMessage(0, 0, errorMessage);
                        return [3 /*break*/, 12];
                    case 7:
                        if (!(attempt > 0 || config.text)) return [3 /*break*/, 10];
                        nextConfig = retryConfig[attempt + 1];
                        if (!(nextConfig && nextConfig.delay > 0)) return [3 /*break*/, 9];
                        this.sendFailureMessage(nextConfig.retry, nextConfig.delay, nextConfig.text);
                        // Wait for the delay before retrying
                        return [4 /*yield*/, this.delay(nextConfig.delay)];
                    case 8:
                        // Wait for the delay before retrying
                        _d.sent();
                        _d.label = 9;
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        nextConfig = retryConfig[attempt + 1];
                        if (!(nextConfig && nextConfig.delay > 0)) return [3 /*break*/, 12];
                        return [4 /*yield*/, this.delay(nextConfig.delay)];
                    case 11:
                        _d.sent();
                        _d.label = 12;
                    case 12: return [3 /*break*/, 13];
                    case 13:
                        attempt++;
                        return [3 /*break*/, 3];
                    case 14:
                        if (!success) {
                            log$3("All MCP retry attempts exhausted");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Attempts a single SSE request. Throws on failure.
     */
    MCPChat.prototype.attemptSSERequest = function (message) {
        return __awaiter$1(this, void 0, void 0, function () {
            var messageText;
            var _a;
            return __generator$1(this, function (_b) {
                messageText = ((_a = message.msg) === null || _a === void 0 ? void 0 : _a.text) || "";
                log$3("[attemptSSERequest] Sending message: \"".concat(messageText, "\", userId: ").concat(this._userId, ", sessionId: ").concat(this._sessionId));
                return [2 /*return*/, this.performSSERequest(this.buildRequestPayload({ message: messageText }))];
            });
        });
    };
    /**
     * Performs an SSE request with the given body.
     * Used for both new session initialization and regular messages.
     */
    MCPChat.prototype.performSSERequest = function (body) {
        return __awaiter$1(this, void 0, void 0, function () {
            var endpoint, messageId, textChunks, hasError, httpStatusCode, sseError;
            var _this = this;
            return __generator$1(this, function (_a) {
                endpoint = this.getEndpoint();
                log$3("SSE request to ".concat(endpoint, ": ").concat(JSON.stringify(body)));
                // Cancel any ongoing stream
                if (this.abortController) {
                    this.abortController.abort();
                    this.abortController = undefined;
                }
                this.abortController = new AbortController();
                messageId = uuid_1();
                this.currentMessageId = messageId;
                textChunks = [];
                hasError = false;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        // WARNING: Do not log headers object - it contains sensitive auth tokens
                        cjs$3.fetchEventSource(endpoint, {
                            method: "POST",
                            headers: __assign$1({ "Content-Type": "application/json" }, ((_this.config.mode || "homeowner") === "business_owner" && _this.config.authToken
                                ? { Authorization: "Bearer ".concat(_this.config.authToken) }
                                : {})),
                            body: JSON.stringify(body),
                            signal: _this.abortController.signal,
                            onopen: function (response) { return __awaiter$1(_this, void 0, void 0, function () {
                                var error;
                                return __generator$1(this, function (_a) {
                                    httpStatusCode = response.status;
                                    if (!response.ok) {
                                        error = new Error("HTTP error! status: ".concat(response.status));
                                        error.statusCode = response.status;
                                        throw error;
                                    }
                                    log$3("SSE connection opened");
                                    // Connection successful - ensure we're marked as online
                                    this.setConnectionStatus("online");
                                    return [2 /*return*/];
                                });
                            }); },
                            onmessage: function (event) {
                                log$3("SSE event: ".concat(event.event, ", data: ").concat(event.data));
                                var eventType = event.event || "message";
                                var data = {};
                                try {
                                    data = JSON.parse(event.data);
                                }
                                catch (e) {
                                    log$3("Failed to parse SSE data: ".concat(e));
                                    return;
                                }
                                // Track sequence number for replay on reconnect
                                if (data.seq !== undefined && data.seq !== null) {
                                    _this.lastSeq = data.seq;
                                    if (_this._sessionId) {
                                        storeLastSeq(_this._sessionId, data.seq);
                                    }
                                }
                                switch (eventType) {
                                    case "connected":
                                        // Connection established
                                        log$3("[SSE] Connected event received, messageId: ".concat(messageId, ", isReturningUser: ").concat(data.isReturningUser, ", isReplay: ").concat(data.isReplay));
                                        // Track if this is a replay connection
                                        if (data.isReplay) {
                                            _this.isReplaying = true;
                                        }
                                        // Store identity from server response
                                        if (data.userId || data.sessionId) {
                                            if (data.userId) {
                                                _this._userId = data.userId;
                                                _this.userIdIsServerAssigned = true;
                                            }
                                            if (data.sessionId) {
                                                _this._sessionId = data.sessionId;
                                                _this.dispatch(setSessionId(_this._sessionId));
                                            }
                                            // Persist to localStorage for session continuity
                                            storeIdentity(data.userId, data.sessionId);
                                            log$3("[SSE] Identity from connected - userId: ".concat(data.userId, ", sessionId: ").concat(data.sessionId));
                                        }
                                        // Always start streaming - server sends greeting for both new and returning users
                                        // (resumeSession requests always get a personalized greeting)
                                        _this.currentToolCalls = [];
                                        _this.stopTyping();
                                        _this.dispatchStreamStart(messageId);
                                        _this.startStreamThrottle(messageId);
                                        break;
                                    case "session_expired":
                                        // Session no longer exists on server - need to start fresh
                                        log$3("[SSE] Session expired: ".concat(data.reason || "Session not found"));
                                        // Clear stored session (and lastSeq) but keep userId for returning user identification
                                        clearStoredSession(_this._sessionId);
                                        _this._sessionId = "";
                                        _this.lastSeq = undefined;
                                        _this.stopTyping();
                                        _this.stopStreamThrottle();
                                        // Reset validation flag before starting new session
                                        // (ensures connected handler will dispatch stream for greeting)
                                        _this.isValidatingSession = false;
                                        // Start a new session automatically
                                        _this.initializeNewSession();
                                        resolve();
                                        break;
                                    case "text":
                                        if (data.text) {
                                            log$3("[SSE] Text chunk received (".concat(data.text.length, " chars), total chunks: ").concat(textChunks.length + 1, ", isReplay: ").concat(data.isReplay));
                                            textChunks.push(data.text);
                                            if (data.isReplay) {
                                                // Replayed text — dispatch immediately (no throttle)
                                                // so the user sees caught-up content instantly
                                                _this.dispatchStreamChunk(messageId, data.text);
                                            }
                                            else {
                                                // Live text — buffer for throttled dispatch
                                                _this.bufferStreamText(data.text);
                                            }
                                        }
                                        break;
                                    case "tool_start":
                                        log$3("Tool execution started: ".concat(data.toolName, ", toolCallId: ").concat(data.toolCallId, ", displayName: ").concat(data.displayName, ", label: ").concat(data.label, ", hidden: ").concat(data.hidden));
                                        if (data.toolName) {
                                            var toolCall = {
                                                name: data.toolName,
                                                toolCallId: data.toolCallId,
                                                displayName: data.displayName,
                                                label: data.label,
                                                hidden: data.hidden,
                                                input: data.toolInput,
                                                startTime: Date.now(),
                                                isExecuting: true,
                                            };
                                            _this.currentToolCalls.push(toolCall);
                                            // Always dispatch tool start for user-friendly progress display
                                            _this.dispatchToolStart({
                                                messageId: messageId,
                                                toolName: data.toolName,
                                                toolCallId: data.toolCallId,
                                                displayName: data.displayName,
                                                label: data.label,
                                                hidden: data.hidden,
                                                toolInput: data.toolInput,
                                            });
                                        }
                                        break;
                                    case "tool_end":
                                        log$3("Tool execution ended: ".concat(data.toolName, ", toolCallId: ").concat(data.toolCallId, ", displayName: ").concat(data.displayName, ", label: ").concat(data.label, ", hidden: ").concat(data.hidden));
                                        if (data.toolName) {
                                            // Find the matching tool call and update it
                                            // Match by toolCallId if available, otherwise fall back to name + isExecuting
                                            var toolCall = _this.currentToolCalls.find(function (tc) {
                                                return data.toolCallId
                                                    ? tc.toolCallId === data.toolCallId
                                                    : tc.name === data.toolName && tc.isExecuting;
                                            });
                                            if (toolCall) {
                                                toolCall.result = data.toolResult;
                                                toolCall.error = data.toolError;
                                                toolCall.label = data.label; // Update with completion label
                                                toolCall.hidden = data.hidden; // Update hidden status
                                                toolCall.endTime = Date.now();
                                                toolCall.isExecuting = false;
                                            }
                                            // Always dispatch tool end for user-friendly progress display
                                            _this.dispatchToolEnd({
                                                messageId: messageId,
                                                toolName: data.toolName,
                                                toolCallId: data.toolCallId,
                                                displayName: data.displayName,
                                                label: data.label,
                                                hidden: data.hidden,
                                                toolResult: data.toolResult,
                                                toolError: data.toolError,
                                            });
                                        }
                                        break;
                                    case "done":
                                        _this.stopTyping();
                                        if (data.response) {
                                            // Update session ID if provided and persist to localStorage
                                            if (data.response.sessionId) {
                                                _this._sessionId = data.response.sessionId;
                                                _this.dispatch(setSessionId(_this._sessionId));
                                                storeIdentity(undefined, data.response.sessionId);
                                            }
                                            // Wait for buffer to flush, then finalize
                                            var accumulatedText = textChunks.join("");
                                            log$3("[SSE] Done event received. Total chunks: ".concat(textChunks.length, ", accumulated text length: ").concat(accumulatedText.length));
                                            log$3("[SSE] First 100 chars of accumulated: ".concat(accumulatedText.substring(0, 100)));
                                            // Map suggestions to options (chips) format
                                            var suggestions = data.response.suggestions;
                                            var options = suggestions === null || suggestions === void 0 ? void 0 : suggestions.map(function (s) { return ({
                                                label: s.title,
                                                actionUrl: s.url || "",
                                            }); });
                                            if (options === null || options === void 0 ? void 0 : options.length) {
                                                log$3("[SSE] Suggestions: ".concat(options.length, " items"));
                                            }
                                            // Map sources for reference links
                                            var sources = data.response.sources;
                                            if (sources === null || sources === void 0 ? void 0 : sources.length) {
                                                log$3("[SSE] Sources: ".concat(sources.length, " items"));
                                            }
                                            var finalMessage_1 = {
                                                text: accumulatedText || data.response.response || "",
                                                options: options,
                                                sources: sources,
                                                displays: data.response.displays,
                                            };
                                            // Capture tool calls before flushing (debug mode)
                                            var toolCalls_1 = _this.config.debugMode ? __spreadArray$1([], _this.currentToolCalls, true) : undefined;
                                            _this.flushStreamBuffer().then(function () {
                                                _this.dispatchStreamEnd(messageId, finalMessage_1, toolCalls_1);
                                                _this.currentToolCalls = []; // Clear after dispatch
                                                resolve();
                                            });
                                        }
                                        else {
                                            _this.stopStreamThrottle();
                                            resolve();
                                        }
                                        break;
                                    case "replay_complete":
                                        _this.isReplaying = false;
                                        log$3("[SSE] Replay complete: replayed ".concat(data.replayedCount, " events, currentSeq: ").concat(data.currentSeq));
                                        break;
                                    case "replay_partial":
                                        _this.isReplaying = false;
                                        log$3("[SSE] Replay partial: some events unavailable, oldestAvailableSeq: ".concat(data.oldestAvailableSeq));
                                        break;
                                    case "error":
                                        hasError = true;
                                        _this.stopTyping();
                                        _this.stopStreamThrottle();
                                        err("SSE error: ".concat(data.error));
                                        // Server-side errors should not retry - reject immediately with the error
                                        reject(new Error(data.error || "Server error during processing"));
                                        break;
                                }
                            },
                            onerror: function (error) {
                                // Only handle error if this is still the current message
                                if (_this.currentMessageId === messageId && !hasError) {
                                    hasError = true;
                                    _this.isReplaying = false;
                                    _this.stopStreamThrottle();
                                    sseError = error instanceof Error ? error : new Error(String(error));
                                    // Get status code if available
                                    var statusCode = (error === null || error === void 0 ? void 0 : error.statusCode) || httpStatusCode;
                                    if (statusCode) {
                                        sseError.statusCode = statusCode;
                                    }
                                    err("SSE connection error: ".concat(error));
                                }
                                // Throw to stop fetchEventSource from retrying
                                throw error;
                            },
                        }).catch(function (error) {
                            // Handle errors that occur before/outside the SSE connection
                            _this.stopStreamThrottle();
                            if (!hasError && _this.currentMessageId === messageId) {
                                var statusCode = (error === null || error === void 0 ? void 0 : error.statusCode) || httpStatusCode;
                                var wrappedError = error instanceof Error ? error : new Error(String(error));
                                if (statusCode) {
                                    wrappedError.statusCode = statusCode;
                                }
                                reject(wrappedError);
                            }
                            else if (sseError) {
                                reject(sseError);
                            }
                            else {
                                reject(error);
                            }
                        });
                    })];
            });
        });
    };
    MCPChat.prototype.sendTyping = function () { };
    MCPChat.prototype.setVisitorInfo = function (visitorInfo, sessionId, cb) {
        this.visitorInfo = visitorInfo;
        this._attributes = __assign$1({}, this.visitorInfo.attributes);
        // do not set currentUrl if localhost
        var href = new URL(window.location.href);
        if (href === null || href === void 0 ? void 0 : href.host.toLowerCase().startsWith("localhost")) {
            this._attributes.isLocal = true;
        }
        else {
            this._attributes.currentUrl = window.location.href;
        }
        this._accessToken = this.visitorInfo.accessToken;
        // Bot joined is dispatched in init() to ensure correct ordering
        // Show typing indicator if we're still waiting for initial greeting
        if (this.isInitializingSession) {
            this.typing();
        }
        this.startSession(sessionId);
        cb();
    };
    MCPChat.prototype.sendChatRating = function () { };
    MCPChat.prototype.sendFile = function (_, cb) {
        cb(new Error("File upload not supported in MCP mode"));
    };
    MCPChat.prototype.markAsRead = function () { };
    MCPChat.prototype.flush = function () { };
    MCPChat.prototype.dispose = function () {
        this.stopStreamThrottle();
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = undefined;
        }
    };
    MCPChat.prototype.sleep = function () {
        this.stopStreamThrottle();
        this.isReplaying = false;
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = undefined;
        }
    };
    MCPChat.prototype.wakeup = function () {
        // When tab is foregrounded, just restore connection status.
        // Don't validate/replay yet — the session will be validated
        // on the next user message. This avoids creating duplicate
        // greetings if validation fails transiently.
        if (this._sessionId) {
            log$3("[MCPChat] Wakeup - session exists, lastSeq: ".concat(this.lastSeq));
            this.setConnectionStatus("online");
        }
    };
    MCPChat.prototype.startSession = function (sessionId) {
        // userId priority:
        // 1. Existing server-assigned userId (from localStorage or previous connected event)
        // 2. Explicitly provided visitorId or email from host app
        // 3. Generate a new one as last resort
        if (this.userIdIsServerAssigned) {
            // Keep server-assigned userId — don't overwrite with default fingerprint
            log$3("[startSession] Preserving server-assigned userId: ".concat(this._userId));
        }
        else if (this.visitorInfo.visitorId) {
            this._userId = "".concat(this.visitorInfo.visitorId);
        }
        else if (this.visitorInfo.email) {
            this._userId = "mcp-widget-user-".concat(this.visitorInfo.email);
        }
        else if (!this._userId) {
            // Only generate a new userId if we don't already have one
            // (preserves userId loaded from localStorage or received from server)
            this._userId = "mcp-widget-user-".concat(uuid_1());
        }
        // Session ID priority:
        // 1. If explicitly provided via setVisitorInfo, use it
        // 2. If empty string provided, generate a new session ID
        // 3. If not provided (undefined) and we have an existing session, keep it
        if (sessionId) {
            // Explicit session ID provided - use it
            this._sessionId = sessionId;
            log$3("Using provided session id: ".concat(this._sessionId));
        }
        else if (sessionId === "") {
            // Empty string explicitly passed - generate new session
            this._sessionId = "mcp-widget-session-".concat(uuid_1());
            this.dispatch(setSessionId(this._sessionId));
            log$3("Using generated session id: ".concat(this._sessionId));
        }
        else if (!this._sessionId && this.config.sessionId) {
            // No existing session and config has one - use config
            this._sessionId = this.config.sessionId;
            log$3("Using config session id: ".concat(this._sessionId));
        }
        else if (!this._sessionId) {
            // No session ID at all - generate one
            this._sessionId = "mcp-widget-session-".concat(uuid_1());
            this.dispatch(setSessionId(this._sessionId));
            log$3("Using generated session id: ".concat(this._sessionId));
        }
        else {
            log$3("Keeping existing session id: ".concat(this._sessionId));
        }
        this.isNewSession = true;
    };
    Object.defineProperty(MCPChat.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MCPChat.prototype, "sessionId", {
        get: function () {
            return this._sessionId;
        },
        enumerable: false,
        configurable: true
    });
    return MCPChat;
}());

/**
 * Sends a POST to your STENTOR based server.
 *
 * @param data
 * @param url
 * @param key
 * @param signal
 * @returns
 */
function postMessageToStentor(data, url, key, signal) {
    return __awaiter$1(this, void 0, void 0, function () {
        var body, response;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    body = JSON.stringify(data);
                    log$3("URL: ".concat(url));
                    log$3("BODY: ".concat(body));
                    return [4 /*yield*/, fetch(url, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": "Bearer ".concat(key),
                            },
                            body: body,
                            mode: "cors",
                            signal: signal
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Status ".concat(response.status, ", Text: ").concat(response.statusText));
                    }
                    return [2 /*return*/, response.json()];
            }
        });
    });
}

function convertFromListDisplay(list) {
    return {
        type: list.type,
        title: list.title,
        items: list.items.map(function (item) {
            var _a, _b;
            var responseItem = {
                title: item.title,
                subTitle: item.description,
                token: item.token,
                url: item.url,
                hideUrl: item.hideUrl,
                imageUrl: (_a = item.image) === null || _a === void 0 ? void 0 : _a.url,
                imageActionUrl: (_b = item.image) === null || _b === void 0 ? void 0 : _b.imageActionUrl
            };
            // TODO: Remove any when the buttons are defined on the list (ListButton - title + openUrlAction)
            var itemButtons = item.buttons;
            if (itemButtons && itemButtons.length > 0) {
                responseItem.buttons = itemButtons.map(function (button) { return ({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    actionUrl: button.openUrlAction,
                    label: button.title
                }); });
            }
            return responseItem;
        })
    };
}
function convertToListDisplay(list) {
    return {
        type: list.type,
        title: list.title,
        items: (list.items || []).map(function (item) {
            var responseItem = {
                title: item.title,
                description: item.subTitle,
                token: item.token,
                url: item.url,
                hideUrl: item.hideUrl,
                image: {
                    url: item.imageUrl,
                    imageActionUrl: item.imageActionUrl,
                    accessibilityText: ""
                }
            };
            // TODO: Remove any when the buttons are defined on the list (ListButton - title + openUrlAction)
            var itemButtons = item.buttons;
            if (itemButtons && itemButtons.length > 0) {
                responseItem.buttons = itemButtons.map(function (button) { return ({
                    openUrlAction: button.actionUrl,
                    title: button.label
                }); });
            }
            return responseItem;
        })
    };
}
function convertFromCardDisplay(card) {
    return {
        content: card.content,
        imageUrl: card.smallImageUrl,
        title: card.title,
        imageActionUrl: card === null || card === void 0 ? void 0 : card.imageActionUrl,
        buttons: card.buttons ? card.buttons.map(function (button) { return ({
            actionUrl: button.openUrlAction,
            label: button.title
        }); }) : undefined
    };
}
function getOutput(value) {
    if (value) {
        if (typeof value === "string") {
            return {
                displayText: value
            };
        }
        else {
            return value;
        }
    }
    return undefined;
}
/**
 * Converts a Stentor Response to a ChatMessageRequest
 *
 * @param botResponse
 * @param now
 * @returns
 */
function responseToMessage(botResponse, now) {
    var _a, _b, _c, _d, _e;
    if (now === void 0) { now = new Date().getTime(); }
    var responseMessage;
    if (!botResponse) {
        return responseMessage;
    }
    var text;
    var html;
    var endSession;
    var outputSpeech = getOutput(botResponse.outputSpeech);
    var reprompt = getOutput(botResponse.reprompt);
    if (outputSpeech) {
        text = outputSpeech.displayText;
        html = outputSpeech.html;
    }
    if (botResponse.system === "TRANSFER_CALL") {
        responseMessage = {
            type: "handOff",
            timestamp: now,
            handoffMessage: text,
            handoffTarget: (_a = botResponse === null || botResponse === void 0 ? void 0 : botResponse.data) === null || _a === void 0 ? void 0 : _a.transferPhoneNumber,
            endSession: false,
            user: undefined
        };
    }
    else if ((_b = botResponse.system) === null || _b === void 0 ? void 0 : _b.startsWith("PERMISSION_")) {
        responseMessage = getPermissionResponse(botResponse, now);
    }
    else {
        endSession = !reprompt || !(reprompt.displayText || reprompt.ssml);
        responseMessage = {
            type: "msg",
            timestamp: now,
            msg: {
                displays: botResponse.displays,
                context: (_d = (_c = botResponse.context) === null || _c === void 0 ? void 0 : _c.active) === null || _d === void 0 ? void 0 : _d.map(function (ctx) { return ctx.name; })
            },
            endSession: endSession,
            user: undefined
        };
        if (text && !html) {
            responseMessage.msg = __assign$1(__assign$1({}, responseMessage.msg), { text: text });
        }
        if (html) {
            responseMessage.msg = __assign$1(__assign$1({}, responseMessage.msg), { html: html });
        }
        if ((_e = outputSpeech === null || outputSpeech === void 0 ? void 0 : outputSpeech.suggestions) === null || _e === void 0 ? void 0 : _e.length) {
            responseMessage.msg.options = outputSpeech.suggestions.map(function (suggestion) {
                if (typeof suggestion === "string") {
                    // Simple chips (strings)
                    return suggestion;
                }
                else {
                    // "call out" chips
                    return {
                        label: suggestion.title,
                        actionUrl: suggestion.url
                    };
                }
            });
        }
    }
    return responseMessage;
}
function getPermissionRequestType(type) {
    switch (type) {
        case "PERMISSION_EMAIL":
            return "EMAIL";
        case "PERMISSION_LOCATION_PRECISE":
            return "LOCATION_PRECISE";
        default:
            throw new Error("Unsupported permission: ".concat(type));
    }
}
function getPermissionResponse(botResponse, now) {
    var _a;
    var type = getPermissionRequestType(botResponse.system);
    var outputSpeech = getOutput(botResponse.outputSpeech);
    var permissionPrimerAccepted = botResponse.data.permissionPrimerAccepted;
    var permissionDenied = botResponse.data.permissionDenied;
    return {
        type: "permissionRequest",
        timestamp: now,
        msg: {
            text: (_a = outputSpeech === null || outputSpeech === void 0 ? void 0 : outputSpeech.displayText) !== null && _a !== void 0 ? _a : "".concat(botResponse.data.permissionRequestTTSContext),
            permissionRequest: {
                time: now,
                type: type,
                approve: typeof permissionPrimerAccepted === "object" ? responseToMessage({
                    outputSpeech: permissionPrimerAccepted
                }).msg : undefined,
                deny: typeof permissionDenied === "object" ? responseToMessage({
                    outputSpeech: permissionDenied
                }).msg : undefined
            }
        },
        endSession: false,
        user: undefined //todo: set
    };
}

var PERMISSION_QUESTION_EXPIRATION_MS$1 = 300000; // 5 minutes
// interface UserLeaveMessage {
//     readonly user: ChatUserInfo;
//     readonly token: string; //todo: what is this
// }
var StentorDirectChat = /** @class */ (function () {
    function StentorDirectChat(config, options) {
        this._userId = "";
        this._sessionId = "";
        this._accessToken = "";
        this._attributes = {};
        this.config = config;
        this.options = options;
        this.configurableMessages = options.configurableMessages;
        this.isNewSession = false;
        this.hooks = options.hooks;
    }
    StentorDirectChat.prototype.init = function (dispatch) {
        this.dispatch = dispatch;
        // TODO: Authenticate - or at least tell the server who you are
        log$3("got init auth: ".concat(this.config.key));
        // We are connected
        this.setConnectionStatus("online");
        this.setAccountStatus("online");
    };
    StentorDirectChat.prototype.setConnectionStatus = function (status) {
        log$3("SERVER: connection_update: ".concat(JSON.stringify(status)));
        this.dispatch(setConnectionStatus(status));
    };
    StentorDirectChat.prototype.setAccountStatus = function (status) {
        log$3("SERVER: account_status: ".concat(JSON.stringify(status)));
        this.dispatch(setAccountStatus(status));
    };
    StentorDirectChat.prototype.sendNewMessage = function (data) {
        log$3("SERVER: new message: ".concat(JSON.stringify(data)));
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.msg",
                user: __assign$1(__assign$1({}, data.user), { nick: "agent:robot" }),
                msg: data.msg,
                timestamp: +new Date(),
            },
        });
    };
    StentorDirectChat.prototype.userJoined = function (data) {
        log$3("SERVER: user joined: ".concat(JSON.stringify(data)));
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.memberjoin",
                user: __assign$1(__assign$1({}, data.user), { nick: "agent:robot" }),
                timestamp: +new Date(),
            },
        });
    };
    // private userLeft(data: UserLeaveMessage) {
    //     log(`SERVER: user left: ${JSON.stringify(data)}`);
    //     this.dispatch({
    //         type: "chat",
    //         detail: {
    //             type: "chat.memberleave",
    //             user: {
    //                 ...data.user,
    //                 nick: "agent:robot",//todo: why change nick?
    //             },
    //             timestamp: +new Date()
    //         }
    //     });
    // }
    StentorDirectChat.prototype.typing = function () {
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.typing",
                user: {
                    nick: "agent:robot",
                },
                typing: true,
                timestamp: +new Date(),
            },
        });
    };
    StentorDirectChat.prototype.stopTyping = function () {
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.typing",
                user: {
                    nick: "agent:robot",
                },
                typing: false,
                timestamp: +new Date(),
            },
        });
    };
    StentorDirectChat.prototype.sendFailureMessage = function (retry, delay, text) {
        this.stopTyping();
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.failureMsg",
                user: {
                    nick: "agent:robot",
                },
                failureMsg: {
                    retry: retry,
                    delay: delay,
                    text: text,
                },
                timestamp: +new Date(),
            },
        });
    };
    // private disconnect() {
    //     log("SERVER: disconnect");
    //     this.dispatch(setAccountStatus("offline"));
    //     this.dispatch(setConnectionStatus("offline"));
    // }
    // private reconnect() {
    //     log("SERVER: reconnect");
    //     this.dispatch(setAccountStatus("online"));
    // }
    // private reconnectError() {
    //     log("SERVER: reconnect error");
    //     this.dispatch(setAccountStatus("offline"));
    // }
    StentorDirectChat.prototype.sendOfflineMsg = function (_, cb) {
        cb();
    };
    StentorDirectChat.prototype.sendChatMsg = function (message, cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, this.sendChatMsgRequest({
                        msg: message,
                        timestamp: new Date().getTime(),
                        agent: false,
                        user: undefined,
                        type: "msg",
                    }, cb)];
            });
        });
    };
    StentorDirectChat.prototype.bargeOut = function (_cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                throw new Error("Method not implemented: bargeOut");
            });
        });
    };
    StentorDirectChat.prototype.bargeIn = function (_agentName, _cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                throw new Error("Method not implemented: bargeIn");
            });
        });
    };
    StentorDirectChat.prototype.getBot = function (user) {
        var _a;
        var bot = (_a = this.options) === null || _a === void 0 ? void 0 : _a.bot;
        if (!user) {
            return bot;
        }
        if (user.displayName && user.nick && user.avatarPath) {
            return user;
        }
        return __assign$1(__assign$1({}, user), { nick: user.nick || bot.nick || "Bot", displayName: user.displayName || bot.displayName || "Bot", avatarPath: user.avatarPath || bot.avatarPath });
    };
    StentorDirectChat.prototype.sendChatMsgRequest = function (serviceRequest, cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            var agentResponse;
            var _a;
            return __generator$1(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.postMessage(serviceRequest)];
                    case 1:
                        agentResponse = _b.sent();
                        if (!((_a = agentResponse.user) === null || _a === void 0 ? void 0 : _a.displayName)) {
                            agentResponse = __assign$1(__assign$1({}, agentResponse), { user: this.getBot(agentResponse.user) });
                        }
                        this.sendNewMessage(agentResponse);
                        cb();
                        return [2 /*return*/];
                }
            });
        });
    };
    StentorDirectChat.prototype.sendTyping = function () { };
    StentorDirectChat.prototype.setVisitorInfo = function (visitorInfo, sessionId, cb) {
        this.visitorInfo = visitorInfo;
        this._attributes = __assign$1({}, this.visitorInfo.attributes);
        // do not set currentUrl if localhost, localhost is not liked by some firewalls, like AWS WAF
        var href = new URL(window.location.href);
        if (href === null || href === void 0 ? void 0 : href.host.toLowerCase().startsWith("localhost")) {
            // we still need to communicate it is localhost though so we make this boolean
            this._attributes.isLocal = true;
        }
        else {
            // not localhost, set it
            this._attributes.currentUrl = window.location.href;
        }
        this._accessToken = this.visitorInfo.accessToken;
        // This is for the bot
        this.userJoined({
            user: this.getBot(undefined),
            token: "",
        });
        this.startSession(sessionId);
        cb();
    };
    StentorDirectChat.prototype.sendChatRating = function () { };
    StentorDirectChat.prototype.sendFile = function (_, cb) {
        cb();
    };
    StentorDirectChat.prototype.markAsRead = function () {
        // mark the messages read
    };
    StentorDirectChat.prototype.flush = function () { };
    StentorDirectChat.prototype.dispose = function () { };
    StentorDirectChat.prototype.sleep = function () { };
    StentorDirectChat.prototype.wakeup = function () { };
    StentorDirectChat.prototype.postMessage = function (message) {
        return __awaiter$1(this, void 0, void 0, function () {
            var request, userId, sessionId, accessToken, attributes, rwgToken, merchantId, environment, enablePreferredTime, service, origin, now, permissionRequest, expired, text, granted, userProfile, isEmail, configurableMessages, botResponse, successResult, success, fail, i, timeout, responseMessage;
            var _this = this;
            var _a, _b, _c, _d, _e;
            return __generator$1(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        userId = this._userId;
                        sessionId = this._sessionId;
                        accessToken = this._accessToken;
                        attributes = this._attributes || {};
                        rwgToken = localStorage.getItem("xa_rwg_token");
                        if (rwgToken) {
                            attributes["rwg_token"] = rwgToken;
                        }
                        merchantId = localStorage.getItem("xa_merchant_id");
                        if (merchantId) {
                            attributes["merchant_id"] = merchantId;
                        }
                        environment = localStorage.getItem("xa_environment");
                        if (environment) {
                            attributes["environment"] = environment;
                        }
                        enablePreferredTime = localStorage.getItem("xa_enablePreferredTime");
                        if (enablePreferredTime) {
                            attributes["enablePreferredTime"] = enablePreferredTime;
                        }
                        service = localStorage.getItem("xa_service");
                        if (service) {
                            attributes["service"] = service;
                        }
                        origin = localStorage.getItem("xa_origin");
                        if (origin) {
                            attributes["origin"] = origin;
                        }
                        // Add current time for accurate date/time responses
                        attributes["currentTime"] = new Date().toISOString();
                        now = new Date().getTime();
                        if (this.isNewSession && !((_a = message === null || message === void 0 ? void 0 : message.msg) === null || _a === void 0 ? void 0 : _a.text)) {
                            request = {
                                type: "LAUNCH_REQUEST",
                                rawQuery: (_b = message === null || message === void 0 ? void 0 : message.msg) === null || _b === void 0 ? void 0 : _b.text,
                                sessionId: sessionId,
                                userId: userId,
                                isNewSession: true,
                                intentId: "LaunchRequest",
                                platform: "stentor-platform",
                                channel: "widget",
                                accessToken: accessToken,
                                attributes: attributes,
                            };
                        }
                        else {
                            permissionRequest = (_c = message.msg) === null || _c === void 0 ? void 0 : _c.permissionRequest;
                            if (permissionRequest) {
                                message = __assign$1(__assign$1({}, message), { msg: __assign$1(__assign$1({}, message.msg), { permissionRequest: undefined }) });
                                expired = now - permissionRequest.time > PERMISSION_QUESTION_EXPIRATION_MS$1;
                                text = (_d = message.msg.text) === null || _d === void 0 ? void 0 : _d.toLowerCase();
                                granted = !expired;
                                userProfile = { id: this._userId };
                                if (!expired) {
                                    if (permissionRequest.type === "EMAIL") {
                                        isEmail = looksLikeEmail$1(text);
                                        granted = isEmail;
                                        userProfile.email = this.visitorInfo.email;
                                        userProfile.name = this.visitorInfo.displayName;
                                        this.visitorInfo.email = text;
                                    }
                                    if (permissionRequest.type === "LOCATION_PRECISE") {
                                        granted = !!message.msg.location;
                                        userProfile.preciseLocation = message.msg.location
                                            ? {
                                                coordinates: {
                                                    latitude: message.msg.location.latitude,
                                                    longitude: message.msg.location.longitude,
                                                },
                                            }
                                            : undefined;
                                    }
                                }
                                request = {
                                    type: "PERMISSION_GRANT",
                                    rawQuery: message.msg.text,
                                    sessionId: this._sessionId,
                                    userId: this._userId,
                                    isNewSession: false,
                                    granted: granted,
                                    userProfile: userProfile,
                                    intentId: "PermissionGrant",
                                    platform: "stentor-platform",
                                    channel: "widget",
                                    accessToken: accessToken,
                                    attributes: attributes,
                                };
                            }
                            else if (message.type === "custom") {
                                request = __assign$1(__assign$1({}, JSON.parse(message.payload)), { 
                                    // token: message.msg.token,
                                    sessionId: this._sessionId, userId: this._userId, isNewSession: false, 
                                    // intentId: "OptionSelect",
                                    platform: "stentor-platform", channel: "widget", accessToken: accessToken, attributes: attributes });
                            }
                            else if (message.msg.token) {
                                request = {
                                    type: "OPTION_SELECT_REQUEST",
                                    token: message.msg.token,
                                    sessionId: this._sessionId,
                                    userId: this._userId,
                                    isNewSession: false,
                                    intentId: "OptionSelect",
                                    platform: "stentor-platform",
                                    channel: "widget",
                                    accessToken: accessToken,
                                    attributes: attributes,
                                };
                            }
                            else {
                                request = {
                                    type: "INTENT_REQUEST",
                                    rawQuery: message.msg.text,
                                    sessionId: this._sessionId,
                                    userId: this._userId,
                                    isNewSession: false,
                                    intentId: "NLU_RESULT_PLACEHOLDER",
                                    platform: "stentor-platform",
                                    channel: "widget",
                                    accessToken: accessToken,
                                    attributes: attributes,
                                };
                            }
                        }
                        log$3("Visitor says: ".concat(JSON.stringify(request, undefined, 2)));
                        configurableMessages = getConfigurableMessagesConfig(this.configurableMessages);
                        successResult = false;
                        success = function (result) {
                            botResponse = result;
                            successResult = true;
                        };
                        fail = function (i, error) { return __awaiter$1(_this, void 0, void 0, function () {
                            var retry, delay, text;
                            return __generator$1(this, function (_a) {
                                retry = configurableMessages[i].retry;
                                delay = configurableMessages[i].delay;
                                text = configurableMessages[i].text;
                                err("POST failed: ".concat(error));
                                this.sendFailureMessage(retry, delay, text);
                                botResponse = { errorText: "" };
                                // We need to delay before we actually make another fetch call again
                                return [2 /*return*/, new Promise(function (resolve) {
                                        // * 1000 to make it seconds
                                        setTimeout(resolve, delay * 1000);
                                    })];
                            });
                        }); };
                        i = 1;
                        _f.label = 1;
                    case 1:
                        if (!(i < configurableMessages.length)) return [3 /*break*/, 4];
                        timeout = this.config.timeout || 22000;
                        log$3("POST attempt ".concat(i, " with timeout ").concat(timeout));
                        this.typing();
                        // We don't start typing IF we have a failure message displayed and we are waiting on the timeout
                        return [4 /*yield*/, new RetryRequest({ retries: 1, timeout: timeout })
                                .fetch(function (signal) {
                                return postMessageToStentor(request, _this.config.url, _this.config.key, signal);
                            })
                                .then(success)
                                // bind the i, the current iteration, to the fail function for looking up the message
                                .catch(fail.bind(this, i))];
                    case 2:
                        // We don't start typing IF we have a failure message displayed and we are waiting on the timeout
                        _f.sent();
                        // If we have what we want, break the for loop
                        if (successResult) {
                            return [3 /*break*/, 4];
                        }
                        _f.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        log$3("Bot says: ".concat(JSON.stringify(botResponse, undefined, 2)));
                        // Now translate the response to server dialect
                        // new session no more
                        this.isNewSession = false;
                        responseMessage = responseToMessage(botResponse);
                        if ((botResponse === null || botResponse === void 0 ? void 0 : botResponse.hasOwnProperty("errorText")) || !botResponse) {
                            responseMessage = {
                                type: "userLeft",
                                timestamp: now,
                                msg: {},
                                user: undefined,
                                endSession: true,
                            };
                            responseMessage.msg = {
                                text: (botResponse === null || botResponse === void 0 ? void 0 : botResponse.hasOwnProperty("errorText"))
                                    ? //eslint-disable-next-line
                                        //@ts-ignore
                                        botResponse.errorText
                                    : "The assistant is not responding right now.  Please close the widget and open it again.",
                            };
                        }
                        if (typeof ((_e = this.hooks) === null || _e === void 0 ? void 0 : _e.onResponse) === "function") {
                            this.hooks.onResponse(botResponse);
                        }
                        this.stopTyping();
                        return [2 /*return*/, responseMessage];
                }
            });
        });
    };
    StentorDirectChat.prototype.startSession = function (sessionId) {
        if (this.visitorInfo.visitorId) {
            this._userId = "".concat(this.visitorInfo.visitorId);
        }
        else if (this.visitorInfo.email) {
            this._userId = "stentor-widget-user-".concat(this.visitorInfo.email);
        }
        else {
            this._userId = "stentor-widget-user-".concat(uuid_1());
        }
        if (sessionId) {
            this._sessionId = sessionId;
            log$3("Using persisted session id: ".concat(this._sessionId));
        }
        else {
            this._sessionId = "stentor-widget-session-".concat(uuid_1());
            this.dispatch(setSessionId(this._sessionId));
            log$3("Using generated session id: ".concat(this._sessionId));
        }
        // This is a flag that is cleared after the first message is sent
        this.isNewSession = true;
    };
    Object.defineProperty(StentorDirectChat.prototype, "userId", {
        // private restartSession(): void {
        //     this._sessionId = `stentor-chat-session-${uuid()}`;
        //     this.isNewSession = true;
        // }
        // private endSession(): Promise<void> {
        //     return Promise.resolve(undefined);
        // }
        get: function () {
            return this._userId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StentorDirectChat.prototype, "sessionId", {
        get: function () {
            return this._sessionId;
        },
        enumerable: false,
        configurable: true
    });
    return StentorDirectChat;
}());
function looksLikeEmail$1(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

var StentorLocalChat = /** @class */ (function () {
    function StentorLocalChat() {
    }
    StentorLocalChat.prototype.init = function () {
    };
    StentorLocalChat.prototype.sendOfflineMsg = function () {
    };
    StentorLocalChat.prototype.sendChatMsg = function () {
    };
    StentorLocalChat.prototype.sendChatMsgRequest = function () {
    };
    StentorLocalChat.prototype.sendTyping = function () {
    };
    StentorLocalChat.prototype.setVisitorInfo = function () {
    };
    StentorLocalChat.prototype.sendChatRating = function () {
    };
    StentorLocalChat.prototype.sendFile = function () {
    };
    StentorLocalChat.prototype.markAsRead = function () {
    };
    StentorLocalChat.prototype.flush = function () {
    };
    StentorLocalChat.prototype.dispose = function () {
    };
    StentorLocalChat.prototype.bargeOut = function () {
    };
    StentorLocalChat.prototype.bargeIn = function () {
    };
    StentorLocalChat.prototype.sleep = function () {
    };
    StentorLocalChat.prototype.wakeup = function () {
    };
    return StentorLocalChat;
}());

/**
 * Animation duration for WebSocket button dismiss animation (in milliseconds).
 * This should match the CSS animation duration in WsButton.scss.
 */
var WS_BUTTON_DISMISS_ANIMATION_DURATION = 300;

/*! Copyright (c) 2022, XAPPmedia */
var PERMISSION_QUESTION_EXPIRATION_MS = 300000; // 5 minutes
function requestFromMessage(message, userId, isNewSession, sessionId, accessToken, attributes, visitorInfo) {
    var _a, _b, _c, _d, _e;
    var request;
    var now = new Date().getTime();
    if (isNewSession && !((_a = message === null || message === void 0 ? void 0 : message.msg) === null || _a === void 0 ? void 0 : _a.text)) {
        request = {
            type: "LAUNCH_REQUEST",
            rawQuery: (_b = message === null || message === void 0 ? void 0 : message.msg) === null || _b === void 0 ? void 0 : _b.text,
            sessionId: sessionId,
            userId: userId,
            isNewSession: true,
            intentId: "LaunchRequest",
            platform: "stentor-platform",
            channel: "widget",
            accessToken: accessToken,
            attributes: attributes
        };
    }
    else {
        // Pending permission request?
        var permissionRequest = (_c = message.msg) === null || _c === void 0 ? void 0 : _c.permissionRequest;
        if (permissionRequest) {
            message = __assign$1(__assign$1({}, message), { msg: __assign$1(__assign$1({}, message.msg), { permissionRequest: undefined }) });
            var expired = now - permissionRequest.time > PERMISSION_QUESTION_EXPIRATION_MS;
            var text = (_d = message.msg.text) === null || _d === void 0 ? void 0 : _d.toLowerCase();
            var granted = !expired;
            var userProfile = { id: userId };
            if (!expired) {
                if (permissionRequest.type === "EMAIL") {
                    var isEmail = looksLikeEmail(text);
                    granted = isEmail;
                    userProfile.email = visitorInfo.email;
                    userProfile.name = visitorInfo.displayName;
                    this.visitorInfo.email = text;
                }
                if (permissionRequest.type === "LOCATION_PRECISE") {
                    granted = !!message.msg.location;
                    userProfile.preciseLocation = message.msg.location ? {
                        coordinates: {
                            latitude: message.msg.location.latitude,
                            longitude: message.msg.location.longitude
                        }
                    } : undefined;
                }
            }
            request = {
                type: "PERMISSION_GRANT",
                rawQuery: message.msg.text,
                sessionId: sessionId,
                userId: userId,
                isNewSession: false,
                granted: granted,
                userProfile: userProfile,
                intentId: "PermissionGrant",
                platform: "stentor-platform",
                channel: "widget",
                accessToken: accessToken,
                attributes: attributes,
            };
        }
        else if (message.type === "custom") {
            request = __assign$1(__assign$1({}, JSON.parse(message.payload)), { 
                // token: message.msg.token,
                sessionId: sessionId, userId: userId, isNewSession: false, 
                // intentId: "OptionSelect",
                platform: "stentor-platform", channel: "widget", accessToken: accessToken, attributes: attributes });
        }
        else if (message.msg.token) {
            request = {
                type: "OPTION_SELECT_REQUEST",
                token: message.msg.token,
                sessionId: sessionId,
                userId: userId,
                isNewSession: false,
                intentId: "OptionSelect",
                platform: "stentor-platform",
                channel: "widget",
                accessToken: accessToken,
                attributes: attributes,
            };
        }
        else {
            request = {
                type: "INTENT_REQUEST",
                rawQuery: message.msg.text,
                sessionId: sessionId,
                userId: userId,
                isNewSession: false,
                intentId: "NLU_RESULT_PLACEHOLDER",
                platform: "stentor-platform",
                channel: "widget",
                accessToken: accessToken,
                attributes: attributes,
            };
        }
    }
    if ((_e = message.msg) === null || _e === void 0 ? void 0 : _e.attributes) {
        request.attributes = __assign$1(__assign$1({}, request.attributes), message.msg.attributes);
    }
    return request;
}
function looksLikeEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

/**
 * Converts a Stentor Request (from a widget) to a ChatMessageRequest
 *
 * it's text only - need to look into file exchange (this is widget-to-widget communication)
 *
 * @param botRequest
 * @param now
 * @returns
 */
function requestToMessage(botRequest, now) {
    if (now === void 0) { now = new Date().getTime(); }
    if (!botRequest) {
        return undefined;
    }
    var text = botRequest.rawQuery;
    var responseMessage = {
        type: "msg",
        timestamp: now,
        msg: {
            text: text,
        },
        endSession: false,
        user: undefined,
    };
    return responseMessage;
}

var ROUTER_USER = "router";
var serverInfo = {
    deviceId: "Router",
    userId: ROUTER_USER,
    displayName: "XAPP Server"};
var StentorRouterChat = /** @class */ (function () {
    function StentorRouterChat(config, options) {
        var _a, _b, _c, _d, _e;
        this.isDisposed = false;
        this._userId = "";
        this._sessionId = "";
        this.accessToken = "";
        this.attributes = {};
        this.routerAttributes = {};
        this.isAdmin = false;
        this.urlAttributes = {};
        this.handlers = {};
        // Sleep delay management
        // Use number | NodeJS.Timeout for cross-environment compatibility (browser vs Node.js)
        this.sleepTimeoutId = null;
        // Message deduplication
        this.receivedMessageIds = new Set();
        this.MESSAGE_DEDUP_CACHE_SIZE = 1000;
        this.config = config;
        this.options = options;
        // Dig out the path parameters. Put them into the attributes.
        // The WS url is the barebone domain.
        var url = new URL(this.config.url);
        this.appId = url.searchParams.get("appId");
        var locationUrl = new URL(window.location.href);
        this.isAdmin = locationUrl.searchParams.get("isAdmin") === "true";
        if (this.appId) {
            // New Path if we have the appId on the query string
            this.serverUrl = this.config.url;
            this.urlAttributes.path = (_a = url.pathname) === null || _a === void 0 ? void 0 : _a.split("/");
            // keep the server url
        }
        else {
            // Old path
            this.serverUrl = "".concat(url.origin);
            var urlPath = (_b = url.pathname) === null || _b === void 0 ? void 0 : _b.split("/");
            if (urlPath && urlPath.length > 1) {
                this.serverUrl = "".concat(this.serverUrl, "/").concat(urlPath[1]);
                this.urlAttributes.path = urlPath.slice(1);
            }
        }
        log$3("WS url: ".concat(this.serverUrl, " isAdmin: ").concat(this.isAdmin, " attributes: ").concat(JSON.stringify(this.attributes), " appId: ").concat(this.appId));
        this.configurableMessages = getConfigurableMessagesConfig(options.configurableMessages);
        this.noOfServerErrors = 0;
        // Initialize sleep delay (default 60 seconds for websocketraw)
        this.SLEEP_DELAY_MS = (_e = (_d = (_c = options === null || options === void 0 ? void 0 : options.env) === null || _c === void 0 ? void 0 : _c.connection) === null || _d === void 0 ? void 0 : _d.backgroundSleepDelay) !== null && _e !== void 0 ? _e : 60000;
        log$3("Background sleep delay set to ".concat(this.SLEEP_DELAY_MS, "ms"));
    }
    StentorRouterChat.prototype.init = function (dispatch) {
        var _this = this;
        var _a, _b;
        this.dispatch = dispatch;
        log$3("INIT called - setting initial accountStatus to OFFLINE");
        this.setAccountStatus("offline");
        // Register "handlers" for the incoming events
        this.handlers["connection update"] = function (data, _sender, _ts, _attributes) {
            log$3("Connection update received. Session created: ".concat(data.sessionCreated, " Error: ").concat(data.errorMessage || ""));
            if (data.sessionCreated) {
                _this.sessionCreated = true;
                // This is overkill. But if we are stuck in pending this can help.
                _this.setConnectionStatus("online");
            }
            else {
                // Shut down
                err("SERVER: something is wrong. Going offline.");
                _this.dispatch(setAccountStatus("offline"));
                _this.dispatch(setConnectionStatus("offline"));
            }
        };
        // Server ping (not sent periodically - at least not for now)
        this.handlers["account status"] = function (_data, _sender, ts, _attributes) {
            dispatch({
                type: "account_status",
                detail: {
                    status: "online",
                    timestamp: ts || new Date().getTime(),
                },
            });
        };
        this.handlers["failure"] = function (data, sender, _ts, _attributes) {
            err("SERVER: something's failed: type: ".concat(data.type, " tries: ").concat(data.tries, " error: ").concat(data.error));
            var _a = _this.configurableMessages[data.tries], retry = _a.retry, delay = _a.delay, text = _a.text;
            _this.sendFailureMessage(retry, data.delay || delay, text, sender);
        };
        this.handlers["new message"] = function (data, sender, ts, attributes, messageId) {
            // Because the router's internal message format is Stentor channel compatible.
            // So the data is either a stentor Request (from widget) or a stentor Response (from bot)
            var _a;
            // Deduplicate messages if messageId is provided
            if (messageId) {
                // Validate messageId to prevent memory exhaustion attacks
                if (messageId.length > 256) {
                    log$3("Rejecting message with oversized messageId (".concat(messageId.length, " chars)"));
                    return;
                }
                if (_this.receivedMessageIds.has(messageId)) {
                    log$3("Deduplicating message with id: ".concat(messageId));
                    return;
                }
                _this.receivedMessageIds.add(messageId);
                // Limit the size of the set to prevent memory issues
                // Batch eviction: remove ~10% of entries when limit exceeded
                // Note: Set maintains insertion order per ES2015 spec. Iteration yields
                // values in insertion order, so we evict the earliest-added entries.
                // After deletions, remaining entries maintain their relative order.
                if (_this.receivedMessageIds.size > _this.MESSAGE_DEDUP_CACHE_SIZE) {
                    var idsToRemove = Math.floor(_this.MESSAGE_DEDUP_CACHE_SIZE * 0.1);
                    var iterator = _this.receivedMessageIds.values();
                    for (var i = 0; i < idsToRemove; i++) {
                        var oldest = iterator.next().value;
                        if (oldest) {
                            _this.receivedMessageIds.delete(oldest);
                        }
                    }
                }
            }
            var message;
            if (sender.deviceId === "Bot") {
                var response = data;
                // Extract router-managed attributes from message root (adjacent to event, data, sender, etc.)
                if (attributes && typeof attributes === "object" && Object.keys(attributes).length > 0) {
                    _this.routerAttributes = __assign$1({}, attributes);
                    log$3("Extracted router attributes: ".concat(JSON.stringify(_this.routerAttributes)));
                }
                if (typeof ((_a = _this.options.hooks) === null || _a === void 0 ? void 0 : _a.onResponse) === "function") {
                    _this.options.hooks.onResponse(response);
                }
                // Session is initialized after first bot response (same as StentorDirectChat)
                if (_this.isNewSession) {
                    _this.isNewSession = false;
                    log$3("Session initialized after receiving first bot response");
                }
                message = responseToMessage(response);
            }
            else if (sender.deviceId === "Widget") {
                message = requestToMessage(data);
            }
            else {
                err("Unknown sender device Id: ".concat(sender.deviceId));
            }
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.msg",
                    user: {
                        displayName: sender.displayName || sender.email || sender.userId,
                        nick: senderToNick(sender),
                        avatarPath: sender.avatarPath
                    },
                    msg: message.msg,
                    timestamp: ts || new Date().getTime(),
                },
            });
        };
        this.handlers["user joined"] = function (data, sender, ts, _attributes) {
            var _a, _b;
            var nick = senderToNick(sender);
            log$3("Received \"user joined\" event - deviceId: ".concat(sender.deviceId, ", userId: ").concat(sender.userId, ", displayName: ").concat(sender.displayName, ", nick: ").concat(nick));
            log$3("Dispatching chat.memberjoin for ".concat(sender.displayName || "Unknown"));
            var userData = data;
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.memberjoin",
                    user: {
                        avatarPath: sender.avatarPath || ((_b = (_a = _this.options) === null || _a === void 0 ? void 0 : _a.bot) === null || _b === void 0 ? void 0 : _b.avatarPath),
                        displayName: sender.displayName,
                        nick: nick,
                    },
                    timestamp: ts || new Date().getTime(),
                    showDivider: userData === null || userData === void 0 ? void 0 : userData.showDivider,
                    message: userData === null || userData === void 0 ? void 0 : userData.message,
                    hideUserInfo: userData === null || userData === void 0 ? void 0 : userData.hideUserInfo,
                },
            });
            log$3("chat.memberjoin dispatched for nick: ".concat(nick));
        };
        this.handlers["user left"] = function (data, sender, ts, _attributes) {
            var userData = data;
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.memberleave",
                    user: {
                        avatarPath: sender.avatarPath,
                        displayName: sender.displayName,
                        nick: senderToNick(sender),
                    },
                    timestamp: ts || new Date().getTime(),
                    showDivider: userData === null || userData === void 0 ? void 0 : userData.showDivider,
                    message: userData === null || userData === void 0 ? void 0 : userData.message,
                },
            });
        };
        this.handlers["typing"] = function (_data, sender, ts, _attributes) {
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.typing",
                    user: {
                        nick: senderToNick(sender),
                    },
                    typing: true,
                    timestamp: ts || new Date().getTime(),
                },
            });
        };
        this.handlers["stop typing"] = function (_data, sender, ts, _attributes) {
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.typing",
                    user: {
                        nick: senderToNick(sender),
                    },
                    typing: false,
                    timestamp: ts || new Date().getTime(),
                },
            });
        };
        this.handlers["disconnect"] = function () {
            log$3("DISCONNECT event received from server");
            err("SERVER: requested disconnect");
            _this.dispatch(setAccountStatus("offline"));
            _this.dispatch(setConnectionStatus("offline"));
        };
        this.handlers["reconnect"] = function () {
            _this.dispatch(setAccountStatus("online"));
            _this.dispatch(setConnectionStatus("online"));
        };
        this.handlers["reconnect failed"] = function (_data) {
            err("SERVER: says re-connect failed");
            _this.dispatch(setAccountStatus("offline"));
            _this.dispatch(setConnectionStatus("offline"));
        };
        this.handlers["reconnect error"] = function (_data) {
            err("SERVER: says there was an error while re-connecting");
            _this.dispatch(setAccountStatus("offline"));
        };
        this.handlers["display button"] = function (data, _sender, _ts, _attributes) {
            log$3("Received \"display button\" event - id: ".concat(data.id, ", text: ").concat(data.text, ", pressBehavior: ").concat(data.pressBehavior));
            _this.dispatch(displayWsButton({
                id: data.id,
                text: data.text,
                pressBehavior: data.pressBehavior || "none"
            }));
        };
        this.handlers["dismiss button"] = function (data, _sender, _ts, _attributes) {
            log$3("Received \"dismiss button\" event - id: ".concat(data.id));
            // First, mark button as dismissing to trigger animation
            _this.dispatch(displayWsButton({
                id: data.id,
                text: '',
                pressBehavior: 'none',
                isDismissing: true
            }));
            // Then actually dismiss after animation completes
            setTimeout(function () {
                _this.dispatch(dismissWsButton(data.id));
            }, WS_BUTTON_DISMISS_ANIMATION_DURATION);
        };
        this.handlers["system-message"] = function (data, sender, ts, _attributes) {
            log$3("Received \"system-message\" event - id: ".concat(data.id, ", message: ").concat(data.message, ", dismissId: ").concat(data.dismissId));
            // If there's a dismissId, dispatch dismiss action first
            if (data.dismissId) {
                _this.dispatch({
                    type: "chat",
                    detail: {
                        type: "chat.systemmessagedismiss",
                        user: {
                            displayName: sender.displayName || "System",
                            nick: senderToNick(sender),
                        },
                        id: data.dismissId,
                        timestamp: ts || new Date().getTime(),
                    },
                });
            }
            // Then dispatch the new system message
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.systemmessage",
                    user: {
                        displayName: sender.displayName || "System",
                        nick: senderToNick(sender),
                    },
                    id: data.id,
                    message: data.message,
                    dismissId: data.dismissId,
                    timestamp: ts || new Date().getTime(),
                },
            });
        };
        this.handlers["system-message-dismiss"] = function (data, sender, ts, _attributes) {
            log$3("Received \"system-message-dismiss\" event - id: ".concat(data.id));
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.systemmessagedismiss",
                    user: {
                        displayName: sender.displayName || "System",
                        nick: senderToNick(sender),
                    },
                    id: data.id,
                    timestamp: ts || new Date().getTime(),
                },
            });
        };
        this.handlers["missed messages"] = function (data, _sender, _ts, _attributes) {
            var _a;
            var missedData = data;
            log$3("Received \"missed messages\" event with ".concat(((_a = missedData === null || missedData === void 0 ? void 0 : missedData.messages) === null || _a === void 0 ? void 0 : _a.length) || 0, " messages"));
            // Process each missed message
            if ((missedData === null || missedData === void 0 ? void 0 : missedData.messages) && Array.isArray(missedData.messages)) {
                missedData.messages.forEach(function (missedMessage) {
                    log$3("Processing missed message: event=".concat(missedMessage.event, ", messageId=").concat(missedMessage.messageId));
                    // Route the missed message to the appropriate handler
                    var handler = _this.handlers[missedMessage.event];
                    if (handler && missedMessage.event !== "missed messages") {
                        handler(missedMessage.data, missedMessage.sender, missedMessage.timeMs, missedMessage.attributes, missedMessage.messageId);
                    }
                    else {
                        log$3("No handler for missed message event: ".concat(missedMessage.event));
                    }
                });
            }
        };
        this.handlers["request missed messages"] = function () {
            // This is a client→server event, so no handler needed on client side
            log$3("Request missed messages handler (no-op on client side)");
        };
        // No-op handlers for user activity events (client→server only)
        // These prevent error logs if the server echoes these events back
        this.handlers["user backgrounded"] = function () {
            log$3("User backgrounded handler (no-op on client side)");
        };
        this.handlers["user foregrounded"] = function () {
            log$3("User foregrounded handler (no-op on client side)");
        };
        this.handlers["user disconnecting"] = function () {
            log$3("User disconnecting handler (no-op on client side)");
        };
        // Register the router as a pseudo-agent (serverInfo) so it can send messages (like internal errors)
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.memberjoin",
                user: {
                    avatarPath: (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.bot) === null || _b === void 0 ? void 0 : _b.avatarPath,
                    displayName: serverInfo.displayName,
                    nick: senderToNick(serverInfo),
                },
                timestamp: new Date().getTime(),
            },
        });
        // pretend we are online. The emit() will connect
        this.setAccountStatus("online");
        this.setConnectionStatus("online");
    };
    StentorRouterChat.prototype.autoReconnect = function (wsCreate) {
        var _this = this;
        if (this.noOfServerErrors === 0) {
            this.setConnectionStatus("pending");
        }
        var setActStatus = this.setAccountStatus.bind(this);
        var setConnStatus = this.setConnectionStatus.bind(this);
        function startReconnecting() {
            var interval = setInterval(function () {
                var ws = wsCreate();
                if (!ws) {
                    clearInterval(interval);
                    return;
                }
                log$3("Re-created WS connection");
                ws.onopen = function () {
                    log$3("Re-opened WS connection");
                    // We are connected
                    setActStatus("online");
                    setConnStatus("online");
                    ws.onclose = function () {
                        log$3("WebSocket ONCLOSE event - connection closed unexpectedly");
                        log$3("Closed WS connection (onclosed was called)");
                        startReconnecting();
                    };
                    clearInterval(interval);
                };
            }, 5000);
        }
        log$3("Creating WS connection");
        var ws = wsCreate();
        if (!ws) {
            return;
        }
        ws.onclose = function () {
            log$3("WebSocket ONCLOSE event (initial) - connection closed");
            log$3("Closed WS connection (onclosed was called)");
            startReconnecting();
        };
        this.ws.onopen = function () {
            log$3("WebSocket ONOPEN event - connection established");
            log$3("Opened WS connection (onopen was called)");
            // We are connected
            _this.setAccountStatus("online");
            _this.setConnectionStatus("online");
        };
    };
    StentorRouterChat.prototype.wsClose = function () {
        if (this.ws) {
            log$3("wsClose() - Closing WebSocket (readyState: ".concat(this.ws.readyState, ")"));
            this.ws.onclose = null;
            this.ws.onerror = null;
            this.ws.onopen = null;
            this.ws.onmessage = null;
            this.ws.close();
        }
    };
    StentorRouterChat.prototype.wsCreate = function (createWsReason) {
        var _this = this;
        if (this.isDisposed) {
            log$3("Stopping reconnect for disposed router connector");
            return undefined;
        }
        else {
            log$3("Trying to re-connect. Reason: \"".concat(createWsReason, "\""));
        }
        var url = new URL(this.serverUrl);
        url.searchParams.set("userId", this._userId);
        url.searchParams.set("isAdmin", "".concat(this.isAdmin));
        url.searchParams.set("createWsReason", createWsReason); // tell the server the reconnect reason
        // Force close - just in case - when you create new
        if (this.ws && !(this.ws.readyState === WebSocket.CLOSED || this.ws.readyState === WebSocket.CLOSING)) {
            var wsState = this.ws.readyState;
            log$3("Forced WS close. State: ".concat(wsState));
            try {
                this.wsClose();
            }
            catch (err) {
                err("Failed to close WS (ready state: ".concat(wsState, "): ").concat(err));
            }
        }
        this.ws = new WebSocket(url.toString());
        this.ws.onerror = function (ev) {
            var _a;
            err("Error in WS connection. Url: ".concat(url.toString(), " Type: ").concat(!ev ? "?" : ev.type, " Ready State: ").concat((_a = _this.ws) === null || _a === void 0 ? void 0 : _a.readyState));
        };
        this.ws.onmessage = function (me) {
            log$3("ROUTER says: ".concat(me.data));
            var message = JSON.parse(me.data);
            var handler = _this.handlers[message.event];
            if (handler) {
                _this.handlers[message.event](message.data, message.sender, message.timeMs, message.attributes, message.messageId);
            }
            else {
                err("Unknown router message event: ".concat(message.event));
            }
        };
        return this.ws;
    };
    StentorRouterChat.prototype.checkConnection = function () {
        var _a;
        return ((_a = this.ws) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN;
    };
    StentorRouterChat.prototype.emit = function (event, data) {
        return __awaiter$1(this, void 0, void 0, function () {
            var payload, payloadData;
            var _this = this;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            event: event,
                            data: data,
                            sender: this.visitorInfo,
                            sessionId: this._sessionId,
                            timeMs: new Date().getTime()
                        };
                        // Add router-managed attributes at payload root level if available
                        if (this.routerAttributes && Object.keys(this.routerAttributes).length > 0) {
                            payload.attributes = this.routerAttributes;
                            log$3("Adding router attributes to outgoing payload: ".concat(JSON.stringify(this.routerAttributes)));
                        }
                        payloadData = JSON.stringify(payload);
                        log$3("Widget says: ".concat(payloadData));
                        if (!this.ws) {
                            // Fire up the WebSocket
                            this.autoReconnect(this.wsCreate.bind(this, "emitNoWs"));
                        }
                        return [4 /*yield*/, waitFor(this.checkConnection.bind(this), 1000, 10000, "connection")
                                .then(function (t) {
                                if (t > 0) {
                                    log$3("Connection is ready in ".concat(t, " ms"));
                                }
                                _this.ws.send(payloadData);
                                _this.noOfServerErrors = 0;
                            })
                                .catch(function (t) {
                                err("Connection wait timed out in ".concat(t, " ms (show error)"));
                                _this.setConnectionStatus("online");
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StentorRouterChat.prototype.setAccountStatus = function (status) {
        log$3("setAccountStatus: ".concat(status));
        log$3("SERVER account_status: ".concat(JSON.stringify(status)));
        this.dispatch(setAccountStatus(status));
    };
    StentorRouterChat.prototype.setConnectionStatus = function (status) {
        log$3("setConnectionStatus: ".concat(status));
        log$3("SERVER: connection_update: ".concat(JSON.stringify(status)));
        this.dispatch(setConnectionStatus(status));
    };
    StentorRouterChat.prototype.sendOfflineMsg = function (_, cb) {
        cb();
    };
    StentorRouterChat.prototype.sendChatMsg = function (message, cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, this.sendChatMsgRequest({
                        msg: message,
                        timestamp: new Date().getTime(),
                        agent: false,
                        user: undefined,
                        type: "msg",
                    }, cb)];
            });
        });
    };
    StentorRouterChat.prototype.sendFailureMessage = function (retry, delay, text, sender) {
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.typing",
                user: {
                    nick: senderToNick(sender),
                },
                typing: false,
                timestamp: +new Date(),
            },
        });
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.failureMsg",
                user: {
                    nick: senderToNick(sender)
                },
                failureMsg: { retry: retry, delay: delay, text: text },
                timestamp: +new Date()
            }
        });
    };
    StentorRouterChat.prototype.sendDisconnectMessage = function () {
        this.dispatch({
            type: "chat",
            detail: {
                type: "chat.msg",
                user: {
                    displayName: "Server",
                    nick: senderToNick(serverInfo),
                    avatarPath: serverInfo.avatarPath
                },
                msg: {
                    text: this.noOfServerErrors === 0 ?
                        "I cannot connect to the server. Please try later." :
                        "Nope. Still no luck. I still cannot connect to the server. Please don't give up."
                },
                timestamp: new Date().getTime(),
            }
        });
        this.noOfServerErrors++;
    };
    StentorRouterChat.prototype.checkSession = function () {
        return this.sessionCreated;
    };
    StentorRouterChat.prototype.sendChatMsgRequest = function (serviceRequest, cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            var _this = this;
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // This is rare, but is happened: no visitor info exchange, but the connection is back.
                        // if (this.checkConnection() && !this.checkSession()) {
                        //     await this.postVisitorInfo();
                        // }
                        if (!this.checkSession()) {
                            this.setConnectionStatus("pending");
                        }
                        return [4 /*yield*/, waitFor(this.checkSession.bind(this), 1000, 10000, "session creation")
                                .then(function (t) {
                                if (t > 0) {
                                    log$3("Session creation is ready in ".concat(t, " ms"));
                                }
                                _this.postMessage(serviceRequest);
                            })
                                .catch(function (t) {
                                err("Session creation wait timed out in ".concat(t, " ms"));
                                _this.setConnectionStatus("online"); // stop pulsing
                                _this.sendDisconnectMessage();
                            })];
                    case 1:
                        _a.sent();
                        this.setConnectionStatus("online");
                        cb();
                        return [2 /*return*/];
                }
            });
        });
    };
    StentorRouterChat.prototype.sendTyping = function (_isTyping) {
        // TODO: Is this too much traffic?
        // this.emit(isTyping ? "typing" : "stop typing");
    };
    StentorRouterChat.prototype.setVisitorInfo = function (visitorInfoMessage, sessionId, cb) {
        log$3("Visitor Info Message = ".concat(JSON.stringify(visitorInfoMessage)));
        this.visitorInfo = {
            deviceId: "Widget",
            userId: visitorInfoMessage.userId,
            displayName: visitorInfoMessage.displayName || visitorInfoMessage.name,
            email: visitorInfoMessage.email,
            isAdmin: this.isAdmin,
            urlAttributes: this.urlAttributes,
        };
        this.attributes = __assign$1(__assign$1(__assign$1({}, visitorInfoMessage.attributes), this.attributes), { currentUrl: window.location.href });
        this.accessToken = visitorInfoMessage.accessToken;
        this.startSession(sessionId);
        this.postVisitorInfo(); // we, the widget, joined the server
        cb();
    };
    StentorRouterChat.prototype.sendChatRating = function () { };
    StentorRouterChat.prototype.sendFile = function (_, cb) {
        cb();
    };
    StentorRouterChat.prototype.markAsRead = function () {
        // mark the messages read
    };
    StentorRouterChat.prototype.flush = function () { };
    StentorRouterChat.prototype.dispose = function () {
        log$3("DISPOSE called - cleaning up connection");
        this.isDisposed = true;
        // Clear any pending sleep timeout
        if (this.sleepTimeoutId) {
            clearTimeout(this.sleepTimeoutId);
            this.sleepTimeoutId = null;
        }
        if (this.ws) {
            this.wsClose();
        }
        log$3("Closed web socket (dispose)");
    };
    StentorRouterChat.prototype.sleep = function () {
        var _this = this;
        log$3("SLEEP called - scheduling delayed close");
        // Notify router that user has backgrounded the tab
        if (this.checkConnection()) {
            log$3("SLEEP - Notifying router of user backgrounded");
            this.emit("user backgrounded");
        }
        // Cancel any pending sleep timeout
        if (this.sleepTimeoutId) {
            clearTimeout(this.sleepTimeoutId);
            this.sleepTimeoutId = null;
        }
        // Schedule WebSocket close after delay
        // Note: Don't set isDisposed here - only in dispose(). Setting it here would
        // prevent reconnection when the user returns to the tab after the timeout.
        this.sleepTimeoutId = window.setTimeout(function () {
            if (_this.ws) {
                _this.wsClose();
            }
            log$3("SLEEP - closed web socket after ".concat(_this.SLEEP_DELAY_MS, "ms delay"));
            _this.sleepTimeoutId = null;
        }, this.SLEEP_DELAY_MS);
        log$3("SLEEP - WebSocket will close in ".concat(this.SLEEP_DELAY_MS, "ms if not woken up"));
    };
    StentorRouterChat.prototype.wakeup = function () {
        var _this = this;
        log$3("WAKEUP called - userId:", this._userId);
        // Cancel pending sleep if user returned before timeout
        if (this.sleepTimeoutId) {
            clearTimeout(this.sleepTimeoutId);
            this.sleepTimeoutId = null;
            log$3("WAKEUP - Cancelled pending sleep, keeping WebSocket open");
            // Notify router that user has foregrounded the tab (connection still open)
            if (this.checkConnection()) {
                log$3("WAKEUP - Notifying router of user foregrounded");
                this.emit("user foregrounded");
            }
            return; // WebSocket is still open, no need to reconnect
        }
        this.isDisposed = false;
        // wait for the session setup
        if (!this._userId) {
            log$3("WAKEUP - No userId, returning early");
            return;
        }
        // Set both statuses immediately to show we're reconnecting
        log$3("WAKEUP - Setting accountStatus and connectionStatus to ONLINE");
        this.setAccountStatus("online");
        this.setConnectionStatus("online");
        log$3("Waking up - setting status to online");
        // Fire up the WebSocket
        log$3("WAKEUP - Calling autoReconnect");
        this.autoReconnect(this.wsCreate.bind(this, "wakeup"));
        // Request any missed messages and notify router after reconnection is established
        // Use waitFor to poll for connection readiness with timeout
        waitFor(this.checkConnection.bind(this), 100, 5000, "wakeup-connection")
            .then(function () {
            // Notify router that user has foregrounded the tab (after reconnect)
            log$3("WAKEUP - Notifying router of user foregrounded (after reconnect)");
            _this.emit("user foregrounded");
            _this.requestMissedMessages();
        })
            .catch(function () {
            log$3("WAKEUP - Connection not ready after 5s, skipping missed messages request");
        });
    };
    StentorRouterChat.prototype.requestMissedMessages = function () {
        log$3("Requesting missed messages from server");
        this.emit("request missed messages");
    };
    /**
     * Notifies the router that the user is disconnecting (e.g., closing tab, navigating away).
     * This is a best-effort notification - it may not arrive before the page unloads.
     * Should be called from a beforeunload event handler.
     */
    StentorRouterChat.prototype.notifyDisconnecting = function () {
        if (!this.checkConnection()) {
            return;
        }
        log$3("Notifying router of user disconnecting");
        var payload = JSON.stringify({
            event: "user disconnecting",
            data: { reason: "tab_close" },
            sender: this.visitorInfo,
            sessionId: this._sessionId,
            timeMs: Date.now()
        });
        try {
            this.ws.send(payload);
        }
        catch (e) {
            // Best-effort - page is unloading, so we can't do much if send fails
            log$3("Failed to send disconnect notification:", e);
        }
    };
    StentorRouterChat.prototype.bargeOut = function (_cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                this.emit("barge out");
                return [2 /*return*/];
            });
        });
    };
    StentorRouterChat.prototype.bargeIn = function (agentName, _cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                this.visitorInfo.displayName = agentName;
                this.emit("barge in");
                return [2 /*return*/];
            });
        });
    };
    StentorRouterChat.prototype.sendButtonPressed = function (buttonId) {
        return __awaiter$1(this, void 0, void 0, function () {
            var data;
            return __generator$1(this, function (_a) {
                log$3("Sending \"button pressed\" event - id: ".concat(buttonId));
                data = { id: buttonId };
                this.emit("button pressed", data);
                return [2 /*return*/];
            });
        });
    };
    StentorRouterChat.prototype.postVisitorInfo = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                this.sessionCreated = false;
                this.emit("user joined");
                return [2 /*return*/];
            });
        });
    };
    StentorRouterChat.prototype.postMessage = function (message) {
        return __awaiter$1(this, void 0, void 0, function () {
            var userId, sessionId, accessToken, attributes, rwgToken, merchantId, environment, enablePreferredTime, service, origin, request;
            return __generator$1(this, function (_a) {
                userId = this._userId;
                sessionId = this._sessionId;
                accessToken = this.accessToken;
                attributes = this.attributes || {};
                rwgToken = localStorage.getItem("xa_rwg_token");
                if (rwgToken) {
                    attributes["rwg_token"] = rwgToken;
                }
                merchantId = localStorage.getItem("xa_merchant_id");
                if (merchantId) {
                    attributes["merchant_id"] = merchantId;
                }
                environment = localStorage.getItem("xa_environment");
                if (environment) {
                    attributes["environment"] = environment;
                }
                enablePreferredTime = localStorage.getItem("xa_enablePreferredTime");
                if (enablePreferredTime) {
                    attributes["enablePreferredTime"] = enablePreferredTime;
                }
                service = localStorage.getItem("xa_service");
                if (service) {
                    attributes["service"] = service;
                }
                origin = localStorage.getItem("xa_origin");
                if (origin) {
                    attributes["origin"] = origin;
                }
                // Add current time for accurate date/time responses
                attributes["currentTime"] = new Date().toISOString();
                request = requestFromMessage(message, userId, this.isNewSession, sessionId, accessToken, attributes, this.visitorInfo);
                // Router attributes are now added at the payload root level in emit()
                this.emit("new message", request);
                return [2 /*return*/];
            });
        });
    };
    StentorRouterChat.prototype.startSession = function (sessionId) {
        if (this.visitorInfo.userId) {
            this._userId = "".concat(this.visitorInfo.userId);
        }
        else if (this.visitorInfo.email) {
            this._userId = "stentor-widget-user-".concat(this.visitorInfo.email);
        }
        else {
            this._userId = "stentor-widget-user-".concat(uuid_1());
        }
        var joinSessionId = new URL(window.location.href).searchParams.get("sessionId");
        if (joinSessionId) {
            this._sessionId = joinSessionId;
            this.dispatch(setSessionId(this._sessionId));
            log$3("Using enforced session id: ".concat(this._sessionId));
        }
        else if (sessionId) {
            this._sessionId = sessionId;
            log$3("Using persisted session id: ".concat(this._sessionId));
        }
        else {
            this._sessionId = "stentor-widget-session-".concat(uuid_1());
            this.dispatch(setSessionId(this._sessionId));
            log$3("Using generated session id: ".concat(this._sessionId));
        }
        // Always. This triggers a LAUNCH_REQUEST most of the time
        this.isNewSession = true;
        log$3("Started session: ".concat(this._sessionId));
    };
    return StentorRouterChat;
}());
function senderToNick(sender) {
    // Both are agents
    return sender.deviceId === "Bot" ?
        "agent:bot:".concat(sender.userId) : "agent:widget:".concat(sender.userId);
}
/**
 *
 * @param check Function that return true/false if the resource is available
 * @param stepMs check period in ms
 * @param timeoutMs max wait in ms
 * @param resource optional resource name. you will see a log message for every check (step)
 *
 * @returns the elapsed time in ms (both resolve/reject)
 */
function waitFor(check, stepMs, timeoutMs, resource) {
    var elapsedMs = 0;
    var poll = function (resolve, reject) {
        if (elapsedMs >= timeoutMs) {
            reject(elapsedMs);
        }
        else {
            if (check()) {
                resolve(elapsedMs);
            }
            else {
                elapsedMs += stepMs;
                if (resource) {
                    log$3("Still waiting for ".concat(resource, " (").concat(elapsedMs, " ms)"));
                }
                setTimeout(function (_) { return poll(resolve, reject); }, stepMs);
            }
        }
    };
    return new Promise(poll);
}

const PACKET_TYPES = Object.create(null); // no Map = no polyfill
PACKET_TYPES["open"] = "0";
PACKET_TYPES["close"] = "1";
PACKET_TYPES["ping"] = "2";
PACKET_TYPES["pong"] = "3";
PACKET_TYPES["message"] = "4";
PACKET_TYPES["upgrade"] = "5";
PACKET_TYPES["noop"] = "6";
const PACKET_TYPES_REVERSE = Object.create(null);
Object.keys(PACKET_TYPES).forEach((key) => {
    PACKET_TYPES_REVERSE[PACKET_TYPES[key]] = key;
});
const ERROR_PACKET = { type: "error", data: "parser error" };

const withNativeBlob$1 = typeof Blob === "function" ||
    (typeof Blob !== "undefined" &&
        Object.prototype.toString.call(Blob) === "[object BlobConstructor]");
const withNativeArrayBuffer$2 = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const isView$1 = (obj) => {
    return typeof ArrayBuffer.isView === "function"
        ? ArrayBuffer.isView(obj)
        : obj && obj.buffer instanceof ArrayBuffer;
};
const encodePacket = ({ type, data }, supportsBinary, callback) => {
    if (withNativeBlob$1 && data instanceof Blob) {
        if (supportsBinary) {
            return callback(data);
        }
        else {
            return encodeBlobAsBase64(data, callback);
        }
    }
    else if (withNativeArrayBuffer$2 &&
        (data instanceof ArrayBuffer || isView$1(data))) {
        if (supportsBinary) {
            return callback(data);
        }
        else {
            return encodeBlobAsBase64(new Blob([data]), callback);
        }
    }
    // plain string
    return callback(PACKET_TYPES[type] + (data || ""));
};
const encodeBlobAsBase64 = (data, callback) => {
    const fileReader = new FileReader();
    fileReader.onload = function () {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function toArray$1(data) {
    if (data instanceof Uint8Array) {
        return data;
    }
    else if (data instanceof ArrayBuffer) {
        return new Uint8Array(data);
    }
    else {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
    }
}
let TEXT_ENCODER;
function encodePacketToBinary(packet, callback) {
    if (withNativeBlob$1 && packet.data instanceof Blob) {
        return packet.data.arrayBuffer().then(toArray$1).then(callback);
    }
    else if (withNativeArrayBuffer$2 &&
        (packet.data instanceof ArrayBuffer || isView$1(packet.data))) {
        return callback(toArray$1(packet.data));
    }
    encodePacket(packet, false, (encoded) => {
        if (!TEXT_ENCODER) {
            TEXT_ENCODER = new TextEncoder();
        }
        callback(TEXT_ENCODER.encode(encoded));
    });
}

// imported from https://github.com/socketio/base64-arraybuffer
const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (let i = 0; i < chars.length; i++) {
    lookup$1[chars.charCodeAt(i)] = i;
}
const decode$1 = (base64) => {
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') {
            bufferLength--;
        }
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for (i = 0; i < len; i += 4) {
        encoded1 = lookup$1[base64.charCodeAt(i)];
        encoded2 = lookup$1[base64.charCodeAt(i + 1)];
        encoded3 = lookup$1[base64.charCodeAt(i + 2)];
        encoded4 = lookup$1[base64.charCodeAt(i + 3)];
        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }
    return arraybuffer;
};

const withNativeArrayBuffer$1 = typeof ArrayBuffer === "function";
const decodePacket = (encodedPacket, binaryType) => {
    if (typeof encodedPacket !== "string") {
        return {
            type: "message",
            data: mapBinary(encodedPacket, binaryType),
        };
    }
    const type = encodedPacket.charAt(0);
    if (type === "b") {
        return {
            type: "message",
            data: decodeBase64Packet(encodedPacket.substring(1), binaryType),
        };
    }
    const packetType = PACKET_TYPES_REVERSE[type];
    if (!packetType) {
        return ERROR_PACKET;
    }
    return encodedPacket.length > 1
        ? {
            type: PACKET_TYPES_REVERSE[type],
            data: encodedPacket.substring(1),
        }
        : {
            type: PACKET_TYPES_REVERSE[type],
        };
};
const decodeBase64Packet = (data, binaryType) => {
    if (withNativeArrayBuffer$1) {
        const decoded = decode$1(data);
        return mapBinary(decoded, binaryType);
    }
    else {
        return { base64: true, data }; // fallback for old browsers
    }
};
const mapBinary = (data, binaryType) => {
    switch (binaryType) {
        case "blob":
            if (data instanceof Blob) {
                // from WebSocket + binaryType "blob"
                return data;
            }
            else {
                // from HTTP long-polling or WebTransport
                return new Blob([data]);
            }
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) {
                // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
                return data;
            }
            else {
                // from WebTransport (Uint8Array)
                return data.buffer;
            }
    }
};

const SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const encodePayload = (packets, callback) => {
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i) => {
        // force base64 encoding for binary packets
        encodePacket(packet, false, (encodedPacket) => {
            encodedPackets[i] = encodedPacket;
            if (++count === length) {
                callback(encodedPackets.join(SEPARATOR));
            }
        });
    });
};
const decodePayload = (encodedPayload, binaryType) => {
    const encodedPackets = encodedPayload.split(SEPARATOR);
    const packets = [];
    for (let i = 0; i < encodedPackets.length; i++) {
        const decodedPacket = decodePacket(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") {
            break;
        }
    }
    return packets;
};
function createPacketEncoderStream() {
    return new TransformStream({
        transform(packet, controller) {
            encodePacketToBinary(packet, (encodedPacket) => {
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                }
                else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                }
                else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") {
                    header[0] |= 0x80;
                }
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        },
    });
}
let TEXT_DECODER;
function totalLength(chunks) {
    return chunks.reduce((acc, chunk) => acc + chunk.length, 0);
}
function concatChunks(chunks, size) {
    if (chunks[0].length === size) {
        return chunks.shift();
    }
    const buffer = new Uint8Array(size);
    let j = 0;
    for (let i = 0; i < size; i++) {
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) {
        chunks[0] = chunks[0].slice(j);
    }
    return buffer;
}
function createPacketDecoderStream(maxPayload, binaryType) {
    if (!TEXT_DECODER) {
        TEXT_DECODER = new TextDecoder();
    }
    const chunks = [];
    let state = 0 /* State.READ_HEADER */;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform(chunk, controller) {
            chunks.push(chunk);
            while (true) {
                if (state === 0 /* State.READ_HEADER */) {
                    if (totalLength(chunks) < 1) {
                        break;
                    }
                    const header = concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) {
                        state = 3 /* State.READ_PAYLOAD */;
                    }
                    else if (expectedLength === 126) {
                        state = 1 /* State.READ_EXTENDED_LENGTH_16 */;
                    }
                    else {
                        state = 2 /* State.READ_EXTENDED_LENGTH_64 */;
                    }
                }
                else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */) {
                    if (totalLength(chunks) < 2) {
                        break;
                    }
                    const headerArray = concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */;
                }
                else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */) {
                    if (totalLength(chunks) < 8) {
                        break;
                    }
                    const headerArray = concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 53 - 32) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue(ERROR_PACKET);
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */;
                }
                else {
                    if (totalLength(chunks) < expectedLength) {
                        break;
                    }
                    const data = concatChunks(chunks, expectedLength);
                    controller.enqueue(decodePacket(isBinary ? data : TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue(ERROR_PACKET);
                    break;
                }
            }
        },
    });
}
const protocol = 4;

/**
 * Expose `Emitter`.
 */

var Emitter_1 = Emitter;

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

// alias used for reserved events (protected method)
Emitter.prototype.emitReserved = Emitter.prototype.emit;

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};

const nextTick = (() => {
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) {
        return (cb) => Promise.resolve().then(cb);
    }
    else {
        return (cb, setTimeoutFn) => setTimeoutFn(cb, 0);
    }
})();
const globalThisShim = (() => {
    if (typeof self !== "undefined") {
        return self;
    }
    else if (typeof window !== "undefined") {
        return window;
    }
    else {
        return Function("return this")();
    }
})();
const defaultBinaryType = "arraybuffer";
function createCookieJar() { }

function pick(obj, ...attr) {
    return attr.reduce((acc, k) => {
        if (obj.hasOwnProperty(k)) {
            acc[k] = obj[k];
        }
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const NATIVE_SET_TIMEOUT = globalThisShim.setTimeout;
const NATIVE_CLEAR_TIMEOUT = globalThisShim.clearTimeout;
function installTimerFunctions(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(globalThisShim);
        obj.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(globalThisShim);
    }
    else {
        obj.setTimeoutFn = globalThisShim.setTimeout.bind(globalThisShim);
        obj.clearTimeoutFn = globalThisShim.clearTimeout.bind(globalThisShim);
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const BASE64_OVERHEAD = 1.33;
// we could also have used `new Blob([obj]).size`, but it isn't supported in IE9
function byteLength(obj) {
    if (typeof obj === "string") {
        return utf8Length(obj);
    }
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * BASE64_OVERHEAD);
}
function utf8Length(str) {
    let c = 0, length = 0;
    for (let i = 0, l = str.length; i < l; i++) {
        c = str.charCodeAt(i);
        if (c < 0x80) {
            length += 1;
        }
        else if (c < 0x800) {
            length += 2;
        }
        else if (c < 0xd800 || c >= 0xe000) {
            length += 3;
        }
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
/**
 * Generates a random 8-characters string.
 */
function randomString$1() {
    return (Date.now().toString(36).substring(3) +
        Math.random().toString(36).substring(2, 5));
}

// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */
function encode(obj) {
    let str = '';
    for (let i in obj) {
        if (obj.hasOwnProperty(i)) {
            if (str.length)
                str += '&';
            str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
        }
    }
    return str;
}
/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */
function decode(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for (let i = 0, l = pairs.length; i < l; i++) {
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}

class TransportError extends Error {
    constructor(reason, description, context) {
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class Transport extends Emitter_1 {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */
    constructor(opts) {
        super();
        this.writable = false;
        installTimerFunctions(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */
    onError(reason, description, context) {
        super.emitReserved("error", new TransportError(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */
    open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */
    close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */
    send(packets) {
        if (this.readyState === "open") {
            this.write(packets);
        }
    }
    /**
     * Called upon open
     *
     * @protected
     */
    onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */
    onData(data) {
        const packet = decodePacket(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */
    onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */
    onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */
    pause(onPause) { }
    createUri(schema, query = {}) {
        return (schema +
            "://" +
            this._hostname() +
            this._port() +
            this.opts.path +
            this._query(query));
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port &&
            ((this.opts.secure && Number(this.opts.port !== 443)) ||
                (!this.opts.secure && Number(this.opts.port) !== 80))) {
            return ":" + this.opts.port;
        }
        else {
            return "";
        }
    }
    _query(query) {
        const encodedQuery = encode(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}

class Polling extends Transport {
    constructor() {
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */
    doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */
    pause(onPause) {
        this.readyState = "pausing";
        const pause = () => {
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function () {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function () {
                    --total || pause();
                });
            }
        }
        else {
            pause();
        }
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */
    _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */
    onData(data) {
        const callback = (packet) => {
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") {
                this.onOpen();
            }
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({ description: "transport closed by the server" });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        decodePayload(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) {
                this._poll();
            }
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */
    doClose() {
        const close = () => {
            this.write([{ type: "close" }]);
        };
        if ("open" === this.readyState) {
            close();
        }
        else {
            // in case we're trying to close while
            // handshaking is in progress (GH-164)
            this.once("open", close);
        }
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */
    write(packets) {
        this.writable = false;
        encodePayload(packets, (data) => {
            this.doWrite(data, () => {
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */
    uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) {
            query[this.opts.timestampParam] = randomString$1();
        }
        if (!this.supportsBinary && !query.sid) {
            query.b64 = 1;
        }
        return this.createUri(schema, query);
    }
}

// imported from https://github.com/component/has-cors
let value$1 = false;
try {
    value$1 = typeof XMLHttpRequest !== 'undefined' &&
        'withCredentials' in new XMLHttpRequest();
}
catch (err) {
    // if XMLHttp support is disabled in IE then it will throw
    // when trying to create
}
const hasCORS = value$1;

function empty$2() { }
class BaseXHR extends Polling {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */
    constructor(opts) {
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) {
                port = isSSL ? "443" : "80";
            }
            this.xd =
                (typeof location !== "undefined" &&
                    opts.hostname !== location.hostname) ||
                    port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */
    doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data,
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context) => {
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */
    doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context) => {
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class Request extends Emitter_1 {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */
    constructor(createRequest, uri, opts) {
        super();
        this.createRequest = createRequest;
        installTimerFunctions(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */
    _create() {
        var _a;
        const opts = pick(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = (this._xhr = this.createRequest(opts));
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for (let i in this._opts.extraHeaders) {
                        if (this._opts.extraHeaders.hasOwnProperty(i)) {
                            xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                        }
                    }
                }
            }
            catch (e) { }
            if ("POST" === this._method) {
                try {
                    xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
                }
                catch (e) { }
            }
            try {
                xhr.setRequestHeader("Accept", "*/*");
            }
            catch (e) { }
            (_a = this._opts.cookieJar) === null || _a === void 0 ? void 0 : _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) {
                xhr.withCredentials = this._opts.withCredentials;
            }
            if (this._opts.requestTimeout) {
                xhr.timeout = this._opts.requestTimeout;
            }
            xhr.onreadystatechange = () => {
                var _a;
                if (xhr.readyState === 3) {
                    (_a = this._opts.cookieJar) === null || _a === void 0 ? void 0 : _a.parseCookies(
                    // @ts-ignore
                    xhr.getResponseHeader("set-cookie"));
                }
                if (4 !== xhr.readyState)
                    return;
                if (200 === xhr.status || 1223 === xhr.status) {
                    this._onLoad();
                }
                else {
                    // make sure the `error` event handler that's user-set
                    // does not throw in the same tick and gets caught here
                    this.setTimeoutFn(() => {
                        this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                    }, 0);
                }
            };
            xhr.send(this._data);
        }
        catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(() => {
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = Request.requestsCount++;
            Request.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */
    _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */
    _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) {
            return;
        }
        this._xhr.onreadystatechange = empty$2;
        if (fromError) {
            try {
                this._xhr.abort();
            }
            catch (e) { }
        }
        if (typeof document !== "undefined") {
            delete Request.requests[this._index];
        }
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */
    _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */
    abort() {
        this._cleanup();
    }
}
Request.requestsCount = 0;
Request.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */
if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") {
        // @ts-ignore
        attachEvent("onunload", unloadHandler);
    }
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in globalThisShim ? "pagehide" : "unload";
        addEventListener(terminationEvent, unloadHandler, false);
    }
}
function unloadHandler() {
    for (let i in Request.requests) {
        if (Request.requests.hasOwnProperty(i)) {
            Request.requests[i].abort();
        }
    }
}
const hasXHR2 = (function () {
    const xhr = newRequest({
        xdomain: false,
    });
    return xhr && xhr.responseType !== null;
})();
/**
 * HTTP long-polling based on the built-in `XMLHttpRequest` object.
 *
 * Usage: browser
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest
 */
class XHR extends BaseXHR {
    constructor(opts) {
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, { xd: this.xd }, this.opts);
        return new Request(newRequest, this.uri(), opts);
    }
}
function newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
            return new XMLHttpRequest();
        }
    }
    catch (e) { }
    if (!xdomain) {
        try {
            return new globalThisShim[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
        }
        catch (e) { }
    }
}

// detect ReactNative environment
const isReactNative = typeof navigator !== "undefined" &&
    typeof navigator.product === "string" &&
    navigator.product.toLowerCase() === "reactnative";
class BaseWS extends Transport {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = isReactNative
            ? {}
            : pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) {
            opts.headers = this.opts.extraHeaders;
        }
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        }
        catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */
    addEventListeners() {
        this.ws.onopen = () => {
            if (this.opts.autoUnref) {
                this.ws._socket.unref();
            }
            this.onOpen();
        };
        this.ws.onclose = (closeEvent) => this.onClose({
            description: "websocket connection closed",
            context: closeEvent,
        });
        this.ws.onmessage = (ev) => this.onData(ev.data);
        this.ws.onerror = (e) => this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for (let i = 0; i < packets.length; i++) {
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            encodePacket(packet, this.supportsBinary, (data) => {
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                }
                catch (e) {
                }
                if (lastPacket) {
                    // fake drain
                    // defer to next tick to allow Socket to clear writeBuffer
                    nextTick(() => {
                        this.writable = true;
                        this.emitReserved("drain");
                    }, this.setTimeoutFn);
                }
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = () => { };
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */
    uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) {
            query[this.opts.timestampParam] = randomString$1();
        }
        // communicate binary support capabilities
        if (!this.supportsBinary) {
            query.b64 = 1;
        }
        return this.createUri(schema, query);
    }
}
const WebSocketCtor = globalThisShim.WebSocket || globalThisShim.MozWebSocket;
/**
 * WebSocket transport based on the built-in `WebSocket` object.
 *
 * Usage: browser, Node.js (since v21), Deno, Bun
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket
 * @see https://caniuse.com/mdn-api_websocket
 * @see https://nodejs.org/api/globals.html#websocket
 */
class WS extends BaseWS {
    createSocket(uri, protocols, opts) {
        return !isReactNative
            ? protocols
                ? new WebSocketCtor(uri, protocols)
                : new WebSocketCtor(uri)
            : new WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}

/**
 * WebTransport transport based on the built-in `WebTransport` object.
 *
 * Usage: browser, Node.js (with the `@fails-components/webtransport` package)
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WebTransport
 * @see https://caniuse.com/webtransport
 */
class WT extends Transport {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        }
        catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed
            .then(() => {
            this.onClose();
        })
            .catch((err) => {
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(() => {
            this._transport.createBidirectionalStream().then((stream) => {
                const decoderStream = createPacketDecoderStream(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = createPacketEncoderStream();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = () => {
                    reader
                        .read()
                        .then(({ done, value }) => {
                        if (done) {
                            return;
                        }
                        this.onPacket(value);
                        read();
                    })
                        .catch((err) => {
                    });
                };
                read();
                const packet = { type: "open" };
                if (this.query.sid) {
                    packet.data = `{"sid":"${this.query.sid}"}`;
                }
                this._writer.write(packet).then(() => this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for (let i = 0; i < packets.length; i++) {
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(() => {
                if (lastPacket) {
                    nextTick(() => {
                        this.writable = true;
                        this.emitReserved("drain");
                    }, this.setTimeoutFn);
                }
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 ? void 0 : _a.close();
    }
}

const transports = {
    websocket: WS,
    webtransport: WT,
    polling: XHR,
};

// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */
const re$1 = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];
function parse$2$1(str) {
    if (str.length > 8000) {
        throw "URI too long";
    }
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }
    let m = re$1.exec(str || ''), uri = {}, i = 14;
    while (i--) {
        uri[parts[i]] = m[i] || '';
    }
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = pathNames(uri, uri['path']);
    uri.queryKey = queryKey(uri, uri['query']);
    return uri;
}
function pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) {
        names.splice(0, 1);
    }
    if (path.slice(-1) == '/') {
        names.splice(names.length - 1, 1);
    }
    return names;
}
function queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
        if ($1) {
            data[$1] = $2;
        }
    });
    return data;
}

const withEventListeners = typeof addEventListener === "function" &&
    typeof removeEventListener === "function";
const OFFLINE_EVENT_LISTENERS = [];
if (withEventListeners) {
    // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
    // script, so we create one single event listener here which will forward the event to the socket instances
    addEventListener("offline", () => {
        OFFLINE_EVENT_LISTENERS.forEach((listener) => listener());
    }, false);
}
/**
 * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
 * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
 *
 * This class comes without upgrade mechanism, which means that it will keep the first low-level transport that
 * successfully establishes the connection.
 *
 * In order to allow tree-shaking, there are no transports included, that's why the `transports` option is mandatory.
 *
 * @example
 * import { SocketWithoutUpgrade, WebSocket } from "engine.io-client";
 *
 * const socket = new SocketWithoutUpgrade({
 *   transports: [WebSocket]
 * });
 *
 * socket.on("open", () => {
 *   socket.send("hello");
 * });
 *
 * @see SocketWithUpgrade
 * @see Socket
 */
class SocketWithoutUpgrade extends Emitter_1 {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */
    constructor(uri, opts) {
        super();
        this.binaryType = defaultBinaryType;
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */
        this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = parse$2$1(uri);
            opts.hostname = parsedUri.host;
            opts.secure =
                parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query)
                opts.query = parsedUri.query;
        }
        else if (opts.host) {
            opts.hostname = parse$2$1(opts.host).host;
        }
        installTimerFunctions(this, opts);
        this.secure =
            null != opts.secure
                ? opts.secure
                : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) {
            // if no port is specified manually, use the protocol default
            opts.port = this.secure ? "443" : "80";
        }
        this.hostname =
            opts.hostname ||
                (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port =
            opts.port ||
                (typeof location !== "undefined" && location.port
                    ? location.port
                    : this.secure
                        ? "443"
                        : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t) => {
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024,
            },
            transportOptions: {},
            closeOnBeforeunload: false,
        }, opts);
        this.opts.path =
            this.opts.path.replace(/\/$/, "") +
                (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") {
            this.opts.query = decode(this.opts.query);
        }
        if (withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = () => {
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = () => {
                    this._onClose("transport close", {
                        description: "network connection lost",
                    });
                };
                OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) {
            this._cookieJar = createCookieJar();
        }
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */
    createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = protocol;
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id)
            query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port,
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */
    _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(() => {
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade &&
            SocketWithoutUpgrade.priorWebsocketSuccess &&
            this.transports.indexOf("websocket") !== -1
            ? "websocket"
            : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */
    setTransport(transport) {
        if (this.transport) {
            this.transport.removeAllListeners();
        }
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport
            .on("drain", this._onDrain.bind(this))
            .on("packet", this._onPacket.bind(this))
            .on("error", this._onError.bind(this))
            .on("close", (reason) => this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */
    onOpen() {
        this.readyState = "open";
        SocketWithoutUpgrade.priorWebsocketSuccess =
            "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */
    _onPacket(packet) {
        if ("opening" === this.readyState ||
            "open" === this.readyState ||
            "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch (packet.type) {
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */
    onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState)
            return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */
    _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(() => {
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) {
            this._pingTimeoutTimer.unref();
        }
    }
    /**
     * Called on `drain` event
     *
     * @private
     */
    _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) {
            this.emitReserved("drain");
        }
        else {
            this.flush();
        }
    }
    /**
     * Flush write buffers.
     *
     * @private
     */
    flush() {
        if ("closed" !== this.readyState &&
            this.transport.writable &&
            !this.upgrading &&
            this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */
    _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload &&
            this.transport.name === "polling" &&
            this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) {
            return this.writeBuffer;
        }
        let payloadSize = 1; // first packet type
        for (let i = 0; i < this.writeBuffer.length; i++) {
            const data = this.writeBuffer[i].data;
            if (data) {
                payloadSize += byteLength(data);
            }
            if (i > 0 && payloadSize > this._maxPayload) {
                return this.writeBuffer.slice(0, i);
            }
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */
    /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime)
            return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            nextTick(() => {
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */
    write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */
    send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */
    _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) {
            return;
        }
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options,
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn)
            this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */
    close() {
        const close = () => {
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = () => {
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = () => {
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) {
                this.once("drain", () => {
                    if (this.upgrading) {
                        waitForUpgrade();
                    }
                    else {
                        close();
                    }
                });
            }
            else if (this.upgrading) {
                waitForUpgrade();
            }
            else {
                close();
            }
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */
    _onError(err) {
        SocketWithoutUpgrade.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports &&
            this.transports.length > 1 &&
            this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */
    _onClose(reason, description) {
        if ("opening" === this.readyState ||
            "open" === this.readyState ||
            "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (withEventListeners) {
                if (this._beforeunloadEventListener) {
                    removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                }
                if (this._offlineEventListener) {
                    const i = OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) {
                        OFFLINE_EVENT_LISTENERS.splice(i, 1);
                    }
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
SocketWithoutUpgrade.protocol = protocol;
/**
 * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
 * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
 *
 * This class comes with an upgrade mechanism, which means that once the connection is established with the first
 * low-level transport, it will try to upgrade to a better transport.
 *
 * In order to allow tree-shaking, there are no transports included, that's why the `transports` option is mandatory.
 *
 * @example
 * import { SocketWithUpgrade, WebSocket } from "engine.io-client";
 *
 * const socket = new SocketWithUpgrade({
 *   transports: [WebSocket]
 * });
 *
 * socket.on("open", () => {
 *   socket.send("hello");
 * });
 *
 * @see SocketWithoutUpgrade
 * @see Socket
 */
class SocketWithUpgrade extends SocketWithoutUpgrade {
    constructor() {
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) {
            for (let i = 0; i < this._upgrades.length; i++) {
                this._probe(this._upgrades[i]);
            }
        }
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */
    _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        SocketWithoutUpgrade.priorWebsocketSuccess = false;
        const onTransportOpen = () => {
            if (failed)
                return;
            transport.send([{ type: "ping", data: "probe" }]);
            transport.once("packet", (msg) => {
                if (failed)
                    return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport)
                        return;
                    SocketWithoutUpgrade.priorWebsocketSuccess =
                        "websocket" === transport.name;
                    this.transport.pause(() => {
                        if (failed)
                            return;
                        if ("closed" === this.readyState)
                            return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([{ type: "upgrade" }]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                }
                else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed)
                return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err) => {
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) {
                freezeTransport();
            }
        }
        // Remove all listeners on the transport and on self
        const cleanup = () => {
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 &&
            name !== "webtransport") {
            // favor WebTransport
            this.setTimeoutFn(() => {
                if (!failed) {
                    transport.open();
                }
            }, 200);
        }
        else {
            transport.open();
        }
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */
    _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for (let i = 0; i < upgrades.length; i++) {
            if (~this.transports.indexOf(upgrades[i]))
                filteredUpgrades.push(upgrades[i]);
        }
        return filteredUpgrades;
    }
}
/**
 * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
 * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
 *
 * This class comes with an upgrade mechanism, which means that once the connection is established with the first
 * low-level transport, it will try to upgrade to a better transport.
 *
 * @example
 * import { Socket } from "engine.io-client";
 *
 * const socket = new Socket();
 *
 * socket.on("open", () => {
 *   socket.send("hello");
 * });
 *
 * @see SocketWithoutUpgrade
 * @see SocketWithUpgrade
 */
let Socket$1 = class Socket extends SocketWithUpgrade {
    constructor(uri, opts = {}) {
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports ||
            (o.transports && typeof o.transports[0] === "string")) {
            o.transports = (o.transports || ["polling", "websocket", "webtransport"])
                .map((transportName) => transports[transportName])
                .filter((t) => !!t);
        }
        super(uri, o);
    }
};

/**
 * URL parser.
 *
 * @param uri - url
 * @param path - the request path of the connection
 * @param loc - An object meant to mimic window.location.
 *        Defaults to window.location.
 * @public
 */
function url(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || (typeof location !== "undefined" && location);
    if (null == uri)
        uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) {
                uri = loc.protocol + uri;
            }
            else {
                uri = loc.host + uri;
            }
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) {
                uri = loc.protocol + "//" + uri;
            }
            else {
                uri = "https://" + uri;
            }
        }
        // parse
        obj = parse$2$1(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) {
            obj.port = "80";
        }
        else if (/^(http|ws)s$/.test(obj.protocol)) {
            obj.port = "443";
        }
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href =
        obj.protocol +
            "://" +
            host +
            (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}

const withNativeArrayBuffer = typeof ArrayBuffer === "function";
const isView = (obj) => {
    return typeof ArrayBuffer.isView === "function"
        ? ArrayBuffer.isView(obj)
        : obj.buffer instanceof ArrayBuffer;
};
const toString$3 = Object.prototype.toString;
const withNativeBlob = typeof Blob === "function" ||
    (typeof Blob !== "undefined" &&
        toString$3.call(Blob) === "[object BlobConstructor]");
const withNativeFile = typeof File === "function" ||
    (typeof File !== "undefined" &&
        toString$3.call(File) === "[object FileConstructor]");
/**
 * Returns true if obj is a Buffer, an ArrayBuffer, a Blob or a File.
 *
 * @private
 */
function isBinary(obj) {
    return ((withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj))) ||
        (withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File));
}
function hasBinary(obj, toJSON) {
    if (!obj || typeof obj !== "object") {
        return false;
    }
    if (Array.isArray(obj)) {
        for (let i = 0, l = obj.length; i < l; i++) {
            if (hasBinary(obj[i])) {
                return true;
            }
        }
        return false;
    }
    if (isBinary(obj)) {
        return true;
    }
    if (obj.toJSON &&
        typeof obj.toJSON === "function" &&
        arguments.length === 1) {
        return hasBinary(obj.toJSON(), true);
    }
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
            return true;
        }
    }
    return false;
}

/**
 * Replaces every Buffer | ArrayBuffer | Blob | File in packet with a numbered placeholder.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @public
 */
function deconstructPacket(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = _deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return { packet: pack, buffers: buffers };
}
function _deconstructPacket(data, buffers) {
    if (!data)
        return data;
    if (isBinary(data)) {
        const placeholder = { _placeholder: true, num: buffers.length };
        buffers.push(data);
        return placeholder;
    }
    else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for (let i = 0; i < data.length; i++) {
            newData[i] = _deconstructPacket(data[i], buffers);
        }
        return newData;
    }
    else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                newData[key] = _deconstructPacket(data[key], buffers);
            }
        }
        return newData;
    }
    return data;
}
/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @public
 */
function reconstructPacket(packet, buffers) {
    packet.data = _reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function _reconstructPacket(data, buffers) {
    if (!data)
        return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" &&
            data.num >= 0 &&
            data.num < buffers.length;
        if (isIndexValid) {
            return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        }
        else {
            throw new Error("illegal attachments");
        }
    }
    else if (Array.isArray(data)) {
        for (let i = 0; i < data.length; i++) {
            data[i] = _reconstructPacket(data[i], buffers);
        }
    }
    else if (typeof data === "object") {
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                data[key] = _reconstructPacket(data[key], buffers);
            }
        }
    }
    return data;
}

/**
 * These strings must not be used as event names, as they have a special meaning.
 */
const RESERVED_EVENTS$1 = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener", // used by the Node.js EventEmitter
];
var PacketType;
(function (PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})(PacketType || (PacketType = {}));
/**
 * A socket.io Encoder instance
 */
class Encoder {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */
    constructor(replacer) {
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */
    encode(obj) {
        if (obj.type === PacketType.EVENT || obj.type === PacketType.ACK) {
            if (hasBinary(obj)) {
                return this.encodeAsBinary({
                    type: obj.type === PacketType.EVENT
                        ? PacketType.BINARY_EVENT
                        : PacketType.BINARY_ACK,
                    nsp: obj.nsp,
                    data: obj.data,
                    id: obj.id,
                });
            }
        }
        return [this.encodeAsString(obj)];
    }
    /**
     * Encode packet as string.
     */
    encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === PacketType.BINARY_EVENT ||
            obj.type === PacketType.BINARY_ACK) {
            str += obj.attachments + "-";
        }
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) {
            str += obj.nsp + ",";
        }
        // immediately followed by the id
        if (null != obj.id) {
            str += obj.id;
        }
        // json data
        if (null != obj.data) {
            str += JSON.stringify(obj.data, this.replacer);
        }
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */
    encodeAsBinary(obj) {
        const deconstruction = deconstructPacket(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function isObject$i(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 */
class Decoder extends Emitter_1 {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */
    constructor(reviver) {
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */
    add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) {
                throw new Error("got plaintext data when reconstructing a packet");
            }
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === PacketType.BINARY_EVENT;
            if (isBinaryEvent || packet.type === PacketType.BINARY_ACK) {
                packet.type = isBinaryEvent ? PacketType.EVENT : PacketType.ACK;
                // binary packet's json
                this.reconstructor = new BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) {
                    super.emitReserved("decoded", packet);
                }
            }
            else {
                // non-binary full packet
                super.emitReserved("decoded", packet);
            }
        }
        else if (isBinary(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) {
                throw new Error("got binary data when not reconstructing a packet");
            }
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        }
        else {
            throw new Error("Unknown type: " + obj);
        }
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */
    decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0)),
        };
        if (PacketType[p.type] === undefined) {
            throw new Error("unknown packet type " + p.type);
        }
        // look up attachments if type binary
        if (p.type === PacketType.BINARY_EVENT ||
            p.type === PacketType.BINARY_ACK) {
            const start = i + 1;
            while (str.charAt(++i) !== "-" && i != str.length) { }
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") {
                throw new Error("Illegal attachments");
            }
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while (++i) {
                const c = str.charAt(i);
                if ("," === c)
                    break;
                if (i === str.length)
                    break;
            }
            p.nsp = str.substring(start, i);
        }
        else {
            p.nsp = "/";
        }
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while (++i) {
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length)
                    break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if (Decoder.isPayloadValid(p.type, payload)) {
                p.data = payload;
            }
            else {
                throw new Error("invalid payload");
            }
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        }
        catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch (type) {
            case PacketType.CONNECT:
                return isObject$i(payload);
            case PacketType.DISCONNECT:
                return payload === undefined;
            case PacketType.CONNECT_ERROR:
                return typeof payload === "string" || isObject$i(payload);
            case PacketType.EVENT:
            case PacketType.BINARY_EVENT:
                return (Array.isArray(payload) &&
                    (typeof payload[0] === "number" ||
                        (typeof payload[0] === "string" &&
                            RESERVED_EVENTS$1.indexOf(payload[0]) === -1)));
            case PacketType.ACK:
            case PacketType.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */
    destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */
class BinaryReconstructor {
    constructor(packet) {
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */
    takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = reconstructPacket(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */
    finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}

var parser = /*#__PURE__*/Object.freeze({
	__proto__: null,
	Decoder: Decoder,
	Encoder: Encoder,
	get PacketType () { return PacketType; }
});

function on(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}

/**
 * Internal events.
 * These events can't be emitted by the user.
 */
const RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1,
});
/**
 * A Socket is the fundamental class for interacting with the server.
 *
 * A Socket belongs to a certain Namespace (by default /) and uses an underlying {@link Manager} to communicate.
 *
 * @example
 * const socket = io();
 *
 * socket.on("connect", () => {
 *   console.log("connected");
 * });
 *
 * // send an event to the server
 * socket.emit("foo", "bar");
 *
 * socket.on("foobar", () => {
 *   // an event was received from the server
 * });
 *
 * // upon disconnection
 * socket.on("disconnect", (reason) => {
 *   console.log(`disconnected due to ${reason}`);
 * });
 */
class Socket extends Emitter_1 {
    /**
     * `Socket` constructor.
     */
    constructor(io, nsp, opts) {
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */
        this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */
        this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */
        this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */
        this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */
        this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */
        this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) {
            this.auth = opts.auth;
        }
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect)
            this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */
    get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */
    subEvents() {
        if (this.subs)
            return;
        const io = this.io;
        this.subs = [
            on(io, "open", this.onopen.bind(this)),
            on(io, "packet", this.onpacket.bind(this)),
            on(io, "error", this.onerror.bind(this)),
            on(io, "close", this.onclose.bind(this)),
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */
    get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */
    connect() {
        if (this.connected)
            return this;
        this.subEvents();
        if (!this.io["_reconnecting"])
            this.io.open(); // ensure open
        if ("open" === this.io._readyState)
            this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */
    open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */
    send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */
    emit(ev, ...args) {
        var _a, _b, _c;
        if (RESERVED_EVENTS.hasOwnProperty(ev)) {
            throw new Error('"' + ev.toString() + '" is a reserved event name');
        }
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: PacketType.EVENT,
            data: args,
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        }
        else {
            this.sendBuffer.push(packet);
        }
        this.flags = {};
        return this;
    }
    /**
     * @private
     */
    _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(() => {
            delete this.acks[id];
            for (let i = 0; i < this.sendBuffer.length; i++) {
                if (this.sendBuffer[i].id === id) {
                    this.sendBuffer.splice(i, 1);
                }
            }
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args) => {
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */
    emitWithAck(ev, ...args) {
        return new Promise((resolve, reject) => {
            const fn = (arg1, arg2) => {
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */
    _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") {
            ack = args.pop();
        }
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args,
            flags: Object.assign({ fromQueue: true }, this.flags),
        };
        args.push((err, ...responseArgs) => {
            if (packet !== this._queue[0]) ;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) {
                        ack(err);
                    }
                }
            }
            else {
                this._queue.shift();
                if (ack) {
                    ack(null, ...responseArgs);
                }
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */
    _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) {
            return;
        }
        const packet = this._queue[0];
        if (packet.pending && !force) {
            return;
        }
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */
    packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */
    onopen() {
        if (typeof this.auth == "function") {
            this.auth((data) => {
                this._sendConnectPacket(data);
            });
        }
        else {
            this._sendConnectPacket(this.auth);
        }
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */
    _sendConnectPacket(data) {
        this.packet({
            type: PacketType.CONNECT,
            data: this._pid
                ? Object.assign({ pid: this._pid, offset: this._lastOffset }, data)
                : data,
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */
    onerror(err) {
        if (!this.connected) {
            this.emitReserved("connect_error", err);
        }
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */
    onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */
    _clearAcks() {
        Object.keys(this.acks).forEach((id) => {
            const isBuffered = this.sendBuffer.some((packet) => String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) {
                    ack.call(this, new Error("socket has been disconnected"));
                }
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */
    onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace)
            return;
        switch (packet.type) {
            case PacketType.CONNECT:
                if (packet.data && packet.data.sid) {
                    this.onconnect(packet.data.sid, packet.data.pid);
                }
                else {
                    this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                }
                break;
            case PacketType.EVENT:
            case PacketType.BINARY_EVENT:
                this.onevent(packet);
                break;
            case PacketType.ACK:
            case PacketType.BINARY_ACK:
                this.onack(packet);
                break;
            case PacketType.DISCONNECT:
                this.ondisconnect();
                break;
            case PacketType.CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */
    onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) {
            args.push(this.ack(packet.id));
        }
        if (this.connected) {
            this.emitEvent(args);
        }
        else {
            this.receiveBuffer.push(Object.freeze(args));
        }
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners) {
                listener.apply(this, args);
            }
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") {
            this._lastOffset = args[args.length - 1];
        }
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */
    ack(id) {
        const self = this;
        let sent = false;
        return function (...args) {
            // prevent double callbacks
            if (sent)
                return;
            sent = true;
            self.packet({
                type: PacketType.ACK,
                id: id,
                data: args,
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */
    onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") {
            return;
        }
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) {
            packet.data.unshift(null);
        }
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */
    onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */
    emitBuffered() {
        this.receiveBuffer.forEach((args) => this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet) => {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */
    ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */
    destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy) => subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */
    disconnect() {
        if (this.connected) {
            this.packet({ type: PacketType.DISCONNECT });
        }
        // remove socket from pool
        this.destroy();
        if (this.connected) {
            // fire events
            this.onclose("io client disconnect");
        }
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */
    close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */
    compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */
    get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */
    timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */
    onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */
    prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */
    offAny(listener) {
        if (!this._anyListeners) {
            return this;
        }
        if (listener) {
            const listeners = this._anyListeners;
            for (let i = 0; i < listeners.length; i++) {
                if (listener === listeners[i]) {
                    listeners.splice(i, 1);
                    return this;
                }
            }
        }
        else {
            this._anyListeners = [];
        }
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */
    listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */
    onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */
    prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */
    offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) {
            return this;
        }
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for (let i = 0; i < listeners.length; i++) {
                if (listener === listeners[i]) {
                    listeners.splice(i, 1);
                    return this;
                }
            }
        }
        else {
            this._anyOutgoingListeners = [];
        }
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */
    listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */
    notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners) {
                listener.apply(this, packet.data);
            }
        }
    }
}

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */
function Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */
Backoff.prototype.duration = function () {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */
Backoff.prototype.reset = function () {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */
Backoff.prototype.setMin = function (min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */
Backoff.prototype.setMax = function (max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */
Backoff.prototype.setJitter = function (jitter) {
    this.jitter = jitter;
};

class Manager extends Emitter_1 {
    constructor(uri, opts) {
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        installTimerFunctions(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new Backoff({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor(),
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || parser;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect)
            this.open();
    }
    reconnection(v) {
        if (!arguments.length)
            return this._reconnection;
        this._reconnection = !!v;
        if (!v) {
            this.skipReconnect = true;
        }
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined)
            return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined)
            return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined)
            return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined)
            return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length)
            return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */
    maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting &&
            this._reconnection &&
            this.backoff.attempts === 0) {
            // keeps reconnection from firing twice for the same reconnection loop
            this.reconnect();
        }
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */
    open(fn) {
        if (~this._readyState.indexOf("open"))
            return this;
        this.engine = new Socket$1(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = on(socket, "open", function () {
            self.onopen();
            fn && fn();
        });
        const onError = (err) => {
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) {
                fn(err);
            }
            else {
                // Only do this if there is no fn to handle the error
                this.maybeReconnectOnOpen();
            }
        };
        // emit `error`
        const errorSub = on(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(() => {
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) {
                timer.unref();
            }
            this.subs.push(() => {
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */
    connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */
    onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push(on(socket, "ping", this.onping.bind(this)), on(socket, "data", this.ondata.bind(this)), on(socket, "error", this.onerror.bind(this)), on(socket, "close", this.onclose.bind(this)), 
        // @ts-ignore
        on(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */
    onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */
    ondata(data) {
        try {
            this.decoder.add(data);
        }
        catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */
    ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        nextTick(() => {
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */
    onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */
    socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new Socket(this, nsp, opts);
            this.nsps[nsp] = socket;
        }
        else if (this._autoConnect && !socket.active) {
            socket.connect();
        }
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */
    _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps) {
            const socket = this.nsps[nsp];
            if (socket.active) {
                return;
            }
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */
    _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for (let i = 0; i < encodedPackets.length; i++) {
            this.engine.write(encodedPackets[i], packet.options);
        }
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */
    cleanup() {
        this.subs.forEach((subDestroy) => subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */
    _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */
    disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */
    onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 ? void 0 : _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) {
            this.reconnect();
        }
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */
    reconnect() {
        if (this._reconnecting || this.skipReconnect)
            return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        }
        else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(() => {
                if (self.skipReconnect)
                    return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect)
                    return;
                self.open((err) => {
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    }
                    else {
                        self.onreconnect();
                    }
                });
            }, delay);
            if (this.opts.autoUnref) {
                timer.unref();
            }
            this.subs.push(() => {
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */
    onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}

/**
 * Managers cache.
 */
const cache$1 = {};
function lookup(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = url(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = cache$1[id] && path in cache$1[id]["nsps"];
    const newConnection = opts.forceNew ||
        opts["force new connection"] ||
        false === opts.multiplex ||
        sameNamespace;
    let io;
    if (newConnection) {
        io = new Manager(source, opts);
    }
    else {
        if (!cache$1[id]) {
            cache$1[id] = new Manager(source, opts);
        }
        io = cache$1[id];
    }
    if (parsed.query && !opts.query) {
        opts.query = parsed.queryKey;
    }
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign(lookup, {
    Manager,
    Socket,
    io: lookup,
    connect: lookup,
});

var StentorServerChat = /** @class */ (function () {
    // private readonly options: ChatServerOptions | undefined;
    function StentorServerChat(config, options) {
        this.config = config;
        // this.options = options;
        this.token = options.token;
    }
    StentorServerChat.prototype.init = function (dispatch) {
        var _this = this;
        log$3("[StentorServerChat] Creating new socket connection to ".concat(this.config.url));
        this.socket = lookup(this.config.url, {
            transports: ["websocket"],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            reconnectionAttempts: 5
        });
        this.dispatch = dispatch;
        // Log connect event
        this.socket.on("connect", function () {
            log$3("[StentorServerChat] Socket CONNECTED - ID: ".concat(_this.socket.id));
        });
        // TODO: Authenticate - or at least tell the server who you are
        // Socket events
        this.socket.on("account_status", function (data) {
            log$3("SERVER: account_status: ".concat(JSON.stringify(data)));
            // Register the "communication" with the server
            if (!_this.token) {
                _this.token = uuid_1();
                dispatch(receiveToken(_this.token));
                log$3("CLIENT: created token: ".concat(_this.token));
            }
            _this.socket.emit("connection update", _this.token);
            dispatch({
                type: "account_status",
                detail: {
                    status: "online",
                    timestamp: +new Date()
                }
            });
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.socket.on("new message", function (data) {
            log$3("SERVER: new message: ".concat(JSON.stringify(data)));
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.msg",
                    user: {
                        displayName: data.username,
                        nick: "agent:robot",
                    },
                    msg: data.message,
                    timestamp: +new Date()
                }
            });
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.socket.on("user joined", function (data) {
            log$3("SERVER: user joined: ".concat(JSON.stringify(data)));
            _this.visitorInfo.token = data.token;
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.memberjoin",
                    user: {
                        displayName: data.username,
                        nick: data.nick || "agent:robot",
                        avatarPath: data.avatarPath
                    },
                    timestamp: +new Date(),
                }
            });
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.socket.on("user left", function (data) {
            log$3("SERVER: user left: ".concat(JSON.stringify(data)));
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.memberleave",
                    user: {
                        displayName: data.username,
                        nick: "agent:robot",
                    },
                    timestamp: +new Date()
                }
            });
        });
        this.socket.on("typing", function (data) {
            log$3("SERVER: typing: ".concat(JSON.stringify(data)));
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.typing",
                    user: {
                        nick: "agent:robot",
                    },
                    typing: true,
                    timestamp: +new Date()
                }
            });
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.socket.on("stop typing", function (data) {
            log$3("SERVER: stop typing: ".concat(JSON.stringify(data)));
            _this.dispatch({
                type: "chat",
                detail: {
                    type: "chat.typing",
                    user: {
                        nick: "agent:robot",
                    },
                    typing: false,
                    timestamp: +new Date()
                }
            });
        });
        this.socket.on("disconnect", function (reason) {
            var reasonStr = typeof reason === "string" ? reason : String(reason || "unknown");
            log$3("[StentorServerChat] Socket DISCONNECTED - Reason: ".concat(reasonStr));
            log$3("SERVER: disconnect");
            _this.dispatch(setAccountStatus("offline"));
            _this.dispatch(setConnectionStatus("offline"));
        });
        this.socket.on("reconnect", function () {
            log$3("SERVER: reconnect");
            _this.dispatch(setAccountStatus("online"));
            _this.dispatch(setConnectionStatus("online"));
        });
        this.socket.on("reconnect_failed", function (data) {
            log$3("SERVER: reconnect_failed", data);
            _this.dispatch(setAccountStatus("offline"));
            _this.dispatch(setConnectionStatus("offline"));
        });
        this.socket.on("reconnect_error", function (data) {
            log$3("SERVER: reconnect_error", data);
            _this.dispatch(setAccountStatus("offline"));
        });
        this.dispatch(setConnectionStatus("pending"));
    };
    StentorServerChat.prototype.sendOfflineMsg = function (_, cb) {
        cb();
    };
    StentorServerChat.prototype.sendChatMsg = function (message, cb) {
        this.socket.emit("new message", message);
        cb();
    };
    StentorServerChat.prototype.sendChatMsgRequest = function (message, cb) {
        this.socket.emit("new message", message);
        cb();
    };
    StentorServerChat.prototype.sendTyping = function (isTyping) {
        this.socket.emit(isTyping ? "typing" : "stop typing");
    };
    StentorServerChat.prototype.setVisitorInfo = function (visitorInfo, _sessionId, cb) {
        this.visitorInfo = visitorInfo;
        this.socket.emit("add user", visitorInfo);
        cb();
    };
    StentorServerChat.prototype.sendChatRating = function () {
    };
    StentorServerChat.prototype.sendFile = function (_, cb) {
        cb();
    };
    StentorServerChat.prototype.markAsRead = function () {
    };
    StentorServerChat.prototype.flush = function () {
    };
    StentorServerChat.prototype.dispose = function () {
        var _a;
        log$3("[StentorServerChat] dispose() called - manually disconnecting socket");
        (_a = this.socket) === null || _a === void 0 ? void 0 : _a.disconnect();
    };
    StentorServerChat.prototype.sleep = function () {
    };
    StentorServerChat.prototype.wakeup = function () {
    };
    StentorServerChat.prototype.bargeOut = function (_cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                throw new Error("Method not implemented: bargeOut");
            });
        });
    };
    StentorServerChat.prototype.bargeIn = function (_agentName, _cb) {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                throw new Error("Method not implemented: bargeIn");
            });
        });
    };
    return StentorServerChat;
}());

function createChatServerCore(config, options) {
    var _a, _b, _c, _d, _e;
    switch (config.type) {
        case "direct":
            return new StentorDirectChat({
                url: config.serverUrl,
                key: config.accountKey,
                timeout: config.timeout,
            }, options);
        case "websocket":
            return new StentorServerChat({
                url: config.serverUrl,
            }, options);
        case "websocketraw":
            return new StentorRouterChat({
                url: config.serverUrl,
            }, options);
        case "mcp":
            return new MCPChat({
                serverUrl: config.serverUrl,
                mode: (_a = config.mcp) === null || _a === void 0 ? void 0 : _a.mode,
                authToken: (_b = config.mcp) === null || _b === void 0 ? void 0 : _b.authToken,
                debugMode: (_c = config.mcp) === null || _c === void 0 ? void 0 : _c.debugMode,
                pageContextOverride: (_d = config.mcp) === null || _d === void 0 ? void 0 : _d.pageContextOverride,
                showAiBadge: (_e = config.mcp) === null || _e === void 0 ? void 0 : _e.showAiBadge,
            }, options);
        case "local":
            return new StentorLocalChat();
        default:
            throw throwBadKind$1(config.type);
    }
}
function createChatServer(config, options) {
    return new LogChat(createChatServerCore(config, options));
}
var ChatServerContext = require$$1.createContext(null);
function useChatServer(config, options) {
    var _a = require$$1.useState(), server = _a[0], setServer = _a[1];
    var dispatch = useChatDispatch();
    var deps = [options, config, dispatch];
    // Track previous values to detect what changed
    var prevDepsRef = require$$1.useRef(undefined);
    // Log what caused the "effect"
    // useWhatChanged(deps, "options, config, dispatch");
    require$$1.useEffect(function () {
        // Log when effect runs and what changed (for debugging connection issues)
        if (prevDepsRef.current) {
            var _a = prevDepsRef.current, prevOptions = _a[0], prevConfig = _a[1], prevDispatch = _a[2];
            var changes = [];
            if (prevOptions !== options)
                changes.push("options");
            if (prevConfig !== config)
                changes.push("config");
            if (prevDispatch !== dispatch)
                changes.push("dispatch");
            if (changes.length > 0) {
                log$3("[useChatServer] Effect re-running due to: ".concat(changes.join(", ")));
            }
        }
        else {
            log$3("[useChatServer] Effect running for first time");
        }
        prevDepsRef.current = [options, config, dispatch];
        // Don't create server if config is null (waiting for async config load)
        if (!config || !options) {
            log$3("[useChatServer] Config or options null, not creating server");
            setServer(undefined);
            return undefined;
        }
        log$3("Creating new chat server - type: ".concat(config.type));
        var newServer = createChatServer(config, options);
        newServer.init(dispatch);
        setServer(newServer);
        return function () {
            log$3("Cleanup - disposing old server");
            newServer.dispose();
        };
    }, deps);
    return server;
}

function useChatServerDispatch() {
    var inner = useChatDispatch();
    var chatServer = require$$1.useContext(ChatServerContext);
    return require$$1.useCallback(function (action) {
        if (!action) {
            console.warn("react bug? Someone invokes with null");
            return;
        }
        if (chatServer) {
            inner(action(chatServer));
        }
    }, [inner, chatServer]);
}

var ChatChipsContainer = function (_) {
    var dispatch = useChatServerDispatch();
    var chips = reactRedux.useSelector(function (state) { return state.chips; });
    var chatDispatch = useChatDispatch();
    var visuals = reactRedux.useSelector(function (state) { return state.visuals; });
    var openUrl = useOpenUrlCallback();
    function optionOnChange(option) {
        var actionUrl = isChatServerActionLink(option) && option.actionUrl;
        if (actionUrl) {
            openUrl(actionUrl, chatDispatch, visuals);
        }
        else {
            // add metadata
            dispatch(executeAction(getChatServerActionLinkLabel(option), {
                action: "click",
                ui: "chip",
            }));
        }
    }
    return (require$$0.jsx("div", { className: "message-list-container__chips ".concat(!(chips === null || chips === void 0 ? void 0 : chips.length) ? "message-list-container__chips--empty" : ""), children: require$$0.jsx(ChatChips, { options: chips, onOptionClick: optionOnChange }) }));
};

var ButtonGroup = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (require$$0.jsx("div", { className: "button-group ".concat(className), children: children }));
};

var CancelButton = function (props) {
    return (require$$0.jsx("div", { id: "xapp-widget-close", "aria-label": "close widget", "aria-hidden": false, tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, className: "cancel-button", onClick: props.onClick }));
};

var ChatMenuItem = function (props) {
    function handleClick() {
        if (props.onClick) {
            props.onClick(props.label);
        }
    }
    var content = props.subtitle ? (require$$0.jsxs("span", { children: [require$$0.jsx("div", { children: props.label }), require$$0.jsx("div", { className: "chat-menu-item--subtitle", children: props.subtitle })] })) : (require$$0.jsx("span", { children: props.label }));
    return (require$$0.jsx("button", { type: "button", className: "chat-menu-item", tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, onClick: handleClick, children: content }));
};

var _this = undefined;
var ChatMenu = function (props) {
    var items = props.items, opened = props.opened;
    var openFrom = props.openFrom || "bottom";
    var handleOpenUrl = useOpenUrlCallback();
    var chatDispatch = useChatDispatch();
    var visuals = reactRedux.useSelector(function (state) { return state.visuals; });
    return (require$$0.jsx("div", { className: "chat-menu-".concat(openFrom, " ").concat(opened ? "chat-menu-".concat(openFrom, "--opened") : "chat-menu-".concat(openFrom, "--closed")), children: items.map(function (item, i) {
            if (lib$5.isStandardMenuItem(item)) {
                return (require$$0.jsx(ChatMenuItem, { onClick: props.onItemClick, label: item.label, subtitle: item.subtitle }, i));
            }
            else if (lib$5.isStaticImageMenuItem(item)) {
                return (require$$0.jsx("div", { className: "chat-menu-item-static", children: require$$0.jsx("img", { style: {
                            maxHeight: "100%",
                            maxWidth: "auto",
                        }, src: item.imageUrl, alt: "Menu Item" }) }, i));
            }
            else if (lib$5.isStaticTextMenuItem(item)) {
                return (require$$0.jsx("div", { className: "chat-menu-item-static-text", children: require$$0.jsxs("div", { children: [require$$0.jsx("div", { children: item.title }), require$$0.jsx("div", { className: "chat-menu-item-static-text--body", children: item.body })] }) }, i));
            }
            else if (lib$5.isOpenURLMenuItem(item)) {
                return (require$$0.jsx("button", { className: "chat-menu-item", onClick: handleOpenUrl.bind(_this, item.url, chatDispatch, visuals, item.behavior), children: item.text }, i));
            }
            return require$$0.jsx("p", { children: "Unknown" });
        }) }));
};

var DrawerBars = function (props) {
    var bars = props.bars;
    // 0 is not a valid number of bars so a simple truthy check works here
    if (!bars) {
        bars = 2;
    }
    function getBars() {
        var barElements = [];
        for (var bar = 0; bar < bars; bar++) {
            barElements.push(require$$0.jsx("div", { className: "drawer-bar bar".concat(bar) }, "drawer-bar-".concat(bar)));
        }
        return barElements;
    }
    return (require$$0.jsx("button", { className: "drawer-bars", tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, "aria-label": "open menu", "aria-hidden": false, onClick: props.onToggle, children: getBars() }));
};

/**
 * Type guard for ChatMsgDetail.
 * Use this to safely narrow ChatDetail to ChatMsgDetail.
 */
function isChatMsgDetail(chat) {
    return chat.type === "chat.msg";
}

/**
 * Formats a suggestion chip for export
 */
function formatSuggestion(option) {
    if (isChatServerActionLink(option)) {
        return option.actionUrl ? "[".concat(option.label, "](").concat(option.actionUrl, ")") : option.label;
    }
    return option;
}
/**
 * Formats chat messages for export
 */
function formatConversation(chats) {
    return chats
        .filter(isChatMsgDetail)
        .map(function (chat) {
        var _a, _b, _c;
        var isVisitor = (_a = chat.user.nick) === null || _a === void 0 ? void 0 : _a.startsWith("visitor:");
        var role = isVisitor ? "User" : "Assistant";
        var text = ((_b = chat.msg) === null || _b === void 0 ? void 0 : _b.text) || "";
        var result = "".concat(role, ": ").concat(text);
        // Add suggestion chips if present
        var options = (_c = chat.msg) === null || _c === void 0 ? void 0 : _c.options;
        if (options && options.length > 0) {
            var suggestions = options.map(formatSuggestion).join(", ");
            result += "\nSuggestions: ".concat(suggestions);
        }
        return result;
    })
        .join("\n");
}
var ExportButton = function (props) {
    var chats = reactRedux.useSelector(function (state) { return state.chats; });
    var handleClick = function () { return __awaiter$1(void 0, void 0, void 0, function () {
        var conversation, textarea;
        return __generator$1(this, function (_b) {
            switch (_b.label) {
                case 0:
                    conversation = formatConversation(chats);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(conversation)];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    // Fallback for older browsers using deprecated execCommand
                    // Note: execCommand is deprecated and may be removed in future browsers
                    console.warn("[ExportButton] Using deprecated execCommand fallback for clipboard copy");
                    textarea = document.createElement("textarea");
                    textarea.value = conversation;
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textarea);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (require$$0.jsx("div", { id: "xapp-widget-export", "aria-label": "export conversation", "aria-hidden": false, tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, className: "export-button", onClick: handleClick }));
};

var MenuButton = function (props) {
    return (require$$0.jsx("div", { id: "xapp-widget-menu", "aria-label": "open menu", "aria-hidden": false, tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, className: "menu-button", onClick: props.onClick }));
};

var MinimizeButton = function (props) {
    return (require$$0.jsx("div", { id: "xapp-widget-minimize", "aria-label": "minimize widget", "aria-hidden": false, tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, className: "minimize-button ".concat(props.showInRight ? "positionRight" : ""), onClick: props.onClick }));
};

var RefreshButton = function (props) {
    return (require$$0.jsx("div", { id: "xapp-widget-refresh", "aria-label": "refresh chat", "aria-hidden": false, tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, className: "refresh-button ".concat(props.showInRight ? "positionRight" : props.showInLeft ? "positionLeft" : ""), onClick: props.onClick }));
};

var DEFAULT_STATUS_CONFIG = {
    online: "Virtual Assistant",
    offline: "Leave us a message",
    away: "We're away!",
    connecting: "Connecting...",
};
function getStatusText(status, config) {
    var _a, _b, _c, _d;
    log$3("getStatusText called with status: \"".concat(status, "\""));
    switch (status) {
        case "online":
            return (_a = config === null || config === void 0 ? void 0 : config.online) !== null && _a !== void 0 ? _a : DEFAULT_STATUS_CONFIG.online;
        case "offline":
            return (_b = config === null || config === void 0 ? void 0 : config.offline) !== null && _b !== void 0 ? _b : DEFAULT_STATUS_CONFIG.offline;
        case "away":
            return (_c = config === null || config === void 0 ? void 0 : config.away) !== null && _c !== void 0 ? _c : DEFAULT_STATUS_CONFIG.away;
        default:
            return (_d = config === null || config === void 0 ? void 0 : config.connecting) !== null && _d !== void 0 ? _d : DEFAULT_STATUS_CONFIG.connecting;
    }
}
/**
 * Determines if a string contains HTML tags
 */
function isHtmlString(text) {
    if (typeof text !== "string") {
        return false;
    }
    // Check for common HTML patterns
    var htmlPattern = /<\/?[a-z][\s\S]*>/i;
    return htmlPattern.test(text);
}
/**
 * Sanitizes HTML string by removing potentially dangerous elements and attributes
 */
function sanitizeHtml(html) {
    try {
        // Check if DOMParser is available
        if (typeof DOMParser === "undefined") {
            log$3("DOMParser not available, returning text content only");
            return html.replace(/<[^>]*>/g, ""); // Strip all HTML tags as fallback
        }
        // Create a temporary DOM element to parse the HTML
        var doc_1 = new DOMParser().parseFromString(html, "text/html");
        // Check if parsing was successful
        if (!doc_1 || !doc_1.body) {
            log$3("DOMParser failed to parse HTML, returning text content only");
            return html.replace(/<[^>]*>/g, ""); // Strip all HTML tags as fallback
        }
        // List of allowed tags (whitelist approach)
        var allowedTags_1 = ["span", "div", "p", "strong", "em", "b", "i", "u", "br"];
        // List of allowed style properties
        var allowedStyleProps_1 = [
            "color", "background-color", "font-size", "font-weight", "font-style",
            "text-align", "display", "flex", "align-items", "justify-content",
            "gap", "margin", "padding", "width", "height", "border-radius"
        ];
        // Recursive function to clean nodes
        var cleanNode_1 = function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
                var element_1 = node;
                var tagName = element_1.tagName.toLowerCase();
                // Remove if not in allowed tags, but preserve text content
                if (!allowedTags_1.includes(tagName)) {
                    // Replace the element with its text content
                    var textNode = doc_1.createTextNode(element_1.textContent || "");
                    element_1.replaceWith(textNode);
                    return;
                }
                // Remove all attributes except style
                var attributes = Array.from(element_1.attributes);
                attributes.forEach(function (attr) {
                    if (attr.name !== "style") {
                        element_1.removeAttribute(attr.name);
                    }
                });
                // Clean style attribute - only allow safe properties
                if (element_1.hasAttribute("style")) {
                    var styleText = element_1.getAttribute("style") || "";
                    var cleanedStyles_1 = [];
                    // Parse individual style properties
                    styleText.split(";").forEach(function (declaration) {
                        var _a = declaration.split(":"), prop = _a[0], valueParts = _a.slice(1);
                        var value = valueParts.join(":").trim(); // Rejoin in case value contains colons
                        var propTrimmed = prop.trim();
                        if (propTrimmed && value && allowedStyleProps_1.includes(propTrimmed.toLowerCase())) {
                            // Additional validation: ensure value doesn't contain javascript: or expression()
                            if (!/javascript:|expression\(|@import|behavior:/i.test(value)) {
                                cleanedStyles_1.push("".concat(propTrimmed, ": ").concat(value));
                            }
                        }
                    });
                    if (cleanedStyles_1.length > 0) {
                        element_1.setAttribute("style", cleanedStyles_1.join("; "));
                    }
                    else {
                        element_1.removeAttribute("style");
                    }
                }
                // Recursively clean child nodes
                var children = Array.from(element_1.childNodes);
                children.forEach(function (child) { return cleanNode_1(child); });
            }
        };
        // Clean each child of the body, not the body itself
        Array.from(doc_1.body.childNodes).forEach(function (child) { return cleanNode_1(child); });
        return doc_1.body.innerHTML;
    }
    catch (error) {
        log$3("Error sanitizing HTML: ".concat(error));
        // Fallback: strip all HTML tags
        return html.replace(/<[^>]*>/g, "");
    }
}
/**
 * Safely renders subtitle text that can be plain text, JSX, or HTML string
 */
function renderSubtitleText(text) {
    // If it's an HTML string, sanitize and render it using dangerouslySetInnerHTML
    if (isHtmlString(text)) {
        var sanitizedHtml = sanitizeHtml(text);
        return require$$0.jsx("span", { dangerouslySetInnerHTML: { __html: sanitizedHtml } });
    }
    // Otherwise, render as-is (handles JSX and plain text)
    return text;
}
var refreshButtonAriaLabel = "To refresh chat click on clockwise gapped circle arrow icon in top right side of widget. ";
var minimizeButtonAriaLabel = "To minimize widget click on minus icon in top right side of widget. ";
var closeButtonAriaLabel = "To close widget click on close icon in top right side of widget.";
var ChatHeader = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var innerDispatch = useChatDispatch();
    var menuConfig = props.menuConfig, onSubmit = props.onSubmit, debugMode = props.debugMode;
    var _r = require$$1.useState(false), drawerOpen = _r[0], setDrawerState = _r[1]; // false initially
    var menuPosition = (menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.menuButtonLocation) || "FOOTER";
    var showMenuLeft = menuPosition === "HEADER_LEFT";
    var showMenuRight = menuPosition === "HEADER_RIGHT";
    var menuItemsRaw = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.items;
    var menuItemsTabIndex = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.itemsTabIndex;
    var menuButtonTabIndex = (_a = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.button) === null || _a === void 0 ? void 0 : _a.tabIndex;
    var menuItems = require$$1.useMemo(function () { return (menuItemsRaw ? menuItemsRaw : []); }, [menuItemsRaw]);
    // Check if we have a right-side menu
    var hasRightMenu = showMenuRight && menuItems.length > 0;
    function toggleDrawer() {
        var newDrawer = !drawerOpen;
        setDrawerState(newDrawer);
        innerDispatch(setVisualStatus({
            drawer: newDrawer,
        }));
    }
    function handleMenuItem(label) {
        setDrawerState(false);
        onSubmit(label);
    }
    var ariaLabel = "";
    var canRefresh = props.canRefresh, canMinimize = props.canMinimize, canCancel = props.canCancel;
    if (canRefresh) {
        ariaLabel = refreshButtonAriaLabel;
    }
    if (canMinimize) {
        ariaLabel = "".concat(ariaLabel).concat(minimizeButtonAriaLabel);
    }
    if (canCancel) {
        ariaLabel = "".concat(ariaLabel).concat(closeButtonAriaLabel);
    }
    return (require$$0.jsxs(require$$0.Fragment, { children: [require$$0.jsxs("div", { className: "status-container background-header", "aria-label": ariaLabel, "aria-hidden": false, children: [showMenuLeft && menuItems.length ? (require$$0.jsx(require$$0.Fragment, { children: require$$0.jsx("div", { className: "chat-footer__menu-icon", children: require$$0.jsx(DrawerBars, { bars: 3, tabIndex: menuButtonTabIndex, onToggle: toggleDrawer }) }) })) : (require$$0.jsx(require$$0.Fragment, {})), ((_b = props === null || props === void 0 ? void 0 : props.agent) === null || _b === void 0 ? void 0 : _b.avatarPath) === undefined ? (require$$0.jsx("div", {})) : (require$$0.jsx("div", { className: "status-container__avatar", children: require$$0.jsx(Avatar$3, { entity: props.agent }) })), require$$0.jsxs("div", { className: "\n                        ".concat("status-text", "\n                        ").concat(showMenuLeft && menuItems.length
                            ? "status-text-positionWithMenu"
                            : ((_c = props === null || props === void 0 ? void 0 : props.agent) === null || _c === void 0 ? void 0 : _c.avatarPath) === undefined
                                ? "status-text-positionLeftNoAvatar"
                                : "status-text-positionLeft", "\n                        ").concat(((_d = props.config) === null || _d === void 0 ? void 0 : _d.alignTextCenter)
                            ? "status-text-positionCenter"
                            : "", "                     \n                        "), children: [require$$0.jsx("span", { className: "status-text-title", children: getStatusText(props.accountStatus, (_e = props.config) === null || _e === void 0 ? void 0 : _e.status) }), ((_g = (_f = props.config) === null || _f === void 0 ? void 0 : _f.subtitle) === null || _g === void 0 ? void 0 : _g.enabled) && (require$$0.jsx("span", { className: "status-text-subtitle", children: renderSubtitleText((_j = (_h = props.config) === null || _h === void 0 ? void 0 : _h.subtitle) === null || _j === void 0 ? void 0 : _j.text) }))] }), require$$0.jsxs(ButtonGroup, { children: [hasRightMenu && (require$$0.jsx(MenuButton, { onClick: toggleDrawer, tabIndex: menuButtonTabIndex })), debugMode && require$$0.jsx(ExportButton, {}), props.canRefresh && (require$$0.jsx(RefreshButton, { onClick: props.refreshOnClick, tabIndex: (_l = (_k = props.config) === null || _k === void 0 ? void 0 : _k.actions) === null || _l === void 0 ? void 0 : _l.refreshTabIndex, showInLeft: false, showInRight: false })), props.canMinimize && (require$$0.jsx(MinimizeButton, { onClick: props.minimizeOnClick, tabIndex: (_o = (_m = props.config) === null || _m === void 0 ? void 0 : _m.actions) === null || _o === void 0 ? void 0 : _o.minimizeTabIndex, showInRight: false })), props.canCancel && (require$$0.jsx(CancelButton, { onClick: props.cancelOnClick, tabIndex: (_q = (_p = props.config) === null || _p === void 0 ? void 0 : _p.actions) === null || _q === void 0 ? void 0 : _q.cancelTabIndex }))] })] }), drawerOpen ? (require$$0.jsx("div", { className: "xa-chat-menu-container", children: require$$0.jsx(ChatMenu, { openFrom: showMenuRight ? "right" : "left", opened: drawerOpen, tabIndex: menuItemsTabIndex, onItemClick: handleMenuItem, items: menuItems }) })) : (require$$0.jsx(require$$0.Fragment, {}))] }));
};

var UnknownMessage = function () { return require$$0.jsx(require$$0.Fragment, {}); };

function renderAvatar(entity) {
    return (require$$0.jsx("div", { className: "xappw-chat-msg-part__avatar", children: require$$0.jsx(Avatar$3, { entity: entity }) }));
}
var ChatMessagePart = function (props) {
    var _a;
    var position = (_a = props.avatarPosition) !== null && _a !== void 0 ? _a : "left";
    var containerClass = "xappw-chat-msg-part" +
        (position === "below" ? " xappw-chat-msg-part--avatar-below" : "") +
        (position === "bottom" ? " xappw-chat-msg-part--avatar-bottom" : "") +
        (props.fullWidth ? " xappw-chat-msg-part--full-width" : "") +
        (props.isStreaming ? " xappw-chat-msg-part--streaming" : "");
    var user = props.user, hideUserInfo = props.hideUserInfo;
    // Hide user info if hideUserInfo is true and position is "bottom"
    var shouldHideUserInfo = hideUserInfo && position === "bottom";
    return (require$$0.jsx("div", { className: containerClass, children: position === "left" ? (require$$0.jsxs(require$$0.Fragment, { children: [props.showAvatar && renderAvatar(user), props.children] })) : (require$$0.jsxs(require$$0.Fragment, { children: [props.children, props.showAvatar && !shouldHideUserInfo && (require$$0.jsxs("div", { className: "xappw-chat-msg-part__avatar-wrapper", children: [renderAvatar(user), (user === null || user === void 0 ? void 0 : user.displayName) && (require$$0.jsx("div", { className: "xappw-chat-msg-part__avatar-name", children: user.displayName }))] }))] })) }));
};

function useExecuteActionCallback() {
    var dispatch = useChatServerDispatch();
    return require$$1.useCallback(function (text, meta) {
        dispatch(executeAction(text, meta));
    }, [dispatch]);
}

function useButtonCallback() {
    var handleOpenUrl = useOpenUrlCallback();
    var chatDispatch = useChatDispatch();
    var visuals = reactRedux.useSelector(function (state) { return state.visuals; });
    var executeAction = useExecuteActionCallback();
    return require$$1.useCallback(function (button) {
        if (button.actionUrl) {
            handleOpenUrl(button.actionUrl, chatDispatch, visuals);
        }
        else {
            executeAction(button.label);
        }
    }, [chatDispatch, executeAction, handleOpenUrl, visuals]);
}

/**
 * Is the Display a Card
 *
 * @privateRemarks We don't want to include stentor-response as a dependency so we are redefining them.
 * @param display
 * @returns
 */
function isCard(display) {
    return !!display && display.type === "CARD";
}
/**
 * Is the Display a List
 *
 * @privateRemarks We don't want to include stentor-response as a dependency so we are redefining them.
 * @param display
 * @returns
 */
function isList(display) {
    return !!display && (display.type === "LIST" || display.type === "CAROUSEL");
}

var CardMiddlewareWidget = function (props) {
    var msg = props.msg, ctx = props.ctx;
    var card = require$$1.useMemo(function () { return convertFromCardDisplay(msg); }, [msg]);
    var user = ctx.user;
    var handleButton = useButtonCallback();
    return (require$$0.jsx(ChatMessagePart, { showAvatar: true, user: user, children: require$$0.jsx("div", { className: "chat-msg", children: require$$0.jsx(ChatCard, { card: card, onButtonClick: handleButton }) }) }));
};
var CardMiddleware = function (next) { return function (props) {
    var msg = props.msg, ctx = props.ctx;
    if (isCard(msg)) {
        return require$$0.jsx(CardMiddlewareWidget, { msg: msg, ctx: ctx });
    }
    return next(props);
}; };

function joinMiddlewares(middlewares) {
    return function (next) { return middlewares.reduceRight(function (prev, cur) { return cur(prev); }, next); };
}

function createSubscribableArray(originalValue) {
    var cache = originalValue || [];
    var subscriptions = [];
    function notify() {
        for (var _i = 0, subscriptions_1 = subscriptions; _i < subscriptions_1.length; _i++) {
            var subscription = subscriptions_1[_i];
            subscription(cache);
        }
    }
    return {
        getArray: function () { return cache; },
        push: function (val) {
            cache = __spreadArray$1(__spreadArray$1([], cache, true), [val], false);
            notify();
        },
        unshift: function (val) {
            cache = __spreadArray$1([val], cache, true);
            notify();
        },
        subscribe: function (callback) {
            subscriptions.push(callback);
            return {
                unsubscribe: function () {
                    var index = subscriptions.indexOf(callback);
                    if (index >= 0) {
                        subscriptions.splice(index, 1);
                    }
                }
            };
        }
    };
}
function useSubscribableArray(array) {
    var _a = require$$1.useState(array.getArray()), res = _a[0], setRes = _a[1];
    var mounted = useIsMounted$1();
    require$$1.useEffect(function () {
        var subscription = array.subscribe(function (newVal) {
            if (mounted()) {
                setRes(newVal);
            }
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [mounted, array]);
    return res;
}

// registration would like below
// (window["xappMsgMiddlewares"] = window["xappMsgMiddlewares"] || []).push(next => (msg, ctx) => next(msg, ctx));
var empty$1 = [];
function createStorage(global, key) {
    return {
        get: function () { return global[key]; },
        set: function (val) { return global[key] = val; }
    };
}
function useGlobalSubscribableArray(storage) {
    var raw = storage.get() || empty$1;
    var array = Array.isArray(raw) ? createSubscribableArray(raw) : raw;
    if (array !== raw) {
        storage.set(array);
    }
    return useSubscribableArray(array);
}
function useLateMiddlewaresBuilder(storage) {
    var middlewares = useGlobalSubscribableArray(storage);
    return require$$1.useMemo(function () { return joinMiddlewares(middlewares); }, [middlewares]);
}
var storage = createStorage(globalThis, "xappMsgMiddlewares");
function useLateMiddleware() {
    return useLateMiddlewaresBuilder(storage);
}

function getSvg() {
    return (require$$0.jsxs("svg", { viewBox: "0 0 20 20", children: [require$$0.jsx("path", { d: "M17 17H3V3h5V1H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5h-2z" }), require$$0.jsx("path", { d: "M19 1h-8l3.29 3.29-5.73 5.73 1.42 1.42 5.73-5.73L19 9V1z" })] }));
}
var ExternalLink = function (props) {
    var url = props.url;
    var handleClick = require$$1.useCallback(function (ev) {
        ev.preventDefault();
    }, []);
    return (require$$0.jsx("a", { href: url, "aria-label": "read more", target: "_blank", rel: "noreferrer", className: props.className, onClick: handleClick, children: getSvg() }));
};

function firstIndex(val, patterns) {
    var res = -1;
    for (var _i = 0, patterns_1 = patterns; _i < patterns_1.length; _i++) {
        var pattern = patterns_1[_i];
        var index = val.indexOf(pattern);
        if (index >= 0) {
            if (res < 0 || ((res >= 0) && (index < res))) {
                res = index;
            }
        }
    }
    return res;
}
var schemeParser = function (rest) {
    var next = rest.indexOf("://");
    if (next < 0)
        return next;
    return next + 3;
};
var domainEnds = [":", "/"];
var portEnds = ["/"];
var pathEnds = ["?", "#"];
var queryEnds = ["#"];
var domainParser = function (rest) {
    return firstIndex(rest, domainEnds);
};
var portParser = function (rest) {
    if (rest.charAt(0) !== ":") {
        return -1;
    }
    return firstIndex(rest, portEnds);
};
var pathParser = function (rest) {
    var res = firstIndex(rest, pathEnds);
    if (res >= 0) {
        return res;
    }
    return rest.length;
};
var queryParser = function (rest) {
    return firstIndex(rest, queryEnds);
};
var parsers$2 = [
    schemeParser,
    domainParser,
    portParser,
    pathParser,
    queryParser
];
function parse$1$1(val) {
    var parts = [];
    var rest = val;
    for (var _i = 0, parsers_1 = parsers$2; _i < parsers_1.length; _i++) {
        var parser = parsers_1[_i];
        var newIndex = Math.max(0, parser(rest, val));
        var part = rest.substring(0, newIndex);
        parts.push(part);
        rest = rest.substring(newIndex);
    }
    if (rest) {
        parts.push(rest);
    }
    return parts;
}
var ellipsis = "/...";
function reduceLink(url, maxLength) {
    if (url.length < maxLength)
        return url;
    var parts = parse$1$1(url); // [scheme, domain, port, path, query, hash]
    function getText() {
        return parts.join("");
    }
    function overflows() {
        return getText().length > maxLength;
    }
    function tryReduce(index) {
        if (overflows()) {
            parts[index] = "";
        }
    }
    if (parts[2] === ":80" && parts[0] === "http://") {
        tryReduce(2);
    }
    if (parts[2] === ":443" && parts[0] === "https://") {
        tryReduce(2);
    }
    tryReduce(5);
    tryReduce(4);
    tryReduce(2);
    tryReduce(0);
    if (overflows()) {
        var path = parts[3];
        var allButPathLength = getText().length - path.length;
        var available = maxLength - allButPathLength;
        if (available < 0) {
            parts[3] = "";
        }
        else if (available < path.length) {
            var newPathStart = path.length - available + ellipsis.length;
            parts[3] = ellipsis + path.substring(newPathStart);
        }
    }
    return getText();
}

var SmartLink = function (props) {
    var url = props.url, className = props.className;
    var handleClick = require$$1.useCallback(function (ev) {
        ev.preventDefault();
    }, []);
    return (require$$0.jsx("a", { href: url, "aria-label": "read more", target: "_blank", rel: "noreferrer", className: className, onClick: handleClick, children: reduceLink(url, 40) }));
};

var ListItem = function (props) {
    var _a;
    var item = props.item;
    var layout = props.layout || "normal";
    var url = item.url || item.imageActionUrl;
    return (require$$0.jsx(ActionItem, { className: "xappw-vlist-item-container", item: item, onButtonClick: props.onButtonClick, onExecute: props.onExecute, onOpenUrl: props.onOpenUrl, children: require$$0.jsxs("div", { className: "xappw-vlist-item xappw-vlist-item--".concat(layout), children: [require$$0.jsxs("div", { className: "xappw-vlist-item__description", children: [item.title && (require$$0.jsx("div", { className: "xappw-vlist-item__title", children: require$$0.jsx("span", { children: item.title }) })), url && !item.hideUrl && (require$$0.jsxs("div", { className: "xappw-vlist-item__link-row", children: [require$$0.jsx(SmartLink, { url: url, className: "xappw-vlist-item__link" }), require$$0.jsx(ExternalLink, { url: url, className: "xappw-vlist-item__external-link" })] })), item.subTitle && (require$$0.jsx("div", { className: "xappw-vlist-item__subtitle", children: require$$0.jsx("span", { children: item.subTitle }) })), !!((_a = item.buttons) === null || _a === void 0 ? void 0 : _a.length) && (require$$0.jsx(ChatActionButtons, { buttons: item.buttons, onClick: props.onButtonClick }))] }), require$$0.jsx("div", { className: "xappw-vlist-item__side", children: require$$0.jsx(ActionItemImage, { item: item, className: "xappw-vlist-item__img", emptyImageVisible: props.emptyImageVisible }) })] }) }));
};

var List = function (props) {
    var list = props.list;
    var listRef = require$$1.useRef(null);
    var hasImage = list.items.some(function (item) { return item.imageUrl; });
    var titlesOnly = !list.items.some(function (item) { var _a; return item.subTitle || ((_a = item.buttons) === null || _a === void 0 ? void 0 : _a.length); });
    var listItems = list.items.map(function (item, itemIndex) {
        return (require$$0.jsx("div", { className: "xappw-vlist-container__item", children: require$$0.jsx(ListItem, { item: item, layout: titlesOnly ? "titles" : "normal", emptyImageVisible: hasImage, onExecute: props.onExecute, onButtonClick: props.onButtonClick, onOpenUrl: props.onOpenUrl }) }, "item-key-".concat(itemIndex)));
    });
    return (require$$0.jsx("div", { className: "xappw-vlist", children: require$$0.jsxs("div", { ref: listRef, className: "xappw-vlist-container", children: [props.list.title && require$$0.jsx("div", { className: "xappw-vlist__header", children: props.list.title }), listItems] }) }));
};

var ListMiddlewareWidget = function (props) {
    var msg = props.msg, ctx = props.ctx;
    if (!ctx) {
        throw new TypeError("ctx not provided to ".concat(ListMiddlewareWidget.name));
    }
    var list = require$$1.useMemo(function () { return convertFromListDisplay(msg); }, [msg]);
    var executeActionCallback = useExecuteActionCallback();
    var handleExecute = require$$1.useCallback(function (ui, text, token) {
        executeActionCallback(text, { token: token, action: "click", ui: ui });
    }, [executeActionCallback]);
    var handleButton = useButtonCallback();
    var user = ctx.user;
    return (require$$0.jsxs(ChatMessagePart, { showAvatar: false, user: user, fullWidth: true, children: [list.type === "CAROUSEL" && (require$$0.jsx("div", { className: "chat-msg chat-msg--fullwidth chat-msg--no-ava", children: require$$0.jsx(Carousel, { list: list, onExecute: handleExecute.bind(null, "carousel"), onButtonClick: handleButton, onOpenUrl: ctx.openUrl }) })), list.type === "LIST" && (require$$0.jsx("div", { className: "chat-msg chat-msg--expand", children: require$$0.jsx(List, { list: list, onExecute: handleExecute.bind(null, "list"), onButtonClick: handleButton, onOpenUrl: ctx.openUrl }) }))] }));
};
var ListMiddleware = function (next) { return function (props) {
    var msg = props.msg, ctx = props.ctx;
    if (isList(msg)) {
        return require$$0.jsx(ListMiddlewareWidget, { msg: msg, ctx: ctx });
    }
    return next(props);
}; };

var MultiSelect = function (props) {
    var items = props.items, checked = props.checked, onChange = props.onChange;
    var handleToggle = require$$1.useCallback(function (ev) {
        var _a;
        var id = ev.target.value;
        onChange(__assign$1(__assign$1({}, checked), (_a = {}, _a[id] = !checked[id], _a)));
    }, [checked, onChange]);
    return (require$$0.jsx("ul", { className: "xappw-multiselect", children: items === null || items === void 0 ? void 0 : items.map(function (item) { return (require$$0.jsx("li", { children: require$$0.jsxs("label", { children: [require$$0.jsx("input", { type: "checkbox", checked: checked[item.id] || false, onChange: handleToggle, value: item.id }), require$$0.jsx("span", { children: item.title })] }) }, item.id)); }) }));
};

function isMultiSelect(display) {
    return display.type === "MultiSelect";
}
function convertToMultiSelectItems(display) {
    return display.items;
}
var MultiSelectMiddlewareWidget = function (props) {
    var msg = props.msg, ctx = props.ctx;
    var items = require$$1.useMemo(function () { return convertToMultiSelectItems(msg); }, [msg]);
    var user = ctx.user;
    var _a = require$$1.useState({}), checked = _a[0], setChecked = _a[1];
    var handleSubmit = require$$1.useCallback(function () {
        ctx.send({
            type: "custom",
            payload: JSON.stringify({
                type: "OPTION_SELECT_REQUEST",
                intentId: "OptionSelect",
                selected: Object.keys(checked).map(function (k) { return ({ id: k }); }),
            }),
        });
    }, [ctx, checked]);
    return (require$$0.jsx(ChatMessagePart, { showAvatar: true, user: user, children: require$$0.jsx("div", { className: "chat-msg", children: require$$0.jsxs("div", { children: [require$$0.jsx(MultiSelect, { items: items, checked: checked, onChange: setChecked }), require$$0.jsx(ActionButton, { label: "Submit", onClick: handleSubmit })] }) }) }));
};
var MultiSelectMiddleware = function (next) { return function (props) {
    var msg = props.msg, ctx = props.ctx;
    if (isMultiSelect(msg)) {
        return require$$0.jsx(MultiSelectMiddlewareWidget, { msg: msg, ctx: ctx });
    }
    return next(props);
}; };

var StandardMiddlewaresBuilder = joinMiddlewares([
    ListMiddleware,
    CardMiddleware,
    MultiSelectMiddleware
]);
function useStandardMiddlewareBuilder() {
    var lateMiddleware = useLateMiddleware();
    return require$$1.useMemo(function () { return joinMiddlewares([
        lateMiddleware,
        StandardMiddlewaresBuilder,
    ]); }, [lateMiddleware]);
}
function useStandardMiddleware() {
    var builder = useStandardMiddlewareBuilder();
    return require$$1.useMemo(function () { return builder(UnknownMessage); }, [builder]);
}
var StandardMiddlewares = StandardMiddlewaresBuilder(UnknownMessage);

function getTailSvgPath(owner) {
    if (owner === "others") {
        return "m 80 0 v 240 h -60 c 40 -40 60 -160 60 -240";
    }
    return "m 0 0 v 240 h 60 c -40 -40 -60 -160 -60 -240";
}
function getTailSvg(owner) {
    return (require$$0.jsx("svg", { className: "chat-text-bubble__tail", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 80 240", children: require$$0.jsx("path", { d: getTailSvgPath(owner), fill: "currentColor" }) }));
}
var ChatMessageBubble = function (props) {
    var owner = props.owner, onClick = props.onClick;
    var handleClick = require$$1.useCallback(function () {
        if (onClick) {
            onClick();
        }
    }, [onClick]);
    return (require$$0.jsxs("div", { onClick: handleClick, className: "chat-text-bubble ".concat(owner === "mine" ? "chat-text-bubble--mine" : "chat-text-bubble--others"), children: [props.hasTail && getTailSvg(owner), props.children] }));
};

var ChatMarkdownMessage = function (props) {
    var onOpenUrl = props.onOpenUrl;
    var agentMessage = isAgent(props.message.user.nick);
    var ref = require$$1.useRef(null);
    var chatDispatch = useChatDispatch();
    var visuals = reactRedux.useSelector(function (state) { return state.visuals; });
    var html = props.message.msg.html;
    var handleLinkClick = require$$1.useCallback(function (ev) {
        if (onOpenUrl) {
            var link = ev.target;
            ev.preventDefault();
            onOpenUrl(link.href, chatDispatch, visuals);
        }
    }, [onOpenUrl]);
    require$$1.useEffect(function () {
        if (ref.current) {
            ref.current.innerHTML = html;
            if (onOpenUrl) {
                var links_1 = ref.current.querySelectorAll("a");
                links_1.forEach(function (link) {
                    link.addEventListener("click", handleLinkClick);
                });
                return function () {
                    links_1.forEach(function (link) {
                        link.removeEventListener("click", handleLinkClick);
                    });
                };
            }
        }
        return undefined;
    }, [ref, html, onOpenUrl, handleLinkClick, props.message.timestamp]);
    return (require$$0.jsx("div", { className: "chat-msg", children: require$$0.jsx("div", { className: "chat-text-container", children: require$$0.jsxs(ChatMessageBubble, { owner: agentMessage ? "others" : "mine", hasTail: agentMessage && !props.sibling, children: [require$$0.jsx("span", { className: "message-sr-only", children: "at " + props.time + (agentMessage ? " the bot said" : " the user said") }), require$$0.jsx("div", { ref: ref })] }) }) }));
};

var ChatPermissionMessage = function (props) {
    var message = props.message, ctx = props.ctx;
    if (!ctx) {
        throw new TypeError("ctx not provided to ".concat(ChatPermissionMessage.name));
    }
    var user = ctx.user;
    var permissionRequest = message.msg.permissionRequest;
    var agentMessage = isAgent(props.message.user.nick);
    var author = message.user;
    var allowLabel = "Allow";
    var denyLabel = "Deny";
    var writeAsAgent = require$$1.useCallback(function (msg) {
        ctx.write({
            type: "msg",
            user: author,
            msg: msg,
        });
    }, [ctx, author]);
    var writeAsUser = require$$1.useCallback(function (msg) {
        ctx.write({
            type: "msg",
            user: user,
            msg: msg,
        });
    }, [ctx, user]);
    var handleFail = require$$1.useCallback(function () {
        ctx.send({
            type: "msg",
            user: undefined,
            msg: {
                text: denyLabel,
            },
        });
    }, [ctx]);
    var handleSend = require$$1.useCallback(function (msg) {
        ctx.send({
            type: "permissionGrant",
            user: author,
            msg: msg,
        });
    }, [author, ctx]);
    var handleResult = require$$1.useCallback(function (position, userMsg) {
        handleSend({
            text: userMsg,
            location: position
                ? {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                }
                : undefined,
            permissionRequest: permissionRequest,
        });
        writeAsUser({
            text: userMsg,
        });
        var agentMsg = position ? permissionRequest === null || permissionRequest === void 0 ? void 0 : permissionRequest.approve : permissionRequest === null || permissionRequest === void 0 ? void 0 : permissionRequest.deny;
        if (agentMsg) {
            writeAsAgent(agentMsg);
        }
    }, [permissionRequest, writeAsUser, writeAsAgent, handleSend]);
    var handleDeny = require$$1.useCallback(function (label) {
        handleResult(undefined, label);
    }, [handleResult]);
    var handleAllow = require$$1.useCallback(function (label) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                handleResult(position, label);
            }, function () {
                handleFail();
            });
        }
    }, [handleFail, handleResult]);
    if (!permissionRequest) {
        return require$$0.jsx(require$$0.Fragment, {});
    }
    return (require$$0.jsxs("div", { className: "chat-msg", children: [require$$0.jsx("span", { className: "message-sr-only", children: "at " + props.time + (agentMessage ? " the bot said" : " the user said") }), require$$0.jsxs("div", { className: "buttons-container", children: [require$$0.jsx(ActionButton, { label: allowLabel, addClass: "button", onClick: handleAllow }), require$$0.jsx(ActionButton, { label: denyLabel, addClass: "button", onClick: handleDeny })] })] }));
};

var CopyButton = function (_a) {
    var text = _a.text;
    var _b = require$$1.useState(false), copied = _b[0], setCopied = _b[1];
    var handleCopy = function (e) { return __awaiter$1(void 0, void 0, void 0, function () {
        var textarea;
        return __generator$1(this, function (_b) {
            switch (_b.label) {
                case 0:
                    e.stopPropagation();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(text)];
                case 2:
                    _b.sent();
                    setCopied(true);
                    setTimeout(function () { return setCopied(false); }, 1500);
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    textarea = document.createElement("textarea");
                    textarea.value = text;
                    document.body.appendChild(textarea);
                    textarea.select();
                    document.execCommand("copy");
                    document.body.removeChild(textarea);
                    setCopied(true);
                    setTimeout(function () { return setCopied(false); }, 1500);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (require$$0.jsx("button", { className: "tool-call-item__copy-btn", onClick: handleCopy, title: "Copy to clipboard", children: copied ? "✓" : "⧉" }));
};
/**
 * Gets the display text for a tool call, using fallback chain:
 * label -> displayName -> toolName -> "Working..."
 */
var getDisplayLabel = function (toolCall) {
    var _a, _b, _c;
    return (_c = (_b = (_a = toolCall.label) !== null && _a !== void 0 ? _a : toolCall.displayName) !== null && _b !== void 0 ? _b : toolCall.name) !== null && _c !== void 0 ? _c : "Working...";
};
/**
 * User-friendly tool progress item (non-debug mode)
 * Shows just the label with a spinner or checkmark
 */
var ToolProgressItem = function (_a) {
    var toolCall = _a.toolCall;
    var label = getDisplayLabel(toolCall);
    return (require$$0.jsxs("div", { className: "tool-progress-item ".concat(toolCall.isExecuting ? "tool-progress-item--executing" : "", " ").concat(toolCall.error ? "tool-progress-item--error" : ""), children: [require$$0.jsx("span", { className: "tool-progress-item__icon", children: toolCall.isExecuting ? (require$$0.jsx("span", { className: "tool-progress-item__spinner", "aria-label": "executing" })) : toolCall.error ? (require$$0.jsx("span", { className: "tool-progress-item__status tool-progress-item__status--error", children: "!" })) : (require$$0.jsx("span", { className: "tool-progress-item__status tool-progress-item__status--success", children: "\u2713" })) }), require$$0.jsx("span", { className: "tool-progress-item__label", children: label })] }));
};
/**
 * Debug mode tool call item with expandable details
 * Shows label, tool name, and expandable input/output
 */
var ToolCallItem = function (_a) {
    var toolCall = _a.toolCall;
    var _b = require$$1.useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var toggleExpanded = function () { return setIsExpanded(!isExpanded); };
    var formatJson = function (data) {
        if (data === undefined || data === null)
            return "";
        try {
            // If it's a string, try to parse it as JSON first (server may send stringified JSON)
            if (typeof data === "string") {
                try {
                    var parsed = JSON.parse(data);
                    return JSON.stringify(parsed, null, 2);
                }
                catch (_a) {
                    // Not valid JSON, return as-is
                    return data;
                }
            }
            return JSON.stringify(data, null, 2);
        }
        catch (_b) {
            return String(data);
        }
    };
    var label = getDisplayLabel(toolCall);
    var duration = toolCall.endTime
        ? "".concat(((toolCall.endTime - toolCall.startTime) / 1000).toFixed(2), "s")
        : null;
    var hasInput = toolCall.input !== undefined && toolCall.input !== null;
    var hasResult = toolCall.result !== undefined && toolCall.result !== null;
    var hasError = !!toolCall.error;
    return (require$$0.jsxs("div", { className: "tool-call-item ".concat(toolCall.isExecuting ? "tool-call-item--executing" : ""), children: [require$$0.jsxs("button", { className: "tool-call-item__header", onClick: toggleExpanded, "aria-expanded": isExpanded, children: [require$$0.jsx("span", { className: "tool-call-item__icon", children: toolCall.isExecuting ? (require$$0.jsx("span", { className: "tool-call-item__spinner", "aria-label": "executing" })) : toolCall.error ? (require$$0.jsx("span", { className: "tool-call-item__status tool-call-item__status--error", children: "!" })) : (require$$0.jsx("span", { className: "tool-call-item__status tool-call-item__status--success", children: "\u2713" })) }), require$$0.jsxs("span", { className: "tool-call-item__info", children: [require$$0.jsx("span", { className: "tool-call-item__label", children: label }), require$$0.jsx("span", { className: "tool-call-item__name", children: toolCall.name })] }), duration && require$$0.jsx("span", { className: "tool-call-item__duration", children: duration }), require$$0.jsx("span", { className: "tool-call-item__chevron ".concat(isExpanded ? "tool-call-item__chevron--expanded" : ""), children: "\u25BE" })] }), isExpanded && (require$$0.jsxs("div", { className: "tool-call-item__content", children: [hasInput && (require$$0.jsxs("div", { className: "tool-call-item__section", children: [require$$0.jsxs("div", { className: "tool-call-item__section-header", children: [require$$0.jsx("span", { className: "tool-call-item__section-label", children: "Input" }), require$$0.jsx(CopyButton, { text: formatJson(toolCall.input) })] }), require$$0.jsx("pre", { className: "tool-call-item__code", children: formatJson(toolCall.input) })] })), hasResult && (require$$0.jsxs("div", { className: "tool-call-item__section", children: [require$$0.jsxs("div", { className: "tool-call-item__section-header", children: [require$$0.jsx("span", { className: "tool-call-item__section-label", children: "Output" }), require$$0.jsx(CopyButton, { text: formatJson(toolCall.result) })] }), require$$0.jsx("pre", { className: "tool-call-item__code", children: formatJson(toolCall.result) })] })), hasError && (require$$0.jsxs("div", { className: "tool-call-item__section", children: [require$$0.jsxs("div", { className: "tool-call-item__section-header", children: [require$$0.jsx("span", { className: "tool-call-item__section-label tool-call-item__section-label--error", children: "Error" }), require$$0.jsx(CopyButton, { text: toolCall.error || "" })] }), require$$0.jsx("pre", { className: "tool-call-item__code tool-call-item__code--error", children: toolCall.error })] })), !hasInput && !hasResult && !hasError && (require$$0.jsx("div", { className: "tool-call-item__empty", children: "No data available" }))] }))] }));
};
var ToolCallDisplay = function (_a) {
    var toolCalls = _a.toolCalls, _b = _a.debugMode, debugMode = _b === void 0 ? false : _b;
    if (!toolCalls || toolCalls.length === 0) {
        return null;
    }
    // Debug mode: show all tools with full expandable details
    if (debugMode) {
        return (require$$0.jsxs("div", { className: "tool-call-display", children: [require$$0.jsxs("div", { className: "tool-call-display__header", children: [require$$0.jsx("span", { className: "tool-call-display__icon", children: "\u2699" }), require$$0.jsxs("span", { className: "tool-call-display__title", children: ["Tool Calls (", toolCalls.length, ")"] })] }), require$$0.jsx("div", { className: "tool-call-display__list", children: toolCalls.map(function (toolCall, index) { return (require$$0.jsx(ToolCallItem, { toolCall: toolCall }, "".concat(toolCall.name, "-").concat(toolCall.startTime, "-").concat(index))); }) })] }));
    }
    // Normal mode: filter out hidden tools and show user-friendly progress
    var visibleToolCalls = toolCalls.filter(function (tc) { return !tc.hidden; });
    if (visibleToolCalls.length === 0) {
        return null;
    }
    return (require$$0.jsx("div", { className: "tool-progress-display", children: visibleToolCalls.map(function (toolCall, index) { return (require$$0.jsx(ToolProgressItem, { toolCall: toolCall }, "".concat(toolCall.name, "-").concat(toolCall.startTime, "-").concat(index))); }) }));
};

/**
 * Parses basic markdown to HTML.
 * Supports: bold, italic, links, headers, and unordered lists.
 */
function parseMarkdown(text) {
    if (!text)
        return "";
    var html = text
        // Escape HTML entities first
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        // Headers (must be at start of line)
        .replace(/^### (.+)$/gm, "<h4>$1</h4>")
        .replace(/^## (.+)$/gm, "<h3>$1</h3>")
        .replace(/^# (.+)$/gm, "<h2>$1</h2>")
        // Bold (** or __)
        .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
        .replace(/__(.+?)__/g, "<strong>$1</strong>")
        // Italic (* or _) - must come after bold
        .replace(/\*([^*]+?)\*/g, "<em>$1</em>")
        .replace(/_([^_]+?)_/g, "<em>$1</em>")
        // Links [text](url)
        .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
        // Unordered lists (- or *)
        .replace(/^[-*] (.+)$/gm, "<li>$1</li>")
        // Line breaks
        .replace(/\n/g, "<br>");
    // Wrap consecutive <li> elements in <ul>
    html = html.replace(/(<li>.*?<\/li>)(<br>)?/g, "$1");
    html = html.replace(/(<li>.*?<\/li>)+/g, "<ul>$&</ul>");
    // Clean up <br> inside <ul>
    html = html.replace(/<ul>(.*?)<\/ul>/g, function (match) {
        return match.replace(/<br>/g, "");
    });
    return html;
}
var ChatTextMessage = function (props) {
    var _a;
    var message = props.message;
    var date = new Date(message.timestamp);
    var time = date.getHours() + ":" + date.getMinutes();
    var agentMessage = isAgent((_a = props.message.user) === null || _a === void 0 ? void 0 : _a.nick);
    var isStreaming = message.isStreaming;
    // Parse markdown for agent messages
    var parsedHtml = require$$1.useMemo(function () {
        if (agentMessage && message.msg.text) {
            return parseMarkdown(message.msg.text);
        }
        return null;
    }, [agentMessage, message.msg.text]);
    // No tail for streaming messages (or messages that were streamed)
    var wasStreamed = message.wasStreamed;
    var showTail = agentMessage && !props.sibling && !isStreaming && !wasStreamed;
    var hasToolCalls = props.toolCalls && props.toolCalls.length > 0;
    return (require$$0.jsxs("div", { className: "chat-msg".concat(isStreaming ? " chat-msg--streaming" : ""), children: [hasToolCalls && (require$$0.jsx(ToolCallDisplay, { toolCalls: props.toolCalls, debugMode: props.debugMode })), require$$0.jsx("div", { className: "chat-text-container", children: require$$0.jsxs(ChatMessageBubble, { owner: agentMessage ? "others" : "mine", hasTail: showTail, children: [require$$0.jsx("span", { className: "message-sr-only", children: "at " + time + (agentMessage ? (isStreaming ? " the bot is typing" : " the bot said") : " the user said") }), parsedHtml ? (require$$0.jsx("span", { className: "chat-msg__content", dangerouslySetInnerHTML: { __html: parsedHtml } })) : (require$$0.jsx("span", { className: "chat-msg__content", children: message.msg.text })), isStreaming && require$$0.jsx("span", { className: "streaming-cursor", "aria-hidden": "true" })] }) })] }));
};

var ChatScheduleWidget = function (props) {
    var display = props.display;
    var chatDispatch = useChatDispatch();
    var visuals = reactRedux.useSelector(function (state) { return state.visuals; });
    var openUrl = useOpenUrlCallback();
    function handleClick() {
        openUrl(scheduleWidgetUrl, chatDispatch, visuals);
    }
    return (require$$0.jsx("div", { className: "chat-schedule-button-container", children: require$$0.jsxs("button", { className: "chat-schedule-button", onClick: handleClick, children: [require$$0.jsx("i", { className: "fa fa-lg fa-calendar" }), require$$0.jsx("span", { children: display.label || "Schedule Now!" })] }) }));
};

/**
 * Displays source links below a chat message.
 * Designed to be compact and unobtrusive, unlike suggestion chips.
 */
var SourceLinks = function (props) {
    var sources = props.sources, _a = props.prefix, prefix = _a === void 0 ? "Sources:" : _a, onSourceClick = props.onSourceClick;
    if (!sources || sources.length === 0) {
        return null;
    }
    var handleClick = function (source, e) {
        if (onSourceClick) {
            e.preventDefault();
            onSourceClick(source);
        }
    };
    return (require$$0.jsxs("div", { className: "source-links", children: [prefix && require$$0.jsx("span", { className: "source-links__prefix", children: prefix }), require$$0.jsx("span", { className: "source-links__list", children: sources.map(function (source, index) { return (require$$0.jsxs("span", { className: "source-links__item", children: [require$$0.jsx("a", { href: source.url, target: source.newTab !== false ? "_blank" : "_self", rel: source.newTab !== false ? "noopener noreferrer" : undefined, className: "source-links__link", onClick: function (e) { return handleClick(source, e); }, title: source.url, children: source.title }), index < sources.length - 1 && (require$$0.jsx("span", { className: "source-links__separator", children: "\u00B7" }))] }, index)); }) })] }));
};

function getClassName(msg) {
    return isAgent(msg.user.nick) ? "agent" : "visitor";
}
var avaKeys = ["text", "html", "card", "list"];
/**
 * Chat Message Bubble with an Avatar
 *
 * @param props
 * @returns
 */
var ChatMessage = function (props) {
    var _a, _b, _c;
    var middleware = props.messageMiddleware || StandardMiddlewares;
    var chatConfig = require$$1.useContext(ChatConfigContext);
    // console.log(`########### chatConfig: ${JSON.stringify(chatConfig, null, 2)}`);
    var ctx = props.middlewareContext;
    var user = props.agent;
    // Get hideUserInfo from the agent info based on the message sender's nick
    var agentInfo = (_a = props.agents) === null || _a === void 0 ? void 0 : _a[props.message.user.nick];
    var hideUserInfo = (agentInfo === null || agentInfo === void 0 ? void 0 : agentInfo.hideUserInfo) || false;
    function renderByType() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        var msg = props.message.msg;
        switch (props.message.type) {
            // TODO: props actually requires it to be "chat.msg". Fix prop typing?
            case "chat.msg":
                // Here is the deal. If we have text (output speech), then text - card - list - options
                // OR card OR list only. Avatar with text bubble.
                var avaKey = avaKeys.find(function (key) { return !!msg[key]; });
                var isStreaming_1 = props.message.isStreaming;
                var wasStreamed = props.message.wasStreamed;
                // Tool calls - show progress while tools execute (before text arrives)
                var toolCalls = props.message.toolCalls;
                var hasToolCalls = toolCalls && toolCalls.length > 0;
                var debugMode = (_d = (_c = (_b = (_a = chatConfig === null || chatConfig === void 0 ? void 0 : chatConfig.env) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.mcp) === null || _c === void 0 ? void 0 : _c.debugMode) !== null && _d !== void 0 ? _d : false;
                // Show tool progress with avatar when no text yet, or above text when text exists
                var showToolProgressWithAvatar = hasToolCalls && !msg.text;
                return (require$$0.jsxs(require$$0.Fragment, { children: [showToolProgressWithAvatar && (require$$0.jsx(ChatMessagePart, { showAvatar: true, user: user, avatarPosition: (_g = (_f = (_e = chatConfig === null || chatConfig === void 0 ? void 0 : chatConfig.env) === null || _e === void 0 ? void 0 : _e.theme) === null || _f === void 0 ? void 0 : _f.messages) === null || _g === void 0 ? void 0 : _g.avatarPosition, hideUserInfo: hideUserInfo, isStreaming: true, children: require$$0.jsx("div", { className: "chat-msg", children: require$$0.jsx(ToolCallDisplay, { toolCalls: toolCalls, debugMode: debugMode }) }) })), msg.text && (require$$0.jsx(ChatMessagePart, { showAvatar: avaKey === "text", user: user, avatarPosition: (_k = (_j = (_h = chatConfig === null || chatConfig === void 0 ? void 0 : chatConfig.env) === null || _h === void 0 ? void 0 : _h.theme) === null || _j === void 0 ? void 0 : _j.messages) === null || _k === void 0 ? void 0 : _k.avatarPosition, hideUserInfo: hideUserInfo, isStreaming: isStreaming_1 || wasStreamed, children: require$$0.jsx(ChatTextMessage, { message: props.message, sibling: props.sibling, user: user, toolCalls: hasToolCalls ? toolCalls : undefined, debugMode: debugMode }) })), msg.html &&
                            require$$0.jsx(ChatMessagePart, { showAvatar: avaKey === "html", user: user, avatarPosition: (_o = (_m = (_l = chatConfig === null || chatConfig === void 0 ? void 0 : chatConfig.env) === null || _l === void 0 ? void 0 : _l.theme) === null || _m === void 0 ? void 0 : _m.messages) === null || _o === void 0 ? void 0 : _o.avatarPosition, hideUserInfo: hideUserInfo, children: require$$0.jsx(ChatMarkdownMessage, { message: props.message, sibling: props.sibling, onOpenUrl: (_p = props.middlewareContext) === null || _p === void 0 ? void 0 : _p.openUrl }) }), msg.displays && middleware && msg.displays.map(function (display, index) {
                            if (display.type === "ScheduleButton") {
                                return (require$$0.jsx(ChatScheduleWidget, { minimizeOnClick: props.minimizeOnClick, display: display }));
                            }
                            var Middleware = middleware;
                            return (require$$0.jsx(Middleware, { msg: display, ctx: props.middlewareContext }, index));
                        }), msg.permissionRequest && ctx &&
                            require$$0.jsx(ChatMessagePart, { showAvatar: avaKey === "permissionRequest", user: user, avatarPosition: (_s = (_r = (_q = chatConfig === null || chatConfig === void 0 ? void 0 : chatConfig.env) === null || _q === void 0 ? void 0 : _q.theme) === null || _r === void 0 ? void 0 : _r.messages) === null || _s === void 0 ? void 0 : _s.avatarPosition, hideUserInfo: hideUserInfo, children: require$$0.jsx(ChatPermissionMessage, { message: props.message, sibling: props.sibling, ctx: ctx }) })] }));
        }
        return (require$$0.jsx(require$$0.Fragment, {}));
    }
    function renderTimestampAndSources() {
        var _a;
        var timestamp = props.message.timestamp;
        var ts = new Date(timestamp);
        var timeAgo = getTimeAgo(ts);
        var sources = (_a = props.message.msg) === null || _a === void 0 ? void 0 : _a.sources;
        var hasSources = sources && sources.length > 0;
        var isAgentMessage = isAgent(props.message.user.nick);
        return (require$$0.jsxs("div", { className: "chat-msg-footer ".concat(isAgentMessage ? "agent" : "visitor"), children: [require$$0.jsx("span", { className: "chat-msg-timestamp", children: timeAgo }), hasSources && (require$$0.jsx(SourceLinks, { sources: sources.map(function (s) { return ({ title: s.title, url: s.url, newTab: s.newTab }); }) }))] }));
    }
    // Don't show timestamp/sources while streaming or if message has no content yet
    var isStreaming = props.message.isStreaming;
    var hasContent = !!(((_b = props.message.msg) === null || _b === void 0 ? void 0 : _b.text) || ((_c = props.message.msg) === null || _c === void 0 ? void 0 : _c.html));
    var showFooter = !isStreaming && hasContent;
    // empty
    return (require$$0.jsx("div", { className: "chat-msg-container-wrapper ".concat(isAgent(props.message.user.nick) ? "agent" : "visitor", " ").concat(props.sibling ? "sibling" : ""), children: require$$0.jsxs("div", { className: "chat-msg-container ".concat(getClassName(props.message)), children: [renderByType(), showFooter && renderTimestampAndSources()] }) }));
};

/**
 * value must be like "60m", "2h" etc.
 */
function convertToSeconds(s) {
    if (!s) {
        return 0;
    }
    var groups = s.match(/(\d+)([dhms]?)/);
    if (!groups) {
        err("Invalid time string: ".concat(s));
        return 0;
    }
    var number = parseInt(groups[1]);
    var unit = groups[2];
    switch (unit) {
        case "d":
            return number * 24 * 60 * 60;
        case "h":
            return number * 60 * 60;
        case "m":
            return number * 60;
        case "s":
            return number;
        default:
            // seconds (no unit)
            return number;
    }
}

function checkSessionExpiration(duration, lastMessageTimestamp, _lastTimestamp) {
    var durationMs = convertToSeconds(duration) * 1000;
    // never if no session duration in config
    if (!duration) {
        return false;
    }
    // TODO: Why? Let's use the time passed since the last message timestamp
    // return lastTimestamp - lastMessageTimestamp > durationMs;
    return +new Date() - lastMessageTimestamp > durationMs;
}

function useExternalScript(url) {
    require$$1.useEffect(function () {
        if (!url) {
            return;
        }
        var id = getSrcId(url);
        var existing = document.getElementById(id);
        if (!existing) {
            var script = document.createElement("script");
            script.id = id;
            script.src = url;
            script.crossOrigin = 'anonymous';
            document.head.appendChild(script);
        }
    }, [url]);
}
function getSafeCh(ch) {
    if (ch >= "0" && ch <= "9") {
        return ch;
    }
    if (ch >= "a" && ch <= "z") {
        return ch;
    }
    if (ch >= "A" && ch <= "Z") {
        return ch;
    }
    return "_".concat(ch.charCodeAt(0), "_");
}
function getSrcId(url) {
    var res = "es-";
    for (var i = 0; i < url.length; i++) {
        res += getSafeCh(url.charAt(i));
    }
    return res;
}

function useChatServerVisitorId() {
    var dispatch = useChatServerDispatch();
    var clientVisitorId = reactRedux.useSelector(function (state) {
        return state.visitorId || state.userId;
    });
    var visitorAccessToken = reactRedux.useSelector(function (state) { return state.accessToken; });
    var attributes = reactRedux.useSelector(function (state) { return state.attributes; });
    return require$$1.useMemo(function () { return ({
        dispatch: dispatch,
        visitorId: clientVisitorId,
        accessToken: visitorAccessToken,
        userId: clientVisitorId,
        attributes: attributes
    }); }, [dispatch, clientVisitorId, visitorAccessToken, attributes]);
}
//send whenever server settings or visitor id changes
function useGreeting(active) {
    var _a, _b;
    var curr = useChatServerVisitorId();
    var snapshotRef = require$$1.useRef(null);
    var ctx = require$$1.useContext(ChatConfigContext);
    // Handle null context (e.g., in preview mode)
    var isAdmin = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.env) === null || _a === void 0 ? void 0 : _a.isAdmin) !== null && _b !== void 0 ? _b : false;
    var sessionId = reactRedux.useSelector(function (state) { return state.sessionId; });
    require$$1.useEffect(function () {
        if (active) {
            if (snapshotRef.current !== curr) {
                snapshotRef.current = curr;
                if (curr.visitorId) {
                    curr.dispatch(sendVisitorInfo({
                        name: "Visitor",
                        visitorId: curr.visitorId,
                        userId: curr.userId,
                        accessToken: curr.accessToken,
                        attributes: __assign$1(__assign$1({}, curr.attributes), { currentUrl: window.location.href })
                    }, sessionId));
                    if (!isAdmin) {
                        var timeoutId_1 = setTimeout(function () {
                            var greetingAction = sendGreeting();
                            curr.dispatch(greetingAction);
                        }, 1000);
                        return function () {
                            clearTimeout(timeoutId_1);
                        };
                    }
                    else {
                        log$3("Admin widget. Not sending greeting.");
                    }
                }
            }
        }
        return undefined;
    }, [curr, active, isAdmin]);
}

function useSuggestionsFetch(search, context) {
    var env = useWidgetEnv();
    var baseUrl = env === null || env === void 0 ? void 0 : env.autocompleteSuggestionsUrl;
    return useSuggestionsFetch_1({
        url: baseUrl,
        query: search,
        context: context
    });
}

function norm(index, len) {
    return (index + len) % len;
}
function useSuggestions(search, context) {
    var _a = require$$1.useState(), suggestions = _a[0], setSuggestions = _a[1];
    var _b = require$$1.useState(-1), suggestionIndex = _b[0], setSuggestionIndex = _b[1];
    var _c = require$$1.useState(search), query = _c[0], setQuery = _c[1];
    var _d = require$$1.useState(context), contextState = _d[0], setContextState = _d[1];
    require$$1.useEffect(function () {
        setQuery(search);
    }, [search]);
    require$$1.useEffect(function () {
        setContextState(context);
    }, [context]);
    var suggestionItem = require$$1.useMemo(function () { return suggestions ? findItemByIndex_1(suggestions, suggestionIndex) : undefined; }, [suggestions, suggestionIndex]);
    var shift = require$$1.useCallback(function (delta) {
        if (suggestions) {
            var len_1 = getItemsLength_1(suggestions);
            setSuggestionIndex(function (index) { return norm(index + delta + ((index < 0 && delta <= 0) ? 1 : 0), len_1); });
        }
        else {
            setSuggestionIndex(-1);
        }
    }, [suggestions]);
    var execute = require$$1.useCallback(function (cmd) {
        switch (cmd) {
            case "prev":
                shift(-1);
                break;
            case "next":
                shift(1);
                break;
            case "cancel":
                setSuggestionIndex(-1);
                setQuery(undefined);
                setContextState(undefined);
                break;
        }
    }, [shift]);
    var suggestionsResponse = useSuggestionsFetch(query || "", contextState);
    var suggestionsData = suggestionsResponse.state === "success" ? suggestionsResponse.data : undefined;
    var raw = require$$1.useMemo(function () {
        return suggestionsData ?
            parseSuggestionsResponse_1(suggestionsData, -1).map(function (suggestion) {
                return {
                    heading: suggestion.heading,
                    items: suggestion.items.slice().reverse()
                };
            }) : undefined;
    }, [suggestionsData]);
    require$$1.useEffect(function () {
        var prev = suggestionItem;
        setSuggestions(raw);
        if (!prev || !raw) {
            setSuggestionIndex(-1);
        }
    }, [raw, suggestionItem]);
    return require$$1.useMemo(function () { return ({
        suggestions: suggestions,
        index: suggestionIndex,
        execute: execute,
        item: suggestionItem
    }); }, [suggestions, suggestionIndex, execute, suggestionItem]);
}

var AdminBar = function (_a) {
    var onAdminJoin = _a.onAdminJoin;
    var name = require$$1.useRef(null);
    // We can manage this locally
    // const hasAdminJoined = useSelector<ChatState, boolean | undefined>(state => state.hasAdminJoined);
    var _b = require$$1.useState(false), joined = _b[0], setJoined = _b[1];
    var _c = require$$1.useState(""), inputName = _c[0], setInputName = _c[1];
    function handleInputChange(event) {
        setInputName(event.target.value);
    }
    var disable = inputName === "" || inputName === undefined;
    var dispatch = useChatServerDispatch();
    function onSubmit(event) {
        var _a;
        event.preventDefault();
        if (!joined) {
            dispatch(sendBargeIn((_a = name.current) === null || _a === void 0 ? void 0 : _a.value));
            setJoined(true);
            onAdminJoin(true);
        }
        else {
            dispatch(sendBargeOut());
            setJoined(false);
            onAdminJoin(false);
            setInputName("");
        }
    }
    function renderJoin() {
        return (require$$0.jsxs("form", { className: "xappw-admin-input-form", onSubmit: onSubmit, children: [require$$0.jsx("div", { className: "xappw-admin-input-form__buttons", children: require$$0.jsx(ActionButton, { addClass: "xappw-admin-input-form__btn", type: "submit", label: "Join", disable: disable }) }), require$$0.jsx("div", { className: "xappw-admin-input", children: require$$0.jsx("input", { ref: name, id: "adminBarInput", placeholder: "Type your name here...", className: "xappw-admin-input__input", onChange: handleInputChange }) })] }));
    }
    function renderLeave() {
        return (require$$0.jsx("form", { className: "xappw-admin-input-form", onSubmit: onSubmit, children: require$$0.jsx("div", { className: "xappw-admin-input-form__buttons", children: require$$0.jsx(ActionButton, { addClass: "xappw-admin-input-form__btn", type: "submit", label: "Leave" }) }) }));
    }
    return (require$$0.jsx("div", { className: "xappw-admin-input-container visible", children: joined ? renderLeave() : renderJoin() }));
};

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = '';

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}

			return classes;
		}

		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}

			if (typeof arg !== 'object') {
				return '';
			}

			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}

			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}

			var classes = '';

			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}

			return classes;
		}

		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

var MarkdownBuilder = function (_a) {
    var text = _a.text, applyBrandingClass = _a.applyBrandingClass, linkColor = _a.linkColor;
    var containerClass = classNames({
        'chat-footer__branding': applyBrandingClass,
    });
    var linkRegex = /\[(.*?)\]\((.*?)\)/g;
    var boldRegex = /\*\*(.*?)\*\*/g;
    var headerRegex = /^(#{1,6}) (.*?)(?=\n|$)/gm;
    var parsedText = text.replace(linkRegex, function (_match, linkText, url) {
        return "<a style=\"color: ".concat(linkColor || '', "; text-decoration: underline;\" href=\"").concat(url, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(linkText, "</a>");
    }).replace(boldRegex, function (_match, boldText) {
        return "<b>".concat(boldText, "</b>");
    }).replace(headerRegex, function (_match, hashes, headerText) {
        var level = hashes.length;
        return "<h".concat(level, ">").concat(headerText, "</h").concat(level, ">");
    });
    return (require$$0.jsx("div", { className: containerClass, dangerouslySetInnerHTML: { __html: parsedText } }));
};

var ChatBranding = function (_a) {
    var text = _a.text;
    var regex = /\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/;
    var match = text === null || text === void 0 ? void 0 : text.match(regex);
    return match ? (require$$0.jsx(MarkdownBuilder, { text: text, applyBrandingClass: true, linkColor: "white" })) : (require$$0.jsx("div", { className: "chat-footer__branding", style: { color: "white" }, children: text }));
};

var CloseIcon = function () {
    // Sergey, I added this style, you will probably want to change it to be more appropriate
    return (require$$0.jsx("svg", { style: { color: "grey", paddingRight: "5px" }, xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: require$$0.jsx("path", { d: "M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" }) }));
};

var LeftDownArrowIcon = function () {
    return (require$$0.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16", children: require$$0.jsx("path", { fillRule: "evenodd", d: "M2 13.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 0-1H3.707L13.854 2.854a.5.5 0 0 0-.708-.708L3 12.293V7.5a.5.5 0 0 0-1 0v6z" }) }));
};

var SendIcon = function () {
    return (require$$0.jsx("svg", { viewBox: "80.208 98.129 313.069 282.823", xmlns: "http://www.w3.org/2000/svg", children: require$$0.jsxs("g", { transform: "matrix(0.024498, 0, 0, -0.038359, 79.83091, 381.182404)", fill: "currentColor", stroke: "none", children: [require$$0.jsx("path", { d: "M12670 7345 c-63 -18 -272 -77 -465 -130 -192 -53 -478 -132 -635 -175 -508 -141 -1091 -302 -2345 -649 -676 -187 -2038 -563 -3025 -836 -987 -273 -2072 -573 -2410 -666 -338 -94 -802 -222 -1030 -285 -1857 -514 -2579 -714 -2684 -742 -38 -10 -65 -21 -60 -24 5 -3 67 -22 139 -41 72 -20 326 -90 565 -157 239 -67 611 -170 825 -230 215 -60 586 -163 825 -230 239 -67 491 -137 560 -156 l126 -34 974 439 c1397 629 4128 1858 6050 2724 910 410 1826 822 2035 917 209 94 387 173 395 176 35 10 -66 -39 -8200 -3928 -586 -280 -1068 -512 -1071 -516 -3 -4 33 -117 82 -252 76 -213 355 -996 765 -2147 65 -183 120 -330 122 -329 1 2 114 558 250 1236 l248 1233 3455 2064 c1900 1135 3670 2193 3933 2351 264 158 491 293 505 301 62 33 -5 -12 -271 -182 -1671 -1070 -7188 -4613 -7188 -4617 0 -7 3661 -2455 3669 -2454 4 1 3713 6853 3977 7347 8 15 11 27 7 26 -5 0 -60 -15 -123 -34z" }), require$$0.jsx("path", { d: "M5030 2232 c-15 -61 -479 -1861 -531 -2058 -21 -83 -39 -154 -39 -158 0 -3 369 330 820 740 452 411 817 750 813 754 -11 10 -1025 754 -1039 763 -8 4 -16 -10 -24 -41z" })] }) }));
};

var SendButton = function (props) {
    var _a = props.disabled, disabled = _a === void 0 ? false : _a;
    var _b = require$$1.useState(false), isHovered = _b[0], setIsHovered = _b[1];
    // Determine which icon to show based on state
    var getIconSrc = function () {
        if (disabled && props.sendButtonIconDisabled) {
            return props.sendButtonIconDisabled;
        }
        if (isHovered && !disabled && props.sendButtonIconHover) {
            return props.sendButtonIconHover;
        }
        return props.sendButtonIcon;
    };
    return (require$$0.jsx(require$$0.Fragment, { children: !props.sendButtonIcon ? (require$$0.jsx(IconButton_1, { className: "xappw-send-button ".concat(props.className || "", " ").concat(disabled ? 'disabled' : ''), tabIndex: props.tabIndex, onClick: disabled ? undefined : props.onClick, icon: SendIcon })) : (require$$0.jsx("button", { className: "xappw-custom-send-button ".concat(disabled ? 'disabled' : ''), tabIndex: props.tabIndex ? Number(props.tabIndex) : 0, onClick: props.onClick, disabled: disabled, onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); }, children: require$$0.jsx("img", { src: getIconSrc(), alt: "Send button", draggable: false, className: "send-button-icon" }) })) }));
};

// Show counter when within this percentage of the limit
var COUNTER_THRESHOLD_PERCENT = 0.8;
var Input$4 = function (props) {
    var _a, _b;
    var value = props.value, placeholder = props.placeholder, sendButtonIcon = props.sendButtonIcon, sendButtonIconHover = props.sendButtonIconHover, sendButtonIconDisabled = props.sendButtonIconDisabled, suggestion = props.suggestion, footerConfig = props.footerConfig, inputConfig = props.inputConfig, onChange = props.onChange, onSubmit = props.onSubmit, onSuggestionCommand = props.onSuggestionCommand;
    var _c = require$$1.useState(false), dragover = _c[0], setDragover = _c[1];
    var maxLength = inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.maxLength;
    var currentLength = value.text.length;
    var isAtLimit = maxLength !== undefined && currentLength >= maxLength;
    var showCounter = maxLength !== undefined && currentLength >= maxLength * COUNTER_THRESHOLD_PERCENT;
    function onDragOver(event) {
        setDragover(true);
        event.preventDefault();
        event.dataTransfer.dropEffect = "copy";
    }
    function onDrop(event) {
        setDragover(false);
        props.onFileUpload(event);
    }
    function onDragLeave() {
        setDragover(false);
    }
    var handleOnSubmit = require$$1.useCallback(function (event) {
        event && event.preventDefault();
        onSubmit(value); // send to the widget
    }, [value, onSubmit]);
    var handleClear = require$$1.useCallback(function () {
        onChange({
            text: "",
            formats: [],
        });
    }, [onChange]);
    var handleKeyDown = require$$1.useCallback(function (event) {
        if (suggestion) {
            if (event.key === "End" || event.key === "ArrowRight" || event.key === "Enter") {
                onChange(suggestion);
                return;
            }
        }
        if (onSuggestionCommand) {
            if (event.key === "ArrowUp") {
                onSuggestionCommand("prev");
                event.preventDefault();
            }
            else if (event.key === "ArrowDown") {
                onSuggestionCommand("next");
                event.preventDefault();
            }
            else if (event.key === "Escape") {
                onSuggestionCommand("cancel");
                event.preventDefault();
            }
        }
    }, [suggestion, onChange, onSuggestionCommand]);
    return (require$$0.jsx("div", { className: "xappw-input-container ".concat(props.addClass, " ").concat(dragover ? "drag-drop-zone" : ""), "aria-label": "To start typing click on rounded rectangle at the bottom of widget. To send your message click icon on right side of rounded rectangle at the bottom of widget" +
            value.text
            ? "To clear input field click on clear icon on the left of send button"
            : "", "aria-hidden": false, onDrop: onDrop, onDragOver: onDragOver, onDragLeave: onDragLeave, children: require$$0.jsxs("form", { className: "xappw-input-form", onSubmit: handleOnSubmit, children: [require$$0.jsx(RichInput_1, { id: "chatWidgetInput", className: "xappw-input", placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "type your question here", tabIndex: inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.tabIndex, maxLength: maxLength, onInput: onChange, onChange: onChange, onKeyDown: handleKeyDown, 
                    // onFocus={onFocus}
                    value: value, spellCheck: true }, "input"), require$$0.jsxs("div", { className: "xappw-input-form__buttons", children: [showCounter && (require$$0.jsxs("span", { className: "xappw-input-form__counter".concat(isAtLimit ? " xappw-input-form__counter--limit" : ""), children: [currentLength, "/", maxLength] })), value.text && (require$$0.jsx(IconButton_1, { icon: CloseIcon, tabIndex: (_a = footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.clearButton) === null || _a === void 0 ? void 0 : _a.tabIndex, className: "xappw-input-form__btn", onClick: handleClear })), require$$0.jsx(SendButton, { className: "xappw-input-form__btn", sendButtonIcon: sendButtonIcon, sendButtonIconHover: sendButtonIconHover, sendButtonIconDisabled: sendButtonIconDisabled, tabIndex: (_b = footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.sendButton) === null || _b === void 0 ? void 0 : _b.tabIndex, disabled: !value.text, onClick: handleOnSubmit })] })] }) }));
};

function createActions(onItemUse) {
    return function (innerProps) {
        var data = innerProps.data;
        var canUse = data.type !== "FAQ";
        var handleUse = require$$1.useCallback(function (ev) {
            onItemUse(data);
            ev.stopPropagation();
        }, [data]);
        if (!canUse) {
            return require$$0.jsx(require$$0.Fragment, {});
        }
        return (require$$0.jsx(IconButton_1, { className: "xappw-suggestions__use", onClick: handleUse, icon: LeftDownArrowIcon }));
    };
}
var Suggestions = function (props) {
    var data = props.data, onItemUse = props.onItemUse, searchTerms = props.searchTerms;
    var _a = require$$1.useState(), fixedSuggestions = _a[0], setFixedSuggestions = _a[1];
    var _b = require$$1.useState(), activeItem = _b[0], setActiveItem = _b[1];
    require$$1.useEffect(function () {
        if (data) {
            setFixedSuggestions(data);
        }
        if (!searchTerms) {
            setFixedSuggestions(undefined);
            setActiveItem(undefined);
        }
    }, [data, searchTerms]);
    var len = data === null || data === void 0 ? void 0 : data.length;
    var currentIndex = len > 0 ? props.index : NaN;
    var item = require$$1.useMemo(function () { return findItemByIndex_1(data, currentIndex); }, [data, currentIndex]);
    var handleSpanClick = require$$1.useCallback(function (target, span) {
        if (span.type === "inputText") {
            onItemUse(target);
            setActiveItem(undefined);
            return false;
        }
        return undefined;
    }, [onItemUse]);
    require$$1.useEffect(function () {
        setActiveItem(item);
    }, [item]);
    var actions = require$$1.useMemo(function () { return createActions(onItemUse); }, [onItemUse]);
    var transformContent = function (content) {
        var lines = content.split('\n');
        return lines.map(function (line) {
            if (line) {
                return require$$0.jsx(MarkdownBuilder, { text: line });
            }
            return require$$0.jsx(require$$0.Fragment, {});
        });
    };
    var containerClass = "xappw-suggestions ".concat(props.className || "", " ").concat(props.hasWsButton ? "xappw-suggestions--with-ws-button" : "").trim();
    return (require$$0.jsxs("div", { className: containerClass, children: [(activeItem === null || activeItem === void 0 ? void 0 : activeItem.content) && require$$0.jsx("div", { className: "xappw-suggestions__answer", children: transformContent(activeItem.content) }), fixedSuggestions && fixedSuggestions.length > 0 &&
                require$$0.jsx(SuggestionsList_1, { suggestions: fixedSuggestions, index: currentIndex, className: "xappw-suggestions__groups", itemActions: actions, onItemClick: props.onItemClick, onItemHover: setActiveItem, onSpanClick: handleSpanClick })] }));
};

var ChatFooter = function (props) {
    var _a, _b, _c;
    var isAdmin = props.isAdmin, isChatting = props.isChatting, visible = props.visible, placeholder = props.placeholder, sendButtonIcon = props.sendButtonIcon, sendButtonIconHover = props.sendButtonIconHover, sendButtonIconDisabled = props.sendButtonIconDisabled, footerConfig = props.footerConfig, menuConfig = props.menuConfig, inputConfig = props.inputConfig, hasWsButton = props.hasWsButton, disabled = props.disabled, onSubmit = props.onSubmit;
    var innerDispatch = useChatDispatch();
    var _d = require$$1.useState(false), drawerOpen = _d[0], setDrawerState = _d[1]; // false initially
    var _e = require$$1.useState(), suggestionSearch = _e[0], setSuggestionSearch = _e[1];
    var contexts = reactRedux.useSelector(function (state) { return state.activeContexts; });
    var suggestions = useSuggestions(suggestionSearch, contexts);
    var menuPosition = (menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.menuButtonLocation) || "FOOTER";
    var showMenu = menuPosition === "FOOTER";
    var menuItemsRaw = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.items;
    var menuItemsTabIndex = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.itemsTabIndex;
    var menuButtonTabIndex = (_a = menuConfig === null || menuConfig === void 0 ? void 0 : menuConfig.button) === null || _a === void 0 ? void 0 : _a.tabIndex;
    var menuItems = require$$1.useMemo(function () { return menuItemsRaw ? menuItemsRaw : []; }, [menuItemsRaw]);
    var brandingEnabled = (_b = footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.branding) === null || _b === void 0 ? void 0 : _b.enabled;
    var brandingText = (_c = footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.branding) === null || _c === void 0 ? void 0 : _c.text;
    // If they are NOT an admin, automatically enabled the input
    var _f = require$$1.useState(!isAdmin), enableInput = _f[0], setEnableInput = _f[1];
    var _g = require$$1.useState({
        text: "",
        formats: []
    }), input = _g[0], setInput = _g[1];
    function toggleDrawer() {
        var newDrawer = !drawerOpen;
        setDrawerState(newDrawer);
        innerDispatch(setVisualStatus({
            drawer: newDrawer
        }));
    }
    function handleMenuItem(label) {
        setDrawerState(false);
        props.onSubmit(label);
    }
    function handleChange(val) {
        setInput(val);
        props.onChange(val.text);
        setSuggestionSearch(val.text);
    }
    // Clears out suggestion and input text
    var handleSubmit = require$$1.useCallback(function (message) {
        // Clears out the suggestions
        setSuggestionSearch("");
        // Clears out the input
        setInput({
            text: "",
            formats: []
        });
        onSubmit(message.text);
    }, [onSubmit]);
    var handleItemClick = require$$1.useCallback(function (data) {
        handleSubmit(data);
    }, [handleSubmit]);
    var handleItemUse = require$$1.useCallback(function (data) {
        setInput(data);
        setSuggestionSearch(data.text);
    }, []);
    var handleAdminJoin = function (status) {
        setEnableInput(status);
    };
    return (require$$0.jsxs("div", { className: "chat-footer background-footer", "aria-label": menuItems.length ? "to open menu click a button above the rounded rectangle at the bottom of widget" : "", "aria-hidden": false, children: [showMenu && menuItems.length ?
                require$$0.jsxs(require$$0.Fragment, { children: [drawerOpen ? require$$0.jsx(ChatMenu, { opened: drawerOpen, tabIndex: menuItemsTabIndex, onItemClick: handleMenuItem, items: menuItems }) : require$$0.jsx(require$$0.Fragment, {}), require$$0.jsx("div", { className: "chat-footer__menu-icon", children: require$$0.jsx(DrawerBars, { tabIndex: menuButtonTabIndex, onToggle: toggleDrawer }) })] }) : require$$0.jsx(require$$0.Fragment, {}), require$$0.jsx(Suggestions, { className: "xappw-chat-footer__suggestions", data: suggestions.suggestions, index: suggestions.index, searchTerms: suggestionSearch, hasWsButton: hasWsButton, onItemClick: handleItemClick, onItemUse: handleItemUse }), isAdmin && isChatting && visible && require$$0.jsx(AdminBar, { onAdminJoin: handleAdminJoin }), require$$0.jsx("div", { style: { pointerEvents: enableInput && !disabled ? "auto" : "none", opacity: enableInput ? 1 : 0.5 }, children: require$$0.jsx(Input$4, { addClass: "chat-footer__input " + (isChatting && visible ? "visible" : ""), suggestion: suggestions.item, value: input, placeholder: placeholder, sendButtonIcon: sendButtonIcon, sendButtonIconHover: sendButtonIconHover, sendButtonIconDisabled: sendButtonIconDisabled, footerConfig: footerConfig, inputConfig: inputConfig, onSubmit: handleSubmit, onChange: handleChange, onSuggestionCommand: suggestions.execute, 
                    // onFocus={this.inputOnFocus}
                    onFileUpload: props.onFileUpload }) }), brandingEnabled && brandingText && require$$0.jsx(ChatBranding, { text: brandingText })] }));
};

/**
 * Build the form-widget configuration from ActionBar button config
 */
function buildFormConfig(buttonConfig, widgetEnv) {
    var _a;
    // Option 1: Use dedicated form config if provided
    if (buttonConfig.formConfig) {
        return {
            api: buttonConfig.formConfig.api,
            intentId: buttonConfig.formConfig.intentId,
            autoGreeting: buttonConfig.formConfig.autoGreeting,
        };
    }
    // Option 2: Use shared chat-widget connection settings
    if ((_a = widgetEnv === null || widgetEnv === void 0 ? void 0 : widgetEnv.connection) === null || _a === void 0 ? void 0 : _a.serverUrl) {
        return {
            api: {
                url: widgetEnv.connection.serverUrl,
                key: widgetEnv.connection.accountKey,
            },
            intentId: buttonConfig.intentId,
            autoGreeting: buttonConfig.autoGreeting,
        };
    }
    // No valid configuration available
    return null;
}
var FormModal = function (_a) {
    var _b, _c;
    var config = _a.config, widgetEnv = _a.widgetEnv, onClose = _a.onClose;
    var modalRef = require$$1.useRef(null);
    var contentRef = require$$1.useRef(null);
    var formConfig = buildFormConfig(config, widgetEnv);
    var _d = require$$1.useState("idle"), loadingState = _d[0], setLoadingState = _d[1];
    var _e = require$$1.useState(""), errorMessage = _e[0], setErrorMessage = _e[1];
    // Get the form widget key from config or widgetEnv
    var formWidgetKey = ((_c = (_b = config.formConfig) === null || _b === void 0 ? void 0 : _b.api) === null || _c === void 0 ? void 0 : _c.key) || (widgetEnv === null || widgetEnv === void 0 ? void 0 : widgetEnv.formWidgetKey);
    // Attempt to load and open the form widget
    var attemptOpenFormWidget = require$$1.useCallback(function () { return __awaiter$1(void 0, void 0, void 0, function () {
        var options, opened, options, opened;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isFormWidgetReady()) return [3 /*break*/, 2];
                    options = config.preselectChipLabel
                        ? { preselectChipLabel: config.preselectChipLabel }
                        : undefined;
                    return [4 /*yield*/, openFormWidgetWhenReady(options, 5, 100)];
                case 1:
                    opened = _a.sent();
                    if (opened) {
                        setLoadingState("success");
                        onClose();
                        return [2 /*return*/];
                    }
                    _a.label = 2;
                case 2:
                    if (!formWidgetKey) return [3 /*break*/, 8];
                    setLoadingState("loading");
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 6, , 7]);
                    return [4 /*yield*/, loadFormWidgetScript(formWidgetKey)];
                case 4:
                    _a.sent();
                    options = config.preselectChipLabel
                        ? { preselectChipLabel: config.preselectChipLabel }
                        : undefined;
                    return [4 /*yield*/, openFormWidgetWhenReady(options, 30, 100)];
                case 5:
                    opened = _a.sent();
                    if (opened) {
                        setLoadingState("success");
                        onClose();
                    }
                    else {
                        setLoadingState("error");
                        setErrorMessage("Form widget loaded but failed to open. Please try again.");
                    }
                    return [3 /*break*/, 7];
                case 6:
                    _a.sent();
                    setLoadingState("error");
                    setErrorMessage("Failed to load form. Please check your connection and try again.");
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 9];
                case 8:
                    setLoadingState("error");
                    setErrorMessage("Form widget key not configured. Please contact support.");
                    _a.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    }); }, [config.preselectChipLabel, formWidgetKey, onClose]);
    // Attempt to open form widget on mount
    require$$1.useEffect(function () {
        attemptOpenFormWidget();
    }, [attemptOpenFormWidget]);
    // Handle Escape key to close
    require$$1.useEffect(function () {
        var handleKeyDown = function (event) {
            if (event.key === "Escape") {
                onClose();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return function () {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);
    // Prevent body scroll when modal is open
    require$$1.useEffect(function () {
        var originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return function () {
            document.body.style.overflow = originalOverflow;
        };
    }, []);
    // Focus trap - focus the modal content on mount
    require$$1.useEffect(function () {
        if (contentRef.current) {
            contentRef.current.focus();
        }
    }, []);
    var handleBackdropClick = require$$1.useCallback(function (event) {
        // Only close if clicking the backdrop, not the content
        if (event.target === modalRef.current) {
            onClose();
        }
    }, [onClose]);
    var handleRetry = require$$1.useCallback(function () {
        setLoadingState("idle");
        setErrorMessage("");
        attemptOpenFormWidget();
    }, [attemptOpenFormWidget]);
    // If form widget opened successfully, the modal will close automatically
    // Show loading/error states in the modal
    if (!formConfig && !formWidgetKey) {
        // No valid configuration available at all
        return (require$$0.jsx("div", { className: "xapp-form-modal", ref: modalRef, onClick: handleBackdropClick, role: "dialog", "aria-modal": "true", "aria-label": "Form", children: require$$0.jsxs("div", { className: "xapp-form-modal__content", ref: contentRef, tabIndex: -1, children: [require$$0.jsx("button", { className: "xapp-form-modal__close", onClick: onClose, "aria-label": "Close form", children: "\u00D7" }), require$$0.jsxs("div", { className: "xapp-form-modal__error", children: [require$$0.jsx("p", { children: "Form configuration not available." }), require$$0.jsx("p", { children: "Please configure the form button with valid settings." })] })] }) }));
    }
    return (require$$0.jsx("div", { className: "xapp-form-modal", ref: modalRef, onClick: handleBackdropClick, role: "dialog", "aria-modal": "true", "aria-label": "Form", children: require$$0.jsxs("div", { className: "xapp-form-modal__content", ref: contentRef, tabIndex: -1, children: [require$$0.jsx("button", { className: "xapp-form-modal__close", onClick: onClose, "aria-label": "Close form", children: "\u00D7" }), require$$0.jsxs("div", { className: "xapp-form-modal__form-container", children: [loadingState === "loading" && (require$$0.jsxs("div", { className: "xapp-form-modal__loading", children: [require$$0.jsx("div", { className: "xapp-form-modal__spinner", "aria-hidden": "true" }), require$$0.jsx("p", { children: "Loading form..." })] })), loadingState === "error" && (require$$0.jsxs("div", { className: "xapp-form-modal__error", children: [require$$0.jsx("p", { children: errorMessage }), require$$0.jsx("button", { className: "xapp-form-modal__retry", onClick: handleRetry, children: "Try Again" })] })), loadingState === "idle" && (require$$0.jsxs("div", { className: "xapp-form-modal__loading", children: [require$$0.jsx("div", { className: "xapp-form-modal__spinner", "aria-hidden": "true" }), require$$0.jsx("p", { children: "Initializing..." })] }))] })] }) }));
};

var noop$5 = function () { };
var MiddlewareContextFactory = /** @class */ (function () {
    function MiddlewareContextFactory(template) {
        this.cache = {};
        this.template = template;
    }
    MiddlewareContextFactory.prototype.resolve = function (user) {
        var _a, _b, _c;
        if (!user) {
            return undefined;
        }
        var cache = this.cache;
        var key = user.nick;
        var val = cache[key];
        if (!val) {
            val = {
                user: user,
                send: (_a = this.template.send) !== null && _a !== void 0 ? _a : noop$5,
                write: (_b = this.template.write) !== null && _b !== void 0 ? _b : noop$5,
                openUrl: (_c = this.template.openUrl) !== null && _c !== void 0 ? _c : noop$5
            };
            cache[key] = val;
        }
        return val;
    };
    return MiddlewareContextFactory;
}());

var CardContainer = function (props) {
    function renderIcon() {
        var isString = typeof props.icon === "string";
        return require$$0.jsx("div", { className: "card-container__icon", children: !isString && props.icon });
    }
    return (require$$0.jsxs("div", { className: "card-container ".concat(props.addClass), children: [renderIcon(), require$$0.jsxs("div", { className: "card-container__content ".concat(props.contentAddClass), children: [require$$0.jsx("div", { className: "card-container__title", children: props.title }), props.children] })] }));
};

var ChatRating = function (_a) {
    var _b = _a.agent, agent = _b === void 0 ? {} : _b, _c = _a.hasRating, hasRating = _c === void 0 ? false : _c, _d = _a.shouldDisplay, shouldDisplay = _d === void 0 ? true : _d, _e = _a.onRate, onRate = _e === void 0 ? function () {
        // no-op
    } : _e;
    var rateBadButtonOnClick = require$$1.useCallback(function () {
        onRate("bad");
    }, [onRate]);
    var rateGoodButtonOnClick = require$$1.useCallback(function () {
        onRate("good");
    }, [onRate]);
    var rateAgainButtonOnClick = require$$1.useCallback(function () {
        onRate(undefined);
    }, [onRate]);
    // Do not think this prop should be here
    if (!shouldDisplay) {
        return null;
    }
    if (!hasRating) {
        return (require$$0.jsxs(CardContainer, { title: "Chat Rating", addClass: "chat-rating-card", children: [agent.displayName, " has requested you to rate the chat service.", require$$0.jsxs("div", { className: "buttons-container", children: [require$$0.jsx(ActionButton, { addClass: "button button-rate-bad", label: "Rate Bad", onClick: rateBadButtonOnClick }), require$$0.jsx(ActionButton, { addClass: "button button-rate-good", label: "Rate Good", onClick: rateGoodButtonOnClick })] })] }));
    }
    else {
        return (require$$0.jsxs(CardContainer, { title: "Chat Rating", addClass: "chat-rating-card", children: ["You have rated the chat service.", require$$0.jsx("div", { className: "buttons-container", children: require$$0.jsx(ActionButton, { addClass: "button button-rate-again", label: "Rate again", onClick: rateAgainButtonOnClick }) })] }));
    }
};

var ChatRatingContainer = function (props) {
    var dispatch = useChatServerDispatch();
    var handleRate = require$$1.useCallback(function (rating) {
        dispatch(sendChatRating(rating));
    }, [dispatch]);
    return (require$$0.jsxs(require$$0.Fragment, { children: [require$$0.jsx("span", { className: "message-sr-only", children: "at " + props.time + " system message" }), require$$0.jsx(ChatRating, { agent: props.agent, hasRating: props.hasRating, shouldDisplay: props.shouldDisplay, onRate: handleRate })] }));
};

var dateFns$1 = {};

var interopRequireDefault = {exports: {}};

(function (module) {
	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (interopRequireDefault));

var interopRequireDefaultExports = interopRequireDefault.exports;

var add$2 = {exports: {}};

var _typeof$13 = {exports: {}};

(function (module) {
	function _typeof(o) {
	  "@babel/helpers - typeof";

	  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (_typeof$13));

var _typeofExports = _typeof$13.exports;

var addDays$2 = {exports: {}};

var toInteger$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = toInteger;
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	  var number = Number(dirtyNumber);
	  if (isNaN(number)) {
	    return number;
	  }
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	module.exports = exports$1.default; 
} (toInteger$2, toInteger$2.exports));

var toIntegerExports = toInteger$2.exports;

var toDate$2 = {exports: {}};

var requiredArgs = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = requiredArgs;
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	module.exports = exports$1.default; 
} (requiredArgs, requiredArgs.exports));

var requiredArgsExports = requiredArgs.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = toDate;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument);

	  // Clone the date
	  if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
	      // eslint-disable-next-line no-console
	      console.warn(new Error().stack);
	    }
	    return new Date(NaN);
	  }
	}
	module.exports = exports$1.default; 
} (toDate$2, toDate$2.exports));

var toDateExports = toDate$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addDays;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} - the new date with the days added
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * const result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	module.exports = exports$1.default; 
} (addDays$2, addDays$2.exports));

var addDaysExports = addDays$2.exports;

var addMonths$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addMonths;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * const result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  var dayOfMonth = date.getDate();

	  // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	module.exports = exports$1.default; 
} (addMonths$2, addMonths$2.exports));

var addMonthsExports = addMonths$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = add;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(addDaysExports);
	var _index2 = _interopRequireDefault(addMonthsExports);
	var _index3 = _interopRequireDefault(toDateExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var _index5 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name add
	 * @category Common Helpers
	 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @description
	 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 *
	 * | Key            | Description                        |
	 * |----------------|------------------------------------|
	 * | years          | Amount of years to be added        |
	 * | months         | Amount of months to be added       |
	 * | weeks          | Amount of weeks to be added        |
	 * | days           | Amount of days to be added         |
	 * | hours          | Amount of hours to be added        |
	 * | minutes        | Amount of minutes to be added      |
	 * | seconds        | Amount of seconds to be added      |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add the following duration to 1 September 2014, 10:19:50
	 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30,
	 * })
	 * //=> Thu Jun 15 2017 15:29:20
	 */
	function add(dirtyDate, duration) {
	  (0, _index4.default)(2, arguments);
	  if (!duration || (0, _typeof2.default)(duration) !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index5.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index5.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index5.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index5.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index5.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index5.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index5.default)(duration.seconds) : 0;

	  // Add years and months
	  var date = (0, _index3.default)(dirtyDate);
	  var dateWithMonths = months || years ? (0, _index2.default)(date, months + years * 12) : date;

	  // Add weeks and days
	  var dateWithDays = days || weeks ? (0, _index.default)(dateWithMonths, days + weeks * 7) : dateWithMonths;

	  // Add days, hours, minutes and seconds
	  var minutesToAdd = minutes + hours * 60;
	  var secondsToAdd = seconds + minutesToAdd * 60;
	  var msToAdd = secondsToAdd * 1000;
	  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
	  return finalDate;
	}
	module.exports = exports$1.default; 
} (add$2, add$2.exports));

var addExports = add$2.exports;

var addBusinessDays$2 = {exports: {}};

var isWeekend$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isWeekend;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isWeekend
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date falls on a weekend
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * const result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day === 0 || day === 6;
	}
	module.exports = exports$1.default; 
} (isWeekend$2, isWeekend$2.exports));

var isWeekendExports = isWeekend$2.exports;

var isSunday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSunday;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSunday
	 * @category Weekday Helpers
	 * @summary Is the given date Sunday?
	 *
	 * @description
	 * Is the given date Sunday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 21 September 2014 Sunday?
	 * const result = isSunday(new Date(2014, 8, 21))
	 * //=> true
	 */
	function isSunday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 0;
	}
	module.exports = exports$1.default; 
} (isSunday$2, isSunday$2.exports));

var isSundayExports = isSunday$2.exports;

var isSaturday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSaturday;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSaturday
	 * @category Weekday Helpers
	 * @summary Is the given date Saturday?
	 *
	 * @description
	 * Is the given date Saturday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 27 September 2014 Saturday?
	 * const result = isSaturday(new Date(2014, 8, 27))
	 * //=> true
	 */
	function isSaturday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 6;
	}
	module.exports = exports$1.default; 
} (isSaturday$2, isSaturday$2.exports));

var isSaturdayExports = isSaturday$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addBusinessDays;
	var _index = _interopRequireDefault(isWeekendExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var _index5 = _interopRequireDefault(isSundayExports);
	var _index6 = _interopRequireDefault(isSaturdayExports);
	/**
	 * @name addBusinessDays
	 * @category Day Helpers
	 * @summary Add the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 business days to 1 September 2014:
	 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
	 */
	function addBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var startedOnWeekend = (0, _index.default)(date);
	  var amount = (0, _index3.default)(dirtyAmount);
	  if (isNaN(amount)) return new Date(NaN);
	  var hours = date.getHours();
	  var sign = amount < 0 ? -1 : 1;
	  var fullWeeks = (0, _index3.default)(amount / 5);
	  date.setDate(date.getDate() + fullWeeks * 7);

	  // Get remaining days not part of a full week
	  var restDays = Math.abs(amount % 5);

	  // Loops over remaining days
	  while (restDays > 0) {
	    date.setDate(date.getDate() + sign);
	    if (!(0, _index.default)(date)) restDays -= 1;
	  }

	  // If the date is a weekend day and we reduce a dividable of
	  // 5 from it, we land on a weekend date.
	  // To counter this, we add days accordingly to land on the next business day
	  if (startedOnWeekend && (0, _index.default)(date) && amount !== 0) {
	    // If we're reducing days, we want to add days until we land on a weekday
	    // If we're adding days we want to reduce days until we land on a weekday
	    if ((0, _index6.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
	    if ((0, _index5.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
	  }

	  // Restore hours to avoid DST lag
	  date.setHours(hours);
	  return date;
	}
	module.exports = exports$1.default; 
} (addBusinessDays$2, addBusinessDays$2.exports));

var addBusinessDaysExports = addBusinessDays$2.exports;

var addHours$2 = {exports: {}};

var addMilliseconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addMilliseconds;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	module.exports = exports$1.default; 
} (addMilliseconds$2, addMilliseconds$2.exports));

var addMillisecondsExports = addMilliseconds$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addHours;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addMillisecondsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_HOUR = 3600000;

	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	module.exports = exports$1.default; 
} (addHours$2, addHours$2.exports));

var addHoursExports = addHours$2.exports;

var addISOWeekYears$2 = {exports: {}};

var getISOWeekYear$2 = {exports: {}};

var startOfISOWeek$2 = {exports: {}};

var startOfWeek$2 = {exports: {}};

var defaultOptions$1$1 = {};

Object.defineProperty(defaultOptions$1$1, "__esModule", {
  value: true
});
defaultOptions$1$1.getDefaultOptions = getDefaultOptions$1$1;
defaultOptions$1$1.setDefaultOptions = setDefaultOptions$1$1;
var defaultOptions$3 = {};
function getDefaultOptions$1$1() {
  return defaultOptions$3;
}
function setDefaultOptions$1$1(newOptions) {
  defaultOptions$3 = newOptions;
}

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(toIntegerExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var _index4 = defaultOptions$1$1;
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index3.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfWeek$2, startOfWeek$2.exports));

var startOfWeekExports = startOfWeek$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfISOWeek;
	var _index = _interopRequireDefault(startOfWeekExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports$1.default; 
} (startOfISOWeek$2, startOfISOWeek$2.exports));

var startOfISOWeekExports = startOfISOWeek$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getISOWeekYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(startOfISOWeekExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeekYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports$1.default; 
} (getISOWeekYear$2, getISOWeekYear$2.exports));

var getISOWeekYearExports = getISOWeekYear$2.exports;

var setISOWeekYear$2 = {exports: {}};

var startOfISOWeekYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfISOWeekYear;
	var _index = _interopRequireDefault(getISOWeekYearExports);
	var _index2 = _interopRequireDefault(startOfISOWeekExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfISOWeekYear$2, startOfISOWeekYear$2.exports));

var startOfISOWeekYearExports = startOfISOWeekYear$2.exports;

var differenceInCalendarDays$2 = {exports: {}};

var getTimezoneOffsetInMilliseconds$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getTimezoneOffsetInMilliseconds;
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	function getTimezoneOffsetInMilliseconds(date) {
	  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	  utcDate.setUTCFullYear(date.getFullYear());
	  return date.getTime() - utcDate.getTime();
	}
	module.exports = exports$1.default; 
} (getTimezoneOffsetInMilliseconds$2, getTimezoneOffsetInMilliseconds$2.exports));

var getTimezoneOffsetInMillisecondsExports = getTimezoneOffsetInMilliseconds$2.exports;

var startOfDay$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfDay;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfDay$2, startOfDay$2.exports));

var startOfDayExports = startOfDay$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInCalendarDays;
	var _index = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index2 = _interopRequireDefault(startOfDayExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_DAY = 86400000;

	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight);

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	module.exports = exports$1.default; 
} (differenceInCalendarDays$2, differenceInCalendarDays$2.exports));

var differenceInCalendarDaysExports = differenceInCalendarDays$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setISOWeekYear;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(startOfISOWeekYearExports);
	var _index4 = _interopRequireDefault(differenceInCalendarDaysExports);
	var _index5 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Set the ISO week-numbering year to the given date.
	 *
	 * @description
	 * Set the ISO week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
	 * @returns {Date} the new date with the ISO week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set ISO week-numbering year 2007 to 29 December 2008:
	 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
	 * //=> Mon Jan 01 2007 00:00:00
	 */
	function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeekYear = (0, _index.default)(dirtyISOWeekYear);
	  var diff = (0, _index4.default)(date, (0, _index3.default)(date));
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  date = (0, _index3.default)(fourthOfJanuary);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	module.exports = exports$1.default; 
} (setISOWeekYear$2, setISOWeekYear$2.exports));

var setISOWeekYearExports = setISOWeekYear$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addISOWeekYears;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(getISOWeekYearExports);
	var _index3 = _interopRequireDefault(setISOWeekYearExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name addISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Add the specified number of ISO week-numbering years to the given date.
	 *
	 * @description
	 * Add the specified number of ISO week-numbering years to the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 ISO week-numbering years to 2 July 2010:
	 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
	 * //=> Fri Jun 26 2015 00:00:00
	 */
	function addISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index3.default)(dirtyDate, (0, _index2.default)(dirtyDate) + amount);
	}
	module.exports = exports$1.default; 
} (addISOWeekYears$2, addISOWeekYears$2.exports));

var addISOWeekYearsExports = addISOWeekYears$2.exports;

var addMinutes$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addMinutes;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addMillisecondsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_MINUTE = 60000;

	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	module.exports = exports$1.default; 
} (addMinutes$2, addMinutes$2.exports));

var addMinutesExports = addMinutes$2.exports;

var addQuarters$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addQuarters;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addMonthsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name addQuarters
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * const result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var months = amount * 3;
	  return (0, _index2.default)(dirtyDate, months);
	}
	module.exports = exports$1.default; 
} (addQuarters$2, addQuarters$2.exports));

var addQuartersExports = addQuarters$2.exports;

var addSeconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addSeconds;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addMillisecondsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name addSeconds
	 * @category Second Helpers
	 * @summary Add the specified number of seconds to the given date.
	 *
	 * @description
	 * Add the specified number of seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 seconds to 10 July 2014 12:45:00:
	 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:45:30
	 */
	function addSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 1000);
	}
	module.exports = exports$1.default; 
} (addSeconds$2, addSeconds$2.exports));

var addSecondsExports = addSeconds$2.exports;

var addWeeks$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addWeeks;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addDaysExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * const result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	module.exports = exports$1.default; 
} (addWeeks$2, addWeeks$2.exports));

var addWeeksExports = addWeeks$2.exports;

var addYears$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addYears;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addMonthsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * const result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	module.exports = exports$1.default; 
} (addYears$2, addYears$2.exports));

var addYearsExports = addYears$2.exports;

var areIntervalsOverlapping$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = areIntervalsOverlapping;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name areIntervalsOverlapping
	 * @category Interval Helpers
	 * @summary Is the given time interval overlapping with another time interval?
	 *
	 * @description
	 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
	 * @returns {Boolean} whether the time intervals are overlapping
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // For adjacent time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // Using the inclusive option:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
	 * )
	 * //=> false
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
	 *   { inclusive: true }
	 * )
	 * //=> true
	 */
	function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
	  (0, _index2.default)(2, arguments);
	  var leftStartTime = (0, _index.default)(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.end).getTime();

	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  if (options !== null && options !== void 0 && options.inclusive) {
	    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
	  }
	  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	}
	module.exports = exports$1.default; 
} (areIntervalsOverlapping$2, areIntervalsOverlapping$2.exports));

var areIntervalsOverlappingExports = areIntervalsOverlapping$2.exports;

var clamp$2 = {exports: {}};

var max$6 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = max;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * const result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;

	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports$1.default; 
} (max$6, max$6.exports));

var maxExports = max$6.exports;

var min$6 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = min;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Returns the earliest of the given dates.
	 *
	 * @description
	 * Returns the earliest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} - the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * const result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports$1.default; 
} (min$6, min$6.exports));

var minExports = min$6.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = clamp;
	var _index = _interopRequireDefault(maxExports);
	var _index2 = _interopRequireDefault(minExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name clamp
	 * @category Interval Helpers
	 * @summary Return a date bounded by the start and the end of the given interval
	 *
	 * @description
	 * Clamps a date to the lower bound with the start of the interval and the upper
	 * bound with the end of the interval.
	 *
	 * - When the date is less than the start of the interval, the start is returned.
	 * - When the date is greater than the end of the interval, the end is returned.
	 * - Otherwise the date is returned.
	 *
	 * @example
	 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
	 * const result = clamp(new Date(2021, 2, 21), {
	 *   start: new Date(2021, 2, 22),
	 *   end: new Date(2021, 3, 1),
	 * })
	 * //=> Mon Mar 22 2021 00:00:00
	 *
	 * @param {Date | Number} date - the date to be bounded
	 * @param {Interval} interval - the interval to bound to
	 * @returns {Date} the date bounded by the start and the end of the interval
	 * @throws {TypeError} 2 arguments required
	 */
	function clamp(date, _ref) {
	  var start = _ref.start,
	    end = _ref.end;
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)([(0, _index.default)([date, start]), end]);
	}
	module.exports = exports$1.default; 
} (clamp$2, clamp$2.exports));

var clampExports = clamp$2.exports;

var closestIndexTo$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = closestIndexTo;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name closestIndexTo
	 * @category Common Helpers
	 * @summary Return an index of the closest date from the array comparing to the given date.
	 *
	 * @description
	 * Return an index of the closest date from the array comparing to the given date.
	 *
	 * @param {Date | Number} dateToCompare - the date to compare with
	 * @param {Array<Date> | Array<number>} datesArray - the array to search
	 * @returns {Number | undefined} an index of the date closest to the given date or undefined if no valid value is given
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015?
	 * const dateToCompare = new Date(2015, 8, 6)
	 * const datesArray = [
	 *   new Date(2015, 0, 1),
	 *   new Date(2016, 0, 1),
	 *   new Date(2017, 0, 1)
	 * ]
	 * const result = closestIndexTo(dateToCompare, datesArray)
	 * //=> 1
	 */
	function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  if (isNaN(Number(dateToCompare))) return NaN;
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray;
	  // `dirtyDatesArray` is undefined or null
	  if (dirtyDatesArray == null) {
	    datesArray = [];

	    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;

	    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate, index) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (isNaN(Number(currentDate))) {
	      result = NaN;
	      minDistance = NaN;
	      return;
	    }
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	    if (result == null || distance < Number(minDistance)) {
	      result = index;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	module.exports = exports$1.default; 
} (closestIndexTo$2, closestIndexTo$2.exports));

var closestIndexToExports = closestIndexTo$2.exports;

var closestTo$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = closestTo;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name closestTo
	 * @category Common Helpers
	 * @summary Return a date from the array closest to the given date.
	 *
	 * @description
	 * Return a date from the array closest to the given date.
	 *
	 * @param {Date | Number} dateToCompare - the date to compare with
	 * @param {Array<Date> | Array<number>} datesArray - the array to search
	 * @returns {Date | undefined} the date from the array closest to the given date or undefined if no valid value is given
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
	 * const dateToCompare = new Date(2015, 8, 6)
	 * const result = closestTo(dateToCompare, [
	 *   new Date(2000, 0, 1),
	 *   new Date(2030, 0, 1)
	 * ])
	 * //=> Tue Jan 01 2030 00:00:00
	 */
	function closestTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  if (isNaN(Number(dateToCompare))) return new Date(NaN);
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray;
	  // `dirtyDatesArray` is undefined or null
	  if (dirtyDatesArray == null) {
	    datesArray = [];

	    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;

	    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (isNaN(Number(currentDate))) {
	      result = new Date(NaN);
	      minDistance = NaN;
	      return;
	    }
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	    if (result == null || distance < Number(minDistance)) {
	      result = currentDate;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	module.exports = exports$1.default; 
} (closestTo$2, closestTo$2.exports));

var closestToExports = closestTo$2.exports;

var compareAsc$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = compareAsc;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name compareAsc
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1;
	    // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	module.exports = exports$1.default; 
} (compareAsc$2, compareAsc$2.exports));

var compareAscExports = compareAsc$2.exports;

var compareDesc$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = compareDesc;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name compareDesc
	 * @category Common Helpers
	 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return -1 if the first date is after the second,
	 * 1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
	 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> 1
	 *
	 * @example
	 * // Sort the array of dates in reverse chronological order:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareDesc)
	 * //=> [
	 * //   Sun Jul 02 1995 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Wed Feb 11 1987 00:00:00
	 * // ]
	 */
	function compareDesc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	  if (diff > 0) {
	    return -1;
	  } else if (diff < 0) {
	    return 1;
	    // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	module.exports = exports$1.default; 
} (compareDesc$2, compareDesc$2.exports));

var compareDescExports = compareDesc$2.exports;

var daysToWeeks$2 = {exports: {}};

var constants$1$1 = {};

Object.defineProperty(constants$1$1, "__esModule", {
  value: true
});
constants$1$1.secondsInYear = constants$1$1.secondsInWeek = constants$1$1.secondsInQuarter = constants$1$1.secondsInMonth = constants$1$1.secondsInMinute = constants$1$1.secondsInHour = constants$1$1.secondsInDay = constants$1$1.quartersInYear = constants$1$1.monthsInYear = constants$1$1.monthsInQuarter = constants$1$1.minutesInHour = constants$1$1.minTime = constants$1$1.millisecondsInSecond = constants$1$1.millisecondsInMinute = constants$1$1.millisecondsInHour = constants$1$1.maxTime = constants$1$1.daysInYear = constants$1$1.daysInWeek = void 0;
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;

/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.daysInWeek = daysInWeek;
var daysInYear$1 = 365.2425;

/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.daysInYear = daysInYear$1;
var maxTime$1 = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.maxTime = maxTime$1;
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.millisecondsInMinute = millisecondsInMinute;
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.millisecondsInHour = millisecondsInHour;
var millisecondsInSecond = 1000;

/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.millisecondsInSecond = millisecondsInSecond;
var minTime = -maxTime$1;

/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.minTime = minTime;
var minutesInHour = 60;

/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.minutesInHour = minutesInHour;
var monthsInQuarter = 3;

/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.monthsInQuarter = monthsInQuarter;
var monthsInYear = 12;

/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.monthsInYear = monthsInYear;
var quartersInYear = 4;

/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.quartersInYear = quartersInYear;
var secondsInHour$1 = 3600;

/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.secondsInHour = secondsInHour$1;
var secondsInMinute = 60;

/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.secondsInMinute = secondsInMinute;
var secondsInDay$1 = secondsInHour$1 * 24;

/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.secondsInDay = secondsInDay$1;
var secondsInWeek = secondsInDay$1 * 7;

/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.secondsInWeek = secondsInWeek;
var secondsInYear$1 = secondsInDay$1 * daysInYear$1;

/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.secondsInYear = secondsInYear$1;
var secondsInMonth$1 = secondsInYear$1 / 12;

/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */
constants$1$1.secondsInMonth = secondsInMonth$1;
var secondsInQuarter = secondsInMonth$1 * 3;
constants$1$1.secondsInQuarter = secondsInQuarter;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = daysToWeeks;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name daysToWeeks
	 * @category Conversion Helpers
	 * @summary Convert days to weeks.
	 *
	 * @description
	 * Convert a number of days to a full number of weeks.
	 *
	 * @param {number} days - number of days to be converted
	 *
	 * @returns {number} the number of days converted in weeks
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 14 days to weeks:
	 * const result = daysToWeeks(14)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = daysToWeeks(13)
	 * //=> 1
	 */
	function daysToWeeks(days) {
	  (0, _index.default)(1, arguments);
	  var weeks = days / _index2.daysInWeek;
	  return Math.floor(weeks);
	}
	module.exports = exports$1.default; 
} (daysToWeeks$2, daysToWeeks$2.exports));

var daysToWeeksExports = daysToWeeks$2.exports;

var differenceInBusinessDays$2 = {exports: {}};

var isSameDay$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameDay;
	var _index = _interopRequireDefault(startOfDayExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day (and year and month)?
	 *
	 * @description
	 * Are the given dates in the same day (and year and month)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day (and year and month)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 *
	 * @example
	 * // Are 4 September and 4 October in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
	 * //=> false
	 *
	 * @example
	 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
	 * //=> false
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	module.exports = exports$1.default; 
} (isSameDay$2, isSameDay$2.exports));

var isSameDayExports = isSameDay$2.exports;

var isValid$2 = {exports: {}};

var isDate$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isDate;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * const result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * const result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * const result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * const result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	module.exports = exports$1.default; 
} (isDate$2, isDate$2.exports));

var isDateExports = isDate$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isValid;
	var _index = _interopRequireDefault(isDateExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * const result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
	    return false;
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  return !isNaN(Number(date));
	}
	module.exports = exports$1.default; 
} (isValid$2, isValid$2.exports));

var isValidExports = isValid$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInBusinessDays;
	var _index = _interopRequireDefault(addDaysExports);
	var _index2 = _interopRequireDefault(differenceInCalendarDaysExports);
	var _index3 = _interopRequireDefault(isSameDayExports);
	var _index4 = _interopRequireDefault(isValidExports);
	var _index5 = _interopRequireDefault(isWeekendExports);
	var _index6 = _interopRequireDefault(toDateExports);
	var _index7 = _interopRequireDefault(requiredArgsExports);
	var _index8 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name differenceInBusinessDays
	 * @category Day Helpers
	 * @summary Get the number of business days between the given dates.
	 *
	 * @description
	 * Get the number of business day periods between the given dates.
	 * Business days being days that arent in the weekend.
	 * Like `differenceInCalendarDays`, the function removes the times from
	 * the dates before calculating the difference.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of business days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many business days are between
	 * // 10 January 2014 and 20 July 2014?
	 * const result = differenceInBusinessDays(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 0, 10)
	 * )
	 * //=> 136
	 *
	 * // How many business days are between
	 * // 30 November 2021 and 1 November 2021?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 30),
	 *   new Date(2021, 10, 1)
	 * )
	 * //=> 21
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 1 December 2021?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 11, 1)
	 * )
	 * //=> -22
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 1 November 2021 ?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 10, 1)
	 * )
	 * //=> 0
	 */
	function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index7.default)(2, arguments);
	  var dateLeft = (0, _index6.default)(dirtyDateLeft);
	  var dateRight = (0, _index6.default)(dirtyDateRight);
	  if (!(0, _index4.default)(dateLeft) || !(0, _index4.default)(dateRight)) return NaN;
	  var calendarDifference = (0, _index2.default)(dateLeft, dateRight);
	  var sign = calendarDifference < 0 ? -1 : 1;
	  var weeks = (0, _index8.default)(calendarDifference / 7);
	  var result = weeks * 5;
	  dateRight = (0, _index.default)(dateRight, weeks * 7);

	  // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
	  while (!(0, _index3.default)(dateLeft, dateRight)) {
	    // sign is used to account for both negative and positive differences
	    result += (0, _index5.default)(dateRight) ? 0 : sign;
	    dateRight = (0, _index.default)(dateRight, sign);
	  }
	  return result === 0 ? 0 : result;
	}
	module.exports = exports$1.default; 
} (differenceInBusinessDays$2, differenceInBusinessDays$2.exports));

var differenceInBusinessDaysExports = differenceInBusinessDays$2.exports;

var differenceInCalendarISOWeekYears$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInCalendarISOWeekYears;
	var _index = _interopRequireDefault(getISOWeekYearExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name differenceInCalendarISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
	 * const result = differenceInCalendarISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft) - (0, _index.default)(dirtyDateRight);
	}
	module.exports = exports$1.default; 
} (differenceInCalendarISOWeekYears$2, differenceInCalendarISOWeekYears$2.exports));

var differenceInCalendarISOWeekYearsExports = differenceInCalendarISOWeekYears$2.exports;

var differenceInCalendarISOWeeks$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInCalendarISOWeeks;
	var _index = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index2 = _interopRequireDefault(startOfISOWeekExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_WEEK = 604800000;

	/**
	 * @name differenceInCalendarISOWeeks
	 * @category ISO Week Helpers
	 * @summary Get the number of calendar ISO weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO weeks between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
	 * const result = differenceInCalendarISOWeeks(
	 *   new Date(2014, 6, 21),
	 *   new Date(2014, 6, 6)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfISOWeekLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfISOWeekRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfISOWeekLeft.getTime() - (0, _index.default)(startOfISOWeekLeft);
	  var timestampRight = startOfISOWeekRight.getTime() - (0, _index.default)(startOfISOWeekRight);

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	module.exports = exports$1.default; 
} (differenceInCalendarISOWeeks$2, differenceInCalendarISOWeeks$2.exports));

var differenceInCalendarISOWeeksExports = differenceInCalendarISOWeeks$2.exports;

var differenceInCalendarMonths$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInCalendarMonths;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	module.exports = exports$1.default; 
} (differenceInCalendarMonths$2, differenceInCalendarMonths$2.exports));

var differenceInCalendarMonthsExports = differenceInCalendarMonths$2.exports;

var differenceInCalendarQuarters$2 = {exports: {}};

var getQuarter$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getQuarter;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * const result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	module.exports = exports$1.default; 
} (getQuarter$2, getQuarter$2.exports));

var getQuarterExports = getQuarter$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInCalendarQuarters;
	var _index = _interopRequireDefault(getQuarterExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name differenceInCalendarQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of calendar quarters between the given dates.
	 *
	 * @description
	 * Get the number of calendar quarters between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
	 * const result = differenceInCalendarQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index2.default)(dirtyDateLeft);
	  var dateRight = (0, _index2.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var quarterDiff = (0, _index.default)(dateLeft) - (0, _index.default)(dateRight);
	  return yearDiff * 4 + quarterDiff;
	}
	module.exports = exports$1.default; 
} (differenceInCalendarQuarters$2, differenceInCalendarQuarters$2.exports));

var differenceInCalendarQuartersExports = differenceInCalendarQuarters$2.exports;

var differenceInCalendarWeeks$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInCalendarWeeks;
	var _index = _interopRequireDefault(startOfWeekExports);
	var _index2 = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_WEEK = 604800000;

	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
	  (0, _index3.default)(2, arguments);
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, options);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, options);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight);

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	module.exports = exports$1.default; 
} (differenceInCalendarWeeks$2, differenceInCalendarWeeks$2.exports));

var differenceInCalendarWeeksExports = differenceInCalendarWeeks$2.exports;

var differenceInCalendarYears$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInCalendarYears;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	module.exports = exports$1.default; 
} (differenceInCalendarYears$2, differenceInCalendarYears$2.exports));

var differenceInCalendarYearsExports = differenceInCalendarYears$2.exports;

var differenceInDays$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInDays;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(differenceInCalendarDaysExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	// Like `compareAsc` but uses local time not UTC, which is needed
	// for accurate equality comparisons of UTC timestamps that end up
	// having the same representation in local time, e.g. one hour before
	// DST ends vs. the instant that DST ends.
	function compareLocalAsc(dateLeft, dateRight) {
	  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1;
	    // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}

	/**
	 * @name differenceInDays
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full day periods between two dates. Fractional days are
	 * truncated towards zero.
	 *
	 * One "full day" is the distance between a local time in one day to the same
	 * local time on the next or previous day. A full day can sometimes be less than
	 * or more than 24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
	 *
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days according to the local timezone
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 * // How many full days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 0
	 * // How many full days are between
	 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 92 days, even in
	 * // time zones where DST starts and the
	 * // period has only 92*24-1 hours.
	 * const result = differenceInDays(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 1)
	 * )
	//=> 92
	 */
	function differenceInDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = compareLocalAsc(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft.setDate(dateLeft.getDate() - sign * difference);

	  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastDayNotFull);
	  // Prevent negative zero
	  return result === 0 ? 0 : result;
	}
	module.exports = exports$1.default; 
} (differenceInDays$2, differenceInDays$2.exports));

var differenceInDaysExports = differenceInDays$2.exports;

var differenceInHours$2 = {exports: {}};

var differenceInMilliseconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInMilliseconds;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name differenceInMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * const result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds(dateLeft, dateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dateLeft).getTime() - (0, _index.default)(dateRight).getTime();
	}
	module.exports = exports$1.default; 
} (differenceInMilliseconds$2, differenceInMilliseconds$2.exports));

var differenceInMillisecondsExports = differenceInMilliseconds$2.exports;

var roundingMethods = {};

Object.defineProperty(roundingMethods, "__esModule", {
  value: true
});
roundingMethods.getRoundingMethod = getRoundingMethod$2;
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE
};

var defaultRoundingMethod = 'trunc';
function getRoundingMethod$2(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInHours;
	var _index = constants$1$1;
	var _index2 = _interopRequireDefault(differenceInMillisecondsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var _index4 = roundingMethods;
	/**
	 * @name differenceInHours
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of hours
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * const result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	function differenceInHours(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInHour;
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports$1.default; 
} (differenceInHours$2, differenceInHours$2.exports));

var differenceInHoursExports = differenceInHours$2.exports;

var differenceInISOWeekYears$2 = {exports: {}};

var subISOWeekYears$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subISOWeekYears;
	var _index = _interopRequireDefault(addISOWeekYearsExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name subISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * @description
	 * Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 ISO week-numbering years from 1 September 2014:
	 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
	 * //=> Mon Aug 31 2009 00:00:00
	 */
	function subISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subISOWeekYears$2, subISOWeekYears$2.exports));

var subISOWeekYearsExports = subISOWeekYears$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInISOWeekYears;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(differenceInCalendarISOWeekYearsExports);
	var _index3 = _interopRequireDefault(compareAscExports);
	var _index4 = _interopRequireDefault(subISOWeekYearsExports);
	var _index5 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name differenceInISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of full ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of full ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
	 * const result = differenceInISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 1
	 */
	function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index5.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft = (0, _index4.default)(dateLeft, sign * difference);

	  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
	  // if last calendar ISO year is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastISOWeekYearNotFull = Number((0, _index3.default)(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastISOWeekYearNotFull);
	  // Prevent negative zero
	  return result === 0 ? 0 : result;
	}
	module.exports = exports$1.default; 
} (differenceInISOWeekYears$2, differenceInISOWeekYears$2.exports));

var differenceInISOWeekYearsExports = differenceInISOWeekYears$2.exports;

var differenceInMinutes$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInMinutes;
	var _index = constants$1$1;
	var _index2 = _interopRequireDefault(differenceInMillisecondsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var _index4 = roundingMethods;
	/**
	 * @name differenceInMinutes
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the signed number of full (rounded towards 0) minutes between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of minutes
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * const result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 *
	 * @example
	 * // How many minutes are between 10:01:59 and 10:00:00
	 * const result = differenceInMinutes(
	 *   new Date(2000, 0, 1, 10, 0, 0),
	 *   new Date(2000, 0, 1, 10, 1, 59)
	 * )
	 * //=> -1
	 */
	function differenceInMinutes(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInMinute;
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports$1.default; 
} (differenceInMinutes$2, differenceInMinutes$2.exports));

var differenceInMinutesExports = differenceInMinutes$2.exports;

var differenceInMonths$2 = {exports: {}};

var isLastDayOfMonth$2 = {exports: {}};

var endOfDay$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfDay;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfDay$2, endOfDay$2.exports));

var endOfDayExports = endOfDay$2.exports;

var endOfMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfMonth;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfMonth$2, endOfMonth$2.exports));

var endOfMonthExports = endOfMonth$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isLastDayOfMonth;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(endOfDayExports);
	var _index3 = _interopRequireDefault(endOfMonthExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isLastDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the last day of a month?
	 *
	 * @description
	 * Is the given date the last day of a month?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 28 February 2014 the last day of a month?
	 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
	 * //=> true
	 */
	function isLastDayOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  return (0, _index2.default)(date).getTime() === (0, _index3.default)(date).getTime();
	}
	module.exports = exports$1.default; 
} (isLastDayOfMonth$2, isLastDayOfMonth$2.exports));

var isLastDayOfMonthExports = isLastDayOfMonth$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInMonths;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(differenceInCalendarMonthsExports);
	var _index3 = _interopRequireDefault(compareAscExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var _index5 = _interopRequireDefault(isLastDayOfMonthExports);
	/**
	 * @name differenceInMonths
	 * @category Month Helpers
	 * @summary Get the number of full months between the given dates.
	 *
	 * @description
	 * Get the number of full months between the given dates using trunc as a default rounding method.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
	 * //=> 7
	 */
	function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var result;

	  // Check for the difference of less than month
	  if (difference < 1) {
	    result = 0;
	  } else {
	    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
	      // This will check if the date is end of Feb and assign a higher end of month date
	      // to compare it with Jan
	      dateLeft.setDate(30);
	    }
	    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);

	    // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
	    // If so, result must be decreased by 1 in absolute value
	    var isLastMonthNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;

	    // Check for cases of one full calendar month
	    if ((0, _index5.default)((0, _index.default)(dirtyDateLeft)) && difference === 1 && (0, _index3.default)(dirtyDateLeft, dateRight) === 1) {
	      isLastMonthNotFull = false;
	    }
	    result = sign * (difference - Number(isLastMonthNotFull));
	  }

	  // Prevent negative zero
	  return result === 0 ? 0 : result;
	}
	module.exports = exports$1.default; 
} (differenceInMonths$2, differenceInMonths$2.exports));

var differenceInMonthsExports = differenceInMonths$2.exports;

var differenceInQuarters$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInQuarters;
	var _index = _interopRequireDefault(differenceInMonthsExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = roundingMethods;
	/**
	 * @name differenceInQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of quarters between the given dates.
	 *
	 * @description
	 * Get the number of quarters between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full quarters are between 31 December 2013 and 2 July 2014?
	 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
	 * //=> 2
	 */
	function differenceInQuarters(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 3;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports$1.default; 
} (differenceInQuarters$2, differenceInQuarters$2.exports));

var differenceInQuartersExports = differenceInQuarters$2.exports;

var differenceInSeconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInSeconds;
	var _index = _interopRequireDefault(differenceInMillisecondsExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = roundingMethods;
	/**
	 * @name differenceInSeconds
	 * @category Second Helpers
	 * @summary Get the number of seconds between the given dates.
	 *
	 * @description
	 * Get the number of seconds between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of seconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many seconds are between
	 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
	 * const result = differenceInSeconds(
	 *   new Date(2014, 6, 2, 12, 30, 20, 0),
	 *   new Date(2014, 6, 2, 12, 30, 7, 999)
	 * )
	 * //=> 12
	 */
	function differenceInSeconds(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 1000;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports$1.default; 
} (differenceInSeconds$2, differenceInSeconds$2.exports));

var differenceInSecondsExports = differenceInSeconds$2.exports;

var differenceInWeeks$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInWeeks;
	var _index = _interopRequireDefault(differenceInDaysExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = roundingMethods;
	/**
	 * @name differenceInWeeks
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between two dates. Fractional weeks are
	 * truncated towards zero by default.
	 *
	 * One "full week" is the distance between a local time in one day to the same
	 * local time 7 days earlier or later. A full week can sometimes be less than
	 * or more than 7*24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
	 *
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
	 * //=> 2
	 *
	 * // How many full weeks are between
	 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 8 weeks (54 days),
	 * // even if DST starts and the period has
	 * // only 54*24-1 hours.
	 * const result = differenceInWeeks(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 6)
	 * )
	 * //=> 8
	 */
	function differenceInWeeks(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 7;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports$1.default; 
} (differenceInWeeks$2, differenceInWeeks$2.exports));

var differenceInWeeksExports = differenceInWeeks$2.exports;

var differenceInYears$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = differenceInYears;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(differenceInCalendarYearsExports);
	var _index3 = _interopRequireDefault(compareAscExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name differenceInYears
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
	 * //=> 1
	 */
	function differenceInYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));

	  // Set both dates to a valid leap year for accurate comparison when dealing
	  // with leap days
	  dateLeft.setFullYear(1584);
	  dateRight.setFullYear(1584);

	  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastYearNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - Number(isLastYearNotFull));
	  // Prevent negative zero
	  return result === 0 ? 0 : result;
	}
	module.exports = exports$1.default; 
} (differenceInYears$2, differenceInYears$2.exports));

var differenceInYearsExports = differenceInYears$2.exports;

var eachDayOfInterval$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachDayOfInterval;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachDayOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of dates within the specified time interval.
	 *
	 * @description
	 * Return the array of dates within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * const result = eachDayOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 9, 10)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDayOfInterval(dirtyInterval, options) {
	  var _options$step;
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime();

	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setDate(currentDate.getDate() + step);
	    currentDate.setHours(0, 0, 0, 0);
	  }
	  return dates;
	}
	module.exports = exports$1.default; 
} (eachDayOfInterval$2, eachDayOfInterval$2.exports));

var eachDayOfIntervalExports = eachDayOfInterval$2.exports;

var eachHourOfInterval$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachHourOfInterval;
	var _index = _interopRequireDefault(addHoursExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachHourOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of hours within the specified time interval.
	 *
	 * @description
	 * Return the array of hours within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
	 * const result = eachHourOfInterval({
	 *   start: new Date(2014, 9, 6, 12),
	 *   end: new Date(2014, 9, 6, 15)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 12:00:00,
	 * //   Mon Oct 06 2014 13:00:00,
	 * //   Mon Oct 06 2014 14:00:00,
	 * //   Mon Oct 06 2014 15:00:00
	 * // ]
	 */
	function eachHourOfInterval(dirtyInterval, options) {
	  var _options$step;
	  (0, _index3.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index2.default)(interval.start);
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime();

	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setMinutes(0, 0, 0);
	  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	  return dates;
	}
	module.exports = exports$1.default; 
} (eachHourOfInterval$2, eachHourOfInterval$2.exports));

var eachHourOfIntervalExports = eachHourOfInterval$2.exports;

var eachMinuteOfInterval$2 = {exports: {}};

var startOfMinute$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfMinute;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfMinute
	 * @category Minute Helpers
	 * @summary Return the start of a minute for the given date.
	 *
	 * @description
	 * Return the start of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a minute for 1 December 2014 22:15:45.400:
	 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:00
	 */
	function startOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfMinute$2, startOfMinute$2.exports));

var startOfMinuteExports = startOfMinute$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachMinuteOfInterval;
	var _index = _interopRequireDefault(addMinutesExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(startOfMinuteExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachMinuteOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of minutes within the specified time interval.
	 *
	 * @description
	 * Returns the array of minutes within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The step must be equal to or greater than 1
	 * @throws {TypeError} 1 argument required
	 * @returns {Date[]} the array with starts of minutes from the minute of the interval start to the minute of the interval end
	 * @throws {RangeError} `options.step` must be a number equal to or greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
	 * const result = eachMinuteOfInterval({
	 *   start: new Date(2014, 9, 14, 13),
	 *   end: new Date(2014, 9, 14, 13, 3)
	 * })
	 * //=> [
	 * //   Wed Oct 14 2014 13:00:00,
	 * //   Wed Oct 14 2014 13:01:00,
	 * //   Wed Oct 14 2014 13:02:00,
	 * //   Wed Oct 14 2014 13:03:00
	 * // ]
	 */
	function eachMinuteOfInterval(interval, options) {
	  var _options$step;
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index3.default)((0, _index2.default)(interval.start));
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime();
	  if (startTime >= endTime) {
	    throw new RangeError('Invalid interval');
	  }
	  var dates = [];
	  var currentDate = startDate;
	  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number equal to or greater than 1');
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	  return dates;
	}
	module.exports = exports$1.default; 
} (eachMinuteOfInterval$2, eachMinuteOfInterval$2.exports));

var eachMinuteOfIntervalExports = eachMinuteOfInterval$2.exports;

var eachMonthOfInterval$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachMonthOfInterval;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachMonthOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of months within the specified time interval.
	 *
	 * @description
	 * Return the array of months within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each month between 6 February 2014 and 10 August 2014:
	 * const result = eachMonthOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Sat Feb 01 2014 00:00:00,
	 * //   Sat Mar 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Thu May 01 2014 00:00:00,
	 * //   Sun Jun 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * //   Fri Aug 01 2014 00:00:00
	 * // ]
	 */
	function eachMonthOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime();
	  var dates = [];

	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setDate(1);
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setMonth(currentDate.getMonth() + 1);
	  }
	  return dates;
	}
	module.exports = exports$1.default; 
} (eachMonthOfInterval$2, eachMonthOfInterval$2.exports));

var eachMonthOfIntervalExports = eachMonthOfInterval$2.exports;

var eachQuarterOfInterval$2 = {exports: {}};

var startOfQuarter$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfQuarter;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfQuarter$2, startOfQuarter$2.exports));

var startOfQuarterExports = startOfQuarter$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachQuarterOfInterval;
	var _index = _interopRequireDefault(addQuartersExports);
	var _index2 = _interopRequireDefault(startOfQuarterExports);
	var _index3 = _interopRequireDefault(toDateExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachQuarterOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of quarters within the specified time interval.
	 *
	 * @description
	 * Return the array of quarters within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each quarter within interval 6 February 2014 - 10 August 2014:
	 * const result = eachQuarterOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * // ]
	 */
	function eachQuarterOfInterval(dirtyInterval) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime();

	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var startDateQuarter = (0, _index2.default)(startDate);
	  var endDateQuarter = (0, _index2.default)(endDate);
	  endTime = endDateQuarter.getTime();
	  var quarters = [];
	  var currentQuarter = startDateQuarter;
	  while (currentQuarter.getTime() <= endTime) {
	    quarters.push((0, _index3.default)(currentQuarter));
	    currentQuarter = (0, _index.default)(currentQuarter, 1);
	  }
	  return quarters;
	}
	module.exports = exports$1.default; 
} (eachQuarterOfInterval$2, eachQuarterOfInterval$2.exports));

var eachQuarterOfIntervalExports = eachQuarterOfInterval$2.exports;

var eachWeekOfInterval$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachWeekOfInterval;
	var _index = _interopRequireDefault(addWeeksExports);
	var _index2 = _interopRequireDefault(startOfWeekExports);
	var _index3 = _interopRequireDefault(toDateExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachWeekOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of weeks within the specified time interval.
	 *
	 * @description
	 * Return the array of weeks within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each week within interval 6 October 2014 - 23 November 2014:
	 * const result = eachWeekOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 10, 23)
	 * })
	 * //=> [
	 * //   Sun Oct 05 2014 00:00:00,
	 * //   Sun Oct 12 2014 00:00:00,
	 * //   Sun Oct 19 2014 00:00:00,
	 * //   Sun Oct 26 2014 00:00:00,
	 * //   Sun Nov 02 2014 00:00:00,
	 * //   Sun Nov 09 2014 00:00:00,
	 * //   Sun Nov 16 2014 00:00:00,
	 * //   Sun Nov 23 2014 00:00:00
	 * // ]
	 */
	function eachWeekOfInterval(dirtyInterval, options) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime();

	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var startDateWeek = (0, _index2.default)(startDate, options);
	  var endDateWeek = (0, _index2.default)(endDate, options);

	  // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
	  startDateWeek.setHours(15);
	  endDateWeek.setHours(15);
	  endTime = endDateWeek.getTime();
	  var weeks = [];
	  var currentWeek = startDateWeek;
	  while (currentWeek.getTime() <= endTime) {
	    currentWeek.setHours(0);
	    weeks.push((0, _index3.default)(currentWeek));
	    currentWeek = (0, _index.default)(currentWeek, 1);
	    currentWeek.setHours(15);
	  }
	  return weeks;
	}
	module.exports = exports$1.default; 
} (eachWeekOfInterval$2, eachWeekOfInterval$2.exports));

var eachWeekOfIntervalExports = eachWeekOfInterval$2.exports;

var eachWeekendOfInterval$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachWeekendOfInterval;
	var _index = _interopRequireDefault(eachDayOfIntervalExports);
	var _index2 = _interopRequireDefault(isSundayExports);
	var _index3 = _interopRequireDefault(isWeekendExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachWeekendOfInterval
	 * @category Interval Helpers
	 * @summary List all the Saturdays and Sundays in the given date interval.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given date interval.
	 *
	 * @param {Interval} interval - the given interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given date interval
	 * const result = eachWeekendOfInterval({
	 *   start: new Date(2018, 8, 17),
	 *   end: new Date(2018, 8, 30)
	 * })
	 * //=> [
	 * //   Sat Sep 22 2018 00:00:00,
	 * //   Sun Sep 23 2018 00:00:00,
	 * //   Sat Sep 29 2018 00:00:00,
	 * //   Sun Sep 30 2018 00:00:00
	 * // ]
	 */
	function eachWeekendOfInterval(interval) {
	  (0, _index4.default)(1, arguments);
	  var dateInterval = (0, _index.default)(interval);
	  var weekends = [];
	  var index = 0;
	  while (index < dateInterval.length) {
	    var date = dateInterval[index++];
	    if ((0, _index3.default)(date)) {
	      weekends.push(date);
	      if ((0, _index2.default)(date)) index = index + 5;
	    }
	  }
	  return weekends;
	}
	module.exports = exports$1.default; 
} (eachWeekendOfInterval$2, eachWeekendOfInterval$2.exports));

var eachWeekendOfIntervalExports = eachWeekendOfInterval$2.exports;

var eachWeekendOfMonth$2 = {exports: {}};

var startOfMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfMonth;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfMonth$2, startOfMonth$2.exports));

var startOfMonthExports = startOfMonth$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachWeekendOfMonth;
	var _index = _interopRequireDefault(eachWeekendOfIntervalExports);
	var _index2 = _interopRequireDefault(startOfMonthExports);
	var _index3 = _interopRequireDefault(endOfMonthExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachWeekendOfMonth
	 * @category Month Helpers
	 * @summary List all the Saturdays and Sundays in the given month.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given month.
	 *
	 * @param {Date|Number} date - the given month
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given month
	 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
	 * //=> [
	 * //   Sat Feb 05 2022 00:00:00,
	 * //   Sun Feb 06 2022 00:00:00,
	 * //   Sat Feb 12 2022 00:00:00,
	 * //   Sun Feb 13 2022 00:00:00,
	 * //   Sat Feb 19 2022 00:00:00,
	 * //   Sun Feb 20 2022 00:00:00,
	 * //   Sat Feb 26 2022 00:00:00,
	 * //   Sun Feb 27 2022 00:00:00
	 * // ]
	 */
	function eachWeekendOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate.getTime())) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	module.exports = exports$1.default; 
} (eachWeekendOfMonth$2, eachWeekendOfMonth$2.exports));

var eachWeekendOfMonthExports = eachWeekendOfMonth$2.exports;

var eachWeekendOfYear$2 = {exports: {}};

var endOfYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfYear
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfYear$2, endOfYear$2.exports));

var endOfYearExports = endOfYear$2.exports;

var startOfYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfYear$2, startOfYear$2.exports));

var startOfYearExports = startOfYear$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachWeekendOfYear;
	var _index = _interopRequireDefault(eachWeekendOfIntervalExports);
	var _index2 = _interopRequireDefault(endOfYearExports);
	var _index3 = _interopRequireDefault(startOfYearExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachWeekendOfYear
	 * @category Year Helpers
	 * @summary List all the Saturdays and Sundays in the year.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the year.
	 *
	 * @param {Date|Number} date - the given year
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the year
	 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
	 * //=> [
	 * //   Sat Jan 03 2020 00:00:00,
	 * //   Sun Jan 04 2020 00:00:00,
	 * //   ...
	 * //   Sun Dec 27 2020 00:00:00
	 * // ]
	 * ]
	 */
	function eachWeekendOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index3.default)(dirtyDate);
	  var endDate = (0, _index2.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	module.exports = exports$1.default; 
} (eachWeekendOfYear$2, eachWeekendOfYear$2.exports));

var eachWeekendOfYearExports = eachWeekendOfYear$2.exports;

var eachYearOfInterval$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = eachYearOfInterval;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name eachYearOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of yearly timestamps within the specified time interval.
	 *
	 * @description
	 * Return the array of yearly timestamps within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each year between 6 February 2014 and 10 August 2017:
	 * const result = eachYearOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2017, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Thu Jan 01 2015 00:00:00,
	 * //   Fri Jan 01 2016 00:00:00,
	 * //   Sun Jan 01 2017 00:00:00
	 * // ]
	 */
	function eachYearOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime();

	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setMonth(0, 1);
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setFullYear(currentDate.getFullYear() + 1);
	  }
	  return dates;
	}
	module.exports = exports$1.default; 
} (eachYearOfInterval$2, eachYearOfInterval$2.exports));

var eachYearOfIntervalExports = eachYearOfInterval$2.exports;

var endOfDecade$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfDecade;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfDecade
	 * @category Decade Helpers
	 * @summary Return the end of a decade for the given date.
	 *
	 * @description
	 * Return the end of a decade for the given date.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a decade
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a decade for 12 May 1984 00:00:00:
	 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
	 * //=> Dec 31 1989 23:59:59.999
	 */
	function endOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 11, 31);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfDecade$2, endOfDecade$2.exports));

var endOfDecadeExports = endOfDecade$2.exports;

var endOfHour$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfHour;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfHour
	 * @category Hour Helpers
	 * @summary Return the end of an hour for the given date.
	 *
	 * @description
	 * Return the end of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an hour for 2 September 2014 11:55:00:
	 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:59:59.999
	 */
	function endOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(59, 59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfHour$2, endOfHour$2.exports));

var endOfHourExports = endOfHour$2.exports;

var endOfISOWeek$2 = {exports: {}};

var endOfWeek$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfWeek;
	var _index = defaultOptions$1$1;
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfWeek$2, endOfWeek$2.exports));

var endOfWeekExports = endOfWeek$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfISOWeek;
	var _index = _interopRequireDefault(endOfWeekExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the end of an ISO week for the given date.
	 *
	 * @description
	 * Return the end of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week for 2 September 2014 11:55:00:
	 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports$1.default; 
} (endOfISOWeek$2, endOfISOWeek$2.exports));

var endOfISOWeekExports = endOfISOWeek$2.exports;

var endOfISOWeekYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfISOWeekYear;
	var _index = _interopRequireDefault(getISOWeekYearExports);
	var _index2 = _interopRequireDefault(startOfISOWeekExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the end of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the end of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week-numbering year for 2 July 2005:
	 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 23:59:59.999
	 */
	function endOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  date.setMilliseconds(date.getMilliseconds() - 1);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfISOWeekYear$2, endOfISOWeekYear$2.exports));

var endOfISOWeekYearExports = endOfISOWeekYear$2.exports;

var endOfMinute$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfMinute;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfMinute
	 * @category Minute Helpers
	 * @summary Return the end of a minute for the given date.
	 *
	 * @description
	 * Return the end of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a minute for 1 December 2014 22:15:45.400:
	 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:59.999
	 */
	function endOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfMinute$2, endOfMinute$2.exports));

var endOfMinuteExports = endOfMinute$2.exports;

var endOfQuarter$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfQuarter;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the end of a year quarter for the given date.
	 *
	 * @description
	 * Return the end of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a quarter for 2 September 2014 11:55:00:
	 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfQuarter$2, endOfQuarter$2.exports));

var endOfQuarterExports = endOfQuarter$2.exports;

var endOfSecond$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfSecond;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name endOfSecond
	 * @category Second Helpers
	 * @summary Return the end of a second for the given date.
	 *
	 * @description
	 * Return the end of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a second for 1 December 2014 22:15:45.400:
	 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.999
	 */
	function endOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfSecond$2, endOfSecond$2.exports));

var endOfSecondExports = endOfSecond$2.exports;

var endOfToday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfToday;
	var _index = _interopRequireDefault(endOfDayExports);
	/**
	 * @name endOfToday
	 * @category Day Helpers
	 * @summary Return the end of today.
	 * @pure false
	 *
	 * @description
	 * Return the end of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the end of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfToday()
	 * //=> Mon Oct 6 2014 23:59:59.999
	 */
	function endOfToday() {
	  return (0, _index.default)(Date.now());
	}
	module.exports = exports$1.default; 
} (endOfToday$2, endOfToday$2.exports));

var endOfTodayExports = endOfToday$2.exports;

var endOfTomorrow$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfTomorrow;
	/**
	 * @name endOfTomorrow
	 * @category Day Helpers
	 * @summary Return the end of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the end of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the end of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfTomorrow()
	 * //=> Tue Oct 7 2014 23:59:59.999
	 */
	function endOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfTomorrow$2, endOfTomorrow$2.exports));

var endOfTomorrowExports = endOfTomorrow$2.exports;

var endOfYesterday$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = endOfYesterday;
	/**
	 * @name endOfYesterday
	 * @category Day Helpers
	 * @summary Return the end of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the end of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the end of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfYesterday()
	 * //=> Sun Oct 5 2014 23:59:59.999
	 */
	function endOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports$1.default; 
} (endOfYesterday$2, endOfYesterday$2.exports));

var endOfYesterdayExports = endOfYesterday$2.exports;

var format$2 = {exports: {}};

var subMilliseconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subMilliseconds;
	var _index = _interopRequireDefault(addMillisecondsExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subMilliseconds$2, subMilliseconds$2.exports));

var subMillisecondsExports = subMilliseconds$2.exports;

var formatters$1 = {exports: {}};

var getUTCDayOfYear = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getUTCDayOfYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_DAY = 86400000;
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	module.exports = exports$1.default; 
} (getUTCDayOfYear, getUTCDayOfYear.exports));

var getUTCDayOfYearExports = getUTCDayOfYear.exports;

var getUTCISOWeek = {exports: {}};

var startOfUTCISOWeek = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfUTCISOWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfUTCISOWeek, startOfUTCISOWeek.exports));

var startOfUTCISOWeekExports = startOfUTCISOWeek.exports;

var startOfUTCISOWeekYear = {exports: {}};

var getUTCISOWeekYear = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getUTCISOWeekYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(startOfUTCISOWeekExports);
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports$1.default; 
} (getUTCISOWeekYear, getUTCISOWeekYear.exports));

var getUTCISOWeekYearExports = getUTCISOWeekYear.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfUTCISOWeekYear;
	var _index = _interopRequireDefault(getUTCISOWeekYearExports);
	var _index2 = _interopRequireDefault(startOfUTCISOWeekExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfUTCISOWeekYear, startOfUTCISOWeekYear.exports));

var startOfUTCISOWeekYearExports = startOfUTCISOWeekYear.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getUTCISOWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(startOfUTCISOWeekExports);
	var _index3 = _interopRequireDefault(startOfUTCISOWeekYearExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports$1.default; 
} (getUTCISOWeek, getUTCISOWeek.exports));

var getUTCISOWeekExports = getUTCISOWeek.exports;

var getUTCWeek = {exports: {}};

var startOfUTCWeek = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfUTCWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	var _index4 = defaultOptions$1$1;
	function startOfUTCWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfUTCWeek, startOfUTCWeek.exports));

var startOfUTCWeekExports = startOfUTCWeek.exports;

var startOfUTCWeekYear = {exports: {}};

var getUTCWeekYear = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getUTCWeekYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(startOfUTCWeekExports);
	var _index4 = _interopRequireDefault(toIntegerExports);
	var _index5 = defaultOptions$1$1;
	function getUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports$1.default; 
} (getUTCWeekYear, getUTCWeekYear.exports));

var getUTCWeekYearExports = getUTCWeekYear.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfUTCWeekYear;
	var _index = _interopRequireDefault(getUTCWeekYearExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(startOfUTCWeekExports);
	var _index4 = _interopRequireDefault(toIntegerExports);
	var _index5 = defaultOptions$1$1;
	function startOfUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var year = (0, _index.default)(dirtyDate, options);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, options);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfUTCWeekYear, startOfUTCWeekYear.exports));

var startOfUTCWeekYearExports = startOfUTCWeekYear.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getUTCWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(startOfUTCWeekExports);
	var _index3 = _interopRequireDefault(startOfUTCWeekYearExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports$1.default; 
} (getUTCWeek, getUTCWeek.exports));

var getUTCWeekExports = getUTCWeek.exports;

var addLeadingZeros$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = addLeadingZeros;
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return sign + output;
	}
	module.exports = exports$1.default; 
} (addLeadingZeros$2, addLeadingZeros$2.exports));

var addLeadingZerosExports = addLeadingZeros$2.exports;

var lightFormatters$1 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var _index = _interopRequireDefault(addLeadingZerosExports);
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */

	var formatters = {
	  // Year
	  y: function y(date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

	    var signedYear = date.getUTCFullYear();
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function M(date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function d(date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function a(date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return dayPeriodEnumValue.toUpperCase();
	      case 'aaa':
	        return dayPeriodEnumValue;
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function H(date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function m(date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function s(date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (lightFormatters$1, lightFormatters$1.exports));

var lightFormattersExports = lightFormatters$1.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var _index = _interopRequireDefault(getUTCDayOfYearExports);
	var _index2 = _interopRequireDefault(getUTCISOWeekExports);
	var _index3 = _interopRequireDefault(getUTCISOWeekYearExports);
	var _index4 = _interopRequireDefault(getUTCWeekExports);
	var _index5 = _interopRequireDefault(getUTCWeekYearExports);
	var _index6 = _interopRequireDefault(addLeadingZerosExports);
	var _index7 = _interopRequireDefault(lightFormattersExports);
	var dayPeriodEnum = {
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	};
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	 * |  p! | Long localized time            |  P! | Long localized date            |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 * - `P` is long localized date format
	 * - `p` is long localized time format
	 */

	var formatters = {
	  // Era
	  G: function G(date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function y(date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear();
	      // Returns 1 for 1 BC (which is year 0 in JavaScript)
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	    return _index7.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function Y(date, token, localize, options) {
	    var signedWeekYear = (0, _index5.default)(date, options);
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

	    // Two digit year
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index6.default)(twoDigitYear, 2);
	    }

	    // Ordinal number
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    }

	    // Padding
	    return (0, _index6.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function R(date, token) {
	    var isoWeekYear = (0, _index3.default)(date);

	    // Padding
	    return (0, _index6.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function u(date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index6.default)(year, token.length);
	  },
	  // Quarter
	  Q: function Q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'QQ':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'qq':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function M(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index7.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function L(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	      case 'LL':
	        return (0, _index6.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function w(date, token, localize, options) {
	    var week = (0, _index4.default)(date, options);
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function I(date, token, localize) {
	    var isoWeek = (0, _index2.default)(date);
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function d(date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	    return _index7.default.d(date, token);
	  },
	  // Day of year
	  D: function D(date, token, localize) {
	    var dayOfYear = (0, _index.default)(date);
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	    return (0, _index6.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function E(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function e(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'ee':
	        return (0, _index6.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function c(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'cc':
	        return (0, _index6.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function i(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	      case 'ii':
	        return (0, _index6.default)(isoDayOfWeek, token.length);
	      // 2nd
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function a(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function b(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	    switch (token) {
	      case 'b':
	      case 'bb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function B(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function H(date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function K(date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function k(date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Minute
	  m: function m(date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	    return _index7.default.m(date, token);
	  },
	  // Second
	  s: function s(date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	    return _index7.default.s(date, token);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    return _index7.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function X(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);

	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);

	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function x(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);

	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);

	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function O(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function z(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function t(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index6.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function T(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index6.default)(timestamp, token.length);
	  }
	};
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	  var delimiter = dirtyDelimiter;
	  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
	}
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
	  }
	  return formatTimezone(offset, dirtyDelimiter);
	}
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index6.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	var _default = formatters;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (formatters$1, formatters$1.exports));

var formattersExports = formatters$1.exports;

var longFormatters$1 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	};
	var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	};
	var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/) || [];
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	  var dateTimeFormat;
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	};
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (longFormatters$1, longFormatters$1.exports));

var longFormattersExports = longFormatters$1.exports;

var protectedTokens$1 = {};

Object.defineProperty(protectedTokens$1, "__esModule", {
  value: true
});
protectedTokens$1.isProtectedDayOfYearToken = isProtectedDayOfYearToken$1;
protectedTokens$1.isProtectedWeekYearToken = isProtectedWeekYearToken$1;
protectedTokens$1.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken$1(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken$1(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var defaultLocale$5 = {exports: {}};

var enUS$1 = {exports: {}};

var formatDistance$1$1 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	var formatDistance = function formatDistance(token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	  return result;
	};
	var _default = formatDistance;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (formatDistance$1$1, formatDistance$1$1.exports));

var formatDistanceExports$1 = formatDistance$1$1.exports;

var formatLong$1t = {exports: {}};

var buildFormatLongFn$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = buildFormatLongFn;
	function buildFormatLongFn(args) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    // TODO: Remove String()
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	module.exports = exports$1.default; 
} (buildFormatLongFn$2, buildFormatLongFn$2.exports));

var buildFormatLongFnExports = buildFormatLongFn$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var _index = _interopRequireDefault(buildFormatLongFnExports);
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (formatLong$1t, formatLong$1t.exports));

var formatLongExports = formatLong$1t.exports;

var formatRelative$1$1 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	var _default = formatRelative;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (formatRelative$1$1, formatRelative$1$1.exports));

var formatRelativeExports$1 = formatRelative$1$1.exports;

var localize$1l = {exports: {}};

var buildLocalizeFn$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = buildLocalizeFn;
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, options) {
	    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
	    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
	    return valuesArray[index];
	  };
	}
	module.exports = exports$1.default; 
} (buildLocalizeFn$2, buildLocalizeFn$2.exports));

var buildLocalizeFnExports = buildLocalizeFn$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var _index = _interopRequireDefault(buildLocalizeFnExports);
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
	};

	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
	  var number = Number(dirtyNumber);

	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`.
	  //
	  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'.

	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	      case 2:
	        return number + 'nd';
	      case 3:
	        return number + 'rd';
	    }
	  }
	  return number + 'th';
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function argumentCallback(quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (localize$1l, localize$1l.exports));

var localizeExports = localize$1l.exports;

var match$1k = {exports: {}};

var buildMatchFn$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = buildMatchFn;
	function buildMatchFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	    if (!matchResult) {
	      return null;
	    }
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    }) : findKey(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    });
	    var value;
	    value = args.valueCallback ? args.valueCallback(key) : key;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	module.exports = exports$1.default; 
} (buildMatchFn$2, buildMatchFn$2.exports));

var buildMatchFnExports = buildMatchFn$2.exports;

var buildMatchPatternFn$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = buildMatchPatternFn;
	function buildMatchPatternFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var matchResult = string.match(args.matchPattern);
	    if (!matchResult) return null;
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	    if (!parseResult) return null;
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	module.exports = exports$1.default; 
} (buildMatchPatternFn$2, buildMatchPatternFn$2.exports));

var buildMatchPatternFnExports = buildMatchPatternFn$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var _index = _interopRequireDefault(buildMatchFnExports);
	var _index2 = _interopRequireDefault(buildMatchPatternFnExports);
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function valueCallback(value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function valueCallback(index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (match$1k, match$1k.exports));

var matchExports = match$1k.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var _index = _interopRequireDefault(formatDistanceExports$1);
	var _index2 = _interopRequireDefault(formatLongExports);
	var _index3 = _interopRequireDefault(formatRelativeExports$1);
	var _index4 = _interopRequireDefault(localizeExports);
	var _index5 = _interopRequireDefault(matchExports);
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0 /* Sunday */,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (enUS$1, enUS$1.exports));

var enUSExports = enUS$1.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = void 0;
	var _index = _interopRequireDefault(enUSExports);
	var _default = _index.default;
	exports$1.default = _default;
	module.exports = exports$1.default; 
} (defaultLocale$5, defaultLocale$5.exports));

var defaultLocaleExports = defaultLocale$5.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = format;
	var _index = _interopRequireDefault(isValidExports);
	var _index2 = _interopRequireDefault(subMillisecondsExports);
	var _index3 = _interopRequireDefault(toDateExports);
	var _index4 = _interopRequireDefault(formattersExports);
	var _index5 = _interopRequireDefault(longFormattersExports);
	var _index6 = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index7 = protectedTokens$1;
	var _index8 = _interopRequireDefault(toIntegerExports);
	var _index9 = _interopRequireDefault(requiredArgsExports);
	var _index10 = defaultOptions$1$1;
	var _index11 = _interopRequireDefault(defaultLocaleExports);
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          | a..aa   | AM, PM                            |       |
	 * |                                 | aaa     | am, pm                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
	 * |                                 | bbb     | am, pm, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 001, ..., 999                |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 04/29/1453                        | 7     |
	 * |                                 | PP      | Apr 29, 1453                      | 7     |
	 * |                                 | PPP     | April 29th, 1453                  | 7     |
	 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
	 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */

	function format(dirtyDate, dirtyFormatStr, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var defaultOptions = (0, _index10.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	  var originalDate = (0, _index3.default)(dirtyDate);
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }

	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = (0, _index6.default)(originalDate);
	  var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	    var firstCharacter = substring[0];
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	    var formatter = _index4.default[firstCharacter];
	    if (formatter) {
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	    return substring;
	  }).join('');
	  return result;
	}
	function cleanEscapedString(input) {
	  var matched = input.match(escapedStringRegExp);
	  if (!matched) {
	    return input;
	  }
	  return matched[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports$1.default; 
} (format$2, format$2.exports));

var formatExports = format$2.exports;

var formatDistance$2I = {exports: {}};

var cloneObject = {exports: {}};

var assign$1 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = assign;
	function assign(target, object) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	  for (var property in object) {
	    if (Object.prototype.hasOwnProperty.call(object, property)) {
	      target[property] = object[property];
	    }
	  }
	  return target;
	}
	module.exports = exports$1.default; 
} (assign$1, assign$1.exports));

var assignExports = assign$1.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = cloneObject;
	var _index = _interopRequireDefault(assignExports);
	function cloneObject(object) {
	  return (0, _index.default)({}, object);
	}
	module.exports = exports$1.default; 
} (cloneObject, cloneObject.exports));

var cloneObjectExports = cloneObject.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatDistance;
	var _index = defaultOptions$1$1;
	var _index2 = _interopRequireDefault(compareAscExports);
	var _index3 = _interopRequireDefault(differenceInMonthsExports);
	var _index4 = _interopRequireDefault(differenceInSecondsExports);
	var _index5 = _interopRequireDefault(defaultLocaleExports);
	var _index6 = _interopRequireDefault(toDateExports);
	var _index7 = _interopRequireDefault(cloneObjectExports);
	var _index8 = _interopRequireDefault(assignExports);
	var _index9 = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index10 = _interopRequireDefault(requiredArgsExports);
	var MINUTES_IN_DAY = 1440;
	var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
	var MINUTES_IN_MONTH = 43200;
	var MINUTES_IN_TWO_MONTHS = 86400;

	/**
	 * @name formatDistance
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words.
	 *
	 * | Distance between dates                                            | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance between dates | Result               |
	 * |------------------------|----------------------|
	 * | 0 secs ... 5 secs      | less than 5 seconds  |
	 * | 5 secs ... 10 secs     | less than 10 seconds |
	 * | 10 secs ... 20 secs    | less than 20 seconds |
	 * | 20 secs ... 40 secs    | half a minute        |
	 * | 40 secs ... 60 secs    | less than a minute   |
	 * | 60 secs ... 90 secs    | 1 minute             |
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00, including seconds?
	 * const result = formatDistance(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 *   { includeSeconds: true }
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> 'about 1 year ago'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> 'pli ol 1 jaro'
	 */

	function formatDistance(dirtyDate, dirtyBaseDate, options) {
	  var _ref, _options$locale;
	  (0, _index10.default)(2, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index5.default;
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain formatDistance property');
	  }
	  var comparison = (0, _index2.default)(dirtyDate, dirtyBaseDate);
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	  var localizeOptions = (0, _index8.default)((0, _index7.default)(options), {
	    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
	    comparison: comparison
	  });
	  var dateLeft;
	  var dateRight;
	  if (comparison > 0) {
	    dateLeft = (0, _index6.default)(dirtyBaseDate);
	    dateRight = (0, _index6.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index6.default)(dirtyDate);
	    dateRight = (0, _index6.default)(dirtyBaseDate);
	  }
	  var seconds = (0, _index4.default)(dateRight, dateLeft);
	  var offsetInSeconds = ((0, _index9.default)(dateRight) - (0, _index9.default)(dateLeft)) / 1000;
	  var minutes = Math.round((seconds - offsetInSeconds) / 60);
	  var months;

	  // 0 up to 2 mins
	  if (minutes < 2) {
	    if (options !== null && options !== void 0 && options.includeSeconds) {
	      if (seconds < 5) {
	        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
	      } else if (seconds < 10) {
	        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
	      } else if (seconds < 20) {
	        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
	      } else if (seconds < 40) {
	        return locale.formatDistance('halfAMinute', 0, localizeOptions);
	      } else if (seconds < 60) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', 1, localizeOptions);
	      }
	    } else {
	      if (minutes === 0) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', minutes, localizeOptions);
	      }
	    }

	    // 2 mins up to 0.75 hrs
	  } else if (minutes < 45) {
	    return locale.formatDistance('xMinutes', minutes, localizeOptions);

	    // 0.75 hrs up to 1.5 hrs
	  } else if (minutes < 90) {
	    return locale.formatDistance('aboutXHours', 1, localizeOptions);

	    // 1.5 hrs up to 24 hrs
	  } else if (minutes < MINUTES_IN_DAY) {
	    var hours = Math.round(minutes / 60);
	    return locale.formatDistance('aboutXHours', hours, localizeOptions);

	    // 1 day up to 1.75 days
	  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
	    return locale.formatDistance('xDays', 1, localizeOptions);

	    // 1.75 days up to 30 days
	  } else if (minutes < MINUTES_IN_MONTH) {
	    var days = Math.round(minutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions);

	    // 1 month up to 2 months
	  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
	    months = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('aboutXMonths', months, localizeOptions);
	  }
	  months = (0, _index3.default)(dateRight, dateLeft);

	  // 2 months up to 12 months
	  if (months < 12) {
	    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('xMonths', nearestMonth, localizeOptions);

	    // 1 year up to max Date
	  } else {
	    var monthsSinceStartOfYear = months % 12;
	    var years = Math.floor(months / 12);

	    // N years up to 1 years 3 months
	    if (monthsSinceStartOfYear < 3) {
	      return locale.formatDistance('aboutXYears', years, localizeOptions);

	      // N years 3 months up to N years 9 months
	    } else if (monthsSinceStartOfYear < 9) {
	      return locale.formatDistance('overXYears', years, localizeOptions);

	      // N years 9 months up to N year 12 months
	    } else {
	      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
	    }
	  }
	}
	module.exports = exports$1.default; 
} (formatDistance$2I, formatDistance$2I.exports));

var formatDistanceExports = formatDistance$2I.exports;

var formatDistanceStrict$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatDistanceStrict;
	var _index = defaultOptions$1$1;
	var _index2 = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index3 = _interopRequireDefault(compareAscExports);
	var _index4 = _interopRequireDefault(toDateExports);
	var _index5 = _interopRequireDefault(cloneObjectExports);
	var _index6 = _interopRequireDefault(assignExports);
	var _index7 = _interopRequireDefault(defaultLocaleExports);
	var _index8 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_MINUTE = 1000 * 60;
	var MINUTES_IN_DAY = 60 * 24;
	var MINUTES_IN_MONTH = MINUTES_IN_DAY * 30;
	var MINUTES_IN_YEAR = MINUTES_IN_DAY * 365;

	/**
	 * @name formatDistanceStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
	 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00?
	 * const result = formatDistanceStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0)
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> '1 year ago'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, in minutes?
	 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
	 *   unit: 'minute'
	 * })
	 * //=> '525600 minutes'
	 *
	 * @example
	 * // What is the distance from 1 January 2015
	 * // to 28 January 2015, in months, rounded up?
	 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> '1 jaro'
	 */

	function formatDistanceStrict(dirtyDate, dirtyBaseDate, options) {
	  var _ref, _options$locale, _options$roundingMeth;
	  (0, _index8.default)(2, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index7.default;
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain localize.formatDistance property');
	  }
	  var comparison = (0, _index3.default)(dirtyDate, dirtyBaseDate);
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	  var localizeOptions = (0, _index6.default)((0, _index5.default)(options), {
	    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
	    comparison: comparison
	  });
	  var dateLeft;
	  var dateRight;
	  if (comparison > 0) {
	    dateLeft = (0, _index4.default)(dirtyBaseDate);
	    dateRight = (0, _index4.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index4.default)(dirtyDate);
	    dateRight = (0, _index4.default)(dirtyBaseDate);
	  }
	  var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : 'round');
	  var roundingMethodFn;
	  if (roundingMethod === 'floor') {
	    roundingMethodFn = Math.floor;
	  } else if (roundingMethod === 'ceil') {
	    roundingMethodFn = Math.ceil;
	  } else if (roundingMethod === 'round') {
	    roundingMethodFn = Math.round;
	  } else {
	    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
	  }
	  var milliseconds = dateRight.getTime() - dateLeft.getTime();
	  var minutes = milliseconds / MILLISECONDS_IN_MINUTE;
	  var timezoneOffset = (0, _index2.default)(dateRight) - (0, _index2.default)(dateLeft);

	  // Use DST-normalized difference in minutes for years, months and days;
	  // use regular difference in minutes for hours, minutes and seconds.
	  var dstNormalizedMinutes = (milliseconds - timezoneOffset) / MILLISECONDS_IN_MINUTE;
	  var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
	  var unit;
	  if (!defaultUnit) {
	    if (minutes < 1) {
	      unit = 'second';
	    } else if (minutes < 60) {
	      unit = 'minute';
	    } else if (minutes < MINUTES_IN_DAY) {
	      unit = 'hour';
	    } else if (dstNormalizedMinutes < MINUTES_IN_MONTH) {
	      unit = 'day';
	    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
	      unit = 'month';
	    } else {
	      unit = 'year';
	    }
	  } else {
	    unit = String(defaultUnit);
	  }

	  // 0 up to 60 seconds
	  if (unit === 'second') {
	    var seconds = roundingMethodFn(milliseconds / 1000);
	    return locale.formatDistance('xSeconds', seconds, localizeOptions);

	    // 1 up to 60 mins
	  } else if (unit === 'minute') {
	    var roundedMinutes = roundingMethodFn(minutes);
	    return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions);

	    // 1 up to 24 hours
	  } else if (unit === 'hour') {
	    var hours = roundingMethodFn(minutes / 60);
	    return locale.formatDistance('xHours', hours, localizeOptions);

	    // 1 up to 30 days
	  } else if (unit === 'day') {
	    var days = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions);

	    // 1 up to 12 months
	  } else if (unit === 'month') {
	    var months = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH);
	    return months === 12 && defaultUnit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions);

	    // 1 year up to max Date
	  } else if (unit === 'year') {
	    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
	    return locale.formatDistance('xYears', years, localizeOptions);
	  }
	  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
	}
	module.exports = exports$1.default; 
} (formatDistanceStrict$2, formatDistanceStrict$2.exports));

var formatDistanceStrictExports = formatDistanceStrict$2.exports;

var formatDistanceToNow$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatDistanceToNow;
	var _index = _interopRequireDefault(formatDistanceExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name formatDistanceToNow
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given date and now in words.
	 *
	 * | Distance to now                                                   | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance to now     | Result               |
	 * |---------------------|----------------------|
	 * | 0 secs ... 5 secs   | less than 5 seconds  |
	 * | 5 secs ... 10 secs  | less than 10 seconds |
	 * | 10 secs ... 20 secs | less than 20 seconds |
	 * | 20 secs ... 40 secs | half a minute        |
	 * | 40 secs ... 60 secs | less than a minute   |
	 * | 60 secs ... 90 secs | 1 minute             |
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * const result = formatDistanceToNow(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * const result = formatDistanceToNow(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * const result = formatDistanceToNow(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in about 1 year'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * const eoLocale = require('date-fns/locale/eo')
	 * const result = formatDistanceToNow(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function formatDistanceToNow(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	module.exports = exports$1.default; 
} (formatDistanceToNow$2, formatDistanceToNow$2.exports));

var formatDistanceToNowExports = formatDistanceToNow$2.exports;

var formatDistanceToNowStrict$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatDistanceToNowStrict;
	var _index = _interopRequireDefault(formatDistanceStrictExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name formatDistanceToNowStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * const result = formatDistanceToNowStrict(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * const result = formatDistanceToNowStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15)
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * const result = formatDistanceToNowStrict(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in 1 year'
	 *
	 * @example
	 * // If today is 28 January 2015,
	 * // what is the distance to 1 January 2015, in months, rounded up??
	 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016 in Esperanto?
	 * const eoLocale = require('date-fns/locale/eo')
	 * const result = formatDistanceToNowStrict(
	 *   new Date(2016, 0, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> '1 jaro'
	 */
	function formatDistanceToNowStrict(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	module.exports = exports$1.default; 
} (formatDistanceToNowStrict$2, formatDistanceToNowStrict$2.exports));

var formatDistanceToNowStrictExports = formatDistanceToNowStrict$2.exports;

var formatDuration$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatDuration;
	var _index = defaultOptions$1$1;
	var _index2 = _interopRequireDefault(defaultLocaleExports);
	var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];

	/**
	 * @name formatDuration
	 * @category Common Helpers
	 * @summary Formats a duration in human-readable format
	 *
	 * @description
	 * Return human-readable duration string i.e. "9 months 2 days"
	 *
	 * @param {Duration} duration - the duration to format
	 * @param {Object} [options] - an object with options.
	 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
	 * @param {boolean} [options.zero=false] - should zeros be included in the output?
	 * @param {string} [options.delimiter=' '] - delimiter string
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {string} the formatted date string
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Format full duration
	 * formatDuration({
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
	 *
	 * @example
	 * // Format partial duration
	 * formatDuration({ months: 9, days: 2 })
	 * //=> '9 months 2 days'
	 *
	 * @example
	 * // Customize the format
	 * formatDuration(
	 *   {
	 *     years: 2,
	 *     months: 9,
	 *     weeks: 1,
	 *     days: 7,
	 *     hours: 5,
	 *     minutes: 9,
	 *     seconds: 30
	 *   },
	 *   { format: ['months', 'weeks'] }
	 * ) === '9 months 1 week'
	 *
	 * @example
	 * // Customize the zeros presence
	 * formatDuration({ years: 0, months: 9 })
	 * //=> '9 months'
	 * formatDuration({ years: 0, months: 9 }, { zero: true })
	 * //=> '0 years 9 months'
	 *
	 * @example
	 * // Customize the delimiter
	 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
	 * //=> '2 years, 9 months, 3 weeks'
	 */
	function formatDuration(duration, options) {
	  var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index2.default;
	  var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat;
	  var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
	  var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : ' ';
	  if (!locale.formatDistance) {
	    return '';
	  }
	  var result = format.reduce(function (acc, unit) {
	    var token = "x".concat(unit.replace(/(^.)/, function (m) {
	      return m.toUpperCase();
	    }));
	    var value = duration[unit];
	    if (typeof value === 'number' && (zero || duration[unit])) {
	      return acc.concat(locale.formatDistance(token, value));
	    }
	    return acc;
	  }, []).join(delimiter);
	  return result;
	}
	module.exports = exports$1.default; 
} (formatDuration$2, formatDuration$2.exports));

var formatDurationExports = formatDuration$2.exports;

var formatISO$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatISO;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(addLeadingZerosExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name formatISO
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
	 *
	 * @description
	 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
	 * @returns {String} the formatted date string (in local time zone)
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.representation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918T190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, date only:
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52Z'
	 */
	function formatISO(date, options) {
	  var _options$format, _options$representati;
	  (0, _index3.default)(1, arguments);
	  var originalDate = (0, _index.default)(date);
	  if (isNaN(originalDate.getTime())) {
	    throw new RangeError('Invalid time value');
	  }
	  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
	  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	  var result = '';
	  var tzOffset = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : '';

	  // Representation is either 'date' or 'complete'
	  if (representation !== 'time') {
	    var day = (0, _index2.default)(originalDate.getDate(), 2);
	    var month = (0, _index2.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index2.default)(originalDate.getFullYear(), 4);

	    // yyyyMMdd or yyyy-MM-dd.
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  }

	  // Representation is either 'time' or 'complete'
	  if (representation !== 'date') {
	    // Add the timezone.
	    var offset = originalDate.getTimezoneOffset();
	    if (offset !== 0) {
	      var absoluteOffset = Math.abs(offset);
	      var hourOffset = (0, _index2.default)(Math.floor(absoluteOffset / 60), 2);
	      var minuteOffset = (0, _index2.default)(absoluteOffset % 60, 2);
	      // If less than 0, the sign is +, because it is ahead of time.
	      var sign = offset < 0 ? '+' : '-';
	      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	    } else {
	      tzOffset = 'Z';
	    }
	    var hour = (0, _index2.default)(originalDate.getHours(), 2);
	    var minute = (0, _index2.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index2.default)(originalDate.getSeconds(), 2);

	    // If there's also date, separate it with time with 'T'
	    var separator = result === '' ? '' : 'T';

	    // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
	    var time = [hour, minute, second].join(timeDelimiter);

	    // HHmmss or HH:mm:ss.
	    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
	  }
	  return result;
	}
	module.exports = exports$1.default; 
} (formatISO$2, formatISO$2.exports));

var formatISOExports = formatISO$2.exports;

var formatISO9075$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatISO9075;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(isValidExports);
	var _index3 = _interopRequireDefault(addLeadingZerosExports);
	/**
	 * @name formatISO9075
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
	 *
	 * @description
	 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.representation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18 19:00:52'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075, short format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918 190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, date only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, time only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52'
	 */
	function formatISO9075(dirtyDate, options) {
	  var _options$format, _options$representati;
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	  var originalDate = (0, _index.default)(dirtyDate);
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
	  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	  var result = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : '';

	  // Representation is either 'date' or 'complete'
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4);

	    // yyyyMMdd or yyyy-MM-dd.
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  }

	  // Representation is either 'time' or 'complete'
	  if (representation !== 'date') {
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2);

	    // If there's also date, separate it with time with a space
	    var separator = result === '' ? '' : ' ';

	    // HHmmss or HH:mm:ss.
	    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
	  }
	  return result;
	}
	module.exports = exports$1.default; 
} (formatISO9075$2, formatISO9075$2.exports));

var formatISO9075Exports = formatISO9075$2.exports;

var formatISODuration$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatISODuration;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name formatISODuration
	 * @category Common Helpers
	 * @summary Format a duration object according as ISO 8601 duration string
	 *
	 * @description
	 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
	 *
	 * @param {Duration} duration - the duration to format
	 *
	 * @returns {String} The ISO 8601 duration string
	 * @throws {TypeError} Requires 1 argument
	 * @throws {Error} Argument must be an object
	 *
	 * @example
	 * // Format the given duration as ISO 8601 string
	 * const result = formatISODuration({
	 *   years: 39,
	 *   months: 2,
	 *   days: 20,
	 *   hours: 7,
	 *   minutes: 5,
	 *   seconds: 0
	 * })
	 * //=> 'P39Y2M20DT0H0M0S'
	 */
	function formatISODuration(duration) {
	  (0, _index.default)(1, arguments);
	  if ((0, _typeof2.default)(duration) !== 'object') throw new Error('Duration must be an object');
	  var _duration$years = duration.years,
	    years = _duration$years === void 0 ? 0 : _duration$years,
	    _duration$months = duration.months,
	    months = _duration$months === void 0 ? 0 : _duration$months,
	    _duration$days = duration.days,
	    days = _duration$days === void 0 ? 0 : _duration$days,
	    _duration$hours = duration.hours,
	    hours = _duration$hours === void 0 ? 0 : _duration$hours,
	    _duration$minutes = duration.minutes,
	    minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
	    _duration$seconds = duration.seconds,
	    seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
	  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
	}
	module.exports = exports$1.default; 
} (formatISODuration$2, formatISODuration$2.exports));

var formatISODurationExports = formatISODuration$2.exports;

var formatRFC3339$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatRFC3339;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(isValidExports);
	var _index3 = _interopRequireDefault(addLeadingZerosExports);
	var _index4 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name formatRFC3339
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
	 *
	 * @description
	 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 2 digits of second fraction:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
	 * //=> '2019-09-18T19:00:52.23Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
	 * //=> '2019-09-18T19:00:52.234Z'
	 */
	function formatRFC3339(dirtyDate, options) {
	  var _options$fractionDigi;
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	  var originalDate = (0, _index.default)(dirtyDate);
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	  var fractionDigits = Number((_options$fractionDigi = options === null || options === void 0 ? void 0 : options.fractionDigits) !== null && _options$fractionDigi !== void 0 ? _options$fractionDigi : 0);

	  // Test if fractionDigits is between 0 and 3 _and_ is not NaN
	  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
	    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
	  }
	  var day = (0, _index3.default)(originalDate.getDate(), 2);
	  var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	  var year = originalDate.getFullYear();
	  var hour = (0, _index3.default)(originalDate.getHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getSeconds(), 2);
	  var fractionalSecond = '';
	  if (fractionDigits > 0) {
	    var milliseconds = originalDate.getMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
	    fractionalSecond = '.' + (0, _index3.default)(fractionalSeconds, fractionDigits);
	  }
	  var offset = '';
	  var tzOffset = originalDate.getTimezoneOffset();
	  if (tzOffset !== 0) {
	    var absoluteOffset = Math.abs(tzOffset);
	    var hourOffset = (0, _index3.default)((0, _index4.default)(absoluteOffset / 60), 2);
	    var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2);
	    // If less than 0, the sign is +, because it is ahead of time.
	    var sign = tzOffset < 0 ? '+' : '-';
	    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	  } else {
	    offset = 'Z';
	  }
	  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
	}
	module.exports = exports$1.default; 
} (formatRFC3339$2, formatRFC3339$2.exports));

var formatRFC3339Exports = formatRFC3339$2.exports;

var formatRFC7231$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatRFC7231;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(isValidExports);
	var _index3 = _interopRequireDefault(addLeadingZerosExports);
	var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

	/**
	 * @name formatRFC7231
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
	 *
	 * @description
	 * Return the formatted date string in RFC 7231 format.
	 * The result will always be in UTC timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 7231 format:
	 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
	 */
	function formatRFC7231(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	  var originalDate = (0, _index.default)(dirtyDate);
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	  var dayName = days[originalDate.getUTCDay()];
	  var dayOfMonth = (0, _index3.default)(originalDate.getUTCDate(), 2);
	  var monthName = months[originalDate.getUTCMonth()];
	  var year = originalDate.getUTCFullYear();
	  var hour = (0, _index3.default)(originalDate.getUTCHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getUTCMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getUTCSeconds(), 2);

	  // Result variables.
	  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
	}
	module.exports = exports$1.default; 
} (formatRFC7231$2, formatRFC7231$2.exports));

var formatRFC7231Exports = formatRFC7231$2.exports;

var formatRelative$2I = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = formatRelative;
	var _index = defaultOptions$1$1;
	var _index2 = _interopRequireDefault(differenceInCalendarDaysExports);
	var _index3 = _interopRequireDefault(formatExports);
	var _index4 = _interopRequireDefault(defaultLocaleExports);
	var _index5 = _interopRequireDefault(subMillisecondsExports);
	var _index6 = _interopRequireDefault(toDateExports);
	var _index7 = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index8 = _interopRequireDefault(requiredArgsExports);
	var _index9 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name formatRelative
	 * @category Common Helpers
	 * @summary Represent the date in words relative to the given base date.
	 *
	 * @description
	 * Represent the date in words relative to the given base date.
	 *
	 * | Distance to the base date | Result                    |
	 * |---------------------------|---------------------------|
	 * | Previous 6 days           | last Sunday at 04:30 AM   |
	 * | Last day                  | yesterday at 04:30 AM     |
	 * | Same day                  | today at 04:30 AM         |
	 * | Next day                  | tomorrow at 04:30 AM      |
	 * | Next 6 days               | Sunday at 04:30 AM        |
	 * | Other                     | 12/31/2017                |
	 *
	 * @param {Date|Number} date - the date to format
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {String} the date in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.locale` must contain `formatRelative` property
	 *
	 * @example
	 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
	 * const result = formatRelative(addDays(new Date(), -6), new Date())
	 * //=> "last Thursday at 12:45 AM"
	 */
	function formatRelative(dirtyDate, dirtyBaseDate, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index8.default)(2, arguments);
	  var date = (0, _index6.default)(dirtyDate);
	  var baseDate = (0, _index6.default)(dirtyBaseDate);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index4.default;
	  var weekStartsOn = (0, _index9.default)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	  if (!locale.formatRelative) {
	    throw new RangeError('locale must contain formatRelative property');
	  }
	  var diff = (0, _index2.default)(date, baseDate);
	  if (isNaN(diff)) {
	    throw new RangeError('Invalid time value');
	  }
	  var token;
	  if (diff < -6) {
	    token = 'other';
	  } else if (diff < -1) {
	    token = 'lastWeek';
	  } else if (diff < 0) {
	    token = 'yesterday';
	  } else if (diff < 1) {
	    token = 'today';
	  } else if (diff < 2) {
	    token = 'tomorrow';
	  } else if (diff < 7) {
	    token = 'nextWeek';
	  } else {
	    token = 'other';
	  }
	  var utcDate = (0, _index5.default)(date, (0, _index7.default)(date));
	  var utcBaseDate = (0, _index5.default)(baseDate, (0, _index7.default)(baseDate));
	  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	  return (0, _index3.default)(date, formatStr, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	}
	module.exports = exports$1.default; 
} (formatRelative$2I, formatRelative$2I.exports));

var formatRelativeExports = formatRelative$2I.exports;

var fromUnixTime$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = fromUnixTime;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(toIntegerExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name fromUnixTime
	 * @category Timestamp Helpers
	 * @summary Create a date from a Unix timestamp.
	 *
	 * @description
	 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
	 *
	 * @param {Number} unixTime - the given Unix timestamp (in seconds)
	 * @returns {Date} the date
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Create the date 29 February 2012 11:45:05:
	 * const result = fromUnixTime(1330515905)
	 * //=> Wed Feb 29 2012 11:45:05
	 */
	function fromUnixTime(dirtyUnixTime) {
	  (0, _index3.default)(1, arguments);
	  var unixTime = (0, _index2.default)(dirtyUnixTime);
	  return (0, _index.default)(unixTime * 1000);
	}
	module.exports = exports$1.default; 
} (fromUnixTime$2, fromUnixTime$2.exports));

var fromUnixTimeExports = fromUnixTime$2.exports;

var getDate$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getDate;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * const result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	module.exports = exports$1.default; 
} (getDate$2, getDate$2.exports));

var getDateExports = getDate$2.exports;

var getDay$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getDay;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * const result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	module.exports = exports$1.default; 
} (getDay$2, getDay$2.exports));

var getDayExports = getDay$2.exports;

var getDayOfYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getDayOfYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(startOfYearExports);
	var _index3 = _interopRequireDefault(differenceInCalendarDaysExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getDayOfYear
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * const result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index3.default)(date, (0, _index2.default)(date));
	  var dayOfYear = diff + 1;
	  return dayOfYear;
	}
	module.exports = exports$1.default; 
} (getDayOfYear$2, getDayOfYear$2.exports));

var getDayOfYearExports = getDayOfYear$2.exports;

var getDaysInMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getDaysInMonth;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * const result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	module.exports = exports$1.default; 
} (getDaysInMonth$2, getDaysInMonth$2.exports));

var getDaysInMonthExports = getDaysInMonth$2.exports;

var getDaysInYear$2 = {exports: {}};

var isLeapYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isLeapYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isLeapYear
	 * @category Year Helpers
	 * @summary Is the given date in the leap year?
	 *
	 * @description
	 * Is the given date in the leap year?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the leap year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2012 in the leap year?
	 * const result = isLeapYear(new Date(2012, 8, 1))
	 * //=> true
	 */
	function isLeapYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	module.exports = exports$1.default; 
} (isLeapYear$2, isLeapYear$2.exports));

var isLeapYearExports = isLeapYear$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getDaysInYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(isLeapYearExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getDaysInYear
	 * @category Year Helpers
	 * @summary Get the number of days in a year of the given date.
	 *
	 * @description
	 * Get the number of days in a year of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in 2012?
	 * const result = getDaysInYear(new Date(2012, 0, 1))
	 * //=> 366
	 */
	function getDaysInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  if (String(new Date(date)) === 'Invalid Date') {
	    return NaN;
	  }
	  return (0, _index2.default)(date) ? 366 : 365;
	}
	module.exports = exports$1.default; 
} (getDaysInYear$2, getDaysInYear$2.exports));

var getDaysInYearExports = getDaysInYear$2.exports;

var getDecade$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getDecade;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getDecade
	 * @category Decade Helpers
	 * @summary Get the decade of the given date.
	 *
	 * @description
	 * Get the decade of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year of decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which decade belongs 27 November 1942?
	 * const result = getDecade(new Date(1942, 10, 27))
	 * //=> 1940
	 */
	function getDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  return decade;
	}
	module.exports = exports$1.default; 
} (getDecade$2, getDecade$2.exports));

var getDecadeExports = getDecade$2.exports;

var getDefaultOptions$3 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getDefaultOptions;
	var _index = defaultOptions$1$1;
	var _index2 = _interopRequireDefault(assignExports);
	/**
	 * @name getDefaultOptions
	 * @category Common Helpers
	 * @summary Get default options.
	 * @pure false
	 *
	 * @description
	 * Returns an object that contains defaults for
	 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
	 * arguments for all functions.
	 *
	 * You can change these with [setDefaultOptions]{@link https://date-fns.org/docs/setDefaultOptions}.
	 *
	 * @returns {Object} default options
	 *
	 * @example
	 * const result = getDefaultOptions()
	 * //=> {}
	 *
	 * @example
	 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
	 * const result = getDefaultOptions()
	 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
	 */
	function getDefaultOptions() {
	  return (0, _index2.default)({}, (0, _index.getDefaultOptions)());
	}
	module.exports = exports$1.default; 
} (getDefaultOptions$3, getDefaultOptions$3.exports));

var getDefaultOptionsExports = getDefaultOptions$3.exports;

var getHours$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getHours;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * const result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	module.exports = exports$1.default; 
} (getHours$2, getHours$2.exports));

var getHoursExports = getHours$2.exports;

var getISODay$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getISODay;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getISODay
	 * @category Weekday Helpers
	 * @summary Get the day of the ISO week of the given date.
	 *
	 * @description
	 * Get the day of the ISO week of the given date,
	 * which is 7 for Sunday, 1 for Monday etc.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the ISO week is 26 February 2012?
	 * const result = getISODay(new Date(2012, 1, 26))
	 * //=> 7
	 */
	function getISODay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  if (day === 0) {
	    day = 7;
	  }
	  return day;
	}
	module.exports = exports$1.default; 
} (getISODay$2, getISODay$2.exports));

var getISODayExports = getISODay$2.exports;

var getISOWeek$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getISOWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(startOfISOWeekExports);
	var _index3 = _interopRequireDefault(startOfISOWeekYearExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_WEEK = 604800000;

	/**
	 * @name getISOWeek
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	function getISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports$1.default; 
} (getISOWeek$2, getISOWeek$2.exports));

var getISOWeekExports = getISOWeek$2.exports;

var getISOWeeksInYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getISOWeeksInYear;
	var _index = _interopRequireDefault(startOfISOWeekYearExports);
	var _index2 = _interopRequireDefault(addWeeksExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_WEEK = 604800000;

	/**
	 * @name getISOWeeksInYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of ISO weeks in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many weeks are in ISO week-numbering year 2015?
	 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
	 * //=> 53
	 */
	function getISOWeeksInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var thisYear = (0, _index.default)(dirtyDate);
	  var nextYear = (0, _index.default)((0, _index2.default)(thisYear, 60));
	  var diff = nextYear.valueOf() - thisYear.valueOf();
	  // Round the number of weeks to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK);
	}
	module.exports = exports$1.default; 
} (getISOWeeksInYear$2, getISOWeeksInYear$2.exports));

var getISOWeeksInYearExports = getISOWeeksInYear$2.exports;

var getMilliseconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getMilliseconds;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the milliseconds of the given date.
	 *
	 * @description
	 * Get the milliseconds of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the milliseconds of 29 February 2012 11:45:05.123:
	 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 123
	 */
	function getMilliseconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var milliseconds = date.getMilliseconds();
	  return milliseconds;
	}
	module.exports = exports$1.default; 
} (getMilliseconds$2, getMilliseconds$2.exports));

var getMillisecondsExports = getMilliseconds$2.exports;

var getMinutes$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getMinutes;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	module.exports = exports$1.default; 
} (getMinutes$2, getMinutes$2.exports));

var getMinutesExports = getMinutes$2.exports;

var getMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getMonth;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * const result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	module.exports = exports$1.default; 
} (getMonth$2, getMonth$2.exports));

var getMonthExports = getMonth$2.exports;

var getOverlappingDaysInIntervals$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getOverlappingDaysInIntervals;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

	/**
	 * @name getOverlappingDaysInIntervals
	 * @category Interval Helpers
	 * @summary Get the number of days that overlap in two time intervals
	 *
	 * @description
	 * Get the number of days that overlap in two time intervals
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
	 * @returns {Number} the number of days that overlap in two time intervals
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals adds 1 for each started overlapping day:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> 3
	 *
	 * @example
	 * // For non-overlapping time intervals returns 0:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> 0
	 */

	function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime();

	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	  if (!isOverlapping) {
	    return 0;
	  }
	  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
	  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
	  var differenceInMs = overlapEndDate - overlapStartDate;
	  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
	}
	module.exports = exports$1.default; 
} (getOverlappingDaysInIntervals$2, getOverlappingDaysInIntervals$2.exports));

var getOverlappingDaysInIntervalsExports = getOverlappingDaysInIntervals$2.exports;

var getSeconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getSeconds;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	module.exports = exports$1.default; 
} (getSeconds$2, getSeconds$2.exports));

var getSecondsExports = getSeconds$2.exports;

var getTime$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getTime;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	module.exports = exports$1.default; 
} (getTime$2, getTime$2.exports));

var getTimeExports = getTime$2.exports;

var getUnixTime$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getUnixTime;
	var _index = _interopRequireDefault(getTimeExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getUnixTime
	 * @category Timestamp Helpers
	 * @summary Get the seconds timestamp of the given date.
	 *
	 * @description
	 * Get the seconds timestamp of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05 CET:
	 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 1330512305
	 */
	function getUnixTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return Math.floor((0, _index.default)(dirtyDate) / 1000);
	}
	module.exports = exports$1.default; 
} (getUnixTime$2, getUnixTime$2.exports));

var getUnixTimeExports = getUnixTime$2.exports;

var getWeek$2 = {exports: {}};

var startOfWeekYear$2 = {exports: {}};

var getWeekYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getWeekYear;
	var _index = _interopRequireDefault(startOfWeekExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var _index5 = defaultOptions$1$1;
	/**
	 * @name getWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Get the local week-numbering year of the given date.
	 *
	 * @description
	 * Get the local week-numbering year of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the local week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 with the default settings?
	 * const result = getWeekYear(new Date(2004, 11, 26))
	 * //=> 2005
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
	 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
	 * //=> 2004
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
	 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
	 * //=> 2004
	 */
	function getWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = date.getFullYear();
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index.default)(firstWeekOfThisYear, options);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports$1.default; 
} (getWeekYear$2, getWeekYear$2.exports));

var getWeekYearExports = getWeekYear$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfWeekYear;
	var _index = _interopRequireDefault(getWeekYearExports);
	var _index2 = _interopRequireDefault(startOfWeekExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var _index5 = defaultOptions$1$1;
	/**
	 * @name startOfWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Return the start of a local week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of a local week-numbering year.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the start of a week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // The start of an a week-numbering year for 2 July 2005 with default settings:
	 * const result = startOfWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // The start of a week-numbering year for 2 July 2005
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * const result = startOfWeekYear(new Date(2005, 6, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var year = (0, _index.default)(dirtyDate, options);
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(firstWeek, options);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfWeekYear$2, startOfWeekYear$2.exports));

var startOfWeekYearExports = startOfWeekYear$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getWeek;
	var _index = _interopRequireDefault(startOfWeekExports);
	var _index2 = _interopRequireDefault(startOfWeekYearExports);
	var _index3 = _interopRequireDefault(toDateExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_WEEK = 604800000;

	/**
	 * @name getWeek
	 * @category Week Helpers
	 * @summary Get the local week index of the given date.
	 *
	 * @description
	 * Get the local week index of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week of the local week numbering year is 2 January 2005 with default options?
	 * const result = getWeek(new Date(2005, 0, 2))
	 * //=> 2
	 *
	 * // Which week of the local week numbering year is 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January?
	 * const result = getWeek(new Date(2005, 0, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> 53
	 */

	function getWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index3.default)(dirtyDate);
	  var diff = (0, _index.default)(date, options).getTime() - (0, _index2.default)(date, options).getTime();

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports$1.default; 
} (getWeek$2, getWeek$2.exports));

var getWeekExports = getWeek$2.exports;

var getWeekOfMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getWeekOfMonth;
	var _index = defaultOptions$1$1;
	var _index2 = _interopRequireDefault(getDateExports);
	var _index3 = _interopRequireDefault(getDayExports);
	var _index4 = _interopRequireDefault(startOfMonthExports);
	var _index5 = _interopRequireDefault(requiredArgsExports);
	var _index6 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name getWeekOfMonth
	 * @category Week Helpers
	 * @summary Get the week of the month of the given date.
	 *
	 * @description
	 * Get the week of the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the week of month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6 inclusively
	 *
	 * @example
	 * // Which week of the month is 9 November 2017?
	 * const result = getWeekOfMonth(new Date(2017, 10, 9))
	 * //=> 2
	 */
	function getWeekOfMonth(date, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index5.default)(1, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var weekStartsOn = (0, _index6.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var currentDayOfMonth = (0, _index2.default)(date);
	  if (isNaN(currentDayOfMonth)) return NaN;
	  var startWeekDay = (0, _index3.default)((0, _index4.default)(date));
	  var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
	  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
	  var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
	  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
	}
	module.exports = exports$1.default; 
} (getWeekOfMonth$2, getWeekOfMonth$2.exports));

var getWeekOfMonthExports = getWeekOfMonth$2.exports;

var getWeeksInMonth$2 = {exports: {}};

var lastDayOfMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = lastDayOfMonth;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name lastDayOfMonth
	 * @category Month Helpers
	 * @summary Return the last day of a month for the given date.
	 *
	 * @description
	 * Return the last day of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a month for 2 September 2014 11:55:00:
	 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (lastDayOfMonth$2, lastDayOfMonth$2.exports));

var lastDayOfMonthExports = lastDayOfMonth$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getWeeksInMonth;
	var _index = _interopRequireDefault(differenceInCalendarWeeksExports);
	var _index2 = _interopRequireDefault(lastDayOfMonthExports);
	var _index3 = _interopRequireDefault(startOfMonthExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getWeeksInMonth
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks a month spans.
	 *
	 * @description
	 * Get the number of calendar weeks the month in the given date spans.
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks does February 2015 span?
	 * const result = getWeeksInMonth(new Date(2015, 1, 8))
	 * //=> 4
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks does July 2017 span?
	 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
	 * //=> 6
	 */
	function getWeeksInMonth(date, options) {
	  (0, _index4.default)(1, arguments);
	  return (0, _index.default)((0, _index2.default)(date), (0, _index3.default)(date), options) + 1;
	}
	module.exports = exports$1.default; 
} (getWeeksInMonth$2, getWeeksInMonth$2.exports));

var getWeeksInMonthExports = getWeeksInMonth$2.exports;

var getYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = getYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * const result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getFullYear();
	}
	module.exports = exports$1.default; 
} (getYear$2, getYear$2.exports));

var getYearExports = getYear$2.exports;

var hoursToMilliseconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = hoursToMilliseconds;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name hoursToMilliseconds
	 * @category  Conversion Helpers
	 * @summary Convert hours to milliseconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of milliseconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted to milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to milliseconds:
	 * const result = hoursToMilliseconds(2)
	 * //=> 7200000
	 */
	function hoursToMilliseconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.millisecondsInHour);
	}
	module.exports = exports$1.default; 
} (hoursToMilliseconds$2, hoursToMilliseconds$2.exports));

var hoursToMillisecondsExports = hoursToMilliseconds$2.exports;

var hoursToMinutes$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = hoursToMinutes;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name hoursToMinutes
	 * @category Conversion Helpers
	 * @summary Convert hours to minutes.
	 *
	 * @description
	 * Convert a number of hours to a full number of minutes.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to minutes:
	 * const result = hoursToMinutes(2)
	 * //=> 120
	 */
	function hoursToMinutes(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.minutesInHour);
	}
	module.exports = exports$1.default; 
} (hoursToMinutes$2, hoursToMinutes$2.exports));

var hoursToMinutesExports = hoursToMinutes$2.exports;

var hoursToSeconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = hoursToSeconds;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name hoursToSeconds
	 * @category Conversion Helpers
	 * @summary Convert hours to seconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of seconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to seconds:
	 * const result = hoursToSeconds(2)
	 * //=> 7200
	 */
	function hoursToSeconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.secondsInHour);
	}
	module.exports = exports$1.default; 
} (hoursToSeconds$2, hoursToSeconds$2.exports));

var hoursToSecondsExports = hoursToSeconds$2.exports;

var intervalToDuration$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = intervalToDuration;
	var _index = _interopRequireDefault(compareAscExports);
	var _index2 = _interopRequireDefault(addExports);
	var _index3 = _interopRequireDefault(differenceInDaysExports);
	var _index4 = _interopRequireDefault(differenceInHoursExports);
	var _index5 = _interopRequireDefault(differenceInMinutesExports);
	var _index6 = _interopRequireDefault(differenceInMonthsExports);
	var _index7 = _interopRequireDefault(differenceInSecondsExports);
	var _index8 = _interopRequireDefault(differenceInYearsExports);
	var _index9 = _interopRequireDefault(toDateExports);
	var _index10 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name intervalToDuration
	 * @category Common Helpers
	 * @summary Convert interval to duration
	 *
	 * @description
	 * Convert a interval object to a duration object.
	 *
	 * @param {Interval} interval - the interval to convert to duration
	 *
	 * @returns {Duration} The duration Object
	 * @throws {TypeError} Requires 2 arguments
	 * @throws {RangeError} `start` must not be Invalid Date
	 * @throws {RangeError} `end` must not be Invalid Date
	 *
	 * @example
	 * // Get the duration between January 15, 1929 and April 4, 1968.
	 * intervalToDuration({
	 *   start: new Date(1929, 0, 15, 12, 0, 0),
	 *   end: new Date(1968, 3, 4, 19, 5, 0)
	 * })
	 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
	 */
	function intervalToDuration(interval) {
	  (0, _index10.default)(1, arguments);
	  var start = (0, _index9.default)(interval.start);
	  var end = (0, _index9.default)(interval.end);
	  if (isNaN(start.getTime())) throw new RangeError('Start Date is invalid');
	  if (isNaN(end.getTime())) throw new RangeError('End Date is invalid');
	  var duration = {};
	  duration.years = Math.abs((0, _index8.default)(end, start));
	  var sign = (0, _index.default)(end, start);
	  var remainingMonths = (0, _index2.default)(start, {
	    years: sign * duration.years
	  });
	  duration.months = Math.abs((0, _index6.default)(end, remainingMonths));
	  var remainingDays = (0, _index2.default)(remainingMonths, {
	    months: sign * duration.months
	  });
	  duration.days = Math.abs((0, _index3.default)(end, remainingDays));
	  var remainingHours = (0, _index2.default)(remainingDays, {
	    days: sign * duration.days
	  });
	  duration.hours = Math.abs((0, _index4.default)(end, remainingHours));
	  var remainingMinutes = (0, _index2.default)(remainingHours, {
	    hours: sign * duration.hours
	  });
	  duration.minutes = Math.abs((0, _index5.default)(end, remainingMinutes));
	  var remainingSeconds = (0, _index2.default)(remainingMinutes, {
	    minutes: sign * duration.minutes
	  });
	  duration.seconds = Math.abs((0, _index7.default)(end, remainingSeconds));
	  return duration;
	}
	module.exports = exports$1.default; 
} (intervalToDuration$2, intervalToDuration$2.exports));

var intervalToDurationExports = intervalToDuration$2.exports;

var intlFormat$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = intlFormat;
	var _index = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name intlFormat
	 * @category Common Helpers
	 * @summary  Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
	 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
	 *
	 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
	 *
	 * @param {Date|Number} argument - the original date.
	 * @param {Object} [formatOptions] - an object with options.
	 * @param {'lookup'|'best fit'} [formatOptions.localeMatcher='best fit'] - locale selection algorithm.
	 * @param {'narrow'|'short'|'long'} [formatOptions.weekday] - representation the days of the week.
	 * @param {'narrow'|'short'|'long'} [formatOptions.era] - representation of eras.
	 * @param {'numeric'|'2-digit'} [formatOptions.year] - representation of years.
	 * @param {'numeric'|'2-digit'|'narrow'|'short'|'long'} [formatOptions.month='numeric'] - representation of month.
	 * @param {'numeric'|'2-digit'} [formatOptions.day='numeric'] - representation of day.
	 * @param {'numeric'|'2-digit'} [formatOptions.hour='numeric'] - representation of hours.
	 * @param {'numeric'|'2-digit'} [formatOptions.minute] - representation of minutes.
	 * @param {'numeric'|'2-digit'} [formatOptions.second] - representation of seconds.
	 * @param {'short'|'long'} [formatOptions.timeZoneName] - representation of names of time zones.
	 * @param {'basic'|'best fit'} [formatOptions.formatMatcher='best fit'] - format selection algorithm.
	 * @param {Boolean} [formatOptions.hour12] - determines whether to use 12-hour time format.
	 * @param {String} [formatOptions.timeZone] - the time zone to use.
	 * @param {Object} [localeOptions] - an object with locale.
	 * @param {String|String[]} [localeOptions.locale] - the locale code
	 * @returns {String} the formatted date string.
	 * @throws {TypeError} 1 argument required.
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 10 October 2019 in German.
	 * // Convert the date with format's options and locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      weekday: 'long',
	 *      year: 'numeric',
	 *      month: 'long',
	 *      day: 'numeric',
	 *    }, {
	 *      locale: 'de-DE',
	 *  })
	 * //=> Freitag, 4. Oktober 2019
	 *
	 * @example
	 * // Represent 10 October 2019.
	 * // Convert the date with format's options.
	 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      year: 'numeric',
	 *      month: 'numeric',
	 *      day: 'numeric',
	 *      hour: 'numeric',
	 *  })
	 * //=> 10/4/2019, 12 PM
	 *
	 * @example
	 * // Represent 10 October 2019 in Korean.
	 * // Convert the date with locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      locale: 'ko-KR',
	 *  })
	 * //=> 2019. 10. 4.
	 *
	 * @example
	 * // Represent 10 October 2019 in middle-endian format:
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
	 * //=> 10/4/2019
	 */
	function intlFormat(date, formatOrLocale, localeOptions) {
	  var _localeOptions;
	  (0, _index.default)(1, arguments);
	  var formatOptions;
	  if (isFormatOptions(formatOrLocale)) {
	    formatOptions = formatOrLocale;
	  } else {
	    localeOptions = formatOrLocale;
	  }
	  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
	}
	function isFormatOptions(opts) {
	  return opts !== undefined && !('locale' in opts);
	}
	module.exports = exports$1.default; 
} (intlFormat$2, intlFormat$2.exports));

var intlFormatExports = intlFormat$2.exports;

var intlFormatDistance$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = intlFormatDistance;
	var _index = constants$1$1;
	var _index2 = _interopRequireDefault(differenceInCalendarDaysExports);
	var _index3 = _interopRequireDefault(differenceInCalendarMonthsExports);
	var _index4 = _interopRequireDefault(differenceInCalendarQuartersExports);
	var _index5 = _interopRequireDefault(differenceInCalendarWeeksExports);
	var _index6 = _interopRequireDefault(differenceInCalendarYearsExports);
	var _index7 = _interopRequireDefault(differenceInHoursExports);
	var _index8 = _interopRequireDefault(differenceInMinutesExports);
	var _index9 = _interopRequireDefault(differenceInSecondsExports);
	var _index10 = _interopRequireDefault(toDateExports);
	var _index11 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name intlFormatDistance
	 * @category Common Helpers
	 * @summary Formats distance between two dates in a human-readable format
	 * @description
	 * The function calculates the difference between two dates and formats it as a human-readable string.
	 *
	 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
	 *
	 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
	 *
	 * See the table below for the unit picking logic:
	 *
	 * | Distance between dates | Result (past)  | Result (future) |
	 * | ---------------------- | -------------- | --------------- |
	 * | 0 seconds              | now            | now             |
	 * | 1-59 seconds           | X seconds ago  | in X seconds    |
	 * | 1-59 minutes           | X minutes ago  | in X minutes    |
	 * | 1-23 hours             | X hours ago    | in X hours      |
	 * | 1 day                  | yesterday      | tomorrow        |
	 * | 2-6 days               | X days ago     | in X days       |
	 * | 7 days                 | last week      | next week       |
	 * | 8 days-1 month         | X weeks ago    | in X weeks      |
	 * | 1 month                | last month     | next month      |
	 * | 2-3 months             | X months ago   | in X months     |
	 * | 1 quarter              | last quarter   | next quarter    |
	 * | 2-3 quarters           | X quarters ago | in X quarters   |
	 * | 1 year                 | last year      | next year       |
	 * | 2+ years               | X years ago    | in X years      |
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with.
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.unit] - formats the distance with the given unit ('year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second').
	 * @param {String|String[]} [options.locale] - the locale to use.
	 * @param {String} [options.localeMatcher='best fit'] - the locale matching algorithm to use. Other value: 'lookup'.
	 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
	 * @param {String} [options.numeric='auto'] - the output message format. The values are 'auto' (e.g. `yesterday`), 'always'(e.g. `1 day ago`).
	 * @param {String} [options.style='long'] - the length of the result. The values are: 'long' (e.g. `1 month`), 'short' (e.g. 'in 1 mo.'), 'narrow' (e.g. 'in 1 mo.').
	 * The narrow one could be similar to the short one for some locales.
	 * @returns {String} the distance in words according to language-sensitive relative time formatting.
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.unit` must not be invalid Unit
	 * @throws {RangeError} `options.locale` must not be invalid locale
	 * @throws {RangeError} `options.localeMatcher` must not be invalid localeMatcher
	 * @throws {RangeError} `options.numeric` must not be invalid numeric
	 * @throws {RangeError} `options.style` must not be invalid style
	 *
	 * @example
	 * // What is the distance between the dates when the fist date is after the second?
	 * intlFormatDistance(
	 *   new Date(1986, 3, 4, 11, 30, 0),
	 *   new Date(1986, 3, 4, 10, 30, 0)
	 * )
	 * //=> 'in 1 hour'
	 *
	 * // What is the distance between the dates when the fist date is before the second?
	 * intlFormatDistance(
	 *   new Date(1986, 3, 4, 10, 30, 0),
	 *   new Date(1986, 3, 4, 11, 30, 0)
	 * )
	 * //=> '1 hour ago'
	 *
	 * @example
	 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
	 * intlFormatDistance(
	 *   new Date(1987, 6, 4, 10, 30, 0),
	 *   new Date(1986, 3, 4, 10, 30, 0),
	 *   { unit: 'quarter' }
	 * )
	 * //=> 'in 5 quarters'
	 *
	 * @example
	 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
	 * intlFormatDistance(
	 *   new Date(1986, 3, 4, 11, 30, 0),
	 *   new Date(1986, 3, 4, 10, 30, 0),
	 *   { locale: 'es' }
	 * )
	 * //=> 'dentro de 1 hora'
	 *
	 * @example
	 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
	 * intlFormatDistance(
	 *   new Date(1986, 3, 5, 11, 30, 0),
	 *   new Date(1986, 3, 4, 11, 30, 0),
	 *   { numeric: 'always' }
	 * )
	 * //=> 'in 1 day'
	 *
	 * @example
	 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
	 * intlFormatDistance(
	 *   new Date(1988, 3, 4, 11, 30, 0),
	 *   new Date(1986, 3, 4, 11, 30, 0),
	 *   { style: 'short' }
	 * )
	 * //=> 'in 2 yr'
	 */
	function intlFormatDistance(date, baseDate, options) {
	  (0, _index11.default)(2, arguments);
	  var value = 0;
	  var unit;
	  var dateLeft = (0, _index10.default)(date);
	  var dateRight = (0, _index10.default)(baseDate);
	  if (!(options !== null && options !== void 0 && options.unit)) {
	    // Get the unit based on diffInSeconds calculations if no unit is specified
	    var diffInSeconds = (0, _index9.default)(dateLeft, dateRight); // The smallest unit

	    if (Math.abs(diffInSeconds) < _index.secondsInMinute) {
	      value = (0, _index9.default)(dateLeft, dateRight);
	      unit = 'second';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInHour) {
	      value = (0, _index8.default)(dateLeft, dateRight);
	      unit = 'minute';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInDay && Math.abs((0, _index2.default)(dateLeft, dateRight)) < 1) {
	      value = (0, _index7.default)(dateLeft, dateRight);
	      unit = 'hour';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInWeek && (value = (0, _index2.default)(dateLeft, dateRight)) && Math.abs(value) < 7) {
	      unit = 'day';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInMonth) {
	      value = (0, _index5.default)(dateLeft, dateRight);
	      unit = 'week';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInQuarter) {
	      value = (0, _index3.default)(dateLeft, dateRight);
	      unit = 'month';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInYear) {
	      if ((0, _index4.default)(dateLeft, dateRight) < 4) {
	        // To filter out cases that are less than a year but match 4 quarters
	        value = (0, _index4.default)(dateLeft, dateRight);
	        unit = 'quarter';
	      } else {
	        value = (0, _index6.default)(dateLeft, dateRight);
	        unit = 'year';
	      }
	    } else {
	      value = (0, _index6.default)(dateLeft, dateRight);
	      unit = 'year';
	    }
	  } else {
	    // Get the value if unit is specified
	    unit = options === null || options === void 0 ? void 0 : options.unit;
	    if (unit === 'second') {
	      value = (0, _index9.default)(dateLeft, dateRight);
	    } else if (unit === 'minute') {
	      value = (0, _index8.default)(dateLeft, dateRight);
	    } else if (unit === 'hour') {
	      value = (0, _index7.default)(dateLeft, dateRight);
	    } else if (unit === 'day') {
	      value = (0, _index2.default)(dateLeft, dateRight);
	    } else if (unit === 'week') {
	      value = (0, _index5.default)(dateLeft, dateRight);
	    } else if (unit === 'month') {
	      value = (0, _index3.default)(dateLeft, dateRight);
	    } else if (unit === 'quarter') {
	      value = (0, _index4.default)(dateLeft, dateRight);
	    } else if (unit === 'year') {
	      value = (0, _index6.default)(dateLeft, dateRight);
	    }
	  }
	  var rtf = new Intl.RelativeTimeFormat(options === null || options === void 0 ? void 0 : options.locale, {
	    localeMatcher: options === null || options === void 0 ? void 0 : options.localeMatcher,
	    numeric: (options === null || options === void 0 ? void 0 : options.numeric) || 'auto',
	    style: options === null || options === void 0 ? void 0 : options.style
	  });
	  return rtf.format(value, unit);
	}
	module.exports = exports$1.default; 
} (intlFormatDistance$2, intlFormatDistance$2.exports));

var intlFormatDistanceExports = intlFormatDistance$2.exports;

var isAfter$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isAfter;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	module.exports = exports$1.default; 
} (isAfter$2, isAfter$2.exports));

var isAfterExports = isAfter$2.exports;

var isBefore$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isBefore;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	module.exports = exports$1.default; 
} (isBefore$2, isBefore$2.exports));

var isBeforeExports = isBefore$2.exports;

var isEqual$3 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isEqual;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * const result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	module.exports = exports$1.default; 
} (isEqual$3, isEqual$3.exports));

var isEqualExports = isEqual$3.exports;

var isExists$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isExists;
	/**
	 * @name isExists
	 * @category Common Helpers
	 * @summary Is the given date exists?
	 *
	 * @description
	 * Checks if the given arguments convert to an existing date.
	 *
	 * @param {Number} year of the date to check
	 * @param {Number} month of the date to check
	 * @param {Number} day of the date to check
	 * @returns {Boolean} the date exists
	 * @throws {TypeError} 3 arguments required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isExists(2018, 0, 31)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isExists(2018, 1, 31)
	 * //=> false
	 */
	function isExists(year, month, day) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
	  }
	  var date = new Date(year, month, day);
	  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
	}
	module.exports = exports$1.default; 
} (isExists$2, isExists$2.exports));

var isExistsExports = isExists$2.exports;

var isFirstDayOfMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isFirstDayOfMonth;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isFirstDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the first day of a month?
	 *
	 * @description
	 * Is the given date the first day of a month?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the first day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2014 the first day of a month?
	 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
	 * //=> true
	 */
	function isFirstDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDate() === 1;
	}
	module.exports = exports$1.default; 
} (isFirstDayOfMonth$2, isFirstDayOfMonth$2.exports));

var isFirstDayOfMonthExports = isFirstDayOfMonth$2.exports;

var isFriday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isFriday;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isFriday
	 * @category Weekday Helpers
	 * @summary Is the given date Friday?
	 *
	 * @description
	 * Is the given date Friday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 26 September 2014 Friday?
	 * const result = isFriday(new Date(2014, 8, 26))
	 * //=> true
	 */
	function isFriday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 5;
	}
	module.exports = exports$1.default; 
} (isFriday$2, isFriday$2.exports));

var isFridayExports = isFriday$2.exports;

var isFuture$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isFuture;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isFuture
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * const result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() > Date.now();
	}
	module.exports = exports$1.default; 
} (isFuture$2, isFuture$2.exports));

var isFutureExports = isFuture$2.exports;

var isMatch$2 = {exports: {}};

var parse$4 = {exports: {}};

var createForOfIteratorHelper = {exports: {}};

var unsupportedIterableToArray = {exports: {}};

var arrayLikeToArray = {exports: {}};

(function (module) {
	function _arrayLikeToArray(r, a) {
	  (null == a || a > r.length) && (a = r.length);
	  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
	  return n;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (arrayLikeToArray));

var arrayLikeToArrayExports = arrayLikeToArray.exports;

(function (module) {
	var arrayLikeToArray = arrayLikeToArrayExports;
	function _unsupportedIterableToArray(r, a) {
	  if (r) {
	    if ("string" == typeof r) return arrayLikeToArray(r, a);
	    var t = {}.toString.call(r).slice(8, -1);
	    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
	  }
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (unsupportedIterableToArray));

var unsupportedIterableToArrayExports = unsupportedIterableToArray.exports;

(function (module) {
	var unsupportedIterableToArray = unsupportedIterableToArrayExports;
	function _createForOfIteratorHelper(r, e) {
	  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	  if (!t) {
	    if (Array.isArray(r) || (t = unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
	      t && (r = t);
	      var _n = 0,
	        F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          return _n >= r.length ? {
	            done: true
	          } : {
	            done: false,
	            value: r[_n++]
	          };
	        },
	        e: function e(r) {
	          throw r;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var o,
	    a = true,
	    u = false;
	  return {
	    s: function s() {
	      t = t.call(r);
	    },
	    n: function n() {
	      var r = t.next();
	      return a = r.done, r;
	    },
	    e: function e(r) {
	      u = true, o = r;
	    },
	    f: function f() {
	      try {
	        a || null == t["return"] || t["return"]();
	      } finally {
	        if (u) throw o;
	      }
	    }
	  };
	}
	module.exports = _createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (createForOfIteratorHelper));

var createForOfIteratorHelperExports = createForOfIteratorHelper.exports;

var Setter$1$1 = {};

var assertThisInitialized = {exports: {}};

(function (module) {
	function _assertThisInitialized(e) {
	  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  return e;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (assertThisInitialized));

var assertThisInitializedExports = assertThisInitialized.exports;

var inherits = {exports: {}};

var setPrototypeOf = {exports: {}};

(function (module) {
	function _setPrototypeOf(t, e) {
	  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
	    return t.__proto__ = e, t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (setPrototypeOf));

var setPrototypeOfExports = setPrototypeOf.exports;

(function (module) {
	var setPrototypeOf = setPrototypeOfExports;
	function _inherits(t, e) {
	  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
	  t.prototype = Object.create(e && e.prototype, {
	    constructor: {
	      value: t,
	      writable: true,
	      configurable: true
	    }
	  }), Object.defineProperty(t, "prototype", {
	    writable: false
	  }), e && setPrototypeOf(t, e);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (inherits));

var inheritsExports = inherits.exports;

var createSuper = {exports: {}};

var getPrototypeOf = {exports: {}};

(function (module) {
	function _getPrototypeOf(t) {
	  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
	    return t.__proto__ || Object.getPrototypeOf(t);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (getPrototypeOf));

var getPrototypeOfExports = getPrototypeOf.exports;

var isNativeReflectConstruct = {exports: {}};

(function (module) {
	function _isNativeReflectConstruct() {
	  try {
	    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	  } catch (t) {}
	  return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
	    return !!t;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
	}
	module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (isNativeReflectConstruct));

var isNativeReflectConstructExports = isNativeReflectConstruct.exports;

var possibleConstructorReturn = {exports: {}};

(function (module) {
	var _typeof = _typeofExports["default"];
	var assertThisInitialized = assertThisInitializedExports;
	function _possibleConstructorReturn(t, e) {
	  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
	  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
	  return assertThisInitialized(t);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (possibleConstructorReturn));

var possibleConstructorReturnExports = possibleConstructorReturn.exports;

(function (module) {
	var getPrototypeOf = getPrototypeOfExports;
	var isNativeReflectConstruct = isNativeReflectConstructExports;
	var possibleConstructorReturn = possibleConstructorReturnExports;
	function _createSuper(t) {
	  var r = isNativeReflectConstruct();
	  return function () {
	    var e,
	      o = getPrototypeOf(t);
	    if (r) {
	      var s = getPrototypeOf(this).constructor;
	      e = Reflect.construct(o, arguments, s);
	    } else e = o.apply(this, arguments);
	    return possibleConstructorReturn(this, e);
	  };
	}
	module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (createSuper));

var createSuperExports = createSuper.exports;

var classCallCheck = {exports: {}};

(function (module) {
	function _classCallCheck(a, n) {
	  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (classCallCheck));

var classCallCheckExports = classCallCheck.exports;

var createClass = {exports: {}};

var toPropertyKey = {exports: {}};

var toPrimitive = {exports: {}};

(function (module) {
	var _typeof = _typeofExports["default"];
	function toPrimitive(t, r) {
	  if ("object" != _typeof(t) || !t) return t;
	  var e = t[Symbol.toPrimitive];
	  if (void 0 !== e) {
	    var i = e.call(t, r || "default");
	    if ("object" != _typeof(i)) return i;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return ("string" === r ? String : Number)(t);
	}
	module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (toPrimitive));

var toPrimitiveExports = toPrimitive.exports;

(function (module) {
	var _typeof = _typeofExports["default"];
	var toPrimitive = toPrimitiveExports;
	function toPropertyKey(t) {
	  var i = toPrimitive(t, "string");
	  return "symbol" == _typeof(i) ? i : i + "";
	}
	module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (toPropertyKey));

var toPropertyKeyExports = toPropertyKey.exports;

(function (module) {
	var toPropertyKey = toPropertyKeyExports;
	function _defineProperties(e, r) {
	  for (var t = 0; t < r.length; t++) {
	    var o = r[t];
	    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, toPropertyKey(o.key), o);
	  }
	}
	function _createClass(e, r, t) {
	  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
	    writable: false
	  }), e;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (createClass));

var createClassExports = createClass.exports;

var defineProperty$3 = {exports: {}};

(function (module) {
	var toPropertyKey = toPropertyKeyExports;
	function _defineProperty(e, r, t) {
	  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
	    value: t,
	    enumerable: true,
	    configurable: true,
	    writable: true
	  }) : e[r] = t, e;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (defineProperty$3));

var definePropertyExports = defineProperty$3.exports;

var _interopRequireDefault$w$1 = interopRequireDefaultExports.default;
Object.defineProperty(Setter$1$1, "__esModule", {
  value: true
});
Setter$1$1.ValueSetter = Setter$1$1.Setter = Setter$1$1.DateToSystemTimezoneSetter = void 0;
var _assertThisInitialized2$v = _interopRequireDefault$w$1(assertThisInitializedExports);
var _inherits2$v = _interopRequireDefault$w$1(inheritsExports);
var _createSuper2$v = _interopRequireDefault$w$1(createSuperExports);
var _classCallCheck2$w = _interopRequireDefault$w$1(classCallCheckExports);
var _createClass2$w = _interopRequireDefault$w$1(createClassExports);
var _defineProperty2$w = _interopRequireDefault$w$1(definePropertyExports);
var TIMEZONE_UNIT_PRIORITY$1 = 10;
var Setter$2 = /*#__PURE__*/function () {
  function Setter() {
    (0, _classCallCheck2$w.default)(this, Setter);
    (0, _defineProperty2$w.default)(this, "priority", void 0);
    (0, _defineProperty2$w.default)(this, "subPriority", 0);
  }
  (0, _createClass2$w.default)(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
Setter$1$1.Setter = Setter$2;
var ValueSetter$1 = /*#__PURE__*/function (_Setter) {
  (0, _inherits2$v.default)(ValueSetter, _Setter);
  var _super = (0, _createSuper2$v.default)(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    (0, _classCallCheck2$w.default)(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  (0, _createClass2$w.default)(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter$2);
Setter$1$1.ValueSetter = ValueSetter$1;
var DateToSystemTimezoneSetter$1 = /*#__PURE__*/function (_Setter2) {
  (0, _inherits2$v.default)(DateToSystemTimezoneSetter, _Setter2);
  var _super2 = (0, _createSuper2$v.default)(DateToSystemTimezoneSetter);
  function DateToSystemTimezoneSetter() {
    var _this2;
    (0, _classCallCheck2$w.default)(this, DateToSystemTimezoneSetter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2$w.default)((0, _assertThisInitialized2$v.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY$1);
    (0, _defineProperty2$w.default)((0, _assertThisInitialized2$v.default)(_this2), "subPriority", -1);
    return _this2;
  }
  (0, _createClass2$w.default)(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter;
}(Setter$2);
Setter$1$1.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter$1;

var parsers$1 = {};

var EraParser$1$1 = {};

var Parser$1$1 = {};

var _interopRequireDefault$v$1 = interopRequireDefaultExports.default;
Object.defineProperty(Parser$1$1, "__esModule", {
  value: true
});
Parser$1$1.Parser = void 0;
var _classCallCheck2$v = _interopRequireDefault$v$1(classCallCheckExports);
var _createClass2$v = _interopRequireDefault$v$1(createClassExports);
var _defineProperty2$v = _interopRequireDefault$v$1(definePropertyExports);
var _Setter$1 = Setter$1$1;
var Parser$2 = /*#__PURE__*/function () {
  function Parser() {
    (0, _classCallCheck2$v.default)(this, Parser);
    (0, _defineProperty2$v.default)(this, "incompatibleTokens", void 0);
    (0, _defineProperty2$v.default)(this, "priority", void 0);
    (0, _defineProperty2$v.default)(this, "subPriority", void 0);
  }
  (0, _createClass2$v.default)(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new _Setter$1.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();
Parser$1$1.Parser = Parser$2;

var _interopRequireDefault$u$1 = interopRequireDefaultExports.default;
Object.defineProperty(EraParser$1$1, "__esModule", {
  value: true
});
EraParser$1$1.EraParser = void 0;
var _classCallCheck2$u = _interopRequireDefault$u$1(classCallCheckExports);
var _createClass2$u = _interopRequireDefault$u$1(createClassExports);
var _assertThisInitialized2$u = _interopRequireDefault$u$1(assertThisInitializedExports);
var _inherits2$u = _interopRequireDefault$u$1(inheritsExports);
var _createSuper2$u = _interopRequireDefault$u$1(createSuperExports);
var _defineProperty2$u = _interopRequireDefault$u$1(definePropertyExports);
var _Parser2$u = Parser$1$1;
var EraParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$u.default)(EraParser, _Parser);
  var _super = (0, _createSuper2$u.default)(EraParser);
  function EraParser() {
    var _this;
    (0, _classCallCheck2$u.default)(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$u.default)((0, _assertThisInitialized2$u.default)(_this), "priority", 140);
    (0, _defineProperty2$u.default)((0, _assertThisInitialized2$u.default)(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  (0, _createClass2$u.default)(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(_Parser2$u.Parser);
EraParser$1$1.EraParser = EraParser$2;

var YearParser$1$1 = {};

var utils$4 = {};

var constants$3 = {};

Object.defineProperty(constants$3, "__esModule", {
  value: true
});
constants$3.timezonePatterns = constants$3.numericPatterns = void 0;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59

  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
constants$3.numericPatterns = numericPatterns;
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
constants$3.timezonePatterns = timezonePatterns;

Object.defineProperty(utils$4, "__esModule", {
  value: true
});
utils$4.dayPeriodEnumToHours = dayPeriodEnumToHours$1;
utils$4.isLeapYearIndex = isLeapYearIndex$2;
utils$4.mapValue = mapValue$1;
utils$4.normalizeTwoDigitYear = normalizeTwoDigitYear$1;
utils$4.parseAnyDigitsSigned = parseAnyDigitsSigned$1;
utils$4.parseNDigits = parseNDigits$1;
utils$4.parseNDigitsSigned = parseNDigitsSigned$1;
utils$4.parseNumericPattern = parseNumericPattern$1;
utils$4.parseTimezonePattern = parseTimezonePattern$1;
var _index$8$1 = constants$1$1;
var _constants$e$1 = constants$3;
function mapValue$1(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern$1(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern$1(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * _index$8$1.millisecondsInHour + minutes * _index$8$1.millisecondsInMinute + seconds * _index$8$1.millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned$1(dateString) {
  return parseNumericPattern$1(_constants$e$1.numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits$1(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern$1(_constants$e$1.numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern$1(_constants$e$1.numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern$1(_constants$e$1.numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern$1(_constants$e$1.numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern$1(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned$1(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern$1(_constants$e$1.numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern$1(_constants$e$1.numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern$1(_constants$e$1.numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern$1(_constants$e$1.numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern$1(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours$1(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear$1(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$2(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

var _interopRequireDefault$t$1 = interopRequireDefaultExports.default;
Object.defineProperty(YearParser$1$1, "__esModule", {
  value: true
});
YearParser$1$1.YearParser = void 0;
var _classCallCheck2$t = _interopRequireDefault$t$1(classCallCheckExports);
var _createClass2$t = _interopRequireDefault$t$1(createClassExports);
var _assertThisInitialized2$t = _interopRequireDefault$t$1(assertThisInitializedExports);
var _inherits2$t = _interopRequireDefault$t$1(inheritsExports);
var _createSuper2$t = _interopRequireDefault$t$1(createSuperExports);
var _defineProperty2$t = _interopRequireDefault$t$1(definePropertyExports);
var _Parser2$t = Parser$1$1;
var _utils$s$1 = utils$4;
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$t.default)(YearParser, _Parser);
  var _super = (0, _createSuper2$t.default)(YearParser);
  function YearParser() {
    var _this;
    (0, _classCallCheck2$t.default)(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$t.default)((0, _assertThisInitialized2$t.default)(_this), "priority", 130);
    (0, _defineProperty2$t.default)((0, _assertThisInitialized2$t.default)(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$t.default)(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return (0, _utils$s$1.mapValue)((0, _utils$s$1.parseNDigits)(4, dateString), valueCallback);
        case 'yo':
          return (0, _utils$s$1.mapValue)(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return (0, _utils$s$1.mapValue)((0, _utils$s$1.parseNDigits)(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = (0, _utils$s$1.normalizeTwoDigitYear)(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(_Parser2$t.Parser);
YearParser$1$1.YearParser = YearParser$2;

var LocalWeekYearParser$1$1 = {};

var _interopRequireDefault$s$1 = interopRequireDefaultExports.default;
Object.defineProperty(LocalWeekYearParser$1$1, "__esModule", {
  value: true
});
LocalWeekYearParser$1$1.LocalWeekYearParser = void 0;
var _classCallCheck2$s = _interopRequireDefault$s$1(classCallCheckExports);
var _createClass2$s = _interopRequireDefault$s$1(createClassExports);
var _assertThisInitialized2$s = _interopRequireDefault$s$1(assertThisInitializedExports);
var _inherits2$s = _interopRequireDefault$s$1(inheritsExports);
var _createSuper2$s = _interopRequireDefault$s$1(createSuperExports);
var _defineProperty2$s = _interopRequireDefault$s$1(definePropertyExports);
var _Parser2$s = Parser$1$1;
var _utils$r$1 = utils$4;
var _index$7$1 = _interopRequireDefault$s$1(getUTCWeekYearExports);
var _index2$2$1 = _interopRequireDefault$s$1(startOfUTCWeekExports);
// Local week-numbering year
var LocalWeekYearParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$s.default)(LocalWeekYearParser, _Parser);
  var _super = (0, _createSuper2$s.default)(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    (0, _classCallCheck2$s.default)(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$s.default)((0, _assertThisInitialized2$s.default)(_this), "priority", 130);
    (0, _defineProperty2$s.default)((0, _assertThisInitialized2$s.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  (0, _createClass2$s.default)(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return (0, _utils$r$1.mapValue)((0, _utils$r$1.parseNDigits)(4, dateString), valueCallback);
        case 'Yo':
          return (0, _utils$r$1.mapValue)(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return (0, _utils$r$1.mapValue)((0, _utils$r$1.parseNDigits)(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = (0, _index$7$1.default)(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = (0, _utils$r$1.normalizeTwoDigitYear)(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return (0, _index2$2$1.default)(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0, _index2$2$1.default)(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(_Parser2$s.Parser);
LocalWeekYearParser$1$1.LocalWeekYearParser = LocalWeekYearParser$2;

var ISOWeekYearParser$1$1 = {};

var _interopRequireDefault$r$1 = interopRequireDefaultExports.default;
Object.defineProperty(ISOWeekYearParser$1$1, "__esModule", {
  value: true
});
ISOWeekYearParser$1$1.ISOWeekYearParser = void 0;
var _classCallCheck2$r = _interopRequireDefault$r$1(classCallCheckExports);
var _createClass2$r = _interopRequireDefault$r$1(createClassExports);
var _assertThisInitialized2$r = _interopRequireDefault$r$1(assertThisInitializedExports);
var _inherits2$r = _interopRequireDefault$r$1(inheritsExports);
var _createSuper2$r = _interopRequireDefault$r$1(createSuperExports);
var _defineProperty2$r = _interopRequireDefault$r$1(definePropertyExports);
var _Parser2$r = Parser$1$1;
var _utils$q$1 = utils$4;
var _index$6$1 = _interopRequireDefault$r$1(startOfUTCISOWeekExports);
// ISO week-numbering year
var ISOWeekYearParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$r.default)(ISOWeekYearParser, _Parser);
  var _super = (0, _createSuper2$r.default)(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    (0, _classCallCheck2$r.default)(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$r.default)((0, _assertThisInitialized2$r.default)(_this), "priority", 130);
    (0, _defineProperty2$r.default)((0, _assertThisInitialized2$r.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$r.default)(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return (0, _utils$q$1.parseNDigitsSigned)(4, dateString);
      }
      return (0, _utils$q$1.parseNDigitsSigned)(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return (0, _index$6$1.default)(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(_Parser2$r.Parser);
ISOWeekYearParser$1$1.ISOWeekYearParser = ISOWeekYearParser$2;

var ExtendedYearParser$1$1 = {};

var _interopRequireDefault$q$1 = interopRequireDefaultExports.default;
Object.defineProperty(ExtendedYearParser$1$1, "__esModule", {
  value: true
});
ExtendedYearParser$1$1.ExtendedYearParser = void 0;
var _classCallCheck2$q = _interopRequireDefault$q$1(classCallCheckExports);
var _createClass2$q = _interopRequireDefault$q$1(createClassExports);
var _assertThisInitialized2$q = _interopRequireDefault$q$1(assertThisInitializedExports);
var _inherits2$q = _interopRequireDefault$q$1(inheritsExports);
var _createSuper2$q = _interopRequireDefault$q$1(createSuperExports);
var _defineProperty2$q = _interopRequireDefault$q$1(definePropertyExports);
var _Parser2$q = Parser$1$1;
var _utils$p$1 = utils$4;
var ExtendedYearParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$q.default)(ExtendedYearParser, _Parser);
  var _super = (0, _createSuper2$q.default)(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    (0, _classCallCheck2$q.default)(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$q.default)((0, _assertThisInitialized2$q.default)(_this), "priority", 130);
    (0, _defineProperty2$q.default)((0, _assertThisInitialized2$q.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$q.default)(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return (0, _utils$p$1.parseNDigitsSigned)(4, dateString);
      }
      return (0, _utils$p$1.parseNDigitsSigned)(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(_Parser2$q.Parser);
ExtendedYearParser$1$1.ExtendedYearParser = ExtendedYearParser$2;

var QuarterParser$1$1 = {};

var _interopRequireDefault$p$1 = interopRequireDefaultExports.default;
Object.defineProperty(QuarterParser$1$1, "__esModule", {
  value: true
});
QuarterParser$1$1.QuarterParser = void 0;
var _classCallCheck2$p = _interopRequireDefault$p$1(classCallCheckExports);
var _createClass2$p = _interopRequireDefault$p$1(createClassExports);
var _assertThisInitialized2$p = _interopRequireDefault$p$1(assertThisInitializedExports);
var _inherits2$p = _interopRequireDefault$p$1(inheritsExports);
var _createSuper2$p = _interopRequireDefault$p$1(createSuperExports);
var _defineProperty2$p = _interopRequireDefault$p$1(definePropertyExports);
var _Parser2$p = Parser$1$1;
var _utils$o$1 = utils$4;
var QuarterParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$p.default)(QuarterParser, _Parser);
  var _super = (0, _createSuper2$p.default)(QuarterParser);
  function QuarterParser() {
    var _this;
    (0, _classCallCheck2$p.default)(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$p.default)((0, _assertThisInitialized2$p.default)(_this), "priority", 120);
    (0, _defineProperty2$p.default)((0, _assertThisInitialized2$p.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$p.default)(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return (0, _utils$o$1.parseNDigits)(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(_Parser2$p.Parser);
QuarterParser$1$1.QuarterParser = QuarterParser$2;

var StandAloneQuarterParser$1$1 = {};

var _interopRequireDefault$o$1 = interopRequireDefaultExports.default;
Object.defineProperty(StandAloneQuarterParser$1$1, "__esModule", {
  value: true
});
StandAloneQuarterParser$1$1.StandAloneQuarterParser = void 0;
var _classCallCheck2$o = _interopRequireDefault$o$1(classCallCheckExports);
var _createClass2$o = _interopRequireDefault$o$1(createClassExports);
var _assertThisInitialized2$o = _interopRequireDefault$o$1(assertThisInitializedExports);
var _inherits2$o = _interopRequireDefault$o$1(inheritsExports);
var _createSuper2$o = _interopRequireDefault$o$1(createSuperExports);
var _defineProperty2$o = _interopRequireDefault$o$1(definePropertyExports);
var _Parser2$o = Parser$1$1;
var _utils$n$1 = utils$4;
var StandAloneQuarterParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$o.default)(StandAloneQuarterParser, _Parser);
  var _super = (0, _createSuper2$o.default)(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    (0, _classCallCheck2$o.default)(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$o.default)((0, _assertThisInitialized2$o.default)(_this), "priority", 120);
    (0, _defineProperty2$o.default)((0, _assertThisInitialized2$o.default)(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$o.default)(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return (0, _utils$n$1.parseNDigits)(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(_Parser2$o.Parser);
StandAloneQuarterParser$1$1.StandAloneQuarterParser = StandAloneQuarterParser$2;

var MonthParser$1$1 = {};

var _interopRequireDefault$n$1 = interopRequireDefaultExports.default;
Object.defineProperty(MonthParser$1$1, "__esModule", {
  value: true
});
MonthParser$1$1.MonthParser = void 0;
var _classCallCheck2$n = _interopRequireDefault$n$1(classCallCheckExports);
var _createClass2$n = _interopRequireDefault$n$1(createClassExports);
var _assertThisInitialized2$n = _interopRequireDefault$n$1(assertThisInitializedExports);
var _inherits2$n = _interopRequireDefault$n$1(inheritsExports);
var _createSuper2$n = _interopRequireDefault$n$1(createSuperExports);
var _defineProperty2$n = _interopRequireDefault$n$1(definePropertyExports);
var _utils$m$1 = utils$4;
var _Parser2$n = Parser$1$1;
var _constants$d$1 = constants$3;
var MonthParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$n.default)(MonthParser, _Parser);
  var _super = (0, _createSuper2$n.default)(MonthParser);
  function MonthParser() {
    var _this;
    (0, _classCallCheck2$n.default)(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$n.default)((0, _assertThisInitialized2$n.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    (0, _defineProperty2$n.default)((0, _assertThisInitialized2$n.default)(_this), "priority", 110);
    return _this;
  }
  (0, _createClass2$n.default)(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return (0, _utils$m$1.mapValue)((0, _utils$m$1.parseNumericPattern)(_constants$d$1.numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return (0, _utils$m$1.mapValue)((0, _utils$m$1.parseNDigits)(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return (0, _utils$m$1.mapValue)(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(_Parser2$n.Parser);
MonthParser$1$1.MonthParser = MonthParser$2;

var StandAloneMonthParser$1$1 = {};

var _interopRequireDefault$m$1 = interopRequireDefaultExports.default;
Object.defineProperty(StandAloneMonthParser$1$1, "__esModule", {
  value: true
});
StandAloneMonthParser$1$1.StandAloneMonthParser = void 0;
var _classCallCheck2$m = _interopRequireDefault$m$1(classCallCheckExports);
var _createClass2$m = _interopRequireDefault$m$1(createClassExports);
var _assertThisInitialized2$m = _interopRequireDefault$m$1(assertThisInitializedExports);
var _inherits2$m = _interopRequireDefault$m$1(inheritsExports);
var _createSuper2$m = _interopRequireDefault$m$1(createSuperExports);
var _defineProperty2$m = _interopRequireDefault$m$1(definePropertyExports);
var _Parser2$m = Parser$1$1;
var _constants$c$1 = constants$3;
var _utils$l$1 = utils$4;
var StandAloneMonthParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$m.default)(StandAloneMonthParser, _Parser);
  var _super = (0, _createSuper2$m.default)(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    (0, _classCallCheck2$m.default)(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$m.default)((0, _assertThisInitialized2$m.default)(_this), "priority", 110);
    (0, _defineProperty2$m.default)((0, _assertThisInitialized2$m.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$m.default)(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return (0, _utils$l$1.mapValue)((0, _utils$l$1.parseNumericPattern)(_constants$c$1.numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return (0, _utils$l$1.mapValue)((0, _utils$l$1.parseNDigits)(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return (0, _utils$l$1.mapValue)(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(_Parser2$m.Parser);
StandAloneMonthParser$1$1.StandAloneMonthParser = StandAloneMonthParser$2;

var LocalWeekParser$1$1 = {};

var setUTCWeek = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setUTCWeek;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(getUTCWeekExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports$1.default; 
} (setUTCWeek, setUTCWeek.exports));

var setUTCWeekExports = setUTCWeek.exports;

var _interopRequireDefault$l$1 = interopRequireDefaultExports.default;
Object.defineProperty(LocalWeekParser$1$1, "__esModule", {
  value: true
});
LocalWeekParser$1$1.LocalWeekParser = void 0;
var _classCallCheck2$l = _interopRequireDefault$l$1(classCallCheckExports);
var _createClass2$l = _interopRequireDefault$l$1(createClassExports);
var _assertThisInitialized2$l = _interopRequireDefault$l$1(assertThisInitializedExports);
var _inherits2$l = _interopRequireDefault$l$1(inheritsExports);
var _createSuper2$l = _interopRequireDefault$l$1(createSuperExports);
var _defineProperty2$l = _interopRequireDefault$l$1(definePropertyExports);
var _Parser2$l = Parser$1$1;
var _constants$b$1 = constants$3;
var _utils$k$1 = utils$4;
var _index$5$1 = _interopRequireDefault$l$1(setUTCWeekExports);
var _index2$1$1 = _interopRequireDefault$l$1(startOfUTCWeekExports);
// Local week of year
var LocalWeekParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$l.default)(LocalWeekParser, _Parser);
  var _super = (0, _createSuper2$l.default)(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    (0, _classCallCheck2$l.default)(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$l.default)((0, _assertThisInitialized2$l.default)(_this), "priority", 100);
    (0, _defineProperty2$l.default)((0, _assertThisInitialized2$l.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  (0, _createClass2$l.default)(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return (0, _utils$k$1.parseNumericPattern)(_constants$b$1.numericPatterns.week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return (0, _utils$k$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return (0, _index2$1$1.default)((0, _index$5$1.default)(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(_Parser2$l.Parser);
LocalWeekParser$1$1.LocalWeekParser = LocalWeekParser$2;

var ISOWeekParser$1$1 = {};

var setUTCISOWeek = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setUTCISOWeek;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(getUTCISOWeekExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports$1.default; 
} (setUTCISOWeek, setUTCISOWeek.exports));

var setUTCISOWeekExports = setUTCISOWeek.exports;

var _interopRequireDefault$k$1 = interopRequireDefaultExports.default;
Object.defineProperty(ISOWeekParser$1$1, "__esModule", {
  value: true
});
ISOWeekParser$1$1.ISOWeekParser = void 0;
var _classCallCheck2$k = _interopRequireDefault$k$1(classCallCheckExports);
var _createClass2$k = _interopRequireDefault$k$1(createClassExports);
var _assertThisInitialized2$k = _interopRequireDefault$k$1(assertThisInitializedExports);
var _inherits2$k = _interopRequireDefault$k$1(inheritsExports);
var _createSuper2$k = _interopRequireDefault$k$1(createSuperExports);
var _defineProperty2$k = _interopRequireDefault$k$1(definePropertyExports);
var _Parser2$k = Parser$1$1;
var _constants$a$1 = constants$3;
var _utils$j$1 = utils$4;
var _index$4$1 = _interopRequireDefault$k$1(setUTCISOWeekExports);
var _index2$4v = _interopRequireDefault$k$1(startOfUTCISOWeekExports);
// ISO week of year
var ISOWeekParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$k.default)(ISOWeekParser, _Parser);
  var _super = (0, _createSuper2$k.default)(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    (0, _classCallCheck2$k.default)(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$k.default)((0, _assertThisInitialized2$k.default)(_this), "priority", 100);
    (0, _defineProperty2$k.default)((0, _assertThisInitialized2$k.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$k.default)(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return (0, _utils$j$1.parseNumericPattern)(_constants$a$1.numericPatterns.week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return (0, _utils$j$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return (0, _index2$4v.default)((0, _index$4$1.default)(date, value));
    }
  }]);
  return ISOWeekParser;
}(_Parser2$k.Parser);
ISOWeekParser$1$1.ISOWeekParser = ISOWeekParser$2;

var DateParser$1$1 = {};

var _interopRequireDefault$j$1 = interopRequireDefaultExports.default;
Object.defineProperty(DateParser$1$1, "__esModule", {
  value: true
});
DateParser$1$1.DateParser = void 0;
var _classCallCheck2$j = _interopRequireDefault$j$1(classCallCheckExports);
var _createClass2$j = _interopRequireDefault$j$1(createClassExports);
var _assertThisInitialized2$j = _interopRequireDefault$j$1(assertThisInitializedExports);
var _inherits2$j = _interopRequireDefault$j$1(inheritsExports);
var _createSuper2$j = _interopRequireDefault$j$1(createSuperExports);
var _defineProperty2$j = _interopRequireDefault$j$1(definePropertyExports);
var _utils$i$1 = utils$4;
var _Parser2$j = Parser$1$1;
var _constants$9$1 = constants$3;
var DAYS_IN_MONTH$1 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR$1 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Day of the month
var DateParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$j.default)(DateParser, _Parser);
  var _super = (0, _createSuper2$j.default)(DateParser);
  function DateParser() {
    var _this;
    (0, _classCallCheck2$j.default)(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$j.default)((0, _assertThisInitialized2$j.default)(_this), "priority", 90);
    (0, _defineProperty2$j.default)((0, _assertThisInitialized2$j.default)(_this), "subPriority", 1);
    (0, _defineProperty2$j.default)((0, _assertThisInitialized2$j.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$j.default)(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return (0, _utils$i$1.parseNumericPattern)(_constants$9$1.numericPatterns.date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return (0, _utils$i$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = (0, _utils$i$1.isLeapYearIndex)(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR$1[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH$1[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(_Parser2$j.Parser);
DateParser$1$1.DateParser = DateParser$2;

var DayOfYearParser$1$1 = {};

var _interopRequireDefault$i$1 = interopRequireDefaultExports.default;
Object.defineProperty(DayOfYearParser$1$1, "__esModule", {
  value: true
});
DayOfYearParser$1$1.DayOfYearParser = void 0;
var _classCallCheck2$i = _interopRequireDefault$i$1(classCallCheckExports);
var _createClass2$i = _interopRequireDefault$i$1(createClassExports);
var _assertThisInitialized2$i = _interopRequireDefault$i$1(assertThisInitializedExports);
var _inherits2$i = _interopRequireDefault$i$1(inheritsExports);
var _createSuper2$i = _interopRequireDefault$i$1(createSuperExports);
var _defineProperty2$i = _interopRequireDefault$i$1(definePropertyExports);
var _Parser2$i = Parser$1$1;
var _constants$8$1 = constants$3;
var _utils$h$1 = utils$4;
var DayOfYearParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$i.default)(DayOfYearParser, _Parser);
  var _super = (0, _createSuper2$i.default)(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    (0, _classCallCheck2$i.default)(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$i.default)((0, _assertThisInitialized2$i.default)(_this), "priority", 90);
    (0, _defineProperty2$i.default)((0, _assertThisInitialized2$i.default)(_this), "subpriority", 1);
    (0, _defineProperty2$i.default)((0, _assertThisInitialized2$i.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$i.default)(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return (0, _utils$h$1.parseNumericPattern)(_constants$8$1.numericPatterns.dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return (0, _utils$h$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = (0, _utils$h$1.isLeapYearIndex)(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(_Parser2$i.Parser);
DayOfYearParser$1$1.DayOfYearParser = DayOfYearParser$2;

var DayParser$1$1 = {};

var setUTCDay = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setUTCDay;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	var _index4 = defaultOptions$1$1;
	function setUTCDay(dirtyDate, dirtyDay, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(2, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports$1.default; 
} (setUTCDay, setUTCDay.exports));

var setUTCDayExports = setUTCDay.exports;

var _interopRequireDefault$h$1 = interopRequireDefaultExports.default;
Object.defineProperty(DayParser$1$1, "__esModule", {
  value: true
});
DayParser$1$1.DayParser = void 0;
var _classCallCheck2$h = _interopRequireDefault$h$1(classCallCheckExports);
var _createClass2$h = _interopRequireDefault$h$1(createClassExports);
var _assertThisInitialized2$h = _interopRequireDefault$h$1(assertThisInitializedExports);
var _inherits2$h = _interopRequireDefault$h$1(inheritsExports);
var _createSuper2$h = _interopRequireDefault$h$1(createSuperExports);
var _defineProperty2$h = _interopRequireDefault$h$1(definePropertyExports);
var _Parser2$h = Parser$1$1;
var _index$3$1 = _interopRequireDefault$h$1(setUTCDayExports);
// Day of week
var DayParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$h.default)(DayParser, _Parser);
  var _super = (0, _createSuper2$h.default)(DayParser);
  function DayParser() {
    var _this;
    (0, _classCallCheck2$h.default)(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$h.default)((0, _assertThisInitialized2$h.default)(_this), "priority", 90);
    (0, _defineProperty2$h.default)((0, _assertThisInitialized2$h.default)(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$h.default)(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = (0, _index$3$1.default)(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(_Parser2$h.Parser);
DayParser$1$1.DayParser = DayParser$2;

var LocalDayParser$1$1 = {};

var _interopRequireDefault$g$1 = interopRequireDefaultExports.default;
Object.defineProperty(LocalDayParser$1$1, "__esModule", {
  value: true
});
LocalDayParser$1$1.LocalDayParser = void 0;
var _classCallCheck2$g = _interopRequireDefault$g$1(classCallCheckExports);
var _createClass2$g = _interopRequireDefault$g$1(createClassExports);
var _assertThisInitialized2$g = _interopRequireDefault$g$1(assertThisInitializedExports);
var _inherits2$g = _interopRequireDefault$g$1(inheritsExports);
var _createSuper2$g = _interopRequireDefault$g$1(createSuperExports);
var _defineProperty2$g = _interopRequireDefault$g$1(definePropertyExports);
var _Parser2$g = Parser$1$1;
var _utils$g$1 = utils$4;
var _index$2$1 = _interopRequireDefault$g$1(setUTCDayExports);
// Local day of week
var LocalDayParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$g.default)(LocalDayParser, _Parser);
  var _super = (0, _createSuper2$g.default)(LocalDayParser);
  function LocalDayParser() {
    var _this;
    (0, _classCallCheck2$g.default)(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$g.default)((0, _assertThisInitialized2$g.default)(_this), "priority", 90);
    (0, _defineProperty2$g.default)((0, _assertThisInitialized2$g.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$g.default)(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return (0, _utils$g$1.mapValue)((0, _utils$g$1.parseNDigits)(token.length, dateString), valueCallback);
        // 3rd
        case 'eo':
          return (0, _utils$g$1.mapValue)(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = (0, _index$2$1.default)(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(_Parser2$g.Parser);
LocalDayParser$1$1.LocalDayParser = LocalDayParser$2;

var StandAloneLocalDayParser$1$1 = {};

var _interopRequireDefault$f$1 = interopRequireDefaultExports.default;
Object.defineProperty(StandAloneLocalDayParser$1$1, "__esModule", {
  value: true
});
StandAloneLocalDayParser$1$1.StandAloneLocalDayParser = void 0;
var _classCallCheck2$f = _interopRequireDefault$f$1(classCallCheckExports);
var _createClass2$f = _interopRequireDefault$f$1(createClassExports);
var _assertThisInitialized2$f = _interopRequireDefault$f$1(assertThisInitializedExports);
var _inherits2$f = _interopRequireDefault$f$1(inheritsExports);
var _createSuper2$f = _interopRequireDefault$f$1(createSuperExports);
var _defineProperty2$f = _interopRequireDefault$f$1(definePropertyExports);
var _Parser2$f = Parser$1$1;
var _utils$f$1 = utils$4;
var _index$1$1 = _interopRequireDefault$f$1(setUTCDayExports);
// Stand-alone local day of week
var StandAloneLocalDayParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$f.default)(StandAloneLocalDayParser, _Parser);
  var _super = (0, _createSuper2$f.default)(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    (0, _classCallCheck2$f.default)(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$f.default)((0, _assertThisInitialized2$f.default)(_this), "priority", 90);
    (0, _defineProperty2$f.default)((0, _assertThisInitialized2$f.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  (0, _createClass2$f.default)(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return (0, _utils$f$1.mapValue)((0, _utils$f$1.parseNDigits)(token.length, dateString), valueCallback);
        // 3rd
        case 'co':
          return (0, _utils$f$1.mapValue)(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = (0, _index$1$1.default)(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(_Parser2$f.Parser);
StandAloneLocalDayParser$1$1.StandAloneLocalDayParser = StandAloneLocalDayParser$2;

var ISODayParser$1$1 = {};

var setUTCISODay = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setUTCISODay;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index2.default)(2, arguments);
	  var day = (0, _index3.default)(dirtyDay);
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports$1.default; 
} (setUTCISODay, setUTCISODay.exports));

var setUTCISODayExports = setUTCISODay.exports;

var _interopRequireDefault$e$1 = interopRequireDefaultExports.default;
Object.defineProperty(ISODayParser$1$1, "__esModule", {
  value: true
});
ISODayParser$1$1.ISODayParser = void 0;
var _classCallCheck2$e = _interopRequireDefault$e$1(classCallCheckExports);
var _createClass2$e = _interopRequireDefault$e$1(createClassExports);
var _assertThisInitialized2$e = _interopRequireDefault$e$1(assertThisInitializedExports);
var _inherits2$e = _interopRequireDefault$e$1(inheritsExports);
var _createSuper2$e = _interopRequireDefault$e$1(createSuperExports);
var _defineProperty2$e = _interopRequireDefault$e$1(definePropertyExports);
var _Parser2$e = Parser$1$1;
var _utils$e$1 = utils$4;
var _index$ad = _interopRequireDefault$e$1(setUTCISODayExports);
// ISO day of week
var ISODayParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$e.default)(ISODayParser, _Parser);
  var _super = (0, _createSuper2$e.default)(ISODayParser);
  function ISODayParser() {
    var _this;
    (0, _classCallCheck2$e.default)(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$e.default)((0, _assertThisInitialized2$e.default)(_this), "priority", 90);
    (0, _defineProperty2$e.default)((0, _assertThisInitialized2$e.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0, _createClass2$e.default)(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return (0, _utils$e$1.parseNDigits)(token.length, dateString);
        // 2nd
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return (0, _utils$e$1.mapValue)(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T
        case 'iiiii':
          return (0, _utils$e$1.mapValue)(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu
        case 'iiiiii':
          return (0, _utils$e$1.mapValue)(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday
        case 'iiii':
        default:
          return (0, _utils$e$1.mapValue)(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = (0, _index$ad.default)(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(_Parser2$e.Parser);
ISODayParser$1$1.ISODayParser = ISODayParser$2;

var AMPMParser$1$1 = {};

var _interopRequireDefault$d$1 = interopRequireDefaultExports.default;
Object.defineProperty(AMPMParser$1$1, "__esModule", {
  value: true
});
AMPMParser$1$1.AMPMParser = void 0;
var _classCallCheck2$d = _interopRequireDefault$d$1(classCallCheckExports);
var _createClass2$d = _interopRequireDefault$d$1(createClassExports);
var _assertThisInitialized2$d = _interopRequireDefault$d$1(assertThisInitializedExports);
var _inherits2$d = _interopRequireDefault$d$1(inheritsExports);
var _createSuper2$d = _interopRequireDefault$d$1(createSuperExports);
var _defineProperty2$d = _interopRequireDefault$d$1(definePropertyExports);
var _Parser2$d = Parser$1$1;
var _utils$d$1 = utils$4;
var AMPMParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$d.default)(AMPMParser, _Parser);
  var _super = (0, _createSuper2$d.default)(AMPMParser);
  function AMPMParser() {
    var _this;
    (0, _classCallCheck2$d.default)(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$d.default)((0, _assertThisInitialized2$d.default)(_this), "priority", 80);
    (0, _defineProperty2$d.default)((0, _assertThisInitialized2$d.default)(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  (0, _createClass2$d.default)(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours((0, _utils$d$1.dayPeriodEnumToHours)(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(_Parser2$d.Parser);
AMPMParser$1$1.AMPMParser = AMPMParser$2;

var AMPMMidnightParser$1$1 = {};

var _interopRequireDefault$c$1 = interopRequireDefaultExports.default;
Object.defineProperty(AMPMMidnightParser$1$1, "__esModule", {
  value: true
});
AMPMMidnightParser$1$1.AMPMMidnightParser = void 0;
var _classCallCheck2$c = _interopRequireDefault$c$1(classCallCheckExports);
var _createClass2$c = _interopRequireDefault$c$1(createClassExports);
var _assertThisInitialized2$c = _interopRequireDefault$c$1(assertThisInitializedExports);
var _inherits2$c = _interopRequireDefault$c$1(inheritsExports);
var _createSuper2$c = _interopRequireDefault$c$1(createSuperExports);
var _defineProperty2$c = _interopRequireDefault$c$1(definePropertyExports);
var _Parser2$c = Parser$1$1;
var _utils$c$1 = utils$4;
var AMPMMidnightParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$c.default)(AMPMMidnightParser, _Parser);
  var _super = (0, _createSuper2$c.default)(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    (0, _classCallCheck2$c.default)(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$c.default)((0, _assertThisInitialized2$c.default)(_this), "priority", 80);
    (0, _defineProperty2$c.default)((0, _assertThisInitialized2$c.default)(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  (0, _createClass2$c.default)(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours((0, _utils$c$1.dayPeriodEnumToHours)(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(_Parser2$c.Parser);
AMPMMidnightParser$1$1.AMPMMidnightParser = AMPMMidnightParser$2;

var DayPeriodParser$1$1 = {};

var _interopRequireDefault$b$1 = interopRequireDefaultExports.default;
Object.defineProperty(DayPeriodParser$1$1, "__esModule", {
  value: true
});
DayPeriodParser$1$1.DayPeriodParser = void 0;
var _classCallCheck2$b = _interopRequireDefault$b$1(classCallCheckExports);
var _createClass2$b = _interopRequireDefault$b$1(createClassExports);
var _assertThisInitialized2$b = _interopRequireDefault$b$1(assertThisInitializedExports);
var _inherits2$b = _interopRequireDefault$b$1(inheritsExports);
var _createSuper2$b = _interopRequireDefault$b$1(createSuperExports);
var _defineProperty2$b = _interopRequireDefault$b$1(definePropertyExports);
var _Parser2$b = Parser$1$1;
var _utils$b$1 = utils$4;
// in the morning, in the afternoon, in the evening, at night
var DayPeriodParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$b.default)(DayPeriodParser, _Parser);
  var _super = (0, _createSuper2$b.default)(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    (0, _classCallCheck2$b.default)(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$b.default)((0, _assertThisInitialized2$b.default)(_this), "priority", 80);
    (0, _defineProperty2$b.default)((0, _assertThisInitialized2$b.default)(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  (0, _createClass2$b.default)(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours((0, _utils$b$1.dayPeriodEnumToHours)(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(_Parser2$b.Parser);
DayPeriodParser$1$1.DayPeriodParser = DayPeriodParser$2;

var Hour1to12Parser$1$1 = {};

var _interopRequireDefault$a$1 = interopRequireDefaultExports.default;
Object.defineProperty(Hour1to12Parser$1$1, "__esModule", {
  value: true
});
Hour1to12Parser$1$1.Hour1to12Parser = void 0;
var _classCallCheck2$a = _interopRequireDefault$a$1(classCallCheckExports);
var _createClass2$a = _interopRequireDefault$a$1(createClassExports);
var _assertThisInitialized2$a = _interopRequireDefault$a$1(assertThisInitializedExports);
var _inherits2$a = _interopRequireDefault$a$1(inheritsExports);
var _createSuper2$a = _interopRequireDefault$a$1(createSuperExports);
var _defineProperty2$a = _interopRequireDefault$a$1(definePropertyExports);
var _Parser2$a = Parser$1$1;
var _constants$7$1 = constants$3;
var _utils$a$1 = utils$4;
var Hour1to12Parser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$a.default)(Hour1to12Parser, _Parser);
  var _super = (0, _createSuper2$a.default)(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    (0, _classCallCheck2$a.default)(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$a.default)((0, _assertThisInitialized2$a.default)(_this), "priority", 70);
    (0, _defineProperty2$a.default)((0, _assertThisInitialized2$a.default)(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  (0, _createClass2$a.default)(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return (0, _utils$a$1.parseNumericPattern)(_constants$7$1.numericPatterns.hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return (0, _utils$a$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(_Parser2$a.Parser);
Hour1to12Parser$1$1.Hour1to12Parser = Hour1to12Parser$2;

var Hour0to23Parser$1$1 = {};

var _interopRequireDefault$9$1 = interopRequireDefaultExports.default;
Object.defineProperty(Hour0to23Parser$1$1, "__esModule", {
  value: true
});
Hour0to23Parser$1$1.Hour0to23Parser = void 0;
var _classCallCheck2$9 = _interopRequireDefault$9$1(classCallCheckExports);
var _createClass2$9 = _interopRequireDefault$9$1(createClassExports);
var _assertThisInitialized2$9 = _interopRequireDefault$9$1(assertThisInitializedExports);
var _inherits2$9 = _interopRequireDefault$9$1(inheritsExports);
var _createSuper2$9 = _interopRequireDefault$9$1(createSuperExports);
var _defineProperty2$9 = _interopRequireDefault$9$1(definePropertyExports);
var _Parser2$9 = Parser$1$1;
var _constants$6$1 = constants$3;
var _utils$9$1 = utils$4;
var Hour0to23Parser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$9.default)(Hour0to23Parser, _Parser);
  var _super = (0, _createSuper2$9.default)(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    (0, _classCallCheck2$9.default)(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$9.default)((0, _assertThisInitialized2$9.default)(_this), "priority", 70);
    (0, _defineProperty2$9.default)((0, _assertThisInitialized2$9.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  (0, _createClass2$9.default)(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return (0, _utils$9$1.parseNumericPattern)(_constants$6$1.numericPatterns.hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return (0, _utils$9$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(_Parser2$9.Parser);
Hour0to23Parser$1$1.Hour0to23Parser = Hour0to23Parser$2;

var Hour0To11Parser$1$1 = {};

var _interopRequireDefault$8$1 = interopRequireDefaultExports.default;
Object.defineProperty(Hour0To11Parser$1$1, "__esModule", {
  value: true
});
Hour0To11Parser$1$1.Hour0To11Parser = void 0;
var _classCallCheck2$8 = _interopRequireDefault$8$1(classCallCheckExports);
var _createClass2$8 = _interopRequireDefault$8$1(createClassExports);
var _assertThisInitialized2$8 = _interopRequireDefault$8$1(assertThisInitializedExports);
var _inherits2$8 = _interopRequireDefault$8$1(inheritsExports);
var _createSuper2$8 = _interopRequireDefault$8$1(createSuperExports);
var _defineProperty2$8 = _interopRequireDefault$8$1(definePropertyExports);
var _Parser2$8 = Parser$1$1;
var _constants$5$1 = constants$3;
var _utils$8$1 = utils$4;
var Hour0To11Parser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$8.default)(Hour0To11Parser, _Parser);
  var _super = (0, _createSuper2$8.default)(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    (0, _classCallCheck2$8.default)(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$8.default)((0, _assertThisInitialized2$8.default)(_this), "priority", 70);
    (0, _defineProperty2$8.default)((0, _assertThisInitialized2$8.default)(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  (0, _createClass2$8.default)(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return (0, _utils$8$1.parseNumericPattern)(_constants$5$1.numericPatterns.hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return (0, _utils$8$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(_Parser2$8.Parser);
Hour0To11Parser$1$1.Hour0To11Parser = Hour0To11Parser$2;

var Hour1To24Parser$1$1 = {};

var _interopRequireDefault$7$1 = interopRequireDefaultExports.default;
Object.defineProperty(Hour1To24Parser$1$1, "__esModule", {
  value: true
});
Hour1To24Parser$1$1.Hour1To24Parser = void 0;
var _classCallCheck2$7 = _interopRequireDefault$7$1(classCallCheckExports);
var _createClass2$7 = _interopRequireDefault$7$1(createClassExports);
var _assertThisInitialized2$7 = _interopRequireDefault$7$1(assertThisInitializedExports);
var _inherits2$7 = _interopRequireDefault$7$1(inheritsExports);
var _createSuper2$7 = _interopRequireDefault$7$1(createSuperExports);
var _defineProperty2$7 = _interopRequireDefault$7$1(definePropertyExports);
var _Parser2$7 = Parser$1$1;
var _constants$4$1 = constants$3;
var _utils$7$1 = utils$4;
var Hour1To24Parser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$7.default)(Hour1To24Parser, _Parser);
  var _super = (0, _createSuper2$7.default)(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    (0, _classCallCheck2$7.default)(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$7.default)((0, _assertThisInitialized2$7.default)(_this), "priority", 70);
    (0, _defineProperty2$7.default)((0, _assertThisInitialized2$7.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  (0, _createClass2$7.default)(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return (0, _utils$7$1.parseNumericPattern)(_constants$4$1.numericPatterns.hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return (0, _utils$7$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(_Parser2$7.Parser);
Hour1To24Parser$1$1.Hour1To24Parser = Hour1To24Parser$2;

var MinuteParser$1$1 = {};

var _interopRequireDefault$6$1 = interopRequireDefaultExports.default;
Object.defineProperty(MinuteParser$1$1, "__esModule", {
  value: true
});
MinuteParser$1$1.MinuteParser = void 0;
var _classCallCheck2$6 = _interopRequireDefault$6$1(classCallCheckExports);
var _createClass2$6 = _interopRequireDefault$6$1(createClassExports);
var _assertThisInitialized2$6 = _interopRequireDefault$6$1(assertThisInitializedExports);
var _inherits2$6 = _interopRequireDefault$6$1(inheritsExports);
var _createSuper2$6 = _interopRequireDefault$6$1(createSuperExports);
var _defineProperty2$6 = _interopRequireDefault$6$1(definePropertyExports);
var _Parser2$6 = Parser$1$1;
var _constants$3$1 = constants$3;
var _utils$6$1 = utils$4;
var MinuteParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$6.default)(MinuteParser, _Parser);
  var _super = (0, _createSuper2$6.default)(MinuteParser);
  function MinuteParser() {
    var _this;
    (0, _classCallCheck2$6.default)(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$6.default)((0, _assertThisInitialized2$6.default)(_this), "priority", 60);
    (0, _defineProperty2$6.default)((0, _assertThisInitialized2$6.default)(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  (0, _createClass2$6.default)(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return (0, _utils$6$1.parseNumericPattern)(_constants$3$1.numericPatterns.minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return (0, _utils$6$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(_Parser2$6.Parser);
MinuteParser$1$1.MinuteParser = MinuteParser$2;

var SecondParser$1$1 = {};

var _interopRequireDefault$5$1 = interopRequireDefaultExports.default;
Object.defineProperty(SecondParser$1$1, "__esModule", {
  value: true
});
SecondParser$1$1.SecondParser = void 0;
var _classCallCheck2$5 = _interopRequireDefault$5$1(classCallCheckExports);
var _createClass2$5 = _interopRequireDefault$5$1(createClassExports);
var _assertThisInitialized2$5 = _interopRequireDefault$5$1(assertThisInitializedExports);
var _inherits2$5 = _interopRequireDefault$5$1(inheritsExports);
var _createSuper2$5 = _interopRequireDefault$5$1(createSuperExports);
var _defineProperty2$5 = _interopRequireDefault$5$1(definePropertyExports);
var _Parser2$5 = Parser$1$1;
var _constants$2$1 = constants$3;
var _utils$5$1 = utils$4;
var SecondParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$5.default)(SecondParser, _Parser);
  var _super = (0, _createSuper2$5.default)(SecondParser);
  function SecondParser() {
    var _this;
    (0, _classCallCheck2$5.default)(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$5.default)((0, _assertThisInitialized2$5.default)(_this), "priority", 50);
    (0, _defineProperty2$5.default)((0, _assertThisInitialized2$5.default)(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  (0, _createClass2$5.default)(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return (0, _utils$5$1.parseNumericPattern)(_constants$2$1.numericPatterns.second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return (0, _utils$5$1.parseNDigits)(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(_Parser2$5.Parser);
SecondParser$1$1.SecondParser = SecondParser$2;

var FractionOfSecondParser$1$1 = {};

var _interopRequireDefault$4$1 = interopRequireDefaultExports.default;
Object.defineProperty(FractionOfSecondParser$1$1, "__esModule", {
  value: true
});
FractionOfSecondParser$1$1.FractionOfSecondParser = void 0;
var _classCallCheck2$4 = _interopRequireDefault$4$1(classCallCheckExports);
var _createClass2$4 = _interopRequireDefault$4$1(createClassExports);
var _assertThisInitialized2$4 = _interopRequireDefault$4$1(assertThisInitializedExports);
var _inherits2$4 = _interopRequireDefault$4$1(inheritsExports);
var _createSuper2$4 = _interopRequireDefault$4$1(createSuperExports);
var _defineProperty2$4 = _interopRequireDefault$4$1(definePropertyExports);
var _Parser2$4 = Parser$1$1;
var _utils$4$1 = utils$4;
var FractionOfSecondParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$4.default)(FractionOfSecondParser, _Parser);
  var _super = (0, _createSuper2$4.default)(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    (0, _classCallCheck2$4.default)(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$4.default)((0, _assertThisInitialized2$4.default)(_this), "priority", 30);
    (0, _defineProperty2$4.default)((0, _assertThisInitialized2$4.default)(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  (0, _createClass2$4.default)(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return (0, _utils$4$1.mapValue)((0, _utils$4$1.parseNDigits)(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(_Parser2$4.Parser);
FractionOfSecondParser$1$1.FractionOfSecondParser = FractionOfSecondParser$2;

var ISOTimezoneWithZParser$1$1 = {};

var _interopRequireDefault$3$1 = interopRequireDefaultExports.default;
Object.defineProperty(ISOTimezoneWithZParser$1$1, "__esModule", {
  value: true
});
ISOTimezoneWithZParser$1$1.ISOTimezoneWithZParser = void 0;
var _classCallCheck2$3 = _interopRequireDefault$3$1(classCallCheckExports);
var _createClass2$3 = _interopRequireDefault$3$1(createClassExports);
var _assertThisInitialized2$3 = _interopRequireDefault$3$1(assertThisInitializedExports);
var _inherits2$3 = _interopRequireDefault$3$1(inheritsExports);
var _createSuper2$3 = _interopRequireDefault$3$1(createSuperExports);
var _defineProperty2$3 = _interopRequireDefault$3$1(definePropertyExports);
var _Parser2$3 = Parser$1$1;
var _constants$1$1 = constants$3;
var _utils$3$1 = utils$4;
// Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$3.default)(ISOTimezoneWithZParser, _Parser);
  var _super = (0, _createSuper2$3.default)(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    (0, _classCallCheck2$3.default)(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$3.default)((0, _assertThisInitialized2$3.default)(_this), "priority", 10);
    (0, _defineProperty2$3.default)((0, _assertThisInitialized2$3.default)(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  (0, _createClass2$3.default)(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return (0, _utils$3$1.parseTimezonePattern)(_constants$1$1.timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return (0, _utils$3$1.parseTimezonePattern)(_constants$1$1.timezonePatterns.basic, dateString);
        case 'XXXX':
          return (0, _utils$3$1.parseTimezonePattern)(_constants$1$1.timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return (0, _utils$3$1.parseTimezonePattern)(_constants$1$1.timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return (0, _utils$3$1.parseTimezonePattern)(_constants$1$1.timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(_Parser2$3.Parser);
ISOTimezoneWithZParser$1$1.ISOTimezoneWithZParser = ISOTimezoneWithZParser$2;

var ISOTimezoneParser$1$1 = {};

var _interopRequireDefault$2$1 = interopRequireDefaultExports.default;
Object.defineProperty(ISOTimezoneParser$1$1, "__esModule", {
  value: true
});
ISOTimezoneParser$1$1.ISOTimezoneParser = void 0;
var _classCallCheck2$2 = _interopRequireDefault$2$1(classCallCheckExports);
var _createClass2$2 = _interopRequireDefault$2$1(createClassExports);
var _assertThisInitialized2$2 = _interopRequireDefault$2$1(assertThisInitializedExports);
var _inherits2$2 = _interopRequireDefault$2$1(inheritsExports);
var _createSuper2$2 = _interopRequireDefault$2$1(createSuperExports);
var _defineProperty2$2 = _interopRequireDefault$2$1(definePropertyExports);
var _Parser2$2 = Parser$1$1;
var _constants$f = constants$3;
var _utils$2$1 = utils$4;
// Timezone (ISO-8601)
var ISOTimezoneParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$2.default)(ISOTimezoneParser, _Parser);
  var _super = (0, _createSuper2$2.default)(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    (0, _classCallCheck2$2.default)(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$2.default)((0, _assertThisInitialized2$2.default)(_this), "priority", 10);
    (0, _defineProperty2$2.default)((0, _assertThisInitialized2$2.default)(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  (0, _createClass2$2.default)(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return (0, _utils$2$1.parseTimezonePattern)(_constants$f.timezonePatterns.basicOptionalMinutes, dateString);
        case 'xx':
          return (0, _utils$2$1.parseTimezonePattern)(_constants$f.timezonePatterns.basic, dateString);
        case 'xxxx':
          return (0, _utils$2$1.parseTimezonePattern)(_constants$f.timezonePatterns.basicOptionalSeconds, dateString);
        case 'xxxxx':
          return (0, _utils$2$1.parseTimezonePattern)(_constants$f.timezonePatterns.extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return (0, _utils$2$1.parseTimezonePattern)(_constants$f.timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(_Parser2$2.Parser);
ISOTimezoneParser$1$1.ISOTimezoneParser = ISOTimezoneParser$2;

var TimestampSecondsParser$1$1 = {};

var _interopRequireDefault$1$1 = interopRequireDefaultExports.default;
Object.defineProperty(TimestampSecondsParser$1$1, "__esModule", {
  value: true
});
TimestampSecondsParser$1$1.TimestampSecondsParser = void 0;
var _classCallCheck2$1 = _interopRequireDefault$1$1(classCallCheckExports);
var _createClass2$1 = _interopRequireDefault$1$1(createClassExports);
var _assertThisInitialized2$1 = _interopRequireDefault$1$1(assertThisInitializedExports);
var _inherits2$1 = _interopRequireDefault$1$1(inheritsExports);
var _createSuper2$1 = _interopRequireDefault$1$1(createSuperExports);
var _defineProperty2$1 = _interopRequireDefault$1$1(definePropertyExports);
var _Parser2$1 = Parser$1$1;
var _utils$1$1 = utils$4;
var TimestampSecondsParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2$1.default)(TimestampSecondsParser, _Parser);
  var _super = (0, _createSuper2$1.default)(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    (0, _classCallCheck2$1.default)(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2$1.default)((0, _assertThisInitialized2$1.default)(_this), "priority", 40);
    (0, _defineProperty2$1.default)((0, _assertThisInitialized2$1.default)(_this), "incompatibleTokens", '*');
    return _this;
  }
  (0, _createClass2$1.default)(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return (0, _utils$1$1.parseAnyDigitsSigned)(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(_Parser2$1.Parser);
TimestampSecondsParser$1$1.TimestampSecondsParser = TimestampSecondsParser$2;

var TimestampMillisecondsParser$1$1 = {};

var _interopRequireDefault$3n = interopRequireDefaultExports.default;
Object.defineProperty(TimestampMillisecondsParser$1$1, "__esModule", {
  value: true
});
TimestampMillisecondsParser$1$1.TimestampMillisecondsParser = void 0;
var _classCallCheck2 = _interopRequireDefault$3n(classCallCheckExports);
var _createClass2 = _interopRequireDefault$3n(createClassExports);
var _assertThisInitialized2 = _interopRequireDefault$3n(assertThisInitializedExports);
var _inherits2 = _interopRequireDefault$3n(inheritsExports);
var _createSuper2 = _interopRequireDefault$3n(createSuperExports);
var _defineProperty2 = _interopRequireDefault$3n(definePropertyExports);
var _Parser2 = Parser$1$1;
var _utils$w = utils$4;
var TimestampMillisecondsParser$2 = /*#__PURE__*/function (_Parser) {
  (0, _inherits2.default)(TimestampMillisecondsParser, _Parser);
  var _super = (0, _createSuper2.default)(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    (0, _classCallCheck2.default)(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 20);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", '*');
    return _this;
  }
  (0, _createClass2.default)(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return (0, _utils$w.parseAnyDigitsSigned)(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(_Parser2.Parser);
TimestampMillisecondsParser$1$1.TimestampMillisecondsParser = TimestampMillisecondsParser$2;

Object.defineProperty(parsers$1, "__esModule", {
  value: true
});
parsers$1.parsers = void 0;
var _EraParser$1 = EraParser$1$1;
var _YearParser$1 = YearParser$1$1;
var _LocalWeekYearParser$1 = LocalWeekYearParser$1$1;
var _ISOWeekYearParser$1 = ISOWeekYearParser$1$1;
var _ExtendedYearParser$1 = ExtendedYearParser$1$1;
var _QuarterParser$1 = QuarterParser$1$1;
var _StandAloneQuarterParser$1 = StandAloneQuarterParser$1$1;
var _MonthParser$1 = MonthParser$1$1;
var _StandAloneMonthParser$1 = StandAloneMonthParser$1$1;
var _LocalWeekParser$1 = LocalWeekParser$1$1;
var _ISOWeekParser$1 = ISOWeekParser$1$1;
var _DateParser$1 = DateParser$1$1;
var _DayOfYearParser$1 = DayOfYearParser$1$1;
var _DayParser$1 = DayParser$1$1;
var _LocalDayParser$1 = LocalDayParser$1$1;
var _StandAloneLocalDayParser$1 = StandAloneLocalDayParser$1$1;
var _ISODayParser$1 = ISODayParser$1$1;
var _AMPMParser$1 = AMPMParser$1$1;
var _AMPMMidnightParser$1 = AMPMMidnightParser$1$1;
var _DayPeriodParser$1 = DayPeriodParser$1$1;
var _Hour1to12Parser$1 = Hour1to12Parser$1$1;
var _Hour0to23Parser$1 = Hour0to23Parser$1$1;
var _Hour0To11Parser$1 = Hour0To11Parser$1$1;
var _Hour1To24Parser$1 = Hour1To24Parser$1$1;
var _MinuteParser$1 = MinuteParser$1$1;
var _SecondParser$1 = SecondParser$1$1;
var _FractionOfSecondParser$1 = FractionOfSecondParser$1$1;
var _ISOTimezoneWithZParser$1 = ISOTimezoneWithZParser$1$1;
var _ISOTimezoneParser$1 = ISOTimezoneParser$1$1;
var _TimestampSecondsParser$1 = TimestampSecondsParser$1$1;
var _TimestampMillisecondsParser$1 = TimestampMillisecondsParser$1$1;
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers$3 = {
  G: new _EraParser$1.EraParser(),
  y: new _YearParser$1.YearParser(),
  Y: new _LocalWeekYearParser$1.LocalWeekYearParser(),
  R: new _ISOWeekYearParser$1.ISOWeekYearParser(),
  u: new _ExtendedYearParser$1.ExtendedYearParser(),
  Q: new _QuarterParser$1.QuarterParser(),
  q: new _StandAloneQuarterParser$1.StandAloneQuarterParser(),
  M: new _MonthParser$1.MonthParser(),
  L: new _StandAloneMonthParser$1.StandAloneMonthParser(),
  w: new _LocalWeekParser$1.LocalWeekParser(),
  I: new _ISOWeekParser$1.ISOWeekParser(),
  d: new _DateParser$1.DateParser(),
  D: new _DayOfYearParser$1.DayOfYearParser(),
  E: new _DayParser$1.DayParser(),
  e: new _LocalDayParser$1.LocalDayParser(),
  c: new _StandAloneLocalDayParser$1.StandAloneLocalDayParser(),
  i: new _ISODayParser$1.ISODayParser(),
  a: new _AMPMParser$1.AMPMParser(),
  b: new _AMPMMidnightParser$1.AMPMMidnightParser(),
  B: new _DayPeriodParser$1.DayPeriodParser(),
  h: new _Hour1to12Parser$1.Hour1to12Parser(),
  H: new _Hour0to23Parser$1.Hour0to23Parser(),
  K: new _Hour0To11Parser$1.Hour0To11Parser(),
  k: new _Hour1To24Parser$1.Hour1To24Parser(),
  m: new _MinuteParser$1.MinuteParser(),
  s: new _SecondParser$1.SecondParser(),
  S: new _FractionOfSecondParser$1.FractionOfSecondParser(),
  X: new _ISOTimezoneWithZParser$1.ISOTimezoneWithZParser(),
  x: new _ISOTimezoneParser$1.ISOTimezoneParser(),
  t: new _TimestampSecondsParser$1.TimestampSecondsParser(),
  T: new _TimestampMillisecondsParser$1.TimestampMillisecondsParser()
};
parsers$1.parsers = parsers$3;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = parse;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _createForOfIteratorHelper2 = _interopRequireDefault(createForOfIteratorHelperExports);
	var _index = _interopRequireDefault(defaultLocaleExports);
	var _index2 = _interopRequireDefault(subMillisecondsExports);
	var _index3 = _interopRequireDefault(toDateExports);
	var _index4 = _interopRequireDefault(assignExports);
	var _index5 = _interopRequireDefault(longFormattersExports);
	var _index6 = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index7 = protectedTokens$1;
	var _index8 = _interopRequireDefault(toIntegerExports);
	var _index9 = _interopRequireDefault(requiredArgsExports);
	var _Setter = Setter$1$1;
	var _index10 = parsers$1;
	var _index11 = defaultOptions$1$1;
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var defaultOptions = (0, _index11.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index.default;
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale
	  };

	  // If timezone isn't specified, it will be set to the system timezone
	  var setters = [new _Setter.DateToSystemTimezoneSetter()];
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter in _index5.default) {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	  var _iterator = (0, _createForOfIteratorHelper2.default)(tokens),
	    _step;
	  try {
	    var _loop = function _loop() {
	      var token = _step.value;
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      var firstCharacter = token[0];
	      var parser = _index10.parsers[firstCharacter];
	      if (parser) {
	        var incompatibleTokens = parser.incompatibleTokens;
	        if (Array.isArray(incompatibleTokens)) {
	          var incompatibleToken = usedTokens.find(function (usedToken) {
	            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
	          });
	          if (incompatibleToken) {
	            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	          }
	        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
	          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	        }
	        usedTokens.push({
	          token: firstCharacter,
	          fullToken: token
	        });
	        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
	        if (!parseResult) {
	          return {
	            v: new Date(NaN)
	          };
	        }
	        setters.push(parseResult.setter);
	        dateString = parseResult.rest;
	      } else {
	        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	        }

	        // Replace two single quote characters with one single quote character
	        if (token === "''") {
	          token = "'";
	        } else if (firstCharacter === "'") {
	          token = cleanEscapedString(token);
	        }

	        // Cut token from string, or, if string doesn't match the token, return Invalid Date
	        if (dateString.indexOf(token) === 0) {
	          dateString = dateString.slice(token.length);
	        } else {
	          return {
	            v: new Date(NaN)
	          };
	        }
	      }
	    };
	    for (_iterator.s(); !(_step = _iterator.n()).done;) {
	      var _ret = _loop();
	      if ((0, _typeof2.default)(_ret) === "object") return _ret.v;
	    }

	    // Check if the remaining input contains something other than whitespace
	  } catch (err) {
	    _iterator.e(err);
	  } finally {
	    _iterator.f();
	  }
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).sort(function (a, b) {
	      return b.subPriority - a.subPriority;
	    });
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }

	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	  var _iterator2 = (0, _createForOfIteratorHelper2.default)(uniquePrioritySetters),
	    _step2;
	  try {
	    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	      var setter = _step2.value;
	      if (!setter.validate(utcDate, subFnOptions)) {
	        return new Date(NaN);
	      }
	      var result = setter.set(utcDate, flags, subFnOptions);
	      // Result is tuple (date, flags)
	      if (Array.isArray(result)) {
	        utcDate = result[0];
	        (0, _index4.default)(flags, result[1]);
	        // Result is date
	      } else {
	        utcDate = result;
	      }
	    }
	  } catch (err) {
	    _iterator2.e(err);
	  } finally {
	    _iterator2.f();
	  }
	  return utcDate;
	}
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports$1.default; 
} (parse$4, parse$4.exports));

var parseExports = parse$4.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isMatch;
	var _index = _interopRequireDefault(parseExports);
	var _index2 = _interopRequireDefault(isValidExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isMatch
	 * @category Common Helpers
	 * @summary validates the date string against given formats
	 *
	 * @description
	 * Return the true if given date is string correct against the given format else
	 * will return false.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * isMatch('23 AM', 'HH a')
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `isMatch('50', 'yy') //=> true`
	 *
	 *    `isMatch('75', 'yy') //=> true`
	 *
	 *    while `uu` will use the year as is:
	 *
	 *    `isMatch('50', 'uu') //=> true`
	 *
	 *    `isMatch('75', 'uu') //=> true`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be checked in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
	 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 *
	 *
	 * @param {String} dateString - the date string to verify
	 * @param {String} formatString - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {Boolean}
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Match 11 February 2014 from middle-endian format:
	 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
	 * //=> true
	 *
	 * @example
	 * // Match 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
	 *   locale: eo
	 * })
	 * //=> true
	 */
	function isMatch(dateString, formatString, options) {
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)((0, _index.default)(dateString, formatString, new Date(), options));
	}
	module.exports = exports$1.default; 
} (isMatch$2, isMatch$2.exports));

var isMatchExports = isMatch$2.exports;

var isMonday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isMonday;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isMonday
	 * @category Weekday Helpers
	 * @summary Is the given date Monday?
	 *
	 * @description
	 * Is the given date Monday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 22 September 2014 Monday?
	 * const result = isMonday(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isMonday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date).getDay() === 1;
	}
	module.exports = exports$1.default; 
} (isMonday$2, isMonday$2.exports));

var isMondayExports = isMonday$2.exports;

var isPast$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isPast;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isPast
	 * @category Common Helpers
	 * @summary Is the given date in the past?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the past?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the past
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 2 July 2014 in the past?
	 * const result = isPast(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isPast(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() < Date.now();
	}
	module.exports = exports$1.default; 
} (isPast$2, isPast$2.exports));

var isPastExports = isPast$2.exports;

var isSameHour$2 = {exports: {}};

var startOfHour$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfHour;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfHour
	 * @category Hour Helpers
	 * @summary Return the start of an hour for the given date.
	 *
	 * @description
	 * Return the start of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an hour for 2 September 2014 11:55:00:
	 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:00:00
	 */
	function startOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfHour$2, startOfHour$2.exports));

var startOfHourExports = startOfHour$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameHour;
	var _index = _interopRequireDefault(startOfHourExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameHour
	 * @category Hour Helpers
	 * @summary Are the given dates in the same hour (and same day)?
	 *
	 * @description
	 * Are the given dates in the same hour (and same day)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same hour (and same day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
	 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
	 * //=> true
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
	 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
	 * //=> false
	 */
	function isSameHour(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfHour = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfHour = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
	}
	module.exports = exports$1.default; 
} (isSameHour$2, isSameHour$2.exports));

var isSameHourExports = isSameHour$2.exports;

var isSameISOWeek$2 = {exports: {}};

var isSameWeek$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameWeek;
	var _index = _interopRequireDefault(startOfWeekExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameWeek
	 * @category Week Helpers
	 * @summary Are the given dates in the same week (and month and year)?
	 *
	 * @description
	 * Are the given dates in the same week (and month and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the dates are in the same week (and month and year)
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Are 31 August 2014 and 4 September 2014 in the same week?
	 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
	 * //=> true
	 *
	 * @example
	 * // If week starts with Monday,
	 * // are 31 August 2014 and 4 September 2014 in the same week?
	 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
	 *   weekStartsOn: 1
	 * })
	 * //=> false
	 *
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same week?
	 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameWeek(dirtyDateLeft, dirtyDateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfWeek = (0, _index.default)(dirtyDateLeft, options);
	  var dateRightStartOfWeek = (0, _index.default)(dirtyDateRight, options);
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
	}
	module.exports = exports$1.default; 
} (isSameWeek$2, isSameWeek$2.exports));

var isSameWeekExports = isSameWeek$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameISOWeek;
	var _index = _interopRequireDefault(isSameWeekExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameISOWeek
	 * @category ISO Week Helpers
	 * @summary Are the given dates in the same ISO week (and year)?
	 *
	 * @description
	 * Are the given dates in the same ISO week (and year)?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
	 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
	 * //=> true
	 *
	 * @example
	 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
	 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
	 * //=> false
	 */
	function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft, dirtyDateRight, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports$1.default; 
} (isSameISOWeek$2, isSameISOWeek$2.exports));

var isSameISOWeekExports = isSameISOWeek$2.exports;

var isSameISOWeekYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameISOWeekYear;
	var _index = _interopRequireDefault(startOfISOWeekYearExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Are the given dates in the same ISO week-numbering year?
	 *
	 * @description
	 * Are the given dates in the same ISO week-numbering year?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week-numbering year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
	 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
	 * //=> true
	 */
	function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfYear = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfYear = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
	}
	module.exports = exports$1.default; 
} (isSameISOWeekYear$2, isSameISOWeekYear$2.exports));

var isSameISOWeekYearExports = isSameISOWeekYear$2.exports;

var isSameMinute$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameMinute;
	var _index = _interopRequireDefault(startOfMinuteExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameMinute
	 * @category Minute Helpers
	 * @summary Are the given dates in the same minute (and hour and day)?
	 *
	 * @description
	 * Are the given dates in the same minute (and hour and day)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same minute (and hour and day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
	 * const result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 4, 6, 30, 15)
	 * )
	 * //=> true
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
	 * const result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 5, 6, 30)
	 * )
	 * //=> false
	 */
	function isSameMinute(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfMinute = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfMinute = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
	}
	module.exports = exports$1.default; 
} (isSameMinute$2, isSameMinute$2.exports));

var isSameMinuteExports = isSameMinute$2.exports;

var isSameMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameMonth;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month (and year)?
	 *
	 * @description
	 * Are the given dates in the same month (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2015 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
	 * //=> false
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	module.exports = exports$1.default; 
} (isSameMonth$2, isSameMonth$2.exports));

var isSameMonthExports = isSameMonth$2.exports;

var isSameQuarter$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameQuarter;
	var _index = _interopRequireDefault(startOfQuarterExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same quarter (and year)?
	 *
	 * @description
	 * Are the given dates in the same quarter (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 *
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	module.exports = exports$1.default; 
} (isSameQuarter$2, isSameQuarter$2.exports));

var isSameQuarterExports = isSameQuarter$2.exports;

var isSameSecond$2 = {exports: {}};

var startOfSecond$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfSecond;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfSecond
	 * @category Second Helpers
	 * @summary Return the start of a second for the given date.
	 *
	 * @description
	 * Return the start of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a second for 1 December 2014 22:15:45.400:
	 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.000
	 */
	function startOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfSecond$2, startOfSecond$2.exports));

var startOfSecondExports = startOfSecond$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameSecond;
	var _index = _interopRequireDefault(startOfSecondExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameSecond
	 * @category Second Helpers
	 * @summary Are the given dates in the same second (and hour and day)?
	 *
	 * @description
	 * Are the given dates in the same second (and hour and day)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same second (and hour and day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
	 * const result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 30, 15),
	 *   new Date(2014, 8, 4, 6, 30, 15, 500)
	 * )
	 * //=> true
	 *
	 * @example
	 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
	 * const result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 0, 15),
	 *   new Date(2014, 8, 4, 6, 1, 15)
	 * )
	 * //=> false
	 *
	 * @example
	 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
	 * const result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 0, 15),
	 *   new Date(2014, 8, 5, 6, 0, 15)
	 * )
	 * //=> false
	 */
	function isSameSecond(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfSecond = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfSecond = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
	}
	module.exports = exports$1.default; 
} (isSameSecond$2, isSameSecond$2.exports));

var isSameSecondExports = isSameSecond$2.exports;

var isSameYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isSameYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	module.exports = exports$1.default; 
} (isSameYear$2, isSameYear$2.exports));

var isSameYearExports = isSameYear$2.exports;

var isThisHour$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isThisHour;
	var _index = _interopRequireDefault(isSameHourExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isThisHour
	 * @category Hour Helpers
	 * @summary Is the given date in the same hour as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same hour as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:00:00 in this hour?
	 * const result = isThisHour(new Date(2014, 8, 25, 18))
	 * //=> true
	 */
	function isThisHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports$1.default; 
} (isThisHour$2, isThisHour$2.exports));

var isThisHourExports = isThisHour$2.exports;

var isThisISOWeek$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isThisISOWeek;
	var _index = _interopRequireDefault(isSameISOWeekExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isThisISOWeek
	 * @category ISO Week Helpers
	 * @summary Is the given date in the same ISO week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same ISO week as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
	 * const result = isThisISOWeek(new Date(2014, 8, 22))
	 * //=> true
	 */

	function isThisISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	module.exports = exports$1.default; 
} (isThisISOWeek$2, isThisISOWeek$2.exports));

var isThisISOWeekExports = isThisISOWeek$2.exports;

var isThisMinute$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isThisMinute;
	var _index = _interopRequireDefault(isSameMinuteExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isThisMinute
	 * @category Minute Helpers
	 * @summary Is the given date in the same minute as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same minute as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:00 in this minute?
	 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
	 * //=> true
	 */

	function isThisMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports$1.default; 
} (isThisMinute$2, isThisMinute$2.exports));

var isThisMinuteExports = isThisMinute$2.exports;

var isThisMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isThisMonth;
	var _index = _interopRequireDefault(isSameMonthExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isThisMonth
	 * @category Month Helpers
	 * @summary Is the given date in the same month as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same month as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 15 September 2014 in this month?
	 * const result = isThisMonth(new Date(2014, 8, 15))
	 * //=> true
	 */

	function isThisMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports$1.default; 
} (isThisMonth$2, isThisMonth$2.exports));

var isThisMonthExports = isThisMonth$2.exports;

var isThisQuarter$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isThisQuarter;
	var _index = _interopRequireDefault(isSameQuarterExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isThisQuarter
	 * @category Quarter Helpers
	 * @summary Is the given date in the same quarter as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same quarter as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
	 * const result = isThisQuarter(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports$1.default; 
} (isThisQuarter$2, isThisQuarter$2.exports));

var isThisQuarterExports = isThisQuarter$2.exports;

var isThisSecond$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isThisSecond;
	var _index = _interopRequireDefault(isSameSecondExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isThisSecond
	 * @category Second Helpers
	 * @summary Is the given date in the same second as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same second as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:15.000 in this second?
	 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
	 * //=> true
	 */
	function isThisSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports$1.default; 
} (isThisSecond$2, isThisSecond$2.exports));

var isThisSecondExports = isThisSecond$2.exports;

var isThisWeek$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isThisWeek;
	var _index = _interopRequireDefault(isSameWeekExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isThisWeek
	 * @category Week Helpers
	 * @summary Is the given date in the same week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same week as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Object} [options] - the object with options
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the date is in this week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // If today is 25 September 2014, is 21 September 2014 in this week?
	 * const result = isThisWeek(new Date(2014, 8, 21))
	 * //=> true
	 *
	 * @example
	 * // If today is 25 September 2014 and week starts with Monday
	 * // is 21 September 2014 in this week?
	 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
	 * //=> false
	 */

	function isThisWeek(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	module.exports = exports$1.default; 
} (isThisWeek$2, isThisWeek$2.exports));

var isThisWeekExports = isThisWeek$2.exports;

var isThisYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isThisYear;
	var _index = _interopRequireDefault(isSameYearExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isThisYear
	 * @category Year Helpers
	 * @summary Is the given date in the same year as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same year as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this year?
	 * const result = isThisYear(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	module.exports = exports$1.default; 
} (isThisYear$2, isThisYear$2.exports));

var isThisYearExports = isThisYear$2.exports;

var isThursday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isThursday;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isThursday
	 * @category Weekday Helpers
	 * @summary Is the given date Thursday?
	 *
	 * @description
	 * Is the given date Thursday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 25 September 2014 Thursday?
	 * const result = isThursday(new Date(2014, 8, 25))
	 * //=> true
	 */
	function isThursday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 4;
	}
	module.exports = exports$1.default; 
} (isThursday$2, isThursday$2.exports));

var isThursdayExports = isThursday$2.exports;

var isToday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isToday;
	var _index = _interopRequireDefault(isSameDayExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isToday
	 * @category Day Helpers
	 * @summary Is the given date today?
	 * @pure false
	 *
	 * @description
	 * Is the given date today?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * const result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	module.exports = exports$1.default; 
} (isToday$2, isToday$2.exports));

var isTodayExports = isToday$2.exports;

var isTomorrow$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isTomorrow;
	var _index = _interopRequireDefault(addDaysExports);
	var _index2 = _interopRequireDefault(isSameDayExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isTomorrow
	 * @category Day Helpers
	 * @summary Is the given date tomorrow?
	 * @pure false
	 *
	 * @description
	 * Is the given date tomorrow?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is tomorrow
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
	 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
	 * //=> true
	 */
	function isTomorrow(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index2.default)(dirtyDate, (0, _index.default)(Date.now(), 1));
	}
	module.exports = exports$1.default; 
} (isTomorrow$2, isTomorrow$2.exports));

var isTomorrowExports = isTomorrow$2.exports;

var isTuesday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isTuesday;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isTuesday
	 * @category Weekday Helpers
	 * @summary Is the given date Tuesday?
	 *
	 * @description
	 * Is the given date Tuesday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 23 September 2014 Tuesday?
	 * const result = isTuesday(new Date(2014, 8, 23))
	 * //=> true
	 */
	function isTuesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 2;
	}
	module.exports = exports$1.default; 
} (isTuesday$2, isTuesday$2.exports));

var isTuesdayExports = isTuesday$2.exports;

var isWednesday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isWednesday;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isWednesday
	 * @category Weekday Helpers
	 * @summary Is the given date Wednesday?
	 *
	 * @description
	 * Is the given date Wednesday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 24 September 2014 Wednesday?
	 * const result = isWednesday(new Date(2014, 8, 24))
	 * //=> true
	 */
	function isWednesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 3;
	}
	module.exports = exports$1.default; 
} (isWednesday$2, isWednesday$2.exports));

var isWednesdayExports = isWednesday$2.exports;

var isWithinInterval$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isWithinInterval;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, interval) {
	  (0, _index2.default)(2, arguments);
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime();

	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  return time >= startTime && time <= endTime;
	}
	module.exports = exports$1.default; 
} (isWithinInterval$2, isWithinInterval$2.exports));

var isWithinIntervalExports = isWithinInterval$2.exports;

var isYesterday$2 = {exports: {}};

var subDays$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subDays;
	var _index = _interopRequireDefault(addDaysExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * const result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subDays$2, subDays$2.exports));

var subDaysExports = subDays$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = isYesterday;
	var _index = _interopRequireDefault(isSameDayExports);
	var _index2 = _interopRequireDefault(subDaysExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isYesterday
	 * @category Day Helpers
	 * @summary Is the given date yesterday?
	 * @pure false
	 *
	 * @description
	 * Is the given date yesterday?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is yesterday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
	 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
	 * //=> true
	 */
	function isYesterday(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, (0, _index2.default)(Date.now(), 1));
	}
	module.exports = exports$1.default; 
} (isYesterday$2, isYesterday$2.exports));

var isYesterdayExports = isYesterday$2.exports;

var lastDayOfDecade$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = lastDayOfDecade;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name lastDayOfDecade
	 * @category Decade Helpers
	 * @summary Return the last day of a decade for the given date.
	 *
	 * @description
	 * Return the last day of a decade for the given date.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a decade for 21 December 2012 21:12:00:
	 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
	 * //=> Wed Dec 31 2019 00:00:00
	 */
	function lastDayOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (lastDayOfDecade$2, lastDayOfDecade$2.exports));

var lastDayOfDecadeExports = lastDayOfDecade$2.exports;

var lastDayOfISOWeek$2 = {exports: {}};

var lastDayOfWeek$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = lastDayOfWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(toIntegerExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var _index4 = defaultOptions$1$1;
	/**
	 * @name lastDayOfWeek
	 * @category Week Helpers
	 * @summary Return the last day of a week for the given date.
	 *
	 * @description
	 * Return the last day of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the last day of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The last day of a week for 2 September 2014 11:55:00:
	 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
	 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index3.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setHours(0, 0, 0, 0);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	module.exports = exports$1.default; 
} (lastDayOfWeek$2, lastDayOfWeek$2.exports));

var lastDayOfWeekExports = lastDayOfWeek$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = lastDayOfISOWeek;
	var _index = _interopRequireDefault(lastDayOfWeekExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name lastDayOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the last day of an ISO week for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week for 2 September 2014 11:55:00:
	 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports$1.default; 
} (lastDayOfISOWeek$2, lastDayOfISOWeek$2.exports));

var lastDayOfISOWeekExports = lastDayOfISOWeek$2.exports;

var lastDayOfISOWeekYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = lastDayOfISOWeekYear;
	var _index = _interopRequireDefault(getISOWeekYearExports);
	var _index2 = _interopRequireDefault(startOfISOWeekExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name lastDayOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the last day of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week-numbering year for 2 July 2005:
	 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 00:00:00
	 */
	function lastDayOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year + 1, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  date.setDate(date.getDate() - 1);
	  return date;
	}
	module.exports = exports$1.default; 
} (lastDayOfISOWeekYear$2, lastDayOfISOWeekYear$2.exports));

var lastDayOfISOWeekYearExports = lastDayOfISOWeekYear$2.exports;

var lastDayOfQuarter$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = lastDayOfQuarter;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name lastDayOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the last day of a year quarter for the given date.
	 *
	 * @description
	 * Return the last day of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the last day of a quarter
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The last day of a quarter for 2 September 2014 11:55:00:
	 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (lastDayOfQuarter$2, lastDayOfQuarter$2.exports));

var lastDayOfQuarterExports = lastDayOfQuarter$2.exports;

var lastDayOfYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = lastDayOfYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name lastDayOfYear
	 * @category Year Helpers
	 * @summary Return the last day of a year for the given date.
	 *
	 * @description
	 * Return the last day of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a year for 2 September 2014 11:55:00:
	 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 00:00:00
	 */
	function lastDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (lastDayOfYear$2, lastDayOfYear$2.exports));

var lastDayOfYearExports = lastDayOfYear$2.exports;

var lightFormat$1 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = lightFormat;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(lightFormattersExports);
	var _index3 = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index4 = _interopRequireDefault(isValidExports);
	var _index5 = _interopRequireDefault(subMillisecondsExports);
	var _index6 = _interopRequireDefault(requiredArgsExports);
	// This RegExp consists of three parts separated by `|`:
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

	/**
	 * @name lightFormat
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. Unlike `format`,
	 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
	 *
	 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   |
	 * |---------------------------------|---------|-----------------------------------|
	 * | AM, PM                          | a..aaa  | AM, PM                            |
	 * |                                 | aaaa    | a.m., p.m.                        |
	 * |                                 | aaaaa   | a, p                              |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
	 * |                                 | yy      | 44, 01, 00, 17                    |
	 * |                                 | yyy     | 044, 001, 000, 017                |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
	 * |                                 | MM      | 01, 02, ..., 12                   |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |
	 * |                                 | dd      | 01, 02, ..., 31                   |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |
	 * | Minute                          | m       | 0, 1, ..., 59                     |
	 * |                                 | mm      | 00, 01, ..., 59                   |
	 * | Second                          | s       | 0, 1, ..., 59                     |
	 * |                                 | ss      | 00, 01, ..., 59                   |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |
	 * |                                 | SS      | 00, 01, ..., 99                   |
	 * |                                 | SSS     | 000, 001, ..., 999                |
	 * |                                 | SSSS    | ...                               |
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
	 * //=> '2014-02-11'
	 */

	function lightFormat(dirtyDate, formatStr) {
	  (0, _index6.default)(2, arguments);
	  var originalDate = (0, _index.default)(dirtyDate);
	  if (!(0, _index4.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }

	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = (0, _index3.default)(originalDate);
	  var utcDate = (0, _index5.default)(originalDate, timezoneOffset);
	  var tokens = formatStr.match(formattingTokensRegExp);

	  // The only case when formattingTokensRegExp doesn't match the string is when it's empty
	  if (!tokens) return '';
	  var result = tokens.map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	    var firstCharacter = substring[0];
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	    var formatter = _index2.default[firstCharacter];
	    if (formatter) {
	      return formatter(utcDate, substring);
	    }
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	    return substring;
	  }).join('');
	  return result;
	}
	function cleanEscapedString(input) {
	  var matches = input.match(escapedStringRegExp);
	  if (!matches) {
	    return input;
	  }
	  return matches[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports$1.default; 
} (lightFormat$1, lightFormat$1.exports));

var lightFormatExports = lightFormat$1.exports;

var milliseconds$3 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = milliseconds;
	var _index = _interopRequireDefault(requiredArgsExports);
	// Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	// 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	var daysInYear = 365.2425;

	/**
	 * @name milliseconds
	 * @category Millisecond Helpers
	 * @summary
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * @description
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * One years equals 365.2425 days according to the formula:
	 *
	 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	 *
	 * One month is a year divided by 12.
	 *
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // 1 year in milliseconds
	 * milliseconds({ years: 1 })
	 * //=> 31556952000
	 *
	 * // 3 months in milliseconds
	 * milliseconds({ months: 3 })
	 * //=> 7889238000
	 */
	function milliseconds(_ref) {
	  var years = _ref.years,
	    months = _ref.months,
	    weeks = _ref.weeks,
	    days = _ref.days,
	    hours = _ref.hours,
	    minutes = _ref.minutes,
	    seconds = _ref.seconds;
	  (0, _index.default)(1, arguments);
	  var totalDays = 0;
	  if (years) totalDays += years * daysInYear;
	  if (months) totalDays += months * (daysInYear / 12);
	  if (weeks) totalDays += weeks * 7;
	  if (days) totalDays += days;
	  var totalSeconds = totalDays * 24 * 60 * 60;
	  if (hours) totalSeconds += hours * 60 * 60;
	  if (minutes) totalSeconds += minutes * 60;
	  if (seconds) totalSeconds += seconds;
	  return Math.round(totalSeconds * 1000);
	}
	module.exports = exports$1.default; 
} (milliseconds$3, milliseconds$3.exports));

var millisecondsExports = milliseconds$3.exports;

var millisecondsToHours$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = millisecondsToHours;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name millisecondsToHours
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to hours.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of hours.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200000 milliseconds to hours:
	 * const result = millisecondsToHours(7200000)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToHours(7199999)
	 * //=> 1
	 */
	function millisecondsToHours(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var hours = milliseconds / _index2.millisecondsInHour;
	  return Math.floor(hours);
	}
	module.exports = exports$1.default; 
} (millisecondsToHours$2, millisecondsToHours$2.exports));

var millisecondsToHoursExports = millisecondsToHours$2.exports;

var millisecondsToMinutes$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = millisecondsToMinutes;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name millisecondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to minutes.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of minutes.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted.
	 *
	 * @returns {number} the number of milliseconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 60000 milliseconds to minutes:
	 * const result = millisecondsToMinutes(60000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToMinutes(119999)
	 * //=> 1
	 */
	function millisecondsToMinutes(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = milliseconds / _index2.millisecondsInMinute;
	  return Math.floor(minutes);
	}
	module.exports = exports$1.default; 
} (millisecondsToMinutes$2, millisecondsToMinutes$2.exports));

var millisecondsToMinutesExports = millisecondsToMinutes$2.exports;

var millisecondsToSeconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = millisecondsToSeconds;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name millisecondsToSeconds
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to seconds.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of seconds.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 1000 miliseconds to seconds:
	 * const result = millisecondsToSeconds(1000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToSeconds(1999)
	 * //=> 1
	 */
	function millisecondsToSeconds(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var seconds = milliseconds / _index2.millisecondsInSecond;
	  return Math.floor(seconds);
	}
	module.exports = exports$1.default; 
} (millisecondsToSeconds$2, millisecondsToSeconds$2.exports));

var millisecondsToSecondsExports = millisecondsToSeconds$2.exports;

var minutesToHours$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = minutesToHours;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name minutesToHours
	 * @category Conversion Helpers
	 * @summary Convert minutes to hours.
	 *
	 * @description
	 * Convert a number of minutes to a full number of hours.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 140 minutes to hours:
	 * const result = minutesToHours(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = minutesToHours(179)
	 * //=> 2
	 */
	function minutesToHours(minutes) {
	  (0, _index.default)(1, arguments);
	  var hours = minutes / _index2.minutesInHour;
	  return Math.floor(hours);
	}
	module.exports = exports$1.default; 
} (minutesToHours$2, minutesToHours$2.exports));

var minutesToHoursExports = minutesToHours$2.exports;

var minutesToMilliseconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = minutesToMilliseconds;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name minutesToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to milliseconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of milliseconds.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to milliseconds
	 * const result = minutesToMilliseconds(2)
	 * //=> 120000
	 */
	function minutesToMilliseconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.millisecondsInMinute);
	}
	module.exports = exports$1.default; 
} (minutesToMilliseconds$2, minutesToMilliseconds$2.exports));

var minutesToMillisecondsExports = minutesToMilliseconds$2.exports;

var minutesToSeconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = minutesToSeconds;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name minutesToSeconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to seconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of seconds.
	 *
	 * @param { number } minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to seconds
	 * const result = minutesToSeconds(2)
	 * //=> 120
	 */
	function minutesToSeconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.secondsInMinute);
	}
	module.exports = exports$1.default; 
} (minutesToSeconds$2, minutesToSeconds$2.exports));

var minutesToSecondsExports = minutesToSeconds$2.exports;

var monthsToQuarters$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = monthsToQuarters;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name monthsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert number of months to quarters.
	 *
	 * @description
	 * Convert a number of months to a full number of quarters.
	 *
	 * @param {number} months - number of months to be converted.
	 *
	 * @returns {number} the number of months converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 6 months to quarters:
	 * const result = monthsToQuarters(6)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = monthsToQuarters(7)
	 * //=> 2
	 */
	function monthsToQuarters(months) {
	  (0, _index.default)(1, arguments);
	  var quarters = months / _index2.monthsInQuarter;
	  return Math.floor(quarters);
	}
	module.exports = exports$1.default; 
} (monthsToQuarters$2, monthsToQuarters$2.exports));

var monthsToQuartersExports = monthsToQuarters$2.exports;

var monthsToYears$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = monthsToYears;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name monthsToYears
	 * @category Conversion Helpers
	 * @summary Convert number of months to years.
	 *
	 * @description
	 * Convert a number of months to a full number of years.
	 *
	 * @param {number} months - number of months to be converted
	 *
	 * @returns {number} the number of months converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 36 months to years:
	 * const result = monthsToYears(36)
	 * //=> 3
	 *
	 * // It uses floor rounding:
	 * const result = monthsToYears(40)
	 * //=> 3
	 */
	function monthsToYears(months) {
	  (0, _index.default)(1, arguments);
	  var years = months / _index2.monthsInYear;
	  return Math.floor(years);
	}
	module.exports = exports$1.default; 
} (monthsToYears$2, monthsToYears$2.exports));

var monthsToYearsExports = monthsToYears$2.exports;

var nextDay$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = nextDay;
	var _index = _interopRequireDefault(addDaysExports);
	var _index2 = _interopRequireDefault(getDayExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name nextDay
	 * @category Weekday Helpers
	 * @summary When is the next day of the week?
	 *
	 * @description
	 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {Day} day - day of the week
	 * @returns {Date} - the date is the next day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the next Monday after Mar, 20, 2020?
	 * const result = nextDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 23 2020 00:00:00
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 21, 2020?
	 * const result = nextDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextDay(date, day) {
	  (0, _index3.default)(2, arguments);
	  var delta = day - (0, _index2.default)(date);
	  if (delta <= 0) delta += 7;
	  return (0, _index.default)(date, delta);
	}
	module.exports = exports$1.default; 
} (nextDay$2, nextDay$2.exports));

var nextDayExports = nextDay$2.exports;

var nextFriday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = nextFriday;
	var _index = _interopRequireDefault(nextDayExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name nextFriday
	 * @category Weekday Helpers
	 * @summary When is the next Friday?
	 *
	 * @description
	 * When is the next Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Friday after Mar, 22, 2020?
	 * const result = nextFriday(new Date(2020, 2, 22))
	 * //=> Fri Mar 27 2020 00:00:00
	 */
	function nextFriday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 5);
	}
	module.exports = exports$1.default; 
} (nextFriday$2, nextFriday$2.exports));

var nextFridayExports = nextFriday$2.exports;

var nextMonday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = nextMonday;
	var _index = _interopRequireDefault(nextDayExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name nextMonday
	 * @category Weekday Helpers
	 * @summary When is the next Monday?
	 *
	 * @description
	 * When is the next Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Monday after Mar, 22, 2020?
	 * const result = nextMonday(new Date(2020, 2, 22))
	 * //=> Mon Mar 23 2020 00:00:00
	 */
	function nextMonday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 1);
	}
	module.exports = exports$1.default; 
} (nextMonday$2, nextMonday$2.exports));

var nextMondayExports = nextMonday$2.exports;

var nextSaturday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = nextSaturday;
	var _index = _interopRequireDefault(nextDayExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name nextSaturday
	 * @category Weekday Helpers
	 * @summary When is the next Saturday?
	 *
	 * @description
	 * When is the next Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Saturday after Mar, 22, 2020?
	 * const result = nextSaturday(new Date(2020, 2, 22))
	 * //=> Sat Mar 28 2020 00:00:00
	 */
	function nextSaturday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 6);
	}
	module.exports = exports$1.default; 
} (nextSaturday$2, nextSaturday$2.exports));

var nextSaturdayExports = nextSaturday$2.exports;

var nextSunday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = nextSunday;
	var _index = _interopRequireDefault(nextDayExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name nextSunday
	 * @category Weekday Helpers
	 * @summary When is the next Sunday?
	 *
	 * @description
	 * When is the next Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Sunday after Mar, 22, 2020?
	 * const result = nextSunday(new Date(2020, 2, 22))
	 * //=> Sun Mar 29 2020 00:00:00
	 */
	function nextSunday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 0);
	}
	module.exports = exports$1.default; 
} (nextSunday$2, nextSunday$2.exports));

var nextSundayExports = nextSunday$2.exports;

var nextThursday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = nextThursday;
	var _index = _interopRequireDefault(nextDayExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name nextThursday
	 * @category Weekday Helpers
	 * @summary When is the next Thursday?
	 *
	 * @description
	 * When is the next Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Thursday after Mar, 22, 2020?
	 * const result = nextThursday(new Date(2020, 2, 22))
	 * //=> Thur Mar 26 2020 00:00:00
	 */
	function nextThursday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 4);
	}
	module.exports = exports$1.default; 
} (nextThursday$2, nextThursday$2.exports));

var nextThursdayExports = nextThursday$2.exports;

var nextTuesday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = nextTuesday;
	var _index = _interopRequireDefault(nextDayExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name nextTuesday
	 * @category Weekday Helpers
	 * @summary When is the next Tuesday?
	 *
	 * @description
	 * When is the next Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 22, 2020?
	 * const result = nextTuesday(new Date(2020, 2, 22))
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextTuesday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 2);
	}
	module.exports = exports$1.default; 
} (nextTuesday$2, nextTuesday$2.exports));

var nextTuesdayExports = nextTuesday$2.exports;

var nextWednesday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = nextWednesday;
	var _index = _interopRequireDefault(nextDayExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name nextWednesday
	 * @category Weekday Helpers
	 * @summary When is the next Wednesday?
	 *
	 * @description
	 * When is the next Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Wednesday after Mar, 22, 2020?
	 * const result = nextWednesday(new Date(2020, 2, 22))
	 * //=> Wed Mar 25 2020 00:00:00
	 */
	function nextWednesday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 3);
	}
	module.exports = exports$1.default; 
} (nextWednesday$2, nextWednesday$2.exports));

var nextWednesdayExports = nextWednesday$2.exports;

var parseISO$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = parseISO;
	var _index = constants$1$1;
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * const result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * const result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parseISO(argument, options) {
	  var _options$additionalDi;
	  (0, _index2.default)(1, arguments);
	  var additionalDigits = (0, _index3.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	  var dateStrings = splitDateString(argument);
	  var date;
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	  if (!date || isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	    if (isNaN(time)) {
	      return new Date(NaN);
	    }
	  }
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time);
	    // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	    var result = new Date(0);
	    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
	    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    return result;
	  }
	  return new Date(timestamp + time + offset);
	}
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString;

	  // The regex match should only return at maximum two array elements.
	  // [date], [time], or [date, time].
	  if (array.length > 2) {
	    return dateStrings;
	  }
	  if (/:/.test(array[0])) {
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	  return dateStrings;
	}
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex);
	  // Invalid ISO-formatted year
	  if (!captures) return {
	    year: NaN,
	    restDateString: ''
	  };
	  var year = captures[1] ? parseInt(captures[1]) : null;
	  var century = captures[2] ? parseInt(captures[2]) : null;

	  // either year or century is null, not both
	  return {
	    year: century === null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return new Date(NaN);
	  var captures = dateString.match(dateRegex);
	  // Invalid ISO-formatted string
	  if (!captures) return new Date(NaN);
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return NaN; // Invalid ISO-formatted time

	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	  return hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * 1000;
	}
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	  return sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute);
	}
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}

	// Validation functions

	// February is null to handle the leap year (using ||)
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	module.exports = exports$1.default; 
} (parseISO$2, parseISO$2.exports));

var parseISOExports = parseISO$2.exports;

var parseJSON$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = parseJSON;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name parseJSON
	 * @category Common Helpers
	 * @summary Parse a JSON date string
	 *
	 * @description
	 * Converts a complete ISO date string in UTC time, the typical format for transmitting
	 * a date in JSON, to a JavaScript `Date` instance.
	 *
	 * This is a minimal implementation for converting dates retrieved from a JSON API to
	 * a `Date` instance which can be used with other functions in the `date-fns` library.
	 * The following formats are supported:
	 *
	 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
	 * - `2000-03-15T05:20:10Z`: Without milliseconds
	 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
	 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
	 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
	 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
	 *
	 * For convenience and ease of use these other input types are also supported
	 * via [toDate]{@link https://date-fns.org/docs/toDate}:
	 *
	 * - A `Date` instance will be cloned
	 * - A `number` will be treated as a timestamp
	 *
	 * Any other input type or invalid date strings will return an `Invalid Date`.
	 *
	 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 */
	function parseJSON(argument) {
	  (0, _index2.default)(1, arguments);
	  if (typeof argument === 'string') {
	    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
	    if (parts) {
	      // Group 8 matches the sign
	      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
	    }
	    return new Date(NaN);
	  }
	  return (0, _index.default)(argument);
	}
	module.exports = exports$1.default; 
} (parseJSON$2, parseJSON$2.exports));

var parseJSONExports = parseJSON$2.exports;

var previousDay$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = previousDay;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = _interopRequireDefault(getDayExports);
	var _index3 = _interopRequireDefault(subDaysExports);
	/**
	 * @name previousDay
	 * @category Weekday Helpers
	 * @summary When is the previous day of the week?
	 *
	 * @description
	 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {number} day - day of the week
	 * @returns {Date} - the date is the previous day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the previous Monday before Mar, 20, 2020?
	 * const result = previousDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 16 2020 00:00:00
	 *
	 * @example
	 * // When is the previous Tuesday before Mar, 21, 2020?
	 * const result = previousDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 17 2020 00:00:00
	 */
	function previousDay(date, day) {
	  (0, _index.default)(2, arguments);
	  var delta = (0, _index2.default)(date) - day;
	  if (delta <= 0) delta += 7;
	  return (0, _index3.default)(date, delta);
	}
	module.exports = exports$1.default; 
} (previousDay$2, previousDay$2.exports));

var previousDayExports = previousDay$2.exports;

var previousFriday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = previousFriday;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = _interopRequireDefault(previousDayExports);
	/**
	 * @name previousFriday
	 * @category Weekday Helpers
	 * @summary When is the previous Friday?
	 *
	 * @description
	 * When is the previous Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Friday before Jun, 19, 2021?
	 * const result = previousFriday(new Date(2021, 5, 19))
	 * //=> Fri June 18 2021 00:00:00
	 */
	function previousFriday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 5);
	}
	module.exports = exports$1.default; 
} (previousFriday$2, previousFriday$2.exports));

var previousFridayExports = previousFriday$2.exports;

var previousMonday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = previousMonday;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = _interopRequireDefault(previousDayExports);
	/**
	 * @name previousMonday
	 * @category Weekday Helpers
	 * @summary When is the previous Monday?
	 *
	 * @description
	 * When is the previous Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Monday before Jun, 18, 2021?
	 * const result = previousMonday(new Date(2021, 5, 18))
	 * //=> Mon June 14 2021 00:00:00
	 */
	function previousMonday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 1);
	}
	module.exports = exports$1.default; 
} (previousMonday$2, previousMonday$2.exports));

var previousMondayExports = previousMonday$2.exports;

var previousSaturday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = previousSaturday;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = _interopRequireDefault(previousDayExports);
	/**
	 * @name previousSaturday
	 * @category Weekday Helpers
	 * @summary When is the previous Saturday?
	 *
	 * @description
	 * When is the previous Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Saturday before Jun, 20, 2021?
	 * const result = previousSaturday(new Date(2021, 5, 20))
	 * //=> Sat June 19 2021 00:00:00
	 */
	function previousSaturday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 6);
	}
	module.exports = exports$1.default; 
} (previousSaturday$2, previousSaturday$2.exports));

var previousSaturdayExports = previousSaturday$2.exports;

var previousSunday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = previousSunday;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = _interopRequireDefault(previousDayExports);
	/**
	 * @name previousSunday
	 * @category Weekday Helpers
	 * @summary When is the previous Sunday?
	 *
	 * @description
	 * When is the previous Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Sunday before Jun, 21, 2021?
	 * const result = previousSunday(new Date(2021, 5, 21))
	 * //=> Sun June 20 2021 00:00:00
	 */
	function previousSunday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 0);
	}
	module.exports = exports$1.default; 
} (previousSunday$2, previousSunday$2.exports));

var previousSundayExports = previousSunday$2.exports;

var previousThursday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = previousThursday;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = _interopRequireDefault(previousDayExports);
	/**
	 * @name previousThursday
	 * @category Weekday Helpers
	 * @summary When is the previous Thursday?
	 *
	 * @description
	 * When is the previous Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Thursday before Jun, 18, 2021?
	 * const result = previousThursday(new Date(2021, 5, 18))
	 * //=> Thu June 17 2021 00:00:00
	 */
	function previousThursday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 4);
	}
	module.exports = exports$1.default; 
} (previousThursday$2, previousThursday$2.exports));

var previousThursdayExports = previousThursday$2.exports;

var previousTuesday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = previousTuesday;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = _interopRequireDefault(previousDayExports);
	/**
	 * @name previousTuesday
	 * @category Weekday Helpers
	 * @summary When is the previous Tuesday?
	 *
	 * @description
	 * When is the previous Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Tuesday before Jun, 18, 2021?
	 * const result = previousTuesday(new Date(2021, 5, 18))
	 * //=> Tue June 15 2021 00:00:00
	 */
	function previousTuesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 2);
	}
	module.exports = exports$1.default; 
} (previousTuesday$2, previousTuesday$2.exports));

var previousTuesdayExports = previousTuesday$2.exports;

var previousWednesday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = previousWednesday;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = _interopRequireDefault(previousDayExports);
	/**
	 * @name previousWednesday
	 * @category Weekday Helpers
	 * @summary When is the previous Wednesday?
	 *
	 * @description
	 * When is the previous Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Wednesday before Jun, 18, 2021?
	 * const result = previousWednesday(new Date(2021, 5, 18))
	 * //=> Wed June 16 2021 00:00:00
	 */
	function previousWednesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 3);
	}
	module.exports = exports$1.default; 
} (previousWednesday$2, previousWednesday$2.exports));

var previousWednesdayExports = previousWednesday$2.exports;

var quartersToMonths$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = quartersToMonths;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name quartersToMonths
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to months.
	 *
	 * @description
	 * Convert a number of quarters to a full number of months.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 quarters to months
	 * const result = quartersToMonths(2)
	 * //=> 6
	 */
	function quartersToMonths(quarters) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(quarters * _index2.monthsInQuarter);
	}
	module.exports = exports$1.default; 
} (quartersToMonths$2, quartersToMonths$2.exports));

var quartersToMonthsExports = quartersToMonths$2.exports;

var quartersToYears$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = quartersToYears;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name quartersToYears
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to years.
	 *
	 * @description
	 * Convert a number of quarters to a full number of years.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 8 quarters to years
	 * const result = quartersToYears(8)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = quartersToYears(11)
	 * //=> 2
	 */
	function quartersToYears(quarters) {
	  (0, _index.default)(1, arguments);
	  var years = quarters / _index2.quartersInYear;
	  return Math.floor(years);
	}
	module.exports = exports$1.default; 
} (quartersToYears$2, quartersToYears$2.exports));

var quartersToYearsExports = quartersToYears$2.exports;

var roundToNearestMinutes$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = roundToNearestMinutes;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = roundingMethods;
	var _index3 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name roundToNearestMinutes
	 * @category Minute Helpers
	 * @summary Rounds the given date to the nearest minute
	 *
	 * @description
	 * Rounds the given date to the nearest minute (or number of minutes).
	 * Rounds up when the given date is exactly between the nearest round minutes.
	 *
	 * @param {Date|Number} date - the date to round
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Date} the new date rounded to the closest minute
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
	 *
	 * @example
	 * // Round 10 July 2014 12:12:34 to nearest minute:
	 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
	 * //=> Thu Jul 10 2014 12:13:00
	 *
	 * @example
	 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
	 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
	 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
	 * //=> Thu Jul 10 2014 12:15:00
	 */
	function roundToNearestMinutes(dirtyDate, options) {
	  var _options$nearestTo;
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only none provided present');
	  }
	  var nearestTo = (0, _index3.default)((_options$nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options$nearestTo !== void 0 ? _options$nearestTo : 1);
	  if (nearestTo < 1 || nearestTo > 30) {
	    throw new RangeError('`options.nearestTo` must be between 1 and 30');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
	  var minutes = date.getMinutes() + seconds / 60;
	  var roundingMethod = (0, _index2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod);
	  var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
	  var remainderMinutes = minutes % nearestTo;
	  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
	}
	module.exports = exports$1.default; 
} (roundToNearestMinutes$2, roundToNearestMinutes$2.exports));

var roundToNearestMinutesExports = roundToNearestMinutes$2.exports;

var secondsToHours$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = secondsToHours;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name secondsToHours
	 * @category Conversion Helpers
	 * @summary Convert seconds to hours.
	 *
	 * @description
	 * Convert a number of seconds to a full number of hours.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200 seconds into hours
	 * const result = secondsToHours(7200)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToHours(7199)
	 * //=> 1
	 */
	function secondsToHours(seconds) {
	  (0, _index.default)(1, arguments);
	  var hours = seconds / _index2.secondsInHour;
	  return Math.floor(hours);
	}
	module.exports = exports$1.default; 
} (secondsToHours$2, secondsToHours$2.exports));

var secondsToHoursExports = secondsToHours$2.exports;

var secondsToMilliseconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = secondsToMilliseconds;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name secondsToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert seconds to milliseconds.
	 *
	 * @description
	 * Convert a number of seconds to a full number of milliseconds.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 seconds into milliseconds
	 * const result = secondsToMilliseconds(2)
	 * //=> 2000
	 */
	function secondsToMilliseconds(seconds) {
	  (0, _index.default)(1, arguments);
	  return seconds * _index2.millisecondsInSecond;
	}
	module.exports = exports$1.default; 
} (secondsToMilliseconds$2, secondsToMilliseconds$2.exports));

var secondsToMillisecondsExports = secondsToMilliseconds$2.exports;

var secondsToMinutes$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = secondsToMinutes;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name secondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert seconds to minutes.
	 *
	 * @description
	 * Convert a number of seconds to a full number of minutes.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 120 seconds into minutes
	 * const result = secondsToMinutes(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToMinutes(119)
	 * //=> 1
	 */
	function secondsToMinutes(seconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = seconds / _index2.secondsInMinute;
	  return Math.floor(minutes);
	}
	module.exports = exports$1.default; 
} (secondsToMinutes$2, secondsToMinutes$2.exports));

var secondsToMinutesExports = secondsToMinutes$2.exports;

var set$3 = {exports: {}};

var setMonth$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setMonth;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(getDaysInMonthExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * const result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth);
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	module.exports = exports$1.default; 
} (setMonth$2, setMonth$2.exports));

var setMonthExports = setMonth$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = set;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(setMonthExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name set
	 * @category Common Helpers
	 * @summary Set date values to a given date.
	 *
	 * @description
	 * Set date values to a given date.
	 *
	 * Sets time values to date from object `values`.
	 * A value is not set if it is undefined or null or doesn't exist in `values`.
	 *
	 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
	 * to use native `Date#setX` methods. If you use this function, you may not want to include the
	 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Object} values - an object with options
	 * @param {Number} [values.year] - the number of years to be set
	 * @param {Number} [values.month] - the number of months to be set
	 * @param {Number} [values.date] - the number of days to be set
	 * @param {Number} [values.hours] - the number of hours to be set
	 * @param {Number} [values.minutes] - the number of minutes to be set
	 * @param {Number} [values.seconds] - the number of seconds to be set
	 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
	 * @returns {Date} the new date with options set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `values` must be an object
	 *
	 * @example
	 * // Transform 1 September 2014 into 20 October 2015 in a single line:
	 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
	 * //=> Tue Oct 20 2015 00:00:00
	 *
	 * @example
	 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
	 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
	 * //=> Mon Sep 01 2014 12:23:45
	 */
	function set(dirtyDate, values) {
	  (0, _index4.default)(2, arguments);
	  if ((0, _typeof2.default)(values) !== 'object' || values === null) {
	    throw new RangeError('values parameter must be an object');
	  }
	  var date = (0, _index.default)(dirtyDate);

	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  if (values.year != null) {
	    date.setFullYear(values.year);
	  }
	  if (values.month != null) {
	    date = (0, _index2.default)(date, values.month);
	  }
	  if (values.date != null) {
	    date.setDate((0, _index3.default)(values.date));
	  }
	  if (values.hours != null) {
	    date.setHours((0, _index3.default)(values.hours));
	  }
	  if (values.minutes != null) {
	    date.setMinutes((0, _index3.default)(values.minutes));
	  }
	  if (values.seconds != null) {
	    date.setSeconds((0, _index3.default)(values.seconds));
	  }
	  if (values.milliseconds != null) {
	    date.setMilliseconds((0, _index3.default)(values.milliseconds));
	  }
	  return date;
	}
	module.exports = exports$1.default; 
} (set$3, set$3.exports));

var setExports = set$3.exports;

var setDate$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setDate;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setDate
	 * @category Day Helpers
	 * @summary Set the day of the month to the given date.
	 *
	 * @description
	 * Set the day of the month to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfMonth - the day of the month of the new date
	 * @returns {Date} the new date with the day of the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 30th day of the month to 1 September 2014:
	 * const result = setDate(new Date(2014, 8, 1), 30)
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function setDate(dirtyDate, dirtyDayOfMonth) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfMonth = (0, _index.default)(dirtyDayOfMonth);
	  date.setDate(dayOfMonth);
	  return date;
	}
	module.exports = exports$1.default; 
} (setDate$2, setDate$2.exports));

var setDateExports = setDate$2.exports;

var setDay$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setDay;
	var _index = _interopRequireDefault(addDaysExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var _index5 = defaultOptions$1$1;
	/**
	 * @name setDay
	 * @category Weekday Helpers
	 * @summary Set the day of the week to the given date.
	 *
	 * @description
	 * Set the day of the week to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the new date with the day of the week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
	 * const result = setDay(new Date(2014, 8, 1), 0)
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Set week day to Sunday, with a weekStartsOn of Monday:
	 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setDay(dirtyDate, dirtyDay, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(2, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var delta = 7 - weekStartsOn;
	  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
	  return (0, _index.default)(date, diff);
	}
	module.exports = exports$1.default; 
} (setDay$2, setDay$2.exports));

var setDayExports = setDay$2.exports;

var setDayOfYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setDayOfYear;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setDayOfYear
	 * @category Day Helpers
	 * @summary Set the day of the year to the given date.
	 *
	 * @description
	 * Set the day of the year to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfYear - the day of the year of the new date
	 * @returns {Date} the new date with the day of the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd day of the year to 2 July 2014:
	 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
	 * //=> Thu Jan 02 2014 00:00:00
	 */
	function setDayOfYear(dirtyDate, dirtyDayOfYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfYear = (0, _index.default)(dirtyDayOfYear);
	  date.setMonth(0);
	  date.setDate(dayOfYear);
	  return date;
	}
	module.exports = exports$1.default; 
} (setDayOfYear$2, setDayOfYear$2.exports));

var setDayOfYearExports = setDayOfYear$2.exports;

var setDefaultOptions$3 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setDefaultOptions;
	var _index = defaultOptions$1$1;
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setDefaultOptions
	 * @category Common Helpers
	 * @summary Set default options including locale.
	 * @pure false
	 *
	 * @description
	 * Sets the defaults for
	 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
	 * arguments for all functions.
	 *
	 * @param {Object} newOptions - an object with options.
	 * @param {Locale} [newOptions.locale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [newOptions.weekStartsOn] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [newOptions.firstWeekContainsDate] - the day of January, which is always in the first week of the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Set global locale:
	 * import { es } from 'date-fns/locale'
	 * setDefaultOptions({ locale: es })
	 * const result = format(new Date(2014, 8, 2), 'PPPP')
	 * //=> 'martes, 2 de septiembre de 2014'
	 *
	 * @example
	 * // Start of the week for 2 September 2014:
	 * const result = startOfWeek(new Date(2014, 8, 2))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Start of the week for 2 September 2014,
	 * // when we set that week starts on Monday by default:
	 * setDefaultOptions({ weekStartsOn: 1 })
	 * const result = startOfWeek(new Date(2014, 8, 2))
	 * //=> Mon Sep 01 2014 00:00:00
	 *
	 * @example
	 * // Manually set options take priority over default options:
	 * setDefaultOptions({ weekStartsOn: 1 })
	 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Remove the option by setting it to `undefined`:
	 * setDefaultOptions({ weekStartsOn: 1 })
	 * setDefaultOptions({ weekStartsOn: undefined })
	 * const result = startOfWeek(new Date(2014, 8, 2))
	 * //=> Sun Aug 31 2014 00:00:00
	 */
	function setDefaultOptions(newOptions) {
	  (0, _index2.default)(1, arguments);
	  var result = {};
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  for (var property in defaultOptions) {
	    if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) {
	      result[property] = defaultOptions[property];
	    }
	  }
	  for (var _property in newOptions) {
	    if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
	      if (newOptions[_property] === undefined) {
	        delete result[_property];
	      } else {
	        result[_property] = newOptions[_property];
	      }
	    }
	  }
	  (0, _index.setDefaultOptions)(result);
	}
	module.exports = exports$1.default; 
} (setDefaultOptions$3, setDefaultOptions$3.exports));

var setDefaultOptionsExports = setDefaultOptions$3.exports;

var setHours$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setHours;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	module.exports = exports$1.default; 
} (setHours$2, setHours$2.exports));

var setHoursExports = setHours$2.exports;

var setISODay$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setISODay;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(addDaysExports);
	var _index4 = _interopRequireDefault(getISODayExports);
	var _index5 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setISODay
	 * @category Weekday Helpers
	 * @summary Set the day of the ISO week to the given date.
	 *
	 * @description
	 * Set the day of the ISO week to the given date.
	 * ISO week starts with Monday.
	 * 7 is the index of Sunday, 1 is the index of Monday etc.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the ISO week of the new date
	 * @returns {Date} the new date with the day of the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * const result = setISODay(new Date(2014, 8, 1), 7)
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setISODay(dirtyDate, dirtyDay) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = (0, _index4.default)(date);
	  var diff = day - currentDay;
	  return (0, _index3.default)(date, diff);
	}
	module.exports = exports$1.default; 
} (setISODay$2, setISODay$2.exports));

var setISODayExports = setISODay$2.exports;

var setISOWeek$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setISOWeek;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(getISOWeekExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setISOWeek
	 * @category ISO Week Helpers
	 * @summary Set the ISO week to the given date.
	 *
	 * @description
	 * Set the ISO week to the given date, saving the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeek - the ISO week of the new date
	 * @returns {Date} the new date with the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 53rd ISO week to 7 August 2004:
	 * const result = setISOWeek(new Date(2004, 7, 7), 53)
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	module.exports = exports$1.default; 
} (setISOWeek$2, setISOWeek$2.exports));

var setISOWeekExports = setISOWeek$2.exports;

var setMilliseconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setMilliseconds;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setMilliseconds
	 * @category Millisecond Helpers
	 * @summary Set the milliseconds to the given date.
	 *
	 * @description
	 * Set the milliseconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} milliseconds - the milliseconds of the new date
	 * @returns {Date} the new date with the milliseconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
	 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
	 * //=> Mon Sep 01 2014 11:30:40.300
	 */
	function setMilliseconds(dirtyDate, dirtyMilliseconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var milliseconds = (0, _index.default)(dirtyMilliseconds);
	  date.setMilliseconds(milliseconds);
	  return date;
	}
	module.exports = exports$1.default; 
} (setMilliseconds$2, setMilliseconds$2.exports));

var setMillisecondsExports = setMilliseconds$2.exports;

var setMinutes$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setMinutes;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	module.exports = exports$1.default; 
} (setMinutes$2, setMinutes$2.exports));

var setMinutesExports = setMinutes$2.exports;

var setQuarter$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setQuarter;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(setMonthExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * const result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	module.exports = exports$1.default; 
} (setQuarter$2, setQuarter$2.exports));

var setQuarterExports = setQuarter$2.exports;

var setSeconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setSeconds;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	module.exports = exports$1.default; 
} (setSeconds$2, setSeconds$2.exports));

var setSecondsExports = setSeconds$2.exports;

var setWeek$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setWeek;
	var _index = _interopRequireDefault(getWeekExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var _index4 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name setWeek
	 * @category Week Helpers
	 * @summary Set the local week to the given date.
	 *
	 * @description
	 * Set the local week to the given date, saving the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} week - the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005 with default options:
	 * const result = setWeek(new Date(2005, 0, 2), 1)
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January:
	 * const result = setWeek(new Date(2005, 0, 2), 1, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sun Jan 4 2004 00:00:00
	 */
	function setWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index4.default)(dirtyWeek);
	  var diff = (0, _index.default)(date, options) - week;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	module.exports = exports$1.default; 
} (setWeek$2, setWeek$2.exports));

var setWeekExports = setWeek$2.exports;

var setWeekYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setWeekYear;
	var _index = _interopRequireDefault(differenceInCalendarDaysExports);
	var _index2 = _interopRequireDefault(startOfWeekYearExports);
	var _index3 = _interopRequireDefault(toDateExports);
	var _index4 = _interopRequireDefault(toIntegerExports);
	var _index5 = _interopRequireDefault(requiredArgsExports);
	var _index6 = defaultOptions$1$1;
	/**
	 * @name setWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Set the local week-numbering year to the given date.
	 *
	 * @description
	 * Set the local week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} weekYear - the local week-numbering year of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
	 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
	 * //=> Sat Jan 03 2004 00:00:00
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010,
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setWeekYear(dirtyDate, dirtyWeekYear, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index5.default)(2, arguments);
	  var defaultOptions = (0, _index6.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var date = (0, _index3.default)(dirtyDate);
	  var weekYear = (0, _index4.default)(dirtyWeekYear);
	  var diff = (0, _index.default)(date, (0, _index2.default)(date, options));
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  date = (0, _index2.default)(firstWeek, options);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	module.exports = exports$1.default; 
} (setWeekYear$2, setWeekYear$2.exports));

var setWeekYearExports = setWeekYear$2.exports;

var setYear$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = setYear;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * const result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear);

	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  date.setFullYear(year);
	  return date;
	}
	module.exports = exports$1.default; 
} (setYear$2, setYear$2.exports));

var setYearExports = setYear$2.exports;

var startOfDecade$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfDecade;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name startOfDecade
	 * @category Decade Helpers
	 * @summary Return the start of a decade for the given date.
	 *
	 * @description
	 * Return the start of a decade for the given date.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a decade for 21 October 2015 00:00:00:
	 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
	 * //=> Jan 01 2010 00:00:00
	 */
	function startOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfDecade$2, startOfDecade$2.exports));

var startOfDecadeExports = startOfDecade$2.exports;

var startOfToday$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfToday;
	var _index = _interopRequireDefault(startOfDayExports);
	/**
	 * @name startOfToday
	 * @category Day Helpers
	 * @summary Return the start of today.
	 * @pure false
	 *
	 * @description
	 * Return the start of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the start of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfToday()
	 * //=> Mon Oct 6 2014 00:00:00
	 */
	function startOfToday() {
	  return (0, _index.default)(Date.now());
	}
	module.exports = exports$1.default; 
} (startOfToday$2, startOfToday$2.exports));

var startOfTodayExports = startOfToday$2.exports;

var startOfTomorrow$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfTomorrow;
	/**
	 * @name startOfTomorrow
	 * @category Day Helpers
	 * @summary Return the start of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the start of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the start of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfTomorrow()
	 * //=> Tue Oct 7 2014 00:00:00
	 */
	function startOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfTomorrow$2, startOfTomorrow$2.exports));

var startOfTomorrowExports = startOfTomorrow$2.exports;

var startOfYesterday$2 = {exports: {}};

(function (module, exports$1) {

	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = startOfYesterday;
	/**
	 * @name startOfYesterday
	 * @category Day Helpers
	 * @summary Return the start of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the start of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the start of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfYesterday()
	 * //=> Sun Oct 5 2014 00:00:00
	 */
	function startOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports$1.default; 
} (startOfYesterday$2, startOfYesterday$2.exports));

var startOfYesterdayExports = startOfYesterday$2.exports;

var sub$2 = {exports: {}};

var subMonths$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subMonths;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addMonthsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * const result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subMonths$2, subMonths$2.exports));

var subMonthsExports = subMonths$2.exports;

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = sub;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(subDaysExports);
	var _index2 = _interopRequireDefault(subMonthsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	var _index4 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name sub
	 * @category Common Helpers
	 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @description
	 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
	 *
	 * | Key     | Description                        |
	 * |---------|------------------------------------|
	 * | years   | Amount of years to be subtracted   |
	 * | months  | Amount of months to be subtracted  |
	 * | weeks   | Amount of weeks to be subtracted   |
	 * | days    | Amount of days to be subtracted    |
	 * | hours   | Amount of hours to be subtracted   |
	 * | minutes | Amount of minutes to be subtracted |
	 * | seconds | Amount of seconds to be subtracted |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract the following duration from 15 June 2017 15:29:20
	 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> Mon Sep 1 2014 10:19:50
	 */
	function sub(date, duration) {
	  (0, _index3.default)(2, arguments);
	  if (!duration || (0, _typeof2.default)(duration) !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index4.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index4.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index4.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index4.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index4.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index4.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index4.default)(duration.seconds) : 0;

	  // Subtract years and months
	  var dateWithoutMonths = (0, _index2.default)(date, months + years * 12);

	  // Subtract weeks and days
	  var dateWithoutDays = (0, _index.default)(dateWithoutMonths, days + weeks * 7);

	  // Subtract hours, minutes and seconds
	  var minutestoSub = minutes + hours * 60;
	  var secondstoSub = seconds + minutestoSub * 60;
	  var mstoSub = secondstoSub * 1000;
	  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
	  return finalDate;
	}
	module.exports = exports$1.default; 
} (sub$2, sub$2.exports));

var subExports = sub$2.exports;

var subBusinessDays$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subBusinessDays;
	var _index = _interopRequireDefault(addBusinessDaysExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name subBusinessDays
	 * @category Day Helpers
	 * @summary Substract the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Substract 10 business days from 1 September 2014:
	 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
	 */
	function subBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subBusinessDays$2, subBusinessDays$2.exports));

var subBusinessDaysExports = subBusinessDays$2.exports;

var subHours$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subHours;
	var _index = _interopRequireDefault(addHoursExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subHours$2, subHours$2.exports));

var subHoursExports = subHours$2.exports;

var subMinutes$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subMinutes;
	var _index = _interopRequireDefault(addMinutesExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subMinutes$2, subMinutes$2.exports));

var subMinutesExports = subMinutes$2.exports;

var subQuarters$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subQuarters;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addQuartersExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name subQuarters
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * const result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subQuarters$2, subQuarters$2.exports));

var subQuartersExports = subQuarters$2.exports;

var subSeconds$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subSeconds;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addSecondsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name subSeconds
	 * @category Second Helpers
	 * @summary Subtract the specified number of seconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of seconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 seconds from 10 July 2014 12:45:00:
	 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:44:30
	 */
	function subSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subSeconds$2, subSeconds$2.exports));

var subSecondsExports = subSeconds$2.exports;

var subWeeks$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subWeeks;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addWeeksExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * const result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subWeeks$2, subWeeks$2.exports));

var subWeeksExports = subWeeks$2.exports;

var subYears$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = subYears;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(addYearsExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * const result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports$1.default; 
} (subYears$2, subYears$2.exports));

var subYearsExports = subYears$2.exports;

var weeksToDays$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = weeksToDays;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name weeksToDays
	 * @category Conversion Helpers
	 * @summary Convert weeks to days.
	 *
	 * @description
	 * Convert a number of weeks to a full number of days.
	 *
	 * @param {number} weeks - number of weeks to be converted
	 *
	 * @returns {number} the number of weeks converted in days
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 weeks into days
	 * const result = weeksToDays(2)
	 * //=> 14
	 */
	function weeksToDays(weeks) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(weeks * _index2.daysInWeek);
	}
	module.exports = exports$1.default; 
} (weeksToDays$2, weeksToDays$2.exports));

var weeksToDaysExports = weeksToDays$2.exports;

var yearsToMonths$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = yearsToMonths;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name yearsToMonths
	 * @category Conversion Helpers
	 * @summary Convert years to months.
	 *
	 * @description
	 * Convert a number of years to a full number of months.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years into months
	 * const result = yearsToMonths(2)
	 * //=> 24
	 */
	function yearsToMonths(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.monthsInYear);
	}
	module.exports = exports$1.default; 
} (yearsToMonths$2, yearsToMonths$2.exports));

var yearsToMonthsExports = yearsToMonths$2.exports;

var yearsToQuarters$2 = {exports: {}};

(function (module, exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	exports$1.default = yearsToQuarters;
	var _index = _interopRequireDefault(requiredArgsExports);
	var _index2 = constants$1$1;
	/**
	 * @name yearsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert years to quarters.
	 *
	 * @description
	 * Convert a number of years to a full number of quarters.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years to quarters
	 * const result = yearsToQuarters(2)
	 * //=> 8
	 */
	function yearsToQuarters(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.quartersInYear);
	}
	module.exports = exports$1.default; 
} (yearsToQuarters$2, yearsToQuarters$2.exports));

var yearsToQuartersExports = yearsToQuarters$2.exports;

(function (exports$1) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports$1, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  add: true,
	  addBusinessDays: true,
	  addDays: true,
	  addHours: true,
	  addISOWeekYears: true,
	  addMilliseconds: true,
	  addMinutes: true,
	  addMonths: true,
	  addQuarters: true,
	  addSeconds: true,
	  addWeeks: true,
	  addYears: true,
	  areIntervalsOverlapping: true,
	  clamp: true,
	  closestIndexTo: true,
	  closestTo: true,
	  compareAsc: true,
	  compareDesc: true,
	  daysToWeeks: true,
	  differenceInBusinessDays: true,
	  differenceInCalendarDays: true,
	  differenceInCalendarISOWeekYears: true,
	  differenceInCalendarISOWeeks: true,
	  differenceInCalendarMonths: true,
	  differenceInCalendarQuarters: true,
	  differenceInCalendarWeeks: true,
	  differenceInCalendarYears: true,
	  differenceInDays: true,
	  differenceInHours: true,
	  differenceInISOWeekYears: true,
	  differenceInMilliseconds: true,
	  differenceInMinutes: true,
	  differenceInMonths: true,
	  differenceInQuarters: true,
	  differenceInSeconds: true,
	  differenceInWeeks: true,
	  differenceInYears: true,
	  eachDayOfInterval: true,
	  eachHourOfInterval: true,
	  eachMinuteOfInterval: true,
	  eachMonthOfInterval: true,
	  eachQuarterOfInterval: true,
	  eachWeekOfInterval: true,
	  eachWeekendOfInterval: true,
	  eachWeekendOfMonth: true,
	  eachWeekendOfYear: true,
	  eachYearOfInterval: true,
	  endOfDay: true,
	  endOfDecade: true,
	  endOfHour: true,
	  endOfISOWeek: true,
	  endOfISOWeekYear: true,
	  endOfMinute: true,
	  endOfMonth: true,
	  endOfQuarter: true,
	  endOfSecond: true,
	  endOfToday: true,
	  endOfTomorrow: true,
	  endOfWeek: true,
	  endOfYear: true,
	  endOfYesterday: true,
	  format: true,
	  formatDistance: true,
	  formatDistanceStrict: true,
	  formatDistanceToNow: true,
	  formatDistanceToNowStrict: true,
	  formatDuration: true,
	  formatISO: true,
	  formatISO9075: true,
	  formatISODuration: true,
	  formatRFC3339: true,
	  formatRFC7231: true,
	  formatRelative: true,
	  fromUnixTime: true,
	  getDate: true,
	  getDay: true,
	  getDayOfYear: true,
	  getDaysInMonth: true,
	  getDaysInYear: true,
	  getDecade: true,
	  getDefaultOptions: true,
	  getHours: true,
	  getISODay: true,
	  getISOWeek: true,
	  getISOWeekYear: true,
	  getISOWeeksInYear: true,
	  getMilliseconds: true,
	  getMinutes: true,
	  getMonth: true,
	  getOverlappingDaysInIntervals: true,
	  getQuarter: true,
	  getSeconds: true,
	  getTime: true,
	  getUnixTime: true,
	  getWeek: true,
	  getWeekOfMonth: true,
	  getWeekYear: true,
	  getWeeksInMonth: true,
	  getYear: true,
	  hoursToMilliseconds: true,
	  hoursToMinutes: true,
	  hoursToSeconds: true,
	  intervalToDuration: true,
	  intlFormat: true,
	  intlFormatDistance: true,
	  isAfter: true,
	  isBefore: true,
	  isDate: true,
	  isEqual: true,
	  isExists: true,
	  isFirstDayOfMonth: true,
	  isFriday: true,
	  isFuture: true,
	  isLastDayOfMonth: true,
	  isLeapYear: true,
	  isMatch: true,
	  isMonday: true,
	  isPast: true,
	  isSameDay: true,
	  isSameHour: true,
	  isSameISOWeek: true,
	  isSameISOWeekYear: true,
	  isSameMinute: true,
	  isSameMonth: true,
	  isSameQuarter: true,
	  isSameSecond: true,
	  isSameWeek: true,
	  isSameYear: true,
	  isSaturday: true,
	  isSunday: true,
	  isThisHour: true,
	  isThisISOWeek: true,
	  isThisMinute: true,
	  isThisMonth: true,
	  isThisQuarter: true,
	  isThisSecond: true,
	  isThisWeek: true,
	  isThisYear: true,
	  isThursday: true,
	  isToday: true,
	  isTomorrow: true,
	  isTuesday: true,
	  isValid: true,
	  isWednesday: true,
	  isWeekend: true,
	  isWithinInterval: true,
	  isYesterday: true,
	  lastDayOfDecade: true,
	  lastDayOfISOWeek: true,
	  lastDayOfISOWeekYear: true,
	  lastDayOfMonth: true,
	  lastDayOfQuarter: true,
	  lastDayOfWeek: true,
	  lastDayOfYear: true,
	  lightFormat: true,
	  max: true,
	  milliseconds: true,
	  millisecondsToHours: true,
	  millisecondsToMinutes: true,
	  millisecondsToSeconds: true,
	  min: true,
	  minutesToHours: true,
	  minutesToMilliseconds: true,
	  minutesToSeconds: true,
	  monthsToQuarters: true,
	  monthsToYears: true,
	  nextDay: true,
	  nextFriday: true,
	  nextMonday: true,
	  nextSaturday: true,
	  nextSunday: true,
	  nextThursday: true,
	  nextTuesday: true,
	  nextWednesday: true,
	  parse: true,
	  parseISO: true,
	  parseJSON: true,
	  previousDay: true,
	  previousFriday: true,
	  previousMonday: true,
	  previousSaturday: true,
	  previousSunday: true,
	  previousThursday: true,
	  previousTuesday: true,
	  previousWednesday: true,
	  quartersToMonths: true,
	  quartersToYears: true,
	  roundToNearestMinutes: true,
	  secondsToHours: true,
	  secondsToMilliseconds: true,
	  secondsToMinutes: true,
	  set: true,
	  setDate: true,
	  setDay: true,
	  setDayOfYear: true,
	  setDefaultOptions: true,
	  setHours: true,
	  setISODay: true,
	  setISOWeek: true,
	  setISOWeekYear: true,
	  setMilliseconds: true,
	  setMinutes: true,
	  setMonth: true,
	  setQuarter: true,
	  setSeconds: true,
	  setWeek: true,
	  setWeekYear: true,
	  setYear: true,
	  startOfDay: true,
	  startOfDecade: true,
	  startOfHour: true,
	  startOfISOWeek: true,
	  startOfISOWeekYear: true,
	  startOfMinute: true,
	  startOfMonth: true,
	  startOfQuarter: true,
	  startOfSecond: true,
	  startOfToday: true,
	  startOfTomorrow: true,
	  startOfWeek: true,
	  startOfWeekYear: true,
	  startOfYear: true,
	  startOfYesterday: true,
	  sub: true,
	  subBusinessDays: true,
	  subDays: true,
	  subHours: true,
	  subISOWeekYears: true,
	  subMilliseconds: true,
	  subMinutes: true,
	  subMonths: true,
	  subQuarters: true,
	  subSeconds: true,
	  subWeeks: true,
	  subYears: true,
	  toDate: true,
	  weeksToDays: true,
	  yearsToMonths: true,
	  yearsToQuarters: true
	};
	Object.defineProperty(exports$1, "add", {
	  enumerable: true,
	  get: function get() {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports$1, "addBusinessDays", {
	  enumerable: true,
	  get: function get() {
	    return _index2.default;
	  }
	});
	Object.defineProperty(exports$1, "addDays", {
	  enumerable: true,
	  get: function get() {
	    return _index3.default;
	  }
	});
	Object.defineProperty(exports$1, "addHours", {
	  enumerable: true,
	  get: function get() {
	    return _index4.default;
	  }
	});
	Object.defineProperty(exports$1, "addISOWeekYears", {
	  enumerable: true,
	  get: function get() {
	    return _index5.default;
	  }
	});
	Object.defineProperty(exports$1, "addMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index6.default;
	  }
	});
	Object.defineProperty(exports$1, "addMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index7.default;
	  }
	});
	Object.defineProperty(exports$1, "addMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index8.default;
	  }
	});
	Object.defineProperty(exports$1, "addQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index9.default;
	  }
	});
	Object.defineProperty(exports$1, "addSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index10.default;
	  }
	});
	Object.defineProperty(exports$1, "addWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index11.default;
	  }
	});
	Object.defineProperty(exports$1, "addYears", {
	  enumerable: true,
	  get: function get() {
	    return _index12.default;
	  }
	});
	Object.defineProperty(exports$1, "areIntervalsOverlapping", {
	  enumerable: true,
	  get: function get() {
	    return _index13.default;
	  }
	});
	Object.defineProperty(exports$1, "clamp", {
	  enumerable: true,
	  get: function get() {
	    return _index14.default;
	  }
	});
	Object.defineProperty(exports$1, "closestIndexTo", {
	  enumerable: true,
	  get: function get() {
	    return _index15.default;
	  }
	});
	Object.defineProperty(exports$1, "closestTo", {
	  enumerable: true,
	  get: function get() {
	    return _index16.default;
	  }
	});
	Object.defineProperty(exports$1, "compareAsc", {
	  enumerable: true,
	  get: function get() {
	    return _index17.default;
	  }
	});
	Object.defineProperty(exports$1, "compareDesc", {
	  enumerable: true,
	  get: function get() {
	    return _index18.default;
	  }
	});
	Object.defineProperty(exports$1, "daysToWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index19.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInBusinessDays", {
	  enumerable: true,
	  get: function get() {
	    return _index20.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInCalendarDays", {
	  enumerable: true,
	  get: function get() {
	    return _index21.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInCalendarISOWeekYears", {
	  enumerable: true,
	  get: function get() {
	    return _index22.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInCalendarISOWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index23.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInCalendarMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index24.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInCalendarQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index25.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInCalendarWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index26.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInCalendarYears", {
	  enumerable: true,
	  get: function get() {
	    return _index27.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInDays", {
	  enumerable: true,
	  get: function get() {
	    return _index28.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInHours", {
	  enumerable: true,
	  get: function get() {
	    return _index29.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInISOWeekYears", {
	  enumerable: true,
	  get: function get() {
	    return _index30.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index31.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index32.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index33.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index34.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index35.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index36.default;
	  }
	});
	Object.defineProperty(exports$1, "differenceInYears", {
	  enumerable: true,
	  get: function get() {
	    return _index37.default;
	  }
	});
	Object.defineProperty(exports$1, "eachDayOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index38.default;
	  }
	});
	Object.defineProperty(exports$1, "eachHourOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index39.default;
	  }
	});
	Object.defineProperty(exports$1, "eachMinuteOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index40.default;
	  }
	});
	Object.defineProperty(exports$1, "eachMonthOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index41.default;
	  }
	});
	Object.defineProperty(exports$1, "eachQuarterOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index42.default;
	  }
	});
	Object.defineProperty(exports$1, "eachWeekOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index43.default;
	  }
	});
	Object.defineProperty(exports$1, "eachWeekendOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index44.default;
	  }
	});
	Object.defineProperty(exports$1, "eachWeekendOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index45.default;
	  }
	});
	Object.defineProperty(exports$1, "eachWeekendOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index46.default;
	  }
	});
	Object.defineProperty(exports$1, "eachYearOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index47.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfDay", {
	  enumerable: true,
	  get: function get() {
	    return _index48.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfDecade", {
	  enumerable: true,
	  get: function get() {
	    return _index49.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfHour", {
	  enumerable: true,
	  get: function get() {
	    return _index50.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index51.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index52.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfMinute", {
	  enumerable: true,
	  get: function get() {
	    return _index53.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index54.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index55.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfSecond", {
	  enumerable: true,
	  get: function get() {
	    return _index56.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfToday", {
	  enumerable: true,
	  get: function get() {
	    return _index57.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfTomorrow", {
	  enumerable: true,
	  get: function get() {
	    return _index58.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index59.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index60.default;
	  }
	});
	Object.defineProperty(exports$1, "endOfYesterday", {
	  enumerable: true,
	  get: function get() {
	    return _index61.default;
	  }
	});
	Object.defineProperty(exports$1, "format", {
	  enumerable: true,
	  get: function get() {
	    return _index62.default;
	  }
	});
	Object.defineProperty(exports$1, "formatDistance", {
	  enumerable: true,
	  get: function get() {
	    return _index63.default;
	  }
	});
	Object.defineProperty(exports$1, "formatDistanceStrict", {
	  enumerable: true,
	  get: function get() {
	    return _index64.default;
	  }
	});
	Object.defineProperty(exports$1, "formatDistanceToNow", {
	  enumerable: true,
	  get: function get() {
	    return _index65.default;
	  }
	});
	Object.defineProperty(exports$1, "formatDistanceToNowStrict", {
	  enumerable: true,
	  get: function get() {
	    return _index66.default;
	  }
	});
	Object.defineProperty(exports$1, "formatDuration", {
	  enumerable: true,
	  get: function get() {
	    return _index67.default;
	  }
	});
	Object.defineProperty(exports$1, "formatISO", {
	  enumerable: true,
	  get: function get() {
	    return _index68.default;
	  }
	});
	Object.defineProperty(exports$1, "formatISO9075", {
	  enumerable: true,
	  get: function get() {
	    return _index69.default;
	  }
	});
	Object.defineProperty(exports$1, "formatISODuration", {
	  enumerable: true,
	  get: function get() {
	    return _index70.default;
	  }
	});
	Object.defineProperty(exports$1, "formatRFC3339", {
	  enumerable: true,
	  get: function get() {
	    return _index71.default;
	  }
	});
	Object.defineProperty(exports$1, "formatRFC7231", {
	  enumerable: true,
	  get: function get() {
	    return _index72.default;
	  }
	});
	Object.defineProperty(exports$1, "formatRelative", {
	  enumerable: true,
	  get: function get() {
	    return _index73.default;
	  }
	});
	Object.defineProperty(exports$1, "fromUnixTime", {
	  enumerable: true,
	  get: function get() {
	    return _index74.default;
	  }
	});
	Object.defineProperty(exports$1, "getDate", {
	  enumerable: true,
	  get: function get() {
	    return _index75.default;
	  }
	});
	Object.defineProperty(exports$1, "getDay", {
	  enumerable: true,
	  get: function get() {
	    return _index76.default;
	  }
	});
	Object.defineProperty(exports$1, "getDayOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index77.default;
	  }
	});
	Object.defineProperty(exports$1, "getDaysInMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index78.default;
	  }
	});
	Object.defineProperty(exports$1, "getDaysInYear", {
	  enumerable: true,
	  get: function get() {
	    return _index79.default;
	  }
	});
	Object.defineProperty(exports$1, "getDecade", {
	  enumerable: true,
	  get: function get() {
	    return _index80.default;
	  }
	});
	Object.defineProperty(exports$1, "getDefaultOptions", {
	  enumerable: true,
	  get: function get() {
	    return _index81.default;
	  }
	});
	Object.defineProperty(exports$1, "getHours", {
	  enumerable: true,
	  get: function get() {
	    return _index82.default;
	  }
	});
	Object.defineProperty(exports$1, "getISODay", {
	  enumerable: true,
	  get: function get() {
	    return _index83.default;
	  }
	});
	Object.defineProperty(exports$1, "getISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index84.default;
	  }
	});
	Object.defineProperty(exports$1, "getISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index85.default;
	  }
	});
	Object.defineProperty(exports$1, "getISOWeeksInYear", {
	  enumerable: true,
	  get: function get() {
	    return _index86.default;
	  }
	});
	Object.defineProperty(exports$1, "getMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index87.default;
	  }
	});
	Object.defineProperty(exports$1, "getMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index88.default;
	  }
	});
	Object.defineProperty(exports$1, "getMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index89.default;
	  }
	});
	Object.defineProperty(exports$1, "getOverlappingDaysInIntervals", {
	  enumerable: true,
	  get: function get() {
	    return _index90.default;
	  }
	});
	Object.defineProperty(exports$1, "getQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index91.default;
	  }
	});
	Object.defineProperty(exports$1, "getSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index92.default;
	  }
	});
	Object.defineProperty(exports$1, "getTime", {
	  enumerable: true,
	  get: function get() {
	    return _index93.default;
	  }
	});
	Object.defineProperty(exports$1, "getUnixTime", {
	  enumerable: true,
	  get: function get() {
	    return _index94.default;
	  }
	});
	Object.defineProperty(exports$1, "getWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index95.default;
	  }
	});
	Object.defineProperty(exports$1, "getWeekOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index96.default;
	  }
	});
	Object.defineProperty(exports$1, "getWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index97.default;
	  }
	});
	Object.defineProperty(exports$1, "getWeeksInMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index98.default;
	  }
	});
	Object.defineProperty(exports$1, "getYear", {
	  enumerable: true,
	  get: function get() {
	    return _index99.default;
	  }
	});
	Object.defineProperty(exports$1, "hoursToMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index100.default;
	  }
	});
	Object.defineProperty(exports$1, "hoursToMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index101.default;
	  }
	});
	Object.defineProperty(exports$1, "hoursToSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index102.default;
	  }
	});
	Object.defineProperty(exports$1, "intervalToDuration", {
	  enumerable: true,
	  get: function get() {
	    return _index103.default;
	  }
	});
	Object.defineProperty(exports$1, "intlFormat", {
	  enumerable: true,
	  get: function get() {
	    return _index104.default;
	  }
	});
	Object.defineProperty(exports$1, "intlFormatDistance", {
	  enumerable: true,
	  get: function get() {
	    return _index105.default;
	  }
	});
	Object.defineProperty(exports$1, "isAfter", {
	  enumerable: true,
	  get: function get() {
	    return _index106.default;
	  }
	});
	Object.defineProperty(exports$1, "isBefore", {
	  enumerable: true,
	  get: function get() {
	    return _index107.default;
	  }
	});
	Object.defineProperty(exports$1, "isDate", {
	  enumerable: true,
	  get: function get() {
	    return _index108.default;
	  }
	});
	Object.defineProperty(exports$1, "isEqual", {
	  enumerable: true,
	  get: function get() {
	    return _index109.default;
	  }
	});
	Object.defineProperty(exports$1, "isExists", {
	  enumerable: true,
	  get: function get() {
	    return _index110.default;
	  }
	});
	Object.defineProperty(exports$1, "isFirstDayOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index111.default;
	  }
	});
	Object.defineProperty(exports$1, "isFriday", {
	  enumerable: true,
	  get: function get() {
	    return _index112.default;
	  }
	});
	Object.defineProperty(exports$1, "isFuture", {
	  enumerable: true,
	  get: function get() {
	    return _index113.default;
	  }
	});
	Object.defineProperty(exports$1, "isLastDayOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index114.default;
	  }
	});
	Object.defineProperty(exports$1, "isLeapYear", {
	  enumerable: true,
	  get: function get() {
	    return _index115.default;
	  }
	});
	Object.defineProperty(exports$1, "isMatch", {
	  enumerable: true,
	  get: function get() {
	    return _index116.default;
	  }
	});
	Object.defineProperty(exports$1, "isMonday", {
	  enumerable: true,
	  get: function get() {
	    return _index117.default;
	  }
	});
	Object.defineProperty(exports$1, "isPast", {
	  enumerable: true,
	  get: function get() {
	    return _index118.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameDay", {
	  enumerable: true,
	  get: function get() {
	    return _index119.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameHour", {
	  enumerable: true,
	  get: function get() {
	    return _index120.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index121.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index122.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameMinute", {
	  enumerable: true,
	  get: function get() {
	    return _index123.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index124.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index125.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameSecond", {
	  enumerable: true,
	  get: function get() {
	    return _index126.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index127.default;
	  }
	});
	Object.defineProperty(exports$1, "isSameYear", {
	  enumerable: true,
	  get: function get() {
	    return _index128.default;
	  }
	});
	Object.defineProperty(exports$1, "isSaturday", {
	  enumerable: true,
	  get: function get() {
	    return _index129.default;
	  }
	});
	Object.defineProperty(exports$1, "isSunday", {
	  enumerable: true,
	  get: function get() {
	    return _index130.default;
	  }
	});
	Object.defineProperty(exports$1, "isThisHour", {
	  enumerable: true,
	  get: function get() {
	    return _index131.default;
	  }
	});
	Object.defineProperty(exports$1, "isThisISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index132.default;
	  }
	});
	Object.defineProperty(exports$1, "isThisMinute", {
	  enumerable: true,
	  get: function get() {
	    return _index133.default;
	  }
	});
	Object.defineProperty(exports$1, "isThisMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index134.default;
	  }
	});
	Object.defineProperty(exports$1, "isThisQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index135.default;
	  }
	});
	Object.defineProperty(exports$1, "isThisSecond", {
	  enumerable: true,
	  get: function get() {
	    return _index136.default;
	  }
	});
	Object.defineProperty(exports$1, "isThisWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index137.default;
	  }
	});
	Object.defineProperty(exports$1, "isThisYear", {
	  enumerable: true,
	  get: function get() {
	    return _index138.default;
	  }
	});
	Object.defineProperty(exports$1, "isThursday", {
	  enumerable: true,
	  get: function get() {
	    return _index139.default;
	  }
	});
	Object.defineProperty(exports$1, "isToday", {
	  enumerable: true,
	  get: function get() {
	    return _index140.default;
	  }
	});
	Object.defineProperty(exports$1, "isTomorrow", {
	  enumerable: true,
	  get: function get() {
	    return _index141.default;
	  }
	});
	Object.defineProperty(exports$1, "isTuesday", {
	  enumerable: true,
	  get: function get() {
	    return _index142.default;
	  }
	});
	Object.defineProperty(exports$1, "isValid", {
	  enumerable: true,
	  get: function get() {
	    return _index143.default;
	  }
	});
	Object.defineProperty(exports$1, "isWednesday", {
	  enumerable: true,
	  get: function get() {
	    return _index144.default;
	  }
	});
	Object.defineProperty(exports$1, "isWeekend", {
	  enumerable: true,
	  get: function get() {
	    return _index145.default;
	  }
	});
	Object.defineProperty(exports$1, "isWithinInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index146.default;
	  }
	});
	Object.defineProperty(exports$1, "isYesterday", {
	  enumerable: true,
	  get: function get() {
	    return _index147.default;
	  }
	});
	Object.defineProperty(exports$1, "lastDayOfDecade", {
	  enumerable: true,
	  get: function get() {
	    return _index148.default;
	  }
	});
	Object.defineProperty(exports$1, "lastDayOfISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index149.default;
	  }
	});
	Object.defineProperty(exports$1, "lastDayOfISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index150.default;
	  }
	});
	Object.defineProperty(exports$1, "lastDayOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index151.default;
	  }
	});
	Object.defineProperty(exports$1, "lastDayOfQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index152.default;
	  }
	});
	Object.defineProperty(exports$1, "lastDayOfWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index153.default;
	  }
	});
	Object.defineProperty(exports$1, "lastDayOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index154.default;
	  }
	});
	Object.defineProperty(exports$1, "lightFormat", {
	  enumerable: true,
	  get: function get() {
	    return _index155.default;
	  }
	});
	Object.defineProperty(exports$1, "max", {
	  enumerable: true,
	  get: function get() {
	    return _index156.default;
	  }
	});
	Object.defineProperty(exports$1, "milliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index157.default;
	  }
	});
	Object.defineProperty(exports$1, "millisecondsToHours", {
	  enumerable: true,
	  get: function get() {
	    return _index158.default;
	  }
	});
	Object.defineProperty(exports$1, "millisecondsToMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index159.default;
	  }
	});
	Object.defineProperty(exports$1, "millisecondsToSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index160.default;
	  }
	});
	Object.defineProperty(exports$1, "min", {
	  enumerable: true,
	  get: function get() {
	    return _index161.default;
	  }
	});
	Object.defineProperty(exports$1, "minutesToHours", {
	  enumerable: true,
	  get: function get() {
	    return _index162.default;
	  }
	});
	Object.defineProperty(exports$1, "minutesToMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index163.default;
	  }
	});
	Object.defineProperty(exports$1, "minutesToSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index164.default;
	  }
	});
	Object.defineProperty(exports$1, "monthsToQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index165.default;
	  }
	});
	Object.defineProperty(exports$1, "monthsToYears", {
	  enumerable: true,
	  get: function get() {
	    return _index166.default;
	  }
	});
	Object.defineProperty(exports$1, "nextDay", {
	  enumerable: true,
	  get: function get() {
	    return _index167.default;
	  }
	});
	Object.defineProperty(exports$1, "nextFriday", {
	  enumerable: true,
	  get: function get() {
	    return _index168.default;
	  }
	});
	Object.defineProperty(exports$1, "nextMonday", {
	  enumerable: true,
	  get: function get() {
	    return _index169.default;
	  }
	});
	Object.defineProperty(exports$1, "nextSaturday", {
	  enumerable: true,
	  get: function get() {
	    return _index170.default;
	  }
	});
	Object.defineProperty(exports$1, "nextSunday", {
	  enumerable: true,
	  get: function get() {
	    return _index171.default;
	  }
	});
	Object.defineProperty(exports$1, "nextThursday", {
	  enumerable: true,
	  get: function get() {
	    return _index172.default;
	  }
	});
	Object.defineProperty(exports$1, "nextTuesday", {
	  enumerable: true,
	  get: function get() {
	    return _index173.default;
	  }
	});
	Object.defineProperty(exports$1, "nextWednesday", {
	  enumerable: true,
	  get: function get() {
	    return _index174.default;
	  }
	});
	Object.defineProperty(exports$1, "parse", {
	  enumerable: true,
	  get: function get() {
	    return _index175.default;
	  }
	});
	Object.defineProperty(exports$1, "parseISO", {
	  enumerable: true,
	  get: function get() {
	    return _index176.default;
	  }
	});
	Object.defineProperty(exports$1, "parseJSON", {
	  enumerable: true,
	  get: function get() {
	    return _index177.default;
	  }
	});
	Object.defineProperty(exports$1, "previousDay", {
	  enumerable: true,
	  get: function get() {
	    return _index178.default;
	  }
	});
	Object.defineProperty(exports$1, "previousFriday", {
	  enumerable: true,
	  get: function get() {
	    return _index179.default;
	  }
	});
	Object.defineProperty(exports$1, "previousMonday", {
	  enumerable: true,
	  get: function get() {
	    return _index180.default;
	  }
	});
	Object.defineProperty(exports$1, "previousSaturday", {
	  enumerable: true,
	  get: function get() {
	    return _index181.default;
	  }
	});
	Object.defineProperty(exports$1, "previousSunday", {
	  enumerable: true,
	  get: function get() {
	    return _index182.default;
	  }
	});
	Object.defineProperty(exports$1, "previousThursday", {
	  enumerable: true,
	  get: function get() {
	    return _index183.default;
	  }
	});
	Object.defineProperty(exports$1, "previousTuesday", {
	  enumerable: true,
	  get: function get() {
	    return _index184.default;
	  }
	});
	Object.defineProperty(exports$1, "previousWednesday", {
	  enumerable: true,
	  get: function get() {
	    return _index185.default;
	  }
	});
	Object.defineProperty(exports$1, "quartersToMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index186.default;
	  }
	});
	Object.defineProperty(exports$1, "quartersToYears", {
	  enumerable: true,
	  get: function get() {
	    return _index187.default;
	  }
	});
	Object.defineProperty(exports$1, "roundToNearestMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index188.default;
	  }
	});
	Object.defineProperty(exports$1, "secondsToHours", {
	  enumerable: true,
	  get: function get() {
	    return _index189.default;
	  }
	});
	Object.defineProperty(exports$1, "secondsToMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index190.default;
	  }
	});
	Object.defineProperty(exports$1, "secondsToMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index191.default;
	  }
	});
	Object.defineProperty(exports$1, "set", {
	  enumerable: true,
	  get: function get() {
	    return _index192.default;
	  }
	});
	Object.defineProperty(exports$1, "setDate", {
	  enumerable: true,
	  get: function get() {
	    return _index193.default;
	  }
	});
	Object.defineProperty(exports$1, "setDay", {
	  enumerable: true,
	  get: function get() {
	    return _index194.default;
	  }
	});
	Object.defineProperty(exports$1, "setDayOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index195.default;
	  }
	});
	Object.defineProperty(exports$1, "setDefaultOptions", {
	  enumerable: true,
	  get: function get() {
	    return _index196.default;
	  }
	});
	Object.defineProperty(exports$1, "setHours", {
	  enumerable: true,
	  get: function get() {
	    return _index197.default;
	  }
	});
	Object.defineProperty(exports$1, "setISODay", {
	  enumerable: true,
	  get: function get() {
	    return _index198.default;
	  }
	});
	Object.defineProperty(exports$1, "setISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index199.default;
	  }
	});
	Object.defineProperty(exports$1, "setISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index200.default;
	  }
	});
	Object.defineProperty(exports$1, "setMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index201.default;
	  }
	});
	Object.defineProperty(exports$1, "setMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index202.default;
	  }
	});
	Object.defineProperty(exports$1, "setMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index203.default;
	  }
	});
	Object.defineProperty(exports$1, "setQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index204.default;
	  }
	});
	Object.defineProperty(exports$1, "setSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index205.default;
	  }
	});
	Object.defineProperty(exports$1, "setWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index206.default;
	  }
	});
	Object.defineProperty(exports$1, "setWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index207.default;
	  }
	});
	Object.defineProperty(exports$1, "setYear", {
	  enumerable: true,
	  get: function get() {
	    return _index208.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfDay", {
	  enumerable: true,
	  get: function get() {
	    return _index209.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfDecade", {
	  enumerable: true,
	  get: function get() {
	    return _index210.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfHour", {
	  enumerable: true,
	  get: function get() {
	    return _index211.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index212.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index213.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfMinute", {
	  enumerable: true,
	  get: function get() {
	    return _index214.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index215.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index216.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfSecond", {
	  enumerable: true,
	  get: function get() {
	    return _index217.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfToday", {
	  enumerable: true,
	  get: function get() {
	    return _index218.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfTomorrow", {
	  enumerable: true,
	  get: function get() {
	    return _index219.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index220.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index221.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index222.default;
	  }
	});
	Object.defineProperty(exports$1, "startOfYesterday", {
	  enumerable: true,
	  get: function get() {
	    return _index223.default;
	  }
	});
	Object.defineProperty(exports$1, "sub", {
	  enumerable: true,
	  get: function get() {
	    return _index224.default;
	  }
	});
	Object.defineProperty(exports$1, "subBusinessDays", {
	  enumerable: true,
	  get: function get() {
	    return _index225.default;
	  }
	});
	Object.defineProperty(exports$1, "subDays", {
	  enumerable: true,
	  get: function get() {
	    return _index226.default;
	  }
	});
	Object.defineProperty(exports$1, "subHours", {
	  enumerable: true,
	  get: function get() {
	    return _index227.default;
	  }
	});
	Object.defineProperty(exports$1, "subISOWeekYears", {
	  enumerable: true,
	  get: function get() {
	    return _index228.default;
	  }
	});
	Object.defineProperty(exports$1, "subMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index229.default;
	  }
	});
	Object.defineProperty(exports$1, "subMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index230.default;
	  }
	});
	Object.defineProperty(exports$1, "subMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index231.default;
	  }
	});
	Object.defineProperty(exports$1, "subQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index232.default;
	  }
	});
	Object.defineProperty(exports$1, "subSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index233.default;
	  }
	});
	Object.defineProperty(exports$1, "subWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index234.default;
	  }
	});
	Object.defineProperty(exports$1, "subYears", {
	  enumerable: true,
	  get: function get() {
	    return _index235.default;
	  }
	});
	Object.defineProperty(exports$1, "toDate", {
	  enumerable: true,
	  get: function get() {
	    return _index236.default;
	  }
	});
	Object.defineProperty(exports$1, "weeksToDays", {
	  enumerable: true,
	  get: function get() {
	    return _index237.default;
	  }
	});
	Object.defineProperty(exports$1, "yearsToMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index238.default;
	  }
	});
	Object.defineProperty(exports$1, "yearsToQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index239.default;
	  }
	});
	var _index = _interopRequireDefault(addExports);
	var _index2 = _interopRequireDefault(addBusinessDaysExports);
	var _index3 = _interopRequireDefault(addDaysExports);
	var _index4 = _interopRequireDefault(addHoursExports);
	var _index5 = _interopRequireDefault(addISOWeekYearsExports);
	var _index6 = _interopRequireDefault(addMillisecondsExports);
	var _index7 = _interopRequireDefault(addMinutesExports);
	var _index8 = _interopRequireDefault(addMonthsExports);
	var _index9 = _interopRequireDefault(addQuartersExports);
	var _index10 = _interopRequireDefault(addSecondsExports);
	var _index11 = _interopRequireDefault(addWeeksExports);
	var _index12 = _interopRequireDefault(addYearsExports);
	var _index13 = _interopRequireDefault(areIntervalsOverlappingExports);
	var _index14 = _interopRequireDefault(clampExports);
	var _index15 = _interopRequireDefault(closestIndexToExports);
	var _index16 = _interopRequireDefault(closestToExports);
	var _index17 = _interopRequireDefault(compareAscExports);
	var _index18 = _interopRequireDefault(compareDescExports);
	var _index19 = _interopRequireDefault(daysToWeeksExports);
	var _index20 = _interopRequireDefault(differenceInBusinessDaysExports);
	var _index21 = _interopRequireDefault(differenceInCalendarDaysExports);
	var _index22 = _interopRequireDefault(differenceInCalendarISOWeekYearsExports);
	var _index23 = _interopRequireDefault(differenceInCalendarISOWeeksExports);
	var _index24 = _interopRequireDefault(differenceInCalendarMonthsExports);
	var _index25 = _interopRequireDefault(differenceInCalendarQuartersExports);
	var _index26 = _interopRequireDefault(differenceInCalendarWeeksExports);
	var _index27 = _interopRequireDefault(differenceInCalendarYearsExports);
	var _index28 = _interopRequireDefault(differenceInDaysExports);
	var _index29 = _interopRequireDefault(differenceInHoursExports);
	var _index30 = _interopRequireDefault(differenceInISOWeekYearsExports);
	var _index31 = _interopRequireDefault(differenceInMillisecondsExports);
	var _index32 = _interopRequireDefault(differenceInMinutesExports);
	var _index33 = _interopRequireDefault(differenceInMonthsExports);
	var _index34 = _interopRequireDefault(differenceInQuartersExports);
	var _index35 = _interopRequireDefault(differenceInSecondsExports);
	var _index36 = _interopRequireDefault(differenceInWeeksExports);
	var _index37 = _interopRequireDefault(differenceInYearsExports);
	var _index38 = _interopRequireDefault(eachDayOfIntervalExports);
	var _index39 = _interopRequireDefault(eachHourOfIntervalExports);
	var _index40 = _interopRequireDefault(eachMinuteOfIntervalExports);
	var _index41 = _interopRequireDefault(eachMonthOfIntervalExports);
	var _index42 = _interopRequireDefault(eachQuarterOfIntervalExports);
	var _index43 = _interopRequireDefault(eachWeekOfIntervalExports);
	var _index44 = _interopRequireDefault(eachWeekendOfIntervalExports);
	var _index45 = _interopRequireDefault(eachWeekendOfMonthExports);
	var _index46 = _interopRequireDefault(eachWeekendOfYearExports);
	var _index47 = _interopRequireDefault(eachYearOfIntervalExports);
	var _index48 = _interopRequireDefault(endOfDayExports);
	var _index49 = _interopRequireDefault(endOfDecadeExports);
	var _index50 = _interopRequireDefault(endOfHourExports);
	var _index51 = _interopRequireDefault(endOfISOWeekExports);
	var _index52 = _interopRequireDefault(endOfISOWeekYearExports);
	var _index53 = _interopRequireDefault(endOfMinuteExports);
	var _index54 = _interopRequireDefault(endOfMonthExports);
	var _index55 = _interopRequireDefault(endOfQuarterExports);
	var _index56 = _interopRequireDefault(endOfSecondExports);
	var _index57 = _interopRequireDefault(endOfTodayExports);
	var _index58 = _interopRequireDefault(endOfTomorrowExports);
	var _index59 = _interopRequireDefault(endOfWeekExports);
	var _index60 = _interopRequireDefault(endOfYearExports);
	var _index61 = _interopRequireDefault(endOfYesterdayExports);
	var _index62 = _interopRequireDefault(formatExports);
	var _index63 = _interopRequireDefault(formatDistanceExports);
	var _index64 = _interopRequireDefault(formatDistanceStrictExports);
	var _index65 = _interopRequireDefault(formatDistanceToNowExports);
	var _index66 = _interopRequireDefault(formatDistanceToNowStrictExports);
	var _index67 = _interopRequireDefault(formatDurationExports);
	var _index68 = _interopRequireDefault(formatISOExports);
	var _index69 = _interopRequireDefault(formatISO9075Exports);
	var _index70 = _interopRequireDefault(formatISODurationExports);
	var _index71 = _interopRequireDefault(formatRFC3339Exports);
	var _index72 = _interopRequireDefault(formatRFC7231Exports);
	var _index73 = _interopRequireDefault(formatRelativeExports);
	var _index74 = _interopRequireDefault(fromUnixTimeExports);
	var _index75 = _interopRequireDefault(getDateExports);
	var _index76 = _interopRequireDefault(getDayExports);
	var _index77 = _interopRequireDefault(getDayOfYearExports);
	var _index78 = _interopRequireDefault(getDaysInMonthExports);
	var _index79 = _interopRequireDefault(getDaysInYearExports);
	var _index80 = _interopRequireDefault(getDecadeExports);
	var _index81 = _interopRequireDefault(getDefaultOptionsExports);
	var _index82 = _interopRequireDefault(getHoursExports);
	var _index83 = _interopRequireDefault(getISODayExports);
	var _index84 = _interopRequireDefault(getISOWeekExports);
	var _index85 = _interopRequireDefault(getISOWeekYearExports);
	var _index86 = _interopRequireDefault(getISOWeeksInYearExports);
	var _index87 = _interopRequireDefault(getMillisecondsExports);
	var _index88 = _interopRequireDefault(getMinutesExports);
	var _index89 = _interopRequireDefault(getMonthExports);
	var _index90 = _interopRequireDefault(getOverlappingDaysInIntervalsExports);
	var _index91 = _interopRequireDefault(getQuarterExports);
	var _index92 = _interopRequireDefault(getSecondsExports);
	var _index93 = _interopRequireDefault(getTimeExports);
	var _index94 = _interopRequireDefault(getUnixTimeExports);
	var _index95 = _interopRequireDefault(getWeekExports);
	var _index96 = _interopRequireDefault(getWeekOfMonthExports);
	var _index97 = _interopRequireDefault(getWeekYearExports);
	var _index98 = _interopRequireDefault(getWeeksInMonthExports);
	var _index99 = _interopRequireDefault(getYearExports);
	var _index100 = _interopRequireDefault(hoursToMillisecondsExports);
	var _index101 = _interopRequireDefault(hoursToMinutesExports);
	var _index102 = _interopRequireDefault(hoursToSecondsExports);
	var _index103 = _interopRequireDefault(intervalToDurationExports);
	var _index104 = _interopRequireDefault(intlFormatExports);
	var _index105 = _interopRequireDefault(intlFormatDistanceExports);
	var _index106 = _interopRequireDefault(isAfterExports);
	var _index107 = _interopRequireDefault(isBeforeExports);
	var _index108 = _interopRequireDefault(isDateExports);
	var _index109 = _interopRequireDefault(isEqualExports);
	var _index110 = _interopRequireDefault(isExistsExports);
	var _index111 = _interopRequireDefault(isFirstDayOfMonthExports);
	var _index112 = _interopRequireDefault(isFridayExports);
	var _index113 = _interopRequireDefault(isFutureExports);
	var _index114 = _interopRequireDefault(isLastDayOfMonthExports);
	var _index115 = _interopRequireDefault(isLeapYearExports);
	var _index116 = _interopRequireDefault(isMatchExports);
	var _index117 = _interopRequireDefault(isMondayExports);
	var _index118 = _interopRequireDefault(isPastExports);
	var _index119 = _interopRequireDefault(isSameDayExports);
	var _index120 = _interopRequireDefault(isSameHourExports);
	var _index121 = _interopRequireDefault(isSameISOWeekExports);
	var _index122 = _interopRequireDefault(isSameISOWeekYearExports);
	var _index123 = _interopRequireDefault(isSameMinuteExports);
	var _index124 = _interopRequireDefault(isSameMonthExports);
	var _index125 = _interopRequireDefault(isSameQuarterExports);
	var _index126 = _interopRequireDefault(isSameSecondExports);
	var _index127 = _interopRequireDefault(isSameWeekExports);
	var _index128 = _interopRequireDefault(isSameYearExports);
	var _index129 = _interopRequireDefault(isSaturdayExports);
	var _index130 = _interopRequireDefault(isSundayExports);
	var _index131 = _interopRequireDefault(isThisHourExports);
	var _index132 = _interopRequireDefault(isThisISOWeekExports);
	var _index133 = _interopRequireDefault(isThisMinuteExports);
	var _index134 = _interopRequireDefault(isThisMonthExports);
	var _index135 = _interopRequireDefault(isThisQuarterExports);
	var _index136 = _interopRequireDefault(isThisSecondExports);
	var _index137 = _interopRequireDefault(isThisWeekExports);
	var _index138 = _interopRequireDefault(isThisYearExports);
	var _index139 = _interopRequireDefault(isThursdayExports);
	var _index140 = _interopRequireDefault(isTodayExports);
	var _index141 = _interopRequireDefault(isTomorrowExports);
	var _index142 = _interopRequireDefault(isTuesdayExports);
	var _index143 = _interopRequireDefault(isValidExports);
	var _index144 = _interopRequireDefault(isWednesdayExports);
	var _index145 = _interopRequireDefault(isWeekendExports);
	var _index146 = _interopRequireDefault(isWithinIntervalExports);
	var _index147 = _interopRequireDefault(isYesterdayExports);
	var _index148 = _interopRequireDefault(lastDayOfDecadeExports);
	var _index149 = _interopRequireDefault(lastDayOfISOWeekExports);
	var _index150 = _interopRequireDefault(lastDayOfISOWeekYearExports);
	var _index151 = _interopRequireDefault(lastDayOfMonthExports);
	var _index152 = _interopRequireDefault(lastDayOfQuarterExports);
	var _index153 = _interopRequireDefault(lastDayOfWeekExports);
	var _index154 = _interopRequireDefault(lastDayOfYearExports);
	var _index155 = _interopRequireDefault(lightFormatExports);
	var _index156 = _interopRequireDefault(maxExports);
	var _index157 = _interopRequireDefault(millisecondsExports);
	var _index158 = _interopRequireDefault(millisecondsToHoursExports);
	var _index159 = _interopRequireDefault(millisecondsToMinutesExports);
	var _index160 = _interopRequireDefault(millisecondsToSecondsExports);
	var _index161 = _interopRequireDefault(minExports);
	var _index162 = _interopRequireDefault(minutesToHoursExports);
	var _index163 = _interopRequireDefault(minutesToMillisecondsExports);
	var _index164 = _interopRequireDefault(minutesToSecondsExports);
	var _index165 = _interopRequireDefault(monthsToQuartersExports);
	var _index166 = _interopRequireDefault(monthsToYearsExports);
	var _index167 = _interopRequireDefault(nextDayExports);
	var _index168 = _interopRequireDefault(nextFridayExports);
	var _index169 = _interopRequireDefault(nextMondayExports);
	var _index170 = _interopRequireDefault(nextSaturdayExports);
	var _index171 = _interopRequireDefault(nextSundayExports);
	var _index172 = _interopRequireDefault(nextThursdayExports);
	var _index173 = _interopRequireDefault(nextTuesdayExports);
	var _index174 = _interopRequireDefault(nextWednesdayExports);
	var _index175 = _interopRequireDefault(parseExports);
	var _index176 = _interopRequireDefault(parseISOExports);
	var _index177 = _interopRequireDefault(parseJSONExports);
	var _index178 = _interopRequireDefault(previousDayExports);
	var _index179 = _interopRequireDefault(previousFridayExports);
	var _index180 = _interopRequireDefault(previousMondayExports);
	var _index181 = _interopRequireDefault(previousSaturdayExports);
	var _index182 = _interopRequireDefault(previousSundayExports);
	var _index183 = _interopRequireDefault(previousThursdayExports);
	var _index184 = _interopRequireDefault(previousTuesdayExports);
	var _index185 = _interopRequireDefault(previousWednesdayExports);
	var _index186 = _interopRequireDefault(quartersToMonthsExports);
	var _index187 = _interopRequireDefault(quartersToYearsExports);
	var _index188 = _interopRequireDefault(roundToNearestMinutesExports);
	var _index189 = _interopRequireDefault(secondsToHoursExports);
	var _index190 = _interopRequireDefault(secondsToMillisecondsExports);
	var _index191 = _interopRequireDefault(secondsToMinutesExports);
	var _index192 = _interopRequireDefault(setExports);
	var _index193 = _interopRequireDefault(setDateExports);
	var _index194 = _interopRequireDefault(setDayExports);
	var _index195 = _interopRequireDefault(setDayOfYearExports);
	var _index196 = _interopRequireDefault(setDefaultOptionsExports);
	var _index197 = _interopRequireDefault(setHoursExports);
	var _index198 = _interopRequireDefault(setISODayExports);
	var _index199 = _interopRequireDefault(setISOWeekExports);
	var _index200 = _interopRequireDefault(setISOWeekYearExports);
	var _index201 = _interopRequireDefault(setMillisecondsExports);
	var _index202 = _interopRequireDefault(setMinutesExports);
	var _index203 = _interopRequireDefault(setMonthExports);
	var _index204 = _interopRequireDefault(setQuarterExports);
	var _index205 = _interopRequireDefault(setSecondsExports);
	var _index206 = _interopRequireDefault(setWeekExports);
	var _index207 = _interopRequireDefault(setWeekYearExports);
	var _index208 = _interopRequireDefault(setYearExports);
	var _index209 = _interopRequireDefault(startOfDayExports);
	var _index210 = _interopRequireDefault(startOfDecadeExports);
	var _index211 = _interopRequireDefault(startOfHourExports);
	var _index212 = _interopRequireDefault(startOfISOWeekExports);
	var _index213 = _interopRequireDefault(startOfISOWeekYearExports);
	var _index214 = _interopRequireDefault(startOfMinuteExports);
	var _index215 = _interopRequireDefault(startOfMonthExports);
	var _index216 = _interopRequireDefault(startOfQuarterExports);
	var _index217 = _interopRequireDefault(startOfSecondExports);
	var _index218 = _interopRequireDefault(startOfTodayExports);
	var _index219 = _interopRequireDefault(startOfTomorrowExports);
	var _index220 = _interopRequireDefault(startOfWeekExports);
	var _index221 = _interopRequireDefault(startOfWeekYearExports);
	var _index222 = _interopRequireDefault(startOfYearExports);
	var _index223 = _interopRequireDefault(startOfYesterdayExports);
	var _index224 = _interopRequireDefault(subExports);
	var _index225 = _interopRequireDefault(subBusinessDaysExports);
	var _index226 = _interopRequireDefault(subDaysExports);
	var _index227 = _interopRequireDefault(subHoursExports);
	var _index228 = _interopRequireDefault(subISOWeekYearsExports);
	var _index229 = _interopRequireDefault(subMillisecondsExports);
	var _index230 = _interopRequireDefault(subMinutesExports);
	var _index231 = _interopRequireDefault(subMonthsExports);
	var _index232 = _interopRequireDefault(subQuartersExports);
	var _index233 = _interopRequireDefault(subSecondsExports);
	var _index234 = _interopRequireDefault(subWeeksExports);
	var _index235 = _interopRequireDefault(subYearsExports);
	var _index236 = _interopRequireDefault(toDateExports);
	var _index237 = _interopRequireDefault(weeksToDaysExports);
	var _index238 = _interopRequireDefault(yearsToMonthsExports);
	var _index239 = _interopRequireDefault(yearsToQuartersExports);
	var _index240 = constants$1$1;
	Object.keys(_index240).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports$1 && exports$1[key] === _index240[key]) return;
	  Object.defineProperty(exports$1, key, {
	    enumerable: true,
	    get: function get() {
	      return _index240[key];
	    }
	  });
	}); 
} (dateFns$1));

var ListDelimiter;
(function (ListDelimiter) {
    ListDelimiter[ListDelimiter["or"] = 0] = "or";
    ListDelimiter[ListDelimiter["and"] = 1] = "and";
})(ListDelimiter || (ListDelimiter = {}));
/**
 * Based on the provided slot value, it will return the appropriate <say-as> tag.
 *
 * {@link https://cloud.google.com/text-to-speech/docs/ssml#say%E2%80%91as}
 * {@link https://developer.amazon.com/en-US/docs/alexa/custom-skills/speech-synthesis-markup-language-ssml-reference.html#say-as}
 * {@link https://docs.aws.amazon.com/polly/latest/dg/supportedtags.html#say-as-tag}
 *
 * @param value
 * @returns
 */
function slotValueToSpeech(value, type) {
    if (type === void 0) { type = "ssml"; }
    var speech;
    switch (typeof value) {
        case "string":
            speech = value;
            break;
        case "number":
            speech = "".concat(value);
            break;
        // let it remain undefined
    }
    if (isDateTime(value)) {
        speech = dateTimeToSpeech(value, type);
    }
    if (isDateTimeRange(value)) {
        speech = dateTimeRangeToSpeech(value, type);
    }
    if (isDuration(value)) {
        speech = durationToSpeech(value, type);
    }
    if (Array.isArray(value)) {
        // We have an array, listisize
        // Not sure how we let them decide if it is an AND or and OR situation
        // Right now we are using AND
        speech = listisize(value, ListDelimiter.and);
    }
    return speech;
}
/**
 * Determine if the request slot value is a DateTime
 *
 * @public
 * @param slotValue - Slot value to check
 */
function isDateTime(slotValue) {
    return !!slotValue && (!!slotValue.date || !!slotValue.time);
}
/**
 * Determine if the request slot value is a DateTimeRange
 *
 * @public
 * @param slotValue - Slot value to check
 */
function isDateTimeRange(slotValue) {
    return !!slotValue && (!!slotValue.start || !!slotValue.end);
}
/**
 * Determine if the request slot value is a Duration
 *
 * @public
 * @param slotValue - Slot value to check
 */
function isDuration(slotValue) {
    return !!slotValue && typeof slotValue === "object" && typeof slotValue.amount === "number" && typeof slotValue.format === "string";
}
/**
 * Converts a date time object to a string that can be used in either SSML or display text.
 *
 * @privateRemarks
 * We will want to consider how we tackle localization of dates.  date-fns
 * can handle it we just need to pass in the locale.  Additionally, when generating
 * a response for display, we may want to support a short and long form.
 *
 * @beta
 * @param value
 * @param type
 */
function dateTimeToSpeech(value, type) {
    if (type === void 0) { type = "ssml"; }
    if (!value) {
        return "";
    }
    // If it is a time only, we need to just add the 
    // current date for parsing.  It won't be spoken 
    // back to the user, just for parsing.
    var toParse = __assign$1({}, value);
    if (!toParse.date) {
        toParse.date = ("yyyy-MM-dd");
    }
    var date = Date.parse(dateTimeToString(toParse));
    var speech = "";
    if (value.date) {
        if (type === "ssml") {
            speech += "<say-as interpret-as=\"date\" format=\"ymd\">".concat(dateFns$1.format(date, "yyyy-MM-dd"), "</say-as>");
        }
        else {
            speech += "".concat(dateFns$1.format(date, "M-d-yyyy"));
        }
    }
    if (value.time) {
        if (type === "ssml") {
            speech += "<say-as interpret-as=\"time\">".concat(dateFns$1.format(date, "h:mm aa"), "</say-as>");
        }
        else {
            if (speech.length > 0) {
                speech += " ";
            }
            speech += "".concat(dateFns$1.format(date, "h:mm aa"));
        }
    }
    return speech;
}
function dateTimeRangeToSpeech(value, type) {
    if (type === void 0) { type = "ssml"; }
    if (!value) {
        return "";
    }
    var start = value.start;
    var end = value.end;
    var refDate = new Date();
    // The default value
    var speech = "".concat(dateTimeToSpeech(start, type), " to ").concat(dateTimeToSpeech(end, type));
    // We want to shorten this down if we can before
    // defaulting to {startDate} to {endDate}, which 
    // can be verbose.  
    //
    // Case 1: If it is the same date, just communicate the time difference
    // "on {date} from {time} to {time}"
    if (dateFns$1.isSameDay(dateFns$1.parse(start.date, "y-M-d", refDate), dateFns$1.parse(end.date, "y-M-d", refDate))) {
        speech = "on ".concat(dateTimeToSpeech({ date: start.date }, type), " from ").concat(dateTimeToSpeech({ time: start.time }, type), " to ").concat(dateTimeToSpeech({ time: end.time }, type));
    }
    return speech;
}
function durationToSpeech(duration, type) {
    if (type === void 0) { type = "ssml"; }
    if (!duration) {
        return "";
    }
    var plural = duration.amount > 1;
    var amount = type === "ssml" ? "<say-as interpret-as=\"cardinal\">".concat(duration.amount, "</say-as>") : duration.amount;
    // We need to get the singular, long form version of the format.
    var multiplier = DURATION_FORMAT_TO_MS_MULTIPLIER[duration.format];
    var rawFormat = duration.format;
    // Now find the one the doesn't end in "s" and the length is greater than 1
    Object.keys(DURATION_FORMAT_TO_MS_MULTIPLIER).forEach(function (key) {
        if (DURATION_FORMAT_TO_MS_MULTIPLIER[key] === multiplier) {
            if (key.length > rawFormat.length && !key.endsWith("s")) {
                rawFormat = key;
            }
        }
    });
    var format = plural ? "".concat(rawFormat, "s") : rawFormat;
    return "".concat(amount, " ").concat(format);
}
/**
 * Converts a date time object to a string.
 *
 * Either a single date (2020-07-19T23:59:59) or a range (2019-07-19T00:00:00 --> 2020-07-19T23:59:59).
 *
 * @param dateTime - Either DateTime or DateTimeRange to convert to a string
 */
function dateTimeToString(dateTime) {
    if (typeof dateTime !== "object") {
        return "";
    }
    var str = "";
    try {
        if (isDateTime(dateTime)) {
            var date = dateTime.date ? dateFns$1.format(dateFns$1.parse(dateTime.date, "y-M-d", new Date()), "yyyy-MM-dd") : undefined;
            var time = dateTime.time;
            str = "".concat(date ? date : "").concat(date && time ? "T" : "").concat(time ? time : "");
        }
        else {
            var start = dateTime.start;
            var end = dateTime.end;
            if (start) {
                var date = start.date ? dateFns$1.format(dateFns$1.parse(start.date, "y-M-d", new Date()), "yyyy-MM-dd") : undefined;
                var time = start.time;
                str = "".concat(date ? date : "").concat(date && time ? "T" : "").concat(time ? time : "");
            }
            if (start && end) {
                str += " --> ";
            }
            if (end) {
                var date = end.date ? dateFns$1.format(dateFns$1.parse(end.date, "y-M-d", new Date()), "yyyy-MM-dd") : undefined;
                var time = end.time;
                str += "".concat(date ? date : "").concat(date && time ? "T" : "").concat(time ? time : "");
            }
        }
    }
    catch (e) {
        console.error(e);
    }
    return str;
}
/**
 * Lookup table to convert a duration format to a multiplier that will convert it to milliseconds
 */
var DURATION_FORMAT_TO_MS_MULTIPLIER = {
    // smallest, just multiple by 1
    ms: 1,
    millisecond: 1,
    milliseconds: 1,
    s: 1000,
    second: 1000,
    seconds: 1000,
    m: 60000,
    minute: 60000,
    minutes: 60000,
    h: 3.6e+6,
    hour: 3.6e+6,
    hours: 3.6e+6,
    d: 8.64e+7,
    day: 8.64e+7,
    days: 8.64e+7,
    w: 6.048e+8,
    week: 6.048e+8,
    weeks: 6.048e+8,
    M: 2.628e+9,
    month: 2.628e+9,
    months: 2.628e+9,
    // Quarters are tricky, going to assume 90 days
    Q: 7.776e+9,
    quarter: 7.776e+9,
    quarters: 7.776e+9,
    // Largest
    y: 3.154e+10,
    years: 3.154e+10,
    year: 3.154e+10
    // Room to add on more such as decade or century
};
/**
 * Builds a speakable and readable list from a set of items.
 *
 * For example, ["one", "two", "three", "four"] will be transformed
 * to "one, two, three or four".
 *
 * @param {string[]} items
 * @param {ListisizeDelimiter} [delimiter]
 */
//eslint-disable-next-line
//@ts-ignore
function listisize(items, preferredDelimiter) {
    if (preferredDelimiter === void 0) { preferredDelimiter = ListDelimiter.or; }
    var delimiter = ListDelimiter[preferredDelimiter];
    if (!items || items.length === 0) {
        return "";
    }
    else if (items.length === 1) {
        return items[0];
    }
    else if (items.length >= 2) {
        var secondToLast_1 = items.length - 2;
        return items.reduce(function (current, item, currentIndex) {
            current += item;
            if (currentIndex < secondToLast_1) {
                current += ", ";
            }
            else if (currentIndex === secondToLast_1) {
                current += " ".concat(delimiter, " ");
            }
            return current;
        }, "");
    }
}

var TEMPLATE_REGEX = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
/* private */
function compileString(value, slots, key, replaceWhenUndefined) {
    var compiledValue = value;
    var result;
    var reg = new RegExp(TEMPLATE_REGEX);
    // Set exit condition to be when the results are null
    while ((result = reg.exec(value)) !== null) {
        // index 1 is the capture
        // trim it so we can support ${ name }
        var captured = result[1].trim();
        var speakableSlotValue = void 0;
        // Find the slot
        var slot = slots[captured];
        // Based on the type, replace it in the string
        if (slot) {
            speakableSlotValue = slotValueToSpeech(slot.value, key);
        }
        // if it exists OR replaceWhenUndefined
        if (speakableSlotValue || replaceWhenUndefined) {
            // replace it
            compiledValue = compiledValue.replace(result[0], speakableSlotValue);
        }
    }
    return compiledValue;
}
/**
 * Compiles a templated response with slot values from the
 * provided slot map.
 *
 * For example, when passed "What date do you want your ${flowers}?"
 * and the slot map contains a slot with name `flowers` it will replace
 * it with the value.
 *
 * It will handle the different potential value types for slots such as
 * strings, numbers, dates and durations.
 *
 * By default, if the slot value does not exist, the template value is left untouched.
 *
 * @param responseOutput
 * @param slots
 * @param replaceWhenUndefined - When set to true, it will replace the value with 'undefined' if it doesn't exist, default behavior is to leave the template as is.
 */
function compileSlotValues(responseOutput, slots, replaceWhenUndefined) {
    if (!responseOutput || !slots) {
        return responseOutput;
    }
    var compiledValue = responseOutput;
    if (typeof compiledValue === "string") {
        // Default it to displayText because it is the safest and works 
        // in both cases.
        compiledValue = compileString(compiledValue, slots, "displayText", replaceWhenUndefined);
    }
    else {
        // Response is { ssml, displayText }
        var value_1 = compiledValue; // This reassignment is only to make TS happy
        // Make some type safe keys
        var keys = ["ssml", "displayText"];
        // Iterate through the keys
        keys.forEach(function (key) {
            if (value_1[key]) {
                value_1[key] = compileString(value_1[key], slots, key, replaceWhenUndefined);
            }
        });
    }
    return compiledValue;
}

var FailureMessage = function (props) {
    var agents = props.agents, text = props.text, delay = props.delay, time = props.time;
    var _a = require$$1.useState(delay), countdown = _a[0], setCountdown = _a[1];
    var agent_names = Object.values(agents).filter(function (agent) { return agent.requestFailed; });
    require$$1.useEffect(function () {
        if (delay !== 0) {
            var countdownValue_1 = delay;
            var myInterval_1 = setInterval(function () {
                countdownValue_1--;
                setCountdown(countdownValue_1);
                if (countdownValue_1 === 0) {
                    clearInterval(myInterval_1);
                }
            }, 1000);
        }
        else {
            setCountdown(5);
        }
    }, [delay]);
    var slots = require$$1.useMemo(function () {
        return {
            sec: {
                name: "sec",
                value: countdown,
            },
        };
    }, [countdown]);
    var failureMessage = require$$1.useMemo(function () {
        return compileSlotValues(text, slots);
    }, [text, slots]);
    if (countdown === 0) {
        return require$$0.jsx(require$$0.Fragment, {});
    }
    return (require$$0.jsx(require$$0.Fragment, { children: agent_names.map(function (agent) {
            var _a, _b;
            return (require$$0.jsx("div", { className: "chat-msg-container-wrapper", children: require$$0.jsx("div", { className: "chat-msg-container agent", children: require$$0.jsx(ChatMessagePart, { user: agent === null || agent === void 0 ? void 0 : agent.user, showAvatar: true, children: require$$0.jsx("div", { className: "chat-msg", children: require$$0.jsxs(ChatMessageBubble, { owner: "others", hasTail: true, children: [require$$0.jsx("span", { className: "message-sr-only", children: "at " + time + " the bot said" }), require$$0.jsx("span", { children: typeof failureMessage === "object"
                                            ? failureMessage.displayText
                                            : failureMessage })] }) }) }) }, (_a = agent === null || agent === void 0 ? void 0 : agent.user) === null || _a === void 0 ? void 0 : _a.nick) }, "failure-msg-".concat((_b = agent === null || agent === void 0 ? void 0 : agent.user) === null || _b === void 0 ? void 0 : _b.nick)));
        }) }));
};

var MessageSvg = function (_) {
    return (require$$0.jsx("svg", { className: "message-svg", width: "16", height: "12", viewBox: "0 0 16 12", children: require$$0.jsx("path", { d: "M14.4 0H1.6C.72 0 .008.675.008 1.5L0 10.5c0 .825.72 1.5 1.6 1.5h12.8c.88 0 1.6-.675 1.6-1.5v-9c0-.825-.72-1.5-1.6-1.5zm0 3L8 6.75 1.6 3V1.5L8 5.25l6.4-3.75V3z", fill: "#424242", fillRule: "evenodd" }) }));
};

var MessageForm = function (props) {
    var name = require$$1.useRef(null);
    var email = require$$1.useRef(null);
    var message = require$$1.useRef(null);
    var form = require$$1.useRef(null);
    var _a = require$$1.useState(false), sent = _a[0], setSent = _a[1];
    function emailChanged() {
        var _a, _b, _c;
        if ((_a = email.current) === null || _a === void 0 ? void 0 : _a.validity.patternMismatch) {
            (_b = email.current) === null || _b === void 0 ? void 0 : _b.setCustomValidity("This doesn't look like an email!");
        }
        else {
            (_c = email.current) === null || _c === void 0 ? void 0 : _c.setCustomValidity("");
        }
    }
    function send(event) {
        var _a, _b, _c, _d, _e;
        event.preventDefault();
        if (!((_a = form.current) === null || _a === void 0 ? void 0 : _a.checkValidity())) {
            (_b = form.current) === null || _b === void 0 ? void 0 : _b.reportValidity();
            return;
        }
        props.onSubmit({
            name: (_c = name.current) === null || _c === void 0 ? void 0 : _c.value,
            email: (_d = email.current) === null || _d === void 0 ? void 0 : _d.value,
            message: (_e = message.current) === null || _e === void 0 ? void 0 : _e.value,
        });
        setSent(true);
    }
    function sendAnother() {
        setSent(false);
    }
    function renderSent() {
        return (require$$0.jsxs("div", { className: "message-form--sent", children: ["Your message has been sent. We will get back to you as soon as possible.", require$$0.jsx(ActionButton, { addClass: "button-resend", label: "Send another", onClick: sendAnother })] }, "sent"));
    }
    function renderForm() {
        return (require$$0.jsxs("form", { ref: form, className: "message-form", onSubmit: send, children: [require$$0.jsxs("div", { className: "content", children: [require$$0.jsxs("div", { className: "section", children: [require$$0.jsx("label", { className: "label", children: "Name" }), require$$0.jsx("input", { ref: name, maxLength: 255 })] }), require$$0.jsxs("div", { className: "section", children: [require$$0.jsx("label", { className: "label", children: "Email" }), require$$0.jsx("input", { ref: email, onChange: emailChanged, type: "email", required: true, pattern: EMAIL_REGEX })] }), require$$0.jsxs("div", { className: "section", children: [require$$0.jsx("label", { className: "label", children: "Message" }), require$$0.jsx("textarea", { required: true, ref: message })] })] }), require$$0.jsx("div", { className: "button-container", children: require$$0.jsx(ActionButton, { type: "submit", addClass: "message-form__submit", label: "Send" }) })] }, "not-sent"));
    }
    return (require$$0.jsx(CardContainer, { title: props.title, addClass: "offline-card", contentAddClass: sent ? "sent" : "", icon: require$$0.jsx(MessageSvg, {}), children: sent ? renderSent() : renderForm() }));
};

var OfflineForm = function (props) {
    return require$$0.jsx(MessageForm, { title: "Offline message card title", onSubmit: props.onSubmit });
};

var OfflineFormContainer = function (props) {
    var dispatch = useChatServerDispatch();
    var handleSubmit = require$$1.useCallback(function (data) {
        dispatch(sendOfflineMsg(data));
    }, [dispatch]);
    return (require$$0.jsxs(require$$0.Fragment, { children: [require$$0.jsx("span", { className: "message-sr-only", children: "at " + props.time + " system message" }), require$$0.jsx(OfflineForm, { onSubmit: handleSubmit })] }));
};

var PrechatForm = function (props) {
    var _a = require$$1.useState(false), sent = _a[0], setSent = _a[1];
    var onSubmit = props.onSubmit;
    var handleSubmit = require$$1.useCallback(function (msg) {
        onSubmit(msg);
        setSent(true);
    }, [onSubmit]);
    return require$$0.jsx(require$$0.Fragment, { children: !sent && require$$0.jsx(MessageForm, { title: "Introduce yourself!", onSubmit: handleSubmit }) });
};

var PrechatFormContainer = function (props) {
    var dispatch = useChatServerDispatch();
    var sessionId = reactRedux.useSelector(function (state) { return state.sessionId; });
    var handleSubmit = require$$1.useCallback(function (data) {
        // Don't send empty messages
        if (!data.message)
            return;
        dispatch(sendVisitorInfo({
            displayName: data.name,
            email: data.email,
        }, sessionId));
        dispatch(executeAction(data.message));
    }, [dispatch, sessionId]);
    return (require$$0.jsxs(require$$0.Fragment, { children: [require$$0.jsx("span", { className: "message-sr-only", children: "at " + props.time + " system message" }), require$$0.jsx(PrechatForm, { onSubmit: handleSubmit })] }));
};

var QueuePosition = function (_a) {
    var _b = _a.position, position = _b === void 0 ? 0 : _b;
    if (position <= 0)
        return null;
    return (require$$0.jsx("div", { className: "system-msg-container", children: require$$0.jsxs("span", { className: "system-msg", children: ["Queue position: ", position] }) }));
};

function isServerUser(user) {
    var _a;
    return (_a = user.nick) === null || _a === void 0 ? void 0 : _a.endsWith(ROUTER_USER);
}
function shouldShowDivider(message) {
    return (message.type === "chat.memberjoin" && message.showDivider) ||
        (message.type === "chat.memberleave" && message.showDivider);
}
function getMessageByType(msg) {
    switch (msg.type) {
        case "chat.memberjoin":
            // Use custom message if provided, otherwise use default
            return msg.message || "".concat(msg.user.displayName || "Bot", " has joined the chat");
        case "chat.memberleave":
            // Use custom message if provided, otherwise use default
            return msg.message || "".concat(msg.user.displayName || "Bot", " has left the chat");
        case "chat.systemmessage":
            return msg.message;
        case "chat.rating":
            if (!msg.newRating) {
                return "You have removed the chat rating";
            }
            else {
                var rating = convertToSentenceCase(msg.newRating);
                return "You have rated the chat service ".concat(rating);
            }
        default:
            return JSON.stringify(msg);
    }
}
var SystemMessage = function (props) {
    var _a;
    if (!isServerUser(props.message.user)) {
        var message = props.message;
        var showDivider = shouldShowDivider(message);
        var avatarUrl = (_a = message.user) === null || _a === void 0 ? void 0 : _a.avatarPath;
        return (require$$0.jsxs("div", { className: "system-msg-container", children: [showDivider && avatarUrl && (require$$0.jsxs("div", { className: "system-msg-divider", children: [require$$0.jsx("div", { className: "divider-line" }), require$$0.jsx("div", { className: "divider-avatar", children: require$$0.jsx("img", { src: avatarUrl, alt: "".concat(message.user.displayName || "User", "'s avatar") }) }), require$$0.jsx("div", { className: "divider-line" })] })), require$$0.jsx("span", { className: "message-sr-only", children: "at " + props.time + " system message" }), require$$0.jsx("span", { className: "system-msg", children: getMessageByType(props.message) })] }));
    }
    else {
        return null;
    }
};
function convertToSentenceCase(s) {
    return s[0].toUpperCase() + s.slice(1);
}

var TypingIndicator = function (_) {
    return (require$$0.jsxs("div", { className: "typing-indicator", children: [require$$0.jsx("div", { className: "typing-indicator-part" }), require$$0.jsx("div", { className: "typing-indicator-part" }), require$$0.jsx("div", { className: "typing-indicator-part" })] }));
};

/**
 * Show the agent is typing (or the bot - for fun)
 */
var TypingStatus = function (props) {
    var agentsTyping = Object.values(props.agents).filter(function (agent) { return agent.typing; });
    return (require$$0.jsx(require$$0.Fragment, { children: agentsTyping.map(function (agent, index) {
            var _a, _b;
            var key = ((_a = agent.user) === null || _a === void 0 ? void 0 : _a.nick) || "".concat(index);
            var displayName = ((_b = agent.user) === null || _b === void 0 ? void 0 : _b.displayName) || "Somebody";
            return (require$$0.jsx("span", { children: !props.textTypingStatusEnabled ? (require$$0.jsx("div", { className: "chat-msg-container-wrapper", children: require$$0.jsx("div", { className: "chat-msg-container agent chat-typing-progress", children: require$$0.jsx(ChatMessagePart, { user: agent.user, showAvatar: true, children: require$$0.jsx("div", { className: "chat-msg", children: require$$0.jsx(ChatMessageBubble, { owner: "others", hasTail: true, children: require$$0.jsx(TypingIndicator, {}) }) }) }) }, key) }, "typing-status-".concat(key))) : (require$$0.jsxs("div", { className: "chat-msg-agent-typing", children: [displayName, " is typing"] }, "typing-status-".concat(key))) }, "typing-status-".concat(index)));
        }) }));
};

var MessageList = function (_a) {
    _a.visible; var _c = _a.messages, messages = _c === void 0 ? [] : _c, _d = _a.agents, agents = _d === void 0 ? {} : _d; _a.isOffline; _a.isChatting; var _g = _a.queuePosition, queuePosition = _g === void 0 ? 0 : _g, _h = _a.lastRatingRequestTimestamp, lastRatingRequestTimestamp = _h === void 0 ? 0 : _h, _j = _a.hasRating, hasRating = _j === void 0 ? false : _j; _a.visitorId; var messageMiddleware = _a.messageMiddleware, textTypingStatusEnabled = _a.textTypingStatusEnabled, agent = _a.agent, hasWsButton = _a.hasWsButton, _l = _a.disableAutoScroll, disableAutoScroll = _l === void 0 ? false : _l, _m = _a.onSend, onSend = _m === void 0 ? function () { return Promise.resolve(); } : _m, _o = _a.onWrite, onWrite = _o === void 0 ? function () { return Promise.resolve(); } : _o, _p = _a.onOpenUrl, onOpenUrl = _p === void 0 ? function () { } : _p, _q = _a.minimizeOnClick, minimizeOnClick = _q === void 0 ? function () { } : _q; _a.children;
    var messagesEndRef = require$$1.useRef(null);
    var containerRef = require$$1.useRef(null);
    var prevHasWsButtonRef = require$$1.useRef(hasWsButton);
    // Check if user is scrolled to bottom
    var isAtBottom = require$$1.useCallback(function () {
        if (!containerRef.current)
            return true;
        var _a = containerRef.current, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        return Math.abs(scrollHeight - clientHeight - scrollTop) < 10;
    }, []);
    // Scroll to bottom
    var scrollToBottom = require$$1.useCallback(function (behavior) {
        if (behavior === void 0) { behavior = "smooth"; }
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: behavior });
        }
    }, []);
    // Always scroll to bottom when messages change (unless disabled)
    require$$1.useEffect(function () {
        if (!disableAutoScroll) {
            scrollToBottom("smooth");
        }
    }, [messages, agents, scrollToBottom, disableAutoScroll]);
    // Handle WS button dismissal - only scroll when button is removed (unless disabled)
    require$$1.useEffect(function () {
        if (disableAutoScroll) {
            return undefined;
        }
        var prevHasButton = prevHasWsButtonRef.current;
        var currentHasButton = hasWsButton;
        // Update ref for next render
        prevHasWsButtonRef.current = currentHasButton;
        // Only handle button dismissal (was true, now false)
        if (prevHasButton && !currentHasButton) {
            var wasAtBottom = isAtBottom();
            if (wasAtBottom) {
                // Delay scroll adjustment to after button animation completes (animation + small buffer)
                var timer_1 = setTimeout(function () {
                    scrollToBottom("smooth");
                }, WS_BUTTON_DISMISS_ANIMATION_DURATION + 50);
                return function () { return clearTimeout(timer_1); };
            }
        }
        return undefined;
    }, [hasWsButton, isAtBottom, scrollToBottom, disableAutoScroll]);
    var handleSend = require$$1.useCallback(function (msg) {
        onSend(msg);
        if (!disableAutoScroll && messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [onSend, disableAutoScroll]);
    var handleWrite = require$$1.useCallback(function (msg) {
        onWrite(msg);
        if (!disableAutoScroll && messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [onWrite, disableAutoScroll]);
    var ctxCache = require$$1.useMemo(function () {
        return new MiddlewareContextFactory({
            send: handleSend,
            write: handleWrite,
            openUrl: onOpenUrl,
        });
    }, [handleSend, handleWrite, onOpenUrl]);
    var date = new Date();
    var time = date.getHours() + ":" + date.getMinutes();
    /**
     * Render the message based on widget state or message type. offline and pre chat are pseudo messages.
     *
     * @param msg
     * @param addClass
     */
    function renderByType(msg, sibling) {
        var _a, _b, _c;
        var user;
        // visitor is this widget
        if ((_b = (_a = msg.user) === null || _a === void 0 ? void 0 : _a.nick) === null || _b === void 0 ? void 0 : _b.startsWith("visitor:")) {
            user = msg.user;
        }
        else {
            user = ((_c = agents[msg.user.nick]) === null || _c === void 0 ? void 0 : _c.user) || agent;
            // Still nothing?
            if (!user) {
                log$3("Could not get a user from agents list with nick: \"".concat(msg.user.nick, "\""));
                user = msg.user;
            }
        }
        switch (msg.type) {
            case "chat.file":
            case "chat.msg":
                return (require$$0.jsx(ChatMessage, { message: msg, sibling: sibling, agent: user, messageMiddleware: messageMiddleware, middlewareContext: ctxCache.resolve(user), minimizeOnClick: minimizeOnClick }, "cm-".concat(msg.type, "-").concat(msg.timestamp)));
            case "chat.failureMsg":
                return (require$$0.jsx(FailureMessage, __assign$1({ agents: agents, time: time }, msg.failureMsg), "fm-".concat(msg.type, "-").concat(msg.timestamp)));
            case "chat.memberjoin":
            case "chat.memberleave":
            case "chat.systemmessage":
            case "chat.rating":
            case "chat.typing":
                return (require$$0.jsx(SystemMessage, { time: time, message: msg }, "sm-".concat(msg.type, "-").concat(msg.timestamp)));
            case "chat.request.rating":
                return (require$$0.jsx(ChatRatingContainer, { agent: user, hasRating: hasRating, time: time, shouldDisplay: msg.timestamp === lastRatingRequestTimestamp }, "cr-".concat(msg.type, "-").concat(msg.timestamp)));
            case "chat.offline":
                return require$$0.jsx(OfflineFormContainer, { time: time }, "offline-".concat(msg.timestamp));
            case "chat.prechat":
                return require$$0.jsx(PrechatFormContainer, { time: time }, "prechat");
            default:
                return (require$$0.jsxs("span", { children: [require$$0.jsx("span", { className: "message-sr-only", children: "at " + time + " system message" }), require$$0.jsxs("div", { children: ["Unhandled message: ", JSON.stringify(msg)] }, "uhm-".concat(+new Date()))] }, "default-".concat(msg.timestamp)));
        }
    }
    /**
     * Render all messages
     *
     */
    function renderAll() {
        var lastMsgIndex = -1;
        for (var i = messages.length - 1; i > 0; i--) {
            if (messages[i].type === "chat.msg") {
                lastMsgIndex = i;
                break;
            }
        }
        return messages.map(function (message, index) {
            // const next = messages[index + 1];
            var _a, _b;
            // let sibling = false;
            // const currentNick = message.nick;
            // const prevNick = next && next.nick;
            // Same agent says more
            // if (next && next.type === message.type && currentNick && currentNick === prevNick) {
            //   sibling = true;
            // }
            // Message types that will show time
            var tsTypes = [
                "chat.file",
                "chat.msg",
                // "chat.failureMsg",
                "chat.memberjoin",
                "chat.memberleave",
                // "chat.systemmessage", // System messages don't show timestamps
                "chat.rating",
                // "chat.typing",
                "chat.request.rating",
                "chat.offline",
                "chat.prechat",
            ];
            // show first and las TS and after at least 5 minutes gap. Don't show "router user"
            var showTs = false;
            if (tsTypes.includes(message.type) && !((_b = (_a = message.user) === null || _a === void 0 ? void 0 : _a.nick) === null || _b === void 0 ? void 0 : _b.endsWith(ROUTER_USER))) {
                if (index === 0 || index === messages.length - 1 || index === lastMsgIndex) {
                    showTs = true;
                }
                else {
                    var previous = messages[index - 1];
                    if (message.timestamp && previous.timestamp) {
                        showTs = message.timestamp - previous.timestamp > 300 * 1000; // 5 minutes
                    }
                }
            }
            // we also don't showTs if it is the very first message in the list & it is a chat.memberjoin
            if (index === 0 && message.type === "chat.memberjoin") {
                showTs = false;
            }
            var ts = showTs ? new Date(message.timestamp).toLocaleString() : undefined;
            return (require$$0.jsxs("span", { children: [showTs && (require$$0.jsx("div", { className: "ts-msg-container", children: require$$0.jsx("span", { className: "ts-msg", children: ts }) })), renderByType(message, false)] }, "message-list-render-all-".concat(index)));
        });
    }
    return (require$$0.jsxs("div", { className: "message-list-container", ref: containerRef, children: [require$$0.jsxs("div", { className: "message-list-container__msgs", children: [renderAll(), require$$0.jsx("div", { ref: messagesEndRef, style: { float: "left", clear: "both" } }), require$$0.jsx(QueuePosition, { position: queuePosition }), require$$0.jsx(TypingStatus, { agents: agents, textTypingStatusEnabled: textTypingStatusEnabled })] }), require$$0.jsx(ChatChipsContainer, {})] }));
};

var ServerOffline = function () {
    return (require$$0.jsxs("div", { className: "server-offline", children: [require$$0.jsx("h2", { children: "Chat is currently unavailable" }), require$$0.jsx("h3", { children: "Server is offline" })] }));
};

function buildStyleContent(theme) {
    var _a, _b, _c, _d, _e;
    return "\n:root {\n".concat(buildVariables(withPrefix("\t--xapp-", union$2(single("primary-color", theme === null || theme === void 0 ? void 0 : theme.primaryColor), withPrefix("widget-", union$2(getSize(theme === null || theme === void 0 ? void 0 : theme.size), getMargins(theme === null || theme === void 0 ? void 0 : theme.margin), getBorderStyle(theme === null || theme === void 0 ? void 0 : theme.border), getZIndex(theme === null || theme === void 0 ? void 0 : theme.zIndex))), getChatButtonStyle(theme === null || theme === void 0 ? void 0 : theme.chatButton), withPrefix("header-", getHeaderStyle(theme === null || theme === void 0 ? void 0 : theme.header)), withPrefix("footer-", getFooterStyle(theme === null || theme === void 0 ? void 0 : theme.footer)), withPrefix("content-", union$2(getBackgroundStyle((_a = theme === null || theme === void 0 ? void 0 : theme.content) === null || _a === void 0 ? void 0 : _a.background))), withPrefix("messages-", getMessagesStyle(theme === null || theme === void 0 ? void 0 : theme.messages)), withPrefix("text-typing-status-", getTextStyle((_b = theme === null || theme === void 0 ? void 0 : theme.textTypingStatus) === null || _b === void 0 ? void 0 : _b.text)), withPrefix("send-", getButtonStyle(theme === null || theme === void 0 ? void 0 : theme.sendButton)), withPrefix("menu-", getButtonStyle(theme === null || theme === void 0 ? void 0 : theme.menuButton)), withPrefix("menu-", getMenuStyle(theme === null || theme === void 0 ? void 0 : theme.menu)), withPrefix("refresh-", getButtonStyle(theme === null || theme === void 0 ? void 0 : theme.refreshButton)), withPrefix("minimize-", getButtonStyle(theme === null || theme === void 0 ? void 0 : theme.minimizeButton)), withPrefix("cancel-", getButtonStyle(theme === null || theme === void 0 ? void 0 : theme.cancelButton)), withPrefix("carousel-", union$2(withPrefix("title-", getTextStyle((_c = theme === null || theme === void 0 ? void 0 : theme.carousel) === null || _c === void 0 ? void 0 : _c.title)), withPrefix("subtitle-", getTextStyle((_d = theme === null || theme === void 0 ? void 0 : theme.carousel) === null || _d === void 0 ? void 0 : _d.subtitle)), withPrefix("action-", getButtonStyle((_e = theme === null || theme === void 0 ? void 0 : theme.carousel) === null || _e === void 0 ? void 0 : _e.button)))), withPrefix("input-", getInputStyle(theme === null || theme === void 0 ? void 0 : theme.input)), withPrefix("cta-", getCtaStyle(theme === null || theme === void 0 ? void 0 : theme.cta)), withPrefix("action-bar-", getActionBarStyle(theme === null || theme === void 0 ? void 0 : theme.actionBar))))), "\n}");
}
function WidgetStylesheet(props) {
    var theme = props.theme;
    var stylesContent = buildStyleContent(theme);
    return require$$0.jsx("style", { children: stylesContent });
}
function buildVariables(gen) {
    var result = gen.next();
    var res = "";
    while (result.done === false) {
        var _a = result.value, key = _a[0], value = _a[1];
        if (value !== undefined && value !== null && value !== "") {
            res += "".concat(key, ": ").concat(value, ";\n\r");
        }
        result = gen.next();
    }
    return res;
}
function withPrefix(prefix, gen) {
    var result;
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0:
                result = gen.next();
                _a.label = 1;
            case 1:
                if (!!result.done) return [3 /*break*/, 3];
                return [4 /*yield*/, ["".concat(prefix).concat(result.value[0]), result.value[1]]];
            case 2:
                _a.sent();
                result = gen.next();
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
function union$2() {
    var _i, _a, children_1, child, result;
    var children = [];
    for (_i = 0; _i < arguments.length; _i++) {
        children[_i] = arguments[_i];
    }
    return __generator$1(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = 0, children_1 = children;
                _b.label = 1;
            case 1:
                if (!(_a < children_1.length)) return [3 /*break*/, 5];
                child = children_1[_a];
                result = child.next();
                _b.label = 2;
            case 2:
                if (!(result.done === false)) return [3 /*break*/, 4];
                return [4 /*yield*/, result.value];
            case 3:
                _b.sent();
                result = child.next();
                return [3 /*break*/, 2];
            case 4:
                _a++;
                return [3 /*break*/, 1];
            case 5: return [2 /*return*/];
        }
    });
}
function single(key, value) {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, [key, value]];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function empty$3() { return __generator$1(this, function (_a) {
    return [2 /*return*/];
}); }
function getChatButtonStyle(style) {
    if (!style) {
        return empty$3();
    }
    return withPrefix("chat-button-", union$2(getMargins(style.margin), getBackgroundStyle(style.background), withPrefix("image-", getSize(style.imageSize)), getAnimationStyle(style.animation)));
}
function getMessagesStyle(style) {
    if (!style) {
        return empty$3();
    }
    return union$2(withPrefix("mine-", getMessageStyle(style.mine)), withPrefix("others-", getMessageStyle(style.others)), getPaddings(style === null || style === void 0 ? void 0 : style.padding), single("max-width", style === null || style === void 0 ? void 0 : style.maxWidth));
}
function getMessageStyle(style) {
    return union$2(single("bubble-color", style === null || style === void 0 ? void 0 : style.bubbleColor), getTextStyle(style === null || style === void 0 ? void 0 : style.text));
}
function getSize(style) {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ["width", style === null || style === void 0 ? void 0 : style.width]];
            case 1:
                _a.sent();
                return [4 /*yield*/, ["height", style === null || style === void 0 ? void 0 : style.height]];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getAnimationStyle(style) {
    var primaryColor, secondaryColor, opacity, intenseBackground, lessIntenseBackground;
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!style) {
                    return [2 /*return*/];
                }
                primaryColor = style.primaryColor || "0, 117, 170";
                secondaryColor = style.secondaryColor || "110, 178, 209";
                opacity = style.opacity || 0.75;
                // Generate CSS variables that can be used by any animation type
                return [4 /*yield*/, ["animation-primary-color", "".concat(primaryColor)]];
            case 1:
                // Generate CSS variables that can be used by any animation type
                _a.sent();
                return [4 /*yield*/, ["animation-secondary-color", "".concat(secondaryColor)]];
            case 2:
                _a.sent();
                return [4 /*yield*/, ["animation-opacity", "".concat(opacity)]];
            case 3:
                _a.sent();
                // Generate colors for box-shadow halo effects
                return [4 /*yield*/, ["animation-primary-rgba", "rgba(".concat(primaryColor, ", ").concat(opacity, ")")]];
            case 4:
                // Generate colors for box-shadow halo effects
                _a.sent();
                return [4 /*yield*/, ["animation-secondary-rgba", "rgba(".concat(secondaryColor, ", ").concat(opacity, ")")]];
            case 5:
                _a.sent();
                intenseBackground = "radial-gradient(40.83% 40.83% at 47.92% 52.5%, rgba(".concat(primaryColor, ", ").concat(opacity, ") 78.85%, rgba(").concat(secondaryColor, ", ").concat(opacity, ") 92.07%)");
                lessIntenseBackground = "radial-gradient(40.83% 40.83% at 47.92% 52.5%, rgba(".concat(primaryColor, ", ").concat(opacity, ") 20.46%, rgba(").concat(secondaryColor, ", ").concat(opacity, ") 92.07%)");
                return [4 /*yield*/, ["animation-pulse-intense", intenseBackground]];
            case 6:
                _a.sent();
                return [4 /*yield*/, ["animation-pulse-less-intense", lessIntenseBackground]];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getZIndex(style) {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!style) return [3 /*break*/, 2];
                return [4 /*yield*/, ["z-index", style]];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}
function getMargins(style) {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!style) return [3 /*break*/, 5];
                return [4 /*yield*/, ["margin-top", style.top]];
            case 1:
                _a.sent();
                return [4 /*yield*/, ["margin-right", style.right]];
            case 2:
                _a.sent();
                return [4 /*yield*/, ["margin-bottom", style.bottom]];
            case 3:
                _a.sent();
                return [4 /*yield*/, ["margin-left", style.left]];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
function getPaddings(style) {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!style) return [3 /*break*/, 5];
                return [4 /*yield*/, ["padding-top", style.top]];
            case 1:
                _a.sent();
                return [4 /*yield*/, ["padding-right", style.right]];
            case 2:
                _a.sent();
                return [4 /*yield*/, ["padding-bottom", style.bottom]];
            case 3:
                _a.sent();
                return [4 /*yield*/, ["padding-left", style.left]];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
function getTextStyle(style) {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!style) return [3 /*break*/, 6];
                return [4 /*yield*/, ["text-color", style.color]];
            case 1:
                _a.sent();
                return [4 /*yield*/, ["font-size", style.fontSize]];
            case 2:
                _a.sent();
                return [4 /*yield*/, ["font-family", style.fontFamily]];
            case 3:
                _a.sent();
                return [4 /*yield*/, ["font-weight", style.fontWeight]];
            case 4:
                _a.sent();
                return [4 /*yield*/, ["font-style", style.fontStyle]];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
function getBackgroundStyle(style) {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ["background", style]];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getButtonStyle(style) {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ["button-color", style === null || style === void 0 ? void 0 : style.color]];
            case 1:
                _a.sent();
                return [4 /*yield*/, ["button-width", style === null || style === void 0 ? void 0 : style.width]];
            case 2:
                _a.sent();
                return [4 /*yield*/, ["button-bg", style === null || style === void 0 ? void 0 : style.background]];
            case 3:
                _a.sent();
                return [4 /*yield*/, ["button-hover-bg", style === null || style === void 0 ? void 0 : style.hoverBackground]];
            case 4:
                _a.sent();
                return [4 /*yield*/, ["button-disabled-bg", style === null || style === void 0 ? void 0 : style.disabledBackground]];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getMenuItemStyle(style) {
    return union$2(getTextStyle(style === null || style === void 0 ? void 0 : style.text), withPrefix("subtitle-", getTextStyle(style === null || style === void 0 ? void 0 : style.subtitle)), getBorderStyle(style === null || style === void 0 ? void 0 : style.border), getBackgroundStyle(style === null || style === void 0 ? void 0 : style.background), single("height", style === null || style === void 0 ? void 0 : style.height));
}
function getMenuStyle(style) {
    return union$2(withPrefix("item-", getMenuItemStyle(style === null || style === void 0 ? void 0 : style.item)));
}
function getBorderStyle(style) {
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!style) return [3 /*break*/, 4];
                return [4 /*yield*/, ["border-color", style.color]];
            case 1:
                _a.sent();
                return [4 /*yield*/, ["border-width", style.width]];
            case 2:
                _a.sent();
                return [4 /*yield*/, ["border-radius", style.radius]];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}
function getHeaderStyle(style) {
    if (!style) {
        return empty$3();
    }
    return union$2(getBackgroundStyle(style.background), getTextStyle(style.text), withPrefix("subtitle-", getTextStyle(style.subtitle)), getBorderStyle(style.border), getPaddings(style.padding), single("avatar-background", style.avatarBackground));
}
function getFooterStyle(style) {
    var _a;
    if (!style) {
        return empty$3();
    }
    return union$2(getBackgroundStyle(style.background), getBorderStyle(style.border), withPrefix("branding-", getTextStyle((_a = style.branding) === null || _a === void 0 ? void 0 : _a.text)));
}
function getInputStyle(style) {
    if (!style) {
        return empty$3();
    }
    return union$2(getBackgroundStyle(style.background), getBorderStyle(style.border), getTextStyle(style.text), withPrefix("placeholder-", getTextStyle(style.placeholder)));
}
function getCtaStyle(style) {
    if (!style) {
        return empty$3();
    }
    return union$2(getBackgroundStyle(style.background), getTextStyle(style.text));
}
function getActionBarStyle(style) {
    if (!style) {
        return empty$3();
    }
    return union$2(getBackgroundStyle(style.background), getBorderStyle(style.border), getPaddings(style.padding), getMargins(style.margin), single("box-shadow", style.boxShadow), single("border-radius", style.borderRadius), withPrefix("button-", getActionBarButtonStyle(style.button)));
}
function getActionBarButtonStyle(style) {
    if (!style) {
        return empty$3();
    }
    return union$2(getBackgroundStyle(style.background), single("hover-background", style.hoverBackground), withPrefix("icon-", getSize(style.iconSize)), single("icon-color", style.iconColor), withPrefix("label-", getTextStyle(style.label)), single("gap", style.gap), single("border-radius", style.borderRadius), getPaddings(style.padding));
}

/**
 * Safely stringify objects, handling circular references and errors
 */
var safeStringify = function (arg) {
    if (arg === null)
        return "null";
    if (arg === undefined)
        return "undefined";
    if (typeof arg !== "object")
        return String(arg);
    try {
        var seen_1 = new WeakSet();
        return JSON.stringify(arg, function (_key, value) {
            if (typeof value === "object" && value !== null) {
                if (seen_1.has(value)) {
                    return "[Circular]";
                }
                seen_1.add(value);
            }
            return value;
        }, 2);
    }
    catch (e) {
        return "[Object: ".concat(Object.prototype.toString.call(arg), "]");
    }
};
var ErrorOverlay = function (_a) {
    var enableErrorOverlay = _a.enableErrorOverlay;
    var _b = require$$1.useState([]), errors = _b[0], setErrors = _b[1];
    var _c = require$$1.useState(false), isMinimized = _c[0], setIsMinimized = _c[1];
    var _d = require$$1.useState(true), isVisible = _d[0], setIsVisible = _d[1];
    var _e = require$$1.useState(false), isEnabled = _e[0], setIsEnabled = _e[1];
    var _f = require$$1.useState("bottom"), position = _f[0], setPosition = _f[1];
    // Check if error overlay should be enabled and load position
    require$$1.useEffect(function () {
        var _a;
        var checkEnabled = function () {
            var _a;
            if (typeof window === "undefined")
                return false;
            // 1. Check localStorage (highest priority)
            var localStorageSetting = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem("xaErrorOverlay");
            if (localStorageSetting === "enabled") {
                console.log("[ErrorOverlay] Enabled via localStorage");
                return true;
            }
            if (localStorageSetting === "disabled") {
                console.log("[ErrorOverlay] Disabled via localStorage");
                return false;
            }
            // 2. Check widget configuration
            if (enableErrorOverlay !== undefined) {
                console.log("[ErrorOverlay] Using config setting:", enableErrorOverlay);
                return enableErrorOverlay;
            }
            // 3. Check for React Native dev mode
            if (typeof globalThis.__DEV__ !== "undefined" && globalThis.__DEV__) {
                console.log("[ErrorOverlay] Enabled via __DEV__");
                return true;
            }
            // 4. Default: disabled
            return false;
        };
        var enabled = checkEnabled();
        setIsEnabled(enabled);
        // Load position preference
        var savedPosition = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem("xaErrorOverlayPosition");
        if (savedPosition === "top" || savedPosition === "bottom") {
            setPosition(savedPosition);
        }
        console.log("[ErrorOverlay] Component mounted, enabled:", enabled, "position:", savedPosition || "bottom");
    }, [enableErrorOverlay]);
    // Define addError with useCallback to prevent stale closures
    var addError = require$$1.useCallback(function (error) {
        console.log("[ErrorOverlay] Adding error:", error);
        setErrors(function (prev) {
            var timestamp = new Date().toISOString();
            // Check if this is a duplicate of the last error
            var lastError = prev[prev.length - 1];
            if (lastError && lastError.message === error.message) {
                // Update count of last error
                return __spreadArray$1(__spreadArray$1([], prev.slice(0, -1), true), [
                    __assign$1(__assign$1({}, lastError), { count: lastError.count + 1, timestamp: timestamp }),
                ], false);
            }
            // Add new error
            var newError = __assign$1({ id: "".concat(timestamp, "-").concat(Math.random()), timestamp: timestamp, count: 1 }, error);
            // Keep only last 50 errors
            var updated = __spreadArray$1(__spreadArray$1([], prev, true), [newError], false);
            return updated.slice(-50);
        });
    }, []);
    require$$1.useEffect(function () {
        if (!isEnabled) {
            console.log("[ErrorOverlay] Not enabled, skipping error interception");
            return undefined;
        }
        console.log("[ErrorOverlay] Setting up error interception");
        // Store original console methods
        var originalError = console.error;
        var originalWarn = console.warn;
        // Override console.error
        console.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var message = args.map(function (arg) { return safeStringify(arg); }).join(" ");
            var error = new Error();
            addError({
                message: message,
                type: "error",
                stack: error.stack,
            });
            // Call original method
            originalError.apply(console, args);
        };
        // Override console.warn
        console.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var message = args.map(function (arg) { return safeStringify(arg); }).join(" ");
            addError({
                message: message,
                type: "warning",
            });
            // Call original method
            originalWarn.apply(console, args);
        };
        // Capture unhandled errors
        var handleError = function (event) {
            var _a;
            addError({
                message: event.message,
                type: "error",
                stack: (_a = event.error) === null || _a === void 0 ? void 0 : _a.stack,
            });
        };
        // Capture unhandled promise rejections
        var handleRejection = function (event) {
            var _a;
            addError({
                message: "Unhandled Promise Rejection: ".concat(event.reason),
                type: "error",
                stack: (_a = event.reason) === null || _a === void 0 ? void 0 : _a.stack,
            });
        };
        window.addEventListener("error", handleError);
        window.addEventListener("unhandledrejection", handleRejection);
        // Cleanup
        return function () {
            console.log("[ErrorOverlay] Cleaning up error interception");
            console.error = originalError;
            console.warn = originalWarn;
            window.removeEventListener("error", handleError);
            window.removeEventListener("unhandledrejection", handleRejection);
        };
    }, [isEnabled, addError]);
    var clearErrors = function () {
        setErrors([]);
    };
    var copyToClipboard = function () { return __awaiter$1(void 0, void 0, void 0, function () {
        var errorText, err_1, textarea;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    errorText = errors
                        .map(function (e) {
                        return "[".concat(e.timestamp, "] ").concat(e.type.toUpperCase(), ": ").concat(e.message).concat(e.stack ? "\n" + e.stack : "");
                    })
                        .join("\n\n");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(errorText)];
                case 2:
                    _a.sent();
                    console.log("[ErrorOverlay] Errors copied to clipboard");
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.error("[ErrorOverlay] Failed to copy to clipboard:", err_1);
                    textarea = document.createElement("textarea");
                    textarea.value = errorText;
                    textarea.style.position = "fixed";
                    textarea.style.opacity = "0";
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                        document.execCommand("copy");
                        console.log("[ErrorOverlay] Errors copied to clipboard using fallback method");
                    }
                    catch (fallbackErr) {
                        console.error("[ErrorOverlay] Fallback copy method also failed:", fallbackErr);
                    }
                    document.body.removeChild(textarea);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    // Toggle enabled state
    var toggleEnabled = function () {
        var newState = !isEnabled;
        setIsEnabled(newState);
        if (typeof window !== "undefined" && window.localStorage) {
            window.localStorage.setItem("xaErrorOverlay", newState ? "enabled" : "disabled");
        }
        console.log("[ErrorOverlay] Toggled enabled state to:", newState);
        // Clear errors when disabling
        if (!newState) {
            setErrors([]);
        }
    };
    // Toggle position between top and bottom
    var togglePosition = function () {
        var newPosition = position === "bottom" ? "top" : "bottom";
        setPosition(newPosition);
        if (typeof window !== "undefined" && window.localStorage) {
            window.localStorage.setItem("xaErrorOverlayPosition", newPosition);
        }
    };
    // Don't render anything if not enabled
    if (!isEnabled) {
        return null;
    }
    // If enabled but not visible (user closed it), don't render
    if (!isVisible) {
        return null;
    }
    // If enabled and visible but no errors yet, don't show the overlay
    // Only show when there are actual errors to display
    if (errors.length === 0) {
        return null;
    }
    return (require$$0.jsxs("div", { className: "error-overlay error-overlay--".concat(position, " ").concat(isMinimized ? "minimized" : ""), children: [require$$0.jsxs("div", { className: "error-overlay-header", children: [require$$0.jsxs("span", { className: "error-overlay-title", children: ["Debug Console (", errors.length, ")"] }), require$$0.jsxs("div", { className: "error-overlay-actions", children: [require$$0.jsx("button", { onClick: copyToClipboard, title: "Copy all to clipboard", children: "\uD83D\uDCCB" }), require$$0.jsx("button", { onClick: clearErrors, title: "Clear all", children: "\uD83D\uDDD1\uFE0F" }), require$$0.jsx("button", { onClick: togglePosition, title: "Move to ".concat(position === "bottom" ? "top" : "bottom"), children: position === "bottom" ? "⬆️" : "⬇️" }), require$$0.jsx("button", { onClick: toggleEnabled, title: "Disable Error Overlay", children: "\uD83D\uDD27" }), require$$0.jsx("button", { onClick: function () { return setIsMinimized(!isMinimized); }, title: "Minimize/Maximize", children: isMinimized ? "▲" : "▼" }), require$$0.jsx("button", { onClick: function () { return setIsVisible(false); }, title: "Close", children: "\u2715" })] })] }), !isMinimized && (require$$0.jsx("div", { className: "error-overlay-content", children: errors.map(function (error) { return (require$$0.jsxs("div", { className: "error-entry error-".concat(error.type), children: [require$$0.jsxs("div", { className: "error-header", children: [require$$0.jsx("span", { className: "error-time", children: new Date(error.timestamp).toLocaleTimeString() }), error.count > 1 && (require$$0.jsxs("span", { className: "error-count", children: ["(", error.count, "x)"] })), require$$0.jsx("span", { className: "error-badge error-badge-".concat(error.type), children: error.type })] }), require$$0.jsx("div", { className: "error-message", children: error.message }), error.stack && (require$$0.jsxs("details", { className: "error-stack", children: [require$$0.jsx("summary", { children: "Stack trace" }), require$$0.jsx("pre", { children: error.stack })] }))] }, error.id)); }) }))] }));
};

var WsButton = function (_a) {
    var button = _a.button, onPress = _a.onPress;
    var handleClick = require$$1.useCallback(function () {
        if (button.pressBehavior !== "disabled" && !button.isPressed) {
            onPress(button.id);
        }
    }, [button.pressBehavior, button.isPressed, button.id, onPress]);
    var className = require$$1.useMemo(function () {
        var classes = ["ws-button"];
        if (button.pressBehavior === "disabled" || button.isPressed) {
            classes.push("ws-button--disabled");
        }
        if (button.isPressed && button.pressBehavior === "spinning") {
            classes.push("ws-button--spinning");
        }
        return classes.join(" ");
    }, [button.pressBehavior, button.isPressed]);
    var containerClassName = require$$1.useMemo(function () {
        var classes = ["ws-button-container"];
        if (button.isDismissing) {
            classes.push("ws-button-container--dismissing");
        }
        return classes.join(" ");
    }, [button.isDismissing]);
    return (require$$0.jsx("div", { className: containerClassName, children: require$$0.jsxs("button", { className: className, onClick: handleClick, disabled: button.pressBehavior === "disabled" || button.isPressed, "aria-label": button.text, "aria-busy": button.isPressed && button.pressBehavior === "spinning", children: [button.isPressed && button.pressBehavior === "spinning" && (require$$0.jsx("span", { className: "ws-button__spinner" })), require$$0.jsx("span", { className: "ws-button__text", children: button.text })] }) }));
};

var ModalContent = function (_a) {
    var onClose = _a.onClose, onReset = _a.onReset;
    return (require$$0.jsxs("div", { className: "modalContent", children: [require$$0.jsxs("div", { className: "modalBody", children: [require$$0.jsx("h2", { children: "Restart Conversation" }), require$$0.jsx("p", { children: "Would you like to refresh and return to the starting point of the conversation?" })] }), require$$0.jsxs("div", { className: "modalActions", children: [require$$0.jsx("button", { onClick: onClose, className: "cancelBtn", children: "Cancel" }), require$$0.jsx("button", { onClick: onReset, className: "restartBtn", children: "Restart" })] })] }));
};

/**
 * Id the visitor (cookies, browser fingerprint, etc)
 *
 * @export
 * @returns {string}
 */
function visitorFingerprint() {
    return uuid_1();
}

var DEFAULT_VISITOR = {
    displayName: "Visitor",
    nick: "visitor:",
    typing: false
};
function createDefaultState$1(state, options) {
    var _a;
    if (!state) {
        state = {};
    }
    state.userId = state.userId ? state.userId : visitorFingerprint();
    state.visitorId = state.userId;
    // Determine if debug mode should be enabled
    var debugMode = false;
    if (typeof window !== 'undefined') {
        var localStorageSetting = (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem('xaErrorOverlay');
        if (localStorageSetting === 'enabled') {
            debugMode = true;
        }
        else if (localStorageSetting === 'disabled') {
            debugMode = false;
        }
        else if (options === null || options === void 0 ? void 0 : options.enableErrorOverlay) {
            // Use config option if no localStorage override
            debugMode = true;
        }
        else if (typeof globalThis.__DEV__ !== 'undefined' && globalThis.__DEV__) {
            // For React Native, default to true in development mode
            debugMode = true;
        }
    }
    return __assign$1({ connection: {
            connectionStatus: "offline",
            token: null,
            greetingRequested: false
        }, accountStatus: "offline", departments: {}, visitor: DEFAULT_VISITOR, agents: {}, chats: [], lastTimestamp: 0, lastRatingRequestTimestamp: 0, hasRating: false, isChatting: false, queuePosition: 0, failureMsg: null, visitorId: visitorFingerprint(), chips: [], sessionExpiration: "24h", visuals: {}, debugMode: debugMode }, state);
}
var DEFAULT_STATE = createDefaultState$1();

function createStateFromMessages(messages) {
    var _a;
    var def = createDefaultState$1();
    // Extract chips from the last message's options (matching rootReducer behavior)
    var lastMessage = messages.length > 0 ? messages[messages.length - 1] : undefined;
    var lastMsg = (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) === "chat.msg" ? lastMessage.msg : null;
    var chips = ((_a = lastMsg === null || lastMsg === void 0 ? void 0 : lastMsg.options) === null || _a === void 0 ? void 0 : _a.length) ? lastMsg.options : [];
    return __assign$1(__assign$1({}, def), { connection: __assign$1(__assign$1({}, def.connection), { connectionStatus: "online" }), accountStatus: "online", chats: __spreadArray$1([], messages, true), chips: chips, isChatting: true, visuals: {
            visible: true,
            opened: true,
        } });
}

// src/utils/formatProdErrorMessage.ts
function formatProdErrorMessage$1(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;

// src/utils/actionTypes.ts
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${ randomString()}`,
  REPLACE: `@@redux/REPLACE${ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;

// src/utils/isPlainObject.ts
function isPlainObject$3(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}

// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error(formatProdErrorMessage$1(2) );
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(formatProdErrorMessage$1(0) );
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(formatProdErrorMessage$1(1) );
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(3) );
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error(formatProdErrorMessage$1(4) );
    }
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(5) );
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(formatProdErrorMessage$1(6) );
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject$3(action)) {
      throw new Error(formatProdErrorMessage$1(7) );
    }
    if (typeof action.type === "undefined") {
      throw new Error(formatProdErrorMessage$1(8) );
    }
    if (typeof action.type !== "string") {
      throw new Error(formatProdErrorMessage$1(17) );
    }
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(9) );
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(formatProdErrorMessage$1(10) );
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(formatProdErrorMessage$1(11) );
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store = {
    dispatch,
    subscribe,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store;
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState === "undefined") {
      throw new Error(formatProdErrorMessage$1(12) );
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error(formatProdErrorMessage$1(13) );
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i++) {
    const key = reducerKeys[i];
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalReducerKeys.length; i++) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        action && action.type;
        throw new Error(formatProdErrorMessage$1(14) );
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

// src/compose.ts
function compose$6(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error(formatProdErrorMessage$1(15) );
    };
    const middlewareAPI = {
      getState: store.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose$6(...chain)(store.dispatch);
    return {
      ...store,
      dispatch
    };
  };
}

// src/index.ts
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;

// src/index.ts

// src/devtoolsExtension.ts
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0) return void 0;
  if (typeof arguments[0] === "object") return compose$6;
  return compose$6.apply(null, arguments);
};
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};

// src/getDefaultMiddleware.ts
function isBoolean$1(x) {
  return typeof x === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options) {
  const {
    thunk: thunk$1 = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options ?? {};
  let middlewareArray = new Tuple();
  if (thunk$1) {
    if (isBoolean$1(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk$1.extraArgument));
    }
  }
  return middlewareArray;
};

// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var autoBatchEnhancer = (options = {
  type: "raf"
}) => (next) => (...args) => {
  const store = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10)
  ) : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l) => l());
    }
  };
  return Object.assign({}, store, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      try {
        notifying = !action?.meta?.[SHOULD_AUTOBATCH];
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};

// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options) {
  const {
    autoBatch = true
  } = options ?? {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
  }
  return enhancerArray;
};

// src/configureStore.ts
function configureStore(options) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = void 0,
    middleware,
    devTools = true,
    duplicateMiddlewareCheck = true,
    preloadedState = void 0,
    enhancers = void 0
  } = options || {};
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (isPlainObject$3(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error(formatProdErrorMessage(1) );
  }
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  let finalCompose = compose$6;
  if (devTools) {
    finalCompose = composeWithDevTools({
      // Enable capture of stack traces for dispatched Redux actions
      trace: "production" !== "production",
      ...typeof devTools === "object" && devTools
    });
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}

// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
  return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

// Function to create a static reducer
function createStaticReducer(state) {
    return function (oldState, action) {
        if (oldState === void 0) { oldState = state; }
        log$3("static reducer", oldState, action);
        return oldState;
    };
}
// Function to create the store using @reduxjs/toolkit's configureStore
function createStaticStore(state) {
    var reducer = createStaticReducer(state);
    var store = configureStore({
        reducer: reducer,
        middleware: function (getDefaultMiddleware) {
            return getDefaultMiddleware({
                thunk: true, // Thunk is included by default, this is just for explicitness
            });
        },
        devTools: "production" !== 'production', // Redux DevTools in non-production environments
    });
    return store;
}

var StaticChatWidgetContainer = function (props) {
    var state = props.state;
    var store = require$$1.useMemo(function () {
        return createStaticStore(state);
    }, [state]);
    var config = require$$1.useMemo(function () {
        return __assign$1(__assign$1({}, props.config), { connection: {
                serverUrl: "",
                type: "local",
            } });
    }, [props.config]);
    return (require$$0.jsx(reactRedux.Provider, { store: store, children: require$$0.jsx(ChatWidgetUI, __assign$1({}, props, { config: config, disableAutoScroll: props.disableAutoScroll, preview: props.preview })) }));
};

var StaticMessagesChatWidgetContainer = function (props) {
    var messages = props.messages;
    var state = require$$1.useMemo(function () {
        return createStateFromMessages(messages);
    }, [messages]);
    return require$$0.jsx(StaticChatWidgetContainer, { state: state, mode: props.mode, config: props.config, disableAutoScroll: props.disableAutoScroll, preview: props.preview });
};

/**
 * Debounce delay for typing indicator in milliseconds.
 * After this delay of inactivity, the "stop typing" event will be sent.
 */
var TYPING_INDICATOR_DEBOUNCE_MS = 2000;
/**
 * Check if we're in development mode. Uses typeof to prevent TypeScript
 * errors after Rollup replaces "production" with a literal string.
 */
typeof process !== "undefined" &&
    typeof process.env !== "undefined" &&
    "production" !== "production";
/**
 * Converts preview messages to ChatDetail format for rendering.
 * This allows preview mode to use the existing message rendering infrastructure.
 *
 * @param messages - Array of preview messages to convert
 * @param config - Widget configuration containing avatarUrl and botName
 * @returns Array of ChatDetail objects suitable for MessageList rendering
 */
function convertPreviewMessagesToChatDetails(messages, config) {
    var timestamp = Date.now();
    return messages.map(function (msg, index) {
        var _a;
        var chatDetail = {
            type: "chat.msg",
            user: {
                nick: "agent:robot",
                display_name: (config === null || config === void 0 ? void 0 : config.botName) || "Assistant",
                avatarPath: config === null || config === void 0 ? void 0 : config.avatarUrl,
            },
            timestamp: timestamp + index,
            msg: {
                text: msg.displayText,
                html: msg.html,
                // Use "#" as fallback for suggestions without URLs to prevent navigation
                options: (_a = msg.suggestions) === null || _a === void 0 ? void 0 : _a.map(function (s) { return ({
                    label: s.title,
                    actionUrl: s.url || "#"
                }); }),
                // Store list in both formats:
                // - 'list': ChatServerList format for interface consistency and testing
                // - 'displays': Display format required by ListMiddleware for rendering
                list: msg.list ? {
                    type: msg.list.type,
                    title: msg.list.title,
                    items: msg.list.items.map(function (item) { return ({
                        title: item.title,
                        subTitle: item.description,
                        url: item.url,
                        imageUrl: item.imageUrl,
                        hideUrl: item.hideUrl,
                    }); })
                } : undefined,
                displays: msg.list ? [convertToListDisplay({
                        type: msg.list.type,
                        title: msg.list.title,
                        items: msg.list.items.map(function (item) { return ({
                            title: item.title,
                            subTitle: item.description,
                            url: item.url,
                            imageUrl: item.imageUrl,
                            hideUrl: item.hideUrl,
                        }); })
                    })] : undefined
            }
        };
        return chatDetail;
    });
}
/**
 * Preview mode component - renders a static chat widget without server connection.
 * Separated to avoid violating React hooks rules in the main wrapper.
 */
var ChatWidgetPreview = function (props) {
    var _a;
    var mode = (_a = props.mode) !== null && _a !== void 0 ? _a : "preview";
    // Memoize preview message conversion to avoid recalculating on every render
    var previewChatDetails = require$$1.useMemo(function () {
        return convertPreviewMessagesToChatDetails(props.previewMessages || [], props.config);
    }, [props.previewMessages, props.config]);
    return (require$$0.jsx(StaticMessagesChatWidgetContainer, { messages: previewChatDetails, mode: mode, config: props.config, disableAutoScroll: props.disableAutoScroll, preview: true }));
};
/**
 * Main wrapper component that handles config loading and server connection.
 */
var ChatWidgetConnected = function (props) {
    var _a;
    var mode = (_a = props.mode) !== null && _a !== void 0 ? _a : "normal";
    var _b = require$$1.useState(props.config), rawConfig = _b[0], setRawConfig = _b[1];
    var _c = require$$1.useState(!!props.getConfig), configLoading = _c[0], setConfigLoading = _c[1];
    var _d = require$$1.useState(), configError = _d[0], setConfigError = _d[1];
    // Load config from callback if provided
    require$$1.useEffect(function () {
        var cancelled = false;
        if (props.getConfig) {
            setConfigLoading(true);
            setConfigError(undefined);
            props
                .getConfig()
                .then(function (config) {
                if (!cancelled) {
                    setRawConfig(config);
                    setConfigLoading(false);
                    log$3("[ChatWidget] Config loaded from getConfig callback");
                }
            })
                .catch(function (error) {
                if (!cancelled) {
                    setConfigError(error);
                    setConfigLoading(false);
                    err("[ChatWidget] Failed to load config: ".concat(error.message));
                }
            });
        }
        else if (props.config) {
            // If no callback, use the config prop directly
            setRawConfig(props.config);
            setConfigLoading(false);
        }
        return function () {
            cancelled = true;
        };
        // Only depend on getConfig and config - not the entire props object to avoid infinite loops
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.getConfig, props.config]);
    var connection = useConnectionInfo(rawConfig);
    var config = require$$1.useMemo(function () {
        var _a;
        return (__assign$1(__assign$1({}, rawConfig), { connection: connection, assetUrl: (_a = connection === null || connection === void 0 ? void 0 : connection.serverUrl) !== null && _a !== void 0 ? _a : defaultServerUrl, env: rawConfig }));
    }, [connection, rawConfig]);
    var token = reactRedux.useSelector(function (state) { return state.connection.token; });
    var options = require$$1.useMemo(function () {
        var configurableMessages = getConfigurableMessages();
        if ((rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.configurableMessages) &&
            Array.isArray(rawConfig.configurableMessages.items) &&
            rawConfig.configurableMessages.items.length > 0) {
            configurableMessages = rawConfig.configurableMessages;
        }
        return {
            token: token,
            bot: {
                nick: "Bot",
                displayName: rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.botName,
                avatarPath: rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.avatarUrl,
            },
            configurableMessages: configurableMessages,
            hooks: rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.hooks,
            env: rawConfig,
        };
    }, [
        token,
        rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.botName,
        rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.avatarUrl,
        rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.configurableMessages,
        rawConfig === null || rawConfig === void 0 ? void 0 : rawConfig.hooks,
    ]);
    // Only create chat server when config is ready (not loading and no error)
    var chatServer = useChatServer(configLoading || configError ? null : connection, configLoading || configError ? null : options);
    // Determine mode class for loading/error states (mode already declared above)
    var modeClass = "widget-container--".concat(mode);
    // Show loading state while config is being fetched
    if (configLoading) {
        return (require$$0.jsx("div", { className: "widget-container widget-container--loading ".concat(modeClass), children: require$$0.jsx("div", { className: "xa-spinner-container visible", children: require$$0.jsx("div", { className: "xa-spinner" }) }) }));
    }
    // Show error state if config failed to load
    if (configError) {
        return (require$$0.jsx("div", { className: "widget-container widget-container--error ".concat(modeClass), children: require$$0.jsxs("div", { className: "widget-error-message", children: ["Failed to load chat configuration: ", configError.message] }) }));
    }
    return (require$$0.jsx(ChatConfigContext.Provider, { value: config, children: require$$0.jsx(ChatServerContext.Provider, { value: chatServer, children: require$$0.jsx(ChatWidgetUI, __assign$1({}, props, { config: rawConfig })) }) }));
};
/**
 * Inner ChatWidget component that renders the actual UI.
 * Exported for use by StaticChatWidgetContainer to avoid infinite loops.
 */
var ChatWidgetUI = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
    var innerDispatch = useChatDispatch();
    var dispatch = useChatServerDispatch();
    // From Redux
    var chatState = reactRedux.useSelector(function (state) { return state; });
    // Refresh modalReference
    var modalRef = require$$1.useRef({});
    var mode = (_a = props.mode) !== null && _a !== void 0 ? _a : "normal";
    var dockedMode = mode === "docked";
    var staticMode = mode === "static";
    // Preview mode can be enabled via `preview` prop (recommended) or legacy `mode="preview"`
    var previewMode = props.preview === true || mode === "preview";
    var modeClass = "widget-container--".concat(mode);
    var canRefresh = (_c = (_b = props.config.header) === null || _b === void 0 ? void 0 : _b.actions) === null || _c === void 0 ? void 0 : _c.refresh;
    // can't minimize in docked mode, static mode, or preview mode.
    var canMinimize = !dockedMode && !staticMode && !previewMode && ((_e = (_d = props.config.header) === null || _d === void 0 ? void 0 : _d.actions) === null || _e === void 0 ? void 0 : _e.minimize);
    log$3("docked: ".concat(dockedMode, " static: ").concat(staticMode, " preview: ").concat(previewMode, " minimized: ").concat((_g = (_f = props.config.header) === null || _f === void 0 ? void 0 : _f.actions) === null || _g === void 0 ? void 0 : _g.minimize));
    var canCancel;
    // To preserve legacy behavior, cancel needs a little more checks
    if (typeof ((_j = (_h = props.config.header) === null || _h === void 0 ? void 0 : _h.actions) === null || _j === void 0 ? void 0 : _j.cancel) === "boolean") {
        canCancel = !dockedMode && !staticMode && !previewMode && ((_l = (_k = props.config.header) === null || _k === void 0 ? void 0 : _k.actions) === null || _l === void 0 ? void 0 : _l.cancel);
    }
    else {
        canCancel = !dockedMode && !staticMode && !previewMode;
    }
    // For backward compatibility. Note: the action will create the actual "visuals" object" (this is a copy).
    if (!chatState.visuals) {
        chatState.visuals = {};
    }
    // Our state - pull from storage
    var _15 = require$$1.useState((!canMinimize && !canCancel) ||
        // !!get("visible") ||
        chatState.visuals.visible ||
        (((_m = props.config) === null || _m === void 0 ? void 0 : _m.autoOpenOnWidth) &&
            window.matchMedia("(min-width: ".concat((_o = props.config) === null || _o === void 0 ? void 0 : _o.autoOpenOnWidth, ")")).matches)), visible = _15[0], setVisibleState = _15[1];
    var _16 = require$$1.useState(false); _16[0]; var setTypingState = _16[1]; // false initially - state kept for potential external observers
    // Ref to track typing state for use in timeout callbacks
    var typingRef = require$$1.useRef(false);
    // Timeout ref for debouncing "stop typing" events
    var stopTypingTimeoutRef = require$$1.useRef(null);
    var chatServer = require$$1.useContext(ChatServerContext);
    var patternsConfig = (_q = (_p = props.config) === null || _p === void 0 ? void 0 : _p.autoOpenOnPattern) === null || _q === void 0 ? void 0 : _q.patterns;
    var currentUrl = window.location.href;
    var patternExist = patternsConfig && patternsConfig.length > 0;
    var patternMatches = patternsConfig === null || patternsConfig === void 0 ? void 0 : patternsConfig.some(function (pattern) { return currentUrl.includes(pattern); });
    var configWidth = (_s = (_r = props.config) === null || _r === void 0 ? void 0 : _r.autoOpenOnPattern) === null || _s === void 0 ? void 0 : _s.minimumWidth;
    // eslint-disable-next-line no-restricted-globals
    var currentWidth = screen.width;
    var setVisible = require$$1.useCallback(function (newVisible) {
        if (staticMode || previewMode) {
            return;
        }
        log$3("setVisible: ".concat(newVisible));
        setVisibleState(newVisible);
        innerDispatch(setVisualStatus({
            visible: newVisible,
        }));
    }, [innerDispatch, staticMode, previewMode]);
    require$$1.useEffect(function () {
        var _a, _b;
        var handleKeyDown = function (event) {
            var body = document.getElementsByTagName("body")[0];
            body.tabIndex = -1;
            if (event.key === "Escape") {
                body.focus();
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        if (checkSessionExpiration((chatState === null || chatState === void 0 ? void 0 : chatState.sessionExpiration) || ((_a = props.config) === null || _a === void 0 ? void 0 : _a.sessionExpiration), (_b = chatState === null || chatState === void 0 ? void 0 : chatState.chats[chatState.chats.length - 1]) === null || _b === void 0 ? void 0 : _b.timestamp, chatState === null || chatState === void 0 ? void 0 : chatState.lastTimestamp)) {
            innerDispatch(setSessionId(undefined));
            innerDispatch(reset());
        }
        return function () {
            document.removeEventListener("keydown", handleKeyDown);
            // Cleanup typing timeout on unmount
            if (stopTypingTimeoutRef.current) {
                clearTimeout(stopTypingTimeoutRef.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _17 = require$$1.useState(!document.hidden), isTabVisible = _17[0], setIsTabVisible = _17[1];
    require$$1.useEffect(function () {
        var handleVisibilityChange = function () {
            setIsTabVisible(!document.hidden);
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return function () {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);
    require$$1.useEffect(function () {
        // Too early?
        if (!chatServer) {
            log$3("Tab visibility changed but no chatServer yet");
            return;
        }
        if (!isTabVisible) {
            log$3("Tab is HIDDEN - calling sleep()");
            chatServer.sleep();
        }
        else {
            log$3("Tab is VISIBLE - calling wakeup()");
            chatServer.wakeup();
        }
    }, [chatServer, innerDispatch, isTabVisible]);
    // Handle beforeunload to notify router when user is leaving
    require$$1.useEffect(function () {
        if (!chatServer) {
            return undefined;
        }
        var handleBeforeUnload = function () {
            log$3("beforeunload - notifying router of user disconnecting");
            if (chatServer.notifyDisconnecting) {
                chatServer.notifyDisconnecting();
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return function () {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [chatServer]);
    require$$1.useEffect(function () {
        // For reopen widget after move on same window
        // if (get("opened")) {
        //     setVisible(true);
        // }
        if (chatState.visuals.opened) {
            setVisible(true);
        }
        else {
            if (mode === "normal") {
                setVisible(false);
            }
        }
        if (patternExist && patternMatches) {
            setVisible(true);
        }
        if (currentWidth < +configWidth) {
            setVisible(false);
        }
    }, [
        currentWidth,
        patternExist,
        patternMatches,
        configWidth,
        setVisible,
        chatState.visuals.opened,
        mode,
    ]);
    var stopTyping = require$$1.useCallback(function () {
        if (!typingRef.current)
            return;
        // Clear the timeout if it exists
        if (stopTypingTimeoutRef.current) {
            clearTimeout(stopTypingTimeoutRef.current);
            stopTypingTimeoutRef.current = null;
        }
        dispatch(sendTyping(false));
        setTypingState(false);
        typingRef.current = false;
    }, [dispatch]);
    var handleOnChange = require$$1.useCallback(function () {
        // Send "typing" event only on first keystroke
        if (!typingRef.current) {
            dispatch(sendTyping(true));
            setTypingState(true);
            typingRef.current = true;
        }
        // Clear any existing timeout
        if (stopTypingTimeoutRef.current) {
            clearTimeout(stopTypingTimeoutRef.current);
        }
        // Set a new timeout to send "stop typing" after inactivity
        stopTypingTimeoutRef.current = window.setTimeout(function () {
            stopTyping();
        }, TYPING_INDICATOR_DEBOUNCE_MS);
    }, [dispatch, stopTyping]);
    function handleSendMessage(msg) {
        // Don't allow sending messages in preview mode
        if (previewMode) {
            return;
        }
        dispatch(sendMessage(msg));
    }
    function handleWriteMessage(msg) {
        // Don't allow writing messages in preview mode
        if (previewMode) {
            return;
        }
        innerDispatch(writeMessage(msg.msg, msg.user));
    }
    var handleOpenUrl = useOpenUrlCallback();
    function handleOnSubmit(rawInput) {
        // Don't allow any actions in preview mode
        if (previewMode) {
            return;
        }
        // Don't allow visitor to send msg if not chatting
        if (chatState.accountStatus === "offline" && !chatState.isChatting)
            return;
        // Don't send empty messages
        if (!rawInput)
            return;
        // Immediately stop typing
        stopTyping();
        chatServer.flush();
        dispatch(executeAction(rawInput));
    }
    function handleFileUpload(event) {
        var _a;
        event.preventDefault();
        // Don't allow file uploads in preview mode
        if (previewMode) {
            return;
        }
        // Only send the first file dropped on input
        var file = (_a = event === null || event === void 0 ? void 0 : event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files[0];
        if (!file) {
            return;
        }
        dispatch(sendFile(file));
    }
    function getVisibilityClass() {
        var _a;
        if (visible) {
            return "visible";
        }
        // Skip hide animation on initial page load when widget was already closed
        // This prevents the "flash" of the close animation running on mount
        if (!((_a = chatState.visuals) === null || _a === void 0 ? void 0 : _a.hasInteracted)) {
            return "widget-container--initial-hidden";
        }
        return "";
    }
    function openRestartConfirmationModal() {
        // Interesting, this call the modalRef of the restart modal
        modalRef.current.style.display = "block";
    }
    function closeRestartConfirmationModal() {
        modalRef.current.style.display = "none";
    }
    function handleReset() {
        innerDispatch(reset());
    }
    function handleRestartClick() {
        if (config.header.actions.refreshShowConfirmation) {
            // show the modal
            openRestartConfirmationModal();
            // we will close when
        }
        else {
            handleReset();
        }
    }
    function handleRestartModalCloseClick() {
        closeRestartConfirmationModal();
    }
    /** Called when minimize button is clicked */
    function handleMinimizeClick() {
        innerDispatch(setVisualStatus({
            opened: false,
            hasInteracted: true,
        }));
        setVisible(false);
    }
    /** Called when cancel is clicked */
    function handleCancelClick() {
        // First reset to clear all state
        innerDispatch(reset());
        // Then set hasInteracted to prevent CTA from showing after cancel
        innerDispatch(setVisualStatus({
            opened: false,
            hasInteracted: true,
        }));
        setVisible(false);
    }
    function chatButtonOnClick() {
        innerDispatch(setVisualStatus({
            opened: true,
            hasInteracted: true,
        }));
        setVisible(true);
        setTimeout(function () {
            document.getElementById("chatWidgetInput").focus();
        }, 100);
    }
    function handleCtaDismiss() {
        innerDispatch(setVisualStatus({
            hasInteracted: true,
        }));
    }
    // Action Bar state and handlers
    var _18 = require$$1.useState(false), formModalOpen = _18[0], setFormModalOpen = _18[1];
    var _19 = require$$1.useState(null), activeFormConfig = _19[0], setActiveFormConfig = _19[1];
    var handleFormButtonClick = require$$1.useCallback(function (formButton) {
        // If form-widget is configured, use its openForm API
        // The form-widget script should already be pre-loaded
        var options = formButton.preselectChipLabel
            ? { preselectChipLabel: formButton.preselectChipLabel }
            : undefined;
        openFormWidgetWhenReady(options).then(function (opened) {
            if (!opened) {
                // Fallback to modal if form-widget isn't available
                log$3("Form widget not available, showing modal fallback");
                setActiveFormConfig(formButton);
                setFormModalOpen(true);
            }
        });
    }, []);
    var handleFormModalClose = require$$1.useCallback(function () {
        setFormModalOpen(false);
        setActiveFormConfig(null);
    }, []);
    function handleWsButtonPress(buttonId) {
        var _a, _b;
        log$3("WS Button pressed: ".concat(buttonId));
        // If the button has spinning behavior, update state to show spinner
        if (((_a = chatState.wsButton) === null || _a === void 0 ? void 0 : _a.pressBehavior) === "spinning") {
            // Update the button state to show it's pressed
            innerDispatch({
                type: "ws_button_display",
                detail: __assign$1(__assign$1({}, chatState.wsButton), { isPressed: true, timestamp: +new Date() })
            });
        }
        // Send the button pressed event to the server
        if (chatServer && chatServer.sendButtonPressed) {
            chatServer.sendButtonPressed(buttonId).catch(function (error) {
                err("Failed to send button press: ".concat(error));
                // Reset button state on error
                if (chatState.wsButton) {
                    innerDispatch({
                        type: "ws_button_display",
                        detail: __assign$1(__assign$1({}, chatState.wsButton), { isPressed: false, timestamp: +new Date() })
                    });
                }
            });
        }
        // If the button has disabled behavior, animate out then dismiss
        if (((_b = chatState.wsButton) === null || _b === void 0 ? void 0 : _b.pressBehavior) === "disabled") {
            // First set dismissing state to trigger animation
            innerDispatch({
                type: "ws_button_display",
                detail: __assign$1(__assign$1({}, chatState.wsButton), { isDismissing: true, timestamp: +new Date() })
            });
            // Then actually dismiss after animation completes
            setTimeout(function () {
                innerDispatch({
                    type: "ws_button_dismiss",
                    detail: {
                        id: buttonId,
                        timestamp: +new Date()
                    }
                });
            }, WS_BUTTON_DISMISS_ANIMATION_DURATION);
        }
    }
    var isOffline = chatState.accountStatus === "offline" && !chatState.isChatting;
    var messages = chatState && chatState.chats;
    log$3("Rendering - accountStatus: \"".concat(chatState.accountStatus, "\", connectionStatus: \"").concat(chatState.connection.connectionStatus, "\""));
    var config = props.config, onConnectionStatusChange = props.onConnectionStatusChange;
    var actionBarEnabled = ((_t = config === null || config === void 0 ? void 0 : config.actionBar) === null || _t === void 0 ? void 0 : _t.enabled) === true;
    // Disable greeting in preview mode
    useGreeting(!isOffline && !props.preChatFormEnabled && visible && !previewMode);
    var connectionStatus = chatState.connection.connectionStatus;
    require$$1.useEffect(function () {
        if (onConnectionStatusChange) {
            onConnectionStatusChange(connectionStatus);
        }
    }, [connectionStatus, onConnectionStatusChange]);
    useExternalScript((_u = props.config) === null || _u === void 0 ? void 0 : _u.middlewareUrl);
    // Pre-load form-widget script if formWidgetKey is provided
    require$$1.useEffect(function () {
        if (config === null || config === void 0 ? void 0 : config.formWidgetKey) {
            preloadFormWidgetScript(config.formWidgetKey);
        }
    }, [config === null || config === void 0 ? void 0 : config.formWidgetKey]);
    // Set body attribute when actionBar is enabled (used by CSS to hide form-widget side button on mobile)
    // Uses reference counting to handle multiple widget instances
    require$$1.useEffect(function () {
        if (actionBarEnabled) {
            // Increment reference count
            var currentCount = parseInt(document.body.getAttribute("data-xapp-action-bar-count") || "0", 10);
            document.body.setAttribute("data-xapp-action-bar-count", String(currentCount + 1));
            document.body.setAttribute("data-xapp-action-bar-enabled", "true");
        }
        return function () {
            if (actionBarEnabled) {
                // Decrement reference count
                var currentCount = parseInt(document.body.getAttribute("data-xapp-action-bar-count") || "0", 10);
                var newCount = Math.max(0, currentCount - 1);
                if (newCount === 0) {
                    document.body.removeAttribute("data-xapp-action-bar-enabled");
                    document.body.removeAttribute("data-xapp-action-bar-count");
                }
                else {
                    document.body.setAttribute("data-xapp-action-bar-count", String(newCount));
                }
            }
        };
    }, [actionBarEnabled]);
    // This is a pseudo agent. It represent's the widget (shown in the header avatar for instance)
    var widgetAgent = ((_v = chatState.agents["agent:robot"]) === null || _v === void 0 ? void 0 : _v.user) ||
        (config === null || config === void 0 ? void 0 : config.agent) || {
        nick: "agent:robot",
        avatarPath: config.avatarUrl,
        display_name: "Agent",
    };
    return (require$$0.jsxs(require$$0.Fragment, { children: [require$$0.jsxs("div", { className: "widget-container ".concat(modeClass, " ").concat(getVisibilityClass()).concat(actionBarEnabled ? " widget-container--with-action-bar" : ""), children: [require$$0.jsx(WidgetStylesheet, { theme: config === null || config === void 0 ? void 0 : config.theme }), require$$0.jsx(ChatHeader, { accountStatus: chatState.accountStatus, refreshOnClick: handleRestartClick, minimizeOnClick: handleMinimizeClick, cancelOnClick: handleCancelClick, agent: widgetAgent, canRefresh: canRefresh, canMinimize: canMinimize, canCancel: canCancel, config: config === null || config === void 0 ? void 0 : config.header, menuConfig: config.menu, debugMode: (_y = (_x = (_w = props.config) === null || _w === void 0 ? void 0 : _w.connection) === null || _x === void 0 ? void 0 : _x.mcp) === null || _y === void 0 ? void 0 : _y.debugMode, onSubmit: handleOnSubmit }), require$$0.jsx(MessageList, { visible: visible, queuePosition: chatState.queuePosition, isChatting: chatState.isChatting, isOffline: isOffline, messages: messages, agents: chatState.agents, agent: config === null || config === void 0 ? void 0 : config.agent, lastRatingRequestTimestamp: chatState.lastRatingRequestTimestamp, hasRating: chatState.hasRating, visitorId: chatState.visitorId, hasWsButton: !!chatState.wsButton, messageMiddleware: props.messageMiddleware, textTypingStatusEnabled: (_0 = (_z = props.config) === null || _z === void 0 ? void 0 : _z.typingStatus) === null || _0 === void 0 ? void 0 : _0.textTypingStatusEnabled, disableAutoScroll: props.disableAutoScroll, onSend: handleSendMessage, onWrite: handleWriteMessage, onOpenUrl: handleOpenUrl, minimizeOnClick: handleMinimizeClick }), require$$0.jsx("div", { className: "xa-spinner-container ".concat(visible && connectionStatus === "pending" ? "visible" : ""), children: require$$0.jsx("div", { className: "xa-spinner" }) }), connectionStatus === "offline" && require$$0.jsx(ServerOffline, {}), chatState.wsButton && visible && (require$$0.jsx(WsButton, { button: chatState.wsButton, onPress: handleWsButtonPress })), require$$0.jsx(ChatFooter, { isAdmin: config === null || config === void 0 ? void 0 : config.isAdmin, isChatting: chatState.isChatting, placeholder: (_1 = config === null || config === void 0 ? void 0 : config.input) === null || _1 === void 0 ? void 0 : _1.placeholder, sendButtonIcon: (_3 = (_2 = config === null || config === void 0 ? void 0 : config.footer) === null || _2 === void 0 ? void 0 : _2.sendButton) === null || _3 === void 0 ? void 0 : _3.icon, sendButtonIconHover: (_5 = (_4 = config === null || config === void 0 ? void 0 : config.footer) === null || _4 === void 0 ? void 0 : _4.sendButton) === null || _5 === void 0 ? void 0 : _5.iconHover, sendButtonIconDisabled: (_7 = (_6 = config === null || config === void 0 ? void 0 : config.footer) === null || _6 === void 0 ? void 0 : _6.sendButton) === null || _7 === void 0 ? void 0 : _7.iconDisabled, visible: visible, hasWsButton: !!chatState.wsButton, menuConfig: (_8 = props.config) === null || _8 === void 0 ? void 0 : _8.menu, footerConfig: (_9 = props.config) === null || _9 === void 0 ? void 0 : _9.footer, inputConfig: (_10 = props.config) === null || _10 === void 0 ? void 0 : _10.input, disabled: previewMode, onChange: handleOnChange, onSubmit: handleOnSubmit, onFileUpload: handleFileUpload }), require$$0.jsx("div", { className: "restartModal", ref: modalRef, onClick: handleRestartModalCloseClick, children: require$$0.jsx(ModalContent, { onClose: handleRestartModalCloseClick, onReset: handleReset }) })] }), actionBarEnabled && config.actionBar ? (require$$0.jsxs(require$$0.Fragment, { children: [require$$0.jsx(ActionBar, { config: __assign$1(__assign$1({}, config.actionBar), { 
                            // Use actionBar.cta if set, otherwise fall back to widget-level cta
                            cta: (_11 = config.actionBar.cta) !== null && _11 !== void 0 ? _11 : config.cta }), visible: visible, chatDisabled: config.disabled, hasUserInteracted: (_12 = chatState.visuals) === null || _12 === void 0 ? void 0 : _12.hasInteracted, onChatClick: chatButtonOnClick, onChatMinimize: handleMinimizeClick, onFormClick: handleFormButtonClick, onCtaDismiss: handleCtaDismiss }), formModalOpen && activeFormConfig && (require$$0.jsx(FormModal, { config: activeFormConfig, widgetEnv: config, onClose: handleFormModalClose }))] })) : (require$$0.jsx(ChatButton, { addClass: visible ? "visible" : "", onClick: chatButtonOnClick, config: config === null || config === void 0 ? void 0 : config.cta, imageUrl: (_13 = config === null || config === void 0 ? void 0 : config.chatButton) === null || _13 === void 0 ? void 0 : _13.imageUrl, visible: visible, hasInteracted: (_14 = chatState.visuals) === null || _14 === void 0 ? void 0 : _14.hasInteracted, onCtaDismiss: handleCtaDismiss })), require$$0.jsx(ErrorOverlay, { enableErrorOverlay: config === null || config === void 0 ? void 0 : config.enableErrorOverlay })] }));
};
/**
 * Top-level wrapper that dispatches between preview mode and connected mode.
 * This separation ensures React hooks rules are not violated.
 */
var ChatWidgetWrapper = function (props) {
    var _a;
    var rawMode = (_a = props.mode) !== null && _a !== void 0 ? _a : "normal";
    // Support both `preview` prop and legacy `mode="preview"`
    var isPreviewMode = props.preview === true || rawMode === "preview";
    // For visual layout, use "static" when mode is "preview" (legacy), otherwise use the actual mode
    var visualMode = rawMode === "preview" ? "static" : rawMode;
    if (isPreviewMode) {
        return require$$0.jsx(ChatWidgetPreview, __assign$1({}, props, { mode: visualMode }));
    }
    return require$$0.jsx(ChatWidgetConnected, __assign$1({}, props));
};

function tryParseJson$1(str) {
    try {
        if (str) {
            return JSON.parse(str);
        }
    }
    catch (_a) {
    }
    return undefined;
}
var BrowserStateStorage = /** @class */ (function () {
    function BrowserStateStorage(innerStorage, key) {
        this.innerStorage = innerStorage;
        this.key = key;
    }
    BrowserStateStorage.prototype.get = function () {
        return tryParseJson$1(this.innerStorage.getItem(this.key));
    };
    BrowserStateStorage.prototype.set = function (val) {
        try {
            this.innerStorage.setItem(this.key, JSON.stringify(val));
        }
        catch (_a) {
            logOnce("storage", "Unable to store redux state");
        }
    };
    return BrowserStateStorage;
}());

/**
 * Polyfill for Browser Local Storage
 *
 * Based on https://github.com/capaj/localstorage-polyfill/blob/master/localStorage.js
 */
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
        this.valuesMap = new Map();
    }
    LocalStorage.prototype.getItem = function (key) {
        var stringKey = String(key);
        if (this.valuesMap.has(key)) {
            return String(this.valuesMap.get(stringKey));
        }
        return null;
    };
    LocalStorage.prototype.setItem = function (key, val) {
        this.valuesMap.set(String(key), String(val));
    };
    LocalStorage.prototype.removeItem = function (key) {
        this.valuesMap.delete(key);
    };
    LocalStorage.prototype.clear = function () {
        this.valuesMap.clear();
    };
    LocalStorage.prototype.key = function (i) {
        if (arguments.length === 0) {
            throw new TypeError("Failed to execute 'key' on 'Storage': 1 argument required, but only 0 present."); // this is a TypeError implemented on Chrome, Firefox throws Not enough arguments to Storage.key.
        }
        var arr = Array.from(this.valuesMap.keys());
        return arr[i];
    };
    Object.defineProperty(LocalStorage.prototype, "length", {
        get: function () {
            return this.valuesMap.size;
        },
        enumerable: false,
        configurable: true
    });
    return LocalStorage;
}());

function persistStateReducer(storage, initialState, innerReducer) {
    var _a;
    var obj = (_a = storage.get()) !== null && _a !== void 0 ? _a : initialState;
    // Clean up hasInteracted flag on page load - don't persist across browser refreshes
    if (obj && obj.visuals) {
        obj = __assign$1(__assign$1({}, obj), { visuals: __assign$1(__assign$1({}, obj.visuals), { hasInteracted: undefined }) });
    }
    return function (state, action) {
        if (state === void 0) { state = obj; }
        var res = innerReducer(state, action);
        storage.set(res);
        return res;
    };
}

function connectionReducer(state, action) {
    switch (action.type) {
        case "connection_update":
            return __assign$1(__assign$1({}, state), { connectionStatus: action.detail.status });
        case "receiveToken":
            return __assign$1(__assign$1({}, state), { token: action.detail.token });
        case "sendGreeting":
            return __assign$1(__assign$1({}, state), { greetingRequested: true });
    }
    return state;
}

function joinMessages(messages, msg) {
    return insertSorted(__spreadArray$1([], messages, true), msg, function (left, right) { return left.timestamp - right.timestamp; });
}

function memberJoin(state, detail) {
    // TODO: Why?
    // if (state.chats.length === 0) {
    // console.log(`######### No chats in member join action`);
    // set("sessionId", "");
    // }
    var agents = __assign$1({}, state.agents);
    var prevAgentInfo = state.agents[detail.user.nick];
    agents[detail.user.nick] = __assign$1(__assign$1({}, prevAgentInfo), { user: __assign$1(__assign$1({}, detail.user), { displayName: detail.user.displayName || "Agent" }), joined: true, typing: false, hideUserInfo: detail.hideUserInfo });
    if (isAgent(detail.user.nick)) {
        // Always show join messages with special visual features (divider or custom message)
        // These are important conversation markers, not routine join notifications
        var hasSpecialVisuals = detail.showDivider || detail.message;
        if ((prevAgentInfo === null || prevAgentInfo === void 0 ? void 0 : prevAgentInfo.joined) && !hasSpecialVisuals) {
            log$3("DEDUPLICATION: Agent \"".concat(detail.user.displayName || "Unknown", "\" (nick: ").concat(detail.user.nick, ") already joined. NOT adding duplicate join message to chat."));
        }
        else {
            if (hasSpecialVisuals) {
                log$3("Agent \"".concat(detail.user.displayName || "Unknown", "\" (nick: ").concat(detail.user.nick, ") is joining with special visuals (divider or custom message). Adding join message to chat."));
            }
            else {
                log$3("Agent \"".concat(detail.user.displayName || "Unknown", "\" (nick: ").concat(detail.user.nick, ") is joining. Adding join message to chat."));
            }
        }
        return __assign$1(__assign$1({}, state), { isChatting: true, chats: ((prevAgentInfo === null || prevAgentInfo === void 0 ? void 0 : prevAgentInfo.joined) && !hasSpecialVisuals) ? state.chats : joinMessages(state.chats, detail), agents: agents });
    }
    else {
        log$3("Non-agent member \"".concat(detail.user.displayName || "Unknown", "\" (nick: ").concat(detail.user.nick, ") is joining. Adding join message to chat."));
        return __assign$1(__assign$1({}, state), { isChatting: true, chats: joinMessages(state.chats, detail), agents: agents });
    }
}

function memberLeave(state, detail) {
    var agents = __assign$1({}, state.agents);
    var prevAgentInfo = state.agents[detail.user.nick];
    agents[detail.user.nick] = __assign$1(__assign$1({}, prevAgentInfo), { joined: false, typing: false });
    // count number of agents that are still joined
    var agentsJoined = Object.values(agents).filter(function (agent) { return agent.joined; });
    var isChatting = agentsJoined.length > 0;
    if (isAgent(detail.user.nick)) {
        var hasSpecialVisuals = detail.showDivider || detail.message;
        if (prevAgentInfo === null || prevAgentInfo === void 0 ? void 0 : prevAgentInfo.joined) {
            if (hasSpecialVisuals) {
                log$3("Agent \"".concat(detail.user.displayName || "Unknown", "\" (nick: ").concat(detail.user.nick, ") is leaving with special visuals (divider or custom message). Adding leave message to chat."));
            }
            else {
                log$3("Agent \"".concat(detail.user.displayName || "Unknown", "\" (nick: ").concat(detail.user.nick, ") is leaving. Adding leave message to chat."));
            }
        }
        else {
            log$3("DEDUPLICATION: Agent \"".concat(detail.user.displayName || "Unknown", "\" (nick: ").concat(detail.user.nick, ") already left. NOT adding duplicate leave message to chat."));
        }
        return __assign$1(__assign$1({}, state), { isChatting: isChatting, chats: (prevAgentInfo === null || prevAgentInfo === void 0 ? void 0 : prevAgentInfo.joined) ? joinMessages(state.chats, detail) : state.chats, agents: agents });
    }
    else {
        log$3("Non-agent member \"".concat(detail.user.displayName || "Unknown", "\" (nick: ").concat(detail.user.nick, ") is leaving. Adding leave message to chat."));
        return __assign$1(__assign$1({}, state), { isChatting: isChatting, chats: joinMessages(state.chats, detail), agents: agents });
    }
}

function resetReducer(state) {
    var _a;
    if (state === void 0) { state = DEFAULT_STATE; }
    var defaultState = createDefaultState$1({
        accessToken: state.accessToken,
        userId: state.userId,
        attributes: state.attributes,
        sessionExpiration: state.sessionExpiration
    });
    // If we have an active connection, preserve status to avoid showing offline during reconnect
    var wasOnline = state.connection.connectionStatus === 'online';
    // Preserve opened state so widget doesn't close on refresh
    var wasOpened = (_a = state.visuals) === null || _a === void 0 ? void 0 : _a.opened;
    return __assign$1(__assign$1({}, defaultState), { connection: __assign$1(__assign$1({}, defaultState.connection), { greetingRequested: false, 
            // Generate new nonce to trigger server recreation and start fresh session
            nonce: uuid_1(), 
            // Preserve connection status during transition if we were online
            connectionStatus: wasOnline ? 'online' : defaultState.connection.connectionStatus }), 
        // Preserve accountStatus if we were online to avoid showing offline message during reconnect
        accountStatus: wasOnline ? 'online' : defaultState.accountStatus, visitor: state.visitor, visitorId: state.visitorId, 
        // Reset visuals but preserve opened state so widget stays open during refresh
        visuals: {
            opened: wasOpened,
            hasInteracted: false
        } });
}

// Type guard for ChatSystemMessageDetail
function isChatSystemMessage(chat) {
    return chat.type === "chat.systemmessage";
}
// todo: create reducer (requires redux-thunk dependency)
function appendMessageToState(state, msg) {
    state.chats = joinMessages(state.chats, msg);
    if (msg.type === "chat.msg") {
        state.activeContexts = msg.msg.context;
    }
}
function update(state, action) {
    var _a, _b, _c, _d;
    var _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    if (state === void 0) { state = DEFAULT_STATE; }
    log$3("action", action);
    if (action.type === "reset") {
        return resetReducer(state);
    }
    switch (action.type) {
        case "connection_update":
        case "receiveToken":
        case "sendGreeting":
            // workaround until state is split. Use combineReducers afterwards
            var newConnectionState = connectionReducer(state.connection, action);
            if (state.connection !== newConnectionState) {
                state = __assign$1(__assign$1({}, state), { lastTimestamp: (_e = action.detail) === null || _e === void 0 ? void 0 : _e.timestamp, connection: newConnectionState });
            }
            return state;
        case "account_status":
            return __assign$1(__assign$1({}, state), { lastTimestamp: (_f = action.detail) === null || _f === void 0 ? void 0 : _f.timestamp, accountStatus: action.detail.status });
        case "session_id":
            return __assign$1(__assign$1({}, state), { lastTimestamp: (_g = action.detail) === null || _g === void 0 ? void 0 : _g.timestamp, sessionId: action.detail.sessionId });
        case "visual_status":
            return __assign$1(__assign$1({}, state), { lastTimestamp: (_h = action.detail) === null || _h === void 0 ? void 0 : _h.timestamp, visuals: __assign$1(__assign$1(__assign$1(__assign$1(__assign$1({}, (state.visuals || {})), (action.detail.status.drawer !== undefined && { drawer: action.detail.status.drawer })), (action.detail.status.opened !== undefined && { opened: action.detail.status.opened })), (action.detail.status.visible !== undefined && { visible: action.detail.status.visible })), (action.detail.status.hasInteracted !== undefined && { hasInteracted: action.detail.status.hasInteracted })) });
        case "toggle_debug_mode":
            var newDebugMode = !state.debugMode;
            // Update localStorage to persist the setting
            if (typeof window !== 'undefined' && window.localStorage) {
                window.localStorage.setItem('xaErrorOverlay', newDebugMode ? 'enabled' : 'disabled');
            }
            return __assign$1(__assign$1({}, state), { debugMode: newDebugMode });
        case "ws_button_display":
            return __assign$1(__assign$1({}, state), { lastTimestamp: (_j = action.detail) === null || _j === void 0 ? void 0 : _j.timestamp, wsButton: {
                    id: action.detail.id,
                    // Preserve existing text if new text is empty (e.g., during dismiss animation)
                    text: action.detail.text || ((_k = state.wsButton) === null || _k === void 0 ? void 0 : _k.text) || '',
                    pressBehavior: action.detail.pressBehavior,
                    isPressed: (_l = action.detail.isPressed) !== null && _l !== void 0 ? _l : false,
                    isDismissing: (_m = action.detail.isDismissing) !== null && _m !== void 0 ? _m : false
                } });
        case "ws_button_dismiss":
            // Only dismiss if the id matches
            if (((_o = state.wsButton) === null || _o === void 0 ? void 0 : _o.id) === action.detail.id) {
                return __assign$1(__assign$1({}, state), { lastTimestamp: (_p = action.detail) === null || _p === void 0 ? void 0 : _p.timestamp, wsButton: undefined });
            }
            return state;
        case "department_update":
            return __assign$1(__assign$1({}, state), { lastTimestamp: (_q = action.detail) === null || _q === void 0 ? void 0 : _q.timestamp, departments: __assign$1(__assign$1({}, state.departments), (_a = {}, _a[action.detail.id] = __assign$1({}, action.detail), _a)) });
        case "visitor_update":
            return __assign$1(__assign$1({}, state), { lastTimestamp: (_r = action.detail) === null || _r === void 0 ? void 0 : _r.timestamp, visitor: __assign$1(__assign$1({}, state.visitor), action.detail) });
        case "agent_update":
            var prevUpdateAgent = state.agents[action.detail.nick];
            return __assign$1(__assign$1({}, state), { lastTimestamp: (_s = action.detail) === null || _s === void 0 ? void 0 : _s.timestamp, agents: __assign$1(__assign$1({}, state.agents), (_b = {}, _b[action.detail.nick] = __assign$1(__assign$1({}, prevUpdateAgent), { user: __assign$1(__assign$1({}, prevUpdateAgent.user), action.detail), typing: (prevUpdateAgent || { typing: false }).typing // if we had it - keep it
                 }), _b)) });
        case "chat":
            var newState = __assign$1(__assign$1({}, state), { lastTimestamp: (_t = action.detail) === null || _t === void 0 ? void 0 : _t.timestamp });
            switch (action.detail.type) {
                case "chat.memberjoin":
                    return memberJoin(state, action.detail);
                case "chat.memberleave":
                    return memberLeave(state, action.detail);
                case "chat.systemmessage":
                    // Add the system message to the chat
                    appendMessageToState(newState, action.detail);
                    return newState;
                case "chat.systemmessagedismiss":
                    // Remove system message(s) with the specified id
                    var dismissId_1 = action.detail.id;
                    return __assign$1(__assign$1({}, newState), { chats: newState.chats.filter(function (chat) {
                            // Keep all non-system messages, and system messages that don't match the id
                            if (isChatSystemMessage(chat)) {
                                return chat.id !== dismissId_1;
                            }
                            return true;
                        }) });
                case "chat.queue.position":
                    newState.queuePosition = action.detail.queuePosition;
                    return newState;
                case "chat.request.rating":
                    appendMessageToState(newState, action.detail);
                    return __assign$1(__assign$1({}, newState), { lastRatingRequestTimestamp: action.detail.timestamp });
                case "chat.rating":
                    appendMessageToState(newState, action.detail);
                    return __assign$1(__assign$1({}, newState), { hasRating: !!action.detail.newRating });
                case "chat.file":
                case "chat.msg":
                    appendMessageToState(newState, action.detail);
                    var detail = action.detail;
                    var msg = detail.type === "chat.msg" ? detail.msg : null;
                    newState.chips = ((_u = msg === null || msg === void 0 ? void 0 : msg.options) === null || _u === void 0 ? void 0 : _u.length) ? msg.options : [];
                    return newState;
                case "chat.failureMsg":
                    var agentDetails = newState.agents[action.detail.user.nick];
                    var oldFailureMsg_1;
                    var retry_1 = action.detail.failureMsg.retry;
                    var finalState = newState;
                    if (retry_1 !== 1) {
                        oldFailureMsg_1 = newState.chats.filter(function (item) {
                            return item.type === "chat.failureMsg" && item.failureMsg.retry < retry_1;
                        })[0];
                        var clearedChats = newState.chats.filter(function (item) {
                            return item !== oldFailureMsg_1;
                        });
                        finalState = __assign$1(__assign$1({}, newState), { chats: clearedChats });
                    }
                    appendMessageToState(finalState, action.detail);
                    return __assign$1(__assign$1({}, finalState), { agents: __assign$1(__assign$1({}, finalState.agents), (_c = {}, _c[action.detail.user.nick] = __assign$1(__assign$1({}, agentDetails), { typing: false, requestFailed: true }), _c)), failureMsg: action.detail.failureMsg });
                case "chat.typing":
                    var agent = state.agents[action.detail.user.nick];
                    return __assign$1(__assign$1({}, state), { lastTimestamp: (_v = action.detail) === null || _v === void 0 ? void 0 : _v.timestamp, agents: __assign$1(__assign$1({}, state.agents), (_d = {}, _d[action.detail.user.nick] = __assign$1(__assign$1({}, agent), { typing: action.detail.typing }), _d)) });
                case "chat.stream.start":
                    // Add placeholder message with streaming state
                    var streamingMsg = {
                        type: "chat.msg",
                        user: action.detail.user,
                        timestamp: action.detail.timestamp,
                        msg: {
                            text: "",
                        },
                        isStreaming: true,
                    };
                    return __assign$1(__assign$1({}, newState), { chats: __spreadArray$1(__spreadArray$1([], newState.chats, true), [streamingMsg], false), streamingMessageId: action.detail.messageId });
                case "chat.stream.chunk": {
                    // Find the streaming message by ID and append text
                    var chunkDetail = action.detail;
                    if (state.streamingMessageId === chunkDetail.messageId) {
                        // Find the streaming message by ID (not by index - other messages could be inserted)
                        var streamingIndex_1 = state.chats.findIndex(function (chat) { return isChatMsgDetail(chat) && chat.isStreaming; });
                        if (streamingIndex_1 >= 0) {
                            var chunkText_1 = chunkDetail.text;
                            return __assign$1(__assign$1({}, state), { lastTimestamp: chunkDetail === null || chunkDetail === void 0 ? void 0 : chunkDetail.timestamp, chats: state.chats.map(function (chat, index) {
                                    var _a;
                                    if (index === streamingIndex_1 && isChatMsgDetail(chat)) {
                                        return __assign$1(__assign$1({}, chat), { msg: __assign$1(__assign$1({}, chat.msg), { text: (((_a = chat.msg) === null || _a === void 0 ? void 0 : _a.text) || "") + chunkText_1 }) });
                                    }
                                    return chat;
                                }) });
                        }
                    }
                    return state;
                }
                case "chat.stream.tool_start": {
                    // Add tool call to the streaming message (in-progress state)
                    log$3("Tool execution started: ".concat(action.detail.toolName));
                    var toolStartDetail_1 = action.detail;
                    if (state.streamingMessageId === toolStartDetail_1.messageId) {
                        // Find the streaming message by ID (not by index - other messages could be inserted)
                        var streamingIndex_2 = state.chats.findIndex(function (chat) { return isChatMsgDetail(chat) && chat.isStreaming; });
                        if (streamingIndex_2 >= 0) {
                            return __assign$1(__assign$1({}, state), { lastTimestamp: toolStartDetail_1.timestamp, chats: state.chats.map(function (chat, index) {
                                    if (index === streamingIndex_2 && isChatMsgDetail(chat)) {
                                        var existingToolCalls = chat.toolCalls || [];
                                        return __assign$1(__assign$1({}, chat), { toolCalls: __spreadArray$1(__spreadArray$1([], existingToolCalls, true), [
                                                {
                                                    name: toolStartDetail_1.toolName,
                                                    toolCallId: toolStartDetail_1.toolCallId,
                                                    displayName: toolStartDetail_1.displayName,
                                                    label: toolStartDetail_1.label,
                                                    hidden: toolStartDetail_1.hidden,
                                                    input: toolStartDetail_1.toolInput,
                                                    startTime: toolStartDetail_1.timestamp,
                                                    isExecuting: true,
                                                },
                                            ], false) });
                                    }
                                    return chat;
                                }) });
                        }
                    }
                    return state;
                }
                case "chat.stream.tool_end": {
                    // Update tool call with result in the streaming message
                    log$3("Tool execution ended: ".concat(action.detail.toolName));
                    var toolEndDetail_1 = action.detail;
                    if (state.streamingMessageId === toolEndDetail_1.messageId) {
                        // Find the streaming message by ID (not by index - other messages could be inserted)
                        var streamingIndex_3 = state.chats.findIndex(function (chat) { return isChatMsgDetail(chat) && chat.isStreaming; });
                        if (streamingIndex_3 >= 0) {
                            return __assign$1(__assign$1({}, state), { lastTimestamp: toolEndDetail_1.timestamp, chats: state.chats.map(function (chat, index) {
                                    var _a;
                                    if (index === streamingIndex_3 && isChatMsgDetail(chat)) {
                                        var toolCalls = (_a = chat.toolCalls) === null || _a === void 0 ? void 0 : _a.map(function (tc) {
                                            var _a;
                                            // Match by toolCallId if available, otherwise fall back to name + isExecuting
                                            var isMatch = toolEndDetail_1.toolCallId
                                                ? tc.toolCallId === toolEndDetail_1.toolCallId
                                                : tc.name === toolEndDetail_1.toolName && tc.isExecuting;
                                            if (isMatch) {
                                                return __assign$1(__assign$1({}, tc), { displayName: toolEndDetail_1.displayName || tc.displayName, label: toolEndDetail_1.label, hidden: (_a = toolEndDetail_1.hidden) !== null && _a !== void 0 ? _a : tc.hidden, result: toolEndDetail_1.toolResult, error: toolEndDetail_1.toolError, endTime: toolEndDetail_1.timestamp, isExecuting: false });
                                            }
                                            return tc;
                                        });
                                        return __assign$1(__assign$1({}, chat), { toolCalls: toolCalls });
                                    }
                                    return chat;
                                }) });
                        }
                    }
                    return state;
                }
                case "chat.stream.end": {
                    // Finalize the streaming message
                    var endDetail = action.detail;
                    if (state.streamingMessageId === endDetail.messageId) {
                        // Find the streaming message by ID (not by index - other messages could be inserted)
                        var streamingIndex_4 = state.chats.findIndex(function (chat) { return isChatMsgDetail(chat) && chat.isStreaming; });
                        var endStreamingChat = streamingIndex_4 >= 0 ? state.chats[streamingIndex_4] : undefined;
                        // Verify it's the right message using type guard
                        if (streamingIndex_4 >= 0 && endStreamingChat && isChatMsgDetail(endStreamingChat)) {
                            var finalMsg_1 = endDetail.msg;
                            // Preserve tool calls from either the action or the existing message
                            var toolCalls_1 = endDetail.toolCalls || endStreamingChat.toolCalls;
                            // Update chips from message options (same as chat.msg handler)
                            var chips = ((_w = finalMsg_1 === null || finalMsg_1 === void 0 ? void 0 : finalMsg_1.options) === null || _w === void 0 ? void 0 : _w.length) ? finalMsg_1.options : [];
                            return __assign$1(__assign$1({}, state), { lastTimestamp: endDetail === null || endDetail === void 0 ? void 0 : endDetail.timestamp, streamingMessageId: undefined, chips: chips, chats: state.chats.map(function (chat, index) {
                                    if (index === streamingIndex_4 && isChatMsgDetail(chat)) {
                                        return __assign$1(__assign$1({}, chat), { msg: finalMsg_1, isStreaming: false, wasStreamed: true, toolCalls: toolCalls_1 });
                                    }
                                    return chat;
                                }) });
                        }
                    }
                    return state;
                }
                default:
                    return state;
            }
        default:
            log$3("Unhandled redux action: ", action.type);
            return state;
    }
}
function mapSynthetic(state, action) {
    var _a;
    if (state === void 0) { state = DEFAULT_STATE; }
    var newTimestamp = (((_a = action.detail) === null || _a === void 0 ? void 0 : _a.timestamp) || +new Date()) + 1; // state.lastTimestamp + 1;
    switch (action.detail.type) {
        case "write_msg":
            return {
                type: "chat",
                detail: {
                    type: "chat.msg",
                    user: action.detail.user,
                    timestamp: newTimestamp,
                    msg: action.detail.msg
                }
            };
        case "visitor.send.file":
            return {
                type: "chat",
                detail: {
                    type: "chat.file",
                    user: {
                        displayName: state.visitor.displayName,
                        nick: "visitor:",
                    },
                    timestamp: newTimestamp,
                    attachment: action.detail.attachment
                }
            };
        default:
            throw new Error("Unknown synthetic action. Detail type: ".concat((action.detail).type));
    }
}
function storeHandler(state, action) {
    if (state === void 0) { state = DEFAULT_STATE; }
    if (action.type === "synthetic") {
        log$3("synthetic action", action); // simulated action by the app
        var new_action = mapSynthetic(state, action);
        return update(state, new_action);
    }
    else {
        return update(state, action);
    }
}

var ADMIN_STORE_KEY = "AdminAccessTimes";
var ADMIN_STORE_MAX = 20;
function createChatStore(config, dataStorage) {
    var _a;
    if (!dataStorage) {
        if (typeof window !== "undefined") {
            dataStorage = localStorage;
        }
        else {
            dataStorage = new LocalStorage();
        }
    }
    var connection = config.connection;
    var joinSessionId = (_a = new URL(window.location.href).searchParams) === null || _a === void 0 ? void 0 : _a.get("sessionId");
    var dataStorageKey;
    var now = new Date().getTime();
    if (joinSessionId) {
        var adminTimesData = dataStorage.getItem(ADMIN_STORE_KEY);
        var adminTimes = adminTimesData ? JSON.parse(adminTimesData) : {};
        if (adminTimes[joinSessionId]) {
            log$3("ChatStore: reusing session: ".concat(joinSessionId));
            adminTimes[joinSessionId].lastAccessMs = now;
            dataStorageKey = adminTimes[joinSessionId].dataStorageKey;
        }
        else {
            if (Object.keys(adminTimes).length >= ADMIN_STORE_MAX) {
                var evictedSessionId = evictAdminSession(adminTimes);
                log$3("ChatStore: evicting session: ".concat(evictedSessionId));
                dataStorage.removeItem(adminTimes[evictedSessionId].dataStorageKey);
                adminTimes[evictedSessionId] = undefined;
            }
            dataStorageKey = generateKey(connection, joinSessionId);
            adminTimes[joinSessionId] = {
                lastAccessMs: now,
                dataStorageKey: dataStorageKey,
            };
        }
        dataStorage.setItem(ADMIN_STORE_KEY, JSON.stringify(adminTimes));
    }
    else {
        dataStorageKey = generateKey(connection);
    }
    var storage = new BrowserStateStorage(dataStorage, dataStorageKey);
    var defaultState = createDefaultState$1({
        accessToken: config.accessToken,
        userId: config.userId,
        attributes: config.attributes,
        sessionExpiration: config.sessionExpiration
    }, {
        enableErrorOverlay: config.enableErrorOverlay
    });
    var chatReducer = persistStateReducer(storage, defaultState, storeHandler);
    // Configure store with @reduxjs/toolkit
    var store = configureStore({
        reducer: chatReducer,
        middleware: function (getDefaultMiddleware) {
            return getDefaultMiddleware({
                thunk: true,
            });
        },
        devTools: "production" !== 'production', // Include dev tools in non-production environments
    });
    return store;
}
function evictAdminSession(adminTimes) {
    var minTimeTs = Number.MAX_VALUE;
    var minSessionId;
    for (var _i = 0, _a = Object.keys(adminTimes); _i < _a.length; _i++) {
        var sessionId = _a[_i];
        if (adminTimes[sessionId].lastAccessMs < minTimeTs) {
            minSessionId = sessionId;
            minTimeTs = adminTimes[sessionId].lastAccessMs;
        }
    }
    return minSessionId;
}
function generateKey(connection, sessionId) {
    var base = "xappchat.".concat(connection.serverUrl);
    if (sessionId) {
        return connection.accountKey
            ? "".concat(base, ".").concat(connection.accountKey, ".").concat(sessionId)
            : "".concat(base, ".").concat(sessionId);
    }
    else {
        return connection.accountKey ? "".concat(base, ".").concat(connection.accountKey) : base;
    }
}

/**
 * Preview mode container - skips server config and store creation.
 */
var ChatWidgetPreviewContainer = function (props) {
    var messageMiddleware = useStandardMiddleware();
    var widgetProps = __assign$1(__assign$1({}, props), { messageMiddleware: messageMiddleware });
    return require$$0.jsx(ChatWidgetWrapper, __assign$1({}, widgetProps));
};
/**
 * Connected mode container - creates store and connects to server.
 */
var ChatWidgetConnectedContainer = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var messageMiddleware = useStandardMiddleware();
    var connection = useServerConfig(props.config);
    var chatStore = require$$1.useMemo(function () {
        var _a, _b, _c, _d, _e;
        return createChatStore({
            connection: connection,
            userId: (_a = props.config) === null || _a === void 0 ? void 0 : _a.userId,
            accessToken: (_b = props.config) === null || _b === void 0 ? void 0 : _b.accessToken,
            attributes: (_c = props.config) === null || _c === void 0 ? void 0 : _c.attributes,
            sessionExpiration: (_d = props.config) === null || _d === void 0 ? void 0 : _d.sessionExpiration,
            enableErrorOverlay: (_e = props.config) === null || _e === void 0 ? void 0 : _e.enableErrorOverlay
        });
    }, [connection, (_a = props.config) === null || _a === void 0 ? void 0 : _a.userId, (_b = props.config) === null || _b === void 0 ? void 0 : _b.accessToken, (_c = props.config) === null || _c === void 0 ? void 0 : _c.attributes, (_d = props.config) === null || _d === void 0 ? void 0 : _d.sessionExpiration, (_e = props.config) === null || _e === void 0 ? void 0 : _e.enableErrorOverlay]);
    if ((_f = props.config) === null || _f === void 0 ? void 0 : _f.disabled) {
        return require$$0.jsx(require$$0.Fragment, {});
    }
    var widgetProps = __assign$1(__assign$1({}, props), { messageMiddleware: messageMiddleware, getConfig: props.getConfig // Pass through getConfig callback
     });
    return (require$$0.jsx(reactRedux.Provider, { store: chatStore, children: require$$0.jsx(ChatWidgetWrapper, __assign$1({}, widgetProps)) }));
};
/**
 * Top-level container that dispatches between preview and connected modes.
 */
var ChatWidgetContainer = function (props) {
    var _a;
    var rawMode = (_a = props.mode) !== null && _a !== void 0 ? _a : "normal";
    // Support both `preview` prop and legacy `mode="preview"`
    var isPreviewMode = props.preview === true || rawMode === "preview";
    if (isPreviewMode) {
        return require$$0.jsx(ChatWidgetPreviewContainer, __assign$1({}, props));
    }
    return require$$0.jsx(ChatWidgetConnectedContainer, __assign$1({}, props));
};
var Chat = ChatWidgetContainer;
lib$5.isActionBarChatButton;
lib$5.isActionBarFormButton;
lib$5.isActionBarPhoneButton;
lib$5.isActionBarUrlButton;

var css_248z$1l = "@import\"https://fonts.googleapis.com/css2?family=Overpass:wght@300;400;500;600;700&display=swap\";@font-face{font-family:OpenSansSemibold;font-style:normal;font-weight:600;font-display:swap;src:local(\"Open Sans SemiBold\"),local(\"OpenSans-SemiBold\"),url(https://fonts.gstatic.com/s/opensans/v17/mem5YaGs126MiZpBA-UNirkOUuhpKKSTjw.woff2) format(\"woff2\")}@font-face{font-family:RobotoRegular;font-style:normal;font-weight:400;font-display:swap;src:local(\"Roboto\"),local(\"Roboto-Regular\"),url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2) format(\"woff2\")}@font-face{font-family:RobotoMedium;font-style:oblique;font-weight:500;font-display:swap;src:local(\"Roboto Medium\"),local(\"Roboto-Medium\"),url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fBBc4AMP6lQ.woff2) format(\"woff2\")}.index_widget-container__0QIg1{background:#fff;display:flex;flex-flow:column nowrap;width:100%;height:100%;visibility:hidden;font-family:RobotoRegular,serif;box-shadow:var(--xapp-widget-box-shadow, 0 4px 24px rgba(0, 0, 0, 0.12));overflow:hidden;border-radius:var(--xapp-widget-border-radius, 20px);border:var(--xapp-widget-border-width, 0px) solid var(--xapp-widget-border-color, var(--xapp-primary-color, #616161));box-sizing:border-box}.index_widget-container__0QIg1 *,.index_widget-container__0QIg1 *:before,.index_widget-container__0QIg1 *:after{box-sizing:border-box}.index_widget-container--normal__hBfGA,.index_widget-container--static__NUYE4{position:fixed;z-index:var(--xapp-widget-z-index, 1000);right:var(--xapp-widget-margin-right, 10px);bottom:var(--xapp-widget-margin-bottom, 10px)}.index_widget-container--normal__hBfGA.index_visible__UmVNQ,.index_widget-container--static__NUYE4.index_visible__UmVNQ{width:min(var(--xapp-widget-width, 400px),100vw - var(--xapp-widget-margin-left, 10px) - var(--xapp-widget-margin-right, 10px));height:min(var(--xapp-widget-height, 500px),100vh - var(--xapp-widget-margin-top, 10px) - var(--xapp-widget-margin-bottom, 10px));height:min(var(--xapp-widget-height, 500px),100dvh - var(--xapp-widget-margin-top, 10px) - var(--xapp-widget-margin-bottom, 10px))}.index_widget-container--with-action-bar__if7vb.index_widget-container--normal__hBfGA,.index_widget-container--with-action-bar__if7vb.index_widget-container--static__NUYE4{bottom:calc(var(--xapp-widget-margin-bottom, 10px) + var(--xapp-action-bar-height, 80px))}.index_widget-container--with-action-bar__if7vb.index_widget-container--normal__hBfGA.index_visible__UmVNQ,.index_widget-container--with-action-bar__if7vb.index_widget-container--static__NUYE4.index_visible__UmVNQ{height:min(var(--xapp-widget-height, 500px),100vh - var(--xapp-widget-margin-top, 10px) - var(--xapp-widget-margin-bottom, 10px) - var(--xapp-action-bar-height, 80px));height:min(var(--xapp-widget-height, 500px),100dvh - var(--xapp-widget-margin-top, 10px) - var(--xapp-widget-margin-bottom, 10px) - var(--xapp-action-bar-height, 80px))}.index_widget-container--docked__ENUcn{position:relative;width:100%;height:100%;border-radius:0;visibility:visible !important;animation:none !important}.index_widget-container--docked__ENUcn .index_xa-spinner-container__DX1eZ{z-index:1}.index_widget-container__0QIg1:not(.index_visible__UmVNQ){animation:index_widget-hide__rznU- .3s ease-out forwards;pointer-events:none;width:min(var(--xapp-widget-width, 400px),100vw - var(--xapp-widget-margin-left, 10px) - var(--xapp-widget-margin-right, 10px));height:min(var(--xapp-widget-height, 500px),100dvh - var(--xapp-widget-margin-top, 10px) - var(--xapp-widget-margin-bottom, 10px))}.index_widget-container__0QIg1.index_visible__UmVNQ{animation:index_widget-show__UV4hy .3s ease-out forwards}.index_widget-container--with-action-bar__if7vb:not(.index_visible__UmVNQ){pointer-events:none;width:min(var(--xapp-widget-width, 400px),100vw - var(--xapp-widget-margin-left, 10px) - var(--xapp-widget-margin-right, 10px));height:min(var(--xapp-widget-height, 500px),100dvh - var(--xapp-widget-margin-top, 10px) - var(--xapp-widget-margin-bottom, 10px) - var(--xapp-action-bar-height, 80px))}.index_widget-container--docked__ENUcn:not(.index_visible__UmVNQ),.index_widget-container--docked__ENUcn.index_visible__UmVNQ{animation:none !important}.index_widget-container--initial-hidden__2IN2-{animation:none !important;visibility:hidden !important}.index_widget-container--loading__SKMGy{display:flex;align-items:center;justify-content:center;background:#fff}.index_widget-container--loading__SKMGy.index_widget-container--docked__ENUcn{width:100%;height:100%}.index_widget-container--error__5sYVe{display:flex;align-items:center;justify-content:center;background:#fff5f5;padding:20px}.index_widget-container--error__5sYVe.index_widget-container--docked__ENUcn{width:100%;height:100%}.index_widget-error-message__XAw-1{color:#dc3545;font-size:14px;line-height:1.5;text-align:center;padding:20px;background:#fff;border:2px solid #dc3545;border-radius:8px;max-width:400px;box-shadow:0 2px 8px rgba(220,53,69,.1)}.index_widget-error-message__XAw-1::before{content:\"⚠️\";display:block;font-size:32px;margin-bottom:12px}.index_widget-container--loading__SKMGy .index_xa-spinner-container__DX1eZ{position:relative}.index_widget-container--loading__SKMGy.index_widget-container--docked__ENUcn .index_xa-spinner-container__DX1eZ{z-index:1}.index_message-svg__NzuSc path{fill:var(--xapp-primary-color, #616161)}.index_chat-msg__Ty0Wl{line-height:20px;font-size:14px;margin-left:48px;max-width:var(--xapp-messages-max-width, calc(100% - 48px))}.index_chat-msg--expand__XesjL{max-width:calc(100% - 48px);width:calc(100% - 48px)}.index_chat-msg__fullwidth__DkGuw{max-width:100%;width:100%}.index_chat-msg--no-ava__MdRR-{margin-left:0}.index_chat-typing-progress__UJ4Ey .index_chat-msg__Ty0Wl{color:#30375b}.index_visitor__CairL .index_chat-text-container__2dhZR{padding-right:20px}.index_chat-media-container__A-gkq{border-radius:8px;border:1px solid #ddd;overflow:hidden}.index_chat-img__cK-vh{min-width:180px;min-height:120px;background-position:center;background-size:cover}.index_ts-msg-container__8Km64{text-align:center}.index_ts-msg__p2RGq{font-size:12px;color:#bfbfbf}.index_system-msg-container__xY4q1{text-align:center;margin:8px 0;padding:4px 0}.index_system-msg__0d5vQ{font-size:14px;color:#bfbfbf}.index_system-msg-divider__sHhPD{position:relative;margin:20px 0 10px 0;display:flex;align-items:center;justify-content:center;gap:0}.index_system-msg-divider__sHhPD .index_divider-line__Am-FC{flex:1;height:1px;background-color:#e0e0e0}.index_system-msg-divider__sHhPD .index_divider-avatar__ZgkZJ{display:flex;align-items:center;justify-content:center}.index_system-msg-divider__sHhPD .index_divider-avatar__ZgkZJ img{width:32px;height:32px;border-radius:50%;object-fit:cover}.index_chat-rating-card__RX0ou{padding-bottom:16px;text-align:center}.index_buttons-container__ZnyxK{display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;width:100%}.index_buttons-container__ZnyxK .index_button__UbuXS{flex-grow:1}.index_buttons-container__ZnyxK .index_button__UbuXS:not(:last-child){margin-right:8px}.index_buttons-container__ZnyxK .index_button-card__z8WrF{flex-grow:0}.index_buttons-container__ZnyxK .index_button-card__z8WrF:not(:last-child){margin-right:8px}@keyframes index_widget-show__UV4hy{from{visibility:visible;transform:translateY(100%)}to{visibility:visible;transform:translateY(0)}}@keyframes index_widget-hide__rznU-{from{visibility:visible;transform:translateY(0)}to{visibility:hidden;transform:translateY(100%)}}@keyframes index_widget-show-grow__vvc0Y{0%{visibility:hidden;opacity:0}1%{visibility:visible;opacity:0;transform:scale(0.5)}100%{visibility:visible;opacity:1;transform:scale(1)}}@keyframes index_widget-hide-shrink__bhO10{0%{visibility:visible;opacity:1;transform:scale(1)}99%{visibility:visible;opacity:0;transform:scale(0.5)}100%{visibility:hidden;opacity:0}}.index_xa-spinner-container__DX1eZ{z-index:var(--xapp-widget-z-index, 1000);position:absolute;width:100%;height:100%;display:flex;align-items:center;background:#fff;transition:visibility 500ms,opacity 500ms;visibility:hidden;opacity:0;top:0 !important;left:0 !important}.index_xa-spinner-container__DX1eZ.index_visible__UmVNQ{visibility:visible;opacity:1}.index_xa-spinner__4waUR{width:40px;height:40px;margin:100px auto;background-color:var(--xapp-primary-color, #616161);border-radius:100%;-webkit-animation:index_sk-scaleout__G2sKM 1s infinite ease-in-out;animation:index_sk-scaleout__G2sKM 1s infinite ease-in-out}.index_xa-chevron__oJbgj{width:100%;height:100%;background:unset;border:unset;padding:unset}@-webkit-keyframes index_sk-scaleout__G2sKM{0%{transform:scale(0)}100%{transform:scale(1);opacity:0}}@keyframes index_sk-scaleout__G2sKM{0%{transform:scale(0)}100%{transform:scale(1);opacity:0}}@media screen and (max-width: 640px){.index_xa-chevron__oJbgj{height:44px;height:44px}}.index_restartModal__GuFlb{display:none;position:fixed;z-index:100;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:#000;background-color:rgba(0,0,0,.4);-webkit-animation-name:index_fadeIn__4DJGW;-webkit-animation-duration:.4s;animation-name:index_fadeIn__4DJGW;animation-duration:.4s}.index_modalContent__juNOp{border-radius:20px;box-shadow:rgba(100,100,111,.2) 0px 7px 29px 0px;position:fixed;bottom:-10px;z-index:200;padding:20px;background-color:#fff;width:100%;-webkit-animation-name:index_slideIn__IQfok;-webkit-animation-duration:.4s;animation-name:index_slideIn__IQfok;animation-duration:.4s}.index_modalBody__leHFH h2{color:#027db6;text-align:center;font-weight:700}.index_modalBody__leHFH p{color:rgba(98,98,98,.6666666667)}.index_modalActions__ak57i{margin:25px 0;justify-content:center;display:flex;gap:1em}.index_modalActions__ak57i button{padding:10px 20px;border-radius:10px;transition:all .5s;cursor:pointer}.index_modalActions__ak57i button:hover{opacity:.7}.index_modalActions__ak57i .index_cancelBtn__ARPM2{color:#027db6;border:solid 1px #027db6;background:rgba(0,0,0,0)}.index_modalActions__ak57i .index_restartBtn__HKXGp{background:#027db6;color:#fff;border:none}@-webkit-keyframes index_slideIn__IQfok{from{bottom:-300px;opacity:0}to{bottom:-10px;opacity:1}}@keyframes index_slideIn__IQfok{from{bottom:-300px;opacity:0}to{bottom:-10px;opacity:1}}@-webkit-keyframes index_fadeIn__4DJGW{from{opacity:0}to{opacity:1}}@keyframes index_fadeIn__4DJGW{from{opacity:0}to{opacity:1}}@keyframes index_action-bar-show__6ZrFY{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}@keyframes index_action-bar-hide__TBdA-{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(20px);visibility:hidden}}.index_xapp-action-bar__zH1IF{position:fixed;bottom:0;z-index:var(--xapp-widget-z-index, 1000);display:flex;align-items:center;justify-content:center;background:var(--xapp-action-bar-background, #ffffff);box-shadow:var(--xapp-action-bar-box-shadow, 0 2px 12px rgba(0, 0, 0, 0.15));padding-top:var(--xapp-action-bar-padding-top, 8px);padding-right:var(--xapp-action-bar-padding-right, 16px);padding-bottom:var(--xapp-action-bar-padding-bottom, 8px);padding-left:var(--xapp-action-bar-padding-left, 16px);gap:var(--xapp-action-bar-button-gap, 8px);animation:index_action-bar-show__6ZrFY .3s ease-out}.index_xapp-action-bar--hidden__2tlRh{animation:index_action-bar-hide__TBdA- .3s forwards}.index_xapp-action-bar__buttons__mkmep{display:flex;align-items:center;justify-content:center;gap:var(--xapp-action-bar-button-gap, 8px)}.index_xapp-action-bar--desktop__pI1dm{border-radius:var(--xapp-action-bar-border-radius, 24px) var(--xapp-action-bar-border-radius, 24px) 0 0;margin:0}.index_xapp-action-bar--desktop__pI1dm.index_xapp-action-bar--left__UXSPU{left:0;right:auto;margin-left:var(--xapp-widget-margin-left, 10px)}.index_xapp-action-bar--desktop__pI1dm.index_xapp-action-bar--center__-k6b1{left:50%;transform:translateX(-50%)}.index_xapp-action-bar--desktop__pI1dm.index_xapp-action-bar--right__fuoTg{right:var(--xapp-widget-margin-right, 10px);left:auto}.index_xapp-action-bar--mobile__ZYOay{left:0;right:0;border-radius:0;justify-content:space-evenly;padding:8px 0;padding-bottom:max(8px,env(safe-area-inset-bottom));margin:0}.index_xapp-action-bar--mobile__ZYOay .index_xapp-action-bar__buttons__mkmep{justify-content:space-evenly;width:100%}.index_xapp-action-bar__button__-0rhy{display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:var(--xapp-action-bar-button-background, transparent) !important;border:none;border-radius:var(--xapp-action-bar-button-border-radius, 12px);padding-top:var(--xapp-action-bar-button-padding-top, 8px);padding-right:var(--xapp-action-bar-button-padding-right, 12px);padding-bottom:var(--xapp-action-bar-button-padding-bottom, 8px);padding-left:var(--xapp-action-bar-button-padding-left, 12px);cursor:pointer;transition:background-color .2s ease,transform .1s ease;min-width:48px;min-height:48px}.index_xapp-action-bar__button__-0rhy:hover{background-color:var(--xapp-action-bar-button-hover-background, rgba(0, 0, 0, 0.05)) !important}.index_xapp-action-bar__button__-0rhy:focus-visible{outline:2px solid var(--xapp-primary-color, #0075aa);outline-offset:2px}.index_xapp-action-bar__button__-0rhy:active{transform:scale(0.95)}.index_xapp-action-bar__button--active__Cz0lc{background-color:var(--xapp-action-bar-button-active-background, rgba(0, 117, 170, 0.15)) !important}.index_xapp-action-bar__button--active__Cz0lc .index_xapp-action-bar__icon__W7fRu{color:var(--xapp-action-bar-button-active-icon-color, var(--xapp-primary-color, #0075aa))}.index_xapp-action-bar__button--active__Cz0lc .index_xapp-action-bar__label__rQUwV{color:var(--xapp-action-bar-button-active-label-color, var(--xapp-primary-color, #0075aa));font-weight:500}.index_xapp-action-bar__button--active__Cz0lc:hover{background-color:var(--xapp-action-bar-button-active-hover-background, rgba(0, 117, 170, 0.25)) !important}.index_xapp-action-bar__icon__W7fRu{width:var(--xapp-action-bar-button-icon-width, 24px);height:var(--xapp-action-bar-button-icon-height, 24px);display:flex;align-items:center;justify-content:center;color:var(--xapp-action-bar-button-icon-color, var(--xapp-primary-color, #0075aa))}.index_xapp-action-bar__icon__W7fRu svg{width:100%;height:100%;fill:currentColor}.index_xapp-action-bar__icon__W7fRu img{width:100%;height:100%;object-fit:contain}.index_xapp-action-bar__label__rQUwV{margin-top:4px;font-family:var(--xapp-action-bar-label-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-action-bar-label-font-weight, normal);font-size:var(--xapp-action-bar-label-font-size, 12px);font-style:var(--xapp-action-bar-label-font-style, normal);color:var(--xapp-action-bar-label-color, #333333);white-space:nowrap}@media(max-width: 768px){.index_xapp-action-bar--mobile__ZYOay~#index_xapp-form-widget__W-qI5 [data-xapp-form-side-button],#index_xapp-form-widget__W-qI5:has(~.index_xapp-action-bar--mobile__ZYOay) [data-xapp-form-side-button]{display:none !important}}@media(max-width: 768px){body[data-xapp-action-bar-enabled=true] [data-xapp-form-side-button]{display:none !important}}@media(prefers-reduced-motion: reduce){.index_xapp-action-bar__zH1IF{animation:none}.index_xapp-action-bar--hidden__2tlRh{animation:none;opacity:0;visibility:hidden}.index_xapp-action-bar__button__-0rhy{transition:none}.index_xapp-action-bar__button__-0rhy:active{transform:none}}.index_action-button__W8QMQ{border:1px solid #ddd;border-radius:4px;text-align:center;opacity:1;outline:none;font-size:14px;padding:8px;text-align:center}.index_action-button__W8QMQ:hover{opacity:.8;cursor:pointer}.index_action-button__W8QMQ:focus-visible{outline:none;filter:invert(100%)}@media screen and (max-width: 640px){.index_action-button__W8QMQ{box-sizing:border-box;height:44px}}.index_avatar__kOeGd{border-radius:20px;color:#fff;background-color:#fff;background-position:center;background-size:cover;background-repeat:no-repeat;width:100%;height:100%;position:relative}.index_avatar--agent__S-KTv{background-color:var(--xapp-header-avatar-background, #ffffff)}.index_avatar--visitor__GG8MZ{background-color:var(--xapp-primary-color, #616161);display:flex;align-items:center;height:100%}.index_avatar--empty__x4lM1{background-color:rgba(0,0,0,0) !important}.index_avatar__ai-badge__vazhb{position:absolute;bottom:-2px;right:-4px;background:linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);color:#fff;font-size:8px;font-weight:700;padding:1px 4px;border-radius:6px;line-height:1.2;letter-spacing:.3px;box-shadow:0 1px 2px rgba(0,0,0,.2);border:1px solid hsla(0,0%,100%,.3)}.index_xappw-carousel__WJWI7{display:flex;flex-flow:row nowrap;align-items:center;justify-content:center}.index_xappw-carousel__prev__-yS5y,.index_xappw-carousel__next__CIGFb{flex:0 0 48px;height:30px;cursor:pointer}.index_xappw-carousel__prev__-yS5y svg,.index_xappw-carousel__next__CIGFb svg{display:block;margin:auto;height:100%}.index_xappw-carousel-items__HvPBK{display:flex;position:relative;height:auto;align-items:stretch;white-space:nowrap;overflow-x:hidden;overflow-y:hidden}@media(hover: none)and (pointer: coarse){.index_xappw-carousel-items__HvPBK{overflow-x:auto}}.index_xappw-carousel-items__HvPBK{scroll-behavior:smooth;-ms-overflow-style:none;-moz-overflow-style:none;-webkit-overflow-scrolling:touch}.index_xappw-carousel-items__item__yB-Ut{display:inline-flex;flex-direction:column;padding-right:10px;flex-shrink:0}.index_xappw-carousel-items__item__yB-Ut:last-child{padding-right:0}@media(max-width: 640px){.index_xappw-carousel-items__item__yB-Ut{min-width:100%}}.index_xappw-carousel-items--one-item__s8gvS{margin-left:48px}.index_chat-list-item__wGnh5{display:flex;flex-direction:column;align-items:flex-start;min-width:220px;min-height:120px;flex:1 1 auto;border:solid 1px #ccc;border-radius:12px}.index_chat-list-item-container__M2Nvr{display:flex;flex-direction:column;flex:1 1 auto}.index_chat-list-item__img__G-fpL{border-radius:12px 12px 0 0;width:100%;height:120px;overflow:hidden}.index_chat-list-item__title__p-HNU{text-align:left;font-family:var(--xapp-carousel-title-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-carousel-title-font-weight, bold);font-size:var(--xapp-carousel-title-font-size, 14px);font-style:var(--xapp-carousel-title-font-style, normal);color:var(--xapp-carousel-title-text-color, #000);line-height:1.3;padding:2px}.index_chat-list-item__title__p-HNU span{display:inline-block;white-space:pre-wrap}.index_chat-list-item__subtitle__MgGKu{text-align:left;font-family:var(--xapp-carousel-subtitle-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-carousel-subtitle-font-weight, normal);font-size:var(--xapp-carousel-subtitle-font-size, 12px);font-style:var(--xapp-carousel-subtitle-font-style, italic);color:var(--xapp-carousel-subtitle-text-color, #979797);line-height:1.3;max-width:200px;padding:2px}.index_chat-list-item__subtitle__MgGKu span{display:inline-block;white-space:pre-wrap}.index_chat-list-item__actions__NyqGP{margin-top:auto}.index_chat-list-item__wGnh5 .index_action-button__W8QMQ{display:inline-block;padding:0 10px;margin:3px;height:25px;font-size:12px;line-height:25px;border-radius:25px;background-color:var(--xapp-carousel-action-button-color, var(--xapp-primary-color, #616161));color:#d5d9e7;cursor:pointer}@keyframes index_wiggle__GLWgK{0%{transform:rotate(0deg)}25%{transform:rotate(5deg)}50%{transform:rotate(-5deg)}75%{transform:rotate(5deg)}100%{transform:rotate(0deg)}}@keyframes index_bounce__Zjq-s{0%,100%{transform:translateY(0)}50%{transform:translateY(-15px)}}@keyframes index_pulse__w3p7T{0%,100%{box-shadow:0 0 8px 0 rgba(0,0,0,.3),0 0 0 0 var(--xapp-chat-button-animation-primary-rgba, rgba(0, 117, 170, 0.75))}50%{box-shadow:0 0 8px 0 rgba(0,0,0,.3),0 0 8px 4px var(--xapp-chat-button-animation-primary-rgba, rgba(0, 117, 170, 0.75))}}.index_xapp-chat-button__VHFlW{position:fixed !important;bottom:0 !important;right:0 !important;top:inherit;cursor:pointer;margin-top:var(--xapp-chat-button-margin-top, var(--xapp-widget-margin-top, 16px));margin-right:var(--xapp-chat-button-margin-right, var(--xapp-widget-margin-right, 16px));margin-bottom:var(--xapp-chat-button-margin-bottom, var(--xapp-widget-margin-bottom, 16px));margin-left:var(--xapp-chat-button-margin-left, var(--xapp-widget-margin-left, 16px));display:block;overflow:visible !important;opacity:1;animation:index_widget-show-grow__vvc0Y .5s backwards;width:48px;height:48px;border-radius:24px;z-index:var(--xapp-widget-z-index, 1000);background-color:rgba(0,0,0,0) !important;padding:0;border-width:0px}.index_xapp-chat-button__VHFlW:focus,.index_xapp-chat-button__VHFlW:active{position:fixed !important;top:auto !important;bottom:0 !important;right:0 !important;background:rgba(0,0,0,0) !important;border:none !important;outline:none !important;box-shadow:none !important}.index_xapp-chat-button__VHFlW.index_visible__UmVNQ{animation:index_widget-hide-shrink__bhO10 .5s forwards}.index_xapp-chat-button__VHFlW:focus-visible{outline:none;box-shadow:0 0 4px 4px rgba(0,0,0,.3)}.index_xapp-chat-button__btn__P78Ya{position:absolute;width:48px;height:48px;border-radius:24px;background-color:var(--xapp-chat-button-background, var(--xapp-primary-color, #616161));box-shadow:0 0 8px 0 rgba(0,0,0,.3);bottom:0px !important;right:0px !important;top:0px !important;display:flex;align-items:center;justify-content:center}.index_xapp-chat-button__btn__P78Ya svg,.index_xapp-chat-button__btn__P78Ya img{display:block}.index_xapp-chat-button__btn__P78Ya svg{margin:auto;height:100%}.index_xapp-chat-button__btn__P78Ya img{width:var(--xapp-chat-button-image-width, 22px);height:var(--xapp-chat-button-image-height, 22px)}.index_xapp-chat-button__cta__lvHCQ{position:absolute;bottom:56px;right:24px;white-space:nowrap;font-size:16px;font-family:RobotoRegular,serif}.index_xapp-chat-button__VHFlW:hover{background:rgba(0,0,0,0) !important}.index_chat-card-container__ghj-9{border-radius:10px;position:relative;overflow:hidden;color:#fff;background:#f6f6f6}.index_chat-card-container__ghj-9 .index_chat-card-img__IPzGI{border-radius:0}.index_chat-card-container__img__VKrmc{min-width:220px;height:120px}.index_chat-card-container__ghj-9 .index_chat-card-title__HVu-h{padding:2px 10px;color:#2e375a;font-family:RobotoMedium,serif;font-size:12px;line-height:14px;font-weight:bold}.index_chat-card-container__ghj-9 .index_chat-card-title__HVu-h span{display:inline-block;white-space:pre-wrap}.index_chat-card-container__ghj-9 .index_chat-card-sub-title__9hQQb{padding:2px 10px;color:#2e375a;font-family:RobotoRegular,serif;font-size:10px;line-height:14px}.index_chat-card-container__ghj-9 .index_chat-card-sub-title__9hQQb span{display:inline-block;white-space:pre-wrap}.index_chat-card-container__ghj-9 .index_action-button__W8QMQ{display:inline-block;padding:0 10px;margin:3px;height:25px;font-size:12px;line-height:25px;border-radius:25px;background-color:var(--xapp-primary-color, #616161);color:#d5d9e7;cursor:pointer}.index_chat-card-container__ghj-9 .index_action-button__W8QMQ:focus-visible{outline:none;filter:invert(100%)}.index_chat-chip__Fd0Yg{display:inline-block;padding:0 10px;margin:3px;height:25px;font-size:12px;color:#2f385a;line-height:25px;border-radius:25px;border:thin solid #aeb3be;cursor:pointer;user-select:none}.index_chat-chip-link__7-aAp{text-decoration:underline}@media screen and (max-width: 640px){.index_chat-chip__Fd0Yg{min-height:44px;padding:8px}}.index_chat-chips__bE6fV{width:100%;overflow-x:auto;overflow-y:hidden;white-space:nowrap;box-sizing:border-box;margin:0 auto;padding:10px;scroll-behavior:smooth;-ms-overflow-style:none;-moz-overflow-style:none;-webkit-overflow-scrolling:touch}.index_chat-chips__bE6fV::-webkit-scrollbar{background-color:#fff;height:10px}.index_chat-chips__bE6fV::-webkit-scrollbar-track{background-color:#fff}.index_chat-chips__bE6fV::-webkit-scrollbar-button{display:none}.index_chat-chips__bE6fV::-webkit-scrollbar-thumb{background-color:#babac0;border-radius:10px;border:2.5px solid #fff}.index_status-container__9p6Da{display:flex;flex-flow:row nowrap;justify-content:space-between;padding-top:var(--xapp-header-padding-top, 0px);padding-right:var(--xapp-header-padding-right, 5px);padding-bottom:var(--xapp-header-padding-bottom, 0px);padding-left:var(--xapp-header-padding-left, 10px);box-sizing:border-box;z-index:100;line-height:40px;min-height:calc(40px + var(--xapp-header-padding-top, 0px) + var(--xapp-header-padding-bottom, 0px));flex-shrink:0;color:#fff;position:relative;width:100%;background:var(--xapp-header-background, var(--xapp-primary-color, #616161)) !important;border-bottom:solid var(--xapp-header-border-width, 0px) var(--xapp-header-border-color, var(--xapp-primary-color, #616161));align-items:center}.index_status-container__avatar__L-N7W{width:30px;height:30px}.index_status-container__avatar__L-N7W .index_avatar__kOeGd:not(.index_avatar--empty__x4lM1){background-color:var(--xapp-header-avatar-background, #ffffff)}.index_status-text__RJpcg{display:inline-flex;flex-direction:column;position:absolute;line-height:100%}.index_status-text-positionLeft__UWRfP{left:56px}.index_status-text-positionLeftNoAvatar__kwN87{left:8px}.index_status-text-positionWithMenu__c6Wc-{left:88px}.index_status-text-positionCenter__QtuWS{left:50%;transform:translateX(-50%);align-items:center}.index_status-text-title__u6Axy{font-family:var(--xapp-header-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-header-font-weight, normal);font-size:var(--xapp-header-font-size, 16px);font-style:var(--xapp-header-font-style, normal);color:var(--xapp-header-text-color, rgba(255, 255, 255, 0.87));font-family:var(--xapp-header-font-family, \"Overpass\", sans-serif);font-weight:var(--xapp-header-font-weight, 500)}.index_status-text-subtitle__-E7xi{margin-top:2px;font-family:var(--xapp-header-subtitle-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-header-subtitle-font-weight, normal);font-size:var(--xapp-header-subtitle-font-size, 10px);font-style:var(--xapp-header-subtitle-font-style, normal);color:var(--xapp-header-subtitle-text-color, rgba(255, 255, 255, 0.5));font-family:var(--xapp-header-subtitle-font-family, \"Overpass\", sans-serif);font-weight:var(--xapp-header-subtitle-font-weight, 400)}.index_xa-chat-menu-container__ex9SH{z-index:100}.index_background-header__1Y7l2 .index_status-container__9p6Da{background-color:#616161 !important}.index_no-avatar__cie8B{left:0px !important;color:aqua !important}@media screen and (max-width: 640px){.index_status-container__9p6Da{line-height:44px;height:44px}}.index_chat-menu__1v-uG{display:flex;flex-flow:column;flex-shrink:0;z-index:999;overflow-y:hidden}.index_chat-menu-bottom--closed__oIQdv{max-height:0}.index_chat-menu-bottom--opened__7PDaE{max-height:calc(var(--xapp-widget-height, 500px) - 40)}.index_chat-menu-left__Cfyj7{position:absolute;top:40px;left:0;width:auto;max-width:var(--xapp-widget-width, 400px);background:var(--xapp-menu-item-background, #efefef);height:100%;overflow:hidden;-webkit-transition:left 1.5s ease-out;-moz-transition:left 1.5s ease-out;-o-transition:left 1.5s ease-out;transition:left 1.5s ease-out}.index_chat-menu-left--closed__Iyi8d{left:-var(--xapp-widget-width, 400px)}.index_chat-menu-right__pobsX{position:absolute;top:40px;right:0;width:auto;max-width:var(--xapp-widget-width, 400px);background:var(--xapp-menu-item-background, #efefef);height:100%;overflow:hidden;-webkit-transition:right 1.5s ease-out;-moz-transition:right 1.5s ease-out;-o-transition:right 1.5s ease-out;transition:right 1.5s ease-out}.index_chat-menu-right--closed__vgbF4{right:-var(--xapp-widget-width, 400px)}.index_chat-msg-container-wrapper__JeCbZ{display:flex;flex-direction:column;margin-bottom:16px}.index_chat-msg-container-wrapper__JeCbZ.index_visitor__CairL{justify-content:flex-end}.index_chat-msg-container-wrapper__JeCbZ.index_agent__C-1W-{justify-content:flex-start}.index_chat-msg-container-wrapper__JeCbZ.index_sibling__GiekN{margin-bottom:8px}.index_chat-msg-container-wrapper__JeCbZ.index_sibling__GiekN .index_avatar__kOeGd{display:none}.index_chat-msg-footer__0K9aF{display:flex;justify-content:space-between;align-items:baseline;font-size:.8em;margin-top:4px;color:var(--xapp-timestamp-color, #888)}.index_chat-msg-footer__0K9aF.index_visitor__CairL{padding-right:20px;align-self:flex-end;flex-direction:row-reverse;gap:12px}.index_chat-msg-footer__0K9aF.index_agent__C-1W-{padding-left:48px;align-self:stretch;gap:12px}.index_xappw-chat-msg-part--avatar-bottom__jKz1u~.index_chat-msg-footer__0K9aF{display:none}.index_chat-msg-timestamp__s-INS{white-space:nowrap}.index_chat-msg-container__3dqAT{display:flex;flex-flow:column nowrap;flex:0 0 auto;justify-content:flex-start;max-width:100%;position:relative}.index_chat-msg-container__3dqAT.index_visitor__CairL{align-items:flex-end}.index_chat-msg-container__3dqAT.index_visitor__CairL .index_xappw-chat-msg-part__avatar__zrYrE{right:0;display:none}.index_chat-msg-container__3dqAT.index_agent__C-1W-{align-items:flex-start}.index_chat-msg-container__3dqAT.index_agent__C-1W- .index_xappw-chat-msg-part__avatar__zrYrE{width:36px;height:36px;left:0}.index_chat-msg-container__3dqAT.index_agent__C-1W- .index_xappw-chat-msg-part--avatar-bottom__jKz1u{align-self:flex-start}.index_message-sr-only__j-6YW{display:none}.index_chat-text-container__2dhZR p{margin:0 0 8px 0;padding:0}.index_chat-msg-agent-typing__AiU-B{margin-top:auto;padding-bottom:16px;font-family:var(--xapp-text-typing-status-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-text-typing-status-font-weight, normal);font-size:var(--xapp-text-typing-status-font-size, 14px);font-style:var(--xapp-text-typing-status-font-style, normal);color:var(--xapp-text-typing-status-text-color, #bfbfbf)}.index_chat-msg-agent-typing__AiU-B::after{display:inline-block;animation:index_dots__-tYj8 steps(1, end) 1.5s infinite;content:\"\"}@keyframes index_dots__-tYj8{0%{content:\"\"}25%{content:\".\"}50%{content:\"..\"}75%{content:\"...\"}100%{content:\"\"}}.index_chat-text-bubble__hkA6E{border-radius:10px;padding:10px;display:inline-block;word-wrap:break-word;position:relative;overflow:visible}.index_chat-text-bubble--mine__hmHoo{font-family:var(--xapp-messages-mine-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-messages-mine-font-weight, normal);font-size:var(--xapp-messages-mine-font-size, 14px);font-style:var(--xapp-messages-mine-font-style, normal);color:var(--xapp-messages-mine-text-color, #ffffff);background:var(--xapp-messages-mine-bubble-color, hsl(120, 75%, 50%));border-bottom-right-radius:0}.index_chat-text-bubble--mine__hmHoo .index_chat-text-bubble__tail__RiYV8{right:-8px;color:var(--xapp-messages-mine-bubble-color, hsl(120, 75%, 50%))}.index_chat-text-bubble--mine__hmHoo a{color:var(--xapp-link-mine-color, #003399) !important;text-decoration:underline !important}.index_chat-text-bubble--mine__hmHoo a:visited{color:var(--xapp-link-mine-visited-color, #551a8b)}.index_chat-text-bubble--mine__hmHoo a:hover{color:var(--xapp-link-mine-hover-color, #001a66)}.index_chat-text-bubble--mine__hmHoo a:focus-visible{outline:2px solid var(--xapp-link-mine-color, #003399);outline-offset:2px}.index_chat-text-bubble--others__9Mz3S{font-family:var(--xapp-messages-others-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-messages-others-font-weight, normal);font-size:var(--xapp-messages-others-font-size, 14px);font-style:var(--xapp-messages-others-font-style, normal);color:var(--xapp-messages-others-text-color, #262726);background:var(--xapp-messages-others-bubble-color, #e1e2e1);border-bottom-left-radius:0}.index_chat-text-bubble--others__9Mz3S .index_chat-text-bubble__tail__RiYV8{left:-8px;color:var(--xapp-messages-others-bubble-color, #e1e2e1)}.index_chat-text-bubble--others__9Mz3S a{color:var(--xapp-link-color, #0066cc) !important;text-decoration:underline !important}.index_chat-text-bubble--others__9Mz3S a:visited{color:var(--xapp-link-visited-color, #551a8b)}.index_chat-text-bubble--others__9Mz3S a:hover{color:var(--xapp-link-hover-color, #0044aa)}.index_chat-text-bubble--others__9Mz3S a:focus-visible{outline:2px solid var(--xapp-link-color, #0066cc);outline-offset:2px}.index_chat-text-bubble__hkA6E span{white-space:pre-wrap}.index_chat-typing-progress__UJ4Ey .index_chat-text-bubble__hkA6E{padding:8px 10px;margin-top:4px}.index_chat-text-bubble__tail__RiYV8{position:absolute;width:8px;height:24px;bottom:0}.index_xappw-chat-msg-part__lk73X{display:inline-block;position:relative;word-wrap:break-word}.index_xappw-chat-msg-part--full-width__5KKjL{display:block;width:100%}.index_xappw-chat-msg-part__lk73X+.index_xappw-chat-msg-part__lk73X{margin-top:4px}.index_xappw-chat-msg-part__lk73X+.index_xappw-chat-msg-part__lk73X .index_chat-card-img__IPzGI{border-radius:12px 12px 12px 0}.index_xappw-chat-msg-part__avatar__zrYrE{position:absolute;top:0;z-index:10}.index_xappw-chat-msg-part--streaming__suPNF{display:flex;align-items:flex-start;gap:8px}.index_xappw-chat-msg-part--streaming__suPNF .index_xappw-chat-msg-part__avatar__zrYrE{position:sticky;top:60px;flex-shrink:0;z-index:10}.index_xappw-chat-msg-part--streaming__suPNF .index_chat-msg__Ty0Wl{margin-left:0}.index_xappw-chat-msg-part--streaming__suPNF .index_chat-text-bubble--others__9Mz3S{border-bottom-left-radius:10px}.index_xappw-chat-msg-part__lk73X ul{list-style-position:inside;padding:0;margin:0 0 8px 0}.index_xappw-chat-msg-part__lk73X li{padding:0;margin:0}.index_xappw-chat-msg-part--avatar-below__4fY-V{display:inline-flex;flex-direction:column;align-items:flex-start;gap:.25rem}.index_xappw-chat-msg-part--avatar-below__4fY-V .index_xappw-chat-msg-part__avatar__zrYrE{position:static;z-index:auto;margin-left:0;margin-top:.125rem}.index_xappw-chat-msg-part--avatar-below__4fY-V .index_chat-msg__Ty0Wl{margin-left:30px !important}.index_xappw-chat-msg-part__avatar-wrapper__uvtFy{display:flex;align-items:center;gap:.5rem;margin-top:.25rem}.index_xappw-chat-msg-part__avatar-name__rraxz{font-size:.8rem;color:#666}.index_xappw-chat-msg-part--avatar-bottom__jKz1u{display:inline-flex;flex-direction:column;align-items:flex-start;gap:.25rem}.index_xappw-chat-msg-part--avatar-bottom__jKz1u .index_xappw-chat-msg-part__avatar__zrYrE{position:static;z-index:auto;margin-left:0;margin-top:0;width:18px !important;height:18px !important}.index_xappw-chat-msg-part--avatar-bottom__jKz1u .index_xappw-chat-msg-part__avatar__zrYrE .index_avatar__kOeGd{border-radius:9px}.index_xappw-chat-msg-part--avatar-bottom__jKz1u .index_xappw-chat-msg-part__avatar-wrapper__uvtFy{margin-top:.125rem;gap:.25rem;align-items:center}.index_xappw-chat-msg-part--avatar-bottom__jKz1u .index_xappw-chat-msg-part__avatar-name__rraxz{font-size:.875rem;line-height:18px}.index_xappw-chat-msg-part--avatar-bottom__jKz1u .index_chat-msg__Ty0Wl{margin-left:0 !important}.index_xappw-chat-msg-part--avatar-bottom__jKz1u .index_chat-text-bubble--others__9Mz3S{border-bottom-right-radius:10px !important}.index_xappw-chat-msg-part--avatar-bottom__jKz1u .index_chat-text-bubble--mine__hmHoo{border-bottom-left-radius:10px !important}.index_xappw-chat-msg-part--avatar-bottom__jKz1u .index_chat-text-bubble__tail__RiYV8{display:none !important}.index_cta-bubble__mQg4h{position:relative;border-radius:50%;background:var(--xapp-cta-background, #e1e2e1);display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;text-align:center;border:var(--xapp-widget-border-width, 0px) solid var(--xapp-widget-border-color, var(--xapp-primary-color, #616161));border-radius:var(--xapp-widget-border-radius, 50%);max-width:192px}.index_cta-bubble__tail__dO8xM{position:absolute;left:-16px;right:-16px;top:-16px;bottom:-16px;z-index:1;color:var(--xapp-cta-background, #e1e2e1)}.index_cta-bubble__tail__dO8xM svg{width:100%;height:100%;margin:0;padding:0}.index_cta-bubble__content__eci6R{font-family:var(--xapp-cta-font-family, 14px);font-size:var(--xapp-cta-font-size, 14px);color:var(--xapp-cta-text-color, var(--xapp-primary-color, #616161));z-index:2;text-transform:none !important}.index_cta-bubble__dismiss__-2X-6{position:absolute;top:4px;right:4px;z-index:3;background:rgba(0,0,0,.2);border:none;border-radius:50%;width:20px;height:20px;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;color:#fff;transition:background-color .2s}.index_cta-bubble__dismiss__-2X-6:hover{background:rgba(0,0,0,.4)}.index_cta-bubble__dismiss__-2X-6:focus{outline:2px solid rgba(0,0,0,.5);outline-offset:2px}.index_cta-bubble__dismiss__-2X-6 svg{display:block}@keyframes index_modal-backdrop-fade-in__leD-Q{from{opacity:0}to{opacity:1}}@keyframes index_modal-content-slide-up__10rNQ{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}@keyframes index_spinner-rotate__bDYKH{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}.index_xapp-form-modal__nLtTm{position:fixed;top:0;left:0;right:0;bottom:0;z-index:calc(var(--xapp-widget-z-index, 1000) + 100);display:flex;align-items:center;justify-content:center;padding:24px;background:rgba(0,0,0,.5);animation:index_modal-backdrop-fade-in__leD-Q .2s ease-out}@media(max-width: 640px){.index_xapp-form-modal__nLtTm{padding:0;align-items:flex-end}}.index_xapp-form-modal__content__to9-3{position:relative;z-index:1;background:#fff;border-radius:16px;box-shadow:0 8px 32px rgba(0,0,0,.2);max-width:600px;max-height:90vh;width:100%;overflow:hidden;animation:index_modal-content-slide-up__10rNQ .3s ease-out;outline:none}@media(max-width: 640px){.index_xapp-form-modal__content__to9-3{border-radius:16px 16px 0 0;max-height:95vh;height:auto}}.index_xapp-form-modal__close__Zw2r2{position:absolute;top:12px;right:12px;width:32px;height:32px;border:none;background:rgba(0,0,0,.1);border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:20px;color:#666;transition:background-color .2s;z-index:10;line-height:1;padding:0}.index_xapp-form-modal__close__Zw2r2:hover{background:rgba(0,0,0,.2)}.index_xapp-form-modal__close__Zw2r2:focus-visible{outline:2px solid var(--xapp-primary-color, #0075aa);outline-offset:2px}.index_xapp-form-modal__form-container__y2ZQL{padding:24px;min-height:200px;overflow-y:auto;max-height:calc(90vh - 48px)}@media(max-width: 640px){.index_xapp-form-modal__form-container__y2ZQL{max-height:calc(95vh - 48px)}}.index_xapp-form-modal__loading__t-P1m{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:200px;color:#666;font-family:\"RobotoRegular\",\"serif\";text-align:center}.index_xapp-form-modal__loading__t-P1m p{margin:8px 0}.index_xapp-form-modal__debug__C9BgT{font-size:12px;color:#999;margin-top:16px;padding:12px;background:#f5f5f5;border-radius:8px;word-break:break-all}.index_xapp-form-modal__error__zYYYq{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:200px;padding:24px;color:#666;font-family:\"RobotoRegular\",\"serif\";text-align:center}.index_xapp-form-modal__error__zYYYq p{margin:8px 0}.index_xapp-form-modal__spinner__5zCg-{width:40px;height:40px;border:3px solid #e0e0e0;border-top-color:var(--xapp-primary-color, #0075aa);border-radius:50%;animation:index_spinner-rotate__bDYKH .8s linear infinite;margin-bottom:16px}.index_xapp-form-modal__retry__JMLao{margin-top:16px;padding:10px 24px;background:var(--xapp-primary-color, #0075aa);color:#fff;border:none;border-radius:8px;font-family:\"RobotoRegular\",\"serif\";font-size:14px;font-weight:500;cursor:pointer;transition:background-color .2s,transform .1s}.index_xapp-form-modal__retry__JMLao:hover{background:var(--xapp-primary-color-dark, #005580)}.index_xapp-form-modal__retry__JMLao:active{transform:scale(0.98)}.index_xapp-form-modal__retry__JMLao:focus-visible{outline:2px solid var(--xapp-primary-color, #0075aa);outline-offset:2px}@media(prefers-reduced-motion: reduce){.index_xapp-form-modal__nLtTm{animation:none}.index_xapp-form-modal__content__to9-3{animation:none}.index_xapp-form-modal__spinner__5zCg-{animation:none;border-top-color:var(--xapp-primary-color, #0075aa)}.index_xapp-form-modal__spinner__5zCg-::after{content:\"\";position:absolute;top:50%;left:50%;width:8px;height:8px;background:var(--xapp-primary-color, #0075aa);border-radius:50%;transform:translate(-50%, -50%)}.index_xapp-form-modal__retry__JMLao,.index_xapp-form-modal__close__Zw2r2{transition:none}.index_xapp-form-modal__retry__JMLao:active,.index_xapp-form-modal__close__Zw2r2:active{transform:none}}.index_xappw-vlist__-oq2F{display:flex;flex-flow:column nowrap}.index_xappw-vlist__header__moUvo{padding:16px 8px;font-family:\"RobotoRegular\",\"serif\";font-weight:bold;font-size:16px}.index_xappw-vlist-container__g-zdd{display:flex;flex-flow:column nowrap;flex:0 0 auto;justify-content:flex-start;width:100%;max-width:100%;position:relative;border:solid 1px #ccc;border-radius:12px;overflow:hidden}.index_xappw-vlist-container__g-zdd .index_xappw-vlist-container__item__uAn6-{display:block;width:100%;border-top:solid 1px #ccc}.index_xappw-vlist-container__g-zdd .index_xappw-vlist-container__item__uAn6-:first-child{border-top:none}.index_xappw-vlist-item__pgUAP{display:flex;flex-direction:row;flex:0 0 auto;width:100%;min-height:56px;padding:8px;box-sizing:border-box;cursor:pointer}.index_xappw-vlist-item--normal__fhfG2{align-items:flex-start}.index_xappw-vlist-item--titles__baU4A{align-items:center}.index_xappw-vlist-item__pgUAP:hover{background-color:#eee}.index_xappw-vlist-item__description__09r44{display:flex;flex-direction:column;flex:1 1 auto;overflow:hidden}.index_xappw-vlist-item__side__-GGRz{flex:0 0 auto;display:flex;flex-direction:column}.index_xappw-vlist-item__img__Nsm-v{border-radius:12px;width:40px;height:40px;overflow:hidden}.index_xappw-vlist-item__link-row__m3Pjo{display:flex;flex-direction:row;align-items:baseline;gap:4px;overflow:hidden}.index_xappw-vlist-item__external-link__Y9lxG{flex-shrink:0;width:10px;height:10px;display:inline-flex;align-items:center;justify-content:center}.index_xappw-vlist-item__external-link__Y9lxG svg{display:block;width:100%;height:100%}.index_xappw-vlist-item__title__f6b3w{text-align:left;font-family:var(--xapp-carousel-title-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-carousel-title-font-weight, bold);font-size:var(--xapp-carousel-title-font-size, 14px);font-style:var(--xapp-carousel-title-font-style, normal);color:var(--xapp-carousel-title-text-color, #000);line-height:1.3}.index_xappw-vlist-item__title__f6b3w span{display:inline-block;white-space:pre-wrap}.index_xappw-vlist-item__link__nppZI{font-family:var(--xapp-carousel-link-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-carousel-link-font-weight, normal);font-size:var(--xapp-carousel-link-font-size, 12px);font-style:var(--xapp-carousel-link-font-style, normal);color:var(--xapp-carousel-link-text-color, #666);line-height:1.3;overflow:hidden;text-overflow:ellipsis;max-width:100%}.index_xappw-vlist-item__subtitle__551Xo{text-align:left;font-family:var(--xapp-carousel-subtitle-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-carousel-subtitle-font-weight, normal);font-size:var(--xapp-carousel-subtitle-font-size, 12px);font-style:var(--xapp-carousel-subtitle-font-style, italic);color:var(--xapp-carousel-subtitle-text-color, #979797);line-height:1.3}.index_xappw-vlist-item__subtitle__551Xo span{display:inline-block;white-space:pre-wrap}.index_xappw-vlist-item__pgUAP .index_action-button__W8QMQ{display:inline-block;padding:0 10px;margin:3px;height:25px;font-size:12px;line-height:25px;border-radius:25px;background-color:var(--xapp-carousel-action-button-color, var(--xapp-primary-color, #616161));color:#d5d9e7;cursor:pointer}.index_xappw-vlist-item__pgUAP .index_action-button__W8QMQ:focus-visible{outline:none;filter:invert(100%)}.index_message-list-container__m7x60{position:relative;flex:1 1 0;min-height:0;overflow-y:scroll;display:flex;flex-direction:column;background:var(--xapp-content-background, #fff)}.index_message-list-container__m7x60::-webkit-scrollbar{display:none}.index_message-list-container__m7x60{scrollbar-width:none;-ms-overflow-style:none}.index_message-list-container__msgs__bI4bR{display:flex;flex-direction:column;flex-grow:1;flex-shrink:1;padding-top:var(--xapp-messages-padding-top, 8px);padding-right:var(--xapp-messages-padding-right, 16px);padding-bottom:var(--xapp-messages-padding-bottom, 0);padding-left:var(--xapp-messages-padding-left, 20px)}.index_message-list-container__chips__WUklT{flex:0 0 auto;border-top:solid 1px #ccc;border-bottom:solid 1px #ccc;margin-top:auto}.index_message-list-container__chips--empty__Dum1s{flex-basis:0;border:none;overflow:hidden}@keyframes index_action-bar-cta-wiggle__OSsci{0%,100%{transform:rotate(0deg)}25%{transform:rotate(-2deg)}75%{transform:rotate(2deg)}}@keyframes index_action-bar-cta-bounce__qLEAo{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}@keyframes index_action-bar-cta-pulse__tD0Es{0%,100%{box-shadow:var(--xapp-action-bar-cta-box-shadow, 0 4px 12px rgba(0, 0, 0, 0.2))}50%{box-shadow:0 0 0 4px rgba(0,117,170,.3),var(--xapp-action-bar-cta-box-shadow, 0 4px 12px rgba(0, 0, 0, 0.2))}}@keyframes index_action-bar-cta-fade-in__OSl20{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}.index_xapp-action-bar-cta-wrapper__OMoRB{position:absolute;bottom:100%;left:0;right:0;padding:0 0 8px 0;pointer-events:none;display:flex;justify-content:stretch}.index_xapp-action-bar-cta-wrapper__OMoRB>*{pointer-events:auto}.index_xapp-action-bar--mobile__ZYOay .index_xapp-action-bar-cta-wrapper__OMoRB{padding:0 8px 8px 8px}.index_xapp-action-bar-cta__jxKci{display:flex;align-items:center;justify-content:center;gap:var(--xapp-action-bar-cta-gap, 8px);width:100%;min-width:250px;padding:var(--xapp-action-bar-cta-padding, 12px 16px);background-color:var(--xapp-action-bar-cta-background, var(--xapp-primary-color, #0075aa)) !important;border-radius:var(--xapp-action-bar-cta-border-radius, 12px);box-shadow:var(--xapp-action-bar-cta-box-shadow, 0 4px 12px rgba(0, 0, 0, 0.2));cursor:pointer;box-sizing:border-box;animation:index_action-bar-cta-fade-in__OSl20 .3s ease-out;transition:background-color .2s ease,transform .1s ease;font-family:var(--xapp-action-bar-label-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-action-bar-cta-font-weight, 500);font-size:var(--xapp-action-bar-cta-font-size, 14px);font-style:var(--xapp-action-bar-label-font-style, normal);color:var(--xapp-action-bar-cta-text-color, #ffffff)}.index_xapp-action-bar-cta__jxKci:hover{filter:brightness(1.1)}.index_xapp-action-bar-cta__jxKci:active{transform:scale(0.98)}.index_xapp-action-bar-cta__jxKci:focus-visible{outline:2px solid #fff;outline-offset:2px}.index_xapp-action-bar-cta--wiggle__K-tpA{animation:index_action-bar-cta-wiggle__OSsci .5s ease-in-out infinite}.index_xapp-action-bar-cta--bounce__6ao-L{animation:index_action-bar-cta-bounce__qLEAo .6s ease-in-out infinite}.index_xapp-action-bar-cta--pulse__--nM6{animation:index_action-bar-cta-pulse__tD0Es 1.5s ease-in-out infinite}.index_xapp-action-bar-cta__message__iiyDV{flex:1;text-align:left;line-height:1.4}.index_xapp-action-bar-cta__dismiss__aTdT0{display:flex;align-items:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;background-color:rgba(0,0,0,0) !important;border:none;border-radius:50%;color:inherit;opacity:.7;cursor:pointer;flex-shrink:0;transition:opacity .2s ease,background-color .2s ease}.index_xapp-action-bar-cta__dismiss__aTdT0:hover{opacity:1;background:hsla(0,0%,100%,.2)}.index_xapp-action-bar-cta__dismiss__aTdT0:focus-visible{outline:2px solid #fff;outline-offset:1px;opacity:1}.index_xapp-action-bar-cta__dismiss__aTdT0 svg{display:block}@media(prefers-reduced-motion: reduce){.index_xapp-action-bar-cta__jxKci{animation:none}.index_xapp-action-bar-cta--wiggle__K-tpA,.index_xapp-action-bar-cta--bounce__6ao-L,.index_xapp-action-bar-cta--pulse__--nM6{animation:none}.index_xapp-action-bar-cta__jxKci:active{transform:none}}.index_xappw-chat-action-item__brMEa{display:block;width:100%;text-decoration:none}.index_xappw-chat-action-item--action__hFbt-{cursor:pointer}.index_chat-menu-item__jjZEE{border:var(--xapp-chat-menu-item-border-width, #fff) solid var(--xapp-chat-menu-item-border-color, #fff);border-radius:var(--xapp-chat-menu-item-border-radius, 0px);opacity:1;background:var(--xapp-menu-item-background, #efefef);font-family:var(--xapp-menu-item-font-family, 14px);font-weight:var(--xapp-menu-item-font-weight, normal);font-size:var(--xapp-menu-item-font-size, 14px);font-style:var(--xapp-menu-item-font-style, normal);color:var(--xapp-menu-item-text-color, var(--xapp-primary-color, #616161));height:var(--xapp-menu-item-height, 24px);width:100%;max-width:100%;box-sizing:border-box;padding:4px 4px 4px 30px;text-align:left}.index_chat-menu-item__jjZEE:hover{opacity:.8;cursor:pointer}.index_chat-menu-item--subtitle__lhOgq{font-family:var(--xapp-menu-item-subtitle-font-family, 14px);font-weight:var(--xapp-menu-item-subtitle-font-weight, normal);font-size:var(--xapp-menu-item-subtitle-font-size, 14px);font-style:var(--xapp-menu-item-subtitle-font-style, normal);color:var(--xapp-menu-item-text-subtitle-color, var(--xapp-primary-color, #616161))}.index_chat-menu-item__jjZEE:focus-visible{outline:none;filter:invert(100%)}.index_chat-menu-item-static__B-ddQ{border:var(--xapp-chat-menu-item-border-width, #fff) solid var(--xapp-chat-menu-item-border-color, #fff);border-radius:var(--xapp-chat-menu-item-border-radius, 0px);background:var(--xapp-menu-item-background, #efefef);font-family:var(--xapp-menu-item-font-family, 14px);font-weight:var(--xapp-menu-item-font-weight, normal);font-size:var(--xapp-menu-item-font-size, 14px);font-style:var(--xapp-menu-item-font-style, normal);color:var(--xapp-menu-item-text-color, var(--xapp-primary-color, #616161));height:var(--xapp-menu-item-height, 24px);display:flex;justify-content:center;text-align:center;padding:4px 4px 4px 30px}.index_chat-menu-item-static--body__3uOr9{font-family:var(--xapp-menu-item-subtitle-font-family, 14px);font-weight:var(--xapp-menu-item-subtitle-font-weight, normal);font-size:var(--xapp-menu-item-subtitle-font-size, 14px);font-style:var(--xapp-menu-item-subtitle-font-style, normal);color:var(--xapp-menu-item-text-subtitle-color, var(--xapp-primary-color, #616161))}.index_chat-menu-item-static-text__nW-eN{border:var(--xapp-chat-menu-item-border-width, #fff) solid var(--xapp-chat-menu-item-border-color, #fff);border-radius:var(--xapp-chat-menu-item-border-radius, 0px);background:var(--xapp-menu-item-background, #efefef);font-family:var(--xapp-menu-item-font-family, 14px);font-weight:var(--xapp-menu-item-font-weight, normal);font-size:var(--xapp-menu-item-font-size, 14px);font-style:var(--xapp-menu-item-font-style, normal);color:var(--xapp-menu-item-text-color, var(--xapp-primary-color, #616161));max-height:100%;max-width:auto;display:flex;justify-content:center;text-align:center;padding:4px 4px 4px 30px}.index_chat-menu-item-static-text--body__Cuziw{font-family:var(--xapp-menu-item-subtitle-font-family, 14px);font-weight:var(--xapp-menu-item-subtitle-font-weight, normal);font-size:var(--xapp-menu-item-subtitle-font-size, 14px);font-style:var(--xapp-menu-item-subtitle-font-style, normal);color:var(--xapp-menu-item-text-subtitle-color, var(--xapp-primary-color, #616161))}.index_chat-msg__content__uTQZT{word-wrap:break-word}.index_chat-msg__content__uTQZT strong,.index_chat-msg__content__uTQZT b{font-weight:600}.index_chat-msg__content__uTQZT em,.index_chat-msg__content__uTQZT i{font-style:italic}.index_chat-msg__content__uTQZT a{color:var(--xapp-link-color, #0066cc) !important;text-decoration:underline !important}.index_chat-msg__content__uTQZT a:hover{text-decoration:none !important}.index_chat-msg__content__uTQZT a:visited{color:var(--xapp-link-color, #0066cc) !important}.index_chat-msg__content__uTQZT h2,.index_chat-msg__content__uTQZT h3,.index_chat-msg__content__uTQZT h4{margin:.5em 0 .25em 0;font-weight:600}.index_chat-msg__content__uTQZT h2:first-child,.index_chat-msg__content__uTQZT h3:first-child,.index_chat-msg__content__uTQZT h4:first-child{margin-top:0}.index_chat-msg__content__uTQZT h2{font-size:1.25em}.index_chat-msg__content__uTQZT h3{font-size:1.1em}.index_chat-msg__content__uTQZT h4{font-size:1em}.index_chat-msg__content__uTQZT ul{margin:.5em 0;padding-left:1.5em}.index_chat-msg__content__uTQZT li{margin:.25em 0}.index_streaming-cursor__fpjuh{display:inline-block;width:2px;height:1em;background-color:currentColor;margin-left:2px;vertical-align:text-bottom;animation:index_streaming-blink__-tFcI .7s ease-in-out infinite}@keyframes index_streaming-blink__-tFcI{0%,50%{opacity:1}51%,100%{opacity:0}}.index_chat-footer__-elCY{position:relative;flex:0 0 auto;background-color:var(--xapp-footer-background, var(--xapp-primary-color, #616161)) !important}.index_chat-footer__menu-icon__pUjv6{border-top:solid var(--xapp-footer-border-width, 0px) var(--xapp-footer-border-color, var(--xapp-primary-color, #616161));z-index:999;padding:6px 0;flex-shrink:0;display:flex;justify-content:center}.index_chat-footer__menu-icon__pUjv6+.index_chat-footer__input__u41YC{margin-top:-6px}.index_chat-footer__input__u41YC{margin-top:6px;margin-bottom:6px}.index_xappw-chat-footer__suggestions__zDzNt{position:absolute;bottom:100%;left:0;right:0;overflow:hidden;z-index:100}.index_background-footer__ojSwW .index_chat-footer__-elCY{background-color:#616161 !important}.index_server-offline__fWNlI{position:absolute;top:44px;right:0;left:0;bottom:0;z-index:100;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center}.index_error-overlay__6FEwc{position:fixed;right:10px;width:400px;max-width:calc(100% - 20px);max-height:50vh;background:#1e1e1e;border:1px solid #333;border-radius:8px;box-shadow:0 4px 6px rgba(0,0,0,.3);z-index:999999;font-family:\"Monaco\",\"Menlo\",\"Ubuntu Mono\",monospace;font-size:12px;color:#fff}.index_error-overlay--bottom__pOC3a{bottom:10px}.index_error-overlay--top__LkaOV{top:10px}.index_error-overlay__6FEwc.index_minimized__AOpMX{max-height:auto}.index_error-overlay__6FEwc .index_error-overlay-header__rq6oe{display:flex;justify-content:space-between;align-items:center;padding:10px 12px;background:#2d2d2d;border-bottom:1px solid #333;border-radius:8px 8px 0 0;min-height:52px}.index_error-overlay__6FEwc .index_error-overlay-header__rq6oe .index_error-overlay-title__4Ozmf{font-weight:bold;color:#ff6b6b}.index_error-overlay__6FEwc .index_error-overlay-header__rq6oe .index_error-overlay-actions__acT6X{display:flex;gap:4px}.index_error-overlay__6FEwc .index_error-overlay-header__rq6oe .index_error-overlay-actions__acT6X button{background:none;border:none;color:#aaa;cursor:pointer;padding:6px 10px;font-size:18px;min-width:36px;min-height:36px;display:flex;align-items:center;justify-content:center;border-radius:4px;transition:all .2s}.index_error-overlay__6FEwc .index_error-overlay-header__rq6oe .index_error-overlay-actions__acT6X button:hover{color:#fff;background:hsla(0,0%,100%,.1)}.index_error-overlay__6FEwc .index_error-overlay-header__rq6oe .index_error-overlay-actions__acT6X button:active{background:hsla(0,0%,100%,.2);transform:scale(0.95)}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0{max-height:calc(50vh - 40px);overflow-y:auto;padding:8px}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0::-webkit-scrollbar{width:8px}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0::-webkit-scrollbar-track{background:#2d2d2d}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0::-webkit-scrollbar-thumb{background:#555;border-radius:4px}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0::-webkit-scrollbar-thumb:hover{background:#666}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc{margin-bottom:8px;padding:8px;background:#2d2d2d;border-radius:4px;border-left:3px solid}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc.index_error-error__tRkAu{border-left-color:#ff6b6b}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc.index_error-warning__5jGtO{border-left-color:#ffd93d}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc.index_error-info__7B-M3{border-left-color:#6bcf7f}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-header__6xf1U{display:flex;align-items:center;gap:8px;margin-bottom:6px}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-header__6xf1U .index_error-time__M9wLe{color:#888;font-size:10px}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-header__6xf1U .index_error-count__WRRlP{color:#ffd93d;font-size:10px;font-weight:bold}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-header__6xf1U .index_error-badge__GujXa{padding:2px 6px;border-radius:3px;font-size:10px;text-transform:uppercase;font-weight:bold}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-header__6xf1U .index_error-badge-error__q0-zW{background:rgba(255,107,107,.2);color:#ff6b6b}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-header__6xf1U .index_error-badge-warning__sWHrq{background:rgba(255,217,61,.2);color:#ffd93d}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-header__6xf1U .index_error-badge-info__EBmSx{background:rgba(107,207,127,.2);color:#6bcf7f}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-message__-h4GT{color:#f0f0f0;word-break:break-word;line-height:1.4}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-stack__lP-EY{margin-top:8px}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-stack__lP-EY summary{color:#888;cursor:pointer;font-size:11px}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-stack__lP-EY summary:hover{color:#aaa}.index_error-overlay__6FEwc .index_error-overlay-content__RbEv0 .index_error-entry__YkJIc .index_error-stack__lP-EY pre{margin:4px 0 0 0;padding:8px;background:#1a1a1a;border-radius:4px;font-size:10px;color:#888;overflow-x:auto;line-height:1.3}.index_ws-button-container__L4yJh{padding:8px 16px;background:#fff;display:flex;justify-content:flex-end;align-items:center;transform-origin:top;transition:transform .3s ease-out,opacity .3s ease-out,max-height .3s ease-out,padding .3s ease-out;max-height:100px;animation:index_ws-button-appear__oYMhA .3s ease-out}.index_ws-button-container--dismissing__PPOB-{transform:scaleY(0);opacity:0;max-height:0;padding-top:0;padding-bottom:0}@keyframes index_ws-button-appear__oYMhA{0%{transform:scaleY(0);opacity:0;max-height:0;padding-top:0;padding-bottom:0}100%{transform:scaleY(1);opacity:1;max-height:100px;padding-top:8px;padding-bottom:8px}}.index_ws-button__gIl2P{display:inline-flex;align-items:center;justify-content:center;padding:8px 16px;height:36px;font-size:14px;font-weight:500;color:#2f385a;line-height:1.5;border-radius:18px;border:1px solid #aeb3be;background-color:#fff;cursor:pointer;user-select:none;transition:all .2s ease-in-out;position:relative;min-width:100px}.index_ws-button__gIl2P:hover:not(.index_ws-button--disabled__JffAq){background-color:#f5f5f5;border-color:#2f385a}.index_ws-button__gIl2P:active:not(.index_ws-button--disabled__JffAq){transform:scale(0.98)}.index_ws-button--disabled__JffAq{opacity:.6;cursor:not-allowed;pointer-events:none}.index_ws-button--spinning__Gbdwq{padding-left:40px;cursor:not-allowed;pointer-events:none}.index_ws-button__text__N4Rcl{display:inline-block}.index_ws-button__spinner__QTyKX{position:absolute;left:12px;width:16px;height:16px;border:2px solid rgba(47,56,90,.2);border-top-color:#2f385a;border-right-color:#2f385a;border-radius:50%;animation:index_ws-button-spin__a-MyH .6s linear infinite}@keyframes index_ws-button-spin__a-MyH{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@media screen and (max-width: 640px){.index_ws-button__gIl2P{min-height:44px;padding:12px 20px;font-size:16px}.index_ws-button--spinning__Gbdwq{padding-left:48px}.index_ws-button__spinner__QTyKX{left:16px;width:20px;height:20px}}.index_chat-card-img__IPzGI{display:block;width:100%;height:100%}.index_chat-card-img__content__VrZ-v{background-position:center;background-size:cover;width:100%;height:100%}.index_button-group__JK0SS{display:flex;flex-direction:row;align-items:center;gap:4px;height:32px;flex-shrink:0}.index_button-group__JK0SS .index_menu-button__goCtD,.index_button-group__JK0SS .index_refresh-button__kHbBS,.index_button-group__JK0SS .index_minimize-button__EdXy9,.index_button-group__JK0SS .index_cancel-button__XmwLo{position:static !important;top:auto !important;right:auto !important;margin:0 !important}.index_cancel-button__XmwLo{margin:0px !important;padding:0px !important;min-width:32px;width:32px;height:32px;border:none;outline:none;display:flex;justify-content:center;align-items:center;cursor:pointer;font-size:16px;color:var(--xapp-cancel-button-color, var(--xapp-cancel-button-color, #a3a6b4));background-color:var(--xapp-cancel-button-bg, rgba(255, 255, 255, 0.15)) !important;border-radius:50%;transition:background-color .2s ease}.index_cancel-button__XmwLo:hover{background-color:var(--xapp-cancel-button-hover-bg, rgba(255, 255, 255, 0.25)) !important}.index_cancel-button__XmwLo:after{content:\"⨉\" !important;opacity:inherit !important}.index_cancel-button__XmwLo:focus-visible{outline:2px solid hsla(0,0%,100%,.5);outline-offset:2px}.index_drawer-bars__Khs-A{display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:rgba(0,0,0,0);border:none;padding:6px 0;cursor:pointer}.index_drawer-bar__mVacq{flex:0 0 5px;border-radius:5px;background-color:var(--xapp-menu-button-color, #fff);width:25px;margin:2.5px}.index_drawer-bar__mVacq:first-child{margin-top:0}.index_drawer-bar__mVacq:last-child{margin-bottom:0}@media screen and (max-width: 640px){.index_drawer-bars__Khs-A{height:44px;width:44px;line-height:44px}}.index_export-button__0liCt{margin:0px !important;padding:0px !important;min-width:32px;width:32px;height:32px;border:none;outline:none;display:flex;justify-content:center;align-items:center;cursor:pointer;font-size:16px;color:var(--xapp-export-button-color, var(--xapp-refresh-button-color, #a3a6b4));background-color:var(--xapp-export-button-bg, rgba(255, 255, 255, 0.15)) !important;border-radius:50%;transition:background-color .2s ease}.index_export-button__0liCt:hover{background-color:var(--xapp-export-button-hover-bg, rgba(255, 255, 255, 0.25)) !important}.index_export-button__0liCt:after{content:\"⧉\" !important;opacity:inherit !important}.index_export-button__0liCt:focus-visible{outline:2px solid hsla(0,0%,100%,.5);outline-offset:2px}.index_menu-button__goCtD{margin:0px !important;padding:0px !important;min-width:32px;width:32px;height:32px;border:none;outline:none;display:flex;justify-content:center;align-items:center;cursor:pointer;font-size:16px;color:var(--xapp-menu-button-color, var(--xapp-cancel-button-color, #a3a6b4));background-color:var(--xapp-menu-button-bg, rgba(255, 255, 255, 0.15)) !important;border-radius:50%;transition:background-color .2s ease}.index_menu-button__goCtD:hover{background-color:var(--xapp-menu-button-hover-bg, rgba(255, 255, 255, 0.25)) !important}.index_menu-button__goCtD:after{content:\"⋮\" !important;opacity:inherit !important}.index_menu-button__goCtD:focus-visible{outline:2px solid hsla(0,0%,100%,.5);outline-offset:2px}.index_minimize-button__EdXy9{margin:0px !important;padding:0px !important;min-width:32px;width:32px;height:32px;border:none;outline:none;display:flex;justify-content:center;align-items:center;cursor:pointer;font-size:16px;color:var(--xapp-minimize-button-color, var(--xapp-minimize-button-color, #a3a6b4)) !important;background-color:var(--xapp-minimize-button-bg, rgba(255, 255, 255, 0.15)) !important;border-radius:50%;transition:background-color .2s ease}.index_minimize-button__EdXy9:hover{background-color:var(--xapp-minimize-button-hover-bg, rgba(255, 255, 255, 0.25)) !important}.index_minimize-button__EdXy9:after{content:\"─\" !important;opacity:inherit !important}.index_minimize-button__EdXy9:focus-visible{outline:2px solid hsla(0,0%,100%,.5);outline-offset:2px}.index_refresh-button__kHbBS{margin:0px !important;padding:0px !important;min-width:32px;width:32px;height:32px;border:none;outline:none;display:flex;justify-content:center;align-items:center;cursor:pointer;font-size:16px;color:var(--xapp-refresh-button-color, var(--xapp-refresh-button-color, #a3a6b4));background-color:var(--xapp-refresh-button-bg, rgba(255, 255, 255, 0.15)) !important;border-radius:50%;transition:background-color .2s ease}.index_refresh-button__kHbBS:hover{background-color:var(--xapp-refresh-button-hover-bg, rgba(255, 255, 255, 0.25)) !important}.index_refresh-button__kHbBS:after{content:\"⟳\" !important;opacity:inherit !important}.index_refresh-button__kHbBS:focus-visible{outline:2px solid hsla(0,0%,100%,.5);outline-offset:2px}.index_chat-schedule-button-container__EX0Z7{padding:10px 0;width:100%;display:flex;flex-direction:row;justify-content:center;margin-top:8px}.index_chat-schedule-button__xfvwb{border-radius:26px;min-width:200px;height:52px;text-align:center;font-size:1.2em;line-height:1.22857;background-color:var(--xapp-header-background, #0295D2);color:var(--xapp-header-text-color, rgba(255, 255, 255, 0.87));border-width:0px;padding:0 10px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px}.index_chat-schedule-button__xfvwb:hover{background-color:var(--xapp-header-background-hover, rgb(1.5188679245, 113.1556603774, 159.4811320755))}.index_source-links__jAv4A{display:flex;align-items:baseline;gap:4px;margin-top:4px;padding:0 4px;font-size:11px;line-height:1.4;overflow:hidden}.index_source-links__prefix__4ee-I{color:var(--xapp-source-links-prefix-color, #6b7280);font-weight:500;margin-right:2px;flex-shrink:0}.index_source-links__list__0D83p{display:flex;align-items:baseline;overflow-x:auto;white-space:nowrap;scrollbar-width:thin;-ms-overflow-style:none}.index_source-links__list__0D83p::-webkit-scrollbar{height:4px}.index_source-links__list__0D83p::-webkit-scrollbar-track{background:rgba(0,0,0,0)}.index_source-links__list__0D83p::-webkit-scrollbar-thumb{background:var(--xapp-source-links-scrollbar-color, #d1d5db);border-radius:2px}.index_source-links__item__31RQD{display:inline-flex;align-items:baseline;flex-shrink:0}.index_source-links__link__zmG8-{color:var(--xapp-source-links-color, #2563eb) !important;text-decoration:underline !important;transition:color .15s ease}.index_source-links__link__zmG8-:hover{color:var(--xapp-source-links-hover-color, #1d4ed8) !important;text-decoration:none !important}.index_source-links__link__zmG8-:visited{color:var(--xapp-source-links-color, #2563eb) !important}.index_source-links__link__zmG8-:focus{outline:1px solid var(--xapp-source-links-focus-color, #2563eb);outline-offset:1px;border-radius:2px}.index_source-links__separator__Jw5GF{color:var(--xapp-source-links-separator-color, #9ca3af);margin:0 4px}.index_source-links--minimal__qPoA- .index_source-links__prefix__4ee-I{display:none}.index_source-links--numbered__6lmxN .index_source-links__link__zmG8-::before{content:\"[\"}.index_source-links--numbered__6lmxN .index_source-links__link__zmG8-::after{content:\"]\"}.index_tool-progress-display__ypwEz{display:flex;flex-direction:column;gap:4px;margin:8px 0;width:100%;min-width:200px}.index_tool-progress-item__WGl7E{display:flex;align-items:center;gap:8px;padding:6px 10px;background:#f8f9fa;border-radius:6px;font-size:13px;color:#555;min-width:220px}.index_tool-progress-item--executing__YynIX{background:#fff8e6;color:#664d00}.index_tool-progress-item--error__RzBjs{background:#fff5f5;color:#c92a2a}.index_tool-progress-item__icon__i-yi2{width:16px;height:16px;display:flex;align-items:center;justify-content:center;flex-shrink:0}.index_tool-progress-item__spinner__DMioa{width:12px;height:12px;border:2px solid #e0c080;border-top-color:#960;border-radius:50%;animation:index_tool-spinner__FqgqY .8s linear infinite}.index_tool-progress-item__status__Te4lp{width:16px;height:16px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:bold}.index_tool-progress-item__status--success__dQijS{background:#d4edda;color:#155724}.index_tool-progress-item__status--error__8Yicb{background:#f8d7da;color:#721c24}.index_tool-progress-item__label__1HiZ3{flex:1;font-weight:400}.index_tool-call-display__c4du2{margin:8px 0;border-radius:8px;background:#f8f9fa;border:1px solid #e0e0e0;overflow:hidden;font-size:13px;width:100%;min-width:280px}.index_tool-call-display__header__HJ2XF{display:flex;align-items:center;gap:6px;padding:8px 12px;background:#f0f0f0;border-bottom:1px solid #e0e0e0;color:#555;font-weight:500}.index_tool-call-display__icon__KDfyy{font-size:14px}.index_tool-call-display__title__DuqW6{font-size:12px;text-transform:uppercase;letter-spacing:.5px}.index_tool-call-display__list__tG3dS{display:flex;flex-direction:column}.index_tool-call-item__ssg0E{border-bottom:1px solid #e8e8e8}.index_tool-call-item__ssg0E:last-child{border-bottom:none}.index_tool-call-item--executing__-32HX{background:#fffef0}.index_tool-call-item__header__YPrhM{display:flex;align-items:center;gap:8px;width:100%;padding:10px 12px;background:rgba(0,0,0,0);border:none;cursor:pointer;text-align:left;font-size:13px;transition:background-color .15s}.index_tool-call-item__header__YPrhM:hover{background:#f0f0f0}.index_tool-call-item__icon__3dMPQ{width:18px;height:18px;display:flex;align-items:center;justify-content:center;flex-shrink:0}.index_tool-call-item__spinner__vhrfF{width:14px;height:14px;border:2px solid #ddd;border-top-color:#666;border-radius:50%;animation:index_tool-spinner__FqgqY .8s linear infinite}.index_tool-call-item__status__Pf4hj{width:18px;height:18px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:bold}.index_tool-call-item__status--success__K7b-k{background:#d4edda;color:#155724}.index_tool-call-item__status--error__XPIEc{background:#f8d7da;color:#721c24}.index_tool-call-item__info__sW6NN{flex:1;display:flex;flex-direction:column;gap:2px;min-width:0}.index_tool-call-item__label__mhzXN{font-weight:500;color:#333}.index_tool-call-item__name__9VmR4{font-family:\"SF Mono\",Monaco,Consolas,monospace;font-size:11px;color:#888}.index_tool-call-item__duration__93ZGs{font-size:11px;color:#888;font-family:\"SF Mono\",Monaco,Consolas,monospace}.index_tool-call-item__chevron__YostU{font-size:10px;color:#888;transition:transform .2s}.index_tool-call-item__chevron--expanded__OW782{transform:rotate(180deg)}.index_tool-call-item__content__VfZ9Y{padding:0 12px 12px;background:#fff}.index_tool-call-item__section__ttxR0{margin-top:8px}.index_tool-call-item__section__ttxR0:first-child{margin-top:0}.index_tool-call-item__section-header__YtrkI{display:flex;align-items:center;justify-content:space-between;margin-bottom:4px}.index_tool-call-item__section-label__Ap9MN{font-size:11px;font-weight:600;text-transform:uppercase;color:#666;letter-spacing:.3px}.index_tool-call-item__section-label--error__tWORu{color:#dc3545}.index_tool-call-item__copy-btn__g0jg-{padding:2px 6px;font-size:12px;background:#e9ecef;border:none;border-radius:3px;cursor:pointer;color:#666;transition:background-color .15s,color .15s}.index_tool-call-item__copy-btn__g0jg-:hover{background:#dee2e6;color:#333}.index_tool-call-item__code__0QR8v{margin:0;padding:8px 10px;background:#f5f5f5;border-radius:4px;font-family:\"SF Mono\",Monaco,Consolas,monospace;font-size:12px;line-height:1.4;overflow-x:auto;white-space:pre-wrap;word-break:break-word;max-height:200px;overflow-y:auto}.index_tool-call-item__code--error__Z67UF{background:#fff5f5;color:#dc3545}.index_tool-call-item__empty__Z-fHW{padding:8px;color:#999;font-style:italic;font-size:12px}@keyframes index_tool-spinner__FqgqY{to{transform:rotate(360deg)}}.index_xappw-admin-input-container__Bmia7{flex-shrink:0;z-index:999;padding-left:20px;padding-right:20px;padding-bottom:0;padding-top:10px}.index_xappw-admin-input-container__Bmia7:not(.index_visible__UmVNQ){display:none}.index_xappw-admin-input-container__Bmia7.index_drag-drop-zone__GSLNi{outline:3px dashed gray;outline-offset:-3px}.index_xappw-admin-input-form__5X-fE{display:flex;align-items:center;overflow:hidden;line-height:48px;position:relative}.index_xappw-admin-input-form__buttons__6Kvkt{display:flex;align-items:center;right:10px;z-index:2;margin-right:10px}.index_xappw-admin-input-form__btn__RWw0d{width:56px}.index_xappw-admin-input__j-6Sj{width:calc(100% - 60px);min-height:32px;padding:7px 10px;line-height:normal;display:inline-block;box-sizing:border-box;font-family:var(--xapp-input-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-font-weight, normal);font-size:var(--xapp-input-font-size, 16px);font-style:var(--xapp-input-font-style, normal);color:var(--xapp-input-text-color, #000);outline-width:0;border:var(--xapp-input-border-width, #fff) solid var(--xapp-input-border-color, #fff);border-radius:var(--xapp-input-border-radius, 20px);background:var(--xapp-input-background, #fff);margin:auto}.index_xappw-admin-input__j-6Sj input:focus::placeholder{color:rgba(0,0,0,0)}.index_xappw-admin-input__j-6Sj input::-webkit-input-placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-admin-input__j-6Sj input:-moz-placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-admin-input__j-6Sj input::-moz-placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-admin-input__j-6Sj input:-ms-input-placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-admin-input__j-6Sj input::placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-admin-input__input__MrN7k{border:none;outline:none;font-size:inherit;line-height:inherit}#index_adminBarInput__KypXS{width:100%}.index_xappw-admin-input__j-6Sj{z-index:1}@media screen and (max-width: 640px){.index_xappw-admin-input-form__5X-fE{height:44px}}.index_chat-footer__branding__SMhjL{text-align:end;padding-right:20px;padding-bottom:12px;font-family:var(--xapp-footer-branding-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-footer-branding-font-weight, normal);font-size:var(--xapp-footer-branding-font-size, 14px);font-style:var(--xapp-footer-branding-font-style, normal);color:var(--xapp-footer-branding-text-color, rgba(255, 255, 255, 0.87))}.index_xapp-search-icon-button__I6v9l{border:none;background:none;background-color:rgba(0,0,0,0) !important;cursor:pointer;padding:0;display:flex;align-items:center}.index_xapp-search-icon-button__I6v9l svg{display:block;margin:auto;height:100%}.index_xapp-search-icon-button__content__NLdPh{display:flex;width:100%}.index_xapp-search-icon-button__I6v9l:focus-visible{outline:none;filter:invert(100%)}@media screen and (max-width: 640px){.index_xapp-search-icon-button__I6v9l{box-sizing:border-box;padding:12px;min-height:44px;min-width:44px}}.index_xappw-message-bubble__0DOsl{border-radius:10px;padding:10px;background:var(--xapp-bubble-background, #fff)}.index_xappw-rich-input__input__AQhqU{display:block !important;width:calc(100% - 50px) !important;height:37px;border:none !important;outline:none !important;box-sizing:border-box !important;box-shadow:none !important;margin:0 !important;font-size:inherit !important;line-height:inherit;color:inherit !important;background-color:inherit !important}.index_xappw-rich-input__input__AQhqU:focus{color:inherit !important}@media screen and (max-width: 640px){.index_xappw-rich-input__input__AQhqU{width:calc(100% - 90px)}}.index_xapp-search-rich-text__7sMe4{display:inline-block;max-width:100%;overflow:hidden;white-space:pre-wrap}.index_xappw-suggestions-group__items__uA7AV{display:flex;flex-direction:column;padding:2px 0}.index_xappw-suggestions-group__heading__ONPxD{margin:0 16px}.index_xappw-suggestions-group-heading__N0dzY{display:flex;align-items:center;font-size:12px;padding:2px 0;color:#061739}.index_xappw-suggestions-group-heading__N0dzY:after{content:\"\";border-top:solid 1px #d4d4d4;flex:1 1 auto;margin-left:8px}.index_xappw-suggestions-item__aeHVy{padding:0 0 0 24px;box-sizing:border-box;width:100%;white-space:nowrap;display:flex;align-items:center;overflow:hidden;font-size:15px;cursor:pointer;border-bottom:solid 1px rgba(0,0,0,0);color:#061739}.index_xappw-suggestions-item--current__DseFz,.index_xappw-suggestions-item__aeHVy:hover{background-color:#3395d2;color:#fff;text-decoration:underline}@media(hover: hover){.index_xappw-suggestions-item--current__DseFz .index_xappw-suggestions-item__actions__6qh4p,.index_xappw-suggestions-item__aeHVy:hover .index_xappw-suggestions-item__actions__6qh4p{visibility:visible;color:#fff}}.index_xappw-suggestions-item__texts__meRy8{padding:3px 0;flex:1 1 auto;overflow:hidden}.index_xappw-suggestions-item__actions__6qh4p{flex:0 0 auto;display:flex;margin-left:8px}@media(hover: hover){.index_xappw-suggestions-item__actions__6qh4p{visibility:hidden}}.index_xappw-suggestions-list__fAwJY{display:flex;flex-direction:column}.index_xapp-search-rich-text-span__A6uiV{flex:0 1 auto;display:inline-block;max-width:100%}.index_xapp-search-rich-text-span__A6uiV:last-child{overflow:hidden;white-space:pre;text-overflow:ellipsis}.index_xapp-search-rich-text-bold-span__hQMEo{font-weight:bold}.index_xapp-search-rich-text-input-span__05xDB{text-decoration:none;font-size:inherit;height:calc(1.5em - 2px);line-height:1em;width:8em;color:inherit}.index_xapp-search-rich-text-input-span--readonly__a24sX{border:dashed 1px green;color:green;height:calc(1em - 2px)}.index_xapp-search-rich-text-normal-span__g6bpN{font-weight:normal}.index_xappw-suggestions__AXXnL{display:flex;flex-direction:column;font-family:RobotoRegular,serif}.index_xappw-suggestions__answer__nv243{background-color:#d9d9d9;padding:8px 11px;border-radius:12px 12px 0px 0px}.index_xappw-suggestions__groups__nE4V7{background-color:#f3f3f3;padding:8px 0;border-bottom:1px solid #e5e5e5}.index_xappw-suggestions__use__Qjoku{width:28px;padding:4px;color:inherit}.index_xappw-suggestions__use__Qjoku svg{display:block;margin:auto;height:100%}.index_xappw-input-container__-ZKmI{flex-shrink:0;z-index:999;padding:6px 20px}.index_xappw-input-container__-ZKmI:not(.index_visible__UmVNQ){display:none}.index_xappw-input-container__-ZKmI.index_drag-drop-zone__GSLNi{outline:3px dashed gray;outline-offset:-3px}.index_xappw-input-form__d3aV6{display:flex;align-items:center;overflow:hidden;line-height:48px;position:relative;border-radius:var(--xapp-input-border-radius, 20px);background:var(--xapp-input-background, #fff);padding:0px !important;border:1px solid var(--xapp-input-border-color, #e0e0e0);transition:border-color .2s ease,box-shadow .2s ease}.index_xappw-input-form__d3aV6:focus-within{border-color:var(--xapp-input-focus-border-color, var(--xapp-primary-color, #0075aa));box-shadow:var(--xapp-input-focus-shadow, 0 0 0 3px rgba(0, 117, 170, 0.1))}.index_xappw-input-form__buttons__p4cLC{display:flex;align-items:center;position:absolute;right:10px;z-index:2}.index_xappw-input-form__btn__qADxv{min-width:20px;width:20px;height:16px}.index_xappw-input-form__counter__qZPhR{font-size:11px;color:#888;margin-right:8px;white-space:nowrap}.index_xappw-input-form__counter--limit__AeHa4{color:#d32f2f}.index_xappw-input__t-qZP{min-height:32px;padding:7px 10px;line-height:normal;display:inline-block;box-sizing:border-box;font-family:var(--xapp-input-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-font-weight, normal);font-size:var(--xapp-input-font-size, 16px);font-style:var(--xapp-input-font-style, normal);color:var(--xapp-input-text-color, #000);outline-width:0;flex-grow:1;border:var(--xapp-input-border-width, #fff) solid var(--xapp-input-border-color, #fff);background:rgba(0,0,0,0)}.index_xappw-input__t-qZP input:focus::placeholder{color:rgba(0,0,0,0)}.index_xappw-input__t-qZP input::-webkit-input-placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-input__t-qZP input:-moz-placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-input__t-qZP input::-moz-placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-input__t-qZP input:-ms-input-placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-input__t-qZP input::placeholder{font-family:var(--xapp-input-placeholder-font-family, \"RobotoRegular\", \"serif\");font-weight:var(--xapp-input-placeholder-font-weight, normal);font-size:var(--xapp-input-placeholder-font-size, 14px);font-style:var(--xapp-input-placeholder-font-style, normal);color:var(--xapp-input-placeholder-text-color, #e1e2e1)}.index_xappw-input__t-qZP{z-index:1}@media screen and (max-width: 640px){.index_xappw-input-form__d3aV6{height:44px}}.index_message-form__kjy-v .index_section__Cgk4C{margin-bottom:16px}.index_message-form__kjy-v .index_label__t4Fj9{display:block;margin-bottom:4px;color:var(--xapp-primary-color, #616161)}.index_message-form__kjy-v input,.index_message-form__kjy-v textarea{border:1px solid #ddd;border-radius:4px;outline-width:0;width:100%;font-size:14px;box-sizing:border-box}.index_message-form__kjy-v input{height:32px;padding:0 10px}.index_message-form__kjy-v textarea{padding:8px 10px;min-height:100px;resize:none;overflow-y:auto}.index_message-form__submit__TfqPd{width:100%;background-color:var(--xapp-primary-color, #616161);color:#fff}.index_message-form--shrink-enter__Fit2C{opacity:.01;position:relative;top:100px}.index_message-form--shrink-enter-active__zJcfx{position:relative;top:0;opacity:1;transition:opacity 500ms,top 500ms;transition-delay:500ms}.index_message-form--shrink-exit__N4xLX{opacity:.5;position:relative;top:0}.index_message-form--shrink-exit-active__ca2fv{top:-200px;opacity:.01;transition:top 500ms,opacity 500ms}.index_message-form--grow-enter__sMkzM{opacity:.5;position:relative;top:-200px}.index_message-form--grow-enter-active__l3Nec{position:relative;top:0;opacity:1;transition:opacity 500ms,top 500ms}.index_message-form--grow-exit__BKo98{opacity:.5;position:relative;top:0;height:50px}.index_message-form--grow-exit-active__kGdyH{top:-100px;height:0;opacity:.01;transition:top 500ms,opacity 500ms,height 500ms}.index_message-form--sent__-pc-r .index_button-resend__XOLN8{width:100%;margin-top:16px;background-color:var(--xapp-primary-color, #616161);color:#fff}.index_xappw-multiselect__kQB50{list-style:none;padding:0;margin:0}.index_xappw-multiselect__kQB50 li{padding:0;margin:0}.index_card-container__3Fy4U{padding-top:16px;position:relative}.index_card-container__content__gpXzs{color:#555;border-radius:8px;border:1px solid #ddd;padding:24px 16px 16px 16px;font-size:14px}.index_card-container__title__B-KRU{text-align:center;color:var(--xapp-primary-color, #616161);margin-bottom:8px}.index_card-container__icon__g0NyB{width:32px;height:32px;position:relative;background-color:#fff;border:1px solid #e0e0e0;border-radius:50%;box-shadow:0 2px 4px 0 rgba(0,0,0,.1);margin:-16px auto;z-index:999}.index_card-container__icon__g0NyB svg{display:block;margin:auto;height:100%}@keyframes index_typing-animation__Fxjgv{0%{transform:translateY(0px)}28%{transform:translateY(-5px)}44%{transform:translateY(0px)}}.index_typing-indicator__HwsxU{height:20px;display:inline-flex;align-items:center}.index_typing-indicator-part__3S7of:nth-child(1){animation-delay:200ms}.index_typing-indicator-part__3S7of:nth-child(2){animation-delay:300ms}.index_typing-indicator-part__3S7of:nth-child(3){animation-delay:400ms}.index_typing-indicator-part__3S7of{display:inline-block;animation:index_typing-animation__Fxjgv 1.5s infinite ease-in-out;border-radius:50%;width:7px;height:7px;margin:0 3px;background-color:#7a7a7a}.index_xappw-send-button__zxbpc{color:var(--xapp-send-button-color, #505050) !important;margin:0;background:var(--xapp-send-button-bg, transparent) !important}.index_xappw-send-button__zxbpc:hover{background:var(--xapp-send-button-hover-bg, transparent) !important}.index_xappw-send-button__zxbpc:disabled{background:var(--xapp-send-button-disabled-bg, transparent) !important}.index_xappw-custom-send-button__hyD04{display:inline-flex;align-items:center;justify-content:center;cursor:pointer;user-select:none;width:var(--xapp-send-button-width, 20px);height:var(--xapp-send-button-width, 20px);border:unset;background:rgba(0,0,0,0);padding:8px;border-radius:50%;transition:opacity .2s ease,background-color .2s ease;position:relative;box-sizing:border-box}.index_xappw-custom-send-button__hyD04:disabled{cursor:not-allowed;opacity:.6}.index_xappw-custom-send-button__hyD04:focus-visible{outline:2px solid var(--xapp-primary-color, #0075aa);outline-offset:2px}.index_xappw-custom-send-button__hyD04:hover:not(:disabled){background-color:rgba(0,0,0,.05)}.index_xappw-custom-send-button__hyD04 .index_send-button-icon__VKlh6{width:24px;height:24px;display:block}@media screen and (max-width: 640px){.index_xappw-send-button__zxbpc{box-sizing:border-box !important;padding:12px !important;min-height:44px;min-width:44px;margin:0}.index_xappw-custom-send-button__hyD04{box-sizing:border-box !important;padding:10px !important;min-height:44px;min-width:44px;width:44px;height:44px;margin:0}.index_xappw-custom-send-button__hyD04 .index_send-button-icon__VKlh6{width:24px;height:24px}.index_xappw-custom-send-button__hyD04>img{width:24px;height:24px}}";
styleInject(css_248z$1l);

const ErrorBoundary = ({ children }) => {
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        const errorHandler = (error) => {
            setHasError(true);
            console.error("Error caught by ErrorBoundary: ", error);
        };
        window.addEventListener('error', errorHandler);
        return () => {
            window.removeEventListener('error', errorHandler);
        };
    }, []);
    if (hasError) {
        return (React__default$4.createElement("div", null, "Something went wrong loading this component"));
    }
    return React__default$4.createElement(React__default$4.Fragment, null, children);
};

function getWidgetUrl() {
    var _a;
    const defaultUrl = "https://widget.xapp.ai";
    try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore It won't always exist
        return ((_a = window.xaStudioConfig) === null || _a === void 0 ? void 0 : _a.widgetUrl) || defaultUrl;
    }
    catch (e) {
        console.warn(`error getting default apiUrl`);
        console.error(e);
        return defaultUrl;
    }
}
const ChatWidget = props => {
    const { widgetKey, mode, environment } = props;
    const [config, setConfig] = useState();
    useEffect(() => {
        if (widgetKey) {
            // Dev Environment
            // https://dev-widget.xapp.media/
            const urlConfig = `${getWidgetUrl()}/config.json?key=${widgetKey}`;
            fetch(urlConfig).then((resp) => {
                if (resp.status === 200) {
                    return resp.json();
                }
            }).then((json) => {
                var _a;
                const env = Object.assign(Object.assign({}, json), { header: Object.assign(Object.assign({}, json === null || json === void 0 ? void 0 : json.header), { actions: Object.assign(Object.assign({}, (_a = json === null || json === void 0 ? void 0 : json.header) === null || _a === void 0 ? void 0 : _a.actions), { refresh: props.displayRefresh }) }), attributes: Object.assign(Object.assign({}, json === null || json === void 0 ? void 0 : json.attributes), { environment: environment || "staging" }) });
                setConfig(env);
            });
        }
    }, [widgetKey, setConfig, environment, props.displayRefresh]);
    if (!config) {
        return (React__default$4.createElement(React__default$4.Fragment, null));
    }
    return (React__default$4.createElement(ErrorBoundary, null,
        React__default$4.createElement(Chat, { config: config, mode: mode || "normal" })));
};

var css_248z$1k = ".Checkbox-module_checkboxWrapper__A680D {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n}\n.Checkbox-module_checkboxWrapper__A680D.Checkbox-module_disabled__WagIC {\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.Checkbox-module_checkbox__D0D4S {\n  position: relative;\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  margin-right: 8px;\n}\n\n.Checkbox-module_checkbox__D0D4S input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n\n.Checkbox-module_checkmark__pjJT2 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;\n  width: 18px;\n  background-color: #fff;\n  border: 2px solid #757575;\n  border-radius: 2px;\n  transition: all 0.2s ease;\n}\n\n.Checkbox-module_checkboxWrapper__A680D:hover .Checkbox-module_checkmark__pjJT2 {\n  border-color: #3f51b5;\n}\n\n.Checkbox-module_checkbox__D0D4S input:checked ~ .Checkbox-module_checkmark__pjJT2 {\n  background-color: #3f51b5;\n  border-color: #3f51b5;\n}\n\n.Checkbox-module_checkmark__pjJT2:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n  left: 5px;\n  top: 2px;\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.Checkbox-module_checkbox__D0D4S input:checked ~ .Checkbox-module_checkmark__pjJT2:after {\n  display: block;\n}\n\n.Checkbox-module_checkbox__D0D4S input:disabled ~ .Checkbox-module_checkmark__pjJT2 {\n  background-color: #f5f5f5;\n  border-color: #e0e0e0;\n}\n\n.Checkbox-module_label__JBaRm {\n  font-size: 14px;\n  color: #333;\n  line-height: 18px;\n}\n\n.Checkbox-module_disabled__WagIC .Checkbox-module_label__JBaRm {\n  color: #999;\n}";
var styles$l = {"checkboxWrapper":"Checkbox-module_checkboxWrapper__A680D","disabled":"Checkbox-module_disabled__WagIC","checkbox":"Checkbox-module_checkbox__D0D4S","checkmark":"Checkbox-module_checkmark__pjJT2","label":"Checkbox-module_label__JBaRm"};
styleInject(css_248z$1k);

/**
 * A simple, material-like checkbox component with an optional label.
 * Compatible with react-toolbox Checkbox API.
 *
 * @param {CheckboxProps} props - The properties object for the checkbox.
 * @returns {JSX.Element} The checkbox component.
 */
const Checkbox = ({ checked = false, onChange, label, disabled = false, className, theme }) => {
    const handleChange = (e) => {
        if (onChange && !disabled) {
            onChange(e.target.checked);
        }
    };
    const wrapperClass = [
        styles$l.checkboxWrapper,
        className,
        disabled ? styles$l.disabled : '',
        theme === null || theme === void 0 ? void 0 : theme.field
    ].filter(Boolean).join(' ');
    return (React__default$4.createElement("label", { className: wrapperClass },
        React__default$4.createElement("div", { className: styles$l.checkbox },
            React__default$4.createElement("input", { type: "checkbox", checked: checked, disabled: disabled, onChange: handleChange }),
            React__default$4.createElement("span", { className: styles$l.checkmark })),
        label && React__default$4.createElement("span", { className: styles$l.label }, label)));
};

const Chips = ({ label, placeholder, values, onChange }) => {
    const [inputValue, setInputValue] = useState();
    const handleKeyPress = (key) => {
        // on enter, we add the new value
        if (key === 'Enter' && inputValue) {
            const updatedValues = [...values || [], inputValue];
            onChange({ value: updatedValues });
            setInputValue('');
        }
    };
    const showPlaceholder = !Array.isArray(values) || (values === null || values === void 0 ? void 0 : values.length) === 0;
    const handleDelete = (index) => {
        const chipsCopy = [...values];
        chipsCopy.splice(index, 1);
        onChange({ value: [...chipsCopy] });
    };
    return (React__default$4.createElement(FormControl, { style: { width: '100%', overflowY: 'hidden' } },
        React__default$4.createElement(InputLabel$1, { htmlFor: "outlined-adornmentd", style: { margin: "15px 0px" } }, label),
        React__default$4.createElement(OutlinedInput, { id: "outlined-adornmentd", value: inputValue, onKeyDown: (evt) => handleKeyPress(evt.key), onChange: (evt) => setInputValue(evt.target.value), placeholder: showPlaceholder ? placeholder : "", style: { padding: "5px", boxSizing: "border-box" }, startAdornment: React__default$4.createElement(InputAdornment$1, { position: "start", id: 'adornment', style: { height: "auto", maxHeight: "none" } },
                React__default$4.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                        padding: "2px",
                        margin: "10px 0px"
                    } }, values && values.length > 0 &&
                    values.map((value, index) => React__default$4.createElement(Chip, { key: index, label: value, style: { margin: 3 }, onDelete: () => handleDelete(index) })))) })));
};

var css_248z$1j = ".CircularProgress_spinner__rWOvt {\n  animation: CircularProgress_rotate__WhuYd 1.4s linear infinite;\n}\n\n.CircularProgress_circle__rN5Vv {\n  stroke-dasharray: 80, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: CircularProgress_dash__AC-1Z 1.4s ease-in-out infinite;\n}\n\n@keyframes CircularProgress_rotate__WhuYd {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes CircularProgress_dash__AC-1Z {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 80, 200;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 80, 200;\n    stroke-dashoffset: -113;\n  }\n}";
var style$T = {"spinner":"CircularProgress_spinner__rWOvt","rotate":"CircularProgress_rotate__WhuYd","circle":"CircularProgress_circle__rN5Vv","dash":"CircularProgress_dash__AC-1Z"};
styleInject(css_248z$1j);

const CircularProgress = ({ size = 24, color = "currentColor", style: inlineStyle }) => {
    return (React__default$4.createElement("svg", { className: style$T.spinner, width: size, height: size, viewBox: "0 0 44 44", style: inlineStyle },
        React__default$4.createElement("circle", { className: style$T.circle, cx: "22", cy: "22", r: "18", fill: "none", stroke: color, strokeWidth: "4" })));
};

var lib$4 = {};

var Alpha$2 = {};

var lib$3 = {};

var flattenNames$1 = {};

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$9 = freeGlobal || freeSelf || Function('return this')();

var _root = root$9;

var root$8 = _root;

/** Built-in value references. */
var Symbol$8 = root$8.Symbol;

var _Symbol = Symbol$8;

var Symbol$7 = _Symbol;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$f.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$f.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$7 ? Symbol$7.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$e.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$e = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$e.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$6 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$9(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$9;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$i = Array.isArray;

var isArray_1 = isArray$i;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$c(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$c;

var baseGetTag$8 = _baseGetTag,
    isArray$h = isArray_1,
    isObjectLike$b = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag$4 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray$h(value) && isObjectLike$b(value) && baseGetTag$8(value) == stringTag$4);
}

var isString_1 = isString;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$2 = createBaseFor();

var _baseFor = baseFor$2;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

var baseGetTag$7 = _baseGetTag,
    isObjectLike$a = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$a(value) && baseGetTag$7(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$9 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$d.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$d.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$4 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$9(value) && hasOwnProperty$d.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$4;

var isBuffer$4 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
}(isBuffer$4, isBuffer$4.exports));

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;

var baseGetTag$6 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$8 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$4 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$2 = '[object Function]',
    mapTag$5 = '[object Map]',
    numberTag$4 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$4] =
typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] =
typedArrayTags[errorTag$2] = typedArrayTags[funcTag$2] =
typedArrayTags[mapTag$5] = typedArrayTags[numberTag$4] =
typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$3] =
typedArrayTags[setTag$5] = typedArrayTags[stringTag$3] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$8(value) &&
    isLength$2(value.length) && !!typedArrayTags[baseGetTag$6(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$4(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$4;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$3 = _baseUnary,
    nodeUtil$2 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$4 = nodeIsTypedArray ? baseUnary$3(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$4;

var baseTimes = _baseTimes,
    isArguments$3 = isArguments_1,
    isArray$g = isArray_1,
    isBuffer$3 = isBuffer$4.exports,
    isIndex$2 = _isIndex,
    isTypedArray$3 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$c.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$g(value),
      isArg = !isArr && isArguments$3(value),
      isBuff = !isArr && !isArg && isBuffer$3(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$3(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$c.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$2(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$b = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$3(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$b;

  return value === proto;
}

var _isPrototype = isPrototype$3;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$2 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$b.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$h(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$h;

var baseGetTag$5 = _baseGetTag,
    isObject$g = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$4(value) {
  if (!isObject$g(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$5(value);
  return tag == funcTag$1 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$4;

var isFunction$3 = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$9(value) {
  return value != null && isLength$1(value.length) && !isFunction$3(value);
}

var isArrayLike_1 = isArrayLike$9;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$8 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$7(object) {
  return isArrayLike$8(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}

var keys_1 = keys$7;

var baseFor$1 = _baseFor,
    keys$6 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$3(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys$6);
}

var _baseForOwn = baseForOwn$3;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$g(value) {
  return value;
}

var identity_1 = identity$g;

var identity$f = identity_1;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction$2(value) {
  return typeof value == 'function' ? value : identity$f;
}

var _castFunction = castFunction$2;

var baseForOwn$2 = _baseForOwn,
    castFunction$1 = _castFunction;

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn$2(object, castFunction$1(iteratee));
}

var forOwn_1 = forOwn;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$3 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$3;

var baseGetTag$4 = _baseGetTag,
    getPrototype$2 = _getPrototype,
    isObjectLike$7 = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$9 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$9.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$2(value) {
  if (!isObjectLike$7(value) || baseGetTag$4(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype$2(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$a.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$2;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$4(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$4;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$5(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$5;

var eq$4 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$4(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var root$7 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$7['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$2 = isFunction_1,
    isMasked = _isMasked,
    isObject$f = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$8 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$8.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$9).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$f(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$2;

var baseIsNative = _baseIsNative,
    getValue$1 = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$6 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$6(root$6, 'Map');

var _Map = Map$4;

var getNative$5 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$5(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$7.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$8.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$6.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$7.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$3 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE$1 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$4(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$4.prototype.clear = stackClear;
Stack$4.prototype['delete'] = stackDelete;
Stack$4.prototype.get = stackGet;
Stack$4.prototype.has = stackHas;
Stack$4.prototype.set = stackSet;

var _Stack = Stack$4;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$2(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;

var _SetCache = SetCache$2;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$2;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$2(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$2;

var SetCache$1 = _SetCache,
    arraySome$1 = _arraySome,
    cacheHas$1 = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache$1 : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome$1(other, function(othValue, othIndex) {
            if (!cacheHas$1(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$5 = _root;

/** Built-in value references. */
var Uint8Array$3 = root$5.Uint8Array;

var _Uint8Array = Uint8Array$3;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$3(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$3;

var Symbol$5 = _Symbol,
    Uint8Array$2 = _Uint8Array,
    eq$3 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray$2 = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$4 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    symbolTag$3 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$5 ? Symbol$5.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$3:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$2:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;

    case boolTag$3:
    case dateTag$2:
    case numberTag$3:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$3(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$2:
    case stringTag$2:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$4:
      var convert = mapToArray;

    case setTag$4:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$3;

var arrayPush$2 = _arrayPush,
    isArray$f = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$f(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols$2 = _getSymbols,
    keys$5 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$5, getSymbols$2);
}

var _getAllKeys = getAllKeys$2;

var getAllKeys$1 = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$4.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys$1(object),
      objLength = objProps.length,
      othProps = getAllKeys$1(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$6.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$4 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$4(root$4, 'DataView');

var _DataView = DataView$2;

var getNative$3 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$3(root$3, 'Promise');

var _Promise = Promise$2;

var getNative$2 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$2(root$2, 'Set');

var _Set = Set$3;

var getNative$1 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative$1(root$1, 'WeakMap');

var _WeakMap = WeakMap$2;

var DataView$1 = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$2 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag$3 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$5 = baseGetTag$3;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag$5(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$1 && getTag$5(new Map$1) != mapTag$3) ||
    (Promise$1 && getTag$5(Promise$1.resolve()) != promiseTag) ||
    (Set$2 && getTag$5(new Set$2) != setTag$3) ||
    (WeakMap$1 && getTag$5(new WeakMap$1) != weakMapTag$1)) {
  getTag$5 = function(value) {
    var result = baseGetTag$3(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$5;

var Stack$3 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$4 = _getTag,
    isArray$e = isArray_1,
    isBuffer$2 = isBuffer$4.exports,
    isTypedArray$2 = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$1 = '[object Object]';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$3.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$e(object),
      othIsArr = isArray$e(other),
      objTag = objIsArr ? arrayTag$1 : getTag$4(object),
      othTag = othIsArr ? arrayTag$1 : getTag$4(other);

  objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$1 : othTag;

  var objIsObj = objTag == objectTag$1,
      othIsObj = othTag == objectTag$1,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$2(object)) {
    if (!isBuffer$2(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$3);
    return (objIsArr || isTypedArray$2(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$5.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$5.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$3);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$3);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$6 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$6(value) && !isObjectLike$6(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;

var Stack$2 = _Stack,
    baseIsEqual$2 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$2;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$e = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$e(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$4 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$4(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var baseGetTag$2 = _baseGetTag,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$6(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$5(value) && baseGetTag$2(value) == symbolTag$2);
}

var isSymbol_1 = isSymbol$6;

var isArray$d = isArray_1,
    isSymbol$5 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$d(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$5(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$2.Cache = MapCache;

var memoize_1 = memoize$2;

var memoize$1 = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize$1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

var Symbol$4 = _Symbol,
    arrayMap$3 = _arrayMap,
    isArray$c = isArray_1,
    isSymbol$4 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$c(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$3(value, baseToString$1) + '';
  }
  if (isSymbol$4(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$2;

var isArray$b = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString$1 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$4(value, object) {
  if (isArray$b(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$1(value));
}

var _castPath = castPath$4;

var isSymbol$3 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$3(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$3 = _castPath,
    toKey$4 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$4(object, path) {
  path = castPath$3(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$4(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$4;

var baseGet$3 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$3(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath$2 = _castPath,
    isArguments$2 = isArguments_1,
    isArray$a = isArray_1,
    isIndex$1 = _isIndex,
    isLength = isLength_1,
    toKey$3 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$2(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$1(key, length) &&
    (isArray$a(object) || isArguments$2(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual$1 = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$2 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet$2 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$2(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey$1 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$e = identity_1,
    isArray$9 = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$b(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$e;
  }
  if (typeof value == 'object') {
    return isArray$9(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$b;

var isArrayLike$7 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$7(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn$1 = _baseForOwn,
    createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$4 = createBaseEach(baseForOwn$1);

var _baseEach = baseEach$4;

var baseEach$3 = _baseEach,
    isArrayLike$6 = isArrayLike_1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$2(collection, iteratee) {
  var index = -1,
      result = isArrayLike$6(collection) ? Array(collection.length) : [];

  baseEach$3(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$2;

var arrayMap$2 = _arrayMap,
    baseIteratee$a = _baseIteratee,
    baseMap$1 = _baseMap,
    isArray$8 = isArray_1;

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map$6(collection, iteratee) {
  var func = isArray$8(collection) ? arrayMap$2 : baseMap$1;
  return func(collection, baseIteratee$a(iteratee));
}

var map_1 = map$6;

Object.defineProperty(flattenNames$1, "__esModule", {
  value: true
});
flattenNames$1.flattenNames = undefined;

var _isString2 = isString_1;

var _isString3 = _interopRequireDefault$3m(_isString2);

var _forOwn2$2 = forOwn_1;

var _forOwn3$2 = _interopRequireDefault$3m(_forOwn2$2);

var _isPlainObject2 = isPlainObject_1;

var _isPlainObject3 = _interopRequireDefault$3m(_isPlainObject2);

var _map2$7 = map_1;

var _map3 = _interopRequireDefault$3m(_map2$7);

function _interopRequireDefault$3m(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = flattenNames$1.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3$2.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

flattenNames$1.default = flattenNames;

var mergeClasses$1 = {};

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$2;

var getNative = _getNative;

var defineProperty$2 = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$11 = defineProperty$2;

var defineProperty$1 = _defineProperty$11;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$4(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$4;

var baseAssignValue$3 = _baseAssignValue,
    eq$2 = eq_1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$2.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$4.call(object, key) && eq$2(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$3(object, key, value);
  }
}

var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
    baseAssignValue$2 = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$6(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$2(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$6;

var copyObject$5 = _copyObject,
    keys$3 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$5(source, keys$3(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$d = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$1.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$d(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike$5 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$5(object) {
  return isArrayLike$5(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$5;

var copyObject$4 = _copyObject,
    keysIn$4 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$4(source, keysIn$4(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

(function (module, exports) {
var root = _root;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
}(_cloneBuffer, _cloneBuffer.exports));

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$2(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$2;

var copyObject$3 = _copyObject,
    getSymbols$1 = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$3(source, getSymbols$1(source), object);
}

var _copySymbols = copySymbols$1;

var arrayPush$1 = _arrayPush,
    getPrototype$1 = _getPrototype,
    getSymbols = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols(object));
    object = getPrototype$1(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

var copyObject$2 = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject$2(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$3 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$2(object) {
  return baseGetAllKeys(object, keysIn$3, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$2;

/** Used for built-in method references. */

var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$2.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var Uint8Array$1 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$3 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$2(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$2;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray$1 = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$2:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray$1(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$2:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$c = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$c(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype = _getPrototype,
    isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$2(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject$2;

var getTag$3 = _getTag,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$4(value) && getTag$3(value) == mapTag$1;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$2 = _baseUnary,
    nodeUtil$1 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$2 = _getTag,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike$3(value) && getTag$2(value) == setTag$1;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary$1 = _baseUnary,
    nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack$1 = _Stack,
    arrayEach$1 = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer$1 = _cloneBuffer.exports,
    copyArray$1 = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys = _getAllKeys,
    getAllKeysIn$1 = _getAllKeysIn,
    getTag$1 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject$1 = _initCloneObject,
    isArray$7 = isArray_1,
    isBuffer$1 = isBuffer$4.exports,
    isMap = isMap_1,
    isObject$b = isObject_1,
    isSet = isSet_1,
    keys$2 = keys_1,
    keysIn$2 = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$2 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag$1] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag$1] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$2(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$2,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$2;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$b(value)) {
    return value;
  }
  var isArr = isArray$7(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray$1(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer$1(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject$1(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$1);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$2(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$2(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn$1 : getAllKeys)
    : (isFlat ? keysIn$2 : keys$2);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach$1(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$2(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$2;

var baseClone$1 = _baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone$1(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}

var cloneDeep_1 = cloneDeep;

Object.defineProperty(mergeClasses$1, "__esModule", {
  value: true
});
mergeClasses$1.mergeClasses = undefined;

var _forOwn2$1 = forOwn_1;

var _forOwn3$1 = _interopRequireDefault$3l(_forOwn2$1);

var _cloneDeep2 = cloneDeep_1;

var _cloneDeep3 = _interopRequireDefault$3l(_cloneDeep2);

var _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault$3l(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = mergeClasses$1.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3$1.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends$10({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

mergeClasses$1.default = mergeClasses;

var autoprefix$1 = {};

Object.defineProperty(autoprefix$1, "__esModule", {
  value: true
});
autoprefix$1.autoprefix = undefined;

var _forOwn2 = forOwn_1;

var _forOwn3 = _interopRequireDefault$3k(_forOwn2);

var _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault$3k(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = autoprefix$1.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends$$({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

autoprefix$1.default = autoprefix;

var hover$1 = {};

Object.defineProperty(hover$1, "__esModule", {
  value: true
});
hover$1.hover = undefined;

var _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1Q = React__default$4;

var _react2$W = _interopRequireDefault$3j(_react$1Q);

function _interopRequireDefault$3j(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$T(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$I(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$I(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = hover$1.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits$I(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$T(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$I(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2$W.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2$W.default.createElement(Component, _extends$_({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn$I(_this, _ret);
    }

    return Hover;
  }(_react2$W.default.Component);
};

hover$1.default = hover;

var active$1 = {};

Object.defineProperty(active$1, "__esModule", {
  value: true
});
active$1.active = undefined;

var _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1P = React__default$4;

var _react2$V = _interopRequireDefault$3i(_react$1P);

function _interopRequireDefault$3i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$S(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$H(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$H(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = active$1.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits$H(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$S(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$H(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2$V.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2$V.default.createElement(Component, _extends$Z({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn$H(_this, _ret);
    }

    return Active;
  }(_react2$V.default.Component);
};

active$1.default = active;

var loop = {};

Object.defineProperty(loop, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

loop.default = loopable;

Object.defineProperty(lib$3, "__esModule", {
  value: true
});
lib$3.ReactCSS = lib$3.loop = lib$3.handleActive = lib$3.handleHover = lib$3.hover = undefined;

var _flattenNames = flattenNames$1;

var _flattenNames2 = _interopRequireDefault$3h(_flattenNames);

var _mergeClasses = mergeClasses$1;

var _mergeClasses2 = _interopRequireDefault$3h(_mergeClasses);

var _autoprefix = autoprefix$1;

var _autoprefix2 = _interopRequireDefault$3h(_autoprefix);

var _hover2 = hover$1;

var _hover3 = _interopRequireDefault$3h(_hover2);

var _active = active$1;

var _active2 = _interopRequireDefault$3h(_active);

var _loop2 = loop;

var _loop3 = _interopRequireDefault$3h(_loop2);

function _interopRequireDefault$3h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

lib$3.hover = _hover3.default;
lib$3.handleHover = _hover3.default;
lib$3.handleActive = _active2.default;
lib$3.loop = _loop3.default;
var ReactCSS = lib$3.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

lib$3.default = ReactCSS;

var common = {};

var Alpha$1 = {};

var alpha$2 = {};

Object.defineProperty(alpha$2, "__esModule", {
  value: true
});
alpha$2.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};

var Checkboard$1 = {};

var checkboard$1 = {};

Object.defineProperty(checkboard$1, "__esModule", {
  value: true
});
var checkboardCache = {};

var render = checkboard$1.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

checkboard$1.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};

Object.defineProperty(Checkboard$1, "__esModule", {
  value: true
});
Checkboard$1.Checkboard = undefined;

var _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1O = React__default$4;

var _react2$U = _interopRequireDefault$3g(_react$1O);

var _reactcss$J = lib$3;

var _reactcss2$J = _interopRequireDefault$3g(_reactcss$J);

var _checkboard = checkboard$1;

var checkboard = _interopRequireWildcard$11(_checkboard);

function _interopRequireWildcard$11(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$3g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = Checkboard$1.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;

  var styles = (0, _reactcss2$J.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return (0, _react$1O.isValidElement)(children) ? _react2$U.default.cloneElement(children, _extends$Y({}, children.props, { style: _extends$Y({}, children.props.style, styles.grid) })) : _react2$U.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

Checkboard$1.default = Checkboard;

Object.defineProperty(Alpha$1, "__esModule", {
  value: true
});
Alpha$1.Alpha = undefined;

var _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$R = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1N = React__default$4;

var _react2$T = _interopRequireDefault$3f(_react$1N);

var _reactcss$I = lib$3;

var _reactcss2$I = _interopRequireDefault$3f(_reactcss$I);

var _alpha = alpha$2;

var alpha$1 = _interopRequireWildcard$10(_alpha);

var _Checkboard$1 = Checkboard$1;

var _Checkboard2$1 = _interopRequireDefault$3f(_Checkboard$1);

function _interopRequireWildcard$10(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$3f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$R(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$G(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$G(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = Alpha$1.Alpha = function (_ref) {
  _inherits$G(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$R(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$G(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = alpha$1.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn$G(_this, _ret);
  }

  _createClass$R(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2$I.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends$X({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2$T.default.createElement(
        'div',
        { style: styles.alpha },
        _react2$T.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2$T.default.createElement(_Checkboard2$1.default, { renderers: this.props.renderers })
        ),
        _react2$T.default.createElement('div', { style: styles.gradient }),
        _react2$T.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2$T.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2$T.default.createElement(this.props.pointer, this.props) : _react2$T.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(_react$1N.PureComponent || _react$1N.Component);

Alpha$1.default = Alpha;

var EditableInput$1 = {};

Object.defineProperty(EditableInput$1, "__esModule", {
  value: true
});
EditableInput$1.EditableInput = undefined;

var _createClass$Q = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1M = React__default$4;

var _react2$S = _interopRequireDefault$3e(_react$1M);

var _reactcss$H = lib$3;

var _reactcss2$H = _interopRequireDefault$3e(_reactcss$H);

function _interopRequireDefault$3e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty$10(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$Q(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$F(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$F(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter$1 = 1;

var EditableInput = EditableInput$1.EditableInput = function (_ref) {
  _inherits$F(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck$Q(this, EditableInput);

    var _this = _possibleConstructorReturn$F(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };

    _this.inputId = 'rc-editable-input-' + idCounter$1++;
    return _this;
  }

  _createClass$Q(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty$10({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2$H.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2$S.default.createElement(
        'div',
        { style: styles.wrap },
        _react2$S.default.createElement('input', {
          id: this.inputId,
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? _react2$S.default.createElement(
          'label',
          {
            htmlFor: this.inputId,
            style: styles.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(_react$1M.PureComponent || _react$1M.Component);

EditableInput$1.default = EditableInput;

var Hue$2 = {};

var hue$3 = {};

Object.defineProperty(hue$3, "__esModule", {
  value: true
});
hue$3.calculateChange = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }
  return null;
};

Object.defineProperty(Hue$2, "__esModule", {
  value: true
});
Hue$2.Hue = undefined;

var _createClass$P = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1L = React__default$4;

var _react2$R = _interopRequireDefault$3d(_react$1L);

var _reactcss$G = lib$3;

var _reactcss2$G = _interopRequireDefault$3d(_reactcss$G);

var _hue = hue$3;

var hue$2 = _interopRequireWildcard$$(_hue);

function _interopRequireWildcard$$(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$3d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$P(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$E(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$E(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue$1 = Hue$2.Hue = function (_ref) {
  _inherits$E(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$P(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$E(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = hue$2.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn$E(_this, _ret);
  }

  _createClass$P(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2$G.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2$R.default.createElement(
        'div',
        { style: styles.hue },
        _react2$R.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2$R.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2$R.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2$R.default.createElement(this.props.pointer, this.props) : _react2$R.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(_react$1L.PureComponent || _react$1L.Component);

Hue$2.default = Hue$1;

var Raised$1 = {};

var baseAssignValue$1 = _baseAssignValue,
    eq$1 = eq_1;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue$2(object, key, value) {
  if ((value !== undefined && !eq$1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue$2;

var isArrayLike$4 = isArrayLike_1,
    isObjectLike$2 = isObjectLike_1;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject$1(value) {
  return isObjectLike$2(value) && isArrayLike$4(value);
}

var isArrayLikeObject_1 = isArrayLikeObject$1;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function safeGet$2(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet$2;

var copyObject$1 = _copyObject,
    keysIn$1 = keysIn_1;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject$1(value) {
  return copyObject$1(value, keysIn$1(value));
}

var toPlainObject_1 = toPlainObject$1;

var assignMergeValue$1 = _assignMergeValue,
    cloneBuffer = _cloneBuffer.exports,
    cloneTypedArray = _cloneTypedArray,
    copyArray = _copyArray,
    initCloneObject = _initCloneObject,
    isArguments$1 = isArguments_1,
    isArray$6 = isArray_1,
    isArrayLikeObject = isArrayLikeObject_1,
    isBuffer = isBuffer$4.exports,
    isFunction$1 = isFunction_1,
    isObject$a = isObject_1,
    isPlainObject$1 = isPlainObject_1,
    isTypedArray$1 = isTypedArray_1,
    safeGet$1 = _safeGet,
    toPlainObject = toPlainObject_1;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep$1(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key),
      srcValue = safeGet$1(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue$1(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray$6(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$6(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject$1(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;
      if (isArguments$1(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject$a(objValue) || isFunction$1(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue$1(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep$1;

var Stack = _Stack,
    assignMergeValue = _assignMergeValue,
    baseFor = _baseFor,
    baseMergeDeep = _baseMergeDeep,
    isObject$9 = isObject_1,
    keysIn = keysIn_1,
    safeGet = _safeGet;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge$1(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject$9(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge$1, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

var _baseMerge = baseMerge$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$2(func, start, transform) {
  start = nativeMax$3(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$3(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$2;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$6(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$6;

var constant$5 = constant_1,
    defineProperty = _defineProperty$11,
    identity$d = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty ? identity$d : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant$5(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
    shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut(baseSetToString);

var _setToString = setToString$2;

var identity$c = identity_1,
    overRest$1 = _overRest,
    setToString$1 = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$2(func, start) {
  return setToString$1(overRest$1(func, start, identity$c), func + '');
}

var _baseRest = baseRest$2;

var eq = eq_1,
    isArrayLike$3 = isArrayLike_1,
    isIndex = _isIndex,
    isObject$8 = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$5(value, index, object) {
  if (!isObject$8(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$3(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall$5;

var baseRest$1 = _baseRest,
    isIterateeCall$4 = _isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner$1(assigner) {
  return baseRest$1(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall$4(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner$1;

var baseMerge = _baseMerge,
    createAssigner = _createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge$3 = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

var merge_1 = merge$3;

Object.defineProperty(Raised$1, "__esModule", {
  value: true
});
Raised$1.Raised = undefined;

var _react$1K = React__default$4;

var _react2$Q = _interopRequireDefault$3c(_react$1K);

var _propTypes$p = propTypes.exports;

var _propTypes2$m = _interopRequireDefault$3c(_propTypes$p);

var _reactcss$F = lib$3;

var _reactcss2$F = _interopRequireDefault$3c(_reactcss$F);

var _merge$d = merge_1;

var _merge2$d = _interopRequireDefault$3c(_merge$d);

function _interopRequireDefault$3c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = Raised$1.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = (0, _reactcss2$F.default)((0, _merge2$d.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return _react2$Q.default.createElement(
    'div',
    { style: styles.wrap },
    _react2$Q.default.createElement('div', { style: styles.bg }),
    _react2$Q.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2$m.default.string,
  zDepth: _propTypes2$m.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2$m.default.number,
  styles: _propTypes2$m.default.object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

Raised$1.default = Raised;

var Saturation$1 = {};

var root = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root.Date.now();
};

var now_1 = now$1;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;

var baseTrim = _baseTrim,
    isObject$7 = isObject_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$2(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$2(value)) {
    return NAN;
  }
  if (isObject$7(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$7(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$2;

var isObject$6 = isObject_1,
    now = now_1,
    toNumber$1 = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$6(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$2(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$1;

var debounce = debounce_1,
    isObject$5 = isObject_1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject$5(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle;

var saturation$1 = {};

Object.defineProperty(saturation$1, "__esModule", {
  value: true
});
saturation$1.calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};

Object.defineProperty(Saturation$1, "__esModule", {
  value: true
});
Saturation$1.Saturation = undefined;

var _createClass$O = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1J = React__default$4;

var _react2$P = _interopRequireDefault$3b(_react$1J);

var _reactcss$E = lib$3;

var _reactcss2$E = _interopRequireDefault$3b(_reactcss$E);

var _throttle$2 = throttle_1;

var _throttle2 = _interopRequireDefault$3b(_throttle$2);

var _saturation = saturation$1;

var saturation = _interopRequireWildcard$_(_saturation);

function _interopRequireWildcard$_(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$3b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$O(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$D(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$D(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = Saturation$1.Saturation = function (_ref) {
  _inherits$D(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck$O(this, Saturation);

    var _this = _possibleConstructorReturn$D(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation.calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass$O(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;

      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2$E.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2$P.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2$P.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2$P.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2$P.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2$P.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2$P.default.createElement(this.props.pointer, this.props) : _react2$P.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(_react$1J.PureComponent || _react$1J.Component);

Saturation$1.default = Saturation;

var ColorWrap$1 = {};

var color$c = {};

var arrayEach = _arrayEach,
    baseEach$2 = _baseEach,
    castFunction = _castFunction,
    isArray$5 = isArray_1;

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray$5(collection) ? arrayEach : baseEach$2;
  return func(collection, castFunction(iteratee));
}

var forEach_1 = forEach;

var each = forEach_1;

var tinycolor = {exports: {}};

(function (module, exports) {
// This file is autogenerated. It's used to publish CJS to npm.
(function (global, factory) {
  module.exports = factory() ;
})(commonjsGlobal$1, (function () {
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  var trimLeft = /^\s+/;
  var trimRight = /\s+$/;
  function tinycolor(color, opts) {
    color = color ? color : "";
    opts = opts || {};

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
      return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
      return new tinycolor(color, opts);
    }
    var rgb = inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
  }
  tinycolor.prototype = {
    isDark: function isDark() {
      return this.getBrightness() < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    isValid: function isValid() {
      return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
      return this._originalInput;
    },
    getFormat: function getFormat() {
      return this._format;
    },
    getAlpha: function getAlpha() {
      return this._a;
    },
    getBrightness: function getBrightness() {
      //http://www.w3.org/TR/AERT#color-contrast
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
      var rgb = this.toRgb();
      var RsRGB, GsRGB, BsRGB, R, G, B;
      RsRGB = rgb.r / 255;
      GsRGB = rgb.g / 255;
      BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = Math.round(100 * this._a) / 100;
      return this;
    },
    toHsv: function toHsv() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v,
        a: this._a
      };
    },
    toHsvString: function toHsvString() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      return {
        h: hsl.h * 360,
        s: hsl.s,
        l: hsl.l,
        a: this._a
      };
    },
    toHslString: function toHslString() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
      return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
      return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
      return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
      return {
        r: Math.round(this._r),
        g: Math.round(this._g),
        b: Math.round(this._b),
        a: this._a
      };
    },
    toRgbString: function toRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
      return {
        r: Math.round(bound01(this._r, 255) * 100) + "%",
        g: Math.round(bound01(this._g, 255) * 100) + "%",
        b: Math.round(bound01(this._b, 255) * 100) + "%",
        a: this._a
      };
    },
    toPercentageRgbString: function toPercentageRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
      if (this._a === 0) {
        return "transparent";
      }
      if (this._a < 1) {
        return false;
      }
      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
      var secondHex8String = hex8String;
      var gradientType = this._gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = tinycolor(secondColor);
        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
      var formatSet = !!format;
      format = format || this._format;
      var formattedString = false;
      var hasAlpha = this._a < 1 && this._a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
      if (needsAlphaFormat) {
        // Special case for "transparent", all other non-alpha formats
        // will return rgba when there is transparency.
        if (format === "name" && this._a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format === "hex" || format === "hex6") {
        formattedString = this.toHexString();
      }
      if (format === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format === "name") {
        formattedString = this.toName();
      }
      if (format === "hsl") {
        formattedString = this.toHslString();
      }
      if (format === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    },
    clone: function clone() {
      return tinycolor(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
      var color = fn.apply(null, [this].concat([].slice.call(args)));
      this._r = color._r;
      this._g = color._g;
      this._b = color._b;
      this.setAlpha(color._a);
      return this;
    },
    lighten: function lighten() {
      return this._applyModification(_lighten, arguments);
    },
    brighten: function brighten() {
      return this._applyModification(_brighten, arguments);
    },
    darken: function darken() {
      return this._applyModification(_darken, arguments);
    },
    desaturate: function desaturate() {
      return this._applyModification(_desaturate, arguments);
    },
    saturate: function saturate() {
      return this._applyModification(_saturate, arguments);
    },
    greyscale: function greyscale() {
      return this._applyModification(_greyscale, arguments);
    },
    spin: function spin() {
      return this._applyModification(_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
      return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function analogous() {
      return this._applyCombination(_analogous, arguments);
    },
    complement: function complement() {
      return this._applyCombination(_complement, arguments);
    },
    monochromatic: function monochromatic() {
      return this._applyCombination(_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
      return this._applyCombination(_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
      return this._applyCombination(polyad, [3]);
    },
    tetrad: function tetrad() {
      return this._applyCombination(polyad, [4]);
    }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function (color, opts) {
    if (_typeof(color) == "object") {
      var newColor = {};
      for (var i in color) {
        if (color.hasOwnProperty(i)) {
          if (i === "a") {
            newColor[i] = color[i];
          } else {
            newColor[i] = convertToPercentage(color[i]);
          }
        }
      }
      color = newColor;
    }
    return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
    var rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") {
      color = stringInputToObject(color);
    }
    if (_typeof(color) == "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (color.hasOwnProperty("a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok: ok,
      format: color.format || format,
      r: Math.min(255, Math.max(rgb.r, 0)),
      g: Math.min(255, Math.max(rgb.g, 0)),
      b: Math.min(255, Math.max(rgb.b, 0)),
      a: a
    };
  }

  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b, 255) * 255
    };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      l: l
    };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
    var r, g, b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      v: v
    };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
    return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) return false;
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function () {
    return tinycolor.fromRatio({
      r: Math.random(),
      g: Math.random(),
      b: Math.random()
    });
  };

  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function _desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _greyscale(color) {
    return tinycolor(color).desaturate(100);
  }
  function _lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }
  function _brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = tinycolor(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return tinycolor(rgb);
  }
  function _darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function _spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function _complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
  }
  function polyad(color, number) {
    if (isNaN(number) || number <= 0) {
      throw new Error("Argument to polyad must be a positive number");
    }
    var hsl = tinycolor(color).toHsl();
    var result = [tinycolor(color)];
    var step = 360 / number;
    for (var i = 1; i < number; i++) {
      result.push(tinycolor({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
      }));
    }
    return result;
  }
  function _splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 72) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 216) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(tinycolor(hsl));
    }
    return ret;
  }
  function _monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while (results--) {
      ret.push(tinycolor({
        h: h,
        s: s,
        v: v
      }));
      v = (v + modification) % 1;
    }
    return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function (color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return tinycolor(rgba);
  };

  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function (color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
  };

  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function (color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
      case "AAsmall":
      case "AAAlarge":
        out = readability >= 4.5;
        break;
      case "AAlarge":
        out = readability >= 3;
        break;
      case "AAAsmall":
        out = readability >= 7;
        break;
    }
    return out;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function (baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for (var i = 0; i < colorList.length; i++) {
      readability = tinycolor.readability(baseColor, colorList[i]);
      if (readability > bestScore) {
        bestScore = readability;
        bestColor = tinycolor(colorList[i]);
      }
    }
    if (tinycolor.isReadable(baseColor, bestColor, {
      level: level,
      size: size
    }) || !includeFallbackColors) {
      return bestColor;
    } else {
      args.includeFallbackColors = false;
      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
    }
  };

  // Big List of Colors
  // ------------------
  // <https://www.w3.org/TR/css-color-4/#named-colors>
  var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);

  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
    var flipped = {};
    for (var i in o) {
      if (o.hasOwnProperty(i)) {
        flipped[o[i]] = i;
      }
    }
    return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
    if (isOnePointZero(n)) n = "100%";
    var processPercent = isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
      n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
      return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
    if (n <= 1) {
      n = n * 100 + "%";
    }
    return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
  }
  var matchers = function () {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
  }();

  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
  }

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color == "transparent") {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
      };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = matchers.rgb.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3]
      };
    }
    if (match = matchers.rgba.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsl.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3]
      };
    }
    if (match = matchers.hsla.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsv.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3]
      };
    }
    if (match = matchers.hsva.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hex8.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex6.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    if (match = matchers.hex4.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        a: convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex3.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
      level: "AA",
      size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
      level = "AA";
    }
    if (size !== "small" && size !== "large") {
      size = "small";
    }
    return {
      level: level,
      size: size
    };
  }

  return tinycolor;

}));
}(tinycolor));

Object.defineProperty(color$c, "__esModule", {
  value: true
});
color$c.isvalidColorString = color$c.red = color$c.getContrastingColor = color$c.isValidHex = color$c.toState = color$c.simpleCheckForValidColor = undefined;

var _each = each;

var _each2 = _interopRequireDefault$3a(_each);

var _tinycolor = tinycolor.exports;

var _tinycolor2 = _interopRequireDefault$3a(_tinycolor);

function _interopRequireDefault$3a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

color$c.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  (0, _each2.default)(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = color$c.toState = function toState(data, oldHue) {
  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

color$c.isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  }
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
};

color$c.getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

color$c.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

color$c.isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return (0, _tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};

Object.defineProperty(ColorWrap$1, "__esModule", {
  value: true
});
ColorWrap$1.ColorWrap = undefined;

var _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$N = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1I = React__default$4;

var _react2$O = _interopRequireDefault$39(_react$1I);

var _debounce = debounce_1;

var _debounce2 = _interopRequireDefault$39(_debounce);

var _color$i = color$c;

var color$b = _interopRequireWildcard$Z(_color$i);

function _interopRequireWildcard$Z(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$39(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$N(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$C(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$C(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = ColorWrap$1.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits$C(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck$N(this, ColorPicker);

      var _this = _possibleConstructorReturn$C(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = color$b.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color$b.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = color$b.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color$b.toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends$W({}, color$b.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass$N(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2$O.default.createElement(Picker, _extends$W({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends$W({}, color$b.toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(_react$1I.PureComponent || _react$1I.Component);

  ColorPicker.propTypes = _extends$W({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends$W({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

ColorWrap$1.default = ColorWrap;

var Swatch$1 = {};

var interaction = {};

Object.defineProperty(interaction, "__esModule", {
  value: true
});
interaction.handleFocus = undefined;

var _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$M = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1H = React__default$4;

var _react2$N = _interopRequireDefault$38(_react$1H);

function _interopRequireDefault$38(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$M(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$B(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$B(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


interaction.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits$B(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$M(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$B(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn$B(_this, _ret);
    }

    _createClass$M(Focus, [{
      key: 'render',
      value: function render() {
        return _react2$N.default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          _react2$N.default.createElement(Component, _extends$V({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(_react2$N.default.Component);
};

Object.defineProperty(Swatch$1, "__esModule", {
  value: true
});
Swatch$1.Swatch = undefined;

var _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1G = React__default$4;

var _react2$M = _interopRequireDefault$37(_react$1G);

var _reactcss$D = lib$3;

var _reactcss2$D = _interopRequireDefault$37(_reactcss$D);

var _interaction = interaction;

var _Checkboard = Checkboard$1;

var _Checkboard2 = _interopRequireDefault$37(_Checkboard);

function _interopRequireDefault$37(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = Swatch$1.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2$D.default)({
    default: {
      swatch: _extends$U({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2$M.default.createElement(
    'div',
    _extends$U({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2$M.default.createElement(_Checkboard2.default, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

Swatch$1.default = (0, _interaction.handleFocus)(Swatch);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alpha = Alpha$1;

Object.defineProperty(exports, 'Alpha', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Checkboard = Checkboard$1;

Object.defineProperty(exports, 'Checkboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkboard).default;
  }
});

var _EditableInput = EditableInput$1;

Object.defineProperty(exports, 'EditableInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditableInput).default;
  }
});

var _Hue = Hue$2;

Object.defineProperty(exports, 'Hue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Raised = Raised$1;

Object.defineProperty(exports, 'Raised', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Raised).default;
  }
});

var _Saturation = Saturation$1;

Object.defineProperty(exports, 'Saturation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Saturation).default;
  }
});

var _ColorWrap = ColorWrap$1;

Object.defineProperty(exports, 'ColorWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Swatch = Swatch$1;

Object.defineProperty(exports, 'Swatch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
}(common));

var AlphaPointer$1 = {};

Object.defineProperty(AlphaPointer$1, "__esModule", {
  value: true
});
AlphaPointer$1.AlphaPointer = undefined;

var _react$1F = React__default$4;

var _react2$L = _interopRequireDefault$36(_react$1F);

var _reactcss$C = lib$3;

var _reactcss2$C = _interopRequireDefault$36(_reactcss$C);

function _interopRequireDefault$36(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPointer = AlphaPointer$1.AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2$C.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2$L.default.createElement('div', { style: styles.picker });
};

AlphaPointer$1.default = AlphaPointer;

Object.defineProperty(Alpha$2, "__esModule", {
  value: true
});
Alpha$2.AlphaPicker = undefined;

var _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1E = React__default$4;

var _react2$K = _interopRequireDefault$35(_react$1E);

var _reactcss$B = lib$3;

var _reactcss2$B = _interopRequireDefault$35(_reactcss$B);

var _common$o = common;

var _AlphaPointer = AlphaPointer$1;

var _AlphaPointer2 = _interopRequireDefault$35(_AlphaPointer);

function _interopRequireDefault$35(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPicker = Alpha$2.AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$B.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return _react2$K.default.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    _react2$K.default.createElement(_common$o.Alpha, _extends$T({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _AlphaPointer2.default
};

Alpha$2.default = (0, _common$o.ColorWrap)(AlphaPicker);

var Block$1 = {};

var BlockSwatches$1 = {};

Object.defineProperty(BlockSwatches$1, "__esModule", {
  value: true
});
BlockSwatches$1.BlockSwatches = undefined;

var _react$1D = React__default$4;

var _react2$J = _interopRequireDefault$34(_react$1D);

var _reactcss$A = lib$3;

var _reactcss2$A = _interopRequireDefault$34(_reactcss$A);

var _map$6 = map_1;

var _map2$6 = _interopRequireDefault$34(_map$6);

var _common$n = common;

function _interopRequireDefault$34(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockSwatches = BlockSwatches$1.BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2$A.default)({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2$J.default.createElement(
    'div',
    { style: styles.swatches },
    (0, _map2$6.default)(colors, function (c) {
      return _react2$J.default.createElement(_common$n.Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    _react2$J.default.createElement('div', { style: styles.clear })
  );
};

BlockSwatches$1.default = BlockSwatches;

Object.defineProperty(Block$1, "__esModule", {
  value: true
});
Block$1.Block = undefined;

var _react$1C = React__default$4;

var _react2$I = _interopRequireDefault$33(_react$1C);

var _propTypes$o = propTypes.exports;

var _propTypes2$l = _interopRequireDefault$33(_propTypes$o);

var _reactcss$z = lib$3;

var _reactcss2$z = _interopRequireDefault$33(_reactcss$z);

var _merge$c = merge_1;

var _merge2$c = _interopRequireDefault$33(_merge$c);

var _color$h = color$c;

var color$a = _interopRequireWildcard$Y(_color$h);

var _common$m = common;

var _BlockSwatches = BlockSwatches$1;

var _BlockSwatches2 = _interopRequireDefault$33(_BlockSwatches);

function _interopRequireWildcard$Y(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$33(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Block = Block$1.Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    color$a.isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = (0, _reactcss2$z.default)((0, _merge2$c.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: color$a.getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), { 'hide-triangle': triangle === 'hide' });

  return _react2$I.default.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    _react2$I.default.createElement('div', { style: styles.triangle }),
    _react2$I.default.createElement(
      'div',
      { style: styles.head },
      transparent && _react2$I.default.createElement(_common$m.Checkboard, { borderRadius: '6px 6px 0 0' }),
      _react2$I.default.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    _react2$I.default.createElement(
      'div',
      { style: styles.body },
      _react2$I.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      _react2$I.default.createElement(_common$m.EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: _propTypes2$l.default.oneOfType([_propTypes2$l.default.string, _propTypes2$l.default.number]),
  colors: _propTypes2$l.default.arrayOf(_propTypes2$l.default.string),
  triangle: _propTypes2$l.default.oneOf(['top', 'hide']),
  styles: _propTypes2$l.default.object
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};

Block$1.default = (0, _common$m.ColorWrap)(Block);

var Circle$1 = {};

var colors = {exports: {}};

(function (module, exports) {
(function(root, factory) {
  {
    module.exports = factory();
  }
})(commonjsGlobal$1, function() {
  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
});
}(colors));

var CircleSwatch$1 = {};

Object.defineProperty(CircleSwatch$1, "__esModule", {
  value: true
});
CircleSwatch$1.CircleSwatch = undefined;

var _react$1B = React__default$4;

var _react2$H = _interopRequireDefault$32(_react$1B);

var _reactcss$y = lib$3;

var _reactcss2$y = _interopRequireDefault$32(_reactcss$y);

var _common$l = common;

function _interopRequireDefault$32(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleSwatch = CircleSwatch$1.CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = (0, _reactcss2$y.default)({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return _react2$H.default.createElement(
    'div',
    { style: styles.swatch },
    _react2$H.default.createElement(_common$l.Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

CircleSwatch$1.default = (0, _reactcss$y.handleHover)(CircleSwatch);

Object.defineProperty(Circle$1, "__esModule", {
  value: true
});
Circle$1.Circle = undefined;

var _react$1A = React__default$4;

var _react2$G = _interopRequireDefault$31(_react$1A);

var _propTypes$n = propTypes.exports;

var _propTypes2$k = _interopRequireDefault$31(_propTypes$n);

var _reactcss$x = lib$3;

var _reactcss2$x = _interopRequireDefault$31(_reactcss$x);

var _map$5 = map_1;

var _map2$5 = _interopRequireDefault$31(_map$5);

var _merge$b = merge_1;

var _merge2$b = _interopRequireDefault$31(_merge$b);

var _materialColors$1 = colors.exports;

var material$1 = _interopRequireWildcard$X(_materialColors$1);

var _common$k = common;

var _CircleSwatch = CircleSwatch$1;

var _CircleSwatch2 = _interopRequireDefault$31(_CircleSwatch);

function _interopRequireWildcard$X(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$31(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = Circle$1.Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$x.default)((0, _merge2$b.default)({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return _react2$G.default.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    (0, _map2$5.default)(colors, function (c) {
      return _react2$G.default.createElement(_CircleSwatch2.default, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: _propTypes2$k.default.oneOfType([_propTypes2$k.default.string, _propTypes2$k.default.number]),
  circleSize: _propTypes2$k.default.number,
  circleSpacing: _propTypes2$k.default.number,
  styles: _propTypes2$k.default.object
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [material$1.red['500'], material$1.pink['500'], material$1.purple['500'], material$1.deepPurple['500'], material$1.indigo['500'], material$1.blue['500'], material$1.lightBlue['500'], material$1.cyan['500'], material$1.teal['500'], material$1.green['500'], material$1.lightGreen['500'], material$1.lime['500'], material$1.yellow['500'], material$1.amber['500'], material$1.orange['500'], material$1.deepOrange['500'], material$1.brown['500'], material$1.blueGrey['500']],
  styles: {}
};

Circle$1.default = (0, _common$k.ColorWrap)(Circle);

var Chrome$1 = {};

var ChromeFields$1 = {};

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */

function isUndefined$1(value) {
  return value === undefined;
}

var isUndefined_1 = isUndefined$1;

var UnfoldMoreHorizontalIcon = {};

Object.defineProperty(UnfoldMoreHorizontalIcon, "__esModule", {
  value: true
});

var _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1z = React__default$4;

var _react2$F = _interopRequireDefault$30(_react$1z);

function _interopRequireDefault$30(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$y(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE$1 = 24;

UnfoldMoreHorizontalIcon.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE$1 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE$1 : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties$y(_ref, ['fill', 'width', 'height', 'style']);

  return _react2$F.default.createElement(
    'svg',
    _extends$S({
      viewBox: '0 0 ' + DEFAULT_SIZE$1 + ' ' + DEFAULT_SIZE$1,
      style: _extends$S({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2$F.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
  );
};

Object.defineProperty(ChromeFields$1, "__esModule", {
  value: true
});
ChromeFields$1.ChromeFields = undefined;

var _createClass$L = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1y = React__default$4;

var _react2$E = _interopRequireDefault$2$(_react$1y);

var _reactcss$w = lib$3;

var _reactcss2$w = _interopRequireDefault$2$(_reactcss$w);

var _color$g = color$c;

var color$9 = _interopRequireWildcard$W(_color$g);

var _isUndefined = isUndefined_1;

var _isUndefined2 = _interopRequireDefault$2$(_isUndefined);

var _common$j = common;

var _UnfoldMoreHorizontalIcon = UnfoldMoreHorizontalIcon;

var _UnfoldMoreHorizontalIcon2 = _interopRequireDefault$2$(_UnfoldMoreHorizontalIcon);

function _interopRequireWildcard$W(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2$(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$L(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$A(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$A(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */

var ChromeFields = ChromeFields$1.ChromeFields = function (_React$Component) {
  _inherits$A(ChromeFields, _React$Component);

  function ChromeFields(props) {
    _classCallCheck$L(this, ChromeFields);

    var _this = _possibleConstructorReturn$A(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        color$9.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }
        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        }

        // We store HSL as a unit interval so we need to override the 1 input to 0.01
        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!(0, _isUndefined2.default)(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!(0, _isUndefined2.default)(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }

  _createClass$L(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2$w.default)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = _react2$E.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2$E.default.createElement(
            'div',
            { style: styles.field },
            _react2$E.default.createElement(_common$j.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = _react2$E.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2$E.default.createElement(
            'div',
            { style: styles.field },
            _react2$E.default.createElement(_common$j.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          _react2$E.default.createElement(
            'div',
            { style: styles.field },
            _react2$E.default.createElement(_common$j.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          _react2$E.default.createElement(
            'div',
            { style: styles.field },
            _react2$E.default.createElement(_common$j.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          _react2$E.default.createElement(
            'div',
            { style: styles.alpha },
            _react2$E.default.createElement(_common$j.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = _react2$E.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2$E.default.createElement(
            'div',
            { style: styles.field },
            _react2$E.default.createElement(_common$j.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          _react2$E.default.createElement(
            'div',
            { style: styles.field },
            _react2$E.default.createElement(_common$j.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2$E.default.createElement(
            'div',
            { style: styles.field },
            _react2$E.default.createElement(_common$j.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2$E.default.createElement(
            'div',
            { style: styles.alpha },
            _react2$E.default.createElement(_common$j.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return _react2$E.default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        _react2$E.default.createElement(
          'div',
          { style: styles.toggle },
          _react2$E.default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            _react2$E.default.createElement(_UnfoldMoreHorizontalIcon2.default, {
              style: styles.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return { view: 'rgb' };
      }
      return null;
    }
  }]);

  return ChromeFields;
}(_react2$E.default.Component);

ChromeFields.defaultProps = {
  view: "hex"
};

ChromeFields$1.default = ChromeFields;

var ChromePointer$1 = {};

Object.defineProperty(ChromePointer$1, "__esModule", {
  value: true
});
ChromePointer$1.ChromePointer = undefined;

var _react$1x = React__default$4;

var _react2$D = _interopRequireDefault$2_(_react$1x);

var _reactcss$v = lib$3;

var _reactcss2$v = _interopRequireDefault$2_(_reactcss$v);

function _interopRequireDefault$2_(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointer = ChromePointer$1.ChromePointer = function ChromePointer() {
  var styles = (0, _reactcss2$v.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2$D.default.createElement('div', { style: styles.picker });
};

ChromePointer$1.default = ChromePointer;

var ChromePointerCircle$1 = {};

Object.defineProperty(ChromePointerCircle$1, "__esModule", {
  value: true
});
ChromePointerCircle$1.ChromePointerCircle = undefined;

var _react$1w = React__default$4;

var _react2$C = _interopRequireDefault$2Z(_react$1w);

var _reactcss$u = lib$3;

var _reactcss2$u = _interopRequireDefault$2Z(_reactcss$u);

function _interopRequireDefault$2Z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointerCircle = ChromePointerCircle$1.ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0, _reactcss2$u.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return _react2$C.default.createElement('div', { style: styles.picker });
};

ChromePointerCircle$1.default = ChromePointerCircle;

Object.defineProperty(Chrome$1, "__esModule", {
  value: true
});
Chrome$1.Chrome = undefined;

var _react$1v = React__default$4;

var _react2$B = _interopRequireDefault$2Y(_react$1v);

var _propTypes$m = propTypes.exports;

var _propTypes2$j = _interopRequireDefault$2Y(_propTypes$m);

var _reactcss$t = lib$3;

var _reactcss2$t = _interopRequireDefault$2Y(_reactcss$t);

var _merge$a = merge_1;

var _merge2$a = _interopRequireDefault$2Y(_merge$a);

var _common$i = common;

var _ChromeFields = ChromeFields$1;

var _ChromeFields2 = _interopRequireDefault$2Y(_ChromeFields);

var _ChromePointer = ChromePointer$1;

var _ChromePointer2 = _interopRequireDefault$2Y(_ChromePointer);

var _ChromePointerCircle = ChromePointerCircle$1;

var _ChromePointerCircle2 = _interopRequireDefault$2Y(_ChromePointerCircle);

function _interopRequireDefault$2Y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chrome = Chrome$1.Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;

  var styles = (0, _reactcss2$t.default)((0, _merge2$a.default)({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return _react2$B.default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    _react2$B.default.createElement(
      'div',
      { style: styles.saturation },
      _react2$B.default.createElement(_common$i.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: _ChromePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2$B.default.createElement(
      'div',
      { style: styles.body },
      _react2$B.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2$B.default.createElement(
          'div',
          { style: styles.color },
          _react2$B.default.createElement(
            'div',
            { style: styles.swatch },
            _react2$B.default.createElement('div', { style: styles.active }),
            _react2$B.default.createElement(_common$i.Checkboard, { renderers: renderers })
          )
        ),
        _react2$B.default.createElement(
          'div',
          { style: styles.toggles },
          _react2$B.default.createElement(
            'div',
            { style: styles.hue },
            _react2$B.default.createElement(_common$i.Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              onChange: onChange
            })
          ),
          _react2$B.default.createElement(
            'div',
            { style: styles.alpha },
            _react2$B.default.createElement(_common$i.Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      _react2$B.default.createElement(_ChromeFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  width: _propTypes2$j.default.oneOfType([_propTypes2$j.default.string, _propTypes2$j.default.number]),
  disableAlpha: _propTypes2$j.default.bool,
  styles: _propTypes2$j.default.object,
  defaultView: _propTypes2$j.default.oneOf(["hex", "rgb", "hsl"])
};

Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};

Chrome$1.default = (0, _common$i.ColorWrap)(Chrome);

var Compact$1 = {};

var CompactColor$1 = {};

Object.defineProperty(CompactColor$1, "__esModule", {
  value: true
});
CompactColor$1.CompactColor = undefined;

var _react$1u = React__default$4;

var _react2$A = _interopRequireDefault$2X(_react$1u);

var _reactcss$s = lib$3;

var _reactcss2$s = _interopRequireDefault$2X(_reactcss$s);

var _color$f = color$c;

var colorUtils$1 = _interopRequireWildcard$V(_color$f);

var _common$h = common;

function _interopRequireWildcard$V(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2X(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactColor = CompactColor$1.CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = (0, _reactcss2$s.default)({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: colorUtils$1.getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return _react2$A.default.createElement(
    _common$h.Swatch,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2$A.default.createElement('div', { style: styles.dot })
  );
};

CompactColor$1.default = CompactColor;

var CompactFields$1 = {};

Object.defineProperty(CompactFields$1, "__esModule", {
  value: true
});
CompactFields$1.CompactFields = undefined;

var _react$1t = React__default$4;

var _react2$z = _interopRequireDefault$2W(_react$1t);

var _reactcss$r = lib$3;

var _reactcss2$r = _interopRequireDefault$2W(_reactcss$r);

var _common$g = common;

function _interopRequireDefault$2W(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactFields = CompactFields$1.CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = (0, _reactcss2$r.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return _react2$z.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2$z.default.createElement('div', { style: styles.active }),
    _react2$z.default.createElement(_common$g.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    _react2$z.default.createElement(_common$g.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2$z.default.createElement(_common$g.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2$z.default.createElement(_common$g.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

CompactFields$1.default = CompactFields;

Object.defineProperty(Compact$1, "__esModule", {
  value: true
});
Compact$1.Compact = undefined;

var _react$1s = React__default$4;

var _react2$y = _interopRequireDefault$2V(_react$1s);

var _propTypes$l = propTypes.exports;

var _propTypes2$i = _interopRequireDefault$2V(_propTypes$l);

var _reactcss$q = lib$3;

var _reactcss2$q = _interopRequireDefault$2V(_reactcss$q);

var _map$4 = map_1;

var _map2$4 = _interopRequireDefault$2V(_map$4);

var _merge$9 = merge_1;

var _merge2$9 = _interopRequireDefault$2V(_merge$9);

var _color$e = color$c;

var color$8 = _interopRequireWildcard$U(_color$e);

var _common$f = common;

var _CompactColor = CompactColor$1;

var _CompactColor2 = _interopRequireDefault$2V(_CompactColor);

var _CompactFields = CompactFields$1;

var _CompactFields2 = _interopRequireDefault$2V(_CompactFields);

function _interopRequireWildcard$U(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2V(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Compact = Compact$1.Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$q.default)((0, _merge2$9.default)({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      color$8.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return _react2$y.default.createElement(
    _common$f.Raised,
    { style: styles.Compact, styles: passedStyles },
    _react2$y.default.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      _react2$y.default.createElement(
        'div',
        null,
        (0, _map2$4.default)(colors, function (c) {
          return _react2$y.default.createElement(_CompactColor2.default, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        _react2$y.default.createElement('div', { style: styles.clear })
      ),
      _react2$y.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: _propTypes2$i.default.arrayOf(_propTypes2$i.default.string),
  styles: _propTypes2$i.default.object
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};

Compact$1.default = (0, _common$f.ColorWrap)(Compact);

var Github$1 = {};

var GithubSwatch$1 = {};

Object.defineProperty(GithubSwatch$1, "__esModule", {
  value: true
});
GithubSwatch$1.GithubSwatch = undefined;

var _react$1r = React__default$4;

var _react2$x = _interopRequireDefault$2U(_react$1r);

var _reactcss$p = lib$3;

var _reactcss2$p = _interopRequireDefault$2U(_reactcss$p);

var _common$e = common;

function _interopRequireDefault$2U(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GithubSwatch = GithubSwatch$1.GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = (0, _reactcss2$p.default)({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return _react2$x.default.createElement(
    'div',
    { style: styles.swatch },
    _react2$x.default.createElement(_common$e.Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

GithubSwatch$1.default = (0, _reactcss$p.handleHover)(GithubSwatch);

Object.defineProperty(Github$1, "__esModule", {
  value: true
});
Github$1.Github = undefined;

var _react$1q = React__default$4;

var _react2$w = _interopRequireDefault$2T(_react$1q);

var _propTypes$k = propTypes.exports;

var _propTypes2$h = _interopRequireDefault$2T(_propTypes$k);

var _reactcss$o = lib$3;

var _reactcss2$o = _interopRequireDefault$2T(_reactcss$o);

var _map$3 = map_1;

var _map2$3 = _interopRequireDefault$2T(_map$3);

var _merge$8 = merge_1;

var _merge2$8 = _interopRequireDefault$2T(_merge$8);

var _common$d = common;

var _GithubSwatch = GithubSwatch$1;

var _GithubSwatch2 = _interopRequireDefault$2T(_GithubSwatch);

function _interopRequireDefault$2T(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Github = Github$1.Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$o.default)((0, _merge2$8.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return _react2$w.default.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    _react2$w.default.createElement('div', { style: styles.triangleShadow }),
    _react2$w.default.createElement('div', { style: styles.triangle }),
    (0, _map2$3.default)(colors, function (c) {
      return _react2$w.default.createElement(_GithubSwatch2.default, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: _propTypes2$h.default.oneOfType([_propTypes2$h.default.string, _propTypes2$h.default.number]),
  colors: _propTypes2$h.default.arrayOf(_propTypes2$h.default.string),
  triangle: _propTypes2$h.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: _propTypes2$h.default.object
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};

Github$1.default = (0, _common$d.ColorWrap)(Github);

var Hue = {};

var HuePointer = {};

Object.defineProperty(HuePointer, "__esModule", {
  value: true
});
HuePointer.SliderPointer = undefined;

var _react$1p = React__default$4;

var _react2$v = _interopRequireDefault$2S(_react$1p);

var _reactcss$n = lib$3;

var _reactcss2$n = _interopRequireDefault$2S(_reactcss$n);

function _interopRequireDefault$2S(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer$2 = HuePointer.SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2$n.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2$v.default.createElement('div', { style: styles.picker });
};

HuePointer.default = SliderPointer$2;

Object.defineProperty(Hue, "__esModule", {
  value: true
});
Hue.HuePicker = undefined;

var _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1o = React__default$4;

var _react2$u = _interopRequireDefault$2R(_react$1o);

var _propTypes$j = propTypes.exports;

var _propTypes2$g = _interopRequireDefault$2R(_propTypes$j);

var _reactcss$m = lib$3;

var _reactcss2$m = _interopRequireDefault$2R(_reactcss$m);

var _merge$7 = merge_1;

var _merge2$7 = _interopRequireDefault$2R(_merge$7);

var _common$c = common;

var _HuePointer = HuePointer;

var _HuePointer2 = _interopRequireDefault$2R(_HuePointer);

function _interopRequireDefault$2R(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HuePicker = Hue.HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$m.default)((0, _merge2$7.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return _react2$u.default.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    _react2$u.default.createElement(_common$c.Hue, _extends$R({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.propTypes = {
  styles: _propTypes2$g.default.object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _HuePointer2.default,
  styles: {}
};

Hue.default = (0, _common$c.ColorWrap)(HuePicker);

var Material$1 = {};

Object.defineProperty(Material$1, "__esModule", {
  value: true
});
Material$1.Material = undefined;

var _react$1n = React__default$4;

var _react2$t = _interopRequireDefault$2Q(_react$1n);

var _reactcss$l = lib$3;

var _reactcss2$l = _interopRequireDefault$2Q(_reactcss$l);

var _merge$6 = merge_1;

var _merge2$6 = _interopRequireDefault$2Q(_merge$6);

var _color$d = color$c;

var color$7 = _interopRequireWildcard$T(_color$d);

var _common$b = common;

function _interopRequireWildcard$T(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2Q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Material = Material$1.Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$l.default)((0, _merge2$6.default)({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      color$7.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return _react2$t.default.createElement(
    _common$b.Raised,
    { styles: passedStyles },
    _react2$t.default.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      _react2$t.default.createElement(_common$b.EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      _react2$t.default.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        _react2$t.default.createElement(
          'div',
          { style: styles.third },
          _react2$t.default.createElement(_common$b.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        _react2$t.default.createElement(
          'div',
          { style: styles.third },
          _react2$t.default.createElement(_common$b.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        _react2$t.default.createElement(
          'div',
          { style: styles.third },
          _react2$t.default.createElement(_common$b.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

Material$1.default = (0, _common$b.ColorWrap)(Material);

var Photoshop$1 = {};

var PhotoshopFields = {};

Object.defineProperty(PhotoshopFields, "__esModule", {
  value: true
});
PhotoshopFields.PhotoshopPicker = undefined;

var _react$1m = React__default$4;

var _react2$s = _interopRequireDefault$2P(_react$1m);

var _reactcss$k = lib$3;

var _reactcss2$k = _interopRequireDefault$2P(_reactcss$k);

var _color$c = color$c;

var color$6 = _interopRequireWildcard$S(_color$c);

var _common$a = common;

function _interopRequireWildcard$S(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2P(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPicker = PhotoshopFields.PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = (0, _reactcss2$k.default)({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        top: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      color$6.isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return _react2$s.default.createElement(
    'div',
    { style: styles.fields },
    _react2$s.default.createElement(_common$a.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    _react2$s.default.createElement(_common$a.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    _react2$s.default.createElement(_common$a.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    _react2$s.default.createElement('div', { style: styles.divider }),
    _react2$s.default.createElement(_common$a.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2$s.default.createElement(_common$a.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2$s.default.createElement(_common$a.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    _react2$s.default.createElement('div', { style: styles.divider }),
    _react2$s.default.createElement(_common$a.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    _react2$s.default.createElement(
      'div',
      { style: styles.fieldSymbols },
      _react2$s.default.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      _react2$s.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      _react2$s.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

PhotoshopFields.default = PhotoshopPicker;

var PhotoshopPointerCircle$2 = {};

Object.defineProperty(PhotoshopPointerCircle$2, "__esModule", {
  value: true
});
PhotoshopPointerCircle$2.PhotoshopPointerCircle = undefined;

var _react$1l = React__default$4;

var _react2$r = _interopRequireDefault$2O(_react$1l);

var _reactcss$j = lib$3;

var _reactcss2$j = _interopRequireDefault$2O(_reactcss$j);

function _interopRequireDefault$2O(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle$1 = PhotoshopPointerCircle$2.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = (0, _reactcss2$j.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return _react2$r.default.createElement('div', { style: styles.picker });
};

PhotoshopPointerCircle$2.default = PhotoshopPointerCircle$1;

var PhotoshopPointer = {};

Object.defineProperty(PhotoshopPointer, "__esModule", {
  value: true
});
PhotoshopPointer.PhotoshopPointerCircle = undefined;

var _react$1k = React__default$4;

var _react2$q = _interopRequireDefault$2N(_react$1k);

var _reactcss$i = lib$3;

var _reactcss2$i = _interopRequireDefault$2N(_reactcss$i);

function _interopRequireDefault$2N(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = PhotoshopPointer.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = (0, _reactcss2$i.default)({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return _react2$q.default.createElement(
    'div',
    { style: styles.pointer },
    _react2$q.default.createElement(
      'div',
      { style: styles.left },
      _react2$q.default.createElement('div', { style: styles.leftInside })
    ),
    _react2$q.default.createElement(
      'div',
      { style: styles.right },
      _react2$q.default.createElement('div', { style: styles.rightInside })
    )
  );
};

PhotoshopPointer.default = PhotoshopPointerCircle;

var PhotoshopButton$1 = {};

Object.defineProperty(PhotoshopButton$1, "__esModule", {
  value: true
});
PhotoshopButton$1.PhotoshopButton = undefined;

var _react$1j = React__default$4;

var _react2$p = _interopRequireDefault$2M(_react$1j);

var _reactcss$h = lib$3;

var _reactcss2$h = _interopRequireDefault$2M(_reactcss$h);

function _interopRequireDefault$2M(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopButton = PhotoshopButton$1.PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = (0, _reactcss2$h.default)({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return _react2$p.default.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

PhotoshopButton$1.default = PhotoshopButton;

var PhotoshopPreviews$1 = {};

Object.defineProperty(PhotoshopPreviews$1, "__esModule", {
  value: true
});
PhotoshopPreviews$1.PhotoshopPreviews = undefined;

var _react$1i = React__default$4;

var _react2$o = _interopRequireDefault$2L(_react$1i);

var _reactcss$g = lib$3;

var _reactcss2$g = _interopRequireDefault$2L(_reactcss$g);

function _interopRequireDefault$2L(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPreviews = PhotoshopPreviews$1.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = (0, _reactcss2$g.default)({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return _react2$o.default.createElement(
    'div',
    null,
    _react2$o.default.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    _react2$o.default.createElement(
      'div',
      { style: styles.swatches },
      _react2$o.default.createElement('div', { style: styles.new }),
      _react2$o.default.createElement('div', { style: styles.current })
    ),
    _react2$o.default.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

PhotoshopPreviews$1.default = PhotoshopPreviews;

Object.defineProperty(Photoshop$1, "__esModule", {
  value: true
});
Photoshop$1.Photoshop = undefined;

var _createClass$K = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1h = React__default$4;

var _react2$n = _interopRequireDefault$2K(_react$1h);

var _propTypes$i = propTypes.exports;

var _propTypes2$f = _interopRequireDefault$2K(_propTypes$i);

var _reactcss$f = lib$3;

var _reactcss2$f = _interopRequireDefault$2K(_reactcss$f);

var _merge$5 = merge_1;

var _merge2$5 = _interopRequireDefault$2K(_merge$5);

var _common$9 = common;

var _PhotoshopFields = PhotoshopFields;

var _PhotoshopFields2 = _interopRequireDefault$2K(_PhotoshopFields);

var _PhotoshopPointerCircle = PhotoshopPointerCircle$2;

var _PhotoshopPointerCircle2 = _interopRequireDefault$2K(_PhotoshopPointerCircle);

var _PhotoshopPointer = PhotoshopPointer;

var _PhotoshopPointer2 = _interopRequireDefault$2K(_PhotoshopPointer);

var _PhotoshopButton = PhotoshopButton$1;

var _PhotoshopButton2 = _interopRequireDefault$2K(_PhotoshopButton);

var _PhotoshopPreviews = PhotoshopPreviews$1;

var _PhotoshopPreviews2 = _interopRequireDefault$2K(_PhotoshopPreviews);

function _interopRequireDefault$2K(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$K(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$z(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$z(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photoshop = Photoshop$1.Photoshop = function (_React$Component) {
  _inherits$z(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck$K(this, Photoshop);

    var _this = _possibleConstructorReturn$z(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass$K(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = (0, _reactcss2$f.default)((0, _merge2$5.default)({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));

      return _react2$n.default.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        _react2$n.default.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        _react2$n.default.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          _react2$n.default.createElement(
            'div',
            { style: styles.saturation },
            _react2$n.default.createElement(_common$9.Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: _PhotoshopPointerCircle2.default,
              onChange: this.props.onChange
            })
          ),
          _react2$n.default.createElement(
            'div',
            { style: styles.hue },
            _react2$n.default.createElement(_common$9.Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: _PhotoshopPointer2.default,
              onChange: this.props.onChange
            })
          ),
          _react2$n.default.createElement(
            'div',
            { style: styles.controls },
            _react2$n.default.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              _react2$n.default.createElement(
                'div',
                { style: styles.previews },
                _react2$n.default.createElement(_PhotoshopPreviews2.default, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              _react2$n.default.createElement(
                'div',
                { style: styles.actions },
                _react2$n.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
                _react2$n.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
                _react2$n.default.createElement(_PhotoshopFields2.default, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(_react2$n.default.Component);

Photoshop.propTypes = {
  header: _propTypes2$f.default.string,
  styles: _propTypes2$f.default.object
};

Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};

Photoshop$1.default = (0, _common$9.ColorWrap)(Photoshop);

var Sketch$1 = {};

var SketchFields$1 = {};

Object.defineProperty(SketchFields$1, "__esModule", {
  value: true
});
SketchFields$1.SketchFields = undefined;

var _react$1g = React__default$4;

var _react2$m = _interopRequireDefault$2J(_react$1g);

var _reactcss$e = lib$3;

var _reactcss2$e = _interopRequireDefault$2J(_reactcss$e);

var _color$b = color$c;

var color$5 = _interopRequireWildcard$R(_color$b);

var _common$8 = common;

function _interopRequireWildcard$R(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2J(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

var SketchFields = SketchFields$1.SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = (0, _reactcss2$e.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      color$5.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return _react2$m.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2$m.default.createElement(
      'div',
      { style: styles.double },
      _react2$m.default.createElement(_common$8.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    _react2$m.default.createElement(
      'div',
      { style: styles.single },
      _react2$m.default.createElement(_common$8.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2$m.default.createElement(
      'div',
      { style: styles.single },
      _react2$m.default.createElement(_common$8.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2$m.default.createElement(
      'div',
      { style: styles.single },
      _react2$m.default.createElement(_common$8.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2$m.default.createElement(
      'div',
      { style: styles.alpha },
      _react2$m.default.createElement(_common$8.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

SketchFields$1.default = SketchFields;

var SketchPresetColors$1 = {};

Object.defineProperty(SketchPresetColors$1, "__esModule", {
  value: true
});
SketchPresetColors$1.SketchPresetColors = undefined;

var _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1f = React__default$4;

var _react2$l = _interopRequireDefault$2I(_react$1f);

var _propTypes$h = propTypes.exports;

var _propTypes2$e = _interopRequireDefault$2I(_propTypes$h);

var _reactcss$d = lib$3;

var _reactcss2$d = _interopRequireDefault$2I(_reactcss$d);

var _common$7 = common;

function _interopRequireDefault$2I(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SketchPresetColors = SketchPresetColors$1.SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2$d.default)({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return _react2$l.default.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return _react2$l.default.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        _react2$l.default.createElement(_common$7.Swatch, _extends$Q({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: _propTypes2$e.default.arrayOf(_propTypes2$e.default.oneOfType([_propTypes2$e.default.string, _propTypes2$e.default.shape({
    color: _propTypes2$e.default.string,
    title: _propTypes2$e.default.string
  })])).isRequired
};

SketchPresetColors$1.default = SketchPresetColors;

Object.defineProperty(Sketch$1, "__esModule", {
  value: true
});
Sketch$1.Sketch = undefined;

var _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$1e = React__default$4;

var _react2$k = _interopRequireDefault$2H(_react$1e);

var _propTypes$g = propTypes.exports;

var _propTypes2$d = _interopRequireDefault$2H(_propTypes$g);

var _reactcss$c = lib$3;

var _reactcss2$c = _interopRequireDefault$2H(_reactcss$c);

var _merge$4 = merge_1;

var _merge2$4 = _interopRequireDefault$2H(_merge$4);

var _common$6 = common;

var _SketchFields = SketchFields$1;

var _SketchFields2 = _interopRequireDefault$2H(_SketchFields);

var _SketchPresetColors = SketchPresetColors$1;

var _SketchPresetColors2 = _interopRequireDefault$2H(_SketchPresetColors);

function _interopRequireDefault$2H(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sketch = Sketch$1.Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$c.default)((0, _merge2$4.default)({
    'default': _extends$P({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return _react2$k.default.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    _react2$k.default.createElement(
      'div',
      { style: styles.saturation },
      _react2$k.default.createElement(_common$6.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    _react2$k.default.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      _react2$k.default.createElement(
        'div',
        { style: styles.sliders },
        _react2$k.default.createElement(
          'div',
          { style: styles.hue },
          _react2$k.default.createElement(_common$6.Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        _react2$k.default.createElement(
          'div',
          { style: styles.alpha },
          _react2$k.default.createElement(_common$6.Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      _react2$k.default.createElement(
        'div',
        { style: styles.color },
        _react2$k.default.createElement(_common$6.Checkboard, null),
        _react2$k.default.createElement('div', { style: styles.activeColor })
      )
    ),
    _react2$k.default.createElement(_SketchFields2.default, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    _react2$k.default.createElement(_SketchPresetColors2.default, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: _propTypes2$d.default.bool,
  width: _propTypes2$d.default.oneOfType([_propTypes2$d.default.string, _propTypes2$d.default.number]),
  styles: _propTypes2$d.default.object
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

Sketch$1.default = (0, _common$6.ColorWrap)(Sketch);

var Slider$1 = {};

var SliderSwatches$1 = {};

var SliderSwatch$1 = {};

Object.defineProperty(SliderSwatch$1, "__esModule", {
  value: true
});
SliderSwatch$1.SliderSwatch = undefined;

var _react$1d = React__default$4;

var _react2$j = _interopRequireDefault$2G(_react$1d);

var _reactcss$b = lib$3;

var _reactcss2$b = _interopRequireDefault$2G(_reactcss$b);

function _interopRequireDefault$2G(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatch = SliderSwatch$1.SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = (0, _reactcss2$b.default)({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return _react2$j.default.createElement('div', { style: styles.swatch, onClick: handleClick });
};

SliderSwatch$1.default = SliderSwatch;

Object.defineProperty(SliderSwatches$1, "__esModule", {
  value: true
});
SliderSwatches$1.SliderSwatches = undefined;

var _react$1c = React__default$4;

var _react2$i = _interopRequireDefault$2F(_react$1c);

var _reactcss$a = lib$3;

var _reactcss2$a = _interopRequireDefault$2F(_reactcss$a);

var _SliderSwatch = SliderSwatch$1;

var _SliderSwatch2 = _interopRequireDefault$2F(_SliderSwatch);

function _interopRequireDefault$2F(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatches = SliderSwatches$1.SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = (0, _reactcss2$a.default)({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  // Acceptible difference in floating point equality
  var epsilon = 0.1;

  return _react2$i.default.createElement(
    'div',
    { style: styles.swatches },
    _react2$i.default.createElement(
      'div',
      { style: styles.swatch },
      _react2$i.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
      })
    ),
    _react2$i.default.createElement(
      'div',
      { style: styles.swatch },
      _react2$i.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2$i.default.createElement(
      'div',
      { style: styles.swatch },
      _react2$i.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2$i.default.createElement(
      'div',
      { style: styles.swatch },
      _react2$i.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2$i.default.createElement(
      'div',
      { style: styles.swatch },
      _react2$i.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
      })
    ),
    _react2$i.default.createElement('div', { style: styles.clear })
  );
};

SliderSwatches$1.default = SliderSwatches;

var SliderPointer$1 = {};

Object.defineProperty(SliderPointer$1, "__esModule", {
  value: true
});
SliderPointer$1.SliderPointer = undefined;

var _react$1b = React__default$4;

var _react2$h = _interopRequireDefault$2E(_react$1b);

var _reactcss$9 = lib$3;

var _reactcss2$9 = _interopRequireDefault$2E(_reactcss$9);

function _interopRequireDefault$2E(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = SliderPointer$1.SliderPointer = function SliderPointer() {
  var styles = (0, _reactcss2$9.default)({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2$h.default.createElement('div', { style: styles.picker });
};

SliderPointer$1.default = SliderPointer;

Object.defineProperty(Slider$1, "__esModule", {
  value: true
});
Slider$1.Slider = undefined;

var _react$1a = React__default$4;

var _react2$g = _interopRequireDefault$2D(_react$1a);

var _propTypes$f = propTypes.exports;

var _propTypes2$c = _interopRequireDefault$2D(_propTypes$f);

var _reactcss$8 = lib$3;

var _reactcss2$8 = _interopRequireDefault$2D(_reactcss$8);

var _merge$3 = merge_1;

var _merge2$3 = _interopRequireDefault$2D(_merge$3);

var _common$5 = common;

var _SliderSwatches = SliderSwatches$1;

var _SliderSwatches2 = _interopRequireDefault$2D(_SliderSwatches);

var _SliderPointer = SliderPointer$1;

var _SliderPointer2 = _interopRequireDefault$2D(_SliderPointer);

function _interopRequireDefault$2D(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = Slider$1.Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$8.default)((0, _merge2$3.default)({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  return _react2$g.default.createElement(
    'div',
    { style: styles.wrap || {}, className: 'slider-picker ' + className },
    _react2$g.default.createElement(
      'div',
      { style: styles.hue },
      _react2$g.default.createElement(_common$5.Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    _react2$g.default.createElement(
      'div',
      { style: styles.swatches },
      _react2$g.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.propTypes = {
  styles: _propTypes2$c.default.object
};
Slider.defaultProps = {
  pointer: _SliderPointer2.default,
  styles: {}
};

Slider$1.default = (0, _common$5.ColorWrap)(Slider);

var Swatches$1 = {};

var SwatchesGroup$1 = {};

var SwatchesColor$1 = {};

var CheckIcon = {};

Object.defineProperty(CheckIcon, "__esModule", {
  value: true
});

var _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$19 = React__default$4;

var _react2$f = _interopRequireDefault$2C(_react$19);

function _interopRequireDefault$2C(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$x(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

CheckIcon.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties$x(_ref, ['fill', 'width', 'height', 'style']);

  return _react2$f.default.createElement(
    'svg',
    _extends$O({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends$O({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2$f.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
  );
};

Object.defineProperty(SwatchesColor$1, "__esModule", {
  value: true
});
SwatchesColor$1.SwatchesColor = undefined;

var _react$18 = React__default$4;

var _react2$e = _interopRequireDefault$2B(_react$18);

var _reactcss$7 = lib$3;

var _reactcss2$7 = _interopRequireDefault$2B(_reactcss$7);

var _color$a = color$c;

var colorUtils = _interopRequireWildcard$Q(_color$a);

var _common$4 = common;

var _CheckIcon = CheckIcon;

var _CheckIcon2 = _interopRequireDefault$2B(_CheckIcon);

function _interopRequireWildcard$Q(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2B(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesColor = SwatchesColor$1.SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = (0, _reactcss2$7.default)({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: colorUtils.getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return _react2$e.default.createElement(
    _common$4.Swatch,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2$e.default.createElement(
      'div',
      { style: styles.check },
      _react2$e.default.createElement(_CheckIcon2.default, null)
    )
  );
};

SwatchesColor$1.default = SwatchesColor;

Object.defineProperty(SwatchesGroup$1, "__esModule", {
  value: true
});
SwatchesGroup$1.SwatchesGroup = undefined;

var _react$17 = React__default$4;

var _react2$d = _interopRequireDefault$2A(_react$17);

var _reactcss$6 = lib$3;

var _reactcss2$6 = _interopRequireDefault$2A(_reactcss$6);

var _map$2 = map_1;

var _map2$2 = _interopRequireDefault$2A(_map$2);

var _SwatchesColor = SwatchesColor$1;

var _SwatchesColor2 = _interopRequireDefault$2A(_SwatchesColor);

function _interopRequireDefault$2A(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesGroup = SwatchesGroup$1.SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = (0, _reactcss2$6.default)({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return _react2$d.default.createElement(
    'div',
    { style: styles.group },
    (0, _map2$2.default)(group, function (color, i) {
      return _react2$d.default.createElement(_SwatchesColor2.default, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

SwatchesGroup$1.default = SwatchesGroup;

Object.defineProperty(Swatches$1, "__esModule", {
  value: true
});
Swatches$1.Swatches = undefined;

var _react$16 = React__default$4;

var _react2$c = _interopRequireDefault$2z(_react$16);

var _propTypes$e = propTypes.exports;

var _propTypes2$b = _interopRequireDefault$2z(_propTypes$e);

var _reactcss$5 = lib$3;

var _reactcss2$5 = _interopRequireDefault$2z(_reactcss$5);

var _map$1 = map_1;

var _map2$1 = _interopRequireDefault$2z(_map$1);

var _merge$2 = merge_1;

var _merge2$2 = _interopRequireDefault$2z(_merge$2);

var _materialColors = colors.exports;

var material = _interopRequireWildcard$P(_materialColors);

var _common$3 = common;

var _SwatchesGroup = SwatchesGroup$1;

var _SwatchesGroup2 = _interopRequireDefault$2z(_SwatchesGroup);

function _interopRequireWildcard$P(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Swatches = Swatches$1.Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$5.default)((0, _merge2$2.default)({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    return onChange({ hex: data, source: 'hex' }, e);
  };

  return _react2$c.default.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    _react2$c.default.createElement(
      _common$3.Raised,
      null,
      _react2$c.default.createElement(
        'div',
        { style: styles.overflow },
        _react2$c.default.createElement(
          'div',
          { style: styles.body },
          (0, _map2$1.default)(colors, function (group) {
            return _react2$c.default.createElement(_SwatchesGroup2.default, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          _react2$c.default.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: _propTypes2$b.default.oneOfType([_propTypes2$b.default.string, _propTypes2$b.default.number]),
  height: _propTypes2$b.default.oneOfType([_propTypes2$b.default.string, _propTypes2$b.default.number]),
  colors: _propTypes2$b.default.arrayOf(_propTypes2$b.default.arrayOf(_propTypes2$b.default.string)),
  styles: _propTypes2$b.default.object

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};

Swatches$1.default = (0, _common$3.ColorWrap)(Swatches);

var Twitter$1 = {};

Object.defineProperty(Twitter$1, "__esModule", {
  value: true
});
Twitter$1.Twitter = undefined;

var _react$15 = React__default$4;

var _react2$b = _interopRequireDefault$2y(_react$15);

var _propTypes$d = propTypes.exports;

var _propTypes2$a = _interopRequireDefault$2y(_propTypes$d);

var _reactcss$4 = lib$3;

var _reactcss2$4 = _interopRequireDefault$2y(_reactcss$4);

var _map = map_1;

var _map2 = _interopRequireDefault$2y(_map);

var _merge$1 = merge_1;

var _merge2$1 = _interopRequireDefault$2y(_merge$1);

var _color$9 = color$c;

var color$4 = _interopRequireWildcard$O(_color$9);

var _common$2 = common;

function _interopRequireWildcard$O(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Twitter = Twitter$1.Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2$4.default)((0, _merge2$1.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    color$4.isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return _react2$b.default.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    _react2$b.default.createElement('div', { style: styles.triangleShadow }),
    _react2$b.default.createElement('div', { style: styles.triangle }),
    _react2$b.default.createElement(
      'div',
      { style: styles.body },
      (0, _map2.default)(colors, function (c, i) {
        return _react2$b.default.createElement(_common$2.Swatch, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      _react2$b.default.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      _react2$b.default.createElement(_common$2.EditableInput, {
        label: null,
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      _react2$b.default.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: _propTypes2$a.default.oneOfType([_propTypes2$a.default.string, _propTypes2$a.default.number]),
  triangle: _propTypes2$a.default.oneOf(['hide', 'top-left', 'top-right']),
  colors: _propTypes2$a.default.arrayOf(_propTypes2$a.default.string),
  styles: _propTypes2$a.default.object
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};

Twitter$1.default = (0, _common$2.ColorWrap)(Twitter);

var Google$1 = {};

var GooglePointerCircle$1 = {};

Object.defineProperty(GooglePointerCircle$1, "__esModule", {
  value: true
});
GooglePointerCircle$1.GooglePointerCircle = undefined;

var _react$14 = React__default$4;

var _react2$a = _interopRequireDefault$2x(_react$14);

var _reactcss$3 = lib$3;

var _reactcss2$3 = _interopRequireDefault$2x(_reactcss$3);

var _propTypes$c = propTypes.exports;

var _propTypes2$9 = _interopRequireDefault$2x(_propTypes$c);

function _interopRequireDefault$2x(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GooglePointerCircle = GooglePointerCircle$1.GooglePointerCircle = function GooglePointerCircle(props) {
  var styles = (0, _reactcss2$3.default)({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        border: '2px #fff solid',
        transform: 'translate(-12px, -13px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', ' + Math.round(props.hsl.s * 100) + '%, ' + Math.round(props.hsl.l * 100) + '%)'
      }
    }
  });

  return _react2$a.default.createElement('div', { style: styles.picker });
};

GooglePointerCircle.propTypes = {
  hsl: _propTypes2$9.default.shape({
    h: _propTypes2$9.default.number,
    s: _propTypes2$9.default.number,
    l: _propTypes2$9.default.number,
    a: _propTypes2$9.default.number
  })
};

GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

GooglePointerCircle$1.default = GooglePointerCircle;

var GooglePointer$1 = {};

Object.defineProperty(GooglePointer$1, "__esModule", {
  value: true
});
GooglePointer$1.GooglePointer = undefined;

var _react$13 = React__default$4;

var _react2$9 = _interopRequireDefault$2w(_react$13);

var _reactcss$2 = lib$3;

var _reactcss2$2 = _interopRequireDefault$2w(_reactcss$2);

var _propTypes$b = propTypes.exports;

var _propTypes2$8 = _interopRequireDefault$2w(_propTypes$b);

function _interopRequireDefault$2w(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GooglePointer = GooglePointer$1.GooglePointer = function GooglePointer(props) {
  var styles = (0, _reactcss2$2.default)({
    'default': {
      picker: {
        width: '20px',
        height: '20px',
        borderRadius: '22px',
        transform: 'translate(-10px, -7px)',
        background: 'hsl(' + Math.round(props.hsl.h) + ', 100%, 50%)',
        border: '2px white solid'
      }
    }
  });

  return _react2$9.default.createElement('div', { style: styles.picker });
};

GooglePointer.propTypes = {
  hsl: _propTypes2$8.default.shape({
    h: _propTypes2$8.default.number,
    s: _propTypes2$8.default.number,
    l: _propTypes2$8.default.number,
    a: _propTypes2$8.default.number
  })
};

GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.50 }
};

GooglePointer$1.default = GooglePointer;

var GoogleFields$1 = {};

Object.defineProperty(GoogleFields$1, "__esModule", {
  value: true
});
GoogleFields$1.GoogleFields = undefined;

var _react$12 = React__default$4;

var _react2$8 = _interopRequireDefault$2v(_react$12);

var _reactcss$1 = lib$3;

var _reactcss2$1 = _interopRequireDefault$2v(_reactcss$1);

var _color$8 = color$c;

var color$3 = _interopRequireWildcard$N(_color$8);

var _common$1 = common;

function _interopRequireWildcard$N(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$2v(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleFields = GoogleFields$1.GoogleFields = function GoogleFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      hsv = _ref.hsv;


  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      color$3.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.rgb) {
      var values = data.rgb.split(',');
      color$3.isvalidColorString(data.rgb, 'rgb') && onChange({
        r: values[0],
        g: values[1],
        b: values[2],
        a: 1,
        source: 'rgb'
      }, e);
    } else if (data.hsv) {
      var _values = data.hsv.split(',');
      if (color$3.isvalidColorString(data.hsv, 'hsv')) {
        _values[2] = _values[2].replace('%', '');
        _values[1] = _values[1].replace('%', '');
        _values[0] = _values[0].replace('°', '');
        if (_values[1] == 1) {
          _values[1] = 0.01;
        } else if (_values[2] == 1) {
          _values[2] = 0.01;
        }
        onChange({
          h: Number(_values[0]),
          s: Number(_values[1]),
          v: Number(_values[2]),
          source: 'hsv'
        }, e);
      }
    } else if (data.hsl) {
      var _values2 = data.hsl.split(',');
      if (color$3.isvalidColorString(data.hsl, 'hsl')) {
        _values2[2] = _values2[2].replace('%', '');
        _values2[1] = _values2[1].replace('%', '');
        _values2[0] = _values2[0].replace('°', '');
        if (hsvValue[1] == 1) {
          hsvValue[1] = 0.01;
        } else if (hsvValue[2] == 1) {
          hsvValue[2] = 0.01;
        }
        onChange({
          h: Number(_values2[0]),
          s: Number(_values2[1]),
          v: Number(_values2[2]),
          source: 'hsl'
        }, e);
      }
    }
  };

  var styles = (0, _reactcss2$1.default)({
    'default': {
      wrap: {
        display: 'flex',
        height: '100px',
        marginTop: '4px'
      },
      fields: {
        width: '100%'
      },
      column: {
        paddingTop: '10px',
        display: 'flex',
        justifyContent: 'space-between'
      },
      double: {
        padding: '0px 4.4px',
        boxSizing: 'border-box'
      },
      input: {
        width: '100%',
        height: '38px',
        boxSizing: 'border-box',
        padding: '4px 10% 3px',
        textAlign: 'center',
        border: '1px solid #dadce0',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      input2: {
        height: '38px',
        width: '100%',
        border: '1px solid #dadce0',
        boxSizing: 'border-box',
        fontSize: '11px',
        textTransform: 'lowercase',
        borderRadius: '5px',
        outline: 'none',
        paddingLeft: '10px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label: {
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '35px',
        top: '-6px',
        left: '0',
        right: '0',
        marginLeft: 'auto',
        marginRight: 'auto',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      label2: {
        left: '10px',
        textAlign: 'center',
        fontSize: '12px',
        background: '#fff',
        position: 'absolute',
        textTransform: 'uppercase',
        color: '#3c4043',
        width: '32px',
        top: '-6px',
        fontFamily: 'Roboto,Arial,sans-serif'
      },
      single: {
        flexGrow: '1',
        margin: '0px 4.4px'
      }
    }
  });

  var rgbValue = rgb.r + ', ' + rgb.g + ', ' + rgb.b;
  var hslValue = Math.round(hsl.h) + '\xB0, ' + Math.round(hsl.s * 100) + '%, ' + Math.round(hsl.l * 100) + '%';
  var hsvValue = Math.round(hsv.h) + '\xB0, ' + Math.round(hsv.s * 100) + '%, ' + Math.round(hsv.v * 100) + '%';

  return _react2$8.default.createElement(
    'div',
    { style: styles.wrap, className: 'flexbox-fix' },
    _react2$8.default.createElement(
      'div',
      { style: styles.fields },
      _react2$8.default.createElement(
        'div',
        { style: styles.double },
        _react2$8.default.createElement(_common$1.EditableInput, {
          style: { input: styles.input, label: styles.label },
          label: 'hex',
          value: hex,
          onChange: handleChange
        })
      ),
      _react2$8.default.createElement(
        'div',
        { style: styles.column },
        _react2$8.default.createElement(
          'div',
          { style: styles.single },
          _react2$8.default.createElement(_common$1.EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'rgb',
            value: rgbValue,
            onChange: handleChange
          })
        ),
        _react2$8.default.createElement(
          'div',
          { style: styles.single },
          _react2$8.default.createElement(_common$1.EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsv',
            value: hsvValue,
            onChange: handleChange
          })
        ),
        _react2$8.default.createElement(
          'div',
          { style: styles.single },
          _react2$8.default.createElement(_common$1.EditableInput, {
            style: { input: styles.input2, label: styles.label2 },
            label: 'hsl',
            value: hslValue,
            onChange: handleChange
          })
        )
      )
    )
  );
};

GoogleFields$1.default = GoogleFields;

Object.defineProperty(Google$1, "__esModule", {
  value: true
});
Google$1.Google = undefined;

var _react$11 = React__default$4;

var _react2$7 = _interopRequireDefault$2u(_react$11);

var _propTypes$a = propTypes.exports;

var _propTypes2$7 = _interopRequireDefault$2u(_propTypes$a);

var _reactcss = lib$3;

var _reactcss2 = _interopRequireDefault$2u(_reactcss);

var _merge = merge_1;

var _merge2 = _interopRequireDefault$2u(_merge);

var _common = common;

var _GooglePointerCircle = GooglePointerCircle$1;

var _GooglePointerCircle2 = _interopRequireDefault$2u(_GooglePointerCircle);

var _GooglePointer = GooglePointer$1;

var _GooglePointer2 = _interopRequireDefault$2u(_GooglePointer);

var _GoogleFields = GoogleFields$1;

var _GoogleFields2 = _interopRequireDefault$2u(_GoogleFields);

function _interopRequireDefault$2u(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Google = Google$1.Google = function Google(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      header = _ref.header,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        border: '1px solid #dfe1e5',
        boxSizing: 'initial',
        display: 'flex',
        flexWrap: 'wrap',
        borderRadius: '8px 8px 0px 0px'
      },
      head: {
        height: '57px',
        width: '100%',
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: '16px',
        fontSize: '20px',
        boxSizing: 'border-box',
        fontFamily: 'Roboto-Regular,HelveticaNeue,Arial,sans-serif'
      },
      saturation: {
        width: '70%',
        padding: '0px',
        position: 'relative',
        overflow: 'hidden'
      },
      swatch: {
        width: '30%',
        height: '228px',
        padding: '0px',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', 1)',
        position: 'relative',
        overflow: 'hidden'
      },
      body: {
        margin: 'auto',
        width: '95%'
      },
      controls: {
        display: 'flex',
        boxSizing: 'border-box',
        height: '52px',
        paddingTop: '22px'
      },
      color: {
        width: '32px'
      },
      hue: {
        height: '8px',
        position: 'relative',
        margin: '0px 16px 0px 16px',
        width: '100%'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));
  return _react2$7.default.createElement(
    'div',
    { style: styles.picker, className: 'google-picker ' + className },
    _react2$7.default.createElement(
      'div',
      { style: styles.head },
      header
    ),
    _react2$7.default.createElement('div', { style: styles.swatch }),
    _react2$7.default.createElement(
      'div',
      { style: styles.saturation },
      _react2$7.default.createElement(_common.Saturation, {
        hsl: hsl,
        hsv: hsv,
        pointer: _GooglePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2$7.default.createElement(
      'div',
      { style: styles.body },
      _react2$7.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2$7.default.createElement(
          'div',
          { style: styles.hue },
          _react2$7.default.createElement(_common.Hue, {
            style: styles.Hue,
            hsl: hsl,
            radius: '4px',
            pointer: _GooglePointer2.default,
            onChange: onChange
          })
        )
      ),
      _react2$7.default.createElement(_GoogleFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
      })
    )
  );
};

Google.propTypes = {
  width: _propTypes2$7.default.oneOfType([_propTypes2$7.default.string, _propTypes2$7.default.number]),
  styles: _propTypes2$7.default.object,
  header: _propTypes2$7.default.string

};

Google.defaultProps = {
  width: 652,
  styles: {},
  header: 'Color picker'
};

Google$1.default = (0, _common.ColorWrap)(Google);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomPicker = exports.GooglePicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;

var _Alpha = Alpha$2;

Object.defineProperty(exports, 'AlphaPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Block = Block$1;

Object.defineProperty(exports, 'BlockPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Block).default;
  }
});

var _Circle = Circle$1;

Object.defineProperty(exports, 'CirclePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _Chrome = Chrome$1;

Object.defineProperty(exports, 'ChromePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Chrome).default;
  }
});

var _Compact = Compact$1;

Object.defineProperty(exports, 'CompactPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Compact).default;
  }
});

var _Github = Github$1;

Object.defineProperty(exports, 'GithubPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Github).default;
  }
});

var _Hue = Hue;

Object.defineProperty(exports, 'HuePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Material = Material$1;

Object.defineProperty(exports, 'MaterialPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Material).default;
  }
});

var _Photoshop = Photoshop$1;

Object.defineProperty(exports, 'PhotoshopPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Photoshop).default;
  }
});

var _Sketch = Sketch$1;

Object.defineProperty(exports, 'SketchPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sketch).default;
  }
});

var _Slider = Slider$1;

Object.defineProperty(exports, 'SliderPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slider).default;
  }
});

var _Swatches = Swatches$1;

Object.defineProperty(exports, 'SwatchesPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatches).default;
  }
});

var _Twitter = Twitter$1;

Object.defineProperty(exports, 'TwitterPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Twitter).default;
  }
});

var _Google = Google$1;

Object.defineProperty(exports, 'GooglePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Google).default;
  }
});

var _ColorWrap = ColorWrap$1;

Object.defineProperty(exports, 'CustomPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Chrome2 = _interopRequireDefault(_Chrome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chrome2.default;
}(lib$4));

var css_248z$1i = ".ColorPicker_color__FYOlk {\n  width: 36px;\n  height: 14px;\n  border-radius: 2px;\n}\n\n.ColorPicker_swatch__5m3Ww {\n  padding: 5px;\n  background: #fff;\n  border-radius: 1px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n  display: inline-block;\n  cursor: pointer;\n}\n\n.ColorPicker_popover__t3h-f {\n  position: absolute;\n  z-index: 2;\n}\n\n.ColorPicker_cover__0p675 {\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}";
var style$S = {"color":"ColorPicker_color__FYOlk","swatch":"ColorPicker_swatch__5m3Ww","popover":"ColorPicker_popover__t3h-f","cover":"ColorPicker_cover__0p675"};
styleInject(css_248z$1i);

/**
 * Utility to manage a boolean state.
 *
 * Returns [state, setFalse, setTrue]
 *
 * For example, const [visible, hide, show]
 *
 * @param defaultState
 * @returns
 */
function useBoolState(defaultState) {
    const [state, setState] = useState(!!defaultState);
    const setFalse = useCallback(() => {
        setState(false);
    }, []);
    const setTrue = useCallback(() => {
        setState(true);
    }, []);
    return [state, setFalse, setTrue];
}

const ColorPicker = props => {
    const { value, onChange } = props;
    const [pickerActive, hidePicker, showPicker] = useBoolState(false);
    const handleChange = useCallback((color) => {
        onChange(color.hex);
    }, [onChange]);
    return (React__default$4.createElement("div", null,
        React__default$4.createElement("div", { className: style$S.swatch, onClick: showPicker },
            React__default$4.createElement("div", { style: { backgroundColor: value }, className: style$S.color })),
        pickerActive ? React__default$4.createElement("div", { className: style$S.popover },
            React__default$4.createElement("div", { className: style$S.cover, onClick: hidePicker }),
            React__default$4.createElement(lib$4.TwitterPicker, { color: value, onChange: handleChange })) : null));
};

const ColorSlider = props => {
    const { value, onChange } = props;
    const handleChange = useCallback((color) => {
        onChange(color.hex);
    }, [onChange]);
    return (React__default$4.createElement(lib$4.SliderPicker, { color: value, onChange: handleChange }));
};

/**
 * A control that allows the user to go back or go to the next step
 */
const NextBackControl = (props) => {
    const { onBack, onNext, disabled } = props;
    const disableNext = disabled === null || disabled === void 0 ? void 0 : disabled.next;
    const disableBack = disabled === null || disabled === void 0 ? void 0 : disabled.back;
    return (React__default$4.createElement("div", { style: {
            padding: "20px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: typeof onBack === "function" ? "space-between" : "right",
        } },
        typeof onBack === "function" && (React__default$4.createElement(Button, { leftIcon: "arrow_back", label: "Back", variation: "secondary", onClick: onBack, disabled: disableBack })),
        React__default$4.createElement(Button, { id: "stepTwoNext", rightIcon: "arrow_forward", label: `Next`, variation: "primary", disabled: disableNext, onClick: onNext })));
};

var css_248z$1h = ".PrimaryAlternateControl-module_root__Ug6xM {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 20px;\n  align-items: center;\n  justify-content: space-around;\n}\n@media (min-width: 600px) {\n  .PrimaryAlternateControl-module_root__Ug6xM {\n    flex-direction: row;\n    column-gap: 20px;\n  }\n}\n\n.PrimaryAlternateControl-module_alternate__Yphi0 {\n  order: 2;\n}\n@media (min-width: 600px) {\n  .PrimaryAlternateControl-module_alternate__Yphi0 {\n    order: 1;\n  }\n}\n\n.PrimaryAlternateControl-module_primary__O5dNS {\n  order: 1;\n}\n@media (min-width: 600px) {\n  .PrimaryAlternateControl-module_primary__O5dNS {\n    order: 2;\n  }\n}";
var styles$k = {"root":"PrimaryAlternateControl-module_root__Ug6xM","alternate":"PrimaryAlternateControl-module_alternate__Yphi0","primary":"PrimaryAlternateControl-module_primary__O5dNS"};
styleInject(css_248z$1h);

const PrimaryAlternateControl = ({ style, className, labels, ids, disabled, onPrimary, onAlternate, }) => {
    return (React__default$4.createElement("div", { style: style, className: `${styles$k.root} ${className || ""}` },
        onAlternate && (React__default$4.createElement(Button, { label: (labels === null || labels === void 0 ? void 0 : labels.alternate) || "Alternate", variation: "secondary", onClick: onAlternate, disabled: disabled === null || disabled === void 0 ? void 0 : disabled.alternate, id: ids === null || ids === void 0 ? void 0 : ids.alternate, className: styles$k.alternate })),
        React__default$4.createElement(Button, { label: (labels === null || labels === void 0 ? void 0 : labels.primary) || "Continue", variation: "primary", onClick: onPrimary, disabled: disabled === null || disabled === void 0 ? void 0 : disabled.primary, id: ids === null || ids === void 0 ? void 0 : ids.primary, className: styles$k.primary })));
};

var css_248z$1g = ".Dashboard-module_dashboardContainer__Qgv20 {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n  padding: 16px;\n}";
var styles$j = {"dashboardContainer":"Dashboard-module_dashboardContainer__Qgv20"};
styleInject(css_248z$1g);

/**
 * Dashboard component that arranges its children in a responsive grid layout.
 */
const Dashboard = ({ children }) => {
    return React__default$4.createElement("div", { className: styles$j.dashboardContainer }, children);
};

var css_248z$1f = ".DashboardRow-module_dashboardRow__gMV0d {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n@media (max-width: 768px) {\n  .DashboardRow-module_dashboardRow__gMV0d {\n    flex-direction: column;\n  }\n}\n.DashboardRow-module_dashboardRow__gMV0d > div {\n  flex: 1;\n}";
var styles$i = {"dashboardRow":"DashboardRow-module_dashboardRow__gMV0d"};
styleInject(css_248z$1f);

/**
 * DashboardRow component that arranges its children in a horizontal row.
 * On small screens, the content will stack vertically.
 */
const DashboardRow = ({ children }) => {
    return React__default$4.createElement("div", { className: styles$i.dashboardRow }, children);
};

var css_248z$1e = "@keyframes Metric-module_fade__JzTFv {\n  0% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.5;\n  }\n}\n.Metric-module_metricContainer__QizRf {\n  border: 1px solid #ccc;\n  padding: 16px;\n  border-radius: 8px;\n  text-align: center;\n  background-color: #f8f9fa;\n  margin: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.Metric-module_title__Ev8Ot {\n  font-size: 1rem;\n  margin: 0 0 8px 0;\n  min-width: 120px;\n}\n\n.Metric-module_value__F-Mcx {\n  font-size: 2rem;\n  font-weight: bold;\n}\n\n.Metric-module_loading__-12d1 {\n  background-color: #656565;\n  animation: Metric-module_fade__JzTFv 1.5s infinite;\n  height: 24px;\n  width: 48px;\n}";
var styles$h = {"metricContainer":"Metric-module_metricContainer__QizRf","title":"Metric-module_title__Ev8Ot","value":"Metric-module_value__F-Mcx","loading":"Metric-module_loading__-12d1","fade":"Metric-module_fade__JzTFv"};
styleInject(css_248z$1e);

/**
 * Metric component to display a numerical value with a title.
 * It adapts the text size based on screen width.
 */
const Metric = ({ title, children, tooltip, loading, style }) => {
    if (!style) {
        style = {};
    }
    return (React__default$4.createElement(Tooltip$5, { content: tooltip },
        React__default$4.createElement("div", { style: Object.assign({}, style), className: styles$h.metricContainer },
            React__default$4.createElement("h3", { className: styles$h.title }, title),
            loading ? React__default$4.createElement("div", { className: styles$h.loading }) : React__default$4.createElement("p", { className: styles$h.value }, children))));
};

var css_248z$1d = "@keyframes Stoplight-module_fade__SiwjH {\n  0% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.5;\n  }\n}\n.Stoplight-module_stoplightContainer__V4PFe {\n  border: 1px solid #ccc;\n  padding: 16px;\n  border-radius: 8px;\n  text-align: center;\n  background-color: #f8f9fa;\n  margin: 10px;\n}\n\n.Stoplight-module_title__-l9X- {\n  font-size: 1rem;\n  margin: 0 0 8px 0;\n  min-width: 120px;\n}\n\n.Stoplight-module_lightContainer__l-0cF {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.Stoplight-module_light__oTorl {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #ccc;\n}\n\n.Stoplight-module_loading__L2rXT {\n  background-color: #656565;\n  animation: Stoplight-module_fade__SiwjH 1.5s infinite;\n}\n\n.Stoplight-module_green__lfmny {\n  background-color: #28a745;\n}\n\n.Stoplight-module_yellow__DgvH- {\n  background-color: #ffc107;\n}\n\n.Stoplight-module_red__O-aZL {\n  background-color: #dc3545;\n}";
var styles$g = {"stoplightContainer":"Stoplight-module_stoplightContainer__V4PFe","title":"Stoplight-module_title__-l9X-","lightContainer":"Stoplight-module_lightContainer__l-0cF","light":"Stoplight-module_light__oTorl","loading":"Stoplight-module_loading__L2rXT","fade":"Stoplight-module_fade__SiwjH","green":"Stoplight-module_green__lfmny","yellow":"Stoplight-module_yellow__DgvH-","red":"Stoplight-module_red__O-aZL"};
styleInject(css_248z$1d);

/**
 * Stoplight component to display a colored indicator (green, yellow, red) with a title.
 */
const Stoplight = ({ title, status, tooltip, loading }) => {
    return (React__default$4.createElement(Tooltip$5, { content: tooltip },
        React__default$4.createElement("div", { className: styles$g.stoplightContainer },
            React__default$4.createElement("h3", { className: styles$g.title }, title),
            React__default$4.createElement("div", { className: styles$g.lightContainer },
                React__default$4.createElement("div", { className: `${styles$g.light} ${styles$g[loading ? "loading" : status]}` })))));
};

var lib$2 = {};

var Surface$1 = {};

var ReactUtils = {};

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */

function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

var reactIs = {exports: {}};

var reactIs_production_min = {};

/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c$1=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k$1=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case h:case l:case q:case p:case g:return a;default:return r}}case c$1:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c$1;reactIs_production_min.Profiler=f;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q};reactIs_production_min.isMemo=function(a){return v(a)===p};
reactIs_production_min.isPortal=function(a){return v(a)===c$1};reactIs_production_min.isProfiler=function(a){return v(a)===f};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};reactIs_production_min.typeOf=v;

var reactIs_development = {};

/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types.
var REACT_ELEMENT_TYPE = Symbol.for('react.element');
var REACT_PORTAL_TYPE = Symbol.for('react.portal');
var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
var REACT_CONTEXT_TYPE = Symbol.for('react.context');
var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
var REACT_MEMO_TYPE = Symbol.for('react.memo');
var REACT_LAZY_TYPE = Symbol.for('react.lazy');
var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');

// -----------------------------------------------------------------------------

var enableScopeAPI = false; // Experimental Create Event Handle API.
var enableCacheElement = false;
var enableTransitionTracing = false; // No known bugs, but needs performance testing

var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
// stuff. Intended to enable React core members to more easily debug scheduling
// issues in DEV builds.

var enableDebugTracing = false; // Track which Fiber(s) schedule render work.

var REACT_MODULE_REFERENCE;

{
  REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
}

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing  || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden  || type === REACT_OFFSCREEN_TYPE || enableScopeAPI  || enableCacheElement  || enableTransitionTracing ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
    // types supported by any Flight configuration anywhere since
    // we don't know which Flight build this will end up being used
    // with.
    type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_SERVER_CONTEXT_TYPE:
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}
function isSuspenseList(object) {
  return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
}

reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.SuspenseList = SuspenseList;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isSuspenseList = isSuspenseList;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

var DataUtils = {};

var baseGetTag$1 = _baseGetTag,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber$2(value) {
  return typeof value == 'number' ||
    (isObjectLike$1(value) && baseGetTag$1(value) == numberTag);
}

var isNumber_1 = isNumber$2;

var isNumber$1 = isNumber_1;

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN$1(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber$1(value) && value != +value;
}

var _isNaN$3 = isNaN$1;

Object.defineProperty(DataUtils, "__esModule", {
  value: true
});
DataUtils.findEntryInArray = findEntryInArray;
DataUtils.uniqueId = DataUtils.mathSign = DataUtils.isPercent = DataUtils.isNumber = DataUtils.isNumOrStr = DataUtils.interpolateNumber = DataUtils.hasDuplicate = DataUtils.getPercentValue = DataUtils.getLinearRegression = DataUtils.getAnyElementOfObject = void 0;
var _isString$5 = _interopRequireDefault$2t(isString_1);
var _isNaN$2 = _interopRequireDefault$2t(_isNaN$3);
var _get$6 = _interopRequireDefault$2t(get_1);
var _isNumber$1 = _interopRequireDefault$2t(isNumber_1);
function _interopRequireDefault$2t(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
DataUtils.mathSign = function mathSign(value) {
  if (value === 0) {
    return 0;
  }
  if (value > 0) {
    return 1;
  }
  return -1;
};
var isPercent = DataUtils.isPercent = function isPercent(value) {
  return (0, _isString$5["default"])(value) && value.indexOf('%') === value.length - 1;
};
var isNumber = DataUtils.isNumber = function isNumber(value) {
  return (0, _isNumber$1["default"])(value) && !(0, _isNaN$2["default"])(value);
};
DataUtils.isNumOrStr = function isNumOrStr(value) {
  return isNumber(value) || (0, _isString$5["default"])(value);
};
var idCounter = 0;
DataUtils.uniqueId = function uniqueId(prefix) {
  var id = ++idCounter;
  return "".concat(prefix || '').concat(id);
};

/**
 * Get percent value of a total value
 * @param {number|string} percent A percent
 * @param {number} totalValue     Total value
 * @param {number} defaultValue   The value returned when percent is undefined or invalid
 * @param {boolean} validate      If set to be true, the result will be validated
 * @return {number} value
 */
DataUtils.getPercentValue = function getPercentValue(percent, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (!isNumber(percent) && !(0, _isString$5["default"])(percent)) {
    return defaultValue;
  }
  var value;
  if (isPercent(percent)) {
    var index = percent.indexOf('%');
    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
  } else {
    value = +percent;
  }
  if ((0, _isNaN$2["default"])(value)) {
    value = defaultValue;
  }
  if (validate && value > totalValue) {
    value = totalValue;
  }
  return value;
};
DataUtils.getAnyElementOfObject = function getAnyElementOfObject(obj) {
  if (!obj) {
    return null;
  }
  var keys = Object.keys(obj);
  if (keys && keys.length) {
    return obj[keys[0]];
  }
  return null;
};
DataUtils.hasDuplicate = function hasDuplicate(ary) {
  if (!Array.isArray(ary)) {
    return false;
  }
  var len = ary.length;
  var cache = {};
  for (var i = 0; i < len; i++) {
    if (!cache[ary[i]]) {
      cache[ary[i]] = true;
    } else {
      return true;
    }
  }
  return false;
};

/* @todo consider to rename this function into `getInterpolator` */
DataUtils.interpolateNumber = function interpolateNumber(numberA, numberB) {
  if (isNumber(numberA) && isNumber(numberB)) {
    return function (t) {
      return numberA + t * (numberB - numberA);
    };
  }
  return function () {
    return numberB;
  };
};
function findEntryInArray(ary, specifiedKey, specifiedValue) {
  if (!ary || !ary.length) {
    return null;
  }
  return ary.find(function (entry) {
    return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, _get$6["default"])(entry, specifiedKey)) === specifiedValue;
  });
}

/**
 * The least square linear regression
 * @param {Array} data The array of points
 * @returns {Object} The domain of x, and the parameter of linear function
 */
DataUtils.getLinearRegression = function getLinearRegression(data) {
  if (!data || !data.length) {
    return null;
  }
  var len = data.length;
  var xsum = 0;
  var ysum = 0;
  var xysum = 0;
  var xxsum = 0;
  var xmin = Infinity;
  var xmax = -Infinity;
  var xcurrent = 0;
  var ycurrent = 0;
  for (var i = 0; i < len; i++) {
    xcurrent = data[i].cx || 0;
    ycurrent = data[i].cy || 0;
    xsum += xcurrent;
    ysum += ycurrent;
    xysum += xcurrent * ycurrent;
    xxsum += xcurrent * xcurrent;
    xmin = Math.min(xmin, xcurrent);
    xmax = Math.max(xmax, xcurrent);
  }
  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
  return {
    xmin: xmin,
    xmax: xmax,
    a: a,
    b: (ysum - a * xsum) / len
  };
};

var ShallowEqual = {};

Object.defineProperty(ShallowEqual, "__esModule", {
  value: true
});
ShallowEqual.shallowEqual = shallowEqual$1;
function shallowEqual$1(a, b) {
  /* eslint-disable no-restricted-syntax */
  for (var key in a) {
    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
      return false;
    }
  }
  for (var _key in b) {
    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
      return false;
    }
  }
  return true;
}

var types = {};

Object.defineProperty(types, "__esModule", {
  value: true
});
types.adaptEventsOfChild = types.adaptEventHandlers = types.SVGElementPropKeys = types.FilteredElementKeyMap = types.EventKeys = void 0;
var _react$10 = React__default$4;
var _isObject$3 = _interopRequireDefault$2s(isObject_1);
function _interopRequireDefault$2s(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$12(o) { "@babel/helpers - typeof"; return _typeof$12 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$12(o); }
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */

//
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//

var SVGContainerPropKeys = ['viewBox', 'children'];
types.SVGElementPropKeys = ['aria-activedescendant', 'aria-atomic', 'aria-autocomplete', 'aria-busy', 'aria-checked', 'aria-colcount', 'aria-colindex', 'aria-colspan', 'aria-controls', 'aria-current', 'aria-describedby', 'aria-details', 'aria-disabled', 'aria-errormessage', 'aria-expanded', 'aria-flowto', 'aria-haspopup', 'aria-hidden', 'aria-invalid', 'aria-keyshortcuts', 'aria-label', 'aria-labelledby', 'aria-level', 'aria-live', 'aria-modal', 'aria-multiline', 'aria-multiselectable', 'aria-orientation', 'aria-owns', 'aria-placeholder', 'aria-posinset', 'aria-pressed', 'aria-readonly', 'aria-relevant', 'aria-required', 'aria-roledescription', 'aria-rowcount', 'aria-rowindex', 'aria-rowspan', 'aria-selected', 'aria-setsize', 'aria-sort', 'aria-valuemax', 'aria-valuemin', 'aria-valuenow', 'aria-valuetext', 'className', 'color', 'height', 'id', 'lang', 'max', 'media', 'method', 'min', 'name', 'style',
/*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */
// 'type',
'target', 'width', 'role', 'tabIndex', 'accentHeight', 'accumulate', 'additive', 'alignmentBaseline', 'allowReorder', 'alphabetic', 'amplitude', 'arabicForm', 'ascent', 'attributeName', 'attributeType', 'autoReverse', 'azimuth', 'baseFrequency', 'baselineShift', 'baseProfile', 'bbox', 'begin', 'bias', 'by', 'calcMode', 'capHeight', 'clip', 'clipPath', 'clipPathUnits', 'clipRule', 'colorInterpolation', 'colorInterpolationFilters', 'colorProfile', 'colorRendering', 'contentScriptType', 'contentStyleType', 'cursor', 'cx', 'cy', 'd', 'decelerate', 'descent', 'diffuseConstant', 'direction', 'display', 'divisor', 'dominantBaseline', 'dur', 'dx', 'dy', 'edgeMode', 'elevation', 'enableBackground', 'end', 'exponent', 'externalResourcesRequired', 'fill', 'fillOpacity', 'fillRule', 'filter', 'filterRes', 'filterUnits', 'floodColor', 'floodOpacity', 'focusable', 'fontFamily', 'fontSize', 'fontSizeAdjust', 'fontStretch', 'fontStyle', 'fontVariant', 'fontWeight', 'format', 'from', 'fx', 'fy', 'g1', 'g2', 'glyphName', 'glyphOrientationHorizontal', 'glyphOrientationVertical', 'glyphRef', 'gradientTransform', 'gradientUnits', 'hanging', 'horizAdvX', 'horizOriginX', 'href', 'ideographic', 'imageRendering', 'in2', 'in', 'intercept', 'k1', 'k2', 'k3', 'k4', 'k', 'kernelMatrix', 'kernelUnitLength', 'kerning', 'keyPoints', 'keySplines', 'keyTimes', 'lengthAdjust', 'letterSpacing', 'lightingColor', 'limitingConeAngle', 'local', 'markerEnd', 'markerHeight', 'markerMid', 'markerStart', 'markerUnits', 'markerWidth', 'mask', 'maskContentUnits', 'maskUnits', 'mathematical', 'mode', 'numOctaves', 'offset', 'opacity', 'operator', 'order', 'orient', 'orientation', 'origin', 'overflow', 'overlinePosition', 'overlineThickness', 'paintOrder', 'panose1', 'pathLength', 'patternContentUnits', 'patternTransform', 'patternUnits', 'pointerEvents', 'pointsAtX', 'pointsAtY', 'pointsAtZ', 'preserveAlpha', 'preserveAspectRatio', 'primitiveUnits', 'r', 'radius', 'refX', 'refY', 'renderingIntent', 'repeatCount', 'repeatDur', 'requiredExtensions', 'requiredFeatures', 'restart', 'result', 'rotate', 'rx', 'ry', 'seed', 'shapeRendering', 'slope', 'spacing', 'specularConstant', 'specularExponent', 'speed', 'spreadMethod', 'startOffset', 'stdDeviation', 'stemh', 'stemv', 'stitchTiles', 'stopColor', 'stopOpacity', 'strikethroughPosition', 'strikethroughThickness', 'string', 'stroke', 'strokeDasharray', 'strokeDashoffset', 'strokeLinecap', 'strokeLinejoin', 'strokeMiterlimit', 'strokeOpacity', 'strokeWidth', 'surfaceScale', 'systemLanguage', 'tableValues', 'targetX', 'targetY', 'textAnchor', 'textDecoration', 'textLength', 'textRendering', 'to', 'transform', 'u1', 'u2', 'underlinePosition', 'underlineThickness', 'unicode', 'unicodeBidi', 'unicodeRange', 'unitsPerEm', 'vAlphabetic', 'values', 'vectorEffect', 'version', 'vertAdvY', 'vertOriginX', 'vertOriginY', 'vHanging', 'vIdeographic', 'viewTarget', 'visibility', 'vMathematical', 'widths', 'wordSpacing', 'writingMode', 'x1', 'x2', 'x', 'xChannelSelector', 'xHeight', 'xlinkActuate', 'xlinkArcrole', 'xlinkHref', 'xlinkRole', 'xlinkShow', 'xlinkTitle', 'xlinkType', 'xmlBase', 'xmlLang', 'xmlns', 'xmlnsXlink', 'xmlSpace', 'y1', 'y2', 'y', 'yChannelSelector', 'z', 'zoomAndPan', 'ref', 'key', 'angle'];
var PolyElementKeys = ['points', 'pathLength'];

/** svg element types that have specific attribute filtration requirements */

/** map of svg element types to unique svg attributes that belong to that element */
types.FilteredElementKeyMap = {
  svg: SVGContainerPropKeys,
  polygon: PolyElementKeys,
  polyline: PolyElementKeys
};
var EventKeys = types.EventKeys = ['dangerouslySetInnerHTML', 'onCopy', 'onCopyCapture', 'onCut', 'onCutCapture', 'onPaste', 'onPasteCapture', 'onCompositionEnd', 'onCompositionEndCapture', 'onCompositionStart', 'onCompositionStartCapture', 'onCompositionUpdate', 'onCompositionUpdateCapture', 'onFocus', 'onFocusCapture', 'onBlur', 'onBlurCapture', 'onChange', 'onChangeCapture', 'onBeforeInput', 'onBeforeInputCapture', 'onInput', 'onInputCapture', 'onReset', 'onResetCapture', 'onSubmit', 'onSubmitCapture', 'onInvalid', 'onInvalidCapture', 'onLoad', 'onLoadCapture', 'onError', 'onErrorCapture', 'onKeyDown', 'onKeyDownCapture', 'onKeyPress', 'onKeyPressCapture', 'onKeyUp', 'onKeyUpCapture', 'onAbort', 'onAbortCapture', 'onCanPlay', 'onCanPlayCapture', 'onCanPlayThrough', 'onCanPlayThroughCapture', 'onDurationChange', 'onDurationChangeCapture', 'onEmptied', 'onEmptiedCapture', 'onEncrypted', 'onEncryptedCapture', 'onEnded', 'onEndedCapture', 'onLoadedData', 'onLoadedDataCapture', 'onLoadedMetadata', 'onLoadedMetadataCapture', 'onLoadStart', 'onLoadStartCapture', 'onPause', 'onPauseCapture', 'onPlay', 'onPlayCapture', 'onPlaying', 'onPlayingCapture', 'onProgress', 'onProgressCapture', 'onRateChange', 'onRateChangeCapture', 'onSeeked', 'onSeekedCapture', 'onSeeking', 'onSeekingCapture', 'onStalled', 'onStalledCapture', 'onSuspend', 'onSuspendCapture', 'onTimeUpdate', 'onTimeUpdateCapture', 'onVolumeChange', 'onVolumeChangeCapture', 'onWaiting', 'onWaitingCapture', 'onAuxClick', 'onAuxClickCapture', 'onClick', 'onClickCapture', 'onContextMenu', 'onContextMenuCapture', 'onDoubleClick', 'onDoubleClickCapture', 'onDrag', 'onDragCapture', 'onDragEnd', 'onDragEndCapture', 'onDragEnter', 'onDragEnterCapture', 'onDragExit', 'onDragExitCapture', 'onDragLeave', 'onDragLeaveCapture', 'onDragOver', 'onDragOverCapture', 'onDragStart', 'onDragStartCapture', 'onDrop', 'onDropCapture', 'onMouseDown', 'onMouseDownCapture', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseMoveCapture', 'onMouseOut', 'onMouseOutCapture', 'onMouseOver', 'onMouseOverCapture', 'onMouseUp', 'onMouseUpCapture', 'onSelect', 'onSelectCapture', 'onTouchCancel', 'onTouchCancelCapture', 'onTouchEnd', 'onTouchEndCapture', 'onTouchMove', 'onTouchMoveCapture', 'onTouchStart', 'onTouchStartCapture', 'onPointerDown', 'onPointerDownCapture', 'onPointerMove', 'onPointerMoveCapture', 'onPointerUp', 'onPointerUpCapture', 'onPointerCancel', 'onPointerCancelCapture', 'onPointerEnter', 'onPointerEnterCapture', 'onPointerLeave', 'onPointerLeaveCapture', 'onPointerOver', 'onPointerOverCapture', 'onPointerOut', 'onPointerOutCapture', 'onGotPointerCapture', 'onGotPointerCaptureCapture', 'onLostPointerCapture', 'onLostPointerCaptureCapture', 'onScroll', 'onScrollCapture', 'onWheel', 'onWheelCapture', 'onAnimationStart', 'onAnimationStartCapture', 'onAnimationEnd', 'onAnimationEndCapture', 'onAnimationIteration', 'onAnimationIterationCapture', 'onTransitionEnd', 'onTransitionEndCapture'];

/** The type of easing function to use for animations */

/** Specifies the duration of animation, the unit of this option is ms. */

/** the offset of a chart, which define the blank space all around */

/**
 * The domain of axis.
 * This is the definition
 *
 * Numeric domain is always defined by an array of exactly two values, for the min and the max of the axis.
 * Categorical domain is defined as array of all possible values.
 *
 * Can be specified in many ways:
 * - array of numbers
 * - with special strings like 'dataMin' and 'dataMax'
 * - with special string math like 'dataMin - 100'
 * - with keyword 'auto'
 * - or a function
 * - array of functions
 * - or a combination of the above
 */

/**
 * NumberDomain is an evaluated {@link AxisDomain}.
 * Unlike {@link AxisDomain}, it has no variety - it's a tuple of two number.
 * This is after all the keywords and functions were evaluated and what is left is [min, max].
 *
 * Know that the min, max values are not guaranteed to be nice numbers - values like -Infinity or NaN are possible.
 *
 * There are also `category` axes that have different things than numbers in their domain.
 */

/** The props definition of base axis */

/** Defines how ticks are placed and whether / how tick collisions are handled.
 * 'preserveStart' keeps the left tick on collision and ensures that the first tick is always shown.
 * 'preserveEnd' keeps the right tick on collision and ensures that the last tick is always shown.
 * 'preserveStartEnd' keeps the left tick on collision and ensures that the first and last ticks are always shown.
 * 'equidistantPreserveStart' selects a number N such that every nTh tick will be shown without collision.
 */

types.adaptEventHandlers = function adaptEventHandlers(props, newHandler) {
  if (!props || typeof props === 'function' || typeof props === 'boolean') {
    return null;
  }
  var inputProps = props;
  if ( /*#__PURE__*/(0, _react$10.isValidElement)(props)) {
    inputProps = props.props;
  }
  if (!(0, _isObject$3["default"])(inputProps)) {
    return null;
  }
  var out = {};
  Object.keys(inputProps).forEach(function (key) {
    if (EventKeys.includes(key)) {
      out[key] = newHandler || function (e) {
        return inputProps[key](inputProps, e);
      };
    }
  });
  return out;
};
var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
  return function (e) {
    originalHandler(data, index, e);
    return null;
  };
};
types.adaptEventsOfChild = function adaptEventsOfChild(props, data, index) {
  if (!(0, _isObject$3["default"])(props) || _typeof$12(props) !== 'object') {
    return null;
  }
  var out = null;
  Object.keys(props).forEach(function (key) {
    var item = props[key];
    if (EventKeys.includes(key) && typeof item === 'function') {
      if (!out) out = {};
      out[key] = getEventHandlerOfChild(item, data, index);
    }
  });
  return out;
};

Object.defineProperty(ReactUtils, "__esModule", {
  value: true
});
ReactUtils.filterSvgElements = ReactUtils.filterProps = ReactUtils.TOOLTIP_TYPES = ReactUtils.SCALE_TYPES = ReactUtils.LEGEND_TYPES = void 0;
ReactUtils.findAllByType = findAllByType;
ReactUtils.findChildByType = findChildByType;
ReactUtils.withoutType = ReactUtils.validateWidthHeight = ReactUtils.toArray = ReactUtils.renderByOrder = ReactUtils.parseChildIndex = ReactUtils.isValidSpreadableProp = ReactUtils.isSingleChildEqual = ReactUtils.isChildrenEqual = ReactUtils.hasClipDot = ReactUtils.getReactEventByType = ReactUtils.getDisplayName = void 0;
var _get$5 = _interopRequireDefault$2r(get_1);
var _isNil$c = _interopRequireDefault$2r(isNil_1);
var _isString$4 = _interopRequireDefault$2r(isString_1);
var _isFunction$r = _interopRequireDefault$2r(isFunction_1);
var _isObject$2 = _interopRequireDefault$2r(isObject_1);
var _react$$ = React__default$4;
var _reactIs = reactIs.exports;
var _DataUtils$v = DataUtils;
var _ShallowEqual$3 = ShallowEqual;
var _types$c = types;
var _excluded$t = ["children"],
  _excluded2$a = ["children"];
function _interopRequireDefault$2r(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties$w(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$t(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$t(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _typeof$11(o) { "@babel/helpers - typeof"; return _typeof$11 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$11(o); }
var REACT_BROWSER_EVENT_MAP = {
  click: 'onClick',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  mouseover: 'onMouseOver',
  mousemove: 'onMouseMove',
  mouseout: 'onMouseOut',
  mouseenter: 'onMouseEnter',
  mouseleave: 'onMouseLeave',
  touchcancel: 'onTouchCancel',
  touchend: 'onTouchEnd',
  touchmove: 'onTouchMove',
  touchstart: 'onTouchStart',
  contextmenu: 'onContextMenu',
  dblclick: 'onDoubleClick'
};
ReactUtils.SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold'];
ReactUtils.LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
ReactUtils.TOOLTIP_TYPES = ['none'];

/**
 * Get the display name of a component
 * @param  {Object} Comp Specified Component
 * @return {String}      Display name of Component
 */
var getDisplayName = ReactUtils.getDisplayName = function getDisplayName(Comp) {
  if (typeof Comp === 'string') {
    return Comp;
  }
  if (!Comp) {
    return '';
  }
  return Comp.displayName || Comp.name || 'Component';
};

// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var lastChildren = null;
var lastResult = null;
var toArray = ReactUtils.toArray = function toArray(children) {
  if (children === lastChildren && Array.isArray(lastResult)) {
    return lastResult;
  }
  var result = [];
  _react$$.Children.forEach(children, function (child) {
    if ((0, _isNil$c["default"])(child)) return;
    if ((0, _reactIs.isFragment)(child)) {
      result = result.concat(toArray(child.props.children));
    } else {
      // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
      result.push(child);
    }
  });
  lastResult = result;
  lastChildren = children;
  return result;
};

/*
 * Find and return all matched children by type.
 * `type` must be a React.ComponentType
 */
function findAllByType(children, type) {
  var result = [];
  var types = [];
  if (Array.isArray(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }
  toArray(children).forEach(function (child) {
    var childType = (0, _get$5["default"])(child, 'type.displayName') || (0, _get$5["default"])(child, 'type.name');
    if (types.indexOf(childType) !== -1) {
      result.push(child);
    }
  });
  return result;
}

/*
 * Return the first matched child by type, return null otherwise.
 * `type` must be a React.ComponentType
 */
function findChildByType(children, type) {
  var result = findAllByType(children, type);
  return result && result[0];
}

/*
 * Create a new array of children excluding the ones matched the type
 */
ReactUtils.withoutType = function withoutType(children, type) {
  var newChildren = [];
  var types;
  if (Array.isArray(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }
  toArray(children).forEach(function (child) {
    var displayName = (0, _get$5["default"])(child, 'type.displayName');
    if (displayName && types.indexOf(displayName) !== -1) {
      return;
    }
    newChildren.push(child);
  });
  return newChildren;
};

/**
 * validate the width and height props of a chart element
 * @param  {Object} el A chart element
 * @return {Boolean}   true If the props width and height are number, and greater than 0
 */
ReactUtils.validateWidthHeight = function validateWidthHeight(el) {
  if (!el || !el.props) {
    return false;
  }
  var _el$props = el.props,
    width = _el$props.width,
    height = _el$props.height;
  if (!(0, _DataUtils$v.isNumber)(width) || width <= 0 || !(0, _DataUtils$v.isNumber)(height) || height <= 0) {
    return false;
  }
  return true;
};
var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
var isSvgElement = function isSvgElement(child) {
  return child && child.type && (0, _isString$4["default"])(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
ReactUtils.hasClipDot = function hasClipDot(dot) {
  return dot && _typeof$11(dot) === 'object' && 'clipDot' in dot;
};

/**
 * Checks if the property is valid to spread onto an SVG element or onto a specific component
 * @param {unknown} property property value currently being compared
 * @param {string} key property key currently being compared
 * @param {boolean} includeEvents if events are included in spreadable props
 * @param {boolean} svgElementType checks against map of SVG element types to attributes
 * @returns {boolean} is prop valid
 */
var isValidSpreadableProp = ReactUtils.isValidSpreadableProp = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
  var _FilteredElementKeyMa;
  /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */
  var matchingElementTypeKeys = (_FilteredElementKeyMa = _types$c.FilteredElementKeyMap === null || _types$c.FilteredElementKeyMap === void 0 ? void 0 : _types$c.FilteredElementKeyMap[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
  return !(0, _isFunction$r["default"])(property) && (svgElementType && matchingElementTypeKeys.includes(key) || _types$c.SVGElementPropKeys.includes(key)) || includeEvents && _types$c.EventKeys.includes(key);
};

/**
 * Filter all the svg elements of children
 * @param  {Array} children The children of a react element
 * @return {Array}          All the svg elements
 */
ReactUtils.filterSvgElements = function filterSvgElements(children) {
  var svgElements = [];
  toArray(children).forEach(function (entry) {
    if (isSvgElement(entry)) {
      svgElements.push(entry);
    }
  });
  return svgElements;
};
ReactUtils.filterProps = function filterProps(props, includeEvents, svgElementType) {
  if (!props || typeof props === 'function' || typeof props === 'boolean') {
    return null;
  }
  var inputProps = props;
  if ( /*#__PURE__*/(0, _react$$.isValidElement)(props)) {
    inputProps = props.props;
  }
  if (!(0, _isObject$2["default"])(inputProps)) {
    return null;
  }
  var out = {};

  /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */
  Object.keys(inputProps).forEach(function (key) {
    var _inputProps;
    if (isValidSpreadableProp((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) {
      out[key] = inputProps[key];
    }
  });
  return out;
};

/**
 * Wether props of children changed
 * @param  {Object} nextChildren The latest children
 * @param  {Object} prevChildren The prev children
 * @return {Boolean}             equal or not
 */
var isChildrenEqual = ReactUtils.isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }
  var count = _react$$.Children.count(nextChildren);
  if (count !== _react$$.Children.count(prevChildren)) {
    return false;
  }
  if (count === 0) {
    return true;
  }
  if (count === 1) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return isSingleChildEqual(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
  }
  for (var i = 0; i < count; i++) {
    var nextChild = nextChildren[i];
    var prevChild = prevChildren[i];
    if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
      if (!isChildrenEqual(nextChild, prevChild)) {
        return false;
      }
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
    } else if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }
  return true;
};
var isSingleChildEqual = ReactUtils.isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
  if ((0, _isNil$c["default"])(nextChild) && (0, _isNil$c["default"])(prevChild)) {
    return true;
  }
  if (!(0, _isNil$c["default"])(nextChild) && !(0, _isNil$c["default"])(prevChild)) {
    var _ref = nextChild.props || {},
      nextChildren = _ref.children,
      nextProps = _objectWithoutProperties$w(_ref, _excluded$t);
    var _ref2 = prevChild.props || {},
      prevChildren = _ref2.children,
      prevProps = _objectWithoutProperties$w(_ref2, _excluded2$a);
    if (nextChildren && prevChildren) {
      return (0, _ShallowEqual$3.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
    }
    if (!nextChildren && !prevChildren) {
      return (0, _ShallowEqual$3.shallowEqual)(nextProps, prevProps);
    }
    return false;
  }
  return false;
};
ReactUtils.renderByOrder = function renderByOrder(children, renderMap) {
  var elements = [];
  var record = {};
  toArray(children).forEach(function (child, index) {
    if (isSvgElement(child)) {
      elements.push(child);
    } else if (child) {
      var displayName = getDisplayName(child.type);
      var _ref3 = renderMap[displayName] || {},
        handler = _ref3.handler,
        once = _ref3.once;
      if (handler && (!once || !record[displayName])) {
        var results = handler(child, displayName, index);
        elements.push(results);
        record[displayName] = true;
      }
    }
  });
  return elements;
};
ReactUtils.getReactEventByType = function getReactEventByType(e) {
  var type = e && e.type;
  if (type && REACT_BROWSER_EVENT_MAP[type]) {
    return REACT_BROWSER_EVENT_MAP[type];
  }
  return null;
};
ReactUtils.parseChildIndex = function parseChildIndex(child, children) {
  return toArray(children).indexOf(child);
};

Object.defineProperty(Surface$1, "__esModule", {
  value: true
});
Surface$1.Surface = Surface;
var _react$_ = _interopRequireDefault$2q(React__default$4);
var _clsx$A = _interopRequireDefault$2q(clsx.exports);
var _ReactUtils$D = ReactUtils;
var _excluded$s = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
/**
 * @fileOverview Surface
 */
function _interopRequireDefault$2q(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
function _objectWithoutProperties$v(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$s(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$s(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function Surface(props) {
  var children = props.children,
    width = props.width,
    height = props.height,
    viewBox = props.viewBox,
    className = props.className,
    style = props.style,
    title = props.title,
    desc = props.desc,
    others = _objectWithoutProperties$v(props, _excluded$s);
  var svgView = viewBox || {
    width: width,
    height: height,
    x: 0,
    y: 0
  };
  var layerClass = (0, _clsx$A["default"])('recharts-surface', className);
  return /*#__PURE__*/_react$_["default"].createElement("svg", _extends$N({}, (0, _ReactUtils$D.filterProps)(others, true, 'svg'), {
    className: layerClass,
    width: width,
    height: height,
    style: style,
    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
  }), /*#__PURE__*/_react$_["default"].createElement("title", null, title), /*#__PURE__*/_react$_["default"].createElement("desc", null, desc), children);
}

var Layer = {};

Object.defineProperty(Layer, "__esModule", {
  value: true
});
Layer.Layer = void 0;
var _react$Z = _interopRequireDefault$2p(React__default$4);
var _clsx$z = _interopRequireDefault$2p(clsx.exports);
var _ReactUtils$C = ReactUtils;
var _excluded$r = ["children", "className"];
function _interopRequireDefault$2p(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
function _objectWithoutProperties$u(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$r(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$r(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
Layer.Layer = /*#__PURE__*/_react$Z["default"].forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    others = _objectWithoutProperties$u(props, _excluded$r);
  var layerClass = (0, _clsx$z["default"])('recharts-layer', className);
  return /*#__PURE__*/_react$Z["default"].createElement("g", _extends$M({
    className: layerClass
  }, (0, _ReactUtils$C.filterProps)(others, true), {
    ref: ref
  }), children);
});

var Legend$1 = {};

var DefaultLegendContent$1 = {};

var LogUtils = {};

Object.defineProperty(LogUtils, "__esModule", {
  value: true
});
LogUtils.warn = void 0;
/* eslint no-console: 0 */
var isDev$1 = process.env.NODE_ENV !== 'production';
LogUtils.warn = function warn(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  if (isDev$1 && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }
    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var argIndex = 0;
        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

var Symbols$1 = {};

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$2(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$2;

var baseSlice$1 = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice$1(array, start, end);
}

var _castSlice = castSlice$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$1;

var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst;

var src$9 = {};

var arc = {};

var src$8 = {};

var path$1 = {};

Object.defineProperty(path$1, "__esModule", {
  value: true
});
path$1.default = void 0;
const pi$1 = Math.PI,
      tau$1 = 2 * pi$1,
      epsilon$1 = 1e-6,
      tauEpsilon = tau$1 - epsilon$1;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath

  this._ = "";
}

function path() {
  return new Path();
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function (x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function () {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function (x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function (x1, y1, x, y) {
    this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function (x1, y1, x2, y2, x, y) {
    this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function (x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.

    if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).

    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    } // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    } // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.

      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function (x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.

    if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).

    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    } // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    } // Is this arc empty? We’re done.


    if (!r) return; // Does the angle go the wrong way? Flip the direction.

    if (da < 0) da = da % tau$1 + tau$1; // Is this a complete circle? Draw two arcs to complete the circle.

    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    } // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + +(da >= pi$1) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function (x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
  },
  toString: function () {
    return this._;
  }
};
var _default$1D = path;
path$1.default = _default$1D;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "path", {
  enumerable: true,
  get: function () {
    return _path.default;
  }
});

var _path = _interopRequireDefault(path$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
}(src$8));

var constant$4 = {};

Object.defineProperty(constant$4, "__esModule", {
  value: true
});
constant$4.default = _default$1C;

function _default$1C(x) {
  return function constant() {
    return x;
  };
}

var math$1 = {};

Object.defineProperty(math$1, "__esModule", {
  value: true
});
math$1.abs = void 0;
math$1.acos = acos;
math$1.asin = asin;
math$1.tau = math$1.sqrt = math$1.sin = math$1.pi = math$1.min = math$1.max = math$1.halfPi = math$1.epsilon = math$1.cos = math$1.atan2 = void 0;
const abs = Math.abs;
math$1.abs = abs;
const atan2 = Math.atan2;
math$1.atan2 = atan2;
const cos = Math.cos;
math$1.cos = cos;
const max$5 = Math.max;
math$1.max = max$5;
const min$5 = Math.min;
math$1.min = min$5;
const sin = Math.sin;
math$1.sin = sin;
const sqrt$1 = Math.sqrt;
math$1.sqrt = sqrt$1;
const epsilon = 1e-12;
math$1.epsilon = epsilon;
const pi = Math.PI;
math$1.pi = pi;
const halfPi = pi / 2;
math$1.halfPi = halfPi;
const tau = 2 * pi;
math$1.tau = tau;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

Object.defineProperty(arc, "__esModule", {
  value: true
});
arc.default = _default$1B;

var _index$ac = src$8;

var _constant$a = _interopRequireDefault$2o(constant$4);

var _math$h = math$1;

function _interopRequireDefault$2o(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0,
      y10 = y1 - y0,
      x32 = x3 - x2,
      y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < _math$h.epsilon) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html


function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / (0, _math$h.sqrt)(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * (0, _math$h.sqrt)((0, _math$h.max)(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00; // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?

  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

function _default$1B() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = (0, _constant$a.default)(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - _math$h.halfPi,
        a1 = endAngle.apply(this, arguments) - _math$h.halfPi,
        da = (0, _math$h.abs)(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = (0, _index$ac.path)(); // Ensure that the outer radius is always larger than the inner radius.

    if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?

    if (!(r1 > _math$h.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
    else if (da > _math$h.tau - _math$h.epsilon) {
      context.moveTo(r1 * (0, _math$h.cos)(a0), r1 * (0, _math$h.sin)(a0));
      context.arc(0, 0, r1, a0, a1, !cw);

      if (r0 > _math$h.epsilon) {
        context.moveTo(r0 * (0, _math$h.cos)(a1), r0 * (0, _math$h.sin)(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    } // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = ap > _math$h.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, _math$h.sqrt)(r0 * r0 + r1 * r1)),
          rc = (0, _math$h.min)((0, _math$h.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.

      if (rp > _math$h.epsilon) {
        var p0 = (0, _math$h.asin)(rp / r0 * (0, _math$h.sin)(ap)),
            p1 = (0, _math$h.asin)(rp / r1 * (0, _math$h.sin)(ap));
        if ((da0 -= p0 * 2) > _math$h.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > _math$h.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * (0, _math$h.cos)(a01),
          y01 = r1 * (0, _math$h.sin)(a01),
          x10 = r0 * (0, _math$h.cos)(a10),
          y10 = r0 * (0, _math$h.sin)(a10); // Apply rounded corners?

      if (rc > _math$h.epsilon) {
        var x11 = r1 * (0, _math$h.cos)(a11),
            y11 = r1 * (0, _math$h.sin)(a11),
            x00 = r0 * (0, _math$h.cos)(a00),
            y00 = r0 * (0, _math$h.sin)(a00),
            oc; // Restrict the corner radius according to the sector angle.

        if (da < _math$h.pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / (0, _math$h.sin)((0, _math$h.acos)((ax * bx + ay * by) / ((0, _math$h.sqrt)(ax * ax + ay * ay) * (0, _math$h.sqrt)(bx * bx + by * by))) / 2),
              lc = (0, _math$h.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = (0, _math$h.min)(rc, (r0 - lc) / (kc - 1));
          rc1 = (0, _math$h.min)(rc, (r1 - lc) / (kc + 1));
        }
      } // Is the sector collapsed to a line?


      if (!(da1 > _math$h.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
      else if (rc1 > _math$h.epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?

        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _math$h.atan2)(t0.y01, t0.x01), (0, _math$h.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, (0, _math$h.atan2)(t0.y01, t0.x01), (0, _math$h.atan2)(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, (0, _math$h.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math$h.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, (0, _math$h.atan2)(t1.y11, t1.x11), (0, _math$h.atan2)(t1.y01, t1.x01), !cw);
        }
      } // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?

      if (!(r0 > _math$h.epsilon) || !(da0 > _math$h.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > _math$h.epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?

        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _math$h.atan2)(t0.y01, t0.x01), (0, _math$h.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, (0, _math$h.atan2)(t0.y01, t0.x01), (0, _math$h.atan2)(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, (0, _math$h.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math$h.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, (0, _math$h.atan2)(t1.y11, t1.x11), (0, _math$h.atan2)(t1.y01, t1.x01), !cw);
        }
      } // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function () {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - _math$h.pi / 2;
    return [(0, _math$h.cos)(a) * r, (0, _math$h.sin)(a) * r];
  };

  arc.innerRadius = function (_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constant$a.default)(+_), arc) : innerRadius;
  };

  arc.outerRadius = function (_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constant$a.default)(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function (_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constant$a.default)(+_), arc) : cornerRadius;
  };

  arc.padRadius = function (_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constant$a.default)(+_), arc) : padRadius;
  };

  arc.startAngle = function (_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant$a.default)(+_), arc) : startAngle;
  };

  arc.endAngle = function (_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant$a.default)(+_), arc) : endAngle;
  };

  arc.padAngle = function (_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant$a.default)(+_), arc) : padAngle;
  };

  arc.context = function (_) {
    return arguments.length ? (context = _ == null ? null : _, arc) : context;
  };

  return arc;
}

var area = {};

var array$3 = {};

Object.defineProperty(array$3, "__esModule", {
  value: true
});
array$3.default = _default$1A;
array$3.slice = void 0;
var slice$3 = Array.prototype.slice;
array$3.slice = slice$3;

function _default$1A(x) {
  return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
  : Array.from(x); // Map, Set, iterable, string, or anything else
}

var linear$3 = {};

Object.defineProperty(linear$3, "__esModule", {
  value: true
});
linear$3.default = _default$1z;

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;

    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;

      case 1:
        this._point = 2;
      // falls through

      default:
        this._context.lineTo(x, y);

        break;
    }
  }
};

function _default$1z(context) {
  return new Linear(context);
}

var line = {};

var point$5 = {};

Object.defineProperty(point$5, "__esModule", {
  value: true
});
point$5.x = x$1;
point$5.y = y;

function x$1(p) {
  return p[0];
}

function y(p) {
  return p[1];
}

Object.defineProperty(line, "__esModule", {
  value: true
});
line.default = _default$1y;

var _index$ab = src$8;

var _array$6 = _interopRequireDefault$2n(array$3);

var _constant$9 = _interopRequireDefault$2n(constant$4);

var _linear$9 = _interopRequireDefault$2n(linear$3);

var _point$2 = point$5;

function _interopRequireDefault$2n(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$1y(x, y) {
  var defined = (0, _constant$9.default)(true),
      context = null,
      curve = _linear$9.default,
      output = null;
  x = typeof x === "function" ? x : x === undefined ? _point$2.x : (0, _constant$9.default)(x);
  y = typeof y === "function" ? y : y === undefined ? _point$2.y : (0, _constant$9.default)(y);

  function line(data) {
    var i,
        n = (data = (0, _array$6.default)(data)).length,
        d,
        defined0 = false,
        buffer;
    if (context == null) output = curve(buffer = (0, _index$ab.path)());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();else output.lineEnd();
      }

      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function (_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant$9.default)(+_), line) : x;
  };

  line.y = function (_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant$9.default)(+_), line) : y;
  };

  line.defined = function (_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant$9.default)(!!_), line) : defined;
  };

  line.curve = function (_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function (_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

Object.defineProperty(area, "__esModule", {
  value: true
});
area.default = _default$1x;

var _index$aa = src$8;

var _array$5 = _interopRequireDefault$2m(array$3);

var _constant$8 = _interopRequireDefault$2m(constant$4);

var _linear$8 = _interopRequireDefault$2m(linear$3);

var _line$1 = _interopRequireDefault$2m(line);

var _point$1 = point$5;

function _interopRequireDefault$2m(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$1x(x0, y0, y1) {
  var x1 = null,
      defined = (0, _constant$8.default)(true),
      context = null,
      curve = _linear$8.default,
      output = null;
  x0 = typeof x0 === "function" ? x0 : x0 === undefined ? _point$1.x : (0, _constant$8.default)(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constant$8.default)(0) : (0, _constant$8.default)(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === undefined ? _point$1.y : (0, _constant$8.default)(+y1);

  function area(data) {
    var i,
        j,
        k,
        n = (data = (0, _array$5.default)(data)).length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);
    if (context == null) output = curve(buffer = (0, _index$aa.path)());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();

          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }

          output.lineEnd();
          output.areaEnd();
        }
      }

      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return (0, _line$1.default)().defined(defined).curve(curve).context(context);
  }

  area.x = function (_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant$8.default)(+_), x1 = null, area) : x0;
  };

  area.x0 = function (_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant$8.default)(+_), area) : x0;
  };

  area.x1 = function (_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant$8.default)(+_), area) : x1;
  };

  area.y = function (_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant$8.default)(+_), y1 = null, area) : y0;
  };

  area.y0 = function (_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant$8.default)(+_), area) : y0;
  };

  area.y1 = function (_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant$8.default)(+_), area) : y1;
  };

  area.lineX0 = area.lineY0 = function () {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function () {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function () {
    return arealine().x(x1).y(y0);
  };

  area.defined = function (_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant$8.default)(!!_), area) : defined;
  };

  area.curve = function (_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function (_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
}

var pie = {};

var descending$3 = {};

Object.defineProperty(descending$3, "__esModule", {
  value: true
});
descending$3.default = _default$1w;

function _default$1w(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

var identity$b = {};

Object.defineProperty(identity$b, "__esModule", {
  value: true
});
identity$b.default = _default$1v;

function _default$1v(d) {
  return d;
}

Object.defineProperty(pie, "__esModule", {
  value: true
});
pie.default = _default$1u;

var _array$4 = _interopRequireDefault$2l(array$3);

var _constant$7 = _interopRequireDefault$2l(constant$4);

var _descending$1 = _interopRequireDefault$2l(descending$3);

var _identity$3 = _interopRequireDefault$2l(identity$b);

var _math$g = math$1;

function _interopRequireDefault$2l(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$1u() {
  var value = _identity$3.default,
      sortValues = _descending$1.default,
      sort = null,
      startAngle = (0, _constant$7.default)(0),
      endAngle = (0, _constant$7.default)(_math$g.tau),
      padAngle = (0, _constant$7.default)(0);

  function pie(data) {
    var i,
        n = (data = (0, _array$4.default)(data)).length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(_math$g.tau, Math.max(-_math$g.tau, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    } // Optionally sort the arcs by previously-computed values or by data.


    if (sortValues != null) index.sort(function (i, j) {
      return sortValues(arcs[i], arcs[j]);
    });else if (sort != null) index.sort(function (i, j) {
      return sort(data[i], data[j]);
    }); // Compute the arcs! They are stored in the original data's order.

    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function (_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant$7.default)(+_), pie) : value;
  };

  pie.sortValues = function (_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function (_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function (_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant$7.default)(+_), pie) : startAngle;
  };

  pie.endAngle = function (_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant$7.default)(+_), pie) : endAngle;
  };

  pie.padAngle = function (_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant$7.default)(+_), pie) : padAngle;
  };

  return pie;
}

var areaRadial = {};

var radial$2 = {};

Object.defineProperty(radial$2, "__esModule", {
  value: true
});
radial$2.curveRadialLinear = void 0;
radial$2.default = curveRadial;

var _linear$7 = _interopRequireDefault$2k(linear$3);

function _interopRequireDefault$2k(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var curveRadialLinear = curveRadial(_linear$7.default);
radial$2.curveRadialLinear = curveRadialLinear;

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function () {
    this._curve.areaStart();
  },
  areaEnd: function () {
    this._curve.areaEnd();
  },
  lineStart: function () {
    this._curve.lineStart();
  },
  lineEnd: function () {
    this._curve.lineEnd();
  },
  point: function (a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {
  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;
  return radial;
}

var lineRadial$1 = {};

Object.defineProperty(lineRadial$1, "__esModule", {
  value: true
});
lineRadial$1.default = _default$1t;
lineRadial$1.lineRadial = lineRadial;

var _radial$1 = _interopRequireWildcard$M(radial$2);

var _line = _interopRequireDefault$2j(line);

function _interopRequireDefault$2j(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache$M(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$M = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$M(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$M(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function lineRadial(l) {
  var c = l.curve;
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function (_) {
    return arguments.length ? c((0, _radial$1.default)(_)) : c()._curve;
  };

  return l;
}

function _default$1t() {
  return lineRadial((0, _line.default)().curve(_radial$1.curveRadialLinear));
}

Object.defineProperty(areaRadial, "__esModule", {
  value: true
});
areaRadial.default = _default$1s;

var _radial = _interopRequireWildcard$L(radial$2);

var _area = _interopRequireDefault$2i(area);

var _lineRadial = lineRadial$1;

function _interopRequireDefault$2i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache$L(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$L = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$L(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$L(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _default$1s() {
  var a = (0, _area.default)().curve(_radial.curveRadialLinear),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;
  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function () {
    return (0, _lineRadial.lineRadial)(x0());
  }, delete a.lineX0;
  a.lineEndAngle = function () {
    return (0, _lineRadial.lineRadial)(x1());
  }, delete a.lineX1;
  a.lineInnerRadius = function () {
    return (0, _lineRadial.lineRadial)(y0());
  }, delete a.lineY0;
  a.lineOuterRadius = function () {
    return (0, _lineRadial.lineRadial)(y1());
  }, delete a.lineY1;

  a.curve = function (_) {
    return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
  };

  return a;
}

var pointRadial = {};

Object.defineProperty(pointRadial, "__esModule", {
  value: true
});
pointRadial.default = _default$1r;

function _default$1r(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}

var link$1 = {};

var bump = {};

Object.defineProperty(bump, "__esModule", {
  value: true
});
bump.bumpRadial = bumpRadial;
bump.bumpX = bumpX;
bump.bumpY = bumpY;

var _pointRadial = _interopRequireDefault$2h(pointRadial);

function _interopRequireDefault$2h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class Bump {
  constructor(context, x) {
    this._context = context;
    this._x = x;
  }

  areaStart() {
    this._line = 0;
  }

  areaEnd() {
    this._line = NaN;
  }

  lineStart() {
    this._point = 0;
  }

  lineEnd() {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  }

  point(x, y) {
    x = +x, y = +y;

    switch (this._point) {
      case 0:
        {
          this._point = 1;
          if (this._line) this._context.lineTo(x, y);else this._context.moveTo(x, y);
          break;
        }

      case 1:
        this._point = 2;
      // falls through

      default:
        {
          if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
          break;
        }
    }

    this._x0 = x, this._y0 = y;
  }

}

class BumpRadial {
  constructor(context) {
    this._context = context;
  }

  lineStart() {
    this._point = 0;
  }

  lineEnd() {}

  point(x, y) {
    x = +x, y = +y;

    if (this._point++ === 0) {
      this._x0 = x, this._y0 = y;
    } else {
      const p0 = (0, _pointRadial.default)(this._x0, this._y0);
      const p1 = (0, _pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
      const p2 = (0, _pointRadial.default)(x, this._y0);
      const p3 = (0, _pointRadial.default)(x, y);

      this._context.moveTo(...p0);

      this._context.bezierCurveTo(...p1, ...p2, ...p3);
    }
  }

}

function bumpX(context) {
  return new Bump(context, true);
}

function bumpY(context) {
  return new Bump(context, false);
}

function bumpRadial(context) {
  return new BumpRadial(context);
}

Object.defineProperty(link$1, "__esModule", {
  value: true
});
link$1.link = link;
link$1.linkHorizontal = linkHorizontal;
link$1.linkRadial = linkRadial;
link$1.linkVertical = linkVertical;

var _index$a9 = src$8;

var _array$3 = array$3;

var _constant$6 = _interopRequireDefault$2g(constant$4);

var _bump = bump;

var _point = point$5;

function _interopRequireDefault$2g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  let source = linkSource;
  let target = linkTarget;
  let x = _point.x;
  let y = _point.y;
  let context = null;
  let output = null;

  function link() {
    let buffer;

    const argv = _array$3.slice.call(arguments);

    const s = source.apply(this, argv);
    const t = target.apply(this, argv);
    if (context == null) output = curve(buffer = (0, _index$a9.path)());
    output.lineStart();
    argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
    argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
    output.lineEnd();
    if (buffer) return output = null, buffer + "" || null;
  }

  link.source = function (_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function (_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function (_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant$6.default)(+_), link) : x;
  };

  link.y = function (_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant$6.default)(+_), link) : y;
  };

  link.context = function (_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
  };

  return link;
}

function linkHorizontal() {
  return link(_bump.bumpX);
}

function linkVertical() {
  return link(_bump.bumpY);
}

function linkRadial() {
  const l = link(_bump.bumpRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}

var symbol = {};

var asterisk = {};

Object.defineProperty(asterisk, "__esModule", {
  value: true
});
asterisk.default = void 0;

var _math$f = math$1;

const sqrt3$2 = (0, _math$f.sqrt)(3);
var _default$1q = {
  draw(context, size) {
    const r = (0, _math$f.sqrt)(size + (0, _math$f.min)(size / 28, 0.75)) * 0.59436;
    const t = r / 2;
    const u = t * sqrt3$2;
    context.moveTo(0, r);
    context.lineTo(0, -r);
    context.moveTo(-u, -t);
    context.lineTo(u, t);
    context.moveTo(-u, t);
    context.lineTo(u, -t);
  }

};
asterisk.default = _default$1q;

var circle = {};

Object.defineProperty(circle, "__esModule", {
  value: true
});
circle.default = void 0;

var _math$e = math$1;

var _default$1p = {
  draw(context, size) {
    const r = (0, _math$e.sqrt)(size / _math$e.pi);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, _math$e.tau);
  }

};
circle.default = _default$1p;

var cross$2 = {};

Object.defineProperty(cross$2, "__esModule", {
  value: true
});
cross$2.default = void 0;

var _math$d = math$1;

var _default$1o = {
  draw(context, size) {
    const r = (0, _math$d.sqrt)(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }

};
cross$2.default = _default$1o;

var diamond = {};

Object.defineProperty(diamond, "__esModule", {
  value: true
});
diamond.default = void 0;

var _math$c = math$1;

const tan30 = (0, _math$c.sqrt)(1 / 3);
const tan30_2 = tan30 * 2;
var _default$1n = {
  draw(context, size) {
    const y = (0, _math$c.sqrt)(size / tan30_2);
    const x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }

};
diamond.default = _default$1n;

var diamond2 = {};

Object.defineProperty(diamond2, "__esModule", {
  value: true
});
diamond2.default = void 0;

var _math$b = math$1;

var _default$1m = {
  draw(context, size) {
    const r = (0, _math$b.sqrt)(size) * 0.62625;
    context.moveTo(0, -r);
    context.lineTo(r, 0);
    context.lineTo(0, r);
    context.lineTo(-r, 0);
    context.closePath();
  }

};
diamond2.default = _default$1m;

var plus = {};

Object.defineProperty(plus, "__esModule", {
  value: true
});
plus.default = void 0;

var _math$a = math$1;

var _default$1l = {
  draw(context, size) {
    const r = (0, _math$a.sqrt)(size - (0, _math$a.min)(size / 7, 2)) * 0.87559;
    context.moveTo(-r, 0);
    context.lineTo(r, 0);
    context.moveTo(0, r);
    context.lineTo(0, -r);
  }

};
plus.default = _default$1l;

var square$1 = {};

Object.defineProperty(square$1, "__esModule", {
  value: true
});
square$1.default = void 0;

var _math$9 = math$1;

var _default$1k = {
  draw(context, size) {
    const w = (0, _math$9.sqrt)(size);
    const x = -w / 2;
    context.rect(x, x, w, w);
  }

};
square$1.default = _default$1k;

var square2 = {};

Object.defineProperty(square2, "__esModule", {
  value: true
});
square2.default = void 0;

var _math$8 = math$1;

var _default$1j = {
  draw(context, size) {
    const r = (0, _math$8.sqrt)(size) * 0.4431;
    context.moveTo(r, r);
    context.lineTo(r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, r);
    context.closePath();
  }

};
square2.default = _default$1j;

var star = {};

Object.defineProperty(star, "__esModule", {
  value: true
});
star.default = void 0;

var _math$7 = math$1;

const ka$1 = 0.89081309152928522810;
const kr = (0, _math$7.sin)(_math$7.pi / 10) / (0, _math$7.sin)(7 * _math$7.pi / 10);
const kx = (0, _math$7.sin)(_math$7.tau / 10) * kr;
const ky = -(0, _math$7.cos)(_math$7.tau / 10) * kr;
var _default$1i = {
  draw(context, size) {
    const r = (0, _math$7.sqrt)(size * ka$1);
    const x = kx * r;
    const y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);

    for (let i = 1; i < 5; ++i) {
      const a = _math$7.tau * i / 5;
      const c = (0, _math$7.cos)(a);
      const s = (0, _math$7.sin)(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }

    context.closePath();
  }

};
star.default = _default$1i;

var triangle = {};

Object.defineProperty(triangle, "__esModule", {
  value: true
});
triangle.default = void 0;

var _math$6 = math$1;

const sqrt3$1 = (0, _math$6.sqrt)(3);
var _default$1h = {
  draw(context, size) {
    const y = -(0, _math$6.sqrt)(size / (sqrt3$1 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3$1 * y, -y);
    context.lineTo(sqrt3$1 * y, -y);
    context.closePath();
  }

};
triangle.default = _default$1h;

var triangle2 = {};

Object.defineProperty(triangle2, "__esModule", {
  value: true
});
triangle2.default = void 0;

var _math$5 = math$1;

const sqrt3 = (0, _math$5.sqrt)(3);
var _default$1g = {
  draw(context, size) {
    const s = (0, _math$5.sqrt)(size) * 0.6824;
    const t = s / 2;
    const u = s * sqrt3 / 2; // cos(Math.PI / 6)

    context.moveTo(0, -s);
    context.lineTo(u, t);
    context.lineTo(-u, t);
    context.closePath();
  }

};
triangle2.default = _default$1g;

var wye = {};

Object.defineProperty(wye, "__esModule", {
  value: true
});
wye.default = void 0;

var _math$4 = math$1;

const c = -0.5;
const s = (0, _math$4.sqrt)(3) / 2;
const k = 1 / (0, _math$4.sqrt)(12);
const a = (k / 2 + 1) * 3;
var _default$1f = {
  draw(context, size) {
    const r = (0, _math$4.sqrt)(size / a);
    const x0 = r / 2,
          y0 = r * k;
    const x1 = x0,
          y1 = r * k + r;
    const x2 = -x1,
          y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }

};
wye.default = _default$1f;

var x = {};

Object.defineProperty(x, "__esModule", {
  value: true
});
x.default = void 0;

var _math$3 = math$1;

var _default$1e = {
  draw(context, size) {
    const r = (0, _math$3.sqrt)(size - (0, _math$3.min)(size / 6, 1.7)) * 0.6189;
    context.moveTo(-r, -r);
    context.lineTo(r, r);
    context.moveTo(-r, r);
    context.lineTo(r, -r);
  }

};
x.default = _default$1e;

Object.defineProperty(symbol, "__esModule", {
  value: true
});
symbol.default = Symbol$2;
symbol.symbolsStroke = symbol.symbolsFill = void 0;

var _index$a8 = src$8;

var _constant$5 = _interopRequireDefault$2f(constant$4);

var _asterisk = _interopRequireDefault$2f(asterisk);

var _circle = _interopRequireDefault$2f(circle);

var _cross = _interopRequireDefault$2f(cross$2);

var _diamond = _interopRequireDefault$2f(diamond);

var _diamond2 = _interopRequireDefault$2f(diamond2);

var _plus = _interopRequireDefault$2f(plus);

var _square = _interopRequireDefault$2f(square$1);

var _square2 = _interopRequireDefault$2f(square2);

var _star = _interopRequireDefault$2f(star);

var _triangle = _interopRequireDefault$2f(triangle);

var _triangle2 = _interopRequireDefault$2f(triangle2);

var _wye = _interopRequireDefault$2f(wye);

var _x = _interopRequireDefault$2f(x);

function _interopRequireDefault$2f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// These symbols are designed to be filled.
const symbolsFill = [_circle.default, _cross.default, _diamond.default, _square.default, _star.default, _triangle.default, _wye.default]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).

symbol.symbolsFill = symbolsFill;
const symbolsStroke = [_circle.default, _plus.default, _x.default, _triangle2.default, _asterisk.default, _square2.default, _diamond2.default];
symbol.symbolsStroke = symbolsStroke;

function Symbol$2(type, size) {
  let context = null;
  type = typeof type === "function" ? type : (0, _constant$5.default)(type || _circle.default);
  size = typeof size === "function" ? size : (0, _constant$5.default)(size === undefined ? 64 : +size);

  function symbol() {
    let buffer;
    if (!context) context = buffer = (0, _index$a8.path)();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function (_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constant$5.default)(_), symbol) : type;
  };

  symbol.size = function (_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constant$5.default)(+_), symbol) : size;
  };

  symbol.context = function (_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
}

var basisClosed$1 = {};

var noop$4 = {};

Object.defineProperty(noop$4, "__esModule", {
  value: true
});
noop$4.default = _default$1d;

function _default$1d() {}

var basis$2 = {};

Object.defineProperty(basis$2, "__esModule", {
  value: true
});
basis$2.Basis = Basis;
basis$2.default = _default$1c;
basis$2.point = point$4;

function point$4(that, x, y) {
  that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 3:
        point$4(this, this._x1, this._y1);
      // falls through

      case 2:
        this._context.lineTo(this._x1, this._y1);

        break;
    }

    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;

    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3;

        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);

      // falls through

      default:
        point$4(this, x, y);
        break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function _default$1c(context) {
  return new Basis(context);
}

Object.defineProperty(basisClosed$1, "__esModule", {
  value: true
});
basisClosed$1.default = _default$1b;

var _noop$3 = _interopRequireDefault$2e(noop$4);

var _basis$4 = basis$2;

function _interopRequireDefault$2e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: _noop$3.default,
  areaEnd: _noop$3.default,
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x2, this._y2);

          this._context.closePath();

          break;
        }

      case 2:
        {
          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);

          this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);

          this._context.closePath();

          break;
        }

      case 3:
        {
          this.point(this._x2, this._y2);
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          break;
        }
    }
  },
  point: function (x, y) {
    x = +x, y = +y;

    switch (this._point) {
      case 0:
        this._point = 1;
        this._x2 = x, this._y2 = y;
        break;

      case 1:
        this._point = 2;
        this._x3 = x, this._y3 = y;
        break;

      case 2:
        this._point = 3;
        this._x4 = x, this._y4 = y;

        this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);

        break;

      default:
        (0, _basis$4.point)(this, x, y);
        break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function _default$1b(context) {
  return new BasisClosed(context);
}

var basisOpen = {};

Object.defineProperty(basisOpen, "__esModule", {
  value: true
});
basisOpen.default = _default$1a;

var _basis$3 = basis$2;

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;

    switch (this._point) {
      case 0:
        this._point = 1;
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3;
        var x0 = (this._x0 + 4 * this._x1 + x) / 6,
            y0 = (this._y0 + 4 * this._y1 + y) / 6;
        this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
        break;

      case 3:
        this._point = 4;
      // falls through

      default:
        (0, _basis$3.point)(this, x, y);
        break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function _default$1a(context) {
  return new BasisOpen(context);
}

var bundle = {};

Object.defineProperty(bundle, "__esModule", {
  value: true
});
bundle.default = void 0;

var _basis$2 = basis$2;

function Bundle(context, beta) {
  this._basis = new _basis$2.Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function () {
    this._x = [];
    this._y = [];

    this._basis.lineStart();
  },
  lineEnd: function () {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;

        this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
      }
    }

    this._x = this._y = null;

    this._basis.lineEnd();
  },
  point: function (x, y) {
    this._x.push(+x);

    this._y.push(+y);
  }
};

var _default$19 = function custom(beta) {
  function bundle(context) {
    return beta === 1 ? new _basis$2.Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function (beta) {
    return custom(+beta);
  };

  return bundle;
}(0.85);

bundle.default = _default$19;

var cardinalClosed = {};

var cardinal = {};

Object.defineProperty(cardinal, "__esModule", {
  value: true
});
cardinal.Cardinal = Cardinal;
cardinal.default = void 0;
cardinal.point = point$3;

function point$3(that, x, y) {
  that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);

        break;

      case 3:
        point$3(this, this._x1, this._y1);
        break;
    }

    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;

    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;

      case 1:
        this._point = 2;
        this._x1 = x, this._y1 = y;
        break;

      case 2:
        this._point = 3;
      // falls through

      default:
        point$3(this, x, y);
        break;
    }

    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var _default$18 = function custom(tension) {
  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function (tension) {
    return custom(+tension);
  };

  return cardinal;
}(0);

cardinal.default = _default$18;

Object.defineProperty(cardinalClosed, "__esModule", {
  value: true
});
cardinalClosed.CardinalClosed = CardinalClosed;
cardinalClosed.default = void 0;

var _noop$2 = _interopRequireDefault$2d(noop$4);

var _cardinal$2 = cardinal;

function _interopRequireDefault$2d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: _noop$2.default,
  areaEnd: _noop$2.default,
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x3, this._y3);

          this._context.closePath();

          break;
        }

      case 2:
        {
          this._context.lineTo(this._x3, this._y3);

          this._context.closePath();

          break;
        }

      case 3:
        {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
    }
  },
  point: function (x, y) {
    x = +x, y = +y;

    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x, this._y3 = y;
        break;

      case 1:
        this._point = 2;

        this._context.moveTo(this._x4 = x, this._y4 = y);

        break;

      case 2:
        this._point = 3;
        this._x5 = x, this._y5 = y;
        break;

      default:
        (0, _cardinal$2.point)(this, x, y);
        break;
    }

    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var _default$17 = function custom(tension) {
  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function (tension) {
    return custom(+tension);
  };

  return cardinal;
}(0);

cardinalClosed.default = _default$17;

var cardinalOpen = {};

Object.defineProperty(cardinalOpen, "__esModule", {
  value: true
});
cardinalOpen.CardinalOpen = CardinalOpen;
cardinalOpen.default = void 0;

var _cardinal$1 = cardinal;

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;

    switch (this._point) {
      case 0:
        this._point = 1;
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;

      case 3:
        this._point = 4;
      // falls through

      default:
        (0, _cardinal$1.point)(this, x, y);
        break;
    }

    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var _default$16 = function custom(tension) {
  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function (tension) {
    return custom(+tension);
  };

  return cardinal;
}(0);

cardinalOpen.default = _default$16;

var catmullRomClosed = {};

var catmullRom = {};

Object.defineProperty(catmullRom, "__esModule", {
  value: true
});
catmullRom.default = void 0;
catmullRom.point = point$2;

var _math$2 = math$1;

var _cardinal = cardinal;

function point$2(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > _math$2.epsilon) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > _math$2.epsilon) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);

        break;

      case 3:
        this.point(this._x2, this._y2);
        break;
    }

    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3;
      // falls through

      default:
        point$2(this, x, y);
        break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var _default$15 = function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new _cardinal.Cardinal(context, 0);
  }

  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}(0.5);

catmullRom.default = _default$15;

Object.defineProperty(catmullRomClosed, "__esModule", {
  value: true
});
catmullRomClosed.default = void 0;

var _cardinalClosed = cardinalClosed;

var _noop$1 = _interopRequireDefault$2c(noop$4);

var _catmullRom$1 = catmullRom;

function _interopRequireDefault$2c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: _noop$1.default,
  areaEnd: _noop$1.default,
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 1:
        {
          this._context.moveTo(this._x3, this._y3);

          this._context.closePath();

          break;
        }

      case 2:
        {
          this._context.lineTo(this._x3, this._y3);

          this._context.closePath();

          break;
        }

      case 3:
        {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
    }
  },
  point: function (x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x, this._y3 = y;
        break;

      case 1:
        this._point = 2;

        this._context.moveTo(this._x4 = x, this._y4 = y);

        break;

      case 2:
        this._point = 3;
        this._x5 = x, this._y5 = y;
        break;

      default:
        (0, _catmullRom$1.point)(this, x, y);
        break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var _default$14 = function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new _cardinalClosed.CardinalClosed(context, 0);
  }

  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}(0.5);

catmullRomClosed.default = _default$14;

var catmullRomOpen = {};

Object.defineProperty(catmullRomOpen, "__esModule", {
  value: true
});
catmullRomOpen.default = void 0;

var _cardinalOpen = cardinalOpen;

var _catmullRom = catmullRom;

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function () {
    if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0:
        this._point = 1;
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;

      case 3:
        this._point = 4;
      // falls through

      default:
        (0, _catmullRom.point)(this, x, y);
        break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var _default$13 = function custom(alpha) {
  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new _cardinalOpen.CardinalOpen(context, 0);
  }

  catmullRom.alpha = function (alpha) {
    return custom(+alpha);
  };

  return catmullRom;
}(0.5);

catmullRomOpen.default = _default$13;

var linearClosed = {};

Object.defineProperty(linearClosed, "__esModule", {
  value: true
});
linearClosed.default = _default$12;

var _noop = _interopRequireDefault$2b(noop$4);

function _interopRequireDefault$2b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: _noop.default,
  areaEnd: _noop.default,
  lineStart: function () {
    this._point = 0;
  },
  lineEnd: function () {
    if (this._point) this._context.closePath();
  },
  point: function (x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);else this._point = 1, this._context.moveTo(x, y);
  }
};

function _default$12(context) {
  return new LinearClosed(context);
}

var monotone = {};

Object.defineProperty(monotone, "__esModule", {
  value: true
});
monotone.monotoneX = monotoneX;
monotone.monotoneY = monotoneY;

function sign(x) {
  return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.


function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.


function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".


function point$1(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;

  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);

        break;

      case 3:
        point$1(this, this._t0, slope2(this, this._t0));
        break;
    }

    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function (x, y) {
    var t1 = NaN;
    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.

    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;

      case 1:
        this._point = 2;
        break;

      case 2:
        this._point = 3;
        point$1(this, slope2(this, t1 = slope3(this, x, y)), t1);
        break;

      default:
        point$1(this, this._t0, t1 = slope3(this, x, y));
        break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function (x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function (x, y) {
    this._context.moveTo(y, x);
  },
  closePath: function () {
    this._context.closePath();
  },
  lineTo: function (x, y) {
    this._context.lineTo(y, x);
  },
  bezierCurveTo: function (x1, y1, x2, y2, x, y) {
    this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
  }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

var natural = {};

Object.defineProperty(natural, "__esModule", {
  value: true
});
natural.default = _default$11;

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x = [];
    this._y = [];
  },
  lineEnd: function () {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);

      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);

        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || this._line !== 0 && n === 1) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function (x, y) {
    this._x.push(+x);

    this._y.push(+y);
  }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.

function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];

  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];

  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];

  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];

  a[n - 1] = r[n - 1] / b[n - 1];

  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];

  b[n - 1] = (x[n] + a[n - 1]) / 2;

  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];

  return [a, b];
}

function _default$11(context) {
  return new Natural(context);
}

var step = {};

Object.defineProperty(step, "__esModule", {
  value: true
});
step.default = _default$10;
step.stepAfter = stepAfter;
step.stepBefore = stepBefore;

function Step$1(context, t) {
  this._context = context;
  this._t = t;
}

Step$1.prototype = {
  areaStart: function () {
    this._line = 0;
  },
  areaEnd: function () {
    this._line = NaN;
  },
  lineStart: function () {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function () {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function (x, y) {
    x = +x, y = +y;

    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
        break;

      case 1:
        this._point = 2;
      // falls through

      default:
        {
          if (this._t <= 0) {
            this._context.lineTo(this._x, y);

            this._context.lineTo(x, y);
          } else {
            var x1 = this._x * (1 - this._t) + x * this._t;

            this._context.lineTo(x1, this._y);

            this._context.lineTo(x1, y);
          }

          break;
        }
    }

    this._x = x, this._y = y;
  }
};

function _default$10(context) {
  return new Step$1(context, 0.5);
}

function stepBefore(context) {
  return new Step$1(context, 0);
}

function stepAfter(context) {
  return new Step$1(context, 1);
}

var stack = {};

var none$1 = {};

Object.defineProperty(none$1, "__esModule", {
  value: true
});
none$1.default = _default$$;

function _default$$(series, order) {
  if (!((n = series.length) > 1)) return;

  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];

    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

var none = {};

Object.defineProperty(none, "__esModule", {
  value: true
});
none.default = _default$_;

function _default$_(series) {
  var n = series.length,
      o = new Array(n);

  while (--n >= 0) o[n] = n;

  return o;
}

Object.defineProperty(stack, "__esModule", {
  value: true
});
stack.default = _default$Z;

var _array$2 = _interopRequireDefault$2a(array$3);

var _constant$4 = _interopRequireDefault$2a(constant$4);

var _none$6 = _interopRequireDefault$2a(none$1);

var _none2 = _interopRequireDefault$2a(none);

function _interopRequireDefault$2a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stackValue(d, key) {
  return d[key];
}

function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}

function _default$Z() {
  var keys = (0, _constant$4.default)([]),
      order = _none2.default,
      offset = _none$6.default,
      value = stackValue;

  function stack(data) {
    var sz = Array.from(keys.apply(this, arguments), stackSeries),
        i,
        n = sz.length,
        j = -1,
        oz;

    for (const d of data) {
      for (i = 0, ++j; i < n; ++i) {
        (sz[i][j] = [0, +value(d, sz[i].key, j, data)]).data = d;
      }
    }

    for (i = 0, oz = (0, _array$2.default)(order(sz)); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function (_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constant$4.default)(Array.from(_)), stack) : keys;
  };

  stack.value = function (_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant$4.default)(+_), stack) : value;
  };

  stack.order = function (_) {
    return arguments.length ? (order = _ == null ? _none2.default : typeof _ === "function" ? _ : (0, _constant$4.default)(Array.from(_)), stack) : order;
  };

  stack.offset = function (_) {
    return arguments.length ? (offset = _ == null ? _none$6.default : _, stack) : offset;
  };

  return stack;
}

var expand$1 = {};

Object.defineProperty(expand$1, "__esModule", {
  value: true
});
expand$1.default = _default$Y;

var _none$5 = _interopRequireDefault$29(none$1);

function _interopRequireDefault$29(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$Y(series, order) {
  if (!((n = series.length) > 0)) return;

  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;

    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }

  (0, _none$5.default)(series, order);
}

var diverging$2 = {};

Object.defineProperty(diverging$2, "__esModule", {
  value: true
});
diverging$2.default = _default$X;

function _default$X(series, order) {
  if (!((n = series.length) > 0)) return;

  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = 0, d[1] = dy;
      }
    }
  }
}

var silhouette = {};

Object.defineProperty(silhouette, "__esModule", {
  value: true
});
silhouette.default = _default$W;

var _none$4 = _interopRequireDefault$28(none$1);

function _interopRequireDefault$28(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$W(series, order) {
  if (!((n = series.length) > 0)) return;

  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;

    s0[j][1] += s0[j][0] = -y / 2;
  }

  (0, _none$4.default)(series, order);
}

var wiggle = {};

Object.defineProperty(wiggle, "__esModule", {
  value: true
});
wiggle.default = _default$V;

var _none$3 = _interopRequireDefault$27(none$1);

function _interopRequireDefault$27(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$V(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;

  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;

      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }

      s1 += sij0, s2 += s3 * sij0;
    }

    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }

  s0[j - 1][1] += s0[j - 1][0] = y;
  (0, _none$3.default)(series, order);
}

var appearance = {};

Object.defineProperty(appearance, "__esModule", {
  value: true
});
appearance.default = _default$U;

var _none$2 = _interopRequireDefault$26(none);

function _interopRequireDefault$26(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$U(series) {
  var peaks = series.map(peak);
  return (0, _none$2.default)(series).sort(function (a, b) {
    return peaks[a] - peaks[b];
  });
}

function peak(series) {
  var i = -1,
      j = 0,
      n = series.length,
      vi,
      vj = -Infinity;

  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;

  return j;
}

var ascending$2 = {};

Object.defineProperty(ascending$2, "__esModule", {
  value: true
});
ascending$2.default = _default$T;
ascending$2.sum = sum$2;

var _none$1 = _interopRequireDefault$25(none);

function _interopRequireDefault$25(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$T(series) {
  var sums = series.map(sum$2);
  return (0, _none$1.default)(series).sort(function (a, b) {
    return sums[a] - sums[b];
  });
}

function sum$2(series) {
  var s = 0,
      i = -1,
      n = series.length,
      v;

  while (++i < n) if (v = +series[i][1]) s += v;

  return s;
}

var descending$2 = {};

Object.defineProperty(descending$2, "__esModule", {
  value: true
});
descending$2.default = _default$S;

var _ascending$a = _interopRequireDefault$24(ascending$2);

function _interopRequireDefault$24(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$S(series) {
  return (0, _ascending$a.default)(series).reverse();
}

var insideOut = {};

Object.defineProperty(insideOut, "__esModule", {
  value: true
});
insideOut.default = _default$R;

var _appearance = _interopRequireDefault$23(appearance);

var _ascending$9 = ascending$2;

function _interopRequireDefault$23(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$R(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(_ascending$9.sum),
      order = (0, _appearance.default)(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];

    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
}

var reverse$5 = {};

Object.defineProperty(reverse$5, "__esModule", {
  value: true
});
reverse$5.default = _default$Q;

var _none = _interopRequireDefault$22(none);

function _interopRequireDefault$22(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$Q(series) {
  return (0, _none.default)(series).reverse();
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "arc", {
  enumerable: true,
  get: function () {
    return _arc.default;
  }
});
Object.defineProperty(exports, "area", {
  enumerable: true,
  get: function () {
    return _area.default;
  }
});
Object.defineProperty(exports, "areaRadial", {
  enumerable: true,
  get: function () {
    return _areaRadial.default;
  }
});
Object.defineProperty(exports, "curveBasis", {
  enumerable: true,
  get: function () {
    return _basis.default;
  }
});
Object.defineProperty(exports, "curveBasisClosed", {
  enumerable: true,
  get: function () {
    return _basisClosed.default;
  }
});
Object.defineProperty(exports, "curveBasisOpen", {
  enumerable: true,
  get: function () {
    return _basisOpen.default;
  }
});
Object.defineProperty(exports, "curveBumpX", {
  enumerable: true,
  get: function () {
    return _bump.bumpX;
  }
});
Object.defineProperty(exports, "curveBumpY", {
  enumerable: true,
  get: function () {
    return _bump.bumpY;
  }
});
Object.defineProperty(exports, "curveBundle", {
  enumerable: true,
  get: function () {
    return _bundle.default;
  }
});
Object.defineProperty(exports, "curveCardinal", {
  enumerable: true,
  get: function () {
    return _cardinal.default;
  }
});
Object.defineProperty(exports, "curveCardinalClosed", {
  enumerable: true,
  get: function () {
    return _cardinalClosed.default;
  }
});
Object.defineProperty(exports, "curveCardinalOpen", {
  enumerable: true,
  get: function () {
    return _cardinalOpen.default;
  }
});
Object.defineProperty(exports, "curveCatmullRom", {
  enumerable: true,
  get: function () {
    return _catmullRom.default;
  }
});
Object.defineProperty(exports, "curveCatmullRomClosed", {
  enumerable: true,
  get: function () {
    return _catmullRomClosed.default;
  }
});
Object.defineProperty(exports, "curveCatmullRomOpen", {
  enumerable: true,
  get: function () {
    return _catmullRomOpen.default;
  }
});
Object.defineProperty(exports, "curveLinear", {
  enumerable: true,
  get: function () {
    return _linear.default;
  }
});
Object.defineProperty(exports, "curveLinearClosed", {
  enumerable: true,
  get: function () {
    return _linearClosed.default;
  }
});
Object.defineProperty(exports, "curveMonotoneX", {
  enumerable: true,
  get: function () {
    return _monotone.monotoneX;
  }
});
Object.defineProperty(exports, "curveMonotoneY", {
  enumerable: true,
  get: function () {
    return _monotone.monotoneY;
  }
});
Object.defineProperty(exports, "curveNatural", {
  enumerable: true,
  get: function () {
    return _natural.default;
  }
});
Object.defineProperty(exports, "curveStep", {
  enumerable: true,
  get: function () {
    return _step.default;
  }
});
Object.defineProperty(exports, "curveStepAfter", {
  enumerable: true,
  get: function () {
    return _step.stepAfter;
  }
});
Object.defineProperty(exports, "curveStepBefore", {
  enumerable: true,
  get: function () {
    return _step.stepBefore;
  }
});
Object.defineProperty(exports, "line", {
  enumerable: true,
  get: function () {
    return _line.default;
  }
});
Object.defineProperty(exports, "lineRadial", {
  enumerable: true,
  get: function () {
    return _lineRadial.default;
  }
});
Object.defineProperty(exports, "link", {
  enumerable: true,
  get: function () {
    return _link.link;
  }
});
Object.defineProperty(exports, "linkHorizontal", {
  enumerable: true,
  get: function () {
    return _link.linkHorizontal;
  }
});
Object.defineProperty(exports, "linkRadial", {
  enumerable: true,
  get: function () {
    return _link.linkRadial;
  }
});
Object.defineProperty(exports, "linkVertical", {
  enumerable: true,
  get: function () {
    return _link.linkVertical;
  }
});
Object.defineProperty(exports, "pie", {
  enumerable: true,
  get: function () {
    return _pie.default;
  }
});
Object.defineProperty(exports, "pointRadial", {
  enumerable: true,
  get: function () {
    return _pointRadial.default;
  }
});
Object.defineProperty(exports, "radialArea", {
  enumerable: true,
  get: function () {
    return _areaRadial.default;
  }
});
Object.defineProperty(exports, "radialLine", {
  enumerable: true,
  get: function () {
    return _lineRadial.default;
  }
});
Object.defineProperty(exports, "stack", {
  enumerable: true,
  get: function () {
    return _stack.default;
  }
});
Object.defineProperty(exports, "stackOffsetDiverging", {
  enumerable: true,
  get: function () {
    return _diverging.default;
  }
});
Object.defineProperty(exports, "stackOffsetExpand", {
  enumerable: true,
  get: function () {
    return _expand.default;
  }
});
Object.defineProperty(exports, "stackOffsetNone", {
  enumerable: true,
  get: function () {
    return _none.default;
  }
});
Object.defineProperty(exports, "stackOffsetSilhouette", {
  enumerable: true,
  get: function () {
    return _silhouette.default;
  }
});
Object.defineProperty(exports, "stackOffsetWiggle", {
  enumerable: true,
  get: function () {
    return _wiggle.default;
  }
});
Object.defineProperty(exports, "stackOrderAppearance", {
  enumerable: true,
  get: function () {
    return _appearance.default;
  }
});
Object.defineProperty(exports, "stackOrderAscending", {
  enumerable: true,
  get: function () {
    return _ascending.default;
  }
});
Object.defineProperty(exports, "stackOrderDescending", {
  enumerable: true,
  get: function () {
    return _descending.default;
  }
});
Object.defineProperty(exports, "stackOrderInsideOut", {
  enumerable: true,
  get: function () {
    return _insideOut.default;
  }
});
Object.defineProperty(exports, "stackOrderNone", {
  enumerable: true,
  get: function () {
    return _none2.default;
  }
});
Object.defineProperty(exports, "stackOrderReverse", {
  enumerable: true,
  get: function () {
    return _reverse.default;
  }
});
Object.defineProperty(exports, "symbol", {
  enumerable: true,
  get: function () {
    return _symbol.default;
  }
});
Object.defineProperty(exports, "symbolAsterisk", {
  enumerable: true,
  get: function () {
    return _asterisk.default;
  }
});
Object.defineProperty(exports, "symbolCircle", {
  enumerable: true,
  get: function () {
    return _circle.default;
  }
});
Object.defineProperty(exports, "symbolCross", {
  enumerable: true,
  get: function () {
    return _cross.default;
  }
});
Object.defineProperty(exports, "symbolDiamond", {
  enumerable: true,
  get: function () {
    return _diamond.default;
  }
});
Object.defineProperty(exports, "symbolDiamond2", {
  enumerable: true,
  get: function () {
    return _diamond2.default;
  }
});
Object.defineProperty(exports, "symbolPlus", {
  enumerable: true,
  get: function () {
    return _plus.default;
  }
});
Object.defineProperty(exports, "symbolSquare", {
  enumerable: true,
  get: function () {
    return _square.default;
  }
});
Object.defineProperty(exports, "symbolSquare2", {
  enumerable: true,
  get: function () {
    return _square2.default;
  }
});
Object.defineProperty(exports, "symbolStar", {
  enumerable: true,
  get: function () {
    return _star.default;
  }
});
Object.defineProperty(exports, "symbolTriangle", {
  enumerable: true,
  get: function () {
    return _triangle.default;
  }
});
Object.defineProperty(exports, "symbolTriangle2", {
  enumerable: true,
  get: function () {
    return _triangle2.default;
  }
});
Object.defineProperty(exports, "symbolWye", {
  enumerable: true,
  get: function () {
    return _wye.default;
  }
});
Object.defineProperty(exports, "symbolX", {
  enumerable: true,
  get: function () {
    return _x.default;
  }
});
Object.defineProperty(exports, "symbols", {
  enumerable: true,
  get: function () {
    return _symbol.symbolsFill;
  }
});
Object.defineProperty(exports, "symbolsFill", {
  enumerable: true,
  get: function () {
    return _symbol.symbolsFill;
  }
});
Object.defineProperty(exports, "symbolsStroke", {
  enumerable: true,
  get: function () {
    return _symbol.symbolsStroke;
  }
});

var _arc = _interopRequireDefault(arc);

var _area = _interopRequireDefault(area);

var _line = _interopRequireDefault(line);

var _pie = _interopRequireDefault(pie);

var _areaRadial = _interopRequireDefault(areaRadial);

var _lineRadial = _interopRequireDefault(lineRadial$1);

var _pointRadial = _interopRequireDefault(pointRadial);

var _link = link$1;

var _symbol = _interopRequireWildcard(symbol);

var _asterisk = _interopRequireDefault(asterisk);

var _circle = _interopRequireDefault(circle);

var _cross = _interopRequireDefault(cross$2);

var _diamond = _interopRequireDefault(diamond);

var _diamond2 = _interopRequireDefault(diamond2);

var _plus = _interopRequireDefault(plus);

var _square = _interopRequireDefault(square$1);

var _square2 = _interopRequireDefault(square2);

var _star = _interopRequireDefault(star);

var _triangle = _interopRequireDefault(triangle);

var _triangle2 = _interopRequireDefault(triangle2);

var _wye = _interopRequireDefault(wye);

var _x = _interopRequireDefault(x);

var _basisClosed = _interopRequireDefault(basisClosed$1);

var _basisOpen = _interopRequireDefault(basisOpen);

var _basis = _interopRequireDefault(basis$2);

var _bump = bump;

var _bundle = _interopRequireDefault(bundle);

var _cardinalClosed = _interopRequireDefault(cardinalClosed);

var _cardinalOpen = _interopRequireDefault(cardinalOpen);

var _cardinal = _interopRequireDefault(cardinal);

var _catmullRomClosed = _interopRequireDefault(catmullRomClosed);

var _catmullRomOpen = _interopRequireDefault(catmullRomOpen);

var _catmullRom = _interopRequireDefault(catmullRom);

var _linearClosed = _interopRequireDefault(linearClosed);

var _linear = _interopRequireDefault(linear$3);

var _monotone = monotone;

var _natural = _interopRequireDefault(natural);

var _step = _interopRequireWildcard(step);

var _stack = _interopRequireDefault(stack);

var _expand = _interopRequireDefault(expand$1);

var _diverging = _interopRequireDefault(diverging$2);

var _none = _interopRequireDefault(none$1);

var _silhouette = _interopRequireDefault(silhouette);

var _wiggle = _interopRequireDefault(wiggle);

var _appearance = _interopRequireDefault(appearance);

var _ascending = _interopRequireDefault(ascending$2);

var _descending = _interopRequireDefault(descending$2);

var _insideOut = _interopRequireDefault(insideOut);

var _none2 = _interopRequireDefault(none);

var _reverse = _interopRequireDefault(reverse$5);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
}(src$9));

// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`
var d3Shape = src$9;

function _typeof$10(o) { "@babel/helpers - typeof"; return _typeof$10 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$10(o); }
Object.defineProperty(Symbols$1, "__esModule", {
  value: true
});
Symbols$1.Symbols = void 0;
var _react$Y = _interopRequireDefault$21(React__default$4);
var _upperFirst$1 = _interopRequireDefault$21(upperFirst_1);
var _d3Shape$1 = d3Shape;
var _clsx$y = _interopRequireDefault$21(clsx.exports);
var _ReactUtils$B = ReactUtils;
var _excluded$q = ["type", "size", "sizeType"];
/**
 * @fileOverview Curve
 */
function _interopRequireDefault$21(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
function ownKeys$U(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$S(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$U(Object(t), !0).forEach(function (r) { _defineProperty$$(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$U(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$$(obj, key, value) { key = _toPropertyKey$U(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$U(t) { var i = _toPrimitive$U(t, "string"); return "symbol" == _typeof$10(i) ? i : i + ""; }
function _toPrimitive$U(t, r) { if ("object" != _typeof$10(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$10(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties$t(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$q(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$q(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var symbolFactories = {
  symbolCircle: _d3Shape$1.symbolCircle,
  symbolCross: _d3Shape$1.symbolCross,
  symbolDiamond: _d3Shape$1.symbolDiamond,
  symbolSquare: _d3Shape$1.symbolSquare,
  symbolStar: _d3Shape$1.symbolStar,
  symbolTriangle: _d3Shape$1.symbolTriangle,
  symbolWye: _d3Shape$1.symbolWye
};
var RADIAN$2 = Math.PI / 180;
var getSymbolFactory = function getSymbolFactory(type) {
  var name = "symbol".concat((0, _upperFirst$1["default"])(type));
  return symbolFactories[name] || _d3Shape$1.symbolCircle;
};
var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
  if (sizeType === 'area') {
    return size;
  }
  switch (type) {
    case 'cross':
      return 5 * size * size / 9;
    case 'diamond':
      return 0.5 * size * size / Math.sqrt(3);
    case 'square':
      return size * size;
    case 'star':
      {
        var angle = 18 * RADIAN$2;
        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
      }
    case 'triangle':
      return Math.sqrt(3) * size * size / 4;
    case 'wye':
      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
    default:
      return Math.PI * size * size / 4;
  }
};
var registerSymbol = function registerSymbol(key, factory) {
  symbolFactories["symbol".concat((0, _upperFirst$1["default"])(key))] = factory;
};
var Symbols = Symbols$1.Symbols = function Symbols(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'circle' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 64 : _ref$size,
    _ref$sizeType = _ref.sizeType,
    sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType,
    rest = _objectWithoutProperties$t(_ref, _excluded$q);
  var props = _objectSpread$S(_objectSpread$S({}, rest), {}, {
    type: type,
    size: size,
    sizeType: sizeType
  });

  /**
   * Calculate the path of curve
   * @return {String} path
   */
  var getPath = function getPath() {
    var symbolFactory = getSymbolFactory(type);
    var symbol = (0, _d3Shape$1.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
    return symbol();
  };
  var className = props.className,
    cx = props.cx,
    cy = props.cy;
  var filteredProps = (0, _ReactUtils$B.filterProps)(props, true);
  if (cx === +cx && cy === +cy && size === +size) {
    return /*#__PURE__*/_react$Y["default"].createElement("path", _extends$L({}, filteredProps, {
      className: (0, _clsx$y["default"])('recharts-symbols', className),
      transform: "translate(".concat(cx, ", ").concat(cy, ")"),
      d: getPath()
    }));
  }
  return null;
};
Symbols.registerSymbol = registerSymbol;

Object.defineProperty(DefaultLegendContent$1, "__esModule", {
  value: true
});
DefaultLegendContent$1.DefaultLegendContent = void 0;
var _react$X = _interopRequireWildcard$K(React__default$4);
var _isFunction$q = _interopRequireDefault$20(isFunction_1);
var _clsx2$1 = _interopRequireDefault$20(clsx.exports);
var _LogUtils$7 = LogUtils;
var _Surface$4 = Surface$1;
var _Symbols$2 = Symbols$1;
var _types$b = types;
function _interopRequireDefault$20(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$K(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$K = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$K(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$$(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$K(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$$(o) { "@babel/helpers - typeof"; return _typeof$$ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$$(o); }
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
function ownKeys$T(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$R(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$T(Object(t), !0).forEach(function (r) { _defineProperty$_(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$T(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$J(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$D(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$T(descriptor.key), descriptor); } }
function _createClass$J(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$D(Constructor.prototype, protoProps); if (staticProps) _defineProperties$D(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$p(t, o, e) { return o = _getPrototypeOf$s(o), _possibleConstructorReturn$y(t, _isNativeReflectConstruct$s() ? Reflect.construct(o, e || [], _getPrototypeOf$s(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$y(self, call) { if (call && (_typeof$$(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$s(self); }
function _assertThisInitialized$s(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$s() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$s = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$s(o) { _getPrototypeOf$s = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$s(o); }
function _inherits$y(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$s(subClass, superClass); }
function _setPrototypeOf$s(o, p) { _setPrototypeOf$s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$s(o, p); }
function _defineProperty$_(obj, key, value) { key = _toPropertyKey$T(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$T(t) { var i = _toPrimitive$T(t, "string"); return "symbol" == _typeof$$(i) ? i : i + ""; }
function _toPrimitive$T(t, r) { if ("object" != _typeof$$(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$$(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Default Legend Content
 */
var SIZE = 32;
var DefaultLegendContent = DefaultLegendContent$1.DefaultLegendContent = /*#__PURE__*/function (_PureComponent) {
  function DefaultLegendContent() {
    _classCallCheck$J(this, DefaultLegendContent);
    return _callSuper$p(this, DefaultLegendContent, arguments);
  }
  _inherits$y(DefaultLegendContent, _PureComponent);
  return _createClass$J(DefaultLegendContent, [{
    key: "renderIcon",
    value:
    /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */
    function renderIcon(data) {
      var inactiveColor = this.props.inactiveColor;
      var halfSize = SIZE / 2;
      var sixthSize = SIZE / 6;
      var thirdSize = SIZE / 3;
      var color = data.inactive ? inactiveColor : data.color;
      if (data.type === 'plainline') {
        return /*#__PURE__*/_react$X["default"].createElement("line", {
          strokeWidth: 4,
          fill: "none",
          stroke: color,
          strokeDasharray: data.payload.strokeDasharray,
          x1: 0,
          y1: halfSize,
          x2: SIZE,
          y2: halfSize,
          className: "recharts-legend-icon"
        });
      }
      if (data.type === 'line') {
        return /*#__PURE__*/_react$X["default"].createElement("path", {
          strokeWidth: 4,
          fill: "none",
          stroke: color,
          d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
          className: "recharts-legend-icon"
        });
      }
      if (data.type === 'rect') {
        return /*#__PURE__*/_react$X["default"].createElement("path", {
          stroke: "none",
          fill: color,
          d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
          className: "recharts-legend-icon"
        });
      }
      if ( /*#__PURE__*/_react$X["default"].isValidElement(data.legendIcon)) {
        var iconProps = _objectSpread$R({}, data);
        delete iconProps.legendIcon;
        return /*#__PURE__*/_react$X["default"].cloneElement(data.legendIcon, iconProps);
      }
      return /*#__PURE__*/_react$X["default"].createElement(_Symbols$2.Symbols, {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: SIZE,
        sizeType: "diameter",
        type: data.type
      });
    }

    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;
      var _this$props = this.props,
        payload = _this$props.payload,
        iconSize = _this$props.iconSize,
        layout = _this$props.layout,
        formatter = _this$props.formatter,
        inactiveColor = _this$props.inactiveColor;
      var viewBox = {
        x: 0,
        y: 0,
        width: SIZE,
        height: SIZE
      };
      var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
      };
      var svgStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 4
      };
      return payload.map(function (entry, i) {
        var finalFormatter = entry.formatter || formatter;
        var className = (0, _clsx2$1["default"])(_defineProperty$_(_defineProperty$_({
          'recharts-legend-item': true
        }, "legend-item-".concat(i), true), "inactive", entry.inactive));
        if (entry.type === 'none') {
          return null;
        }

        // Do not render entry.value as functions. Always require static string properties.
        var entryValue = !(0, _isFunction$q["default"])(entry.value) ? entry.value : null;
        (0, _LogUtils$7.warn)(!(0, _isFunction$q["default"])(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
        );
        var color = entry.inactive ? inactiveColor : entry.color;
        return /*#__PURE__*/_react$X["default"].createElement("li", _extends$K({
          className: className,
          style: itemStyle
          // eslint-disable-next-line react/no-array-index-key
          ,
          key: "legend-item-".concat(i)
        }, (0, _types$b.adaptEventsOfChild)(_this.props, entry, i)), /*#__PURE__*/_react$X["default"].createElement(_Surface$4.Surface, {
          width: iconSize,
          height: iconSize,
          viewBox: viewBox,
          style: svgStyle
        }, _this.renderIcon(entry)), /*#__PURE__*/_react$X["default"].createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: color
          }
        }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        payload = _this$props2.payload,
        layout = _this$props2.layout,
        align = _this$props2.align;
      if (!payload || !payload.length) {
        return null;
      }
      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
      };
      return /*#__PURE__*/_react$X["default"].createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
      }, this.renderItems());
    }
  }]);
}(_react$X.PureComponent);
_defineProperty$_(DefaultLegendContent, "displayName", 'Legend');
_defineProperty$_(DefaultLegendContent, "defaultProps", {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'middle',
  inactiveColor: '#ccc'
});

var getUniqPayload$1 = {};

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$2(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$2;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex$1 = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex$1(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$1;

var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$1;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith$1(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith$1;

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */

function noop$3() {
  // No operation performed.
}

var noop_1 = noop$3;

var Set$1 = _Set,
    noop$2 = noop_1,
    setToArray$1 = _setToArray;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet$1 = !(Set$1 && (1 / setToArray$1(new Set$1([,-0]))[1]) == INFINITY$1) ? noop$2 : function(values) {
  return new Set$1(values);
};

var _createSet = createSet$1;

var SetCache = _SetCache,
    arrayIncludes = _arrayIncludes,
    arrayIncludesWith = _arrayIncludesWith,
    cacheHas = _cacheHas,
    createSet = _createSet,
    setToArray = _setToArray;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq$1(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseUniq = baseUniq$1;

var baseIteratee$9 = _baseIteratee,
    baseUniq = _baseUniq;

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee$9(iteratee)) : [];
}

var uniqBy_1 = uniqBy;

Object.defineProperty(getUniqPayload$1, "__esModule", {
  value: true
});
getUniqPayload$1.getUniqPayload = getUniqPayload;
var _uniqBy = _interopRequireDefault$1$(uniqBy_1);
var _isFunction$p = _interopRequireDefault$1$(isFunction_1);
function _interopRequireDefault$1$(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * This is configuration option that decides how to filter for unique values only:
 *
 * - `false` means "no filter"
 * - `true` means "use recharts default filter"
 * - function means "use return of this function as the default key"
 */

function getUniqPayload(payload, option, defaultUniqBy) {
  if (option === true) {
    return (0, _uniqBy["default"])(payload, defaultUniqBy);
  }
  if ((0, _isFunction$p["default"])(option)) {
    return (0, _uniqBy["default"])(payload, option);
  }
  return payload;
}

function _typeof$_(o) { "@babel/helpers - typeof"; return _typeof$_ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$_(o); }
Object.defineProperty(Legend$1, "__esModule", {
  value: true
});
Legend$1.Legend = void 0;
var _react$W = _interopRequireWildcard$J(React__default$4);
var _DefaultLegendContent = DefaultLegendContent$1;
var _DataUtils$u = DataUtils;
var _getUniqPayload$1 = getUniqPayload$1;
var _excluded$p = ["ref"];
/**
 * @fileOverview Legend
 */
function _getRequireWildcardCache$J(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$J = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$J(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$_(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$J(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys$S(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$Q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$S(Object(t), !0).forEach(function (r) { _defineProperty$Z(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$S(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$I(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$C(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$S(descriptor.key), descriptor); } }
function _createClass$I(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$C(Constructor.prototype, protoProps); if (staticProps) _defineProperties$C(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$o(t, o, e) { return o = _getPrototypeOf$r(o), _possibleConstructorReturn$x(t, _isNativeReflectConstruct$r() ? Reflect.construct(o, e || [], _getPrototypeOf$r(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$x(self, call) { if (call && (_typeof$_(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$r(self); }
function _assertThisInitialized$r(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$r() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$r = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$r(o) { _getPrototypeOf$r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$r(o); }
function _inherits$x(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$r(subClass, superClass); }
function _setPrototypeOf$r(o, p) { _setPrototypeOf$r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$r(o, p); }
function _defineProperty$Z(obj, key, value) { key = _toPropertyKey$S(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$S(t) { var i = _toPrimitive$S(t, "string"); return "symbol" == _typeof$_(i) ? i : i + ""; }
function _toPrimitive$S(t, r) { if ("object" != _typeof$_(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$_(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties$s(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$p(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$p(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function defaultUniqBy$1(entry) {
  return entry.value;
}
function renderContent$1(content, props) {
  if ( /*#__PURE__*/_react$W["default"].isValidElement(content)) {
    return /*#__PURE__*/_react$W["default"].cloneElement(content, props);
  }
  if (typeof content === 'function') {
    return /*#__PURE__*/_react$W["default"].createElement(content, props);
  }
  props.ref;
    var otherProps = _objectWithoutProperties$s(props, _excluded$p);
  return /*#__PURE__*/_react$W["default"].createElement(_DefaultLegendContent.DefaultLegendContent, otherProps);
}
var EPS = 1;
var Legend = Legend$1.Legend = /*#__PURE__*/function (_PureComponent) {
  function Legend() {
    var _this;
    _classCallCheck$I(this, Legend);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$o(this, Legend, [].concat(args));
    _defineProperty$Z(_this, "lastBoundingBox", {
      width: -1,
      height: -1
    });
    return _this;
  }
  _inherits$x(Legend, _PureComponent);
  return _createClass$I(Legend, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();
        box.height = this.wrapperNode.offsetHeight;
        box.width = this.wrapperNode.offsetWidth;
        return box;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var onBBoxUpdate = this.props.onBBoxUpdate;
      var box = this.getBBox();
      if (box) {
        if (Math.abs(box.width - this.lastBoundingBox.width) > EPS || Math.abs(box.height - this.lastBoundingBox.height) > EPS) {
          this.lastBoundingBox.width = box.width;
          this.lastBoundingBox.height = box.height;
          if (onBBoxUpdate) {
            onBBoxUpdate(box);
          }
        }
      } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
        this.lastBoundingBox.width = -1;
        this.lastBoundingBox.height = -1;
        if (onBBoxUpdate) {
          onBBoxUpdate(null);
        }
      }
    }
  }, {
    key: "getBBoxSnapshot",
    value: function getBBoxSnapshot() {
      if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) {
        return _objectSpread$Q({}, this.lastBoundingBox);
      }
      return {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function getDefaultPosition(style) {
      var _this$props = this.props,
        layout = _this$props.layout,
        align = _this$props.align,
        verticalAlign = _this$props.verticalAlign,
        margin = _this$props.margin,
        chartWidth = _this$props.chartWidth,
        chartHeight = _this$props.chartHeight;
      var hPos, vPos;
      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') {
          var box = this.getBBoxSnapshot();
          hPos = {
            left: ((chartWidth || 0) - box.width) / 2
          };
        } else {
          hPos = align === 'right' ? {
            right: margin && margin.right || 0
          } : {
            left: margin && margin.left || 0
          };
        }
      }
      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') {
          var _box = this.getBBoxSnapshot();
          vPos = {
            top: ((chartHeight || 0) - _box.height) / 2
          };
        } else {
          vPos = verticalAlign === 'bottom' ? {
            bottom: margin && margin.bottom || 0
          } : {
            top: margin && margin.top || 0
          };
        }
      }
      return _objectSpread$Q(_objectSpread$Q({}, hPos), vPos);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        content = _this$props2.content,
        width = _this$props2.width,
        height = _this$props2.height,
        wrapperStyle = _this$props2.wrapperStyle,
        payloadUniqBy = _this$props2.payloadUniqBy,
        payload = _this$props2.payload;
      var outerStyle = _objectSpread$Q(_objectSpread$Q({
        position: 'absolute',
        width: width || 'auto',
        height: height || 'auto'
      }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
      return /*#__PURE__*/_react$W["default"].createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      }, renderContent$1(content, _objectSpread$Q(_objectSpread$Q({}, this.props), {}, {
        payload: (0, _getUniqPayload$1.getUniqPayload)(payload, payloadUniqBy, defaultUniqBy$1)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function getWithHeight(item, chartWidth) {
      var _this$defaultProps$it = _objectSpread$Q(_objectSpread$Q({}, this.defaultProps), item.props),
        layout = _this$defaultProps$it.layout;
      if (layout === 'vertical' && (0, _DataUtils$u.isNumber)(item.props.height)) {
        return {
          height: item.props.height
        };
      }
      if (layout === 'horizontal') {
        return {
          width: item.props.width || chartWidth
        };
      }
      return null;
    }
  }]);
}(_react$W.PureComponent);
_defineProperty$Z(Legend, "displayName", 'Legend');
_defineProperty$Z(Legend, "defaultProps", {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom'
});

var Tooltip$1 = {};

var DefaultTooltipContent = {};

var Symbol$1 = _Symbol,
    isArguments = isArguments_1,
    isArray$4 = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$4(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush = _arrayPush,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$3(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$3(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$3;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy$1(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy$1;

var isSymbol$1 = isSymbol_1;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol$1(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol$1(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending$1;

var compareAscending = _compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple$1(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple$1;

var arrayMap$1 = _arrayMap,
    baseGet$1 = _baseGet,
    baseIteratee$8 = _baseIteratee,
    baseMap = _baseMap,
    baseSortBy = _baseSortBy,
    baseUnary = _baseUnary,
    compareMultiple = _compareMultiple,
    identity$a = identity_1,
    isArray$3 = isArray_1;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap$1(iteratees, function(iteratee) {
      if (isArray$3(iteratee)) {
        return function(value) {
          return baseGet$1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$a];
  }

  var index = -1;
  iteratees = arrayMap$1(iteratees, baseUnary(baseIteratee$8));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap$1(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy$1;

var baseFlatten$2 = _baseFlatten,
    baseOrderBy = _baseOrderBy,
    baseRest = _baseRest,
    isIterateeCall$3 = _isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall$3(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall$3(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten$2(iteratees, 1), []);
});

var sortBy_1 = sortBy;

Object.defineProperty(DefaultTooltipContent, "__esModule", {
  value: true
});
DefaultTooltipContent.DefaultTooltipContent = void 0;
var _react$V = _interopRequireDefault$1_(React__default$4);
var _sortBy$1 = _interopRequireDefault$1_(sortBy_1);
var _isNil$b = _interopRequireDefault$1_(isNil_1);
var _clsx$x = _interopRequireDefault$1_(clsx.exports);
var _DataUtils$t = DataUtils;
function _interopRequireDefault$1_(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$Z(o) { "@babel/helpers - typeof"; return _typeof$Z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$Z(o); }
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
function _slicedToArray$k(arr, i) { return _arrayWithHoles$j(arr) || _iterableToArrayLimit$i(arr, i) || _unsupportedIterableToArray$A(arr, i) || _nonIterableRest$j(); }
function _nonIterableRest$j() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$A(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$A(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$A(o, minLen); }
function _arrayLikeToArray$A(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$i(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$j(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys$R(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$P(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$R(Object(t), !0).forEach(function (r) { _defineProperty$Y(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$R(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$Y(obj, key, value) { key = _toPropertyKey$R(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$R(t) { var i = _toPrimitive$R(t, "string"); return "symbol" == _typeof$Z(i) ? i : i + ""; }
function _toPrimitive$R(t, r) { if ("object" != _typeof$Z(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$Z(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Default Tooltip Content
 */
function defaultFormatter(value) {
  return Array.isArray(value) && (0, _DataUtils$t.isNumOrStr)(value[0]) && (0, _DataUtils$t.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
}
DefaultTooltipContent.DefaultTooltipContent = function DefaultTooltipContent(props) {
  var _props$separator = props.separator,
    separator = _props$separator === void 0 ? ' : ' : _props$separator,
    _props$contentStyle = props.contentStyle,
    contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle,
    _props$itemStyle = props.itemStyle,
    itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle,
    _props$labelStyle = props.labelStyle,
    labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle,
    payload = props.payload,
    formatter = props.formatter,
    itemSorter = props.itemSorter,
    wrapperClassName = props.wrapperClassName,
    labelClassName = props.labelClassName,
    label = props.label,
    labelFormatter = props.labelFormatter,
    _props$accessibilityL = props.accessibilityLayer,
    accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
  var renderContent = function renderContent() {
    if (payload && payload.length) {
      var listStyle = {
        padding: 0,
        margin: 0
      };
      var items = (itemSorter ? (0, _sortBy$1["default"])(payload, itemSorter) : payload).map(function (entry, i) {
        if (entry.type === 'none') {
          return null;
        }
        var finalItemStyle = _objectSpread$P({
          display: 'block',
          paddingTop: 4,
          paddingBottom: 4,
          color: entry.color || '#000'
        }, itemStyle);
        var finalFormatter = entry.formatter || formatter || defaultFormatter;
        var value = entry.value,
          name = entry.name;
        var finalValue = value;
        var finalName = name;
        if (finalFormatter && finalValue != null && finalName != null) {
          var formatted = finalFormatter(value, name, entry, i, payload);
          if (Array.isArray(formatted)) {
            var _formatted = _slicedToArray$k(formatted, 2);
            finalValue = _formatted[0];
            finalName = _formatted[1];
          } else {
            finalValue = formatted;
          }
        }
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          _react$V["default"].createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(i),
            style: finalItemStyle
          }, (0, _DataUtils$t.isNumOrStr)(finalName) ? /*#__PURE__*/_react$V["default"].createElement("span", {
            className: "recharts-tooltip-item-name"
          }, finalName) : null, (0, _DataUtils$t.isNumOrStr)(finalName) ? /*#__PURE__*/_react$V["default"].createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, separator) : null, /*#__PURE__*/_react$V["default"].createElement("span", {
            className: "recharts-tooltip-item-value"
          }, finalValue), /*#__PURE__*/_react$V["default"].createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, entry.unit || ''))
        );
      });
      return /*#__PURE__*/_react$V["default"].createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: listStyle
      }, items);
    }
    return null;
  };
  var finalStyle = _objectSpread$P({
    margin: 0,
    padding: 10,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    whiteSpace: 'nowrap'
  }, contentStyle);
  var finalLabelStyle = _objectSpread$P({
    margin: 0
  }, labelStyle);
  var hasLabel = !(0, _isNil$b["default"])(label);
  var finalLabel = hasLabel ? label : '';
  var wrapperCN = (0, _clsx$x["default"])('recharts-default-tooltip', wrapperClassName);
  var labelCN = (0, _clsx$x["default"])('recharts-tooltip-label', labelClassName);
  if (hasLabel && labelFormatter && payload !== undefined && payload !== null) {
    finalLabel = labelFormatter(label, payload);
  }
  var accessibilityAttributes = accessibilityLayer ? {
    role: 'status',
    'aria-live': 'assertive'
  } : {};
  return /*#__PURE__*/_react$V["default"].createElement("div", _extends$J({
    className: wrapperCN,
    style: finalStyle
  }, accessibilityAttributes), /*#__PURE__*/_react$V["default"].createElement("p", {
    className: labelCN,
    style: finalLabelStyle
  }, /*#__PURE__*/_react$V["default"].isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};

var TooltipBoundingBox = {};

var translate$1 = {};

Object.defineProperty(translate$1, "__esModule", {
  value: true
});
translate$1.getTooltipCSSClassName = getTooltipCSSClassName;
translate$1.getTooltipTranslate = getTooltipTranslate;
translate$1.getTooltipTranslateXY = getTooltipTranslateXY;
translate$1.getTransformStyle = getTransformStyle;
var _clsx2 = _interopRequireDefault$1Z(clsx.exports);
var _DataUtils$s = DataUtils;
function _interopRequireDefault$1Z(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$Y(o) { "@babel/helpers - typeof"; return _typeof$Y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$Y(o); }
function _defineProperty$X(obj, key, value) { key = _toPropertyKey$Q(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$Q(t) { var i = _toPrimitive$Q(t, "string"); return "symbol" == _typeof$Y(i) ? i : i + ""; }
function _toPrimitive$Q(t, r) { if ("object" != _typeof$Y(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$Y(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var TOOLTIP_HIDDEN = {
  visibility: 'hidden'
};
function getTooltipCSSClassName(_ref) {
  var coordinate = _ref.coordinate,
    translateX = _ref.translateX,
    translateY = _ref.translateY;
  return (0, _clsx2["default"])(CSS_CLASS_PREFIX, _defineProperty$X(_defineProperty$X(_defineProperty$X(_defineProperty$X({}, "".concat(CSS_CLASS_PREFIX, "-right"), (0, _DataUtils$s.isNumber)(translateX) && coordinate && (0, _DataUtils$s.isNumber)(coordinate.x) && translateX >= coordinate.x), "".concat(CSS_CLASS_PREFIX, "-left"), (0, _DataUtils$s.isNumber)(translateX) && coordinate && (0, _DataUtils$s.isNumber)(coordinate.x) && translateX < coordinate.x), "".concat(CSS_CLASS_PREFIX, "-bottom"), (0, _DataUtils$s.isNumber)(translateY) && coordinate && (0, _DataUtils$s.isNumber)(coordinate.y) && translateY >= coordinate.y), "".concat(CSS_CLASS_PREFIX, "-top"), (0, _DataUtils$s.isNumber)(translateY) && coordinate && (0, _DataUtils$s.isNumber)(coordinate.y) && translateY < coordinate.y));
}
function getTooltipTranslateXY(_ref2) {
  var allowEscapeViewBox = _ref2.allowEscapeViewBox,
    coordinate = _ref2.coordinate,
    key = _ref2.key,
    offsetTopLeft = _ref2.offsetTopLeft,
    position = _ref2.position,
    reverseDirection = _ref2.reverseDirection,
    tooltipDimension = _ref2.tooltipDimension,
    viewBox = _ref2.viewBox,
    viewBoxDimension = _ref2.viewBoxDimension;
  if (position && (0, _DataUtils$s.isNumber)(position[key])) {
    return position[key];
  }
  var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
  var positive = coordinate[key] + offsetTopLeft;
  if (allowEscapeViewBox[key]) {
    return reverseDirection[key] ? negative : positive;
  }
  if (reverseDirection[key]) {
    var _tooltipBoundary = negative;
    var _viewBoxBoundary = viewBox[key];
    if (_tooltipBoundary < _viewBoxBoundary) {
      return Math.max(positive, viewBox[key]);
    }
    return Math.max(negative, viewBox[key]);
  }
  var tooltipBoundary = positive + tooltipDimension;
  var viewBoxBoundary = viewBox[key] + viewBoxDimension;
  if (tooltipBoundary > viewBoxBoundary) {
    return Math.max(negative, viewBox[key]);
  }
  return Math.max(positive, viewBox[key]);
}
function getTransformStyle(_ref3) {
  var translateX = _ref3.translateX,
    translateY = _ref3.translateY,
    useTranslate3d = _ref3.useTranslate3d;
  return {
    transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
  };
}
function getTooltipTranslate(_ref4) {
  var allowEscapeViewBox = _ref4.allowEscapeViewBox,
    coordinate = _ref4.coordinate,
    offsetTopLeft = _ref4.offsetTopLeft,
    position = _ref4.position,
    reverseDirection = _ref4.reverseDirection,
    tooltipBox = _ref4.tooltipBox,
    useTranslate3d = _ref4.useTranslate3d,
    viewBox = _ref4.viewBox;
  var cssProperties, translateX, translateY;
  if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
    translateX = getTooltipTranslateXY({
      allowEscapeViewBox: allowEscapeViewBox,
      coordinate: coordinate,
      key: 'x',
      offsetTopLeft: offsetTopLeft,
      position: position,
      reverseDirection: reverseDirection,
      tooltipDimension: tooltipBox.width,
      viewBox: viewBox,
      viewBoxDimension: viewBox.width
    });
    translateY = getTooltipTranslateXY({
      allowEscapeViewBox: allowEscapeViewBox,
      coordinate: coordinate,
      key: 'y',
      offsetTopLeft: offsetTopLeft,
      position: position,
      reverseDirection: reverseDirection,
      tooltipDimension: tooltipBox.height,
      viewBox: viewBox,
      viewBoxDimension: viewBox.height
    });
    cssProperties = getTransformStyle({
      translateX: translateX,
      translateY: translateY,
      useTranslate3d: useTranslate3d
    });
  } else {
    cssProperties = TOOLTIP_HIDDEN;
  }
  return {
    cssProperties: cssProperties,
    cssClasses: getTooltipCSSClassName({
      translateX: translateX,
      translateY: translateY,
      coordinate: coordinate
    })
  };
}

Object.defineProperty(TooltipBoundingBox, "__esModule", {
  value: true
});
TooltipBoundingBox.TooltipBoundingBox = void 0;
var _react$U = _interopRequireWildcard$I(React__default$4);
var _translate = translate$1;
function _getRequireWildcardCache$I(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$I = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$I(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$X(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$I(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$X(o) { "@babel/helpers - typeof"; return _typeof$X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$X(o); }
function ownKeys$Q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$O(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$Q(Object(t), !0).forEach(function (r) { _defineProperty$W(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$Q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$H(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$B(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$P(descriptor.key), descriptor); } }
function _createClass$H(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$B(Constructor.prototype, protoProps); if (staticProps) _defineProperties$B(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$n(t, o, e) { return o = _getPrototypeOf$q(o), _possibleConstructorReturn$w(t, _isNativeReflectConstruct$q() ? Reflect.construct(o, e || [], _getPrototypeOf$q(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$w(self, call) { if (call && (_typeof$X(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$q(self); }
function _assertThisInitialized$q(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$q() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$q = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$q(o) { _getPrototypeOf$q = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$q(o); }
function _inherits$w(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$q(subClass, superClass); }
function _setPrototypeOf$q(o, p) { _setPrototypeOf$q = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$q(o, p); }
function _defineProperty$W(obj, key, value) { key = _toPropertyKey$P(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$P(t) { var i = _toPrimitive$P(t, "string"); return "symbol" == _typeof$X(i) ? i : i + ""; }
function _toPrimitive$P(t, r) { if ("object" != _typeof$X(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$X(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EPSILON = 1;
TooltipBoundingBox.TooltipBoundingBox = /*#__PURE__*/function (_PureComponent) {
  function TooltipBoundingBox() {
    var _this;
    _classCallCheck$H(this, TooltipBoundingBox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$n(this, TooltipBoundingBox, [].concat(args));
    _defineProperty$W(_this, "state", {
      dismissed: false,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    });
    _defineProperty$W(_this, "handleKeyDown", function (event) {
      if (event.key === 'Escape') {
        var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
        _this.setState({
          dismissed: true,
          dismissedAtCoordinate: {
            x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
            y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
          }
        });
      }
    });
    return _this;
  }
  _inherits$w(TooltipBoundingBox, _PureComponent);
  return _createClass$H(TooltipBoundingBox, [{
    key: "updateBBox",
    value: function updateBBox() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();
        if (Math.abs(box.width - this.state.lastBoundingBox.width) > EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > EPSILON) {
          this.setState({
            lastBoundingBox: {
              width: box.width,
              height: box.height
            }
          });
        }
      } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) {
        this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
      this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props$coordinat5, _this$props$coordinat6;
      if (this.props.active) {
        this.updateBBox();
      }
      if (!this.state.dismissed) {
        return;
      }
      if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) {
        this.state.dismissed = false;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        active = _this$props.active,
        allowEscapeViewBox = _this$props.allowEscapeViewBox,
        animationDuration = _this$props.animationDuration,
        animationEasing = _this$props.animationEasing,
        children = _this$props.children,
        coordinate = _this$props.coordinate,
        hasPayload = _this$props.hasPayload,
        isAnimationActive = _this$props.isAnimationActive,
        offset = _this$props.offset,
        position = _this$props.position,
        reverseDirection = _this$props.reverseDirection,
        useTranslate3d = _this$props.useTranslate3d,
        viewBox = _this$props.viewBox,
        wrapperStyle = _this$props.wrapperStyle;
      var _getTooltipTranslate = (0, _translate.getTooltipTranslate)({
          allowEscapeViewBox: allowEscapeViewBox,
          coordinate: coordinate,
          offsetTopLeft: offset,
          position: position,
          reverseDirection: reverseDirection,
          tooltipBox: this.state.lastBoundingBox,
          useTranslate3d: useTranslate3d,
          viewBox: viewBox
        }),
        cssClasses = _getTooltipTranslate.cssClasses,
        cssProperties = _getTooltipTranslate.cssProperties;
      var outerStyle = _objectSpread$O(_objectSpread$O({
        transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
      }, cssProperties), {}, {
        pointerEvents: 'none',
        visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
        position: 'absolute',
        top: 0,
        left: 0
      }, wrapperStyle);
      return (
        /*#__PURE__*/
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        _react$U["default"].createElement("div", {
          tabIndex: -1,
          className: cssClasses,
          style: outerStyle,
          ref: function ref(node) {
            _this2.wrapperNode = node;
          }
        }, children)
      );
    }
  }]);
}(_react$U.PureComponent);

var Global$1 = {};

Object.defineProperty(Global$1, "__esModule", {
  value: true
});
Global$1.Global = void 0;
var parseIsSsrByDefault = function parseIsSsrByDefault() {
  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var Global = Global$1.Global = {
  isSsr: parseIsSsrByDefault(),
  get: function get(key) {
    return Global[key];
  },
  set: function set(key, value) {
    if (typeof key === 'string') {
      Global[key] = value;
    } else {
      var keys = Object.keys(key);
      if (keys && keys.length) {
        keys.forEach(function (k) {
          Global[k] = key[k];
        });
      }
    }
  }
};

Object.defineProperty(Tooltip$1, "__esModule", {
  value: true
});
Tooltip$1.Tooltip = void 0;
var _react$T = _interopRequireWildcard$H(React__default$4);
var _DefaultTooltipContent = DefaultTooltipContent;
var _TooltipBoundingBox = TooltipBoundingBox;
var _Global$c = Global$1;
var _getUniqPayload = getUniqPayload$1;
function _getRequireWildcardCache$H(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$H = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$H(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$W(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$H(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$W(o) { "@babel/helpers - typeof"; return _typeof$W = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$W(o); }
function ownKeys$P(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$N(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$P(Object(t), !0).forEach(function (r) { _defineProperty$V(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$P(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$G(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$A(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$O(descriptor.key), descriptor); } }
function _createClass$G(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$A(Constructor.prototype, protoProps); if (staticProps) _defineProperties$A(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$m(t, o, e) { return o = _getPrototypeOf$p(o), _possibleConstructorReturn$v(t, _isNativeReflectConstruct$p() ? Reflect.construct(o, e || [], _getPrototypeOf$p(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$v(self, call) { if (call && (_typeof$W(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$p(self); }
function _assertThisInitialized$p(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$p() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$p = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$p(o) { _getPrototypeOf$p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$p(o); }
function _inherits$v(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$p(subClass, superClass); }
function _setPrototypeOf$p(o, p) { _setPrototypeOf$p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$p(o, p); }
function _defineProperty$V(obj, key, value) { key = _toPropertyKey$O(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$O(t) { var i = _toPrimitive$O(t, "string"); return "symbol" == _typeof$W(i) ? i : i + ""; }
function _toPrimitive$O(t, r) { if ("object" != _typeof$W(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$W(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Tooltip
 */
function defaultUniqBy(entry) {
  return entry.dataKey;
}
function renderContent(content, props) {
  if ( /*#__PURE__*/_react$T["default"].isValidElement(content)) {
    return /*#__PURE__*/_react$T["default"].cloneElement(content, props);
  }
  if (typeof content === 'function') {
    return /*#__PURE__*/_react$T["default"].createElement(content, props);
  }
  return /*#__PURE__*/_react$T["default"].createElement(_DefaultTooltipContent.DefaultTooltipContent, props);
}
var Tooltip = Tooltip$1.Tooltip = /*#__PURE__*/function (_PureComponent) {
  function Tooltip() {
    _classCallCheck$G(this, Tooltip);
    return _callSuper$m(this, Tooltip, arguments);
  }
  _inherits$v(Tooltip, _PureComponent);
  return _createClass$G(Tooltip, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        active = _this$props.active,
        allowEscapeViewBox = _this$props.allowEscapeViewBox,
        animationDuration = _this$props.animationDuration,
        animationEasing = _this$props.animationEasing,
        content = _this$props.content,
        coordinate = _this$props.coordinate,
        filterNull = _this$props.filterNull,
        isAnimationActive = _this$props.isAnimationActive,
        offset = _this$props.offset,
        payload = _this$props.payload,
        payloadUniqBy = _this$props.payloadUniqBy,
        position = _this$props.position,
        reverseDirection = _this$props.reverseDirection,
        useTranslate3d = _this$props.useTranslate3d,
        viewBox = _this$props.viewBox,
        wrapperStyle = _this$props.wrapperStyle;
      var finalPayload = payload !== null && payload !== void 0 ? payload : [];
      if (filterNull && finalPayload.length) {
        finalPayload = (0, _getUniqPayload.getUniqPayload)(payload.filter(function (entry) {
          return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
        }), payloadUniqBy, defaultUniqBy);
      }
      var hasPayload = finalPayload.length > 0;
      return /*#__PURE__*/_react$T["default"].createElement(_TooltipBoundingBox.TooltipBoundingBox, {
        allowEscapeViewBox: allowEscapeViewBox,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        active: active,
        coordinate: coordinate,
        hasPayload: hasPayload,
        offset: offset,
        position: position,
        reverseDirection: reverseDirection,
        useTranslate3d: useTranslate3d,
        viewBox: viewBox,
        wrapperStyle: wrapperStyle
      }, renderContent(content, _objectSpread$N(_objectSpread$N({}, this.props), {}, {
        payload: finalPayload
      })));
    }
  }]);
}(_react$T.PureComponent);
_defineProperty$V(Tooltip, "displayName", 'Tooltip');
_defineProperty$V(Tooltip, "defaultProps", {
  accessibilityLayer: false,
  allowEscapeViewBox: {
    x: false,
    y: false
  },
  animationDuration: 400,
  animationEasing: 'ease',
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: true,
  cursorStyle: {},
  filterNull: true,
  isAnimationActive: !_Global$c.Global.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: false,
    y: false
  },
  separator: ' : ',
  trigger: 'hover',
  useTranslate3d: false,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});

var ResponsiveContainer = {};

function _typeof$V(o) { "@babel/helpers - typeof"; return _typeof$V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$V(o); }
Object.defineProperty(ResponsiveContainer, "__esModule", {
  value: true
});
ResponsiveContainer.ResponsiveContainer = void 0;
var _clsx$w = _interopRequireDefault$1Y(clsx.exports);
var _react$S = _interopRequireWildcard$G(React__default$4);
var _throttle$1 = _interopRequireDefault$1Y(throttle_1);
var _DataUtils$r = DataUtils;
var _LogUtils$6 = LogUtils;
var _ReactUtils$A = ReactUtils;
function _getRequireWildcardCache$G(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$G = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$G(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$V(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$G(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault$1Y(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys$O(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$M(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$O(Object(t), !0).forEach(function (r) { _defineProperty$U(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$O(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$U(obj, key, value) { key = _toPropertyKey$N(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$N(t) { var i = _toPrimitive$N(t, "string"); return "symbol" == _typeof$V(i) ? i : i + ""; }
function _toPrimitive$N(t, r) { if ("object" != _typeof$V(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$V(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray$j(arr, i) { return _arrayWithHoles$i(arr) || _iterableToArrayLimit$h(arr, i) || _unsupportedIterableToArray$z(arr, i) || _nonIterableRest$i(); }
function _nonIterableRest$i() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$z(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$z(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$z(o, minLen); }
function _arrayLikeToArray$z(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$h(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$i(arr) { if (Array.isArray(arr)) return arr; } /**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */
ResponsiveContainer.ResponsiveContainer = /*#__PURE__*/(0, _react$S.forwardRef)(function (_ref, ref) {
  var aspect = _ref.aspect,
    _ref$initialDimension = _ref.initialDimension,
    initialDimension = _ref$initialDimension === void 0 ? {
      width: -1,
      height: -1
    } : _ref$initialDimension,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$minWidth = _ref.minWidth,
    minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth,
    minHeight = _ref.minHeight,
    maxHeight = _ref.maxHeight,
    children = _ref.children,
    _ref$debounce = _ref.debounce,
    debounce = _ref$debounce === void 0 ? 0 : _ref$debounce,
    id = _ref.id,
    className = _ref.className,
    onResize = _ref.onResize,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var containerRef = (0, _react$S.useRef)(null);
  var onResizeRef = (0, _react$S.useRef)();
  onResizeRef.current = onResize;
  (0, _react$S.useImperativeHandle)(ref, function () {
    return Object.defineProperty(containerRef.current, 'current', {
      get: function get() {
        // eslint-disable-next-line no-console
        console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
        return containerRef.current;
      },
      configurable: true
    });
  });
  var _useState = (0, _react$S.useState)({
      containerWidth: initialDimension.width,
      containerHeight: initialDimension.height
    }),
    _useState2 = _slicedToArray$j(_useState, 2),
    sizes = _useState2[0],
    setSizes = _useState2[1];
  var setContainerSize = (0, _react$S.useCallback)(function (newWidth, newHeight) {
    setSizes(function (prevState) {
      var roundedWidth = Math.round(newWidth);
      var roundedHeight = Math.round(newHeight);
      if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) {
        return prevState;
      }
      return {
        containerWidth: roundedWidth,
        containerHeight: roundedHeight
      };
    });
  }, []);
  (0, _react$S.useEffect)(function () {
    var callback = function callback(entries) {
      var _onResizeRef$current;
      var _entries$0$contentRec = entries[0].contentRect,
        containerWidth = _entries$0$contentRec.width,
        containerHeight = _entries$0$contentRec.height;
      setContainerSize(containerWidth, containerHeight);
      (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
    };
    if (debounce > 0) {
      callback = (0, _throttle$1["default"])(callback, debounce, {
        trailing: true,
        leading: false
      });
    }
    var observer = new ResizeObserver(callback);
    var _containerRef$current = containerRef.current.getBoundingClientRect(),
      containerWidth = _containerRef$current.width,
      containerHeight = _containerRef$current.height;
    setContainerSize(containerWidth, containerHeight);
    observer.observe(containerRef.current);
    return function () {
      observer.disconnect();
    };
  }, [setContainerSize, debounce]);
  var chartContent = (0, _react$S.useMemo)(function () {
    var containerWidth = sizes.containerWidth,
      containerHeight = sizes.containerHeight;
    if (containerWidth < 0 || containerHeight < 0) {
      return null;
    }
    (0, _LogUtils$6.warn)((0, _DataUtils$r.isPercent)(width) || (0, _DataUtils$r.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
    (0, _LogUtils$6.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
    var calculatedWidth = (0, _DataUtils$r.isPercent)(width) ? containerWidth : width;
    var calculatedHeight = (0, _DataUtils$r.isPercent)(height) ? containerHeight : height;
    if (aspect && aspect > 0) {
      // Preserve the desired aspect ratio
      if (calculatedWidth) {
        // Will default to using width for aspect ratio
        calculatedHeight = calculatedWidth / aspect;
      } else if (calculatedHeight) {
        // But we should also take height into consideration
        calculatedWidth = calculatedHeight * aspect;
      }

      // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
      if (maxHeight && calculatedHeight > maxHeight) {
        calculatedHeight = maxHeight;
      }
    }
    (0, _LogUtils$6.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
    var isCharts = !Array.isArray(children) && (0, _ReactUtils$A.getDisplayName)(children.type).endsWith('Chart');
    return _react$S["default"].Children.map(children, function (child) {
      if ( /*#__PURE__*/_react$S["default"].isValidElement(child)) {
        return /*#__PURE__*/(0, _react$S.cloneElement)(child, _objectSpread$M({
          width: calculatedWidth,
          height: calculatedHeight
        }, isCharts ? {
          style: _objectSpread$M({
            height: '100%',
            width: '100%',
            maxHeight: calculatedHeight,
            maxWidth: calculatedWidth
          }, child.props.style)
        } : {}));
      }
      return child;
    });
  }, [aspect, children, height, maxHeight, minHeight, minWidth, sizes, width]);
  return /*#__PURE__*/_react$S["default"].createElement("div", {
    id: id ? "".concat(id) : undefined,
    className: (0, _clsx$w["default"])('recharts-responsive-container', className),
    style: _objectSpread$M(_objectSpread$M({}, style), {}, {
      width: width,
      height: height,
      minWidth: minWidth,
      minHeight: minHeight,
      maxHeight: maxHeight
    }),
    ref: containerRef
  }, chartContent);
});

var Cell$2 = {};

Object.defineProperty(Cell$2, "__esModule", {
  value: true
});
Cell$2.Cell = void 0;
/**
 * @fileOverview Cross
 */

var Cell$1 = Cell$2.Cell = function Cell(_props) {
  return null;
};
Cell$1.displayName = 'Cell';

var Text = {};

var DOMUtils = {};

function _typeof$U(o) { "@babel/helpers - typeof"; return _typeof$U = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$U(o); }
Object.defineProperty(DOMUtils, "__esModule", {
  value: true
});
DOMUtils.getStyleString = DOMUtils.getStringSize = DOMUtils.getOffset = void 0;
var _Global$b = Global$1;
function ownKeys$N(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$L(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$N(Object(t), !0).forEach(function (r) { _defineProperty$T(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$N(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$T(obj, key, value) { key = _toPropertyKey$M(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$M(t) { var i = _toPrimitive$M(t, "string"); return "symbol" == _typeof$U(i) ? i : i + ""; }
function _toPrimitive$M(t, r) { if ("object" != _typeof$U(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$U(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray$c(arr) { return _arrayWithoutHoles$c(arr) || _iterableToArray$d(arr) || _unsupportedIterableToArray$y(arr) || _nonIterableSpread$c(); }
function _nonIterableSpread$c() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$y(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$y(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$y(o, minLen); }
function _iterableToArray$d(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$c(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$y(arr); }
function _arrayLikeToArray$y(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var stringCache = {
  widthCache: {},
  cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
  position: 'absolute',
  top: '-20000px',
  left: 0,
  padding: 0,
  margin: 0,
  border: 'none',
  whiteSpace: 'pre'
};
var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function autoCompleteStyle(name, value) {
  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
    return "".concat(value, "px");
  }
  return value;
}
function camelToMiddleLine(text) {
  var strs = text.split('');
  var formatStrs = strs.reduce(function (result, entry) {
    if (entry === entry.toUpperCase()) {
      return [].concat(_toConsumableArray$c(result), ['-', entry.toLowerCase()]);
    }
    return [].concat(_toConsumableArray$c(result), [entry]);
  }, []);
  return formatStrs.join('');
}
DOMUtils.getStyleString = function getStyleString(style) {
  return Object.keys(style).reduce(function (result, s) {
    return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
  }, '');
};
function removeInvalidKeys(obj) {
  var copyObj = _objectSpread$L({}, obj);
  Object.keys(copyObj).forEach(function (key) {
    if (!copyObj[key]) {
      delete copyObj[key];
    }
  });
  return copyObj;
}
DOMUtils.getStringSize = function getStringSize(text) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (text === undefined || text === null || _Global$b.Global.isSsr) {
    return {
      width: 0,
      height: 0
    };
  }
  var copyStyle = removeInvalidKeys(style);
  var cacheKey = JSON.stringify({
    text: text,
    copyStyle: copyStyle
  });
  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }
  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
    if (!measurementSpan) {
      measurementSpan = document.createElement('span');
      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
      measurementSpan.setAttribute('aria-hidden', 'true');
      document.body.appendChild(measurementSpan);
    }
    // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
    // https://en.wikipedia.org/wiki/Content_Security_Policy
    var measurementSpanStyle = _objectSpread$L(_objectSpread$L({}, SPAN_STYLE), copyStyle);
    Object.assign(measurementSpan.style, measurementSpanStyle);
    measurementSpan.textContent = "".concat(text);
    var rect = measurementSpan.getBoundingClientRect();
    var result = {
      width: rect.width,
      height: rect.height
    };
    stringCache.widthCache[cacheKey] = result;
    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }
    return result;
  } catch (e) {
    return {
      width: 0,
      height: 0
    };
  }
};
DOMUtils.getOffset = function getOffset(rect) {
  return {
    top: rect.top + window.scrollY - document.documentElement.clientTop,
    left: rect.left + window.scrollX - document.documentElement.clientLeft
  };
};

var ReduceCSSCalc = {};

Object.defineProperty(ReduceCSSCalc, "__esModule", {
  value: true
});
ReduceCSSCalc.reduceCSSCalc = reduceCSSCalc;
ReduceCSSCalc.safeEvaluateExpression = safeEvaluateExpression;
function _typeof$T(o) { "@babel/helpers - typeof"; return _typeof$T = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$T(o); }
function _slicedToArray$i(arr, i) { return _arrayWithHoles$h(arr) || _iterableToArrayLimit$g(arr, i) || _unsupportedIterableToArray$x(arr, i) || _nonIterableRest$h(); }
function _nonIterableRest$h() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$x(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$x(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$x(o, minLen); }
function _arrayLikeToArray$x(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$g(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$h(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck$F(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$z(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$L(descriptor.key), descriptor); } }
function _createClass$F(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$z(Constructor.prototype, protoProps); if (staticProps) _defineProperties$z(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey$L(t) { var i = _toPrimitive$L(t, "string"); return "symbol" == _typeof$T(i) ? i : i + ""; }
function _toPrimitive$L(t, r) { if ("object" != _typeof$T(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$T(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var CONVERSION_RATES = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  "in": 96,
  Q: 96 / (2.54 * 40),
  px: 1
};
var FIXED_CSS_LENGTH_UNITS = Object.keys(CONVERSION_RATES);
var STR_NAN = 'NaN';
function convertToPx(value, unit) {
  return value * CONVERSION_RATES[unit];
}
var DecimalCSS = /*#__PURE__*/function () {
  function DecimalCSS(num, unit) {
    _classCallCheck$F(this, DecimalCSS);
    this.num = num;
    this.unit = unit;
    this.num = num;
    this.unit = unit;
    if (Number.isNaN(num)) {
      this.unit = '';
    }
    if (unit !== '' && !CSS_LENGTH_UNIT_REGEX.test(unit)) {
      this.num = NaN;
      this.unit = '';
    }
    if (FIXED_CSS_LENGTH_UNITS.includes(unit)) {
      this.num = convertToPx(num, unit);
      this.unit = 'px';
    }
  }
  return _createClass$F(DecimalCSS, [{
    key: "add",
    value: function add(other) {
      if (this.unit !== other.unit) {
        return new DecimalCSS(NaN, '');
      }
      return new DecimalCSS(this.num + other.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function subtract(other) {
      if (this.unit !== other.unit) {
        return new DecimalCSS(NaN, '');
      }
      return new DecimalCSS(this.num - other.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function multiply(other) {
      if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) {
        return new DecimalCSS(NaN, '');
      }
      return new DecimalCSS(this.num * other.num, this.unit || other.unit);
    }
  }, {
    key: "divide",
    value: function divide(other) {
      if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) {
        return new DecimalCSS(NaN, '');
      }
      return new DecimalCSS(this.num / other.num, this.unit || other.unit);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function isNaN() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function parse(str) {
      var _NUM_SPLIT_REGEX$exec;
      var _ref = (_NUM_SPLIT_REGEX$exec = NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [],
        _ref2 = _slicedToArray$i(_ref, 3),
        numStr = _ref2[1],
        unit = _ref2[2];
      return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
    }
  }]);
}();
function calculateArithmetic(expr) {
  if (expr.includes(STR_NAN)) {
    return STR_NAN;
  }
  var newExpr = expr;
  while (newExpr.includes('*') || newExpr.includes('/')) {
    var _MULTIPLY_OR_DIVIDE_R;
    var _ref3 = (_MULTIPLY_OR_DIVIDE_R = MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [],
      _ref4 = _slicedToArray$i(_ref3, 4),
      leftOperand = _ref4[1],
      operator = _ref4[2],
      rightOperand = _ref4[3];
    var lTs = DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
    var rTs = DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
    var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
    if (result.isNaN()) {
      return STR_NAN;
    }
    newExpr = newExpr.replace(MULTIPLY_OR_DIVIDE_REGEX, result.toString());
  }
  while (newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)) {
    var _ADD_OR_SUBTRACT_REGE;
    var _ref5 = (_ADD_OR_SUBTRACT_REGE = ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [],
      _ref6 = _slicedToArray$i(_ref5, 4),
      _leftOperand = _ref6[1],
      _operator = _ref6[2],
      _rightOperand = _ref6[3];
    var _lTs = DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
    var _rTs = DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
    var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
    if (_result.isNaN()) {
      return STR_NAN;
    }
    newExpr = newExpr.replace(ADD_OR_SUBTRACT_REGEX, _result.toString());
  }
  return newExpr;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(expr) {
  var newExpr = expr;
  while (newExpr.includes('(')) {
    var _PARENTHESES_REGEX$ex = PARENTHESES_REGEX.exec(newExpr),
      _PARENTHESES_REGEX$ex2 = _slicedToArray$i(_PARENTHESES_REGEX$ex, 2),
      parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
    newExpr = newExpr.replace(PARENTHESES_REGEX, calculateArithmetic(parentheticalExpression));
  }
  return newExpr;
}
function evaluateExpression(expression) {
  var newExpr = expression.replace(/\s+/g, '');
  newExpr = calculateParentheses(newExpr);
  newExpr = calculateArithmetic(newExpr);
  return newExpr;
}
function safeEvaluateExpression(expression) {
  try {
    return evaluateExpression(expression);
  } catch (e) {
    /* istanbul ignore next */
    return STR_NAN;
  }
}
function reduceCSSCalc(expression) {
  var result = safeEvaluateExpression(expression.slice(5, -1));
  if (result === STR_NAN) {
    // notify the user
    return '';
  }
  return result;
}

function _typeof$S(o) { "@babel/helpers - typeof"; return _typeof$S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$S(o); }
Object.defineProperty(Text, "__esModule", {
  value: true
});
Text.Text = void 0;
var _react$R = _interopRequireWildcard$F(React__default$4);
var _isNil$a = _interopRequireDefault$1X(isNil_1);
var _clsx$v = _interopRequireDefault$1X(clsx.exports);
var _DataUtils$q = DataUtils;
var _Global$a = Global$1;
var _ReactUtils$z = ReactUtils;
var _DOMUtils$3 = DOMUtils;
var _ReduceCSSCalc = ReduceCSSCalc;
var _excluded$o = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"],
  _excluded2$9 = ["dx", "dy", "angle", "className", "breakAll"];
function _interopRequireDefault$1X(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$F(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$F = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$F(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$S(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$F(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
function _objectWithoutProperties$r(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$o(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$o(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _slicedToArray$h(arr, i) { return _arrayWithHoles$g(arr) || _iterableToArrayLimit$f(arr, i) || _unsupportedIterableToArray$w(arr, i) || _nonIterableRest$g(); }
function _nonIterableRest$g() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$w(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$w(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$w(o, minLen); }
function _arrayLikeToArray$w(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$f(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$g(arr) { if (Array.isArray(arr)) return arr; }
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var calculateWordWidths = function calculateWordWidths(_ref) {
  var children = _ref.children,
    breakAll = _ref.breakAll,
    style = _ref.style;
  try {
    var words = [];
    if (!(0, _isNil$a["default"])(children)) {
      if (breakAll) {
        words = children.toString().split('');
      } else {
        words = children.toString().split(BREAKING_SPACES);
      }
    }
    var wordsWithComputedWidth = words.map(function (word) {
      return {
        word: word,
        width: (0, _DOMUtils$3.getStringSize)(word, style).width
      };
    });
    var spaceWidth = breakAll ? 0 : (0, _DOMUtils$3.getStringSize)("\xA0", style).width;
    return {
      wordsWithComputedWidth: wordsWithComputedWidth,
      spaceWidth: spaceWidth
    };
  } catch (e) {
    return null;
  }
};
var calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
  var maxLines = _ref2.maxLines,
    children = _ref2.children,
    style = _ref2.style,
    breakAll = _ref2.breakAll;
  var shouldLimitLines = (0, _DataUtils$q.isNumber)(maxLines);
  var text = children;
  var calculate = function calculate() {
    var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return words.reduce(function (result, _ref3) {
      var word = _ref3.word,
        width = _ref3.width;
      var currentLine = result[result.length - 1];
      if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
        // Word can be added to an existing line
        currentLine.words.push(word);
        currentLine.width += width + spaceWidth;
      } else {
        // Add first word to line or word is too long to scaleToFit on existing line
        var newLine = {
          words: [word],
          width: width
        };
        result.push(newLine);
      }
      return result;
    }, []);
  };
  var originalResult = calculate(initialWordsWithComputedWith);
  var findLongestLine = function findLongestLine(words) {
    return words.reduce(function (a, b) {
      return a.width > b.width ? a : b;
    });
  };
  if (!shouldLimitLines) {
    return originalResult;
  }
  var suffix = '…';
  var checkOverflow = function checkOverflow(index) {
    var tempText = text.slice(0, index);
    var words = calculateWordWidths({
      breakAll: breakAll,
      style: style,
      children: tempText + suffix
    }).wordsWithComputedWidth;
    var result = calculate(words);
    var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
    return [doesOverflow, result];
  };
  var start = 0;
  var end = text.length - 1;
  var iterations = 0;
  var trimmedResult;
  while (start <= end && iterations <= text.length - 1) {
    var middle = Math.floor((start + end) / 2);
    var prev = middle - 1;
    var _checkOverflow = checkOverflow(prev),
      _checkOverflow2 = _slicedToArray$h(_checkOverflow, 2),
      doesPrevOverflow = _checkOverflow2[0],
      result = _checkOverflow2[1];
    var _checkOverflow3 = checkOverflow(middle),
      _checkOverflow4 = _slicedToArray$h(_checkOverflow3, 1),
      doesMiddleOverflow = _checkOverflow4[0];
    if (!doesPrevOverflow && !doesMiddleOverflow) {
      start = middle + 1;
    }
    if (doesPrevOverflow && doesMiddleOverflow) {
      end = middle - 1;
    }
    if (!doesPrevOverflow && doesMiddleOverflow) {
      trimmedResult = result;
      break;
    }
    iterations++;
  }

  // Fallback to originalResult (result without trimming) if we cannot find the
  // where to trim.  This should not happen :tm:
  return trimmedResult || originalResult;
};
var getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
  var words = !(0, _isNil$a["default"])(children) ? children.toString().split(BREAKING_SPACES) : [];
  return [{
    words: words
  }];
};
var getWordsByLines = function getWordsByLines(_ref4) {
  var width = _ref4.width,
    scaleToFit = _ref4.scaleToFit,
    children = _ref4.children,
    style = _ref4.style,
    breakAll = _ref4.breakAll,
    maxLines = _ref4.maxLines;
  // Only perform calculations if using features that require them (multiline, scaleToFit)
  if ((width || scaleToFit) && !_Global$a.Global.isSsr) {
    var wordsWithComputedWidth, spaceWidth;
    var wordWidths = calculateWordWidths({
      breakAll: breakAll,
      children: children,
      style: style
    });
    if (wordWidths) {
      var wcw = wordWidths.wordsWithComputedWidth,
        sw = wordWidths.spaceWidth;
      wordsWithComputedWidth = wcw;
      spaceWidth = sw;
    } else {
      return getWordsWithoutCalculate(children);
    }
    return calculateWordsByLines({
      breakAll: breakAll,
      children: children,
      maxLines: maxLines,
      style: style
    }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
  }
  return getWordsWithoutCalculate(children);
};
var DEFAULT_FILL = '#808080';
Text.Text = function Text(_ref5) {
  var _ref5$x = _ref5.x,
    propsX = _ref5$x === void 0 ? 0 : _ref5$x,
    _ref5$y = _ref5.y,
    propsY = _ref5$y === void 0 ? 0 : _ref5$y,
    _ref5$lineHeight = _ref5.lineHeight,
    lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight,
    _ref5$capHeight = _ref5.capHeight,
    capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight,
    _ref5$scaleToFit = _ref5.scaleToFit,
    scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit,
    _ref5$textAnchor = _ref5.textAnchor,
    textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor,
    _ref5$verticalAnchor = _ref5.verticalAnchor,
    verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor,
    _ref5$fill = _ref5.fill,
    fill = _ref5$fill === void 0 ? DEFAULT_FILL : _ref5$fill,
    props = _objectWithoutProperties$r(_ref5, _excluded$o);
  var wordsByLines = (0, _react$R.useMemo)(function () {
    return getWordsByLines({
      breakAll: props.breakAll,
      children: props.children,
      maxLines: props.maxLines,
      scaleToFit: scaleToFit,
      style: props.style,
      width: props.width
    });
  }, [props.breakAll, props.children, props.maxLines, scaleToFit, props.style, props.width]);
  var dx = props.dx,
    dy = props.dy,
    angle = props.angle,
    className = props.className,
    breakAll = props.breakAll,
    textProps = _objectWithoutProperties$r(props, _excluded2$9);
  if (!(0, _DataUtils$q.isNumOrStr)(propsX) || !(0, _DataUtils$q.isNumOrStr)(propsY)) {
    return null;
  }
  var x = propsX + ((0, _DataUtils$q.isNumber)(dx) ? dx : 0);
  var y = propsY + ((0, _DataUtils$q.isNumber)(dy) ? dy : 0);
  var startDy;
  switch (verticalAnchor) {
    case 'start':
      startDy = (0, _ReduceCSSCalc.reduceCSSCalc)("calc(".concat(capHeight, ")"));
      break;
    case 'middle':
      startDy = (0, _ReduceCSSCalc.reduceCSSCalc)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
      break;
    default:
      startDy = (0, _ReduceCSSCalc.reduceCSSCalc)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
      break;
  }
  var transforms = [];
  if (scaleToFit) {
    var lineWidth = wordsByLines[0].width;
    var width = props.width;
    transforms.push("scale(".concat(((0, _DataUtils$q.isNumber)(width) ? width / lineWidth : 1) / lineWidth, ")"));
  }
  if (angle) {
    transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
  }
  if (transforms.length) {
    textProps.transform = transforms.join(' ');
  }
  return /*#__PURE__*/_react$R["default"].createElement("text", _extends$I({}, (0, _ReactUtils$z.filterProps)(textProps, true), {
    x: x,
    y: y,
    className: (0, _clsx$v["default"])('recharts-text', className),
    textAnchor: textAnchor,
    fill: fill.includes('url') ? DEFAULT_FILL : fill
  }), wordsByLines.map(function (line, index) {
    var words = line.words.join(breakAll ? '' : ' ');
    return (
      /*#__PURE__*/
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      _react$R["default"].createElement("tspan", {
        x: x,
        dy: index === 0 ? startDy : lineHeight,
        key: "".concat(words, "-").concat(index)
      }, words)
    );
  }));
};

var Label$1 = {};

var PolarUtils = {};

var ChartUtils = {};

var src$7 = {};

var band$1 = {};

var src$6 = {};

var bisect = {};

var ascending$1 = {};

Object.defineProperty(ascending$1, "__esModule", {
  value: true
});
ascending$1.default = ascending;

function ascending(a, b) {
  return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

var bisector$1 = {};

var descending$1 = {};

Object.defineProperty(descending$1, "__esModule", {
  value: true
});
descending$1.default = descending;

function descending(a, b) {
  return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

Object.defineProperty(bisector$1, "__esModule", {
  value: true
});
bisector$1.default = bisector;

var _ascending$8 = _interopRequireDefault$1W(ascending$1);

var _descending = _interopRequireDefault$1W(descending$1);

function _interopRequireDefault$1W(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bisector(f) {
  let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
  // can test whether the search value is (self-) comparable. We can’t do this
  // for a comparator (except for specific, known comparators) because we can’t
  // tell if the comparator is symmetric, and an asymmetric comparator can’t be
  // used to test whether a single value is comparable.

  if (f.length !== 2) {
    compare1 = _ascending$8.default;

    compare2 = (d, x) => (0, _ascending$8.default)(f(d), x);

    delta = (d, x) => f(d) - x;
  } else {
    compare1 = f === _ascending$8.default || f === _descending.default ? f : zero$1;
    compare2 = f;
    delta = f;
  }

  function left(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;

      do {
        const mid = lo + hi >>> 1;
        if (compare2(a[mid], x) < 0) lo = mid + 1;else hi = mid;
      } while (lo < hi);
    }

    return lo;
  }

  function right(a, x, lo = 0, hi = a.length) {
    if (lo < hi) {
      if (compare1(x, x) !== 0) return hi;

      do {
        const mid = lo + hi >>> 1;
        if (compare2(a[mid], x) <= 0) lo = mid + 1;else hi = mid;
      } while (lo < hi);
    }

    return lo;
  }

  function center(a, x, lo = 0, hi = a.length) {
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {
    left,
    center,
    right
  };
}

function zero$1() {
  return 0;
}

var number$5 = {};

Object.defineProperty(number$5, "__esModule", {
  value: true
});
number$5.default = number$4;
number$5.numbers = numbers;

function number$4(x) {
  return x === null ? NaN : +x;
}

function* numbers(values, valueof) {
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}

Object.defineProperty(bisect, "__esModule", {
  value: true
});
bisect.default = bisect.bisectRight = bisect.bisectLeft = bisect.bisectCenter = void 0;

var _ascending$7 = _interopRequireDefault$1V(ascending$1);

var _bisector = _interopRequireDefault$1V(bisector$1);

var _number$7 = _interopRequireDefault$1V(number$5);

function _interopRequireDefault$1V(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ascendingBisect = (0, _bisector.default)(_ascending$7.default);
const bisectRight = ascendingBisect.right;
bisect.bisectRight = bisectRight;
const bisectLeft = ascendingBisect.left;
bisect.bisectLeft = bisectLeft;
const bisectCenter = (0, _bisector.default)(_number$7.default).center;
bisect.bisectCenter = bisectCenter;
var _default$P = bisectRight;
bisect.default = _default$P;

var count$1 = {};

Object.defineProperty(count$1, "__esModule", {
  value: true
});
count$1.default = count;

function count(values, valueof) {
  let count = 0;

  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count;
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        ++count;
      }
    }
  }

  return count;
}

var cross$1 = {};

Object.defineProperty(cross$1, "__esModule", {
  value: true
});
cross$1.default = cross;

function length$1(array) {
  return array.length | 0;
}

function empty(length) {
  return !(length > 0);
}

function arrayify(values) {
  return typeof values !== "object" || "length" in values ? values : Array.from(values);
}

function reducer(reduce) {
  return values => reduce(...values);
}

function cross(...values) {
  const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
  values = values.map(arrayify);
  const lengths = values.map(length$1);
  const j = values.length - 1;
  const index = new Array(j + 1).fill(0);
  const product = [];
  if (j < 0 || lengths.some(empty)) return product;

  while (true) {
    product.push(index.map((j, i) => values[i][j]));
    let i = j;

    while (++index[i] === lengths[i]) {
      if (i === 0) return reduce ? product.map(reduce) : product;
      index[i--] = 0;
    }
  }
}

var cumsum$1 = {};

Object.defineProperty(cumsum$1, "__esModule", {
  value: true
});
cumsum$1.default = cumsum;

function cumsum(values, valueof) {
  var sum = 0,
      index = 0;
  return Float64Array.from(values, valueof === undefined ? v => sum += +v || 0 : v => sum += +valueof(v, index++, values) || 0);
}

var deviation$1 = {};

var variance$1 = {};

Object.defineProperty(variance$1, "__esModule", {
  value: true
});
variance$1.default = variance;

function variance(values, valueof) {
  let count = 0;
  let delta;
  let mean = 0;
  let sum = 0;

  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        delta = value - mean;
        mean += delta / ++count;
        sum += delta * (value - mean);
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        delta = value - mean;
        mean += delta / ++count;
        sum += delta * (value - mean);
      }
    }
  }

  if (count > 1) return sum / (count - 1);
}

Object.defineProperty(deviation$1, "__esModule", {
  value: true
});
deviation$1.default = deviation;

var _variance = _interopRequireDefault$1U(variance$1);

function _interopRequireDefault$1U(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deviation(values, valueof) {
  const v = (0, _variance.default)(values, valueof);
  return v ? Math.sqrt(v) : v;
}

var extent$1 = {};

Object.defineProperty(extent$1, "__esModule", {
  value: true
});
extent$1.default = extent;

function extent(values, valueof) {
  let min;
  let max;

  if (valueof === undefined) {
    for (const value of values) {
      if (value != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  }

  return [min, max];
}

var fsum$1 = {};

Object.defineProperty(fsum$1, "__esModule", {
  value: true
});
fsum$1.Adder = void 0;
fsum$1.fcumsum = fcumsum;
fsum$1.fsum = fsum;

// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class Adder {
  constructor() {
    this._partials = new Float64Array(32);
    this._n = 0;
  }

  add(x) {
    const p = this._partials;
    let i = 0;

    for (let j = 0; j < this._n && j < 32; j++) {
      const y = p[j],
            hi = x + y,
            lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
      if (lo) p[i++] = lo;
      x = hi;
    }

    p[i] = x;
    this._n = i + 1;
    return this;
  }

  valueOf() {
    const p = this._partials;
    let n = this._n,
        x,
        y,
        lo,
        hi = 0;

    if (n > 0) {
      hi = p[--n];

      while (n > 0) {
        x = hi;
        y = p[--n];
        hi = x + y;
        lo = y - (hi - x);
        if (lo) break;
      }

      if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
        y = lo * 2;
        x = hi + y;
        if (y == x - hi) hi = x;
      }
    }

    return hi;
  }

}

fsum$1.Adder = Adder;

function fsum(values, valueof) {
  const adder = new Adder();

  if (valueof === undefined) {
    for (let value of values) {
      if (value = +value) {
        adder.add(value);
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if (value = +valueof(value, ++index, values)) {
        adder.add(value);
      }
    }
  }

  return +adder;
}

function fcumsum(values, valueof) {
  const adder = new Adder();
  let index = -1;
  return Float64Array.from(values, valueof === undefined ? v => adder.add(+v || 0) : v => adder.add(+valueof(v, ++index, values) || 0));
}

var group$1 = {};

var src$5 = {};

Object.defineProperty(src$5, "__esModule", {
  value: true
});
src$5.InternSet = src$5.InternMap = void 0;

class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, {
      _intern: {
        value: new Map()
      },
      _key: {
        value: key
      }
    });
    if (entries != null) for (const [key, value] of entries) this.set(key, value);
  }

  get(key) {
    return super.get(intern_get(this, key));
  }

  has(key) {
    return super.has(intern_get(this, key));
  }

  set(key, value) {
    return super.set(intern_set(this, key), value);
  }

  delete(key) {
    return super.delete(intern_delete(this, key));
  }

}

src$5.InternMap = InternMap;

class InternSet extends Set {
  constructor(values, key = keyof) {
    super();
    Object.defineProperties(this, {
      _intern: {
        value: new Map()
      },
      _key: {
        value: key
      }
    });
    if (values != null) for (const value of values) this.add(value);
  }

  has(value) {
    return super.has(intern_get(this, value));
  }

  add(value) {
    return super.add(intern_set(this, value));
  }

  delete(value) {
    return super.delete(intern_delete(this, value));
  }

}

src$5.InternSet = InternSet;

function intern_get({
  _intern,
  _key
}, value) {
  const key = _key(value);

  return _intern.has(key) ? _intern.get(key) : value;
}

function intern_set({
  _intern,
  _key
}, value) {
  const key = _key(value);

  if (_intern.has(key)) return _intern.get(key);

  _intern.set(key, value);

  return value;
}

function intern_delete({
  _intern,
  _key
}, value) {
  const key = _key(value);

  if (_intern.has(key)) {
    value = _intern.get(key);

    _intern.delete(key);
  }

  return value;
}

function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}

var identity$9 = {};

Object.defineProperty(identity$9, "__esModule", {
  value: true
});
identity$9.default = identity$8;

function identity$8(x) {
  return x;
}

Object.defineProperty(group$1, "__esModule", {
  value: true
});
group$1.default = group;
group$1.flatGroup = flatGroup;
group$1.flatRollup = flatRollup;
group$1.groups = groups;
group$1.index = index$c;
group$1.indexes = indexes;
group$1.rollup = rollup;
group$1.rollups = rollups;

var _index$a7 = src$5;

var _identity$2 = _interopRequireDefault$1T(identity$9);

function _interopRequireDefault$1T(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function group(values, ...keys) {
  return nest(values, _identity$2.default, _identity$2.default, keys);
}

function groups(values, ...keys) {
  return nest(values, Array.from, _identity$2.default, keys);
}

function flatten$3(groups, keys) {
  for (let i = 1, n = keys.length; i < n; ++i) {
    groups = groups.flatMap(g => g.pop().map(([key, value]) => [...g, key, value]));
  }

  return groups;
}

function flatGroup(values, ...keys) {
  return flatten$3(groups(values, ...keys), keys);
}

function flatRollup(values, reduce, ...keys) {
  return flatten$3(rollups(values, reduce, ...keys), keys);
}

function rollup(values, reduce, ...keys) {
  return nest(values, _identity$2.default, reduce, keys);
}

function rollups(values, reduce, ...keys) {
  return nest(values, Array.from, reduce, keys);
}

function index$c(values, ...keys) {
  return nest(values, _identity$2.default, unique, keys);
}

function indexes(values, ...keys) {
  return nest(values, Array.from, unique, keys);
}

function unique(values) {
  if (values.length !== 1) throw new Error("duplicate key");
  return values[0];
}

function nest(values, map, reduce, keys) {
  return function regroup(values, i) {
    if (i >= keys.length) return reduce(values);
    const groups = new _index$a7.InternMap();
    const keyof = keys[i++];
    let index = -1;

    for (const value of values) {
      const key = keyof(value, ++index, values);
      const group = groups.get(key);
      if (group) group.push(value);else groups.set(key, [value]);
    }

    for (const [key, values] of groups) {
      groups.set(key, regroup(values, i));
    }

    return map(groups);
  }(values, 0);
}

var groupSort$1 = {};

var sort$1 = {};

var permute$1 = {};

Object.defineProperty(permute$1, "__esModule", {
  value: true
});
permute$1.default = permute;

function permute(source, keys) {
  return Array.from(keys, key => source[key]);
}

Object.defineProperty(sort$1, "__esModule", {
  value: true
});
sort$1.ascendingDefined = ascendingDefined;
sort$1.compareDefined = compareDefined;
sort$1.default = sort;

var _ascending$6 = _interopRequireDefault$1S(ascending$1);

var _permute = _interopRequireDefault$1S(permute$1);

function _interopRequireDefault$1S(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sort(values, ...F) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  values = Array.from(values);
  let [f] = F;

  if (f && f.length !== 2 || F.length > 1) {
    const index = Uint32Array.from(values, (d, i) => i);

    if (F.length > 1) {
      F = F.map(f => values.map(f));
      index.sort((i, j) => {
        for (const f of F) {
          const c = ascendingDefined(f[i], f[j]);
          if (c) return c;
        }
      });
    } else {
      f = values.map(f);
      index.sort((i, j) => ascendingDefined(f[i], f[j]));
    }

    return (0, _permute.default)(values, index);
  }

  return values.sort(compareDefined(f));
}

function compareDefined(compare = _ascending$6.default) {
  if (compare === _ascending$6.default) return ascendingDefined;
  if (typeof compare !== "function") throw new TypeError("compare is not a function");
  return (a, b) => {
    const x = compare(a, b);
    if (x || x === 0) return x;
    return (compare(b, b) === 0) - (compare(a, a) === 0);
  };
}

function ascendingDefined(a, b) {
  return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

Object.defineProperty(groupSort$1, "__esModule", {
  value: true
});
groupSort$1.default = groupSort;

var _ascending$5 = _interopRequireDefault$1R(ascending$1);

var _group = _interopRequireWildcard$E(group$1);

var _sort$2 = _interopRequireDefault$1R(sort$1);

function _getRequireWildcardCache$E(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$E = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$E(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$E(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault$1R(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function groupSort(values, reduce, key) {
  return (reduce.length !== 2 ? (0, _sort$2.default)((0, _group.rollup)(values, reduce, key), ([ak, av], [bk, bv]) => (0, _ascending$5.default)(av, bv) || (0, _ascending$5.default)(ak, bk)) : (0, _sort$2.default)((0, _group.default)(values, key), ([ak, av], [bk, bv]) => reduce(av, bv) || (0, _ascending$5.default)(ak, bk))).map(([key]) => key);
}

var bin$1 = {};

var array$2 = {};

Object.defineProperty(array$2, "__esModule", {
  value: true
});
array$2.slice = array$2.map = void 0;
var array$1 = Array.prototype;
var slice$2 = array$1.slice;
array$2.slice = slice$2;
var map$5 = array$1.map;
array$2.map = map$5;

var constant$3 = {};

Object.defineProperty(constant$3, "__esModule", {
  value: true
});
constant$3.default = constant$2;

function constant$2(x) {
  return () => x;
}

var nice$3 = {};

var ticks$2 = {};

Object.defineProperty(ticks$2, "__esModule", {
  value: true
});
ticks$2.default = ticks$1;
ticks$2.tickIncrement = tickIncrement;
ticks$2.tickStep = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks$1(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;
  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    let r0 = Math.round(start / step),
        r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);

    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step),
        r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);

    while (++i < n) ticks[i] = (r0 + i) / step;
  }

  if (reverse) ticks.reverse();
  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;else if (error >= e5) step1 *= 5;else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

Object.defineProperty(nice$3, "__esModule", {
  value: true
});
nice$3.default = nice$2;

var _ticks$1 = ticks$2;

function nice$2(start, stop, count) {
  let prestep;

  while (true) {
    const step = (0, _ticks$1.tickIncrement)(start, stop, count);

    if (step === prestep || step === 0 || !isFinite(step)) {
      return [start, stop];
    } else if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
    }

    prestep = step;
  }
}

var sturges = {};

Object.defineProperty(sturges, "__esModule", {
  value: true
});
sturges.default = thresholdSturges;

var _count$2 = _interopRequireDefault$1Q(count$1);

function _interopRequireDefault$1Q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function thresholdSturges(values) {
  return Math.ceil(Math.log((0, _count$2.default)(values)) / Math.LN2) + 1;
}

Object.defineProperty(bin$1, "__esModule", {
  value: true
});
bin$1.default = bin;

var _array$1 = array$2;

var _bisect = _interopRequireDefault$1P(bisect);

var _constant$3 = _interopRequireDefault$1P(constant$3);

var _extent = _interopRequireDefault$1P(extent$1);

var _identity$1 = _interopRequireDefault$1P(identity$9);

var _nice$2 = _interopRequireDefault$1P(nice$3);

var _ticks = _interopRequireWildcard$D(ticks$2);

var _sturges = _interopRequireDefault$1P(sturges);

function _getRequireWildcardCache$D(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$D = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$D(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$D(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault$1P(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bin() {
  var value = _identity$1.default,
      domain = _extent.default,
      threshold = _sturges.default;

  function histogram(data) {
    if (!Array.isArray(data)) data = Array.from(data);
    var i,
        n = data.length,
        x,
        step,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
    // default domain accordingly.

    if (!Array.isArray(tz)) {
      const max = x1,
            tn = +tz;
      if (domain === _extent.default) [x0, x1] = (0, _nice$2.default)(x0, x1, tn);
      tz = (0, _ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
      // default), then we can use quantization rather than bisection to bin
      // values, which is substantially faster.

      if (tz[0] <= x0) step = (0, _ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
      // last bin will be zero-width. If the default domain is used, and this
      // last threshold is coincident with the maximum input value, we can
      // extend the niced upper bound by one tick to ensure uniform bin widths;
      // otherwise, we simply remove the last threshold. Note that we don’t
      // coerce values or the domain to numbers, and thus must be careful to
      // compare order (>=) rather than strict equality (===)!

      if (tz[tz.length - 1] >= x1) {
        if (max >= x1 && domain === _extent.default) {
          const step = (0, _ticks.tickIncrement)(x0, x1, tn);

          if (isFinite(step)) {
            if (step > 0) {
              x1 = (Math.floor(x1 / step) + 1) * step;
            } else if (step < 0) {
              x1 = (Math.ceil(x1 * -step) + 1) / -step;
            }
          }
        } else {
          tz.pop();
        }
      }
    } // Remove any thresholds outside the domain.


    var m = tz.length;

    while (tz[0] <= x0) tz.shift(), --m;

    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin; // Initialize bins.

    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    } // Assign data to bins by value, ignoring any outside the domain.


    if (isFinite(step)) {
      if (step > 0) {
        for (i = 0; i < n; ++i) {
          if ((x = values[i]) != null && x0 <= x && x <= x1) {
            bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
          }
        }
      } else if (step < 0) {
        for (i = 0; i < n; ++i) {
          if ((x = values[i]) != null && x0 <= x && x <= x1) {
            const j = Math.floor((x0 - x) * step);
            bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
          }
        }
      }
    } else {
      for (i = 0; i < n; ++i) {
        if ((x = values[i]) != null && x0 <= x && x <= x1) {
          bins[(0, _bisect.default)(tz, x, 0, m)].push(data[i]);
        }
      }
    }

    return bins;
  }

  histogram.value = function (_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant$3.default)(_), histogram) : value;
  };

  histogram.domain = function (_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constant$3.default)([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function (_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constant$3.default)(_array$1.slice.call(_)) : (0, _constant$3.default)(_), histogram) : threshold;
  };

  return histogram;
}

var freedmanDiaconis = {};

var quantile$3 = {};

var max$4 = {};

Object.defineProperty(max$4, "__esModule", {
  value: true
});
max$4.default = max$3;

function max$3(values, valueof) {
  let max;

  if (valueof === undefined) {
    for (const value of values) {
      if (value != null && (max < value || max === undefined && value >= value)) {
        max = value;
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) {
        max = value;
      }
    }
  }

  return max;
}

var min$4 = {};

Object.defineProperty(min$4, "__esModule", {
  value: true
});
min$4.default = min$3;

function min$3(values, valueof) {
  let min;

  if (valueof === undefined) {
    for (const value of values) {
      if (value != null && (min > value || min === undefined && value >= value)) {
        min = value;
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) {
        min = value;
      }
    }
  }

  return min;
}

var quickselect$1 = {};

Object.defineProperty(quickselect$1, "__esModule", {
  value: true
});
quickselect$1.default = quickselect;

var _sort$1 = sort$1;

// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = array.length - 1, compare) {
  compare = compare === undefined ? _sort$1.ascendingDefined : (0, _sort$1.compareDefined)(compare);

  while (right > left) {
    if (right - left > 600) {
      const n = right - left + 1;
      const m = k - left + 1;
      const z = Math.log(n);
      const s = 0.5 * Math.exp(2 * z / 3);
      const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
      const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
      quickselect(array, k, newLeft, newRight, compare);
    }

    const t = array[k];
    let i = left;
    let j = right;
    swap(array, left, k);
    if (compare(array[right], t) > 0) swap(array, left, right);

    while (i < j) {
      swap(array, i, j), ++i, --j;

      while (compare(array[i], t) < 0) ++i;

      while (compare(array[j], t) > 0) --j;
    }

    if (compare(array[left], t) === 0) swap(array, left, j);else ++j, swap(array, j, right);
    if (j <= k) left = j + 1;
    if (k <= j) right = j - 1;
  }

  return array;
}

function swap(array, i, j) {
  const t = array[i];
  array[i] = array[j];
  array[j] = t;
}

Object.defineProperty(quantile$3, "__esModule", {
  value: true
});
quantile$3.default = quantile$2;
quantile$3.quantileSorted = quantileSorted;

var _max$1 = _interopRequireDefault$1O(max$4);

var _min$2 = _interopRequireDefault$1O(min$4);

var _quickselect = _interopRequireDefault$1O(quickselect$1);

var _number$6 = _interopRequireWildcard$C(number$5);

function _getRequireWildcardCache$C(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$C = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$C(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$C(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault$1O(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function quantile$2(values, p, valueof) {
  values = Float64Array.from((0, _number$6.numbers)(values, valueof));
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return (0, _min$2.default)(values);
  if (p >= 1) return (0, _max$1.default)(values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = (0, _max$1.default)((0, _quickselect.default)(values, i0).subarray(0, i0 + 1)),
      value1 = (0, _min$2.default)(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}

function quantileSorted(values, p, valueof = _number$6.default) {
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}

Object.defineProperty(freedmanDiaconis, "__esModule", {
  value: true
});
freedmanDiaconis.default = thresholdFreedmanDiaconis;

var _count$1 = _interopRequireDefault$1N(count$1);

var _quantile$1 = _interopRequireDefault$1N(quantile$3);

function _interopRequireDefault$1N(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function thresholdFreedmanDiaconis(values, min, max) {
  return Math.ceil((max - min) / (2 * ((0, _quantile$1.default)(values, 0.75) - (0, _quantile$1.default)(values, 0.25)) * Math.pow((0, _count$1.default)(values), -1 / 3)));
}

var scott = {};

Object.defineProperty(scott, "__esModule", {
  value: true
});
scott.default = thresholdScott;

var _count = _interopRequireDefault$1M(count$1);

var _deviation = _interopRequireDefault$1M(deviation$1);

function _interopRequireDefault$1M(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function thresholdScott(values, min, max) {
  return Math.ceil((max - min) * Math.cbrt((0, _count.default)(values)) / (3.49 * (0, _deviation.default)(values)));
}

var maxIndex$1 = {};

Object.defineProperty(maxIndex$1, "__esModule", {
  value: true
});
maxIndex$1.default = maxIndex;

function maxIndex(values, valueof) {
  let max;
  let maxIndex = -1;
  let index = -1;

  if (valueof === undefined) {
    for (const value of values) {
      ++index;

      if (value != null && (max < value || max === undefined && value >= value)) {
        max = value, maxIndex = index;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) {
        max = value, maxIndex = index;
      }
    }
  }

  return maxIndex;
}

var mean$1 = {};

Object.defineProperty(mean$1, "__esModule", {
  value: true
});
mean$1.default = mean;

function mean(values, valueof) {
  let count = 0;
  let sum = 0;

  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count, sum += value;
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        ++count, sum += value;
      }
    }
  }

  if (count) return sum / count;
}

var median$1 = {};

Object.defineProperty(median$1, "__esModule", {
  value: true
});
median$1.default = median;

var _quantile = _interopRequireDefault$1L(quantile$3);

function _interopRequireDefault$1L(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function median(values, valueof) {
  return (0, _quantile.default)(values, 0.5, valueof);
}

var merge$2 = {};

Object.defineProperty(merge$2, "__esModule", {
  value: true
});
merge$2.default = merge$1;

function* flatten$2(arrays) {
  for (const array of arrays) {
    yield* array;
  }
}

function merge$1(arrays) {
  return Array.from(flatten$2(arrays));
}

var minIndex$1 = {};

Object.defineProperty(minIndex$1, "__esModule", {
  value: true
});
minIndex$1.default = minIndex;

function minIndex(values, valueof) {
  let min;
  let minIndex = -1;
  let index = -1;

  if (valueof === undefined) {
    for (const value of values) {
      ++index;

      if (value != null && (min > value || min === undefined && value >= value)) {
        min = value, minIndex = index;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) {
        min = value, minIndex = index;
      }
    }
  }

  return minIndex;
}

var mode$1 = {};

Object.defineProperty(mode$1, "__esModule", {
  value: true
});
mode$1.default = mode;

var _index$a6 = src$5;

function mode(values, valueof) {
  const counts = new _index$a6.InternMap();

  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && value >= value) {
        counts.set(value, (counts.get(value) || 0) + 1);
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && value >= value) {
        counts.set(value, (counts.get(value) || 0) + 1);
      }
    }
  }

  let modeValue;
  let modeCount = 0;

  for (const [value, count] of counts) {
    if (count > modeCount) {
      modeCount = count;
      modeValue = value;
    }
  }

  return modeValue;
}

var pairs$1 = {};

Object.defineProperty(pairs$1, "__esModule", {
  value: true
});
pairs$1.default = pairs;
pairs$1.pair = pair;

function pairs(values, pairof = pair) {
  const pairs = [];
  let previous;
  let first = false;

  for (const value of values) {
    if (first) pairs.push(pairof(previous, value));
    previous = value;
    first = true;
  }

  return pairs;
}

function pair(a, b) {
  return [a, b];
}

var range$3 = {};

Object.defineProperty(range$3, "__esModule", {
  value: true
});
range$3.default = range$2;

function range$2(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

var rank$1 = {};

Object.defineProperty(rank$1, "__esModule", {
  value: true
});
rank$1.default = rank;

var _ascending$4 = _interopRequireDefault$1K(ascending$1);

var _sort = sort$1;

function _interopRequireDefault$1K(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rank(values, valueof = _ascending$4.default) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  let V = Array.from(values);
  const R = new Float64Array(V.length);
  if (valueof.length !== 2) V = V.map(valueof), valueof = _ascending$4.default;

  const compareIndex = (i, j) => valueof(V[i], V[j]);

  let k, r;
  Uint32Array.from(V, (_, i) => i).sort(valueof === _ascending$4.default ? (i, j) => (0, _sort.ascendingDefined)(V[i], V[j]) : (0, _sort.compareDefined)(compareIndex)).forEach((j, i) => {
    const c = compareIndex(j, k === undefined ? j : k);

    if (c >= 0) {
      if (k === undefined || c > 0) k = j, r = i;
      R[j] = r;
    } else {
      R[j] = NaN;
    }
  });
  return R;
}

var least$1 = {};

Object.defineProperty(least$1, "__esModule", {
  value: true
});
least$1.default = least;

var _ascending$3 = _interopRequireDefault$1J(ascending$1);

function _interopRequireDefault$1J(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function least(values, compare = _ascending$3.default) {
  let min;
  let defined = false;

  if (compare.length === 1) {
    let minValue;

    for (const element of values) {
      const value = compare(element);

      if (defined ? (0, _ascending$3.default)(value, minValue) < 0 : (0, _ascending$3.default)(value, value) === 0) {
        min = element;
        minValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
        min = value;
        defined = true;
      }
    }
  }

  return min;
}

var leastIndex$1 = {};

Object.defineProperty(leastIndex$1, "__esModule", {
  value: true
});
leastIndex$1.default = leastIndex;

var _ascending$2 = _interopRequireDefault$1I(ascending$1);

var _minIndex = _interopRequireDefault$1I(minIndex$1);

function _interopRequireDefault$1I(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function leastIndex(values, compare = _ascending$2.default) {
  if (compare.length === 1) return (0, _minIndex.default)(values, compare);
  let minValue;
  let min = -1;
  let index = -1;

  for (const value of values) {
    ++index;

    if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
      minValue = value;
      min = index;
    }
  }

  return min;
}

var greatest$1 = {};

Object.defineProperty(greatest$1, "__esModule", {
  value: true
});
greatest$1.default = greatest;

var _ascending$1 = _interopRequireDefault$1H(ascending$1);

function _interopRequireDefault$1H(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function greatest(values, compare = _ascending$1.default) {
  let max;
  let defined = false;

  if (compare.length === 1) {
    let maxValue;

    for (const element of values) {
      const value = compare(element);

      if (defined ? (0, _ascending$1.default)(value, maxValue) > 0 : (0, _ascending$1.default)(value, value) === 0) {
        max = element;
        maxValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
        max = value;
        defined = true;
      }
    }
  }

  return max;
}

var greatestIndex$1 = {};

Object.defineProperty(greatestIndex$1, "__esModule", {
  value: true
});
greatestIndex$1.default = greatestIndex;

var _ascending = _interopRequireDefault$1G(ascending$1);

var _maxIndex = _interopRequireDefault$1G(maxIndex$1);

function _interopRequireDefault$1G(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function greatestIndex(values, compare = _ascending.default) {
  if (compare.length === 1) return (0, _maxIndex.default)(values, compare);
  let maxValue;
  let max = -1;
  let index = -1;

  for (const value of values) {
    ++index;

    if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
      maxValue = value;
      max = index;
    }
  }

  return max;
}

var scan$1 = {};

Object.defineProperty(scan$1, "__esModule", {
  value: true
});
scan$1.default = scan;

var _leastIndex = _interopRequireDefault$1F(leastIndex$1);

function _interopRequireDefault$1F(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scan(values, compare) {
  const index = (0, _leastIndex.default)(values, compare);
  return index < 0 ? undefined : index;
}

var shuffle = {};

Object.defineProperty(shuffle, "__esModule", {
  value: true
});
shuffle.default = void 0;
shuffle.shuffler = shuffler;

var _default$O = shuffler(Math.random);

shuffle.default = _default$O;

function shuffler(random) {
  return function shuffle(array, i0 = 0, i1 = array.length) {
    let m = i1 - (i0 = +i0);

    while (m) {
      const i = random() * m-- | 0,
            t = array[m + i0];
      array[m + i0] = array[i + i0];
      array[i + i0] = t;
    }

    return array;
  };
}

var sum$1 = {};

Object.defineProperty(sum$1, "__esModule", {
  value: true
});
sum$1.default = sum;

function sum(values, valueof) {
  let sum = 0;

  if (valueof === undefined) {
    for (let value of values) {
      if (value = +value) {
        sum += value;
      }
    }
  } else {
    let index = -1;

    for (let value of values) {
      if (value = +valueof(value, ++index, values)) {
        sum += value;
      }
    }
  }

  return sum;
}

var transpose$3 = {};

Object.defineProperty(transpose$3, "__esModule", {
  value: true
});
transpose$3.default = transpose$2;

var _min$1 = _interopRequireDefault$1E(min$4);

function _interopRequireDefault$1E(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transpose$2(matrix) {
  if (!(n = matrix.length)) return [];

  for (var i = -1, m = (0, _min$1.default)(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }

  return transpose;
}

function length(d) {
  return d.length;
}

var zip$1 = {};

Object.defineProperty(zip$1, "__esModule", {
  value: true
});
zip$1.default = zip;

var _transpose = _interopRequireDefault$1D(transpose$3);

function _interopRequireDefault$1D(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function zip() {
  return (0, _transpose.default)(arguments);
}

var every$2 = {};

Object.defineProperty(every$2, "__esModule", {
  value: true
});
every$2.default = every$1;

function every$1(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index = -1;

  for (const value of values) {
    if (!test(value, ++index, values)) {
      return false;
    }
  }

  return true;
}

var some$2 = {};

Object.defineProperty(some$2, "__esModule", {
  value: true
});
some$2.default = some$1;

function some$1(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index = -1;

  for (const value of values) {
    if (test(value, ++index, values)) {
      return true;
    }
  }

  return false;
}

var filter$1 = {};

Object.defineProperty(filter$1, "__esModule", {
  value: true
});
filter$1.default = filter;

function filter(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  const array = [];
  let index = -1;

  for (const value of values) {
    if (test(value, ++index, values)) {
      array.push(value);
    }
  }

  return array;
}

var map$4 = {};

Object.defineProperty(map$4, "__esModule", {
  value: true
});
map$4.default = map$3;

function map$3(values, mapper) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
  return Array.from(values, (value, index) => mapper(value, index, values));
}

var reduce$3 = {};

Object.defineProperty(reduce$3, "__esModule", {
  value: true
});
reduce$3.default = reduce$2;

function reduce$2(values, reducer, value) {
  if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
  const iterator = values[Symbol.iterator]();
  let done,
      next,
      index = -1;

  if (arguments.length < 3) {
    ({
      done,
      value
    } = iterator.next());
    if (done) return;
    ++index;
  }

  while (({
    done,
    value: next
  } = iterator.next()), !done) {
    value = reducer(value, next, ++index, values);
  }

  return value;
}

var reverse$4 = {};

Object.defineProperty(reverse$4, "__esModule", {
  value: true
});
reverse$4.default = reverse$3;

function reverse$3(values) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  return Array.from(values).reverse();
}

var difference$1 = {};

Object.defineProperty(difference$1, "__esModule", {
  value: true
});
difference$1.default = difference;

var _index$a5 = src$5;

function difference(values, ...others) {
  values = new _index$a5.InternSet(values);

  for (const other of others) {
    for (const value of other) {
      values.delete(value);
    }
  }

  return values;
}

var disjoint$1 = {};

Object.defineProperty(disjoint$1, "__esModule", {
  value: true
});
disjoint$1.default = disjoint;

var _index$a4 = src$5;

function disjoint(values, other) {
  const iterator = other[Symbol.iterator](),
        set = new _index$a4.InternSet();

  for (const v of values) {
    if (set.has(v)) return false;
    let value, done;

    while (({
      value,
      done
    } = iterator.next())) {
      if (done) break;
      if (Object.is(v, value)) return false;
      set.add(value);
    }
  }

  return true;
}

var intersection$1 = {};

Object.defineProperty(intersection$1, "__esModule", {
  value: true
});
intersection$1.default = intersection;

var _index$a3 = src$5;

function intersection(values, ...others) {
  values = new _index$a3.InternSet(values);
  others = others.map(set$2);

  out: for (const value of values) {
    for (const other of others) {
      if (!other.has(value)) {
        values.delete(value);
        continue out;
      }
    }
  }

  return values;
}

function set$2(values) {
  return values instanceof _index$a3.InternSet ? values : new _index$a3.InternSet(values);
}

var subset$1 = {};

var superset$1 = {};

Object.defineProperty(superset$1, "__esModule", {
  value: true
});
superset$1.default = superset;

function superset(values, other) {
  const iterator = values[Symbol.iterator](),
        set = new Set();

  for (const o of other) {
    const io = intern(o);
    if (set.has(io)) continue;
    let value, done;

    while (({
      value,
      done
    } = iterator.next())) {
      if (done) return false;
      const ivalue = intern(value);
      set.add(ivalue);
      if (Object.is(io, ivalue)) break;
    }
  }

  return true;
}

function intern(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}

Object.defineProperty(subset$1, "__esModule", {
  value: true
});
subset$1.default = subset;

var _superset = _interopRequireDefault$1C(superset$1);

function _interopRequireDefault$1C(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function subset(values, other) {
  return (0, _superset.default)(other, values);
}

var union$1 = {};

Object.defineProperty(union$1, "__esModule", {
  value: true
});
union$1.default = union;

var _index$a2 = src$5;

function union(...others) {
  const set = new _index$a2.InternSet();

  for (const other of others) {
    for (const o of other) {
      set.add(o);
    }
  }

  return set;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Adder", {
  enumerable: true,
  get: function () {
    return _fsum.Adder;
  }
});
Object.defineProperty(exports, "InternMap", {
  enumerable: true,
  get: function () {
    return _index.InternMap;
  }
});
Object.defineProperty(exports, "InternSet", {
  enumerable: true,
  get: function () {
    return _index.InternSet;
  }
});
Object.defineProperty(exports, "ascending", {
  enumerable: true,
  get: function () {
    return _ascending.default;
  }
});
Object.defineProperty(exports, "bin", {
  enumerable: true,
  get: function () {
    return _bin.default;
  }
});
Object.defineProperty(exports, "bisect", {
  enumerable: true,
  get: function () {
    return _bisect.default;
  }
});
Object.defineProperty(exports, "bisectCenter", {
  enumerable: true,
  get: function () {
    return _bisect.bisectCenter;
  }
});
Object.defineProperty(exports, "bisectLeft", {
  enumerable: true,
  get: function () {
    return _bisect.bisectLeft;
  }
});
Object.defineProperty(exports, "bisectRight", {
  enumerable: true,
  get: function () {
    return _bisect.bisectRight;
  }
});
Object.defineProperty(exports, "bisector", {
  enumerable: true,
  get: function () {
    return _bisector.default;
  }
});
Object.defineProperty(exports, "count", {
  enumerable: true,
  get: function () {
    return _count.default;
  }
});
Object.defineProperty(exports, "cross", {
  enumerable: true,
  get: function () {
    return _cross.default;
  }
});
Object.defineProperty(exports, "cumsum", {
  enumerable: true,
  get: function () {
    return _cumsum.default;
  }
});
Object.defineProperty(exports, "descending", {
  enumerable: true,
  get: function () {
    return _descending.default;
  }
});
Object.defineProperty(exports, "deviation", {
  enumerable: true,
  get: function () {
    return _deviation.default;
  }
});
Object.defineProperty(exports, "difference", {
  enumerable: true,
  get: function () {
    return _difference.default;
  }
});
Object.defineProperty(exports, "disjoint", {
  enumerable: true,
  get: function () {
    return _disjoint.default;
  }
});
Object.defineProperty(exports, "every", {
  enumerable: true,
  get: function () {
    return _every.default;
  }
});
Object.defineProperty(exports, "extent", {
  enumerable: true,
  get: function () {
    return _extent.default;
  }
});
Object.defineProperty(exports, "fcumsum", {
  enumerable: true,
  get: function () {
    return _fsum.fcumsum;
  }
});
Object.defineProperty(exports, "filter", {
  enumerable: true,
  get: function () {
    return _filter.default;
  }
});
Object.defineProperty(exports, "flatGroup", {
  enumerable: true,
  get: function () {
    return _group.flatGroup;
  }
});
Object.defineProperty(exports, "flatRollup", {
  enumerable: true,
  get: function () {
    return _group.flatRollup;
  }
});
Object.defineProperty(exports, "fsum", {
  enumerable: true,
  get: function () {
    return _fsum.fsum;
  }
});
Object.defineProperty(exports, "greatest", {
  enumerable: true,
  get: function () {
    return _greatest.default;
  }
});
Object.defineProperty(exports, "greatestIndex", {
  enumerable: true,
  get: function () {
    return _greatestIndex.default;
  }
});
Object.defineProperty(exports, "group", {
  enumerable: true,
  get: function () {
    return _group.default;
  }
});
Object.defineProperty(exports, "groupSort", {
  enumerable: true,
  get: function () {
    return _groupSort.default;
  }
});
Object.defineProperty(exports, "groups", {
  enumerable: true,
  get: function () {
    return _group.groups;
  }
});
Object.defineProperty(exports, "histogram", {
  enumerable: true,
  get: function () {
    return _bin.default;
  }
});
Object.defineProperty(exports, "index", {
  enumerable: true,
  get: function () {
    return _group.index;
  }
});
Object.defineProperty(exports, "indexes", {
  enumerable: true,
  get: function () {
    return _group.indexes;
  }
});
Object.defineProperty(exports, "intersection", {
  enumerable: true,
  get: function () {
    return _intersection.default;
  }
});
Object.defineProperty(exports, "least", {
  enumerable: true,
  get: function () {
    return _least.default;
  }
});
Object.defineProperty(exports, "leastIndex", {
  enumerable: true,
  get: function () {
    return _leastIndex.default;
  }
});
Object.defineProperty(exports, "map", {
  enumerable: true,
  get: function () {
    return _map.default;
  }
});
Object.defineProperty(exports, "max", {
  enumerable: true,
  get: function () {
    return _max.default;
  }
});
Object.defineProperty(exports, "maxIndex", {
  enumerable: true,
  get: function () {
    return _maxIndex.default;
  }
});
Object.defineProperty(exports, "mean", {
  enumerable: true,
  get: function () {
    return _mean.default;
  }
});
Object.defineProperty(exports, "median", {
  enumerable: true,
  get: function () {
    return _median.default;
  }
});
Object.defineProperty(exports, "merge", {
  enumerable: true,
  get: function () {
    return _merge.default;
  }
});
Object.defineProperty(exports, "min", {
  enumerable: true,
  get: function () {
    return _min.default;
  }
});
Object.defineProperty(exports, "minIndex", {
  enumerable: true,
  get: function () {
    return _minIndex.default;
  }
});
Object.defineProperty(exports, "mode", {
  enumerable: true,
  get: function () {
    return _mode.default;
  }
});
Object.defineProperty(exports, "nice", {
  enumerable: true,
  get: function () {
    return _nice.default;
  }
});
Object.defineProperty(exports, "pairs", {
  enumerable: true,
  get: function () {
    return _pairs.default;
  }
});
Object.defineProperty(exports, "permute", {
  enumerable: true,
  get: function () {
    return _permute.default;
  }
});
Object.defineProperty(exports, "quantile", {
  enumerable: true,
  get: function () {
    return _quantile.default;
  }
});
Object.defineProperty(exports, "quantileSorted", {
  enumerable: true,
  get: function () {
    return _quantile.quantileSorted;
  }
});
Object.defineProperty(exports, "quickselect", {
  enumerable: true,
  get: function () {
    return _quickselect.default;
  }
});
Object.defineProperty(exports, "range", {
  enumerable: true,
  get: function () {
    return _range.default;
  }
});
Object.defineProperty(exports, "rank", {
  enumerable: true,
  get: function () {
    return _rank.default;
  }
});
Object.defineProperty(exports, "reduce", {
  enumerable: true,
  get: function () {
    return _reduce.default;
  }
});
Object.defineProperty(exports, "reverse", {
  enumerable: true,
  get: function () {
    return _reverse.default;
  }
});
Object.defineProperty(exports, "rollup", {
  enumerable: true,
  get: function () {
    return _group.rollup;
  }
});
Object.defineProperty(exports, "rollups", {
  enumerable: true,
  get: function () {
    return _group.rollups;
  }
});
Object.defineProperty(exports, "scan", {
  enumerable: true,
  get: function () {
    return _scan.default;
  }
});
Object.defineProperty(exports, "shuffle", {
  enumerable: true,
  get: function () {
    return _shuffle.default;
  }
});
Object.defineProperty(exports, "shuffler", {
  enumerable: true,
  get: function () {
    return _shuffle.shuffler;
  }
});
Object.defineProperty(exports, "some", {
  enumerable: true,
  get: function () {
    return _some.default;
  }
});
Object.defineProperty(exports, "sort", {
  enumerable: true,
  get: function () {
    return _sort.default;
  }
});
Object.defineProperty(exports, "subset", {
  enumerable: true,
  get: function () {
    return _subset.default;
  }
});
Object.defineProperty(exports, "sum", {
  enumerable: true,
  get: function () {
    return _sum.default;
  }
});
Object.defineProperty(exports, "superset", {
  enumerable: true,
  get: function () {
    return _superset.default;
  }
});
Object.defineProperty(exports, "thresholdFreedmanDiaconis", {
  enumerable: true,
  get: function () {
    return _freedmanDiaconis.default;
  }
});
Object.defineProperty(exports, "thresholdScott", {
  enumerable: true,
  get: function () {
    return _scott.default;
  }
});
Object.defineProperty(exports, "thresholdSturges", {
  enumerable: true,
  get: function () {
    return _sturges.default;
  }
});
Object.defineProperty(exports, "tickIncrement", {
  enumerable: true,
  get: function () {
    return _ticks.tickIncrement;
  }
});
Object.defineProperty(exports, "tickStep", {
  enumerable: true,
  get: function () {
    return _ticks.tickStep;
  }
});
Object.defineProperty(exports, "ticks", {
  enumerable: true,
  get: function () {
    return _ticks.default;
  }
});
Object.defineProperty(exports, "transpose", {
  enumerable: true,
  get: function () {
    return _transpose.default;
  }
});
Object.defineProperty(exports, "union", {
  enumerable: true,
  get: function () {
    return _union.default;
  }
});
Object.defineProperty(exports, "variance", {
  enumerable: true,
  get: function () {
    return _variance.default;
  }
});
Object.defineProperty(exports, "zip", {
  enumerable: true,
  get: function () {
    return _zip.default;
  }
});

var _bisect = _interopRequireWildcard(bisect);

var _ascending = _interopRequireDefault(ascending$1);

var _bisector = _interopRequireDefault(bisector$1);

var _count = _interopRequireDefault(count$1);

var _cross = _interopRequireDefault(cross$1);

var _cumsum = _interopRequireDefault(cumsum$1);

var _descending = _interopRequireDefault(descending$1);

var _deviation = _interopRequireDefault(deviation$1);

var _extent = _interopRequireDefault(extent$1);

var _fsum = fsum$1;

var _group = _interopRequireWildcard(group$1);

var _groupSort = _interopRequireDefault(groupSort$1);

var _bin = _interopRequireDefault(bin$1);

var _freedmanDiaconis = _interopRequireDefault(freedmanDiaconis);

var _scott = _interopRequireDefault(scott);

var _sturges = _interopRequireDefault(sturges);

var _max = _interopRequireDefault(max$4);

var _maxIndex = _interopRequireDefault(maxIndex$1);

var _mean = _interopRequireDefault(mean$1);

var _median = _interopRequireDefault(median$1);

var _merge = _interopRequireDefault(merge$2);

var _min = _interopRequireDefault(min$4);

var _minIndex = _interopRequireDefault(minIndex$1);

var _mode = _interopRequireDefault(mode$1);

var _nice = _interopRequireDefault(nice$3);

var _pairs = _interopRequireDefault(pairs$1);

var _permute = _interopRequireDefault(permute$1);

var _quantile = _interopRequireWildcard(quantile$3);

var _quickselect = _interopRequireDefault(quickselect$1);

var _range = _interopRequireDefault(range$3);

var _rank = _interopRequireDefault(rank$1);

var _least = _interopRequireDefault(least$1);

var _leastIndex = _interopRequireDefault(leastIndex$1);

var _greatest = _interopRequireDefault(greatest$1);

var _greatestIndex = _interopRequireDefault(greatestIndex$1);

var _scan = _interopRequireDefault(scan$1);

var _shuffle = _interopRequireWildcard(shuffle);

var _sum = _interopRequireDefault(sum$1);

var _ticks = _interopRequireWildcard(ticks$2);

var _transpose = _interopRequireDefault(transpose$3);

var _variance = _interopRequireDefault(variance$1);

var _zip = _interopRequireDefault(zip$1);

var _every = _interopRequireDefault(every$2);

var _some = _interopRequireDefault(some$2);

var _filter = _interopRequireDefault(filter$1);

var _map = _interopRequireDefault(map$4);

var _reduce = _interopRequireDefault(reduce$3);

var _reverse = _interopRequireDefault(reverse$4);

var _sort = _interopRequireDefault(sort$1);

var _difference = _interopRequireDefault(difference$1);

var _disjoint = _interopRequireDefault(disjoint$1);

var _intersection = _interopRequireDefault(intersection$1);

var _subset = _interopRequireDefault(subset$1);

var _superset = _interopRequireDefault(superset$1);

var _union = _interopRequireDefault(union$1);

var _index = src$5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
}(src$6));

var init$1 = {};

Object.defineProperty(init$1, "__esModule", {
  value: true
});
init$1.initInterpolator = initInterpolator;
init$1.initRange = initRange;

function initRange(domain, range) {
  switch (arguments.length) {
    case 0:
      break;

    case 1:
      this.range(domain);
      break;

    default:
      this.range(range).domain(domain);
      break;
  }

  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;

    case 1:
      {
        if (typeof domain === "function") this.interpolator(domain);else this.range(domain);
        break;
      }

    default:
      {
        this.domain(domain);
        if (typeof interpolator === "function") this.interpolator(interpolator);else this.range(interpolator);
        break;
      }
  }

  return this;
}

var ordinal$1 = {};

Object.defineProperty(ordinal$1, "__esModule", {
  value: true
});
ordinal$1.default = ordinal;
ordinal$1.implicit = void 0;

var _index$a1 = src$6;

var _init$e = init$1;

const implicit = Symbol("implicit");
ordinal$1.implicit = implicit;

function ordinal() {
  var index = new _index$a1.InternMap(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    let i = index.get(d);

    if (i === undefined) {
      if (unknown !== implicit) return unknown;
      index.set(d, i = domain.push(d) - 1);
    }

    return range[i % range.length];
  }

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new _index$a1.InternMap();

    for (const value of _) {
      if (index.has(value)) continue;
      index.set(value, domain.push(value) - 1);
    }

    return scale;
  };

  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return ordinal(domain, range).unknown(unknown);
  };

  _init$e.initRange.apply(scale, arguments);

  return scale;
}

Object.defineProperty(band$1, "__esModule", {
  value: true
});
band$1.default = band;
band$1.point = point;

var _index$a0 = src$6;

var _init$d = init$1;

var _ordinal = _interopRequireDefault$1B(ordinal$1);

function _interopRequireDefault$1B(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function band() {
  var scale = (0, _ordinal.default)().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      r0 = 0,
      r1 = 1,
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;
  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = r1 < r0,
        start = reverse ? r1 : r0,
        stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = (0, _index$a0.range)(n).map(function (i) {
      return start + step * i;
    });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function (_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };

  scale.rangeRound = function (_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };

  scale.bandwidth = function () {
    return bandwidth;
  };

  scale.step = function () {
    return step;
  };

  scale.round = function (_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function (_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function (_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function (_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function (_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function () {
    return band(domain(), [r0, r1]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };

  return _init$d.initRange.apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;
  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function () {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

var identity$7 = {};

var linear$2 = {};

var continuous$1 = {};

var src$4 = {};

var value = {};

var src$3 = {};

var color$2 = {};

var define = {};

Object.defineProperty(define, "__esModule", {
  value: true
});
define.default = _default$N;
define.extend = extend;

function _default$N(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);

  for (var key in definition) prototype[key] = definition[key];

  return prototype;
}

Object.defineProperty(color$2, "__esModule", {
  value: true
});
color$2.Color = Color;
color$2.Rgb = Rgb;
color$2.darker = color$2.brighter = void 0;
color$2.default = color$1;
color$2.hsl = hsl$2;
color$2.hslConvert = hslConvert;
color$2.rgb = rgb$1;
color$2.rgbConvert = rgbConvert;

var _define$2 = _interopRequireWildcard$B(define);

function _getRequireWildcardCache$B(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$B = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$B(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$B(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Color() {}

var darker = 0.7;
color$2.darker = darker;
var brighter = 1 / darker;
color$2.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`),
    reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`),
    reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`),
    reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`),
    reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`),
    reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};
(0, _define$2.default)(Color, color$1, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },

  displayable() {
    return this.rgb().displayable();
  },

  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHex8() {
  return this.rgb().formatHex8();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color$1(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
  : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
  : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
  : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
  : null // invalid hex
  ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
  : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
  : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
  : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
  : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
  : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
  : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
  : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color$1(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb$1(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

(0, _define$2.default)(Rgb, rgb$1, (0, _define$2.extend)(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },

  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },

  rgb() {
    return this;
  },

  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },

  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },

  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}

function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}

function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}

function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}

function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}

function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;else if (l <= 0 || l >= 1) h = s = NaN;else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color$1(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;

  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;else if (g === max) h = (b - r) / s + 2;else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }

  return new Hsl(h, s, l, o.opacity);
}

function hsl$2(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

(0, _define$2.default)(Hsl, hsl$2, (0, _define$2.extend)(Color, {
  brighter(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },

  darker(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },

  rgb() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
  },

  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },

  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },

  formatHsl() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }

}));

function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}

function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */


function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

var lab$3 = {};

var math = {};

Object.defineProperty(math, "__esModule", {
  value: true
});
math.radians = math.degrees = void 0;
const radians = Math.PI / 180;
math.radians = radians;
const degrees$1 = 180 / Math.PI;
math.degrees = degrees$1;

Object.defineProperty(lab$3, "__esModule", {
  value: true
});
lab$3.Hcl = Hcl;
lab$3.Lab = Lab;
lab$3.default = lab$2;
lab$3.gray = gray;
lab$3.hcl = hcl$2;
lab$3.lch = lch;

var _define$1 = _interopRequireWildcard$A(define);

var _color$7 = color$2;

var _math$1 = math;

function _getRequireWildcardCache$A(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$A = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$A(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$A(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18,
      Xn = 0.96422,
      Yn = 1,
      Zn = 0.82521,
      t0$1 = 4 / 29,
      t1$1 = 6 / 29,
      t2 = 3 * t1$1 * t1$1,
      t3 = t1$1 * t1$1 * t1$1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof _color$7.Rgb)) o = (0, _color$7.rgbConvert)(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn),
      x,
      z;
  if (r === g && g === b) x = z = y;else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab$2(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

(0, _define$1.default)(Lab, lab$2, (0, _define$1.extend)(_color$7.Color, {
  brighter(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },

  darker(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },

  rgb() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new _color$7.Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
  }

}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0$1;
}

function lab2xyz(t) {
  return t > t1$1 ? t * t * t : t2 * (t - t0$1);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);

  var h = Math.atan2(o.b, o.a) * _math$1.degrees;

  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl$2(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * _math$1.radians;
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

(0, _define$1.default)(Hcl, hcl$2, (0, _define$1.extend)(_color$7.Color, {
  brighter(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },

  darker(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },

  rgb() {
    return hcl2lab(this).rgb();
  }

}));

var cubehelix$3 = {};

Object.defineProperty(cubehelix$3, "__esModule", {
  value: true
});
cubehelix$3.Cubehelix = Cubehelix;
cubehelix$3.default = cubehelix$2;

var _define = _interopRequireWildcard$z(define);

var _color$6 = color$2;

var _math = math;

function _getRequireWildcardCache$z(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$z = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$z(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$z(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof _color$6.Rgb)) o = (0, _color$6.rgbConvert)(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)),
      // NaN if l=0 or l=1
  h = s ? Math.atan2(k, bl) * _math.degrees - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix$2(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

(0, _define.default)(Cubehelix, cubehelix$2, (0, _define.extend)(_color$6.Color, {
  brighter(k) {
    k = k == null ? _color$6.brighter : Math.pow(_color$6.brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },

  darker(k) {
    k = k == null ? _color$6.darker : Math.pow(_color$6.darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },

  rgb() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * _math.radians,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new _color$6.Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
  }

}));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "color", {
  enumerable: true,
  get: function () {
    return _color.default;
  }
});
Object.defineProperty(exports, "cubehelix", {
  enumerable: true,
  get: function () {
    return _cubehelix.default;
  }
});
Object.defineProperty(exports, "gray", {
  enumerable: true,
  get: function () {
    return _lab.gray;
  }
});
Object.defineProperty(exports, "hcl", {
  enumerable: true,
  get: function () {
    return _lab.hcl;
  }
});
Object.defineProperty(exports, "hsl", {
  enumerable: true,
  get: function () {
    return _color.hsl;
  }
});
Object.defineProperty(exports, "lab", {
  enumerable: true,
  get: function () {
    return _lab.default;
  }
});
Object.defineProperty(exports, "lch", {
  enumerable: true,
  get: function () {
    return _lab.lch;
  }
});
Object.defineProperty(exports, "rgb", {
  enumerable: true,
  get: function () {
    return _color.rgb;
  }
});

var _color = _interopRequireWildcard(color$2);

var _lab = _interopRequireWildcard(lab$3);

var _cubehelix = _interopRequireDefault(cubehelix$3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
}(src$3));

var rgb = {};

var basis$1 = {};

Object.defineProperty(basis$1, "__esModule", {
  value: true
});
basis$1.basis = basis;
basis$1.default = _default$M;

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1,
      t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

function _default$M(values) {
  var n = values.length - 1;
  return function (t) {
    var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

var basisClosed = {};

Object.defineProperty(basisClosed, "__esModule", {
  value: true
});
basisClosed.default = _default$L;

var _basis$1 = basis$1;

function _default$L(values) {
  var n = values.length;
  return function (t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return (0, _basis$1.basis)((t - i / n) * n, v0, v1, v2, v3);
  };
}

var color = {};

var constant$1 = {};

Object.defineProperty(constant$1, "__esModule", {
  value: true
});
constant$1.default = void 0;

var _default$K = x => () => x;

constant$1.default = _default$K;

Object.defineProperty(color, "__esModule", {
  value: true
});
color.default = nogamma;
color.gamma = gamma;
color.hue = hue$1;

var _constant$2 = _interopRequireDefault$1A(constant$1);

function _interopRequireDefault$1A(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function linear$1(a, d) {
  return function (t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function (t) {
    return Math.pow(a + t * b, y);
  };
}

function hue$1(a, b) {
  var d = b - a;
  return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constant$2.default)(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function (a, b) {
    return b - a ? exponential(a, b, y) : (0, _constant$2.default)(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : (0, _constant$2.default)(isNaN(a) ? b : a);
}

Object.defineProperty(rgb, "__esModule", {
  value: true
});
rgb.rgbBasisClosed = rgb.rgbBasis = rgb.default = void 0;

var _index$9$ = src$3;

var _basis = _interopRequireDefault$1z(basis$1);

var _basisClosed = _interopRequireDefault$1z(basisClosed);

var _color$5 = _interopRequireWildcard$y(color);

function _getRequireWildcardCache$y(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$y = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$y(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$y(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault$1z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default$J = function rgbGamma(y) {
  var color = (0, _color$5.gamma)(y);

  function rgb(start, end) {
    var r = color((start = (0, _index$9$.rgb)(start)).r, (end = (0, _index$9$.rgb)(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = (0, _color$5.default)(start.opacity, end.opacity);
    return function (t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;
  return rgb;
}(1);

rgb.default = _default$J;

function rgbSpline(spline) {
  return function (colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i,
        color;

    for (i = 0; i < n; ++i) {
      color = (0, _index$9$.rgb)(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }

    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function (t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(_basis.default);
rgb.rgbBasis = rgbBasis;
var rgbBasisClosed = rgbSpline(_basisClosed.default);
rgb.rgbBasisClosed = rgbBasisClosed;

var array = {};

var numberArray = {};

Object.defineProperty(numberArray, "__esModule", {
  value: true
});
numberArray.default = _default$I;
numberArray.isNumberArray = isNumberArray;

function _default$I(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function (t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;

    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

Object.defineProperty(array, "__esModule", {
  value: true
});
array.default = _default$H;
array.genericArray = genericArray;

var _value$2 = _interopRequireDefault$1y(value);

var _numberArray$1 = _interopRequireWildcard$x(numberArray);

function _getRequireWildcardCache$x(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$x = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$x(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$x(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault$1y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$H(a, b) {
  return ((0, _numberArray$1.isNumberArray)(b) ? _numberArray$1.default : genericArray)(a, b);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = (0, _value$2.default)(a[i], b[i]);

  for (; i < nb; ++i) c[i] = b[i];

  return function (t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);

    return c;
  };
}

var date$1 = {};

Object.defineProperty(date$1, "__esModule", {
  value: true
});
date$1.default = _default$G;

function _default$G(a, b) {
  var d = new Date();
  return a = +a, b = +b, function (t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

var number$3 = {};

Object.defineProperty(number$3, "__esModule", {
  value: true
});
number$3.default = _default$F;

function _default$F(a, b) {
  return a = +a, b = +b, function (t) {
    return a * (1 - t) + b * t;
  };
}

var object = {};

Object.defineProperty(object, "__esModule", {
  value: true
});
object.default = _default$E;

var _value$1 = _interopRequireDefault$1x(value);

function _interopRequireDefault$1x(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$E(a, b) {
  var i = {},
      c = {},
      k;
  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = (0, _value$1.default)(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function (t) {
    for (k in i) c[k] = i[k](t);

    return c;
  };
}

var string = {};

Object.defineProperty(string, "__esModule", {
  value: true
});
string.default = _default$D;

var _number$5 = _interopRequireDefault$1w(number$3);

function _interopRequireDefault$1w(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function () {
    return b;
  };
}

function one(b) {
  return function (t) {
    return b(t) + "";
  };
}

function _default$D(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0,
      // scan index for next number in b
  am,
      // current match in a
  bm,
      // current match in b
  bs,
      // string preceding current number in b, if any
  i = -1,
      // index in s
  s = [],
      // string constants and placeholders
  q = []; // number interpolators
  // Coerce inputs to strings.

  a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.

  while ((am = reA.exec(a)) && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) {
      // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }

    if ((am = am[0]) === (bm = bm[0])) {
      // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else {
      // interpolate non-matching numbers
      s[++i] = null;
      q.push({
        i: i,
        x: (0, _number$5.default)(am, bm)
      });
    }

    bi = reB.lastIndex;
  } // Add remains of b.


  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  } // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.


  return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function (t) {
    for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);

    return s.join("");
  });
}

Object.defineProperty(value, "__esModule", {
  value: true
});
value.default = _default$C;

var _index$9_ = src$3;

var _rgb = _interopRequireDefault$1v(rgb);

var _array = array;

var _date = _interopRequireDefault$1v(date$1);

var _number$4 = _interopRequireDefault$1v(number$3);

var _object = _interopRequireDefault$1v(object);

var _string = _interopRequireDefault$1v(string);

var _constant$1 = _interopRequireDefault$1v(constant$1);

var _numberArray = _interopRequireWildcard$w(numberArray);

function _getRequireWildcardCache$w(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$w = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$w(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$w(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault$1v(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$C(a, b) {
  var t = typeof b,
      c;
  return b == null || t === "boolean" ? (0, _constant$1.default)(b) : (t === "number" ? _number$4.default : t === "string" ? (c = (0, _index$9_.color)(b)) ? (b = c, _rgb.default) : _string.default : b instanceof _index$9_.color ? _rgb.default : b instanceof Date ? _date.default : (0, _numberArray.isNumberArray)(b) ? _numberArray.default : Array.isArray(b) ? _array.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? _object.default : _number$4.default)(a, b);
}

var discrete = {};

Object.defineProperty(discrete, "__esModule", {
  value: true
});
discrete.default = _default$B;

function _default$B(range) {
  var n = range.length;
  return function (t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

var hue = {};

Object.defineProperty(hue, "__esModule", {
  value: true
});
hue.default = _default$A;

var _color$4 = color;

function _default$A(a, b) {
  var i = (0, _color$4.hue)(+a, +b);
  return function (t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
}

var round = {};

Object.defineProperty(round, "__esModule", {
  value: true
});
round.default = _default$z;

function _default$z(a, b) {
  return a = +a, b = +b, function (t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

var transform = {};

var parse$2 = {};

var decompose = {};

Object.defineProperty(decompose, "__esModule", {
  value: true
});
decompose.default = _default$y;
decompose.identity = void 0;
var degrees = 180 / Math.PI;
var identity$6 = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
decompose.identity = identity$6;

function _default$y(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
}

Object.defineProperty(parse$2, "__esModule", {
  value: true
});
parse$2.parseCss = parseCss;
parse$2.parseSvg = parseSvg;

var _decompose = _interopRequireWildcard$v(decompose);

function _getRequireWildcardCache$v(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$v = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$v(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$v(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var svgNode;
/* eslint-disable no-undef */

function parseCss(value) {
  const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
  return m.isIdentity ? _decompose.identity : (0, _decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}

function parseSvg(value) {
  if (value == null) return _decompose.identity;
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return _decompose.identity;
  value = value.matrix;
  return (0, _decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

Object.defineProperty(transform, "__esModule", {
  value: true
});
transform.interpolateTransformSvg = transform.interpolateTransformCss = void 0;

var _number$3 = _interopRequireDefault$1u(number$3);

var _parse = parse$2;

function _interopRequireDefault$1u(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function interpolateTransform(parse, pxComma, pxParen, degParen) {
  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({
        i: i - 4,
        x: (0, _number$3.default)(xa, xb)
      }, {
        i: i - 2,
        x: (0, _number$3.default)(ya, yb)
      });
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360;else if (b - a > 180) a += 360; // shortest path

      q.push({
        i: s.push(pop(s) + "rotate(", null, degParen) - 2,
        x: (0, _number$3.default)(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({
        i: s.push(pop(s) + "skewX(", null, degParen) - 2,
        x: (0, _number$3.default)(a, b)
      });
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: (0, _number$3.default)(xa, xb)
      }, {
        i: i - 2,
        x: (0, _number$3.default)(ya, yb)
      });
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function (a, b) {
    var s = [],
        // string constants and placeholders
    q = []; // number interpolators

    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc

    return function (t) {
      var i = -1,
          n = q.length,
          o;

      while (++i < n) s[(o = q[i]).i] = o.x(t);

      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(_parse.parseCss, "px, ", "px)", "deg)");
transform.interpolateTransformCss = interpolateTransformCss;
var interpolateTransformSvg = interpolateTransform(_parse.parseSvg, ", ", ")", ")");
transform.interpolateTransformSvg = interpolateTransformSvg;

var zoom = {};

Object.defineProperty(zoom, "__esModule", {
  value: true
});
zoom.default = void 0;
var epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

var _default$x = function zoomRho(rho, rho2, rho4) {
  // p0 = [ux0, uy0, w0]
  // p1 = [ux1, uy1, w1]
  function zoom(p0, p1) {
    var ux0 = p0[0],
        uy0 = p0[1],
        w0 = p0[2],
        ux1 = p1[0],
        uy1 = p1[1],
        w1 = p1[2],
        dx = ux1 - ux0,
        dy = uy1 - uy0,
        d2 = dx * dx + dy * dy,
        i,
        S; // Special case for u0 ≅ u1.

    if (d2 < epsilon2) {
      S = Math.log(w1 / w0) / rho;

      i = function (t) {
        return [ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(rho * t * S)];
      };
    } // General case.
    else {
      var d1 = Math.sqrt(d2),
          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;

      i = function (t) {
        var s = t * S,
            coshr0 = cosh(r0),
            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / cosh(rho * s + r0)];
      };
    }

    i.duration = S * 1000 * rho / Math.SQRT2;
    return i;
  }

  zoom.rho = function (_) {
    var _1 = Math.max(1e-3, +_),
        _2 = _1 * _1,
        _4 = _2 * _2;

    return zoomRho(_1, _2, _4);
  };

  return zoom;
}(Math.SQRT2, 2, 4);

zoom.default = _default$x;

var hsl$1 = {};

Object.defineProperty(hsl$1, "__esModule", {
  value: true
});
hsl$1.hslLong = hsl$1.default = void 0;

var _index$9Z = src$3;

var _color$3 = _interopRequireWildcard$u(color);

function _getRequireWildcardCache$u(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$u = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$u(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$u(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function hsl(hue) {
  return function (start, end) {
    var h = hue((start = (0, _index$9Z.hsl)(start)).h, (end = (0, _index$9Z.hsl)(end)).h),
        s = (0, _color$3.default)(start.s, end.s),
        l = (0, _color$3.default)(start.l, end.l),
        opacity = (0, _color$3.default)(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}

var _default$w = hsl(_color$3.hue);

hsl$1.default = _default$w;
var hslLong = hsl(_color$3.default);
hsl$1.hslLong = hslLong;

var lab$1 = {};

Object.defineProperty(lab$1, "__esModule", {
  value: true
});
lab$1.default = lab;

var _index$9Y = src$3;

var _color$2 = _interopRequireDefault$1t(color);

function _interopRequireDefault$1t(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function lab(start, end) {
  var l = (0, _color$2.default)((start = (0, _index$9Y.lab)(start)).l, (end = (0, _index$9Y.lab)(end)).l),
      a = (0, _color$2.default)(start.a, end.a),
      b = (0, _color$2.default)(start.b, end.b),
      opacity = (0, _color$2.default)(start.opacity, end.opacity);
  return function (t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}

var hcl$1 = {};

Object.defineProperty(hcl$1, "__esModule", {
  value: true
});
hcl$1.hclLong = hcl$1.default = void 0;

var _index$9X = src$3;

var _color$1 = _interopRequireWildcard$t(color);

function _getRequireWildcardCache$t(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$t = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$t(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$t(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function hcl(hue) {
  return function (start, end) {
    var h = hue((start = (0, _index$9X.hcl)(start)).h, (end = (0, _index$9X.hcl)(end)).h),
        c = (0, _color$1.default)(start.c, end.c),
        l = (0, _color$1.default)(start.l, end.l),
        opacity = (0, _color$1.default)(start.opacity, end.opacity);
    return function (t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}

var _default$v = hcl(_color$1.hue);

hcl$1.default = _default$v;
var hclLong = hcl(_color$1.default);
hcl$1.hclLong = hclLong;

var cubehelix$1 = {};

Object.defineProperty(cubehelix$1, "__esModule", {
  value: true
});
cubehelix$1.default = cubehelix$1.cubehelixLong = void 0;

var _index$9W = src$3;

var _color = _interopRequireWildcard$s(color);

function _getRequireWildcardCache$s(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$s = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$s(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$s(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function cubehelix(hue) {
  return function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = (0, _index$9W.cubehelix)(start)).h, (end = (0, _index$9W.cubehelix)(end)).h),
          s = (0, _color.default)(start.s, end.s),
          l = (0, _color.default)(start.l, end.l),
          opacity = (0, _color.default)(start.opacity, end.opacity);
      return function (t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;
    return cubehelix;
  }(1);
}

var _default$u = cubehelix(_color.hue);

cubehelix$1.default = _default$u;
var cubehelixLong = cubehelix(_color.default);
cubehelix$1.cubehelixLong = cubehelixLong;

var piecewise$1 = {};

Object.defineProperty(piecewise$1, "__esModule", {
  value: true
});
piecewise$1.default = piecewise;

var _value = _interopRequireDefault$1s(value);

function _interopRequireDefault$1s(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function piecewise(interpolate, values) {
  if (values === undefined) values = interpolate, interpolate = _value.default;
  var i = 0,
      n = values.length - 1,
      v = values[0],
      I = new Array(n < 0 ? 0 : n);

  while (i < n) I[i] = interpolate(v, v = values[++i]);

  return function (t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}

var quantize$2 = {};

Object.defineProperty(quantize$2, "__esModule", {
  value: true
});
quantize$2.default = _default$t;

function _default$t(interpolator, n) {
  var samples = new Array(n);

  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));

  return samples;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "interpolate", {
  enumerable: true,
  get: function () {
    return _value.default;
  }
});
Object.defineProperty(exports, "interpolateArray", {
  enumerable: true,
  get: function () {
    return _array.default;
  }
});
Object.defineProperty(exports, "interpolateBasis", {
  enumerable: true,
  get: function () {
    return _basis.default;
  }
});
Object.defineProperty(exports, "interpolateBasisClosed", {
  enumerable: true,
  get: function () {
    return _basisClosed.default;
  }
});
Object.defineProperty(exports, "interpolateCubehelix", {
  enumerable: true,
  get: function () {
    return _cubehelix.default;
  }
});
Object.defineProperty(exports, "interpolateCubehelixLong", {
  enumerable: true,
  get: function () {
    return _cubehelix.cubehelixLong;
  }
});
Object.defineProperty(exports, "interpolateDate", {
  enumerable: true,
  get: function () {
    return _date.default;
  }
});
Object.defineProperty(exports, "interpolateDiscrete", {
  enumerable: true,
  get: function () {
    return _discrete.default;
  }
});
Object.defineProperty(exports, "interpolateHcl", {
  enumerable: true,
  get: function () {
    return _hcl.default;
  }
});
Object.defineProperty(exports, "interpolateHclLong", {
  enumerable: true,
  get: function () {
    return _hcl.hclLong;
  }
});
Object.defineProperty(exports, "interpolateHsl", {
  enumerable: true,
  get: function () {
    return _hsl.default;
  }
});
Object.defineProperty(exports, "interpolateHslLong", {
  enumerable: true,
  get: function () {
    return _hsl.hslLong;
  }
});
Object.defineProperty(exports, "interpolateHue", {
  enumerable: true,
  get: function () {
    return _hue.default;
  }
});
Object.defineProperty(exports, "interpolateLab", {
  enumerable: true,
  get: function () {
    return _lab.default;
  }
});
Object.defineProperty(exports, "interpolateNumber", {
  enumerable: true,
  get: function () {
    return _number.default;
  }
});
Object.defineProperty(exports, "interpolateNumberArray", {
  enumerable: true,
  get: function () {
    return _numberArray.default;
  }
});
Object.defineProperty(exports, "interpolateObject", {
  enumerable: true,
  get: function () {
    return _object.default;
  }
});
Object.defineProperty(exports, "interpolateRgb", {
  enumerable: true,
  get: function () {
    return _rgb.default;
  }
});
Object.defineProperty(exports, "interpolateRgbBasis", {
  enumerable: true,
  get: function () {
    return _rgb.rgbBasis;
  }
});
Object.defineProperty(exports, "interpolateRgbBasisClosed", {
  enumerable: true,
  get: function () {
    return _rgb.rgbBasisClosed;
  }
});
Object.defineProperty(exports, "interpolateRound", {
  enumerable: true,
  get: function () {
    return _round.default;
  }
});
Object.defineProperty(exports, "interpolateString", {
  enumerable: true,
  get: function () {
    return _string.default;
  }
});
Object.defineProperty(exports, "interpolateTransformCss", {
  enumerable: true,
  get: function () {
    return _index.interpolateTransformCss;
  }
});
Object.defineProperty(exports, "interpolateTransformSvg", {
  enumerable: true,
  get: function () {
    return _index.interpolateTransformSvg;
  }
});
Object.defineProperty(exports, "interpolateZoom", {
  enumerable: true,
  get: function () {
    return _zoom.default;
  }
});
Object.defineProperty(exports, "piecewise", {
  enumerable: true,
  get: function () {
    return _piecewise.default;
  }
});
Object.defineProperty(exports, "quantize", {
  enumerable: true,
  get: function () {
    return _quantize.default;
  }
});

var _value = _interopRequireDefault(value);

var _array = _interopRequireDefault(array);

var _basis = _interopRequireDefault(basis$1);

var _basisClosed = _interopRequireDefault(basisClosed);

var _date = _interopRequireDefault(date$1);

var _discrete = _interopRequireDefault(discrete);

var _hue = _interopRequireDefault(hue);

var _number = _interopRequireDefault(number$3);

var _numberArray = _interopRequireDefault(numberArray);

var _object = _interopRequireDefault(object);

var _round = _interopRequireDefault(round);

var _string = _interopRequireDefault(string);

var _index = transform;

var _zoom = _interopRequireDefault(zoom);

var _rgb = _interopRequireWildcard(rgb);

var _hsl = _interopRequireWildcard(hsl$1);

var _lab = _interopRequireDefault(lab$1);

var _hcl = _interopRequireWildcard(hcl$1);

var _cubehelix = _interopRequireWildcard(cubehelix$1);

var _piecewise = _interopRequireDefault(piecewise$1);

var _quantize = _interopRequireDefault(quantize$2);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
}(src$4));

var constant = {};

Object.defineProperty(constant, "__esModule", {
  value: true
});
constant.default = constants$2;

function constants$2(x) {
  return function () {
    return x;
  };
}

var number$2 = {};

Object.defineProperty(number$2, "__esModule", {
  value: true
});
number$2.default = number$1;

function number$1(x) {
  return +x;
}

Object.defineProperty(continuous$1, "__esModule", {
  value: true
});
continuous$1.copy = copy$1;
continuous$1.default = continuous;
continuous$1.identity = identity$5;
continuous$1.transformer = transformer$2;

var _index$9V = src$6;

var _index2$4u = src$4;

var _constant = _interopRequireDefault$1r(constant);

var _number$2 = _interopRequireDefault$1r(number$2);

function _interopRequireDefault$1r(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unit = [0, 1];

function identity$5(x) {
  return x;
}

function normalize(a, b) {
  return (b -= a = +a) ? function (x) {
    return (x - a) / b;
  } : (0, _constant.default)(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function (x) {
    return Math.max(a, Math.min(b, x));
  };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].


function bimap(domain, range, interpolate) {
  var d0 = domain[0],
      d1 = domain[1],
      r0 = range[0],
      r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function (x) {
    return r0(d0(x));
  };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1; // Reverse descending domains.

  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function (x) {
    var i = (0, _index$9V.bisect)(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy$1(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}

function transformer$2() {
  var domain = unit,
      range = unit,
      interpolate = _index2$4u.interpolate,
      transform,
      untransform,
      unknown,
      clamp = identity$5,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$5) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function (y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), _index2$4u.interpolateNumber)))(y)));
  };

  scale.domain = function (_) {
    return arguments.length ? (domain = Array.from(_, _number$2.default), rescale()) : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function (_) {
    return range = Array.from(_), interpolate = _index2$4u.interpolateRound, rescale();
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = _ ? true : identity$5, rescale()) : clamp !== identity$5;
  };

  scale.interpolate = function (_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function (t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer$2()(identity$5, identity$5);
}

var tickFormat$1 = {};

var src$2 = {};

var defaultLocale$4 = {};

var locale$4 = {};

var exponent = {};

var formatDecimal = {};

Object.defineProperty(formatDecimal, "__esModule", {
  value: true
});
formatDecimal.default = _default$s;
formatDecimal.formatDecimalParts = formatDecimalParts;

function _default$s(x) {
  return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].


function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity

  var i,
      coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).

  return [coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient, +x.slice(i + 1)];
}

Object.defineProperty(exponent, "__esModule", {
  value: true
});
exponent.default = _default$r;

var _formatDecimal$3 = formatDecimal;

function _default$r(x) {
  return x = (0, _formatDecimal$3.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

var formatGroup = {};

Object.defineProperty(formatGroup, "__esModule", {
  value: true
});
formatGroup.default = _default$q;

function _default$q(grouping, thousands) {
  return function (value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

var formatNumerals = {};

Object.defineProperty(formatNumerals, "__esModule", {
  value: true
});
formatNumerals.default = _default$p;

function _default$p(numerals) {
  return function (value) {
    return value.replace(/[0-9]/g, function (i) {
      return numerals[+i];
    });
  };
}

var formatSpecifier$1 = {};

Object.defineProperty(formatSpecifier$1, "__esModule", {
  value: true
});
formatSpecifier$1.FormatSpecifier = FormatSpecifier;
formatSpecifier$1.default = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function () {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

var formatTrim = {};

Object.defineProperty(formatTrim, "__esModule", {
  value: true
});
formatTrim.default = _default$o;

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function _default$o(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".":
        i0 = i1 = i;
        break;

      case "0":
        if (i0 === 0) i0 = i;
        i1 = i;
        break;

      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }

  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var formatTypes = {};

var formatPrefixAuto = {};

Object.defineProperty(formatPrefixAuto, "__esModule", {
  value: true
});
formatPrefixAuto.default = _default$n;
formatPrefixAuto.prefixExponent = void 0;

var _formatDecimal$2 = formatDecimal;

var prefixExponent;
formatPrefixAuto.prefixExponent = prefixExponent;

function _default$n(x, p) {
  var d = (0, _formatDecimal$2.formatDecimalParts)(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (formatPrefixAuto.prefixExponent = prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimal$2.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

var formatRounded = {};

Object.defineProperty(formatRounded, "__esModule", {
  value: true
});
formatRounded.default = _default$m;

var _formatDecimal$1 = formatDecimal;

function _default$m(x, p) {
  var d = (0, _formatDecimal$1.formatDecimalParts)(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

Object.defineProperty(formatTypes, "__esModule", {
  value: true
});
formatTypes.default = void 0;

var _formatDecimal = _interopRequireDefault$1q(formatDecimal);

var _formatPrefixAuto$1 = _interopRequireDefault$1q(formatPrefixAuto);

var _formatRounded = _interopRequireDefault$1q(formatRounded);

function _interopRequireDefault$1q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default$l = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": x => Math.round(x).toString(2),
  "c": x => x + "",
  "d": _formatDecimal.default,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": x => Math.round(x).toString(8),
  "p": (x, p) => (0, _formatRounded.default)(x * 100, p),
  "r": _formatRounded.default,
  "s": _formatPrefixAuto$1.default,
  "X": x => Math.round(x).toString(16).toUpperCase(),
  "x": x => Math.round(x).toString(16)
};
formatTypes.default = _default$l;

var identity$4 = {};

Object.defineProperty(identity$4, "__esModule", {
  value: true
});
identity$4.default = _default$k;

function _default$k(x) {
  return x;
}

Object.defineProperty(locale$4, "__esModule", {
  value: true
});
locale$4.default = _default$j;

var _exponent$3 = _interopRequireDefault$1p(exponent);

var _formatGroup = _interopRequireDefault$1p(formatGroup);

var _formatNumerals = _interopRequireDefault$1p(formatNumerals);

var _formatSpecifier = _interopRequireDefault$1p(formatSpecifier$1);

var _formatTrim = _interopRequireDefault$1p(formatTrim);

var _formatTypes = _interopRequireDefault$1p(formatTypes);

var _formatPrefixAuto = formatPrefixAuto;

var _identity = _interopRequireDefault$1p(identity$4);

function _interopRequireDefault$1p(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var map$2 = Array.prototype.map,
    prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];

function _default$j(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? _identity.default : (0, _formatGroup.default)(map$2.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? _identity.default : (0, _formatNumerals.default)(map$2.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = (0, _formatSpecifier.default)(specifier);
    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type; // The "n" type is an alias for ",g".

    if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.

    if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.

    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?

    var formatType = _formatTypes.default[type],
        maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].

    precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i,
          n,
          c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!

        var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.

        value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.

        if (trim) value = (0, _formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.

        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.

        valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + _formatPrefixAuto.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.

        if (maybeSuffix) {
          i = -1, n = value.length;

          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      } // If the fill character is not "0", grouping is applied before padding.


      if (comma && !zero) value = group(value, Infinity); // Compute the padding.

      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.

      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.

      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;

        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;

        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;

        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }

      return numerals(value);
    }

    format.toString = function () {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = (0, _formatSpecifier.default)(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor((0, _exponent$3.default)(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function (value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

Object.defineProperty(defaultLocale$4, "__esModule", {
  value: true
});
defaultLocale$4.default = defaultLocale$3;
defaultLocale$4.formatPrefix = defaultLocale$4.format = void 0;

var _locale$1 = _interopRequireDefault$1o(locale$4);

function _interopRequireDefault$1o(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale$3;
var format$1;
defaultLocale$4.format = format$1;
var formatPrefix;
defaultLocale$4.formatPrefix = formatPrefix;
defaultLocale$3({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale$3(definition) {
  locale$3 = (0, _locale$1.default)(definition);
  defaultLocale$4.format = format$1 = locale$3.format;
  defaultLocale$4.formatPrefix = formatPrefix = locale$3.formatPrefix;
  return locale$3;
}

var precisionFixed = {};

Object.defineProperty(precisionFixed, "__esModule", {
  value: true
});
precisionFixed.default = _default$i;

var _exponent$2 = _interopRequireDefault$1n(exponent);

function _interopRequireDefault$1n(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$i(step) {
  return Math.max(0, -(0, _exponent$2.default)(Math.abs(step)));
}

var precisionPrefix = {};

Object.defineProperty(precisionPrefix, "__esModule", {
  value: true
});
precisionPrefix.default = _default$h;

var _exponent$1 = _interopRequireDefault$1m(exponent);

function _interopRequireDefault$1m(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$h(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponent$1.default)(value) / 3))) * 3 - (0, _exponent$1.default)(Math.abs(step)));
}

var precisionRound = {};

Object.defineProperty(precisionRound, "__esModule", {
  value: true
});
precisionRound.default = _default$g;

var _exponent = _interopRequireDefault$1l(exponent);

function _interopRequireDefault$1l(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _default$g(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, (0, _exponent.default)(max) - (0, _exponent.default)(step)) + 1;
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FormatSpecifier", {
  enumerable: true,
  get: function () {
    return _formatSpecifier.FormatSpecifier;
  }
});
Object.defineProperty(exports, "format", {
  enumerable: true,
  get: function () {
    return _defaultLocale.format;
  }
});
Object.defineProperty(exports, "formatDefaultLocale", {
  enumerable: true,
  get: function () {
    return _defaultLocale.default;
  }
});
Object.defineProperty(exports, "formatLocale", {
  enumerable: true,
  get: function () {
    return _locale.default;
  }
});
Object.defineProperty(exports, "formatPrefix", {
  enumerable: true,
  get: function () {
    return _defaultLocale.formatPrefix;
  }
});
Object.defineProperty(exports, "formatSpecifier", {
  enumerable: true,
  get: function () {
    return _formatSpecifier.default;
  }
});
Object.defineProperty(exports, "precisionFixed", {
  enumerable: true,
  get: function () {
    return _precisionFixed.default;
  }
});
Object.defineProperty(exports, "precisionPrefix", {
  enumerable: true,
  get: function () {
    return _precisionPrefix.default;
  }
});
Object.defineProperty(exports, "precisionRound", {
  enumerable: true,
  get: function () {
    return _precisionRound.default;
  }
});

var _defaultLocale = _interopRequireWildcard(defaultLocale$4);

var _locale = _interopRequireDefault(locale$4);

var _formatSpecifier = _interopRequireWildcard(formatSpecifier$1);

var _precisionFixed = _interopRequireDefault(precisionFixed);

var _precisionPrefix = _interopRequireDefault(precisionPrefix);

var _precisionRound = _interopRequireDefault(precisionRound);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
}(src$2));

Object.defineProperty(tickFormat$1, "__esModule", {
  value: true
});
tickFormat$1.default = tickFormat;

var _index$9U = src$6;

var _index2$4t = src$2;

function tickFormat(start, stop, count, specifier) {
  var step = (0, _index$9U.tickStep)(start, stop, count),
      precision;
  specifier = (0, _index2$4t.formatSpecifier)(specifier == null ? ",f" : specifier);

  switch (specifier.type) {
    case "s":
      {
        var value = Math.max(Math.abs(start), Math.abs(stop));
        if (specifier.precision == null && !isNaN(precision = (0, _index2$4t.precisionPrefix)(step, value))) specifier.precision = precision;
        return (0, _index2$4t.formatPrefix)(specifier, value);
      }

    case "":
    case "e":
    case "g":
    case "p":
    case "r":
      {
        if (specifier.precision == null && !isNaN(precision = (0, _index2$4t.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
        break;
      }

    case "f":
    case "%":
      {
        if (specifier.precision == null && !isNaN(precision = (0, _index2$4t.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
        break;
      }
  }

  return (0, _index2$4t.format)(specifier);
}

Object.defineProperty(linear$2, "__esModule", {
  value: true
});
linear$2.default = linear;
linear$2.linearish = linearish;

var _index$9T = src$6;

var _continuous$8 = _interopRequireWildcard$r(continuous$1);

var _init$c = init$1;

var _tickFormat = _interopRequireDefault$1k(tickFormat$1);

function _interopRequireDefault$1k(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache$r(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$r = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$r(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$r(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function (count) {
    var d = domain();
    return (0, _index$9T.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function (count, specifier) {
    var d = domain();
    return (0, _tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function (count) {
    if (count == null) count = 10;
    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    while (maxIter-- > 0) {
      step = (0, _index$9T.tickIncrement)(start, stop, count);

      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }

      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = (0, _continuous$8.default)();

  scale.copy = function () {
    return (0, _continuous$8.copy)(scale, linear());
  };

  _init$c.initRange.apply(scale, arguments);

  return linearish(scale);
}

Object.defineProperty(identity$7, "__esModule", {
  value: true
});
identity$7.default = identity$3;

var _linear$6 = linear$2;

var _number$1 = _interopRequireDefault$1j(number$2);

function _interopRequireDefault$1j(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function identity$3(domain) {
  var unknown;

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function (_) {
    return arguments.length ? (domain = Array.from(_, _number$1.default), scale) : domain.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return identity$3(domain).unknown(unknown);
  };

  domain = arguments.length ? Array.from(domain, _number$1.default) : [0, 1];
  return (0, _linear$6.linearish)(scale);
}

var log$2 = {};

var nice$1 = {};

Object.defineProperty(nice$1, "__esModule", {
  value: true
});
nice$1.default = nice;

function nice(domain, interval) {
  domain = domain.slice();
  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

Object.defineProperty(log$2, "__esModule", {
  value: true
});
log$2.default = log$1;
log$2.loggish = loggish;

var _index$9S = src$6;

var _index2$4s = src$2;

var _nice$1 = _interopRequireDefault$1i(nice$1);

var _continuous$7 = continuous$1;

var _init$b = init$1;

function _interopRequireDefault$1i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10 : base === Math.E ? Math.exp : x => Math.pow(base, x);
}

function logp(base) {
  return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), x => Math.log(x) / base);
}

function reflect(f) {
  return (x, k) => -f(-x, k);
}

function loggish(transform) {
  const scale = transform(transformLog, transformExp);
  const domain = scale.domain;
  let base = 10;
  let logs;
  let pows;

  function rescale() {
    logs = logp(base), pows = powp(base);

    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }

    return scale;
  }

  scale.base = function (_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function (_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = count => {
    const d = domain();
    let u = d[0];
    let v = d[d.length - 1];
    const r = v < u;
    if (r) [u, v] = [v, u];
    let i = logs(u);
    let j = logs(v);
    let k;
    let t;
    const n = count == null ? 10 : +count;
    let z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0) for (; i <= j; ++i) {
        for (k = 1; k < base; ++k) {
          t = i < 0 ? k / pows(-i) : k * pows(i);
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i <= j; ++i) {
        for (k = base - 1; k >= 1; --k) {
          t = i > 0 ? k / pows(-i) : k * pows(i);
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = (0, _index$9S.ticks)(u, v, n);
    } else {
      z = (0, _index$9S.ticks)(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = (count, specifier) => {
    if (count == null) count = 10;
    if (specifier == null) specifier = base === 10 ? "s" : ",";

    if (typeof specifier !== "function") {
      if (!(base % 1) && (specifier = (0, _index2$4s.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
      specifier = (0, _index2$4s.format)(specifier);
    }

    if (count === Infinity) return specifier;
    const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?

    return d => {
      let i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = () => {
    return domain((0, _nice$1.default)(domain(), {
      floor: x => pows(Math.floor(logs(x))),
      ceil: x => pows(Math.ceil(logs(x)))
    }));
  };

  return scale;
}

function log$1() {
  const scale = loggish((0, _continuous$7.transformer)()).domain([1, 10]);

  scale.copy = () => (0, _continuous$7.copy)(scale, log$1()).base(scale.base());

  _init$b.initRange.apply(scale, arguments);

  return scale;
}

var symlog$1 = {};

Object.defineProperty(symlog$1, "__esModule", {
  value: true
});
symlog$1.default = symlog;
symlog$1.symlogish = symlogish;

var _linear$5 = linear$2;

var _continuous$6 = continuous$1;

var _init$a = init$1;

function transformSymlog(c) {
  return function (x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}

function transformSymexp(c) {
  return function (x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}

function symlogish(transform) {
  var c = 1,
      scale = transform(transformSymlog(c), transformSymexp(c));

  scale.constant = function (_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };

  return (0, _linear$5.linearish)(scale);
}

function symlog() {
  var scale = symlogish((0, _continuous$6.transformer)());

  scale.copy = function () {
    return (0, _continuous$6.copy)(scale, symlog()).constant(scale.constant());
  };

  return _init$a.initRange.apply(scale, arguments);
}

var pow$1 = {};

Object.defineProperty(pow$1, "__esModule", {
  value: true
});
pow$1.default = pow;
pow$1.powish = powish;
pow$1.sqrt = sqrt;

var _linear$4 = linear$2;

var _continuous$5 = continuous$1;

var _init$9 = init$1;

function transformPow(exponent) {
  return function (x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}

function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}

function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}

function powish(transform) {
  var scale = transform(_continuous$5.identity, _continuous$5.identity),
      exponent = 1;

  function rescale() {
    return exponent === 1 ? transform(_continuous$5.identity, _continuous$5.identity) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
  }

  scale.exponent = function (_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };

  return (0, _linear$4.linearish)(scale);
}

function pow() {
  var scale = powish((0, _continuous$5.transformer)());

  scale.copy = function () {
    return (0, _continuous$5.copy)(scale, pow()).exponent(scale.exponent());
  };

  _init$9.initRange.apply(scale, arguments);

  return scale;
}

function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}

var radial$1 = {};

Object.defineProperty(radial$1, "__esModule", {
  value: true
});
radial$1.default = radial;

var _continuous$4 = _interopRequireDefault$1h(continuous$1);

var _init$8 = init$1;

var _linear$3 = linear$2;

var _number = _interopRequireDefault$1h(number$2);

function _interopRequireDefault$1h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function square(x) {
  return Math.sign(x) * x * x;
}

function unsquare(x) {
  return Math.sign(x) * Math.sqrt(Math.abs(x));
}

function radial() {
  var squared = (0, _continuous$4.default)(),
      range = [0, 1],
      round = false,
      unknown;

  function scale(x) {
    var y = unsquare(squared(x));
    return isNaN(y) ? unknown : round ? Math.round(y) : y;
  }

  scale.invert = function (y) {
    return squared.invert(square(y));
  };

  scale.domain = function (_) {
    return arguments.length ? (squared.domain(_), scale) : squared.domain();
  };

  scale.range = function (_) {
    return arguments.length ? (squared.range((range = Array.from(_, _number.default)).map(square)), scale) : range.slice();
  };

  scale.rangeRound = function (_) {
    return scale.range(_).round(true);
  };

  scale.round = function (_) {
    return arguments.length ? (round = !!_, scale) : round;
  };

  scale.clamp = function (_) {
    return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
  };

  _init$8.initRange.apply(scale, arguments);

  return (0, _linear$3.linearish)(scale);
}

var quantile$1 = {};

Object.defineProperty(quantile$1, "__esModule", {
  value: true
});
quantile$1.default = quantile;

var _index$9R = src$6;

var _init$7 = init$1;

function quantile() {
  var domain = [],
      range = [],
      thresholds = [],
      unknown;

  function rescale() {
    var i = 0,
        n = Math.max(1, range.length);
    thresholds = new Array(n - 1);

    while (++i < n) thresholds[i - 1] = (0, _index$9R.quantileSorted)(domain, i / n);

    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : range[(0, _index$9R.bisect)(thresholds, x)];
  }

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [i > 0 ? thresholds[i - 1] : domain[0], i < thresholds.length ? thresholds[i] : domain[domain.length - 1]];
  };

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [];

    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);

    domain.sort(_index$9R.ascending);
    return rescale();
  };

  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.quantiles = function () {
    return thresholds.slice();
  };

  scale.copy = function () {
    return quantile().domain(domain).range(range).unknown(unknown);
  };

  return _init$7.initRange.apply(scale, arguments);
}

var quantize$1 = {};

Object.defineProperty(quantize$1, "__esModule", {
  value: true
});
quantize$1.default = quantize;

var _index$9Q = src$6;

var _linear$2 = linear$2;

var _init$6 = init$1;

function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1],
      unknown;

  function scale(x) {
    return x != null && x <= x ? range[(0, _index$9Q.bisect)(domain, x, 0, n)] : unknown;
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);

    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);

    return scale;
  }

  scale.domain = function (_) {
    return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
  };

  scale.range = function (_) {
    return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : i < 1 ? [x0, domain[0]] : i >= n ? [domain[n - 1], x1] : [domain[i - 1], domain[i]];
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };

  scale.thresholds = function () {
    return domain.slice();
  };

  scale.copy = function () {
    return quantize().domain([x0, x1]).range(range).unknown(unknown);
  };

  return _init$6.initRange.apply((0, _linear$2.linearish)(scale), arguments);
}

var threshold$1 = {};

Object.defineProperty(threshold$1, "__esModule", {
  value: true
});
threshold$1.default = threshold;

var _index$9P = src$6;

var _init$5 = init$1;

function threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x != null && x <= x ? range[(0, _index$9P.bisect)(domain, x, 0, n)] : unknown;
  }

  scale.domain = function (_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function (_) {
    return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function (y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function () {
    return threshold().domain(domain).range(range).unknown(unknown);
  };

  return _init$5.initRange.apply(scale, arguments);
}

var time$1 = {};

var src$1 = {};

var interval$2 = {};

Object.defineProperty(interval$2, "__esModule", {
  value: true
});
interval$2.default = newInterval;
var t0 = new Date(),
    t1 = new Date();

function newInterval(floori, offseti, count, field) {
  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
  }

  interval.floor = function (date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function (date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function (date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function (date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function (start, stop, step) {
    var range = [],
        previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date

    do range.push(previous = new Date(+start)), offseti(start, step), floori(start); while (previous < start && start < stop);

    return range;
  };

  interval.filter = function (test) {
    return newInterval(function (date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function (date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty

        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty

        }
      }
    });
  };

  if (count) {
    interval.count = function (start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function (step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function (d) {
        return field(d) % step === 0;
      } : function (d) {
        return interval.count(0, d) % step === 0;
      });
    };
  }

  return interval;
}

var millisecond$1 = {};

Object.defineProperty(millisecond$1, "__esModule", {
  value: true
});
millisecond$1.milliseconds = millisecond$1.default = void 0;

var _interval$d = _interopRequireDefault$1g(interval$2);

function _interopRequireDefault$1g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var millisecond = (0, _interval$d.default)(function () {// noop
}, function (date, step) {
  date.setTime(+date + step);
}, function (start, end) {
  return end - start;
}); // An optimized implementation for this simple case.

millisecond.every = function (k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return (0, _interval$d.default)(function (date) {
    date.setTime(Math.floor(date / k) * k);
  }, function (date, step) {
    date.setTime(+date + step * k);
  }, function (start, end) {
    return (end - start) / k;
  });
};

var _default$f = millisecond;
millisecond$1.default = _default$f;
var milliseconds$2 = millisecond.range;
millisecond$1.milliseconds = milliseconds$2;

var second$1 = {};

var duration = {};

Object.defineProperty(duration, "__esModule", {
  value: true
});
duration.durationYear = duration.durationWeek = duration.durationSecond = duration.durationMonth = duration.durationMinute = duration.durationHour = duration.durationDay = void 0;
const durationSecond = 1000;
duration.durationSecond = durationSecond;
const durationMinute = durationSecond * 60;
duration.durationMinute = durationMinute;
const durationHour = durationMinute * 60;
duration.durationHour = durationHour;
const durationDay = durationHour * 24;
duration.durationDay = durationDay;
const durationWeek = durationDay * 7;
duration.durationWeek = durationWeek;
const durationMonth = durationDay * 30;
duration.durationMonth = durationMonth;
const durationYear = durationDay * 365;
duration.durationYear = durationYear;

Object.defineProperty(second$1, "__esModule", {
  value: true
});
second$1.seconds = second$1.default = void 0;

var _interval$c = _interopRequireDefault$1f(interval$2);

var _duration$9 = duration;

function _interopRequireDefault$1f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var second = (0, _interval$c.default)(function (date) {
  date.setTime(date - date.getMilliseconds());
}, function (date, step) {
  date.setTime(+date + step * _duration$9.durationSecond);
}, function (start, end) {
  return (end - start) / _duration$9.durationSecond;
}, function (date) {
  return date.getUTCSeconds();
});
var _default$e = second;
second$1.default = _default$e;
var seconds = second.range;
second$1.seconds = seconds;

var minute$1 = {};

Object.defineProperty(minute$1, "__esModule", {
  value: true
});
minute$1.minutes = minute$1.default = void 0;

var _interval$b = _interopRequireDefault$1e(interval$2);

var _duration$8 = duration;

function _interopRequireDefault$1e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minute = (0, _interval$b.default)(function (date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration$8.durationSecond);
}, function (date, step) {
  date.setTime(+date + step * _duration$8.durationMinute);
}, function (start, end) {
  return (end - start) / _duration$8.durationMinute;
}, function (date) {
  return date.getMinutes();
});
var _default$d = minute;
minute$1.default = _default$d;
var minutes = minute.range;
minute$1.minutes = minutes;

var hour$1 = {};

Object.defineProperty(hour$1, "__esModule", {
  value: true
});
hour$1.hours = hour$1.default = void 0;

var _interval$a = _interopRequireDefault$1d(interval$2);

var _duration$7 = duration;

function _interopRequireDefault$1d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hour = (0, _interval$a.default)(function (date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration$7.durationSecond - date.getMinutes() * _duration$7.durationMinute);
}, function (date, step) {
  date.setTime(+date + step * _duration$7.durationHour);
}, function (start, end) {
  return (end - start) / _duration$7.durationHour;
}, function (date) {
  return date.getHours();
});
var _default$c = hour;
hour$1.default = _default$c;
var hours = hour.range;
hour$1.hours = hours;

var day$1 = {};

Object.defineProperty(day$1, "__esModule", {
  value: true
});
day$1.default = day$1.days = void 0;

var _interval$9 = _interopRequireDefault$1c(interval$2);

var _duration$6 = duration;

function _interopRequireDefault$1c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var day = (0, _interval$9.default)(date => date.setHours(0, 0, 0, 0), (date, step) => date.setDate(date.getDate() + step), (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration$6.durationMinute) / _duration$6.durationDay, date => date.getDate() - 1);
var _default$b = day;
day$1.default = _default$b;
var days$1 = day.range;
day$1.days = days$1;

var week$1 = {};

Object.defineProperty(week$1, "__esModule", {
  value: true
});
week$1.wednesdays = week$1.wednesday = week$1.tuesdays = week$1.tuesday = week$1.thursdays = week$1.thursday = week$1.sundays = week$1.sunday = week$1.saturdays = week$1.saturday = week$1.mondays = week$1.monday = week$1.fridays = week$1.friday = void 0;

var _interval$8 = _interopRequireDefault$1b(interval$2);

var _duration$5 = duration;

function _interopRequireDefault$1b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function weekday(i) {
  return (0, _interval$8.default)(function (date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function (start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration$5.durationMinute) / _duration$5.durationWeek;
  });
}

var sunday = weekday(0);
week$1.sunday = sunday;
var monday = weekday(1);
week$1.monday = monday;
var tuesday = weekday(2);
week$1.tuesday = tuesday;
var wednesday = weekday(3);
week$1.wednesday = wednesday;
var thursday = weekday(4);
week$1.thursday = thursday;
var friday = weekday(5);
week$1.friday = friday;
var saturday = weekday(6);
week$1.saturday = saturday;
var sundays = sunday.range;
week$1.sundays = sundays;
var mondays = monday.range;
week$1.mondays = mondays;
var tuesdays = tuesday.range;
week$1.tuesdays = tuesdays;
var wednesdays = wednesday.range;
week$1.wednesdays = wednesdays;
var thursdays = thursday.range;
week$1.thursdays = thursdays;
var fridays = friday.range;
week$1.fridays = fridays;
var saturdays = saturday.range;
week$1.saturdays = saturdays;

var month$1 = {};

Object.defineProperty(month$1, "__esModule", {
  value: true
});
month$1.months = month$1.default = void 0;

var _interval$7 = _interopRequireDefault$1a(interval$2);

function _interopRequireDefault$1a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var month = (0, _interval$7.default)(function (date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function (date, step) {
  date.setMonth(date.getMonth() + step);
}, function (start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function (date) {
  return date.getMonth();
});
var _default$a = month;
month$1.default = _default$a;
var months$1 = month.range;
month$1.months = months$1;

var year$1 = {};

Object.defineProperty(year$1, "__esModule", {
  value: true
});
year$1.years = year$1.default = void 0;

var _interval$6 = _interopRequireDefault$19(interval$2);

function _interopRequireDefault$19(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var year = (0, _interval$6.default)(function (date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function (date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function (start, end) {
  return end.getFullYear() - start.getFullYear();
}, function (date) {
  return date.getFullYear();
}); // An optimized implementation for this simple case.

year.every = function (k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval$6.default)(function (date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var _default$9 = year;
year$1.default = _default$9;
var years = year.range;
year$1.years = years;

var utcMinute$1 = {};

Object.defineProperty(utcMinute$1, "__esModule", {
  value: true
});
utcMinute$1.utcMinutes = utcMinute$1.default = void 0;

var _interval$5 = _interopRequireDefault$18(interval$2);

var _duration$4 = duration;

function _interopRequireDefault$18(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utcMinute = (0, _interval$5.default)(function (date) {
  date.setUTCSeconds(0, 0);
}, function (date, step) {
  date.setTime(+date + step * _duration$4.durationMinute);
}, function (start, end) {
  return (end - start) / _duration$4.durationMinute;
}, function (date) {
  return date.getUTCMinutes();
});
var _default$8 = utcMinute;
utcMinute$1.default = _default$8;
var utcMinutes = utcMinute.range;
utcMinute$1.utcMinutes = utcMinutes;

var utcHour$1 = {};

Object.defineProperty(utcHour$1, "__esModule", {
  value: true
});
utcHour$1.utcHours = utcHour$1.default = void 0;

var _interval$4 = _interopRequireDefault$17(interval$2);

var _duration$3 = duration;

function _interopRequireDefault$17(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utcHour = (0, _interval$4.default)(function (date) {
  date.setUTCMinutes(0, 0, 0);
}, function (date, step) {
  date.setTime(+date + step * _duration$3.durationHour);
}, function (start, end) {
  return (end - start) / _duration$3.durationHour;
}, function (date) {
  return date.getUTCHours();
});
var _default$7 = utcHour;
utcHour$1.default = _default$7;
var utcHours = utcHour.range;
utcHour$1.utcHours = utcHours;

var utcDay$1 = {};

Object.defineProperty(utcDay$1, "__esModule", {
  value: true
});
utcDay$1.utcDays = utcDay$1.default = void 0;

var _interval$3 = _interopRequireDefault$16(interval$2);

var _duration$2 = duration;

function _interopRequireDefault$16(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utcDay = (0, _interval$3.default)(function (date) {
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function (start, end) {
  return (end - start) / _duration$2.durationDay;
}, function (date) {
  return date.getUTCDate() - 1;
});
var _default$6 = utcDay;
utcDay$1.default = _default$6;
var utcDays = utcDay.range;
utcDay$1.utcDays = utcDays;

var utcWeek = {};

Object.defineProperty(utcWeek, "__esModule", {
  value: true
});
utcWeek.utcWednesdays = utcWeek.utcWednesday = utcWeek.utcTuesdays = utcWeek.utcTuesday = utcWeek.utcThursdays = utcWeek.utcThursday = utcWeek.utcSundays = utcWeek.utcSunday = utcWeek.utcSaturdays = utcWeek.utcSaturday = utcWeek.utcMondays = utcWeek.utcMonday = utcWeek.utcFridays = utcWeek.utcFriday = void 0;

var _interval$2 = _interopRequireDefault$15(interval$2);

var _duration$1 = duration;

function _interopRequireDefault$15(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function utcWeekday(i) {
  return (0, _interval$2.default)(function (date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function (start, end) {
    return (end - start) / _duration$1.durationWeek;
  });
}

var utcSunday = utcWeekday(0);
utcWeek.utcSunday = utcSunday;
var utcMonday = utcWeekday(1);
utcWeek.utcMonday = utcMonday;
var utcTuesday = utcWeekday(2);
utcWeek.utcTuesday = utcTuesday;
var utcWednesday = utcWeekday(3);
utcWeek.utcWednesday = utcWednesday;
var utcThursday = utcWeekday(4);
utcWeek.utcThursday = utcThursday;
var utcFriday = utcWeekday(5);
utcWeek.utcFriday = utcFriday;
var utcSaturday = utcWeekday(6);
utcWeek.utcSaturday = utcSaturday;
var utcSundays = utcSunday.range;
utcWeek.utcSundays = utcSundays;
var utcMondays = utcMonday.range;
utcWeek.utcMondays = utcMondays;
var utcTuesdays = utcTuesday.range;
utcWeek.utcTuesdays = utcTuesdays;
var utcWednesdays = utcWednesday.range;
utcWeek.utcWednesdays = utcWednesdays;
var utcThursdays = utcThursday.range;
utcWeek.utcThursdays = utcThursdays;
var utcFridays = utcFriday.range;
utcWeek.utcFridays = utcFridays;
var utcSaturdays = utcSaturday.range;
utcWeek.utcSaturdays = utcSaturdays;

var utcMonth$1 = {};

Object.defineProperty(utcMonth$1, "__esModule", {
  value: true
});
utcMonth$1.utcMonths = utcMonth$1.default = void 0;

var _interval$1 = _interopRequireDefault$14(interval$2);

function _interopRequireDefault$14(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utcMonth = (0, _interval$1.default)(function (date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function (start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function (date) {
  return date.getUTCMonth();
});
var _default$5 = utcMonth;
utcMonth$1.default = _default$5;
var utcMonths = utcMonth.range;
utcMonth$1.utcMonths = utcMonths;

var utcYear$1 = {};

Object.defineProperty(utcYear$1, "__esModule", {
  value: true
});
utcYear$1.utcYears = utcYear$1.default = void 0;

var _interval = _interopRequireDefault$13(interval$2);

function _interopRequireDefault$13(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utcYear = (0, _interval.default)(function (date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function (date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function (start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function (date) {
  return date.getUTCFullYear();
}); // An optimized implementation for this simple case.

utcYear.every = function (k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function (date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function (date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var _default$4 = utcYear;
utcYear$1.default = _default$4;
var utcYears = utcYear.range;
utcYear$1.utcYears = utcYears;

var ticks = {};

Object.defineProperty(ticks, "__esModule", {
  value: true
});
ticks.utcTicks = ticks.utcTickInterval = ticks.timeTicks = ticks.timeTickInterval = void 0;

var _index$9O = src$6;

var _duration = duration;

var _millisecond = _interopRequireDefault$12(millisecond$1);

var _second = _interopRequireDefault$12(second$1);

var _minute = _interopRequireDefault$12(minute$1);

var _hour = _interopRequireDefault$12(hour$1);

var _day = _interopRequireDefault$12(day$1);

var _week = week$1;

var _month = _interopRequireDefault$12(month$1);

var _year = _interopRequireDefault$12(year$1);

var _utcMinute = _interopRequireDefault$12(utcMinute$1);

var _utcHour = _interopRequireDefault$12(utcHour$1);

var _utcDay = _interopRequireDefault$12(utcDay$1);

var _utcWeek = utcWeek;

var _utcMonth = _interopRequireDefault$12(utcMonth$1);

var _utcYear = _interopRequireDefault$12(utcYear$1);

function _interopRequireDefault$12(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [[_second.default, 1, _duration.durationSecond], [_second.default, 5, 5 * _duration.durationSecond], [_second.default, 15, 15 * _duration.durationSecond], [_second.default, 30, 30 * _duration.durationSecond], [minute, 1, _duration.durationMinute], [minute, 5, 5 * _duration.durationMinute], [minute, 15, 15 * _duration.durationMinute], [minute, 30, 30 * _duration.durationMinute], [hour, 1, _duration.durationHour], [hour, 3, 3 * _duration.durationHour], [hour, 6, 6 * _duration.durationHour], [hour, 12, 12 * _duration.durationHour], [day, 1, _duration.durationDay], [day, 2, 2 * _duration.durationDay], [week, 1, _duration.durationWeek], [month, 1, _duration.durationMonth], [month, 3, 3 * _duration.durationMonth], [year, 1, _duration.durationYear]];

  function ticks(start, stop, count) {
    const reverse = stop < start;
    if (reverse) [start, stop] = [stop, start];
    const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
    const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop

    return reverse ? ticks.reverse() : ticks;
  }

  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count;
    const i = (0, _index$9O.bisector)(([,, step]) => step).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every((0, _index$9O.tickStep)(start / _duration.durationYear, stop / _duration.durationYear, count));
    if (i === 0) return _millisecond.default.every(Math.max((0, _index$9O.tickStep)(start, stop, count), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }

  return [ticks, tickInterval];
}

const [utcTicks, utcTickInterval] = ticker(_utcYear.default, _utcMonth.default, _utcWeek.utcSunday, _utcDay.default, _utcHour.default, _utcMinute.default);
ticks.utcTickInterval = utcTickInterval;
ticks.utcTicks = utcTicks;
const [timeTicks, timeTickInterval] = ticker(_year.default, _month.default, _week.sunday, _day.default, _hour.default, _minute.default);
ticks.timeTickInterval = timeTickInterval;
ticks.timeTicks = timeTicks;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "timeDay", {
  enumerable: true,
  get: function () {
    return _day.default;
  }
});
Object.defineProperty(exports, "timeDays", {
  enumerable: true,
  get: function () {
    return _day.days;
  }
});
Object.defineProperty(exports, "timeFriday", {
  enumerable: true,
  get: function () {
    return _week.friday;
  }
});
Object.defineProperty(exports, "timeFridays", {
  enumerable: true,
  get: function () {
    return _week.fridays;
  }
});
Object.defineProperty(exports, "timeHour", {
  enumerable: true,
  get: function () {
    return _hour.default;
  }
});
Object.defineProperty(exports, "timeHours", {
  enumerable: true,
  get: function () {
    return _hour.hours;
  }
});
Object.defineProperty(exports, "timeInterval", {
  enumerable: true,
  get: function () {
    return _interval.default;
  }
});
Object.defineProperty(exports, "timeMillisecond", {
  enumerable: true,
  get: function () {
    return _millisecond.default;
  }
});
Object.defineProperty(exports, "timeMilliseconds", {
  enumerable: true,
  get: function () {
    return _millisecond.milliseconds;
  }
});
Object.defineProperty(exports, "timeMinute", {
  enumerable: true,
  get: function () {
    return _minute.default;
  }
});
Object.defineProperty(exports, "timeMinutes", {
  enumerable: true,
  get: function () {
    return _minute.minutes;
  }
});
Object.defineProperty(exports, "timeMonday", {
  enumerable: true,
  get: function () {
    return _week.monday;
  }
});
Object.defineProperty(exports, "timeMondays", {
  enumerable: true,
  get: function () {
    return _week.mondays;
  }
});
Object.defineProperty(exports, "timeMonth", {
  enumerable: true,
  get: function () {
    return _month.default;
  }
});
Object.defineProperty(exports, "timeMonths", {
  enumerable: true,
  get: function () {
    return _month.months;
  }
});
Object.defineProperty(exports, "timeSaturday", {
  enumerable: true,
  get: function () {
    return _week.saturday;
  }
});
Object.defineProperty(exports, "timeSaturdays", {
  enumerable: true,
  get: function () {
    return _week.saturdays;
  }
});
Object.defineProperty(exports, "timeSecond", {
  enumerable: true,
  get: function () {
    return _second.default;
  }
});
Object.defineProperty(exports, "timeSeconds", {
  enumerable: true,
  get: function () {
    return _second.seconds;
  }
});
Object.defineProperty(exports, "timeSunday", {
  enumerable: true,
  get: function () {
    return _week.sunday;
  }
});
Object.defineProperty(exports, "timeSundays", {
  enumerable: true,
  get: function () {
    return _week.sundays;
  }
});
Object.defineProperty(exports, "timeThursday", {
  enumerable: true,
  get: function () {
    return _week.thursday;
  }
});
Object.defineProperty(exports, "timeThursdays", {
  enumerable: true,
  get: function () {
    return _week.thursdays;
  }
});
Object.defineProperty(exports, "timeTickInterval", {
  enumerable: true,
  get: function () {
    return _ticks.timeTickInterval;
  }
});
Object.defineProperty(exports, "timeTicks", {
  enumerable: true,
  get: function () {
    return _ticks.timeTicks;
  }
});
Object.defineProperty(exports, "timeTuesday", {
  enumerable: true,
  get: function () {
    return _week.tuesday;
  }
});
Object.defineProperty(exports, "timeTuesdays", {
  enumerable: true,
  get: function () {
    return _week.tuesdays;
  }
});
Object.defineProperty(exports, "timeWednesday", {
  enumerable: true,
  get: function () {
    return _week.wednesday;
  }
});
Object.defineProperty(exports, "timeWednesdays", {
  enumerable: true,
  get: function () {
    return _week.wednesdays;
  }
});
Object.defineProperty(exports, "timeWeek", {
  enumerable: true,
  get: function () {
    return _week.sunday;
  }
});
Object.defineProperty(exports, "timeWeeks", {
  enumerable: true,
  get: function () {
    return _week.sundays;
  }
});
Object.defineProperty(exports, "timeYear", {
  enumerable: true,
  get: function () {
    return _year.default;
  }
});
Object.defineProperty(exports, "timeYears", {
  enumerable: true,
  get: function () {
    return _year.years;
  }
});
Object.defineProperty(exports, "utcDay", {
  enumerable: true,
  get: function () {
    return _utcDay.default;
  }
});
Object.defineProperty(exports, "utcDays", {
  enumerable: true,
  get: function () {
    return _utcDay.utcDays;
  }
});
Object.defineProperty(exports, "utcFriday", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcFriday;
  }
});
Object.defineProperty(exports, "utcFridays", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcFridays;
  }
});
Object.defineProperty(exports, "utcHour", {
  enumerable: true,
  get: function () {
    return _utcHour.default;
  }
});
Object.defineProperty(exports, "utcHours", {
  enumerable: true,
  get: function () {
    return _utcHour.utcHours;
  }
});
Object.defineProperty(exports, "utcMillisecond", {
  enumerable: true,
  get: function () {
    return _millisecond.default;
  }
});
Object.defineProperty(exports, "utcMilliseconds", {
  enumerable: true,
  get: function () {
    return _millisecond.milliseconds;
  }
});
Object.defineProperty(exports, "utcMinute", {
  enumerable: true,
  get: function () {
    return _utcMinute.default;
  }
});
Object.defineProperty(exports, "utcMinutes", {
  enumerable: true,
  get: function () {
    return _utcMinute.utcMinutes;
  }
});
Object.defineProperty(exports, "utcMonday", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcMonday;
  }
});
Object.defineProperty(exports, "utcMondays", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcMondays;
  }
});
Object.defineProperty(exports, "utcMonth", {
  enumerable: true,
  get: function () {
    return _utcMonth.default;
  }
});
Object.defineProperty(exports, "utcMonths", {
  enumerable: true,
  get: function () {
    return _utcMonth.utcMonths;
  }
});
Object.defineProperty(exports, "utcSaturday", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcSaturday;
  }
});
Object.defineProperty(exports, "utcSaturdays", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcSaturdays;
  }
});
Object.defineProperty(exports, "utcSecond", {
  enumerable: true,
  get: function () {
    return _second.default;
  }
});
Object.defineProperty(exports, "utcSeconds", {
  enumerable: true,
  get: function () {
    return _second.seconds;
  }
});
Object.defineProperty(exports, "utcSunday", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcSunday;
  }
});
Object.defineProperty(exports, "utcSundays", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcSundays;
  }
});
Object.defineProperty(exports, "utcThursday", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcThursday;
  }
});
Object.defineProperty(exports, "utcThursdays", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcThursdays;
  }
});
Object.defineProperty(exports, "utcTickInterval", {
  enumerable: true,
  get: function () {
    return _ticks.utcTickInterval;
  }
});
Object.defineProperty(exports, "utcTicks", {
  enumerable: true,
  get: function () {
    return _ticks.utcTicks;
  }
});
Object.defineProperty(exports, "utcTuesday", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcTuesday;
  }
});
Object.defineProperty(exports, "utcTuesdays", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcTuesdays;
  }
});
Object.defineProperty(exports, "utcWednesday", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcWednesday;
  }
});
Object.defineProperty(exports, "utcWednesdays", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcWednesdays;
  }
});
Object.defineProperty(exports, "utcWeek", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcSunday;
  }
});
Object.defineProperty(exports, "utcWeeks", {
  enumerable: true,
  get: function () {
    return _utcWeek.utcSundays;
  }
});
Object.defineProperty(exports, "utcYear", {
  enumerable: true,
  get: function () {
    return _utcYear.default;
  }
});
Object.defineProperty(exports, "utcYears", {
  enumerable: true,
  get: function () {
    return _utcYear.utcYears;
  }
});

var _interval = _interopRequireDefault(interval$2);

var _millisecond = _interopRequireWildcard(millisecond$1);

var _second = _interopRequireWildcard(second$1);

var _minute = _interopRequireWildcard(minute$1);

var _hour = _interopRequireWildcard(hour$1);

var _day = _interopRequireWildcard(day$1);

var _week = week$1;

var _month = _interopRequireWildcard(month$1);

var _year = _interopRequireWildcard(year$1);

var _utcMinute = _interopRequireWildcard(utcMinute$1);

var _utcHour = _interopRequireWildcard(utcHour$1);

var _utcDay = _interopRequireWildcard(utcDay$1);

var _utcWeek = utcWeek;

var _utcMonth = _interopRequireWildcard(utcMonth$1);

var _utcYear = _interopRequireWildcard(utcYear$1);

var _ticks = ticks;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
}(src$1));

var src = {};

var defaultLocale$2 = {};

var locale$2 = {};

Object.defineProperty(locale$2, "__esModule", {
  value: true
});
locale$2.default = formatLocale;

var _index$9N = src$1;

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }

  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }

  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {
    y: y,
    m: m,
    d: d,
    H: 0,
    M: 0,
    S: 0,
    L: 0
  };
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;
  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear$1,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear$1,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  }; // These recursive directive definitions must be deferred.

  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function (date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;
      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function (string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week,
          day;
      if (i != string.length) return null; // If a UNIX timestamp is specified, return it.

      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.

      if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.

      if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.

      if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.

      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;

        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? _index$9N.utcMonday.ceil(week) : (0, _index$9N.utcMonday)(week);
          week = _index$9N.utcDay.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? _index$9N.timeMonday.ceil(week) : (0, _index$9N.timeMonday)(week);
          week = _index$9N.timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      } // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.


      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      } // Otherwise, all fields are in local time.


      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);

      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || (j = parse(d, string, j)) < 0) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function (specifier) {
      var f = newFormat(specifier += "", formats);

      f.toString = function () {
        return specifier;
      };

      return f;
    },
    parse: function (specifier) {
      var p = newParse(specifier += "", false);

      p.toString = function () {
        return specifier;
      };

      return p;
    },
    utcFormat: function (specifier) {
      var f = newFormat(specifier += "", utcFormats);

      f.toString = function () {
        return specifier;
      };

      return f;
    },
    utcParse: function (specifier) {
      var p = newParse(specifier += "", true);

      p.toString = function () {
        return specifier;
      };

      return p;
    }
  };
}

var pads = {
  "-": "",
  "_": " ",
  "0": "0"
},
    numberRe = /^\s*\d+/,
    // note: ignores next directive
percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear$1(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + _index$9N.timeDay.count((0, _index$9N.timeYear)(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(_index$9N.timeSunday.count((0, _index$9N.timeYear)(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return day >= 4 || day === 0 ? (0, _index$9N.timeThursday)(d) : _index$9N.timeThursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(_index$9N.timeThursday.count((0, _index$9N.timeYear)(d), d) + ((0, _index$9N.timeYear)(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(_index$9N.timeMonday.count((0, _index$9N.timeYear)(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = day >= 4 || day === 0 ? (0, _index$9N.timeThursday)(d) : _index$9N.timeThursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + _index$9N.utcDay.count((0, _index$9N.utcYear)(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(_index$9N.utcSunday.count((0, _index$9N.utcYear)(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return day >= 4 || day === 0 ? (0, _index$9N.utcThursday)(d) : _index$9N.utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(_index$9N.utcThursday.count((0, _index$9N.utcYear)(d), d) + ((0, _index$9N.utcYear)(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(_index$9N.utcMonday.count((0, _index$9N.utcYear)(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = day >= 4 || day === 0 ? (0, _index$9N.utcThursday)(d) : _index$9N.utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

Object.defineProperty(defaultLocale$2, "__esModule", {
  value: true
});
defaultLocale$2.default = defaultLocale$1;
defaultLocale$2.utcParse = defaultLocale$2.utcFormat = defaultLocale$2.timeParse = defaultLocale$2.timeFormat = void 0;

var _locale = _interopRequireDefault$11(locale$2);

function _interopRequireDefault$11(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locale$1;
var timeFormat;
defaultLocale$2.timeFormat = timeFormat;
var timeParse;
defaultLocale$2.timeParse = timeParse;
var utcFormat;
defaultLocale$2.utcFormat = utcFormat;
var utcParse;
defaultLocale$2.utcParse = utcParse;
defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$1(definition) {
  locale$1 = (0, _locale.default)(definition);
  defaultLocale$2.timeFormat = timeFormat = locale$1.format;
  defaultLocale$2.timeParse = timeParse = locale$1.parse;
  defaultLocale$2.utcFormat = utcFormat = locale$1.utcFormat;
  defaultLocale$2.utcParse = utcParse = locale$1.utcParse;
  return locale$1;
}

var isoFormat = {};

Object.defineProperty(isoFormat, "__esModule", {
  value: true
});
isoFormat.isoSpecifier = isoFormat.default = void 0;

var _defaultLocale$1 = defaultLocale$2;

var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
isoFormat.isoSpecifier = isoSpecifier;

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocale$1.utcFormat)(isoSpecifier);
var _default$3 = formatIso;
isoFormat.default = _default$3;

var isoParse = {};

Object.defineProperty(isoParse, "__esModule", {
  value: true
});
isoParse.default = void 0;

var _isoFormat = isoFormat;

var _defaultLocale = defaultLocale$2;

function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocale.utcParse)(_isoFormat.isoSpecifier);
var _default$2 = parseIso;
isoParse.default = _default$2;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "isoFormat", {
  enumerable: true,
  get: function () {
    return _isoFormat.default;
  }
});
Object.defineProperty(exports, "isoParse", {
  enumerable: true,
  get: function () {
    return _isoParse.default;
  }
});
Object.defineProperty(exports, "timeFormat", {
  enumerable: true,
  get: function () {
    return _defaultLocale.timeFormat;
  }
});
Object.defineProperty(exports, "timeFormatDefaultLocale", {
  enumerable: true,
  get: function () {
    return _defaultLocale.default;
  }
});
Object.defineProperty(exports, "timeFormatLocale", {
  enumerable: true,
  get: function () {
    return _locale.default;
  }
});
Object.defineProperty(exports, "timeParse", {
  enumerable: true,
  get: function () {
    return _defaultLocale.timeParse;
  }
});
Object.defineProperty(exports, "utcFormat", {
  enumerable: true,
  get: function () {
    return _defaultLocale.utcFormat;
  }
});
Object.defineProperty(exports, "utcParse", {
  enumerable: true,
  get: function () {
    return _defaultLocale.utcParse;
  }
});

var _defaultLocale = _interopRequireWildcard(defaultLocale$2);

var _locale = _interopRequireDefault(locale$2);

var _isoFormat = _interopRequireDefault(isoFormat);

var _isoParse = _interopRequireDefault(isoParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
}(src));

Object.defineProperty(time$1, "__esModule", {
  value: true
});
time$1.calendar = calendar;
time$1.default = time;

var _index$9M = src$1;

var _index2$4r = src;

var _continuous$3 = _interopRequireWildcard$q(continuous$1);

var _init$4 = init$1;

var _nice = _interopRequireDefault$10(nice$1);

function _interopRequireDefault$10(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache$q(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache$q = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard$q(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache$q(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
  var scale = (0, _continuous$3.default)(),
      invert = scale.invert,
      domain = scale.domain;
  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
  }

  scale.invert = function (y) {
    return new Date(invert(y));
  };

  scale.domain = function (_) {
    return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
  };

  scale.ticks = function (interval) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };

  scale.tickFormat = function (count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function (interval) {
    var d = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain((0, _nice.default)(d, interval)) : scale;
  };

  scale.copy = function () {
    return (0, _continuous$3.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
  };

  return scale;
}

function time() {
  return _init$4.initRange.apply(calendar(_index$9M.timeTicks, _index$9M.timeTickInterval, _index$9M.timeYear, _index$9M.timeMonth, _index$9M.timeWeek, _index$9M.timeDay, _index$9M.timeHour, _index$9M.timeMinute, _index$9M.timeSecond, _index2$4r.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

var utcTime$1 = {};

Object.defineProperty(utcTime$1, "__esModule", {
  value: true
});
utcTime$1.default = utcTime;

var _index$9L = src$1;

var _index2$4q = src;

var _time = time$1;

var _init$3 = init$1;

function utcTime() {
  return _init$3.initRange.apply((0, _time.calendar)(_index$9L.utcTicks, _index$9L.utcTickInterval, _index$9L.utcYear, _index$9L.utcMonth, _index$9L.utcWeek, _index$9L.utcDay, _index$9L.utcHour, _index$9L.utcMinute, _index$9L.utcSecond, _index2$4q.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
}

var sequential$1 = {};

Object.defineProperty(sequential$1, "__esModule", {
  value: true
});
sequential$1.copy = copy;
sequential$1.default = sequential;
sequential$1.sequentialLog = sequentialLog;
sequential$1.sequentialPow = sequentialPow;
sequential$1.sequentialSqrt = sequentialSqrt;
sequential$1.sequentialSymlog = sequentialSymlog;

var _index$9K = src$4;

var _continuous$2 = continuous$1;

var _init$2 = init$1;

var _linear$1 = linear$2;

var _log$1 = log$2;

var _symlog$1 = symlog$1;

var _pow$1 = pow$1;

function transformer$1() {
  var x0 = 0,
      x1 = 1,
      t0,
      t1,
      k10,
      transform,
      interpolator = _continuous$2.identity,
      clamp = false,
      unknown;

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function (_) {
    return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  function range(interpolate) {
    return function (_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }

  scale.range = range(_index$9K.interpolate);
  scale.rangeRound = range(_index$9K.interpolateRound);

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function (t) {
    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
    return scale;
  };
}

function copy(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}

function sequential() {
  var scale = (0, _linear$1.linearish)(transformer$1()(_continuous$2.identity));

  scale.copy = function () {
    return copy(scale, sequential());
  };

  return _init$2.initInterpolator.apply(scale, arguments);
}

function sequentialLog() {
  var scale = (0, _log$1.loggish)(transformer$1()).domain([1, 10]);

  scale.copy = function () {
    return copy(scale, sequentialLog()).base(scale.base());
  };

  return _init$2.initInterpolator.apply(scale, arguments);
}

function sequentialSymlog() {
  var scale = (0, _symlog$1.symlogish)(transformer$1());

  scale.copy = function () {
    return copy(scale, sequentialSymlog()).constant(scale.constant());
  };

  return _init$2.initInterpolator.apply(scale, arguments);
}

function sequentialPow() {
  var scale = (0, _pow$1.powish)(transformer$1());

  scale.copy = function () {
    return copy(scale, sequentialPow()).exponent(scale.exponent());
  };

  return _init$2.initInterpolator.apply(scale, arguments);
}

function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}

var sequentialQuantile$1 = {};

Object.defineProperty(sequentialQuantile$1, "__esModule", {
  value: true
});
sequentialQuantile$1.default = sequentialQuantile;

var _index$9J = src$6;

var _continuous$1 = continuous$1;

var _init$1 = init$1;

function sequentialQuantile() {
  var domain = [],
      interpolator = _continuous$1.identity;

  function scale(x) {
    if (x != null && !isNaN(x = +x)) return interpolator(((0, _index$9J.bisect)(domain, x, 1) - 1) / (domain.length - 1));
  }

  scale.domain = function (_) {
    if (!arguments.length) return domain.slice();
    domain = [];

    for (let d of _) if (d != null && !isNaN(d = +d)) domain.push(d);

    domain.sort(_index$9J.ascending);
    return scale;
  };

  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.range = function () {
    return domain.map((d, i) => interpolator(i / (domain.length - 1)));
  };

  scale.quantiles = function (n) {
    return Array.from({
      length: n + 1
    }, (_, i) => (0, _index$9J.quantile)(domain, i / n));
  };

  scale.copy = function () {
    return sequentialQuantile(interpolator).domain(domain);
  };

  return _init$1.initInterpolator.apply(scale, arguments);
}

var diverging$1 = {};

Object.defineProperty(diverging$1, "__esModule", {
  value: true
});
diverging$1.default = diverging;
diverging$1.divergingLog = divergingLog;
diverging$1.divergingPow = divergingPow;
diverging$1.divergingSqrt = divergingSqrt;
diverging$1.divergingSymlog = divergingSymlog;

var _index$9I = src$4;

var _continuous = continuous$1;

var _init = init$1;

var _linear = linear$2;

var _log = log$2;

var _sequential = sequential$1;

var _symlog = symlog$1;

var _pow = pow$1;

function transformer() {
  var x0 = 0,
      x1 = 0.5,
      x2 = 1,
      s = 1,
      t0,
      t1,
      t2,
      k10,
      k21,
      interpolator = _continuous.identity,
      transform,
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function (_) {
    return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [x0, x1, x2];
  };

  scale.clamp = function (_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function (_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  function range(interpolate) {
    return function (_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _index$9I.piecewise)(interpolate, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }

  scale.range = range(_index$9I.interpolate);
  scale.rangeRound = range(_index$9I.interpolateRound);

  scale.unknown = function (_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function (t) {
    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
    return scale;
  };
}

function diverging() {
  var scale = (0, _linear.linearish)(transformer()(_continuous.identity));

  scale.copy = function () {
    return (0, _sequential.copy)(scale, diverging());
  };

  return _init.initInterpolator.apply(scale, arguments);
}

function divergingLog() {
  var scale = (0, _log.loggish)(transformer()).domain([0.1, 1, 10]);

  scale.copy = function () {
    return (0, _sequential.copy)(scale, divergingLog()).base(scale.base());
  };

  return _init.initInterpolator.apply(scale, arguments);
}

function divergingSymlog() {
  var scale = (0, _symlog.symlogish)(transformer());

  scale.copy = function () {
    return (0, _sequential.copy)(scale, divergingSymlog()).constant(scale.constant());
  };

  return _init.initInterpolator.apply(scale, arguments);
}

function divergingPow() {
  var scale = (0, _pow.powish)(transformer());

  scale.copy = function () {
    return (0, _sequential.copy)(scale, divergingPow()).exponent(scale.exponent());
  };

  return _init.initInterpolator.apply(scale, arguments);
}

function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "scaleBand", {
  enumerable: true,
  get: function () {
    return _band.default;
  }
});
Object.defineProperty(exports, "scaleDiverging", {
  enumerable: true,
  get: function () {
    return _diverging.default;
  }
});
Object.defineProperty(exports, "scaleDivergingLog", {
  enumerable: true,
  get: function () {
    return _diverging.divergingLog;
  }
});
Object.defineProperty(exports, "scaleDivergingPow", {
  enumerable: true,
  get: function () {
    return _diverging.divergingPow;
  }
});
Object.defineProperty(exports, "scaleDivergingSqrt", {
  enumerable: true,
  get: function () {
    return _diverging.divergingSqrt;
  }
});
Object.defineProperty(exports, "scaleDivergingSymlog", {
  enumerable: true,
  get: function () {
    return _diverging.divergingSymlog;
  }
});
Object.defineProperty(exports, "scaleIdentity", {
  enumerable: true,
  get: function () {
    return _identity.default;
  }
});
Object.defineProperty(exports, "scaleImplicit", {
  enumerable: true,
  get: function () {
    return _ordinal.implicit;
  }
});
Object.defineProperty(exports, "scaleLinear", {
  enumerable: true,
  get: function () {
    return _linear.default;
  }
});
Object.defineProperty(exports, "scaleLog", {
  enumerable: true,
  get: function () {
    return _log.default;
  }
});
Object.defineProperty(exports, "scaleOrdinal", {
  enumerable: true,
  get: function () {
    return _ordinal.default;
  }
});
Object.defineProperty(exports, "scalePoint", {
  enumerable: true,
  get: function () {
    return _band.point;
  }
});
Object.defineProperty(exports, "scalePow", {
  enumerable: true,
  get: function () {
    return _pow.default;
  }
});
Object.defineProperty(exports, "scaleQuantile", {
  enumerable: true,
  get: function () {
    return _quantile.default;
  }
});
Object.defineProperty(exports, "scaleQuantize", {
  enumerable: true,
  get: function () {
    return _quantize.default;
  }
});
Object.defineProperty(exports, "scaleRadial", {
  enumerable: true,
  get: function () {
    return _radial.default;
  }
});
Object.defineProperty(exports, "scaleSequential", {
  enumerable: true,
  get: function () {
    return _sequential.default;
  }
});
Object.defineProperty(exports, "scaleSequentialLog", {
  enumerable: true,
  get: function () {
    return _sequential.sequentialLog;
  }
});
Object.defineProperty(exports, "scaleSequentialPow", {
  enumerable: true,
  get: function () {
    return _sequential.sequentialPow;
  }
});
Object.defineProperty(exports, "scaleSequentialQuantile", {
  enumerable: true,
  get: function () {
    return _sequentialQuantile.default;
  }
});
Object.defineProperty(exports, "scaleSequentialSqrt", {
  enumerable: true,
  get: function () {
    return _sequential.sequentialSqrt;
  }
});
Object.defineProperty(exports, "scaleSequentialSymlog", {
  enumerable: true,
  get: function () {
    return _sequential.sequentialSymlog;
  }
});
Object.defineProperty(exports, "scaleSqrt", {
  enumerable: true,
  get: function () {
    return _pow.sqrt;
  }
});
Object.defineProperty(exports, "scaleSymlog", {
  enumerable: true,
  get: function () {
    return _symlog.default;
  }
});
Object.defineProperty(exports, "scaleThreshold", {
  enumerable: true,
  get: function () {
    return _threshold.default;
  }
});
Object.defineProperty(exports, "scaleTime", {
  enumerable: true,
  get: function () {
    return _time.default;
  }
});
Object.defineProperty(exports, "scaleUtc", {
  enumerable: true,
  get: function () {
    return _utcTime.default;
  }
});
Object.defineProperty(exports, "tickFormat", {
  enumerable: true,
  get: function () {
    return _tickFormat.default;
  }
});

var _band = _interopRequireWildcard(band$1);

var _identity = _interopRequireDefault(identity$7);

var _linear = _interopRequireDefault(linear$2);

var _log = _interopRequireDefault(log$2);

var _symlog = _interopRequireDefault(symlog$1);

var _ordinal = _interopRequireWildcard(ordinal$1);

var _pow = _interopRequireWildcard(pow$1);

var _radial = _interopRequireDefault(radial$1);

var _quantile = _interopRequireDefault(quantile$1);

var _quantize = _interopRequireDefault(quantize$1);

var _threshold = _interopRequireDefault(threshold$1);

var _time = _interopRequireDefault(time$1);

var _utcTime = _interopRequireDefault(utcTime$1);

var _sequential = _interopRequireWildcard(sequential$1);

var _sequentialQuantile = _interopRequireDefault(sequentialQuantile$1);

var _diverging = _interopRequireWildcard(diverging$1);

var _tickFormat = _interopRequireDefault(tickFormat$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
}(src$7));

// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`
var d3Scale = src$7;

var isSymbol = isSymbol_1;

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum$4(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

var _baseExtremum = baseExtremum$4;

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */

function baseGt$2(value, other) {
  return value > other;
}

var _baseGt = baseGt$2;

var baseExtremum$3 = _baseExtremum,
    baseGt$1 = _baseGt,
    identity$2 = identity_1;

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max$2(array) {
  return (array && array.length)
    ? baseExtremum$3(array, identity$2, baseGt$1)
    : undefined;
}

var max_1 = max$2;

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */

function baseLt$2(value, other) {
  return value < other;
}

var _baseLt = baseLt$2;

var baseExtremum$2 = _baseExtremum,
    baseLt$1 = _baseLt,
    identity$1 = identity_1;

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min$2(array) {
  return (array && array.length)
    ? baseExtremum$2(array, identity$1, baseLt$1)
    : undefined;
}

var min_1 = min$2;

var baseFlatten$1 = _baseFlatten,
    map$1 = map_1;

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten$1(map$1(collection, iteratee), 1);
}

var flatMap_1 = flatMap;

var baseIsEqual = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual$2(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1 = isEqual$2;

var lib$1 = {};

var getNiceTickValues$1 = {};

var decimal = {exports: {}};

/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */

(function (module) {
(function (globalScope) {


  /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */


  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //


    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
  var MAX_DIGITS = 1e9,                        // 0 to 1e9


    // The initial configuration properties of the Decimal constructor.
    Decimal = {

      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed during run-time using `Decimal.config`.

      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,                         // 1 to MAX_DIGITS

      // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
      // `toFixed`, `toPrecision` and `toSignificantDigits`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,                           // 0 to 8

      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,                          // 0 to -MAX_E

      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos:  21,                         // 0 to MAX_E

      // The natural logarithm of 10.
      // 115 digits
      LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    },


  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //


    external = true,

    decimalError = '[DecimalError] ',
    invalidArgument = decimalError + 'Invalid argument: ',
    exponentOutOfRange = decimalError + 'Exponent out of range: ',

    mathfloor = Math.floor,
    mathpow = Math.pow,

    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,

    ONE,
    BASE = 1e7,
    LOG_BASE = 7,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284

    // Decimal.prototype object
    P = {};


  // Decimal prototype methods


  /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */


  /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */
  P.absoluteValue = P.abs = function () {
    var x = new this.constructor(this);
    if (x.s) x.s = 1;
    return x;
  };


  /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */
  P.comparedTo = P.cmp = function (y) {
    var i, j, xdL, ydL,
      x = this;

    y = new x.constructor(y);

    // Signs differ?
    if (x.s !== y.s) return x.s || -y.s;

    // Compare exponents.
    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;

    xdL = x.d.length;
    ydL = y.d.length;

    // Compare digit by digit.
    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
      if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
    }

    // Compare lengths.
    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
  };


  /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */
  P.decimalPlaces = P.dp = function () {
    var x = this,
      w = x.d.length - 1,
      dp = (w - x.e) * LOG_BASE;

    // Subtract the number of trailing zeros of the last word.
    w = x.d[w];
    if (w) for (; w % 10 == 0; w /= 10) dp--;

    return dp < 0 ? 0 : dp;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.dividedBy = P.div = function (y) {
    return divide(this, new this.constructor(y));
  };


  /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */
  P.dividedToIntegerBy = P.idiv = function (y) {
    var x = this,
      Ctor = x.constructor;
    return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
  };


  /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */
  P.equals = P.eq = function (y) {
    return !this.cmp(y);
  };


  /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */
  P.exponent = function () {
    return getBase10Exponent(this);
  };


  /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */
  P.greaterThan = P.gt = function (y) {
    return this.cmp(y) > 0;
  };


  /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */
  P.greaterThanOrEqualTo = P.gte = function (y) {
    return this.cmp(y) >= 0;
  };


  /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */
  P.isInteger = P.isint = function () {
    return this.e > this.d.length - 2;
  };


  /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */
  P.isNegative = P.isneg = function () {
    return this.s < 0;
  };


  /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */
  P.isPositive = P.ispos = function () {
    return this.s > 0;
  };


  /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */
  P.isZero = function () {
    return this.s === 0;
  };


  /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */
  P.lessThan = P.lt = function (y) {
    return this.cmp(y) < 0;
  };


  /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */
  P.lessThanOrEqualTo = P.lte = function (y) {
    return this.cmp(y) < 1;
  };


  /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */
  P.logarithm = P.log = function (base) {
    var r,
      x = this,
      Ctor = x.constructor,
      pr = Ctor.precision,
      wpr = pr + 5;

    // Default base is 10.
    if (base === void 0) {
      base = new Ctor(10);
    } else {
      base = new Ctor(base);

      // log[-b](x) = NaN
      // log[0](x)  = NaN
      // log[1](x)  = NaN
      if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
    }

    // log[b](-x) = NaN
    // log[b](0) = -Infinity
    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

    // log[b](1) = 0
    if (x.eq(ONE)) return new Ctor(0);

    external = false;
    r = divide(ln(x, wpr), ln(base, wpr), wpr);
    external = true;

    return round(r, pr);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.minus = P.sub = function (y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.modulo = P.mod = function (y) {
    var q,
      x = this,
      Ctor = x.constructor,
      pr = Ctor.precision;

    y = new Ctor(y);

    // x % 0 = NaN
    if (!y.s) throw Error(decimalError + 'NaN');

    // Return x if x is 0.
    if (!x.s) return round(new Ctor(x), pr);

    // Prevent rounding of intermediate calculations.
    external = false;
    q = divide(x, y, 0, 1).times(y);
    external = true;

    return x.minus(q);
  };


  /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */
  P.naturalExponential = P.exp = function () {
    return exp(this);
  };


  /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */
  P.naturalLogarithm = P.ln = function () {
    return ln(this);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */
  P.negated = P.neg = function () {
    var x = new this.constructor(this);
    x.s = -x.s || 0;
    return x;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.plus = P.add = function (y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
  };


  /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */
  P.precision = P.sd = function (z) {
    var e, sd, w,
      x = this;

    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

    e = getBase10Exponent(x) + 1;
    w = x.d.length - 1;
    sd = w * LOG_BASE + 1;
    w = x.d[w];

    // If non-zero...
    if (w) {

      // Subtract the number of trailing zeros of the last word.
      for (; w % 10 == 0; w /= 10) sd--;

      // Add the number of digits of the first word.
      for (w = x.d[0]; w >= 10; w /= 10) sd++;
    }

    return z && e > sd ? e : sd;
  };


  /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */
  P.squareRoot = P.sqrt = function () {
    var e, n, pr, r, s, t, wpr,
      x = this,
      Ctor = x.constructor;

    // Negative or zero?
    if (x.s < 1) {
      if (!x.s) return new Ctor(0);

      // sqrt(-x) = NaN
      throw Error(decimalError + 'NaN');
    }

    e = getBase10Exponent(x);
    external = false;

    // Initial estimate.
    s = Math.sqrt(+x);

    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
      n = digitsToString(x.d);
      if ((n.length + e) % 2 == 0) n += '0';
      s = Math.sqrt(n);
      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

      if (s == 1 / 0) {
        n = '5e' + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf('e') + 1) + e;
      }

      r = new Ctor(n);
    } else {
      r = new Ctor(s.toString());
    }

    pr = Ctor.precision;
    s = wpr = pr + 3;

    // Newton-Raphson iteration.
    for (;;) {
      t = r;
      r = t.plus(divide(x, t, wpr + 2)).times(0.5);

      if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
        n = n.slice(wpr - 3, wpr + 1);

        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
        // 4999, i.e. approaching a rounding boundary, continue the iteration.
        if (s == wpr && n == '4999') {

          // On the first iteration only, check to see if rounding up gives the exact result as the
          // nines may infinitely repeat.
          round(t, pr + 1, 0);

          if (t.times(t).eq(x)) {
            r = t;
            break;
          }
        } else if (n != '9999') {
          break;
        }

        wpr += 4;
      }
    }

    external = true;

    return round(r, pr);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.times = P.mul = function (y) {
    var carry, e, i, k, r, rL, t, xdL, ydL,
      x = this,
      Ctor = x.constructor,
      xd = x.d,
      yd = (y = new Ctor(y)).d;

    // Return 0 if either is 0.
    if (!x.s || !y.s) return new Ctor(0);

    y.s *= x.s;
    e = x.e + y.e;
    xdL = xd.length;
    ydL = yd.length;

    // Ensure xd points to the longer array.
    if (xdL < ydL) {
      r = xd;
      xd = yd;
      yd = r;
      rL = xdL;
      xdL = ydL;
      ydL = rL;
    }

    // Initialise the result array with zeros.
    r = [];
    rL = xdL + ydL;
    for (i = rL; i--;) r.push(0);

    // Multiply!
    for (i = ydL; --i >= 0;) {
      carry = 0;
      for (k = xdL + i; k > i;) {
        t = r[k] + yd[i] * xd[k - i - 1] + carry;
        r[k--] = t % BASE | 0;
        carry = t / BASE | 0;
      }

      r[k] = (r[k] + carry) % BASE | 0;
    }

    // Remove trailing zeros.
    for (; !r[--rL];) r.pop();

    if (carry) ++e;
    else r.shift();

    y.d = r;
    y.e = e;

    return external ? round(y, Ctor.precision) : y;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toDecimalPlaces = P.todp = function (dp, rm) {
    var x = this,
      Ctor = x.constructor;

    x = new Ctor(x);
    if (dp === void 0) return x;

    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    return round(x, dp + getBase10Exponent(x) + 1, rm);
  };


  /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toExponential = function (dp, rm) {
    var str,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) {
      str = toString(x, true);
    } else {
      checkInt32(dp, 0, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = round(new Ctor(x), dp + 1, rm);
      str = toString(x, true, dp + 1);
    }

    return str;
  };


  /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */
  P.toFixed = function (dp, rm) {
    var str, y,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) return toString(x);

    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
    str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);

    // To determine whether to add the minus sign look at the value before it was rounded,
    // i.e. look at `x` rather than `y`.
    return x.isneg() && !x.isZero() ? '-' + str : str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */
  P.toInteger = P.toint = function () {
    var x = this,
      Ctor = x.constructor;
    return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
  };


  /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */
  P.toNumber = function () {
    return +this;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */
  P.toPower = P.pow = function (y) {
    var e, k, pr, r, sign, yIsInt,
      x = this,
      Ctor = x.constructor,
      guard = 12,
      yn = +(y = new Ctor(y));

    // pow(x, 0) = 1
    if (!y.s) return new Ctor(ONE);

    x = new Ctor(x);

    // pow(0, y > 0) = 0
    // pow(0, y < 0) = Infinity
    if (!x.s) {
      if (y.s < 1) throw Error(decimalError + 'Infinity');
      return x;
    }

    // pow(1, y) = 1
    if (x.eq(ONE)) return x;

    pr = Ctor.precision;

    // pow(x, 1) = x
    if (y.eq(ONE)) return round(x, pr);

    e = y.e;
    k = y.d.length - 1;
    yIsInt = e >= k;
    sign = x.s;

    if (!yIsInt) {

      // pow(x < 0, y non-integer) = NaN
      if (sign < 0) throw Error(decimalError + 'NaN');

    // If y is a small integer use the 'exponentiation by squaring' algorithm.
    } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
      r = new Ctor(ONE);

      // Max k of 9007199254740991 takes 53 loop iterations.
      // Maximum digits array length; leaves [28, 34] guard digits.
      e = Math.ceil(pr / LOG_BASE + 4);

      external = false;

      for (;;) {
        if (k % 2) {
          r = r.times(x);
          truncate(r.d, e);
        }

        k = mathfloor(k / 2);
        if (k === 0) break;

        x = x.times(x);
        truncate(x.d, e);
      }

      external = true;

      return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
    }

    // Result is negative if x is negative and the last digit of integer y is odd.
    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;

    x.s = 1;
    external = false;
    r = y.times(ln(x, pr + guard));
    external = true;
    r = exp(r);
    r.s = sign;

    return r;
  };


  /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toPrecision = function (sd, rm) {
    var e, str,
      x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      e = getBase10Exponent(x);
      str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = round(new Ctor(x), sd, rm);
      e = getBase10Exponent(x);
      str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
    }

    return str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toSignificantDigits = P.tosd = function (sd, rm) {
    var x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      sd = Ctor.precision;
      rm = Ctor.rounding;
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);
    }

    return round(new Ctor(x), sd, rm);
  };


  /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */
  P.toString = P.valueOf = P.val = P.toJSON = function () {
    var x = this,
      e = getBase10Exponent(x),
      Ctor = x.constructor;

    return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
  };


  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.


  /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */


  function add(x, y) {
    var carry, d, e, i, k, len, xd, yd,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // If either is zero...
    if (!x.s || !y.s) {

      // Return x if y is zero.
      // Return y if y is non-zero.
      if (!y.s) y = new Ctor(x);
      return external ? round(y, pr) : y;
    }

    xd = x.d;
    yd = y.d;

    // x and y are finite, non-zero numbers with the same sign.

    k = x.e;
    e = y.e;
    xd = xd.slice();
    i = k - e;

    // If base 1e7 exponents differ...
    if (i) {
      if (i < 0) {
        d = xd;
        i = -i;
        len = yd.length;
      } else {
        d = yd;
        e = k;
        len = xd.length;
      }

      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
      k = Math.ceil(pr / LOG_BASE);
      len = k > len ? k + 1 : len + 1;

      if (i > len) {
        i = len;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
      d.reverse();
      for (; i--;) d.push(0);
      d.reverse();
    }

    len = xd.length;
    i = yd.length;

    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
    if (len - i < 0) {
      i = len;
      d = yd;
      yd = xd;
      xd = d;
    }

    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
    for (carry = 0; i;) {
      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
      xd[i] %= BASE;
    }

    if (carry) {
      xd.unshift(carry);
      ++e;
    }

    // Remove trailing zeros.
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    for (len = xd.length; xd[--len] == 0;) xd.pop();

    y.d = xd;
    y.e = e;

    return external ? round(y, pr) : y;
  }


  function checkInt32(i, min, max) {
    if (i !== ~~i || i < min || i > max) {
      throw Error(invalidArgument + i);
    }
  }


  function digitsToString(d) {
    var i, k, ws,
      indexOfLastWord = d.length - 1,
      str = '',
      w = d[0];

    if (indexOfLastWord > 0) {
      str += w;
      for (i = 1; i < indexOfLastWord; i++) {
        ws = d[i] + '';
        k = LOG_BASE - ws.length;
        if (k) str += getZeroString(k);
        str += ws;
      }

      w = d[i];
      ws = w + '';
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
    } else if (w === 0) {
      return '0';
    }

    // Remove trailing zeros of last w.
    for (; w % 10 === 0;) w /= 10;

    return str + w;
  }


  var divide = (function () {

    // Assumes non-zero x and k, and hence non-zero result.
    function multiplyInteger(x, k) {
      var temp,
        carry = 0,
        i = x.length;

      for (x = x.slice(); i--;) {
        temp = x[i] * k + carry;
        x[i] = temp % BASE | 0;
        carry = temp / BASE | 0;
      }

      if (carry) x.unshift(carry);

      return x;
    }

    function compare(a, b, aL, bL) {
      var i, r;

      if (aL != bL) {
        r = aL > bL ? 1 : -1;
      } else {
        for (i = r = 0; i < aL; i++) {
          if (a[i] != b[i]) {
            r = a[i] > b[i] ? 1 : -1;
            break;
          }
        }
      }

      return r;
    }

    function subtract(a, b, aL) {
      var i = 0;

      // Subtract b from a.
      for (; aL--;) {
        a[aL] -= i;
        i = a[aL] < b[aL] ? 1 : 0;
        a[aL] = i * BASE + a[aL] - b[aL];
      }

      // Remove leading zeros.
      for (; !a[0] && a.length > 1;) a.shift();
    }

    return function (x, y, pr, dp) {
      var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
        Ctor = x.constructor,
        sign = x.s == y.s ? 1 : -1,
        xd = x.d,
        yd = y.d;

      // Either 0?
      if (!x.s) return new Ctor(x);
      if (!y.s) throw Error(decimalError + 'Division by zero');

      e = x.e - y.e;
      yL = yd.length;
      xL = xd.length;
      q = new Ctor(sign);
      qd = q.d = [];

      // Result exponent may be one less than e.
      for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
      if (yd[i] > (xd[i] || 0)) --e;

      if (pr == null) {
        sd = pr = Ctor.precision;
      } else if (dp) {
        sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
      } else {
        sd = pr;
      }

      if (sd < 0) return new Ctor(0);

      // Convert precision in number of base 10 digits to base 1e7 digits.
      sd = sd / LOG_BASE + 2 | 0;
      i = 0;

      // divisor < 1e7
      if (yL == 1) {
        k = 0;
        yd = yd[0];
        sd++;

        // k is the carry.
        for (; (i < xL || k) && sd--; i++) {
          t = k * BASE + (xd[i] || 0);
          qd[i] = t / yd | 0;
          k = t % yd | 0;
        }

      // divisor >= 1e7
      } else {

        // Normalise xd and yd so highest order digit of yd is >= BASE/2
        k = BASE / (yd[0] + 1) | 0;

        if (k > 1) {
          yd = multiplyInteger(yd, k);
          xd = multiplyInteger(xd, k);
          yL = yd.length;
          xL = xd.length;
        }

        xi = yL;
        rem = xd.slice(0, yL);
        remL = rem.length;

        // Add zeros to make remainder as long as divisor.
        for (; remL < yL;) rem[remL++] = 0;

        yz = yd.slice();
        yz.unshift(0);
        yd0 = yd[0];

        if (yd[1] >= BASE / 2) ++yd0;

        do {
          k = 0;

          // Compare divisor and remainder.
          cmp = compare(yd, rem, yL, remL);

          // If divisor < remainder.
          if (cmp < 0) {

            // Calculate trial digit, k.
            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);

            // k will be how many times the divisor goes into the current remainder.
            k = rem0 / yd0 | 0;

            //  Algorithm:
            //  1. product = divisor * trial digit (k)
            //  2. if product > remainder: product -= divisor, k--
            //  3. remainder -= product
            //  4. if product was < remainder at 2:
            //    5. compare new remainder and divisor
            //    6. If remainder > divisor: remainder -= divisor, k++

            if (k > 1) {
              if (k >= BASE) k = BASE - 1;

              // product = divisor * trial digit.
              prod = multiplyInteger(yd, k);
              prodL = prod.length;
              remL = rem.length;

              // Compare product and remainder.
              cmp = compare(prod, rem, prodL, remL);

              // product > remainder.
              if (cmp == 1) {
                k--;

                // Subtract divisor from product.
                subtract(prod, yL < prodL ? yz : yd, prodL);
              }
            } else {

              // cmp is -1.
              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
              if (k == 0) cmp = k = 1;
              prod = yd.slice();
            }

            prodL = prod.length;
            if (prodL < remL) prod.unshift(0);

            // Subtract product from remainder.
            subtract(rem, prod, remL);

            // If product was < previous remainder.
            if (cmp == -1) {
              remL = rem.length;

              // Compare divisor and new remainder.
              cmp = compare(yd, rem, yL, remL);

              // If divisor < new remainder, subtract divisor from remainder.
              if (cmp < 1) {
                k++;

                // Subtract divisor from remainder.
                subtract(rem, yL < remL ? yz : yd, remL);
              }
            }

            remL = rem.length;
          } else if (cmp === 0) {
            k++;
            rem = [0];
          }    // if cmp === 1, k will be 0

          // Add the next digit, k, to the result array.
          qd[i++] = k;

          // Update the remainder.
          if (cmp && rem[0]) {
            rem[remL++] = xd[xi] || 0;
          } else {
            rem = [xd[xi]];
            remL = 1;
          }

        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
      }

      // Leading zero?
      if (!qd[0]) qd.shift();

      q.e = e;

      return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
    };
  })();


  /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */
  function exp(x, sd) {
    var denominator, guard, pow, sum, t, wpr,
      i = 0,
      k = 0,
      Ctor = x.constructor,
      pr = Ctor.precision;

    if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));

    // exp(0) = 1
    if (!x.s) return new Ctor(ONE);

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    t = new Ctor(0.03125);

    while (x.abs().gte(0.1)) {
      x = x.times(t);    // x = x / 2^5
      k += 5;
    }

    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
    wpr += guard;
    denominator = pow = sum = new Ctor(ONE);
    Ctor.precision = wpr;

    for (;;) {
      pow = round(pow.times(x), wpr);
      denominator = denominator.times(++i);
      t = sum.plus(divide(pow, denominator, wpr));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        while (k--) sum = round(sum.times(sum), wpr);
        Ctor.precision = pr;
        return sd == null ? (external = true, round(sum, pr)) : sum;
      }

      sum = t;
    }
  }


  // Calculate the base 10 exponent from the base 1e7 exponent.
  function getBase10Exponent(x) {
    var e = x.e * LOG_BASE,
      w = x.d[0];

    // Add the number of digits of the first word of the digits array.
    for (; w >= 10; w /= 10) e++;
    return e;
  }


  function getLn10(Ctor, sd, pr) {

    if (sd > Ctor.LN10.sd()) {


      // Reset global state in case the exception is caught.
      external = true;
      if (pr) Ctor.precision = pr;
      throw Error(decimalError + 'LN10 precision limit exceeded');
    }

    return round(new Ctor(Ctor.LN10), sd);
  }


  function getZeroString(k) {
    var zs = '';
    for (; k--;) zs += '0';
    return zs;
  }


  /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */
  function ln(y, sd) {
    var c, c0, denominator, e, numerator, sum, t, wpr, x2,
      n = 1,
      guard = 10,
      x = y,
      xd = x.d,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // ln(-x) = NaN
    // ln(0) = -Infinity
    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

    // ln(1) = 0
    if (x.eq(ONE)) return new Ctor(0);

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    if (x.eq(10)) {
      if (sd == null) external = true;
      return getLn10(Ctor, wpr);
    }

    wpr += guard;
    Ctor.precision = wpr;
    c = digitsToString(xd);
    c0 = c.charAt(0);
    e = getBase10Exponent(x);

    if (Math.abs(e) < 1.5e15) {

      // Argument reduction.
      // The series converges faster the closer the argument is to 1, so using
      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
      // later be divided by this number, then separate out the power of 10 using
      // ln(a*10^b) = ln(a) + b*ln(10).

      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
      // max n is 6 (gives 0.7 - 1.3)
      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
        x = x.times(y);
        c = digitsToString(x.d);
        c0 = c.charAt(0);
        n++;
      }

      e = getBase10Exponent(x);

      if (c0 > 1) {
        x = new Ctor('0.' + c);
        e++;
      } else {
        x = new Ctor(c0 + '.' + c.slice(1));
      }
    } else {

      // The argument reduction method above may result in overflow if the argument y is a massive
      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
      // function using ln(x*10^e) = ln(x) + e*ln(10).
      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
      x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);

      Ctor.precision = pr;
      return sd == null ? (external = true, round(x, pr)) : x;
    }

    // x is reduced to a value near 1.

    // Taylor series.
    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
    // where x = (y - 1)/(y + 1)    (|x| < 1)
    sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
    x2 = round(x.times(x), wpr);
    denominator = 3;

    for (;;) {
      numerator = round(numerator.times(x2), wpr);
      t = sum.plus(divide(numerator, new Ctor(denominator), wpr));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        sum = sum.times(2);

        // Reverse the argument reduction.
        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
        sum = divide(sum, new Ctor(n), wpr);

        Ctor.precision = pr;
        return sd == null ? (external = true, round(sum, pr)) : sum;
      }

      sum = t;
      denominator += 2;
    }
  }


  /*
   * Parse the value of a new Decimal `x` from string `str`.
   */
  function parseDecimal(x, str) {
    var e, i, len;

    // Decimal point?
    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

    // Exponential form?
    if ((i = str.search(/e/i)) > 0) {

      // Determine exponent.
      if (e < 0) e = i;
      e += +str.slice(i + 1);
      str = str.substring(0, i);
    } else if (e < 0) {

      // Integer.
      e = str.length;
    }

    // Determine leading zeros.
    for (i = 0; str.charCodeAt(i) === 48;) ++i;

    // Determine trailing zeros.
    for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
    str = str.slice(i, len);

    if (str) {
      len -= i;
      e = e - i - 1;
      x.e = mathfloor(e / LOG_BASE);
      x.d = [];

      // Transform base

      // e is the base 10 exponent.
      // i is where to slice str to get the first word of the digits array.
      i = (e + 1) % LOG_BASE;
      if (e < 0) i += LOG_BASE;

      if (i < len) {
        if (i) x.d.push(+str.slice(0, i));
        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
        str = str.slice(i);
        i = LOG_BASE - str.length;
      } else {
        i -= len;
      }

      for (; i--;) str += '0';
      x.d.push(+str);

      if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
    } else {

      // Zero.
      x.s = 0;
      x.e = 0;
      x.d = [0];
    }

    return x;
  }


  /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */
   function round(x, sd, rm) {
    var i, j, k, n, rd, doRound, w, xdi,
      xd = x.d;

    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
    // w: the word of xd which contains the rounding digit, a base 1e7 number.
    // xdi: the index of w within xd.
    // n: the number of digits of w.
    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
    // they had leading zeros)
    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

    // Get the length of the first word of the digits array xd.
    for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
    i = sd - n;

    // Is the rounding digit in the first word of xd?
    if (i < 0) {
      i += LOG_BASE;
      j = sd;
      w = xd[xdi = 0];
    } else {
      xdi = Math.ceil((i + 1) / LOG_BASE);
      k = xd.length;
      if (xdi >= k) return x;
      w = k = xd[xdi];

      // Get the number of digits of w.
      for (n = 1; k >= 10; k /= 10) n++;

      // Get the index of rd within w.
      i %= LOG_BASE;

      // Get the index of rd within w, adjusted for leading zeros.
      // The number of leading zeros of w is given by LOG_BASE - n.
      j = i - LOG_BASE + n;
    }

    if (rm !== void 0) {
      k = mathpow(10, n - j - 1);

      // Get the rounding digit at index j of w.
      rd = w / k % 10 | 0;

      // Are there any non-zero digits after the rounding digit?
      doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;

      // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
      // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
      // 714.

      doRound = rm < 4
        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
        : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&

          // Check whether the digit to the left of the rounding digit is odd.
          ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
            rm == (x.s < 0 ? 8 : 7));
    }

    if (sd < 1 || !xd[0]) {
      if (doRound) {
        k = getBase10Exponent(x);
        xd.length = 1;

        // Convert sd to decimal places.
        sd = sd - k - 1;

        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
        x.e = mathfloor(-sd / LOG_BASE) || 0;
      } else {
        xd.length = 1;

        // Zero.
        xd[0] = x.e = x.s = 0;
      }

      return x;
    }

    // Remove excess digits.
    if (i == 0) {
      xd.length = xdi;
      k = 1;
      xdi--;
    } else {
      xd.length = xdi + 1;
      k = mathpow(10, LOG_BASE - i);

      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
      // j > 0 means i > number of leading zeros of w.
      xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
    }

    if (doRound) {
      for (;;) {

        // Is the digit to be rounded up in the first word of xd?
        if (xdi == 0) {
          if ((xd[0] += k) == BASE) {
            xd[0] = 1;
            ++x.e;
          }

          break;
        } else {
          xd[xdi] += k;
          if (xd[xdi] != BASE) break;
          xd[xdi--] = 0;
          k = 1;
        }
      }
    }

    // Remove trailing zeros.
    for (i = xd.length; xd[--i] === 0;) xd.pop();

    if (external && (x.e > MAX_E || x.e < -MAX_E)) {
      throw Error(exponentOutOfRange + getBase10Exponent(x));
    }

    return x;
  }


  function subtract(x, y) {
    var d, e, i, j, k, len, xd, xe, xLTy, yd,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // Return y negated if x is zero.
    // Return x if y is zero and x is non-zero.
    if (!x.s || !y.s) {
      if (y.s) y.s = -y.s;
      else y = new Ctor(x);
      return external ? round(y, pr) : y;
    }

    xd = x.d;
    yd = y.d;

    // x and y are non-zero numbers with the same sign.

    e = y.e;
    xe = x.e;
    xd = xd.slice();
    k = xe - e;

    // If exponents differ...
    if (k) {
      xLTy = k < 0;

      if (xLTy) {
        d = xd;
        k = -k;
        len = yd.length;
      } else {
        d = yd;
        e = xe;
        len = xd.length;
      }

      // Numbers with massively different exponents would result in a very high number of zeros
      // needing to be prepended, but this can be avoided while still ensuring correct rounding by
      // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

      if (k > i) {
        k = i;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents.
      d.reverse();
      for (i = k; i--;) d.push(0);
      d.reverse();

    // Base 1e7 exponents equal.
    } else {

      // Check digits to determine which is the bigger number.

      i = xd.length;
      len = yd.length;
      xLTy = i < len;
      if (xLTy) len = i;

      for (i = 0; i < len; i++) {
        if (xd[i] != yd[i]) {
          xLTy = xd[i] < yd[i];
          break;
        }
      }

      k = 0;
    }

    if (xLTy) {
      d = xd;
      xd = yd;
      yd = d;
      y.s = -y.s;
    }

    len = xd.length;

    // Append zeros to xd if shorter.
    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

    // Subtract yd from xd.
    for (i = yd.length; i > k;) {
      if (xd[--i] < yd[i]) {
        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
        --xd[j];
        xd[i] += BASE;
      }

      xd[i] -= yd[i];
    }

    // Remove trailing zeros.
    for (; xd[--len] === 0;) xd.pop();

    // Remove leading zeros and adjust exponent accordingly.
    for (; xd[0] === 0; xd.shift()) --e;

    // Zero?
    if (!xd[0]) return new Ctor(0);

    y.d = xd;
    y.e = e;

    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
    return external ? round(y, pr) : y;
  }


  function toString(x, isExp, sd) {
    var k,
      e = getBase10Exponent(x),
      str = digitsToString(x.d),
      len = str.length;

    if (isExp) {
      if (sd && (k = sd - len) > 0) {
        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
      } else if (len > 1) {
        str = str.charAt(0) + '.' + str.slice(1);
      }

      str = str + (e < 0 ? 'e' : 'e+') + e;
    } else if (e < 0) {
      str = '0.' + getZeroString(-e - 1) + str;
      if (sd && (k = sd - len) > 0) str += getZeroString(k);
    } else if (e >= len) {
      str += getZeroString(e + 1 - len);
      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
    } else {
      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
      if (sd && (k = sd - len) > 0) {
        if (e + 1 === len) str += '.';
        str += getZeroString(k);
      }
    }

    return x.s < 0 ? '-' + str : str;
  }


  // Does not strip trailing zeros.
  function truncate(arr, len) {
    if (arr.length > len) {
      arr.length = len;
      return true;
    }
  }


  // Decimal methods


  /*
   *  clone
   *  config/set
   */


  /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */
  function clone(obj) {
    var i, p, ps;

    /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */
    function Decimal(value) {
      var x = this;

      // Decimal called without new.
      if (!(x instanceof Decimal)) return new Decimal(value);

      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
      // which points to Object.
      x.constructor = Decimal;

      // Duplicate.
      if (value instanceof Decimal) {
        x.s = value.s;
        x.e = value.e;
        x.d = (value = value.d) ? value.slice() : value;
        return;
      }

      if (typeof value === 'number') {

        // Reject Infinity/NaN.
        if (value * 0 !== 0) {
          throw Error(invalidArgument + value);
        }

        if (value > 0) {
          x.s = 1;
        } else if (value < 0) {
          value = -value;
          x.s = -1;
        } else {
          x.s = 0;
          x.e = 0;
          x.d = [0];
          return;
        }

        // Fast path for small integers.
        if (value === ~~value && value < 1e7) {
          x.e = 0;
          x.d = [value];
          return;
        }

        return parseDecimal(x, value.toString());
      } else if (typeof value !== 'string') {
        throw Error(invalidArgument + value);
      }

      // Minus sign?
      if (value.charCodeAt(0) === 45) {
        value = value.slice(1);
        x.s = -1;
      } else {
        x.s = 1;
      }

      if (isDecimal.test(value)) parseDecimal(x, value);
      else throw Error(invalidArgument + value);
    }

    Decimal.prototype = P;

    Decimal.ROUND_UP = 0;
    Decimal.ROUND_DOWN = 1;
    Decimal.ROUND_CEIL = 2;
    Decimal.ROUND_FLOOR = 3;
    Decimal.ROUND_HALF_UP = 4;
    Decimal.ROUND_HALF_DOWN = 5;
    Decimal.ROUND_HALF_EVEN = 6;
    Decimal.ROUND_HALF_CEIL = 7;
    Decimal.ROUND_HALF_FLOOR = 8;

    Decimal.clone = clone;
    Decimal.config = Decimal.set = config;

    if (obj === void 0) obj = {};
    if (obj) {
      ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
      for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
    }

    Decimal.config(obj);

    return Decimal;
  }


  /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */
  function config(obj) {
    if (!obj || typeof obj !== 'object') {
      throw Error(decimalError + 'Object expected');
    }
    var i, p, v,
      ps = [
        'precision', 1, MAX_DIGITS,
        'rounding', 0, 8,
        'toExpNeg', -1 / 0, 0,
        'toExpPos', 0, 1 / 0
      ];

    for (i = 0; i < ps.length; i += 3) {
      if ((v = obj[p = ps[i]]) !== void 0) {
        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
        else throw Error(invalidArgument + p + ': ' + v);
      }
    }

    if ((v = obj[p = 'LN10']) !== void 0) {
        if (v == Math.LN10) this[p] = new this(v);
        else throw Error(invalidArgument + p + ': ' + v);
    }

    return this;
  }


  // Create and configure initial Decimal constructor.
  Decimal = clone(Decimal);

  Decimal['default'] = Decimal.Decimal = Decimal;

  // Internal constant.
  ONE = new Decimal(1);


  // Export.


  // AMD.
  if (module.exports) {
    module.exports = Decimal;

    // Browser.
  } else {
    if (!globalScope) {
      globalScope = typeof self != 'undefined' && self && self.self == self
        ? self : Function('return this')();
    }

    globalScope.Decimal = Decimal;
  }
})(commonjsGlobal$1);
}(decimal));

var utils$3 = {};

Object.defineProperty(utils$3, "__esModule", {
  value: true
});
utils$3.memoize = utils$3.reverse = utils$3.compose = utils$3.map = utils$3.range = utils$3.curry = utils$3.PLACE_HOLDER = void 0;

function _toConsumableArray$b(arr) { return _arrayWithoutHoles$b(arr) || _iterableToArray$c(arr) || _unsupportedIterableToArray$v(arr) || _nonIterableSpread$b(); }

function _nonIterableSpread$b() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$v(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$v(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$v(o, minLen); }

function _iterableToArray$c(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$b(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$v(arr); }

function _arrayLikeToArray$v(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var identity = function identity(i) {
  return i;
};

var PLACE_HOLDER = {
  '@@functional/placeholder': true
};
utils$3.PLACE_HOLDER = PLACE_HOLDER;

var isPlaceHolder = function isPlaceHolder(val) {
  return val === PLACE_HOLDER;
};

var curry0 = function curry0(fn) {
  return function _curried() {
    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
      return _curried;
    }

    return fn.apply(void 0, arguments);
  };
};

var curryN = function curryN(n, fn) {
  if (n === 1) {
    return fn;
  }

  return curry0(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsLength = args.filter(function (arg) {
      return arg !== PLACE_HOLDER;
    }).length;

    if (argsLength >= n) {
      return fn.apply(void 0, args);
    }

    return curryN(n - argsLength, curry0(function () {
      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restArgs[_key2] = arguments[_key2];
      }

      var newArgs = args.map(function (arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });
      return fn.apply(void 0, _toConsumableArray$b(newArgs).concat(restArgs));
    }));
  });
};

var curry$4 = function curry(fn) {
  return curryN(fn.length, fn);
};

utils$3.curry = curry$4;

var range$1 = function range(begin, end) {
  var arr = [];

  for (var i = begin; i < end; ++i) {
    arr[i - begin] = i;
  }

  return arr;
};

utils$3.range = range$1;
var map = curry$4(function (fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }

  return Object.keys(arr).map(function (key) {
    return arr[key];
  }).map(fn);
});
utils$3.map = map;

var compose$5 = function compose() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse(); // first function can receive multiply arguments

  var firstFn = fns[0];
  var tailsFn = fns.slice(1);
  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(void 0, arguments));
  };
};

utils$3.compose = compose$5;

var reverse$2 = function reverse(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  } // can be string


  return arr.split('').reverse.join('');
};

utils$3.reverse = reverse$2;

var memoize = function memoize(fn) {
  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (lastArgs && args.every(function (val, i) {
      return val === lastArgs[i];
    })) {
      return lastResult;
    }

    lastArgs = args;
    lastResult = fn.apply(void 0, args);
    return lastResult;
  };
};

utils$3.memoize = memoize;

var arithmetic = {};

Object.defineProperty(arithmetic, "__esModule", {
  value: true
});
arithmetic.default = void 0;

var _decimal$1 = _interopRequireDefault$$(decimal.exports);

var _utils$v = utils$3;

function _interopRequireDefault$$(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */
function getDigitCount(value) {
  var result;

  if (value === 0) {
    result = 1;
  } else {
    result = Math.floor(new _decimal$1.default(value).abs().log(10).toNumber()) + 1;
  }

  return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */


function rangeStep(start, end, step) {
  var num = new _decimal$1.default(start);
  var i = 0;
  var result = []; // magic number to prevent infinite loop

  while (num.lt(end) && i < 100000) {
    result.push(num.toNumber());
    num = num.add(step);
    i++;
  }

  return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */


var interpolateNumber = (0, _utils$v.curry)(function (a, b, t) {
  var newA = +a;
  var newB = +b;
  return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */

var uninterpolateNumber = (0, _utils$v.curry)(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */

var uninterpolateTruncation = (0, _utils$v.curry)(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return Math.max(0, Math.min(1, (x - a) / diff));
});
var _default$1 = {
  rangeStep: rangeStep,
  getDigitCount: getDigitCount,
  interpolateNumber: interpolateNumber,
  uninterpolateNumber: uninterpolateNumber,
  uninterpolateTruncation: uninterpolateTruncation
};
arithmetic.default = _default$1;

Object.defineProperty(getNiceTickValues$1, "__esModule", {
  value: true
});
getNiceTickValues$1.getTickValuesFixedDomain = getNiceTickValues$1.getTickValues = getNiceTickValues$1.getNiceTickValues = void 0;

var _decimal = _interopRequireDefault$_(decimal.exports);

var _utils$u = utils$3;

var _arithmetic = _interopRequireDefault$_(arithmetic);

function _interopRequireDefault$_(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray$a(arr) { return _arrayWithoutHoles$a(arr) || _iterableToArray$b(arr) || _unsupportedIterableToArray$u(arr) || _nonIterableSpread$a(); }

function _nonIterableSpread$a() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$b(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$a(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$u(arr); }

function _slicedToArray$g(arr, i) { return _arrayWithHoles$f(arr) || _iterableToArrayLimit$e(arr, i) || _unsupportedIterableToArray$u(arr, i) || _nonIterableRest$f(); }

function _nonIterableRest$f() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$u(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$u(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$u(o, minLen); }

function _arrayLikeToArray$u(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$e(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$f(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */
function getValidInterval(_ref) {
  var _ref2 = _slicedToArray$g(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  var validMin = min,
      validMax = max; // exchange

  if (min > max) {
    validMin = max;
    validMax = min;
  }

  return [validMin, validMax];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */


function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep.lte(0)) {
    return new _decimal.default(0);
  }

  var digitCount = _arithmetic.default.getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
  // order of magnitudes than the rough step


  var digitCountValue = new _decimal.default(10).pow(digitCount);
  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong

  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
  var amendStepRatio = new _decimal.default(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
  var formatStep = amendStepRatio.mul(digitCountValue);
  return allowDecimals ? formatStep : new _decimal.default(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */


function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var step = 1; // calculate the middle value of ticks

  var middle = new _decimal.default(value);

  if (!middle.isint() && allowDecimals) {
    var absVal = Math.abs(value);

    if (absVal < 1) {
      // The step should be a float number when the difference is smaller than 1
      step = new _decimal.default(10).pow(_arithmetic.default.getDigitCount(value) - 1);
      middle = new _decimal.default(Math.floor(middle.div(step).toNumber())).mul(step);
    } else if (absVal > 1) {
      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
      middle = new _decimal.default(Math.floor(value));
    }
  } else if (value === 0) {
    middle = new _decimal.default(Math.floor((tickCount - 1) / 2));
  } else if (!allowDecimals) {
    middle = new _decimal.default(Math.floor(value));
  }

  var middleIndex = Math.floor((tickCount - 1) / 2);
  var fn = (0, _utils$u.compose)((0, _utils$u.map)(function (n) {
    return middle.add(new _decimal.default(n - middleIndex).mul(step)).toNumber();
  }), _utils$u.range);
  return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */


function calculateStep(min, max, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // dirty hack (for recharts' test)
  if (!Number.isFinite((max - min) / (tickCount - 1))) {
    return {
      step: new _decimal.default(0),
      tickMin: new _decimal.default(0),
      tickMax: new _decimal.default(0)
    };
  } // The step which is easy to understand between two ticks


  var step = getFormatStep(new _decimal.default(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks

  var middle; // When 0 is inside the interval, 0 should be a tick

  if (min <= 0 && max >= 0) {
    middle = new _decimal.default(0);
  } else {
    // calculate the middle value
    middle = new _decimal.default(min).add(max).div(2); // minus modulo value

    middle = middle.sub(new _decimal.default(middle).mod(step));
  }

  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
  var upCount = Math.ceil(new _decimal.default(max).sub(middle).div(step).toNumber());
  var scaleCount = belowCount + upCount + 1;

  if (scaleCount > tickCount) {
    // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
  }

  if (scaleCount < tickCount) {
    // When less ticks can cover the interval, we should add some additional ticks
    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }

  return {
    step: step,
    tickMin: middle.sub(new _decimal.default(belowCount).mul(step)),
    tickMax: middle.add(new _decimal.default(upCount).mul(step))
  };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray$g(_ref3, 2),
      min = _ref4[0],
      max = _ref4[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval = getValidInterval([min, max]),
      _getValidInterval2 = _slicedToArray$g(_getValidInterval, 2),
      cormin = _getValidInterval2[0],
      cormax = _getValidInterval2[1];

  if (cormin === -Infinity || cormax === Infinity) {
    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray$a((0, _utils$u.range)(0, tickCount - 1).map(function () {
      return Infinity;
    }))) : [].concat(_toConsumableArray$a((0, _utils$u.range)(0, tickCount - 1).map(function () {
      return -Infinity;
    })), [cormax]);

    return min > max ? (0, _utils$u.reverse)(_values) : _values;
  }

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  } // Get the step between two ticks


  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
      step = _calculateStep.step,
      tickMin = _calculateStep.tickMin,
      tickMax = _calculateStep.tickMax;

  var values = _arithmetic.default.rangeStep(tickMin, tickMax.add(new _decimal.default(0.1).mul(step)), step);

  return min > max ? (0, _utils$u.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getTickValuesFn(_ref5) {
  var _ref6 = _slicedToArray$g(_ref5, 2),
      min = _ref6[0],
      max = _ref6[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval3 = getValidInterval([min, max]),
      _getValidInterval4 = _slicedToArray$g(_getValidInterval3, 2),
      cormin = _getValidInterval4[0],
      cormax = _getValidInterval4[1];

  if (cormin === -Infinity || cormax === Infinity) {
    return [min, max];
  }

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }

  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
  var fn = (0, _utils$u.compose)((0, _utils$u.map)(function (n) {
    return new _decimal.default(cormin).add(new _decimal.default(n).mul(step)).toNumber();
  }), _utils$u.range);
  var values = fn(0, count).filter(function (entry) {
    return entry >= cormin && entry <= cormax;
  });
  return min > max ? (0, _utils$u.reverse)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray$g(_ref7, 2),
      min = _ref8[0],
      max = _ref8[1];

  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var _getValidInterval5 = getValidInterval([min, max]),
      _getValidInterval6 = _slicedToArray$g(_getValidInterval5, 2),
      cormin = _getValidInterval6[0],
      cormax = _getValidInterval6[1];

  if (cormin === -Infinity || cormax === Infinity) {
    return [min, max];
  }

  if (cormin === cormax) {
    return [cormin];
  }

  var count = Math.max(tickCount, 2);
  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
  var values = [].concat(_toConsumableArray$a(_arithmetic.default.rangeStep(new _decimal.default(cormin), new _decimal.default(cormax).sub(new _decimal.default(0.99).mul(step)), step)), [cormax]);
  return min > max ? (0, _utils$u.reverse)(values) : values;
}

var getNiceTickValues = (0, _utils$u.memoize)(getNiceTickValuesFn);
getNiceTickValues$1.getNiceTickValues = getNiceTickValues;
var getTickValues = (0, _utils$u.memoize)(getTickValuesFn);
getNiceTickValues$1.getTickValues = getTickValues;
var getTickValuesFixedDomain = (0, _utils$u.memoize)(getTickValuesFixedDomainFn);
getNiceTickValues$1.getTickValuesFixedDomain = getTickValuesFixedDomain;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getTickValues", {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValues;
  }
});
Object.defineProperty(exports, "getNiceTickValues", {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getNiceTickValues;
  }
});
Object.defineProperty(exports, "getTickValuesFixedDomain", {
  enumerable: true,
  get: function get() {
    return _getNiceTickValues.getTickValuesFixedDomain;
  }
});

var _getNiceTickValues = getNiceTickValues$1;
}(lib$1));

var ErrorBar$1 = {};

var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

var tinyInvariant_cjs = invariant;

Object.defineProperty(ErrorBar$1, "__esModule", {
  value: true
});
ErrorBar$1.ErrorBar = void 0;
var _react$Q = _interopRequireDefault$Z(React__default$4);
var _tinyInvariant$3 = _interopRequireDefault$Z(tinyInvariant_cjs);
var _Layer$m = Layer;
var _ReactUtils$y = ReactUtils;
var _excluded$n = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function _interopRequireDefault$Z(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$R(o) { "@babel/helpers - typeof"; return _typeof$R = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$R(o); }
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
function _slicedToArray$f(arr, i) { return _arrayWithHoles$e(arr) || _iterableToArrayLimit$d(arr, i) || _unsupportedIterableToArray$t(arr, i) || _nonIterableRest$e(); }
function _nonIterableRest$e() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$t(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$t(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$t(o, minLen); }
function _arrayLikeToArray$t(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$d(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$e(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties$q(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$n(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$n(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _classCallCheck$E(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$y(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$K(descriptor.key), descriptor); } }
function _createClass$E(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$y(Constructor.prototype, protoProps); if (staticProps) _defineProperties$y(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$l(t, o, e) { return o = _getPrototypeOf$o(o), _possibleConstructorReturn$u(t, _isNativeReflectConstruct$o() ? Reflect.construct(o, e || [], _getPrototypeOf$o(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$u(self, call) { if (call && (_typeof$R(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$o(self); }
function _assertThisInitialized$o(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$o() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$o = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$o(o) { _getPrototypeOf$o = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$o(o); }
function _inherits$u(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$o(subClass, superClass); }
function _setPrototypeOf$o(o, p) { _setPrototypeOf$o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$o(o, p); }
function _defineProperty$S(obj, key, value) { key = _toPropertyKey$K(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$K(t) { var i = _toPrimitive$K(t, "string"); return "symbol" == _typeof$R(i) ? i : i + ""; }
function _toPrimitive$K(t, r) { if ("object" != _typeof$R(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$R(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Render a group of error bar
 */
// eslint-disable-next-line react/prefer-stateless-function -- requires static defaultProps
var ErrorBar = ErrorBar$1.ErrorBar = /*#__PURE__*/function (_React$Component) {
  function ErrorBar() {
    _classCallCheck$E(this, ErrorBar);
    return _callSuper$l(this, ErrorBar, arguments);
  }
  _inherits$u(ErrorBar, _React$Component);
  return _createClass$E(ErrorBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        offset = _this$props.offset,
        layout = _this$props.layout,
        width = _this$props.width,
        dataKey = _this$props.dataKey,
        data = _this$props.data,
        dataPointFormatter = _this$props.dataPointFormatter,
        xAxis = _this$props.xAxis,
        yAxis = _this$props.yAxis,
        others = _objectWithoutProperties$q(_this$props, _excluded$n);
      var svgProps = (0, _ReactUtils$y.filterProps)(others, false);
      !!(this.props.direction === 'x' && xAxis.type !== 'number') ? process.env.NODE_ENV !== "production" ? (0, _tinyInvariant$3["default"])(false, 'ErrorBar requires Axis type property to be "number".') : (0, _tinyInvariant$3["default"])(false) : void 0;
      var errorBars = data.map(function (entry) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
          x = _dataPointFormatter.x,
          y = _dataPointFormatter.y,
          value = _dataPointFormatter.value,
          errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) {
          return null;
        }
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
          var _errorVal = _slicedToArray$f(errorVal, 2);
          lowBound = _errorVal[0];
          highBound = _errorVal[1];
        } else {
          lowBound = highBound = errorVal;
        }
        if (layout === 'vertical') {
          // error bar for horizontal charts, the y is fixed, x is a range value
          var scale = xAxis.scale;
          var yMid = y + offset;
          var yMin = yMid + width;
          var yMax = yMid - width;
          var xMin = scale(value - lowBound);
          var xMax = scale(value + highBound);

          // the right line of |--|
          lineCoordinates.push({
            x1: xMax,
            y1: yMin,
            x2: xMax,
            y2: yMax
          });
          // the middle line of |--|
          lineCoordinates.push({
            x1: xMin,
            y1: yMid,
            x2: xMax,
            y2: yMid
          });
          // the left line of |--|
          lineCoordinates.push({
            x1: xMin,
            y1: yMin,
            x2: xMin,
            y2: yMax
          });
        } else if (layout === 'horizontal') {
          // error bar for horizontal charts, the x is fixed, y is a range value
          var _scale = yAxis.scale;
          var xMid = x + offset;
          var _xMin = xMid - width;
          var _xMax = xMid + width;
          var _yMin = _scale(value - lowBound);
          var _yMax = _scale(value + highBound);

          // the top line
          lineCoordinates.push({
            x1: _xMin,
            y1: _yMax,
            x2: _xMax,
            y2: _yMax
          });
          // the middle line
          lineCoordinates.push({
            x1: xMid,
            y1: _yMin,
            x2: xMid,
            y2: _yMax
          });
          // the bottom line
          lineCoordinates.push({
            x1: _xMin,
            y1: _yMin,
            x2: _xMax,
            y2: _yMin
          });
        }
        return /*#__PURE__*/_react$Q["default"].createElement(_Layer$m.Layer, _extends$H({
          className: "recharts-errorBar",
          key: "bar-".concat(lineCoordinates.map(function (c) {
            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
          }))
        }, svgProps), lineCoordinates.map(function (coordinates) {
          return /*#__PURE__*/_react$Q["default"].createElement("line", _extends$H({}, coordinates, {
            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
          }));
        }));
      });
      return /*#__PURE__*/_react$Q["default"].createElement(_Layer$m.Layer, {
        className: "recharts-errorBars"
      }, errorBars);
    }
  }]);
}(_react$Q["default"].Component);
_defineProperty$S(ErrorBar, "defaultProps", {
  stroke: 'black',
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: 'horizontal'
});
_defineProperty$S(ErrorBar, "displayName", 'ErrorBar');

var getLegendProps = {};

Object.defineProperty(getLegendProps, "__esModule", {
  value: true
});
getLegendProps.getLegendProps = void 0;
var _Legend$1 = Legend$1;
var _ChartUtils$i = ChartUtils;
var _ReactUtils$x = ReactUtils;
function _typeof$Q(o) { "@babel/helpers - typeof"; return _typeof$Q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$Q(o); }
function ownKeys$M(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$K(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$M(Object(t), !0).forEach(function (r) { _defineProperty$R(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$M(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$R(obj, key, value) { key = _toPropertyKey$J(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$J(t) { var i = _toPrimitive$J(t, "string"); return "symbol" == _typeof$Q(i) ? i : i + ""; }
function _toPrimitive$J(t, r) { if ("object" != _typeof$Q(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$Q(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
getLegendProps.getLegendProps = function getLegendProps(_ref) {
  var children = _ref.children,
    formattedGraphicalItems = _ref.formattedGraphicalItems,
    legendWidth = _ref.legendWidth,
    legendContent = _ref.legendContent;
  var legendItem = (0, _ReactUtils$x.findChildByType)(children, _Legend$1.Legend);
  if (!legendItem) {
    return null;
  }
  var legendDefaultProps = _Legend$1.Legend.defaultProps;
  var legendProps = legendDefaultProps !== undefined ? _objectSpread$K(_objectSpread$K({}, legendDefaultProps), legendItem.props) : {};
  var legendData;
  if (legendItem.props && legendItem.props.payload) {
    legendData = legendItem.props && legendItem.props.payload;
  } else if (legendContent === 'children') {
    legendData = (formattedGraphicalItems || []).reduce(function (result, _ref2) {
      var item = _ref2.item,
        props = _ref2.props;
      var data = props.sectors || props.data || [];
      return result.concat(data.map(function (entry) {
        return {
          type: legendItem.props.iconType || item.props.legendType,
          value: entry.name,
          color: entry.fill,
          payload: entry
        };
      }));
    }, []);
  } else {
    legendData = (formattedGraphicalItems || []).map(function (_ref3) {
      var item = _ref3.item;
      var itemDefaultProps = item.type.defaultProps;
      var itemProps = itemDefaultProps !== undefined ? _objectSpread$K(_objectSpread$K({}, itemDefaultProps), item.props) : {};
      var dataKey = itemProps.dataKey,
        name = itemProps.name,
        legendType = itemProps.legendType,
        hide = itemProps.hide;
      return {
        inactive: hide,
        dataKey: dataKey,
        type: legendProps.iconType || legendType || 'square',
        color: (0, _ChartUtils$i.getMainColorOfGraphicItem)(item),
        value: name || dataKey,
        // @ts-expect-error property strokeDasharray is required in Payload but optional in props
        payload: itemProps
      };
    });
  }
  return _objectSpread$K(_objectSpread$K(_objectSpread$K({}, legendProps), _Legend$1.Legend.getWithHeight(legendItem, legendWidth)), {}, {
    payload: legendData,
    item: legendItem
  });
};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCateCoordinateOfBar = exports.getBaseValueOfBar = exports.getBarSizeList = exports.getBarPosition = exports.getBandSizeOfAxis = exports.findPositionOfBar = exports.combineEventHandlers = exports.checkDomainOfScale = exports.calculateActiveTickIndex = exports.appendOffsetOfLegend = exports.MIN_VALUE_REG = exports.MAX_VALUE_REG = void 0;
exports.getCateCoordinateOfLine = getCateCoordinateOfLine;
exports.getCoordinatesOfGrid = void 0;
exports.getDomainOfDataByKey = getDomainOfDataByKey;
exports.getDomainOfStackGroups = exports.getDomainOfItemsWithSameAxis = exports.getDomainOfErrorBars = void 0;
Object.defineProperty(exports, "getLegendProps", {
  enumerable: true,
  get: function get() {
    return _getLegendProps.getLegendProps;
  }
});
exports.getTooltipItem = exports.getTicksOfScale = exports.getTicksOfAxis = exports.getStackedDataOfItem = exports.getStackedData = exports.getStackGroupsByAxisId = exports.getMainColorOfGraphicItem = void 0;
exports.getValueByDataKey = getValueByDataKey;
exports.truncateByDomain = exports.parseSpecifiedDomain = exports.parseScale = exports.parseErrorBarsOfAxis = exports.parseDomainOfCategoryAxis = exports.offsetSign = exports.offsetPositive = exports.isCategoricalAxis = void 0;
var d3Scales = _interopRequireWildcard(d3Scale);
var _d3Shape = d3Shape;
var _max = _interopRequireDefault(max_1);
var _min = _interopRequireDefault(min_1);
var _isNil = _interopRequireDefault(isNil_1);
var _isFunction = _interopRequireDefault(isFunction_1);
var _isString = _interopRequireDefault(isString_1);
var _get = _interopRequireDefault(get_1);
var _flatMap = _interopRequireDefault(flatMap_1);
var _isNaN = _interopRequireDefault(_isNaN$3);
var _upperFirst = _interopRequireDefault(upperFirst_1);
var _isEqual = _interopRequireDefault(isEqual_1);
var _sortBy = _interopRequireDefault(sortBy_1);
var _rechartsScale = lib$1;
var _ErrorBar = ErrorBar$1;
var _DataUtils = DataUtils;
var _ReactUtils = ReactUtils;
var _getLegendProps = getLegendProps;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // TODO: Cause of circular dependency. Needs refactor.
// import { RadiusAxisProps, AngleAxisProps } from '../polar/types';
// Exported for backwards compatibility
function getValueByDataKey(obj, dataKey, defaultValue) {
  if ((0, _isNil["default"])(obj) || (0, _isNil["default"])(dataKey)) {
    return defaultValue;
  }
  if ((0, _DataUtils.isNumOrStr)(dataKey)) {
    return (0, _get["default"])(obj, dataKey, defaultValue);
  }
  if ((0, _isFunction["default"])(dataKey)) {
    return dataKey(obj);
  }
  return defaultValue;
}
/**
 * Get domain of data by key.
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */
function getDomainOfDataByKey(data, key, type, filterNil) {
  var flattenData = (0, _flatMap["default"])(data, function (entry) {
    return getValueByDataKey(entry, key);
  });
  if (type === 'number') {
    // @ts-expect-error parseFloat type only accepts strings
    var domain = flattenData.filter(function (entry) {
      return (0, _DataUtils.isNumber)(entry) || parseFloat(entry);
    });
    return domain.length ? [(0, _min["default"])(domain), (0, _max["default"])(domain)] : [Infinity, -Infinity];
  }
  var validateData = filterNil ? flattenData.filter(function (entry) {
    return !(0, _isNil["default"])(entry);
  }) : flattenData;

  // Supports x-axis of Date type
  return validateData.map(function (entry) {
    return (0, _DataUtils.isNumOrStr)(entry) || entry instanceof Date ? entry : '';
  });
}
exports.calculateActiveTickIndex = function calculateActiveTickIndex(coordinate) {
  var _ticks$length;
  var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
  var axis = arguments.length > 3 ? arguments[3] : undefined;
  var index = -1;
  var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;

  // if there are 1 or less ticks ticks then the active tick is at index 0
  if (len <= 1) {
    return 0;
  }
  if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
    var range = axis.range;
    // ticks are distributed in a circle
    for (var i = 0; i < len; i++) {
      var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
      var cur = unsortedTicks[i].coordinate;
      var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
      var sameDirectionCoord = void 0;
      if ((0, _DataUtils.mathSign)(cur - before) !== (0, _DataUtils.mathSign)(after - cur)) {
        var diffInterval = [];
        if ((0, _DataUtils.mathSign)(after - cur) === (0, _DataUtils.mathSign)(range[1] - range[0])) {
          sameDirectionCoord = after;
          var curInRange = cur + range[1] - range[0];
          diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
          diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
        } else {
          sameDirectionCoord = before;
          var afterInRange = after + range[1] - range[0];
          diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
          diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
        }
        var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
        if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
          index = unsortedTicks[i].index;
          break;
        }
      } else {
        var minValue = Math.min(before, after);
        var maxValue = Math.max(before, after);
        if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
          index = unsortedTicks[i].index;
          break;
        }
      }
    }
  } else {
    // ticks are distributed in a single direction
    for (var _i = 0; _i < len; _i++) {
      if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
        index = ticks[_i].index;
        break;
      }
    }
  }
  return index;
};

/**
 * Get the main color of each graphic item
 * @param  {ReactElement} item A graphic item
 * @return {String}            Color
 */
var getMainColorOfGraphicItem = exports.getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
  var _item$type;
  var _ref = item,
    displayName = _ref.type.displayName; // TODO: check if displayName is valid.
  var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
  var stroke = defaultedProps.stroke,
    fill = defaultedProps.fill;
  var result;
  switch (displayName) {
    case 'Line':
      result = stroke;
      break;
    case 'Area':
    case 'Radar':
      result = stroke && stroke !== 'none' ? stroke : fill;
      break;
    default:
      result = fill;
      break;
  }
  return result;
};
/**
 * Calculate the size of all groups for stacked bar graph
 * @param  {Object} stackGroups The items grouped by axisId and stackId
 * @return {Object} The size of all groups
 */
exports.getBarSizeList = function getBarSizeList(_ref2) {
  var globalSize = _ref2.barSize,
    totalSize = _ref2.totalSize,
    _ref2$stackGroups = _ref2.stackGroups,
    stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
  if (!stackGroups) {
    return {};
  }
  var result = {};
  var numericAxisIds = Object.keys(stackGroups);
  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
    var stackIds = Object.keys(sgs);
    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]],
        items = _sgs$stackIds$j.items,
        cateAxisId = _sgs$stackIds$j.cateAxisId;
      var barItems = items.filter(function (item) {
        return (0, _ReactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
      });
      if (barItems && barItems.length) {
        var barItemDefaultProps = barItems[0].type.defaultProps;
        var barItemProps = barItemDefaultProps !== undefined ? _objectSpread(_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
        var selfSize = barItemProps.barSize;
        var cateId = barItemProps[cateAxisId];
        if (!result[cateId]) {
          result[cateId] = [];
        }
        var barSize = (0, _isNil["default"])(selfSize) ? globalSize : selfSize;
        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: (0, _isNil["default"])(barSize) ? undefined : (0, _DataUtils.getPercentValue)(barSize, totalSize, 0)
        });
      }
    }
  }
  return result;
};
/**
 * Calculate the size of each bar and offset between start of band and the bar
 *
 * @param  {number} bandSize is the size of area where bars can render
 * @param  {number | string} barGap is the gap size, as a percentage of `bandSize`.
 *                                  Can be defined as number or percent string
 * @param  {number | string} barCategoryGap is the gap size, as a percentage of `bandSize`.
 *                                  Can be defined as number or percent string
 * @param  {Array<object>} sizeList Sizes of all groups
 * @param  {number} maxBarSize The maximum size of each bar
 * @return {Array<object>} The size and offset of each bar
 */
exports.getBarPosition = function getBarPosition(_ref3) {
  var barGap = _ref3.barGap,
    barCategoryGap = _ref3.barCategoryGap,
    bandSize = _ref3.bandSize,
    _ref3$sizeList = _ref3.sizeList,
    sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList,
    maxBarSize = _ref3.maxBarSize;
  var len = sizeList.length;
  if (len < 1) return null;
  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
  var result;
  var initialValue = [];

  // whether or not is barSize setted by user
  if (sizeList[0].barSize === +sizeList[0].barSize) {
    var useFull = false;
    var fullBarSize = bandSize / len;
    // @ts-expect-error the type check above does not check for type number explicitly
    var sum = sizeList.reduce(function (res, entry) {
      return res + entry.barSize || 0;
    }, 0);
    sum += (len - 1) * realBarGap;
    if (sum >= bandSize) {
      sum -= (len - 1) * realBarGap;
      realBarGap = 0;
    }
    if (sum >= bandSize && fullBarSize > 0) {
      useFull = true;
      fullBarSize *= 0.9;
      sum = len * fullBarSize;
    }
    var offset = (bandSize - sum) / 2 >> 0;
    var prev = {
      offset: offset - realBarGap,
      size: 0
    };
    result = sizeList.reduce(function (res, entry) {
      var newPosition = {
        item: entry.item,
        position: {
          offset: prev.offset + prev.size + realBarGap,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: useFull ? fullBarSize : entry.barSize
        }
      };
      var newRes = [].concat(_toConsumableArray(res), [newPosition]);
      prev = newRes[newRes.length - 1].position;
      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: prev
          });
        });
      }
      return newRes;
    }, initialValue);
  } else {
    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
      realBarGap = 0;
    }
    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
    if (originalSize > 1) {
      originalSize >>= 0;
    }
    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
    result = sizeList.reduce(function (res, entry, i) {
      var newRes = [].concat(_toConsumableArray(res), [{
        item: entry.item,
        position: {
          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
          size: size
        }
      }]);
      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: newRes[newRes.length - 1].position
          });
        });
      }
      return newRes;
    }, initialValue);
  }
  return result;
};
exports.appendOffsetOfLegend = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
  var children = props.children,
    width = props.width,
    margin = props.margin;
  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
  var legendProps = (0, _getLegendProps.getLegendProps)({
    children: children,
    legendWidth: legendWidth
  });
  if (legendProps) {
    var _ref4 = legendBox || {},
      boxWidth = _ref4.width,
      boxHeight = _ref4.height;
    var align = legendProps.align,
      verticalAlign = legendProps.verticalAlign,
      layout = legendProps.layout;
    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, _DataUtils.isNumber)(offset[align])) {
      return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, align, offset[align] + (boxWidth || 0)));
    }
    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
      return _objectSpread(_objectSpread({}, offset), {}, _defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
  }
  return offset;
};
var isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
  if ((0, _isNil["default"])(axisType)) {
    return true;
  }
  if (layout === 'horizontal') {
    return axisType === 'yAxis';
  }
  if (layout === 'vertical') {
    return axisType === 'xAxis';
  }
  if (direction === 'x') {
    return axisType === 'xAxis';
  }
  if (direction === 'y') {
    return axisType === 'yAxis';
  }
  return true;
};
var getDomainOfErrorBars = exports.getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
  var children = item.props.children;
  var errorBars = (0, _ReactUtils.findAllByType)(children, _ErrorBar.ErrorBar).filter(function (errorBarChild) {
    return isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
  });
  if (errorBars && errorBars.length) {
    var keys = errorBars.map(function (errorBarChild) {
      return errorBarChild.props.dataKey;
    });
    return data.reduce(function (result, entry) {
      var entryValue = getValueByDataKey(entry, dataKey);
      if ((0, _isNil["default"])(entryValue)) return result;
      var mainValue = Array.isArray(entryValue) ? [(0, _min["default"])(entryValue), (0, _max["default"])(entryValue)] : [entryValue, entryValue];
      var errorDomain = keys.reduce(function (prevErrorArr, k) {
        var errorValue = getValueByDataKey(entry, k, 0);
        var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
        var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
      }, [Infinity, -Infinity]);
      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
    }, [Infinity, -Infinity]);
  }
  return null;
};
exports.parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
  var domains = items.map(function (item) {
    return getDomainOfErrorBars(data, item, dataKey, layout, axisType);
  }).filter(function (entry) {
    return !(0, _isNil["default"])(entry);
  });
  if (domains && domains.length) {
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }
  return null;
};

/**
 * Get domain of data by the configuration of item element
 * @param  {Array}   data      The data displayed in the chart
 * @param  {Array}   items     The instances of item
 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
 * @param  {LayoutType} layout The type of layout
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array}        Domain
 */
exports.getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
  var domains = items.map(function (item) {
    var dataKey = item.props.dataKey;
    if (type === 'number' && dataKey) {
      return getDomainOfErrorBars(data, item, dataKey, layout) || getDomainOfDataByKey(data, dataKey, type, filterNil);
    }
    return getDomainOfDataByKey(data, dataKey, type, filterNil);
  });
  if (type === 'number') {
    // Calculate the domain of number axis
    return domains.reduce(
    // @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }
  var tag = {};
  // Get the union set of category axis
  return domains.reduce(function (result, entry) {
    for (var i = 0, len = entry.length; i < len; i++) {
      // @ts-expect-error Date cannot index an object
      if (!tag[entry[i]]) {
        // @ts-expect-error Date cannot index an object
        tag[entry[i]] = true;

        // @ts-expect-error Date cannot index an object
        result.push(entry[i]);
      }
    }
    return result;
  }, []);
};
exports.isCategoricalAxis = function isCategoricalAxis(layout, axisType) {
  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};

/**
 * Calculate the Coordinates of grid
 * @param  {Array} ticks           The ticks in axis
 * @param {Number} minValue        The minimun value of axis
 * @param {Number} maxValue        The maximun value of axis
 * @param {boolean} syncWithTicks  Synchronize grid lines with ticks or not
 * @return {Array}                 Coordinates
 */
exports.getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
  if (syncWithTicks) {
    return ticks.map(function (entry) {
      return entry.coordinate;
    });
  }
  var hasMin, hasMax;
  var values = ticks.map(function (entry) {
    if (entry.coordinate === minValue) {
      hasMin = true;
    }
    if (entry.coordinate === maxValue) {
      hasMax = true;
    }
    return entry.coordinate;
  });
  if (!hasMin) {
    values.push(minValue);
  }
  if (!hasMax) {
    values.push(maxValue);
  }
  return values;
};

/**
 * Get the ticks of an axis
 * @param  {Object}  axis The configuration of an axis
 * @param {Boolean} isGrid Whether or not are the ticks in grid
 * @param {Boolean} isAll Return the ticks of all the points or not
 * @return {Array}  Ticks
 */
exports.getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale = axis.scale;
  var duplicateDomain = axis.duplicateDomain,
    type = axis.type,
    range = axis.range;
  var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
  offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, _DataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset;

  // The ticks set by user should only affect the ticks adjacent to axis line
  if (isGrid && (axis.ticks || axis.niceTicks)) {
    var result = (axis.ticks || axis.niceTicks).map(function (entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: scale(scaleContent) + offset,
        value: entry,
        offset: offset
      };
    });
    return result.filter(function (row) {
      return !(0, _isNaN["default"])(row.coordinate);
    });
  }

  // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
  if (axis.isCategorical && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function (entry, index) {
      return {
        coordinate: scale(entry) + offset,
        value: entry,
        index: index,
        offset: offset
      };
    });
  }
  if (scale.ticks && !isAll) {
    return scale.ticks(axis.tickCount).map(function (entry) {
      return {
        coordinate: scale(entry) + offset,
        value: entry,
        offset: offset
      };
    });
  }

  // When axis has duplicated text, serial numbers are used to generate scale
  return scale.domain().map(function (entry, index) {
    return {
      coordinate: scale(entry) + offset,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index,
      offset: offset
    };
  });
};

/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */

var handlerWeakMap = new WeakMap();
exports.combineEventHandlers = function combineEventHandlers(defaultHandler, childHandler) {
  if (typeof childHandler !== 'function') {
    return defaultHandler;
  }
  if (!handlerWeakMap.has(defaultHandler)) {
    handlerWeakMap.set(defaultHandler, new WeakMap());
  }
  var childWeakMap = handlerWeakMap.get(defaultHandler);
  if (childWeakMap.has(childHandler)) {
    return childWeakMap.get(childHandler);
  }
  var combineHandler = function combineHandler() {
    defaultHandler.apply(void 0, arguments);
    childHandler.apply(void 0, arguments);
  };
  childWeakMap.set(childHandler, combineHandler);
  return combineHandler;
};

/**
 * Parse the scale function of axis
 * @param  {Object}   axis          The option of axis
 * @param  {String}   chartType     The displayName of chart
 * @param  {Boolean}  hasBar        if it has a bar
 * @return {object}               The scale function and resolved name
 */
exports.parseScale = function parseScale(axis, chartType, hasBar) {
  var scale = axis.scale,
    type = axis.type,
    layout = axis.layout,
    axisType = axis.axisType;
  if (scale === 'auto') {
    if (layout === 'radial' && axisType === 'radiusAxis') {
      return {
        scale: d3Scales.scaleBand(),
        realScaleType: 'band'
      };
    }
    if (layout === 'radial' && axisType === 'angleAxis') {
      return {
        scale: d3Scales.scaleLinear(),
        realScaleType: 'linear'
      };
    }
    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) {
      return {
        scale: d3Scales.scalePoint(),
        realScaleType: 'point'
      };
    }
    if (type === 'category') {
      return {
        scale: d3Scales.scaleBand(),
        realScaleType: 'band'
      };
    }
    return {
      scale: d3Scales.scaleLinear(),
      realScaleType: 'linear'
    };
  }
  if ((0, _isString["default"])(scale)) {
    var name = "scale".concat((0, _upperFirst["default"])(scale));
    return {
      scale: (d3Scales[name] || d3Scales.scalePoint)(),
      realScaleType: d3Scales[name] ? name : 'point'
    };
  }
  return (0, _isFunction["default"])(scale) ? {
    scale: scale
  } : {
    scale: d3Scales.scalePoint(),
    realScaleType: 'point'
  };
};
var EPS = 1e-4;
exports.checkDomainOfScale = function checkDomainOfScale(scale) {
  var domain = scale.domain();
  if (!domain || domain.length <= 2) {
    return;
  }
  var len = domain.length;
  var range = scale.range();
  var minValue = Math.min(range[0], range[1]) - EPS;
  var maxValue = Math.max(range[0], range[1]) + EPS;
  var first = scale(domain[0]);
  var last = scale(domain[len - 1]);
  if (first < minValue || first > maxValue || last < minValue || last > maxValue) {
    scale.domain([domain[0], domain[len - 1]]);
  }
};
exports.findPositionOfBar = function findPositionOfBar(barPosition, child) {
  if (!barPosition) {
    return null;
  }
  for (var i = 0, len = barPosition.length; i < len; i++) {
    if (barPosition[i].item === child) {
      return barPosition[i].position;
    }
  }
  return null;
};

/**
 * Both value and domain are tuples of two numbers
 * - but the type stays as array of numbers until we have better support in rest of the app
 * @param {Array} value input that will be truncated
 * @param {Array} domain boundaries
 * @returns {Array} tuple of two numbers
 */
exports.truncateByDomain = function truncateByDomain(value, domain) {
  if (!domain || domain.length !== 2 || !(0, _DataUtils.isNumber)(domain[0]) || !(0, _DataUtils.isNumber)(domain[1])) {
    return value;
  }
  var minValue = Math.min(domain[0], domain[1]);
  var maxValue = Math.max(domain[0], domain[1]);
  var result = [value[0], value[1]];
  if (!(0, _DataUtils.isNumber)(value[0]) || value[0] < minValue) {
    result[0] = minValue;
  }
  if (!(0, _DataUtils.isNumber)(value[1]) || value[1] > maxValue) {
    result[1] = maxValue;
  }
  if (result[0] > maxValue) {
    result[0] = maxValue;
  }
  if (result[1] < minValue) {
    result[1] = minValue;
  }
  return result;
};

/**
 * Stacks all positive numbers above zero and all negative numbers below zero.
 *
 * If all values in the series are positive then this behaves the same as 'none' stacker.
 *
 * @param {Array} series from d3-shape Stack
 * @return {Array} series with applied offset
 */
var offsetSign = exports.offsetSign = function offsetSign(series) {
  var n = series.length;
  if (n <= 0) {
    return;
  }
  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    var negative = 0;
    for (var i = 0; i < n; ++i) {
      var value = (0, _isNaN["default"])(series[i][j][1]) ? series[i][j][0] : series[i][j][1];

      /* eslint-disable prefer-destructuring, no-param-reassign */
      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = negative;
        series[i][j][1] = negative + value;
        negative = series[i][j][1];
      }
      /* eslint-enable prefer-destructuring, no-param-reassign */
    }
  }
};

/**
 * Replaces all negative values with zero when stacking data.
 *
 * If all values in the series are positive then this behaves the same as 'none' stacker.
 *
 * @param {Array} series from d3-shape Stack
 * @return {Array} series with applied offset
 */
var offsetPositive = exports.offsetPositive = function offsetPositive(series) {
  var n = series.length;
  if (n <= 0) {
    return;
  }
  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    for (var i = 0; i < n; ++i) {
      var value = (0, _isNaN["default"])(series[i][j][1]) ? series[i][j][0] : series[i][j][1];

      /* eslint-disable prefer-destructuring, no-param-reassign */
      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = 0;
        series[i][j][1] = 0;
      }
      /* eslint-enable prefer-destructuring, no-param-reassign */
    }
  }
};

/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */

var STACK_OFFSET_MAP = {
  sign: offsetSign,
  // @ts-expect-error definitelytyped types are incorrect
  expand: _d3Shape.stackOffsetExpand,
  // @ts-expect-error definitelytyped types are incorrect
  none: _d3Shape.stackOffsetNone,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: _d3Shape.stackOffsetSilhouette,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: _d3Shape.stackOffsetWiggle,
  positive: offsetPositive
};
var getStackedData = exports.getStackedData = function getStackedData(data, stackItems, offsetType) {
  var dataKeys = stackItems.map(function (item) {
    return item.props.dataKey;
  });
  var offsetAccessor = STACK_OFFSET_MAP[offsetType];
  var stack = (0, _d3Shape.stack)()
  // @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
  .keys(dataKeys).value(function (d, key) {
    return +getValueByDataKey(d, key, 0);
  }).order(_d3Shape.stackOrderNone)
  // @ts-expect-error definitelytyped types are incorrect
  .offset(offsetAccessor);
  return stack(data);
};
exports.getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
  if (!data) {
    return null;
  }

  // reversing items to affect render order (for layering)
  var items = reverseStackOrder ? _items.reverse() : _items;
  var parentStackGroupsInitialValue = {};
  var stackGroups = items.reduce(function (result, item) {
    var _item$type2;
    var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId,
      hide = defaultedProps.hide;
    if (hide) {
      return result;
    }
    var axisId = defaultedProps[numericAxisId];
    var parentGroup = result[axisId] || {
      hasStack: false,
      stackGroups: {}
    };
    if ((0, _DataUtils.isNumOrStr)(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: []
      };
      childGroup.items.push(item);
      parentGroup.hasStack = true;
      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: [item]
      };
    }
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, parentGroup));
  }, parentStackGroupsInitialValue);
  var axisStackGroupsInitialValue = {};
  return Object.keys(stackGroups).reduce(function (result, axisId) {
    var group = stackGroups[axisId];
    if (group.hasStack) {
      var stackGroupsInitialValue = {};
      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
        var g = group.stackGroups[stackId];
        return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, stackId, {
          numericAxisId: numericAxisId,
          cateAxisId: cateAxisId,
          items: g.items,
          stackedData: getStackedData(data, g.items, offsetType)
        }));
      }, stackGroupsInitialValue);
    }
    return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, axisId, group));
  }, axisStackGroupsInitialValue);
};

/**
 * Configure the scale function of axis
 * @param {Object} scale The scale function
 * @param {Object} opts  The configuration of axis
 * @return {Object}      null
 */
exports.getTicksOfScale = function getTicksOfScale(scale, opts) {
  var realScaleType = opts.realScaleType,
    type = opts.type,
    tickCount = opts.tickCount,
    originalDomain = opts.originalDomain,
    allowDecimals = opts.allowDecimals;
  var scaleType = realScaleType || opts.scale;
  if (scaleType !== 'auto' && scaleType !== 'linear') {
    return null;
  }
  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
    // Calculate the ticks by the number of grid when the axis is a number axis
    var domain = scale.domain();
    if (!domain.length) {
      return null;
    }
    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
    scale.domain([(0, _min["default"])(tickValues), (0, _max["default"])(tickValues)]);
    return {
      niceTicks: tickValues
    };
  }
  if (tickCount && type === 'number') {
    var _domain = scale.domain();
    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
    return {
      niceTicks: _tickValues
    };
  }
  return null;
};
function getCateCoordinateOfLine(_ref5) {
  var axis = _ref5.axis,
    ticks = _ref5.ticks,
    bandSize = _ref5.bandSize,
    entry = _ref5.entry,
    index = _ref5.index,
    dataKey = _ref5.dataKey;
  if (axis.type === 'category') {
    // find coordinate of category axis by the value of category
    // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
    if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNil["default"])(entry[axis.dataKey])) {
      // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
      var matchedTick = (0, _DataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
      if (matchedTick) {
        return matchedTick.coordinate + bandSize / 2;
      }
    }
    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }
  var value = getValueByDataKey(entry, !(0, _isNil["default"])(dataKey) ? dataKey : axis.dataKey);
  return !(0, _isNil["default"])(value) ? axis.scale(value) : null;
}
exports.getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref6) {
  var axis = _ref6.axis,
    ticks = _ref6.ticks,
    offset = _ref6.offset,
    bandSize = _ref6.bandSize,
    entry = _ref6.entry,
    index = _ref6.index;
  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + offset : null;
  }
  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
  return !(0, _isNil["default"])(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
exports.getBaseValueOfBar = function getBaseValueOfBar(_ref7) {
  var numericAxis = _ref7.numericAxis;
  var domain = numericAxis.scale.domain();
  if (numericAxis.type === 'number') {
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    if (minValue <= 0 && maxValue >= 0) {
      return 0;
    }
    if (maxValue < 0) {
      return maxValue;
    }
    return minValue;
  }
  return domain[0];
};
exports.getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
  var _item$type3;
  var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? _objectSpread(_objectSpread({}, item.type.defaultProps), item.props) : item.props;
  var stackId = defaultedProps.stackId;
  if ((0, _DataUtils.isNumOrStr)(stackId)) {
    var group = stackGroups[stackId];
    if (group) {
      var itemIndex = group.items.indexOf(item);
      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }
  return null;
};
var getDomainOfSingle = function getDomainOfSingle(data) {
  return data.reduce(function (result, entry) {
    return [(0, _min["default"])(entry.concat([result[0]]).filter(_DataUtils.isNumber)), (0, _max["default"])(entry.concat([result[1]]).filter(_DataUtils.isNumber))];
  }, [Infinity, -Infinity]);
};
exports.getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function (result, stackId) {
    var group = stackGroups[stackId];
    var stackedData = group.stackedData;
    var domain = stackedData.reduce(function (res, entry) {
      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
    }, [Infinity, -Infinity]);
    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
  }, [Infinity, -Infinity]).map(function (result) {
    return result === Infinity || result === -Infinity ? 0 : result;
  });
};
var MIN_VALUE_REG = exports.MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = exports.MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
exports.parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
  if ((0, _isFunction["default"])(specifiedDomain)) {
    return specifiedDomain(dataDomain, allowDataOverflow);
  }
  if (!Array.isArray(specifiedDomain)) {
    return dataDomain;
  }
  var domain = [];

  /* eslint-disable prefer-destructuring */
  if ((0, _DataUtils.isNumber)(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
    domain[0] = dataDomain[0] - value;
  } else if ((0, _isFunction["default"])(specifiedDomain[0])) {
    domain[0] = specifiedDomain[0](dataDomain[0]);
  } else {
    domain[0] = dataDomain[0];
  }
  if ((0, _DataUtils.isNumber)(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
    domain[1] = dataDomain[1] + _value;
  } else if ((0, _isFunction["default"])(specifiedDomain[1])) {
    domain[1] = specifiedDomain[1](dataDomain[1]);
  } else {
    domain[1] = dataDomain[1];
  }
  /* eslint-enable prefer-destructuring */

  return domain;
};

/**
 * Calculate the size between two category
 * @param  {Object} axis  The options of axis
 * @param  {Array}  ticks The ticks of axis
 * @param  {Boolean} isBar if items in axis are bars
 * @return {Number} Size
 */
exports.getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks, isBar) {
  // @ts-expect-error we need to rethink scale type
  if (axis && axis.scale && axis.scale.bandwidth) {
    // @ts-expect-error we need to rethink scale type
    var bandWidth = axis.scale.bandwidth();
    if (!isBar || bandWidth > 0) {
      return bandWidth;
    }
  }
  if (axis && ticks && ticks.length >= 2) {
    var orderedTicks = (0, _sortBy["default"])(ticks, function (o) {
      return o.coordinate;
    });
    var bandSize = Infinity;
    for (var i = 1, len = orderedTicks.length; i < len; i++) {
      var cur = orderedTicks[i];
      var prev = orderedTicks[i - 1];
      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }
    return bandSize === Infinity ? 0 : bandSize;
  }
  return isBar ? undefined : 0;
};
/**
 * parse the domain of a category axis when a domain is specified
 * @param   {Array}        specifiedDomain  The domain specified by users
 * @param   {Array}        calculatedDomain The domain calculated by dateKey
 * @param   {ReactElement} axisChild        The axis ReactElement
 * @returns {Array}        domains
 */
exports.parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
  if (!specifiedDomain || !specifiedDomain.length) {
    return calculatedDomain;
  }
  if ((0, _isEqual["default"])(specifiedDomain, (0, _get["default"])(axisChild, 'type.defaultProps.domain'))) {
    return calculatedDomain;
  }
  return specifiedDomain;
};
exports.getTooltipItem = function getTooltipItem(graphicalItem, payload) {
  var defaultedProps = graphicalItem.type.defaultProps ? _objectSpread(_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
  var dataKey = defaultedProps.dataKey,
    name = defaultedProps.name,
    unit = defaultedProps.unit,
    formatter = defaultedProps.formatter,
    tooltipType = defaultedProps.tooltipType,
    chartType = defaultedProps.chartType,
    hide = defaultedProps.hide;
  return _objectSpread(_objectSpread({}, (0, _ReactUtils.filterProps)(graphicalItem, false)), {}, {
    dataKey: dataKey,
    unit: unit,
    formatter: formatter,
    name: name || dataKey,
    color: getMainColorOfGraphicItem(graphicalItem),
    value: getValueByDataKey(payload, dataKey),
    type: tooltipType,
    payload: payload,
    chartType: chartType,
    hide: hide
  });
};
}(ChartUtils));

function _typeof$P(o) { "@babel/helpers - typeof"; return _typeof$P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$P(o); }
Object.defineProperty(PolarUtils, "__esModule", {
  value: true
});
PolarUtils.radianToDegree = PolarUtils.polarToCartesian = PolarUtils.inRangeOfSector = PolarUtils.getTickClassName = PolarUtils.getMaxRadius = PolarUtils.getAngleOfPoint = PolarUtils.formatAxisMap = PolarUtils.formatAngleOfSector = PolarUtils.distanceBetweenPoints = PolarUtils.degreeToRadian = PolarUtils.RADIAN = void 0;
var _isNil$9 = _interopRequireDefault$Y(isNil_1);
var _react$P = React__default$4;
var _isFunction$o = _interopRequireDefault$Y(isFunction_1);
var _DataUtils$p = DataUtils;
var _ChartUtils$h = ChartUtils;
function _interopRequireDefault$Y(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys$L(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$J(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$L(Object(t), !0).forEach(function (r) { _defineProperty$Q(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$L(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$Q(obj, key, value) { key = _toPropertyKey$I(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$I(t) { var i = _toPrimitive$I(t, "string"); return "symbol" == _typeof$P(i) ? i : i + ""; }
function _toPrimitive$I(t, r) { if ("object" != _typeof$P(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$P(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray$e(arr, i) { return _arrayWithHoles$d(arr) || _iterableToArrayLimit$c(arr, i) || _unsupportedIterableToArray$s(arr, i) || _nonIterableRest$d(); }
function _nonIterableRest$d() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$s(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$s(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$s(o, minLen); }
function _arrayLikeToArray$s(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$c(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$d(arr) { if (Array.isArray(arr)) return arr; }
var RADIAN$1 = PolarUtils.RADIAN = Math.PI / 180;
PolarUtils.degreeToRadian = function degreeToRadian(angle) {
  return angle * Math.PI / 180;
};
var radianToDegree = PolarUtils.radianToDegree = function radianToDegree(angleInRadian) {
  return angleInRadian * 180 / Math.PI;
};
PolarUtils.polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN$1 * angle) * radius,
    y: cy + Math.sin(-RADIAN$1 * angle) * radius
  };
};
var getMaxRadius = PolarUtils.getMaxRadius = function getMaxRadius(width, height) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};

/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */
PolarUtils.formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
    height = props.height;
  var startAngle = props.startAngle,
    endAngle = props.endAngle;
  var cx = (0, _DataUtils$p.getPercentValue)(props.cx, width, width / 2);
  var cy = (0, _DataUtils$p.getPercentValue)(props.cy, height, height / 2);
  var maxRadius = getMaxRadius(width, height, offset);
  var innerRadius = (0, _DataUtils$p.getPercentValue)(props.innerRadius, maxRadius, 0);
  var outerRadius = (0, _DataUtils$p.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
  var ids = Object.keys(axisMap);
  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var domain = axis.domain,
      reversed = axis.reversed;
    var range;
    if ((0, _isNil$9["default"])(axis.range)) {
      if (axisType === 'angleAxis') {
        range = [startAngle, endAngle];
      } else if (axisType === 'radiusAxis') {
        range = [innerRadius, outerRadius];
      }
      if (reversed) {
        range = [range[1], range[0]];
      }
    } else {
      range = axis.range;
      var _range = range;
      var _range2 = _slicedToArray$e(_range, 2);
      startAngle = _range2[0];
      endAngle = _range2[1];
    }
    var _parseScale = (0, _ChartUtils$h.parseScale)(axis, chartName),
      realScaleType = _parseScale.realScaleType,
      scale = _parseScale.scale;
    scale.domain(domain).range(range);
    (0, _ChartUtils$h.checkDomainOfScale)(scale);
    var ticks = (0, _ChartUtils$h.getTicksOfScale)(scale, _objectSpread$J(_objectSpread$J({}, axis), {}, {
      realScaleType: realScaleType
    }));
    var finalAxis = _objectSpread$J(_objectSpread$J(_objectSpread$J({}, axis), ticks), {}, {
      range: range,
      radius: outerRadius,
      realScaleType: realScaleType,
      scale: scale,
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    });
    return _objectSpread$J(_objectSpread$J({}, result), {}, _defineProperty$Q({}, id, finalAxis));
  }, {});
};
var distanceBetweenPoints = PolarUtils.distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
  var x1 = point.x,
    y1 = point.y;
  var x2 = anotherPoint.x,
    y2 = anotherPoint.y;
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = PolarUtils.getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
  var x = _ref.x,
    y = _ref.y;
  var cx = _ref2.cx,
    cy = _ref2.cy;
  var radius = distanceBetweenPoints({
    x: x,
    y: y
  }, {
    x: cx,
    y: cy
  });
  if (radius <= 0) {
    return {
      radius: radius
    };
  }
  var cos = (x - cx) / radius;
  var angleInRadian = Math.acos(cos);
  if (y > cy) {
    angleInRadian = 2 * Math.PI - angleInRadian;
  }
  return {
    radius: radius,
    angle: radianToDegree(angleInRadian),
    angleInRadian: angleInRadian
  };
};
var formatAngleOfSector = PolarUtils.formatAngleOfSector = function formatAngleOfSector(_ref3) {
  var startAngle = _ref3.startAngle,
    endAngle = _ref3.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return {
    startAngle: startAngle - min * 360,
    endAngle: endAngle - min * 360
  };
};
var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
  var startAngle = _ref4.startAngle,
    endAngle = _ref4.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return angle + min * 360;
};
PolarUtils.inRangeOfSector = function inRangeOfSector(_ref5, sector) {
  var x = _ref5.x,
    y = _ref5.y;
  var _getAngleOfPoint = getAngleOfPoint({
      x: x,
      y: y
    }, sector),
    radius = _getAngleOfPoint.radius,
    angle = _getAngleOfPoint.angle;
  var innerRadius = sector.innerRadius,
    outerRadius = sector.outerRadius;
  if (radius < innerRadius || radius > outerRadius) {
    return false;
  }
  if (radius === 0) {
    return true;
  }
  var _formatAngleOfSector = formatAngleOfSector(sector),
    startAngle = _formatAngleOfSector.startAngle,
    endAngle = _formatAngleOfSector.endAngle;
  var formatAngle = angle;
  var inRange;
  if (startAngle <= endAngle) {
    while (formatAngle > endAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < startAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
  } else {
    while (formatAngle > startAngle) {
      formatAngle -= 360;
    }
    while (formatAngle < endAngle) {
      formatAngle += 360;
    }
    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
  }
  if (inRange) {
    return _objectSpread$J(_objectSpread$J({}, sector), {}, {
      radius: radius,
      angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
  }
  return null;
};
PolarUtils.getTickClassName = function getTickClassName(tick) {
  return ! /*#__PURE__*/(0, _react$P.isValidElement)(tick) && !(0, _isFunction$o["default"])(tick) && typeof tick !== 'boolean' ? tick.className : '';
};

function _typeof$O(o) { "@babel/helpers - typeof"; return _typeof$O = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$O(o); }
Object.defineProperty(Label$1, "__esModule", {
  value: true
});
Label$1.Label = Label;
var _react$O = _interopRequireWildcard$p(React__default$4);
var _isNil$8 = _interopRequireDefault$X(isNil_1);
var _isFunction$n = _interopRequireDefault$X(isFunction_1);
var _isObject$1 = _interopRequireDefault$X(isObject_1);
var _clsx$u = _interopRequireDefault$X(clsx.exports);
var _Text$6 = Text;
var _ReactUtils$w = ReactUtils;
var _DataUtils$o = DataUtils;
var _PolarUtils$e = PolarUtils;
var _excluded$m = ["offset"];
function _interopRequireDefault$X(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$p(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$p = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$p(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$O(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$p(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray$9(arr) { return _arrayWithoutHoles$9(arr) || _iterableToArray$a(arr) || _unsupportedIterableToArray$r(arr) || _nonIterableSpread$9(); }
function _nonIterableSpread$9() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$r(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$r(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$r(o, minLen); }
function _iterableToArray$a(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$9(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$r(arr); }
function _arrayLikeToArray$r(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties$p(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$m(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$m(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ownKeys$K(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$I(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$K(Object(t), !0).forEach(function (r) { _defineProperty$P(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$K(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$P(obj, key, value) { key = _toPropertyKey$H(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$H(t) { var i = _toPrimitive$H(t, "string"); return "symbol" == _typeof$O(i) ? i : i + ""; }
function _toPrimitive$H(t, r) { if ("object" != _typeof$O(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$O(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
var getLabel = function getLabel(props) {
  var value = props.value,
    formatter = props.formatter;
  var label = (0, _isNil$8["default"])(props.children) ? value : props.children;
  if ((0, _isFunction$n["default"])(formatter)) {
    return formatter(label);
  }
  return label;
};
var getDeltaAngle$1 = function getDeltaAngle(startAngle, endAngle) {
  var sign = (0, _DataUtils$o.mathSign)(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign * deltaAngle;
};
var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
  var position = labelProps.position,
    viewBox = labelProps.viewBox,
    offset = labelProps.offset,
    className = labelProps.className;
  var _ref = viewBox,
    cx = _ref.cx,
    cy = _ref.cy,
    innerRadius = _ref.innerRadius,
    outerRadius = _ref.outerRadius,
    startAngle = _ref.startAngle,
    endAngle = _ref.endAngle,
    clockWise = _ref.clockWise;
  var radius = (innerRadius + outerRadius) / 2;
  var deltaAngle = getDeltaAngle$1(startAngle, endAngle);
  var sign = deltaAngle >= 0 ? 1 : -1;
  var labelAngle, direction;
  if (position === 'insideStart') {
    labelAngle = startAngle + sign * offset;
    direction = clockWise;
  } else if (position === 'insideEnd') {
    labelAngle = endAngle - sign * offset;
    direction = !clockWise;
  } else if (position === 'end') {
    labelAngle = endAngle + sign * offset;
    direction = clockWise;
  }
  direction = deltaAngle <= 0 ? direction : !direction;
  var startPoint = (0, _PolarUtils$e.polarToCartesian)(cx, cy, radius, labelAngle);
  var endPoint = (0, _PolarUtils$e.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
  var id = (0, _isNil$8["default"])(labelProps.id) ? (0, _DataUtils$o.uniqueId)('recharts-radial-line-') : labelProps.id;
  return /*#__PURE__*/_react$O["default"].createElement("text", _extends$G({}, attrs, {
    dominantBaseline: "central",
    className: (0, _clsx$u["default"])('recharts-radial-bar-label', className)
  }), /*#__PURE__*/_react$O["default"].createElement("defs", null, /*#__PURE__*/_react$O["default"].createElement("path", {
    id: id,
    d: path
  })), /*#__PURE__*/_react$O["default"].createElement("textPath", {
    xlinkHref: "#".concat(id)
  }, label));
};
var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
  var viewBox = props.viewBox,
    offset = props.offset,
    position = props.position;
  var _ref2 = viewBox,
    cx = _ref2.cx,
    cy = _ref2.cy,
    innerRadius = _ref2.innerRadius,
    outerRadius = _ref2.outerRadius,
    startAngle = _ref2.startAngle,
    endAngle = _ref2.endAngle;
  var midAngle = (startAngle + endAngle) / 2;
  if (position === 'outside') {
    var _polarToCartesian = (0, _PolarUtils$e.polarToCartesian)(cx, cy, outerRadius + offset, midAngle),
      _x = _polarToCartesian.x,
      _y = _polarToCartesian.y;
    return {
      x: _x,
      y: _y,
      textAnchor: _x >= cx ? 'start' : 'end',
      verticalAnchor: 'middle'
    };
  }
  if (position === 'center') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'middle'
    };
  }
  if (position === 'centerTop') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }
  if (position === 'centerBottom') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'end'
    };
  }
  var r = (innerRadius + outerRadius) / 2;
  var _polarToCartesian2 = (0, _PolarUtils$e.polarToCartesian)(cx, cy, r, midAngle),
    x = _polarToCartesian2.x,
    y = _polarToCartesian2.y;
  return {
    x: x,
    y: y,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  };
};
var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
  var viewBox = props.viewBox,
    parentViewBox = props.parentViewBox,
    offset = props.offset,
    position = props.position;
  var _ref3 = viewBox,
    x = _ref3.x,
    y = _ref3.y,
    width = _ref3.width,
    height = _ref3.height;

  // Define vertical offsets and position inverts based on the value being positive or negative
  var verticalSign = height >= 0 ? 1 : -1;
  var verticalOffset = verticalSign * offset;
  var verticalEnd = verticalSign > 0 ? 'end' : 'start';
  var verticalStart = verticalSign > 0 ? 'start' : 'end';

  // Define horizontal offsets and position inverts based on the value being positive or negative
  var horizontalSign = width >= 0 ? 1 : -1;
  var horizontalOffset = horizontalSign * offset;
  var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
  var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
  if (position === 'top') {
    var attrs = {
      x: x + width / 2,
      y: y - verticalSign * offset,
      textAnchor: 'middle',
      verticalAnchor: verticalEnd
    };
    return _objectSpread$I(_objectSpread$I({}, attrs), parentViewBox ? {
      height: Math.max(y - parentViewBox.y, 0),
      width: width
    } : {});
  }
  if (position === 'bottom') {
    var _attrs = {
      x: x + width / 2,
      y: y + height + verticalOffset,
      textAnchor: 'middle',
      verticalAnchor: verticalStart
    };
    return _objectSpread$I(_objectSpread$I({}, _attrs), parentViewBox ? {
      height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
      width: width
    } : {});
  }
  if (position === 'left') {
    var _attrs2 = {
      x: x - horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: 'middle'
    };
    return _objectSpread$I(_objectSpread$I({}, _attrs2), parentViewBox ? {
      width: Math.max(_attrs2.x - parentViewBox.x, 0),
      height: height
    } : {});
  }
  if (position === 'right') {
    var _attrs3 = {
      x: x + width + horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalStart,
      verticalAnchor: 'middle'
    };
    return _objectSpread$I(_objectSpread$I({}, _attrs3), parentViewBox ? {
      width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
      height: height
    } : {});
  }
  var sizeAttrs = parentViewBox ? {
    width: width,
    height: height
  } : {};
  if (position === 'insideLeft') {
    return _objectSpread$I({
      x: x + horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalStart,
      verticalAnchor: 'middle'
    }, sizeAttrs);
  }
  if (position === 'insideRight') {
    return _objectSpread$I({
      x: x + width - horizontalOffset,
      y: y + height / 2,
      textAnchor: horizontalEnd,
      verticalAnchor: 'middle'
    }, sizeAttrs);
  }
  if (position === 'insideTop') {
    return _objectSpread$I({
      x: x + width / 2,
      y: y + verticalOffset,
      textAnchor: 'middle',
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }
  if (position === 'insideBottom') {
    return _objectSpread$I({
      x: x + width / 2,
      y: y + height - verticalOffset,
      textAnchor: 'middle',
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }
  if (position === 'insideTopLeft') {
    return _objectSpread$I({
      x: x + horizontalOffset,
      y: y + verticalOffset,
      textAnchor: horizontalStart,
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }
  if (position === 'insideTopRight') {
    return _objectSpread$I({
      x: x + width - horizontalOffset,
      y: y + verticalOffset,
      textAnchor: horizontalEnd,
      verticalAnchor: verticalStart
    }, sizeAttrs);
  }
  if (position === 'insideBottomLeft') {
    return _objectSpread$I({
      x: x + horizontalOffset,
      y: y + height - verticalOffset,
      textAnchor: horizontalStart,
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }
  if (position === 'insideBottomRight') {
    return _objectSpread$I({
      x: x + width - horizontalOffset,
      y: y + height - verticalOffset,
      textAnchor: horizontalEnd,
      verticalAnchor: verticalEnd
    }, sizeAttrs);
  }
  if ((0, _isObject$1["default"])(position) && ((0, _DataUtils$o.isNumber)(position.x) || (0, _DataUtils$o.isPercent)(position.x)) && ((0, _DataUtils$o.isNumber)(position.y) || (0, _DataUtils$o.isPercent)(position.y))) {
    return _objectSpread$I({
      x: x + (0, _DataUtils$o.getPercentValue)(position.x, width),
      y: y + (0, _DataUtils$o.getPercentValue)(position.y, height),
      textAnchor: 'end',
      verticalAnchor: 'end'
    }, sizeAttrs);
  }
  return _objectSpread$I({
    x: x + width / 2,
    y: y + height / 2,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  }, sizeAttrs);
};
var isPolar = function isPolar(viewBox) {
  return 'cx' in viewBox && (0, _DataUtils$o.isNumber)(viewBox.cx);
};
function Label(_ref4) {
  var _ref4$offset = _ref4.offset,
    offset = _ref4$offset === void 0 ? 5 : _ref4$offset,
    restProps = _objectWithoutProperties$p(_ref4, _excluded$m);
  var props = _objectSpread$I({
    offset: offset
  }, restProps);
  var viewBox = props.viewBox,
    position = props.position,
    value = props.value,
    children = props.children,
    content = props.content,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    textBreakAll = props.textBreakAll;
  if (!viewBox || (0, _isNil$8["default"])(value) && (0, _isNil$8["default"])(children) && ! /*#__PURE__*/(0, _react$O.isValidElement)(content) && !(0, _isFunction$n["default"])(content)) {
    return null;
  }
  if ( /*#__PURE__*/(0, _react$O.isValidElement)(content)) {
    return /*#__PURE__*/(0, _react$O.cloneElement)(content, props);
  }
  var label;
  if ((0, _isFunction$n["default"])(content)) {
    label = /*#__PURE__*/(0, _react$O.createElement)(content, props);
    if ( /*#__PURE__*/(0, _react$O.isValidElement)(label)) {
      return label;
    }
  } else {
    label = getLabel(props);
  }
  var isPolarLabel = isPolar(viewBox);
  var attrs = (0, _ReactUtils$w.filterProps)(props, true);
  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
    return renderRadialLabel(props, label, attrs);
  }
  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
  return /*#__PURE__*/_react$O["default"].createElement(_Text$6.Text, _extends$G({
    className: (0, _clsx$u["default"])('recharts-label', className)
  }, attrs, positionAttrs, {
    breakAll: textBreakAll
  }), label);
}
Label.displayName = 'Label';
var parseViewBox = function parseViewBox(props) {
  var cx = props.cx,
    cy = props.cy,
    angle = props.angle,
    startAngle = props.startAngle,
    endAngle = props.endAngle,
    r = props.r,
    radius = props.radius,
    innerRadius = props.innerRadius,
    outerRadius = props.outerRadius,
    x = props.x,
    y = props.y,
    top = props.top,
    left = props.left,
    width = props.width,
    height = props.height,
    clockWise = props.clockWise,
    labelViewBox = props.labelViewBox;
  if (labelViewBox) {
    return labelViewBox;
  }
  if ((0, _DataUtils$o.isNumber)(width) && (0, _DataUtils$o.isNumber)(height)) {
    if ((0, _DataUtils$o.isNumber)(x) && (0, _DataUtils$o.isNumber)(y)) {
      return {
        x: x,
        y: y,
        width: width,
        height: height
      };
    }
    if ((0, _DataUtils$o.isNumber)(top) && (0, _DataUtils$o.isNumber)(left)) {
      return {
        x: top,
        y: left,
        width: width,
        height: height
      };
    }
  }
  if ((0, _DataUtils$o.isNumber)(x) && (0, _DataUtils$o.isNumber)(y)) {
    return {
      x: x,
      y: y,
      width: 0,
      height: 0
    };
  }
  if ((0, _DataUtils$o.isNumber)(cx) && (0, _DataUtils$o.isNumber)(cy)) {
    return {
      cx: cx,
      cy: cy,
      startAngle: startAngle || angle || 0,
      endAngle: endAngle || angle || 0,
      innerRadius: innerRadius || 0,
      outerRadius: outerRadius || radius || r || 0,
      clockWise: clockWise
    };
  }
  if (props.viewBox) {
    return props.viewBox;
  }
  return {};
};
var parseLabel = function parseLabel(label, viewBox) {
  if (!label) {
    return null;
  }
  if (label === true) {
    return /*#__PURE__*/_react$O["default"].createElement(Label, {
      key: "label-implicit",
      viewBox: viewBox
    });
  }
  if ((0, _DataUtils$o.isNumOrStr)(label)) {
    return /*#__PURE__*/_react$O["default"].createElement(Label, {
      key: "label-implicit",
      viewBox: viewBox,
      value: label
    });
  }
  if ( /*#__PURE__*/(0, _react$O.isValidElement)(label)) {
    if (label.type === Label) {
      return /*#__PURE__*/(0, _react$O.cloneElement)(label, {
        key: 'label-implicit',
        viewBox: viewBox
      });
    }
    return /*#__PURE__*/_react$O["default"].createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox: viewBox
    });
  }
  if ((0, _isFunction$n["default"])(label)) {
    return /*#__PURE__*/_react$O["default"].createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox: viewBox
    });
  }
  if ((0, _isObject$1["default"])(label)) {
    return /*#__PURE__*/_react$O["default"].createElement(Label, _extends$G({
      viewBox: viewBox
    }, label, {
      key: "label-implicit"
    }));
  }
  return null;
};
var renderCallByParent$1 = function renderCallByParent(parentProps, viewBox) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) {
    return null;
  }
  var children = parentProps.children;
  var parentViewBox = parseViewBox(parentProps);
  var explicitChildren = (0, _ReactUtils$w.findAllByType)(children, Label).map(function (child, index) {
    return /*#__PURE__*/(0, _react$O.cloneElement)(child, {
      viewBox: viewBox || parentViewBox,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(index)
    });
  });
  if (!checkPropsLabel) {
    return explicitChildren;
  }
  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
  return [implicitLabel].concat(_toConsumableArray$9(explicitChildren));
};
Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent$1;

var LabelList$1 = {};

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last$1;

function _typeof$N(o) { "@babel/helpers - typeof"; return _typeof$N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$N(o); }
Object.defineProperty(LabelList$1, "__esModule", {
  value: true
});
LabelList$1.LabelList = LabelList;
var _react$N = _interopRequireWildcard$o(React__default$4);
var _isNil$7 = _interopRequireDefault$W(isNil_1);
var _isObject = _interopRequireDefault$W(isObject_1);
var _isFunction$m = _interopRequireDefault$W(isFunction_1);
var _last$1 = _interopRequireDefault$W(last_1);
var _Label$6 = Label$1;
var _Layer$l = Layer;
var _ReactUtils$v = ReactUtils;
var _ChartUtils$g = ChartUtils;
var _excluded$l = ["valueAccessor"],
  _excluded2$8 = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function _interopRequireDefault$W(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$o(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$o = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$o(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$N(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$o(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray$8(arr) { return _arrayWithoutHoles$8(arr) || _iterableToArray$9(arr) || _unsupportedIterableToArray$q(arr) || _nonIterableSpread$8(); }
function _nonIterableSpread$8() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$q(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$q(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$q(o, minLen); }
function _iterableToArray$9(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$8(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$q(arr); }
function _arrayLikeToArray$q(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
function ownKeys$J(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$H(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$J(Object(t), !0).forEach(function (r) { _defineProperty$O(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$J(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$O(obj, key, value) { key = _toPropertyKey$G(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$G(t) { var i = _toPrimitive$G(t, "string"); return "symbol" == _typeof$N(i) ? i : i + ""; }
function _toPrimitive$G(t, r) { if ("object" != _typeof$N(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$N(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties$o(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$l(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$l(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var defaultAccessor = function defaultAccessor(entry) {
  return Array.isArray(entry.value) ? (0, _last$1["default"])(entry.value) : entry.value;
};
function LabelList(_ref) {
  var _ref$valueAccessor = _ref.valueAccessor,
    valueAccessor = _ref$valueAccessor === void 0 ? defaultAccessor : _ref$valueAccessor,
    restProps = _objectWithoutProperties$o(_ref, _excluded$l);
  var data = restProps.data,
    dataKey = restProps.dataKey,
    clockWise = restProps.clockWise,
    id = restProps.id,
    textBreakAll = restProps.textBreakAll,
    others = _objectWithoutProperties$o(restProps, _excluded2$8);
  if (!data || !data.length) {
    return null;
  }
  return /*#__PURE__*/_react$N["default"].createElement(_Layer$l.Layer, {
    className: "recharts-label-list"
  }, data.map(function (entry, index) {
    var value = (0, _isNil$7["default"])(dataKey) ? valueAccessor(entry, index) : (0, _ChartUtils$g.getValueByDataKey)(entry && entry.payload, dataKey);
    var idProps = (0, _isNil$7["default"])(id) ? {} : {
      id: "".concat(id, "-").concat(index)
    };
    return /*#__PURE__*/_react$N["default"].createElement(_Label$6.Label, _extends$F({}, (0, _ReactUtils$v.filterProps)(entry, true), others, idProps, {
      parentViewBox: entry.parentViewBox,
      value: value,
      textBreakAll: textBreakAll,
      viewBox: _Label$6.Label.parseViewBox((0, _isNil$7["default"])(clockWise) ? entry : _objectSpread$H(_objectSpread$H({}, entry), {}, {
        clockWise: clockWise
      })),
      key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
      ,
      index: index
    }));
  }));
}
LabelList.displayName = 'LabelList';
function parseLabelList(label, data) {
  if (!label) {
    return null;
  }
  if (label === true) {
    return /*#__PURE__*/_react$N["default"].createElement(LabelList, {
      key: "labelList-implicit",
      data: data
    });
  }
  if ( /*#__PURE__*/_react$N["default"].isValidElement(label) || (0, _isFunction$m["default"])(label)) {
    return /*#__PURE__*/_react$N["default"].createElement(LabelList, {
      key: "labelList-implicit",
      data: data,
      content: label
    });
  }
  if ((0, _isObject["default"])(label)) {
    return /*#__PURE__*/_react$N["default"].createElement(LabelList, _extends$F({
      data: data
    }, label, {
      key: "labelList-implicit"
    }));
  }
  return null;
}
function renderCallByParent(parentProps, data) {
  var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) {
    return null;
  }
  var children = parentProps.children;
  var explicitChildren = (0, _ReactUtils$v.findAllByType)(children, LabelList).map(function (child, index) {
    return /*#__PURE__*/(0, _react$N.cloneElement)(child, {
      data: data,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(index)
    });
  });
  if (!checkPropsLabel) {
    return explicitChildren;
  }
  var implicitLabelList = parseLabelList(parentProps.label, data);
  return [implicitLabelList].concat(_toConsumableArray$8(explicitChildren));
}
LabelList.renderCallByParent = renderCallByParent;

var Customized$1 = {};

Object.defineProperty(Customized$1, "__esModule", {
  value: true
});
Customized$1.Customized = Customized;
var _react$M = _interopRequireWildcard$n(React__default$4);
var _isFunction$l = _interopRequireDefault$V(isFunction_1);
var _Layer$k = Layer;
var _LogUtils$5 = LogUtils;
var _excluded$k = ["component"];
/**
 * @fileOverview Customized
 */
function _interopRequireDefault$V(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$n(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$n = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$n(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$M(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$n(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$M(o) { "@babel/helpers - typeof"; return _typeof$M = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$M(o); }
function _objectWithoutProperties$n(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$k(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$k(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
/**
 * custom svg elements by rechart instance props and state.
 * @returns {Object}   svg elements
 */
function Customized(_ref) {
  var component = _ref.component,
    props = _objectWithoutProperties$n(_ref, _excluded$k);
  var child;
  if ( /*#__PURE__*/(0, _react$M.isValidElement)(component)) {
    child = /*#__PURE__*/(0, _react$M.cloneElement)(component, props);
  } else if ((0, _isFunction$l["default"])(component)) {
    child = /*#__PURE__*/(0, _react$M.createElement)(component, props);
  } else {
    (0, _LogUtils$5.warn)(false, "Customized's props `component` must be React.element or Function, but got %s.", _typeof$M(component));
  }
  return /*#__PURE__*/_react$M["default"].createElement(_Layer$k.Layer, {
    className: "recharts-customized-wrapper"
  }, child);
}
Customized.displayName = 'Customized';

var Sector = {};

Object.defineProperty(Sector, "__esModule", {
  value: true
});
Sector.Sector = void 0;
var _react$L = _interopRequireDefault$U(React__default$4);
var _clsx$t = _interopRequireDefault$U(clsx.exports);
var _ReactUtils$u = ReactUtils;
var _PolarUtils$d = PolarUtils;
var _DataUtils$n = DataUtils;
function _interopRequireDefault$U(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$L(o) { "@babel/helpers - typeof"; return _typeof$L = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$L(o); }
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
function ownKeys$I(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$G(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$I(Object(t), !0).forEach(function (r) { _defineProperty$N(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$I(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$N(obj, key, value) { key = _toPropertyKey$F(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$F(t) { var i = _toPrimitive$F(t, "string"); return "symbol" == _typeof$L(i) ? i : i + ""; }
function _toPrimitive$F(t, r) { if ("object" != _typeof$L(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$L(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Sector
 */
var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = (0, _DataUtils$n.mathSign)(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
  return sign * deltaAngle;
};
var getTangentCircle = function getTangentCircle(_ref) {
  var cx = _ref.cx,
    cy = _ref.cy,
    radius = _ref.radius,
    angle = _ref.angle,
    sign = _ref.sign,
    isExternal = _ref.isExternal,
    cornerRadius = _ref.cornerRadius,
    cornerIsExternal = _ref.cornerIsExternal;
  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils$d.RADIAN;
  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
  var center = (0, _PolarUtils$d.polarToCartesian)(cx, cy, centerRadius, centerAngle);
  // The coordinate of point which is tangent to the circle
  var circleTangency = (0, _PolarUtils$d.polarToCartesian)(cx, cy, radius, centerAngle);
  // The coordinate of point which is tangent to the radius line
  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
  var lineTangency = (0, _PolarUtils$d.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils$d.RADIAN), lineTangencyAngle);
  return {
    center: center,
    circleTangency: circleTangency,
    lineTangency: lineTangency,
    theta: theta
  };
};
var getSectorPath = function getSectorPath(_ref2) {
  var cx = _ref2.cx,
    cy = _ref2.cy,
    innerRadius = _ref2.innerRadius,
    outerRadius = _ref2.outerRadius,
    startAngle = _ref2.startAngle,
    endAngle = _ref2.endAngle;
  var angle = getDeltaAngle(startAngle, endAngle);

  // When the angle of sector equals to 360, star point and end point coincide
  var tempEndAngle = startAngle + angle;
  var outerStartPoint = (0, _PolarUtils$d.polarToCartesian)(cx, cy, outerRadius, startAngle);
  var outerEndPoint = (0, _PolarUtils$d.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
  if (innerRadius > 0) {
    var innerStartPoint = (0, _PolarUtils$d.polarToCartesian)(cx, cy, innerRadius, startAngle);
    var innerEndPoint = (0, _PolarUtils$d.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
  } else {
    path += "L ".concat(cx, ",").concat(cy, " Z");
  }
  return path;
};
var getSectorWithCorner = function getSectorWithCorner(_ref3) {
  var cx = _ref3.cx,
    cy = _ref3.cy,
    innerRadius = _ref3.innerRadius,
    outerRadius = _ref3.outerRadius,
    cornerRadius = _ref3.cornerRadius,
    forceCornerRadius = _ref3.forceCornerRadius,
    cornerIsExternal = _ref3.cornerIsExternal,
    startAngle = _ref3.startAngle,
    endAngle = _ref3.endAngle;
  var sign = (0, _DataUtils$n.mathSign)(endAngle - startAngle);
  var _getTangentCircle = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: outerRadius,
      angle: startAngle,
      sign: sign,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal
    }),
    soct = _getTangentCircle.circleTangency,
    solt = _getTangentCircle.lineTangency,
    sot = _getTangentCircle.theta;
  var _getTangentCircle2 = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: outerRadius,
      angle: endAngle,
      sign: -sign,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal
    }),
    eoct = _getTangentCircle2.circleTangency,
    eolt = _getTangentCircle2.lineTangency,
    eot = _getTangentCircle2.theta;
  var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
  if (outerArcAngle < 0) {
    if (forceCornerRadius) {
      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
    }
    return getSectorPath({
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    });
  }
  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: innerRadius,
        angle: startAngle,
        sign: sign,
        isExternal: true,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
      }),
      sict = _getTangentCircle3.circleTangency,
      silt = _getTangentCircle3.lineTangency,
      sit = _getTangentCircle3.theta;
    var _getTangentCircle4 = getTangentCircle({
        cx: cx,
        cy: cy,
        radius: innerRadius,
        angle: endAngle,
        sign: -sign,
        isExternal: true,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
      }),
      eict = _getTangentCircle4.circleTangency,
      eilt = _getTangentCircle4.lineTangency,
      eit = _getTangentCircle4.theta;
    var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
    if (innerArcAngle < 0 && cornerRadius === 0) {
      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
    }
    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
  } else {
    path += "L".concat(cx, ",").concat(cy, "Z");
  }
  return path;
};
var defaultProps$3 = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: false,
  cornerIsExternal: false
};
Sector.Sector = function Sector(sectorProps) {
  var props = _objectSpread$G(_objectSpread$G({}, defaultProps$3), sectorProps);
  var cx = props.cx,
    cy = props.cy,
    innerRadius = props.innerRadius,
    outerRadius = props.outerRadius,
    cornerRadius = props.cornerRadius,
    forceCornerRadius = props.forceCornerRadius,
    cornerIsExternal = props.cornerIsExternal,
    startAngle = props.startAngle,
    endAngle = props.endAngle,
    className = props.className;
  if (outerRadius < innerRadius || startAngle === endAngle) {
    return null;
  }
  var layerClass = (0, _clsx$t["default"])('recharts-sector', className);
  var deltaRadius = outerRadius - innerRadius;
  var cr = (0, _DataUtils$n.getPercentValue)(cornerRadius, deltaRadius, 0, true);
  var path;
  if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
    path = getSectorWithCorner({
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      cornerRadius: Math.min(cr, deltaRadius / 2),
      forceCornerRadius: forceCornerRadius,
      cornerIsExternal: cornerIsExternal,
      startAngle: startAngle,
      endAngle: endAngle
    });
  } else {
    path = getSectorPath({
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    });
  }
  return /*#__PURE__*/_react$L["default"].createElement("path", _extends$E({}, (0, _ReactUtils$u.filterProps)(props, true), {
    className: layerClass,
    d: path,
    role: "img"
  }));
};

var Curve = {};

Object.defineProperty(Curve, "__esModule", {
  value: true
});
Curve.getPath = Curve.Curve = void 0;
var _react$K = _interopRequireDefault$T(React__default$4);
var _d3Shape = d3Shape;
var _upperFirst = _interopRequireDefault$T(upperFirst_1);
var _isFunction$k = _interopRequireDefault$T(isFunction_1);
var _clsx$s = _interopRequireDefault$T(clsx.exports);
var _types$a = types;
var _ReactUtils$t = ReactUtils;
var _DataUtils$m = DataUtils;
function _interopRequireDefault$T(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$K(o) { "@babel/helpers - typeof"; return _typeof$K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$K(o); }
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
function ownKeys$H(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$F(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$H(Object(t), !0).forEach(function (r) { _defineProperty$M(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$H(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$M(obj, key, value) { key = _toPropertyKey$E(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$E(t) { var i = _toPrimitive$E(t, "string"); return "symbol" == _typeof$K(i) ? i : i + ""; }
function _toPrimitive$E(t, r) { if ("object" != _typeof$K(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$K(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Curve
 */
var CURVE_FACTORIES = {
  curveBasisClosed: _d3Shape.curveBasisClosed,
  curveBasisOpen: _d3Shape.curveBasisOpen,
  curveBasis: _d3Shape.curveBasis,
  curveBumpX: _d3Shape.curveBumpX,
  curveBumpY: _d3Shape.curveBumpY,
  curveLinearClosed: _d3Shape.curveLinearClosed,
  curveLinear: _d3Shape.curveLinear,
  curveMonotoneX: _d3Shape.curveMonotoneX,
  curveMonotoneY: _d3Shape.curveMonotoneY,
  curveNatural: _d3Shape.curveNatural,
  curveStep: _d3Shape.curveStep,
  curveStepAfter: _d3Shape.curveStepAfter,
  curveStepBefore: _d3Shape.curveStepBefore
};
var defined = function defined(p) {
  return p.x === +p.x && p.y === +p.y;
};
var getX = function getX(p) {
  return p.x;
};
var getY = function getY(p) {
  return p.y;
};
var getCurveFactory = function getCurveFactory(type, layout) {
  if ((0, _isFunction$k["default"])(type)) {
    return type;
  }
  var name = "curve".concat((0, _upperFirst["default"])(type));
  if ((name === 'curveMonotone' || name === 'curveBump') && layout) {
    return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
  }
  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
};
/**
 * Calculate the path of curve. Returns null if points is an empty array.
 * @return path or null
 */
var getPath$1 = Curve.getPath = function getPath(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'linear' : _ref$type,
    _ref$points = _ref.points,
    points = _ref$points === void 0 ? [] : _ref$points,
    baseLine = _ref.baseLine,
    layout = _ref.layout,
    _ref$connectNulls = _ref.connectNulls,
    connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
  var curveFactory = getCurveFactory(type, layout);
  var formatPoints = connectNulls ? points.filter(function (entry) {
    return defined(entry);
  }) : points;
  var lineFunction;
  if (Array.isArray(baseLine)) {
    var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
      return defined(base);
    }) : baseLine;
    var areaPoints = formatPoints.map(function (entry, index) {
      return _objectSpread$F(_objectSpread$F({}, entry), {}, {
        base: formatBaseLine[index]
      });
    });
    if (layout === 'vertical') {
      lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
        return d.base.x;
      });
    } else {
      lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
        return d.base.y;
      });
    }
    lineFunction.defined(defined).curve(curveFactory);
    return lineFunction(areaPoints);
  }
  if (layout === 'vertical' && (0, _DataUtils$m.isNumber)(baseLine)) {
    lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
  } else if ((0, _DataUtils$m.isNumber)(baseLine)) {
    lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
  } else {
    lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
  }
  lineFunction.defined(defined).curve(curveFactory);
  return lineFunction(formatPoints);
};
Curve.Curve = function Curve(props) {
  var className = props.className,
    points = props.points,
    path = props.path,
    pathRef = props.pathRef;
  if ((!points || !points.length) && !path) {
    return null;
  }
  var realPath = points && points.length ? getPath$1(props) : path;
  return /*#__PURE__*/_react$K["default"].createElement("path", _extends$D({}, (0, _ReactUtils$t.filterProps)(props, false), (0, _types$a.adaptEventHandlers)(props), {
    className: (0, _clsx$s["default"])('recharts-curve', className),
    d: realPath,
    ref: pathRef
  }));
};

var Rectangle = {};

var lib = {};

var Animate$1 = {};

var cjs$2 = {};

var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
/**
 * Combine two comparators into a single comparators.
 */
function combineComparators(comparatorA, comparatorB) {
    return function isEqual(a, b, state) {
        return comparatorA(a, b, state) && comparatorB(a, b, state);
    };
}
/**
 * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
 * for circular references to be safely included in the comparison without creating
 * stack overflows.
 */
function createIsCircular(areItemsEqual) {
    return function isCircular(a, b, state) {
        if (!a || !b || typeof a !== 'object' || typeof b !== 'object') {
            return areItemsEqual(a, b, state);
        }
        var cache = state.cache;
        var cachedA = cache.get(a);
        var cachedB = cache.get(b);
        if (cachedA && cachedB) {
            return cachedA === b && cachedB === a;
        }
        cache.set(a, b);
        cache.set(b, a);
        var result = areItemsEqual(a, b, state);
        cache.delete(a);
        cache.delete(b);
        return result;
    };
}
/**
 * Get the `@@toStringTag` of the value, if it exists.
 */
function getShortTag(value) {
    return value != null ? value[Symbol.toStringTag] : undefined;
}
/**
 * Get the properties to strictly examine, which include both own properties that are
 * not enumerable and symbol properties.
 */
function getStrictProperties(object) {
    return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
}
/**
 * Whether the object contains the property passed as an own property.
 */
var hasOwn = 
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
Object.hasOwn ||
    (function (object, property) {
        return hasOwnProperty$1.call(object, property);
    });
/**
 * Whether the values passed are strictly equal or both NaN.
 */
function sameValueZeroEqual(a, b) {
    return a === b || (!a && !b && a !== a && b !== b);
}

var PREACT_VNODE = '__v';
var PREACT_OWNER = '__o';
var REACT_OWNER = '_owner';
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys$1 = Object.keys;
/**
 * Whether the arrays are equal in value.
 */
function areArraysEqual(a, b, state) {
    var index = a.length;
    if (b.length !== index) {
        return false;
    }
    while (index-- > 0) {
        if (!state.equals(a[index], b[index], index, index, a, b, state)) {
            return false;
        }
    }
    return true;
}
/**
 * Whether the dates passed are equal in value.
 */
function areDatesEqual(a, b) {
    return sameValueZeroEqual(a.getTime(), b.getTime());
}
/**
 * Whether the errors passed are equal in value.
 */
function areErrorsEqual(a, b) {
    return (a.name === b.name &&
        a.message === b.message &&
        a.cause === b.cause &&
        a.stack === b.stack);
}
/**
 * Whether the functions passed are equal in value.
 */
function areFunctionsEqual(a, b) {
    return a === b;
}
/**
 * Whether the `Map`s are equal in value.
 */
function areMapsEqual(a, b, state) {
    var size = a.size;
    if (size !== b.size) {
        return false;
    }
    if (!size) {
        return true;
    }
    var matchedIndices = new Array(size);
    var aIterable = a.entries();
    var aResult;
    var bResult;
    var index = 0;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while ((aResult = aIterable.next())) {
        if (aResult.done) {
            break;
        }
        var bIterable = b.entries();
        var hasMatch = false;
        var matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while ((bResult = bIterable.next())) {
            if (bResult.done) {
                break;
            }
            if (matchedIndices[matchIndex]) {
                matchIndex++;
                continue;
            }
            var aEntry = aResult.value;
            var bEntry = bResult.value;
            if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) &&
                state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = true;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) {
            return false;
        }
        index++;
    }
    return true;
}
/**
 * Whether the numbers are equal in value.
 */
var areNumbersEqual = sameValueZeroEqual;
/**
 * Whether the objects are equal in value.
 */
function areObjectsEqual(a, b, state) {
    var properties = keys$1(a);
    var index = properties.length;
    if (keys$1(b).length !== index) {
        return false;
    }
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while (index-- > 0) {
        if (!isPropertyEqual(a, b, state, properties[index])) {
            return false;
        }
    }
    return true;
}
/**
 * Whether the objects are equal in value with strict property checking.
 */
function areObjectsEqualStrict(a, b, state) {
    var properties = getStrictProperties(a);
    var index = properties.length;
    if (getStrictProperties(b).length !== index) {
        return false;
    }
    var property;
    var descriptorA;
    var descriptorB;
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while (index-- > 0) {
        property = properties[index];
        if (!isPropertyEqual(a, b, state, property)) {
            return false;
        }
        descriptorA = getOwnPropertyDescriptor(a, property);
        descriptorB = getOwnPropertyDescriptor(b, property);
        if ((descriptorA || descriptorB) &&
            (!descriptorA ||
                !descriptorB ||
                descriptorA.configurable !== descriptorB.configurable ||
                descriptorA.enumerable !== descriptorB.enumerable ||
                descriptorA.writable !== descriptorB.writable)) {
            return false;
        }
    }
    return true;
}
/**
 * Whether the primitive wrappers passed are equal in value.
 */
function arePrimitiveWrappersEqual(a, b) {
    return sameValueZeroEqual(a.valueOf(), b.valueOf());
}
/**
 * Whether the regexps passed are equal in value.
 */
function areRegExpsEqual(a, b) {
    return a.source === b.source && a.flags === b.flags;
}
/**
 * Whether the `Set`s are equal in value.
 */
function areSetsEqual(a, b, state) {
    var size = a.size;
    if (size !== b.size) {
        return false;
    }
    if (!size) {
        return true;
    }
    var matchedIndices = new Array(size);
    var aIterable = a.values();
    var aResult;
    var bResult;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while ((aResult = aIterable.next())) {
        if (aResult.done) {
            break;
        }
        var bIterable = b.values();
        var hasMatch = false;
        var matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while ((bResult = bIterable.next())) {
            if (bResult.done) {
                break;
            }
            if (!matchedIndices[matchIndex] &&
                state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = true;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) {
            return false;
        }
    }
    return true;
}
/**
 * Whether the TypedArray instances are equal in value.
 */
function areTypedArraysEqual(a, b) {
    var index = a.length;
    if (b.length !== index) {
        return false;
    }
    while (index-- > 0) {
        if (a[index] !== b[index]) {
            return false;
        }
    }
    return true;
}
/**
 * Whether the URL instances are equal in value.
 */
function areUrlsEqual(a, b) {
    return (a.hostname === b.hostname &&
        a.pathname === b.pathname &&
        a.protocol === b.protocol &&
        a.port === b.port &&
        a.hash === b.hash &&
        a.username === b.username &&
        a.password === b.password);
}
function isPropertyEqual(a, b, state, property) {
    if ((property === REACT_OWNER ||
        property === PREACT_OWNER ||
        property === PREACT_VNODE) &&
        (a.$$typeof || b.$$typeof)) {
        return true;
    }
    return (hasOwn(b, property) &&
        state.equals(a[property], b[property], property, property, a, b, state));
}

var ARGUMENTS_TAG = '[object Arguments]';
var BOOLEAN_TAG = '[object Boolean]';
var DATE_TAG = '[object Date]';
var ERROR_TAG = '[object Error]';
var MAP_TAG = '[object Map]';
var NUMBER_TAG = '[object Number]';
var OBJECT_TAG = '[object Object]';
var REG_EXP_TAG = '[object RegExp]';
var SET_TAG = '[object Set]';
var STRING_TAG = '[object String]';
var URL_TAG = '[object URL]';
var isArray$2 = Array.isArray;
var isTypedArray = typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function'
    ? ArrayBuffer.isView
    : null;
var assign = Object.assign;
var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
/**
 * Create a comparator method based on the type-specific equality comparators passed.
 */
function createEqualityComparator(_a) {
    var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areErrorsEqual = _a.areErrorsEqual, areFunctionsEqual = _a.areFunctionsEqual, areMapsEqual = _a.areMapsEqual, areNumbersEqual = _a.areNumbersEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual, areUrlsEqual = _a.areUrlsEqual, unknownTagComparators = _a.unknownTagComparators;
    /**
     * compare the value of the two objects and return true if they are equivalent in values
     */
    return function comparator(a, b, state) {
        // If the items are strictly equal, no need to do a value comparison.
        if (a === b) {
            return true;
        }
        // If either of the items are nullish and fail the strictly equal check
        // above, then they must be unequal.
        if (a == null || b == null) {
            return false;
        }
        var type = typeof a;
        if (type !== typeof b) {
            return false;
        }
        if (type !== 'object') {
            if (type === 'number') {
                return areNumbersEqual(a, b, state);
            }
            if (type === 'function') {
                return areFunctionsEqual(a, b, state);
            }
            // If a primitive value that is not strictly equal, it must be unequal.
            return false;
        }
        var constructor = a.constructor;
        // Checks are listed in order of commonality of use-case:
        //   1. Common complex object types (plain object, array)
        //   2. Common data values (date, regexp)
        //   3. Less-common complex object types (map, set)
        //   4. Less-common data values (promise, primitive wrappers)
        // Inherently this is both subjective and assumptive, however
        // when reviewing comparable libraries in the wild this order
        // appears to be generally consistent.
        // Constructors should match, otherwise there is potential for false positives
        // between class and subclass or custom object and POJO.
        if (constructor !== b.constructor) {
            return false;
        }
        // `isPlainObject` only checks against the object's own realm. Cross-realm
        // comparisons are rare, and will be handled in the ultimate fallback, so
        // we can avoid capturing the string tag.
        if (constructor === Object) {
            return areObjectsEqual(a, b, state);
        }
        // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
        // the string tag or doing an `instanceof` check.
        if (isArray$2(a)) {
            return areArraysEqual(a, b, state);
        }
        // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
        // capturing the string tag or comparing against all possible constructors.
        if (isTypedArray != null && isTypedArray(a)) {
            return areTypedArraysEqual(a, b, state);
        }
        // Try to fast-path equality checks for other complex object types in the
        // same realm to avoid capturing the string tag. Strict equality is used
        // instead of `instanceof` because it is more performant for the common
        // use-case. If someone is subclassing a native class, it will be handled
        // with the string tag comparison.
        if (constructor === Date) {
            return areDatesEqual(a, b, state);
        }
        if (constructor === RegExp) {
            return areRegExpsEqual(a, b, state);
        }
        if (constructor === Map) {
            return areMapsEqual(a, b, state);
        }
        if (constructor === Set) {
            return areSetsEqual(a, b, state);
        }
        // Since this is a custom object, capture the string tag to determing its type.
        // This is reasonably performant in modern environments like v8 and SpiderMonkey.
        var tag = getTag(a);
        if (tag === DATE_TAG) {
            return areDatesEqual(a, b, state);
        }
        // For RegExp, the properties are not enumerable, and therefore will give false positives if
        // tested like a standard object.
        if (tag === REG_EXP_TAG) {
            return areRegExpsEqual(a, b, state);
        }
        if (tag === MAP_TAG) {
            return areMapsEqual(a, b, state);
        }
        if (tag === SET_TAG) {
            return areSetsEqual(a, b, state);
        }
        if (tag === OBJECT_TAG) {
            // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return (typeof a.then !== 'function' &&
                typeof b.then !== 'function' &&
                areObjectsEqual(a, b, state));
        }
        // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
        // enumerable, and therefore will give false positives if tested like a standard object.
        if (tag === URL_TAG) {
            return areUrlsEqual(a, b, state);
        }
        // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
        // enumerable, and therefore will give false positives if tested like a standard object.
        if (tag === ERROR_TAG) {
            return areErrorsEqual(a, b, state);
        }
        // If an arguments tag, it should be treated as a standard object.
        if (tag === ARGUMENTS_TAG) {
            return areObjectsEqual(a, b, state);
        }
        // As the penultimate fallback, check if the values passed are primitive wrappers. This
        // is very rare in modern JS, which is why it is deprioritized compared to all other object
        // types.
        if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) {
            return arePrimitiveWrappersEqual(a, b, state);
        }
        if (unknownTagComparators) {
            var unknownTagComparator = unknownTagComparators[tag];
            if (!unknownTagComparator) {
                var shortTag = getShortTag(a);
                if (shortTag) {
                    unknownTagComparator = unknownTagComparators[shortTag];
                }
            }
            // If the custom config has an unknown tag comparator that matches the captured tag or the
            // @@toStringTag, it is the source of truth for whether the values are equal.
            if (unknownTagComparator) {
                return unknownTagComparator(a, b, state);
            }
        }
        // If not matching any tags that require a specific type of comparison, then we hard-code false because
        // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
        //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
        //     comparison that can be made.
        //   - For types that can be introspected, but rarely have requirements to be compared
        //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
        //     use-cases (may be included in a future release, if requested enough).
        //   - For types that can be introspected but do not have an objective definition of what
        //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
        // In all cases, these decisions should be reevaluated based on changes to the language and
        // common development practices.
        return false;
    };
}
/**
 * Create the configuration object used for building comparators.
 */
function createEqualityComparatorConfig(_a) {
    var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
    var config = {
        areArraysEqual: strict
            ? areObjectsEqualStrict
            : areArraysEqual,
        areDatesEqual: areDatesEqual,
        areErrorsEqual: areErrorsEqual,
        areFunctionsEqual: areFunctionsEqual,
        areMapsEqual: strict
            ? combineComparators(areMapsEqual, areObjectsEqualStrict)
            : areMapsEqual,
        areNumbersEqual: areNumbersEqual,
        areObjectsEqual: strict
            ? areObjectsEqualStrict
            : areObjectsEqual,
        arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
        areRegExpsEqual: areRegExpsEqual,
        areSetsEqual: strict
            ? combineComparators(areSetsEqual, areObjectsEqualStrict)
            : areSetsEqual,
        areTypedArraysEqual: strict
            ? areObjectsEqualStrict
            : areTypedArraysEqual,
        areUrlsEqual: areUrlsEqual,
        unknownTagComparators: undefined,
    };
    if (createCustomConfig) {
        config = assign({}, config, createCustomConfig(config));
    }
    if (circular) {
        var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
        var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
        var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
        var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
        config = assign({}, config, {
            areArraysEqual: areArraysEqual$1,
            areMapsEqual: areMapsEqual$1,
            areObjectsEqual: areObjectsEqual$1,
            areSetsEqual: areSetsEqual$1,
        });
    }
    return config;
}
/**
 * Default equality comparator pass-through, used as the standard `isEqual` creator for
 * use inside the built comparator.
 */
function createInternalEqualityComparator(compare) {
    return function (a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
        return compare(a, b, state);
    };
}
/**
 * Create the `isEqual` function used by the consuming application.
 */
function createIsEqual(_a) {
    var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
    if (createState) {
        return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict,
            });
        };
    }
    if (circular) {
        return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict,
            });
        };
    }
    var state = {
        cache: undefined,
        equals: equals,
        meta: undefined,
        strict: strict,
    };
    return function isEqual(a, b) {
        return comparator(a, b, state);
    };
}

/**
 * Whether the items passed are deeply-equal in value.
 */
var deepEqual = createCustomEqual();
/**
 * Whether the items passed are deeply-equal in value based on strict comparison.
 */
var strictDeepEqual = createCustomEqual({ strict: true });
/**
 * Whether the items passed are deeply-equal in value, including circular references.
 */
var circularDeepEqual = createCustomEqual({ circular: true });
/**
 * Whether the items passed are deeply-equal in value, including circular references,
 * based on strict comparison.
 */
var strictCircularDeepEqual = createCustomEqual({
    circular: true,
    strict: true,
});
/**
 * Whether the items passed are shallowly-equal in value.
 */
var shallowEqual = createCustomEqual({
    createInternalComparator: function () { return sameValueZeroEqual; },
});
/**
 * Whether the items passed are shallowly-equal in value based on strict comparison
 */
var strictShallowEqual = createCustomEqual({
    strict: true,
    createInternalComparator: function () { return sameValueZeroEqual; },
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references.
 */
var circularShallowEqual = createCustomEqual({
    circular: true,
    createInternalComparator: function () { return sameValueZeroEqual; },
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references,
 * based on strict comparison.
 */
var strictCircularShallowEqual = createCustomEqual({
    circular: true,
    createInternalComparator: function () { return sameValueZeroEqual; },
    strict: true,
});
/**
 * Create a custom equality comparison method.
 *
 * This can be done to create very targeted comparisons in extreme hot-path scenarios
 * where the standard methods are not performant enough, but can also be used to provide
 * support for legacy environments that do not support expected features like
 * `RegExp.prototype.flags` out of the box.
 */
function createCustomEqual(options) {
    if (options === void 0) { options = {}; }
    var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
    var config = createEqualityComparatorConfig(options);
    var comparator = createEqualityComparator(config);
    var equals = createCustomInternalComparator
        ? createCustomInternalComparator(comparator)
        : createInternalEqualityComparator(comparator);
    return createIsEqual({ circular: circular, comparator: comparator, createState: createState, equals: equals, strict: strict });
}

cjs$2.circularDeepEqual = circularDeepEqual;
cjs$2.circularShallowEqual = circularShallowEqual;
cjs$2.createCustomEqual = createCustomEqual;
cjs$2.deepEqual = deepEqual;
cjs$2.sameValueZeroEqual = sameValueZeroEqual;
cjs$2.shallowEqual = shallowEqual;
cjs$2.strictCircularDeepEqual = strictCircularDeepEqual;
cjs$2.strictCircularShallowEqual = strictCircularShallowEqual;
cjs$2.strictDeepEqual = strictDeepEqual;
cjs$2.strictShallowEqual = strictShallowEqual;

var AnimateManager = {};

var setRafTimeout$1 = {};

Object.defineProperty(setRafTimeout$1, "__esModule", {
  value: true
});
setRafTimeout$1.default = setRafTimeout;
function safeRequestAnimationFrame(callback) {
  if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currTime = -1;
  var shouldUpdate = function shouldUpdate(now) {
    if (currTime < 0) {
      currTime = now;
    }
    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      safeRequestAnimationFrame(shouldUpdate);
    }
  };
  requestAnimationFrame(shouldUpdate);
}

Object.defineProperty(AnimateManager, "__esModule", {
  value: true
});
AnimateManager.default = createAnimateManager;
var _setRafTimeout = _interopRequireDefault$S(setRafTimeout$1);
function _interopRequireDefault$S(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof$J(o) { "@babel/helpers - typeof"; return _typeof$J = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$J(o); }
function _toArray(arr) { return _arrayWithHoles$c(arr) || _iterableToArray$8(arr) || _unsupportedIterableToArray$p(arr) || _nonIterableRest$c(); }
function _nonIterableRest$c() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$p(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$p(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$p(o, minLen); }
function _arrayLikeToArray$p(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArray$8(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithHoles$c(arr) { if (Array.isArray(arr)) return arr; }
function createAnimateManager() {
  var currStyle = {};
  var handleChange = function handleChange() {
    return null;
  };
  var shouldStop = false;
  var setStyle = function setStyle(_style) {
    if (shouldStop) {
      return;
    }
    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }
      var styles = _style;
      var _styles = _toArray(styles),
        curr = _styles[0],
        restStyles = _styles.slice(1);
      if (typeof curr === 'number') {
        (0, _setRafTimeout.default)(setStyle.bind(null, restStyles), curr);
        return;
      }
      setStyle(curr);
      (0, _setRafTimeout.default)(setStyle.bind(null, restStyles));
      return;
    }
    if (_typeof$J(_style) === 'object') {
      currStyle = _style;
      handleChange(currStyle);
    }
    if (typeof _style === 'function') {
      _style();
    }
  };
  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;
      return function () {
        handleChange = function handleChange() {
          return null;
        };
      };
    }
  };
}

var easing = {};

var util = {};

Object.defineProperty(util, "__esModule", {
  value: true
});
util.warn = util.mapObject = util.log = util.identity = util.getTransitionVal = util.getIntersectionKeys = util.getDashCase = util.debugf = util.debug = void 0;
function _typeof$I(o) { "@babel/helpers - typeof"; return _typeof$I = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$I(o); }
function ownKeys$G(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$E(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$G(Object(t), !0).forEach(function (r) { _defineProperty$L(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$G(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$L(obj, key, value) { key = _toPropertyKey$D(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$D(arg) { var key = _toPrimitive$D(arg, "string"); return _typeof$I(key) === "symbol" ? key : String(key); }
function _toPrimitive$D(input, hint) { if (_typeof$I(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof$I(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint no-console: 0 */

util.getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
  return [Object.keys(preObj), Object.keys(nextObj)].reduce(function (a, b) {
    return a.filter(function (c) {
      return b.includes(c);
    });
  });
};
util.identity = function identity(param) {
  return param;
};

/*
 * @description: convert camel case to dash case
 * string => string
 */
var getDashCase = util.getDashCase = function getDashCase(name) {
  return name.replace(/([A-Z])/g, function (v) {
    return "-".concat(v.toLowerCase());
  });
};
var log = util.log = function log() {
  var _console;
  (_console = console).log.apply(_console, arguments);
};

/*
 * @description: log the value of a varible
 * string => any => any
 */
util.debug = function debug(name) {
  return function (item) {
    log(name, item);
    return item;
  };
};

/*
 * @description: log name, args, return value of a function
 * function => function
 */
util.debugf = function debugf(tag, f) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var res = f.apply(void 0, args);
    var name = tag || f.name || 'anonymous function';
    var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
    log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
    return res;
  };
};

/*
 * @description: map object on every element in this object.
 * (function, object) => object
 */
util.mapObject = function mapObject(fn, obj) {
  return Object.keys(obj).reduce(function (res, key) {
    return _objectSpread$E(_objectSpread$E({}, res), {}, _defineProperty$L({}, key, fn(key, obj[key])));
  }, {});
};
util.getTransitionVal = function getTransitionVal(props, duration, easing) {
  return props.map(function (prop) {
    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
  }).join(',');
};
var isDev = process.env.NODE_ENV !== 'production';
util.warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }
    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

Object.defineProperty(easing, "__esModule", {
  value: true
});
easing.configSpring = easing.configEasing = easing.configBezier = void 0;
var _util$2 = util;
function _slicedToArray$d(arr, i) { return _arrayWithHoles$b(arr) || _iterableToArrayLimit$b(arr, i) || _unsupportedIterableToArray$o(arr, i) || _nonIterableRest$b(); }
function _nonIterableRest$b() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit$b(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$b(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray$7(arr) { return _arrayWithoutHoles$7(arr) || _iterableToArray$7(arr) || _unsupportedIterableToArray$o(arr) || _nonIterableSpread$7(); }
function _nonIterableSpread$7() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$o(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$o(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$o(o, minLen); }
function _iterableToArray$7(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$7(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$o(arr); }
function _arrayLikeToArray$o(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var ACCURACY = 1e-4;
var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
};
var multyTime = function multyTime(params, t) {
  return params.map(function (param, i) {
    return param * Math.pow(t, i);
  }).reduce(function (pre, curr) {
    return pre + curr;
  });
};
var cubicBezier = function cubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    return multyTime(params, t);
  };
};
var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    var newParams = [].concat(_toConsumableArray$7(params.map(function (param, i) {
      return param * i;
    }).slice(1)), [0]);
    return multyTime(newParams, t);
  };
};

// calculate cubic-bezier using Newton's method
var configBezier = easing.configBezier = function configBezier() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var x1 = args[0],
    y1 = args[1],
    x2 = args[2],
    y2 = args[3];
  if (args.length === 1) {
    switch (args[0]) {
      case 'linear':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;
      case 'ease':
        x1 = 0.25;
        y1 = 0.1;
        x2 = 0.25;
        y2 = 1.0;
        break;
      case 'ease-in':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;
      case 'ease-out':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;
      case 'ease-in-out':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;
      default:
        {
          var easing = args[0].split('(');
          if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
            var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function (x) {
              return parseFloat(x);
            });
            var _easing$1$split$0$spl2 = _slicedToArray$d(_easing$1$split$0$spl, 4);
            x1 = _easing$1$split$0$spl2[0];
            y1 = _easing$1$split$0$spl2[1];
            x2 = _easing$1$split$0$spl2[2];
            y2 = _easing$1$split$0$spl2[3];
          } else {
            (0, _util$2.warn)(false, '[configBezier]: arguments should be one of ' + "oneOf 'linear', 'ease', 'ease-in', 'ease-out', " + "'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
          }
        }
    }
  }
  (0, _util$2.warn)([x1, x2, y1, y2].every(function (num) {
    return typeof num === 'number' && num >= 0 && num <= 1;
  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
  var curveX = cubicBezier(x1, x2);
  var curveY = cubicBezier(y1, y2);
  var derCurveX = derivativeCubicBezier(x1, x2);
  var rangeValue = function rangeValue(value) {
    if (value > 1) {
      return 1;
    }
    if (value < 0) {
      return 0;
    }
    return value;
  };
  var bezier = function bezier(_t) {
    var t = _t > 1 ? 1 : _t;
    var x = t;
    for (var i = 0; i < 8; ++i) {
      var evalT = curveX(x) - t;
      var derVal = derCurveX(x);
      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
        return curveY(x);
      }
      x = rangeValue(x - evalT / derVal);
    }
    return curveY(x);
  };
  bezier.isStepper = false;
  return bezier;
};
var configSpring = easing.configSpring = function configSpring() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$stiff = config.stiff,
    stiff = _config$stiff === void 0 ? 100 : _config$stiff,
    _config$damping = config.damping,
    damping = _config$damping === void 0 ? 8 : _config$damping,
    _config$dt = config.dt,
    dt = _config$dt === void 0 ? 17 : _config$dt;
  var stepper = function stepper(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + (FSpring - FDamping) * dt / 1000;
    var newX = currV * dt / 1000 + currX;
    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }
    return [newX, newV];
  };
  stepper.isStepper = true;
  stepper.dt = dt;
  return stepper;
};
easing.configEasing = function configEasing() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var easing = args[0];
  if (typeof easing === 'string') {
    switch (easing) {
      case 'ease':
      case 'ease-in-out':
      case 'ease-out':
      case 'ease-in':
      case 'linear':
        return configBezier(easing);
      case 'spring':
        return configSpring();
      default:
        if (easing.split('(')[0] === 'cubic-bezier') {
          return configBezier(easing);
        }
        (0, _util$2.warn)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', " + "'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
  }
  if (typeof easing === 'function') {
    return easing;
  }
  (0, _util$2.warn)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
  return null;
};

var configUpdate = {};

function _typeof$H(o) { "@babel/helpers - typeof"; return _typeof$H = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$H(o); }
Object.defineProperty(configUpdate, "__esModule", {
  value: true
});
configUpdate.default = void 0;
var _util$1 = util;
function _toConsumableArray$6(arr) { return _arrayWithoutHoles$6(arr) || _iterableToArray$6(arr) || _unsupportedIterableToArray$n(arr) || _nonIterableSpread$6(); }
function _nonIterableSpread$6() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray$6(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$6(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$n(arr); }
function ownKeys$F(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$D(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$F(Object(t), !0).forEach(function (r) { _defineProperty$K(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$F(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$K(obj, key, value) { key = _toPropertyKey$C(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$C(arg) { var key = _toPrimitive$C(arg, "string"); return _typeof$H(key) === "symbol" ? key : String(key); }
function _toPrimitive$C(input, hint) { if (_typeof$H(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof$H(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray$c(arr, i) { return _arrayWithHoles$a(arr) || _iterableToArrayLimit$a(arr, i) || _unsupportedIterableToArray$n(arr, i) || _nonIterableRest$a(); }
function _nonIterableRest$a() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$n(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$n(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$n(o, minLen); }
function _arrayLikeToArray$n(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$a(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$a(arr) { if (Array.isArray(arr)) return arr; }
var alpha = function alpha(begin, end, k) {
  return begin + (end - begin) * k;
};
var needContinue = function needContinue(_ref) {
  var from = _ref.from,
    to = _ref.to;
  return from !== to;
};

/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */
var calStepperVals = function calStepperVals(easing, preVals, steps) {
  var nextStepVals = (0, _util$1.mapObject)(function (key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity),
        _easing2 = _slicedToArray$c(_easing, 2),
        newX = _easing2[0],
        newV = _easing2[1];
      return _objectSpread$D(_objectSpread$D({}, val), {}, {
        from: newX,
        velocity: newV
      });
    }
    return val;
  }, preVals);
  if (steps < 1) {
    return (0, _util$1.mapObject)(function (key, val) {
      if (needContinue(val)) {
        return _objectSpread$D(_objectSpread$D({}, val), {}, {
          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
          from: alpha(val.from, nextStepVals[key].from, steps)
        });
      }
      return val;
    }, preVals);
  }
  return calStepperVals(easing, nextStepVals, steps - 1);
};

// configure update function
configUpdate.default = function _default(from, to, easing, duration, render) {
  var interKeys = (0, _util$1.getIntersectionKeys)(from, to);
  var timingStyle = interKeys.reduce(function (res, key) {
    return _objectSpread$D(_objectSpread$D({}, res), {}, _defineProperty$K({}, key, [from[key], to[key]]));
  }, {});
  var stepperStyle = interKeys.reduce(function (res, key) {
    return _objectSpread$D(_objectSpread$D({}, res), {}, _defineProperty$K({}, key, {
      from: from[key],
      velocity: 0,
      to: to[key]
    }));
  }, {});
  var cafId = -1;
  var preTime;
  var beginTime;
  var update = function update() {
    return null;
  };
  var getCurrStyle = function getCurrStyle() {
    return (0, _util$1.mapObject)(function (key, val) {
      return val.from;
    }, stepperStyle);
  };
  var shouldStopAnimation = function shouldStopAnimation() {
    return !Object.values(stepperStyle).filter(needContinue).length;
  };

  // stepper timing function like spring
  var stepperUpdate = function stepperUpdate(now) {
    if (!preTime) {
      preTime = now;
    }
    var deltaTime = now - preTime;
    var steps = deltaTime / easing.dt;
    stepperStyle = calStepperVals(easing, stepperStyle, steps);
    // get union set and add compatible prefix
    render(_objectSpread$D(_objectSpread$D(_objectSpread$D({}, from), to), getCurrStyle()));
    preTime = now;
    if (!shouldStopAnimation()) {
      cafId = requestAnimationFrame(update);
    }
  };

  // t => val timing function like cubic-bezier
  var timingUpdate = function timingUpdate(now) {
    if (!beginTime) {
      beginTime = now;
    }
    var t = (now - beginTime) / duration;
    var currStyle = (0, _util$1.mapObject)(function (key, val) {
      return alpha.apply(void 0, _toConsumableArray$6(val).concat([easing(t)]));
    }, timingStyle);

    // get union set and add compatible prefix
    render(_objectSpread$D(_objectSpread$D(_objectSpread$D({}, from), to), currStyle));
    if (t < 1) {
      cafId = requestAnimationFrame(update);
    } else {
      var finalStyle = (0, _util$1.mapObject)(function (key, val) {
        return alpha.apply(void 0, _toConsumableArray$6(val).concat([easing(1)]));
      }, timingStyle);
      render(_objectSpread$D(_objectSpread$D(_objectSpread$D({}, from), to), finalStyle));
    }
  };
  update = easing.isStepper ? stepperUpdate : timingUpdate;

  // return start animation method
  return function () {
    requestAnimationFrame(update);

    // return stop animation method
    return function () {
      cancelAnimationFrame(cafId);
    };
  };
};

function _typeof$G(o) { "@babel/helpers - typeof"; return _typeof$G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$G(o); }
Object.defineProperty(Animate$1, "__esModule", {
  value: true
});
Animate$1.default = void 0;
var _react$J = _interopRequireWildcard$m(React__default$4);
var _propTypes$9 = _interopRequireDefault$R(propTypes.exports);
var _fastEquals = cjs$2;
var _AnimateManager = _interopRequireDefault$R(AnimateManager);
var _easing = easing;
var _configUpdate = _interopRequireDefault$R(configUpdate);
var _util = util;
var _excluded$j = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function _interopRequireDefault$R(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache$m(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$m = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$m(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$G(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$m(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties$m(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$j(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$j(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray$5(arr) { return _arrayWithoutHoles$5(arr) || _iterableToArray$5(arr) || _unsupportedIterableToArray$m(arr) || _nonIterableSpread$5(); }
function _nonIterableSpread$5() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$m(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$m(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$m(o, minLen); }
function _iterableToArray$5(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$5(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$m(arr); }
function _arrayLikeToArray$m(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys$E(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$C(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$E(Object(t), !0).forEach(function (r) { _defineProperty$J(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$E(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$J(obj, key, value) { key = _toPropertyKey$B(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck$D(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$x(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$B(descriptor.key), descriptor); } }
function _createClass$D(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$x(Constructor.prototype, protoProps); if (staticProps) _defineProperties$x(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey$B(arg) { var key = _toPrimitive$B(arg, "string"); return _typeof$G(key) === "symbol" ? key : String(key); }
function _toPrimitive$B(input, hint) { if (_typeof$G(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof$G(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits$t(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$n(subClass, superClass); }
function _setPrototypeOf$n(o, p) { _setPrototypeOf$n = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$n(o, p); }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$n(); return function _createSuperInternal() { var Super = _getPrototypeOf$n(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$n(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$t(this, result); }; }
function _possibleConstructorReturn$t(self, call) { if (call && (_typeof$G(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$n(self); }
function _assertThisInitialized$n(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$n() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$n(o) { _getPrototypeOf$n = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$n(o); }
var Animate = /*#__PURE__*/function (_PureComponent) {
  _inherits$t(Animate, _PureComponent);
  var _super = _createSuper$2(Animate);
  function Animate(props, context) {
    var _this;
    _classCallCheck$D(this, Animate);
    _this = _super.call(this, props, context);
    var _this$props = _this.props,
      isActive = _this$props.isActive,
      attributeName = _this$props.attributeName,
      from = _this$props.from,
      to = _this$props.to,
      steps = _this$props.steps,
      children = _this$props.children,
      duration = _this$props.duration;
    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized$n(_this));
    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized$n(_this));
    if (!isActive || duration <= 0) {
      _this.state = {
        style: {}
      };

      // if children is a function and animation is not active, set style to 'to'
      if (typeof children === 'function') {
        _this.state = {
          style: to
        };
      }
      return _possibleConstructorReturn$t(_this);
    }
    if (steps && steps.length) {
      _this.state = {
        style: steps[0].style
      };
    } else if (from) {
      if (typeof children === 'function') {
        _this.state = {
          style: from
        };
        return _possibleConstructorReturn$t(_this);
      }
      _this.state = {
        style: attributeName ? _defineProperty$J({}, attributeName, from) : from
      };
    } else {
      _this.state = {
        style: {}
      };
    }
    return _this;
  }
  _createClass$D(Animate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        isActive = _this$props2.isActive,
        canBegin = _this$props2.canBegin;
      this.mounted = true;
      if (!isActive || !canBegin) {
        return;
      }
      this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
        isActive = _this$props3.isActive,
        canBegin = _this$props3.canBegin,
        attributeName = _this$props3.attributeName,
        shouldReAnimate = _this$props3.shouldReAnimate,
        to = _this$props3.to,
        currentFrom = _this$props3.from;
      var style = this.state.style;
      if (!canBegin) {
        return;
      }
      if (!isActive) {
        var newState = {
          style: attributeName ? _defineProperty$J({}, attributeName, to) : to
        };
        if (this.state && style) {
          if (attributeName && style[attributeName] !== to || !attributeName && style !== to) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(newState);
          }
        }
        return;
      }
      if ((0, _fastEquals.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) {
        return;
      }
      var isTriggered = !prevProps.canBegin || !prevProps.isActive;
      if (this.manager) {
        this.manager.stop();
      }
      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
      var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
      if (this.state && style) {
        var _newState = {
          style: attributeName ? _defineProperty$J({}, attributeName, from) : from
        };
        if (attributeName && style[attributeName] !== from || !attributeName && style !== from) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState(_newState);
        }
      }
      this.runAnimation(_objectSpread$C(_objectSpread$C({}, this.props), {}, {
        from: from,
        begin: 0
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      var onAnimationEnd = this.props.onAnimationEnd;
      if (this.unSubscribe) {
        this.unSubscribe();
      }
      if (this.manager) {
        this.manager.stop();
        this.manager = null;
      }
      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
      if (onAnimationEnd) {
        onAnimationEnd();
      }
    }
  }, {
    key: "handleStyleChange",
    value: function handleStyleChange(style) {
      this.changeStyle(style);
    }
  }, {
    key: "changeStyle",
    value: function changeStyle(style) {
      if (this.mounted) {
        this.setState({
          style: style
        });
      }
    }
  }, {
    key: "runJSAnimation",
    value: function runJSAnimation(props) {
      var _this2 = this;
      var from = props.from,
        to = props.to,
        duration = props.duration,
        easing = props.easing,
        begin = props.begin,
        onAnimationEnd = props.onAnimationEnd,
        onAnimationStart = props.onAnimationStart;
      var startAnimation = (0, _configUpdate.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
      var finalStartAnimation = function finalStartAnimation() {
        _this2.stopJSAnimation = startAnimation();
      };
      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
    }
  }, {
    key: "runStepAnimation",
    value: function runStepAnimation(props) {
      var _this3 = this;
      var steps = props.steps,
        begin = props.begin,
        onAnimationStart = props.onAnimationStart;
      var _steps$ = steps[0],
        initialStyle = _steps$.style,
        _steps$$duration = _steps$.duration,
        initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
      var addStyle = function addStyle(sequence, nextItem, index) {
        if (index === 0) {
          return sequence;
        }
        var duration = nextItem.duration,
          _nextItem$easing = nextItem.easing,
          easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
          style = nextItem.style,
          nextProperties = nextItem.properties,
          onAnimationEnd = nextItem.onAnimationEnd;
        var preItem = index > 0 ? steps[index - 1] : nextItem;
        var properties = nextProperties || Object.keys(style);
        if (typeof easing === 'function' || easing === 'spring') {
          return [].concat(_toConsumableArray$5(sequence), [_this3.runJSAnimation.bind(_this3, {
            from: preItem.style,
            to: style,
            duration: duration,
            easing: easing
          }), duration]);
        }
        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
        var newStyle = _objectSpread$C(_objectSpread$C(_objectSpread$C({}, preItem.style), style), {}, {
          transition: transition
        });
        return [].concat(_toConsumableArray$5(sequence), [newStyle, duration, onAnimationEnd]).filter(_util.identity);
      };
      return this.manager.start([onAnimationStart].concat(_toConsumableArray$5(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function runAnimation(props) {
      if (!this.manager) {
        this.manager = (0, _AnimateManager.default)();
      }
      var begin = props.begin,
        duration = props.duration,
        attributeName = props.attributeName,
        propsTo = props.to,
        easing = props.easing,
        onAnimationStart = props.onAnimationStart,
        onAnimationEnd = props.onAnimationEnd,
        steps = props.steps,
        children = props.children;
      var manager = this.manager;
      this.unSubscribe = manager.subscribe(this.handleStyleChange);
      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
        this.runJSAnimation(props);
        return;
      }
      if (steps.length > 1) {
        this.runStepAnimation(props);
        return;
      }
      var to = attributeName ? _defineProperty$J({}, attributeName, propsTo) : propsTo;
      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
      manager.start([onAnimationStart, begin, _objectSpread$C(_objectSpread$C({}, to), {}, {
        transition: transition
      }), duration, onAnimationEnd]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        children = _this$props4.children;
        _this$props4.begin;
        var duration = _this$props4.duration;
        _this$props4.attributeName;
        _this$props4.easing;
        var isActive = _this$props4.isActive;
        _this$props4.steps;
        _this$props4.from;
        _this$props4.to;
        _this$props4.canBegin;
        _this$props4.onAnimationEnd;
        _this$props4.shouldReAnimate;
        _this$props4.onAnimationReStart;
        var others = _objectWithoutProperties$m(_this$props4, _excluded$j);
      var count = _react$J.Children.count(children);
      // eslint-disable-next-line react/destructuring-assignment
      var stateStyle = this.state.style;
      if (typeof children === 'function') {
        return children(stateStyle);
      }
      if (!isActive || count === 0 || duration <= 0) {
        return children;
      }
      var cloneContainer = function cloneContainer(container) {
        var _container$props = container.props,
          _container$props$styl = _container$props.style,
          style = _container$props$styl === void 0 ? {} : _container$props$styl,
          className = _container$props.className;
        var res = /*#__PURE__*/(0, _react$J.cloneElement)(container, _objectSpread$C(_objectSpread$C({}, others), {}, {
          style: _objectSpread$C(_objectSpread$C({}, style), stateStyle),
          className: className
        }));
        return res;
      };
      if (count === 1) {
        return cloneContainer(_react$J.Children.only(children));
      }
      return /*#__PURE__*/_react$J.default.createElement("div", null, _react$J.Children.map(children, function (child) {
        return cloneContainer(child);
      }));
    }
  }]);
  return Animate;
}(_react$J.PureComponent);
Animate.displayName = 'Animate';
Animate.defaultProps = {
  begin: 0,
  duration: 1000,
  from: '',
  to: '',
  attributeName: '',
  easing: 'ease',
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationStart: function onAnimationStart() {}
};
Animate.propTypes = {
  from: _propTypes$9.default.oneOfType([_propTypes$9.default.object, _propTypes$9.default.string]),
  to: _propTypes$9.default.oneOfType([_propTypes$9.default.object, _propTypes$9.default.string]),
  attributeName: _propTypes$9.default.string,
  // animation duration
  duration: _propTypes$9.default.number,
  begin: _propTypes$9.default.number,
  easing: _propTypes$9.default.oneOfType([_propTypes$9.default.string, _propTypes$9.default.func]),
  steps: _propTypes$9.default.arrayOf(_propTypes$9.default.shape({
    duration: _propTypes$9.default.number.isRequired,
    style: _propTypes$9.default.object.isRequired,
    easing: _propTypes$9.default.oneOfType([_propTypes$9.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes$9.default.func]),
    // transition css properties(dash case), optional
    properties: _propTypes$9.default.arrayOf('string'),
    onAnimationEnd: _propTypes$9.default.func
  })),
  children: _propTypes$9.default.oneOfType([_propTypes$9.default.node, _propTypes$9.default.func]),
  isActive: _propTypes$9.default.bool,
  canBegin: _propTypes$9.default.bool,
  onAnimationEnd: _propTypes$9.default.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: _propTypes$9.default.bool,
  onAnimationStart: _propTypes$9.default.func,
  onAnimationReStart: _propTypes$9.default.func
};
Animate$1.default = Animate;

var AnimateGroup$1 = {};

var AnimateGroupChild$1 = {};

Object.defineProperty(AnimateGroupChild$1, "__esModule", {
  value: true
});
AnimateGroupChild$1.default = void 0;
var _react$I = _interopRequireWildcard$l(React__default$4);
var _reactTransitionGroup$1 = cjs$4;
var _propTypes$8 = _interopRequireDefault$Q(propTypes.exports);
var _Animate = _interopRequireDefault$Q(Animate$1);
var _excluded$i = ["children", "appearOptions", "enterOptions", "leaveOptions"];
function _interopRequireDefault$Q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache$l(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$l = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$l(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$F(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$l(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof$F(o) { "@babel/helpers - typeof"; return _typeof$F = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$F(o); }
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
function _objectWithoutProperties$l(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$i(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$i(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys$D(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$B(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$D(Object(t), !0).forEach(function (r) { _defineProperty$I(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$D(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$C(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$w(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$A(descriptor.key), descriptor); } }
function _createClass$C(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$w(Constructor.prototype, protoProps); if (staticProps) _defineProperties$w(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits$s(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$m(subClass, superClass); }
function _setPrototypeOf$m(o, p) { _setPrototypeOf$m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$m(o, p); }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$m(); return function _createSuperInternal() { var Super = _getPrototypeOf$m(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf$m(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$s(this, result); }; }
function _possibleConstructorReturn$s(self, call) { if (call && (_typeof$F(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$m(self); }
function _assertThisInitialized$m(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$m() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf$m(o) { _getPrototypeOf$m = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$m(o); }
function _defineProperty$I(obj, key, value) { key = _toPropertyKey$A(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$A(arg) { var key = _toPrimitive$A(arg, "string"); return _typeof$F(key) === "symbol" ? key : String(key); }
function _toPrimitive$A(input, hint) { if (_typeof$F(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof$F(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var steps = options.steps,
    duration = options.duration;
  if (steps && steps.length) {
    return steps.reduce(function (result, entry) {
      return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
  }
  if (Number.isFinite(duration)) {
    return duration;
  }
  return 0;
};
var AnimateGroupChild = /*#__PURE__*/function (_Component) {
  _inherits$s(AnimateGroupChild, _Component);
  var _super = _createSuper$1(AnimateGroupChild);
  function AnimateGroupChild() {
    var _this;
    _classCallCheck$C(this, AnimateGroupChild);
    _this = _super.call(this);
    _defineProperty$I(_assertThisInitialized$m(_this), "handleEnter", function (node, isAppearing) {
      var _this$props = _this.props,
        appearOptions = _this$props.appearOptions,
        enterOptions = _this$props.enterOptions;
      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
    });
    _defineProperty$I(_assertThisInitialized$m(_this), "handleExit", function () {
      var leaveOptions = _this.props.leaveOptions;
      _this.handleStyleActive(leaveOptions);
    });
    _this.state = {
      isActive: false
    };
    return _this;
  }
  _createClass$C(AnimateGroupChild, [{
    key: "handleStyleActive",
    value: function handleStyleActive(style) {
      if (style) {
        var onAnimationEnd = style.onAnimationEnd ? function () {
          style.onAnimationEnd();
        } : null;
        this.setState(_objectSpread$B(_objectSpread$B({}, style), {}, {
          onAnimationEnd: onAnimationEnd,
          isActive: true
        }));
      }
    }
  }, {
    key: "parseTimeout",
    value: function parseTimeout() {
      var _this$props2 = this.props,
        appearOptions = _this$props2.appearOptions,
        enterOptions = _this$props2.enterOptions,
        leaveOptions = _this$props2.leaveOptions;
      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        children = _this$props3.children;
        _this$props3.appearOptions;
        _this$props3.enterOptions;
        _this$props3.leaveOptions;
        var props = _objectWithoutProperties$l(_this$props3, _excluded$i);
      return /*#__PURE__*/_react$I.default.createElement(_reactTransitionGroup$1.Transition, _extends$C({}, props, {
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        timeout: this.parseTimeout()
      }), function () {
        return /*#__PURE__*/_react$I.default.createElement(_Animate.default, _this2.state, _react$I.Children.only(children));
      });
    }
  }]);
  return AnimateGroupChild;
}(_react$I.Component);
AnimateGroupChild.propTypes = {
  appearOptions: _propTypes$8.default.object,
  enterOptions: _propTypes$8.default.object,
  leaveOptions: _propTypes$8.default.object,
  children: _propTypes$8.default.element
};
AnimateGroupChild$1.default = AnimateGroupChild;

function _typeof$E(o) { "@babel/helpers - typeof"; return _typeof$E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$E(o); }
Object.defineProperty(AnimateGroup$1, "__esModule", {
  value: true
});
AnimateGroup$1.default = void 0;
var _react$H = _interopRequireWildcard$k(React__default$4);
var _reactTransitionGroup = cjs$4;
var _propTypes$7 = _interopRequireDefault$P(propTypes.exports);
var _AnimateGroupChild = _interopRequireDefault$P(AnimateGroupChild$1);
function _interopRequireDefault$P(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache$k(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$k = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$k(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$E(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache$k(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function AnimateGroup(props) {
  var component = props.component,
    children = props.children,
    appear = props.appear,
    enter = props.enter,
    leave = props.leave;
  return /*#__PURE__*/_react$H.default.createElement(_reactTransitionGroup.TransitionGroup, {
    component: component
  }, _react$H.Children.map(children, function (child, index) {
    return /*#__PURE__*/_react$H.default.createElement(_AnimateGroupChild.default, {
      appearOptions: appear,
      enterOptions: enter,
      leaveOptions: leave,
      key: "child-".concat(index) // eslint-disable-line
    }, child);
  }));
}
AnimateGroup.propTypes = {
  appear: _propTypes$7.default.object,
  enter: _propTypes$7.default.object,
  leave: _propTypes$7.default.object,
  children: _propTypes$7.default.oneOfType([_propTypes$7.default.array, _propTypes$7.default.element]),
  component: _propTypes$7.default.any
};
AnimateGroup.defaultProps = {
  component: 'span'
};
AnimateGroup$1.default = AnimateGroup;

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AnimateGroup", {
  enumerable: true,
  get: function get() {
    return _AnimateGroup.default;
  }
});
Object.defineProperty(exports, "configBezier", {
  enumerable: true,
  get: function get() {
    return _easing.configBezier;
  }
});
Object.defineProperty(exports, "configSpring", {
  enumerable: true,
  get: function get() {
    return _easing.configSpring;
  }
});
exports.default = void 0;
var _Animate = _interopRequireDefault(Animate$1);
var _easing = easing;
var _AnimateGroup = _interopRequireDefault(AnimateGroup$1);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
exports.default = _Animate.default;
}(lib));

Object.defineProperty(Rectangle, "__esModule", {
  value: true
});
Rectangle.isInRectangle = Rectangle.Rectangle = void 0;
var _react$G = _interopRequireWildcard$j(React__default$4);
var _clsx$r = _interopRequireDefault$O(clsx.exports);
var _reactSmooth$a = _interopRequireDefault$O(lib);
var _ReactUtils$s = ReactUtils;
function _interopRequireDefault$O(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$j(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$j = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$j(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$D(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$j(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$D(o) { "@babel/helpers - typeof"; return _typeof$D = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$D(o); }
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
function _slicedToArray$b(arr, i) { return _arrayWithHoles$9(arr) || _iterableToArrayLimit$9(arr, i) || _unsupportedIterableToArray$l(arr, i) || _nonIterableRest$9(); }
function _nonIterableRest$9() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$l(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$l(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$l(o, minLen); }
function _arrayLikeToArray$l(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$9(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$9(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys$C(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$A(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$C(Object(t), !0).forEach(function (r) { _defineProperty$H(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$C(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$H(obj, key, value) { key = _toPropertyKey$z(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$z(t) { var i = _toPrimitive$z(t, "string"); return "symbol" == _typeof$D(i) ? i : i + ""; }
function _toPrimitive$z(t, r) { if ("object" != _typeof$D(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$D(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Rectangle
 */
var getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
  var ySign = height >= 0 ? 1 : -1;
  var xSign = width >= 0 ? 1 : -1;
  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
  var path;
  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [0, 0, 0, 0];
    for (var i = 0, len = 4; i < len; i++) {
      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
    }
    path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
    if (newRadius[0] > 0) {
      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
    }
    path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
    if (newRadius[1] > 0) {
      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
    }
    path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
    if (newRadius[2] > 0) {
      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
    }
    path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
    if (newRadius[3] > 0) {
      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
    }
    path += 'Z';
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);
    path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
  } else {
    path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
  }
  return path;
};
Rectangle.isInRectangle = function isInRectangle(point, rect) {
  if (!point || !rect) {
    return false;
  }
  var px = point.x,
    py = point.y;
  var x = rect.x,
    y = rect.y,
    width = rect.width,
    height = rect.height;
  if (Math.abs(width) > 0 && Math.abs(height) > 0) {
    var minX = Math.min(x, x + width);
    var maxX = Math.max(x, x + width);
    var minY = Math.min(y, y + height);
    var maxY = Math.max(y, y + height);
    return px >= minX && px <= maxX && py >= minY && py <= maxY;
  }
  return false;
};
var defaultProps$2 = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};
Rectangle.Rectangle = function Rectangle(rectangleProps) {
  var props = _objectSpread$A(_objectSpread$A({}, defaultProps$2), rectangleProps);
  var pathRef = (0, _react$G.useRef)();
  var _useState = (0, _react$G.useState)(-1),
    _useState2 = _slicedToArray$b(_useState, 2),
    totalLength = _useState2[0],
    setTotalLength = _useState2[1];
  (0, _react$G.useEffect)(function () {
    if (pathRef.current && pathRef.current.getTotalLength) {
      try {
        var pathTotalLength = pathRef.current.getTotalLength();
        if (pathTotalLength) {
          setTotalLength(pathTotalLength);
        }
      } catch (err) {
        // calculate total length error
      }
    }
  }, []);
  var x = props.x,
    y = props.y,
    width = props.width,
    height = props.height,
    radius = props.radius,
    className = props.className;
  var animationEasing = props.animationEasing,
    animationDuration = props.animationDuration,
    animationBegin = props.animationBegin,
    isAnimationActive = props.isAnimationActive,
    isUpdateAnimationActive = props.isUpdateAnimationActive;
  if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
    return null;
  }
  var layerClass = (0, _clsx$r["default"])('recharts-rectangle', className);
  if (!isUpdateAnimationActive) {
    return /*#__PURE__*/_react$G["default"].createElement("path", _extends$B({}, (0, _ReactUtils$s.filterProps)(props, true), {
      className: layerClass,
      d: getRectanglePath(x, y, width, height, radius)
    }));
  }
  return /*#__PURE__*/_react$G["default"].createElement(_reactSmooth$a["default"], {
    canBegin: totalLength > 0,
    from: {
      width: width,
      height: height,
      x: x,
      y: y
    },
    to: {
      width: width,
      height: height,
      x: x,
      y: y
    },
    duration: animationDuration,
    animationEasing: animationEasing,
    isActive: isUpdateAnimationActive
  }, function (_ref) {
    var currWidth = _ref.width,
      currHeight = _ref.height,
      currX = _ref.x,
      currY = _ref.y;
    return /*#__PURE__*/_react$G["default"].createElement(_reactSmooth$a["default"], {
      canBegin: totalLength > 0,
      from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
      to: "".concat(totalLength, "px 0px"),
      attributeName: "strokeDasharray",
      begin: animationBegin,
      duration: animationDuration,
      isActive: isAnimationActive,
      easing: animationEasing
    }, /*#__PURE__*/_react$G["default"].createElement("path", _extends$B({}, (0, _ReactUtils$s.filterProps)(props, true), {
      className: layerClass,
      d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
      ref: pathRef
    })));
  });
};

var Polygon = {};

Object.defineProperty(Polygon, "__esModule", {
  value: true
});
Polygon.Polygon = void 0;
var _react$F = _interopRequireDefault$N(React__default$4);
var _clsx$q = _interopRequireDefault$N(clsx.exports);
var _ReactUtils$r = ReactUtils;
var _excluded$h = ["points", "className", "baseLinePoints", "connectNulls"];
function _interopRequireDefault$N(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
function _objectWithoutProperties$k(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$h(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$h(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _toConsumableArray$4(arr) { return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$k(arr) || _nonIterableSpread$4(); }
function _nonIterableSpread$4() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$k(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$k(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$k(o, minLen); }
function _iterableToArray$4(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$4(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$k(arr); }
function _arrayLikeToArray$k(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /**
 * @fileOverview Polygon
 */
var isValidatePoint = function isValidatePoint(point) {
  return point && point.x === +point.x && point.y === +point.y;
};
var getParsedPoints = function getParsedPoints() {
  var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var segmentPoints = [[]];
  points.forEach(function (entry) {
    if (isValidatePoint(entry)) {
      segmentPoints[segmentPoints.length - 1].push(entry);
    } else if (segmentPoints[segmentPoints.length - 1].length > 0) {
      // add another path
      segmentPoints.push([]);
    }
  });
  if (isValidatePoint(points[0])) {
    segmentPoints[segmentPoints.length - 1].push(points[0]);
  }
  if (segmentPoints[segmentPoints.length - 1].length <= 0) {
    segmentPoints = segmentPoints.slice(0, -1);
  }
  return segmentPoints;
};
var getSinglePolygonPath = function getSinglePolygonPath(points, connectNulls) {
  var segmentPoints = getParsedPoints(points);
  if (connectNulls) {
    segmentPoints = [segmentPoints.reduce(function (res, segPoints) {
      return [].concat(_toConsumableArray$4(res), _toConsumableArray$4(segPoints));
    }, [])];
  }
  var polygonPath = segmentPoints.map(function (segPoints) {
    return segPoints.reduce(function (path, point, index) {
      return "".concat(path).concat(index === 0 ? 'M' : 'L').concat(point.x, ",").concat(point.y);
    }, '');
  }).join('');
  return segmentPoints.length === 1 ? "".concat(polygonPath, "Z") : polygonPath;
};
var getRanglePath = function getRanglePath(points, baseLinePoints, connectNulls) {
  var outerPath = getSinglePolygonPath(points, connectNulls);
  return "".concat(outerPath.slice(-1) === 'Z' ? outerPath.slice(0, -1) : outerPath, "L").concat(getSinglePolygonPath(baseLinePoints.reverse(), connectNulls).slice(1));
};
Polygon.Polygon = function Polygon(props) {
  var points = props.points,
    className = props.className,
    baseLinePoints = props.baseLinePoints,
    connectNulls = props.connectNulls,
    others = _objectWithoutProperties$k(props, _excluded$h);
  if (!points || !points.length) {
    return null;
  }
  var layerClass = (0, _clsx$q["default"])('recharts-polygon', className);
  if (baseLinePoints && baseLinePoints.length) {
    var hasStroke = others.stroke && others.stroke !== 'none';
    var rangePath = getRanglePath(points, baseLinePoints, connectNulls);
    return /*#__PURE__*/_react$F["default"].createElement("g", {
      className: layerClass
    }, /*#__PURE__*/_react$F["default"].createElement("path", _extends$A({}, (0, _ReactUtils$r.filterProps)(others, true), {
      fill: rangePath.slice(-1) === 'Z' ? others.fill : 'none',
      stroke: "none",
      d: rangePath
    })), hasStroke ? /*#__PURE__*/_react$F["default"].createElement("path", _extends$A({}, (0, _ReactUtils$r.filterProps)(others, true), {
      fill: "none",
      d: getSinglePolygonPath(points, connectNulls)
    })) : null, hasStroke ? /*#__PURE__*/_react$F["default"].createElement("path", _extends$A({}, (0, _ReactUtils$r.filterProps)(others, true), {
      fill: "none",
      d: getSinglePolygonPath(baseLinePoints, connectNulls)
    })) : null);
  }
  var singlePath = getSinglePolygonPath(points, connectNulls);
  return /*#__PURE__*/_react$F["default"].createElement("path", _extends$A({}, (0, _ReactUtils$r.filterProps)(others, true), {
    fill: singlePath.slice(-1) === 'Z' ? others.fill : 'none',
    className: layerClass,
    d: singlePath
  }));
};

var Dot = {};

Object.defineProperty(Dot, "__esModule", {
  value: true
});
Dot.Dot = void 0;
var _react$E = _interopRequireDefault$M(React__default$4);
var _clsx$p = _interopRequireDefault$M(clsx.exports);
var _types$9 = types;
var _ReactUtils$q = ReactUtils;
function _interopRequireDefault$M(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); } /**
 * @fileOverview Dot
 */
Dot.Dot = function Dot(props) {
  var cx = props.cx,
    cy = props.cy,
    r = props.r,
    className = props.className;
  var layerClass = (0, _clsx$p["default"])('recharts-dot', className);
  if (cx === +cx && cy === +cy && r === +r) {
    return /*#__PURE__*/_react$E["default"].createElement("circle", _extends$z({}, (0, _ReactUtils$q.filterProps)(props, false), (0, _types$9.adaptEventHandlers)(props), {
      className: layerClass,
      cx: cx,
      cy: cy,
      r: r
    }));
  }
  return null;
};

var Cross = {};

function _typeof$C(o) { "@babel/helpers - typeof"; return _typeof$C = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$C(o); }
Object.defineProperty(Cross, "__esModule", {
  value: true
});
Cross.Cross = void 0;
var _react$D = _interopRequireDefault$L(React__default$4);
var _clsx$o = _interopRequireDefault$L(clsx.exports);
var _DataUtils$l = DataUtils;
var _ReactUtils$p = ReactUtils;
var _excluded$g = ["x", "y", "top", "left", "width", "height", "className"];
/**
 * @fileOverview Cross
 */
function _interopRequireDefault$L(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
function ownKeys$B(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$B(Object(t), !0).forEach(function (r) { _defineProperty$G(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$B(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$G(obj, key, value) { key = _toPropertyKey$y(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$y(t) { var i = _toPrimitive$y(t, "string"); return "symbol" == _typeof$C(i) ? i : i + ""; }
function _toPrimitive$y(t, r) { if ("object" != _typeof$C(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$C(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties$j(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$g(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$g(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var getPath = function getPath(x, y, width, height, top, left) {
  return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
Cross.Cross = function Cross(_ref) {
  var _ref$x = _ref.x,
    x = _ref$x === void 0 ? 0 : _ref$x,
    _ref$y = _ref.y,
    y = _ref$y === void 0 ? 0 : _ref$y,
    _ref$top = _ref.top,
    top = _ref$top === void 0 ? 0 : _ref$top,
    _ref$left = _ref.left,
    left = _ref$left === void 0 ? 0 : _ref$left,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height,
    className = _ref.className,
    rest = _objectWithoutProperties$j(_ref, _excluded$g);
  var props = _objectSpread$z({
    x: x,
    y: y,
    top: top,
    left: left,
    width: width,
    height: height
  }, rest);
  if (!(0, _DataUtils$l.isNumber)(x) || !(0, _DataUtils$l.isNumber)(y) || !(0, _DataUtils$l.isNumber)(width) || !(0, _DataUtils$l.isNumber)(height) || !(0, _DataUtils$l.isNumber)(top) || !(0, _DataUtils$l.isNumber)(left)) {
    return null;
  }
  return /*#__PURE__*/_react$D["default"].createElement("path", _extends$y({}, (0, _ReactUtils$p.filterProps)(props, true), {
    className: (0, _clsx$o["default"])('recharts-cross', className),
    d: getPath(x, y, width, height, top, left)
  }));
};

var PolarGrid$1 = {};

Object.defineProperty(PolarGrid$1, "__esModule", {
  value: true
});
PolarGrid$1.PolarGrid = void 0;
var _react$C = _interopRequireDefault$K(React__default$4);
var _clsx$n = _interopRequireDefault$K(clsx.exports);
var _PolarUtils$c = PolarUtils;
var _ReactUtils$o = ReactUtils;
var _excluded$f = ["cx", "cy", "innerRadius", "outerRadius", "gridType", "radialLines"];
function _interopRequireDefault$K(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$B(o) { "@babel/helpers - typeof"; return _typeof$B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$B(o); }
function _objectWithoutProperties$i(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$f(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$f(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
function ownKeys$A(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$A(Object(t), !0).forEach(function (r) { _defineProperty$F(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$A(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$F(obj, key, value) { key = _toPropertyKey$x(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$x(t) { var i = _toPrimitive$x(t, "string"); return "symbol" == _typeof$B(i) ? i : i + ""; }
function _toPrimitive$x(t, r) { if ("object" != _typeof$B(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$B(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Polar Grid
 */
var getPolygonPath = function getPolygonPath(radius, cx, cy, polarAngles) {
  var path = '';
  polarAngles.forEach(function (angle, i) {
    var point = (0, _PolarUtils$c.polarToCartesian)(cx, cy, radius, angle);
    if (i) {
      path += "L ".concat(point.x, ",").concat(point.y);
    } else {
      path += "M ".concat(point.x, ",").concat(point.y);
    }
  });
  path += 'Z';
  return path;
};

// Draw axis of radial line
var PolarAngles = function PolarAngles(props) {
  var cx = props.cx,
    cy = props.cy,
    innerRadius = props.innerRadius,
    outerRadius = props.outerRadius,
    polarAngles = props.polarAngles,
    radialLines = props.radialLines;
  if (!polarAngles || !polarAngles.length || !radialLines) {
    return null;
  }
  var polarAnglesProps = _objectSpread$y({
    stroke: '#ccc'
  }, (0, _ReactUtils$o.filterProps)(props, false));
  return /*#__PURE__*/_react$C["default"].createElement("g", {
    className: "recharts-polar-grid-angle"
  }, polarAngles.map(function (entry) {
    var start = (0, _PolarUtils$c.polarToCartesian)(cx, cy, innerRadius, entry);
    var end = (0, _PolarUtils$c.polarToCartesian)(cx, cy, outerRadius, entry);
    return /*#__PURE__*/_react$C["default"].createElement("line", _extends$x({}, polarAnglesProps, {
      key: "line-".concat(entry),
      x1: start.x,
      y1: start.y,
      x2: end.x,
      y2: end.y
    }));
  }));
};

// Draw concentric circles
var ConcentricCircle = function ConcentricCircle(props) {
  var cx = props.cx,
    cy = props.cy,
    radius = props.radius,
    index = props.index;
  var concentricCircleProps = _objectSpread$y(_objectSpread$y({
    stroke: '#ccc'
  }, (0, _ReactUtils$o.filterProps)(props, false)), {}, {
    fill: 'none'
  });
  return /*#__PURE__*/_react$C["default"].createElement("circle", _extends$x({}, concentricCircleProps, {
    className: (0, _clsx$n["default"])('recharts-polar-grid-concentric-circle', props.className),
    key: "circle-".concat(index),
    cx: cx,
    cy: cy,
    r: radius
  }));
};

// Draw concentric polygons
var ConcentricPolygon = function ConcentricPolygon(props) {
  var radius = props.radius,
    index = props.index;
  var concentricPolygonProps = _objectSpread$y(_objectSpread$y({
    stroke: '#ccc'
  }, (0, _ReactUtils$o.filterProps)(props, false)), {}, {
    fill: 'none'
  });
  return /*#__PURE__*/_react$C["default"].createElement("path", _extends$x({}, concentricPolygonProps, {
    className: (0, _clsx$n["default"])('recharts-polar-grid-concentric-polygon', props.className),
    key: "path-".concat(index),
    d: getPolygonPath(radius, props.cx, props.cy, props.polarAngles)
  }));
};

// Draw concentric axis
// TODO Optimize the name
var ConcentricPath = function ConcentricPath(props) {
  var polarRadius = props.polarRadius,
    gridType = props.gridType;
  if (!polarRadius || !polarRadius.length) {
    return null;
  }
  return /*#__PURE__*/_react$C["default"].createElement("g", {
    className: "recharts-polar-grid-concentric"
  }, polarRadius.map(function (entry, i) {
    var key = i;
    if (gridType === 'circle') return /*#__PURE__*/_react$C["default"].createElement(ConcentricCircle, _extends$x({
      key: key
    }, props, {
      radius: entry,
      index: i
    }));
    return /*#__PURE__*/_react$C["default"].createElement(ConcentricPolygon, _extends$x({
      key: key
    }, props, {
      radius: entry,
      index: i
    }));
  }));
};
var PolarGrid = PolarGrid$1.PolarGrid = function PolarGrid(_ref) {
  var _ref$cx = _ref.cx,
    cx = _ref$cx === void 0 ? 0 : _ref$cx,
    _ref$cy = _ref.cy,
    cy = _ref$cy === void 0 ? 0 : _ref$cy,
    _ref$innerRadius = _ref.innerRadius,
    innerRadius = _ref$innerRadius === void 0 ? 0 : _ref$innerRadius,
    _ref$outerRadius = _ref.outerRadius,
    outerRadius = _ref$outerRadius === void 0 ? 0 : _ref$outerRadius,
    _ref$gridType = _ref.gridType,
    gridType = _ref$gridType === void 0 ? 'polygon' : _ref$gridType,
    _ref$radialLines = _ref.radialLines,
    radialLines = _ref$radialLines === void 0 ? true : _ref$radialLines,
    props = _objectWithoutProperties$i(_ref, _excluded$f);
  if (outerRadius <= 0) {
    return null;
  }
  return /*#__PURE__*/_react$C["default"].createElement("g", {
    className: "recharts-polar-grid"
  }, /*#__PURE__*/_react$C["default"].createElement(PolarAngles, _extends$x({
    cx: cx,
    cy: cy,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    gridType: gridType,
    radialLines: radialLines
  }, props)), /*#__PURE__*/_react$C["default"].createElement(ConcentricPath, _extends$x({
    cx: cx,
    cy: cy,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    gridType: gridType,
    radialLines: radialLines
  }, props)));
};
PolarGrid.displayName = 'PolarGrid';

var PolarRadiusAxis$1 = {};

var baseExtremum$1 = _baseExtremum,
    baseGt = _baseGt,
    baseIteratee$7 = _baseIteratee;

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum$1(array, baseIteratee$7(iteratee), baseGt)
    : undefined;
}

var maxBy_1 = maxBy;

var baseExtremum = _baseExtremum,
    baseIteratee$6 = _baseIteratee,
    baseLt = _baseLt;

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee$6(iteratee), baseLt)
    : undefined;
}

var minBy_1 = minBy;

Object.defineProperty(PolarRadiusAxis$1, "__esModule", {
  value: true
});
PolarRadiusAxis$1.PolarRadiusAxis = void 0;
var _react$B = _interopRequireWildcard$i(React__default$4);
var _maxBy$1 = _interopRequireDefault$J(maxBy_1);
var _minBy = _interopRequireDefault$J(minBy_1);
var _isFunction$j = _interopRequireDefault$J(isFunction_1);
var _clsx$m = _interopRequireDefault$J(clsx.exports);
var _Text$5 = Text;
var _Label$5 = Label$1;
var _Layer$j = Layer;
var _PolarUtils$b = PolarUtils;
var _types$8 = types;
var _ReactUtils$n = ReactUtils;
var _excluded$e = ["cx", "cy", "angle", "ticks", "axisLine"],
  _excluded2$7 = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function _interopRequireDefault$J(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$i(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$i = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$i(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$A(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$i(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$A(o) { "@babel/helpers - typeof"; return _typeof$A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$A(o); }
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
function ownKeys$z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$x(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$z(Object(t), !0).forEach(function (r) { _defineProperty$E(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties$h(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$e(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$e(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _classCallCheck$B(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$v(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$w(descriptor.key), descriptor); } }
function _createClass$B(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$v(Constructor.prototype, protoProps); if (staticProps) _defineProperties$v(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$k(t, o, e) { return o = _getPrototypeOf$l(o), _possibleConstructorReturn$r(t, _isNativeReflectConstruct$l() ? Reflect.construct(o, e || [], _getPrototypeOf$l(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$r(self, call) { if (call && (_typeof$A(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$l(self); }
function _assertThisInitialized$l(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$l() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$l = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$l(o) { _getPrototypeOf$l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$l(o); }
function _inherits$r(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$l(subClass, superClass); }
function _setPrototypeOf$l(o, p) { _setPrototypeOf$l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$l(o, p); }
function _defineProperty$E(obj, key, value) { key = _toPropertyKey$w(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$w(t) { var i = _toPrimitive$w(t, "string"); return "symbol" == _typeof$A(i) ? i : i + ""; }
function _toPrimitive$w(t, r) { if ("object" != _typeof$A(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$A(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview The axis of polar coordinate system
 */
var PolarRadiusAxis = PolarRadiusAxis$1.PolarRadiusAxis = /*#__PURE__*/function (_PureComponent) {
  function PolarRadiusAxis() {
    _classCallCheck$B(this, PolarRadiusAxis);
    return _callSuper$k(this, PolarRadiusAxis, arguments);
  }
  _inherits$r(PolarRadiusAxis, _PureComponent);
  return _createClass$B(PolarRadiusAxis, [{
    key: "getTickValueCoord",
    value:
    /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */
    function getTickValueCoord(_ref) {
      var coordinate = _ref.coordinate;
      var _this$props = this.props,
        angle = _this$props.angle,
        cx = _this$props.cx,
        cy = _this$props.cy;
      return (0, _PolarUtils$b.polarToCartesian)(cx, cy, coordinate, angle);
    }
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var orientation = this.props.orientation;
      var textAnchor;
      switch (orientation) {
        case 'left':
          textAnchor = 'end';
          break;
        case 'right':
          textAnchor = 'start';
          break;
        default:
          textAnchor = 'middle';
          break;
      }
      return textAnchor;
    }
  }, {
    key: "getViewBox",
    value: function getViewBox() {
      var _this$props2 = this.props,
        cx = _this$props2.cx,
        cy = _this$props2.cy,
        angle = _this$props2.angle,
        ticks = _this$props2.ticks;
      var maxRadiusTick = (0, _maxBy$1["default"])(ticks, function (entry) {
        return entry.coordinate || 0;
      });
      var minRadiusTick = (0, _minBy["default"])(ticks, function (entry) {
        return entry.coordinate || 0;
      });
      return {
        cx: cx,
        cy: cy,
        startAngle: angle,
        endAngle: angle,
        innerRadius: minRadiusTick.coordinate || 0,
        outerRadius: maxRadiusTick.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props3 = this.props,
        cx = _this$props3.cx,
        cy = _this$props3.cy,
        angle = _this$props3.angle,
        ticks = _this$props3.ticks,
        axisLine = _this$props3.axisLine,
        others = _objectWithoutProperties$h(_this$props3, _excluded$e);
      var extent = ticks.reduce(function (result, entry) {
        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
      }, [Infinity, -Infinity]);
      var point0 = (0, _PolarUtils$b.polarToCartesian)(cx, cy, extent[0], angle);
      var point1 = (0, _PolarUtils$b.polarToCartesian)(cx, cy, extent[1], angle);
      var props = _objectSpread$x(_objectSpread$x(_objectSpread$x({}, (0, _ReactUtils$n.filterProps)(others, false)), {}, {
        fill: 'none'
      }, (0, _ReactUtils$n.filterProps)(axisLine, false)), {}, {
        x1: point0.x,
        y1: point0.y,
        x2: point1.x,
        y2: point1.y
      });
      return /*#__PURE__*/_react$B["default"].createElement("line", _extends$w({
        className: "recharts-polar-radius-axis-line"
      }, props));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;
      var _this$props4 = this.props,
        ticks = _this$props4.ticks,
        tick = _this$props4.tick,
        angle = _this$props4.angle,
        tickFormatter = _this$props4.tickFormatter,
        stroke = _this$props4.stroke,
        others = _objectWithoutProperties$h(_this$props4, _excluded2$7);
      var textAnchor = this.getTickTextAnchor();
      var axisProps = (0, _ReactUtils$n.filterProps)(others, false);
      var customTickProps = (0, _ReactUtils$n.filterProps)(tick, false);
      var items = ticks.map(function (entry, i) {
        var coord = _this.getTickValueCoord(entry);
        var tickProps = _objectSpread$x(_objectSpread$x(_objectSpread$x(_objectSpread$x({
          textAnchor: textAnchor,
          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
        }, axisProps), {}, {
          stroke: 'none',
          fill: stroke
        }, customTickProps), {}, {
          index: i
        }, coord), {}, {
          payload: entry
        });
        return /*#__PURE__*/_react$B["default"].createElement(_Layer$j.Layer, _extends$w({
          className: (0, _clsx$m["default"])('recharts-polar-radius-axis-tick', (0, _PolarUtils$b.getTickClassName)(tick)),
          key: "tick-".concat(entry.coordinate)
        }, (0, _types$8.adaptEventsOfChild)(_this.props, entry, i)), PolarRadiusAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
      });
      return /*#__PURE__*/_react$B["default"].createElement(_Layer$j.Layer, {
        className: "recharts-polar-radius-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        ticks = _this$props5.ticks,
        axisLine = _this$props5.axisLine,
        tick = _this$props5.tick;
      if (!ticks || !ticks.length) {
        return null;
      }
      return /*#__PURE__*/_react$B["default"].createElement(_Layer$j.Layer, {
        className: (0, _clsx$m["default"])('recharts-polar-radius-axis', this.props.className)
      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), _Label$5.Label.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;
      if ( /*#__PURE__*/_react$B["default"].isValidElement(option)) {
        tickItem = /*#__PURE__*/_react$B["default"].cloneElement(option, props);
      } else if ((0, _isFunction$j["default"])(option)) {
        tickItem = option(props);
      } else {
        tickItem = /*#__PURE__*/_react$B["default"].createElement(_Text$5.Text, _extends$w({}, props, {
          className: "recharts-polar-radius-axis-tick-value"
        }), value);
      }
      return tickItem;
    }
  }]);
}(_react$B.PureComponent);
_defineProperty$E(PolarRadiusAxis, "displayName", 'PolarRadiusAxis');
_defineProperty$E(PolarRadiusAxis, "axisType", 'radiusAxis');
_defineProperty$E(PolarRadiusAxis, "defaultProps", {
  type: 'number',
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: 'right',
  stroke: '#ccc',
  axisLine: true,
  tick: true,
  tickCount: 5,
  allowDataOverflow: false,
  scale: 'auto',
  allowDuplicatedCategory: true
});

var PolarAngleAxis$1 = {};

Object.defineProperty(PolarAngleAxis$1, "__esModule", {
  value: true
});
PolarAngleAxis$1.PolarAngleAxis = void 0;
var _react$A = _interopRequireWildcard$h(React__default$4);
var _isFunction$i = _interopRequireDefault$I(isFunction_1);
var _clsx$l = _interopRequireDefault$I(clsx.exports);
var _Layer$i = Layer;
var _Dot$5 = Dot;
var _Polygon$2 = Polygon;
var _Text$4 = Text;
var _types$7 = types;
var _ReactUtils$m = ReactUtils;
var _PolarUtils$a = PolarUtils;
function _interopRequireDefault$I(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$h(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$h = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$h(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$z(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$h(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$z(o) { "@babel/helpers - typeof"; return _typeof$z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$z(o); }
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
function ownKeys$y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$w(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$y(Object(t), !0).forEach(function (r) { _defineProperty$D(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$A(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$u(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$v(descriptor.key), descriptor); } }
function _createClass$A(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$u(Constructor.prototype, protoProps); if (staticProps) _defineProperties$u(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$j(t, o, e) { return o = _getPrototypeOf$k(o), _possibleConstructorReturn$q(t, _isNativeReflectConstruct$k() ? Reflect.construct(o, e || [], _getPrototypeOf$k(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$q(self, call) { if (call && (_typeof$z(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$k(self); }
function _assertThisInitialized$k(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$k() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$k = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$k(o) { _getPrototypeOf$k = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$k(o); }
function _inherits$q(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$k(subClass, superClass); }
function _setPrototypeOf$k(o, p) { _setPrototypeOf$k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$k(o, p); }
function _defineProperty$D(obj, key, value) { key = _toPropertyKey$v(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$v(t) { var i = _toPrimitive$v(t, "string"); return "symbol" == _typeof$z(i) ? i : i + ""; }
function _toPrimitive$v(t, r) { if ("object" != _typeof$z(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$z(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Axis of radial direction
 */
var RADIAN = Math.PI / 180;
var eps = 1e-5;
var PolarAngleAxis = PolarAngleAxis$1.PolarAngleAxis = /*#__PURE__*/function (_PureComponent) {
  function PolarAngleAxis() {
    _classCallCheck$A(this, PolarAngleAxis);
    return _callSuper$j(this, PolarAngleAxis, arguments);
  }
  _inherits$q(PolarAngleAxis, _PureComponent);
  return _createClass$A(PolarAngleAxis, [{
    key: "getTickLineCoord",
    value:
    /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */
    function getTickLineCoord(data) {
      var _this$props = this.props,
        cx = _this$props.cx,
        cy = _this$props.cy,
        radius = _this$props.radius,
        orientation = _this$props.orientation,
        tickSize = _this$props.tickSize;
      var tickLineSize = tickSize || 8;
      var p1 = (0, _PolarUtils$a.polarToCartesian)(cx, cy, radius, data.coordinate);
      var p2 = (0, _PolarUtils$a.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
      return {
        x1: p1.x,
        y1: p1.y,
        x2: p2.x,
        y2: p2.y
      };
    }

    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor(data) {
      var orientation = this.props.orientation;
      var cos = Math.cos(-data.coordinate * RADIAN);
      var textAnchor;
      if (cos > eps) {
        textAnchor = orientation === 'outer' ? 'start' : 'end';
      } else if (cos < -eps) {
        textAnchor = orientation === 'outer' ? 'end' : 'start';
      } else {
        textAnchor = 'middle';
      }
      return textAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props2 = this.props,
        cx = _this$props2.cx,
        cy = _this$props2.cy,
        radius = _this$props2.radius,
        axisLine = _this$props2.axisLine,
        axisLineType = _this$props2.axisLineType;
      var props = _objectSpread$w(_objectSpread$w({}, (0, _ReactUtils$m.filterProps)(this.props, false)), {}, {
        fill: 'none'
      }, (0, _ReactUtils$m.filterProps)(axisLine, false));
      if (axisLineType === 'circle') {
        return /*#__PURE__*/_react$A["default"].createElement(_Dot$5.Dot, _extends$v({
          className: "recharts-polar-angle-axis-line"
        }, props, {
          cx: cx,
          cy: cy,
          r: radius
        }));
      }
      var ticks = this.props.ticks;
      var points = ticks.map(function (entry) {
        return (0, _PolarUtils$a.polarToCartesian)(cx, cy, radius, entry.coordinate);
      });
      return /*#__PURE__*/_react$A["default"].createElement(_Polygon$2.Polygon, _extends$v({
        className: "recharts-polar-angle-axis-line"
      }, props, {
        points: points
      }));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;
      var _this$props3 = this.props,
        ticks = _this$props3.ticks,
        tick = _this$props3.tick,
        tickLine = _this$props3.tickLine,
        tickFormatter = _this$props3.tickFormatter,
        stroke = _this$props3.stroke;
      var axisProps = (0, _ReactUtils$m.filterProps)(this.props, false);
      var customTickProps = (0, _ReactUtils$m.filterProps)(tick, false);
      var tickLineProps = _objectSpread$w(_objectSpread$w({}, axisProps), {}, {
        fill: 'none'
      }, (0, _ReactUtils$m.filterProps)(tickLine, false));
      var items = ticks.map(function (entry, i) {
        var lineCoord = _this.getTickLineCoord(entry);
        var textAnchor = _this.getTickTextAnchor(entry);
        var tickProps = _objectSpread$w(_objectSpread$w(_objectSpread$w({
          textAnchor: textAnchor
        }, axisProps), {}, {
          stroke: 'none',
          fill: stroke
        }, customTickProps), {}, {
          index: i,
          payload: entry,
          x: lineCoord.x2,
          y: lineCoord.y2
        });
        return /*#__PURE__*/_react$A["default"].createElement(_Layer$i.Layer, _extends$v({
          className: (0, _clsx$l["default"])('recharts-polar-angle-axis-tick', (0, _PolarUtils$a.getTickClassName)(tick)),
          key: "tick-".concat(entry.coordinate)
        }, (0, _types$7.adaptEventsOfChild)(_this.props, entry, i)), tickLine && /*#__PURE__*/_react$A["default"].createElement("line", _extends$v({
          className: "recharts-polar-angle-axis-tick-line"
        }, tickLineProps, lineCoord)), tick && PolarAngleAxis.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value, i) : entry.value));
      });
      return /*#__PURE__*/_react$A["default"].createElement(_Layer$i.Layer, {
        className: "recharts-polar-angle-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        ticks = _this$props4.ticks,
        radius = _this$props4.radius,
        axisLine = _this$props4.axisLine;
      if (radius <= 0 || !ticks || !ticks.length) {
        return null;
      }
      return /*#__PURE__*/_react$A["default"].createElement(_Layer$i.Layer, {
        className: (0, _clsx$l["default"])('recharts-polar-angle-axis', this.props.className)
      }, axisLine && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;
      if ( /*#__PURE__*/_react$A["default"].isValidElement(option)) {
        tickItem = /*#__PURE__*/_react$A["default"].cloneElement(option, props);
      } else if ((0, _isFunction$i["default"])(option)) {
        tickItem = option(props);
      } else {
        tickItem = /*#__PURE__*/_react$A["default"].createElement(_Text$4.Text, _extends$v({}, props, {
          className: "recharts-polar-angle-axis-tick-value"
        }), value);
      }
      return tickItem;
    }
  }]);
}(_react$A.PureComponent);
_defineProperty$D(PolarAngleAxis, "displayName", 'PolarAngleAxis');
_defineProperty$D(PolarAngleAxis, "axisType", 'angleAxis');
_defineProperty$D(PolarAngleAxis, "defaultProps", {
  type: 'category',
  angleAxisId: 0,
  scale: 'auto',
  cx: 0,
  cy: 0,
  orientation: 'outer',
  axisLine: true,
  tickLine: true,
  tickSize: 8,
  tick: true,
  hide: false,
  allowDuplicatedCategory: true
});

var Pie$1 = {};

var ActiveShapeUtils = {};

var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

var isBoolean_1 = isBoolean;

var Trapezoid = {};

Object.defineProperty(Trapezoid, "__esModule", {
  value: true
});
Trapezoid.Trapezoid = void 0;
var _react$z = _interopRequireWildcard$g(React__default$4);
var _clsx$k = _interopRequireDefault$H(clsx.exports);
var _reactSmooth$9 = _interopRequireDefault$H(lib);
var _ReactUtils$l = ReactUtils;
function _interopRequireDefault$H(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$g(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$g = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$g(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$y(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$g(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$y(o) { "@babel/helpers - typeof"; return _typeof$y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$y(o); }
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
function _slicedToArray$a(arr, i) { return _arrayWithHoles$8(arr) || _iterableToArrayLimit$8(arr, i) || _unsupportedIterableToArray$j(arr, i) || _nonIterableRest$8(); }
function _nonIterableRest$8() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$j(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$j(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$j(o, minLen); }
function _arrayLikeToArray$j(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$8(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$8(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys$x(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$v(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$x(Object(t), !0).forEach(function (r) { _defineProperty$C(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$x(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$C(obj, key, value) { key = _toPropertyKey$u(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$u(t) { var i = _toPrimitive$u(t, "string"); return "symbol" == _typeof$y(i) ? i : i + ""; }
function _toPrimitive$u(t, r) { if ("object" != _typeof$y(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$y(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Rectangle
 */
var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
  var widthGap = upperWidth - lowerWidth;
  var path;
  path = "M ".concat(x, ",").concat(y);
  path += "L ".concat(x + upperWidth, ",").concat(y);
  path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
  path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
  path += "L ".concat(x, ",").concat(y, " Z");
  return path;
};
var defaultProps$1 = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};
Trapezoid.Trapezoid = function Trapezoid(props) {
  var trapezoidProps = _objectSpread$v(_objectSpread$v({}, defaultProps$1), props);
  var pathRef = (0, _react$z.useRef)();
  var _useState = (0, _react$z.useState)(-1),
    _useState2 = _slicedToArray$a(_useState, 2),
    totalLength = _useState2[0],
    setTotalLength = _useState2[1];
  (0, _react$z.useEffect)(function () {
    if (pathRef.current && pathRef.current.getTotalLength) {
      try {
        var pathTotalLength = pathRef.current.getTotalLength();
        if (pathTotalLength) {
          setTotalLength(pathTotalLength);
        }
      } catch (err) {
        // calculate total length error
      }
    }
  }, []);
  var x = trapezoidProps.x,
    y = trapezoidProps.y,
    upperWidth = trapezoidProps.upperWidth,
    lowerWidth = trapezoidProps.lowerWidth,
    height = trapezoidProps.height,
    className = trapezoidProps.className;
  var animationEasing = trapezoidProps.animationEasing,
    animationDuration = trapezoidProps.animationDuration,
    animationBegin = trapezoidProps.animationBegin,
    isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
  if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) {
    return null;
  }
  var layerClass = (0, _clsx$k["default"])('recharts-trapezoid', className);
  if (!isUpdateAnimationActive) {
    return /*#__PURE__*/_react$z["default"].createElement("g", null, /*#__PURE__*/_react$z["default"].createElement("path", _extends$u({}, (0, _ReactUtils$l.filterProps)(trapezoidProps, true), {
      className: layerClass,
      d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
  }
  return /*#__PURE__*/_react$z["default"].createElement(_reactSmooth$9["default"], {
    canBegin: totalLength > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: height,
      x: x,
      y: y
    },
    to: {
      upperWidth: upperWidth,
      lowerWidth: lowerWidth,
      height: height,
      x: x,
      y: y
    },
    duration: animationDuration,
    animationEasing: animationEasing,
    isActive: isUpdateAnimationActive
  }, function (_ref) {
    var currUpperWidth = _ref.upperWidth,
      currLowerWidth = _ref.lowerWidth,
      currHeight = _ref.height,
      currX = _ref.x,
      currY = _ref.y;
    return /*#__PURE__*/_react$z["default"].createElement(_reactSmooth$9["default"], {
      canBegin: totalLength > 0,
      from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
      to: "".concat(totalLength, "px 0px"),
      attributeName: "strokeDasharray",
      begin: animationBegin,
      duration: animationDuration,
      easing: animationEasing
    }, /*#__PURE__*/_react$z["default"].createElement("path", _extends$u({}, (0, _ReactUtils$l.filterProps)(trapezoidProps, true), {
      className: layerClass,
      d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
      ref: pathRef
    })));
  });
};

Object.defineProperty(ActiveShapeUtils, "__esModule", {
  value: true
});
ActiveShapeUtils.Shape = Shape;
ActiveShapeUtils.compareFunnel = compareFunnel;
ActiveShapeUtils.comparePie = comparePie;
ActiveShapeUtils.compareScatter = compareScatter;
ActiveShapeUtils.getActiveShapeIndexForTooltip = getActiveShapeIndexForTooltip;
ActiveShapeUtils.getPropsFromShapeOption = getPropsFromShapeOption;
ActiveShapeUtils.isFunnel = isFunnel;
ActiveShapeUtils.isPie = isPie;
ActiveShapeUtils.isScatter = isScatter;
var _react$y = _interopRequireWildcard$f(React__default$4);
var _isFunction$h = _interopRequireDefault$G(isFunction_1);
var _isPlainObject = _interopRequireDefault$G(isPlainObject_1);
var _isBoolean = _interopRequireDefault$G(isBoolean_1);
var _isEqual$8 = _interopRequireDefault$G(isEqual_1);
var _Rectangle$5 = Rectangle;
var _Trapezoid = Trapezoid;
var _Sector$2 = Sector;
var _Layer$h = Layer;
var _Symbols$1 = Symbols$1;
var _excluded$d = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function _interopRequireDefault$G(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$f(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$f = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$f(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$x(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$f(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$x(o) { "@babel/helpers - typeof"; return _typeof$x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$x(o); }
function _objectWithoutProperties$g(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$d(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$d(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ownKeys$w(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$u(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$w(Object(t), !0).forEach(function (r) { _defineProperty$B(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$w(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$B(obj, key, value) { key = _toPropertyKey$t(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$t(t) { var i = _toPrimitive$t(t, "string"); return "symbol" == _typeof$x(i) ? i : i + ""; }
function _toPrimitive$t(t, r) { if ("object" != _typeof$x(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$x(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */

function defaultPropTransformer(option, props) {
  return _objectSpread$u(_objectSpread$u({}, props), option);
}
function isSymbolsProps(shapeType, _elementProps) {
  return shapeType === 'symbols';
}
function ShapeSelector(_ref) {
  var shapeType = _ref.shapeType,
    elementProps = _ref.elementProps;
  switch (shapeType) {
    case 'rectangle':
      return /*#__PURE__*/_react$y["default"].createElement(_Rectangle$5.Rectangle, elementProps);
    case 'trapezoid':
      return /*#__PURE__*/_react$y["default"].createElement(_Trapezoid.Trapezoid, elementProps);
    case 'sector':
      return /*#__PURE__*/_react$y["default"].createElement(_Sector$2.Sector, elementProps);
    case 'symbols':
      if (isSymbolsProps(shapeType)) {
        return /*#__PURE__*/_react$y["default"].createElement(_Symbols$1.Symbols, elementProps);
      }
      break;
    default:
      return null;
  }
}
function getPropsFromShapeOption(option) {
  if ( /*#__PURE__*/(0, _react$y.isValidElement)(option)) {
    return option.props;
  }
  return option;
}
function Shape(_ref2) {
  var option = _ref2.option,
    shapeType = _ref2.shapeType,
    _ref2$propTransformer = _ref2.propTransformer,
    propTransformer = _ref2$propTransformer === void 0 ? defaultPropTransformer : _ref2$propTransformer,
    _ref2$activeClassName = _ref2.activeClassName,
    activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName,
    isActive = _ref2.isActive,
    props = _objectWithoutProperties$g(_ref2, _excluded$d);
  var shape;
  if ( /*#__PURE__*/(0, _react$y.isValidElement)(option)) {
    shape = /*#__PURE__*/(0, _react$y.cloneElement)(option, _objectSpread$u(_objectSpread$u({}, props), getPropsFromShapeOption(option)));
  } else if ((0, _isFunction$h["default"])(option)) {
    shape = option(props);
  } else if ((0, _isPlainObject["default"])(option) && !(0, _isBoolean["default"])(option)) {
    var nextProps = propTransformer(option, props);
    shape = /*#__PURE__*/_react$y["default"].createElement(ShapeSelector, {
      shapeType: shapeType,
      elementProps: nextProps
    });
  } else {
    var elementProps = props;
    shape = /*#__PURE__*/_react$y["default"].createElement(ShapeSelector, {
      shapeType: shapeType,
      elementProps: elementProps
    });
  }
  if (isActive) {
    return /*#__PURE__*/_react$y["default"].createElement(_Layer$h.Layer, {
      className: activeClassName
    }, shape);
  }
  return shape;
}

/**
 * This is an abstraction to handle identifying the active index from a tooltip mouse interaction
 */

function isFunnel(graphicalItem, _item) {
  return _item != null && 'trapezoids' in graphicalItem.props;
}
function isPie(graphicalItem, _item) {
  return _item != null && 'sectors' in graphicalItem.props;
}
function isScatter(graphicalItem, _item) {
  return _item != null && 'points' in graphicalItem.props;
}
function compareFunnel(shapeData, activeTooltipItem) {
  var _activeTooltipItem$la, _activeTooltipItem$la2;
  var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
  var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
  return xMatches && yMatches;
}
function comparePie(shapeData, activeTooltipItem) {
  var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
  var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
  return startAngleMatches && endAngleMatches;
}
function compareScatter(shapeData, activeTooltipItem) {
  var xMatches = shapeData.x === activeTooltipItem.x;
  var yMatches = shapeData.y === activeTooltipItem.y;
  var zMatches = shapeData.z === activeTooltipItem.z;
  return xMatches && yMatches && zMatches;
}
function getComparisonFn(graphicalItem, activeItem) {
  var comparison;
  if (isFunnel(graphicalItem, activeItem)) {
    comparison = compareFunnel;
  } else if (isPie(graphicalItem, activeItem)) {
    comparison = comparePie;
  } else if (isScatter(graphicalItem, activeItem)) {
    comparison = compareScatter;
  }
  return comparison;
}
function getShapeDataKey(graphicalItem, activeItem) {
  var shapeKey;
  if (isFunnel(graphicalItem, activeItem)) {
    shapeKey = 'trapezoids';
  } else if (isPie(graphicalItem, activeItem)) {
    shapeKey = 'sectors';
  } else if (isScatter(graphicalItem, activeItem)) {
    shapeKey = 'points';
  }
  return shapeKey;
}
function getActiveShapeTooltipPayload(graphicalItem, activeItem) {
  if (isFunnel(graphicalItem, activeItem)) {
    var _activeItem$tooltipPa;
    return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
  }
  if (isPie(graphicalItem, activeItem)) {
    var _activeItem$tooltipPa2;
    return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
  }
  if (isScatter(graphicalItem, activeItem)) {
    return activeItem.payload;
  }
  return {};
}
/**
 *
 * @param {GetActiveShapeIndexForTooltip} arg an object of incoming attributes from Tooltip
 * @returns {number}
 *
 * To handle possible duplicates in the data set,
 * match both the data value of the active item to a data value on a graph item,
 * and match the mouse coordinates of the active item to the coordinates of in a particular components shape data.
 * This assumes equal lengths of shape objects to data items.
 */
function getActiveShapeIndexForTooltip(_ref3) {
  var activeTooltipItem = _ref3.activeTooltipItem,
    graphicalItem = _ref3.graphicalItem,
    itemData = _ref3.itemData;
  var shapeKey = getShapeDataKey(graphicalItem, activeTooltipItem);
  var tooltipPayload = getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
  var activeItemMatches = itemData.filter(function (datum, dataIndex) {
    var valuesMatch = (0, _isEqual$8["default"])(tooltipPayload, datum);
    var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function (shapeData) {
      var comparison = getComparisonFn(graphicalItem, activeTooltipItem);
      return comparison(shapeData, activeTooltipItem);
    });

    // get the last index in case of multiple matches
    var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
    var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
    return valuesMatch && coordinatesMatch;
  });

  // get the last index in case of multiple matches
  var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
  return activeIndex;
}

Object.defineProperty(Pie$1, "__esModule", {
  value: true
});
Pie$1.Pie = void 0;
var _react$x = _interopRequireWildcard$e(React__default$4);
var _reactSmooth$8 = _interopRequireDefault$F(lib);
var _get$4 = _interopRequireDefault$F(get_1);
var _isEqual$7 = _interopRequireDefault$F(isEqual_1);
var _isNil$6 = _interopRequireDefault$F(isNil_1);
var _isFunction$g = _interopRequireDefault$F(isFunction_1);
var _clsx$j = _interopRequireDefault$F(clsx.exports);
var _Layer$g = Layer;
var _Curve$4 = Curve;
var _Text$3 = Text;
var _Label$4 = Label$1;
var _LabelList$7 = LabelList$1;
var _Cell$4 = Cell$2;
var _ReactUtils$k = ReactUtils;
var _Global$9 = Global$1;
var _PolarUtils$9 = PolarUtils;
var _DataUtils$k = DataUtils;
var _ChartUtils$f = ChartUtils;
var _LogUtils$4 = LogUtils;
var _types$6 = types;
var _ActiveShapeUtils$5 = ActiveShapeUtils;
var _Pie$1;
function _interopRequireDefault$F(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$e(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$e = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$e(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$w(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$e(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$w(o) { "@babel/helpers - typeof"; return _typeof$w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$w(o); }
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
function ownKeys$v(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$t(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$v(Object(t), !0).forEach(function (r) { _defineProperty$A(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$v(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$z(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$t(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$s(descriptor.key), descriptor); } }
function _createClass$z(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$t(Constructor.prototype, protoProps); if (staticProps) _defineProperties$t(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$i(t, o, e) { return o = _getPrototypeOf$j(o), _possibleConstructorReturn$p(t, _isNativeReflectConstruct$j() ? Reflect.construct(o, e || [], _getPrototypeOf$j(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$p(self, call) { if (call && (_typeof$w(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$j(self); }
function _assertThisInitialized$j(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$j() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$j = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$j(o) { _getPrototypeOf$j = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$j(o); }
function _inherits$p(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$j(subClass, superClass); }
function _setPrototypeOf$j(o, p) { _setPrototypeOf$j = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$j(o, p); }
function _defineProperty$A(obj, key, value) { key = _toPropertyKey$s(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$s(t) { var i = _toPrimitive$s(t, "string"); return "symbol" == _typeof$w(i) ? i : i + ""; }
function _toPrimitive$s(t, r) { if ("object" != _typeof$w(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$w(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Render sectors of a pie
 */
var Pie = Pie$1.Pie = /*#__PURE__*/function (_PureComponent) {
  function Pie(props) {
    var _this;
    _classCallCheck$z(this, Pie);
    _this = _callSuper$i(this, Pie, [props]);
    _defineProperty$A(_this, "pieRef", null);
    _defineProperty$A(_this, "sectorRefs", []);
    _defineProperty$A(_this, "id", (0, _DataUtils$k.uniqueId)('recharts-pie-'));
    _defineProperty$A(_this, "handleAnimationEnd", function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if ((0, _isFunction$g["default"])(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$A(_this, "handleAnimationStart", function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if ((0, _isFunction$g["default"])(onAnimationStart)) {
        onAnimationStart();
      }
    });
    _this.state = {
      isAnimationFinished: !props.isAnimationActive,
      prevIsAnimationActive: props.isAnimationActive,
      prevAnimationId: props.animationId,
      sectorToFocus: 0
    };
    return _this;
  }
  _inherits$p(Pie, _PureComponent);
  return _createClass$z(Pie, [{
    key: "isActiveIndex",
    value: function isActiveIndex(i) {
      var activeIndex = this.props.activeIndex;
      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i) !== -1;
      }
      return i === activeIndex;
    }
  }, {
    key: "hasActiveIndex",
    value: function hasActiveIndex() {
      var activeIndex = this.props.activeIndex;
      return Array.isArray(activeIndex) ? activeIndex.length !== 0 : activeIndex || activeIndex === 0;
    }
  }, {
    key: "renderLabels",
    value: function renderLabels(sectors) {
      var isAnimationActive = this.props.isAnimationActive;
      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props = this.props,
        label = _this$props.label,
        labelLine = _this$props.labelLine,
        dataKey = _this$props.dataKey,
        valueKey = _this$props.valueKey;
      var pieProps = (0, _ReactUtils$k.filterProps)(this.props, false);
      var customLabelProps = (0, _ReactUtils$k.filterProps)(label, false);
      var customLabelLineProps = (0, _ReactUtils$k.filterProps)(labelLine, false);
      var offsetRadius = label && label.offsetRadius || 20;
      var labels = sectors.map(function (entry, i) {
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = (0, _PolarUtils$9.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
        var labelProps = _objectSpread$t(_objectSpread$t(_objectSpread$t(_objectSpread$t({}, pieProps), entry), {}, {
          stroke: 'none'
        }, customLabelProps), {}, {
          index: i,
          textAnchor: Pie.getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);
        var lineProps = _objectSpread$t(_objectSpread$t(_objectSpread$t(_objectSpread$t({}, pieProps), entry), {}, {
          fill: 'none',
          stroke: entry.fill
        }, customLabelLineProps), {}, {
          index: i,
          points: [(0, _PolarUtils$9.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
        });
        var realDataKey = dataKey;
        // TODO: compatible to lower versions
        if ((0, _isNil$6["default"])(dataKey) && (0, _isNil$6["default"])(valueKey)) {
          realDataKey = 'value';
        } else if ((0, _isNil$6["default"])(dataKey)) {
          realDataKey = valueKey;
        }
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          _react$x["default"].createElement(_Layer$g.Layer, {
            key: "label-".concat(entry.startAngle, "-").concat(entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
          }, labelLine && Pie.renderLabelLineItem(labelLine, lineProps, 'line'), Pie.renderLabelItem(label, labelProps, (0, _ChartUtils$f.getValueByDataKey)(entry, realDataKey)))
        );
      });
      return /*#__PURE__*/_react$x["default"].createElement(_Layer$g.Layer, {
        className: "recharts-pie-labels"
      }, labels);
    }
  }, {
    key: "renderSectorsStatically",
    value: function renderSectorsStatically(sectors) {
      var _this2 = this;
      var _this$props2 = this.props,
        activeShape = _this$props2.activeShape,
        blendStroke = _this$props2.blendStroke,
        inactiveShapeProp = _this$props2.inactiveShape;
      return sectors.map(function (entry, i) {
        if ((entry === null || entry === void 0 ? void 0 : entry.startAngle) === 0 && (entry === null || entry === void 0 ? void 0 : entry.endAngle) === 0 && sectors.length !== 1) return null;
        var isActive = _this2.isActiveIndex(i);
        var inactiveShape = inactiveShapeProp && _this2.hasActiveIndex() ? inactiveShapeProp : null;
        var sectorOptions = isActive ? activeShape : inactiveShape;
        var sectorProps = _objectSpread$t(_objectSpread$t({}, entry), {}, {
          stroke: blendStroke ? entry.fill : entry.stroke,
          tabIndex: -1
        });
        return /*#__PURE__*/_react$x["default"].createElement(_Layer$g.Layer, _extends$t({
          ref: function ref(_ref) {
            if (_ref && !_this2.sectorRefs.includes(_ref)) {
              _this2.sectorRefs.push(_ref);
            }
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, (0, _types$6.adaptEventsOfChild)(_this2.props, entry, i), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(entry === null || entry === void 0 ? void 0 : entry.startAngle, "-").concat(entry === null || entry === void 0 ? void 0 : entry.endAngle, "-").concat(entry.midAngle, "-").concat(i)
        }), /*#__PURE__*/_react$x["default"].createElement(_ActiveShapeUtils$5.Shape, _extends$t({
          option: sectorOptions,
          isActive: isActive,
          shapeType: "sector"
        }, sectorProps)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function renderSectorsWithAnimation() {
      var _this3 = this;
      var _this$props3 = this.props,
        sectors = _this$props3.sectors,
        isAnimationActive = _this$props3.isAnimationActive,
        animationBegin = _this$props3.animationBegin,
        animationDuration = _this$props3.animationDuration,
        animationEasing = _this$props3.animationEasing,
        animationId = _this$props3.animationId;
      var _this$state = this.state,
        prevSectors = _this$state.prevSectors,
        prevIsAnimationActive = _this$state.prevIsAnimationActive;
      return /*#__PURE__*/_react$x["default"].createElement(_reactSmooth$8["default"], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId, "-").concat(prevIsAnimationActive),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref2) {
        var t = _ref2.t;
        var stepData = [];
        var first = sectors && sectors[0];
        var curAngle = first.startAngle;
        sectors.forEach(function (entry, index) {
          var prev = prevSectors && prevSectors[index];
          var paddingAngle = index > 0 ? (0, _get$4["default"])(entry, 'paddingAngle', 0) : 0;
          if (prev) {
            var angleIp = (0, _DataUtils$k.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
            var latest = _objectSpread$t(_objectSpread$t({}, entry), {}, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + angleIp(t) + paddingAngle
            });
            stepData.push(latest);
            curAngle = latest.endAngle;
          } else {
            var endAngle = entry.endAngle,
              startAngle = entry.startAngle;
            var interpolatorAngle = (0, _DataUtils$k.interpolateNumber)(0, endAngle - startAngle);
            var deltaAngle = interpolatorAngle(t);
            var _latest = _objectSpread$t(_objectSpread$t({}, entry), {}, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + deltaAngle + paddingAngle
            });
            stepData.push(_latest);
            curAngle = _latest.endAngle;
          }
        });
        return /*#__PURE__*/_react$x["default"].createElement(_Layer$g.Layer, null, _this3.renderSectorsStatically(stepData));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function attachKeyboardHandlers(pieRef) {
      var _this4 = this;
      // eslint-disable-next-line no-param-reassign
      pieRef.onkeydown = function (e) {
        if (!e.altKey) {
          switch (e.key) {
            case 'ArrowLeft':
              {
                var next = ++_this4.state.sectorToFocus % _this4.sectorRefs.length;
                _this4.sectorRefs[next].focus();
                _this4.setState({
                  sectorToFocus: next
                });
                break;
              }
            case 'ArrowRight':
              {
                var _next = --_this4.state.sectorToFocus < 0 ? _this4.sectorRefs.length - 1 : _this4.state.sectorToFocus % _this4.sectorRefs.length;
                _this4.sectorRefs[_next].focus();
                _this4.setState({
                  sectorToFocus: _next
                });
                break;
              }
            case 'Escape':
              {
                _this4.sectorRefs[_this4.state.sectorToFocus].blur();
                _this4.setState({
                  sectorToFocus: 0
                });
                break;
              }
          }
        }
      };
    }
  }, {
    key: "renderSectors",
    value: function renderSectors() {
      var _this$props4 = this.props,
        sectors = _this$props4.sectors,
        isAnimationActive = _this$props4.isAnimationActive;
      var prevSectors = this.state.prevSectors;
      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqual$7["default"])(prevSectors, sectors))) {
        return this.renderSectorsWithAnimation();
      }
      return this.renderSectorsStatically(sectors);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.pieRef) {
        this.attachKeyboardHandlers(this.pieRef);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props5 = this.props,
        hide = _this$props5.hide,
        sectors = _this$props5.sectors,
        className = _this$props5.className,
        label = _this$props5.label,
        cx = _this$props5.cx,
        cy = _this$props5.cy,
        innerRadius = _this$props5.innerRadius,
        outerRadius = _this$props5.outerRadius,
        isAnimationActive = _this$props5.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;
      if (hide || !sectors || !sectors.length || !(0, _DataUtils$k.isNumber)(cx) || !(0, _DataUtils$k.isNumber)(cy) || !(0, _DataUtils$k.isNumber)(innerRadius) || !(0, _DataUtils$k.isNumber)(outerRadius)) {
        return null;
      }
      var layerClass = (0, _clsx$j["default"])('recharts-pie', className);
      return /*#__PURE__*/_react$x["default"].createElement(_Layer$g.Layer, {
        tabIndex: this.props.rootTabIndex,
        className: layerClass,
        ref: function ref(_ref3) {
          _this5.pieRef = _ref3;
        }
      }, this.renderSectors(), label && this.renderLabels(sectors), _Label$4.Label.renderCallByParent(this.props, null, false), (!isAnimationActive || isAnimationFinished) && _LabelList$7.LabelList.renderCallByParent(this.props, sectors, false));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.prevIsAnimationActive !== nextProps.isAnimationActive) {
        return {
          prevIsAnimationActive: nextProps.isAnimationActive,
          prevAnimationId: nextProps.animationId,
          curSectors: nextProps.sectors,
          prevSectors: [],
          isAnimationFinished: true
        };
      }
      if (nextProps.isAnimationActive && nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curSectors: nextProps.sectors,
          prevSectors: prevState.curSectors,
          isAnimationFinished: true
        };
      }
      if (nextProps.sectors !== prevState.curSectors) {
        return {
          curSectors: nextProps.sectors,
          isAnimationFinished: true
        };
      }
      return null;
    }
  }, {
    key: "getTextAnchor",
    value: function getTextAnchor(x, cx) {
      if (x > cx) {
        return 'start';
      }
      if (x < cx) {
        return 'end';
      }
      return 'middle';
    }
  }, {
    key: "renderLabelLineItem",
    value: function renderLabelLineItem(option, props, key) {
      if ( /*#__PURE__*/_react$x["default"].isValidElement(option)) {
        return /*#__PURE__*/_react$x["default"].cloneElement(option, props);
      }
      if ((0, _isFunction$g["default"])(option)) {
        return option(props);
      }
      var className = (0, _clsx$j["default"])('recharts-pie-label-line', typeof option !== 'boolean' ? option.className : '');
      return /*#__PURE__*/_react$x["default"].createElement(_Curve$4.Curve, _extends$t({}, props, {
        key: key,
        type: "linear",
        className: className
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function renderLabelItem(option, props, value) {
      if ( /*#__PURE__*/_react$x["default"].isValidElement(option)) {
        return /*#__PURE__*/_react$x["default"].cloneElement(option, props);
      }
      var label = value;
      if ((0, _isFunction$g["default"])(option)) {
        label = option(props);
        if ( /*#__PURE__*/_react$x["default"].isValidElement(label)) {
          return label;
        }
      }
      var className = (0, _clsx$j["default"])('recharts-pie-label-text', typeof option !== 'boolean' && !(0, _isFunction$g["default"])(option) ? option.className : '');
      return /*#__PURE__*/_react$x["default"].createElement(_Text$3.Text, _extends$t({}, props, {
        alignmentBaseline: "middle",
        className: className
      }), label);
    }
  }]);
}(_react$x.PureComponent);
_Pie$1 = Pie;
_defineProperty$A(Pie, "displayName", 'Pie');
_defineProperty$A(Pie, "defaultProps", {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  cx: '50%',
  cy: '50%',
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: '80%',
  paddingAngle: 0,
  labelLine: true,
  hide: false,
  minAngle: 0,
  isAnimationActive: !_Global$9.Global.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease',
  nameKey: 'name',
  blendStroke: false,
  rootTabIndex: 0
});
_defineProperty$A(Pie, "parseDeltaAngle", function (startAngle, endAngle) {
  var sign = (0, _DataUtils$k.mathSign)(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign * deltaAngle;
});
_defineProperty$A(Pie, "getRealPieData", function (itemProps) {
  var data = itemProps.data,
    children = itemProps.children;
  var presentationProps = (0, _ReactUtils$k.filterProps)(itemProps, false);
  var cells = (0, _ReactUtils$k.findAllByType)(children, _Cell$4.Cell);
  if (data && data.length) {
    return data.map(function (entry, index) {
      return _objectSpread$t(_objectSpread$t(_objectSpread$t({
        payload: entry
      }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
  }
  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _objectSpread$t(_objectSpread$t({}, presentationProps), cell.props);
    });
  }
  return [];
});
_defineProperty$A(Pie, "parseCoordinateOfPie", function (itemProps, offset) {
  var top = offset.top,
    left = offset.left,
    width = offset.width,
    height = offset.height;
  var maxPieRadius = (0, _PolarUtils$9.getMaxRadius)(width, height);
  var cx = left + (0, _DataUtils$k.getPercentValue)(itemProps.cx, width, width / 2);
  var cy = top + (0, _DataUtils$k.getPercentValue)(itemProps.cy, height, height / 2);
  var innerRadius = (0, _DataUtils$k.getPercentValue)(itemProps.innerRadius, maxPieRadius, 0);
  var outerRadius = (0, _DataUtils$k.getPercentValue)(itemProps.outerRadius, maxPieRadius, maxPieRadius * 0.8);
  var maxRadius = itemProps.maxRadius || Math.sqrt(width * width + height * height) / 2;
  return {
    cx: cx,
    cy: cy,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    maxRadius: maxRadius
  };
});
_defineProperty$A(Pie, "getComposedData", function (_ref4) {
  var item = _ref4.item,
    offset = _ref4.offset;
  var itemProps = item.type.defaultProps !== undefined ? _objectSpread$t(_objectSpread$t({}, item.type.defaultProps), item.props) : item.props;
  var pieData = _Pie$1.getRealPieData(itemProps);
  if (!pieData || !pieData.length) {
    return null;
  }
  var cornerRadius = itemProps.cornerRadius,
    startAngle = itemProps.startAngle,
    endAngle = itemProps.endAngle,
    paddingAngle = itemProps.paddingAngle,
    dataKey = itemProps.dataKey,
    nameKey = itemProps.nameKey,
    valueKey = itemProps.valueKey,
    tooltipType = itemProps.tooltipType;
  var minAngle = Math.abs(itemProps.minAngle);
  var coordinate = _Pie$1.parseCoordinateOfPie(itemProps, offset);
  var deltaAngle = _Pie$1.parseDeltaAngle(startAngle, endAngle);
  var absDeltaAngle = Math.abs(deltaAngle);
  var realDataKey = dataKey;
  if ((0, _isNil$6["default"])(dataKey) && (0, _isNil$6["default"])(valueKey)) {
    (0, _LogUtils$4.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
    realDataKey = 'value';
  } else if ((0, _isNil$6["default"])(dataKey)) {
    (0, _LogUtils$4.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
    realDataKey = valueKey;
  }
  var notZeroItemCount = pieData.filter(function (entry) {
    return (0, _ChartUtils$f.getValueByDataKey)(entry, realDataKey, 0) !== 0;
  }).length;
  var totalPadingAngle = (absDeltaAngle >= 360 ? notZeroItemCount : notZeroItemCount - 1) * paddingAngle;
  var realTotalAngle = absDeltaAngle - notZeroItemCount * minAngle - totalPadingAngle;
  var sum = pieData.reduce(function (result, entry) {
    var val = (0, _ChartUtils$f.getValueByDataKey)(entry, realDataKey, 0);
    return result + ((0, _DataUtils$k.isNumber)(val) ? val : 0);
  }, 0);
  var sectors;
  if (sum > 0) {
    var prev;
    sectors = pieData.map(function (entry, i) {
      var val = (0, _ChartUtils$f.getValueByDataKey)(entry, realDataKey, 0);
      var name = (0, _ChartUtils$f.getValueByDataKey)(entry, nameKey, i);
      var percent = ((0, _DataUtils$k.isNumber)(val) ? val : 0) / sum;
      var tempStartAngle;
      if (i) {
        tempStartAngle = prev.endAngle + (0, _DataUtils$k.mathSign)(deltaAngle) * paddingAngle * (val !== 0 ? 1 : 0);
      } else {
        tempStartAngle = startAngle;
      }
      var tempEndAngle = tempStartAngle + (0, _DataUtils$k.mathSign)(deltaAngle) * ((val !== 0 ? minAngle : 0) + percent * realTotalAngle);
      var midAngle = (tempStartAngle + tempEndAngle) / 2;
      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
      var tooltipPayload = [{
        name: name,
        value: val,
        payload: entry,
        dataKey: realDataKey,
        type: tooltipType
      }];
      var tooltipPosition = (0, _PolarUtils$9.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
      prev = _objectSpread$t(_objectSpread$t(_objectSpread$t({
        percent: percent,
        cornerRadius: cornerRadius,
        name: name,
        tooltipPayload: tooltipPayload,
        midAngle: midAngle,
        middleRadius: middleRadius,
        tooltipPosition: tooltipPosition
      }, entry), coordinate), {}, {
        value: (0, _ChartUtils$f.getValueByDataKey)(entry, realDataKey),
        startAngle: tempStartAngle,
        endAngle: tempEndAngle,
        payload: entry,
        paddingAngle: (0, _DataUtils$k.mathSign)(deltaAngle) * paddingAngle
      });
      return prev;
    });
  }
  return _objectSpread$t(_objectSpread$t({}, coordinate), {}, {
    sectors: sectors,
    data: pieData
  });
});

var Radar$1 = {};

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */

function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

var head_1 = head;

var first = head_1;

Object.defineProperty(Radar$1, "__esModule", {
  value: true
});
Radar$1.Radar = void 0;
var _react$w = _interopRequireWildcard$d(React__default$4);
var _reactSmooth$7 = _interopRequireDefault$E(lib);
var _isNil$5 = _interopRequireDefault$E(isNil_1);
var _last = _interopRequireDefault$E(last_1);
var _first = _interopRequireDefault$E(first);
var _isEqual$6 = _interopRequireDefault$E(isEqual_1);
var _isFunction$f = _interopRequireDefault$E(isFunction_1);
var _clsx$i = _interopRequireDefault$E(clsx.exports);
var _DataUtils$j = DataUtils;
var _Global$8 = Global$1;
var _PolarUtils$8 = PolarUtils;
var _ChartUtils$e = ChartUtils;
var _Polygon$1 = Polygon;
var _Dot$4 = Dot;
var _Layer$f = Layer;
var _LabelList$6 = LabelList$1;
var _ReactUtils$j = ReactUtils;
var _excluded$c = ["key"];
function _interopRequireDefault$E(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$d(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$d = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$d(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$v(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$d(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$v(o) { "@babel/helpers - typeof"; return _typeof$v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$v(o); }
function _objectWithoutProperties$f(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$c(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$c(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
function ownKeys$u(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$s(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$u(Object(t), !0).forEach(function (r) { _defineProperty$z(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$u(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$y(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$s(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$r(descriptor.key), descriptor); } }
function _createClass$y(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$s(Constructor.prototype, protoProps); if (staticProps) _defineProperties$s(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$h(t, o, e) { return o = _getPrototypeOf$i(o), _possibleConstructorReturn$o(t, _isNativeReflectConstruct$i() ? Reflect.construct(o, e || [], _getPrototypeOf$i(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$o(self, call) { if (call && (_typeof$v(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$i(self); }
function _assertThisInitialized$i(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$i() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$i = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$i(o) { _getPrototypeOf$i = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$i(o); }
function _inherits$o(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$i(subClass, superClass); }
function _setPrototypeOf$i(o, p) { _setPrototypeOf$i = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$i(o, p); }
function _defineProperty$z(obj, key, value) { key = _toPropertyKey$r(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$r(t) { var i = _toPrimitive$r(t, "string"); return "symbol" == _typeof$v(i) ? i : i + ""; }
function _toPrimitive$r(t, r) { if ("object" != _typeof$v(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$v(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Radar
 */
var Radar = Radar$1.Radar = /*#__PURE__*/function (_PureComponent) {
  function Radar() {
    var _this;
    _classCallCheck$y(this, Radar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$h(this, Radar, [].concat(args));
    _defineProperty$z(_this, "state", {
      isAnimationFinished: false
    });
    _defineProperty$z(_this, "handleAnimationEnd", function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if ((0, _isFunction$f["default"])(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$z(_this, "handleAnimationStart", function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if ((0, _isFunction$f["default"])(onAnimationStart)) {
        onAnimationStart();
      }
    });
    _defineProperty$z(_this, "handleMouseEnter", function (e) {
      var onMouseEnter = _this.props.onMouseEnter;
      if (onMouseEnter) {
        onMouseEnter(_this.props, e);
      }
    });
    _defineProperty$z(_this, "handleMouseLeave", function (e) {
      var onMouseLeave = _this.props.onMouseLeave;
      if (onMouseLeave) {
        onMouseLeave(_this.props, e);
      }
    });
    return _this;
  }
  _inherits$o(Radar, _PureComponent);
  return _createClass$y(Radar, [{
    key: "renderDots",
    value: function renderDots(points) {
      var _this$props = this.props,
        dot = _this$props.dot,
        dataKey = _this$props.dataKey;
      var baseProps = (0, _ReactUtils$j.filterProps)(this.props, false);
      var customDotProps = (0, _ReactUtils$j.filterProps)(dot, true);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread$s(_objectSpread$s(_objectSpread$s({
          key: "dot-".concat(i),
          r: 3
        }, baseProps), customDotProps), {}, {
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          payload: entry
        });
        return Radar.renderDotItem(dot, dotProps);
      });
      return /*#__PURE__*/_react$w["default"].createElement(_Layer$f.Layer, {
        className: "recharts-radar-dots"
      }, dots);
    }
  }, {
    key: "renderPolygonStatically",
    value: function renderPolygonStatically(points) {
      var _this$props2 = this.props,
        shape = _this$props2.shape,
        dot = _this$props2.dot,
        isRange = _this$props2.isRange,
        baseLinePoints = _this$props2.baseLinePoints,
        connectNulls = _this$props2.connectNulls;
      var radar;
      if ( /*#__PURE__*/_react$w["default"].isValidElement(shape)) {
        radar = /*#__PURE__*/_react$w["default"].cloneElement(shape, _objectSpread$s(_objectSpread$s({}, this.props), {}, {
          points: points
        }));
      } else if ((0, _isFunction$f["default"])(shape)) {
        radar = shape(_objectSpread$s(_objectSpread$s({}, this.props), {}, {
          points: points
        }));
      } else {
        radar = /*#__PURE__*/_react$w["default"].createElement(_Polygon$1.Polygon, _extends$s({}, (0, _ReactUtils$j.filterProps)(this.props, true), {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          points: points,
          baseLinePoints: isRange ? baseLinePoints : null,
          connectNulls: connectNulls
        }));
      }
      return /*#__PURE__*/_react$w["default"].createElement(_Layer$f.Layer, {
        className: "recharts-radar-polygon"
      }, radar, dot ? this.renderDots(points) : null);
    }
  }, {
    key: "renderPolygonWithAnimation",
    value: function renderPolygonWithAnimation() {
      var _this2 = this;
      var _this$props3 = this.props,
        points = _this$props3.points,
        isAnimationActive = _this$props3.isAnimationActive,
        animationBegin = _this$props3.animationBegin,
        animationDuration = _this$props3.animationDuration,
        animationEasing = _this$props3.animationEasing,
        animationId = _this$props3.animationId;
      var prevPoints = this.state.prevPoints;
      return /*#__PURE__*/_react$w["default"].createElement(_reactSmooth$7["default"], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radar-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
        var stepData = points.map(function (entry, index) {
          var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];
          if (prev) {
            var _interpolatorX = (0, _DataUtils$j.interpolateNumber)(prev.x, entry.x);
            var _interpolatorY = (0, _DataUtils$j.interpolateNumber)(prev.y, entry.y);
            return _objectSpread$s(_objectSpread$s({}, entry), {}, {
              x: _interpolatorX(t),
              y: _interpolatorY(t)
            });
          }
          var interpolatorX = (0, _DataUtils$j.interpolateNumber)(entry.cx, entry.x);
          var interpolatorY = (0, _DataUtils$j.interpolateNumber)(entry.cy, entry.y);
          return _objectSpread$s(_objectSpread$s({}, entry), {}, {
            x: interpolatorX(t),
            y: interpolatorY(t)
          });
        });
        return _this2.renderPolygonStatically(stepData);
      });
    }
  }, {
    key: "renderPolygon",
    value: function renderPolygon() {
      var _this$props4 = this.props,
        points = _this$props4.points,
        isAnimationActive = _this$props4.isAnimationActive,
        isRange = _this$props4.isRange;
      var prevPoints = this.state.prevPoints;
      if (isAnimationActive && points && points.length && !isRange && (!prevPoints || !(0, _isEqual$6["default"])(prevPoints, points))) {
        return this.renderPolygonWithAnimation();
      }
      return this.renderPolygonStatically(points);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        hide = _this$props5.hide,
        className = _this$props5.className,
        points = _this$props5.points,
        isAnimationActive = _this$props5.isAnimationActive;
      if (hide || !points || !points.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = (0, _clsx$i["default"])('recharts-radar', className);
      return /*#__PURE__*/_react$w["default"].createElement(_Layer$f.Layer, {
        className: layerClass
      }, this.renderPolygon(), (!isAnimationActive || isAnimationFinished) && _LabelList$6.LabelList.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          prevPoints: prevState.curPoints
        };
      }
      if (nextProps.points !== prevState.curPoints) {
        return {
          curPoints: nextProps.points
        };
      }
      return null;
    }
  }, {
    key: "renderDotItem",
    value: function renderDotItem(option, props) {
      var dotItem;
      if ( /*#__PURE__*/_react$w["default"].isValidElement(option)) {
        dotItem = /*#__PURE__*/_react$w["default"].cloneElement(option, props);
      } else if ((0, _isFunction$f["default"])(option)) {
        dotItem = option(props);
      } else {
        var key = props.key,
          dotProps = _objectWithoutProperties$f(props, _excluded$c);
        dotItem = /*#__PURE__*/_react$w["default"].createElement(_Dot$4.Dot, _extends$s({}, dotProps, {
          key: key,
          className: (0, _clsx$i["default"])('recharts-radar-dot', typeof option !== 'boolean' ? option.className : '')
        }));
      }
      return dotItem;
    }
  }]);
}(_react$w.PureComponent);
_defineProperty$z(Radar, "displayName", 'Radar');
_defineProperty$z(Radar, "defaultProps", {
  angleAxisId: 0,
  radiusAxisId: 0,
  hide: false,
  activeDot: true,
  dot: false,
  legendType: 'rect',
  isAnimationActive: !_Global$8.Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
});
_defineProperty$z(Radar, "getComposedData", function (_ref2) {
  var radiusAxis = _ref2.radiusAxis,
    angleAxis = _ref2.angleAxis,
    displayedData = _ref2.displayedData,
    dataKey = _ref2.dataKey,
    bandSize = _ref2.bandSize;
  var cx = angleAxis.cx,
    cy = angleAxis.cy;
  var isRange = false;
  var points = [];
  var angleBandSize = angleAxis.type !== 'number' ? bandSize !== null && bandSize !== void 0 ? bandSize : 0 : 0;
  displayedData.forEach(function (entry, i) {
    var name = (0, _ChartUtils$e.getValueByDataKey)(entry, angleAxis.dataKey, i);
    var value = (0, _ChartUtils$e.getValueByDataKey)(entry, dataKey);
    var angle = angleAxis.scale(name) + angleBandSize;
    var pointValue = Array.isArray(value) ? (0, _last["default"])(value) : value;
    var radius = (0, _isNil$5["default"])(pointValue) ? undefined : radiusAxis.scale(pointValue);
    if (Array.isArray(value) && value.length >= 2) {
      isRange = true;
    }
    points.push(_objectSpread$s(_objectSpread$s({}, (0, _PolarUtils$8.polarToCartesian)(cx, cy, radius, angle)), {}, {
      name: name,
      value: value,
      cx: cx,
      cy: cy,
      radius: radius,
      angle: angle,
      payload: entry
    }));
  });
  var baseLinePoints = [];
  if (isRange) {
    points.forEach(function (point) {
      if (Array.isArray(point.value)) {
        var baseValue = (0, _first["default"])(point.value);
        var radius = (0, _isNil$5["default"])(baseValue) ? undefined : radiusAxis.scale(baseValue);
        baseLinePoints.push(_objectSpread$s(_objectSpread$s({}, point), {}, {
          radius: radius
        }, (0, _PolarUtils$8.polarToCartesian)(cx, cy, radius, point.angle)));
      } else {
        baseLinePoints.push(point);
      }
    });
  }
  return {
    points: points,
    isRange: isRange,
    baseLinePoints: baseLinePoints
  };
});

var RadialBar$1 = {};

var RadialBarUtils = {};

Object.defineProperty(RadialBarUtils, "__esModule", {
  value: true
});
RadialBarUtils.RadialBarSector = RadialBarSector;
RadialBarUtils.parseCornerRadius = parseCornerRadius;
RadialBarUtils.typeGuardSectorProps = typeGuardSectorProps;
var _react$v = _interopRequireDefault$D(React__default$4);
var _ActiveShapeUtils$4 = ActiveShapeUtils;
function _interopRequireDefault$D(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$u(o) { "@babel/helpers - typeof"; return _typeof$u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$u(o); }
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
function ownKeys$t(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$r(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$t(Object(t), !0).forEach(function (r) { _defineProperty$y(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$t(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$y(obj, key, value) { key = _toPropertyKey$q(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$q(t) { var i = _toPrimitive$q(t, "string"); return "symbol" == _typeof$u(i) ? i : i + ""; }
function _toPrimitive$q(t, r) { if ("object" != _typeof$u(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$u(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function parseCornerRadius(cornerRadius) {
  if (typeof cornerRadius === 'string') {
    return parseInt(cornerRadius, 10);
  }
  return cornerRadius;
}

// Sector props is expecting cx, cy as numbers.
// When props are being spread in from a user defined component in RadialBar,
// the prop types of an SVGElement have these typed as string | number.
// This function will return the passed in props along with cx, cy as numbers.
function typeGuardSectorProps(option, props) {
  var cxValue = "".concat(props.cx || option.cx);
  var cx = Number(cxValue);
  var cyValue = "".concat(props.cy || option.cy);
  var cy = Number(cyValue);
  return _objectSpread$r(_objectSpread$r(_objectSpread$r({}, props), option), {}, {
    cx: cx,
    cy: cy
  });
}
function RadialBarSector(props) {
  return /*#__PURE__*/_react$v["default"].createElement(_ActiveShapeUtils$4.Shape, _extends$r({
    shapeType: "sector",
    propTransformer: typeGuardSectorProps
  }, props));
}

Object.defineProperty(RadialBar$1, "__esModule", {
  value: true
});
RadialBar$1.RadialBar = void 0;
var _react$u = _interopRequireWildcard$c(React__default$4);
var _clsx$h = _interopRequireDefault$C(clsx.exports);
var _reactSmooth$6 = _interopRequireDefault$C(lib);
var _isEqual$5 = _interopRequireDefault$C(isEqual_1);
var _isFunction$e = _interopRequireDefault$C(isFunction_1);
var _RadialBarUtils = RadialBarUtils;
var _Layer$e = Layer;
var _ReactUtils$i = ReactUtils;
var _Global$7 = Global$1;
var _LabelList$5 = LabelList$1;
var _Cell$3 = Cell$2;
var _DataUtils$i = DataUtils;
var _ChartUtils$d = ChartUtils;
var _types$5 = types;
var _PolarUtils$7 = PolarUtils;
var _excluded$b = ["shape", "activeShape", "activeIndex", "cornerRadius"],
  _excluded2$6 = ["value", "background"];
function _interopRequireDefault$C(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$c(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$c = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$c(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$t(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$c(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$t(o) { "@babel/helpers - typeof"; return _typeof$t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$t(o); }
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
function ownKeys$s(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$s(Object(t), !0).forEach(function (r) { _defineProperty$x(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$s(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties$e(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$b(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$b(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _classCallCheck$x(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$r(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$p(descriptor.key), descriptor); } }
function _createClass$x(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$r(Constructor.prototype, protoProps); if (staticProps) _defineProperties$r(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$g(t, o, e) { return o = _getPrototypeOf$h(o), _possibleConstructorReturn$n(t, _isNativeReflectConstruct$h() ? Reflect.construct(o, e || [], _getPrototypeOf$h(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$n(self, call) { if (call && (_typeof$t(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$h(self); }
function _assertThisInitialized$h(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$h() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$h = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$h(o) { _getPrototypeOf$h = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$h(o); }
function _inherits$n(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$h(subClass, superClass); }
function _setPrototypeOf$h(o, p) { _setPrototypeOf$h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$h(o, p); }
function _defineProperty$x(obj, key, value) { key = _toPropertyKey$p(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$p(t) { var i = _toPrimitive$p(t, "string"); return "symbol" == _typeof$t(i) ? i : i + ""; }
function _toPrimitive$p(t, r) { if ("object" != _typeof$t(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$t(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Render a group of radial bar
 */
// TODO: Cause of circular dependency. Needs refactoring of functions that need them.
// import { AngleAxisProps, RadiusAxisProps } from './types';
var RadialBar = RadialBar$1.RadialBar = /*#__PURE__*/function (_PureComponent) {
  function RadialBar() {
    var _this;
    _classCallCheck$x(this, RadialBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$g(this, RadialBar, [].concat(args));
    _defineProperty$x(_this, "state", {
      isAnimationFinished: false
    });
    _defineProperty$x(_this, "handleAnimationEnd", function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if ((0, _isFunction$e["default"])(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$x(_this, "handleAnimationStart", function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if ((0, _isFunction$e["default"])(onAnimationStart)) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _inherits$n(RadialBar, _PureComponent);
  return _createClass$x(RadialBar, [{
    key: "getDeltaAngle",
    value: function getDeltaAngle() {
      var _this$props = this.props,
        startAngle = _this$props.startAngle,
        endAngle = _this$props.endAngle;
      var sign = (0, _DataUtils$i.mathSign)(endAngle - startAngle);
      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
      return sign * deltaAngle;
    }
  }, {
    key: "renderSectorsStatically",
    value: function renderSectorsStatically(sectors) {
      var _this2 = this;
      var _this$props2 = this.props,
        shape = _this$props2.shape,
        activeShape = _this$props2.activeShape,
        activeIndex = _this$props2.activeIndex,
        cornerRadius = _this$props2.cornerRadius,
        others = _objectWithoutProperties$e(_this$props2, _excluded$b);
      var baseProps = (0, _ReactUtils$i.filterProps)(others, false);
      return sectors.map(function (entry, i) {
        var isActive = i === activeIndex;
        var props = _objectSpread$q(_objectSpread$q(_objectSpread$q(_objectSpread$q({}, baseProps), {}, {
          cornerRadius: (0, _RadialBarUtils.parseCornerRadius)(cornerRadius)
        }, entry), (0, _types$5.adaptEventsOfChild)(_this2.props, entry, i)), {}, {
          className: "recharts-radial-bar-sector ".concat(entry.className),
          forceCornerRadius: others.forceCornerRadius,
          cornerIsExternal: others.cornerIsExternal,
          isActive: isActive,
          option: isActive ? activeShape : shape
        });
        return /*#__PURE__*/_react$u["default"].createElement(_RadialBarUtils.RadialBarSector, _extends$q({}, props, {
          key: "sector-".concat(i)
        }));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function renderSectorsWithAnimation() {
      var _this3 = this;
      var _this$props3 = this.props,
        data = _this$props3.data,
        isAnimationActive = _this$props3.isAnimationActive,
        animationBegin = _this$props3.animationBegin,
        animationDuration = _this$props3.animationDuration,
        animationEasing = _this$props3.animationEasing,
        animationId = _this$props3.animationId;
      var prevData = this.state.prevData;
      return /*#__PURE__*/_react$u["default"].createElement(_reactSmooth$6["default"], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radialBar-".concat(animationId),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref) {
        var t = _ref.t;
        var stepData = data.map(function (entry, index) {
          var prev = prevData && prevData[index];
          if (prev) {
            var interpolatorStartAngle = (0, _DataUtils$i.interpolateNumber)(prev.startAngle, entry.startAngle);
            var interpolatorEndAngle = (0, _DataUtils$i.interpolateNumber)(prev.endAngle, entry.endAngle);
            return _objectSpread$q(_objectSpread$q({}, entry), {}, {
              startAngle: interpolatorStartAngle(t),
              endAngle: interpolatorEndAngle(t)
            });
          }
          var endAngle = entry.endAngle,
            startAngle = entry.startAngle;
          var interpolator = (0, _DataUtils$i.interpolateNumber)(startAngle, endAngle);
          return _objectSpread$q(_objectSpread$q({}, entry), {}, {
            endAngle: interpolator(t)
          });
        });
        return /*#__PURE__*/_react$u["default"].createElement(_Layer$e.Layer, null, _this3.renderSectorsStatically(stepData));
      });
    }
  }, {
    key: "renderSectors",
    value: function renderSectors() {
      var _this$props4 = this.props,
        data = _this$props4.data,
        isAnimationActive = _this$props4.isAnimationActive;
      var prevData = this.state.prevData;
      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual$5["default"])(prevData, data))) {
        return this.renderSectorsWithAnimation();
      }
      return this.renderSectorsStatically(data);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground(sectors) {
      var _this4 = this;
      var cornerRadius = this.props.cornerRadius;
      var backgroundProps = (0, _ReactUtils$i.filterProps)(this.props.background, false);
      return sectors.map(function (entry, i) {
        entry.value;
          var background = entry.background,
          rest = _objectWithoutProperties$e(entry, _excluded2$6);
        if (!background) {
          return null;
        }
        var props = _objectSpread$q(_objectSpread$q(_objectSpread$q(_objectSpread$q(_objectSpread$q({
          cornerRadius: (0, _RadialBarUtils.parseCornerRadius)(cornerRadius)
        }, rest), {}, {
          fill: '#eee'
        }, background), backgroundProps), (0, _types$5.adaptEventsOfChild)(_this4.props, entry, i)), {}, {
          index: i,
          className: (0, _clsx$h["default"])('recharts-radial-bar-background-sector', backgroundProps === null || backgroundProps === void 0 ? void 0 : backgroundProps.className),
          option: background,
          isActive: false
        });
        return /*#__PURE__*/_react$u["default"].createElement(_RadialBarUtils.RadialBarSector, _extends$q({}, props, {
          key: "sector-".concat(i)
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        hide = _this$props5.hide,
        data = _this$props5.data,
        className = _this$props5.className,
        background = _this$props5.background,
        isAnimationActive = _this$props5.isAnimationActive;
      if (hide || !data || !data.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = (0, _clsx$h["default"])('recharts-area', className);
      return /*#__PURE__*/_react$u["default"].createElement(_Layer$e.Layer, {
        className: layerClass
      }, background && /*#__PURE__*/_react$u["default"].createElement(_Layer$e.Layer, {
        className: "recharts-radial-bar-background"
      }, this.renderBackground(data)), /*#__PURE__*/_react$u["default"].createElement(_Layer$e.Layer, {
        className: "recharts-radial-bar-sectors"
      }, this.renderSectors()), (!isAnimationActive || isAnimationFinished) && _LabelList$5.LabelList.renderCallByParent(_objectSpread$q({}, this.props), data));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curData: nextProps.data,
          prevData: prevState.curData
        };
      }
      if (nextProps.data !== prevState.curData) {
        return {
          curData: nextProps.data
        };
      }
      return null;
    }
  }]);
}(_react$u.PureComponent);
_defineProperty$x(RadialBar, "displayName", 'RadialBar');
_defineProperty$x(RadialBar, "defaultProps", {
  angleAxisId: 0,
  radiusAxisId: 0,
  minPointSize: 0,
  hide: false,
  legendType: 'rect',
  data: [],
  isAnimationActive: !_Global$7.Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  forceCornerRadius: false,
  cornerIsExternal: false
});
_defineProperty$x(RadialBar, "getComposedData", function (_ref2) {
  var item = _ref2.item,
    props = _ref2.props,
    radiusAxis = _ref2.radiusAxis,
    radiusAxisTicks = _ref2.radiusAxisTicks,
    angleAxis = _ref2.angleAxis,
    angleAxisTicks = _ref2.angleAxisTicks,
    displayedData = _ref2.displayedData,
    dataKey = _ref2.dataKey,
    stackedData = _ref2.stackedData,
    barPosition = _ref2.barPosition,
    bandSize = _ref2.bandSize,
    dataStartIndex = _ref2.dataStartIndex;
  var pos = (0, _ChartUtils$d.findPositionOfBar)(barPosition, item);
  if (!pos) {
    return null;
  }
  var cx = angleAxis.cx,
    cy = angleAxis.cy;
  var layout = props.layout;
  var _item$props = item.props,
    children = _item$props.children,
    minPointSize = _item$props.minPointSize;
  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = (0, _ChartUtils$d.getBaseValueOfBar)({
    numericAxis: numericAxis
  });
  var cells = (0, _ReactUtils$i.findAllByType)(children, _Cell$3.Cell);
  var sectors = displayedData.map(function (entry, index) {
    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;
    if (stackedData) {
      value = (0, _ChartUtils$d.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = (0, _ChartUtils$d.getValueByDataKey)(entry, dataKey);
      if (!Array.isArray(value)) {
        value = [baseValue, value];
      }
    }
    if (layout === 'radial') {
      innerRadius = (0, _ChartUtils$d.getCateCoordinateOfBar)({
        axis: radiusAxis,
        ticks: radiusAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = angleAxis.scale(value[1]);
      startAngle = angleAxis.scale(value[0]);
      outerRadius = innerRadius + pos.size;
      var deltaAngle = endAngle - startAngle;
      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
        var delta = (0, _DataUtils$i.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
        endAngle += delta;
      }
      backgroundSector = {
        background: {
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: props.startAngle,
          endAngle: props.endAngle
        }
      };
    } else {
      innerRadius = radiusAxis.scale(value[0]);
      outerRadius = radiusAxis.scale(value[1]);
      startAngle = (0, _ChartUtils$d.getCateCoordinateOfBar)({
        axis: angleAxis,
        ticks: angleAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = startAngle + pos.size;
      var deltaRadius = outerRadius - innerRadius;
      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
        var _delta = (0, _DataUtils$i.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
        outerRadius += _delta;
      }
    }
    return _objectSpread$q(_objectSpread$q(_objectSpread$q(_objectSpread$q({}, entry), backgroundSector), {}, {
      payload: entry,
      value: stackedData ? value : value[1],
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    }, cells && cells[index] && cells[index].props), {}, {
      tooltipPayload: [(0, _ChartUtils$d.getTooltipItem)(item, entry)],
      tooltipPosition: (0, _PolarUtils$7.polarToCartesian)(cx, cy, (innerRadius + outerRadius) / 2, (startAngle + endAngle) / 2)
    });
  });
  return {
    data: sectors,
    layout: layout
  };
});

var Brush$1 = {};

/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeCeil = Math.ceil,
    nativeMax$1 = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange$1(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax$1(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

var _baseRange = baseRange$1;

var toNumber = toNumber_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$2(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$2;

var baseRange = _baseRange,
    isIterateeCall$2 = _isIterateeCall,
    toFinite$1 = toFinite_1;

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange$1(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall$2(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite$1(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite$1(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite$1(step);
    return baseRange(start, end, step, fromRight);
  };
}

var _createRange = createRange$1;

var createRange = _createRange;

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

var range_1 = range;

var CssPrefixUtils = {};

Object.defineProperty(CssPrefixUtils, "__esModule", {
  value: true
});
CssPrefixUtils.generatePrefixStyle = void 0;
function _typeof$s(o) { "@babel/helpers - typeof"; return _typeof$s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$s(o); }
function ownKeys$r(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$p(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$r(Object(t), !0).forEach(function (r) { _defineProperty$w(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$r(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$w(obj, key, value) { key = _toPropertyKey$o(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$o(t) { var i = _toPrimitive$o(t, "string"); return "symbol" == _typeof$s(i) ? i : i + ""; }
function _toPrimitive$o(t, r) { if ("object" != _typeof$s(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$s(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
CssPrefixUtils.generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (!name) {
    return null;
  }
  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var result = PREFIX_LIST.reduce(function (res, entry) {
    return _objectSpread$p(_objectSpread$p({}, res), {}, _defineProperty$w({}, entry + camelName, value));
  }, {});
  result[name] = value;
  return result;
};

Object.defineProperty(Brush$1, "__esModule", {
  value: true
});
Brush$1.Brush = void 0;
var _react$t = _interopRequireWildcard$b(React__default$4);
var _clsx$g = _interopRequireDefault$B(clsx.exports);
var _d3Scale$1 = d3Scale;
var _isFunction$d = _interopRequireDefault$B(isFunction_1);
var _range$1 = _interopRequireDefault$B(range_1);
var _Layer$d = Layer;
var _Text$2 = Text;
var _ChartUtils$c = ChartUtils;
var _DataUtils$h = DataUtils;
var _CssPrefixUtils = CssPrefixUtils;
var _ReactUtils$h = ReactUtils;
function _interopRequireDefault$B(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$b(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$b = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$b(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$r(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$b(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$r(o) { "@babel/helpers - typeof"; return _typeof$r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$r(o); }
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
function ownKeys$q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$o(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$q(Object(t), !0).forEach(function (r) { _defineProperty$v(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$w(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$q(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$n(descriptor.key), descriptor); } }
function _createClass$w(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$q(Constructor.prototype, protoProps); if (staticProps) _defineProperties$q(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$f(t, o, e) { return o = _getPrototypeOf$g(o), _possibleConstructorReturn$m(t, _isNativeReflectConstruct$g() ? Reflect.construct(o, e || [], _getPrototypeOf$g(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$m(self, call) { if (call && (_typeof$r(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$g(self); }
function _assertThisInitialized$g(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$g() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$g = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$g(o) { _getPrototypeOf$g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$g(o); }
function _inherits$m(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$g(subClass, superClass); }
function _setPrototypeOf$g(o, p) { _setPrototypeOf$g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$g(o, p); }
function _defineProperty$v(obj, key, value) { key = _toPropertyKey$n(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$n(t) { var i = _toPrimitive$n(t, "string"); return "symbol" == _typeof$r(i) ? i : i + ""; }
function _toPrimitive$n(t, r) { if ("object" != _typeof$r(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$r(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Brush
 */
var createScale = function createScale(_ref) {
  var data = _ref.data,
    startIndex = _ref.startIndex,
    endIndex = _ref.endIndex,
    x = _ref.x,
    width = _ref.width,
    travellerWidth = _ref.travellerWidth;
  if (!data || !data.length) {
    return {};
  }
  var len = data.length;
  var scale = (0, _d3Scale$1.scalePoint)().domain((0, _range$1["default"])(0, len)).range([x, x + width - travellerWidth]);
  var scaleValues = scale.domain().map(function (entry) {
    return scale(entry);
  });
  return {
    isTextActive: false,
    isSlideMoving: false,
    isTravellerMoving: false,
    isTravellerFocused: false,
    startX: scale(startIndex),
    endX: scale(endIndex),
    scale: scale,
    scaleValues: scaleValues
  };
};
var isTouch = function isTouch(e) {
  return e.changedTouches && !!e.changedTouches.length;
};
var Brush = Brush$1.Brush = /*#__PURE__*/function (_PureComponent) {
  function Brush(props) {
    var _this;
    _classCallCheck$w(this, Brush);
    _this = _callSuper$f(this, Brush, [props]);
    _defineProperty$v(_this, "handleDrag", function (e) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }
      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e);
      }
    });
    _defineProperty$v(_this, "handleTouchMove", function (e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this.handleDrag(e.changedTouches[0]);
      }
    });
    _defineProperty$v(_this, "handleDragEnd", function () {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false
      }, function () {
        var _this$props = _this.props,
          endIndex = _this$props.endIndex,
          onDragEnd = _this$props.onDragEnd,
          startIndex = _this$props.startIndex;
        onDragEnd === null || onDragEnd === void 0 || onDragEnd({
          endIndex: endIndex,
          startIndex: startIndex
        });
      });
      _this.detachDragEndListener();
    });
    _defineProperty$v(_this, "handleLeaveWrapper", function () {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
      }
    });
    _defineProperty$v(_this, "handleEnterSlideOrTraveller", function () {
      _this.setState({
        isTextActive: true
      });
    });
    _defineProperty$v(_this, "handleLeaveSlideOrTraveller", function () {
      _this.setState({
        isTextActive: false
      });
    });
    _defineProperty$v(_this, "handleSlideDragStart", function (e) {
      var event = isTouch(e) ? e.changedTouches[0] : e;
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX
      });
      _this.attachDragEndListener();
    });
    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
    };
    _this.state = {};
    return _this;
  }
  _inherits$m(Brush, _PureComponent);
  return _createClass$w(Brush, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      }
      this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function getIndex(_ref2) {
      var startX = _ref2.startX,
        endX = _ref2.endX;
      var scaleValues = this.state.scaleValues;
      var _this$props2 = this.props,
        gap = _this$props2.gap,
        data = _this$props2.data;
      var lastIndex = data.length - 1;
      var min = Math.min(startX, endX);
      var max = Math.max(startX, endX);
      var minIndex = Brush.getIndexInRange(scaleValues, min);
      var maxIndex = Brush.getIndexInRange(scaleValues, max);
      return {
        startIndex: minIndex - minIndex % gap,
        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
      };
    }
  }, {
    key: "getTextOfTick",
    value: function getTextOfTick(index) {
      var _this$props3 = this.props,
        data = _this$props3.data,
        tickFormatter = _this$props3.tickFormatter,
        dataKey = _this$props3.dataKey;
      var text = (0, _ChartUtils$c.getValueByDataKey)(data[index], dataKey, index);
      return (0, _isFunction$d["default"])(tickFormatter) ? tickFormatter(text, index) : text;
    }
  }, {
    key: "attachDragEndListener",
    value: function attachDragEndListener() {
      window.addEventListener('mouseup', this.handleDragEnd, true);
      window.addEventListener('touchend', this.handleDragEnd, true);
      window.addEventListener('mousemove', this.handleDrag, true);
    }
  }, {
    key: "detachDragEndListener",
    value: function detachDragEndListener() {
      window.removeEventListener('mouseup', this.handleDragEnd, true);
      window.removeEventListener('touchend', this.handleDragEnd, true);
      window.removeEventListener('mousemove', this.handleDrag, true);
    }
  }, {
    key: "handleSlideDrag",
    value: function handleSlideDrag(e) {
      var _this$state = this.state,
        slideMoveStartX = _this$state.slideMoveStartX,
        startX = _this$state.startX,
        endX = _this$state.endX;
      var _this$props4 = this.props,
        x = _this$props4.x,
        width = _this$props4.width,
        travellerWidth = _this$props4.travellerWidth,
        startIndex = _this$props4.startIndex,
        endIndex = _this$props4.endIndex,
        onChange = _this$props4.onChange;
      var delta = e.pageX - slideMoveStartX;
      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
      } else if (delta < 0) {
        delta = Math.max(delta, x - startX, x - endX);
      }
      var newIndex = this.getIndex({
        startX: startX + delta,
        endX: endX + delta
      });
      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
        onChange(newIndex);
      }
      this.setState({
        startX: startX + delta,
        endX: endX + delta,
        slideMoveStartX: e.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function handleTravellerDragStart(id, e) {
      var event = isTouch(e) ? e.changedTouches[0] : e;
      this.setState({
        isSlideMoving: false,
        isTravellerMoving: true,
        movingTravellerId: id,
        brushMoveStartX: event.pageX
      });
      this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function handleTravellerMove(e) {
      var _this$state2 = this.state,
        brushMoveStartX = _this$state2.brushMoveStartX,
        movingTravellerId = _this$state2.movingTravellerId,
        endX = _this$state2.endX,
        startX = _this$state2.startX;
      var prevValue = this.state[movingTravellerId];
      var _this$props5 = this.props,
        x = _this$props5.x,
        width = _this$props5.width,
        travellerWidth = _this$props5.travellerWidth,
        onChange = _this$props5.onChange,
        gap = _this$props5.gap,
        data = _this$props5.data;
      var params = {
        startX: this.state.startX,
        endX: this.state.endX
      };
      var delta = e.pageX - brushMoveStartX;
      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - prevValue);
      } else if (delta < 0) {
        delta = Math.max(delta, x - prevValue);
      }
      params[movingTravellerId] = prevValue + delta;
      var newIndex = this.getIndex(params);
      var startIndex = newIndex.startIndex,
        endIndex = newIndex.endIndex;
      var isFullGap = function isFullGap() {
        var lastIndex = data.length - 1;
        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
          return true;
        }
        return false;
      };
      this.setState(_defineProperty$v(_defineProperty$v({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function () {
        if (onChange) {
          if (isFullGap()) {
            onChange(newIndex);
          }
        }
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function handleTravellerMoveKeyboard(direction, id) {
      var _this2 = this;
      // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
      var _this$state3 = this.state,
        scaleValues = _this$state3.scaleValues,
        startX = _this$state3.startX,
        endX = _this$state3.endX;
      // currentScaleValue refers to which coordinate the current traveller should be placed at.
      var currentScaleValue = this.state[id];
      var currentIndex = scaleValues.indexOf(currentScaleValue);
      if (currentIndex === -1) {
        return;
      }
      var newIndex = currentIndex + direction;
      if (newIndex === -1 || newIndex >= scaleValues.length) {
        return;
      }
      var newScaleValue = scaleValues[newIndex];

      // Prevent travellers from being on top of each other or overlapping
      if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) {
        return;
      }
      this.setState(_defineProperty$v({}, id, newScaleValue), function () {
        _this2.props.onChange(_this2.getIndex({
          startX: _this2.state.startX,
          endX: _this2.state.endX
        }));
      });
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this$props6 = this.props,
        x = _this$props6.x,
        y = _this$props6.y,
        width = _this$props6.width,
        height = _this$props6.height,
        fill = _this$props6.fill,
        stroke = _this$props6.stroke;
      return /*#__PURE__*/_react$t["default"].createElement("rect", {
        stroke: stroke,
        fill: fill,
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, {
    key: "renderPanorama",
    value: function renderPanorama() {
      var _this$props7 = this.props,
        x = _this$props7.x,
        y = _this$props7.y,
        width = _this$props7.width,
        height = _this$props7.height,
        data = _this$props7.data,
        children = _this$props7.children,
        padding = _this$props7.padding;
      var chartElement = _react$t.Children.only(children);
      if (!chartElement) {
        return null;
      }
      return /*#__PURE__*/_react$t["default"].cloneElement(chartElement, {
        x: x,
        y: y,
        width: width,
        height: height,
        margin: padding,
        compact: true,
        data: data
      });
    }
  }, {
    key: "renderTravellerLayer",
    value: function renderTravellerLayer(travellerX, id) {
      var _data$startIndex,
        _data$endIndex,
        _this3 = this;
      var _this$props8 = this.props,
        y = _this$props8.y,
        travellerWidth = _this$props8.travellerWidth,
        height = _this$props8.height,
        traveller = _this$props8.traveller,
        ariaLabel = _this$props8.ariaLabel,
        data = _this$props8.data,
        startIndex = _this$props8.startIndex,
        endIndex = _this$props8.endIndex;
      var x = Math.max(travellerX, this.props.x);
      var travellerProps = _objectSpread$o(_objectSpread$o({}, (0, _ReactUtils$h.filterProps)(this.props, false)), {}, {
        x: x,
        y: y,
        width: travellerWidth,
        height: height
      });
      var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
      return /*#__PURE__*/_react$t["default"].createElement(_Layer$d.Layer, {
        tabIndex: 0,
        role: "slider",
        "aria-label": ariaLabelBrush,
        "aria-valuenow": travellerX,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[id],
        onTouchStart: this.travellerDragStartHandlers[id],
        onKeyDown: function onKeyDown(e) {
          if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
        },
        onFocus: function onFocus() {
          _this3.setState({
            isTravellerFocused: true
          });
        },
        onBlur: function onBlur() {
          _this3.setState({
            isTravellerFocused: false
          });
        },
        style: {
          cursor: 'col-resize'
        }
      }, Brush.renderTraveller(traveller, travellerProps));
    }
  }, {
    key: "renderSlide",
    value: function renderSlide(startX, endX) {
      var _this$props9 = this.props,
        y = _this$props9.y,
        height = _this$props9.height,
        stroke = _this$props9.stroke,
        travellerWidth = _this$props9.travellerWidth;
      var x = Math.min(startX, endX) + travellerWidth;
      var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
      return /*#__PURE__*/_react$t["default"].createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: 'move'
        },
        stroke: "none",
        fill: stroke,
        fillOpacity: 0.2,
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, {
    key: "renderText",
    value: function renderText() {
      var _this$props10 = this.props,
        startIndex = _this$props10.startIndex,
        endIndex = _this$props10.endIndex,
        y = _this$props10.y,
        height = _this$props10.height,
        travellerWidth = _this$props10.travellerWidth,
        stroke = _this$props10.stroke;
      var _this$state4 = this.state,
        startX = _this$state4.startX,
        endX = _this$state4.endX;
      var offset = 5;
      var attrs = {
        pointerEvents: 'none',
        fill: stroke
      };
      return /*#__PURE__*/_react$t["default"].createElement(_Layer$d.Layer, {
        className: "recharts-brush-texts"
      }, /*#__PURE__*/_react$t["default"].createElement(_Text$2.Text, _extends$p({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(startX, endX) - offset,
        y: y + height / 2
      }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/_react$t["default"].createElement(_Text$2.Text, _extends$p({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(startX, endX) + travellerWidth + offset,
        y: y + height / 2
      }, attrs), this.getTextOfTick(endIndex)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
        data = _this$props11.data,
        className = _this$props11.className,
        children = _this$props11.children,
        x = _this$props11.x,
        y = _this$props11.y,
        width = _this$props11.width,
        height = _this$props11.height,
        alwaysShowText = _this$props11.alwaysShowText;
      var _this$state5 = this.state,
        startX = _this$state5.startX,
        endX = _this$state5.endX,
        isTextActive = _this$state5.isTextActive,
        isSlideMoving = _this$state5.isSlideMoving,
        isTravellerMoving = _this$state5.isTravellerMoving,
        isTravellerFocused = _this$state5.isTravellerFocused;
      if (!data || !data.length || !(0, _DataUtils$h.isNumber)(x) || !(0, _DataUtils$h.isNumber)(y) || !(0, _DataUtils$h.isNumber)(width) || !(0, _DataUtils$h.isNumber)(height) || width <= 0 || height <= 0) {
        return null;
      }
      var layerClass = (0, _clsx$g["default"])('recharts-brush', className);
      var isPanoramic = _react$t["default"].Children.count(children) === 1;
      var style = (0, _CssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
      return /*#__PURE__*/_react$t["default"].createElement(_Layer$d.Layer, {
        className: layerClass,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: style
      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function renderDefaultTraveller(props) {
      var x = props.x,
        y = props.y,
        width = props.width,
        height = props.height,
        stroke = props.stroke;
      var lineY = Math.floor(y + height / 2) - 1;
      return /*#__PURE__*/_react$t["default"].createElement(_react$t["default"].Fragment, null, /*#__PURE__*/_react$t["default"].createElement("rect", {
        x: x,
        y: y,
        width: width,
        height: height,
        fill: stroke,
        stroke: "none"
      }), /*#__PURE__*/_react$t["default"].createElement("line", {
        x1: x + 1,
        y1: lineY,
        x2: x + width - 1,
        y2: lineY,
        fill: "none",
        stroke: "#fff"
      }), /*#__PURE__*/_react$t["default"].createElement("line", {
        x1: x + 1,
        y1: lineY + 2,
        x2: x + width - 1,
        y2: lineY + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function renderTraveller(option, props) {
      var rectangle;
      if ( /*#__PURE__*/_react$t["default"].isValidElement(option)) {
        rectangle = /*#__PURE__*/_react$t["default"].cloneElement(option, props);
      } else if ((0, _isFunction$d["default"])(option)) {
        rectangle = option(props);
      } else {
        rectangle = Brush.renderDefaultTraveller(props);
      }
      return rectangle;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var data = nextProps.data,
        width = nextProps.width,
        x = nextProps.x,
        travellerWidth = nextProps.travellerWidth,
        updateId = nextProps.updateId,
        startIndex = nextProps.startIndex,
        endIndex = nextProps.endIndex;
      if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) {
        return _objectSpread$o({
          prevData: data,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x,
          prevWidth: width
        }, data && data.length ? createScale({
          data: data,
          width: width,
          x: x,
          travellerWidth: travellerWidth,
          startIndex: startIndex,
          endIndex: endIndex
        }) : {
          scale: null,
          scaleValues: null
        });
      }
      if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
        prevState.scale.range([x, x + width - travellerWidth]);
        var scaleValues = prevState.scale.domain().map(function (entry) {
          return prevState.scale(entry);
        });
        return {
          prevData: data,
          prevTravellerWidth: travellerWidth,
          prevUpdateId: updateId,
          prevX: x,
          prevWidth: width,
          startX: prevState.scale(nextProps.startIndex),
          endX: prevState.scale(nextProps.endIndex),
          scaleValues: scaleValues
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function getIndexInRange(valueRange, x) {
      var len = valueRange.length;
      var start = 0;
      var end = len - 1;
      while (end - start > 1) {
        var middle = Math.floor((start + end) / 2);
        if (valueRange[middle] > x) {
          end = middle;
        } else {
          start = middle;
        }
      }
      return x >= valueRange[end] ? end : start;
    }
  }]);
}(_react$t.PureComponent);
_defineProperty$v(Brush, "displayName", 'Brush');
_defineProperty$v(Brush, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: '#fff',
  stroke: '#666',
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1000,
  alwaysShowText: false
});

var ReferenceLine$1 = {};

var baseEach$1 = _baseEach;

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome$1(collection, predicate) {
  var result;

  baseEach$1(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

var _baseSome = baseSome$1;

var arraySome = _arraySome,
    baseIteratee$5 = _baseIteratee,
    baseSome = _baseSome,
    isArray$1 = isArray_1,
    isIterateeCall$1 = _isIterateeCall;

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray$1(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall$1(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee$5(predicate));
}

var some_1 = some;

var IfOverflowMatches = {};

Object.defineProperty(IfOverflowMatches, "__esModule", {
  value: true
});
IfOverflowMatches.ifOverflowMatches = void 0;
IfOverflowMatches.ifOverflowMatches = function ifOverflowMatches(props, value) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;
  if (alwaysShow) {
    ifOverflow = 'extendDomain';
  }
  return ifOverflow === value;
};

var CartesianUtils = {};

var baseAssignValue = _baseAssignValue,
    baseForOwn = _baseForOwn,
    baseIteratee$4 = _baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$4(iteratee);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */

function arrayEvery$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

var _arrayEvery = arrayEvery$1;

var baseEach = _baseEach;

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery$1(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

var _baseEvery = baseEvery$1;

var arrayEvery = _arrayEvery,
    baseEvery = _baseEvery,
    baseIteratee$3 = _baseIteratee,
    isArray = isArray_1,
    isIterateeCall = _isIterateeCall;

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee$3(predicate));
}

var every_1 = every;

var Bar$1 = {};

var BarUtils = {};

Object.defineProperty(BarUtils, "__esModule", {
  value: true
});
BarUtils.BarRectangle = BarRectangle;
BarUtils.minPointSizeCallback = void 0;
var _react$s = _interopRequireDefault$A(React__default$4);
var _tinyInvariant$2 = _interopRequireDefault$A(tinyInvariant_cjs);
var _ActiveShapeUtils$3 = ActiveShapeUtils;
var _excluded$a = ["x", "y"];
function _interopRequireDefault$A(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$q(o) { "@babel/helpers - typeof"; return _typeof$q = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$q(o); }
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
function ownKeys$p(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$p(Object(t), !0).forEach(function (r) { _defineProperty$u(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$p(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$u(obj, key, value) { key = _toPropertyKey$m(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$m(t) { var i = _toPrimitive$m(t, "string"); return "symbol" == _typeof$q(i) ? i : i + ""; }
function _toPrimitive$m(t, r) { if ("object" != _typeof$q(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$q(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties$d(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$a(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$a(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function typeguardBarRectangleProps(_ref, props) {
  var xProp = _ref.x,
    yProp = _ref.y,
    option = _objectWithoutProperties$d(_ref, _excluded$a);
  var xValue = "".concat(xProp);
  var x = parseInt(xValue, 10);
  var yValue = "".concat(yProp);
  var y = parseInt(yValue, 10);
  var heightValue = "".concat(props.height || option.height);
  var height = parseInt(heightValue, 10);
  var widthValue = "".concat(props.width || option.width);
  var width = parseInt(widthValue, 10);
  return _objectSpread$n(_objectSpread$n(_objectSpread$n(_objectSpread$n(_objectSpread$n({}, props), option), x ? {
    x: x
  } : {}), y ? {
    y: y
  } : {}), {}, {
    height: height,
    width: width,
    name: props.name,
    radius: props.radius
  });
}
function BarRectangle(props) {
  return /*#__PURE__*/_react$s["default"].createElement(_ActiveShapeUtils$3.Shape, _extends$o({
    shapeType: "rectangle",
    propTransformer: typeguardBarRectangleProps,
    activeClassName: "recharts-active-bar"
  }, props));
}
/**
 * Safely gets minPointSize from from the minPointSize prop if it is a function
 * @param minPointSize minPointSize as passed to the Bar component
 * @param defaultValue default minPointSize
 * @returns minPointSize
 */
BarUtils.minPointSizeCallback = function minPointSizeCallback(minPointSize) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return function (value, index) {
    if (typeof minPointSize === 'number') return minPointSize;
    var isValueNumber = typeof value === 'number';
    if (isValueNumber) {
      return minPointSize(value, index);
    }
    !isValueNumber ? process.env.NODE_ENV !== "production" ? (0, _tinyInvariant$2["default"])(false, "minPointSize callback function received a value with type of ".concat(_typeof$q(value), ". Currently only numbers are supported.")) : (0, _tinyInvariant$2["default"])(false) : void 0;
    return defaultValue;
  };
};

Object.defineProperty(Bar$1, "__esModule", {
  value: true
});
Bar$1.Bar = void 0;
var _react$r = _interopRequireWildcard$a(React__default$4);
var _clsx$f = _interopRequireDefault$z(clsx.exports);
var _reactSmooth$5 = _interopRequireDefault$z(lib);
var _isEqual$4 = _interopRequireDefault$z(isEqual_1);
var _isNil$4 = _interopRequireDefault$z(isNil_1);
var _Layer$c = Layer;
var _ErrorBar$2 = ErrorBar$1;
var _Cell$2 = Cell$2;
var _LabelList$4 = LabelList$1;
var _DataUtils$g = DataUtils;
var _ReactUtils$g = ReactUtils;
var _Global$6 = Global$1;
var _ChartUtils$b = ChartUtils;
var _types$4 = types;
var _BarUtils = BarUtils;
var _excluded$9 = ["value", "background"];
var _Bar$3;
function _interopRequireDefault$z(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$a(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$a = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$a(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$p(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$a(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$p(o) { "@babel/helpers - typeof"; return _typeof$p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$p(o); }
function _objectWithoutProperties$c(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$9(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$9(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
function ownKeys$o(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$o(Object(t), !0).forEach(function (r) { _defineProperty$t(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$o(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$v(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$p(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$l(descriptor.key), descriptor); } }
function _createClass$v(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$p(Constructor.prototype, protoProps); if (staticProps) _defineProperties$p(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$e(t, o, e) { return o = _getPrototypeOf$f(o), _possibleConstructorReturn$l(t, _isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], _getPrototypeOf$f(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$l(self, call) { if (call && (_typeof$p(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$f(self); }
function _assertThisInitialized$f(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$f() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$f = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$f(o) { _getPrototypeOf$f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$f(o); }
function _inherits$l(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$f(subClass, superClass); }
function _setPrototypeOf$f(o, p) { _setPrototypeOf$f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$f(o, p); }
function _defineProperty$t(obj, key, value) { key = _toPropertyKey$l(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$l(t) { var i = _toPrimitive$l(t, "string"); return "symbol" == _typeof$p(i) ? i : i + ""; }
function _toPrimitive$l(t, r) { if ("object" != _typeof$p(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$p(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Render a group of bar
 */
var Bar = Bar$1.Bar = /*#__PURE__*/function (_PureComponent) {
  function Bar() {
    var _this;
    _classCallCheck$v(this, Bar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$e(this, Bar, [].concat(args));
    _defineProperty$t(_this, "state", {
      isAnimationFinished: false
    });
    _defineProperty$t(_this, "id", (0, _DataUtils$g.uniqueId)('recharts-bar-'));
    _defineProperty$t(_this, "handleAnimationEnd", function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if (onAnimationEnd) {
        onAnimationEnd();
      }
    });
    _defineProperty$t(_this, "handleAnimationStart", function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if (onAnimationStart) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _inherits$l(Bar, _PureComponent);
  return _createClass$v(Bar, [{
    key: "renderRectanglesStatically",
    value: function renderRectanglesStatically(data) {
      var _this2 = this;
      var _this$props = this.props,
        shape = _this$props.shape,
        dataKey = _this$props.dataKey,
        activeIndex = _this$props.activeIndex,
        activeBar = _this$props.activeBar;
      var baseProps = (0, _ReactUtils$g.filterProps)(this.props, false);
      return data && data.map(function (entry, i) {
        var isActive = i === activeIndex;
        var option = isActive ? activeBar : shape;
        var props = _objectSpread$m(_objectSpread$m(_objectSpread$m({}, baseProps), entry), {}, {
          isActive: isActive,
          option: option,
          index: i,
          dataKey: dataKey,
          onAnimationStart: _this2.handleAnimationStart,
          onAnimationEnd: _this2.handleAnimationEnd
        });
        return /*#__PURE__*/_react$r["default"].createElement(_Layer$c.Layer, _extends$n({
          className: "recharts-bar-rectangle"
        }, (0, _types$4.adaptEventsOfChild)(_this2.props, entry, i), {
          key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
        }), /*#__PURE__*/_react$r["default"].createElement(_BarUtils.BarRectangle, props));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function renderRectanglesWithAnimation() {
      var _this3 = this;
      var _this$props2 = this.props,
        data = _this$props2.data,
        layout = _this$props2.layout,
        isAnimationActive = _this$props2.isAnimationActive,
        animationBegin = _this$props2.animationBegin,
        animationDuration = _this$props2.animationDuration,
        animationEasing = _this$props2.animationEasing,
        animationId = _this$props2.animationId;
      var prevData = this.state.prevData;
      return /*#__PURE__*/_react$r["default"].createElement(_reactSmooth$5["default"], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var stepData = data.map(function (entry, index) {
          var prev = prevData && prevData[index];
          if (prev) {
            var interpolatorX = (0, _DataUtils$g.interpolateNumber)(prev.x, entry.x);
            var interpolatorY = (0, _DataUtils$g.interpolateNumber)(prev.y, entry.y);
            var interpolatorWidth = (0, _DataUtils$g.interpolateNumber)(prev.width, entry.width);
            var interpolatorHeight = (0, _DataUtils$g.interpolateNumber)(prev.height, entry.height);
            return _objectSpread$m(_objectSpread$m({}, entry), {}, {
              x: interpolatorX(t),
              y: interpolatorY(t),
              width: interpolatorWidth(t),
              height: interpolatorHeight(t)
            });
          }
          if (layout === 'horizontal') {
            var _interpolatorHeight = (0, _DataUtils$g.interpolateNumber)(0, entry.height);
            var h = _interpolatorHeight(t);
            return _objectSpread$m(_objectSpread$m({}, entry), {}, {
              y: entry.y + entry.height - h,
              height: h
            });
          }
          var interpolator = (0, _DataUtils$g.interpolateNumber)(0, entry.width);
          var w = interpolator(t);
          return _objectSpread$m(_objectSpread$m({}, entry), {}, {
            width: w
          });
        });
        return /*#__PURE__*/_react$r["default"].createElement(_Layer$c.Layer, null, _this3.renderRectanglesStatically(stepData));
      });
    }
  }, {
    key: "renderRectangles",
    value: function renderRectangles() {
      var _this$props3 = this.props,
        data = _this$props3.data,
        isAnimationActive = _this$props3.isAnimationActive;
      var prevData = this.state.prevData;
      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual$4["default"])(prevData, data))) {
        return this.renderRectanglesWithAnimation();
      }
      return this.renderRectanglesStatically(data);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this4 = this;
      var _this$props4 = this.props,
        data = _this$props4.data,
        dataKey = _this$props4.dataKey,
        activeIndex = _this$props4.activeIndex;
      var backgroundProps = (0, _ReactUtils$g.filterProps)(this.props.background, false);
      return data.map(function (entry, i) {
        entry.value;
          var background = entry.background,
          rest = _objectWithoutProperties$c(entry, _excluded$9);
        if (!background) {
          return null;
        }
        var props = _objectSpread$m(_objectSpread$m(_objectSpread$m(_objectSpread$m(_objectSpread$m({}, rest), {}, {
          fill: '#eee'
        }, background), backgroundProps), (0, _types$4.adaptEventsOfChild)(_this4.props, entry, i)), {}, {
          onAnimationStart: _this4.handleAnimationStart,
          onAnimationEnd: _this4.handleAnimationEnd,
          dataKey: dataKey,
          index: i,
          className: 'recharts-bar-background-rectangle'
        });
        return /*#__PURE__*/_react$r["default"].createElement(_BarUtils.BarRectangle, _extends$n({
          key: "background-bar-".concat(i),
          option: _this4.props.background,
          isActive: i === activeIndex
        }, props));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar(needClip, clipPathId) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props5 = this.props,
        data = _this$props5.data,
        xAxis = _this$props5.xAxis,
        yAxis = _this$props5.yAxis,
        layout = _this$props5.layout,
        children = _this$props5.children;
      var errorBarItems = (0, _ReactUtils$g.findAllByType)(children, _ErrorBar$2.ErrorBar);
      if (!errorBarItems) {
        return null;
      }
      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
      var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
        /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */
        var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: value,
          errorVal: (0, _ChartUtils$b.getValueByDataKey)(dataPoint, dataKey)
        };
      };
      var errorBarProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return /*#__PURE__*/_react$r["default"].createElement(_Layer$c.Layer, errorBarProps, errorBarItems.map(function (item) {
        return /*#__PURE__*/_react$r["default"].cloneElement(item, {
          key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
          data: data,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: layout,
          offset: offset,
          dataPointFormatter: dataPointFormatter
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        hide = _this$props6.hide,
        data = _this$props6.data,
        className = _this$props6.className,
        xAxis = _this$props6.xAxis,
        yAxis = _this$props6.yAxis,
        left = _this$props6.left,
        top = _this$props6.top,
        width = _this$props6.width,
        height = _this$props6.height,
        isAnimationActive = _this$props6.isAnimationActive,
        background = _this$props6.background,
        id = _this$props6.id;
      if (hide || !data || !data.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = (0, _clsx$f["default"])('recharts-bar', className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = (0, _isNil$4["default"])(id) ? this.id : id;
      return /*#__PURE__*/_react$r["default"].createElement(_Layer$c.Layer, {
        className: layerClass
      }, needClipX || needClipY ? /*#__PURE__*/_react$r["default"].createElement("defs", null, /*#__PURE__*/_react$r["default"].createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /*#__PURE__*/_react$r["default"].createElement("rect", {
        x: needClipX ? left : left - width / 2,
        y: needClipY ? top : top - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
      }))) : null, /*#__PURE__*/_react$r["default"].createElement(_Layer$c.Layer, {
        className: "recharts-bar-rectangles",
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList$4.LabelList.renderCallByParent(this.props, data));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curData: nextProps.data,
          prevData: prevState.curData
        };
      }
      if (nextProps.data !== prevState.curData) {
        return {
          curData: nextProps.data
        };
      }
      return null;
    }
  }]);
}(_react$r.PureComponent);
_Bar$3 = Bar;
_defineProperty$t(Bar, "displayName", 'Bar');
_defineProperty$t(Bar, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'rect',
  minPointSize: 0,
  hide: false,
  data: [],
  layout: 'vertical',
  activeBar: false,
  isAnimationActive: !_Global$6.Global.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */
_defineProperty$t(Bar, "getComposedData", function (_ref2) {
  var props = _ref2.props,
    item = _ref2.item,
    barPosition = _ref2.barPosition,
    bandSize = _ref2.bandSize,
    xAxis = _ref2.xAxis,
    yAxis = _ref2.yAxis,
    xAxisTicks = _ref2.xAxisTicks,
    yAxisTicks = _ref2.yAxisTicks,
    stackedData = _ref2.stackedData,
    dataStartIndex = _ref2.dataStartIndex,
    displayedData = _ref2.displayedData,
    offset = _ref2.offset;
  var pos = (0, _ChartUtils$b.findPositionOfBar)(barPosition, item);
  if (!pos) {
    return null;
  }
  var layout = props.layout;
  var itemDefaultProps = item.type.defaultProps;
  var itemProps = itemDefaultProps !== undefined ? _objectSpread$m(_objectSpread$m({}, itemDefaultProps), item.props) : item.props;
  var dataKey = itemProps.dataKey,
    children = itemProps.children,
    minPointSizeProp = itemProps.minPointSize;
  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = (0, _ChartUtils$b.getBaseValueOfBar)({
    numericAxis: numericAxis
  });
  var cells = (0, _ReactUtils$g.findAllByType)(children, _Cell$2.Cell);
  var rects = displayedData.map(function (entry, index) {
    var value, x, y, width, height, background;
    if (stackedData) {
      value = (0, _ChartUtils$b.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = (0, _ChartUtils$b.getValueByDataKey)(entry, dataKey);
      if (!Array.isArray(value)) {
        value = [baseValue, value];
      }
    }
    var minPointSize = (0, _BarUtils.minPointSizeCallback)(minPointSizeProp, _Bar$3.defaultProps.minPointSize)(value[1], index);
    if (layout === 'horizontal') {
      var _ref4;
      var _ref3 = [yAxis.scale(value[0]), yAxis.scale(value[1])],
        baseValueScale = _ref3[0],
        currentValueScale = _ref3[1];
      x = (0, _ChartUtils$b.getCateCoordinateOfBar)({
        axis: xAxis,
        ticks: xAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
      width = pos.size;
      var computedHeight = baseValueScale - currentValueScale;
      height = Number.isNaN(computedHeight) ? 0 : computedHeight;
      background = {
        x: x,
        y: yAxis.y,
        width: width,
        height: yAxis.height
      };
      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
        var delta = (0, _DataUtils$g.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
        y -= delta;
        height += delta;
      }
    } else {
      var _ref5 = [xAxis.scale(value[0]), xAxis.scale(value[1])],
        _baseValueScale = _ref5[0],
        _currentValueScale = _ref5[1];
      x = _baseValueScale;
      y = (0, _ChartUtils$b.getCateCoordinateOfBar)({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      width = _currentValueScale - _baseValueScale;
      height = pos.size;
      background = {
        x: xAxis.x,
        y: y,
        width: xAxis.width,
        height: height
      };
      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
        var _delta = (0, _DataUtils$g.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
        width += _delta;
      }
    }
    return _objectSpread$m(_objectSpread$m(_objectSpread$m({}, entry), {}, {
      x: x,
      y: y,
      width: width,
      height: height,
      value: stackedData ? value : value[1],
      payload: entry,
      background: background
    }, cells && cells[index] && cells[index].props), {}, {
      tooltipPayload: [(0, _ChartUtils$b.getTooltipItem)(item, entry)],
      tooltipPosition: {
        x: x + width / 2,
        y: y + height / 2
      }
    });
  });
  return _objectSpread$m({
    data: rects,
    layout: layout
  }, offset);
});

Object.defineProperty(CartesianUtils, "__esModule", {
  value: true
});
CartesianUtils.getAngledRectangleWidth = CartesianUtils.formatAxisMap = CartesianUtils.createLabeledScales = CartesianUtils.ScaleHelper = void 0;
CartesianUtils.normalizeAngle = normalizeAngle;
CartesianUtils.rectWithPoints = CartesianUtils.rectWithCoords = void 0;
var _mapValues = _interopRequireDefault$y(mapValues_1);
var _every$1 = _interopRequireDefault$y(every_1);
var _ChartUtils$a = ChartUtils;
var _ReactUtils$f = ReactUtils;
var _DataUtils$f = DataUtils;
var _Bar$2 = Bar$1;
function _interopRequireDefault$y(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$o(o) { "@babel/helpers - typeof"; return _typeof$o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$o(o); }
function _classCallCheck$u(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$o(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$k(descriptor.key), descriptor); } }
function _createClass$u(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$o(Constructor.prototype, protoProps); if (staticProps) _defineProperties$o(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys$n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$n(Object(t), !0).forEach(function (r) { _defineProperty$s(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$s(obj, key, value) { key = _toPropertyKey$k(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$k(t) { var i = _toPrimitive$k(t, "string"); return "symbol" == _typeof$o(i) ? i : i + ""; }
function _toPrimitive$k(t, r) { if ("object" != _typeof$o(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$o(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {String} axisType  The type of axes, x-axis or y-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */
CartesianUtils.formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
    height = props.height,
    layout = props.layout,
    children = props.children;
  var ids = Object.keys(axisMap);
  var steps = {
    left: offset.left,
    leftMirror: offset.left,
    right: width - offset.right,
    rightMirror: width - offset.right,
    top: offset.top,
    topMirror: offset.top,
    bottom: height - offset.bottom,
    bottomMirror: height - offset.bottom
  };
  var hasBar = !!(0, _ReactUtils$f.findChildByType)(children, _Bar$2.Bar);
  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var orientation = axis.orientation,
      domain = axis.domain,
      _axis$padding = axis.padding,
      padding = _axis$padding === void 0 ? {} : _axis$padding,
      mirror = axis.mirror,
      reversed = axis.reversed;
    var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
    var calculatedPadding, range, x, y, needSpace;
    if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
      var diff = domain[1] - domain[0];
      var smallestDistanceBetweenValues = Infinity;
      var sortedValues = axis.categoricalDomain.sort();
      sortedValues.forEach(function (value, index) {
        if (index > 0) {
          smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
        }
      });
      if (Number.isFinite(smallestDistanceBetweenValues)) {
        var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
        var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
        if (axis.padding === 'gap') {
          calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
        }
        if (axis.padding === 'no-gap') {
          var gap = (0, _DataUtils$f.getPercentValue)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
          var halfBand = smallestDistanceInPercent * rangeWidth / 2;
          calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
        }
      }
    }
    if (axisType === 'xAxis') {
      range = [offset.left + (padding.left || 0) + (calculatedPadding || 0), offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)];
    } else if (axisType === 'yAxis') {
      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0) + (calculatedPadding || 0), offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)];
    } else {
      range = axis.range;
    }
    if (reversed) {
      range = [range[1], range[0]];
    }
    var _parseScale = (0, _ChartUtils$a.parseScale)(axis, chartName, hasBar),
      scale = _parseScale.scale,
      realScaleType = _parseScale.realScaleType;
    scale.domain(domain).range(range);
    (0, _ChartUtils$a.checkDomainOfScale)(scale);
    var ticks = (0, _ChartUtils$a.getTicksOfScale)(scale, _objectSpread$l(_objectSpread$l({}, axis), {}, {
      realScaleType: realScaleType
    }));
    if (axisType === 'xAxis') {
      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
      x = offset.left;
      y = steps[offsetKey] - needSpace * axis.height;
    } else if (axisType === 'yAxis') {
      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
      x = steps[offsetKey] - needSpace * axis.width;
      y = offset.top;
    }
    var finalAxis = _objectSpread$l(_objectSpread$l(_objectSpread$l({}, axis), ticks), {}, {
      realScaleType: realScaleType,
      x: x,
      y: y,
      scale: scale,
      width: axisType === 'xAxis' ? offset.width : axis.width,
      height: axisType === 'yAxis' ? offset.height : axis.height
    });
    finalAxis.bandSize = (0, _ChartUtils$a.getBandSizeOfAxis)(finalAxis, ticks);
    if (!axis.hide && axisType === 'xAxis') {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
    } else if (!axis.hide) {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
    }
    return _objectSpread$l(_objectSpread$l({}, result), {}, _defineProperty$s({}, id, finalAxis));
  }, {});
};
var rectWithPoints = CartesianUtils.rectWithPoints = function rectWithPoints(_ref, _ref2) {
  var x1 = _ref.x,
    y1 = _ref.y;
  var x2 = _ref2.x,
    y2 = _ref2.y;
  return {
    x: Math.min(x1, x2),
    y: Math.min(y1, y2),
    width: Math.abs(x2 - x1),
    height: Math.abs(y2 - y1)
  };
};

/**
 * Compute the x, y, width, and height of a box from two reference points.
 * @param  {Object} coords     x1, x2, y1, and y2
 * @return {Object} object
 */
CartesianUtils.rectWithCoords = function rectWithCoords(_ref3) {
  var x1 = _ref3.x1,
    y1 = _ref3.y1,
    x2 = _ref3.x2,
    y2 = _ref3.y2;
  return rectWithPoints({
    x: x1,
    y: y1
  }, {
    x: x2,
    y: y2
  });
};
var ScaleHelper = CartesianUtils.ScaleHelper = /*#__PURE__*/function () {
  function ScaleHelper(scale) {
    _classCallCheck$u(this, ScaleHelper);
    this.scale = scale;
  }
  return _createClass$u(ScaleHelper, [{
    key: "domain",
    get: function get() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function get() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function get() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function get() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function get() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function apply(value) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        bandAware = _ref4.bandAware,
        position = _ref4.position;
      if (value === undefined) {
        return undefined;
      }
      if (position) {
        switch (position) {
          case 'start':
            {
              return this.scale(value);
            }
          case 'middle':
            {
              var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(value) + offset;
            }
          case 'end':
            {
              var _offset = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(value) + _offset;
            }
          default:
            {
              return this.scale(value);
            }
        }
      }
      if (bandAware) {
        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
        return this.scale(value) + _offset2;
      }
      return this.scale(value);
    }
  }, {
    key: "isInRange",
    value: function isInRange(value) {
      var range = this.range();
      var first = range[0];
      var last = range[range.length - 1];
      return first <= last ? value >= first && value <= last : value >= last && value <= first;
    }
  }], [{
    key: "create",
    value: function create(obj) {
      return new ScaleHelper(obj);
    }
  }]);
}();
_defineProperty$s(ScaleHelper, "EPS", 1e-4);
CartesianUtils.createLabeledScales = function createLabeledScales(options) {
  var scales = Object.keys(options).reduce(function (res, key) {
    return _objectSpread$l(_objectSpread$l({}, res), {}, _defineProperty$s({}, key, ScaleHelper.create(options[key])));
  }, {});
  return _objectSpread$l(_objectSpread$l({}, scales), {}, {
    apply: function apply(coord) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        bandAware = _ref5.bandAware,
        position = _ref5.position;
      return (0, _mapValues["default"])(coord, function (value, label) {
        return scales[label].apply(value, {
          bandAware: bandAware,
          position: position
        });
      });
    },
    isInRange: function isInRange(coord) {
      return (0, _every$1["default"])(coord, function (value, label) {
        return scales[label].isInRange(value);
      });
    }
  });
};

/** Normalizes the angle so that 0 <= angle < 180.
 * @param {number} angle Angle in degrees.
 * @return {number} the normalized angle with a value of at least 0 and never greater or equal to 180. */
function normalizeAngle(angle) {
  return (angle % 180 + 180) % 180;
}

/** Calculates the width of the largest horizontal line that fits inside a rectangle that is displayed at an angle.
 * @param {Object} size Width and height of the text in a horizontal position.
 * @param {number} angle Angle in degrees in which the text is displayed.
 * @return {number} The width of the largest horizontal line that fits inside a rectangle that is displayed at an angle.
 */
CartesianUtils.getAngledRectangleWidth = function getAngledRectangleWidth(_ref6) {
  var width = _ref6.width,
    height = _ref6.height;
  var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Ensure angle is >= 0 && < 180
  var normalizedAngle = normalizeAngle(angle);
  var angleRadians = normalizedAngle * Math.PI / 180;

  /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */
  var angleThreshold = Math.atan(height / width);
  var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
  return Math.abs(angledWidth);
};

var chartLayoutContext = {};

var baseIteratee$2 = _baseIteratee,
    isArrayLike$2 = isArrayLike_1,
    keys = keys_1;

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind$1(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike$2(collection)) {
      var iteratee = baseIteratee$2(predicate);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind$1;

var toFinite = toFinite_1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$1(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$1;

var baseFindIndex = _baseFindIndex,
    baseIteratee$1 = _baseIteratee,
    toInteger = toInteger_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex$2(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee$1(predicate), index);
}

var findIndex_1 = findIndex$2;

var createFind = _createFind,
    findIndex$1 = findIndex_1;

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex$1);

var find_1 = find;

var calculateViewBox = {};

Object.defineProperty(calculateViewBox, "__esModule", {
  value: true
});
calculateViewBox.calculateViewBox = void 0;
var _memoize = _interopRequireDefault$x(memoize_1);
function _interopRequireDefault$x(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * This is memoized because the viewBox is unlikely to change often
 * - but because it is computed from offset, any change to it would re-render all children.
 *
 * And because we have many readers of the viewBox, and update it only rarely,
 * then let's optimize with memoization.
 */
calculateViewBox.calculateViewBox = (0, _memoize["default"])(function (offset) {
  return {
    x: offset.left,
    y: offset.top,
    width: offset.width,
    height: offset.height
  };
}, function (offset) {
  return ['l', offset.left, 't', offset.top, 'w', offset.width, 'h', offset.height].join('');
});

Object.defineProperty(chartLayoutContext, "__esModule", {
  value: true
});
chartLayoutContext.useYAxisWithFiniteDomainOrRandom = chartLayoutContext.useYAxisOrThrow = chartLayoutContext.useXAxisOrThrow = chartLayoutContext.useViewBox = chartLayoutContext.useOffset = chartLayoutContext.useClipPathId = chartLayoutContext.useChartWidth = chartLayoutContext.useChartHeight = chartLayoutContext.useArbitraryYAxis = chartLayoutContext.useArbitraryXAxis = chartLayoutContext.YAxisContext = chartLayoutContext.XAxisContext = chartLayoutContext.ViewBoxContext = chartLayoutContext.OffsetContext = chartLayoutContext.ClipPathIdContext = chartLayoutContext.ChartWidthContext = chartLayoutContext.ChartLayoutContextProvider = chartLayoutContext.ChartHeightContext = void 0;
var _react$q = _interopRequireWildcard$9(React__default$4);
var _tinyInvariant$1 = _interopRequireDefault$w(tinyInvariant_cjs);
var _find = _interopRequireDefault$w(find_1);
var _every = _interopRequireDefault$w(every_1);
var _calculateViewBox = calculateViewBox;
var _DataUtils$e = DataUtils;
function _interopRequireDefault$w(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$9(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$9 = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$9(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$n(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$9(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$n(o) { "@babel/helpers - typeof"; return _typeof$n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$n(o); }
var XAxisContext = chartLayoutContext.XAxisContext = /*#__PURE__*/(0, _react$q.createContext)(undefined);
var YAxisContext = chartLayoutContext.YAxisContext = /*#__PURE__*/(0, _react$q.createContext)(undefined);
var ViewBoxContext = chartLayoutContext.ViewBoxContext = /*#__PURE__*/(0, _react$q.createContext)(undefined);
var OffsetContext = chartLayoutContext.OffsetContext = /*#__PURE__*/(0, _react$q.createContext)({});
var ClipPathIdContext = chartLayoutContext.ClipPathIdContext = /*#__PURE__*/(0, _react$q.createContext)(undefined);
var ChartHeightContext = chartLayoutContext.ChartHeightContext = /*#__PURE__*/(0, _react$q.createContext)(0);
var ChartWidthContext = chartLayoutContext.ChartWidthContext = /*#__PURE__*/(0, _react$q.createContext)(0);

/**
 * Will add all the properties required to render all individual Recharts components into a React Context.
 *
 * If you want to read these properties, see the collection of hooks exported from this file.
 *
 * @param {object} props CategoricalChartState, plus children
 * @returns {ReactElement} React Context Provider
 */
chartLayoutContext.ChartLayoutContextProvider = function ChartLayoutContextProvider(props) {
  var _props$state = props.state,
    xAxisMap = _props$state.xAxisMap,
    yAxisMap = _props$state.yAxisMap,
    offset = _props$state.offset,
    clipPathId = props.clipPathId,
    children = props.children,
    width = props.width,
    height = props.height;

  /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */
  var viewBox = (0, _calculateViewBox.calculateViewBox)(offset);

  /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */
  return /*#__PURE__*/_react$q["default"].createElement(XAxisContext.Provider, {
    value: xAxisMap
  }, /*#__PURE__*/_react$q["default"].createElement(YAxisContext.Provider, {
    value: yAxisMap
  }, /*#__PURE__*/_react$q["default"].createElement(OffsetContext.Provider, {
    value: offset
  }, /*#__PURE__*/_react$q["default"].createElement(ViewBoxContext.Provider, {
    value: viewBox
  }, /*#__PURE__*/_react$q["default"].createElement(ClipPathIdContext.Provider, {
    value: clipPathId
  }, /*#__PURE__*/_react$q["default"].createElement(ChartHeightContext.Provider, {
    value: height
  }, /*#__PURE__*/_react$q["default"].createElement(ChartWidthContext.Provider, {
    value: width
  }, children)))))));
};
chartLayoutContext.useClipPathId = function useClipPathId() {
  return (0, _react$q.useContext)(ClipPathIdContext);
};
function getKeysForDebug(object) {
  var keys = Object.keys(object);
  if (keys.length === 0) {
    return 'There are no available ids.';
  }
  return "Available ids are: ".concat(keys, ".");
}

/**
 * This either finds and returns Axis by the specified ID, or throws an exception if an axis with this ID does not exist.
 *
 * @param xAxisId identifier of the axis - it's either autogenerated ('0'), or passed via `id` prop as <XAxis id='foo' />
 * @returns axis configuration object
 * @throws Error if no axis with this ID exists
 */
chartLayoutContext.useXAxisOrThrow = function useXAxisOrThrow(xAxisId) {
  var xAxisMap = (0, _react$q.useContext)(XAxisContext);
  !(xAxisMap != null) ? process.env.NODE_ENV !== "production" ? (0, _tinyInvariant$1["default"])(false, 'Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?') : (0, _tinyInvariant$1["default"])(false) : void 0;
  var xAxis = xAxisMap[xAxisId];
  !(xAxis != null) ? process.env.NODE_ENV !== "production" ? (0, _tinyInvariant$1["default"])(false, "Could not find xAxis by id \"".concat(xAxisId, "\" [").concat(_typeof$n(xAxisId), "]. ").concat(getKeysForDebug(xAxisMap))) : (0, _tinyInvariant$1["default"])(false) : void 0;
  return xAxis;
};

/**
 * This will find an arbitrary first XAxis. If there's exactly one it always returns that one
 * - but if there are multiple then it can return any of those.
 *
 * If you want specific XAxis out of multiple then prefer using useXAxisOrThrow
 *
 * @returns X axisOptions, or undefined - if there are no X axes
 */
chartLayoutContext.useArbitraryXAxis = function useArbitraryXAxis() {
  var xAxisMap = (0, _react$q.useContext)(XAxisContext);
  return (0, _DataUtils$e.getAnyElementOfObject)(xAxisMap);
};

/**
 * This will find an arbitrary first YAxis. If there's exactly one it always returns that one
 * - but if there are multiple then it can return any of those.
 *
 * If you want specific YAxis out of multiple then prefer using useXAxisOrThrow
 *
 * @returns Y axisOptions, or undefined - if there are no Y axes
 */
chartLayoutContext.useArbitraryYAxis = function useArbitraryYAxis() {
  var yAxisMap = (0, _react$q.useContext)(YAxisContext);
  return (0, _DataUtils$e.getAnyElementOfObject)(yAxisMap);
};

/**
 * This hooks will:
 * 1st attempt to find an YAxis that has all elements in its domain finite
 * If no such axis exists, it will return an arbitrary YAxis
 * if there are no Y axes then it returns undefined
 *
 * @returns Either Y axisOptions, or undefined if there are no Y axes
 */
chartLayoutContext.useYAxisWithFiniteDomainOrRandom = function useYAxisWithFiniteDomainOrRandom() {
  var yAxisMap = (0, _react$q.useContext)(YAxisContext);
  var yAxisWithFiniteDomain = (0, _find["default"])(yAxisMap, function (axis) {
    return (0, _every["default"])(axis.domain, Number.isFinite);
  });
  return yAxisWithFiniteDomain || (0, _DataUtils$e.getAnyElementOfObject)(yAxisMap);
};

/**
 * This either finds and returns Axis by the specified ID, or throws an exception if an axis with this ID does not exist.
 *
 * @param yAxisId identifier of the axis - it's either autogenerated ('0'), or passed via `id` prop as <YAxis id='foo' />
 * @returns axis configuration object
 * @throws Error if no axis with this ID exists
 */
chartLayoutContext.useYAxisOrThrow = function useYAxisOrThrow(yAxisId) {
  var yAxisMap = (0, _react$q.useContext)(YAxisContext);
  !(yAxisMap != null) ? process.env.NODE_ENV !== "production" ? (0, _tinyInvariant$1["default"])(false, 'Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?') : (0, _tinyInvariant$1["default"])(false) : void 0;
  var yAxis = yAxisMap[yAxisId];
  !(yAxis != null) ? process.env.NODE_ENV !== "production" ? (0, _tinyInvariant$1["default"])(false, "Could not find yAxis by id \"".concat(yAxisId, "\" [").concat(_typeof$n(yAxisId), "]. ").concat(getKeysForDebug(yAxisMap))) : (0, _tinyInvariant$1["default"])(false) : void 0;
  return yAxis;
};
chartLayoutContext.useViewBox = function useViewBox() {
  var viewBox = (0, _react$q.useContext)(ViewBoxContext);
  return viewBox;
};
chartLayoutContext.useOffset = function useOffset() {
  return (0, _react$q.useContext)(OffsetContext);
};
chartLayoutContext.useChartWidth = function useChartWidth() {
  return (0, _react$q.useContext)(ChartWidthContext);
};
chartLayoutContext.useChartHeight = function useChartHeight() {
  return (0, _react$q.useContext)(ChartHeightContext);
};

function _typeof$m(o) { "@babel/helpers - typeof"; return _typeof$m = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$m(o); }
Object.defineProperty(ReferenceLine$1, "__esModule", {
  value: true
});
ReferenceLine$1.getEndPoints = ReferenceLine$1.ReferenceLine = void 0;
var _react$p = _interopRequireDefault$v(React__default$4);
var _isFunction$c = _interopRequireDefault$v(isFunction_1);
var _some = _interopRequireDefault$v(some_1);
var _clsx$e = _interopRequireDefault$v(clsx.exports);
var _Layer$b = Layer;
var _Label$3 = Label$1;
var _IfOverflowMatches$3 = IfOverflowMatches;
var _DataUtils$d = DataUtils;
var _CartesianUtils$8 = CartesianUtils;
var _LogUtils$3 = LogUtils;
var _ReactUtils$e = ReactUtils;
var _chartLayoutContext$4 = chartLayoutContext;
function _interopRequireDefault$v(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck$t(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$n(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$j(descriptor.key), descriptor); } }
function _createClass$t(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$n(Constructor.prototype, protoProps); if (staticProps) _defineProperties$n(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$d(t, o, e) { return o = _getPrototypeOf$e(o), _possibleConstructorReturn$k(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf$e(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$k(self, call) { if (call && (_typeof$m(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$e(self); }
function _assertThisInitialized$e(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$e() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$e = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$e(o) { _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$e(o); }
function _inherits$k(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$e(subClass, superClass); }
function _setPrototypeOf$e(o, p) { _setPrototypeOf$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$e(o, p); }
function ownKeys$m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$m(Object(t), !0).forEach(function (r) { _defineProperty$r(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$r(obj, key, value) { key = _toPropertyKey$j(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$j(t) { var i = _toPrimitive$j(t, "string"); return "symbol" == _typeof$m(i) ? i : i + ""; }
function _toPrimitive$j(t, r) { if ("object" != _typeof$m(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$m(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray$9(arr, i) { return _arrayWithHoles$7(arr) || _iterableToArrayLimit$7(arr, i) || _unsupportedIterableToArray$i(arr, i) || _nonIterableRest$7(); }
function _nonIterableRest$7() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$i(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$i(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$i(o, minLen); }
function _arrayLikeToArray$i(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$7(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$7(arr) { if (Array.isArray(arr)) return arr; }
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); } /**
 * @fileOverview Reference Line
 */
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */

var renderLine = function renderLine(option, props) {
  var line;
  if ( /*#__PURE__*/_react$p["default"].isValidElement(option)) {
    line = /*#__PURE__*/_react$p["default"].cloneElement(option, props);
  } else if ((0, _isFunction$c["default"])(option)) {
    line = option(props);
  } else {
    line = /*#__PURE__*/_react$p["default"].createElement("line", _extends$m({}, props, {
      className: "recharts-reference-line-line"
    }));
  }
  return line;
};
// TODO: ScaleHelper
var getEndPoints = ReferenceLine$1.getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
  var x = viewBox.x,
    y = viewBox.y,
    width = viewBox.width,
    height = viewBox.height;
  if (isFixedY) {
    var yCoord = props.y;
    var coord = scales.y.apply(yCoord, {
      position: position
    });
    if ((0, _IfOverflowMatches$3.ifOverflowMatches)(props, 'discard') && !scales.y.isInRange(coord)) {
      return null;
    }
    var points = [{
      x: x + width,
      y: coord
    }, {
      x: x,
      y: coord
    }];
    return yAxisOrientation === 'left' ? points.reverse() : points;
  }
  if (isFixedX) {
    var xCoord = props.x;
    var _coord = scales.x.apply(xCoord, {
      position: position
    });
    if ((0, _IfOverflowMatches$3.ifOverflowMatches)(props, 'discard') && !scales.x.isInRange(_coord)) {
      return null;
    }
    var _points = [{
      x: _coord,
      y: y + height
    }, {
      x: _coord,
      y: y
    }];
    return xAxisOrientation === 'top' ? _points.reverse() : _points;
  }
  if (isSegment) {
    var segment = props.segment;
    var _points2 = segment.map(function (p) {
      return scales.apply(p, {
        position: position
      });
    });
    if ((0, _IfOverflowMatches$3.ifOverflowMatches)(props, 'discard') && (0, _some["default"])(_points2, function (p) {
      return !scales.isInRange(p);
    })) {
      return null;
    }
    return _points2;
  }
  return null;
};
function ReferenceLineImpl(props) {
  var fixedX = props.x,
    fixedY = props.y,
    segment = props.segment,
    xAxisId = props.xAxisId,
    yAxisId = props.yAxisId,
    shape = props.shape,
    className = props.className,
    alwaysShow = props.alwaysShow;
  var clipPathId = (0, _chartLayoutContext$4.useClipPathId)();
  var xAxis = (0, _chartLayoutContext$4.useXAxisOrThrow)(xAxisId);
  var yAxis = (0, _chartLayoutContext$4.useYAxisOrThrow)(yAxisId);
  var viewBox = (0, _chartLayoutContext$4.useViewBox)();
  if (!clipPathId || !viewBox) {
    return null;
  }
  (0, _LogUtils$3.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var scales = (0, _CartesianUtils$8.createLabeledScales)({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var isX = (0, _DataUtils$d.isNumOrStr)(fixedX);
  var isY = (0, _DataUtils$d.isNumOrStr)(fixedY);
  var isSegment = segment && segment.length === 2;
  var endPoints = getEndPoints(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
  if (!endPoints) {
    return null;
  }
  var _endPoints = _slicedToArray$9(endPoints, 2),
    _endPoints$ = _endPoints[0],
    x1 = _endPoints$.x,
    y1 = _endPoints$.y,
    _endPoints$2 = _endPoints[1],
    x2 = _endPoints$2.x,
    y2 = _endPoints$2.y;
  var clipPath = (0, _IfOverflowMatches$3.ifOverflowMatches)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
  var lineProps = _objectSpread$k(_objectSpread$k({
    clipPath: clipPath
  }, (0, _ReactUtils$e.filterProps)(props, true)), {}, {
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2
  });
  return /*#__PURE__*/_react$p["default"].createElement(_Layer$b.Layer, {
    className: (0, _clsx$e["default"])('recharts-reference-line', className)
  }, renderLine(shape, lineProps), _Label$3.Label.renderCallByParent(props, (0, _CartesianUtils$8.rectWithCoords)({
    x1: x1,
    y1: y1,
    x2: x2,
    y2: y2
  })));
}

// eslint-disable-next-line react/prefer-stateless-function -- requires static defaultProps
var ReferenceLine = ReferenceLine$1.ReferenceLine = /*#__PURE__*/function (_React$Component) {
  function ReferenceLine() {
    _classCallCheck$t(this, ReferenceLine);
    return _callSuper$d(this, ReferenceLine, arguments);
  }
  _inherits$k(ReferenceLine, _React$Component);
  return _createClass$t(ReferenceLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react$p["default"].createElement(ReferenceLineImpl, this.props);
    }
  }]);
}(_react$p["default"].Component);
_defineProperty$r(ReferenceLine, "displayName", 'ReferenceLine');
_defineProperty$r(ReferenceLine, "defaultProps", {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  fill: 'none',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1,
  position: 'middle'
});

var ReferenceDot$1 = {};

Object.defineProperty(ReferenceDot$1, "__esModule", {
  value: true
});
ReferenceDot$1.ReferenceDot = void 0;
var _react$o = _interopRequireDefault$u(React__default$4);
var _isFunction$b = _interopRequireDefault$u(isFunction_1);
var _clsx$d = _interopRequireDefault$u(clsx.exports);
var _Layer$a = Layer;
var _Dot$3 = Dot;
var _Label$2 = Label$1;
var _DataUtils$c = DataUtils;
var _IfOverflowMatches$2 = IfOverflowMatches;
var _CartesianUtils$7 = CartesianUtils;
var _LogUtils$2 = LogUtils;
var _ReactUtils$d = ReactUtils;
function _interopRequireDefault$u(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
function _typeof$l(o) { "@babel/helpers - typeof"; return _typeof$l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$l(o); }
function ownKeys$l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$l(Object(t), !0).forEach(function (r) { _defineProperty$q(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$s(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$m(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$i(descriptor.key), descriptor); } }
function _createClass$s(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$m(Constructor.prototype, protoProps); if (staticProps) _defineProperties$m(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$c(t, o, e) { return o = _getPrototypeOf$d(o), _possibleConstructorReturn$j(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf$d(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$j(self, call) { if (call && (_typeof$l(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$d(self); }
function _assertThisInitialized$d(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$d() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$d(o) { _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$d(o); }
function _inherits$j(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$d(subClass, superClass); }
function _setPrototypeOf$d(o, p) { _setPrototypeOf$d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$d(o, p); }
function _defineProperty$q(obj, key, value) { key = _toPropertyKey$i(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$i(t) { var i = _toPrimitive$i(t, "string"); return "symbol" == _typeof$l(i) ? i : i + ""; }
function _toPrimitive$i(t, r) { if ("object" != _typeof$l(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$l(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Reference Dot
 */
var getCoordinate = function getCoordinate(props) {
  var x = props.x,
    y = props.y,
    xAxis = props.xAxis,
    yAxis = props.yAxis;
  var scales = (0, _CartesianUtils$7.createLabeledScales)({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var result = scales.apply({
    x: x,
    y: y
  }, {
    bandAware: true
  });
  if ((0, _IfOverflowMatches$2.ifOverflowMatches)(props, 'discard') && !scales.isInRange(result)) {
    return null;
  }
  return result;
};

// eslint-disable-next-line react/prefer-stateless-function -- requires static defaultProps
var ReferenceDot = ReferenceDot$1.ReferenceDot = /*#__PURE__*/function (_React$Component) {
  function ReferenceDot() {
    _classCallCheck$s(this, ReferenceDot);
    return _callSuper$c(this, ReferenceDot, arguments);
  }
  _inherits$j(ReferenceDot, _React$Component);
  return _createClass$s(ReferenceDot, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        x = _this$props.x,
        y = _this$props.y,
        r = _this$props.r,
        alwaysShow = _this$props.alwaysShow,
        clipPathId = _this$props.clipPathId;
      var isX = (0, _DataUtils$c.isNumOrStr)(x);
      var isY = (0, _DataUtils$c.isNumOrStr)(y);
      (0, _LogUtils$2.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      if (!isX || !isY) {
        return null;
      }
      var coordinate = getCoordinate(this.props);
      if (!coordinate) {
        return null;
      }
      var cx = coordinate.x,
        cy = coordinate.y;
      var _this$props2 = this.props,
        shape = _this$props2.shape,
        className = _this$props2.className;
      var clipPath = (0, _IfOverflowMatches$2.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
      var dotProps = _objectSpread$j(_objectSpread$j({
        clipPath: clipPath
      }, (0, _ReactUtils$d.filterProps)(this.props, true)), {}, {
        cx: cx,
        cy: cy
      });
      return /*#__PURE__*/_react$o["default"].createElement(_Layer$a.Layer, {
        className: (0, _clsx$d["default"])('recharts-reference-dot', className)
      }, ReferenceDot.renderDot(shape, dotProps), _Label$2.Label.renderCallByParent(this.props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
      }));
    }
  }]);
}(_react$o["default"].Component);
_defineProperty$q(ReferenceDot, "displayName", 'ReferenceDot');
_defineProperty$q(ReferenceDot, "defaultProps", {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#fff',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1
});
_defineProperty$q(ReferenceDot, "renderDot", function (option, props) {
  var dot;
  if ( /*#__PURE__*/_react$o["default"].isValidElement(option)) {
    dot = /*#__PURE__*/_react$o["default"].cloneElement(option, props);
  } else if ((0, _isFunction$b["default"])(option)) {
    dot = option(props);
  } else {
    dot = /*#__PURE__*/_react$o["default"].createElement(_Dot$3.Dot, _extends$l({}, props, {
      cx: props.cx,
      cy: props.cy,
      className: "recharts-reference-dot-dot"
    }));
  }
  return dot;
});

var ReferenceArea$1 = {};

Object.defineProperty(ReferenceArea$1, "__esModule", {
  value: true
});
ReferenceArea$1.ReferenceArea = void 0;
var _react$n = _interopRequireDefault$t(React__default$4);
var _isFunction$a = _interopRequireDefault$t(isFunction_1);
var _clsx$c = _interopRequireDefault$t(clsx.exports);
var _Layer$9 = Layer;
var _Label$1 = Label$1;
var _CartesianUtils$6 = CartesianUtils;
var _IfOverflowMatches$1 = IfOverflowMatches;
var _DataUtils$b = DataUtils;
var _LogUtils$1 = LogUtils;
var _Rectangle$4 = Rectangle;
var _ReactUtils$c = ReactUtils;
function _interopRequireDefault$t(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
function _typeof$k(o) { "@babel/helpers - typeof"; return _typeof$k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$k(o); }
function ownKeys$k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$k(Object(t), !0).forEach(function (r) { _defineProperty$p(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$r(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$l(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$h(descriptor.key), descriptor); } }
function _createClass$r(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$l(Constructor.prototype, protoProps); if (staticProps) _defineProperties$l(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$b(t, o, e) { return o = _getPrototypeOf$c(o), _possibleConstructorReturn$i(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf$c(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$i(self, call) { if (call && (_typeof$k(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$c(self); }
function _assertThisInitialized$c(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$c() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$c(o) { _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$c(o); }
function _inherits$i(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$c(subClass, superClass); }
function _setPrototypeOf$c(o, p) { _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$c(o, p); }
function _defineProperty$p(obj, key, value) { key = _toPropertyKey$h(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$h(t) { var i = _toPrimitive$h(t, "string"); return "symbol" == _typeof$k(i) ? i : i + ""; }
function _toPrimitive$h(t, r) { if ("object" != _typeof$k(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$k(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Reference Line
 */
var getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
  var xValue1 = props.x1,
    xValue2 = props.x2,
    yValue1 = props.y1,
    yValue2 = props.y2,
    xAxis = props.xAxis,
    yAxis = props.yAxis;
  if (!xAxis || !yAxis) return null;
  var scales = (0, _CartesianUtils$6.createLabeledScales)({
    x: xAxis.scale,
    y: yAxis.scale
  });
  var p1 = {
    x: hasX1 ? scales.x.apply(xValue1, {
      position: 'start'
    }) : scales.x.rangeMin,
    y: hasY1 ? scales.y.apply(yValue1, {
      position: 'start'
    }) : scales.y.rangeMin
  };
  var p2 = {
    x: hasX2 ? scales.x.apply(xValue2, {
      position: 'end'
    }) : scales.x.rangeMax,
    y: hasY2 ? scales.y.apply(yValue2, {
      position: 'end'
    }) : scales.y.rangeMax
  };
  if ((0, _IfOverflowMatches$1.ifOverflowMatches)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) {
    return null;
  }
  return (0, _CartesianUtils$6.rectWithPoints)(p1, p2);
};

// eslint-disable-next-line react/prefer-stateless-function -- requires static defaultProps
var ReferenceArea = ReferenceArea$1.ReferenceArea = /*#__PURE__*/function (_React$Component) {
  function ReferenceArea() {
    _classCallCheck$r(this, ReferenceArea);
    return _callSuper$b(this, ReferenceArea, arguments);
  }
  _inherits$i(ReferenceArea, _React$Component);
  return _createClass$r(ReferenceArea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        x1 = _this$props.x1,
        x2 = _this$props.x2,
        y1 = _this$props.y1,
        y2 = _this$props.y2,
        className = _this$props.className,
        alwaysShow = _this$props.alwaysShow,
        clipPathId = _this$props.clipPathId;
      (0, _LogUtils$1.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var hasX1 = (0, _DataUtils$b.isNumOrStr)(x1);
      var hasX2 = (0, _DataUtils$b.isNumOrStr)(x2);
      var hasY1 = (0, _DataUtils$b.isNumOrStr)(y1);
      var hasY2 = (0, _DataUtils$b.isNumOrStr)(y2);
      var shape = this.props.shape;
      if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
        return null;
      }
      var rect = getRect(hasX1, hasX2, hasY1, hasY2, this.props);
      if (!rect && !shape) {
        return null;
      }
      var clipPath = (0, _IfOverflowMatches$1.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
      return /*#__PURE__*/_react$n["default"].createElement(_Layer$9.Layer, {
        className: (0, _clsx$c["default"])('recharts-reference-area', className)
      }, ReferenceArea.renderRect(shape, _objectSpread$i(_objectSpread$i({
        clipPath: clipPath
      }, (0, _ReactUtils$c.filterProps)(this.props, true)), rect)), _Label$1.Label.renderCallByParent(this.props, rect));
    }
  }]);
}(_react$n["default"].Component);
_defineProperty$p(ReferenceArea, "displayName", 'ReferenceArea');
_defineProperty$p(ReferenceArea, "defaultProps", {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#ccc',
  fillOpacity: 0.5,
  stroke: 'none',
  strokeWidth: 1
});
_defineProperty$p(ReferenceArea, "renderRect", function (option, props) {
  var rect;
  if ( /*#__PURE__*/_react$n["default"].isValidElement(option)) {
    rect = /*#__PURE__*/_react$n["default"].cloneElement(option, props);
  } else if ((0, _isFunction$a["default"])(option)) {
    rect = option(props);
  } else {
    rect = /*#__PURE__*/_react$n["default"].createElement(_Rectangle$4.Rectangle, _extends$k({}, props, {
      className: "recharts-reference-area-rect"
    }));
  }
  return rect;
});

var CartesianAxis$1 = {};

var getTicks$1 = {};

var TickUtils = {};

var getEveryNthWithCondition$1 = {};

Object.defineProperty(getEveryNthWithCondition$1, "__esModule", {
  value: true
});
getEveryNthWithCondition$1.getEveryNthWithCondition = getEveryNthWithCondition;
/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */
function getEveryNthWithCondition(array, n, isValid) {
  if (n < 1) {
    return [];
  }
  if (n === 1 && isValid === undefined) {
    return array;
  }
  var result = [];
  for (var i = 0; i < array.length; i += n) {
    if (isValid === undefined || isValid(array[i]) === true) {
      result.push(array[i]);
    } else {
      return undefined;
    }
  }
  return result;
}

Object.defineProperty(TickUtils, "__esModule", {
  value: true
});
TickUtils.getAngledTickWidth = getAngledTickWidth;
TickUtils.getNumberIntervalTicks = getNumberIntervalTicks;
TickUtils.getTickBoundaries = getTickBoundaries;
TickUtils.isVisible = isVisible;
var _CartesianUtils$5 = CartesianUtils;
var _getEveryNthWithCondition$1 = getEveryNthWithCondition$1;
function getAngledTickWidth(contentSize, unitSize, angle) {
  var size = {
    width: contentSize.width + unitSize.width,
    height: contentSize.height + unitSize.height
  };
  return (0, _CartesianUtils$5.getAngledRectangleWidth)(size, angle);
}
function getTickBoundaries(viewBox, sign, sizeKey) {
  var isWidth = sizeKey === 'width';
  var x = viewBox.x,
    y = viewBox.y,
    width = viewBox.width,
    height = viewBox.height;
  if (sign === 1) {
    return {
      start: isWidth ? x : y,
      end: isWidth ? x + width : y + height
    };
  }
  return {
    start: isWidth ? x + width : y + height,
    end: isWidth ? x : y
  };
}
function isVisible(sign, tickPosition, getSize, start, end) {
  /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */
  if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) {
    return false;
  }
  var size = getSize();
  return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function getNumberIntervalTicks(ticks, interval) {
  return (0, _getEveryNthWithCondition$1.getEveryNthWithCondition)(ticks, interval + 1);
}

var getEquidistantTicks$1 = {};

Object.defineProperty(getEquidistantTicks$1, "__esModule", {
  value: true
});
getEquidistantTicks$1.getEquidistantTicks = getEquidistantTicks;
var _TickUtils$1 = TickUtils;
var _getEveryNthWithCondition = getEveryNthWithCondition$1;
function getEquidistantTicks(sign, boundaries, getTickSize, ticks, minTickGap) {
  var result = (ticks || []).slice();
  var initialStart = boundaries.start,
    end = boundaries.end;
  var index = 0;
  // Premature optimisation idea 1: Estimate a lower bound, and start from there.
  // For now, start from every tick
  var stepsize = 1;
  var start = initialStart;
  var _loop = function _loop() {
      // Given stepsize, evaluate whether every stepsize-th tick can be shown.
      // If it can not, then increase the stepsize by 1, and try again.

      var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];

      // Break condition - If we have evaluate all the ticks, then we are done.
      if (entry === undefined) {
        return {
          v: (0, _getEveryNthWithCondition.getEveryNthWithCondition)(ticks, stepsize)
        };
      }

      // Check if the element collides with the next element
      var i = index;
      var size;
      var getSize = function getSize() {
        if (size === undefined) {
          size = getTickSize(entry, i);
        }
        return size;
      };
      var tickCoord = entry.coordinate;
      // We will always show the first tick.
      var isShow = index === 0 || (0, _TickUtils$1.isVisible)(sign, tickCoord, getSize, start, end);
      if (!isShow) {
        // Start all over with a larger stepsize
        index = 0;
        start = initialStart;
        stepsize += 1;
      }
      if (isShow) {
        // If it can be shown, update the start
        start = tickCoord + sign * (getSize() / 2 + minTickGap);
        index += stepsize;
      }
    },
    _ret;
  while (stepsize <= result.length) {
    _ret = _loop();
    if (_ret) return _ret.v;
  }
  return [];
}

Object.defineProperty(getTicks$1, "__esModule", {
  value: true
});
getTicks$1.getTicks = getTicks;
var _isFunction$9 = _interopRequireDefault$s(isFunction_1);
var _DataUtils$a = DataUtils;
var _DOMUtils$2 = DOMUtils;
var _Global$5 = Global$1;
var _TickUtils = TickUtils;
var _getEquidistantTicks = getEquidistantTicks$1;
function _interopRequireDefault$s(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$j(o) { "@babel/helpers - typeof"; return _typeof$j = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$j(o); }
function ownKeys$j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$j(Object(t), !0).forEach(function (r) { _defineProperty$o(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$o(obj, key, value) { key = _toPropertyKey$g(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$g(t) { var i = _toPrimitive$g(t, "string"); return "symbol" == _typeof$j(i) ? i : i + ""; }
function _toPrimitive$g(t, r) { if ("object" != _typeof$j(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$j(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
  var result = (ticks || []).slice();
  var len = result.length;
  var start = boundaries.start;
  var end = boundaries.end;
  var _loop = function _loop(i) {
    var entry = result[i];
    var size;
    var getSize = function getSize() {
      if (size === undefined) {
        size = getTickSize(entry, i);
      }
      return size;
    };
    if (i === len - 1) {
      var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
      result[i] = entry = _objectSpread$h(_objectSpread$h({}, entry), {}, {
        tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
      });
    } else {
      result[i] = entry = _objectSpread$h(_objectSpread$h({}, entry), {}, {
        tickCoord: entry.coordinate
      });
    }
    var isShow = (0, _TickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
    if (isShow) {
      end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
      result[i] = _objectSpread$h(_objectSpread$h({}, entry), {}, {
        isShow: true
      });
    }
  };
  for (var i = len - 1; i >= 0; i--) {
    _loop(i);
  }
  return result;
}
function getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
  var result = (ticks || []).slice();
  var len = result.length;
  var start = boundaries.start,
    end = boundaries.end;
  if (preserveEnd) {
    // Try to guarantee the tail to be displayed
    var tail = ticks[len - 1];
    var tailSize = getTickSize(tail, len - 1);
    var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
    result[len - 1] = tail = _objectSpread$h(_objectSpread$h({}, tail), {}, {
      tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
    });
    var isTailShow = (0, _TickUtils.isVisible)(sign, tail.tickCoord, function () {
      return tailSize;
    }, start, end);
    if (isTailShow) {
      end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
      result[len - 1] = _objectSpread$h(_objectSpread$h({}, tail), {}, {
        isShow: true
      });
    }
  }
  var count = preserveEnd ? len - 1 : len;
  var _loop2 = function _loop2(i) {
    var entry = result[i];
    var size;
    var getSize = function getSize() {
      if (size === undefined) {
        size = getTickSize(entry, i);
      }
      return size;
    };
    if (i === 0) {
      var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
      result[i] = entry = _objectSpread$h(_objectSpread$h({}, entry), {}, {
        tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
      });
    } else {
      result[i] = entry = _objectSpread$h(_objectSpread$h({}, entry), {}, {
        tickCoord: entry.coordinate
      });
    }
    var isShow = (0, _TickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
    if (isShow) {
      start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
      result[i] = _objectSpread$h(_objectSpread$h({}, entry), {}, {
        isShow: true
      });
    }
  };
  for (var i = 0; i < count; i++) {
    _loop2(i);
  }
  return result;
}
function getTicks(props, fontSize, letterSpacing) {
  var tick = props.tick,
    ticks = props.ticks,
    viewBox = props.viewBox,
    minTickGap = props.minTickGap,
    orientation = props.orientation,
    interval = props.interval,
    tickFormatter = props.tickFormatter,
    unit = props.unit,
    angle = props.angle;
  if (!ticks || !ticks.length || !tick) {
    return [];
  }
  if ((0, _DataUtils$a.isNumber)(interval) || _Global$5.Global.isSsr) {
    return (0, _TickUtils.getNumberIntervalTicks)(ticks, typeof interval === 'number' && (0, _DataUtils$a.isNumber)(interval) ? interval : 0);
  }
  var candidates = [];
  var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
  var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils$2.getStringSize)(unit, {
    fontSize: fontSize,
    letterSpacing: letterSpacing
  }) : {
    width: 0,
    height: 0
  };
  var getTickSize = function getTickSize(content, index) {
    var value = (0, _isFunction$9["default"])(tickFormatter) ? tickFormatter(content.value, index) : content.value;
    // Recharts only supports angles when sizeKey === 'width'
    return sizeKey === 'width' ? (0, _TickUtils.getAngledTickWidth)((0, _DOMUtils$2.getStringSize)(value, {
      fontSize: fontSize,
      letterSpacing: letterSpacing
    }), unitSize, angle) : (0, _DOMUtils$2.getStringSize)(value, {
      fontSize: fontSize,
      letterSpacing: letterSpacing
    })[sizeKey];
  };
  var sign = ticks.length >= 2 ? (0, _DataUtils$a.mathSign)(ticks[1].coordinate - ticks[0].coordinate) : 1;
  var boundaries = (0, _TickUtils.getTickBoundaries)(viewBox, sign, sizeKey);
  if (interval === 'equidistantPreserveStart') {
    return (0, _getEquidistantTicks.getEquidistantTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
  }
  if (interval === 'preserveStart' || interval === 'preserveStartEnd') {
    candidates = getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
  } else {
    candidates = getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
  }
  return candidates.filter(function (entry) {
    return entry.isShow;
  });
}

Object.defineProperty(CartesianAxis$1, "__esModule", {
  value: true
});
CartesianAxis$1.CartesianAxis = void 0;
var _react$m = _interopRequireWildcard$8(React__default$4);
var _isFunction$8 = _interopRequireDefault$r(isFunction_1);
var _get$3 = _interopRequireDefault$r(get_1);
var _clsx$b = _interopRequireDefault$r(clsx.exports);
var _ShallowEqual$2 = ShallowEqual;
var _Layer$8 = Layer;
var _Text$1 = Text;
var _Label = Label$1;
var _DataUtils$9 = DataUtils;
var _types$3 = types;
var _ReactUtils$b = ReactUtils;
var _getTicks$1 = getTicks$1;
var _excluded$8 = ["viewBox"],
  _excluded2$5 = ["viewBox"],
  _excluded3 = ["ticks"];
function _interopRequireDefault$r(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$8(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$8 = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$8(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$i(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$8(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$i(o) { "@babel/helpers - typeof"; return _typeof$i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$i(o); }
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
function ownKeys$i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$i(Object(t), !0).forEach(function (r) { _defineProperty$n(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties$b(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _classCallCheck$q(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$k(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$f(descriptor.key), descriptor); } }
function _createClass$q(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$k(Constructor.prototype, protoProps); if (staticProps) _defineProperties$k(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$a(t, o, e) { return o = _getPrototypeOf$b(o), _possibleConstructorReturn$h(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf$b(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$h(self, call) { if (call && (_typeof$i(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$b(self); }
function _assertThisInitialized$b(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$b() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$b(o) { _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$b(o); }
function _inherits$h(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$b(subClass, superClass); }
function _setPrototypeOf$b(o, p) { _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$b(o, p); }
function _defineProperty$n(obj, key, value) { key = _toPropertyKey$f(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$f(t) { var i = _toPrimitive$f(t, "string"); return "symbol" == _typeof$i(i) ? i : i + ""; }
function _toPrimitive$f(t, r) { if ("object" != _typeof$i(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$i(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Cartesian Axis
 */
/** The orientation of the axis in correspondence to the chart */
/** A unit to be appended to a value */
/** The formatter function of tick */
var CartesianAxis = CartesianAxis$1.CartesianAxis = /*#__PURE__*/function (_Component) {
  function CartesianAxis(props) {
    var _this;
    _classCallCheck$q(this, CartesianAxis);
    _this = _callSuper$a(this, CartesianAxis, [props]);
    _this.state = {
      fontSize: '',
      letterSpacing: ''
    };
    return _this;
  }
  _inherits$h(CartesianAxis, _Component);
  return _createClass$q(CartesianAxis, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref, nextState) {
      var viewBox = _ref.viewBox,
        restProps = _objectWithoutProperties$b(_ref, _excluded$8);
      // props.viewBox is sometimes generated every time -
      // check that specially as object equality is likely to fail
      var _this$props = this.props,
        viewBoxOld = _this$props.viewBox,
        restPropsOld = _objectWithoutProperties$b(_this$props, _excluded2$5);
      return !(0, _ShallowEqual$2.shallowEqual)(viewBox, viewBoxOld) || !(0, _ShallowEqual$2.shallowEqual)(restProps, restPropsOld) || !(0, _ShallowEqual$2.shallowEqual)(nextState, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var htmlLayer = this.layerReference;
      if (!htmlLayer) return;
      var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
      if (tick) {
        this.setState({
          fontSize: window.getComputedStyle(tick).fontSize,
          letterSpacing: window.getComputedStyle(tick).letterSpacing
        });
      }
    }

    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function getTickLineCoord(data) {
      var _this$props2 = this.props,
        x = _this$props2.x,
        y = _this$props2.y,
        width = _this$props2.width,
        height = _this$props2.height,
        orientation = _this$props2.orientation,
        tickSize = _this$props2.tickSize,
        mirror = _this$props2.mirror,
        tickMargin = _this$props2.tickMargin;
      var x1, x2, y1, y2, tx, ty;
      var sign = mirror ? -1 : 1;
      var finalTickSize = data.tickSize || tickSize;
      var tickCoord = (0, _DataUtils$9.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
      switch (orientation) {
        case 'top':
          x1 = x2 = data.coordinate;
          y2 = y + +!mirror * height;
          y1 = y2 - sign * finalTickSize;
          ty = y1 - sign * tickMargin;
          tx = tickCoord;
          break;
        case 'left':
          y1 = y2 = data.coordinate;
          x2 = x + +!mirror * width;
          x1 = x2 - sign * finalTickSize;
          tx = x1 - sign * tickMargin;
          ty = tickCoord;
          break;
        case 'right':
          y1 = y2 = data.coordinate;
          x2 = x + +mirror * width;
          x1 = x2 + sign * finalTickSize;
          tx = x1 + sign * tickMargin;
          ty = tickCoord;
          break;
        default:
          x1 = x2 = data.coordinate;
          y2 = y + +mirror * height;
          y1 = y2 + sign * finalTickSize;
          ty = y1 + sign * tickMargin;
          tx = tickCoord;
          break;
      }
      return {
        line: {
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2
        },
        tick: {
          x: tx,
          y: ty
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var _this$props3 = this.props,
        orientation = _this$props3.orientation,
        mirror = _this$props3.mirror;
      var textAnchor;
      switch (orientation) {
        case 'left':
          textAnchor = mirror ? 'start' : 'end';
          break;
        case 'right':
          textAnchor = mirror ? 'end' : 'start';
          break;
        default:
          textAnchor = 'middle';
          break;
      }
      return textAnchor;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function getTickVerticalAnchor() {
      var _this$props4 = this.props,
        orientation = _this$props4.orientation,
        mirror = _this$props4.mirror;
      var verticalAnchor = 'end';
      switch (orientation) {
        case 'left':
        case 'right':
          verticalAnchor = 'middle';
          break;
        case 'top':
          verticalAnchor = mirror ? 'start' : 'end';
          break;
        default:
          verticalAnchor = mirror ? 'end' : 'start';
          break;
      }
      return verticalAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props5 = this.props,
        x = _this$props5.x,
        y = _this$props5.y,
        width = _this$props5.width,
        height = _this$props5.height,
        orientation = _this$props5.orientation,
        mirror = _this$props5.mirror,
        axisLine = _this$props5.axisLine;
      var props = _objectSpread$g(_objectSpread$g(_objectSpread$g({}, (0, _ReactUtils$b.filterProps)(this.props, false)), (0, _ReactUtils$b.filterProps)(axisLine, false)), {}, {
        fill: 'none'
      });
      if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
        props = _objectSpread$g(_objectSpread$g({}, props), {}, {
          x1: x,
          y1: y + needHeight * height,
          x2: x + width,
          y2: y + needHeight * height
        });
      } else {
        var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
        props = _objectSpread$g(_objectSpread$g({}, props), {}, {
          x1: x + needWidth * width,
          y1: y,
          x2: x + needWidth * width,
          y2: y + height
        });
      }
      return /*#__PURE__*/_react$m["default"].createElement("line", _extends$j({}, props, {
        className: (0, _clsx$b["default"])('recharts-cartesian-axis-line', (0, _get$3["default"])(axisLine, 'className'))
      }));
    }
  }, {
    key: "renderTicks",
    value:
    /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */
    function renderTicks(ticks, fontSize, letterSpacing) {
      var _this2 = this;
      var _this$props6 = this.props,
        tickLine = _this$props6.tickLine,
        stroke = _this$props6.stroke,
        tick = _this$props6.tick,
        tickFormatter = _this$props6.tickFormatter,
        unit = _this$props6.unit;
      var finalTicks = (0, _getTicks$1.getTicks)(_objectSpread$g(_objectSpread$g({}, this.props), {}, {
        ticks: ticks
      }), fontSize, letterSpacing);
      var textAnchor = this.getTickTextAnchor();
      var verticalAnchor = this.getTickVerticalAnchor();
      var axisProps = (0, _ReactUtils$b.filterProps)(this.props, false);
      var customTickProps = (0, _ReactUtils$b.filterProps)(tick, false);
      var tickLineProps = _objectSpread$g(_objectSpread$g({}, axisProps), {}, {
        fill: 'none'
      }, (0, _ReactUtils$b.filterProps)(tickLine, false));
      var items = finalTicks.map(function (entry, i) {
        var _this2$getTickLineCoo = _this2.getTickLineCoord(entry),
          lineCoord = _this2$getTickLineCoo.line,
          tickCoord = _this2$getTickLineCoo.tick;
        var tickProps = _objectSpread$g(_objectSpread$g(_objectSpread$g(_objectSpread$g({
          textAnchor: textAnchor,
          verticalAnchor: verticalAnchor
        }, axisProps), {}, {
          stroke: 'none',
          fill: stroke
        }, customTickProps), tickCoord), {}, {
          index: i,
          payload: entry,
          visibleTicksCount: finalTicks.length,
          tickFormatter: tickFormatter
        });
        return /*#__PURE__*/_react$m["default"].createElement(_Layer$8.Layer, _extends$j({
          className: "recharts-cartesian-axis-tick",
          key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, (0, _types$3.adaptEventsOfChild)(_this2.props, entry, i)), tickLine && /*#__PURE__*/_react$m["default"].createElement("line", _extends$j({}, tickLineProps, lineCoord, {
          className: (0, _clsx$b["default"])('recharts-cartesian-axis-tick-line', (0, _get$3["default"])(tickLine, 'className'))
        })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, _isFunction$8["default"])(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
      });
      return /*#__PURE__*/_react$m["default"].createElement("g", {
        className: "recharts-cartesian-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props7 = this.props,
        axisLine = _this$props7.axisLine,
        width = _this$props7.width,
        height = _this$props7.height,
        ticksGenerator = _this$props7.ticksGenerator,
        className = _this$props7.className,
        hide = _this$props7.hide;
      if (hide) {
        return null;
      }
      var _this$props8 = this.props,
        ticks = _this$props8.ticks,
        noTicksProps = _objectWithoutProperties$b(_this$props8, _excluded3);
      var finalTicks = ticks;
      if ((0, _isFunction$8["default"])(ticksGenerator)) {
        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
      }
      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
        return null;
      }
      return /*#__PURE__*/_react$m["default"].createElement(_Layer$8.Layer, {
        className: (0, _clsx$b["default"])('recharts-cartesian-axis', className),
        ref: function ref(_ref2) {
          _this3.layerReference = _ref2;
        }
      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), _Label.Label.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;
      if ( /*#__PURE__*/_react$m["default"].isValidElement(option)) {
        tickItem = /*#__PURE__*/_react$m["default"].cloneElement(option, props);
      } else if ((0, _isFunction$8["default"])(option)) {
        tickItem = option(props);
      } else {
        tickItem = /*#__PURE__*/_react$m["default"].createElement(_Text$1.Text, _extends$j({}, props, {
          className: "recharts-cartesian-axis-tick-value"
        }), value);
      }
      return tickItem;
    }
  }]);
}(_react$m.Component);
_defineProperty$n(CartesianAxis, "displayName", 'CartesianAxis');
_defineProperty$n(CartesianAxis, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: 'bottom',
  // The ticks
  ticks: [],
  stroke: '#666',
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: 'preserveEnd'
});

var CartesianGrid$1 = {};

Object.defineProperty(CartesianGrid$1, "__esModule", {
  value: true
});
CartesianGrid$1.CartesianGrid = CartesianGrid;
var _react$l = _interopRequireDefault$q(React__default$4);
var _isFunction$7 = _interopRequireDefault$q(isFunction_1);
var _LogUtils = LogUtils;
var _DataUtils$8 = DataUtils;
var _ReactUtils$a = ReactUtils;
var _ChartUtils$9 = ChartUtils;
var _getTicks = getTicks$1;
var _CartesianAxis$2 = CartesianAxis$1;
var _chartLayoutContext$3 = chartLayoutContext;
var _excluded$7 = ["x1", "y1", "x2", "y2", "key"],
  _excluded2$4 = ["offset"];
/**
 * @fileOverview Cartesian Grid
 */
function _interopRequireDefault$q(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$h(o) { "@babel/helpers - typeof"; return _typeof$h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$h(o); }
function ownKeys$h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$h(Object(t), !0).forEach(function (r) { _defineProperty$m(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$m(obj, key, value) { key = _toPropertyKey$e(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$e(t) { var i = _toPrimitive$e(t, "string"); return "symbol" == _typeof$h(i) ? i : i + ""; }
function _toPrimitive$e(t, r) { if ("object" != _typeof$h(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$h(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
function _objectWithoutProperties$a(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
/**
 * The <CartesianGrid horizontal
 */

var Background = function Background(props) {
  var fill = props.fill;
  if (!fill || fill === 'none') {
    return null;
  }
  var fillOpacity = props.fillOpacity,
    x = props.x,
    y = props.y,
    width = props.width,
    height = props.height,
    ry = props.ry;
  return /*#__PURE__*/_react$l["default"].createElement("rect", {
    x: x,
    y: y,
    ry: ry,
    width: width,
    height: height,
    stroke: "none",
    fill: fill,
    fillOpacity: fillOpacity,
    className: "recharts-cartesian-grid-bg"
  });
};
function renderLineItem(option, props) {
  var lineItem;
  if ( /*#__PURE__*/_react$l["default"].isValidElement(option)) {
    // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/_react$l["default"].cloneElement(option, props);
  } else if ((0, _isFunction$7["default"])(option)) {
    lineItem = option(props);
  } else {
    var x1 = props.x1,
      y1 = props.y1,
      x2 = props.x2,
      y2 = props.y2,
      key = props.key,
      others = _objectWithoutProperties$a(props, _excluded$7);
    var _filterProps = (0, _ReactUtils$a.filterProps)(others, false);
      _filterProps.offset;
      var restOfFilteredProps = _objectWithoutProperties$a(_filterProps, _excluded2$4);
    lineItem = /*#__PURE__*/_react$l["default"].createElement("line", _extends$i({}, restOfFilteredProps, {
      x1: x1,
      y1: y1,
      x2: x2,
      y2: y2,
      fill: "none",
      key: key
    }));
  }
  return lineItem;
}
function HorizontalGridLines(props) {
  var x = props.x,
    width = props.width,
    _props$horizontal = props.horizontal,
    horizontal = _props$horizontal === void 0 ? true : _props$horizontal,
    horizontalPoints = props.horizontalPoints;
  if (!horizontal || !horizontalPoints || !horizontalPoints.length) {
    return null;
  }
  var items = horizontalPoints.map(function (entry, i) {
    var lineItemProps = _objectSpread$f(_objectSpread$f({}, props), {}, {
      x1: x,
      y1: entry,
      x2: x + width,
      y2: entry,
      key: "line-".concat(i),
      index: i
    });
    return renderLineItem(horizontal, lineItemProps);
  });
  return /*#__PURE__*/_react$l["default"].createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, items);
}
function VerticalGridLines(props) {
  var y = props.y,
    height = props.height,
    _props$vertical = props.vertical,
    vertical = _props$vertical === void 0 ? true : _props$vertical,
    verticalPoints = props.verticalPoints;
  if (!vertical || !verticalPoints || !verticalPoints.length) {
    return null;
  }
  var items = verticalPoints.map(function (entry, i) {
    var lineItemProps = _objectSpread$f(_objectSpread$f({}, props), {}, {
      x1: entry,
      y1: y,
      x2: entry,
      y2: y + height,
      key: "line-".concat(i),
      index: i
    });
    return renderLineItem(vertical, lineItemProps);
  });
  return /*#__PURE__*/_react$l["default"].createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, items);
}
function HorizontalStripes(props) {
  var horizontalFill = props.horizontalFill,
    fillOpacity = props.fillOpacity,
    x = props.x,
    y = props.y,
    width = props.width,
    height = props.height,
    horizontalPoints = props.horizontalPoints,
    _props$horizontal2 = props.horizontal,
    horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
  if (!horizontal || !horizontalFill || !horizontalFill.length) {
    return null;
  }

  // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
  var roundedSortedHorizontalPoints = horizontalPoints.map(function (e) {
    return Math.round(e + y - y);
  }).sort(function (a, b) {
    return a - b;
  });
  // Why is this condition `!==` instead of `<=` ?
  if (y !== roundedSortedHorizontalPoints[0]) {
    roundedSortedHorizontalPoints.unshift(0);
  }
  var items = roundedSortedHorizontalPoints.map(function (entry, i) {
    // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
    var lastStripe = !roundedSortedHorizontalPoints[i + 1];
    var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
    if (lineHeight <= 0) {
      return null;
    }
    var colorIndex = i % horizontalFill.length;
    return /*#__PURE__*/_react$l["default"].createElement("rect", {
      key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
      ,
      y: entry,
      x: x,
      height: lineHeight,
      width: width,
      stroke: "none",
      fill: horizontalFill[colorIndex],
      fillOpacity: fillOpacity,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /*#__PURE__*/_react$l["default"].createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, items);
}
function VerticalStripes(props) {
  var _props$vertical2 = props.vertical,
    vertical = _props$vertical2 === void 0 ? true : _props$vertical2,
    verticalFill = props.verticalFill,
    fillOpacity = props.fillOpacity,
    x = props.x,
    y = props.y,
    width = props.width,
    height = props.height,
    verticalPoints = props.verticalPoints;
  if (!vertical || !verticalFill || !verticalFill.length) {
    return null;
  }
  var roundedSortedVerticalPoints = verticalPoints.map(function (e) {
    return Math.round(e + x - x);
  }).sort(function (a, b) {
    return a - b;
  });
  if (x !== roundedSortedVerticalPoints[0]) {
    roundedSortedVerticalPoints.unshift(0);
  }
  var items = roundedSortedVerticalPoints.map(function (entry, i) {
    var lastStripe = !roundedSortedVerticalPoints[i + 1];
    var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
    if (lineWidth <= 0) {
      return null;
    }
    var colorIndex = i % verticalFill.length;
    return /*#__PURE__*/_react$l["default"].createElement("rect", {
      key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
      ,
      x: entry,
      y: y,
      width: lineWidth,
      height: height,
      stroke: "none",
      fill: verticalFill[colorIndex],
      fillOpacity: fillOpacity,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /*#__PURE__*/_react$l["default"].createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, items);
}
var defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
  var xAxis = _ref.xAxis,
    width = _ref.width,
    height = _ref.height,
    offset = _ref.offset;
  return (0, _ChartUtils$9.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread$f(_objectSpread$f(_objectSpread$f({}, _CartesianAxis$2.CartesianAxis.defaultProps), xAxis), {}, {
    ticks: (0, _ChartUtils$9.getTicksOfAxis)(xAxis, true),
    viewBox: {
      x: 0,
      y: 0,
      width: width,
      height: height
    }
  })), offset.left, offset.left + offset.width, syncWithTicks);
};
var defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
  var yAxis = _ref2.yAxis,
    width = _ref2.width,
    height = _ref2.height,
    offset = _ref2.offset;
  return (0, _ChartUtils$9.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread$f(_objectSpread$f(_objectSpread$f({}, _CartesianAxis$2.CartesianAxis.defaultProps), yAxis), {}, {
    ticks: (0, _ChartUtils$9.getTicksOfAxis)(yAxis, true),
    viewBox: {
      x: 0,
      y: 0,
      width: width,
      height: height
    }
  })), offset.top, offset.top + offset.height, syncWithTicks);
};
var defaultProps = {
  horizontal: true,
  vertical: true,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: '#ccc',
  fill: 'none',
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function CartesianGrid(props) {
  var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
  var chartWidth = (0, _chartLayoutContext$3.useChartWidth)();
  var chartHeight = (0, _chartLayoutContext$3.useChartHeight)();
  var offset = (0, _chartLayoutContext$3.useOffset)();
  var propsIncludingDefaults = _objectSpread$f(_objectSpread$f({}, props), {}, {
    stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : defaultProps.stroke,
    fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : defaultProps.fill,
    horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : defaultProps.horizontal,
    horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : defaultProps.horizontalFill,
    vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : defaultProps.vertical,
    verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : defaultProps.verticalFill,
    x: (0, _DataUtils$8.isNumber)(props.x) ? props.x : offset.left,
    y: (0, _DataUtils$8.isNumber)(props.y) ? props.y : offset.top,
    width: (0, _DataUtils$8.isNumber)(props.width) ? props.width : offset.width,
    height: (0, _DataUtils$8.isNumber)(props.height) ? props.height : offset.height
  });
  var x = propsIncludingDefaults.x,
    y = propsIncludingDefaults.y,
    width = propsIncludingDefaults.width,
    height = propsIncludingDefaults.height,
    syncWithTicks = propsIncludingDefaults.syncWithTicks,
    horizontalValues = propsIncludingDefaults.horizontalValues,
    verticalValues = propsIncludingDefaults.verticalValues;

  // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
  var xAxis = (0, _chartLayoutContext$3.useArbitraryXAxis)();
  // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
  var yAxis = (0, _chartLayoutContext$3.useYAxisWithFiniteDomainOrRandom)();
  if (!(0, _DataUtils$8.isNumber)(width) || width <= 0 || !(0, _DataUtils$8.isNumber)(height) || height <= 0 || !(0, _DataUtils$8.isNumber)(x) || x !== +x || !(0, _DataUtils$8.isNumber)(y) || y !== +y) {
    return null;
  }

  /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */
  var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || defaultVerticalCoordinatesGenerator;
  var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || defaultHorizontalCoordinatesGenerator;
  var horizontalPoints = propsIncludingDefaults.horizontalPoints,
    verticalPoints = propsIncludingDefaults.verticalPoints;

  // No horizontal points are specified
  if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunction$7["default"])(horizontalCoordinatesGenerator)) {
    var isHorizontalValues = horizontalValues && horizontalValues.length;
    var generatorResult = horizontalCoordinatesGenerator({
      yAxis: yAxis ? _objectSpread$f(_objectSpread$f({}, yAxis), {}, {
        ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
      }) : undefined,
      width: chartWidth,
      height: chartHeight,
      offset: offset
    }, isHorizontalValues ? true : syncWithTicks);
    (0, _LogUtils.warn)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof$h(generatorResult), "]"));
    if (Array.isArray(generatorResult)) {
      horizontalPoints = generatorResult;
    }
  }

  // No vertical points are specified
  if ((!verticalPoints || !verticalPoints.length) && (0, _isFunction$7["default"])(verticalCoordinatesGenerator)) {
    var isVerticalValues = verticalValues && verticalValues.length;
    var _generatorResult = verticalCoordinatesGenerator({
      xAxis: xAxis ? _objectSpread$f(_objectSpread$f({}, xAxis), {}, {
        ticks: isVerticalValues ? verticalValues : xAxis.ticks
      }) : undefined,
      width: chartWidth,
      height: chartHeight,
      offset: offset
    }, isVerticalValues ? true : syncWithTicks);
    (0, _LogUtils.warn)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof$h(_generatorResult), "]"));
    if (Array.isArray(_generatorResult)) {
      verticalPoints = _generatorResult;
    }
  }
  return /*#__PURE__*/_react$l["default"].createElement("g", {
    className: "recharts-cartesian-grid"
  }, /*#__PURE__*/_react$l["default"].createElement(Background, {
    fill: propsIncludingDefaults.fill,
    fillOpacity: propsIncludingDefaults.fillOpacity,
    x: propsIncludingDefaults.x,
    y: propsIncludingDefaults.y,
    width: propsIncludingDefaults.width,
    height: propsIncludingDefaults.height,
    ry: propsIncludingDefaults.ry
  }), /*#__PURE__*/_react$l["default"].createElement(HorizontalGridLines, _extends$i({}, propsIncludingDefaults, {
    offset: offset,
    horizontalPoints: horizontalPoints,
    xAxis: xAxis,
    yAxis: yAxis
  })), /*#__PURE__*/_react$l["default"].createElement(VerticalGridLines, _extends$i({}, propsIncludingDefaults, {
    offset: offset,
    verticalPoints: verticalPoints,
    xAxis: xAxis,
    yAxis: yAxis
  })), /*#__PURE__*/_react$l["default"].createElement(HorizontalStripes, _extends$i({}, propsIncludingDefaults, {
    horizontalPoints: horizontalPoints
  })), /*#__PURE__*/_react$l["default"].createElement(VerticalStripes, _extends$i({}, propsIncludingDefaults, {
    verticalPoints: verticalPoints
  })));
}
CartesianGrid.displayName = 'CartesianGrid';

var Line$1 = {};

Object.defineProperty(Line$1, "__esModule", {
  value: true
});
Line$1.Line = void 0;
var _react$k = _interopRequireWildcard$7(React__default$4);
var _reactSmooth$4 = _interopRequireDefault$p(lib);
var _isFunction$6 = _interopRequireDefault$p(isFunction_1);
var _isNil$3 = _interopRequireDefault$p(isNil_1);
var _isEqual$3 = _interopRequireDefault$p(isEqual_1);
var _clsx$a = _interopRequireDefault$p(clsx.exports);
var _Curve$3 = Curve;
var _Dot$2 = Dot;
var _Layer$7 = Layer;
var _LabelList$3 = LabelList$1;
var _ErrorBar$1 = ErrorBar$1;
var _DataUtils$7 = DataUtils;
var _ReactUtils$9 = ReactUtils;
var _Global$4 = Global$1;
var _ChartUtils$8 = ChartUtils;
var _excluded$6 = ["type", "layout", "connectNulls", "ref"],
  _excluded2$3 = ["key"];
function _interopRequireDefault$p(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$7(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$7 = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$7(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$g(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$7(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$g(o) { "@babel/helpers - typeof"; return _typeof$g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$g(o); }
function _objectWithoutProperties$9(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$6(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$6(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
function ownKeys$g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$g(Object(t), !0).forEach(function (r) { _defineProperty$l(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray$3(arr) { return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$h(arr) || _nonIterableSpread$3(); }
function _nonIterableSpread$3() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$h(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$h(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$h(o, minLen); }
function _iterableToArray$3(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$3(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$h(arr); }
function _arrayLikeToArray$h(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck$p(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$j(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$d(descriptor.key), descriptor); } }
function _createClass$p(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$j(Constructor.prototype, protoProps); if (staticProps) _defineProperties$j(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$9(t, o, e) { return o = _getPrototypeOf$a(o), _possibleConstructorReturn$g(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf$a(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$g(self, call) { if (call && (_typeof$g(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$a(self); }
function _assertThisInitialized$a(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$a() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$a(o) { _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$a(o); }
function _inherits$g(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$a(subClass, superClass); }
function _setPrototypeOf$a(o, p) { _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$a(o, p); }
function _defineProperty$l(obj, key, value) { key = _toPropertyKey$d(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$d(t) { var i = _toPrimitive$d(t, "string"); return "symbol" == _typeof$g(i) ? i : i + ""; }
function _toPrimitive$d(t, r) { if ("object" != _typeof$g(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$g(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Line
 */
var Line = Line$1.Line = /*#__PURE__*/function (_PureComponent) {
  function Line() {
    var _this;
    _classCallCheck$p(this, Line);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$9(this, Line, [].concat(args));
    _defineProperty$l(_this, "state", {
      isAnimationFinished: true,
      totalLength: 0
    });
    _defineProperty$l(_this, "generateSimpleStrokeDasharray", function (totalLength, length) {
      return "".concat(length, "px ").concat(totalLength - length, "px");
    });
    _defineProperty$l(_this, "getStrokeDasharray", function (length, totalLength, lines) {
      var lineLength = lines.reduce(function (pre, next) {
        return pre + next;
      });

      // if lineLength is 0 return the default when no strokeDasharray is provided
      if (!lineLength) {
        return _this.generateSimpleStrokeDasharray(totalLength, length);
      }
      var count = Math.floor(length / lineLength);
      var remainLength = length % lineLength;
      var restLength = totalLength - length;
      var remainLines = [];
      for (var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i) {
        if (sum + lines[i] > remainLength) {
          remainLines = [].concat(_toConsumableArray$3(lines.slice(0, i)), [remainLength - sum]);
          break;
        }
      }
      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
      return [].concat(_toConsumableArray$3(Line.repeat(lines, count)), _toConsumableArray$3(remainLines), emptyLines).map(function (line) {
        return "".concat(line, "px");
      }).join(', ');
    });
    _defineProperty$l(_this, "id", (0, _DataUtils$7.uniqueId)('recharts-line-'));
    _defineProperty$l(_this, "pathRef", function (node) {
      _this.mainCurve = node;
    });
    _defineProperty$l(_this, "handleAnimationEnd", function () {
      _this.setState({
        isAnimationFinished: true
      });
      if (_this.props.onAnimationEnd) {
        _this.props.onAnimationEnd();
      }
    });
    _defineProperty$l(_this, "handleAnimationStart", function () {
      _this.setState({
        isAnimationFinished: false
      });
      if (_this.props.onAnimationStart) {
        _this.props.onAnimationStart();
      }
    });
    return _this;
  }
  _inherits$g(Line, _PureComponent);
  return _createClass$p(Line, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isAnimationActive) {
        return;
      }
      var totalLength = this.getTotalLength();
      this.setState({
        totalLength: totalLength
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.props.isAnimationActive) {
        return;
      }
      var totalLength = this.getTotalLength();
      if (totalLength !== this.state.totalLength) {
        this.setState({
          totalLength: totalLength
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function getTotalLength() {
      var curveDom = this.mainCurve;
      try {
        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
      } catch (err) {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar(needClip, clipPathId) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props = this.props,
        points = _this$props.points,
        xAxis = _this$props.xAxis,
        yAxis = _this$props.yAxis,
        layout = _this$props.layout,
        children = _this$props.children;
      var errorBarItems = (0, _ReactUtils$9.findAllByType)(children, _ErrorBar$1.ErrorBar);
      if (!errorBarItems) {
        return null;
      }
      var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: (0, _ChartUtils$8.getValueByDataKey)(dataPoint.payload, dataKey)
        };
      };
      var errorBarProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return /*#__PURE__*/_react$k["default"].createElement(_Layer$7.Layer, errorBarProps, errorBarItems.map(function (item) {
        return /*#__PURE__*/_react$k["default"].cloneElement(item, {
          key: "bar-".concat(item.props.dataKey),
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: layout,
          dataPointFormatter: dataPointFormatter
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function renderDots(needClip, clipDot, clipPathId) {
      var isAnimationActive = this.props.isAnimationActive;
      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props2 = this.props,
        dot = _this$props2.dot,
        points = _this$props2.points,
        dataKey = _this$props2.dataKey;
      var lineProps = (0, _ReactUtils$9.filterProps)(this.props, false);
      var customDotProps = (0, _ReactUtils$9.filterProps)(dot, true);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread$e(_objectSpread$e(_objectSpread$e({
          key: "dot-".concat(i),
          r: 3
        }, lineProps), customDotProps), {}, {
          value: entry.value,
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          payload: entry.payload
        });
        return Line.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
      };
      return /*#__PURE__*/_react$k["default"].createElement(_Layer$7.Layer, _extends$h({
        className: "recharts-line-dots",
        key: "dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderCurveStatically",
    value: function renderCurveStatically(points, needClip, clipPathId, props) {
      var _this$props3 = this.props,
        type = _this$props3.type,
        layout = _this$props3.layout,
        connectNulls = _this$props3.connectNulls;
        _this$props3.ref;
        var others = _objectWithoutProperties$9(_this$props3, _excluded$6);
      var curveProps = _objectSpread$e(_objectSpread$e(_objectSpread$e({}, (0, _ReactUtils$9.filterProps)(others, true)), {}, {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
        points: points
      }, props), {}, {
        type: type,
        layout: layout,
        connectNulls: connectNulls
      });
      return /*#__PURE__*/_react$k["default"].createElement(_Curve$3.Curve, _extends$h({}, curveProps, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function renderCurveWithAnimation(needClip, clipPathId) {
      var _this2 = this;
      var _this$props4 = this.props,
        points = _this$props4.points,
        strokeDasharray = _this$props4.strokeDasharray,
        isAnimationActive = _this$props4.isAnimationActive,
        animationBegin = _this$props4.animationBegin,
        animationDuration = _this$props4.animationDuration,
        animationEasing = _this$props4.animationEasing,
        animationId = _this$props4.animationId,
        animateNewValues = _this$props4.animateNewValues,
        width = _this$props4.width,
        height = _this$props4.height;
      var _this$state = this.state,
        prevPoints = _this$state.prevPoints,
        totalLength = _this$state.totalLength;
      return /*#__PURE__*/_react$k["default"].createElement(_reactSmooth$4["default"], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length;
          var stepData = points.map(function (entry, index) {
            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = (0, _DataUtils$7.interpolateNumber)(prev.x, entry.x);
              var interpolatorY = (0, _DataUtils$7.interpolateNumber)(prev.y, entry.y);
              return _objectSpread$e(_objectSpread$e({}, entry), {}, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            }

            // magic number of faking previous x and y location
            if (animateNewValues) {
              var _interpolatorX = (0, _DataUtils$7.interpolateNumber)(width * 2, entry.x);
              var _interpolatorY = (0, _DataUtils$7.interpolateNumber)(height / 2, entry.y);
              return _objectSpread$e(_objectSpread$e({}, entry), {}, {
                x: _interpolatorX(t),
                y: _interpolatorY(t)
              });
            }
            return _objectSpread$e(_objectSpread$e({}, entry), {}, {
              x: entry.x,
              y: entry.y
            });
          });
          return _this2.renderCurveStatically(stepData, needClip, clipPathId);
        }
        var interpolator = (0, _DataUtils$7.interpolateNumber)(0, totalLength);
        var curLength = interpolator(t);
        var currentStrokeDasharray;
        if (strokeDasharray) {
          var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function (num) {
            return parseFloat(num);
          });
          currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
        } else {
          currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
        }
        return _this2.renderCurveStatically(points, needClip, clipPathId, {
          strokeDasharray: currentStrokeDasharray
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function renderCurve(needClip, clipPathId) {
      var _this$props5 = this.props,
        points = _this$props5.points,
        isAnimationActive = _this$props5.isAnimationActive;
      var _this$state2 = this.state,
        prevPoints = _this$state2.prevPoints,
        totalLength = _this$state2.totalLength;
      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual$3["default"])(prevPoints, points))) {
        return this.renderCurveWithAnimation(needClip, clipPathId);
      }
      return this.renderCurveStatically(points, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _filterProps;
      var _this$props6 = this.props,
        hide = _this$props6.hide,
        dot = _this$props6.dot,
        points = _this$props6.points,
        className = _this$props6.className,
        xAxis = _this$props6.xAxis,
        yAxis = _this$props6.yAxis,
        top = _this$props6.top,
        left = _this$props6.left,
        width = _this$props6.width,
        height = _this$props6.height,
        isAnimationActive = _this$props6.isAnimationActive,
        id = _this$props6.id;
      if (hide || !points || !points.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = (0, _clsx$a["default"])('recharts-line', className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = (0, _isNil$3["default"])(id) ? this.id : id;
      var _ref2 = (_filterProps = (0, _ReactUtils$9.filterProps)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
          r: 3,
          strokeWidth: 2
        },
        _ref2$r = _ref2.r,
        r = _ref2$r === void 0 ? 3 : _ref2$r,
        _ref2$strokeWidth = _ref2.strokeWidth,
        strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
      var _ref3 = (0, _ReactUtils$9.hasClipDot)(dot) ? dot : {},
        _ref3$clipDot = _ref3.clipDot,
        clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
      var dotSize = r * 2 + strokeWidth;
      return /*#__PURE__*/_react$k["default"].createElement(_Layer$7.Layer, {
        className: layerClass
      }, needClipX || needClipY ? /*#__PURE__*/_react$k["default"].createElement("defs", null, /*#__PURE__*/_react$k["default"].createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /*#__PURE__*/_react$k["default"].createElement("rect", {
        x: needClipX ? left : left - width / 2,
        y: needClipY ? top : top - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
      })), !clipDot && /*#__PURE__*/_react$k["default"].createElement("clipPath", {
        id: "clipPath-dots-".concat(clipPathId)
      }, /*#__PURE__*/_react$k["default"].createElement("rect", {
        x: left - dotSize / 2,
        y: top - dotSize / 2,
        width: width + dotSize,
        height: height + dotSize
      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList$3.LabelList.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          prevPoints: prevState.curPoints
        };
      }
      if (nextProps.points !== prevState.curPoints) {
        return {
          curPoints: nextProps.points
        };
      }
      return null;
    }
  }, {
    key: "repeat",
    value: function repeat(lines, count) {
      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray$3(lines), [0]) : lines;
      var result = [];
      for (var i = 0; i < count; ++i) {
        result = [].concat(_toConsumableArray$3(result), _toConsumableArray$3(linesUnit));
      }
      return result;
    }
  }, {
    key: "renderDotItem",
    value: function renderDotItem(option, props) {
      var dotItem;
      if ( /*#__PURE__*/_react$k["default"].isValidElement(option)) {
        dotItem = /*#__PURE__*/_react$k["default"].cloneElement(option, props);
      } else if ((0, _isFunction$6["default"])(option)) {
        dotItem = option(props);
      } else {
        var key = props.key,
          dotProps = _objectWithoutProperties$9(props, _excluded2$3);
        var className = (0, _clsx$a["default"])('recharts-line-dot', typeof option !== 'boolean' ? option.className : '');
        dotItem = /*#__PURE__*/_react$k["default"].createElement(_Dot$2.Dot, _extends$h({
          key: key
        }, dotProps, {
          className: className
        }));
      }
      return dotItem;
    }
  }]);
}(_react$k.PureComponent);
_defineProperty$l(Line, "displayName", 'Line');
_defineProperty$l(Line, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: 'line',
  stroke: '#3182bd',
  strokeWidth: 1,
  fill: '#fff',
  points: [],
  isAnimationActive: !_Global$4.Global.isSsr,
  animateNewValues: true,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  hide: false,
  label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */
_defineProperty$l(Line, "getComposedData", function (_ref4) {
  var props = _ref4.props,
    xAxis = _ref4.xAxis,
    yAxis = _ref4.yAxis,
    xAxisTicks = _ref4.xAxisTicks,
    yAxisTicks = _ref4.yAxisTicks,
    dataKey = _ref4.dataKey,
    bandSize = _ref4.bandSize,
    displayedData = _ref4.displayedData,
    offset = _ref4.offset;
  var layout = props.layout;
  var points = displayedData.map(function (entry, index) {
    var value = (0, _ChartUtils$8.getValueByDataKey)(entry, dataKey);
    if (layout === 'horizontal') {
      return {
        x: (0, _ChartUtils$8.getCateCoordinateOfLine)({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index
        }),
        y: (0, _isNil$3["default"])(value) ? null : yAxis.scale(value),
        value: value,
        payload: entry
      };
    }
    return {
      x: (0, _isNil$3["default"])(value) ? null : xAxis.scale(value),
      y: (0, _ChartUtils$8.getCateCoordinateOfLine)({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index
      }),
      value: value,
      payload: entry
    };
  });
  return _objectSpread$e({
    points: points,
    layout: layout
  }, offset);
});

var Area$1 = {};

Object.defineProperty(Area$1, "__esModule", {
  value: true
});
Area$1.Area = void 0;
var _react$j = _interopRequireWildcard$6(React__default$4);
var _clsx$9 = _interopRequireDefault$o(clsx.exports);
var _reactSmooth$3 = _interopRequireDefault$o(lib);
var _isFunction$5 = _interopRequireDefault$o(isFunction_1);
var _max = _interopRequireDefault$o(max_1);
var _isNil$2 = _interopRequireDefault$o(isNil_1);
var _isNaN$1 = _interopRequireDefault$o(_isNaN$3);
var _isEqual$2 = _interopRequireDefault$o(isEqual_1);
var _Curve$2 = Curve;
var _Dot$1 = Dot;
var _Layer$6 = Layer;
var _LabelList$2 = LabelList$1;
var _Global$3 = Global$1;
var _DataUtils$6 = DataUtils;
var _ChartUtils$7 = ChartUtils;
var _ReactUtils$8 = ReactUtils;
var _excluded$5 = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"],
  _excluded2$2 = ["key"];
var _Area$2;
function _interopRequireDefault$o(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$6(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$6 = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$6(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$f(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$6(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$f(o) { "@babel/helpers - typeof"; return _typeof$f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$f(o); }
function _objectWithoutProperties$8(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$5(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) { _defineProperty$k(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$o(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$i(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$c(descriptor.key), descriptor); } }
function _createClass$o(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$i(Constructor.prototype, protoProps); if (staticProps) _defineProperties$i(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$8(t, o, e) { return o = _getPrototypeOf$9(o), _possibleConstructorReturn$f(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf$9(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$f(self, call) { if (call && (_typeof$f(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$9(self); }
function _assertThisInitialized$9(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$9() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$9(o) { _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$9(o); }
function _inherits$f(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$9(subClass, superClass); }
function _setPrototypeOf$9(o, p) { _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$9(o, p); }
function _defineProperty$k(obj, key, value) { key = _toPropertyKey$c(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$c(t) { var i = _toPrimitive$c(t, "string"); return "symbol" == _typeof$f(i) ? i : i + ""; }
function _toPrimitive$c(t, r) { if ("object" != _typeof$f(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$f(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Area
 */
var Area = Area$1.Area = /*#__PURE__*/function (_PureComponent) {
  function Area() {
    var _this;
    _classCallCheck$o(this, Area);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$8(this, Area, [].concat(args));
    _defineProperty$k(_this, "state", {
      isAnimationFinished: true
    });
    _defineProperty$k(_this, "id", (0, _DataUtils$6.uniqueId)('recharts-area-'));
    _defineProperty$k(_this, "handleAnimationEnd", function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if ((0, _isFunction$5["default"])(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$k(_this, "handleAnimationStart", function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if ((0, _isFunction$5["default"])(onAnimationStart)) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _inherits$f(Area, _PureComponent);
  return _createClass$o(Area, [{
    key: "renderDots",
    value: function renderDots(needClip, clipDot, clipPathId) {
      var isAnimationActive = this.props.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;
      if (isAnimationActive && !isAnimationFinished) {
        return null;
      }
      var _this$props = this.props,
        dot = _this$props.dot,
        points = _this$props.points,
        dataKey = _this$props.dataKey;
      var areaProps = (0, _ReactUtils$8.filterProps)(this.props, false);
      var customDotProps = (0, _ReactUtils$8.filterProps)(dot, true);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread$d(_objectSpread$d(_objectSpread$d({
          key: "dot-".concat(i),
          r: 3
        }, areaProps), customDotProps), {}, {
          index: i,
          cx: entry.x,
          cy: entry.y,
          dataKey: dataKey,
          value: entry.value,
          payload: entry.payload,
          points: points
        });
        return Area.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : null
      };
      return /*#__PURE__*/_react$j["default"].createElement(_Layer$6.Layer, _extends$g({
        className: "recharts-area-dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderHorizontalRect",
    value: function renderHorizontalRect(alpha) {
      var _this$props2 = this.props,
        baseLine = _this$props2.baseLine,
        points = _this$props2.points,
        strokeWidth = _this$props2.strokeWidth;
      var startX = points[0].x;
      var endX = points[points.length - 1].x;
      var width = alpha * Math.abs(startX - endX);
      var maxY = (0, _max["default"])(points.map(function (entry) {
        return entry.y || 0;
      }));
      if ((0, _DataUtils$6.isNumber)(baseLine) && typeof baseLine === 'number') {
        maxY = Math.max(baseLine, maxY);
      } else if (baseLine && Array.isArray(baseLine) && baseLine.length) {
        maxY = Math.max((0, _max["default"])(baseLine.map(function (entry) {
          return entry.y || 0;
        })), maxY);
      }
      if ((0, _DataUtils$6.isNumber)(maxY)) {
        return /*#__PURE__*/_react$j["default"].createElement("rect", {
          x: startX < endX ? startX : startX - width,
          y: 0,
          width: width,
          height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
        });
      }
      return null;
    }
  }, {
    key: "renderVerticalRect",
    value: function renderVerticalRect(alpha) {
      var _this$props3 = this.props,
        baseLine = _this$props3.baseLine,
        points = _this$props3.points,
        strokeWidth = _this$props3.strokeWidth;
      var startY = points[0].y;
      var endY = points[points.length - 1].y;
      var height = alpha * Math.abs(startY - endY);
      var maxX = (0, _max["default"])(points.map(function (entry) {
        return entry.x || 0;
      }));
      if ((0, _DataUtils$6.isNumber)(baseLine) && typeof baseLine === 'number') {
        maxX = Math.max(baseLine, maxX);
      } else if (baseLine && Array.isArray(baseLine) && baseLine.length) {
        maxX = Math.max((0, _max["default"])(baseLine.map(function (entry) {
          return entry.x || 0;
        })), maxX);
      }
      if ((0, _DataUtils$6.isNumber)(maxX)) {
        return /*#__PURE__*/_react$j["default"].createElement("rect", {
          x: 0,
          y: startY < endY ? startY : startY - height,
          width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
          height: Math.floor(height)
        });
      }
      return null;
    }
  }, {
    key: "renderClipRect",
    value: function renderClipRect(alpha) {
      var layout = this.props.layout;
      if (layout === 'vertical') {
        return this.renderVerticalRect(alpha);
      }
      return this.renderHorizontalRect(alpha);
    }
  }, {
    key: "renderAreaStatically",
    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
      var _this$props4 = this.props,
        layout = _this$props4.layout,
        type = _this$props4.type,
        stroke = _this$props4.stroke,
        connectNulls = _this$props4.connectNulls,
        isRange = _this$props4.isRange;
        _this$props4.ref;
        var others = _objectWithoutProperties$8(_this$props4, _excluded$5);
      return /*#__PURE__*/_react$j["default"].createElement(_Layer$6.Layer, {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, /*#__PURE__*/_react$j["default"].createElement(_Curve$2.Curve, _extends$g({}, (0, _ReactUtils$8.filterProps)(others, true), {
        points: points,
        connectNulls: connectNulls,
        type: type,
        baseLine: baseLine,
        layout: layout,
        stroke: "none",
        className: "recharts-area-area"
      })), stroke !== 'none' && /*#__PURE__*/_react$j["default"].createElement(_Curve$2.Curve, _extends$g({}, (0, _ReactUtils$8.filterProps)(this.props, false), {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: points
      })), stroke !== 'none' && isRange && /*#__PURE__*/_react$j["default"].createElement(_Curve$2.Curve, _extends$g({}, (0, _ReactUtils$8.filterProps)(this.props, false), {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: baseLine
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function renderAreaWithAnimation(needClip, clipPathId) {
      var _this2 = this;
      var _this$props5 = this.props,
        points = _this$props5.points,
        baseLine = _this$props5.baseLine,
        isAnimationActive = _this$props5.isAnimationActive,
        animationBegin = _this$props5.animationBegin,
        animationDuration = _this$props5.animationDuration,
        animationEasing = _this$props5.animationEasing,
        animationId = _this$props5.animationId;
      var _this$state = this.state,
        prevPoints = _this$state.prevPoints,
        prevBaseLine = _this$state.prevBaseLine;
      // const clipPathId = isNil(id) ? this.id : id;

      return /*#__PURE__*/_react$j["default"].createElement(_reactSmooth$3["default"], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length;
          // update animtaion
          var stepPoints = points.map(function (entry, index) {
            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = (0, _DataUtils$6.interpolateNumber)(prev.x, entry.x);
              var interpolatorY = (0, _DataUtils$6.interpolateNumber)(prev.y, entry.y);
              return _objectSpread$d(_objectSpread$d({}, entry), {}, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            }
            return entry;
          });
          var stepBaseLine;
          if ((0, _DataUtils$6.isNumber)(baseLine) && typeof baseLine === 'number') {
            var interpolator = (0, _DataUtils$6.interpolateNumber)(prevBaseLine, baseLine);
            stepBaseLine = interpolator(t);
          } else if ((0, _isNil$2["default"])(baseLine) || (0, _isNaN$1["default"])(baseLine)) {
            var _interpolator = (0, _DataUtils$6.interpolateNumber)(prevBaseLine, 0);
            stepBaseLine = _interpolator(t);
          } else {
            stepBaseLine = baseLine.map(function (entry, index) {
              var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
              if (prevBaseLine[prevPointIndex]) {
                var prev = prevBaseLine[prevPointIndex];
                var interpolatorX = (0, _DataUtils$6.interpolateNumber)(prev.x, entry.x);
                var interpolatorY = (0, _DataUtils$6.interpolateNumber)(prev.y, entry.y);
                return _objectSpread$d(_objectSpread$d({}, entry), {}, {
                  x: interpolatorX(t),
                  y: interpolatorY(t)
                });
              }
              return entry;
            });
          }
          return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
        }
        return /*#__PURE__*/_react$j["default"].createElement(_Layer$6.Layer, null, /*#__PURE__*/_react$j["default"].createElement("defs", null, /*#__PURE__*/_react$j["default"].createElement("clipPath", {
          id: "animationClipPath-".concat(clipPathId)
        }, _this2.renderClipRect(t))), /*#__PURE__*/_react$j["default"].createElement(_Layer$6.Layer, {
          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
        }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
      });
    }
  }, {
    key: "renderArea",
    value: function renderArea(needClip, clipPathId) {
      var _this$props6 = this.props,
        points = _this$props6.points,
        baseLine = _this$props6.baseLine,
        isAnimationActive = _this$props6.isAnimationActive;
      var _this$state2 = this.state,
        prevPoints = _this$state2.prevPoints,
        prevBaseLine = _this$state2.prevBaseLine,
        totalLength = _this$state2.totalLength;
      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual$2["default"])(prevPoints, points) || !(0, _isEqual$2["default"])(prevBaseLine, baseLine))) {
        return this.renderAreaWithAnimation(needClip, clipPathId);
      }
      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _filterProps;
      var _this$props7 = this.props,
        hide = _this$props7.hide,
        dot = _this$props7.dot,
        points = _this$props7.points,
        className = _this$props7.className,
        top = _this$props7.top,
        left = _this$props7.left,
        xAxis = _this$props7.xAxis,
        yAxis = _this$props7.yAxis,
        width = _this$props7.width,
        height = _this$props7.height,
        isAnimationActive = _this$props7.isAnimationActive,
        id = _this$props7.id;
      if (hide || !points || !points.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = (0, _clsx$9["default"])('recharts-area', className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = (0, _isNil$2["default"])(id) ? this.id : id;
      var _ref2 = (_filterProps = (0, _ReactUtils$8.filterProps)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
          r: 3,
          strokeWidth: 2
        },
        _ref2$r = _ref2.r,
        r = _ref2$r === void 0 ? 3 : _ref2$r,
        _ref2$strokeWidth = _ref2.strokeWidth,
        strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
      var _ref3 = (0, _ReactUtils$8.hasClipDot)(dot) ? dot : {},
        _ref3$clipDot = _ref3.clipDot,
        clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
      var dotSize = r * 2 + strokeWidth;
      return /*#__PURE__*/_react$j["default"].createElement(_Layer$6.Layer, {
        className: layerClass
      }, needClipX || needClipY ? /*#__PURE__*/_react$j["default"].createElement("defs", null, /*#__PURE__*/_react$j["default"].createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /*#__PURE__*/_react$j["default"].createElement("rect", {
        x: needClipX ? left : left - width / 2,
        y: needClipY ? top : top - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
      })), !clipDot && /*#__PURE__*/_react$j["default"].createElement("clipPath", {
        id: "clipPath-dots-".concat(clipPathId)
      }, /*#__PURE__*/_react$j["default"].createElement("rect", {
        x: left - dotSize / 2,
        y: top - dotSize / 2,
        width: width + dotSize,
        height: height + dotSize
      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList$2.LabelList.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          curBaseLine: nextProps.baseLine,
          prevPoints: prevState.curPoints,
          prevBaseLine: prevState.curBaseLine
        };
      }
      if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) {
        return {
          curPoints: nextProps.points,
          curBaseLine: nextProps.baseLine
        };
      }
      return null;
    }
  }]);
}(_react$j.PureComponent);
_Area$2 = Area;
_defineProperty$k(Area, "displayName", 'Area');
_defineProperty$k(Area, "defaultProps", {
  stroke: '#3182bd',
  fill: '#3182bd',
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'line',
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  activeDot: true,
  hide: false,
  isAnimationActive: !_Global$3.Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
});
_defineProperty$k(Area, "getBaseValue", function (props, item, xAxis, yAxis) {
  var layout = props.layout,
    chartBaseValue = props.baseValue;
  var itemBaseValue = item.props.baseValue;

  // The baseValue can be defined both on the AreaChart as well as on the Area.
  // The value for the item takes precedence.
  var baseValue = itemBaseValue !== null && itemBaseValue !== void 0 ? itemBaseValue : chartBaseValue;
  if ((0, _DataUtils$6.isNumber)(baseValue) && typeof baseValue === 'number') {
    return baseValue;
  }
  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numericAxis.scale.domain();
  if (numericAxis.type === 'number') {
    var domainMax = Math.max(domain[0], domain[1]);
    var domainMin = Math.min(domain[0], domain[1]);
    if (baseValue === 'dataMin') {
      return domainMin;
    }
    if (baseValue === 'dataMax') {
      return domainMax;
    }
    return domainMax < 0 ? domainMax : Math.max(Math.min(domain[0], domain[1]), 0);
  }
  if (baseValue === 'dataMin') {
    return domain[0];
  }
  if (baseValue === 'dataMax') {
    return domain[1];
  }
  return domain[0];
});
_defineProperty$k(Area, "getComposedData", function (_ref4) {
  var props = _ref4.props,
    item = _ref4.item,
    xAxis = _ref4.xAxis,
    yAxis = _ref4.yAxis,
    xAxisTicks = _ref4.xAxisTicks,
    yAxisTicks = _ref4.yAxisTicks,
    bandSize = _ref4.bandSize,
    dataKey = _ref4.dataKey,
    stackedData = _ref4.stackedData,
    dataStartIndex = _ref4.dataStartIndex,
    displayedData = _ref4.displayedData,
    offset = _ref4.offset;
  var layout = props.layout;
  var hasStack = stackedData && stackedData.length;
  var baseValue = _Area$2.getBaseValue(props, item, xAxis, yAxis);
  var isHorizontalLayout = layout === 'horizontal';
  var isRange = false;
  var points = displayedData.map(function (entry, index) {
    var value;
    if (hasStack) {
      value = stackedData[dataStartIndex + index];
    } else {
      value = (0, _ChartUtils$7.getValueByDataKey)(entry, dataKey);
      if (!Array.isArray(value)) {
        value = [baseValue, value];
      } else {
        isRange = true;
      }
    }
    var isBreakPoint = value[1] == null || hasStack && (0, _ChartUtils$7.getValueByDataKey)(entry, dataKey) == null;
    if (isHorizontalLayout) {
      return {
        x: (0, _ChartUtils$7.getCateCoordinateOfLine)({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index
        }),
        y: isBreakPoint ? null : yAxis.scale(value[1]),
        value: value,
        payload: entry
      };
    }
    return {
      x: isBreakPoint ? null : xAxis.scale(value[1]),
      y: (0, _ChartUtils$7.getCateCoordinateOfLine)({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index
      }),
      value: value,
      payload: entry
    };
  });
  var baseLine;
  if (hasStack || isRange) {
    baseLine = points.map(function (entry) {
      var x = Array.isArray(entry.value) ? entry.value[0] : null;
      if (isHorizontalLayout) {
        return {
          x: entry.x,
          y: x != null && entry.y != null ? yAxis.scale(x) : null
        };
      }
      return {
        x: x != null ? xAxis.scale(x) : null,
        y: entry.y
      };
    });
  } else {
    baseLine = isHorizontalLayout ? yAxis.scale(baseValue) : xAxis.scale(baseValue);
  }
  return _objectSpread$d({
    points: points,
    baseLine: baseLine,
    layout: layout,
    isRange: isRange
  }, offset);
});
_defineProperty$k(Area, "renderDotItem", function (option, props) {
  var dotItem;
  if ( /*#__PURE__*/_react$j["default"].isValidElement(option)) {
    dotItem = /*#__PURE__*/_react$j["default"].cloneElement(option, props);
  } else if ((0, _isFunction$5["default"])(option)) {
    dotItem = option(props);
  } else {
    var className = (0, _clsx$9["default"])('recharts-area-dot', typeof option !== 'boolean' ? option.className : '');
    var key = props.key,
      rest = _objectWithoutProperties$8(props, _excluded2$2);
    dotItem = /*#__PURE__*/_react$j["default"].createElement(_Dot$1.Dot, _extends$g({}, rest, {
      key: key,
      className: className
    }));
  }
  return dotItem;
});

var Scatter$1 = {};

var ZAxis$1 = {};

Object.defineProperty(ZAxis$1, "__esModule", {
  value: true
});
ZAxis$1.ZAxis = void 0;
var _react$i = _interopRequireDefault$n(React__default$4);
function _interopRequireDefault$n(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$e(o) { "@babel/helpers - typeof"; return _typeof$e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$e(o); }
function _classCallCheck$n(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$h(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$b(descriptor.key), descriptor); } }
function _createClass$n(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$h(Constructor.prototype, protoProps); if (staticProps) _defineProperties$h(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$7(t, o, e) { return o = _getPrototypeOf$8(o), _possibleConstructorReturn$e(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf$8(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$e(self, call) { if (call && (_typeof$e(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$8(self); }
function _assertThisInitialized$8(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$8() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$8(o) { _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$8(o); }
function _inherits$e(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$8(subClass, superClass); }
function _setPrototypeOf$8(o, p) { _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$8(o, p); }
function _defineProperty$j(obj, key, value) { key = _toPropertyKey$b(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$b(t) { var i = _toPrimitive$b(t, "string"); return "symbol" == _typeof$e(i) ? i : i + ""; }
function _toPrimitive$b(t, r) { if ("object" != _typeof$e(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$e(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Z Axis
 */
// eslint-disable-next-line react/prefer-stateless-function -- requires static defaultProps
var ZAxis = ZAxis$1.ZAxis = /*#__PURE__*/function (_React$Component) {
  function ZAxis() {
    _classCallCheck$n(this, ZAxis);
    return _callSuper$7(this, ZAxis, arguments);
  }
  _inherits$e(ZAxis, _React$Component);
  return _createClass$n(ZAxis, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);
}(_react$i["default"].Component);
_defineProperty$j(ZAxis, "displayName", 'ZAxis');
_defineProperty$j(ZAxis, "defaultProps", {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto',
  type: 'number'
});

var ScatterUtils = {};

Object.defineProperty(ScatterUtils, "__esModule", {
  value: true
});
ScatterUtils.ScatterSymbol = ScatterSymbol;
var _react$h = _interopRequireDefault$m(React__default$4);
var _Symbols = Symbols$1;
var _ActiveShapeUtils$2 = ActiveShapeUtils;
var _excluded$4 = ["option", "isActive"];
function _interopRequireDefault$m(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
function _objectWithoutProperties$7(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ScatterSymbol(_ref) {
  var option = _ref.option,
    isActive = _ref.isActive,
    props = _objectWithoutProperties$7(_ref, _excluded$4);
  if (typeof option === 'string') {
    return /*#__PURE__*/_react$h["default"].createElement(_ActiveShapeUtils$2.Shape, _extends$f({
      option: /*#__PURE__*/_react$h["default"].createElement(_Symbols.Symbols, _extends$f({
        type: option
      }, props)),
      isActive: isActive,
      shapeType: "symbols"
    }, props));
  }
  return /*#__PURE__*/_react$h["default"].createElement(_ActiveShapeUtils$2.Shape, _extends$f({
    option: option,
    isActive: isActive,
    shapeType: "symbols"
  }, props));
}

Object.defineProperty(Scatter$1, "__esModule", {
  value: true
});
Scatter$1.Scatter = void 0;
var _react$g = _interopRequireWildcard$5(React__default$4);
var _reactSmooth$2 = _interopRequireDefault$l(lib);
var _isNil$1 = _interopRequireDefault$l(isNil_1);
var _isEqual$1 = _interopRequireDefault$l(isEqual_1);
var _isFunction$4 = _interopRequireDefault$l(isFunction_1);
var _clsx$8 = _interopRequireDefault$l(clsx.exports);
var _Layer$5 = Layer;
var _LabelList$1 = LabelList$1;
var _ReactUtils$7 = ReactUtils;
var _Global$2 = Global$1;
var _ZAxis$2 = ZAxis$1;
var _Curve$1 = Curve;
var _ErrorBar = ErrorBar$1;
var _Cell$1 = Cell$2;
var _DataUtils$5 = DataUtils;
var _ChartUtils$6 = ChartUtils;
var _types$2 = types;
var _ScatterUtils = ScatterUtils;
function _interopRequireDefault$l(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$5(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$5 = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$5(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$d(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$5(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$d(o) { "@babel/helpers - typeof"; return _typeof$d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$d(o); }
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) { _defineProperty$i(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$m(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$g(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$a(descriptor.key), descriptor); } }
function _createClass$m(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$g(Constructor.prototype, protoProps); if (staticProps) _defineProperties$g(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$6(t, o, e) { return o = _getPrototypeOf$7(o), _possibleConstructorReturn$d(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf$7(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$d(self, call) { if (call && (_typeof$d(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$7(self); }
function _assertThisInitialized$7(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$7() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$7(o) { _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$7(o); }
function _inherits$d(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$7(subClass, superClass); }
function _setPrototypeOf$7(o, p) { _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$7(o, p); }
function _defineProperty$i(obj, key, value) { key = _toPropertyKey$a(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$a(t) { var i = _toPrimitive$a(t, "string"); return "symbol" == _typeof$d(i) ? i : i + ""; }
function _toPrimitive$a(t, r) { if ("object" != _typeof$d(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$d(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Render a group of scatters
 */
var Scatter = Scatter$1.Scatter = /*#__PURE__*/function (_PureComponent) {
  function Scatter() {
    var _this;
    _classCallCheck$m(this, Scatter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$6(this, Scatter, [].concat(args));
    _defineProperty$i(_this, "state", {
      isAnimationFinished: false
    });
    _defineProperty$i(_this, "handleAnimationEnd", function () {
      _this.setState({
        isAnimationFinished: true
      });
    });
    _defineProperty$i(_this, "handleAnimationStart", function () {
      _this.setState({
        isAnimationFinished: false
      });
    });
    _defineProperty$i(_this, "id", (0, _DataUtils$5.uniqueId)('recharts-scatter-'));
    return _this;
  }
  _inherits$d(Scatter, _PureComponent);
  return _createClass$m(Scatter, [{
    key: "renderSymbolsStatically",
    value: function renderSymbolsStatically(points) {
      var _this2 = this;
      var _this$props = this.props,
        shape = _this$props.shape,
        activeShape = _this$props.activeShape,
        activeIndex = _this$props.activeIndex;
      var baseProps = (0, _ReactUtils$7.filterProps)(this.props, false);
      return points.map(function (entry, i) {
        var isActive = activeIndex === i;
        var option = isActive ? activeShape : shape;
        var props = _objectSpread$c(_objectSpread$c({}, baseProps), entry);
        return /*#__PURE__*/_react$g["default"].createElement(_Layer$5.Layer, _extends$e({
          className: "recharts-scatter-symbol"
          // eslint-disable-next-line react/no-array-index-key
          ,
          key: "symbol-".concat(entry === null || entry === void 0 ? void 0 : entry.cx, "-").concat(entry === null || entry === void 0 ? void 0 : entry.cy, "-").concat(entry === null || entry === void 0 ? void 0 : entry.size, "-").concat(i)
        }, (0, _types$2.adaptEventsOfChild)(_this2.props, entry, i), {
          role: "img"
        }), /*#__PURE__*/_react$g["default"].createElement(_ScatterUtils.ScatterSymbol, _extends$e({
          option: option,
          isActive: isActive
          // eslint-disable-next-line react/no-array-index-key
          ,
          key: "symbol-".concat(i)
        }, props)));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function renderSymbolsWithAnimation() {
      var _this3 = this;
      var _this$props2 = this.props,
        points = _this$props2.points,
        isAnimationActive = _this$props2.isAnimationActive,
        animationBegin = _this$props2.animationBegin,
        animationDuration = _this$props2.animationDuration,
        animationEasing = _this$props2.animationEasing,
        animationId = _this$props2.animationId;
      var prevPoints = this.state.prevPoints;
      return /*#__PURE__*/_react$g["default"].createElement(_reactSmooth$2["default"], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var stepData = points.map(function (entry, index) {
          var prev = prevPoints && prevPoints[index];
          if (prev) {
            var interpolatorCx = (0, _DataUtils$5.interpolateNumber)(prev.cx, entry.cx);
            var interpolatorCy = (0, _DataUtils$5.interpolateNumber)(prev.cy, entry.cy);
            var interpolatorSize = (0, _DataUtils$5.interpolateNumber)(prev.size, entry.size);
            return _objectSpread$c(_objectSpread$c({}, entry), {}, {
              cx: interpolatorCx(t),
              cy: interpolatorCy(t),
              size: interpolatorSize(t)
            });
          }
          var interpolator = (0, _DataUtils$5.interpolateNumber)(0, entry.size);
          return _objectSpread$c(_objectSpread$c({}, entry), {}, {
            size: interpolator(t)
          });
        });
        return /*#__PURE__*/_react$g["default"].createElement(_Layer$5.Layer, null, _this3.renderSymbolsStatically(stepData));
      });
    }
  }, {
    key: "renderSymbols",
    value: function renderSymbols() {
      var _this$props3 = this.props,
        points = _this$props3.points,
        isAnimationActive = _this$props3.isAnimationActive;
      var prevPoints = this.state.prevPoints;
      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual$1["default"])(prevPoints, points))) {
        return this.renderSymbolsWithAnimation();
      }
      return this.renderSymbolsStatically(points);
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar() {
      var isAnimationActive = this.props.isAnimationActive;
      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }
      var _this$props4 = this.props,
        points = _this$props4.points,
        xAxis = _this$props4.xAxis,
        yAxis = _this$props4.yAxis,
        children = _this$props4.children;
      var errorBarItems = (0, _ReactUtils$7.findAllByType)(children, _ErrorBar.ErrorBar);
      if (!errorBarItems) {
        return null;
      }
      return errorBarItems.map(function (item, i) {
        var _item$props = item.props,
          direction = _item$props.direction,
          errorDataKey = _item$props.dataKey;
        return /*#__PURE__*/_react$g["default"].cloneElement(item, {
          key: "".concat(direction, "-").concat(errorDataKey, "-").concat(points[i]),
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: direction === 'x' ? 'vertical' : 'horizontal',
          dataPointFormatter: function dataPointFormatter(dataPoint, dataKey) {
            return {
              x: dataPoint.cx,
              y: dataPoint.cy,
              value: direction === 'x' ? +dataPoint.node.x : +dataPoint.node.y,
              errorVal: (0, _ChartUtils$6.getValueByDataKey)(dataPoint, dataKey)
            };
          }
        });
      });
    }
  }, {
    key: "renderLine",
    value: function renderLine() {
      var _this$props5 = this.props,
        points = _this$props5.points,
        line = _this$props5.line,
        lineType = _this$props5.lineType,
        lineJointType = _this$props5.lineJointType;
      var scatterProps = (0, _ReactUtils$7.filterProps)(this.props, false);
      var customLineProps = (0, _ReactUtils$7.filterProps)(line, false);
      var linePoints, lineItem;
      if (lineType === 'joint') {
        linePoints = points.map(function (entry) {
          return {
            x: entry.cx,
            y: entry.cy
          };
        });
      } else if (lineType === 'fitting') {
        var _getLinearRegression = (0, _DataUtils$5.getLinearRegression)(points),
          xmin = _getLinearRegression.xmin,
          xmax = _getLinearRegression.xmax,
          a = _getLinearRegression.a,
          b = _getLinearRegression.b;
        var linearExp = function linearExp(x) {
          return a * x + b;
        };
        linePoints = [{
          x: xmin,
          y: linearExp(xmin)
        }, {
          x: xmax,
          y: linearExp(xmax)
        }];
      }
      var lineProps = _objectSpread$c(_objectSpread$c(_objectSpread$c({}, scatterProps), {}, {
        fill: 'none',
        stroke: scatterProps && scatterProps.fill
      }, customLineProps), {}, {
        points: linePoints
      });
      if ( /*#__PURE__*/_react$g["default"].isValidElement(line)) {
        lineItem = /*#__PURE__*/_react$g["default"].cloneElement(line, lineProps);
      } else if ((0, _isFunction$4["default"])(line)) {
        lineItem = line(lineProps);
      } else {
        lineItem = /*#__PURE__*/_react$g["default"].createElement(_Curve$1.Curve, _extends$e({}, lineProps, {
          type: lineJointType
        }));
      }
      return /*#__PURE__*/_react$g["default"].createElement(_Layer$5.Layer, {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, lineItem);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        hide = _this$props6.hide,
        points = _this$props6.points,
        line = _this$props6.line,
        className = _this$props6.className,
        xAxis = _this$props6.xAxis,
        yAxis = _this$props6.yAxis,
        left = _this$props6.left,
        top = _this$props6.top,
        width = _this$props6.width,
        height = _this$props6.height,
        id = _this$props6.id,
        isAnimationActive = _this$props6.isAnimationActive;
      if (hide || !points || !points.length) {
        return null;
      }
      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = (0, _clsx$8["default"])('recharts-scatter', className);
      var needClipX = xAxis && xAxis.allowDataOverflow;
      var needClipY = yAxis && yAxis.allowDataOverflow;
      var needClip = needClipX || needClipY;
      var clipPathId = (0, _isNil$1["default"])(id) ? this.id : id;
      return /*#__PURE__*/_react$g["default"].createElement(_Layer$5.Layer, {
        className: layerClass,
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, needClipX || needClipY ? /*#__PURE__*/_react$g["default"].createElement("defs", null, /*#__PURE__*/_react$g["default"].createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /*#__PURE__*/_react$g["default"].createElement("rect", {
        x: needClipX ? left : left - width / 2,
        y: needClipY ? top : top - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
      }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/_react$g["default"].createElement(_Layer$5.Layer, {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && _LabelList$1.LabelList.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          prevPoints: prevState.curPoints
        };
      }
      if (nextProps.points !== prevState.curPoints) {
        return {
          curPoints: nextProps.points
        };
      }
      return null;
    }
  }]);
}(_react$g.PureComponent);
_defineProperty$i(Scatter, "displayName", 'Scatter');
_defineProperty$i(Scatter, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: 'circle',
  lineType: 'joint',
  lineJointType: 'linear',
  data: [],
  shape: 'circle',
  hide: false,
  isAnimationActive: !_Global$2.Global.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'linear'
});
/**
 * Compose the data of each group
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */
_defineProperty$i(Scatter, "getComposedData", function (_ref2) {
  var xAxis = _ref2.xAxis,
    yAxis = _ref2.yAxis,
    zAxis = _ref2.zAxis,
    item = _ref2.item,
    displayedData = _ref2.displayedData,
    xAxisTicks = _ref2.xAxisTicks,
    yAxisTicks = _ref2.yAxisTicks,
    offset = _ref2.offset;
  var tooltipType = item.props.tooltipType;
  var cells = (0, _ReactUtils$7.findAllByType)(item.props.children, _Cell$1.Cell);
  var xAxisDataKey = (0, _isNil$1["default"])(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
  var yAxisDataKey = (0, _isNil$1["default"])(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
  var zAxisDataKey = zAxis && zAxis.dataKey;
  var defaultRangeZ = zAxis ? zAxis.range : _ZAxis$2.ZAxis.defaultProps.range;
  var defaultZ = defaultRangeZ && defaultRangeZ[0];
  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
  var points = displayedData.map(function (entry, index) {
    var x = (0, _ChartUtils$6.getValueByDataKey)(entry, xAxisDataKey);
    var y = (0, _ChartUtils$6.getValueByDataKey)(entry, yAxisDataKey);
    var z = !(0, _isNil$1["default"])(zAxisDataKey) && (0, _ChartUtils$6.getValueByDataKey)(entry, zAxisDataKey) || '-';
    var tooltipPayload = [{
      name: (0, _isNil$1["default"])(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
      unit: xAxis.unit || '',
      value: x,
      payload: entry,
      dataKey: xAxisDataKey,
      type: tooltipType
    }, {
      name: (0, _isNil$1["default"])(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
      unit: yAxis.unit || '',
      value: y,
      payload: entry,
      dataKey: yAxisDataKey,
      type: tooltipType
    }];
    if (z !== '-') {
      tooltipPayload.push({
        name: zAxis.name || zAxis.dataKey,
        unit: zAxis.unit || '',
        value: z,
        payload: entry,
        dataKey: zAxisDataKey,
        type: tooltipType
      });
    }
    var cx = (0, _ChartUtils$6.getCateCoordinateOfLine)({
      axis: xAxis,
      ticks: xAxisTicks,
      bandSize: xBandSize,
      entry: entry,
      index: index,
      dataKey: xAxisDataKey
    });
    var cy = (0, _ChartUtils$6.getCateCoordinateOfLine)({
      axis: yAxis,
      ticks: yAxisTicks,
      bandSize: yBandSize,
      entry: entry,
      index: index,
      dataKey: yAxisDataKey
    });
    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
    return _objectSpread$c(_objectSpread$c({}, entry), {}, {
      cx: cx,
      cy: cy,
      x: cx - radius,
      y: cy - radius,
      xAxis: xAxis,
      yAxis: yAxis,
      zAxis: zAxis,
      width: 2 * radius,
      height: 2 * radius,
      size: size,
      node: {
        x: x,
        y: y,
        z: z
      },
      tooltipPayload: tooltipPayload,
      tooltipPosition: {
        x: cx,
        y: cy
      },
      payload: entry
    }, cells && cells[index] && cells[index].props);
  });
  return _objectSpread$c({
    points: points
  }, offset);
});

var XAxis$1 = {};

function _typeof$c(o) { "@babel/helpers - typeof"; return _typeof$c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$c(o); }
Object.defineProperty(XAxis$1, "__esModule", {
  value: true
});
XAxis$1.XAxis = void 0;
var _react$f = _interopRequireDefault$k(React__default$4);
var _clsx$7 = _interopRequireDefault$k(clsx.exports);
var _chartLayoutContext$2 = chartLayoutContext;
var _CartesianAxis$1 = CartesianAxis$1;
var _ChartUtils$5 = ChartUtils;
function _interopRequireDefault$k(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck$l(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$f(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$9(descriptor.key), descriptor); } }
function _createClass$l(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$f(Constructor.prototype, protoProps); if (staticProps) _defineProperties$f(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$5(t, o, e) { return o = _getPrototypeOf$6(o), _possibleConstructorReturn$c(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf$6(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$c(self, call) { if (call && (_typeof$c(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$6(self); }
function _assertThisInitialized$6(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$6() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$6(o) { _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$6(o); }
function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$6(subClass, superClass); }
function _setPrototypeOf$6(o, p) { _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$6(o, p); }
function _defineProperty$h(obj, key, value) { key = _toPropertyKey$9(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$9(t) { var i = _toPrimitive$9(t, "string"); return "symbol" == _typeof$c(i) ? i : i + ""; }
function _toPrimitive$9(t, r) { if ("object" != _typeof$c(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$c(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); } /**
 * @fileOverview X Axis
 */
/** Define of XAxis props */

function XAxisImpl(_ref) {
  var xAxisId = _ref.xAxisId;
  var width = (0, _chartLayoutContext$2.useChartWidth)();
  var height = (0, _chartLayoutContext$2.useChartHeight)();
  var axisOptions = (0, _chartLayoutContext$2.useXAxisOrThrow)(xAxisId);
  if (axisOptions == null) {
    return null;
  }
  return (
    /*#__PURE__*/
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    _react$f["default"].createElement(_CartesianAxis$1.CartesianAxis, _extends$d({}, axisOptions, {
      className: (0, _clsx$7["default"])("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
      viewBox: {
        x: 0,
        y: 0,
        width: width,
        height: height
      },
      ticksGenerator: function ticksGenerator(axis) {
        return (0, _ChartUtils$5.getTicksOfAxis)(axis, true);
      }
    }))
  );
}

// eslint-disable-next-line react/prefer-stateless-function -- requires static defaultProps
var XAxis = XAxis$1.XAxis = /*#__PURE__*/function (_React$Component) {
  function XAxis() {
    _classCallCheck$l(this, XAxis);
    return _callSuper$5(this, XAxis, arguments);
  }
  _inherits$c(XAxis, _React$Component);
  return _createClass$l(XAxis, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react$f["default"].createElement(XAxisImpl, this.props);
    }
  }]);
}(_react$f["default"].Component);
_defineProperty$h(XAxis, "displayName", 'XAxis');
_defineProperty$h(XAxis, "defaultProps", {
  allowDecimals: true,
  hide: false,
  orientation: 'bottom',
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: 'category',
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false,
  allowDuplicatedCategory: true
});

var YAxis$1 = {};

function _typeof$b(o) { "@babel/helpers - typeof"; return _typeof$b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$b(o); }
Object.defineProperty(YAxis$1, "__esModule", {
  value: true
});
YAxis$1.YAxis = void 0;
var _react$e = _interopRequireDefault$j(React__default$4);
var _clsx$6 = _interopRequireDefault$j(clsx.exports);
var _chartLayoutContext$1 = chartLayoutContext;
var _CartesianAxis = CartesianAxis$1;
var _ChartUtils$4 = ChartUtils;
function _interopRequireDefault$j(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck$k(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$e(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$8(descriptor.key), descriptor); } }
function _createClass$k(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$e(Constructor.prototype, protoProps); if (staticProps) _defineProperties$e(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$4(t, o, e) { return o = _getPrototypeOf$5(o), _possibleConstructorReturn$b(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf$5(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$b(self, call) { if (call && (_typeof$b(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$5(self); }
function _assertThisInitialized$5(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$5() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$5(o) { _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$5(o); }
function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$5(subClass, superClass); }
function _setPrototypeOf$5(o, p) { _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$5(o, p); }
function _defineProperty$g(obj, key, value) { key = _toPropertyKey$8(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$8(t) { var i = _toPrimitive$8(t, "string"); return "symbol" == _typeof$b(i) ? i : i + ""; }
function _toPrimitive$8(t, r) { if ("object" != _typeof$b(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$b(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); } /**
 * @fileOverview Y Axis
 */
var YAxisImpl = function YAxisImpl(_ref) {
  var yAxisId = _ref.yAxisId;
  var width = (0, _chartLayoutContext$1.useChartWidth)();
  var height = (0, _chartLayoutContext$1.useChartHeight)();
  var axisOptions = (0, _chartLayoutContext$1.useYAxisOrThrow)(yAxisId);
  if (axisOptions == null) {
    return null;
  }
  return (
    /*#__PURE__*/
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    _react$e["default"].createElement(_CartesianAxis.CartesianAxis, _extends$c({}, axisOptions, {
      className: (0, _clsx$6["default"])("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
      viewBox: {
        x: 0,
        y: 0,
        width: width,
        height: height
      },
      ticksGenerator: function ticksGenerator(axis) {
        return (0, _ChartUtils$4.getTicksOfAxis)(axis, true);
      }
    }))
  );
};

// eslint-disable-next-line react/prefer-stateless-function -- requires static defaultProps
var YAxis = YAxis$1.YAxis = /*#__PURE__*/function (_React$Component) {
  function YAxis() {
    _classCallCheck$k(this, YAxis);
    return _callSuper$4(this, YAxis, arguments);
  }
  _inherits$b(YAxis, _React$Component);
  return _createClass$k(YAxis, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react$e["default"].createElement(YAxisImpl, this.props);
    }
  }]);
}(_react$e["default"].Component);
_defineProperty$g(YAxis, "displayName", 'YAxis');
_defineProperty$g(YAxis, "defaultProps", {
  allowDuplicatedCategory: true,
  allowDecimals: true,
  hide: false,
  orientation: 'left',
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: 'number',
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false
});

var LineChart = {};

var generateCategoricalChart = {};

var DetectReferenceElementsDomain = {};

Object.defineProperty(DetectReferenceElementsDomain, "__esModule", {
  value: true
});
DetectReferenceElementsDomain.detectReferenceElementsDomain = void 0;
var _ReferenceDot = ReferenceDot$1;
var _ReferenceLine = ReferenceLine$1;
var _ReferenceArea = ReferenceArea$1;
var _IfOverflowMatches = IfOverflowMatches;
var _ReactUtils$6 = ReactUtils;
var _DataUtils$4 = DataUtils;
function _toConsumableArray$2(arr) { return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$g(arr) || _nonIterableSpread$2(); }
function _nonIterableSpread$2() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$g(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$g(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$g(o, minLen); }
function _iterableToArray$2(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$2(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$g(arr); }
function _arrayLikeToArray$g(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
DetectReferenceElementsDomain.detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
  var lines = (0, _ReactUtils$6.findAllByType)(children, _ReferenceLine.ReferenceLine);
  var dots = (0, _ReactUtils$6.findAllByType)(children, _ReferenceDot.ReferenceDot);
  var elements = [].concat(_toConsumableArray$2(lines), _toConsumableArray$2(dots));
  var areas = (0, _ReactUtils$6.findAllByType)(children, _ReferenceArea.ReferenceArea);
  var idKey = "".concat(axisType, "Id");
  var valueKey = axisType[0];
  var finalDomain = domain;
  if (elements.length) {
    finalDomain = elements.reduce(function (result, el) {
      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils$4.isNumber)(el.props[valueKey])) {
        var value = el.props[valueKey];
        return [Math.min(result[0], value), Math.max(result[1], value)];
      }
      return result;
    }, finalDomain);
  }
  if (areas.length) {
    var key1 = "".concat(valueKey, "1");
    var key2 = "".concat(valueKey, "2");
    finalDomain = areas.reduce(function (result, el) {
      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils$4.isNumber)(el.props[key1]) && (0, _DataUtils$4.isNumber)(el.props[key2])) {
        var value1 = el.props[key1];
        var value2 = el.props[key2];
        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
      }
      return result;
    }, finalDomain);
  }
  if (specifiedTicks && specifiedTicks.length) {
    finalDomain = specifiedTicks.reduce(function (result, tick) {
      if ((0, _DataUtils$4.isNumber)(tick)) {
        return [Math.min(result[0], tick), Math.max(result[1], tick)];
      }
      return result;
    }, finalDomain);
  }
  return finalDomain;
};

var Events = {};

var eventemitter3 = {exports: {}};

(function (module) {

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
{
  module.exports = EventEmitter;
}
}(eventemitter3));

Object.defineProperty(Events, "__esModule", {
  value: true
});
Events.eventCenter = Events.SYNC_EVENT = void 0;
var _eventemitter = _interopRequireDefault$i(eventemitter3.exports);
function _interopRequireDefault$i(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
Events.eventCenter = new _eventemitter["default"]();
Events.SYNC_EVENT = 'recharts.syncMouseEvents';

var AccessibilityManager = {};

Object.defineProperty(AccessibilityManager, "__esModule", {
  value: true
});
AccessibilityManager.AccessibilityManager = void 0;
function _typeof$a(o) { "@babel/helpers - typeof"; return _typeof$a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$a(o); }
function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$d(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$7(descriptor.key), descriptor); } }
function _createClass$j(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$d(Constructor.prototype, protoProps); if (staticProps) _defineProperties$d(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty$f(obj, key, value) { key = _toPropertyKey$7(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$7(t) { var i = _toPrimitive$7(t, "string"); return "symbol" == _typeof$a(i) ? i : i + ""; }
function _toPrimitive$7(t, r) { if ("object" != _typeof$a(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$a(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
AccessibilityManager.AccessibilityManager = /*#__PURE__*/function () {
  function AccessibilityManager() {
    _classCallCheck$j(this, AccessibilityManager);
    _defineProperty$f(this, "activeIndex", 0);
    _defineProperty$f(this, "coordinateList", []);
    _defineProperty$f(this, "layout", 'horizontal');
  }
  return _createClass$j(AccessibilityManager, [{
    key: "setDetails",
    value: function setDetails(_ref) {
      var _ref2;
      var _ref$coordinateList = _ref.coordinateList,
        coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList,
        _ref$container = _ref.container,
        container = _ref$container === void 0 ? null : _ref$container,
        _ref$layout = _ref.layout,
        layout = _ref$layout === void 0 ? null : _ref$layout,
        _ref$offset = _ref.offset,
        offset = _ref$offset === void 0 ? null : _ref$offset,
        _ref$mouseHandlerCall = _ref.mouseHandlerCallback,
        mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
      this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
      this.container = container !== null && container !== void 0 ? container : this.container;
      this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
      this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
      this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;

      // Keep activeIndex in the bounds between 0 and the last coordinate index
      this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function keyboardEvent(e) {
      // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
      // it can cause errors. We use this function to check. We don't want arrow keys to be processed
      // if there are no tooltips, since that will cause unexpected behavior of users.
      if (this.coordinateList.length === 0) {
        return;
      }
      switch (e.key) {
        case 'ArrowRight':
          {
            if (this.layout !== 'horizontal') {
              return;
            }
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
            this.spoofMouse();
            break;
          }
        case 'ArrowLeft':
          {
            if (this.layout !== 'horizontal') {
              return;
            }
            this.activeIndex = Math.max(this.activeIndex - 1, 0);
            this.spoofMouse();
            break;
          }
      }
    }
  }, {
    key: "setIndex",
    value: function setIndex(newIndex) {
      this.activeIndex = newIndex;
    }
  }, {
    key: "spoofMouse",
    value: function spoofMouse() {
      var _window, _window2;
      if (this.layout !== 'horizontal') {
        return;
      }

      // This can happen when the tooltips suddenly stop existing as children of the component
      // That update doesn't otherwise fire events, so we have to double check here.
      if (this.coordinateList.length === 0) {
        return;
      }
      var _this$container$getBo = this.container.getBoundingClientRect(),
        x = _this$container$getBo.x,
        y = _this$container$getBo.y,
        height = _this$container$getBo.height;
      var coordinate = this.coordinateList[this.activeIndex].coordinate;
      var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
      var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
      var pageX = x + coordinate + scrollOffsetX;
      var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
      this.mouseHandlerCallback({
        pageX: pageX,
        pageY: pageY
      });
    }
  }]);
}();

var isDomainSpecifiedByUser$1 = {};

Object.defineProperty(isDomainSpecifiedByUser$1, "__esModule", {
  value: true
});
isDomainSpecifiedByUser$1.isDomainSpecifiedByUser = isDomainSpecifiedByUser;
var _DataUtils$3 = DataUtils;
/**
 * Takes a domain and user props to determine whether he provided the domain via props or if we need to calculate it.
 * @param   {AxisDomain}  domain              The potential domain from props
 * @param   {Boolean}     allowDataOverflow   from props
 * @param   {String}      axisType            from props
 * @returns {Boolean}                         `true` if domain is specified by user
 */
function isDomainSpecifiedByUser(domain, allowDataOverflow, axisType) {
  if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
    var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
    var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];

    /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */
    if (!!domainStart && !!domainEnd && (0, _DataUtils$3.isNumber)(domainStart) && (0, _DataUtils$3.isNumber)(domainEnd)) {
      return true;
    }
  }
  return false;
}

var Cursor$1 = {};

var getCursorRectangle$1 = {};

Object.defineProperty(getCursorRectangle$1, "__esModule", {
  value: true
});
getCursorRectangle$1.getCursorRectangle = getCursorRectangle;
function getCursorRectangle(layout, activeCoordinate, offset, tooltipAxisBandSize) {
  var halfSize = tooltipAxisBandSize / 2;
  return {
    stroke: 'none',
    fill: '#ccc',
    x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
    y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
    width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
    height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
  };
}

var getRadialCursorPoints$1 = {};

Object.defineProperty(getRadialCursorPoints$1, "__esModule", {
  value: true
});
getRadialCursorPoints$1.getRadialCursorPoints = getRadialCursorPoints;
var _PolarUtils$6 = PolarUtils;
/**
 * Only applicable for radial layouts
 * @param {Object} activeCoordinate ChartCoordinate
 * @returns {Object} RadialCursorPoints
 */
function getRadialCursorPoints(activeCoordinate) {
  var cx = activeCoordinate.cx,
    cy = activeCoordinate.cy,
    radius = activeCoordinate.radius,
    startAngle = activeCoordinate.startAngle,
    endAngle = activeCoordinate.endAngle;
  var startPoint = (0, _PolarUtils$6.polarToCartesian)(cx, cy, radius, startAngle);
  var endPoint = (0, _PolarUtils$6.polarToCartesian)(cx, cy, radius, endAngle);
  return {
    points: [startPoint, endPoint],
    cx: cx,
    cy: cy,
    radius: radius,
    startAngle: startAngle,
    endAngle: endAngle
  };
}

var getCursorPoints$1 = {};

Object.defineProperty(getCursorPoints$1, "__esModule", {
  value: true
});
getCursorPoints$1.getCursorPoints = getCursorPoints;
var _PolarUtils$5 = PolarUtils;
var _getRadialCursorPoints$1 = getRadialCursorPoints$1;
function getCursorPoints(layout, activeCoordinate, offset) {
  var x1, y1, x2, y2;
  if (layout === 'horizontal') {
    x1 = activeCoordinate.x;
    x2 = x1;
    y1 = offset.top;
    y2 = offset.top + offset.height;
  } else if (layout === 'vertical') {
    y1 = activeCoordinate.y;
    y2 = y1;
    x1 = offset.left;
    x2 = offset.left + offset.width;
  } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
    if (layout === 'centric') {
      var cx = activeCoordinate.cx,
        cy = activeCoordinate.cy,
        innerRadius = activeCoordinate.innerRadius,
        outerRadius = activeCoordinate.outerRadius,
        angle = activeCoordinate.angle;
      var innerPoint = (0, _PolarUtils$5.polarToCartesian)(cx, cy, innerRadius, angle);
      var outerPoint = (0, _PolarUtils$5.polarToCartesian)(cx, cy, outerRadius, angle);
      x1 = innerPoint.x;
      y1 = innerPoint.y;
      x2 = outerPoint.x;
      y2 = outerPoint.y;
    } else {
      return (0, _getRadialCursorPoints$1.getRadialCursorPoints)(activeCoordinate);
    }
  }
  return [{
    x: x1,
    y: y1
  }, {
    x: x2,
    y: y2
  }];
}

Object.defineProperty(Cursor$1, "__esModule", {
  value: true
});
Cursor$1.Cursor = Cursor;
var _react$d = React__default$4;
var _clsx$5 = _interopRequireDefault$h(clsx.exports);
var _Curve = Curve;
var _Cross = Cross;
var _getCursorRectangle = getCursorRectangle$1;
var _Rectangle$3 = Rectangle;
var _getRadialCursorPoints = getRadialCursorPoints$1;
var _Sector$1 = Sector;
var _getCursorPoints = getCursorPoints$1;
var _ReactUtils$5 = ReactUtils;
function _interopRequireDefault$h(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$9(o) { "@babel/helpers - typeof"; return _typeof$9 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$9(o); }
function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) { _defineProperty$e(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$e(obj, key, value) { key = _toPropertyKey$6(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$6(t) { var i = _toPrimitive$6(t, "string"); return "symbol" == _typeof$9(i) ? i : i + ""; }
function _toPrimitive$6(t, r) { if ("object" != _typeof$9(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$9(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Cursor is the background, or a highlight,
 * that shows when user mouses over or activates
 * an area.
 *
 * It usually shows together with a tooltip
 * to emphasise which part of the chart does the tooltip refer to.
 */
function Cursor(props) {
  var _element$props$cursor, _defaultProps;
  var element = props.element,
    tooltipEventType = props.tooltipEventType,
    isActive = props.isActive,
    activeCoordinate = props.activeCoordinate,
    activePayload = props.activePayload,
    offset = props.offset,
    activeTooltipIndex = props.activeTooltipIndex,
    tooltipAxisBandSize = props.tooltipAxisBandSize,
    layout = props.layout,
    chartName = props.chartName;
  var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
  if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') {
    return null;
  }
  var restProps;
  var cursorComp = _Curve.Curve;
  if (chartName === 'ScatterChart') {
    restProps = activeCoordinate;
    cursorComp = _Cross.Cross;
  } else if (chartName === 'BarChart') {
    restProps = (0, _getCursorRectangle.getCursorRectangle)(layout, activeCoordinate, offset, tooltipAxisBandSize);
    cursorComp = _Rectangle$3.Rectangle;
  } else if (layout === 'radial') {
    var _getRadialCursorPoint = (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate),
      cx = _getRadialCursorPoint.cx,
      cy = _getRadialCursorPoint.cy,
      radius = _getRadialCursorPoint.radius,
      startAngle = _getRadialCursorPoint.startAngle,
      endAngle = _getRadialCursorPoint.endAngle;
    restProps = {
      cx: cx,
      cy: cy,
      startAngle: startAngle,
      endAngle: endAngle,
      innerRadius: radius,
      outerRadius: radius
    };
    cursorComp = _Sector$1.Sector;
  } else {
    restProps = {
      points: (0, _getCursorPoints.getCursorPoints)(layout, activeCoordinate, offset)
    };
    cursorComp = _Curve.Curve;
  }
  var cursorProps = _objectSpread$b(_objectSpread$b(_objectSpread$b(_objectSpread$b({
    stroke: '#ccc',
    pointerEvents: 'none'
  }, offset), restProps), (0, _ReactUtils$5.filterProps)(elementPropsCursor, false)), {}, {
    payload: activePayload,
    payloadIndex: activeTooltipIndex,
    className: (0, _clsx$5["default"])('recharts-tooltip-cursor', elementPropsCursor.className)
  });
  return /*#__PURE__*/(0, _react$d.isValidElement)(elementPropsCursor) ? /*#__PURE__*/(0, _react$d.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/(0, _react$d.createElement)(cursorComp, cursorProps);
}

Object.defineProperty(generateCategoricalChart, "__esModule", {
  value: true
});
generateCategoricalChart.getAxisMapByAxes = generateCategoricalChart.generateCategoricalChart = generateCategoricalChart.createDefaultState = void 0;
var _react$c = _interopRequireWildcard$4(React__default$4);
var _isNil = _interopRequireDefault$g(isNil_1);
var _isFunction$3 = _interopRequireDefault$g(isFunction_1);
var _range = _interopRequireDefault$g(range_1);
var _get$2 = _interopRequireDefault$g(get_1);
var _sortBy = _interopRequireDefault$g(sortBy_1);
var _throttle = _interopRequireDefault$g(throttle_1);
var _clsx$4 = _interopRequireDefault$g(clsx.exports);
var _tinyInvariant = _interopRequireDefault$g(tinyInvariant_cjs);
var _Surface$3 = Surface$1;
var _Layer$4 = Layer;
var _Tooltip$3 = Tooltip$1;
var _Legend = Legend$1;
var _Dot = Dot;
var _Rectangle$2 = Rectangle;
var _ReactUtils$4 = ReactUtils;
var _Brush = Brush$1;
var _DOMUtils$1 = DOMUtils;
var _DataUtils$2 = DataUtils;
var _ChartUtils$3 = ChartUtils;
var _DetectReferenceElementsDomain = DetectReferenceElementsDomain;
var _PolarUtils$4 = PolarUtils;
var _ShallowEqual$1 = ShallowEqual;
var _Events = Events;
var _types$1 = types;
var _AccessibilityManager = AccessibilityManager;
var _isDomainSpecifiedByUser = isDomainSpecifiedByUser$1;
var _ActiveShapeUtils$1 = ActiveShapeUtils;
var _Cursor = Cursor$1;
var _chartLayoutContext = chartLayoutContext;
var _excluded$3 = ["item"],
  _excluded2$1 = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function _interopRequireDefault$g(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$4(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$4 = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$4(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$8(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$4(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$8(o) { "@babel/helpers - typeof"; return _typeof$8 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$8(o); }
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
function _slicedToArray$8(arr, i) { return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$f(arr, i) || _nonIterableRest$6(); }
function _nonIterableRest$6() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit$6(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$6(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$c(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$5(descriptor.key), descriptor); } }
function _createClass$i(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$c(Constructor.prototype, protoProps); if (staticProps) _defineProperties$c(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$3(t, o, e) { return o = _getPrototypeOf$4(o), _possibleConstructorReturn$a(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf$4(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$a(self, call) { if (call && (_typeof$8(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$4(self); }
function _assertThisInitialized$4(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$4() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$4(o) { _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$4(o); }
function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$4(subClass, superClass); }
function _setPrototypeOf$4(o, p) { _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$4(o, p); }
function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$f(arr) || _nonIterableSpread$1(); }
function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$f(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$f(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$f(o, minLen); }
function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$f(arr); }
function _arrayLikeToArray$f(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) { _defineProperty$d(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$d(obj, key, value) { key = _toPropertyKey$5(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$5(t) { var i = _toPrimitive$5(t, "string"); return "symbol" == _typeof$8(i) ? i : i + ""; }
function _toPrimitive$5(t, r) { if ("object" != _typeof$8(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$8(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // eslint-disable-next-line no-restricted-imports
var ORIENT_MAP = {
  xAxis: ['bottom', 'top'],
  yAxis: ['left', 'right']
};
var FULL_WIDTH_AND_HEIGHT = {
  width: '100%',
  height: '100%'
};
var originCoordinate = {
  x: 0,
  y: 0
};

/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */
function renderAsIs(element) {
  return element;
}
var calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
  if (layout === 'horizontal') {
    return rangeObj.x;
  }
  if (layout === 'vertical') {
    return rangeObj.y;
  }
  if (layout === 'centric') {
    return rangeObj.angle;
  }
  return rangeObj.radius;
};
var getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
  var entry = tooltipTicks.find(function (tick) {
    return tick && tick.index === activeIndex;
  });
  if (entry) {
    if (layout === 'horizontal') {
      return {
        x: entry.coordinate,
        y: rangeObj.y
      };
    }
    if (layout === 'vertical') {
      return {
        x: rangeObj.x,
        y: entry.coordinate
      };
    }
    if (layout === 'centric') {
      var _angle = entry.coordinate;
      var _radius = rangeObj.radius;
      return _objectSpread$a(_objectSpread$a(_objectSpread$a({}, rangeObj), (0, _PolarUtils$4.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
        angle: _angle,
        radius: _radius
      });
    }
    var radius = entry.coordinate;
    var angle = rangeObj.angle;
    return _objectSpread$a(_objectSpread$a(_objectSpread$a({}, rangeObj), (0, _PolarUtils$4.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
      angle: angle,
      radius: radius
    });
  }
  return originCoordinate;
};
var getDisplayedData = function getDisplayedData(data, _ref) {
  var graphicalItems = _ref.graphicalItems,
    dataStartIndex = _ref.dataStartIndex,
    dataEndIndex = _ref.dataEndIndex;
  var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function (result, child) {
    var itemData = child.props.data;
    if (itemData && itemData.length) {
      return [].concat(_toConsumableArray$1(result), _toConsumableArray$1(itemData));
    }
    return result;
  }, []);
  if (itemsData.length > 0) {
    return itemsData;
  }
  if (data && data.length && (0, _DataUtils$2.isNumber)(dataStartIndex) && (0, _DataUtils$2.isNumber)(dataEndIndex)) {
    return data.slice(dataStartIndex, dataEndIndex + 1);
  }
  return [];
};
function getDefaultDomainByAxisType(axisType) {
  return axisType === 'number' ? [0, 'auto'] : undefined;
}

/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */
var getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
  var graphicalItems = state.graphicalItems,
    tooltipAxis = state.tooltipAxis;
  var displayedData = getDisplayedData(chartData, state);
  if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
    return null;
  }
  // get data by activeIndex when the axis don't allow duplicated category
  return graphicalItems.reduce(function (result, child) {
    var _child$props$data;
    /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */
    var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
    if (data && state.dataStartIndex + state.dataEndIndex !== 0 &&
    // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    state.dataEndIndex - state.dataStartIndex >= activeIndex) {
      data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
    }
    var payload;
    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
      // graphic child has data props
      var entries = data === undefined ? displayedData : data;
      payload = (0, _DataUtils$2.findEntryInArray)(entries, tooltipAxis.dataKey, activeLabel);
    } else {
      payload = data && data[activeIndex] || displayedData[activeIndex];
    }
    if (!payload) {
      return result;
    }
    return [].concat(_toConsumableArray$1(result), [(0, _ChartUtils$3.getTooltipItem)(child, payload)]);
  }, []);
};

/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */
var getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
  var rangeData = rangeObj || {
    x: state.chartX,
    y: state.chartY
  };
  var pos = calculateTooltipPos(rangeData, layout);
  var ticks = state.orderedTooltipTicks,
    axis = state.tooltipAxis,
    tooltipTicks = state.tooltipTicks;
  var activeIndex = (0, _ChartUtils$3.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
  if (activeIndex >= 0 && tooltipTicks) {
    var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
    var activePayload = getTooltipContent(state, chartData, activeIndex, activeLabel);
    var activeCoordinate = getActiveCoordinate(layout, ticks, activeIndex, rangeData);
    return {
      activeTooltipIndex: activeIndex,
      activeLabel: activeLabel,
      activePayload: activePayload,
      activeCoordinate: activeCoordinate
    };
  }
  return null;
};

/**
 * Get the configuration of axis by the options of axis instance
 * @param  {Object} props         Latest props
 * @param {Array}  axes           The instance of axes
 * @param  {Array} graphicalItems The instances of item
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}      Configuration
 */
var getAxisMapByAxes = generateCategoricalChart.getAxisMapByAxes = function getAxisMapByAxes(props, _ref2) {
  var axes = _ref2.axes,
    graphicalItems = _ref2.graphicalItems,
    axisType = _ref2.axisType,
    axisIdKey = _ref2.axisIdKey,
    stackGroups = _ref2.stackGroups,
    dataStartIndex = _ref2.dataStartIndex,
    dataEndIndex = _ref2.dataEndIndex;
  var layout = props.layout,
    children = props.children,
    stackOffset = props.stackOffset;
  var isCategorical = (0, _ChartUtils$3.isCategoricalAxis)(layout, axisType);

  // Eliminate duplicated axes
  return axes.reduce(function (result, child) {
    var _childProps$domain2;
    var childProps = child.type.defaultProps !== undefined ? _objectSpread$a(_objectSpread$a({}, child.type.defaultProps), child.props) : child.props;
    var type = childProps.type,
      dataKey = childProps.dataKey,
      allowDataOverflow = childProps.allowDataOverflow,
      allowDuplicatedCategory = childProps.allowDuplicatedCategory,
      scale = childProps.scale,
      ticks = childProps.ticks,
      includeHidden = childProps.includeHidden;
    var axisId = childProps[axisIdKey];
    if (result[axisId]) {
      return result;
    }
    var displayedData = getDisplayedData(props.data, {
      graphicalItems: graphicalItems.filter(function (item) {
        var _defaultProps;
        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
        return itemAxisId === axisId;
      }),
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var domain, duplicateDomain, categoricalDomain;

    /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */
    if ((0, _isDomainSpecifiedByUser.isDomainSpecifiedByUser)(childProps.domain, allowDataOverflow, type)) {
      domain = (0, _ChartUtils$3.parseSpecifiedDomain)(childProps.domain, null, allowDataOverflow);
      /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */
      if (isCategorical && (type === 'number' || scale !== 'auto')) {
        categoricalDomain = (0, _ChartUtils$3.getDomainOfDataByKey)(displayedData, dataKey, 'category');
      }
    }

    // if the domain is defaulted we need this for `originalDomain` as well
    var defaultDomain = getDefaultDomainByAxisType(type);

    // we didn't create the domain from user's props above, so we need to calculate it
    if (!domain || domain.length === 0) {
      var _childProps$domain;
      var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
      if (dataKey) {
        // has dataKey in <Axis />
        domain = (0, _ChartUtils$3.getDomainOfDataByKey)(displayedData, dataKey, type);
        if (type === 'category' && isCategorical) {
          // the field type is category data and this axis is categorical axis
          var duplicate = (0, _DataUtils$2.hasDuplicate)(domain);
          if (allowDuplicatedCategory && duplicate) {
            duplicateDomain = domain;
            // When category axis has duplicated text, serial numbers are used to generate scale
            domain = (0, _range["default"])(0, len);
          } else if (!allowDuplicatedCategory) {
            // remove duplicated category
            domain = (0, _ChartUtils$3.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function (finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray$1(finalDomain), [entry]);
            }, []);
          }
        } else if (type === 'category') {
          // the field type is category data and this axis is numerical axis
          if (!allowDuplicatedCategory) {
            domain = (0, _ChartUtils$3.parseDomainOfCategoryAxis)(childDomain, domain, child).reduce(function (finalDomain, entry) {
              return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNil["default"])(entry) ? finalDomain : [].concat(_toConsumableArray$1(finalDomain), [entry]);
            }, []);
          } else {
            // eliminate undefined or null or empty string
            domain = domain.filter(function (entry) {
              return entry !== '' && !(0, _isNil["default"])(entry);
            });
          }
        } else if (type === 'number') {
          // the field type is numerical
          var errorBarsDomain = (0, _ChartUtils$3.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function (item) {
            var _defaultProps2, _defaultProps3;
            var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
            var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
            return itemAxisId === axisId && (includeHidden || !itemHide);
          }), dataKey, axisType, layout);
          if (errorBarsDomain) {
            domain = errorBarsDomain;
          }
        }
        if (isCategorical && (type === 'number' || scale !== 'auto')) {
          categoricalDomain = (0, _ChartUtils$3.getDomainOfDataByKey)(displayedData, dataKey, 'category');
        }
      } else if (isCategorical) {
        // the axis is a categorical axis
        domain = (0, _range["default"])(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
        // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
        domain = stackOffset === 'expand' ? [0, 1] : (0, _ChartUtils$3.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
      } else {
        domain = (0, _ChartUtils$3.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
          var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
          var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
          return itemAxisId === axisId && (includeHidden || !itemHide);
        }), type, layout, true);
      }
      if (type === 'number') {
        // To detect wether there is any reference lines whose props alwaysShow is true
        domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
        if (childDomain) {
          domain = (0, _ChartUtils$3.parseSpecifiedDomain)(childDomain, domain, allowDataOverflow);
        }
      } else if (type === 'category' && childDomain) {
        var axisDomain = childDomain;
        var isDomainValid = domain.every(function (entry) {
          return axisDomain.indexOf(entry) >= 0;
        });
        if (isDomainValid) {
          domain = axisDomain;
        }
      }
    }
    return _objectSpread$a(_objectSpread$a({}, result), {}, _defineProperty$d({}, axisId, _objectSpread$a(_objectSpread$a({}, childProps), {}, {
      axisType: axisType,
      domain: domain,
      categoricalDomain: categoricalDomain,
      duplicateDomain: duplicateDomain,
      originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
      isCategorical: isCategorical,
      layout: layout
    })));
  }, {});
};

/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */
var getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
  var graphicalItems = _ref3.graphicalItems,
    Axis = _ref3.Axis,
    axisType = _ref3.axisType,
    axisIdKey = _ref3.axisIdKey,
    stackGroups = _ref3.stackGroups,
    dataStartIndex = _ref3.dataStartIndex,
    dataEndIndex = _ref3.dataEndIndex;
  var layout = props.layout,
    children = props.children;
  var displayedData = getDisplayedData(props.data, {
    graphicalItems: graphicalItems,
    dataStartIndex: dataStartIndex,
    dataEndIndex: dataEndIndex
  });
  var len = displayedData.length;
  var isCategorical = (0, _ChartUtils$3.isCategoricalAxis)(layout, axisType);
  var index = -1;

  // The default type of x-axis is category axis,
  // The default contents of x-axis is the serial numbers of data
  // The default type of y-axis is number axis
  // The default contents of y-axis is the domain of data
  return graphicalItems.reduce(function (result, child) {
    var childProps = child.type.defaultProps !== undefined ? _objectSpread$a(_objectSpread$a({}, child.type.defaultProps), child.props) : child.props;
    var axisId = childProps[axisIdKey];
    var originalDomain = getDefaultDomainByAxisType('number');
    if (!result[axisId]) {
      index++;
      var domain;
      if (isCategorical) {
        domain = (0, _range["default"])(0, len);
      } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
        domain = (0, _ChartUtils$3.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
        domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
      } else {
        domain = (0, _ChartUtils$3.parseSpecifiedDomain)(originalDomain, (0, _ChartUtils$3.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
          var _defaultProps4, _defaultProps5;
          var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
          var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
          return itemAxisId === axisId && !itemHide;
        }), 'number', layout), Axis.defaultProps.allowDataOverflow);
        domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
      }
      return _objectSpread$a(_objectSpread$a({}, result), {}, _defineProperty$d({}, axisId, _objectSpread$a(_objectSpread$a({
        axisType: axisType
      }, Axis.defaultProps), {}, {
        hide: true,
        orientation: (0, _get$2["default"])(ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
        domain: domain,
        originalDomain: originalDomain,
        isCategorical: isCategorical,
        layout: layout
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return result;
  }, {});
};

/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */
var getAxisMap = function getAxisMap(props, _ref4) {
  var _ref4$axisType = _ref4.axisType,
    axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType,
    AxisComp = _ref4.AxisComp,
    graphicalItems = _ref4.graphicalItems,
    stackGroups = _ref4.stackGroups,
    dataStartIndex = _ref4.dataStartIndex,
    dataEndIndex = _ref4.dataEndIndex;
  var children = props.children;
  var axisIdKey = "".concat(axisType, "Id");
  // Get all the instance of Axis
  var axes = (0, _ReactUtils$4.findAllByType)(children, AxisComp);
  var axisMap = {};
  if (axes && axes.length) {
    axisMap = getAxisMapByAxes(props, {
      axes: axes,
      graphicalItems: graphicalItems,
      axisType: axisType,
      axisIdKey: axisIdKey,
      stackGroups: stackGroups,
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex
    });
  } else if (graphicalItems && graphicalItems.length) {
    axisMap = getAxisMapByItems(props, {
      Axis: AxisComp,
      graphicalItems: graphicalItems,
      axisType: axisType,
      axisIdKey: axisIdKey,
      stackGroups: stackGroups,
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex
    });
  }
  return axisMap;
};
var tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
  var axis = (0, _DataUtils$2.getAnyElementOfObject)(axisMap);
  var tooltipTicks = (0, _ChartUtils$3.getTicksOfAxis)(axis, false, true);
  return {
    tooltipTicks: tooltipTicks,
    orderedTooltipTicks: (0, _sortBy["default"])(tooltipTicks, function (o) {
      return o.coordinate;
    }),
    tooltipAxis: axis,
    tooltipAxisBandSize: (0, _ChartUtils$3.getBandSizeOfAxis)(axis, tooltipTicks)
  };
};

/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */
var createDefaultState = generateCategoricalChart.createDefaultState = function createDefaultState(props) {
  var children = props.children,
    defaultShowTooltip = props.defaultShowTooltip;
  var brushItem = (0, _ReactUtils$4.findChildByType)(children, _Brush.Brush);
  var startIndex = 0;
  var endIndex = 0;
  if (props.data && props.data.length !== 0) {
    endIndex = props.data.length - 1;
  }
  if (brushItem && brushItem.props) {
    if (brushItem.props.startIndex >= 0) {
      startIndex = brushItem.props.startIndex;
    }
    if (brushItem.props.endIndex >= 0) {
      endIndex = brushItem.props.endIndex;
    }
  }
  return {
    chartX: 0,
    chartY: 0,
    dataStartIndex: startIndex,
    dataEndIndex: endIndex,
    activeTooltipIndex: -1,
    isTooltipActive: Boolean(defaultShowTooltip)
  };
};
var hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
  if (!graphicalItems || !graphicalItems.length) {
    return false;
  }
  return graphicalItems.some(function (item) {
    var name = (0, _ReactUtils$4.getDisplayName)(item && item.type);
    return name && name.indexOf('Bar') >= 0;
  });
};
var getAxisNameByLayout = function getAxisNameByLayout(layout) {
  if (layout === 'horizontal') {
    return {
      numericAxisName: 'yAxis',
      cateAxisName: 'xAxis'
    };
  }
  if (layout === 'vertical') {
    return {
      numericAxisName: 'xAxis',
      cateAxisName: 'yAxis'
    };
  }
  if (layout === 'centric') {
    return {
      numericAxisName: 'radiusAxis',
      cateAxisName: 'angleAxis'
    };
  }
  return {
    numericAxisName: 'angleAxis',
    cateAxisName: 'radiusAxis'
  };
};

/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */
var calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
  var props = _ref5.props,
    graphicalItems = _ref5.graphicalItems,
    _ref5$xAxisMap = _ref5.xAxisMap,
    xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap,
    _ref5$yAxisMap = _ref5.yAxisMap,
    yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
  var width = props.width,
    height = props.height,
    children = props.children;
  var margin = props.margin || {};
  var brushItem = (0, _ReactUtils$4.findChildByType)(children, _Brush.Brush);
  var legendItem = (0, _ReactUtils$4.findChildByType)(children, _Legend.Legend);
  var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
    var entry = yAxisMap[id];
    var orientation = entry.orientation;
    if (!entry.mirror && !entry.hide) {
      return _objectSpread$a(_objectSpread$a({}, result), {}, _defineProperty$d({}, orientation, result[orientation] + entry.width));
    }
    return result;
  }, {
    left: margin.left || 0,
    right: margin.right || 0
  });
  var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
    var entry = xAxisMap[id];
    var orientation = entry.orientation;
    if (!entry.mirror && !entry.hide) {
      return _objectSpread$a(_objectSpread$a({}, result), {}, _defineProperty$d({}, orientation, (0, _get$2["default"])(result, "".concat(orientation)) + entry.height));
    }
    return result;
  }, {
    top: margin.top || 0,
    bottom: margin.bottom || 0
  });
  var offset = _objectSpread$a(_objectSpread$a({}, offsetV), offsetH);
  var brushBottom = offset.bottom;
  if (brushItem) {
    offset.bottom += brushItem.props.height || _Brush.Brush.defaultProps.height;
  }
  if (legendItem && prevLegendBBox) {
    // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, _ChartUtils$3.appendOffsetOfLegend)(offset, graphicalItems, props, prevLegendBBox);
  }
  var offsetWidth = width - offset.left - offset.right;
  var offsetHeight = height - offset.top - offset.bottom;
  return _objectSpread$a(_objectSpread$a({
    brushBottom: brushBottom
  }, offset), {}, {
    // never return negative values for height and width
    width: Math.max(offsetWidth, 0),
    height: Math.max(offsetHeight, 0)
  });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
  if (axisName === 'xAxis') {
    return axisObj[axisName].width;
  }
  if (axisName === 'yAxis') {
    return axisObj[axisName].height;
  }
  // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
  return undefined;
};
generateCategoricalChart.generateCategoricalChart = function generateCategoricalChart(_ref6) {
  var chartName = _ref6.chartName,
    GraphicalChild = _ref6.GraphicalChild,
    _ref6$defaultTooltipE = _ref6.defaultTooltipEventType,
    defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE,
    _ref6$validateTooltip = _ref6.validateTooltipEventTypes,
    validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? ['axis'] : _ref6$validateTooltip,
    axisComponents = _ref6.axisComponents,
    legendContent = _ref6.legendContent,
    formatAxisMap = _ref6.formatAxisMap,
    defaultProps = _ref6.defaultProps;
  var getFormatItems = function getFormatItems(props, currentState) {
    var graphicalItems = currentState.graphicalItems,
      stackGroups = currentState.stackGroups,
      offset = currentState.offset,
      updateId = currentState.updateId,
      dataStartIndex = currentState.dataStartIndex,
      dataEndIndex = currentState.dataEndIndex;
    var barSize = props.barSize,
      layout = props.layout,
      barGap = props.barGap,
      barCategoryGap = props.barCategoryGap,
      globalMaxBarSize = props.maxBarSize;
    var _getAxisNameByLayout = getAxisNameByLayout(layout),
      numericAxisName = _getAxisNameByLayout.numericAxisName,
      cateAxisName = _getAxisNameByLayout.cateAxisName;
    var hasBar = hasGraphicalBarItem(graphicalItems);
    var formattedItems = [];
    graphicalItems.forEach(function (item, index) {
      var displayedData = getDisplayedData(props.data, {
        graphicalItems: [item],
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
      });
      var itemProps = item.type.defaultProps !== undefined ? _objectSpread$a(_objectSpread$a({}, item.type.defaultProps), item.props) : item.props;
      var dataKey = itemProps.dataKey,
        childMaxBarSize = itemProps.maxBarSize;
      // axisId of the numerical axis
      var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
      // axisId of the categorical axis
      var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
      var axisObjInitialValue = {};
      var axisObj = axisComponents.reduce(function (result, entry) {
        var _item$type$displayNam, _item$type;
        // map of axisId to axis for a specific axis type
        var axisMap = currentState["".concat(entry.axisType, "Map")];
        // axisId of axis we are currently computing
        var id = itemProps["".concat(entry.axisType, "Id")];

        /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */
        !(axisMap && axisMap[id] || entry.axisType === 'zAxis') ? process.env.NODE_ENV !== "production" ? (0, _tinyInvariant["default"])(false, "Specifying a(n) ".concat(entry.axisType, "Id requires a corresponding ").concat(entry.axisType
        // @ts-expect-error we should stop reading data from ReactElements
        , "Id on the targeted graphical component ").concat((_item$type$displayNam = item === null || item === void 0 || (_item$type = item.type) === null || _item$type === void 0 ? void 0 : _item$type.displayName) !== null && _item$type$displayNam !== void 0 ? _item$type$displayNam : '')) : (0, _tinyInvariant["default"])(false) : void 0;

        // the axis we are currently formatting
        var axis = axisMap[id];
        return _objectSpread$a(_objectSpread$a({}, result), {}, _defineProperty$d(_defineProperty$d({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, _ChartUtils$3.getTicksOfAxis)(axis)));
      }, axisObjInitialValue);
      var cateAxis = axisObj[cateAxisName];
      var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
      var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _ChartUtils$3.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
      var itemIsBar = (0, _ReactUtils$4.getDisplayName)(item.type).indexOf('Bar') >= 0;
      var bandSize = (0, _ChartUtils$3.getBandSizeOfAxis)(cateAxis, cateTicks);
      var barPosition = [];
      var sizeList = hasBar && (0, _ChartUtils$3.getBarSizeList)({
        barSize: barSize,
        stackGroups: stackGroups,
        totalSize: getCartesianAxisSize(axisObj, cateAxisName)
      });
      if (itemIsBar) {
        var _ref7, _getBandSizeOfAxis;
        // If it is bar, calculate the position of bar
        var maxBarSize = (0, _isNil["default"])(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
        var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, _ChartUtils$3.getBandSizeOfAxis)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
        barPosition = (0, _ChartUtils$3.getBarPosition)({
          barGap: barGap,
          barCategoryGap: barCategoryGap,
          bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
          sizeList: sizeList[cateAxisId],
          maxBarSize: maxBarSize
        });
        if (barBandSize !== bandSize) {
          barPosition = barPosition.map(function (pos) {
            return _objectSpread$a(_objectSpread$a({}, pos), {}, {
              position: _objectSpread$a(_objectSpread$a({}, pos.position), {}, {
                offset: pos.position.offset - barBandSize / 2
              })
            });
          });
        }
      }
      // @ts-expect-error we should stop reading data from ReactElements
      var composedFn = item && item.type && item.type.getComposedData;
      if (composedFn) {
        formattedItems.push({
          props: _objectSpread$a(_objectSpread$a({}, composedFn(_objectSpread$a(_objectSpread$a({}, axisObj), {}, {
            displayedData: displayedData,
            props: props,
            dataKey: dataKey,
            item: item,
            bandSize: bandSize,
            barPosition: barPosition,
            offset: offset,
            stackedData: stackedData,
            layout: layout,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }))), {}, _defineProperty$d(_defineProperty$d(_defineProperty$d({
            key: item.key || "item-".concat(index)
          }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
          childIndex: (0, _ReactUtils$4.parseChildIndex)(item, props.children),
          item: item
        });
      }
    });
    return formattedItems;
  };

  /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */
  var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
    var props = _ref8.props,
      dataStartIndex = _ref8.dataStartIndex,
      dataEndIndex = _ref8.dataEndIndex,
      updateId = _ref8.updateId;
    if (!(0, _ReactUtils$4.validateWidthHeight)({
      props: props
    })) {
      return null;
    }
    var children = props.children,
      layout = props.layout,
      stackOffset = props.stackOffset,
      data = props.data,
      reverseStackOrder = props.reverseStackOrder;
    var _getAxisNameByLayout2 = getAxisNameByLayout(layout),
      numericAxisName = _getAxisNameByLayout2.numericAxisName,
      cateAxisName = _getAxisNameByLayout2.cateAxisName;
    var graphicalItems = (0, _ReactUtils$4.findAllByType)(children, GraphicalChild);
    var stackGroups = (0, _ChartUtils$3.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
    var axisObj = axisComponents.reduce(function (result, entry) {
      var name = "".concat(entry.axisType, "Map");
      return _objectSpread$a(_objectSpread$a({}, result), {}, _defineProperty$d({}, name, getAxisMap(props, _objectSpread$a(_objectSpread$a({}, entry), {}, {
        graphicalItems: graphicalItems,
        stackGroups: entry.axisType === numericAxisName && stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
      }))));
    }, {});
    var offset = calculateOffset(_objectSpread$a(_objectSpread$a({}, axisObj), {}, {
      props: props,
      graphicalItems: graphicalItems
    }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
    Object.keys(axisObj).forEach(function (key) {
      axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
    });
    var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
    var ticksObj = tooltipTicksGenerator(cateAxisMap);
    var formattedGraphicalItems = getFormatItems(props, _objectSpread$a(_objectSpread$a({}, axisObj), {}, {
      dataStartIndex: dataStartIndex,
      dataEndIndex: dataEndIndex,
      updateId: updateId,
      graphicalItems: graphicalItems,
      stackGroups: stackGroups,
      offset: offset
    }));
    return _objectSpread$a(_objectSpread$a({
      formattedGraphicalItems: formattedGraphicalItems,
      graphicalItems: graphicalItems,
      offset: offset,
      stackGroups: stackGroups
    }, ticksObj), axisObj);
  };
  var CategoricalChartWrapper = /*#__PURE__*/function (_Component) {
    function CategoricalChartWrapper(_props) {
      var _props$id, _props$throttleDelay;
      var _this;
      _classCallCheck$i(this, CategoricalChartWrapper);
      _this = _callSuper$3(this, CategoricalChartWrapper, [_props]);
      _defineProperty$d(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
      _defineProperty$d(_this, "accessibilityManager", new _AccessibilityManager.AccessibilityManager());
      _defineProperty$d(_this, "handleLegendBBoxUpdate", function (box) {
        if (box) {
          var _this$state = _this.state,
            dataStartIndex = _this$state.dataStartIndex,
            dataEndIndex = _this$state.dataEndIndex,
            updateId = _this$state.updateId;
          _this.setState(_objectSpread$a({
            legendBBox: box
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId
          }, _objectSpread$a(_objectSpread$a({}, _this.state), {}, {
            legendBBox: box
          }))));
        }
      });
      _defineProperty$d(_this, "handleReceiveSyncEvent", function (cId, data, emitter) {
        if (_this.props.syncId === cId) {
          if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') {
            return;
          }
          _this.applySyncEvent(data);
        }
      });
      _defineProperty$d(_this, "handleBrushChange", function (_ref9) {
        var startIndex = _ref9.startIndex,
          endIndex = _ref9.endIndex;
        // Only trigger changes if the extents of the brush have actually changed
        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
          var updateId = _this.state.updateId;
          _this.setState(function () {
            return _objectSpread$a({
              dataStartIndex: startIndex,
              dataEndIndex: endIndex
            }, updateStateOfAxisMapsOffsetAndStackGroups({
              props: _this.props,
              dataStartIndex: startIndex,
              dataEndIndex: endIndex,
              updateId: updateId
            }, _this.state));
          });
          _this.triggerSyncEvent({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          });
        }
      });
      /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */
      _defineProperty$d(_this, "handleMouseEnter", function (e) {
        var mouse = _this.getMouseInfo(e);
        if (mouse) {
          var _nextState = _objectSpread$a(_objectSpread$a({}, mouse), {}, {
            isTooltipActive: true
          });
          _this.setState(_nextState);
          _this.triggerSyncEvent(_nextState);
          var onMouseEnter = _this.props.onMouseEnter;
          if ((0, _isFunction$3["default"])(onMouseEnter)) {
            onMouseEnter(_nextState, e);
          }
        }
      });
      _defineProperty$d(_this, "triggeredAfterMouseMove", function (e) {
        var mouse = _this.getMouseInfo(e);
        var nextState = mouse ? _objectSpread$a(_objectSpread$a({}, mouse), {}, {
          isTooltipActive: true
        }) : {
          isTooltipActive: false
        };
        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);
        var onMouseMove = _this.props.onMouseMove;
        if ((0, _isFunction$3["default"])(onMouseMove)) {
          onMouseMove(nextState, e);
        }
      });
      /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */
      _defineProperty$d(_this, "handleItemMouseEnter", function (el) {
        _this.setState(function () {
          return {
            isTooltipActive: true,
            activeItem: el,
            activePayload: el.tooltipPayload,
            activeCoordinate: el.tooltipPosition || {
              x: el.cx,
              y: el.cy
            }
          };
        });
      });
      /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */
      _defineProperty$d(_this, "handleItemMouseLeave", function () {
        _this.setState(function () {
          return {
            isTooltipActive: false
          };
        });
      });
      /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */
      _defineProperty$d(_this, "handleMouseMove", function (e) {
        e.persist();
        _this.throttleTriggeredAfterMouseMove(e);
      });
      /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */
      _defineProperty$d(_this, "handleMouseLeave", function (e) {
        _this.throttleTriggeredAfterMouseMove.cancel();
        var nextState = {
          isTooltipActive: false
        };
        _this.setState(nextState);
        _this.triggerSyncEvent(nextState);
        var onMouseLeave = _this.props.onMouseLeave;
        if ((0, _isFunction$3["default"])(onMouseLeave)) {
          onMouseLeave(nextState, e);
        }
      });
      _defineProperty$d(_this, "handleOuterEvent", function (e) {
        var eventName = (0, _ReactUtils$4.getReactEventByType)(e);
        var event = (0, _get$2["default"])(_this.props, "".concat(eventName));
        if (eventName && (0, _isFunction$3["default"])(event)) {
          var _mouse;
          var mouse;
          if (/.*touch.*/i.test(eventName)) {
            mouse = _this.getMouseInfo(e.changedTouches[0]);
          } else {
            mouse = _this.getMouseInfo(e);
          }
          event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
        }
      });
      _defineProperty$d(_this, "handleClick", function (e) {
        var mouse = _this.getMouseInfo(e);
        if (mouse) {
          var _nextState2 = _objectSpread$a(_objectSpread$a({}, mouse), {}, {
            isTooltipActive: true
          });
          _this.setState(_nextState2);
          _this.triggerSyncEvent(_nextState2);
          var onClick = _this.props.onClick;
          if ((0, _isFunction$3["default"])(onClick)) {
            onClick(_nextState2, e);
          }
        }
      });
      _defineProperty$d(_this, "handleMouseDown", function (e) {
        var onMouseDown = _this.props.onMouseDown;
        if ((0, _isFunction$3["default"])(onMouseDown)) {
          var _nextState3 = _this.getMouseInfo(e);
          onMouseDown(_nextState3, e);
        }
      });
      _defineProperty$d(_this, "handleMouseUp", function (e) {
        var onMouseUp = _this.props.onMouseUp;
        if ((0, _isFunction$3["default"])(onMouseUp)) {
          var _nextState4 = _this.getMouseInfo(e);
          onMouseUp(_nextState4, e);
        }
      });
      _defineProperty$d(_this, "handleTouchMove", function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
        }
      });
      _defineProperty$d(_this, "handleTouchStart", function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseDown(e.changedTouches[0]);
        }
      });
      _defineProperty$d(_this, "handleTouchEnd", function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseUp(e.changedTouches[0]);
        }
      });
      _defineProperty$d(_this, "handleDoubleClick", function (e) {
        var onDoubleClick = _this.props.onDoubleClick;
        if ((0, _isFunction$3["default"])(onDoubleClick)) {
          var _nextState5 = _this.getMouseInfo(e);
          onDoubleClick(_nextState5, e);
        }
      });
      _defineProperty$d(_this, "handleContextMenu", function (e) {
        var onContextMenu = _this.props.onContextMenu;
        if ((0, _isFunction$3["default"])(onContextMenu)) {
          var _nextState6 = _this.getMouseInfo(e);
          onContextMenu(_nextState6, e);
        }
      });
      _defineProperty$d(_this, "triggerSyncEvent", function (data) {
        if (_this.props.syncId !== undefined) {
          _Events.eventCenter.emit(_Events.SYNC_EVENT, _this.props.syncId, data, _this.eventEmitterSymbol);
        }
      });
      _defineProperty$d(_this, "applySyncEvent", function (data) {
        var _this$props = _this.props,
          layout = _this$props.layout,
          syncMethod = _this$props.syncMethod;
        var updateId = _this.state.updateId;
        var dataStartIndex = data.dataStartIndex,
          dataEndIndex = data.dataEndIndex;
        if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) {
          _this.setState(_objectSpread$a({
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }, updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId
          }, _this.state)));
        } else if (data.activeTooltipIndex !== undefined) {
          var chartX = data.chartX,
            chartY = data.chartY;
          var activeTooltipIndex = data.activeTooltipIndex;
          var _this$state2 = _this.state,
            offset = _this$state2.offset,
            tooltipTicks = _this$state2.tooltipTicks;
          if (!offset) {
            return;
          }
          if (typeof syncMethod === 'function') {
            // Call a callback function. If there is an application specific algorithm
            activeTooltipIndex = syncMethod(tooltipTicks, data);
          } else if (syncMethod === 'value') {
            // Set activeTooltipIndex to the index with the same value as data.activeLabel
            // For loop instead of findIndex because the latter is very slow in some browsers
            activeTooltipIndex = -1; // in case we cannot find the element
            for (var i = 0; i < tooltipTicks.length; i++) {
              if (tooltipTicks[i].value === data.activeLabel) {
                activeTooltipIndex = i;
                break;
              }
            }
          }
          var viewBox = _objectSpread$a(_objectSpread$a({}, offset), {}, {
            x: offset.left,
            y: offset.top
          });
          // When a categorical chart is combined with another chart, the value of chartX
          // and chartY may beyond the boundaries.
          var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
          var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
          var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
          var activePayload = getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
          var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
            x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
            y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
          } : originCoordinate;
          _this.setState(_objectSpread$a(_objectSpread$a({}, data), {}, {
            activeLabel: activeLabel,
            activeCoordinate: activeCoordinate,
            activePayload: activePayload,
            activeTooltipIndex: activeTooltipIndex
          }));
        } else {
          _this.setState(data);
        }
      });
      _defineProperty$d(_this, "renderCursor", function (element) {
        var _element$props$active;
        var _this$state3 = _this.state,
          isTooltipActive = _this$state3.isTooltipActive,
          activeCoordinate = _this$state3.activeCoordinate,
          activePayload = _this$state3.activePayload,
          offset = _this$state3.offset,
          activeTooltipIndex = _this$state3.activeTooltipIndex,
          tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
        var tooltipEventType = _this.getTooltipEventType();
        // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
        var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
        var layout = _this.props.layout;
        var key = element.key || '_recharts-cursor';
        return /*#__PURE__*/_react$c["default"].createElement(_Cursor.Cursor, {
          key: key,
          activeCoordinate: activeCoordinate,
          activePayload: activePayload,
          activeTooltipIndex: activeTooltipIndex,
          chartName: chartName,
          element: element,
          isActive: isActive,
          layout: layout,
          offset: offset,
          tooltipAxisBandSize: tooltipAxisBandSize,
          tooltipEventType: tooltipEventType
        });
      });
      _defineProperty$d(_this, "renderPolarAxis", function (element, displayName, index) {
        var axisType = (0, _get$2["default"])(element, 'type.axisType');
        var axisMap = (0, _get$2["default"])(_this.state, "".concat(axisType, "Map"));
        var elementDefaultProps = element.type.defaultProps;
        var elementProps = elementDefaultProps !== undefined ? _objectSpread$a(_objectSpread$a({}, elementDefaultProps), element.props) : element.props;
        var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
        return /*#__PURE__*/(0, _react$c.cloneElement)(element, _objectSpread$a(_objectSpread$a({}, axisOption), {}, {
          className: (0, _clsx$4["default"])(axisType, axisOption.className),
          key: element.key || "".concat(displayName, "-").concat(index),
          ticks: (0, _ChartUtils$3.getTicksOfAxis)(axisOption, true)
        }));
      });
      _defineProperty$d(_this, "renderPolarGrid", function (element) {
        var _element$props = element.props,
          radialLines = _element$props.radialLines,
          polarAngles = _element$props.polarAngles,
          polarRadius = _element$props.polarRadius;
        var _this$state4 = _this.state,
          radiusAxisMap = _this$state4.radiusAxisMap,
          angleAxisMap = _this$state4.angleAxisMap;
        var radiusAxis = (0, _DataUtils$2.getAnyElementOfObject)(radiusAxisMap);
        var angleAxis = (0, _DataUtils$2.getAnyElementOfObject)(angleAxisMap);
        var cx = angleAxis.cx,
          cy = angleAxis.cy,
          innerRadius = angleAxis.innerRadius,
          outerRadius = angleAxis.outerRadius;
        return /*#__PURE__*/(0, _react$c.cloneElement)(element, {
          polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, _ChartUtils$3.getTicksOfAxis)(angleAxis, true).map(function (entry) {
            return entry.coordinate;
          }),
          polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, _ChartUtils$3.getTicksOfAxis)(radiusAxis, true).map(function (entry) {
            return entry.coordinate;
          }),
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          key: element.key || 'polar-grid',
          radialLines: radialLines
        });
      });
      /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */
      _defineProperty$d(_this, "renderLegend", function () {
        var formattedGraphicalItems = _this.state.formattedGraphicalItems;
        var _this$props2 = _this.props,
          children = _this$props2.children,
          width = _this$props2.width,
          height = _this$props2.height;
        var margin = _this.props.margin || {};
        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
        var props = (0, _ChartUtils$3.getLegendProps)({
          children: children,
          formattedGraphicalItems: formattedGraphicalItems,
          legendWidth: legendWidth,
          legendContent: legendContent
        });
        if (!props) {
          return null;
        }
        var item = props.item,
          otherProps = _objectWithoutProperties$6(props, _excluded$3);
        return /*#__PURE__*/(0, _react$c.cloneElement)(item, _objectSpread$a(_objectSpread$a({}, otherProps), {}, {
          chartWidth: width,
          chartHeight: height,
          margin: margin,
          onBBoxUpdate: _this.handleLegendBBoxUpdate
        }));
      });
      /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */
      _defineProperty$d(_this, "renderTooltip", function () {
        var _tooltipItem$props$ac;
        var _this$props3 = _this.props,
          children = _this$props3.children,
          accessibilityLayer = _this$props3.accessibilityLayer;
        var tooltipItem = (0, _ReactUtils$4.findChildByType)(children, _Tooltip$3.Tooltip);
        if (!tooltipItem) {
          return null;
        }
        var _this$state5 = _this.state,
          isTooltipActive = _this$state5.isTooltipActive,
          activeCoordinate = _this$state5.activeCoordinate,
          activePayload = _this$state5.activePayload,
          activeLabel = _this$state5.activeLabel,
          offset = _this$state5.offset;

        // The user can set isActive on the Tooltip,
        // and we respect the user to enable customisation.
        // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
        var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
        return /*#__PURE__*/(0, _react$c.cloneElement)(tooltipItem, {
          viewBox: _objectSpread$a(_objectSpread$a({}, offset), {}, {
            x: offset.left,
            y: offset.top
          }),
          active: isActive,
          label: activeLabel,
          payload: isActive ? activePayload : [],
          coordinate: activeCoordinate,
          accessibilityLayer: accessibilityLayer
        });
      });
      _defineProperty$d(_this, "renderBrush", function (element) {
        var _this$props4 = _this.props,
          margin = _this$props4.margin,
          data = _this$props4.data;
        var _this$state6 = _this.state,
          offset = _this$state6.offset,
          dataStartIndex = _this$state6.dataStartIndex,
          dataEndIndex = _this$state6.dataEndIndex,
          updateId = _this$state6.updateId;

        // TODO: update brush when children update
        return /*#__PURE__*/(0, _react$c.cloneElement)(element, {
          key: element.key || '_recharts-brush',
          onChange: (0, _ChartUtils$3.combineEventHandlers)(_this.handleBrushChange, element.props.onChange),
          data: data,
          x: (0, _DataUtils$2.isNumber)(element.props.x) ? element.props.x : offset.left,
          y: (0, _DataUtils$2.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
          width: (0, _DataUtils$2.isNumber)(element.props.width) ? element.props.width : offset.width,
          startIndex: dataStartIndex,
          endIndex: dataEndIndex,
          updateId: "brush-".concat(updateId)
        });
      });
      _defineProperty$d(_this, "renderReferenceElement", function (element, displayName, index) {
        if (!element) {
          return null;
        }
        var _this2 = _this,
          clipPathId = _this2.clipPathId;
        var _this$state7 = _this.state,
          xAxisMap = _this$state7.xAxisMap,
          yAxisMap = _this$state7.yAxisMap,
          offset = _this$state7.offset;
        var elementDefaultProps = element.type.defaultProps || {};
        var _element$props2 = element.props,
          _element$props2$xAxis = _element$props2.xAxisId,
          xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis,
          _element$props2$yAxis = _element$props2.yAxisId,
          yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
        return /*#__PURE__*/(0, _react$c.cloneElement)(element, {
          key: element.key || "".concat(displayName, "-").concat(index),
          xAxis: xAxisMap[xAxisId],
          yAxis: yAxisMap[yAxisId],
          viewBox: {
            x: offset.left,
            y: offset.top,
            width: offset.width,
            height: offset.height
          },
          clipPathId: clipPathId
        });
      });
      _defineProperty$d(_this, "renderActivePoints", function (_ref10) {
        var item = _ref10.item,
          activePoint = _ref10.activePoint,
          basePoint = _ref10.basePoint,
          childIndex = _ref10.childIndex,
          isRange = _ref10.isRange;
        var result = [];
        // item is not a React Element so we don't need to resolve defaultProps.
        var key = item.props.key;
        var itemItemProps = item.item.type.defaultProps !== undefined ? _objectSpread$a(_objectSpread$a({}, item.item.type.defaultProps), item.item.props) : item.item.props;
        var activeDot = itemItemProps.activeDot,
          dataKey = itemItemProps.dataKey;
        var dotProps = _objectSpread$a(_objectSpread$a({
          index: childIndex,
          dataKey: dataKey,
          cx: activePoint.x,
          cy: activePoint.y,
          r: 4,
          fill: (0, _ChartUtils$3.getMainColorOfGraphicItem)(item.item),
          strokeWidth: 2,
          stroke: '#fff',
          payload: activePoint.payload,
          value: activePoint.value
        }, (0, _ReactUtils$4.filterProps)(activeDot, false)), (0, _types$1.adaptEventHandlers)(activeDot));
        result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
        if (basePoint) {
          result.push(CategoricalChartWrapper.renderActiveDot(activeDot, _objectSpread$a(_objectSpread$a({}, dotProps), {}, {
            cx: basePoint.x,
            cy: basePoint.y
          }), "".concat(key, "-basePoint-").concat(childIndex)));
        } else if (isRange) {
          result.push(null);
        }
        return result;
      });
      _defineProperty$d(_this, "renderGraphicChild", function (element, displayName, index) {
        var item = _this.filterFormatItem(element, displayName, index);
        if (!item) {
          return null;
        }
        var tooltipEventType = _this.getTooltipEventType();
        var _this$state8 = _this.state,
          isTooltipActive = _this$state8.isTooltipActive,
          tooltipAxis = _this$state8.tooltipAxis,
          activeTooltipIndex = _this$state8.activeTooltipIndex,
          activeLabel = _this$state8.activeLabel;
        var children = _this.props.children;
        var tooltipItem = (0, _ReactUtils$4.findChildByType)(children, _Tooltip$3.Tooltip);
        // item is not a React Element so we don't need to resolve defaultProps
        var _item$props = item.props,
          points = _item$props.points,
          isRange = _item$props.isRange,
          baseLine = _item$props.baseLine;
        var itemItemProps = item.item.type.defaultProps !== undefined ? _objectSpread$a(_objectSpread$a({}, item.item.type.defaultProps), item.item.props) : item.item.props;
        var activeDot = itemItemProps.activeDot,
          hide = itemItemProps.hide,
          activeBar = itemItemProps.activeBar,
          activeShape = itemItemProps.activeShape;
        var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
        var itemEvents = {};
        if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') {
          itemEvents = {
            onClick: (0, _ChartUtils$3.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onClick)
          };
        } else if (tooltipEventType !== 'axis') {
          itemEvents = {
            onMouseLeave: (0, _ChartUtils$3.combineEventHandlers)(_this.handleItemMouseLeave, element.props.onMouseLeave),
            onMouseEnter: (0, _ChartUtils$3.combineEventHandlers)(_this.handleItemMouseEnter, element.props.onMouseEnter)
          };
        }
        var graphicalItem = /*#__PURE__*/(0, _react$c.cloneElement)(element, _objectSpread$a(_objectSpread$a({}, item.props), itemEvents));
        function findWithPayload(entry) {
          // TODO needs to verify dataKey is Function
          return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
        }
        if (hasActive) {
          if (activeTooltipIndex >= 0) {
            var activePoint, basePoint;
            if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
              // number transform to string
              var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
              activePoint = (0, _DataUtils$2.findEntryInArray)(points, specifiedKey, activeLabel);
              basePoint = isRange && baseLine && (0, _DataUtils$2.findEntryInArray)(baseLine, specifiedKey, activeLabel);
            } else {
              activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
              basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
            }
            if (activeShape || activeBar) {
              var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
              return [/*#__PURE__*/(0, _react$c.cloneElement)(element, _objectSpread$a(_objectSpread$a(_objectSpread$a({}, item.props), itemEvents), {}, {
                activeIndex: activeIndex
              })), null, null];
            }
            if (!(0, _isNil["default"])(activePoint)) {
              return [graphicalItem].concat(_toConsumableArray$1(_this.renderActivePoints({
                item: item,
                activePoint: activePoint,
                basePoint: basePoint,
                childIndex: activeTooltipIndex,
                isRange: isRange
              })));
            }
          } else {
            var _this$getItemByXY;
            /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */
            var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                graphicalItem: graphicalItem
              },
              _ref11$graphicalItem = _ref11.graphicalItem,
              _ref11$graphicalItem$ = _ref11$graphicalItem.item,
              xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$,
              childIndex = _ref11$graphicalItem.childIndex;
            var elementProps = _objectSpread$a(_objectSpread$a(_objectSpread$a({}, item.props), itemEvents), {}, {
              activeIndex: childIndex
            });
            return [/*#__PURE__*/(0, _react$c.cloneElement)(xyItem, elementProps), null, null];
          }
        }
        if (isRange) {
          return [graphicalItem, null, null];
        }
        return [graphicalItem, null];
      });
      _defineProperty$d(_this, "renderCustomized", function (element, displayName, index) {
        return /*#__PURE__*/(0, _react$c.cloneElement)(element, _objectSpread$a(_objectSpread$a({
          key: "recharts-customized-".concat(index)
        }, _this.props), _this.state));
      });
      _defineProperty$d(_this, "renderMap", {
        CartesianGrid: {
          handler: renderAsIs,
          once: true
        },
        ReferenceArea: {
          handler: _this.renderReferenceElement
        },
        ReferenceLine: {
          handler: renderAsIs
        },
        ReferenceDot: {
          handler: _this.renderReferenceElement
        },
        XAxis: {
          handler: renderAsIs
        },
        YAxis: {
          handler: renderAsIs
        },
        Brush: {
          handler: _this.renderBrush,
          once: true
        },
        Bar: {
          handler: _this.renderGraphicChild
        },
        Line: {
          handler: _this.renderGraphicChild
        },
        Area: {
          handler: _this.renderGraphicChild
        },
        Radar: {
          handler: _this.renderGraphicChild
        },
        RadialBar: {
          handler: _this.renderGraphicChild
        },
        Scatter: {
          handler: _this.renderGraphicChild
        },
        Pie: {
          handler: _this.renderGraphicChild
        },
        Funnel: {
          handler: _this.renderGraphicChild
        },
        Tooltip: {
          handler: _this.renderCursor,
          once: true
        },
        PolarGrid: {
          handler: _this.renderPolarGrid,
          once: true
        },
        PolarAngleAxis: {
          handler: _this.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: _this.renderPolarAxis
        },
        Customized: {
          handler: _this.renderCustomized
        }
      });
      _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, _DataUtils$2.uniqueId)('recharts'), "-clip");

      // trigger 60fps
      _this.throttleTriggeredAfterMouseMove = (0, _throttle["default"])(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
      _this.state = {};
      return _this;
    }
    _inherits$a(CategoricalChartWrapper, _Component);
    return _createClass$i(CategoricalChartWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props$margin$le, _this$props$margin$to;
        this.addListener();
        this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        });
        this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function displayDefaultTooltip() {
        var _this$props5 = this.props,
          children = _this$props5.children,
          data = _this$props5.data,
          height = _this$props5.height,
          layout = _this$props5.layout;
        var tooltipElem = (0, _ReactUtils$4.findChildByType)(children, _Tooltip$3.Tooltip);
        // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
        if (!tooltipElem) {
          return;
        }
        var defaultIndex = tooltipElem.props.defaultIndex;

        // Protect against runtime errors
        if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) {
          return;
        }
        var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
        var activePayload = getTooltipContent(this.state, data, defaultIndex, activeLabel);
        var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
        var dependentAxisCoord = (this.state.offset.top + height) / 2;
        var isHorizontal = layout === 'horizontal';
        var activeCoordinate = isHorizontal ? {
          x: independentAxisCoord,
          y: dependentAxisCoord
        } : {
          y: independentAxisCoord,
          x: dependentAxisCoord
        };

        // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
        // element knows its own Y coordinates.
        // If there's a scatter plot, we'll want to grab that element for an interrogation.
        var scatterPlotElement = this.state.formattedGraphicalItems.find(function (_ref12) {
          var item = _ref12.item;
          return item.type.name === 'Scatter';
        });
        if (scatterPlotElement) {
          activeCoordinate = _objectSpread$a(_objectSpread$a({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
          activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
        }
        var nextState = {
          activeTooltipIndex: defaultIndex,
          isTooltipActive: true,
          activeLabel: activeLabel,
          activePayload: activePayload,
          activeCoordinate: activeCoordinate
        };
        this.setState(nextState);
        this.renderCursor(tooltipElem);

        // Make sure that anyone who keyboard-only users who tab to the chart will start their
        // cursors at defaultIndex
        this.accessibilityManager.setIndex(defaultIndex);
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function getSnapshotBeforeUpdate(prevProps, prevState) {
        if (!this.props.accessibilityLayer) {
          return null;
        }
        if (this.state.tooltipTicks !== prevState.tooltipTicks) {
          this.accessibilityManager.setDetails({
            coordinateList: this.state.tooltipTicks
          });
        }
        if (this.props.layout !== prevProps.layout) {
          this.accessibilityManager.setDetails({
            layout: this.props.layout
          });
        }
        if (this.props.margin !== prevProps.margin) {
          var _this$props$margin$le2, _this$props$margin$to2;
          this.accessibilityManager.setDetails({
            offset: {
              left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
              top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
            }
          });
        }

        // Something has to be returned for getSnapshotBeforeUpdate
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        // Check to see if the Tooltip updated. If so, re-check default tooltip position
        if (!(0, _ReactUtils$4.isChildrenEqual)([(0, _ReactUtils$4.findChildByType)(prevProps.children, _Tooltip$3.Tooltip)], [(0, _ReactUtils$4.findChildByType)(this.props.children, _Tooltip$3.Tooltip)])) {
          this.displayDefaultTooltip();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.removeListener();
        this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function getTooltipEventType() {
        var tooltipItem = (0, _ReactUtils$4.findChildByType)(this.props.children, _Tooltip$3.Tooltip);
        if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
          var eventType = tooltipItem.props.shared ? 'axis' : 'item';
          return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
        }
        return defaultTooltipEventType;
      }

      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function getMouseInfo(event) {
        if (!this.container) {
          return null;
        }
        var element = this.container;
        var boundingRect = element.getBoundingClientRect();
        var containerOffset = (0, _DOMUtils$1.getOffset)(boundingRect);
        var e = {
          chartX: Math.round(event.pageX - containerOffset.left),
          chartY: Math.round(event.pageY - containerOffset.top)
        };
        var scale = boundingRect.width / element.offsetWidth || 1;
        var rangeObj = this.inRange(e.chartX, e.chartY, scale);
        if (!rangeObj) {
          return null;
        }
        var _this$state9 = this.state,
          xAxisMap = _this$state9.xAxisMap,
          yAxisMap = _this$state9.yAxisMap;
        var tooltipEventType = this.getTooltipEventType();
        if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
          var xScale = (0, _DataUtils$2.getAnyElementOfObject)(xAxisMap).scale;
          var yScale = (0, _DataUtils$2.getAnyElementOfObject)(yAxisMap).scale;
          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
          return _objectSpread$a(_objectSpread$a({}, e), {}, {
            xValue: xValue,
            yValue: yValue
          });
        }
        var toolTipData = getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
        if (toolTipData) {
          return _objectSpread$a(_objectSpread$a({}, e), toolTipData);
        }
        return null;
      }
    }, {
      key: "inRange",
      value: function inRange(x, y) {
        var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var layout = this.props.layout;
        var scaledX = x / scale,
          scaledY = y / scale;
        if (layout === 'horizontal' || layout === 'vertical') {
          var offset = this.state.offset;
          var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
          return isInRange ? {
            x: scaledX,
            y: scaledY
          } : null;
        }
        var _this$state10 = this.state,
          angleAxisMap = _this$state10.angleAxisMap,
          radiusAxisMap = _this$state10.radiusAxisMap;
        if (angleAxisMap && radiusAxisMap) {
          var angleAxis = (0, _DataUtils$2.getAnyElementOfObject)(angleAxisMap);
          return (0, _PolarUtils$4.inRangeOfSector)({
            x: scaledX,
            y: scaledY
          }, angleAxis);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function parseEventsOfWrapper() {
        var children = this.props.children;
        var tooltipEventType = this.getTooltipEventType();
        var tooltipItem = (0, _ReactUtils$4.findChildByType)(children, _Tooltip$3.Tooltip);
        var tooltipEvents = {};
        if (tooltipItem && tooltipEventType === 'axis') {
          if (tooltipItem.props.trigger === 'click') {
            tooltipEvents = {
              onClick: this.handleClick
            };
          } else {
            tooltipEvents = {
              onMouseEnter: this.handleMouseEnter,
              onDoubleClick: this.handleDoubleClick,
              onMouseMove: this.handleMouseMove,
              onMouseLeave: this.handleMouseLeave,
              onTouchMove: this.handleTouchMove,
              onTouchStart: this.handleTouchStart,
              onTouchEnd: this.handleTouchEnd,
              onContextMenu: this.handleContextMenu
            };
          }
        }

        // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
        var outerEvents = (0, _types$1.adaptEventHandlers)(this.props, this.handleOuterEvent);
        return _objectSpread$a(_objectSpread$a({}, outerEvents), tooltipEvents);
      }
    }, {
      key: "addListener",
      value: function addListener() {
        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function removeListener() {
        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function filterFormatItem(item, displayName, childIndex) {
        var formattedGraphicalItems = this.state.formattedGraphicalItems;
        for (var i = 0, len = formattedGraphicalItems.length; i < len; i++) {
          var entry = formattedGraphicalItems[i];
          if (entry.item === item || entry.props.key === item.key || displayName === (0, _ReactUtils$4.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) {
            return entry;
          }
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function renderClipPath() {
        var clipPathId = this.clipPathId;
        var _this$state$offset = this.state.offset,
          left = _this$state$offset.left,
          top = _this$state$offset.top,
          height = _this$state$offset.height,
          width = _this$state$offset.width;
        return /*#__PURE__*/_react$c["default"].createElement("defs", null, /*#__PURE__*/_react$c["default"].createElement("clipPath", {
          id: clipPathId
        }, /*#__PURE__*/_react$c["default"].createElement("rect", {
          x: left,
          y: top,
          height: height,
          width: width
        })));
      }
    }, {
      key: "getXScales",
      value: function getXScales() {
        var xAxisMap = this.state.xAxisMap;
        return xAxisMap ? Object.entries(xAxisMap).reduce(function (res, _ref13) {
          var _ref14 = _slicedToArray$8(_ref13, 2),
            axisId = _ref14[0],
            axisProps = _ref14[1];
          return _objectSpread$a(_objectSpread$a({}, res), {}, _defineProperty$d({}, axisId, axisProps.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function getYScales() {
        var yAxisMap = this.state.yAxisMap;
        return yAxisMap ? Object.entries(yAxisMap).reduce(function (res, _ref15) {
          var _ref16 = _slicedToArray$8(_ref15, 2),
            axisId = _ref16[0],
            axisProps = _ref16[1];
          return _objectSpread$a(_objectSpread$a({}, res), {}, _defineProperty$d({}, axisId, axisProps.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function getXScaleByAxisId(axisId) {
        var _this$state$xAxisMap;
        return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function getYScaleByAxisId(axisId) {
        var _this$state$yAxisMap;
        return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
      }
    }, {
      key: "getItemByXY",
      value: function getItemByXY(chartXY) {
        var _this$state11 = this.state,
          formattedGraphicalItems = _this$state11.formattedGraphicalItems,
          activeItem = _this$state11.activeItem;
        if (formattedGraphicalItems && formattedGraphicalItems.length) {
          for (var i = 0, len = formattedGraphicalItems.length; i < len; i++) {
            var graphicalItem = formattedGraphicalItems[i];
            // graphicalItem is not a React Element so we don't need to resolve defaultProps
            var props = graphicalItem.props,
              item = graphicalItem.item;
            var itemProps = item.type.defaultProps !== undefined ? _objectSpread$a(_objectSpread$a({}, item.type.defaultProps), item.props) : item.props;
            var itemDisplayName = (0, _ReactUtils$4.getDisplayName)(item.type);
            if (itemDisplayName === 'Bar') {
              var activeBarItem = (props.data || []).find(function (entry) {
                return (0, _Rectangle$2.isInRectangle)(chartXY, entry);
              });
              if (activeBarItem) {
                return {
                  graphicalItem: graphicalItem,
                  payload: activeBarItem
                };
              }
            } else if (itemDisplayName === 'RadialBar') {
              var _activeBarItem = (props.data || []).find(function (entry) {
                return (0, _PolarUtils$4.inRangeOfSector)(chartXY, entry);
              });
              if (_activeBarItem) {
                return {
                  graphicalItem: graphicalItem,
                  payload: _activeBarItem
                };
              }
            } else if ((0, _ActiveShapeUtils$1.isFunnel)(graphicalItem, activeItem) || (0, _ActiveShapeUtils$1.isPie)(graphicalItem, activeItem) || (0, _ActiveShapeUtils$1.isScatter)(graphicalItem, activeItem)) {
              var activeIndex = (0, _ActiveShapeUtils$1.getActiveShapeIndexForTooltip)({
                graphicalItem: graphicalItem,
                activeTooltipItem: activeItem,
                itemData: itemProps.data
              });
              var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
              return {
                graphicalItem: _objectSpread$a(_objectSpread$a({}, graphicalItem), {}, {
                  childIndex: childIndex
                }),
                payload: (0, _ActiveShapeUtils$1.isScatter)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
              };
            }
          }
        }
        return null;
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;
        if (!(0, _ReactUtils$4.validateWidthHeight)(this)) {
          return null;
        }
        var _this$props6 = this.props,
          children = _this$props6.children,
          className = _this$props6.className,
          width = _this$props6.width,
          height = _this$props6.height,
          style = _this$props6.style,
          compact = _this$props6.compact,
          title = _this$props6.title,
          desc = _this$props6.desc,
          others = _objectWithoutProperties$6(_this$props6, _excluded2$1);
        var attrs = (0, _ReactUtils$4.filterProps)(others, false);

        // The "compact" mode is mainly used as the panorama within Brush
        if (compact) {
          return /*#__PURE__*/_react$c["default"].createElement(_chartLayoutContext.ChartLayoutContextProvider, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /*#__PURE__*/_react$c["default"].createElement(_Surface$3.Surface, _extends$b({}, attrs, {
            width: width,
            height: height,
            title: title,
            desc: desc
          }), this.renderClipPath(), (0, _ReactUtils$4.renderByOrder)(children, this.renderMap)));
        }
        if (this.props.accessibilityLayer) {
          var _this$props$tabIndex, _this$props$role;
          // Set tabIndex to 0 by default (can be overwritten)
          attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
          // Set role to img by default (can be overwritten)
          attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
          attrs.onKeyDown = function (e) {
            _this3.accessibilityManager.keyboardEvent(e);
            // 'onKeyDown' is not currently a supported prop that can be passed through
            // if it's added, this should be added: this.props.onKeyDown(e);
          };
          attrs.onFocus = function () {
            _this3.accessibilityManager.focus();
            // 'onFocus' is not currently a supported prop that can be passed through
            // if it's added, the focus event should be forwarded to the prop
          };
        }
        var events = this.parseEventsOfWrapper();
        return /*#__PURE__*/_react$c["default"].createElement(_chartLayoutContext.ChartLayoutContextProvider, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /*#__PURE__*/_react$c["default"].createElement("div", _extends$b({
          className: (0, _clsx$4["default"])('recharts-wrapper', className),
          style: _objectSpread$a({
            position: 'relative',
            cursor: 'default',
            width: width,
            height: height
          }, style)
        }, events, {
          ref: function ref(node) {
            _this3.container = node;
          }
        }), /*#__PURE__*/_react$c["default"].createElement(_Surface$3.Surface, _extends$b({}, attrs, {
          width: width,
          height: height,
          title: title,
          desc: desc,
          style: FULL_WIDTH_AND_HEIGHT
        }), this.renderClipPath(), (0, _ReactUtils$4.renderByOrder)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(_react$c.Component);
  _defineProperty$d(CategoricalChartWrapper, "displayName", chartName);
  // todo join specific chart propTypes
  _defineProperty$d(CategoricalChartWrapper, "defaultProps", _objectSpread$a({
    layout: 'horizontal',
    stackOffset: 'none',
    barCategoryGap: '10%',
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: false,
    syncMethod: 'index'
  }, defaultProps));
  _defineProperty$d(CategoricalChartWrapper, "getDerivedStateFromProps", function (nextProps, prevState) {
    var dataKey = nextProps.dataKey,
      data = nextProps.data,
      children = nextProps.children,
      width = nextProps.width,
      height = nextProps.height,
      layout = nextProps.layout,
      stackOffset = nextProps.stackOffset,
      margin = nextProps.margin;
    var dataStartIndex = prevState.dataStartIndex,
      dataEndIndex = prevState.dataEndIndex;
    if (prevState.updateId === undefined) {
      var defaultState = createDefaultState(nextProps);
      return _objectSpread$a(_objectSpread$a(_objectSpread$a({}, defaultState), {}, {
        updateId: 0
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread$a(_objectSpread$a({
        props: nextProps
      }, defaultState), {}, {
        updateId: 0
      }), prevState)), {}, {
        prevDataKey: dataKey,
        prevData: data,
        prevWidth: width,
        prevHeight: height,
        prevLayout: layout,
        prevStackOffset: stackOffset,
        prevMargin: margin,
        prevChildren: children
      });
    }
    if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, _ShallowEqual$1.shallowEqual)(margin, prevState.prevMargin)) {
      var _defaultState = createDefaultState(nextProps);

      // Fixes https://github.com/recharts/recharts/issues/2143
      var keepFromPrevState = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: prevState.chartX,
        chartY: prevState.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: prevState.isTooltipActive
      };
      var updatesToState = _objectSpread$a(_objectSpread$a({}, getTooltipData(prevState, data, layout)), {}, {
        updateId: prevState.updateId + 1
      });
      var newState = _objectSpread$a(_objectSpread$a(_objectSpread$a({}, _defaultState), keepFromPrevState), updatesToState);
      return _objectSpread$a(_objectSpread$a(_objectSpread$a({}, newState), updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread$a({
        props: nextProps
      }, newState), prevState)), {}, {
        prevDataKey: dataKey,
        prevData: data,
        prevWidth: width,
        prevHeight: height,
        prevLayout: layout,
        prevStackOffset: stackOffset,
        prevMargin: margin,
        prevChildren: children
      });
    }
    if (!(0, _ReactUtils$4.isChildrenEqual)(children, prevState.prevChildren)) {
      var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
      // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
      var brush = (0, _ReactUtils$4.findChildByType)(children, _Brush.Brush);
      var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
      var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
      var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;

      // update configuration in children
      var hasGlobalData = !(0, _isNil["default"])(data);
      var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
      return _objectSpread$a(_objectSpread$a({
        updateId: newUpdateId
      }, updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread$a(_objectSpread$a({
        props: nextProps
      }, prevState), {}, {
        updateId: newUpdateId,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex
      }), prevState)), {}, {
        prevChildren: children,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex
      });
    }
    return null;
  });
  _defineProperty$d(CategoricalChartWrapper, "renderActiveDot", function (option, props, key) {
    var dot;
    if ( /*#__PURE__*/(0, _react$c.isValidElement)(option)) {
      dot = /*#__PURE__*/(0, _react$c.cloneElement)(option, props);
    } else if ((0, _isFunction$3["default"])(option)) {
      dot = option(props);
    } else {
      dot = /*#__PURE__*/_react$c["default"].createElement(_Dot.Dot, props);
    }
    return /*#__PURE__*/_react$c["default"].createElement(_Layer$4.Layer, {
      className: "recharts-active-dot",
      key: key
    }, dot);
  });
  var CategoricalChart = /*#__PURE__*/(0, _react$c.forwardRef)(function CategoricalChart(props, ref) {
    return /*#__PURE__*/_react$c["default"].createElement(CategoricalChartWrapper, _extends$b({}, props, {
      ref: ref
    }));
  });
  CategoricalChart.displayName = CategoricalChartWrapper.displayName;
  return CategoricalChart;
};

Object.defineProperty(LineChart, "__esModule", {
  value: true
});
LineChart.LineChart = void 0;
var _generateCategoricalChart$8 = generateCategoricalChart;
var _Line$1 = Line$1;
var _XAxis$4 = XAxis$1;
var _YAxis$4 = YAxis$1;
var _CartesianUtils$4 = CartesianUtils;
/**
 * @fileOverview Line Chart
 */

LineChart.LineChart = (0, _generateCategoricalChart$8.generateCategoricalChart)({
  chartName: 'LineChart',
  GraphicalChild: _Line$1.Line,
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: _XAxis$4.XAxis
  }, {
    axisType: 'yAxis',
    AxisComp: _YAxis$4.YAxis
  }],
  formatAxisMap: _CartesianUtils$4.formatAxisMap
});

var BarChart = {};

Object.defineProperty(BarChart, "__esModule", {
  value: true
});
BarChart.BarChart = void 0;
var _generateCategoricalChart$7 = generateCategoricalChart;
var _Bar$1 = Bar$1;
var _XAxis$3 = XAxis$1;
var _YAxis$3 = YAxis$1;
var _CartesianUtils$3 = CartesianUtils;
/**
 * @fileOverview Bar Chart
 */

BarChart.BarChart = (0, _generateCategoricalChart$7.generateCategoricalChart)({
  chartName: 'BarChart',
  GraphicalChild: _Bar$1.Bar,
  defaultTooltipEventType: 'axis',
  validateTooltipEventTypes: ['axis', 'item'],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: _XAxis$3.XAxis
  }, {
    axisType: 'yAxis',
    AxisComp: _YAxis$3.YAxis
  }],
  formatAxisMap: _CartesianUtils$3.formatAxisMap
});

var PieChart = {};

Object.defineProperty(PieChart, "__esModule", {
  value: true
});
PieChart.PieChart = void 0;
var _generateCategoricalChart$6 = generateCategoricalChart;
var _PolarAngleAxis$2 = PolarAngleAxis$1;
var _PolarRadiusAxis$2 = PolarRadiusAxis$1;
var _PolarUtils$3 = PolarUtils;
var _Pie = Pie$1;
/**
 * @fileOverview Pie Chart
 */

PieChart.PieChart = (0, _generateCategoricalChart$6.generateCategoricalChart)({
  chartName: 'PieChart',
  GraphicalChild: _Pie.Pie,
  validateTooltipEventTypes: ['item'],
  defaultTooltipEventType: 'item',
  legendContent: 'children',
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: _PolarAngleAxis$2.PolarAngleAxis
  }, {
    axisType: 'radiusAxis',
    AxisComp: _PolarRadiusAxis$2.PolarRadiusAxis
  }],
  formatAxisMap: _PolarUtils$3.formatAxisMap,
  defaultProps: {
    layout: 'centric',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  }
});

var Treemap$1 = {};

var baseGet = _baseGet,
    baseSlice = _baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent$1(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

var _parent = parent$1;

var castPath$1 = _castPath,
    last = last_1,
    parent = _parent,
    toKey = _toKey;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset$1(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

var _baseUnset = baseUnset$1;

var isPlainObject = isPlainObject_1;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone$1(value) {
  return isPlainObject(value) ? undefined : value;
}

var _customOmitClone = customOmitClone$1;

var baseFlatten = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

var flatten_1 = flatten$1;

var flatten = flatten_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$1(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

var _flatRest = flatRest$1;

var arrayMap = _arrayMap,
    baseClone = _baseClone,
    baseUnset = _baseUnset,
    castPath = _castPath,
    copyObject = _copyObject,
    customOmitClone = _customOmitClone,
    flatRest = _flatRest,
    getAllKeysIn = _getAllKeysIn;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

var omit_1 = omit;

var Constants = {};

Object.defineProperty(Constants, "__esModule", {
  value: true
});
Constants.COLOR_PANEL = void 0;
Constants.COLOR_PANEL = ['#1890FF', '#66B5FF', '#41D9C7', '#2FC25B', '#6EDB8F', '#9AE65C', '#FACC14', '#E6965C', '#57AD71', '#223273', '#738AE6', '#7564CC', '#8543E0', '#A877ED', '#5C8EE6', '#13C2C2', '#70E0E0', '#5CA3E6', '#3436C7', '#8082FF', '#DD81E6', '#F04864', '#FA7D92', '#D598D9'];

Object.defineProperty(Treemap$1, "__esModule", {
  value: true
});
Treemap$1.Treemap = void 0;
var _isNaN = _interopRequireDefault$f(_isNaN$3);
var _isFunction$2 = _interopRequireDefault$f(isFunction_1);
var _omit$1 = _interopRequireDefault$f(omit_1);
var _get$1 = _interopRequireDefault$f(get_1);
var _clsx$3 = _interopRequireDefault$f(clsx.exports);
var _react$b = _interopRequireWildcard$3(React__default$4);
var _reactSmooth$1 = _interopRequireDefault$f(lib);
var _Tooltip$2 = Tooltip$1;
var _Layer$3 = Layer;
var _Surface$2 = Surface$1;
var _Polygon = Polygon;
var _Rectangle$1 = Rectangle;
var _ChartUtils$2 = ChartUtils;
var _Constants = Constants;
var _DataUtils$1 = DataUtils;
var _DOMUtils = DOMUtils;
var _Global$1 = Global$1;
var _ReactUtils$3 = ReactUtils;
var _excluded$2 = ["width", "height", "className", "style", "children", "type"];
function _getRequireWildcardCache$3(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$3 = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$3(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$7(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$3(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault$f(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$7(o) { "@babel/helpers - typeof"; return _typeof$7 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$7(o); }
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$b(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$4(descriptor.key), descriptor); } }
function _createClass$h(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$b(Constructor.prototype, protoProps); if (staticProps) _defineProperties$b(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$2(t, o, e) { return o = _getPrototypeOf$3(o), _possibleConstructorReturn$9(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf$3(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$9(self, call) { if (call && (_typeof$7(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$3(self); }
function _assertThisInitialized$3(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$3(o) { _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$3(o); }
function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$3(subClass, superClass); }
function _setPrototypeOf$3(o, p) { _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$3(o, p); }
function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) { _defineProperty$c(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$c(obj, key, value) { key = _toPropertyKey$4(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$4(t) { var i = _toPrimitive$4(t, "string"); return "symbol" == _typeof$7(i) ? i : i + ""; }
function _toPrimitive$4(t, r) { if ("object" != _typeof$7(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$7(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview TreemapChart
 */
var NODE_VALUE_KEY = 'value';
var computeNode = function computeNode(_ref) {
  var depth = _ref.depth,
    node = _ref.node,
    index = _ref.index,
    valueKey = _ref.valueKey;
  var children = node.children;
  var childDepth = depth + 1;
  var computedChildren = children && children.length ? children.map(function (child, i) {
    return computeNode({
      depth: childDepth,
      node: child,
      index: i,
      valueKey: valueKey
    });
  }) : null;
  var nodeValue;
  if (children && children.length) {
    nodeValue = computedChildren.reduce(function (result, child) {
      return result + child[NODE_VALUE_KEY];
    }, 0);
  } else {
    // TODO need to verify valueKey
    nodeValue = (0, _isNaN["default"])(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
  }
  return _objectSpread$9(_objectSpread$9({}, node), {}, _defineProperty$c(_defineProperty$c(_defineProperty$c({
    children: computedChildren
  }, NODE_VALUE_KEY, nodeValue), "depth", depth), "index", index));
};
var filterRect = function filterRect(node) {
  return {
    x: node.x,
    y: node.y,
    width: node.width,
    height: node.height
  };
};

// Compute the area for each child based on value & scale.
var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
  return children.map(function (child) {
    var area = child[NODE_VALUE_KEY] * ratio;
    return _objectSpread$9(_objectSpread$9({}, child), {}, {
      area: (0, _isNaN["default"])(area) || area <= 0 ? 0 : area
    });
  });
};

// Computes the score for the specified row, as the worst aspect ratio.
var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
  var parentArea = parentSize * parentSize;
  var rowArea = row.area * row.area;
  var _row$reduce = row.reduce(function (result, child) {
      return {
        min: Math.min(result.min, child.area),
        max: Math.max(result.max, child.area)
      };
    }, {
      min: Infinity,
      max: 0
    }),
    min = _row$reduce.min,
    max = _row$reduce.max;
  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
};
var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
  if (isFlush || rowHeight > parentRect.height) {
    rowHeight = parentRect.height;
  }
  var curX = parentRect.x;
  var child;
  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = curX;
    child.y = parentRect.y;
    child.height = rowHeight;
    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
    curX += child.width;
  }
  // add the remain x to the last one of row
  child.width += parentRect.x + parentRect.width - curX;
  return _objectSpread$9(_objectSpread$9({}, parentRect), {}, {
    y: parentRect.y + rowHeight,
    height: parentRect.height - rowHeight
  });
};
var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
  if (isFlush || rowWidth > parentRect.width) {
    rowWidth = parentRect.width;
  }
  var curY = parentRect.y;
  var child;
  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = parentRect.x;
    child.y = curY;
    child.width = rowWidth;
    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
    curY += child.height;
  }
  if (child) {
    child.height += parentRect.y + parentRect.height - curY;
  }
  return _objectSpread$9(_objectSpread$9({}, parentRect), {}, {
    x: parentRect.x + rowWidth,
    width: parentRect.width - rowWidth
  });
};
var position = function position(row, parentSize, parentRect, isFlush) {
  if (parentSize === parentRect.width) {
    return horizontalPosition(row, parentSize, parentRect, isFlush);
  }
  return verticalPosition(row, parentSize, parentRect, isFlush);
};

// Recursively arranges the specified node's children into squarified rows.
var squarify = function squarify(node, aspectRatio) {
  var children = node.children;
  if (children && children.length) {
    var rect = filterRect(node);
    // maybe a bug
    var row = [];
    var best = Infinity; // the best row score so far
    var child, score; // the current row score
    var size = Math.min(rect.width, rect.height); // initial orientation
    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node[NODE_VALUE_KEY]);
    var tempChildren = scaleChildren.slice();
    row.area = 0;
    while (tempChildren.length > 0) {
      // row first
      // eslint-disable-next-line prefer-destructuring
      row.push(child = tempChildren[0]);
      row.area += child.area;
      score = getWorstScore(row, size, aspectRatio);
      if (score <= best) {
        // continue with this orientation
        tempChildren.shift();
        best = score;
      } else {
        // abort, and try a different orientation
        row.area -= row.pop().area;
        rect = position(row, size, rect, false);
        size = Math.min(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
    }
    if (row.length) {
      rect = position(row, size, rect, true);
      row.length = row.area = 0;
    }
    return _objectSpread$9(_objectSpread$9({}, node), {}, {
      children: scaleChildren.map(function (c) {
        return squarify(c, aspectRatio);
      })
    });
  }
  return node;
};
var defaultState = {
  isTooltipActive: false,
  isAnimationFinished: false,
  activeNode: null,
  formatRoot: null,
  currentRoot: null,
  nestIndex: []
};
var Treemap = Treemap$1.Treemap = /*#__PURE__*/function (_PureComponent) {
  function Treemap() {
    var _this;
    _classCallCheck$h(this, Treemap);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$2(this, Treemap, [].concat(args));
    _defineProperty$c(_this, "state", _objectSpread$9({}, defaultState));
    _defineProperty$c(_this, "handleAnimationEnd", function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if ((0, _isFunction$2["default"])(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$c(_this, "handleAnimationStart", function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if ((0, _isFunction$2["default"])(onAnimationStart)) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _inherits$9(Treemap, _PureComponent);
  return _createClass$h(Treemap, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter(node, e) {
      e.persist();
      var _this$props = this.props,
        onMouseEnter = _this$props.onMouseEnter,
        children = _this$props.children;
      var tooltipItem = (0, _ReactUtils$3.findChildByType)(children, _Tooltip$2.Tooltip);
      if (tooltipItem) {
        this.setState({
          isTooltipActive: true,
          activeNode: node
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(node, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(node, e);
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(node, e) {
      e.persist();
      var _this$props2 = this.props,
        onMouseLeave = _this$props2.onMouseLeave,
        children = _this$props2.children;
      var tooltipItem = (0, _ReactUtils$3.findChildByType)(children, _Tooltip$2.Tooltip);
      if (tooltipItem) {
        this.setState({
          isTooltipActive: false,
          activeNode: null
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(node, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(node, e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(node) {
      var _this$props3 = this.props,
        onClick = _this$props3.onClick,
        type = _this$props3.type;
      if (type === 'nest' && node.children) {
        var _this$props4 = this.props,
          width = _this$props4.width,
          height = _this$props4.height,
          dataKey = _this$props4.dataKey,
          aspectRatio = _this$props4.aspectRatio;
        var root = computeNode({
          depth: 0,
          node: _objectSpread$9(_objectSpread$9({}, node), {}, {
            x: 0,
            y: 0,
            width: width,
            height: height
          }),
          index: 0,
          valueKey: dataKey
        });
        var formatRoot = squarify(root, aspectRatio);
        var nestIndex = this.state.nestIndex;
        nestIndex.push(node);
        this.setState({
          formatRoot: formatRoot,
          currentRoot: root,
          nestIndex: nestIndex
        });
      }
      if (onClick) {
        onClick(node);
      }
    }
  }, {
    key: "handleNestIndex",
    value: function handleNestIndex(node, i) {
      var nestIndex = this.state.nestIndex;
      var _this$props5 = this.props,
        width = _this$props5.width,
        height = _this$props5.height,
        dataKey = _this$props5.dataKey,
        aspectRatio = _this$props5.aspectRatio;
      var root = computeNode({
        depth: 0,
        node: _objectSpread$9(_objectSpread$9({}, node), {}, {
          x: 0,
          y: 0,
          width: width,
          height: height
        }),
        index: 0,
        valueKey: dataKey
      });
      var formatRoot = squarify(root, aspectRatio);
      nestIndex = nestIndex.slice(0, i + 1);
      this.setState({
        formatRoot: formatRoot,
        currentRoot: node,
        nestIndex: nestIndex
      });
    }
  }, {
    key: "renderItem",
    value: function renderItem(content, nodeProps, isLeaf) {
      var _this2 = this;
      var _this$props6 = this.props,
        isAnimationActive = _this$props6.isAnimationActive,
        animationBegin = _this$props6.animationBegin,
        animationDuration = _this$props6.animationDuration,
        animationEasing = _this$props6.animationEasing,
        isUpdateAnimationActive = _this$props6.isUpdateAnimationActive,
        type = _this$props6.type,
        animationId = _this$props6.animationId,
        colorPanel = _this$props6.colorPanel;
      var isAnimationFinished = this.state.isAnimationFinished;
      var width = nodeProps.width,
        height = nodeProps.height,
        x = nodeProps.x,
        y = nodeProps.y,
        depth = nodeProps.depth;
      var translateX = parseInt("".concat((Math.random() * 2 - 1) * width), 10);
      var event = {};
      if (isLeaf || type === 'nest') {
        event = {
          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
          onClick: this.handleClick.bind(this, nodeProps)
        };
      }
      if (!isAnimationActive) {
        return /*#__PURE__*/_react$b["default"].createElement(_Layer$3.Layer, event, this.constructor.renderContentItem(content, _objectSpread$9(_objectSpread$9({}, nodeProps), {}, {
          isAnimationActive: false,
          isUpdateAnimationActive: false,
          width: width,
          height: height,
          x: x,
          y: y
        }), type, colorPanel));
      }
      return /*#__PURE__*/_react$b["default"].createElement(_reactSmooth$1["default"], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        key: "treemap-".concat(animationId),
        from: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        to: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref2) {
        var currX = _ref2.x,
          currY = _ref2.y,
          currWidth = _ref2.width,
          currHeight = _ref2.height;
        return /*#__PURE__*/_react$b["default"].createElement(_reactSmooth$1["default"], {
          from: "translate(".concat(translateX, "px, ").concat(translateX, "px)"),
          to: "translate(0, 0)",
          attributeName: "transform",
          begin: animationBegin,
          easing: animationEasing,
          isActive: isAnimationActive,
          duration: animationDuration
        }, /*#__PURE__*/_react$b["default"].createElement(_Layer$3.Layer, event, function () {
          // when animation Duration , only render depth=1 nodes
          if (depth > 2 && !isAnimationFinished) {
            return null;
          }
          return _this2.constructor.renderContentItem(content, _objectSpread$9(_objectSpread$9({}, nodeProps), {}, {
            isAnimationActive: isAnimationActive,
            isUpdateAnimationActive: !isUpdateAnimationActive,
            width: currWidth,
            height: currHeight,
            x: currX,
            y: currY
          }), type, colorPanel);
        }()));
      });
    }
  }, {
    key: "renderNode",
    value: function renderNode(root, node) {
      var _this3 = this;
      var _this$props7 = this.props,
        content = _this$props7.content,
        type = _this$props7.type;
      var nodeProps = _objectSpread$9(_objectSpread$9(_objectSpread$9({}, (0, _ReactUtils$3.filterProps)(this.props, false)), node), {}, {
        root: root
      });
      var isLeaf = !node.children || !node.children.length;
      var currentRoot = this.state.currentRoot;
      var isCurrentRootChild = (currentRoot.children || []).filter(function (item) {
        return item.depth === node.depth && item.name === node.name;
      });
      if (!isCurrentRootChild.length && root.depth && type === 'nest') {
        return null;
      }
      return /*#__PURE__*/_react$b["default"].createElement(_Layer$3.Layer, {
        key: "recharts-treemap-node-".concat(nodeProps.x, "-").concat(nodeProps.y, "-").concat(nodeProps.name),
        className: "recharts-treemap-depth-".concat(node.depth)
      }, this.renderItem(content, nodeProps, isLeaf), node.children && node.children.length ? node.children.map(function (child) {
        return _this3.renderNode(node, child);
      }) : null);
    }
  }, {
    key: "renderAllNodes",
    value: function renderAllNodes() {
      var formatRoot = this.state.formatRoot;
      if (!formatRoot) {
        return null;
      }
      return this.renderNode(formatRoot, formatRoot);
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var _this$props8 = this.props,
        children = _this$props8.children,
        nameKey = _this$props8.nameKey;
      var tooltipItem = (0, _ReactUtils$3.findChildByType)(children, _Tooltip$2.Tooltip);
      if (!tooltipItem) {
        return null;
      }
      var _this$props9 = this.props,
        width = _this$props9.width,
        height = _this$props9.height;
      var _this$state = this.state,
        isTooltipActive = _this$state.isTooltipActive,
        activeNode = _this$state.activeNode;
      var viewBox = {
        x: 0,
        y: 0,
        width: width,
        height: height
      };
      var coordinate = activeNode ? {
        x: activeNode.x + activeNode.width / 2,
        y: activeNode.y + activeNode.height / 2
      } : null;
      var payload = isTooltipActive && activeNode ? [{
        payload: activeNode,
        name: (0, _ChartUtils$2.getValueByDataKey)(activeNode, nameKey, ''),
        value: (0, _ChartUtils$2.getValueByDataKey)(activeNode, NODE_VALUE_KEY)
      }] : [];
      return /*#__PURE__*/_react$b["default"].cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    }

    // render nest treemap
  }, {
    key: "renderNestIndex",
    value: function renderNestIndex() {
      var _this4 = this;
      var _this$props10 = this.props,
        nameKey = _this$props10.nameKey,
        nestIndexContent = _this$props10.nestIndexContent;
      var nestIndex = this.state.nestIndex;
      return /*#__PURE__*/_react$b["default"].createElement("div", {
        className: "recharts-treemap-nest-index-wrapper",
        style: {
          marginTop: '8px',
          textAlign: 'center'
        }
      }, nestIndex.map(function (item, i) {
        // TODO need to verify nameKey type
        var name = (0, _get$1["default"])(item, nameKey, 'root');
        var content = null;
        if ( /*#__PURE__*/_react$b["default"].isValidElement(nestIndexContent)) {
          content = /*#__PURE__*/_react$b["default"].cloneElement(nestIndexContent, item, i);
        }
        if ((0, _isFunction$2["default"])(nestIndexContent)) {
          content = nestIndexContent(item, i);
        } else {
          content = name;
        }
        return (
          /*#__PURE__*/
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          _react$b["default"].createElement("div", {
            onClick: _this4.handleNestIndex.bind(_this4, item, i),
            key: "nest-index-".concat((0, _DataUtils$1.uniqueId)()),
            className: "recharts-treemap-nest-index-box",
            style: {
              cursor: 'pointer',
              display: 'inline-block',
              padding: '0 7px',
              background: '#000',
              color: '#fff',
              marginRight: '3px'
            }
          }, content)
        );
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (!(0, _ReactUtils$3.validateWidthHeight)(this)) {
        return null;
      }
      var _this$props11 = this.props,
        width = _this$props11.width,
        height = _this$props11.height,
        className = _this$props11.className,
        style = _this$props11.style,
        children = _this$props11.children,
        type = _this$props11.type,
        others = _objectWithoutProperties$5(_this$props11, _excluded$2);
      var attrs = (0, _ReactUtils$3.filterProps)(others, false);
      return /*#__PURE__*/_react$b["default"].createElement("div", {
        className: (0, _clsx$3["default"])('recharts-wrapper', className),
        style: _objectSpread$9(_objectSpread$9({}, style), {}, {
          position: 'relative',
          cursor: 'default',
          width: width,
          height: height
        }),
        role: "region"
      }, /*#__PURE__*/_react$b["default"].createElement(_Surface$2.Surface, _extends$a({}, attrs, {
        width: width,
        height: type === 'nest' ? height - 30 : height
      }), this.renderAllNodes(), (0, _ReactUtils$3.filterSvgElements)(children)), this.renderTooltip(), type === 'nest' && this.renderNestIndex());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.data !== prevState.prevData || nextProps.type !== prevState.prevType || nextProps.width !== prevState.prevWidth || nextProps.height !== prevState.prevHeight || nextProps.dataKey !== prevState.prevDataKey || nextProps.aspectRatio !== prevState.prevAspectRatio) {
        var root = computeNode({
          depth: 0,
          node: {
            children: nextProps.data,
            x: 0,
            y: 0,
            width: nextProps.width,
            height: nextProps.height
          },
          index: 0,
          valueKey: nextProps.dataKey
        });
        var formatRoot = squarify(root, nextProps.aspectRatio);
        return _objectSpread$9(_objectSpread$9({}, prevState), {}, {
          formatRoot: formatRoot,
          currentRoot: root,
          nestIndex: [root],
          prevAspectRatio: nextProps.aspectRatio,
          prevData: nextProps.data,
          prevWidth: nextProps.width,
          prevHeight: nextProps.height,
          prevDataKey: nextProps.dataKey,
          prevType: nextProps.type
        });
      }
      return null;
    }
  }, {
    key: "renderContentItem",
    value: function renderContentItem(content, nodeProps, type, colorPanel) {
      if ( /*#__PURE__*/_react$b["default"].isValidElement(content)) {
        return /*#__PURE__*/_react$b["default"].cloneElement(content, nodeProps);
      }
      if ((0, _isFunction$2["default"])(content)) {
        return content(nodeProps);
      }
      // optimize default shape
      var x = nodeProps.x,
        y = nodeProps.y,
        width = nodeProps.width,
        height = nodeProps.height,
        index = nodeProps.index;
      var arrow = null;
      if (width > 10 && height > 10 && nodeProps.children && type === 'nest') {
        arrow = /*#__PURE__*/_react$b["default"].createElement(_Polygon.Polygon, {
          points: [{
            x: x + 2,
            y: y + height / 2
          }, {
            x: x + 6,
            y: y + height / 2 + 3
          }, {
            x: x + 2,
            y: y + height / 2 + 6
          }]
        });
      }
      var text = null;
      var nameSize = (0, _DOMUtils.getStringSize)(nodeProps.name);
      if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) {
        text = /*#__PURE__*/_react$b["default"].createElement("text", {
          x: x + 8,
          y: y + height / 2 + 7,
          fontSize: 14
        }, nodeProps.name);
      }
      var colors = colorPanel || _Constants.COLOR_PANEL;
      return /*#__PURE__*/_react$b["default"].createElement("g", null, /*#__PURE__*/_react$b["default"].createElement(_Rectangle$1.Rectangle, _extends$a({
        fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
        stroke: "#fff"
      }, (0, _omit$1["default"])(nodeProps, 'children'), {
        role: "img"
      })), arrow, text);
    }
  }]);
}(_react$b.PureComponent);
_defineProperty$c(Treemap, "displayName", 'Treemap');
_defineProperty$c(Treemap, "defaultProps", {
  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
  dataKey: 'value',
  type: 'flat',
  isAnimationActive: !_Global$1.Global.isSsr,
  isUpdateAnimationActive: !_Global$1.Global.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'linear'
});

var Sankey$1 = {};

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */

function baseSum$1(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

var _baseSum = baseSum$1;

var baseIteratee = _baseIteratee,
    baseSum = _baseSum;

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee))
    : 0;
}

var sumBy_1 = sumBy;

Object.defineProperty(Sankey$1, "__esModule", {
  value: true
});
Sankey$1.Sankey = void 0;
var _react$a = _interopRequireWildcard$2(React__default$4);
var _maxBy = _interopRequireDefault$e(maxBy_1);
var _min = _interopRequireDefault$e(min_1);
var _get = _interopRequireDefault$e(get_1);
var _sumBy = _interopRequireDefault$e(sumBy_1);
var _isFunction$1 = _interopRequireDefault$e(isFunction_1);
var _clsx$2 = _interopRequireDefault$e(clsx.exports);
var _Surface$1 = Surface$1;
var _Layer$2 = Layer;
var _Tooltip$1 = Tooltip$1;
var _Rectangle = Rectangle;
var _ShallowEqual = ShallowEqual;
var _ReactUtils$2 = ReactUtils;
var _ChartUtils$1 = ChartUtils;
var _excluded$1 = ["width", "height", "className", "style", "children"],
  _excluded2 = ["sourceX", "sourceY", "sourceControlX", "targetX", "targetY", "targetControlX", "linkWidth"];
function _interopRequireDefault$e(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$2(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$2 = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$2(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$6(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$2(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof$6(o) { "@babel/helpers - typeof"; return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$6(o); }
function _objectWithoutProperties$4(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$a(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$3(descriptor.key), descriptor); } }
function _createClass$g(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$a(Constructor.prototype, protoProps); if (staticProps) _defineProperties$a(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper$1(t, o, e) { return o = _getPrototypeOf$2(o), _possibleConstructorReturn$8(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf$2(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$8(self, call) { if (call && (_typeof$6(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$2(self); }
function _assertThisInitialized$2(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$2(o) { _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$2(o); }
function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$2(subClass, superClass); }
function _setPrototypeOf$2(o, p) { _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$2(o, p); }
function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) { _defineProperty$b(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$b(obj, key, value) { key = _toPropertyKey$3(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$3(t) { var i = _toPrimitive$3(t, "string"); return "symbol" == _typeof$6(i) ? i : i + ""; }
function _toPrimitive$3(t, r) { if ("object" != _typeof$6(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$6(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @file TreemapChart
 */
var defaultCoordinateOfTooltip = {
  x: 0,
  y: 0
};
var interpolationGenerator = function interpolationGenerator(a, b) {
  var ka = +a;
  var kb = b - ka;
  return function (t) {
    return ka + kb * t;
  };
};
var centerY = function centerY(node) {
  return node.y + node.dy / 2;
};
var getValue = function getValue(entry) {
  return entry && entry.value || 0;
};
var getSumOfIds = function getSumOfIds(links, ids) {
  return ids.reduce(function (result, id) {
    return result + getValue(links[id]);
  }, 0);
};
var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var sourceNode = tree[link.source];
    return result + centerY(sourceNode) * getValue(links[id]);
  }, 0);
};
var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var targetNode = tree[link.target];
    return result + centerY(targetNode) * getValue(links[id]);
  }, 0);
};
var ascendingY = function ascendingY(a, b) {
  return a.y - b.y;
};
var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
  var sourceNodes = [];
  var sourceLinks = [];
  var targetNodes = [];
  var targetLinks = [];
  for (var i = 0, len = links.length; i < len; i++) {
    var link = links[i];
    if (link.source === id) {
      targetNodes.push(link.target);
      targetLinks.push(i);
    }
    if (link.target === id) {
      sourceNodes.push(link.source);
      sourceLinks.push(i);
    }
  }
  return {
    sourceNodes: sourceNodes,
    sourceLinks: sourceLinks,
    targetLinks: targetLinks,
    targetNodes: targetNodes
  };
};
var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
  var targetNodes = curNode.targetNodes;
  for (var i = 0, len = targetNodes.length; i < len; i++) {
    var target = tree[targetNodes[i]];
    if (target) {
      target.depth = Math.max(curNode.depth + 1, target.depth);
      updateDepthOfTargets(tree, target);
    }
  }
};
var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
  var nodes = _ref.nodes,
    links = _ref.links;
  var tree = nodes.map(function (entry, index) {
    var result = searchTargetsAndSources(links, index);
    return _objectSpread$8(_objectSpread$8(_objectSpread$8({}, entry), result), {}, {
      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
      depth: 0
    });
  });
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    if (!node.sourceNodes.length) {
      updateDepthOfTargets(tree, node);
    }
  }
  var maxDepth = (0, _maxBy["default"])(tree, function (entry) {
    return entry.depth;
  }).depth;
  if (maxDepth >= 1) {
    var childWidth = (width - nodeWidth) / maxDepth;
    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
      var _node = tree[_i];
      if (!_node.targetNodes.length) {
        _node.depth = maxDepth;
      }
      _node.x = _node.depth * childWidth;
      _node.dx = nodeWidth;
    }
  }
  return {
    tree: tree,
    maxDepth: maxDepth
  };
};
var getDepthTree = function getDepthTree(tree) {
  var result = [];
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    if (!result[node.depth]) {
      result[node.depth] = [];
    }
    result[node.depth].push(node);
  }
  return result;
};
var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
  var yRatio = (0, _min["default"])(depthTree.map(function (nodes) {
    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy["default"])(nodes, getValue);
  }));
  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
    for (var i = 0, len = depthTree[d].length; i < len; i++) {
      var node = depthTree[d][i];
      node.y = i;
      node.dy = node.value * yRatio;
    }
  }
  return links.map(function (link) {
    return _objectSpread$8(_objectSpread$8({}, link), {}, {
      dy: getValue(link) * yRatio
    });
  });
};
var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
  var sort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  for (var i = 0, len = depthTree.length; i < len; i++) {
    var nodes = depthTree[i];
    var n = nodes.length;

    // Sort by the value of y
    if (sort) {
      nodes.sort(ascendingY);
    }
    var y0 = 0;
    for (var j = 0; j < n; j++) {
      var node = nodes[j];
      var dy = y0 - node.y;
      if (dy > 0) {
        node.y += dy;
      }
      y0 = node.y + node.dy + nodePadding;
    }
    y0 = height + nodePadding;
    for (var _j = n - 1; _j >= 0; _j--) {
      var _node2 = nodes[_j];
      var _dy = _node2.y + _node2.dy + nodePadding - y0;
      if (_dy > 0) {
        _node2.y -= _dy;
        y0 = _node2.y;
      } else {
        break;
      }
    }
  }
};
var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
    var nodes = depthTree[i];
    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];
      if (node.sourceLinks.length) {
        var sourceSum = getSumOfIds(links, node.sourceLinks);
        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
        var y = weightedSum / sourceSum;
        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
  for (var i = depthTree.length - 1; i >= 0; i--) {
    var nodes = depthTree[i];
    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];
      if (node.targetLinks.length) {
        var targetSum = getSumOfIds(links, node.targetLinks);
        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
        var y = weightedSum / targetSum;
        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};
var updateYOfLinks = function updateYOfLinks(tree, links) {
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    var sy = 0;
    var ty = 0;
    node.targetLinks.sort(function (a, b) {
      return tree[links[a].target].y - tree[links[b].target].y;
    });
    node.sourceLinks.sort(function (a, b) {
      return tree[links[a].source].y - tree[links[b].source].y;
    });
    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
      var link = links[node.targetLinks[j]];
      if (link) {
        link.sy = sy;
        sy += link.dy;
      }
    }
    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
      var _link = links[node.sourceLinks[_j2]];
      if (_link) {
        _link.ty = ty;
        ty += _link.dy;
      }
    }
  }
};
var computeData = function computeData(_ref2) {
  var data = _ref2.data,
    width = _ref2.width,
    height = _ref2.height,
    iterations = _ref2.iterations,
    nodeWidth = _ref2.nodeWidth,
    nodePadding = _ref2.nodePadding,
    sort = _ref2.sort;
  var links = data.links;
  var _getNodesTree = getNodesTree(data, width, nodeWidth),
    tree = _getNodesTree.tree;
  var depthTree = getDepthTree(tree);
  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
  resolveCollisions(depthTree, height, nodePadding, sort);
  var alpha = 1;
  for (var i = 1; i <= iterations; i++) {
    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
    resolveCollisions(depthTree, height, nodePadding, sort);
    relaxLeftToRight(tree, depthTree, newLinks, alpha);
    resolveCollisions(depthTree, height, nodePadding, sort);
  }
  updateYOfLinks(tree, newLinks);
  return {
    nodes: tree,
    links: newLinks
  };
};
var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
  if (type === 'node') {
    return {
      x: el.x + el.width / 2,
      y: el.y + el.height / 2
    };
  }
  return {
    x: (el.sourceX + el.targetX) / 2,
    y: (el.sourceY + el.targetY) / 2
  };
};
var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
  var payload = el.payload;
  if (type === 'node') {
    return [{
      payload: el,
      name: (0, _ChartUtils$1.getValueByDataKey)(payload, nameKey, ''),
      value: (0, _ChartUtils$1.getValueByDataKey)(payload, 'value')
    }];
  }
  if (payload.source && payload.target) {
    var sourceName = (0, _ChartUtils$1.getValueByDataKey)(payload.source, nameKey, '');
    var targetName = (0, _ChartUtils$1.getValueByDataKey)(payload.target, nameKey, '');
    return [{
      payload: el,
      name: "".concat(sourceName, " - ").concat(targetName),
      value: (0, _ChartUtils$1.getValueByDataKey)(payload, 'value')
    }];
  }
  return [];
};
var Sankey = Sankey$1.Sankey = /*#__PURE__*/function (_PureComponent) {
  function Sankey() {
    var _this;
    _classCallCheck$g(this, Sankey);
    for (var _len2 = arguments.length, args = new Array(_len2), _key = 0; _key < _len2; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper$1(this, Sankey, [].concat(args));
    _defineProperty$b(_this, "state", {
      activeElement: null,
      activeElementType: null,
      isTooltipActive: false,
      nodes: [],
      links: []
    });
    return _this;
  }
  _inherits$8(Sankey, _PureComponent);
  return _createClass$g(Sankey, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter(el, type, e) {
      var _this$props = this.props,
        onMouseEnter = _this$props.onMouseEnter,
        children = _this$props.children;
      var tooltipItem = (0, _ReactUtils$2.findChildByType)(children, _Tooltip$1.Tooltip);
      if (tooltipItem) {
        this.setState(function (prev) {
          if (tooltipItem.props.trigger === 'hover') {
            return _objectSpread$8(_objectSpread$8({}, prev), {}, {
              activeElement: el,
              activeElementType: type,
              isTooltipActive: true
            });
          }
          return prev;
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(el, type, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(el, type, e);
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(el, type, e) {
      var _this$props2 = this.props,
        onMouseLeave = _this$props2.onMouseLeave,
        children = _this$props2.children;
      var tooltipItem = (0, _ReactUtils$2.findChildByType)(children, _Tooltip$1.Tooltip);
      if (tooltipItem) {
        this.setState(function (prev) {
          if (tooltipItem.props.trigger === 'hover') {
            return _objectSpread$8(_objectSpread$8({}, prev), {}, {
              activeElement: undefined,
              activeElementType: undefined,
              isTooltipActive: false
            });
          }
          return prev;
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(el, type, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(el, type, e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(el, type, e) {
      var _this$props3 = this.props,
        onClick = _this$props3.onClick,
        children = _this$props3.children;
      var tooltipItem = (0, _ReactUtils$2.findChildByType)(children, _Tooltip$1.Tooltip);
      if (tooltipItem && tooltipItem.props.trigger === 'click') {
        if (this.state.isTooltipActive) {
          this.setState(function (prev) {
            return _objectSpread$8(_objectSpread$8({}, prev), {}, {
              activeElement: undefined,
              activeElementType: undefined,
              isTooltipActive: false
            });
          });
        } else {
          this.setState(function (prev) {
            return _objectSpread$8(_objectSpread$8({}, prev), {}, {
              activeElement: el,
              activeElementType: type,
              isTooltipActive: true
            });
          });
        }
      }
      if (onClick) onClick(el, type, e);
    }
  }, {
    key: "renderLinks",
    value: function renderLinks(links, nodes) {
      var _this2 = this;
      var _this$props4 = this.props,
        linkCurvature = _this$props4.linkCurvature,
        linkContent = _this$props4.link,
        margin = _this$props4.margin;
      var top = (0, _get["default"])(margin, 'top') || 0;
      var left = (0, _get["default"])(margin, 'left') || 0;
      return /*#__PURE__*/_react$a["default"].createElement(_Layer$2.Layer, {
        className: "recharts-sankey-links",
        key: "recharts-sankey-links"
      }, links.map(function (link, i) {
        var sourceRelativeY = link.sy,
          targetRelativeY = link.ty,
          linkWidth = link.dy;
        var source = nodes[link.source];
        var target = nodes[link.target];
        var sourceX = source.x + source.dx + left;
        var targetX = target.x + left;
        var interpolationFunc = interpolationGenerator(sourceX, targetX);
        var sourceControlX = interpolationFunc(linkCurvature);
        var targetControlX = interpolationFunc(1 - linkCurvature);
        var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
        var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
        var linkProps = _objectSpread$8({
          sourceX: sourceX,
          targetX: targetX,
          sourceY: sourceY,
          targetY: targetY,
          sourceControlX: sourceControlX,
          targetControlX: targetControlX,
          sourceRelativeY: sourceRelativeY,
          targetRelativeY: targetRelativeY,
          linkWidth: linkWidth,
          index: i,
          payload: _objectSpread$8(_objectSpread$8({}, link), {}, {
            source: source,
            target: target
          })
        }, (0, _ReactUtils$2.filterProps)(linkContent, false));
        var events = {
          onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
          onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
          onClick: _this2.handleClick.bind(_this2, linkProps, 'link')
        };
        return /*#__PURE__*/_react$a["default"].createElement(_Layer$2.Layer, _extends$9({
          key: "link-".concat(link.source, "-").concat(link.target, "-").concat(link.value)
        }, events), _this2.constructor.renderLinkItem(linkContent, linkProps));
      }));
    }
  }, {
    key: "renderNodes",
    value: function renderNodes(nodes) {
      var _this3 = this;
      var _this$props5 = this.props,
        nodeContent = _this$props5.node,
        margin = _this$props5.margin;
      var top = (0, _get["default"])(margin, 'top') || 0;
      var left = (0, _get["default"])(margin, 'left') || 0;
      return /*#__PURE__*/_react$a["default"].createElement(_Layer$2.Layer, {
        className: "recharts-sankey-nodes",
        key: "recharts-sankey-nodes"
      }, nodes.map(function (node, i) {
        var x = node.x,
          y = node.y,
          dx = node.dx,
          dy = node.dy;
        var nodeProps = _objectSpread$8(_objectSpread$8({}, (0, _ReactUtils$2.filterProps)(nodeContent, false)), {}, {
          x: x + left,
          y: y + top,
          width: dx,
          height: dy,
          index: i,
          payload: node
        });
        var events = {
          onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
          onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
          onClick: _this3.handleClick.bind(_this3, nodeProps, 'node')
        };
        return /*#__PURE__*/_react$a["default"].createElement(_Layer$2.Layer, _extends$9({
          key: "node-".concat(node.x, "-").concat(node.y, "-").concat(node.value)
        }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps));
      }));
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var _this$props6 = this.props,
        children = _this$props6.children,
        width = _this$props6.width,
        height = _this$props6.height,
        nameKey = _this$props6.nameKey;
      var tooltipItem = (0, _ReactUtils$2.findChildByType)(children, _Tooltip$1.Tooltip);
      if (!tooltipItem) {
        return null;
      }
      var _this$state = this.state,
        isTooltipActive = _this$state.isTooltipActive,
        activeElement = _this$state.activeElement,
        activeElementType = _this$state.activeElementType;
      var viewBox = {
        x: 0,
        y: 0,
        width: width,
        height: height
      };
      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
      return /*#__PURE__*/_react$a["default"].cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!(0, _ReactUtils$2.validateWidthHeight)(this)) {
        return null;
      }
      var _this$props7 = this.props,
        width = _this$props7.width,
        height = _this$props7.height,
        className = _this$props7.className,
        style = _this$props7.style,
        children = _this$props7.children,
        others = _objectWithoutProperties$4(_this$props7, _excluded$1);
      var _this$state2 = this.state,
        links = _this$state2.links,
        nodes = _this$state2.nodes;
      var attrs = (0, _ReactUtils$2.filterProps)(others, false);
      return /*#__PURE__*/_react$a["default"].createElement("div", {
        className: (0, _clsx$2["default"])('recharts-wrapper', className),
        style: _objectSpread$8(_objectSpread$8({}, style), {}, {
          position: 'relative',
          cursor: 'default',
          width: width,
          height: height
        }),
        role: "region"
      }, /*#__PURE__*/_react$a["default"].createElement(_Surface$1.Surface, _extends$9({}, attrs, {
        width: width,
        height: height
      }), (0, _ReactUtils$2.filterSvgElements)(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var data = nextProps.data,
        width = nextProps.width,
        height = nextProps.height,
        margin = nextProps.margin,
        iterations = nextProps.iterations,
        nodeWidth = nextProps.nodeWidth,
        nodePadding = nextProps.nodePadding,
        sort = nextProps.sort;
      if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || !(0, _ShallowEqual.shallowEqual)(margin, prevState.prevMargin) || iterations !== prevState.prevIterations || nodeWidth !== prevState.prevNodeWidth || nodePadding !== prevState.prevNodePadding || sort !== prevState.sort) {
        var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
        var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
        var _computeData = computeData({
            data: data,
            width: contentWidth,
            height: contentHeight,
            iterations: iterations,
            nodeWidth: nodeWidth,
            nodePadding: nodePadding,
            sort: sort
          }),
          links = _computeData.links,
          nodes = _computeData.nodes;
        return _objectSpread$8(_objectSpread$8({}, prevState), {}, {
          nodes: nodes,
          links: links,
          prevData: data,
          prevWidth: iterations,
          prevHeight: height,
          prevMargin: margin,
          prevNodePadding: nodePadding,
          prevNodeWidth: nodeWidth,
          prevIterations: iterations,
          prevSort: sort
        });
      }
      return null;
    }
  }, {
    key: "renderLinkItem",
    value: function renderLinkItem(option, props) {
      if ( /*#__PURE__*/_react$a["default"].isValidElement(option)) {
        return /*#__PURE__*/_react$a["default"].cloneElement(option, props);
      }
      if ((0, _isFunction$1["default"])(option)) {
        return option(props);
      }
      var sourceX = props.sourceX,
        sourceY = props.sourceY,
        sourceControlX = props.sourceControlX,
        targetX = props.targetX,
        targetY = props.targetY,
        targetControlX = props.targetControlX,
        linkWidth = props.linkWidth,
        others = _objectWithoutProperties$4(props, _excluded2);
      return /*#__PURE__*/_react$a["default"].createElement("path", _extends$9({
        className: "recharts-sankey-link",
        d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
        fill: "none",
        stroke: "#333",
        strokeWidth: linkWidth,
        strokeOpacity: "0.2"
      }, (0, _ReactUtils$2.filterProps)(others, false)));
    }
  }, {
    key: "renderNodeItem",
    value: function renderNodeItem(option, props) {
      if ( /*#__PURE__*/_react$a["default"].isValidElement(option)) {
        return /*#__PURE__*/_react$a["default"].cloneElement(option, props);
      }
      if ((0, _isFunction$1["default"])(option)) {
        return option(props);
      }
      return /*#__PURE__*/_react$a["default"].createElement(_Rectangle.Rectangle, _extends$9({
        className: "recharts-sankey-node",
        fill: "#0088fe",
        fillOpacity: "0.8"
      }, (0, _ReactUtils$2.filterProps)(props, false), {
        role: "img"
      }));
    }
  }]);
}(_react$a.PureComponent);
_defineProperty$b(Sankey, "displayName", 'Sankey');
_defineProperty$b(Sankey, "defaultProps", {
  nameKey: 'name',
  dataKey: 'value',
  nodePadding: 10,
  nodeWidth: 10,
  linkCurvature: 0.5,
  iterations: 32,
  margin: {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
  },
  sort: true
});

var RadarChart = {};

Object.defineProperty(RadarChart, "__esModule", {
  value: true
});
RadarChart.RadarChart = void 0;
var _generateCategoricalChart$5 = generateCategoricalChart;
var _Radar = Radar$1;
var _PolarAngleAxis$1 = PolarAngleAxis$1;
var _PolarRadiusAxis$1 = PolarRadiusAxis$1;
var _PolarUtils$2 = PolarUtils;
/**
 * @fileOverview Radar Chart
 */

RadarChart.RadarChart = (0, _generateCategoricalChart$5.generateCategoricalChart)({
  chartName: 'RadarChart',
  GraphicalChild: _Radar.Radar,
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: _PolarAngleAxis$1.PolarAngleAxis
  }, {
    axisType: 'radiusAxis',
    AxisComp: _PolarRadiusAxis$1.PolarRadiusAxis
  }],
  formatAxisMap: _PolarUtils$2.formatAxisMap,
  defaultProps: {
    layout: 'centric',
    startAngle: 90,
    endAngle: -270,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  }
});

var ScatterChart = {};

Object.defineProperty(ScatterChart, "__esModule", {
  value: true
});
ScatterChart.ScatterChart = void 0;
var _generateCategoricalChart$4 = generateCategoricalChart;
var _Scatter$1 = Scatter$1;
var _XAxis$2 = XAxis$1;
var _YAxis$2 = YAxis$1;
var _ZAxis$1 = ZAxis$1;
var _CartesianUtils$2 = CartesianUtils;
/**
 * @fileOverview Scatter Chart
 */

ScatterChart.ScatterChart = (0, _generateCategoricalChart$4.generateCategoricalChart)({
  chartName: 'ScatterChart',
  GraphicalChild: _Scatter$1.Scatter,
  defaultTooltipEventType: 'item',
  validateTooltipEventTypes: ['item'],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: _XAxis$2.XAxis
  }, {
    axisType: 'yAxis',
    AxisComp: _YAxis$2.YAxis
  }, {
    axisType: 'zAxis',
    AxisComp: _ZAxis$1.ZAxis
  }],
  formatAxisMap: _CartesianUtils$2.formatAxisMap
});

var AreaChart = {};

Object.defineProperty(AreaChart, "__esModule", {
  value: true
});
AreaChart.AreaChart = void 0;
var _generateCategoricalChart$3 = generateCategoricalChart;
var _Area$1 = Area$1;
var _XAxis$1 = XAxis$1;
var _YAxis$1 = YAxis$1;
var _CartesianUtils$1 = CartesianUtils;
/**
 * @fileOverview Area Chart
 */

AreaChart.AreaChart = (0, _generateCategoricalChart$3.generateCategoricalChart)({
  chartName: 'AreaChart',
  GraphicalChild: _Area$1.Area,
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: _XAxis$1.XAxis
  }, {
    axisType: 'yAxis',
    AxisComp: _YAxis$1.YAxis
  }],
  formatAxisMap: _CartesianUtils$1.formatAxisMap
});

var RadialBarChart = {};

Object.defineProperty(RadialBarChart, "__esModule", {
  value: true
});
RadialBarChart.RadialBarChart = void 0;
var _generateCategoricalChart$2 = generateCategoricalChart;
var _PolarAngleAxis = PolarAngleAxis$1;
var _PolarRadiusAxis = PolarRadiusAxis$1;
var _PolarUtils$1 = PolarUtils;
var _RadialBar = RadialBar$1;
/**
 * @fileOverview Radar Bar Chart
 */

RadialBarChart.RadialBarChart = (0, _generateCategoricalChart$2.generateCategoricalChart)({
  chartName: 'RadialBarChart',
  GraphicalChild: _RadialBar.RadialBar,
  legendContent: 'children',
  defaultTooltipEventType: 'axis',
  validateTooltipEventTypes: ['axis', 'item'],
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: _PolarAngleAxis.PolarAngleAxis
  }, {
    axisType: 'radiusAxis',
    AxisComp: _PolarRadiusAxis.PolarRadiusAxis
  }],
  formatAxisMap: _PolarUtils$1.formatAxisMap,
  defaultProps: {
    layout: 'radial',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  }
});

var ComposedChart = {};

Object.defineProperty(ComposedChart, "__esModule", {
  value: true
});
ComposedChart.ComposedChart = void 0;
var _generateCategoricalChart$1 = generateCategoricalChart;
var _Area = Area$1;
var _Bar = Bar$1;
var _Line = Line$1;
var _Scatter = Scatter$1;
var _XAxis = XAxis$1;
var _YAxis = YAxis$1;
var _ZAxis = ZAxis$1;
var _CartesianUtils = CartesianUtils;
/**
 * @fileOverview Composed Chart
 */

ComposedChart.ComposedChart = (0, _generateCategoricalChart$1.generateCategoricalChart)({
  chartName: 'ComposedChart',
  GraphicalChild: [_Line.Line, _Area.Area, _Bar.Bar, _Scatter.Scatter],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: _XAxis.XAxis
  }, {
    axisType: 'yAxis',
    AxisComp: _YAxis.YAxis
  }, {
    axisType: 'zAxis',
    AxisComp: _ZAxis.ZAxis
  }],
  formatAxisMap: _CartesianUtils.formatAxisMap
});

var SunburstChart = {};

function _typeof$5(o) { "@babel/helpers - typeof"; return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$5(o); }
Object.defineProperty(SunburstChart, "__esModule", {
  value: true
});
SunburstChart.SunburstChart = void 0;
var _react$9 = _interopRequireWildcard$1(React__default$4);
var _d3Scale = d3Scale;
var _clsx$1 = _interopRequireDefault$d(clsx.exports);
var _ReactUtils$1 = ReactUtils;
var _Surface = Surface$1;
var _Layer$1 = Layer;
var _Sector = Sector;
var _Text = Text;
var _PolarUtils = PolarUtils;
var _Tooltip = Tooltip$1;
function _interopRequireDefault$d(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache$1(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache$1 = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard$1(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$5(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache$1(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
function _slicedToArray$7(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$e(arr, i) || _nonIterableRest$5(); }
function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit$5(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$e(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$e(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$e(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$e(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$e(arr); }
function _arrayLikeToArray$e(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var defaultTextProps = {
  fontWeight: 'bold',
  paintOrder: 'stroke fill',
  fontSize: '.75rem',
  stroke: '#FFF',
  fill: 'black',
  pointerEvents: 'none'
};
function getMaxDepthOf(node) {
  if (!node.children || node.children.length === 0) return 1;

  // Calculate depth for each child and find the maximum
  var childDepths = node.children.map(function (d) {
    return getMaxDepthOf(d);
  });
  return 1 + Math.max.apply(Math, _toConsumableArray(childDepths));
}
SunburstChart.SunburstChart = function SunburstChart(_ref) {
  var className = _ref.className,
    data = _ref.data,
    children = _ref.children,
    width = _ref.width,
    height = _ref.height,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 2 : _ref$padding,
    _ref$dataKey = _ref.dataKey,
    dataKey = _ref$dataKey === void 0 ? 'value' : _ref$dataKey,
    _ref$ringPadding = _ref.ringPadding,
    ringPadding = _ref$ringPadding === void 0 ? 2 : _ref$ringPadding,
    _ref$innerRadius = _ref.innerRadius,
    innerRadius = _ref$innerRadius === void 0 ? 50 : _ref$innerRadius,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? '#333' : _ref$fill,
    _ref$stroke = _ref.stroke,
    stroke = _ref$stroke === void 0 ? '#FFF' : _ref$stroke,
    _ref$textOptions = _ref.textOptions,
    textOptions = _ref$textOptions === void 0 ? defaultTextProps : _ref$textOptions,
    _ref$outerRadius = _ref.outerRadius,
    outerRadius = _ref$outerRadius === void 0 ? Math.min(width, height) / 2 : _ref$outerRadius,
    _ref$cx = _ref.cx,
    cx = _ref$cx === void 0 ? width / 2 : _ref$cx,
    _ref$cy = _ref.cy,
    cy = _ref$cy === void 0 ? height / 2 : _ref$cy,
    _ref$startAngle = _ref.startAngle,
    startAngle = _ref$startAngle === void 0 ? 0 : _ref$startAngle,
    _ref$endAngle = _ref.endAngle,
    endAngle = _ref$endAngle === void 0 ? 360 : _ref$endAngle,
    onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave;
  var _useState = (0, _react$9.useState)(false),
    _useState2 = _slicedToArray$7(_useState, 2),
    isTooltipActive = _useState2[0],
    setIsTooltipActive = _useState2[1];
  var _useState3 = (0, _react$9.useState)(null),
    _useState4 = _slicedToArray$7(_useState3, 2),
    activeNode = _useState4[0],
    setActiveNode = _useState4[1];
  var rScale = (0, _d3Scale.scaleLinear)([0, data[dataKey]], [0, endAngle]);
  var treeDepth = getMaxDepthOf(data);
  var thickness = (outerRadius - innerRadius) / treeDepth;
  var sectors = [];
  var positions = new Map([]);

  // event handlers
  function handleMouseEnter(node, e) {
    if (onMouseEnter) onMouseEnter(node, e);
    setActiveNode(node);
    setIsTooltipActive(true);
  }
  function handleMouseLeave(node, e) {
    if (onMouseLeave) onMouseLeave(node, e);
    setActiveNode(null);
    setIsTooltipActive(false);
  }
  function handleClick(node) {
    if (onClick) onClick(node);
  }

  // recursively add nodes for each data point and its children
  function drawArcs(childNodes, options) {
    var radius = options.radius,
      innerR = options.innerR,
      initialAngle = options.initialAngle,
      childColor = options.childColor;
    var currentAngle = initialAngle;
    if (!childNodes) return; // base case: no children of this node

    childNodes.forEach(function (d) {
      var _ref2, _d$fill;
      var arcLength = rScale(d[dataKey]);
      var start = currentAngle;
      // color priority - if there's a color on the individual point use that, otherwise use parent color or default
      var fillColor = (_ref2 = (_d$fill = d === null || d === void 0 ? void 0 : d.fill) !== null && _d$fill !== void 0 ? _d$fill : childColor) !== null && _ref2 !== void 0 ? _ref2 : fill;
      var _polarToCartesian = (0, _PolarUtils.polarToCartesian)(0, 0, innerR + radius / 2, -(start + arcLength - arcLength / 2)),
        textX = _polarToCartesian.x,
        textY = _polarToCartesian.y;
      currentAngle += arcLength;
      sectors.push(
      /*#__PURE__*/
      // TODO: Missing key warning. Can we use `key={d.name}`?
      _react$9["default"].createElement("g", {
        "aria-label": d.name,
        tabIndex: 0
      }, /*#__PURE__*/_react$9["default"].createElement(_Sector.Sector, {
        onClick: function onClick() {
          return handleClick(d);
        },
        onMouseEnter: function onMouseEnter(e) {
          return handleMouseEnter(d, e);
        },
        onMouseLeave: function onMouseLeave(e) {
          return handleMouseLeave(d, e);
        },
        fill: fillColor,
        stroke: stroke,
        strokeWidth: padding,
        startAngle: start,
        endAngle: start + arcLength,
        innerRadius: innerR,
        outerRadius: innerR + radius,
        cx: cx,
        cy: cy
      }), /*#__PURE__*/_react$9["default"].createElement(_Text.Text, _extends$8({}, textOptions, {
        alignmentBaseline: "middle",
        textAnchor: "middle",
        x: textX + cx,
        y: cy - textY
      }), d[dataKey])));
      var _polarToCartesian2 = (0, _PolarUtils.polarToCartesian)(cx, cy, innerR + radius / 2, start),
        tooltipX = _polarToCartesian2.x,
        tooltipY = _polarToCartesian2.y;
      positions.set(d.name, {
        x: tooltipX,
        y: tooltipY
      });
      return drawArcs(d.children, {
        radius: radius,
        innerR: innerR + radius + ringPadding,
        initialAngle: start,
        childColor: fillColor
      });
    });
  }
  drawArcs(data.children, {
    radius: thickness,
    innerR: innerRadius,
    initialAngle: startAngle
  });
  var layerClass = (0, _clsx$1["default"])('recharts-sunburst', className);
  function renderTooltip() {
    var tooltipComponent = (0, _ReactUtils$1.findChildByType)([children], _Tooltip.Tooltip);
    if (!tooltipComponent || !activeNode) return null;
    var viewBox = {
      x: 0,
      y: 0,
      width: width,
      height: height
    };
    return /*#__PURE__*/_react$9["default"].cloneElement(tooltipComponent, {
      viewBox: viewBox,
      coordinate: positions.get(activeNode.name),
      payload: [activeNode],
      active: isTooltipActive
    });
  }
  return /*#__PURE__*/_react$9["default"].createElement("div", {
    className: (0, _clsx$1["default"])('recharts-wrapper', className),
    style: {
      position: 'relative',
      width: width,
      height: height
    },
    role: "region"
  }, /*#__PURE__*/_react$9["default"].createElement(_Surface.Surface, {
    width: width,
    height: height
  }, children, /*#__PURE__*/_react$9["default"].createElement(_Layer$1.Layer, {
    className: layerClass
  }, sectors)), renderTooltip());
};

var Funnel$1 = {};

var FunnelUtils = {};

Object.defineProperty(FunnelUtils, "__esModule", {
  value: true
});
FunnelUtils.FunnelTrapezoid = FunnelTrapezoid;
FunnelUtils.typeGuardTrapezoidProps = typeGuardTrapezoidProps;
var _react$8 = _interopRequireDefault$c(React__default$4);
var _ActiveShapeUtils = ActiveShapeUtils;
function _interopRequireDefault$c(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof$4(o) { "@babel/helpers - typeof"; return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$4(o); }
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) { _defineProperty$a(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty$a(obj, key, value) { key = _toPropertyKey$2(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$2(t) { var i = _toPrimitive$2(t, "string"); return "symbol" == _typeof$4(i) ? i : i + ""; }
function _toPrimitive$2(t, r) { if ("object" != _typeof$4(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$4(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Trapezoid props is expecting x, y, height as numbers.
// When props are being spread in from a user defined component in Funnel,
// the prop types of an SVGElement have these typed as string | number.
// This function will return the passed in props along with x, y, height as numbers.
function typeGuardTrapezoidProps(option, props) {
  var xValue = "".concat(props.x || option.x);
  var x = parseInt(xValue, 10);
  var yValue = "".concat(props.y || option.y);
  var y = parseInt(yValue, 10);
  var heightValue = "".concat((props === null || props === void 0 ? void 0 : props.height) || (option === null || option === void 0 ? void 0 : option.height));
  var height = parseInt(heightValue, 10);
  return _objectSpread$7(_objectSpread$7(_objectSpread$7({}, props), (0, _ActiveShapeUtils.getPropsFromShapeOption)(option)), {}, {
    height: height,
    x: x,
    y: y
  });
}
function FunnelTrapezoid(props) {
  return /*#__PURE__*/_react$8["default"].createElement(_ActiveShapeUtils.Shape, _extends$7({
    shapeType: "trapezoid",
    propTransformer: typeGuardTrapezoidProps
  }, props));
}

Object.defineProperty(Funnel$1, "__esModule", {
  value: true
});
Funnel$1.Funnel = void 0;
var _react$7 = _interopRequireWildcard(React__default$4);
var _reactSmooth = _interopRequireDefault$b(lib);
var _isFunction = _interopRequireDefault$b(isFunction_1);
var _isNumber = _interopRequireDefault$b(isNumber_1);
var _isString$3 = _interopRequireDefault$b(isString_1);
var _omit = _interopRequireDefault$b(omit_1);
var _isEqual = _interopRequireDefault$b(isEqual_1);
var _clsx = _interopRequireDefault$b(clsx.exports);
var _Layer = Layer;
var _LabelList = LabelList$1;
var _Cell = Cell$2;
var _ReactUtils = ReactUtils;
var _Global = Global$1;
var _DataUtils = DataUtils;
var _ChartUtils = ChartUtils;
var _types = types;
var _FunnelUtils = FunnelUtils;
var _Funnel$1;
function _interopRequireDefault$b(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof$3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray$6(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$d(arr, i) || _nonIterableRest$4(); }
function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$d(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$d(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$d(o, minLen); }
function _arrayLikeToArray$d(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit$4(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }
function _typeof$3(o) { "@babel/helpers - typeof"; return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof$3(o); }
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) { _defineProperty$9(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties$9(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor); } }
function _createClass$f(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$9(Constructor.prototype, protoProps); if (staticProps) _defineProperties$9(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf$1(o), _possibleConstructorReturn$7(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf$1(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn$7(self, call) { if (call && (_typeof$3(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized$1(self); }
function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf$1(o) { _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf$1(o); }
function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf$1(subClass, superClass); }
function _setPrototypeOf$1(o, p) { _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf$1(o, p); }
function _defineProperty$9(obj, key, value) { key = _toPropertyKey$1(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey$1(t) { var i = _toPrimitive$1(t, "string"); return "symbol" == _typeof$3(i) ? i : i + ""; }
function _toPrimitive$1(t, r) { if ("object" != _typeof$3(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof$3(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @fileOverview Render sectors of a funnel
 */
var Funnel = Funnel$1.Funnel = /*#__PURE__*/function (_PureComponent) {
  function Funnel() {
    var _this;
    _classCallCheck$f(this, Funnel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Funnel, [].concat(args));
    _defineProperty$9(_this, "state", {
      isAnimationFinished: false
    });
    _defineProperty$9(_this, "handleAnimationEnd", function () {
      var onAnimationEnd = _this.props.onAnimationEnd;
      _this.setState({
        isAnimationFinished: true
      });
      if ((0, _isFunction["default"])(onAnimationEnd)) {
        onAnimationEnd();
      }
    });
    _defineProperty$9(_this, "handleAnimationStart", function () {
      var onAnimationStart = _this.props.onAnimationStart;
      _this.setState({
        isAnimationFinished: false
      });
      if ((0, _isFunction["default"])(onAnimationStart)) {
        onAnimationStart();
      }
    });
    return _this;
  }
  _inherits$7(Funnel, _PureComponent);
  return _createClass$f(Funnel, [{
    key: "isActiveIndex",
    value: function isActiveIndex(i) {
      var activeIndex = this.props.activeIndex;
      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i) !== -1;
      }
      return i === activeIndex;
    }
  }, {
    key: "renderTrapezoidsStatically",
    value: function renderTrapezoidsStatically(trapezoids) {
      var _this2 = this;
      var _this$props = this.props,
        shape = _this$props.shape,
        activeShape = _this$props.activeShape;
      return trapezoids.map(function (entry, i) {
        var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : shape;
        var trapezoidProps = _objectSpread$6(_objectSpread$6({}, entry), {}, {
          isActive: _this2.isActiveIndex(i),
          stroke: entry.stroke
        });
        return /*#__PURE__*/_react$7["default"].createElement(_Layer.Layer, _extends$6({
          className: "recharts-funnel-trapezoid"
        }, (0, _types.adaptEventsOfChild)(_this2.props, entry, i), {
          key: "trapezoid-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.name, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value),
          role: "img"
        }), /*#__PURE__*/_react$7["default"].createElement(_FunnelUtils.FunnelTrapezoid, _extends$6({
          option: trapezoidOptions
        }, trapezoidProps)));
      });
    }
  }, {
    key: "renderTrapezoidsWithAnimation",
    value: function renderTrapezoidsWithAnimation() {
      var _this3 = this;
      var _this$props2 = this.props,
        trapezoids = _this$props2.trapezoids,
        isAnimationActive = _this$props2.isAnimationActive,
        animationBegin = _this$props2.animationBegin,
        animationDuration = _this$props2.animationDuration,
        animationEasing = _this$props2.animationEasing,
        animationId = _this$props2.animationId;
      var prevTrapezoids = this.state.prevTrapezoids;
      return /*#__PURE__*/_react$7["default"].createElement(_reactSmooth["default"], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "funnel-".concat(animationId),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref) {
        var t = _ref.t;
        var stepData = trapezoids.map(function (entry, index) {
          var prev = prevTrapezoids && prevTrapezoids[index];
          if (prev) {
            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
            var _interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(prev.upperWidth, entry.upperWidth);
            var _interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(prev.lowerWidth, entry.lowerWidth);
            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
            return _objectSpread$6(_objectSpread$6({}, entry), {}, {
              x: _interpolatorX(t),
              y: _interpolatorY(t),
              upperWidth: _interpolatorUpperWidth(t),
              lowerWidth: _interpolatorLowerWidth(t),
              height: _interpolatorHeight(t)
            });
          }
          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.x + entry.upperWidth / 2, entry.x);
          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.y + entry.height / 2, entry.y);
          var interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(0, entry.upperWidth);
          var interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(0, entry.lowerWidth);
          var interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
          return _objectSpread$6(_objectSpread$6({}, entry), {}, {
            x: interpolatorX(t),
            y: interpolatorY(t),
            upperWidth: interpolatorUpperWidth(t),
            lowerWidth: interpolatorLowerWidth(t),
            height: interpolatorHeight(t)
          });
        });
        return /*#__PURE__*/_react$7["default"].createElement(_Layer.Layer, null, _this3.renderTrapezoidsStatically(stepData));
      });
    }
  }, {
    key: "renderTrapezoids",
    value: function renderTrapezoids() {
      var _this$props3 = this.props,
        trapezoids = _this$props3.trapezoids,
        isAnimationActive = _this$props3.isAnimationActive;
      var prevTrapezoids = this.state.prevTrapezoids;
      if (isAnimationActive && trapezoids && trapezoids.length && (!prevTrapezoids || !(0, _isEqual["default"])(prevTrapezoids, trapezoids))) {
        return this.renderTrapezoidsWithAnimation();
      }
      return this.renderTrapezoidsStatically(trapezoids);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        hide = _this$props4.hide,
        trapezoids = _this$props4.trapezoids,
        className = _this$props4.className,
        isAnimationActive = _this$props4.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;
      if (hide || !trapezoids || !trapezoids.length) {
        return null;
      }
      var layerClass = (0, _clsx["default"])('recharts-trapezoids', className);
      return /*#__PURE__*/_react$7["default"].createElement(_Layer.Layer, {
        className: layerClass
      }, this.renderTrapezoids(), (!isAnimationActive || isAnimationFinished) && _LabelList.LabelList.renderCallByParent(this.props, trapezoids));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curTrapezoids: nextProps.trapezoids,
          prevTrapezoids: prevState.curTrapezoids
        };
      }
      if (nextProps.trapezoids !== prevState.curTrapezoids) {
        return {
          curTrapezoids: nextProps.trapezoids
        };
      }
      return null;
    }
  }]);
}(_react$7.PureComponent);
_Funnel$1 = Funnel;
_defineProperty$9(Funnel, "displayName", 'Funnel');
_defineProperty$9(Funnel, "defaultProps", {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  labelLine: true,
  hide: false,
  isAnimationActive: !_Global.Global.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease',
  nameKey: 'name',
  lastShapeType: 'triangle'
});
_defineProperty$9(Funnel, "getRealFunnelData", function (item) {
  var _item$props = item.props,
    data = _item$props.data,
    children = _item$props.children;
  var presentationProps = (0, _ReactUtils.filterProps)(item.props, false);
  var cells = (0, _ReactUtils.findAllByType)(children, _Cell.Cell);
  if (data && data.length) {
    return data.map(function (entry, index) {
      return _objectSpread$6(_objectSpread$6(_objectSpread$6({
        payload: entry
      }, presentationProps), entry), cells && cells[index] && cells[index].props);
    });
  }
  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _objectSpread$6(_objectSpread$6({}, presentationProps), cell.props);
    });
  }
  return [];
});
_defineProperty$9(Funnel, "getRealWidthHeight", function (item, offset) {
  var customWidth = item.props.width;
  var width = offset.width,
    height = offset.height,
    left = offset.left,
    right = offset.right,
    top = offset.top,
    bottom = offset.bottom;
  var realHeight = height;
  var realWidth = width;
  if ((0, _isNumber["default"])(customWidth)) {
    realWidth = customWidth;
  } else if ((0, _isString$3["default"])(customWidth)) {
    realWidth = realWidth * parseFloat(customWidth) / 100;
  }
  return {
    realWidth: realWidth - left - right - 50,
    realHeight: realHeight - bottom - top,
    offsetX: (width - realWidth) / 2,
    offsetY: (height - realHeight) / 2
  };
});
_defineProperty$9(Funnel, "getComposedData", function (_ref2) {
  var item = _ref2.item,
    offset = _ref2.offset;
  var funnelData = _Funnel$1.getRealFunnelData(item);
  var _item$props2 = item.props,
    dataKey = _item$props2.dataKey,
    nameKey = _item$props2.nameKey,
    tooltipType = _item$props2.tooltipType,
    lastShapeType = _item$props2.lastShapeType,
    reversed = _item$props2.reversed;
  var left = offset.left,
    top = offset.top;
  var _Funnel$getRealWidthH = _Funnel$1.getRealWidthHeight(item, offset),
    realHeight = _Funnel$getRealWidthH.realHeight,
    realWidth = _Funnel$getRealWidthH.realWidth,
    offsetX = _Funnel$getRealWidthH.offsetX,
    offsetY = _Funnel$getRealWidthH.offsetY;
  var maxValue = Math.max.apply(null, funnelData.map(function (entry) {
    return (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
  }));
  var len = funnelData.length;
  var rowHeight = realHeight / len;
  var parentViewBox = {
    x: offset.left,
    y: offset.top,
    width: offset.width,
    height: offset.height
  };
  var trapezoids = funnelData.map(function (entry, i) {
    var rawVal = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
    var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
    var val = rawVal;
    var nextVal;
    if (i !== len - 1) {
      nextVal = (0, _ChartUtils.getValueByDataKey)(funnelData[i + 1], dataKey, 0);
      if (nextVal instanceof Array) {
        var _nextVal = nextVal;
        var _nextVal2 = _slicedToArray$6(_nextVal, 1);
        nextVal = _nextVal2[0];
      }
    } else if (rawVal instanceof Array && rawVal.length === 2) {
      var _rawVal = _slicedToArray$6(rawVal, 2);
      val = _rawVal[0];
      nextVal = _rawVal[1];
    } else if (lastShapeType === 'rectangle') {
      nextVal = val;
    } else {
      nextVal = 0;
    }
    var x = (maxValue - val) * realWidth / (2 * maxValue) + top + 25 + offsetX;
    var y = rowHeight * i + left + offsetY;
    var upperWidth = val / maxValue * realWidth;
    var lowerWidth = nextVal / maxValue * realWidth;
    var tooltipPayload = [{
      name: name,
      value: val,
      payload: entry,
      dataKey: dataKey,
      type: tooltipType
    }];
    var tooltipPosition = {
      x: x + upperWidth / 2,
      y: y + rowHeight / 2
    };
    return _objectSpread$6(_objectSpread$6({
      x: x,
      y: y,
      width: Math.max(upperWidth, lowerWidth),
      upperWidth: upperWidth,
      lowerWidth: lowerWidth,
      height: rowHeight,
      name: name,
      val: val,
      tooltipPayload: tooltipPayload,
      tooltipPosition: tooltipPosition
    }, (0, _omit["default"])(entry, 'width')), {}, {
      payload: entry,
      parentViewBox: parentViewBox,
      labelViewBox: {
        x: x + (upperWidth - lowerWidth) / 4,
        y: y,
        width: Math.abs(upperWidth - lowerWidth) / 2 + Math.min(upperWidth, lowerWidth),
        height: rowHeight
      }
    });
  });
  if (reversed) {
    trapezoids = trapezoids.map(function (entry, index) {
      var newY = entry.y - index * rowHeight + (len - 1 - index) * rowHeight;
      return _objectSpread$6(_objectSpread$6({}, entry), {}, {
        upperWidth: entry.lowerWidth,
        lowerWidth: entry.upperWidth,
        x: entry.x - (entry.lowerWidth - entry.upperWidth) / 2,
        y: entry.y - index * rowHeight + (len - 1 - index) * rowHeight,
        tooltipPosition: _objectSpread$6(_objectSpread$6({}, entry.tooltipPosition), {}, {
          y: newY + rowHeight / 2
        }),
        labelViewBox: _objectSpread$6(_objectSpread$6({}, entry.labelViewBox), {}, {
          y: newY
        })
      });
    });
  }
  return {
    trapezoids: trapezoids,
    data: funnelData
  };
});

var FunnelChart = {};

Object.defineProperty(FunnelChart, "__esModule", {
  value: true
});
FunnelChart.FunnelChart = void 0;
var _generateCategoricalChart = generateCategoricalChart;
var _Funnel = Funnel$1;
/**
 * @fileOverview Funnel Chart
 */

FunnelChart.FunnelChart = (0, _generateCategoricalChart.generateCategoricalChart)({
  chartName: 'FunnelChart',
  GraphicalChild: _Funnel.Funnel,
  validateTooltipEventTypes: ['item'],
  defaultTooltipEventType: 'item',
  axisComponents: [],
  defaultProps: {
    layout: 'centric'
  }
});

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Area", {
  enumerable: true,
  get: function get() {
    return _Area.Area;
  }
});
Object.defineProperty(exports, "AreaChart", {
  enumerable: true,
  get: function get() {
    return _AreaChart.AreaChart;
  }
});
Object.defineProperty(exports, "Bar", {
  enumerable: true,
  get: function get() {
    return _Bar.Bar;
  }
});
Object.defineProperty(exports, "BarChart", {
  enumerable: true,
  get: function get() {
    return _BarChart.BarChart;
  }
});
Object.defineProperty(exports, "Brush", {
  enumerable: true,
  get: function get() {
    return _Brush.Brush;
  }
});
Object.defineProperty(exports, "CartesianAxis", {
  enumerable: true,
  get: function get() {
    return _CartesianAxis.CartesianAxis;
  }
});
Object.defineProperty(exports, "CartesianGrid", {
  enumerable: true,
  get: function get() {
    return _CartesianGrid.CartesianGrid;
  }
});
Object.defineProperty(exports, "Cell", {
  enumerable: true,
  get: function get() {
    return _Cell.Cell;
  }
});
Object.defineProperty(exports, "ComposedChart", {
  enumerable: true,
  get: function get() {
    return _ComposedChart.ComposedChart;
  }
});
Object.defineProperty(exports, "Cross", {
  enumerable: true,
  get: function get() {
    return _Cross.Cross;
  }
});
Object.defineProperty(exports, "Curve", {
  enumerable: true,
  get: function get() {
    return _Curve.Curve;
  }
});
Object.defineProperty(exports, "Customized", {
  enumerable: true,
  get: function get() {
    return _Customized.Customized;
  }
});
Object.defineProperty(exports, "DefaultLegendContent", {
  enumerable: true,
  get: function get() {
    return _DefaultLegendContent.DefaultLegendContent;
  }
});
Object.defineProperty(exports, "DefaultTooltipContent", {
  enumerable: true,
  get: function get() {
    return _DefaultTooltipContent.DefaultTooltipContent;
  }
});
Object.defineProperty(exports, "Dot", {
  enumerable: true,
  get: function get() {
    return _Dot.Dot;
  }
});
Object.defineProperty(exports, "ErrorBar", {
  enumerable: true,
  get: function get() {
    return _ErrorBar.ErrorBar;
  }
});
Object.defineProperty(exports, "Funnel", {
  enumerable: true,
  get: function get() {
    return _Funnel.Funnel;
  }
});
Object.defineProperty(exports, "FunnelChart", {
  enumerable: true,
  get: function get() {
    return _FunnelChart.FunnelChart;
  }
});
Object.defineProperty(exports, "Global", {
  enumerable: true,
  get: function get() {
    return _Global.Global;
  }
});
Object.defineProperty(exports, "Label", {
  enumerable: true,
  get: function get() {
    return _Label.Label;
  }
});
Object.defineProperty(exports, "LabelList", {
  enumerable: true,
  get: function get() {
    return _LabelList.LabelList;
  }
});
Object.defineProperty(exports, "Layer", {
  enumerable: true,
  get: function get() {
    return _Layer.Layer;
  }
});
Object.defineProperty(exports, "Legend", {
  enumerable: true,
  get: function get() {
    return _Legend.Legend;
  }
});
Object.defineProperty(exports, "Line", {
  enumerable: true,
  get: function get() {
    return _Line.Line;
  }
});
Object.defineProperty(exports, "LineChart", {
  enumerable: true,
  get: function get() {
    return _LineChart.LineChart;
  }
});
Object.defineProperty(exports, "Pie", {
  enumerable: true,
  get: function get() {
    return _Pie.Pie;
  }
});
Object.defineProperty(exports, "PieChart", {
  enumerable: true,
  get: function get() {
    return _PieChart.PieChart;
  }
});
Object.defineProperty(exports, "PolarAngleAxis", {
  enumerable: true,
  get: function get() {
    return _PolarAngleAxis.PolarAngleAxis;
  }
});
Object.defineProperty(exports, "PolarGrid", {
  enumerable: true,
  get: function get() {
    return _PolarGrid.PolarGrid;
  }
});
Object.defineProperty(exports, "PolarRadiusAxis", {
  enumerable: true,
  get: function get() {
    return _PolarRadiusAxis.PolarRadiusAxis;
  }
});
Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _Polygon.Polygon;
  }
});
Object.defineProperty(exports, "Radar", {
  enumerable: true,
  get: function get() {
    return _Radar.Radar;
  }
});
Object.defineProperty(exports, "RadarChart", {
  enumerable: true,
  get: function get() {
    return _RadarChart.RadarChart;
  }
});
Object.defineProperty(exports, "RadialBar", {
  enumerable: true,
  get: function get() {
    return _RadialBar.RadialBar;
  }
});
Object.defineProperty(exports, "RadialBarChart", {
  enumerable: true,
  get: function get() {
    return _RadialBarChart.RadialBarChart;
  }
});
Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _Rectangle.Rectangle;
  }
});
Object.defineProperty(exports, "ReferenceArea", {
  enumerable: true,
  get: function get() {
    return _ReferenceArea.ReferenceArea;
  }
});
Object.defineProperty(exports, "ReferenceDot", {
  enumerable: true,
  get: function get() {
    return _ReferenceDot.ReferenceDot;
  }
});
Object.defineProperty(exports, "ReferenceLine", {
  enumerable: true,
  get: function get() {
    return _ReferenceLine.ReferenceLine;
  }
});
Object.defineProperty(exports, "ResponsiveContainer", {
  enumerable: true,
  get: function get() {
    return _ResponsiveContainer.ResponsiveContainer;
  }
});
Object.defineProperty(exports, "Sankey", {
  enumerable: true,
  get: function get() {
    return _Sankey.Sankey;
  }
});
Object.defineProperty(exports, "Scatter", {
  enumerable: true,
  get: function get() {
    return _Scatter.Scatter;
  }
});
Object.defineProperty(exports, "ScatterChart", {
  enumerable: true,
  get: function get() {
    return _ScatterChart.ScatterChart;
  }
});
Object.defineProperty(exports, "Sector", {
  enumerable: true,
  get: function get() {
    return _Sector.Sector;
  }
});
Object.defineProperty(exports, "SunburstChart", {
  enumerable: true,
  get: function get() {
    return _SunburstChart.SunburstChart;
  }
});
Object.defineProperty(exports, "Surface", {
  enumerable: true,
  get: function get() {
    return _Surface.Surface;
  }
});
Object.defineProperty(exports, "Symbols", {
  enumerable: true,
  get: function get() {
    return _Symbols.Symbols;
  }
});
Object.defineProperty(exports, "Text", {
  enumerable: true,
  get: function get() {
    return _Text.Text;
  }
});
Object.defineProperty(exports, "Tooltip", {
  enumerable: true,
  get: function get() {
    return _Tooltip.Tooltip;
  }
});
Object.defineProperty(exports, "Trapezoid", {
  enumerable: true,
  get: function get() {
    return _Trapezoid.Trapezoid;
  }
});
Object.defineProperty(exports, "Treemap", {
  enumerable: true,
  get: function get() {
    return _Treemap.Treemap;
  }
});
Object.defineProperty(exports, "XAxis", {
  enumerable: true,
  get: function get() {
    return _XAxis.XAxis;
  }
});
Object.defineProperty(exports, "YAxis", {
  enumerable: true,
  get: function get() {
    return _YAxis.YAxis;
  }
});
Object.defineProperty(exports, "ZAxis", {
  enumerable: true,
  get: function get() {
    return _ZAxis.ZAxis;
  }
});
var _Surface = Surface$1;
var _Layer = Layer;
var _Legend = Legend$1;
var _DefaultLegendContent = DefaultLegendContent$1;
var _Tooltip = Tooltip$1;
var _DefaultTooltipContent = DefaultTooltipContent;
var _ResponsiveContainer = ResponsiveContainer;
var _Cell = Cell$2;
var _Text = Text;
var _Label = Label$1;
var _LabelList = LabelList$1;
var _Customized = Customized$1;
var _Sector = Sector;
var _Curve = Curve;
var _Rectangle = Rectangle;
var _Polygon = Polygon;
var _Dot = Dot;
var _Cross = Cross;
var _Symbols = Symbols$1;
var _PolarGrid = PolarGrid$1;
var _PolarRadiusAxis = PolarRadiusAxis$1;
var _PolarAngleAxis = PolarAngleAxis$1;
var _Pie = Pie$1;
var _Radar = Radar$1;
var _RadialBar = RadialBar$1;
var _Brush = Brush$1;
var _ReferenceLine = ReferenceLine$1;
var _ReferenceDot = ReferenceDot$1;
var _ReferenceArea = ReferenceArea$1;
var _CartesianAxis = CartesianAxis$1;
var _CartesianGrid = CartesianGrid$1;
var _Line = Line$1;
var _Area = Area$1;
var _Bar = Bar$1;
var _Scatter = Scatter$1;
var _XAxis = XAxis$1;
var _YAxis = YAxis$1;
var _ZAxis = ZAxis$1;
var _ErrorBar = ErrorBar$1;
var _LineChart = LineChart;
var _BarChart = BarChart;
var _PieChart = PieChart;
var _Treemap = Treemap$1;
var _Sankey = Sankey$1;
var _RadarChart = RadarChart;
var _ScatterChart = ScatterChart;
var _AreaChart = AreaChart;
var _RadialBarChart = RadialBarChart;
var _ComposedChart = ComposedChart;
var _SunburstChart = SunburstChart;
var _Funnel = Funnel$1;
var _FunnelChart = FunnelChart;
var _Trapezoid = Trapezoid;
var _Global = Global$1;
}(lib$2));

var css_248z$1c = "@keyframes ChartAnimations-module_chartPulse__PjGT1 {\n  0%, 100% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n.ChartAnimations-module_loadingPulse__qE88p {\n  animation: ChartAnimations-module_chartPulse__PjGT1 1.5s ease-in-out infinite;\n}";
var styles$f = {"loadingPulse":"ChartAnimations-module_loadingPulse__qE88p","chartPulse":"ChartAnimations-module_chartPulse__PjGT1"};
styleInject(css_248z$1c);

// Placeholder data for loading state
const LOADING_DATA$2 = [
    { name: 'Loading 1', value: 35, color: '#e0e0e0' },
    { name: 'Loading 2', value: 25, color: '#d0d0d0' },
    { name: 'Loading 3', value: 20, color: '#c0c0c0' },
    { name: 'Loading 4', value: 20, color: '#b0b0b0' }
];
// Empty state styles
const emptyContainerStyle$2 = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#999',
    textAlign: 'center',
    padding: '20px'
};
const emptyIconStyle$2 = {
    fontSize: '48px',
    marginBottom: '12px',
    opacity: 0.5
};
const emptyTextStyle$2 = {
    fontSize: '14px',
    fontWeight: 500
};
const DEFAULT_COLORS = [
    '#00c04b', '#1fd655', '#00ab41', '#008631', '#9eed98',
    '#8884d8', '#82ca9d', '#ffc658', '#ff8042', '#a4de6c'
];
/**
 * DonutChart component - a reusable recharts-based donut chart
 * with customizable styling and data display options.
 */
const DonutChart = ({ data, variant = 'donut', width = "100%", height = 320, innerRadius = 40, outerRadius = 100, showLabels = true, showLegend = true, legendPosition = 'left', showTooltip = true, enableAnimation = false, paddingAngle = 0, loading = false, emptyMessage = "No data available", ariaLabel = "Donut chart", onSegmentClick }) => {
    // For pie variant, inner radius is 0 (full circle)
    const effectiveInnerRadius = variant === 'pie' ? 0 : innerRadius;
    // Check for empty state (not loading and no data)
    const isEmpty = !loading && (!data || data.length === 0);
    // Use loading data when loading, otherwise use provided data
    const displayData = loading ? LOADING_DATA$2 : data;
    // Ensure each data point has a color
    const chartData = displayData.map((item, index) => (Object.assign(Object.assign({}, item), { color: item.color || DEFAULT_COLORS[index % DEFAULT_COLORS.length] })));
    // Determine legend layout based on position
    const isVerticalLegend = legendPosition === 'left' || legendPosition === 'right';
    const legendLayout = isVerticalLegend ? 'vertical' : 'horizontal';
    const legendAlign = legendPosition === 'left' ? 'left' : legendPosition === 'right' ? 'right' : 'center';
    const legendVerticalAlign = legendPosition === 'top' ? 'top' : legendPosition === 'bottom' ? 'bottom' : 'middle';
    // Adjust chart center based on legend position
    const cx = isVerticalLegend ? (legendPosition === 'left' ? '60%' : '40%') : '50%';
    const cy = showLegend && !isVerticalLegend ? (legendPosition === 'top' ? '55%' : '45%') : '50%';
    // Render empty state
    if (isEmpty) {
        return (React__default$4.createElement("div", { style: Object.assign(Object.assign({}, emptyContainerStyle$2), { width, height: height }) },
            React__default$4.createElement("div", { style: emptyIconStyle$2 }, "\u25CB"),
            React__default$4.createElement("div", { style: emptyTextStyle$2 }, emptyMessage)));
    }
    // Generate accessible description from data
    const accessibleDescription = loading
        ? "Loading chart data"
        : `${ariaLabel} showing ${chartData.map(d => `${d.name}: ${d.value}`).join(', ')}`;
    return (React__default$4.createElement("div", { className: loading ? styles$f.loadingPulse : undefined, role: "img", "aria-label": accessibleDescription },
        React__default$4.createElement(lib$2.ResponsiveContainer, { width: width, height: height },
            React__default$4.createElement(lib$2.PieChart, null,
                React__default$4.createElement(lib$2.Pie, { data: chartData, cx: cx, cy: cy, innerRadius: effectiveInnerRadius, outerRadius: outerRadius, dataKey: "value", label: loading ? false : showLabels, isAnimationActive: enableAnimation, paddingAngle: paddingAngle, onClick: !loading && onSegmentClick ? (_data, index) => onSegmentClick(chartData[index], index) : undefined, style: !loading && onSegmentClick ? { cursor: 'pointer' } : undefined }, chartData.map((entry, index) => (React__default$4.createElement(lib$2.Cell, { key: `cell-${index}`, fill: entry.color })))),
                !loading && showTooltip && React__default$4.createElement(lib$2.Tooltip, null),
                !loading && showLegend && (React__default$4.createElement(lib$2.Legend, { layout: legendLayout, align: legendAlign, verticalAlign: legendVerticalAlign }))))));
};

const DEFAULT_BAR_COLOR = '#00c04b';
// Placeholder data for loading state
const LOADING_DATA$1 = [
    { name: 'Loading...', value: 80, color: '#e0e0e0' },
    { name: 'Loading...', value: 65, color: '#d0d0d0' },
    { name: 'Loading...', value: 50, color: '#c0c0c0' },
    { name: 'Loading...', value: 35, color: '#b0b0b0' },
    { name: 'Loading...', value: 20, color: '#a0a0a0' }
];
// Empty state styles
const emptyContainerStyle$1 = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#999',
    textAlign: 'center',
    padding: '20px'
};
const emptyIconStyle$1 = {
    fontSize: '48px',
    marginBottom: '12px',
    opacity: 0.5
};
const emptyTextStyle$1 = {
    fontSize: '14px',
    fontWeight: 500
};
/**
 * HorizontalBarChart component - a reusable recharts-based horizontal bar chart
 * with customizable styling and data display options.
 */
const HorizontalBarChart = ({ data, width = "99%", height = 400, barColor = DEFAULT_BAR_COLOR, showGrid = true, showTooltip = true, enableAnimation = false, maxItems, margin = { top: 20, right: 30, left: 20, bottom: 20 }, loading = false, emptyMessage = "No data available", ariaLabel = "Horizontal bar chart", onBarClick }) => {
    // Check for empty state (not loading and no data)
    const isEmpty = !loading && (!data || data.length === 0);
    // Use loading data when loading, otherwise use provided data
    const displayData = loading ? LOADING_DATA$1 : data;
    // Limit items if maxItems is specified
    const chartData = maxItems ? displayData.slice(0, maxItems) : displayData;
    // Render empty state
    if (isEmpty) {
        return (React__default$4.createElement("div", { style: Object.assign(Object.assign({}, emptyContainerStyle$1), { width, height: height }) },
            React__default$4.createElement("div", { style: emptyIconStyle$1 }, "\u2630"),
            React__default$4.createElement("div", { style: emptyTextStyle$1 }, emptyMessage)));
    }
    // Generate accessible description from data
    const accessibleDescription = loading
        ? "Loading chart data"
        : `${ariaLabel} showing ${chartData.map(d => `${d.name}: ${d.value}`).join(', ')}`;
    return (React__default$4.createElement("div", { className: loading ? styles$f.loadingPulse : undefined, role: "img", "aria-label": accessibleDescription },
        React__default$4.createElement(lib$2.ResponsiveContainer, { width: width, height: height },
            React__default$4.createElement(lib$2.BarChart, { data: chartData, layout: "vertical", margin: margin },
                showGrid && React__default$4.createElement(lib$2.CartesianGrid, { strokeDasharray: "3 3", stroke: loading ? '#f0f0f0' : undefined }),
                React__default$4.createElement(lib$2.XAxis, { type: "number", tick: loading ? { fill: '#d0d0d0' } : undefined }),
                React__default$4.createElement(lib$2.YAxis, { dataKey: "name", type: "category", width: 120, tick: loading ? { fill: '#d0d0d0' } : undefined, interval: 0 }),
                !loading && showTooltip && React__default$4.createElement(lib$2.Tooltip, null),
                React__default$4.createElement(lib$2.Bar, { dataKey: "value", isAnimationActive: enableAnimation, onClick: !loading && onBarClick ? (_data, index) => onBarClick(chartData[index], index) : undefined, style: !loading && onBarClick ? { cursor: 'pointer' } : undefined }, chartData.map((entry, index) => (React__default$4.createElement(lib$2.Cell, { key: `cell-${index}`, fill: entry.color || barColor }))))))));
};

const DEFAULT_PRIMARY_COLOR = '#2196f3';
const DEFAULT_SECONDARY_COLOR = '#bdbdbd';
// Placeholder data for loading state
const LOADING_DATA = [
    { name: 'Mon', primaryValue: 80, secondaryValue: 40 },
    { name: 'Tue', primaryValue: 70, secondaryValue: 35 },
    { name: 'Wed', primaryValue: 60, secondaryValue: 30 },
    { name: 'Thu', primaryValue: 55, secondaryValue: 28 },
    { name: 'Fri', primaryValue: 50, secondaryValue: 25 },
    { name: 'Sat', primaryValue: 30, secondaryValue: 45 },
    { name: 'Sun', primaryValue: 25, secondaryValue: 50 }
];
// Empty state styles
const emptyContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#999',
    textAlign: 'center',
    padding: '20px'
};
const emptyIconStyle = {
    fontSize: '48px',
    marginBottom: '12px',
    opacity: 0.5
};
const emptyTextStyle = {
    fontSize: '14px',
    fontWeight: 500
};
const summaryTextStyle = {
    fontSize: '12px',
    color: '#666',
    backgroundColor: '#f5f5f5',
    padding: '4px 8px',
    borderRadius: '4px',
    display: 'inline-block',
    marginBottom: '8px'
};
const CustomTooltip = ({ active, payload, label, primaryLabel, secondaryLabel }) => {
    if (!active || !payload || payload.length === 0) {
        return null;
    }
    const typedPayload = payload;
    const total = typedPayload.reduce((sum, entry) => sum + (entry.value || 0), 0);
    return (React__default$4.createElement("div", { style: {
            backgroundColor: 'white',
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        } },
        React__default$4.createElement("p", { style: { margin: '0 0 8px 0', fontWeight: 'bold' } }, label),
        typedPayload.map((entry, index) => (React__default$4.createElement("p", { key: index, style: { margin: '4px 0', color: entry.color } },
            entry.dataKey === 'primaryValue' ? primaryLabel : secondaryLabel,
            ": ",
            entry.value))),
        React__default$4.createElement("p", { style: { margin: '8px 0 0 0', borderTop: '1px solid #eee', paddingTop: '8px', fontWeight: 'bold' } },
            "Total: ",
            total)));
};
/**
 * StackedBarChart component - a reusable recharts-based stacked bar chart
 * for displaying data with two categories per bar (e.g., business hours vs non-business hours).
 */
const StackedBarChart = ({ data, primaryLabel = 'Primary', secondaryLabel = 'Secondary', primaryColor = DEFAULT_PRIMARY_COLOR, secondaryColor = DEFAULT_SECONDARY_COLOR, width = "99%", height = 400, showGrid = true, showTooltip = true, showLegend = true, enableAnimation = false, margin = { top: 20, right: 30, left: 20, bottom: 60 }, loading = false, emptyMessage = "No data available", ariaLabel = "Stacked bar chart", summaryText, onBarClick }) => {
    // Check for empty state (not loading and no data)
    const isEmpty = !loading && (!data || data.length === 0);
    // Use loading data when loading, otherwise use provided data
    const displayData = loading ? LOADING_DATA : data;
    // Add totals to data
    const chartData = useMemo(() => displayData.map(item => {
        var _a;
        return (Object.assign(Object.assign({}, item), { total: (_a = item.total) !== null && _a !== void 0 ? _a : (item.primaryValue + item.secondaryValue) }));
    }), [displayData]);
    // Generate accessible description from data (memoized for performance)
    // Must be before early return to satisfy React hooks rules
    const accessibleDescription = useMemo(() => loading
        ? "Loading chart data"
        : `${ariaLabel} showing ${chartData.map(d => `${d.name}: ${d.primaryValue} ${primaryLabel}, ${d.secondaryValue} ${secondaryLabel}`).join('; ')}`, [loading, ariaLabel, chartData, primaryLabel, secondaryLabel]);
    // Render empty state
    if (isEmpty) {
        return (React__default$4.createElement("div", { style: Object.assign(Object.assign({}, emptyContainerStyle), { width, height: height }) },
            React__default$4.createElement("div", { style: emptyIconStyle }, "|||"),
            React__default$4.createElement("div", { style: emptyTextStyle }, emptyMessage)));
    }
    // Custom legend formatter
    const legendFormatter = (value) => {
        if (value === 'primaryValue')
            return primaryLabel;
        if (value === 'secondaryValue')
            return secondaryLabel;
        return value;
    };
    return (React__default$4.createElement("div", { className: loading ? styles$f.loadingPulse : undefined, role: "img", "aria-label": accessibleDescription },
        summaryText && !loading && (React__default$4.createElement("div", { style: { textAlign: 'left', marginBottom: '4px' } },
            React__default$4.createElement("span", { style: summaryTextStyle }, summaryText))),
        React__default$4.createElement(lib$2.ResponsiveContainer, { width: width, height: height },
            React__default$4.createElement(lib$2.BarChart, { data: chartData, margin: margin },
                showGrid && React__default$4.createElement(lib$2.CartesianGrid, { strokeDasharray: "3 3", stroke: loading ? '#f0f0f0' : undefined }),
                React__default$4.createElement(lib$2.XAxis, { dataKey: "name", tick: loading ? { fill: '#d0d0d0' } : undefined, interval: 0, height: 60, angle: loading ? 0 : -45, textAnchor: loading ? 'middle' : 'end', fontSize: 12 }),
                React__default$4.createElement(lib$2.YAxis, { tick: loading ? { fill: '#d0d0d0' } : undefined }),
                !loading && showTooltip && (React__default$4.createElement(lib$2.Tooltip, { content: React__default$4.createElement(CustomTooltip, { primaryLabel: primaryLabel, secondaryLabel: secondaryLabel }) })),
                !loading && showLegend && (React__default$4.createElement(lib$2.Legend, { formatter: legendFormatter, wrapperStyle: { paddingTop: '20px' } })),
                React__default$4.createElement(lib$2.Bar, { dataKey: "primaryValue", stackId: "stack", fill: loading ? '#e0e0e0' : primaryColor, isAnimationActive: enableAnimation, onClick: !loading && onBarClick ? (_data, index) => onBarClick(chartData[index], index, 'primary') : undefined, style: !loading && onBarClick ? { cursor: 'pointer' } : undefined }),
                React__default$4.createElement(lib$2.Bar, { dataKey: "secondaryValue", stackId: "stack", fill: loading ? '#d0d0d0' : secondaryColor, isAnimationActive: enableAnimation, onClick: !loading && onBarClick ? (_data, index) => onBarClick(chartData[index], index, 'secondary') : undefined, style: !loading && onBarClick ? { cursor: 'pointer' } : undefined })))));
};

var css_248z$1b = ".WordCloud-module_wordCloudContainer__0Q7-3 {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 8px;\n}\n\n.WordCloud-module_wordCloudTerm__R3bwc {\n  position: absolute;\n  padding: 0;\n  font-weight: 600;\n  cursor: default;\n  transition: transform 0.15s ease, text-shadow 0.15s ease;\n  user-select: none;\n  white-space: nowrap;\n  line-height: 1.1;\n}\n.WordCloud-module_wordCloudTerm__R3bwc:hover {\n  transform: scale(1.1);\n  z-index: 10;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.WordCloud-module_emptyState__-glag {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f9f9f9;\n  border: 1px dashed #ddd;\n  border-radius: 8px;\n}\n\n.WordCloud-module_emptyStateContent__Rf761 {\n  text-align: center;\n  color: #666;\n}\n.WordCloud-module_emptyStateContent__Rf761 p {\n  margin: 8px 0 0;\n  font-size: 14px;\n}\n\n.WordCloud-module_emptyStateIcon__UqIEl {\n  font-size: 32px;\n  display: block;\n}";
var styles$e = {"wordCloudContainer":"WordCloud-module_wordCloudContainer__0Q7-3","wordCloudTerm":"WordCloud-module_wordCloudTerm__R3bwc","emptyState":"WordCloud-module_emptyState__-glag","emptyStateContent":"WordCloud-module_emptyStateContent__Rf761","emptyStateIcon":"WordCloud-module_emptyStateIcon__UqIEl"};
styleInject(css_248z$1b);

/**
 * Sanitizes text content to prevent XSS attacks.
 * Escapes HTML special characters.
 */
const sanitizeText = (text) => {
    if (typeof text !== 'string') {
        return '';
    }
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;');
};
const COLORS = ['#00c04b', '#1fd655', '#00ab41', '#008631', '#8884d8', '#82ca9d', '#ffc658', '#ff7c43'];
/**
 * Check if two bounding boxes overlap
 * Using 1px padding like d3-cloud for tight packing
 */
const boxesOverlap = (a, b, padding = 1) => {
    return !(a.x + a.width + padding < b.x ||
        b.x + b.width + padding < a.x ||
        a.y + a.height + padding < b.y ||
        b.y + b.height + padding < a.y);
};
/**
 * Check if a box is within container bounds
 */
const isWithinBounds = (box, containerWidth, containerHeight, margin = 2) => {
    return (box.x >= margin &&
        box.y >= margin &&
        box.x + box.width <= containerWidth - margin &&
        box.y + box.height <= containerHeight - margin);
};
// Text estimation constants
// Average character width as a ratio of font size for sans-serif fonts.
// Based on typical character metrics where most characters are ~55% as wide as they are tall.
const AVG_CHAR_WIDTH_RATIO = 0.55;
// Line height multiplier for single-line text. Uses 1.1 (110%) for tight vertical spacing.
const LINE_HEIGHT_RATIO = 1.1;
/**
 * Estimate text dimensions based on font size and character count
 * This is an approximation - actual rendering may vary slightly
 */
const estimateTextSize = (text, fontSize) => {
    const width = text.length * fontSize * AVG_CHAR_WIDTH_RATIO;
    const height = fontSize * LINE_HEIGHT_RATIO;
    return { width, height };
};
// Spiral placement constants based on d3-cloud algorithm
// Controls the tightness of the spiral - smaller values create tighter spirals.
// Value of 0.1 provides good balance between packing density and performance.
const SPIRAL_SCALE_FACTOR = 0.1;
/**
 * Archimedean spiral generator for word placement
 * Based on d3-cloud's approach with aspect ratio compensation
 * Returns positions moving outward from center
 */
function* spiralPositions(centerX, centerY, containerWidth, containerHeight, maxRadius) {
    // Start at center
    yield { x: centerX, y: centerY };
    // Aspect ratio compensation (like d3-cloud)
    const aspectRatio = containerWidth / containerHeight;
    let t = 0;
    const dt = 1; // Increment per iteration
    while (true) {
        t += dt;
        const scaledT = t * SPIRAL_SCALE_FACTOR;
        const radius = scaledT;
        if (radius > maxRadius)
            break;
        // Apply aspect ratio to x coordinate for even distribution
        const x = centerX + aspectRatio * radius * Math.cos(scaledT);
        const y = centerY + radius * Math.sin(scaledT);
        yield { x, y };
    }
}
/**
 * Try to place a word using spiral placement algorithm
 */
const placeWord = (text, fontSize, placedWords, containerWidth, containerHeight, color, count, score) => {
    const { width, height } = estimateTextSize(text, fontSize);
    const centerX = containerWidth / 2;
    const centerY = containerHeight / 2;
    const maxRadius = Math.max(containerWidth, containerHeight);
    // Try positions along the spiral
    for (const pos of spiralPositions(centerX, centerY, containerWidth, containerHeight, maxRadius)) {
        // Center the word on the position
        const box = {
            x: pos.x - width / 2,
            y: pos.y - height / 2,
            width,
            height
        };
        // Check if within bounds
        if (!isWithinBounds(box, containerWidth, containerHeight)) {
            continue;
        }
        // Check for collisions with already placed words
        let hasCollision = false;
        for (const placed of placedWords) {
            if (boxesOverlap(box, placed)) {
                hasCollision = true;
                break;
            }
        }
        if (!hasCollision) {
            return {
                term: text,
                count,
                score,
                fontSize,
                x: box.x,
                y: box.y,
                width,
                height,
                color
            };
        }
    }
    return null; // Couldn't place word
};
/**
 * WordCloud component that displays terms in a tightly-packed cloud layout
 * using spiral placement algorithm. Larger words are placed in the center.
 */
const WordCloud = ({ terms, maxTerms = 20, minFontSize = 12, maxFontSize = 48, width = "100%", height = 300 }) => {
    const containerRef = useRef(null);
    // Default container size used before ResizeObserver measures actual dimensions.
    // 400x300 provides reasonable initial layout for typical dashboard placements.
    const [containerSize, setContainerSize] = useState({ width: 400, height: 300 });
    const [placedWords, setPlacedWords] = useState([]);
    // Sort by score/count (largest first) and limit
    const sortedTerms = useMemo(() => [...terms]
        .sort((a, b) => (b.score || b.count) - (a.score || a.count))
        .slice(0, maxTerms), [terms, maxTerms]);
    // Calculate font sizes for each term
    const termsWithSizes = useMemo(() => {
        if (sortedTerms.length === 0)
            return [];
        const scores = sortedTerms.map(t => t.score || t.count);
        const minScore = Math.min(...scores);
        const maxScore = Math.max(...scores);
        const scoreRange = maxScore - minScore || 1;
        return sortedTerms.map((term, index) => {
            const normalizedScore = ((term.score || term.count) - minScore) / scoreRange;
            // Use square root (0.5 exponent) scaling to make size differences more pronounced
            // while keeping the visual hierarchy readable. Linear scaling would make
            // medium-frequency terms too similar to low-frequency ones.
            const scaledScore = Math.pow(normalizedScore, 0.5);
            const fontSize = Math.round(minFontSize + (scaledScore * (maxFontSize - minFontSize)));
            return Object.assign(Object.assign({}, term), { fontSize, color: COLORS[index % COLORS.length] });
        });
    }, [sortedTerms, minFontSize, maxFontSize]);
    // Measure container size
    useEffect(() => {
        const updateSize = () => {
            if (containerRef.current) {
                const rect = containerRef.current.getBoundingClientRect();
                const numericHeight = typeof height === 'number' ? height : parseInt(String(height), 10) || 300;
                setContainerSize({
                    width: rect.width || 400,
                    height: numericHeight
                });
            }
        };
        updateSize();
        // Use ResizeObserver if available
        if (typeof ResizeObserver !== 'undefined' && containerRef.current) {
            const observer = new ResizeObserver(updateSize);
            observer.observe(containerRef.current);
            return () => observer.disconnect();
        }
        // Fallback to window resize
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, [height]);
    // Calculate word placements when size or terms change
    useEffect(() => {
        // Minimum container width of 100px ensures there's enough space for
        // meaningful word placement. Below this, words would overlap significantly.
        if (termsWithSizes.length === 0 || containerSize.width < 100) {
            setPlacedWords([]);
            return;
        }
        const placed = [];
        // Place words in order (largest first, so they go in center)
        for (const term of termsWithSizes) {
            const placedWord = placeWord(term.term, term.fontSize, placed, containerSize.width, containerSize.height, term.color, term.count, term.score);
            if (placedWord) {
                placed.push(placedWord);
            }
        }
        setPlacedWords(placed);
    }, [termsWithSizes, containerSize]);
    if (sortedTerms.length === 0) {
        return (React__default$4.createElement("div", { className: styles$e.emptyState, style: { width, height } },
            React__default$4.createElement("div", { className: styles$e.emptyStateContent },
                React__default$4.createElement("span", { className: styles$e.emptyStateIcon }, "\u2601\uFE0F"),
                React__default$4.createElement("p", null, "No data available"))));
    }
    return (React__default$4.createElement("div", { ref: containerRef, className: styles$e.wordCloudContainer, style: { width, height } }, placedWords.map((word, index) => {
        const sanitizedTerm = sanitizeText(word.term);
        return (React__default$4.createElement("span", { key: `${word.term}-${index}`, className: styles$e.wordCloudTerm, style: {
                fontSize: `${word.fontSize}px`,
                left: `${word.x}px`,
                top: `${word.y}px`,
                color: word.color
            }, title: `${sanitizedTerm}: ${word.count} occurrences${word.score ? ` (score: ${word.score.toFixed(2)})` : ''}` }, sanitizedTerm));
    })));
};

/**
 * Sparkline component - a minimal inline chart for showing trends
 * in condensed spaces with minimal labeling.
 */
const Sparkline = ({ data, width = 120, height = 32, color = '#00c04b', showArea = false, areaOpacity = 0.1, showAverage = false, showTooltip = true, showDots = false, strokeWidth = 2, enableAnimation = false }) => {
    if (!data || data.length === 0) {
        return (React__default$4.createElement("div", { style: { width, height, backgroundColor: '#f5f5f5', borderRadius: 4 } }));
    }
    // Calculate average for reference line
    const average = data.reduce((sum, d) => sum + d.value, 0) / data.length;
    // Get min/max for proper scaling
    const values = data.map(d => d.value);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const padding = (max - min) * 0.1 || 1;
    return (React__default$4.createElement(lib$2.ResponsiveContainer, { width: width, height: height },
        React__default$4.createElement(lib$2.LineChart, { data: data, margin: { top: 2, right: 2, bottom: 2, left: 2 } },
            React__default$4.createElement(lib$2.YAxis, { domain: [min - padding, max + padding], hide: true }),
            showAverage && (React__default$4.createElement(lib$2.ReferenceLine, { y: average, stroke: "#999", strokeDasharray: "3 3", strokeWidth: 1 })),
            showTooltip && (React__default$4.createElement(lib$2.Tooltip, { content: (props) => {
                    var _a;
                    const { active, payload } = props;
                    if (active && payload && payload.length && ((_a = payload[0]) === null || _a === void 0 ? void 0 : _a.payload)) {
                        const dataPoint = payload[0].payload;
                        return (React__default$4.createElement("div", { style: {
                                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: 4,
                                fontSize: 12
                            } },
                            dataPoint.label && React__default$4.createElement("div", null, dataPoint.label),
                            React__default$4.createElement("div", { style: { fontWeight: 600 } }, dataPoint.value)));
                    }
                    return null;
                } })),
            React__default$4.createElement(lib$2.Line, { type: "monotone", dataKey: "value", stroke: color, strokeWidth: strokeWidth, dot: showDots, fill: showArea ? color : 'none', fillOpacity: showArea ? areaOpacity : 0, isAnimationActive: enableAnimation }))));
};

var dist$4 = {};

var dateFns = {};

var add$1 = {};

var addDays$1 = {};

var toDate$1 = {};

toDate$1.toDate = toDate;

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === "object" && argStr === "[object Date]")
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
  } else if (
    typeof argument === "number" ||
    argStr === "[object Number]" ||
    typeof argument === "string" ||
    argStr === "[object String]"
  ) {
    // TODO: Can we get rid of as?
    return new Date(argument);
  } else {
    // TODO: Can we get rid of as?
    return new Date(NaN);
  }
}

var constructFrom$1 = {};

constructFrom$1.constructFrom = constructFrom;

/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */
function constructFrom(date, value) {
  if (date instanceof Date) {
    return new date.constructor(value);
  } else {
    return new Date(value);
  }
}

addDays$1.addDays = addDays;
var _index$9H = toDate$1;
var _index2$4p = constructFrom$1;

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(date, amount) {
  const _date = (0, _index$9H.toDate)(date);
  if (isNaN(amount)) return (0, _index2$4p.constructFrom)(date, NaN);
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}

var addMonths$1 = {};

addMonths$1.addMonths = addMonths;
var _index$9G = toDate$1;
var _index2$4o = constructFrom$1;

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */
function addMonths(date, amount) {
  const _date = (0, _index$9G.toDate)(date);
  if (isNaN(amount)) return (0, _index2$4o.constructFrom)(date, NaN);
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
  }
  const dayOfMonth = _date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  const endOfDesiredMonth = (0, _index2$4o.constructFrom)(date, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth,
    );
    return _date;
  }
}

add$1.add = add;
var _index$9F = addDays$1;
var _index2$4n = addMonths$1;
var _index3$2h = constructFrom$1;
var _index4$1M = toDate$1;

/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,\\-7
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add(date, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = duration;

  // Add years and months
  const _date = (0, _index4$1M.toDate)(date);
  const dateWithMonths =
    months || years
      ? (0, _index2$4n.addMonths)(_date, months + years * 12)
      : _date;

  // Add weeks and days
  const dateWithDays =
    days || weeks
      ? (0, _index$9F.addDays)(dateWithMonths, days + weeks * 7)
      : dateWithMonths;

  // Add days, hours, minutes and seconds
  const minutesToAdd = minutes + hours * 60;
  const secondsToAdd = seconds + minutesToAdd * 60;
  const msToAdd = secondsToAdd * 1000;
  const finalDate = (0, _index3$2h.constructFrom)(
    date,
    dateWithDays.getTime() + msToAdd,
  );

  return finalDate;
}

var addBusinessDays$1 = {};

var isSaturday$1 = {};

isSaturday$1.isSaturday = isSaturday;
var _index$9E = toDate$1;

/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday(date) {
  return (0, _index$9E.toDate)(date).getDay() === 6;
}

var isSunday$1 = {};

isSunday$1.isSunday = isSunday;
var _index$9D = toDate$1;

/**
 * @name isSunday
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * const result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday(date) {
  return (0, _index$9D.toDate)(date).getDay() === 0;
}

var isWeekend$1 = {};

isWeekend$1.isWeekend = isWeekend;
var _index$9C = toDate$1;

/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * const result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend(date) {
  const day = (0, _index$9C.toDate)(date).getDay();
  return day === 0 || day === 6;
}

addBusinessDays$1.addBusinessDays = addBusinessDays;
var _index$9B = constructFrom$1;
var _index2$4m = isSaturday$1;
var _index3$2g = isSunday$1;
var _index4$1L = isWeekend$1;
var _index5$1D = toDate$1;

/**
 * @name addBusinessDays
 * @category Date Extension Helpers
 * @summary Add the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be added.
 *
 * @returns The new date with the business days added
 *
 * @example
 * // Add 10 business days to 1 September 2014:
 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
 */
function addBusinessDays(date, amount) {
  const _date = (0, _index5$1D.toDate)(date);
  const startedOnWeekend = (0, _index4$1L.isWeekend)(_date);

  if (isNaN(amount)) return (0, _index$9B.constructFrom)(date, NaN);

  const hours = _date.getHours();
  const sign = amount < 0 ? -1 : 1;
  const fullWeeks = Math.trunc(amount / 5);

  _date.setDate(_date.getDate() + fullWeeks * 7);

  // Get remaining days not part of a full week
  let restDays = Math.abs(amount % 5);

  // Loops over remaining days
  while (restDays > 0) {
    _date.setDate(_date.getDate() + sign);
    if (!(0, _index4$1L.isWeekend)(_date)) restDays -= 1;
  }

  // If the date is a weekend day and we reduce a dividable of
  // 5 from it, we land on a weekend date.
  // To counter this, we add days accordingly to land on the next business day
  if (startedOnWeekend && (0, _index4$1L.isWeekend)(_date) && amount !== 0) {
    // If we're reducing days, we want to add days until we land on a weekday
    // If we're adding days we want to reduce days until we land on a weekday
    if ((0, _index2$4m.isSaturday)(_date))
      _date.setDate(_date.getDate() + (sign < 0 ? 2 : -1));
    if ((0, _index3$2g.isSunday)(_date))
      _date.setDate(_date.getDate() + (sign < 0 ? 1 : -2));
  }

  // Restore hours to avoid DST lag
  _date.setHours(hours);

  return _date;
}

var addHours$1 = {};

var addMilliseconds$1 = {};

addMilliseconds$1.addMilliseconds = addMilliseconds;
var _index$9A = toDate$1;
var _index2$4l = constructFrom$1;

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be added.
 *
 * @returns The new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(date, amount) {
  const timestamp = +(0, _index$9A.toDate)(date);
  return (0, _index2$4l.constructFrom)(date, timestamp + amount);
}

var constants$1 = {};

constants$1.secondsInYear =
  constants$1.secondsInWeek =
  constants$1.secondsInQuarter =
  constants$1.secondsInMonth =
  constants$1.secondsInMinute =
  constants$1.secondsInHour =
  constants$1.secondsInDay =
  constants$1.quartersInYear =
  constants$1.monthsInYear =
  constants$1.monthsInQuarter =
  constants$1.minutesInYear =
  constants$1.minutesInMonth =
  constants$1.minutesInHour =
  constants$1.minutesInDay =
  constants$1.minTime =
  constants$1.millisecondsInWeek =
  constants$1.millisecondsInSecond =
  constants$1.millisecondsInMinute =
  constants$1.millisecondsInHour =
  constants$1.millisecondsInDay =
  constants$1.maxTime =
  constants$1.daysInYear =
  constants$1.daysInWeek =
    void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */

/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */
(constants$1.daysInWeek = 7);

/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */
const daysInYear = (constants$1.daysInYear = 365.2425);

/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */
const maxTime = (constants$1.maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000);

/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */
(constants$1.minTime = -maxTime);

/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */
(constants$1.millisecondsInWeek = 604800000);

/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */
(constants$1.millisecondsInDay = 86400000);

/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */
(constants$1.millisecondsInMinute = 60000);

/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */
(constants$1.millisecondsInHour = 3600000);

/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */
(constants$1.millisecondsInSecond = 1000);

/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */
(constants$1.minutesInYear = 525600);

/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */
(constants$1.minutesInMonth = 43200);

/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */
(constants$1.minutesInDay = 1440);

/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */
(constants$1.minutesInHour = 60);

/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */
(constants$1.monthsInQuarter = 3);

/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */
(constants$1.monthsInYear = 12);

/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */
(constants$1.quartersInYear = 4);

/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */
const secondsInHour = (constants$1.secondsInHour = 3600);

/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */
(constants$1.secondsInMinute = 60);

/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */
const secondsInDay = (constants$1.secondsInDay = secondsInHour * 24);

/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */
(constants$1.secondsInWeek = secondsInDay * 7);

/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */
const secondsInYear = (constants$1.secondsInYear = secondsInDay * daysInYear);

/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */
const secondsInMonth = (constants$1.secondsInMonth = secondsInYear / 12);

/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */
(constants$1.secondsInQuarter = secondsInMonth * 3);

addHours$1.addHours = addHours;
var _index$9z = addMilliseconds$1;
var _index2$4k = constants$1;

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be added.
 *
 * @returns The new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours(date, amount) {
  return (0, _index$9z.addMilliseconds)(date, amount * _index2$4k.millisecondsInHour);
}

var addISOWeekYears$1 = {};

var getISOWeekYear$1 = {};

var startOfISOWeek$1 = {};

var startOfWeek$1 = {};

var defaultOptions$1 = {};

defaultOptions$1.getDefaultOptions = getDefaultOptions$2;
defaultOptions$1.setDefaultOptions = setDefaultOptions$2;

let defaultOptions = {};

function getDefaultOptions$2() {
  return defaultOptions;
}

function setDefaultOptions$2(newOptions) {
  defaultOptions = newOptions;
}

startOfWeek$1.startOfWeek = startOfWeek;
var _index$9y = toDate$1;

var _index2$4j = defaultOptions$1;

/**
 * The {@link startOfWeek} function options.
 */

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(date, options) {
  const defaultOptions = (0, _index2$4j.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index$9y.toDate)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;

  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

startOfISOWeek$1.startOfISOWeek = startOfISOWeek;
var _index$9x = startOfWeek$1;

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(date) {
  return (0, _index$9x.startOfWeek)(date, { weekStartsOn: 1 });
}

getISOWeekYear$1.getISOWeekYear = getISOWeekYear;
var _index$9w = constructFrom$1;
var _index2$4i = startOfISOWeek$1;
var _index3$2f = toDate$1;

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(date) {
  const _date = (0, _index3$2f.toDate)(date);
  const year = _date.getFullYear();

  const fourthOfJanuaryOfNextYear = (0, _index$9w.constructFrom)(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = (0, _index2$4i.startOfISOWeek)(
    fourthOfJanuaryOfNextYear,
  );

  const fourthOfJanuaryOfThisYear = (0, _index$9w.constructFrom)(date, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = (0, _index2$4i.startOfISOWeek)(
    fourthOfJanuaryOfThisYear,
  );

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

var setISOWeekYear$1 = {};

var differenceInCalendarDays$1 = {};

var startOfDay$1 = {};

startOfDay$1.startOfDay = startOfDay;
var _index$9v = toDate$1;

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(date) {
  const _date = (0, _index$9v.toDate)(date);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

var getTimezoneOffsetInMilliseconds$1 = {};

getTimezoneOffsetInMilliseconds$1.getTimezoneOffsetInMilliseconds = getTimezoneOffsetInMilliseconds;
var _index$9u = toDate$1;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  const _date = (0, _index$9u.toDate)(date);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds(),
    ),
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date - +utcDate;
}

differenceInCalendarDays$1.differenceInCalendarDays = differenceInCalendarDays;
var _index$9t = constants$1;
var _index2$4h = startOfDay$1;
var _index3$2e = getTimezoneOffsetInMilliseconds$1;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = (0, _index2$4h.startOfDay)(dateLeft);
  const startOfDayRight = (0, _index2$4h.startOfDay)(dateRight);

  const timestampLeft =
    +startOfDayLeft -
    (0, _index3$2e.getTimezoneOffsetInMilliseconds)(startOfDayLeft);
  const timestampRight =
    +startOfDayRight -
    (0, _index3$2e.getTimezoneOffsetInMilliseconds)(startOfDayRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a day is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(
    (timestampLeft - timestampRight) / _index$9t.millisecondsInDay,
  );
}

var startOfISOWeekYear$1 = {};

startOfISOWeekYear$1.startOfISOWeekYear = startOfISOWeekYear;
var _index$9s = getISOWeekYear$1;
var _index2$4g = startOfISOWeek$1;
var _index3$2d = constructFrom$1;

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(date) {
  const year = (0, _index$9s.getISOWeekYear)(date);
  const fourthOfJanuary = (0, _index3$2d.constructFrom)(date, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return (0, _index2$4g.startOfISOWeek)(fourthOfJanuary);
}

setISOWeekYear$1.setISOWeekYear = setISOWeekYear;
var _index$9r = constructFrom$1;
var _index2$4f = differenceInCalendarDays$1;
var _index3$2c = startOfISOWeekYear$1;
var _index4$1K = toDate$1;

/**
 * @name setISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The ISO week-numbering year of the new date
 *
 * @returns The new date with the ISO week-numbering year set
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOWeekYear(date, weekYear) {
  let _date = (0, _index4$1K.toDate)(date);
  const diff = (0, _index2$4f.differenceInCalendarDays)(
    _date,
    (0, _index3$2c.startOfISOWeekYear)(_date),
  );
  const fourthOfJanuary = (0, _index$9r.constructFrom)(date, 0);
  fourthOfJanuary.setFullYear(weekYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  _date = (0, _index3$2c.startOfISOWeekYear)(fourthOfJanuary);
  _date.setDate(_date.getDate() + diff);
  return _date;
}

addISOWeekYears$1.addISOWeekYears = addISOWeekYears;
var _index$9q = getISOWeekYear$1;
var _index2$4e = setISOWeekYear$1;

/**
 * @name addISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be added.
 *
 * @returns The new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jn 26 2015 00:00:00
 */
function addISOWeekYears(date, amount) {
  return (0, _index2$4e.setISOWeekYear)(
    date,
    (0, _index$9q.getISOWeekYear)(date) + amount,
  );
}

var addMinutes$1 = {};

addMinutes$1.addMinutes = addMinutes;
var _index$9p = addMilliseconds$1;
var _index2$4d = constants$1;

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(date, amount) {
  return (0, _index$9p.addMilliseconds)(
    date,
    amount * _index2$4d.millisecondsInMinute,
  );
}

var addQuarters$1 = {};

addQuarters$1.addQuarters = addQuarters;
var _index$9o = addMonths$1;

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be added.
 *
 * @returns The new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters(date, amount) {
  const months = amount * 3;
  return (0, _index$9o.addMonths)(date, months);
}

var addSeconds$1 = {};

addSeconds$1.addSeconds = addSeconds;
var _index$9n = addMilliseconds$1;

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be added.
 *
 * @returns The new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds(date, amount) {
  return (0, _index$9n.addMilliseconds)(date, amount * 1000);
}

var addWeeks$1 = {};

addWeeks$1.addWeeks = addWeeks;
var _index$9m = addDays$1;

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be added.
 *
 * @returns The new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(date, amount) {
  const days = amount * 7;
  return (0, _index$9m.addDays)(date, days);
}

var addYears$1 = {};

addYears$1.addYears = addYears;
var _index$9l = addMonths$1;

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(date, amount) {
  return (0, _index$9l.addMonths)(date, amount * 12);
}

var areIntervalsOverlapping$1 = {};

areIntervalsOverlapping$1.areIntervalsOverlapping = areIntervalsOverlapping;
var _index$9k = toDate$1;

/**
 * The {@link areIntervalsOverlapping} function options.
 */

/**
 * @name areIntervalsOverlapping
 * @category Interval Helpers
 * @summary Is the given time interval overlapping with another time interval?
 *
 * @description
 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping unless `inclusive` is set to `true`.
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 * @param options - The object with options
 *
 * @returns Whether the time intervals are overlapping
 *
 * @example
 * // For overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> false
 *
 * @example
 * // For adjacent time intervals:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
 * )
 * //=> false
 *
 * @example
 * // Using the inclusive option:
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
 * )
 * //=> false
 *
 * @example
 * areIntervalsOverlapping(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
 *   { inclusive: true }
 * )
 * //=> true
 */
function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
  const [leftStartTime, leftEndTime] = [
    +(0, _index$9k.toDate)(intervalLeft.start),
    +(0, _index$9k.toDate)(intervalLeft.end),
  ].sort((a, b) => a - b);
  const [rightStartTime, rightEndTime] = [
    +(0, _index$9k.toDate)(intervalRight.start),
    +(0, _index$9k.toDate)(intervalRight.end),
  ].sort((a, b) => a - b);

  if (options?.inclusive)
    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;

  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

var clamp$1 = {};

var max$1 = {};

max$1.max = max;
var _index$9j = toDate$1;

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max(dates) {
  let result;
  dates.forEach(function (dirtyDate) {
    const currentDate = (0, _index$9j.toDate)(dirtyDate);

    if (
      result === undefined ||
      result < currentDate ||
      isNaN(Number(currentDate))
    ) {
      result = currentDate;
    }
  });

  return result || new Date(NaN);
}

var min$1 = {};

min$1.min = min;
var _index$9i = toDate$1;

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dates - The dates to compare
 *
 * @returns The earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min(dates) {
  let result;

  dates.forEach((dirtyDate) => {
    const date = (0, _index$9i.toDate)(dirtyDate);
    if (!result || result > date || isNaN(+date)) {
      result = date;
    }
  });

  return result || new Date(NaN);
}

clamp$1.clamp = clamp;
var _index$9h = max$1;
var _index2$4c = min$1;

/**
 * @name clamp
 * @category Interval Helpers
 * @summary Return a date bounded by the start and the end of the given interval
 *
 * @description
 * Clamps a date to the lower bound with the start of the interval and the upper
 * bound with the end of the interval.
 *
 * - When the date is less than the start of the interval, the start is returned.
 * - When the date is greater than the end of the interval, the end is returned.
 * - Otherwise the date is returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be bounded
 * @param interval - The interval to bound to
 *
 * @returns The date bounded by the start and the end of the interval
 *
 * @example
 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
 * const result = clamp(new Date(2021, 2, 21), {
 *   start: new Date(2021, 2, 22),
 *   end: new Date(2021, 3, 1),
 * })
 * //=> Mon Mar 22 2021 00:00:00
 */
function clamp(date, interval) {
  return (0, _index2$4c.min)([
    (0, _index$9h.max)([date, interval.start]),
    interval.end,
  ]);
}

var closestIndexTo$1 = {};

closestIndexTo$1.closestIndexTo = closestIndexTo;
var _index$9g = toDate$1;

/**
 * @name closestIndexTo
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns An index of the date closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * const dateToCompare = new Date(2015, 8, 6)
 * const datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * const result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo(dateToCompare, dates) {
  const date = (0, _index$9g.toDate)(dateToCompare);

  if (isNaN(Number(date))) return NaN;

  const timeToCompare = date.getTime();

  let result;
  let minDistance;
  dates.forEach(function (dirtyDate, index) {
    const currentDate = (0, _index$9g.toDate)(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = NaN;
      minDistance = NaN;
      return;
    }

    const distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < minDistance) {
      result = index;
      minDistance = distance;
    }
  });

  return result;
}

var closestTo$1 = {};

closestTo$1.closestTo = closestTo;
var _index$9f = constructFrom$1;
var _index2$4b = toDate$1;

/**
 * @name closestTo
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateToCompare - The date to compare with
 * @param dates - The array to search
 *
 * @returns The date from the array closest to the given date or undefined if no valid value is given
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * const dateToCompare = new Date(2015, 8, 6)
 * const result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo(dateToCompare, dates) {
  const date = (0, _index2$4b.toDate)(dateToCompare);

  if (isNaN(Number(date))) return (0, _index$9f.constructFrom)(dateToCompare, NaN);

  const timeToCompare = date.getTime();

  let result;
  let minDistance;
  dates.forEach((dirtyDate) => {
    const currentDate = (0, _index2$4b.toDate)(dirtyDate);

    if (isNaN(Number(currentDate))) {
      result = (0, _index$9f.constructFrom)(dateToCompare, NaN);
      minDistance = NaN;
      return;
    }

    const distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < minDistance) {
      result = currentDate;
      minDistance = distance;
    }
  });

  return result;
}

var compareAsc$1 = {};

compareAsc$1.compareAsc = compareAsc;
var _index$9e = toDate$1;

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc(dateLeft, dateRight) {
  const _dateLeft = (0, _index$9e.toDate)(dateLeft);
  const _dateRight = (0, _index$9e.toDate)(dateRight);

  const diff = _dateLeft.getTime() - _dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

var compareDesc$1 = {};

compareDesc$1.compareDesc = compareDesc;
var _index$9d = toDate$1;

/**
 * @name compareDesc
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc(dateLeft, dateRight) {
  const _dateLeft = (0, _index$9d.toDate)(dateLeft);
  const _dateRight = (0, _index$9d.toDate)(dateRight);

  const diff = _dateLeft.getTime() - _dateRight.getTime();

  if (diff > 0) {
    return -1;
  } else if (diff < 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

var constructNow$1 = {};

constructNow$1.constructNow = constructNow;
var _index$9c = constructFrom$1;

/**
 * @name constructNow
 * @category Generic Helpers
 * @summary Constructs a new current date using the passed value constructor.
 * @pure false
 *
 * @description
 * The function constructs a new current date using the constructor from
 * the reference date. It helps to build generic functions that accept date
 * extensions and use the current date.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 *
 * @returns Current date initialized using the given date constructor
 *
 * @example
 * import { constructNow, isSameDay } from 'date-fns'
 *
 * function isToday<DateType extends Date>(
 *   date: DateType | number | string,
 * ): boolean {
 *   // If we were to use `new Date()` directly, the function would  behave
 *   // differently in different timezones and return false for the same date.
 *   return isSameDay(date, constructNow(date));
 * }
 */
function constructNow(date) {
  return (0, _index$9c.constructFrom)(date, Date.now());
}

var daysToWeeks$1 = {};

daysToWeeks$1.daysToWeeks = daysToWeeks;
var _index$9b = constants$1;

/**
 * @name daysToWeeks
 * @category Conversion Helpers
 * @summary Convert days to weeks.
 *
 * @description
 * Convert a number of days to a full number of weeks.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param days - The number of days to be converted
 *
 * @returns The number of days converted in weeks
 *
 * @example
 * // Convert 14 days to weeks:
 * const result = daysToWeeks(14)
 * //=> 2
 *
 * @example
 * // It uses trunc rounding:
 * const result = daysToWeeks(13)
 * //=> 1
 */
function daysToWeeks(days) {
  const weeks = days / _index$9b.daysInWeek;
  const result = Math.trunc(weeks);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

var differenceInBusinessDays$1 = {};

var isSameDay$1 = {};

isSameDay$1.isSameDay = isSameDay;
var _index$9a = startOfDay$1;

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same day (and year and month)
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dateLeft, dateRight) {
  const dateLeftStartOfDay = (0, _index$9a.startOfDay)(dateLeft);
  const dateRightStartOfDay = (0, _index$9a.startOfDay)(dateRight);

  return +dateLeftStartOfDay === +dateRightStartOfDay;
}

var isValid$1 = {};

var isDate$1 = {};

isDate$1.isDate = isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  return (
    value instanceof Date ||
    (typeof value === "object" &&
      Object.prototype.toString.call(value) === "[object Date]")
  );
}

isValid$1.isValid = isValid;
var _index$99 = isDate$1;
var _index2$4a = toDate$1;

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(date) {
  if (!(0, _index$99.isDate)(date) && typeof date !== "number") {
    return false;
  }
  const _date = (0, _index2$4a.toDate)(date);
  return !isNaN(Number(_date));
}

differenceInBusinessDays$1.differenceInBusinessDays = differenceInBusinessDays;
var _index$98 = addDays$1;
var _index2$49 = differenceInCalendarDays$1;
var _index3$2b = isSameDay$1;
var _index4$1J = isValid$1;
var _index5$1C = isWeekend$1;
var _index6$5 = toDate$1;

/**
 * @name differenceInBusinessDays
 * @category Day Helpers
 * @summary Get the number of business days between the given dates.
 *
 * @description
 * Get the number of business day periods between the given dates.
 * Business days being days that arent in the weekend.
 * Like `differenceInCalendarDays`, the function removes the times from
 * the dates before calculating the difference.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of business days
 *
 * @example
 * // How many business days are between
 * // 10 January 2014 and 20 July 2014?
 * const result = differenceInBusinessDays(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 0, 10)
 * )
 * //=> 136
 *
 * // How many business days are between
 * // 30 November 2021 and 1 November 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 30),
 *   new Date(2021, 10, 1)
 * )
 * //=> 21
 *
 * // How many business days are between
 * // 1 November 2021 and 1 December 2021?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 11, 1)
 * )
 * //=> -22
 *
 * // How many business days are between
 * // 1 November 2021 and 1 November 2021 ?
 * const result = differenceInBusinessDays(
 *   new Date(2021, 10, 1),
 *   new Date(2021, 10, 1)
 * )
 * //=> 0
 */
function differenceInBusinessDays(dateLeft, dateRight) {
  const _dateLeft = (0, _index6$5.toDate)(dateLeft);
  let _dateRight = (0, _index6$5.toDate)(dateRight);

  if (!(0, _index4$1J.isValid)(_dateLeft) || !(0, _index4$1J.isValid)(_dateRight))
    return NaN;

  const calendarDifference = (0, _index2$49.differenceInCalendarDays)(
    _dateLeft,
    _dateRight,
  );
  const sign = calendarDifference < 0 ? -1 : 1;

  const weeks = Math.trunc(calendarDifference / 7);

  let result = weeks * 5;
  _dateRight = (0, _index$98.addDays)(_dateRight, weeks * 7);

  // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
  while (!(0, _index3$2b.isSameDay)(_dateLeft, _dateRight)) {
    // sign is used to account for both negative and positive differences
    result += (0, _index5$1C.isWeekend)(_dateRight) ? 0 : sign;
    _dateRight = (0, _index$98.addDays)(_dateRight, sign);
  }

  // Prevent negative zero
  return result === 0 ? 0 : result;
}

var differenceInCalendarISOWeekYears$1 = {};

differenceInCalendarISOWeekYears$1.differenceInCalendarISOWeekYears = differenceInCalendarISOWeekYears;
var _index$97 = getISOWeekYear$1;

/**
 * @name differenceInCalendarISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * const result = differenceInCalendarISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOWeekYears(dateLeft, dateRight) {
  return (
    (0, _index$97.getISOWeekYear)(dateLeft) - (0, _index$97.getISOWeekYear)(dateRight)
  );
}

var differenceInCalendarISOWeeks$1 = {};

differenceInCalendarISOWeeks$1.differenceInCalendarISOWeeks = differenceInCalendarISOWeeks;
var _index$96 = constants$1;
var _index2$48 = startOfISOWeek$1;
var _index3$2a = getTimezoneOffsetInMilliseconds$1;

/**
 * @name differenceInCalendarISOWeeks
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * const result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks(dateLeft, dateRight) {
  const startOfISOWeekLeft = (0, _index2$48.startOfISOWeek)(dateLeft);
  const startOfISOWeekRight = (0, _index2$48.startOfISOWeek)(dateRight);

  const timestampLeft =
    +startOfISOWeekLeft -
    (0, _index3$2a.getTimezoneOffsetInMilliseconds)(startOfISOWeekLeft);
  const timestampRight =
    +startOfISOWeekRight -
    (0, _index3$2a.getTimezoneOffsetInMilliseconds)(startOfISOWeekRight);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(
    (timestampLeft - timestampRight) / _index$96.millisecondsInWeek,
  );
}

var differenceInCalendarMonths$1 = {};

differenceInCalendarMonths$1.differenceInCalendarMonths = differenceInCalendarMonths;
var _index$95 = toDate$1;

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dateLeft, dateRight) {
  const _dateLeft = (0, _index$95.toDate)(dateLeft);
  const _dateRight = (0, _index$95.toDate)(dateRight);

  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const monthDiff = _dateLeft.getMonth() - _dateRight.getMonth();

  return yearDiff * 12 + monthDiff;
}

var differenceInCalendarQuarters$1 = {};

var getQuarter$1 = {};

getQuarter$1.getQuarter = getQuarter;
var _index$94 = toDate$1;

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(date) {
  const _date = (0, _index$94.toDate)(date);
  const quarter = Math.trunc(_date.getMonth() / 3) + 1;
  return quarter;
}

differenceInCalendarQuarters$1.differenceInCalendarQuarters = differenceInCalendarQuarters;
var _index$93 = getQuarter$1;
var _index2$47 = toDate$1;

/**
 * @name differenceInCalendarQuarters
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters(dateLeft, dateRight) {
  const _dateLeft = (0, _index2$47.toDate)(dateLeft);
  const _dateRight = (0, _index2$47.toDate)(dateRight);

  const yearDiff = _dateLeft.getFullYear() - _dateRight.getFullYear();
  const quarterDiff =
    (0, _index$93.getQuarter)(_dateLeft) - (0, _index$93.getQuarter)(_dateRight);

  return yearDiff * 4 + quarterDiff;
}

var differenceInCalendarWeeks$1 = {};

differenceInCalendarWeeks$1.differenceInCalendarWeeks = differenceInCalendarWeeks;
var _index$92 = constants$1;
var _index2$46 = startOfWeek$1;

var _index3$29 = getTimezoneOffsetInMilliseconds$1;

/**
 * The {@link differenceInCalendarWeeks} function options.
 */

/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */
function differenceInCalendarWeeks(dateLeft, dateRight, options) {
  const startOfWeekLeft = (0, _index2$46.startOfWeek)(dateLeft, options);
  const startOfWeekRight = (0, _index2$46.startOfWeek)(dateRight, options);

  const timestampLeft =
    +startOfWeekLeft -
    (0, _index3$29.getTimezoneOffsetInMilliseconds)(startOfWeekLeft);
  const timestampRight =
    +startOfWeekRight -
    (0, _index3$29.getTimezoneOffsetInMilliseconds)(startOfWeekRight);

  // Round the number of days to the nearest integer because the number of
  // milliseconds in a days is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(
    (timestampLeft - timestampRight) / _index$92.millisecondsInWeek,
  );
}

var differenceInCalendarYears$1 = {};

differenceInCalendarYears$1.differenceInCalendarYears = differenceInCalendarYears;
var _index$91 = toDate$1;

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date

 * @returns The number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dateLeft, dateRight) {
  const _dateLeft = (0, _index$91.toDate)(dateLeft);
  const _dateRight = (0, _index$91.toDate)(dateRight);

  return _dateLeft.getFullYear() - _dateRight.getFullYear();
}

var differenceInDays$1 = {};

differenceInDays$1.differenceInDays = differenceInDays;
var _index$90 = differenceInCalendarDays$1;
var _index2$45 = toDate$1;

/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */
function differenceInDays(dateLeft, dateRight) {
  const _dateLeft = (0, _index2$45.toDate)(dateLeft);
  const _dateRight = (0, _index2$45.toDate)(dateRight);

  const sign = compareLocalAsc(_dateLeft, _dateRight);
  const difference = Math.abs(
    (0, _index$90.differenceInCalendarDays)(_dateLeft, _dateRight),
  );

  _dateLeft.setDate(_dateLeft.getDate() - sign * difference);

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  const isLastDayNotFull = Number(
    compareLocalAsc(_dateLeft, _dateRight) === -sign,
  );
  const result = sign * (difference - isLastDayNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
  const diff =
    dateLeft.getFullYear() - dateRight.getFullYear() ||
    dateLeft.getMonth() - dateRight.getMonth() ||
    dateLeft.getDate() - dateRight.getDate() ||
    dateLeft.getHours() - dateRight.getHours() ||
    dateLeft.getMinutes() - dateRight.getMinutes() ||
    dateLeft.getSeconds() - dateRight.getSeconds() ||
    dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

var differenceInHours$1 = {};

var getRoundingMethod$1 = {};

getRoundingMethod$1.getRoundingMethod = getRoundingMethod;

function getRoundingMethod(method) {
  return (number) => {
    const round = method ? Math[method] : Math.trunc;
    const result = round(number);
    // Prevent negative zero
    return result === 0 ? 0 : result;
  };
}

var differenceInMilliseconds$1 = {};

differenceInMilliseconds$1.differenceInMilliseconds = differenceInMilliseconds;
var _index$8$ = toDate$1;

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dateLeft, dateRight) {
  return +(0, _index$8$.toDate)(dateLeft) - +(0, _index$8$.toDate)(dateRight);
}

differenceInHours$1.differenceInHours = differenceInHours;
var _index$8_ = getRoundingMethod$1;
var _index2$44 = constants$1;
var _index3$28 = differenceInMilliseconds$1;

/**
 * The {@link differenceInHours} function options.
 */

/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours(dateLeft, dateRight, options) {
  const diff =
    (0, _index3$28.differenceInMilliseconds)(dateLeft, dateRight) /
    _index2$44.millisecondsInHour;
  return (0, _index$8_.getRoundingMethod)(options?.roundingMethod)(diff);
}

var differenceInISOWeekYears$1 = {};

var subISOWeekYears$1 = {};

subISOWeekYears$1.subISOWeekYears = subISOWeekYears;
var _index$8Z = addISOWeekYears$1;

/**
 * @name subISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of ISO week-numbering years to be subtracted.
 *
 * @returns The new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOWeekYears(date, amount) {
  return (0, _index$8Z.addISOWeekYears)(date, -amount);
}

differenceInISOWeekYears$1.differenceInISOWeekYears = differenceInISOWeekYears;
var _index$8Y = compareAsc$1;
var _index2$43 = differenceInCalendarISOWeekYears$1;
var _index3$27 = subISOWeekYears$1;
var _index4$1I = toDate$1;

/**
 * @name differenceInISOWeekYears
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * const result = differenceInISOWeekYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOWeekYears(dateLeft, dateRight) {
  let _dateLeft = (0, _index4$1I.toDate)(dateLeft);
  const _dateRight = (0, _index4$1I.toDate)(dateRight);

  const sign = (0, _index$8Y.compareAsc)(_dateLeft, _dateRight);
  const difference = Math.abs(
    (0, _index2$43.differenceInCalendarISOWeekYears)(_dateLeft, _dateRight),
  );
  _dateLeft = (0, _index3$27.subISOWeekYears)(_dateLeft, sign * difference);

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  const isLastISOWeekYearNotFull = Number(
    (0, _index$8Y.compareAsc)(_dateLeft, _dateRight) === -sign,
  );
  const result = sign * (difference - isLastISOWeekYearNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

var differenceInMinutes$1 = {};

differenceInMinutes$1.differenceInMinutes = differenceInMinutes;
var _index$8X = getRoundingMethod$1;
var _index2$42 = constants$1;
var _index3$26 = differenceInMilliseconds$1;

/**
 * The {@link differenceInMinutes} function options.
 */

/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */
function differenceInMinutes(dateLeft, dateRight, options) {
  const diff =
    (0, _index3$26.differenceInMilliseconds)(dateLeft, dateRight) /
    _index2$42.millisecondsInMinute;
  return (0, _index$8X.getRoundingMethod)(options?.roundingMethod)(diff);
}

var differenceInMonths$1 = {};

var isLastDayOfMonth$1 = {};

var endOfDay$1 = {};

endOfDay$1.endOfDay = endOfDay;
var _index$8W = toDate$1;

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(date) {
  const _date = (0, _index$8W.toDate)(date);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

var endOfMonth$1 = {};

endOfMonth$1.endOfMonth = endOfMonth;
var _index$8V = toDate$1;

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(date) {
  const _date = (0, _index$8V.toDate)(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

isLastDayOfMonth$1.isLastDayOfMonth = isLastDayOfMonth;
var _index$8U = endOfDay$1;
var _index2$41 = endOfMonth$1;
var _index3$25 = toDate$1;

/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth(date) {
  const _date = (0, _index3$25.toDate)(date);
  return +(0, _index$8U.endOfDay)(_date) === +(0, _index2$41.endOfMonth)(_date);
}

differenceInMonths$1.differenceInMonths = differenceInMonths;
var _index$8T = compareAsc$1;
var _index2$40 = differenceInCalendarMonths$1;
var _index3$24 = isLastDayOfMonth$1;
var _index4$1H = toDate$1;

/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */
function differenceInMonths(dateLeft, dateRight) {
  const _dateLeft = (0, _index4$1H.toDate)(dateLeft);
  const _dateRight = (0, _index4$1H.toDate)(dateRight);

  const sign = (0, _index$8T.compareAsc)(_dateLeft, _dateRight);
  const difference = Math.abs(
    (0, _index2$40.differenceInCalendarMonths)(_dateLeft, _dateRight),
  );
  let result;

  // Check for the difference of less than month
  if (difference < 1) {
    result = 0;
  } else {
    if (_dateLeft.getMonth() === 1 && _dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      _dateLeft.setDate(30);
    }

    _dateLeft.setMonth(_dateLeft.getMonth() - sign * difference);

    // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value
    let isLastMonthNotFull =
      (0, _index$8T.compareAsc)(_dateLeft, _dateRight) === -sign;

    // Check for cases of one full calendar month
    if (
      (0, _index3$24.isLastDayOfMonth)((0, _index4$1H.toDate)(dateLeft)) &&
      difference === 1 &&
      (0, _index$8T.compareAsc)(dateLeft, _dateRight) === 1
    ) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  }

  // Prevent negative zero
  return result === 0 ? 0 : result;
}

var differenceInQuarters$1 = {};

differenceInQuarters$1.differenceInQuarters = differenceInQuarters;
var _index$8S = getRoundingMethod$1;
var _index2$3$ = differenceInMonths$1;

/**
 * The {@link differenceInQuarters} function options.
 */

/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */
function differenceInQuarters(dateLeft, dateRight, options) {
  const diff = (0, _index2$3$.differenceInMonths)(dateLeft, dateRight) / 3;
  return (0, _index$8S.getRoundingMethod)(options?.roundingMethod)(diff);
}

var differenceInSeconds$1 = {};

differenceInSeconds$1.differenceInSeconds = differenceInSeconds;
var _index$8R = getRoundingMethod$1;
var _index2$3_ = differenceInMilliseconds$1;

/**
 * The {@link differenceInSeconds} function options.
 */

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options.
 *
 * @returns The number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds(dateLeft, dateRight, options) {
  const diff =
    (0, _index2$3_.differenceInMilliseconds)(dateLeft, dateRight) / 1000;
  return (0, _index$8R.getRoundingMethod)(options?.roundingMethod)(diff);
}

var differenceInWeeks$1 = {};

differenceInWeeks$1.differenceInWeeks = differenceInWeeks;
var _index$8Q = getRoundingMethod$1;
var _index2$3Z = differenceInDays$1;

/**
 * The {@link differenceInWeeks} function options.
 */

/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 * @param options - An object with options
 *
 * @returns The number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * @example
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */
function differenceInWeeks(dateLeft, dateRight, options) {
  const diff = (0, _index2$3Z.differenceInDays)(dateLeft, dateRight) / 7;
  return (0, _index$8Q.getRoundingMethod)(options?.roundingMethod)(diff);
}

var differenceInYears$1 = {};

differenceInYears$1.differenceInYears = differenceInYears;
var _index$8P = compareAsc$1;
var _index2$3Y = differenceInCalendarYears$1;
var _index3$23 = toDate$1;

/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */
function differenceInYears(dateLeft, dateRight) {
  const _dateLeft = (0, _index3$23.toDate)(dateLeft);
  const _dateRight = (0, _index3$23.toDate)(dateRight);

  const sign = (0, _index$8P.compareAsc)(_dateLeft, _dateRight);
  const difference = Math.abs(
    (0, _index2$3Y.differenceInCalendarYears)(_dateLeft, _dateRight),
  );

  // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days
  _dateLeft.setFullYear(1584);
  _dateRight.setFullYear(1584);

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  const isLastYearNotFull =
    (0, _index$8P.compareAsc)(_dateLeft, _dateRight) === -sign;
  const result = sign * (difference - +isLastYearNotFull);

  // Prevent negative zero
  return result === 0 ? 0 : result;
}

var eachDayOfInterval$1 = {};

eachDayOfInterval$1.eachDayOfInterval = eachDayOfInterval;
var _index$8O = toDate$1;

/**
 * The {@link eachDayOfInterval} function options.
 */

/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of days from the day of the interval start to the day of the interval end
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDayOfInterval(interval, options) {
  const startDate = (0, _index$8O.toDate)(interval.start);
  const endDate = (0, _index$8O.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index$8O.toDate)(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return reversed ? dates.reverse() : dates;
}

var eachHourOfInterval$1 = {};

eachHourOfInterval$1.eachHourOfInterval = eachHourOfInterval;
var _index$8N = addHours$1;
var _index2$3X = toDate$1;

/**
 * The {@link eachHourOfInterval} function options.
 */

/**
 * @name eachHourOfInterval
 * @category Interval Helpers
 * @summary Return the array of hours within the specified time interval.
 *
 * @description
 * Return the array of hours within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of hours from the hour of the interval start to the hour of the interval end
 *
 * @example
 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
 * const result = eachHourOfInterval({
 *   start: new Date(2014, 9, 6, 12),
 *   end: new Date(2014, 9, 6, 15)
 * })
 * //=> [
 * //   Mon Oct 06 2014 12:00:00,
 * //   Mon Oct 06 2014 13:00:00,
 * //   Mon Oct 06 2014 14:00:00,
 * //   Mon Oct 06 2014 15:00:00
 * // ]
 */
function eachHourOfInterval(interval, options) {
  const startDate = (0, _index2$3X.toDate)(interval.start);
  const endDate = (0, _index2$3X.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  let currentDate = reversed ? endDate : startDate;
  currentDate.setMinutes(0, 0, 0);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index2$3X.toDate)(currentDate));
    currentDate = (0, _index$8N.addHours)(currentDate, step);
  }

  return reversed ? dates.reverse() : dates;
}

var eachMinuteOfInterval$1 = {};

var startOfMinute$1 = {};

startOfMinute$1.startOfMinute = startOfMinute;
var _index$8M = toDate$1;

/**
 * @name startOfMinute
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute(date) {
  const _date = (0, _index$8M.toDate)(date);
  _date.setSeconds(0, 0);
  return _date;
}

eachMinuteOfInterval$1.eachMinuteOfInterval = eachMinuteOfInterval;
var _index$8L = addMinutes$1;
var _index2$3W = startOfMinute$1;
var _index3$22 = toDate$1;

/**
 * The {@link eachMinuteOfInterval} function options.
 */

/**
 * @name eachMinuteOfInterval
 * @category Interval Helpers
 * @summary Return the array of minutes within the specified time interval.
 *
 * @description
 * Returns the array of minutes within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of minutes from the minute of the interval start to the minute of the interval end
 *
 * @example
 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
 * const result = eachMinuteOfInterval({
 *   start: new Date(2014, 9, 14, 13),
 *   end: new Date(2014, 9, 14, 13, 3)
 * })
 * //=> [
 * //   Wed Oct 14 2014 13:00:00,
 * //   Wed Oct 14 2014 13:01:00,
 * //   Wed Oct 14 2014 13:02:00,
 * //   Wed Oct 14 2014 13:03:00
 * // ]
 */
function eachMinuteOfInterval(interval, options) {
  const startDate = (0, _index2$3W.startOfMinute)(
    (0, _index3$22.toDate)(interval.start),
  );
  const endDate = (0, _index3$22.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  let currentDate = reversed ? endDate : startDate;

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index3$22.toDate)(currentDate));
    currentDate = (0, _index$8L.addMinutes)(currentDate, step);
  }

  return reversed ? dates.reverse() : dates;
}

var eachMonthOfInterval$1 = {};

eachMonthOfInterval$1.eachMonthOfInterval = eachMonthOfInterval;
var _index$8K = toDate$1;

/**
 * The {@link eachMonthOfInterval} function options.
 */

/**
 * @name eachMonthOfInterval
 * @category Interval Helpers
 * @summary Return the array of months within the specified time interval.
 *
 * @description
 * Return the array of months within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of months from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each month between 6 February 2014 and 10 August 2014:
 * const result = eachMonthOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Sat Feb 01 2014 00:00:00,
 * //   Sat Mar 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Thu May 01 2014 00:00:00,
 * //   Sun Jun 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * //   Fri Aug 01 2014 00:00:00
 * // ]
 */
function eachMonthOfInterval(interval, options) {
  const startDate = (0, _index$8K.toDate)(interval.start);
  const endDate = (0, _index$8K.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setDate(1);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index$8K.toDate)(currentDate));
    currentDate.setMonth(currentDate.getMonth() + step);
  }

  return reversed ? dates.reverse() : dates;
}

var eachQuarterOfInterval$1 = {};

var startOfQuarter$1 = {};

startOfQuarter$1.startOfQuarter = startOfQuarter;
var _index$8J = toDate$1;

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(date) {
  const _date = (0, _index$8J.toDate)(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - (currentMonth % 3);
  _date.setMonth(month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

eachQuarterOfInterval$1.eachQuarterOfInterval = eachQuarterOfInterval;
var _index$8I = addQuarters$1;
var _index2$3V = startOfQuarter$1;
var _index3$21 = toDate$1;

/**
 * The {@link eachQuarterOfInterval} function options.
 */

/**
 * @name eachQuarterOfInterval
 * @category Interval Helpers
 * @summary Return the array of quarters within the specified time interval.
 *
 * @description
 * Return the array of quarters within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval
 *
 * @returns The array with starts of quarters from the quarter of the interval start to the quarter of the interval end
 *
 * @example
 * // Each quarter within interval 6 February 2014 - 10 August 2014:
 * const result = eachQuarterOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2014, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Tue Apr 01 2014 00:00:00,
 * //   Tue Jul 01 2014 00:00:00,
 * // ]
 */
function eachQuarterOfInterval(interval, options) {
  const startDate = (0, _index3$21.toDate)(interval.start);
  const endDate = (0, _index3$21.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed
    ? +(0, _index2$3V.startOfQuarter)(startDate)
    : +(0, _index2$3V.startOfQuarter)(endDate);
  let currentDate = reversed
    ? (0, _index2$3V.startOfQuarter)(endDate)
    : (0, _index2$3V.startOfQuarter)(startDate);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index3$21.toDate)(currentDate));
    currentDate = (0, _index$8I.addQuarters)(currentDate, step);
  }

  return reversed ? dates.reverse() : dates;
}

var eachWeekOfInterval$1 = {};

eachWeekOfInterval$1.eachWeekOfInterval = eachWeekOfInterval;
var _index$8H = addWeeks$1;
var _index2$3U = startOfWeek$1;
var _index3$20 = toDate$1;

/**
 * The {@link eachWeekOfInterval} function options.
 */

/**
 * @name eachWeekOfInterval
 * @category Interval Helpers
 * @summary Return the array of weeks within the specified time interval.
 *
 * @description
 * Return the array of weeks within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 * @param options - An object with options.
 *
 * @returns The array with starts of weeks from the week of the interval start to the week of the interval end
 *
 * @example
 * // Each week within interval 6 October 2014 - 23 November 2014:
 * const result = eachWeekOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 10, 23)
 * })
 * //=> [
 * //   Sun Oct 05 2014 00:00:00,
 * //   Sun Oct 12 2014 00:00:00,
 * //   Sun Oct 19 2014 00:00:00,
 * //   Sun Oct 26 2014 00:00:00,
 * //   Sun Nov 02 2014 00:00:00,
 * //   Sun Nov 09 2014 00:00:00,
 * //   Sun Nov 16 2014 00:00:00,
 * //   Sun Nov 23 2014 00:00:00
 * // ]
 */
function eachWeekOfInterval(interval, options) {
  const startDate = (0, _index3$20.toDate)(interval.start);
  const endDate = (0, _index3$20.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const startDateWeek = reversed
    ? (0, _index2$3U.startOfWeek)(endDate, options)
    : (0, _index2$3U.startOfWeek)(startDate, options);
  const endDateWeek = reversed
    ? (0, _index2$3U.startOfWeek)(startDate, options)
    : (0, _index2$3U.startOfWeek)(endDate, options);

  // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
  startDateWeek.setHours(15);
  endDateWeek.setHours(15);

  const endTime = +endDateWeek.getTime();
  let currentDate = startDateWeek;

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    currentDate.setHours(0);
    dates.push((0, _index3$20.toDate)(currentDate));
    currentDate = (0, _index$8H.addWeeks)(currentDate, step);
    currentDate.setHours(15);
  }

  return reversed ? dates.reverse() : dates;
}

var eachWeekendOfInterval$1 = {};

eachWeekendOfInterval$1.eachWeekendOfInterval = eachWeekendOfInterval;
var _index$8G = eachDayOfInterval$1;
var _index2$3T = isWeekend$1;

/**
 * @name eachWeekendOfInterval
 * @category Interval Helpers
 * @summary List all the Saturdays and Sundays in the given date interval.
 *
 * @description
 * Get all the Saturdays and Sundays in the given date interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The given interval
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given date interval
 * const result = eachWeekendOfInterval({
 *   start: new Date(2018, 8, 17),
 *   end: new Date(2018, 8, 30)
 * })
 * //=> [
 * //   Sat Sep 22 2018 00:00:00,
 * //   Sun Sep 23 2018 00:00:00,
 * //   Sat Sep 29 2018 00:00:00,
 * //   Sun Sep 30 2018 00:00:00
 * // ]
 */
function eachWeekendOfInterval(interval) {
  const dateInterval = (0, _index$8G.eachDayOfInterval)(interval);
  const weekends = [];
  let index = 0;
  while (index < dateInterval.length) {
    const date = dateInterval[index++];
    if ((0, _index2$3T.isWeekend)(date)) weekends.push(date);
  }
  return weekends;
}

var eachWeekendOfMonth$1 = {};

var startOfMonth$1 = {};

startOfMonth$1.startOfMonth = startOfMonth;
var _index$8F = toDate$1;

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(date) {
  const _date = (0, _index$8F.toDate)(date);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

eachWeekendOfMonth$1.eachWeekendOfMonth = eachWeekendOfMonth;
var _index$8E = eachWeekendOfInterval$1;
var _index2$3S = endOfMonth$1;
var _index3$1$ = startOfMonth$1;

/**
 * @name eachWeekendOfMonth
 * @category Month Helpers
 * @summary List all the Saturdays and Sundays in the given month.
 *
 * @description
 * Get all the Saturdays and Sundays in the given month.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given month
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the given month
 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
 * //=> [
 * //   Sat Feb 05 2022 00:00:00,
 * //   Sun Feb 06 2022 00:00:00,
 * //   Sat Feb 12 2022 00:00:00,
 * //   Sun Feb 13 2022 00:00:00,
 * //   Sat Feb 19 2022 00:00:00,
 * //   Sun Feb 20 2022 00:00:00,
 * //   Sat Feb 26 2022 00:00:00,
 * //   Sun Feb 27 2022 00:00:00
 * // ]
 */
function eachWeekendOfMonth(date) {
  const start = (0, _index3$1$.startOfMonth)(date);
  const end = (0, _index2$3S.endOfMonth)(date);
  return (0, _index$8E.eachWeekendOfInterval)({ start, end });
}

var eachWeekendOfYear$1 = {};

var endOfYear$1 = {};

endOfYear$1.endOfYear = endOfYear;
var _index$8D = toDate$1;

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(date) {
  const _date = (0, _index$8D.toDate)(date);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

var startOfYear$1 = {};

startOfYear$1.startOfYear = startOfYear;
var _index$8C = toDate$1;
var _index2$3R = constructFrom$1;

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(date) {
  const cleanDate = (0, _index$8C.toDate)(date);
  const _date = (0, _index2$3R.constructFrom)(date, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

eachWeekendOfYear$1.eachWeekendOfYear = eachWeekendOfYear;
var _index$8B = eachWeekendOfInterval$1;
var _index2$3Q = endOfYear$1;
var _index3$1_ = startOfYear$1;

/**
 * @name eachWeekendOfYear
 * @category Year Helpers
 * @summary List all the Saturdays and Sundays in the year.
 *
 * @description
 * Get all the Saturdays and Sundays in the year.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given year
 *
 * @returns An array containing all the Saturdays and Sundays
 *
 * @example
 * // Lists all Saturdays and Sundays in the year
 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
 * //=> [
 * //   Sat Jan 03 2020 00:00:00,
 * //   Sun Jan 04 2020 00:00:00,
 * //   ...
 * //   Sun Dec 27 2020 00:00:00
 * // ]
 * ]
 */
function eachWeekendOfYear(date) {
  const start = (0, _index3$1_.startOfYear)(date);
  const end = (0, _index2$3Q.endOfYear)(date);
  return (0, _index$8B.eachWeekendOfInterval)({ start, end });
}

var eachYearOfInterval$1 = {};

eachYearOfInterval$1.eachYearOfInterval = eachYearOfInterval;
var _index$8A = toDate$1;

/**
 * The {@link eachYearOfInterval} function options.
 */

/**
 * @name eachYearOfInterval
 * @category Interval Helpers
 * @summary Return the array of yearly timestamps within the specified time interval.
 *
 * @description
 * Return the array of yearly timestamps within the specified time interval.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval.
 *
 * @returns The array with starts of yearly timestamps from the month of the interval start to the month of the interval end
 *
 * @example
 * // Each year between 6 February 2014 and 10 August 2017:
 * const result = eachYearOfInterval({
 *   start: new Date(2014, 1, 6),
 *   end: new Date(2017, 7, 10)
 * })
 * //=> [
 * //   Wed Jan 01 2014 00:00:00,
 * //   Thu Jan 01 2015 00:00:00,
 * //   Fri Jan 01 2016 00:00:00,
 * //   Sun Jan 01 2017 00:00:00
 * // ]
 */
function eachYearOfInterval(interval, options) {
  const startDate = (0, _index$8A.toDate)(interval.start);
  const endDate = (0, _index$8A.toDate)(interval.end);

  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setMonth(0, 1);

  let step = options?.step ?? 1;
  if (!step) return [];
  if (step < 0) {
    step = -step;
    reversed = !reversed;
  }

  const dates = [];

  while (+currentDate <= endTime) {
    dates.push((0, _index$8A.toDate)(currentDate));
    currentDate.setFullYear(currentDate.getFullYear() + step);
  }

  return reversed ? dates.reverse() : dates;
}

var endOfDecade$1 = {};

endOfDecade$1.endOfDecade = endOfDecade;
var _index$8z = toDate$1;

/**
 * @name endOfDecade
 * @category Decade Helpers
 * @summary Return the end of a decade for the given date.
 *
 * @description
 * Return the end of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a decade
 *
 * @example
 * // The end of a decade for 12 May 1984 00:00:00:
 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
 * //=> Dec 31 1989 23:59:59.999
 */
function endOfDecade(date) {
  // TODO: Switch to more technical definition in of decades that start with 1
  // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
  // change, so it can only be done in 4.0.
  const _date = (0, _index$8z.toDate)(date);
  const year = _date.getFullYear();
  const decade = 9 + Math.floor(year / 10) * 10;
  _date.setFullYear(decade, 11, 31);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

var endOfHour$1 = {};

endOfHour$1.endOfHour = endOfHour;
var _index$8y = toDate$1;

/**
 * @name endOfHour
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour(date) {
  const _date = (0, _index$8y.toDate)(date);
  _date.setMinutes(59, 59, 999);
  return _date;
}

var endOfISOWeek$1 = {};

var endOfWeek$1 = {};

endOfWeek$1.endOfWeek = endOfWeek;
var _index$8x = toDate$1;

var _index2$3P = defaultOptions$1;

/**
 * The {@link endOfWeek} function options.
 */

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(date, options) {
  const defaultOptions = (0, _index2$3P.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index$8x.toDate)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

endOfISOWeek$1.endOfISOWeek = endOfISOWeek;
var _index$8w = endOfWeek$1;

/**
 * @name endOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek(date) {
  return (0, _index$8w.endOfWeek)(date, { weekStartsOn: 1 });
}

var endOfISOWeekYear$1 = {};

endOfISOWeekYear$1.endOfISOWeekYear = endOfISOWeekYear;
var _index$8v = getISOWeekYear$1;
var _index2$3O = startOfISOWeek$1;
var _index3$1Z = constructFrom$1;

/**
 * @name endOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOWeekYear(date) {
  const year = (0, _index$8v.getISOWeekYear)(date);
  const fourthOfJanuaryOfNextYear = (0, _index3$1Z.constructFrom)(date, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const _date = (0, _index2$3O.startOfISOWeek)(fourthOfJanuaryOfNextYear);
  _date.setMilliseconds(_date.getMilliseconds() - 1);
  return _date;
}

var endOfMinute$1 = {};

endOfMinute$1.endOfMinute = endOfMinute;
var _index$8u = toDate$1;

/**
 * @name endOfMinute
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute(date) {
  const _date = (0, _index$8u.toDate)(date);
  _date.setSeconds(59, 999);
  return _date;
}

var endOfQuarter$1 = {};

endOfQuarter$1.endOfQuarter = endOfQuarter;
var _index$8t = toDate$1;

/**
 * @name endOfQuarter
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter(date) {
  const _date = (0, _index$8t.toDate)(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - (currentMonth % 3) + 3;
  _date.setMonth(month, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}

var endOfSecond$1 = {};

endOfSecond$1.endOfSecond = endOfSecond;
var _index$8s = toDate$1;

/**
 * @name endOfSecond
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond(date) {
  const _date = (0, _index$8s.toDate)(date);
  _date.setMilliseconds(999);
  return _date;
}

var endOfToday$1 = {};

endOfToday$1.endOfToday = endOfToday;
var _index$8r = endOfDay$1;

/**
 * @name endOfToday
 * @category Day Helpers
 * @summary Return the end of today.
 * @pure false
 *
 * @description
 * Return the end of today.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday() {
  return (0, _index$8r.endOfDay)(Date.now());
}

var endOfTomorrow$1 = {};

endOfTomorrow$1.endOfTomorrow = endOfTomorrow; /**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(23, 59, 59, 999);
  return date;
}

var endOfYesterday$1 = {};

endOfYesterday$1.endOfYesterday = endOfYesterday; /**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @returns The end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(23, 59, 59, 999);
  return date;
}

var format = {};

var defaultLocale = {};

var enUS = {};

var formatDistance$2H = {};

formatDistance$2H.formatDistance = void 0;

const formatDistanceLocale$1j = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "1 hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "1 day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "1 month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "1 year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years",
  },
};

const formatDistance$2G = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$1j[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};
formatDistance$2H.formatDistance = formatDistance$2G;

var formatLong$1s = {};

var buildFormatLongFn$1 = {};

buildFormatLongFn$1.buildFormatLongFn = buildFormatLongFn;

function buildFormatLongFn(args) {
  return (options = {}) => {
    // TODO: Remove String()
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

formatLong$1s.formatLong = void 0;
var _index$8q = buildFormatLongFn$1;

const dateFormats$1s = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$1s = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1s = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1s.formatLong = {
  date: (0, _index$8q.buildFormatLongFn)({
    formats: dateFormats$1s,
    defaultWidth: "full",
  }),

  time: (0, _index$8q.buildFormatLongFn)({
    formats: timeFormats$1s,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$8q.buildFormatLongFn)({
    formats: dateTimeFormats$1s,
    defaultWidth: "full",
  }),
});

var formatRelative$2H = {};

formatRelative$2H.formatRelative = void 0;

const formatRelativeLocale$1k = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative$2G = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$1k[token];
formatRelative$2H.formatRelative = formatRelative$2G;

var localize$1k = {};

var buildLocalizeFn$1 = {};

buildLocalizeFn$1.buildLocalizeFn = buildLocalizeFn; /* eslint-disable no-unused-vars */

/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */

/**
 * The map of localized values for each width.
 */

/**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */

/**
 * Converts the unit value to the tuple of values.
 */

/**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */

/**
 * The tuple of localized quarter values. The first element represents Q1.
 */

/**
 * The tuple of localized day values. The first element represents Sunday.
 */

/**
 * The tuple of localized month values. The first element represents January.
 */

function buildLocalizeFn(args) {
  return (value, options) => {
    const context = options?.context ? String(options.context) : "standalone";

    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = options?.width ? String(options.width) : defaultWidth;

      valuesArray =
        args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = options?.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index = args.argumentCallback ? args.argumentCallback(value) : value;

    // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

localize$1k.localize = void 0;
var _index$8p = buildLocalizeFn$1;

const eraValues$1k = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"],
};

const quarterValues$1k = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$1k = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],

  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

const dayValues$1k = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ],
};

const dayPeriodValues$1k = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night",
  },
};

const formattingDayPeriodValues$14 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night",
  },
};

const ordinalNumber$1k = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "st";
      case 2:
        return number + "nd";
      case 3:
        return number + "rd";
    }
  }
  return number + "th";
};

(localize$1k.localize = {
  ordinalNumber: ordinalNumber$1k,

  era: (0, _index$8p.buildLocalizeFn)({
    values: eraValues$1k,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$8p.buildLocalizeFn)({
    values: quarterValues$1k,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$8p.buildLocalizeFn)({
    values: monthValues$1k,
    defaultWidth: "wide",
  }),

  day: (0, _index$8p.buildLocalizeFn)({
    values: dayValues$1k,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$8p.buildLocalizeFn)({
    values: dayPeriodValues$1k,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$14,
    defaultFormattingWidth: "wide",
  }),
});

var match$1j = {};

var buildMatchFn$1 = {};

buildMatchFn$1.buildMatchFn = buildMatchFn;

function buildMatchFn(args) {
  return (string, options = {}) => {
    const width = options.width;

    const matchPattern =
      (width && args.matchPatterns[width]) ||
      args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];

    const parsePatterns =
      (width && args.parsePatterns[width]) ||
      args.parsePatterns[args.defaultParseWidth];

    const key = Array.isArray(parsePatterns)
      ? findIndex(parsePatterns, (pattern) => pattern.test(matchedString))
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        findKey(parsePatterns, (pattern) => pattern.test(matchedString));

    let value;

    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        options.valueCallback(value)
      : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

function findKey(object, predicate) {
  for (const key in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, key) &&
      predicate(object[key])
    ) {
      return key;
    }
  }
  return undefined;
}

function findIndex(array, predicate) {
  for (let key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

var buildMatchPatternFn$1 = {};

buildMatchPatternFn$1.buildMatchPatternFn = buildMatchPatternFn;

function buildMatchPatternFn(args) {
  return (string, options = {}) => {
    const matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];

    const parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback
      ? args.valueCallback(parseResult[0])
      : parseResult[0];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
    value = options.valueCallback ? options.valueCallback(value) : value;

    const rest = string.slice(matchedString.length);

    return { value, rest };
  };
}

match$1j.match = void 0;

var _index$8o = buildMatchFn$1;
var _index2$3N = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$1j = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$1j = /\d+/i;

const matchEraPatterns$1j = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i,
};
const parseEraPatterns$1j = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns$1j = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i,
};
const parseQuarterPatterns$1j = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1j = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i,
};
const parseMonthPatterns$1j = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$1j = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i,
};
const parseDayPatterns$1j = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns$1j = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns$1j = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

(match$1j.match = {
  ordinalNumber: (0, _index2$3N.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1j,
    parsePattern: parseOrdinalNumberPattern$1j,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$8o.buildMatchFn)({
    matchPatterns: matchEraPatterns$1j,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1j,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$8o.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1j,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1j,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$8o.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1j,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1j,
    defaultParseWidth: "any",
  }),

  day: (0, _index$8o.buildMatchFn)({
    matchPatterns: matchDayPatterns$1j,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1j,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$8o.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1j,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1j,
    defaultParseWidth: "any",
  }),
});

enUS.enUS = void 0;
var _index$8n = formatDistance$2H;
var _index2$3M = formatLong$1s;
var _index3$1Y = formatRelative$2H;
var _index4$1G = localize$1k;
var _index5$1B = match$1j;

/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
(enUS.enUS = {
  code: "en-US",
  formatDistance: _index$8n.formatDistance,
  formatLong: _index2$3M.formatLong,
  formatRelative: _index3$1Y.formatRelative,
  localize: _index4$1G.localize,
  match: _index5$1B.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

(function (exports) {
Object.defineProperty(exports, "defaultLocale", {
  enumerable: true,
  get: function () {
    return _index.enUS;
  },
});
var _index = enUS;
}(defaultLocale));

var formatters = {};

var getDayOfYear$1 = {};

getDayOfYear$1.getDayOfYear = getDayOfYear;
var _index$8m = differenceInCalendarDays$1;
var _index2$3L = startOfYear$1;
var _index3$1X = toDate$1;

/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear(date) {
  const _date = (0, _index3$1X.toDate)(date);
  const diff = (0, _index$8m.differenceInCalendarDays)(
    _date,
    (0, _index2$3L.startOfYear)(_date),
  );
  const dayOfYear = diff + 1;
  return dayOfYear;
}

var getISOWeek$1 = {};

getISOWeek$1.getISOWeek = getISOWeek;
var _index$8l = constants$1;
var _index2$3K = startOfISOWeek$1;
var _index3$1W = startOfISOWeekYear$1;
var _index4$1F = toDate$1;

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(date) {
  const _date = (0, _index4$1F.toDate)(date);
  const diff =
    +(0, _index2$3K.startOfISOWeek)(_date) -
    +(0, _index3$1W.startOfISOWeekYear)(_date);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / _index$8l.millisecondsInWeek) + 1;
}

var getWeek$1 = {};

var startOfWeekYear$1 = {};

var getWeekYear$1 = {};

getWeekYear$1.getWeekYear = getWeekYear;
var _index$8k = constructFrom$1;
var _index2$3J = startOfWeek$1;
var _index3$1V = toDate$1;

var _index4$1E = defaultOptions$1;

/**
 * The {@link getWeekYear} function options.
 */

/**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */
function getWeekYear(date, options) {
  const _date = (0, _index3$1V.toDate)(date);
  const year = _date.getFullYear();

  const defaultOptions = (0, _index4$1E.getDefaultOptions)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const firstWeekOfNextYear = (0, _index$8k.constructFrom)(date, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = (0, _index2$3J.startOfWeek)(
    firstWeekOfNextYear,
    options,
  );

  const firstWeekOfThisYear = (0, _index$8k.constructFrom)(date, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = (0, _index2$3J.startOfWeek)(
    firstWeekOfThisYear,
    options,
  );

  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

startOfWeekYear$1.startOfWeekYear = startOfWeekYear;
var _index$8j = constructFrom$1;
var _index2$3I = getWeekYear$1;
var _index3$1U = startOfWeek$1;

var _index4$1D = defaultOptions$1;

/**
 * The {@link startOfWeekYear} function options.
 */

/**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfWeekYear(date, options) {
  const defaultOptions = (0, _index4$1D.getDefaultOptions)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const year = (0, _index2$3I.getWeekYear)(date, options);
  const firstWeek = (0, _index$8j.constructFrom)(date, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = (0, _index3$1U.startOfWeek)(firstWeek, options);
  return _date;
}

getWeek$1.getWeek = getWeek;
var _index$8i = constants$1;
var _index2$3H = startOfWeek$1;
var _index3$1T = startOfWeekYear$1;
var _index4$1C = toDate$1;

/**
 * The {@link getWeek} function options.
 */

/**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */

function getWeek(date, options) {
  const _date = (0, _index4$1C.toDate)(date);
  const diff =
    +(0, _index2$3H.startOfWeek)(_date, options) -
    +(0, _index3$1T.startOfWeekYear)(_date, options);

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / _index$8i.millisecondsInWeek) + 1;
}

var addLeadingZeros$1 = {};

addLeadingZeros$1.addLeadingZeros = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  const sign = number < 0 ? "-" : "";
  const output = Math.abs(number).toString().padStart(targetLength, "0");
  return sign + output;
}

var lightFormatters = {};

lightFormatters.lightFormatters = void 0;
var _index$8h = addLeadingZeros$1;

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

(lightFormatters.lightFormatters = {
  // Year
  y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    const signedYear = date.getFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0, _index$8h.addLeadingZeros)(
      token === "yy" ? year % 100 : year,
      token.length,
    );
  },

  // Month
  M(date, token) {
    const month = date.getMonth();
    return token === "M"
      ? String(month + 1)
      : (0, _index$8h.addLeadingZeros)(month + 1, 2);
  },

  // Day of the month
  d(date, token) {
    return (0, _index$8h.addLeadingZeros)(date.getDate(), token.length);
  },

  // AM or PM
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  // Hour [1-12]
  h(date, token) {
    return (0, _index$8h.addLeadingZeros)(
      date.getHours() % 12 || 12,
      token.length,
    );
  },

  // Hour [0-23]
  H(date, token) {
    return (0, _index$8h.addLeadingZeros)(date.getHours(), token.length);
  },

  // Minute
  m(date, token) {
    return (0, _index$8h.addLeadingZeros)(date.getMinutes(), token.length);
  },

  // Second
  s(date, token) {
    return (0, _index$8h.addLeadingZeros)(date.getSeconds(), token.length);
  },

  // Fraction of second
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return (0, _index$8h.addLeadingZeros)(fractionalSeconds, token.length);
  },
});

formatters.formatters = void 0;
var _index$8g = getDayOfYear$1;
var _index2$3G = getISOWeek$1;
var _index3$1S = getISOWeekYear$1;
var _index4$1B = getWeek$1;
var _index5$1A = getWeekYear$1;

var _index6$4 = addLeadingZeros$1;
var _index7$4 = lightFormatters;

const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night",
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

(formatters.formatters = {
  // Era
  G: function (date, token, localize) {
    const era = date.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize.era(era, { width: "wide" });
    }
  },

  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === "yo") {
      const signedYear = date.getFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, { unit: "year" });
    }

    return _index7$4.lightFormatters.y(date, token);
  },

  // Local week-numbering year
  Y: function (date, token, localize, options) {
    const signedWeekYear = (0, _index5$1A.getWeekYear)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return (0, _index6$4.addLeadingZeros)(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === "Yo") {
      return localize.ordinalNumber(weekYear, { unit: "year" });
    }

    // Padding
    return (0, _index6$4.addLeadingZeros)(weekYear, token.length);
  },

  // ISO week-numbering year
  R: function (date, token) {
    const isoWeekYear = (0, _index3$1S.getISOWeekYear)(date);

    // Padding
    return (0, _index6$4.addLeadingZeros)(isoWeekYear, token.length);
  },

  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    const year = date.getFullYear();
    return (0, _index6$4.addLeadingZeros)(year, token.length);
  },

  // Quarter
  Q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return (0, _index6$4.addLeadingZeros)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "formatting",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone quarter
  q: function (date, token, localize) {
    const quarter = Math.ceil((date.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return (0, _index6$4.addLeadingZeros)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize.quarter(quarter, {
          width: "abbreviated",
          context: "standalone",
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize.quarter(quarter, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize.quarter(quarter, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // Month
  M: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return _index7$4.lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize.month(month, {
          width: "abbreviated",
          context: "formatting",
        });
      // J, F, ..., D
      case "MMMMM":
        return localize.month(month, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize.month(month, { width: "wide", context: "formatting" });
    }
  },

  // Stand-alone month
  L: function (date, token, localize) {
    const month = date.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return (0, _index6$4.addLeadingZeros)(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize.month(month, {
          width: "abbreviated",
          context: "standalone",
        });
      // J, F, ..., D
      case "LLLLL":
        return localize.month(month, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize.month(month, { width: "wide", context: "standalone" });
    }
  },

  // Local week of year
  w: function (date, token, localize, options) {
    const week = (0, _index4$1B.getWeek)(date, options);

    if (token === "wo") {
      return localize.ordinalNumber(week, { unit: "week" });
    }

    return (0, _index6$4.addLeadingZeros)(week, token.length);
  },

  // ISO week of year
  I: function (date, token, localize) {
    const isoWeek = (0, _index2$3G.getISOWeek)(date);

    if (token === "Io") {
      return localize.ordinalNumber(isoWeek, { unit: "week" });
    }

    return (0, _index6$4.addLeadingZeros)(isoWeek, token.length);
  },

  // Day of the month
  d: function (date, token, localize) {
    if (token === "do") {
      return localize.ordinalNumber(date.getDate(), { unit: "date" });
    }

    return _index7$4.lightFormatters.d(date, token);
  },

  // Day of year
  D: function (date, token, localize) {
    const dayOfYear = (0, _index$8g.getDayOfYear)(date);

    if (token === "Do") {
      return localize.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }

    return (0, _index6$4.addLeadingZeros)(dayOfYear, token.length);
  },

  // Day of week
  E: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "EEEEE":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "EEEE":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Local day of week
  e: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return (0, _index6$4.addLeadingZeros)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "eeeee":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "eeee":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    const dayOfWeek = date.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return (0, _index6$4.addLeadingZeros)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone",
        });
      // T
      case "ccccc":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "standalone",
        });
      // Tuesday
      case "cccc":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "standalone",
        });
    }
  },

  // ISO day of week
  i: function (date, token, localize) {
    const dayOfWeek = date.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return (0, _index6$4.addLeadingZeros)(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting",
        });
      // T
      case "iiiii":
        return localize.day(dayOfWeek, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "iiiiii":
        return localize.day(dayOfWeek, {
          width: "short",
          context: "formatting",
        });
      // Tuesday
      case "iiii":
      default:
        return localize.day(dayOfWeek, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM or PM
  a: function (date, token, localize) {
    const hours = date.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "aaa":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "aaaaa":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }

    switch (token) {
      case "b":
      case "bb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "bbb":
        return localize
          .dayPeriod(dayPeriodEnumValue, {
            width: "abbreviated",
            context: "formatting",
          })
          .toLowerCase();
      case "bbbbb":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    const hours = date.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting",
        });
      case "BBBBB":
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting",
        });
    }
  },

  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === "ho") {
      let hours = date.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return _index7$4.lightFormatters.h(date, token);
  },

  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === "Ho") {
      return localize.ordinalNumber(date.getHours(), { unit: "hour" });
    }

    return _index7$4.lightFormatters.H(date, token);
  },

  // Hour [0-11]
  K: function (date, token, localize) {
    const hours = date.getHours() % 12;

    if (token === "Ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return (0, _index6$4.addLeadingZeros)(hours, token.length);
  },

  // Hour [1-24]
  k: function (date, token, localize) {
    let hours = date.getHours();
    if (hours === 0) hours = 24;

    if (token === "ko") {
      return localize.ordinalNumber(hours, { unit: "hour" });
    }

    return (0, _index6$4.addLeadingZeros)(hours, token.length);
  },

  // Minute
  m: function (date, token, localize) {
    if (token === "mo") {
      return localize.ordinalNumber(date.getMinutes(), { unit: "minute" });
    }

    return _index7$4.lightFormatters.m(date, token);
  },

  // Second
  s: function (date, token, localize) {
    if (token === "so") {
      return localize.ordinalNumber(date.getSeconds(), { unit: "second" });
    }

    return _index7$4.lightFormatters.s(date, token);
  },

  // Fraction of second
  S: function (date, token) {
    return _index7$4.lightFormatters.S(date, token);
  },

  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return "Z";
    }

    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx": // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx": // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (GMT)
  O: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, _localize) {
    const timezoneOffset = date.getTimezoneOffset();

    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },

  // Seconds timestamp
  t: function (date, token, _localize) {
    const timestamp = Math.trunc(date.getTime() / 1000);
    return (0, _index6$4.addLeadingZeros)(timestamp, token.length);
  },

  // Milliseconds timestamp
  T: function (date, token, _localize) {
    const timestamp = date.getTime();
    return (0, _index6$4.addLeadingZeros)(timestamp, token.length);
  },
});

function formatTimezoneShort(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  return (
    sign + String(hours) + delimiter + (0, _index6$4.addLeadingZeros)(minutes, 2)
  );
}

function formatTimezoneWithOptionalMinutes(offset, delimiter) {
  if (offset % 60 === 0) {
    const sign = offset > 0 ? "-" : "+";
    return sign + (0, _index6$4.addLeadingZeros)(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, delimiter);
}

function formatTimezone(offset, delimiter = "") {
  const sign = offset > 0 ? "-" : "+";
  const absOffset = Math.abs(offset);
  const hours = (0, _index6$4.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
  const minutes = (0, _index6$4.addLeadingZeros)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var longFormatters = {};

longFormatters.longFormatters = void 0;

const dateLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "P":
      return formatLong.date({ width: "short" });
    case "PP":
      return formatLong.date({ width: "medium" });
    case "PPP":
      return formatLong.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong.date({ width: "full" });
  }
};

const timeLongFormatter = (pattern, formatLong) => {
  switch (pattern) {
    case "p":
      return formatLong.time({ width: "short" });
    case "pp":
      return formatLong.time({ width: "medium" });
    case "ppp":
      return formatLong.time({ width: "long" });
    case "pppp":
    default:
      return formatLong.time({ width: "full" });
  }
};

const dateTimeLongFormatter = (pattern, formatLong) => {
  const matchResult = pattern.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  let dateTimeFormat;

  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong.dateTime({ width: "full" });
      break;
  }

  return dateTimeFormat
    .replace("{{date}}", dateLongFormatter(datePattern, formatLong))
    .replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};

(longFormatters.longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter,
});

var protectedTokens = {};

protectedTokens.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
protectedTokens.isProtectedWeekYearToken = isProtectedWeekYearToken;
protectedTokens.warnOrThrowProtectedError = warnOrThrowProtectedError;
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;

const throwTokens = ["D", "DD", "YY", "YYYY"];

function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}

function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}

function warnOrThrowProtectedError(token, format, input) {
  const _message = message(token, format, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}

function message(token, format, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

(function (exports) {
exports.format = exports.formatDate = format;
Object.defineProperty(exports, "formatters", {
  enumerable: true,
  get: function () {
    return _index3.formatters;
  },
});
Object.defineProperty(exports, "longFormatters", {
  enumerable: true,
  get: function () {
    return _index4.longFormatters;
  },
});
var _index = defaultLocale;
var _index2 = defaultOptions$1;
var _index3 = formatters;
var _index4 = longFormatters;
var _index5 = protectedTokens;

var _index6 = isValid$1;
var _index7 = toDate$1;

// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * The {@link format} function options.
 */

/**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(date, formatStr, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index.defaultLocale;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const originalDate = (0, _index7.toDate)(date);

  if (!(0, _index6.isValid)(originalDate)) {
    throw new RangeError("Invalid time value");
  }

  let parts = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter === "p" || firstCharacter === "P") {
        const longFormatter = _index4.longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp)
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return { isToken: false, value: "'" };
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return { isToken: false, value: cleanEscapedString(substring) };
      }

      if (_index3.formatters[firstCharacter]) {
        return { isToken: true, value: substring };
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return { isToken: false, value: substring };
    });

  // invoke localize preprocessor (only for french locales at the moment)
  if (locale.localize.preprocessor) {
    parts = locale.localize.preprocessor(originalDate, parts);
  }

  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  return parts
    .map((part) => {
      if (!part.isToken) return part.value;

      const token = part.value;

      if (
        (!options?.useAdditionalWeekYearTokens &&
          (0, _index5.isProtectedWeekYearToken)(token)) ||
        (!options?.useAdditionalDayOfYearTokens &&
          (0, _index5.isProtectedDayOfYearToken)(token))
      ) {
        (0, _index5.warnOrThrowProtectedError)(token, formatStr, String(date));
      }

      const formatter = _index3.formatters[token[0]];
      return formatter(originalDate, token, locale.localize, formatterOptions);
    })
    .join("");
}

function cleanEscapedString(input) {
  const matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}
}(format));

var formatDistance$2F = {};

formatDistance$2F.formatDistance = formatDistance$2E;
var _index$8f = compareAsc$1;
var _index2$3F = constants$1;
var _index3$1R = differenceInMonths$1;
var _index4$1A = differenceInSeconds$1;
var _index5$1z = toDate$1;

var _index6$3 = defaultLocale;
var _index7$3 = defaultOptions$1;
var _index8$2 = getTimezoneOffsetInMilliseconds$1;

/**
 * The {@link formatDistance} function options.
 */

/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance$2E(date, baseDate, options) {
  const defaultOptions = (0, _index7$3.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index6$3.defaultLocale;
  const minutesInAlmostTwoDays = 2520;

  const comparison = (0, _index$8f.compareAsc)(date, baseDate);

  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }

  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison: comparison,
  });

  let dateLeft;
  let dateRight;
  if (comparison > 0) {
    dateLeft = (0, _index5$1z.toDate)(baseDate);
    dateRight = (0, _index5$1z.toDate)(date);
  } else {
    dateLeft = (0, _index5$1z.toDate)(date);
    dateRight = (0, _index5$1z.toDate)(baseDate);
  }

  const seconds = (0, _index4$1A.differenceInSeconds)(dateRight, dateLeft);
  const offsetInSeconds =
    ((0, _index8$2.getTimezoneOffsetInMilliseconds)(dateRight) -
      (0, _index8$2.getTimezoneOffsetInMilliseconds)(dateLeft)) /
    1000;
  const minutes = Math.round((seconds - offsetInSeconds) / 60);
  let months;

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options?.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance("halfAMinute", 0, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale.formatDistance("xMinutes", minutes, localizeOptions);
      }
    }

    // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return locale.formatDistance("xMinutes", minutes, localizeOptions);

    // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance("aboutXHours", 1, localizeOptions);

    // 1.5 hrs up to 24 hrs
  } else if (minutes < _index2$3F.minutesInDay) {
    const hours = Math.round(minutes / 60);
    return locale.formatDistance("aboutXHours", hours, localizeOptions);

    // 1 day up to 1.75 days
  } else if (minutes < minutesInAlmostTwoDays) {
    return locale.formatDistance("xDays", 1, localizeOptions);

    // 1.75 days up to 30 days
  } else if (minutes < _index2$3F.minutesInMonth) {
    const days = Math.round(minutes / _index2$3F.minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);

    // 1 month up to 2 months
  } else if (minutes < _index2$3F.minutesInMonth * 2) {
    months = Math.round(minutes / _index2$3F.minutesInMonth);
    return locale.formatDistance("aboutXMonths", months, localizeOptions);
  }

  months = (0, _index3$1R.differenceInMonths)(dateRight, dateLeft);

  // 2 months up to 12 months
  if (months < 12) {
    const nearestMonth = Math.round(minutes / _index2$3F.minutesInMonth);
    return locale.formatDistance("xMonths", nearestMonth, localizeOptions);

    // 1 year up to max Date
  } else {
    const monthsSinceStartOfYear = months % 12;
    const years = Math.trunc(months / 12);

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance("aboutXYears", years, localizeOptions);

      // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance("overXYears", years, localizeOptions);

      // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
  }
}

var formatDistanceStrict$1 = {};

formatDistanceStrict$1.formatDistanceStrict = formatDistanceStrict;
var _index$8e = defaultLocale;
var _index2$3E = defaultOptions$1;
var _index3$1Q = getRoundingMethod$1;
var _index4$1z = getTimezoneOffsetInMilliseconds$1;
var _index5$1y = compareAsc$1;
var _index6$2 = constants$1;

var _index7$2 = toDate$1;

/**
 * The {@link formatDistanceStrict} function options.
 */

/**
 * The unit used to format the distance in {@link formatDistanceStrict}.
 */

/**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * const result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */

function formatDistanceStrict(date, baseDate, options) {
  const defaultOptions = (0, _index2$3E.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index$8e.defaultLocale;

  const comparison = (0, _index5$1y.compareAsc)(date, baseDate);

  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }

  const localizeOptions = Object.assign({}, options, {
    addSuffix: options?.addSuffix,
    comparison: comparison,
  });

  let dateLeft;
  let dateRight;
  if (comparison > 0) {
    dateLeft = (0, _index7$2.toDate)(baseDate);
    dateRight = (0, _index7$2.toDate)(date);
  } else {
    dateLeft = (0, _index7$2.toDate)(date);
    dateRight = (0, _index7$2.toDate)(baseDate);
  }

  const roundingMethod = (0, _index3$1Q.getRoundingMethod)(
    options?.roundingMethod ?? "round",
  );

  const milliseconds = dateRight.getTime() - dateLeft.getTime();
  const minutes = milliseconds / _index6$2.millisecondsInMinute;

  const timezoneOffset =
    (0, _index4$1z.getTimezoneOffsetInMilliseconds)(dateRight) -
    (0, _index4$1z.getTimezoneOffsetInMilliseconds)(dateLeft);

  // Use DST-normalized difference in minutes for years, months and days;
  // use regular difference in minutes for hours, minutes and seconds.
  const dstNormalizedMinutes =
    (milliseconds - timezoneOffset) / _index6$2.millisecondsInMinute;

  const defaultUnit = options?.unit;
  let unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = "second";
    } else if (minutes < 60) {
      unit = "minute";
    } else if (minutes < _index6$2.minutesInDay) {
      unit = "hour";
    } else if (dstNormalizedMinutes < _index6$2.minutesInMonth) {
      unit = "day";
    } else if (dstNormalizedMinutes < _index6$2.minutesInYear) {
      unit = "month";
    } else {
      unit = "year";
    }
  } else {
    unit = defaultUnit;
  }

  // 0 up to 60 seconds
  if (unit === "second") {
    const seconds = roundingMethod(milliseconds / 1000);
    return locale.formatDistance("xSeconds", seconds, localizeOptions);

    // 1 up to 60 mins
  } else if (unit === "minute") {
    const roundedMinutes = roundingMethod(minutes);
    return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);

    // 1 up to 24 hours
  } else if (unit === "hour") {
    const hours = roundingMethod(minutes / 60);
    return locale.formatDistance("xHours", hours, localizeOptions);

    // 1 up to 30 days
  } else if (unit === "day") {
    const days = roundingMethod(dstNormalizedMinutes / _index6$2.minutesInDay);
    return locale.formatDistance("xDays", days, localizeOptions);

    // 1 up to 12 months
  } else if (unit === "month") {
    const months = roundingMethod(
      dstNormalizedMinutes / _index6$2.minutesInMonth,
    );
    return months === 12 && defaultUnit !== "month"
      ? locale.formatDistance("xYears", 1, localizeOptions)
      : locale.formatDistance("xMonths", months, localizeOptions);

    // 1 year up to max Date
  } else {
    const years = roundingMethod(dstNormalizedMinutes / _index6$2.minutesInYear);
    return locale.formatDistance("xYears", years, localizeOptions);
  }
}

var formatDistanceToNow$1 = {};

formatDistanceToNow$1.formatDistanceToNow = formatDistanceToNow;
var _index$8d = constructNow$1;

var _index2$3D = formatDistance$2F;

/**
 * The {@link formatDistanceToNow} function options.
 */

/**
 * @name formatDistanceToNow
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - The object with options
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function formatDistanceToNow(date, options) {
  return (0, _index2$3D.formatDistance)(
    date,
    (0, _index$8d.constructNow)(date),
    options,
  );
}

var formatDistanceToNowStrict$1 = {};

formatDistanceToNowStrict$1.formatDistanceToNowStrict = formatDistanceToNowStrict;
var _index$8c = formatDistanceStrict$1;
var _index2$3C = constructNow$1;

/**
 * The {@link formatDistanceToNowStrict} function options.
 */

/**
 * @name formatDistanceToNowStrict
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 * @pure false
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The distance in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `formatDistance` property
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * const result = formatDistanceToNowStrict(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * const result = formatDistanceToNowStrict(
 *   new Date(2015, 0, 1, 0, 0, 15)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in 1 year'
 *
 * @example
 * // If today is 28 January 2015,
 * // what is the distance to 1 January 2015, in months, rounded up??
 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016 in Esperanto?
 * const eoLocale = require('date-fns/locale/eo')
 * const result = formatDistanceToNowStrict(
 *   new Date(2016, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function formatDistanceToNowStrict(date, options) {
  return (0, _index$8c.formatDistanceStrict)(
    date,
    (0, _index2$3C.constructNow)(date),
    options,
  );
}

var formatDuration$1 = {};

formatDuration$1.formatDuration = formatDuration;

var _index$8b = defaultLocale;
var _index2$3B = defaultOptions$1;

/**
 * The {@link formatDuration} function options.
 */

const defaultFormat = [
  "years",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
];

/**
 * @name formatDuration
 * @category Common Helpers
 * @summary Formats a duration in human-readable format
 *
 * @description
 * Return human-readable duration string i.e. "9 months 2 days"
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param duration - The duration to format
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @example
 * // Format full duration
 * formatDuration({
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
 *
 * @example
 * // Format partial duration
 * formatDuration({ months: 9, days: 2 })
 * //=> '9 months 2 days'
 *
 * @example
 * // Customize the format
 * formatDuration(
 *   {
 *     years: 2,
 *     months: 9,
 *     weeks: 1,
 *     days: 7,
 *     hours: 5,
 *     minutes: 9,
 *     seconds: 30
 *   },
 *   { format: ['months', 'weeks'] }
 * ) === '9 months 1 week'
 *
 * @example
 * // Customize the zeros presence
 * formatDuration({ years: 0, months: 9 })
 * //=> '9 months'
 * formatDuration({ years: 0, months: 9 }, { zero: true })
 * //=> '0 years 9 months'
 *
 * @example
 * // Customize the delimiter
 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
 * //=> '2 years, 9 months, 3 weeks'
 */
function formatDuration(duration, options) {
  const defaultOptions = (0, _index2$3B.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index$8b.defaultLocale;
  const format = options?.format ?? defaultFormat;
  const zero = options?.zero ?? false;
  const delimiter = options?.delimiter ?? " ";

  if (!locale.formatDistance) {
    return "";
  }

  const result = format
    .reduce((acc, unit) => {
      const token = `x${unit.replace(/(^.)/, (m) => m.toUpperCase())}`;
      const value = duration[unit];
      if (value !== undefined && (zero || duration[unit])) {
        return acc.concat(locale.formatDistance(token, value));
      }
      return acc;
    }, [])
    .join(delimiter);

  return result;
}

var formatISO$1 = {};

formatISO$1.formatISO = formatISO;
var _index$8a = toDate$1;

var _index2$3A = addLeadingZeros$1;

/**
 * The {@link formatISO} function options.
 */

/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string (in loca.l time zone)
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */
function formatISO(date, options) {
  const _date = (0, _index$8a.toDate)(date);

  if (isNaN(_date.getTime())) {
    throw new RangeError("Invalid time value");
  }

  const format = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";

  let result = "";
  let tzOffset = "";

  const dateDelimiter = format === "extended" ? "-" : "";
  const timeDelimiter = format === "extended" ? ":" : "";

  // Representation is either 'date' or 'complete'
  if (representation !== "time") {
    const day = (0, _index2$3A.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, _index2$3A.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = (0, _index2$3A.addLeadingZeros)(_date.getFullYear(), 4);

    // yyyyMMdd or yyyy-MM-dd.
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }

  // Representation is either 'time' or 'complete'
  if (representation !== "date") {
    // Add the timezone.
    const offset = _date.getTimezoneOffset();

    if (offset !== 0) {
      const absoluteOffset = Math.abs(offset);
      const hourOffset = (0, _index2$3A.addLeadingZeros)(
        Math.trunc(absoluteOffset / 60),
        2,
      );
      const minuteOffset = (0, _index2$3A.addLeadingZeros)(absoluteOffset % 60, 2);
      // If less than 0, the sign is +, because it is ahead of time.
      const sign = offset < 0 ? "+" : "-";

      tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
    } else {
      tzOffset = "Z";
    }

    const hour = (0, _index2$3A.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, _index2$3A.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, _index2$3A.addLeadingZeros)(_date.getSeconds(), 2);

    // If there's also date, separate it with time with 'T'
    const separator = result === "" ? "" : "T";

    // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
    const time = [hour, minute, second].join(timeDelimiter);

    // HHmmss or HH:mm:ss.
    result = `${result}${separator}${time}${tzOffset}`;
  }

  return result;
}

var formatISO9075$1 = {};

formatISO9075$1.formatISO9075 = formatISO9075;
var _index$89 = isValid$1;
var _index2$3z = toDate$1;

var _index3$1P = addLeadingZeros$1;

/**
 * The {@link formatISO9075} function options.
 */

/**
 * @name formatISO9075
 * @category Common Helpers
 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
 *
 * @description
 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18 19:00:52'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075, short format:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918 190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, date only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 9075 format, time only:
 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52'
 */
function formatISO9075(date, options) {
  const _date = (0, _index2$3z.toDate)(date);

  if (!(0, _index$89.isValid)(_date)) {
    throw new RangeError("Invalid time value");
  }

  const format = options?.format ?? "extended";
  const representation = options?.representation ?? "complete";

  let result = "";

  const dateDelimiter = format === "extended" ? "-" : "";
  const timeDelimiter = format === "extended" ? ":" : "";

  // Representation is either 'date' or 'complete'
  if (representation !== "time") {
    const day = (0, _index3$1P.addLeadingZeros)(_date.getDate(), 2);
    const month = (0, _index3$1P.addLeadingZeros)(_date.getMonth() + 1, 2);
    const year = (0, _index3$1P.addLeadingZeros)(_date.getFullYear(), 4);

    // yyyyMMdd or yyyy-MM-dd.
    result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
  }

  // Representation is either 'time' or 'complete'
  if (representation !== "date") {
    const hour = (0, _index3$1P.addLeadingZeros)(_date.getHours(), 2);
    const minute = (0, _index3$1P.addLeadingZeros)(_date.getMinutes(), 2);
    const second = (0, _index3$1P.addLeadingZeros)(_date.getSeconds(), 2);

    // If there's also date, separate it with time with a space
    const separator = result === "" ? "" : " ";

    // HHmmss or HH:mm:ss.
    result = `${result}${separator}${hour}${timeDelimiter}${minute}${timeDelimiter}${second}`;
  }

  return result;
}

var formatISODuration$1 = {};

formatISODuration$1.formatISODuration = formatISODuration;

/**
 * @name formatISODuration
 * @category Common Helpers
 * @summary Format a duration object according as ISO 8601 duration string
 *
 * @description
 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs//90001488-13/reference/r_iso_8601_duration_format.htm)
 *
 * @param duration - The duration to format
 *
 * @returns The ISO 8601 duration string
 *
 * @example
 * // Format the given duration as ISO 8601 string
 * const result = formatISODuration({
 *   years: 39,
 *   months: 2,
 *   days: 20,
 *   hours: 7,
 *   minutes: 5,
 *   seconds: 0
 * })
 * //=> 'P39Y2M20DT0H0M0S'
 */
function formatISODuration(duration) {
  const {
    years = 0,
    months = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = duration;

  return `P${years}Y${months}M${days}DT${hours}H${minutes}M${seconds}S`;
}

var formatRFC3339$1 = {};

formatRFC3339$1.formatRFC3339 = formatRFC3339;
var _index$88 = isValid$1;
var _index2$3y = toDate$1;
var _index3$1O = addLeadingZeros$1;

/**
 * The {@link formatRFC3339} function options.
 */

/**
 * @name formatRFC3339
 * @category Common Helpers
 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
 *
 * @description
 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options.
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format:
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
 * formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), {
 *   fractionDigits: 3
 * })
 * //=> '2019-09-18T19:00:52.234Z'
 */
function formatRFC3339(date, options) {
  const _date = (0, _index2$3y.toDate)(date);

  if (!(0, _index$88.isValid)(_date)) {
    throw new RangeError("Invalid time value");
  }

  const fractionDigits = options?.fractionDigits ?? 0;

  const day = (0, _index3$1O.addLeadingZeros)(_date.getDate(), 2);
  const month = (0, _index3$1O.addLeadingZeros)(_date.getMonth() + 1, 2);
  const year = _date.getFullYear();

  const hour = (0, _index3$1O.addLeadingZeros)(_date.getHours(), 2);
  const minute = (0, _index3$1O.addLeadingZeros)(_date.getMinutes(), 2);
  const second = (0, _index3$1O.addLeadingZeros)(_date.getSeconds(), 2);

  let fractionalSecond = "";
  if (fractionDigits > 0) {
    const milliseconds = _date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, fractionDigits - 3),
    );
    fractionalSecond =
      "." + (0, _index3$1O.addLeadingZeros)(fractionalSeconds, fractionDigits);
  }

  let offset = "";
  const tzOffset = _date.getTimezoneOffset();

  if (tzOffset !== 0) {
    const absoluteOffset = Math.abs(tzOffset);
    const hourOffset = (0, _index3$1O.addLeadingZeros)(
      Math.trunc(absoluteOffset / 60),
      2,
    );
    const minuteOffset = (0, _index3$1O.addLeadingZeros)(absoluteOffset % 60, 2);
    // If less than 0, the sign is +, because it is ahead of time.
    const sign = tzOffset < 0 ? "+" : "-";

    offset = `${sign}${hourOffset}:${minuteOffset}`;
  } else {
    offset = "Z";
  }

  return `${year}-${month}-${day}T${hour}:${minute}:${second}${fractionalSecond}${offset}`;
}

var formatRFC7231$1 = {};

formatRFC7231$1.formatRFC7231 = formatRFC7231;
var _index$87 = isValid$1;
var _index2$3x = toDate$1;
var _index3$1N = addLeadingZeros$1;

const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/**
 * @name formatRFC7231
 * @category Common Helpers
 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
 *
 * @description
 * Return the formatted date string in RFC 7231 format.
 * The result will always be in UTC timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 18 September 2019 in RFC 7231 format:
 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
 */
function formatRFC7231(date) {
  const _date = (0, _index2$3x.toDate)(date);

  if (!(0, _index$87.isValid)(_date)) {
    throw new RangeError("Invalid time value");
  }

  const dayName = days[_date.getUTCDay()];
  const dayOfMonth = (0, _index3$1N.addLeadingZeros)(_date.getUTCDate(), 2);
  const monthName = months[_date.getUTCMonth()];
  const year = _date.getUTCFullYear();

  const hour = (0, _index3$1N.addLeadingZeros)(_date.getUTCHours(), 2);
  const minute = (0, _index3$1N.addLeadingZeros)(_date.getUTCMinutes(), 2);
  const second = (0, _index3$1N.addLeadingZeros)(_date.getUTCSeconds(), 2);

  // Result variables.
  return `${dayName}, ${dayOfMonth} ${monthName} ${year} ${hour}:${minute}:${second} GMT`;
}

var formatRelative$2F = {};

formatRelative$2F.formatRelative = formatRelative$2E;
var _index$86 = differenceInCalendarDays$1;
var _index2$3w = format;

var _index3$1M = toDate$1;

var _index4$1y = defaultLocale;
var _index5$1x = defaultOptions$1;

/**
 * The {@link formatRelative} function options.
 */

/**
 * @name formatRelative
 * @category Common Helpers
 * @summary Represent the date in words relative to the given base date.
 *
 * @description
 * Represent the date in words relative to the given base date.
 *
 * | Distance to the base date | Result                    |
 * |---------------------------|---------------------------|
 * | Previous 6 days           | last Sunday at 04:30 AM   |
 * | Last day                  | yesterday at 04:30 AM     |
 * | Same day                  | today at 04:30 AM         |
 * | Next day                  | tomorrow at 04:30 AM      |
 * | Next 6 days               | Sunday at 04:30 AM        |
 * | Other                     | 12/31/2017                |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param baseDate - The date to compare with
 * @param options - An object with options
 *
 * @returns The date in words
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws `options.locale` must contain `formatRelative` property
 *
 * @example
 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
 * const result = formatRelative(subDays(new Date(), 6), new Date())
 * //=> "last Thursday at 12:45 AM"
 */
function formatRelative$2E(date, baseDate, options) {
  const _date = (0, _index3$1M.toDate)(date);
  const _baseDate = (0, _index3$1M.toDate)(baseDate);

  const defaultOptions = (0, _index5$1x.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index4$1y.defaultLocale;
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const diff = (0, _index$86.differenceInCalendarDays)(_date, _baseDate);

  if (isNaN(diff)) {
    throw new RangeError("Invalid time value");
  }

  let token;
  if (diff < -6) {
    token = "other";
  } else if (diff < -1) {
    token = "lastWeek";
  } else if (diff < 0) {
    token = "yesterday";
  } else if (diff < 1) {
    token = "today";
  } else if (diff < 2) {
    token = "tomorrow";
  } else if (diff < 7) {
    token = "nextWeek";
  } else {
    token = "other";
  }

  const formatStr = locale.formatRelative(token, _date, _baseDate, {
    locale,
    weekStartsOn,
  });
  return (0, _index2$3w.format)(_date, formatStr, { locale, weekStartsOn });
}

var fromUnixTime$1 = {};

fromUnixTime$1.fromUnixTime = fromUnixTime;
var _index$85 = toDate$1;

/**
 * @name fromUnixTime
 * @category Timestamp Helpers
 * @summary Create a date from a Unix timestamp.
 *
 * @description
 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
 *
 * @param unixTime - The given Unix timestamp (in seconds)
 *
 * @returns The date
 *
 * @example
 * // Create the date 29 February 2012 11:45:05:
 * const result = fromUnixTime(1330515905)
 * //=> Wed Feb 29 2012 11:45:05
 */
function fromUnixTime(unixTime) {
  return (0, _index$85.toDate)(unixTime * 1000);
}

var getDate$1 = {};

getDate$1.getDate = getDate;
var _index$84 = toDate$1;

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(date) {
  const _date = (0, _index$84.toDate)(date);
  const dayOfMonth = _date.getDate();
  return dayOfMonth;
}

var getDay$1 = {};

getDay$1.getDay = getDay;
var _index$83 = toDate$1;

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of week, 0 represents Sunday
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(date) {
  const _date = (0, _index$83.toDate)(date);
  const day = _date.getDay();
  return day;
}

var getDaysInMonth$1 = {};

getDaysInMonth$1.getDaysInMonth = getDaysInMonth;
var _index$82 = toDate$1;
var _index2$3v = constructFrom$1;

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(date) {
  const _date = (0, _index$82.toDate)(date);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = (0, _index2$3v.constructFrom)(date, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

var getDaysInYear$1 = {};

var isLeapYear$1 = {};

isLeapYear$1.isLeapYear = isLeapYear;
var _index$81 = toDate$1;

/**
 * @name isLeapYear
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * const result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear(date) {
  const _date = (0, _index$81.toDate)(date);
  const year = _date.getFullYear();
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

getDaysInYear$1.getDaysInYear = getDaysInYear;
var _index$80 = isLeapYear$1;
var _index2$3u = toDate$1;

/**
 * @name getDaysInYear
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * const result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear(date) {
  const _date = (0, _index2$3u.toDate)(date);

  if (String(new Date(_date)) === "Invalid Date") {
    return NaN;
  }

  return (0, _index$80.isLeapYear)(_date) ? 366 : 365;
}

var getDecade$1 = {};

getDecade$1.getDecade = getDecade;
var _index$7$ = toDate$1;

/**
 * @name getDecade
 * @category Decade Helpers
 * @summary Get the decade of the given date.
 *
 * @description
 * Get the decade of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year of decade
 *
 * @example
 * // Which decade belongs 27 November 1942?
 * const result = getDecade(new Date(1942, 10, 27))
 * //=> 1940
 */
function getDecade(date) {
  // TODO: Switch to more technical definition in of decades that start with 1
  // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
  // change, so it can only be done in 4.0.
  const _date = (0, _index$7$.toDate)(date);
  const year = _date.getFullYear();
  const decade = Math.floor(year / 10) * 10;
  return decade;
}

var getDefaultOptions$1 = {};

getDefaultOptions$1.getDefaultOptions = getDefaultOptions;

var _index$7_ = defaultOptions$1;

/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */
function getDefaultOptions() {
  return Object.assign({}, (0, _index$7_.getDefaultOptions)());
}

var getHours$1 = {};

getHours$1.getHours = getHours;
var _index$7Z = toDate$1;

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(date) {
  const _date = (0, _index$7Z.toDate)(date);
  const hours = _date.getHours();
  return hours;
}

var getISODay$1 = {};

getISODay$1.getISODay = getISODay;
var _index$7Y = toDate$1;

/**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay(date) {
  const _date = (0, _index$7Y.toDate)(date);
  let day = _date.getDay();

  if (day === 0) {
    day = 7;
  }

  return day;
}

var getISOWeeksInYear$1 = {};

getISOWeeksInYear$1.getISOWeeksInYear = getISOWeeksInYear;
var _index$7X = addWeeks$1;
var _index2$3t = constants$1;
var _index3$1L = startOfISOWeekYear$1;

/**
 * @name getISOWeeksInYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear(date) {
  const thisYear = (0, _index3$1L.startOfISOWeekYear)(date);
  const nextYear = (0, _index3$1L.startOfISOWeekYear)(
    (0, _index$7X.addWeeks)(thisYear, 60),
  );
  const diff = +nextYear - +thisYear;

  // Round the number of weeks to the nearest integer because the number of
  // milliseconds in a week is not constant (e.g. it's different in the week of
  // the daylight saving time clock shift).
  return Math.round(diff / _index2$3t.millisecondsInWeek);
}

var getMilliseconds$1 = {};

getMilliseconds$1.getMilliseconds = getMilliseconds;
var _index$7W = toDate$1;

/**
 * @name getMilliseconds
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds(date) {
  const _date = (0, _index$7W.toDate)(date);
  const milliseconds = _date.getMilliseconds();
  return milliseconds;
}

var getMinutes$1 = {};

getMinutes$1.getMinutes = getMinutes;
var _index$7V = toDate$1;

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(date) {
  const _date = (0, _index$7V.toDate)(date);
  const minutes = _date.getMinutes();
  return minutes;
}

var getMonth$1 = {};

getMonth$1.getMonth = getMonth;
var _index$7U = toDate$1;

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The month index (0-11)
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(date) {
  const _date = (0, _index$7U.toDate)(date);
  const month = _date.getMonth();
  return month;
}

var getOverlappingDaysInIntervals$1 = {};

getOverlappingDaysInIntervals$1.getOverlappingDaysInIntervals = getOverlappingDaysInIntervals;
var _index$7T = getTimezoneOffsetInMilliseconds$1;
var _index2$3s = constants$1;
var _index3$1K = toDate$1;

/**
 * @name getOverlappingDaysInIntervals
 * @category Interval Helpers
 * @summary Get the number of days that overlap in two time intervals
 *
 * @description
 * Get the number of days that overlap in two time intervals. It uses the time
 * between dates to calculate the number of days, rounding it up to include
 * partial days.
 *
 * Two equal 0-length intervals will result in 0. Two equal 1ms intervals will
 * result in 1.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param intervalLeft - The first interval to compare.
 * @param intervalRight - The second interval to compare.
 *
 * @returns The number of days that overlap in two time intervals
 *
 * @example
 * // For overlapping time intervals adds 1 for each started overlapping day:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping time intervals returns 0:
 * getOverlappingDaysInIntervals(
 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
 * )
 * //=> 0
 */

function getOverlappingDaysInIntervals(intervalLeft, intervalRight) {
  const [leftStart, leftEnd] = [
    +(0, _index3$1K.toDate)(intervalLeft.start),
    +(0, _index3$1K.toDate)(intervalLeft.end),
  ].sort((a, b) => a - b);
  const [rightStart, rightEnd] = [
    +(0, _index3$1K.toDate)(intervalRight.start),
    +(0, _index3$1K.toDate)(intervalRight.end),
  ].sort((a, b) => a - b);

  // Prevent NaN result if intervals don't overlap at all.
  const isOverlapping = leftStart < rightEnd && rightStart < leftEnd;
  if (!isOverlapping) return 0;

  // Remove the timezone offset to negate the DST effect on calculations.
  const overlapLeft = rightStart < leftStart ? leftStart : rightStart;
  const left =
    overlapLeft - (0, _index$7T.getTimezoneOffsetInMilliseconds)(overlapLeft);
  const overlapRight = rightEnd > leftEnd ? leftEnd : rightEnd;
  const right =
    overlapRight - (0, _index$7T.getTimezoneOffsetInMilliseconds)(overlapRight);

  // Ceil the number to include partial days too.
  return Math.ceil((right - left) / _index2$3s.millisecondsInDay);
}

var getSeconds$1 = {};

getSeconds$1.getSeconds = getSeconds;
var _index$7S = toDate$1;

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(date) {
  const _date = (0, _index$7S.toDate)(date);
  const seconds = _date.getSeconds();
  return seconds;
}

var getTime$1 = {};

getTime$1.getTime = getTime;
var _index$7R = toDate$1;

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(date) {
  const _date = (0, _index$7R.toDate)(date);
  const timestamp = _date.getTime();
  return timestamp;
}

var getUnixTime$1 = {};

getUnixTime$1.getUnixTime = getUnixTime;
var _index$7Q = toDate$1;

/**
 * @name getUnixTime
 * @category Timestamp Helpers
 * @summary Get the seconds timestamp of the given date.
 *
 * @description
 * Get the seconds timestamp of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05 CET:
 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 1330512305
 */
function getUnixTime(date) {
  return Math.trunc(+(0, _index$7Q.toDate)(date) / 1000);
}

var getWeekOfMonth$1 = {};

getWeekOfMonth$1.getWeekOfMonth = getWeekOfMonth;
var _index$7P = getDate$1;
var _index2$3r = getDay$1;
var _index3$1J = startOfMonth$1;

var _index4$1x = defaultOptions$1;

/**
 * The {@link getWeekOfMonth} function options.
 */

/**
 * @name getWeekOfMonth
 * @category Week Helpers
 * @summary Get the week of the month of the given date.
 *
 * @description
 * Get the week of the month of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The week of month
 *
 * @example
 * // Which week of the month is 9 November 2017?
 * const result = getWeekOfMonth(new Date(2017, 10, 9))
 * //=> 2
 */
function getWeekOfMonth(date, options) {
  const defaultOptions = (0, _index4$1x.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const currentDayOfMonth = (0, _index$7P.getDate)(date);
  if (isNaN(currentDayOfMonth)) return NaN;

  const startWeekDay = (0, _index2$3r.getDay)((0, _index3$1J.startOfMonth)(date));

  let lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;

  const remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

var getWeeksInMonth$1 = {};

var lastDayOfMonth$1 = {};

lastDayOfMonth$1.lastDayOfMonth = lastDayOfMonth;
var _index$7O = toDate$1;

/**
 * @name lastDayOfMonth
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth(date) {
  const _date = (0, _index$7O.toDate)(date);
  const month = _date.getMonth();
  _date.setFullYear(_date.getFullYear(), month + 1, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

getWeeksInMonth$1.getWeeksInMonth = getWeeksInMonth;
var _index$7N = differenceInCalendarWeeks$1;
var _index2$3q = lastDayOfMonth$1;
var _index3$1I = startOfMonth$1;

/**
 * The {@link getWeeksInMonth} function options.
 */

/**
 * @name getWeeksInMonth
 * @category Week Helpers
 * @summary Get the number of calendar weeks a month spans.
 *
 * @description
 * Get the number of calendar weeks the month in the given date spans.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The number of calendar weeks
 *
 * @example
 * // How many calendar weeks does February 2015 span?
 * const result = getWeeksInMonth(new Date(2015, 1, 8))
 * //=> 4
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks does July 2017 span?
 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
 * //=> 6
 */
function getWeeksInMonth(date, options) {
  return (
    (0, _index$7N.differenceInCalendarWeeks)(
      (0, _index2$3q.lastDayOfMonth)(date),
      (0, _index3$1I.startOfMonth)(date),
      options,
    ) + 1
  );
}

var getYear$1 = {};

getYear$1.getYear = getYear;
var _index$7M = toDate$1;

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The year
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(date) {
  return (0, _index$7M.toDate)(date).getFullYear();
}

var hoursToMilliseconds$1 = {};

hoursToMilliseconds$1.hoursToMilliseconds = hoursToMilliseconds;
var _index$7L = constants$1;

/**
 * @name hoursToMilliseconds
 * @category  Conversion Helpers
 * @summary Convert hours to milliseconds.
 *
 * @description
 * Convert a number of hours to a full number of milliseconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted to milliseconds
 *
 * @example
 * // Convert 2 hours to milliseconds:
 * const result = hoursToMilliseconds(2)
 * //=> 7200000
 */
function hoursToMilliseconds(hours) {
  return Math.trunc(hours * _index$7L.millisecondsInHour);
}

var hoursToMinutes$1 = {};

hoursToMinutes$1.hoursToMinutes = hoursToMinutes;
var _index$7K = constants$1;

/**
 * @name hoursToMinutes
 * @category Conversion Helpers
 * @summary Convert hours to minutes.
 *
 * @description
 * Convert a number of hours to a full number of minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - number of hours to be converted
 *
 * @returns The number of hours converted in minutes
 *
 * @example
 * // Convert 2 hours to minutes:
 * const result = hoursToMinutes(2)
 * //=> 120
 */
function hoursToMinutes(hours) {
  return Math.trunc(hours * _index$7K.minutesInHour);
}

var hoursToSeconds$1 = {};

hoursToSeconds$1.hoursToSeconds = hoursToSeconds;
var _index$7J = constants$1;

/**
 * @name hoursToSeconds
 * @category Conversion Helpers
 * @summary Convert hours to seconds.
 *
 * @description
 * Convert a number of hours to a full number of seconds.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param hours - The number of hours to be converted
 *
 * @returns The number of hours converted in seconds
 *
 * @example
 * // Convert 2 hours to seconds:
 * const result = hoursToSeconds(2)
 * //=> 7200
 */
function hoursToSeconds(hours) {
  return Math.trunc(hours * _index$7J.secondsInHour);
}

var interval$1 = {};

interval$1.interval = interval;
var _index$7I = toDate$1;

/**
 * The {@link interval} function options.
 */

/**
 * @name interval
 * @category Interval Helpers
 * @summary Creates an interval object and validates its values.
 *
 * @description
 * Creates a normalized interval object and validates its values. If the interval is invalid, an exception is thrown.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param start - The start of the interval.
 * @param end - The end of the interval.
 * @param options - The options object.
 *
 * @throws `Start date is invalid` when `start` is invalid.
 * @throws `End date is invalid` when `end` is invalid.
 * @throws `End date must be after start date` when end is before `start` and `options.assertPositive` is true.
 *
 * @returns The normalized and validated interval object.
 */
function interval(start, end, options) {
  const _start = (0, _index$7I.toDate)(start);
  if (isNaN(+_start)) throw new TypeError("Start date is invalid");

  const _end = (0, _index$7I.toDate)(end);
  if (isNaN(+_end)) throw new TypeError("End date is invalid");

  if (options?.assertPositive && +_start > +_end)
    throw new TypeError("End date must be after start date");

  return { start: _start, end: _end };
}

var intervalToDuration$1 = {};

intervalToDuration$1.intervalToDuration = intervalToDuration;
var _index$7H = add$1;
var _index2$3p = differenceInDays$1;
var _index3$1H = differenceInHours$1;
var _index4$1w = differenceInMinutes$1;
var _index5$1w = differenceInMonths$1;
var _index6$1 = differenceInSeconds$1;
var _index7$1 = differenceInYears$1;
var _index8$1 = toDate$1;

/**
 * @name intervalToDuration
 * @category Common Helpers
 * @summary Convert interval to duration
 *
 * @description
 * Convert a interval object to a duration object.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param interval - The interval to convert to duration
 *
 * @returns The duration object
 *
 * @example
 * // Get the duration between January 15, 1929 and April 4, 1968.
 * intervalToDuration({
 *   start: new Date(1929, 0, 15, 12, 0, 0),
 *   end: new Date(1968, 3, 4, 19, 5, 0)
 * })
 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
 */
function intervalToDuration(interval) {
  const start = (0, _index8$1.toDate)(interval.start);
  const end = (0, _index8$1.toDate)(interval.end);

  const duration = {};

  const years = (0, _index7$1.differenceInYears)(end, start);
  if (years) duration.years = years;

  const remainingMonths = (0, _index$7H.add)(start, { years: duration.years });

  const months = (0, _index5$1w.differenceInMonths)(end, remainingMonths);
  if (months) duration.months = months;

  const remainingDays = (0, _index$7H.add)(remainingMonths, {
    months: duration.months,
  });

  const days = (0, _index2$3p.differenceInDays)(end, remainingDays);
  if (days) duration.days = days;

  const remainingHours = (0, _index$7H.add)(remainingDays, {
    days: duration.days,
  });

  const hours = (0, _index3$1H.differenceInHours)(end, remainingHours);
  if (hours) duration.hours = hours;

  const remainingMinutes = (0, _index$7H.add)(remainingHours, {
    hours: duration.hours,
  });

  const minutes = (0, _index4$1w.differenceInMinutes)(end, remainingMinutes);
  if (minutes) duration.minutes = minutes;

  const remainingSeconds = (0, _index$7H.add)(remainingMinutes, {
    minutes: duration.minutes,
  });

  const seconds = (0, _index6$1.differenceInSeconds)(end, remainingSeconds);
  if (seconds) duration.seconds = seconds;

  return duration;
}

var intlFormat$1 = {};

intlFormat$1.intlFormat = intlFormat;
var _index$7G = toDate$1;

/**
 * The locale string (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument).
 */

/**
 * The format options (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options)
 */

/**
 * The locale options.
 */

/**
 * @name intlFormat
 * @category Common Helpers
 * @summary Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
 *
 * @description
 * Return the formatted date string in the given format.
 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
 *
 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in middle-endian format:
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
 * //=> 10/4/2019
 */

/**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in Korean.
 * // Convert the date with locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   locale: 'ko-KR',
 * })
 * //=> 2019. 10. 4.
 */

/**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019.
 * // Convert the date with format's options.
 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   year: 'numeric',
 *   month: 'numeric',
 *   day: 'numeric',
 *   hour: 'numeric',
 * })
 * //=> 10/4/2019, 12 PM
 */

/**
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to format
 * @param formatOptions - The format options
 * @param localeOptions - An object with locale
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 *
 * @example
 * // Represent 4 October 2019 in German.
 * // Convert the date with format's options and locale's options.
 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
 *   weekday: 'long',
 *   year: 'numeric',
 *   month: 'long',
 *   day: 'numeric',
 * }, {
 *   locale: 'de-DE',
 * })
 * //=> Freitag, 4. Oktober 2019
 */

function intlFormat(date, formatOrLocale, localeOptions) {
  let formatOptions;

  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }

  return new Intl.DateTimeFormat(localeOptions?.locale, formatOptions).format(
    (0, _index$7G.toDate)(date),
  );
}

function isFormatOptions(opts) {
  return opts !== undefined && !("locale" in opts);
}

var intlFormatDistance$1 = {};

intlFormatDistance$1.intlFormatDistance = intlFormatDistance;
var _index$7F = constants$1;

var _index2$3o = differenceInCalendarDays$1;
var _index3$1G = differenceInCalendarMonths$1;
var _index4$1v = differenceInCalendarQuarters$1;
var _index5$1v = differenceInCalendarWeeks$1;
var _index6 = differenceInCalendarYears$1;
var _index7 = differenceInHours$1;
var _index8 = differenceInMinutes$1;
var _index9 = differenceInSeconds$1;
var _index10 = toDate$1;

/**
 * The {@link intlFormatDistance} function options.
 */

/**
 * The unit used to format the distance in {@link intlFormatDistance}.
 */

/**
 * @name intlFormatDistance
 * @category Common Helpers
 * @summary Formats distance between two dates in a human-readable format
 * @description
 * The function calculates the difference between two dates and formats it as a human-readable string.
 *
 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
 *
 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
 *
 * See the table below for the unit picking logic:
 *
 * | Distance between dates | Result (past)  | Result (future) |
 * | ---------------------- | -------------- | --------------- |
 * | 0 seconds              | now            | now             |
 * | 1-59 seconds           | X seconds ago  | in X seconds    |
 * | 1-59 minutes           | X minutes ago  | in X minutes    |
 * | 1-23 hours             | X hours ago    | in X hours      |
 * | 1 day                  | yesterday      | tomorrow        |
 * | 2-6 days               | X days ago     | in X days       |
 * | 7 days                 | last week      | next week       |
 * | 8 days-1 month         | X weeks ago    | in X weeks      |
 * | 1 month                | last month     | next month      |
 * | 2-3 months             | X months ago   | in X months     |
 * | 1 quarter              | last quarter   | next quarter    |
 * | 2-3 quarters           | X quarters ago | in X quarters   |
 * | 1 year                 | last year      | next year       |
 * | 2+ years               | X years ago    | in X years      |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date
 * @param baseDate - The date to compare with.
 * @param options - An object with options.
 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
 * The narrow one could be similar to the short one for some locales.
 *
 * @returns The distance in words according to language-sensitive relative time formatting.
 *
 * @throws `date` must not be Invalid Date
 * @throws `baseDate` must not be Invalid Date
 * @throws `options.unit` must not be invalid Unit
 * @throws `options.locale` must not be invalid locale
 * @throws `options.localeMatcher` must not be invalid localeMatcher
 * @throws `options.numeric` must not be invalid numeric
 * @throws `options.style` must not be invalid style
 *
 * @example
 * // What is the distance between the dates when the fist date is after the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0)
 * )
 * //=> 'in 1 hour'
 *
 * // What is the distance between the dates when the fist date is before the second?
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0)
 * )
 * //=> '1 hour ago'
 *
 * @example
 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
 * intlFormatDistance(
 *   new Date(1987, 6, 4, 10, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { unit: 'quarter' }
 * )
 * //=> 'in 5 quarters'
 *
 * @example
 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
 * intlFormatDistance(
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 10, 30, 0),
 *   { locale: 'es' }
 * )
 * //=> 'dentro de 1 hora'
 *
 * @example
 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
 * intlFormatDistance(
 *   new Date(1986, 3, 5, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { numeric: 'always' }
 * )
 * //=> 'in 1 day'
 *
 * @example
 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
 * intlFormatDistance(
 *   new Date(1988, 3, 4, 11, 30, 0),
 *   new Date(1986, 3, 4, 11, 30, 0),
 *   { style: 'short' }
 * )
 * //=> 'in 2 yr'
 */
function intlFormatDistance(date, baseDate, options) {
  let value = 0;
  let unit;
  const dateLeft = (0, _index10.toDate)(date);
  const dateRight = (0, _index10.toDate)(baseDate);

  if (!options?.unit) {
    // Get the unit based on diffInSeconds calculations if no unit is specified
    const diffInSeconds = (0, _index9.differenceInSeconds)(dateLeft, dateRight); // The smallest unit

    if (Math.abs(diffInSeconds) < _index$7F.secondsInMinute) {
      value = (0, _index9.differenceInSeconds)(dateLeft, dateRight);
      unit = "second";
    } else if (Math.abs(diffInSeconds) < _index$7F.secondsInHour) {
      value = (0, _index8.differenceInMinutes)(dateLeft, dateRight);
      unit = "minute";
    } else if (
      Math.abs(diffInSeconds) < _index$7F.secondsInDay &&
      Math.abs((0, _index2$3o.differenceInCalendarDays)(dateLeft, dateRight)) < 1
    ) {
      value = (0, _index7.differenceInHours)(dateLeft, dateRight);
      unit = "hour";
    } else if (
      Math.abs(diffInSeconds) < _index$7F.secondsInWeek &&
      (value = (0, _index2$3o.differenceInCalendarDays)(dateLeft, dateRight)) &&
      Math.abs(value) < 7
    ) {
      unit = "day";
    } else if (Math.abs(diffInSeconds) < _index$7F.secondsInMonth) {
      value = (0, _index5$1v.differenceInCalendarWeeks)(dateLeft, dateRight);
      unit = "week";
    } else if (Math.abs(diffInSeconds) < _index$7F.secondsInQuarter) {
      value = (0, _index3$1G.differenceInCalendarMonths)(dateLeft, dateRight);
      unit = "month";
    } else if (Math.abs(diffInSeconds) < _index$7F.secondsInYear) {
      if ((0, _index4$1v.differenceInCalendarQuarters)(dateLeft, dateRight) < 4) {
        // To filter out cases that are less than a year but match 4 quarters
        value = (0, _index4$1v.differenceInCalendarQuarters)(dateLeft, dateRight);
        unit = "quarter";
      } else {
        value = (0, _index6.differenceInCalendarYears)(dateLeft, dateRight);
        unit = "year";
      }
    } else {
      value = (0, _index6.differenceInCalendarYears)(dateLeft, dateRight);
      unit = "year";
    }
  } else {
    // Get the value if unit is specified
    unit = options?.unit;
    if (unit === "second") {
      value = (0, _index9.differenceInSeconds)(dateLeft, dateRight);
    } else if (unit === "minute") {
      value = (0, _index8.differenceInMinutes)(dateLeft, dateRight);
    } else if (unit === "hour") {
      value = (0, _index7.differenceInHours)(dateLeft, dateRight);
    } else if (unit === "day") {
      value = (0, _index2$3o.differenceInCalendarDays)(dateLeft, dateRight);
    } else if (unit === "week") {
      value = (0, _index5$1v.differenceInCalendarWeeks)(dateLeft, dateRight);
    } else if (unit === "month") {
      value = (0, _index3$1G.differenceInCalendarMonths)(dateLeft, dateRight);
    } else if (unit === "quarter") {
      value = (0, _index4$1v.differenceInCalendarQuarters)(dateLeft, dateRight);
    } else if (unit === "year") {
      value = (0, _index6.differenceInCalendarYears)(dateLeft, dateRight);
    }
  }

  const rtf = new Intl.RelativeTimeFormat(options?.locale, {
    localeMatcher: options?.localeMatcher,
    numeric: options?.numeric || "auto",
    style: options?.style,
  });

  return rtf.format(value, unit);
}

var isAfter$1 = {};

isAfter$1.isAfter = isAfter;
var _index$7E = toDate$1;

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be after the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(date, dateToCompare) {
  const _date = (0, _index$7E.toDate)(date);
  const _dateToCompare = (0, _index$7E.toDate)(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}

var isBefore$1 = {};

isBefore$1.isBefore = isBefore;
var _index$7D = toDate$1;

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(date, dateToCompare) {
  const _date = (0, _index$7D.toDate)(date);
  const _dateToCompare = (0, _index$7D.toDate)(dateToCompare);
  return +_date < +_dateToCompare;
}

var isEqual$1 = {};

isEqual$1.isEqual = isEqual;
var _index$7C = toDate$1;

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to compare
 * @param dateRight - The second date to compare
 *
 * @returns The dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(leftDate, rightDate) {
  const _dateLeft = (0, _index$7C.toDate)(leftDate);
  const _dateRight = (0, _index$7C.toDate)(rightDate);
  return +_dateLeft === +_dateRight;
}

var isExists$1 = {};

isExists$1.isExists = isExists; /**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param year - The year of the date to check
 * @param month - The month of the date to check
 * @param day - The day of the date to check
 *
 * @returns `true` if the date exists
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */
function isExists(year, month, day) {
  const date = new Date(year, month, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month &&
    date.getDate() === day
  );
}

var isFirstDayOfMonth$1 = {};

isFirstDayOfMonth$1.isFirstDayOfMonth = isFirstDayOfMonth;
var _index$7B = toDate$1;

/**
 * @name isFirstDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check

 * @returns The date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth(date) {
  return (0, _index$7B.toDate)(date).getDate() === 1;
}

var isFriday$1 = {};

isFriday$1.isFriday = isFriday;
var _index$7A = toDate$1;

/**
 * @name isFriday
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * const result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday(date) {
  return (0, _index$7A.toDate)(date).getDay() === 5;
}

var isFuture$1 = {};

isFuture$1.isFuture = isFuture;
var _index$7z = toDate$1;

/**
 * @name isFuture
 * @category Common Helpers
 * @summary Is the given date in the future?
 * @pure false
 *
 * @description
 * Is the given date in the future?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * const result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture(date) {
  return +(0, _index$7z.toDate)(date) > Date.now();
}

var isMatch$1 = {};

var parse$1 = {};

var parsers = {};

var EraParser$1 = {};

var Parser$1 = {};

var Setter$1 = {};

var transpose$1 = {};

transpose$1.transpose = transpose;
var _index$7y = constructFrom$1;

/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam DateInputType - The input `Date` type derived from the passed argument.
 * @typeParam DateOutputType - The output `Date` type derived from the passed constructor.
 *
 * @param fromDate - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */
function transpose(fromDate, constructor) {
  const date =
    constructor instanceof Date
      ? (0, _index$7y.constructFrom)(constructor, 0)
      : new constructor(0);
  date.setFullYear(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate(),
  );
  date.setHours(
    fromDate.getHours(),
    fromDate.getMinutes(),
    fromDate.getSeconds(),
    fromDate.getMilliseconds(),
  );
  return date;
}

Setter$1.ValueSetter =
  Setter$1.Setter =
  Setter$1.DateToSystemTimezoneSetter =
    void 0;
var _index$7x = transpose$1;
var _index2$3n = constructFrom$1;

const TIMEZONE_UNIT_PRIORITY = 10;

class Setter {
  subPriority = 0;

  validate(_utcDate, _options) {
    return true;
  }
}
Setter$1.Setter = Setter;

class ValueSetter extends Setter {
  constructor(
    value,

    validateValue,

    setValue,

    priority,
    subPriority,
  ) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }

  validate(date, options) {
    return this.validateValue(date, this.value, options);
  }

  set(date, flags, options) {
    return this.setValue(date, flags, this.value, options);
  }
}
Setter$1.ValueSetter = ValueSetter;

class DateToSystemTimezoneSetter extends Setter {
  priority = TIMEZONE_UNIT_PRIORITY;
  subPriority = -1;
  set(date, flags) {
    if (flags.timestampIsSet) return date;
    return (0, _index2$3n.constructFrom)(date, (0, _index$7x.transpose)(date, Date));
  }
}
Setter$1.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter;

Parser$1.Parser = void 0;
var _Setter = Setter$1;

class Parser {
  run(dateString, token, match, options) {
    const result = this.parse(dateString, token, match, options);
    if (!result) {
      return null;
    }

    return {
      setter: new _Setter.ValueSetter(
        result.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority,
      ),
      rest: result.rest,
    };
  }

  validate(_utcDate, _value, _options) {
    return true;
  }
}
Parser$1.Parser = Parser;

EraParser$1.EraParser = void 0;

var _Parser$u = Parser$1;

class EraParser extends _Parser$u.Parser {
  priority = 140;

  parse(dateString, token, match) {
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return (
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );

      // A, B
      case "GGGGG":
        return match.era(dateString, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return (
          match.era(dateString, { width: "wide" }) ||
          match.era(dateString, { width: "abbreviated" }) ||
          match.era(dateString, { width: "narrow" })
        );
    }
  }

  set(date, flags, value) {
    flags.era = value;
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["R", "u", "t", "T"];
}
EraParser$1.EraParser = EraParser;

var YearParser$1 = {};

var utils$2 = {};

var constants = {};

constants.timezonePatterns = constants.numericPatterns = void 0;
(constants.numericPatterns = {
  month: /^(1[0-2]|0?\d)/, // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/, // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/, // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/, // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/, // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/, // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/, // 0 to 12
  minute: /^[0-5]?\d/, // 0 to 59
  second: /^[0-5]?\d/, // 0 to 59

  singleDigit: /^\d/, // 0 to 9
  twoDigits: /^\d{1,2}/, // 0 to 99
  threeDigits: /^\d{1,3}/, // 0 to 999
  fourDigits: /^\d{1,4}/, // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/, // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/, // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/, // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/, // 0 to 9999, -0 to -9999
});

(constants.timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/,
});

utils$2.dayPeriodEnumToHours = dayPeriodEnumToHours;
utils$2.isLeapYearIndex = isLeapYearIndex$1;
utils$2.mapValue = mapValue;
utils$2.normalizeTwoDigitYear = normalizeTwoDigitYear;
utils$2.parseAnyDigitsSigned = parseAnyDigitsSigned;
utils$2.parseNDigits = parseNDigits;
utils$2.parseNDigitsSigned = parseNDigitsSigned;
utils$2.parseNumericPattern = parseNumericPattern;
utils$2.parseTimezonePattern = parseTimezonePattern;
var _index$7w = constants$1;

var _constants$e = constants;

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }

  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest,
  };
}

function parseNumericPattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseTimezonePattern(pattern, dateString) {
  const matchResult = dateString.match(pattern);

  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1),
    };
  }

  const sign = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;

  return {
    value:
      sign *
      (hours * _index$7w.millisecondsInHour +
        minutes * _index$7w.millisecondsInMinute +
        seconds * _index$7w.millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length),
  };
}

function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(
    _constants$e.numericPatterns.anyDigitsSigned,
    dateString,
  );
}

function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(
        _constants$e.numericPatterns.singleDigit,
        dateString,
      );
    case 2:
      return parseNumericPattern(
        _constants$e.numericPatterns.twoDigits,
        dateString,
      );
    case 3:
      return parseNumericPattern(
        _constants$e.numericPatterns.threeDigits,
        dateString,
      );
    case 4:
      return parseNumericPattern(
        _constants$e.numericPatterns.fourDigits,
        dateString,
      );
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}

function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(
        _constants$e.numericPatterns.singleDigitSigned,
        dateString,
      );
    case 2:
      return parseNumericPattern(
        _constants$e.numericPatterns.twoDigitsSigned,
        dateString,
      );
    case 3:
      return parseNumericPattern(
        _constants$e.numericPatterns.threeDigitsSigned,
        dateString,
      );
    case 4:
      return parseNumericPattern(
        _constants$e.numericPatterns.fourDigitsSigned,
        dateString,
      );
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}

function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;

  let result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

function isLeapYearIndex$1(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

YearParser$1.YearParser = void 0;
var _Parser$t = Parser$1;

var _utils$t = utils$2;

// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
class YearParser extends _Parser$t.Parser {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "yy",
    });

    switch (token) {
      case "y":
        return (0, _utils$t.mapValue)(
          (0, _utils$t.parseNDigits)(4, dateString),
          valueCallback,
        );
      case "yo":
        return (0, _utils$t.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return (0, _utils$t.mapValue)(
          (0, _utils$t.parseNDigits)(token.length, dateString),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value) {
    const currentYear = date.getFullYear();

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = (0, _utils$t.normalizeTwoDigitYear)(
        value.year,
        currentYear,
      );
      date.setFullYear(normalizedTwoDigitYear, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
YearParser$1.YearParser = YearParser;

var LocalWeekYearParser$1 = {};

LocalWeekYearParser$1.LocalWeekYearParser = void 0;
var _index$7v = getWeekYear$1;

var _index2$3m = startOfWeek$1;
var _Parser$s = Parser$1;

var _utils$s = utils$2;

// Local week-numbering year
class LocalWeekYearParser extends _Parser$s.Parser {
  priority = 130;

  parse(dateString, token, match) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "YY",
    });

    switch (token) {
      case "Y":
        return (0, _utils$s.mapValue)(
          (0, _utils$s.parseNDigits)(4, dateString),
          valueCallback,
        );
      case "Yo":
        return (0, _utils$s.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "year",
          }),
          valueCallback,
        );
      default:
        return (0, _utils$s.mapValue)(
          (0, _utils$s.parseNDigits)(token.length, dateString),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }

  set(date, flags, value, options) {
    const currentYear = (0, _index$7v.getWeekYear)(date, options);

    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = (0, _utils$s.normalizeTwoDigitYear)(
        value.year,
        currentYear,
      );
      date.setFullYear(
        normalizedTwoDigitYear,
        0,
        options.firstWeekContainsDate,
      );
      date.setHours(0, 0, 0, 0);
      return (0, _index2$3m.startOfWeek)(date, options);
    }

    const year =
      !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date.setFullYear(year, 0, options.firstWeekContainsDate);
    date.setHours(0, 0, 0, 0);
    return (0, _index2$3m.startOfWeek)(date, options);
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}
LocalWeekYearParser$1.LocalWeekYearParser = LocalWeekYearParser;

var ISOWeekYearParser$1 = {};

ISOWeekYearParser$1.ISOWeekYearParser = void 0;
var _index$7u = startOfISOWeek$1;
var _index2$3l = constructFrom$1;
var _Parser$r = Parser$1;

var _utils$r = utils$2;

// ISO week-numbering year
class ISOWeekYearParser extends _Parser$r.Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "R") {
      return (0, _utils$r.parseNDigitsSigned)(4, dateString);
    }

    return (0, _utils$r.parseNDigitsSigned)(token.length, dateString);
  }

  set(date, _flags, value) {
    const firstWeekOfYear = (0, _index2$3l.constructFrom)(date, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return (0, _index$7u.startOfISOWeek)(firstWeekOfYear);
  }

  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}
ISOWeekYearParser$1.ISOWeekYearParser = ISOWeekYearParser;

var ExtendedYearParser$1 = {};

ExtendedYearParser$1.ExtendedYearParser = void 0;
var _Parser$q = Parser$1;

var _utils$q = utils$2;

class ExtendedYearParser extends _Parser$q.Parser {
  priority = 130;

  parse(dateString, token) {
    if (token === "u") {
      return (0, _utils$q.parseNDigitsSigned)(4, dateString);
    }

    return (0, _utils$q.parseNDigitsSigned)(token.length, dateString);
  }

  set(date, _flags, value) {
    date.setFullYear(value, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
ExtendedYearParser$1.ExtendedYearParser = ExtendedYearParser;

var QuarterParser$1 = {};

QuarterParser$1.QuarterParser = void 0;
var _Parser$p = Parser$1;

var _utils$p = utils$2;

class QuarterParser extends _Parser$p.Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ": // 01, 02, 03, 04
        return (0, _utils$p.parseNDigits)(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return match.quarter(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
QuarterParser$1.QuarterParser = QuarterParser;

var StandAloneQuarterParser$1 = {};

StandAloneQuarterParser$1.StandAloneQuarterParser = void 0;
var _Parser$o = Parser$1;

var _utils$o = utils$2;

class StandAloneQuarterParser extends _Parser$o.Parser {
  priority = 120;

  parse(dateString, token, match) {
    switch (token) {
      // 1, 2, 3, 4
      case "q":
      case "qq": // 01, 02, 03, 04
        return (0, _utils$o.parseNDigits)(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return match.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return (
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );

      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return match.quarter(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return (
          match.quarter(dateString, {
            width: "wide",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.quarter(dateString, {
            width: "narrow",
            context: "standalone",
          })
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 4;
  }

  set(date, _flags, value) {
    date.setMonth((value - 1) * 3, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
StandAloneQuarterParser$1.StandAloneQuarterParser = StandAloneQuarterParser;

var MonthParser$1 = {};

MonthParser$1.MonthParser = void 0;
var _constants$d = constants;
var _Parser$n = Parser$1;

var _utils$n = utils$2;

class MonthParser extends _Parser$n.Parser {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];

  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "M":
        return (0, _utils$n.mapValue)(
          (0, _utils$n.parseNumericPattern)(
            _constants$d.numericPatterns.month,
            dateString,
          ),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "MM":
        return (0, _utils$n.mapValue)(
          (0, _utils$n.parseNDigits)(2, dateString),
          valueCallback,
        );
      // 1st, 2nd, ..., 12th
      case "Mo":
        return (0, _utils$n.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );

      // J, F, ..., D
      case "MMMMM":
        return match.month(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return (
          match.month(dateString, { width: "wide", context: "formatting" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.month(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }
}
MonthParser$1.MonthParser = MonthParser;

var StandAloneMonthParser$1 = {};

StandAloneMonthParser$1.StandAloneMonthParser = void 0;
var _constants$c = constants;
var _Parser$m = Parser$1;

var _utils$m = utils$2;

class StandAloneMonthParser extends _Parser$m.Parser {
  priority = 110;

  parse(dateString, token, match) {
    const valueCallback = (value) => value - 1;

    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return (0, _utils$m.mapValue)(
          (0, _utils$m.parseNumericPattern)(
            _constants$c.numericPatterns.month,
            dateString,
          ),
          valueCallback,
        );
      // 01, 02, ..., 12
      case "LL":
        return (0, _utils$m.mapValue)(
          (0, _utils$m.parseNDigits)(2, dateString),
          valueCallback,
        );
      // 1st, 2nd, ..., 12th
      case "Lo":
        return (0, _utils$m.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "month",
          }),
          valueCallback,
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return (
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );

      // J, F, ..., D
      case "LLLLL":
        return match.month(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return (
          match.month(dateString, { width: "wide", context: "standalone" }) ||
          match.month(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.month(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    date.setMonth(value, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
StandAloneMonthParser$1.StandAloneMonthParser = StandAloneMonthParser;

var LocalWeekParser$1 = {};

var setWeek$1 = {};

setWeek$1.setWeek = setWeek;
var _index$7t = getWeek$1;
var _index2$3k = toDate$1;

/**
 * The {@link setWeek} function options.
 */

/**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */
function setWeek(date, week, options) {
  const _date = (0, _index2$3k.toDate)(date);
  const diff = (0, _index$7t.getWeek)(_date, options) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}

LocalWeekParser$1.LocalWeekParser = void 0;
var _index$7s = setWeek$1;
var _index2$3j = startOfWeek$1;
var _constants$b = constants;
var _Parser$l = Parser$1;

var _utils$l = utils$2;

// Local week of year
class LocalWeekParser extends _Parser$l.Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "w":
        return (0, _utils$l.parseNumericPattern)(
          _constants$b.numericPatterns.week,
          dateString,
        );
      case "wo":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return (0, _utils$l.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value, options) {
    return (0, _index2$3j.startOfWeek)(
      (0, _index$7s.setWeek)(date, value, options),
      options,
    );
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T",
  ];
}
LocalWeekParser$1.LocalWeekParser = LocalWeekParser;

var ISOWeekParser$1 = {};

var setISOWeek$1 = {};

setISOWeek$1.setISOWeek = setISOWeek;
var _index$7r = getISOWeek$1;
var _index2$3i = toDate$1;

/**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek(date, week) {
  const _date = (0, _index2$3i.toDate)(date);
  const diff = (0, _index$7r.getISOWeek)(_date) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}

ISOWeekParser$1.ISOWeekParser = void 0;
var _index$7q = setISOWeek$1;
var _index2$3h = startOfISOWeek$1;
var _constants$a = constants;
var _Parser$k = Parser$1;

var _utils$k = utils$2;

// ISO week of year
class ISOWeekParser extends _Parser$k.Parser {
  priority = 100;

  parse(dateString, token, match) {
    switch (token) {
      case "I":
        return (0, _utils$k.parseNumericPattern)(
          _constants$a.numericPatterns.week,
          dateString,
        );
      case "Io":
        return match.ordinalNumber(dateString, { unit: "week" });
      default:
        return (0, _utils$k.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 53;
  }

  set(date, _flags, value) {
    return (0, _index2$3h.startOfISOWeek)((0, _index$7q.setISOWeek)(date, value));
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T",
  ];
}
ISOWeekParser$1.ISOWeekParser = ISOWeekParser;

var DateParser$1 = {};

DateParser$1.DateParser = void 0;
var _constants$9 = constants;
var _Parser$j = Parser$1;

var _utils$j = utils$2;

const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR = [
  31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31,
];

// Day of the month
class DateParser extends _Parser$j.Parser {
  priority = 90;
  subPriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "d":
        return (0, _utils$j.parseNumericPattern)(
          _constants$9.numericPatterns.date,
          dateString,
        );
      case "do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return (0, _utils$j.parseNDigits)(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = (0, _utils$j.isLeapYearIndex)(year);
    const month = date.getMonth();
    if (isLeapYear) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }

  set(date, _flags, value) {
    date.setDate(value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
DateParser$1.DateParser = DateParser;

var DayOfYearParser$1 = {};

DayOfYearParser$1.DayOfYearParser = void 0;
var _constants$8 = constants;
var _Parser$i = Parser$1;

var _utils$i = utils$2;

class DayOfYearParser extends _Parser$i.Parser {
  priority = 90;

  subpriority = 1;

  parse(dateString, token, match) {
    switch (token) {
      case "D":
      case "DD":
        return (0, _utils$i.parseNumericPattern)(
          _constants$8.numericPatterns.dayOfYear,
          dateString,
        );
      case "Do":
        return match.ordinalNumber(dateString, { unit: "date" });
      default:
        return (0, _utils$i.parseNDigits)(token.length, dateString);
    }
  }

  validate(date, value) {
    const year = date.getFullYear();
    const isLeapYear = (0, _utils$i.isLeapYearIndex)(year);
    if (isLeapYear) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }

  set(date, _flags, value) {
    date.setMonth(0, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T",
  ];
}
DayOfYearParser$1.DayOfYearParser = DayOfYearParser;

var DayParser$1 = {};

var setDay$1 = {};

setDay$1.setDay = setDay;
var _index$7p = addDays$1;
var _index2$3g = toDate$1;

var _index3$1F = defaultOptions$1;

/**
 * The {@link setDay} function options.
 */

/**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay(date, day, options) {
  const defaultOptions = (0, _index3$1F.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index2$3g.toDate)(date);
  const currentDay = _date.getDay();

  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;

  const delta = 7 - weekStartsOn;
  const diff =
    day < 0 || day > 6
      ? day - ((currentDay + delta) % 7)
      : ((dayIndex + delta) % 7) - ((currentDay + delta) % 7);
  return (0, _index$7p.addDays)(_date, diff);
}

DayParser$1.DayParser = void 0;
var _index$7o = setDay$1;
var _Parser$h = Parser$1;

// Day of week
class DayParser extends _Parser$h.Parser {
  priority = 90;

  parse(dateString, token, match) {
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "EEEEE":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "EEEEEE":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "EEEE":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = (0, _index$7o.setDay)(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
DayParser$1.DayParser = DayParser;

var LocalDayParser$1 = {};

LocalDayParser$1.LocalDayParser = void 0;
var _index$7n = setDay$1;
var _Parser$g = Parser$1;

var _utils$h = utils$2;

// Local day of week
class LocalDayParser extends _Parser$g.Parser {
  priority = 90;
  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "e":
      case "ee": // 03
        return (0, _utils$h.mapValue)(
          (0, _utils$h.parseNDigits)(token.length, dateString),
          valueCallback,
        );
      // 3rd
      case "eo":
        return (0, _utils$h.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "eee":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // T
      case "eeeee":
        return match.day(dateString, {
          width: "narrow",
          context: "formatting",
        });
      // Tu
      case "eeeeee":
        return (
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );

      // Tuesday
      case "eeee":
      default:
        return (
          match.day(dateString, { width: "wide", context: "formatting" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.day(dateString, { width: "short", context: "formatting" }) ||
          match.day(dateString, { width: "narrow", context: "formatting" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = (0, _index$7n.setDay)(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T",
  ];
}
LocalDayParser$1.LocalDayParser = LocalDayParser;

var StandAloneLocalDayParser$1 = {};

StandAloneLocalDayParser$1.StandAloneLocalDayParser = void 0;
var _index$7m = setDay$1;
var _Parser$f = Parser$1;

var _utils$g = utils$2;

// Stand-alone local day of week
class StandAloneLocalDayParser extends _Parser$f.Parser {
  priority = 90;

  parse(dateString, token, match, options) {
    const valueCallback = (value) => {
      // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return ((value + options.weekStartsOn + 6) % 7) + wholeWeekDays;
    };

    switch (token) {
      // 3
      case "c":
      case "cc": // 03
        return (0, _utils$g.mapValue)(
          (0, _utils$g.parseNDigits)(token.length, dateString),
          valueCallback,
        );
      // 3rd
      case "co":
        return (0, _utils$g.mapValue)(
          match.ordinalNumber(dateString, {
            unit: "day",
          }),
          valueCallback,
        );
      // Tue
      case "ccc":
        return (
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // T
      case "ccccc":
        return match.day(dateString, {
          width: "narrow",
          context: "standalone",
        });
      // Tu
      case "cccccc":
        return (
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );

      // Tuesday
      case "cccc":
      default:
        return (
          match.day(dateString, { width: "wide", context: "standalone" }) ||
          match.day(dateString, {
            width: "abbreviated",
            context: "standalone",
          }) ||
          match.day(dateString, { width: "short", context: "standalone" }) ||
          match.day(dateString, { width: "narrow", context: "standalone" })
        );
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 6;
  }

  set(date, _flags, value, options) {
    date = (0, _index$7m.setDay)(date, value, options);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T",
  ];
}
StandAloneLocalDayParser$1.StandAloneLocalDayParser = StandAloneLocalDayParser;

var ISODayParser$1 = {};

var setISODay$1 = {};

setISODay$1.setISODay = setISODay;
var _index$7l = addDays$1;
var _index2$3f = getISODay$1;
var _index3$1E = toDate$1;

/**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay(date, day) {
  const _date = (0, _index3$1E.toDate)(date);
  const currentDay = (0, _index2$3f.getISODay)(_date);
  const diff = day - currentDay;
  return (0, _index$7l.addDays)(_date, diff);
}

ISODayParser$1.ISODayParser = void 0;
var _index$7k = setISODay$1;
var _Parser$e = Parser$1;

var _utils$f = utils$2;

// ISO day of week
class ISODayParser extends _Parser$e.Parser {
  priority = 90;

  parse(dateString, token, match) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };

    switch (token) {
      // 2
      case "i":
      case "ii": // 02
        return (0, _utils$f.parseNDigits)(token.length, dateString);
      // 2nd
      case "io":
        return match.ordinalNumber(dateString, { unit: "day" });
      // Tue
      case "iii":
        return (0, _utils$f.mapValue)(
          match.day(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // T
      case "iiiii":
        return (0, _utils$f.mapValue)(
          match.day(dateString, {
            width: "narrow",
            context: "formatting",
          }),
          valueCallback,
        );
      // Tu
      case "iiiiii":
        return (0, _utils$f.mapValue)(
          match.day(dateString, {
            width: "short",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
      // Tuesday
      case "iiii":
      default:
        return (0, _utils$f.mapValue)(
          match.day(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
            match.day(dateString, {
              width: "abbreviated",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "short",
              context: "formatting",
            }) ||
            match.day(dateString, {
              width: "narrow",
              context: "formatting",
            }),
          valueCallback,
        );
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 7;
  }

  set(date, _flags, value) {
    date = (0, _index$7k.setISODay)(date, value);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T",
  ];
}
ISODayParser$1.ISODayParser = ISODayParser;

var AMPMParser$1 = {};

AMPMParser$1.AMPMParser = void 0;
var _Parser$d = Parser$1;

var _utils$e = utils$2;

class AMPMParser extends _Parser$d.Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "aaaaa":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "aaaa":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours((0, _utils$e.dayPeriodEnumToHours)(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
AMPMParser$1.AMPMParser = AMPMParser;

var AMPMMidnightParser$1 = {};

AMPMMidnightParser$1.AMPMMidnightParser = void 0;
var _Parser$c = Parser$1;

var _utils$d = utils$2;

class AMPMMidnightParser extends _Parser$c.Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "bbbbb":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "bbbb":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours((0, _utils$d.dayPeriodEnumToHours)(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
AMPMMidnightParser$1.AMPMMidnightParser = AMPMMidnightParser;

var DayPeriodParser$1 = {};

DayPeriodParser$1.DayPeriodParser = void 0;
var _Parser$b = Parser$1;

var _utils$c = utils$2;

// in the morning, in the afternoon, in the evening, at night
class DayPeriodParser extends _Parser$b.Parser {
  priority = 80;

  parse(dateString, token, match) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return (
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );

      case "BBBBB":
        return match.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting",
        });
      case "BBBB":
      default:
        return (
          match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting",
          }) ||
          match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting",
          })
        );
    }
  }

  set(date, _flags, value) {
    date.setHours((0, _utils$c.dayPeriodEnumToHours)(value), 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "t", "T"];
}
DayPeriodParser$1.DayPeriodParser = DayPeriodParser;

var Hour1to12Parser$1 = {};

Hour1to12Parser$1.Hour1to12Parser = void 0;
var _constants$7 = constants;
var _Parser$a = Parser$1;

var _utils$b = utils$2;

class Hour1to12Parser extends _Parser$a.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "h":
        return (0, _utils$b.parseNumericPattern)(
          _constants$7.numericPatterns.hour12h,
          dateString,
        );
      case "ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils$b.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 12;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date.setHours(0, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
Hour1to12Parser$1.Hour1to12Parser = Hour1to12Parser;

var Hour0to23Parser$1 = {};

Hour0to23Parser$1.Hour0to23Parser = void 0;
var _constants$6 = constants;
var _Parser$9 = Parser$1;

var _utils$a = utils$2;

class Hour0to23Parser extends _Parser$9.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "H":
        return (0, _utils$a.parseNumericPattern)(
          _constants$6.numericPatterns.hour23h,
          dateString,
        );
      case "Ho":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils$a.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 23;
  }

  set(date, _flags, value) {
    date.setHours(value, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
Hour0to23Parser$1.Hour0to23Parser = Hour0to23Parser;

var Hour0To11Parser$1 = {};

Hour0To11Parser$1.Hour0To11Parser = void 0;
var _constants$5 = constants;
var _Parser$8 = Parser$1;

var _utils$9 = utils$2;

class Hour0To11Parser extends _Parser$8.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "K":
        return (0, _utils$9.parseNumericPattern)(
          _constants$5.numericPatterns.hour11h,
          dateString,
        );
      case "Ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils$9.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 11;
  }

  set(date, _flags, value) {
    const isPM = date.getHours() >= 12;
    if (isPM && value < 12) {
      date.setHours(value + 12, 0, 0, 0);
    } else {
      date.setHours(value, 0, 0, 0);
    }
    return date;
  }

  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
Hour0To11Parser$1.Hour0To11Parser = Hour0To11Parser;

var Hour1To24Parser$1 = {};

Hour1To24Parser$1.Hour1To24Parser = void 0;
var _constants$4 = constants;
var _Parser$7 = Parser$1;

var _utils$8 = utils$2;

class Hour1To24Parser extends _Parser$7.Parser {
  priority = 70;

  parse(dateString, token, match) {
    switch (token) {
      case "k":
        return (0, _utils$8.parseNumericPattern)(
          _constants$4.numericPatterns.hour24h,
          dateString,
        );
      case "ko":
        return match.ordinalNumber(dateString, { unit: "hour" });
      default:
        return (0, _utils$8.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 1 && value <= 24;
  }

  set(date, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date.setHours(hours, 0, 0, 0);
    return date;
  }

  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
Hour1To24Parser$1.Hour1To24Parser = Hour1To24Parser;

var MinuteParser$1 = {};

MinuteParser$1.MinuteParser = void 0;
var _constants$3 = constants;
var _Parser$6 = Parser$1;

var _utils$7 = utils$2;

class MinuteParser extends _Parser$6.Parser {
  priority = 60;

  parse(dateString, token, match) {
    switch (token) {
      case "m":
        return (0, _utils$7.parseNumericPattern)(
          _constants$3.numericPatterns.minute,
          dateString,
        );
      case "mo":
        return match.ordinalNumber(dateString, { unit: "minute" });
      default:
        return (0, _utils$7.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setMinutes(value, 0, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}
MinuteParser$1.MinuteParser = MinuteParser;

var SecondParser$1 = {};

SecondParser$1.SecondParser = void 0;
var _constants$2 = constants;
var _Parser$5 = Parser$1;

var _utils$6 = utils$2;

class SecondParser extends _Parser$5.Parser {
  priority = 50;

  parse(dateString, token, match) {
    switch (token) {
      case "s":
        return (0, _utils$6.parseNumericPattern)(
          _constants$2.numericPatterns.second,
          dateString,
        );
      case "so":
        return match.ordinalNumber(dateString, { unit: "second" });
      default:
        return (0, _utils$6.parseNDigits)(token.length, dateString);
    }
  }

  validate(_date, value) {
    return value >= 0 && value <= 59;
  }

  set(date, _flags, value) {
    date.setSeconds(value, 0);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}
SecondParser$1.SecondParser = SecondParser;

var FractionOfSecondParser$1 = {};

FractionOfSecondParser$1.FractionOfSecondParser = void 0;
var _Parser$4 = Parser$1;

var _utils$5 = utils$2;

class FractionOfSecondParser extends _Parser$4.Parser {
  priority = 30;

  parse(dateString, token) {
    const valueCallback = (value) =>
      Math.trunc(value * Math.pow(10, -token.length + 3));
    return (0, _utils$5.mapValue)(
      (0, _utils$5.parseNDigits)(token.length, dateString),
      valueCallback,
    );
  }

  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }

  incompatibleTokens = ["t", "T"];
}
FractionOfSecondParser$1.FractionOfSecondParser = FractionOfSecondParser;

var ISOTimezoneWithZParser$1 = {};

ISOTimezoneWithZParser$1.ISOTimezoneWithZParser = void 0;
var _index$7j = constructFrom$1;
var _index2$3e = getTimezoneOffsetInMilliseconds$1;
var _constants$1 = constants;
var _Parser$3 = Parser$1;

var _utils$4 = utils$2;

// Timezone (ISO-8601. +00:00 is `'Z'`)
class ISOTimezoneWithZParser extends _Parser$3.Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "X":
        return (0, _utils$4.parseTimezonePattern)(
          _constants$1.timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "XX":
        return (0, _utils$4.parseTimezonePattern)(
          _constants$1.timezonePatterns.basic,
          dateString,
        );
      case "XXXX":
        return (0, _utils$4.parseTimezonePattern)(
          _constants$1.timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "XXXXX":
        return (0, _utils$4.parseTimezonePattern)(
          _constants$1.timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "XXX":
      default:
        return (0, _utils$4.parseTimezonePattern)(
          _constants$1.timezonePatterns.extended,
          dateString,
        );
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return (0, _index$7j.constructFrom)(
      date,
      date.getTime() -
        (0, _index2$3e.getTimezoneOffsetInMilliseconds)(date) -
        value,
    );
  }

  incompatibleTokens = ["t", "T", "x"];
}
ISOTimezoneWithZParser$1.ISOTimezoneWithZParser = ISOTimezoneWithZParser;

var ISOTimezoneParser$1 = {};

ISOTimezoneParser$1.ISOTimezoneParser = void 0;
var _index$7i = constructFrom$1;
var _index2$3d = getTimezoneOffsetInMilliseconds$1;
var _constants = constants;
var _Parser$2 = Parser$1;

var _utils$3 = utils$2;

// Timezone (ISO-8601)
class ISOTimezoneParser extends _Parser$2.Parser {
  priority = 10;

  parse(dateString, token) {
    switch (token) {
      case "x":
        return (0, _utils$3.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalMinutes,
          dateString,
        );
      case "xx":
        return (0, _utils$3.parseTimezonePattern)(
          _constants.timezonePatterns.basic,
          dateString,
        );
      case "xxxx":
        return (0, _utils$3.parseTimezonePattern)(
          _constants.timezonePatterns.basicOptionalSeconds,
          dateString,
        );
      case "xxxxx":
        return (0, _utils$3.parseTimezonePattern)(
          _constants.timezonePatterns.extendedOptionalSeconds,
          dateString,
        );
      case "xxx":
      default:
        return (0, _utils$3.parseTimezonePattern)(
          _constants.timezonePatterns.extended,
          dateString,
        );
    }
  }

  set(date, flags, value) {
    if (flags.timestampIsSet) return date;
    return (0, _index$7i.constructFrom)(
      date,
      date.getTime() -
        (0, _index2$3d.getTimezoneOffsetInMilliseconds)(date) -
        value,
    );
  }

  incompatibleTokens = ["t", "T", "X"];
}
ISOTimezoneParser$1.ISOTimezoneParser = ISOTimezoneParser;

var TimestampSecondsParser$1 = {};

TimestampSecondsParser$1.TimestampSecondsParser = void 0;
var _index$7h = constructFrom$1;
var _Parser$1 = Parser$1;

var _utils$2 = utils$2;

class TimestampSecondsParser extends _Parser$1.Parser {
  priority = 40;

  parse(dateString) {
    return (0, _utils$2.parseAnyDigitsSigned)(dateString);
  }

  set(date, _flags, value) {
    return [
      (0, _index$7h.constructFrom)(date, value * 1000),
      { timestampIsSet: true },
    ];
  }

  incompatibleTokens = "*";
}
TimestampSecondsParser$1.TimestampSecondsParser = TimestampSecondsParser;

var TimestampMillisecondsParser$1 = {};

TimestampMillisecondsParser$1.TimestampMillisecondsParser = void 0;
var _index$7g = constructFrom$1;
var _Parser = Parser$1;

var _utils$1 = utils$2;

class TimestampMillisecondsParser extends _Parser.Parser {
  priority = 20;

  parse(dateString) {
    return (0, _utils$1.parseAnyDigitsSigned)(dateString);
  }

  set(date, _flags, value) {
    return [(0, _index$7g.constructFrom)(date, value), { timestampIsSet: true }];
  }

  incompatibleTokens = "*";
}
TimestampMillisecondsParser$1.TimestampMillisecondsParser = TimestampMillisecondsParser;

parsers.parsers = void 0;
var _EraParser = EraParser$1;
var _YearParser = YearParser$1;
var _LocalWeekYearParser = LocalWeekYearParser$1;
var _ISOWeekYearParser = ISOWeekYearParser$1;
var _ExtendedYearParser = ExtendedYearParser$1;
var _QuarterParser = QuarterParser$1;
var _StandAloneQuarterParser = StandAloneQuarterParser$1;
var _MonthParser = MonthParser$1;
var _StandAloneMonthParser = StandAloneMonthParser$1;
var _LocalWeekParser = LocalWeekParser$1;
var _ISOWeekParser = ISOWeekParser$1;
var _DateParser = DateParser$1;
var _DayOfYearParser = DayOfYearParser$1;
var _DayParser = DayParser$1;
var _LocalDayParser = LocalDayParser$1;
var _StandAloneLocalDayParser = StandAloneLocalDayParser$1;
var _ISODayParser = ISODayParser$1;
var _AMPMParser = AMPMParser$1;
var _AMPMMidnightParser = AMPMMidnightParser$1;
var _DayPeriodParser = DayPeriodParser$1;
var _Hour1to12Parser = Hour1to12Parser$1;
var _Hour0to23Parser = Hour0to23Parser$1;
var _Hour0To11Parser = Hour0To11Parser$1;
var _Hour1To24Parser = Hour1To24Parser$1;
var _MinuteParser = MinuteParser$1;
var _SecondParser = SecondParser$1;
var _FractionOfSecondParser = FractionOfSecondParser$1;
var _ISOTimezoneWithZParser = ISOTimezoneWithZParser$1;
var _ISOTimezoneParser = ISOTimezoneParser$1;
var _TimestampSecondsParser = TimestampSecondsParser$1;
var _TimestampMillisecondsParser = TimestampMillisecondsParser$1;

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- It's ok, we want any here
(parsers.parsers = {
  G: new _EraParser.EraParser(),
  y: new _YearParser.YearParser(),
  Y: new _LocalWeekYearParser.LocalWeekYearParser(),
  R: new _ISOWeekYearParser.ISOWeekYearParser(),
  u: new _ExtendedYearParser.ExtendedYearParser(),
  Q: new _QuarterParser.QuarterParser(),
  q: new _StandAloneQuarterParser.StandAloneQuarterParser(),
  M: new _MonthParser.MonthParser(),
  L: new _StandAloneMonthParser.StandAloneMonthParser(),
  w: new _LocalWeekParser.LocalWeekParser(),
  I: new _ISOWeekParser.ISOWeekParser(),
  d: new _DateParser.DateParser(),
  D: new _DayOfYearParser.DayOfYearParser(),
  E: new _DayParser.DayParser(),
  e: new _LocalDayParser.LocalDayParser(),
  c: new _StandAloneLocalDayParser.StandAloneLocalDayParser(),
  i: new _ISODayParser.ISODayParser(),
  a: new _AMPMParser.AMPMParser(),
  b: new _AMPMMidnightParser.AMPMMidnightParser(),
  B: new _DayPeriodParser.DayPeriodParser(),
  h: new _Hour1to12Parser.Hour1to12Parser(),
  H: new _Hour0to23Parser.Hour0to23Parser(),
  K: new _Hour0To11Parser.Hour0To11Parser(),
  k: new _Hour1To24Parser.Hour1To24Parser(),
  m: new _MinuteParser.MinuteParser(),
  s: new _SecondParser.SecondParser(),
  S: new _FractionOfSecondParser.FractionOfSecondParser(),
  X: new _ISOTimezoneWithZParser.ISOTimezoneWithZParser(),
  x: new _ISOTimezoneParser.ISOTimezoneParser(),
  t: new _TimestampSecondsParser.TimestampSecondsParser(),
  T: new _TimestampMillisecondsParser.TimestampMillisecondsParser(),
});

(function (exports) {
Object.defineProperty(exports, "longFormatters", {
  enumerable: true,
  get: function () {
    return _index5.longFormatters;
  },
});
exports.parse = parse;
Object.defineProperty(exports, "parsers", {
  enumerable: true,
  get: function () {
    return _index7.parsers;
  },
});
var _index = constructFrom$1;
var _index2 = getDefaultOptions$1;
var _index3 = defaultLocale;
var _index4 = toDate$1;

var _index5 = longFormatters;
var _index6 = protectedTokens;

var _index7 = parsers;

var _Setter = Setter$1;

// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874

/**
 * The {@link parse} function options.
 */

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp =
  /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;

const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dateStr, formatStr, referenceDate, options) {
  const defaultOptions = (0, _index2.getDefaultOptions)();
  const locale =
    options?.locale ?? defaultOptions.locale ?? _index3.defaultLocale;

  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  if (formatStr === "") {
    if (dateStr === "") {
      return (0, _index4.toDate)(referenceDate);
    } else {
      return (0, _index.constructFrom)(referenceDate, NaN);
    }
  }

  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale,
  };

  // If timezone isn't specified, it will be set to the system timezone
  const setters = [new _Setter.DateToSystemTimezoneSetter()];

  const tokens = formatStr
    .match(longFormattingTokensRegExp)
    .map((substring) => {
      const firstCharacter = substring[0];
      if (firstCharacter in _index5.longFormatters) {
        const longFormatter = _index5.longFormatters[firstCharacter];
        return longFormatter(substring, locale.formatLong);
      }
      return substring;
    })
    .join("")
    .match(formattingTokensRegExp);

  const usedTokens = [];

  for (let token of tokens) {
    if (
      !options?.useAdditionalWeekYearTokens &&
      (0, _index6.isProtectedWeekYearToken)(token)
    ) {
      (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
    }
    if (
      !options?.useAdditionalDayOfYearTokens &&
      (0, _index6.isProtectedDayOfYearToken)(token)
    ) {
      (0, _index6.warnOrThrowProtectedError)(token, formatStr, dateStr);
    }

    const firstCharacter = token[0];
    const parser = _index7.parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find(
          (usedToken) =>
            incompatibleTokens.includes(usedToken.token) ||
            usedToken.token === firstCharacter,
        );
        if (incompatibleToken) {
          throw new RangeError(
            `The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`,
          );
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(
          `The format string mustn't contain \`${token}\` and any other token at the same time`,
        );
      }

      usedTokens.push({ token: firstCharacter, fullToken: token });

      const parseResult = parser.run(
        dateStr,
        token,
        locale.match,
        subFnOptions,
      );

      if (!parseResult) {
        return (0, _index.constructFrom)(referenceDate, NaN);
      }

      setters.push(parseResult.setter);

      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      // Replace two single quote characters with one single quote character
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      }

      // Cut token from string, or, if string doesn't match the token, return Invalid Date
      if (dateStr.indexOf(token) === 0) {
        dateStr = dateStr.slice(token.length);
      } else {
        return (0, _index.constructFrom)(referenceDate, NaN);
      }
    }
  }

  // Check if the remaining input contains something other than whitespace
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return (0, _index.constructFrom)(referenceDate, NaN);
  }

  const uniquePrioritySetters = setters
    .map((setter) => setter.priority)
    .sort((a, b) => b - a)
    .filter((priority, index, array) => array.indexOf(priority) === index)
    .map((priority) =>
      setters
        .filter((setter) => setter.priority === priority)
        .sort((a, b) => b.subPriority - a.subPriority),
    )
    .map((setterArray) => setterArray[0]);

  let date = (0, _index4.toDate)(referenceDate);

  if (isNaN(date.getTime())) {
    return (0, _index.constructFrom)(referenceDate, NaN);
  }

  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date, subFnOptions)) {
      return (0, _index.constructFrom)(referenceDate, NaN);
    }

    const result = setter.set(date, flags, subFnOptions);
    // Result is tuple (date, flags)
    if (Array.isArray(result)) {
      date = result[0];
      Object.assign(flags, result[1]);
      // Result is date
    } else {
      date = result;
    }
  }

  return (0, _index.constructFrom)(referenceDate, date);
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
}(parse$1));

isMatch$1.isMatch = isMatch;
var _index$7f = isValid$1;
var _index2$3c = parse$1;

/**
 * The {@link isMatch} function options.
 */

/**
 * @name isMatch
 * @category Common Helpers
 * @summary validates the date string against given formats
 *
 * @description
 * Return the true if given date is string correct against the given format else
 * will return false.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * isMatch('23 AM', 'HH a')
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `isMatch('50', 'yy') //=> true`
 *
 *    `isMatch('75', 'yy') //=> true`
 *
 *    while `uu` will use the year as is:
 *
 *    `isMatch('50', 'uu') //=> true`
 *
 *    `isMatch('75', 'uu') //=> true`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be checked in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateStr - The date string to verify
 * @param format - The string of tokens
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns Is format string a match for date string?
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Match 11 February 2014 from middle-endian format:
 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
 * //=> true
 *
 * @example
 * // Match 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
 *   locale: eo
 * })
 * //=> true
 */
function isMatch(dateStr, formatStr, options) {
  return (0, _index$7f.isValid)(
    (0, _index2$3c.parse)(dateStr, formatStr, new Date(), options),
  );
}

var isMonday$1 = {};

isMonday$1.isMonday = isMonday;
var _index$7e = toDate$1;

/**
 * @name isMonday
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * const result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday(date) {
  return (0, _index$7e.toDate)(date).getDay() === 1;
}

var isPast$1 = {};

isPast$1.isPast = isPast;
var _index$7d = toDate$1;

/**
 * @name isPast
 * @category Common Helpers
 * @summary Is the given date in the past?
 * @pure false
 *
 * @description
 * Is the given date in the past?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * const result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast(date) {
  return +(0, _index$7d.toDate)(date) < Date.now();
}

var isSameHour$1 = {};

var startOfHour$1 = {};

startOfHour$1.startOfHour = startOfHour;
var _index$7c = toDate$1;

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour(date) {
  const _date = (0, _index$7c.toDate)(date);
  _date.setMinutes(0, 0, 0);
  return _date;
}

isSameHour$1.isSameHour = isSameHour;
var _index$7b = startOfHour$1;

/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same hour (and same day)
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */
function isSameHour(dateLeft, dateRight) {
  const dateLeftStartOfHour = (0, _index$7b.startOfHour)(dateLeft);
  const dateRightStartOfHour = (0, _index$7b.startOfHour)(dateRight);

  return +dateLeftStartOfHour === +dateRightStartOfHour;
}

var isSameISOWeek$1 = {};

var isSameWeek$1 = {};

isSameWeek$1.isSameWeek = isSameWeek;
var _index$7a = startOfWeek$1;

/**
 * The {@link isSameWeek} function options.
 */

/**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 * @param options - An object with options
 *
 * @returns The dates are in the same week (and month and year)
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameWeek(dateLeft, dateRight, options) {
  const dateLeftStartOfWeek = (0, _index$7a.startOfWeek)(dateLeft, options);
  const dateRightStartOfWeek = (0, _index$7a.startOfWeek)(dateRight, options);

  return +dateLeftStartOfWeek === +dateRightStartOfWeek;
}

isSameISOWeek$1.isSameISOWeek = isSameISOWeek;
var _index$79 = isSameWeek$1;

/**
 * @name isSameISOWeek
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week (and year)?
 *
 * @description
 * Are the given dates in the same ISO week (and year)?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week (and year)
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
 * //=> true
 *
 * @example
 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
 * //=> false
 */
function isSameISOWeek(dateLeft, dateRight) {
  return (0, _index$79.isSameWeek)(dateLeft, dateRight, { weekStartsOn: 1 });
}

var isSameISOWeekYear$1 = {};

isSameISOWeekYear$1.isSameISOWeekYear = isSameISOWeekYear;
var _index$78 = startOfISOWeekYear$1;

/**
 * @name isSameISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
 * //=> true
 */
function isSameISOWeekYear(dateLeft, dateRight) {
  const dateLeftStartOfYear = (0, _index$78.startOfISOWeekYear)(dateLeft);
  const dateRightStartOfYear = (0, _index$78.startOfISOWeekYear)(dateRight);

  return +dateLeftStartOfYear === +dateRightStartOfYear;
}

var isSameMinute$1 = {};

isSameMinute$1.isSameMinute = isSameMinute;
var _index$77 = startOfMinute$1;

/**
 * @name isSameMinute
 * @category Minute Helpers
 * @summary Are the given dates in the same minute (and hour and day)?
 *
 * @description
 * Are the given dates in the same minute (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same minute (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
 * const result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 5, 6, 30)
 * )
 * //=> false
 */
function isSameMinute(dateLeft, dateRight) {
  const dateLeftStartOfMinute = (0, _index$77.startOfMinute)(dateLeft);
  const dateRightStartOfMinute = (0, _index$77.startOfMinute)(dateRight);

  return +dateLeftStartOfMinute === +dateRightStartOfMinute;
}

var isSameMonth$1 = {};

isSameMonth$1.isSameMonth = isSameMonth;
var _index$76 = toDate$1;

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same month (and year)
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dateLeft, dateRight) {
  const _dateLeft = (0, _index$76.toDate)(dateLeft);
  const _dateRight = (0, _index$76.toDate)(dateRight);
  return (
    _dateLeft.getFullYear() === _dateRight.getFullYear() &&
    _dateLeft.getMonth() === _dateRight.getMonth()
  );
}

var isSameQuarter$1 = {};

isSameQuarter$1.isSameQuarter = isSameQuarter;
var _index$75 = startOfQuarter$1;

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check

 * @returns The dates are in the same quarter (and year)
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameQuarter(dateLeft, dateRight) {
  const dateLeftStartOfQuarter = (0, _index$75.startOfQuarter)(dateLeft);
  const dateRightStartOfQuarter = (0, _index$75.startOfQuarter)(dateRight);

  return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}

var isSameSecond$1 = {};

var startOfSecond$1 = {};

startOfSecond$1.startOfSecond = startOfSecond;
var _index$74 = toDate$1;

/**
 * @name startOfSecond
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond(date) {
  const _date = (0, _index$74.toDate)(date);
  _date.setMilliseconds(0);
  return _date;
}

isSameSecond$1.isSameSecond = isSameSecond;
var _index$73 = startOfSecond$1;

/**
 * @name isSameSecond
 * @category Second Helpers
 * @summary Are the given dates in the same second (and hour and day)?
 *
 * @description
 * Are the given dates in the same second (and hour and day)?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same second (and hour and day)
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 4, 6, 1, 15)
 * )
 * //=> false
 *
 * @example
 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
 * const result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 0, 15),
 *   new Date(2014, 8, 5, 6, 0, 15)
 * )
 * //=> false
 */
function isSameSecond(dateLeft, dateRight) {
  const dateLeftStartOfSecond = (0, _index$73.startOfSecond)(dateLeft);
  const dateRightStartOfSecond = (0, _index$73.startOfSecond)(dateRight);

  return +dateLeftStartOfSecond === +dateRightStartOfSecond;
}

var isSameYear$1 = {};

isSameYear$1.isSameYear = isSameYear;
var _index$72 = toDate$1;

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The first date to check
 * @param dateRight - The second date to check
 *
 * @returns The dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dateLeft, dateRight) {
  const _dateLeft = (0, _index$72.toDate)(dateLeft);
  const _dateRight = (0, _index$72.toDate)(dateRight);
  return _dateLeft.getFullYear() === _dateRight.getFullYear();
}

var isThisHour$1 = {};

isThisHour$1.isThisHour = isThisHour;
var _index$71 = constructNow$1;
var _index2$3b = isSameHour$1;

/**
 * @name isThisHour
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * const result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour(date) {
  return (0, _index2$3b.isSameHour)(date, (0, _index$71.constructNow)(date));
}

var isThisISOWeek$1 = {};

isThisISOWeek$1.isThisISOWeek = isThisISOWeek;
var _index$70 = constructNow$1;
var _index2$3a = isSameISOWeek$1;

/**
 * @name isThisISOWeek
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * const result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */

function isThisISOWeek(date) {
  return (0, _index2$3a.isSameISOWeek)(date, (0, _index$70.constructNow)(date));
}

var isThisMinute$1 = {};

isThisMinute$1.isThisMinute = isThisMinute;
var _index$6$ = constructNow$1;
var _index2$39 = isSameMinute$1;

/**
 * @name isThisMinute
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */

function isThisMinute(date) {
  return (0, _index2$39.isSameMinute)(date, (0, _index$6$.constructNow)(date));
}

var isThisMonth$1 = {};

isThisMonth$1.isThisMonth = isThisMonth;
var _index$6_ = constructNow$1;
var _index2$38 = isSameMonth$1;

/**
 * @name isThisMonth
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * const result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */

function isThisMonth(date) {
  return (0, _index2$38.isSameMonth)(date, (0, _index$6_.constructNow)(date));
}

var isThisQuarter$1 = {};

isThisQuarter$1.isThisQuarter = isThisQuarter;
var _index$6Z = constructNow$1;
var _index2$37 = isSameQuarter$1;

/**
 * @name isThisQuarter
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * const result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter(date) {
  return (0, _index2$37.isSameQuarter)(date, (0, _index$6Z.constructNow)(date));
}

var isThisSecond$1 = {};

isThisSecond$1.isThisSecond = isThisSecond;
var _index$6Y = constructNow$1;
var _index2$36 = isSameSecond$1;

/**
 * @name isThisSecond
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond(date) {
  return (0, _index2$36.isSameSecond)(date, (0, _index$6Y.constructNow)(date));
}

var isThisWeek$1 = {};

isThisWeek$1.isThisWeek = isThisWeek;
var _index$6X = constructNow$1;
var _index2$35 = isSameWeek$1;

/**
 * The {@link isThisWeek} function options.
 */

/**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param options - The object with options
 *
 * @returns The date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */
function isThisWeek(date, options) {
  return (0, _index2$35.isSameWeek)(date, (0, _index$6X.constructNow)(date), options);
}

var isThisYear$1 = {};

isThisYear$1.isThisYear = isThisYear;
var _index$6W = constructNow$1;
var _index2$34 = isSameYear$1;

/**
 * @name isThisYear
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * const result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear(date) {
  return (0, _index2$34.isSameYear)(date, (0, _index$6W.constructNow)(date));
}

var isThursday$1 = {};

isThursday$1.isThursday = isThursday;
var _index$6V = toDate$1;

/**
 * @name isThursday
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * const result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday(date) {
  return (0, _index$6V.toDate)(date).getDay() === 4;
}

var isToday$1 = {};

isToday$1.isToday = isToday;
var _index$6U = constructNow$1;
var _index2$33 = isSameDay$1;

/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday(date) {
  return (0, _index2$33.isSameDay)(date, (0, _index$6U.constructNow)(date));
}

var isTomorrow$1 = {};

isTomorrow$1.isTomorrow = isTomorrow;
var _index$6T = addDays$1;
var _index2$32 = constructNow$1;
var _index3$1D = isSameDay$1;

/**
 * @name isTomorrow
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 * @pure false
 *
 * @description
 * Is the given date tomorrow?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow(date) {
  return (0, _index3$1D.isSameDay)(
    date,
    (0, _index$6T.addDays)((0, _index2$32.constructNow)(date), 1),
  );
}

var isTuesday$1 = {};

isTuesday$1.isTuesday = isTuesday;
var _index$6S = toDate$1;

/**
 * @name isTuesday
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * const result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday(date) {
  return (0, _index$6S.toDate)(date).getDay() === 2;
}

var isWednesday$1 = {};

isWednesday$1.isWednesday = isWednesday;
var _index$6R = toDate$1;

/**
 * @name isWednesday
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * const result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday(date) {
  return (0, _index$6R.toDate)(date).getDay() === 3;
}

var isWithinInterval$1 = {};

isWithinInterval$1.isWithinInterval = isWithinInterval;
var _index$6Q = toDate$1;

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param interval - The interval to check
 *
 * @returns The date is within the interval
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date })
 * // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end })
 * // => true
 */
function isWithinInterval(date, interval) {
  const time = +(0, _index$6Q.toDate)(date);
  const [startTime, endTime] = [
    +(0, _index$6Q.toDate)(interval.start),
    +(0, _index$6Q.toDate)(interval.end),
  ].sort((a, b) => a - b);

  return time >= startTime && time <= endTime;
}

var isYesterday$1 = {};

var subDays$1 = {};

subDays$1.subDays = subDays;
var _index$6P = addDays$1;

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be subtracted.
 *
 * @returns The new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(date, amount) {
  return (0, _index$6P.addDays)(date, -amount);
}

isYesterday$1.isYesterday = isYesterday;
var _index$6O = constructNow$1;
var _index2$31 = isSameDay$1;
var _index3$1C = subDays$1;

/**
 * @name isYesterday
 * @category Day Helpers
 * @summary Is the given date yesterday?
 * @pure false
 *
 * @description
 * Is the given date yesterday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday(date) {
  return (0, _index2$31.isSameDay)(
    date,
    (0, _index3$1C.subDays)((0, _index$6O.constructNow)(date), 1),
  );
}

var lastDayOfDecade$1 = {};

lastDayOfDecade$1.lastDayOfDecade = lastDayOfDecade;
var _index$6N = toDate$1;

/**
 * @name lastDayOfDecade
 * @category Decade Helpers
 * @summary Return the last day of a decade for the given date.
 *
 * @description
 * Return the last day of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a decade
 *
 * @example
 * // The last day of a decade for 21 December 2012 21:12:00:
 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
 * //=> Wed Dec 31 2019 00:00:00
 */
function lastDayOfDecade(date) {
  // TODO: Switch to more technical definition in of decades that start with 1
  // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
  // change, so it can only be done in 4.0.
  const _date = (0, _index$6N.toDate)(date);
  const year = _date.getFullYear();
  const decade = 9 + Math.floor(year / 10) * 10;
  _date.setFullYear(decade + 1, 0, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

var lastDayOfISOWeek$1 = {};

var lastDayOfWeek$1 = {};

lastDayOfWeek$1.lastDayOfWeek = lastDayOfWeek;
var _index$6M = toDate$1;

var _index2$30 = defaultOptions$1;

/**
 * The {@link lastDayOfWeek} function options.
 */

/**
 * @name lastDayOfWeek
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek(date, options) {
  const defaultOptions = (0, _index2$30.getDefaultOptions)();
  const weekStartsOn =
    options?.weekStartsOn ??
    options?.locale?.options?.weekStartsOn ??
    defaultOptions.weekStartsOn ??
    defaultOptions.locale?.options?.weekStartsOn ??
    0;

  const _date = (0, _index$6M.toDate)(date);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);

  _date.setHours(0, 0, 0, 0);
  _date.setDate(_date.getDate() + diff);
  return _date;
}

lastDayOfISOWeek$1.lastDayOfISOWeek = lastDayOfISOWeek;
var _index$6L = lastDayOfWeek$1;

/**
 * @name lastDayOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek(date) {
  return (0, _index$6L.lastDayOfWeek)(date, { weekStartsOn: 1 });
}

var lastDayOfISOWeekYear$1 = {};

lastDayOfISOWeekYear$1.lastDayOfISOWeekYear = lastDayOfISOWeekYear;
var _index$6K = getISOWeekYear$1;
var _index2$2$ = startOfISOWeek$1;
var _index3$1B = constructFrom$1;

/**
 * @name lastDayOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOWeekYear(date) {
  const year = (0, _index$6K.getISOWeekYear)(date);
  const fourthOfJanuary = (0, _index3$1B.constructFrom)(date, 0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  const _date = (0, _index2$2$.startOfISOWeek)(fourthOfJanuary);
  _date.setDate(_date.getDate() - 1);
  return _date;
}

var lastDayOfQuarter$1 = {};

lastDayOfQuarter$1.lastDayOfQuarter = lastDayOfQuarter;
var _index$6J = toDate$1;

/**
 * @name lastDayOfQuarter
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter(date) {
  const _date = (0, _index$6J.toDate)(date);
  const currentMonth = _date.getMonth();
  const month = currentMonth - (currentMonth % 3) + 3;
  _date.setMonth(month, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

var lastDayOfYear$1 = {};

lastDayOfYear$1.lastDayOfYear = lastDayOfYear;
var _index$6I = toDate$1;

/**
 * @name lastDayOfYear
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear(date) {
  const _date = (0, _index$6I.toDate)(date);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

var lightFormat = {};

(function (exports) {
exports.lightFormat = lightFormat;
Object.defineProperty(exports, "lightFormatters", {
  enumerable: true,
  get: function () {
    return _index3.lightFormatters;
  },
});
var _index = isValid$1;
var _index2 = toDate$1;
var _index3 = lightFormatters;

// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874

// This RegExp consists of three parts separated by `|`:
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;

const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @private
 */

/**
 * @name lightFormat
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. Unlike `format`,
 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
 *
 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   |
 * |---------------------------------|---------|-----------------------------------|
 * | AM, PM                          | a..aaa  | AM, PM                            |
 * |                                 | aaaa    | a.m., p.m.                        |
 * |                                 | aaaaa   | a, p                              |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
 * |                                 | yy      | 44, 01, 00, 17                    |
 * |                                 | yyy     | 044, 001, 000, 017                |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
 * |                                 | MM      | 01, 02, ..., 12                   |
 * | Day of month                    | d       | 1, 2, ..., 31                     |
 * |                                 | dd      | 01, 02, ..., 31                   |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
 * |                                 | hh      | 01, 02, ..., 11, 12               |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
 * |                                 | HH      | 00, 01, 02, ..., 23               |
 * | Minute                          | m       | 0, 1, ..., 59                     |
 * |                                 | mm      | 00, 01, ..., 59                   |
 * | Second                          | s       | 0, 1, ..., 59                     |
 * |                                 | ss      | 00, 01, ..., 59                   |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |
 * |                                 | SS      | 00, 01, ..., 99                   |
 * |                                 | SSS     | 000, 001, ..., 999                |
 * |                                 | SSSS    | ...                               |
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 *
 * @returns The formatted date string
 *
 * @throws `Invalid time value` if the date is invalid
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
 * //=> '2014-02-11'
 */
function lightFormat(date, formatStr) {
  const _date = (0, _index2.toDate)(date);

  if (!(0, _index.isValid)(_date)) {
    throw new RangeError("Invalid time value");
  }

  const tokens = formatStr.match(formattingTokensRegExp);

  // The only case when formattingTokensRegExp doesn't match the string is when it's empty
  if (!tokens) return "";

  const result = tokens
    .map((substring) => {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return "'";
      }

      const firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return cleanEscapedString(substring);
      }

      const formatter = _index3.lightFormatters[firstCharacter];
      if (formatter) {
        return formatter(_date, substring);
      }

      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" +
            firstCharacter +
            "`",
        );
      }

      return substring;
    })
    .join("");

  return result;
}

function cleanEscapedString(input) {
  const matches = input.match(escapedStringRegExp);

  if (!matches) {
    return input;
  }

  return matches[1].replace(doubleQuoteRegExp, "'");
}
}(lightFormat));

var milliseconds$1 = {};

milliseconds$1.milliseconds = milliseconds;
var _index$6H = constants$1;

/**
 * @name milliseconds
 * @category Millisecond Helpers
 * @summary
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * @description
 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * One month is a year divided by 12.
 *
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be added.
 *
 * @returns The milliseconds
 *
 * @example
 * // 1 year in milliseconds
 * milliseconds({ years: 1 })
 * //=> 31556952000
 *
 * // 3 months in milliseconds
 * milliseconds({ months: 3 })
 * //=> 7889238000
 */
function milliseconds({ years, months, weeks, days, hours, minutes, seconds }) {
  let totalDays = 0;

  if (years) totalDays += years * _index$6H.daysInYear;
  if (months) totalDays += months * (_index$6H.daysInYear / 12);
  if (weeks) totalDays += weeks * 7;
  if (days) totalDays += days;

  let totalSeconds = totalDays * 24 * 60 * 60;

  if (hours) totalSeconds += hours * 60 * 60;
  if (minutes) totalSeconds += minutes * 60;
  if (seconds) totalSeconds += seconds;

  return Math.trunc(totalSeconds * 1000);
}

var millisecondsToHours$1 = {};

millisecondsToHours$1.millisecondsToHours = millisecondsToHours;
var _index$6G = constants$1;

/**
 * @name millisecondsToHours
 * @category Conversion Helpers
 * @summary Convert milliseconds to hours.
 *
 * @description
 * Convert a number of milliseconds to a full number of hours.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in hours
 *
 * @example
 * // Convert 7200000 milliseconds to hours:
 * const result = millisecondsToHours(7200000)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToHours(7199999)
 * //=> 1
 */
function millisecondsToHours(milliseconds) {
  const hours = milliseconds / _index$6G.millisecondsInHour;
  return Math.trunc(hours);
}

var millisecondsToMinutes$1 = {};

millisecondsToMinutes$1.millisecondsToMinutes = millisecondsToMinutes;
var _index$6F = constants$1;

/**
 * @name millisecondsToMinutes
 * @category Conversion Helpers
 * @summary Convert milliseconds to minutes.
 *
 * @description
 * Convert a number of milliseconds to a full number of minutes.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in minutes
 *
 * @example
 * // Convert 60000 milliseconds to minutes:
 * const result = millisecondsToMinutes(60000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToMinutes(119999)
 * //=> 1
 */
function millisecondsToMinutes(milliseconds) {
  const minutes = milliseconds / _index$6F.millisecondsInMinute;
  return Math.trunc(minutes);
}

var millisecondsToSeconds$1 = {};

millisecondsToSeconds$1.millisecondsToSeconds = millisecondsToSeconds;
var _index$6E = constants$1;

/**
 * @name millisecondsToSeconds
 * @category Conversion Helpers
 * @summary Convert milliseconds to seconds.
 *
 * @description
 * Convert a number of milliseconds to a full number of seconds.
 *
 * @param milliseconds - The number of milliseconds to be converted
 *
 * @returns The number of milliseconds converted in seconds
 *
 * @example
 * // Convert 1000 miliseconds to seconds:
 * const result = millisecondsToSeconds(1000)
 * //=> 1
 *
 * @example
 * // It uses floor rounding:
 * const result = millisecondsToSeconds(1999)
 * //=> 1
 */
function millisecondsToSeconds(milliseconds) {
  const seconds = milliseconds / _index$6E.millisecondsInSecond;
  return Math.trunc(seconds);
}

var minutesToHours$1 = {};

minutesToHours$1.minutesToHours = minutesToHours;
var _index$6D = constants$1;

/**
 * @name minutesToHours
 * @category Conversion Helpers
 * @summary Convert minutes to hours.
 *
 * @description
 * Convert a number of minutes to a full number of hours.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in hours
 *
 * @example
 * // Convert 140 minutes to hours:
 * const result = minutesToHours(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = minutesToHours(179)
 * //=> 2
 */
function minutesToHours(minutes) {
  const hours = minutes / _index$6D.minutesInHour;
  return Math.trunc(hours);
}

var minutesToMilliseconds$1 = {};

minutesToMilliseconds$1.minutesToMilliseconds = minutesToMilliseconds;
var _index$6C = constants$1;

/**
 * @name minutesToMilliseconds
 * @category Conversion Helpers
 * @summary Convert minutes to milliseconds.
 *
 * @description
 * Convert a number of minutes to a full number of milliseconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in milliseconds
 *
 * @example
 * // Convert 2 minutes to milliseconds
 * const result = minutesToMilliseconds(2)
 * //=> 120000
 */
function minutesToMilliseconds(minutes) {
  return Math.trunc(minutes * _index$6C.millisecondsInMinute);
}

var minutesToSeconds$1 = {};

minutesToSeconds$1.minutesToSeconds = minutesToSeconds;
var _index$6B = constants$1;

/**
 * @name minutesToSeconds
 * @category Conversion Helpers
 * @summary Convert minutes to seconds.
 *
 * @description
 * Convert a number of minutes to a full number of seconds.
 *
 * @param minutes - The number of minutes to be converted
 *
 * @returns The number of minutes converted in seconds
 *
 * @example
 * // Convert 2 minutes to seconds
 * const result = minutesToSeconds(2)
 * //=> 120
 */
function minutesToSeconds(minutes) {
  return Math.trunc(minutes * _index$6B.secondsInMinute);
}

var monthsToQuarters$1 = {};

monthsToQuarters$1.monthsToQuarters = monthsToQuarters;
var _index$6A = constants$1;

/**
 * @name monthsToQuarters
 * @category Conversion Helpers
 * @summary Convert number of months to quarters.
 *
 * @description
 * Convert a number of months to a full number of quarters.
 *
 * @param months - The number of months to be converted.
 *
 * @returns The number of months converted in quarters
 *
 * @example
 * // Convert 6 months to quarters:
 * const result = monthsToQuarters(6)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = monthsToQuarters(7)
 * //=> 2
 */
function monthsToQuarters(months) {
  const quarters = months / _index$6A.monthsInQuarter;
  return Math.trunc(quarters);
}

var monthsToYears$1 = {};

monthsToYears$1.monthsToYears = monthsToYears;
var _index$6z = constants$1;

/**
 * @name monthsToYears
 * @category Conversion Helpers
 * @summary Convert number of months to years.
 *
 * @description
 * Convert a number of months to a full number of years.
 *
 * @param months - The number of months to be converted
 *
 * @returns The number of months converted in years
 *
 * @example
 * // Convert 36 months to years:
 * const result = monthsToYears(36)
 * //=> 3
 *
 * // It uses floor rounding:
 * const result = monthsToYears(40)
 * //=> 3
 */
function monthsToYears(months) {
  const years = months / _index$6z.monthsInYear;
  return Math.trunc(years);
}

var nextDay$1 = {};

nextDay$1.nextDay = nextDay;
var _index$6y = addDays$1;
var _index2$2_ = getDay$1;

/**
 * @name nextDay
 * @category Weekday Helpers
 * @summary When is the next day of the week?
 *
 * @description
 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - day of the week
 *
 * @returns The date is the next day of week
 *
 * @example
 * // When is the next Monday after Mar, 20, 2020?
 * const result = nextDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 23 2020 00:00:00
 *
 * @example
 * // When is the next Tuesday after Mar, 21, 2020?
 * const result = nextDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 24 2020 00:00:00
 */
function nextDay(date, day) {
  let delta = day - (0, _index2$2_.getDay)(date);
  if (delta <= 0) delta += 7;

  return (0, _index$6y.addDays)(date, delta);
}

var nextFriday$1 = {};

nextFriday$1.nextFriday = nextFriday;
var _index$6x = nextDay$1;

/**
 * @name nextFriday
 * @category Weekday Helpers
 * @summary When is the next Friday?
 *
 * @description
 * When is the next Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Friday
 *
 * @example
 * // When is the next Friday after Mar, 22, 2020?
 * const result = nextFriday(new Date(2020, 2, 22))
 * //=> Fri Mar 27 2020 00:00:00
 */
function nextFriday(date) {
  return (0, _index$6x.nextDay)(date, 5);
}

var nextMonday$1 = {};

nextMonday$1.nextMonday = nextMonday;
var _index$6w = nextDay$1;

/**
 * @name nextMonday
 * @category Weekday Helpers
 * @summary When is the next Monday?
 *
 * @description
 * When is the next Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Monday
 *
 * @example
 * // When is the next Monday after Mar, 22, 2020?
 * const result = nextMonday(new Date(2020, 2, 22))
 * //=> Mon Mar 23 2020 00:00:00
 */
function nextMonday(date) {
  return (0, _index$6w.nextDay)(date, 1);
}

var nextSaturday$1 = {};

nextSaturday$1.nextSaturday = nextSaturday;
var _index$6v = nextDay$1;

/**
 * @name nextSaturday
 * @category Weekday Helpers
 * @summary When is the next Saturday?
 *
 * @description
 * When is the next Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Saturday
 *
 * @example
 * // When is the next Saturday after Mar, 22, 2020?
 * const result = nextSaturday(new Date(2020, 2, 22))
 * //=> Sat Mar 28 2020 00:00:00
 */
function nextSaturday(date) {
  return (0, _index$6v.nextDay)(date, 6);
}

var nextSunday$1 = {};

nextSunday$1.nextSunday = nextSunday;
var _index$6u = nextDay$1;

/**
 * @name nextSunday
 * @category Weekday Helpers
 * @summary When is the next Sunday?
 *
 * @description
 * When is the next Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Sunday
 *
 * @example
 * // When is the next Sunday after Mar, 22, 2020?
 * const result = nextSunday(new Date(2020, 2, 22))
 * //=> Sun Mar 29 2020 00:00:00
 */
function nextSunday(date) {
  return (0, _index$6u.nextDay)(date, 0);
}

var nextThursday$1 = {};

nextThursday$1.nextThursday = nextThursday;
var _index$6t = nextDay$1;

/**
 * @name nextThursday
 * @category Weekday Helpers
 * @summary When is the next Thursday?
 *
 * @description
 * When is the next Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Thursday
 *
 * @example
 * // When is the next Thursday after Mar, 22, 2020?
 * const result = nextThursday(new Date(2020, 2, 22))
 * //=> Thur Mar 26 2020 00:00:00
 */
function nextThursday(date) {
  return (0, _index$6t.nextDay)(date, 4);
}

var nextTuesday$1 = {};

nextTuesday$1.nextTuesday = nextTuesday;
var _index$6s = nextDay$1;

/**
 * @name nextTuesday
 * @category Weekday Helpers
 * @summary When is the next Tuesday?
 *
 * @description
 * When is the next Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Tuesday
 *
 * @example
 * // When is the next Tuesday after Mar, 22, 2020?
 * const result = nextTuesday(new Date(2020, 2, 22))
 * //=> Tue Mar 24 2020 00:00:00
 */
function nextTuesday(date) {
  return (0, _index$6s.nextDay)(date, 2);
}

var nextWednesday$1 = {};

nextWednesday$1.nextWednesday = nextWednesday;
var _index$6r = nextDay$1;

/**
 * @name nextWednesday
 * @category Weekday Helpers
 * @summary When is the next Wednesday?
 *
 * @description
 * When is the next Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The next Wednesday
 *
 * @example
 * // When is the next Wednesday after Mar, 22, 2020?
 * const result = nextWednesday(new Date(2020, 2, 22))
 * //=> Wed Mar 25 2020 00:00:00
 */
function nextWednesday(date) {
  return (0, _index$6r.nextDay)(date, 3);
}

var parseISO$1 = {};

parseISO$1.parseISO = parseISO;
var _index$6q = constants$1;

/**
 * The {@link parseISO} function options.
 */

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 * @param options - An object with options
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  const additionalDigits = options?.additionalDigits ?? 2;
  const dateStrings = splitDateString(argument);

  let date;
  if (dateStrings.date) {
    const parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  const timestamp = date.getTime();
  let time = 0;
  let offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    const dirtyDate = new Date(timestamp + time);
    // JS parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    const result = new Date(0);
    result.setFullYear(
      dirtyDate.getUTCFullYear(),
      dirtyDate.getUTCMonth(),
      dirtyDate.getUTCDate(),
    );
    result.setHours(
      dirtyDate.getUTCHours(),
      dirtyDate.getUTCMinutes(),
      dirtyDate.getUTCSeconds(),
      dirtyDate.getUTCMilliseconds(),
    );
    return result;
  }

  return new Date(timestamp + time + offset);
}

const patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/,
};

const dateRegex =
  /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const timeRegex =
  /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  const dateStrings = {};
  const array = dateString.split(patterns.dateTimeDelimiter);
  let timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(
        dateStrings.date.length,
        dateString.length,
      );
    }
  }

  if (timeString) {
    const token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  const regex = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" +
      (4 + additionalDigits) +
      "})|(\\d{2}|[+-]\\d{" +
      (2 + additionalDigits) +
      "})$)",
  );

  const captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return { year: NaN, restDateString: "" };

  const year = captures[1] ? parseInt(captures[1]) : null;
  const century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length),
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);

  const captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);

  const isWeekDate = !!captures[4];
  const dayOfYear = parseDateUnit(captures[1]);
  const month = parseDateUnit(captures[2]) - 1;
  const day = parseDateUnit(captures[3]);
  const week = parseDateUnit(captures[4]);
  const dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    const date = new Date(0);
    if (
      !validateDate(year, month, day) ||
      !validateDayOfYearDate(year, dayOfYear)
    ) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  const captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  const hours = parseTimeUnit(captures[1]);
  const minutes = parseTimeUnit(captures[2]);
  const seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return (
    hours * _index$6q.millisecondsInHour +
    minutes * _index$6q.millisecondsInMinute +
    seconds * 1000
  );
}

function parseTimeUnit(value) {
  return (value && parseFloat(value.replace(",", "."))) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;

  const captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;

  const sign = captures[1] === "+" ? -1 : 1;
  const hours = parseInt(captures[2]);
  const minutes = (captures[3] && parseInt(captures[3])) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return (
    sign *
    (hours * _index$6q.millisecondsInHour + minutes * _index$6q.millisecondsInMinute)
  );
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  const date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  const fourthOfJanuaryDay = date.getUTCDay() || 7;
  const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
const daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
}

function validateDate(year, month, date) {
  return (
    month >= 0 &&
    month <= 11 &&
    date >= 1 &&
    date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28))
  );
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return (
    seconds >= 0 &&
    seconds < 60 &&
    minutes >= 0 &&
    minutes < 60 &&
    hours >= 0 &&
    hours < 25
  );
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

var parseJSON$1 = {};

parseJSON$1.parseJSON = parseJSON; /**
 * @name parseJSON
 * @category Common Helpers
 * @summary Parse a JSON date string
 *
 * @description
 * Converts a complete ISO date string in UTC time, the typical format for transmitting
 * a date in JSON, to a JavaScript `Date` instance.
 *
 * This is a minimal implementation for converting dates retrieved from a JSON API to
 * a `Date` instance which can be used with other functions in the `date-fns` library.
 * The following formats are supported:
 *
 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
 * - `2000-03-15T05:20:10Z`: Without milliseconds
 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
 *
 * For convenience and ease of use these other input types are also supported
 * via [toDate](https://date-fns.org/docs/toDate):
 *
 * - A `Date` instance will be cloned
 * - A `number` will be treated as a timestamp
 *
 * Any other input type or invalid date strings will return an `Invalid Date`.
 *
 * @param dateStr - A fully formed ISO8601 date string to convert
 *
 * @returns The parsed date in the local time zone
 */
function parseJSON(dateStr) {
  const parts = dateStr.match(
    /(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/,
  );
  if (parts) {
    // Group 8 matches the sign
    return new Date(
      Date.UTC(
        +parts[1],
        +parts[2] - 1,
        +parts[3],
        +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1),
        +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1),
        +parts[6],
        +((parts[7] || "0") + "00").substring(0, 3),
      ),
    );
  }
  return new Date(NaN);
}

var previousDay$1 = {};

previousDay$1.previousDay = previousDay;
var _index$6p = getDay$1;
var _index2$2Z = subDays$1;

/**
 * @name previousDay
 * @category Weekday Helpers
 * @summary When is the previous day of the week?
 *
 * @description
 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 * @param day - The day of the week
 *
 * @returns The date is the previous day of week
 *
 * @example
 * // When is the previous Monday before Mar, 20, 2020?
 * const result = previousDay(new Date(2020, 2, 20), 1)
 * //=> Mon Mar 16 2020 00:00:00
 *
 * @example
 * // When is the previous Tuesday before Mar, 21, 2020?
 * const result = previousDay(new Date(2020, 2, 21), 2)
 * //=> Tue Mar 17 2020 00:00:00
 */
function previousDay(date, day) {
  let delta = (0, _index$6p.getDay)(date) - day;
  if (delta <= 0) delta += 7;

  return (0, _index2$2Z.subDays)(date, delta);
}

var previousFriday$1 = {};

previousFriday$1.previousFriday = previousFriday;
var _index$6o = previousDay$1;

/**
 * @name previousFriday
 * @category Weekday Helpers
 * @summary When is the previous Friday?
 *
 * @description
 * When is the previous Friday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Friday
 *
 * @example
 * // When is the previous Friday before Jun, 19, 2021?
 * const result = previousFriday(new Date(2021, 5, 19))
 * //=> Fri June 18 2021 00:00:00
 */
function previousFriday(date) {
  return (0, _index$6o.previousDay)(date, 5);
}

var previousMonday$1 = {};

previousMonday$1.previousMonday = previousMonday;
var _index$6n = previousDay$1;

/**
 * @name previousMonday
 * @category Weekday Helpers
 * @summary When is the previous Monday?
 *
 * @description
 * When is the previous Monday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Monday
 *
 * @example
 * // When is the previous Monday before Jun, 18, 2021?
 * const result = previousMonday(new Date(2021, 5, 18))
 * //=> Mon June 14 2021 00:00:00
 */
function previousMonday(date) {
  return (0, _index$6n.previousDay)(date, 1);
}

var previousSaturday$1 = {};

previousSaturday$1.previousSaturday = previousSaturday;
var _index$6m = previousDay$1;

/**
 * @name previousSaturday
 * @category Weekday Helpers
 * @summary When is the previous Saturday?
 *
 * @description
 * When is the previous Saturday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Saturday
 *
 * @example
 * // When is the previous Saturday before Jun, 20, 2021?
 * const result = previousSaturday(new Date(2021, 5, 20))
 * //=> Sat June 19 2021 00:00:00
 */
function previousSaturday(date) {
  return (0, _index$6m.previousDay)(date, 6);
}

var previousSunday$1 = {};

previousSunday$1.previousSunday = previousSunday;
var _index$6l = previousDay$1;

/**
 * @name previousSunday
 * @category Weekday Helpers
 * @summary When is the previous Sunday?
 *
 * @description
 * When is the previous Sunday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Sunday
 *
 * @example
 * // When is the previous Sunday before Jun, 21, 2021?
 * const result = previousSunday(new Date(2021, 5, 21))
 * //=> Sun June 20 2021 00:00:00
 */
function previousSunday(date) {
  return (0, _index$6l.previousDay)(date, 0);
}

var previousThursday$1 = {};

previousThursday$1.previousThursday = previousThursday;
var _index$6k = previousDay$1;

/**
 * @name previousThursday
 * @category Weekday Helpers
 * @summary When is the previous Thursday?
 *
 * @description
 * When is the previous Thursday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Thursday
 *
 * @example
 * // When is the previous Thursday before Jun, 18, 2021?
 * const result = previousThursday(new Date(2021, 5, 18))
 * //=> Thu June 17 2021 00:00:00
 */
function previousThursday(date) {
  return (0, _index$6k.previousDay)(date, 4);
}

var previousTuesday$1 = {};

previousTuesday$1.previousTuesday = previousTuesday;
var _index$6j = previousDay$1;

/**
 * @name previousTuesday
 * @category Weekday Helpers
 * @summary When is the previous Tuesday?
 *
 * @description
 * When is the previous Tuesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Tuesday
 *
 * @example
 * // When is the previous Tuesday before Jun, 18, 2021?
 * const result = previousTuesday(new Date(2021, 5, 18))
 * //=> Tue June 15 2021 00:00:00
 */
function previousTuesday(date) {
  return (0, _index$6j.previousDay)(date, 2);
}

var previousWednesday$1 = {};

previousWednesday$1.previousWednesday = previousWednesday;
var _index$6i = previousDay$1;

/**
 * @name previousWednesday
 * @category Weekday Helpers
 * @summary When is the previous Wednesday?
 *
 * @description
 * When is the previous Wednesday?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to start counting from
 *
 * @returns The previous Wednesday
 *
 * @example
 * // When is the previous Wednesday before Jun, 18, 2021?
 * const result = previousWednesday(new Date(2021, 5, 18))
 * //=> Wed June 16 2021 00:00:00
 */
function previousWednesday(date) {
  return (0, _index$6i.previousDay)(date, 3);
}

var quartersToMonths$1 = {};

quartersToMonths$1.quartersToMonths = quartersToMonths;
var _index$6h = constants$1;

/**
 * @name quartersToMonths
 * @category Conversion Helpers
 * @summary Convert number of quarters to months.
 *
 * @description
 * Convert a number of quarters to a full number of months.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in months
 *
 * @example
 * // Convert 2 quarters to months
 * const result = quartersToMonths(2)
 * //=> 6
 */
function quartersToMonths(quarters) {
  return Math.trunc(quarters * _index$6h.monthsInQuarter);
}

var quartersToYears$1 = {};

quartersToYears$1.quartersToYears = quartersToYears;
var _index$6g = constants$1;

/**
 * @name quartersToYears
 * @category Conversion Helpers
 * @summary Convert number of quarters to years.
 *
 * @description
 * Convert a number of quarters to a full number of years.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param quarters - The number of quarters to be converted
 *
 * @returns The number of quarters converted in years
 *
 * @example
 * // Convert 8 quarters to years
 * const result = quartersToYears(8)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = quartersToYears(11)
 * //=> 2
 */
function quartersToYears(quarters) {
  const years = quarters / _index$6g.quartersInYear;
  return Math.trunc(years);
}

var roundToNearestHours$1 = {};

roundToNearestHours$1.roundToNearestHours = roundToNearestHours;
var _index$6f = getRoundingMethod$1;
var _index2$2Y = constructFrom$1;
var _index3$1A = toDate$1;

/**
 * The {@link roundToNearestHours} function options.
 */

/**
 * @name roundToNearestHours
 * @category Hour Helpers
 * @summary Rounds the given date to the nearest hour
 *
 * @description
 * Rounds the given date to the nearest hour (or number of hours).
 * Rounds up when the given date is exactly between the nearest round hours.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest hour
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56))
 * //=> Thu Jul 10 2014 13:00:00
 *
 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 6 })
 * //=> Thu Jul 10 2014 12:00:00

 * @example
 * // Round 10 July 2014 12:34:56 to nearest half hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { nearestTo: 8 })
 * //=> Thu Jul 10 2014 16:00:00

* @example
 * // Floor (rounds down) 10 July 2014 12:34:56 to nearest hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 1, 23, 45), { roundingMethod: 'ceil' })
 * //=> Thu Jul 10 2014 02:00:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:34:56 to nearest quarter hour:
 * const result = roundToNearestHours(new Date(2014, 6, 10, 12, 34, 56), { roundingMethod: 'floor', nearestTo: 8 })
 * //=> Thu Jul 10 2014 08:00:00
 */
function roundToNearestHours(date, options) {
  const nearestTo = options?.nearestTo ?? 1;

  if (nearestTo < 1 || nearestTo > 12)
    return (0, _index2$2Y.constructFrom)(date, NaN);

  const _date = (0, _index3$1A.toDate)(date);
  const fractionalMinutes = _date.getMinutes() / 60;
  const fractionalSeconds = _date.getSeconds() / 60 / 60;
  const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60 / 60;
  const hours =
    _date.getHours() +
    fractionalMinutes +
    fractionalSeconds +
    fractionalMilliseconds;

  // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = (0, _index$6f.getRoundingMethod)(method);

  // nearestTo option does not care daylight savings time
  const roundedHours = roundingMethod(hours / nearestTo) * nearestTo;

  const result = (0, _index2$2Y.constructFrom)(date, _date);
  result.setHours(roundedHours, 0, 0, 0);
  return result;
}

var roundToNearestMinutes$1 = {};

roundToNearestMinutes$1.roundToNearestMinutes = roundToNearestMinutes;
var _index$6e = getRoundingMethod$1;
var _index2$2X = constructFrom$1;
var _index3$1z = toDate$1;

/**
 * The {@link roundToNearestMinutes} function options.
 */

/**
 * @name roundToNearestMinutes
 * @category Minute Helpers
 * @summary Rounds the given date to the nearest minute
 *
 * @description
 * Rounds the given date to the nearest minute (or number of minutes).
 * Rounds up when the given date is exactly between the nearest round minutes.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to round
 * @param options - An object with options.
 *
 * @returns The new date rounded to the closest minute
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
 * //=> Thu Jul 10 2014 12:13:00
 *
 * @example
 * // Round 10 July 2014 12:12:34 to nearest quarter hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
 * //=> Thu Jul 10 2014 12:15:00
 *
 * @example
 * // Floor (rounds down) 10 July 2014 12:12:34 to nearest minute:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'floor' })
 * //=> Thu Jul 10 2014 12:12:00
 *
 * @example
 * // Ceil (rounds up) 10 July 2014 12:12:34 to nearest half hour:
 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { roundingMethod: 'ceil', nearestTo: 30 })
 * //=> Thu Jul 10 2014 12:30:00
 */
function roundToNearestMinutes(date, options) {
  const nearestTo = options?.nearestTo ?? 1;

  if (nearestTo < 1 || nearestTo > 30)
    return (0, _index2$2X.constructFrom)(date, NaN);

  const _date = (0, _index3$1z.toDate)(date);
  const fractionalSeconds = _date.getSeconds() / 60;
  const fractionalMilliseconds = _date.getMilliseconds() / 1000 / 60;
  const minutes =
    _date.getMinutes() + fractionalSeconds + fractionalMilliseconds;

  // Unlike the `differenceIn*` functions, the default rounding behavior is `round` and not 'trunc'
  const method = options?.roundingMethod ?? "round";
  const roundingMethod = (0, _index$6e.getRoundingMethod)(method);

  const roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;

  const result = (0, _index2$2X.constructFrom)(date, _date);
  result.setMinutes(roundedMinutes, 0, 0);
  return result;
}

var secondsToHours$1 = {};

secondsToHours$1.secondsToHours = secondsToHours;
var _index$6d = constants$1;

/**
 * @name secondsToHours
 * @category Conversion Helpers
 * @summary Convert seconds to hours.
 *
 * @description
 * Convert a number of seconds to a full number of hours.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in hours
 *
 * @example
 * // Convert 7200 seconds into hours
 * const result = secondsToHours(7200)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToHours(7199)
 * //=> 1
 */
function secondsToHours(seconds) {
  const hours = seconds / _index$6d.secondsInHour;
  return Math.trunc(hours);
}

var secondsToMilliseconds$1 = {};

secondsToMilliseconds$1.secondsToMilliseconds = secondsToMilliseconds;
var _index$6c = constants$1;

/**
 * @name secondsToMilliseconds
 * @category Conversion Helpers
 * @summary Convert seconds to milliseconds.
 *
 * @description
 * Convert a number of seconds to a full number of milliseconds.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in milliseconds
 *
 * @example
 * // Convert 2 seconds into milliseconds
 * const result = secondsToMilliseconds(2)
 * //=> 2000
 */
function secondsToMilliseconds(seconds) {
  return seconds * _index$6c.millisecondsInSecond;
}

var secondsToMinutes$1 = {};

secondsToMinutes$1.secondsToMinutes = secondsToMinutes;
var _index$6b = constants$1;

/**
 * @name secondsToMinutes
 * @category Conversion Helpers
 * @summary Convert seconds to minutes.
 *
 * @description
 * Convert a number of seconds to a full number of minutes.
 *
 * @param seconds - The number of seconds to be converted
 *
 * @returns The number of seconds converted in minutes
 *
 * @example
 * // Convert 120 seconds into minutes
 * const result = secondsToMinutes(120)
 * //=> 2
 *
 * @example
 * // It uses floor rounding:
 * const result = secondsToMinutes(119)
 * //=> 1
 */
function secondsToMinutes(seconds) {
  const minutes = seconds / _index$6b.secondsInMinute;
  return Math.trunc(minutes);
}

var set$1 = {};

var setMonth$1 = {};

setMonth$1.setMonth = setMonth;
var _index$6a = constructFrom$1;
var _index2$2W = getDaysInMonth$1;
var _index3$1y = toDate$1;

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param month - The month index to set (0-11)
 *
 * @returns The new date with the month set
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(date, month) {
  const _date = (0, _index3$1y.toDate)(date);
  const year = _date.getFullYear();
  const day = _date.getDate();

  const dateWithDesiredMonth = (0, _index$6a.constructFrom)(date, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = (0, _index2$2W.getDaysInMonth)(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}

set$1.set = set;
var _index$69 = constructFrom$1;
var _index2$2V = setMonth$1;
var _index3$1x = toDate$1;

/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param values - The date values to be set
 *
 * @returns The new date with options set
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */

function set(date, values) {
  let _date = (0, _index3$1x.toDate)(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return (0, _index$69.constructFrom)(date, NaN);
  }

  if (values.year != null) {
    _date.setFullYear(values.year);
  }

  if (values.month != null) {
    _date = (0, _index2$2V.setMonth)(_date, values.month);
  }

  if (values.date != null) {
    _date.setDate(values.date);
  }

  if (values.hours != null) {
    _date.setHours(values.hours);
  }

  if (values.minutes != null) {
    _date.setMinutes(values.minutes);
  }

  if (values.seconds != null) {
    _date.setSeconds(values.seconds);
  }

  if (values.milliseconds != null) {
    _date.setMilliseconds(values.milliseconds);
  }

  return _date;
}

var setDate$1 = {};

setDate$1.setDate = setDate;
var _index$68 = toDate$1;

/**
 * @name setDate
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfMonth - The day of the month of the new date
 *
 * @returns The new date with the day of the month set
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * const result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate(date, dayOfMonth) {
  const _date = (0, _index$68.toDate)(date);
  _date.setDate(dayOfMonth);
  return _date;
}

var setDayOfYear$1 = {};

setDayOfYear$1.setDayOfYear = setDayOfYear;
var _index$67 = toDate$1;

/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear(date, dayOfYear) {
  const _date = (0, _index$67.toDate)(date);
  _date.setMonth(0);
  _date.setDate(dayOfYear);
  return _date;
}

var setDefaultOptions$1 = {};

setDefaultOptions$1.setDefaultOptions = setDefaultOptions;

var _index$66 = defaultOptions$1;

/**
 * @name setDefaultOptions
 * @category Common Helpers
 * @summary Set default options including locale.
 * @pure false
 *
 * @description
 * Sets the defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * @param options - An object with options
 *
 * @example
 * // Set global locale:
 * import { es } from 'date-fns/locale'
 * setDefaultOptions({ locale: es })
 * const result = format(new Date(2014, 8, 2), 'PPPP')
 * //=> 'martes, 2 de septiembre de 2014'
 *
 * @example
 * // Start of the week for 2 September 2014:
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Start of the week for 2 September 2014,
 * // when we set that week starts on Monday by default:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Mon Sep 01 2014 00:00:00
 *
 * @example
 * // Manually set options take priority over default options:
 * setDefaultOptions({ weekStartsOn: 1 })
 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Remove the option by setting it to `undefined`:
 * setDefaultOptions({ weekStartsOn: 1 })
 * setDefaultOptions({ weekStartsOn: undefined })
 * const result = startOfWeek(new Date(2014, 8, 2))
 * //=> Sun Aug 31 2014 00:00:00
 */
function setDefaultOptions(options) {
  const result = {};
  const defaultOptions = (0, _index$66.getDefaultOptions)();

  for (const property in defaultOptions) {
    if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      result[property] = defaultOptions[property];
    }
  }

  for (const property in options) {
    if (Object.prototype.hasOwnProperty.call(options, property)) {
      if (options[property] === undefined) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        delete result[property];
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        result[property] = options[property];
      }
    }
  }

  (0, _index$66.setDefaultOptions)(result);
}

var setHours$1 = {};

setHours$1.setHours = setHours;
var _index$65 = toDate$1;

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param hours - The hours of the new date
 *
 * @returns The new date with the hours set
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(date, hours) {
  const _date = (0, _index$65.toDate)(date);
  _date.setHours(hours);
  return _date;
}

var setMilliseconds$1 = {};

setMilliseconds$1.setMilliseconds = setMilliseconds;
var _index$64 = toDate$1;

/**
 * @name setMilliseconds
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param milliseconds - The milliseconds of the new date
 *
 * @returns The new date with the milliseconds set
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds(date, milliseconds) {
  const _date = (0, _index$64.toDate)(date);
  _date.setMilliseconds(milliseconds);
  return _date;
}

var setMinutes$1 = {};

setMinutes$1.setMinutes = setMinutes;
var _index$63 = toDate$1;

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param minutes - The minutes of the new date
 *
 * @returns The new date with the minutes set
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(date, minutes) {
  const _date = (0, _index$63.toDate)(date);
  _date.setMinutes(minutes);
  return _date;
}

var setQuarter$1 = {};

setQuarter$1.setQuarter = setQuarter;
var _index$62 = setMonth$1;
var _index2$2U = toDate$1;

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param quarter - The quarter of the new date
 *
 * @returns The new date with the quarter set
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(date, quarter) {
  const _date = (0, _index2$2U.toDate)(date);
  const oldQuarter = Math.trunc(_date.getMonth() / 3) + 1;
  const diff = quarter - oldQuarter;
  return (0, _index$62.setMonth)(_date, _date.getMonth() + diff * 3);
}

var setSeconds$1 = {};

setSeconds$1.setSeconds = setSeconds;
var _index$61 = toDate$1;

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param seconds - The seconds of the new date
 *
 * @returns The new date with the seconds set
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(date, seconds) {
  const _date = (0, _index$61.toDate)(date);
  _date.setSeconds(seconds);
  return _date;
}

var setWeekYear$1 = {};

setWeekYear$1.setWeekYear = setWeekYear;
var _index$60 = constructFrom$1;
var _index2$2T = differenceInCalendarDays$1;
var _index3$1w = startOfWeekYear$1;
var _index4$1u = toDate$1;

var _index5$1u = defaultOptions$1;

/**
 * The {@link setWeekYear} function options.
 */

/**
 * @name setWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Set the local week-numbering year to the given date.
 *
 * @description
 * Set the local week-numbering year to the given date,
 * saving the week number and the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param weekYear - The local week-numbering year of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week-numbering year set
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
 * //=> Sat Jan 03 2004 00:00:00
 *
 * @example
 * // Set the local week-numbering year 2004 to 2 January 2010,
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sat Jan 01 2005 00:00:00
 */
function setWeekYear(date, weekYear, options) {
  const defaultOptions = (0, _index5$1u.getDefaultOptions)();
  const firstWeekContainsDate =
    options?.firstWeekContainsDate ??
    options?.locale?.options?.firstWeekContainsDate ??
    defaultOptions.firstWeekContainsDate ??
    defaultOptions.locale?.options?.firstWeekContainsDate ??
    1;

  let _date = (0, _index4$1u.toDate)(date);
  const diff = (0, _index2$2T.differenceInCalendarDays)(
    _date,
    (0, _index3$1w.startOfWeekYear)(_date, options),
  );
  const firstWeek = (0, _index$60.constructFrom)(date, 0);
  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  _date = (0, _index3$1w.startOfWeekYear)(firstWeek, options);
  _date.setDate(_date.getDate() + diff);
  return _date;
}

var setYear$1 = {};

setYear$1.setYear = setYear;
var _index$5$ = constructFrom$1;
var _index2$2S = toDate$1;

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param year - The year of the new date
 *
 * @returns The new date with the year set
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(date, year) {
  const _date = (0, _index2$2S.toDate)(date);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(+_date)) {
    return (0, _index$5$.constructFrom)(date, NaN);
  }

  _date.setFullYear(year);
  return _date;
}

var startOfDecade$1 = {};

startOfDecade$1.startOfDecade = startOfDecade;
var _index$5_ = toDate$1;

/**
 * @name startOfDecade
 * @category Decade Helpers
 * @summary Return the start of a decade for the given date.
 *
 * @description
 * Return the start of a decade for the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a decade
 *
 * @example
 * // The start of a decade for 21 October 2015 00:00:00:
 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
 * //=> Jan 01 2010 00:00:00
 */
function startOfDecade(date) {
  // TODO: Switch to more technical definition in of decades that start with 1
  // end with 0. I.e. 2001-2010 instead of current 2000-2009. It's a breaking
  // change, so it can only be done in 4.0.
  const _date = (0, _index$5_.toDate)(date);
  const year = _date.getFullYear();
  const decade = Math.floor(year / 10) * 10;
  _date.setFullYear(decade, 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}

var startOfToday$1 = {};

startOfToday$1.startOfToday = startOfToday;
var _index$5Z = startOfDay$1;

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * @returns The start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday() {
  return (0, _index$5Z.startOfDay)(Date.now());
}

var startOfTomorrow$1 = {};

startOfTomorrow$1.startOfTomorrow = startOfTomorrow; /**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns The start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const date = new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

var startOfYesterday$1 = {};

startOfYesterday$1.startOfYesterday = startOfYesterday; /**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns The start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const date = new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

var sub$1 = {};

var subMonths$1 = {};

subMonths$1.subMonths = subMonths;
var _index$5Y = addMonths$1;

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be subtracted.
 *
 * @returns The new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(date, amount) {
  return (0, _index$5Y.addMonths)(date, -amount);
}

sub$1.sub = sub;
var _index$5X = subDays$1;
var _index2$2R = subMonths$1;

var _index3$1v = constructFrom$1;

/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param duration - The object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */
function sub(date, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
  } = duration;

  // Subtract years and months
  const dateWithoutMonths = (0, _index2$2R.subMonths)(date, months + years * 12);

  // Subtract weeks and days
  const dateWithoutDays = (0, _index$5X.subDays)(
    dateWithoutMonths,
    days + weeks * 7,
  );

  // Subtract hours, minutes and seconds
  const minutestoSub = minutes + hours * 60;
  const secondstoSub = seconds + minutestoSub * 60;
  const mstoSub = secondstoSub * 1000;
  const finalDate = (0, _index3$1v.constructFrom)(
    date,
    dateWithoutDays.getTime() - mstoSub,
  );

  return finalDate;
}

var subBusinessDays$1 = {};

subBusinessDays$1.subBusinessDays = subBusinessDays;
var _index$5W = addBusinessDays$1;

/**
 * @name subBusinessDays
 * @category Day Helpers
 * @summary Substract the specified number of business days (mon - fri) to the given date.
 *
 * @description
 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of business days to be subtracted.
 *
 * @returns The new date with the business days subtracted
 *
 * @example
 * // Substract 10 business days from 1 September 2014:
 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
 */
function subBusinessDays(date, amount) {
  return (0, _index$5W.addBusinessDays)(date, -amount);
}

var subHours$1 = {};

subHours$1.subHours = subHours;
var _index$5V = addHours$1;

/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of hours to be subtracted.
 *
 * @returns The new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours(date, amount) {
  return (0, _index$5V.addHours)(date, -amount);
}

var subMilliseconds$1 = {};

subMilliseconds$1.subMilliseconds = subMilliseconds;
var _index$5U = addMilliseconds$1;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of milliseconds to be subtracted.
 *
 * @returns The new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(date, amount) {
  return (0, _index$5U.addMilliseconds)(date, -amount);
}

var subMinutes$1 = {};

subMinutes$1.subMinutes = subMinutes;
var _index$5T = addMinutes$1;

/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be subtracted.
 *
 * @returns The new date with the minutes subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes(date, amount) {
  return (0, _index$5T.addMinutes)(date, -amount);
}

var subQuarters$1 = {};

subQuarters$1.subQuarters = subQuarters;
var _index$5S = addQuarters$1;

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of quarters to be subtracted.
 *
 * @returns The new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters(date, amount) {
  return (0, _index$5S.addQuarters)(date, -amount);
}

var subSeconds$1 = {};

subSeconds$1.subSeconds = subSeconds;
var _index$5R = addSeconds$1;

/**
 * @name subSeconds
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of seconds to be subtracted.
 *
 * @returns The new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds(date, amount) {
  return (0, _index$5R.addSeconds)(date, -amount);
}

var subWeeks$1 = {};

subWeeks$1.subWeeks = subWeeks;
var _index$5Q = addWeeks$1;

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of weeks to be subtracted.
 *
 * @returns The new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(date, amount) {
  return (0, _index$5Q.addWeeks)(date, -amount);
}

var subYears$1 = {};

subYears$1.subYears = subYears;
var _index$5P = addYears$1;

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be subtracted.
 *
 * @returns The new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(date, amount) {
  return (0, _index$5P.addYears)(date, -amount);
}

var weeksToDays$1 = {};

weeksToDays$1.weeksToDays = weeksToDays;
var _index$5O = constants$1;

/**
 * @name weeksToDays
 * @category Conversion Helpers
 * @summary Convert weeks to days.
 *
 * @description
 * Convert a number of weeks to a full number of days.
 *
 * @param weeks - The number of weeks to be converted
 *
 * @returns The number of weeks converted in days
 *
 * @example
 * // Convert 2 weeks into days
 * const result = weeksToDays(2)
 * //=> 14
 */
function weeksToDays(weeks) {
  return Math.trunc(weeks * _index$5O.daysInWeek);
}

var yearsToDays$1 = {};

yearsToDays$1.yearsToDays = yearsToDays;
var _index$5N = constants$1;

/**
 * @name yearsToDays
 * @category Conversion Helpers
 * @summary Convert years to days.
 *
 * @description
 * Convert a number of years to a full number of days.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in days
 *
 * @example
 * // Convert 2 years into days
 * const result = yearsToDays(2)
 * //=> 730
 */
function yearsToDays(years) {
  return Math.trunc(years * _index$5N.daysInYear);
}

var yearsToMonths$1 = {};

yearsToMonths$1.yearsToMonths = yearsToMonths;
var _index$5M = constants$1;

/**
 * @name yearsToMonths
 * @category Conversion Helpers
 * @summary Convert years to months.
 *
 * @description
 * Convert a number of years to a full number of months.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in months
 *
 * @example
 * // Convert 2 years into months
 * const result = yearsToMonths(2)
 * //=> 24
 */
function yearsToMonths(years) {
  return Math.trunc(years * _index$5M.monthsInYear);
}

var yearsToQuarters$1 = {};

yearsToQuarters$1.yearsToQuarters = yearsToQuarters;
var _index$5L = constants$1;

/**
 * @name yearsToQuarters
 * @category Conversion Helpers
 * @summary Convert years to quarters.
 *
 * @description
 * Convert a number of years to a full number of quarters.
 *
 * @param years - The number of years to be converted
 *
 * @returns The number of years converted in quarters
 *
 * @example
 * // Convert 2 years to quarters
 * const result = yearsToQuarters(2)
 * //=> 8
 */
function yearsToQuarters(years) {
  return Math.trunc(years * _index$5L.quartersInYear);
}

(function (exports) {

var _index = add$1;
Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index[key];
    },
  });
});
var _index2 = addBusinessDays$1;
Object.keys(_index2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index2[key];
    },
  });
});
var _index3 = addDays$1;
Object.keys(_index3).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index3[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index3[key];
    },
  });
});
var _index4 = addHours$1;
Object.keys(_index4).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index4[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index4[key];
    },
  });
});
var _index5 = addISOWeekYears$1;
Object.keys(_index5).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index5[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index5[key];
    },
  });
});
var _index6 = addMilliseconds$1;
Object.keys(_index6).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index6[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index6[key];
    },
  });
});
var _index7 = addMinutes$1;
Object.keys(_index7).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index7[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index7[key];
    },
  });
});
var _index8 = addMonths$1;
Object.keys(_index8).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index8[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index8[key];
    },
  });
});
var _index9 = addQuarters$1;
Object.keys(_index9).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index9[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index9[key];
    },
  });
});
var _index10 = addSeconds$1;
Object.keys(_index10).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index10[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index10[key];
    },
  });
});
var _index11 = addWeeks$1;
Object.keys(_index11).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index11[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index11[key];
    },
  });
});
var _index12 = addYears$1;
Object.keys(_index12).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index12[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index12[key];
    },
  });
});
var _index13 = areIntervalsOverlapping$1;
Object.keys(_index13).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index13[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index13[key];
    },
  });
});
var _index14 = clamp$1;
Object.keys(_index14).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index14[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index14[key];
    },
  });
});
var _index15 = closestIndexTo$1;
Object.keys(_index15).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index15[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index15[key];
    },
  });
});
var _index16 = closestTo$1;
Object.keys(_index16).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index16[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index16[key];
    },
  });
});
var _index17 = compareAsc$1;
Object.keys(_index17).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index17[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index17[key];
    },
  });
});
var _index18 = compareDesc$1;
Object.keys(_index18).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index18[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index18[key];
    },
  });
});
var _index19 = constructFrom$1;
Object.keys(_index19).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index19[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index19[key];
    },
  });
});
var _index20 = constructNow$1;
Object.keys(_index20).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index20[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index20[key];
    },
  });
});
var _index21 = daysToWeeks$1;
Object.keys(_index21).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index21[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index21[key];
    },
  });
});
var _index22 = differenceInBusinessDays$1;
Object.keys(_index22).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index22[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index22[key];
    },
  });
});
var _index23 = differenceInCalendarDays$1;
Object.keys(_index23).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index23[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index23[key];
    },
  });
});
var _index24 = differenceInCalendarISOWeekYears$1;
Object.keys(_index24).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index24[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index24[key];
    },
  });
});
var _index25 = differenceInCalendarISOWeeks$1;
Object.keys(_index25).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index25[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index25[key];
    },
  });
});
var _index26 = differenceInCalendarMonths$1;
Object.keys(_index26).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index26[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index26[key];
    },
  });
});
var _index27 = differenceInCalendarQuarters$1;
Object.keys(_index27).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index27[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index27[key];
    },
  });
});
var _index28 = differenceInCalendarWeeks$1;
Object.keys(_index28).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index28[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index28[key];
    },
  });
});
var _index29 = differenceInCalendarYears$1;
Object.keys(_index29).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index29[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index29[key];
    },
  });
});
var _index30 = differenceInDays$1;
Object.keys(_index30).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index30[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index30[key];
    },
  });
});
var _index31 = differenceInHours$1;
Object.keys(_index31).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index31[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index31[key];
    },
  });
});
var _index32 = differenceInISOWeekYears$1;
Object.keys(_index32).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index32[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index32[key];
    },
  });
});
var _index33 = differenceInMilliseconds$1;
Object.keys(_index33).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index33[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index33[key];
    },
  });
});
var _index34 = differenceInMinutes$1;
Object.keys(_index34).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index34[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index34[key];
    },
  });
});
var _index35 = differenceInMonths$1;
Object.keys(_index35).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index35[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index35[key];
    },
  });
});
var _index36 = differenceInQuarters$1;
Object.keys(_index36).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index36[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index36[key];
    },
  });
});
var _index37 = differenceInSeconds$1;
Object.keys(_index37).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index37[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index37[key];
    },
  });
});
var _index38 = differenceInWeeks$1;
Object.keys(_index38).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index38[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index38[key];
    },
  });
});
var _index39 = differenceInYears$1;
Object.keys(_index39).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index39[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index39[key];
    },
  });
});
var _index40 = eachDayOfInterval$1;
Object.keys(_index40).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index40[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index40[key];
    },
  });
});
var _index41 = eachHourOfInterval$1;
Object.keys(_index41).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index41[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index41[key];
    },
  });
});
var _index42 = eachMinuteOfInterval$1;
Object.keys(_index42).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index42[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index42[key];
    },
  });
});
var _index43 = eachMonthOfInterval$1;
Object.keys(_index43).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index43[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index43[key];
    },
  });
});
var _index44 = eachQuarterOfInterval$1;
Object.keys(_index44).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index44[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index44[key];
    },
  });
});
var _index45 = eachWeekOfInterval$1;
Object.keys(_index45).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index45[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index45[key];
    },
  });
});
var _index46 = eachWeekendOfInterval$1;
Object.keys(_index46).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index46[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index46[key];
    },
  });
});
var _index47 = eachWeekendOfMonth$1;
Object.keys(_index47).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index47[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index47[key];
    },
  });
});
var _index48 = eachWeekendOfYear$1;
Object.keys(_index48).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index48[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index48[key];
    },
  });
});
var _index49 = eachYearOfInterval$1;
Object.keys(_index49).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index49[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index49[key];
    },
  });
});
var _index50 = endOfDay$1;
Object.keys(_index50).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index50[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index50[key];
    },
  });
});
var _index51 = endOfDecade$1;
Object.keys(_index51).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index51[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index51[key];
    },
  });
});
var _index52 = endOfHour$1;
Object.keys(_index52).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index52[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index52[key];
    },
  });
});
var _index53 = endOfISOWeek$1;
Object.keys(_index53).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index53[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index53[key];
    },
  });
});
var _index54 = endOfISOWeekYear$1;
Object.keys(_index54).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index54[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index54[key];
    },
  });
});
var _index55 = endOfMinute$1;
Object.keys(_index55).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index55[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index55[key];
    },
  });
});
var _index56 = endOfMonth$1;
Object.keys(_index56).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index56[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index56[key];
    },
  });
});
var _index57 = endOfQuarter$1;
Object.keys(_index57).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index57[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index57[key];
    },
  });
});
var _index58 = endOfSecond$1;
Object.keys(_index58).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index58[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index58[key];
    },
  });
});
var _index59 = endOfToday$1;
Object.keys(_index59).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index59[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index59[key];
    },
  });
});
var _index60 = endOfTomorrow$1;
Object.keys(_index60).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index60[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index60[key];
    },
  });
});
var _index61 = endOfWeek$1;
Object.keys(_index61).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index61[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index61[key];
    },
  });
});
var _index62 = endOfYear$1;
Object.keys(_index62).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index62[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index62[key];
    },
  });
});
var _index63 = endOfYesterday$1;
Object.keys(_index63).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index63[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index63[key];
    },
  });
});
var _index64 = format;
Object.keys(_index64).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index64[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index64[key];
    },
  });
});
var _index65 = formatDistance$2F;
Object.keys(_index65).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index65[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index65[key];
    },
  });
});
var _index66 = formatDistanceStrict$1;
Object.keys(_index66).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index66[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index66[key];
    },
  });
});
var _index67 = formatDistanceToNow$1;
Object.keys(_index67).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index67[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index67[key];
    },
  });
});
var _index68 = formatDistanceToNowStrict$1;
Object.keys(_index68).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index68[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index68[key];
    },
  });
});
var _index69 = formatDuration$1;
Object.keys(_index69).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index69[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index69[key];
    },
  });
});
var _index70 = formatISO$1;
Object.keys(_index70).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index70[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index70[key];
    },
  });
});
var _index71 = formatISO9075$1;
Object.keys(_index71).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index71[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index71[key];
    },
  });
});
var _index72 = formatISODuration$1;
Object.keys(_index72).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index72[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index72[key];
    },
  });
});
var _index73 = formatRFC3339$1;
Object.keys(_index73).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index73[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index73[key];
    },
  });
});
var _index74 = formatRFC7231$1;
Object.keys(_index74).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index74[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index74[key];
    },
  });
});
var _index75 = formatRelative$2F;
Object.keys(_index75).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index75[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index75[key];
    },
  });
});
var _index76 = fromUnixTime$1;
Object.keys(_index76).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index76[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index76[key];
    },
  });
});
var _index77 = getDate$1;
Object.keys(_index77).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index77[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index77[key];
    },
  });
});
var _index78 = getDay$1;
Object.keys(_index78).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index78[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index78[key];
    },
  });
});
var _index79 = getDayOfYear$1;
Object.keys(_index79).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index79[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index79[key];
    },
  });
});
var _index80 = getDaysInMonth$1;
Object.keys(_index80).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index80[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index80[key];
    },
  });
});
var _index81 = getDaysInYear$1;
Object.keys(_index81).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index81[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index81[key];
    },
  });
});
var _index82 = getDecade$1;
Object.keys(_index82).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index82[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index82[key];
    },
  });
});
var _index83 = getDefaultOptions$1;
Object.keys(_index83).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index83[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index83[key];
    },
  });
});
var _index84 = getHours$1;
Object.keys(_index84).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index84[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index84[key];
    },
  });
});
var _index85 = getISODay$1;
Object.keys(_index85).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index85[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index85[key];
    },
  });
});
var _index86 = getISOWeek$1;
Object.keys(_index86).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index86[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index86[key];
    },
  });
});
var _index87 = getISOWeekYear$1;
Object.keys(_index87).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index87[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index87[key];
    },
  });
});
var _index88 = getISOWeeksInYear$1;
Object.keys(_index88).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index88[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index88[key];
    },
  });
});
var _index89 = getMilliseconds$1;
Object.keys(_index89).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index89[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index89[key];
    },
  });
});
var _index90 = getMinutes$1;
Object.keys(_index90).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index90[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index90[key];
    },
  });
});
var _index91 = getMonth$1;
Object.keys(_index91).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index91[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index91[key];
    },
  });
});
var _index92 = getOverlappingDaysInIntervals$1;
Object.keys(_index92).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index92[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index92[key];
    },
  });
});
var _index93 = getQuarter$1;
Object.keys(_index93).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index93[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index93[key];
    },
  });
});
var _index94 = getSeconds$1;
Object.keys(_index94).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index94[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index94[key];
    },
  });
});
var _index95 = getTime$1;
Object.keys(_index95).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index95[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index95[key];
    },
  });
});
var _index96 = getUnixTime$1;
Object.keys(_index96).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index96[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index96[key];
    },
  });
});
var _index97 = getWeek$1;
Object.keys(_index97).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index97[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index97[key];
    },
  });
});
var _index98 = getWeekOfMonth$1;
Object.keys(_index98).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index98[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index98[key];
    },
  });
});
var _index99 = getWeekYear$1;
Object.keys(_index99).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index99[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index99[key];
    },
  });
});
var _index100 = getWeeksInMonth$1;
Object.keys(_index100).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index100[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index100[key];
    },
  });
});
var _index101 = getYear$1;
Object.keys(_index101).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index101[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index101[key];
    },
  });
});
var _index102 = hoursToMilliseconds$1;
Object.keys(_index102).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index102[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index102[key];
    },
  });
});
var _index103 = hoursToMinutes$1;
Object.keys(_index103).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index103[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index103[key];
    },
  });
});
var _index104 = hoursToSeconds$1;
Object.keys(_index104).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index104[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index104[key];
    },
  });
});
var _index105 = interval$1;
Object.keys(_index105).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index105[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index105[key];
    },
  });
});
var _index106 = intervalToDuration$1;
Object.keys(_index106).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index106[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index106[key];
    },
  });
});
var _index107 = intlFormat$1;
Object.keys(_index107).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index107[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index107[key];
    },
  });
});
var _index108 = intlFormatDistance$1;
Object.keys(_index108).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index108[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index108[key];
    },
  });
});
var _index109 = isAfter$1;
Object.keys(_index109).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index109[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index109[key];
    },
  });
});
var _index110 = isBefore$1;
Object.keys(_index110).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index110[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index110[key];
    },
  });
});
var _index111 = isDate$1;
Object.keys(_index111).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index111[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index111[key];
    },
  });
});
var _index112 = isEqual$1;
Object.keys(_index112).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index112[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index112[key];
    },
  });
});
var _index113 = isExists$1;
Object.keys(_index113).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index113[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index113[key];
    },
  });
});
var _index114 = isFirstDayOfMonth$1;
Object.keys(_index114).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index114[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index114[key];
    },
  });
});
var _index115 = isFriday$1;
Object.keys(_index115).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index115[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index115[key];
    },
  });
});
var _index116 = isFuture$1;
Object.keys(_index116).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index116[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index116[key];
    },
  });
});
var _index117 = isLastDayOfMonth$1;
Object.keys(_index117).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index117[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index117[key];
    },
  });
});
var _index118 = isLeapYear$1;
Object.keys(_index118).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index118[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index118[key];
    },
  });
});
var _index119 = isMatch$1;
Object.keys(_index119).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index119[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index119[key];
    },
  });
});
var _index120 = isMonday$1;
Object.keys(_index120).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index120[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index120[key];
    },
  });
});
var _index121 = isPast$1;
Object.keys(_index121).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index121[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index121[key];
    },
  });
});
var _index122 = isSameDay$1;
Object.keys(_index122).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index122[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index122[key];
    },
  });
});
var _index123 = isSameHour$1;
Object.keys(_index123).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index123[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index123[key];
    },
  });
});
var _index124 = isSameISOWeek$1;
Object.keys(_index124).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index124[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index124[key];
    },
  });
});
var _index125 = isSameISOWeekYear$1;
Object.keys(_index125).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index125[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index125[key];
    },
  });
});
var _index126 = isSameMinute$1;
Object.keys(_index126).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index126[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index126[key];
    },
  });
});
var _index127 = isSameMonth$1;
Object.keys(_index127).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index127[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index127[key];
    },
  });
});
var _index128 = isSameQuarter$1;
Object.keys(_index128).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index128[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index128[key];
    },
  });
});
var _index129 = isSameSecond$1;
Object.keys(_index129).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index129[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index129[key];
    },
  });
});
var _index130 = isSameWeek$1;
Object.keys(_index130).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index130[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index130[key];
    },
  });
});
var _index131 = isSameYear$1;
Object.keys(_index131).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index131[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index131[key];
    },
  });
});
var _index132 = isSaturday$1;
Object.keys(_index132).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index132[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index132[key];
    },
  });
});
var _index133 = isSunday$1;
Object.keys(_index133).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index133[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index133[key];
    },
  });
});
var _index134 = isThisHour$1;
Object.keys(_index134).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index134[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index134[key];
    },
  });
});
var _index135 = isThisISOWeek$1;
Object.keys(_index135).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index135[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index135[key];
    },
  });
});
var _index136 = isThisMinute$1;
Object.keys(_index136).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index136[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index136[key];
    },
  });
});
var _index137 = isThisMonth$1;
Object.keys(_index137).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index137[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index137[key];
    },
  });
});
var _index138 = isThisQuarter$1;
Object.keys(_index138).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index138[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index138[key];
    },
  });
});
var _index139 = isThisSecond$1;
Object.keys(_index139).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index139[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index139[key];
    },
  });
});
var _index140 = isThisWeek$1;
Object.keys(_index140).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index140[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index140[key];
    },
  });
});
var _index141 = isThisYear$1;
Object.keys(_index141).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index141[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index141[key];
    },
  });
});
var _index142 = isThursday$1;
Object.keys(_index142).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index142[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index142[key];
    },
  });
});
var _index143 = isToday$1;
Object.keys(_index143).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index143[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index143[key];
    },
  });
});
var _index144 = isTomorrow$1;
Object.keys(_index144).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index144[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index144[key];
    },
  });
});
var _index145 = isTuesday$1;
Object.keys(_index145).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index145[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index145[key];
    },
  });
});
var _index146 = isValid$1;
Object.keys(_index146).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index146[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index146[key];
    },
  });
});
var _index147 = isWednesday$1;
Object.keys(_index147).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index147[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index147[key];
    },
  });
});
var _index148 = isWeekend$1;
Object.keys(_index148).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index148[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index148[key];
    },
  });
});
var _index149 = isWithinInterval$1;
Object.keys(_index149).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index149[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index149[key];
    },
  });
});
var _index150 = isYesterday$1;
Object.keys(_index150).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index150[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index150[key];
    },
  });
});
var _index151 = lastDayOfDecade$1;
Object.keys(_index151).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index151[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index151[key];
    },
  });
});
var _index152 = lastDayOfISOWeek$1;
Object.keys(_index152).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index152[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index152[key];
    },
  });
});
var _index153 = lastDayOfISOWeekYear$1;
Object.keys(_index153).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index153[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index153[key];
    },
  });
});
var _index154 = lastDayOfMonth$1;
Object.keys(_index154).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index154[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index154[key];
    },
  });
});
var _index155 = lastDayOfQuarter$1;
Object.keys(_index155).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index155[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index155[key];
    },
  });
});
var _index156 = lastDayOfWeek$1;
Object.keys(_index156).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index156[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index156[key];
    },
  });
});
var _index157 = lastDayOfYear$1;
Object.keys(_index157).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index157[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index157[key];
    },
  });
});
var _index158 = lightFormat;
Object.keys(_index158).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index158[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index158[key];
    },
  });
});
var _index159 = max$1;
Object.keys(_index159).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index159[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index159[key];
    },
  });
});
var _index160 = milliseconds$1;
Object.keys(_index160).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index160[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index160[key];
    },
  });
});
var _index161 = millisecondsToHours$1;
Object.keys(_index161).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index161[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index161[key];
    },
  });
});
var _index162 = millisecondsToMinutes$1;
Object.keys(_index162).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index162[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index162[key];
    },
  });
});
var _index163 = millisecondsToSeconds$1;
Object.keys(_index163).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index163[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index163[key];
    },
  });
});
var _index164 = min$1;
Object.keys(_index164).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index164[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index164[key];
    },
  });
});
var _index165 = minutesToHours$1;
Object.keys(_index165).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index165[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index165[key];
    },
  });
});
var _index166 = minutesToMilliseconds$1;
Object.keys(_index166).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index166[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index166[key];
    },
  });
});
var _index167 = minutesToSeconds$1;
Object.keys(_index167).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index167[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index167[key];
    },
  });
});
var _index168 = monthsToQuarters$1;
Object.keys(_index168).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index168[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index168[key];
    },
  });
});
var _index169 = monthsToYears$1;
Object.keys(_index169).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index169[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index169[key];
    },
  });
});
var _index170 = nextDay$1;
Object.keys(_index170).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index170[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index170[key];
    },
  });
});
var _index171 = nextFriday$1;
Object.keys(_index171).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index171[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index171[key];
    },
  });
});
var _index172 = nextMonday$1;
Object.keys(_index172).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index172[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index172[key];
    },
  });
});
var _index173 = nextSaturday$1;
Object.keys(_index173).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index173[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index173[key];
    },
  });
});
var _index174 = nextSunday$1;
Object.keys(_index174).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index174[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index174[key];
    },
  });
});
var _index175 = nextThursday$1;
Object.keys(_index175).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index175[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index175[key];
    },
  });
});
var _index176 = nextTuesday$1;
Object.keys(_index176).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index176[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index176[key];
    },
  });
});
var _index177 = nextWednesday$1;
Object.keys(_index177).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index177[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index177[key];
    },
  });
});
var _index178 = parse$1;
Object.keys(_index178).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index178[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index178[key];
    },
  });
});
var _index179 = parseISO$1;
Object.keys(_index179).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index179[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index179[key];
    },
  });
});
var _index180 = parseJSON$1;
Object.keys(_index180).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index180[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index180[key];
    },
  });
});
var _index181 = previousDay$1;
Object.keys(_index181).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index181[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index181[key];
    },
  });
});
var _index182 = previousFriday$1;
Object.keys(_index182).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index182[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index182[key];
    },
  });
});
var _index183 = previousMonday$1;
Object.keys(_index183).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index183[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index183[key];
    },
  });
});
var _index184 = previousSaturday$1;
Object.keys(_index184).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index184[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index184[key];
    },
  });
});
var _index185 = previousSunday$1;
Object.keys(_index185).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index185[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index185[key];
    },
  });
});
var _index186 = previousThursday$1;
Object.keys(_index186).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index186[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index186[key];
    },
  });
});
var _index187 = previousTuesday$1;
Object.keys(_index187).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index187[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index187[key];
    },
  });
});
var _index188 = previousWednesday$1;
Object.keys(_index188).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index188[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index188[key];
    },
  });
});
var _index189 = quartersToMonths$1;
Object.keys(_index189).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index189[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index189[key];
    },
  });
});
var _index190 = quartersToYears$1;
Object.keys(_index190).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index190[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index190[key];
    },
  });
});
var _index191 = roundToNearestHours$1;
Object.keys(_index191).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index191[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index191[key];
    },
  });
});
var _index192 = roundToNearestMinutes$1;
Object.keys(_index192).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index192[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index192[key];
    },
  });
});
var _index193 = secondsToHours$1;
Object.keys(_index193).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index193[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index193[key];
    },
  });
});
var _index194 = secondsToMilliseconds$1;
Object.keys(_index194).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index194[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index194[key];
    },
  });
});
var _index195 = secondsToMinutes$1;
Object.keys(_index195).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index195[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index195[key];
    },
  });
});
var _index196 = set$1;
Object.keys(_index196).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index196[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index196[key];
    },
  });
});
var _index197 = setDate$1;
Object.keys(_index197).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index197[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index197[key];
    },
  });
});
var _index198 = setDay$1;
Object.keys(_index198).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index198[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index198[key];
    },
  });
});
var _index199 = setDayOfYear$1;
Object.keys(_index199).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index199[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index199[key];
    },
  });
});
var _index200 = setDefaultOptions$1;
Object.keys(_index200).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index200[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index200[key];
    },
  });
});
var _index201 = setHours$1;
Object.keys(_index201).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index201[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index201[key];
    },
  });
});
var _index202 = setISODay$1;
Object.keys(_index202).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index202[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index202[key];
    },
  });
});
var _index203 = setISOWeek$1;
Object.keys(_index203).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index203[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index203[key];
    },
  });
});
var _index204 = setISOWeekYear$1;
Object.keys(_index204).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index204[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index204[key];
    },
  });
});
var _index205 = setMilliseconds$1;
Object.keys(_index205).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index205[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index205[key];
    },
  });
});
var _index206 = setMinutes$1;
Object.keys(_index206).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index206[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index206[key];
    },
  });
});
var _index207 = setMonth$1;
Object.keys(_index207).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index207[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index207[key];
    },
  });
});
var _index208 = setQuarter$1;
Object.keys(_index208).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index208[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index208[key];
    },
  });
});
var _index209 = setSeconds$1;
Object.keys(_index209).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index209[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index209[key];
    },
  });
});
var _index210 = setWeek$1;
Object.keys(_index210).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index210[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index210[key];
    },
  });
});
var _index211 = setWeekYear$1;
Object.keys(_index211).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index211[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index211[key];
    },
  });
});
var _index212 = setYear$1;
Object.keys(_index212).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index212[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index212[key];
    },
  });
});
var _index213 = startOfDay$1;
Object.keys(_index213).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index213[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index213[key];
    },
  });
});
var _index214 = startOfDecade$1;
Object.keys(_index214).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index214[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index214[key];
    },
  });
});
var _index215 = startOfHour$1;
Object.keys(_index215).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index215[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index215[key];
    },
  });
});
var _index216 = startOfISOWeek$1;
Object.keys(_index216).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index216[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index216[key];
    },
  });
});
var _index217 = startOfISOWeekYear$1;
Object.keys(_index217).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index217[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index217[key];
    },
  });
});
var _index218 = startOfMinute$1;
Object.keys(_index218).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index218[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index218[key];
    },
  });
});
var _index219 = startOfMonth$1;
Object.keys(_index219).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index219[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index219[key];
    },
  });
});
var _index220 = startOfQuarter$1;
Object.keys(_index220).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index220[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index220[key];
    },
  });
});
var _index221 = startOfSecond$1;
Object.keys(_index221).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index221[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index221[key];
    },
  });
});
var _index222 = startOfToday$1;
Object.keys(_index222).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index222[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index222[key];
    },
  });
});
var _index223 = startOfTomorrow$1;
Object.keys(_index223).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index223[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index223[key];
    },
  });
});
var _index224 = startOfWeek$1;
Object.keys(_index224).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index224[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index224[key];
    },
  });
});
var _index225 = startOfWeekYear$1;
Object.keys(_index225).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index225[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index225[key];
    },
  });
});
var _index226 = startOfYear$1;
Object.keys(_index226).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index226[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index226[key];
    },
  });
});
var _index227 = startOfYesterday$1;
Object.keys(_index227).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index227[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index227[key];
    },
  });
});
var _index228 = sub$1;
Object.keys(_index228).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index228[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index228[key];
    },
  });
});
var _index229 = subBusinessDays$1;
Object.keys(_index229).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index229[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index229[key];
    },
  });
});
var _index230 = subDays$1;
Object.keys(_index230).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index230[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index230[key];
    },
  });
});
var _index231 = subHours$1;
Object.keys(_index231).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index231[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index231[key];
    },
  });
});
var _index232 = subISOWeekYears$1;
Object.keys(_index232).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index232[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index232[key];
    },
  });
});
var _index233 = subMilliseconds$1;
Object.keys(_index233).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index233[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index233[key];
    },
  });
});
var _index234 = subMinutes$1;
Object.keys(_index234).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index234[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index234[key];
    },
  });
});
var _index235 = subMonths$1;
Object.keys(_index235).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index235[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index235[key];
    },
  });
});
var _index236 = subQuarters$1;
Object.keys(_index236).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index236[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index236[key];
    },
  });
});
var _index237 = subSeconds$1;
Object.keys(_index237).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index237[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index237[key];
    },
  });
});
var _index238 = subWeeks$1;
Object.keys(_index238).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index238[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index238[key];
    },
  });
});
var _index239 = subYears$1;
Object.keys(_index239).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index239[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index239[key];
    },
  });
});
var _index240 = toDate$1;
Object.keys(_index240).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index240[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index240[key];
    },
  });
});
var _index241 = transpose$1;
Object.keys(_index241).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index241[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index241[key];
    },
  });
});
var _index242 = weeksToDays$1;
Object.keys(_index242).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index242[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index242[key];
    },
  });
});
var _index243 = yearsToDays$1;
Object.keys(_index243).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index243[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index243[key];
    },
  });
});
var _index244 = yearsToMonths$1;
Object.keys(_index244).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index244[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index244[key];
    },
  });
});
var _index245 = yearsToQuarters$1;
Object.keys(_index245).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index245[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index245[key];
    },
  });
});
}(dateFns));

var locale = {};

var af = {};

var formatDistance$2D = {};

formatDistance$2D.formatDistance = void 0;

const formatDistanceLocale$1i = {
  lessThanXSeconds: {
    one: "minder as 'n sekonde",
    other: "minder as {{count}} sekondes",
  },

  xSeconds: {
    one: "1 sekonde",
    other: "{{count}} sekondes",
  },

  halfAMinute: "'n halwe minuut",

  lessThanXMinutes: {
    one: "minder as 'n minuut",
    other: "minder as {{count}} minute",
  },

  xMinutes: {
    one: "'n minuut",
    other: "{{count}} minute",
  },

  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} ure",
  },

  xHours: {
    one: "1 uur",
    other: "{{count}} ure",
  },

  xDays: {
    one: "1 dag",
    other: "{{count}} dae",
  },

  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weke",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weke",
  },

  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maande",
  },

  xMonths: {
    one: "1 maand",
    other: "{{count}} maande",
  },

  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar",
  },

  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar",
  },

  overXYears: {
    one: "meer as 1 jaar",
    other: "meer as {{count}} jaar",
  },

  almostXYears: {
    one: "byna 1 jaar",
    other: "byna {{count}} jaar",
  },
};

const formatDistance$2C = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$1i[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "oor " + result;
    } else {
      return result + " gelede";
    }
  }

  return result;
};
formatDistance$2D.formatDistance = formatDistance$2C;

var formatLong$1r = {};

formatLong$1r.formatLong = void 0;
var _index$5K = buildFormatLongFn$1;

const dateFormats$1r = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "yyyy/MM/dd",
};

const timeFormats$1r = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$1r = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1r.formatLong = {
  date: (0, _index$5K.buildFormatLongFn)({
    formats: dateFormats$1r,
    defaultWidth: "full",
  }),

  time: (0, _index$5K.buildFormatLongFn)({
    formats: timeFormats$1r,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$5K.buildFormatLongFn)({
    formats: dateTimeFormats$1r,
    defaultWidth: "full",
  }),
});

var formatRelative$2D = {};

formatRelative$2D.formatRelative = void 0;

const formatRelativeLocale$1j = {
  lastWeek: "'verlede' eeee 'om' p",
  yesterday: "'gister om' p",
  today: "'vandag om' p",
  tomorrow: "'môre om' p",
  nextWeek: "eeee 'om' p",
  other: "P",
};

const formatRelative$2C = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$1j[token];
formatRelative$2D.formatRelative = formatRelative$2C;

var localize$1j = {};

localize$1j.localize = void 0;
var _index$5J = buildLocalizeFn$1;

const eraValues$1j = {
  narrow: ["vC", "nC"],
  abbreviated: ["vC", "nC"],
  wide: ["voor Christus", "na Christus"],
};

const quarterValues$1j = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ste kwartaal", "2de kwartaal", "3de kwartaal", "4de kwartaal"],
};

const monthValues$1j = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mrt",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Des",
  ],

  wide: [
    "Januarie",
    "Februarie",
    "Maart",
    "April",
    "Mei",
    "Junie",
    "Julie",
    "Augustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ],
};

const dayValues$1j = {
  narrow: ["S", "M", "D", "W", "D", "V", "S"],
  short: ["So", "Ma", "Di", "Wo", "Do", "Vr", "Sa"],
  abbreviated: ["Son", "Maa", "Din", "Woe", "Don", "Vry", "Sat"],
  wide: [
    "Sondag",
    "Maandag",
    "Dinsdag",
    "Woensdag",
    "Donderdag",
    "Vrydag",
    "Saterdag",
  ],
};

const dayPeriodValues$1j = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand",
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand",
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand",
  },
};
const formattingDayPeriodValues$13 = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand",
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand",
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand",
  },
};

const ordinalNumber$1j = (dirtyNumber) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 < 20) {
    switch (rem100) {
      case 1:
      case 8:
        return number + "ste";
      default:
        return number + "de";
    }
  }
  return number + "ste";
};

(localize$1j.localize = {
  ordinalNumber: ordinalNumber$1j,

  era: (0, _index$5J.buildLocalizeFn)({
    values: eraValues$1j,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$5J.buildLocalizeFn)({
    values: quarterValues$1j,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$5J.buildLocalizeFn)({
    values: monthValues$1j,
    defaultWidth: "wide",
  }),

  day: (0, _index$5J.buildLocalizeFn)({
    values: dayValues$1j,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$5J.buildLocalizeFn)({
    values: dayPeriodValues$1j,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$13,
    defaultFormattingWidth: "wide",
  }),
});

var match$1i = {};

match$1i.match = void 0;

var _index$5I = buildMatchFn$1;
var _index2$2Q = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$1i = /^(\d+)(ste|de)?/i;
const parseOrdinalNumberPattern$1i = /\d+/i;

const matchEraPatterns$1i = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?C\.?)/,
  wide: /^((voor|na) Christus)/,
};
const parseEraPatterns$1i = {
  any: [/^v/, /^n/],
};

const matchQuarterPatterns$1i = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](st|d)e kwartaal/i,
};
const parseQuarterPatterns$1i = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1i = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
  wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i,
};
const parseMonthPatterns$1i = {
  narrow: [
    /^J/i,
    /^F/i,
    /^M/i,
    /^A/i,
    /^M/i,
    /^J/i,
    /^J/i,
    /^A/i,
    /^S/i,
    /^O/i,
    /^N/i,
    /^D/i,
  ],

  any: [
    /^Jan/i,
    /^Feb/i,
    /^Mrt/i,
    /^Apr/i,
    /^Mei/i,
    /^Jun/i,
    /^Jul/i,
    /^Aug/i,
    /^Sep/i,
    /^Okt/i,
    /^Nov/i,
    /^Dec/i,
  ],
};

const matchDayPatterns$1i = {
  narrow: /^[smdwv]/i,
  short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
  abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
  wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i,
};
const parseDayPatterns$1i = {
  narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
  any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i],
};

const matchDayPeriodPatterns$1i = {
  any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i,
};
const parseDayPeriodPatterns$1i = {
  any: {
    am: /^vm/i,
    pm: /^nm/i,
    midnight: /^middernag/i,
    noon: /^middaguur/i,
    morning: /oggend/i,
    afternoon: /middag/i,
    evening: /laat middag/i,
    night: /aand/i,
  },
};

(match$1i.match = {
  ordinalNumber: (0, _index2$2Q.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1i,
    parsePattern: parseOrdinalNumberPattern$1i,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$5I.buildMatchFn)({
    matchPatterns: matchEraPatterns$1i,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1i,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$5I.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1i,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1i,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$5I.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1i,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1i,
    defaultParseWidth: "any",
  }),

  day: (0, _index$5I.buildMatchFn)({
    matchPatterns: matchDayPatterns$1i,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1i,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$5I.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1i,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1i,
    defaultParseWidth: "any",
  }),
});

af.af = void 0;
var _index$5H = formatDistance$2D;
var _index2$2P = formatLong$1r;
var _index3$1u = formatRelative$2D;
var _index4$1t = localize$1j;
var _index5$1t = match$1i;

/**
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw](https://github.com/marnusw)
 */
(af.af = {
  code: "af",
  formatDistance: _index$5H.formatDistance,
  formatLong: _index2$2P.formatLong,
  formatRelative: _index3$1u.formatRelative,
  localize: _index4$1t.localize,
  match: _index5$1t.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var ar = {};

var formatDistance$2B = {};

formatDistance$2B.formatDistance = void 0;

const formatDistanceLocale$1h = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من ثانيتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية",
  },

  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانيتان",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية",
  },

  halfAMinute: "نصف دقيقة",

  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة",
  },

  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتان",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة",
  },

  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريبا",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً",
  },

  xHours: {
    one: "ساعة واحدة",
    two: "ساعتان",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة",
  },

  xDays: {
    one: "يوم واحد",
    two: "يومان",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم",
  },

  aboutXWeeks: {
    one: "أسبوع واحد تقريبا",
    two: "أسبوعين تقريبا",
    threeToTen: "{{count}} أسابيع تقريبا",
    other: "{{count}} أسبوعا تقريبا",
  },

  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعان",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوعا",
  },

  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريبا",
    threeToTen: "{{count}} أشهر تقريبا",
    other: "{{count}} شهرا تقريباً",
  },

  xMonths: {
    one: "شهر واحد",
    two: "شهران",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهرا",
  },

  aboutXYears: {
    one: "سنة واحدة تقريباً",
    two: "سنتين تقريبا",
    threeToTen: "{{count}} سنوات تقريباً",
    other: "{{count}} سنة تقريباً",
  },

  xYears: {
    one: "سنة واحد",
    two: "سنتان",
    threeToTen: "{{count}} سنوات",
    other: "{{count}} سنة",
  },

  overXYears: {
    one: "أكثر من سنة",
    two: "أكثر من سنتين",
    threeToTen: "أكثر من {{count}} سنوات",
    other: "أكثر من {{count}} سنة",
  },

  almostXYears: {
    one: "ما يقارب سنة واحدة",
    two: "ما يقارب سنتين",
    threeToTen: "ما يقارب {{count}} سنوات",
    other: "ما يقارب {{count}} سنة",
  },
};

const formatDistance$2A = (token, count, options) => {
  const usageGroup = formatDistanceLocale$1h[token];
  let result;
  if (typeof usageGroup === "string") {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace("{{count}}", String(count));
  } else {
    result = usageGroup.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "خلال " + result;
    } else {
      return "منذ " + result;
    }
  }

  return result;
};
formatDistance$2B.formatDistance = formatDistance$2A;

var formatLong$1q = {};

formatLong$1q.formatLong = void 0;
var _index$5G = buildFormatLongFn$1;

const dateFormats$1q = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy",
};

const timeFormats$1q = {
  full: "HH:mm:ss",
  long: "HH:mm:ss",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$1q = {
  full: "{{date}} 'عند الساعة' {{time}}",
  long: "{{date}} 'عند الساعة' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1q.formatLong = {
  date: (0, _index$5G.buildFormatLongFn)({
    formats: dateFormats$1q,
    defaultWidth: "full",
  }),

  time: (0, _index$5G.buildFormatLongFn)({
    formats: timeFormats$1q,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$5G.buildFormatLongFn)({
    formats: dateTimeFormats$1q,
    defaultWidth: "full",
  }),
});

var formatRelative$2B = {};

formatRelative$2B.formatRelative = void 0;

const formatRelativeLocale$1i = {
  lastWeek: "eeee 'الماضي عند الساعة' p",
  yesterday: "'الأمس عند الساعة' p",
  today: "'اليوم عند الساعة' p",
  tomorrow: "'غدا عند الساعة' p",
  nextWeek: "eeee 'القادم عند الساعة' p",
  other: "P",
};

const formatRelative$2A = (token) => formatRelativeLocale$1i[token];
formatRelative$2B.formatRelative = formatRelative$2A;

var localize$1i = {};

localize$1i.localize = void 0;
var _index$5F = buildLocalizeFn$1;

const eraValues$1i = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"],
};

const quarterValues$1i = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"],
};

const monthValues$1i = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],

  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],
};

const dayValues$1i = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],

  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
};

const dayPeriodValues$1i = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل",
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل",
  },
};

const formattingDayPeriodValues$12 = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل",
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل",
  },
};

const ordinalNumber$1i = (num) => String(num);

(localize$1i.localize = {
  ordinalNumber: ordinalNumber$1i,

  era: (0, _index$5F.buildLocalizeFn)({
    values: eraValues$1i,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$5F.buildLocalizeFn)({
    values: quarterValues$1i,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$5F.buildLocalizeFn)({
    values: monthValues$1i,
    defaultWidth: "wide",
  }),

  day: (0, _index$5F.buildLocalizeFn)({
    values: dayValues$1i,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$5F.buildLocalizeFn)({
    values: dayPeriodValues$1i,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$12,
    defaultFormattingWidth: "wide",
  }),
});

var match$1h = {};

match$1h.match = void 0;
var _index$5E = buildMatchPatternFn$1;
var _index2$2O = buildMatchFn$1;

const matchOrdinalNumberPattern$1h = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$1h = /\d+/i;

const matchEraPatterns$1h = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/,
};
const parseEraPatterns$1h = {
  any: [/قبل/, /بعد/],
};

const matchQuarterPatterns$1h = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/,
};
const parseQuarterPatterns$1h = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1h = {
  narrow: /^[أيفمسند]/,
  abbreviated:
    /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
};
const parseMonthPatterns$1h = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i,
  ],

  any: [
    /^يناير/i,
    /^فبراير/i,
    /^مارس/i,
    /^أبريل/i,
    /^مايو/i,
    /^يونيو/i,
    /^يوليو/i,
    /^أغسطس/i,
    /^سبتمبر/i,
    /^أكتوبر/i,
    /^نوفمبر/i,
    /^ديسمبر/i,
  ],
};

const matchDayPatterns$1h = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i,
};
const parseDayPatterns$1h = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i,
  ],

  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i],
};

const matchDayPeriodPatterns$1h = {
  narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
  any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
};
const parseDayPeriodPatterns$1h = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /منتصف الليل/,
    noon: /الظهر/,
    afternoon: /بعد الظهر/,
    morning: /في الصباح/,
    evening: /في المساء/,
    night: /في الليل/,
  },
};

(match$1h.match = {
  ordinalNumber: (0, _index$5E.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1h,
    parsePattern: parseOrdinalNumberPattern$1h,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index2$2O.buildMatchFn)({
    matchPatterns: matchEraPatterns$1h,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1h,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index2$2O.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1h,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1h,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index2$2O.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1h,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1h,
    defaultParseWidth: "any",
  }),

  day: (0, _index2$2O.buildMatchFn)({
    matchPatterns: matchDayPatterns$1h,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1h,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index2$2O.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1h,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1h,
    defaultParseWidth: "any",
  }),
});

ar.ar = void 0;
var _index$5D = formatDistance$2B;
var _index2$2N = formatLong$1q;
var _index3$1t = formatRelative$2B;
var _index4$1s = localize$1i;
var _index5$1s = match$1h;

/**
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO](https://github.com/AbdallahAHO)
 * @author Koussay Haj Kacem [@essana3](https://github.com/essana3)
 */
(ar.ar = {
  code: "ar",
  formatDistance: _index$5D.formatDistance,
  formatLong: _index2$2N.formatLong,
  formatRelative: _index3$1t.formatRelative,
  localize: _index4$1s.localize,
  match: _index5$1s.match,
  options: {
    weekStartsOn: 6 /* Saturday */,
    firstWeekContainsDate: 1,
  },
});

var arDZ = {};

var formatDistance$2z = {};

formatDistance$2z.formatDistance = void 0;

const formatDistanceLocale$1g = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية",
  },

  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية",
  },

  halfAMinute: "نصف دقيقة",

  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة",
  },

  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة",
  },

  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً",
  },

  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة",
  },

  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم",
  },

  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً",
  },

  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع",
  },

  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً",
  },

  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر",
  },

  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً",
  },

  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام",
  },

  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام",
  },

  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً",
  },
};

const formatDistance$2y = (token, count, options) => {
  options = options || {};

  const usageGroup = formatDistanceLocale$1g[token];
  let result;
  if (typeof usageGroup === "string") {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace("{{count}}", String(count));
  } else {
    result = usageGroup.other.replace("{{count}}", String(count));
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "في خلال " + result;
    } else {
      return "منذ " + result;
    }
  }

  return result;
};
formatDistance$2z.formatDistance = formatDistance$2y;

var formatLong$1p = {};

formatLong$1p.formatLong = void 0;
var _index$5C = buildFormatLongFn$1;

const dateFormats$1p = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$1p = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1p = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1p.formatLong = {
  date: (0, _index$5C.buildFormatLongFn)({
    formats: dateFormats$1p,
    defaultWidth: "full",
  }),

  time: (0, _index$5C.buildFormatLongFn)({
    formats: timeFormats$1p,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$5C.buildFormatLongFn)({
    formats: dateTimeFormats$1p,
    defaultWidth: "full",
  }),
});

var formatRelative$2z = {};

formatRelative$2z.formatRelative = void 0;

const formatRelativeLocale$1h = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P",
};

const formatRelative$2y = (token, _date, _baseDate, _options) => {
  return formatRelativeLocale$1h[token];
};
formatRelative$2z.formatRelative = formatRelative$2y;

var localize$1h = {};

localize$1h.localize = void 0;
var _index$5B = buildLocalizeFn$1;

const eraValues$1h = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"],
};

const quarterValues$1h = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"],
};

const monthValues$1h = {
  narrow: ["ج", "ف", "م", "أ", "م", "ج", "ج", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "جانـ",
    "فيفـ",
    "مارس",
    "أفريل",
    "مايـ",
    "جوانـ",
    "جويـ",
    "أوت",
    "سبتـ",
    "أكتـ",
    "نوفـ",
    "ديسـ",
  ],

  wide: [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوت",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],
};

const dayValues$1h = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
};

const dayPeriodValues$1h = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً",
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً",
  },
};
const formattingDayPeriodValues$11 = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل",
  },
};

const ordinalNumber$1h = (dirtyNumber) => {
  return String(dirtyNumber);
};

(localize$1h.localize = {
  ordinalNumber: ordinalNumber$1h,

  era: (0, _index$5B.buildLocalizeFn)({
    values: eraValues$1h,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$5B.buildLocalizeFn)({
    values: quarterValues$1h,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1,
  }),

  month: (0, _index$5B.buildLocalizeFn)({
    values: monthValues$1h,
    defaultWidth: "wide",
  }),

  day: (0, _index$5B.buildLocalizeFn)({
    values: dayValues$1h,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$5B.buildLocalizeFn)({
    values: dayPeriodValues$1h,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$11,
    defaultFormattingWidth: "wide",
  }),
});

var match$1g = {};

match$1g.match = void 0;
var _index$5A = buildMatchPatternFn$1;
var _index2$2M = buildMatchFn$1;

const matchOrdinalNumberPattern$1g = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$1g = /\d+/i;

const matchEraPatterns$1g = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i,
};
const parseEraPatterns$1g = {
  any: [/^قبل/i, /^بعد/i],
};

const matchQuarterPatterns$1g = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i,
};
const parseQuarterPatterns$1g = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1g = {
  narrow: /^[جفمأسند]/i,
  abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i,
};

const parseMonthPatterns$1g = {
  narrow: [
    /^ج/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ج/i,
    /^ج/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i,
  ],

  any: [
    /^جان/i,
    /^فيف/i,
    /^مار/i,
    /^أفر/i,
    /^ماي/i,
    /^جوا/i,
    /^جوي/i,
    /^أوت/i,
    /^سبت/i,
    /^أكت/i,
    /^نوف/i,
    /^ديس/i,
  ],
};

const matchDayPatterns$1g = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i,
};
const parseDayPatterns$1g = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i,
  ],

  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i],
};

const matchDayPeriodPatterns$1g = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns$1g = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

(match$1g.match = {
  ordinalNumber: (0, _index$5A.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1g,
    parsePattern: parseOrdinalNumberPattern$1g,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index2$2M.buildMatchFn)({
    matchPatterns: matchEraPatterns$1g,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1g,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index2$2M.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1g,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1g,
    defaultParseWidth: "any",
    valueCallback: (index) => Number(index) + 1,
  }),

  month: (0, _index2$2M.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1g,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1g,
    defaultParseWidth: "any",
  }),

  day: (0, _index2$2M.buildMatchFn)({
    matchPatterns: matchDayPatterns$1g,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1g,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index2$2M.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1g,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1g,
    defaultParseWidth: "any",
  }),
});

arDZ.arDZ = void 0;
var _index$5z = formatDistance$2z;
var _index2$2L = formatLong$1p;
var _index3$1s = formatRelative$2z;
var _index4$1r = localize$1h;
var _index5$1r = match$1g;

/**
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429](https://github.com/badre429)
 * @author Ahmed ElShahat [@elshahat](https://github.com/elshahat)
 */
(arDZ.arDZ = {
  code: "ar-DZ",
  formatDistance: _index$5z.formatDistance,
  formatLong: _index2$2L.formatLong,
  formatRelative: _index3$1s.formatRelative,
  localize: _index4$1r.localize,
  match: _index5$1r.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var arEG = {};

var formatDistance$2x = {};

formatDistance$2x.formatDistance = void 0;

const formatDistanceLocale$1f = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من ثانيتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية",
  },

  xSeconds: {
    one: "ثانية",
    two: "ثانيتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية",
  },

  halfAMinute: "نص دقيقة",

  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقايق",
    other: "أقل من {{count}} دقيقة",
  },

  xMinutes: {
    one: "دقيقة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقايق",
    other: "{{count}} دقيقة",
  },

  aboutXHours: {
    one: "حوالي ساعة",
    two: "حوالي ساعتين",
    threeToTen: "حوالي {{count}} ساعات",
    other: "حوالي {{count}} ساعة",
  },

  xHours: {
    one: "ساعة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة",
  },

  xDays: {
    one: "يوم",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم",
  },

  aboutXWeeks: {
    one: "حوالي أسبوع",
    two: "حوالي أسبوعين",
    threeToTen: "حوالي {{count}} أسابيع",
    other: "حوالي {{count}} أسبوع",
  },

  xWeeks: {
    one: "أسبوع",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع",
  },

  aboutXMonths: {
    one: "حوالي شهر",
    two: "حوالي شهرين",
    threeToTen: "حوالي {{count}} أشهر",
    other: "حوالي {{count}} شهر",
  },

  xMonths: {
    one: "شهر",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر",
  },

  aboutXYears: {
    one: "حوالي سنة",
    two: "حوالي سنتين",
    threeToTen: "حوالي {{count}} سنين",
    other: "حوالي {{count}} سنة",
  },

  xYears: {
    one: "عام",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام",
  },

  overXYears: {
    one: "أكثر من سنة",
    two: "أكثر من سنتين",
    threeToTen: "أكثر من {{count}} سنين",
    other: "أكثر من {{count}} سنة",
  },

  almostXYears: {
    one: "عام تقريبًا",
    two: "عامين تقريبًا",
    threeToTen: "{{count}} أعوام تقريبًا",
    other: "{{count}} عام تقريبًا",
  },
};

const formatDistance$2w = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$1f[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else if (count === 2) {
    result = tokenValue.two;
  } else if (count <= 10) {
    result = tokenValue.threeToTen.replace("{{count}}", String(count));
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return `في خلال ${result}`;
    } else {
      return `منذ ${result}`;
    }
  }

  return result;
};
formatDistance$2x.formatDistance = formatDistance$2w;

var formatLong$1o = {};

formatLong$1o.formatLong = void 0;
var _index$5y = buildFormatLongFn$1;

const dateFormats$1o = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "dd/MMM/y",
  short: "d/MM/y",
};

const timeFormats$1o = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1o = {
  full: "{{date}} 'الساعة' {{time}}",
  long: "{{date}} 'الساعة' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1o.formatLong = {
  date: (0, _index$5y.buildFormatLongFn)({
    formats: dateFormats$1o,
    defaultWidth: "full",
  }),

  time: (0, _index$5y.buildFormatLongFn)({
    formats: timeFormats$1o,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$5y.buildFormatLongFn)({
    formats: dateTimeFormats$1o,
    defaultWidth: "full",
  }),
});

var formatRelative$2x = {};

formatRelative$2x.formatRelative = void 0;

const formatRelativeLocale$1g = {
  lastWeek: "eeee 'اللي جاي الساعة' p",
  yesterday: "'إمبارح الساعة' p",
  today: "'النهاردة الساعة' p",
  tomorrow: "'بكرة الساعة' p",
  nextWeek: "eeee 'الساعة' p",
  other: "P",
};

const formatRelative$2w = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$1g[token];
formatRelative$2x.formatRelative = formatRelative$2w;

var localize$1g = {};

localize$1g.localize = void 0;
var _index$5x = buildLocalizeFn$1;

const eraValues$1g = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م", "ب.م"],
  wide: ["قبل الميلاد", "بعد الميلاد"],
};

const quarterValues$1g = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"],
};

const monthValues$1g = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "ينا",
    "فبر",
    "مارس",
    "أبريل",
    "مايو",
    "يونـ",
    "يولـ",
    "أغسـ",
    "سبتـ",
    "أكتـ",
    "نوفـ",
    "ديسـ",
  ],

  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],
};

const dayValues$1g = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],

  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
};

const dayPeriodValues$1g = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً",
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً",
  },
};

const formattingDayPeriodValues$10 = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    morning: "في الصباح",
    noon: "ظهراً",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
  },
};

const ordinalNumber$1g = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$1g.localize = {
  ordinalNumber: ordinalNumber$1g,

  era: (0, _index$5x.buildLocalizeFn)({
    values: eraValues$1g,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$5x.buildLocalizeFn)({
    values: quarterValues$1g,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$5x.buildLocalizeFn)({
    values: monthValues$1g,
    defaultWidth: "wide",
  }),

  day: (0, _index$5x.buildLocalizeFn)({
    values: dayValues$1g,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$5x.buildLocalizeFn)({
    values: dayPeriodValues$1g,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$10,
    defaultFormattingWidth: "wide",
  }),
});

var match$1f = {};

match$1f.match = void 0;

var _index$5w = buildMatchFn$1;
var _index2$2K = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$1f = /^(\d+)/;
const parseOrdinalNumberPattern$1f = /\d+/i;

const matchEraPatterns$1f = {
  narrow: /^(ق|ب)/g,
  abbreviated: /^(ق.م|ب.م)/g,
  wide: /^(قبل الميلاد|بعد الميلاد)/g,
};
const parseEraPatterns$1f = {
  any: [/^ق/g, /^ب/g],
};
const matchQuarterPatterns$1f = {
  narrow: /^[1234]/,
  abbreviated: /^ر[1234]/,
  wide: /^الربع (الأول|الثاني|الثالث|الرابع)/,
};
const parseQuarterPatterns$1f = {
  wide: [/الربع الأول/, /الربع الثاني/, /الربع الثالث/, /الربع الرابع/],

  any: [/1/, /2/, /3/, /4/],
};

const matchMonthPatterns$1f = {
  narrow: /^(ي|ف|م|أ|س|ن|د)/,
  abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
};
const parseMonthPatterns$1f = {
  narrow: [
    /^ي/,
    /^ف/,
    /^م/,
    /^أ/,
    /^م/,
    /^ي/,
    /^ي/,
    /^أ/,
    /^س/,
    /^أ/,
    /^ن/,
    /^د/,
  ],

  any: [
    /^ينا/,
    /^فبر/,
    /^مارس/,
    /^أبريل/,
    /^مايو/,
    /^يون/,
    /^يول/,
    /^أغس/,
    /^سبت/,
    /^أكت/,
    /^نوف/,
    /^ديس/,
  ],
};

const matchDayPatterns$1f = {
  narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/,
};
const parseDayPatterns$1f = {
  narrow: [/^ح/, /^ن/, /^ث/, /^ر/, /^خ/, /^ج/, /^س/],
  any: [/أحد/, /اثنين/, /ثلاثاء/, /أربعاء/, /خميس/, /جمعة/, /سبت/],
};

const matchDayPeriodPatterns$1f = {
  narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
  abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
  wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
  any: /^(ص|م|صباح|ظهر|مساء|ليل)/,
};
const parseDayPeriodPatterns$1f = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /^ن/,
    noon: /^ظ/,
    morning: /^ص/,
    afternoon: /^بعد/,
    evening: /^م/,
    night: /^ل/,
  },
};

(match$1f.match = {
  ordinalNumber: (0, _index2$2K.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1f,
    parsePattern: parseOrdinalNumberPattern$1f,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: (0, _index$5w.buildMatchFn)({
    matchPatterns: matchEraPatterns$1f,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1f,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$5w.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1f,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1f,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$5w.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1f,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1f,
    defaultParseWidth: "any",
  }),

  day: (0, _index$5w.buildMatchFn)({
    matchPatterns: matchDayPatterns$1f,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1f,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$5w.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1f,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1f,
    defaultParseWidth: "any",
  }),
});

arEG.arEG = void 0;
var _index$5v = formatDistance$2x;
var _index2$2J = formatLong$1o;
var _index3$1r = formatRelative$2x;
var _index4$1q = localize$1g;
var _index5$1q = match$1f;

/**
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13](https://github.com/AbdAllahAbdElFattah13)
 */
(arEG.arEG = {
  code: "ar-EG",
  formatDistance: _index$5v.formatDistance,
  formatLong: _index2$2J.formatLong,
  formatRelative: _index3$1r.formatRelative,
  localize: _index4$1q.localize,
  match: _index5$1q.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var arMA = {};

var formatDistance$2v = {};

formatDistance$2v.formatDistance = void 0;

const formatDistanceLocale$1e = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية",
  },

  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية",
  },

  halfAMinute: "نصف دقيقة",

  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة",
  },

  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة",
  },

  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً",
  },

  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة",
  },

  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم",
  },

  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً",
  },

  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع",
  },

  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً",
  },

  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر",
  },

  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً",
  },

  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام",
  },

  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام",
  },

  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً",
  },
};

const formatDistance$2u = (token, count, options) => {
  options = options || {};

  const usageGroup = formatDistanceLocale$1e[token];
  let result;
  if (typeof usageGroup === "string") {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace("{{count}}", String(count));
  } else {
    result = usageGroup.other.replace("{{count}}", String(count));
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "في خلال " + result;
    } else {
      return "منذ " + result;
    }
  }

  return result;
};
formatDistance$2v.formatDistance = formatDistance$2u;

var formatLong$1n = {};

formatLong$1n.formatLong = void 0;
var _index$5u = buildFormatLongFn$1;

const dateFormats$1n = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$1n = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1n = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1n.formatLong = {
  date: (0, _index$5u.buildFormatLongFn)({
    formats: dateFormats$1n,
    defaultWidth: "full",
  }),

  time: (0, _index$5u.buildFormatLongFn)({
    formats: timeFormats$1n,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$5u.buildFormatLongFn)({
    formats: dateTimeFormats$1n,
    defaultWidth: "full",
  }),
});

var formatRelative$2v = {};

formatRelative$2v.formatRelative = void 0;

const formatRelativeLocale$1f = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P",
};

const formatRelative$2u = (token, _date, _baseDate, _options) => {
  return formatRelativeLocale$1f[token];
};
formatRelative$2v.formatRelative = formatRelative$2u;

var localize$1f = {};

localize$1f.localize = void 0;
var _index$5t = buildLocalizeFn$1;

const eraValues$1f = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"],
};

const quarterValues$1f = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"],
};

const monthValues$1f = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "غ", "ش", "أ", "ن", "د"],
  abbreviated: [
    "ينا",
    "فبر",
    "مارس",
    "أبريل",
    "ماي",
    "يونـ",
    "يولـ",
    "غشت",
    "شتنـ",
    "أكتـ",
    "نونـ",
    "دجنـ",
  ],

  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "ماي",
    "يونيو",
    "يوليوز",
    "غشت",
    "شتنبر",
    "أكتوبر",
    "نونبر",
    "دجنبر",
  ],
};

const dayValues$1f = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الإثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
};

const dayPeriodValues$1f = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً",
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً",
  },
};
const formattingDayPeriodValues$$ = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل",
  },
};

const ordinalNumber$1f = (dirtyNumber) => {
  return String(dirtyNumber);
};

(localize$1f.localize = {
  ordinalNumber: ordinalNumber$1f,

  era: (0, _index$5t.buildLocalizeFn)({
    values: eraValues$1f,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$5t.buildLocalizeFn)({
    values: quarterValues$1f,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1,
  }),

  month: (0, _index$5t.buildLocalizeFn)({
    values: monthValues$1f,
    defaultWidth: "wide",
  }),

  day: (0, _index$5t.buildLocalizeFn)({
    values: dayValues$1f,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$5t.buildLocalizeFn)({
    values: dayPeriodValues$1f,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$$,
    defaultFormattingWidth: "wide",
  }),
});

var match$1e = {};

match$1e.match = void 0;
var _index$5s = buildMatchPatternFn$1;
var _index2$2I = buildMatchFn$1;

const matchOrdinalNumberPattern$1e = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$1e = /\d+/i;

const matchEraPatterns$1e = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i,
};
const parseEraPatterns$1e = {
  any: [/^قبل/i, /^بعد/i],
};

const matchQuarterPatterns$1e = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i,
};
const parseQuarterPatterns$1e = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1e = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
};
const parseMonthPatterns$1e = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^غ/i,
    /^ش/i,
    /^أ/i,
    /^ن/i,
    /^د/i,
  ],

  any: [
    /^ين/i,
    /^فب/i,
    /^مار/i,
    /^أب/i,
    /^ماي/i,
    /^يون/i,
    /^يول/i,
    /^غشت/i,
    /^ش/i,
    /^أك/i,
    /^ن/i,
    /^د/i,
  ],
};

const matchDayPatterns$1e = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i,
};
const parseDayPatterns$1e = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الإثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i,
  ],

  any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i],
};

const matchDayPeriodPatterns$1e = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns$1e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

(match$1e.match = {
  ordinalNumber: (0, _index$5s.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1e,
    parsePattern: parseOrdinalNumberPattern$1e,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index2$2I.buildMatchFn)({
    matchPatterns: matchEraPatterns$1e,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1e,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index2$2I.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1e,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1e,
    defaultParseWidth: "any",
    valueCallback: (index) => Number(index) + 1,
  }),

  month: (0, _index2$2I.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1e,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1e,
    defaultParseWidth: "any",
  }),

  day: (0, _index2$2I.buildMatchFn)({
    matchPatterns: matchDayPatterns$1e,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1e,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index2$2I.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1e,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1e,
    defaultParseWidth: "any",
  }),
});

arMA.arMA = void 0;
var _index$5r = formatDistance$2v;
var _index2$2H = formatLong$1n;
var _index3$1q = formatRelative$2v;
var _index4$1p = localize$1f;
var _index5$1p = match$1e;

/**
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf](https://github.com/rramiachraf)
 */
(arMA.arMA = {
  code: "ar-MA",
  formatDistance: _index$5r.formatDistance,
  formatLong: _index2$2H.formatLong,
  formatRelative: _index3$1q.formatRelative,
  localize: _index4$1p.localize,
  match: _index5$1p.match,
  options: {
    // Monday is 1
    weekStartsOn: 1,
    firstWeekContainsDate: 1,
  },
});

var arSA = {};

var formatDistance$2t = {};

formatDistance$2t.formatDistance = void 0;

const formatDistanceLocale$1d = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية",
  },

  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية",
  },

  halfAMinute: "نصف دقيقة",

  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة",
  },

  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة",
  },

  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً",
  },

  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة",
  },

  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم",
  },

  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً",
  },

  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع",
  },

  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً",
  },

  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر",
  },

  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً",
  },

  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام",
  },

  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام",
  },

  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً",
  },
};

const formatDistance$2s = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$1d[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else if (count === 2) {
    result = tokenValue.two;
  } else if (count <= 10) {
    result = tokenValue.threeToTen.replace("{{count}}", String(count));
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "في خلال " + result;
    } else {
      return "منذ " + result;
    }
  }

  return result;
};
formatDistance$2t.formatDistance = formatDistance$2s;

var formatLong$1m = {};

formatLong$1m.formatLong = void 0;
var _index$5q = buildFormatLongFn$1;

const dateFormats$1m = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$1m = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1m = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1m.formatLong = {
  date: (0, _index$5q.buildFormatLongFn)({
    formats: dateFormats$1m,
    defaultWidth: "full",
  }),

  time: (0, _index$5q.buildFormatLongFn)({
    formats: timeFormats$1m,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$5q.buildFormatLongFn)({
    formats: dateTimeFormats$1m,
    defaultWidth: "full",
  }),
});

var formatRelative$2t = {};

formatRelative$2t.formatRelative = void 0;

const formatRelativeLocale$1e = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P",
};

const formatRelative$2s = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$1e[token];
formatRelative$2t.formatRelative = formatRelative$2s;

var localize$1e = {};

localize$1e.localize = void 0;
var _index$5p = buildLocalizeFn$1;

const eraValues$1e = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"],
};

const quarterValues$1e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"],
};

const monthValues$1e = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "ينا",
    "فبر",
    "مارس",
    "أبريل",
    "مايو",
    "يونـ",
    "يولـ",
    "أغسـ",
    "سبتـ",
    "أكتـ",
    "نوفـ",
    "ديسـ",
  ],

  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],
};

const dayValues$1e = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
};

const dayPeriodValues$1e = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً",
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً",
  },
};
const formattingDayPeriodValues$_ = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل",
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل",
  },
};

const ordinalNumber$1e = (dirtyNumber) => {
  return String(dirtyNumber);
};

(localize$1e.localize = {
  ordinalNumber: ordinalNumber$1e,

  era: (0, _index$5p.buildLocalizeFn)({
    values: eraValues$1e,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$5p.buildLocalizeFn)({
    values: quarterValues$1e,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$5p.buildLocalizeFn)({
    values: monthValues$1e,
    defaultWidth: "wide",
  }),

  day: (0, _index$5p.buildLocalizeFn)({
    values: dayValues$1e,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$5p.buildLocalizeFn)({
    values: dayPeriodValues$1e,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$_,
    defaultFormattingWidth: "wide",
  }),
});

var match$1d = {};

match$1d.match = void 0;

var _index$5o = buildMatchFn$1;
var _index2$2G = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$1d = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$1d = /\d+/i;

const matchEraPatterns$1d = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i,
};
const parseEraPatterns$1d = {
  any: [/^قبل/i, /^بعد/i],
};

const matchQuarterPatterns$1d = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i,
};
const parseQuarterPatterns$1d = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1d = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
};
const parseMonthPatterns$1d = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i,
  ],

  any: [
    /^ين/i,
    /^ف/i,
    /^مار/i,
    /^أب/i,
    /^ماي/i,
    /^يون/i,
    /^يول/i,
    /^أغ/i,
    /^س/i,
    /^أك/i,
    /^ن/i,
    /^د/i,
  ],
};

const matchDayPatterns$1d = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i,
};
const parseDayPatterns$1d = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i,
  ],

  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i],
};

const matchDayPeriodPatterns$1d = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i,
};
const parseDayPeriodPatterns$1d = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i,
  },
};

(match$1d.match = {
  ordinalNumber: (0, _index2$2G.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1d,
    parsePattern: parseOrdinalNumberPattern$1d,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$5o.buildMatchFn)({
    matchPatterns: matchEraPatterns$1d,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1d,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$5o.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1d,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1d,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$5o.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1d,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1d,
    defaultParseWidth: "any",
  }),

  day: (0, _index$5o.buildMatchFn)({
    matchPatterns: matchDayPatterns$1d,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1d,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$5o.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1d,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1d,
    defaultParseWidth: "any",
  }),
});

arSA.arSA = void 0;
var _index$5n = formatDistance$2t;
var _index2$2F = formatLong$1m;
var _index3$1p = formatRelative$2t;
var _index4$1o = localize$1e;
var _index5$1o = match$1d;

/**
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani](https://github.com/dalwadani)
 */
(arSA.arSA = {
  code: "ar-SA",
  formatDistance: _index$5n.formatDistance,
  formatLong: _index2$2F.formatLong,
  formatRelative: _index3$1p.formatRelative,
  localize: _index4$1o.localize,
  match: _index5$1o.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var arTN = {};

var formatDistance$2r = {};

formatDistance$2r.formatDistance = void 0;

const formatDistanceLocale$1c = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من زوز ثواني",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية",
  },

  xSeconds: {
    one: "ثانية",
    two: "زوز ثواني",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية",
  },

  halfAMinute: "نص دقيقة",

  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقايق",
    other: "أقل من {{count}} دقيقة",
  },

  xMinutes: {
    one: "دقيقة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقايق",
    other: "{{count}} دقيقة",
  },

  aboutXHours: {
    one: "ساعة تقريب",
    two: "ساعتين تقريب",
    threeToTen: "{{count}} سوايع تقريب",
    other: "{{count}} ساعة تقريب",
  },

  xHours: {
    one: "ساعة",
    two: "ساعتين",
    threeToTen: "{{count}} سوايع",
    other: "{{count}} ساعة",
  },

  xDays: {
    one: "نهار",
    two: "نهارين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم",
  },

  aboutXWeeks: {
    one: "جمعة تقريب",
    two: "جمعتين تقريب",
    threeToTen: "{{count}} جماع تقريب",
    other: "{{count}} جمعة تقريب",
  },

  xWeeks: {
    one: "جمعة",
    two: "جمعتين",
    threeToTen: "{{count}} جماع",
    other: "{{count}} جمعة",
  },

  aboutXMonths: {
    one: "شهر تقريب",
    two: "شهرين تقريب",
    threeToTen: "{{count}} أشهرة تقريب",
    other: "{{count}} شهر تقريب",
  },

  xMonths: {
    one: "شهر",
    two: "شهرين",
    threeToTen: "{{count}} أشهرة",
    other: "{{count}} شهر",
  },

  aboutXYears: {
    one: "عام تقريب",
    two: "عامين تقريب",
    threeToTen: "{{count}} أعوام تقريب",
    other: "{{count}} عام تقريب",
  },

  xYears: {
    one: "عام",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام",
  },

  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام",
  },

  almostXYears: {
    one: "عام تقريب",
    two: "عامين تقريب",
    threeToTen: "{{count}} أعوام تقريب",
    other: "{{count}} عام تقريب",
  },
};

const formatDistance$2q = (token, count, options) => {
  const usageGroup = formatDistanceLocale$1c[token];
  let result;
  if (typeof usageGroup === "string") {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace("{{count}}", String(count));
  } else {
    result = usageGroup.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "في " + result;
    } else {
      return "عندو " + result;
    }
  }

  return result;
};
formatDistance$2r.formatDistance = formatDistance$2q;

var formatLong$1l = {};

formatLong$1l.formatLong = void 0;
var _index$5m = buildFormatLongFn$1;

const dateFormats$1l = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy",
};

const timeFormats$1l = {
  full: "HH:mm:ss",
  long: "HH:mm:ss",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$1l = {
  full: "{{date}} 'مع' {{time}}",
  long: "{{date}} 'مع' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1l.formatLong = {
  date: (0, _index$5m.buildFormatLongFn)({
    formats: dateFormats$1l,
    defaultWidth: "full",
  }),

  time: (0, _index$5m.buildFormatLongFn)({
    formats: timeFormats$1l,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$5m.buildFormatLongFn)({
    formats: dateTimeFormats$1l,
    defaultWidth: "full",
  }),
});

var formatRelative$2r = {};

formatRelative$2r.formatRelative = void 0;

const formatRelativeLocale$1d = {
  lastWeek: "eeee 'إلي فات مع' p",
  yesterday: "'البارح مع' p",
  today: "'اليوم مع' p",
  tomorrow: "'غدوة مع' p",
  nextWeek: "eeee 'الجمعة الجاية مع' p 'نهار'",
  other: "P",
};

const formatRelative$2q = (token) => formatRelativeLocale$1d[token];
formatRelative$2r.formatRelative = formatRelative$2q;

var localize$1d = {};

localize$1d.localize = void 0;
var _index$5l = buildLocalizeFn$1;

const eraValues$1d = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"],
};

const quarterValues$1d = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"],
};

const monthValues$1d = {
  narrow: ["د", "ن", "أ", "س", "أ", "ج", "ج", "م", "أ", "م", "ف", "ج"],
  abbreviated: [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوت",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],

  wide: [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوت",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر",
  ],
};

const dayValues$1d = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],

  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
};

const dayPeriodValues$1d = {
  narrow: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل",
  },
  abbreviated: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل",
  },
  wide: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل",
  },
};

const formattingDayPeriodValues$Z = {
  narrow: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل",
  },
  abbreviated: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل",
  },
  wide: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل",
  },
};

const ordinalNumber$1d = (num) => String(num);

(localize$1d.localize = {
  ordinalNumber: ordinalNumber$1d,

  era: (0, _index$5l.buildLocalizeFn)({
    values: eraValues$1d,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$5l.buildLocalizeFn)({
    values: quarterValues$1d,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$5l.buildLocalizeFn)({
    values: monthValues$1d,
    defaultWidth: "wide",
  }),

  day: (0, _index$5l.buildLocalizeFn)({
    values: dayValues$1d,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$5l.buildLocalizeFn)({
    values: dayPeriodValues$1d,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$Z,
    defaultFormattingWidth: "wide",
  }),
});

var match$1c = {};

match$1c.match = void 0;
var _index$5k = buildMatchPatternFn$1;
var _index2$2E = buildMatchFn$1;

const matchOrdinalNumberPattern$1c = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$1c = /\d+/i;

const matchEraPatterns$1c = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/,
};
const parseEraPatterns$1c = {
  any: [/قبل/, /بعد/],
};

const matchQuarterPatterns$1c = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/,
};
const parseQuarterPatterns$1c = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1c = {
  narrow: /^[جفمأسند]/,
  abbreviated:
    /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
};
const parseMonthPatterns$1c = {
  narrow: [
    /^ج/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ج/i,
    /^ج/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i,
  ],

  any: [
    /^جانفي/i,
    /^فيفري/i,
    /^مارس/i,
    /^أفريل/i,
    /^ماي/i,
    /^جوان/i,
    /^جويلية/i,
    /^أوت/i,
    /^سبتمبر/i,
    /^أكتوبر/i,
    /^نوفمبر/i,
    /^ديسمبر/i,
  ],
};

const matchDayPatterns$1c = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i,
};
const parseDayPatterns$1c = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i,
  ],

  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i],
};

const matchDayPeriodPatterns$1c = {
  narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
  any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/,
};
const parseDayPeriodPatterns$1c = {
  any: {
    am: /^ص/,
    pm: /^ع/,
    midnight: /نص الليل/,
    noon: /قايلة/,
    afternoon: /بعد القايلة/,
    morning: /صباح/,
    evening: /عشية/,
    night: /ليل/,
  },
};

(match$1c.match = {
  ordinalNumber: (0, _index$5k.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1c,
    parsePattern: parseOrdinalNumberPattern$1c,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index2$2E.buildMatchFn)({
    matchPatterns: matchEraPatterns$1c,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1c,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index2$2E.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1c,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1c,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index2$2E.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1c,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1c,
    defaultParseWidth: "any",
  }),

  day: (0, _index2$2E.buildMatchFn)({
    matchPatterns: matchDayPatterns$1c,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1c,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index2$2E.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1c,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1c,
    defaultParseWidth: "any",
  }),
});

arTN.arTN = void 0;
var _index$5j = formatDistance$2r;
var _index2$2D = formatLong$1l;
var _index3$1o = formatRelative$2r;
var _index4$1n = localize$1d;
var _index5$1n = match$1c;

/**
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3](https://github.com/essana3)
 */
(arTN.arTN = {
  code: "ar-TN",
  formatDistance: _index$5j.formatDistance,
  formatLong: _index2$2D.formatLong,
  formatRelative: _index3$1o.formatRelative,
  localize: _index4$1n.localize,
  match: _index5$1n.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var az = {};

var formatDistance$2p = {};

formatDistance$2p.formatDistance = void 0;

const formatDistanceLocale$1b = {
  lessThanXSeconds: {
    one: "bir saniyədən az",
    other: "{{count}} bir saniyədən az",
  },

  xSeconds: {
    one: "1 saniyə",
    other: "{{count}} saniyə",
  },

  halfAMinute: "yarım dəqiqə",

  lessThanXMinutes: {
    one: "bir dəqiqədən az",
    other: "{{count}} bir dəqiqədən az",
  },

  xMinutes: {
    one: "bir dəqiqə",
    other: "{{count}} dəqiqə",
  },

  aboutXHours: {
    one: "təxminən 1 saat",
    other: "təxminən {{count}} saat",
  },

  xHours: {
    one: "1 saat",
    other: "{{count}} saat",
  },

  xDays: {
    one: "1 gün",
    other: "{{count}} gün",
  },

  aboutXWeeks: {
    one: "təxminən 1 həftə",
    other: "təxminən {{count}} həftə",
  },

  xWeeks: {
    one: "1 həftə",
    other: "{{count}} həftə",
  },

  aboutXMonths: {
    one: "təxminən 1 ay",
    other: "təxminən {{count}} ay",
  },

  xMonths: {
    one: "1 ay",
    other: "{{count}} ay",
  },

  aboutXYears: {
    one: "təxminən 1 il",
    other: "təxminən {{count}} il",
  },

  xYears: {
    one: "1 il",
    other: "{{count}} il",
  },

  overXYears: {
    one: "1 ildən çox",
    other: "{{count}} ildən çox",
  },

  almostXYears: {
    one: "demək olar ki 1 il",
    other: "demək olar ki {{count}} il",
  },
};

const formatDistance$2o = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$1b[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " sonra";
    } else {
      return result + " əvvəl";
    }
  }

  return result;
};
formatDistance$2p.formatDistance = formatDistance$2o;

var formatLong$1k = {};

formatLong$1k.formatLong = void 0;
var _index$5i = buildFormatLongFn$1;

const dateFormats$1k = {
  full: "EEEE, do MMMM y 'il'",
  long: "do MMMM y 'il'",
  medium: "d MMM y 'il'",
  short: "dd.MM.yyyy",
};

const timeFormats$1k = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$1k = {
  full: "{{date}} {{time}} - 'də'",
  long: "{{date}} {{time}} - 'də'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1k.formatLong = {
  date: (0, _index$5i.buildFormatLongFn)({
    formats: dateFormats$1k,
    defaultWidth: "full",
  }),

  time: (0, _index$5i.buildFormatLongFn)({
    formats: timeFormats$1k,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$5i.buildFormatLongFn)({
    formats: dateTimeFormats$1k,
    defaultWidth: "full",
  }),
});

var formatRelative$2p = {};

formatRelative$2p.formatRelative = void 0;

const formatRelativeLocale$1c = {
  lastWeek: "'sonuncu' eeee p -'də'",
  yesterday: "'dünən' p -'də'",
  today: "'bugün' p -'də'",
  tomorrow: "'sabah' p -'də'",
  nextWeek: "eeee p -'də'",
  other: "P",
};

const formatRelative$2o = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$1c[token];
formatRelative$2p.formatRelative = formatRelative$2o;

var localize$1c = {};

localize$1c.localize = void 0;
var _index$5h = buildLocalizeFn$1;

const eraValues$1c = {
  narrow: ["e.ə", "b.e"],
  abbreviated: ["e.ə", "b.e"],
  wide: ["eramızdan əvvəl", "bizim era"],
};

const quarterValues$1c = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ci kvartal", "2ci kvartal", "3cü kvartal", "4cü kvartal"],
};
const monthValues$1c = {
  narrow: ["Y", "F", "M", "A", "M", "İ", "İ", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Yan",
    "Fev",
    "Mar",
    "Apr",
    "May",
    "İyun",
    "İyul",
    "Avq",
    "Sen",
    "Okt",
    "Noy",
    "Dek",
  ],

  wide: [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "İyun",
    "İyul",
    "Avqust",
    "Sentyabr",
    "Oktyabr",
    "Noyabr",
    "Dekabr",
  ],
};

const dayValues$1c = {
  narrow: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  short: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  abbreviated: ["Baz", "Baz.e", "Çər.a", "Çər", "Cüm.a", "Cüm", "Şə"],
  wide: [
    "Bazar",
    "Bazar ertəsi",
    "Çərşənbə axşamı",
    "Çərşənbə",
    "Cümə axşamı",
    "Cümə",
    "Şənbə",
  ],
};

const dayPeriodValues$1c = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə",
  },
};

const formattingDayPeriodValues$Y = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə",
  },
};

const suffixes$1 = {
  1: "-inci",
  5: "-inci",
  8: "-inci",
  70: "-inci",
  80: "-inci",
  2: "-nci",
  7: "-nci",
  20: "-nci",
  50: "-nci",
  3: "-üncü",
  4: "-üncü",
  100: "-üncü",
  6: "-ncı",
  9: "-uncu",
  10: "-uncu",
  30: "-uncu",
  60: "-ıncı",
  90: "-ıncı",
};

const getSuffix = (number) => {
  if (number === 0) {
    // special case for zero
    return number + "-ıncı";
  }

  const a = number % 10;
  const b = (number % 100) - a;
  const c = number >= 100 ? 100 : null;

  if (suffixes$1[a]) {
    return suffixes$1[a];
  } else if (suffixes$1[b]) {
    return suffixes$1[b];
  } else if (c !== null) {
    return suffixes$1[c];
  }
  return "";
};

const ordinalNumber$1c = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const suffix = getSuffix(number);

  return number + suffix;
};

(localize$1c.localize = {
  ordinalNumber: ordinalNumber$1c,

  era: (0, _index$5h.buildLocalizeFn)({
    values: eraValues$1c,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$5h.buildLocalizeFn)({
    values: quarterValues$1c,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$5h.buildLocalizeFn)({
    values: monthValues$1c,
    defaultWidth: "wide",
  }),

  day: (0, _index$5h.buildLocalizeFn)({
    values: dayValues$1c,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$5h.buildLocalizeFn)({
    values: dayPeriodValues$1c,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$Y,
    defaultFormattingWidth: "wide",
  }),
});

var match$1b = {};

match$1b.match = void 0;

var _index$5g = buildMatchFn$1;
var _index2$2C = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$1b = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
const parseOrdinalNumberPattern$1b = /\d+/i;

const matchEraPatterns$1b = {
  narrow: /^(b|a)$/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
  wide: /^(bizim eradan əvvəl|bizim era)$/i,
};
const parseEraPatterns$1b = {
  any: [/^b$/i, /^(a|c)$/i],
};

const matchQuarterPatterns$1b = {
  narrow: /^[1234]$/i,
  abbreviated: /^K[1234]$/i,
  wide: /^[1234](ci)? kvartal$/i,
};
const parseQuarterPatterns$1b = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1b = {
  narrow: /^[(?-i)yfmaisond]$/i,
  abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
  wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i,
};
const parseMonthPatterns$1b = {
  narrow: [
    /^[(?-i)y]$/i,
    /^[(?-i)f]$/i,
    /^[(?-i)m]$/i,
    /^[(?-i)a]$/i,
    /^[(?-i)m]$/i,
    /^[(?-i)i]$/i,
    /^[(?-i)i]$/i,
    /^[(?-i)a]$/i,
    /^[(?-i)s]$/i,
    /^[(?-i)o]$/i,
    /^[(?-i)n]$/i,
    /^[(?-i)d]$/i,
  ],

  abbreviated: [
    /^Yan$/i,
    /^Fev$/i,
    /^Mar$/i,
    /^Apr$/i,
    /^May$/i,
    /^İyun$/i,
    /^İyul$/i,
    /^Avg$/i,
    /^Sen$/i,
    /^Okt$/i,
    /^Noy$/i,
    /^Dek$/i,
  ],

  wide: [
    /^Yanvar$/i,
    /^Fevral$/i,
    /^Mart$/i,
    /^Aprel$/i,
    /^May$/i,
    /^İyun$/i,
    /^İyul$/i,
    /^Avgust$/i,
    /^Sentyabr$/i,
    /^Oktyabr$/i,
    /^Noyabr$/i,
    /^Dekabr$/i,
  ],
};

const matchDayPatterns$1b = {
  narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
  wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i,
};
const parseDayPatterns$1b = {
  narrow: [
    /^B\.$/i,
    /^B\.e$/i,
    /^Ç\.a$/i,
    /^Ç\.$/i,
    /^C\.a$/i,
    /^C\.$/i,
    /^Ş\.$/i,
  ],

  abbreviated: [
    /^Baz$/i,
    /^Baz\.e$/i,
    /^Çər\.a$/i,
    /^Çər$/i,
    /^Cüm\.a$/i,
    /^Cüm$/i,
    /^Şə$/i,
  ],

  wide: [
    /^Bazar$/i,
    /^Bazar ertəsi$/i,
    /^Çərşənbə axşamı$/i,
    /^Çərşənbə$/i,
    /^Cümə axşamı$/i,
    /^Cümə$/i,
    /^Şənbə$/i,
  ],

  any: [
    /^B\.$/i,
    /^B\.e$/i,
    /^Ç\.a$/i,
    /^Ç\.$/i,
    /^C\.a$/i,
    /^C\.$/i,
    /^Ş\.$/i,
  ],
};

const matchDayPeriodPatterns$1b = {
  narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
  any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
};
const parseDayPeriodPatterns$1b = {
  any: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /^gecəyarı$/i,
    noon: /^gün$/i,
    morning: /səhər$/i,
    afternoon: /gündüz$/i,
    evening: /axşam$/i,
    night: /gecə$/i,
  },
};

(match$1b.match = {
  ordinalNumber: (0, _index2$2C.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1b,
    parsePattern: parseOrdinalNumberPattern$1b,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$5g.buildMatchFn)({
    matchPatterns: matchEraPatterns$1b,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1b,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$5g.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1b,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1b,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$5g.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1b,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1b,
    defaultParseWidth: "narrow",
  }),

  day: (0, _index$5g.buildMatchFn)({
    matchPatterns: matchDayPatterns$1b,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1b,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$5g.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1b,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1b,
    defaultParseWidth: "any",
  }),
});

az.az = void 0;
var _index$5f = formatDistance$2p;
var _index2$2B = formatLong$1k;
var _index3$1n = formatRelative$2p;
var _index4$1m = localize$1c;
var _index5$1m = match$1b;

/**
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */

(az.az = {
  code: "az",
  formatDistance: _index$5f.formatDistance,
  formatLong: _index2$2B.formatLong,
  formatRelative: _index3$1n.formatRelative,
  localize: _index4$1m.localize,
  match: _index5$1m.match,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1,
  },
});

var be = {};

var formatDistance$2n = {};

formatDistance$2n.formatDistance = void 0;

function declension$6(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  const rem10 = count % 10;
  const rem100 = count % 100;

  // 1, 21, 31, ...
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));

    // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));

    // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}

function buildLocalizeTokenFn$4(scheme) {
  return (count, options) => {
    if (options && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension$6(scheme.future, count);
        } else {
          return "праз " + declension$6(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension$6(scheme.past, count);
        } else {
          return declension$6(scheme.regular, count) + " таму";
        }
      }
    } else {
      return declension$6(scheme.regular, count);
    }
  };
}

const halfAMinute$1 = (_, options) => {
  if (options && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "праз паўхвіліны";
    } else {
      return "паўхвіліны таму";
    }
  }

  return "паўхвіліны";
};

const formatDistanceLocale$1a = {
  lessThanXSeconds: buildLocalizeTokenFn$4({
    regular: {
      one: "менш за секунду",
      singularNominative: "менш за {{count}} секунду",
      singularGenitive: "менш за {{count}} секунды",
      pluralGenitive: "менш за {{count}} секунд",
    },
    future: {
      one: "менш, чым праз секунду",
      singularNominative: "менш, чым праз {{count}} секунду",
      singularGenitive: "менш, чым праз {{count}} секунды",
      pluralGenitive: "менш, чым праз {{count}} секунд",
    },
  }),

  xSeconds: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд",
    },
    past: {
      singularNominative: "{{count}} секунду таму",
      singularGenitive: "{{count}} секунды таму",
      pluralGenitive: "{{count}} секунд таму",
    },
    future: {
      singularNominative: "праз {{count}} секунду",
      singularGenitive: "праз {{count}} секунды",
      pluralGenitive: "праз {{count}} секунд",
    },
  }),

  halfAMinute: halfAMinute$1,

  lessThanXMinutes: buildLocalizeTokenFn$4({
    regular: {
      one: "менш за хвіліну",
      singularNominative: "менш за {{count}} хвіліну",
      singularGenitive: "менш за {{count}} хвіліны",
      pluralGenitive: "менш за {{count}} хвілін",
    },
    future: {
      one: "менш, чым праз хвіліну",
      singularNominative: "менш, чым праз {{count}} хвіліну",
      singularGenitive: "менш, чым праз {{count}} хвіліны",
      pluralGenitive: "менш, чым праз {{count}} хвілін",
    },
  }),

  xMinutes: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "{{count}} хвіліна",
      singularGenitive: "{{count}} хвіліны",
      pluralGenitive: "{{count}} хвілін",
    },
    past: {
      singularNominative: "{{count}} хвіліну таму",
      singularGenitive: "{{count}} хвіліны таму",
      pluralGenitive: "{{count}} хвілін таму",
    },
    future: {
      singularNominative: "праз {{count}} хвіліну",
      singularGenitive: "праз {{count}} хвіліны",
      pluralGenitive: "праз {{count}} хвілін",
    },
  }),

  aboutXHours: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "каля {{count}} гадзіны",
      singularGenitive: "каля {{count}} гадзін",
      pluralGenitive: "каля {{count}} гадзін",
    },
    future: {
      singularNominative: "прыблізна праз {{count}} гадзіну",
      singularGenitive: "прыблізна праз {{count}} гадзіны",
      pluralGenitive: "прыблізна праз {{count}} гадзін",
    },
  }),

  xHours: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "{{count}} гадзіна",
      singularGenitive: "{{count}} гадзіны",
      pluralGenitive: "{{count}} гадзін",
    },
    past: {
      singularNominative: "{{count}} гадзіну таму",
      singularGenitive: "{{count}} гадзіны таму",
      pluralGenitive: "{{count}} гадзін таму",
    },
    future: {
      singularNominative: "праз {{count}} гадзіну",
      singularGenitive: "праз {{count}} гадзіны",
      pluralGenitive: "праз {{count}} гадзін",
    },
  }),

  xDays: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "{{count}} дзень",
      singularGenitive: "{{count}} дні",
      pluralGenitive: "{{count}} дзён",
    },
  }),

  aboutXWeeks: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "каля {{count}} тыдні",
      singularGenitive: "каля {{count}} тыдняў",
      pluralGenitive: "каля {{count}} тыдняў",
    },
    future: {
      singularNominative: "прыблізна праз {{count}} тыдзень",
      singularGenitive: "прыблізна праз {{count}} тыдні",
      pluralGenitive: "прыблізна праз {{count}} тыдняў",
    },
  }),

  xWeeks: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "{{count}} тыдзень",
      singularGenitive: "{{count}} тыдні",
      pluralGenitive: "{{count}} тыдняў",
    },
  }),

  aboutXMonths: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў",
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў",
    },
  }),

  xMonths: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў",
    },
  }),

  aboutXYears: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "каля {{count}} года",
      singularGenitive: "каля {{count}} гадоў",
      pluralGenitive: "каля {{count}} гадоў",
    },
    future: {
      singularNominative: "прыблізна праз {{count}} год",
      singularGenitive: "прыблізна праз {{count}} гады",
      pluralGenitive: "прыблізна праз {{count}} гадоў",
    },
  }),

  xYears: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} гады",
      pluralGenitive: "{{count}} гадоў",
    },
  }),

  overXYears: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "больш за {{count}} год",
      singularGenitive: "больш за {{count}} гады",
      pluralGenitive: "больш за {{count}} гадоў",
    },
    future: {
      singularNominative: "больш, чым праз {{count}} год",
      singularGenitive: "больш, чым праз {{count}} гады",
      pluralGenitive: "больш, чым праз {{count}} гадоў",
    },
  }),

  almostXYears: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: "амаль {{count}} год",
      singularGenitive: "амаль {{count}} гады",
      pluralGenitive: "амаль {{count}} гадоў",
    },
    future: {
      singularNominative: "амаль праз {{count}} год",
      singularGenitive: "амаль праз {{count}} гады",
      pluralGenitive: "амаль праз {{count}} гадоў",
    },
  }),
};

const formatDistance$2m = (token, count, options) => {
  options = options || {};
  return formatDistanceLocale$1a[token](count, options);
};
formatDistance$2n.formatDistance = formatDistance$2m;

var formatLong$1j = {};

formatLong$1j.formatLong = void 0;
var _index$5e = buildFormatLongFn$1;

const dateFormats$1j = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y",
};

const timeFormats$1j = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$1j = {
  any: "{{date}}, {{time}}",
};

(formatLong$1j.formatLong = {
  date: (0, _index$5e.buildFormatLongFn)({
    formats: dateFormats$1j,
    defaultWidth: "full",
  }),

  time: (0, _index$5e.buildFormatLongFn)({
    formats: timeFormats$1j,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$5e.buildFormatLongFn)({
    formats: dateTimeFormats$1j,
    defaultWidth: "any",
  }),
});

var formatRelative$2n = {};

formatRelative$2n.formatRelative = void 0;
var _index$5d = isSameWeek$1;
var _index2$2A = toDate$1;

const accusativeWeekdays$7 = [
  "нядзелю",
  "панядзелак",
  "аўторак",
  "сераду",
  "чацвер",
  "пятніцу",
  "суботу",
];

function lastWeek$8(day) {
  const weekday = accusativeWeekdays$7[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + weekday + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у мінулы " + weekday + " а' p";
  }
}

function thisWeek$8(day) {
  const weekday = accusativeWeekdays$7[day];

  return "'у " + weekday + " а' p";
}

function nextWeek$8(day) {
  const weekday = accusativeWeekdays$7[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + weekday + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у наступны " + weekday + " а' p";
  }
}

const lastWeekFormat$2 = (dirtyDate, baseDate, options) => {
  const date = (0, _index2$2A.toDate)(dirtyDate);
  const day = date.getDay();
  if ((0, _index$5d.isSameWeek)(date, baseDate, options)) {
    return thisWeek$8(day);
  } else {
    return lastWeek$8(day);
  }
};

const nextWeekFormat$2 = (dirtyDate, baseDate, options) => {
  const date = (0, _index2$2A.toDate)(dirtyDate);
  const day = date.getDay();
  if ((0, _index$5d.isSameWeek)(date, baseDate, options)) {
    return thisWeek$8(day);
  } else {
    return nextWeek$8(day);
  }
};

const formatRelativeLocale$1b = {
  lastWeek: lastWeekFormat$2,
  yesterday: "'учора а' p",
  today: "'сёння а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: nextWeekFormat$2,
  other: "P",
};

const formatRelative$2m = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$1b[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$2n.formatRelative = formatRelative$2m;

var localize$1b = {};

localize$1b.localize = void 0;

var _index$5c = buildLocalizeFn$1;

const eraValues$1b = {
  narrow: ["да н.э.", "н.э."],
  abbreviated: ["да н. э.", "н. э."],
  wide: ["да нашай эры", "нашай эры"],
};

const quarterValues$1b = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ы кв.", "2-і кв.", "3-і кв.", "4-ы кв."],
  wide: ["1-ы квартал", "2-і квартал", "3-і квартал", "4-ы квартал"],
};

const monthValues$1b = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "май",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "снеж.",
  ],

  wide: [
    "студзень",
    "люты",
    "сакавік",
    "красавік",
    "май",
    "чэрвень",
    "ліпень",
    "жнівень",
    "верасень",
    "кастрычнік",
    "лістапад",
    "снежань",
  ],
};
const formattingMonthValues$i = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "мая",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "снеж.",
  ],

  wide: [
    "студзеня",
    "лютага",
    "сакавіка",
    "красавіка",
    "мая",
    "чэрвеня",
    "ліпеня",
    "жніўня",
    "верасня",
    "кастрычніка",
    "лістапада",
    "снежня",
  ],
};

const dayValues$1b = {
  narrow: ["Н", "П", "А", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "аў", "ср", "чц", "пт", "сб"],
  abbreviated: ["нядз", "пан", "аўт", "сер", "чац", "пят", "суб"],
  wide: [
    "нядзеля",
    "панядзелак",
    "аўторак",
    "серада",
    "чацвер",
    "пятніца",
    "субота",
  ],
};

const dayPeriodValues$1b = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніца",
    afternoon: "дзень",
    evening: "вечар",
    night: "ноч",
  },
};
const formattingDayPeriodValues$X = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніцы",
    afternoon: "дня",
    evening: "вечара",
    night: "ночы",
  },
};

const ordinalNumber$1b = (dirtyNumber, options) => {
  const unit = String(options?.unit);
  const number = Number(dirtyNumber);
  let suffix;

  /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */
  if (unit === "date") {
    suffix = "-га";
  } else if (unit === "hour" || unit === "minute" || unit === "second") {
    suffix = "-я";
  } else {
    suffix =
      (number % 10 === 2 || number % 10 === 3) &&
      number % 100 !== 12 &&
      number % 100 !== 13
        ? "-і"
        : "-ы";
  }

  return number + suffix;
};

(localize$1b.localize = {
  ordinalNumber: ordinalNumber$1b,

  era: (0, _index$5c.buildLocalizeFn)({
    values: eraValues$1b,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$5c.buildLocalizeFn)({
    values: quarterValues$1b,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$5c.buildLocalizeFn)({
    values: monthValues$1b,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$i,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$5c.buildLocalizeFn)({
    values: dayValues$1b,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$5c.buildLocalizeFn)({
    values: dayPeriodValues$1b,
    defaultWidth: "any",
    formattingValues: formattingDayPeriodValues$X,
    defaultFormattingWidth: "wide",
  }),
});

var match$1a = {};

match$1a.match = void 0;

var _index$5b = buildMatchFn$1;
var _index2$2z = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$1a =
  /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
const parseOrdinalNumberPattern$1a = /\d+/i;

const matchEraPatterns$1a = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i,
};
const parseEraPatterns$1a = {
  any: [/^д/i, /^н/i],
};

const matchQuarterPatterns$1a = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i,
};
const parseQuarterPatterns$1a = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$1a = {
  narrow: /^[слкмчжв]/i,
  abbreviated:
    /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i,
};
const parseMonthPatterns$1a = {
  narrow: [
    /^с/i,
    /^л/i,
    /^с/i,
    /^к/i,
    /^м/i,
    /^ч/i,
    /^л/i,
    /^ж/i,
    /^в/i,
    /^к/i,
    /^л/i,
    /^с/i,
  ],

  any: [
    /^ст/i,
    /^лю/i,
    /^са/i,
    /^кр/i,
    /^ма/i,
    /^ч/i,
    /^ліп/i,
    /^ж/i,
    /^в/i,
    /^ка/i,
    /^ліс/i,
    /^сн/i,
  ],
};

const matchDayPatterns$1a = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i,
};
const parseDayPatterns$1a = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i],
};

const matchDayPeriodPatterns$1a = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i,
};
const parseDayPeriodPatterns$1a = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i,
  },
};

(match$1a.match = {
  ordinalNumber: (0, _index2$2z.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1a,
    parsePattern: parseOrdinalNumberPattern$1a,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$5b.buildMatchFn)({
    matchPatterns: matchEraPatterns$1a,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1a,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$5b.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1a,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1a,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$5b.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1a,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1a,
    defaultParseWidth: "any",
  }),

  day: (0, _index$5b.buildMatchFn)({
    matchPatterns: matchDayPatterns$1a,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1a,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$5b.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1a,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$1a,
    defaultParseWidth: "any",
  }),
});

be.be = void 0;
var _index$5a = formatDistance$2n;
var _index2$2y = formatLong$1j;
var _index3$1m = formatRelative$2n;
var _index4$1l = localize$1b;
var _index5$1l = match$1a;

/**
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik](https://github.com/alyrik)
 * @author Martin Wind [@arvigeus](https://github.com/mawi12345)
 */
(be.be = {
  code: "be",
  formatDistance: _index$5a.formatDistance,
  formatLong: _index2$2y.formatLong,
  formatRelative: _index3$1m.formatRelative,
  localize: _index4$1l.localize,
  match: _index5$1l.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var beTarask = {};

var formatDistance$2l = {};

formatDistance$2l.formatDistance = void 0;

function declension$5(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  const rem10 = count % 10;
  const rem100 = count % 100;

  // 1, 21, 31, ...
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));

    // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));

    // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}

function buildLocalizeTokenFn$3(scheme) {
  return (count, options) => {
    if (options && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension$5(scheme.future, count);
        } else {
          return "праз " + declension$5(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension$5(scheme.past, count);
        } else {
          return declension$5(scheme.regular, count) + " таму";
        }
      }
    } else {
      return declension$5(scheme.regular, count);
    }
  };
}

const halfAMinute = (_, options) => {
  if (options && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "праз паўхвіліны";
    } else {
      return "паўхвіліны таму";
    }
  }

  return "паўхвіліны";
};

const formatDistanceLocale$19 = {
  lessThanXSeconds: buildLocalizeTokenFn$3({
    regular: {
      one: "менш за секунду",
      singularNominative: "менш за {{count}} секунду",
      singularGenitive: "менш за {{count}} секунды",
      pluralGenitive: "менш за {{count}} секунд",
    },
    future: {
      one: "менш, чым праз секунду",
      singularNominative: "менш, чым праз {{count}} секунду",
      singularGenitive: "менш, чым праз {{count}} секунды",
      pluralGenitive: "менш, чым праз {{count}} секунд",
    },
  }),

  xSeconds: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд",
    },
    past: {
      singularNominative: "{{count}} секунду таму",
      singularGenitive: "{{count}} секунды таму",
      pluralGenitive: "{{count}} секунд таму",
    },
    future: {
      singularNominative: "праз {{count}} секунду",
      singularGenitive: "праз {{count}} секунды",
      pluralGenitive: "праз {{count}} секунд",
    },
  }),

  halfAMinute: halfAMinute,

  lessThanXMinutes: buildLocalizeTokenFn$3({
    regular: {
      one: "менш за хвіліну",
      singularNominative: "менш за {{count}} хвіліну",
      singularGenitive: "менш за {{count}} хвіліны",
      pluralGenitive: "менш за {{count}} хвілін",
    },
    future: {
      one: "менш, чым праз хвіліну",
      singularNominative: "менш, чым праз {{count}} хвіліну",
      singularGenitive: "менш, чым праз {{count}} хвіліны",
      pluralGenitive: "менш, чым праз {{count}} хвілін",
    },
  }),

  xMinutes: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "{{count}} хвіліна",
      singularGenitive: "{{count}} хвіліны",
      pluralGenitive: "{{count}} хвілін",
    },
    past: {
      singularNominative: "{{count}} хвіліну таму",
      singularGenitive: "{{count}} хвіліны таму",
      pluralGenitive: "{{count}} хвілін таму",
    },
    future: {
      singularNominative: "праз {{count}} хвіліну",
      singularGenitive: "праз {{count}} хвіліны",
      pluralGenitive: "праз {{count}} хвілін",
    },
  }),

  aboutXHours: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "каля {{count}} гадзіны",
      singularGenitive: "каля {{count}} гадзін",
      pluralGenitive: "каля {{count}} гадзін",
    },
    future: {
      singularNominative: "прыблізна праз {{count}} гадзіну",
      singularGenitive: "прыблізна праз {{count}} гадзіны",
      pluralGenitive: "прыблізна праз {{count}} гадзін",
    },
  }),

  xHours: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "{{count}} гадзіна",
      singularGenitive: "{{count}} гадзіны",
      pluralGenitive: "{{count}} гадзін",
    },
    past: {
      singularNominative: "{{count}} гадзіну таму",
      singularGenitive: "{{count}} гадзіны таму",
      pluralGenitive: "{{count}} гадзін таму",
    },
    future: {
      singularNominative: "праз {{count}} гадзіну",
      singularGenitive: "праз {{count}} гадзіны",
      pluralGenitive: "праз {{count}} гадзін",
    },
  }),

  xDays: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "{{count}} дзень",
      singularGenitive: "{{count}} дні",
      pluralGenitive: "{{count}} дзён",
    },
  }),

  aboutXWeeks: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "каля {{count}} тыдні",
      singularGenitive: "каля {{count}} тыдняў",
      pluralGenitive: "каля {{count}} тыдняў",
    },
    future: {
      singularNominative: "прыблізна праз {{count}} тыдзень",
      singularGenitive: "прыблізна праз {{count}} тыдні",
      pluralGenitive: "прыблізна праз {{count}} тыдняў",
    },
  }),

  xWeeks: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "{{count}} тыдзень",
      singularGenitive: "{{count}} тыдні",
      pluralGenitive: "{{count}} тыдняў",
    },
  }),

  aboutXMonths: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў",
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў",
    },
  }),

  xMonths: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў",
    },
  }),

  aboutXYears: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "каля {{count}} года",
      singularGenitive: "каля {{count}} гадоў",
      pluralGenitive: "каля {{count}} гадоў",
    },
    future: {
      singularNominative: "прыблізна праз {{count}} год",
      singularGenitive: "прыблізна праз {{count}} гады",
      pluralGenitive: "прыблізна праз {{count}} гадоў",
    },
  }),

  xYears: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} гады",
      pluralGenitive: "{{count}} гадоў",
    },
  }),

  overXYears: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "больш за {{count}} год",
      singularGenitive: "больш за {{count}} гады",
      pluralGenitive: "больш за {{count}} гадоў",
    },
    future: {
      singularNominative: "больш, чым праз {{count}} год",
      singularGenitive: "больш, чым праз {{count}} гады",
      pluralGenitive: "больш, чым праз {{count}} гадоў",
    },
  }),

  almostXYears: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: "амаль {{count}} год",
      singularGenitive: "амаль {{count}} гады",
      pluralGenitive: "амаль {{count}} гадоў",
    },
    future: {
      singularNominative: "амаль праз {{count}} год",
      singularGenitive: "амаль праз {{count}} гады",
      pluralGenitive: "амаль праз {{count}} гадоў",
    },
  }),
};

const formatDistance$2k = (token, count, options) => {
  options = options || {};
  return formatDistanceLocale$19[token](count, options);
};
formatDistance$2l.formatDistance = formatDistance$2k;

var formatLong$1i = {};

formatLong$1i.formatLong = void 0;
var _index$59 = buildFormatLongFn$1;

const dateFormats$1i = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y",
};

const timeFormats$1i = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$1i = {
  any: "{{date}}, {{time}}",
};

(formatLong$1i.formatLong = {
  date: (0, _index$59.buildFormatLongFn)({
    formats: dateFormats$1i,
    defaultWidth: "full",
  }),

  time: (0, _index$59.buildFormatLongFn)({
    formats: timeFormats$1i,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$59.buildFormatLongFn)({
    formats: dateTimeFormats$1i,
    defaultWidth: "any",
  }),
});

var formatRelative$2l = {};

formatRelative$2l.formatRelative = void 0;
var _index$58 = isSameWeek$1;
var _index2$2x = toDate$1;

const accusativeWeekdays$6 = [
  "нядзелю",
  "панядзелак",
  "аўторак",
  "сераду",
  "чацьвер",
  "пятніцу",
  "суботу",
];

function lastWeek$7(day) {
  const weekday = accusativeWeekdays$6[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + weekday + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у мінулы " + weekday + " а' p";
  }
}

function thisWeek$7(day) {
  const weekday = accusativeWeekdays$6[day];

  return "'у " + weekday + " а' p";
}

function nextWeek$7(day) {
  const weekday = accusativeWeekdays$6[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + weekday + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у наступны " + weekday + " а' p";
  }
}

const lastWeekFormat$1 = (dirtyDate, baseDate, options) => {
  const date = (0, _index2$2x.toDate)(dirtyDate);
  const day = date.getDay();
  if ((0, _index$58.isSameWeek)(date, baseDate, options)) {
    return thisWeek$7(day);
  } else {
    return lastWeek$7(day);
  }
};

const nextWeekFormat$1 = (dirtyDate, baseDate, options) => {
  const date = (0, _index2$2x.toDate)(dirtyDate);
  const day = date.getDay();
  if ((0, _index$58.isSameWeek)(date, baseDate, options)) {
    return thisWeek$7(day);
  } else {
    return nextWeek$7(day);
  }
};

const formatRelativeLocale$1a = {
  lastWeek: lastWeekFormat$1,
  yesterday: "'учора а' p",
  today: "'сёньня а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: nextWeekFormat$1,
  other: "P",
};

const formatRelative$2k = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$1a[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$2l.formatRelative = formatRelative$2k;

var localize$1a = {};

localize$1a.localize = void 0;

var _index$57 = buildLocalizeFn$1;

const eraValues$1a = {
  narrow: ["да н.э.", "н.э."],
  abbreviated: ["да н. э.", "н. э."],
  wide: ["да нашай эры", "нашай эры"],
};

const quarterValues$1a = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ы кв.", "2-і кв.", "3-і кв.", "4-ы кв."],
  wide: ["1-ы квартал", "2-і квартал", "3-і квартал", "4-ы квартал"],
};

const monthValues$1a = {
  narrow: ["С", "Л", "С", "К", "Т", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "трав.",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "сьнеж.",
  ],

  wide: [
    "студзень",
    "люты",
    "сакавік",
    "красавік",
    "травень",
    "чэрвень",
    "ліпень",
    "жнівень",
    "верасень",
    "кастрычнік",
    "лістапад",
    "сьнежань",
  ],
};
const formattingMonthValues$h = {
  narrow: ["С", "Л", "С", "К", "Т", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "трав.",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "сьнеж.",
  ],

  wide: [
    "студзеня",
    "лютага",
    "сакавіка",
    "красавіка",
    "траўня",
    "чэрвеня",
    "ліпеня",
    "жніўня",
    "верасня",
    "кастрычніка",
    "лістапада",
    "сьнежня",
  ],
};

const dayValues$1a = {
  narrow: ["Н", "П", "А", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "аў", "ср", "чц", "пт", "сб"],
  abbreviated: ["нядз", "пан", "аўт", "сер", "чаць", "пят", "суб"],
  wide: [
    "нядзеля",
    "панядзелак",
    "аўторак",
    "серада",
    "чацьвер",
    "пятніца",
    "субота",
  ],
};

const dayPeriodValues$1a = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніца",
    afternoon: "дзень",
    evening: "вечар",
    night: "ноч",
  },
};
const formattingDayPeriodValues$W = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніцы",
    afternoon: "дня",
    evening: "вечара",
    night: "ночы",
  },
};

const ordinalNumber$1a = (dirtyNumber, options) => {
  const unit = String(options?.unit);
  const number = Number(dirtyNumber);
  let suffix;

  /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */
  if (unit === "date") {
    suffix = "-га";
  } else if (unit === "hour" || unit === "minute" || unit === "second") {
    suffix = "-я";
  } else {
    suffix =
      (number % 10 === 2 || number % 10 === 3) &&
      number % 100 !== 12 &&
      number % 100 !== 13
        ? "-і"
        : "-ы";
  }

  return number + suffix;
};

(localize$1a.localize = {
  ordinalNumber: ordinalNumber$1a,

  era: (0, _index$57.buildLocalizeFn)({
    values: eraValues$1a,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$57.buildLocalizeFn)({
    values: quarterValues$1a,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$57.buildLocalizeFn)({
    values: monthValues$1a,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$h,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$57.buildLocalizeFn)({
    values: dayValues$1a,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$57.buildLocalizeFn)({
    values: dayPeriodValues$1a,
    defaultWidth: "any",
    formattingValues: formattingDayPeriodValues$W,
    defaultFormattingWidth: "wide",
  }),
});

var match$19 = {};

match$19.match = void 0;

var _index$56 = buildMatchFn$1;
var _index2$2w = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$19 =
  /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
const parseOrdinalNumberPattern$19 = /\d+/i;

const matchEraPatterns$19 = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i,
};
const parseEraPatterns$19 = {
  any: [/^д/i, /^н/i],
};

const matchQuarterPatterns$19 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i,
};
const parseQuarterPatterns$19 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$19 = {
  narrow: /^[слкмчжв]/i,
  abbreviated:
    /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i,
};
const parseMonthPatterns$19 = {
  narrow: [
    /^с/i,
    /^л/i,
    /^с/i,
    /^к/i,
    /^т/i,
    /^ч/i,
    /^л/i,
    /^ж/i,
    /^в/i,
    /^к/i,
    /^л/i,
    /^с/i,
  ],

  any: [
    /^ст/i,
    /^лю/i,
    /^са/i,
    /^кр/i,
    /^тр/i,
    /^ч/i,
    /^ліп/i,
    /^ж/i,
    /^в/i,
    /^ка/i,
    /^ліс/i,
    /^сн/i,
  ],
};

const matchDayPatterns$19 = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i,
};
const parseDayPatterns$19 = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i],
};

const matchDayPeriodPatterns$19 = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i,
};
const parseDayPeriodPatterns$19 = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i,
  },
};

(match$19.match = {
  ordinalNumber: (0, _index2$2w.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$19,
    parsePattern: parseOrdinalNumberPattern$19,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$56.buildMatchFn)({
    matchPatterns: matchEraPatterns$19,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$19,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$56.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$19,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$19,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$56.buildMatchFn)({
    matchPatterns: matchMonthPatterns$19,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$19,
    defaultParseWidth: "any",
  }),

  day: (0, _index$56.buildMatchFn)({
    matchPatterns: matchDayPatterns$19,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$19,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$56.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$19,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$19,
    defaultParseWidth: "any",
  }),
});

beTarask.beTarask = void 0;
var _index$55 = formatDistance$2l;
var _index2$2v = formatLong$1i;
var _index3$1l = formatRelative$2l;
var _index4$1k = localize$1a;
var _index5$1k = match$19;

/**
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears](https://github.com/nopears)
 */
(beTarask.beTarask = {
  code: "be-tarask",
  formatDistance: _index$55.formatDistance,
  formatLong: _index2$2v.formatLong,
  formatRelative: _index3$1l.formatRelative,
  localize: _index4$1k.localize,
  match: _index5$1k.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var bg = {};

var formatDistance$2j = {};

formatDistance$2j.formatDistance = void 0;

const formatDistanceLocale$18 = {
  lessThanXSeconds: {
    one: "по-малко от секунда",
    other: "по-малко от {{count}} секунди",
  },

  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди",
  },

  halfAMinute: "половин минута",

  lessThanXMinutes: {
    one: "по-малко от минута",
    other: "по-малко от {{count}} минути",
  },

  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути",
  },

  aboutXHours: {
    one: "около час",
    other: "около {{count}} часа",
  },

  xHours: {
    one: "1 час",
    other: "{{count}} часа",
  },

  xDays: {
    one: "1 ден",
    other: "{{count}} дни",
  },

  aboutXWeeks: {
    one: "около седмица",
    other: "около {{count}} седмици",
  },

  xWeeks: {
    one: "1 седмица",
    other: "{{count}} седмици",
  },

  aboutXMonths: {
    one: "около месец",
    other: "около {{count}} месеца",
  },

  xMonths: {
    one: "1 месец",
    other: "{{count}} месеца",
  },

  aboutXYears: {
    one: "около година",
    other: "около {{count}} години",
  },

  xYears: {
    one: "1 година",
    other: "{{count}} години",
  },

  overXYears: {
    one: "над година",
    other: "над {{count}} години",
  },

  almostXYears: {
    one: "почти година",
    other: "почти {{count}} години",
  },
};

const formatDistance$2i = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$18[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "след " + result;
    } else {
      return "преди " + result;
    }
  }

  return result;
};
formatDistance$2j.formatDistance = formatDistance$2i;

var formatLong$1h = {};

formatLong$1h.formatLong = void 0;
var _index$54 = buildFormatLongFn$1;

const dateFormats$1h = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy",
};

const timeFormats$1h = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$1h = {
  any: "{{date}} {{time}}",
};

(formatLong$1h.formatLong = {
  date: (0, _index$54.buildFormatLongFn)({
    formats: dateFormats$1h,
    defaultWidth: "full",
  }),

  time: (0, _index$54.buildFormatLongFn)({
    formats: timeFormats$1h,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$54.buildFormatLongFn)({
    formats: dateTimeFormats$1h,
    defaultWidth: "any",
  }),
});

var formatRelative$2j = {};

formatRelative$2j.formatRelative = void 0;
var _index$53 = isSameWeek$1;
var _index2$2u = toDate$1;

// Adapted from the `ru` translation

const weekdays$3 = [
  "неделя",
  "понеделник",
  "вторник",
  "сряда",
  "четвъртък",
  "петък",
  "събота",
];

function lastWeek$6(day) {
  const weekday = weekdays$3[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'миналата " + weekday + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'миналия " + weekday + " в' p";
  }
}

function thisWeek$6(day) {
  const weekday = weekdays$3[day];

  if (day === 2 /* Tue */) {
    return "'във " + weekday + " в' p";
  } else {
    return "'в " + weekday + " в' p";
  }
}

function nextWeek$6(day) {
  const weekday = weekdays$3[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'следващата " + weekday + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следващия " + weekday + " в' p";
  }
}

const lastWeekFormatToken = (dirtyDate, baseDate, options) => {
  const date = (0, _index2$2u.toDate)(dirtyDate);
  const day = date.getDay();
  if ((0, _index$53.isSameWeek)(date, baseDate, options)) {
    return thisWeek$6(day);
  } else {
    return lastWeek$6(day);
  }
};

const nextWeekFormatToken = (dirtyDate, baseDate, options) => {
  const date = (0, _index2$2u.toDate)(dirtyDate);
  const day = date.getDay();
  if ((0, _index$53.isSameWeek)(date, baseDate, options)) {
    return thisWeek$6(day);
  } else {
    return nextWeek$6(day);
  }
};

const formatRelativeLocale$19 = {
  lastWeek: lastWeekFormatToken,
  yesterday: "'вчера в' p",
  today: "'днес в' p",
  tomorrow: "'утре в' p",
  nextWeek: nextWeekFormatToken,
  other: "P",
};

const formatRelative$2i = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$19[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$2j.formatRelative = formatRelative$2i;

var localize$19 = {};

localize$19.localize = void 0;
var _index$52 = buildLocalizeFn$1;

const eraValues$19 = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["преди н. е.", "н. е."],
  wide: ["преди новата ера", "новата ера"],
};

const quarterValues$19 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-во тримес.", "2-ро тримес.", "3-то тримес.", "4-то тримес."],

  wide: [
    "1-во тримесечие",
    "2-ро тримесечие",
    "3-то тримесечие",
    "4-то тримесечие",
  ],
};

const monthValues$19 = {
  abbreviated: [
    "яну",
    "фев",
    "мар",
    "апр",
    "май",
    "юни",
    "юли",
    "авг",
    "сеп",
    "окт",
    "ное",
    "дек",
  ],

  wide: [
    "януари",
    "февруари",
    "март",
    "април",
    "май",
    "юни",
    "юли",
    "август",
    "септември",
    "октомври",
    "ноември",
    "декември",
  ],
};

const dayValues$19 = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вто", "сря", "чет", "пет", "съб"],
  wide: [
    "неделя",
    "понеделник",
    "вторник",
    "сряда",
    "четвъртък",
    "петък",
    "събота",
  ],
};

const dayPeriodValues$19 = {
  wide: {
    am: "преди обяд",
    pm: "след обяд",
    midnight: "в полунощ",
    noon: "на обяд",
    morning: "сутринта",
    afternoon: "следобед",
    evening: "вечерта",
    night: "през нощта",
  },
};

function isFeminine(unit) {
  return (
    unit === "year" || unit === "week" || unit === "minute" || unit === "second"
  );
}

function isNeuter(unit) {
  return unit === "quarter";
}

function numberWithSuffix(number, unit, masculine, feminine, neuter) {
  const suffix = isNeuter(unit)
    ? neuter
    : isFeminine(unit)
      ? feminine
      : masculine;
  return number + "-" + suffix;
}

const ordinalNumber$19 = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = options?.unit;

  if (number === 0) {
    return numberWithSuffix(0, unit, "ев", "ева", "ево");
  } else if (number % 1000 === 0) {
    return numberWithSuffix(number, unit, "ен", "на", "но");
  } else if (number % 100 === 0) {
    return numberWithSuffix(number, unit, "тен", "тна", "тно");
  }

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return numberWithSuffix(number, unit, "ви", "ва", "во");
      case 2:
        return numberWithSuffix(number, unit, "ри", "ра", "ро");
      case 7:
      case 8:
        return numberWithSuffix(number, unit, "ми", "ма", "мо");
    }
  }

  return numberWithSuffix(number, unit, "ти", "та", "то");
};

(localize$19.localize = {
  ordinalNumber: ordinalNumber$19,

  era: (0, _index$52.buildLocalizeFn)({
    values: eraValues$19,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$52.buildLocalizeFn)({
    values: quarterValues$19,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$52.buildLocalizeFn)({
    values: monthValues$19,
    defaultWidth: "wide",
  }),

  day: (0, _index$52.buildLocalizeFn)({
    values: dayValues$19,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$52.buildLocalizeFn)({
    values: dayPeriodValues$19,
    defaultWidth: "wide",
  }),
});

var match$18 = {};

match$18.match = void 0;

var _index$51 = buildMatchFn$1;
var _index2$2t = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$18 =
  /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
const parseOrdinalNumberPattern$18 = /\d+/i;

const matchEraPatterns$18 = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(преди новата ера|новата ера|нова ера)/i,
};
const parseEraPatterns$18 = {
  any: [/^п/i, /^н/i],
};

const matchQuarterPatterns$18 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
  wide: /^[1234](-?[врт]?о?)? тримесечие/i,
};
const parseQuarterPatterns$18 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchDayPatterns$18 = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i,
};

const parseDayPatterns$18 = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i],
};

const matchMonthPatterns$18 = {
  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i,
};

const parseMonthPatterns$18 = {
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^май/i,
    /^юн/i,
    /^юл/i,
    /^ав/i,
    /^се/i,
    /^окт/i,
    /^но/i,
    /^де/i,
  ],
};

const matchDayPeriodPatterns$18 = {
  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i,
};
const parseDayPeriodPatterns$18 = {
  any: {
    am: /^преди о/i,
    pm: /^след о/i,
    midnight: /^в пол/i,
    noon: /^на об/i,
    morning: /^сут/i,
    afternoon: /^следо/i,
    evening: /^веч/i,
    night: /^през н/i,
  },
};

(match$18.match = {
  ordinalNumber: (0, _index2$2t.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$18,
    parsePattern: parseOrdinalNumberPattern$18,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$51.buildMatchFn)({
    matchPatterns: matchEraPatterns$18,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$18,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$51.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$18,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$18,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$51.buildMatchFn)({
    matchPatterns: matchMonthPatterns$18,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$18,
    defaultParseWidth: "any",
  }),

  day: (0, _index$51.buildMatchFn)({
    matchPatterns: matchDayPatterns$18,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$18,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$51.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$18,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$18,
    defaultParseWidth: "any",
  }),
});

bg.bg = void 0;
var _index$50 = formatDistance$2j;
var _index2$2s = formatLong$1h;
var _index3$1k = formatRelative$2j;
var _index4$1j = localize$19;
var _index5$1j = match$18;

/**
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus](https://github.com/arvigeus)
 * @author Tsvetan Ovedenski [@fintara](https://github.com/fintara)
 */
(bg.bg = {
  code: "bg",
  formatDistance: _index$50.formatDistance,
  formatLong: _index2$2s.formatLong,
  formatRelative: _index3$1k.formatRelative,
  localize: _index4$1j.localize,
  match: _index5$1j.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var bn = {};

var formatDistance$2h = {};

var localize$18 = {};

localize$18.localize = void 0;
localize$18.numberToLocale = numberToLocale$1;
var _index$4$ = buildLocalizeFn$1;

const numberValues$1 = {
  locale: {
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯",
    0: "০",
  },
  number: {
    "১": "1",
    "২": "2",
    "৩": "3",
    "৪": "4",
    "৫": "5",
    "৬": "6",
    "৭": "7",
    "৮": "8",
    "৯": "9",
    "০": "0",
  },
};

const eraValues$18 = {
  narrow: ["খ্রিঃপূঃ", "খ্রিঃ"],
  abbreviated: ["খ্রিঃপূর্ব", "খ্রিঃ"],
  wide: ["খ্রিস্টপূর্ব", "খ্রিস্টাব্দ"],
};

const quarterValues$18 = {
  narrow: ["১", "২", "৩", "৪"],
  abbreviated: ["১ত্রৈ", "২ত্রৈ", "৩ত্রৈ", "৪ত্রৈ"],
  wide: ["১ম ত্রৈমাসিক", "২য় ত্রৈমাসিক", "৩য় ত্রৈমাসিক", "৪র্থ ত্রৈমাসিক"],
};

const monthValues$18 = {
  narrow: [
    "জানু",
    "ফেব্রু",
    "মার্চ",
    "এপ্রিল",
    "মে",
    "জুন",
    "জুলাই",
    "আগস্ট",
    "সেপ্ট",
    "অক্টো",
    "নভে",
    "ডিসে",
  ],

  abbreviated: [
    "জানু",
    "ফেব্রু",
    "মার্চ",
    "এপ্রিল",
    "মে",
    "জুন",
    "জুলাই",
    "আগস্ট",
    "সেপ্ট",
    "অক্টো",
    "নভে",
    "ডিসে",
  ],

  wide: [
    "জানুয়ারি",
    "ফেব্রুয়ারি",
    "মার্চ",
    "এপ্রিল",
    "মে",
    "জুন",
    "জুলাই",
    "আগস্ট",
    "সেপ্টেম্বর",
    "অক্টোবর",
    "নভেম্বর",
    "ডিসেম্বর",
  ],
};

const dayValues$18 = {
  narrow: ["র", "সো", "ম", "বু", "বৃ", "শু", "শ"],
  short: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  abbreviated: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  wide: [
    "রবিবার",
    "সোমবার",
    "মঙ্গলবার",
    "বুধবার",
    "বৃহস্পতিবার ",
    "শুক্রবার",
    "শনিবার",
  ],
};

const dayPeriodValues$18 = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত",
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত",
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত",
  },
};

const formattingDayPeriodValues$V = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত",
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত",
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত",
  },
};

function dateOrdinalNumber(number, localeNumber) {
  if (number > 18 && number <= 31) {
    return localeNumber + "শে";
  } else {
    switch (number) {
      case 1:
        return localeNumber + "লা";
      case 2:
      case 3:
        return localeNumber + "রা";
      case 4:
        return localeNumber + "ঠা";
      default:
        return localeNumber + "ই";
    }
  }
}

const ordinalNumber$18 = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const localeNumber = numberToLocale$1(number);
  const unit = options?.unit;

  if (unit === "date") {
    return dateOrdinalNumber(number, localeNumber);
  }
  if (number > 10 || number === 0) return localeNumber + "তম";

  const rem10 = number % 10;
  switch (rem10) {
    case 2:
    case 3:
      return localeNumber + "য়";
    case 4:
      return localeNumber + "র্থ";
    case 6:
      return localeNumber + "ষ্ঠ";
    default:
      return localeNumber + "ম";
  }
};

// function localeToNumber(locale: string): number {
//   const enNumber = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
//     return numberValues.number[match as keyof typeof numberValues.number]
//   })
//   return Number(enNumber)
// }

function numberToLocale$1(enNumber) {
  return enNumber.toString().replace(/\d/g, function (match) {
    return numberValues$1.locale[match];
  });
}

(localize$18.localize = {
  ordinalNumber: ordinalNumber$18,

  era: (0, _index$4$.buildLocalizeFn)({
    values: eraValues$18,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4$.buildLocalizeFn)({
    values: quarterValues$18,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4$.buildLocalizeFn)({
    values: monthValues$18,
    defaultWidth: "wide",
  }),

  day: (0, _index$4$.buildLocalizeFn)({
    values: dayValues$18,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4$.buildLocalizeFn)({
    values: dayPeriodValues$18,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$V,
    defaultFormattingWidth: "wide",
  }),
});

formatDistance$2h.formatDistance = void 0;
var _index$4_ = localize$18;

const formatDistanceLocale$17 = {
  lessThanXSeconds: {
    one: "প্রায় ১ সেকেন্ড",
    other: "প্রায় {{count}} সেকেন্ড",
  },

  xSeconds: {
    one: "১ সেকেন্ড",
    other: "{{count}} সেকেন্ড",
  },

  halfAMinute: "আধ মিনিট",

  lessThanXMinutes: {
    one: "প্রায় ১ মিনিট",
    other: "প্রায় {{count}} মিনিট",
  },

  xMinutes: {
    one: "১ মিনিট",
    other: "{{count}} মিনিট",
  },

  aboutXHours: {
    one: "প্রায় ১ ঘন্টা",
    other: "প্রায় {{count}} ঘন্টা",
  },

  xHours: {
    one: "১ ঘন্টা",
    other: "{{count}} ঘন্টা",
  },

  xDays: {
    one: "১ দিন",
    other: "{{count}} দিন",
  },

  aboutXWeeks: {
    one: "প্রায় ১ সপ্তাহ",
    other: "প্রায় {{count}} সপ্তাহ",
  },

  xWeeks: {
    one: "১ সপ্তাহ",
    other: "{{count}} সপ্তাহ",
  },

  aboutXMonths: {
    one: "প্রায় ১ মাস",
    other: "প্রায় {{count}} মাস",
  },

  xMonths: {
    one: "১ মাস",
    other: "{{count}} মাস",
  },

  aboutXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর",
  },

  xYears: {
    one: "১ বছর",
    other: "{{count}} বছর",
  },

  overXYears: {
    one: "১ বছরের বেশি",
    other: "{{count}} বছরের বেশি",
  },

  almostXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর",
  },
};

const formatDistance$2g = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$17[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace(
      "{{count}}",
      (0, _index$4_.numberToLocale)(count),
    );
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " এর মধ্যে";
    } else {
      return result + " আগে";
    }
  }

  return result;
};
formatDistance$2h.formatDistance = formatDistance$2g;

var formatLong$1g = {};

formatLong$1g.formatLong = void 0;
var _index$4Z = buildFormatLongFn$1;

const dateFormats$1g = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$1g = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1g = {
  full: "{{date}} {{time}} 'সময়'",
  long: "{{date}} {{time}} 'সময়'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1g.formatLong = {
  date: (0, _index$4Z.buildFormatLongFn)({
    formats: dateFormats$1g,
    defaultWidth: "full",
  }),

  time: (0, _index$4Z.buildFormatLongFn)({
    formats: timeFormats$1g,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4Z.buildFormatLongFn)({
    formats: dateTimeFormats$1g,
    defaultWidth: "full",
  }),
});

var formatRelative$2h = {};

formatRelative$2h.formatRelative = void 0;

const formatRelativeLocale$18 = {
  lastWeek: "'গত' eeee 'সময়' p",
  yesterday: "'গতকাল' 'সময়' p",
  today: "'আজ' 'সময়' p",
  tomorrow: "'আগামীকাল' 'সময়' p",
  nextWeek: "eeee 'সময়' p",
  other: "P",
};

const formatRelative$2g = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$18[token];
formatRelative$2h.formatRelative = formatRelative$2g;

var match$17 = {};

match$17.match = void 0;

var _index$4Y = buildMatchFn$1;
var _index2$2r = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$17 = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
const parseOrdinalNumberPattern$17 = /\d+/i;

const matchEraPatterns$17 = {
  narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
  abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
  wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i,
};
const parseEraPatterns$17 = {
  narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
  abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
  wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i],
};

const matchQuarterPatterns$17 = {
  narrow: /^[১২৩৪]/i,
  abbreviated: /^[১২৩৪]ত্রৈ/i,
  wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i,
};
const parseQuarterPatterns$17 = {
  any: [/১/i, /২/i, /৩/i, /৪/i],
};

const matchMonthPatterns$17 = {
  narrow:
    /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  abbreviated:
    /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i,
};
const parseMonthPatterns$17 = {
  any: [
    /^জানু/i,
    /^ফেব্রু/i,
    /^মার্চ/i,
    /^এপ্রিল/i,
    /^মে/i,
    /^জুন/i,
    /^জুলাই/i,
    /^আগস্ট/i,
    /^সেপ্ট/i,
    /^অক্টো/i,
    /^নভে/i,
    /^ডিসে/i,
  ],
};

const matchDayPatterns$17 = {
  narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
  short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i,
};
const parseDayPatterns$17 = {
  narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
  short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],

  abbreviated: [
    /^রবি/i,
    /^সোম/i,
    /^মঙ্গল/i,
    /^বুধ/i,
    /^বৃহ/i,
    /^শুক্র/i,
    /^শনি/i,
  ],

  wide: [
    /^রবিবার/i,
    /^সোমবার/i,
    /^মঙ্গলবার/i,
    /^বুধবার/i,
    /^বৃহস্পতিবার /i,
    /^শুক্রবার/i,
    /^শনিবার/i,
  ],
};

const matchDayPeriodPatterns$17 = {
  narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
};
const parseDayPeriodPatterns$17 = {
  any: {
    am: /^পূ/i,
    pm: /^অপ/i,
    midnight: /^মধ্যরাত/i,
    noon: /^মধ্যাহ্ন/i,
    morning: /সকাল/i,
    afternoon: /বিকাল/i,
    evening: /সন্ধ্যা/i,
    night: /রাত/i,
  },
};

(match$17.match = {
  ordinalNumber: (0, _index2$2r.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$17,
    parsePattern: parseOrdinalNumberPattern$17,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$4Y.buildMatchFn)({
    matchPatterns: matchEraPatterns$17,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$17,
    defaultParseWidth: "wide",
  }),

  quarter: (0, _index$4Y.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$17,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$17,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$4Y.buildMatchFn)({
    matchPatterns: matchMonthPatterns$17,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$17,
    defaultParseWidth: "any",
  }),

  day: (0, _index$4Y.buildMatchFn)({
    matchPatterns: matchDayPatterns$17,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$17,
    defaultParseWidth: "wide",
  }),

  dayPeriod: (0, _index$4Y.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$17,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$17,
    defaultParseWidth: "any",
  }),
});

bn.bn = void 0;
var _index$4X = formatDistance$2h;
var _index2$2q = formatLong$1g;
var _index3$1j = formatRelative$2h;
var _index4$1i = localize$18;
var _index5$1i = match$17;

/**
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman](https://github.com/touhidrahman)
 * @author Farhad Yasir [@nutboltu](https://github.com/nutboltu)
 */
(bn.bn = {
  code: "bn",
  formatDistance: _index$4X.formatDistance,
  formatLong: _index2$2q.formatLong,
  formatRelative: _index3$1j.formatRelative,
  localize: _index4$1i.localize,
  match: _index5$1i.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var bs = {};

var formatDistance$2f = {};

formatDistance$2f.formatDistance = void 0;

const formatDistanceLocale$16 = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu",
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi",
  },

  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu",
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi",
  },

  halfAMinute: "pola minute",

  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu",
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta",
  },

  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu",
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta",
  },

  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat",
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati",
  },

  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat",
    },
    dual: "{{count}} sata",
    other: "{{count}} sati",
  },

  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan",
    },
    dual: "{{count}} dana",
    other: "{{count}} dana",
  },

  aboutXWeeks: {
    one: {
      standalone: "oko 1 sedmicu",
      withPrepositionAgo: "oko 1 sedmicu",
      withPrepositionIn: "oko 1 sedmicu",
    },
    dual: "oko {{count}} sedmice",
    other: "oko {{count}} sedmice",
  },

  xWeeks: {
    one: {
      standalone: "1 sedmicu",
      withPrepositionAgo: "1 sedmicu",
      withPrepositionIn: "1 sedmicu",
    },
    dual: "{{count}} sedmice",
    other: "{{count}} sedmice",
  },

  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec",
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci",
  },

  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec",
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci",
  },

  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu",
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina",
  },

  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu",
    },
    dual: "{{count}} godine",
    other: "{{count}} godina",
  },

  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu",
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina",
  },

  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu",
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina",
  },
};

const formatDistance$2e = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$16[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    if (options?.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        result = tokenValue.one.withPrepositionIn;
      } else {
        result = tokenValue.one.withPrepositionAgo;
      }
    } else {
      result = tokenValue.one.standalone;
    }
  } else if (
    count % 10 > 1 &&
    count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
  ) {
    result = tokenValue.dual.replace("{{count}}", String(count));
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "za " + result;
    } else {
      return "prije " + result;
    }
  }

  return result;
};
formatDistance$2f.formatDistance = formatDistance$2e;

var formatLong$1f = {};

formatLong$1f.formatLong = void 0;
var _index$4W = buildFormatLongFn$1;

const dateFormats$1f = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy.",
};

const timeFormats$1f = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$1f = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$1f.formatLong = {
  date: (0, _index$4W.buildFormatLongFn)({
    formats: dateFormats$1f,
    defaultWidth: "full",
  }),

  time: (0, _index$4W.buildFormatLongFn)({
    formats: timeFormats$1f,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4W.buildFormatLongFn)({
    formats: dateTimeFormats$1f,
    defaultWidth: "full",
  }),
});

var formatRelative$2f = {};

formatRelative$2f.formatRelative = void 0;

const formatRelativeLocale$17 = {
  lastWeek: (date) => {
    switch (date.getDay()) {
      case 0:
        return "'prošle nedjelje u' p";
      case 3:
        return "'prošle srijede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (date) => {
    switch (date.getDay()) {
      case 0:
        return "'sljedeće nedjelje u' p";
      case 3:
        return "'sljedeću srijedu u' p";
      case 6:
        return "'sljedeću subotu u' p";
      default:
        return "'sljedeći' EEEE 'u' p";
    }
  },
  other: "P",
};

const formatRelative$2e = (token, date, _baseDate, _options) => {
  const format = formatRelativeLocale$17[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$2f.formatRelative = formatRelative$2e;

var localize$17 = {};

localize$17.localize = void 0;
var _index$4V = buildLocalizeFn$1;

const eraValues$17 = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Prije Hrista", "Poslije Hrista"],
};

const quarterValues$17 = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"],
};

const monthValues$17 = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12.",
  ],

  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec",
  ],

  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "juni",
    "juli",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar",
  ],
};

const formattingMonthValues$g = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12.",
  ],

  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec",
  ],

  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "juni",
    "juli",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar",
  ],
};

const dayValues$17 = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: [
    "nedjelja",
    "ponedjeljak",
    "utorak",
    "srijeda",
    "četvrtak",
    "petak",
    "subota",
  ],
};

const dayPeriodValues$17 = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću",
  },
};

const formattingDayPeriodValues$U = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću",
  },
};

const ordinalNumber$17 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return String(number) + ".";
};

(localize$17.localize = {
  ordinalNumber: ordinalNumber$17,

  era: (0, _index$4V.buildLocalizeFn)({
    values: eraValues$17,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4V.buildLocalizeFn)({
    values: quarterValues$17,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4V.buildLocalizeFn)({
    values: monthValues$17,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$g,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$4V.buildLocalizeFn)({
    values: dayValues$17,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4V.buildLocalizeFn)({
    values: dayPeriodValues$17,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$U,
    defaultFormattingWidth: "wide",
  }),
});

var match$16 = {};

match$16.match = void 0;

var _index$4U = buildMatchFn$1;
var _index2$2p = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$16 = /^(\d+)\./i;
const parseOrdinalNumberPattern$16 = /\d+/i;

const matchEraPatterns$16 = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i,
};
const parseEraPatterns$16 = {
  any: [/^pr/i, /^(po|nova)/i],
};

const matchQuarterPatterns$16 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i,
};
const parseQuarterPatterns$16 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$16 = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i,
};
const parseMonthPatterns$16 = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^avg/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$16 = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i,
};
const parseDayPatterns$16 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns$16 = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i,
};
const parseDayPeriodPatterns$16 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i,
  },
};

(match$16.match = {
  ordinalNumber: (0, _index2$2p.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$16,
    parsePattern: parseOrdinalNumberPattern$16,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$4U.buildMatchFn)({
    matchPatterns: matchEraPatterns$16,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$16,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$4U.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$16,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$16,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$4U.buildMatchFn)({
    matchPatterns: matchMonthPatterns$16,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$16,
    defaultParseWidth: "any",
  }),

  day: (0, _index$4U.buildMatchFn)({
    matchPatterns: matchDayPatterns$16,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$16,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$4U.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$16,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$16,
    defaultParseWidth: "any",
  }),
});

bs.bs = void 0;
var _index$4T = formatDistance$2f;
var _index2$2o = formatLong$1f;
var _index3$1i = formatRelative$2f;
var _index4$1h = localize$17;
var _index5$1h = match$16;

/**
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic](https://github.com/branislavlazic)
 */
(bs.bs = {
  code: "bs",
  formatDistance: _index$4T.formatDistance,
  formatLong: _index2$2o.formatLong,
  formatRelative: _index3$1i.formatRelative,
  localize: _index4$1h.localize,
  match: _index5$1h.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var ca = {};

var formatDistance$2d = {};

formatDistance$2d.formatDistance = void 0;

/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */

const formatDistanceLocale$15 = {
  lessThanXSeconds: {
    one: "menys d'un segon",
    eleven: "menys d'onze segons",
    other: "menys de {{count}} segons",
  },

  xSeconds: {
    one: "1 segon",
    other: "{{count}} segons",
  },

  halfAMinute: "mig minut",

  lessThanXMinutes: {
    one: "menys d'un minut",
    eleven: "menys d'onze minuts",
    other: "menys de {{count}} minuts",
  },

  xMinutes: {
    one: "1 minut",
    other: "{{count}} minuts",
  },

  aboutXHours: {
    one: "aproximadament una hora",
    other: "aproximadament {{count}} hores",
  },

  xHours: {
    one: "1 hora",
    other: "{{count}} hores",
  },

  xDays: {
    one: "1 dia",
    other: "{{count}} dies",
  },

  aboutXWeeks: {
    one: "aproximadament una setmana",
    other: "aproximadament {{count}} setmanes",
  },

  xWeeks: {
    one: "1 setmana",
    other: "{{count}} setmanes",
  },

  aboutXMonths: {
    one: "aproximadament un mes",
    other: "aproximadament {{count}} mesos",
  },

  xMonths: {
    one: "1 mes",
    other: "{{count}} mesos",
  },

  aboutXYears: {
    one: "aproximadament un any",
    other: "aproximadament {{count}} anys",
  },

  xYears: {
    one: "1 any",
    other: "{{count}} anys",
  },

  overXYears: {
    one: "més d'un any",
    eleven: "més d'onze anys",
    other: "més de {{count}} anys",
  },

  almostXYears: {
    one: "gairebé un any",
    other: "gairebé {{count}} anys",
  },
};

const formatDistance$2c = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$15[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else if (count === 11 && tokenValue.eleven) {
    result = tokenValue.eleven;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "en " + result;
    } else {
      return "fa " + result;
    }
  }

  return result;
};
formatDistance$2d.formatDistance = formatDistance$2c;

var formatLong$1e = {};

formatLong$1e.formatLong = void 0;
var _index$4S = buildFormatLongFn$1;

const dateFormats$1e = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats$1e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$1e = {
  full: "{{date}} 'a les' {{time}}",
  long: "{{date}} 'a les' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1e.formatLong = {
  date: (0, _index$4S.buildFormatLongFn)({
    formats: dateFormats$1e,
    defaultWidth: "full",
  }),

  time: (0, _index$4S.buildFormatLongFn)({
    formats: timeFormats$1e,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4S.buildFormatLongFn)({
    formats: dateTimeFormats$1e,
    defaultWidth: "full",
  }),
});

var formatRelative$2d = {};

formatRelative$2d.formatRelative = void 0;

const formatRelativeLocale$16 = {
  lastWeek: "'el' eeee 'passat a la' LT",
  yesterday: "'ahir a la' p",
  today: "'avui a la' p",
  tomorrow: "'demà a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P",
};

const formatRelativeLocalePlural$3 = {
  lastWeek: "'el' eeee 'passat a les' p",
  yesterday: "'ahir a les' p",
  today: "'avui a les' p",
  tomorrow: "'demà a les' p",
  nextWeek: "eeee 'a les' p",
  other: "P",
};

const formatRelative$2c = (token, date, _baseDate, _options) => {
  if (date.getHours() !== 1) {
    return formatRelativeLocalePlural$3[token];
  }
  return formatRelativeLocale$16[token];
};
formatRelative$2d.formatRelative = formatRelative$2c;

var localize$16 = {};

localize$16.localize = void 0;
var _index$4R = buildLocalizeFn$1;

/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */

/**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */
const eraValues$16 = {
  narrow: ["aC", "dC"],
  abbreviated: ["a. de C.", "d. de C."],
  wide: ["abans de Crist", "després de Crist"],
};

const quarterValues$16 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1r trimestre", "2n trimestre", "3r trimestre", "4t trimestre"],
};

/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */
const monthValues$16 = {
  narrow: [
    "GN",
    "FB",
    "MÇ",
    "AB",
    "MG",
    "JN",
    "JL",
    "AG",
    "ST",
    "OC",
    "NV",
    "DS",
  ],

  /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */
  abbreviated: [
    "gen.",
    "febr.",
    "març",
    "abr.",
    "maig",
    "juny",
    "jul.",
    "ag.",
    "set.",
    "oct.",
    "nov.",
    "des.",
  ],

  wide: [
    "gener",
    "febrer",
    "març",
    "abril",
    "maig",
    "juny",
    "juliol",
    "agost",
    "setembre",
    "octubre",
    "novembre",
    "desembre",
  ],
};

/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */
const dayValues$16 = {
  narrow: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  short: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  abbreviated: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  wide: [
    "diumenge",
    "dilluns",
    "dimarts",
    "dimecres",
    "dijous",
    "divendres",
    "dissabte",
  ],
};

/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */
const dayPeriodValues$16 = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit",
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit",
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit",
  },
};

const formattingDayPeriodValues$T = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit",
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit",
  },
};

/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */
const ordinalNumber$16 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "r";
      case 2:
        return number + "n";
      case 3:
        return number + "r";
      case 4:
        return number + "t";
    }
  }
  return number + "è";
};

(localize$16.localize = {
  ordinalNumber: ordinalNumber$16,

  era: (0, _index$4R.buildLocalizeFn)({
    values: eraValues$16,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4R.buildLocalizeFn)({
    values: quarterValues$16,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4R.buildLocalizeFn)({
    values: monthValues$16,
    defaultWidth: "wide",
  }),

  day: (0, _index$4R.buildLocalizeFn)({
    values: dayValues$16,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4R.buildLocalizeFn)({
    values: dayPeriodValues$16,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$T,
    defaultFormattingWidth: "wide",
  }),
});

var match$15 = {};

match$15.match = void 0;

var _index$4Q = buildMatchFn$1;
var _index2$2n = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$15 = /^(\d+)(è|r|n|r|t)?/i;
const parseOrdinalNumberPattern$15 = /\d+/i;

const matchEraPatterns$15 = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a. de C.|d. de C.)/i,
  wide: /^(abans de Crist|despr[eé]s de Crist)/i,
};
const parseEraPatterns$15 = {
  narrow: [/^aC/i, /^dC/i],
  abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
  wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i],
};

const matchQuarterPatterns$15 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](è|r|n|r|t)? trimestre/i,
};
const parseQuarterPatterns$15 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$15 = {
  narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
  abbreviated:
    /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
  wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i,
};
const parseMonthPatterns$15 = {
  narrow: [
    /^GN/i,
    /^FB/i,
    /^MÇ/i,
    /^AB/i,
    /^MG/i,
    /^JN/i,
    /^JL/i,
    /^AG/i,
    /^ST/i,
    /^OC/i,
    /^NV/i,
    /^DS/i,
  ],

  abbreviated: [
    /^gen./i,
    /^febr./i,
    /^març/i,
    /^abr./i,
    /^maig/i,
    /^juny/i,
    /^jul./i,
    /^ag./i,
    /^set./i,
    /^oct./i,
    /^nov./i,
    /^des./i,
  ],

  wide: [
    /^gener/i,
    /^febrer/i,
    /^març/i,
    /^abril/i,
    /^maig/i,
    /^juny/i,
    /^juliol/i,
    /^agost/i,
    /^setembre/i,
    /^octubre/i,
    /^novembre/i,
    /^desembre/i,
  ],
};

const matchDayPatterns$15 = {
  narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i,
};
const parseDayPatterns$15 = {
  narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],

  abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],

  wide: [
    /^diumenge/i,
    /^dilluns/i,
    /^dimarts/i,
    /^dimecres/i,
    /^dijous/i,
    /^divendres/i,
    /^disssabte/i,
  ],
};

const matchDayPeriodPatterns$15 = {
  narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
  abbreviated:
    /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
  wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
};
const parseDayPeriodPatterns$15 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mitjanit/i,
    noon: /^migdia/i,
    morning: /matí/i,
    afternoon: /tarda/i,
    evening: /vespre/i,
    night: /nit/i,
  },
};

(match$15.match = {
  ordinalNumber: (0, _index2$2n.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$15,
    parsePattern: parseOrdinalNumberPattern$15,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$4Q.buildMatchFn)({
    matchPatterns: matchEraPatterns$15,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$15,
    defaultParseWidth: "wide",
  }),

  quarter: (0, _index$4Q.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$15,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$15,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$4Q.buildMatchFn)({
    matchPatterns: matchMonthPatterns$15,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$15,
    defaultParseWidth: "wide",
  }),

  day: (0, _index$4Q.buildMatchFn)({
    matchPatterns: matchDayPatterns$15,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$15,
    defaultParseWidth: "wide",
  }),

  dayPeriod: (0, _index$4Q.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$15,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$15,
    defaultParseWidth: "any",
  }),
});

ca.ca = void 0;
var _index$4P = formatDistance$2d;
var _index2$2m = formatLong$1e;
var _index3$1h = formatRelative$2d;
var _index4$1g = localize$16;
var _index5$1g = match$15;

/**
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
 * @author Alex Vizcaino [@avizcaino](https://github.com/avizcaino)
 */
(ca.ca = {
  code: "ca",
  formatDistance: _index$4P.formatDistance,
  formatLong: _index2$2m.formatLong,
  formatRelative: _index3$1h.formatRelative,
  localize: _index4$1g.localize,
  match: _index5$1g.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var ckb = {};

var formatDistance$2b = {};

formatDistance$2b.formatDistance = void 0;

const formatDistanceLocale$14 = {
  lessThanXSeconds: {
    one: "کەمتر لە یەک چرکە",
    other: "کەمتر لە {{count}} چرکە",
  },

  xSeconds: {
    one: "1 چرکە",
    other: "{{count}} چرکە",
  },

  halfAMinute: "نیو کاتژمێر",

  lessThanXMinutes: {
    one: "کەمتر لە یەک خولەک",
    other: "کەمتر لە {{count}} خولەک",
  },

  xMinutes: {
    one: "1 خولەک",
    other: "{{count}} خولەک",
  },

  aboutXHours: {
    one: "دەوروبەری 1 کاتژمێر",
    other: "دەوروبەری {{count}} کاتژمێر",
  },

  xHours: {
    one: "1 کاتژمێر",
    other: "{{count}} کاتژمێر",
  },

  xDays: {
    one: "1 ڕۆژ",
    other: "{{count}} ژۆژ",
  },

  aboutXWeeks: {
    one: "دەوروبەری 1 هەفتە",
    other: "دوروبەری {{count}} هەفتە",
  },

  xWeeks: {
    one: "1 هەفتە",
    other: "{{count}} هەفتە",
  },

  aboutXMonths: {
    one: "داوروبەری 1 مانگ",
    other: "دەوروبەری {{count}} مانگ",
  },

  xMonths: {
    one: "1 مانگ",
    other: "{{count}} مانگ",
  },

  aboutXYears: {
    one: "دەوروبەری  1 ساڵ",
    other: "دەوروبەری {{count}} ساڵ",
  },

  xYears: {
    one: "1 ساڵ",
    other: "{{count}} ساڵ",
  },

  overXYears: {
    one: "زیاتر لە ساڵێک",
    other: "زیاتر لە {{count}} ساڵ",
  },

  almostXYears: {
    one: "بەنزیکەیی ساڵێک  ",
    other: "بەنزیکەیی {{count}} ساڵ",
  },
};

const formatDistance$2a = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$14[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "لە ماوەی " + result + "دا";
    } else {
      return result + "پێش ئێستا";
    }
  }

  return result;
};
formatDistance$2b.formatDistance = formatDistance$2a;

var formatLong$1d = {};

formatLong$1d.formatLong = void 0;
var _index$4O = buildFormatLongFn$1;

const dateFormats$1d = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$1d = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1d = {
  full: "{{date}} 'کاتژمێر' {{time}}",
  long: "{{date}} 'کاتژمێر' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1d.formatLong = {
  date: (0, _index$4O.buildFormatLongFn)({
    formats: dateFormats$1d,
    defaultWidth: "full",
  }),

  time: (0, _index$4O.buildFormatLongFn)({
    formats: timeFormats$1d,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4O.buildFormatLongFn)({
    formats: dateTimeFormats$1d,
    defaultWidth: "full",
  }),
});

var formatRelative$2b = {};

formatRelative$2b.formatRelative = void 0;

const formatRelativeLocale$15 = {
  lastWeek: "'هەفتەی ڕابردوو' eeee 'کاتژمێر' p",
  yesterday: "'دوێنێ کاتژمێر' p",
  today: "'ئەمڕۆ کاتژمێر' p",
  tomorrow: "'بەیانی کاتژمێر' p",
  nextWeek: "eeee 'کاتژمێر' p",
  other: "P",
};

const formatRelative$2a = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$15[token];
formatRelative$2b.formatRelative = formatRelative$2a;

var localize$15 = {};

localize$15.localize = void 0;

var _index$4N = buildLocalizeFn$1;

const eraValues$15 = {
  narrow: ["پ", "د"],
  abbreviated: ["پ-ز", "د-ز"],
  wide: ["پێش زاین", "دوای زاین"],
};

const quarterValues$15 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["چ1م", "چ2م", "چ3م", "چ4م"],
  wide: ["چارەگی یەکەم", "چارەگی دووەم", "چارەگی سێیەم", "چارەگی چوارەم"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$15 = {
  narrow: [
    "ک-د",
    "ش",
    "ئا",
    "ن",
    "م",
    "ح",
    "ت",
    "ئا",
    "ئە",
    "تش-ی",
    "تش-د",
    "ک-ی",
  ],

  abbreviated: [
    "کان-دوو",
    "شوب",
    "ئاد",
    "نیس",
    "مایس",
    "حوز",
    "تەم",
    "ئاب",
    "ئەل",
    "تش-یەک",
    "تش-دوو",
    "کان-یەک",
  ],

  wide: [
    "کانوونی دووەم",
    "شوبات",
    "ئادار",
    "نیسان",
    "مایس",
    "حوزەیران",
    "تەمموز",
    "ئاب",
    "ئەیلول",
    "تشرینی یەکەم",
    "تشرینی دووەم",
    "کانوونی یەکەم",
  ],
};

const dayValues$15 = {
  narrow: ["ی-ش", "د-ش", "س-ش", "چ-ش", "پ-ش", "هە", "ش"],
  short: ["یە-شە", "دوو-شە", "سێ-شە", "چو-شە", "پێ-شە", "هەی", "شە"],
  abbreviated: [
    "یەک-شەم",
    "دوو-شەم",
    "سێ-شەم",
    "چوار-شەم",
    "پێنج-شەم",
    "هەینی",
    "شەمە",
  ],

  wide: [
    "یەک شەمە",
    "دوو شەمە",
    "سێ شەمە",
    "چوار شەمە",
    "پێنج شەمە",
    "هەینی",
    "شەمە",
  ],
};

const dayPeriodValues$15 = {
  narrow: {
    am: "پ",
    pm: "د",
    midnight: "ن-ش",
    noon: "ن",
    morning: "بەیانی",
    afternoon: "دوای نیوەڕۆ",
    evening: "ئێوارە",
    night: "شەو",
  },
  abbreviated: {
    am: "پ-ن",
    pm: "د-ن",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "بەیانی",
    afternoon: "دوای نیوەڕۆ",
    evening: "ئێوارە",
    night: "شەو",
  },
  wide: {
    am: "پێش نیوەڕۆ",
    pm: "دوای نیوەڕۆ",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "بەیانی",
    afternoon: "دوای نیوەڕۆ",
    evening: "ئێوارە",
    night: "شەو",
  },
};

const formattingDayPeriodValues$S = {
  narrow: {
    am: "پ",
    pm: "د",
    midnight: "ن-ش",
    noon: "ن",
    morning: "لە بەیانیدا",
    afternoon: "لە دوای نیوەڕۆدا",
    evening: "لە ئێوارەدا",
    night: "لە شەودا",
  },
  abbreviated: {
    am: "پ-ن",
    pm: "د-ن",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "لە بەیانیدا",
    afternoon: "لە دوای نیوەڕۆدا",
    evening: "لە ئێوارەدا",
    night: "لە شەودا",
  },
  wide: {
    am: "پێش نیوەڕۆ",
    pm: "دوای نیوەڕۆ",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "لە بەیانیدا",
    afternoon: "لە دوای نیوەڕۆدا",
    evening: "لە ئێوارەدا",
    night: "لە شەودا",
  },
};

const ordinalNumber$15 = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$15.localize = {
  ordinalNumber: ordinalNumber$15,

  era: (0, _index$4N.buildLocalizeFn)({
    values: eraValues$15,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4N.buildLocalizeFn)({
    values: quarterValues$15,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4N.buildLocalizeFn)({
    values: monthValues$15,
    defaultWidth: "wide",
  }),

  day: (0, _index$4N.buildLocalizeFn)({
    values: dayValues$15,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4N.buildLocalizeFn)({
    values: dayPeriodValues$15,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$S,
    defaultFormattingWidth: "wide",
  }),
});

var match$14 = {};

match$14.match = void 0;

var _index$4M = buildMatchFn$1;
var _index2$2l = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$14 = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$14 = /\d+/i;

const matchEraPatterns$14 = {
  narrow: /^(پ|د)/i,
  abbreviated: /^(پ-ز|د.ز)/i,
  wide: /^(پێش زاین| دوای زاین)/i,
};
const parseEraPatterns$14 = {
  any: [/^د/g, /^پ/g],
};

const matchQuarterPatterns$14 = {
  narrow: /^[1234]/i,
  abbreviated: /^م[1234]چ/i,
  wide: /^(یەکەم|دووەم|سێیەم| چوارەم) (چارەگی)? quarter/i,
};
const parseQuarterPatterns$14 = {
  wide: [/چارەگی یەکەم/, /چارەگی دووەم/, /چارەگی سيیەم/, /چارەگی چوارەم/],

  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$14 = {
  narrow: /^(ک-د|ش|ئا|ن|م|ح|ت|ئە|تش-ی|تش-د|ک-ی)/i,
  abbreviated:
    /^(کان-دوو|شوب|ئاد|نیس|مایس|حوز|تەم|ئاب|ئەل|تش-یەک|تش-دوو|کان-یەک)/i,
  wide: /^(کانوونی دووەم|شوبات|ئادار|نیسان|مایس|حوزەیران|تەمموز|ئاب|ئەیلول|تشرینی یەکەم|تشرینی دووەم|کانوونی یەکەم)/i,
};
const parseMonthPatterns$14 = {
  narrow: [
    /^ک-د/i,
    /^ش/i,
    /^ئا/i,
    /^ن/i,
    /^م/i,
    /^ح/i,
    /^ت/i,
    /^ئا/i,
    /^ئە/i,
    /^تش-ی/i,
    /^تش-د/i,
    /^ک-ی/i,
  ],

  any: [
    /^کان-دوو/i,
    /^شوب/i,
    /^ئاد/i,
    /^نیس/i,
    /^مایس/i,
    /^حوز/i,
    /^تەم/i,
    /^ئاب/i,
    /^ئەل/i,
    /^تش-یەک/i,
    /^تش-دوو/i,
    /^|کان-یەک/i,
  ],
};

const matchDayPatterns$14 = {
  narrow: /^(ش|ی|د|س|چ|پ|هە)/i,
  short: /^(یە-شە|دوو-شە|سێ-شە|چو-شە|پێ-شە|هە|شە)/i,
  abbreviated: /^(یەک-شەم|دوو-شەم|سێ-شەم|چوار-شەم|پێنخ-شەم|هەینی|شەمە)/i,
  wide: /^(یەک شەمە|دوو شەمە|سێ شەمە|چوار شەمە|پێنج شەمە|هەینی|شەمە)/i,
};
const parseDayPatterns$14 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns$14 = {
  narrow: /^(پ|د|ن-ش|ن| (بەیانی|دوای نیوەڕۆ|ئێوارە|شەو))/i,
  abbreviated: /^(پ-ن|د-ن|نیوە شەو|نیوەڕۆ|بەیانی|دوای نیوەڕۆ|ئێوارە|شەو)/,
  wide: /^(پێش نیوەڕۆ|دوای نیوەڕۆ|نیوەڕۆ|نیوە شەو|لەبەیانیدا|لەدواینیوەڕۆدا|لە ئێوارەدا|لە شەودا)/,
  any: /^(پ|د|بەیانی|نیوەڕۆ|ئێوارە|شەو)/,
};
const parseDayPeriodPatterns$14 = {
  any: {
    am: /^د/i,
    pm: /^پ/i,
    midnight: /^ن-ش/i,
    noon: /^ن/i,
    morning: /بەیانی/i,
    afternoon: /دواینیوەڕۆ/i,
    evening: /ئێوارە/i,
    night: /شەو/i,
  },
};

(match$14.match = {
  ordinalNumber: (0, _index2$2l.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$14,
    parsePattern: parseOrdinalNumberPattern$14,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$4M.buildMatchFn)({
    matchPatterns: matchEraPatterns$14,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$14,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$4M.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$14,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$14,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$4M.buildMatchFn)({
    matchPatterns: matchMonthPatterns$14,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$14,
    defaultParseWidth: "any",
  }),

  day: (0, _index$4M.buildMatchFn)({
    matchPatterns: matchDayPatterns$14,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$14,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$4M.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$14,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$14,
    defaultParseWidth: "any",
  }),
});

ckb.ckb = void 0;
var _index$4L = formatDistance$2b;
var _index2$2k = formatLong$1d;
var _index3$1g = formatRelative$2b;
var _index4$1f = localize$15;
var _index5$1f = match$14;

/**
 * @type {Locale}
 * @category Locales
 * @summary Central Kurdish locale.
 * @language Central Kurdish
 * @iso-639-2 kur
 * @author Revan Sarbast [@Revan99]{@link https://github.com/Revan99}
 */
(ckb.ckb = {
  code: "ckb",
  formatDistance: _index$4L.formatDistance,
  formatLong: _index2$2k.formatLong,
  formatRelative: _index3$1g.formatRelative,
  localize: _index4$1f.localize,
  match: _index5$1f.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var cs = {};

var formatDistance$29 = {};

formatDistance$29.formatDistance = void 0;

const formatDistanceLocale$13 = {
  lessThanXSeconds: {
    one: {
      regular: "méně než 1 sekunda",
      past: "před méně než 1 sekundou",
      future: "za méně než 1 sekundu",
    },
    few: {
      regular: "méně než {{count}} sekundy",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekundy",
    },
    many: {
      regular: "méně než {{count}} sekund",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekund",
    },
  },

  xSeconds: {
    one: {
      regular: "1 sekunda",
      past: "před 1 sekundou",
      future: "za 1 sekundu",
    },
    few: {
      regular: "{{count}} sekundy",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekundy",
    },
    many: {
      regular: "{{count}} sekund",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekund",
    },
  },

  halfAMinute: {
    type: "other",
    other: {
      regular: "půl minuty",
      past: "před půl minutou",
      future: "za půl minuty",
    },
  },

  lessThanXMinutes: {
    one: {
      regular: "méně než 1 minuta",
      past: "před méně než 1 minutou",
      future: "za méně než 1 minutu",
    },
    few: {
      regular: "méně než {{count}} minuty",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minuty",
    },
    many: {
      regular: "méně než {{count}} minut",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minut",
    },
  },

  xMinutes: {
    one: {
      regular: "1 minuta",
      past: "před 1 minutou",
      future: "za 1 minutu",
    },
    few: {
      regular: "{{count}} minuty",
      past: "před {{count}} minutami",
      future: "za {{count}} minuty",
    },
    many: {
      regular: "{{count}} minut",
      past: "před {{count}} minutami",
      future: "za {{count}} minut",
    },
  },

  aboutXHours: {
    one: {
      regular: "přibližně 1 hodina",
      past: "přibližně před 1 hodinou",
      future: "přibližně za 1 hodinu",
    },
    few: {
      regular: "přibližně {{count}} hodiny",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodiny",
    },
    many: {
      regular: "přibližně {{count}} hodin",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodin",
    },
  },

  xHours: {
    one: {
      regular: "1 hodina",
      past: "před 1 hodinou",
      future: "za 1 hodinu",
    },
    few: {
      regular: "{{count}} hodiny",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodiny",
    },
    many: {
      regular: "{{count}} hodin",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodin",
    },
  },

  xDays: {
    one: {
      regular: "1 den",
      past: "před 1 dnem",
      future: "za 1 den",
    },
    few: {
      regular: "{{count}} dny",
      past: "před {{count}} dny",
      future: "za {{count}} dny",
    },
    many: {
      regular: "{{count}} dní",
      past: "před {{count}} dny",
      future: "za {{count}} dní",
    },
  },

  aboutXWeeks: {
    one: {
      regular: "přibližně 1 týden",
      past: "přibližně před 1 týdnem",
      future: "přibližně za 1 týden",
    },

    few: {
      regular: "přibližně {{count}} týdny",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdny",
    },

    many: {
      regular: "přibližně {{count}} týdnů",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdnů",
    },
  },

  xWeeks: {
    one: {
      regular: "1 týden",
      past: "před 1 týdnem",
      future: "za 1 týden",
    },

    few: {
      regular: "{{count}} týdny",
      past: "před {{count}} týdny",
      future: "za {{count}} týdny",
    },

    many: {
      regular: "{{count}} týdnů",
      past: "před {{count}} týdny",
      future: "za {{count}} týdnů",
    },
  },

  aboutXMonths: {
    one: {
      regular: "přibližně 1 měsíc",
      past: "přibližně před 1 měsícem",
      future: "přibližně za 1 měsíc",
    },

    few: {
      regular: "přibližně {{count}} měsíce",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíce",
    },

    many: {
      regular: "přibližně {{count}} měsíců",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíců",
    },
  },

  xMonths: {
    one: {
      regular: "1 měsíc",
      past: "před 1 měsícem",
      future: "za 1 měsíc",
    },

    few: {
      regular: "{{count}} měsíce",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíce",
    },

    many: {
      regular: "{{count}} měsíců",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíců",
    },
  },

  aboutXYears: {
    one: {
      regular: "přibližně 1 rok",
      past: "přibližně před 1 rokem",
      future: "přibližně za 1 rok",
    },
    few: {
      regular: "přibližně {{count}} roky",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roky",
    },
    many: {
      regular: "přibližně {{count}} roků",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roků",
    },
  },

  xYears: {
    one: {
      regular: "1 rok",
      past: "před 1 rokem",
      future: "za 1 rok",
    },
    few: {
      regular: "{{count}} roky",
      past: "před {{count}} roky",
      future: "za {{count}} roky",
    },
    many: {
      regular: "{{count}} roků",
      past: "před {{count}} roky",
      future: "za {{count}} roků",
    },
  },

  overXYears: {
    one: {
      regular: "více než 1 rok",
      past: "před více než 1 rokem",
      future: "za více než 1 rok",
    },
    few: {
      regular: "více než {{count}} roky",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roky",
    },
    many: {
      regular: "více než {{count}} roků",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roků",
    },
  },

  almostXYears: {
    one: {
      regular: "skoro 1 rok",
      past: "skoro před 1 rokem",
      future: "skoro za 1 rok",
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roky",
    },
    many: {
      regular: "skoro {{count}} roků",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roků",
    },
  },
};

const formatDistance$28 = (token, count, options) => {
  let pluralResult;

  const tokenValue = formatDistanceLocale$13[token];

  // cs pluralization
  if (tokenValue.type === "other") {
    pluralResult = tokenValue.other;
  } else if (count === 1) {
    pluralResult = tokenValue.one;
  } else if (count > 1 && count < 5) {
    pluralResult = tokenValue.few;
  } else {
    pluralResult = tokenValue.many;
  }

  // times
  const suffixExist = options?.addSuffix === true;
  const comparison = options?.comparison;

  let timeResult;
  if (suffixExist && comparison === -1) {
    timeResult = pluralResult.past;
  } else if (suffixExist && comparison === 1) {
    timeResult = pluralResult.future;
  } else {
    timeResult = pluralResult.regular;
  }

  return timeResult.replace("{{count}}", String(count));
};
formatDistance$29.formatDistance = formatDistance$28;

var formatLong$1c = {};

formatLong$1c.formatLong = void 0;
var _index$4K = buildFormatLongFn$1;

const dateFormats$1c = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy",
};

const timeFormats$1c = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$1c = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1c.formatLong = {
  date: (0, _index$4K.buildFormatLongFn)({
    formats: dateFormats$1c,
    defaultWidth: "full",
  }),

  time: (0, _index$4K.buildFormatLongFn)({
    formats: timeFormats$1c,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4K.buildFormatLongFn)({
    formats: dateTimeFormats$1c,
    defaultWidth: "full",
  }),
});

var formatRelative$29 = {};

formatRelative$29.formatRelative = void 0;

const accusativeWeekdays$5 = [
  "neděli",
  "pondělí",
  "úterý",
  "středu",
  "čtvrtek",
  "pátek",
  "sobotu",
];

const formatRelativeLocale$14 = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: (date) => {
    const day = date.getDay();
    return "'v " + accusativeWeekdays$5[day] + " o' p";
  },
  other: "P",
};

const formatRelative$28 = (token, date) => {
  const format = formatRelativeLocale$14[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$29.formatRelative = formatRelative$28;

var localize$14 = {};

localize$14.localize = void 0;
var _index$4J = buildLocalizeFn$1;

const eraValues$14 = {
  narrow: ["př. n. l.", "n. l."],
  abbreviated: ["př. n. l.", "n. l."],
  wide: ["před naším letopočtem", "našeho letopočtu"],
};

const quarterValues$14 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],

  wide: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],
};

const monthValues$14 = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro",
  ],

  wide: [
    "leden",
    "únor",
    "březen",
    "duben",
    "květen",
    "červen",
    "červenec",
    "srpen",
    "září",
    "říjen",
    "listopad",
    "prosinec",
  ],
};

const formattingMonthValues$f = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro",
  ],

  wide: [
    "ledna",
    "února",
    "března",
    "dubna",
    "května",
    "června",
    "července",
    "srpna",
    "září",
    "října",
    "listopadu",
    "prosince",
  ],
};

const dayValues$14 = {
  narrow: ["ne", "po", "út", "st", "čt", "pá", "so"],
  short: ["ne", "po", "út", "st", "čt", "pá", "so"],
  abbreviated: ["ned", "pon", "úte", "stř", "čtv", "pát", "sob"],
  wide: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"],
};

const dayPeriodValues$14 = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc",
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc",
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc",
  },
};

const formattingDayPeriodValues$R = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc",
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc",
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc",
  },
};

const ordinalNumber$14 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$14.localize = {
  ordinalNumber: ordinalNumber$14,

  era: (0, _index$4J.buildLocalizeFn)({
    values: eraValues$14,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4J.buildLocalizeFn)({
    values: quarterValues$14,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4J.buildLocalizeFn)({
    values: monthValues$14,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$f,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$4J.buildLocalizeFn)({
    values: dayValues$14,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4J.buildLocalizeFn)({
    values: dayPeriodValues$14,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$R,
    defaultFormattingWidth: "wide",
  }),
});

var match$13 = {};

match$13.match = void 0;

var _index$4I = buildMatchFn$1;
var _index2$2j = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$13 = /^(\d+)\.?/i;
const parseOrdinalNumberPattern$13 = /\d+/i;

const matchEraPatterns$13 = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i,
};

const parseEraPatterns$13 = {
  any: [/^p[řr]/i, /^(po|n)/i],
};

const matchQuarterPatterns$13 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i,
};
const parseQuarterPatterns$13 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$13 = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated:
    /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i,
};
const parseMonthPatterns$13 = {
  narrow: [
    /^l/i,
    /^[úu]/i,
    /^b/i,
    /^d/i,
    /^k/i,
    /^[čc]/i,
    /^[čc]/i,
    /^s/i,
    /^z/i,
    /^[řr]/i,
    /^l/i,
    /^p/i,
  ],

  any: [
    /^led/i,
    /^[úu]n/i,
    /^b[řr]e/i,
    /^dub/i,
    /^kv[ěe]/i,
    /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
    /^[čc]vc|[čc]erven(ec|ce)/i,
    /^srp/i,
    /^z[áa][řr]/i,
    /^[řr][íi]j/i,
    /^lis/i,
    /^pro/i,
  ],
};

const matchDayPatterns$13 = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i,
};

const parseDayPatterns$13 = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i],
};

const matchDayPeriodPatterns$13 = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i,
};
const parseDayPeriodPatterns$13 = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i,
  },
};

(match$13.match = {
  ordinalNumber: (0, _index2$2j.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$13,
    parsePattern: parseOrdinalNumberPattern$13,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$4I.buildMatchFn)({
    matchPatterns: matchEraPatterns$13,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$13,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$4I.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$13,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$13,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$4I.buildMatchFn)({
    matchPatterns: matchMonthPatterns$13,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$13,
    defaultParseWidth: "any",
  }),

  day: (0, _index$4I.buildMatchFn)({
    matchPatterns: matchDayPatterns$13,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$13,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$4I.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$13,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$13,
    defaultParseWidth: "any",
  }),
});

cs.cs = void 0;
var _index$4H = formatDistance$29;
var _index2$2i = formatLong$1c;
var _index3$1f = formatRelative$29;
var _index4$1e = localize$14;
var _index5$1e = match$13;

/**
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus](https://github.com/davidrus)
 * @author Pavel Hrách [@SilenY](https://github.com/SilenY)
 * @author Jozef Bíroš [@JozefBiros](https://github.com/JozefBiros)
 */
(cs.cs = {
  code: "cs",
  formatDistance: _index$4H.formatDistance,
  formatLong: _index2$2i.formatLong,
  formatRelative: _index3$1f.formatRelative,
  localize: _index4$1e.localize,
  match: _index5$1e.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var cy = {};

var formatDistance$27 = {};

formatDistance$27.formatDistance = void 0;

const formatDistanceLocale$12 = {
  lessThanXSeconds: {
    one: "llai na eiliad",
    other: "llai na {{count}} eiliad",
  },

  xSeconds: {
    one: "1 eiliad",
    other: "{{count}} eiliad",
  },

  halfAMinute: "hanner munud",

  lessThanXMinutes: {
    one: "llai na munud",
    two: "llai na 2 funud",
    other: "llai na {{count}} munud",
  },

  xMinutes: {
    one: "1 munud",
    two: "2 funud",
    other: "{{count}} munud",
  },

  aboutXHours: {
    one: "tua 1 awr",
    other: "tua {{count}} awr",
  },

  xHours: {
    one: "1 awr",
    other: "{{count}} awr",
  },

  xDays: {
    one: "1 diwrnod",
    two: "2 ddiwrnod",
    other: "{{count}} diwrnod",
  },

  aboutXWeeks: {
    one: "tua 1 wythnos",
    two: "tua pythefnos",
    other: "tua {{count}} wythnos",
  },

  xWeeks: {
    one: "1 wythnos",
    two: "pythefnos",
    other: "{{count}} wythnos",
  },

  aboutXMonths: {
    one: "tua 1 mis",
    two: "tua 2 fis",
    other: "tua {{count}} mis",
  },

  xMonths: {
    one: "1 mis",
    two: "2 fis",
    other: "{{count}} mis",
  },

  aboutXYears: {
    one: "tua 1 flwyddyn",
    two: "tua 2 flynedd",
    other: "tua {{count}} mlynedd",
  },

  xYears: {
    one: "1 flwyddyn",
    two: "2 flynedd",
    other: "{{count}} mlynedd",
  },

  overXYears: {
    one: "dros 1 flwyddyn",
    two: "dros 2 flynedd",
    other: "dros {{count}} mlynedd",
  },

  almostXYears: {
    one: "bron 1 flwyddyn",
    two: "bron 2 flynedd",
    other: "bron {{count}} mlynedd",
  },
};

const formatDistance$26 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$12[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else if (count === 2 && !!tokenValue.two) {
    result = tokenValue.two;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "mewn " + result;
    } else {
      return result + " yn ôl";
    }
  }

  return result;
};
formatDistance$27.formatDistance = formatDistance$26;

var formatLong$1b = {};

formatLong$1b.formatLong = void 0;
var _index$4G = buildFormatLongFn$1;

const dateFormats$1b = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy",
};

const timeFormats$1b = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$1b = {
  full: "{{date}} 'am' {{time}}",
  long: "{{date}} 'am' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$1b.formatLong = {
  date: (0, _index$4G.buildFormatLongFn)({
    formats: dateFormats$1b,
    defaultWidth: "full",
  }),

  time: (0, _index$4G.buildFormatLongFn)({
    formats: timeFormats$1b,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4G.buildFormatLongFn)({
    formats: dateTimeFormats$1b,
    defaultWidth: "full",
  }),
});

var formatRelative$27 = {};

formatRelative$27.formatRelative = void 0;

const formatRelativeLocale$13 = {
  lastWeek: "eeee 'diwethaf am' p",
  yesterday: "'ddoe am' p",
  today: "'heddiw am' p",
  tomorrow: "'yfory am' p",
  nextWeek: "eeee 'am' p",
  other: "P",
};

const formatRelative$26 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$13[token];
formatRelative$27.formatRelative = formatRelative$26;

var localize$13 = {};

localize$13.localize = void 0;
var _index$4F = buildLocalizeFn$1;

const eraValues$13 = {
  narrow: ["C", "O"],
  abbreviated: ["CC", "OC"],
  wide: ["Cyn Crist", "Ar ôl Crist"],
};

const quarterValues$13 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ch1", "Ch2", "Ch3", "Ch4"],
  wide: ["Chwarter 1af", "2ail chwarter", "3ydd chwarter", "4ydd chwarter"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$13 = {
  narrow: ["I", "Ch", "Ma", "E", "Mi", "Me", "G", "A", "Md", "H", "T", "Rh"],

  abbreviated: [
    "Ion",
    "Chwe",
    "Maw",
    "Ebr",
    "Mai",
    "Meh",
    "Gor",
    "Aws",
    "Med",
    "Hyd",
    "Tach",
    "Rhag",
  ],

  wide: [
    "Ionawr",
    "Chwefror",
    "Mawrth",
    "Ebrill",
    "Mai",
    "Mehefin",
    "Gorffennaf",
    "Awst",
    "Medi",
    "Hydref",
    "Tachwedd",
    "Rhagfyr",
  ],
};

const dayValues$13 = {
  narrow: ["S", "Ll", "M", "M", "I", "G", "S"],
  short: ["Su", "Ll", "Ma", "Me", "Ia", "Gw", "Sa"],
  abbreviated: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
  wide: [
    "dydd Sul",
    "dydd Llun",
    "dydd Mawrth",
    "dydd Mercher",
    "dydd Iau",
    "dydd Gwener",
    "dydd Sadwrn",
  ],
};

const dayPeriodValues$13 = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos",
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos",
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos",
  },
};

const formattingDayPeriodValues$Q = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos",
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos",
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos",
  },
};

const ordinalNumber$13 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  if (number < 20) {
    switch (number) {
      case 0:
        return number + "fed";
      case 1:
        return number + "af";
      case 2:
        return number + "ail";
      case 3:
      case 4:
        return number + "ydd";
      case 5:
      case 6:
        return number + "ed";
      case 7:
      case 8:
      case 9:
      case 10:
      case 12:
      case 15:
      case 18:
        return number + "fed";
      case 11:
      case 13:
      case 14:
      case 16:
      case 17:
      case 19:
        return number + "eg";
    }
  } else if ((number >= 50 && number <= 60) || number === 80 || number >= 100) {
    return number + "fed";
  }
  return number + "ain";
};

(localize$13.localize = {
  ordinalNumber: ordinalNumber$13,

  era: (0, _index$4F.buildLocalizeFn)({
    values: eraValues$13,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4F.buildLocalizeFn)({
    values: quarterValues$13,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4F.buildLocalizeFn)({
    values: monthValues$13,
    defaultWidth: "wide",
  }),

  day: (0, _index$4F.buildLocalizeFn)({
    values: dayValues$13,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4F.buildLocalizeFn)({
    values: dayPeriodValues$13,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$Q,
    defaultFormattingWidth: "wide",
  }),
});

var match$12 = {};

match$12.match = void 0;

var _index$4E = buildMatchFn$1;
var _index2$2h = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$12 = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
const parseOrdinalNumberPattern$12 = /\d+/i;

const matchEraPatterns$12 = {
  narrow: /^(c|o)/i,
  abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
  wide: /^(cyn christ|ar ôl crist|ar ol crist)/i,
};
const parseEraPatterns$12 = {
  wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
  any: [/^c/i, /^o/i],
};

const matchQuarterPatterns$12 = {
  narrow: /^[1234]/i,
  abbreviated: /^ch[1234]/i,
  wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i,
};
const parseQuarterPatterns$12 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$12 = {
  narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
  abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
  wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i,
};
const parseMonthPatterns$12 = {
  narrow: [
    /^i/i,
    /^ch/i,
    /^m/i,
    /^e/i,
    /^m/i,
    /^m/i,
    /^g/i,
    /^a/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^rh/i,
  ],

  any: [
    /^io/i,
    /^ch/i,
    /^maw/i,
    /^e/i,
    /^mai/i,
    /^meh/i,
    /^g/i,
    /^a/i,
    /^med/i,
    /^h/i,
    /^t/i,
    /^rh/i,
  ],
};

const matchDayPatterns$12 = {
  narrow: /^(s|ll|m|i|g)/i,
  short: /^(su|ll|ma|me|ia|gw|sa)/i,
  abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
  wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i,
};
const parseDayPatterns$12 = {
  narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
  wide: [
    /^dydd su/i,
    /^dydd ll/i,
    /^dydd ma/i,
    /^dydd me/i,
    /^dydd i/i,
    /^dydd g/i,
    /^dydd sa/i,
  ],

  any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i],
};

const matchDayPeriodPatterns$12 = {
  narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
  any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
};
const parseDayPeriodPatterns$12 = {
  any: {
    am: /^b|(y\.?\s?b\.?)/i,
    pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
    midnight: /^hn|hanner nos/i,
    noon: /^hd|hanner dydd/i,
    morning: /bore/i,
    afternoon: /prynhawn/i,
    evening: /^gyda'r nos$/i,
    night: /blah/i,
  },
};

(match$12.match = {
  ordinalNumber: (0, _index2$2h.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$12,
    parsePattern: parseOrdinalNumberPattern$12,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$4E.buildMatchFn)({
    matchPatterns: matchEraPatterns$12,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$12,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$4E.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$12,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$12,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$4E.buildMatchFn)({
    matchPatterns: matchMonthPatterns$12,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$12,
    defaultParseWidth: "any",
  }),

  day: (0, _index$4E.buildMatchFn)({
    matchPatterns: matchDayPatterns$12,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$12,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$4E.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$12,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$12,
    defaultParseWidth: "any",
  }),
});

cy.cy = void 0;
var _index$4D = formatDistance$27;
var _index2$2g = formatLong$1b;
var _index3$1e = formatRelative$27;
var _index4$1d = localize$13;
var _index5$1d = match$12;

/**
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo](https://github.com/elmomalmo)
 */
(cy.cy = {
  code: "cy",
  formatDistance: _index$4D.formatDistance,
  formatLong: _index2$2g.formatLong,
  formatRelative: _index3$1e.formatRelative,
  localize: _index4$1d.localize,
  match: _index5$1d.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var da = {};

var formatDistance$25 = {};

formatDistance$25.formatDistance = void 0;

const formatDistanceLocale$11 = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder",
  },

  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder",
  },

  halfAMinute: "ét halvt minut",

  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter",
  },

  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter",
  },

  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer",
  },

  xHours: {
    one: "1 time",
    other: "{{count}} timer",
  },

  xDays: {
    one: "1 dag",
    other: "{{count}} dage",
  },

  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger",
  },

  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger",
  },

  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder",
  },

  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder",
  },

  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år",
  },

  xYears: {
    one: "1 år",
    other: "{{count}} år",
  },

  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år",
  },

  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år",
  },
};

const formatDistance$24 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$11[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "om " + result;
    } else {
      return result + " siden";
    }
  }

  return result;
};
formatDistance$25.formatDistance = formatDistance$24;

var formatLong$1a = {};

formatLong$1a.formatLong = void 0;
var _index$4C = buildFormatLongFn$1;

const dateFormats$1a = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y",
};

const timeFormats$1a = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$1a = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$1a.formatLong = {
  date: (0, _index$4C.buildFormatLongFn)({
    formats: dateFormats$1a,
    defaultWidth: "full",
  }),

  time: (0, _index$4C.buildFormatLongFn)({
    formats: timeFormats$1a,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4C.buildFormatLongFn)({
    formats: dateTimeFormats$1a,
    defaultWidth: "full",
  }),
});

var formatRelative$25 = {};

formatRelative$25.formatRelative = void 0;

const formatRelativeLocale$12 = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P",
};

const formatRelative$24 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$12[token];
formatRelative$25.formatRelative = formatRelative$24;

var localize$12 = {};

localize$12.localize = void 0;
var _index$4B = buildLocalizeFn$1;

const eraValues$12 = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"],
};

const quarterValues$12 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"],
};

const monthValues$12 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec.",
  ],

  wide: [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december",
  ],
};

// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
const dayValues$12 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],

  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag",
  ],
};

const dayPeriodValues$12 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat",
  },
};

const formattingDayPeriodValues$P = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten",
  },
};

const ordinalNumber$12 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$12.localize = {
  ordinalNumber: ordinalNumber$12,

  era: (0, _index$4B.buildLocalizeFn)({
    values: eraValues$12,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4B.buildLocalizeFn)({
    values: quarterValues$12,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4B.buildLocalizeFn)({
    values: monthValues$12,
    defaultWidth: "wide",
  }),

  day: (0, _index$4B.buildLocalizeFn)({
    values: dayValues$12,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4B.buildLocalizeFn)({
    values: dayPeriodValues$12,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$P,
    defaultFormattingWidth: "wide",
  }),
});

var match$11 = {};

match$11.match = void 0;

var _index$4A = buildMatchFn$1;
var _index2$2f = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$11 = /^(\d+)(\.)?/i;
const parseOrdinalNumberPattern$11 = /\d+/i;

const matchEraPatterns$11 = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i,
};
const parseEraPatterns$11 = {
  any: [/^f/i, /^(v|e)/i],
};

const matchQuarterPatterns$11 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i,
};
const parseQuarterPatterns$11 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$11 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i,
};
const parseMonthPatterns$11 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$11 = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i,
};
const parseDayPatterns$11 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i],
};

const matchDayPeriodPatterns$11 = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
};
const parseDayPeriodPatterns$11 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i,
  },
};

(match$11.match = {
  ordinalNumber: (0, _index2$2f.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$11,
    parsePattern: parseOrdinalNumberPattern$11,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$4A.buildMatchFn)({
    matchPatterns: matchEraPatterns$11,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$11,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$4A.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$11,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$11,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$4A.buildMatchFn)({
    matchPatterns: matchMonthPatterns$11,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$11,
    defaultParseWidth: "any",
  }),

  day: (0, _index$4A.buildMatchFn)({
    matchPatterns: matchDayPatterns$11,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$11,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$4A.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$11,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$11,
    defaultParseWidth: "any",
  }),
});

da.da = void 0;
var _index$4z = formatDistance$25;
var _index2$2e = formatLong$1a;
var _index3$1d = formatRelative$25;
var _index4$1c = localize$12;
var _index5$1c = match$11;

/**
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg](https://github.com/MathiasKandelborg)
 * @author Anders B. Hansen [@Andersbiha](https://github.com/Andersbiha)
 * @author [@kgram](https://github.com/kgram)
 * @author [@stefanbugge](https://github.com/stefanbugge)
 */
(da.da = {
  code: "da",
  formatDistance: _index$4z.formatDistance,
  formatLong: _index2$2e.formatLong,
  formatRelative: _index3$1d.formatRelative,
  localize: _index4$1c.localize,
  match: _index5$1c.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var de = {};

var formatDistance$23 = {};

formatDistance$23.formatDistance = void 0;

const formatDistanceLocale$10 = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden",
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden",
    },
  },

  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden",
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden",
    },
  },

  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute",
  },

  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten",
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten",
    },
  },

  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten",
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten",
    },
  },

  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden",
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden",
    },
  },

  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden",
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden",
    },
  },

  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage",
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen",
    },
  },

  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen",
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen",
    },
  },

  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen",
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen",
    },
  },

  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate",
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten",
    },
  },

  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate",
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten",
    },
  },

  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre",
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren",
    },
  },

  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre",
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren",
    },
  },

  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre",
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren",
    },
  },

  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre",
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren",
    },
  },
};

const formatDistance$22 = (token, count, options) => {
  let result;

  const tokenValue = options?.addSuffix
    ? formatDistanceLocale$10[token].withPreposition
    : formatDistanceLocale$10[token].standalone;
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return "vor " + result;
    }
  }

  return result;
};
formatDistance$23.formatDistance = formatDistance$22;

var formatLong$19 = {};

formatLong$19.formatLong = void 0;
var _index$4y = buildFormatLongFn$1;

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
const dateFormats$19 = {
  full: "EEEE, do MMMM y", // Montag, 7. Januar 2018
  long: "do MMMM y", // 7. Januar 2018
  medium: "do MMM y", // 7. Jan. 2018
  short: "dd.MM.y", // 07.01.2018
};

const timeFormats$19 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$19 = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$19.formatLong = {
  date: (0, _index$4y.buildFormatLongFn)({
    formats: dateFormats$19,
    defaultWidth: "full",
  }),

  time: (0, _index$4y.buildFormatLongFn)({
    formats: timeFormats$19,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4y.buildFormatLongFn)({
    formats: dateTimeFormats$19,
    defaultWidth: "full",
  }),
});

var formatRelative$23 = {};

formatRelative$23.formatRelative = void 0;

const formatRelativeLocale$11 = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P",
};

const formatRelative$22 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$11[token];
formatRelative$23.formatRelative = formatRelative$22;

var localize$11 = {};

localize$11.localize = void 0;
var _index$4x = buildLocalizeFn$1;

const eraValues$11 = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"],
};

const quarterValues$11 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"],
};

// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$11 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ],

  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
};

// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
const formattingMonthValues$e = {
  narrow: monthValues$11.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez.",
  ],

  wide: monthValues$11.wide,
};

const dayValues$11 = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ],
};

// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const dayPeriodValues$11 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht",
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht",
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht",
  },
};
const formattingDayPeriodValues$O = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts",
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts",
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts",
  },
};

const ordinalNumber$11 = (dirtyNumber) => {
  const number = Number(dirtyNumber);

  return number + ".";
};

(localize$11.localize = {
  ordinalNumber: ordinalNumber$11,

  era: (0, _index$4x.buildLocalizeFn)({
    values: eraValues$11,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4x.buildLocalizeFn)({
    values: quarterValues$11,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4x.buildLocalizeFn)({
    values: monthValues$11,
    formattingValues: formattingMonthValues$e,
    defaultWidth: "wide",
  }),

  day: (0, _index$4x.buildLocalizeFn)({
    values: dayValues$11,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4x.buildLocalizeFn)({
    values: dayPeriodValues$11,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$O,
    defaultFormattingWidth: "wide",
  }),
});

var match$10 = {};

match$10.match = void 0;

var _index$4w = buildMatchFn$1;
var _index2$2d = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$10 = /^(\d+)(\.)?/i;
const parseOrdinalNumberPattern$10 = /\d+/i;

const matchEraPatterns$10 = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i,
};
const parseEraPatterns$10 = {
  any: [/^v/i, /^n/i],
};

const matchQuarterPatterns$10 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i,
};
const parseQuarterPatterns$10 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$10 = {
  narrow: /^[jfmasond]/i,
  abbreviated:
    /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i,
};
const parseMonthPatterns$10 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$10 = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i,
};
const parseDayPatterns$10 = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns$10 = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated:
    /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i,
};
const parseDayPeriodPatterns$10 = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i, // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i, // will never be matched. Night is matched by `pm`
  },
};

(match$10.match = {
  ordinalNumber: (0, _index2$2d.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$10,
    parsePattern: parseOrdinalNumberPattern$10,
    valueCallback: (value) => parseInt(value),
  }),

  era: (0, _index$4w.buildMatchFn)({
    matchPatterns: matchEraPatterns$10,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$10,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$4w.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$10,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$10,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$4w.buildMatchFn)({
    matchPatterns: matchMonthPatterns$10,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$10,
    defaultParseWidth: "any",
  }),

  day: (0, _index$4w.buildMatchFn)({
    matchPatterns: matchDayPatterns$10,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$10,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$4w.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$10,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$10,
    defaultParseWidth: "any",
  }),
});

de.de = void 0;
var _index$4v = formatDistance$23;
var _index2$2c = formatLong$19;
var _index3$1c = formatRelative$23;
var _index4$1b = localize$11;
var _index5$1b = match$10;

/**
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Asia [@asia-t](https://github.com/asia-t)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author RomanErnst [@pex](https://github.com/pex)
 * @author Philipp Keck [@Philipp91](https://github.com/Philipp91)
 */
(de.de = {
  code: "de",
  formatDistance: _index$4v.formatDistance,
  formatLong: _index2$2c.formatLong,
  formatRelative: _index3$1c.formatRelative,
  localize: _index4$1b.localize,
  match: _index5$1b.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var deAT = {};

var localize$10 = {};

localize$10.localize = void 0;
var _index$4u = buildLocalizeFn$1;

const eraValues$10 = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"],
};

const quarterValues$10 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"],
};

// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$10 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jän",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ],

  wide: [
    "Jänner",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
};

// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
const formattingMonthValues$d = {
  narrow: monthValues$10.narrow,
  abbreviated: [
    "Jän.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez.",
  ],

  wide: monthValues$10.wide,
};

const dayValues$10 = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag",
  ],
};

// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
const dayPeriodValues$10 = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht",
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht",
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht",
  },
};
const formattingDayPeriodValues$N = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts",
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts",
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts",
  },
};

const ordinalNumber$10 = (dirtyNumber) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$10.localize = {
  ordinalNumber: ordinalNumber$10,

  era: (0, _index$4u.buildLocalizeFn)({
    values: eraValues$10,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4u.buildLocalizeFn)({
    values: quarterValues$10,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4u.buildLocalizeFn)({
    values: monthValues$10,
    formattingValues: formattingMonthValues$d,
    defaultWidth: "wide",
  }),

  day: (0, _index$4u.buildLocalizeFn)({
    values: dayValues$10,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4u.buildLocalizeFn)({
    values: dayPeriodValues$10,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$N,
    defaultFormattingWidth: "wide",
  }),
});

deAT.deAT = void 0;
var _index$4t = formatDistance$23;
var _index2$2b = formatLong$19;
var _index3$1b = formatRelative$23;
var _index4$1a = match$10;

var _index5$1a = localize$10; // difference to 'de' locale

/**
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein](https://github.com/cstenglein)
 */
(deAT.deAT = {
  code: "de-AT",
  formatDistance: _index$4t.formatDistance,
  formatLong: _index2$2b.formatLong,
  formatRelative: _index3$1b.formatRelative,
  localize: _index5$1a.localize,
  match: _index4$1a.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var el = {};

var formatDistance$21 = {};

formatDistance$21.formatDistance = void 0;

const formatDistanceLocale$$ = {
  lessThanXSeconds: {
    one: "λιγότερο από ένα δευτερόλεπτο",
    other: "λιγότερο από {{count}} δευτερόλεπτα",
  },

  xSeconds: {
    one: "1 δευτερόλεπτο",
    other: "{{count}} δευτερόλεπτα",
  },

  halfAMinute: "μισό λεπτό",

  lessThanXMinutes: {
    one: "λιγότερο από ένα λεπτό",
    other: "λιγότερο από {{count}} λεπτά",
  },

  xMinutes: {
    one: "1 λεπτό",
    other: "{{count}} λεπτά",
  },

  aboutXHours: {
    one: "περίπου 1 ώρα",
    other: "περίπου {{count}} ώρες",
  },

  xHours: {
    one: "1 ώρα",
    other: "{{count}} ώρες",
  },

  xDays: {
    one: "1 ημέρα",
    other: "{{count}} ημέρες",
  },

  aboutXWeeks: {
    one: "περίπου 1 εβδομάδα",
    other: "περίπου {{count}} εβδομάδες",
  },

  xWeeks: {
    one: "1 εβδομάδα",
    other: "{{count}} εβδομάδες",
  },

  aboutXMonths: {
    one: "περίπου 1 μήνας",
    other: "περίπου {{count}} μήνες",
  },

  xMonths: {
    one: "1 μήνας",
    other: "{{count}} μήνες",
  },

  aboutXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια",
  },

  xYears: {
    one: "1 χρόνο",
    other: "{{count}} χρόνια",
  },

  overXYears: {
    one: "πάνω από 1 χρόνο",
    other: "πάνω από {{count}} χρόνια",
  },

  almostXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια",
  },
};

const formatDistance$20 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$$[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "σε " + result;
    } else {
      return result + " πριν";
    }
  }

  return result;
};
formatDistance$21.formatDistance = formatDistance$20;

var formatLong$18 = {};

formatLong$18.formatLong = void 0;
var _index$4s = buildFormatLongFn$1;

const dateFormats$18 = {
  full: "EEEE, d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "d/M/yy",
};

const timeFormats$18 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$18 = {
  full: "{{date}} - {{time}}",
  long: "{{date}} - {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$18.formatLong = {
  date: (0, _index$4s.buildFormatLongFn)({
    formats: dateFormats$18,
    defaultWidth: "full",
  }),

  time: (0, _index$4s.buildFormatLongFn)({
    formats: timeFormats$18,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4s.buildFormatLongFn)({
    formats: dateTimeFormats$18,
    defaultWidth: "full",
  }),
});

var formatRelative$21 = {};

formatRelative$21.formatRelative = void 0;

const formatRelativeLocale$10 = {
  lastWeek: (date) => {
    switch (date.getDay()) {
      case 6: //Σάββατο
        return "'το προηγούμενο' eeee 'στις' p";
      default:
        return "'την προηγούμενη' eeee 'στις' p";
    }
  },
  yesterday: "'χθες στις' p",
  today: "'σήμερα στις' p",
  tomorrow: "'αύριο στις' p",
  nextWeek: "eeee 'στις' p",
  other: "P",
};

const formatRelative$20 = (token, date) => {
  const format = formatRelativeLocale$10[token];

  if (typeof format === "function") return format(date);

  return format;
};
formatRelative$21.formatRelative = formatRelative$20;

var localize$$ = {};

localize$$.localize = void 0;
var _index$4r = buildLocalizeFn$1;

const eraValues$$ = {
  narrow: ["πΧ", "μΧ"],
  abbreviated: ["π.Χ.", "μ.Χ."],
  wide: ["προ Χριστού", "μετά Χριστόν"],
};

const quarterValues$$ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Τ1", "Τ2", "Τ3", "Τ4"],
  wide: ["1ο τρίμηνο", "2ο τρίμηνο", "3ο τρίμηνο", "4ο τρίμηνο"],
};

const monthValues$$ = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: [
    "Ιαν",
    "Φεβ",
    "Μάρ",
    "Απρ",
    "Μάι",
    "Ιούν",
    "Ιούλ",
    "Αύγ",
    "Σεπ",
    "Οκτ",
    "Νοέ",
    "Δεκ",
  ],

  wide: [
    "Ιανουάριος",
    "Φεβρουάριος",
    "Μάρτιος",
    "Απρίλιος",
    "Μάιος",
    "Ιούνιος",
    "Ιούλιος",
    "Αύγουστος",
    "Σεπτέμβριος",
    "Οκτώβριος",
    "Νοέμβριος",
    "Δεκέμβριος",
  ],
};

const formattingMonthValues$c = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: [
    "Ιαν",
    "Φεβ",
    "Μαρ",
    "Απρ",
    "Μαΐ",
    "Ιουν",
    "Ιουλ",
    "Αυγ",
    "Σεπ",
    "Οκτ",
    "Νοε",
    "Δεκ",
  ],

  wide: [
    "Ιανουαρίου",
    "Φεβρουαρίου",
    "Μαρτίου",
    "Απριλίου",
    "Μαΐου",
    "Ιουνίου",
    "Ιουλίου",
    "Αυγούστου",
    "Σεπτεμβρίου",
    "Οκτωβρίου",
    "Νοεμβρίου",
    "Δεκεμβρίου",
  ],
};

const dayValues$$ = {
  narrow: ["Κ", "Δ", "T", "Τ", "Π", "Π", "Σ"],
  short: ["Κυ", "Δε", "Τρ", "Τε", "Πέ", "Πα", "Σά"],
  abbreviated: ["Κυρ", "Δευ", "Τρί", "Τετ", "Πέμ", "Παρ", "Σάβ"],
  wide: [
    "Κυριακή",
    "Δευτέρα",
    "Τρίτη",
    "Τετάρτη",
    "Πέμπτη",
    "Παρασκευή",
    "Σάββατο",
  ],
};

const dayPeriodValues$$ = {
  narrow: {
    am: "πμ",
    pm: "μμ",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα",
  },
  abbreviated: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα",
  },
  wide: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα",
  },
};

const ordinalNumber$$ = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = options?.unit;
  let suffix;

  if (unit === "year" || unit === "month") {
    suffix = "ος";
  } else if (
    unit === "week" ||
    unit === "dayOfYear" ||
    unit === "day" ||
    unit === "hour" ||
    unit === "date"
  ) {
    suffix = "η";
  } else {
    suffix = "ο";
  }

  return number + suffix;
};

(localize$$.localize = {
  ordinalNumber: ordinalNumber$$,

  era: (0, _index$4r.buildLocalizeFn)({
    values: eraValues$$,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4r.buildLocalizeFn)({
    values: quarterValues$$,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$4r.buildLocalizeFn)({
    values: monthValues$$,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$c,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$4r.buildLocalizeFn)({
    values: dayValues$$,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4r.buildLocalizeFn)({
    values: dayPeriodValues$$,
    defaultWidth: "wide",
  }),
});

var match$$ = {};

match$$.match = void 0;

var _index$4q = buildMatchFn$1;
var _index2$2a = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$$ = /^(\d+)(ος|η|ο)?/i;
const parseOrdinalNumberPattern$$ = /\d+/i;

const matchEraPatterns$$ = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i,
};
const parseEraPatterns$$ = {
  any: [/^π/i, /^(μ|κ)/i],
};

const matchQuarterPatterns$$ = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i,
};
const parseQuarterPatterns$$ = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$$ = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated:
    /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i,
};
const parseMonthPatterns$$ = {
  narrow: [
    /^ι/i,
    /^φ/i,
    /^μ/i,
    /^α/i,
    /^μ/i,
    /^ι/i,
    /^ι/i,
    /^α/i,
    /^σ/i,
    /^ο/i,
    /^ν/i,
    /^δ/i,
  ],

  any: [
    /^ια/i,
    /^φ/i,
    /^μ[άα]ρ/i,
    /^απ/i,
    /^μ[άα][ιΐ]/i,
    /^ιο[ύυ]ν/i,
    /^ιο[ύυ]λ/i,
    /^α[ύυ]/i,
    /^σ/i,
    /^ο/i,
    /^ν/i,
    /^δ/i,
  ],
};

const matchDayPatterns$$ = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i,
};
const parseDayPatterns$$ = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i],
};

const matchDayPeriodPatterns$$ = {
  narrow:
    /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
};
const parseDayPeriodPatterns$$ = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i,
  },
};

(match$$.match = {
  ordinalNumber: (0, _index2$2a.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$$,
    parsePattern: parseOrdinalNumberPattern$$,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$4q.buildMatchFn)({
    matchPatterns: matchEraPatterns$$,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$$,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$4q.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$$,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$$,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$4q.buildMatchFn)({
    matchPatterns: matchMonthPatterns$$,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$$,
    defaultParseWidth: "any",
  }),

  day: (0, _index$4q.buildMatchFn)({
    matchPatterns: matchDayPatterns$$,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$$,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$4q.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$$,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$$,
    defaultParseWidth: "any",
  }),
});

el.el = void 0;
var _index$4p = formatDistance$21;
var _index2$29 = formatLong$18;
var _index3$1a = formatRelative$21;
var _index4$19 = localize$$;
var _index5$19 = match$$;

/**
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk](https://github.com/fanixk)
 * @author Theodoros Orfanidis [@teoulas](https://github.com/teoulas)
 */
(el.el = {
  code: "el",
  formatDistance: _index$4p.formatDistance,
  formatLong: _index2$29.formatLong,
  formatRelative: _index3$1a.formatRelative,
  localize: _index4$19.localize,
  match: _index5$19.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var enAU = {};

var formatLong$17 = {};

formatLong$17.formatLong = void 0;
var _index$4o = buildFormatLongFn$1;

const dateFormats$17 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy",
};

const timeFormats$17 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$17 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$17.formatLong = {
  date: (0, _index$4o.buildFormatLongFn)({
    formats: dateFormats$17,
    defaultWidth: "full",
  }),

  time: (0, _index$4o.buildFormatLongFn)({
    formats: timeFormats$17,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4o.buildFormatLongFn)({
    formats: dateTimeFormats$17,
    defaultWidth: "full",
  }),
});

enAU.enAU = void 0;
var _index$4n = formatDistance$2H;
var _index2$28 = formatLong$17;
var _index3$19 = formatRelative$2H;
var _index4$18 = localize$1k;
var _index5$18 = match$1j;

/**
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige](https://github.com/JulienMalige)
 */
(enAU.enAU = {
  code: "en-AU",
  formatDistance: _index$4n.formatDistance,
  formatLong: _index2$28.formatLong,
  formatRelative: _index3$19.formatRelative,
  localize: _index4$18.localize,
  match: _index5$18.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var enCA = {};

var formatDistance$1$ = {};

formatDistance$1$.formatDistance = void 0;

const formatDistanceLocale$_ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds",
  },

  xSeconds: {
    one: "a second",
    other: "{{count}} seconds",
  },

  halfAMinute: "half a minute",

  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes",
  },

  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours",
  },

  xHours: {
    one: "an hour",
    other: "{{count}} hours",
  },

  xDays: {
    one: "a day",
    other: "{{count}} days",
  },

  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks",
  },

  xWeeks: {
    one: "a week",
    other: "{{count}} weeks",
  },

  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months",
  },

  xMonths: {
    one: "a month",
    other: "{{count}} months",
  },

  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years",
  },

  xYears: {
    one: "a year",
    other: "{{count}} years",
  },

  overXYears: {
    one: "over a year",
    other: "over {{count}} years",
  },

  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years",
  },
};

const formatDistance$1_ = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$_[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }

  return result;
};
formatDistance$1$.formatDistance = formatDistance$1_;

var formatLong$16 = {};

formatLong$16.formatLong = void 0;
var _index$4m = buildFormatLongFn$1;

const dateFormats$16 = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd",
};

const timeFormats$16 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$16 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$16.formatLong = {
  date: (0, _index$4m.buildFormatLongFn)({
    formats: dateFormats$16,
    defaultWidth: "full",
  }),

  time: (0, _index$4m.buildFormatLongFn)({
    formats: timeFormats$16,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4m.buildFormatLongFn)({
    formats: dateTimeFormats$16,
    defaultWidth: "full",
  }),
});

enCA.enCA = void 0;
var _index$4l = formatRelative$2H;
var _index2$27 = localize$1k;
var _index3$18 = match$1j;

var _index4$17 = formatDistance$1$;
var _index5$17 = formatLong$16;

/**
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak](https://github.com/markowsiak)
 * @author Marco Imperatore [@mimperatore](https://github.com/mimperatore)
 */
(enCA.enCA = {
  code: "en-CA",
  formatDistance: _index4$17.formatDistance,
  formatLong: _index5$17.formatLong,
  formatRelative: _index$4l.formatRelative,
  localize: _index2$27.localize,
  match: _index3$18.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var enGB = {};

var formatLong$15 = {};

formatLong$15.formatLong = void 0;
var _index$4k = buildFormatLongFn$1;

const dateFormats$15 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy",
};

const timeFormats$15 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$15 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$15.formatLong = {
  date: (0, _index$4k.buildFormatLongFn)({
    formats: dateFormats$15,
    defaultWidth: "full",
  }),

  time: (0, _index$4k.buildFormatLongFn)({
    formats: timeFormats$15,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4k.buildFormatLongFn)({
    formats: dateTimeFormats$15,
    defaultWidth: "full",
  }),
});

enGB.enGB = void 0;
var _index$4j = formatDistance$2H;
var _index2$26 = formatRelative$2H;
var _index3$17 = localize$1k;
var _index4$16 = match$1j;

var _index5$16 = formatLong$15;

/**
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik](https://github.com/glintik)
 */
(enGB.enGB = {
  code: "en-GB",
  formatDistance: _index$4j.formatDistance,
  formatLong: _index5$16.formatLong,
  formatRelative: _index2$26.formatRelative,
  localize: _index3$17.localize,
  match: _index4$16.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var enIE = {};

enIE.enIE = void 0;
var _index$4i = formatDistance$2H;
var _index2$25 = formatRelative$2H;
var _index3$16 = localize$1k;
var _index4$15 = match$1j;

var _index5$15 = formatLong$15;

/**
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75](https://github.com/tan75)
 */
(enIE.enIE = {
  code: "en-IE",
  formatDistance: _index$4i.formatDistance,
  formatLong: _index5$15.formatLong,
  formatRelative: _index2$25.formatRelative,
  localize: _index3$16.localize,
  match: _index4$15.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var enIN = {};

var formatLong$14 = {};

formatLong$14.formatLong = void 0;
var _index$4h = buildFormatLongFn$1;

const dateFormats$14 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM, yyyy",
  medium: "d MMM, yyyy",
  short: "dd/MM/yyyy",
};

const timeFormats$14 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$14 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$14.formatLong = {
  date: (0, _index$4h.buildFormatLongFn)({
    formats: dateFormats$14,
    defaultWidth: "full",
  }),

  time: (0, _index$4h.buildFormatLongFn)({
    formats: timeFormats$14,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4h.buildFormatLongFn)({
    formats: dateTimeFormats$14,
    defaultWidth: "full",
  }),
});

enIN.enIN = void 0;
var _index$4g = formatDistance$2H;
var _index2$24 = formatRelative$2H;
var _index3$15 = localize$1k;
var _index4$14 = match$1j;

var _index5$14 = formatLong$14;

/**
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha](https://github.com/gbhasha)
 */
(enIN.enIN = {
  code: "en-IN",
  formatDistance: _index$4g.formatDistance,
  formatLong: _index5$14.formatLong,
  formatRelative: _index2$24.formatRelative,
  localize: _index3$15.localize,
  match: _index4$14.match,
  options: {
    weekStartsOn: 1, // Monday is the first day of the week.
    firstWeekContainsDate: 4, // The week that contains Jan 4th is the first week of the year.
  },
});

var enNZ = {};

var formatLong$13 = {};

formatLong$13.formatLong = void 0;
var _index$4f = buildFormatLongFn$1;

const dateFormats$13 = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy",
};

const timeFormats$13 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$13 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$13.formatLong = {
  date: (0, _index$4f.buildFormatLongFn)({
    formats: dateFormats$13,
    defaultWidth: "full",
  }),

  time: (0, _index$4f.buildFormatLongFn)({
    formats: timeFormats$13,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4f.buildFormatLongFn)({
    formats: dateTimeFormats$13,
    defaultWidth: "full",
  }),
});

enNZ.enNZ = void 0;
var _index$4e = formatDistance$2H;
var _index2$23 = formatRelative$2H;
var _index3$14 = localize$1k;
var _index4$13 = match$1j;

var _index5$13 = formatLong$13;

/**
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact](https://github.com/muntact)
 */
(enNZ.enNZ = {
  code: "en-NZ",
  formatDistance: _index$4e.formatDistance,
  formatLong: _index5$13.formatLong,
  formatRelative: _index2$23.formatRelative,
  localize: _index3$14.localize,
  match: _index4$13.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var enZA = {};

var formatLong$12 = {};

formatLong$12.formatLong = void 0;
var _index$4d = buildFormatLongFn$1;

const dateFormats$12 = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "yyyy/MM/dd",
};

const timeFormats$12 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$12 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$12.formatLong = {
  date: (0, _index$4d.buildFormatLongFn)({
    formats: dateFormats$12,
    defaultWidth: "full",
  }),

  time: (0, _index$4d.buildFormatLongFn)({
    formats: timeFormats$12,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4d.buildFormatLongFn)({
    formats: dateTimeFormats$12,
    defaultWidth: "full",
  }),
});

enZA.enZA = void 0;
var _index$4c = formatDistance$2H;
var _index2$22 = formatRelative$2H;
var _index3$13 = localize$1k;
var _index4$12 = match$1j;

var _index5$12 = formatLong$12;

/**
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav](https://github.com/shaykav)
 */
(enZA.enZA = {
  code: "en-ZA",
  formatDistance: _index$4c.formatDistance,
  formatLong: _index5$12.formatLong,
  formatRelative: _index2$22.formatRelative,
  localize: _index3$13.localize,
  match: _index4$12.match,
  options: {
    weekStartsOn: 0, // Sunday is the first day of the week.
    firstWeekContainsDate: 1, // The week that contains Jan 1st is the first week of the year.
  },
});

var eo = {};

var formatDistance$1Z = {};

formatDistance$1Z.formatDistance = void 0;

const formatDistanceLocale$Z = {
  lessThanXSeconds: {
    one: "malpli ol sekundo",
    other: "malpli ol {{count}} sekundoj",
  },

  xSeconds: {
    one: "1 sekundo",
    other: "{{count}} sekundoj",
  },

  halfAMinute: "duonminuto",

  lessThanXMinutes: {
    one: "malpli ol minuto",
    other: "malpli ol {{count}} minutoj",
  },

  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutoj",
  },

  aboutXHours: {
    one: "proksimume 1 horo",
    other: "proksimume {{count}} horoj",
  },

  xHours: {
    one: "1 horo",
    other: "{{count}} horoj",
  },

  xDays: {
    one: "1 tago",
    other: "{{count}} tagoj",
  },

  aboutXMonths: {
    one: "proksimume 1 monato",
    other: "proksimume {{count}} monatoj",
  },

  xWeeks: {
    one: "1 semajno",
    other: "{{count}} semajnoj",
  },

  aboutXWeeks: {
    one: "proksimume 1 semajno",
    other: "proksimume {{count}} semajnoj",
  },

  xMonths: {
    one: "1 monato",
    other: "{{count}} monatoj",
  },

  aboutXYears: {
    one: "proksimume 1 jaro",
    other: "proksimume {{count}} jaroj",
  },

  xYears: {
    one: "1 jaro",
    other: "{{count}} jaroj",
  },

  overXYears: {
    one: "pli ol 1 jaro",
    other: "pli ol {{count}} jaroj",
  },

  almostXYears: {
    one: "preskaŭ 1 jaro",
    other: "preskaŭ {{count}} jaroj",
  },
};

const formatDistance$1Y = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$Z[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options?.comparison && options.comparison > 0) {
      return "post " + result;
    } else {
      return "antaŭ " + result;
    }
  }

  return result;
};
formatDistance$1Z.formatDistance = formatDistance$1Y;

var formatLong$11 = {};

formatLong$11.formatLong = void 0;
var _index$4b = buildFormatLongFn$1;

const dateFormats$11 = {
  full: "EEEE, do 'de' MMMM y",
  long: "y-MMMM-dd",
  medium: "y-MMM-dd",
  short: "yyyy-MM-dd",
};

const timeFormats$11 = {
  full: "Ho 'horo kaj' m:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$11 = {
  any: "{{date}} {{time}}",
};

(formatLong$11.formatLong = {
  date: (0, _index$4b.buildFormatLongFn)({
    formats: dateFormats$11,
    defaultWidth: "full",
  }),

  time: (0, _index$4b.buildFormatLongFn)({
    formats: timeFormats$11,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$4b.buildFormatLongFn)({
    formats: dateTimeFormats$11,
    defaultWidth: "any",
  }),
});

var formatRelative$1$ = {};

formatRelative$1$.formatRelative = void 0;

const formatRelativeLocale$$ = {
  lastWeek: "'pasinta' eeee 'je' p",
  yesterday: "'hieraŭ je' p",
  today: "'hodiaŭ je' p",
  tomorrow: "'morgaŭ je' p",
  nextWeek: "eeee 'je' p",
  other: "P",
};

const formatRelative$1_ = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$$[token];
formatRelative$1$.formatRelative = formatRelative$1_;

var localize$_ = {};

localize$_.localize = void 0;

var _index$4a = buildLocalizeFn$1;

const eraValues$_ = {
  narrow: ["aK", "pK"],
  abbreviated: ["a.K.E.", "p.K.E."],
  wide: ["antaŭ Komuna Erao", "Komuna Erao"],
};

const quarterValues$_ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: [
    "1-a kvaronjaro",
    "2-a kvaronjaro",
    "3-a kvaronjaro",
    "4-a kvaronjaro",
  ],
};

const monthValues$_ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "aŭg",
    "sep",
    "okt",
    "nov",
    "dec",
  ],

  wide: [
    "januaro",
    "februaro",
    "marto",
    "aprilo",
    "majo",
    "junio",
    "julio",
    "aŭgusto",
    "septembro",
    "oktobro",
    "novembro",
    "decembro",
  ],
};

const dayValues$_ = {
  narrow: ["D", "L", "M", "M", "Ĵ", "V", "S"],
  short: ["di", "lu", "ma", "me", "ĵa", "ve", "sa"],
  abbreviated: ["dim", "lun", "mar", "mer", "ĵaŭ", "ven", "sab"],
  wide: [
    "dimanĉo",
    "lundo",
    "mardo",
    "merkredo",
    "ĵaŭdo",
    "vendredo",
    "sabato",
  ],
};

const dayPeriodValues$_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte",
  },
  abbreviated: {
    am: "a.t.m.",
    pm: "p.t.m.",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte",
  },
  wide: {
    am: "antaŭtagmeze",
    pm: "posttagmeze",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte",
  },
};

const ordinalNumber$_ = (dirtyNumber) => {
  const number = Number(dirtyNumber);
  return number + "-a";
};

(localize$_.localize = {
  ordinalNumber: ordinalNumber$_,

  era: (0, _index$4a.buildLocalizeFn)({
    values: eraValues$_,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$4a.buildLocalizeFn)({
    values: quarterValues$_,
    defaultWidth: "wide",
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    },
  }),

  month: (0, _index$4a.buildLocalizeFn)({
    values: monthValues$_,
    defaultWidth: "wide",
  }),

  day: (0, _index$4a.buildLocalizeFn)({
    values: dayValues$_,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$4a.buildLocalizeFn)({
    values: dayPeriodValues$_,
    defaultWidth: "wide",
  }),
});

var match$_ = {};

match$_.match = void 0;
var _index$49 = buildMatchPatternFn$1;
var _index2$21 = buildMatchFn$1;

const matchOrdinalNumberPattern$_ = /^(\d+)(-?a)?/i;
const parseOrdinalNumberPattern$_ = /\d+/i;

const matchEraPatterns$_ = {
  narrow: /^([ap]k)/i,
  abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
  wide: /^((antaǔ |post )?komuna erao)/i,
};
const parseEraPatterns$_ = {
  any: [/^a/i, /^[kp]/i],
};

const matchQuarterPatterns$_ = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](-?a)? kvaronjaro/i,
};
const parseQuarterPatterns$_ = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$_ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
  wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i,
};
const parseMonthPatterns$_ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^a(u|ŭ)/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$_ = {
  narrow: /^[dlmĵjvs]/i,
  short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
  wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i,
};
const parseDayPatterns$_ = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i],
};

const matchDayPeriodPatterns$_ = {
  narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  abbreviated:
    /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i,
};
const parseDayPeriodPatterns$_ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^noktom/i,
    noon: /^t/i,
    morning: /^m/i,
    afternoon: /^posttagmeze/i,
    evening: /^v/i,
    night: /^n/i,
  },
};

(match$_.match = {
  ordinalNumber: (0, _index$49.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$_,
    parsePattern: parseOrdinalNumberPattern$_,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: (0, _index2$21.buildMatchFn)({
    matchPatterns: matchEraPatterns$_,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$_,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index2$21.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$_,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$_,
    defaultParseWidth: "any",
    valueCallback: function (index) {
      return index + 1;
    },
  }),

  month: (0, _index2$21.buildMatchFn)({
    matchPatterns: matchMonthPatterns$_,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$_,
    defaultParseWidth: "any",
  }),

  day: (0, _index2$21.buildMatchFn)({
    matchPatterns: matchDayPatterns$_,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$_,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index2$21.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$_,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$_,
    defaultParseWidth: "any",
  }),
});

eo.eo = void 0;
var _index$48 = formatDistance$1Z;
var _index2$20 = formatLong$11;
var _index3$12 = formatRelative$1$;
var _index4$11 = localize$_;
var _index5$11 = match$_;

/**
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */
(eo.eo = {
  code: "eo",
  formatDistance: _index$48.formatDistance,
  formatLong: _index2$20.formatLong,
  formatRelative: _index3$12.formatRelative,
  localize: _index4$11.localize,
  match: _index5$11.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var es = {};

var formatDistance$1X = {};

formatDistance$1X.formatDistance = void 0;

const formatDistanceLocale$Y = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos",
  },

  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos",
  },

  halfAMinute: "medio minuto",

  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos",
  },

  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos",
  },

  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas",
  },

  xHours: {
    one: "1 hora",
    other: "{{count}} horas",
  },

  xDays: {
    one: "1 día",
    other: "{{count}} días",
  },

  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas",
  },

  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas",
  },

  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses",
  },

  xMonths: {
    one: "1 mes",
    other: "{{count}} meses",
  },

  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años",
  },

  xYears: {
    one: "1 año",
    other: "{{count}} años",
  },

  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años",
  },

  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años",
  },
};

const formatDistance$1W = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$Y[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "en " + result;
    } else {
      return "hace " + result;
    }
  }

  return result;
};
formatDistance$1X.formatDistance = formatDistance$1W;

var formatLong$10 = {};

formatLong$10.formatLong = void 0;
var _index$47 = buildFormatLongFn$1;

const dateFormats$10 = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats$10 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$10 = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$10.formatLong = {
  date: (0, _index$47.buildFormatLongFn)({
    formats: dateFormats$10,
    defaultWidth: "full",
  }),

  time: (0, _index$47.buildFormatLongFn)({
    formats: timeFormats$10,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$47.buildFormatLongFn)({
    formats: dateTimeFormats$10,
    defaultWidth: "full",
  }),
});

var formatRelative$1Z = {};

formatRelative$1Z.formatRelative = void 0;

const formatRelativeLocale$_ = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P",
};

const formatRelativeLocalePlural$2 = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P",
};

const formatRelative$1Y = (token, date, _baseDate, _options) => {
  if (date.getHours() !== 1) {
    return formatRelativeLocalePlural$2[token];
  } else {
    return formatRelativeLocale$_[token];
  }
};
formatRelative$1Z.formatRelative = formatRelative$1Y;

var localize$Z = {};

localize$Z.localize = void 0;
var _index$46 = buildLocalizeFn$1;

const eraValues$Z = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"],
};

const quarterValues$Z = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"],
};

const monthValues$Z = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic",
  ],

  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ],
};

const dayValues$Z = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado",
  ],
};

const dayPeriodValues$Z = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche",
  },
};

const formattingDayPeriodValues$M = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche",
  },
};

const ordinalNumber$Z = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "º";
};

(localize$Z.localize = {
  ordinalNumber: ordinalNumber$Z,

  era: (0, _index$46.buildLocalizeFn)({
    values: eraValues$Z,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$46.buildLocalizeFn)({
    values: quarterValues$Z,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1,
  }),

  month: (0, _index$46.buildLocalizeFn)({
    values: monthValues$Z,
    defaultWidth: "wide",
  }),

  day: (0, _index$46.buildLocalizeFn)({
    values: dayValues$Z,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$46.buildLocalizeFn)({
    values: dayPeriodValues$Z,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$M,
    defaultFormattingWidth: "wide",
  }),
});

var match$Z = {};

match$Z.match = void 0;
var _index$45 = buildMatchPatternFn$1;
var _index2$1$ = buildMatchFn$1;

const matchOrdinalNumberPattern$Z = /^(\d+)(º)?/i;
const parseOrdinalNumberPattern$Z = /\d+/i;

const matchEraPatterns$Z = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i,
};
const parseEraPatterns$Z = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i,
  ],
};

const matchQuarterPatterns$Z = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i,
};
const parseQuarterPatterns$Z = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$Z = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
};
const parseMonthPatterns$Z = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i,
  ],
};

const matchDayPatterns$Z = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i,
};
const parseDayPatterns$Z = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i],
};

const matchDayPeriodPatterns$Z = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i,
};
const parseDayPeriodPatterns$Z = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i,
  },
};

(match$Z.match = {
  ordinalNumber: (0, _index$45.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$Z,
    parsePattern: parseOrdinalNumberPattern$Z,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: (0, _index2$1$.buildMatchFn)({
    matchPatterns: matchEraPatterns$Z,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$Z,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index2$1$.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$Z,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$Z,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index2$1$.buildMatchFn)({
    matchPatterns: matchMonthPatterns$Z,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$Z,
    defaultParseWidth: "any",
  }),

  day: (0, _index2$1$.buildMatchFn)({
    matchPatterns: matchDayPatterns$Z,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$Z,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index2$1$.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$Z,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$Z,
    defaultParseWidth: "any",
  }),
});

es.es = void 0;
var _index$44 = formatDistance$1X;
var _index2$1_ = formatLong$10;
var _index3$11 = formatRelative$1Z;
var _index4$10 = localize$Z;
var _index5$10 = match$Z;

/**
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto](https://github.com/juanangosto)
 * @author Guillermo Grau [@guigrpa](https://github.com/guigrpa)
 * @author Fernando Agüero [@fjaguero](https://github.com/fjaguero)
 * @author Gastón Haro [@harogaston](https://github.com/harogaston)
 * @author Yago Carballo [@YagoCarballo](https://github.com/YagoCarballo)
 */
(es.es = {
  code: "es",
  formatDistance: _index$44.formatDistance,
  formatLong: _index2$1_.formatLong,
  formatRelative: _index3$11.formatRelative,
  localize: _index4$10.localize,
  match: _index5$10.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var et = {};

var formatDistance$1V = {};

formatDistance$1V.formatDistance = void 0;

const formatDistanceLocale$X = {
  lessThanXSeconds: {
    standalone: {
      one: "vähem kui üks sekund",
      other: "vähem kui {{count}} sekundit",
    },
    withPreposition: {
      one: "vähem kui ühe sekundi",
      other: "vähem kui {{count}} sekundi",
    },
  },

  xSeconds: {
    standalone: {
      one: "üks sekund",
      other: "{{count}} sekundit",
    },
    withPreposition: {
      one: "ühe sekundi",
      other: "{{count}} sekundi",
    },
  },

  halfAMinute: {
    standalone: "pool minutit",
    withPreposition: "poole minuti",
  },

  lessThanXMinutes: {
    standalone: {
      one: "vähem kui üks minut",
      other: "vähem kui {{count}} minutit",
    },
    withPreposition: {
      one: "vähem kui ühe minuti",
      other: "vähem kui {{count}} minuti",
    },
  },

  xMinutes: {
    standalone: {
      one: "üks minut",
      other: "{{count}} minutit",
    },
    withPreposition: {
      one: "ühe minuti",
      other: "{{count}} minuti",
    },
  },

  aboutXHours: {
    standalone: {
      one: "umbes üks tund",
      other: "umbes {{count}} tundi",
    },
    withPreposition: {
      one: "umbes ühe tunni",
      other: "umbes {{count}} tunni",
    },
  },

  xHours: {
    standalone: {
      one: "üks tund",
      other: "{{count}} tundi",
    },
    withPreposition: {
      one: "ühe tunni",
      other: "{{count}} tunni",
    },
  },

  xDays: {
    standalone: {
      one: "üks päev",
      other: "{{count}} päeva",
    },
    withPreposition: {
      one: "ühe päeva",
      other: "{{count}} päeva",
    },
  },

  aboutXWeeks: {
    standalone: {
      one: "umbes üks nädal",
      other: "umbes {{count}} nädalat",
    },
    withPreposition: {
      one: "umbes ühe nädala",
      other: "umbes {{count}} nädala",
    },
  },

  xWeeks: {
    standalone: {
      one: "üks nädal",
      other: "{{count}} nädalat",
    },
    withPreposition: {
      one: "ühe nädala",
      other: "{{count}} nädala",
    },
  },

  aboutXMonths: {
    standalone: {
      one: "umbes üks kuu",
      other: "umbes {{count}} kuud",
    },
    withPreposition: {
      one: "umbes ühe kuu",
      other: "umbes {{count}} kuu",
    },
  },

  xMonths: {
    standalone: {
      one: "üks kuu",
      other: "{{count}} kuud",
    },
    withPreposition: {
      one: "ühe kuu",
      other: "{{count}} kuu",
    },
  },

  aboutXYears: {
    standalone: {
      one: "umbes üks aasta",
      other: "umbes {{count}} aastat",
    },
    withPreposition: {
      one: "umbes ühe aasta",
      other: "umbes {{count}} aasta",
    },
  },

  xYears: {
    standalone: {
      one: "üks aasta",
      other: "{{count}} aastat",
    },
    withPreposition: {
      one: "ühe aasta",
      other: "{{count}} aasta",
    },
  },

  overXYears: {
    standalone: {
      one: "rohkem kui üks aasta",
      other: "rohkem kui {{count}} aastat",
    },
    withPreposition: {
      one: "rohkem kui ühe aasta",
      other: "rohkem kui {{count}} aasta",
    },
  },

  almostXYears: {
    standalone: {
      one: "peaaegu üks aasta",
      other: "peaaegu {{count}} aastat",
    },
    withPreposition: {
      one: "peaaegu ühe aasta",
      other: "peaaegu {{count}} aasta",
    },
  },
};

const formatDistance$1U = (token, count, options) => {
  const usageGroup = options?.addSuffix
    ? formatDistanceLocale$X[token].withPreposition
    : formatDistanceLocale$X[token].standalone;

  let result;
  if (typeof usageGroup === "string") {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else {
    result = usageGroup.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " pärast";
    } else {
      return result + " eest";
    }
  }

  return result;
};
formatDistance$1V.formatDistance = formatDistance$1U;

var formatLong$$ = {};

formatLong$$.formatLong = void 0;
var _index$43 = buildFormatLongFn$1;

const dateFormats$$ = {
  full: "EEEE, d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y",
};

const timeFormats$$ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$$ = {
  full: "{{date}} 'kell' {{time}}",
  long: "{{date}} 'kell' {{time}}",
  medium: "{{date}}. {{time}}",
  short: "{{date}}. {{time}}",
};

(formatLong$$.formatLong = {
  date: (0, _index$43.buildFormatLongFn)({
    formats: dateFormats$$,
    defaultWidth: "full",
  }),

  time: (0, _index$43.buildFormatLongFn)({
    formats: timeFormats$$,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$43.buildFormatLongFn)({
    formats: dateTimeFormats$$,
    defaultWidth: "full",
  }),
});

var formatRelative$1X = {};

formatRelative$1X.formatRelative = void 0;

const formatRelativeLocale$Z = {
  lastWeek: "'eelmine' eeee 'kell' p",
  yesterday: "'eile kell' p",
  today: "'täna kell' p",
  tomorrow: "'homme kell' p",
  nextWeek: "'järgmine' eeee 'kell' p",
  other: "P",
};

const formatRelative$1W = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$Z[token];
formatRelative$1X.formatRelative = formatRelative$1W;

var localize$Y = {};

localize$Y.localize = void 0;
var _index$42 = buildLocalizeFn$1;

const eraValues$Y = {
  narrow: ["e.m.a", "m.a.j"],
  abbreviated: ["e.m.a", "m.a.j"],
  wide: ["enne meie ajaarvamist", "meie ajaarvamise järgi"],
};

const quarterValues$Y = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"],
};

const monthValues$Y = {
  narrow: ["J", "V", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jaan",
    "veebr",
    "märts",
    "apr",
    "mai",
    "juuni",
    "juuli",
    "aug",
    "sept",
    "okt",
    "nov",
    "dets",
  ],

  wide: [
    "jaanuar",
    "veebruar",
    "märts",
    "aprill",
    "mai",
    "juuni",
    "juuli",
    "august",
    "september",
    "oktoober",
    "november",
    "detsember",
  ],
};

const dayValues$Y = {
  narrow: ["P", "E", "T", "K", "N", "R", "L"],
  short: ["P", "E", "T", "K", "N", "R", "L"],
  abbreviated: [
    "pühap.",
    "esmasp.",
    "teisip.",
    "kolmap.",
    "neljap.",
    "reede.",
    "laup.",
  ],

  wide: [
    "pühapäev",
    "esmaspäev",
    "teisipäev",
    "kolmapäev",
    "neljapäev",
    "reede",
    "laupäev",
  ],
};

const dayPeriodValues$Y = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö",
  },
};

const formattingDayPeriodValues$L = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel",
  },
};

const ordinalNumber$Y = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$Y.localize = {
  ordinalNumber: ordinalNumber$Y,

  era: (0, _index$42.buildLocalizeFn)({
    values: eraValues$Y,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$42.buildLocalizeFn)({
    values: quarterValues$Y,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$42.buildLocalizeFn)({
    values: monthValues$Y,
    defaultWidth: "wide",
    formattingValues: monthValues$Y,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$42.buildLocalizeFn)({
    values: dayValues$Y,
    defaultWidth: "wide",
    formattingValues: dayValues$Y,
    defaultFormattingWidth: "wide",
  }),

  dayPeriod: (0, _index$42.buildLocalizeFn)({
    values: dayPeriodValues$Y,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$L,
    defaultFormattingWidth: "wide",
  }),
});

var match$Y = {};

match$Y.match = void 0;

var _index$41 = buildMatchFn$1;
var _index2$1Z = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$Y = /^\d+\./i;
const parseOrdinalNumberPattern$Y = /\d+/i;

const matchEraPatterns$Y = {
  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i,
};
const parseEraPatterns$Y = {
  any: [/^e/i, /^(m|p)/i],
};

const matchQuarterPatterns$Y = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](\.)? kvartal/i,
};
const parseQuarterPatterns$Y = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$Y = {
  narrow: /^[jvmasond]/i,
  abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
  wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i,
};
const parseMonthPatterns$Y = {
  narrow: [
    /^j/i,
    /^v/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^v/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^juun/i,
    /^juul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$Y = {
  narrow: /^[petknrl]/i,
  short: /^[petknrl]/i,
  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
  wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i,
};
const parseDayPatterns$Y = {
  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i],
};

const matchDayPeriodPatterns$Y = {
  any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i,
};
const parseDayPeriodPatterns$Y = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^keskö/i,
    noon: /^keskp/i,
    morning: /hommik/i,
    afternoon: /pärastlõuna/i,
    evening: /õhtu/i,
    night: /öö/i,
  },
};

(match$Y.match = {
  ordinalNumber: (0, _index2$1Z.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$Y,
    parsePattern: parseOrdinalNumberPattern$Y,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$41.buildMatchFn)({
    matchPatterns: matchEraPatterns$Y,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$Y,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$41.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$Y,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$Y,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$41.buildMatchFn)({
    matchPatterns: matchMonthPatterns$Y,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$Y,
    defaultParseWidth: "any",
  }),

  day: (0, _index$41.buildMatchFn)({
    matchPatterns: matchDayPatterns$Y,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$Y,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$41.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$Y,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$Y,
    defaultParseWidth: "any",
  }),
});

et.et = void 0;
var _index$40 = formatDistance$1V;
var _index2$1Y = formatLong$$;
var _index3$10 = formatRelative$1X;
var _index4$$ = localize$Y;
var _index5$$ = match$Y;

/**
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit](https://github.com/priithansen)
 */
(et.et = {
  code: "et",
  formatDistance: _index$40.formatDistance,
  formatLong: _index2$1Y.formatLong,
  formatRelative: _index3$10.formatRelative,
  localize: _index4$$.localize,
  match: _index5$$.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var eu = {};

var formatDistance$1T = {};

formatDistance$1T.formatDistance = void 0;

const formatDistanceLocale$W = {
  lessThanXSeconds: {
    one: "segundo bat baino gutxiago",
    other: "{{count}} segundo baino gutxiago",
  },

  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundo",
  },

  halfAMinute: "minutu erdi",

  lessThanXMinutes: {
    one: "minutu bat baino gutxiago",
    other: "{{count}} minutu baino gutxiago",
  },

  xMinutes: {
    one: "1 minutu",
    other: "{{count}} minutu",
  },

  aboutXHours: {
    one: "1 ordu gutxi gorabehera",
    other: "{{count}} ordu gutxi gorabehera",
  },

  xHours: {
    one: "1 ordu",
    other: "{{count}} ordu",
  },

  xDays: {
    one: "1 egun",
    other: "{{count}} egun",
  },

  aboutXWeeks: {
    one: "aste 1 inguru",
    other: "{{count}} aste inguru",
  },

  xWeeks: {
    one: "1 aste",
    other: "{{count}} astean",
  },

  aboutXMonths: {
    one: "1 hilabete gutxi gorabehera",
    other: "{{count}} hilabete gutxi gorabehera",
  },

  xMonths: {
    one: "1 hilabete",
    other: "{{count}} hilabete",
  },

  aboutXYears: {
    one: "1 urte gutxi gorabehera",
    other: "{{count}} urte gutxi gorabehera",
  },

  xYears: {
    one: "1 urte",
    other: "{{count}} urte",
  },

  overXYears: {
    one: "1 urte baino gehiago",
    other: "{{count}} urte baino gehiago",
  },

  almostXYears: {
    one: "ia 1 urte",
    other: "ia {{count}} urte",
  },
};

const formatDistance$1S = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$W[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "en " + result;
    } else {
      return "duela " + result;
    }
  }

  return result;
};
formatDistance$1T.formatDistance = formatDistance$1S;

var formatLong$_ = {};

formatLong$_.formatLong = void 0;
var _index$3$ = buildFormatLongFn$1;

const dateFormats$_ = {
  full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
  long: "y'ko' MMMM'ren' d'a'",
  medium: "y MMM d",
  short: "yy/MM/dd",
};

const timeFormats$_ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$_ = {
  full: "{{date}} 'tan' {{time}}",
  long: "{{date}} 'tan' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$_.formatLong = {
  date: (0, _index$3$.buildFormatLongFn)({
    formats: dateFormats$_,
    defaultWidth: "full",
  }),

  time: (0, _index$3$.buildFormatLongFn)({
    formats: timeFormats$_,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3$.buildFormatLongFn)({
    formats: dateTimeFormats$_,
    defaultWidth: "full",
  }),
});

var formatRelative$1V = {};

formatRelative$1V.formatRelative = void 0;

const formatRelativeLocale$Y = {
  lastWeek: "'joan den' eeee, LT",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P",
};

const formatRelativeLocalePlural$1 = {
  lastWeek: "'joan den' eeee, p",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P",
};

const formatRelative$1U = (token, date) => {
  if (date.getHours() !== 1) {
    return formatRelativeLocalePlural$1[token];
  }
  return formatRelativeLocale$Y[token];
};
formatRelative$1V.formatRelative = formatRelative$1U;

var localize$X = {};

localize$X.localize = void 0;
var _index$3_ = buildLocalizeFn$1;

const eraValues$X = {
  narrow: ["k.a.", "k.o."],
  abbreviated: ["k.a.", "k.o."],
  wide: ["kristo aurretik", "kristo ondoren"],
};

const quarterValues$X = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1H", "2H", "3H", "4H"],
  wide: [
    "1. hiruhilekoa",
    "2. hiruhilekoa",
    "3. hiruhilekoa",
    "4. hiruhilekoa",
  ],
};

const monthValues$X = {
  narrow: ["u", "o", "m", "a", "m", "e", "u", "a", "i", "u", "a", "a"],
  abbreviated: [
    "urt",
    "ots",
    "mar",
    "api",
    "mai",
    "eka",
    "uzt",
    "abu",
    "ira",
    "urr",
    "aza",
    "abe",
  ],

  wide: [
    "urtarrila",
    "otsaila",
    "martxoa",
    "apirila",
    "maiatza",
    "ekaina",
    "uztaila",
    "abuztua",
    "iraila",
    "urria",
    "azaroa",
    "abendua",
  ],
};

const dayValues$X = {
  narrow: ["i", "a", "a", "a", "o", "o", "l"],
  short: ["ig", "al", "as", "az", "og", "or", "lr"],
  abbreviated: ["iga", "ast", "ast", "ast", "ost", "ost", "lar"],
  wide: [
    "igandea",
    "astelehena",
    "asteartea",
    "asteazkena",
    "osteguna",
    "ostirala",
    "larunbata",
  ],
};

const dayPeriodValues$X = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua",
  },
};

const formattingDayPeriodValues$K = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean",
  },
};

const ordinalNumber$X = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$X.localize = {
  ordinalNumber: ordinalNumber$X,

  era: (0, _index$3_.buildLocalizeFn)({
    values: eraValues$X,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3_.buildLocalizeFn)({
    values: quarterValues$X,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3_.buildLocalizeFn)({
    values: monthValues$X,
    defaultWidth: "wide",
  }),

  day: (0, _index$3_.buildLocalizeFn)({
    values: dayValues$X,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3_.buildLocalizeFn)({
    values: dayPeriodValues$X,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$K,
    defaultFormattingWidth: "wide",
  }),
});

var match$X = {};

match$X.match = void 0;

var _index$3Z = buildMatchFn$1;
var _index2$1X = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$X = /^(\d+)(.)?/i;
const parseOrdinalNumberPattern$X = /\d+/i;

const matchEraPatterns$X = {
  narrow: /^(k.a.|k.o.)/i,
  abbreviated: /^(k.a.|k.o.)/i,
  wide: /^(kristo aurretik|kristo ondoren)/i,
};
const parseEraPatterns$X = {
  narrow: [/^k.a./i, /^k.o./i],
  abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
  wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i],
};

const matchQuarterPatterns$X = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]H/i,
  wide: /^[1234](.)? hiruhilekoa/i,
};
const parseQuarterPatterns$X = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$X = {
  narrow: /^[uomaei]/i,
  abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
  wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i,
};
const parseMonthPatterns$X = {
  narrow: [
    /^u/i,
    /^o/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^e/i,
    /^u/i,
    /^a/i,
    /^i/i,
    /^u/i,
    /^a/i,
    /^a/i,
  ],

  any: [
    /^urt/i,
    /^ots/i,
    /^mar/i,
    /^api/i,
    /^mai/i,
    /^eka/i,
    /^uzt/i,
    /^abu/i,
    /^ira/i,
    /^urr/i,
    /^aza/i,
    /^abe/i,
  ],
};

const matchDayPatterns$X = {
  narrow: /^[iaol]/i,
  short: /^(ig|al|as|az|og|or|lr)/i,
  abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
  wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i,
};
const parseDayPatterns$X = {
  narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
  short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
  abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],

  wide: [
    /^igandea/i,
    /^astelehena/i,
    /^asteartea/i,
    /^asteazkena/i,
    /^osteguna/i,
    /^ostirala/i,
    /^larunbata/i,
  ],
};

const matchDayPeriodPatterns$X = {
  narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
  any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
};
const parseDayPeriodPatterns$X = {
  narrow: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^ge/i,
    noon: /^eg/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i,
  },
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^gauerdia/i,
    noon: /^eguerdia/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i,
  },
};

(match$X.match = {
  ordinalNumber: (0, _index2$1X.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$X,
    parsePattern: parseOrdinalNumberPattern$X,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$3Z.buildMatchFn)({
    matchPatterns: matchEraPatterns$X,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$X,
    defaultParseWidth: "wide",
  }),

  quarter: (0, _index$3Z.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$X,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$X,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3Z.buildMatchFn)({
    matchPatterns: matchMonthPatterns$X,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$X,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3Z.buildMatchFn)({
    matchPatterns: matchDayPatterns$X,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$X,
    defaultParseWidth: "wide",
  }),

  dayPeriod: (0, _index$3Z.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$X,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$X,
    defaultParseWidth: "any",
  }),
});

eu.eu = void 0;
var _index$3Y = formatDistance$1T;
var _index2$1W = formatLong$_;
var _index3$$ = formatRelative$1V;
var _index4$_ = localize$X;
var _index5$_ = match$X;

/**
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom](https://github.com/JacobSoderblom)
 */
(eu.eu = {
  code: "eu",
  formatDistance: _index$3Y.formatDistance,
  formatLong: _index2$1W.formatLong,
  formatRelative: _index3$$.formatRelative,
  localize: _index4$_.localize,
  match: _index5$_.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var faIR = {};

var formatDistance$1R = {};

formatDistance$1R.formatDistance = void 0;

const formatDistanceLocale$V = {
  lessThanXSeconds: {
    one: "کمتر از یک ثانیه",
    other: "کمتر از {{count}} ثانیه",
  },

  xSeconds: {
    one: "1 ثانیه",
    other: "{{count}} ثانیه",
  },

  halfAMinute: "نیم دقیقه",

  lessThanXMinutes: {
    one: "کمتر از یک دقیقه",
    other: "کمتر از {{count}} دقیقه",
  },

  xMinutes: {
    one: "1 دقیقه",
    other: "{{count}} دقیقه",
  },

  aboutXHours: {
    one: "حدود 1 ساعت",
    other: "حدود {{count}} ساعت",
  },

  xHours: {
    one: "1 ساعت",
    other: "{{count}} ساعت",
  },

  xDays: {
    one: "1 روز",
    other: "{{count}} روز",
  },

  aboutXWeeks: {
    one: "حدود 1 هفته",
    other: "حدود {{count}} هفته",
  },

  xWeeks: {
    one: "1 هفته",
    other: "{{count}} هفته",
  },

  aboutXMonths: {
    one: "حدود 1 ماه",
    other: "حدود {{count}} ماه",
  },

  xMonths: {
    one: "1 ماه",
    other: "{{count}} ماه",
  },

  aboutXYears: {
    one: "حدود 1 سال",
    other: "حدود {{count}} سال",
  },

  xYears: {
    one: "1 سال",
    other: "{{count}} سال",
  },

  overXYears: {
    one: "بیشتر از 1 سال",
    other: "بیشتر از {{count}} سال",
  },

  almostXYears: {
    one: "نزدیک 1 سال",
    other: "نزدیک {{count}} سال",
  },
};

const formatDistance$1Q = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$V[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "در " + result;
    } else {
      return result + " قبل";
    }
  }

  return result;
};
formatDistance$1R.formatDistance = formatDistance$1Q;

var formatLong$Z = {};

formatLong$Z.formatLong = void 0;
var _index$3X = buildFormatLongFn$1;

const dateFormats$Z = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "yyyy/MM/dd",
};

const timeFormats$Z = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$Z = {
  full: "{{date}} 'در' {{time}}",
  long: "{{date}} 'در' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$Z.formatLong = {
  date: (0, _index$3X.buildFormatLongFn)({
    formats: dateFormats$Z,
    defaultWidth: "full",
  }),

  time: (0, _index$3X.buildFormatLongFn)({
    formats: timeFormats$Z,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3X.buildFormatLongFn)({
    formats: dateTimeFormats$Z,
    defaultWidth: "full",
  }),
});

var formatRelative$1T = {};

formatRelative$1T.formatRelative = void 0;

const formatRelativeLocale$X = {
  lastWeek: "eeee 'گذشته در' p",
  yesterday: "'دیروز در' p",
  today: "'امروز در' p",
  tomorrow: "'فردا در' p",
  nextWeek: "eeee 'در' p",
  other: "P",
};

const formatRelative$1S = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$X[token];
formatRelative$1T.formatRelative = formatRelative$1S;

var localize$W = {};

localize$W.localize = void 0;
var _index$3W = buildLocalizeFn$1;

const eraValues$W = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل از میلاد", "بعد از میلاد"],
};

const quarterValues$W = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["س‌م1", "س‌م2", "س‌م3", "س‌م4"],
  wide: ["سه‌ماهه 1", "سه‌ماهه 2", "سه‌ماهه 3", "سه‌ماهه 4"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$W = {
  narrow: ["ژ", "ف", "م", "آ", "م", "ج", "ج", "آ", "س", "ا", "ن", "د"],
  abbreviated: [
    "ژانـ",
    "فور",
    "مارس",
    "آپر",
    "می",
    "جون",
    "جولـ",
    "آگو",
    "سپتـ",
    "اکتـ",
    "نوامـ",
    "دسامـ",
  ],

  wide: [
    "ژانویه",
    "فوریه",
    "مارس",
    "آپریل",
    "می",
    "جون",
    "جولای",
    "آگوست",
    "سپتامبر",
    "اکتبر",
    "نوامبر",
    "دسامبر",
  ],
};

const dayValues$W = {
  narrow: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
  short: ["1ش", "2ش", "3ش", "4ش", "5ش", "ج", "ش"],
  abbreviated: [
    "یکشنبه",
    "دوشنبه",
    "سه‌شنبه",
    "چهارشنبه",
    "پنجشنبه",
    "جمعه",
    "شنبه",
  ],

  wide: ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"],
};

const dayPeriodValues$W = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش",
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب",
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب",
  },
};

const formattingDayPeriodValues$J = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش",
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب",
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب",
  },
};

const ordinalNumber$W = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$W.localize = {
  ordinalNumber: ordinalNumber$W,

  era: (0, _index$3W.buildLocalizeFn)({
    values: eraValues$W,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3W.buildLocalizeFn)({
    values: quarterValues$W,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3W.buildLocalizeFn)({
    values: monthValues$W,
    defaultWidth: "wide",
  }),

  day: (0, _index$3W.buildLocalizeFn)({
    values: dayValues$W,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3W.buildLocalizeFn)({
    values: dayPeriodValues$W,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$J,
    defaultFormattingWidth: "wide",
  }),
});

var match$W = {};

match$W.match = void 0;

var _index$3V = buildMatchFn$1;
var _index2$1V = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$W = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$W = /\d+/i;

const matchEraPatterns$W = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
  wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i,
};
const parseEraPatterns$W = {
  any: [/^قبل/i, /^بعد/i],
};

const matchQuarterPatterns$W = {
  narrow: /^[1234]/i,
  abbreviated: /^س‌م[1234]/i,
  wide: /^سه‌ماهه [1234]/i,
};
const parseQuarterPatterns$W = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$W = {
  narrow: /^[جژفمآاماسند]/i,
  abbreviated:
    /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
  wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i,
};
const parseMonthPatterns$W = {
  narrow: [
    /^(ژ|ج)/i,
    /^ف/i,
    /^م/i,
    /^(آ|ا)/i,
    /^م/i,
    /^(ژ|ج)/i,
    /^(ج|ژ)/i,
    /^(آ|ا)/i,
    /^س/i,
    /^ا/i,
    /^ن/i,
    /^د/i,
  ],

  any: [
    /^ژا/i,
    /^ف/i,
    /^ما/i,
    /^آپ/i,
    /^(می|مه)/i,
    /^(ژوئن|جون)/i,
    /^(ژوئی|جول)/i,
    /^(اوت|آگ)/i,
    /^س/i,
    /^(اوک|اک)/i,
    /^ن/i,
    /^د/i,
  ],
};

const matchDayPatterns$W = {
  narrow: /^[شیدسچپج]/i,
  short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
  abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
  wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
};
const parseDayPatterns$W = {
  narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [
    /^(ی|1ش|یکشنبه)/i,
    /^(د|2ش|دوشنبه)/i,
    /^(س|3ش|سه‌شنبه)/i,
    /^(چ|4ش|چهارشنبه)/i,
    /^(پ|5ش|پنجشنبه)/i,
    /^(ج|جمعه)/i,
    /^(ش|شنبه)/i,
  ],
};

const matchDayPeriodPatterns$W = {
  narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
  abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
  wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
};
const parseDayPeriodPatterns$W = {
  any: {
    am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
    pm: /^(ب|ب.ظ.|بعدازظهر)/i,
    midnight: /^(‌نیمه‌شب|ن)/i,
    noon: /^(ظ|ظهر)/i,
    morning: /(ص|صبح)/i,
    afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
    evening: /(ع|عصر)/i,
    night: /(ش|شب)/i,
  },
};

(match$W.match = {
  ordinalNumber: (0, _index2$1V.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$W,
    parsePattern: parseOrdinalNumberPattern$W,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$3V.buildMatchFn)({
    matchPatterns: matchEraPatterns$W,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$W,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3V.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$W,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$W,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3V.buildMatchFn)({
    matchPatterns: matchMonthPatterns$W,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$W,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3V.buildMatchFn)({
    matchPatterns: matchDayPatterns$W,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$W,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3V.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$W,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$W,
    defaultParseWidth: "any",
  }),
});

faIR.faIR = void 0;
var _index$3U = formatDistance$1R;
var _index2$1U = formatLong$Z;
var _index3$_ = formatRelative$1T;
var _index4$Z = localize$W;
var _index5$Z = match$W;

/**
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za](https://github.com/mort3za)
 */
(faIR.faIR = {
  code: "fa-IR",
  formatDistance: _index$3U.formatDistance,
  formatLong: _index2$1U.formatLong,
  formatRelative: _index3$_.formatRelative,
  localize: _index4$Z.localize,
  match: _index5$Z.match,
  options: {
    weekStartsOn: 6 /* Saturday */,
    firstWeekContainsDate: 1,
  },
});

var fi = {};

var formatDistance$1P = {};

formatDistance$1P.formatDistance = void 0;

function futureSeconds(text) {
  return text.replace(/sekuntia?/, "sekunnin");
}

function futureMinutes(text) {
  return text.replace(/minuuttia?/, "minuutin");
}

function futureHours(text) {
  return text.replace(/tuntia?/, "tunnin");
}

function futureDays(text) {
  return text.replace(/päivää?/, "päivän");
}

function futureWeeks(text) {
  return text.replace(/(viikko|viikkoa)/, "viikon");
}

function futureMonths(text) {
  return text.replace(/(kuukausi|kuukautta)/, "kuukauden");
}

function futureYears(text) {
  return text.replace(/(vuosi|vuotta)/, "vuoden");
}

const formatDistanceLocale$U = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: futureSeconds,
  },

  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: futureSeconds,
  },

  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: (_text) => "puolen minuutin",
  },

  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: futureMinutes,
  },

  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: futureMinutes,
  },

  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: futureHours,
  },

  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: futureHours,
  },

  xDays: {
    one: "päivä",
    other: "{{count}} päivää",
    futureTense: futureDays,
  },

  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: futureWeeks,
  },

  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: futureWeeks,
  },

  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: futureMonths,
  },

  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: futureMonths,
  },

  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: futureYears,
  },

  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: futureYears,
  },

  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: futureYears,
  },

  almostXYears: {
    one: "lähes vuosi",
    other: "lähes {{count}} vuotta",
    futureTense: futureYears,
  },
};

const formatDistance$1O = (token, count, options) => {
  const tokenValue = formatDistanceLocale$U[token];
  const result =
    count === 1
      ? tokenValue.one
      : tokenValue.other.replace("{{count}}", String(count));

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return tokenValue.futureTense(result) + " kuluttua";
    } else {
      return result + " sitten";
    }
  }

  return result;
};
formatDistance$1P.formatDistance = formatDistance$1O;

var formatLong$Y = {};

formatLong$Y.formatLong = void 0;
var _index$3T = buildFormatLongFn$1;

const dateFormats$Y = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y",
};

const timeFormats$Y = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm",
};

const dateTimeFormats$Y = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$Y.formatLong = {
  date: (0, _index$3T.buildFormatLongFn)({
    formats: dateFormats$Y,
    defaultWidth: "full",
  }),

  time: (0, _index$3T.buildFormatLongFn)({
    formats: timeFormats$Y,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3T.buildFormatLongFn)({
    formats: dateTimeFormats$Y,
    defaultWidth: "full",
  }),
});

var formatRelative$1R = {};

formatRelative$1R.formatRelative = void 0;

const formatRelativeLocale$W = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P",
};

const formatRelative$1Q = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$W[token];
formatRelative$1R.formatRelative = formatRelative$1Q;

var localize$V = {};

localize$V.localize = void 0;
var _index$3S = buildLocalizeFn$1;

const eraValues$V = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "jälkeen ajanlaskun alun"],
};

const quarterValues$V = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"],
};

const monthValues$V = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: [
    "tammi",
    "helmi",
    "maalis",
    "huhti",
    "touko",
    "kesä",
    "heinä",
    "elo",
    "syys",
    "loka",
    "marras",
    "joulu",
  ],

  wide: [
    "tammikuu",
    "helmikuu",
    "maaliskuu",
    "huhtikuu",
    "toukokuu",
    "kesäkuu",
    "heinäkuu",
    "elokuu",
    "syyskuu",
    "lokakuu",
    "marraskuu",
    "joulukuu",
  ],
};

const formattingMonthValues$b = {
  narrow: monthValues$V.narrow,
  abbreviated: monthValues$V.abbreviated,
  wide: [
    "tammikuuta",
    "helmikuuta",
    "maaliskuuta",
    "huhtikuuta",
    "toukokuuta",
    "kesäkuuta",
    "heinäkuuta",
    "elokuuta",
    "syyskuuta",
    "lokakuuta",
    "marraskuuta",
    "joulukuuta",
  ],
};

const dayValues$V = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],

  wide: [
    "sunnuntai",
    "maanantai",
    "tiistai",
    "keskiviikko",
    "torstai",
    "perjantai",
    "lauantai",
  ],
};

const formattingDayValues$3 = {
  narrow: dayValues$V.narrow,
  short: dayValues$V.short,
  abbreviated: dayValues$V.abbreviated,
  wide: [
    "sunnuntaina",
    "maanantaina",
    "tiistaina",
    "keskiviikkona",
    "torstaina",
    "perjantaina",
    "lauantaina",
  ],
};

const dayPeriodValues$V = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä",
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä",
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyöllä",
    noon: "keskipäivällä",
    morning: "aamupäivällä",
    afternoon: "iltapäivällä",
    evening: "illalla",
    night: "yöllä",
  },
};

const ordinalNumber$V = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$V.localize = {
  ordinalNumber: ordinalNumber$V,

  era: (0, _index$3S.buildLocalizeFn)({
    values: eraValues$V,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3S.buildLocalizeFn)({
    values: quarterValues$V,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3S.buildLocalizeFn)({
    values: monthValues$V,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$b,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$3S.buildLocalizeFn)({
    values: dayValues$V,
    defaultWidth: "wide",
    formattingValues: formattingDayValues$3,
    defaultFormattingWidth: "wide",
  }),

  dayPeriod: (0, _index$3S.buildLocalizeFn)({
    values: dayPeriodValues$V,
    defaultWidth: "wide",
  }),
});

var match$V = {};

match$V.match = void 0;

var _index$3R = buildMatchFn$1;
var _index2$1T = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$V = /^(\d+)(\.)/i;
const parseOrdinalNumberPattern$V = /\d+/i;

const matchEraPatterns$V = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i,
};
const parseEraPatterns$V = {
  any: [/^e/i, /^j/i],
};

const matchQuarterPatterns$V = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i,
};
const parseQuarterPatterns$V = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$V = {
  narrow: /^[thmkeslj]/i,
  abbreviated:
    /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i,
};
const parseMonthPatterns$V = {
  narrow: [
    /^t/i,
    /^h/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^k/i,
    /^h/i,
    /^e/i,
    /^s/i,
    /^l/i,
    /^m/i,
    /^j/i,
  ],

  any: [
    /^ta/i,
    /^hel/i,
    /^maa/i,
    /^hu/i,
    /^to/i,
    /^k/i,
    /^hei/i,
    /^e/i,
    /^s/i,
    /^l/i,
    /^mar/i,
    /^j/i,
  ],
};

const matchDayPatterns$V = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i,
};
const parseDayPatterns$V = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i],
};

const matchDayPeriodPatterns$V = {
  narrow:
    /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
};
const parseDayPeriodPatterns$V = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i,
  },
};

(match$V.match = {
  ordinalNumber: (0, _index2$1T.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$V,
    parsePattern: parseOrdinalNumberPattern$V,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$3R.buildMatchFn)({
    matchPatterns: matchEraPatterns$V,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$V,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3R.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$V,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$V,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3R.buildMatchFn)({
    matchPatterns: matchMonthPatterns$V,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$V,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3R.buildMatchFn)({
    matchPatterns: matchDayPatterns$V,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$V,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3R.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$V,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$V,
    defaultParseWidth: "any",
  }),
});

fi.fi = void 0;
var _index$3Q = formatDistance$1P;
var _index2$1S = formatLong$Y;
var _index3$Z = formatRelative$1R;
var _index4$Y = localize$V;
var _index5$Y = match$V;

/**
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe](https://github.com/Pyppe)
 * @author Edo Rivai [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Samu Juvonen [@sjuvonen](https://github.com/sjuvonen)
 */
(fi.fi = {
  code: "fi",
  formatDistance: _index$3Q.formatDistance,
  formatLong: _index2$1S.formatLong,
  formatRelative: _index3$Z.formatRelative,
  localize: _index4$Y.localize,
  match: _index5$Y.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var fr = {};

var formatDistance$1N = {};

formatDistance$1N.formatDistance = void 0;

const formatDistanceLocale$T = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes",
  },

  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes",
  },

  halfAMinute: "30 secondes",

  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes",
  },

  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes",
  },

  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures",
  },

  xHours: {
    one: "1 heure",
    other: "{{count}} heures",
  },

  xDays: {
    one: "1 jour",
    other: "{{count}} jours",
  },

  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines",
  },

  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines",
  },

  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois",
  },

  xMonths: {
    one: "1 mois",
    other: "{{count}} mois",
  },

  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans",
  },

  xYears: {
    one: "1 an",
    other: "{{count}} ans",
  },

  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans",
  },

  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans",
  },
};

const formatDistance$1M = (token, count, options) => {
  let result;
  const form = formatDistanceLocale$T[token];
  if (typeof form === "string") {
    result = form;
  } else if (count === 1) {
    result = form.one;
  } else {
    result = form.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "dans " + result;
    } else {
      return "il y a " + result;
    }
  }

  return result;
};
formatDistance$1N.formatDistance = formatDistance$1M;

var formatLong$X = {};

formatLong$X.formatLong = void 0;
var _index$3P = buildFormatLongFn$1;

const dateFormats$X = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats$X = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$X = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$X.formatLong = {
  date: (0, _index$3P.buildFormatLongFn)({
    formats: dateFormats$X,
    defaultWidth: "full",
  }),

  time: (0, _index$3P.buildFormatLongFn)({
    formats: timeFormats$X,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3P.buildFormatLongFn)({
    formats: dateTimeFormats$X,
    defaultWidth: "full",
  }),
});

var formatRelative$1P = {};

formatRelative$1P.formatRelative = void 0;

const formatRelativeLocale$V = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P",
};

const formatRelative$1O = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$V[token];
formatRelative$1P.formatRelative = formatRelative$1O;

var localize$U = {};

localize$U.localize = void 0;
var _index$3O = buildLocalizeFn$1;

const eraValues$U = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"],
};

const quarterValues$U = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"],
};

const monthValues$U = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc.",
  ],

  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
  ],
};

const dayValues$U = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],

  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi",
  ],
};

const dayPeriodValues$U = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat.",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin",
  },
};

const ordinalNumber$U = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = options?.unit;

  if (number === 0) return "0";

  const feminineUnits = ["year", "week", "hour", "minute", "second"];
  let suffix;

  if (number === 1) {
    suffix = unit && feminineUnits.includes(unit) ? "ère" : "er";
  } else {
    suffix = "ème";
  }

  return number + suffix;
};

const LONG_MONTHS_TOKENS = ["MMM", "MMMM"];

(localize$U.localize = {
  preprocessor: (date, parts) => {
    // Replaces the `do` tokens with `d` when used with long month tokens and the day of the month is greater than one.
    // Use case "do MMMM" => 1er août, 29 août
    // see https://github.com/date-fns/date-fns/issues/1391

    if (date.getDate() === 1) return parts;

    const hasLongMonthToken = parts.some(
      (part) => part.isToken && LONG_MONTHS_TOKENS.includes(part.value),
    );

    if (!hasLongMonthToken) return parts;

    return parts.map((part) =>
      part.isToken && part.value === "do"
        ? { isToken: true, value: "d" }
        : part,
    );
  },

  ordinalNumber: ordinalNumber$U,

  era: (0, _index$3O.buildLocalizeFn)({
    values: eraValues$U,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3O.buildLocalizeFn)({
    values: quarterValues$U,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3O.buildLocalizeFn)({
    values: monthValues$U,
    defaultWidth: "wide",
  }),

  day: (0, _index$3O.buildLocalizeFn)({
    values: dayValues$U,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3O.buildLocalizeFn)({
    values: dayPeriodValues$U,
    defaultWidth: "wide",
  }),
});

var match$U = {};

match$U.match = void 0;

var _index$3N = buildMatchFn$1;
var _index2$1R = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$U = /^(\d+)(ième|ère|ème|er|e)?/i;
const parseOrdinalNumberPattern$U = /\d+/i;

const matchEraPatterns$U = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i,
};
const parseEraPatterns$U = {
  any: [/^av/i, /^ap/i],
};

const matchQuarterPatterns$U = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i,
};
const parseQuarterPatterns$U = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$U = {
  narrow: /^[jfmasond]/i,
  abbreviated:
    /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
};
const parseMonthPatterns$U = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$U = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i,
};
const parseDayPatterns$U = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i],
};

const matchDayPeriodPatterns$U = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i,
};
const parseDayPeriodPatterns$U = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i,
  },
};

(match$U.match = {
  ordinalNumber: (0, _index2$1R.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$U,
    parsePattern: parseOrdinalNumberPattern$U,
    valueCallback: (value) => parseInt(value),
  }),

  era: (0, _index$3N.buildMatchFn)({
    matchPatterns: matchEraPatterns$U,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$U,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3N.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$U,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$U,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3N.buildMatchFn)({
    matchPatterns: matchMonthPatterns$U,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$U,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3N.buildMatchFn)({
    matchPatterns: matchDayPatterns$U,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$U,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3N.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$U,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$U,
    defaultParseWidth: "any",
  }),
});

fr.fr = void 0;
var _index$3M = formatDistance$1N;
var _index2$1Q = formatLong$X;
var _index3$Y = formatRelative$1P;
var _index4$X = localize$U;
var _index5$X = match$U;

/**
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 */
(fr.fr = {
  code: "fr",
  formatDistance: _index$3M.formatDistance,
  formatLong: _index2$1Q.formatLong,
  formatRelative: _index3$Y.formatRelative,
  localize: _index4$X.localize,
  match: _index5$X.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var frCA = {};

var formatLong$W = {};

formatLong$W.formatLong = void 0;
var _index$3L = buildFormatLongFn$1;

const dateFormats$W = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "yy-MM-dd",
};

const timeFormats$W = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$W = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$W.formatLong = {
  date: (0, _index$3L.buildFormatLongFn)({
    formats: dateFormats$W,
    defaultWidth: "full",
  }),

  time: (0, _index$3L.buildFormatLongFn)({
    formats: timeFormats$W,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3L.buildFormatLongFn)({
    formats: dateTimeFormats$W,
    defaultWidth: "full",
  }),
});

frCA.frCA = void 0;
var _index$3K = formatDistance$1N;
var _index2$1P = formatRelative$1P;
var _index3$X = localize$U;
var _index4$W = match$U;

var _index5$W = formatLong$W; // Same as fr
// Unique for fr-CA
/**
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 * @author Gabriele Petrioli [@gpetrioli](https://github.com/gpetrioli)
 */
(frCA.frCA = {
  code: "fr-CA",
  formatDistance: _index$3K.formatDistance,
  formatLong: _index5$W.formatLong,
  formatRelative: _index2$1P.formatRelative,
  localize: _index3$X.localize,
  match: _index4$W.match,

  // Unique for fr-CA
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var frCH = {};

var formatLong$V = {};

formatLong$V.formatLong = void 0;
var _index$3J = buildFormatLongFn$1;

const dateFormats$V = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y",
};

const timeFormats$V = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$V = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$V.formatLong = {
  date: (0, _index$3J.buildFormatLongFn)({
    formats: dateFormats$V,
    defaultWidth: "full",
  }),

  time: (0, _index$3J.buildFormatLongFn)({
    formats: timeFormats$V,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3J.buildFormatLongFn)({
    formats: dateTimeFormats$V,
    defaultWidth: "full",
  }),
});

var formatRelative$1N = {};

formatRelative$1N.formatRelative = void 0;

const formatRelativeLocale$U = {
  lastWeek: "eeee 'la semaine dernière à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'la semaine prochaine à' p",
  other: "P",
};

const formatRelative$1M = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$U[token];
formatRelative$1N.formatRelative = formatRelative$1M;

frCH.frCH = void 0;
var _index$3I = formatDistance$1N;
var _index2$1O = localize$U;
var _index3$W = match$U;

var _index4$V = formatLong$V;
var _index5$V = formatRelative$1N; // Same as fr
// Unique for fr-CH
/**
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau](https://github.com/izeau)
 * @author François B [@fbonzon](https://github.com/fbonzon)
 * @author Van Vuong Ngo [@vanvuongngo](https://github.com/vanvuongngo)
 * @author Alex Hoeing [@dcbn](https://github.com/dcbn)
 */
(frCH.frCH = {
  code: "fr-CH",
  formatDistance: _index$3I.formatDistance,
  formatLong: _index4$V.formatLong,
  formatRelative: _index5$V.formatRelative,
  localize: _index2$1O.localize,
  match: _index3$W.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var fy = {};

var formatDistance$1L = {};

formatDistance$1L.formatDistance = void 0;

const formatDistanceLocale$S = {
  lessThanXSeconds: {
    one: "minder as 1 sekonde",
    other: "minder as {{count}} sekonden",
  },

  xSeconds: {
    one: "1 sekonde",
    other: "{{count}} sekonden",
  },

  halfAMinute: "oardel minút",

  lessThanXMinutes: {
    one: "minder as 1 minút",
    other: "minder as {{count}} minuten",
  },

  xMinutes: {
    one: "1 minút",
    other: "{{count}} minuten",
  },

  aboutXHours: {
    one: "sawat 1 oere",
    other: "sawat {{count}} oere",
  },

  xHours: {
    one: "1 oere",
    other: "{{count}} oere",
  },

  xDays: {
    one: "1 dei",
    other: "{{count}} dagen",
  },

  aboutXWeeks: {
    one: "sawat 1 wike",
    other: "sawat {{count}} wiken",
  },

  xWeeks: {
    one: "1 wike",
    other: "{{count}} wiken",
  },

  aboutXMonths: {
    one: "sawat 1 moanne",
    other: "sawat {{count}} moannen",
  },

  xMonths: {
    one: "1 moanne",
    other: "{{count}} moannen",
  },

  aboutXYears: {
    one: "sawat 1 jier",
    other: "sawat {{count}} jier",
  },

  xYears: {
    one: "1 jier",
    other: "{{count}} jier",
  },

  overXYears: {
    one: "mear as 1 jier",
    other: "mear as {{count}}s jier",
  },

  almostXYears: {
    one: "hast 1 jier",
    other: "hast {{count}} jier",
  },
};

const formatDistance$1K = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$S[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "oer " + result;
    } else {
      return result + " lyn";
    }
  }

  return result;
};
formatDistance$1L.formatDistance = formatDistance$1K;

var formatLong$U = {};

formatLong$U.formatLong = void 0;
var _index$3H = buildFormatLongFn$1;

const dateFormats$U = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y",
};

const timeFormats$U = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$U = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$U.formatLong = {
  date: (0, _index$3H.buildFormatLongFn)({
    formats: dateFormats$U,
    defaultWidth: "full",
  }),

  time: (0, _index$3H.buildFormatLongFn)({
    formats: timeFormats$U,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3H.buildFormatLongFn)({
    formats: dateTimeFormats$U,
    defaultWidth: "full",
  }),
});

var formatRelative$1L = {};

formatRelative$1L.formatRelative = void 0;

const formatRelativeLocale$T = {
  lastWeek: "'ôfrûne' eeee 'om' p",
  yesterday: "'juster om' p",
  today: "'hjoed om' p",
  tomorrow: "'moarn om' p",
  nextWeek: "eeee 'om' p",
  other: "P",
};

const formatRelative$1K = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$T[token];
formatRelative$1L.formatRelative = formatRelative$1K;

var localize$T = {};

localize$T.localize = void 0;
var _index$3G = buildLocalizeFn$1;

const eraValues$T = {
  narrow: ["f.K.", "n.K."],
  abbreviated: ["f.Kr.", "n.Kr."],
  wide: ["foar Kristus", "nei Kristus"],
};

const quarterValues$T = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e fearnsjier", "2e fearnsjier", "3e fearnsjier", "4e fearnsjier"],
};

const monthValues$T = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mai.",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des.",
  ],

  wide: [
    "jannewaris",
    "febrewaris",
    "maart",
    "april",
    "maaie",
    "juny",
    "july",
    "augustus",
    "septimber",
    "oktober",
    "novimber",
    "desimber",
  ],
};

const dayValues$T = {
  narrow: ["s", "m", "t", "w", "t", "f", "s"],
  short: ["si", "mo", "ti", "wo", "to", "fr", "so"],
  abbreviated: ["snein", "moa", "tii", "woa", "ton", "fre", "sneon"],
  wide: [
    "snein",
    "moandei",
    "tiisdei",
    "woansdei",
    "tongersdei",
    "freed",
    "sneon",
  ],
};

const dayPeriodValues$T = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts",
  },
};

const ordinalNumber$T = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "e";
};

(localize$T.localize = {
  ordinalNumber: ordinalNumber$T,

  era: (0, _index$3G.buildLocalizeFn)({
    values: eraValues$T,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3G.buildLocalizeFn)({
    values: quarterValues$T,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3G.buildLocalizeFn)({
    values: monthValues$T,
    defaultWidth: "wide",
  }),

  day: (0, _index$3G.buildLocalizeFn)({
    values: dayValues$T,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3G.buildLocalizeFn)({
    values: dayPeriodValues$T,
    defaultWidth: "wide",
  }),
});

var match$T = {};

match$T.match = void 0;

var _index$3F = buildMatchFn$1;
var _index2$1N = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$T = /^(\d+)e?/i;
const parseOrdinalNumberPattern$T = /\d+/i;

const matchEraPatterns$T = {
  narrow: /^([fn]\.? ?K\.?)/,
  abbreviated: /^([fn]\. ?Kr\.?)/,
  wide: /^((foar|nei) Kristus)/,
};
const parseEraPatterns$T = {
  any: [/^f/, /^n/],
};

const matchQuarterPatterns$T = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e fearnsjier/i,
};

const parseQuarterPatterns$T = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$T = {
  narrow: /^[jfmasond]/i,
  abbreviated:
    /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
  wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i,
};
const parseMonthPatterns$T = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^des/i,
  ],
};

const matchDayPatterns$T = {
  narrow: /^[smtwf]/i,
  short: /^(si|mo|ti|wo|to|fr|so)/i,
  abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
  wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i,
};
const parseDayPatterns$T = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^sn/i, /^mo/i, /^ti/i, /^wo/i, /^to/i, /^fr/i, /^sn/i],
};

const matchDayPeriodPatterns$T = {
  any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i,
};
const parseDayPeriodPatterns$T = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^middei/i,
    morning: /moarns/i,
    afternoon: /^middeis/i,
    evening: /jûns/i,
    night: /nachts/i,
  },
};

(match$T.match = {
  ordinalNumber: (0, _index2$1N.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$T,
    parsePattern: parseOrdinalNumberPattern$T,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$3F.buildMatchFn)({
    matchPatterns: matchEraPatterns$T,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$T,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3F.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$T,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$T,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3F.buildMatchFn)({
    matchPatterns: matchMonthPatterns$T,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$T,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3F.buildMatchFn)({
    matchPatterns: matchDayPatterns$T,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$T,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3F.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$T,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$T,
    defaultParseWidth: "any",
  }),
});

fy.fy = void 0;
var _index$3E = formatDistance$1L;
var _index2$1M = formatLong$U;
var _index3$V = formatRelative$1L;
var _index4$U = localize$T;
var _index5$U = match$T;

/**
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02](https://github.com/damon02)
 */
(fy.fy = {
  code: "fy",
  formatDistance: _index$3E.formatDistance,
  formatLong: _index2$1M.formatLong,
  formatRelative: _index3$V.formatRelative,
  localize: _index4$U.localize,
  match: _index5$U.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var gd = {};

var formatDistance$1J = {};

formatDistance$1J.formatDistance = void 0;

const formatDistanceLocale$R = {
  lessThanXSeconds: {
    one: "nas lugha na diog",
    other: "nas lugha na {{count}} diogan",
  },

  xSeconds: {
    one: "1 diog",
    two: "2 dhiog",
    twenty: "20 diog",
    other: "{{count}} diogan",
  },

  halfAMinute: "leth mhionaid",

  lessThanXMinutes: {
    one: "nas lugha na mionaid",
    other: "nas lugha na {{count}} mionaidean",
  },

  xMinutes: {
    one: "1 mionaid",
    two: "2 mhionaid",
    twenty: "20 mionaid",
    other: "{{count}} mionaidean",
  },

  aboutXHours: {
    one: "mu uair de thìde",
    other: "mu {{count}} uairean de thìde",
  },

  xHours: {
    one: "1 uair de thìde",
    two: "2 uair de thìde",
    twenty: "20 uair de thìde",
    other: "{{count}} uairean de thìde",
  },

  xDays: {
    one: "1 là",
    other: "{{count}} là",
  },

  aboutXWeeks: {
    one: "mu 1 seachdain",
    other: "mu {{count}} seachdainean",
  },

  xWeeks: {
    one: "1 seachdain",
    other: "{{count}} seachdainean",
  },

  aboutXMonths: {
    one: "mu mhìos",
    other: "mu {{count}} mìosan",
  },

  xMonths: {
    one: "1 mìos",
    other: "{{count}} mìosan",
  },

  aboutXYears: {
    one: "mu bhliadhna",
    other: "mu {{count}} bliadhnaichean",
  },

  xYears: {
    one: "1 bhliadhna",
    other: "{{count}} bliadhna",
  },

  overXYears: {
    one: "còrr is bliadhna",
    other: "còrr is {{count}} bliadhnaichean",
  },

  almostXYears: {
    one: "cha mhòr bliadhna",
    other: "cha mhòr {{count}} bliadhnaichean",
  },
};

const formatDistance$1I = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$R[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else if (count === 2 && !!tokenValue.two) {
    result = tokenValue.two;
  } else if (count === 20 && !!tokenValue.twenty) {
    result = tokenValue.twenty;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "ann an " + result;
    } else {
      return "o chionn " + result;
    }
  }

  return result;
};
formatDistance$1J.formatDistance = formatDistance$1I;

var formatLong$T = {};

formatLong$T.formatLong = void 0;
var _index$3D = buildFormatLongFn$1;

const dateFormats$T = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$T = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$T = {
  full: "{{date}} 'aig' {{time}}",
  long: "{{date}} 'aig' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$T.formatLong = {
  date: (0, _index$3D.buildFormatLongFn)({
    formats: dateFormats$T,
    defaultWidth: "full",
  }),

  time: (0, _index$3D.buildFormatLongFn)({
    formats: timeFormats$T,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3D.buildFormatLongFn)({
    formats: dateTimeFormats$T,
    defaultWidth: "full",
  }),
});

var formatRelative$1J = {};

formatRelative$1J.formatRelative = void 0;

const formatRelativeLocale$S = {
  lastWeek: "'mu dheireadh' eeee 'aig' p", //FIX
  yesterday: "'an-dè aig' p",
  today: "'an-diugh aig' p",
  tomorrow: "'a-màireach aig' p",
  nextWeek: "eeee 'aig' p",
  other: "P",
};

const formatRelative$1I = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$S[token];
formatRelative$1J.formatRelative = formatRelative$1I;

var localize$S = {};

localize$S.localize = void 0;
var _index$3C = buildLocalizeFn$1;

const eraValues$S = {
  narrow: ["R", "A"],
  abbreviated: ["RC", "AD"],
  wide: ["ro Chrìosta", "anno domini"],
};

const quarterValues$S = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["C1", "C2", "C3", "C4"],
  wide: [
    "a' chiad chairteal",
    "an dàrna cairteal",
    "an treas cairteal",
    "an ceathramh cairteal",
  ],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$S = {
  narrow: ["F", "G", "M", "G", "C", "Ò", "I", "L", "S", "D", "S", "D"],
  abbreviated: [
    "Faoi",
    "Gear",
    "Màrt",
    "Gibl",
    "Cèit",
    "Ògmh",
    "Iuch",
    "Lùn",
    "Sult",
    "Dàmh",
    "Samh",
    "Dùbh",
  ],

  wide: [
    "Am Faoilleach",
    "An Gearran",
    "Am Màrt",
    "An Giblean",
    "An Cèitean",
    "An t-Ògmhios",
    "An t-Iuchar",
    "An Lùnastal",
    "An t-Sultain",
    "An Dàmhair",
    "An t-Samhain",
    "An Dùbhlachd",
  ],
};

const dayValues$S = {
  narrow: ["D", "L", "M", "C", "A", "H", "S"],
  short: ["Dò", "Lu", "Mà", "Ci", "Ar", "Ha", "Sa"],
  abbreviated: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
  wide: [
    "Didòmhnaich",
    "Diluain",
    "Dimàirt",
    "Diciadain",
    "Diardaoin",
    "Dihaoine",
    "Disathairne",
  ],
};

const dayPeriodValues$S = {
  narrow: {
    am: "m",
    pm: "f",
    midnight: "m.o.",
    noon: "m.l.",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche",
  },
  abbreviated: {
    am: "M.",
    pm: "F.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche",
  },
  wide: {
    am: "m.",
    pm: "f.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche",
  },
};

const formattingDayPeriodValues$I = {
  narrow: {
    am: "m",
    pm: "f",
    midnight: "m.o.",
    noon: "m.l.",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche",
  },
  abbreviated: {
    am: "M.",
    pm: "F.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche",
  },
  wide: {
    am: "m.",
    pm: "f.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche",
  },
};

const ordinalNumber$S = (dirtyNumber) => {
  const number = Number(dirtyNumber);
  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "d";
      case 2:
        return number + "na";
    }
  }

  if (rem100 === 12) {
    return number + "na";
  }

  return number + "mh";
};

(localize$S.localize = {
  ordinalNumber: ordinalNumber$S,

  era: (0, _index$3C.buildLocalizeFn)({
    values: eraValues$S,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3C.buildLocalizeFn)({
    values: quarterValues$S,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3C.buildLocalizeFn)({
    values: monthValues$S,
    defaultWidth: "wide",
  }),

  day: (0, _index$3C.buildLocalizeFn)({
    values: dayValues$S,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3C.buildLocalizeFn)({
    values: dayPeriodValues$S,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$I,
    defaultFormattingWidth: "wide",
  }),
});

var match$S = {};

match$S.match = void 0;

var _index$3B = buildMatchFn$1;
var _index2$1L = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$S = /^(\d+)(d|na|tr|mh)?/i;
const parseOrdinalNumberPattern$S = /\d+/i;

const matchEraPatterns$S = {
  narrow: /^(r|a)/i,
  abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
  wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i,
};
const parseEraPatterns$S = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns$S = {
  narrow: /^[1234]/i,
  abbreviated: /^c[1234]/i,
  wide: /^[1234](cd|na|tr|mh)? cairteal/i,
};
const parseQuarterPatterns$S = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$S = {
  narrow: /^[fgmcòilsd]/i,
  abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
  wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i,
};
const parseMonthPatterns$S = {
  narrow: [
    /^f/i,
    /^g/i,
    /^m/i,
    /^g/i,
    /^c/i,
    /^ò/i,
    /^i/i,
    /^l/i,
    /^s/i,
    /^d/i,
    /^s/i,
    /^d/i,
  ],

  any: [
    /^fa/i,
    /^ge/i,
    /^mà/i,
    /^gi/i,
    /^c/i,
    /^ò/i,
    /^i/i,
    /^l/i,
    /^su/i,
    /^d/i,
    /^sa/i,
    /^d/i,
  ],
};

const matchDayPatterns$S = {
  narrow: /^[dlmcahs]/i,
  short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
  abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
  wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i,
};
const parseDayPatterns$S = {
  narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
  any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
};

const matchDayPeriodPatterns$S = {
  narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
  any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
};
const parseDayPeriodPatterns$S = {
  any: {
    am: /^m/i,
    pm: /^f/i,
    midnight: /^meadhan oidhche/i,
    noon: /^meadhan là/i,
    morning: /sa mhadainn/i,
    afternoon: /feasgar/i,
    evening: /feasgar/i,
    night: /air an oidhche/i,
  },
};

(match$S.match = {
  ordinalNumber: (0, _index2$1L.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$S,
    parsePattern: parseOrdinalNumberPattern$S,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$3B.buildMatchFn)({
    matchPatterns: matchEraPatterns$S,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$S,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3B.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$S,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$S,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3B.buildMatchFn)({
    matchPatterns: matchMonthPatterns$S,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$S,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3B.buildMatchFn)({
    matchPatterns: matchDayPatterns$S,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$S,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3B.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$S,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$S,
    defaultParseWidth: "any",
  }),
});

gd.gd = void 0;
var _index$3A = formatDistance$1J;
var _index2$1K = formatLong$T;
var _index3$U = formatRelative$1J;
var _index4$T = localize$S;
var _index5$T = match$S;

/**
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll](https://github.com/leedriscoll)
 */
(gd.gd = {
  code: "gd",
  formatDistance: _index$3A.formatDistance,
  formatLong: _index2$1K.formatLong,
  formatRelative: _index3$U.formatRelative,
  localize: _index4$T.localize,
  match: _index5$T.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var gl = {};

var formatDistance$1H = {};

formatDistance$1H.formatDistance = void 0;

const formatDistanceLocale$Q = {
  lessThanXSeconds: {
    one: "menos dun segundo",
    other: "menos de {{count}} segundos",
  },

  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos",
  },

  halfAMinute: "medio minuto",

  lessThanXMinutes: {
    one: "menos dun minuto",
    other: "menos de {{count}} minutos",
  },

  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos",
  },

  aboutXHours: {
    one: "arredor dunha hora",
    other: "arredor de {{count}} horas",
  },

  xHours: {
    one: "1 hora",
    other: "{{count}} horas",
  },

  xDays: {
    one: "1 día",
    other: "{{count}} días",
  },

  aboutXWeeks: {
    one: "arredor dunha semana",
    other: "arredor de {{count}} semanas",
  },

  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas",
  },

  aboutXMonths: {
    one: "arredor de 1 mes",
    other: "arredor de {{count}} meses",
  },

  xMonths: {
    one: "1 mes",
    other: "{{count}} meses",
  },

  aboutXYears: {
    one: "arredor dun ano",
    other: "arredor de {{count}} anos",
  },

  xYears: {
    one: "1 ano",
    other: "{{count}} anos",
  },

  overXYears: {
    one: "máis dun ano",
    other: "máis de {{count}} anos",
  },

  almostXYears: {
    one: "case un ano",
    other: "case {{count}} anos",
  },
};

const formatDistance$1G = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$Q[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "en " + result;
    } else {
      return "hai " + result;
    }
  }

  return result;
};
formatDistance$1H.formatDistance = formatDistance$1G;

var formatLong$S = {};

formatLong$S.formatLong = void 0;
var _index$3z = buildFormatLongFn$1;

const dateFormats$S = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats$S = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$S = {
  full: "{{date}} 'ás' {{time}}",
  long: "{{date}} 'ás' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$S.formatLong = {
  date: (0, _index$3z.buildFormatLongFn)({
    formats: dateFormats$S,
    defaultWidth: "full",
  }),

  time: (0, _index$3z.buildFormatLongFn)({
    formats: timeFormats$S,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3z.buildFormatLongFn)({
    formats: dateTimeFormats$S,
    defaultWidth: "full",
  }),
});

var formatRelative$1H = {};

formatRelative$1H.formatRelative = void 0;

const formatRelativeLocale$R = {
  lastWeek: "'o' eeee 'pasado á' LT",
  yesterday: "'onte á' p",
  today: "'hoxe á' p",
  tomorrow: "'mañá á' p",
  nextWeek: "eeee 'á' p",
  other: "P",
};

const formatRelativeLocalePlural = {
  lastWeek: "'o' eeee 'pasado ás' p",
  yesterday: "'onte ás' p",
  today: "'hoxe ás' p",
  tomorrow: "'mañá ás' p",
  nextWeek: "eeee 'ás' p",
  other: "P",
};

const formatRelative$1G = (token, date, _baseDate, _options) => {
  if (date.getHours() !== 1) {
    return formatRelativeLocalePlural[token];
  }
  return formatRelativeLocale$R[token];
};
formatRelative$1H.formatRelative = formatRelative$1G;

var localize$R = {};

localize$R.localize = void 0;
var _index$3y = buildLocalizeFn$1;

const eraValues$R = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "despois de cristo"],
};

const quarterValues$R = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"],
};

const monthValues$R = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "xan",
    "feb",
    "mar",
    "abr",
    "mai",
    "xun",
    "xul",
    "ago",
    "set",
    "out",
    "nov",
    "dec",
  ],

  wide: [
    "xaneiro",
    "febreiro",
    "marzo",
    "abril",
    "maio",
    "xuño",
    "xullo",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "decembro",
  ],
};

const dayValues$R = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "me", "xo", "ve", "sa"],
  abbreviated: ["dom", "lun", "mar", "mer", "xov", "ven", "sab"],
  wide: ["domingo", "luns", "martes", "mércores", "xoves", "venres", "sábado"],
};

const dayPeriodValues$R = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite",
  },
};

const formattingDayPeriodValues$H = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite",
  },
};

const ordinalNumber$R = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "º";
};

(localize$R.localize = {
  ordinalNumber: ordinalNumber$R,

  era: (0, _index$3y.buildLocalizeFn)({
    values: eraValues$R,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3y.buildLocalizeFn)({
    values: quarterValues$R,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3y.buildLocalizeFn)({
    values: monthValues$R,
    defaultWidth: "wide",
  }),

  day: (0, _index$3y.buildLocalizeFn)({
    values: dayValues$R,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3y.buildLocalizeFn)({
    values: dayPeriodValues$R,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$H,
    defaultFormattingWidth: "wide",
  }),
});

var match$R = {};

match$R.match = void 0;

var _index$3x = buildMatchFn$1;
var _index2$1J = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$R = /^(\d+)(º)?/i;
const parseOrdinalNumberPattern$R = /\d+/i;

const matchEraPatterns$R = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i,
};
const parseEraPatterns$R = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes da era com[uú]n)/i,
    /^(despois de cristo|era com[uú]n)/i,
  ],
};

const matchQuarterPatterns$R = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i,
};
const parseQuarterPatterns$R = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$R = {
  narrow: /^[xfmasond]/i,
  abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
  wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i,
};
const parseMonthPatterns$R = {
  narrow: [
    /^x/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^x/i,
    /^x/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^xan/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^xun/i,
    /^xul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dec/i,
  ],
};

const matchDayPatterns$R = {
  narrow: /^[dlmxvs]/i,
  short: /^(do|lu|ma|me|xo|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
  wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i,
};
const parseDayPatterns$R = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i],
};

const matchDayPeriodPatterns$R = {
  narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
};
const parseDayPeriodPatterns$R = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañ[aá]/i,
    afternoon: /tarde/i,
    evening: /tardiña/i,
    night: /noite/i,
  },
};

(match$R.match = {
  ordinalNumber: (0, _index2$1J.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$R,
    parsePattern: parseOrdinalNumberPattern$R,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$3x.buildMatchFn)({
    matchPatterns: matchEraPatterns$R,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$R,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3x.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$R,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$R,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3x.buildMatchFn)({
    matchPatterns: matchMonthPatterns$R,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$R,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3x.buildMatchFn)({
    matchPatterns: matchDayPatterns$R,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$R,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3x.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$R,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$R,
    defaultParseWidth: "any",
  }),
});

gl.gl = void 0;
var _index$3w = formatDistance$1H;
var _index2$1I = formatLong$S;
var _index3$T = formatRelative$1H;
var _index4$S = localize$R;
var _index5$S = match$R;

/**
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech](https://github.com/cocodinTech)
 * @author Fidel Pita [@fidelpita](https://github.com/fidelpita)
 */
(gl.gl = {
  code: "gl",
  formatDistance: _index$3w.formatDistance,
  formatLong: _index2$1I.formatLong,
  formatRelative: _index3$T.formatRelative,
  localize: _index4$S.localize,
  match: _index5$S.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var gu = {};

var formatDistance$1F = {};

formatDistance$1F.formatDistance = void 0;

// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const formatDistanceLocale$P = {
  lessThanXSeconds: {
    one: "હમણાં", // CLDR #1461
    other: "​આશરે {{count}} સેકંડ",
  },

  xSeconds: {
    one: "1 સેકંડ",
    other: "{{count}} સેકંડ",
  },

  halfAMinute: "અડધી મિનિટ",

  lessThanXMinutes: {
    one: "આ મિનિટ", // CLDR #1448
    other: "​આશરે {{count}} મિનિટ",
  },

  xMinutes: {
    one: "1 મિનિટ",
    other: "{{count}} મિનિટ",
  },

  aboutXHours: {
    one: "​આશરે 1 કલાક",
    other: "​આશરે {{count}} કલાક",
  },

  xHours: {
    one: "1 કલાક",
    other: "{{count}} કલાક",
  },

  xDays: {
    one: "1 દિવસ",
    other: "{{count}} દિવસ",
  },

  aboutXWeeks: {
    one: "આશરે 1 અઠવાડિયું",
    other: "આશરે {{count}} અઠવાડિયા",
  },

  xWeeks: {
    one: "1 અઠવાડિયું",
    other: "{{count}} અઠવાડિયા",
  },

  aboutXMonths: {
    one: "આશરે 1 મહિનો",
    other: "આશરે {{count}} મહિના",
  },

  xMonths: {
    one: "1 મહિનો",
    other: "{{count}} મહિના",
  },

  aboutXYears: {
    one: "આશરે 1 વર્ષ",
    other: "આશરે {{count}} વર્ષ",
  },

  xYears: {
    one: "1 વર્ષ",
    other: "{{count}} વર્ષ",
  },

  overXYears: {
    one: "1 વર્ષથી વધુ",
    other: "{{count}} વર્ષથી વધુ",
  },

  almostXYears: {
    one: "લગભગ 1 વર્ષ",
    other: "લગભગ {{count}} વર્ષ",
  },
};

const formatDistance$1E = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$P[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + "માં";
    } else {
      return result + " પહેલાં";
    }
  }

  return result;
};
formatDistance$1F.formatDistance = formatDistance$1E;

var formatLong$R = {};

formatLong$R.formatLong = void 0;
var _index$3v = buildFormatLongFn$1;

//Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
const dateFormats$R = {
  full: "EEEE, d MMMM, y", // CLDR #1825
  long: "d MMMM, y", // CLDR #1826
  medium: "d MMM, y", // CLDR #1827
  short: "d/M/yy", // CLDR #1828
};

const timeFormats$R = {
  full: "hh:mm:ss a zzzz", // CLDR #1829
  long: "hh:mm:ss a z", // CLDR #1830
  medium: "hh:mm:ss a", // CLDR #1831
  short: "hh:mm a", // CLDR #1832
};

const dateTimeFormats$R = {
  full: "{{date}} {{time}}", // CLDR #1833
  long: "{{date}} {{time}}", // CLDR #1834
  medium: "{{date}} {{time}}", // CLDR #1835
  short: "{{date}} {{time}}", // CLDR #1836
};

(formatLong$R.formatLong = {
  date: (0, _index$3v.buildFormatLongFn)({
    formats: dateFormats$R,
    defaultWidth: "full",
  }),

  time: (0, _index$3v.buildFormatLongFn)({
    formats: timeFormats$R,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3v.buildFormatLongFn)({
    formats: dateTimeFormats$R,
    defaultWidth: "full",
  }),
});

var formatRelative$1F = {};

formatRelative$1F.formatRelative = void 0;

// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html

const formatRelativeLocale$Q = {
  lastWeek: "'પાછલા' eeee p", // CLDR #1384
  yesterday: "'ગઈકાલે' p", // CLDR #1409
  today: "'આજે' p", // CLDR #1410
  tomorrow: "'આવતીકાલે' p", // CLDR #1411
  nextWeek: "eeee p", // CLDR #1386
  other: "P",
};

const formatRelative$1E = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$Q[token];
formatRelative$1F.formatRelative = formatRelative$1E;

var localize$Q = {};

localize$Q.localize = void 0;
var _index$3u = buildLocalizeFn$1;

// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1621 - #1630
const eraValues$Q = {
  narrow: ["ઈસપૂ", "ઈસ"],
  abbreviated: ["ઈ.સ.પૂર્વે", "ઈ.સ."],
  wide: ["ઈસવીસન પૂર્વે", "ઈસવીસન"],
};

// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
const quarterValues$Q = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1લો ત્રિમાસ", "2જો ત્રિમાસ", "3જો ત્રિમાસ", "4થો ત્રિમાસ"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
const monthValues$Q = {
  narrow: ["જા", "ફે", "મા", "એ", "મે", "જૂ", "જુ", "ઓ", "સ", "ઓ", "ન", "ડિ"],

  abbreviated: [
    "જાન્યુ",
    "ફેબ્રુ",
    "માર્ચ",
    "એપ્રિલ",
    "મે",
    "જૂન",
    "જુલાઈ",
    "ઑગસ્ટ",
    "સપ્ટે",
    "ઓક્ટો",
    "નવે",
    "ડિસે",
  ],

  wide: [
    "જાન્યુઆરી",
    "ફેબ્રુઆરી",
    "માર્ચ",
    "એપ્રિલ",
    "મે",
    "જૂન",
    "જુલાઇ",
    "ઓગસ્ટ",
    "સપ્ટેમ્બર",
    "ઓક્ટોબર",
    "નવેમ્બર",
    "ડિસેમ્બર",
  ],
};

// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
const dayValues$Q = {
  narrow: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  short: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  abbreviated: ["રવિ", "સોમ", "મંગળ", "બુધ", "ગુરુ", "શુક્ર", "શનિ"],
  wide: [
    "રવિવાર" /* Sunday */,
    "સોમવાર" /* Monday */,
    "મંગળવાર" /* Tuesday */,
    "બુધવાર" /* Wednesday */,
    "ગુરુવાર" /* Thursday */,
    "શુક્રવાર" /* Friday */,
    "શનિવાર" /* Saturday */,
  ],
};

// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
const dayPeriodValues$Q = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બ.",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે",
  },
};

const formattingDayPeriodValues$G = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે",
  },
};

const ordinalNumber$Q = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$Q.localize = {
  ordinalNumber: ordinalNumber$Q,

  era: (0, _index$3u.buildLocalizeFn)({
    values: eraValues$Q,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3u.buildLocalizeFn)({
    values: quarterValues$Q,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3u.buildLocalizeFn)({
    values: monthValues$Q,
    defaultWidth: "wide",
  }),

  day: (0, _index$3u.buildLocalizeFn)({
    values: dayValues$Q,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3u.buildLocalizeFn)({
    values: dayPeriodValues$Q,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$G,
    defaultFormattingWidth: "wide",
  }),
});

var match$Q = {};

match$Q.match = void 0;

var _index$3t = buildMatchFn$1;
var _index2$1H = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$Q = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
const parseOrdinalNumberPattern$Q = /\d+/i;

const matchEraPatterns$Q = {
  narrow: /^(ઈસપૂ|ઈસ)/i,
  abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
  wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i,
};
const parseEraPatterns$Q = {
  any: [/^ઈસપૂ/i, /^ઈસ/i],
};

const matchQuarterPatterns$Q = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i,
};
const parseQuarterPatterns$Q = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$Q = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
  abbreviated:
    /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
  wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i,
};
const parseMonthPatterns$Q = {
  narrow: [
    /^જા/i,
    /^ફે/i,
    /^મા/i,
    /^એ/i,
    /^મે/i,
    /^જૂ/i,
    /^જુ/i,
    /^ઑગ/i,
    /^સ/i,
    /^ઓક્ટો/i,
    /^ન/i,
    /^ડિ/i,
  ],

  any: [
    /^જા/i,
    /^ફે/i,
    /^મા/i,
    /^એ/i,
    /^મે/i,
    /^જૂ/i,
    /^જુ/i,
    /^ઑગ/i,
    /^સ/i,
    /^ઓક્ટો/i,
    /^ન/i,
    /^ડિ/i,
  ],
};

const matchDayPatterns$Q = {
  narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
  wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i,
};
const parseDayPatterns$Q = {
  narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
  any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
};

const matchDayPeriodPatterns$Q = {
  narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
  any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
};
const parseDayPeriodPatterns$Q = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^મ\.?/i,
    noon: /^બ/i,
    morning: /સ/i,
    afternoon: /બ/i,
    evening: /સાં/i,
    night: /રા/i,
  },
};

(match$Q.match = {
  ordinalNumber: (0, _index2$1H.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$Q,
    parsePattern: parseOrdinalNumberPattern$Q,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$3t.buildMatchFn)({
    matchPatterns: matchEraPatterns$Q,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$Q,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3t.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$Q,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$Q,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3t.buildMatchFn)({
    matchPatterns: matchMonthPatterns$Q,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$Q,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3t.buildMatchFn)({
    matchPatterns: matchDayPatterns$Q,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$Q,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3t.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$Q,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$Q,
    defaultParseWidth: "any",
  }),
});

gu.gu = void 0;
var _index$3s = formatDistance$1F;
var _index2$1G = formatLong$R;
var _index3$S = formatRelative$1F;
var _index4$R = localize$Q;
var _index5$R = match$Q;

/**
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM](https://github.com/manadaym)
 */
(gu.gu = {
  code: "gu",
  formatDistance: _index$3s.formatDistance,
  formatLong: _index2$1G.formatLong,
  formatRelative: _index3$S.formatRelative,
  localize: _index4$R.localize,
  match: _index5$R.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var he = {};

var formatDistance$1D = {};

formatDistance$1D.formatDistance = void 0;

const formatDistanceLocale$O = {
  lessThanXSeconds: {
    one: "פחות משנייה",
    two: "פחות משתי שניות",
    other: "פחות מ־{{count}} שניות",
  },

  xSeconds: {
    one: "שנייה",
    two: "שתי שניות",
    other: "{{count}} שניות",
  },

  halfAMinute: "חצי דקה",

  lessThanXMinutes: {
    one: "פחות מדקה",
    two: "פחות משתי דקות",
    other: "פחות מ־{{count}} דקות",
  },

  xMinutes: {
    one: "דקה",
    two: "שתי דקות",
    other: "{{count}} דקות",
  },

  aboutXHours: {
    one: "כשעה",
    two: "כשעתיים",
    other: "כ־{{count}} שעות",
  },

  xHours: {
    one: "שעה",
    two: "שעתיים",
    other: "{{count}} שעות",
  },

  xDays: {
    one: "יום",
    two: "יומיים",
    other: "{{count}} ימים",
  },

  aboutXWeeks: {
    one: "כשבוע",
    two: "כשבועיים",
    other: "כ־{{count}} שבועות",
  },

  xWeeks: {
    one: "שבוע",
    two: "שבועיים",
    other: "{{count}} שבועות",
  },

  aboutXMonths: {
    one: "כחודש",
    two: "כחודשיים",
    other: "כ־{{count}} חודשים",
  },

  xMonths: {
    one: "חודש",
    two: "חודשיים",
    other: "{{count}} חודשים",
  },

  aboutXYears: {
    one: "כשנה",
    two: "כשנתיים",
    other: "כ־{{count}} שנים",
  },

  xYears: {
    one: "שנה",
    two: "שנתיים",
    other: "{{count}} שנים",
  },

  overXYears: {
    one: "יותר משנה",
    two: "יותר משנתיים",
    other: "יותר מ־{{count}} שנים",
  },

  almostXYears: {
    one: "כמעט שנה",
    two: "כמעט שנתיים",
    other: "כמעט {{count}} שנים",
  },
};

const formatDistance$1C = (token, count, options) => {
  // Return word instead of `in one day` or `one day ago`
  if (token === "xDays" && options?.addSuffix && count <= 2) {
    if (options.comparison && options.comparison > 0) {
      return count === 1 ? "מחר" : "מחרתיים";
    }

    return count === 1 ? "אתמול" : "שלשום";
  }

  let result;

  const tokenValue = formatDistanceLocale$O[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else if (count === 2) {
    result = tokenValue.two;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "בעוד " + result;
    } else {
      return "לפני " + result;
    }
  }

  return result;
};
formatDistance$1D.formatDistance = formatDistance$1C;

var formatLong$Q = {};

formatLong$Q.formatLong = void 0;
var _index$3r = buildFormatLongFn$1;

const dateFormats$Q = {
  full: "EEEE, d בMMMM y",
  long: "d בMMMM y",
  medium: "d בMMM y",
  short: "d.M.y",
};

const timeFormats$Q = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$Q = {
  full: "{{date}} 'בשעה' {{time}}",
  long: "{{date}} 'בשעה' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$Q.formatLong = {
  date: (0, _index$3r.buildFormatLongFn)({
    formats: dateFormats$Q,
    defaultWidth: "full",
  }),

  time: (0, _index$3r.buildFormatLongFn)({
    formats: timeFormats$Q,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3r.buildFormatLongFn)({
    formats: dateTimeFormats$Q,
    defaultWidth: "full",
  }),
});

var formatRelative$1D = {};

formatRelative$1D.formatRelative = void 0;

const formatRelativeLocale$P = {
  lastWeek: "eeee 'שעבר בשעה' p",
  yesterday: "'אתמול בשעה' p",
  today: "'היום בשעה' p",
  tomorrow: "'מחר בשעה' p",
  nextWeek: "eeee 'בשעה' p",
  other: "P",
};

const formatRelative$1C = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$P[token];
formatRelative$1D.formatRelative = formatRelative$1C;

var localize$P = {};

localize$P.localize = void 0;
var _index$3q = buildLocalizeFn$1;

const eraValues$P = {
  narrow: ["לפנה״ס", "לספירה"],
  abbreviated: ["לפנה״ס", "לספירה"],
  wide: ["לפני הספירה", "לספירה"],
};

const quarterValues$P = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["רבעון 1", "רבעון 2", "רבעון 3", "רבעון 4"],
};

const monthValues$P = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],

  abbreviated: [
    "ינו׳",
    "פבר׳",
    "מרץ",
    "אפר׳",
    "מאי",
    "יוני",
    "יולי",
    "אוג׳",
    "ספט׳",
    "אוק׳",
    "נוב׳",
    "דצמ׳",
  ],

  wide: [
    "ינואר",
    "פברואר",
    "מרץ",
    "אפריל",
    "מאי",
    "יוני",
    "יולי",
    "אוגוסט",
    "ספטמבר",
    "אוקטובר",
    "נובמבר",
    "דצמבר",
  ],
};

const dayValues$P = {
  narrow: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  short: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  abbreviated: [
    "יום א׳",
    "יום ב׳",
    "יום ג׳",
    "יום ד׳",
    "יום ה׳",
    "יום ו׳",
    "שבת",
  ],

  wide: [
    "יום ראשון",
    "יום שני",
    "יום שלישי",
    "יום רביעי",
    "יום חמישי",
    "יום שישי",
    "יום שבת",
  ],
};

const dayPeriodValues$P = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה",
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה",
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה",
  },
};

const formattingDayPeriodValues$F = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "בצהריים",
    evening: "בערב",
    night: "בלילה",
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה",
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה",
  },
};

const ordinalNumber$P = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);

  // We only show words till 10
  if (number <= 0 || number > 10) return String(number);

  const unit = String(options?.unit);

  const isFemale = ["year", "hour", "minute", "second"].indexOf(unit) >= 0;

  const male = [
    "ראשון",
    "שני",
    "שלישי",
    "רביעי",
    "חמישי",
    "שישי",
    "שביעי",
    "שמיני",
    "תשיעי",
    "עשירי",
  ];

  const female = [
    "ראשונה",
    "שנייה",
    "שלישית",
    "רביעית",
    "חמישית",
    "שישית",
    "שביעית",
    "שמינית",
    "תשיעית",
    "עשירית",
  ];

  const index = number - 1;
  return isFemale ? female[index] : male[index];
};

(localize$P.localize = {
  ordinalNumber: ordinalNumber$P,

  era: (0, _index$3q.buildLocalizeFn)({
    values: eraValues$P,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3q.buildLocalizeFn)({
    values: quarterValues$P,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3q.buildLocalizeFn)({
    values: monthValues$P,
    defaultWidth: "wide",
  }),

  day: (0, _index$3q.buildLocalizeFn)({
    values: dayValues$P,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3q.buildLocalizeFn)({
    values: dayPeriodValues$P,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$F,
    defaultFormattingWidth: "wide",
  }),
});

var match$P = {};

match$P.match = void 0;

var _index$3p = buildMatchFn$1;
var _index2$1F = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$P =
  /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
const parseOrdinalNumberPattern$P = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;

const matchEraPatterns$P = {
  narrow: /^ל(ספירה|פנה״ס)/i,
  abbreviated: /^ל(ספירה|פנה״ס)/i,
  wide: /^ל(פני ה)?ספירה/i,
};
const parseEraPatterns$P = {
  any: [/^לפ/i, /^לס/i],
};

const matchQuarterPatterns$P = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^רבעון [1234]/i,
};
const parseQuarterPatterns$P = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$P = {
  narrow: /^\d+/i,
  abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
  wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i,
};
const parseMonthPatterns$P = {
  narrow: [
    /^1$/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i,
  ],

  any: [
    /^ינ/i,
    /^פ/i,
    /^מר/i,
    /^אפ/i,
    /^מא/i,
    /^יונ/i,
    /^יול/i,
    /^אוג/i,
    /^ס/i,
    /^אוק/i,
    /^נ/i,
    /^ד/i,
  ],
};

const matchDayPatterns$P = {
  narrow: /^[אבגדהוש]׳/i,
  short: /^[אבגדהוש]׳/i,
  abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
  wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i,
};
const parseDayPatterns$P = {
  abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
  wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
  any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i],
};

const matchDayPeriodPatterns$P = {
  any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i,
};
const parseDayPeriodPatterns$P = {
  any: {
    am: /^לפ/i,
    pm: /^אחה/i,
    midnight: /^ח/i,
    noon: /^צ/i,
    morning: /בוקר/i,
    afternoon: /בצ|אחר/i,
    evening: /ערב/i,
    night: /לילה/i,
  },
};

const ordinalName = ["רא", "שנ", "של", "רב", "ח", "שי", "שב", "שמ", "ת", "ע"];

(match$P.match = {
  ordinalNumber: (0, _index2$1F.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$P,
    parsePattern: parseOrdinalNumberPattern$P,
    valueCallback: (value) => {
      const number = parseInt(value, 10);
      return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
    },
  }),

  era: (0, _index$3p.buildMatchFn)({
    matchPatterns: matchEraPatterns$P,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$P,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3p.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$P,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$P,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3p.buildMatchFn)({
    matchPatterns: matchMonthPatterns$P,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$P,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3p.buildMatchFn)({
    matchPatterns: matchDayPatterns$P,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$P,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3p.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$P,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$P,
    defaultParseWidth: "any",
  }),
});

he.he = void 0;
var _index$3o = formatDistance$1D;
var _index2$1E = formatLong$Q;
var _index3$R = formatRelative$1D;
var _index4$Q = localize$P;
var _index5$Q = match$P;

/**
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah](https://github.com/nirlah)
 */
(he.he = {
  code: "he",
  formatDistance: _index$3o.formatDistance,
  formatLong: _index2$1E.formatLong,
  formatRelative: _index3$R.formatRelative,
  localize: _index4$Q.localize,
  match: _index5$Q.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var hi = {};

var formatDistance$1B = {};

var localize$O = {};

localize$O.localeToNumber = localeToNumber;
localize$O.localize = void 0;
localize$O.numberToLocale = numberToLocale;
var _index$3n = buildLocalizeFn$1;

const numberValues = {
  locale: {
    1: "१",
    2: "२",
    3: "३",
    4: "४",
    5: "५",
    6: "६",
    7: "७",
    8: "८",
    9: "९",
    0: "०",
  },
  number: {
    "१": "1",
    "२": "2",
    "३": "3",
    "४": "4",
    "५": "5",
    "६": "6",
    "७": "7",
    "८": "8",
    "९": "9",
    "०": "0",
  },
};

// CLDR #1585 - #1592
const eraValues$O = {
  narrow: ["ईसा-पूर्व", "ईस्वी"],
  abbreviated: ["ईसा-पूर्व", "ईस्वी"],
  wide: ["ईसा-पूर्व", "ईसवी सन"],
};

// CLDR #1593 - #1616
const quarterValues$O = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ति1", "ति2", "ति3", "ति4"],
  wide: ["पहली तिमाही", "दूसरी तिमाही", "तीसरी तिमाही", "चौथी तिमाही"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
const monthValues$O = {
  narrow: [
    "ज",
    "फ़",
    "मा",
    "अ",
    "मई",
    "जू",
    "जु",
    "अग",
    "सि",
    "अक्टू",
    "न",
    "दि",
  ],

  abbreviated: [
    "जन",
    "फ़र",
    "मार्च",
    "अप्रैल",
    "मई",
    "जून",
    "जुल",
    "अग",
    "सित",
    "अक्टू",
    "नव",
    "दिस",
  ],

  wide: [
    "जनवरी",
    "फ़रवरी",
    "मार्च",
    "अप्रैल",
    "मई",
    "जून",
    "जुलाई",
    "अगस्त",
    "सितंबर",
    "अक्टूबर",
    "नवंबर",
    "दिसंबर",
  ],
};

// CLDR #1689 - #1744
const dayValues$O = {
  narrow: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  short: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  abbreviated: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
  wide: [
    "रविवार",
    "सोमवार",
    "मंगलवार",
    "बुधवार",
    "गुरुवार",
    "शुक्रवार",
    "शनिवार",
  ],
};

const dayPeriodValues$O = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात",
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात",
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात",
  },
};

const formattingDayPeriodValues$E = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात",
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात",
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात",
  },
};

const ordinalNumber$O = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return numberToLocale(number);
};

function localeToNumber(locale) {
  const enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function (match) {
    return numberValues.number[match];
  });
  return Number(enNumber);
}

function numberToLocale(enNumber) {
  return enNumber.toString().replace(/\d/g, function (match) {
    return numberValues.locale[match];
  });
}

(localize$O.localize = {
  ordinalNumber: ordinalNumber$O,

  era: (0, _index$3n.buildLocalizeFn)({
    values: eraValues$O,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3n.buildLocalizeFn)({
    values: quarterValues$O,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3n.buildLocalizeFn)({
    values: monthValues$O,
    defaultWidth: "wide",
  }),

  day: (0, _index$3n.buildLocalizeFn)({
    values: dayValues$O,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3n.buildLocalizeFn)({
    values: dayPeriodValues$O,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$E,
    defaultFormattingWidth: "wide",
  }),
});

formatDistance$1B.formatDistance = void 0;
var _index$3m = localize$O;

// Source: https://www.unicode.org/cldr/charts/32/summary/hi.html

const formatDistanceLocale$N = {
  lessThanXSeconds: {
    one: "१ सेकंड से कम", // CLDR #1310
    other: "{{count}} सेकंड से कम",
  },

  xSeconds: {
    one: "१ सेकंड",
    other: "{{count}} सेकंड",
  },

  halfAMinute: "आधा मिनट",

  lessThanXMinutes: {
    one: "१ मिनट से कम",
    other: "{{count}} मिनट से कम",
  },

  xMinutes: {
    one: "१ मिनट", // CLDR #1307
    other: "{{count}} मिनट",
  },

  aboutXHours: {
    one: "लगभग १ घंटा",
    other: "लगभग {{count}} घंटे",
  },

  xHours: {
    one: "१ घंटा", // CLDR #1304
    other: "{{count}} घंटे", // CLDR #4467
  },

  xDays: {
    one: "१ दिन", // CLDR #1286
    other: "{{count}} दिन",
  },

  aboutXWeeks: {
    one: "लगभग १ सप्ताह",
    other: "लगभग {{count}} सप्ताह",
  },

  xWeeks: {
    one: "१ सप्ताह",
    other: "{{count}} सप्ताह",
  },

  aboutXMonths: {
    one: "लगभग १ महीना",
    other: "लगभग {{count}} महीने",
  },

  xMonths: {
    one: "१ महीना",
    other: "{{count}} महीने",
  },

  aboutXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष", // CLDR #4823
  },

  xYears: {
    one: "१ वर्ष",
    other: "{{count}} वर्ष",
  },

  overXYears: {
    one: "१ वर्ष से अधिक",
    other: "{{count}} वर्ष से अधिक",
  },

  almostXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष",
  },
};

const formatDistance$1A = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$N[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace(
      "{{count}}",
      (0, _index$3m.numberToLocale)(count),
    );
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + "मे ";
    } else {
      return result + " पहले";
    }
  }

  return result;
};
formatDistance$1B.formatDistance = formatDistance$1A;

var formatLong$P = {};

formatLong$P.formatLong = void 0;
var _index$3l = buildFormatLongFn$1;

const dateFormats$P = {
  full: "EEEE, do MMMM, y", // CLDR #1787
  long: "do MMMM, y", // CLDR #1788
  medium: "d MMM, y", // CLDR #1789
  short: "dd/MM/yyyy", // CLDR #1790
};

const timeFormats$P = {
  full: "h:mm:ss a zzzz", // CLDR #1791
  long: "h:mm:ss a z", // CLDR #1792
  medium: "h:mm:ss a", // CLDR #1793
  short: "h:mm a", // CLDR #1794
};

const dateTimeFormats$P = {
  full: "{{date}} 'को' {{time}}", // CLDR #1795
  long: "{{date}} 'को' {{time}}", // CLDR #1796
  medium: "{{date}}, {{time}}", // CLDR #1797
  short: "{{date}}, {{time}}", // CLDR #1798
};

(formatLong$P.formatLong = {
  date: (0, _index$3l.buildFormatLongFn)({
    formats: dateFormats$P,
    defaultWidth: "full",
  }),

  time: (0, _index$3l.buildFormatLongFn)({
    formats: timeFormats$P,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3l.buildFormatLongFn)({
    formats: dateTimeFormats$P,
    defaultWidth: "full",
  }),
});

var formatRelative$1B = {};

formatRelative$1B.formatRelative = void 0;

const formatRelativeLocale$O = {
  lastWeek: "'पिछले' eeee p",
  yesterday: "'कल' p",
  today: "'आज' p",
  tomorrow: "'कल' p",
  nextWeek: "eeee 'को' p",
  other: "P",
};

const formatRelative$1A = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$O[token];
formatRelative$1B.formatRelative = formatRelative$1A;

var match$O = {};

match$O.match = void 0;

var _index$3k = buildMatchFn$1;
var _index2$1D = buildMatchPatternFn$1;
var _index3$Q = localize$O;

const matchOrdinalNumberPattern$O = /^[०१२३४५६७८९]+/i;
const parseOrdinalNumberPattern$O = /^[०१२३४५६७८९]+/i;

const matchEraPatterns$O = {
  narrow: /^(ईसा-पूर्व|ईस्वी)/i,
  abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
  wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i,
};

const parseEraPatterns$O = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns$O = {
  narrow: /^[1234]/i,
  abbreviated: /^ति[1234]/i,
  wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i,
};
const parseQuarterPatterns$O = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$O = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
  abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
  wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i,
};
const parseMonthPatterns$O = {
  narrow: [
    /^ज/i,
    /^फ़/i,
    /^मा/i,
    /^अप्/i,
    /^मई/i,
    /^जू/i,
    /^जु/i,
    /^अग/i,
    /^सि/i,
    /^अक्तू/i,
    /^न/i,
    /^दि/i,
  ],

  any: [
    /^जन/i,
    /^फ़/i,
    /^मा/i,
    /^अप्/i,
    /^मई/i,
    /^जू/i,
    /^जु/i,
    /^अग/i,
    /^सि/i,
    /^अक्तू/i,
    /^नव/i,
    /^दिस/i,
  ],
};

const matchDayPatterns$O = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i,
};
const parseDayPatterns$O = {
  narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],

  any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
};

const matchDayPeriodPatterns$O = {
  narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
  any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i,
};
const parseDayPeriodPatterns$O = {
  any: {
    am: /^पूर्वाह्न/i,
    pm: /^अपराह्न/i,
    midnight: /^मध्य/i,
    noon: /^दो/i,
    morning: /सु/i,
    afternoon: /दो/i,
    evening: /शा/i,
    night: /रा/i,
  },
};

(match$O.match = {
  ordinalNumber: (0, _index2$1D.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$O,
    parsePattern: parseOrdinalNumberPattern$O,
    valueCallback: _index3$Q.localeToNumber,
  }),

  era: (0, _index$3k.buildMatchFn)({
    matchPatterns: matchEraPatterns$O,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$O,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3k.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$O,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$O,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3k.buildMatchFn)({
    matchPatterns: matchMonthPatterns$O,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$O,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3k.buildMatchFn)({
    matchPatterns: matchDayPatterns$O,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$O,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3k.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$O,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$O,
    defaultParseWidth: "any",
  }),
});

hi.hi = void 0;
var _index$3j = formatDistance$1B;
var _index2$1C = formatLong$P;
var _index3$P = formatRelative$1B;
var _index4$P = localize$O;
var _index5$P = match$O;

/**
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal](https://github.com/mukeshmandiwal)
 */
(hi.hi = {
  code: "hi",
  formatDistance: _index$3j.formatDistance,
  formatLong: _index2$1C.formatLong,
  formatRelative: _index3$P.formatRelative,
  localize: _index4$P.localize,
  match: _index5$P.match,
  options: {
    weekStartsOn: 0 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var hr = {};

var formatDistance$1z = {};

formatDistance$1z.formatDistance = void 0;

const formatDistanceLocale$M = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu",
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi",
  },

  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu",
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi",
  },

  halfAMinute: "pola minute",

  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu",
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta",
  },

  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu",
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta",
  },

  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat",
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati",
  },

  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat",
    },
    dual: "{{count}} sata",
    other: "{{count}} sati",
  },

  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan",
    },
    dual: "{{count}} dana",
    other: "{{count}} dana",
  },

  aboutXWeeks: {
    one: {
      standalone: "oko 1 tjedan",
      withPrepositionAgo: "oko 1 tjedan",
      withPrepositionIn: "oko 1 tjedan",
    },
    dual: "oko {{count}} tjedna",
    other: "oko {{count}} tjedana",
  },

  xWeeks: {
    one: {
      standalone: "1 tjedan",
      withPrepositionAgo: "1 tjedan",
      withPrepositionIn: "1 tjedan",
    },
    dual: "{{count}} tjedna",
    other: "{{count}} tjedana",
  },

  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec",
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci",
  },

  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec",
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci",
  },

  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu",
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina",
  },

  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu",
    },
    dual: "{{count}} godine",
    other: "{{count}} godina",
  },

  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu",
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina",
  },

  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu",
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina",
  },
};

const formatDistance$1y = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$M[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    if (options?.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        result = tokenValue.one.withPrepositionIn;
      } else {
        result = tokenValue.one.withPrepositionAgo;
      }
    } else {
      result = tokenValue.one.standalone;
    }
  } else if (
    count % 10 > 1 &&
    count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
  ) {
    result = tokenValue.dual.replace("{{count}}", String(count));
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "za " + result;
    } else {
      return "prije " + result;
    }
  }

  return result;
};
formatDistance$1z.formatDistance = formatDistance$1y;

var formatLong$O = {};

formatLong$O.formatLong = void 0;
var _index$3i = buildFormatLongFn$1;

const dateFormats$O = {
  full: "EEEE, d. MMMM y.",
  long: "d. MMMM y.",
  medium: "d. MMM y.",
  short: "dd. MM. y.",
};

const timeFormats$O = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$O = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$O.formatLong = {
  date: (0, _index$3i.buildFormatLongFn)({
    formats: dateFormats$O,
    defaultWidth: "full",
  }),

  time: (0, _index$3i.buildFormatLongFn)({
    formats: timeFormats$O,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3i.buildFormatLongFn)({
    formats: dateTimeFormats$O,
    defaultWidth: "full",
  }),
});

var formatRelative$1z = {};

formatRelative$1z.formatRelative = void 0;

const formatRelativeLocale$N = {
  lastWeek: (date) => {
    switch (date.getDay()) {
      case 0:
        return "'prošlu nedjelju u' p";
      case 3:
        return "'prošlu srijedu u' p";
      case 6:
        return "'prošlu subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'jučer u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (date) => {
    switch (date.getDay()) {
      case 0:
        return "'iduću nedjelju u' p";
      case 3:
        return "'iduću srijedu u' p";
      case 6:
        return "'iduću subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  other: "P",
};

const formatRelative$1y = (token, date, _baseDate, _options) => {
  const format = formatRelativeLocale$N[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$1z.formatRelative = formatRelative$1y;

var localize$N = {};

localize$N.localize = void 0;
var _index$3h = buildLocalizeFn$1;

const eraValues$N = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Kr.", "po. Kr."],
  wide: ["Prije Krista", "Poslije Krista"],
};

const quarterValues$N = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"],
};

const monthValues$N = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12.",
  ],

  abbreviated: [
    "sij",
    "velj",
    "ožu",
    "tra",
    "svi",
    "lip",
    "srp",
    "kol",
    "ruj",
    "lis",
    "stu",
    "pro",
  ],

  wide: [
    "siječanj",
    "veljača",
    "ožujak",
    "travanj",
    "svibanj",
    "lipanj",
    "srpanj",
    "kolovoz",
    "rujan",
    "listopad",
    "studeni",
    "prosinac",
  ],
};

const formattingMonthValues$a = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12.",
  ],

  abbreviated: [
    "sij",
    "velj",
    "ožu",
    "tra",
    "svi",
    "lip",
    "srp",
    "kol",
    "ruj",
    "lis",
    "stu",
    "pro",
  ],

  wide: [
    "siječnja",
    "veljače",
    "ožujka",
    "travnja",
    "svibnja",
    "lipnja",
    "srpnja",
    "kolovoza",
    "rujna",
    "listopada",
    "studenog",
    "prosinca",
  ],
};

const dayValues$N = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  wide: [
    "nedjelja",
    "ponedjeljak",
    "utorak",
    "srijeda",
    "četvrtak",
    "petak",
    "subota",
  ],
};

const formattingDayPeriodValues$D = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću",
  },
};

const dayPeriodValues$N = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću",
  },
};

const ordinalNumber$N = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$N.localize = {
  ordinalNumber: ordinalNumber$N,

  era: (0, _index$3h.buildLocalizeFn)({
    values: eraValues$N,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3h.buildLocalizeFn)({
    values: quarterValues$N,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3h.buildLocalizeFn)({
    values: monthValues$N,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$a,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$3h.buildLocalizeFn)({
    values: dayValues$N,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3h.buildLocalizeFn)({
    values: dayPeriodValues$N,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$D,
    defaultFormattingWidth: "wide",
  }),
});

var match$N = {};

match$N.match = void 0;

var _index$3g = buildMatchFn$1;
var _index2$1B = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$N = /^(\d+)\./i;
const parseOrdinalNumberPattern$N = /\d+/i;

const matchEraPatterns$N = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
  wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i,
};
const parseEraPatterns$N = {
  any: [/^pr/i, /^(po|nova)/i],
};

const matchQuarterPatterns$N = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i,
};
const parseQuarterPatterns$N = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$N = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
  wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i,
};
const parseMonthPatterns$N = {
  narrow: [
    /1/i,
    /2/i,
    /3/i,
    /4/i,
    /5/i,
    /6/i,
    /7/i,
    /8/i,
    /9/i,
    /10/i,
    /11/i,
    /12/i,
  ],

  abbreviated: [
    /^sij/i,
    /^velj/i,
    /^(ožu|ozu)/i,
    /^tra/i,
    /^svi/i,
    /^lip/i,
    /^srp/i,
    /^kol/i,
    /^ruj/i,
    /^lis/i,
    /^stu/i,
    /^pro/i,
  ],

  wide: [
    /^sij/i,
    /^velj/i,
    /^(ožu|ozu)/i,
    /^tra/i,
    /^svi/i,
    /^lip/i,
    /^srp/i,
    /^kol/i,
    /^ruj/i,
    /^lis/i,
    /^stu/i,
    /^pro/i,
  ],
};

const matchDayPatterns$N = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i,
};
const parseDayPatterns$N = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns$N = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i,
};
const parseDayPeriodPatterns$N = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(navece|naveče)/i,
    night: /(nocu|noću)/i,
  },
};

(match$N.match = {
  ordinalNumber: (0, _index2$1B.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$N,
    parsePattern: parseOrdinalNumberPattern$N,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$3g.buildMatchFn)({
    matchPatterns: matchEraPatterns$N,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$N,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3g.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$N,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$N,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3g.buildMatchFn)({
    matchPatterns: matchMonthPatterns$N,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$N,
    defaultParseWidth: "wide",
  }),

  day: (0, _index$3g.buildMatchFn)({
    matchPatterns: matchDayPatterns$N,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$N,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3g.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$N,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$N,
    defaultParseWidth: "any",
  }),
});

hr.hr = void 0;
var _index$3f = formatDistance$1z;
var _index2$1A = formatLong$O;
var _index3$O = formatRelative$1z;
var _index4$O = localize$N;
var _index5$O = match$N;

/**
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon](https://github.com/silvenon)
 * @author Manico [@manico](https://github.com/manico)
 * @author Ivan Jeržabek [@jerzabek](https://github.com/jerzabek)
 */
(hr.hr = {
  code: "hr",
  formatDistance: _index$3f.formatDistance,
  formatLong: _index2$1A.formatLong,
  formatRelative: _index3$O.formatRelative,
  localize: _index4$O.localize,
  match: _index5$O.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var ht = {};

var formatDistance$1x = {};

formatDistance$1x.formatDistance = void 0;

const formatDistanceLocale$L = {
  lessThanXSeconds: {
    one: "mwens pase yon segond",
    other: "mwens pase {{count}} segond",
  },

  xSeconds: {
    one: "1 segond",
    other: "{{count}} segond",
  },

  halfAMinute: "30 segond",

  lessThanXMinutes: {
    one: "mwens pase yon minit",
    other: "mwens pase {{count}} minit",
  },

  xMinutes: {
    one: "1 minit",
    other: "{{count}} minit",
  },

  aboutXHours: {
    one: "anviwon inè",
    other: "anviwon {{count}} è",
  },

  xHours: {
    one: "1 lè",
    other: "{{count}} lè",
  },

  xDays: {
    one: "1 jou",
    other: "{{count}} jou",
  },

  aboutXWeeks: {
    one: "anviwon 1 semèn",
    other: "anviwon {{count}} semèn",
  },

  xWeeks: {
    one: "1 semèn",
    other: "{{count}} semèn",
  },

  aboutXMonths: {
    one: "anviwon 1 mwa",
    other: "anviwon {{count}} mwa",
  },

  xMonths: {
    one: "1 mwa",
    other: "{{count}} mwa",
  },

  aboutXYears: {
    one: "anviwon 1 an",
    other: "anviwon {{count}} an",
  },

  xYears: {
    one: "1 an",
    other: "{{count}} an",
  },

  overXYears: {
    one: "plis pase 1 an",
    other: "plis pase {{count}} an",
  },

  almostXYears: {
    one: "prèske 1 an",
    other: "prèske {{count}} an",
  },
};

const formatDistance$1w = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$L[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "nan " + result;
    } else {
      return "sa fè " + result;
    }
  }

  return result;
};
formatDistance$1x.formatDistance = formatDistance$1w;

var formatLong$N = {};

formatLong$N.formatLong = void 0;
var _index$3e = buildFormatLongFn$1;

const dateFormats$N = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats$N = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$N = {
  full: "{{date}} 'nan lè' {{time}}",
  long: "{{date}} 'nan lè' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$N.formatLong = {
  date: (0, _index$3e.buildFormatLongFn)({
    formats: dateFormats$N,
    defaultWidth: "full",
  }),

  time: (0, _index$3e.buildFormatLongFn)({
    formats: timeFormats$N,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3e.buildFormatLongFn)({
    formats: dateTimeFormats$N,
    defaultWidth: "full",
  }),
});

var formatRelative$1x = {};

formatRelative$1x.formatRelative = void 0;

const formatRelativeLocale$M = {
  lastWeek: "eeee 'pase nan lè' p",
  yesterday: "'yè nan lè' p",
  today: "'jodi a' p",
  tomorrow: "'demen nan lè' p'",
  nextWeek: "eeee 'pwochen nan lè' p",
  other: "P",
};

const formatRelative$1w = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$M[token];
formatRelative$1x.formatRelative = formatRelative$1w;

var localize$M = {};

localize$M.localize = void 0;
var _index$3d = buildLocalizeFn$1;

const eraValues$M = {
  narrow: ["av. J.-K", "ap. J.-K"],
  abbreviated: ["av. J.-K", "ap. J.-K"],
  wide: ["anvan Jezi Kris", "apre Jezi Kris"],
};

const quarterValues$M = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1ye trim.", "2yèm trim.", "3yèm trim.", "4yèm trim."],
  wide: ["1ye trimès", "2yèm trimès", "3yèm trimès", "4yèm trimès"],
};

const monthValues$M = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "fevr.",
    "mas",
    "avr.",
    "me",
    "jen",
    "jiyè",
    "out",
    "sept.",
    "okt.",
    "nov.",
    "des.",
  ],

  wide: [
    "janvye",
    "fevrye",
    "mas",
    "avril",
    "me",
    "jen",
    "jiyè",
    "out",
    "septanm",
    "oktòb",
    "novanm",
    "desanm",
  ],
};

const dayValues$M = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "le", "ma", "mè", "je", "va", "sa"],
  abbreviated: ["dim.", "len.", "mad.", "mèk.", "jed.", "van.", "sam."],

  wide: ["dimanch", "lendi", "madi", "mèkredi", "jedi", "vandredi", "samdi"],
};

const dayPeriodValues$M = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "swa",
    night: "mat.",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "maten",
    afternoon: "aprèmidi",
    evening: "swa",
    night: "maten",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "nan maten",
    afternoon: "nan aprèmidi",
    evening: "nan aswè",
    night: "nan maten",
  },
};

const ordinalNumber$M = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  if (number === 0) return String(number);

  const suffix = number === 1 ? "ye" : "yèm";

  return number + suffix;
};

(localize$M.localize = {
  ordinalNumber: ordinalNumber$M,

  era: (0, _index$3d.buildLocalizeFn)({
    values: eraValues$M,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$3d.buildLocalizeFn)({
    values: quarterValues$M,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$3d.buildLocalizeFn)({
    values: monthValues$M,
    defaultWidth: "wide",
  }),

  day: (0, _index$3d.buildLocalizeFn)({
    values: dayValues$M,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$3d.buildLocalizeFn)({
    values: dayPeriodValues$M,
    defaultWidth: "wide",
  }),
});

var match$M = {};

match$M.match = void 0;

var _index$3c = buildMatchFn$1;
var _index2$1z = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$M = /^(\d+)(ye|yèm)?/i;
const parseOrdinalNumberPattern$M = /\d+/i;

const matchEraPatterns$M = {
  narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
  abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
  wide: /^(avan Jezi Kris|apre Jezi Kris)/i,
};
const parseEraPatterns$M = {
  any: [/^av/i, /^ap/i],
};

const matchQuarterPatterns$M = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](ye|yèm)? trimès/i,
};
const parseQuarterPatterns$M = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$M = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
  wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i,
};
const parseMonthPatterns$M = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^o/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^av/i,
    /^me/i,
    /^je/i,
    /^ji/i,
    /^ou/i,
    /^s/i,
    /^ok/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$M = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|le|ma|me|je|va|sa)/i,
  abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
  wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i,
};
const parseDayPatterns$M = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^le/i, /^ma/i, /^mè/i, /^je/i, /^va/i, /^sa/i],
};

const matchDayPeriodPatterns$M = {
  narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
  any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i,
};
const parseDayPeriodPatterns$M = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /sw/i,
    night: /nwit/i,
  },
};

(match$M.match = {
  ordinalNumber: (0, _index2$1z.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$M,
    parsePattern: parseOrdinalNumberPattern$M,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$3c.buildMatchFn)({
    matchPatterns: matchEraPatterns$M,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$M,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$3c.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$M,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$M,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$3c.buildMatchFn)({
    matchPatterns: matchMonthPatterns$M,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$M,
    defaultParseWidth: "any",
  }),

  day: (0, _index$3c.buildMatchFn)({
    matchPatterns: matchDayPatterns$M,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$M,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$3c.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$M,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$M,
    defaultParseWidth: "any",
  }),
});

ht.ht = void 0;
var _index$3b = formatDistance$1x;
var _index2$1y = formatLong$N;
var _index3$N = formatRelative$1x;
var _index4$N = localize$M;
var _index5$N = match$M;

/**
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo](https://github.com/rmariuzzo)
 * @author Watson Marcelain [@watsongm24](https://github.com/watsongm24)
 */
(ht.ht = {
  code: "ht",
  formatDistance: _index$3b.formatDistance,
  formatLong: _index2$1y.formatLong,
  formatRelative: _index3$N.formatRelative,
  localize: _index4$N.localize,
  match: _index5$N.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var hu = {};

var formatDistance$1v = {};

formatDistance$1v.formatDistance = void 0;

const translations$1 = {
  about: "körülbelül",
  over: "több mint",
  almost: "majdnem",
  lessthan: "kevesebb mint",
};

const withoutSuffixes = {
  xseconds: " másodperc",
  halfaminute: "fél perc",
  xminutes: " perc",
  xhours: " óra",
  xdays: " nap",
  xweeks: " hét",
  xmonths: " hónap",
  xyears: " év",
};

const withSuffixes = {
  xseconds: {
    "-1": " másodperccel ezelőtt",
    1: " másodperc múlva",
    0: " másodperce",
  },
  halfaminute: {
    "-1": "fél perccel ezelőtt",
    1: "fél perc múlva",
    0: "fél perce",
  },
  xminutes: {
    "-1": " perccel ezelőtt",
    1: " perc múlva",
    0: " perce",
  },
  xhours: {
    "-1": " órával ezelőtt",
    1: " óra múlva",
    0: " órája",
  },
  xdays: {
    "-1": " nappal ezelőtt",
    1: " nap múlva",
    0: " napja",
  },
  xweeks: {
    "-1": " héttel ezelőtt",
    1: " hét múlva",
    0: " hete",
  },
  xmonths: {
    "-1": " hónappal ezelőtt",
    1: " hónap múlva",
    0: " hónapja",
  },
  xyears: {
    "-1": " évvel ezelőtt",
    1: " év múlva",
    0: " éve",
  },
};

const formatDistance$1u = (token, count, options) => {
  const adverb = token.match(/about|over|almost|lessthan/i);
  const unit = adverb ? token.replace(adverb[0], "") : token;

  const addSuffix = options?.addSuffix === true;
  const key = unit.toLowerCase();
  const comparison = options?.comparison || 0;

  const translated = addSuffix
    ? withSuffixes[key][comparison]
    : withoutSuffixes[key];

  let result = key === "halfaminute" ? translated : count + translated;

  if (adverb) {
    const adv = adverb[0].toLowerCase();
    result = translations$1[adv] + " " + result;
  }

  return result;
};
formatDistance$1v.formatDistance = formatDistance$1u;

var formatLong$M = {};

formatLong$M.formatLong = void 0;
var _index$3a = buildFormatLongFn$1;

const dateFormats$M = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd.",
};

const timeFormats$M = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$M = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$M.formatLong = {
  date: (0, _index$3a.buildFormatLongFn)({
    formats: dateFormats$M,
    defaultWidth: "full",
  }),

  time: (0, _index$3a.buildFormatLongFn)({
    formats: timeFormats$M,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3a.buildFormatLongFn)({
    formats: dateTimeFormats$M,
    defaultWidth: "full",
  }),
});

var formatRelative$1v = {};

formatRelative$1v.formatRelative = void 0;

const accusativeWeekdays$4 = [
  "vasárnap",
  "hétfőn",
  "kedden",
  "szerdán",
  "csütörtökön",
  "pénteken",
  "szombaton",
];

function week(isFuture) {
  return (date) => {
    const weekday = accusativeWeekdays$4[date.getDay()];
    const prefix = isFuture ? "" : "'múlt' ";
    return `${prefix}'${weekday}' p'-kor'`;
  };
}
const formatRelativeLocale$L = {
  lastWeek: week(false),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: week(true),
  other: "P",
};

const formatRelative$1u = (token, date) => {
  const format = formatRelativeLocale$L[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$1v.formatRelative = formatRelative$1u;

var localize$L = {};

localize$L.localize = void 0;
var _index$39 = buildLocalizeFn$1;

const eraValues$L = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus előtt", "időszámításunk szerint"],
};

const quarterValues$L = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.év", "2. n.év", "3. n.év", "4. n.év"],
  wide: ["1. negyedév", "2. negyedév", "3. negyedév", "4. negyedév"],
};

const formattingQuarterValues$3 = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.év", "II. n.év", "III. n.év", "IV. n.év"],
  wide: ["I. negyedév", "II. negyedév", "III. negyedév", "IV. negyedév"],
};

const monthValues$L = {
  narrow: ["J", "F", "M", "Á", "M", "J", "J", "A", "Sz", "O", "N", "D"],

  abbreviated: [
    "jan.",
    "febr.",
    "márc.",
    "ápr.",
    "máj.",
    "jún.",
    "júl.",
    "aug.",
    "szept.",
    "okt.",
    "nov.",
    "dec.",
  ],

  wide: [
    "január",
    "február",
    "március",
    "április",
    "május",
    "június",
    "július",
    "augusztus",
    "szeptember",
    "október",
    "november",
    "december",
  ],
};

const dayValues$L = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: [
    "vasárnap",
    "hétfő",
    "kedd",
    "szerda",
    "csütörtök",
    "péntek",
    "szombat",
  ],
};

const dayPeriodValues$L = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel",
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel",
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "délután",
    evening: "este",
    night: "éjjel",
  },
};

const ordinalNumber$L = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$L.localize = {
  ordinalNumber: ordinalNumber$L,

  era: (0, _index$39.buildLocalizeFn)({
    values: eraValues$L,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$39.buildLocalizeFn)({
    values: quarterValues$L,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
    formattingValues: formattingQuarterValues$3,
    defaultFormattingWidth: "wide",
  }),

  month: (0, _index$39.buildLocalizeFn)({
    values: monthValues$L,
    defaultWidth: "wide",
  }),

  day: (0, _index$39.buildLocalizeFn)({
    values: dayValues$L,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$39.buildLocalizeFn)({
    values: dayPeriodValues$L,
    defaultWidth: "wide",
  }),
});

var match$L = {};

match$L.match = void 0;

var _index$38 = buildMatchFn$1;
var _index2$1x = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$L = /^(\d+)\.?/i;
const parseOrdinalNumberPattern$L = /\d+/i;

const matchEraPatterns$L = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i,
};
const parseEraPatterns$L = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i],
};

const matchQuarterPatterns$L = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i,
};
const parseQuarterPatterns$L = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i],
};

const matchMonthPatterns$L = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated:
    /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i,
};
const parseMonthPatterns$L = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a|á/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s|sz/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^már/i,
    /^áp/i,
    /^máj/i,
    /^jún/i,
    /^júl/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$L = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i,
};
const parseDayPatterns$L = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i],
};

const matchDayPeriodPatterns$L = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i,
};
const parseDayPeriodPatterns$L = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i,
  },
};

(match$L.match = {
  ordinalNumber: (0, _index2$1x.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$L,
    parsePattern: parseOrdinalNumberPattern$L,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$38.buildMatchFn)({
    matchPatterns: matchEraPatterns$L,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$L,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$38.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$L,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$L,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$38.buildMatchFn)({
    matchPatterns: matchMonthPatterns$L,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$L,
    defaultParseWidth: "any",
  }),

  day: (0, _index$38.buildMatchFn)({
    matchPatterns: matchDayPatterns$L,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$L,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$38.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$L,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$L,
    defaultParseWidth: "any",
  }),
});

hu.hu = void 0;
var _index$37 = formatDistance$1v;
var _index2$1w = formatLong$M;
var _index3$M = formatRelative$1v;
var _index4$M = localize$L;
var _index5$M = match$L;

/**
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak](https://github.com/pshpak)
 * @author Eduardo Pardo [@eduardopsll](https://github.com/eduardopsll)
 * @author Zoltan Szepesi [@twodcube](https://github.com/twodcube)
 */
(hu.hu = {
  code: "hu",
  formatDistance: _index$37.formatDistance,
  formatLong: _index2$1w.formatLong,
  formatRelative: _index3$M.formatRelative,
  localize: _index4$M.localize,
  match: _index5$M.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var hy = {};

var formatDistance$1t = {};

formatDistance$1t.formatDistance = void 0;

const formatDistanceLocale$K = {
  lessThanXSeconds: {
    one: "ավելի քիչ քան 1 վայրկյան",
    other: "ավելի քիչ քան {{count}} վայրկյան",
  },

  xSeconds: {
    one: "1 վայրկյան",
    other: "{{count}} վայրկյան",
  },

  halfAMinute: "կես րոպե",

  lessThanXMinutes: {
    one: "ավելի քիչ քան 1 րոպե",
    other: "ավելի քիչ քան {{count}} րոպե",
  },

  xMinutes: {
    one: "1 րոպե",
    other: "{{count}} րոպե",
  },

  aboutXHours: {
    one: "մոտ 1 ժամ",
    other: "մոտ {{count}} ժամ",
  },

  xHours: {
    one: "1 ժամ",
    other: "{{count}} ժամ",
  },

  xDays: {
    one: "1 օր",
    other: "{{count}} օր",
  },

  aboutXWeeks: {
    one: "մոտ 1 շաբաթ",
    other: "մոտ {{count}} շաբաթ",
  },

  xWeeks: {
    one: "1 շաբաթ",
    other: "{{count}} շաբաթ",
  },

  aboutXMonths: {
    one: "մոտ 1 ամիս",
    other: "մոտ {{count}} ամիս",
  },

  xMonths: {
    one: "1 ամիս",
    other: "{{count}} ամիս",
  },

  aboutXYears: {
    one: "մոտ 1 տարի",
    other: "մոտ {{count}} տարի",
  },

  xYears: {
    one: "1 տարի",
    other: "{{count}} տարի",
  },

  overXYears: {
    one: "ավելի քան 1 տարի",
    other: "ավելի քան {{count}} տարի",
  },

  almostXYears: {
    one: "համարյա 1 տարի",
    other: "համարյա {{count}} տարի",
  },
};

const formatDistance$1s = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$K[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " հետո";
    } else {
      return result + " առաջ";
    }
  }

  return result;
};
formatDistance$1t.formatDistance = formatDistance$1s;

var formatLong$L = {};

formatLong$L.formatLong = void 0;
var _index$36 = buildFormatLongFn$1;

const dateFormats$L = {
  full: "d MMMM, y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd.MM.yyyy",
};

const timeFormats$L = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$L = {
  full: "{{date}} 'ժ․'{{time}}",
  long: "{{date}} 'ժ․'{{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$L.formatLong = {
  date: (0, _index$36.buildFormatLongFn)({
    formats: dateFormats$L,
    defaultWidth: "full",
  }),

  time: (0, _index$36.buildFormatLongFn)({
    formats: timeFormats$L,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$36.buildFormatLongFn)({
    formats: dateTimeFormats$L,
    defaultWidth: "full",
  }),
});

var formatRelative$1t = {};

formatRelative$1t.formatRelative = void 0;

const formatRelativeLocale$K = {
  lastWeek: "'նախորդ' eeee p'֊ին'",
  yesterday: "'երեկ' p'֊ին'",
  today: "'այսօր' p'֊ին'",
  tomorrow: "'վաղը' p'֊ին'",
  nextWeek: "'հաջորդ' eeee p'֊ին'",
  other: "P",
};

const formatRelative$1s = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$K[token];
formatRelative$1t.formatRelative = formatRelative$1s;

var localize$K = {};

localize$K.localize = void 0;
var _index$35 = buildLocalizeFn$1;

const eraValues$K = {
  narrow: ["Ք", "Մ"],
  abbreviated: ["ՔԱ", "ՄԹ"],
  wide: ["Քրիստոսից առաջ", "Մեր թվարկության"],
};

const quarterValues$K = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ք1", "Ք2", "Ք3", "Ք4"],
  wide: ["1֊ին քառորդ", "2֊րդ քառորդ", "3֊րդ քառորդ", "4֊րդ քառորդ"],
};

const monthValues$K = {
  narrow: ["Հ", "Փ", "Մ", "Ա", "Մ", "Հ", "Հ", "Օ", "Ս", "Հ", "Ն", "Դ"],
  abbreviated: [
    "հուն",
    "փետ",
    "մար",
    "ապր",
    "մայ",
    "հուն",
    "հուլ",
    "օգս",
    "սեպ",
    "հոկ",
    "նոյ",
    "դեկ",
  ],

  wide: [
    "հունվար",
    "փետրվար",
    "մարտ",
    "ապրիլ",
    "մայիս",
    "հունիս",
    "հուլիս",
    "օգոստոս",
    "սեպտեմբեր",
    "հոկտեմբեր",
    "նոյեմբեր",
    "դեկտեմբեր",
  ],
};

const dayValues$K = {
  narrow: ["Կ", "Ե", "Ե", "Չ", "Հ", "Ո", "Շ"],
  short: ["կր", "եր", "եք", "չք", "հգ", "ուր", "շբ"],
  abbreviated: ["կիր", "երկ", "երք", "չոր", "հնգ", "ուրբ", "շաբ"],
  wide: [
    "կիրակի",
    "երկուշաբթի",
    "երեքշաբթի",
    "չորեքշաբթի",
    "հինգշաբթի",
    "ուրբաթ",
    "շաբաթ",
  ],
};

const dayPeriodValues$K = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր",
  },
};

const formattingDayPeriodValues$C = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը",
  },
};

const ordinalNumber$K = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  const rem100 = number % 100;
  if (rem100 < 10) {
    if (rem100 % 10 === 1) {
      return number + "֊ին";
    }
  }
  return number + "֊րդ";
};

(localize$K.localize = {
  ordinalNumber: ordinalNumber$K,

  era: (0, _index$35.buildLocalizeFn)({
    values: eraValues$K,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$35.buildLocalizeFn)({
    values: quarterValues$K,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$35.buildLocalizeFn)({
    values: monthValues$K,
    defaultWidth: "wide",
  }),

  day: (0, _index$35.buildLocalizeFn)({
    values: dayValues$K,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$35.buildLocalizeFn)({
    values: dayPeriodValues$K,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$C,
    defaultFormattingWidth: "wide",
  }),
});

var match$K = {};

match$K.match = void 0;

var _index$34 = buildMatchFn$1;
var _index2$1v = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$K = /^(\d+)((-|֊)?(ին|րդ))?/i;
const parseOrdinalNumberPattern$K = /\d+/i;

const matchEraPatterns$K = {
  narrow: /^(Ք|Մ)/i,
  abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
  wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i,
};
const parseEraPatterns$K = {
  any: [/^ք/i, /^մ/i],
};

const matchQuarterPatterns$K = {
  narrow: /^[1234]/i,
  abbreviated: /^ք[1234]/i,
  wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i,
};
const parseQuarterPatterns$K = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$K = {
  narrow: /^[հփմաօսնդ]/i,
  abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
  wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i,
};
const parseMonthPatterns$K = {
  narrow: [
    /^հ/i,
    /^փ/i,
    /^մ/i,
    /^ա/i,
    /^մ/i,
    /^հ/i,
    /^հ/i,
    /^օ/i,
    /^ս/i,
    /^հ/i,
    /^ն/i,
    /^դ/i,
  ],

  any: [
    /^հու/i,
    /^փ/i,
    /^մար/i,
    /^ա/i,
    /^մայ/i,
    /^հուն/i,
    /^հուլ/i,
    /^օ/i,
    /^ս/i,
    /^հոկ/i,
    /^ն/i,
    /^դ/i,
  ],
};

const matchDayPatterns$K = {
  narrow: /^[եչհոշկ]/i,
  short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
  abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
  wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i,
};
const parseDayPatterns$K = {
  narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],

  wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
};

const matchDayPeriodPatterns$K = {
  narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
  any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
};
const parseDayPeriodPatterns$K = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /կեսգիշեր/i,
    noon: /կեսօր/i,
    morning: /առավոտ/i,
    afternoon: /ցերեկ/i,
    evening: /երեկո/i,
    night: /գիշեր/i,
  },
};

(match$K.match = {
  ordinalNumber: (0, _index2$1v.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$K,
    parsePattern: parseOrdinalNumberPattern$K,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$34.buildMatchFn)({
    matchPatterns: matchEraPatterns$K,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$K,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$34.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$K,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$K,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$34.buildMatchFn)({
    matchPatterns: matchMonthPatterns$K,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$K,
    defaultParseWidth: "any",
  }),

  day: (0, _index$34.buildMatchFn)({
    matchPatterns: matchDayPatterns$K,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$K,
    defaultParseWidth: "wide",
  }),

  dayPeriod: (0, _index$34.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$K,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$K,
    defaultParseWidth: "any",
  }),
});

hy.hy = void 0;
var _index$33 = formatDistance$1t;
var _index2$1u = formatLong$L;
var _index3$L = formatRelative$1t;
var _index4$L = localize$K;
var _index5$L = match$K;

/**
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan](https://github.com/alexigityan)
 */
(hy.hy = {
  code: "hy",
  formatDistance: _index$33.formatDistance,
  formatLong: _index2$1u.formatLong,
  formatRelative: _index3$L.formatRelative,
  localize: _index4$L.localize,
  match: _index5$L.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var id = {};

var formatDistance$1r = {};

formatDistance$1r.formatDistance = void 0;

const formatDistanceLocale$J = {
  lessThanXSeconds: {
    one: "kurang dari 1 detik",
    other: "kurang dari {{count}} detik",
  },

  xSeconds: {
    one: "1 detik",
    other: "{{count}} detik",
  },

  halfAMinute: "setengah menit",

  lessThanXMinutes: {
    one: "kurang dari 1 menit",
    other: "kurang dari {{count}} menit",
  },

  xMinutes: {
    one: "1 menit",
    other: "{{count}} menit",
  },

  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam",
  },

  xHours: {
    one: "1 jam",
    other: "{{count}} jam",
  },

  xDays: {
    one: "1 hari",
    other: "{{count}} hari",
  },

  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu",
  },

  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu",
  },

  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan",
  },

  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan",
  },

  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun",
  },

  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun",
  },

  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun",
  },

  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun",
  },
};

const formatDistance$1q = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$J[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "dalam waktu " + result;
    } else {
      return result + " yang lalu";
    }
  }

  return result;
};
formatDistance$1r.formatDistance = formatDistance$1q;

var formatLong$K = {};

formatLong$K.formatLong = void 0;
var _index$32 = buildFormatLongFn$1;

const dateFormats$K = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy",
};

const timeFormats$K = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm",
};

const dateTimeFormats$K = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$K.formatLong = {
  date: (0, _index$32.buildFormatLongFn)({
    formats: dateFormats$K,
    defaultWidth: "full",
  }),

  time: (0, _index$32.buildFormatLongFn)({
    formats: timeFormats$K,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$32.buildFormatLongFn)({
    formats: dateTimeFormats$K,
    defaultWidth: "full",
  }),
});

var formatRelative$1r = {};

formatRelative$1r.formatRelative = void 0;

const formatRelativeLocale$J = {
  lastWeek: "eeee 'lalu pukul' p",
  yesterday: "'Kemarin pukul' p",
  today: "'Hari ini pukul' p",
  tomorrow: "'Besok pukul' p",
  nextWeek: "eeee 'pukul' p",
  other: "P",
};

const formatRelative$1q = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$J[token];
formatRelative$1r.formatRelative = formatRelative$1q;

var localize$J = {};

localize$J.localize = void 0;
var _index$31 = buildLocalizeFn$1;

// All data for localization are taken from this page
// https://www.unicode.org/cldr/charts/32/summary/id.html
const eraValues$J = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masehi", "Masehi"],
};

const quarterValues$J = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["Kuartal ke-1", "Kuartal ke-2", "Kuartal ke-3", "Kuartal ke-4"],
};

// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$J = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Agt",
    "Sep",
    "Okt",
    "Nov",
    "Des",
  ],

  wide: [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ],
};

const dayValues$J = {
  narrow: ["M", "S", "S", "R", "K", "J", "S"],
  short: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  abbreviated: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  wide: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
};

const dayPeriodValues$J = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam",
  },
};

const formattingDayPeriodValues$B = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam",
  },
};

const ordinalNumber$J = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  // Can't use "pertama", "kedua" because can't be parsed

  return "ke-" + number;
};

(localize$J.localize = {
  ordinalNumber: ordinalNumber$J,

  era: (0, _index$31.buildLocalizeFn)({
    values: eraValues$J,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$31.buildLocalizeFn)({
    values: quarterValues$J,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$31.buildLocalizeFn)({
    values: monthValues$J,
    defaultWidth: "wide",
  }),

  day: (0, _index$31.buildLocalizeFn)({
    values: dayValues$J,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$31.buildLocalizeFn)({
    values: dayPeriodValues$J,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$B,
    defaultFormattingWidth: "wide",
  }),
});

var match$J = {};

match$J.match = void 0;

var _index$30 = buildMatchFn$1;
var _index2$1t = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$J = /^ke-(\d+)?/i;
const parseOrdinalNumberPattern$J = /\d+/i;

const matchEraPatterns$J = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
  wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i,
};
const parseEraPatterns$J = {
  any: [/^s/i, /^(m|e)/i],
};

const matchQuarterPatterns$J = {
  narrow: /^[1234]/i,
  abbreviated: /^K-?\s[1234]/i,
  wide: /^Kuartal ke-?\s?[1234]/i,
};
const parseQuarterPatterns$J = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$J = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
  wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i,
};
const parseMonthPatterns$J = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^ap/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$J = {
  narrow: /^[srkjm]/i,
  short: /^(min|sen|sel|rab|kam|jum|sab)/i,
  abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
  wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i,
};
const parseDayPatterns$J = {
  narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i],
};

const matchDayPeriodPatterns$J = {
  narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
};
const parseDayPeriodPatterns$J = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pagi/i,
    afternoon: /siang/i,
    evening: /sore/i,
    night: /malam/i,
  },
};

(match$J.match = {
  ordinalNumber: (0, _index2$1t.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$J,
    parsePattern: parseOrdinalNumberPattern$J,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$30.buildMatchFn)({
    matchPatterns: matchEraPatterns$J,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$J,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$30.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$J,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$J,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$30.buildMatchFn)({
    matchPatterns: matchMonthPatterns$J,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$J,
    defaultParseWidth: "any",
  }),

  day: (0, _index$30.buildMatchFn)({
    matchPatterns: matchDayPatterns$J,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$J,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$30.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$J,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$J,
    defaultParseWidth: "any",
  }),
});

id.id = void 0;
var _index$2$ = formatDistance$1r;
var _index2$1s = formatLong$K;
var _index3$K = formatRelative$1r;
var _index4$K = localize$J;
var _index5$K = match$J;

/**
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso](https://github.com/rbudiharso)
 * @author Benget Nata [@bentinata](https://github.com/bentinata)
 * @author Budi Irawan [@deerawan](https://github.com/deerawan)
 * @author Try Ajitiono [@imballinst](https://github.com/imballinst)
 */
(id.id = {
  code: "id",
  formatDistance: _index$2$.formatDistance,
  formatLong: _index2$1s.formatLong,
  formatRelative: _index3$K.formatRelative,
  localize: _index4$K.localize,
  match: _index5$K.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var is = {};

var formatDistance$1p = {};

formatDistance$1p.formatDistance = void 0;

const formatDistanceLocale$I = {
  lessThanXSeconds: {
    one: "minna en 1 sekúnda",
    other: "minna en {{count}} sekúndur",
  },

  xSeconds: {
    one: "1 sekúnda",
    other: "{{count}} sekúndur",
  },

  halfAMinute: "hálf mínúta",

  lessThanXMinutes: {
    one: "minna en 1 mínúta",
    other: "minna en {{count}} mínútur",
  },

  xMinutes: {
    one: "1 mínúta",
    other: "{{count}} mínútur",
  },

  aboutXHours: {
    one: "u.þ.b. 1 klukkustund",
    other: "u.þ.b. {{count}} klukkustundir",
  },

  xHours: {
    one: "1 klukkustund",
    other: "{{count}} klukkustundir",
  },

  xDays: {
    one: "1 dagur",
    other: "{{count}} dagar",
  },

  aboutXWeeks: {
    one: "um viku",
    other: "um {{count}} vikur",
  },

  xWeeks: {
    one: "1 viku",
    other: "{{count}} vikur",
  },

  aboutXMonths: {
    one: "u.þ.b. 1 mánuður",
    other: "u.þ.b. {{count}} mánuðir",
  },

  xMonths: {
    one: "1 mánuður",
    other: "{{count}} mánuðir",
  },

  aboutXYears: {
    one: "u.þ.b. 1 ár",
    other: "u.þ.b. {{count}} ár",
  },

  xYears: {
    one: "1 ár",
    other: "{{count}} ár",
  },

  overXYears: {
    one: "meira en 1 ár",
    other: "meira en {{count}} ár",
  },

  almostXYears: {
    one: "næstum 1 ár",
    other: "næstum {{count}} ár",
  },
};

const formatDistance$1o = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$I[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "í " + result;
    } else {
      return result + " síðan";
    }
  }

  return result;
};
formatDistance$1p.formatDistance = formatDistance$1o;

var formatLong$J = {};

formatLong$J.formatLong = void 0;
var _index$2_ = buildFormatLongFn$1;

const dateFormats$J = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "d.MM.y",
};

const timeFormats$J = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$J = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$J.formatLong = {
  date: (0, _index$2_.buildFormatLongFn)({
    formats: dateFormats$J,
    defaultWidth: "full",
  }),

  time: (0, _index$2_.buildFormatLongFn)({
    formats: timeFormats$J,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2_.buildFormatLongFn)({
    formats: dateTimeFormats$J,
    defaultWidth: "full",
  }),
});

var formatRelative$1p = {};

formatRelative$1p.formatRelative = void 0;

const formatRelativeLocale$I = {
  lastWeek: "'síðasta' dddd 'kl.' p",
  yesterday: "'í gær kl.' p",
  today: "'í dag kl.' p",
  tomorrow: "'á morgun kl.' p",
  nextWeek: "dddd 'kl.' p",
  other: "P",
};

const formatRelative$1o = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$I[token];
formatRelative$1p.formatRelative = formatRelative$1o;

var localize$I = {};

localize$I.localize = void 0;
var _index$2Z = buildLocalizeFn$1;

const eraValues$I = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["fyrir Krist", "eftir Krist"],
};

const quarterValues$I = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1F", "2F", "3F", "4F"],
  wide: ["1. fjórðungur", "2. fjórðungur", "3. fjórðungur", "4. fjórðungur"],
};

const monthValues$I = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "Á", "S", "Ó", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apríl",
    "maí",
    "júní",
    "júlí",
    "ágúst",
    "sept.",
    "okt.",
    "nóv.",
    "des.",
  ],

  wide: [
    "janúar",
    "febrúar",
    "mars",
    "apríl",
    "maí",
    "júní",
    "júlí",
    "ágúst",
    "september",
    "október",
    "nóvember",
    "desember",
  ],
};

const dayValues$I = {
  narrow: ["S", "M", "Þ", "M", "F", "F", "L"],
  short: ["Su", "Má", "Þr", "Mi", "Fi", "Fö", "La"],
  abbreviated: ["sun.", "mán.", "þri.", "mið.", "fim.", "fös.", "lau."],

  wide: [
    "sunnudagur",
    "mánudagur",
    "þriðjudagur",
    "miðvikudagur",
    "fimmtudagur",
    "föstudagur",
    "laugardagur",
  ],
};

const dayPeriodValues$I = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt",
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt",
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt",
  },
};

const formattingDayPeriodValues$A = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt",
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt",
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt",
  },
};

const ordinalNumber$I = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  return number + ".";
};

(localize$I.localize = {
  ordinalNumber: ordinalNumber$I,

  era: (0, _index$2Z.buildLocalizeFn)({
    values: eraValues$I,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2Z.buildLocalizeFn)({
    values: quarterValues$I,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2Z.buildLocalizeFn)({
    values: monthValues$I,
    defaultWidth: "wide",
  }),

  day: (0, _index$2Z.buildLocalizeFn)({
    values: dayValues$I,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2Z.buildLocalizeFn)({
    values: dayPeriodValues$I,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$A,
    defaultFormattingWidth: "wide",
  }),
});

var match$I = {};

match$I.match = void 0;

var _index$2Y = buildMatchFn$1;
var _index2$1r = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$I = /^(\d+)(\.)?/i;
const parseOrdinalNumberPattern$I = /\d+(\.)?/i;

const matchEraPatterns$I = {
  narrow: /^(f\.Kr\.|e\.Kr\.)/i,
  abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
  wide: /^(fyrir Krist|eftir Krist)/i,
};
const parseEraPatterns$I = {
  any: [/^(f\.Kr\.)/i, /^(e\.Kr\.)/i],
};

const matchQuarterPatterns$I = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^q[1234]\.?/i,
  wide: /^[1234]\.? fjórðungur/i,
};
const parseQuarterPatterns$I = {
  any: [/1\.?/i, /2\.?/i, /3\.?/i, /4\.?/i],
};

const matchMonthPatterns$I = {
  narrow: /^[jfmásónd]/i,
  abbreviated:
    /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
  wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i,
};

const parseMonthPatterns$I = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^á/i,
    /^s/i,
    /^ó/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maí/i,
    /^jún/i,
    /^júl/i,
    /^áu/i,
    /^s/i,
    /^ó/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$I = {
  narrow: /^[smtwf]/i,
  short: /^(su|má|þr|mi|fi|fö|la)/i,
  abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
  wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i,
};
const parseDayPatterns$I = {
  narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
  any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i],
};

const matchDayPeriodPatterns$I = {
  narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
  any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
};
const parseDayPeriodPatterns$I = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^mi/i,
    noon: /^há/i,
    morning: /morgunn/i,
    afternoon: /síðdegi/i,
    evening: /kvöld/i,
    night: /nótt/i,
  },
};

(match$I.match = {
  ordinalNumber: (0, _index2$1r.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$I,
    parsePattern: parseOrdinalNumberPattern$I,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$2Y.buildMatchFn)({
    matchPatterns: matchEraPatterns$I,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$I,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2Y.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$I,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$I,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2Y.buildMatchFn)({
    matchPatterns: matchMonthPatterns$I,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$I,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2Y.buildMatchFn)({
    matchPatterns: matchDayPatterns$I,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$I,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2Y.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$I,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$I,
    defaultParseWidth: "any",
  }),
});

is.is = void 0;
var _index$2X = formatDistance$1p;
var _index2$1q = formatLong$J;
var _index3$J = formatRelative$1p;
var _index4$J = localize$I;
var _index5$J = match$I;

/**
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank](https://github.com/derekblank)
 * @author Arnór Ýmir [@lamayg](https://github.com/lamayg)
 */
(is.is = {
  code: "is",
  formatDistance: _index$2X.formatDistance,
  formatLong: _index2$1q.formatLong,
  formatRelative: _index3$J.formatRelative,
  localize: _index4$J.localize,
  match: _index5$J.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var it = {};

var formatDistance$1n = {};

formatDistance$1n.formatDistance = void 0;

const formatDistanceLocale$H = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi",
  },

  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi",
  },

  halfAMinute: "alcuni secondi",

  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti",
  },

  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti",
  },

  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore",
  },

  xHours: {
    one: "un'ora",
    other: "{{count}} ore",
  },

  xDays: {
    one: "un giorno",
    other: "{{count}} giorni",
  },

  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane",
  },

  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane",
  },

  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi",
  },

  xMonths: {
    one: "un mese",
    other: "{{count}} mesi",
  },

  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni",
  },

  xYears: {
    one: "un anno",
    other: "{{count}} anni",
  },

  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni",
  },

  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni",
  },
};

const formatDistance$1m = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$H[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "tra " + result;
    } else {
      return result + " fa";
    }
  }

  return result;
};
formatDistance$1n.formatDistance = formatDistance$1m;

var formatLong$I = {};

formatLong$I.formatLong = void 0;
var _index$2W = buildFormatLongFn$1;

const dateFormats$I = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats$I = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$I = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$I.formatLong = {
  date: (0, _index$2W.buildFormatLongFn)({
    formats: dateFormats$I,
    defaultWidth: "full",
  }),

  time: (0, _index$2W.buildFormatLongFn)({
    formats: timeFormats$I,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2W.buildFormatLongFn)({
    formats: dateTimeFormats$I,
    defaultWidth: "full",
  }),
});

var formatRelative$1n = {};

formatRelative$1n.formatRelative = void 0;
var _index$2V = isSameWeek$1;

const weekdays$2 = [
  "domenica",
  "lunedì",
  "martedì",
  "mercoledì",
  "giovedì",
  "venerdì",
  "sabato",
];

function lastWeek$5(day) {
  switch (day) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + weekdays$2[day] + " scorso alle' p";
  }
}

function thisWeek$5(day) {
  return "'" + weekdays$2[day] + " alle' p";
}

function nextWeek$5(day) {
  switch (day) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + weekdays$2[day] + " prossimo alle' p";
  }
}

const formatRelativeLocale$H = {
  lastWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$2V.isSameWeek)(date, baseDate, options)) {
      return thisWeek$5(day);
    } else {
      return lastWeek$5(day);
    }
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$2V.isSameWeek)(date, baseDate, options)) {
      return thisWeek$5(day);
    } else {
      return nextWeek$5(day);
    }
  },
  other: "P",
};

const formatRelative$1m = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$H[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$1n.formatRelative = formatRelative$1m;

var localize$H = {};

localize$H.localize = void 0;
var _index$2U = buildLocalizeFn$1;

const eraValues$H = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"],
};

const quarterValues$H = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"],
};

const monthValues$H = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "gen",
    "feb",
    "mar",
    "apr",
    "mag",
    "giu",
    "lug",
    "ago",
    "set",
    "ott",
    "nov",
    "dic",
  ],

  wide: [
    "gennaio",
    "febbraio",
    "marzo",
    "aprile",
    "maggio",
    "giugno",
    "luglio",
    "agosto",
    "settembre",
    "ottobre",
    "novembre",
    "dicembre",
  ],
};

const dayValues$H = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: [
    "domenica",
    "lunedì",
    "martedì",
    "mercoledì",
    "giovedì",
    "venerdì",
    "sabato",
  ],
};

const dayPeriodValues$H = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte",
  },
};

const formattingDayPeriodValues$z = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte",
  },
};

const ordinalNumber$H = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return String(number);
};

(localize$H.localize = {
  ordinalNumber: ordinalNumber$H,

  era: (0, _index$2U.buildLocalizeFn)({
    values: eraValues$H,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2U.buildLocalizeFn)({
    values: quarterValues$H,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2U.buildLocalizeFn)({
    values: monthValues$H,
    defaultWidth: "wide",
  }),

  day: (0, _index$2U.buildLocalizeFn)({
    values: dayValues$H,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2U.buildLocalizeFn)({
    values: dayPeriodValues$H,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$z,
    defaultFormattingWidth: "wide",
  }),
});

var match$H = {};

match$H.match = void 0;

var _index$2T = buildMatchFn$1;
var _index2$1p = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$H = /^(\d+)(º)?/i;
const parseOrdinalNumberPattern$H = /\d+/i;

const matchEraPatterns$H = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i,
};
const parseEraPatterns$H = {
  any: [/^a/i, /^(d|e)/i],
};

const matchQuarterPatterns$H = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i,
};
const parseQuarterPatterns$H = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$H = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i,
};
const parseMonthPatterns$H = {
  narrow: [
    /^g/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^g/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ge/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mag/i,
    /^gi/i,
    /^l/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$H = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i,
};
const parseDayPatterns$H = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i],
};

const matchDayPeriodPatterns$H = {
  narrow:
    /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
};
const parseDayPeriodPatterns$H = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i,
  },
};

(match$H.match = {
  ordinalNumber: (0, _index2$1p.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$H,
    parsePattern: parseOrdinalNumberPattern$H,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$2T.buildMatchFn)({
    matchPatterns: matchEraPatterns$H,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$H,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2T.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$H,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$H,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2T.buildMatchFn)({
    matchPatterns: matchMonthPatterns$H,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$H,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2T.buildMatchFn)({
    matchPatterns: matchDayPatterns$H,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$H,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2T.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$H,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$H,
    defaultParseWidth: "any",
  }),
});

it.it = void 0;
var _index$2S = formatDistance$1n;
var _index2$1o = formatLong$I;
var _index3$I = formatRelative$1n;
var _index4$I = localize$H;
var _index5$I = match$H;

/**
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo](https://github.com/albertorestifo)
 * @author Giovanni Polimeni [@giofilo](https://github.com/giofilo)
 * @author Vincenzo Carrese [@vin-car](https://github.com/vin-car)
 */
(it.it = {
  code: "it",
  formatDistance: _index$2S.formatDistance,
  formatLong: _index2$1o.formatLong,
  formatRelative: _index3$I.formatRelative,
  localize: _index4$I.localize,
  match: _index5$I.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var itCH = {};

var formatLong$H = {};

formatLong$H.formatLong = void 0;
var _index$2R = buildFormatLongFn$1;

const dateFormats$H = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y",
};

const timeFormats$H = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$H = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$H.formatLong = {
  date: (0, _index$2R.buildFormatLongFn)({
    formats: dateFormats$H,
    defaultWidth: "full",
  }),

  time: (0, _index$2R.buildFormatLongFn)({
    formats: timeFormats$H,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2R.buildFormatLongFn)({
    formats: dateTimeFormats$H,
    defaultWidth: "full",
  }),
});

itCH.itCH = void 0;
var _index$2Q = formatDistance$1n;
var _index2$1n = formatRelative$1n;
var _index3$H = localize$H;
var _index4$H = match$H;
var _index5$H = formatLong$H;

/**
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66](https://github.com/maic66)
 */
(itCH.itCH = {
  code: "it-CH",
  formatDistance: _index$2Q.formatDistance,
  formatLong: _index5$H.formatLong,
  formatRelative: _index2$1n.formatRelative,
  localize: _index3$H.localize,
  match: _index4$H.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var ja = {};

var formatDistance$1l = {};

formatDistance$1l.formatDistance = void 0;

const formatDistanceLocale$G = {
  lessThanXSeconds: {
    one: "1秒未満",
    other: "{{count}}秒未満",
    oneWithSuffix: "約1秒",
    otherWithSuffix: "約{{count}}秒",
  },

  xSeconds: {
    one: "1秒",
    other: "{{count}}秒",
  },

  halfAMinute: "30秒",

  lessThanXMinutes: {
    one: "1分未満",
    other: "{{count}}分未満",
    oneWithSuffix: "約1分",
    otherWithSuffix: "約{{count}}分",
  },

  xMinutes: {
    one: "1分",
    other: "{{count}}分",
  },

  aboutXHours: {
    one: "約1時間",
    other: "約{{count}}時間",
  },

  xHours: {
    one: "1時間",
    other: "{{count}}時間",
  },

  xDays: {
    one: "1日",
    other: "{{count}}日",
  },

  aboutXWeeks: {
    one: "約1週間",
    other: "約{{count}}週間",
  },

  xWeeks: {
    one: "1週間",
    other: "{{count}}週間",
  },

  aboutXMonths: {
    one: "約1か月",
    other: "約{{count}}か月",
  },

  xMonths: {
    one: "1か月",
    other: "{{count}}か月",
  },

  aboutXYears: {
    one: "約1年",
    other: "約{{count}}年",
  },

  xYears: {
    one: "1年",
    other: "{{count}}年",
  },

  overXYears: {
    one: "1年以上",
    other: "{{count}}年以上",
  },

  almostXYears: {
    one: "1年近く",
    other: "{{count}}年近く",
  },
};

const formatDistance$1k = (token, count, options) => {
  options = options || {};

  let result;

  const tokenValue = formatDistanceLocale$G[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    if (options.addSuffix && tokenValue.oneWithSuffix) {
      result = tokenValue.oneWithSuffix;
    } else {
      result = tokenValue.one;
    }
  } else {
    if (options.addSuffix && tokenValue.otherWithSuffix) {
      result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    } else {
      result = tokenValue.other.replace("{{count}}", String(count));
    }
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + "後";
    } else {
      return result + "前";
    }
  }

  return result;
};
formatDistance$1l.formatDistance = formatDistance$1k;

var formatLong$G = {};

formatLong$G.formatLong = void 0;
var _index$2P = buildFormatLongFn$1;

const dateFormats$G = {
  full: "y年M月d日EEEE",
  long: "y年M月d日",
  medium: "y/MM/dd",
  short: "y/MM/dd",
};

const timeFormats$G = {
  full: "H時mm分ss秒 zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$G = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$G.formatLong = {
  date: (0, _index$2P.buildFormatLongFn)({
    formats: dateFormats$G,
    defaultWidth: "full",
  }),

  time: (0, _index$2P.buildFormatLongFn)({
    formats: timeFormats$G,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2P.buildFormatLongFn)({
    formats: dateTimeFormats$G,
    defaultWidth: "full",
  }),
});

var formatRelative$1l = {};

formatRelative$1l.formatRelative = void 0;

const formatRelativeLocale$G = {
  lastWeek: "先週のeeeeのp",
  yesterday: "昨日のp",
  today: "今日のp",
  tomorrow: "明日のp",
  nextWeek: "翌週のeeeeのp",
  other: "P",
};

const formatRelative$1k = (token, _date, _baseDate, _options) => {
  return formatRelativeLocale$G[token];
};
formatRelative$1l.formatRelative = formatRelative$1k;

var localize$G = {};

localize$G.localize = void 0;
var _index$2O = buildLocalizeFn$1;

const eraValues$G = {
  narrow: ["BC", "AC"],
  abbreviated: ["紀元前", "西暦"],
  wide: ["紀元前", "西暦"],
};

const quarterValues$G = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["第1四半期", "第2四半期", "第3四半期", "第4四半期"],
};

const monthValues$G = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],

  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ],

  wide: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ],
};

const dayValues$G = {
  narrow: ["日", "月", "火", "水", "木", "金", "土"],
  short: ["日", "月", "火", "水", "木", "金", "土"],
  abbreviated: ["日", "月", "火", "水", "木", "金", "土"],
  wide: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
};

const dayPeriodValues$G = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜",
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜",
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜",
  },
};
const formattingDayPeriodValues$y = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜",
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜",
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜",
  },
};

const ordinalNumber$G = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = String(options?.unit);

  switch (unit) {
    case "year":
      return `${number}年`;
    case "quarter":
      return `第${number}四半期`;
    case "month":
      return `${number}月`;
    case "week":
      return `第${number}週`;
    case "date":
      return `${number}日`;
    case "hour":
      return `${number}時`;
    case "minute":
      return `${number}分`;
    case "second":
      return `${number}秒`;
    default:
      return `${number}`;
  }
};

(localize$G.localize = {
  ordinalNumber: ordinalNumber$G,

  era: (0, _index$2O.buildLocalizeFn)({
    values: eraValues$G,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2O.buildLocalizeFn)({
    values: quarterValues$G,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1,
  }),

  month: (0, _index$2O.buildLocalizeFn)({
    values: monthValues$G,
    defaultWidth: "wide",
  }),

  day: (0, _index$2O.buildLocalizeFn)({
    values: dayValues$G,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2O.buildLocalizeFn)({
    values: dayPeriodValues$G,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$y,
    defaultFormattingWidth: "wide",
  }),
});

var match$G = {};

match$G.match = void 0;
var _index$2N = buildMatchPatternFn$1;
var _index2$1m = buildMatchFn$1;

const matchOrdinalNumberPattern$G = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
const parseOrdinalNumberPattern$G = /\d+/i;

const matchEraPatterns$G = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i,
};
const parseEraPatterns$G = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i],
};

const matchQuarterPatterns$G = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i,
};
const parseQuarterPatterns$G = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i],
};

const matchMonthPatterns$G = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i,
};
const parseMonthPatterns$G = {
  any: [
    /^1\D/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/,
  ],
};

const matchDayPatterns$G = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/,
};
const parseDayPatterns$G = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/],
};

const matchDayPeriodPatterns$G = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i,
};
const parseDayPeriodPatterns$G = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i,
  },
};

(match$G.match = {
  ordinalNumber: (0, _index$2N.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$G,
    parsePattern: parseOrdinalNumberPattern$G,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: (0, _index2$1m.buildMatchFn)({
    matchPatterns: matchEraPatterns$G,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$G,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index2$1m.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$G,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$G,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index2$1m.buildMatchFn)({
    matchPatterns: matchMonthPatterns$G,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$G,
    defaultParseWidth: "any",
  }),

  day: (0, _index2$1m.buildMatchFn)({
    matchPatterns: matchDayPatterns$G,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$G,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index2$1m.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$G,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$G,
    defaultParseWidth: "any",
  }),
});

ja.ja = void 0;
var _index$2M = formatDistance$1l;
var _index2$1l = formatLong$G;
var _index3$G = formatRelative$1l;
var _index4$G = localize$G;
var _index5$G = match$G;

/**
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu](https://github.com/DeMuu)
 * @author Yamagishi Kazutoshi [@ykzts](https://github.com/ykzts)
 * @author Luca Ban [@mesqueeb](https://github.com/mesqueeb)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 * @author Taiki IKeda [@so99ynoodles](https://github.com/so99ynoodles)
 */
(ja.ja = {
  code: "ja",
  formatDistance: _index$2M.formatDistance,
  formatLong: _index2$1l.formatLong,
  formatRelative: _index3$G.formatRelative,
  localize: _index4$G.localize,
  match: _index5$G.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var jaHira = {};

var formatDistance$1j = {};

formatDistance$1j.formatDistance = void 0;

const formatDistanceLocale$F = {
  lessThanXSeconds: {
    one: "1びょうみまん",
    other: "{{count}}びょうみまん",
    oneWithSuffix: "やく1びょう",
    otherWithSuffix: "やく{{count}}びょう",
  },

  xSeconds: {
    one: "1びょう",
    other: "{{count}}びょう",
  },

  halfAMinute: "30びょう",

  lessThanXMinutes: {
    one: "1ぷんみまん",
    other: "{{count}}ふんみまん",
    oneWithSuffix: "やく1ぷん",
    otherWithSuffix: "やく{{count}}ふん",
  },

  xMinutes: {
    one: "1ぷん",
    other: "{{count}}ふん",
  },

  aboutXHours: {
    one: "やく1じかん",
    other: "やく{{count}}じかん",
  },

  xHours: {
    one: "1じかん",
    other: "{{count}}じかん",
  },

  xDays: {
    one: "1にち",
    other: "{{count}}にち",
  },

  aboutXWeeks: {
    one: "やく1しゅうかん",
    other: "やく{{count}}しゅうかん",
  },

  xWeeks: {
    one: "1しゅうかん",
    other: "{{count}}しゅうかん",
  },

  aboutXMonths: {
    one: "やく1かげつ",
    other: "やく{{count}}かげつ",
  },

  xMonths: {
    one: "1かげつ",
    other: "{{count}}かげつ",
  },

  aboutXYears: {
    one: "やく1ねん",
    other: "やく{{count}}ねん",
  },

  xYears: {
    one: "1ねん",
    other: "{{count}}ねん",
  },

  overXYears: {
    one: "1ねんいじょう",
    other: "{{count}}ねんいじょう",
  },

  almostXYears: {
    one: "1ねんちかく",
    other: "{{count}}ねんちかく",
  },
};

const formatDistance$1i = (token, count, options) => {
  options = options || {};

  let result;

  const tokenValue = formatDistanceLocale$F[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    if (options.addSuffix && tokenValue.oneWithSuffix) {
      result = tokenValue.oneWithSuffix;
    } else {
      result = tokenValue.one;
    }
  } else {
    if (options.addSuffix && tokenValue.otherWithSuffix) {
      result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    } else {
      result = tokenValue.other.replace("{{count}}", String(count));
    }
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + "あと";
    } else {
      return result + "まえ";
    }
  }

  return result;
};
formatDistance$1j.formatDistance = formatDistance$1i;

var formatLong$F = {};

formatLong$F.formatLong = void 0;
var _index$2L = buildFormatLongFn$1;

const dateFormats$F = {
  full: "yねんMがつdにちEEEE",
  long: "yねんMがつdにち",
  medium: "y/MM/dd",
  short: "y/MM/dd",
};

const timeFormats$F = {
  full: "Hじmmふんssびょう zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$F = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$F.formatLong = {
  date: (0, _index$2L.buildFormatLongFn)({
    formats: dateFormats$F,
    defaultWidth: "full",
  }),

  time: (0, _index$2L.buildFormatLongFn)({
    formats: timeFormats$F,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2L.buildFormatLongFn)({
    formats: dateTimeFormats$F,
    defaultWidth: "full",
  }),
});

var formatRelative$1j = {};

formatRelative$1j.formatRelative = void 0;

const formatRelativeLocale$F = {
  lastWeek: "せんしゅうのeeeeのp",
  yesterday: "きのうのp",
  today: "きょうのp",
  tomorrow: "あしたのp",
  nextWeek: "よくしゅうのeeeeのp",
  other: "P",
};

const formatRelative$1i = (token, _date, _baseDate, _options) => {
  return formatRelativeLocale$F[token];
};
formatRelative$1j.formatRelative = formatRelative$1i;

var localize$F = {};

localize$F.localize = void 0;

var _index$2K = buildLocalizeFn$1;

const eraValues$F = {
  narrow: ["BC", "AC"],
  abbreviated: ["きげんぜん", "せいれき"],
  wide: ["きげんぜん", "せいれき"],
};

const quarterValues$F = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["だい1しはんき", "だい2しはんき", "だい3しはんき", "だい4しはんき"],
};

const monthValues$F = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],

  abbreviated: [
    "1がつ",
    "2がつ",
    "3がつ",
    "4がつ",
    "5がつ",
    "6がつ",
    "7がつ",
    "8がつ",
    "9がつ",
    "10がつ",
    "11がつ",
    "12がつ",
  ],

  wide: [
    "1がつ",
    "2がつ",
    "3がつ",
    "4がつ",
    "5がつ",
    "6がつ",
    "7がつ",
    "8がつ",
    "9がつ",
    "10がつ",
    "11がつ",
    "12がつ",
  ],
};

const dayValues$F = {
  narrow: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  short: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  abbreviated: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  wide: [
    "にちようび",
    "げつようび",
    "かようび",
    "すいようび",
    "もくようび",
    "きんようび",
    "どようび",
  ],
};

const dayPeriodValues$F = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや",
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや",
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや",
  },
};
const formattingDayPeriodValues$x = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや",
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや",
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや",
  },
};

const ordinalNumber$F = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = String(options?.unit);

  switch (unit) {
    case "year":
      return `${number}ねん`;
    case "quarter":
      return `だい${number}しはんき`;
    case "month":
      return `${number}がつ`;
    case "week":
      return `だい${number}しゅう`;
    case "date":
      return `${number}にち`;
    case "hour":
      return `${number}じ`;
    case "minute":
      return `${number}ふん`;
    case "second":
      return `${number}びょう`;
    default:
      return `${number}`;
  }
};

(localize$F.localize = {
  ordinalNumber: ordinalNumber$F,

  era: (0, _index$2K.buildLocalizeFn)({
    values: eraValues$F,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2K.buildLocalizeFn)({
    values: quarterValues$F,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1,
  }),

  month: (0, _index$2K.buildLocalizeFn)({
    values: monthValues$F,
    defaultWidth: "wide",
  }),

  day: (0, _index$2K.buildLocalizeFn)({
    values: dayValues$F,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2K.buildLocalizeFn)({
    values: dayPeriodValues$F,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$x,
    defaultFormattingWidth: "wide",
  }),
});

var match$F = {};

match$F.match = void 0;

var _index$2J = buildMatchFn$1;
var _index2$1k = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$F =
  /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
const parseOrdinalNumberPattern$F = /\d+/i;

const matchEraPatterns$F = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(きげん[前後]|せいれき)/i,
  wide: /^(きげん[前後]|せいれき)/i,
};
const parseEraPatterns$F = {
  narrow: [/^B/i, /^A/i],
  any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i],
};

const matchQuarterPatterns$F = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^だい[1234一二三四１２３４]しはんき/i,
};
const parseQuarterPatterns$F = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i],
};

const matchMonthPatterns$F = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])がつ/i,
  wide: /^([123456789]|1[012])がつ/i,
};
const parseMonthPatterns$F = {
  any: [
    /^1\D/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/,
  ],
};

const matchDayPatterns$F = {
  narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
  short: /^(にち|げつ|か|すい|もく|きん|ど)/,
  abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
  wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/,
};
const parseDayPatterns$F = {
  any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/],
};

const matchDayPeriodPatterns$F = {
  any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i,
};
const parseDayPeriodPatterns$F = {
  any: {
    am: /^(A|ごぜん)/i,
    pm: /^(P|ごご)/i,
    midnight: /^しんや|まよなか/i,
    noon: /^しょうご/i,
    morning: /^あさ/i,
    afternoon: /^ごご/i,
    evening: /^よる/i,
    night: /^しんや/i,
  },
};

(match$F.match = {
  ordinalNumber: (0, _index2$1k.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$F,
    parsePattern: parseOrdinalNumberPattern$F,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: (0, _index$2J.buildMatchFn)({
    matchPatterns: matchEraPatterns$F,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$F,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2J.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$F,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$F,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2J.buildMatchFn)({
    matchPatterns: matchMonthPatterns$F,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$F,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2J.buildMatchFn)({
    matchPatterns: matchDayPatterns$F,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$F,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2J.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$F,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$F,
    defaultParseWidth: "any",
  }),
});

jaHira.jaHira = void 0;
var _index$2I = formatDistance$1j;
var _index2$1j = formatLong$F;
var _index3$F = formatRelative$1j;
var _index4$F = localize$F;
var _index5$F = match$F;

/**
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo](https://github.com/Eritutteo)
 */
(jaHira.jaHira = {
  code: "ja-Hira",
  formatDistance: _index$2I.formatDistance,
  formatLong: _index2$1j.formatLong,
  formatRelative: _index3$F.formatRelative,
  localize: _index4$F.localize,
  match: _index5$F.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var ka = {};

var formatDistance$1h = {};

formatDistance$1h.formatDistance = void 0;

const formatDistanceLocale$E = {
  lessThanXSeconds: {
    past: "{{count}} წამზე ნაკლები ხნის წინ",
    present: "{{count}} წამზე ნაკლები",
    future: "{{count}} წამზე ნაკლებში",
  },

  xSeconds: {
    past: "{{count}} წამის წინ",
    present: "{{count}} წამი",
    future: "{{count}} წამში",
  },

  halfAMinute: {
    past: "ნახევარი წუთის წინ",
    present: "ნახევარი წუთი",
    future: "ნახევარი წუთში",
  },

  lessThanXMinutes: {
    past: "{{count}} წუთზე ნაკლები ხნის წინ",
    present: "{{count}} წუთზე ნაკლები",
    future: "{{count}} წუთზე ნაკლებში",
  },

  xMinutes: {
    past: "{{count}} წუთის წინ",
    present: "{{count}} წუთი",
    future: "{{count}} წუთში",
  },

  aboutXHours: {
    past: "დაახლოებით {{count}} საათის წინ",
    present: "დაახლოებით {{count}} საათი",
    future: "დაახლოებით {{count}} საათში",
  },

  xHours: {
    past: "{{count}} საათის წინ",
    present: "{{count}} საათი",
    future: "{{count}} საათში",
  },

  xDays: {
    past: "{{count}} დღის წინ",
    present: "{{count}} დღე",
    future: "{{count}} დღეში",
  },

  aboutXWeeks: {
    past: "დაახლოებით {{count}} კვირას წინ",
    present: "დაახლოებით {{count}} კვირა",
    future: "დაახლოებით {{count}} კვირაში",
  },

  xWeeks: {
    past: "{{count}} კვირას კვირა",
    present: "{{count}} კვირა",
    future: "{{count}} კვირაში",
  },

  aboutXMonths: {
    past: "დაახლოებით {{count}} თვის წინ",
    present: "დაახლოებით {{count}} თვე",
    future: "დაახლოებით {{count}} თვეში",
  },

  xMonths: {
    past: "{{count}} თვის წინ",
    present: "{{count}} თვე",
    future: "{{count}} თვეში",
  },

  aboutXYears: {
    past: "დაახლოებით {{count}} წლის წინ",
    present: "დაახლოებით {{count}} წელი",
    future: "დაახლოებით {{count}} წელში",
  },

  xYears: {
    past: "{{count}} წლის წინ",
    present: "{{count}} წელი",
    future: "{{count}} წელში",
  },

  overXYears: {
    past: "{{count}} წელზე მეტი ხნის წინ",
    present: "{{count}} წელზე მეტი",
    future: "{{count}} წელზე მეტი ხნის შემდეგ",
  },

  almostXYears: {
    past: "თითქმის {{count}} წლის წინ",
    present: "თითქმის {{count}} წელი",
    future: "თითქმის {{count}} წელში",
  },
};

const formatDistance$1g = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$E[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (
    options?.addSuffix &&
    options.comparison &&
    options.comparison > 0
  ) {
    result = tokenValue.future.replace("{{count}}", String(count));
  } else if (options?.addSuffix) {
    result = tokenValue.past.replace("{{count}}", String(count));
  } else {
    result = tokenValue.present.replace("{{count}}", String(count));
  }

  return result;
};
formatDistance$1h.formatDistance = formatDistance$1g;

var formatLong$E = {};

formatLong$E.formatLong = void 0;
var _index$2H = buildFormatLongFn$1;

const dateFormats$E = {
  full: "EEEE, do MMMM, y",
  long: "do, MMMM, y",
  medium: "d, MMM, y",
  short: "dd/MM/yyyy",
};

const timeFormats$E = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$E = {
  full: "{{date}} {{time}}'-ზე'",
  long: "{{date}} {{time}}'-ზე'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$E.formatLong = {
  date: (0, _index$2H.buildFormatLongFn)({
    formats: dateFormats$E,
    defaultWidth: "full",
  }),

  time: (0, _index$2H.buildFormatLongFn)({
    formats: timeFormats$E,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2H.buildFormatLongFn)({
    formats: dateTimeFormats$E,
    defaultWidth: "full",
  }),
});

var formatRelative$1h = {};

formatRelative$1h.formatRelative = void 0;

const formatRelativeLocale$E = {
  lastWeek: "'წინა' eeee p'-ზე'",
  yesterday: "'გუშინ' p'-ზე'",
  today: "'დღეს' p'-ზე'",
  tomorrow: "'ხვალ' p'-ზე'",
  nextWeek: "'შემდეგი' eeee p'-ზე'",
  other: "P",
};

const formatRelative$1g = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$E[token];
formatRelative$1h.formatRelative = formatRelative$1g;

var localize$E = {};

localize$E.localize = void 0;
var _index$2G = buildLocalizeFn$1;

const eraValues$E = {
  narrow: ["ჩ.წ-მდე", "ჩ.წ"],
  abbreviated: ["ჩვ.წ-მდე", "ჩვ.წ"],
  wide: ["ჩვენს წელთაღრიცხვამდე", "ჩვენი წელთაღრიცხვით"],
};

const quarterValues$E = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ლი კვ", "2-ე კვ", "3-ე კვ", "4-ე კვ"],
  wide: ["1-ლი კვარტალი", "2-ე კვარტალი", "3-ე კვარტალი", "4-ე კვარტალი"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$E = {
  narrow: [
    "ია",
    "თე",
    "მა",
    "აპ",
    "მს",
    "ვნ",
    "ვლ",
    "აგ",
    "სე",
    "ოქ",
    "ნო",
    "დე",
  ],

  abbreviated: [
    "იან",
    "თებ",
    "მარ",
    "აპრ",
    "მაი",
    "ივნ",
    "ივლ",
    "აგვ",
    "სექ",
    "ოქტ",
    "ნოე",
    "დეკ",
  ],

  wide: [
    "იანვარი",
    "თებერვალი",
    "მარტი",
    "აპრილი",
    "მაისი",
    "ივნისი",
    "ივლისი",
    "აგვისტო",
    "სექტემბერი",
    "ოქტომბერი",
    "ნოემბერი",
    "დეკემბერი",
  ],
};

const dayValues$E = {
  narrow: ["კვ", "ორ", "სა", "ოთ", "ხუ", "პა", "შა"],
  short: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  abbreviated: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  wide: [
    "კვირა",
    "ორშაბათი",
    "სამშაბათი",
    "ოთხშაბათი",
    "ხუთშაბათი",
    "პარასკევი",
    "შაბათი",
  ],
};

const dayPeriodValues$E = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე",
  },
};

const formattingDayPeriodValues$w = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით",
  },
};

const ordinalNumber$E = (dirtyNumber) => {
  const number = Number(dirtyNumber);

  if (number === 1) {
    return number + "-ლი";
  }

  return number + "-ე";
};

(localize$E.localize = {
  ordinalNumber: ordinalNumber$E,

  era: (0, _index$2G.buildLocalizeFn)({
    values: eraValues$E,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2G.buildLocalizeFn)({
    values: quarterValues$E,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2G.buildLocalizeFn)({
    values: monthValues$E,
    defaultWidth: "wide",
  }),

  day: (0, _index$2G.buildLocalizeFn)({
    values: dayValues$E,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2G.buildLocalizeFn)({
    values: dayPeriodValues$E,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$w,
    defaultFormattingWidth: "wide",
  }),
});

var match$E = {};

match$E.match = void 0;

var _index$2F = buildMatchFn$1;
var _index2$1i = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$E = /^(\d+)(-ლი|-ე)?/i;
const parseOrdinalNumberPattern$E = /\d+/i;

const matchEraPatterns$E = {
  narrow: /^(ჩვ?\.წ)/i,
  abbreviated: /^(ჩვ?\.წ)/i,
  wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i,
};
const parseEraPatterns$E = {
  any: [
    /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
    /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i,
  ],
};

const matchQuarterPatterns$E = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-(ლი|ე)? კვ/i,
  wide: /^[1234]-(ლი|ე)? კვარტალი/i,
};
const parseQuarterPatterns$E = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$E = {
  any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i,
};
const parseMonthPatterns$E = {
  any: [
    /^ია/i,
    /^თ/i,
    /^მარ/i,
    /^აპ/i,
    /^მაი/i,
    /^ი?ვნ/i,
    /^ი?ვლ/i,
    /^აგ/i,
    /^ს/i,
    /^ო/i,
    /^ნ/i,
    /^დ/i,
  ],
};

const matchDayPatterns$E = {
  narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
  short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
  wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i,
};
const parseDayPatterns$E = {
  any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i],
};

const matchDayPeriodPatterns$E = {
  any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i,
};
const parseDayPeriodPatterns$E = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^შუაღ/i,
    noon: /^შუადღ/i,
    morning: /^დილ/i,
    afternoon: /ნაშუადღევს/i,
    evening: /საღამო/i,
    night: /ღამ/i,
  },
};

(match$E.match = {
  ordinalNumber: (0, _index2$1i.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$E,
    parsePattern: parseOrdinalNumberPattern$E,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$2F.buildMatchFn)({
    matchPatterns: matchEraPatterns$E,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$E,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2F.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$E,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$E,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2F.buildMatchFn)({
    matchPatterns: matchMonthPatterns$E,
    defaultMatchWidth: "any",
    parsePatterns: parseMonthPatterns$E,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2F.buildMatchFn)({
    matchPatterns: matchDayPatterns$E,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$E,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2F.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$E,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$E,
    defaultParseWidth: "any",
  }),
});

ka.ka = void 0;
var _index$2E = formatDistance$1h;
var _index2$1h = formatLong$E;
var _index3$E = formatRelative$1h;
var _index4$E = localize$E;
var _index5$E = match$E;

/**
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish](https://github.com/Landish)
 * @author Nick Shvelidze [@shvelo](https://github.com/shvelo)
 */
(ka.ka = {
  code: "ka",
  formatDistance: _index$2E.formatDistance,
  formatLong: _index2$1h.formatLong,
  formatRelative: _index3$E.formatRelative,
  localize: _index4$E.localize,
  match: _index5$E.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var kk = {};

var formatDistance$1f = {};

formatDistance$1f.formatDistance = void 0;

const formatDistanceLocale$D = {
  lessThanXSeconds: {
    regular: {
      one: "1 секундтан аз",
      singularNominative: "{{count}} секундтан аз",
      singularGenitive: "{{count}} секундтан аз",
      pluralGenitive: "{{count}} секундтан аз",
    },
    future: {
      one: "бір секундтан кейін",
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін",
    },
  },

  xSeconds: {
    regular: {
      singularNominative: "{{count}} секунд",
      singularGenitive: "{{count}} секунд",
      pluralGenitive: "{{count}} секунд",
    },
    past: {
      singularNominative: "{{count}} секунд бұрын",
      singularGenitive: "{{count}} секунд бұрын",
      pluralGenitive: "{{count}} секунд бұрын",
    },
    future: {
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін",
    },
  },

  halfAMinute: (options) => {
    if (options?.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return "жарты минут ішінде";
      } else {
        return "жарты минут бұрын";
      }
    }

    return "жарты минут";
  },

  lessThanXMinutes: {
    regular: {
      one: "1 минуттан аз",
      singularNominative: "{{count}} минуттан аз",
      singularGenitive: "{{count}} минуттан аз",
      pluralGenitive: "{{count}} минуттан аз",
    },
    future: {
      one: "минуттан кем ",
      singularNominative: "{{count}} минуттан кем",
      singularGenitive: "{{count}} минуттан кем",
      pluralGenitive: "{{count}} минуттан кем",
    },
  },

  xMinutes: {
    regular: {
      singularNominative: "{{count}} минут",
      singularGenitive: "{{count}} минут",
      pluralGenitive: "{{count}} минут",
    },
    past: {
      singularNominative: "{{count}} минут бұрын",
      singularGenitive: "{{count}} минут бұрын",
      pluralGenitive: "{{count}} минут бұрын",
    },
    future: {
      singularNominative: "{{count}} минуттан кейін",
      singularGenitive: "{{count}} минуттан кейін",
      pluralGenitive: "{{count}} минуттан кейін",
    },
  },

  aboutXHours: {
    regular: {
      singularNominative: "шамамен {{count}} сағат",
      singularGenitive: "шамамен {{count}} сағат",
      pluralGenitive: "шамамен {{count}} сағат",
    },
    future: {
      singularNominative: "шамамен {{count}} сағаттан кейін",
      singularGenitive: "шамамен {{count}} сағаттан кейін",
      pluralGenitive: "шамамен {{count}} сағаттан кейін",
    },
  },

  xHours: {
    regular: {
      singularNominative: "{{count}} сағат",
      singularGenitive: "{{count}} сағат",
      pluralGenitive: "{{count}} сағат",
    },
  },

  xDays: {
    regular: {
      singularNominative: "{{count}} күн",
      singularGenitive: "{{count}} күн",
      pluralGenitive: "{{count}} күн",
    },
    future: {
      singularNominative: "{{count}} күннен кейін",
      singularGenitive: "{{count}} күннен кейін",
      pluralGenitive: "{{count}} күннен кейін",
    },
  },

  aboutXWeeks: {
    type: "weeks",
    one: "шамамен 1 апта",
    other: "шамамен {{count}} апта",
  },

  xWeeks: {
    type: "weeks",
    one: "1 апта",
    other: "{{count}} апта",
  },

  aboutXMonths: {
    regular: {
      singularNominative: "шамамен {{count}} ай",
      singularGenitive: "шамамен {{count}} ай",
      pluralGenitive: "шамамен {{count}} ай",
    },
    future: {
      singularNominative: "шамамен {{count}} айдан кейін",
      singularGenitive: "шамамен {{count}} айдан кейін",
      pluralGenitive: "шамамен {{count}} айдан кейін",
    },
  },

  xMonths: {
    regular: {
      singularNominative: "{{count}} ай",
      singularGenitive: "{{count}} ай",
      pluralGenitive: "{{count}} ай",
    },
  },

  aboutXYears: {
    regular: {
      singularNominative: "шамамен {{count}} жыл",
      singularGenitive: "шамамен {{count}} жыл",
      pluralGenitive: "шамамен {{count}} жыл",
    },
    future: {
      singularNominative: "шамамен {{count}} жылдан кейін",
      singularGenitive: "шамамен {{count}} жылдан кейін",
      pluralGenitive: "шамамен {{count}} жылдан кейін",
    },
  },

  xYears: {
    regular: {
      singularNominative: "{{count}} жыл",
      singularGenitive: "{{count}} жыл",
      pluralGenitive: "{{count}} жыл",
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін",
    },
  },

  overXYears: {
    regular: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам",
    },
    future: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам",
    },
  },

  almostXYears: {
    regular: {
      singularNominative: "{{count}} жылға жақын",
      singularGenitive: "{{count}} жылға жақын",
      pluralGenitive: "{{count}} жылға жақын",
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін",
    },
  },
};

function declension$4(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one && count === 1) return scheme.one;

  const rem10 = count % 10;
  const rem100 = count % 100;

  // 1, 21, 31, ...
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));

    // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));

    // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}

const formatDistance$1e = (token, count, options) => {
  const tokenValue = formatDistanceLocale$D[token];

  if (typeof tokenValue === "function") return tokenValue(options);

  if (tokenValue.type === "weeks") {
    return count === 1
      ? tokenValue.one
      : tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      if (tokenValue.future) {
        return declension$4(tokenValue.future, count);
      } else {
        return declension$4(tokenValue.regular, count) + " кейін";
      }
    } else {
      if (tokenValue.past) {
        return declension$4(tokenValue.past, count);
      } else {
        return declension$4(tokenValue.regular, count) + " бұрын";
      }
    }
  } else {
    return declension$4(tokenValue.regular, count);
  }
};
formatDistance$1f.formatDistance = formatDistance$1e;

var formatLong$D = {};

formatLong$D.formatLong = void 0;
var _index$2D = buildFormatLongFn$1;

const dateFormats$D = {
  full: "EEEE, do MMMM y 'ж.'",
  long: "do MMMM y 'ж.'",
  medium: "d MMM y 'ж.'",
  short: "dd.MM.yyyy",
};

const timeFormats$D = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$D = {
  any: "{{date}}, {{time}}",
};

(formatLong$D.formatLong = {
  date: (0, _index$2D.buildFormatLongFn)({
    formats: dateFormats$D,
    defaultWidth: "full",
  }),

  time: (0, _index$2D.buildFormatLongFn)({
    formats: timeFormats$D,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2D.buildFormatLongFn)({
    formats: dateTimeFormats$D,
    defaultWidth: "any",
  }),
});

var formatRelative$1f = {};

formatRelative$1f.formatRelative = void 0;
var _index$2C = isSameWeek$1;

const accusativeWeekdays$3 = [
  "жексенбіде",
  "дүйсенбіде",
  "сейсенбіде",
  "сәрсенбіде",
  "бейсенбіде",
  "жұмада",
  "сенбіде",
];

function lastWeek$4(day) {
  const weekday = accusativeWeekdays$3[day];

  return "'өткен " + weekday + " сағат' p'-де'";
}

function thisWeek$4(day) {
  const weekday = accusativeWeekdays$3[day];

  return "'" + weekday + " сағат' p'-де'";
}

function nextWeek$4(day) {
  const weekday = accusativeWeekdays$3[day];

  return "'келесі " + weekday + " сағат' p'-де'";
}

const formatRelativeLocale$D = {
  lastWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$2C.isSameWeek)(date, baseDate, options)) {
      return thisWeek$4(day);
    } else {
      return lastWeek$4(day);
    }
  },
  yesterday: "'кеше сағат' p'-де'",
  today: "'бүгін сағат' p'-де'",
  tomorrow: "'ертең сағат' p'-де'",
  nextWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$2C.isSameWeek)(date, baseDate, options)) {
      return thisWeek$4(day);
    } else {
      return nextWeek$4(day);
    }
  },
  other: "P",
};

const formatRelative$1e = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$D[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$1f.formatRelative = formatRelative$1e;

var localize$D = {};

localize$D.localize = void 0;
var _index$2B = buildLocalizeFn$1;

const eraValues$D = {
  narrow: ["б.з.д.", "б.з."],
  abbreviated: ["б.з.д.", "б.з."],
  wide: ["біздің заманымызға дейін", "біздің заманымыз"],
};

const quarterValues$D = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ші тоқ.", "2-ші тоқ.", "3-ші тоқ.", "4-ші тоқ."],
  wide: ["1-ші тоқсан", "2-ші тоқсан", "3-ші тоқсан", "4-ші тоқсан"],
};

const monthValues$D = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: [
    "қаң",
    "ақп",
    "нау",
    "сәу",
    "мам",
    "мау",
    "шіл",
    "там",
    "қыр",
    "қаз",
    "қар",
    "жел",
  ],

  wide: [
    "қаңтар",
    "ақпан",
    "наурыз",
    "сәуір",
    "мамыр",
    "маусым",
    "шілде",
    "тамыз",
    "қыркүйек",
    "қазан",
    "қараша",
    "желтоқсан",
  ],
};
const formattingMonthValues$9 = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: [
    "қаң",
    "ақп",
    "нау",
    "сәу",
    "мам",
    "мау",
    "шіл",
    "там",
    "қыр",
    "қаз",
    "қар",
    "жел",
  ],

  wide: [
    "қаңтар",
    "ақпан",
    "наурыз",
    "сәуір",
    "мамыр",
    "маусым",
    "шілде",
    "тамыз",
    "қыркүйек",
    "қазан",
    "қараша",
    "желтоқсан",
  ],
};

const dayValues$D = {
  narrow: ["Ж", "Д", "С", "С", "Б", "Ж", "С"],
  short: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  abbreviated: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  wide: [
    "жексенбі",
    "дүйсенбі",
    "сейсенбі",
    "сәрсенбі",
    "бейсенбі",
    "жұма",
    "сенбі",
  ],
};

const dayPeriodValues$D = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн",
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн",
  },
};

const formattingDayPeriodValues$v = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түс",
    morning: "таң",
    afternoon: "күн",
    evening: "кеш",
    night: "түн",
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түсте",
    morning: "таңертең",
    afternoon: "күндіз",
    evening: "кеште",
    night: "түнде",
  },
};

const suffixes = {
  0: "-ші",
  1: "-ші",
  2: "-ші",
  3: "-ші",
  4: "-ші",
  5: "-ші",
  6: "-шы",
  7: "-ші",
  8: "-ші",
  9: "-шы",
  10: "-шы",
  20: "-шы",
  30: "-шы",
  40: "-шы",
  50: "-ші",
  60: "-шы",
  70: "-ші",
  80: "-ші",
  90: "-шы",
  100: "-ші",
};

const ordinalNumber$D = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  const mod10 = number % 10;
  const b = number >= 100 ? 100 : null;
  const suffix =
    suffixes[number] || suffixes[mod10] || (b && suffixes[b]) || "";

  return number + suffix;
};

(localize$D.localize = {
  ordinalNumber: ordinalNumber$D,

  era: (0, _index$2B.buildLocalizeFn)({
    values: eraValues$D,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2B.buildLocalizeFn)({
    values: quarterValues$D,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2B.buildLocalizeFn)({
    values: monthValues$D,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$9,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$2B.buildLocalizeFn)({
    values: dayValues$D,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2B.buildLocalizeFn)({
    values: dayPeriodValues$D,
    defaultWidth: "any",
    formattingValues: formattingDayPeriodValues$v,
    defaultFormattingWidth: "wide",
  }),
});

var match$D = {};

match$D.match = void 0;

var _index$2A = buildMatchFn$1;
var _index2$1g = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$D = /^(\d+)(-?(ші|шы))?/i;
const parseOrdinalNumberPattern$D = /\d+/i;

const matchEraPatterns$D = {
  narrow: /^((б )?з\.?\s?д\.?)/i,
  abbreviated: /^((б )?з\.?\s?д\.?)/i,
  wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i,
};
const parseEraPatterns$D = {
  any: [/^б/i, /^з/i],
};

const matchQuarterPatterns$D = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?ші)? тоқ.?/i,
  wide: /^[1234](-?ші)? тоқсан/i,
};
const parseQuarterPatterns$D = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$D = {
  narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
  abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
  wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i,
};
const parseMonthPatterns$D = {
  narrow: [
    /^қ/i,
    /^а/i,
    /^н/i,
    /^с/i,
    /^м/i,
    /^м/i,
    /^ш/i,
    /^т/i,
    /^қ/i,
    /^қ/i,
    /^қ/i,
    /^ж/i,
  ],

  abbreviated: [
    /^қаң/i,
    /^ақп/i,
    /^нау/i,
    /^сәу/i,
    /^мам/i,
    /^мау/i,
    /^шіл/i,
    /^там/i,
    /^қыр/i,
    /^қаз/i,
    /^қар/i,
    /^жел/i,
  ],

  any: [
    /^қ/i,
    /^а/i,
    /^н/i,
    /^с/i,
    /^м/i,
    /^м/i,
    /^ш/i,
    /^т/i,
    /^қ/i,
    /^қ/i,
    /^қ/i,
    /^ж/i,
  ],
};

const matchDayPatterns$D = {
  narrow: /^(ж|д|с|с|б|ж|с)/i,
  short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
  wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i,
};
const parseDayPatterns$D = {
  narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
  short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
  any: [
    /^ж[ек]/i,
    /^д[үй]/i,
    /^сe[й]/i,
    /^сә[р]/i,
    /^б[ей]/i,
    /^ж[ұм]/i,
    /^се[н]/i,
  ],
};

const matchDayPeriodPatterns$D = {
  narrow:
    /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
};
const parseDayPeriodPatterns$D = {
  any: {
    am: /^ТД/i,
    pm: /^ТК/i,
    midnight: /^түн орта/i,
    noon: /^күндіз/i,
    morning: /таң/i,
    afternoon: /түс/i,
    evening: /кеш/i,
    night: /түн/i,
  },
};

(match$D.match = {
  ordinalNumber: (0, _index2$1g.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$D,
    parsePattern: parseOrdinalNumberPattern$D,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$2A.buildMatchFn)({
    matchPatterns: matchEraPatterns$D,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$D,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2A.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$D,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$D,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2A.buildMatchFn)({
    matchPatterns: matchMonthPatterns$D,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$D,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2A.buildMatchFn)({
    matchPatterns: matchDayPatterns$D,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$D,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2A.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$D,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$D,
    defaultParseWidth: "any",
  }),
});

kk.kk = void 0;
var _index$2z = formatDistance$1f;
var _index2$1f = formatLong$D;
var _index3$D = formatRelative$1f;
var _index4$D = localize$D;
var _index5$D = match$D;

/**
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi](https://github.com/drugoi)
 */
(kk.kk = {
  code: "kk",
  formatDistance: _index$2z.formatDistance,
  formatLong: _index2$1f.formatLong,
  formatRelative: _index3$D.formatRelative,
  localize: _index4$D.localize,
  match: _index5$D.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var km = {};

var formatDistance$1d = {};

formatDistance$1d.formatDistance = void 0;

const formatDistanceLocale$C = {
  lessThanXSeconds: "តិចជាង {{count}} វិនាទី",
  xSeconds: "{{count}} វិនាទី",
  halfAMinute: "កន្លះនាទី",
  lessThanXMinutes: "តិចជាង {{count}} នាទី",
  xMinutes: "{{count}} នាទី",
  aboutXHours: "ប្រហែល {{count}} ម៉ោង",
  xHours: "{{count}} ម៉ោង",
  xDays: "{{count}} ថ្ងៃ",
  aboutXWeeks: "ប្រហែល {{count}} សប្តាហ៍",
  xWeeks: "{{count}} សប្តាហ៍",
  aboutXMonths: "ប្រហែល {{count}} ខែ",
  xMonths: "{{count}} ខែ",
  aboutXYears: "ប្រហែល {{count}} ឆ្នាំ",
  xYears: "{{count}} ឆ្នាំ",
  overXYears: "ជាង {{count}} ឆ្នាំ",
  almostXYears: "ជិត {{count}} ឆ្នាំ",
};

const formatDistance$1c = (token, count, options) => {
  const tokenValue = formatDistanceLocale$C[token];

  let result = tokenValue;

  if (typeof count === "number") {
    result = result.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "ក្នុងរយៈពេល " + result;
    } else {
      return result + "មុន";
    }
  }

  return result;
};
formatDistance$1d.formatDistance = formatDistance$1c;

var formatLong$C = {};

formatLong$C.formatLong = void 0;
var _index$2y = buildFormatLongFn$1;

const dateFormats$C = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy",
};

const timeFormats$C = {
  full: "h:mm:ss a",
  long: "h:mm:ss a",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$C = {
  full: "{{date}} 'ម៉ោង' {{time}}",
  long: "{{date}} 'ម៉ោង' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$C.formatLong = {
  date: (0, _index$2y.buildFormatLongFn)({
    formats: dateFormats$C,
    defaultWidth: "full",
  }),

  time: (0, _index$2y.buildFormatLongFn)({
    formats: timeFormats$C,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2y.buildFormatLongFn)({
    formats: dateTimeFormats$C,
    defaultWidth: "full",
  }),
});

var formatRelative$1d = {};

formatRelative$1d.formatRelative = void 0;

const formatRelativeLocale$C = {
  lastWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​មុនម៉ោង' p",
  yesterday: "'ម្សិលមិញនៅម៉ោង' p",
  today: "'ថ្ងៃនេះម៉ោង' p",
  tomorrow: "'ថ្ងៃស្អែកម៉ោង' p",
  nextWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​ក្រោយម៉ោង' p",
  other: "P",
};

const formatRelative$1c = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$C[token];
formatRelative$1d.formatRelative = formatRelative$1c;

var localize$C = {};

localize$C.localize = void 0;
var _index$2x = buildLocalizeFn$1;

const eraValues$C = {
  narrow: ["ម.គស", "គស"],
  abbreviated: ["មុនគ.ស", "គ.ស"],
  wide: ["មុនគ្រិស្តសករាជ", "នៃគ្រិស្តសករាជ"],
};

const quarterValues$C = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ត្រីមាសទី 1", "ត្រីមាសទី 2", "ត្រីមាសទី 3", "ត្រីមាសទី 4"],
};

const monthValues$C = {
  narrow: [
    "ម.ក",
    "ក.ម",
    "មិ",
    "ម.ស",
    "ឧ.ស",
    "ម.ថ",
    "ក.ដ",
    "សី",
    "កញ",
    "តុ",
    "វិ",
    "ធ",
  ],

  abbreviated: [
    "មករា",
    "កុម្ភៈ",
    "មីនា",
    "មេសា",
    "ឧសភា",
    "មិថុនា",
    "កក្កដា",
    "សីហា",
    "កញ្ញា",
    "តុលា",
    "វិច្ឆិកា",
    "ធ្នូ",
  ],

  wide: [
    "មករា",
    "កុម្ភៈ",
    "មីនា",
    "មេសា",
    "ឧសភា",
    "មិថុនា",
    "កក្កដា",
    "សីហា",
    "កញ្ញា",
    "តុលា",
    "វិច្ឆិកា",
    "ធ្នូ",
  ],
};

const dayValues$C = {
  narrow: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  short: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  abbreviated: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  wide: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"],
};

const dayPeriodValues$C = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់",
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់",
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់",
  },
};

const formattingDayPeriodValues$u = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់",
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់",
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់",
  },
};

const ordinalNumber$C = (dirtyNumber, _) => {
  const number = Number(dirtyNumber);
  return number.toString();
};

(localize$C.localize = {
  ordinalNumber: ordinalNumber$C,

  era: (0, _index$2x.buildLocalizeFn)({
    values: eraValues$C,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2x.buildLocalizeFn)({
    values: quarterValues$C,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2x.buildLocalizeFn)({
    values: monthValues$C,
    defaultWidth: "wide",
  }),

  day: (0, _index$2x.buildLocalizeFn)({
    values: dayValues$C,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2x.buildLocalizeFn)({
    values: dayPeriodValues$C,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$u,
    defaultFormattingWidth: "wide",
  }),
});

var match$C = {};

match$C.match = void 0;

var _index$2w = buildMatchFn$1;
var _index2$1e = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$C = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$C = /\d+/i;

const matchEraPatterns$C = {
  narrow: /^(ម\.)?គស/i,
  abbreviated: /^(មុន)?គ\.ស/i,
  wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i,
};
const parseEraPatterns$C = {
  any: [/^(ម|មុន)គ\.?ស/i, /^(នៃ)?គ\.?ស/i],
};

const matchQuarterPatterns$C = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i,
};
const parseQuarterPatterns$C = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$C = {
  narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
  abbreviated:
    /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
  wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
};
const parseMonthPatterns$C = {
  narrow: [
    /^ម\.ក/i,
    /^ក\.ម/i,
    /^មិ/i,
    /^ម\.ស/i,
    /^ឧ\.ស/i,
    /^ម\.ថ/i,
    /^ក\.ដ/i,
    /^សី/i,
    /^កញ/i,
    /^តុ/i,
    /^វិ/i,
    /^ធ/i,
  ],

  any: [
    /^មក/i,
    /^កុ/i,
    /^មីន/i,
    /^មេ/i,
    /^ឧស/i,
    /^មិថ/i,
    /^កក/i,
    /^សី/i,
    /^កញ/i,
    /^តុ/i,
    /^វិច/i,
    /^ធ/i,
  ],
};

const matchDayPatterns$C = {
  narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i,
};
const parseDayPatterns$C = {
  narrow: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^ស/i],
  any: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^សៅ/i],
};

const matchDayPeriodPatterns$C = {
  narrow:
    /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
  any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
};

const parseDayPeriodPatterns$C = {
  any: {
    am: /^ព្រឹក/i,
    pm: /^ល្ងាច/i,
    midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
    noon: /^ពេលថ្ងៃត្រង់/i,
    morning: /ពេលព្រឹក/i,
    afternoon: /ពេលរសៀល/i,
    evening: /ពេលល្ងាច/i,
    night: /ពេលយប់/i,
  },
};

(match$C.match = {
  ordinalNumber: (0, _index2$1e.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$C,
    parsePattern: parseOrdinalNumberPattern$C,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: (0, _index$2w.buildMatchFn)({
    matchPatterns: matchEraPatterns$C,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$C,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2w.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$C,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$C,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2w.buildMatchFn)({
    matchPatterns: matchMonthPatterns$C,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$C,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2w.buildMatchFn)({
    matchPatterns: matchDayPatterns$C,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$C,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2w.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$C,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$C,
    defaultParseWidth: "any",
  }),
});

km.km = void 0;
var _index$2v = formatDistance$1d;
var _index2$1d = formatLong$C;
var _index3$C = formatRelative$1d;
var _index4$C = localize$C;
var _index5$C = match$C;

/**
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay](https://github.com/seanghay)
 */
(km.km = {
  code: "km",
  formatDistance: _index$2v.formatDistance,
  formatLong: _index2$1d.formatLong,
  formatRelative: _index3$C.formatRelative,
  localize: _index4$C.localize,
  match: _index5$C.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var kn = {};

var formatDistance$1b = {};

formatDistance$1b.formatDistance = void 0;

// note: no implementation for weeks

const formatDistanceLocale$B = {
  lessThanXSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
    },
  },

  xSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್",
      future: "1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ",
      past: "1 ಸೆಕೆಂಡ್ ಹಿಂದೆ",
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡುಗಳು",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ",
      past: "{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ",
    },
  },

  halfAMinute: {
    other: {
      default: "ಅರ್ಧ ನಿಮಿಷ",
      future: "ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ",
      past: "ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ",
    },
  },

  lessThanXMinutes: {
    one: {
      default: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
    },
    other: {
      default: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
    },
  },

  xMinutes: {
    one: {
      default: "1 ನಿಮಿಷ",
      future: "1 ನಿಮಿಷದಲ್ಲಿ",
      past: "1 ನಿಮಿಷದ ಹಿಂದೆ",
    },
    other: {
      default: "{{count}} ನಿಮಿಷಗಳು",
      future: "{{count}} ನಿಮಿಷಗಳಲ್ಲಿ",
      past: "{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ",
    },
  },

  aboutXHours: {
    one: {
      default: "ಸುಮಾರು 1 ಗಂಟೆ",
      future: "ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ",
    },
    other: {
      default: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳು",
      future: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ",
    },
  },

  xHours: {
    one: {
      default: "1 ಗಂಟೆ",
      future: "1 ಗಂಟೆಯಲ್ಲಿ",
      past: "1 ಗಂಟೆ ಹಿಂದೆ",
    },
    other: {
      default: "{{count}} ಗಂಟೆಗಳು",
      future: "{{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ",
    },
  },

  xDays: {
    one: {
      default: "1 ದಿನ",
      future: "1 ದಿನದಲ್ಲಿ",
      past: "1 ದಿನದ ಹಿಂದೆ",
    },
    other: {
      default: "{{count}} ದಿನಗಳು",
      future: "{{count}} ದಿನಗಳಲ್ಲಿ",
      past: "{{count}} ದಿನಗಳ ಹಿಂದೆ",
    },
  },

  // TODO
  // aboutXWeeks: {},

  // TODO
  // xWeeks: {},

  aboutXMonths: {
    one: {
      default: "ಸುಮಾರು 1 ತಿಂಗಳು",
      future: "ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ",
    },
    other: {
      default: "ಸುಮಾರು {{count}} ತಿಂಗಳು",
      future: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ",
    },
  },

  xMonths: {
    one: {
      default: "1 ತಿಂಗಳು",
      future: "1 ತಿಂಗಳಲ್ಲಿ",
      past: "1 ತಿಂಗಳ ಹಿಂದೆ",
    },
    other: {
      default: "{{count}} ತಿಂಗಳು",
      future: "{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ",
    },
  },

  aboutXYears: {
    one: {
      default: "ಸುಮಾರು 1 ವರ್ಷ",
      future: "ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ",
    },
    other: {
      default: "ಸುಮಾರು {{count}} ವರ್ಷಗಳು",
      future: "ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ",
    },
  },

  xYears: {
    one: {
      default: "1 ವರ್ಷ",
      future: "1 ವರ್ಷದಲ್ಲಿ",
      past: "1 ವರ್ಷದ ಹಿಂದೆ",
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳು",
      future: "{{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "{{count}} ವರ್ಷಗಳ ಹಿಂದೆ",
    },
  },

  overXYears: {
    one: {
      default: "1 ವರ್ಷದ ಮೇಲೆ",
      future: "1 ವರ್ಷದ ಮೇಲೆ",
      past: "1 ವರ್ಷದ ಮೇಲೆ",
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      future: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      past: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
    },
  },

  almostXYears: {
    one: {
      default: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      future: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
    },
    other: {
      default: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      future: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
    },
  },
};

function getResultByTense(parentToken, options) {
  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return parentToken.future;
    } else {
      return parentToken.past;
    }
  }
  return parentToken.default;
}

const formatDistance$1a = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$B[token];

  if (tokenValue.one && count === 1) {
    result = getResultByTense(tokenValue.one, options);
  } else {
    result = getResultByTense(tokenValue.other, options);
  }

  return result.replace("{{count}}", String(count));
};
formatDistance$1b.formatDistance = formatDistance$1a;

var formatLong$B = {};

formatLong$B.formatLong = void 0;
var _index$2u = buildFormatLongFn$1;

// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html

const dateFormats$B = {
  full: "EEEE, MMMM d, y", // CLDR 1816
  long: "MMMM d, y", // CLDR 1817
  medium: "MMM d, y", // CLDR 1818
  short: "d/M/yy", // CLDR 1819
};

const timeFormats$B = {
  full: "hh:mm:ss a zzzz", // CLDR 1820
  long: "hh:mm:ss a z", // CLDR 1821
  medium: "hh:mm:ss a", // CLDR 1822
  short: "hh:mm a", // CLDR 1823
};

const dateTimeFormats$B = {
  full: "{{date}} {{time}}", // CLDR 1824
  long: "{{date}} {{time}}", // CLDR 1825
  medium: "{{date}} {{time}}", // CLDR 1826
  short: "{{date}} {{time}}", // CLDR 1827
};

(formatLong$B.formatLong = {
  date: (0, _index$2u.buildFormatLongFn)({
    formats: dateFormats$B,
    defaultWidth: "full",
  }),

  time: (0, _index$2u.buildFormatLongFn)({
    formats: timeFormats$B,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2u.buildFormatLongFn)({
    formats: dateTimeFormats$B,
    defaultWidth: "full",
  }),
});

var formatRelative$1b = {};

formatRelative$1b.formatRelative = void 0;

const formatRelativeLocale$B = {
  lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
  yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
  today: "'ಇಂದು' p 'ಕ್ಕೆ'",
  tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
  nextWeek: "eeee p 'ಕ್ಕೆ'",
  other: "P",
};

const formatRelative$1a = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$B[token];
formatRelative$1b.formatRelative = formatRelative$1a;

var localize$B = {};

localize$B.localize = void 0;
var _index$2t = buildLocalizeFn$1;

// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html

const eraValues$B = {
  narrow: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"],
  abbreviated: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"], // CLDR #1618, #1620
  wide: ["ಕ್ರಿಸ್ತ ಪೂರ್ವ", "ಕ್ರಿಸ್ತ ಶಕ"], // CLDR #1614, #1616
};

const quarterValues$B = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ತ್ರೈ 1", "ತ್ರೈ 2", "ತ್ರೈ 3", "ತ್ರೈ 4"], // CLDR #1630 - #1638
  wide: ["1ನೇ ತ್ರೈಮಾಸಿಕ", "2ನೇ ತ್ರೈಮಾಸಿಕ", "3ನೇ ತ್ರೈಮಾಸಿಕ", "4ನೇ ತ್ರೈಮಾಸಿಕ"],
  // CLDR #1622 - #1629
};

// CLDR #1646 - #1717
const monthValues$B = {
  narrow: ["ಜ", "ಫೆ", "ಮಾ", "ಏ", "ಮೇ", "ಜೂ", "ಜು", "ಆ", "ಸೆ", "ಅ", "ನ", "ಡಿ"],

  abbreviated: [
    "ಜನ",
    "ಫೆಬ್ರ",
    "ಮಾರ್ಚ್",
    "ಏಪ್ರಿ",
    "ಮೇ",
    "ಜೂನ್",
    "ಜುಲೈ",
    "ಆಗ",
    "ಸೆಪ್ಟೆಂ",
    "ಅಕ್ಟೋ",
    "ನವೆಂ",
    "ಡಿಸೆಂ",
  ],

  wide: [
    "ಜನವರಿ",
    "ಫೆಬ್ರವರಿ",
    "ಮಾರ್ಚ್",
    "ಏಪ್ರಿಲ್",
    "ಮೇ",
    "ಜೂನ್",
    "ಜುಲೈ",
    "ಆಗಸ್ಟ್",
    "ಸೆಪ್ಟೆಂಬರ್",
    "ಅಕ್ಟೋಬರ್",
    "ನವೆಂಬರ್",
    "ಡಿಸೆಂಬರ್",
  ],
};

// CLDR #1718 - #1773
const dayValues$B = {
  narrow: ["ಭಾ", "ಸೋ", "ಮಂ", "ಬು", "ಗು", "ಶು", "ಶ"],
  short: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  abbreviated: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  wide: [
    "ಭಾನುವಾರ",
    "ಸೋಮವಾರ",
    "ಮಂಗಳವಾರ",
    "ಬುಧವಾರ",
    "ಗುರುವಾರ",
    "ಶುಕ್ರವಾರ",
    "ಶನಿವಾರ",
  ],
};

// CLDR #1774 - #1815
const dayPeriodValues$B = {
  narrow: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾಹ್ನ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾಹ್ನ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ",
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ",
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ",
  },
};

const formattingDayPeriodValues$t = {
  narrow: {
    am: "ಪೂ",
    pm: "ಅ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ",
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ",
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ",
  },
};

const ordinalNumber$B = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "ನೇ";
};

(localize$B.localize = {
  ordinalNumber: ordinalNumber$B,

  era: (0, _index$2t.buildLocalizeFn)({
    values: eraValues$B,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2t.buildLocalizeFn)({
    values: quarterValues$B,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2t.buildLocalizeFn)({
    values: monthValues$B,
    defaultWidth: "wide",
  }),

  day: (0, _index$2t.buildLocalizeFn)({
    values: dayValues$B,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2t.buildLocalizeFn)({
    values: dayPeriodValues$B,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$t,
    defaultFormattingWidth: "wide",
  }),
});

var match$B = {};

match$B.match = void 0;

var _index$2s = buildMatchFn$1;
var _index2$1c = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$B = /^(\d+)(ನೇ|ನೆ)?/i;
const parseOrdinalNumberPattern$B = /\d+/i;

const matchEraPatterns$B = {
  narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
  abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
  wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i,
};
const parseEraPatterns$B = {
  any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i],
};

const matchQuarterPatterns$B = {
  narrow: /^[1234]/i,
  abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
  wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i,
};
const parseQuarterPatterns$B = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$B = {
  narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
  abbreviated:
    /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
  wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i,
};
const parseMonthPatterns$B = {
  narrow: [
    /^ಜ$/i,
    /^ಫೆ/i,
    /^ಮಾ/i,
    /^ಏ/i,
    /^ಮೇ/i,
    /^ಜೂ/i,
    /^ಜು$/i,
    /^ಆ/i,
    /^ಸೆ/i,
    /^ಅ/i,
    /^ನ/i,
    /^ಡಿ/i,
  ],

  any: [
    /^ಜನ/i,
    /^ಫೆ/i,
    /^ಮಾ/i,
    /^ಏ/i,
    /^ಮೇ/i,
    /^ಜೂನ್/i,
    /^ಜುಲೈ/i,
    /^ಆ/i,
    /^ಸೆ/i,
    /^ಅ/i,
    /^ನ/i,
    /^ಡಿ/i,
  ],
};

const matchDayPatterns$B = {
  narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
  short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i,
};
const parseDayPatterns$B = {
  narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
  any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
};

const matchDayPeriodPatterns$B = {
  narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
  any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
};
const parseDayPeriodPatterns$B = {
  any: {
    am: /^ಪೂ/i,
    pm: /^ಅ/i,
    midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
    noon: /ಮಧ್ಯಾನ್ಹ/i,
    morning: /ಬೆಳಗ್ಗೆ/i,
    afternoon: /ಮಧ್ಯಾನ್ಹ/i,
    evening: /ಸಂಜೆ/i,
    night: /ರಾತ್ರಿ/i,
  },
};

(match$B.match = {
  ordinalNumber: (0, _index2$1c.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$B,
    parsePattern: parseOrdinalNumberPattern$B,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$2s.buildMatchFn)({
    matchPatterns: matchEraPatterns$B,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$B,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2s.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$B,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$B,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2s.buildMatchFn)({
    matchPatterns: matchMonthPatterns$B,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$B,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2s.buildMatchFn)({
    matchPatterns: matchDayPatterns$B,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$B,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2s.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$B,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$B,
    defaultParseWidth: "any",
  }),
});

kn.kn = void 0;
var _index$2r = formatDistance$1b;
var _index2$1b = formatLong$B;
var _index3$B = formatRelative$1b;
var _index4$B = localize$B;
var _index5$B = match$B;

/**
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli](https://github.com/developergouli)
 */
(kn.kn = {
  code: "kn",
  formatDistance: _index$2r.formatDistance,
  formatLong: _index2$1b.formatLong,
  formatRelative: _index3$B.formatRelative,
  localize: _index4$B.localize,
  match: _index5$B.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var ko = {};

var formatDistance$19 = {};

formatDistance$19.formatDistance = void 0;

const formatDistanceLocale$A = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만",
  },

  xSeconds: {
    one: "1초",
    other: "{{count}}초",
  },

  halfAMinute: "30초",

  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만",
  },

  xMinutes: {
    one: "1분",
    other: "{{count}}분",
  },

  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간",
  },

  xHours: {
    one: "1시간",
    other: "{{count}}시간",
  },

  xDays: {
    one: "1일",
    other: "{{count}}일",
  },

  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주",
  },

  xWeeks: {
    one: "1주",
    other: "{{count}}주",
  },

  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월",
  },

  xMonths: {
    one: "1개월",
    other: "{{count}}개월",
  },

  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년",
  },

  xYears: {
    one: "1년",
    other: "{{count}}년",
  },

  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상",
  },

  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년",
  },
};

const formatDistance$18 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$A[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " 후";
    } else {
      return result + " 전";
    }
  }

  return result;
};
formatDistance$19.formatDistance = formatDistance$18;

var formatLong$A = {};

formatLong$A.formatLong = void 0;
var _index$2q = buildFormatLongFn$1;

const dateFormats$A = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd",
};

const timeFormats$A = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$A = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$A.formatLong = {
  date: (0, _index$2q.buildFormatLongFn)({
    formats: dateFormats$A,
    defaultWidth: "full",
  }),

  time: (0, _index$2q.buildFormatLongFn)({
    formats: timeFormats$A,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2q.buildFormatLongFn)({
    formats: dateTimeFormats$A,
    defaultWidth: "full",
  }),
});

var formatRelative$19 = {};

formatRelative$19.formatRelative = void 0;

const formatRelativeLocale$A = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P",
};

const formatRelative$18 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$A[token];
formatRelative$19.formatRelative = formatRelative$18;

var localize$A = {};

localize$A.localize = void 0;
var _index$2p = buildLocalizeFn$1;

const eraValues$A = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"],
};

const quarterValues$A = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"],
};

const monthValues$A = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],

  abbreviated: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월",
  ],

  wide: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월",
  ],
};

const dayValues$A = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
};

const dayPeriodValues$A = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤",
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤",
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤",
  },
};

const formattingDayPeriodValues$s = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤",
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤",
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤",
  },
};

const ordinalNumber$A = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = String(options?.unit);

  switch (unit) {
    case "minute":
    case "second":
      return String(number);
    case "date":
      return number + "일";
    default:
      return number + "번째";
  }
};

(localize$A.localize = {
  ordinalNumber: ordinalNumber$A,

  era: (0, _index$2p.buildLocalizeFn)({
    values: eraValues$A,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2p.buildLocalizeFn)({
    values: quarterValues$A,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2p.buildLocalizeFn)({
    values: monthValues$A,
    defaultWidth: "wide",
  }),

  day: (0, _index$2p.buildLocalizeFn)({
    values: dayValues$A,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2p.buildLocalizeFn)({
    values: dayPeriodValues$A,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$s,
    defaultFormattingWidth: "wide",
  }),
});

var match$A = {};

match$A.match = void 0;

var _index$2o = buildMatchFn$1;
var _index2$1a = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$A = /^(\d+)(일|번째)?/i;
const parseOrdinalNumberPattern$A = /\d+/i;

const matchEraPatterns$A = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i,
};
const parseEraPatterns$A = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i],
};

const matchQuarterPatterns$A = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i,
};
const parseQuarterPatterns$A = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$A = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i,
};
const parseMonthPatterns$A = {
  any: [
    /^1월?$/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/,
  ],
};

const matchDayPatterns$A = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/,
};
const parseDayPatterns$A = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/],
};

const matchDayPeriodPatterns$A = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i,
};
const parseDayPeriodPatterns$A = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i,
  },
};

(match$A.match = {
  ordinalNumber: (0, _index2$1a.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$A,
    parsePattern: parseOrdinalNumberPattern$A,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$2o.buildMatchFn)({
    matchPatterns: matchEraPatterns$A,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$A,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2o.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$A,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$A,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2o.buildMatchFn)({
    matchPatterns: matchMonthPatterns$A,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$A,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2o.buildMatchFn)({
    matchPatterns: matchDayPatterns$A,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$A,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2o.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$A,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$A,
    defaultParseWidth: "any",
  }),
});

ko.ko = void 0;
var _index$2n = formatDistance$19;
var _index2$19 = formatLong$A;
var _index3$A = formatRelative$19;
var _index4$A = localize$A;
var _index5$A = match$A;

/**
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev](https://github.com/angdev)
 * @author Lee Seoyoen [@iamssen](https://github.com/iamssen)
 * @author Taiki IKeda [@so99ynoodles](https://github.com/so99ynoodles)
 */
(ko.ko = {
  code: "ko",
  formatDistance: _index$2n.formatDistance,
  formatLong: _index2$19.formatLong,
  formatRelative: _index3$A.formatRelative,
  localize: _index4$A.localize,
  match: _index5$A.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var lb = {};

var formatDistance$17 = {};

formatDistance$17.formatDistance = void 0;

const formatDistanceLocale$z = {
  lessThanXSeconds: {
    standalone: {
      one: "manner wéi eng Sekonn",
      other: "manner wéi {{count}} Sekonnen",
    },
    withPreposition: {
      one: "manner wéi enger Sekonn",
      other: "manner wéi {{count}} Sekonnen",
    },
  },

  xSeconds: {
    standalone: {
      one: "eng Sekonn",
      other: "{{count}} Sekonnen",
    },
    withPreposition: {
      one: "enger Sekonn",
      other: "{{count}} Sekonnen",
    },
  },

  halfAMinute: {
    standalone: "eng hallef Minutt",
    withPreposition: "enger hallwer Minutt",
  },

  lessThanXMinutes: {
    standalone: {
      one: "manner wéi eng Minutt",
      other: "manner wéi {{count}} Minutten",
    },
    withPreposition: {
      one: "manner wéi enger Minutt",
      other: "manner wéi {{count}} Minutten",
    },
  },

  xMinutes: {
    standalone: {
      one: "eng Minutt",
      other: "{{count}} Minutten",
    },
    withPreposition: {
      one: "enger Minutt",
      other: "{{count}} Minutten",
    },
  },

  aboutXHours: {
    standalone: {
      one: "ongeféier eng Stonn",
      other: "ongeféier {{count}} Stonnen",
    },
    withPreposition: {
      one: "ongeféier enger Stonn",
      other: "ongeféier {{count}} Stonnen",
    },
  },

  xHours: {
    standalone: {
      one: "eng Stonn",
      other: "{{count}} Stonnen",
    },
    withPreposition: {
      one: "enger Stonn",
      other: "{{count}} Stonnen",
    },
  },

  xDays: {
    standalone: {
      one: "een Dag",
      other: "{{count}} Deeg",
    },
    withPreposition: {
      one: "engem Dag",
      other: "{{count}} Deeg",
    },
  },

  aboutXWeeks: {
    standalone: {
      one: "ongeféier eng Woch",
      other: "ongeféier {{count}} Wochen",
    },
    withPreposition: {
      one: "ongeféier enger Woche",
      other: "ongeféier {{count}} Wochen",
    },
  },

  xWeeks: {
    standalone: {
      one: "eng Woch",
      other: "{{count}} Wochen",
    },
    withPreposition: {
      one: "enger Woch",
      other: "{{count}} Wochen",
    },
  },

  aboutXMonths: {
    standalone: {
      one: "ongeféier ee Mount",
      other: "ongeféier {{count}} Méint",
    },
    withPreposition: {
      one: "ongeféier engem Mount",
      other: "ongeféier {{count}} Méint",
    },
  },

  xMonths: {
    standalone: {
      one: "ee Mount",
      other: "{{count}} Méint",
    },
    withPreposition: {
      one: "engem Mount",
      other: "{{count}} Méint",
    },
  },

  aboutXYears: {
    standalone: {
      one: "ongeféier ee Joer",
      other: "ongeféier {{count}} Joer",
    },
    withPreposition: {
      one: "ongeféier engem Joer",
      other: "ongeféier {{count}} Joer",
    },
  },

  xYears: {
    standalone: {
      one: "ee Joer",
      other: "{{count}} Joer",
    },
    withPreposition: {
      one: "engem Joer",
      other: "{{count}} Joer",
    },
  },

  overXYears: {
    standalone: {
      one: "méi wéi ee Joer",
      other: "méi wéi {{count}} Joer",
    },
    withPreposition: {
      one: "méi wéi engem Joer",
      other: "méi wéi {{count}} Joer",
    },
  },

  almostXYears: {
    standalone: {
      one: "bal ee Joer",
      other: "bal {{count}} Joer",
    },
    withPreposition: {
      one: "bal engem Joer",
      other: "bal {{count}} Joer",
    },
  },
};

const EXCEPTION_CONSONANTS = ["d", "h", "n", "t", "z"];
const VOWELS = ["a,", "e", "i", "o", "u"];
const DIGITS_SPOKEN_N_NEEDED = [0, 1, 2, 3, 8, 9];
const FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [40, 50, 60, 70];

// Eifeler Regel
function isFinalNNeeded(nextWords) {
  const firstLetter = nextWords.charAt(0).toLowerCase();
  if (
    VOWELS.indexOf(firstLetter) != -1 ||
    EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1
  ) {
    return true;
  }

  // Numbers would need to converted into words for checking.
  // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
  const firstWord = nextWords.split(" ")[0];
  const number = parseInt(firstWord);
  if (
    !isNaN(number) &&
    DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 &&
    FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(
      parseInt(firstWord.substring(0, 2)),
    ) == -1
  ) {
    return true;
  }

  // Omit other checks as they are not expected here.
  return false;
}

const formatDistance$16 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$z[token];

  const usageGroup = options?.addSuffix
    ? tokenValue.withPreposition
    : tokenValue.standalone;

  if (typeof usageGroup === "string") {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else {
    result = usageGroup.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "a" + (isFinalNNeeded(result) ? "n" : "") + " " + result;
    } else {
      return "viru" + (isFinalNNeeded(result) ? "n" : "") + " " + result;
    }
  }

  return result;
};
formatDistance$17.formatDistance = formatDistance$16;

var formatLong$z = {};

formatLong$z.formatLong = void 0;
var _index$2m = buildFormatLongFn$1;

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008

const dateFormats$z = {
  full: "EEEE, do MMMM y", // Méindeg, 7. Januar 2018
  long: "do MMMM y", // 7. Januar 2018
  medium: "do MMM y", // 7. Jan 2018
  short: "dd.MM.yy", // 07.01.18
};

const timeFormats$z = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$z = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$z.formatLong = {
  date: (0, _index$2m.buildFormatLongFn)({
    formats: dateFormats$z,
    defaultWidth: "full",
  }),

  time: (0, _index$2m.buildFormatLongFn)({
    formats: timeFormats$z,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2m.buildFormatLongFn)({
    formats: dateTimeFormats$z,
    defaultWidth: "full",
  }),
});

var formatRelative$17 = {};

formatRelative$17.formatRelative = void 0;

const formatRelativeLocale$z = {
  lastWeek: (date) => {
    const day = date.getDay();
    let result = "'läschte";
    if (day === 2 || day === 4) {
      // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
      result += "n";
    }
    result += "' eeee 'um' p";
    return result;
  },
  yesterday: "'gëschter um' p",
  today: "'haut um' p",
  tomorrow: "'moien um' p",
  nextWeek: "eeee 'um' p",
  other: "P",
};

const formatRelative$16 = (token, date, _baseDate, _options) => {
  const format = formatRelativeLocale$z[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$17.formatRelative = formatRelative$16;

var localize$z = {};

localize$z.localize = void 0;
var _index$2l = buildLocalizeFn$1;

const eraValues$z = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["viru Christus", "no Christus"],
};

const quarterValues$z = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"],
};

const monthValues$z = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mäe",
    "Abr",
    "Mee",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez",
  ],

  wide: [
    "Januar",
    "Februar",
    "Mäerz",
    "Abrëll",
    "Mee",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
};

const dayValues$z = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mé", "Dë", "Më", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mé.", "Dë.", "Më.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonndeg",
    "Méindeg",
    "Dënschdeg",
    "Mëttwoch",
    "Donneschdeg",
    "Freideg",
    "Samschdeg",
  ],
};

const dayPeriodValues$z = {
  narrow: {
    am: "mo.",
    pm: "nomë.",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht",
  },
  abbreviated: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht",
  },
  wide: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht",
  },
};

const formattingDayPeriodValues$r = {
  narrow: {
    am: "mo.",
    pm: "nom.",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets",
  },
  abbreviated: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets",
  },
  wide: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets",
  },
};

const ordinalNumber$z = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$z.localize = {
  ordinalNumber: ordinalNumber$z,

  era: (0, _index$2l.buildLocalizeFn)({
    values: eraValues$z,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2l.buildLocalizeFn)({
    values: quarterValues$z,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2l.buildLocalizeFn)({
    values: monthValues$z,
    defaultWidth: "wide",
  }),

  day: (0, _index$2l.buildLocalizeFn)({
    values: dayValues$z,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2l.buildLocalizeFn)({
    values: dayPeriodValues$z,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$r,
    defaultFormattingWidth: "wide",
  }),
});

var match$z = {};

match$z.match = void 0;

var _index$2k = buildMatchFn$1;
var _index2$18 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$z = /^(\d+)(\.)?/i;
const parseOrdinalNumberPattern$z = /\d+/i;

const matchEraPatterns$z = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i,
};
const parseEraPatterns$z = {
  any: [/^v/i, /^n/i],
};

const matchQuarterPatterns$z = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i,
};
const parseQuarterPatterns$z = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$z = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
  wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i,
};
const parseMonthPatterns$z = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mä/i,
    /^ab/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$z = {
  narrow: /^[smdf]/i,
  short: /^(so|mé|dë|më|do|fr|sa)/i,
  abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
  wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i,
};
const parseDayPatterns$z = {
  any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns$z = {
  narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  abbreviated:
    /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
};
const parseDayPeriodPatterns$z = {
  any: {
    am: /^m/i,
    pm: /^n/i,
    midnight: /^Mëtter/i,
    noon: /^mëttes/i,
    morning: /moies/i,
    afternoon: /nomëttes/i, // will never be matched. Afternoon is matched by `pm`
    evening: /owes/i,
    night: /nuets/i, // will never be matched. Night is matched by `pm`
  },
};

(match$z.match = {
  ordinalNumber: (0, _index2$18.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$z,
    parsePattern: parseOrdinalNumberPattern$z,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$2k.buildMatchFn)({
    matchPatterns: matchEraPatterns$z,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$z,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2k.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$z,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$z,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2k.buildMatchFn)({
    matchPatterns: matchMonthPatterns$z,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$z,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2k.buildMatchFn)({
    matchPatterns: matchDayPatterns$z,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$z,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2k.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$z,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$z,
    defaultParseWidth: "any",
  }),
});

lb.lb = void 0;
var _index$2j = formatDistance$17;
var _index2$17 = formatLong$z;
var _index3$z = formatRelative$17;
var _index4$z = localize$z;
var _index5$z = match$z;

/**
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler](https://github.com/dwaxweiler)
 */
(lb.lb = {
  code: "lb",
  formatDistance: _index$2j.formatDistance,
  formatLong: _index2$17.formatLong,
  formatRelative: _index3$z.formatRelative,
  localize: _index4$z.localize,
  match: _index5$z.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var lt = {};

var formatDistance$15 = {};

formatDistance$15.formatDistance = void 0;

const translations = {
  xseconds_other: "sekundė_sekundžių_sekundes",
  xminutes_one: "minutė_minutės_minutę",
  xminutes_other: "minutės_minučių_minutes",
  xhours_one: "valanda_valandos_valandą",
  xhours_other: "valandos_valandų_valandas",
  xdays_one: "diena_dienos_dieną",
  xdays_other: "dienos_dienų_dienas",
  xweeks_one: "savaitė_savaitės_savaitę",
  xweeks_other: "savaitės_savaičių_savaites",
  xmonths_one: "mėnuo_mėnesio_mėnesį",
  xmonths_other: "mėnesiai_mėnesių_mėnesius",
  xyears_one: "metai_metų_metus",
  xyears_other: "metai_metų_metus",
  about: "apie",
  over: "daugiau nei",
  almost: "beveik",
  lessthan: "mažiau nei",
};

const translateSeconds = (_number, addSuffix, _key, isFuture) => {
  if (!addSuffix) {
    return "kelios sekundės";
  } else {
    return isFuture ? "kelių sekundžių" : "kelias sekundes";
  }
};

const translateSingular = (_number, addSuffix, key, isFuture) => {
  return !addSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
};

const translate = (number, addSuffix, key, isFuture) => {
  const result = number + " ";
  if (number === 1) {
    return result + translateSingular(number, addSuffix, key, isFuture);
  } else if (!addSuffix) {
    return result + (special(number) ? forms(key)[1] : forms(key)[0]);
  } else {
    if (isFuture) {
      return result + forms(key)[1];
    } else {
      return result + (special(number) ? forms(key)[1] : forms(key)[2]);
    }
  }
};

function special(number) {
  return number % 10 === 0 || (number > 10 && number < 20);
}

function forms(key) {
  return translations[key].split("_");
}

const formatDistanceLocale$y = {
  lessThanXSeconds: {
    one: translateSeconds,
    other: translate,
  },

  xSeconds: {
    one: translateSeconds,
    other: translate,
  },

  halfAMinute: "pusė minutės",

  lessThanXMinutes: {
    one: translateSingular,
    other: translate,
  },

  xMinutes: {
    one: translateSingular,
    other: translate,
  },

  aboutXHours: {
    one: translateSingular,
    other: translate,
  },

  xHours: {
    one: translateSingular,
    other: translate,
  },

  xDays: {
    one: translateSingular,
    other: translate,
  },

  aboutXWeeks: {
    one: translateSingular,
    other: translate,
  },

  xWeeks: {
    one: translateSingular,
    other: translate,
  },

  aboutXMonths: {
    one: translateSingular,
    other: translate,
  },

  xMonths: {
    one: translateSingular,
    other: translate,
  },

  aboutXYears: {
    one: translateSingular,
    other: translate,
  },

  xYears: {
    one: translateSingular,
    other: translate,
  },

  overXYears: {
    one: translateSingular,
    other: translate,
  },

  almostXYears: {
    one: translateSingular,
    other: translate,
  },
};

const formatDistance$14 = (token, count, options) => {
  const adverb = token.match(/about|over|almost|lessthan/i);
  const unit = adverb ? token.replace(adverb[0], "") : token;

  const isFuture = options?.comparison !== undefined && options.comparison > 0;

  let result;

  const tokenValue = formatDistanceLocale$y[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one(
      count,
      options?.addSuffix === true,
      unit.toLowerCase() + "_one",
      isFuture,
    );
  } else {
    result = tokenValue.other(
      count,
      options?.addSuffix === true,
      unit.toLowerCase() + "_other",
      isFuture,
    );
  }

  if (adverb) {
    const key = adverb[0].toLowerCase();
    result = translations[key] + " " + result;
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "po " + result;
    } else {
      return "prieš " + result;
    }
  }

  return result;
};
formatDistance$15.formatDistance = formatDistance$14;

var formatLong$y = {};

formatLong$y.formatLong = void 0;
var _index$2i = buildFormatLongFn$1;

const dateFormats$y = {
  full: "y 'm'. MMMM d 'd'., EEEE",
  long: "y 'm'. MMMM d 'd'.",
  medium: "y-MM-dd",
  short: "y-MM-dd",
};

const timeFormats$y = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$y = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$y.formatLong = {
  date: (0, _index$2i.buildFormatLongFn)({
    formats: dateFormats$y,
    defaultWidth: "full",
  }),

  time: (0, _index$2i.buildFormatLongFn)({
    formats: timeFormats$y,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2i.buildFormatLongFn)({
    formats: dateTimeFormats$y,
    defaultWidth: "full",
  }),
});

var formatRelative$15 = {};

formatRelative$15.formatRelative = void 0;

const formatRelativeLocale$y = {
  lastWeek: "'Praėjusį' eeee p",
  yesterday: "'Vakar' p",
  today: "'Šiandien' p",
  tomorrow: "'Rytoj' p",
  nextWeek: "eeee p",
  other: "P",
};

const formatRelative$14 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$y[token];
formatRelative$15.formatRelative = formatRelative$14;

var localize$y = {};

localize$y.localize = void 0;
var _index$2h = buildLocalizeFn$1;

const eraValues$y = {
  narrow: ["pr. Kr.", "po Kr."],
  abbreviated: ["pr. Kr.", "po Kr."],
  wide: ["prieš Kristų", "po Kristaus"],
};

const quarterValues$y = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I ketv.", "II ketv.", "III ketv.", "IV ketv."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"],
};

const formattingQuarterValues$2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I k.", "II k.", "III k.", "IV k."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"],
};

const monthValues$y = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: [
    "saus.",
    "vas.",
    "kov.",
    "bal.",
    "geg.",
    "birž.",
    "liep.",
    "rugp.",
    "rugs.",
    "spal.",
    "lapkr.",
    "gruod.",
  ],

  wide: [
    "sausis",
    "vasaris",
    "kovas",
    "balandis",
    "gegužė",
    "birželis",
    "liepa",
    "rugpjūtis",
    "rugsėjis",
    "spalis",
    "lapkritis",
    "gruodis",
  ],
};

const formattingMonthValues$8 = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: [
    "saus.",
    "vas.",
    "kov.",
    "bal.",
    "geg.",
    "birž.",
    "liep.",
    "rugp.",
    "rugs.",
    "spal.",
    "lapkr.",
    "gruod.",
  ],

  wide: [
    "sausio",
    "vasario",
    "kovo",
    "balandžio",
    "gegužės",
    "birželio",
    "liepos",
    "rugpjūčio",
    "rugsėjo",
    "spalio",
    "lapkričio",
    "gruodžio",
  ],
};

const dayValues$y = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: [
    "sekmadienis",
    "pirmadienis",
    "antradienis",
    "trečiadienis",
    "ketvirtadienis",
    "penktadienis",
    "šeštadienis",
  ],
};

const formattingDayValues$2 = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: [
    "sekmadienį",
    "pirmadienį",
    "antradienį",
    "trečiadienį",
    "ketvirtadienį",
    "penktadienį",
    "šeštadienį",
  ],
};

const dayPeriodValues$y = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis",
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis",
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis",
  },
};

const formattingDayPeriodValues$q = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis",
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis",
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis",
  },
};

const ordinalNumber$y = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "-oji";
};

(localize$y.localize = {
  ordinalNumber: ordinalNumber$y,

  era: (0, _index$2h.buildLocalizeFn)({
    values: eraValues$y,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2h.buildLocalizeFn)({
    values: quarterValues$y,
    defaultWidth: "wide",
    formattingValues: formattingQuarterValues$2,
    defaultFormattingWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2h.buildLocalizeFn)({
    values: monthValues$y,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$8,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$2h.buildLocalizeFn)({
    values: dayValues$y,
    defaultWidth: "wide",
    formattingValues: formattingDayValues$2,
    defaultFormattingWidth: "wide",
  }),

  dayPeriod: (0, _index$2h.buildLocalizeFn)({
    values: dayPeriodValues$y,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$q,
    defaultFormattingWidth: "wide",
  }),
});

var match$y = {};

match$y.match = void 0;

var _index$2g = buildMatchFn$1;
var _index2$16 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$y = /^(\d+)(-oji)?/i;
const parseOrdinalNumberPattern$y = /\d+/i;

const matchEraPatterns$y = {
  narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
  abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
  wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i,
};
const parseEraPatterns$y = {
  wide: [/prieš/i, /(po|mūsų)/i],
  any: [/^pr/i, /^(po|m)/i],
};

const matchQuarterPatterns$y = {
  narrow: /^([1234])/i,
  abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
  wide: /^(I|II|III|IV)\s?ketvirtis/i,
};
const parseQuarterPatterns$y = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/I$/i, /II$/i, /III/i, /IV/i],
};

const matchMonthPatterns$y = {
  narrow: /^[svkbglr]/i,
  abbreviated:
    /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
  wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i,
};
const parseMonthPatterns$y = {
  narrow: [
    /^s/i,
    /^v/i,
    /^k/i,
    /^b/i,
    /^g/i,
    /^b/i,
    /^l/i,
    /^r/i,
    /^r/i,
    /^s/i,
    /^l/i,
    /^g/i,
  ],

  any: [
    /^saus/i,
    /^vas/i,
    /^kov/i,
    /^bal/i,
    /^geg/i,
    /^birž/i,
    /^liep/i,
    /^rugp/i,
    /^rugs/i,
    /^spal/i,
    /^lapkr/i,
    /^gruod/i,
  ],
};

const matchDayPatterns$y = {
  narrow: /^[spatkš]/i,
  short: /^(sk|pr|an|tr|kt|pn|št)/i,
  abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
  wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i,
};
const parseDayPatterns$y = {
  narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
  wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
  any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i],
};

const matchDayPeriodPatterns$y = {
  narrow:
    /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
  any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
};
const parseDayPeriodPatterns$y = {
  narrow: {
    am: /^pr/i,
    pm: /^pop./i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i,
  },
  any: {
    am: /^pr/i,
    pm: /^popiet$/i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i,
  },
};

(match$y.match = {
  ordinalNumber: (0, _index2$16.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$y,
    parsePattern: parseOrdinalNumberPattern$y,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$2g.buildMatchFn)({
    matchPatterns: matchEraPatterns$y,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$y,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2g.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$y,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$y,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2g.buildMatchFn)({
    matchPatterns: matchMonthPatterns$y,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$y,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2g.buildMatchFn)({
    matchPatterns: matchDayPatterns$y,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$y,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2g.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$y,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$y,
    defaultParseWidth: "any",
  }),
});

lt.lt = void 0;
var _index$2f = formatDistance$15;
var _index2$15 = formatLong$y;
var _index3$y = formatRelative$15;
var _index4$y = localize$y;
var _index5$y = match$y;

/**
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak](https://github.com/pshpak)
 * @author Eduardo Pardo [@eduardopsll](https://github.com/eduardopsll)
 */
(lt.lt = {
  code: "lt",
  formatDistance: _index$2f.formatDistance,
  formatLong: _index2$15.formatLong,
  formatRelative: _index3$y.formatRelative,
  localize: _index4$y.localize,
  match: _index5$y.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var lv = {};

var formatDistance$13 = {};

formatDistance$13.formatDistance = void 0;

function buildLocalizeTokenFn$2(schema) {
  return (count, options) => {
    if (count === 1) {
      if (options?.addSuffix) {
        return schema.one[0].replace("{{time}}", schema.one[2]);
      } else {
        return schema.one[0].replace("{{time}}", schema.one[1]);
      }
    } else {
      const rem = count % 10 === 1 && count % 100 !== 11;
      if (options?.addSuffix) {
        return schema.other[0]
          .replace("{{time}}", rem ? schema.other[3] : schema.other[4])
          .replace("{{count}}", String(count));
      } else {
        return schema.other[0]
          .replace("{{time}}", rem ? schema.other[1] : schema.other[2])
          .replace("{{count}}", String(count));
      }
    }
  };
}

const formatDistanceLocale$x = {
  lessThanXSeconds: buildLocalizeTokenFn$2({
    one: ["mazāk par {{time}}", "sekundi", "sekundi"],
    other: [
      "mazāk nekā {{count}} {{time}}",
      "sekunde",
      "sekundes",
      "sekundes",
      "sekundēm",
    ],
  }),

  xSeconds: buildLocalizeTokenFn$2({
    one: ["1 {{time}}", "sekunde", "sekundes"],
    other: [
      "{{count}} {{time}}",
      "sekunde",
      "sekundes",
      "sekundes",
      "sekundēm",
    ],
  }),

  halfAMinute: (_count, options) => {
    if (options?.addSuffix) {
      return "pusminūtes";
    } else {
      return "pusminūte";
    }
  },

  lessThanXMinutes: buildLocalizeTokenFn$2({
    one: ["mazāk par {{time}}", "minūti", "minūti"],
    other: [
      "mazāk nekā {{count}} {{time}}",
      "minūte",
      "minūtes",
      "minūtes",
      "minūtēm",
    ],
  }),

  xMinutes: buildLocalizeTokenFn$2({
    one: ["1 {{time}}", "minūte", "minūtes"],
    other: ["{{count}} {{time}}", "minūte", "minūtes", "minūtes", "minūtēm"],
  }),

  aboutXHours: buildLocalizeTokenFn$2({
    one: ["apmēram 1 {{time}}", "stunda", "stundas"],
    other: [
      "apmēram {{count}} {{time}}",
      "stunda",
      "stundas",
      "stundas",
      "stundām",
    ],
  }),

  xHours: buildLocalizeTokenFn$2({
    one: ["1 {{time}}", "stunda", "stundas"],
    other: ["{{count}} {{time}}", "stunda", "stundas", "stundas", "stundām"],
  }),

  xDays: buildLocalizeTokenFn$2({
    one: ["1 {{time}}", "diena", "dienas"],
    other: ["{{count}} {{time}}", "diena", "dienas", "dienas", "dienām"],
  }),

  aboutXWeeks: buildLocalizeTokenFn$2({
    one: ["apmēram 1 {{time}}", "nedēļa", "nedēļas"],
    other: [
      "apmēram {{count}} {{time}}",
      "nedēļa",
      "nedēļu",
      "nedēļas",
      "nedēļām",
    ],
  }),

  xWeeks: buildLocalizeTokenFn$2({
    one: ["1 {{time}}", "nedēļa", "nedēļas"],
    other: [
      "{{count}} {{time}}", // TODO
      "nedēļa",
      "nedēļu",
      "nedēļas",
      "nedēļām",
    ],
  }),

  aboutXMonths: buildLocalizeTokenFn$2({
    one: ["apmēram 1 {{time}}", "mēnesis", "mēneša"],
    other: [
      "apmēram {{count}} {{time}}",
      "mēnesis",
      "mēneši",
      "mēneša",
      "mēnešiem",
    ],
  }),

  xMonths: buildLocalizeTokenFn$2({
    one: ["1 {{time}}", "mēnesis", "mēneša"],
    other: ["{{count}} {{time}}", "mēnesis", "mēneši", "mēneša", "mēnešiem"],
  }),

  aboutXYears: buildLocalizeTokenFn$2({
    one: ["apmēram 1 {{time}}", "gads", "gada"],
    other: ["apmēram {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"],
  }),

  xYears: buildLocalizeTokenFn$2({
    one: ["1 {{time}}", "gads", "gada"],
    other: ["{{count}} {{time}}", "gads", "gadi", "gada", "gadiem"],
  }),

  overXYears: buildLocalizeTokenFn$2({
    one: ["ilgāk par 1 {{time}}", "gadu", "gadu"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"],
  }),

  almostXYears: buildLocalizeTokenFn$2({
    one: ["gandrīz 1 {{time}}", "gads", "gada"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"],
  }),
};

const formatDistance$12 = (token, count, options) => {
  const result = formatDistanceLocale$x[token](count, options);

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "pēc " + result;
    } else {
      return "pirms " + result;
    }
  }

  return result;
};
formatDistance$13.formatDistance = formatDistance$12;

var formatLong$x = {};

formatLong$x.formatLong = void 0;
var _index$2e = buildFormatLongFn$1;

const dateFormats$x = {
  full: "EEEE, y. 'gada' d. MMMM",
  long: "y. 'gada' d. MMMM",
  medium: "dd.MM.y.",
  short: "dd.MM.y.",
};

const timeFormats$x = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$x = {
  full: "{{date}} 'plkst.' {{time}}",
  long: "{{date}} 'plkst.' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$x.formatLong = {
  date: (0, _index$2e.buildFormatLongFn)({
    formats: dateFormats$x,
    defaultWidth: "full",
  }),

  time: (0, _index$2e.buildFormatLongFn)({
    formats: timeFormats$x,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$2e.buildFormatLongFn)({
    formats: dateTimeFormats$x,
    defaultWidth: "full",
  }),
});

var formatRelative$13 = {};

formatRelative$13.formatRelative = void 0;
var _index$2d = isSameWeek$1;

const weekdays$1 = [
  "svētdienā",
  "pirmdienā",
  "otrdienā",
  "trešdienā",
  "ceturtdienā",
  "piektdienā",
  "sestdienā",
];

const formatRelativeLocale$x = {
  lastWeek: (date, baseDate, options) => {
    if ((0, _index$2d.isSameWeek)(date, baseDate, options)) {
      return "eeee 'plkst.' p";
    }

    const weekday = weekdays$1[date.getDay()];
    return "'Pagājušā " + weekday + " plkst.' p";
  },
  yesterday: "'Vakar plkst.' p",
  today: "'Šodien plkst.' p",
  tomorrow: "'Rīt plkst.' p",
  nextWeek: (date, baseDate, options) => {
    if ((0, _index$2d.isSameWeek)(date, baseDate, options)) {
      return "eeee 'plkst.' p";
    }

    const weekday = weekdays$1[date.getDay()];
    return "'Nākamajā " + weekday + " plkst.' p";
  },
  other: "P",
};

const formatRelative$12 = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$x[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$13.formatRelative = formatRelative$12;

var localize$x = {};

localize$x.localize = void 0;
var _index$2c = buildLocalizeFn$1;

const eraValues$x = {
  narrow: ["p.m.ē", "m.ē"],
  abbreviated: ["p. m. ē.", "m. ē."],
  wide: ["pirms mūsu ēras", "mūsu ērā"],
};

const quarterValues$x = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: [
    "pirmais ceturksnis",
    "otrais ceturksnis",
    "trešais ceturksnis",
    "ceturtais ceturksnis",
  ],
};

const formattingQuarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: [
    "pirmajā ceturksnī",
    "otrajā ceturksnī",
    "trešajā ceturksnī",
    "ceturtajā ceturksnī",
  ],
};

const monthValues$x = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "febr.",
    "marts",
    "apr.",
    "maijs",
    "jūn.",
    "jūl.",
    "aug.",
    "sept.",
    "okt.",
    "nov.",
    "dec.",
  ],

  wide: [
    "janvāris",
    "februāris",
    "marts",
    "aprīlis",
    "maijs",
    "jūnijs",
    "jūlijs",
    "augusts",
    "septembris",
    "oktobris",
    "novembris",
    "decembris",
  ],
};

const formattingMonthValues$7 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "febr.",
    "martā",
    "apr.",
    "maijs",
    "jūn.",
    "jūl.",
    "aug.",
    "sept.",
    "okt.",
    "nov.",
    "dec.",
  ],

  wide: [
    "janvārī",
    "februārī",
    "martā",
    "aprīlī",
    "maijā",
    "jūnijā",
    "jūlijā",
    "augustā",
    "septembrī",
    "oktobrī",
    "novembrī",
    "decembrī",
  ],
};

const dayValues$x = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: [
    "svētd.",
    "pirmd.",
    "otrd.",
    "trešd.",
    "ceturtd.",
    "piektd.",
    "sestd.",
  ],

  wide: [
    "svētdiena",
    "pirmdiena",
    "otrdiena",
    "trešdiena",
    "ceturtdiena",
    "piektdiena",
    "sestdiena",
  ],
};

const formattingDayValues$1 = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: [
    "svētd.",
    "pirmd.",
    "otrd.",
    "trešd.",
    "ceturtd.",
    "piektd.",
    "sestd.",
  ],

  wide: [
    "svētdienā",
    "pirmdienā",
    "otrdienā",
    "trešdienā",
    "ceturtdienā",
    "piektdienā",
    "sestdienā",
  ],
};

const dayPeriodValues$x = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "diena",
    evening: "vakars",
    night: "nakts",
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "pēcpusd.",
    evening: "vakars",
    night: "nakts",
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnakts",
    noon: "pusdienlaiks",
    morning: "rīts",
    afternoon: "pēcpusdiena",
    evening: "vakars",
    night: "nakts",
  },
};

const formattingDayPeriodValues$p = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "dienā",
    evening: "vakarā",
    night: "naktī",
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "pēcpusd.",
    evening: "vakarā",
    night: "naktī",
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnaktī",
    noon: "pusdienlaikā",
    morning: "rītā",
    afternoon: "pēcpusdienā",
    evening: "vakarā",
    night: "naktī",
  },
};

const ordinalNumber$x = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$x.localize = {
  ordinalNumber: ordinalNumber$x,

  era: (0, _index$2c.buildLocalizeFn)({
    values: eraValues$x,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2c.buildLocalizeFn)({
    values: quarterValues$x,
    defaultWidth: "wide",
    formattingValues: formattingQuarterValues$1,
    defaultFormattingWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2c.buildLocalizeFn)({
    values: monthValues$x,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$7,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$2c.buildLocalizeFn)({
    values: dayValues$x,
    defaultWidth: "wide",
    formattingValues: formattingDayValues$1,
    defaultFormattingWidth: "wide",
  }),

  dayPeriod: (0, _index$2c.buildLocalizeFn)({
    values: dayPeriodValues$x,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$p,
    defaultFormattingWidth: "wide",
  }),
});

var match$x = {};

match$x.match = void 0;

var _index$2b = buildMatchFn$1;
var _index2$14 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$x = /^(\d+)\./i;
const parseOrdinalNumberPattern$x = /\d+/i;

const matchEraPatterns$x = {
  narrow: /^(p\.m\.ē|m\.ē)/i,
  abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
  wide: /^(pirms mūsu ēras|mūsu ērā)/i,
};
const parseEraPatterns$x = {
  any: [/^p/i, /^m/i],
};

const matchQuarterPatterns$x = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](\. cet\.)/i,
  wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i,
};
const parseQuarterPatterns$x = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
  abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
  wide: [/^p/i, /^o/i, /^t/i, /^c/i],
};

const matchMonthPatterns$x = {
  narrow: /^[jfmasond]/i,
  abbreviated:
    /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
  wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i,
};
const parseMonthPatterns$x = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jūn/i,
    /^jūl/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$x = {
  narrow: /^[spotc]/i,
  short: /^(sv|pi|o|t|c|pk|s)/i,
  abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
  wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i,
};
const parseDayPatterns$x = {
  narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
  any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i],
};

const matchDayPeriodPatterns$x = {
  narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
  abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
  wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i,
};
const parseDayPeriodPatterns$x = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^pusn/i,
    noon: /^pusd/i,
    morning: /^r/i,
    afternoon: /^(d|pēc)/i,
    evening: /^v/i,
    night: /^n/i,
  },
};

(match$x.match = {
  ordinalNumber: (0, _index2$14.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$x,
    parsePattern: parseOrdinalNumberPattern$x,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$2b.buildMatchFn)({
    matchPatterns: matchEraPatterns$x,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$x,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$2b.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$x,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$x,
    defaultParseWidth: "wide",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$2b.buildMatchFn)({
    matchPatterns: matchMonthPatterns$x,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$x,
    defaultParseWidth: "any",
  }),

  day: (0, _index$2b.buildMatchFn)({
    matchPatterns: matchDayPatterns$x,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$x,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$2b.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$x,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$x,
    defaultParseWidth: "any",
  }),
});

lv.lv = void 0;
var _index$2a = formatDistance$13;
var _index2$13 = formatLong$x;
var _index3$x = formatRelative$13;
var _index4$x = localize$x;
var _index5$x = match$x;

/**
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs](https://github.com/prudolfs)
 */
(lv.lv = {
  code: "lv",
  formatDistance: _index$2a.formatDistance,
  formatLong: _index2$13.formatLong,
  formatRelative: _index3$x.formatRelative,
  localize: _index4$x.localize,
  match: _index5$x.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var mk = {};

var formatDistance$11 = {};

formatDistance$11.formatDistance = void 0;

const formatDistanceLocale$w = {
  lessThanXSeconds: {
    one: "помалку од секунда",
    other: "помалку од {{count}} секунди",
  },

  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди",
  },

  halfAMinute: "половина минута",

  lessThanXMinutes: {
    one: "помалку од минута",
    other: "помалку од {{count}} минути",
  },

  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути",
  },

  aboutXHours: {
    one: "околу 1 час",
    other: "околу {{count}} часа",
  },

  xHours: {
    one: "1 час",
    other: "{{count}} часа",
  },

  xDays: {
    one: "1 ден",
    other: "{{count}} дена",
  },

  aboutXWeeks: {
    one: "околу 1 недела",
    other: "околу {{count}} месеци",
  },

  xWeeks: {
    one: "1 недела",
    other: "{{count}} недели",
  },

  aboutXMonths: {
    one: "околу 1 месец",
    other: "околу {{count}} недели",
  },

  xMonths: {
    one: "1 месец",
    other: "{{count}} месеци",
  },

  aboutXYears: {
    one: "околу 1 година",
    other: "околу {{count}} години",
  },

  xYears: {
    one: "1 година",
    other: "{{count}} години",
  },

  overXYears: {
    one: "повеќе од 1 година",
    other: "повеќе од {{count}} години",
  },

  almostXYears: {
    one: "безмалку 1 година",
    other: "безмалку {{count}} години",
  },
};

const formatDistance$10 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$w[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "за " + result;
    } else {
      return "пред " + result;
    }
  }

  return result;
};
formatDistance$11.formatDistance = formatDistance$10;

var formatLong$w = {};

formatLong$w.formatLong = void 0;
var _index$29 = buildFormatLongFn$1;

const dateFormats$w = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy",
};

const timeFormats$w = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$w = {
  any: "{{date}} {{time}}",
};

(formatLong$w.formatLong = {
  date: (0, _index$29.buildFormatLongFn)({
    formats: dateFormats$w,
    defaultWidth: "full",
  }),

  time: (0, _index$29.buildFormatLongFn)({
    formats: timeFormats$w,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$29.buildFormatLongFn)({
    formats: dateTimeFormats$w,
    defaultWidth: "any",
  }),
});

var formatRelative$11 = {};

formatRelative$11.formatRelative = void 0;
var _index$28 = isSameWeek$1;

const weekdays = [
  "недела",
  "понеделник",
  "вторник",
  "среда",
  "четврток",
  "петок",
  "сабота",
];

function lastWeek$3(day) {
  const weekday = weekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'минатата " + weekday + " во' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'минатиот " + weekday + " во' p";
  }
}

function thisWeek$3(day) {
  const weekday = weekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'ова " + weekday + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'овој " + weekday + " вo' p";
  }
}

function nextWeek$3(day) {
  const weekday = weekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'следната " + weekday + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следниот " + weekday + " вo' p";
  }
}

const formatRelativeLocale$w = {
  lastWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$28.isSameWeek)(date, baseDate, options)) {
      return thisWeek$3(day);
    } else {
      return lastWeek$3(day);
    }
  },
  yesterday: "'вчера во' p",
  today: "'денес во' p",
  tomorrow: "'утре во' p",
  nextWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$28.isSameWeek)(date, baseDate, options)) {
      return thisWeek$3(day);
    } else {
      return nextWeek$3(day);
    }
  },
  other: "P",
};

const formatRelative$10 = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$w[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$11.formatRelative = formatRelative$10;

var localize$w = {};

localize$w.localize = void 0;
var _index$27 = buildLocalizeFn$1;

const eraValues$w = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["пред н. е.", "н. е."],
  wide: ["пред нашата ера", "нашата ера"],
};

const quarterValues$w = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ви кв.", "2-ри кв.", "3-ти кв.", "4-ти кв."],
  wide: ["1-ви квартал", "2-ри квартал", "3-ти квартал", "4-ти квартал"],
};

const monthValues$w = {
  abbreviated: [
    "јан",
    "фев",
    "мар",
    "апр",
    "мај",
    "јун",
    "јул",
    "авг",
    "септ",
    "окт",
    "ноем",
    "дек",
  ],

  wide: [
    "јануари",
    "февруари",
    "март",
    "април",
    "мај",
    "јуни",
    "јули",
    "август",
    "септември",
    "октомври",
    "ноември",
    "декември",
  ],
};

const dayValues$w = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["не", "по", "вт", "ср", "че", "пе", "са"],
  abbreviated: ["нед", "пон", "вто", "сре", "чет", "пет", "саб"],
  wide: [
    "недела",
    "понеделник",
    "вторник",
    "среда",
    "четврток",
    "петок",
    "сабота",
  ],
};

const dayPeriodValues$w = {
  wide: {
    am: "претпладне",
    pm: "попладне",
    midnight: "полноќ",
    noon: "напладне",
    morning: "наутро",
    afternoon: "попладне",
    evening: "навечер",
    night: "ноќе",
  },
};

const ordinalNumber$w = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + "-ви";
      case 2:
        return number + "-ри";
      case 7:
      case 8:
        return number + "-ми";
    }
  }
  return number + "-ти";
};

(localize$w.localize = {
  ordinalNumber: ordinalNumber$w,

  era: (0, _index$27.buildLocalizeFn)({
    values: eraValues$w,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$27.buildLocalizeFn)({
    values: quarterValues$w,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$27.buildLocalizeFn)({
    values: monthValues$w,
    defaultWidth: "wide",
  }),

  day: (0, _index$27.buildLocalizeFn)({
    values: dayValues$w,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$27.buildLocalizeFn)({
    values: dayPeriodValues$w,
    defaultWidth: "wide",
  }),
});

var match$w = {};

match$w.match = void 0;

var _index$26 = buildMatchFn$1;
var _index2$12 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$w = /^(\d+)(-?[врмт][и])?/i;
const parseOrdinalNumberPattern$w = /\d+/i;

const matchEraPatterns$w = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(пред нашата ера|нашата ера)/i,
};
const parseEraPatterns$w = {
  any: [/^п/i, /^н/i],
};

const matchQuarterPatterns$w = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
  wide: /^[1234](-?[врт]?и?)? квартал/i,
};
const parseQuarterPatterns$w = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchDayPatterns$w = {
  narrow: /^[нпвсч]/i,
  short: /^(не|по|вт|ср|че|пе|са)/i,
  abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
  wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i,
};

const parseDayPatterns$w = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i],
};

const matchMonthPatterns$w = {
  abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
  wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i,
};
const parseMonthPatterns$w = {
  any: [
    /^ја/i,
    /^Ф/i,
    /^мар/i,
    /^ап/i,
    /^мај/i,
    /^јун/i,
    /^јул/i,
    /^ав/i,
    /^се/i,
    /^окт/i,
    /^но/i,
    /^де/i,
  ],
};

const matchDayPeriodPatterns$w = {
  any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i,
};
const parseDayPeriodPatterns$w = {
  any: {
    am: /претпладне/i,
    pm: /попладне/i,
    midnight: /полноќ/i,
    noon: /напладне/i,
    morning: /наутро/i,
    afternoon: /попладне/i,
    evening: /навечер/i,
    night: /ноќе/i,
  },
};

(match$w.match = {
  ordinalNumber: (0, _index2$12.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$w,
    parsePattern: parseOrdinalNumberPattern$w,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$26.buildMatchFn)({
    matchPatterns: matchEraPatterns$w,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$w,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$26.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$w,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$w,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$26.buildMatchFn)({
    matchPatterns: matchMonthPatterns$w,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$w,
    defaultParseWidth: "any",
  }),

  day: (0, _index$26.buildMatchFn)({
    matchPatterns: matchDayPatterns$w,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$w,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$26.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$w,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$w,
    defaultParseWidth: "any",
  }),
});

mk.mk = void 0;
var _index$25 = formatDistance$11;
var _index2$11 = formatLong$w;
var _index3$w = formatRelative$11;
var _index4$w = localize$w;
var _index5$w = match$w;

/**
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar](https://github.com/vlahupetar)
 * @author Altrim Beqiri [@altrim](https://github.com/altrim)
 */
(mk.mk = {
  code: "mk",
  formatDistance: _index$25.formatDistance,
  formatLong: _index2$11.formatLong,
  formatRelative: _index3$w.formatRelative,
  localize: _index4$w.localize,
  match: _index5$w.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var mn = {};

var formatDistance$$ = {};

formatDistance$$.formatDistance = void 0;

const formatDistanceLocale$v = {
  lessThanXSeconds: {
    one: "секунд хүрэхгүй",
    other: "{{count}} секунд хүрэхгүй",
  },

  xSeconds: {
    one: "1 секунд",
    other: "{{count}} секунд",
  },

  halfAMinute: "хагас минут",

  lessThanXMinutes: {
    one: "минут хүрэхгүй",
    other: "{{count}} минут хүрэхгүй",
  },

  xMinutes: {
    one: "1 минут",
    other: "{{count}} минут",
  },

  aboutXHours: {
    one: "ойролцоогоор 1 цаг",
    other: "ойролцоогоор {{count}} цаг",
  },

  xHours: {
    one: "1 цаг",
    other: "{{count}} цаг",
  },

  xDays: {
    one: "1 өдөр",
    other: "{{count}} өдөр",
  },

  aboutXWeeks: {
    one: "ойролцоогоор 1 долоо хоног",
    other: "ойролцоогоор {{count}} долоо хоног",
  },

  xWeeks: {
    one: "1 долоо хоног",
    other: "{{count}} долоо хоног",
  },

  aboutXMonths: {
    one: "ойролцоогоор 1 сар",
    other: "ойролцоогоор {{count}} сар",
  },

  xMonths: {
    one: "1 сар",
    other: "{{count}} сар",
  },

  aboutXYears: {
    one: "ойролцоогоор 1 жил",
    other: "ойролцоогоор {{count}} жил",
  },

  xYears: {
    one: "1 жил",
    other: "{{count}} жил",
  },

  overXYears: {
    one: "1 жил гаран",
    other: "{{count}} жил гаран",
  },

  almostXYears: {
    one: "бараг 1 жил",
    other: "бараг {{count}} жил",
  },
};

const formatDistance$_ = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$v[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    /**
     * Append genitive case
     */
    const words = result.split(" ");
    const lastword = words.pop();
    result = words.join(" ");
    switch (lastword) {
      case "секунд":
        result += " секундийн";
        break;
      case "минут":
        result += " минутын";
        break;
      case "цаг":
        result += " цагийн";
        break;
      case "өдөр":
        result += " өдрийн";
        break;
      case "сар":
        result += " сарын";
        break;
      case "жил":
        result += " жилийн";
        break;
      case "хоног":
        result += " хоногийн";
        break;
      case "гаран":
        result += " гараны";
        break;
      case "хүрэхгүй":
        result += " хүрэхгүй хугацааны";
        break;
      default:
        result += lastword + "-н";
    }

    if (options.comparison && options.comparison > 0) {
      return result + " дараа";
    } else {
      return result + " өмнө";
    }
  }

  return result;
};
formatDistance$$.formatDistance = formatDistance$_;

var formatLong$v = {};

formatLong$v.formatLong = void 0;
var _index$24 = buildFormatLongFn$1;

const dateFormats$v = {
  full: "y 'оны' MMMM'ын' d, EEEE 'гараг'",
  long: "y 'оны' MMMM'ын' d",
  medium: "y 'оны' MMM'ын' d",
  short: "y.MM.dd",
};

const timeFormats$v = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$v = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$v.formatLong = {
  date: (0, _index$24.buildFormatLongFn)({
    formats: dateFormats$v,
    defaultWidth: "full",
  }),

  time: (0, _index$24.buildFormatLongFn)({
    formats: timeFormats$v,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$24.buildFormatLongFn)({
    formats: dateTimeFormats$v,
    defaultWidth: "full",
  }),
});

var formatRelative$$ = {};

formatRelative$$.formatRelative = void 0;

const formatRelativeLocale$v = {
  lastWeek: "'өнгөрсөн' eeee 'гарагийн' p 'цагт'",
  yesterday: "'өчигдөр' p 'цагт'",
  today: "'өнөөдөр' p 'цагт'",
  tomorrow: "'маргааш' p 'цагт'",
  nextWeek: "'ирэх' eeee 'гарагийн' p 'цагт'",
  other: "P",
};

const formatRelative$_ = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$v[token];
formatRelative$$.formatRelative = formatRelative$_;

var localize$v = {};

localize$v.localize = void 0;
var _index$23 = buildLocalizeFn$1;

const eraValues$v = {
  narrow: ["НТӨ", "НТ"],
  abbreviated: ["НТӨ", "НТ"],
  wide: ["нийтийн тооллын өмнөх", "нийтийн тооллын"],
};

const quarterValues$v = {
  narrow: ["I", "II", "III", "IV"],
  abbreviated: ["I улирал", "II улирал", "III улирал", "IV улирал"],
  wide: ["1-р улирал", "2-р улирал", "3-р улирал", "4-р улирал"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$v = {
  narrow: [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII",
  ],

  abbreviated: [
    "1-р сар",
    "2-р сар",
    "3-р сар",
    "4-р сар",
    "5-р сар",
    "6-р сар",
    "7-р сар",
    "8-р сар",
    "9-р сар",
    "10-р сар",
    "11-р сар",
    "12-р сар",
  ],

  wide: [
    "Нэгдүгээр сар",
    "Хоёрдугаар сар",
    "Гуравдугаар сар",
    "Дөрөвдүгээр сар",
    "Тавдугаар сар",
    "Зургаадугаар сар",
    "Долоодугаар сар",
    "Наймдугаар сар",
    "Есдүгээр сар",
    "Аравдугаар сар",
    "Арваннэгдүгээр сар",
    "Арван хоёрдугаар сар",
  ],
};

const formattingMonthValues$6 = {
  narrow: [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII",
  ],

  abbreviated: [
    "1-р сар",
    "2-р сар",
    "3-р сар",
    "4-р сар",
    "5-р сар",
    "6-р сар",
    "7-р сар",
    "8-р сар",
    "9-р сар",
    "10-р сар",
    "11-р сар",
    "12-р сар",
  ],

  wide: [
    "нэгдүгээр сар",
    "хоёрдугаар сар",
    "гуравдугаар сар",
    "дөрөвдүгээр сар",
    "тавдугаар сар",
    "зургаадугаар сар",
    "долоодугаар сар",
    "наймдугаар сар",
    "есдүгээр сар",
    "аравдугаар сар",
    "арваннэгдүгээр сар",
    "арван хоёрдугаар сар",
  ],
};

const dayValues$v = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"],
};

const formattingDayValues = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["ням", "даваа", "мягмар", "лхагва", "пүрэв", "баасан", "бямба"],
};

const dayPeriodValues$v = {
  narrow: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө",
  },
  abbreviated: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө",
  },
  wide: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө",
  },
};

const ordinalNumber$v = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$v.localize = {
  ordinalNumber: ordinalNumber$v,

  era: (0, _index$23.buildLocalizeFn)({
    values: eraValues$v,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$23.buildLocalizeFn)({
    values: quarterValues$v,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$23.buildLocalizeFn)({
    values: monthValues$v,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$6,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$23.buildLocalizeFn)({
    values: dayValues$v,
    defaultWidth: "wide",
    formattingValues: formattingDayValues,
    defaultFormattingWidth: "wide",
  }),

  dayPeriod: (0, _index$23.buildLocalizeFn)({
    values: dayPeriodValues$v,
    defaultWidth: "wide",
  }),
});

var match$v = {};

match$v.match = void 0;

var _index$22 = buildMatchFn$1;
var _index2$10 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$v = /\d+/i;
const parseOrdinalNumberPattern$v = /\d+/i;

const matchEraPatterns$v = {
  narrow: /^(нтө|нт)/i,
  abbreviated: /^(нтө|нт)/i,
  wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i,
};
const parseEraPatterns$v = {
  any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i],
};

const matchQuarterPatterns$v = {
  narrow: /^(iv|iii|ii|i)/i,
  abbreviated: /^(iv|iii|ii|i) улирал/i,
  wide: /^[1-4]-р улирал/i,
};
const parseQuarterPatterns$v = {
  any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i],
};

const matchMonthPatterns$v = {
  narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
  abbreviated:
    /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
  wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i,
};
const parseMonthPatterns$v = {
  narrow: [
    /^i$/i,
    /^ii$/i,
    /^iii$/i,
    /^iv$/i,
    /^v$/i,
    /^vi$/i,
    /^vii$/i,
    /^viii$/i,
    /^ix$/i,
    /^x$/i,
    /^xi$/i,
    /^xii$/i,
  ],

  any: [
    /^(1|нэгдүгээр)/i,
    /^(2|хоёрдугаар)/i,
    /^(3|гуравдугаар)/i,
    /^(4|дөрөвдүгээр)/i,
    /^(5|тавдугаар)/i,
    /^(6|зургаадугаар)/i,
    /^(7|долоодугаар)/i,
    /^(8|наймдугаар)/i,
    /^(9|есдүгээр)/i,
    /^(10|аравдугаар)/i,
    /^(11|арван нэгдүгээр)/i,
    /^(12|арван хоёрдугаар)/i,
  ],
};

const matchDayPatterns$v = {
  narrow: /^[ндмлпбб]/i,
  short: /^(ня|да|мя|лх|пү|ба|бя)/i,
  abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
  wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i,
};
const parseDayPatterns$v = {
  narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
  any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i],
};

const matchDayPeriodPatterns$v = {
  narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
  any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
};
const parseDayPeriodPatterns$v = {
  any: {
    am: /^ү\.ө\./i,
    pm: /^ү\.х\./i,
    midnight: /^шөнө дунд/i,
    noon: /^үд дунд/i,
    morning: /өглөө/i,
    afternoon: /өдөр/i,
    evening: /орой/i,
    night: /шөнө/i,
  },
};

(match$v.match = {
  ordinalNumber: (0, _index2$10.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$v,
    parsePattern: parseOrdinalNumberPattern$v,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$22.buildMatchFn)({
    matchPatterns: matchEraPatterns$v,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$v,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$22.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$v,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$v,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$22.buildMatchFn)({
    matchPatterns: matchMonthPatterns$v,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$v,
    defaultParseWidth: "any",
  }),

  day: (0, _index$22.buildMatchFn)({
    matchPatterns: matchDayPatterns$v,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$v,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$22.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$v,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$v,
    defaultParseWidth: "any",
  }),
});

mn.mn = void 0;
var _index$21 = formatDistance$$;
var _index2$$ = formatLong$v;
var _index3$v = formatRelative$$;
var _index4$v = localize$v;
var _index5$v = match$v;

/**
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203](https://github.com/bilguun0203)
 */
(mn.mn = {
  code: "mn",
  formatDistance: _index$21.formatDistance,
  formatLong: _index2$$.formatLong,
  formatRelative: _index3$v.formatRelative,
  localize: _index4$v.localize,
  match: _index5$v.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var ms = {};

var formatDistance$Z = {};

formatDistance$Z.formatDistance = void 0;

const formatDistanceLocale$u = {
  lessThanXSeconds: {
    one: "kurang dari 1 saat",
    other: "kurang dari {{count}} saat",
  },

  xSeconds: {
    one: "1 saat",
    other: "{{count}} saat",
  },

  halfAMinute: "setengah minit",

  lessThanXMinutes: {
    one: "kurang dari 1 minit",
    other: "kurang dari {{count}} minit",
  },

  xMinutes: {
    one: "1 minit",
    other: "{{count}} minit",
  },

  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam",
  },

  xHours: {
    one: "1 jam",
    other: "{{count}} jam",
  },

  xDays: {
    one: "1 hari",
    other: "{{count}} hari",
  },

  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu",
  },

  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu",
  },

  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan",
  },

  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan",
  },

  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun",
  },

  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun",
  },

  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun",
  },

  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun",
  },
};

const formatDistance$Y = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$u[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "dalam masa " + result;
    } else {
      return result + " yang lalu";
    }
  }

  return result;
};
formatDistance$Z.formatDistance = formatDistance$Y;

var formatLong$u = {};

formatLong$u.formatLong = void 0;
var _index$20 = buildFormatLongFn$1;

const dateFormats$u = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy",
};

const timeFormats$u = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm",
};

const dateTimeFormats$u = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$u.formatLong = {
  date: (0, _index$20.buildFormatLongFn)({
    formats: dateFormats$u,
    defaultWidth: "full",
  }),

  time: (0, _index$20.buildFormatLongFn)({
    formats: timeFormats$u,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$20.buildFormatLongFn)({
    formats: dateTimeFormats$u,
    defaultWidth: "full",
  }),
});

var formatRelative$Z = {};

formatRelative$Z.formatRelative = void 0;

const formatRelativeLocale$u = {
  lastWeek: "eeee 'lepas pada jam' p",
  yesterday: "'Semalam pada jam' p",
  today: "'Hari ini pada jam' p",
  tomorrow: "'Esok pada jam' p",
  nextWeek: "eeee 'pada jam' p",
  other: "P",
};

const formatRelative$Y = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$u[token];
formatRelative$Z.formatRelative = formatRelative$Y;

var localize$u = {};

localize$u.localize = void 0;
var _index$1$ = buildLocalizeFn$1;

// Most data for localization are taken from this page
// https://www.unicode.org/cldr/charts/32/summary/ms.html
const eraValues$u = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masihi", "Masihi"],
};

const quarterValues$u = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["S1", "S2", "S3", "S4"],
  wide: ["Suku pertama", "Suku kedua", "Suku ketiga", "Suku keempat"],
};

// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$u = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mac",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Ogo",
    "Sep",
    "Okt",
    "Nov",
    "Dis",
  ],

  wide: [
    "Januari",
    "Februari",
    "Mac",
    "April",
    "Mei",
    "Jun",
    "Julai",
    "Ogos",
    "September",
    "Oktober",
    "November",
    "Disember",
  ],
};

const dayValues$u = {
  narrow: ["A", "I", "S", "R", "K", "J", "S"],
  short: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  abbreviated: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  wide: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"],
};

const dayPeriodValues$u = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tgh malam",
    noon: "tgh hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam",
  },
};

const formattingDayPeriodValues$o = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam",
  },
};

const ordinalNumber$u = (dirtyNumber, _options) => {
  // Can't use "pertama", "kedua" because can't be parsed
  return "ke-" + Number(dirtyNumber);
};

(localize$u.localize = {
  ordinalNumber: ordinalNumber$u,

  era: (0, _index$1$.buildLocalizeFn)({
    values: eraValues$u,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1$.buildLocalizeFn)({
    values: quarterValues$u,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1$.buildLocalizeFn)({
    values: monthValues$u,
    defaultWidth: "wide",
  }),

  day: (0, _index$1$.buildLocalizeFn)({
    values: dayValues$u,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1$.buildLocalizeFn)({
    values: dayPeriodValues$u,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$o,
    defaultFormattingWidth: "wide",
  }),
});

var match$u = {};

match$u.match = void 0;

var _index$1_ = buildMatchFn$1;
var _index2$_ = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$u = /^ke-(\d+)?/i;
const parseOrdinalNumberPattern$u = /petama|\d+/i;

const matchEraPatterns$u = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
  wide: /^(sebelum masihi|masihi)/i,
};
const parseEraPatterns$u = {
  any: [/^s/i, /^(m)/i],
};

const matchQuarterPatterns$u = {
  narrow: /^[1234]/i,
  abbreviated: /^S[1234]/i,
  wide: /Suku (pertama|kedua|ketiga|keempat)/i,
};
const parseQuarterPatterns$u = {
  any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i],
};

const matchMonthPatterns$u = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
  wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i,
};
const parseMonthPatterns$u = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^o/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^ap/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^og/i,
    /^s/i,
    /^ok/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$u = {
  narrow: /^[aisrkj]/i,
  short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i,
};
const parseDayPatterns$u = {
  narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i],
};

const matchDayPeriodPatterns$u = {
  narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i,
};
const parseDayPeriodPatterns$u = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pa/i,
    afternoon: /tengah h/i,
    evening: /pe/i,
    night: /m/i,
  },
};

(match$u.match = {
  ordinalNumber: (0, _index2$_.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$u,
    parsePattern: parseOrdinalNumberPattern$u,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1_.buildMatchFn)({
    matchPatterns: matchEraPatterns$u,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$u,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1_.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$u,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$u,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1_.buildMatchFn)({
    matchPatterns: matchMonthPatterns$u,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$u,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1_.buildMatchFn)({
    matchPatterns: matchDayPatterns$u,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$u,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1_.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$u,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$u,
    defaultParseWidth: "any",
  }),
});

ms.ms = void 0;
var _index$1Z = formatDistance$Z;
var _index2$Z = formatLong$u;
var _index3$u = formatRelative$Z;
var _index4$u = localize$u;
var _index5$u = match$u;

/**
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten](https://github.com/Zyten)
 */
(ms.ms = {
  code: "ms",
  formatDistance: _index$1Z.formatDistance,
  formatLong: _index2$Z.formatLong,
  formatRelative: _index3$u.formatRelative,
  localize: _index4$u.localize,
  match: _index5$u.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var mt = {};

var formatDistance$X = {};

formatDistance$X.formatDistance = void 0;

const formatDistanceLocale$t = {
  lessThanXSeconds: {
    one: "inqas minn sekonda",
    other: "inqas minn {{count}} sekondi",
  },

  xSeconds: {
    one: "sekonda",
    other: "{{count}} sekondi",
  },

  halfAMinute: "nofs minuta",

  lessThanXMinutes: {
    one: "inqas minn minuta",
    other: "inqas minn {{count}} minuti",
  },

  xMinutes: {
    one: "minuta",
    other: "{{count}} minuti",
  },

  aboutXHours: {
    one: "madwar siegħa",
    other: "madwar {{count}} siegħat",
  },

  xHours: {
    one: "siegħa",
    other: "{{count}} siegħat",
  },

  xDays: {
    one: "ġurnata",
    other: "{{count}} ġranet",
  },

  aboutXWeeks: {
    one: "madwar ġimgħa",
    other: "madwar {{count}} ġimgħat",
  },

  xWeeks: {
    one: "ġimgħa",
    other: "{{count}} ġimgħat",
  },

  aboutXMonths: {
    one: "madwar xahar",
    other: "madwar {{count}} xhur",
  },

  xMonths: {
    one: "xahar",
    other: "{{count}} xhur",
  },

  aboutXYears: {
    one: "madwar sena",
    two: "madwar sentejn",
    other: "madwar {{count}} snin",
  },

  xYears: {
    one: "sena",
    two: "sentejn",
    other: "{{count}} snin",
  },

  overXYears: {
    one: "aktar minn sena",
    two: "aktar minn sentejn",
    other: "aktar minn {{count}} snin",
  },

  almostXYears: {
    one: "kważi sena",
    two: "kważi sentejn",
    other: "kważi {{count}} snin",
  },
};

const formatDistance$W = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$t[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else if (count === 2 && tokenValue.two) {
    result = tokenValue.two;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "f'" + result;
    } else {
      return result + " ilu";
    }
  }

  return result;
};
formatDistance$X.formatDistance = formatDistance$W;

var formatLong$t = {};

formatLong$t.formatLong = void 0;
var _index$1Y = buildFormatLongFn$1;

const dateFormats$t = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy",
};

const timeFormats$t = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$t = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$t.formatLong = {
  date: (0, _index$1Y.buildFormatLongFn)({
    formats: dateFormats$t,
    defaultWidth: "full",
  }),

  time: (0, _index$1Y.buildFormatLongFn)({
    formats: timeFormats$t,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1Y.buildFormatLongFn)({
    formats: dateTimeFormats$t,
    defaultWidth: "full",
  }),
});

var formatRelative$X = {};

formatRelative$X.formatRelative = void 0;

const formatRelativeLocale$t = {
  lastWeek: "eeee 'li għadda' 'fil-'p",
  yesterday: "'Il-bieraħ fil-'p",
  today: "'Illum fil-'p",
  tomorrow: "'Għada fil-'p",
  nextWeek: "eeee 'fil-'p",
  other: "P",
};

const formatRelative$W = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$t[token];
formatRelative$X.formatRelative = formatRelative$W;

var localize$t = {};

localize$t.localize = void 0;
var _index$1X = buildLocalizeFn$1;

const eraValues$t = {
  narrow: ["Q", "W"],
  abbreviated: ["QK", "WK"],
  wide: ["qabel Kristu", "wara Kristu"],
};

const quarterValues$t = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kwart", "2. kwart", "3. kwart", "4. kwart"],
};

const monthValues$t = {
  narrow: ["J", "F", "M", "A", "M", "Ġ", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Fra",
    "Mar",
    "Apr",
    "Mej",
    "Ġun",
    "Lul",
    "Aww",
    "Set",
    "Ott",
    "Nov",
    "Diċ",
  ],

  wide: [
    "Jannar",
    "Frar",
    "Marzu",
    "April",
    "Mejju",
    "Ġunju",
    "Lulju",
    "Awwissu",
    "Settembru",
    "Ottubru",
    "Novembru",
    "Diċembru",
  ],
};

const dayValues$t = {
  narrow: ["Ħ", "T", "T", "E", "Ħ", "Ġ", "S"],
  short: ["Ħa", "Tn", "Tl", "Er", "Ħa", "Ġi", "Si"],
  abbreviated: ["Ħad", "Tne", "Tli", "Erb", "Ħam", "Ġim", "Sib"],
  wide: [
    "Il-Ħadd",
    "It-Tnejn",
    "It-Tlieta",
    "L-Erbgħa",
    "Il-Ħamis",
    "Il-Ġimgħa",
    "Is-Sibt",
  ],
};

const dayPeriodValues$t = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl",
  },
};

const formattingDayPeriodValues$n = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl",
  },
};

const ordinalNumber$t = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "º";
};

(localize$t.localize = {
  ordinalNumber: ordinalNumber$t,

  era: (0, _index$1X.buildLocalizeFn)({
    values: eraValues$t,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1X.buildLocalizeFn)({
    values: quarterValues$t,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1X.buildLocalizeFn)({
    values: monthValues$t,
    defaultWidth: "wide",
  }),

  day: (0, _index$1X.buildLocalizeFn)({
    values: dayValues$t,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1X.buildLocalizeFn)({
    values: dayPeriodValues$t,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$n,
    defaultFormattingWidth: "wide",
  }),
});

var match$t = {};

match$t.match = void 0;

var _index$1W = buildMatchFn$1;
var _index2$Y = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$t = /^(\d+)(º)?/i;
const parseOrdinalNumberPattern$t = /\d+/i;

const matchEraPatterns$t = {
  narrow: /^(q|w)/i,
  abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
  wide: /^(qabel kristu|before common era|wara kristu|common era)/i,
};
const parseEraPatterns$t = {
  any: [/^(q|b)/i, /^(w|c)/i],
};

const matchQuarterPatterns$t = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](\.)? kwart/i,
};
const parseQuarterPatterns$t = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$t = {
  narrow: /^[jfmaglsond]/i,
  abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
  wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i,
};
const parseMonthPatterns$t = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^ġ/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mej/i,
    /^ġ/i,
    /^l/i,
    /^aw/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$t = {
  narrow: /^[ħteġs]/i,
  short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
  abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
  wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i,
};
const parseDayPatterns$t = {
  narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
  any: [
    /^(il-)?ħad/i,
    /^(it-)?tn/i,
    /^(it-)?tl/i,
    /^(l-)?er/i,
    /^(il-)?ham/i,
    /^(il-)?ġi/i,
    /^(is-)?si/i,
  ],
};

const matchDayPeriodPatterns$t = {
  narrow:
    /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
  any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
};
const parseDayPeriodPatterns$t = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^f'nofsillejl/i,
    noon: /^f'nofsinhar/i,
    morning: /għodwa/i,
    afternoon: /wara(\s.*)nofsinhar/i,
    evening: /filgħaxija/i,
    night: /lejl/i,
  },
};

(match$t.match = {
  ordinalNumber: (0, _index2$Y.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$t,
    parsePattern: parseOrdinalNumberPattern$t,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1W.buildMatchFn)({
    matchPatterns: matchEraPatterns$t,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$t,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1W.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$t,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$t,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1W.buildMatchFn)({
    matchPatterns: matchMonthPatterns$t,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$t,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1W.buildMatchFn)({
    matchPatterns: matchDayPatterns$t,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$t,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1W.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$t,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$t,
    defaultParseWidth: "any",
  }),
});

mt.mt = void 0;
var _index$1V = formatDistance$X;
var _index2$X = formatLong$t;
var _index3$t = formatRelative$X;
var _index4$t = localize$t;
var _index5$t = match$t;

/**
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */
(mt.mt = {
  code: "mt",
  formatDistance: _index$1V.formatDistance,
  formatLong: _index2$X.formatLong,
  formatRelative: _index3$t.formatRelative,
  localize: _index4$t.localize,
  match: _index5$t.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var nb = {};

var formatDistance$V = {};

formatDistance$V.formatDistance = void 0;

const formatDistanceLocale$s = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder",
  },

  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder",
  },

  halfAMinute: "et halvt minutt",

  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter",
  },

  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter",
  },

  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer",
  },

  xHours: {
    one: "en time",
    other: "{{count}} timer",
  },

  xDays: {
    one: "en dag",
    other: "{{count}} dager",
  },

  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker",
  },

  xWeeks: {
    one: "en uke",
    other: "{{count}} uker",
  },

  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder",
  },

  xMonths: {
    one: "en måned",
    other: "{{count}} måneder",
  },

  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år",
  },

  xYears: {
    one: "ett år",
    other: "{{count}} år",
  },

  overXYears: {
    one: "over ett år",
    other: "over {{count}} år",
  },

  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år",
  },
};

const formatDistance$U = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$s[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "om " + result;
    } else {
      return result + " siden";
    }
  }

  return result;
};
formatDistance$V.formatDistance = formatDistance$U;

var formatLong$s = {};

formatLong$s.formatLong = void 0;
var _index$1U = buildFormatLongFn$1;

const dateFormats$s = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y",
};

const timeFormats$s = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$s = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$s.formatLong = {
  date: (0, _index$1U.buildFormatLongFn)({
    formats: dateFormats$s,
    defaultWidth: "full",
  }),

  time: (0, _index$1U.buildFormatLongFn)({
    formats: timeFormats$s,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1U.buildFormatLongFn)({
    formats: dateTimeFormats$s,
    defaultWidth: "full",
  }),
});

var formatRelative$V = {};

formatRelative$V.formatRelative = void 0;

const formatRelativeLocale$s = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P",
};

const formatRelative$U = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$s[token];
formatRelative$V.formatRelative = formatRelative$U;

var localize$s = {};

localize$s.localize = void 0;
var _index$1T = buildLocalizeFn$1;

const eraValues$s = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"],
};

const quarterValues$s = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"],
};

const monthValues$s = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "mai",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des.",
  ],

  wide: [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember",
  ],
};

const dayValues$s = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag",
  ],
};

const dayPeriodValues$s = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten",
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten",
  },
};

const ordinalNumber$s = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$s.localize = {
  ordinalNumber: ordinalNumber$s,

  era: (0, _index$1T.buildLocalizeFn)({
    values: eraValues$s,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1T.buildLocalizeFn)({
    values: quarterValues$s,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1T.buildLocalizeFn)({
    values: monthValues$s,
    defaultWidth: "wide",
  }),

  day: (0, _index$1T.buildLocalizeFn)({
    values: dayValues$s,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1T.buildLocalizeFn)({
    values: dayPeriodValues$s,
    defaultWidth: "wide",
  }),
});

var match$s = {};

match$s.match = void 0;

var _index$1S = buildMatchFn$1;
var _index2$W = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$s = /^(\d+)\.?/i;
const parseOrdinalNumberPattern$s = /\d+/i;

const matchEraPatterns$s = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i,
};
const parseEraPatterns$s = {
  any: [/^f/i, /^e/i],
};

const matchQuarterPatterns$s = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i,
};
const parseQuarterPatterns$s = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$s = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i,
};
const parseMonthPatterns$s = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$s = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i,
};
const parseDayPatterns$s = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i],
};

const matchDayPeriodPatterns$s = {
  narrow:
    /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i,
};
const parseDayPeriodPatterns$s = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i,
  },
};

(match$s.match = {
  ordinalNumber: (0, _index2$W.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$s,
    parsePattern: parseOrdinalNumberPattern$s,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1S.buildMatchFn)({
    matchPatterns: matchEraPatterns$s,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$s,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1S.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$s,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$s,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1S.buildMatchFn)({
    matchPatterns: matchMonthPatterns$s,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$s,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1S.buildMatchFn)({
    matchPatterns: matchDayPatterns$s,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$s,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1S.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$s,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$s,
    defaultParseWidth: "any",
  }),
});

nb.nb = void 0;
var _index$1R = formatDistance$V;
var _index2$V = formatLong$s;
var _index3$s = formatRelative$V;
var _index4$s = localize$s;
var _index5$s = match$s;

/**
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse](https://github.com/Hanse)
 * @author Mikolaj Grzyb [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Dag Stuan [@dagstuan](https://github.com/dagstuan)
 */
(nb.nb = {
  code: "nb",
  formatDistance: _index$1R.formatDistance,
  formatLong: _index2$V.formatLong,
  formatRelative: _index3$s.formatRelative,
  localize: _index4$s.localize,
  match: _index5$s.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var nl = {};

var formatDistance$T = {};

formatDistance$T.formatDistance = void 0;

const formatDistanceLocale$r = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden",
  },

  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden",
  },

  halfAMinute: "een halve minuut",

  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten",
  },

  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten",
  },

  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur",
  },

  xHours: {
    one: "1 uur",
    other: "{{count}} uur",
  },

  xDays: {
    one: "1 dag",
    other: "{{count}} dagen",
  },

  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weken",
  },

  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden",
  },

  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden",
  },

  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar",
  },

  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar",
  },

  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar",
  },

  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar",
  },
};

const formatDistance$S = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$r[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "over " + result;
    } else {
      return result + " geleden";
    }
  }

  return result;
};
formatDistance$T.formatDistance = formatDistance$S;

var formatLong$r = {};

formatLong$r.formatLong = void 0;
var _index$1Q = buildFormatLongFn$1;

const dateFormats$r = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y",
};

const timeFormats$r = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$r = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$r.formatLong = {
  date: (0, _index$1Q.buildFormatLongFn)({
    formats: dateFormats$r,
    defaultWidth: "full",
  }),

  time: (0, _index$1Q.buildFormatLongFn)({
    formats: timeFormats$r,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1Q.buildFormatLongFn)({
    formats: dateTimeFormats$r,
    defaultWidth: "full",
  }),
});

var formatRelative$T = {};

formatRelative$T.formatRelative = void 0;

const formatRelativeLocale$r = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P",
};

const formatRelative$S = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$r[token];
formatRelative$T.formatRelative = formatRelative$S;

var localize$r = {};

localize$r.localize = void 0;
var _index$1P = buildLocalizeFn$1;

const eraValues$r = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"],
};

const quarterValues$r = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"],
};

const monthValues$r = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec.",
  ],

  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december",
  ],
};

const dayValues$r = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag",
  ],
};

const dayPeriodValues$r = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts",
  },
};

const ordinalNumber$r = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "e";
};

(localize$r.localize = {
  ordinalNumber: ordinalNumber$r,

  era: (0, _index$1P.buildLocalizeFn)({
    values: eraValues$r,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1P.buildLocalizeFn)({
    values: quarterValues$r,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1P.buildLocalizeFn)({
    values: monthValues$r,
    defaultWidth: "wide",
  }),

  day: (0, _index$1P.buildLocalizeFn)({
    values: dayValues$r,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1P.buildLocalizeFn)({
    values: dayPeriodValues$r,
    defaultWidth: "wide",
  }),
});

var match$r = {};

match$r.match = void 0;

var _index$1O = buildMatchFn$1;
var _index2$U = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$r = /^(\d+)e?/i;
const parseOrdinalNumberPattern$r = /\d+/i;

const matchEraPatterns$r = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/,
};
const parseEraPatterns$r = {
  any: [/^v/, /^n/],
};

const matchQuarterPatterns$r = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i,
};
const parseQuarterPatterns$r = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$r = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i,
};
const parseMonthPatterns$r = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i,
  ],
};

const matchDayPatterns$r = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i,
};
const parseDayPatterns$r = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i],
};

const matchDayPeriodPatterns$r = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i,
};
const parseDayPeriodPatterns$r = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i,
  },
};

(match$r.match = {
  ordinalNumber: (0, _index2$U.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$r,
    parsePattern: parseOrdinalNumberPattern$r,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1O.buildMatchFn)({
    matchPatterns: matchEraPatterns$r,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$r,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1O.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$r,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$r,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1O.buildMatchFn)({
    matchPatterns: matchMonthPatterns$r,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$r,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1O.buildMatchFn)({
    matchPatterns: matchDayPatterns$r,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$r,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1O.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$r,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$r,
    defaultParseWidth: "any",
  }),
});

nl.nl = void 0;
var _index$1N = formatDistance$T;
var _index2$T = formatLong$r;
var _index3$r = formatRelative$T;
var _index4$r = localize$r;
var _index5$r = match$r;

/**
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
 * @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
 * @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
 * @author Edo Rivai [@edorivai](https://github.com/edorivai)
 * @author Niels Keurentjes [@curry684](https://github.com/curry684)
 * @author Stefan Vermaas [@stefanvermaas](https://github.com/stefanvermaas)
 */
(nl.nl = {
  code: "nl",
  formatDistance: _index$1N.formatDistance,
  formatLong: _index2$T.formatLong,
  formatRelative: _index3$r.formatRelative,
  localize: _index4$r.localize,
  match: _index5$r.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var nlBE = {};

var formatDistance$R = {};

formatDistance$R.formatDistance = void 0;

const formatDistanceLocale$q = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden",
  },

  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden",
  },

  halfAMinute: "een halve minuut",

  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten",
  },

  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten",
  },

  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur",
  },

  xHours: {
    one: "1 uur",
    other: "{{count}} uur",
  },

  xDays: {
    one: "1 dag",
    other: "{{count}} dagen",
  },

  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken",
  },

  xWeeks: {
    one: "1 week",
    other: "{{count}} weken",
  },

  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden",
  },

  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden",
  },

  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar",
  },

  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar",
  },

  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar",
  },

  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar",
  },
};

const formatDistance$Q = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$q[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "over " + result;
    } else {
      return result + " geleden";
    }
  }

  return result;
};
formatDistance$R.formatDistance = formatDistance$Q;

var formatLong$q = {};

formatLong$q.formatLong = void 0;
var _index$1M = buildFormatLongFn$1;

const dateFormats$q = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y",
};

const timeFormats$q = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$q = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$q.formatLong = {
  date: (0, _index$1M.buildFormatLongFn)({
    formats: dateFormats$q,
    defaultWidth: "full",
  }),

  time: (0, _index$1M.buildFormatLongFn)({
    formats: timeFormats$q,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1M.buildFormatLongFn)({
    formats: dateTimeFormats$q,
    defaultWidth: "full",
  }),
});

var formatRelative$R = {};

formatRelative$R.formatRelative = void 0;

const formatRelativeLocale$q = {
  lastWeek: "'vorige' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P",
};

const formatRelative$Q = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$q[token];
formatRelative$R.formatRelative = formatRelative$Q;

var localize$q = {};

localize$q.localize = void 0;
var _index$1L = buildLocalizeFn$1;

const eraValues$q = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"],
};

const quarterValues$q = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"],
};

const monthValues$q = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec.",
  ],

  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december",
  ],
};

const dayValues$q = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag",
  ],
};

const dayPeriodValues$q = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts",
  },
};

const ordinalNumber$q = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "e";
};

(localize$q.localize = {
  ordinalNumber: ordinalNumber$q,

  era: (0, _index$1L.buildLocalizeFn)({
    values: eraValues$q,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1L.buildLocalizeFn)({
    values: quarterValues$q,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1L.buildLocalizeFn)({
    values: monthValues$q,
    defaultWidth: "wide",
  }),

  day: (0, _index$1L.buildLocalizeFn)({
    values: dayValues$q,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1L.buildLocalizeFn)({
    values: dayPeriodValues$q,
    defaultWidth: "wide",
  }),
});

var match$q = {};

match$q.match = void 0;

var _index$1K = buildMatchFn$1;
var _index2$S = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$q = /^(\d+)e?/i;
const parseOrdinalNumberPattern$q = /\d+/i;

const matchEraPatterns$q = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/,
};
const parseEraPatterns$q = {
  any: [/^v/, /^n/],
};

const matchQuarterPatterns$q = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i,
};
const parseQuarterPatterns$q = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$q = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i,
};
const parseMonthPatterns$q = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i,
  ],
};

const matchDayPatterns$q = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i,
};
const parseDayPatterns$q = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i],
};

const matchDayPeriodPatterns$q = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i,
};
const parseDayPeriodPatterns$q = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i,
  },
};

(match$q.match = {
  ordinalNumber: (0, _index2$S.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$q,
    parsePattern: parseOrdinalNumberPattern$q,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1K.buildMatchFn)({
    matchPatterns: matchEraPatterns$q,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$q,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1K.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$q,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$q,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1K.buildMatchFn)({
    matchPatterns: matchMonthPatterns$q,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$q,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1K.buildMatchFn)({
    matchPatterns: matchDayPatterns$q,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$q,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1K.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$q,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$q,
    defaultParseWidth: "any",
  }),
});

nlBE.nlBE = void 0;
var _index$1J = formatDistance$R;
var _index2$R = formatLong$q;
var _index3$q = formatRelative$R;
var _index4$q = localize$q;
var _index5$q = match$q;

/**
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder](https://github.com/jtangelder)
 * @author Ruben Stolk [@rubenstolk](https://github.com/rubenstolk)
 * @author Lode Vanhove [@bitcrumb](https://github.com/bitcrumb)
 * @author Alex Hoeing [@dcbn](https://github.com/dcbn)
 */
(nlBE.nlBE = {
  code: "nl-BE",
  formatDistance: _index$1J.formatDistance,
  formatLong: _index2$R.formatLong,
  formatRelative: _index3$q.formatRelative,
  localize: _index4$q.localize,
  match: _index5$q.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var nn = {};

var formatDistance$P = {};

formatDistance$P.formatDistance = void 0;

const formatDistanceLocale$p = {
  lessThanXSeconds: {
    one: "mindre enn eitt sekund",
    other: "mindre enn {{count}} sekund",
  },

  xSeconds: {
    one: "eitt sekund",
    other: "{{count}} sekund",
  },

  halfAMinute: "eit halvt minutt",

  lessThanXMinutes: {
    one: "mindre enn eitt minutt",
    other: "mindre enn {{count}} minutt",
  },

  xMinutes: {
    one: "eitt minutt",
    other: "{{count}} minutt",
  },

  aboutXHours: {
    one: "omtrent ein time",
    other: "omtrent {{count}} timar",
  },

  xHours: {
    one: "ein time",
    other: "{{count}} timar",
  },

  xDays: {
    one: "ein dag",
    other: "{{count}} dagar",
  },

  aboutXWeeks: {
    one: "omtrent ei veke",
    other: "omtrent {{count}} veker",
  },

  xWeeks: {
    one: "ei veke",
    other: "{{count}} veker",
  },

  aboutXMonths: {
    one: "omtrent ein månad",
    other: "omtrent {{count}} månader",
  },

  xMonths: {
    one: "ein månad",
    other: "{{count}} månader",
  },

  aboutXYears: {
    one: "omtrent eitt år",
    other: "omtrent {{count}} år",
  },

  xYears: {
    one: "eitt år",
    other: "{{count}} år",
  },

  overXYears: {
    one: "over eitt år",
    other: "over {{count}} år",
  },

  almostXYears: {
    one: "nesten eitt år",
    other: "nesten {{count}} år",
  },
};

const wordMapping$1 = [
  "null",
  "ein",
  "to",
  "tre",
  "fire",
  "fem",
  "seks",
  "sju",
  "åtte",
  "ni",
  "ti",
  "elleve",
  "tolv",
];

const formatDistance$O = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$p[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace(
      "{{count}}",
      count < 13 ? wordMapping$1[count] : String(count),
    );
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "om " + result;
    } else {
      return result + " sidan";
    }
  }

  return result;
};
formatDistance$P.formatDistance = formatDistance$O;

var formatLong$p = {};

formatLong$p.formatLong = void 0;
var _index$1I = buildFormatLongFn$1;

const dateFormats$p = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y",
};

const timeFormats$p = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$p = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$p.formatLong = {
  date: (0, _index$1I.buildFormatLongFn)({
    formats: dateFormats$p,
    defaultWidth: "full",
  }),

  time: (0, _index$1I.buildFormatLongFn)({
    formats: timeFormats$p,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1I.buildFormatLongFn)({
    formats: dateTimeFormats$p,
    defaultWidth: "full",
  }),
});

var formatRelative$P = {};

formatRelative$P.formatRelative = void 0;

const formatRelativeLocale$p = {
  lastWeek: "'førre' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P",
};

const formatRelative$O = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$p[token];
formatRelative$P.formatRelative = formatRelative$O;

var localize$p = {};

localize$p.localize = void 0;
var _index$1H = buildLocalizeFn$1;

const eraValues$p = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"],
};

const quarterValues$p = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"],
};

const monthValues$p = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "mai",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des.",
  ],

  wide: [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember",
  ],
};

const dayValues$p = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["su", "må", "ty", "on", "to", "fr", "lau"],
  abbreviated: ["sun", "mån", "tys", "ons", "tor", "fre", "laur"],
  wide: [
    "sundag",
    "måndag",
    "tysdag",
    "onsdag",
    "torsdag",
    "fredag",
    "laurdag",
  ],
};

const dayPeriodValues$p = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta",
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natta",
  },
};

const ordinalNumber$p = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$p.localize = {
  ordinalNumber: ordinalNumber$p,

  era: (0, _index$1H.buildLocalizeFn)({
    values: eraValues$p,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1H.buildLocalizeFn)({
    values: quarterValues$p,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1H.buildLocalizeFn)({
    values: monthValues$p,
    defaultWidth: "wide",
  }),

  day: (0, _index$1H.buildLocalizeFn)({
    values: dayValues$p,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1H.buildLocalizeFn)({
    values: dayPeriodValues$p,
    defaultWidth: "wide",
  }),
});

var match$p = {};

match$p.match = void 0;

var _index$1G = buildMatchFn$1;
var _index2$Q = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$p = /^(\d+)\.?/i;
const parseOrdinalNumberPattern$p = /\d+/i;

const matchEraPatterns$p = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i,
};
const parseEraPatterns$p = {
  any: [/^f/i, /^e/i],
};

const matchQuarterPatterns$p = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i,
};
const parseQuarterPatterns$p = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$p = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i,
};
const parseMonthPatterns$p = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$p = {
  narrow: /^[smtofl]/i,
  short: /^(su|må|ty|on|to|fr|la)/i,
  abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
  wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i,
};
const parseDayPatterns$p = {
  any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i],
};

const matchDayPeriodPatterns$p = {
  narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i,
};
const parseDayPeriodPatterns$p = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i,
  },
};

(match$p.match = {
  ordinalNumber: (0, _index2$Q.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$p,
    parsePattern: parseOrdinalNumberPattern$p,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1G.buildMatchFn)({
    matchPatterns: matchEraPatterns$p,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$p,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1G.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$p,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$p,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1G.buildMatchFn)({
    matchPatterns: matchMonthPatterns$p,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$p,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1G.buildMatchFn)({
    matchPatterns: matchDayPatterns$p,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$p,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1G.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$p,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$p,
    defaultParseWidth: "any",
  }),
});

nn.nn = void 0;
var _index$1F = formatDistance$P;
var _index2$P = formatLong$p;
var _index3$p = formatRelative$P;
var _index4$p = localize$p;
var _index5$p = match$p;

/**
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner](https://github.com/draperunner)
 */
(nn.nn = {
  code: "nn",
  formatDistance: _index$1F.formatDistance,
  formatLong: _index2$P.formatLong,
  formatRelative: _index3$p.formatRelative,
  localize: _index4$p.localize,
  match: _index5$p.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var oc = {};

var formatDistance$N = {};

formatDistance$N.formatDistance = void 0;

const formatDistanceLocale$o = {
  lessThanXSeconds: {
    one: "mens d’una segonda",
    other: "mens de {{count}} segondas",
  },

  xSeconds: {
    one: "1 segonda",
    other: "{{count}} segondas",
  },

  halfAMinute: "30 segondas",

  lessThanXMinutes: {
    one: "mens d’una minuta",
    other: "mens de {{count}} minutas",
  },

  xMinutes: {
    one: "1 minuta",
    other: "{{count}} minutas",
  },

  aboutXHours: {
    one: "environ 1 ora",
    other: "environ {{count}} oras",
  },

  xHours: {
    one: "1 ora",
    other: "{{count}} oras",
  },

  xDays: {
    one: "1 jorn",
    other: "{{count}} jorns",
  },

  aboutXWeeks: {
    one: "environ 1 setmana",
    other: "environ {{count}} setmanas",
  },

  xWeeks: {
    one: "1 setmana",
    other: "{{count}} setmanas",
  },

  aboutXMonths: {
    one: "environ 1 mes",
    other: "environ {{count}} meses",
  },

  xMonths: {
    one: "1 mes",
    other: "{{count}} meses",
  },

  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans",
  },

  xYears: {
    one: "1 an",
    other: "{{count}} ans",
  },

  overXYears: {
    one: "mai d’un an",
    other: "mai de {{count}} ans",
  },

  almostXYears: {
    one: "gaireben un an",
    other: "gaireben {{count}} ans",
  },
};

const formatDistance$M = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$o[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "d’aquí " + result;
    } else {
      return "fa " + result;
    }
  }

  return result;
};
formatDistance$N.formatDistance = formatDistance$M;

var formatLong$o = {};

formatLong$o.formatLong = void 0;
var _index$1E = buildFormatLongFn$1;

const dateFormats$o = {
  full: "EEEE d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y",
};

const timeFormats$o = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$o = {
  full: "{{date}} 'a' {{time}}",
  long: "{{date}} 'a' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$o.formatLong = {
  date: (0, _index$1E.buildFormatLongFn)({
    formats: dateFormats$o,
    defaultWidth: "full",
  }),

  time: (0, _index$1E.buildFormatLongFn)({
    formats: timeFormats$o,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1E.buildFormatLongFn)({
    formats: dateTimeFormats$o,
    defaultWidth: "full",
  }),
});

var formatRelative$N = {};

formatRelative$N.formatRelative = void 0;

const formatRelativeLocale$o = {
  lastWeek: "eeee 'passat a' p",
  yesterday: "'ièr a' p",
  today: "'uèi a' p",
  tomorrow: "'deman a' p",
  nextWeek: "eeee 'a' p",
  other: "P",
};

const formatRelative$M = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$o[token];
formatRelative$N.formatRelative = formatRelative$M;

var localize$o = {};

localize$o.localize = void 0;
var _index$1D = buildLocalizeFn$1;

const eraValues$o = {
  narrow: ["ab. J.C.", "apr. J.C."],
  abbreviated: ["ab. J.C.", "apr. J.C."],
  wide: ["abans Jèsus-Crist", "après Jèsus-Crist"],
};

const quarterValues$o = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1èr trim.", "2nd trim.", "3en trim.", "4en trim."],
  wide: ["1èr trimèstre", "2nd trimèstre", "3en trimèstre", "4en trimèstre"],
};

const monthValues$o = {
  narrow: [
    "GN",
    "FB",
    "MÇ",
    "AB",
    "MA",
    "JN",
    "JL",
    "AG",
    "ST",
    "OC",
    "NV",
    "DC",
  ],

  abbreviated: [
    "gen.",
    "febr.",
    "març",
    "abr.",
    "mai",
    "junh",
    "jul.",
    "ag.",
    "set.",
    "oct.",
    "nov.",
    "dec.",
  ],

  wide: [
    "genièr",
    "febrièr",
    "març",
    "abril",
    "mai",
    "junh",
    "julhet",
    "agost",
    "setembre",
    "octòbre",
    "novembre",
    "decembre",
  ],
};

const dayValues$o = {
  narrow: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  short: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  abbreviated: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  wide: [
    "dimenge",
    "diluns",
    "dimars",
    "dimècres",
    "dijòus",
    "divendres",
    "dissabte",
  ],
};

const dayPeriodValues$o = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch",
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch",
  },
};

const formattingDayPeriodValues$m = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch",
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch",
  },
};

const ordinalNumber$o = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = options?.unit;
  let ordinal;

  switch (number) {
    case 1:
      ordinal = "èr";
      break;
    case 2:
      ordinal = "nd";
      break;
    default:
      ordinal = "en";
  }

  // feminine for year, week, hour, minute, second
  if (
    unit === "year" ||
    unit === "week" ||
    unit === "hour" ||
    unit === "minute" ||
    unit === "second"
  ) {
    ordinal += "a";
  }

  return number + ordinal;
};

(localize$o.localize = {
  ordinalNumber: ordinalNumber$o,

  era: (0, _index$1D.buildLocalizeFn)({
    values: eraValues$o,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1D.buildLocalizeFn)({
    values: quarterValues$o,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1D.buildLocalizeFn)({
    values: monthValues$o,
    defaultWidth: "wide",
  }),

  day: (0, _index$1D.buildLocalizeFn)({
    values: dayValues$o,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1D.buildLocalizeFn)({
    values: dayPeriodValues$o,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$m,
    defaultFormattingWidth: "wide",
  }),
});

var match$o = {};

match$o.match = void 0;

var _index$1C = buildMatchFn$1;
var _index2$O = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$o = /^(\d+)(èr|nd|en)?[a]?/i;
const parseOrdinalNumberPattern$o = /\d+/i;

const matchEraPatterns$o = {
  narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
  abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i,
};
const parseEraPatterns$o = {
  any: [/^ab/i, /^ap/i],
};

const matchQuarterPatterns$o = {
  narrow: /^T[1234]/i,
  abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
  wide: /^[1234](èr|nd|en)? trimèstre/i,
};
const parseQuarterPatterns$o = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$o = {
  narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
  abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
  wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i,
};
const parseMonthPatterns$o = {
  any: [
    /^g/i,
    /^f/i,
    /^ma[r?]|MÇ/i,
    /^ab/i,
    /^ma[i?]/i,
    /^ju[n?]|JN/i,
    /^ju[l?]|JL/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$o = {
  narrow: /^d[glmcjvs]\.?/i,
  short: /^d[glmcjvs]\.?/i,
  abbreviated: /^d[glmcjvs]\.?/i,
  wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i,
};
const parseDayPatterns$o = {
  narrow: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  short: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  abbreviated: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],

  any: [
    /^dg|dime/i,
    /^dl|dil/i,
    /^dm|dima/i,
    /^dc|dimè/i,
    /^dj|dij/i,
    /^dv|div/i,
    /^ds|dis/i,
  ],
};

const matchDayPeriodPatterns$o = {
  any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i,
};
const parseDayPeriodPatterns$o = {
  any: {
    am: /(^a)|ante meridiem/i,
    pm: /(^p)|post meridiem/i,
    midnight: /^mièj/i,
    noon: /^mièg/i,
    morning: /matin/i,
    afternoon: /aprèp-miègjorn/i,
    evening: /vèspre|ser/i,
    night: /nuèch/i,
  },
};

(match$o.match = {
  ordinalNumber: (0, _index2$O.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$o,
    parsePattern: parseOrdinalNumberPattern$o,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1C.buildMatchFn)({
    matchPatterns: matchEraPatterns$o,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$o,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1C.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$o,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$o,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1C.buildMatchFn)({
    matchPatterns: matchMonthPatterns$o,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$o,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1C.buildMatchFn)({
    matchPatterns: matchDayPatterns$o,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$o,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1C.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$o,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$o,
    defaultParseWidth: "any",
  }),
});

oc.oc = void 0;
var _index$1B = formatDistance$N;
var _index2$N = formatLong$o;
var _index3$o = formatRelative$N;
var _index4$o = localize$o;
var _index5$o = match$o;

/**
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */
(oc.oc = {
  code: "oc",
  formatDistance: _index$1B.formatDistance,
  formatLong: _index2$N.formatLong,
  formatRelative: _index3$o.formatRelative,
  localize: _index4$o.localize,
  match: _index5$o.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var pl = {};

var formatDistance$L = {};

formatDistance$L.formatDistance = void 0;

const formatDistanceLocale$n = {
  lessThanXSeconds: {
    one: {
      regular: "mniej niż sekunda",
      past: "mniej niż sekundę",
      future: "mniej niż sekundę",
    },
    twoFour: "mniej niż {{count}} sekundy",
    other: "mniej niż {{count}} sekund",
  },

  xSeconds: {
    one: {
      regular: "sekunda",
      past: "sekundę",
      future: "sekundę",
    },
    twoFour: "{{count}} sekundy",
    other: "{{count}} sekund",
  },

  halfAMinute: {
    one: "pół minuty",
    twoFour: "pół minuty",
    other: "pół minuty",
  },

  lessThanXMinutes: {
    one: {
      regular: "mniej niż minuta",
      past: "mniej niż minutę",
      future: "mniej niż minutę",
    },
    twoFour: "mniej niż {{count}} minuty",
    other: "mniej niż {{count}} minut",
  },

  xMinutes: {
    one: {
      regular: "minuta",
      past: "minutę",
      future: "minutę",
    },
    twoFour: "{{count}} minuty",
    other: "{{count}} minut",
  },

  aboutXHours: {
    one: {
      regular: "około godziny",
      past: "około godziny",
      future: "około godzinę",
    },
    twoFour: "około {{count}} godziny",
    other: "około {{count}} godzin",
  },

  xHours: {
    one: {
      regular: "godzina",
      past: "godzinę",
      future: "godzinę",
    },
    twoFour: "{{count}} godziny",
    other: "{{count}} godzin",
  },

  xDays: {
    one: {
      regular: "dzień",
      past: "dzień",
      future: "1 dzień",
    },
    twoFour: "{{count}} dni",
    other: "{{count}} dni",
  },

  aboutXWeeks: {
    one: "około tygodnia",
    twoFour: "około {{count}} tygodni",
    other: "około {{count}} tygodni",
  },

  xWeeks: {
    one: "tydzień",
    twoFour: "{{count}} tygodnie",
    other: "{{count}} tygodni",
  },

  aboutXMonths: {
    one: "około miesiąc",
    twoFour: "około {{count}} miesiące",
    other: "około {{count}} miesięcy",
  },

  xMonths: {
    one: "miesiąc",
    twoFour: "{{count}} miesiące",
    other: "{{count}} miesięcy",
  },

  aboutXYears: {
    one: "około rok",
    twoFour: "około {{count}} lata",
    other: "około {{count}} lat",
  },

  xYears: {
    one: "rok",
    twoFour: "{{count}} lata",
    other: "{{count}} lat",
  },

  overXYears: {
    one: "ponad rok",
    twoFour: "ponad {{count}} lata",
    other: "ponad {{count}} lat",
  },

  almostXYears: {
    one: "prawie rok",
    twoFour: "prawie {{count}} lata",
    other: "prawie {{count}} lat",
  },
};

function declensionGroup$1(scheme, count) {
  if (count === 1) {
    return scheme.one;
  }

  const rem100 = count % 100;

  // ends with 11-20
  if (rem100 <= 20 && rem100 > 10) {
    return scheme.other;
  }

  const rem10 = rem100 % 10;

  // ends with 2, 3, 4
  if (rem10 >= 2 && rem10 <= 4) {
    return scheme.twoFour;
  }

  return scheme.other;
}

function declension$3(scheme, count, time) {
  const group = declensionGroup$1(scheme, count);
  const finalText = typeof group === "string" ? group : group[time];
  return finalText.replace("{{count}}", String(count));
}

const formatDistance$K = (token, count, options) => {
  const scheme = formatDistanceLocale$n[token];
  if (!options?.addSuffix) {
    return declension$3(scheme, count, "regular");
  }

  if (options.comparison && options.comparison > 0) {
    return "za " + declension$3(scheme, count, "future");
  } else {
    return declension$3(scheme, count, "past") + " temu";
  }
};
formatDistance$L.formatDistance = formatDistance$K;

var formatLong$n = {};

formatLong$n.formatLong = void 0;
var _index$1A = buildFormatLongFn$1;

const dateFormats$n = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y",
};

const timeFormats$n = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$n = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$n.formatLong = {
  date: (0, _index$1A.buildFormatLongFn)({
    formats: dateFormats$n,
    defaultWidth: "full",
  }),

  time: (0, _index$1A.buildFormatLongFn)({
    formats: timeFormats$n,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1A.buildFormatLongFn)({
    formats: dateTimeFormats$n,
    defaultWidth: "full",
  }),
});

var formatRelative$L = {};

formatRelative$L.formatRelative = void 0;
var _index$1z = isSameWeek$1;

const adjectivesLastWeek = {
  masculine: "ostatni",
  feminine: "ostatnia",
};

const adjectivesThisWeek = {
  masculine: "ten",
  feminine: "ta",
};

const adjectivesNextWeek = {
  masculine: "następny",
  feminine: "następna",
};

const dayGrammaticalGender = {
  0: "feminine",
  1: "masculine",
  2: "masculine",
  3: "feminine",
  4: "masculine",
  5: "masculine",
  6: "feminine",
};

function dayAndTimeWithAdjective(token, date, baseDate, options) {
  let adjectives;
  if ((0, _index$1z.isSameWeek)(date, baseDate, options)) {
    adjectives = adjectivesThisWeek;
  } else if (token === "lastWeek") {
    adjectives = adjectivesLastWeek;
  } else if (token === "nextWeek") {
    adjectives = adjectivesNextWeek;
  } else {
    throw new Error(`Cannot determine adjectives for token ${token}`);
  }

  const day = date.getDay();
  const grammaticalGender = dayGrammaticalGender[day];

  const adjective = adjectives[grammaticalGender];

  return `'${adjective}' eeee 'o' p`;
}

const formatRelativeLocale$n = {
  lastWeek: dayAndTimeWithAdjective,
  yesterday: "'wczoraj o' p",
  today: "'dzisiaj o' p",
  tomorrow: "'jutro o' p",
  nextWeek: dayAndTimeWithAdjective,
  other: "P",
};

const formatRelative$K = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$n[token];

  if (typeof format === "function") {
    return format(token, date, baseDate, options);
  }

  return format;
};
formatRelative$L.formatRelative = formatRelative$K;

var localize$n = {};

localize$n.localize = void 0;
var _index$1y = buildLocalizeFn$1;

const eraValues$n = {
  narrow: ["p.n.e.", "n.e."],
  abbreviated: ["p.n.e.", "n.e."],
  wide: ["przed naszą erą", "naszej ery"],
};

const quarterValues$n = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I kw.", "II kw.", "III kw.", "IV kw."],
  wide: ["I kwartał", "II kwartał", "III kwartał", "IV kwartał"],
};

const monthValues$n = {
  narrow: ["S", "L", "M", "K", "M", "C", "L", "S", "W", "P", "L", "G"],
  abbreviated: [
    "sty",
    "lut",
    "mar",
    "kwi",
    "maj",
    "cze",
    "lip",
    "sie",
    "wrz",
    "paź",
    "lis",
    "gru",
  ],

  wide: [
    "styczeń",
    "luty",
    "marzec",
    "kwiecień",
    "maj",
    "czerwiec",
    "lipiec",
    "sierpień",
    "wrzesień",
    "październik",
    "listopad",
    "grudzień",
  ],
};
const monthFormattingValues = {
  narrow: ["s", "l", "m", "k", "m", "c", "l", "s", "w", "p", "l", "g"],
  abbreviated: [
    "sty",
    "lut",
    "mar",
    "kwi",
    "maj",
    "cze",
    "lip",
    "sie",
    "wrz",
    "paź",
    "lis",
    "gru",
  ],

  wide: [
    "stycznia",
    "lutego",
    "marca",
    "kwietnia",
    "maja",
    "czerwca",
    "lipca",
    "sierpnia",
    "września",
    "października",
    "listopada",
    "grudnia",
  ],
};

const dayValues$n = {
  narrow: ["N", "P", "W", "Ś", "C", "P", "S"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: [
    "niedziela",
    "poniedziałek",
    "wtorek",
    "środa",
    "czwartek",
    "piątek",
    "sobota",
  ],
};
const dayFormattingValues = {
  narrow: ["n", "p", "w", "ś", "c", "p", "s"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: [
    "niedziela",
    "poniedziałek",
    "wtorek",
    "środa",
    "czwartek",
    "piątek",
    "sobota",
  ],
};

const dayPeriodValues$n = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "półn.",
    noon: "poł",
    morning: "rano",
    afternoon: "popoł.",
    evening: "wiecz.",
    night: "noc",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc",
  },
};

const dayPeriodFormattingValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "o półn.",
    noon: "w poł.",
    morning: "rano",
    afternoon: "po poł.",
    evening: "wiecz.",
    night: "w nocy",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy",
  },
};

const ordinalNumber$n = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$n.localize = {
  ordinalNumber: ordinalNumber$n,

  era: (0, _index$1y.buildLocalizeFn)({
    values: eraValues$n,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1y.buildLocalizeFn)({
    values: quarterValues$n,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1y.buildLocalizeFn)({
    values: monthValues$n,
    defaultWidth: "wide",
    formattingValues: monthFormattingValues,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$1y.buildLocalizeFn)({
    values: dayValues$n,
    defaultWidth: "wide",
    formattingValues: dayFormattingValues,
    defaultFormattingWidth: "wide",
  }),

  dayPeriod: (0, _index$1y.buildLocalizeFn)({
    values: dayPeriodValues$n,
    defaultWidth: "wide",
    formattingValues: dayPeriodFormattingValues,
    defaultFormattingWidth: "wide",
  }),
});

var match$n = {};

match$n.match = void 0;

var _index$1x = buildMatchFn$1;
var _index2$M = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$n = /^(\d+)?/i;
const parseOrdinalNumberPattern$n = /\d+/i;

const matchEraPatterns$n = {
  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i,
};
const parseEraPatterns$n = {
  any: [/^p/i, /^n/i],
};

const matchQuarterPatterns$n = {
  narrow: /^[1234]/i,
  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i,
};
const parseQuarterPatterns$n = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i],
};

const matchMonthPatterns$n = {
  narrow: /^[slmkcwpg]/i,
  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i,
};
const parseMonthPatterns$n = {
  narrow: [
    /^s/i,
    /^l/i,
    /^m/i,
    /^k/i,
    /^m/i,
    /^c/i,
    /^l/i,
    /^s/i,
    /^w/i,
    /^p/i,
    /^l/i,
    /^g/i,
  ],

  any: [
    /^st/i,
    /^lu/i,
    /^mar/i,
    /^k/i,
    /^maj/i,
    /^c/i,
    /^lip/i,
    /^si/i,
    /^w/i,
    /^p/i,
    /^lis/i,
    /^g/i,
  ],
};

const matchDayPatterns$n = {
  narrow: /^[npwścs]/i,
  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i,
};
const parseDayPatterns$n = {
  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],

  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i],
};

const matchDayPeriodPatterns$n = {
  narrow:
    /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i,
};
const parseDayPeriodPatterns$n = {
  narrow: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i,
  },
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i,
  },
};

(match$n.match = {
  ordinalNumber: (0, _index2$M.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$n,
    parsePattern: parseOrdinalNumberPattern$n,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1x.buildMatchFn)({
    matchPatterns: matchEraPatterns$n,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$n,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1x.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$n,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$n,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1x.buildMatchFn)({
    matchPatterns: matchMonthPatterns$n,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$n,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1x.buildMatchFn)({
    matchPatterns: matchDayPatterns$n,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$n,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1x.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$n,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$n,
    defaultParseWidth: "any",
  }),
});

pl.pl = void 0;
var _index$1w = formatDistance$L;
var _index2$L = formatLong$n;
var _index3$n = formatRelative$L;
var _index4$n = localize$n;
var _index5$n = match$n;

/**
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks](https://github.com/ertrzyiks)
 * @author Just RAG [@justrag](https://github.com/justrag)
 * @author Mikolaj Grzyb [@mikolajgrzyb](https://github.com/mikolajgrzyb)
 * @author Mateusz Tokarski [@mutisz](https://github.com/mutisz)
 */
(pl.pl = {
  code: "pl",
  formatDistance: _index$1w.formatDistance,
  formatLong: _index2$L.formatLong,
  formatRelative: _index3$n.formatRelative,
  localize: _index4$n.localize,
  match: _index5$n.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var pt = {};

var formatDistance$J = {};

formatDistance$J.formatDistance = void 0;

const formatDistanceLocale$m = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos",
  },

  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos",
  },

  halfAMinute: "meio minuto",

  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos",
  },

  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos",
  },

  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas",
  },

  xHours: {
    one: "1 hora",
    other: "{{count}} horas",
  },

  xDays: {
    one: "1 dia",
    other: "{{count}} dias",
  },

  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas",
  },

  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas",
  },

  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses",
  },

  xMonths: {
    one: "1 mês",
    other: "{{count}} meses",
  },

  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos",
  },

  xYears: {
    one: "1 ano",
    other: "{{count}} anos",
  },

  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos",
  },

  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos",
  },
};

const formatDistance$I = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$m[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "daqui a " + result;
    } else {
      return "há " + result;
    }
  }

  return result;
};
formatDistance$J.formatDistance = formatDistance$I;

var formatLong$m = {};

formatLong$m.formatLong = void 0;
var _index$1v = buildFormatLongFn$1;

const dateFormats$m = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y",
};

const timeFormats$m = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$m = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$m.formatLong = {
  date: (0, _index$1v.buildFormatLongFn)({
    formats: dateFormats$m,
    defaultWidth: "full",
  }),

  time: (0, _index$1v.buildFormatLongFn)({
    formats: timeFormats$m,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1v.buildFormatLongFn)({
    formats: dateTimeFormats$m,
    defaultWidth: "full",
  }),
});

var formatRelative$J = {};

formatRelative$J.formatRelative = void 0;

const formatRelativeLocale$m = {
  lastWeek: (date) => {
    const weekday = date.getDay();
    const last = weekday === 0 || weekday === 6 ? "último" : "última";
    return "'" + last + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P",
};

const formatRelative$I = (token, date, _baseDate, _options) => {
  const format = formatRelativeLocale$m[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$J.formatRelative = formatRelative$I;

var localize$m = {};

localize$m.localize = void 0;
var _index$1u = buildLocalizeFn$1;

const eraValues$m = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"],
};

const quarterValues$m = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"],
};

const monthValues$m = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez",
  ],

  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ],
};

const dayValues$m = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado",
  ],
};

const dayPeriodValues$m = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada",
  },
};

const formattingDayPeriodValues$l = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada",
  },
};

const ordinalNumber$m = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "º";
};

(localize$m.localize = {
  ordinalNumber: ordinalNumber$m,

  era: (0, _index$1u.buildLocalizeFn)({
    values: eraValues$m,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1u.buildLocalizeFn)({
    values: quarterValues$m,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1u.buildLocalizeFn)({
    values: monthValues$m,
    defaultWidth: "wide",
  }),

  day: (0, _index$1u.buildLocalizeFn)({
    values: dayValues$m,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1u.buildLocalizeFn)({
    values: dayPeriodValues$m,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$l,
    defaultFormattingWidth: "wide",
  }),
});

var match$m = {};

match$m.match = void 0;

var _index$1t = buildMatchFn$1;
var _index2$K = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$m = /^(\d+)(º|ª)?/i;
const parseOrdinalNumberPattern$m = /\d+/i;

const matchEraPatterns$m = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i,
};
const parseEraPatterns$m = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes da era comum)/i,
    /^(depois de cristo|era comum)/i,
  ],
};

const matchQuarterPatterns$m = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i,
};
const parseQuarterPatterns$m = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$m = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i,
};
const parseMonthPatterns$m = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ab/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$m = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i,
};
const parseDayPatterns$m = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i],
};

const matchDayPeriodPatterns$m = {
  narrow:
    /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
};
const parseDayPeriodPatterns$m = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i,
  },
};

(match$m.match = {
  ordinalNumber: (0, _index2$K.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$m,
    parsePattern: parseOrdinalNumberPattern$m,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1t.buildMatchFn)({
    matchPatterns: matchEraPatterns$m,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$m,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1t.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$m,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$m,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1t.buildMatchFn)({
    matchPatterns: matchMonthPatterns$m,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$m,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1t.buildMatchFn)({
    matchPatterns: matchDayPatterns$m,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$m,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1t.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$m,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$m,
    defaultParseWidth: "any",
  }),
});

pt.pt = void 0;
var _index$1s = formatDistance$J;
var _index2$J = formatLong$m;
var _index3$m = formatRelative$J;
var _index4$m = localize$m;
var _index5$m = match$m;

/**
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire](https://github.com/dfreire)
 * @author Adrián de la Rosa [@adrm](https://github.com/adrm)
 */
(pt.pt = {
  code: "pt",
  formatDistance: _index$1s.formatDistance,
  formatLong: _index2$J.formatLong,
  formatRelative: _index3$m.formatRelative,
  localize: _index4$m.localize,
  match: _index5$m.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var ptBR = {};

var formatDistance$H = {};

formatDistance$H.formatDistance = void 0;

const formatDistanceLocale$l = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos",
  },

  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos",
  },

  halfAMinute: "meio minuto",

  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos",
  },

  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos",
  },

  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas",
  },

  xHours: {
    one: "1 hora",
    other: "{{count}} horas",
  },

  xDays: {
    one: "1 dia",
    other: "{{count}} dias",
  },

  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas",
  },

  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas",
  },

  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses",
  },

  xMonths: {
    one: "1 mês",
    other: "{{count}} meses",
  },

  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos",
  },

  xYears: {
    one: "1 ano",
    other: "{{count}} anos",
  },

  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos",
  },

  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos",
  },
};

const formatDistance$G = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$l[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "em " + result;
    } else {
      return "há " + result;
    }
  }

  return result;
};
formatDistance$H.formatDistance = formatDistance$G;

var formatLong$l = {};

formatLong$l.formatLong = void 0;
var _index$1r = buildFormatLongFn$1;

const dateFormats$l = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy",
};

const timeFormats$l = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$l = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$l.formatLong = {
  date: (0, _index$1r.buildFormatLongFn)({
    formats: dateFormats$l,
    defaultWidth: "full",
  }),

  time: (0, _index$1r.buildFormatLongFn)({
    formats: timeFormats$l,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1r.buildFormatLongFn)({
    formats: dateTimeFormats$l,
    defaultWidth: "full",
  }),
});

var formatRelative$H = {};

formatRelative$H.formatRelative = void 0;

const formatRelativeLocale$l = {
  lastWeek: (date) => {
    const weekday = date.getDay();
    const last = weekday === 0 || weekday === 6 ? "último" : "última";
    return "'" + last + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P",
};

const formatRelative$G = (token, date, _baseDate, _options) => {
  const format = formatRelativeLocale$l[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$H.formatRelative = formatRelative$G;

var localize$l = {};

localize$l.localize = void 0;
var _index$1q = buildLocalizeFn$1;

const eraValues$l = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"],
};

const quarterValues$l = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"],
};

const monthValues$l = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez",
  ],

  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ],
};

const dayValues$l = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado",
  ],

  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado",
  ],
};

const dayPeriodValues$l = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite",
  },
};

const formattingDayPeriodValues$k = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite",
  },
};

const ordinalNumber$l = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);

  if (options?.unit === "week") {
    return number + "ª";
  }
  return number + "º";
};

(localize$l.localize = {
  ordinalNumber: ordinalNumber$l,

  era: (0, _index$1q.buildLocalizeFn)({
    values: eraValues$l,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1q.buildLocalizeFn)({
    values: quarterValues$l,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1q.buildLocalizeFn)({
    values: monthValues$l,
    defaultWidth: "wide",
  }),

  day: (0, _index$1q.buildLocalizeFn)({
    values: dayValues$l,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1q.buildLocalizeFn)({
    values: dayPeriodValues$l,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$k,
    defaultFormattingWidth: "wide",
  }),
});

var match$l = {};

match$l.match = void 0;

var _index$1p = buildMatchFn$1;
var _index2$I = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$l = /^(\d+)[ºªo]?/i;
const parseOrdinalNumberPattern$l = /\d+/i;

const matchEraPatterns$l = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i,
};
const parseEraPatterns$l = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i],
};

const matchQuarterPatterns$l = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i,
};
const parseQuarterPatterns$l = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$l = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i,
};
const parseMonthPatterns$l = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i,
  ],
};

const matchDayPatterns$l = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i,
};
const parseDayPatterns$l = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i],
};

const matchDayPeriodPatterns$l = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i,
};
const parseDayPeriodPatterns$l = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i,
  },
};

(match$l.match = {
  ordinalNumber: (0, _index2$I.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$l,
    parsePattern: parseOrdinalNumberPattern$l,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1p.buildMatchFn)({
    matchPatterns: matchEraPatterns$l,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$l,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1p.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$l,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$l,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1p.buildMatchFn)({
    matchPatterns: matchMonthPatterns$l,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$l,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1p.buildMatchFn)({
    matchPatterns: matchDayPatterns$l,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$l,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1p.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$l,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$l,
    defaultParseWidth: "any",
  }),
});

ptBR.ptBR = void 0;
var _index$1o = formatDistance$H;
var _index2$H = formatLong$l;
var _index3$l = formatRelative$H;
var _index4$l = localize$l;
var _index5$l = match$l;

/**
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe](https://github.com/duailibe)
 * @author Yago Carballo [@yagocarballo](https://github.com/YagoCarballo)
 */
(ptBR.ptBR = {
  code: "pt-BR",
  formatDistance: _index$1o.formatDistance,
  formatLong: _index2$H.formatLong,
  formatRelative: _index3$l.formatRelative,
  localize: _index4$l.localize,
  match: _index5$l.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var ro = {};

var formatDistance$F = {};

formatDistance$F.formatDistance = void 0;

const formatDistanceLocale$k = {
  lessThanXSeconds: {
    one: "mai puțin de o secundă",
    other: "mai puțin de {{count}} secunde",
  },

  xSeconds: {
    one: "1 secundă",
    other: "{{count}} secunde",
  },

  halfAMinute: "jumătate de minut",

  lessThanXMinutes: {
    one: "mai puțin de un minut",
    other: "mai puțin de {{count}} minute",
  },

  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute",
  },

  aboutXHours: {
    one: "circa 1 oră",
    other: "circa {{count}} ore",
  },

  xHours: {
    one: "1 oră",
    other: "{{count}} ore",
  },

  xDays: {
    one: "1 zi",
    other: "{{count}} zile",
  },

  aboutXWeeks: {
    one: "circa o săptămână",
    other: "circa {{count}} săptămâni",
  },

  xWeeks: {
    one: "1 săptămână",
    other: "{{count}} săptămâni",
  },

  aboutXMonths: {
    one: "circa 1 lună",
    other: "circa {{count}} luni",
  },

  xMonths: {
    one: "1 lună",
    other: "{{count}} luni",
  },

  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani",
  },

  xYears: {
    one: "1 an",
    other: "{{count}} ani",
  },

  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani",
  },

  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani",
  },
};

const formatDistance$E = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$k[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "în " + result;
    } else {
      return result + " în urmă";
    }
  }

  return result;
};
formatDistance$F.formatDistance = formatDistance$E;

var formatLong$k = {};

formatLong$k.formatLong = void 0;
var _index$1n = buildFormatLongFn$1;

const dateFormats$k = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy",
};

const timeFormats$k = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$k = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$k.formatLong = {
  date: (0, _index$1n.buildFormatLongFn)({
    formats: dateFormats$k,
    defaultWidth: "full",
  }),

  time: (0, _index$1n.buildFormatLongFn)({
    formats: timeFormats$k,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1n.buildFormatLongFn)({
    formats: dateTimeFormats$k,
    defaultWidth: "full",
  }),
});

var formatRelative$F = {};

formatRelative$F.formatRelative = void 0;

const formatRelativeLocale$k = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P",
};

const formatRelative$E = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$k[token];
formatRelative$F.formatRelative = formatRelative$E;

var localize$k = {};

localize$k.localize = void 0;
var _index$1m = buildLocalizeFn$1;

const eraValues$k = {
  narrow: ["Î", "D"],
  abbreviated: ["Î.d.C.", "D.C."],
  wide: ["Înainte de Cristos", "După Cristos"],
};

const quarterValues$k = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: [
    "primul trimestru",
    "al doilea trimestru",
    "al treilea trimestru",
    "al patrulea trimestru",
  ],
};

const monthValues$k = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: [
    "ian",
    "feb",
    "mar",
    "apr",
    "mai",
    "iun",
    "iul",
    "aug",
    "sep",
    "oct",
    "noi",
    "dec",
  ],

  wide: [
    "ianuarie",
    "februarie",
    "martie",
    "aprilie",
    "mai",
    "iunie",
    "iulie",
    "august",
    "septembrie",
    "octombrie",
    "noiembrie",
    "decembrie",
  ],
};

const dayValues$k = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "sâ"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "sâm"],
  wide: ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"],
};

const dayPeriodValues$k = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte",
  },
};

const formattingDayPeriodValues$j = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte",
  },
};

const ordinalNumber$k = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$k.localize = {
  ordinalNumber: ordinalNumber$k,

  era: (0, _index$1m.buildLocalizeFn)({
    values: eraValues$k,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1m.buildLocalizeFn)({
    values: quarterValues$k,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1m.buildLocalizeFn)({
    values: monthValues$k,
    defaultWidth: "wide",
  }),

  day: (0, _index$1m.buildLocalizeFn)({
    values: dayValues$k,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1m.buildLocalizeFn)({
    values: dayPeriodValues$k,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$j,
    defaultFormattingWidth: "wide",
  }),
});

var match$k = {};

match$k.match = void 0;

var _index$1l = buildMatchFn$1;
var _index2$G = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$k = /^(\d+)?/i;
const parseOrdinalNumberPattern$k = /\d+/i;

const matchEraPatterns$k = {
  narrow: /^(Î|D)/i,
  abbreviated:
    /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i,
};
const parseEraPatterns$k = {
  any: [/^ÎC/i, /^DC/i],
  wide: [
    /^(Înainte de Cristos|Înaintea erei noastre)/i,
    /^(După Cristos|Era noastră)/i,
  ],
};

const matchQuarterPatterns$k = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i,
};
const parseQuarterPatterns$k = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$k = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i,
};
const parseMonthPatterns$k = {
  narrow: [
    /^i/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^i/i,
    /^i/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ia/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^iun/i,
    /^iul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$k = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i,
};
const parseDayPatterns$k = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i],
};

const matchDayPeriodPatterns$k = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i,
};
const parseDayPeriodPatterns$k = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i,
  },
};

(match$k.match = {
  ordinalNumber: (0, _index2$G.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$k,
    parsePattern: parseOrdinalNumberPattern$k,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1l.buildMatchFn)({
    matchPatterns: matchEraPatterns$k,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$k,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1l.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$k,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$k,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1l.buildMatchFn)({
    matchPatterns: matchMonthPatterns$k,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$k,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1l.buildMatchFn)({
    matchPatterns: matchDayPatterns$k,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$k,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1l.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$k,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$k,
    defaultParseWidth: "any",
  }),
});

ro.ro = void 0;
var _index$1k = formatDistance$F;
var _index2$F = formatLong$k;
var _index3$k = formatRelative$F;
var _index4$k = localize$k;
var _index5$k = match$k;

/**
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu](https://github.com/jsergiu)
 * @author Adrian Ocneanu [@aocneanu](https://github.com/aocneanu)
 * @author Mihai Ocneanu [@gandesc](https://github.com/gandesc)
 */
(ro.ro = {
  code: "ro",
  formatDistance: _index$1k.formatDistance,
  formatLong: _index2$F.formatLong,
  formatRelative: _index3$k.formatRelative,
  localize: _index4$k.localize,
  match: _index5$k.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var ru = {};

var formatDistance$D = {};

formatDistance$D.formatDistance = void 0;

function declension$2(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  const rem10 = count % 10;
  const rem100 = count % 100;

  // 1, 21, 31, ...
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));

    // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));

    // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}

function buildLocalizeTokenFn$1(scheme) {
  return (count, options) => {
    if (options?.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension$2(scheme.future, count);
        } else {
          return "через " + declension$2(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension$2(scheme.past, count);
        } else {
          return declension$2(scheme.regular, count) + " назад";
        }
      }
    } else {
      return declension$2(scheme.regular, count);
    }
  };
}

const formatDistanceLocale$j = {
  lessThanXSeconds: buildLocalizeTokenFn$1({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд",
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд",
    },
  }),

  xSeconds: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд",
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад",
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд",
    },
  }),

  halfAMinute: (_count, options) => {
    if (options?.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return "через полминуты";
      } else {
        return "полминуты назад";
      }
    }

    return "полминуты";
  },

  lessThanXMinutes: buildLocalizeTokenFn$1({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут",
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут",
    },
  }),

  xMinutes: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут",
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад",
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут",
    },
  }),

  aboutXHours: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов",
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов",
    },
  }),

  xHours: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов",
    },
  }),

  xDays: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней",
    },
  }),

  aboutXWeeks: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель",
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель",
    },
  }),

  xWeeks: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель",
    },
  }),

  aboutXMonths: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев",
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев",
    },
  }),

  xMonths: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев",
    },
  }),

  aboutXYears: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет",
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет",
    },
  }),

  xYears: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет",
    },
  }),

  overXYears: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет",
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет",
    },
  }),

  almostXYears: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет",
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет",
    },
  }),
};

const formatDistance$C = (token, count, options) => {
  return formatDistanceLocale$j[token](count, options);
};
formatDistance$D.formatDistance = formatDistance$C;

var formatLong$j = {};

formatLong$j.formatLong = void 0;
var _index$1j = buildFormatLongFn$1;

const dateFormats$j = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y",
};

const timeFormats$j = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$j = {
  any: "{{date}}, {{time}}",
};

(formatLong$j.formatLong = {
  date: (0, _index$1j.buildFormatLongFn)({
    formats: dateFormats$j,
    defaultWidth: "full",
  }),

  time: (0, _index$1j.buildFormatLongFn)({
    formats: timeFormats$j,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1j.buildFormatLongFn)({
    formats: dateTimeFormats$j,
    defaultWidth: "any",
  }),
});

var formatRelative$D = {};

formatRelative$D.formatRelative = void 0;
var _index$1i = isSameWeek$1;

const accusativeWeekdays$2 = [
  "воскресенье",
  "понедельник",
  "вторник",
  "среду",
  "четверг",
  "пятницу",
  "субботу",
];

function lastWeek$2(day) {
  const weekday = accusativeWeekdays$2[day];

  switch (day) {
    case 0:
      return "'в прошлое " + weekday + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + weekday + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + weekday + " в' p";
  }
}

function thisWeek$2(day) {
  const weekday = accusativeWeekdays$2[day];

  if (day === 2 /* Tue */) {
    return "'во " + weekday + " в' p";
  } else {
    return "'в " + weekday + " в' p";
  }
}

function nextWeek$2(day) {
  const weekday = accusativeWeekdays$2[day];

  switch (day) {
    case 0:
      return "'в следующее " + weekday + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + weekday + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + weekday + " в' p";
  }
}

const formatRelativeLocale$j = {
  lastWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$1i.isSameWeek)(date, baseDate, options)) {
      return thisWeek$2(day);
    } else {
      return lastWeek$2(day);
    }
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$1i.isSameWeek)(date, baseDate, options)) {
      return thisWeek$2(day);
    } else {
      return nextWeek$2(day);
    }
  },
  other: "P",
};

const formatRelative$C = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$j[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$D.formatRelative = formatRelative$C;

var localize$j = {};

localize$j.localize = void 0;
var _index$1h = buildLocalizeFn$1;

const eraValues$j = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"],
};

const quarterValues$j = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"],
};

const monthValues$j = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек.",
  ],

  wide: [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь",
  ],
};

const formattingMonthValues$5 = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек.",
  ],

  wide: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ],
};

const dayValues$j = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота",
  ],
};

const dayPeriodValues$j = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь",
  },
};

const formattingDayPeriodValues$i = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи",
  },
};

const ordinalNumber$j = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = options?.unit;

  let suffix;
  if (unit === "date") {
    suffix = "-е";
  } else if (unit === "week" || unit === "minute" || unit === "second") {
    suffix = "-я";
  } else {
    suffix = "-й";
  }

  return number + suffix;
};

(localize$j.localize = {
  ordinalNumber: ordinalNumber$j,

  era: (0, _index$1h.buildLocalizeFn)({
    values: eraValues$j,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1h.buildLocalizeFn)({
    values: quarterValues$j,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1h.buildLocalizeFn)({
    values: monthValues$j,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$5,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$1h.buildLocalizeFn)({
    values: dayValues$j,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1h.buildLocalizeFn)({
    values: dayPeriodValues$j,
    defaultWidth: "any",
    formattingValues: formattingDayPeriodValues$i,
    defaultFormattingWidth: "wide",
  }),
});

var match$j = {};

match$j.match = void 0;

var _index$1g = buildMatchFn$1;
var _index2$E = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$j = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
const parseOrdinalNumberPattern$j = /\d+/i;

const matchEraPatterns$j = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i,
};
const parseEraPatterns$j = {
  any: [/^д/i, /^н/i],
};

const matchQuarterPatterns$j = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i,
};

const parseQuarterPatterns$j = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$j = {
  narrow: /^[яфмаисонд]/i,
  abbreviated:
    /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i,
};

const parseMonthPatterns$j = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^я/i,
  ],

  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i,
  ],
};

const matchDayPatterns$j = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i,
};

const parseDayPatterns$j = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i],
};

const matchDayPeriodPatterns$j = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i,
};

const parseDayPeriodPatterns$j = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i,
  },
};

(match$j.match = {
  ordinalNumber: (0, _index2$E.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$j,
    parsePattern: parseOrdinalNumberPattern$j,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1g.buildMatchFn)({
    matchPatterns: matchEraPatterns$j,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$j,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1g.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$j,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$j,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1g.buildMatchFn)({
    matchPatterns: matchMonthPatterns$j,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$j,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1g.buildMatchFn)({
    matchPatterns: matchDayPatterns$j,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$j,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1g.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$j,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$j,
    defaultParseWidth: "any",
  }),
});

ru.ru = void 0;
var _index$1f = formatDistance$D;
var _index2$D = formatLong$j;
var _index3$j = formatRelative$D;
var _index4$j = localize$j;
var _index5$j = match$j;

/**
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */
(ru.ru = {
  code: "ru",
  formatDistance: _index$1f.formatDistance,
  formatLong: _index2$D.formatLong,
  formatRelative: _index3$j.formatRelative,
  localize: _index4$j.localize,
  match: _index5$j.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var se = {};

var formatDistance$B = {};

formatDistance$B.formatDistance = void 0;

const formatDistanceLocale$i = {
  lessThanXSeconds: {
    one: "unnit go ovtta sekundda",
    other: "unnit go {{count}} sekundda",
  },

  xSeconds: {
    one: "sekundda",
    other: "{{count}} sekundda",
  },

  halfAMinute: "bealle minuhta",

  lessThanXMinutes: {
    one: "unnit go bealle minuhta",
    other: "unnit go {{count}} minuhta",
  },

  xMinutes: {
    one: "minuhta",
    other: "{{count}} minuhta",
  },

  aboutXHours: {
    one: "sullii ovtta diimmu",
    other: "sullii {{count}} diimmu",
  },

  xHours: {
    one: "diimmu",
    other: "{{count}} diimmu",
  },

  xDays: {
    one: "beaivvi",
    other: "{{count}} beaivvi",
  },

  aboutXWeeks: {
    one: "sullii ovtta vahku",
    other: "sullii {{count}} vahku",
  },

  xWeeks: {
    one: "vahku",
    other: "{{count}} vahku",
  },

  aboutXMonths: {
    one: "sullii ovtta mánu",
    other: "sullii {{count}} mánu",
  },

  xMonths: {
    one: "mánu",
    other: "{{count}} mánu",
  },

  aboutXYears: {
    one: "sullii ovtta jagi",
    other: "sullii {{count}} jagi",
  },

  xYears: {
    one: "jagi",
    other: "{{count}} jagi",
  },

  overXYears: {
    one: "guhkit go jagi",
    other: "guhkit go {{count}} jagi",
  },

  almostXYears: {
    one: "measta jagi",
    other: "measta {{count}} jagi",
  },
};

const formatDistance$A = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$i[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "geahčen " + result;
    } else {
      return result + " áigi";
    }
  }

  return result;
};
formatDistance$B.formatDistance = formatDistance$A;

var formatLong$i = {};

formatLong$i.formatLong = void 0;
var _index$1e = buildFormatLongFn$1;

const dateFormats$i = {
  full: "EEEE MMMM d. 'b.' y",
  long: "MMMM d. 'b.' y",
  medium: "MMM d. 'b.' y",
  short: "dd.MM.y",
};

const timeFormats$i = {
  full: "'dii.' HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$i = {
  full: "{{date}} 'dii.' {{time}}",
  long: "{{date}} 'dii.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$i.formatLong = {
  date: (0, _index$1e.buildFormatLongFn)({
    formats: dateFormats$i,
    defaultWidth: "full",
  }),

  time: (0, _index$1e.buildFormatLongFn)({
    formats: timeFormats$i,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1e.buildFormatLongFn)({
    formats: dateTimeFormats$i,
    defaultWidth: "full",
  }),
});

var formatRelative$B = {};

formatRelative$B.formatRelative = void 0;

const formatRelativeLocale$i = {
  lastWeek: "'ovddit' eeee 'dii.' p",
  yesterday: "'ikte dii.' p",
  today: "'odne dii.' p",
  tomorrow: "'ihtin dii.' p",
  nextWeek: "EEEE 'dii.' p",
  other: "P",
};

const formatRelative$A = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$i[token];
formatRelative$B.formatRelative = formatRelative$A;

var localize$i = {};

localize$i.localize = void 0;
var _index$1d = buildLocalizeFn$1;

const eraValues$i = {
  narrow: ["o.Kr.", "m.Kr."],
  abbreviated: ["o.Kr.", "m.Kr."],
  wide: ["ovdal Kristusa", "maŋŋel Kristusa"],
};

const quarterValues$i = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartála", "2. kvartála", "3. kvartála", "4. kvartála"],
};

const monthValues$i = {
  narrow: ["O", "G", "N", "C", "M", "G", "S", "B", "Č", "G", "S", "J"],
  abbreviated: [
    "ođđa",
    "guov",
    "njuk",
    "cuo",
    "mies",
    "geas",
    "suoi",
    "borg",
    "čakč",
    "golg",
    "skáb",
    "juov",
  ],

  wide: [
    "ođđajagemánnu",
    "guovvamánnu",
    "njukčamánnu",
    "cuoŋománnu",
    "miessemánnu",
    "geassemánnu",
    "suoidnemánnu",
    "borgemánnu",
    "čakčamánnu",
    "golggotmánnu",
    "skábmamánnu",
    "juovlamánnu",
  ],
};

const dayValues$i = {
  narrow: ["S", "V", "M", "G", "D", "B", "L"],
  short: ["sotn", "vuos", "maŋ", "gask", "duor", "bear", "láv"],
  abbreviated: ["sotn", "vuos", "maŋ", "gask", "duor", "bear", "láv"],
  wide: [
    "sotnabeaivi",
    "vuossárga",
    "maŋŋebárga",
    "gaskavahkku",
    "duorastat",
    "bearjadat",
    "lávvardat",
  ],
};

const dayPeriodValues$i = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "gaskaidja",
    noon: "gaskabeaivi",
    morning: "iđđes",
    afternoon: "maŋŋel gaska.",
    evening: "eahkes",
    night: "ihkku",
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gaskaidja",
    noon: "gaskabeaivvi",
    morning: "iđđes",
    afternoon: "maŋŋel gaskabea.",
    evening: "eahkes",
    night: "ihkku",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gaskaidja",
    noon: "gaskabeavvi",
    morning: "iđđes",
    afternoon: "maŋŋel gaskabeaivvi",
    evening: "eahkes",
    night: "ihkku",
  },
};

const ordinalNumber$i = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$i.localize = {
  ordinalNumber: ordinalNumber$i,

  era: (0, _index$1d.buildLocalizeFn)({
    values: eraValues$i,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$1d.buildLocalizeFn)({
    values: quarterValues$i,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$1d.buildLocalizeFn)({
    values: monthValues$i,
    defaultWidth: "wide",
  }),

  day: (0, _index$1d.buildLocalizeFn)({
    values: dayValues$i,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$1d.buildLocalizeFn)({
    values: dayPeriodValues$i,
    defaultWidth: "wide",
  }),
});

var match$i = {};

match$i.match = void 0;

var _index$1c = buildMatchFn$1;
var _index2$C = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$i = /^(\d+)\.?/i;
const parseOrdinalNumberPattern$i = /\d+/i;

const matchEraPatterns$i = {
  narrow: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
  abbreviated: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
  wide: /^(ovdal Kristusa|ovdal min áiggi|maŋŋel Kristusa|min áigi)/i,
};
const parseEraPatterns$i = {
  any: [/^o/i, /^m/i],
};

const matchQuarterPatterns$i = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartála/i,
};
const parseQuarterPatterns$i = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$i = {
  narrow: /^[ogncmsbčj]/i,
  abbreviated:
    /^(ođđa|guov|njuk|cuo|mies|geas|suoi|borg|čakč|golg|skáb|juov)\.?/i,
  wide: /^(ođđajagemánnu|guovvamánnu|njukčamánnu|cuoŋománnu|miessemánnu|geassemánnu|suoidnemánnu|borgemánnu|čakčamánnu|golggotmánnu|skábmamánnu|juovlamánnu)/i,
};
const parseMonthPatterns$i = {
  narrow: [
    /^o/i,
    /^g/i,
    /^n/i,
    /^c/i,
    /^m/i,
    /^g/i,
    /^s/i,
    /^b/i,
    /^č/i,
    /^g/i,
    /^s/i,
    /^j/i,
  ],

  any: [
    /^o/i,
    /^gu/i,
    /^n/i,
    /^c/i,
    /^m/i,
    /^ge/i,
    /^su/i,
    /^b/i,
    /^č/i,
    /^go/i,
    /^sk/i,
    /^j/i,
  ],
};

const matchDayPatterns$i = {
  narrow: /^[svmgdbl]/i,
  short: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
  abbreviated: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
  wide: /^(sotnabeaivi|vuossárga|maŋŋebárga|gaskavahkku|duorastat|bearjadat|lávvardat)/i,
};
const parseDayPatterns$i = {
  any: [/^s/i, /^v/i, /^m/i, /^g/i, /^d/i, /^b/i, /^l/i],
};

const matchDayPeriodPatterns$i = {
  narrow:
    /^(gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku))/i,
};
const parseDayPeriodPatterns$i = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^gaskai/i,
    noon: /^gaskab/i,
    morning: /iđđes/i,
    afternoon: /maŋŋel gaskabeaivvi/i,
    evening: /eahkes/i,
    night: /ihkku/i,
  },
};

(match$i.match = {
  ordinalNumber: (0, _index2$C.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$i,
    parsePattern: parseOrdinalNumberPattern$i,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1c.buildMatchFn)({
    matchPatterns: matchEraPatterns$i,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$i,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1c.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$i,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$i,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1c.buildMatchFn)({
    matchPatterns: matchMonthPatterns$i,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$i,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1c.buildMatchFn)({
    matchPatterns: matchDayPatterns$i,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$i,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1c.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$i,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$i,
    defaultParseWidth: "any",
  }),
});

se.se = void 0;
var _index$1b = formatDistance$B;
var _index2$B = formatLong$i;
var _index3$i = formatRelative$B;
var _index4$i = localize$i;
var _index5$i = match$i;

/**
 * @category Locales
 * @summary Northern Sámi locale.
 * @language Northern Sámi
 * @iso-639-2 sme
 * @author Audun Rundberg [@audunru](https://github.com/audunru)
 */
(se.se = {
  code: "se",
  formatDistance: _index$1b.formatDistance,
  formatLong: _index2$B.formatLong,
  formatRelative: _index3$i.formatRelative,
  localize: _index4$i.localize,
  match: _index5$i.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var sk = {};

var formatDistance$z = {};

formatDistance$z.formatDistance = void 0;

function declensionGroup(scheme, count) {
  if (count === 1 && scheme.one) {
    return scheme.one;
  }

  if (count >= 2 && count <= 4 && scheme.twoFour) {
    return scheme.twoFour;
  }

  // if count === null || count === 0 || count >= 5
  return scheme.other;
}

function declension$1(scheme, count, time) {
  const group = declensionGroup(scheme, count);
  const finalText = group[time];
  return finalText.replace("{{count}}", String(count));
}

function extractPreposition(token) {
  const result = ["lessThan", "about", "over", "almost"].filter(
    function (preposition) {
      return !!token.match(new RegExp("^" + preposition));
    },
  );

  return result[0];
}

function prefixPreposition(preposition) {
  let translation = "";

  if (preposition === "almost") {
    translation = "takmer";
  }

  if (preposition === "about") {
    translation = "približne";
  }

  return translation.length > 0 ? translation + " " : "";
}

function suffixPreposition(preposition) {
  let translation = "";

  if (preposition === "lessThan") {
    translation = "menej než";
  }

  if (preposition === "over") {
    translation = "viac než";
  }

  return translation.length > 0 ? translation + " " : "";
}

function lowercaseFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

const formatDistanceLocale$h = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu",
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy",
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd",
    },
  },

  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty",
    },
  },

  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu",
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty",
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút",
    },
  },

  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu",
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny",
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín",
    },
  },

  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň",
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni",
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní",
    },
  },

  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň",
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne",
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov",
    },
  },

  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac",
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace",
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov",
    },
  },

  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok",
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky",
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov",
    },
  },
};

const formatDistance$y = (token, count, options) => {
  const preposition = extractPreposition(token) || "";
  const key = lowercaseFirstLetter(token.substring(preposition.length));
  const scheme = formatDistanceLocale$h[key];

  if (!options?.addSuffix) {
    return (
      prefixPreposition(preposition) +
      suffixPreposition(preposition) +
      declension$1(scheme, count, "present")
    );
  }

  if (options.comparison && options.comparison > 0) {
    return (
      prefixPreposition(preposition) +
      "o " +
      suffixPreposition(preposition) +
      declension$1(scheme, count, "future")
    );
  } else {
    return (
      prefixPreposition(preposition) +
      "pred " +
      suffixPreposition(preposition) +
      declension$1(scheme, count, "past")
    );
  }
};
formatDistance$z.formatDistance = formatDistance$y;

var formatLong$h = {};

formatLong$h.formatLong = void 0;
var _index$1a = buildFormatLongFn$1;

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986
const dateFormats$h = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y",
};

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
const timeFormats$h = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
const dateTimeFormats$h = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$h.formatLong = {
  date: (0, _index$1a.buildFormatLongFn)({
    formats: dateFormats$h,
    defaultWidth: "full",
  }),

  time: (0, _index$1a.buildFormatLongFn)({
    formats: timeFormats$h,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$1a.buildFormatLongFn)({
    formats: dateTimeFormats$h,
    defaultWidth: "full",
  }),
});

var formatRelative$z = {};

formatRelative$z.formatRelative = void 0;
var _index$19 = isSameWeek$1;

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
const accusativeWeekdays$1 = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu",
];

function lastWeek$1(day) {
  const weekday = accusativeWeekdays$1[day];

  switch (day) {
    case 0: /* Sun */
    case 3: /* Wed */
    case 6 /* Sat */:
      return "'minulú " + weekday + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}

function thisWeek$1(day) {
  const weekday = accusativeWeekdays$1[day];

  if (day === 4 /* Thu */) {
    return "'vo' eeee 'o' p";
  } else {
    return "'v " + weekday + " o' p";
  }
}

function nextWeek$1(day) {
  const weekday = accusativeWeekdays$1[day];

  switch (day) {
    case 0: /* Sun */
    case 4: /* Wed */
    case 6 /* Sat */:
      return "'budúcu " + weekday + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}

const formatRelativeLocale$h = {
  lastWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$19.isSameWeek)(date, baseDate, options)) {
      return thisWeek$1(day);
    } else {
      return lastWeek$1(day);
    }
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (date, baseDate, options) => {
    const day = date.getDay();
    if ((0, _index$19.isSameWeek)(date, baseDate, options)) {
      return thisWeek$1(day);
    } else {
      return nextWeek$1(day);
    }
  },
  other: "P",
};

const formatRelative$y = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$h[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$z.formatRelative = formatRelative$y;

var localize$h = {};

localize$h.localize = void 0;
var _index$18 = buildLocalizeFn$1;

// https://www.unicode.org/cldr/charts/32/summary/sk.html#1772
const eraValues$h = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"],
};

// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
const quarterValues$h = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"],
};

// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
const monthValues$h = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec",
  ],

  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december",
  ],
};
const formattingMonthValues$4 = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec",
  ],

  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra",
  ],
};

// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
const dayValues$h = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota",
  ],
};

// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
const dayPeriodValues$h = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc",
  },
};

const formattingDayPeriodValues$h = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n.",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci",
  },
};

const ordinalNumber$h = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$h.localize = {
  ordinalNumber: ordinalNumber$h,

  era: (0, _index$18.buildLocalizeFn)({
    values: eraValues$h,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$18.buildLocalizeFn)({
    values: quarterValues$h,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$18.buildLocalizeFn)({
    values: monthValues$h,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$4,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$18.buildLocalizeFn)({
    values: dayValues$h,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$18.buildLocalizeFn)({
    values: dayPeriodValues$h,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$h,
    defaultFormattingWidth: "wide",
  }),
});

var match$h = {};

match$h.match = void 0;

var _index$17 = buildMatchFn$1;
var _index2$A = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$h = /^(\d+)\.?/i;
const parseOrdinalNumberPattern$h = /\d+/i;

const matchEraPatterns$h = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i,
};
const parseEraPatterns$h = {
  any: [/^pr/i, /^(po|n)/i],
};

const matchQuarterPatterns$h = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i,
};
const parseQuarterPatterns$h = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$h = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i,
};
const parseMonthPatterns$h = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$h = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i,
};
const parseDayPatterns$h = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i],
};

const matchDayPeriodPatterns$h = {
  narrow:
    /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated:
    /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i,
};
const parseDayPeriodPatterns$h = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i,
  },
};

(match$h.match = {
  ordinalNumber: (0, _index2$A.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$h,
    parsePattern: parseOrdinalNumberPattern$h,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$17.buildMatchFn)({
    matchPatterns: matchEraPatterns$h,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$h,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$17.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$h,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$h,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$17.buildMatchFn)({
    matchPatterns: matchMonthPatterns$h,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$h,
    defaultParseWidth: "any",
  }),

  day: (0, _index$17.buildMatchFn)({
    matchPatterns: matchDayPatterns$h,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$h,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$17.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$h,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$h,
    defaultParseWidth: "any",
  }),
});

sk.sk = void 0;
var _index$16 = formatDistance$z;
var _index2$z = formatLong$h;
var _index3$h = formatRelative$z;
var _index4$h = localize$h;
var _index5$h = match$h;

/**
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak](https://github.com/mareksuscak)
 */
(sk.sk = {
  code: "sk",
  formatDistance: _index$16.formatDistance,
  formatLong: _index2$z.formatLong,
  formatRelative: _index3$h.formatRelative,
  localize: _index4$h.localize,
  match: _index5$h.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var sl = {};

var formatDistance$x = {};

formatDistance$x.formatDistance = void 0;

function isPluralType$1(val) {
  return val.one !== undefined;
}

const formatDistanceLocale$g = {
  lessThanXSeconds: {
    present: {
      one: "manj kot {{count}} sekunda",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund",
    },
    past: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundama",
      few: "manj kot {{count}} sekundami",
      other: "manj kot {{count}} sekundami",
    },
    future: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund",
    },
  },

  xSeconds: {
    present: {
      one: "{{count}} sekunda",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund",
    },
    past: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundama",
      few: "{{count}} sekundami",
      other: "{{count}} sekundami",
    },
    future: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund",
    },
  },

  halfAMinute: "pol minute",

  lessThanXMinutes: {
    present: {
      one: "manj kot {{count}} minuta",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut",
    },
    past: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minutama",
      few: "manj kot {{count}} minutami",
      other: "manj kot {{count}} minutami",
    },
    future: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut",
    },
  },

  xMinutes: {
    present: {
      one: "{{count}} minuta",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut",
    },
    past: {
      one: "{{count}} minuto",
      two: "{{count}} minutama",
      few: "{{count}} minutami",
      other: "{{count}} minutami",
    },
    future: {
      one: "{{count}} minuto",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut",
    },
  },

  aboutXHours: {
    present: {
      one: "približno {{count}} ura",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur",
    },
    past: {
      one: "približno {{count}} uro",
      two: "približno {{count}} urama",
      few: "približno {{count}} urami",
      other: "približno {{count}} urami",
    },
    future: {
      one: "približno {{count}} uro",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur",
    },
  },

  xHours: {
    present: {
      one: "{{count}} ura",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur",
    },
    past: {
      one: "{{count}} uro",
      two: "{{count}} urama",
      few: "{{count}} urami",
      other: "{{count}} urami",
    },
    future: {
      one: "{{count}} uro",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur",
    },
  },

  xDays: {
    present: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni",
    },
    past: {
      one: "{{count}} dnem",
      two: "{{count}} dnevoma",
      few: "{{count}} dnevi",
      other: "{{count}} dnevi",
    },
    future: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni",
    },
  },

  // no tenses for weeks?
  aboutXWeeks: {
    one: "približno {{count}} teden",
    two: "približno {{count}} tedna",
    few: "približno {{count}} tedne",
    other: "približno {{count}} tednov",
  },

  // no tenses for weeks?
  xWeeks: {
    one: "{{count}} teden",
    two: "{{count}} tedna",
    few: "{{count}} tedne",
    other: "{{count}} tednov",
  },

  aboutXMonths: {
    present: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev",
    },
    past: {
      one: "približno {{count}} mesecem",
      two: "približno {{count}} mesecema",
      few: "približno {{count}} meseci",
      other: "približno {{count}} meseci",
    },
    future: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev",
    },
  },

  xMonths: {
    present: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} meseci",
      other: "{{count}} mesecev",
    },
    past: {
      one: "{{count}} mesecem",
      two: "{{count}} mesecema",
      few: "{{count}} meseci",
      other: "{{count}} meseci",
    },
    future: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} mesece",
      other: "{{count}} mesecev",
    },
  },

  aboutXYears: {
    present: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let",
    },
    past: {
      one: "približno {{count}} letom",
      two: "približno {{count}} letoma",
      few: "približno {{count}} leti",
      other: "približno {{count}} leti",
    },
    future: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let",
    },
  },

  xYears: {
    present: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let",
    },
    past: {
      one: "{{count}} letom",
      two: "{{count}} letoma",
      few: "{{count}} leti",
      other: "{{count}} leti",
    },
    future: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let",
    },
  },

  overXYears: {
    present: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let",
    },
    past: {
      one: "več kot {{count}} letom",
      two: "več kot {{count}} letoma",
      few: "več kot {{count}} leti",
      other: "več kot {{count}} leti",
    },
    future: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let",
    },
  },

  almostXYears: {
    present: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let",
    },
    past: {
      one: "skoraj {{count}} letom",
      two: "skoraj {{count}} letoma",
      few: "skoraj {{count}} leti",
      other: "skoraj {{count}} leti",
    },
    future: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let",
    },
  },
};

function getFormFromCount(count) {
  switch (count % 100) {
    case 1:
      return "one";
    case 2:
      return "two";
    case 3:
    case 4:
      return "few";
    default:
      return "other";
  }
}

const formatDistance$w = (token, count, options) => {
  let result = "";
  let tense = "present";

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      tense = "future";
      result = "čez ";
    } else {
      tense = "past";
      result = "pred ";
    }
  }

  const tokenValue = formatDistanceLocale$g[token];

  if (typeof tokenValue === "string") {
    result += tokenValue;
  } else {
    const form = getFormFromCount(count);
    if (isPluralType$1(tokenValue)) {
      result += tokenValue[form].replace("{{count}}", String(count));
    } else {
      result += tokenValue[tense][form].replace("{{count}}", String(count));
    }
  }

  return result;
};
formatDistance$x.formatDistance = formatDistance$w;

var formatLong$g = {};

formatLong$g.formatLong = void 0;
var _index$15 = buildFormatLongFn$1;

const dateFormats$g = {
  full: "EEEE, dd. MMMM y",
  long: "dd. MMMM y",
  medium: "d. MMM y",
  short: "d. MM. yy",
};

const timeFormats$g = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$g = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$g.formatLong = {
  date: (0, _index$15.buildFormatLongFn)({
    formats: dateFormats$g,
    defaultWidth: "full",
  }),

  time: (0, _index$15.buildFormatLongFn)({
    formats: timeFormats$g,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$15.buildFormatLongFn)({
    formats: dateTimeFormats$g,
    defaultWidth: "full",
  }),
});

var formatRelative$x = {};

formatRelative$x.formatRelative = void 0;

const formatRelativeLocale$g = {
  lastWeek: (date) => {
    const day = date.getDay();

    switch (day) {
      case 0:
        return "'prejšnjo nedeljo ob' p";
      case 3:
        return "'prejšnjo sredo ob' p";
      case 6:
        return "'prejšnjo soboto ob' p";
      default:
        return "'prejšnji' EEEE 'ob' p";
    }
  },
  yesterday: "'včeraj ob' p",
  today: "'danes ob' p",
  tomorrow: "'jutri ob' p",
  nextWeek: (date) => {
    const day = date.getDay();

    switch (day) {
      case 0:
        return "'naslednjo nedeljo ob' p";
      case 3:
        return "'naslednjo sredo ob' p";
      case 6:
        return "'naslednjo soboto ob' p";
      default:
        return "'naslednji' EEEE 'ob' p";
    }
  },
  other: "P",
};

const formatRelative$w = (token, date, _baseDate, _options) => {
  const format = formatRelativeLocale$g[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$x.formatRelative = formatRelative$w;

var localize$g = {};

localize$g.localize = void 0;
var _index$14 = buildLocalizeFn$1;

const eraValues$g = {
  narrow: ["pr. n. št.", "po n. št."],
  abbreviated: ["pr. n. št.", "po n. št."],
  wide: ["pred našim štetjem", "po našem štetju"],
};

const quarterValues$g = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čet.", "2. čet.", "3. čet.", "4. čet."],
  wide: ["1. četrtletje", "2. četrtletje", "3. četrtletje", "4. četrtletje"],
};

const monthValues$g = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "avg.",
    "sep.",
    "okt.",
    "nov.",
    "dec.",
  ],

  wide: [
    "januar",
    "februar",
    "marec",
    "april",
    "maj",
    "junij",
    "julij",
    "avgust",
    "september",
    "oktober",
    "november",
    "december",
  ],
};

const dayValues$g = {
  narrow: ["n", "p", "t", "s", "č", "p", "s"],
  short: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
  abbreviated: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],

  wide: [
    "nedelja",
    "ponedeljek",
    "torek",
    "sreda",
    "četrtek",
    "petek",
    "sobota",
  ],
};

const dayPeriodValues$g = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "j",
    afternoon: "p",
    evening: "v",
    night: "n",
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "poln.",
    noon: "pold.",
    morning: "jut.",
    afternoon: "pop.",
    evening: "več.",
    night: "noč",
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "polnoč",
    noon: "poldne",
    morning: "jutro",
    afternoon: "popoldne",
    evening: "večer",
    night: "noč",
  },
};

const formattingDayPeriodValues$g = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "zj",
    afternoon: "p",
    evening: "zv",
    night: "po",
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "opoln.",
    noon: "opold.",
    morning: "zjut.",
    afternoon: "pop.",
    evening: "zveč.",
    night: "ponoči",
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "opolnoči",
    noon: "opoldne",
    morning: "zjutraj",
    afternoon: "popoldan",
    evening: "zvečer",
    night: "ponoči",
  },
};

const ordinalNumber$g = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$g.localize = {
  ordinalNumber: ordinalNumber$g,

  era: (0, _index$14.buildLocalizeFn)({
    values: eraValues$g,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$14.buildLocalizeFn)({
    values: quarterValues$g,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$14.buildLocalizeFn)({
    values: monthValues$g,
    defaultWidth: "wide",
  }),

  day: (0, _index$14.buildLocalizeFn)({
    values: dayValues$g,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$14.buildLocalizeFn)({
    values: dayPeriodValues$g,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$g,
    defaultFormattingWidth: "wide",
  }),
});

var match$g = {};

match$g.match = void 0;

var _index$13 = buildMatchFn$1;
var _index2$y = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$g = /^(\d+)\./i;
const parseOrdinalNumberPattern$g = /\d+/i;

const matchEraPatterns$g = {
  abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
  wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i,
};
const parseEraPatterns$g = {
  any: [/^pr/i, /^(po|na[sš]em)/i],
};

const matchQuarterPatterns$g = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?[čc]et\.?/i,
  wide: /^[1234]\. [čc]etrtletje/i,
};
const parseQuarterPatterns$g = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$g = {
  narrow: /^[jfmasond]/i,
  abbreviated:
    /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
  wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i,
};
const parseMonthPatterns$g = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  abbreviated: [
    /^ja/i,
    /^fe/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  wide: [
    /^ja/i,
    /^fe/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$g = {
  narrow: /^[nptsčc]/i,
  short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i,
};
const parseDayPatterns$g = {
  narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i],
};

const matchDayPeriodPatterns$g = {
  narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
  any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i,
};
const parseDayPeriodPatterns$g = {
  narrow: {
    am: /^d/i,
    pm: /^p/i,
    midnight: /^24/i,
    noon: /^12/i,
    morning: /^(z?j)/i,
    afternoon: /^p/i,
    evening: /^(z?v)/i,
    night: /^(n|po)/i,
  },
  any: {
    am: /^dop\./i,
    pm: /^pop\./i,
    midnight: /^o?poln/i,
    noon: /^o?pold/i,
    morning: /j/i,
    afternoon: /^pop\./i,
    evening: /^z?ve/i,
    night: /(po)?no/i,
  },
};

(match$g.match = {
  ordinalNumber: (0, _index2$y.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$g,
    parsePattern: parseOrdinalNumberPattern$g,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$13.buildMatchFn)({
    matchPatterns: matchEraPatterns$g,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$g,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$13.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$g,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$g,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$13.buildMatchFn)({
    matchPatterns: matchMonthPatterns$g,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$g,
    defaultParseWidth: "wide",
  }),

  day: (0, _index$13.buildMatchFn)({
    matchPatterns: matchDayPatterns$g,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$g,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$13.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$g,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$g,
    defaultParseWidth: "any",
  }),
});

sl.sl = void 0;
var _index$12 = formatDistance$x;
var _index2$x = formatLong$g;
var _index3$g = formatRelative$x;
var _index4$g = localize$g;
var _index5$g = match$g;

/**
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph](https://github.com/Neoglyph)
 * @author Mato Žgajner [@mzgajner](https://github.com/mzgajner)
 */
(sl.sl = {
  code: "sl",
  formatDistance: _index$12.formatDistance,
  formatLong: _index2$x.formatLong,
  formatRelative: _index3$g.formatRelative,
  localize: _index4$g.localize,
  match: _index5$g.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var sq = {};

var formatDistance$v = {};

formatDistance$v.formatDistance = void 0;

const formatDistanceLocale$f = {
  lessThanXSeconds: {
    one: "më pak se një sekondë",
    other: "më pak se {{count}} sekonda",
  },

  xSeconds: {
    one: "1 sekondë",
    other: "{{count}} sekonda",
  },

  halfAMinute: "gjysëm minuti",

  lessThanXMinutes: {
    one: "më pak se një minute",
    other: "më pak se {{count}} minuta",
  },

  xMinutes: {
    one: "1 minutë",
    other: "{{count}} minuta",
  },

  aboutXHours: {
    one: "rreth 1 orë",
    other: "rreth {{count}} orë",
  },

  xHours: {
    one: "1 orë",
    other: "{{count}} orë",
  },

  xDays: {
    one: "1 ditë",
    other: "{{count}} ditë",
  },

  aboutXWeeks: {
    one: "rreth 1 javë",
    other: "rreth {{count}} javë",
  },

  xWeeks: {
    one: "1 javë",
    other: "{{count}} javë",
  },

  aboutXMonths: {
    one: "rreth 1 muaj",
    other: "rreth {{count}} muaj",
  },

  xMonths: {
    one: "1 muaj",
    other: "{{count}} muaj",
  },

  aboutXYears: {
    one: "rreth 1 vit",
    other: "rreth {{count}} vite",
  },

  xYears: {
    one: "1 vit",
    other: "{{count}} vite",
  },

  overXYears: {
    one: "mbi 1 vit",
    other: "mbi {{count}} vite",
  },

  almostXYears: {
    one: "pothuajse 1 vit",
    other: "pothuajse {{count}} vite",
  },
};

const formatDistance$u = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$f[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "në " + result;
    } else {
      return result + " më parë";
    }
  }

  return result;
};
formatDistance$v.formatDistance = formatDistance$u;

var formatLong$f = {};

formatLong$f.formatLong = void 0;
var _index$11 = buildFormatLongFn$1;

const dateFormats$f = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$f = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$f = {
  full: "{{date}} 'në' {{time}}",
  long: "{{date}} 'në' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$f.formatLong = {
  date: (0, _index$11.buildFormatLongFn)({
    formats: dateFormats$f,
    defaultWidth: "full",
  }),

  time: (0, _index$11.buildFormatLongFn)({
    formats: timeFormats$f,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$11.buildFormatLongFn)({
    formats: dateTimeFormats$f,
    defaultWidth: "full",
  }),
});

var formatRelative$v = {};

formatRelative$v.formatRelative = void 0;

const formatRelativeLocale$f = {
  lastWeek: "'të' eeee 'e shkuar në' p",
  yesterday: "'dje në' p",
  today: "'sot në' p",
  tomorrow: "'nesër në' p",
  nextWeek: "eeee 'at' p",
  other: "P",
};

const formatRelative$u = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$f[token];
formatRelative$v.formatRelative = formatRelative$u;

var localize$f = {};

localize$f.localize = void 0;
var _index$10 = buildLocalizeFn$1;

const eraValues$f = {
  narrow: ["P", "M"],
  abbreviated: ["PK", "MK"],
  wide: ["Para Krishtit", "Mbas Krishtit"],
};

const quarterValues$f = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["4-mujori I", "4-mujori II", "4-mujori III", "4-mujori IV"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$f = {
  narrow: ["J", "S", "M", "P", "M", "Q", "K", "G", "S", "T", "N", "D"],
  abbreviated: [
    "Jan",
    "Shk",
    "Mar",
    "Pri",
    "Maj",
    "Qer",
    "Kor",
    "Gus",
    "Sht",
    "Tet",
    "Nën",
    "Dhj",
  ],

  wide: [
    "Janar",
    "Shkurt",
    "Mars",
    "Prill",
    "Maj",
    "Qershor",
    "Korrik",
    "Gusht",
    "Shtator",
    "Tetor",
    "Nëntor",
    "Dhjetor",
  ],
};

const dayValues$f = {
  narrow: ["D", "H", "M", "M", "E", "P", "S"],
  short: ["Di", "Hë", "Ma", "Më", "En", "Pr", "Sh"],
  abbreviated: ["Die", "Hën", "Mar", "Mër", "Enj", "Pre", "Sht"],
  wide: ["Dielë", "Hënë", "Martë", "Mërkurë", "Enjte", "Premte", "Shtunë"],
};

const dayPeriodValues$f = {
  narrow: {
    am: "p",
    pm: "m",
    midnight: "m",
    noon: "d",
    morning: "mëngjes",
    afternoon: "dite",
    evening: "mbrëmje",
    night: "natë",
  },
  abbreviated: {
    am: "PD",
    pm: "MD",
    midnight: "mesnëtë",
    noon: "drek",
    morning: "mëngjes",
    afternoon: "mbasdite",
    evening: "mbrëmje",
    night: "natë",
  },
  wide: {
    am: "p.d.",
    pm: "m.d.",
    midnight: "mesnëtë",
    noon: "drek",
    morning: "mëngjes",
    afternoon: "mbasdite",
    evening: "mbrëmje",
    night: "natë",
  },
};

const formattingDayPeriodValues$f = {
  narrow: {
    am: "p",
    pm: "m",
    midnight: "m",
    noon: "d",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë",
  },
  abbreviated: {
    am: "PD",
    pm: "MD",
    midnight: "mesnatë",
    noon: "drek",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë",
  },
  wide: {
    am: "p.d.",
    pm: "m.d.",
    midnight: "mesnatë",
    noon: "drek",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë",
  },
};

const ordinalNumber$f = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);

  if (options?.unit === "hour") return String(number);

  if (number === 1) return number + "-rë";
  if (number === 4) return number + "t";

  return number + "-të";
};

(localize$f.localize = {
  ordinalNumber: ordinalNumber$f,

  era: (0, _index$10.buildLocalizeFn)({
    values: eraValues$f,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$10.buildLocalizeFn)({
    values: quarterValues$f,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$10.buildLocalizeFn)({
    values: monthValues$f,
    defaultWidth: "wide",
  }),

  day: (0, _index$10.buildLocalizeFn)({
    values: dayValues$f,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$10.buildLocalizeFn)({
    values: dayPeriodValues$f,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$f,
    defaultFormattingWidth: "wide",
  }),
});

var match$f = {};

match$f.match = void 0;

var _index$$ = buildMatchFn$1;
var _index2$w = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$f = /^(\d+)(-rë|-të|t|)?/i;
const parseOrdinalNumberPattern$f = /\d+/i;

const matchEraPatterns$f = {
  narrow: /^(p|m)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(para krishtit|mbas krishtit)/i,
};
const parseEraPatterns$f = {
  any: [/^b/i, /^(p|m)/i],
};

const matchQuarterPatterns$f = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]-mujori (i{1,3}|iv)/i,
};
const parseQuarterPatterns$f = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$f = {
  narrow: /^[jsmpqkftnd]/i,
  abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
  wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i,
};
const parseMonthPatterns$f = {
  narrow: [
    /^j/i,
    /^s/i,
    /^m/i,
    /^p/i,
    /^m/i,
    /^q/i,
    /^k/i,
    /^g/i,
    /^s/i,
    /^t/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^shk/i,
    /^mar/i,
    /^pri/i,
    /^maj/i,
    /^qer/i,
    /^kor/i,
    /^gu/i,
    /^sht/i,
    /^tet/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$f = {
  narrow: /^[dhmeps]/i,
  short: /^(di|hë|ma|më|en|pr|sh)/i,
  abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
  wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i,
};
const parseDayPatterns$f = {
  narrow: [/^d/i, /^h/i, /^m/i, /^m/i, /^e/i, /^p/i, /^s/i],
  any: [/^d/i, /^h/i, /^ma/i, /^më/i, /^e/i, /^p/i, /^s/i],
};

const matchDayPeriodPatterns$f = {
  narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
  any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
};
const parseDayPeriodPatterns$f = {
  any: {
    am: /^p/i,
    pm: /^m/i,
    midnight: /^me/i,
    noon: /^dr/i,
    morning: /mëngjes/i,
    afternoon: /mbasdite/i,
    evening: /mbrëmje/i,
    night: /natë/i,
  },
};

(match$f.match = {
  ordinalNumber: (0, _index2$w.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$f,
    parsePattern: parseOrdinalNumberPattern$f,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$$.buildMatchFn)({
    matchPatterns: matchEraPatterns$f,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$f,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$$.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$f,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$f,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$$.buildMatchFn)({
    matchPatterns: matchMonthPatterns$f,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$f,
    defaultParseWidth: "any",
  }),

  day: (0, _index$$.buildMatchFn)({
    matchPatterns: matchDayPatterns$f,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$f,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$$.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$f,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$f,
    defaultParseWidth: "any",
  }),
});

sq.sq = void 0;
var _index$_ = formatDistance$v;
var _index2$v = formatLong$f;
var _index3$f = formatRelative$v;
var _index4$f = localize$f;
var _index5$f = match$f;

/**
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine](https://github.com/arditdine)
 */
(sq.sq = {
  code: "sq",
  formatDistance: _index$_.formatDistance,
  formatLong: _index2$v.formatLong,
  formatRelative: _index3$f.formatRelative,
  localize: _index4$f.localize,
  match: _index5$f.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var sr = {};

var formatDistance$t = {};

formatDistance$t.formatDistance = void 0;

const formatDistanceLocale$e = {
  lessThanXSeconds: {
    one: {
      standalone: "мање од 1 секунде",
      withPrepositionAgo: "мање од 1 секунде",
      withPrepositionIn: "мање од 1 секунду",
    },
    dual: "мање од {{count}} секунде",
    other: "мање од {{count}} секунди",
  },

  xSeconds: {
    one: {
      standalone: "1 секунда",
      withPrepositionAgo: "1 секунде",
      withPrepositionIn: "1 секунду",
    },
    dual: "{{count}} секунде",
    other: "{{count}} секунди",
  },

  halfAMinute: "пола минуте",

  lessThanXMinutes: {
    one: {
      standalone: "мање од 1 минуте",
      withPrepositionAgo: "мање од 1 минуте",
      withPrepositionIn: "мање од 1 минуту",
    },
    dual: "мање од {{count}} минуте",
    other: "мање од {{count}} минута",
  },

  xMinutes: {
    one: {
      standalone: "1 минута",
      withPrepositionAgo: "1 минуте",
      withPrepositionIn: "1 минуту",
    },
    dual: "{{count}} минуте",
    other: "{{count}} минута",
  },

  aboutXHours: {
    one: {
      standalone: "око 1 сат",
      withPrepositionAgo: "око 1 сат",
      withPrepositionIn: "око 1 сат",
    },
    dual: "око {{count}} сата",
    other: "око {{count}} сати",
  },

  xHours: {
    one: {
      standalone: "1 сат",
      withPrepositionAgo: "1 сат",
      withPrepositionIn: "1 сат",
    },
    dual: "{{count}} сата",
    other: "{{count}} сати",
  },

  xDays: {
    one: {
      standalone: "1 дан",
      withPrepositionAgo: "1 дан",
      withPrepositionIn: "1 дан",
    },
    dual: "{{count}} дана",
    other: "{{count}} дана",
  },

  aboutXWeeks: {
    one: {
      standalone: "око 1 недељу",
      withPrepositionAgo: "око 1 недељу",
      withPrepositionIn: "око 1 недељу",
    },
    dual: "око {{count}} недеље",
    other: "око {{count}} недеље",
  },

  xWeeks: {
    one: {
      standalone: "1 недељу",
      withPrepositionAgo: "1 недељу",
      withPrepositionIn: "1 недељу",
    },
    dual: "{{count}} недеље",
    other: "{{count}} недеље",
  },

  aboutXMonths: {
    one: {
      standalone: "око 1 месец",
      withPrepositionAgo: "око 1 месец",
      withPrepositionIn: "око 1 месец",
    },
    dual: "око {{count}} месеца",
    other: "око {{count}} месеци",
  },

  xMonths: {
    one: {
      standalone: "1 месец",
      withPrepositionAgo: "1 месец",
      withPrepositionIn: "1 месец",
    },
    dual: "{{count}} месеца",
    other: "{{count}} месеци",
  },

  aboutXYears: {
    one: {
      standalone: "око 1 годину",
      withPrepositionAgo: "око 1 годину",
      withPrepositionIn: "око 1 годину",
    },
    dual: "око {{count}} године",
    other: "око {{count}} година",
  },

  xYears: {
    one: {
      standalone: "1 година",
      withPrepositionAgo: "1 године",
      withPrepositionIn: "1 годину",
    },
    dual: "{{count}} године",
    other: "{{count}} година",
  },

  overXYears: {
    one: {
      standalone: "преко 1 годину",
      withPrepositionAgo: "преко 1 годину",
      withPrepositionIn: "преко 1 годину",
    },
    dual: "преко {{count}} године",
    other: "преко {{count}} година",
  },

  almostXYears: {
    one: {
      standalone: "готово 1 годину",
      withPrepositionAgo: "готово 1 годину",
      withPrepositionIn: "готово 1 годину",
    },
    dual: "готово {{count}} године",
    other: "готово {{count}} година",
  },
};

const formatDistance$s = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$e[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    if (options?.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        result = tokenValue.one.withPrepositionIn;
      } else {
        result = tokenValue.one.withPrepositionAgo;
      }
    } else {
      result = tokenValue.one.standalone;
    }
  } else if (
    count % 10 > 1 &&
    count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
  ) {
    result = tokenValue.dual.replace("{{count}}", String(count));
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "за " + result;
    } else {
      return "пре " + result;
    }
  }

  return result;
};
formatDistance$t.formatDistance = formatDistance$s;

var formatLong$e = {};

formatLong$e.formatLong = void 0;
var _index$Z = buildFormatLongFn$1;

const dateFormats$e = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy.",
};

const timeFormats$e = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$e = {
  full: "{{date}} 'у' {{time}}",
  long: "{{date}} 'у' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$e.formatLong = {
  date: (0, _index$Z.buildFormatLongFn)({
    formats: dateFormats$e,
    defaultWidth: "full",
  }),

  time: (0, _index$Z.buildFormatLongFn)({
    formats: timeFormats$e,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$Z.buildFormatLongFn)({
    formats: dateTimeFormats$e,
    defaultWidth: "full",
  }),
});

var formatRelative$t = {};

formatRelative$t.formatRelative = void 0;

const formatRelativeLocale$e = {
  lastWeek: (date) => {
    const day = date.getDay();

    switch (day) {
      case 0:
        return "'прошле недеље у' p";
      case 3:
        return "'прошле среде у' p";
      case 6:
        return "'прошле суботе у' p";
      default:
        return "'прошли' EEEE 'у' p";
    }
  },
  yesterday: "'јуче у' p",
  today: "'данас у' p",
  tomorrow: "'сутра у' p",
  nextWeek: (date) => {
    const day = date.getDay();

    switch (day) {
      case 0:
        return "'следеће недеље у' p";
      case 3:
        return "'следећу среду у' p";
      case 6:
        return "'следећу суботу у' p";
      default:
        return "'следећи' EEEE 'у' p";
    }
  },
  other: "P",
};

const formatRelative$s = (token, date, _baseDate, _options) => {
  const format = formatRelativeLocale$e[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$t.formatRelative = formatRelative$s;

var localize$e = {};

localize$e.localize = void 0;
var _index$Y = buildLocalizeFn$1;

const eraValues$e = {
  narrow: ["пр.н.е.", "АД"],
  abbreviated: ["пр. Хр.", "по. Хр."],
  wide: ["Пре Христа", "После Христа"],
};

const quarterValues$e = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. кв.", "2. кв.", "3. кв.", "4. кв."],
  wide: ["1. квартал", "2. квартал", "3. квартал", "4. квартал"],
};

const monthValues$e = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12.",
  ],

  abbreviated: [
    "јан",
    "феб",
    "мар",
    "апр",
    "мај",
    "јун",
    "јул",
    "авг",
    "сеп",
    "окт",
    "нов",
    "дец",
  ],

  wide: [
    "јануар",
    "фебруар",
    "март",
    "април",
    "мај",
    "јун",
    "јул",
    "август",
    "септембар",
    "октобар",
    "новембар",
    "децембар",
  ],
};

const formattingMonthValues$3 = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12.",
  ],

  abbreviated: [
    "јан",
    "феб",
    "мар",
    "апр",
    "мај",
    "јун",
    "јул",
    "авг",
    "сеп",
    "окт",
    "нов",
    "дец",
  ],

  wide: [
    "јануар",
    "фебруар",
    "март",
    "април",
    "мај",
    "јун",
    "јул",
    "август",
    "септембар",
    "октобар",
    "новембар",
    "децембар",
  ],
};

const dayValues$e = {
  narrow: ["Н", "П", "У", "С", "Ч", "П", "С"],
  short: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  abbreviated: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  wide: [
    "недеља",
    "понедељак",
    "уторак",
    "среда",
    "четвртак",
    "петак",
    "субота",
  ],
};

const formattingDayPeriodValues$e = {
  narrow: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу",
  },
  abbreviated: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу",
  },
};

const dayPeriodValues$e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу",
  },
};

const ordinalNumber$e = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$e.localize = {
  ordinalNumber: ordinalNumber$e,

  era: (0, _index$Y.buildLocalizeFn)({
    values: eraValues$e,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$Y.buildLocalizeFn)({
    values: quarterValues$e,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$Y.buildLocalizeFn)({
    values: monthValues$e,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$3,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$Y.buildLocalizeFn)({
    values: dayValues$e,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$Y.buildLocalizeFn)({
    values: dayPeriodValues$e,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$e,
    defaultFormattingWidth: "wide",
  }),
});

var match$e = {};

match$e.match = void 0;

var _index$X = buildMatchFn$1;
var _index2$u = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$e = /^(\d+)\./i;
const parseOrdinalNumberPattern$e = /\d+/i;

const matchEraPatterns$e = {
  narrow: /^(пр\.н\.е\.|АД)/i,
  abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
  wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i,
};
const parseEraPatterns$e = {
  any: [/^пр/i, /^(по|нова)/i],
};

const matchQuarterPatterns$e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?кв\.?/i,
  wide: /^[1234]\. квартал/i,
};
const parseQuarterPatterns$e = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$e = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
  wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i,
};
const parseMonthPatterns$e = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i,
  ],

  any: [
    /^ја/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^мај/i,
    /^јун/i,
    /^јул/i,
    /^авг/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i,
  ],
};

const matchDayPatterns$e = {
  narrow: /^[пусчн]/i,
  short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i,
};
const parseDayPatterns$e = {
  narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^п/i, /^с/i, /^н/i],
  any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i],
};

const matchDayPeriodPatterns$e = {
  any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i,
};
const parseDayPeriodPatterns$e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^поно/i,
    noon: /^под/i,
    morning: /ујутру/i,
    afternoon: /(после\s|по)+подне/i,
    evening: /(увече)/i,
    night: /(ноћу)/i,
  },
};

(match$e.match = {
  ordinalNumber: (0, _index2$u.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$e,
    parsePattern: parseOrdinalNumberPattern$e,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$X.buildMatchFn)({
    matchPatterns: matchEraPatterns$e,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$e,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$X.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$e,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$e,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$X.buildMatchFn)({
    matchPatterns: matchMonthPatterns$e,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$e,
    defaultParseWidth: "any",
  }),

  day: (0, _index$X.buildMatchFn)({
    matchPatterns: matchDayPatterns$e,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$e,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$X.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$e,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$e,
    defaultParseWidth: "any",
  }),
});

sr.sr = void 0;
var _index$W = formatDistance$t;
var _index2$t = formatLong$e;
var _index3$e = formatRelative$t;
var _index4$e = localize$e;
var _index5$e = match$e;

/**
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje](https://github.com/rogyvoje)
 */
(sr.sr = {
  code: "sr",
  formatDistance: _index$W.formatDistance,
  formatLong: _index2$t.formatLong,
  formatRelative: _index3$e.formatRelative,
  localize: _index4$e.localize,
  match: _index5$e.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var srLatn = {};

var formatDistance$r = {};

formatDistance$r.formatDistance = void 0;

const formatDistanceLocale$d = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu",
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi",
  },

  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu",
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi",
  },

  halfAMinute: "pola minute",

  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu",
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta",
  },

  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu",
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta",
  },

  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat",
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati",
  },

  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat",
    },
    dual: "{{count}} sata",
    other: "{{count}} sati",
  },

  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan",
    },
    dual: "{{count}} dana",
    other: "{{count}} dana",
  },

  aboutXWeeks: {
    one: {
      standalone: "oko 1 nedelju",
      withPrepositionAgo: "oko 1 nedelju",
      withPrepositionIn: "oko 1 nedelju",
    },
    dual: "oko {{count}} nedelje",
    other: "oko {{count}} nedelje",
  },

  xWeeks: {
    one: {
      standalone: "1 nedelju",
      withPrepositionAgo: "1 nedelju",
      withPrepositionIn: "1 nedelju",
    },
    dual: "{{count}} nedelje",
    other: "{{count}} nedelje",
  },

  aboutXMonths: {
    one: {
      standalone: "oko 1 mesec",
      withPrepositionAgo: "oko 1 mesec",
      withPrepositionIn: "oko 1 mesec",
    },
    dual: "oko {{count}} meseca",
    other: "oko {{count}} meseci",
  },

  xMonths: {
    one: {
      standalone: "1 mesec",
      withPrepositionAgo: "1 mesec",
      withPrepositionIn: "1 mesec",
    },
    dual: "{{count}} meseca",
    other: "{{count}} meseci",
  },

  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu",
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina",
  },

  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu",
    },
    dual: "{{count}} godine",
    other: "{{count}} godina",
  },

  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu",
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina",
  },

  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu",
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina",
  },
};

const formatDistance$q = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$d[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    if (options?.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        result = tokenValue.one.withPrepositionIn;
      } else {
        result = tokenValue.one.withPrepositionAgo;
      }
    } else {
      result = tokenValue.one.standalone;
    }
  } else if (
    count % 10 > 1 &&
    count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
  ) {
    result = tokenValue.dual.replace("{{count}}", String(count));
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "za " + result;
    } else {
      return "pre " + result;
    }
  }

  return result;
};
formatDistance$r.formatDistance = formatDistance$q;

var formatLong$d = {};

formatLong$d.formatLong = void 0;
var _index$V = buildFormatLongFn$1;

const dateFormats$d = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy.",
};

const timeFormats$d = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$d = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$d.formatLong = {
  date: (0, _index$V.buildFormatLongFn)({
    formats: dateFormats$d,
    defaultWidth: "full",
  }),

  time: (0, _index$V.buildFormatLongFn)({
    formats: timeFormats$d,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$V.buildFormatLongFn)({
    formats: dateTimeFormats$d,
    defaultWidth: "full",
  }),
});

var formatRelative$r = {};

formatRelative$r.formatRelative = void 0;

const formatRelativeLocale$d = {
  lastWeek: (date) => {
    switch (date.getDay()) {
      case 0:
        return "'prošle nedelje u' p";
      case 3:
        return "'prošle srede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (date) => {
    switch (date.getDay()) {
      case 0:
        return "'sledeće nedelje u' p";
      case 3:
        return "'sledeću sredu u' p";
      case 6:
        return "'sledeću subotu u' p";
      default:
        return "'sledeći' EEEE 'u' p";
    }
  },
  other: "P",
};

const formatRelative$q = (token, date, _baseDate, _options) => {
  const format = formatRelativeLocale$d[token];

  if (typeof format === "function") {
    return format(date);
  }

  return format;
};
formatRelative$r.formatRelative = formatRelative$q;

var localize$d = {};

localize$d.localize = void 0;
var _index$U = buildLocalizeFn$1;

const eraValues$d = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"],
};

const quarterValues$d = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"],
};

const monthValues$d = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12.",
  ],

  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec",
  ],

  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar",
  ],
};

const formattingMonthValues$2 = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12.",
  ],

  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec",
  ],

  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar",
  ],
};

const dayValues$d = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: [
    "nedelja",
    "ponedeljak",
    "utorak",
    "sreda",
    "četvrtak",
    "petak",
    "subota",
  ],
};

const formattingDayPeriodValues$d = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću",
  },
};

const dayPeriodValues$d = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću",
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću",
  },
};

const ordinalNumber$d = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$d.localize = {
  ordinalNumber: ordinalNumber$d,

  era: (0, _index$U.buildLocalizeFn)({
    values: eraValues$d,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$U.buildLocalizeFn)({
    values: quarterValues$d,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$U.buildLocalizeFn)({
    values: monthValues$d,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$2,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$U.buildLocalizeFn)({
    values: dayValues$d,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$U.buildLocalizeFn)({
    values: dayPeriodValues$d,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$d,
    defaultFormattingWidth: "wide",
  }),
});

var match$d = {};

match$d.match = void 0;

var _index$T = buildMatchFn$1;
var _index2$s = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$d = /^(\d+)\./i;
const parseOrdinalNumberPattern$d = /\d+/i;

const matchEraPatterns$d = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i,
};
const parseEraPatterns$d = {
  any: [/^pr/i, /^(po|nova)/i],
};

const matchQuarterPatterns$d = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i,
};
const parseQuarterPatterns$d = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$d = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i,
};
const parseMonthPatterns$d = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^avg/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$d = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i,
};
const parseDayPatterns$d = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i],
};

const matchDayPeriodPatterns$d = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i,
};
const parseDayPeriodPatterns$d = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i,
  },
};

(match$d.match = {
  ordinalNumber: (0, _index2$s.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$d,
    parsePattern: parseOrdinalNumberPattern$d,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$T.buildMatchFn)({
    matchPatterns: matchEraPatterns$d,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$d,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$T.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$d,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$d,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$T.buildMatchFn)({
    matchPatterns: matchMonthPatterns$d,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$d,
    defaultParseWidth: "any",
  }),

  day: (0, _index$T.buildMatchFn)({
    matchPatterns: matchDayPatterns$d,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$d,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$T.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$d,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$d,
    defaultParseWidth: "any",
  }),
});

srLatn.srLatn = void 0;
var _index$S = formatDistance$r;
var _index2$r = formatLong$d;
var _index3$d = formatRelative$r;
var _index4$d = localize$d;
var _index5$d = match$d;

/**
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje](https://github.com/rogyvoje)
 */
(srLatn.srLatn = {
  code: "sr-Latn",
  formatDistance: _index$S.formatDistance,
  formatLong: _index2$r.formatLong,
  formatRelative: _index3$d.formatRelative,
  localize: _index4$d.localize,
  match: _index5$d.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var sv = {};

var formatDistance$p = {};

formatDistance$p.formatDistance = void 0;

const formatDistanceLocale$c = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder",
  },

  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder",
  },

  halfAMinute: "en halv minut",

  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter",
  },

  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter",
  },

  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar",
  },

  xHours: {
    one: "en timme",
    other: "{{count}} timmar",
  },

  xDays: {
    one: "en dag",
    other: "{{count}} dagar",
  },

  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} veckor",
  },

  xWeeks: {
    one: "en vecka",
    other: "{{count}} veckor",
  },

  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader",
  },

  xMonths: {
    one: "en månad",
    other: "{{count}} månader",
  },

  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år",
  },

  xYears: {
    one: "ett år",
    other: "{{count}} år",
  },

  overXYears: {
    one: "över ett år",
    other: "över {{count}} år",
  },

  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år",
  },
};

const wordMapping = [
  "noll",
  "en",
  "två",
  "tre",
  "fyra",
  "fem",
  "sex",
  "sju",
  "åtta",
  "nio",
  "tio",
  "elva",
  "tolv",
];

const formatDistance$o = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$c[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace(
      "{{count}}",
      count < 13 ? wordMapping[count] : String(count),
    );
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "om " + result;
    } else {
      return result + " sedan";
    }
  }

  return result;
};
formatDistance$p.formatDistance = formatDistance$o;

var formatLong$c = {};

formatLong$c.formatLong = void 0;
var _index$R = buildFormatLongFn$1;

const dateFormats$c = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd",
};

const timeFormats$c = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$c = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$c.formatLong = {
  date: (0, _index$R.buildFormatLongFn)({
    formats: dateFormats$c,
    defaultWidth: "full",
  }),

  time: (0, _index$R.buildFormatLongFn)({
    formats: timeFormats$c,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$R.buildFormatLongFn)({
    formats: dateTimeFormats$c,
    defaultWidth: "full",
  }),
});

var formatRelative$p = {};

formatRelative$p.formatRelative = void 0;

const formatRelativeLocale$c = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P",
};

const formatRelative$o = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$c[token];
formatRelative$p.formatRelative = formatRelative$o;

var localize$c = {};

localize$c.localize = void 0;
var _index$Q = buildLocalizeFn$1;

const eraValues$c = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"],
};

const quarterValues$c = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"],
};

const monthValues$c = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "maj",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec.",
  ],

  wide: [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december",
  ],
};

const dayValues$c = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"],
};

// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
const dayPeriodValues$c = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt",
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt",
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt",
  },
};

const formattingDayPeriodValues$c = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten",
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten",
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten",
  },
};

const ordinalNumber$c = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
      case 2:
        return number + ":a";
    }
  }
  return number + ":e";
};

(localize$c.localize = {
  ordinalNumber: ordinalNumber$c,

  era: (0, _index$Q.buildLocalizeFn)({
    values: eraValues$c,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$Q.buildLocalizeFn)({
    values: quarterValues$c,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$Q.buildLocalizeFn)({
    values: monthValues$c,
    defaultWidth: "wide",
  }),

  day: (0, _index$Q.buildLocalizeFn)({
    values: dayValues$c,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$Q.buildLocalizeFn)({
    values: dayPeriodValues$c,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$c,
    defaultFormattingWidth: "wide",
  }),
});

var match$c = {};

match$c.match = void 0;

var _index$P = buildMatchFn$1;
var _index2$q = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$c = /^(\d+)(:a|:e)?/i;
const parseOrdinalNumberPattern$c = /\d+/i;

const matchEraPatterns$c = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i,
};
const parseEraPatterns$c = {
  any: [/^f/i, /^[ev]/i],
};

const matchQuarterPatterns$c = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i,
};
const parseQuarterPatterns$c = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$c = {
  narrow: /^[jfmasond]/i,
  abbreviated:
    /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i,
};
const parseMonthPatterns$c = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$c = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i,
};
const parseDayPatterns$c = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i],
};

const matchDayPeriodPatterns$c = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i,
};
const parseDayPeriodPatterns$c = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i,
  },
};

(match$c.match = {
  ordinalNumber: (0, _index2$q.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$c,
    parsePattern: parseOrdinalNumberPattern$c,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$P.buildMatchFn)({
    matchPatterns: matchEraPatterns$c,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$c,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$P.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$c,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$c,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$P.buildMatchFn)({
    matchPatterns: matchMonthPatterns$c,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$c,
    defaultParseWidth: "any",
  }),

  day: (0, _index$P.buildMatchFn)({
    matchPatterns: matchDayPatterns$c,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$c,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$P.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$c,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$c,
    defaultParseWidth: "any",
  }),
});

sv.sv = void 0;
var _index$O = formatDistance$p;
var _index2$p = formatLong$c;
var _index3$c = formatRelative$p;
var _index4$c = localize$c;
var _index5$c = match$c;

/**
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen](https://github.com/ejulen)
 * @author Alexander Nanberg [@alexandernanberg](https://github.com/alexandernanberg)
 * @author Henrik Andersson [@limelights](https://github.com/limelights)
 */
(sv.sv = {
  code: "sv",
  formatDistance: _index$O.formatDistance,
  formatLong: _index2$p.formatLong,
  formatRelative: _index3$c.formatRelative,
  localize: _index4$c.localize,
  match: _index5$c.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var ta = {};

var formatDistance$n = {};

formatDistance$n.formatDistance = void 0;

function isPluralType(val) {
  return val.one !== undefined;
}

const formatDistanceLocale$b = {
  lessThanXSeconds: {
    one: {
      default: "ஒரு வினாடிக்கு குறைவாக",
      in: "ஒரு வினாடிக்குள்",
      ago: "ஒரு வினாடிக்கு முன்பு",
    },
    other: {
      default: "{{count}} வினாடிகளுக்கு குறைவாக",
      in: "{{count}} வினாடிகளுக்குள்",
      ago: "{{count}} வினாடிகளுக்கு முன்பு",
    },
  },

  xSeconds: {
    one: {
      default: "1 வினாடி",
      in: "1 வினாடியில்",
      ago: "1 வினாடி முன்பு",
    },
    other: {
      default: "{{count}} விநாடிகள்",
      in: "{{count}} வினாடிகளில்",
      ago: "{{count}} விநாடிகளுக்கு முன்பு",
    },
  },

  halfAMinute: {
    default: "அரை நிமிடம்",
    in: "அரை நிமிடத்தில்",
    ago: "அரை நிமிடம் முன்பு",
  },

  lessThanXMinutes: {
    one: {
      default: "ஒரு நிமிடத்திற்கும் குறைவாக",
      in: "ஒரு நிமிடத்திற்குள்",
      ago: "ஒரு நிமிடத்திற்கு முன்பு",
    },
    other: {
      default: "{{count}} நிமிடங்களுக்கும் குறைவாக",
      in: "{{count}} நிமிடங்களுக்குள்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு",
    },
  },

  xMinutes: {
    one: {
      default: "1 நிமிடம்",
      in: "1 நிமிடத்தில்",
      ago: "1 நிமிடம் முன்பு",
    },
    other: {
      default: "{{count}} நிமிடங்கள்",
      in: "{{count}} நிமிடங்களில்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு",
    },
  },

  aboutXHours: {
    one: {
      default: "சுமார் 1 மணி நேரம்",
      in: "சுமார் 1 மணி நேரத்தில்",
      ago: "சுமார் 1 மணி நேரத்திற்கு முன்பு",
    },
    other: {
      default: "சுமார் {{count}} மணி நேரம்",
      in: "சுமார் {{count}} மணி நேரத்திற்கு முன்பு",
      ago: "சுமார் {{count}} மணி நேரத்தில்",
    },
  },

  xHours: {
    one: {
      default: "1 மணி நேரம்",
      in: "1 மணி நேரத்தில்",
      ago: "1 மணி நேரத்திற்கு முன்பு",
    },
    other: {
      default: "{{count}} மணி நேரம்",
      in: "{{count}} மணி நேரத்தில்",
      ago: "{{count}} மணி நேரத்திற்கு முன்பு",
    },
  },

  xDays: {
    one: {
      default: "1 நாள்",
      in: "1 நாளில்",
      ago: "1 நாள் முன்பு",
    },
    other: {
      default: "{{count}} நாட்கள்",
      in: "{{count}} நாட்களில்",
      ago: "{{count}} நாட்களுக்கு முன்பு",
    },
  },

  aboutXWeeks: {
    one: {
      default: "சுமார் 1 வாரம்",
      in: "சுமார் 1 வாரத்தில்",
      ago: "சுமார் 1 வாரம் முன்பு",
    },
    other: {
      default: "சுமார் {{count}} வாரங்கள்",
      in: "சுமார் {{count}} வாரங்களில்",
      ago: "சுமார் {{count}} வாரங்களுக்கு முன்பு",
    },
  },

  xWeeks: {
    one: {
      default: "1 வாரம்",
      in: "1 வாரத்தில்",
      ago: "1 வாரம் முன்பு",
    },
    other: {
      default: "{{count}} வாரங்கள்",
      in: "{{count}} வாரங்களில்",
      ago: "{{count}} வாரங்களுக்கு முன்பு",
    },
  },

  aboutXMonths: {
    one: {
      default: "சுமார் 1 மாதம்",
      in: "சுமார் 1 மாதத்தில்",
      ago: "சுமார் 1 மாதத்திற்கு முன்பு",
    },
    other: {
      default: "சுமார் {{count}} மாதங்கள்",
      in: "சுமார் {{count}} மாதங்களில்",
      ago: "சுமார் {{count}} மாதங்களுக்கு முன்பு",
    },
  },

  xMonths: {
    one: {
      default: "1 மாதம்",
      in: "1 மாதத்தில்",
      ago: "1 மாதம் முன்பு",
    },
    other: {
      default: "{{count}} மாதங்கள்",
      in: "{{count}} மாதங்களில்",
      ago: "{{count}} மாதங்களுக்கு முன்பு",
    },
  },

  aboutXYears: {
    one: {
      default: "சுமார் 1 வருடம்",
      in: "சுமார் 1 ஆண்டில்",
      ago: "சுமார் 1 வருடம் முன்பு",
    },
    other: {
      default: "சுமார் {{count}} ஆண்டுகள்",
      in: "சுமார் {{count}} ஆண்டுகளில்",
      ago: "சுமார் {{count}} ஆண்டுகளுக்கு முன்பு",
    },
  },

  xYears: {
    one: {
      default: "1 வருடம்",
      in: "1 ஆண்டில்",
      ago: "1 வருடம் முன்பு",
    },
    other: {
      default: "{{count}} ஆண்டுகள்",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு",
    },
  },

  overXYears: {
    one: {
      default: "1 வருடத்திற்கு மேல்",
      in: "1 வருடத்திற்கும் மேலாக",
      ago: "1 வருடம் முன்பு",
    },
    other: {
      default: "{{count}} ஆண்டுகளுக்கும் மேலாக",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு",
    },
  },

  almostXYears: {
    one: {
      default: "கிட்டத்தட்ட 1 வருடம்",
      in: "கிட்டத்தட்ட 1 ஆண்டில்",
      ago: "கிட்டத்தட்ட 1 வருடம் முன்பு",
    },
    other: {
      default: "கிட்டத்தட்ட {{count}} ஆண்டுகள்",
      in: "கிட்டத்தட்ட {{count}} ஆண்டுகளில்",
      ago: "கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு",
    },
  },
};

const formatDistance$m = (token, count, options) => {
  const tense = options?.addSuffix
    ? options.comparison && options.comparison > 0
      ? "in"
      : "ago"
    : "default";

  const tokenValue = formatDistanceLocale$b[token];

  if (!isPluralType(tokenValue)) return tokenValue[tense];

  if (count === 1) {
    return tokenValue.one[tense];
  } else {
    return tokenValue.other[tense].replace("{{count}}", String(count));
  }
};
formatDistance$n.formatDistance = formatDistance$m;

var formatLong$b = {};

formatLong$b.formatLong = void 0;
var _index$N = buildFormatLongFn$1;

// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html

// CLDR #1846 - #1849
const dateFormats$b = {
  full: "EEEE, d MMMM, y",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "d/M/yy",
};

// CLDR #1850 - #1853
const timeFormats$b = {
  full: "a h:mm:ss zzzz",
  long: "a h:mm:ss z",
  medium: "a h:mm:ss",
  short: "a h:mm",
};

const dateTimeFormats$b = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$b.formatLong = {
  date: (0, _index$N.buildFormatLongFn)({
    formats: dateFormats$b,
    defaultWidth: "full",
  }),

  time: (0, _index$N.buildFormatLongFn)({
    formats: timeFormats$b,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$N.buildFormatLongFn)({
    formats: dateTimeFormats$b,
    defaultWidth: "full",
  }),
});

var formatRelative$n = {};

formatRelative$n.formatRelative = void 0;

const formatRelativeLocale$b = {
  lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
  yesterday: "'நேற்று ' p 'மணிக்கு'",
  today: "'இன்று ' p 'மணிக்கு'",
  tomorrow: "'நாளை ' p 'மணிக்கு'",
  nextWeek: "eeee p 'மணிக்கு'",
  other: "P",
};

const formatRelative$m = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$b[token];
formatRelative$n.formatRelative = formatRelative$m;

var localize$b = {};

localize$b.localize = void 0;
var _index$M = buildLocalizeFn$1;

// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html

const eraValues$b = {
  narrow: ["கி.மு.", "கி.பி."],
  abbreviated: ["கி.மு.", "கி.பி."], // CLDR #1624, #1626
  wide: ["கிறிஸ்துவுக்கு முன்", "அன்னோ டோமினி"], // CLDR #1620, #1622
};

const quarterValues$b = {
  // CLDR #1644 - #1647
  narrow: ["1", "2", "3", "4"],
  // CLDR #1636 - #1639
  abbreviated: ["காலா.1", "காலா.2", "காலா.3", "காலா.4"],
  // CLDR #1628 - #1631
  wide: [
    "ஒன்றாம் காலாண்டு",
    "இரண்டாம் காலாண்டு",
    "மூன்றாம் காலாண்டு",
    "நான்காம் காலாண்டு",
  ],
};

const monthValues$b = {
  // CLDR #700 - #711
  narrow: ["ஜ", "பி", "மா", "ஏ", "மே", "ஜூ", "ஜூ", "ஆ", "செ", "அ", "ந", "டி"],

  // CLDR #1676 - #1687
  abbreviated: [
    "ஜன.",
    "பிப்.",
    "மார்.",
    "ஏப்.",
    "மே",
    "ஜூன்",
    "ஜூலை",
    "ஆக.",
    "செப்.",
    "அக்.",
    "நவ.",
    "டிச.",
  ],

  // CLDR #1652 - #1663
  wide: [
    "ஜனவரி", // January
    "பிப்ரவரி", // February
    "மார்ச்", // March
    "ஏப்ரல்", // April
    "மே", // May
    "ஜூன்", // June
    "ஜூலை", // July
    "ஆகஸ்ட்", // August
    "செப்டம்பர்", // September
    "அக்டோபர்", // October
    "நவம்பர்", // November
    "டிசம்பர்", // December
  ],
};

const dayValues$b = {
  // CLDR #1766 - #1772
  narrow: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  // CLDR #1752 - #1758
  short: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  // CLDR #1738 - #1744
  abbreviated: ["ஞாயி.", "திங்.", "செவ்.", "புத.", "வியா.", "வெள்.", "சனி"],

  // CLDR #1724 - #1730
  wide: [
    "ஞாயிறு", // Sunday
    "திங்கள்", // Monday
    "செவ்வாய்", // Tuesday
    "புதன்", // Wednesday
    "வியாழன்", // Thursday
    "வெள்ளி", // Friday
    "சனி", // Saturday
  ],
};

// CLDR #1780 - #1845
const dayPeriodValues$b = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர.",
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு",
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு",
  },
};

// CLDR #1780 - #1845
const formattingDayPeriodValues$b = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர.",
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு",
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு",
  },
};

const ordinalNumber$b = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$b.localize = {
  ordinalNumber: ordinalNumber$b,

  era: (0, _index$M.buildLocalizeFn)({
    values: eraValues$b,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$M.buildLocalizeFn)({
    values: quarterValues$b,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$M.buildLocalizeFn)({
    values: monthValues$b,
    defaultWidth: "wide",
  }),

  day: (0, _index$M.buildLocalizeFn)({
    values: dayValues$b,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$M.buildLocalizeFn)({
    values: dayPeriodValues$b,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$b,
    defaultFormattingWidth: "wide",
  }),
});

var match$b = {};

match$b.match = void 0;

var _index$L = buildMatchFn$1;
var _index2$o = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$b = /^(\d+)(வது)?/i;
const parseOrdinalNumberPattern$b = /\d+/i;

const matchEraPatterns$b = {
  narrow: /^(கி.மு.|கி.பி.)/i,
  abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
  wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i,
};
const parseEraPatterns$b = {
  any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/],
};

const matchQuarterPatterns$b = {
  narrow: /^[1234]/i,
  abbreviated: /^காலா.[1234]/i,
  wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i,
};
const parseQuarterPatterns$b = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [
    /(1|காலா.1|ஒன்றாம்)/i,
    /(2|காலா.2|இரண்டாம்)/i,
    /(3|காலா.3|மூன்றாம்)/i,
    /(4|காலா.4|நான்காம்)/i,
  ],
};

const matchMonthPatterns$b = {
  narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
  abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
  wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i,
};
const parseMonthPatterns$b = {
  narrow: [
    /^ஜ$/i,
    /^பி/i,
    /^மா/i,
    /^ஏ/i,
    /^மே/i,
    /^ஜூ/i,
    /^ஜூ/i,
    /^ஆ/i,
    /^செ/i,
    /^அ/i,
    /^ந/i,
    /^டி/i,
  ],

  any: [
    /^ஜன/i,
    /^பி/i,
    /^மா/i,
    /^ஏ/i,
    /^மே/i,
    /^ஜூன்/i,
    /^ஜூலை/i,
    /^ஆ/i,
    /^செ/i,
    /^அ/i,
    /^ந/i,
    /^டி/i,
  ],
};

const matchDayPatterns$b = {
  narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
  wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i,
};
const parseDayPatterns$b = {
  narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
  any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
};

const matchDayPeriodPatterns$b = {
  narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
  any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i,
};
const parseDayPeriodPatterns$b = {
  any: {
    am: /^மு/i,
    pm: /^பி/i,
    midnight: /^நள்/i,
    noon: /^நண்/i,
    morning: /காலை/i,
    afternoon: /மதியம்/i,
    evening: /மாலை/i,
    night: /இரவு/i,
  },
};

(match$b.match = {
  ordinalNumber: (0, _index2$o.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$b,
    parsePattern: parseOrdinalNumberPattern$b,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$L.buildMatchFn)({
    matchPatterns: matchEraPatterns$b,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$b,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$L.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$b,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$b,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$L.buildMatchFn)({
    matchPatterns: matchMonthPatterns$b,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$b,
    defaultParseWidth: "any",
  }),

  day: (0, _index$L.buildMatchFn)({
    matchPatterns: matchDayPatterns$b,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$b,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$L.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$b,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$b,
    defaultParseWidth: "any",
  }),
});

ta.ta = void 0;
var _index$K = formatDistance$n;
var _index2$n = formatLong$b;
var _index3$b = formatRelative$n;
var _index4$b = localize$b;
var _index5$b = match$b;

/**
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s](https://github.com/sibiraj-s)
 */
(ta.ta = {
  code: "ta",
  formatDistance: _index$K.formatDistance,
  formatLong: _index2$n.formatLong,
  formatRelative: _index3$b.formatRelative,
  localize: _index4$b.localize,
  match: _index5$b.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var te = {};

var formatDistance$l = {};

formatDistance$l.formatDistance = void 0;

// Source: https://www.unicode.org/cldr/charts/32/summary/te.html

const formatDistanceLocale$a = {
  lessThanXSeconds: {
    standalone: {
      one: "సెకను కన్నా తక్కువ",
      other: "{{count}} సెకన్ల కన్నా తక్కువ",
    },
    withPreposition: {
      one: "సెకను",
      other: "{{count}} సెకన్ల",
    },
  },

  xSeconds: {
    standalone: {
      one: "ఒక సెకను", // CLDR #1314
      other: "{{count}} సెకన్ల",
    },
    withPreposition: {
      one: "ఒక సెకను",
      other: "{{count}} సెకన్ల",
    },
  },

  halfAMinute: {
    standalone: "అర నిమిషం",
    withPreposition: "అర నిమిషం",
  },

  lessThanXMinutes: {
    standalone: {
      one: "ఒక నిమిషం కన్నా తక్కువ",
      other: "{{count}} నిమిషాల కన్నా తక్కువ",
    },
    withPreposition: {
      one: "ఒక నిమిషం",
      other: "{{count}} నిమిషాల",
    },
  },

  xMinutes: {
    standalone: {
      one: "ఒక నిమిషం", // CLDR #1311
      other: "{{count}} నిమిషాలు",
    },
    withPreposition: {
      one: "ఒక నిమిషం", // CLDR #1311
      other: "{{count}} నిమిషాల",
    },
  },

  aboutXHours: {
    standalone: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటలు",
    },
    withPreposition: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటల",
    },
  },

  xHours: {
    standalone: {
      one: "ఒక గంట", // CLDR #1308
      other: "{{count}} గంటలు",
    },
    withPreposition: {
      one: "ఒక గంట",
      other: "{{count}} గంటల",
    },
  },

  xDays: {
    standalone: {
      one: "ఒక రోజు", // CLDR #1292
      other: "{{count}} రోజులు",
    },
    withPreposition: {
      one: "ఒక రోజు",
      other: "{{count}} రోజుల",
    },
  },

  aboutXWeeks: {
    standalone: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలు",
    },
    withPreposition: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలల",
    },
  },

  xWeeks: {
    standalone: {
      one: "ఒక వారం",
      other: "{{count}} వారాలు",
    },
    withPreposition: {
      one: "ఒక వారం",
      other: "{{count}} వారాలల",
    },
  },

  aboutXMonths: {
    standalone: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలలు",
    },
    withPreposition: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలల",
    },
  },

  xMonths: {
    standalone: {
      one: "ఒక నెల", // CLDR #1281
      other: "{{count}} నెలలు",
    },
    withPreposition: {
      one: "ఒక నెల",
      other: "{{count}} నెలల",
    },
  },

  aboutXYears: {
    standalone: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాలు",
    },
    withPreposition: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాల",
    },
  },

  xYears: {
    standalone: {
      one: "ఒక సంవత్సరం", // CLDR #1275
      other: "{{count}} సంవత్సరాలు",
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల",
    },
  },

  overXYears: {
    standalone: {
      one: "ఒక సంవత్సరం పైగా",
      other: "{{count}} సంవత్సరాలకు పైగా",
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల",
    },
  },

  almostXYears: {
    standalone: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాలు",
    },
    withPreposition: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాల",
    },
  },
};

const formatDistance$k = (token, count, options) => {
  let result;

  const tokenValue = options?.addSuffix
    ? formatDistanceLocale$a[token].withPreposition
    : formatDistanceLocale$a[token].standalone;

  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + "లో";
    } else {
      return result + " క్రితం";
    }
  }

  return result;
};
formatDistance$l.formatDistance = formatDistance$k;

var formatLong$a = {};

formatLong$a.formatLong = void 0;
var _index$J = buildFormatLongFn$1;

// Source: https://www.unicode.org/cldr/charts/32/summary/te.html

// CLDR #1807 - #1811
const dateFormats$a = {
  full: "d, MMMM y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd-MM-yy",
};

// CLDR #1807 - #1811
const timeFormats$a = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

// CLDR #1815 - #1818
const dateTimeFormats$a = {
  full: "{{date}} {{time}}'కి'",
  long: "{{date}} {{time}}'కి'",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$a.formatLong = {
  date: (0, _index$J.buildFormatLongFn)({
    formats: dateFormats$a,
    defaultWidth: "full",
  }),

  time: (0, _index$J.buildFormatLongFn)({
    formats: timeFormats$a,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$J.buildFormatLongFn)({
    formats: dateTimeFormats$a,
    defaultWidth: "full",
  }),
});

var formatRelative$l = {};

formatRelative$l.formatRelative = void 0;

// Source: https://www.unicode.org/cldr/charts/32/summary/te.html

const formatRelativeLocale$a = {
  lastWeek: "'గత' eeee p", // CLDR #1384
  yesterday: "'నిన్న' p", // CLDR #1393
  today: "'ఈ రోజు' p", // CLDR #1394
  tomorrow: "'రేపు' p", // CLDR #1395
  nextWeek: "'తదుపరి' eeee p", // CLDR #1386
  other: "P",
};

const formatRelative$k = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$a[token];
formatRelative$l.formatRelative = formatRelative$k;

var localize$a = {};

localize$a.localize = void 0;
var _index$I = buildLocalizeFn$1;

// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
// Source: https://dsal.uchicago.edu/dictionaries/brown/

// CLDR #1605 - #1608
const eraValues$a = {
  narrow: ["క్రీ.పూ.", "క్రీ.శ."],
  abbreviated: ["క్రీ.పూ.", "క్రీ.శ."],
  wide: ["క్రీస్తు పూర్వం", "క్రీస్తుశకం"],
};

// CLDR #1613 - #1628
const quarterValues$a = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["త్రై1", "త్రై2", "త్రై3", "త్రై4"],
  wide: ["1వ త్రైమాసికం", "2వ త్రైమాసికం", "3వ త్రైమాసికం", "4వ త్రైమాసికం"],
};

// CLDR #1637 - #1708
const monthValues$a = {
  narrow: ["జ", "ఫి", "మా", "ఏ", "మే", "జూ", "జు", "ఆ", "సె", "అ", "న", "డి"],

  abbreviated: [
    "జన",
    "ఫిబ్ర",
    "మార్చి",
    "ఏప్రి",
    "మే",
    "జూన్",
    "జులై",
    "ఆగ",
    "సెప్టెం",
    "అక్టో",
    "నవం",
    "డిసెం",
  ],

  wide: [
    "జనవరి",
    "ఫిబ్రవరి",
    "మార్చి",
    "ఏప్రిల్",
    "మే",
    "జూన్",
    "జులై",
    "ఆగస్టు",
    "సెప్టెంబర్",
    "అక్టోబర్",
    "నవంబర్",
    "డిసెంబర్",
  ],
};

// CLDR #1709 - #1764
const dayValues$a = {
  narrow: ["ఆ", "సో", "మ", "బు", "గు", "శు", "శ"],
  short: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  abbreviated: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  wide: [
    "ఆదివారం",
    "సోమవారం",
    "మంగళవారం",
    "బుధవారం",
    "గురువారం",
    "శుక్రవారం",
    "శనివారం",
  ],
};

// CLDR #1767 - #1806
const dayPeriodValues$a = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి",
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి",
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి",
  },
};

const formattingDayPeriodValues$a = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి",
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి",
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి",
  },
};

const ordinalNumber$a = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + "వ";
};

(localize$a.localize = {
  ordinalNumber: ordinalNumber$a,

  era: (0, _index$I.buildLocalizeFn)({
    values: eraValues$a,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$I.buildLocalizeFn)({
    values: quarterValues$a,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$I.buildLocalizeFn)({
    values: monthValues$a,
    defaultWidth: "wide",
  }),

  day: (0, _index$I.buildLocalizeFn)({
    values: dayValues$a,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$I.buildLocalizeFn)({
    values: dayPeriodValues$a,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$a,
    defaultFormattingWidth: "wide",
  }),
});

var match$a = {};

match$a.match = void 0;

var _index$H = buildMatchFn$1;
var _index2$m = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$a = /^(\d+)(వ)?/i;
const parseOrdinalNumberPattern$a = /\d+/i;

const matchEraPatterns$a = {
  narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
  abbreviated:
    /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
  wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i,
};
const parseEraPatterns$a = {
  any: [/^(పూ|శ)/i, /^సా/i],
};

const matchQuarterPatterns$a = {
  narrow: /^[1234]/i,
  abbreviated: /^త్రై[1234]/i,
  wide: /^[1234](వ)? త్రైమాసికం/i,
};
const parseQuarterPatterns$a = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$a = {
  narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
  abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
  wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i,
};
const parseMonthPatterns$a = {
  narrow: [
    /^జ/i,
    /^ఫి/i,
    /^మా/i,
    /^ఏ/i,
    /^మే/i,
    /^జూ/i,
    /^జు/i,
    /^ఆ/i,
    /^సె/i,
    /^అ/i,
    /^న/i,
    /^డి/i,
  ],

  any: [
    /^జన/i,
    /^ఫి/i,
    /^మా/i,
    /^ఏ/i,
    /^మే/i,
    /^జూన్/i,
    /^జులై/i,
    /^ఆగ/i,
    /^సె/i,
    /^అ/i,
    /^న/i,
    /^డి/i,
  ],
};

const matchDayPatterns$a = {
  narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
  short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i,
};
const parseDayPatterns$a = {
  narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
  any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i],
};

const matchDayPeriodPatterns$a = {
  narrow:
    /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
  any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
};
const parseDayPeriodPatterns$a = {
  any: {
    am: /^పూర్వాహ్నం/i,
    pm: /^అపరాహ్నం/i,
    midnight: /^అర్ధ/i,
    noon: /^మిట్ట/i,
    morning: /ఉదయం/i,
    afternoon: /మధ్యాహ్నం/i,
    evening: /సాయంత్రం/i,
    night: /రాత్రి/i,
  },
};

(match$a.match = {
  ordinalNumber: (0, _index2$m.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$a,
    parsePattern: parseOrdinalNumberPattern$a,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$H.buildMatchFn)({
    matchPatterns: matchEraPatterns$a,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$a,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$H.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$a,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$a,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$H.buildMatchFn)({
    matchPatterns: matchMonthPatterns$a,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$a,
    defaultParseWidth: "any",
  }),

  day: (0, _index$H.buildMatchFn)({
    matchPatterns: matchDayPatterns$a,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$a,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$H.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$a,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$a,
    defaultParseWidth: "any",
  }),
});

te.te = void 0;
var _index$G = formatDistance$l;
var _index2$l = formatLong$a;
var _index3$a = formatRelative$l;
var _index4$a = localize$a;
var _index5$a = match$a;

/**
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum](https://github.com/kranthilakum)
 */
(te.te = {
  code: "te",
  formatDistance: _index$G.formatDistance,
  formatLong: _index2$l.formatLong,
  formatRelative: _index3$a.formatRelative,
  localize: _index4$a.localize,
  match: _index5$a.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var th = {};

var formatDistance$j = {};

formatDistance$j.formatDistance = void 0;

const formatDistanceLocale$9 = {
  lessThanXSeconds: {
    one: "น้อยกว่า 1 วินาที",
    other: "น้อยกว่า {{count}} วินาที",
  },

  xSeconds: {
    one: "1 วินาที",
    other: "{{count}} วินาที",
  },

  halfAMinute: "ครึ่งนาที",

  lessThanXMinutes: {
    one: "น้อยกว่า 1 นาที",
    other: "น้อยกว่า {{count}} นาที",
  },

  xMinutes: {
    one: "1 นาที",
    other: "{{count}} นาที",
  },

  aboutXHours: {
    one: "ประมาณ 1 ชั่วโมง",
    other: "ประมาณ {{count}} ชั่วโมง",
  },

  xHours: {
    one: "1 ชั่วโมง",
    other: "{{count}} ชั่วโมง",
  },

  xDays: {
    one: "1 วัน",
    other: "{{count}} วัน",
  },

  aboutXWeeks: {
    one: "ประมาณ 1 สัปดาห์",
    other: "ประมาณ {{count}} สัปดาห์",
  },

  xWeeks: {
    one: "1 สัปดาห์",
    other: "{{count}} สัปดาห์",
  },

  aboutXMonths: {
    one: "ประมาณ 1 เดือน",
    other: "ประมาณ {{count}} เดือน",
  },

  xMonths: {
    one: "1 เดือน",
    other: "{{count}} เดือน",
  },

  aboutXYears: {
    one: "ประมาณ 1 ปี",
    other: "ประมาณ {{count}} ปี",
  },

  xYears: {
    one: "1 ปี",
    other: "{{count}} ปี",
  },

  overXYears: {
    one: "มากกว่า 1 ปี",
    other: "มากกว่า {{count}} ปี",
  },

  almostXYears: {
    one: "เกือบ 1 ปี",
    other: "เกือบ {{count}} ปี",
  },
};

const formatDistance$i = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$9[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      if (token === "halfAMinute") {
        return "ใน" + result;
      } else {
        return "ใน " + result;
      }
    } else {
      return result + "ที่ผ่านมา";
    }
  }

  return result;
};
formatDistance$j.formatDistance = formatDistance$i;

var formatLong$9 = {};

formatLong$9.formatLong = void 0;
var _index$F = buildFormatLongFn$1;

const dateFormats$9 = {
  full: "วันEEEEที่ do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy",
};

const timeFormats$9 = {
  full: "H:mm:ss น. zzzz",
  long: "H:mm:ss น. z",
  medium: "H:mm:ss น.",
  short: "H:mm น.",
};

const dateTimeFormats$9 = {
  full: "{{date}} 'เวลา' {{time}}",
  long: "{{date}} 'เวลา' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$9.formatLong = {
  date: (0, _index$F.buildFormatLongFn)({
    formats: dateFormats$9,
    defaultWidth: "full",
  }),

  time: (0, _index$F.buildFormatLongFn)({
    formats: timeFormats$9,
    defaultWidth: "medium",
  }),

  dateTime: (0, _index$F.buildFormatLongFn)({
    formats: dateTimeFormats$9,
    defaultWidth: "full",
  }),
});

var formatRelative$j = {};

formatRelative$j.formatRelative = void 0;

const formatRelativeLocale$9 = {
  lastWeek: "eeee'ที่แล้วเวลา' p",
  yesterday: "'เมื่อวานนี้เวลา' p",
  today: "'วันนี้เวลา' p",
  tomorrow: "'พรุ่งนี้เวลา' p",
  nextWeek: "eeee 'เวลา' p",
  other: "P",
};

const formatRelative$i = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$9[token];
formatRelative$j.formatRelative = formatRelative$i;

var localize$9 = {};

localize$9.localize = void 0;
var _index$E = buildLocalizeFn$1;

const eraValues$9 = {
  narrow: ["B", "คศ"],
  abbreviated: ["BC", "ค.ศ."],
  wide: ["ปีก่อนคริสตกาล", "คริสต์ศักราช"],
};

const quarterValues$9 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ไตรมาสแรก", "ไตรมาสที่สอง", "ไตรมาสที่สาม", "ไตรมาสที่สี่"],
};

const dayValues$9 = {
  narrow: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  abbreviated: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  wide: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"],
};

const monthValues$9 = {
  narrow: [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ],

  abbreviated: [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค.",
  ],

  wide: [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม",
  ],
};

const dayPeriodValues$9 = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน",
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน",
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน",
  },
};

const formattingDayPeriodValues$9 = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน",
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน",
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน",
  },
};

const ordinalNumber$9 = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$9.localize = {
  ordinalNumber: ordinalNumber$9,

  era: (0, _index$E.buildLocalizeFn)({
    values: eraValues$9,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$E.buildLocalizeFn)({
    values: quarterValues$9,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$E.buildLocalizeFn)({
    values: monthValues$9,
    defaultWidth: "wide",
  }),

  day: (0, _index$E.buildLocalizeFn)({
    values: dayValues$9,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$E.buildLocalizeFn)({
    values: dayPeriodValues$9,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$9,
    defaultFormattingWidth: "wide",
  }),
});

var match$9 = {};

match$9.match = void 0;

var _index$D = buildMatchFn$1;
var _index2$k = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$9 = /^\d+/i;
const parseOrdinalNumberPattern$9 = /\d+/i;

const matchEraPatterns$9 = {
  narrow: /^([bB]|[aA]|คศ)/i,
  abbreviated:
    /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
  wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i,
};
const parseEraPatterns$9 = {
  any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i],
};

const matchQuarterPatterns$9 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^ไตรมาส(ที่)? ?[1234]/i,
};
const parseQuarterPatterns$9 = {
  any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i],
};

const matchMonthPatterns$9 = {
  narrow:
    /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
  abbreviated:
    /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
  wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i,
};
const parseMonthPatterns$9 = {
  wide: [
    /^มก/i,
    /^กุม/i,
    /^มี/i,
    /^เม/i,
    /^พฤษ/i,
    /^มิ/i,
    /^กรก/i,
    /^ส/i,
    /^กัน/i,
    /^ต/i,
    /^พฤศ/i,
    /^ธ/i,
  ],

  any: [
    /^ม\.?ค\.?/i,
    /^ก\.?พ\.?/i,
    /^มี\.?ค\.?/i,
    /^เม\.?ย\.?/i,
    /^พ\.?ค\.?/i,
    /^มิ\.?ย\.?/i,
    /^ก\.?ค\.?/i,
    /^ส\.?ค\.?/i,
    /^ก\.?ย\.?/i,
    /^ต\.?ค\.?/i,
    /^พ\.?ย\.?/i,
    /^ธ\.?ค\.?/i,
  ],
};

const matchDayPatterns$9 = {
  narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i,
};
const parseDayPatterns$9 = {
  wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
  any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i],
};

const matchDayPeriodPatterns$9 = {
  any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i,
};
const parseDayPeriodPatterns$9 = {
  any: {
    am: /^ก่อนเที่ยง/i,
    pm: /^หลังเที่ยง/i,
    midnight: /^เที่ยงคืน/i,
    noon: /^เที่ยง/i,
    morning: /เช้า/i,
    afternoon: /บ่าย/i,
    evening: /เย็น/i,
    night: /กลางคืน/i,
  },
};

(match$9.match = {
  ordinalNumber: (0, _index2$k.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$9,
    parsePattern: parseOrdinalNumberPattern$9,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$D.buildMatchFn)({
    matchPatterns: matchEraPatterns$9,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$9,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$D.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$9,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$9,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$D.buildMatchFn)({
    matchPatterns: matchMonthPatterns$9,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$9,
    defaultParseWidth: "any",
  }),

  day: (0, _index$D.buildMatchFn)({
    matchPatterns: matchDayPatterns$9,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$9,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$D.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$9,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$9,
    defaultParseWidth: "any",
  }),
});

th.th = void 0;
var _index$C = formatDistance$j;
var _index2$j = formatLong$9;
var _index3$9 = formatRelative$j;
var _index4$9 = localize$9;
var _index5$9 = match$9;

/**
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat](https://github.com/athivvat)
 * @author [@hawkup](https://github.com/hawkup)
 * @author  Jirawat I. [@nodtem66](https://github.com/nodtem66)
 */
(th.th = {
  code: "th",
  formatDistance: _index$C.formatDistance,
  formatLong: _index2$j.formatLong,
  formatRelative: _index3$9.formatRelative,
  localize: _index4$9.localize,
  match: _index5$9.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var tr = {};

var formatDistance$h = {};

formatDistance$h.formatDistance = void 0;

const formatDistanceLocale$8 = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az",
  },

  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye",
  },

  halfAMinute: "yarım dakika",

  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az",
  },

  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika",
  },

  aboutXHours: {
    one: "yaklaşık 1 saat",
    other: "yaklaşık {{count}} saat",
  },

  xHours: {
    one: "1 saat",
    other: "{{count}} saat",
  },

  xDays: {
    one: "1 gün",
    other: "{{count}} gün",
  },

  aboutXWeeks: {
    one: "yaklaşık 1 hafta",
    other: "yaklaşık {{count}} hafta",
  },

  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta",
  },

  aboutXMonths: {
    one: "yaklaşık 1 ay",
    other: "yaklaşık {{count}} ay",
  },

  xMonths: {
    one: "1 ay",
    other: "{{count}} ay",
  },

  aboutXYears: {
    one: "yaklaşık 1 yıl",
    other: "yaklaşık {{count}} yıl",
  },

  xYears: {
    one: "1 yıl",
    other: "{{count}} yıl",
  },

  overXYears: {
    one: "1 yıldan fazla",
    other: "{{count}} yıldan fazla",
  },

  almostXYears: {
    one: "neredeyse 1 yıl",
    other: "neredeyse {{count}} yıl",
  },
};

const formatDistance$g = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$8[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " sonra";
    } else {
      return result + " önce";
    }
  }

  return result;
};
formatDistance$h.formatDistance = formatDistance$g;

var formatLong$8 = {};

formatLong$8.formatLong = void 0;
var _index$B = buildFormatLongFn$1;

const dateFormats$8 = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy",
};

const timeFormats$8 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$8 = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$8.formatLong = {
  date: (0, _index$B.buildFormatLongFn)({
    formats: dateFormats$8,
    defaultWidth: "full",
  }),

  time: (0, _index$B.buildFormatLongFn)({
    formats: timeFormats$8,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$B.buildFormatLongFn)({
    formats: dateTimeFormats$8,
    defaultWidth: "full",
  }),
});

var formatRelative$h = {};

formatRelative$h.formatRelative = void 0;

const formatRelativeLocale$8 = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P",
};

const formatRelative$g = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$8[token];
formatRelative$h.formatRelative = formatRelative$g;

var localize$8 = {};

localize$8.localize = void 0;

var _index$A = buildLocalizeFn$1;

const eraValues$8 = {
  narrow: ["MÖ", "MS"],
  abbreviated: ["MÖ", "MS"],
  wide: ["Milattan Önce", "Milattan Sonra"],
};

const quarterValues$8 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1Ç", "2Ç", "3Ç", "4Ç"],
  wide: ["İlk çeyrek", "İkinci Çeyrek", "Üçüncü çeyrek", "Son çeyrek"],
};

const monthValues$8 = {
  narrow: ["O", "Ş", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: [
    "Oca",
    "Şub",
    "Mar",
    "Nis",
    "May",
    "Haz",
    "Tem",
    "Ağu",
    "Eyl",
    "Eki",
    "Kas",
    "Ara",
  ],

  wide: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık",
  ],
};

const dayValues$8 = {
  narrow: ["P", "P", "S", "Ç", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cts"],
  wide: [
    "Pazar",
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi",
  ],
};

const dayPeriodValues$8 = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge",
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece",
  },
  wide: {
    am: "Ö.Ö.",
    pm: "Ö.S.",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece",
  },
};

const formattingDayPeriodValues$8 = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge",
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin",
  },
  wide: {
    am: "ö.ö.",
    pm: "ö.s.",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin",
  },
};

const ordinalNumber$8 = (dirtyNumber, _options) => {
  const number = Number(dirtyNumber);
  return number + ".";
};

(localize$8.localize = {
  ordinalNumber: ordinalNumber$8,

  era: (0, _index$A.buildLocalizeFn)({
    values: eraValues$8,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$A.buildLocalizeFn)({
    values: quarterValues$8,
    defaultWidth: "wide",
    argumentCallback: (quarter) => Number(quarter) - 1,
  }),

  month: (0, _index$A.buildLocalizeFn)({
    values: monthValues$8,
    defaultWidth: "wide",
  }),

  day: (0, _index$A.buildLocalizeFn)({
    values: dayValues$8,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$A.buildLocalizeFn)({
    values: dayPeriodValues$8,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$8,
    defaultFormattingWidth: "wide",
  }),
});

var match$8 = {};

match$8.match = void 0;

var _index$z = buildMatchFn$1;
var _index2$i = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$8 = /^(\d+)(\.)?/i;
const parseOrdinalNumberPattern$8 = /\d+/i;

const matchEraPatterns$8 = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i,
};
const parseEraPatterns$8 = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i],
};

const matchQuarterPatterns$8 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i,
};
const parseQuarterPatterns$8 = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [
    /^(i|İ)lk çeyrek/i,
    /(i|İ)kinci çeyrek/i,
    /üçüncü çeyrek/i,
    /son çeyrek/i,
  ],
};

const matchMonthPatterns$8 = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i,
};
const parseMonthPatterns$8 = {
  narrow: [
    /^o/i,
    /^ş/i,
    /^m/i,
    /^n/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^a/i,
    /^e/i,
    /^e/i,
    /^k/i,
    /^a/i,
  ],

  any: [
    /^o/i,
    /^ş/i,
    /^mar/i,
    /^n/i,
    /^may/i,
    /^h/i,
    /^t/i,
    /^ağ/i,
    /^ey/i,
    /^ek/i,
    /^k/i,
    /^ar/i,
  ],
};

const matchDayPatterns$8 = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i,
};
const parseDayPatterns$8 = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [
    /^pazar(?!tesi)/i,
    /^pazartesi/i,
    /^salı/i,
    /^çarşamba/i,
    /^perşembe/i,
    /^cuma(?!rtesi)/i,
    /^cumartesi/i,
  ],
};

const matchDayPeriodPatterns$8 = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i,
};
const parseDayPeriodPatterns$8 = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i,
  },
};

(match$8.match = {
  ordinalNumber: (0, _index2$i.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$8,
    parsePattern: parseOrdinalNumberPattern$8,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: (0, _index$z.buildMatchFn)({
    matchPatterns: matchEraPatterns$8,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$8,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$z.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$8,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$8,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$z.buildMatchFn)({
    matchPatterns: matchMonthPatterns$8,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$8,
    defaultParseWidth: "any",
  }),

  day: (0, _index$z.buildMatchFn)({
    matchPatterns: matchDayPatterns$8,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$8,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$z.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$8,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$8,
    defaultParseWidth: "any",
  }),
});

tr.tr = void 0;
var _index$y = formatDistance$h;
var _index2$h = formatLong$8;
var _index3$8 = formatRelative$h;
var _index4$8 = localize$8;
var _index5$8 = match$8;

/**
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin](https://github.com/alpcanaydin)
 * @author Berkay Sargın [@berkaey](https://github.com/berkaey)
 * @author Fatih Bulut [@bulutfatih](https://github.com/bulutfatih)
 * @author Ismail Demirbilek [@dbtek](https://github.com/dbtek)
 * @author İsmail Kayar [@ikayar](https://github.com/ikayar)
 *
 *
 */
(tr.tr = {
  code: "tr",
  formatDistance: _index$y.formatDistance,
  formatLong: _index2$h.formatLong,
  formatRelative: _index3$8.formatRelative,
  localize: _index4$8.localize,
  match: _index5$8.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var ug = {};

var formatDistance$f = {};

formatDistance$f.formatDistance = void 0;

const formatDistanceLocale$7 = {
  lessThanXSeconds: {
    one: "بىر سىكۇنت ئىچىدە",
    other: "سىكۇنت ئىچىدە {{count}}",
  },

  xSeconds: {
    one: "بىر سىكۇنت",
    other: "سىكۇنت {{count}}",
  },

  halfAMinute: "يىرىم مىنۇت",

  lessThanXMinutes: {
    one: "بىر مىنۇت ئىچىدە",
    other: "مىنۇت ئىچىدە {{count}}",
  },

  xMinutes: {
    one: "بىر مىنۇت",
    other: "مىنۇت {{count}}",
  },

  aboutXHours: {
    one: "تەخمىنەن بىر سائەت",
    other: "سائەت {{count}} تەخمىنەن",
  },

  xHours: {
    one: "بىر سائەت",
    other: "سائەت {{count}}",
  },

  xDays: {
    one: "بىر كۈن",
    other: "كۈن {{count}}",
  },

  aboutXWeeks: {
    one: "تەخمىنەن بىرھەپتە",
    other: "ھەپتە {{count}} تەخمىنەن",
  },

  xWeeks: {
    one: "بىرھەپتە",
    other: "ھەپتە {{count}}",
  },

  aboutXMonths: {
    one: "تەخمىنەن بىر ئاي",
    other: "ئاي {{count}} تەخمىنەن",
  },

  xMonths: {
    one: "بىر ئاي",
    other: "ئاي {{count}}",
  },

  aboutXYears: {
    one: "تەخمىنەن بىر يىل",
    other: "يىل {{count}} تەخمىنەن",
  },

  xYears: {
    one: "بىر يىل",
    other: "يىل {{count}}",
  },

  overXYears: {
    one: "بىر يىلدىن ئارتۇق",
    other: "يىلدىن ئارتۇق {{count}}",
  },

  almostXYears: {
    one: "ئاساسەن بىر يىل",
    other: "يىل {{count}} ئاساسەن",
  },
};

const formatDistance$e = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$7[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result;
    } else {
      return result + " بولدى";
    }
  }

  return result;
};
formatDistance$f.formatDistance = formatDistance$e;

var formatLong$7 = {};

formatLong$7.formatLong = void 0;
var _index$x = buildFormatLongFn$1;

const dateFormats$7 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy",
};

const timeFormats$7 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a",
};

const dateTimeFormats$7 = {
  full: "{{date}} 'دە' {{time}}",
  long: "{{date}} 'دە' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$7.formatLong = {
  date: (0, _index$x.buildFormatLongFn)({
    formats: dateFormats$7,
    defaultWidth: "full",
  }),

  time: (0, _index$x.buildFormatLongFn)({
    formats: timeFormats$7,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$x.buildFormatLongFn)({
    formats: dateTimeFormats$7,
    defaultWidth: "full",
  }),
});

var formatRelative$f = {};

formatRelative$f.formatRelative = void 0;

const formatRelativeLocale$7 = {
  lastWeek: "'ئ‍ۆتكەن' eeee 'دە' p",
  yesterday: "'تۈنۈگۈن دە' p",
  today: "'بۈگۈن دە' p",
  tomorrow: "'ئەتە دە' p",
  nextWeek: "eeee 'دە' p",
  other: "P",
};

const formatRelative$e = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$7[token];
formatRelative$f.formatRelative = formatRelative$e;

var localize$7 = {};

localize$7.localize = void 0;
var _index$w = buildLocalizeFn$1;

const eraValues$7 = {
  narrow: ["ب", "ك"],
  abbreviated: ["ب", "ك"],
  wide: ["مىيلادىدىن بۇرۇن", "مىيلادىدىن كىيىن"],
};

const quarterValues$7 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1", "2", "3", "4"],
  wide: ["بىرىنجى چارەك", "ئىككىنجى چارەك", "ئۈچىنجى چارەك", "تۆتىنجى چارەك"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$7 = {
  narrow: ["ي", "ف", "م", "ا", "م", "ى", "ى", "ا", "س", "ۆ", "ن", "د"],
  abbreviated: [
    "يانۋار",
    "فېۋىرال",
    "مارت",
    "ئاپرىل",
    "ماي",
    "ئىيۇن",
    "ئىيول",
    "ئاۋغۇست",
    "سىنتەبىر",
    "ئۆكتەبىر",
    "نويابىر",
    "دىكابىر",
  ],

  wide: [
    "يانۋار",
    "فېۋىرال",
    "مارت",
    "ئاپرىل",
    "ماي",
    "ئىيۇن",
    "ئىيول",
    "ئاۋغۇست",
    "سىنتەبىر",
    "ئۆكتەبىر",
    "نويابىر",
    "دىكابىر",
  ],
};

const dayValues$7 = {
  narrow: ["ي", "د", "س", "چ", "پ", "ج", "ش"],
  short: ["ي", "د", "س", "چ", "پ", "ج", "ش"],
  abbreviated: [
    "يەكشەنبە",
    "دۈشەنبە",
    "سەيشەنبە",
    "چارشەنبە",
    "پەيشەنبە",
    "جۈمە",
    "شەنبە",
  ],

  wide: [
    "يەكشەنبە",
    "دۈشەنبە",
    "سەيشەنبە",
    "چارشەنبە",
    "پەيشەنبە",
    "جۈمە",
    "شەنبە",
  ],
};

const dayPeriodValues$7 = {
  narrow: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە",
  },
  abbreviated: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە",
  },
  wide: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە",
  },
};

const formattingDayPeriodValues$7 = {
  narrow: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە",
  },
  abbreviated: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە",
  },
  wide: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە",
  },
};

const ordinalNumber$7 = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$7.localize = {
  ordinalNumber: ordinalNumber$7,

  era: (0, _index$w.buildLocalizeFn)({
    values: eraValues$7,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$w.buildLocalizeFn)({
    values: quarterValues$7,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$w.buildLocalizeFn)({
    values: monthValues$7,
    defaultWidth: "wide",
  }),

  day: (0, _index$w.buildLocalizeFn)({
    values: dayValues$7,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$w.buildLocalizeFn)({
    values: dayPeriodValues$7,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$7,
    defaultFormattingWidth: "wide",
  }),
});

var match$7 = {};

match$7.match = void 0;

var _index$v = buildMatchFn$1;
var _index2$g = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$7 = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern$7 = /\d+/i;

const matchEraPatterns$7 = {
  narrow: /^(ب|ك)/i,
  wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i,
};
const parseEraPatterns$7 = {
  any: [/^بۇرۇن/i, /^كىيىن/i],
};

const matchQuarterPatterns$7 = {
  narrow: /^[1234]/i,
  abbreviated: /^چ[1234]/i,
  wide: /^چارەك [1234]/i,
};
const parseQuarterPatterns$7 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$7 = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[يفمئامئ‍ئاسۆند]/i,
  abbreviated:
    /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
  wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
};
const parseMonthPatterns$7 = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^ا/i,
    /^م/i,
    /^ى‍/i,
    /^ى‍/i,
    /^ا‍/i,
    /^س/i,
    /^ۆ/i,
    /^ن/i,
    /^د/i,
  ],

  any: [
    /^يان/i,
    /^فېۋ/i,
    /^مار/i,
    /^ئاپ/i,
    /^ماي/i,
    /^ئىيۇن/i,
    /^ئىيول/i,
    /^ئاۋ/i,
    /^سىن/i,
    /^ئۆك/i,
    /^نوي/i,
    /^دىك/i,
  ],
};

const matchDayPatterns$7 = {
  narrow: /^[دسچپجشي]/i,
  short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i,
};
const parseDayPatterns$7 = {
  narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
};

const matchDayPeriodPatterns$7 = {
  narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
  any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
};
const parseDayPeriodPatterns$7 = {
  any: {
    am: /^ئە/i,
    pm: /^چ/i,
    midnight: /^ك/i,
    noon: /^چ/i,
    morning: /ئەتىگەن/i,
    afternoon: /چۈشتىن كىيىن/i,
    evening: /ئاخشىم/i,
    night: /كىچە/i,
  },
};

(match$7.match = {
  ordinalNumber: (0, _index2$g.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$7,
    parsePattern: parseOrdinalNumberPattern$7,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$v.buildMatchFn)({
    matchPatterns: matchEraPatterns$7,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$7,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$v.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$7,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$7,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$v.buildMatchFn)({
    matchPatterns: matchMonthPatterns$7,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$7,
    defaultParseWidth: "any",
  }),

  day: (0, _index$v.buildMatchFn)({
    matchPatterns: matchDayPatterns$7,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$7,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$v.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$7,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$7,
    defaultParseWidth: "any",
  }),
});

ug.ug = void 0;
var _index$u = formatDistance$f;
var _index2$f = formatLong$7;
var _index3$7 = formatRelative$f;
var _index4$7 = localize$7;
var _index5$7 = match$7;

/**
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly](https://github.com/abduwaly)
 */
(ug.ug = {
  code: "ug",
  formatDistance: _index$u.formatDistance,
  formatLong: _index2$f.formatLong,
  formatRelative: _index3$7.formatRelative,
  localize: _index4$7.localize,
  match: _index5$7.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var uk = {};

var formatDistance$d = {};

formatDistance$d.formatDistance = void 0;

function declension(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  const rem10 = count % 10;
  const rem100 = count % 100;

  // 1, 21, 31, ...
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));

    // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));

    // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}

function buildLocalizeTokenFn(scheme) {
  return (count, options) => {
    if (options && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension(scheme.future, count);
        } else {
          return "за " + declension(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension(scheme.past, count);
        } else {
          return declension(scheme.regular, count) + " тому";
        }
      }
    } else {
      return declension(scheme.regular, count);
    }
  };
}

const halfAtMinute = (_, options) => {
  if (options && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "за півхвилини";
    } else {
      return "півхвилини тому";
    }
  }

  return "півхвилини";
};

const formatDistanceLocale$6 = {
  lessThanXSeconds: buildLocalizeTokenFn({
    regular: {
      one: "менше секунди",
      singularNominative: "менше {{count}} секунди",
      singularGenitive: "менше {{count}} секунд",
      pluralGenitive: "менше {{count}} секунд",
    },
    future: {
      one: "менше, ніж за секунду",
      singularNominative: "менше, ніж за {{count}} секунду",
      singularGenitive: "менше, ніж за {{count}} секунди",
      pluralGenitive: "менше, ніж за {{count}} секунд",
    },
  }),

  xSeconds: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунди",
      pluralGenitive: "{{count}} секунд",
    },
    past: {
      singularNominative: "{{count}} секунду тому",
      singularGenitive: "{{count}} секунди тому",
      pluralGenitive: "{{count}} секунд тому",
    },
    future: {
      singularNominative: "за {{count}} секунду",
      singularGenitive: "за {{count}} секунди",
      pluralGenitive: "за {{count}} секунд",
    },
  }),

  halfAMinute: halfAtMinute,

  lessThanXMinutes: buildLocalizeTokenFn({
    regular: {
      one: "менше хвилини",
      singularNominative: "менше {{count}} хвилини",
      singularGenitive: "менше {{count}} хвилин",
      pluralGenitive: "менше {{count}} хвилин",
    },
    future: {
      one: "менше, ніж за хвилину",
      singularNominative: "менше, ніж за {{count}} хвилину",
      singularGenitive: "менше, ніж за {{count}} хвилини",
      pluralGenitive: "менше, ніж за {{count}} хвилин",
    },
  }),

  xMinutes: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} хвилина",
      singularGenitive: "{{count}} хвилини",
      pluralGenitive: "{{count}} хвилин",
    },
    past: {
      singularNominative: "{{count}} хвилину тому",
      singularGenitive: "{{count}} хвилини тому",
      pluralGenitive: "{{count}} хвилин тому",
    },
    future: {
      singularNominative: "за {{count}} хвилину",
      singularGenitive: "за {{count}} хвилини",
      pluralGenitive: "за {{count}} хвилин",
    },
  }),

  aboutXHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: "близько {{count}} години",
      singularGenitive: "близько {{count}} годин",
      pluralGenitive: "близько {{count}} годин",
    },
    future: {
      singularNominative: "приблизно за {{count}} годину",
      singularGenitive: "приблизно за {{count}} години",
      pluralGenitive: "приблизно за {{count}} годин",
    },
  }),

  xHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} годину",
      singularGenitive: "{{count}} години",
      pluralGenitive: "{{count}} годин",
    },
  }),

  xDays: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} днi",
      pluralGenitive: "{{count}} днів",
    },
  }),

  aboutXWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: "близько {{count}} тижня",
      singularGenitive: "близько {{count}} тижнів",
      pluralGenitive: "близько {{count}} тижнів",
    },
    future: {
      singularNominative: "приблизно за {{count}} тиждень",
      singularGenitive: "приблизно за {{count}} тижні",
      pluralGenitive: "приблизно за {{count}} тижнів",
    },
  }),

  xWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} тиждень",
      singularGenitive: "{{count}} тижні",
      pluralGenitive: "{{count}} тижнів",
    },
  }),

  aboutXMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: "близько {{count}} місяця",
      singularGenitive: "близько {{count}} місяців",
      pluralGenitive: "близько {{count}} місяців",
    },
    future: {
      singularNominative: "приблизно за {{count}} місяць",
      singularGenitive: "приблизно за {{count}} місяці",
      pluralGenitive: "приблизно за {{count}} місяців",
    },
  }),

  xMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} місяць",
      singularGenitive: "{{count}} місяці",
      pluralGenitive: "{{count}} місяців",
    },
  }),

  aboutXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: "близько {{count}} року",
      singularGenitive: "близько {{count}} років",
      pluralGenitive: "близько {{count}} років",
    },
    future: {
      singularNominative: "приблизно за {{count}} рік",
      singularGenitive: "приблизно за {{count}} роки",
      pluralGenitive: "приблизно за {{count}} років",
    },
  }),

  xYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: "{{count}} рік",
      singularGenitive: "{{count}} роки",
      pluralGenitive: "{{count}} років",
    },
  }),

  overXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: "більше {{count}} року",
      singularGenitive: "більше {{count}} років",
      pluralGenitive: "більше {{count}} років",
    },
    future: {
      singularNominative: "більше, ніж за {{count}} рік",
      singularGenitive: "більше, ніж за {{count}} роки",
      pluralGenitive: "більше, ніж за {{count}} років",
    },
  }),

  almostXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: "майже {{count}} рік",
      singularGenitive: "майже {{count}} роки",
      pluralGenitive: "майже {{count}} років",
    },
    future: {
      singularNominative: "майже за {{count}} рік",
      singularGenitive: "майже за {{count}} роки",
      pluralGenitive: "майже за {{count}} років",
    },
  }),
};

const formatDistance$c = (token, count, options) => {
  options = options || {};

  return formatDistanceLocale$6[token](count, options);
};
formatDistance$d.formatDistance = formatDistance$c;

var formatLong$6 = {};

formatLong$6.formatLong = void 0;
var _index$t = buildFormatLongFn$1;

const dateFormats$6 = {
  full: "EEEE, do MMMM y 'р.'",
  long: "do MMMM y 'р.'",
  medium: "d MMM y 'р.'",
  short: "dd.MM.y",
};

const timeFormats$6 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$6 = {
  full: "{{date}} 'о' {{time}}",
  long: "{{date}} 'о' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}",
};

(formatLong$6.formatLong = {
  date: (0, _index$t.buildFormatLongFn)({
    formats: dateFormats$6,
    defaultWidth: "full",
  }),

  time: (0, _index$t.buildFormatLongFn)({
    formats: timeFormats$6,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$t.buildFormatLongFn)({
    formats: dateTimeFormats$6,
    defaultWidth: "full",
  }),
});

var formatRelative$d = {};

formatRelative$d.formatRelative = void 0;
var _index$s = isSameWeek$1;
var _index2$e = toDate$1;

const accusativeWeekdays = [
  "неділю",
  "понеділок",
  "вівторок",
  "середу",
  "четвер",
  "п’ятницю",
  "суботу",
];

function lastWeek(day) {
  const weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у минулу " + weekday + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у минулий " + weekday + " о' p";
  }
}

function thisWeek(day) {
  const weekday = accusativeWeekdays[day];

  return "'у " + weekday + " о' p";
}

function nextWeek(day) {
  const weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступну " + weekday + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у наступний " + weekday + " о' p";
  }
}

const lastWeekFormat = (dirtyDate, baseDate, options) => {
  const date = (0, _index2$e.toDate)(dirtyDate);
  const day = date.getDay();

  if ((0, _index$s.isSameWeek)(date, baseDate, options)) {
    return thisWeek(day);
  } else {
    return lastWeek(day);
  }
};

const nextWeekFormat = (dirtyDate, baseDate, options) => {
  const date = (0, _index2$e.toDate)(dirtyDate);
  const day = date.getDay();
  if ((0, _index$s.isSameWeek)(date, baseDate, options)) {
    return thisWeek(day);
  } else {
    return nextWeek(day);
  }
};

const formatRelativeLocale$6 = {
  lastWeek: lastWeekFormat,
  yesterday: "'вчора о' p",
  today: "'сьогодні о' p",
  tomorrow: "'завтра о' p",
  nextWeek: nextWeekFormat,
  other: "P",
};

const formatRelative$c = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$6[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$d.formatRelative = formatRelative$c;

var localize$6 = {};

localize$6.localize = void 0;
var _index$r = buildLocalizeFn$1;

const eraValues$6 = {
  narrow: ["до н.е.", "н.е."],
  abbreviated: ["до н. е.", "н. е."],
  wide: ["до нашої ери", "нашої ери"],
};

const quarterValues$6 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"],
};

const monthValues$6 = {
  // ДСТУ 3582:2013
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: [
    "січ.",
    "лют.",
    "берез.",
    "квіт.",
    "трав.",
    "черв.",
    "лип.",
    "серп.",
    "верес.",
    "жовт.",
    "листоп.",
    "груд.",
  ],

  wide: [
    "січень",
    "лютий",
    "березень",
    "квітень",
    "травень",
    "червень",
    "липень",
    "серпень",
    "вересень",
    "жовтень",
    "листопад",
    "грудень",
  ],
};

const formattingMonthValues$1 = {
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: [
    "січ.",
    "лют.",
    "берез.",
    "квіт.",
    "трав.",
    "черв.",
    "лип.",
    "серп.",
    "верес.",
    "жовт.",
    "листоп.",
    "груд.",
  ],

  wide: [
    "січня",
    "лютого",
    "березня",
    "квітня",
    "травня",
    "червня",
    "липня",
    "серпня",
    "вересня",
    "жовтня",
    "листопада",
    "грудня",
  ],
};

const dayValues$6 = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вів", "сер", "чтв", "птн", "суб"],
  wide: [
    "неділя",
    "понеділок",
    "вівторок",
    "середа",
    "четвер",
    "п’ятниця",
    "субота",
  ],
};

const dayPeriodValues$6 = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранок",
    afternoon: "день",
    evening: "вечір",
    night: "ніч",
  },
};

const formattingDayPeriodValues$6 = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі",
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі",
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі",
  },
};

const ordinalNumber$6 = (dirtyNumber, options) => {
  const unit = String(options?.unit);
  const number = Number(dirtyNumber);
  let suffix;

  if (unit === "date") {
    if (number === 3 || number === 23) {
      suffix = "-є";
    } else {
      suffix = "-е";
    }
  } else if (unit === "minute" || unit === "second" || unit === "hour") {
    suffix = "-а";
  } else {
    suffix = "-й";
  }

  return number + suffix;
};

(localize$6.localize = {
  ordinalNumber: ordinalNumber$6,

  era: (0, _index$r.buildLocalizeFn)({
    values: eraValues$6,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$r.buildLocalizeFn)({
    values: quarterValues$6,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$r.buildLocalizeFn)({
    values: monthValues$6,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues$1,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$r.buildLocalizeFn)({
    values: dayValues$6,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$r.buildLocalizeFn)({
    values: dayPeriodValues$6,
    defaultWidth: "any",
    formattingValues: formattingDayPeriodValues$6,
    defaultFormattingWidth: "wide",
  }),
});

var match$6 = {};

match$6.match = void 0;

var _index$q = buildMatchFn$1;
var _index2$d = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$6 = /^(\d+)(-?(е|й|є|а|я))?/i;
const parseOrdinalNumberPattern$6 = /\d+/i;

const matchEraPatterns$6 = {
  narrow: /^((до )?н\.?\s?е\.?)/i,
  abbreviated: /^((до )?н\.?\s?е\.?)/i,
  wide: /^(до нашої ери|нашої ери|наша ера)/i,
};

const parseEraPatterns$6 = {
  any: [/^д/i, /^н/i],
};

const matchQuarterPatterns$6 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
  wide: /^[1234](-?[иі]?й?)? квартал/i,
};

const parseQuarterPatterns$6 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$6 = {
  narrow: /^[слбктчвжг]/i,
  abbreviated:
    /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
  wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i,
};

const parseMonthPatterns$6 = {
  narrow: [
    /^с/i,
    /^л/i,
    /^б/i,
    /^к/i,
    /^т/i,
    /^ч/i,
    /^л/i,
    /^с/i,
    /^в/i,
    /^ж/i,
    /^л/i,
    /^г/i,
  ],

  any: [
    /^сі/i,
    /^лю/i,
    /^б/i,
    /^к/i,
    /^т/i,
    /^ч/i,
    /^лип/i,
    /^се/i,
    /^в/i,
    /^ж/i,
    /^лис/i,
    /^г/i,
  ],
};

const matchDayPatterns$6 = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
  abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
  wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i,
};

const parseDayPatterns$6 = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i],
};

const matchDayPeriodPatterns$6 = {
  narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i,
};

const parseDayPeriodPatterns$6 = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^півн/i,
    noon: /^пол/i,
    morning: /^р/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i,
  },
};

(match$6.match = {
  ordinalNumber: (0, _index2$d.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$6,
    parsePattern: parseOrdinalNumberPattern$6,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$q.buildMatchFn)({
    matchPatterns: matchEraPatterns$6,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$6,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$q.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$6,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$6,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$q.buildMatchFn)({
    matchPatterns: matchMonthPatterns$6,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$6,
    defaultParseWidth: "any",
  }),

  day: (0, _index$q.buildMatchFn)({
    matchPatterns: matchDayPatterns$6,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$6,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$q.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$6,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$6,
    defaultParseWidth: "any",
  }),
});

uk.uk = void 0;
var _index$p = formatDistance$d;
var _index2$c = formatLong$6;
var _index3$6 = formatRelative$d;
var _index4$6 = localize$6;
var _index5$6 = match$6;

/**
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk](https://github.com/korzhyk)
 * @author Andriy Shcherbyak [@shcherbyakdev](https://github.com/shcherbyakdev)
 */
(uk.uk = {
  code: "uk",
  formatDistance: _index$p.formatDistance,
  formatLong: _index2$c.formatLong,
  formatRelative: _index3$6.formatRelative,
  localize: _index4$6.localize,
  match: _index5$6.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var uz = {};

var formatDistance$b = {};

formatDistance$b.formatDistance = void 0;

const formatDistanceLocale$5 = {
  lessThanXSeconds: {
    one: "sekunddan kam",
    other: "{{count}} sekunddan kam",
  },

  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekund",
  },

  halfAMinute: "yarim minut",

  lessThanXMinutes: {
    one: "bir minutdan kam",
    other: "{{count}} minutdan kam",
  },

  xMinutes: {
    one: "1 minut",
    other: "{{count}} minut",
  },

  aboutXHours: {
    one: "tahminan 1 soat",
    other: "tahminan {{count}} soat",
  },

  xHours: {
    one: "1 soat",
    other: "{{count}} soat",
  },

  xDays: {
    one: "1 kun",
    other: "{{count}} kun",
  },

  aboutXWeeks: {
    one: "tahminan 1 hafta",
    other: "tahminan {{count}} hafta",
  },

  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta",
  },

  aboutXMonths: {
    one: "tahminan 1 oy",
    other: "tahminan {{count}} oy",
  },

  xMonths: {
    one: "1 oy",
    other: "{{count}} oy",
  },

  aboutXYears: {
    one: "tahminan 1 yil",
    other: "tahminan {{count}} yil",
  },

  xYears: {
    one: "1 yil",
    other: "{{count}} yil",
  },

  overXYears: {
    one: "1 yildan ko'p",
    other: "{{count}} yildan ko'p",
  },

  almostXYears: {
    one: "deyarli 1 yil",
    other: "deyarli {{count}} yil",
  },
};

const formatDistance$a = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$5[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " dan keyin";
    } else {
      return result + " oldin";
    }
  }

  return result;
};
formatDistance$b.formatDistance = formatDistance$a;

var formatLong$5 = {};

formatLong$5.formatLong = void 0;
var _index$o = buildFormatLongFn$1;

const dateFormats$5 = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy",
};

const timeFormats$5 = {
  full: "h:mm:ss zzzz",
  long: "h:mm:ss z",
  medium: "h:mm:ss",
  short: "h:mm",
};

const dateTimeFormats$5 = {
  any: "{{date}}, {{time}}",
};

(formatLong$5.formatLong = {
  date: (0, _index$o.buildFormatLongFn)({
    formats: dateFormats$5,
    defaultWidth: "full",
  }),

  time: (0, _index$o.buildFormatLongFn)({
    formats: timeFormats$5,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$o.buildFormatLongFn)({
    formats: dateTimeFormats$5,
    defaultWidth: "any",
  }),
});

var formatRelative$b = {};

formatRelative$b.formatRelative = void 0;

const formatRelativeLocale$5 = {
  lastWeek: "'oldingi' eeee p 'da'",
  yesterday: "'kecha' p 'da'",
  today: "'bugun' p 'da'",
  tomorrow: "'ertaga' p 'da'",
  nextWeek: "eeee p 'da'",
  other: "P",
};

const formatRelative$a = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$5[token];
formatRelative$b.formatRelative = formatRelative$a;

var localize$5 = {};

localize$5.localize = void 0;
var _index$n = buildLocalizeFn$1;

const eraValues$5 = {
  narrow: ["M.A", "M."],
  abbreviated: ["M.A", "M."],
  wide: ["Miloddan Avvalgi", "Milodiy"],
};

const quarterValues$5 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["CH.1", "CH.2", "CH.3", "CH.4"],
  wide: ["1-chi chorak", "2-chi chorak", "3-chi chorak", "4-chi chorak"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$5 = {
  narrow: ["Y", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Yan",
    "Fev",
    "Mar",
    "Apr",
    "May",
    "Iyun",
    "Iyul",
    "Avg",
    "Sen",
    "Okt",
    "Noy",
    "Dek",
  ],

  wide: [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "Iyun",
    "Iyul",
    "Avgust",
    "Sentabr",
    "Oktabr",
    "Noyabr",
    "Dekabr",
  ],
};

const dayValues$5 = {
  narrow: ["Y", "D", "S", "CH", "P", "J", "SH"],
  short: ["Ya", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
  abbreviated: ["Yak", "Dush", "Sesh", "Chor", "Pay", "Jum", "Shan"],
  wide: [
    "Yakshanba",
    "Dushanba",
    "Seshanba",
    "Chorshanba",
    "Payshanba",
    "Juma",
    "Shanba",
  ],
};

const dayPeriodValues$5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun",
  },
};

const formattingDayPeriodValues$5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun",
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun",
  },
};

const ordinalNumber$5 = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$5.localize = {
  ordinalNumber: ordinalNumber$5,

  era: (0, _index$n.buildLocalizeFn)({
    values: eraValues$5,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$n.buildLocalizeFn)({
    values: quarterValues$5,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$n.buildLocalizeFn)({
    values: monthValues$5,
    defaultWidth: "wide",
  }),

  day: (0, _index$n.buildLocalizeFn)({
    values: dayValues$5,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$n.buildLocalizeFn)({
    values: dayPeriodValues$5,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$5,
    defaultFormattingWidth: "wide",
  }),
});

var match$5 = {};

match$5.match = void 0;

var _index$m = buildMatchFn$1;
var _index2$b = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$5 = /^(\d+)(chi)?/i;
const parseOrdinalNumberPattern$5 = /\d+/i;

const matchEraPatterns$5 = {
  narrow: /^(m\.a|m\.)/i,
  abbreviated: /^(m\.a\.?\s?m\.?)/i,
  wide: /^(miloddan avval|miloddan keyin)/i,
};
const parseEraPatterns$5 = {
  any: [/^b/i, /^(a|c)/i],
};

const matchQuarterPatterns$5 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](chi)? chorak/i,
};
const parseQuarterPatterns$5 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$5 = {
  narrow: /^[yfmasond]/i,
  abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
  wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i,
};
const parseMonthPatterns$5 = {
  narrow: [
    /^y/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^i/i,
    /^i/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],

  any: [
    /^ya/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^iyun/i,
    /^iyul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i,
  ],
};

const matchDayPatterns$5 = {
  narrow: /^[ydschj]/i,
  short: /^(ya|du|se|cho|pa|ju|sha)/i,
  abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
  wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i,
};
const parseDayPatterns$5 = {
  narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
  any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
};

const matchDayPeriodPatterns$5 = {
  narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
  any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i,
};
const parseDayPeriodPatterns$5 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^y\.t/i,
    noon: /^pe/i,
    morning: /ertalab/i,
    afternoon: /tushdan keyin/i,
    evening: /kechqurun/i,
    night: /tun/i,
  },
};

(match$5.match = {
  ordinalNumber: (0, _index2$b.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$5,
    parsePattern: parseOrdinalNumberPattern$5,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$m.buildMatchFn)({
    matchPatterns: matchEraPatterns$5,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$5,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$m.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$5,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$5,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$m.buildMatchFn)({
    matchPatterns: matchMonthPatterns$5,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$5,
    defaultParseWidth: "any",
  }),

  day: (0, _index$m.buildMatchFn)({
    matchPatterns: matchDayPatterns$5,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$5,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$m.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$5,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$5,
    defaultParseWidth: "any",
  }),
});

uz.uz = void 0;
var _index$l = formatDistance$b;
var _index2$a = formatLong$5;
var _index3$5 = formatRelative$b;
var _index4$5 = localize$5;
var _index5$5 = match$5;

/**
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali](https://github.com/Mukhammadali)
 */
(uz.uz = {
  code: "uz",
  formatDistance: _index$l.formatDistance,
  formatLong: _index2$a.formatLong,
  formatRelative: _index3$5.formatRelative,
  localize: _index4$5.localize,
  match: _index5$5.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var uzCyrl = {};

var formatDistance$9 = {};

formatDistance$9.formatDistance = void 0;

const formatDistanceLocale$4 = {
  lessThanXSeconds: {
    one: "1 сониядан кам",
    other: "{{count}} сониядан кам",
  },

  xSeconds: {
    one: "1 сония",
    other: "{{count}} сония",
  },

  halfAMinute: "ярим дақиқа",

  lessThanXMinutes: {
    one: "1 дақиқадан кам",
    other: "{{count}} дақиқадан кам",
  },

  xMinutes: {
    one: "1 дақиқа",
    other: "{{count}} дақиқа",
  },

  aboutXHours: {
    one: "тахминан 1 соат",
    other: "тахминан {{count}} соат",
  },

  xHours: {
    one: "1 соат",
    other: "{{count}} соат",
  },

  xDays: {
    one: "1 кун",
    other: "{{count}} кун",
  },

  aboutXWeeks: {
    one: "тахминан 1 хафта",
    other: "тахминан {{count}} хафта",
  },

  xWeeks: {
    one: "1 хафта",
    other: "{{count}} хафта",
  },

  aboutXMonths: {
    one: "тахминан 1 ой",
    other: "тахминан {{count}} ой",
  },

  xMonths: {
    one: "1 ой",
    other: "{{count}} ой",
  },

  aboutXYears: {
    one: "тахминан 1 йил",
    other: "тахминан {{count}} йил",
  },

  xYears: {
    one: "1 йил",
    other: "{{count}} йил",
  },

  overXYears: {
    one: "1 йилдан кўп",
    other: "{{count}} йилдан кўп",
  },

  almostXYears: {
    one: "деярли 1 йил",
    other: "деярли {{count}} йил",
  },
};

const formatDistance$8 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$4[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + "дан кейин";
    } else {
      return result + " олдин";
    }
  }

  return result;
};
formatDistance$9.formatDistance = formatDistance$8;

var formatLong$4 = {};

formatLong$4.formatLong = void 0;
var _index$k = buildFormatLongFn$1;

const dateFormats$4 = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy",
};

const timeFormats$4 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm",
};

const dateTimeFormats$4 = {
  any: "{{date}}, {{time}}",
};

(formatLong$4.formatLong = {
  date: (0, _index$k.buildFormatLongFn)({
    formats: dateFormats$4,
    defaultWidth: "full",
  }),

  time: (0, _index$k.buildFormatLongFn)({
    formats: timeFormats$4,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$k.buildFormatLongFn)({
    formats: dateTimeFormats$4,
    defaultWidth: "any",
  }),
});

var formatRelative$9 = {};

formatRelative$9.formatRelative = void 0;

const formatRelativeLocale$4 = {
  lastWeek: "'ўтган' eeee p 'да'",
  yesterday: "'кеча' p 'да'",
  today: "'бугун' p 'да'",
  tomorrow: "'эртага' p 'да'",
  nextWeek: "eeee p 'да'",
  other: "P",
};

const formatRelative$8 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$4[token];
formatRelative$9.formatRelative = formatRelative$8;

var localize$4 = {};

localize$4.localize = void 0;
var _index$j = buildLocalizeFn$1;

const eraValues$4 = {
  narrow: ["М.А", "М"],
  abbreviated: ["М.А", "М"],
  wide: ["Милоддан Аввалги", "Милодий"],
};

const quarterValues$4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-чор.", "2-чор.", "3-чор.", "4-чор."],
  wide: ["1-чорак", "2-чорак", "3-чорак", "4-чорак"],
};

const monthValues$4 = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв",
    "фев",
    "мар",
    "апр",
    "май",
    "июн",
    "июл",
    "авг",
    "сен",
    "окт",
    "ноя",
    "дек",
  ],

  wide: [
    "январ",
    "феврал",
    "март",
    "апрел",
    "май",
    "июн",
    "июл",
    "август",
    "сентабр",
    "октабр",
    "ноябр",
    "декабр",
  ],
};

const dayValues$4 = {
  narrow: ["Я", "Д", "С", "Ч", "П", "Ж", "Ш"],
  short: ["як", "ду", "се", "чо", "па", "жу", "ша"],
  abbreviated: ["якш", "душ", "сеш", "чор", "пай", "жум", "шан"],
  wide: [
    "якшанба",
    "душанба",
    "сешанба",
    "чоршанба",
    "пайшанба",
    "жума",
    "шанба",
  ],
};

const dayPeriodValues$4 = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун",
  },
};

const formattingDayPeriodValues$4 = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун",
  },
};

const ordinalNumber$4 = (dirtyNumber, _options) => {
  return String(dirtyNumber);
};

(localize$4.localize = {
  ordinalNumber: ordinalNumber$4,

  era: (0, _index$j.buildLocalizeFn)({
    values: eraValues$4,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$j.buildLocalizeFn)({
    values: quarterValues$4,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$j.buildLocalizeFn)({
    values: monthValues$4,
    defaultWidth: "wide",
  }),

  day: (0, _index$j.buildLocalizeFn)({
    values: dayValues$4,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$j.buildLocalizeFn)({
    values: dayPeriodValues$4,
    defaultWidth: "any",
    formattingValues: formattingDayPeriodValues$4,
    defaultFormattingWidth: "any",
  }),
});

var match$4 = {};

match$4.match = void 0;

var _index$i = buildMatchFn$1;
var _index2$9 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$4 = /^(\d+)(чи)?/i;
const parseOrdinalNumberPattern$4 = /\d+/i;

const matchEraPatterns$4 = {
  narrow: /^(м\.а|м\.)/i,
  abbreviated: /^(м\.а|м\.)/i,
  wide: /^(милоддан аввал|милоддан кейин)/i,
};
const parseEraPatterns$4 = {
  any: [/^м/i, /^а/i],
};

const matchQuarterPatterns$4 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-чор./i,
  wide: /^[1234]-чорак/i,
};
const parseQuarterPatterns$4 = {
  any: [/1/i, /2/i, /3/i, /4/i],
};

const matchMonthPatterns$4 = {
  narrow: /^[яфмамииасонд]/i,
  abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
  wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i,
};
const parseMonthPatterns$4 = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i,
  ],

  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^май/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i,
  ],
};

const matchDayPatterns$4 = {
  narrow: /^[ядсчпжш]/i,
  short: /^(як|ду|се|чо|па|жу|ша)/i,
  abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
  wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i,
};
const parseDayPatterns$4 = {
  narrow: [/^я/i, /^д/i, /^с/i, /^ч/i, /^п/i, /^ж/i, /^ш/i],
  any: [/^як/i, /^ду/i, /^се/i, /^чор/i, /^пай/i, /^жу/i, /^шан/i],
};

const matchDayPeriodPatterns$4 = {
  any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i,
};
const parseDayPeriodPatterns$4 = {
  any: {
    am: /^п\.о\./i,
    pm: /^п\.к\./i,
    midnight: /^ярим тун/i,
    noon: /^пешиндан кейин/i,
    morning: /эрталаб/i,
    afternoon: /пешиндан кейин/i,
    evening: /кечаси/i,
    night: /тун/i,
  },
};

(match$4.match = {
  ordinalNumber: (0, _index2$9.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$4,
    parsePattern: parseOrdinalNumberPattern$4,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$i.buildMatchFn)({
    matchPatterns: matchEraPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$4,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$i.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$4,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$i.buildMatchFn)({
    matchPatterns: matchMonthPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$4,
    defaultParseWidth: "any",
  }),

  day: (0, _index$i.buildMatchFn)({
    matchPatterns: matchDayPatterns$4,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$4,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$i.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$4,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$4,
    defaultParseWidth: "any",
  }),
});

uzCyrl.uzCyrl = void 0;
var _index$h = formatDistance$9;
var _index2$8 = formatLong$4;
var _index3$4 = formatRelative$9;
var _index4$4 = localize$4;
var _index5$4 = match$4;

/**
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28](https://github.com/kamronbek28)
 */
(uzCyrl.uzCyrl = {
  code: "uz-Cyrl",
  formatDistance: _index$h.formatDistance,
  formatLong: _index2$8.formatLong,
  formatRelative: _index3$4.formatRelative,
  localize: _index4$4.localize,
  match: _index5$4.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1,
  },
});

var vi = {};

var formatDistance$7 = {};

formatDistance$7.formatDistance = void 0;

const formatDistanceLocale$3 = {
  lessThanXSeconds: {
    one: "dưới 1 giây",
    other: "dưới {{count}} giây",
  },

  xSeconds: {
    one: "1 giây",
    other: "{{count}} giây",
  },

  halfAMinute: "nửa phút",

  lessThanXMinutes: {
    one: "dưới 1 phút",
    other: "dưới {{count}} phút",
  },

  xMinutes: {
    one: "1 phút",
    other: "{{count}} phút",
  },

  aboutXHours: {
    one: "khoảng 1 giờ",
    other: "khoảng {{count}} giờ",
  },

  xHours: {
    one: "1 giờ",
    other: "{{count}} giờ",
  },

  xDays: {
    one: "1 ngày",
    other: "{{count}} ngày",
  },

  aboutXWeeks: {
    one: "khoảng 1 tuần",
    other: "khoảng {{count}} tuần",
  },

  xWeeks: {
    one: "1 tuần",
    other: "{{count}} tuần",
  },

  aboutXMonths: {
    one: "khoảng 1 tháng",
    other: "khoảng {{count}} tháng",
  },

  xMonths: {
    one: "1 tháng",
    other: "{{count}} tháng",
  },

  aboutXYears: {
    one: "khoảng 1 năm",
    other: "khoảng {{count}} năm",
  },

  xYears: {
    one: "1 năm",
    other: "{{count}} năm",
  },

  overXYears: {
    one: "hơn 1 năm",
    other: "hơn {{count}} năm",
  },

  almostXYears: {
    one: "gần 1 năm",
    other: "gần {{count}} năm",
  },
};

const formatDistance$6 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$3[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + " nữa";
    } else {
      return result + " trước";
    }
  }

  return result;
};
formatDistance$7.formatDistance = formatDistance$6;

var formatLong$3 = {};

formatLong$3.formatLong = void 0;
var _index$g = buildFormatLongFn$1;

const dateFormats$3 = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017
  full: "EEEE, 'ngày' d MMMM 'năm' y",
  // ngày 25 tháng 08 năm 2017
  long: "'ngày' d MMMM 'năm' y",
  // 25 thg 08 năm 2017
  medium: "d MMM 'năm' y",
  // 25/08/2017
  short: "dd/MM/y",
};

const timeFormats$3 = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm",
};

const dateTimeFormats$3 = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
  full: "{{date}} {{time}}",
  // ngày 25 tháng 08 năm 2017 23:25
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$3.formatLong = {
  date: (0, _index$g.buildFormatLongFn)({
    formats: dateFormats$3,
    defaultWidth: "full",
  }),

  time: (0, _index$g.buildFormatLongFn)({
    formats: timeFormats$3,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$g.buildFormatLongFn)({
    formats: dateTimeFormats$3,
    defaultWidth: "full",
  }),
});

var formatRelative$7 = {};

formatRelative$7.formatRelative = void 0;

const formatRelativeLocale$3 = {
  lastWeek: "eeee 'tuần trước vào lúc' p",
  yesterday: "'hôm qua vào lúc' p",
  today: "'hôm nay vào lúc' p",
  tomorrow: "'ngày mai vào lúc' p",
  nextWeek: "eeee 'tới vào lúc' p",
  other: "P",
};

const formatRelative$6 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$3[token];
formatRelative$7.formatRelative = formatRelative$6;

var localize$3 = {};

localize$3.localize = void 0;
var _index$f = buildLocalizeFn$1;

// Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134

const eraValues$3 = {
  narrow: ["TCN", "SCN"],
  abbreviated: ["trước CN", "sau CN"],
  wide: ["trước Công Nguyên", "sau Công Nguyên"],
};

const quarterValues$3 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["Quý 1", "Quý 2", "Quý 3", "Quý 4"],
};

const formattingQuarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  // I notice many news outlet use this "quý II/2018"
  wide: ["quý I", "quý II", "quý III", "quý IV"],
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues$3 = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],

  abbreviated: [
    "Thg 1",
    "Thg 2",
    "Thg 3",
    "Thg 4",
    "Thg 5",
    "Thg 6",
    "Thg 7",
    "Thg 8",
    "Thg 9",
    "Thg 10",
    "Thg 11",
    "Thg 12",
  ],

  wide: [
    "Tháng Một",
    "Tháng Hai",
    "Tháng Ba",
    "Tháng Tư",
    "Tháng Năm",
    "Tháng Sáu",
    "Tháng Bảy",
    "Tháng Tám",
    "Tháng Chín",
    "Tháng Mười",
    "Tháng Mười Một",
    "Tháng Mười Hai",
  ],
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
const formattingMonthValues = {
  narrow: [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ],

  abbreviated: [
    "thg 1",
    "thg 2",
    "thg 3",
    "thg 4",
    "thg 5",
    "thg 6",
    "thg 7",
    "thg 8",
    "thg 9",
    "thg 10",
    "thg 11",
    "thg 12",
  ],

  wide: [
    "tháng 01",
    "tháng 02",
    "tháng 03",
    "tháng 04",
    "tháng 05",
    "tháng 06",
    "tháng 07",
    "tháng 08",
    "tháng 09",
    "tháng 10",
    "tháng 11",
    "tháng 12",
  ],
};

const dayValues$3 = {
  narrow: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  short: ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"],
  abbreviated: ["CN", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],

  wide: [
    "Chủ Nhật",
    "Thứ Hai",
    "Thứ Ba",
    "Thứ Tư",
    "Thứ Năm",
    "Thứ Sáu",
    "Thứ Bảy",
  ],
};

// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
const dayPeriodValues$3 = {
  // narrow date period is extremely rare in Vietnamese
  // I used abbreviated form for noon, morning and afternoon
  // which are regconizable by Vietnamese, others cannot be any shorter
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm",
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm",
  },
};

const formattingDayPeriodValues$3 = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm",
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm",
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "giữa trưa",
    morning: "vào buổi sáng",
    afternoon: "vào buổi chiều",
    evening: "vào buổi tối",
    night: "vào ban đêm",
  },
};

const ordinalNumber$3 = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);
  const unit = options?.unit;

  if (unit === "quarter") {
    // many news outlets use "quý I"...
    switch (number) {
      case 1:
        return "I";
      case 2:
        return "II";
      case 3:
        return "III";
      case 4:
        return "IV";
    }
  } else if (unit === "day") {
    // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch (number) {
      case 1:
        return "thứ 2"; // meaning 2nd day but it's the first day of the week :D
      case 2:
        return "thứ 3"; // meaning 3rd day
      case 3:
        return "thứ 4"; // meaning 4th day and so on
      case 4:
        return "thứ 5";
      case 5:
        return "thứ 6";
      case 6:
        return "thứ 7";
      case 7:
        return "chủ nhật"; // meaning Sunday, there's no 8th day :D
    }
  } else if (unit === "week") {
    if (number === 1) {
      return "thứ nhất";
    } else {
      return "thứ " + number;
    }
  } else if (unit === "dayOfYear") {
    if (number === 1) {
      return "đầu tiên";
    } else {
      return "thứ " + number;
    }
  }

  // there are no different forms of ordinal numbers in Vietnamese
  return String(number);
};

(localize$3.localize = {
  ordinalNumber: ordinalNumber$3,

  era: (0, _index$f.buildLocalizeFn)({
    values: eraValues$3,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$f.buildLocalizeFn)({
    values: quarterValues$3,
    defaultWidth: "wide",
    formattingValues: formattingQuarterValues,
    defaultFormattingWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$f.buildLocalizeFn)({
    values: monthValues$3,
    defaultWidth: "wide",
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: "wide",
  }),

  day: (0, _index$f.buildLocalizeFn)({
    values: dayValues$3,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$f.buildLocalizeFn)({
    values: dayPeriodValues$3,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$3,
    defaultFormattingWidth: "wide",
  }),
});

var match$3 = {};

match$3.match = void 0;

var _index$e = buildMatchFn$1;
var _index2$7 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$3 = /^(\d+)/i;
const parseOrdinalNumberPattern$3 = /\d+/i;

const matchEraPatterns$3 = {
  narrow: /^(tcn|scn)/i,
  abbreviated: /^(trước CN|sau CN)/i,
  wide: /^(trước Công Nguyên|sau Công Nguyên)/i,
};
const parseEraPatterns$3 = {
  any: [/^t/i, /^s/i],
};

const matchQuarterPatterns$3 = {
  narrow: /^([1234]|i{1,3}v?)/i,
  abbreviated: /^q([1234]|i{1,3}v?)/i,
  wide: /^quý ([1234]|i{1,3}v?)/i,
};
const parseQuarterPatterns$3 = {
  any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i],
};

const matchMonthPatterns$3 = {
  // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
  // note the order of '1' since it is a sub-string of '10', so must be lower priority
  narrow: /^(0?[2-9]|10|11|12|0?1)/i,
  // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
  abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
  // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
  wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i,
};
const parseMonthPatterns$3 = {
  narrow: [
    /0?1$/i,
    /0?2/i,
    /3/,
    /4/,
    /5/,
    /6/,
    /7/,
    /8/,
    /9/,
    /10/,
    /11/,
    /12/,
  ],

  abbreviated: [
    /^thg[ _]?0?1(?!\d)/i,
    /^thg[ _]?0?2/i,
    /^thg[ _]?0?3/i,
    /^thg[ _]?0?4/i,
    /^thg[ _]?0?5/i,
    /^thg[ _]?0?6/i,
    /^thg[ _]?0?7/i,
    /^thg[ _]?0?8/i,
    /^thg[ _]?0?9/i,
    /^thg[ _]?10/i,
    /^thg[ _]?11/i,
    /^thg[ _]?12/i,
  ],

  wide: [
    /^tháng ?(Một|0?1(?!\d))/i,
    /^tháng ?(Hai|0?2)/i,
    /^tháng ?(Ba|0?3)/i,
    /^tháng ?(Tư|0?4)/i,
    /^tháng ?(Năm|0?5)/i,
    /^tháng ?(Sáu|0?6)/i,
    /^tháng ?(Bảy|0?7)/i,
    /^tháng ?(Tám|0?8)/i,
    /^tháng ?(Chín|0?9)/i,
    /^tháng ?(Mười|10)/i,
    /^tháng ?(Mười ?Một|11)/i,
    /^tháng ?(Mười ?Hai|12)/i,
  ],
};

const matchDayPatterns$3 = {
  narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
  short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i,
};
const parseDayPatterns$3 = {
  narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i],
};

const matchDayPeriodPatterns$3 = {
  narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
};
const parseDayPeriodPatterns$3 = {
  any: {
    am: /^(a|sa)/i,
    pm: /^(p|ch[^i]*)/i,
    midnight: /nửa đêm/i,
    noon: /trưa/i,
    morning: /sáng/i,
    afternoon: /chiều/i,
    evening: /tối/i,
    night: /^đêm/i,
  },
};

(match$3.match = {
  ordinalNumber: (0, _index2$7.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$3,
    parsePattern: parseOrdinalNumberPattern$3,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$e.buildMatchFn)({
    matchPatterns: matchEraPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$3,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$e.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$3,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$e.buildMatchFn)({
    matchPatterns: matchMonthPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$3,
    defaultParseWidth: "wide",
  }),

  day: (0, _index$e.buildMatchFn)({
    matchPatterns: matchDayPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$3,
    defaultParseWidth: "wide",
  }),

  dayPeriod: (0, _index$e.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$3,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPeriodPatterns$3,
    defaultParseWidth: "any",
  }),
});

vi.vi = void 0;
var _index$d = formatDistance$7;
var _index2$6 = formatLong$3;
var _index3$3 = formatRelative$7;
var _index4$3 = localize$3;
var _index5$3 = match$3;

/**
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh](https://github.com/trongthanh)
 * @author Leroy Hopson [@lihop](https://github.com/lihop)
 */
(vi.vi = {
  code: "vi",
  formatDistance: _index$d.formatDistance,
  formatLong: _index2$6.formatLong,
  formatRelative: _index3$3.formatRelative,
  localize: _index4$3.localize,
  match: _index5$3.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */,
  },
});

var zhCN = {};

var formatDistance$5 = {};

formatDistance$5.formatDistance = void 0;

const formatDistanceLocale$2 = {
  lessThanXSeconds: {
    one: "不到 1 秒",
    other: "不到 {{count}} 秒",
  },

  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒",
  },

  halfAMinute: "半分钟",

  lessThanXMinutes: {
    one: "不到 1 分钟",
    other: "不到 {{count}} 分钟",
  },

  xMinutes: {
    one: "1 分钟",
    other: "{{count}} 分钟",
  },

  xHours: {
    one: "1 小时",
    other: "{{count}} 小时",
  },

  aboutXHours: {
    one: "大约 1 小时",
    other: "大约 {{count}} 小时",
  },

  xDays: {
    one: "1 天",
    other: "{{count}} 天",
  },

  aboutXWeeks: {
    one: "大约 1 个星期",
    other: "大约 {{count}} 个星期",
  },

  xWeeks: {
    one: "1 个星期",
    other: "{{count}} 个星期",
  },

  aboutXMonths: {
    one: "大约 1 个月",
    other: "大约 {{count}} 个月",
  },

  xMonths: {
    one: "1 个月",
    other: "{{count}} 个月",
  },

  aboutXYears: {
    one: "大约 1 年",
    other: "大约 {{count}} 年",
  },

  xYears: {
    one: "1 年",
    other: "{{count}} 年",
  },

  overXYears: {
    one: "超过 1 年",
    other: "超过 {{count}} 年",
  },

  almostXYears: {
    one: "将近 1 年",
    other: "将近 {{count}} 年",
  },
};

const formatDistance$4 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$2[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + "内";
    } else {
      return result + "前";
    }
  }

  return result;
};
formatDistance$5.formatDistance = formatDistance$4;

var formatLong$2 = {};

formatLong$2.formatLong = void 0;
var _index$c = buildFormatLongFn$1;

const dateFormats$2 = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd",
};

const timeFormats$2 = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm",
};

const dateTimeFormats$2 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$2.formatLong = {
  date: (0, _index$c.buildFormatLongFn)({
    formats: dateFormats$2,
    defaultWidth: "full",
  }),

  time: (0, _index$c.buildFormatLongFn)({
    formats: timeFormats$2,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$c.buildFormatLongFn)({
    formats: dateTimeFormats$2,
    defaultWidth: "full",
  }),
});

var formatRelative$5 = {};

formatRelative$5.formatRelative = void 0;
var _index$b = isSameWeek$1;

function checkWeek(date, baseDate, options) {
  const baseFormat = "eeee p";

  if ((0, _index$b.isSameWeek)(date, baseDate, options)) {
    return baseFormat; // in same week
  } else if (date.getTime() > baseDate.getTime()) {
    return "'下个'" + baseFormat; // in next week
  }
  return "'上个'" + baseFormat; // in last week
}

const formatRelativeLocale$2 = {
  lastWeek: checkWeek, // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: checkWeek, // days after tomorrow, maybe in this week or next week
  other: "PP p",
};

const formatRelative$4 = (token, date, baseDate, options) => {
  const format = formatRelativeLocale$2[token];

  if (typeof format === "function") {
    return format(date, baseDate, options);
  }

  return format;
};
formatRelative$5.formatRelative = formatRelative$4;

var localize$2 = {};

localize$2.localize = void 0;
var _index$a = buildLocalizeFn$1;

const eraValues$2 = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"],
};

const quarterValues$2 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"],
};

const monthValues$2 = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二",
  ],

  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ],

  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月",
  ],
};

const dayValues$2 = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],

  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
};

const dayPeriodValues$2 = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜",
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间",
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间",
  },
};

const formattingDayPeriodValues$2 = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜",
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间",
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间",
  },
};

const ordinalNumber$2 = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);

  switch (options?.unit) {
    case "date":
      return number.toString() + "日";
    case "hour":
      return number.toString() + "时";
    case "minute":
      return number.toString() + "分";
    case "second":
      return number.toString() + "秒";
    default:
      return "第 " + number.toString();
  }
};

(localize$2.localize = {
  ordinalNumber: ordinalNumber$2,

  era: (0, _index$a.buildLocalizeFn)({
    values: eraValues$2,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$a.buildLocalizeFn)({
    values: quarterValues$2,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$a.buildLocalizeFn)({
    values: monthValues$2,
    defaultWidth: "wide",
  }),

  day: (0, _index$a.buildLocalizeFn)({
    values: dayValues$2,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$a.buildLocalizeFn)({
    values: dayPeriodValues$2,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$2,
    defaultFormattingWidth: "wide",
  }),
});

var match$2 = {};

match$2.match = void 0;

var _index$9 = buildMatchFn$1;
var _index2$5 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$2 = /^(第\s*)?\d+(日|时|分|秒)?/i;
const parseOrdinalNumberPattern$2 = /\d+/i;

const matchEraPatterns$2 = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i,
};
const parseEraPatterns$2 = {
  any: [/^(前)/i, /^(公元)/i],
};

const matchQuarterPatterns$2 = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i,
};
const parseQuarterPatterns$2 = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i],
};

const matchMonthPatterns$2 = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i,
};
const parseMonthPatterns$2 = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i,
  ],

  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i,
  ],
};

const matchDayPatterns$2 = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i,
};
const parseDayPatterns$2 = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i],
};

const matchDayPeriodPatterns$2 = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i,
};
const parseDayPeriodPatterns$2 = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i,
  },
};

(match$2.match = {
  ordinalNumber: (0, _index2$5.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$2,
    parsePattern: parseOrdinalNumberPattern$2,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$9.buildMatchFn)({
    matchPatterns: matchEraPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$2,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$9.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$2,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$9.buildMatchFn)({
    matchPatterns: matchMonthPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$2,
    defaultParseWidth: "any",
  }),

  day: (0, _index$9.buildMatchFn)({
    matchPatterns: matchDayPatterns$2,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$2,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$9.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$2,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$2,
    defaultParseWidth: "any",
  }),
});

zhCN.zhCN = void 0;
var _index$8 = formatDistance$5;
var _index2$4 = formatLong$2;
var _index3$2 = formatRelative$5;
var _index4$2 = localize$2;
var _index5$2 = match$2;

/**
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario](https://github.com/KingMario)
 * @author Song Shuoyun [@fnlctrl](https://github.com/fnlctrl)
 * @author sabrinaM [@sabrinamiao](https://github.com/sabrinamiao)
 * @author Carney Wu [@cubicwork](https://github.com/cubicwork)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 */
(zhCN.zhCN = {
  code: "zh-CN",
  formatDistance: _index$8.formatDistance,
  formatLong: _index2$4.formatLong,
  formatRelative: _index3$2.formatRelative,
  localize: _index4$2.localize,
  match: _index5$2.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

var zhHK = {};

var formatDistance$3 = {};

formatDistance$3.formatDistance = void 0;

const formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒",
  },

  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒",
  },

  halfAMinute: "半分鐘",

  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘",
  },

  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘",
  },

  xHours: {
    one: "1 小時",
    other: "{{count}} 小時",
  },

  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時",
  },

  xDays: {
    one: "1 天",
    other: "{{count}} 天",
  },

  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期",
  },

  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期",
  },

  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月",
  },

  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月",
  },

  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年",
  },

  xYears: {
    one: "1 年",
    other: "{{count}} 年",
  },

  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年",
  },

  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年",
  },
};

const formatDistance$2 = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + "內";
    } else {
      return result + "前";
    }
  }

  return result;
};
formatDistance$3.formatDistance = formatDistance$2;

var formatLong$1 = {};

formatLong$1.formatLong = void 0;
var _index$7 = buildFormatLongFn$1;

const dateFormats$1 = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd",
};

const timeFormats$1 = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm",
};

const dateTimeFormats$1 = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong$1.formatLong = {
  date: (0, _index$7.buildFormatLongFn)({
    formats: dateFormats$1,
    defaultWidth: "full",
  }),

  time: (0, _index$7.buildFormatLongFn)({
    formats: timeFormats$1,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$7.buildFormatLongFn)({
    formats: dateTimeFormats$1,
    defaultWidth: "full",
  }),
});

var formatRelative$3 = {};

formatRelative$3.formatRelative = void 0;

const formatRelativeLocale$1 = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P",
};

const formatRelative$2 = (token, _date, _baseDate, _options) =>
  formatRelativeLocale$1[token];
formatRelative$3.formatRelative = formatRelative$2;

var localize$1 = {};

localize$1.localize = void 0;
var _index$6 = buildLocalizeFn$1;

const eraValues$1 = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"],
};

const quarterValues$1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"],
};

const monthValues$1 = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二",
  ],

  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ],

  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月",
  ],
};

const dayValues$1 = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],

  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
};

const dayPeriodValues$1 = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜",
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚",
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚",
  },
};

const formattingDayPeriodValues$1 = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜",
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚",
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚",
  },
};

const ordinalNumber$1 = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);

  switch (options?.unit) {
    case "date":
      return number + "日";
    case "hour":
      return number + "時";
    case "minute":
      return number + "分";
    case "second":
      return number + "秒";
    default:
      return "第 " + number;
  }
};

(localize$1.localize = {
  ordinalNumber: ordinalNumber$1,

  era: (0, _index$6.buildLocalizeFn)({
    values: eraValues$1,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$6.buildLocalizeFn)({
    values: quarterValues$1,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$6.buildLocalizeFn)({
    values: monthValues$1,
    defaultWidth: "wide",
  }),

  day: (0, _index$6.buildLocalizeFn)({
    values: dayValues$1,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$6.buildLocalizeFn)({
    values: dayPeriodValues$1,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: "wide",
  }),
});

var match$1 = {};

match$1.match = void 0;

var _index$5 = buildMatchFn$1;
var _index2$3 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern$1 = /^(第\s*)?\d+(日|時|分|秒)?/i;
const parseOrdinalNumberPattern$1 = /\d+/i;

const matchEraPatterns$1 = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i,
};
const parseEraPatterns$1 = {
  any: [/^(前)/i, /^(公元)/i],
};

const matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]季/i,
  wide: /^第[一二三四]季度/i,
};
const parseQuarterPatterns$1 = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i],
};

const matchMonthPatterns$1 = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i,
};
const parseMonthPatterns$1 = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i,
  ],

  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i,
  ],
};

const matchDayPatterns$1 = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i,
};
const parseDayPatterns$1 = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i],
};

const matchDayPeriodPatterns$1 = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i,
};
const parseDayPeriodPatterns$1 = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i,
  },
};

(match$1.match = {
  ordinalNumber: (0, _index2$3.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$5.buildMatchFn)({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$5.buildMatchFn)({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$5.buildMatchFn)({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: "any",
  }),

  day: (0, _index$5.buildMatchFn)({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$5.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: "any",
  }),
});

zhHK.zhHK = void 0;
var _index$4 = formatDistance$3;
var _index2$2 = formatLong$1;
var _index3$1 = formatRelative$3;
var _index4$1 = localize$1;
var _index5$1 = match$1;

/**
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo](https://github.com/gaplo)
 */
(zhHK.zhHK = {
  code: "zh-HK",
  formatDistance: _index$4.formatDistance,
  formatLong: _index2$2.formatLong,
  formatRelative: _index3$1.formatRelative,
  localize: _index4$1.localize,
  match: _index5$1.match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1,
  },
});

var zhTW = {};

var formatDistance$1 = {};

formatDistance$1.formatDistance = void 0;

const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒",
  },

  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒",
  },

  halfAMinute: "半分鐘",

  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘",
  },

  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘",
  },

  xHours: {
    one: "1 小時",
    other: "{{count}} 小時",
  },

  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時",
  },

  xDays: {
    one: "1 天",
    other: "{{count}} 天",
  },

  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期",
  },

  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期",
  },

  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月",
  },

  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月",
  },

  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年",
  },

  xYears: {
    one: "1 年",
    other: "{{count}} 年",
  },

  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年",
  },

  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年",
  },
};

const formatDistance = (token, count, options) => {
  let result;

  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", String(count));
  }

  if (options?.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + "內";
    } else {
      return result + "前";
    }
  }

  return result;
};
formatDistance$1.formatDistance = formatDistance;

var formatLong = {};

formatLong.formatLong = void 0;
var _index$3 = buildFormatLongFn$1;

const dateFormats = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd",
};

const timeFormats = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm",
};

const dateTimeFormats = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}",
};

(formatLong.formatLong = {
  date: (0, _index$3.buildFormatLongFn)({
    formats: dateFormats,
    defaultWidth: "full",
  }),

  time: (0, _index$3.buildFormatLongFn)({
    formats: timeFormats,
    defaultWidth: "full",
  }),

  dateTime: (0, _index$3.buildFormatLongFn)({
    formats: dateTimeFormats,
    defaultWidth: "full",
  }),
});

var formatRelative$1 = {};

formatRelative$1.formatRelative = void 0;

const formatRelativeLocale = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P",
};

const formatRelative = (token, _date, _baseDate, _options) =>
  formatRelativeLocale[token];
formatRelative$1.formatRelative = formatRelative;

var localize = {};

localize.localize = void 0;
var _index$2 = buildLocalizeFn$1;

const eraValues = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"],
};

const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一刻", "第二刻", "第三刻", "第四刻"],
  wide: ["第一刻鐘", "第二刻鐘", "第三刻鐘", "第四刻鐘"],
};

const monthValues = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二",
  ],

  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ],

  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月",
  ],
};

const dayValues = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],

  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
};

const dayPeriodValues = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜",
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間",
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間",
  },
};

const formattingDayPeriodValues = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜",
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間",
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間",
  },
};

const ordinalNumber = (dirtyNumber, options) => {
  const number = Number(dirtyNumber);

  switch (options?.unit) {
    case "date":
      return number + "日";
    case "hour":
      return number + "時";
    case "minute":
      return number + "分";
    case "second":
      return number + "秒";
    default:
      return "第 " + number;
  }
};

(localize.localize = {
  ordinalNumber,

  era: (0, _index$2.buildLocalizeFn)({
    values: eraValues,
    defaultWidth: "wide",
  }),

  quarter: (0, _index$2.buildLocalizeFn)({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1,
  }),

  month: (0, _index$2.buildLocalizeFn)({
    values: monthValues,
    defaultWidth: "wide",
  }),

  day: (0, _index$2.buildLocalizeFn)({
    values: dayValues,
    defaultWidth: "wide",
  }),

  dayPeriod: (0, _index$2.buildLocalizeFn)({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide",
  }),
});

var match = {};

match.match = void 0;

var _index$1 = buildMatchFn$1;
var _index2$1 = buildMatchPatternFn$1;

const matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i,
};
const parseEraPatterns = {
  any: [/^(前)/i, /^(公元)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻鐘/i,
};
const parseQuarterPatterns = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i],
};

const matchMonthPatterns = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i,
};
const parseMonthPatterns = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i,
  ],

  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i,
  ],
};

const matchDayPatterns = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i,
};
const parseDayPatterns = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i],
};

const matchDayPeriodPatterns = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i,
};
const parseDayPeriodPatterns = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i,
  },
};

(match.match = {
  ordinalNumber: (0, _index2$1.buildMatchPatternFn)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10),
  }),

  era: (0, _index$1.buildMatchFn)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any",
  }),

  quarter: (0, _index$1.buildMatchFn)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index) => index + 1,
  }),

  month: (0, _index$1.buildMatchFn)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any",
  }),

  day: (0, _index$1.buildMatchFn)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any",
  }),

  dayPeriod: (0, _index$1.buildMatchFn)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any",
  }),
});

zhTW.zhTW = void 0;
var _index = formatDistance$1;
var _index2 = formatLong;
var _index3 = formatRelative$1;
var _index4 = localize;
var _index5 = match;

/**
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai](https://github.com/tpai)
 * @author Jack Hsu [@jackhsu978](https://github.com/jackhsu978)
 * @author Terrence Lam [@skyuplam](https://github.com/skyuplam)
 */
(zhTW.zhTW = {
  code: "zh-TW",
  formatDistance: _index.formatDistance,
  formatLong: _index2.formatLong,
  formatRelative: _index3.formatRelative,
  localize: _index4.localize,
  match: _index5.match,
  options: {
    weekStartsOn: 1 /* Monday */,
    firstWeekContainsDate: 4,
  },
});

(function (exports) {

var _index = af;
Object.keys(_index).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index[key];
    },
  });
});
var _index2 = ar;
Object.keys(_index2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index2[key];
    },
  });
});
var _index3 = arDZ;
Object.keys(_index3).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index3[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index3[key];
    },
  });
});
var _index4 = arEG;
Object.keys(_index4).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index4[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index4[key];
    },
  });
});
var _index5 = arMA;
Object.keys(_index5).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index5[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index5[key];
    },
  });
});
var _index6 = arSA;
Object.keys(_index6).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index6[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index6[key];
    },
  });
});
var _index7 = arTN;
Object.keys(_index7).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index7[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index7[key];
    },
  });
});
var _index8 = az;
Object.keys(_index8).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index8[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index8[key];
    },
  });
});
var _index9 = be;
Object.keys(_index9).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index9[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index9[key];
    },
  });
});
var _index10 = beTarask;
Object.keys(_index10).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index10[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index10[key];
    },
  });
});
var _index11 = bg;
Object.keys(_index11).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index11[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index11[key];
    },
  });
});
var _index12 = bn;
Object.keys(_index12).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index12[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index12[key];
    },
  });
});
var _index13 = bs;
Object.keys(_index13).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index13[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index13[key];
    },
  });
});
var _index14 = ca;
Object.keys(_index14).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index14[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index14[key];
    },
  });
});
var _index15 = ckb;
Object.keys(_index15).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index15[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index15[key];
    },
  });
});
var _index16 = cs;
Object.keys(_index16).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index16[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index16[key];
    },
  });
});
var _index17 = cy;
Object.keys(_index17).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index17[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index17[key];
    },
  });
});
var _index18 = da;
Object.keys(_index18).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index18[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index18[key];
    },
  });
});
var _index19 = de;
Object.keys(_index19).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index19[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index19[key];
    },
  });
});
var _index20 = deAT;
Object.keys(_index20).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index20[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index20[key];
    },
  });
});
var _index21 = el;
Object.keys(_index21).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index21[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index21[key];
    },
  });
});
var _index22 = enAU;
Object.keys(_index22).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index22[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index22[key];
    },
  });
});
var _index23 = enCA;
Object.keys(_index23).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index23[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index23[key];
    },
  });
});
var _index24 = enGB;
Object.keys(_index24).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index24[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index24[key];
    },
  });
});
var _index25 = enIE;
Object.keys(_index25).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index25[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index25[key];
    },
  });
});
var _index26 = enIN;
Object.keys(_index26).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index26[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index26[key];
    },
  });
});
var _index27 = enNZ;
Object.keys(_index27).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index27[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index27[key];
    },
  });
});
var _index28 = enUS;
Object.keys(_index28).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index28[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index28[key];
    },
  });
});
var _index29 = enZA;
Object.keys(_index29).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index29[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index29[key];
    },
  });
});
var _index30 = eo;
Object.keys(_index30).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index30[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index30[key];
    },
  });
});
var _index31 = es;
Object.keys(_index31).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index31[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index31[key];
    },
  });
});
var _index32 = et;
Object.keys(_index32).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index32[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index32[key];
    },
  });
});
var _index33 = eu;
Object.keys(_index33).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index33[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index33[key];
    },
  });
});
var _index34 = faIR;
Object.keys(_index34).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index34[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index34[key];
    },
  });
});
var _index35 = fi;
Object.keys(_index35).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index35[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index35[key];
    },
  });
});
var _index36 = fr;
Object.keys(_index36).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index36[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index36[key];
    },
  });
});
var _index37 = frCA;
Object.keys(_index37).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index37[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index37[key];
    },
  });
});
var _index38 = frCH;
Object.keys(_index38).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index38[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index38[key];
    },
  });
});
var _index39 = fy;
Object.keys(_index39).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index39[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index39[key];
    },
  });
});
var _index40 = gd;
Object.keys(_index40).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index40[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index40[key];
    },
  });
});
var _index41 = gl;
Object.keys(_index41).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index41[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index41[key];
    },
  });
});
var _index42 = gu;
Object.keys(_index42).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index42[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index42[key];
    },
  });
});
var _index43 = he;
Object.keys(_index43).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index43[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index43[key];
    },
  });
});
var _index44 = hi;
Object.keys(_index44).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index44[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index44[key];
    },
  });
});
var _index45 = hr;
Object.keys(_index45).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index45[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index45[key];
    },
  });
});
var _index46 = ht;
Object.keys(_index46).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index46[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index46[key];
    },
  });
});
var _index47 = hu;
Object.keys(_index47).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index47[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index47[key];
    },
  });
});
var _index48 = hy;
Object.keys(_index48).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index48[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index48[key];
    },
  });
});
var _index49 = id;
Object.keys(_index49).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index49[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index49[key];
    },
  });
});
var _index50 = is;
Object.keys(_index50).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index50[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index50[key];
    },
  });
});
var _index51 = it;
Object.keys(_index51).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index51[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index51[key];
    },
  });
});
var _index52 = itCH;
Object.keys(_index52).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index52[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index52[key];
    },
  });
});
var _index53 = ja;
Object.keys(_index53).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index53[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index53[key];
    },
  });
});
var _index54 = jaHira;
Object.keys(_index54).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index54[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index54[key];
    },
  });
});
var _index55 = ka;
Object.keys(_index55).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index55[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index55[key];
    },
  });
});
var _index56 = kk;
Object.keys(_index56).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index56[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index56[key];
    },
  });
});
var _index57 = km;
Object.keys(_index57).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index57[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index57[key];
    },
  });
});
var _index58 = kn;
Object.keys(_index58).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index58[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index58[key];
    },
  });
});
var _index59 = ko;
Object.keys(_index59).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index59[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index59[key];
    },
  });
});
var _index60 = lb;
Object.keys(_index60).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index60[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index60[key];
    },
  });
});
var _index61 = lt;
Object.keys(_index61).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index61[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index61[key];
    },
  });
});
var _index62 = lv;
Object.keys(_index62).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index62[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index62[key];
    },
  });
});
var _index63 = mk;
Object.keys(_index63).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index63[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index63[key];
    },
  });
});
var _index64 = mn;
Object.keys(_index64).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index64[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index64[key];
    },
  });
});
var _index65 = ms;
Object.keys(_index65).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index65[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index65[key];
    },
  });
});
var _index66 = mt;
Object.keys(_index66).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index66[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index66[key];
    },
  });
});
var _index67 = nb;
Object.keys(_index67).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index67[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index67[key];
    },
  });
});
var _index68 = nl;
Object.keys(_index68).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index68[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index68[key];
    },
  });
});
var _index69 = nlBE;
Object.keys(_index69).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index69[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index69[key];
    },
  });
});
var _index70 = nn;
Object.keys(_index70).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index70[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index70[key];
    },
  });
});
var _index71 = oc;
Object.keys(_index71).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index71[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index71[key];
    },
  });
});
var _index72 = pl;
Object.keys(_index72).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index72[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index72[key];
    },
  });
});
var _index73 = pt;
Object.keys(_index73).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index73[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index73[key];
    },
  });
});
var _index74 = ptBR;
Object.keys(_index74).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index74[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index74[key];
    },
  });
});
var _index75 = ro;
Object.keys(_index75).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index75[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index75[key];
    },
  });
});
var _index76 = ru;
Object.keys(_index76).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index76[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index76[key];
    },
  });
});
var _index77 = se;
Object.keys(_index77).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index77[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index77[key];
    },
  });
});
var _index78 = sk;
Object.keys(_index78).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index78[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index78[key];
    },
  });
});
var _index79 = sl;
Object.keys(_index79).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index79[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index79[key];
    },
  });
});
var _index80 = sq;
Object.keys(_index80).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index80[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index80[key];
    },
  });
});
var _index81 = sr;
Object.keys(_index81).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index81[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index81[key];
    },
  });
});
var _index82 = srLatn;
Object.keys(_index82).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index82[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index82[key];
    },
  });
});
var _index83 = sv;
Object.keys(_index83).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index83[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index83[key];
    },
  });
});
var _index84 = ta;
Object.keys(_index84).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index84[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index84[key];
    },
  });
});
var _index85 = te;
Object.keys(_index85).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index85[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index85[key];
    },
  });
});
var _index86 = th;
Object.keys(_index86).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index86[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index86[key];
    },
  });
});
var _index87 = tr;
Object.keys(_index87).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index87[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index87[key];
    },
  });
});
var _index88 = ug;
Object.keys(_index88).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index88[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index88[key];
    },
  });
});
var _index89 = uk;
Object.keys(_index89).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index89[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index89[key];
    },
  });
});
var _index90 = uz;
Object.keys(_index90).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index90[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index90[key];
    },
  });
});
var _index91 = uzCyrl;
Object.keys(_index91).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index91[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index91[key];
    },
  });
});
var _index92 = vi;
Object.keys(_index92).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index92[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index92[key];
    },
  });
});
var _index93 = zhCN;
Object.keys(_index93).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index93[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index93[key];
    },
  });
});
var _index94 = zhHK;
Object.keys(_index94).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index94[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index94[key];
    },
  });
});
var _index95 = zhTW;
Object.keys(_index95).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _index95[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _index95[key];
    },
  });
});
}(locale));

(function (exports) {

var jsxRuntime = require$$11;
var react = React__default$4;
var dateFns$1 = dateFns;
var locale$1 = locale;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/** Returns true when the props are of type {@link DayPickerMultipleProps}. */
function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}

/** Returns true when the props are of type {@link DayPickerRangeProps}. */
function isDayPickerRange(props) {
    return props.mode === 'range';
}

/** Returns true when the props are of type {@link DayPickerSingleProps}. */
function isDayPickerSingle(props) {
    return props.mode === 'single';
}

/**
 * The name of the default CSS classes.
 */
var defaultClassNames = {
    root: 'rdp',
    multiple_months: 'rdp-multiple_months',
    with_weeknumber: 'rdp-with_weeknumber',
    vhidden: 'rdp-vhidden',
    button_reset: 'rdp-button_reset',
    button: 'rdp-button',
    caption: 'rdp-caption',
    caption_start: 'rdp-caption_start',
    caption_end: 'rdp-caption_end',
    caption_between: 'rdp-caption_between',
    caption_label: 'rdp-caption_label',
    caption_dropdowns: 'rdp-caption_dropdowns',
    dropdown: 'rdp-dropdown',
    dropdown_month: 'rdp-dropdown_month',
    dropdown_year: 'rdp-dropdown_year',
    dropdown_icon: 'rdp-dropdown_icon',
    months: 'rdp-months',
    month: 'rdp-month',
    table: 'rdp-table',
    tbody: 'rdp-tbody',
    tfoot: 'rdp-tfoot',
    head: 'rdp-head',
    head_row: 'rdp-head_row',
    head_cell: 'rdp-head_cell',
    nav: 'rdp-nav',
    nav_button: 'rdp-nav_button',
    nav_button_previous: 'rdp-nav_button_previous',
    nav_button_next: 'rdp-nav_button_next',
    nav_icon: 'rdp-nav_icon',
    row: 'rdp-row',
    weeknumber: 'rdp-weeknumber',
    cell: 'rdp-cell',
    day: 'rdp-day',
    day_today: 'rdp-day_today',
    day_outside: 'rdp-day_outside',
    day_selected: 'rdp-day_selected',
    day_disabled: 'rdp-day_disabled',
    day_hidden: 'rdp-day_hidden',
    day_range_start: 'rdp-day_range_start',
    day_range_end: 'rdp-day_range_end',
    day_range_middle: 'rdp-day_range_middle'
};

/**
 * The default formatter for the caption.
 */
function formatCaption(month, options) {
    return dateFns$1.format(month, 'LLLL y', options);
}

/**
 * The default formatter for the Day button.
 */
function formatDay(day, options) {
    return dateFns$1.format(day, 'd', options);
}

/**
 * The default formatter for the Month caption.
 */
function formatMonthCaption(month, options) {
    return dateFns$1.format(month, 'LLLL', options);
}

/**
 * The default formatter for the week number.
 */
function formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}

/**
 * The default formatter for the name of the weekday.
 */
function formatWeekdayName(weekday, options) {
    return dateFns$1.format(weekday, 'cccccc', options);
}

/**
 * The default formatter for the Year caption.
 */
function formatYearCaption(year, options) {
    return dateFns$1.format(year, 'yyyy', options);
}

var formatters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    formatCaption: formatCaption,
    formatDay: formatDay,
    formatMonthCaption: formatMonthCaption,
    formatWeekNumber: formatWeekNumber,
    formatWeekdayName: formatWeekdayName,
    formatYearCaption: formatYearCaption
});

/**
 * The default ARIA label for the day button.
 */
var labelDay = function (day, activeModifiers, options) {
    return dateFns$1.format(day, 'do MMMM (EEEE)', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelMonthDropdown = function () {
    return 'Month: ';
};

/**
 * The default ARIA label for next month button in navigation
 */
var labelNext = function () {
    return 'Go to next month';
};

/**
 * The default ARIA label for previous month button in navigation
 */
var labelPrevious = function () {
    return 'Go to previous month';
};

/**
 * The default ARIA label for the Weekday element.
 */
var labelWeekday = function (day, options) {
    return dateFns$1.format(day, 'cccc', options);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelWeekNumber = function (n) {
    return "Week n. ".concat(n);
};

/**
 * The default ARIA label for the WeekNumber element.
 */
var labelYearDropdown = function () {
    return 'Year: ';
};

var labels = /*#__PURE__*/Object.freeze({
    __proto__: null,
    labelDay: labelDay,
    labelMonthDropdown: labelMonthDropdown,
    labelNext: labelNext,
    labelPrevious: labelPrevious,
    labelWeekNumber: labelWeekNumber,
    labelWeekday: labelWeekday,
    labelYearDropdown: labelYearDropdown
});

/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */
function getDefaultContextValues() {
    var captionLayout = 'buttons';
    var classNames = defaultClassNames;
    var locale$1$1 = locale$1.enUS;
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: formatters,
        labels: labels,
        locale: locale$1$1,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: 'default'
    };
}

/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */
function parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) {
        fromDate = dateFns$1.startOfMonth(fromMonth);
    }
    else if (fromYear) {
        fromDate = new Date(fromYear, 0, 1);
    }
    if (toMonth) {
        toDate = dateFns$1.endOfMonth(toMonth);
    }
    else if (toYear) {
        toDate = new Date(toYear, 11, 31);
    }
    return {
        fromDate: fromDate ? dateFns$1.startOfDay(fromDate) : undefined,
        toDate: toDate ? dateFns$1.startOfDay(toDate) : undefined
    };
}

/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */
var DayPickerContext = react.createContext(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */
function DayPickerProvider(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = getDefaultContextValues();
    var _b = parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== 'buttons' && (!fromDate || !toDate)) {
        // When no from/to dates are set, the caption is always buttons
        captionLayout = 'buttons';
    }
    var onSelect;
    if (isDayPickerSingle(initialProps) ||
        isDayPickerMultiple(initialProps) ||
        isDayPickerRange(initialProps)) {
        onSelect = initialProps.onSelect;
    }
    var value = __assign(__assign(__assign({}, defaultContextValues), initialProps), { captionLayout: captionLayout, classNames: __assign(__assign({}, defaultContextValues.classNames), initialProps.classNames), components: __assign({}, initialProps.components), formatters: __assign(__assign({}, defaultContextValues.formatters), initialProps.formatters), fromDate: fromDate, labels: __assign(__assign({}, defaultContextValues.labels), initialProps.labels), mode: initialProps.mode || defaultContextValues.mode, modifiers: __assign(__assign({}, defaultContextValues.modifiers), initialProps.modifiers), modifiersClassNames: __assign(__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames), onSelect: onSelect, styles: __assign(__assign({}, defaultContextValues.styles), initialProps.styles), toDate: toDate });
    return (jsxRuntime.jsx(DayPickerContext.Provider, { value: value, children: props.children }));
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */
function useDayPicker() {
    var context = react.useContext(DayPickerContext);
    if (!context) {
        throw new Error("useDayPicker must be used within a DayPickerProvider.");
    }
    return context;
}

/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */
function CaptionLabel(props) {
    var _a = useDayPicker(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (jsxRuntime.jsx("div", { className: classNames.caption_label, style: styles.caption_label, "aria-live": "polite", role: "presentation", id: props.id, children: formatCaption(props.displayMonth, { locale: locale }) }));
}

/**
 * Render the icon in the styled drop-down.
 */
function IconDropdown(props) {
    return (jsxRuntime.jsx("svg", __assign({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, props, { children: jsxRuntime.jsx("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) })));
}

/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */
function Dropdown(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = useDayPicker();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : IconDropdown;
    return (jsxRuntime.jsxs("div", { className: className, style: style, children: [jsxRuntime.jsx("span", { className: dayPicker.classNames.vhidden, children: props['aria-label'] }), jsxRuntime.jsx("select", { name: props.name, "aria-label": props['aria-label'], className: dayPicker.classNames.dropdown, style: dayPicker.styles.dropdown, value: value, onChange: onChange, children: children }), jsxRuntime.jsxs("div", { className: dayPicker.classNames.caption_label, style: dayPicker.styles.caption_label, "aria-hidden": "true", children: [caption, jsxRuntime.jsx(IconDropdownComponent, { className: dayPicker.classNames.dropdown_icon, style: dayPicker.styles.dropdown_icon })] })] }));
}

/** Render the dropdown to navigate between months. */
function MonthsDropdown(props) {
    var _a;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return jsxRuntime.jsx(jsxRuntime.Fragment, {});
    if (!toDate)
        return jsxRuntime.jsx(jsxRuntime.Fragment, {});
    var dropdownMonths = [];
    if (dateFns$1.isSameYear(fromDate, toDate)) {
        // only display the months included in the range
        var date = dateFns$1.startOfMonth(fromDate);
        for (var month = fromDate.getMonth(); month <= toDate.getMonth(); month++) {
            dropdownMonths.push(dateFns$1.setMonth(date, month));
        }
    }
    else {
        // display all the 12 months
        var date = dateFns$1.startOfMonth(new Date()); // Any date should be OK, as we just need the year
        for (var month = 0; month <= 11; month++) {
            dropdownMonths.push(dateFns$1.setMonth(date, month));
        }
    }
    var handleChange = function (e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = dateFns$1.setMonth(dateFns$1.startOfMonth(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (jsxRuntime.jsx(DropdownComponent, { name: "months", "aria-label": labelMonthDropdown(), className: classNames.dropdown_month, style: styles.dropdown_month, onChange: handleChange, value: props.displayMonth.getMonth(), caption: formatMonthCaption(props.displayMonth, { locale: locale }), children: dropdownMonths.map(function (m) { return (jsxRuntime.jsx("option", { value: m.getMonth(), children: formatMonthCaption(m, { locale: locale }) }, m.getMonth())); }) }));
}

/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */
function YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = useDayPicker(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate)
        return jsxRuntime.jsx(jsxRuntime.Fragment, {});
    if (!toDate)
        return jsxRuntime.jsx(jsxRuntime.Fragment, {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for (var year = fromYear; year <= toYear; year++) {
        years.push(dateFns$1.setYear(dateFns$1.startOfYear(new Date()), year));
    }
    var handleChange = function (e) {
        var newMonth = dateFns$1.setYear(dateFns$1.startOfMonth(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : Dropdown;
    return (jsxRuntime.jsx(DropdownComponent, { name: "years", "aria-label": labelYearDropdown(), className: classNames.dropdown_year, style: styles.dropdown_year, onChange: handleChange, value: displayMonth.getFullYear(), caption: formatYearCaption(displayMonth, { locale: locale }), children: years.map(function (year) { return (jsxRuntime.jsx("option", { value: year.getFullYear(), children: formatYearCaption(year, { locale: locale }) }, year.getFullYear())); }) }));
}

/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */
function useControlledValue(defaultValue, controlledValue) {
    var _a = react.useState(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [value, setValue];
}

/** Return the initial month according to the given options. */
function getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && dateFns$1.differenceInCalendarMonths(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = dateFns$1.addMonths(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && dateFns$1.differenceInCalendarMonths(initialMonth, fromDate) < 0) {
        initialMonth = fromDate;
    }
    return dateFns$1.startOfMonth(initialMonth);
}

/** Controls the navigation state. */
function useNavigationState() {
    var context = useDayPicker();
    var initialMonth = getInitialMonth(context);
    var _a = useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function (date) {
        var _a;
        if (context.disableNavigation)
            return;
        var month = dateFns$1.startOfMonth(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 ? void 0 : _a.call(context, month);
    };
    return [month, goToMonth];
}

/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */
function getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = dateFns$1.startOfMonth(month);
    var end = dateFns$1.startOfMonth(dateFns$1.addMonths(start, numberOfMonths));
    var monthsDiff = dateFns$1.differenceInCalendarMonths(end, start);
    var months = [];
    for (var i = 0; i < monthsDiff; i++) {
        var nextMonth = dateFns$1.addMonths(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths)
        months = months.reverse();
    return months;
}

/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */
function getNextMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = dateFns$1.startOfMonth(startingMonth);
    if (!toDate) {
        return dateFns$1.addMonths(month, offset);
    }
    var monthsDiff = dateFns$1.differenceInCalendarMonths(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) {
        return undefined;
    }
    // Jump forward as the number of months when paged navigation
    return dateFns$1.addMonths(month, offset);
}

/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */
function getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) {
        return undefined;
    }
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = dateFns$1.startOfMonth(startingMonth);
    if (!fromDate) {
        return dateFns$1.addMonths(month, -offset);
    }
    var monthsDiff = dateFns$1.differenceInCalendarMonths(month, fromDate);
    if (monthsDiff <= 0) {
        return undefined;
    }
    // Jump back as the number of months when paged navigation
    return dateFns$1.addMonths(month, -offset);
}

/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */
var NavigationContext = react.createContext(undefined);
/** Provides the values for the {@link NavigationContext}. */
function NavigationProvider(props) {
    var dayPicker = useDayPicker();
    var _a = useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = getNextMonth(currentMonth, dayPicker);
    var previousMonth = getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function (date) {
        return displayMonths.some(function (displayMonth) {
            return dateFns$1.isSameMonth(date, displayMonth);
        });
    };
    var goToDate = function (date, refDate) {
        if (isDateDisplayed(date)) {
            return;
        }
        if (refDate && dateFns$1.isBefore(date, refDate)) {
            goToMonth(dateFns$1.addMonths(date, 1 + dayPicker.numberOfMonths * -1));
        }
        else {
            goToMonth(date);
        }
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (jsxRuntime.jsx(NavigationContext.Provider, { value: value, children: props.children }));
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useNavigation() {
    var context = react.useContext(NavigationContext);
    if (!context) {
        throw new Error('useNavigation must be used within a NavigationProvider');
    }
    return context;
}

/**
 * Render a caption with the dropdowns to navigate between months and years.
 */
function CaptionDropdowns(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = useNavigation().goToMonth;
    var handleMonthChange = function (newMonth) {
        goToMonth(dateFns$1.addMonths(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var captionLabel = (jsxRuntime.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    return (jsxRuntime.jsxs("div", { className: classNames.caption_dropdowns, style: styles.caption_dropdowns, children: [jsxRuntime.jsx("div", { className: classNames.vhidden, children: captionLabel }), jsxRuntime.jsx(MonthsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth }), jsxRuntime.jsx(YearsDropdown, { onChange: handleMonthChange, displayMonth: props.displayMonth })] }));
}

/**
 * Render the "previous month" button in the navigation.
 */
function IconLeft(props) {
    return (jsxRuntime.jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsxRuntime.jsx("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) })));
}

/**
 * Render the "next month" button in the navigation.
 */
function IconRight(props) {
    return (jsxRuntime.jsx("svg", __assign({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, props, { children: jsxRuntime.jsx("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) })));
}

/** Render a button HTML element applying the reset class name. */
var Button = react.forwardRef(function (props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [classNames.button_reset, classNames.button];
    if (props.className) {
        classNamesArr.push(props.className);
    }
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) {
        Object.assign(style, props.style);
    }
    return (jsxRuntime.jsx("button", __assign({}, props, { ref: ref, type: "button", className: className, style: style })));
});

/** A component rendering the navigation buttons or the drop-downs. */
function Navigation(props) {
    var _a, _b;
    var _c = useDayPicker(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) {
        return jsxRuntime.jsx(jsxRuntime.Fragment, {});
    }
    var previousLabel = labelPrevious(props.previousMonth, { locale: locale });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(props.nextMonth, { locale: locale });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(' ');
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : IconRight;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : IconLeft;
    return (jsxRuntime.jsxs("div", { className: classNames.nav, style: styles.nav, children: [!props.hidePrevious && (jsxRuntime.jsx(Button, { name: "previous-month", "aria-label": previousLabel, className: previousClassName, style: styles.nav_button_previous, disabled: !props.previousMonth, onClick: props.onPreviousClick, children: dir === 'rtl' ? (jsxRuntime.jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (jsxRuntime.jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) })), !props.hideNext && (jsxRuntime.jsx(Button, { name: "next-month", "aria-label": nextLabel, className: nextClassName, style: styles.nav_button_next, disabled: !props.nextMonth, onClick: props.onNextClick, children: dir === 'rtl' ? (jsxRuntime.jsx(IconLeftComponent, { className: classNames.nav_icon, style: styles.nav_icon })) : (jsxRuntime.jsx(IconRightComponent, { className: classNames.nav_icon, style: styles.nav_icon })) }))] }));
}

/**
 * Render a caption with a button-based navigation.
 */
function CaptionNavigation(props) {
    var numberOfMonths = useDayPicker().numberOfMonths;
    var _a = useNavigation(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function (month) {
        return dateFns$1.isSameMonth(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function () {
        if (!previousMonth)
            return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function () {
        if (!nextMonth)
            return;
        goToMonth(nextMonth);
    };
    return (jsxRuntime.jsx(Navigation, { displayMonth: props.displayMonth, hideNext: hideNext, hidePrevious: hidePrevious, nextMonth: nextMonth, previousMonth: previousMonth, onPreviousClick: handlePreviousClick, onNextClick: handleNextClick }));
}

/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */
function Caption(props) {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : CaptionLabel;
    var caption;
    if (disableNavigation) {
        caption = (jsxRuntime.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth }));
    }
    else if (captionLayout === 'dropdown') {
        caption = (jsxRuntime.jsx(CaptionDropdowns, { displayMonth: props.displayMonth, id: props.id }));
    }
    else if (captionLayout === 'dropdown-buttons') {
        caption = (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(CaptionDropdowns, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id }), jsxRuntime.jsx(CaptionNavigation, { displayMonth: props.displayMonth, displayIndex: props.displayIndex, id: props.id })] }));
    }
    else {
        caption = (jsxRuntime.jsxs(jsxRuntime.Fragment, { children: [jsxRuntime.jsx(CaptionLabelComponent, { id: props.id, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsxRuntime.jsx(CaptionNavigation, { displayMonth: props.displayMonth, id: props.id })] }));
    }
    return (jsxRuntime.jsx("div", { className: classNames.caption, style: styles.caption, children: caption }));
}

/** Render the Footer component (empty as default).*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function Footer(props) {
    var _a = useDayPicker(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer)
        return jsxRuntime.jsx(jsxRuntime.Fragment, {});
    return (jsxRuntime.jsx("tfoot", { className: tfoot, style: styles.tfoot, children: jsxRuntime.jsx("tr", { children: jsxRuntime.jsx("td", { colSpan: 8, children: footer }) }) }));
}

/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */
function getWeekdays(locale, 
/** The index of the first day of the week (0 - Sunday). */
weekStartsOn, 
/** Use ISOWeek instead of locale/ */
ISOWeek) {
    var start = ISOWeek
        ? dateFns$1.startOfISOWeek(new Date())
        : dateFns$1.startOfWeek(new Date(), { locale: locale, weekStartsOn: weekStartsOn });
    var days = [];
    for (var i = 0; i < 7; i++) {
        var day = dateFns$1.addDays(start, i);
        days.push(day);
    }
    return days;
}

/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */
function HeadRow() {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = getWeekdays(locale, weekStartsOn, ISOWeek);
    return (jsxRuntime.jsxs("tr", { style: styles.head_row, className: classNames.head_row, children: [showWeekNumber && (jsxRuntime.jsx("td", { style: styles.head_cell, className: classNames.head_cell })), weekdays.map(function (weekday, i) { return (jsxRuntime.jsx("th", { scope: "col", className: classNames.head_cell, style: styles.head_cell, "aria-label": labelWeekday(weekday, { locale: locale }), children: formatWeekdayName(weekday, { locale: locale }) }, i)); })] }));
}

/** Render the table head. */
function Head() {
    var _a;
    var _b = useDayPicker(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : HeadRow;
    return (jsxRuntime.jsx("thead", { style: styles.head, className: classNames.head, children: jsxRuntime.jsx(HeadRowComponent, {}) }));
}

/** Render the content of the day cell. */
function DayContent(props) {
    var _a = useDayPicker(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return jsxRuntime.jsx(jsxRuntime.Fragment, { children: formatDay(props.date, { locale: locale }) });
}

/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */
var SelectMultipleContext = react.createContext(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */
function SelectMultipleProvider(props) {
    if (!isDayPickerMultiple(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (jsxRuntime.jsx(SelectMultipleContext.Provider, { value: emptyContextValue, children: props.children }));
    }
    return (jsxRuntime.jsx(SelectMultipleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectMultipleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) {
            return;
        }
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) {
            return;
        }
        var selectedDays = selected ? __spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function (selectedDay) {
                return dateFns$1.isSameDay(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        }
        else {
            selectedDays.push(day);
        }
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) {
        modifiers.disabled.push(function (day) {
            var isMaxSelected = max && selected.length > max - 1;
            var isSelected = selected.some(function (selectedDay) {
                return dateFns$1.isSameDay(selectedDay, day);
            });
            return Boolean(isMaxSelected && !isSelected);
        });
    }
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (jsxRuntime.jsx(SelectMultipleContext.Provider, { value: contextValue, children: children }));
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectMultiple() {
    var context = react.useContext(SelectMultipleContext);
    if (!context) {
        throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    }
    return context;
}

/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */
function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if (dateFns$1.isSameDay(to, day) && dateFns$1.isSameDay(from, day)) {
            return undefined;
        }
        if (dateFns$1.isSameDay(to, day)) {
            return { from: to, to: undefined };
        }
        if (dateFns$1.isSameDay(from, day)) {
            return undefined;
        }
        if (dateFns$1.isAfter(from, day)) {
            return { from: day, to: to };
        }
        return { from: from, to: day };
    }
    if (to) {
        if (dateFns$1.isAfter(day, to)) {
            return { from: to, to: day };
        }
        return { from: day, to: to };
    }
    if (from) {
        if (dateFns$1.isBefore(day, from)) {
            return { from: day, to: from };
        }
        return { from: from, to: day };
    }
    return { from: day, to: undefined };
}

/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */
var SelectRangeContext = react.createContext(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */
function SelectRangeProvider(props) {
    if (!isDayPickerRange(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (jsxRuntime.jsx(SelectRangeContext.Provider, { value: emptyContextValue, children: props.children }));
    }
    return (jsxRuntime.jsx(SelectRangeProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectRangeProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        var newRange = addToRange(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [selectedFrom];
        if (!selectedTo) {
            modifiers.range_end = [selectedFrom];
        }
        else {
            modifiers.range_end = [selectedTo];
            if (!dateFns$1.isSameDay(selectedFrom, selectedTo)) {
                modifiers.range_middle = [
                    {
                        after: selectedFrom,
                        before: selectedTo
                    }
                ];
            }
        }
    }
    else if (selectedTo) {
        modifiers.range_start = [selectedTo];
        modifiers.range_end = [selectedTo];
    }
    if (min) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                after: dateFns$1.subDays(selectedFrom, min - 1),
                before: dateFns$1.addDays(selectedFrom, min - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: selectedFrom,
                before: dateFns$1.addDays(selectedFrom, min - 1)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                after: dateFns$1.subDays(selectedTo, min - 1),
                before: dateFns$1.addDays(selectedTo, min - 1)
            });
        }
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: dateFns$1.addDays(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: dateFns$1.addDays(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = dateFns$1.differenceInCalendarDays(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: dateFns$1.subDays(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: dateFns$1.addDays(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: dateFns$1.addDays(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: dateFns$1.addDays(selectedTo, max - 1)
            });
        }
    }
    return (jsxRuntime.jsx(SelectRangeContext.Provider, { value: { selected: selected, onDayClick: onDayClick, modifiers: modifiers }, children: children }));
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectRange() {
    var context = react.useContext(SelectRangeContext);
    if (!context) {
        throw new Error('useSelectRange must be used within a SelectRangeProvider');
    }
    return context;
}

/** Normalize to array a matcher input. */
function matcherToArray(matcher) {
    if (Array.isArray(matcher)) {
        return __spreadArray([], matcher, true);
    }
    else if (matcher !== undefined) {
        return [matcher];
    }
    else {
        return [];
    }
}

/** Create CustomModifiers from dayModifiers */
function getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function (_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = matcherToArray(matcher);
    });
    return customModifiers;
}

/** The name of the modifiers that are used internally by DayPicker. */
exports.InternalModifier = void 0;
(function (InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */
    InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */
    InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */
    InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */
    InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */
    InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */
    InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */
    InternalModifier["RangeMiddle"] = "range_middle";
})(exports.InternalModifier || (exports.InternalModifier = {}));

var Selected = exports.InternalModifier.Selected, Disabled = exports.InternalModifier.Disabled, Hidden = exports.InternalModifier.Hidden, Today = exports.InternalModifier.Today, RangeEnd = exports.InternalModifier.RangeEnd, RangeMiddle = exports.InternalModifier.RangeMiddle, RangeStart = exports.InternalModifier.RangeStart, Outside = exports.InternalModifier.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */
function getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {},
        _a[Selected] = matcherToArray(dayPicker.selected),
        _a[Disabled] = matcherToArray(dayPicker.disabled),
        _a[Hidden] = matcherToArray(dayPicker.hidden),
        _a[Today] = [dayPicker.today],
        _a[RangeEnd] = [],
        _a[RangeMiddle] = [],
        _a[RangeStart] = [],
        _a[Outside] = [],
        _a);
    if (dayPicker.fromDate) {
        internalModifiers[Disabled].push({ before: dayPicker.fromDate });
    }
    if (dayPicker.toDate) {
        internalModifiers[Disabled].push({ after: dayPicker.toDate });
    }
    if (isDayPickerMultiple(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectMultiple.modifiers[Disabled]);
    }
    else if (isDayPickerRange(dayPicker)) {
        internalModifiers[Disabled] = internalModifiers[Disabled].concat(selectRange.modifiers[Disabled]);
        internalModifiers[RangeStart] = selectRange.modifiers[RangeStart];
        internalModifiers[RangeMiddle] = selectRange.modifiers[RangeMiddle];
        internalModifiers[RangeEnd] = selectRange.modifiers[RangeEnd];
    }
    return internalModifiers;
}

/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */
var ModifiersContext = react.createContext(undefined);
/** Provide the value for the {@link ModifiersContext}. */
function ModifiersProvider(props) {
    var dayPicker = useDayPicker();
    var selectMultiple = useSelectMultiple();
    var selectRange = useSelectRange();
    var internalModifiers = getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = getCustomModifiers(dayPicker.modifiers);
    var modifiers = __assign(__assign({}, internalModifiers), customModifiers);
    return (jsxRuntime.jsx(ModifiersContext.Provider, { value: modifiers, children: props.children }));
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */
function useModifiers() {
    var context = react.useContext(ModifiersContext);
    if (!context) {
        throw new Error('useModifiers must be used within a ModifiersProvider');
    }
    return context;
}

/** Returns true if `matcher` is of type {@link DateInterval}. */
function isDateInterval(matcher) {
    return Boolean(matcher &&
        typeof matcher === 'object' &&
        'before' in matcher &&
        'after' in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */
function isDateRange(value) {
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */
function isDateAfterType(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */
function isDateBeforeType(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */
function isDayOfWeekType(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}

/** Return `true` whether `date` is inside `range`. */
function isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = dateFns$1.differenceInCalendarDays(to, from) < 0;
        if (isRangeInverted) {
            _a = [to, from], from = _a[0], to = _a[1];
        }
        var isInRange = dateFns$1.differenceInCalendarDays(date, from) >= 0 &&
            dateFns$1.differenceInCalendarDays(to, date) >= 0;
        return isInRange;
    }
    if (to) {
        return dateFns$1.isSameDay(to, date);
    }
    if (from) {
        return dateFns$1.isSameDay(from, date);
    }
    return false;
}

/** Returns true if `value` is a Date type. */
function isDateType(value) {
    return dateFns$1.isDate(value);
}
/** Returns true if `value` is an array of valid dates. */
function isArrayOfDates(value) {
    return Array.isArray(value) && value.every(dateFns$1.isDate);
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */
function isMatch(day, matchers) {
    return matchers.some(function (matcher) {
        if (typeof matcher === 'boolean') {
            return matcher;
        }
        if (isDateType(matcher)) {
            return dateFns$1.isSameDay(day, matcher);
        }
        if (isArrayOfDates(matcher)) {
            return matcher.includes(day);
        }
        if (isDateRange(matcher)) {
            return isDateInRange(day, matcher);
        }
        if (isDayOfWeekType(matcher)) {
            return matcher.dayOfWeek.includes(day.getDay());
        }
        if (isDateInterval(matcher)) {
            var diffBefore = dateFns$1.differenceInCalendarDays(matcher.before, day);
            var diffAfter = dateFns$1.differenceInCalendarDays(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = dateFns$1.isAfter(matcher.before, matcher.after);
            if (isClosedInterval) {
                return isDayAfter && isDayBefore;
            }
            else {
                return isDayBefore || isDayAfter;
            }
        }
        if (isDateAfterType(matcher)) {
            return dateFns$1.differenceInCalendarDays(day, matcher.after) > 0;
        }
        if (isDateBeforeType(matcher)) {
            return dateFns$1.differenceInCalendarDays(matcher.before, day) > 0;
        }
        if (typeof matcher === 'function') {
            return matcher(day);
        }
        return false;
    });
}

/** Return the active modifiers for the given day. */
function getActiveModifiers(day, 
/** The modifiers to match for the given date. */
modifiers, 
/** The month where the day is displayed, to add the "outside" modifiers.  */
displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function (result, key) {
        var modifier = modifiers[key];
        if (isMatch(day, modifier)) {
            result.push(key);
        }
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function (modifier) { return (activeModifiers[modifier] = true); });
    if (displayMonth && !dateFns$1.isSameMonth(day, displayMonth)) {
        activeModifiers.outside = true;
    }
    return activeModifiers;
}

/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */
function getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = dateFns$1.startOfMonth(displayMonths[0]);
    var lastDayInMonth = dateFns$1.endOfMonth(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while (date <= lastDayInMonth) {
        var activeModifiers = getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = dateFns$1.addDays(date, 1);
            continue;
        }
        if (activeModifiers.selected) {
            return date;
        }
        if (activeModifiers.today && !today) {
            today = date;
        }
        if (!firstFocusableDay) {
            firstFocusableDay = date;
        }
        date = dateFns$1.addDays(date, 1);
    }
    if (today) {
        return today;
    }
    else {
        return firstFocusableDay;
    }
}

var MAX_RETRY = 365;
/** Return the next date to be focused. */
function getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? { count: 0, lastFocused: focusedDay } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: dateFns$1.addDays,
        week: dateFns$1.addWeeks,
        month: dateFns$1.addMonths,
        year: dateFns$1.addYears,
        startOfWeek: function (date) {
            return context.ISOWeek
                ? dateFns$1.startOfISOWeek(date)
                : dateFns$1.startOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        },
        endOfWeek: function (date) {
            return context.ISOWeek
                ? dateFns$1.endOfISOWeek(date)
                : dateFns$1.endOfWeek(date, { locale: locale, weekStartsOn: weekStartsOn });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === 'after' ? 1 : -1);
    if (direction === 'before' && fromDate) {
        newFocusedDay = dateFns$1.max([fromDate, newFocusedDay]);
    }
    else if (direction === 'after' && toDate) {
        newFocusedDay = dateFns$1.min([toDate, newFocusedDay]);
    }
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) {
        return newFocusedDay;
    }
    else {
        if (retry.count > MAX_RETRY) {
            return retry.lastFocused;
        }
        return getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: __assign(__assign({}, retry), { count: retry.count + 1 })
        });
    }
}

/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */
var FocusContext = react.createContext(undefined);
/** The provider for the {@link FocusContext}. */
function FocusProvider(props) {
    var navigation = useNavigation();
    var modifiers = useModifiers();
    var _a = react.useState(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = react.useState(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : (lastFocused && navigation.isDateDisplayed(lastFocused)))
        ? lastFocused
        : initialFocusTarget;
    var blur = function () {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function (date) {
        setFocusedDay(date);
    };
    var context = useDayPicker();
    var moveFocus = function (moveBy, direction) {
        if (!focusedDay)
            return;
        var nextFocused = getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if (dateFns$1.isSameDay(focusedDay, nextFocused))
            return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function () { return moveFocus('day', 'after'); },
        focusDayBefore: function () { return moveFocus('day', 'before'); },
        focusWeekAfter: function () { return moveFocus('week', 'after'); },
        focusWeekBefore: function () { return moveFocus('week', 'before'); },
        focusMonthBefore: function () { return moveFocus('month', 'before'); },
        focusMonthAfter: function () { return moveFocus('month', 'after'); },
        focusYearBefore: function () { return moveFocus('year', 'before'); },
        focusYearAfter: function () { return moveFocus('year', 'after'); },
        focusStartOfWeek: function () { return moveFocus('startOfWeek', 'before'); },
        focusEndOfWeek: function () { return moveFocus('endOfWeek', 'after'); }
    };
    return (jsxRuntime.jsx(FocusContext.Provider, { value: value, children: props.children }));
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useFocusContext() {
    var context = react.useContext(FocusContext);
    if (!context) {
        throw new Error('useFocusContext must be used within a FocusProvider');
    }
    return context;
}

/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */
function useActiveModifiers(day, 
/**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */
displayMonth) {
    var modifiers = useModifiers();
    var activeModifiers = getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}

/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */
var SelectSingleContext = react.createContext(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */
function SelectSingleProvider(props) {
    if (!isDayPickerSingle(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (jsxRuntime.jsx(SelectSingleContext.Provider, { value: emptyContextValue, children: props.children }));
    }
    return (jsxRuntime.jsx(SelectSingleProviderInternal, { initialProps: props.initialProps, children: props.children }));
}
function SelectSingleProviderInternal(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function (day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 ? void 0 : _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 ? void 0 : _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 ? void 0 : _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (jsxRuntime.jsx(SelectSingleContext.Provider, { value: contextValue, children: children }));
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */
function useSelectSingle() {
    var context = react.useContext(SelectSingleContext);
    if (!context) {
        throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    }
    return context;
}

/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */
function useDayEventHandlers(date, activeModifiers) {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var _a = useFocusContext(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function (e) {
        var _a, _b, _c, _d;
        if (isDayPickerSingle(dayPicker)) {
            (_a = single.onDayClick) === null || _a === void 0 ? void 0 : _a.call(single, date, activeModifiers, e);
        }
        else if (isDayPickerMultiple(dayPicker)) {
            (_b = multiple.onDayClick) === null || _b === void 0 ? void 0 : _b.call(multiple, date, activeModifiers, e);
        }
        else if (isDayPickerRange(dayPicker)) {
            (_c = range.onDayClick) === null || _c === void 0 ? void 0 : _c.call(range, date, activeModifiers, e);
        }
        else {
            (_d = dayPicker.onDayClick) === null || _d === void 0 ? void 0 : _d.call(dayPicker, date, activeModifiers, e);
        }
    };
    var onFocus = function (e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function (e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function (e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function (e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function (e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function (e) {
        var _a;
        switch (e.key) {
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayAfter() : focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayBefore() : focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 ? void 0 : _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}

/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */
function useSelectedDays() {
    var dayPicker = useDayPicker();
    var single = useSelectSingle();
    var multiple = useSelectMultiple();
    var range = useSelectRange();
    var selectedDays = isDayPickerSingle(dayPicker)
        ? single.selected
        : isDayPickerMultiple(dayPicker)
            ? multiple.selected
            : isDayPickerRange(dayPicker)
                ? range.selected
                : undefined;
    return selectedDays;
}

function isInternalModifier(modifier) {
    return Object.values(exports.InternalModifier).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */
function getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [dayPicker.classNames.day];
    Object.keys(activeModifiers).forEach(function (modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) {
            classNames.push(customClassName);
        }
        else if (isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) {
                classNames.push(internalClassName);
            }
        }
    });
    return classNames;
}

/** Return the style for the Day element, according to the given active modifiers. */
function getDayStyle(dayPicker, activeModifiers) {
    var style = __assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function (modifier) {
        var _a;
        style = __assign(__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}

/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */
function useDayRender(
/** The date to render. */
day, 
/** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */
displayMonth, 
/** A ref to the button element that will be target of focus when rendered (if required). */
buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var activeModifiers = useActiveModifiers(day, displayMonth);
    var eventHandlers = useDayEventHandlers(day, activeModifiers);
    var selectedDays = useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== 'default');
    // Focus the button if the day is focused according to the focus context
    react.useEffect(function () {
        var _a;
        if (activeModifiers.outside)
            return;
        if (!focusContext.focusedDay)
            return;
        if (!isButton)
            return;
        if (dateFns$1.isSameDay(focusContext.focusedDay, day)) {
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = getDayClassNames(dayPicker, activeModifiers).join(' ');
    var style = getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean((activeModifiers.outside && !dayPicker.showOutsideDays) ||
        activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : DayContent;
    var children = (jsxRuntime.jsx(DayContentComponent, { date: day, displayMonth: displayMonth, activeModifiers: activeModifiers }));
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: 'gridcell'
    };
    var isFocusTarget = focusContext.focusTarget &&
        dateFns$1.isSameDay(focusContext.focusTarget, day) &&
        !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && dateFns$1.isSameDay(focusContext.focusedDay, day);
    var buttonProps = __assign(__assign(__assign({}, divProps), (_a = { disabled: activeModifiers.disabled, role: 'gridcell' }, _a['aria-selected'] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}

/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
function Day(props) {
    var buttonRef = react.useRef(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) {
        return jsxRuntime.jsx("div", { role: "gridcell" });
    }
    if (!dayRender.isButton) {
        return jsxRuntime.jsx("div", __assign({}, dayRender.divProps));
    }
    return jsxRuntime.jsx(Button, __assign({ name: "day", ref: buttonRef }, dayRender.buttonProps));
}

/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */
function WeekNumber(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = useDayPicker(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), { locale: locale });
    if (!onWeekNumberClick) {
        return (jsxRuntime.jsx("span", { className: classNames.weeknumber, style: styles.weeknumber, children: content }));
    }
    var label = labelWeekNumber(Number(weekNumber), { locale: locale });
    var handleClick = function (e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (jsxRuntime.jsx(Button, { name: "week-number", "aria-label": label, className: classNames.weeknumber, style: styles.weeknumber, onClick: handleClick, children: content }));
}

/** Render a row in the calendar, with the days and the week number. */
function Row(props) {
    var _a, _b;
    var _c = useDayPicker(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : Day;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : WeekNumber;
    var weekNumberCell;
    if (showWeekNumber) {
        weekNumberCell = (jsxRuntime.jsx("td", { className: classNames.cell, style: styles.cell, children: jsxRuntime.jsx(WeeknumberComponent, { number: props.weekNumber, dates: props.dates }) }));
    }
    return (jsxRuntime.jsxs("tr", { className: classNames.row, style: styles.row, children: [weekNumberCell, props.dates.map(function (date) { return (jsxRuntime.jsx("td", { className: classNames.cell, style: styles.cell, role: "presentation", children: jsxRuntime.jsx(DayComponent, { displayMonth: props.displayMonth, date: date }) }, dateFns$1.getUnixTime(date))); })] }));
}

/** Return the weeks between two dates.  */
function daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? dateFns$1.endOfISOWeek(toDate)
        : dateFns$1.endOfWeek(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek)
        ? dateFns$1.startOfISOWeek(fromDate)
        : dateFns$1.startOfWeek(fromDate, options);
    var nOfDays = dateFns$1.differenceInCalendarDays(toWeek, fromWeek);
    var days = [];
    for (var i = 0; i <= nOfDays; i++) {
        days.push(dateFns$1.addDays(fromWeek, i));
    }
    var weeksInMonth = days.reduce(function (result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek)
            ? dateFns$1.getISOWeek(date)
            : dateFns$1.getWeek(date, options);
        var existingWeek = result.find(function (value) { return value.weekNumber === weekNumber; });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [date]
        });
        return result;
    }, []);
    return weeksInMonth;
}

/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */
function getMonthWeeks(month, options) {
    var weeksInMonth = daysToMonthWeeks(dateFns$1.startOfMonth(month), dateFns$1.endOfMonth(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = dateFns$1.getWeeksInMonth(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = dateFns$1.addWeeks(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = daysToMonthWeeks(dateFns$1.addWeeks(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}

/** Render the table with the calendar. */
function Table(props) {
    var _a, _b, _c;
    var _d = useDayPicker(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : Head;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : Row;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : Footer;
    return (jsxRuntime.jsxs("table", { id: props.id, className: classNames.table, style: styles.table, role: "grid", "aria-labelledby": props['aria-labelledby'], children: [!hideHead && jsxRuntime.jsx(HeadComponent, {}), jsxRuntime.jsx("tbody", { className: classNames.tbody, style: styles.tbody, children: weeks.map(function (week) { return (jsxRuntime.jsx(RowComponent, { displayMonth: props.displayMonth, dates: week.dates, weekNumber: week.weekNumber }, week.weekNumber)); }) }), jsxRuntime.jsx(FooterComponent, { displayMonth: props.displayMonth })] }));
}

/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */
function canUseDOM() {
    return !!(typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */
var useIsomorphicLayoutEffect = canUseDOM() ? react.useLayoutEffect : react.useEffect;
var serverHandoffComplete = false;
var id = 0;
function genId() {
    return "react-day-picker-".concat(++id);
}
function useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : (serverHandoffComplete ? genId() : null);
    var _b = react.useState(initialId), id = _b[0], setId = _b[1];
    useIsomorphicLayoutEffect(function () {
        if (id === null) {
            // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
            // rendering flicker, though it'll make the first render slower (unlikely
            // to matter, but you're welcome to measure your app and let us know if
            // it's a problem).
            setId(genId());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react.useEffect(function () {
        if (serverHandoffComplete === false) {
            // Flag all future uses of `useId` to skip the update dance. This is in
            // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
            // accidentally bail out of the patch-up dance prematurely.
            serverHandoffComplete = true;
        }
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}

/** Render a month. */
function Month(props) {
    var _a;
    var _b;
    var dayPicker = useDayPicker();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = useNavigation().displayMonths;
    var captionId = useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id
        ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex)
        : undefined;
    var className = [classNames.month];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === 'rtl') {
        _a = [isStart, isEnd], isEnd = _a[0], isStart = _a[1];
    }
    if (isStart) {
        className.push(classNames.caption_start);
        style = __assign(__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = __assign(__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = __assign(__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : Caption;
    return (jsxRuntime.jsxs("div", { className: className.join(' '), style: style, children: [jsxRuntime.jsx(CaptionComponent, { id: captionId, displayMonth: props.displayMonth, displayIndex: props.displayIndex }), jsxRuntime.jsx(Table, { id: tableId, "aria-labelledby": captionId, displayMonth: props.displayMonth })] }, props.displayIndex));
}

/**
 * Render the wrapper for the month grids.
 */
function Months(props) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    return (jsxRuntime.jsx("div", { className: classNames.months, style: styles.months, children: props.children }));
}

/** Render the container with the months according to the number of months to display. */
function Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = useDayPicker();
    var focusContext = useFocusContext();
    var navigation = useNavigation();
    var _d = react.useState(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    react.useEffect(function () {
        if (!dayPicker.initialFocus)
            return;
        if (!focusContext.focusTarget)
            return;
        if (hasInitialFocus)
            return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [dayPicker.classNames.root, dayPicker.className];
    if (dayPicker.numberOfMonths > 1) {
        classNames.push(dayPicker.classNames.multiple_months);
    }
    if (dayPicker.showWeekNumber) {
        classNames.push(dayPicker.classNames.with_weeknumber);
    }
    var style = __assign(__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps)
        .filter(function (key) { return key.startsWith('data-'); })
        .reduce(function (attrs, key) {
        var _a;
        return __assign(__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : Months;
    return (jsxRuntime.jsx("div", __assign({ className: classNames.join(' '), style: style, dir: dayPicker.dir, id: dayPicker.id, nonce: initialProps.nonce, title: initialProps.title, lang: initialProps.lang }, dataAttributes, { children: jsxRuntime.jsx(MonthsComponent, { children: navigation.displayMonths.map(function (month, i) { return (jsxRuntime.jsx(Month, { displayIndex: i, displayMonth: month }, i)); }) }) })));
}

/** Provide the value for all the context providers. */
function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (jsxRuntime.jsx(DayPickerProvider, { initialProps: initialProps, children: jsxRuntime.jsx(NavigationProvider, { children: jsxRuntime.jsx(SelectSingleProvider, { initialProps: initialProps, children: jsxRuntime.jsx(SelectMultipleProvider, { initialProps: initialProps, children: jsxRuntime.jsx(SelectRangeProvider, { initialProps: initialProps, children: jsxRuntime.jsx(ModifiersProvider, { children: jsxRuntime.jsx(FocusProvider, { children: children }) }) }) }) }) }) }));
}

/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */
function DayPicker(props) {
    return (jsxRuntime.jsx(RootProvider, __assign({}, props, { children: jsxRuntime.jsx(Root, { initialProps: props }) })));
}

/** @private */
function isValidDate(day) {
    return !isNaN(day.getTime());
}

/** Return props and setters for binding an input field to DayPicker. */
function useInput(options) {
    if (options === void 0) { options = {}; }
    var _a = options.locale, locale$1$1 = _a === void 0 ? locale$1.enUS : _a, required = options.required, _b = options.format, format = _b === void 0 ? 'PP' : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function (value) { return dateFns$1.parse(value, format, today, { locale: locale$1$1 }); };
    // Initialize states
    var _e = react.useState(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = react.useState(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected
        ? dateFns$1.format(defaultSelected, format, { locale: locale$1$1 })
        : '';
    var _g = react.useState(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function () {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : '');
    };
    var setSelected = function (date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? dateFns$1.format(date, format, { locale: locale$1$1 }) : '');
    };
    var handleDayClick = function (day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue('');
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? dateFns$1.format(day, format, { locale: locale$1$1 }) : '');
    };
    var handleMonthChange = function (month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function (e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && dateFns$1.differenceInCalendarDays(fromDate, day) > 0;
        var isAfter = toDate && dateFns$1.differenceInCalendarDays(day, toDate) > 0;
        if (!isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function (e) {
        var day = parseValue(e.target.value);
        if (!isValidDate(day)) {
            reset();
        }
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function (e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if (isValidDate(day)) {
            setMonth(day);
        }
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale$1$1,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: dateFns$1.format(new Date(), format, { locale: locale$1$1 })
    };
    return { dayPickerProps: dayPickerProps, inputProps: inputProps, reset: reset, setSelected: setSelected };
}

/** Returns true when the props are of type {@link DayPickerDefaultProps}. */
function isDayPickerDefault(props) {
    return props.mode === undefined || props.mode === 'default';
}

exports.Button = Button;
exports.Caption = Caption;
exports.CaptionDropdowns = CaptionDropdowns;
exports.CaptionLabel = CaptionLabel;
exports.CaptionNavigation = CaptionNavigation;
exports.Day = Day;
exports.DayContent = DayContent;
exports.DayPicker = DayPicker;
exports.DayPickerContext = DayPickerContext;
exports.DayPickerProvider = DayPickerProvider;
exports.Dropdown = Dropdown;
exports.FocusContext = FocusContext;
exports.FocusProvider = FocusProvider;
exports.Footer = Footer;
exports.Head = Head;
exports.HeadRow = HeadRow;
exports.IconDropdown = IconDropdown;
exports.IconLeft = IconLeft;
exports.IconRight = IconRight;
exports.Months = Months;
exports.NavigationContext = NavigationContext;
exports.NavigationProvider = NavigationProvider;
exports.RootProvider = RootProvider;
exports.Row = Row;
exports.SelectMultipleContext = SelectMultipleContext;
exports.SelectMultipleProvider = SelectMultipleProvider;
exports.SelectMultipleProviderInternal = SelectMultipleProviderInternal;
exports.SelectRangeContext = SelectRangeContext;
exports.SelectRangeProvider = SelectRangeProvider;
exports.SelectRangeProviderInternal = SelectRangeProviderInternal;
exports.SelectSingleContext = SelectSingleContext;
exports.SelectSingleProvider = SelectSingleProvider;
exports.SelectSingleProviderInternal = SelectSingleProviderInternal;
exports.WeekNumber = WeekNumber;
exports.addToRange = addToRange;
exports.isDateAfterType = isDateAfterType;
exports.isDateBeforeType = isDateBeforeType;
exports.isDateInterval = isDateInterval;
exports.isDateRange = isDateRange;
exports.isDayOfWeekType = isDayOfWeekType;
exports.isDayPickerDefault = isDayPickerDefault;
exports.isDayPickerMultiple = isDayPickerMultiple;
exports.isDayPickerRange = isDayPickerRange;
exports.isDayPickerSingle = isDayPickerSingle;
exports.isMatch = isMatch;
exports.useActiveModifiers = useActiveModifiers;
exports.useDayPicker = useDayPicker;
exports.useDayRender = useDayRender;
exports.useFocusContext = useFocusContext;
exports.useInput = useInput;
exports.useNavigation = useNavigation;
exports.useSelectMultiple = useSelectMultiple;
exports.useSelectRange = useSelectRange;
exports.useSelectSingle = useSelectSingle;

}(dist$4));

var css_248z$1a = ".style_rdp__X3YUi {\n  --rdp-cell-size: 40px; /* Size of the day cells. */\n  --rdp-caption-font-size: 18px; /* Font size for the caption labels. */\n  --rdp-accent-color: #0000ff; /* Accent color for the background of selected days. */\n  --rdp-background-color: #e7edff; /* Background color for the hovered/focused elements. */\n  --rdp-accent-color-dark: #3003e1; /* Accent color for the background of selected days (to use in dark-mode). */\n  --rdp-background-color-dark: #180270; /* Background color for the hovered/focused elements (to use in dark-mode). */\n  --rdp-outline: 2px solid var(--rdp-accent-color); /* Outline border for focused elements */\n  --rdp-outline-selected: 3px solid var(--rdp-accent-color); /* Outline border for focused _and_ selected elements */\n  --rdp-selected-color: #fff; /* Color of selected day text */\n\n  margin: 1em;\n}\n\n/* Hide elements for devices that are not screen readers */\n.style_rdp-vhidden__xlr7p {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  border: 0;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  position: absolute !important;\n  top: 0;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  border: 0 !important;\n}\n\n/* Buttons */\n.style_rdp-button_reset__y4hiA {\n  appearance: none;\n  position: relative;\n  margin: 0;\n  padding: 0;\n  cursor: default;\n  color: inherit;\n  background: none;\n  font: inherit;\n\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n\n.style_rdp-button_reset__y4hiA:focus-visible {\n  /* Make sure to reset outline only when :focus-visible is supported */\n  outline: none;\n}\n\n.style_rdp-button__KZowZ {\n  border: 2px solid transparent;\n}\n\n.style_rdp-button__KZowZ[disabled]:not(.style_rdp-day_selected__flp1f) {\n  opacity: 0.25;\n}\n\n.style_rdp-button__KZowZ:not([disabled]) {\n  cursor: pointer;\n}\n\n.style_rdp-button__KZowZ:focus-visible:not([disabled]) {\n  color: inherit;\n  background-color: var(--rdp-background-color);\n  border: var(--rdp-outline);\n}\n\n.style_rdp-button__KZowZ:hover:not([disabled]):not(.style_rdp-day_selected__flp1f) {\n  background-color: var(--rdp-background-color);\n}\n\n.style_rdp-months__QBxP0 {\n  display: flex;\n}\n\n.style_rdp-month__aQl-B {\n  margin: 0 1em;\n}\n\n.style_rdp-month__aQl-B:first-child {\n  margin-left: 0;\n}\n\n.style_rdp-month__aQl-B:last-child {\n  margin-right: 0;\n}\n\n.style_rdp-table__VwTac {\n  margin: 0;\n  max-width: calc(var(--rdp-cell-size) * 7);\n  border-collapse: collapse;\n}\n\n.style_rdp-with_weeknumber__St7o2 .style_rdp-table__VwTac {\n  max-width: calc(var(--rdp-cell-size) * 8);\n  border-collapse: collapse;\n}\n\n.style_rdp-caption__0ar1e {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0;\n  text-align: left;\n}\n\n.style_rdp-multiple_months__BzPEi .style_rdp-caption__0ar1e {\n  position: relative;\n  display: block;\n  text-align: center;\n}\n\n.style_rdp-caption_dropdowns__Z8QMf {\n  position: relative;\n  display: inline-flex;\n}\n\n.style_rdp-caption_label__tSOrV {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n  padding: 0 0.25em;\n  white-space: nowrap;\n  color: currentColor;\n  border: 0;\n  border: 2px solid transparent;\n  font-family: inherit;\n  font-size: var(--rdp-caption-font-size);\n  font-weight: bold;\n}\n\n.style_rdp-nav__MpInA {\n  white-space: nowrap;\n}\n\n.style_rdp-multiple_months__BzPEi .style_rdp-caption_start__bIAsO .style_rdp-nav__MpInA {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n}\n\n.style_rdp-multiple_months__BzPEi .style_rdp-caption_end__9v4nb .style_rdp-nav__MpInA {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n}\n\n.style_rdp-nav_button__kMTG- {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--rdp-cell-size);\n  height: var(--rdp-cell-size);\n  padding: 0.25em;\n  border-radius: 100%;\n}\n\n/* ---------- */\n/* Dropdowns  */\n/* ---------- */\n\n.style_rdp-dropdown_year__euvUh,\n.style_rdp-dropdown_month__GS2xl {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n}\n\n.style_rdp-dropdown__LPPQb {\n  appearance: none;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  cursor: inherit;\n  opacity: 0;\n  border: none;\n  background-color: transparent;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.style_rdp-dropdown__LPPQb[disabled] {\n  opacity: unset;\n  color: unset;\n}\n\n.style_rdp-dropdown__LPPQb:focus-visible:not([disabled]) + .style_rdp-caption_label__tSOrV {\n  background-color: var(--rdp-background-color);\n  border: var(--rdp-outline);\n  border-radius: 6px;\n}\n\n.style_rdp-dropdown_icon__FyejG {\n  margin: 0 0 0 5px;\n}\n\n.style_rdp-head__4dtE6 {\n  border: 0;\n}\n\n.style_rdp-head_row__v5qx-,\n.style_rdp-row__dbG1m {\n  height: 100%;\n}\n\n.style_rdp-head_cell__vAWEc {\n  vertical-align: middle;\n  font-size: 0.75em;\n  font-weight: 700;\n  text-align: center;\n  height: 100%;\n  height: var(--rdp-cell-size);\n  padding: 0;\n  text-transform: uppercase;\n}\n\n.style_rdp-tbody__PmfxN {\n  border: 0;\n}\n\n.style_rdp-tfoot__5tcOr {\n  margin: 0.5em;\n}\n\n.style_rdp-cell__UVhWG {\n  width: var(--rdp-cell-size);\n  height: 100%;\n  height: var(--rdp-cell-size);\n  padding: 0;\n  text-align: center;\n}\n\n.style_rdp-weeknumber__jE1LW {\n  font-size: 0.75em;\n}\n\n.style_rdp-weeknumber__jE1LW,\n.style_rdp-day__fDjY7 {\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: var(--rdp-cell-size);\n  max-width: var(--rdp-cell-size);\n  height: var(--rdp-cell-size);\n  margin: 0;\n  border: 2px solid transparent;\n  border-radius: 100%;\n}\n\n.style_rdp-day_today__uBA9p:not(.style_rdp-day_outside__BkKN-) {\n  font-weight: bold;\n}\n\n.style_rdp-day_selected__flp1f,\n.style_rdp-day_selected__flp1f:focus-visible,\n.style_rdp-day_selected__flp1f:hover {\n  color: var(--rdp-selected-color);\n  opacity: 1;\n  background-color: var(--rdp-accent-color);\n}\n\n.style_rdp-day_outside__BkKN- {\n  opacity: 0.5;\n}\n\n.style_rdp-day_selected__flp1f:focus-visible {\n  /* Since the background is the same use again the outline */\n  outline: var(--rdp-outline);\n  outline-offset: 2px;\n  z-index: 1;\n}\n\n.style_rdp__X3YUi:not([dir='rtl']) .style_rdp-day_range_start__BKTjm:not(.style_rdp-day_range_end__IMFUt) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.style_rdp__X3YUi:not([dir='rtl']) .style_rdp-day_range_end__IMFUt:not(.style_rdp-day_range_start__BKTjm) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.style_rdp__X3YUi[dir='rtl'] .style_rdp-day_range_start__BKTjm:not(.style_rdp-day_range_end__IMFUt) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.style_rdp__X3YUi[dir='rtl'] .style_rdp-day_range_end__IMFUt:not(.style_rdp-day_range_start__BKTjm) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.style_rdp-day_range_end__IMFUt.style_rdp-day_range_start__BKTjm {\n  border-radius: 100%;\n}\n\n.style_rdp-day_range_middle__PvNY4 {\n  border-radius: 0;\n}";
styleInject(css_248z$1a);

var css_248z$19 = ".IconButton-module_endIcon__WBdkD {\n  margin: 0;\n  margin-left: 0px !important;\n}\n\n.IconButton-module_loading__8nf-D {\n  -webkit-animation: IconButton-module_spin__YXL2p 4s linear infinite;\n  -moz-animation: IconButton-module_spin__YXL2p 4s linear infinite;\n  animation: IconButton-module_spin__YXL2p 4s linear infinite;\n}\n\n@-moz-keyframes IconButton-module_spin__YXL2p {\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes IconButton-module_spin__YXL2p {\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@keyframes IconButton-module_spin__YXL2p {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}";
var style$R = {"endIcon":"IconButton-module_endIcon__WBdkD","loading":"IconButton-module_loading__8nf-D","spin":"IconButton-module_spin__YXL2p"};
styleInject(css_248z$19);

const IconButton = (_a) => {
    var { iconName, onClick, loading, color } = _a, props = __rest$2(_a, ["iconName", "onClick", "loading", "color"]);
    const icon = loading ? (React__default$4.createElement(Icon$1, { value: "rotate_right", className: style$R.loading })) : (React__default$4.createElement(Icon$1, { value: iconName }));
    return (React__default$4.createElement(Button, Object.assign({ variation: "flat", color: color ? color : "inherit", onClick: onClick, endIcon: icon }, props, { disabled: props.disabled || loading, classes: Object.assign(Object.assign({}, props.classes), { endIcon: style$R.endIcon }), style: { minWidth: 2, margin: 0 } })));
};

var css_248z$18 = ".Dropdown_dropdown__QS64I {\n  font-size: var(--form-control-font-size, 14px);\n  background: var(--form-control-background, #ffffff);\n  color: var(--form-control-color, #061739);\n  display: block;\n  height: var(--form-control-size, 38px);\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.25em 0.75em;\n}";
var style$Q = {"dropdown":"Dropdown_dropdown__QS64I"};
styleInject(css_248z$18);

function Dropdown(props) {
    const { disabled, value, onChange } = props;
    const handleChange = useCallback((ev) => {
        onChange(ev.target.value);
    }, [onChange]);
    return (React__default$4.createElement("select", { className: style$Q.dropdown, value: value, onChange: handleChange, disabled: disabled },
        props.placeholder && !value && (React__default$4.createElement("option", { key: undefined, value: "" }, props.placeholder)),
        props.options.map((opt) => (React__default$4.createElement("option", { key: opt.value, value: opt.value }, opt.text)))));
}

var css_248z$17 = ".Field_field__R9WzD {\n  margin-bottom: 12px;\n}\n\n.Field_fieldLabel__Z-0gG {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 18px;\n  line-height: 17px;\n  font-weight: 500;\n  color: var(--form-control-color, #061739);\n}\n\n.Field_fieldError__kC14j {\n  color: #ef828b;\n}\n\n.Field_fieldErrorState__sU-Zq {\n  --form-control-icon-color: #ef828b;\n}\n.Field_fieldErrorState__sU-Zq input, .Field_fieldErrorState__sU-Zq input:focus,\n.Field_fieldErrorState__sU-Zq textarea,\n.Field_fieldErrorState__sU-Zq textarea:focus,\n.Field_fieldErrorState__sU-Zq select,\n.Field_fieldErrorState__sU-Zq select:focus {\n  border-color: #ef828b;\n  color: #ef828b;\n  outline-color: #ef828b;\n}";
var style$P = {"field":"Field_field__R9WzD","fieldLabel":"Field_fieldLabel__Z-0gG","fieldError":"Field_fieldError__kC14j","fieldErrorState":"Field_fieldErrorState__sU-Zq"};
styleInject(css_248z$17);

const FieldInner = props => {
    const { state } = props;
    const isError = state === "error";
    return (React__default$4.createElement("div", { className: style$P.field + " " + (isError ? style$P.fieldErrorState : ""), style: props.style },
        React__default$4.createElement("label", { className: props.labelClassName },
            props.label && React__default$4.createElement("span", { className: style$P.fieldLabel }, props.label),
            props.children),
        props.errorMessage && React__default$4.createElement("div", { className: style$P.fieldError }, props.errorMessage)));
};
const Field = React__default$4.memo(FieldInner);

var css_248z$16 = ".FieldCheckbox_label__N7J-2 {\n  display: flex;\n  align-items: center;\n}\n\n.FieldCheckbox_checkbox__bl1LC {\n  order: -1;\n  margin-right: 8px;\n  width: 20px; /* Increase the size of the checkbox */\n  height: 20px; /* Increase the size of the checkbox */\n  appearance: none; /* Remove default styling */\n  background-color: #fff; /* Background color */\n  border: 2px solid #1aa7dc; /* Border color */\n  border-radius: 4px; /* Rounded corners */\n  cursor: pointer; /* Pointer cursor on hover */\n  position: relative;\n}\n\n.FieldCheckbox_checkbox__bl1LC:checked {\n  background-color: #1aa7dc; /* Background color when checked */\n  border-color: #1aa7dc; /* Border color when checked */\n}\n\n.FieldCheckbox_checkbox__bl1LC:checked::after {\n  content: \"\";\n  position: absolute;\n  top: 0px; /* Adjusted to center the check mark */\n  left: 4px; /* Adjusted to center the check mark */\n  width: 6px;\n  height: 12px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.FieldCheckbox_checkbox__bl1LC:disabled {\n  background-color: #e9ecef; /* Background color when disabled */\n  border-color: #ced4da; /* Border color when disabled */\n  cursor: not-allowed; /* Change cursor to not-allowed */\n}\n\n.FieldCheckbox_checkbox__bl1LC:disabled:checked::after {\n  border-color: #adb5bd; /* Check mark color when disabled */\n}";
var style$O = {"label":"FieldCheckbox_label__N7J-2","checkbox":"FieldCheckbox_checkbox__bl1LC"};
styleInject(css_248z$16);

const FieldCheckbox = props => {
    const { disabled, label, value, errorMessage, state, onChange, fieldStyle } = props;
    const handleChange = useCallback((ev) => {
        if (onChange) {
            onChange(ev.target.checked);
        }
    }, [onChange]);
    return (React__default$4.createElement(Field, { label: label, labelClassName: style$O.label, errorMessage: errorMessage, state: state, style: fieldStyle || undefined },
        React__default$4.createElement("input", { type: "checkbox", disabled: disabled, className: style$O.checkbox, checked: value, onChange: handleChange })));
};

function FieldDropdown(props) {
    const { label, errorMessage, state } = props;
    return (React__default$4.createElement(Field, { label: label, errorMessage: errorMessage, state: state },
        React__default$4.createElement(Dropdown, { value: props.value, onChange: props.onChange, options: props.options, placeholder: props.placeholder, disabled: props.disabled })));
}

var css_248z$15 = ".Input_inputWrapper__VA2OH {\n  position: relative;\n  width: 100%;\n  padding-bottom: 15px;\n}\n\n.Input_outlined__7vItV {\n  padding-top: 15px;\n}\n\n.Input_withHelperText__26Ucn {\n  margin-bottom: 20px;\n}\n@media screen and (max-width: 600px) {\n  .Input_withHelperText__26Ucn {\n    margin-bottom: 35px;\n  }\n}\n\n.Input_withHelperTextAndOutlined__pirRK {\n  margin-bottom: 20px;\n}\n@media screen and (max-width: 600px) {\n  .Input_withHelperTextAndOutlined__pirRK {\n    margin-bottom: 35px;\n  }\n}\n\n.Input_inputDescription__CEge2 {\n  padding-bottom: 20px;\n}\n.Input_inputDescription__CEge2 .Input_input__-5pwu {\n  height: auto;\n}\n.Input_inputDescription__CEge2 .MuiInputBase-root {\n  background: var(--form-control-background, #ffffff);\n}\n.Input_inputDescription__CEge2 textarea {\n  resize: vertical;\n  overflow-y: auto !important;\n}\n\n.Input_input__-5pwu {\n  font-size: var(--form-control-font-size, 14px);\n  background: var(--form-control-background, #ffffff);\n  color: var(--form-control-color, #061739);\n  height: var(--form-control-size, 38px);\n  width: 100%;\n  padding: 0.25em 0.75em;\n  border-radius: 12px;\n  border-width: 2px;\n  border-style: solid;\n  box-sizing: border-box;\n}\n.Input_input__-5pwu::placeholder {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 16px;\n  line-height: 17px;\n  font-weight: normal;\n  color: #969595;\n}\n\n.Input_withPrefix__z7X9X {\n  padding-left: calc(var(--form-control-size, 38px) - 2px);\n}\n\n.Input_withSuffix__RSJ9y {\n  padding-right: calc(var(--form-control-size, 38px) - 2px);\n}\n\n.Input_prefix__QNZYL,\n.Input_suffix__ocYPL {\n  position: absolute;\n  height: calc(var(--form-control-size, 38px) - 2px);\n  width: calc(var(--form-control-size, 38px) - 2px);\n  top: 0;\n  font-size: calc(var(--form-control-size, 38px) - 2px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.Input_prefix__QNZYL .material-icons,\n.Input_suffix__ocYPL .material-icons {\n  font-size: var(--form-control-icon-size, 24px);\n  color: var(--form-control-icon-color, var(--form-control-color, #061739));\n}\n\n.Input_prefix__QNZYL {\n  left: 0;\n  margin-top: 10px;\n}\n\n.Input_suffix__ocYPL {\n  right: 0;\n  margin-top: 10px;\n}\n\n@media screen and (max-width: 600px) {\n  .Input_passwordInput__uz5g7 {\n    margin-bottom: 40px;\n  }\n}";
var style$N = {"inputWrapper":"Input_inputWrapper__VA2OH","outlined":"Input_outlined__7vItV","withHelperText":"Input_withHelperText__26Ucn","withHelperTextAndOutlined":"Input_withHelperTextAndOutlined__pirRK","inputDescription":"Input_inputDescription__CEge2","input":"Input_input__-5pwu","withPrefix":"Input_withPrefix__z7X9X","withSuffix":"Input_withSuffix__RSJ9y","prefix":"Input_prefix__QNZYL","suffix":"Input_suffix__ocYPL","passwordInput":"Input_passwordInput__uz5g7"};
styleInject(css_248z$15);

const StyledTextField = styles$u.styled(TextField$1)({
    " .MuiInput-underline:after": {
        borderBottomColor: "#677389",
        borderBottom: "3px solid #677389",
    },
    "&:hover .MuiInput-underline:before": {
        borderBottom: "3px solid #677389",
    },
    "& label.Mui-focused": {
        color: "#334561",
    },
    "&:hover .MuiInput-underline:hover:before": {
        borderBottom: "none",
    },
    " .MuiInputBase-root": {
        paddingLeft: 5,
        borderRadius: 0,
    },
    "&.MuiTextField-root": {
        borderRadius: 0,
        background: "transparent",
    },
});
// Subtle Loading Overlay (shimmer effect)
const LoadingOverlay = styles$u.styled("div")(({ variation }) => {
    let nudging = { top: "0px" };
    if (variation === "standard") {
        nudging = { bottom: "5px" };
    }
    else if (variation === "outlined") {
        nudging = { bottom: "-2px" };
    }
    return Object.assign(Object.assign({ position: "absolute" }, nudging), { left: 0, width: "100%", height: "2px", background: "linear-gradient(90deg, rgba(103,115,137,0) 0%, rgba(103,115,137,0.5) 50%, rgba(103,115,137,0) 100%)", backgroundSize: "200% 100%", animation: "shimmer 2s infinite", borderRadius: "2px", pointerEvents: "none", "@keyframes shimmer": {
            "0%": { backgroundPosition: "200% 0" },
            "100%": { backgroundPosition: "-200% 0" },
        } });
});
const InputInner = (_a) => {
    var { prefixIcon, suffixIcon, variation = "standard", className, helperText, onChange, style: styleProp, multiline, loading = false, wrapperStyle, disabled, rows } = _a, props = __rest$2(_a, ["prefixIcon", "suffixIcon", "variation", "className", "helperText", "onChange", "style", "multiline", "loading", "wrapperStyle", "disabled", "rows"]);
    // Handle onChange method
    const handleChange = (event) => {
        if (onChange) {
            onChange(event.target.value, event);
        }
    };
    // Construct conditional classNames
    const wrapperClasses = classNames$1(style$N.inputWrapper, { [style$N.outlined]: variation === "outlined" }, className, {
        [style$N.inputDescription]: multiline,
        [style$N.withHelperText]: !!helperText && variation !== "outlined",
        [style$N.withHelperTextAndOutlined]: !!helperText && variation === "outlined",
    });
    const inputClasses = classNames$1(style$N.input, {
        [style$N.withPrefix]: prefixIcon,
        [style$N.withSuffix]: suffixIcon,
        [style$N.loading]: loading,
    });
    const inputStyles = Object.assign(Object.assign({}, styleProp), { marginLeft: prefixIcon ? 35 : undefined });
    const wrapperStyles = Object.assign({ position: "relative" }, wrapperStyle);
    return (React__default$4.createElement("div", { className: wrapperClasses, style: wrapperStyles },
        prefixIcon && (React__default$4.createElement("div", { className: style$N.prefix },
            React__default$4.createElement(Icon$1, { value: prefixIcon }))),
        React__default$4.createElement(StyledTextField, Object.assign({}, props, { multiline: multiline, rows: multiline ? (rows || 4) : undefined, onChange: handleChange, helperText: helperText, variant: variation, className: inputClasses, style: inputStyles, disabled: loading || disabled })),
        suffixIcon && (React__default$4.createElement("div", { className: style$N.suffix },
            React__default$4.createElement(Icon$1, { iconName: suffixIcon }))),
        loading && React__default$4.createElement(LoadingOverlay, { variation: variation })));
};
const Input$3 = React__default$4.memo(InputInner);

/**
 * Validates a given URL.
 *
 * @param url - The URL to validate.
 * @param websocket - Indicates if the URL is for a websocket connection.
 * @returns An object containing the validity of the URL and an optional error message.
 */
function validateURL(url, websocket = false) {
    // Check for spaces in the URL
    if (/\s/.test(url)) {
        return { valid: false, error: "URL must not contain spaces" };
    }
    // Check for invalid characters in the URL
    const invalidCharsPattern = /[<>^`{}|\\]/;
    if (invalidCharsPattern.test(url)) {
        return { valid: false, error: "URL contains invalid characters" };
    }
    try {
        if (websocket) {
            if (!/^wss?:\/\//i.test(url)) {
                return { valid: false, error: "URL must start with wss:// or ws://" };
            }
        }
        else {
            if (!/^https?:\/\//i.test(url)) {
                return { valid: false, error: "URL must start with https:// or http://" };
            }
        }
        const validUrl = new URL(url); // The URL constructor will throw an error if the url is invalid
        // Check if the URL has a TLD
        const tldPattern = /\.[a-z]{2,}$/i;
        if (!tldPattern.test(validUrl.hostname)) {
            return { valid: false, error: "URL must have a top-level domain. Examples are .com, .co, and .biz" };
        }
        return { valid: true };
    }
    catch (_) {
        return { valid: false, error: "Invalid URL" };
    }
}
const URLInput = (_a) => {
    var { onChange, helperText, websocket, requiredBaseUrl } = _a, props = __rest$2(_a, ["onChange", "helperText", "websocket", "requiredBaseUrl"]);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (props.value && typeof props.value === "string") {
            if (props.value.length === 0) {
                setError(null);
            }
            else {
                const isValid = validateURL(props.value, websocket);
                if (!isValid.valid) {
                    setError(isValid.error || "Invalid URL");
                }
                else {
                    setError(null);
                }
            }
        }
        else {
            if (!props.value) {
                setError(null);
            }
            else {
                setError("Invalid URL");
            }
        }
    }, [props.value, websocket]);
    const handleChange = (value) => {
        if (typeof value === "string") {
            if (requiredBaseUrl) {
                if (!value.startsWith(requiredBaseUrl)) {
                    // ignore the change, they are trying to modify the base URL
                    return;
                }
                // do not let them delete it
                if (value.length < requiredBaseUrl.length) {
                    value = requiredBaseUrl;
                }
            }
            const validity = validateURL(value);
            const valid = validity.valid;
            if (typeof onChange === "function") {
                onChange(value, valid);
            }
        }
    };
    return (React__default$4.createElement(Input$3, Object.assign({}, props, { value: requiredBaseUrl && !props.value ? requiredBaseUrl : props.value, onChange: handleChange, error: !!error, helperText: error || helperText, type: "url" // Set the type to url for client-side validation
     })));
};

// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var metadata = {"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|2[23]"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","(?:01\\d|[24-689])\\d{7}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["0"]]]],"BL":["590","00","(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","8001\\d{5}|(?:[2-467]\\d|50)\\d{6}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[235]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","[2-9]\\d{9}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["5"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]","(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123","10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["46"]],["(\\d{3})(\\d{7})","$1 $2",["6|90"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9,10,11,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[03568]","15(?:[0568]|31)"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d{5})","$1",["20[2-59]"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[68])0|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"],["(\\d)(\\d{4,9})","$1 $2",["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:[2-8]\\d{3}|9008)\\d{3}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6|7[245]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","(?:[2-489]\\d|55)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13,14,15,16,17],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11,12],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]|43"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}",[6,7,8,9,10,11]],["3[2-9]\\d{7,8}|(?:31|43)\\d{8}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],["3[2-8]\\d{9,10}",[11,12]],0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]","3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[25-9]"],"0$1"]],"0",0,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[36]0|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[0135-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["4[67]|[56]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(0-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"0 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(0-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(0-$1)",1]],"0",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"],["80[0-7]\\d{6}"],["89\\d{7}"],0,0,0,0,["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"],["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|452|678|86","[12]|452|6788|86"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670"],"MQ":["596","00","(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-79]|8(?:0[6-9]|[36])"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","[2-9]\\d{9}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"]]],0,0,0,0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[0467]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}",[8,10,11,12,13,14],[["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["3"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["20[129]"],"0$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[4-7]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}|(?:708|8\\d\\d)\\d{6}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","00","709\\d{6}|(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-9]"],"0$1"]],"0",0,0,0,0,0,[["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"],["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"],["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],"RO":["40","00","(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","[6-9]\\d{6}|[1-6]\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","(?:[2489]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10,12],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-9]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["(?:2|90)4|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|77|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721"],"SY":["963","00","[1-359]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-4]|5[1-3]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[59]"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649"],"TD":["235","00|16","(?:22|[689]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[26-9]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","[0-57-9]\\d{8}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[02-479]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3(?:[1245]|3[12])"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","(?:[1-6]\\d|71)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["[67]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"],0,0,0,["305209\\d{4}"]]],"UY":["598","0(?:0|1[3-9]\\d)","0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[6,7,8,9,10,11,12,13],[["(\\d{3})(\\d{3,4})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","00","(?:20|33|[5-9]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"]]]],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11,12],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[47-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}",[8,9,10,11,12],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2|39"],"0$1"],["(\\d{2})(\\d{7,10})","$1 $2",["3"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,0,[["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"],["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"],["80\\d{7}"],0,0,0,0,0,["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[235-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"],0,0,0,0,0,0,["2\\d{8}",[9]]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"6\\d{9}|[0-36-9]\\d{8}",[9,10],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],["(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["6\\d{9}|[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,["348[57]\\d{7}",[11]],0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],"883":["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}};

// Importing from a ".js" file is a workaround for Node.js "ES Modules"

function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments);
	args.push(metadata);
	return func.apply(this, args)
}

function _typeof$2(obj) { "@babel/helpers - typeof"; return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$2(obj); }

function _defineProperties$8(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$8(Constructor.prototype, protoProps); if (staticProps) _defineProperties$8(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn$6(this, result); }; }

function _possibleConstructorReturn$6(self, call) { if (call && (_typeof$2(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  _inherits$6(ParseError, _Error);

  var _super = _createSuper(ParseError);

  function ParseError(code) {
    var _this;

    _classCallCheck$e(this, ParseError);

    _this = _super.call(this, code); // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.

    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }

  return _createClass$e(ParseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function compare (a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

var objectConstructor = {}.constructor;
function isObject$4(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}

function _typeof$1(obj) { "@babel/helpers - typeof"; return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof$1(obj); }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$7(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$7(Constructor.prototype, protoProps); if (staticProps) _defineProperties$7(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    _classCallCheck$d(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass$d(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();

var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$d(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass$d(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    } // Is always present.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    } // Is only present when a country supports multiple IDD prefixes.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    } // "possible length" data is always present in Google's metadata.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    _classCallCheck$d(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass$d(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    _classCallCheck$d(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass$d(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!isObject$4(metadata) || !isObject$4(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject$4(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var typeOf = function typeOf(_) {
  return _typeof$1(_);
};
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries.hasOwnProperty(country);
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}

function _createForOfIteratorHelperLoose$8(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$c(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$c(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$c(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$c(o, minLen); }

function _arrayLikeToArray$c(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose$8(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}

function _createForOfIteratorHelperLoose$7(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$b(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$b(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$b(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen); }

function _arrayLikeToArray$b(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose$7(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {function?} emitEvent - An optional "emit event" function.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
      // Any 3rd-party code that used to `import` and call this function before that
      // won't be passing any `emitEvent` argument.
      //
      // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
      // of parsing an input string when the user inputs something like `"2+7"
      // https://github.com/catamphetamine/react-phone-number-input/issues/437
      //
      // If the parser encounters an unexpected `+` in a string being parsed
      // then it simply discards that out-of-place `+` and any following characters.
      //
      if (typeof emitEvent === 'function') {
        emitEvent('end');
      }

      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}

function _createForOfIteratorHelperLoose$6(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$a(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$a(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$a(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen); }

function _arrayLikeToArray$a(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = _createForOfIteratorHelperLoose$6(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

/**
 * Checks if a phone number is "possible" (basically just checks its length).
 *
 * isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  } // Old metadata (< 1.0.18) had no "possible length" data.


  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}

/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

function _createForOfIteratorHelperLoose$5(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$9(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$9(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$9(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen); }

function _arrayLikeToArray$9(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returns an empty object — `{}` —
  // that means that the phone number is malformed,
  // so it can't possibly be valid.

  if (!input.country && !input.countryCallingCode) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _iterator = _createForOfIteratorHelperLoose$5(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}

/**
 * Checks if a given phone number is valid.
 *
 * isValid(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}

/**
 * Returns a list of countries that the phone number could potentially belong to.
 * @param  {string} callingCode — Calling code.
 * @param  {string} nationalNumber — National (significant) number.
 * @param  {object} metadata — Metadata.
 * @return {string[]} A list of possible countries.
 */

function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);

  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return [];
  }

  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}

function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);

  _metadata.selectNumberingPlan(country);

  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }

  return false;
}

//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}

// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix;
      _ref.carrierCode;
      _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}

/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

function _createForOfIteratorHelperLoose$4(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$8(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$8(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen); }

function _arrayLikeToArray$8(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$8(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$8(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
/**
 * Formats a phone number.
 *
 * format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
 * format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
 *
 * format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
 * format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {string} format
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread$5(_objectSpread$5({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber$1(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber$1(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber$1(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$4(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value;

    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber$1(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber$1(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$7(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$6(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$6(Constructor.prototype, protoProps); if (staticProps) _defineProperties$6(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PhoneNumber = /*#__PURE__*/function () {
  /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck$c(this, PhoneNumber);

    if (!countryOrCountryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    if (!metadata) {
      throw new TypeError('`metadata` not passed');
    }

    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
        country = _getCountryAndCountry.country,
        countryCallingCode = _getCountryAndCountry.countryCallingCode;

    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
    // so that it doesn't clutter the console output of Node.js.
    // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
    // it would output the whole internal structure of the `metadata` object.

    this.getMetadata = function () {
      return metadata;
    };
  }

  _createClass$c(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }

      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$4(_objectSpread$4({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();

var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
  // Also store the country code as `.country`.

  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode
  };
}

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}

/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
        // then carrier code is the first one.

        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}

/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;

  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    } // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


    if (metadata.possibleLengths()) {
      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  } // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }


  return true;
}

function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;

    default:
      return true;
  }
}

/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}

/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }

  var isNumberWithIddPrefix; // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376

  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
} // The possible values for the returned `countryCallingCodeSource` are:
//
// Copy-pasted from:
// https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
//
// // The source from which the country_code is derived. This is not set in the
// // general parsing method, but in the method that parses and keeps raw_input.
// // New fields could be added upon request.
// enum CountryCodeSource {
//  // Default value returned if this is not set, because the phone number was
//  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
//  // return false if this is the case.
//  UNSPECIFIED = 0;
//
//  // The country_code is derived based on a phone number with a leading "+",
//  // e.g. the French number "+33 1 42 68 53 00".
//  FROM_NUMBER_WITH_PLUS_SIGN = 1;
//
//  // The country_code is derived based on a phone number with a leading IDD,
//  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
//  FROM_NUMBER_WITH_IDD = 5;
//
//  // The country_code is derived based on a phone number without a leading
//  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
//  // supplied as France.
//  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
//
//  // The country_code is derived NOT based on the phone number itself, but
//  // from the defaultCountry parameter provided in the parsing function by the
//  // clients. This happens mostly for numbers written in the national format
//  // (without country code). For example, this would be set when parsing the
//  // French number "01 42 68 53 00", when defaultCountry is supplied as
//  // France.
//  FROM_DEFAULT_COUNTRY = 20;
// }

function _createForOfIteratorHelperLoose$3(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$7(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$7(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen); }

function _arrayLikeToArray$7(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries;
      _ref.defaultCountry;
      var metadata = _ref.metadata;
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata); // const matchingCountries = []

  for (var _iterator = _createForOfIteratorHelperLoose$3(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
    // By definition, matching "leading digits" is a sufficient but not a necessary
    // condition for a phone number to belong to a country.
    // The point of "leading digits" check is that it's the fastest one to get a match.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
    // because of the intended use of that feature.

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      // If both the `defaultCountry` and the "main" one match the phone number,
      // don't prefer the `defaultCountry` over the "main" one.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
      return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
      // if (defaultCountry) {
      // 	if (country === defaultCountry) {
      // 		return country
      // 	}
      // 	matchingCountries.push(country)
      // } else {
      // 	return country
      // }
    }
  } // // Return the first ("main") one of the `matchingCountries`.
  // if (matchingCountries.length > 0) {
  // 	return matchingCountries[0]
  // }

}

var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;

  /* istanbul ignore if */
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  }

  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry: defaultCountry,
    metadata: metadata.metadata
  });
}

// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
var PLUS_SIGN = '+';
var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var RFC3966_PHONE_DIGIT_ = '(' + '[' + VALID_DIGITS + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + VALID_DIGITS + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */

var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS

var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var VALID_ALPHA_ = 'a-zA-Z';
var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */

var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
var RFC3966_PREFIX_ = 'tel:';
var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
var RFC3966_ISDN_SUBADDRESS_ = ';isub=';
/**
 * Extracts the value of the phone-context parameter of `numberToExtractFrom`,
 * following the syntax defined in RFC3966.
 *
 * @param {string} numberToExtractFrom
 * @return {string|null} the extracted string (possibly empty), or `null` if no phone-context parameter is found.
 */

function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_); // If no phone-context parameter is present

  if (indexOfPhoneContext < 0) {
    return null;
  }

  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length; // If phone-context parameter is empty

  if (phoneContextStart >= numberToExtractFrom.length) {
    return '';
  }

  var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter

  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
/**
 * Returns whether the value of phoneContext follows the syntax defined in RFC3966.
 *
 * @param {string|null} phoneContext
 * @return {boolean}
 */

function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }

  if (phoneContext.length === 0) {
    return false;
  } // Does phone-context value match pattern of global-number-digits or domainname.


  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

/**
 * @param  {string} numberToParse
 * @param  {string} nationalNumber
 * @return {}
 */

function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);

  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError('NOT_A_NUMBER');
  }

  var phoneNumberString;

  if (phoneContext === null) {
    // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
  } else {
    phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
    // it, whereas domains will be ignored.

    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    } // Now append everything between the "tel:" prefix and the phone-context.
    // This should include the national number, an optional extension or
    // isdn-subaddress component. Note we also handle the case when "tel:" is
    // missing, as we have seen in some of the phone number inputs.
    // In that case, we append everything from the beginning.


    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
    // `isPhoneContextValid()` requires it to be present.

    /* istanbul ignore else */

    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }

    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  } // Delete the isdn-subaddress and everything after it if it is present.
  // Note extension won't appear at the same time with isdn-subaddress
  // according to paragraph 5.3 of the RFC3966 spec.


  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);

  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  } // If both phone context and isdn-subaddress are absent but other
  // parameters are present, the parameters are left in nationalNumber.
  // This is because we are concerned about deleting content from a potential
  // number string when there is no strong evidence that the number is
  // actually written in RFC3966.


  if (phoneNumberString !== '') {
    return phoneNumberString;
  }
}

// This is a port of Google Android `libphonenumber`'s
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

/**
 * Parses a phone number.
 *
 * parse('123456789', { defaultCountry: 'RU', v2: true }, metadata)
 * parse('123456789', { defaultCountry: 'RU' }, metadata)
 * parse('123456789', undefined, metadata)
 *
 * @param  {string} input
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {object|PhoneNumber?} If `options.v2: true` flag is passed, it returns a `PhoneNumber?` instance. Otherwise, returns an object of shape `{ phone: '...', country: '...' }` (or just `{}` if no phone number was parsed).
 */

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }

      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber$1(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // // Parse RFC 3966 phone number URI.
  // if (text && text.indexOf('tel:') === 0) {
  // 	return parseRFC3966(text)
  // }
  // let number = extractFormattedPhoneNumber(text, extract, v2)
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
      return _extractFormattedPhoneNumber(text, extract, v2);
    }
  }); // If the phone number is not viable, then abort.

  if (!number) {
    return {};
  }

  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }

    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber$1(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is passed in "national" format
  // then `number` is defined and `countryCallingCode` is `undefined`.
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

    if (defaultCountry) {
      country = defaultCountry;
    }

    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};

  if (!number) {
    return {
      countryCallingCodeSource: countryCallingCodeSource,
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber: nationalNumber,
    defaultCountry: defaultCountry,
    metadata: metadata
  });

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') ; else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    countryCallingCodeSource: countryCallingCodeSource,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$6(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$6(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumberWithError(text, options, metadata) {
  return parse(text, _objectSpread$3(_objectSpread$3({}, options), {}, {
    v2: true
  }), metadata);
}

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$5(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$5(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$6(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$6(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen); }

function _arrayLikeToArray$6(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$3(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }
// * input `text`
// * `options` object
// * `metadata` JSON

function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = _slicedToArray$5(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = _objectSpread$2({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject$4(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$4(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function parsePhoneNumber(text, options, metadata) {
  // Validate `defaultCountry`.
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = _objectSpread$1(_objectSpread$1({}, options), {}, {
      defaultCountry: undefined
    });
  } // Parse phone number.


  try {
    return parsePhoneNumberWithError(text, options, metadata);
  } catch (error) {
    /* istanbul ignore else */
    if (error instanceof ParseError) ; else {
      throw error;
    }
  }
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$3(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function isValidPhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  options = _objectSpread(_objectSpread({}, options), {}, {
    extract: false
  });
  var phoneNumber = parsePhoneNumber(text, options, metadata);
  return phoneNumber && phoneNumber.isValid() || false;
}

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$5(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$b(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$5(Constructor.prototype, protoProps); if (staticProps) _defineProperties$5(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// This "state" object simply holds the state of the "AsYouType" parser:
//
// * `country?: string`
// * `callingCode?: string`
// * `digits: string`
// * `international: boolean`
// * `missingPlus: boolean`
// * `IDDPrefix?: string`
// * `carrierCode?: string`
// * `nationalPrefix?: string`
// * `nationalSignificantNumber?: string`
// * `nationalSignificantNumberMatchesInput: boolean`
// * `complexPrefixBeforeNationalSignificantNumber?: string`
//
// `state.country` and `state.callingCode` aren't required to be in sync.
// For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
// So `state.country` and `state.callingCode` are totally independent.
//
var AsYouTypeState = /*#__PURE__*/function () {
  function AsYouTypeState(_ref) {
    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    _classCallCheck$b(this, AsYouTypeState);

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  _createClass$b(AsYouTypeState, [{
    key: "reset",
    value: function reset(_ref2) {
      var country = _ref2.country,
          callingCode = _ref2.callingCode;
      this.international = false;
      this.missingPlus = false;
      this.IDDPrefix = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "update",
    value: function update(properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this[key] = properties[key];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      this.onCallingCodeChange(callingCode, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(country, callingCode) {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();

function _createForOfIteratorHelperLoose$2(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}
function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}
function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
    var index = _dangling_braces[_i];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}
function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = _createForOfIteratorHelperLoose$2(digits.split('')), _step2; !(_step2 = _iterator2()).done;) {
    var digit = _step2.value;

    // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.
    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}

function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}
function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix;
  // `format` has already been checked for `nationalPrefix` requirement.
  state.nationalSignificantNumber;
      state.international;
      state.nationalPrefix;
      state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$a(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PatternParser = /*#__PURE__*/function () {
  function PatternParser() {
    _classCallCheck$a(this, PatternParser);
  }

  _createClass$a(PatternParser, [{
    key: "parse",
    value: function parse(pattern) {
      this.context = [{
        or: true,
        instructions: []
      }];
      this.parsePattern(pattern);

      if (this.context.length !== 1) {
        throw new Error('Non-finalized contexts left when pattern parse ended');
      }

      var _this$context$ = this.context[0],
          branches = _this$context$.branches,
          instructions = _this$context$.instructions;

      if (branches) {
        return {
          op: '|',
          args: branches.concat([expandSingleElementArray(instructions)])
        };
      }
      /* istanbul ignore if */


      if (instructions.length === 0) {
        throw new Error('Pattern is required');
      }

      if (instructions.length === 1) {
        return instructions[0];
      }

      return instructions;
    }
  }, {
    key: "startContext",
    value: function startContext(context) {
      this.context.push(context);
    }
  }, {
    key: "endContext",
    value: function endContext() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function parsePattern(pattern) {
      if (!pattern) {
        throw new Error('Pattern is required');
      }

      var match = pattern.match(OPERATOR);

      if (!match) {
        if (ILLEGAL_CHARACTER_REGEXP.test(pattern)) {
          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
        }

        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
        return;
      }

      var operator = match[1];
      var before = pattern.slice(0, match.index);
      var rightPart = pattern.slice(match.index + operator.length);

      switch (operator) {
        case '(?:':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            or: true,
            instructions: [],
            branches: []
          });
          break;

        case ')':
          if (!this.getContext().or) {
            throw new Error('")" operator must be preceded by "(?:" operator');
          }

          if (before) {
            this.parsePattern(before);
          }

          if (this.getContext().instructions.length === 0) {
            throw new Error('No instructions found after "|" operator in an "or" group');
          }

          var _this$getContext = this.getContext(),
              branches = _this$getContext.branches;

          branches.push(expandSingleElementArray(this.getContext().instructions));
          this.endContext();
          this.getContext().instructions.push({
            op: '|',
            args: branches
          });
          break;

        case '|':
          if (!this.getContext().or) {
            throw new Error('"|" operator can only be used inside "or" groups');
          }

          if (before) {
            this.parsePattern(before);
          } // The top-level is an implicit "or" group, if required.


          if (!this.getContext().branches) {
            // `branches` are not defined only for the root implicit "or" operator.

            /* istanbul ignore else */
            if (this.context.length === 1) {
              this.getContext().branches = [];
            } else {
              throw new Error('"branches" not found in an "or" group context');
            }
          }

          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions));
          this.getContext().instructions = [];
          break;

        case '[':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            oneOfSet: true
          });
          break;

        case ']':
          if (!this.getContext().oneOfSet) {
            throw new Error('"]" operator must be preceded by "[" operator');
          }

          this.endContext();
          this.getContext().instructions.push({
            op: '[]',
            args: parseOneOfSet(before)
          });
          break;

        /* istanbul ignore next */

        default:
          throw new Error("Unknown operator: ".concat(operator));
      }

      if (rightPart) {
        this.parsePattern(rightPart);
      }
    }
  }]);

  return PatternParser;
}();

function parseOneOfSet(pattern) {
  var values = [];
  var i = 0;

  while (i < pattern.length) {
    if (pattern[i] === '-') {
      if (i === 0 || i === pattern.length - 1) {
        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
      }

      var prevValue = pattern[i - 1].charCodeAt(0) + 1;
      var nextValue = pattern[i + 1].charCodeAt(0) - 1;
      var value = prevValue;

      while (value <= nextValue) {
        values.push(String.fromCharCode(value));
        value++;
      }
    } else {
      values.push(pattern[i]);
    }

    i++;
  }

  return values;
}

var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var OPERATOR = new RegExp( // any of:
'(' + // or operator
'\\|' + // or
'|' + // or group start
'\\(\\?\\:' + // or
'|' + // or group end
'\\)' + // or
'|' + // one-of set start
'\\[' + // or
'|' + // one-of set end
'\\]' + ')');

function expandSingleElementArray(array) {
  if (array.length === 1) {
    return array[0];
  }

  return array;
}

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$9(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var PatternMatcher = /*#__PURE__*/function () {
  function PatternMatcher(pattern) {
    _classCallCheck$9(this, PatternMatcher);

    this.matchTree = new PatternParser().parse(pattern);
  }

  _createClass$9(PatternMatcher, [{
    key: "match",
    value: function match(string) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          allowOverflow = _ref.allowOverflow;

      if (!string) {
        throw new Error('String is required');
      }

      var result = _match(string.split(''), this.matchTree, true);

      if (result && result.match) {
        delete result.matchedChars;
      }

      if (result && result.overflow) {
        if (!allowOverflow) {
          return;
        }
      }

      return result;
    }
  }]);

  return PatternMatcher;
}();

function _match(characters, tree, last) {
  // If `tree` is a string, then `tree` is a single character.
  // That's because when a pattern is parsed, multi-character-string parts
  // of a pattern are compiled into arrays of single characters.
  // I still wrote this piece of code for a "general" hypothetical case
  // when `tree` could be a string of several characters, even though
  // such case is not possible with the current implementation.
  if (typeof tree === 'string') {
    var characterString = characters.join('');

    if (tree.indexOf(characterString) === 0) {
      // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore else */
      if (characters.length === tree.length) {
        return {
          match: true,
          matchedChars: characters
        };
      } // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore next */


      return {
        partialMatch: true // matchedChars: characters

      };
    }

    if (characterString.indexOf(tree) === 0) {
      if (last) {
        // The `else` path is not possible because `tree` is always a single character.
        // The `else` case for `characters.length > tree.length` would be
        // `characters.length <= tree.length` which means `characters.length <= 1`.
        // `characters` array can't be empty, so that means `characters === [tree]`,
        // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
        // that the `if (tree.indexOf(characterString) === 0)` condition before this
        // `if` condition would be entered, and returned from there, not reaching this code.

        /* istanbul ignore else */
        if (characters.length > tree.length) {
          return {
            overflow: true
          };
        }
      }

      return {
        match: true,
        matchedChars: characters.slice(0, tree.length)
      };
    }

    return;
  }

  if (Array.isArray(tree)) {
    var restCharacters = characters.slice();
    var i = 0;

    while (i < tree.length) {
      var subtree = tree[i];

      var result = _match(restCharacters, subtree, last && i === tree.length - 1);

      if (!result) {
        return;
      } else if (result.overflow) {
        return result;
      } else if (result.match) {
        // Continue with the next subtree with the rest of the characters.
        restCharacters = restCharacters.slice(result.matchedChars.length);

        if (restCharacters.length === 0) {
          if (i === tree.length - 1) {
            return {
              match: true,
              matchedChars: characters
            };
          } else {
            return {
              partialMatch: true // matchedChars: characters

            };
          }
        }
      } else {
        /* istanbul ignore else */
        if (result.partialMatch) {
          return {
            partialMatch: true // matchedChars: characters

          };
        } else {
          throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
        }
      }

      i++;
    } // If `last` then overflow has already been checked
    // by the last element of the `tree` array.

    /* istanbul ignore if */


    if (last) {
      return {
        overflow: true
      };
    }

    return {
      match: true,
      matchedChars: characters.slice(0, characters.length - restCharacters.length)
    };
  }

  switch (tree.op) {
    case '|':
      var partialMatch;

      for (var _iterator = _createForOfIteratorHelperLoose$1(tree.args), _step; !(_step = _iterator()).done;) {
        var branch = _step.value;

        var _result = _match(characters, branch, last);

        if (_result) {
          if (_result.overflow) {
            return _result;
          } else if (_result.match) {
            return {
              match: true,
              matchedChars: _result.matchedChars
            };
          } else {
            /* istanbul ignore else */
            if (_result.partialMatch) {
              partialMatch = true;
            } else {
              throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
            }
          }
        }
      }

      if (partialMatch) {
        return {
          partialMatch: true // matchedChars: ...

        };
      } // Not even a partial match.


      return;

    case '[]':
      for (var _iterator2 = _createForOfIteratorHelperLoose$1(tree.args), _step2; !(_step2 = _iterator2()).done;) {
        var _char = _step2.value;

        if (characters[0] === _char) {
          if (characters.length === 1) {
            return {
              match: true,
              matchedChars: characters
            };
          }

          if (last) {
            return {
              overflow: true
            };
          }

          return {
            match: true,
            matchedChars: [_char]
          };
        }
      } // No character matches.


      return;

    /* istanbul ignore next */

    default:
      throw new Error("Unsupported instruction tree: ".concat(tree));
  }
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$8(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
// Could be any digit, I guess.

var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN = function () {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN = function () {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + VALID_PUNCTUATION + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter = /*#__PURE__*/function () {
  function AsYouTypeFormatter(_ref) {
    _ref.state;
        var metadata = _ref.metadata;

    _classCallCheck$8(this, AsYouTypeFormatter);

    this.metadata = metadata;
    this.resetFormat();
  }

  _createClass$8(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */

  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this = this;

      // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //
      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = _createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;) {
          var format = _step.value;
          var formattedCompleteNumber = formatCompleteNumber(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
              return _this.getSeparatorAfterNationalPrefix(format);
            }
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref2) {
      var _this2 = this;

      var nationalSignificantNumber = _ref2.nationalSignificantNumber,
          nationalPrefix = _ref2.nationalPrefix,
          international = _ref2.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.
      // The test case could be found by searching for "leadingDigitsPatternsCount === 0".

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start narrowing down the list of possible formats based on the leading digits.
      // (only previously matched formats take part in the narrowing down process)
      // `leading_digits_patterns` start with 3 digits min
      // and then go up from there one digit at a time.


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
      // to be minimum 3 digits long in order to be eligible
      // for checking those with a leading digits pattern.
      //
      // Since `leading_digits_patterns` start with 3 digits min,
      // Google's original `libphonenumber` library only starts
      // excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      //
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.
      //
      // Also, `leading_digits_patterns` doesn't always correspond to a single
      // digits count. For example, `60|8` pattern would already match `8`
      // but the `60` part would require having at least two leading digits,
      // so the whole pattern would require inputting two digits first in order to
      // decide on whether it matches the input, even when the input is "80".
      //
      // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
      // even when there's only 1 or 2 digits of the national (significant) number.
      // To do that, it uses a non-strict pattern matcher written specifically for that.
      //

      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        // Before leading digits < 3 matching was implemented:
        // return true
        //
        // After leading digits < 3 matching was implemented:
        try {
          return new PatternMatcher(leadingDigitsPattern).match(leadingDigits, {
            allowOverflow: true
          }) !== undefined;
        } catch (error)
        /* istanbul ignore next */
        {
          // There's a slight possibility that there could be some undiscovered bug
          // in the pattern matcher code. Since the "leading digits < 3 matching"
          // feature is not "essential" for operation, it can fall back to the old way
          // in case of any issues rather than halting the application's execution.
          console.error(error);
          return true;
        }
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
      // available then use the usual regular expression matching.
      //
      // The whole pattern is wrapped in round brackets (`()`) because
      // the pattern can use "or" operator (`|`) at the top level of the pattern.
      //


      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this3 = this;

      var _loop = function _loop() {
        var format = _step2.value;

        // If this format is currently being used
        // and is still suitable, then stick to it.
        if (_this3.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this3.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this3.matchingFormats = _this3.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this3.chosenFormat = format;
        return "break";
      };

      // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      //
      // For some weird reason, `istanbul` says "else path not taken"
      // for the `for of` line below. Supposedly that means that
      // the loop doesn't ever go over the last element in the list.
      // That's true because there always is `this.chosenFormat`
      // when `this.matchingFormats` is non-empty.
      // And, for some weird reason, it doesn't think that the case
      // with empty `this.matchingFormats` qualifies for a valid "else" path.
      // So simply muting this `istanbul` warning.
      // It doesn't skip the contents of the `for of` loop,
      // it just skips the `for of` line.
      //

      /* istanbul ignore next */
      for (var _iterator2 = _createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;) {
        var _ret = _loop();

        if (_ret === "break") break;
        if (_ret === "continue") continue;
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if (format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function getSeparatorAfterNationalPrefix(format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
      var IDDPrefix = _ref3.IDDPrefix,
          missingPlus = _ref3.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref4) {
      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          international = _ref4.international,
          nationalPrefix = _ref4.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //


      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + parseDigits('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = applyInternationalSeparatorStyle(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
      var international = _ref5.international,
          nationalPrefix = _ref5.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    }
  }]);

  return AsYouTypeFormatter;
}();

function _slicedToArray$4(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$2(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$7(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser = /*#__PURE__*/function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    _classCallCheck$7(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  _createClass$7(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = _slicedToArray$4(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = parseDigits(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
            return state.update(stateUpdate);
          });
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode$1(state) {
      var _extractCountryCallin = extractCountryCallingCode('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function (stateUpdate) {
        return state.update(stateUpdate);
      })) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits;
          state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state, {
          country: undefined,
          callingCode: undefined
        });
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode;
            _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state, {
            country: state.country,
            callingCode: newCallingCode
          });
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state, _ref3) {
      var country = _ref3.country,
          callingCode = _ref3.callingCode;
      state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
          return state.update(stateUpdate);
        });
      }
    }
  }]);

  return AsYouTypeParser;
}();

function extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = extractFormattedPhoneNumber(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = _slicedToArray$4(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}

function _slicedToArray$3(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$6(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var AsYouType$1 = /*#__PURE__*/function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck$6(this, AsYouType);

    this.metadata = new Metadata(metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = _slicedToArray$3(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1]; // `this.defaultCountry` and `this.defaultCallingCode` aren't required to be in sync.
    // For example, `this.defaultCountry` could be `"AR"` and `this.defaultCallingCode` could be `undefined`.
    // So `this.defaultCountry` and `this.defaultCallingCode` are totally independent.


    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  _createClass$6(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (isObject$4(optionsOrDefaultCountry)) {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new AsYouTypeState({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      });
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      // If the number is being input in national format and some "default calling code"
      // has been passed to `AsYouType` constructor, then `this.state.callingCode`
      // is equal to that "default calling code".
      //
      // If the number is being input in national format and no "default calling code"
      // has been passed to `AsYouType` constructor, then returns `undefined`,
      // even if a "default country" has been passed to `AsYouType` constructor.
      //
      if (this.isInternational()) {
        return this.state.callingCode;
      }
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var digits = this.state.digits; // Return `undefined` if no digits have been input yet.

      if (digits) {
        return this._getCountry();
      }
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */

  }, {
    key: "_getCountry",
    value: function _getCountry() {
      var country = this.state.country;

      return country;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state = this.state,
          nationalSignificantNumber = _this$state.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */

  }, {
    key: "getNumberValue",
    value: function getNumberValue() {
      var _this$state2 = this.state,
          digits = _this$state2.digits,
          callingCode = _this$state2.callingCode,
          country = _this$state2.country,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.

      if (!digits) {
        return;
      }

      if (this.isInternational()) {
        if (callingCode) {
          return '+' + callingCode + nationalSignificantNumber;
        } else {
          return '+' + digits;
        }
      } else {
        if (country || callingCode) {
          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
          return '+' + callingCode_ + nationalSignificantNumber;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode,
          callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
      // with the only change that it return `undefined` in case of a
      // "non-geographic" numbering plan instead of `"001"` "internal use" value.

      var country = this._getCountry();

      if (!nationalSignificantNumber) {
        return;
      } // `state.country` and `state.callingCode` aren't required to be in sync.
      // For example, `country` could be `"AR"` and `callingCode` could be `undefined`.
      // So `country` and `callingCode` are totally independent.


      if (!country && !callingCode) {
        return;
      } // By default, if `defaultCountry` parameter was passed when
      // creating `AsYouType` instance, `state.country` is gonna be
      // that `defaultCountry`, which doesn't entirely conform with
      // `parsePhoneNumber()`'s behavior where it attempts to determine
      // the country more precisely in cases when multiple countries
      // could correspond to the same `countryCallingCode`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417192969
      //
      // Because `AsYouType.getNumber()` method is supposed to be a 1:1
      // equivalent for `parsePhoneNumber(AsYouType.getNumberValue())`,
      // then it should also behave accordingly in cases of `country` ambiguity.
      // That's how users of this library would expect it to behave anyway.
      //


      if (country) {
        if (country === this.defaultCountry) {
          // `state.country` and `state.callingCode` aren't required to be in sync.
          // For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
          // So `state.country` and `state.callingCode` are totally independent.
          var metadata = new Metadata(this.metadata.metadata);
          metadata.selectNumberingPlan(country);

          var _callingCode = metadata.numberingPlan.callingCode();

          var ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);

          if (ambiguousCountries.length > 1) {
            var exactCountry = getCountryByNationalNumber(nationalSignificantNumber, {
              countries: ambiguousCountries,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });

            if (exactCountry) {
              country = exactCountry;
            }
          }
        }
      }

      var phoneNumber = new PhoneNumber(country || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();

function isValidPhoneNumber() {
	return withMetadataArgument(isValidPhoneNumber$1, arguments)
}

// Importing from a ".js" file is a workaround for Node.js "ES Modules"

function AsYouType(country) {
	return AsYouType$1.call(this, country, metadata)
}

AsYouType.prototype = Object.create(AsYouType$1.prototype, {});
AsYouType.prototype.constructor = AsYouType;

/**
 * Validates an email address
 */
const validateEmail = (email) => {
    // Simple email validation regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
/**
 * Validates a phone number
 */
const validatePhoneNumber = (number, country = "US") => {
    return isValidPhoneNumber(number, country);
};

/**
 * Check if the browser is mobile or not
 * From: http://stackoverflow.com/a/11381730/1349766
 *
 * @returns {boolean}
 */
function isMobileOrTablet() {
    return isMobileOrTabletImpl(navigator.userAgent, navigator.vendor);
}
/**
 * Do not use directly, use isMobileOrTablet instead.
 * @param userAgent
 * @param vendor
 * @returns
 */
function isMobileOrTabletImpl(userAgent, vendor) {
    let check = false;
    (a => {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) ||
            // eslint-disable-next-line no-useless-escape
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            check = true;
        }
    })(userAgent || vendor);
    return check;
}
/**
 * The threshold where greater than or equal is not mobile, everything less than is considered mobile.
 */
const mobileWidthThreshold = 480;
/**
 * Determine if the current window inner width is less than the mobile width threshold.
 *
 * @export
 * @param {Window} [_window] Optional window paramter, only used when unit testing
 * @returns {boolean} True if the
 */
function isMobileWidth(_window) {
    // if a window is passed in, use that otherwise set it to the global window object
    _window = _window ? _window : window;
    let isMobileWidth = false;
    if (_window.innerWidth < mobileWidthThreshold) {
        isMobileWidth = true;
    }
    return isMobileWidth;
}
/**
 * Register a callback to listen for browser resize events.
 *
 * @export
 * @param {(event: UIEvent) => void} callback
 * @param {Window} [_window]
 *
 * @return A wrapped event in which you can register it or unregister it when the time comes.
 * */
function onResize(callback, _window) {
    return {
        register() {
            _window = _window ? _window : window;
            _window.addEventListener("resize", callback);
        },
        unregister() {
            _window = _window ? _window : window;
            _window.removeEventListener("resize", callback);
        }
    };
}
/**
 * Register a callback to receive mutation updates for a given Node (Element).
 *
 * @export
 * @param {Node} node
 * @param {MutationCallback} callback
 * @returns {MutationObserver}
 */
function onMutation(node, callback) {
    let observer;
    // MutationObserver doesn't exist on Node.js
    if (typeof MutationObserver !== "undefined" && node && callback) {
        observer = new MutationObserver(callback);
        observer.observe(node, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
    }
    else {
        // Otherwise return an innocuous observer
        observer = {
            disconnect: () => { },
            observe: () => { },
            takeRecords: () => {
                return [];
            }
        };
    }
    return observer;
}
/**
 * Get the current size of the browser window.
 *
 * Returns window.innerWidth and window.innerHeight.
 *
 * @export
 * @param {Window} [_window] Optional window object, only used when testing.
 * @returns {{ width: number, height: number }}
 */
function size(_window) {
    _window = _window ? _window : window;
    return { width: _window.innerWidth, height: _window.innerHeight };
}

/**
 * Validating input for email addresses.
 *
 * Uses validateEmail from utils/validators.
 */
const EmailInput = (_a) => {
    var { onChange, helperText } = _a, props = __rest$2(_a, ["onChange", "helperText"]);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (props.value && typeof props.value === "string") {
            if (!validateEmail(props.value)) {
                setError("Invalid email address");
            }
        }
    }, [props.value]);
    const handleChange = (value) => {
        if (typeof value === "string") {
            let valid = true;
            if (value === "") {
                setError(null); // Clear error when input is empty
            }
            else if (!validateEmail(value)) {
                valid = false;
                setError("Invalid email address");
            }
            else {
                setError(null);
            }
            onChange && onChange(value, valid);
        }
    };
    return (React__default$4.createElement(Input$3, Object.assign({}, props, { onChange: handleChange, error: !!error, helperText: error || helperText, type: "email" // Set the type to email for client-side validation
     })));
};

const DEFAULT_REQUIREMENTS = {
    minLength: 8,
    maxLength: 20,
    uppercase: true,
    lowercase: true,
    numbers: true,
    specialChars: true,
};
const PasswordInput = (_a) => {
    var { onChange, requirements = DEFAULT_REQUIREMENTS, helperText } = _a, props = __rest$2(_a, ["onChange", "requirements", "helperText"]);
    const [error, setError] = useState(null);
    const validatePassword = useCallback((password) => {
        if (typeof requirements.minLength === "number" && password.length < requirements.minLength) {
            return "Password must be at least 8 characters.";
        }
        if (typeof requirements.maxLength === "number" && password.length > requirements.maxLength) {
            return "Password must be at most 20 characters.";
        }
        if (typeof requirements.uppercase === "boolean" && requirements.uppercase && !/[A-Z]/.test(password)) {
            return "Password must contain at least one uppercase letter.";
        }
        if (typeof requirements.lowercase === "boolean" && requirements.lowercase && !/[a-z]/.test(password)) {
            return "Password must contain at least one lowercase letter.";
        }
        if (typeof requirements.numbers === "boolean" && requirements.numbers && !/\d/.test(password)) {
            return "Password must contain at least one number.";
        }
        if (typeof requirements.specialChars === "boolean" &&
            requirements.specialChars &&
            !/[@$!%*?&]/.test(password)) {
            return "Password must contain at least one special character.";
        }
        return null;
    }, [
        requirements.lowercase,
        requirements.maxLength,
        requirements.minLength,
        requirements.numbers,
        requirements.specialChars,
        requirements.uppercase,
    ]);
    const handleChange = (value) => {
        if (typeof value === "string") {
            let valid = true;
            const errorMessage = validatePassword(value);
            if (value === "") {
                setError(null); // Clear error when input is empty
            }
            else if (errorMessage) {
                valid = false;
                setError(errorMessage);
            }
            else {
                setError(null);
            }
            onChange && onChange(value, valid);
        }
    };
    return (React__default$4.createElement(Input$3, Object.assign({}, props, { className: style$N.passwordInput, onChange: handleChange, error: error !== "Valid Password" && !!error, helperText: error || helperText, type: "password", name: "password", id: "password", title: "Password must be at least 8 characters long, with at least one number, one uppercase letter, one lowercase letter, and one special character." })));
};

const PhoneNumberInput = (_a) => {
    var { onChange, helperText, country = 'US' } = _a, props = __rest$2(_a, ["onChange", "helperText", "country"]);
    const [value, setValue] = useState('');
    const [error, setError] = useState(null);
    useEffect(() => {
        // If the parent component updates the value prop, update the state
        if (props.value && props.value !== value && typeof props.value === "string") {
            const formatter = new AsYouType(country); // Create a new instance of AsYouType with the specified country
            const formattedNumber = formatter.input(props.value);
            setValue(formattedNumber);
            if (!validatePhoneNumber(`${props.value}`, country)) {
                setError("Invalid phone number");
            }
        }
    }, [country, props.value, value]);
    const handleChange = (inputValue) => {
        const formatter = new AsYouType(country); // Create a new instance of AsYouType with the specified country
        const formattedNumber = formatter.input(`${inputValue}`);
        setValue(formattedNumber); // Set the state with the formatted number
        let valid = true;
        if (inputValue === "") {
            setError(null); // Clear error when input is empty
        }
        else if (!validatePhoneNumber(`${inputValue}`, country)) {
            valid = false;
            setError("Invalid phone number");
        }
        else {
            setError(null);
        }
        onChange && onChange(formattedNumber, valid); // Pass the formatted number to the onChange handler
    };
    return (React__default$4.createElement(Input$3, Object.assign({}, props, { value: value, onChange: handleChange, error: !!error, helperText: error || helperText, type: "tel" })));
};

var css_248z$14 = ".AutoCompleteSuggestionsInput-module_autocomplete__NxjgK {\n  position: relative;\n  width: 100%;\n}\n\n.AutoCompleteSuggestionsInput-module_suggestions__sOviQ {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  min-width: 100%;\n  background: white;\n  border: 1px solid #ccc;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  max-height: 300px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.AutoCompleteSuggestionsInput-module_suggestion__bdobf {\n  padding: 12px 15px;\n  font-size: 16px;\n  cursor: pointer;\n  border-bottom: 1px solid #eee;\n}\n.AutoCompleteSuggestionsInput-module_suggestion__bdobf:hover {\n  background-color: #f1f1f1;\n}\n@media (max-width: 768px) {\n  .AutoCompleteSuggestionsInput-module_suggestion__bdobf {\n    padding: 16px 20px;\n    font-size: 18px;\n  }\n}\n\n.AutoCompleteSuggestionsInput-module_selected__2u5p- {\n  background-color: #e6f0ff;\n  font-weight: bold;\n}\n\n.AutoCompleteSuggestionsInput-module_business__MKcTY {\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.AutoCompleteSuggestionsInput-module_modalOverlay__gWegY {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding-top: 5vh;\n}\n\n.AutoCompleteSuggestionsInput-module_modalContent__xWIln {\n  background: white;\n  border-radius: 4px 4px 0 0;\n  padding: 1.5rem;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.AutoCompleteSuggestionsInput-module_modalHeader__c643Z {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.AutoCompleteSuggestionsInput-module_modalTitle__RSTwb {\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.AutoCompleteSuggestionsInput-module_closeButton__xXFvh {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #444;\n  cursor: pointer;\n}";
var style$M = {"autocomplete":"AutoCompleteSuggestionsInput-module_autocomplete__NxjgK","suggestions":"AutoCompleteSuggestionsInput-module_suggestions__sOviQ","suggestion":"AutoCompleteSuggestionsInput-module_suggestion__bdobf","selected":"AutoCompleteSuggestionsInput-module_selected__2u5p-","business":"AutoCompleteSuggestionsInput-module_business__MKcTY","modalOverlay":"AutoCompleteSuggestionsInput-module_modalOverlay__gWegY","modalContent":"AutoCompleteSuggestionsInput-module_modalContent__xWIln","modalHeader":"AutoCompleteSuggestionsInput-module_modalHeader__c643Z","modalTitle":"AutoCompleteSuggestionsInput-module_modalTitle__RSTwb","closeButton":"AutoCompleteSuggestionsInput-module_closeButton__xXFvh"};
styleInject(css_248z$14);

const AutoCompleteSuggestionsInput = (_a) => {
    var { suggestions: initialSuggestions = [], getSuggestions, renderSuggestion, echo = false, value, onChange, wrapperStyle } = _a, inputProps = __rest$2(_a, ["suggestions", "getSuggestions", "renderSuggestion", "echo", "value", "onChange", "wrapperStyle"]);
    const [suggestions, setSuggestions] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [isMobile, setIsMobile] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const inputRef = useRef(null);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        if (typeof value === "string") {
            setInputValue(value);
        }
        else if (value && typeof value === "object") {
            setInputValue(value.label);
        }
        else {
            setInputValue("");
        }
    }, [value]);
    const fetchSuggestions = (val) => __awaiter$2(void 0, void 0, void 0, function* () {
        let newSuggestions = [];
        if (getSuggestions) {
            newSuggestions = yield getSuggestions(val);
        }
        else {
            const input = val.toLowerCase();
            const startsWith = initialSuggestions.filter((s) => s.label.toLowerCase().startsWith(input));
            const includes = initialSuggestions.filter((s) => !startsWith.includes(s) && s.label.toLowerCase().includes(input));
            newSuggestions = [...startsWith, ...includes];
            if (newSuggestions.length === 0) {
                const words = input.split(" ");
                newSuggestions = initialSuggestions.filter((s) => words.some((word) => s.label.toLowerCase().includes(word)));
            }
            if (echo && input) {
                const exactMatch = newSuggestions.find((s) => s.label.trim().toLowerCase() === input.trim().toLowerCase());
                if (!exactMatch) {
                    newSuggestions.unshift({ label: val, id: "echo" });
                }
            }
        }
        setSuggestions(newSuggestions);
        setShowSuggestions(true);
        setHighlightedIndex(-1);
    });
    const handleInputChange = (val) => {
        setInputValue(val);
        onChange(val);
        fetchSuggestions(val);
    };
    const handleSuggestionClick = (suggestion) => {
        onChange(suggestion);
        setInputValue(suggestion.label);
        setSuggestions([]);
        setShowSuggestions(false);
        closeModal();
    };
    const handleKeyDown = (e) => {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightedIndex((prev) => (prev + 1) % suggestions.length);
        }
        else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightedIndex((prev) => (prev - 1 + suggestions.length) % suggestions.length);
        }
        else if (e.key === "Enter") {
            if (highlightedIndex >= 0 && suggestions[highlightedIndex]) {
                handleSuggestionClick(suggestions[highlightedIndex]);
            }
            else {
                setShowSuggestions(false);
                closeModal();
            }
        }
        else if (e.key === "Escape") {
            setShowSuggestions(false);
            closeModal();
        }
    };
    const handleBlur = () => {
        setShowSuggestions(false);
    };
    const openModal = () => {
        if (isMobile) {
            setModalOpen(true);
            document.body.style.overflow = "hidden";
        }
        else {
            setShowSuggestions(true);
        }
    };
    const closeModal = () => {
        setModalOpen(false);
        document.body.style.overflow = "";
    };
    const renderSuggestions = () => showSuggestions &&
        suggestions.length > 0 && (React__default$4.createElement("div", { className: style$M.suggestions }, suggestions.map((s, idx) => (React__default$4.createElement("div", { key: `${s.id}-${idx}`, className: `${style$M.suggestion} ${highlightedIndex === idx ? style$M.selected : ""}`, onClick: () => handleSuggestionClick(s), onMouseDown: () => handleSuggestionClick(s) }, renderSuggestion ? (renderSuggestion(s, highlightedIndex === idx)) : (React__default$4.createElement("div", { className: style$M.business }, s.label)))))));
    return (React__default$4.createElement("div", { className: style$M.autocomplete },
        React__default$4.createElement(Input$3, Object.assign({}, inputProps, { autoComplete: "off", autoCorrect: "off", spellCheck: false, value: inputValue, onChange: (val) => handleInputChange(`${val}`), onFocus: openModal, onKeyDown: handleKeyDown, onBlur: handleBlur, className: style$M.input, wrapperStyle: wrapperStyle, ref: inputRef })),
        !isMobile && renderSuggestions(),
        modalOpen && (React__default$4.createElement("div", { className: style$M.modalOverlay, onClick: closeModal },
            React__default$4.createElement("div", { className: style$M.modalContent, onClick: (e) => e.stopPropagation() },
                React__default$4.createElement("header", { className: style$M.modalHeader },
                    React__default$4.createElement(IconButton, { iconName: "close", className: style$M.closeButton, onClick: closeModal }),
                    React__default$4.createElement(Button, { label: "Done", leftIcon: "check_circle", className: style$M.doneButton, onClick: closeModal })),
                React__default$4.createElement(Input$3, Object.assign({}, inputProps, { value: inputValue, onChange: (val) => handleInputChange(`${val}`), autoFocus: true, className: style$M.input, wrapperStyle: wrapperStyle, onKeyDown: handleKeyDown, onBlur: handleBlur })),
                renderSuggestions())))));
};

const FieldInput = props => {
    const { label, errorMessage, state, disabled } = props;
    const isError = state === "error";
    return (React__default$4.createElement(Field, { label: label, errorMessage: errorMessage, state: state },
        React__default$4.createElement(Input$3, { type: props.type, value: props.value, onChange: () => props.onChange, variation: "standard", placeholder: props.placeholder, disabled: disabled, suffixIcon: isError ? "warning" : undefined })));
};

var css_248z$13 = ".TextArea_textarea__Sg8Yb {\n  font-size: var(--form-control-font-size, 14px);\n  background: var(--form-control-background, #ffffff);\n  color: var(--form-control-color, #061739);\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.25em 0.75em;\n  border-radius: 12px;\n  resize: vertical;\n  font: 1em sans-serif;\n}";
var style$L = {"textarea":"TextArea_textarea__Sg8Yb"};
styleInject(css_248z$13);

/**
 *
 * @deprecated Use multiline field on Input
 * @param props
 * @returns
 */
const TextArea = props => {
    const { disabled, onChange } = props;
    const handleChange = useCallback((ev) => {
        onChange(ev.target.value);
    }, [onChange]);
    return (React__default$4.createElement("textarea", { className: classNames$1(style$L.textarea, props.className), placeholder: props.placeholder, value: props.value, onChange: handleChange, disabled: disabled }));
};

const FieldTextArea = props => {
    const { className, label, errorMessage, state, disabled } = props;
    return (React__default$4.createElement(Field, { label: label, errorMessage: errorMessage, state: state },
        React__default$4.createElement(TextArea, { className: className, value: props.value, onChange: props.onChange, placeholder: props.placeholder, disabled: disabled })));
};

var css_248z$12 = ".Form_form__27M2j {\n  padding: 0;\n  margin: 0;\n}\n\n.Form_normal__eFpnj {\n  --form-control-size: 38px;\n  --form-control-font-size: 14px;\n  --form-control-icon-size: 24px;\n}\n\n.Form_large__gnFPL {\n  --form-control-size: 68px;\n  --form-control-font-size: 26px;\n  --form-control-icon-size: 36px;\n}";
var style$K = {"form":"Form_form__27M2j","normal":"Form_normal__eFpnj","large":"Form_large__gnFPL"};
styleInject(css_248z$12);

const Form = props => {
    const controlSize = props.controlSize || "normal";
    return (React__default$4.createElement("form", { className: style$K.form + (controlSize === "normal" ? " " + style$K.normal : "") + (controlSize === "large" ? " " + style$K.large : "") }, props.children));
};

/**
 * Functional component to measure the dimensions of its root element
 * and notify the parent component of any changes.
 */
const Measure = ({ style, className, onMeasure, children }) => {
    const rootRef = useRef(null);
    const [lastMeasure, setLastMeasure] = useState({ width: -1, height: -1 });
    useEffect(() => {
        if (!rootRef.current)
            return;
        const updateDimensions = () => {
            if (!rootRef.current)
                return;
            const dimensions = getDimensions(rootRef.current);
            if (lastMeasure.width !== dimensions.width || lastMeasure.height !== dimensions.height) {
                onMeasure(dimensions);
                setLastMeasure(dimensions);
            }
        };
        const resizeEvent = onResize(updateDimensions);
        resizeEvent.register();
        const observer = onMutation(rootRef.current, updateDimensions);
        updateDimensions();
        return () => {
            resizeEvent === null || resizeEvent === void 0 ? void 0 : resizeEvent.unregister();
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [lastMeasure, onMeasure]);
    const getDimensions = (element) => {
        let width, height, heightOffset;
        if (window) {
            const padding = 16;
            const windowDimens = size();
            const rect = element.getBoundingClientRect();
            heightOffset = rect.top;
            width = rect.right - rect.left;
            height = windowDimens.height - heightOffset - padding;
        }
        else {
            width = 200;
            height = 200;
            heightOffset = 0;
        }
        return { width, height };
    };
    return (React__default$4.createElement("div", { style: style, className: className, ref: rootRef }, children));
};

var index_umd = {exports: {}};

(function (module, exports) {
!function(r,t){t(exports);}(commonjsGlobal$1,function(r){var t="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof commonjsGlobal$1?commonjsGlobal$1:"undefined"!=typeof self?self:{};function n(r){return r&&r.__esModule&&Object.prototype.hasOwnProperty.call(r,"default")?r.default:r}var e,i,o={};function u(){if(i)return e;i=1;var r=function(r){return r&&r.Math===Math&&r};return e=r("object"==typeof globalThis&&globalThis)||r("object"==typeof window&&window)||r("object"==typeof self&&self)||r("object"==typeof t&&t)||r("object"==typeof e&&e)||function(){return this}()||Function("return this")()}var a,c,f,s,l,h,p,v,d={};function g(){return c?a:(c=1,a=function(r){try{return !!r()}catch(r){return !0}})}function y(){if(s)return f;s=1;var r=g();return f=!r(function(){return 7!==Object.defineProperty({},1,{get:function(){return 7}})[1]})}function b(){if(h)return l;h=1;var r=g();return l=!r(function(){var r=function(){}.bind();return "function"!=typeof r||r.hasOwnProperty("prototype")})}function m(){if(v)return p;v=1;var r=b(),t=Function.prototype.call;return p=r?t.bind(t):function(){return t.apply(t,arguments)},p}var w,S,O,I,E,j,P,T,R,x,L,k,A,_,C,F,M,D,N,U,$,G,z,K,H,W,B,Z,J,Y,q,V,X,Q,rr,tr,nr,er,ir,or,ur,ar={};function cr(){return O?S:(O=1,S=function(r,t){return {enumerable:!(1&r),configurable:!(2&r),writable:!(4&r),value:t}})}function fr(){if(E)return I;E=1;var r=b(),t=Function.prototype,n=t.call,e=r&&t.bind.bind(n,n);return I=r?e:function(r){return function(){return n.apply(r,arguments)}},I}function sr(){if(P)return j;P=1;var r=fr(),t=r({}.toString),n=r("".slice);return j=function(r){return n(t(r),8,-1)}}function lr(){return L?x:(L=1,x=function(r){return null==r})}function hr(){if(A)return k;A=1;var r=lr(),t=TypeError;return k=function(n){if(r(n))throw new t("Can't call method on "+n);return n}}function pr(){if(C)return _;C=1;var r=function(){if(R)return T;R=1;var r=fr(),t=g(),n=sr(),e=Object,i=r("".split);return T=t(function(){return !e("z").propertyIsEnumerable(0)})?function(r){return "String"===n(r)?i(r,""):e(r)}:e}(),t=hr();return _=function(n){return r(t(n))}}function vr(){if(M)return F;M=1;var r="object"==typeof document&&document.all;return F=void 0===r&&void 0!==r?function(t){return "function"==typeof t||t===r}:function(r){return "function"==typeof r}}function dr(){if(N)return D;N=1;var r=vr();return D=function(t){return "object"==typeof t?null!==t:r(t)}}function gr(){if($)return U;$=1;var r=u(),t=vr();return U=function(n,e){return arguments.length<2?(i=r[n],t(i)?i:void 0):r[n]&&r[n][e];var i;},U}function yr(){if(z)return G;z=1;var r=fr();return G=r({}.isPrototypeOf)}function br(){if(B)return W;B=1;var r,t,n=u(),e=function(){if(H)return K;H=1;var r=u().navigator,t=r&&r.userAgent;return K=t?String(t):""}(),i=n.process,o=n.Deno,a=i&&i.versions||o&&o.version,c=a&&a.v8;return c&&(t=(r=c.split("."))[0]>0&&r[0]<4?1:+(r[0]+r[1])),!t&&e&&(!(r=e.match(/Edge\/(\d+)/))||r[1]>=74)&&(r=e.match(/Chrome\/(\d+)/))&&(t=+r[1]),W=t}function mr(){if(J)return Z;J=1;var r=br(),t=g(),n=u().String;return Z=!!Object.getOwnPropertySymbols&&!t(function(){var t=Symbol("symbol detection");return !n(t)||!(Object(t)instanceof Symbol)||!Symbol.sham&&r&&r<41})}function wr(){if(q)return Y;q=1;var r=mr();return Y=r&&!Symbol.sham&&"symbol"==typeof Symbol.iterator}function Sr(){if(X)return V;X=1;var r=gr(),t=vr(),n=yr(),e=wr(),i=Object;return V=e?function(r){return "symbol"==typeof r}:function(e){var o=r("Symbol");return t(o)&&n(o.prototype,i(e))}}function Or(){if(rr)return Q;rr=1;var r=String;return Q=function(t){try{return r(t)}catch(r){return "Object"}}}function Ir(){if(nr)return tr;nr=1;var r=vr(),t=Or(),n=TypeError;return tr=function(e){if(r(e))return e;throw new n(t(e)+" is not a function")}}function Er(){if(ir)return er;ir=1;var r=Ir(),t=lr();return er=function(n,e){var i=n[e];return t(i)?void 0:r(i)}}function jr(){if(ur)return or;ur=1;var r=m(),t=vr(),n=dr(),e=TypeError;return or=function(i,o){var u,a;if("string"===o&&t(u=i.toString)&&!n(a=r(u,i)))return a;if(t(u=i.valueOf)&&!n(a=r(u,i)))return a;if("string"!==o&&t(u=i.toString)&&!n(a=r(u,i)))return a;throw new e("Can't convert object to primitive value")}}var Pr,Tr,Rr,xr,Lr,kr,Ar,_r,Cr,Fr,Mr,Dr,Nr,Ur,$r,Gr,zr,Kr,Hr,Wr,Br,Zr,Jr,Yr,qr={exports:{}};function Vr(){return Tr?Pr:(Tr=1,Pr=!1)}function Xr(){if(xr)return Rr;xr=1;var r=u(),t=Object.defineProperty;return Rr=function(n,e){try{t(r,n,{value:e,configurable:!0,writable:!0});}catch(t){r[n]=e;}return e}}function Qr(){if(Lr)return qr.exports;Lr=1;var r=Vr(),t=u(),n=Xr(),e="__core-js_shared__",i=qr.exports=t[e]||n(e,{});return (i.versions||(i.versions=[])).push({version:"3.43.0",mode:r?"pure":"global",copyright:"© 2014-2025 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.43.0/LICENSE",source:"https://github.com/zloirock/core-js"}),qr.exports}function rt(){if(Ar)return kr;Ar=1;var r=Qr();return kr=function(t,n){return r[t]||(r[t]=n||{})}}function tt(){if(Cr)return _r;Cr=1;var r=hr(),t=Object;return _r=function(n){return t(r(n))}}function nt(){if(Mr)return Fr;Mr=1;var r=fr(),t=tt(),n=r({}.hasOwnProperty);return Fr=Object.hasOwn||function(r,e){return n(t(r),e)}}function et(){if(Nr)return Dr;Nr=1;var r=fr(),t=0,n=Math.random(),e=r(1.1.toString);return Dr=function(r){return "Symbol("+(void 0===r?"":r)+")_"+e(++t+n,36)}}function it(){if($r)return Ur;$r=1;var r=u(),t=rt(),n=nt(),e=et(),i=mr(),o=wr(),a=r.Symbol,c=t("wks"),f=o?a.for||a:a&&a.withoutSetter||e;return Ur=function(r){return n(c,r)||(c[r]=i&&n(a,r)?a[r]:f("Symbol."+r)),c[r]}}function ot(){if(zr)return Gr;zr=1;var r=m(),t=dr(),n=Sr(),e=Er(),i=jr(),o=it(),u=TypeError,a=o("toPrimitive");return Gr=function(o,c){if(!t(o)||n(o))return o;var f,s=e(o,a);if(s){if(void 0===c&&(c="default"),f=r(s,o,c),!t(f)||n(f))return f;throw new u("Can't convert object to primitive value")}return void 0===c&&(c="number"),i(o,c)}}function ut(){if(Hr)return Kr;Hr=1;var r=ot(),t=Sr();return Kr=function(n){var e=r(n,"string");return t(e)?e:e+""}}function at(){if(Br)return Wr;Br=1;var r=u(),t=dr(),n=r.document,e=t(n)&&t(n.createElement);return Wr=function(r){return e?n.createElement(r):{}}}function ct(){if(Jr)return Zr;Jr=1;var r=y(),t=g(),n=at();return Zr=!r&&!t(function(){return 7!==Object.defineProperty(n("div"),"a",{get:function(){return 7}}).a})}function ft(){if(Yr)return d;Yr=1;var r=y(),t=m(),n=function(){if(w)return ar;w=1;var r={}.propertyIsEnumerable,t=Object.getOwnPropertyDescriptor,n=t&&!r.call({1:2},1);return ar.f=n?function(r){var n=t(this,r);return !!n&&n.enumerable}:r,ar}(),e=cr(),i=pr(),o=ut(),u=nt(),a=ct(),c=Object.getOwnPropertyDescriptor;return d.f=r?c:function(r,f){if(r=i(r),f=o(f),a)try{return c(r,f)}catch(r){}if(u(r,f))return e(!t(n.f,r,f),r[f])},d}var st,lt,ht,pt,vt,dt,gt,yt={};function bt(){if(lt)return st;lt=1;var r=y(),t=g();return st=r&&t(function(){return 42!==Object.defineProperty(function(){},"prototype",{value:42,writable:!1}).prototype})}function mt(){if(pt)return ht;pt=1;var r=dr(),t=String,n=TypeError;return ht=function(e){if(r(e))return e;throw new n(t(e)+" is not an object")}}function wt(){if(vt)return yt;vt=1;var r=y(),t=ct(),n=bt(),e=mt(),i=ut(),o=TypeError,u=Object.defineProperty,a=Object.getOwnPropertyDescriptor,c="enumerable",f="configurable",s="writable";return yt.f=r?n?function(r,t,n){if(e(r),t=i(t),e(n),"function"==typeof r&&"prototype"===t&&"value"in n&&s in n&&!n[s]){var o=a(r,t);o&&o[s]&&(r[t]=n.value,n={configurable:f in n?n[f]:o[f],enumerable:c in n?n[c]:o[c],writable:!1});}return u(r,t,n)}:u:function(r,n,a){if(e(r),n=i(n),e(a),t)try{return u(r,n,a)}catch(r){}if("get"in a||"set"in a)throw new o("Accessors not supported");return "value"in a&&(r[n]=a.value),r},yt}function St(){if(gt)return dt;gt=1;var r=y(),t=wt(),n=cr();return dt=r?function(r,e,i){return t.f(r,e,n(1,i))}:function(r,t,n){return r[t]=n,r}}var Ot,It,Et,jt,Pt,Tt,Rt,xt,Lt,kt,At,_t,Ct,Ft,Mt,Dt={exports:{}};function Nt(){if(jt)return Et;jt=1;var r=fr(),t=vr(),n=Qr(),e=r(Function.toString);return t(n.inspectSource)||(n.inspectSource=function(r){return e(r)}),Et=n.inspectSource}function Ut(){if(xt)return Rt;xt=1;var r=rt(),t=et(),n=r("keys");return Rt=function(r){return n[r]||(n[r]=t(r))}}function $t(){return kt?Lt:(kt=1,Lt={})}function Gt(){if(_t)return At;_t=1;var r,t,n,e=function(){if(Tt)return Pt;Tt=1;var r=u(),t=vr(),n=r.WeakMap;return Pt=t(n)&&/native code/.test(String(n))}(),i=u(),o=dr(),a=St(),c=nt(),f=Qr(),s=Ut(),l=$t(),h="Object already initialized",p=i.TypeError,v=i.WeakMap;if(e||f.state){var d=f.state||(f.state=new v);d.get=d.get,d.has=d.has,d.set=d.set,r=function(r,t){if(d.has(r))throw new p(h);return t.facade=r,d.set(r,t),t},t=function(r){return d.get(r)||{}},n=function(r){return d.has(r)};}else {var g=s("state");l[g]=!0,r=function(r,t){if(c(r,g))throw new p(h);return t.facade=r,a(r,g,t),t},t=function(r){return c(r,g)?r[g]:{}},n=function(r){return c(r,g)};}return At={set:r,get:t,has:n,enforce:function(e){return n(e)?t(e):r(e,{})},getterFor:function(r){return function(n){var e;if(!o(n)||(e=t(n)).type!==r)throw new p("Incompatible receiver, "+r+" required");return e}}}}function zt(){if(Ct)return Dt.exports;Ct=1;var r=fr(),t=g(),n=vr(),e=nt(),i=y(),o=function(){if(It)return Ot;It=1;var r=y(),t=nt(),n=Function.prototype,e=r&&Object.getOwnPropertyDescriptor,i=t(n,"name"),o=i&&"something"===function(){}.name,u=i&&(!r||r&&e(n,"name").configurable);return Ot={EXISTS:i,PROPER:o,CONFIGURABLE:u}}().CONFIGURABLE,u=Nt(),a=Gt(),c=a.enforce,f=a.get,s=String,l=Object.defineProperty,h=r("".slice),p=r("".replace),v=r([].join),d=i&&!t(function(){return 8!==l(function(){},"length",{value:8}).length}),b=String(String).split("String"),m=Dt.exports=function(r,t,n){"Symbol("===h(s(t),0,7)&&(t="["+p(s(t),/^Symbol\(([^)]*)\).*$/,"$1")+"]"),n&&n.getter&&(t="get "+t),n&&n.setter&&(t="set "+t),(!e(r,"name")||o&&r.name!==t)&&(i?l(r,"name",{value:t,configurable:!0}):r.name=t),d&&n&&e(n,"arity")&&r.length!==n.arity&&l(r,"length",{value:n.arity});try{n&&e(n,"constructor")&&n.constructor?i&&l(r,"prototype",{writable:!1}):r.prototype&&(r.prototype=void 0);}catch(r){}var u=c(r);return e(u,"source")||(u.source=v(b,"string"==typeof t?t:"")),r};return Function.prototype.toString=m(function(){return n(this)&&f(this).source||u(this)},"toString"),Dt.exports}function Kt(){if(Mt)return Ft;Mt=1;var r=vr(),t=wt(),n=zt(),e=Xr();return Ft=function(i,o,u,a){a||(a={});var c=a.enumerable,f=void 0!==a.name?a.name:o;if(r(u)&&n(u,f,a),a.global)c?i[o]=u:e(o,u);else {try{a.unsafe?i[o]&&(c=!0):delete i[o];}catch(r){}c?i[o]=u:t.f(i,o,{value:u,enumerable:!1,configurable:!a.nonConfigurable,writable:!a.nonWritable});}return i}}var Ht,Wt,Bt,Zt,Jt,Yt,qt,Vt,Xt,Qt,rn,tn,nn,en,on,un,an,cn={};function fn(){if(Zt)return Bt;Zt=1;var r=function(){if(Wt)return Ht;Wt=1;var r=Math.ceil,t=Math.floor;return Ht=Math.trunc||function(n){var e=+n;return (e>0?t:r)(e)}}();return Bt=function(t){var n=+t;return n!=n||0===n?0:r(n)}}function sn(){if(Yt)return Jt;Yt=1;var r=fn(),t=Math.max,n=Math.min;return Jt=function(e,i){var o=r(e);return o<0?t(o+i,0):n(o,i)}}function ln(){if(Vt)return qt;Vt=1;var r=fn(),t=Math.min;return qt=function(n){var e=r(n);return e>0?t(e,9007199254740991):0}}function hn(){if(Qt)return Xt;Qt=1;var r=ln();return Xt=function(t){return r(t.length)}}function pn(){if(en)return nn;en=1;var r=fr(),t=nt(),n=pr(),e=function(){if(tn)return rn;tn=1;var r=pr(),t=sn(),n=hn(),e=function(e){return function(i,o,u){var a=r(i),c=n(a);if(0===c)return !e&&-1;var f,s=t(u,c);if(e&&o!=o){for(;c>s;)if((f=a[s++])!=f)return !0}else for(;c>s;s++)if((e||s in a)&&a[s]===o)return e||s||0;return !e&&-1}};return rn={includes:e(!0),indexOf:e(!1)}}().indexOf,i=$t(),o=r([].push);return nn=function(r,u){var a,c=n(r),f=0,s=[];for(a in c)!t(i,a)&&t(c,a)&&o(s,a);for(;u.length>f;)t(c,a=u[f++])&&(~e(s,a)||o(s,a));return s}}function vn(){return un?on:(un=1,on=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"])}var dn,gn,yn,bn,mn,wn,Sn,On,In,En,jn,Pn,Tn,Rn,xn,Ln,kn,An,_n,Cn={};function Fn(){if(yn)return gn;yn=1;var r=gr(),t=fr(),n=function(){if(an)return cn;an=1;var r=pn(),t=vn().concat("length","prototype");return cn.f=Object.getOwnPropertyNames||function(n){return r(n,t)},cn}(),e=(dn||(dn=1,Cn.f=Object.getOwnPropertySymbols),Cn),i=mt(),o=t([].concat);return gn=r("Reflect","ownKeys")||function(r){var t=n.f(i(r)),u=e.f;return u?o(t,u(r)):t}}function Mn(){if(mn)return bn;mn=1;var r=nt(),t=Fn(),n=ft(),e=wt();return bn=function(i,o,u){for(var a=t(o),c=e.f,f=n.f,s=0;s<a.length;s++){var l=a[s];r(i,l)||u&&r(u,l)||c(i,l,f(o,l));}}}function Dn(){if(In)return On;In=1;var r=u(),t=ft().f,n=St(),e=Kt(),i=Xr(),o=Mn(),a=function(){if(Sn)return wn;Sn=1;var r=g(),t=vr(),n=/#|\.prototype\./,e=function(n,e){var c=o[i(n)];return c===a||c!==u&&(t(e)?r(e):!!e)},i=e.normalize=function(r){return String(r).replace(n,".").toLowerCase()},o=e.data={},u=e.NATIVE="N",a=e.POLYFILL="P";return wn=e}();return On=function(u,c){var f,s,l,h,p,v=u.target,d=u.global,g=u.stat;if(f=d?r:g?r[v]||i(v,{}):r[v]&&r[v].prototype)for(s in c){if(h=c[s],l=u.dontCallGetSet?(p=t(f,s))&&p.value:f[s],!a(d?s:v+(g?".":"#")+s,u.forced)&&void 0!==l){if(typeof h==typeof l)continue;o(h,l);}(u.sham||l&&l.sham)&&n(h,"sham",!0),e(f,s,h,u);}}}function Nn(){if(jn)return En;jn=1;var r=yr(),t=TypeError;return En=function(n,e){if(r(e,n))return n;throw new t("Incorrect invocation")}}function Un(){if(xn)return Rn;xn=1;var r=nt(),t=vr(),n=tt(),e=Ut(),i=function(){if(Tn)return Pn;Tn=1;var r=g();return Pn=!r(function(){function r(){}return r.prototype.constructor=null,Object.getPrototypeOf(new r)!==r.prototype})}(),o=e("IE_PROTO"),u=Object,a=u.prototype;return Rn=i?u.getPrototypeOf:function(e){var i=n(e);if(r(i,o))return i[o];var c=i.constructor;return t(c)&&i instanceof c?c.prototype:i instanceof u?a:null}}function $n(){if(kn)return Ln;kn=1;var r=zt(),t=wt();return Ln=function(n,e,i){return i.get&&r(i.get,e,{getter:!0}),i.set&&r(i.set,e,{setter:!0}),t.f(n,e,i)}}function Gn(){if(_n)return An;_n=1;var r=y(),t=wt(),n=cr();return An=function(e,i,o){r?t.f(e,i,n(0,o)):e[i]=o;}}var zn,Kn,Hn,Wn,Bn,Zn,Jn,Yn,qn,Vn,Xn,Qn={};function re(){if(Kn)return zn;Kn=1;var r=pn(),t=vn();return zn=Object.keys||function(n){return r(n,t)}}function te(){if(Bn)return Wn;Bn=1;var r=gr();return Wn=r("document","documentElement")}function ne(){if(Jn)return Zn;Jn=1;var r,t=mt(),n=function(){if(Hn)return Qn;Hn=1;var r=y(),t=bt(),n=wt(),e=mt(),i=pr(),o=re();return Qn.f=r&&!t?Object.defineProperties:function(r,t){e(r);for(var u,a=i(t),c=o(t),f=c.length,s=0;f>s;)n.f(r,u=c[s++],a[u]);return r},Qn}(),e=vn(),i=$t(),o=te(),u=at(),a=Ut(),c="prototype",f="script",s=a("IE_PROTO"),l=function(){},h=function(r){return "<"+f+">"+r+"</"+f+">"},p=function(r){r.write(h("")),r.close();var t=r.parentWindow.Object;return r=null,t},v=function(){try{r=new ActiveXObject("htmlfile");}catch(r){}var t,n,i;v="undefined"!=typeof document?document.domain&&r?p(r):(n=u("iframe"),i="java"+f+":",n.style.display="none",o.appendChild(n),n.src=String(i),(t=n.contentWindow.document).open(),t.write(h("document.F=Object")),t.close(),t.F):p(r);for(var a=e.length;a--;)delete v[c][e[a]];return v()};return i[s]=!0,Zn=Object.create||function(r,e){var i;return null!==r?(l[c]=t(r),i=new l,l[c]=null,i[s]=r):i=v(),void 0===e?i:n.f(i,e)}}function ee(){if(qn)return Yn;qn=1;var r,t,n,e=g(),i=vr(),o=dr(),u=ne(),a=Un(),c=Kt(),f=it(),s=Vr(),l=f("iterator"),h=!1;return [].keys&&("next"in(n=[].keys())?(t=a(a(n)))!==Object.prototype&&(r=t):h=!0),!o(r)||e(function(){var t={};return r[l].call(t)!==t})?r={}:s&&(r=u(r)),i(r[l])||c(r,l,function(){return this}),Yn={IteratorPrototype:r,BUGGY_SAFARI_ITERATORS:h}}Xn||(Xn=1,function(){if(Vn)return o;Vn=1;var r=Dn(),t=u(),n=Nn(),e=mt(),i=vr(),a=Un(),c=$n(),f=Gn(),s=g(),l=nt(),h=it(),p=ee().IteratorPrototype,v=y(),d=Vr(),b="constructor",m="Iterator",w=h("toStringTag"),S=TypeError,O=t[m],I=d||!i(O)||O.prototype!==p||!s(function(){O({});}),E=function(){if(n(this,p),a(this)===p)throw new S("Abstract class Iterator not directly constructable")},j=function(r,t){v?c(p,r,{configurable:!0,get:function(){return t},set:function(t){if(e(this),this===p)throw new S("You can't redefine this property");l(this,r)?this[r]=t:f(this,r,t);}}):p[r]=t;};l(p,w)||j(w,m),!I&&l(p,b)&&p[b]!==Object||j(b,E),E.prototype=p,r({global:!0,constructor:!0,forced:I},{Iterator:E});}());var ie,oe,ue,ae,ce,fe,se,le,he,pe,ve,de,ge,ye,be,me,we,Se,Oe,Ie,Ee,je,Pe,Te,Re,xe,Le={};function ke(){if(ae)return ue;ae=1;var r=function(){if(oe)return ie;oe=1;var r=sr(),t=fr();return ie=function(n){if("Function"===r(n))return t(n)}}(),t=Ir(),n=b(),e=r(r.bind);return ue=function(r,i){return t(r),void 0===i?r:n?e(r,i):function(){return r.apply(i,arguments)}},ue}function Ae(){return fe?ce:(fe=1,ce={})}function _e(){if(le)return se;le=1;var r=it(),t=Ae(),n=r("iterator"),e=Array.prototype;return se=function(r){return void 0!==r&&(t.Array===r||e[n]===r)}}function Ce(){if(de)return ve;de=1;var r=function(){if(pe)return he;pe=1;var r={};return r[it()("toStringTag")]="z",he="[object z]"===String(r)}(),t=vr(),n=sr(),e=it()("toStringTag"),i=Object,o="Arguments"===n(function(){return arguments}());return ve=r?n:function(r){var u,a,c;return void 0===r?"Undefined":null===r?"Null":"string"==typeof(a=function(r,t){try{return r[t]}catch(r){}}(u=i(r),e))?a:o?n(u):"Object"===(c=n(u))&&t(u.callee)?"Arguments":c}}function Fe(){if(ye)return ge;ye=1;var r=Ce(),t=Er(),n=lr(),e=Ae(),i=it()("iterator");return ge=function(o){if(!n(o))return t(o,i)||t(o,"@@iterator")||e[r(o)]}}function Me(){if(me)return be;me=1;var r=m(),t=Ir(),n=mt(),e=Or(),i=Fe(),o=TypeError;return be=function(u,a){var c=arguments.length<2?i(u):a;if(t(c))return n(r(c,u));throw new o(e(u)+" is not iterable")},be}function De(){if(Se)return we;Se=1;var r=m(),t=mt(),n=Er();return we=function(e,i,o){var u,a;t(e);try{if(!(u=n(e,"return"))){if("throw"===i)throw o;return o}u=r(u,e);}catch(r){a=!0,u=r;}if("throw"===i)throw o;if(a)throw u;return t(u),o}}function Ne(){if(Ie)return Oe;Ie=1;var r=ke(),t=m(),n=mt(),e=Or(),i=_e(),o=hn(),u=yr(),a=Me(),c=Fe(),f=De(),s=TypeError,l=function(r,t){this.stopped=r,this.result=t;},h=l.prototype;return Oe=function(p,v,d){var g,y,b,m,w,S,O,I=d&&d.that,E=!(!d||!d.AS_ENTRIES),j=!(!d||!d.IS_RECORD),P=!(!d||!d.IS_ITERATOR),T=!(!d||!d.INTERRUPTED),R=r(v,I),x=function(r){return g&&f(g,"normal"),new l(!0,r)},L=function(r){return E?(n(r),T?R(r[0],r[1],x):R(r[0],r[1])):T?R(r,x):R(r)};if(j)g=p.iterator;else if(P)g=p;else {if(!(y=c(p)))throw new s(e(p)+" is not iterable");if(i(y)){for(b=0,m=o(p);m>b;b++)if((w=L(p[b]))&&u(h,w))return w;return new l(!1)}g=a(p,y);}for(S=j?p.next:g.next;!(O=t(S,g)).done;){try{w=L(O.value);}catch(r){f(g,"throw",r);}if("object"==typeof w&&w&&u(h,w))return w}return new l(!1)}}function Ue(){return je?Ee:(je=1,Ee=function(r){return {iterator:r,next:r.next,done:!1}})}function $e(){if(Te)return Pe;Te=1;var r=u();return Pe=function(t,n){var e=r.Iterator,i=e&&e.prototype,o=i&&i[t],u=!1;if(o)try{o.call({next:function(){return {done:!0}},return:function(){u=!0;}},-1);}catch(r){r instanceof n||(u=!1);}if(!u)return o}}xe||(xe=1,function(){if(Re)return Le;Re=1;var r=Dn(),t=m(),n=Ne(),e=Ir(),i=mt(),o=Ue(),u=De(),a=$e()("forEach",TypeError);r({target:"Iterator",proto:!0,real:!0,forced:a},{forEach:function(r){i(this);try{e(r);}catch(r){u(this,"throw",r);}if(a)return t(a,this,r);var c=o(this),f=0;n(c,function(t){r(t,f++);},{IS_RECORD:!0});}});}());var Ge,ze,Ke,He,We,Be,Ze,Je,Ye,qe,Ve,Xe,Qe,ri,ti,ni,ei={};function ii(){if(ze)return Ge;ze=1;var r=Kt();return Ge=function(t,n,e){for(var i in n)r(t,i,n[i],e);return t}}function oi(){return He?Ke:(He=1,Ke=function(r,t){return {value:r,done:t}})}function ui(){if(Be)return We;Be=1;var r=De();return We=function(t,n,e){for(var i=t.length-1;i>=0;i--)if(void 0!==t[i])try{e=r(t[i].iterator,n,e);}catch(r){n="throw",e=r;}if("throw"===n)throw e;return e}}function ai(){if(qe)return Ye;qe=1;var r=mt(),t=De();return Ye=function(n,e,i,o){try{return o?e(r(i)[0],i[1]):e(i)}catch(r){t(n,"throw",r);}}}function ci(){return Xe?Ve:(Xe=1,Ve=function(r,t){var n="function"==typeof Iterator&&Iterator.prototype[r];if(n)try{n.call({next:null},t).next();}catch(r){return !0}})}function fi(){if(Qe)return ei;Qe=1;var r=Dn(),t=m(),n=Ir(),e=mt(),i=Ue(),o=function(){if(Je)return Ze;Je=1;var r=m(),t=ne(),n=St(),e=ii(),i=it(),o=Gt(),u=Er(),a=ee().IteratorPrototype,c=oi(),f=De(),s=ui(),l=i("toStringTag"),h="IteratorHelper",p="WrapForValidIterator",v="normal",d="throw",g=o.set,y=function(n){var i=o.getterFor(n?p:h);return e(t(a),{next:function(){var r=i(this);if(n)return r.nextHandler();if(r.done)return c(void 0,!0);try{var t=r.nextHandler();return r.returnHandlerResult?t:c(t,r.done)}catch(t){throw r.done=!0,t}},return:function(){var t=i(this),e=t.iterator;if(t.done=!0,n){var o=u(e,"return");return o?r(o,e):c(void 0,!0)}if(t.inner)try{f(t.inner.iterator,v);}catch(r){return f(e,d,r)}if(t.openIters)try{s(t.openIters,v);}catch(r){return f(e,d,r)}return e&&f(e,v),c(void 0,!0)}})},b=y(!0),w=y(!1);return n(w,l,"Iterator Helper"),Ze=function(r,t,n){var e=function(e,i){i?(i.iterator=e.iterator,i.next=e.next):i=e,i.type=t?p:h,i.returnHandlerResult=!!n,i.nextHandler=r,i.counter=0,i.done=!1,g(this,i);};return e.prototype=t?b:w,e}}(),u=ai(),a=De(),c=ci(),f=$e(),s=Vr(),l=!s&&!c("map",function(){}),h=!s&&!l&&f("map",TypeError),p=s||l||h,v=o(function(){var r=this.iterator,n=e(t(this.next,r));if(!(this.done=!!n.done))return u(r,this.mapper,[n.value,this.counter++],!0)});return r({target:"Iterator",proto:!0,real:!0,forced:p},{map:function(r){e(this);try{n(r);}catch(r){a(this,"throw",r);}return h?t(h,this,r):new v(i(this),{mapper:r})}}),ei}function si(r,t,n,e){return new(n||(n=Promise))(function(i,o){function u(r){try{c(e.next(r));}catch(r){o(r);}}function a(r){try{c(e.throw(r));}catch(r){o(r);}}function c(r){var t;r.done?i(r.value):(t=r.value,t instanceof n?t:new n(function(r){r(t);})).then(u,a);}c((e=e.apply(r,t||[])).next());})}ri||(ri=1,fi()),"function"==typeof SuppressedError&&SuppressedError;var li=n(ni?ti:(ni=1,ti=function r(t,n){if(t===n)return !0;if(t&&n&&"object"==typeof t&&"object"==typeof n){if(t.constructor!==n.constructor)return !1;var e,i,o;if(Array.isArray(t)){if((e=t.length)!=n.length)return !1;for(i=e;0!==i--;)if(!r(t[i],n[i]))return !1;return !0}if(t.constructor===RegExp)return t.source===n.source&&t.flags===n.flags;if(t.valueOf!==Object.prototype.valueOf)return t.valueOf()===n.valueOf();if(t.toString!==Object.prototype.toString)return t.toString()===n.toString();if((e=(o=Object.keys(t)).length)!==Object.keys(n).length)return !1;for(i=e;0!==i--;)if(!Object.prototype.hasOwnProperty.call(n,o[i]))return !1;for(i=e;0!==i--;){var u=o[i];if(!r(t[u],n[u]))return !1}return !0}return t!=t&&n!=n}));const hi="__googleMapsScriptId";var pi;r.LoaderStatus=void 0,(pi=r.LoaderStatus||(r.LoaderStatus={}))[pi.INITIALIZED=0]="INITIALIZED",pi[pi.LOADING=1]="LOADING",pi[pi.SUCCESS=2]="SUCCESS",pi[pi.FAILURE=3]="FAILURE";class vi{constructor(r){let{apiKey:t,authReferrerPolicy:n,channel:e,client:i,id:o=hi,language:u,libraries:a=[],mapIds:c,nonce:f,region:s,retries:l=3,url:h="https://maps.googleapis.com/maps/api/js",version:p}=r;if(this.callbacks=[],this.done=!1,this.loading=!1,this.errors=[],this.apiKey=t,this.authReferrerPolicy=n,this.channel=e,this.client=i,this.id=o||hi,this.language=u,this.libraries=a,this.mapIds=c,this.nonce=f,this.region=s,this.retries=l,this.url=h,this.version=p,vi.instance){if(!li(this.options,vi.instance.options))throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(vi.instance.options)}`);return vi.instance}vi.instance=this;}get options(){return {version:this.version,apiKey:this.apiKey,channel:this.channel,client:this.client,id:this.id,libraries:this.libraries,language:this.language,region:this.region,mapIds:this.mapIds,nonce:this.nonce,url:this.url,authReferrerPolicy:this.authReferrerPolicy}}get status(){return this.errors.length?r.LoaderStatus.FAILURE:this.done?r.LoaderStatus.SUCCESS:this.loading?r.LoaderStatus.LOADING:r.LoaderStatus.INITIALIZED}get failed(){return this.done&&!this.loading&&this.errors.length>=this.retries+1}createUrl(){let r=this.url;return r+="?callback=__googleMapsCallback&loading=async",this.apiKey&&(r+=`&key=${this.apiKey}`),this.channel&&(r+=`&channel=${this.channel}`),this.client&&(r+=`&client=${this.client}`),this.libraries.length>0&&(r+=`&libraries=${this.libraries.join(",")}`),this.language&&(r+=`&language=${this.language}`),this.region&&(r+=`&region=${this.region}`),this.version&&(r+=`&v=${this.version}`),this.mapIds&&(r+=`&map_ids=${this.mapIds.join(",")}`),this.authReferrerPolicy&&(r+=`&auth_referrer_policy=${this.authReferrerPolicy}`),r}deleteScript(){const r=document.getElementById(this.id);r&&r.remove();}load(){return this.loadPromise()}loadPromise(){return new Promise((r,t)=>{this.loadCallback(n=>{n?t(n.error):r(window.google);});})}importLibrary(r){return this.execute(),google.maps.importLibrary(r)}loadCallback(r){this.callbacks.push(r),this.execute();}setScript(){var r,t;if(document.getElementById(this.id))return void this.callback();const n={key:this.apiKey,channel:this.channel,client:this.client,libraries:this.libraries.length&&this.libraries,v:this.version,mapIds:this.mapIds,language:this.language,region:this.region,authReferrerPolicy:this.authReferrerPolicy};Object.keys(n).forEach(r=>!n[r]&&delete n[r]),(null===(t=null===(r=null===window||void 0===window?void 0:window.google)||void 0===r?void 0:r.maps)||void 0===t?void 0:t.importLibrary)||(r=>{let t,n,e,i="The Google Maps JavaScript API",o="google",u="importLibrary",a="__ib__",c=document,f=window;f=f[o]||(f[o]={});const s=f.maps||(f.maps={}),l=new Set,h=new URLSearchParams,p=()=>t||(t=new Promise((u,f)=>si(this,void 0,void 0,function*(){var p;for(e in yield n=c.createElement("script"),n.id=this.id,h.set("libraries",[...l]+""),r)h.set(e.replace(/[A-Z]/g,r=>"_"+r[0].toLowerCase()),r[e]);h.set("callback",o+".maps."+a),n.src=this.url+"?"+h,s[a]=u,n.onerror=()=>t=f(Error(i+" could not load.")),n.nonce=this.nonce||(null===(p=c.querySelector("script[nonce]"))||void 0===p?void 0:p.nonce)||"",c.head.append(n);})));s[u]?console.warn(i+" only loads once. Ignoring:",r):s[u]=function(r){for(var t=arguments.length,n=new Array(t>1?t-1:0),e=1;e<t;e++)n[e-1]=arguments[e];return l.add(r)&&p().then(()=>s[u](r,...n))};})(n);const e=this.libraries.map(r=>this.importLibrary(r));e.length||e.push(this.importLibrary("core")),Promise.all(e).then(()=>this.callback(),r=>{const t=new ErrorEvent("error",{error:r});this.loadErrorCallback(t);});}reset(){this.deleteScript(),this.done=!1,this.loading=!1,this.errors=[],this.onerrorEvent=null;}resetIfRetryingFailed(){this.failed&&this.reset();}loadErrorCallback(r){if(this.errors.push(r),this.errors.length<=this.retries){const r=this.errors.length*Math.pow(2,this.errors.length);console.error(`Failed to load Google Maps script, retrying in ${r} ms.`),setTimeout(()=>{this.deleteScript(),this.setScript();},r);}else this.onerrorEvent=r,this.callback();}callback(){this.done=!0,this.loading=!1,this.callbacks.forEach(r=>{r(this.onerrorEvent);}),this.callbacks=[];}execute(){if(this.resetIfRetryingFailed(),!this.loading)if(this.done)this.callback();else {if(window.google&&window.google.maps&&window.google.maps.version)return console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match."),void this.callback();this.loading=!0,this.setScript();}}}r.DEFAULT_ID=hi,r.Loader=vi;});

}(index_umd, index_umd.exports));

var css_248z$11 = ".style_container__kq4Np {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.style_inputContainer__L3IvV {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  flex-wrap: wrap;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.style_buttonTest__qPQCH {\n  background-color: #2464dc;\n  border: none;\n  color: white;\n  padding: 8px 16px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 500;\n  margin: 4px 2px;\n  cursor: pointer;\n  margin-top: 5px;\n  border-radius: 10px;\n}";
var style$J = {"container":"style_container__kq4Np","inputContainer":"style_inputContainer__L3IvV","buttonTest":"style_buttonTest__qPQCH"};
styleInject(css_248z$11);

const useMapsScripts = ({ apiKey, hideMap, center, buttonLabel, onAddPlace, }) => {
    const [placesButton, setPlacesButton] = useState(null);
    const handlePlaces = useCallback((map) => {
        const input = document.getElementById("pac-input");
        if (!input) {
            throw new Error("Input element with id 'pac-input' not found");
        }
        // Specify just the place data fields that you need.
        const autocomplete = new google.maps.places.Autocomplete(input, {
            fields: [
                "place_id",
                "geometry",
                "formatted_address",
                "name",
                "address_components",
                "formatted_phone_number",
                "website",
            ],
        });
        autocomplete.bindTo("bounds", map);
        // map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
        const infowindowContent = document.getElementById("infowindow-content");
        if (!infowindowContent) {
            throw new Error("Element with id 'infowindow-content' not found");
        }
        const infowindow = new google.maps.InfoWindow({
            pixelOffset: new google.maps.Size(0, -30),
            content: infowindowContent,
        });
        infowindow.setContent(infowindowContent);
        const marker = new google.maps.Marker({ map: map });
        marker.addListener("click", () => {
            console.log("click place");
            infowindow.open(map, marker);
        });
        autocomplete.addListener("place_changed", () => {
            infowindow.close();
            const place = autocomplete.getPlace();
            if (!place.geometry || !place.geometry.location) {
                return;
            }
            const exportData = () => {
                var _a;
                if (onAddPlace) {
                    // change the format of address_components
                    const addressComponents = (_a = (place.address_components || [])) === null || _a === void 0 ? void 0 : _a.map((component) => {
                        return {
                            longName: component.long_name,
                            shortName: component.short_name,
                            types: component.types,
                        };
                    });
                    onAddPlace({
                        name: (place === null || place === void 0 ? void 0 : place.name) || "",
                        placeId: (place === null || place === void 0 ? void 0 : place.place_id) || "",
                        formattedAddress: (place === null || place === void 0 ? void 0 : place.formatted_address) || "",
                        phone: (place === null || place === void 0 ? void 0 : place.formatted_phone_number) || "",
                        website: (place === null || place === void 0 ? void 0 : place.website) || "",
                        addressComponents,
                    });
                }
            };
            if (hideMap) {
                exportData();
                return;
            }
            if (place.geometry.viewport) {
                map.fitBounds(place.geometry.viewport);
            }
            else {
                map.setCenter(place.geometry.location);
                map.setZoom(17);
            }
            // Set the position of the marker using the place ID and location.
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore This should be in @typings/googlemaps.
            marker.setPlace({
                placeId: place.place_id,
                location: place.geometry.location,
            });
            marker.setVisible(true);
            infowindowContent.children.namedItem("place-name").innerHTML = `<b>${place.name}</b>`;
            //  (infowindowContent.children.namedItem("place-id") as HTMLElement).innerHTML = `<b>Place ID: </b>${place.place_id}`;
            infowindowContent.children.namedItem("place-address").textContent =
                place.formatted_address;
            infowindowContent.children.namedItem("place-website").textContent =
                place.website;
            let button = infowindowContent.querySelector(`.${style$J.buttonTest}`);
            if (!button && typeof onAddPlace === "function") {
                button = document.createElement("button");
                button.innerHTML = buttonLabel || "Add to my places";
                button.classList.add(style$J.buttonTest);
                button.addEventListener("click", exportData);
                setPlacesButton(button);
                infowindowContent.appendChild(button);
            }
            if (button && typeof onAddPlace === "function") {
                button.removeEventListener("click", () => { });
                button.addEventListener("click", exportData);
                setPlacesButton(button);
            }
            if (typeof onAddPlace === "function" && placesButton) {
                placesButton.addEventListener("click", exportData);
                return () => {
                    placesButton.removeEventListener("click", exportData);
                };
            }
            const suggestionList = document.querySelector(".pac-container");
            if (suggestionList) {
                suggestionList.style.zIndex = "9999";
            }
            infowindow.open(map, marker);
        });
    }, 
    // Do not add placesButton here, as the warning suggests
    // It will then stop working, not sure why
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onAddPlace]);
    const loadMap = useCallback(() => __awaiter$2(void 0, void 0, void 0, function* () {
        const loader = new index_umd.exports.Loader({
            apiKey,
            version: "weekly",
            libraries: ["places"],
        });
        const elem = document.getElementById("map");
        return loader
            .load()
            .then((google) => {
            const map = new google.maps.Map(elem, {
                center,
                zoom: 4,
            });
            handlePlaces(map);
            return true;
        })
            .catch((e) => {
            console.log("Error loading map: ", { e });
            return false;
        });
    }), [apiKey, center, handlePlaces]);
    return [loadMap];
};

const GMap = ({ apiKey, hideMap, height, width, center, onAddPlace, optionalInput, addPlaceButtonLabel, searchInputPlaceholder, }) => {
    // We could at some point use this to show a loading spinner
    const [, setLoading] = useState(false);
    const [loadMap] = useMapsScripts({ apiKey, center, hideMap, buttonLabel: addPlaceButtonLabel, onAddPlace });
    // called once when the component is mounted
    useEffect(() => {
        function fetchData() {
            return __awaiter$2(this, void 0, void 0, function* () {
                const loadResult = yield loadMap();
                setLoading(loadResult);
            });
        }
        fetchData();
    }, [loadMap, setLoading]);
    // You cannot optionally render any of the div with IDs, as they are required for the map to work
    // The bootstrap looks for them and attaches the map to the div with the ID 'map'
    return (React__default$4.createElement("div", { className: style$J.container, style: { maxHeight: height, maxWidth: width } },
        React__default$4.createElement("div", { id: "pac-container", className: style$J.inputContainer },
            React__default$4.createElement("input", { id: "pac-input", type: "text", placeholder: searchInputPlaceholder || "Search for location", style: {
                    margin: "10px",
                    fontSize: "18px",
                    padding: "10px 15px",
                    width: "100%",
                    // width: "70%",
                    border: "1px solid #aaa",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                } }),
            optionalInput ? React__default$4.createElement("div", null, optionalInput) : React__default$4.createElement(React__default$4.Fragment, null)),
        React__default$4.createElement("div", { id: "map", style: { height, width, margin: "auto", display: hideMap ? "none" : "inherit" } }),
        React__default$4.createElement("div", { id: "infowindow-content", style: {
                display: hideMap ? "none" : "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
            } },
            React__default$4.createElement("span", { id: "place-name", className: "title" }),
            React__default$4.createElement("span", { id: "place-address" }),
            React__default$4.createElement("span", { id: "place-website" }))));
};

// import { getApiUrl } from "../../utils/getApiUrl";
// const API_URL = `${getApiUrl()}/places/predictions`;
// just always use prod here for the most part
const API_URL$2 = `https://api.xapp.ai/places/predictions`;
const fetchSuggestions = (input, signal, options) => __awaiter$2(void 0, void 0, void 0, function* () {
    if (!input.trim())
        return [];
    try {
        const response = yield fetch(API_URL$2, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(Object.assign({ input, includePureServiceAreaBusinesses: true, includedPrimaryTypes: ["establishment"] }, options)),
            signal,
        });
        if (!response.ok) {
            throw new Error(`API Error: ${response.status} ${response.statusText}`);
        }
        const data = yield response.json();
        if (!data || !data.suggestions) {
            return [];
        }
        return data.suggestions
            .map((suggestion) => {
            const placePrediction = suggestion.placePrediction || suggestion.queryPrediction;
            if (!placePrediction)
                return null;
            // Extract structured format data safely
            const structuredFormat = placePrediction.structuredFormat || {};
            const mainTextObj = structuredFormat.mainText || {};
            const secondaryTextObj = structuredFormat.secondaryText || {};
            return {
                place_id: placePrediction.placeId,
                structured_formatting: {
                    main_text: mainTextObj.text || "",
                    main_text_matched_substrings: (mainTextObj.matches || []).map((match) => {
                        var _a, _b, _c;
                        return ({
                            offset: (_a = match.startOffset) !== null && _a !== void 0 ? _a : 0, // Use `startOffset` if available
                            length: ((_b = match.endOffset) !== null && _b !== void 0 ? _b : 0) - ((_c = match.startOffset) !== null && _c !== void 0 ? _c : 0), // Correct length calculation
                        });
                    }),
                    secondary_text: secondaryTextObj.text || "",
                },
            };
        })
            .filter(Boolean); // Remove null values
    }
    catch (error) {
        if (error.name === "AbortError") {
            return [];
        }
        console.error("Error fetching autocomplete suggestions:", error);
        return [];
    }
});

/**
 * The global definition of the API URL may not be defined in
 * unit tests, so this returns either the defined on eor the
 * dev url.
 *
 * It contains https:// but not the trailing /
 */
function getApiUrl() {
    var _a;
    const defaultUrl = "https://dev-api.xapp.media";
    try {
        // @ts-expect-error - window is not defined in unit tests
        return ((_a = window.xaStudioConfig) === null || _a === void 0 ? void 0 : _a.apiUrl) || defaultUrl;
    }
    catch (e) {
        console.warn(`error getting default apiUrl`);
        console.error(e);
        return defaultUrl;
    }
}

/**
 * Converts the PlaceDetailsResponse to a Place
 * @param data
 * @returns
 */
const placeDetailsToPlace = (data) => {
    var _a, _b, _c, _d;
    // change the address components from long_name to longName
    const addressComponents = (data.addressComponents || []).map((component) => {
        // if we have shortText, use those
        if (component.shortText || component.longText) {
            return {
                longName: component.longText,
                shortName: component.shortText,
                types: component.types,
            };
        }
        else {
            return {
                longName: component.longName,
                shortName: component.shortName,
                types: component.types,
            };
        }
    });
    const reviews = (data.reviews || []).map((review) => {
        var _a, _b, _c, _d;
        return {
            authorName: (_a = review.authorAttribution) === null || _a === void 0 ? void 0 : _a.displayName,
            authorUrl: (_b = review.authorAttribution) === null || _b === void 0 ? void 0 : _b.uri,
            profilePhotoUrl: (_c = review.authorAttribution) === null || _c === void 0 ? void 0 : _c.photoUri,
            rating: review.rating,
            text: (_d = review.text) === null || _d === void 0 ? void 0 : _d.text,
        };
    });
    const photos = (data.photos || []).map((photo) => {
        // photo.name starts with /place/{place_id}/photos/{photo_reference}
        // we want to strip the /place/{place_id}/photos/ part
        const photoReference = photo.name.split("/").pop() || "";
        return {
            height: photo.heightPx,
            width: photo.widthPx,
            photoReference,
        };
    });
    // Google Places API v1 returns id as "places/ChIJ..." but we expect just "ChIJ..."
    // Strip the "places/" prefix to match the input placeId format
    const normalizedPlaceId = (_b = (_a = data.id) === null || _a === void 0 ? void 0 : _a.replace(/^places\//, '')) !== null && _b !== void 0 ? _b : data.id;
    const place = {
        name: (_c = data.displayName) === null || _c === void 0 ? void 0 : _c.text,
        placeId: normalizedPlaceId,
        mapsUrl: data.googleMapsUri,
        formattedAddress: data.formattedAddress,
        website: data.websiteUri,
        phone: data.nationalPhoneNumber,
        addressComponents,
        rating: data.rating,
        totalRatings: data.userRatingCount,
        pureServiceAreaBusiness: data.pureServiceAreaBusiness,
        reviews,
        photos,
        types: data.types,
        primaryDisplayType: (_d = data.primaryTypeDisplayName) === null || _d === void 0 ? void 0 : _d.text,
    };
    return place;
};

const API_URL$1 = `${getApiUrl()}/places/details`;
// const API_URL = `https://api.xapp.ai/places/details`;
// In-memory cache for place details (5 minute TTL)
const CACHE_TTL_MS = 5 * 60 * 1000;
const placeCache = new Map();
/**
 * Fetch details for a place, with in-memory caching to prevent duplicate requests.
 *
 * @param placeId
 * @returns
 */
const fetchDetails = (placeId, signal) => __awaiter$2(void 0, void 0, void 0, function* () {
    if (!placeId) {
        return undefined;
    }
    // Check cache first
    const cached = placeCache.get(placeId);
    if (cached && Date.now() - cached.timestamp < CACHE_TTL_MS) {
        return cached.place;
    }
    try {
        const response = yield fetch(`${API_URL$1}/${placeId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            signal,
        });
        if (!response.ok) {
            throw new Error(`API Error: ${response.status} ${response.statusText}`);
        }
        const data = yield response.json();
        const place = placeDetailsToPlace(data);
        if (place) {
            placeCache.set(placeId, { place, timestamp: Date.now() });
        }
        return place;
    }
    catch (error) {
        console.error("Failed to fetch place details", error);
        return undefined;
    }
});

/**
 * Simple text normalization for comparison.
 *
 * It will remove all special characters, convert to lower case, and remove spaces.
 *
 * @param text
 */
const normalizeText = (text) => {
    if (!text) {
        return "";
    }
    return `${text}`
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "")
        .replace(/\s+/g, "")
        .trim();
};

var css_248z$10 = "@charset \"UTF-8\";\n.PlacesAutocomplete-module_autocomplete__L-O1e {\n  position: relative;\n  width: 100%;\n}\n\n.PlacesAutocomplete-module_input__iG0fA {\n  width: 100%;\n  padding: 10px 0; /* Only top & bottom padding to prevent overflow */\n  text-indent: 10px; /* Adds space for text on the left */\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  outline: none;\n}\n.PlacesAutocomplete-module_input__iG0fA:focus {\n  border-color: #4285f4;\n}\n\n.PlacesAutocomplete-module_suggestions__Zh6Pz {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  min-width: 100%;\n  max-width: 100vw;\n  background: white;\n  border: 1px solid #ccc;\n  border-top: none;\n  border-radius: 0px 0px 4px 4px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  max-height: 300px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 10000;\n}\n\n.PlacesAutocomplete-module_suggestion__MrhPt {\n  display: flex;\n  align-items: center;\n  padding: 3px 10px;\n  cursor: pointer;\n  font-size: 14px;\n  border-bottom: 1px solid #f0f0f0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.PlacesAutocomplete-module_suggestion__MrhPt:hover, .PlacesAutocomplete-module_suggestion__MrhPt.PlacesAutocomplete-module_selected__R-0yw {\n  background: #f1f1f1;\n}\n\n.PlacesAutocomplete-module_icon__Y-azR {\n  width: 15px;\n  height: 20px;\n  margin-right: 7px;\n  margin-top: 6px;\n  display: inline-block;\n  vertical-align: top;\n  background-image: url(\"https://maps.gstatic.com/mapfiles/api-3/images/autocomplete-icons_hdpi.png\");\n  background-size: 34px;\n  background-position: -1px -161px;\n}\n\n.PlacesAutocomplete-module_suggestionContent__edkgF {\n  display: flex;\n  width: 100%;\n  overflow: hidden;\n}\n\n.PlacesAutocomplete-module_business__MsxEW {\n  font-weight: bold;\n  max-width: 50%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.PlacesAutocomplete-module_address__mPOta {\n  font-size: 14px;\n  color: #666;\n  flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-left: 8px;\n}\n\n.PlacesAutocomplete-module_highlight__RSquS {\n  font-weight: bold;\n  color: #4285f4;\n}\n\n.PlacesAutocomplete-module_loadingIndicator__iz4oI {\n  padding: 10px;\n  font-size: 14px;\n  color: #666;\n  text-align: center;\n}\n\n.PlacesAutocomplete-module_hint__bkRab {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n  background: #f9f9f9;\n  border-top: 1px solid #ddd;\n}\n\n.PlacesAutocomplete-module_hintText__0TsUM {\n  font-size: 14px;\n  color: #666;\n  font-style: italic;\n  width: 100%;\n  text-align: center;\n  font-weight: bold;\n}\n\n.PlacesAutocomplete-module_advancedSearch__SCmvR {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  align-items: center;\n  padding: 8px;\n  background: #f9f9f9;\n  border-top: 1px solid #ddd;\n}\n\n.PlacesAutocomplete-module_advancedSearchButton__C9wjA {\n  background: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 5px 10px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #666;\n  transition: background 0.2s;\n}\n.PlacesAutocomplete-module_advancedSearchButton__C9wjA:hover {\n  background: #e1e1e1;\n}\n\n.PlacesAutocomplete-module_poweredByGoogle__sWaaH {\n  display: flex;\n  justify-content: flex-end;\n  padding: 8px;\n  background: #f9f9f9;\n  border-top: 1px solid #ddd;\n}\n\n.PlacesAutocomplete-module_googleImage__YEJu6 {\n  height: 15px;\n}\n\n/* ✅ Mobile Fix: Prevent dropdown from being too wide */\n@media (max-width: 600px) {\n  .PlacesAutocomplete-module_suggestions__Zh6Pz {\n    max-width: calc(100% - 10px);\n  }\n}\n.PlacesAutocomplete-module_modalOverlay__a7Vv5 {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding-top: 5vh;\n}\n\n.PlacesAutocomplete-module_modalContent__xBTrH {\n  background: #fff;\n  border-radius: 4px 4px 0px 0px;\n  padding: 1.5rem;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.PlacesAutocomplete-module_modalHeader__VmgPH {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.PlacesAutocomplete-module_closeButton__Ax22X {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #444;\n  cursor: pointer;\n}\n\n.PlacesAutocomplete-module_doneButton__jBVSJ {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  font-weight: bold;\n}";
var styles$d = {"autocomplete":"PlacesAutocomplete-module_autocomplete__L-O1e","input":"PlacesAutocomplete-module_input__iG0fA","suggestions":"PlacesAutocomplete-module_suggestions__Zh6Pz","suggestion":"PlacesAutocomplete-module_suggestion__MrhPt","selected":"PlacesAutocomplete-module_selected__R-0yw","icon":"PlacesAutocomplete-module_icon__Y-azR","suggestionContent":"PlacesAutocomplete-module_suggestionContent__edkgF","business":"PlacesAutocomplete-module_business__MsxEW","address":"PlacesAutocomplete-module_address__mPOta","highlight":"PlacesAutocomplete-module_highlight__RSquS","loadingIndicator":"PlacesAutocomplete-module_loadingIndicator__iz4oI","hint":"PlacesAutocomplete-module_hint__bkRab","hintText":"PlacesAutocomplete-module_hintText__0TsUM","advancedSearch":"PlacesAutocomplete-module_advancedSearch__SCmvR","advancedSearchButton":"PlacesAutocomplete-module_advancedSearchButton__C9wjA","poweredByGoogle":"PlacesAutocomplete-module_poweredByGoogle__sWaaH","googleImage":"PlacesAutocomplete-module_googleImage__YEJu6","modalOverlay":"PlacesAutocomplete-module_modalOverlay__a7Vv5","modalContent":"PlacesAutocomplete-module_modalContent__xBTrH","modalHeader":"PlacesAutocomplete-module_modalHeader__VmgPH","closeButton":"PlacesAutocomplete-module_closeButton__Ax22X","doneButton":"PlacesAutocomplete-module_doneButton__jBVSJ"};
styleInject(css_248z$10);

const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= breakpoint);
    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [breakpoint]);
    return isMobile;
};
const MobileModal = ({ onClose, children }) => (React__default$4.createElement("div", { className: styles$d.modalOverlay, onClick: onClose },
    React__default$4.createElement("div", { className: styles$d.modalContent, onClick: (e) => e.stopPropagation() },
        React__default$4.createElement("div", { className: styles$d.modalHeader },
            React__default$4.createElement(IconButton, { iconName: "close", className: styles$d.closeButton, onClick: onClose }),
            React__default$4.createElement(Button, { label: "Done", leftIcon: "check_circle", className: styles$d.doneButton, onClick: onClose })),
        children)));
const PlacesAutocomplete = (_a) => {
    var _b, _c, _d;
    var { addressSearch = false, onSelect, onPlace, onUseAdvancedSearch, config } = _a, rest = __rest$2(_a, ["addressSearch", "onSelect", "onPlace", "onUseAdvancedSearch", "config"]);
    const [inputValue, setInputValue] = useState((rest === null || rest === void 0 ? void 0 : rest.value) ? `${rest.value}` : "");
    const [suggestions, setSuggestions] = useState([]);
    const [hint, setHint] = useState();
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isFirstSearch, setIsFirstSearch] = useState(true); // Track first input or cleared input
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isMobile = useIsMobile();
    const [loadingPlace, setLoadingPlace] = useState(false);
    const disableAutocomplete = (config === null || config === void 0 ? void 0 : config.disableAutocomplete) || false;
    const parrotInput = (config === null || config === void 0 ? void 0 : config.parrotInput) || false;
    const debounceTimeout = useRef(null);
    const abortController = useRef(null);
    useEffect(() => {
        if (rest === null || rest === void 0 ? void 0 : rest.value) {
            setInputValue(`${rest.value}`);
        }
    }, [rest === null || rest === void 0 ? void 0 : rest.value]);
    useEffect(() => {
        return () => {
            if (abortController.current) {
                abortController.current.abort();
            }
        };
    }, []);
    // Listen for changes in the input value
    // and searches for suggestions
    const handleChange = useCallback((value) => {
        // const value = event.target.value;
        setInputValue(`${value}`);
        setSelectedIndex(null);
        if (typeof (rest === null || rest === void 0 ? void 0 : rest.onChange) === "function") {
            rest.onChange(value);
        }
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        if (abortController.current) {
            abortController.current.abort();
        }
        let performSearch = !disableAutocomplete && `${value}`.length > 0;
        if (config === null || config === void 0 ? void 0 : config.displaySuggestionsAfterCharacters) {
            performSearch = performSearch && `${value}`.length >= config.displaySuggestionsAfterCharacters;
        }
        if (performSearch) {
            if (isFirstSearch) {
                setIsLoading(true); // Show loading only on first search or after clear
            }
            debounceTimeout.current = setTimeout(() => __awaiter$2(void 0, void 0, void 0, function* () {
                var _a, _b, _c, _d;
                abortController.current = new AbortController();
                try {
                    const options = {
                        includePureServiceAreaBusinesses: !addressSearch,
                        includedPrimaryTypes: addressSearch ? ["geocode"] : ["establishment"],
                        includedRegionCodes: ["us", "ca"],
                    };
                    if (rest === null || rest === void 0 ? void 0 : rest.types) {
                        options.includedPrimaryTypes = rest.types;
                    }
                    const results = (yield (fetchSuggestions(`${value}`, abortController.current.signal, options) || [])).slice(0, 4); // Limit to 4 suggestions
                    // Check the results to see if we have an exact match coming in from Google
                    // and if we don't, we add our own
                    const hasExactMatch = results.some((result) => {
                        const mainText = result.structured_formatting.main_text;
                        // just compare main texts, somewhat normalized
                        // to avoid issues with commas and spaces
                        const normalizedMainText = normalizeText(mainText);
                        const normalizedInput = normalizeText(value);
                        return normalizedMainText === normalizedInput;
                    });
                    /*
                    const hasStartsWithMatch = results.some((result) => {
                        const mainText = result.structured_formatting.main_text;
                        const normalizedMainText = normalizeText(mainText);
                        const normalizedInput = normalizeText(value);
                        return normalizedMainText.startsWith(normalizedInput);
                    }); */
                    // Check if we have many similar results on the main text, look at the first one and see if we have any more similar
                    const firstMainText = (_a = results[0]) === null || _a === void 0 ? void 0 : _a.structured_formatting.main_text;
                    const normalizedFirstMainText = normalizeText(firstMainText);
                    // Just seeing if we have more than one result that is exact same
                    // make sure we don't compare the first one with itself
                    const hasSimilarResults = results.some((result, index) => {
                        if (index === 0) {
                            return false; // Skip the first result
                        }
                        const mainText = result.structured_formatting.main_text;
                        const normalizedMainText = normalizeText(mainText);
                        return normalizedMainText === normalizedFirstMainText;
                    });
                    // sort if we have an exact match with the input (both normalized)
                    // we move this to the top
                    if (hasExactMatch) {
                        results.sort((a, b) => {
                            const normalizedInput = normalizeText(value);
                            const aMainText = normalizeText(a.structured_formatting.main_text);
                            const bMainText = normalizeText(b.structured_formatting.main_text);
                            if (aMainText === normalizedInput) {
                                return -1; // Move a to the top
                            }
                            else if (bMainText === normalizedInput) {
                                return 1; // Move b to the top
                            }
                            return 0;
                        });
                    }
                    // Parrot the input is helpful when we found
                    // 1. no results whatsoever, they can still select one
                    // 2. we have multiple of the exact same (like a franchise), they don't see theirs and they still want to select one
                    // 3. we have a similar result, but they want to select theirs
                    // const canParrot = hasSimilarResults;
                    if (parrotInput) {
                        // If no suggestions, add the input value as a suggestion to the beginning
                        results.unshift({
                            place_id: "input",
                            structured_formatting: {
                                main_text: `${value}`,
                                secondary_text: "",
                                // the whole string is a match
                                main_text_matched_substrings: [
                                    {
                                        offset: 0,
                                        length: `${value}`.length,
                                    },
                                ],
                            },
                        });
                    }
                    if (hasSimilarResults && ((_b = config === null || config === void 0 ? void 0 : config.autocompleteHints) === null || _b === void 0 ? void 0 : _b.multipleSimilarResults)) {
                        setHint(config.autocompleteHints.multipleSimilarResults);
                    }
                    else if (results.length === 0 && ((_c = config === null || config === void 0 ? void 0 : config.autocompleteHints) === null || _c === void 0 ? void 0 : _c.noResults)) {
                        setHint(config.autocompleteHints.noResults);
                    }
                    else if (results.length > 0 && ((_d = config === null || config === void 0 ? void 0 : config.autocompleteHints) === null || _d === void 0 ? void 0 : _d.hasResults)) {
                        setHint(config.autocompleteHints.hasResults);
                    }
                    else {
                        setHint(undefined);
                    }
                    if ((config === null || config === void 0 ? void 0 : config.onlyDisplayOnExactMatch) && !hasExactMatch) {
                        setSuggestions([]);
                        setIsDropdownOpen(false);
                    }
                    else {
                        setSuggestions(results.slice(0, 4)); // Limit to 4 suggestions
                        setIsDropdownOpen(true);
                    }
                }
                catch (error) {
                    console.error(error);
                }
                finally {
                    setIsLoading(false);
                    setIsFirstSearch(false); // Disable first search flag after loading once
                }
            }), 300);
        }
        else {
            setSuggestions([]);
            setIsDropdownOpen(false);
            setIsFirstSearch(true); // Reset first search flag when input is cleared
        }
    }, [
        addressSearch,
        (_b = config === null || config === void 0 ? void 0 : config.autocompleteHints) === null || _b === void 0 ? void 0 : _b.hasResults,
        (_c = config === null || config === void 0 ? void 0 : config.autocompleteHints) === null || _c === void 0 ? void 0 : _c.multipleSimilarResults,
        (_d = config === null || config === void 0 ? void 0 : config.autocompleteHints) === null || _d === void 0 ? void 0 : _d.noResults,
        config === null || config === void 0 ? void 0 : config.displaySuggestionsAfterCharacters,
        config === null || config === void 0 ? void 0 : config.onlyDisplayOnExactMatch,
        disableAutocomplete,
        isFirstSearch,
        parrotInput,
        rest,
    ]);
    const handleSelect = (placeId, description) => {
        const selectedSuggestion = suggestions.find((s) => s.place_id === placeId);
        if (selectedSuggestion) {
            const selectedValue = `${selectedSuggestion.structured_formatting.main_text}, ${selectedSuggestion.structured_formatting.secondary_text}`;
            if (config === null || config === void 0 ? void 0 : config.onlyDisplayBusinessName) {
                setInputValue(`${selectedSuggestion.structured_formatting.main_text}`);
            }
            else if (config === null || config === void 0 ? void 0 : config.onlyDisplayAddress) {
                setInputValue(`${selectedSuggestion.structured_formatting.secondary_text}`);
            }
            else {
                setInputValue(selectedValue);
            }
            if (typeof (rest === null || rest === void 0 ? void 0 : rest.onChange) === "function") {
                rest.onChange(selectedValue);
            }
        }
        setSuggestions([]);
        setIsDropdownOpen(false);
        setIsModalOpen(false);
        if (typeof onSelect === "function") {
            onSelect(placeId, description);
        }
        // optional route, see if we have onPlace callback and fetch the place details
        if (typeof onPlace === "function") {
            setLoadingPlace(true);
            fetchDetails(placeId, undefined)
                .then((place) => {
                if (place) {
                    onPlace(place);
                }
            })
                .finally(() => {
                setLoadingPlace(false);
            });
        }
    };
    const handleKeyDown = (event) => {
        if (!isDropdownOpen || suggestions.length === 0)
            return;
        switch (event.key) {
            case "ArrowDown":
                setSelectedIndex((prev) => (prev === null || prev >= suggestions.length - 1 ? 0 : prev + 1));
                break;
            case "ArrowUp":
                setSelectedIndex((prev) => (prev === null || prev <= 0 ? suggestions.length - 1 : prev - 1));
                break;
            case "Enter":
                if (selectedIndex !== null) {
                    const selected = suggestions[selectedIndex];
                    handleSelect(selected.place_id, selected.structured_formatting.main_text);
                }
                else {
                    // If no suggestion is selected, we can close the dropdown
                    setIsDropdownOpen(false);
                    setIsModalOpen(false);
                }
                break;
            case "Escape":
                setIsDropdownOpen(false);
                setIsModalOpen(false);
                break;
            case "Tab":
                if (selectedIndex !== null) {
                    const selected = suggestions[selectedIndex];
                    handleSelect(selected.place_id, selected.structured_formatting.main_text);
                }
                setIsDropdownOpen(false);
                setIsModalOpen(false);
                break;
        }
    };
    // IFFY
    const handleLoseFocus = () => {
        // cancel search and close the dropdown
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
            debounceTimeout.current = null;
        }
        // make sure we don't open the dropdown either, this can happen if you type something
        setTimeout(() => {
            setIsDropdownOpen(false);
        }, 200);
    };
    const renderHighlightedText = (text, matches = []) => {
        let lastIndex = 0;
        const parts = [];
        matches.forEach(({ offset, length }, index) => {
            parts.push(React__default$4.createElement("span", { key: `before-${index}` }, text.substring(lastIndex, offset)));
            parts.push(React__default$4.createElement("span", { key: `highlight-${index}`, className: styles$d.highlight }, text.substring(offset, offset + length)));
            lastIndex = offset + length;
        });
        parts.push(React__default$4.createElement("span", { key: "last" }, text.substring(lastIndex)));
        return parts;
    };
    const inputProps = Object.assign(Object.assign({ type: "text", variation: "outlined", placeholder: "Search for business or address" }, rest), { autoComplete: "off", autoCorrect: "off", spellCheck: false, value: inputValue, loading: loadingPlace, onChange: handleChange, onKeyDown: handleKeyDown, onBlur: handleLoseFocus });
    const suggestionsElement = isDropdownOpen && (React__default$4.createElement("div", { className: styles$d.suggestions },
        isLoading && isFirstSearch ? (React__default$4.createElement("div", { className: styles$d.loadingIndicator }, "Loading...")) : (suggestions.map((suggestion, index) => (React__default$4.createElement("div", { key: suggestion.place_id, className: `${styles$d.suggestion} ${selectedIndex === index ? styles$d.selected : ""}`, onClick: () => handleSelect(suggestion.place_id, suggestion.structured_formatting.main_text) },
            React__default$4.createElement("div", { className: styles$d.icon }),
            React__default$4.createElement("div", { className: styles$d.suggestionContent },
                React__default$4.createElement("div", { className: styles$d.business }, renderHighlightedText(suggestion.structured_formatting.main_text, suggestion.structured_formatting.main_text_matched_substrings)),
                React__default$4.createElement("div", { className: styles$d.address }, suggestion.structured_formatting.secondary_text)))))),
        hint && (React__default$4.createElement("div", { className: styles$d.hint },
            React__default$4.createElement("span", { className: styles$d.hintText }, hint))),
        typeof onUseAdvancedSearch === "function" && (React__default$4.createElement("div", { className: styles$d.advancedSearch, onClick: onUseAdvancedSearch },
            React__default$4.createElement("button", { className: styles$d.advancedSearchButton, onClick: onUseAdvancedSearch }, (config === null || config === void 0 ? void 0 : config.advancedSearchText) || "Advanced Search"))),
        React__default$4.createElement("div", { className: styles$d.poweredByGoogle },
            React__default$4.createElement("img", { src: "https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png", alt: "Powered by Google", className: styles$d.googleImage }))));
    return (React__default$4.createElement("div", { className: styles$d.autocomplete },
        React__default$4.createElement(Input$3, Object.assign({}, inputProps, { onFocus: (e) => {
                if (isMobile && !disableAutocomplete) {
                    e.preventDefault();
                    e.target.blur();
                    setIsModalOpen(true);
                }
            } })),
        !disableAutocomplete && !isMobile && suggestionsElement,
        !disableAutocomplete && isMobile && isModalOpen && (React__default$4.createElement(MobileModal, { onClose: () => setIsModalOpen(false) },
            React__default$4.createElement("div", null,
                React__default$4.createElement(Input$3, Object.assign({}, inputProps, { autoFocus: true })),
                suggestionsElement)))));
};

// import { getApiUrl } from "../../utils/getApiUrl";
// const API_URL = `${getApiUrl()}/places/search`;
const API_URL = `https://api.xapp.ai/places/search`;
const fetchPlaces = (query, signal, options) => __awaiter$2(void 0, void 0, void 0, function* () {
    if (!query.trim())
        return [];
    try {
        const response = yield fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(Object.assign({ textQuery: query, includePureServiceAreaBusinesses: true }, options)),
            signal,
        });
        if (!response.ok) {
            throw new Error(`API Error: ${response.status} ${response.statusText}`);
        }
        const data = yield response.json();
        if (!data || !data.places) {
            return [];
        }
        return data.places.map((place) => {
            var _a;
            return ({
                name: (_a = place.displayName) === null || _a === void 0 ? void 0 : _a.text,
                placeId: place.id,
                formattedAddress: place.formattedAddress,
                website: place.websiteUri,
                phone: place.nationalPhoneNumber,
            });
        });
    }
    catch (error) {
        if (error.name === "AbortError") {
            // console.log("Request aborted:", query);
            return [];
        }
        console.error("Error fetching places:", error);
        return [];
    }
});

const COUNTRIES = [
    { value: "US", text: "United States" },
    { value: "CA", text: "Canada" }
];
const CANADIAN_PROVINCES = [
    { value: "AB", text: "Alberta" },
    { value: "BC", text: "British Columbia" },
    { value: "MB", text: "Manitoba" },
    { value: "NB", text: "New Brunswick" },
    { value: "NL", text: "Newfoundland and Labrador" },
    { value: "NS", text: "Nova Scotia" },
    { value: "ON", text: "Ontario" },
    { value: "PE", text: "Prince Edward Island" },
    { value: "QC", text: "Quebec" },
    { value: "SK", text: "Saskatchewan" },
    { value: "NT", text: "Northwest Territories" },
    { value: "NU", text: "Nunavut" },
    { value: "YT", text: "Yukon" }
];
const US_STATES = [
    { value: "AL", text: "Alabama" },
    { value: "AK", text: "Alaska" },
    { value: "AZ", text: "Arizona" },
    { value: "AR", text: "Arkansas" },
    { value: "CA", text: "California" },
    { value: "CO", text: "Colorado" },
    { value: "CT", text: "Connecticut" },
    { value: "DE", text: "Delaware" },
    { value: "DC", text: "District of Columbia (D.C.)" },
    { value: "FL", text: "Florida" },
    { value: "GA", text: "Georgia" },
    { value: "HI", text: "Hawaii" },
    { value: "ID", text: "Idaho" },
    { value: "IL", text: "Illinois" },
    { value: "IN", text: "Indiana" },
    { value: "IA", text: "Iowa" },
    { value: "KS", text: "Kansas" },
    { value: "KY", text: "Kentucky" },
    { value: "LA", text: "Louisiana" },
    { value: "ME", text: "Maine" },
    { value: "MD", text: "Maryland" },
    { value: "MA", text: "Massachusetts" },
    { value: "MI", text: "Michigan" },
    { value: "MN", text: "Minnesota" },
    { value: "MS", text: "Mississippi" },
    { value: "MO", text: "Missouri" },
    { value: "MT", text: "Montana" },
    { value: "NE", text: "Nebraska" },
    { value: "NV", text: "Nevada" },
    { value: "NH", text: "New Hampshire" },
    { value: "NJ", text: "New Jersey" },
    { value: "NM", text: "New Mexico" },
    { value: "NY", text: "New York" },
    { value: "NC", text: "North Carolina" },
    { value: "ND", text: "North Dakota" },
    { value: "OH", text: "Ohio" },
    { value: "OK", text: "Oklahoma" },
    { value: "OR", text: "Oregon" },
    { value: "PA", text: "Pennsylvania" },
    { value: "RI", text: "Rhode Island" },
    { value: "SC", text: "South Carolina" },
    { value: "SD", text: "South Dakota" },
    { value: "TN", text: "Tennessee" },
    { value: "TX", text: "Texas" },
    { value: "UT", text: "Utah" },
    { value: "VT", text: "Vermont" },
    { value: "VA", text: "Virginia" },
    { value: "WA", text: "Washington" },
    { value: "WV", text: "West Virginia" },
    { value: "WI", text: "Wisconsin" },
    { value: "WY", text: "Wyoming" }
];

const getAddress1 = (value) => {
    var _a, _b, _c, _d, _e, _f;
    if (!value) {
        return undefined;
    }
    const streetAddress = (_b = (_a = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _a === void 0 ? void 0 : _a.find((comp) => { var _a; return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("street_address"); })) === null || _b === void 0 ? void 0 : _b.longName;
    if (streetAddress) {
        return streetAddress;
    }
    const streetNumber = ((_d = (_c = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _c === void 0 ? void 0 : _c.find((comp) => { var _a; return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("street_number"); })) === null || _d === void 0 ? void 0 : _d.longName) || "";
    const route = ((_f = (_e = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _e === void 0 ? void 0 : _e.find((comp) => { var _a; return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("route"); })) === null || _f === void 0 ? void 0 : _f.longName) || "";
    return `${streetNumber} ${route}`.trim();
};
/**
 * Looks for component 'subpremise' and returns the long name
 *
 * This is typically your Suite or Apartment number
 */
const getAddress2 = (value) => {
    var _a;
    if (!value) {
        return undefined;
    }
    if (!Array.isArray(value === null || value === void 0 ? void 0 : value.addressComponents)) {
        return undefined;
    }
    const subpremiseComponent = (_a = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _a === void 0 ? void 0 : _a.find((comp) => {
        var _a;
        return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("subpremise");
    });
    const sublocality = (subpremiseComponent === null || subpremiseComponent === void 0 ? void 0 : subpremiseComponent.longName) || "";
    return `${sublocality}`;
};
const getCity = (value) => {
    var _a;
    if (!value) {
        return undefined;
    }
    return (_a = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _a === void 0 ? void 0 : _a.find((comp) => { var _a; return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("locality"); });
};
const getState$1 = (value) => {
    var _a;
    if (!value) {
        return undefined;
    }
    return (_a = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _a === void 0 ? void 0 : _a.find((comp) => { var _a; return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("administrative_area_level_1"); });
};
const getPostalCode = (value) => {
    var _a;
    if (!value) {
        return undefined;
    }
    return (_a = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _a === void 0 ? void 0 : _a.find((comp) => { var _a; return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("postal_code"); });
};
const getCountry = (value) => {
    var _a;
    if (!value) {
        return undefined;
    }
    return (_a = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _a === void 0 ? void 0 : _a.find((comp) => { var _a; return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("country"); });
};
const hasRequiredFields = (value) => {
    const missing = [];
    const name = value === null || value === void 0 ? void 0 : value.name;
    if (!name) {
        missing.push("Business Name");
    }
    const address1 = getAddress1(value);
    if (!address1) {
        missing.push("Address");
    }
    const city = getCity(value);
    if (!city) {
        missing.push("City");
    }
    const state = getState$1(value);
    if (!state) {
        missing.push("State");
    }
    const postalCode = getPostalCode(value);
    if (!postalCode) {
        missing.push("Postal Code");
    }
    const country = getCountry(value);
    if (!country) {
        missing.push("Country");
    }
    return {
        hasFields: missing.length === 0,
        missing,
    };
};

var css_248z$$ = ".style_wrapper__qDFJB {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.style_placeAutoCompleteWrapper__GBYpI {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.style_fieldContainer__Pu3vw {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.style_disabledFields__y-snw {\n  cursor: pointer;\n}\n\n.style_responsiveRow__R1ecC {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.style_responsiveRow__R1ecC > * {\n  flex: 1;\n  min-width: 150px;\n}\n\n.style_buttonContainer__rrVdT {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.style_missing__rCH5R {\n  color: red;\n  font-size: 0.8em;\n}";
var style$I = {"wrapper":"style_wrapper__qDFJB","placeAutoCompleteWrapper":"style_placeAutoCompleteWrapper__GBYpI","fieldContainer":"style_fieldContainer__Pu3vw","disabledFields":"style_disabledFields__y-snw","responsiveRow":"style_responsiveRow__R1ecC","buttonContainer":"style_buttonContainer__rrVdT","missing":"style_missing__rCH5R"};
styleInject(css_248z$$);

const PARTNER_SERVICE_SUGGESTIONS = [
    { id: "jobber", label: "Jobber" },
    { id: "contractor-appointments", label: "Contractor Appointments" },
    { id: "servicetitan", label: "ServiceTitan" },
    { id: "housecallpro", label: "Housecall Pro" },
    { id: "fieldpulse", label: "FieldPulse" },
    { id: "sfl", label: "Surefire Local" },
    { id: "lacrm", label: "LACRM" },
    { id: "zapier", label: "Zapier" },
];
function getValidity(website, phone) {
    const validPhone = phone ? validatePhoneNumber(phone) : true;
    const validWebsite = website ? validateURL(website).valid : true;
    return validPhone && validWebsite;
}
/**
 * Component to enter address details
 */
const AddressView = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const { apiKey, value, header, onChange, tips, editMode, searchOnly, searchPlaceholder } = props;
    const valid = getValidity(value === null || value === void 0 ? void 0 : value.website, value === null || value === void 0 ? void 0 : value.phone);
    const [missing, setMissing] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [showFields, setShowFields] = useState(!!editMode);
    const [dimensions, setDimensions] = useState();
    const address1 = getAddress1(value);
    const address2 = getAddress2(value);
    const city = getCity(value);
    const state = getState$1(value);
    const postalCode = getPostalCode(value);
    const country = getCountry(value);
    useEffect(() => {
        if (value) {
            // check if we have all the required fields
            const { missing } = hasRequiredFields(value);
            setMissing(missing);
        }
    }, [value]);
    // by default use a combination of both but if the country is known, use the specific country
    let stateOptions = [...US_STATES, ...CANADIAN_PROVINCES];
    if (country === null || country === void 0 ? void 0 : country.shortName) {
        stateOptions = country.shortName === "CA" ? CANADIAN_PROVINCES : US_STATES;
    }
    let stateValue;
    if (state === null || state === void 0 ? void 0 : state.shortName) {
        stateValue = stateOptions.find((val) => state.shortName === val.value);
    }
    let countryValue = undefined;
    if (country === null || country === void 0 ? void 0 : country.shortName) {
        const foundCountry = COUNTRIES.find((val) => country.shortName === val.value);
        if (!foundCountry) {
            COUNTRIES.push({ value: country.shortName, text: country.longName || country.shortName });
            countryValue = COUNTRIES[COUNTRIES.length - 1];
        }
        else {
            countryValue = foundCountry;
        }
    }
    let height = 0;
    let width = 0;
    if (dimensions) {
        const MAX_HEIGHT = 500;
        //  const MAX_WIDTH = 300;
        height = dimensions.height - 40 < MAX_HEIGHT ? dimensions.height - 40 : MAX_HEIGHT;
        // if it is less than max width, use it, otherwise use the max width
        width = dimensions.width - 40; // : MAX_WIDTH;
    }
    /**
     * Only used by autocomplete address field, only updates place's address components
     */
    const handleFoundAddressForAddressField = useCallback((place) => {
        // just take the address components
        const components = (place === null || place === void 0 ? void 0 : place.addressComponents) || [];
        const newPlace = Object.assign(Object.assign({}, value), { formattedAddress: place === null || place === void 0 ? void 0 : place.formattedAddress, addressComponents: components });
        const { hasFields, missing } = hasRequiredFields(newPlace);
        setMissing(missing);
        onChange(newPlace, hasFields && valid);
    }, [onChange, valid, value]);
    const handleFoundAddress = useCallback((place) => {
        var _a, _b, _c, _d;
        // Quick check on the name of the place, make sure it isn't just the short version of the street address
        const streetNumber = (_b = (_a = place === null || place === void 0 ? void 0 : place.addressComponents) === null || _a === void 0 ? void 0 : _a.find((comp) => { var _a; return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("street_number"); })) === null || _b === void 0 ? void 0 : _b.shortName;
        const route = (_d = (_c = place === null || place === void 0 ? void 0 : place.addressComponents) === null || _c === void 0 ? void 0 : _c.find((comp) => { var _a; return (_a = comp === null || comp === void 0 ? void 0 : comp.types) === null || _a === void 0 ? void 0 : _a.includes("route"); })) === null || _d === void 0 ? void 0 : _d.shortName;
        const shortStreetAddress = `${streetNumber} ${route}`.trim();
        if ((place === null || place === void 0 ? void 0 : place.name) === shortStreetAddress) {
            if (value === null || value === void 0 ? void 0 : value.name) {
                place.name = value === null || value === void 0 ? void 0 : value.name;
            }
            else {
                place.name = "";
            }
        }
        if (!searchOnly) {
            setShowFields(true);
        }
        const { hasFields, missing } = hasRequiredFields(place);
        setMissing(missing);
        if (missing.length === 0) {
            setDisabled(true);
        }
        else {
            // it we are missing fields, allow the user to enter them
            setDisabled(false);
        }
        onChange(place, hasFields && valid);
    }, [searchOnly, onChange, valid, value === null || value === void 0 ? void 0 : value.name]);
    const handlePlaceSelected = useCallback((placeId, description) => {
        // no-op for now
    }, []);
    const handleSearchAgain = useCallback(() => {
        setShowFields(false);
        setDisabled(false);
        const place = Object.assign(Object.assign({}, value), { addressComponents: [] });
        delete place.placeId;
        delete place.formattedAddress;
        const { hasFields, missing } = hasRequiredFields(place);
        setMissing(missing);
        onChange(place, hasFields && valid);
    }, [onChange, value, valid]);
    const handleBusinessNameChange = useCallback((name) => {
        const place = Object.assign(Object.assign({}, value), { name: `${name}` });
        const { hasFields, missing } = hasRequiredFields(place);
        setMissing(missing);
        onChange(place, hasFields && valid);
    }, [onChange, value, valid]);
    const handlePhoneNumberChange = useCallback((phone) => {
        const place = Object.assign(Object.assign({}, value), { phone });
        const { hasFields, missing } = hasRequiredFields(place);
        setMissing(missing);
        onChange(place, hasFields && getValidity(value === null || value === void 0 ? void 0 : value.website, phone));
    }, [onChange, value]);
    const handleWebsiteChange = useCallback((website) => {
        const place = Object.assign(Object.assign({}, value), { website });
        const { hasFields, missing } = hasRequiredFields(place);
        setMissing(missing);
        onChange(place, hasFields && getValidity(website, value === null || value === void 0 ? void 0 : value.phone));
    }, [onChange, value]);
    const handlePartnerServiceChange = useCallback((selection) => {
        var _a, _b;
        const service = typeof selection === "string" ? selection : selection.label;
        const place = Object.assign(Object.assign({}, value), { partnerId: {
                service,
                id: ((_a = value === null || value === void 0 ? void 0 : value.partnerId) === null || _a === void 0 ? void 0 : _a.id) || "",
            } });
        // If both are empty, remove partnerId entirely
        if (!service && !((_b = place.partnerId) === null || _b === void 0 ? void 0 : _b.id)) {
            delete place.partnerId;
        }
        const { hasFields, missing } = hasRequiredFields(place);
        setMissing(missing);
        onChange(place, hasFields && valid);
    }, [onChange, value, valid]);
    const handlePartnerIdChange = useCallback((id) => {
        var _a, _b;
        const place = Object.assign(Object.assign({}, value), { partnerId: {
                service: ((_a = value === null || value === void 0 ? void 0 : value.partnerId) === null || _a === void 0 ? void 0 : _a.service) || "",
                id: `${id}`,
            } });
        // If both are empty, remove partnerId entirely
        if (!((_b = place.partnerId) === null || _b === void 0 ? void 0 : _b.service) && !id) {
            delete place.partnerId;
        }
        const { hasFields, missing } = hasRequiredFields(place);
        setMissing(missing);
        onChange(place, hasFields && valid);
    }, [onChange, value, valid]);
    /**
     * For handling address field changes
     *
     * Will convert it to an address component and update the place
     */
    const handleAddressFieldChange = useCallback((fieldKey, fieldValue) => {
        const components = (value === null || value === void 0 ? void 0 : value.addressComponents) || [];
        // Find the current component by key
        const currentComponent = components.find((comp) => { var _a; return (_a = comp.types) === null || _a === void 0 ? void 0 : _a.includes(fieldKey); });
        // If the component exists, update it
        if (currentComponent) {
            currentComponent.shortName = fieldValue.toString();
            currentComponent.longName = fieldValue.toString();
            // if the new value is empty, remove the component
            if (fieldValue.toString().trim() === "") {
                const index = components.indexOf(currentComponent);
                components.splice(index, 1);
            }
        }
        else {
            // Otherwise, create a new component
            components.push({
                longName: fieldValue.toString(),
                shortName: fieldValue.toString(),
                types: [fieldKey],
            });
        }
        // if country is changed, clear the state
        if (fieldKey === "country") {
            const stateComponent = components.find((comp) => { var _a; return (_a = comp.types) === null || _a === void 0 ? void 0 : _a.includes("administrative_area_level_1"); });
            if (stateComponent) {
                const index = components.indexOf(stateComponent);
                components.splice(index, 1);
            }
        }
        const place = Object.assign(Object.assign({}, value), { addressComponents: components });
        const { hasFields, missing } = hasRequiredFields(place);
        setMissing(missing);
        onChange(place, hasFields && valid);
    }, [onChange, value, valid]);
    const placeholder = searchPlaceholder || "Search for business name or address...";
    const hasAddress = typeof ((_a = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _a === void 0 ? void 0 : _a.length) === "number" ? ((_b = value === null || value === void 0 ? void 0 : value.addressComponents) === null || _b === void 0 ? void 0 : _b.length) > 1 : false;
    return (React__default$4.createElement(Measure, { onMeasure: setDimensions, className: style$I.wrapper },
        header && React__default$4.createElement("h3", null, header),
        showFields && (React__default$4.createElement(React__default$4.Fragment, null,
            React__default$4.createElement("div", { className: style$I.fieldContainer },
                React__default$4.createElement(Input$3, { required: true, label: "Business Name", placeholder: "Business Name", value: (value === null || value === void 0 ? void 0 : value.name) || "", onChange: handleBusinessNameChange }),
                React__default$4.createElement(PlacesAutocomplete, { addressSearch: true, required: true, disabled: disabled, label: "Address", placeholder: "Address", variation: "standard", value: address1, onChange: handleAddressFieldChange.bind(null, "street_address"), onSelect: () => { }, onPlace: handleFoundAddressForAddressField }),
                React__default$4.createElement("div", { className: style$I.fieldContainer },
                    React__default$4.createElement(Input$3, { required: false, disabled: !hasAddress || disabled, label: "Apt/Suite Number", placeholder: "Apt/Suite Number", value: address2 || "", onChange: handleAddressFieldChange.bind(null, "subpremise") }),
                    React__default$4.createElement("div", { className: style$I.responsiveRow },
                        React__default$4.createElement(Input$3, { required: true, disabled: !hasAddress || disabled, label: "City", placeholder: "City", value: (city === null || city === void 0 ? void 0 : city.longName) || "", onChange: handleAddressFieldChange.bind(null, "locality") }),
                        React__default$4.createElement(Dropdown, { disabled: !hasAddress || disabled, options: stateOptions, placeholder: "Select State/Province", value: (stateValue === null || stateValue === void 0 ? void 0 : stateValue.value) || "", onChange: handleAddressFieldChange.bind(null, "administrative_area_level_1") }),
                        React__default$4.createElement(Input$3, { required: true, disabled: !hasAddress || disabled, label: "Zip/Postal Code", placeholder: "Zip", value: (postalCode === null || postalCode === void 0 ? void 0 : postalCode.longName) || "", onChange: handleAddressFieldChange.bind(null, "postal_code") })),
                    React__default$4.createElement(Dropdown, { disabled: !hasAddress || disabled, placeholder: "Select Country", options: COUNTRIES, value: (countryValue === null || countryValue === void 0 ? void 0 : countryValue.value) || "", onChange: handleAddressFieldChange.bind(null, "country") })),
                React__default$4.createElement("div", { className: style$I.responsiveRow, style: { alignItems: "flex-start" } },
                    React__default$4.createElement(PhoneNumberInput, { disabled: disabled, required: false, label: "Phone Number", value: (value === null || value === void 0 ? void 0 : value.phone) || "", onChange: handlePhoneNumberChange }),
                    React__default$4.createElement(URLInput, { disabled: disabled, required: false, label: "Business Website", value: (value === null || value === void 0 ? void 0 : value.website) || "", onChange: handleWebsiteChange })),
                React__default$4.createElement(Accordion, { title: "Advanced", defaultExpanded: !!((_c = value === null || value === void 0 ? void 0 : value.partnerId) === null || _c === void 0 ? void 0 : _c.service) || !!((_d = value === null || value === void 0 ? void 0 : value.partnerId) === null || _d === void 0 ? void 0 : _d.id) },
                    React__default$4.createElement("div", { className: style$I.responsiveRow, style: { alignItems: "flex-start" } },
                        React__default$4.createElement(AutoCompleteSuggestionsInput, { disabled: disabled, required: false, label: "Partner Service", suggestions: PARTNER_SERVICE_SUGGESTIONS, echo: true, placeholder: "Select or enter a service", value: ((_e = value === null || value === void 0 ? void 0 : value.partnerId) === null || _e === void 0 ? void 0 : _e.service) || "", onChange: handlePartnerServiceChange }),
                        React__default$4.createElement(Input$3, { disabled: disabled, required: false, label: "Partner ID", placeholder: "External system location ID", value: ((_f = value === null || value === void 0 ? void 0 : value.partnerId) === null || _f === void 0 ? void 0 : _f.id) || "", onChange: handlePartnerIdChange })))),
            !editMode && (React__default$4.createElement("div", { className: style$I.buttonContainer },
                React__default$4.createElement(Button, { label: "Back to Search", variation: "secondary", onClick: handleSearchAgain }))),
            !editMode && missing.length < 3 && missing.length > 0 && (React__default$4.createElement("div", { className: style$I.missing },
                React__default$4.createElement("p", null,
                    missing[0],
                    " Required"))),
            editMode && missing.length > 0 && (React__default$4.createElement("div", { className: style$I.missing },
                React__default$4.createElement("p", null,
                    "Missing Fields: ",
                    missing.join(", ")))))),
        !showFields && !apiKey && (React__default$4.createElement("div", { className: style$I.placeAutoCompleteWrapper },
            React__default$4.createElement(PlacesAutocomplete, { placeholder: placeholder, onSelect: handlePlaceSelected, onPlace: handleFoundAddress }))),
        !showFields && apiKey && dimensions && (React__default$4.createElement(React__default$4.Fragment, null,
            React__default$4.createElement(GMap, { apiKey: apiKey, hideMap: props.hideMap, height: typeof props.height === "number" ? props.height : height, width: typeof props.width === "number" ? props.width : width, onAddPlace: handleFoundAddress, center: props.center && typeof props.center === "object"
                    ? props.center
                    : { lat: 33.753746, lng: -84.38633 }, searchInputPlaceholder: placeholder, addPlaceButtonLabel: "Use this Location", optionalInput: searchOnly ? (React__default$4.createElement(React__default$4.Fragment, null)) : (React__default$4.createElement("div", { style: {
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignContent: "center",
                        alignItems: "center",
                    } },
                    React__default$4.createElement("p", null, "Can't find your business?"),
                    React__default$4.createElement(Button, { onClick: () => {
                            setShowFields(true);
                        } }, "Enter Address"))) }),
            tips && tips))));
};

const DatePicker = (_a) => {
    var { title, openCalendar, dateValue, onCalendar } = _a, props = __rest$2(_a, ["title", "openCalendar", "dateValue", "onCalendar"]);
    return (React__default$4.createElement("div", { style: { position: "relative" } },
        React__default$4.createElement("div", null, title),
        React__default$4.createElement("div", { style: { display: "flex", alignItems: "center" } },
            React__default$4.createElement(Input$3, { value: dateValue || "", onClick: onCalendar, wrapperStyle: { paddingBottom: 0, minWidth: "200px" } }),
            React__default$4.createElement(IconButton, { iconName: "calendar_month", onClick: onCalendar })),
        openCalendar && (React__default$4.createElement("div", { style: { position: "absolute", top: "100%", right: 0, zIndex: 1000, backgroundColor: "white", boxShadow: "0 2px 8px rgba(0,0,0,0.15)", borderRadius: "4px", fontSize: "14px" } },
            React__default$4.createElement(dist$4.DayPicker, Object.assign({ captionLayout: "dropdown-buttons" }, props))))));
};

const Dialog = (_a) => {
    var { title, actions, active, children, onClose, onDismiss } = _a, props = __rest$2(_a, ["title", "actions", "active", "children", "onClose", "onDismiss"]);
    const handleClose = () => {
        var _a;
        // Support both onClose and onDismiss (onClose takes precedence)
        (_a = (onClose !== null && onClose !== void 0 ? onClose : onDismiss)) === null || _a === void 0 ? void 0 : _a();
    };
    return (React__default$4.createElement(node.Dialog, Object.assign({}, props, { open: active, onClose: handleClose }),
        React__default$4.createElement(DialogTitle, null, title),
        React__default$4.createElement(DialogContent, null, children),
        React__default$4.createElement(DialogActions, null, actions && actions.map((actionProps, i) => {
            return React__default$4.createElement(Button, Object.assign({ key: i }, actionProps));
        }))));
};

var css_248z$_ = ".style_hrSect__fMKps {\n  display: flex;\n  flex-basis: 100%;\n  align-items: center;\n  color: #3e3e3e;\n  margin: 8px 0;\n}\n\n.style_hrSect__fMKps::before,\n.style_hrSect__fMKps::after {\n  content: \"\";\n  flex-grow: 1;\n  background-color: #3e3e3e;\n  height: 1px;\n  font-size: 0;\n  line-height: 0;\n  margin: 0 8px;\n}";
var style$H = {"hrSect":"style_hrSect__fMKps"};
styleInject(css_248z$_);

/**
 * Simple horizontal divider with text in the middle.
 *
 * @src https://stackoverflow.com/a/36159798/1349766
 * @param props
 */
const Divider = props => {
    return React__default$4.createElement("div", { className: style$H.hrSect }, props.children);
};

var reactContenteditable = {};

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

var __extends = (commonjsGlobal$1 && commonjsGlobal$1.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (commonjsGlobal$1 && commonjsGlobal$1.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (commonjsGlobal$1 && commonjsGlobal$1.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal$1 && commonjsGlobal$1.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (commonjsGlobal$1 && commonjsGlobal$1.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (commonjsGlobal$1 && commonjsGlobal$1.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (commonjsGlobal$1 && commonjsGlobal$1.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(reactContenteditable, "__esModule", { value: true });
var React$b = __importStar(React__default$4);
var fast_deep_equal_1 = __importDefault(fastDeepEqual);
var PropTypes$3 = __importStar(propTypes.exports);
function normalizeHtml(str) {
    return str && str.replace(/&nbsp;|\u202F|\u00A0/g, ' ').replace(/<br \/>/g, '<br>');
}
function replaceCaret(el) {
    // Place the caret at the end of the element
    var target = document.createTextNode('');
    el.appendChild(target);
    // do not move caret if element was not focused
    var isTargetFocused = document.activeElement === el;
    if (target !== null && target.nodeValue !== null && isTargetFocused) {
        var sel = window.getSelection();
        if (sel !== null) {
            var range = document.createRange();
            range.setStart(target, target.nodeValue.length);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }
        if (el instanceof HTMLElement)
            el.focus();
    }
}
/**
 * A simple component for an html element with editable contents.
 */
var ContentEditable$1 = /** @class */ (function (_super) {
    __extends(ContentEditable, _super);
    function ContentEditable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastHtml = _this.props.html;
        _this.el = typeof _this.props.innerRef === 'function' ? { current: null } : React$b.createRef();
        _this.getEl = function () { return (_this.props.innerRef && typeof _this.props.innerRef !== 'function' ? _this.props.innerRef : _this.el).current; };
        _this.emitChange = function (originalEvt) {
            var el = _this.getEl();
            if (!el)
                return;
            var html = el.innerHTML;
            if (_this.props.onChange && html !== _this.lastHtml) {
                // Clone event with Object.assign to avoid
                // "Cannot assign to read only property 'target' of object"
                var evt = Object.assign({}, originalEvt, {
                    target: {
                        value: html
                    }
                });
                _this.props.onChange(evt);
            }
            _this.lastHtml = html;
        };
        return _this;
    }
    ContentEditable.prototype.render = function () {
        var _this = this;
        var _a = this.props, tagName = _a.tagName, html = _a.html, innerRef = _a.innerRef, props = __rest(_a, ["tagName", "html", "innerRef"]);
        return React$b.createElement(tagName || 'div', __assign(__assign({}, props), { ref: typeof innerRef === 'function' ? function (current) {
                innerRef(current);
                _this.el.current = current;
            } : innerRef || this.el, onInput: this.emitChange, onBlur: this.props.onBlur || this.emitChange, onKeyUp: this.props.onKeyUp || this.emitChange, onKeyDown: this.props.onKeyDown || this.emitChange, contentEditable: !this.props.disabled, dangerouslySetInnerHTML: { __html: html } }), this.props.children);
    };
    ContentEditable.prototype.shouldComponentUpdate = function (nextProps) {
        var props = this.props;
        var el = this.getEl();
        // We need not rerender if the change of props simply reflects the user's edits.
        // Rerendering in this case would make the cursor/caret jump
        // Rerender if there is no element yet... (somehow?)
        if (!el)
            return true;
        // ...or if html really changed... (programmatically, not by user edit)
        if (normalizeHtml(nextProps.html) !== normalizeHtml(el.innerHTML)) {
            return true;
        }
        // Handle additional properties
        return props.disabled !== nextProps.disabled ||
            props.tagName !== nextProps.tagName ||
            props.className !== nextProps.className ||
            props.innerRef !== nextProps.innerRef ||
            props.placeholder !== nextProps.placeholder ||
            !(0, fast_deep_equal_1.default)(props.style, nextProps.style);
    };
    ContentEditable.prototype.componentDidUpdate = function () {
        var el = this.getEl();
        if (!el)
            return;
        // Perhaps React (whose VDOM gets outdated because we often prevent
        // rerendering) did not update the DOM. So we update it manually now.
        if (this.props.html !== el.innerHTML) {
            el.innerHTML = this.props.html;
        }
        this.lastHtml = this.props.html;
        replaceCaret(el);
    };
    ContentEditable.propTypes = {
        html: PropTypes$3.string.isRequired,
        onChange: PropTypes$3.func,
        disabled: PropTypes$3.bool,
        tagName: PropTypes$3.string,
        className: PropTypes$3.string,
        style: PropTypes$3.object,
        innerRef: PropTypes$3.oneOfType([
            PropTypes$3.object,
            PropTypes$3.func,
        ])
    };
    return ContentEditable;
}(React$b.Component));
var _default = reactContenteditable.default = ContentEditable$1;

var css_248z$Z = ".style_field__eP9pC {\n  padding: 0 4px;\n}\n\n.style_error__Fi9zY {\n  color: #e94949;\n  outline: 2px solid #e94949;\n  border-radius: 3px;\n}\n.style_error__Fi9zY[placeholder]:empty:before {\n  content: attr(placeholder);\n}";
var style$G = {"field":"style_field__eP9pC","error":"style_error__Fi9zY"};
styleInject(css_248z$Z);

const ContentEditable = (props) => {
    const { className, disabled, value, required, onChange } = props;
    const [isEmpty, setIsEmpty] = useState(false);
    function handleBlur(event) {
        if (event.currentTarget.innerText === "" && required) {
            setIsEmpty(true);
        }
    }
    function handleFocus(event) {
        if (event.currentTarget.innerText === "" && required) {
            setIsEmpty(false);
        }
    }
    function handleChange(event) {
        if (onChange && typeof onChange === "function") {
            onChange(event.currentTarget.innerText);
        }
    }
    return (React__default$4.createElement(_default, { className: `${className} ${style$G.field} ${required && isEmpty ? style$G.error : ""}`, tagName: "span", html: value, disabled: typeof disabled === "boolean" ? disabled : typeof onChange !== "function", onChange: handleChange, placeholder: "this field is required", onFocus: handleFocus, onBlur: handleBlur }));
};

var cjs$1 = {};

var cjs = {};

var loader$4 = {};

var _rollupPluginBabelHelpers$2 = {};

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _defineProperty$2(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys$1(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), true).forEach(function (r) {
      _defineProperty$2(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties$3(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _slicedToArray$2(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

_rollupPluginBabelHelpers$2.arrayLikeToArray = _arrayLikeToArray;
_rollupPluginBabelHelpers$2.arrayWithHoles = _arrayWithHoles;
_rollupPluginBabelHelpers$2.defineProperty = _defineProperty$2;
_rollupPluginBabelHelpers$2.iterableToArrayLimit = _iterableToArrayLimit;
_rollupPluginBabelHelpers$2.nonIterableRest = _nonIterableRest;
_rollupPluginBabelHelpers$2.objectSpread2 = _objectSpread2$1;
_rollupPluginBabelHelpers$2.objectWithoutProperties = _objectWithoutProperties$3;
_rollupPluginBabelHelpers$2.objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;
_rollupPluginBabelHelpers$2.slicedToArray = _slicedToArray$2;
_rollupPluginBabelHelpers$2.toPrimitive = _toPrimitive;
_rollupPluginBabelHelpers$2.toPropertyKey = _toPropertyKey;
_rollupPluginBabelHelpers$2.unsupportedIterableToArray = _unsupportedIterableToArray;

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function compose$4() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduceRight(function (y, f) {
      return f(y);
    }, x);
  };
}

function curry$3(fn) {
  return function curried() {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return args.length >= fn.length ? fn.apply(this, args) : function () {
      for (var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        nextArgs[_key3] = arguments[_key3];
      }

      return curried.apply(_this, [].concat(args, nextArgs));
    };
  };
}

function isObject$3(value) {
  return {}.toString.call(value).includes('Object');
}

function isEmpty(obj) {
  return !Object.keys(obj).length;
}

function isFunction(value) {
  return typeof value === 'function';
}

function hasOwnProperty(object, property) {
  return Object.prototype.hasOwnProperty.call(object, property);
}

function validateChanges(initial, changes) {
  if (!isObject$3(changes)) errorHandler$1('changeType');
  if (Object.keys(changes).some(function (field) {
    return !hasOwnProperty(initial, field);
  })) errorHandler$1('changeField');
  return changes;
}

function validateSelector(selector) {
  if (!isFunction(selector)) errorHandler$1('selectorType');
}

function validateHandler(handler) {
  if (!(isFunction(handler) || isObject$3(handler))) errorHandler$1('handlerType');
  if (isObject$3(handler) && Object.values(handler).some(function (_handler) {
    return !isFunction(_handler);
  })) errorHandler$1('handlersType');
}

function validateInitial(initial) {
  if (!initial) errorHandler$1('initialIsRequired');
  if (!isObject$3(initial)) errorHandler$1('initialType');
  if (isEmpty(initial)) errorHandler$1('initialContent');
}

function throwError$1(errorMessages, type) {
  throw new Error(errorMessages[type] || errorMessages["default"]);
}

var errorMessages$1 = {
  initialIsRequired: 'initial state is required',
  initialType: 'initial state should be an object',
  initialContent: 'initial state shouldn\'t be an empty object',
  handlerType: 'handler should be an object or a function',
  handlersType: 'all handlers should be a functions',
  selectorType: 'selector should be a function',
  changeType: 'provided value of changes should be an object',
  changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
  "default": 'an unknown error accured in `state-local` package'
};
var errorHandler$1 = curry$3(throwError$1)(errorMessages$1);
var validators$2 = {
  changes: validateChanges,
  selector: validateSelector,
  handler: validateHandler,
  initial: validateInitial
};

function create(initial) {
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  validators$2.initial(initial);
  validators$2.handler(handler);
  var state = {
    current: initial
  };
  var didUpdate = curry$3(didStateUpdate)(state, handler);
  var update = curry$3(updateState)(state);
  var validate = curry$3(validators$2.changes)(initial);
  var getChanges = curry$3(extractChanges)(state);

  function getState() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {
      return state;
    };
    validators$2.selector(selector);
    return selector(state.current);
  }

  function setState(causedChanges) {
    compose$4(didUpdate, update, validate, getChanges)(causedChanges);
  }

  return [getState, setState];
}

function extractChanges(state, causedChanges) {
  return isFunction(causedChanges) ? causedChanges(state.current) : causedChanges;
}

function updateState(state, changes) {
  state.current = _objectSpread2(_objectSpread2({}, state.current), changes);
  return changes;
}

function didStateUpdate(state, handler, changes) {
  isFunction(handler) ? handler(state.current) : Object.keys(changes).forEach(function (field) {
    var _handler$field;

    return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
  });
  return changes;
}

var index$b = {
  create: create
};

var stateLocal = index$b;

var config$2 = {};

Object.defineProperty(config$2, '__esModule', { value: true });

var config$1 = {
  paths: {
    vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.54.0/min/vs'
  }
};

config$2.default = config$1;

var validators$1 = {};

var curry$2 = {};

Object.defineProperty(curry$2, '__esModule', { value: true });

function curry$1(fn) {
  return function curried() {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return args.length >= fn.length ? fn.apply(this, args) : function () {
      for (var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nextArgs[_key2] = arguments[_key2];
      }
      return curried.apply(_this, [].concat(args, nextArgs));
    };
  };
}

curry$2.default = curry$1;

var isObject$2 = {};

Object.defineProperty(isObject$2, '__esModule', { value: true });

function isObject$1(value) {
  return {}.toString.call(value).includes('Object');
}

isObject$2.default = isObject$1;

Object.defineProperty(validators$1, '__esModule', { value: true });

var curry = curry$2;
var isObject = isObject$2;

/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */
function validateConfig(config) {
  if (!config) errorHandler('configIsRequired');
  if (!isObject.default(config)) errorHandler('configType');
  if (config.urls) {
    informAboutDeprecation();
    return {
      paths: {
        vs: config.urls.monacoBase
      }
    };
  }
  return config;
}

/**
 * logs deprecation message
 */
function informAboutDeprecation() {
  console.warn(errorMessages.deprecation);
}
function throwError(errorMessages, type) {
  throw new Error(errorMessages[type] || errorMessages["default"]);
}
var errorMessages = {
  configIsRequired: 'the configuration object is required',
  configType: 'the configuration object should be an object',
  "default": 'an unknown error accured in `@monaco-editor/loader` package',
  deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var errorHandler = curry.default(throwError)(errorMessages);
var validators = {
  config: validateConfig
};

validators$1.default = validators;
validators$1.errorHandler = errorHandler;
validators$1.errorMessages = errorMessages;

var compose$3 = {};

Object.defineProperty(compose$3, '__esModule', { value: true });

var compose$2 = function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (x) {
    return fns.reduceRight(function (y, f) {
      return f(y);
    }, x);
  };
};

compose$3.default = compose$2;

var deepMerge$1 = {};

Object.defineProperty(deepMerge$1, '__esModule', { value: true });

var _rollupPluginBabelHelpers$1 = _rollupPluginBabelHelpers$2;

function merge(target, source) {
  Object.keys(source).forEach(function (key) {
    if (source[key] instanceof Object) {
      if (target[key]) {
        Object.assign(source[key], merge(target[key], source[key]));
      }
    }
  });
  return _rollupPluginBabelHelpers$1.objectSpread2(_rollupPluginBabelHelpers$1.objectSpread2({}, target), source);
}

deepMerge$1.default = merge;

var makeCancelable$2 = {};

Object.defineProperty(makeCancelable$2, '__esModule', { value: true });

// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325

var CANCELATION_MESSAGE = {
  type: 'cancelation',
  msg: 'operation is manually canceled'
};
function makeCancelable$1(promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject(CANCELATION_MESSAGE) : resolve(val);
    });
    promise["catch"](reject);
  });
  return wrappedPromise.cancel = function () {
    return hasCanceled_ = true;
  }, wrappedPromise;
}

makeCancelable$2.CANCELATION_MESSAGE = CANCELATION_MESSAGE;
makeCancelable$2.default = makeCancelable$1;

Object.defineProperty(loader$4, '__esModule', { value: true });

var _rollupPluginBabelHelpers = _rollupPluginBabelHelpers$2;
var state = stateLocal;
var index$a = config$2;
var index$1$2 = validators$1;
var compose$1 = compose$3;
var deepMerge = deepMerge$1;
var makeCancelable = makeCancelable$2;

var _excluded = ["monaco"];

/** the local state of the module */
var _state$create = state.create({
    config: index$a.default,
    isInitialized: false,
    resolve: null,
    reject: null,
    monaco: null
  }),
  _state$create2 = _rollupPluginBabelHelpers.slicedToArray(_state$create, 2),
  getState = _state$create2[0],
  setState = _state$create2[1];

/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */
function config(globalConfig) {
  var _validators$config = index$1$2.default.config(globalConfig),
    monaco = _validators$config.monaco,
    config = _rollupPluginBabelHelpers.objectWithoutProperties(_validators$config, _excluded);
  setState(function (state) {
    return {
      config: deepMerge.default(state.config, config),
      monaco: monaco
    };
  });
}

/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */
function init() {
  var state = getState(function (_ref) {
    var monaco = _ref.monaco,
      isInitialized = _ref.isInitialized,
      resolve = _ref.resolve;
    return {
      monaco: monaco,
      isInitialized: isInitialized,
      resolve: resolve
    };
  });
  if (!state.isInitialized) {
    setState({
      isInitialized: true
    });
    if (state.monaco) {
      state.resolve(state.monaco);
      return makeCancelable.default(wrapperPromise);
    }
    if (window.monaco && window.monaco.editor) {
      storeMonacoInstance(window.monaco);
      state.resolve(window.monaco);
      return makeCancelable.default(wrapperPromise);
    }
    compose$1.default(injectScripts, getMonacoLoaderScript)(configureLoader);
  }
  return makeCancelable.default(wrapperPromise);
}

/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */
function injectScripts(script) {
  return document.body.appendChild(script);
}

/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */
function createScript(src) {
  var script = document.createElement('script');
  return src && (script.src = src), script;
}

/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */
function getMonacoLoaderScript(configureLoader) {
  var state = getState(function (_ref2) {
    var config = _ref2.config,
      reject = _ref2.reject;
    return {
      config: config,
      reject: reject
    };
  });
  var loaderScript = createScript("".concat(state.config.paths.vs, "/loader.js"));
  loaderScript.onload = function () {
    return configureLoader();
  };
  loaderScript.onerror = state.reject;
  return loaderScript;
}

/**
 * configures the monaco loader
 */
function configureLoader() {
  var state = getState(function (_ref3) {
    var config = _ref3.config,
      resolve = _ref3.resolve,
      reject = _ref3.reject;
    return {
      config: config,
      resolve: resolve,
      reject: reject
    };
  });
  var require = window.require;
  require.config(state.config);
  require(['vs/editor/editor.main'], function (_ref4) {
    var monaco = _ref4.m;
    storeMonacoInstance(monaco);
    state.resolve(monaco);
  }, function (error) {
    state.reject(error);
  });
}

/**
 * store monaco instance in local state
 */
function storeMonacoInstance(monaco) {
  if (!getState().monaco) {
    setState({
      monaco: monaco
    });
  }
}

/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */
function __getMonacoInstance() {
  return getState(function (_ref5) {
    var monaco = _ref5.monaco;
    return monaco;
  });
}
var wrapperPromise = new Promise(function (resolve, reject) {
  return setState({
    resolve: resolve,
    reject: reject
  });
});
var loader$3 = {
  config: config,
  init: init,
  __getMonacoInstance: __getMonacoInstance
};

loader$4.default = loader$3;

Object.defineProperty(cjs, '__esModule', { value: true });

var index$9 = loader$4;



cjs.default = index$9.default;

var DiffEditor$3 = {};

var DiffEditor$2 = {};

var MonacoContainer$4 = {};

var MonacoContainer$3 = {};

var Loading$2 = {};

Object.defineProperty(Loading$2, '__esModule', { value: true });

var React$a = React__default$4;

function _interopDefaultLegacy$4 (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default$3 = /*#__PURE__*/_interopDefaultLegacy$4(React$a);

const loadingStyles = {
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center'
};

function Loading$1({
  content
}) {
  return /*#__PURE__*/React__default$3['default'].createElement("div", {
    style: loadingStyles
  }, content);
}

Loading$2.default = Loading$1;

var styles$c = {};

Object.defineProperty(styles$c, '__esModule', { value: true });

const styles$b = {
  wrapper: {
    display: 'flex',
    position: 'relative',
    textAlign: 'initial'
  },
  fullWidth: {
    width: '100%'
  },
  hide: {
    display: 'none'
  }
};

styles$c.default = styles$b;

Object.defineProperty(MonacoContainer$3, '__esModule', { value: true });

var React$9 = React__default$4;
var PropTypes$2 = propTypes.exports;
var Loading = Loading$2;
var styles$a = styles$c;

function _interopDefaultLegacy$3 (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default$2 = /*#__PURE__*/_interopDefaultLegacy$3(React$9);
var PropTypes__default$2 = /*#__PURE__*/_interopDefaultLegacy$3(PropTypes$2);

// one of the reasons why we use a separate prop for passing ref instead of using forwardref

function MonacoContainer$2({
  width,
  height,
  isEditorReady,
  loading,
  _ref,
  className,
  wrapperClassName
}) {
  return /*#__PURE__*/React__default$2['default'].createElement("section", {
    style: { ...styles$a['default'].wrapper,
      width,
      height
    },
    className: wrapperClassName
  }, !isEditorReady && /*#__PURE__*/React__default$2['default'].createElement(Loading['default'], {
    content: loading
  }), /*#__PURE__*/React__default$2['default'].createElement("div", {
    ref: _ref,
    style: { ...styles$a['default'].fullWidth,
      ...(!isEditorReady && styles$a['default'].hide)
    },
    className: className
  }));
}

MonacoContainer$2.propTypes = {
  width: PropTypes__default$2['default'].oneOfType([PropTypes__default$2['default'].number, PropTypes__default$2['default'].string]).isRequired,
  height: PropTypes__default$2['default'].oneOfType([PropTypes__default$2['default'].number, PropTypes__default$2['default'].string]).isRequired,
  loading: PropTypes__default$2['default'].oneOfType([PropTypes__default$2['default'].element, PropTypes__default$2['default'].string]).isRequired,
  isEditorReady: PropTypes__default$2['default'].bool.isRequired,
  className: PropTypes__default$2['default'].string,
  wrapperClassName: PropTypes__default$2['default'].string
};

MonacoContainer$3.default = MonacoContainer$2;

Object.defineProperty(MonacoContainer$4, '__esModule', { value: true });

var React$8 = React__default$4;
var MonacoContainer$1 = MonacoContainer$3;

var MonacoContainer = /*#__PURE__*/React$8.memo(MonacoContainer$1['default']);

MonacoContainer$4.default = MonacoContainer;

var useMount$1 = {};

Object.defineProperty(useMount$1, '__esModule', { value: true });

var React$7 = React__default$4;

function useMount(effect) {
  React$7.useEffect(effect, []);
}

useMount$1.default = useMount;

var useUpdate$1 = {};

Object.defineProperty(useUpdate$1, '__esModule', { value: true });

var React$6 = React__default$4;

function useUpdate(effect, deps, applyChanges = true) {
  const isInitialMount = React$6.useRef(true);
  React$6.useEffect(isInitialMount.current || !applyChanges ? () => {
    isInitialMount.current = false;
  } : effect, deps);
}

useUpdate$1.default = useUpdate;

var utils$1 = {};

Object.defineProperty(utils$1, '__esModule', { value: true });

function noop$1() {}

function getOrCreateModel(monaco, value, language, path) {
  return getModel(monaco, path) || createModel(monaco, value, language, path);
}

function getModel(monaco, path) {
  return monaco.editor.getModel(crateModelUri(monaco, path));
}

function createModel(monaco, value, language, path) {
  return monaco.editor.createModel(value, language, path && crateModelUri(monaco, path));
}

function crateModelUri(monaco, path) {
  return monaco.Uri.parse(path);
}

function isUndefined(input) {
  return input === undefined;
}

utils$1.getOrCreateModel = getOrCreateModel;
utils$1.isUndefined = isUndefined;
utils$1.noop = noop$1;

Object.defineProperty(DiffEditor$2, '__esModule', { value: true });

var loader$2 = cjs;
var React$5 = React__default$4;
var PropTypes$1 = propTypes.exports;
var index$2$1 = MonacoContainer$4;
var index$8 = useMount$1;
var index$1$1 = useUpdate$1;
var index$3$1 = utils$1;

function _interopDefaultLegacy$2 (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var loader__default$2 = /*#__PURE__*/_interopDefaultLegacy$2(loader$2);
var React__default$1 = /*#__PURE__*/_interopDefaultLegacy$2(React$5);
var PropTypes__default$1 = /*#__PURE__*/_interopDefaultLegacy$2(PropTypes$1);

function DiffEditor$1({
  original,
  modified,
  language,
  originalLanguage,
  modifiedLanguage,

  /* === */
  originalModelPath,
  modifiedModelPath,
  keepCurrentOriginalModel,
  keepCurrentModifiedModel,
  theme,
  loading,
  options,

  /* === */
  height,
  width,
  className,
  wrapperClassName,

  /* === */
  beforeMount,
  onMount
}) {
  const [isEditorReady, setIsEditorReady] = React$5.useState(false);
  const [isMonacoMounting, setIsMonacoMounting] = React$5.useState(true);
  const editorRef = React$5.useRef(null);
  const monacoRef = React$5.useRef(null);
  const containerRef = React$5.useRef(null);
  const onMountRef = React$5.useRef(onMount);
  const beforeMountRef = React$5.useRef(beforeMount);
  index$8['default'](() => {
    const cancelable = loader__default$2['default'].init();
    cancelable.then(monaco => (monacoRef.current = monaco) && setIsMonacoMounting(false)).catch(error => (error === null || error === void 0 ? void 0 : error.type) !== 'cancelation' && console.error('Monaco initialization: error:', error));
    return () => editorRef.current ? disposeEditor() : cancelable.cancel();
  });
  index$1$1['default'](() => {
    const modifiedEditor = editorRef.current.getModifiedEditor();

    if (modifiedEditor.getOption(monacoRef.current.editor.EditorOption.readOnly)) {
      modifiedEditor.setValue(modified);
    } else {
      if (modified !== modifiedEditor.getValue()) {
        modifiedEditor.executeEdits('', [{
          range: modifiedEditor.getModel().getFullModelRange(),
          text: modified,
          forceMoveMarkers: true
        }]);
        modifiedEditor.pushUndoStop();
      }
    }
  }, [modified], isEditorReady);
  index$1$1['default'](() => {
    editorRef.current.getModel().original.setValue(original);
  }, [original], isEditorReady);
  index$1$1['default'](() => {
    const {
      original,
      modified
    } = editorRef.current.getModel();
    monacoRef.current.editor.setModelLanguage(original, originalLanguage || language);
    monacoRef.current.editor.setModelLanguage(modified, modifiedLanguage || language);
  }, [language, originalLanguage, modifiedLanguage], isEditorReady);
  index$1$1['default'](() => {
    monacoRef.current.editor.setTheme(theme);
  }, [theme], isEditorReady);
  index$1$1['default'](() => {
    editorRef.current.updateOptions(options);
  }, [options], isEditorReady);
  const setModels = React$5.useCallback(() => {
    beforeMountRef.current(monacoRef.current);
    const originalModel = monacoRef.current.editor.createModel(original, originalLanguage || language, originalModelPath && monacoRef.current.Uri.parse(originalModelPath));
    const modifiedModel = monacoRef.current.editor.createModel(modified, modifiedLanguage || language, modifiedModelPath && monacoRef.current.Uri.parse(modifiedModelPath));
    editorRef.current.setModel({
      original: originalModel,
      modified: modifiedModel
    });
  }, [language, modified, modifiedLanguage, original, originalLanguage, originalModelPath, modifiedModelPath]);
  const createEditor = React$5.useCallback(() => {
    editorRef.current = monacoRef.current.editor.createDiffEditor(containerRef.current, {
      automaticLayout: true,
      ...options
    });
    setModels();
    monacoRef.current.editor.setTheme(theme);
    setIsEditorReady(true);
  }, [options, theme, setModels]);
  React$5.useEffect(() => {
    if (isEditorReady) {
      onMountRef.current(editorRef.current, monacoRef.current);
    }
  }, [isEditorReady]);
  React$5.useEffect(() => {
    !isMonacoMounting && !isEditorReady && createEditor();
  }, [isMonacoMounting, isEditorReady, createEditor]);

  function disposeEditor() {
    const models = editorRef.current.getModel();

    if (!keepCurrentOriginalModel) {
      var _models$original;

      (_models$original = models.original) === null || _models$original === void 0 ? void 0 : _models$original.dispose();
    }

    if (!keepCurrentModifiedModel) {
      var _models$modified;

      (_models$modified = models.modified) === null || _models$modified === void 0 ? void 0 : _models$modified.dispose();
    }

    editorRef.current.dispose();
  }

  return /*#__PURE__*/React__default$1['default'].createElement(index$2$1['default'], {
    width: width,
    height: height,
    isEditorReady: isEditorReady,
    loading: loading,
    _ref: containerRef,
    className: className,
    wrapperClassName: wrapperClassName
  });
}

DiffEditor$1.propTypes = {
  original: PropTypes__default$1['default'].string,
  modified: PropTypes__default$1['default'].string,
  language: PropTypes__default$1['default'].string,
  originalLanguage: PropTypes__default$1['default'].string,
  modifiedLanguage: PropTypes__default$1['default'].string,

  /* === */
  originalModelPath: PropTypes__default$1['default'].string,
  modifiedModelPath: PropTypes__default$1['default'].string,
  keepCurrentOriginalModel: PropTypes__default$1['default'].bool,
  keepCurrentModifiedModel: PropTypes__default$1['default'].bool,
  theme: PropTypes__default$1['default'].string,
  loading: PropTypes__default$1['default'].oneOfType([PropTypes__default$1['default'].element, PropTypes__default$1['default'].string]),
  options: PropTypes__default$1['default'].object,

  /* === */
  width: PropTypes__default$1['default'].oneOfType([PropTypes__default$1['default'].number, PropTypes__default$1['default'].string]),
  height: PropTypes__default$1['default'].oneOfType([PropTypes__default$1['default'].number, PropTypes__default$1['default'].string]),
  className: PropTypes__default$1['default'].string,
  wrapperClassName: PropTypes__default$1['default'].string,

  /* === */
  beforeMount: PropTypes__default$1['default'].func,
  onMount: PropTypes__default$1['default'].func
};
DiffEditor$1.defaultProps = {
  theme: 'light',
  loading: 'Loading...',
  options: {},
  keepCurrentOriginalModel: false,
  keepCurrentModifiedModel: false,

  /* === */
  width: '100%',
  height: '100%',

  /* === */
  beforeMount: index$3$1.noop,
  onMount: index$3$1.noop
};

DiffEditor$2.default = DiffEditor$1;

Object.defineProperty(DiffEditor$3, '__esModule', { value: true });

var React$4 = React__default$4;
var DiffEditor = DiffEditor$2;

var index$7 = /*#__PURE__*/React$4.memo(DiffEditor['default']);

DiffEditor$3.default = index$7;

var useMonaco$1 = {};

Object.defineProperty(useMonaco$1, '__esModule', { value: true });

var loader$1 = cjs;
var React$3 = React__default$4;
var index$6 = useMount$1;

function _interopDefaultLegacy$1 (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var loader__default$1 = /*#__PURE__*/_interopDefaultLegacy$1(loader$1);

function useMonaco() {
  const [monaco, setMonaco] = React$3.useState(loader__default$1['default'].__getMonacoInstance());
  index$6['default'](() => {
    let cancelable;

    if (!monaco) {
      cancelable = loader__default$1['default'].init();
      cancelable.then(monaco => {
        setMonaco(monaco);
      });
    }

    return () => {
      var _cancelable;

      return (_cancelable = cancelable) === null || _cancelable === void 0 ? void 0 : _cancelable.cancel();
    };
  });
  return monaco;
}

useMonaco$1.default = useMonaco;

var Editor$4 = {};

var Editor$3 = {};

var usePrevious$1 = {};

Object.defineProperty(usePrevious$1, '__esModule', { value: true });

var React$2 = React__default$4;

function usePrevious(value) {
  const ref = React$2.useRef();
  React$2.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

usePrevious$1.default = usePrevious;

Object.defineProperty(Editor$3, '__esModule', { value: true });

var loader = cjs;
var React$1 = React__default$4;
var PropTypes = propTypes.exports;
var index$4 = MonacoContainer$4;
var index$1 = useMount$1;
var index$2 = useUpdate$1;
var index$3 = utils$1;
var index$5 = usePrevious$1;

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var loader__default = /*#__PURE__*/_interopDefaultLegacy(loader);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React$1);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

const viewStates = new Map();

function Editor$2({
  defaultValue,
  defaultLanguage,
  defaultPath,
  value,
  language,
  path,

  /* === */
  theme,
  line,
  loading,
  options,
  overrideServices,
  saveViewState,
  keepCurrentModel,

  /* === */
  width,
  height,
  className,
  wrapperClassName,

  /* === */
  beforeMount,
  onMount,
  onChange,
  onValidate
}) {
  const [isEditorReady, setIsEditorReady] = React$1.useState(false);
  const [isMonacoMounting, setIsMonacoMounting] = React$1.useState(true);
  const monacoRef = React$1.useRef(null);
  const editorRef = React$1.useRef(null);
  const containerRef = React$1.useRef(null);
  const onMountRef = React$1.useRef(onMount);
  const beforeMountRef = React$1.useRef(beforeMount);
  const subscriptionRef = React$1.useRef(null);
  const valueRef = React$1.useRef(value);
  const previousPath = index$5['default'](path);
  index$1['default'](() => {
    const cancelable = loader__default['default'].init();
    cancelable.then(monaco => (monacoRef.current = monaco) && setIsMonacoMounting(false)).catch(error => (error === null || error === void 0 ? void 0 : error.type) !== 'cancelation' && console.error('Monaco initialization: error:', error));
    return () => editorRef.current ? disposeEditor() : cancelable.cancel();
  });
  index$2['default'](() => {
    const model = index$3.getOrCreateModel(monacoRef.current, defaultValue || value, defaultLanguage || language, path);

    if (model !== editorRef.current.getModel()) {
      saveViewState && viewStates.set(previousPath, editorRef.current.saveViewState());
      editorRef.current.setModel(model);
      saveViewState && editorRef.current.restoreViewState(viewStates.get(path));
    }
  }, [path], isEditorReady);
  index$2['default'](() => {
    editorRef.current.updateOptions(options);
  }, [options], isEditorReady);
  index$2['default'](() => {
    if (editorRef.current.getOption(monacoRef.current.editor.EditorOption.readOnly)) {
      editorRef.current.setValue(value);
    } else {
      if (value !== editorRef.current.getValue()) {
        editorRef.current.executeEdits('', [{
          range: editorRef.current.getModel().getFullModelRange(),
          text: value,
          forceMoveMarkers: true
        }]);
        editorRef.current.pushUndoStop();
      }
    }
  }, [value], isEditorReady);
  index$2['default'](() => {
    monacoRef.current.editor.setModelLanguage(editorRef.current.getModel(), language);
  }, [language], isEditorReady);
  index$2['default'](() => {
    // reason for undefined check: https://github.com/suren-atoyan/monaco-react/pull/188
    if (!index$3.isUndefined(line)) {
      editorRef.current.revealLine(line);
    }
  }, [line], isEditorReady);
  index$2['default'](() => {
    monacoRef.current.editor.setTheme(theme);
  }, [theme], isEditorReady);
  const createEditor = React$1.useCallback(() => {
    beforeMountRef.current(monacoRef.current);
    const autoCreatedModelPath = path || defaultPath;
    const defaultModel = index$3.getOrCreateModel(monacoRef.current, value || defaultValue, defaultLanguage || language, autoCreatedModelPath);
    editorRef.current = monacoRef.current.editor.create(containerRef.current, {
      model: defaultModel,
      automaticLayout: true,
      ...options
    }, overrideServices);
    saveViewState && editorRef.current.restoreViewState(viewStates.get(autoCreatedModelPath));
    monacoRef.current.editor.setTheme(theme);
    setIsEditorReady(true);
  }, [defaultValue, defaultLanguage, defaultPath, value, language, path, options, overrideServices, saveViewState, theme]);
  React$1.useEffect(() => {
    if (isEditorReady) {
      onMountRef.current(editorRef.current, monacoRef.current);
    }
  }, [isEditorReady]);
  React$1.useEffect(() => {
    !isMonacoMounting && !isEditorReady && createEditor();
  }, [isMonacoMounting, isEditorReady, createEditor]); // subscription
  // to avoid unnecessary updates (attach - dispose listener) in subscription

  valueRef.current = value;
  React$1.useEffect(() => {
    if (isEditorReady && onChange) {
      var _subscriptionRef$curr, _editorRef$current;

      (_subscriptionRef$curr = subscriptionRef.current) === null || _subscriptionRef$curr === void 0 ? void 0 : _subscriptionRef$curr.dispose();
      subscriptionRef.current = (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.onDidChangeModelContent(event => {
        const editorValue = editorRef.current.getValue();

        if (valueRef.current !== editorValue) {
          onChange(editorValue, event);
        }
      });
    }
  }, [isEditorReady, onChange]); // onValidate

  React$1.useEffect(() => {
    if (isEditorReady) {
      const changeMarkersListener = monacoRef.current.editor.onDidChangeMarkers(uris => {
        var _editorRef$current$ge;

        const editorUri = (_editorRef$current$ge = editorRef.current.getModel()) === null || _editorRef$current$ge === void 0 ? void 0 : _editorRef$current$ge.uri;

        if (editorUri) {
          const currentEditorHasMarkerChanges = uris.find(uri => uri.path === editorUri.path);

          if (currentEditorHasMarkerChanges) {
            const markers = monacoRef.current.editor.getModelMarkers({
              resource: editorUri
            });
            onValidate === null || onValidate === void 0 ? void 0 : onValidate(markers);
          }
        }
      });
      return () => {
        changeMarkersListener === null || changeMarkersListener === void 0 ? void 0 : changeMarkersListener.dispose();
      };
    }
  }, [isEditorReady, onValidate]);

  function disposeEditor() {
    var _subscriptionRef$curr2;

    (_subscriptionRef$curr2 = subscriptionRef.current) === null || _subscriptionRef$curr2 === void 0 ? void 0 : _subscriptionRef$curr2.dispose();

    if (keepCurrentModel) {
      saveViewState && viewStates.set(path, editorRef.current.saveViewState());
    } else {
      var _editorRef$current$ge2;

      (_editorRef$current$ge2 = editorRef.current.getModel()) === null || _editorRef$current$ge2 === void 0 ? void 0 : _editorRef$current$ge2.dispose();
    }

    editorRef.current.dispose();
  }

  return /*#__PURE__*/React__default['default'].createElement(index$4['default'], {
    width: width,
    height: height,
    isEditorReady: isEditorReady,
    loading: loading,
    _ref: containerRef,
    className: className,
    wrapperClassName: wrapperClassName
  });
}

Editor$2.propTypes = {
  defaultValue: PropTypes__default['default'].string,
  defaultPath: PropTypes__default['default'].string,
  defaultLanguage: PropTypes__default['default'].string,
  value: PropTypes__default['default'].string,
  language: PropTypes__default['default'].string,
  path: PropTypes__default['default'].string,

  /* === */
  theme: PropTypes__default['default'].string,
  line: PropTypes__default['default'].number,
  loading: PropTypes__default['default'].oneOfType([PropTypes__default['default'].element, PropTypes__default['default'].string]),
  options: PropTypes__default['default'].object,
  overrideServices: PropTypes__default['default'].object,
  saveViewState: PropTypes__default['default'].bool,
  keepCurrentModel: PropTypes__default['default'].bool,

  /* === */
  width: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
  height: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string]),
  className: PropTypes__default['default'].string,
  wrapperClassName: PropTypes__default['default'].string,

  /* === */
  beforeMount: PropTypes__default['default'].func,
  onMount: PropTypes__default['default'].func,
  onChange: PropTypes__default['default'].func,
  onValidate: PropTypes__default['default'].func
};
Editor$2.defaultProps = {
  theme: 'light',
  loading: 'Loading...',
  options: {},
  overrideServices: {},
  saveViewState: true,
  keepCurrentModel: false,

  /* === */
  width: '100%',
  height: '100%',

  /* === */
  beforeMount: index$3.noop,
  onMount: index$3.noop,
  onValidate: index$3.noop
};

Editor$3.default = Editor$2;

Object.defineProperty(Editor$4, '__esModule', { value: true });

var React = React__default$4;
var Editor$1 = Editor$3;

var index = /*#__PURE__*/React.memo(Editor$1['default']);

Editor$4.default = index;

(function (exports) {

Object.defineProperty(exports, '__esModule', { value: true });

var loader = cjs;
var index = DiffEditor$3;
var index$1 = useMonaco$1;
var index$2 = Editor$4;

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var loader__default = /*#__PURE__*/_interopDefaultLegacy(loader);



Object.defineProperty(exports, 'loader', {
	enumerable: true,
	get: function () {
		return loader__default['default'];
	}
});
exports.DiffEditor = index['default'];
exports.useMonaco = index$1['default'];
exports.default = index$2['default'];
}(cjs$1));

var Editor = /*@__PURE__*/getDefaultExportFromCjs$1(cjs$1);

var css_248z$Y = ".style_jsonEditor__rZT-D {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  height: 100%;\n  width: 100%;\n  padding-bottom: 20px;\n}\n.style_jsonEditor__rZT-D > section {\n  flex: 1 1 auto;\n}";
var style$F = {"jsonEditor":"style_jsonEditor__rZT-D"};
styleInject(css_248z$Y);

function softCompare(left, right) {
    return JSON.stringify(left) === JSON.stringify(right);
}
function tryParse(str) {
    try {
        return JSON.parse(str);
    }
    catch (_a) {
        return undefined;
    }
}
/**
 * Simple component to display and edit JSON objects.
 */
function JSONEditor(props) {
    const [mutableValue, setMutableValue] = useState(JSON.stringify(props.value, undefined, 2));
    const [error, setError] = useState(undefined);
    useEffect(() => {
        const current = tryParse(mutableValue);
        if (!softCompare(props.value, current)) {
            setMutableValue(JSON.stringify(props.value, undefined, 2));
        }
    }, [mutableValue, props.value]);
    const monacoRef = useRef();
    useEffect(() => {
        if (monacoRef === null || monacoRef === void 0 ? void 0 : monacoRef.current) {
            const old = monacoRef.current.getValue();
            if (mutableValue.replace(/\s/g, "") !== old.replace(/\s/g, "")) {
                monacoRef.current.setValue(mutableValue);
            }
        }
    }, [mutableValue]);
    function handleEditorDidMount(editor) {
        monacoRef.current = editor;
        if (mutableValue) {
            monacoRef.current.setValue(mutableValue);
        }
    }
    function handleEditorChange(newValue) {
        const { onChange, onError } = props;
        try {
            if (newValue) {
                const mutableValue = JSON.parse(newValue);
                setError(undefined);
                // only call onChange when we can parse
                onChange(mutableValue);
            }
        }
        catch (error) {
            // JSON.parse only throws SyntaxErrors, we don't want to
            // be accidentally swallowing another type of error
            if (error instanceof SyntaxError) {
                setError(error);
                if (onError) {
                    onError(error);
                }
                else {
                    // If not a syntax error, throw it again
                    throw error;
                }
            }
        }
    }
    const options = useMemo(() => {
        var _a;
        return ({
            readOnly: (_a = props.readonly) !== null && _a !== void 0 ? _a : false,
        });
    }, [props.readonly]);
    return (React__default$4.createElement("div", { className: style$F.jsonEditor, style: Object.assign({}, props.style) },
        props.label && React__default$4.createElement("p", null, props.label),
        React__default$4.createElement(Editor, { language: "json", options: options, defaultValue: mutableValue, onMount: handleEditorDidMount, onChange: handleEditorChange }),
        error !== undefined ? React__default$4.createElement("p", null, error.message) : React__default$4.createElement("p", null, "Valid JSON")));
}

const SingleLineCodeEditor = props => {
    const handleEditorDidMount = (editor, monaco) => {
        editor.onKeyDown((e) => {
            if (e.keyCode === monaco.KeyCode.Enter) {
                // We only prevent enter when the suggest model is not active
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore Not sure about this yet
                if (editor.getContribution("editor.contrib.suggestController").model.state === 0) {
                    e.preventDefault();
                }
            }
        });
        editor.onDidPaste((e) => {
            const textModel = editor.getModel();
            if (textModel && e.range.endLineNumber > 1) {
                let newContent = "";
                const lineCount = textModel.getLineCount();
                for (let i = 0; i < lineCount; i++) {
                    newContent += textModel.getLineContent(i + 1);
                }
                textModel.setValue(newContent);
            }
        });
        if (props.onMount) {
            props.onMount(editor, monaco);
        }
    };
    const options = useMemo(() => (Object.assign(Object.assign({}, props.options), { find: { addExtraSpaceOnTop: false, autoFindInSelection: "never", seedSearchStringFromSelection: false /* newer versions use "never" */ }, folding: false, glyphMargin: false, hideCursorInOverviewRuler: true, lineDecorationsWidth: 0, lineNumbers: "off", lineNumbersMinChars: 0, minimap: {
            enabled: false
        }, overviewRulerBorder: false, overviewRulerLanes: 0, scrollBeyondLastColumn: 0, scrollbar: { horizontal: "hidden", vertical: "hidden" }, wordWrap: "off" })), [props.options]);
    return React__default$4.createElement(Editor, Object.assign({}, props, { height: "20px", options: options, onMount: handleEditorDidMount }));
};

const typings = `
declare type DurationFormat =
    "years" | "quarters" | "months" |
    "weeks" | "days" | "hours" |
    "minutes" | "seconds" | "milliseconds";

declare function activeWithin(amount: number, format: DurationFormat): boolean;

declare function fitsSchedule(start: string, startFormat: string, durationAmount: number, durationFormat: DurationFormat, timeZone?: string): boolean;

declare function isIntentRequest(): boolean;
declare function isLaunchRequest(): boolean;
declare function isInputUnknownRequest(): boolean;

declare function isRequestID(id: string | readonly string[]): boolean;

declare function hasSlot(name: string): boolean;
declare function slotExists(name: string): boolean;
declare function slotDoesNotExist(name: string): boolean;
declare function slotEquals(name: string, value: string): boolean;
`;

function ConditionCodeEditor(props) {
    const monacoRef = useRef();
    function handleEditorWillMount(monaco) {
        monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
            allowNonTsExtensions: true,
            lib: ["ScriptHost"],
            module: monaco.languages.typescript.ModuleKind.None,
            moduleResolution: monaco.languages.typescript.ModuleResolutionKind.None,
            noEmit: true,
            target: monaco.languages.typescript.ScriptTarget.ES2016,
        });
        monaco.languages.typescript.javascriptDefaults.addExtraLib(typings);
    }
    useEffect(() => {
        if (monacoRef.current) {
            const old = monacoRef.current.getValue();
            if (props.defaultValue !== old) {
                monacoRef.current.setValue(props.defaultValue);
            }
        }
    }, [props.defaultValue]);
    function handleEditorDidMount(editor, monaco) {
        monacoRef.current = editor;
    }
    return (React__default$4.createElement("div", { style: { marginBottom: "24px", border: "1px solid #d9d9d9" } },
        React__default$4.createElement(SingleLineCodeEditor, Object.assign({ defaultLanguage: "javascript", beforeMount: handleEditorWillMount, onMount: handleEditorDidMount }, props))));
}

function ConditionEditor(props) {
    const { onChange, onSyntaxError } = props;
    const handleValidation = (markers) => {
        if (typeof onSyntaxError === "function") {
            const errors = markers.map((marker) => {
                return marker.message;
            });
            onSyntaxError(errors);
        }
    };
    if (typeof props.value === "string") {
        return (React__default$4.createElement(ConditionCodeEditor, { defaultValue: props.value, onChange: onChange, onValidate: handleValidation }));
    }
    return React__default$4.createElement(React__default$4.Fragment, null,
        "Unknown condition type ",
        typeof props.value);
}

var css_248z$X = ".style_wrap__AFgwP {\n  background-color: #fdfdfd;\n  padding: 2em 1em;\n  text-align: center;\n  margin-bottom: 1em;\n}";
var Style = {"wrap":"style_wrap__AFgwP"};
styleInject(css_248z$X);

/**
 * Empty list placeholder.
 *
 * @param props
 * @returns
 */
const Empty = ({ title, children, style }) => {
    return (React__default$4.createElement("div", { className: Style.wrap, style: style },
        React__default$4.createElement("h3", null, title),
        children));
};

var css_248z$W = ".Expander_expander__4Fm5T {\n  margin: 0 auto;\n}";
var style$E = {"expander":"Expander_expander__4Fm5T"};
styleInject(css_248z$W);

const Expander = () => {
    return (React__default$4.createElement("div", { className: style$E.expander }));
};

var css_248z$V = ".FeatureList-module_featureList__x8Qoc {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.FeatureList-module_featureItem__UThQm {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.FeatureList-module_icon__T44S3 {\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.FeatureList-module_text__mZq6I {\n  display: flex;\n  flex-direction: column;\n}\n\n.FeatureList-module_title__-M4nr {\n  font-weight: 500;\n  color: #565758;\n}\n\n.FeatureList-module_subtitle__L-cGT {\n  font-size: 0.9rem;\n  color: #565758;\n}\n\n.FeatureList-module_availabilityWrapper__ntw9D {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  margin-top: 4px;\n  font-size: 0.8rem;\n  color: #4b5563;\n}\n\n.FeatureList-module_unavailableWrapper__VZTDJ {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  margin-top: 4px;\n  font-size: 0.8rem;\n  color: #4b5563;\n}\n\n.FeatureList-module_unavailableText__DXyk7 {\n  color: #6b7280;\n  font-style: italic;\n  font-size: 0.7rem;\n}";
var style$D = {"featureList":"FeatureList-module_featureList__x8Qoc","featureItem":"FeatureList-module_featureItem__UThQm","icon":"FeatureList-module_icon__T44S3","text":"FeatureList-module_text__mZq6I","title":"FeatureList-module_title__-M4nr","subtitle":"FeatureList-module_subtitle__L-cGT","availabilityWrapper":"FeatureList-module_availabilityWrapper__ntw9D","unavailableWrapper":"FeatureList-module_unavailableWrapper__VZTDJ","unavailableText":"FeatureList-module_unavailableText__DXyk7"};
styleInject(css_248z$V);

const FeatureList = ({ features }) => {
    return (React__default$4.createElement("div", { className: style$D.featureList }, features
        .filter((f) => !f.disable)
        .map((feature, index) => (React__default$4.createElement("div", { key: index, className: style$D.featureItem },
        React__default$4.createElement("div", { className: style$D.icon },
            React__default$4.createElement(Icon$1, { value: "check", style: { color: feature.available ? "green" : "orange" } })),
        React__default$4.createElement("div", { className: style$D.text },
            React__default$4.createElement("div", { className: style$D.title }, feature.title),
            feature.subtitle && React__default$4.createElement("div", { className: style$D.subtitle }, feature.subtitle),
            feature.available && feature.availabilityText && (React__default$4.createElement("div", { className: style$D.availabilityWrapper },
                React__default$4.createElement(Icon$1, { value: "check_circle", style: { color: "green", fontSize: "0.9rem" } }),
                React__default$4.createElement("div", { className: style$D.availabilityText }, feature.availabilityText))),
            !feature.available && feature.unavailableText && (React__default$4.createElement("div", { className: style$D.unavailableWrapper },
                React__default$4.createElement(Icon$1, { value: "priority_high", style: { color: "orange", fontSize: "0.9rem" } }),
                React__default$4.createElement("div", { className: style$D.unavailableText }, feature.unavailableText)))))))));
};

const Rating = (_a) => {
    var { label, value, footer, onChange } = _a, props = __rest$2(_a, ["label", "value", "footer", "onChange"]);
    return (React__default$4.createElement(React__default$4.Fragment, null,
        label && React__default$4.createElement(node.Typography, null, label),
        React__default$4.createElement(RatingMUI, Object.assign({ value: value, onChange: (_, newValue) => {
                onChange(newValue);
            } }, props)),
        footer && React__default$4.createElement(node.Typography, null, label)));
};

var css_248z$U = ".style_feedbackCardWrapper__FgbC1 {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  text-align: center;\n  margin: auto;\n  padding: 5px;\n}";
var style$C = {"feedbackCardWrapper":"style_feedbackCardWrapper__FgbC1"};
styleInject(css_248z$U);

const FeedbackCard = ({ title, subtitle, description, qualification, author, avatarSRC, rating = true, }) => {
    const [value, setValue] = useState(5);
    const handleChange = (newValue) => {
        setValue(newValue);
    };
    const isImageUrl = (url) => {
        const imageExtensions = /\.(jpg|jpeg|gif|png|bmp|svg)$/i;
        return imageExtensions.test(url);
    };
    const renderContent = () => {
        if (isImageUrl(title)) {
            return React__default$4.createElement("img", { style: { width: 150 }, src: title, alt: "Imagen" });
        }
        else if (title) {
            return React__default$4.createElement("h2", null, title);
        }
        else {
            return React__default$4.createElement(React__default$4.Fragment, null);
        }
    };
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement("div", { className: style$C.feedbackCardWrapper },
            renderContent(),
            avatarSRC ? React__default$4.createElement(Avatar$4, { src: avatarSRC, sx: { width: 65, height: 65, margin: "auto" } }) : React__default$4.createElement(React__default$4.Fragment, null),
            subtitle ? React__default$4.createElement("h4", null, subtitle) : React__default$4.createElement(React__default$4.Fragment, null, " "),
            description ? React__default$4.createElement("p", null, description) : React__default$4.createElement(React__default$4.Fragment, null),
            rating && (React__default$4.createElement("div", null,
                React__default$4.createElement(Rating, { disabled: true, value: value, onChange: handleChange }),
                " ")),
            React__default$4.createElement("h6", null, author),
            qualification ? (React__default$4.createElement("h5", { style: { width: 100, margin: "auto", marginTop: 20 } }, qualification)) : (React__default$4.createElement(React__default$4.Fragment, null, " ")))));
};

var Check = {};

var _interopRequireDefault$a = interopRequireDefault$1.exports;
Object.defineProperty(Check, "__esModule", {
  value: true
});
var default_1 = Check.default = void 0;
var _createSvgIcon = _interopRequireDefault$a(createSvgIcon);
var _jsxRuntime = require$$11;
default_1 = Check.default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

const FilterChips = ({ label, options, selectedValues, onChange }) => {
    const handleClick = (value) => {
        const isSelected = selectedValues.includes(value);
        if (isSelected) {
            // Remove from selection
            onChange(selectedValues.filter(v => v !== value));
        }
        else {
            // Add to selection
            onChange([...selectedValues, value]);
        }
    };
    return (React__default$4.createElement(FormControl, { style: { width: '100%' } },
        label && (React__default$4.createElement(FormLabel, { style: { marginBottom: '8px', fontSize: '14px' } }, label)),
        React__default$4.createElement("div", { style: {
                display: 'flex',
                gap: '8px',
                flexWrap: 'wrap',
            } }, options.map((option) => {
            const isSelected = selectedValues.includes(option.value);
            return (React__default$4.createElement(Chip, { key: option.value, label: option.label, onClick: () => handleClick(option.value), color: isSelected ? 'primary' : 'default', variant: isSelected ? 'filled' : 'outlined', clickable: true, icon: isSelected ? React__default$4.createElement(default_1, null) : undefined, sx: {
                    padding: '6px 12px',
                    height: 'auto',
                    fontSize: '14px',
                    borderRadius: '16px',
                    '& .MuiChip-label': {
                        padding: '0 8px'
                    },
                    '& .MuiChip-icon': {
                        marginLeft: '8px',
                        marginRight: '-4px'
                    }
                } }));
        }))));
};

var css_248z$T = ".FireworksCanvas-module_canvas__tbQUl {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 0;\n}";
var style$B = {"canvas":"FireworksCanvas-module_canvas__tbQUl"};
styleInject(css_248z$T);

const FireworksCanvas = ({ className }) => {
    const canvasRef = useRef(null);
    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas)
            return;
        const ctx = canvas.getContext("2d");
        if (!ctx)
            return;
        // always sync buffer size to css size
        const resize = () => {
            canvas.width = canvas.clientWidth;
            canvas.height = canvas.clientHeight;
        };
        resize();
        window.addEventListener("resize", resize);
        let particles = [];
        let lastTime = 0;
        const spawnFirework = () => {
            const w = canvas.width;
            const h = canvas.height;
            const x = Math.random() * w;
            const y = Math.random() * (h / 2);
            const color = `hsl(${Math.random() * 360}, 100%, 60%)`;
            for (let i = 0; i < 80; i++) {
                const angle = (Math.PI * 2 * i) / 80;
                const speed = Math.random() * 3 + 2;
                particles.push({
                    x,
                    y,
                    vx: Math.cos(angle) * speed,
                    vy: Math.sin(angle) * speed,
                    alpha: 1,
                    color,
                    life: Math.random() * 60 + 40,
                });
            }
        };
        const update = (delta) => {
            particles = particles.filter((p) => p.life > 0 && p.alpha > 0);
            particles.forEach((p) => {
                p.x += p.vx;
                p.y += p.vy;
                p.vy += 0.05; // gravity
                p.life -= delta * 0.1;
                p.alpha -= 0.01;
            });
        };
        const draw = () => {
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            particles.forEach((p) => {
                ctx.fillStyle = p.color;
                ctx.globalAlpha = p.alpha;
                ctx.beginPath();
                ctx.arc(p.x, p.y, 2, 0, Math.PI * 2);
                ctx.fill();
            });
            ctx.globalAlpha = 1;
        };
        const loop = (time) => {
            const delta = time - lastTime;
            lastTime = time;
            update(delta);
            draw();
            requestAnimationFrame(loop);
        };
        const interval = setInterval(spawnFirework, 700);
        requestAnimationFrame(loop);
        return () => {
            clearInterval(interval);
            window.removeEventListener("resize", resize);
        };
    }, []);
    return React__default$4.createElement("canvas", { ref: canvasRef, className: `${style$B.canvas} ${className !== null && className !== void 0 ? className : ""}` });
};

var css_248z$S = ".FireworksBackground-module_wrapper__WoLIu {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  background: #fff;\n}\n\n.FireworksBackground-module_content__rtJ8t {\n  position: relative;\n  z-index: 1;\n}";
var classes$2 = {"wrapper":"FireworksBackground-module_wrapper__WoLIu","content":"FireworksBackground-module_content__rtJ8t"};
styleInject(css_248z$S);

const FireworksBackground = ({ children, style }) => {
    return (React__default$4.createElement("div", { className: classes$2.wrapper, style: style },
        React__default$4.createElement(FireworksCanvas, null),
        React__default$4.createElement("div", { className: classes$2.content }, children)));
};

var css_248z$R = ".GoogleBusinessProfile-module_card__c9nV6 {\n  max-width: 400px;\n  padding: 1rem;\n  border-radius: 1rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  background: white;\n}\n\n.GoogleBusinessProfile-module_title__BJi0h {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.GoogleBusinessProfile-module_tagline__-Mase {\n  font-size: 1rem;\n  color: gray;\n}\n\n.GoogleBusinessProfile-module_ratingContainer__2mtE3 {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  margin-top: 0.5rem;\n}\n\n.GoogleBusinessProfile-module_star__65WHo {\n  color: gray;\n}\n\n.GoogleBusinessProfile-module_starFilled__UvKqY {\n  color: gold;\n}\n\n.GoogleBusinessProfile-module_rating__t-rUQ {\n  margin-top: 0.25rem;\n  color: gray;\n}\n\n.GoogleBusinessProfile-module_chipContainer__KzdgT {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  overflow-x: auto;\n}\n\n.GoogleBusinessProfile-module_chip__D8jyf {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  border: 1px solid #d2d2d2;\n  padding: 0.5rem 1rem;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: bold;\n  text-decoration: none;\n  color: black;\n  transition: background 0.2s;\n}\n.GoogleBusinessProfile-module_chip__D8jyf:hover {\n  background: #e0e0e0;\n}\n\n.GoogleBusinessProfile-module_materialIcon__o-VNf {\n  font-size: 1.3rem;\n  color: #1a73e8;\n}\n\n.GoogleBusinessProfile-module_bookButton__rd7ff {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: #fff;\n  background-color: #1a73e8;\n  border: 1px solid #fff;\n  padding: 0.75rem;\n  border-radius: 20px;\n  font-size: 1rem;\n  font-weight: normal;\n  text-decoration: none;\n  margin-top: 0.75rem;\n  position: relative;\n  overflow: hidden;\n  transition: background 0.2s;\n}\n.GoogleBusinessProfile-module_bookButton__rd7ff:hover {\n  background: #bbd1e9;\n}\n.GoogleBusinessProfile-module_bookButton__rd7ff .GoogleBusinessProfile-module_material-icons__ozNUE {\n  font-size: 1.25rem;\n  color: white;\n}\n\n/* Shimmer Effect */\n.GoogleBusinessProfile-module_shimmerEffect__LDUFy {\n  box-shadow: 0 0 10px rgba(30, 136, 229, 0.6), 0 0 20px rgba(30, 136, 229, 0.4); /* Adds glow effect */\n}\n.GoogleBusinessProfile-module_shimmerEffect__LDUFy::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -150%;\n  width: 250%;\n  height: 100%;\n  background: linear-gradient(120deg, transparent 40%, rgba(255, 255, 255, 0.7) 50%, transparent 60%);\n  transform: skewX(-20deg);\n  animation: GoogleBusinessProfile-module_shimmer__c0RHi 1.5s infinite ease-in-out;\n}\n\n@keyframes GoogleBusinessProfile-module_shimmer__c0RHi {\n  0% {\n    left: -150%;\n  }\n  100% {\n    left: 150%;\n  }\n}\n.GoogleBusinessProfile-module_additionalInfo__xDNa7 {\n  margin-top: 16px;\n  padding-top: 12px;\n  overflow-x: auto;\n}\n\n.GoogleBusinessProfile-module_divider__ZYi1u {\n  border: none;\n  border-top: 1px solid #ddd;\n  margin: 0px 0px;\n  margin-bottom: 12px;\n}\n\n.GoogleBusinessProfile-module_additionalInfo__xDNa7 p {\n  margin: 4px 0;\n  font-size: 14px;\n  color: #333;\n}\n\n.GoogleBusinessProfile-module_additionalInfo__xDNa7 strong {\n  font-weight: bold;\n  color: #000;\n}\n\n.GoogleBusinessProfile-module_additionalInfo__xDNa7 a {\n  color: #0073e6;\n  text-decoration: none;\n}\n\n.GoogleBusinessProfile-module_additionalInfo__xDNa7 a:hover {\n  text-decoration: underline;\n}\n\n.GoogleBusinessProfile-module_reviewCount__BDOMh {\n  font-size: 0.875rem;\n  color: gray;\n}\n\n.GoogleBusinessProfile-module_imageContainer__3bIXF {\n  display: flex;\n  gap: 0.5rem;\n  overflow-x: auto;\n  margin-top: 1rem;\n}\n\n.GoogleBusinessProfile-module_image__VblyL {\n  width: 5rem;\n  height: 5rem;\n  border-radius: 0.5rem;\n  object-fit: cover;\n}\n\n.GoogleBusinessProfile-module_content__C0VLu {\n  margin-top: 1rem;\n}\n\n.GoogleBusinessProfile-module_infoRow__htkas {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: gray;\n}\n\n.GoogleBusinessProfile-module_icon__T2SsH {\n  width: 1.25rem;\n  height: 1.25rem;\n}\n\n.GoogleBusinessProfile-module_website__paBLW {\n  color: blue;\n  text-decoration: none;\n}\n.GoogleBusinessProfile-module_website__paBLW:hover {\n  text-decoration: underline;\n}\n\n.GoogleBusinessProfile-module_reviewsSection__aJrsT {\n  margin-top: 1rem;\n  border-top: 1px solid #e0e0e0;\n  padding-top: 1rem;\n}\n\n.GoogleBusinessProfile-module_reviewTitle__k5YUk {\n  font-weight: bold;\n}\n\n.GoogleBusinessProfile-module_reviewCard__u5j-K {\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 0.5rem;\n}\n\n.GoogleBusinessProfile-module_reviewAuthor__iee69 {\n  font-weight: medium;\n}\n\n.GoogleBusinessProfile-module_reviewComment__Ga1FF {\n  font-size: 0.875rem;\n  color: gray;\n}\n\n.GoogleBusinessProfile-module_viewMoreButton__3ZSSj {\n  width: 100%;\n  margin-top: 1rem;\n  background: blue;\n  color: white;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n}\n.GoogleBusinessProfile-module_viewMoreButton__3ZSSj:hover {\n  background: darkblue;\n}\n\n@media (max-width: 600px) {\n  .GoogleBusinessProfile-module_imageContainer__3bIXF {\n    display: none;\n  }\n  .GoogleBusinessProfile-module_chipContainer__KzdgT {\n    display: none;\n  }\n}";
var styles$9 = {"card":"GoogleBusinessProfile-module_card__c9nV6","title":"GoogleBusinessProfile-module_title__BJi0h","tagline":"GoogleBusinessProfile-module_tagline__-Mase","ratingContainer":"GoogleBusinessProfile-module_ratingContainer__2mtE3","star":"GoogleBusinessProfile-module_star__65WHo","starFilled":"GoogleBusinessProfile-module_starFilled__UvKqY","rating":"GoogleBusinessProfile-module_rating__t-rUQ","chipContainer":"GoogleBusinessProfile-module_chipContainer__KzdgT","chip":"GoogleBusinessProfile-module_chip__D8jyf","materialIcon":"GoogleBusinessProfile-module_materialIcon__o-VNf","bookButton":"GoogleBusinessProfile-module_bookButton__rd7ff","material-icons":"GoogleBusinessProfile-module_material-icons__ozNUE","shimmerEffect":"GoogleBusinessProfile-module_shimmerEffect__LDUFy","shimmer":"GoogleBusinessProfile-module_shimmer__c0RHi","additionalInfo":"GoogleBusinessProfile-module_additionalInfo__xDNa7","divider":"GoogleBusinessProfile-module_divider__ZYi1u","reviewCount":"GoogleBusinessProfile-module_reviewCount__BDOMh","imageContainer":"GoogleBusinessProfile-module_imageContainer__3bIXF","image":"GoogleBusinessProfile-module_image__VblyL","content":"GoogleBusinessProfile-module_content__C0VLu","infoRow":"GoogleBusinessProfile-module_infoRow__htkas","icon":"GoogleBusinessProfile-module_icon__T2SsH","website":"GoogleBusinessProfile-module_website__paBLW","reviewsSection":"GoogleBusinessProfile-module_reviewsSection__aJrsT","reviewTitle":"GoogleBusinessProfile-module_reviewTitle__k5YUk","reviewCard":"GoogleBusinessProfile-module_reviewCard__u5j-K","reviewAuthor":"GoogleBusinessProfile-module_reviewAuthor__iee69","reviewComment":"GoogleBusinessProfile-module_reviewComment__Ga1FF","viewMoreButton":"GoogleBusinessProfile-module_viewMoreButton__3ZSSj"};
styleInject(css_248z$R);

const PlacesTypeOne = [
    "accounting",
    "airport",
    "amusement_park",
    "aquarium",
    "art_gallery",
    "atm",
    "bakery",
    "bank",
    "bar",
    "beauty_salon",
    "bicycle_store",
    "book_store",
    "bowling_alley",
    "bus_station",
    "cafe",
    "campground",
    "car_dealer",
    "car_rental",
    "car_repair",
    "car_wash",
    "casino",
    "cemetery",
    "church",
    "city_hall",
    "clothing_store",
    "convenience_store",
    "courthouse",
    "dentist",
    "department_store",
    "doctor",
    "drugstore",
    "electrician",
    "electronics_store",
    "embassy",
    "fire_station",
    "florist",
    "funeral_home",
    "furniture_store",
    "gas_station",
    "gym",
    "hair_care",
    "hardware_store",
    "hindu_temple",
    "home_goods_store",
    "hospital",
    "insurance_agency",
    "jewelry_store",
    "laundry",
    "lawyer",
    "library",
    "light_rail_station",
    "liquor_store",
    "local_government_office",
    "locksmith",
    "lodging",
    "meal_delivery",
    "meal_takeaway",
    "mosque",
    "movie_rental",
    "movie_theater",
    "moving_company",
    "museum",
    "night_club",
    "painter",
    "park",
    "parking",
    "pet_store",
    "pharmacy",
    "physiotherapist",
    "plumber",
    "police",
    "post_office",
    "primary_school",
    "real_estate_agency",
    "restaurant",
    "roofing_contractor",
    "rv_park",
    "school",
    "secondary_school",
    "shoe_store",
    "shopping_mall",
    "spa",
    "stadium",
    "storage",
    "store",
    "subway_station",
    "supermarket",
    "synagogue",
    "taxi_stand",
    "tourist_attraction",
    "train_station",
    "transit_station",
    "travel_agency",
    "university",
    "veterinary_care",
    "zoo",
];
const PlacesTypeTwo = [
    "administrative_area_level_1",
    "administrative_area_level_2",
    "administrative_area_level_3",
    "administrative_area_level_4",
    "administrative_area_level_5",
    "administrative_area_level_6",
    "administrative_area_level_7",
    "archipelago",
    "colloquial_area",
    "continent",
    "country",
    "establishment",
    "finance",
    "floor",
    "food",
    "general_contractor",
    "geocode",
    "health",
    "intersection",
    "landmark",
    "locality",
    "natural_feature",
    "neighborhood",
    "place_of_worship",
    "plus_code",
    "point_of_interest",
    "political",
    "post_box",
    "postal_code",
    "postal_code_prefix",
    "postal_code_suffix",
    "postal_town",
    "premise",
    "room",
    "route",
    "street_address",
    "street_number",
    "sublocality",
    "sublocality_level_1",
    "sublocality_level_2",
    "sublocality_level_3",
    "sublocality_level_4",
    "sublocality_level_5",
    "subpremise",
    "town_square",
];

/**
 * Generates a tagline for the business profile like "Plumbing in San Francisco, CA"
 *
 * If it doesn't have a place type one (like plumber), it should just say "Business in San Francisco, CA"
 *
 * @param place
 */
const generateTagline = (place) => {
    var _a, _b, _c, _d;
    let placeType;
    if (place.types) {
        placeType = place.types.find((type) => PlacesTypeOne.includes(type));
        // capitalize, replace underscores with spaces
        if (placeType) {
            placeType = placeType === null || placeType === void 0 ? void 0 : placeType.replace(/_/g, " ");
            placeType = (placeType === null || placeType === void 0 ? void 0 : placeType.charAt(0).toUpperCase()) + (placeType === null || placeType === void 0 ? void 0 : placeType.slice(1));
        }
    }
    // get city & state
    const city = (_b = (_a = place.addressComponents) === null || _a === void 0 ? void 0 : _a.find((component) => { var _a; return (_a = component === null || component === void 0 ? void 0 : component.types) === null || _a === void 0 ? void 0 : _a.includes("locality"); })) === null || _b === void 0 ? void 0 : _b.longName;
    const state = (_d = (_c = place.addressComponents) === null || _c === void 0 ? void 0 : _c.find((component) => { var _a; return (_a = component === null || component === void 0 ? void 0 : component.types) === null || _a === void 0 ? void 0 : _a.includes("administrative_area_level_1"); })) === null || _d === void 0 ? void 0 : _d.shortName;
    let location;
    if (city && state) {
        location = `${city}, ${state}`;
    }
    else if (city) {
        location = city;
    }
    else if (state) {
        location = state;
    }
    if (placeType && location) {
        return `${placeType} in ${location}`;
    }
    else if (location) {
        return `Business in ${location}`;
    }
    else {
        return "Business";
    }
};

var css_248z$Q = "@keyframes style_pulse__B-h0L {\n  0% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(0.75);\n  }\n  50% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n.style_loader__-ei7d {\n  text-align: center;\n  padding: 1em;\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.style_carriage__Br73Z {\n  padding: 0;\n  display: inline-block;\n  width: 144px;\n  transform: rotate(-45deg);\n}\n\n.style_box__XTpbE {\n  width: 40px;\n  height: 40px;\n  border: 2px solid #1aa7dc;\n  background-color: #1aa7dc;\n  display: inline-block;\n  text-align: center;\n  line-height: 40px;\n  font-family: sans-serif;\n  margin: 2px;\n  flex: 0 0 auto;\n  animation-name: style_pulse__B-h0L;\n  animation-duration: 1s;\n  animation-iteration-count: infinite;\n}\n\n.style_second__uN6Cq {\n  animation-delay: 0.25s;\n}\n\n.style_third__p1NJL {\n  animation-delay: 0.5s;\n}\n\n.style_fourth__1pfO0 {\n  animation-delay: 0.75s;\n}\n\n.style_spacer__K1FIi {\n  visibility: none;\n  opacity: 0;\n}\n\n.style_white__fs6aE {\n  background-color: transparent;\n}";
var style$A = {"loader":"style_loader__-ei7d","carriage":"style_carriage__Br73Z","box":"style_box__XTpbE","pulse":"style_pulse__B-h0L","second":"style_second__uN6Cq","third":"style_third__p1NJL","fourth":"style_fourth__1pfO0","spacer":"style_spacer__K1FIi","white":"style_white__fs6aE"};
styleInject(css_248z$Q);

/**
 * Animated loading spinner of the XAPP "squares" logo. Add `loadingText=` for a custom message.
 */
const LoadingSpinner = props => {
    return (React__default$4.createElement("div", { className: style$A.loader, style: props.loaderStyle },
        React__default$4.createElement("div", { className: style$A.carriage },
            React__default$4.createElement("div", { className: style$A.box }),
            React__default$4.createElement("div", { className: classNames$1(style$A.box, style$A.second) }),
            React__default$4.createElement("div", { className: classNames$1(style$A.box, style$A.spacer) }),
            React__default$4.createElement("div", { className: classNames$1(style$A.box, style$A.spacer) }),
            React__default$4.createElement("div", { className: classNames$1(style$A.box, style$A.third) }),
            React__default$4.createElement("div", { className: classNames$1(style$A.box, style$A.fourth, style$A.white) })),
        React__default$4.createElement("h2", { style: props.textStyle }, props.loadingText)));
};

const LOADING_TEXT = [
    "Reticulating splines...",
    "Setting SSML phoneme to stutter…",
    "Reprompting the reprompts…",
    "Mishearing homophones...",
    "Randomizing email responses…",
    "Obfuscating forwarding conditions…",
];
const SimLoadingSpinner = ({ loaderStyle, textStyle, messageInterval = 2000 }) => {
    const [textIndex, setTextIndex] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setTextIndex((prevIndex) => (prevIndex + 1) % LOADING_TEXT.length);
        }, messageInterval);
        return () => clearInterval(interval);
    }, [messageInterval]);
    return React__default$4.createElement(LoadingSpinner, { loadingText: LOADING_TEXT[textIndex], loaderStyle: loaderStyle, textStyle: textStyle });
};

const generateLoadingMessages = (place) => {
    return [
        (place === null || place === void 0 ? void 0 : place.name) ? `Exploring ${place.name}...` : "Discovering new places...",
        (place === null || place === void 0 ? void 0 : place.businessStatus) ? `Checking ${place.businessStatus} status...` : "Verifying business status...",
        (place === null || place === void 0 ? void 0 : place.phone) ? `Noting phone number ${place.phone}...` : "Searching for contact information...",
        (place === null || place === void 0 ? void 0 : place.rating) ? `Checking ${place.name}'s ${place.rating} star rating...` : "Gathering customer feedback...",
        (place === null || place === void 0 ? void 0 : place.totalRatings) ? `Noting ${place.totalRatings} reviews...` : "Analyzing visitor opinions...",
        (place === null || place === void 0 ? void 0 : place.website) ? `Loading website: ${place.website}...` : "Finding online presence...",
        (place === null || place === void 0 ? void 0 : place.formattedAddress) ? `Locating ${place.formattedAddress}...` : "Retrieving location details...",
        "Searching for business logo...",
        "Checking for photos...",
        "Initial training complete...",
    ];
};
/**
 * A loading spinner component that displays messages related to a specific place.
 *
 * @returns
 */
const PlaceLoadingSpinner = ({ place, loaderStyle, textStyle, messageInterval = 2000, }) => {
    const messages = generateLoadingMessages(place);
    const [textIndex, setTextIndex] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setTextIndex((prevIndex) => (prevIndex + 1) % messages.length);
        }, messageInterval);
        return () => clearInterval(interval);
    }, [messageInterval, messages]);
    return React__default$4.createElement(LoadingSpinner, { loadingText: messages[textIndex], loaderStyle: loaderStyle, textStyle: textStyle });
};

const GoogleBusinessProfile = (props) => {
    var _a, _b, _c;
    const { loading, place, showReviews, showContact, showBookOnline, bookingUrl } = props;
    const handleBookOnlineClick = useCallback((event) => {
        var _a;
        if ((_a = props.callbacks) === null || _a === void 0 ? void 0 : _a.handleBookOnlineClick) {
            props.callbacks.handleBookOnlineClick(event);
        }
        else {
            // Default behavior if no callback is provided
            if (event) {
                event.preventDefault();
            }
        }
    }, [props.callbacks]);
    if (loading) {
        return (React__default$4.createElement("div", { className: styles$9.card },
            React__default$4.createElement(LoadingSpinner, null)));
    }
    const { name, formattedAddress, phone, website, rating, totalRatings, photos, reviews, mapsUrl } = place;
    const tagline = generateTagline(place);
    const preventClick = (event) => {
        event.preventDefault();
    };
    // clean off the query string from the website for display
    let cleanWebsiteForDisplay = website;
    if (cleanWebsiteForDisplay && cleanWebsiteForDisplay.includes("?")) {
        cleanWebsiteForDisplay = cleanWebsiteForDisplay.split("?")[0];
    }
    return (React__default$4.createElement("div", { className: styles$9.card },
        photos && photos.length > 0 && (React__default$4.createElement("div", { className: styles$9.imageContainer }, (photos || []).slice(0, 3).map((photo, index) => {
            const src = `https://places.xapp.ai/maps/api/place/photo?maxwidth=400&photoreference=${photo.photoReference}`;
            return React__default$4.createElement("img", { key: index, src: src, alt: "Business", className: styles$9.image });
        }))),
        React__default$4.createElement("h2", { className: styles$9.title }, name),
        typeof rating === "number" && (React__default$4.createElement("div", { className: styles$9.ratingContainer },
            React__default$4.createElement("span", { className: styles$9.rating }, rating),
            [...Array(5)].map((_, i) => (React__default$4.createElement("span", { key: i, className: `material-icons ${i < rating ? styles$9.starFilled : styles$9.star}` }, "star"))),
            React__default$4.createElement("span", { className: styles$9.reviewCount },
                "(",
                totalRatings,
                " reviews)"))),
        React__default$4.createElement("p", { className: styles$9.tagline }, tagline),
        React__default$4.createElement("div", { className: styles$9.chipContainer },
            website && (React__default$4.createElement("a", { href: website, target: "_blank", rel: "noopener noreferrer", className: styles$9.chip, onClick: preventClick },
                React__default$4.createElement("span", { className: classNames$1("material-icons", styles$9.materialIcon) }, "public"),
                " Website")),
            React__default$4.createElement("a", { href: mapsUrl ||
                    `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(formattedAddress || "")}`, target: "_blank", rel: "noopener noreferrer", className: styles$9.chip, onClick: handleBookOnlineClick },
                React__default$4.createElement("span", { className: classNames$1("material-icons", styles$9.materialIcon) }, "directions"),
                " Directions"),
            phone && (React__default$4.createElement("a", { href: `tel:${phone}`, className: styles$9.chip, onClick: preventClick },
                React__default$4.createElement("span", { className: classNames$1("material-icons", styles$9.materialIcon) }, "phone"),
                " Call"))),
        showBookOnline && (React__default$4.createElement("a", { href: bookingUrl, target: "_blank", rel: "noopener noreferrer", className: classNames$1(styles$9.bookButton, {
                [styles$9.shimmerEffect]: (_a = props.styles) === null || _a === void 0 ? void 0 : _a.razzleDazzle,
                [((_b = props.styles) === null || _b === void 0 ? void 0 : _b.bookOnlineClass) || ""]: !!((_c = props.styles) === null || _c === void 0 ? void 0 : _c.bookOnlineClass),
            }), onClick: preventClick },
            React__default$4.createElement("span", { className: "material-icons" }, "event"),
            " Book online")),
        showContact && (React__default$4.createElement("div", { className: styles$9.additionalInfo },
            React__default$4.createElement("hr", { className: styles$9.divider }),
            formattedAddress && (React__default$4.createElement("p", null,
                React__default$4.createElement("strong", null, "Address:"),
                " ",
                formattedAddress)),
            phone && (React__default$4.createElement("p", null,
                React__default$4.createElement("strong", null, "Phone:"),
                " ",
                phone)),
            website && (React__default$4.createElement("p", null,
                React__default$4.createElement("strong", null, "Website:"),
                " ",
                cleanWebsiteForDisplay)))),
        showReviews && (React__default$4.createElement("div", { className: styles$9.reviewsSection },
            React__default$4.createElement("h3", { className: styles$9.reviewTitle }, "Recent Reviews"),
            (reviews || []).slice(0, 3).map((review, index) => (React__default$4.createElement("div", { key: index, className: styles$9.reviewCard },
                React__default$4.createElement("p", { className: styles$9.reviewAuthor }, review.authorName),
                React__default$4.createElement("div", { className: styles$9.ratingContainer }, [...Array(5)].map((_, i) => (React__default$4.createElement("span", { key: i, className: `material-icons ${i < review.rating ? styles$9.starFilled : styles$9.star}` }, "star")))),
                React__default$4.createElement("p", { className: styles$9.reviewComment }, review.text))))))));
};

const GoogleBusinessProfileContainer = (_a) => {
    var _b;
    var { compare, placeId } = _a, props = __rest$2(_a, ["compare", "placeId"]);
    const [place, setPlace] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const fetchedPlaceIdRef = useRef(null);
    useEffect(() => {
        if (!placeId) {
            if (loading)
                setLoading(false);
            return;
        }
        if (fetchedPlaceIdRef.current === placeId) {
            return;
        }
        const abortController = new AbortController();
        const { signal } = abortController;
        function fetchData() {
            return __awaiter$2(this, void 0, void 0, function* () {
                setLoading(true);
                try {
                    const detailedPlace = yield fetchDetails(placeId, signal);
                    if (!signal.aborted) {
                        setPlace(detailedPlace);
                        fetchedPlaceIdRef.current = placeId;
                    }
                }
                catch (error) {
                    if (!signal.aborted) {
                        console.error("Error fetching place details:", error);
                    }
                }
                finally {
                    if (!signal.aborted) {
                        setLoading(false);
                    }
                }
            });
        }
        fetchData();
        return () => {
            abortController.abort();
        };
    }, [placeId]);
    if (loading) {
        return React__default$4.createElement(LoadingSpinner, { loadingText: "Fetching place details..." });
    }
    if (!place) {
        return React__default$4.createElement("p", null,
            "No place details available for ",
            placeId);
    }
    if (compare) {
        // render two side by side
        return (React__default$4.createElement("div", { style: { display: "flex", gap: "20px" } },
            React__default$4.createElement(GoogleBusinessProfile, Object.assign({}, props, { place: place, showBookOnline: false })),
            React__default$4.createElement(GoogleBusinessProfile, Object.assign({}, props, { place: place, showBookOnline: true }))));
    }
    return (React__default$4.createElement(GoogleBusinessProfile, Object.assign({}, props, { place: place, callbacks: {
            handleBookOnlineClick: (_b = props.callbacks) === null || _b === void 0 ? void 0 : _b.handleBookOnlineClick,
        } })));
};

var css_248z$P = ".PlaceList-module_placeList__aDK3a {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.PlaceList-module_selected__CDPdY {\n  background-color: #e0f7fa;\n  border-color: #26c6da;\n}\n\n.PlaceList-module_placeItem__8umce {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n.PlaceList-module_placeItem__8umce:hover {\n  background-color: #f5f5f5;\n}\n.PlaceList-module_placeItem__8umce.PlaceList-module_selected__CDPdY {\n  background-color: #e0f7fa;\n  border-color: #26c6da;\n}\n\n.PlaceList-module_placeNameWrapper__UuBFd {\n  flex: 2;\n  display: flex;\n  align-items: flex-start;\n}\n\n.PlaceList-module_placeName__SVEEO {\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.PlaceList-module_placeDetails__2g-FA {\n  text-align: right;\n  font-size: 0.875rem;\n}\n\n.PlaceList-module_link__Sv0Fg {\n  color: #1a73e8;\n  text-decoration: underline;\n}";
var styles$8 = {"placeList":"PlaceList-module_placeList__aDK3a","selected":"PlaceList-module_selected__CDPdY","placeItem":"PlaceList-module_placeItem__8umce","placeNameWrapper":"PlaceList-module_placeNameWrapper__UuBFd","placeName":"PlaceList-module_placeName__SVEEO","placeDetails":"PlaceList-module_placeDetails__2g-FA","link":"PlaceList-module_link__Sv0Fg"};
styleInject(css_248z$P);

const PlaceListItem = ({ place, onSelect }) => {
    const handleClick = () => {
        if (onSelect) {
            onSelect(place);
        }
    };
    // clean off the query string from the website if it exists
    if (place.website) {
        const url = new URL(place.website);
        place.website = url.origin;
    }
    return (React__default$4.createElement("div", { role: "button", tabIndex: 0, onClick: handleClick, onKeyDown: (e) => (e.key === "Enter" || e.key === " ") && handleClick(), className: `${styles$8.placeItem} ${place.selected ? styles$8.selected : ""}` },
        React__default$4.createElement("div", { className: styles$8.placeNameWrapper },
            React__default$4.createElement("h2", { className: styles$8.placeName }, place.name || "Unnamed Place")),
        React__default$4.createElement("div", { className: styles$8.placeDetails },
            place.formattedAddress && React__default$4.createElement("p", null, place.formattedAddress),
            place.phone && React__default$4.createElement("p", null,
                "\uD83D\uDCDE ",
                place.phone),
            place.website && (React__default$4.createElement("p", null,
                "\uD83C\uDF10 ",
                React__default$4.createElement("span", { className: styles$8.link }, place.website))))));
};
const PlaceList = ({ places, onSelect }) => {
    if (places.length === 0) {
        return React__default$4.createElement("p", null, "No places found.");
    }
    return (React__default$4.createElement("div", { className: styles$8.placeList }, places.map((place) => (React__default$4.createElement(PlaceListItem, { key: place.placeId, place: place, onSelect: onSelect })))));
};

var css_248z$O = "h1 {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 36px;\n  line-height: 44px;\n  font-weight: 500;\n  font-size: 32px;\n}\n\nh2 {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 32px;\n  line-height: 39px;\n  font-weight: 500;\n  font-size: 26px;\n}\n\nh3 {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: 700;\n  font-size: 20px;\n}\n\nh4 {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 18px;\n  line-height: 22px;\n  font-weight: normal;\n  font-size: 18px;\n}\n\n.Header_header__79ire {\n  margin: 0 0 24px;\n  border-bottom: solid 1px var(--divider-color, #061739);\n  display: flex;\n  color: var(--text-color, #000);\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n}\n\n.Header_sticky__94MGO {\n  position: sticky;\n  top: 0;\n  padding: 10px 16px;\n}\n\n.Header_actions__I6j3t {\n  display: flex;\n  flex: 0 1 auto;\n  text-align: right;\n  align-items: center;\n  margin-bottom: 4px;\n}\n.Header_actions__I6j3t > *:last-child {\n  margin-right: 0;\n}";
var style$z = {"header":"Header_header__79ire","sticky":"Header_sticky__94MGO","actions":"Header_actions__I6j3t"};
styleInject(css_248z$O);

const Header = props => {
    var _a, _b;
    const { level, sticky, className } = props;
    const Tag = `h${level || 2}`;
    // get buttons if they exist
    const buttons = ((props === null || props === void 0 ? void 0 : props.buttons) && ((_a = props === null || props === void 0 ? void 0 : props.buttons) === null || _a === void 0 ? void 0 : _a.length) > 0) ? (_b = props === null || props === void 0 ? void 0 : props.buttons) === null || _b === void 0 ? void 0 : _b.map((button, index) => (React__default$4.createElement(Tooltip$5, { content: button.tooltip, key: index },
        React__default$4.createElement(IconButton, { key: index, iconName: button.icon, onClick: button.onClick, disabled: button.disabled })))) : undefined;
    return (React__default$4.createElement(Tag, { style: props.style ? Object.assign({}, props.style) : undefined, className: classNames$1(style$z.header, { [style$z.sticky]: sticky }, { [`${className}`]: !!props.className }) },
        props.children,
        buttons ? (React__default$4.createElement("div", { className: style$z.actions }, buttons)) : React__default$4.createElement(React__default$4.Fragment, null)));
};

var css_248z$N = ".style_header__iAYfS {\n  align-items: center;\n  display: flex;\n  align-items: center;\n}\n\n.style_static__TW113 {\n  position: relative;\n  top: 0;\n  display: flex;\n  flex: 1 1 auto;\n}\n\n.style_title__8HyX- {\n  display: flex;\n  flex: 1 1 auto;\n  padding-right: 1em;\n}\n\n.style_actions__zY-e8 {\n  display: flex;\n  flex: 0 1 auto;\n  text-align: right;\n  align-items: center;\n  margin-bottom: 4px;\n}\n.style_actions__zY-e8 > *:last-child {\n  margin-right: 0;\n}\n\n.style_editor__Xy-N6 {\n  vertical-align: middle;\n  padding-right: 5px;\n}\n.style_editor__Xy-N6 [contenteditable]:focus {\n  outline: 0 solid transparent;\n}";
var style$y = {"header":"style_header__iAYfS","static":"style_static__TW113 style_header__iAYfS","title":"style_title__8HyX-","actions":"style_actions__zY-e8","editor":"style_editor__Xy-N6"};
styleInject(css_248z$N);

/**
 * Header that displays a title.
 *
 * If an onChange callback is provided, the name becomes editable.
 *
 * @param props
 */
const TitleHeader = (props) => {
    const { onChange, value } = props;
    // Static is the opposite of sticky?  I'm not sure what it does to be honest.
    const className = props.static ? style$y.static : style$y.header;
    return (React__default$4.createElement(Header, { sticky: props.sticky, buttons: props.buttons, level: props.level, className: classNames$1(className, props.className), style: props.style },
        typeof value === "string" ? (React__default$4.createElement("div", { className: style$y.title },
            React__default$4.createElement("div", { className: style$y.editor },
                React__default$4.createElement(ContentEditable, { value: value, onChange: onChange })))) : (React__default$4.createElement("div", { className: style$y.title }, value)),
        props.children && React__default$4.createElement("div", { "data-puppet": "page_actions", className: style$y.actions }, props.children)));
};

/**
 * Simple header with a title on the left and optional buttons on the right.
 *
 * @param props
 * @returns
 */
const ViewHeader = (props) => {
    const { children, dirty, value, title, style, onAdd, onBack, onClose, onDelete, onRename, onSave, onToggleJSON, saving, tooltips, isTitleRequired } = props;
    function handleNameChange(name) {
        // determine if value is a jsx element
        if (onRename && typeof value === "object" && typeof value.name === "string") {
            onRename(Object.assign(Object.assign({}, value), { name }));
        }
    }
    function renderName() {
        if (title) {
            if (typeof onBack === "function") {
                return (React__default$4.createElement(React__default$4.Fragment, null,
                    React__default$4.createElement(IconButton, { iconName: "arrow_back", onClick: onBack }),
                    title));
            }
            else {
                return title;
            }
        }
        else if (value) {
            if (typeof onBack === "function") {
                return (React__default$4.createElement(React__default$4.Fragment, null,
                    React__default$4.createElement(IconButton, { iconName: "arrow_back", onClick: onBack }),
                    React__default$4.createElement(ContentEditable, { value: value.name, onChange: onRename ? handleNameChange : undefined, required: isTitleRequired })));
            }
            else {
                return value ? value.name : "";
            }
        }
        else {
            return "";
        }
    }
    return (React__default$4.createElement(TitleHeader, { sticky: props.sticky, level: props.level, value: renderName(), onChange: onRename ? handleNameChange : undefined, style: Object.assign({ top: "0px" }, style), className: props.className },
        typeof onToggleJSON === "function" && (React__default$4.createElement(Tooltip$5, { content: "View JSON" },
            React__default$4.createElement(IconButton, { iconName: "code", onClick: onToggleJSON }))),
        children && (children),
        typeof onDelete === "function" && (React__default$4.createElement(Tooltip$5, { content: (tooltips === null || tooltips === void 0 ? void 0 : tooltips.delete) ? tooltips.delete : "Delete" },
            React__default$4.createElement(IconButton, { iconName: "delete", onClick: onDelete }))),
        typeof onSave === "function" && (React__default$4.createElement(Tooltip$5, { content: (tooltips === null || tooltips === void 0 ? void 0 : tooltips.save) ? tooltips.save : "Save" },
            React__default$4.createElement(IconButton, { color: "primary", iconName: "save", disabled: !dirty || saving, onClick: onSave, style: { width: 25 } }))),
        typeof onAdd === "function" && (React__default$4.createElement(Tooltip$5, { content: (tooltips === null || tooltips === void 0 ? void 0 : tooltips.add) ? tooltips.add : "Add" },
            React__default$4.createElement(IconButton, { iconName: "add", onClick: onAdd }))),
        typeof onClose === "function" && (React__default$4.createElement(Tooltip$5, { content: "Close" },
            React__default$4.createElement(IconButton, { iconName: "close", onClick: onClose })))));
};

var css_248z$M = ".style_row__hRoCU {\n  display: flex;\n  margin: 10px;\n}\n\n.style_inputwrap__7Fygx {\n  flex-grow: 1;\n  padding-right: 1em;\n}\n\n.style_buttonwrap__eTL2o {\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n}";
var style$x = {"row":"style_row__hRoCU","inputwrap":"style_inputwrap__7Fygx","buttonwrap":"style_buttonwrap__eTL2o"};
styleInject(css_248z$M);

const InputAction = (props) => {
    const { buttonProps, inputProps } = props;
    const { onClick } = buttonProps;
    const handleKeyPress = useCallback((event) => {
        if (event && event.key && event.key === "Enter" && onClick) {
            onClick();
        }
    }, [onClick]);
    return (React__default$4.createElement("div", { className: style$x.row },
        React__default$4.createElement("div", { className: style$x.inputwrap },
            React__default$4.createElement(Input$3, Object.assign({ onKeyDown: handleKeyPress }, inputProps))),
        React__default$4.createElement("div", { className: style$x.buttonwrap },
            React__default$4.createElement(Button, Object.assign({}, buttonProps)))));
};

const LanguagePickerInner = props => {
    const langs = useMemo(() => [{
            text: "English",
            value: "en"
        }, {
            text: "Russian",
            value: "ru"
        }, {
            text: "Ukranian",
            value: "ua"
        }], []);
    return (React__default$4.createElement(Dropdown, { value: props.value, onChange: props.onChange, options: langs }));
};
const LanguagePicker = React__default$4.memo(LanguagePickerInner);

var css_248z$L = "/* LeadDetail.module.scss */\n.LeadDetail-module_leadDetail__DxF66 {\n  border: 1px solid #ccc;\n  padding: 16px;\n  border-radius: 6px;\n  font-family: Arial, sans-serif;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_row__yc86L {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_row__yc86L .LeadDetail-module_field__lF0km {\n  flex: 1;\n  min-width: 200px;\n  margin-right: 16px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_row__yc86L .LeadDetail-module_field__lF0km label {\n  font-weight: bold;\n  display: block;\n  margin-bottom: 4px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_row__yc86L .LeadDetail-module_field__lF0km span {\n  display: block;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_row__yc86L .LeadDetail-module_field__lF0km .LeadDetail-module_integrationError__c-AKh {\n  display: block;\n  color: #d32f2f;\n  margin-top: 4px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_row__yc86L .LeadDetail-module_field__lF0km .LeadDetail-module_integrationsList__Kr-wz {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 4px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_row__yc86L .LeadDetail-module_field__lF0km .LeadDetail-module_integrationItem__2ieLx {\n  display: inline-flex;\n  flex-direction: column;\n  background-color: #f5f5f5;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n.LeadDetail-module_leadDetail__DxF66 h3 {\n  margin-bottom: 8px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_transcript__HDbgi .LeadDetail-module_message__d0RF3 {\n  margin-bottom: 12px;\n  padding: 8px;\n  border-radius: 4px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_transcript__HDbgi .LeadDetail-module_message__d0RF3.LeadDetail-module_bot__zSgek {\n  background-color: #f0f0f0;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_transcript__HDbgi .LeadDetail-module_message__d0RF3.LeadDetail-module_user__n55Gf {\n  background-color: #e6f7ff;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_transcript__HDbgi .LeadDetail-module_message__d0RF3 .LeadDetail-module_messageHeader__DN4lQ {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-bottom: 4px;\n  color: #555;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_transcript__HDbgi .LeadDetail-module_message__d0RF3 .LeadDetail-module_messageHeader__DN4lQ .LeadDetail-module_messageFrom__n3Paa {\n  font-weight: bold;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_transcript__HDbgi .LeadDetail-module_message__d0RF3 .LeadDetail-module_messageContent__Adl7h {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_emailThread__-09Gg .LeadDetail-module_emailMessage__iCIgd {\n  margin-bottom: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  overflow: hidden;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_emailThread__-09Gg .LeadDetail-module_emailMessage__iCIgd.LeadDetail-module_emailInbound__C9Vp5 {\n  border-left: 3px solid #1976d2;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_emailThread__-09Gg .LeadDetail-module_emailMessage__iCIgd.LeadDetail-module_emailOutbound__Onycs {\n  border-left: 3px solid #9e9e9e;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_emailThread__-09Gg .LeadDetail-module_emailMessage__iCIgd .LeadDetail-module_emailHeader__hQyHf {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 12px;\n  background-color: #fafafa;\n  border-bottom: 1px solid #eee;\n  font-size: 12px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_emailThread__-09Gg .LeadDetail-module_emailMessage__iCIgd .LeadDetail-module_emailHeader__hQyHf .LeadDetail-module_emailMeta__9NNf8 {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_emailThread__-09Gg .LeadDetail-module_emailMessage__iCIgd .LeadDetail-module_emailHeader__hQyHf .LeadDetail-module_emailFrom__x2brO {\n  font-weight: 600;\n  color: #333;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_emailThread__-09Gg .LeadDetail-module_emailMessage__iCIgd .LeadDetail-module_emailHeader__hQyHf .LeadDetail-module_emailTo__bBhb7 {\n  color: #888;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_emailThread__-09Gg .LeadDetail-module_emailMessage__iCIgd .LeadDetail-module_emailHeader__hQyHf .LeadDetail-module_emailTime__u1-ac {\n  color: #888;\n  white-space: nowrap;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_emailThread__-09Gg .LeadDetail-module_emailMessage__iCIgd .LeadDetail-module_emailBody__0a-m1 {\n  padding: 12px;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  font-size: 13px;\n  line-height: 1.5;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_summary__UTKZu {\n  background-color: #f9f9f9;\n  padding: 8px;\n  border-radius: 4px;\n  white-space: pre-wrap;\n  font-family: monospace;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditIntegration__V4A6e {\n  margin-bottom: 12px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditIntegration__V4A6e:last-child {\n  margin-bottom: 0;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditIntegrationHeader__sKStc {\n  font-weight: bold;\n  font-size: 13px;\n  margin-bottom: 6px;\n  text-transform: capitalize;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN th, .LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN td {\n  text-align: left;\n  padding: 4px 8px;\n  border-bottom: 1px solid #eee;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN th {\n  font-weight: 600;\n  color: #555;\n  background-color: #fafafa;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN .LeadDetail-module_auditUrl__nG6T- {\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN .LeadDetail-module_auditError__-evZ9 {\n  color: #d32f2f;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN .LeadDetail-module_auditErrorMessage__GV6qH {\n  font-size: 11px;\n  color: #d32f2f;\n  margin-top: 2px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN .LeadDetail-module_auditRowClickable__R5V7y {\n  cursor: pointer;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN .LeadDetail-module_auditRowClickable__R5V7y:hover {\n  background-color: #f5f5f5;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN .LeadDetail-module_auditExpandIcon__JLIoe {\n  font-size: 10px;\n  margin-right: 4px;\n  color: #888;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditTable__KbulN .LeadDetail-module_auditDetailRow__mNeCw td {\n  padding: 0;\n  border-bottom: 1px solid #ddd;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditPayloads__Olp0o {\n  padding: 8px 12px;\n  background-color: #fafafa;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditStepDescription__n3yvD {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 8px;\n  font-style: italic;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditPayloadColumns__cXrhl {\n  display: flex;\n  gap: 12px;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditPayloadColumn__st8LH {\n  flex: 1;\n  min-width: 0;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditPayloadLabel__hLNht {\n  font-size: 11px;\n  font-weight: 600;\n  color: #555;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditPayloadContent__l9xnQ {\n  background-color: #f0f0f0;\n  padding: 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-family: monospace;\n  white-space: pre-wrap;\n  word-break: break-all;\n  max-height: 300px;\n  overflow-y: auto;\n  margin: 0 0 8px 0;\n}\n.LeadDetail-module_leadDetail__DxF66 .LeadDetail-module_auditTrail__mqsiA .LeadDetail-module_auditPayloadEmpty__hq3rz {\n  font-size: 11px;\n  color: #999;\n  font-style: italic;\n}";
var styles$7 = {"leadDetail":"LeadDetail-module_leadDetail__DxF66","row":"LeadDetail-module_row__yc86L","field":"LeadDetail-module_field__lF0km","integrationError":"LeadDetail-module_integrationError__c-AKh","integrationsList":"LeadDetail-module_integrationsList__Kr-wz","integrationItem":"LeadDetail-module_integrationItem__2ieLx","transcript":"LeadDetail-module_transcript__HDbgi","message":"LeadDetail-module_message__d0RF3","bot":"LeadDetail-module_bot__zSgek","user":"LeadDetail-module_user__n55Gf","messageHeader":"LeadDetail-module_messageHeader__DN4lQ","messageFrom":"LeadDetail-module_messageFrom__n3Paa","messageContent":"LeadDetail-module_messageContent__Adl7h","emailThread":"LeadDetail-module_emailThread__-09Gg","emailMessage":"LeadDetail-module_emailMessage__iCIgd","emailInbound":"LeadDetail-module_emailInbound__C9Vp5","emailOutbound":"LeadDetail-module_emailOutbound__Onycs","emailHeader":"LeadDetail-module_emailHeader__hQyHf","emailMeta":"LeadDetail-module_emailMeta__9NNf8","emailFrom":"LeadDetail-module_emailFrom__x2brO","emailTo":"LeadDetail-module_emailTo__bBhb7","emailTime":"LeadDetail-module_emailTime__u1-ac","emailBody":"LeadDetail-module_emailBody__0a-m1","summary":"LeadDetail-module_summary__UTKZu","auditTrail":"LeadDetail-module_auditTrail__mqsiA","auditIntegration":"LeadDetail-module_auditIntegration__V4A6e","auditIntegrationHeader":"LeadDetail-module_auditIntegrationHeader__sKStc","auditTable":"LeadDetail-module_auditTable__KbulN","auditUrl":"LeadDetail-module_auditUrl__nG6T-","auditError":"LeadDetail-module_auditError__-evZ9","auditErrorMessage":"LeadDetail-module_auditErrorMessage__GV6qH","auditRowClickable":"LeadDetail-module_auditRowClickable__R5V7y","auditExpandIcon":"LeadDetail-module_auditExpandIcon__JLIoe","auditDetailRow":"LeadDetail-module_auditDetailRow__mNeCw","auditPayloads":"LeadDetail-module_auditPayloads__Olp0o","auditStepDescription":"LeadDetail-module_auditStepDescription__n3yvD","auditPayloadColumns":"LeadDetail-module_auditPayloadColumns__cXrhl","auditPayloadColumn":"LeadDetail-module_auditPayloadColumn__st8LH","auditPayloadLabel":"LeadDetail-module_auditPayloadLabel__hLNht","auditPayloadContent":"LeadDetail-module_auditPayloadContent__l9xnQ","auditPayloadEmpty":"LeadDetail-module_auditPayloadEmpty__hq3rz"};
styleInject(css_248z$L);

const LEAD_SOURCE_LABELS = {
    widget: "Chat Widget",
    "chat-widget": "Chat Widget",
    chat: "Chat Widget",
    form: "Form",
    "form-widget": "Form",
    email: "Email",
    phone: "Phone",
};

// LeadDetail.tsx
const formatPayload = (body) => {
    if (!body)
        return '';
    try {
        return JSON.stringify(JSON.parse(body), null, 2);
    }
    catch (_a) {
        return body;
    }
};
const renderHeaders = (headers) => {
    if (!headers || typeof headers !== 'object' || Array.isArray(headers))
        return '';
    return Object.entries(headers)
        .map(([k, v]) => `${k}: ${v}`)
        .join('\n');
};
const LeadDetail = (props) => {
    var _a, _b, _c, _d, _e;
    const { lead } = props;
    const [expandedRows, setExpandedRows] = useState(new Set());
    const toggleRow = useCallback((key) => {
        setExpandedRows((prev) => {
            const next = new Set(prev);
            if (next.has(key)) {
                next.delete(key);
            }
            else {
                next.add(key);
            }
            return next;
        });
    }, []);
    const { source, channel, lead: leadData } = lead;
    const leadDateTime = lead.date;
    const formattedLeadDateTime = new Date(leadDateTime).toLocaleString();
    const formattedLeadSource = source ? ((_a = LEAD_SOURCE_LABELS[source]) !== null && _a !== void 0 ? _a : source) : 'Unknown';
    // Helper function to format date strings
    const formatDate = (dateString) => new Date(dateString).toLocaleString();
    // Extract specific fields
    const getField = (fieldName) => { var _a; return ((_a = leadData === null || leadData === void 0 ? void 0 : leadData.fields.find((field) => field.name === fieldName)) === null || _a === void 0 ? void 0 : _a.value) || ''; };
    const transcriptRaw = (leadData === null || leadData === void 0 ? void 0 : leadData.transcript) || [];
    // filter, remove empty messages and messages that equal "Launch"
    const transcript = transcriptRaw.filter((msg) => msg.message && msg.message !== 'Launch');
    const fullName = getField('FULL_NAME') || `${getField('FIRST_NAME')} ${getField('LAST_NAME')}`.trim() || 'N/A';
    const phone = getField('PHONE') || 'N/A';
    const email = getField('EMAIL') || 'N/A';
    const addressRaw = getField('ADDRESS');
    const zipCode = getField('ZIP_CODE') || getField('ZIP') || getField('POSTAL_CODE');
    const address = addressRaw || zipCode || 'N/A';
    const message = getField('MESSAGE') || 'N/A';
    let preferredDate = getField('DATETIME');
    // preferredData is ISO-8601 format, convert to just date, month/date/year
    if (preferredDate) {
        const date = new Date(preferredDate);
        preferredDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    }
    const preferredTime = getField('PREFERRED_TIME');
    let preferredDateTime = `${preferredDate}`;
    // combine preferredDate and preferredTime, only display value if provided
    if (preferredTime) {
        preferredDateTime += ` ${preferredTime}`;
    }
    preferredDateTime = preferredDateTime.trim() || 'N/A';
    // Sent to integrations
    const integrationsSent = (lead === null || lead === void 0 ? void 0 : lead.integrationSent) || [];
    return (React__default$4.createElement("div", { className: styles$7.leadDetail },
        React__default$4.createElement("div", { className: styles$7.row },
            React__default$4.createElement("div", { className: styles$7.field },
                React__default$4.createElement("small", null,
                    "Source:",
                    formattedLeadSource)),
            React__default$4.createElement("div", { className: styles$7.field },
                React__default$4.createElement("small", null,
                    "Sent To Integration",
                    integrationsSent.length > 1 ? 's' : '',
                    ":"),
                integrationsSent.length === 0 ? (React__default$4.createElement("small", { className: styles$7.integrationItem }, "N/A")) : (React__default$4.createElement("div", { className: styles$7.integrationsList }, integrationsSent.map((integration, index) => (React__default$4.createElement("div", { key: index, className: styles$7.integrationItem },
                    React__default$4.createElement("small", null, integration.integrationId),
                    integration.wasError && (React__default$4.createElement("small", { className: styles$7.integrationError },
                        "Error: ",
                        integration.errorName || 'Unknown',
                        integration.errorMessage ? ` - ${integration.errorMessage}` : '')))))))),
            React__default$4.createElement("div", { className: styles$7.field },
                React__default$4.createElement("small", null,
                    "Received:",
                    formattedLeadDateTime))),
        React__default$4.createElement("div", { className: styles$7.row },
            React__default$4.createElement("div", { className: styles$7.field },
                React__default$4.createElement("label", null, "Name:"),
                React__default$4.createElement("span", null, fullName)),
            React__default$4.createElement("div", { className: styles$7.field },
                React__default$4.createElement("label", null, "Phone:"),
                React__default$4.createElement("span", null, phone)),
            React__default$4.createElement("div", { className: styles$7.field },
                React__default$4.createElement("label", null, "Email:"),
                React__default$4.createElement("span", null, email))),
        React__default$4.createElement("div", { className: styles$7.row },
            React__default$4.createElement("div", { className: styles$7.field },
                React__default$4.createElement("label", null, "Address:"),
                React__default$4.createElement("span", null, address))),
        React__default$4.createElement("div", { className: styles$7.row },
            React__default$4.createElement("div", { className: styles$7.field },
                React__default$4.createElement("label", null, "Message:"),
                React__default$4.createElement("span", null, message))),
        (!!preferredDate || !!preferredTime) && (React__default$4.createElement("div", { className: styles$7.row },
            React__default$4.createElement("div", { className: styles$7.field },
                React__default$4.createElement("label", null, "Prefferred Date & Time:"),
                React__default$4.createElement("span", null, preferredDateTime)))),
        (lead.urgency || lead.contactType || lead.serviceType || lead.jobType || lead.environment || lead.referringSource) && (React__default$4.createElement(React__default$4.Fragment, null,
            React__default$4.createElement("div", { className: styles$7.row },
                lead.urgency && (React__default$4.createElement("div", { className: styles$7.field },
                    React__default$4.createElement("label", null, "Urgency:"),
                    React__default$4.createElement("span", null, lead.urgency))),
                lead.contactType && (React__default$4.createElement("div", { className: styles$7.field },
                    React__default$4.createElement("label", null, "Contact Type:"),
                    React__default$4.createElement("span", null, lead.contactType))),
                lead.serviceType && (React__default$4.createElement("div", { className: styles$7.field },
                    React__default$4.createElement("label", null, "Service Type:"),
                    React__default$4.createElement("span", null, lead.serviceType)))),
            React__default$4.createElement("div", { className: styles$7.row },
                lead.jobType && (React__default$4.createElement("div", { className: styles$7.field },
                    React__default$4.createElement("label", null, "Job Type:"),
                    React__default$4.createElement("span", null, lead.jobType))),
                lead.environment && (React__default$4.createElement("div", { className: styles$7.field },
                    React__default$4.createElement("label", null, "Environment:"),
                    React__default$4.createElement("span", null, lead.environment))),
                lead.referringSource && (React__default$4.createElement("div", { className: styles$7.field },
                    React__default$4.createElement("label", null, "Referring Source:"),
                    React__default$4.createElement("span", null, lead.referringSource)))))),
        integrationsSent.some((i) => { var _a, _b; return (_b = (_a = i.auditTrail) === null || _a === void 0 ? void 0 : _a.summary) === null || _b === void 0 ? void 0 : _b.length; }) && (React__default$4.createElement(Accordion, { title: "Integration Audit Trail" },
            React__default$4.createElement("div", { className: styles$7.auditTrail }, integrationsSent.map((integration) => {
                var _a, _b;
                const entries = (_a = integration.auditTrail) === null || _a === void 0 ? void 0 : _a.summary;
                const details = (_b = integration.auditTrail) === null || _b === void 0 ? void 0 : _b.details;
                if (!(entries === null || entries === void 0 ? void 0 : entries.length))
                    return null;
                return (React__default$4.createElement("div", { key: integration.integrationId, className: styles$7.auditIntegration },
                    React__default$4.createElement("div", { className: styles$7.auditIntegrationHeader }, integration.integrationId.replace(/[-_]/g, ' ')),
                    React__default$4.createElement("table", { className: styles$7.auditTable, "aria-label": `Audit trail for ${integration.integrationId}` },
                        React__default$4.createElement("thead", null,
                            React__default$4.createElement("tr", null,
                                React__default$4.createElement("th", null, "Method"),
                                React__default$4.createElement("th", null, "URL"),
                                React__default$4.createElement("th", null, "Status"),
                                React__default$4.createElement("th", null, "Duration"),
                                React__default$4.createElement("th", null, "Timestamp"))),
                        React__default$4.createElement("tbody", null, entries.map((entry, idx) => {
                            const rowKey = `${integration.integrationId}-${idx}`;
                            const detail = details === null || details === void 0 ? void 0 : details[idx];
                            const hasPayload = detail && (detail.requestBody || detail.responseBody ||
                                detail.requestHeaders || detail.responseHeaders);
                            const isExpanded = expandedRows.has(rowKey);
                            return (React__default$4.createElement(React__default$4.Fragment, { key: `${entry.timestamp}-${entry.method}-${idx}` },
                                React__default$4.createElement("tr", { className: classNames$1({
                                        [styles$7.auditError]: entry.wasError,
                                        [styles$7.auditRowClickable]: !!hasPayload
                                    }), onClick: hasPayload ? () => toggleRow(rowKey) : undefined },
                                    React__default$4.createElement("td", null,
                                        hasPayload && React__default$4.createElement("span", { className: styles$7.auditExpandIcon }, isExpanded ? '▼' : '▶'),
                                        entry.method),
                                    React__default$4.createElement("td", { className: styles$7.auditUrl, title: entry.url }, entry.url),
                                    React__default$4.createElement("td", null,
                                        entry.statusCode || '—',
                                        entry.wasError && entry.errorMessage && (React__default$4.createElement("div", { className: styles$7.auditErrorMessage }, entry.errorMessage))),
                                    React__default$4.createElement("td", null,
                                        entry.durationMs,
                                        "ms"),
                                    React__default$4.createElement("td", null, entry.timestamp ? new Date(entry.timestamp).toLocaleString() : '—')),
                                isExpanded && detail && (React__default$4.createElement("tr", { className: styles$7.auditDetailRow },
                                    React__default$4.createElement("td", { colSpan: 5 },
                                        React__default$4.createElement("div", { className: styles$7.auditPayloads },
                                            detail.stepDescription && (React__default$4.createElement("div", { className: styles$7.auditStepDescription }, detail.stepDescription)),
                                            React__default$4.createElement("div", { className: styles$7.auditPayloadColumns },
                                                React__default$4.createElement("div", { className: styles$7.auditPayloadColumn },
                                                    React__default$4.createElement("div", { className: styles$7.auditPayloadLabel }, "Request"),
                                                    detail.requestHeaders && (React__default$4.createElement("pre", { className: styles$7.auditPayloadContent }, renderHeaders(detail.requestHeaders))),
                                                    detail.requestBody && (React__default$4.createElement("pre", { className: styles$7.auditPayloadContent }, formatPayload(detail.requestBody))),
                                                    !detail.requestHeaders && !detail.requestBody && (React__default$4.createElement("div", { className: styles$7.auditPayloadEmpty }, "No request data"))),
                                                React__default$4.createElement("div", { className: styles$7.auditPayloadColumn },
                                                    React__default$4.createElement("div", { className: styles$7.auditPayloadLabel }, "Response"),
                                                    detail.responseHeaders && (React__default$4.createElement("pre", { className: styles$7.auditPayloadContent }, renderHeaders(detail.responseHeaders))),
                                                    detail.responseBody && (React__default$4.createElement("pre", { className: styles$7.auditPayloadContent }, formatPayload(detail.responseBody))),
                                                    !detail.responseHeaders && !detail.responseBody && (React__default$4.createElement("div", { className: styles$7.auditPayloadEmpty }, "No response data"))))))))));
                        })))));
            })))),
        (source === 'widget' || source === 'chat-widget') && transcript.length > 0 && (React__default$4.createElement(React__default$4.Fragment, null,
            React__default$4.createElement("h3", null, "Transcript"),
            React__default$4.createElement("div", { className: styles$7.transcript }, transcript.map((msg, index) => {
                var _a;
                const isBot = ((_a = msg === null || msg === void 0 ? void 0 : msg.from) === null || _a === void 0 ? void 0 : _a.id) === 'bot';
                const botName = props.botName || 'Bot';
                const user = fullName || 'User';
                return (React__default$4.createElement("div", { key: index, className: `${styles$7.message} ${isBot ? styles$7.bot : styles$7.user}` },
                    React__default$4.createElement("div", { className: styles$7.messageHeader },
                        React__default$4.createElement("span", { className: styles$7.messageFrom }, isBot ? botName : user),
                        React__default$4.createElement("span", { className: styles$7.messageTime }, formatDate(msg.createdTime))),
                    React__default$4.createElement("div", { className: styles$7.messageContent }, msg.message)));
            })))),
        (source === 'email' || channel === 'email') && ((_d = (_c = (_b = lead.emailThread) === null || _b === void 0 ? void 0 : _b.messages) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0 && (React__default$4.createElement(React__default$4.Fragment, null,
            React__default$4.createElement("h3", null, "Email Thread"),
            React__default$4.createElement("div", { className: styles$7.emailThread }, lead.emailThread.messages.map((msg, index) => {
                var _a, _b, _c, _d;
                const isOutbound = msg.role === 'assistant' || msg.role === 'bot' || msg.role === 'system';
                const senderName = isOutbound
                    ? (props.botName || 'Auto-Reply')
                    : (((_a = lead.emailThread) === null || _a === void 0 ? void 0 : _a.customerName) || ((_b = lead.emailThread) === null || _b === void 0 ? void 0 : _b.customerEmail) || fullName || 'Customer');
                const recipientName = isOutbound
                    ? (((_c = lead.emailThread) === null || _c === void 0 ? void 0 : _c.customerName) || ((_d = lead.emailThread) === null || _d === void 0 ? void 0 : _d.customerEmail) || 'Customer')
                    : (props.botName || 'System');
                const messageClass = classNames$1(styles$7.emailMessage, {
                    [styles$7.emailInbound]: !isOutbound,
                    [styles$7.emailOutbound]: isOutbound,
                });
                return (React__default$4.createElement("div", { key: msg.id || `${msg.timestamp}-${index}`, className: messageClass },
                    React__default$4.createElement("div", { className: styles$7.emailHeader },
                        React__default$4.createElement("div", { className: styles$7.emailMeta },
                            React__default$4.createElement("span", { className: styles$7.emailFrom },
                                React__default$4.createElement("span", { "aria-hidden": "true" }, isOutbound ? '📤 ' : '📨 '),
                                senderName),
                            React__default$4.createElement("span", { className: styles$7.emailTo },
                                "\u2192 ",
                                recipientName)),
                        React__default$4.createElement("span", { className: styles$7.emailTime }, formatDate(msg.timestamp))),
                    React__default$4.createElement("div", { className: styles$7.emailBody }, msg.content || '(no content)')));
            })))),
        source === 'form-widget' && (leadData === null || leadData === void 0 ? void 0 : leadData.transcript) && (React__default$4.createElement(React__default$4.Fragment, null,
            React__default$4.createElement(Accordion, { title: "Raw Details" },
                React__default$4.createElement("pre", { className: styles$7.summary }, ((_e = leadData === null || leadData === void 0 ? void 0 : leadData.transcript[0]) === null || _e === void 0 ? void 0 : _e.message) || 'No summary available.'),
                lead.analysis && (React__default$4.createElement("div", { style: { marginTop: '16px' } },
                    React__default$4.createElement("h4", { style: { marginBottom: '8px', fontSize: '14px', fontWeight: 600 } }, "AI Analysis (for debugging)"),
                    React__default$4.createElement("pre", { className: styles$7.summary }, lead.analysis))))))));
};

var css_248z$K = "@keyframes LoadingProgressBar_load__koMhq {\n  0% {\n    left: -500px;\n  }\n  50% {\n    left: 100%;\n  }\n  100% {\n    left: -500px;\n  }\n}\n.LoadingProgressBar_loading__e7Emf {\n  position: relative;\n  overflow: hidden;\n  width: 150px;\n  height: 32px;\n  margin-right: 32px;\n  background: #f1f3f4;\n}\n.LoadingProgressBar_loading__e7Emf:before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: -500px;\n  top: 0;\n  height: 100%;\n  width: 500px;\n  background: #dadada;\n  animation: LoadingProgressBar_load__koMhq 3000ms ease-in-out infinite;\n}";
var style$w = {"loading":"LoadingProgressBar_loading__e7Emf","load":"LoadingProgressBar_load__koMhq"};
styleInject(css_248z$K);

const LoadingProgressBar = props => {
    return React__default$4.createElement("div", { className: style$w.loading });
};

var css_248z$J = ".LoadingTrainer-module_container__jT4NW {\n  background-color: black;\n  color: #00ff00;\n  font-family: monospace;\n  padding: 20px;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.LoadingTrainer-module_logsContainer__oL-de {\n  flex: 1;\n  overflow: hidden;\n}\n\n.LoadingTrainer-module_logs__UXhyf {\n  overflow-y: auto;\n  height: 100%;\n  white-space: pre-wrap;\n  line-height: 1.5;\n}\n\n.LoadingTrainer-module_completeMessage__EBkQi {\n  text-align: center;\n  color: white;\n  margin-top: 20px;\n  font-weight: bold;\n}";
var styles$6 = {"container":"LoadingTrainer-module_container__jT4NW","logsContainer":"LoadingTrainer-module_logsContainer__oL-de","logs":"LoadingTrainer-module_logs__UXhyf","completeMessage":"LoadingTrainer-module_completeMessage__EBkQi"};
styleInject(css_248z$J);

const LoadingTrainer = ({ place, loadingTime }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const totalSteps = Math.ceil(loadingTime / 300); // Generates logs every 300ms
        let step = 0;
        const interval = setInterval(() => {
            var _a, _b, _c, _d, _e;
            if (step >= totalSteps) {
                clearInterval(interval);
                setLoading(false);
                return;
            }
            const randomData = [
                `Processing: ${(_a = place.name) !== null && _a !== void 0 ? _a : "[UNKNOWN]"}`,
                `Analyzing Location ID: ${(_c = (_b = place.placeId) === null || _b === void 0 ? void 0 : _b.slice(0, 6)) !== null && _c !== void 0 ? _c : "[REDACTED]"}...`,
                `Fetching: ${(_d = place.mapsUrl) !== null && _d !== void 0 ? _d : "URL_NOT_FOUND"}`,
                `Compiling AI model with rating: ${(_e = place.rating) !== null && _e !== void 0 ? _e : "N/A"}`,
                `Applying ML Weighting Factors...`,
                `Calibrating Neural Layers...`,
                `Checksum Verification: ${Math.random().toString(36).slice(2, 10)}`,
                `Data Hash: ${Math.random().toString(16).slice(2, 12)}`,
                `Generating AI Insight Matrix...`,
                `Data Validation Status: ${Math.random() > 0.2 ? "PASSED" : "FAILED"}`,
                `Memory Allocation: ${Math.floor(Math.random() * 100)}MB`,
                `Training Node: ${Math.floor(Math.random() * 256)}`,
                `Backpropagating Error: ${Math.random().toFixed(5)}`,
                `Updating Tensor Map...`,
                `Debug Mode: ${Math.random() > 0.5 ? "ENABLED" : "DISABLED"}`,
            ];
            setLogs((prevLogs) => [...prevLogs, randomData[Math.floor(Math.random() * randomData.length)]]);
            step++;
        }, 300);
        return () => clearInterval(interval);
    }, [place, loadingTime]);
    return (React__default$4.createElement("div", { className: styles$6.container },
        React__default$4.createElement("div", { className: styles$6.logsContainer },
            React__default$4.createElement("div", { className: styles$6.logs }, logs.map((log, index) => (React__default$4.createElement("div", { key: index }, log))))),
        !loading && React__default$4.createElement("div", { className: styles$6.completeMessage }, "AI Training Complete")));
};

var css_248z$I = ".style_loginWrapper__CH442 {\n  width: 80%;\n  text-align: center;\n  margin: auto;\n}\n.style_loginWrapper__CH442 p {\n  color: #242427;\n  font-size: 15px;\n}\n\n.style_headerWrapper__J0EDw {\n  padding-bottom: 20px;\n}\n.style_headerWrapper__J0EDw h3 {\n  font-size: 30px;\n  padding-bottom: 5px;\n  margin-bottom: 0px;\n  line-height: 40px;\n}\n.style_headerWrapper__J0EDw p {\n  margin-top: 0px;\n  font-size: 20px;\n}\n\n.style_socialButtonsWrapper__LTadN {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.style_marginbuttons__IFRVp {\n  margin-top: 40px;\n  margin-bottom: 0px;\n  margin-left: 0px;\n  margin-right: 0px;\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n}\n@media screen and (max-width: 600px) {\n  .style_marginbuttons__IFRVp {\n    margin-top: 45px;\n  }\n}\n@media screen and (max-width: 400px) {\n  .style_marginbuttons__IFRVp {\n    margin-top: 65px;\n  }\n}\n\n.style_st12__1xNkL {\n  fill: #F6B704;\n}\n\n.style_st13__1JvlZ {\n  fill: #E54335;\n}\n\n.style_st14__HlwZ7 {\n  fill: #4280EF;\n}\n\n.style_st15__KdaKu {\n  fill: #34A353;\n}\n\n.style_gsiMaterialButton__2s4YU {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -webkit-appearance: none;\n  background-color: WHITE;\n  background-image: none;\n  border: 1px solid #747775;\n  border-radius: 4px;\n  box-sizing: border-box;\n  color: #1f1f1f;\n  cursor: pointer;\n  font-family: \"Roboto\", arial, sans-serif;\n  font-size: 16px;\n  height: 40px;\n  letter-spacing: 0.25px;\n  outline: none;\n  overflow: hidden;\n  padding: 0 12px;\n  position: relative;\n  text-align: center;\n  transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: auto;\n  max-width: 400px;\n  min-width: min-content;\n}\n.style_gsiMaterialButton__2s4YU:disabled {\n  cursor: default;\n  background-color: rgba(255, 255, 255, 0.3803921569);\n  border-color: rgba(31, 31, 31, 0.1215686275);\n}\n.style_gsiMaterialButton__2s4YU:disabled .style_gsiMaterialButtonContents__TRU5J,\n.style_gsiMaterialButton__2s4YU:disabled .style_gsiMaterialButtonIcon__0v-BS {\n  opacity: 38%;\n}\n.style_gsiMaterialButton__2s4YU:not(:disabled):active .style_gsiMaterialButtonState__N7zj7, .style_gsiMaterialButton__2s4YU:not(:disabled):focus .style_gsiMaterialButtonState__N7zj7 {\n  background-color: #303030;\n  opacity: 12%;\n}\n.style_gsiMaterialButton__2s4YU:not(:disabled):hover {\n  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\n}\n.style_gsiMaterialButton__2s4YU:not(:disabled):hover .style_gsiMaterialButtonState__N7zj7 {\n  background-color: #303030;\n  opacity: 8%;\n}\n.style_gsiMaterialButton__2s4YU .style_gsiMaterialButtonState__N7zj7 {\n  transition: opacity 0.218s;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.style_gsiMaterialButton__2s4YU .style_gsiMaterialButtonContentWrapper__oH2TR {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  height: 100%;\n  position: relative;\n  width: 100%;\n}\n.style_gsiMaterialButton__2s4YU .style_gsiMaterialButtonContentWrapper__oH2TR .style_gsiMaterialButtonIcon__0v-BS {\n  height: 20px;\n  margin-left: 10px;\n  margin-right: 15px;\n  min-width: 20px;\n  width: 20px;\n}\n.style_gsiMaterialButton__2s4YU .style_gsiMaterialButtonContentWrapper__oH2TR .style_gsiMaterialButtonContents__TRU5J {\n  flex-grow: 1;\n  font-family: \"Roboto\", arial, sans-serif;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: top;\n}\n\n.style_facebookLoginBtn__jI2XB {\n  background-color: #1877F2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-family: Arial, sans-serif;\n  font-size: 16px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n.style_facebookLoginBtn__jI2XB:hover {\n  background-color: #165DB6;\n}\n.style_facebookLoginBtn__jI2XB:focus {\n  outline: 2px solid #FFF;\n  outline-offset: 2px;\n}\n.style_facebookLoginBtn__jI2XB:disabled {\n  background-color: #D3D3D3;\n  cursor: not-allowed;\n}\n\n.style_facebookLogo__R0cPj {\n  width: 24px;\n  height: 24px;\n}\n\n.style_emailLoginBtn__PPqxU {\n  background-color: rgb(26, 167, 220);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-family: \"Roboto\", system-ui, sans-serif;\n  font-size: 16px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  width: 245px;\n}\n\n.style_backToOptionsBtn__PVvaT {\n  background-color: rgb(26, 167, 220);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-family: \"Roboto\", system-ui, sans-serif;\n  font-size: 16px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  width: 245px;\n}";
var style$v = {"loginWrapper":"style_loginWrapper__CH442","headerWrapper":"style_headerWrapper__J0EDw","socialButtonsWrapper":"style_socialButtonsWrapper__LTadN","marginbuttons":"style_marginbuttons__IFRVp","st12":"style_st12__1xNkL","st13":"style_st13__1JvlZ","st14":"style_st14__HlwZ7","st15":"style_st15__KdaKu","gsiMaterialButton":"style_gsiMaterialButton__2s4YU","gsiMaterialButtonContents":"style_gsiMaterialButtonContents__TRU5J","gsiMaterialButtonIcon":"style_gsiMaterialButtonIcon__0v-BS","gsiMaterialButtonState":"style_gsiMaterialButtonState__N7zj7","gsiMaterialButtonContentWrapper":"style_gsiMaterialButtonContentWrapper__oH2TR","facebookLoginBtn":"style_facebookLoginBtn__jI2XB","facebookLogo":"style_facebookLogo__R0cPj","emailLoginBtn":"style_emailLoginBtn__PPqxU","backToOptionsBtn":"style_backToOptionsBtn__PVvaT"};
styleInject(css_248z$I);

// TODO: THis is actually for signing up, not logging in, maybe change it to authentication instead
const LoginForm = ({ className, footer, hideFields, initialData, onDisabledClick, onFacebookSubmit, onGoogleSubmit, onSubmit, passwordRequirements, resetData, subtitle, title, urlSignIn, }) => {
    hideFields = hideFields || {};
    const [data, setData] = useState(Object.assign({}, initialData));
    const [emailValid, setEmailValid] = useState(false);
    const [websiteValid, setWebsiteValid] = useState(false);
    const [passwordValid, setPasswordValid] = useState(false);
    const [formVisible, hideForm, showForm] = useBoolState(false);
    // Quick validity check, email and website should be valid and we should have a first name and password
    let notValid = !emailValid || !data.password || !passwordValid;
    if (!hideFields.website && !websiteValid) {
        notValid = true;
    }
    if (!hideFields.firstName && !data.firstName) {
        notValid = true;
    }
    if (!hideFields.fullName && !data.fullName) {
        notValid = true;
    }
    const handleWebsiteChange = useCallback((value, valid) => {
        setData(Object.assign(Object.assign({}, data), { website: value }));
        setWebsiteValid(valid);
    }, [data]);
    const handleEmailChange = useCallback((value, valid) => {
        setData(Object.assign(Object.assign({}, data), { email: value }));
        setEmailValid(valid);
    }, [data]);
    const handlePasswordChange = useCallback((value, valid) => {
        setData(Object.assign(Object.assign({}, data), { password: value }));
        setPasswordValid(valid);
    }, [data]);
    useEffect(() => {
        if (resetData) {
            setData({});
        }
    }, [resetData]);
    const handleDisabledClick = useCallback((e) => {
        if (notValid && typeof onDisabledClick === "function") {
            onDisabledClick(data);
        }
    }, [data, notValid, onDisabledClick]);
    const handleSubmit = () => {
        onSubmit(data);
    };
    return (React__default$4.createElement("div", { className: classNames$1(style$v.loginWrapper, className) },
        React__default$4.createElement("div", { className: style$v.headerWrapper },
            React__default$4.createElement("h3", null, title),
            React__default$4.createElement("p", null, subtitle)),
        !formVisible ? (React__default$4.createElement("div", { className: style$v.socialButtonsWrapper },
            typeof onGoogleSubmit === "function" ? (React__default$4.createElement("button", { className: style$v.gsiMaterialButton, style: { width: "245px" }, onClick: onGoogleSubmit },
                React__default$4.createElement("div", { className: style$v.gsiMaterialButtonState }),
                React__default$4.createElement("div", { className: style$v.gsiMaterialButtonContentWrapper },
                    React__default$4.createElement("div", { className: style$v.gsiMaterialButtonIcon },
                        React__default$4.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", xmlnsXlink: "http://www.w3.org/1999/xlink", style: { display: "block" } },
                            React__default$4.createElement("path", { fill: "#EA4335", d: "M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" }),
                            React__default$4.createElement("path", { fill: "#4285F4", d: "M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" }),
                            React__default$4.createElement("path", { fill: "#FBBC05", d: "M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" }),
                            React__default$4.createElement("path", { fill: "#34A853", d: "M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" }),
                            React__default$4.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }))),
                    React__default$4.createElement("span", { className: style$v.gsMaterialButtonContents }, "Continue with Google"),
                    React__default$4.createElement("span", { style: { display: "none" } }, "Continue with Google")))) : (React__default$4.createElement(React__default$4.Fragment, null)),
            typeof onFacebookSubmit === "function" ? (React__default$4.createElement("button", { className: style$v.facebookLoginBtn, onClick: onFacebookSubmit },
                React__default$4.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: style$v.facebookLogo },
                    React__default$4.createElement("path", { d: "M24 12.073c0-6.627-5.373-12-12-12S0 5.446 0 12.073c0 5.995 4.388 10.982 10.125 11.85v-8.385H7.078v-3.465h3.047V9.907c0-3.026 1.792-4.687 4.533-4.687 1.312 0 2.686.236 2.686.236v2.953h-1.513c-1.491 0-1.953.926-1.953 1.873v2.219h3.328l-.532 3.465h-2.796v8.385C19.612 23.055 24 18.068 24 12.073z", fill: "#FFFFFF" })),
                React__default$4.createElement("span", null, "Continue with Facebook"))) : (React__default$4.createElement(React__default$4.Fragment, null)),
            React__default$4.createElement("button", { className: style$v.emailLoginBtn, onClick: showForm },
                React__default$4.createElement(Icon$1, { iconName: "mail" }),
                "Continue with Email"))) : (React__default$4.createElement(React__default$4.Fragment, null,
            React__default$4.createElement("button", { className: style$v.backToOptionsBtn, onClick: hideForm },
                React__default$4.createElement(Icon$1, { iconName: "arrow_back" }),
                "Show Other Options"),
            React__default$4.createElement("form", null,
                React__default$4.createElement("div", { style: { display: "flex", flexDirection: "column", rowGap: "10px" } },
                    !hideFields.firstName ? (React__default$4.createElement(Input$3, { label: "First Name", variation: "outlined", type: "text", required: true, value: data.firstName || "", onChange: (value) => setData(Object.assign(Object.assign({}, data), { firstName: value })) })) : (React__default$4.createElement(React__default$4.Fragment, null)),
                    !hideFields.lastName ? (React__default$4.createElement(Input$3, { label: "Last Name", variation: "outlined", type: "text", value: data.lastName || "", onChange: (value) => setData(Object.assign(Object.assign({}, data), { lastName: value })) })) : (React__default$4.createElement(React__default$4.Fragment, null)),
                    !hideFields.fullName ? (React__default$4.createElement(Input$3, { label: "Name", variation: "outlined", type: "text", required: true, value: data.fullName || "", onChange: (value) => setData(Object.assign(Object.assign({}, data), { fullName: value })) })) : (React__default$4.createElement(React__default$4.Fragment, null)),
                    !hideFields.website ? (React__default$4.createElement(URLInput, { label: "Website", variation: "outlined", type: "url", required: true, helperText: "The website for your business.", value: data.website || "", onChange: handleWebsiteChange })) : (React__default$4.createElement(React__default$4.Fragment, null)),
                    React__default$4.createElement(EmailInput, { label: "Email", name: "email", variation: "outlined", type: "email", autoComplete: "email", required: true, helperText: "Your email will be how you login.", value: data.email || "", onChange: handleEmailChange }),
                    React__default$4.createElement(PasswordInput, { label: "Password", name: "password", variation: "outlined", type: "password", autoComplete: "new-password", requirements: passwordRequirements, 
                        // pattern="^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z]).*$"
                        helperText: "Use 8 or more characters with a mix of letters, numbers, and special characters", required: true, value: data.password || "", onChange: handlePasswordChange })),
                React__default$4.createElement("div", { className: style$v.marginbuttons, onClick: handleDisabledClick },
                    React__default$4.createElement(Button, { disabled: notValid, variation: "primary", label: "Create Account", onClick: handleSubmit }))))),
        React__default$4.createElement("footer", null,
            !!footer ? React__default$4.createElement("div", null, footer) : React__default$4.createElement(React__default$4.Fragment, null),
            typeof urlSignIn === "string" ? (React__default$4.createElement("p", null,
                "If you already have an account, ",
                React__default$4.createElement("a", { href: urlSignIn }, "sign in"),
                ".")) : (React__default$4.createElement(React__default$4.Fragment, null)))));
};

const LoginScreen = ({ onSubmit, onGoogleSubmit, titleCard, subtitleCard, descriptionCard, authorCard, avatar, qualification, titleForm, subtitleForm, footerForm, urlSignIn, resetData }) => {
    const handleSubmit = (data) => {
        onSubmit(data);
    };
    return (React__default$4.createElement("div", { style: { display: "flex", justifyContent: "center", alignItems: "center" } },
        React__default$4.createElement(FeedbackCard, { title: titleCard, subtitle: subtitleCard, description: descriptionCard, author: authorCard, avatarSRC: avatar, qualification: qualification }),
        React__default$4.createElement(LoginForm, { onSubmit: handleSubmit, onGoogleSubmit: onGoogleSubmit, title: titleForm, subtitle: subtitleForm, footer: footerForm, urlSignIn: urlSignIn, resetData: resetData })));
};

var css_248z$H = ".MenuBarItem_menuitem__ynYMd {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: stretch;\n  justify-content: center;\n  position: relative;\n  max-width: 100%;\n  margin-right: 7px;\n  height: 55px;\n}\n.MenuBarItem_menuitem__ynYMd:hover .MenuBarItem_children__UKA4I, .MenuBarItem_menuitem__ynYMd:focus-within .MenuBarItem_children__UKA4I {\n  display: flex;\n}\n\n.MenuBarItem_link__Ps3Bq {\n  display: flex;\n  padding: 0 17.5px 0 17.5px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  white-space: nowrap;\n  box-sizing: border-box;\n}\n.MenuBarItem_link__Ps3Bq:hover, .MenuBarItem_link__Ps3Bq:focus {\n  background: #b5e2fa;\n}\n.MenuBarItem_link__Ps3Bq:hover + .MenuBarItem_children__UKA4I, .MenuBarItem_link__Ps3Bq:focus + .MenuBarItem_children__UKA4I {\n  display: flex;\n}\n.MenuBarItem_link__Ps3Bq.MenuBarItem_active__0THKP, .MenuBarItem_link__Ps3Bq:visited.MenuBarItem_active__0THKP, .MenuBarItem_link__Ps3Bq:active.MenuBarItem_active__0THKP, .MenuBarItem_link__Ps3Bq:link.MenuBarItem_active__0THKP {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 14px;\n  line-height: 17px;\n  font-weight: 800;\n  color: var(--menubar-item-active-color, #3295d2);\n  text-decoration: underline;\n}\n.MenuBarItem_link__Ps3Bq.MenuBarItem_inactive__kn6oG, .MenuBarItem_link__Ps3Bq:visited.MenuBarItem_inactive__kn6oG, .MenuBarItem_link__Ps3Bq:active.MenuBarItem_inactive__kn6oG, .MenuBarItem_link__Ps3Bq:link.MenuBarItem_inactive__kn6oG {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 14px;\n  line-height: 17px;\n  font-weight: 500;\n  color: var(--menubar-item-inactive-color, var(--text-color, #000));\n}\n\n.MenuBarItem_text__at-6T {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.MenuBarItem_children__UKA4I {\n  list-style: none;\n  display: none;\n  flex-direction: column;\n  align-items: stretch;\n  position: absolute;\n  top: 55px;\n  left: 0;\n  max-width: 200px;\n  min-width: 100%;\n  margin: 0;\n  padding: 0;\n  background-color: var(--menubar-background, #f8f8f8);\n  z-index: 100;\n  box-shadow: 6px 0 4px -4px #bfbfbf, -6px 0 4px -4px #bfbfbf, 6px 6px 4px -4px #bfbfbf, -6px 6px 4px -4px #bfbfbf;\n}\n.MenuBarItem_children__UKA4I li {\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: stretch;\n  height: auto;\n}\n.MenuBarItem_children__UKA4I li a {\n  padding: 14px 12px;\n  justify-content: flex-start;\n}\n\n.MenuBarItem_notification__8U8Pr {\n  color: white;\n  border-radius: 50%;\n  padding: 0.2em 0.5em;\n  margin-left: 0.5em;\n  font-size: 0.8em;\n  display: inline-block;\n}";
var style$u = {"menuitem":"MenuBarItem_menuitem__ynYMd","children":"MenuBarItem_children__UKA4I","link":"MenuBarItem_link__Ps3Bq","active":"MenuBarItem_active__0THKP","inactive":"MenuBarItem_inactive__kn6oG","text":"MenuBarItem_text__at-6T","notification":"MenuBarItem_notification__8U8Pr"};
styleInject(css_248z$H);

const MenuBarItemInner = props => {
    const { item, loading } = props;
    const { children, url, notification, icon, iconMode } = item;
    const handleClick = useCallback(() => {
        try {
            const active = document.activeElement;
            if (active && active.blur) {
                active.blur();
            }
        }
        catch (_a) {
        }
    }, []);
    if (loading) {
        return (React__default$4.createElement("li", { className: style$u.menuitem, style: { alignItems: "center", marginLeft: "7px" } },
            React__default$4.createElement(LoadingProgressBar, null)));
    }
    return (React__default$4.createElement("li", { className: style$u.menuitem },
        url ? (React__default$4.createElement(Link, { className: style$u.link + " " + (item.active ? style$u.active : style$u.inactive), href: url, onClick: handleClick },
            icon && iconMode ? (React__default$4.createElement(Tooltip$5, { content: item.label, align: "top" }, typeof icon === "string" ? React__default$4.createElement(Icon$1, { iconName: icon }) : icon)) : (React__default$4.createElement("span", { className: style$u.text }, item.label)),
            notification && (React__default$4.createElement(Tooltip$5, { content: notification.tooltip },
                React__default$4.createElement("span", { className: style$u.notification, style: { backgroundColor: notification.color }, title: notification.tooltip }, notification.content))))) : (React__default$4.createElement("div", { className: style$u.link + " " + (item.active ? style$u.active : style$u.inactive) },
            icon && iconMode ? (React__default$4.createElement(Tooltip$5, { content: item.label, align: "top" }, typeof icon === "string" ? React__default$4.createElement(Icon$1, { iconName: icon }) : icon)) : (React__default$4.createElement("span", { className: style$u.text }, item.label)),
            notification && (React__default$4.createElement(Tooltip$5, { content: notification.tooltip },
                React__default$4.createElement("span", { className: style$u.notification, style: { backgroundColor: notification.color }, title: notification.tooltip }, notification.content))))),
        children && children.length > 0 && (React__default$4.createElement("ul", { className: style$u.children }, children.map((child, index) => React__default$4.createElement(MenuBarItem, { item: child, key: index }))))));
};
const MenuBarItem = React__default$4.memo(MenuBarItemInner);

var css_248z$G = ".MenuBar_menubar__Lsxzd {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  align-content: center;\n  background: var(--menubar-background, #f8f8f8);\n  padding: 0;\n  margin: 0;\n  box-shadow: 0 2px 4px 3px #bfbfbf;\n}\n.MenuBar_menubar__Lsxzd .MenuBar_items__vY34t {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  overflow-y: visible;\n}\n.MenuBar_menubar__Lsxzd .MenuBar_items__vY34t.MenuBar_hideScrollbar__y92sT {\n  scrollbar-width: none;\n}\n.MenuBar_menubar__Lsxzd .MenuBar_items__vY34t.MenuBar_hideScrollbar__y92sT::-webkit-scrollbar {\n  display: none;\n}";
var style$t = {"menubar":"MenuBar_menubar__Lsxzd","items":"MenuBar_items__vY34t","hideScrollbar":"MenuBar_hideScrollbar__y92sT"};
styleInject(css_248z$G);

const MenuBarInner = props => {
    const { children, loading } = props;
    const itemsRef = useRef(null);
    useEffect(() => {
        const checkOverflow = () => {
            if (itemsRef.current) {
                // console.log(`scrollWidth: ${itemsRef.current.scrollWidth} > clientWidth: ${itemsRef.current.clientWidth}`);
                // we want to add a buffer so that even if it is a little over the width, by 20px
                // we will still hide the scroll bar
                if ((itemsRef.current.scrollWidth) > itemsRef.current.clientWidth) {
                    // Add class to hide scrollbar
                    itemsRef.current.classList.remove(style$t.hideScrollbar);
                }
                else {
                    // Remove class to show scrollbar
                    itemsRef.current.classList.add(style$t.hideScrollbar);
                }
            }
        };
        // Initial check
        checkOverflow();
        // Check on window resize
        window.addEventListener('resize', checkOverflow);
        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', checkOverflow);
        };
    }, []);
    return (React__default$4.createElement("menu", { className: style$t.menubar },
        React__default$4.createElement("div", { className: `${style$t.items} ${style$t.hideScrollbar}`, ref: itemsRef }, props.items.map((item, index) => React__default$4.createElement(MenuBarItem, { key: index, item: item, loading: loading }))),
        children ? (React__default$4.createElement("div", null, children)) : React__default$4.createElement(React__default$4.Fragment, null)));
};
const MenuBar = React__default$4.memo(MenuBarInner);

var css_248z$F = ".MultiSelectCard-module_grid__16m2p {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.MultiSelectCard-module_card__0cxFu {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  border: 2px solid #ccc;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  transition: border-color 0.2s, background-color 0.2s;\n}\n.MultiSelectCard-module_card__0cxFu:hover {\n  border-color: #333;\n}\n\n.MultiSelectCard-module_selected__z0HFl {\n  border-color: #1aa7dc;\n  background-color: #f0f8ff;\n}\n\n.MultiSelectCard-module_icon__z9AAZ {\n  margin-right: 1rem;\n  font-size: 1.5rem;\n}\n\n.MultiSelectCard-module_content__CqkGx {\n  flex: 1;\n}\n\n.MultiSelectCard-module_title__EZd1j {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.MultiSelectCard-module_subtitle__wi0yl {\n  font-size: 0.875rem;\n  color: #666;\n}\n\n.MultiSelectCard-module_checkIcon__70IM9 {\n  color: #0073e6;\n}";
var styles$5 = {"grid":"MultiSelectCard-module_grid__16m2p","card":"MultiSelectCard-module_card__0cxFu","selected":"MultiSelectCard-module_selected__z0HFl","icon":"MultiSelectCard-module_icon__z9AAZ","content":"MultiSelectCard-module_content__CqkGx","title":"MultiSelectCard-module_title__EZd1j","subtitle":"MultiSelectCard-module_subtitle__wi0yl","checkIcon":"MultiSelectCard-module_checkIcon__70IM9"};
styleInject(css_248z$F);

const MultiSelectCard = ({ options, selected, onChange }) => {
    const toggleSelection = (id) => {
        if (selected.includes(id)) {
            onChange(selected.filter((item) => item !== id));
        }
        else {
            onChange([...selected, id]);
        }
    };
    return (React__default$4.createElement("div", { className: styles$5.grid }, options.map((option) => {
        const isSelected = selected.includes(option.id);
        return (React__default$4.createElement("button", { key: option.id, className: `${styles$5.card} ${isSelected ? styles$5.selected : ""}`, onClick: () => toggleSelection(option.id) },
            React__default$4.createElement("div", { className: styles$5.icon }, option.icon),
            React__default$4.createElement("div", { className: styles$5.content },
                React__default$4.createElement("div", { className: styles$5.title }, option.title),
                option.subtitle && React__default$4.createElement("div", { className: styles$5.subtitle }, option.subtitle))));
    })));
};

var css_248z$E = ".style_parent__sCYKM {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.style_child__iluBz p {\n  text-align: center;\n}\n\n.style_emoji__vuHJ9 {\n  font-size: 5em;\n}";
var style$s = {"parent":"style_parent__sCYKM","child":"style_child__iluBz","emoji":"style_emoji__vuHJ9"};
styleInject(css_248z$E);

const NotFound = (props) => {
    const { message } = props;
    return (React__default$4.createElement("section", { className: style$s.parent },
        React__default$4.createElement("span", { className: style$s.child },
            React__default$4.createElement("p", { className: style$s.emoji }, "\uD83D\uDE43"),
            React__default$4.createElement("p", null, message))));
};

var css_248z$D = ".style_stepperContainer__aOtRh {\n  overflow-x: auto;\n  white-space: nowrap;\n  width: 100%; /* This ensures the stepper takes up full width */\n  min-height: 115px;\n}\n\n.style_stepperHorizontal__OGYKn {\n  display: table;\n  width: 100%;\n  margin: 0 auto;\n  background-color: #ffffff;\n  overflow-x: hidden; /* Hide the horizontal overflow */\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim {\n  display: table-cell;\n  position: relative;\n  padding: 24px;\n  min-width: 80px; /* Set a minimum width for each step to ensure centering */\n  background-color: #ffffff;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim:hover,\n.style_stepperHorizontal__OGYKn .style_step__Sfqim:active {\n  background-color: rgba(0, 0, 0, 0.26);\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim:active {\n  border-radius: 15%/75%;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim:first-child:active {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim:last-child:active {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim:hover .style_stepCircle__O-12y {\n  background-color: #3e3e3e;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim:first-child .style_stepBarLeft__NHLt3,\n.style_stepperHorizontal__OGYKn .style_step__Sfqim:last-child .style_stepBarRight__RxO1H {\n  display: none;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim .style_stepCircle__O-12y {\n  width: 30px;\n  height: 30px;\n  margin: 0 auto;\n  background-color: rgb(125.75, 125.75, 125.75);\n  border-radius: 50%;\n  text-align: center;\n  line-height: 30px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_active__Ie-by .style_stepCircle__O-12y {\n  background-color: #1aa7dc;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_done__H1-Px .style_stepCircle__O-12y::before {\n  font-family: \"Material Icons\";\n  font-weight: 100;\n  content: \"\\e5ca\";\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_done__H1-Px .style_stepCircle__O-12y *,\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_editable__4AcZN .style_stepCircle__O-12y * {\n  display: none;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_editable__4AcZN .style_stepCircle__O-12y {\n  -o-transform: scaleX(-1);\n  transform: scaleX(-1);\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_editable__4AcZN .style_stepCircle__O-12y::before {\n  font-family: \"Material Icons\";\n  font-weight: 100;\n  content: \"\\e3c9\";\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim .style_stepTitle__Jl2IL {\n  margin-top: 16px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim .style_stepTitle__Jl2IL,\n.style_stepperHorizontal__OGYKn .style_step__Sfqim .style_stepOptional__qWXPN {\n  text-align: center;\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_active__Ie-by .style_stepTitle__Jl2IL {\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_active__Ie-by.style_done__H1-Px .style_stepTitle__Jl2IL,\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_active__Ie-by.style_editable__4AcZN .style_stepTitle__Jl2IL {\n  font-weight: 600;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim .style_stepOptional__qWXPN {\n  font-size: 12px;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_active__Ie-by .style_stepOptional__qWXPN {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim .style_stepBarLeft__NHLt3,\n.style_stepperHorizontal__OGYKn .style_step__Sfqim .style_stepBarRight__RxO1H {\n  position: absolute;\n  top: 36px;\n  height: 1px;\n  border-top: 1px solid #dadada;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim .style_stepBarRight__RxO1H {\n  right: 0;\n  left: 50%;\n  margin-left: 20px;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim .style_stepBarLeft__NHLt3 {\n  left: 0;\n  right: 50%;\n  margin-right: 20px;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_done__H1-Px .style_stepBarLeft__NHLt3,\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_done__H1-Px .style_stepBarRight__RxO1H {\n  background-color: #1aa7dc;\n  height: 3px;\n  border-top: none;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_active__Ie-by .style_stepBarLeft__NHLt3 {\n  background-color: #1aa7dc;\n  height: 3px;\n  border-top: none;\n}\n\n.style_stepperHorizontal__OGYKn .style_step__Sfqim.style_active__Ie-by .style_stepBarRight__RxO1H {\n  background-color: #1aa7dc;\n}\n\n@media only screen and (max-width: 768px) {\n  .style_stepperHorizontal__OGYKn {\n    display: flex;\n    justify-content: center; /* Centers the steps horizontally */\n    overflow-x: scroll; /* Allows horizontal scroll on overflow */\n  }\n  .style_stepperContainer__aOtRh {\n    display: flex;\n    justify-content: center; /* Centers the stepper horizontally */\n    width: 100%;\n    padding: 0 10px; /* Add some padding to account for scrollbar space */\n    box-sizing: border-box;\n    border-radius: 0px;\n  }\n  .style_stepperHorizontal__OGYKn .style_step__Sfqim {\n    min-width: 80px; /* Set a minimum width for each step to ensure centering */\n  }\n  .style_step__Sfqim:not(.style_active__Ie-by) {\n    display: none;\n  }\n}";
var style$r = {"stepperContainer":"style_stepperContainer__aOtRh","stepperHorizontal":"style_stepperHorizontal__OGYKn","step":"style_step__Sfqim","stepCircle":"style_stepCircle__O-12y","stepBarLeft":"style_stepBarLeft__NHLt3","stepBarRight":"style_stepBarRight__RxO1H","active":"style_active__Ie-by","done":"style_done__H1-Px","editable":"style_editable__4AcZN","stepTitle":"style_stepTitle__Jl2IL","stepOptional":"style_stepOptional__qWXPN"};
styleInject(css_248z$D);

const Step = (props) => {
    const { index, title, optional, active, disabled, done } = props;
    return (React__default$4.createElement("div", { className: classNames$1(style$r.step, {
            [style$r.active]: active,
            [style$r.disabled]: disabled,
            [style$r.done]: done,
        }) },
        React__default$4.createElement("div", { className: style$r.stepCircle },
            React__default$4.createElement("span", null, index)),
        React__default$4.createElement("div", { className: style$r.stepTitle }, title),
        React__default$4.createElement("div", { className: style$r.stepOptional }, optional),
        React__default$4.createElement("div", { className: style$r.stepBarLeft }),
        React__default$4.createElement("div", { className: style$r.stepBarRight })));
};

/**
 * Determines if the child is a React Element
 */
function isReactElement(child) {
    if (!child) {
        return false;
    }
    if (typeof child === "string") {
        return false;
    }
    if (typeof child === "number") {
        return false;
    }
    if (typeof child === "boolean") {
        return false;
    }
    if (typeof child === "function") {
        return false;
    }
    return !!child.type;
}

/**
 * A horizontal stepper component for communicating where the user is with regards to the
 * entire process.
 *
 * Help on this component from {@link https://codepen.io/thdeux/pen/zBGNrM?editors=1100} and
 * {@link https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/Stepper/Stepper.js}
 */
const Stepper = (props) => {
    const { activeStep, children } = props;
    const containerRef = useRef(null);
    const activeStepRef = useRef(null);
    useEffect(() => {
        if (containerRef.current && activeStepRef.current) {
            // Calculate the left offset of the active step within the container
            const containerWidth = containerRef.current.clientWidth;
            const activeStepWidth = activeStepRef.current.clientWidth;
            const activeStepOffsetLeft = activeStepRef.current.offsetLeft;
            const scrollOffset = activeStepOffsetLeft - containerWidth / 2 + activeStepWidth / 2;
            // Scroll to the active step
            containerRef.current.scrollTo({
                left: scrollOffset,
                behavior: "smooth",
            });
        }
    }, [activeStep]);
    const newChildren = [];
    React__default$4.Children.forEach(children, (child, index) => {
        if (isReactElement(child)) {
            newChildren.push(React__default$4.cloneElement(child, Object.assign({ active: index === activeStep, index: index + 1 }, child.props)));
        }
        else {
            throw TypeError(`Only Steps can be children of a Stepper.`);
        }
    });
    return (React__default$4.createElement("div", { ref: containerRef, style: props.style, className: style$r.stepperContainer },
        React__default$4.createElement("div", { className: style$r.stepperHorizontal }, newChildren)));
};

var css_248z$C = ".style_wrapper__1SLwc {\n  border-radius: 10px;\n  padding: 10px;\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.0705882353), 0 10px 10px -5px rgba(97, 56, 122, 0.031372549);\n  min-width: 950px;\n}\n\n.style_stepperWrapper__4FysV {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n}\n.style_stepperWrapper__4FysV .style_backButton__SyNE4 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n}\n.style_stepperWrapper__4FysV .style_stepper__nkH-e {\n  width: 100%;\n}\n\n.style_stepBodyWrapper__IOVLa {\n  background-color: #ffffff;\n  padding: 20px;\n}\n\n.style_bottomWrapper__XZL1K {\n  margin-top: auto;\n  padding: 16px;\n  background-color: white;\n  border-top: 1px solid #ddd;\n}\n\n.style_step__q52Yc {\n  height: 0;\n  opacity: 0;\n  transition: height 0ms 400ms, opacity 400ms 0ms;\n}\n\n.style_active__PujaC {\n  height: auto;\n  opacity: 1;\n  transition: height 0ms 0ms, opacity 600ms 0ms;\n}\n\n.style_stepContentWrapper__rEDyI {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  padding: 6px;\n}\n\n.style_onboardingHeader__unoei {\n  padding-left: 20px;\n  padding-bottom: 20px;\n  font-size: 36px;\n  font-weight: 700;\n  word-break: break-word;\n  font-style: normal;\n  line-height: 44px;\n  width: 90%;\n}\n\n.style_onboardingAside__MJiob {\n  flex: 1;\n  min-width: 200px;\n  background-color: #ffffff;\n  padding: 20px;\n  display: block;\n}\n\n.style_onboardingContent__zSGS8 {\n  flex: 1;\n  background-color: #ffffff;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: -6px 6px 6px 6px rgba(0, 0, 0, 0.0705882353), 0 10px 10px -5px rgba(97, 56, 122, 0.031372549);\n  min-width: 400px;\n}\n\n@media (max-width: 1024px) {\n  .style_wrapper__1SLwc {\n    min-width: 700px;\n  }\n}\n@media (max-width: 768px) {\n  .style_wrapper__1SLwc {\n    border: none;\n    box-shadow: none;\n    padding-top: 0px;\n    min-width: unset;\n  }\n  .style_onboardingAside__MJiob {\n    display: none;\n  }\n  .style_onboardingContent__zSGS8 {\n    padding-top: 2px;\n    padding-bottom: 0px;\n    padding-left: 10px;\n    padding-right: 10px;\n    width: 100%;\n    min-width: unset;\n    border: none;\n    box-shadow: none;\n  }\n  .style_onboardingHeader__unoei {\n    width: 100%;\n    font-size: 24px;\n    line-height: 32px;\n    padding-bottom: 10px;\n    padding-left: 0px;\n  }\n}\n@media (max-width: 768px) {\n  .style_wrapper__1SLwc {\n    padding-left: 6px;\n    padding-right: 6px;\n    padding-top: 0px;\n    min-width: unset;\n  }\n  .style_stepperWrapper__4FysV {\n    flex-direction: column;\n  }\n  .style_stepContentWrapper__rEDyI {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .style_stepBodyWrapper__IOVLa {\n    padding-left: 0px;\n    padding-right: 0px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n  .style_onboardingContent__zSGS8 {\n    padding-left: 0px;\n    padding-right: 0px;\n    min-width: unset;\n  }\n}";
var classes$1 = {"wrapper":"style_wrapper__1SLwc","stepperWrapper":"style_stepperWrapper__4FysV","backButton":"style_backButton__SyNE4","stepper":"style_stepper__nkH-e","stepBodyWrapper":"style_stepBodyWrapper__IOVLa","bottomWrapper":"style_bottomWrapper__XZL1K","step":"style_step__q52Yc","active":"style_active__PujaC","stepContentWrapper":"style_stepContentWrapper__rEDyI","onboardingHeader":"style_onboardingHeader__unoei","onboardingAside":"style_onboardingAside__MJiob","onboardingContent":"style_onboardingContent__zSGS8"};
styleInject(css_248z$C);

var css_248z$B = ".style_wrapper__9OZAb {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.style_total__08fDb {\n  width: 100%;\n  border-radius: 999px;\n  position: relative;\n  overflow: hidden;\n}\n\n.style_progress__sIrOm {\n  background-color: #39d75a;\n  border-radius: 999px;\n  transition: width 1.5s ease-in-out;\n}\n\n.style_percent__sgmZ7 {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-weight: bold;\n  color: white;\n  text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);\n}";
var styles$4 = {"wrapper":"style_wrapper__9OZAb","total":"style_total__08fDb","progress":"style_progress__sIrOm","percent":"style_percent__sgmZ7"};
styleInject(css_248z$B);

var rgbToHsl$1 = {exports: {}};

(function() {
  rgbToHsl$1.exports = function(r, g, b) {
    var d, h, l, max, min, s;
    r /= 255;
    g /= 255;
    b /= 255;
    max = Math.max(r, g, b);
    min = Math.min(r, g, b);
    h = 0;
    s = 0;
    l = (max + min) / 2;
    if (max === min) {
      h = s = 0;
    } else {
      d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
      }
      h /= 6;
    }
    h = Math.ceil(h * 360);
    s = (Math.ceil(s * 100)) + "%";
    l = (Math.ceil(l * 100)) + "%";
    return [h, s, l];
  };

}).call(commonjsGlobal$1);

var hexToRgb$1 = function hexToRgb (hex) {

  if (hex.charAt && hex.charAt(0) === '#') {
    hex = removeHash(hex);
  }

  if (hex.length === 3) {
    hex = expand(hex);
  }

  var bigint = parseInt(hex, 16);
  var r = (bigint >> 16) & 255;
  var g = (bigint >> 8) & 255;
  var b = bigint & 255;

  return [r, g, b]
};

function removeHash (hex) {

  var arr = hex.split('');
  arr.shift();
  return arr.join('')
}

function expand (hex) {

  return hex
    .split('')
    .reduce(function (accum, value) {

      return accum.concat([value, value])
    }, [])
    .join('')
}

var rgbToHsl = rgbToHsl$1.exports;
var hexToRgb = hexToRgb$1;

var hexToHsl = function (hex) {
	var hsl = rgbToHsl.apply(rgbToHsl, hexToRgb(hex));
	return [hsl[0], parseInt(hsl[1], 10), parseInt(hsl[2], 10)];
};

function desaturateHex(hex, saturation) {
    const hslArray = hexToHsl(hex);
    return `hsla(${hslArray[0]}, ${saturation}%, ${hslArray[2]}%, .5)`;
}

const ProgressBar = ({ percentComplete, showPercent = false, height = "1em" }) => {
    const [animatedPercent, setAnimatedPercent] = useState(0);
    useEffect(() => {
        setAnimatedPercent(percentComplete);
    }, [percentComplete]);
    return (React__default$4.createElement("div", { className: styles$4.wrapper, style: { height } },
        React__default$4.createElement("div", { className: styles$4.total, style: {
                height,
                backgroundColor: desaturateHex("#39d75a", animatedPercent),
            } },
            React__default$4.createElement("div", { className: styles$4.progress, style: { width: `${animatedPercent}%`, height } }),
            showPercent && React__default$4.createElement("span", { className: styles$4.percent },
                Math.round(animatedPercent),
                "%"))));
};

var css_248z$A = ".StepperProgress-module_wrapper__ontRB {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n}\n\n.StepperProgress-module_stepFraction__N2reP {\n  font-weight: bold;\n  white-space: nowrap;\n}\n\n.StepperProgress-module_stepTitle__FUohI {\n  flex: 5;\n  text-align: center;\n  font-weight: 600;\n  color: #444;\n  text-transform: uppercase;\n  font-size: 0.85em;\n}";
var styles$3 = {"wrapper":"StepperProgress-module_wrapper__ontRB","stepFraction":"StepperProgress-module_stepFraction__N2reP","stepTitle":"StepperProgress-module_stepTitle__FUohI"};
styleInject(css_248z$A);

const StepperProgress = ({ onBack, steps, showTitle = true, height = "1em", disableBack, disableNumericalProgress = false, }) => {
    // Filter out hidden steps for counting
    const visibleSteps = useMemo(() => steps.filter((step) => !step.hide), [steps]);
    // Find active step
    const activeStep = useMemo(() => steps.find((step) => step.active), [steps]);
    let currentIndex = visibleSteps.findIndex((step) => step.active);
    // If the activeStep is hidden, we find the previous visible step
    if (activeStep === null || activeStep === void 0 ? void 0 : activeStep.hide) {
        currentIndex = steps.findIndex((step) => step.number === activeStep.number) - 1;
    }
    // Sanity check, currentIndex should never be more than total steps
    if (currentIndex < 0) {
        currentIndex = 0;
    }
    if (currentIndex >= visibleSteps.length) {
        currentIndex = visibleSteps.length - 1;
    }
    const totalSteps = visibleSteps.length;
    // Calculate progress percentage (0% if no steps)
    const percentComplete = totalSteps > 0 ? ((currentIndex + 1) / totalSteps) * 100 : 0;
    return (React__default$4.createElement("div", { className: styles$3.wrapper },
        onBack && React__default$4.createElement(IconButton, { disabled: disableBack, onClick: onBack, iconName: "arrow_back" }),
        !disableNumericalProgress && (React__default$4.createElement("span", { className: styles$3.stepFraction },
            currentIndex + 1,
            " / ",
            totalSteps)),
        showTitle && (activeStep === null || activeStep === void 0 ? void 0 : activeStep.title) && React__default$4.createElement("span", { className: styles$3.stepTitle }, activeStep.title),
        React__default$4.createElement(ProgressBar, { percentComplete: percentComplete, height: height })));
};

const Onboarding = (props) => {
    const { children, progressBar } = props;
    const { bottom } = props.steps || {};
    const { onBack, disableBack, disableNumericalProgress } = progressBar || {};
    const progressIndicator = (progressBar === null || progressBar === void 0 ? void 0 : progressBar.type) || "stepper";
    const [steps, setSteps] = useState([]);
    useEffect(() => {
        const steps = [];
        React__default$4.Children.map(children, (child, index) => {
            if (isReactElement(child)) {
                steps.push({
                    title: child.props.title,
                    number: index + 1,
                    active: child.props.active,
                    hide: child.props.hide,
                    done: child.props.done,
                });
            }
        });
        setSteps(steps);
    }, [children]);
    const getSteps = useCallback(() => {
        // filter steps that are hidden
        const notHiddenSteps = (steps || []).filter((step) => !step.hide);
        return notHiddenSteps.map((props, index) => {
            return React__default$4.createElement(Step, Object.assign({ key: index }, props, { hideTitle: !props.title }));
        });
    }, [steps]);
    const activeStep = steps.find((step) => {
        return step.active;
    });
    return (React__default$4.createElement("section", { className: classes$1.wrapper },
        React__default$4.createElement("div", { className: classes$1.stepperWrapper },
            progressIndicator === "none" && React__default$4.createElement(React__default$4.Fragment, null),
            progressIndicator === "loading-bar" && (React__default$4.createElement(StepperProgress, { onBack: onBack, steps: steps, disableBack: disableBack, disableNumericalProgress: disableNumericalProgress })),
            !progressIndicator ||
                (progressIndicator === "stepper" && (React__default$4.createElement(React__default$4.Fragment, null,
                    onBack && (React__default$4.createElement(IconButton, { className: classes$1.backButton, onClick: onBack, iconName: "arrow_back", disabled: disableBack })),
                    React__default$4.createElement(Stepper, { activeStep: activeStep === null || activeStep === void 0 ? void 0 : activeStep.number }, getSteps())))), progressBar === null || progressBar === void 0 ? void 0 :
            progressBar.rightContent),
        React__default$4.createElement("div", { className: classes$1.stepBodyWrapper, style: {
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
            } }, children),
        bottom && React__default$4.createElement("div", { className: classes$1.bottomWrapper }, bottom)));
};

const OnboardingAside = ({ children }) => {
    return React__default$4.createElement("aside", { className: classes$1.onboardingAside }, children);
};
const OnboardingContent = ({ children, style, className }) => {
    return (React__default$4.createElement("main", { style: Object.assign({}, style), className: classNames$1(classes$1.onboardingContent, className) }, children));
};
const OnboardingStep = (props) => {
    const { active, hide, className, style, header } = props;
    // if not active, don't show the children
    if (!active) {
        return React__default$4.createElement(React__default$4.Fragment, null);
    }
    return (React__default$4.createElement("div", { style: style, className: classNames$1(classes$1.step, { [classes$1.active]: active, [classes$1.hidden]: hide }, { [className || ""]: !!className }) },
        header && React__default$4.createElement("div", { className: classes$1.onboardingHeader }, header),
        React__default$4.createElement("div", { className: classes$1.stepContentWrapper }, active ? props.children : React__default$4.createElement(React__default$4.Fragment, null))));
};

const OpportunityAlertsTable = ({ data, onAlertDisable, onAlertDelete, idSelect, emptyTableContent }) => {
    const handleDisable = (alert, index) => {
        if (onAlertDisable) {
            onAlertDisable(alert, index);
        }
    };
    const handleDelete = (alert, index) => {
        if (onAlertDelete) {
            onAlertDelete(alert, index);
        }
    };
    const canDelete = typeof onAlertDelete === "function";
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement(TableContainer$1, { component: Paper },
            React__default$4.createElement(Table$1, { sx: { minWidth: 650 } },
                React__default$4.createElement(TableHead$1, null,
                    React__default$4.createElement(TableRow$1, null,
                        React__default$4.createElement(TableCell$1, { align: "left" }, " Email "),
                        React__default$4.createElement(TableCell$1, { align: "left" }, " Disabled "),
                        canDelete && React__default$4.createElement(TableCell$1, { align: "left" }, " Actions "))),
                React__default$4.createElement(TableBody$1, null, data === null || data === void 0 ? void 0 : data.map((alert, index) => (React__default$4.createElement(TableRow$1, { key: `${alert.email}-${index}`, sx: { '&:last-child td, &:last-child th': { border: 0 } } },
                    React__default$4.createElement(TableCell$1, { align: "left" }, alert.email),
                    React__default$4.createElement(TableCell$1, { align: "left" },
                        React__default$4.createElement(FieldCheckbox, { value: alert.disabled, onChange: () => handleDisable(alert, index), disabled: typeof onAlertDisable === "function" ? false : true })),
                    canDelete && (React__default$4.createElement(TableCell$1, null,
                        React__default$4.createElement(IconButton_1$1, { style: { border: "none" }, icon: "delete", onClick: () => handleDelete(alert, index) }))))))))),
        (data && (data === null || data === void 0 ? void 0 : data.length) === 0) && (React__default$4.createElement("div", { style: {
                display: "flex",
                margin: "30px",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
            } }, emptyTableContent))));
};

/**
 *
 * @deprecated - Use PlacesAutocomplete instead
 * @param props
 * @returns
 */
const PlacesSearch = (props) => {
    const { apiKey, placeHolder, initialQuery } = props;
    const [query, setQuery] = useState(initialQuery || "");
    const [errorMessage, setErrorMessage] = useState();
    const [results, setResults] = useState();
    const handleSearch = useCallback(() => __awaiter$2(void 0, void 0, void 0, function* () {
        const url = `https://places.googleapis.com/v1/places:searchText`;
        const body = JSON.stringify({
            textQuery: query.toString(),
        });
        try {
            const response = yield fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Goog-Api-Key": apiKey,
                    "X-Goog-FieldMask": "places.displayName,places.formattedAddress",
                },
                body: body,
            });
            if (!response.ok) {
                setErrorMessage("Network response was not ok");
                return;
            }
            const data = yield response.json();
            const places = (data.places || []).map((place) => {
                var _a;
                return ({
                    id: place.place_id,
                    name: (_a = place.displayName) === null || _a === void 0 ? void 0 : _a.text,
                    address: place.formattedAddress,
                });
            });
            console.log(places);
            setResults(places);
        }
        catch (error) {
            console.error("Places search failed:", error);
        }
    }), [apiKey, query]);
    return (React__default$4.createElement("div", null,
        React__default$4.createElement("div", null,
            React__default$4.createElement(Input$3, { placeholder: placeHolder || "Search for a place", value: query, onChange: setQuery }),
            React__default$4.createElement(Button, { onClick: handleSearch }, "Search")),
        errorMessage && React__default$4.createElement("p", null, errorMessage),
        React__default$4.createElement("ul", null,
            results && results.length === 0 && React__default$4.createElement("li", null, "No results found"),
            results &&
                results.map((result) => (React__default$4.createElement("li", { key: result.id },
                    React__default$4.createElement("h3", null, result.name),
                    React__default$4.createElement("p", null, result.address)))))));
};

var css_248z$z = ".JSONEditorDialog-module_codeWrap__QNc-A {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n}";
var style$q = {"codeWrap":"JSONEditorDialog-module_codeWrap__QNc-A"};
styleInject(css_248z$z);

const JSONEditorDialog = (props) => {
    const [dimensions, setDimensions] = useState();
    let height = 0;
    let width = 0;
    if (dimensions) {
        const MAX_HEIGHT = 600;
        height = dimensions.height - 100 < MAX_HEIGHT ? dimensions.height - 100 : MAX_HEIGHT;
        width = dimensions.width;
    }
    // Maybe use Dimension?
    return (React__default$4.createElement(Dialog, Object.assign({ maxWidth: "lg", fullScreen: true, onClose: props.onDismissRequest, actions: [{ label: "Done", onClick: props.onDismissRequest }] }, props),
        React__default$4.createElement(Measure, { onMeasure: setDimensions, className: style$q.codeWrap },
            React__default$4.createElement(JSONEditor, { style: { height, width }, value: props.value, onChange: props.onChange }))));
};

var css_248z$y = ".PlacesTable_tableCell__ymRiU {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  justify-content: space-around;\n}\n\n.PlacesTable_ellipsisCell__BWluE {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  max-width: 250px;\n}\n.PlacesTable_ellipsisCell__BWluE > span, .PlacesTable_ellipsisCell__BWluE > a {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  min-width: 0;\n}\n.PlacesTable_ellipsisCell__BWluE button {\n  flex-shrink: 0;\n}\n\n.PlacesTable_addressCell__G1h6c {\n  max-width: 300px;\n}\n\n.PlacesTable_websiteCell__MDvQ6 {\n  max-width: 200px;\n}\n\n.PlacesTable_placeIdCell__dD0vR {\n  max-width: 180px;\n}\n\n.PlacesTable_hoursCell__lywDi {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  white-space: nowrap;\n}";
var classes = {"tableCell":"PlacesTable_tableCell__ymRiU","ellipsisCell":"PlacesTable_ellipsisCell__BWluE","addressCell":"PlacesTable_addressCell__G1h6c PlacesTable_ellipsisCell__BWluE","websiteCell":"PlacesTable_websiteCell__MDvQ6 PlacesTable_ellipsisCell__BWluE","placeIdCell":"PlacesTable_placeIdCell__dD0vR PlacesTable_ellipsisCell__BWluE","hoursCell":"PlacesTable_hoursCell__lywDi"};
styleInject(css_248z$y);

/**
 * Get the hours string for the current day from weekdayText
 * weekdayText format: ["Monday: 9:00 AM – 5:00 PM", "Tuesday: ...", ...]
 */
const getTodayHours = (weekdayText) => {
    if (!weekdayText || weekdayText.length === 0)
        return null;
    const dayIndex = new Date().getDay();
    // weekdayText starts with Monday (index 0), but getDay() returns 0 for Sunday
    // So we need to map: Sun=0 -> 6, Mon=1 -> 0, Tue=2 -> 1, etc.
    const weekdayIndex = dayIndex === 0 ? 6 : dayIndex - 1;
    const todayEntry = weekdayText[weekdayIndex];
    if (!todayEntry)
        return null;
    // Extract just the hours part (after the colon and space)
    const colonIndex = todayEntry.indexOf(':');
    if (colonIndex === -1)
        return todayEntry;
    return todayEntry.substring(colonIndex + 2).trim();
};
const PlacesTable = ({ data, onValueCopy, onPlaceVerify, onPlaceOptOut, onPlaceEdit, onPlaceDelete, onPlaceSelect, onPlaceRefresh, refreshingPlaceId, optOutLoading, idSelect, emptyTableContent, }) => {
    var _a;
    const [selectedCell, setSelectedCell] = useState(idSelect ? [idSelect] : []);
    const [hoursDialogPlace, setHoursDialogPlace] = useState(null);
    // Check if any place has opening hours
    const hasAnyHours = useMemo(() => {
        return data === null || data === void 0 ? void 0 : data.some(place => { var _a; return ((_a = place === null || place === void 0 ? void 0 : place.openingHours) === null || _a === void 0 ? void 0 : _a.weekdayText) && place.openingHours.weekdayText.length > 0; });
    }, [data]);
    useEffect(() => {
        if (onPlaceSelect) {
            onPlaceSelect(selectedCell);
        }
    }, [selectedCell, onPlaceSelect]);
    const handleSelectedCell = (placeId) => {
        if (selectedCell.includes(placeId)) {
            setSelectedCell(selectedCell.filter((cell) => cell !== placeId));
        }
        else {
            setSelectedCell([...selectedCell, placeId]);
        }
    };
    const handleVerifyChange = (index, placeId, value) => {
        if (onPlaceVerify) {
            onPlaceVerify(index, placeId, value);
        }
    };
    const handleOptOutChange = (index, placeId, value) => {
        if (onPlaceOptOut) {
            onPlaceOptOut(index, placeId, value);
        }
    };
    const handleCopy = (value) => {
        if (onValueCopy) {
            onValueCopy(value || "");
        }
    };
    const handleDelete = (index, placeId) => {
        if (onPlaceDelete) {
            onPlaceDelete(index, placeId);
        }
    };
    const handleRefresh = (index, placeId) => {
        if (onPlaceRefresh) {
            onPlaceRefresh(index, placeId);
        }
    };
    const canEdit = typeof onPlaceEdit === "function";
    const canDelete = typeof onPlaceDelete === "function";
    const canRefresh = typeof onPlaceRefresh === "function";
    const canCopy = typeof onValueCopy === "function";
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement(TableContainer$1, { component: Paper, style: { overflowX: "auto" } },
            React__default$4.createElement(Table$1, { sx: { minWidth: 650 } },
                React__default$4.createElement(TableHead$1, null,
                    React__default$4.createElement(TableRow$1, null,
                        typeof onPlaceSelect === "function" && (React__default$4.createElement(TableCell$1, null,
                            React__default$4.createElement(FieldCheckbox, { disabled: true }))),
                        React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Has this location been verified by XAPP") }, "Verified")),
                        React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Opt out of Reserve with Google") }, "Opt Out")),
                        React__default$4.createElement(TableCell$1, { align: "center" }, "Name"),
                        React__default$4.createElement(TableCell$1, { align: "center" }, "Address"),
                        React__default$4.createElement(TableCell$1, { align: "center" }, "Phone"),
                        React__default$4.createElement(TableCell$1, { align: "center" }, "Website"),
                        React__default$4.createElement(TableCell$1, { align: "center" }, "Place ID"),
                        hasAnyHours && (React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Business hours from Google") }, "Hours"))),
                        (canDelete || canEdit || canRefresh) && React__default$4.createElement(TableCell$1, { align: "center" }, "Actions"))),
                React__default$4.createElement(TableBody$1, null, data === null || data === void 0 ? void 0 : data.map((place, index) => {
                    var _a, _b;
                    return (React__default$4.createElement(TableRow$1, { key: place === null || place === void 0 ? void 0 : place.placeId, sx: { "&:last-child td, &:last-child th": { border: 0 } } },
                        typeof onPlaceSelect === "function" && (React__default$4.createElement(TableCell$1, { component: "th", scope: "row" },
                            React__default$4.createElement(FieldCheckbox, { value: selectedCell === null || selectedCell === void 0 ? void 0 : selectedCell.includes((_a = place === null || place === void 0 ? void 0 : place.placeId) !== null && _a !== void 0 ? _a : ""), onChange: () => { var _a; return handleSelectedCell((_a = place === null || place === void 0 ? void 0 : place.placeId) !== null && _a !== void 0 ? _a : ""); } }))),
                        React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement("div", { className: classes.tableCell }, typeof onPlaceVerify === "function" ? ((place === null || place === void 0 ? void 0 : place.adminVerified) ? (React__default$4.createElement(Button, { label: "Un-verify", style: { backgroundColor: "#ed6c02", color: "#fff" }, onClick: () => { var _a; return handleVerifyChange(index, (_a = place === null || place === void 0 ? void 0 : place.placeId) !== null && _a !== void 0 ? _a : "", false); } })) : (React__default$4.createElement(Button, { label: "Verify", onClick: () => { var _a; return handleVerifyChange(index, (_a = place === null || place === void 0 ? void 0 : place.placeId) !== null && _a !== void 0 ? _a : "", true); } }))) : (React__default$4.createElement(FieldCheckbox, { disabled: true, value: place === null || place === void 0 ? void 0 : place.adminVerified })))),
                        React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement(FieldCheckbox, { disabled: typeof onPlaceOptOut !== "function" || optOutLoading, value: typeof (place === null || place === void 0 ? void 0 : place.bookingOptOut) === "boolean" ? place === null || place === void 0 ? void 0 : place.bookingOptOut : false, onChange: (value) => { var _a; return handleOptOutChange(index, (_a = place === null || place === void 0 ? void 0 : place.placeId) !== null && _a !== void 0 ? _a : "", value); } })),
                        React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement("div", { className: classes.tableCell }, place === null || place === void 0 ? void 0 :
                                place.name,
                                React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Copy this location name") },
                                    React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: onValueCopy && "content_copy", onClick: () => { var _a; return handleCopy((_a = place === null || place === void 0 ? void 0 : place.name) !== null && _a !== void 0 ? _a : ""); } })))),
                        React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement("div", { className: classes.addressCell },
                                !(place === null || place === void 0 ? void 0 : place.formattedAddress) && onPlaceEdit && (React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Add Address") },
                                    React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: "add", onClick: () => onPlaceEdit(index, place) }))),
                                !(place === null || place === void 0 ? void 0 : place.formattedAddress) && !onPlaceEdit && React__default$4.createElement("i", null, "Not Set"),
                                (place === null || place === void 0 ? void 0 : place.formattedAddress) && !canCopy && React__default$4.createElement("span", { title: place === null || place === void 0 ? void 0 : place.formattedAddress }, place === null || place === void 0 ? void 0 : place.formattedAddress),
                                (place === null || place === void 0 ? void 0 : place.formattedAddress) && canCopy && (React__default$4.createElement(React__default$4.Fragment, null,
                                    React__default$4.createElement("span", { title: place === null || place === void 0 ? void 0 : place.formattedAddress }, place === null || place === void 0 ? void 0 : place.formattedAddress),
                                    React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Copy address") },
                                        React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: "content_copy", onClick: () => { var _a; return handleCopy((_a = place === null || place === void 0 ? void 0 : place.formattedAddress) !== null && _a !== void 0 ? _a : ""); } })))))),
                        React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement("div", { className: classes.tableCell }, place === null || place === void 0 ? void 0 :
                                place.phone,
                                (place === null || place === void 0 ? void 0 : place.phone) && canCopy && (React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Copy phone") },
                                    React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: "content_copy", onClick: () => { var _a; return handleCopy((_a = place === null || place === void 0 ? void 0 : place.phone) !== null && _a !== void 0 ? _a : ""); } }))))),
                        React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement("div", { className: classes.websiteCell },
                                (place === null || place === void 0 ? void 0 : place.website) && (React__default$4.createElement(React__default$4.Fragment, null,
                                    React__default$4.createElement("span", { title: place === null || place === void 0 ? void 0 : place.website }, place === null || place === void 0 ? void 0 : place.website),
                                    canCopy && (React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Copy website") },
                                        React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: "content_copy", onClick: () => { var _a; return handleCopy((_a = place === null || place === void 0 ? void 0 : place.website) !== null && _a !== void 0 ? _a : ""); } }))))),
                                !(place === null || place === void 0 ? void 0 : place.website) && React__default$4.createElement("i", null, "Not Set"))),
                        React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement("div", { className: classes.placeIdCell }, (place === null || place === void 0 ? void 0 : place.placeId) ? (React__default$4.createElement(React__default$4.Fragment, null,
                                React__default$4.createElement("span", { title: place === null || place === void 0 ? void 0 : place.placeId }, place === null || place === void 0 ? void 0 : place.placeId),
                                React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: onValueCopy && "content_copy", onClick: () => { var _a; return handleCopy((_a = place === null || place === void 0 ? void 0 : place.placeId) !== null && _a !== void 0 ? _a : ""); } }),
                                React__default$4.createElement("a", { href: `https://www.google.com/maps/place/?q=place_id:${place === null || place === void 0 ? void 0 : place.placeId}`, target: "_blank", rel: "noreferrer", title: "View on Google Maps" },
                                    React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: "link" })))) : (React__default$4.createElement("i", null, "Not Set")))),
                        hasAnyHours && (React__default$4.createElement(TableCell$1, { align: "center" },
                            React__default$4.createElement("div", { className: classes.hoursCell }, ((_b = place === null || place === void 0 ? void 0 : place.openingHours) === null || _b === void 0 ? void 0 : _b.weekdayText) && place.openingHours.weekdayText.length > 0 ? (React__default$4.createElement(React__default$4.Fragment, null,
                                React__default$4.createElement("span", { style: { fontSize: "13px" } }, getTodayHours(place.openingHours.weekdayText) || "—"),
                                React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "View all hours") },
                                    React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: "schedule", onClick: () => setHoursDialogPlace(place) })))) : (React__default$4.createElement("i", { style: { fontSize: "13px", color: "#999" } }, "Not Set"))))),
                        (canDelete || canEdit || canRefresh) && (React__default$4.createElement(TableCell$1, null,
                            React__default$4.createElement("div", { style: { display: "flex", flexDirection: "row", alignItems: "center" } },
                                canRefresh && (React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Refresh from Google") },
                                    React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: refreshingPlaceId === (place === null || place === void 0 ? void 0 : place.placeId) ? "hourglass_empty" : "refresh", disabled: refreshingPlaceId === (place === null || place === void 0 ? void 0 : place.placeId), onClick: () => { var _a; return handleRefresh(index, (_a = place === null || place === void 0 ? void 0 : place.placeId) !== null && _a !== void 0 ? _a : ""); } }))),
                                canEdit && (React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Edit this location") },
                                    React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: "edit", onClick: () => onPlaceEdit && onPlaceEdit(index, place) }))),
                                canDelete && (React__default$4.createElement(Tooltip$5, { content: React__default$4.createElement("p", { style: { width: "100px" } }, "Delete this location") },
                                    React__default$4.createElement(IconButton_1$1, { style: { border: "none", background: "none" }, icon: "delete", onClick: () => { var _a; return handleDelete(index, (_a = place === null || place === void 0 ? void 0 : place.placeId) !== null && _a !== void 0 ? _a : ""); } }))))))));
                })))),
        data && (data === null || data === void 0 ? void 0 : data.length) === 0 && (React__default$4.createElement("div", { style: {
                display: "flex",
                margin: "30px",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
            } }, emptyTableContent)),
        React__default$4.createElement(Dialog$1, { open: !!hoursDialogPlace, onClose: () => setHoursDialogPlace(null), maxWidth: "xs", fullWidth: true },
            React__default$4.createElement(DialogTitle, null,
                "Business Hours",
                (hoursDialogPlace === null || hoursDialogPlace === void 0 ? void 0 : hoursDialogPlace.name) && (React__default$4.createElement("div", { style: { fontSize: "14px", fontWeight: "normal", color: "#666", marginTop: "4px" } }, hoursDialogPlace.name))),
            React__default$4.createElement(DialogContent, null,
                ((_a = hoursDialogPlace === null || hoursDialogPlace === void 0 ? void 0 : hoursDialogPlace.openingHours) === null || _a === void 0 ? void 0 : _a.weekdayText) && hoursDialogPlace.openingHours.weekdayText.length > 0 ? (React__default$4.createElement("ul", { style: { margin: 0, padding: "0 0 0 20px", lineHeight: "1.8" } }, hoursDialogPlace.openingHours.weekdayText.map((text, idx) => {
                    // Highlight current day
                    const dayIndex = new Date().getDay();
                    const weekdayIndex = dayIndex === 0 ? 6 : dayIndex - 1;
                    const isToday = idx === weekdayIndex;
                    return (React__default$4.createElement("li", { key: idx, style: {
                            fontWeight: isToday ? 600 : 400,
                            color: isToday ? "#1976d2" : "#333",
                        } }, text));
                }))) : (React__default$4.createElement("p", { style: { color: "#999", fontStyle: "italic" } }, "No business hours available.")),
                (hoursDialogPlace === null || hoursDialogPlace === void 0 ? void 0 : hoursDialogPlace.lastRefreshedFromGoogle) && (React__default$4.createElement("p", { style: { marginTop: "16px", fontSize: "12px", color: "#888" } },
                    "Last updated: ",
                    new Date(hoursDialogPlace.lastRefreshedFromGoogle).toLocaleDateString()))),
            React__default$4.createElement(DialogActions, null,
                React__default$4.createElement(MuiButton, { onClick: () => setHoursDialogPlace(null) }, "Close")))));
};

const PlacesView = ({ config, value, onChange, onValueCopy, onPlaceVerify, onPlaceRefresh, refreshingPlaceId }) => {
    // Dialogs
    const [dialogActive, setDialogActive] = useState(false);
    const [jsonDialogActive, setJsonDialogActive] = useState(false);
    // Editing/Adding
    const [editingIndex, setEditingIndex] = useState(undefined);
    const [mutablePlace, setMutablePlace] = useState(undefined);
    const [valid, setValid] = useState(undefined);
    const handleJSONChange = useCallback((value) => {
        const copy = [...value];
        if (typeof onChange === "function") {
            onChange(copy);
        }
    }, [onChange]);
    const handleCloseDialog = useCallback(() => {
        setDialogActive(false);
        setEditingIndex(undefined);
        setMutablePlace(undefined);
    }, []);
    const handleEditPlace = (index, place) => {
        setEditingIndex(index);
        setMutablePlace(place);
        setDialogActive(true);
    };
    const handleDoneEdit = useCallback(() => {
        setDialogActive(false);
        setEditingIndex(undefined);
        if (typeof editingIndex === "number" && mutablePlace) {
            const copy = [...value];
            copy[editingIndex] = mutablePlace;
            if (typeof onChange === "function") {
                onChange(copy);
            }
        }
        setMutablePlace(undefined);
    }, [editingIndex, onChange, mutablePlace, value]);
    const handlePlaceDelete = useCallback((index, placeId) => {
        const copy = [...value];
        copy.splice(index, 1);
        if (typeof onChange === "function") {
            onChange(copy);
        }
    }, [onChange, value]);
    const handleBookingOptOut = useCallback((index, placeId, bookingOptOut) => {
        const copy = [...value];
        // copy the place at the index and update the bookingOptOut
        const newPlace = Object.assign({}, copy[index]);
        newPlace.bookingOptOut = bookingOptOut;
        copy[index] = newPlace;
        if (typeof onChange === "function") {
            onChange(copy);
        }
    }, [onChange, value]);
    // Adds a new Place
    const handleAddNewPlace = useCallback(() => {
        // add the new place to the list
        if (typeof onChange === "function") {
            const copy = [...value];
            if (mutablePlace) {
                copy.push(mutablePlace);
            }
            onChange(copy);
        }
        setMutablePlace(undefined);
        setEditingIndex(undefined);
        setDialogActive(false);
    }, [mutablePlace, onChange, value]);
    // Updates mutable place from the AddressView
    const handleMutablePlaceChange = useCallback((place, valid) => {
        setMutablePlace(place);
        setValid(valid);
    }, []);
    const handleAddPlaceRequest = () => {
        setDialogActive(true);
        setMutablePlace({});
    };
    const actions = [
        {
            label: "Close",
            onClick: handleCloseDialog,
            variation: "secondary",
        },
    ];
    if (editingIndex !== undefined) {
        actions.push({
            label: "Done",
            onClick: handleDoneEdit,
            disabled: typeof valid === "boolean" ? !valid : true,
            variation: "primary",
        });
    }
    else {
        actions.push({
            label: "Add",
            onClick: handleAddNewPlace,
            disabled: typeof valid === "boolean" ? !valid : true,
            variation: "primary",
        });
    }
    const editing = editingIndex !== undefined;
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement(TitleHeader, { value: "Locations" },
            React__default$4.createElement(Tooltip$5, { content: "JSON" },
                React__default$4.createElement(IconButton, { iconName: "code", onClick: () => setJsonDialogActive(true) })),
            React__default$4.createElement(Tooltip$5, { content: "Add Place" },
                React__default$4.createElement(IconButton, { iconName: "add", onClick: handleAddPlaceRequest })), config === null || config === void 0 ? void 0 :
            config.titleButtons),
        React__default$4.createElement("section", null,
            React__default$4.createElement(PageAlert, { background: "blue" },
                React__default$4.createElement("p", null, " Add a location to your business."),
                React__default$4.createElement("p", null,
                    "These will be used to match to your Google Business Profile where we will add a \"Book Online\" button. To disable the \"Book Online\" button, select \"Opt-Out\" for the location. Each location will be verified based on your credentials & billing information to determine if you are the owner of the profile before it is published.",
                    " ")),
            React__default$4.createElement(PlacesTable, { data: value, onValueCopy: onValueCopy, onPlaceEdit: handleEditPlace, onPlaceOptOut: handleBookingOptOut, onPlaceDelete: handlePlaceDelete, onPlaceVerify: onPlaceVerify, onPlaceRefresh: onPlaceRefresh, refreshingPlaceId: refreshingPlaceId, emptyTableContent: React__default$4.createElement("div", null,
                    React__default$4.createElement(Button, { variation: "primary", label: "ADD", onClick: () => setDialogActive(true) })) })),
        React__default$4.createElement(Dialog, { title: editing ? "Edit" : (config === null || config === void 0 ? void 0 : config.titleDialog) || "Add Place", active: dialogActive, onClose: () => setDialogActive(false), actions: actions, fullWidth: true, maxWidth: "md", style: { zIndex: 999 } },
            React__default$4.createElement("div", { style: { height: 420 } },
                React__default$4.createElement(AddressView, { value: mutablePlace, onChange: handleMutablePlaceChange, editMode: editing }))),
        React__default$4.createElement(JSONEditorDialog, { title: "Edit JSON", active: jsonDialogActive, fullWidth: true, value: value, onDismissRequest: () => setJsonDialogActive(false), onChange: handleJSONChange })));
};

var css_248z$x = ".style_container__HEEmO {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.style_wrap__vo5LT {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.style_compactWrap__-mhc3 {\n  justify-content: center;\n}\n\n.style_name__jhU09 {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 0;\n  color: #000000;\n}\n\n.style_priceWrap__pXtYO {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.style_compactPriceWrap__k-ew3 {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin: 0 10px;\n}\n\n.style_originalPrice__Avgc4 {\n  color: rgb(125.75, 125.75, 125.75);\n  text-decoration: line-through;\n  font-size: 1.5rem;\n}\n\n.style_price__gMjoa {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin: 8px;\n  color: #1aa7dc;\n}\n@media (max-width: 768px) {\n  .style_price__gMjoa {\n    margin: 2px;\n  }\n}\n\n.style_priceLong__QjLGr {\n  font-size: 1rem;\n}\n\np {\n  margin: 0;\n}\n\n.style_clarificationText__wZLBv {\n  font-size: 1.2rem;\n  color: #000000;\n}\n\n.style_compactClarificationText__L5IZJ {\n  font-size: 0.8rem;\n  color: rgb(125.75, 125.75, 125.75);\n  margin: 0 10px;\n}\n\n.style_cancellationText__aQU3b {\n  font-size: 1.2rem;\n  color: #000000;\n  margin: 0 10px;\n}\n\n.style_compactCancellationText__qGDnL {\n  font-size: 0.8rem;\n  color: rgb(125.75, 125.75, 125.75);\n  margin: 0 10px;\n}\n\n.style_field__cA6mp {\n  cursor: pointer;\n  display: flex;\n  height: auto;\n}\n\n.style_title__K18uI {\n  font-size: 1.25rem;\n  font-weight: bold;\n  margin: 0;\n}\n\n.style_description__jEfCa {\n  margin: 0;\n  color: rgb(125.75, 125.75, 125.75);\n  padding: 10px;\n}\n\n.style_examples__02nUG {\n  color: #000000;\n}\n\n.style_list__5Th8K {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.style_featuresList__8zYgZ {\n  list-style: square;\n}\n.style_featuresList__8zYgZ li {\n  font-style: normal;\n}";
var style$p = {"container":"style_container__HEEmO","wrap":"style_wrap__vo5LT","compactWrap":"style_compactWrap__-mhc3","name":"style_name__jhU09","priceWrap":"style_priceWrap__pXtYO","compactPriceWrap":"style_compactPriceWrap__k-ew3","originalPrice":"style_originalPrice__Avgc4","price":"style_price__gMjoa","priceLong":"style_priceLong__QjLGr","clarificationText":"style_clarificationText__wZLBv","compactClarificationText":"style_compactClarificationText__L5IZJ","cancellationText":"style_cancellationText__aQU3b","compactCancellationText":"style_compactCancellationText__qGDnL","field":"style_field__cA6mp","title":"style_title__K18uI","description":"style_description__jEfCa","examples":"style_examples__02nUG","list":"style_list__5Th8K","featuresList":"style_featuresList__8zYgZ"};
styleInject(css_248z$x);

/**
 * Simple Pricing Component
 */
const Pricing = (props) => {
    const { name, priceInCents, trialDays, coupon, config, clarificationText, cancellationText } = props;
    let { price } = props;
    const { compact } = config || {};
    const couponFontSize = compact ? "0.7rem" : "0.9rem";
    let fontSize = config === null || config === void 0 ? void 0 : config.fontSize;
    if (!fontSize || typeof fontSize !== "string") {
        // if we are one line, we want a smaller font size
        fontSize = compact ? "1.25rem" : "1.5rem";
    }
    let percentOff = 0;
    if (typeof coupon === "object" && typeof coupon.percentOff === "number") {
        percentOff = coupon.percentOff;
    }
    const billingFrequency = compact ? "mo" : "month";
    // make sure price ends in /month if it doesn't already
    if (!(price === null || price === void 0 ? void 0 : price.endsWith("month"))) {
        price += ` / ${billingFrequency}`;
    }
    const currency = props.currency || "$";
    const hasTrial = typeof trialDays === "number" && trialDays > 0;
    const hasCoupon = !!coupon && typeof coupon === "object" && typeof priceInCents === "number" && percentOff > 0;
    const isForeverCoupon = (coupon === null || coupon === void 0 ? void 0 : coupon.duration) === "forever";
    // reduced price in cents
    const reducedPriceInCents = hasCoupon && typeof priceInCents === "number" ? priceInCents * (1 - percentOff / 100) : 0;
    // now convert to dollars, rounded to the nearest cent
    const reducedPriceInDollars = Math.round(reducedPriceInCents) / 100;
    let couponDescription = "";
    if (hasCoupon) {
        switch (coupon.duration) {
            case "forever":
                couponDescription = compact ? `` : `${coupon.percentOff}% off forever`;
                break;
            case "once":
                couponDescription = compact
                    ? `for 1 month then ${price}`
                    : `${coupon.percentOff}% off once then ${price}`;
                break;
            case "repeating":
            default:
                couponDescription = compact
                    ? `for ${coupon.durationInMonths} months`
                    : `${coupon.percentOff}% off for ${coupon.durationInMonths} months then ${price}`;
                break;
        }
    }
    // round to the nearest cent
    const displayPrice = hasCoupon ? `${currency}${reducedPriceInDollars} / ${billingFrequency}` : `${price}`;
    const priceDescription = hasTrial ? `${trialDays} Days Free then ${displayPrice}` : displayPrice;
    // Display Strategy:
    // - if we have a coupon, we show the original price above the computed price above it with a strike through
    // - if we have a trial, we change the price language to be "X Days Free then $Y / month"
    const priceClass = classNames$1(style$p.price, {
        [style$p.priceLong]: hasTrial,
    });
    return (React__default$4.createElement("div", { className: style$p.container },
        React__default$4.createElement("div", { className: classNames$1(style$p.wrap, { [style$p.compactWrap]: compact }) },
            name ? (React__default$4.createElement("h1", { style: { fontSize }, className: style$p.name }, name)) : (React__default$4.createElement(React__default$4.Fragment, null)),
            React__default$4.createElement("div", { className: classNames$1(style$p.priceWrap, { [style$p.compactPriceWrap]: compact }) },
                hasCoupon && !isForeverCoupon && !compact ? (React__default$4.createElement("div", { className: style$p.originalPrice }, price)) : (React__default$4.createElement(React__default$4.Fragment, null, " ")),
                React__default$4.createElement("h4", { style: { fontSize }, className: priceClass }, priceDescription),
                hasCoupon && !isForeverCoupon && couponDescription ? (React__default$4.createElement("small", { style: { fontSize: couponFontSize } }, couponDescription)) : (React__default$4.createElement(React__default$4.Fragment, null)),
                hasTrial && !compact ? (React__default$4.createElement("small", null,
                    "Credit Card Required, nothing billed for ",
                    trialDays,
                    " days")) : (React__default$4.createElement(React__default$4.Fragment, null)))),
        clarificationText ? (React__default$4.createElement("div", { className: classNames$1(style$p.clarificationText, { [style$p.compactClarificationText]: compact }) },
            React__default$4.createElement("small", null, clarificationText))) : (React__default$4.createElement(React__default$4.Fragment, null)),
        cancellationText ? (React__default$4.createElement("div", { className: classNames$1(style$p.cancellationText, { [style$p.compactCancellationText]: compact }) },
            React__default$4.createElement("small", null, cancellationText))) : (React__default$4.createElement(React__default$4.Fragment, null))));
};

var css_248z$w = ".style_container__nTH-e {\n  display: flex;\n}\n\n.style_input__n2jG2 {\n  display: flex;\n  width: 0%;\n  transition: width 0.3s ease-in-out;\n  background-color: transparent;\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n  color: #3e3e3e;\n  outline: none;\n  padding: 0;\n}\n\n.style_active__eRUnt {\n  width: 100%;\n}";
var style$o = {"container":"style_container__nTH-e","input":"style_input__n2jG2","active":"style_active__eRUnt"};
styleInject(css_248z$w);

const SearchBar = props => {
    const { value, onChange } = props;
    const handleSearchChange = useCallback((value) => {
        onChange(value);
    }, [onChange]);
    const classNames = classNames$1(style$o.input, { [style$o.active]: props.expanded });
    return (React__default$4.createElement("span", { className: style$o.container },
        React__default$4.createElement(IconButton, { iconName: "search", onClick: props.onToggle }),
        React__default$4.createElement(Input$3, { className: classNames, placeholder: "Search", value: value || "", onChange: handleSearchChange })));
};

// antiguo
const ExpandableSearchBar = ({ value, onChange }) => {
    const [searchBarVisible, setSearchBarVisible] = useState(!!value);
    const toggleSearchBar = useCallback(() => {
        setSearchBarVisible(cur => !cur);
    }, []);
    return (React__default$4.createElement(SearchBar, { value: value, onChange: onChange, onToggle: toggleSearchBar, expanded: searchBarVisible }));
};

const Select = (_a) => {
    var { label, size, variation = "standard", fullWidth, items, onChange, displayEmpty, value } = _a, props = __rest$2(_a, ["label", "size", "variation", "fullWidth", "items", "onChange", "displayEmpty", "value"]);
    return (React__default$4.createElement(FormControl, { fullWidth: fullWidth, size: size },
        React__default$4.createElement(InputLabel$1, { id: "select-label", shrink: displayEmpty || (value !== undefined && value !== '') }, label),
        React__default$4.createElement(Select$1, Object.assign({}, props, { variant: variation, labelId: "select-label", displayEmpty: displayEmpty, value: value, onChange: (evt) => { onChange && onChange(evt.target.value); } }), items.map((item) => (React__default$4.createElement(MenuItem, { key: item.value, value: item.value }, item.label))))));
};

var css_248z$v = ".SiteFooter_footer__BBt-7 {\n  display: flex;\n  border-top: solid 1px var(--divider-color, #061739);\n  padding-top: 16px;\n  box-sizing: border-box;\n}\n\n.SiteFooter_links__Qm--C {\n  display: flex;\n  flex: 1 1 auto;\n  margin: 0 16px;\n  justify-content: space-around;\n}\n\n.SiteFooter_linksItem__LfFRF {\n  display: flex;\n}\n\n.SiteFooter_link__9uGDU {\n  padding: 0 8px;\n}\n.SiteFooter_link__9uGDU, .SiteFooter_link__9uGDU:hover, .SiteFooter_link__9uGDU:visited, .SiteFooter_link__9uGDU:link {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 14px;\n  line-height: 17px;\n  font-weight: 500;\n  color: var(--menubar-item-inactive-color, var(--text-color, #000));\n}\n\n.SiteFooter_activeLink__Y7tPw, .SiteFooter_activeLink__Y7tPw:hover, .SiteFooter_activeLink__Y7tPw:visited, .SiteFooter_activeLink__Y7tPw:link {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 14px;\n  line-height: 17px;\n  font-weight: 800;\n  color: var(--menubar-item-active-color, #3295d2);\n}\n\n.SiteFooter_xappLogo__bk8dl {\n  width: 100px;\n  height: 16px;\n}\n\n.SiteFooter_xappLogoImg__Vq3ne {\n  object-fit: contain;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.SiteFooter_awsLogo__v6pOI {\n  width: 182px;\n  height: 30px;\n}\n\n.SiteFooter_awsLogoImg__MHbNM {\n  object-fit: contain;\n  max-width: 100%;\n  max-height: 100%;\n}";
var style$n = {"footer":"SiteFooter_footer__BBt-7","links":"SiteFooter_links__Qm--C","linksItem":"SiteFooter_linksItem__LfFRF","link":"SiteFooter_link__9uGDU","activeLink":"SiteFooter_activeLink__Y7tPw","xappLogo":"SiteFooter_xappLogo__bk8dl","xappLogoImg":"SiteFooter_xappLogoImg__Vq3ne","awsLogo":"SiteFooter_awsLogo__v6pOI","awsLogoImg":"SiteFooter_awsLogoImg__MHbNM"};
styleInject(css_248z$v);

const items = [{
        label: "Workshop",
        url: "#"
    }, {
        active: true,
        label: "Resources",
        url: "#",
    }, {
        label: "Support",
        url: "#"
    }];
const SiteFooterInner = () => {
    return (React__default$4.createElement("footer", { className: style$n.footer },
        React__default$4.createElement("div", { className: style$n.xappLogo },
            React__default$4.createElement("img", { className: style$n.xappLogoImg, src: "/img/xappailogo_purple.svg", alt: "XAPP" })),
        React__default$4.createElement("nav", { className: style$n.links }, items.map((item, index) => (React__default$4.createElement("li", { key: index, className: style$n.linksItem },
            React__default$4.createElement("a", { href: item.url, className: style$n.link + (item.active ? " " + style$n.activeLink : "") }, item.label))))),
        React__default$4.createElement("div", { className: style$n.awsLogo },
            React__default$4.createElement("img", { className: style$n.awsLogoImg, src: "/img/aws.png", alt: "AWS" }))));
};
const SiteFooter = React__default$4.memo(SiteFooterInner);

var css_248z$u = ".SiteHeader_siteHeader__9aqDx {\n  background-color: #061739;\n  color: #fff;\n  --body-background: #000;\n  --content-background: #000;\n  --content-alternative-background: rgb(63.75, 63.75, 63.75);\n  --divider-color: rgb(63.75, 63.75, 63.75);\n  --form-control-background: #061739;\n  --form-control-color: #ffffff;\n  --text-color: #fff;\n  --menubar-background: #3295d2;\n  --menubar-item-active-color: var(--text-color, #000);\n  --menubar-item-inactive-color: var(--text-color, #000);\n  display: flex;\n  flex-direction: row;\n  background: #061739;\n  height: 82px;\n  flex: 0 0 82px;\n  align-items: center;\n  box-sizing: border-box;\n}";
var style$m = {"siteHeader":"SiteHeader_siteHeader__9aqDx"};
styleInject(css_248z$u);

const SiteHeader = props => {
    return (React__default$4.createElement("header", { className: style$m.siteHeader }, props.children));
};

var css_248z$t = ".SiteHeaderIconButton_icon__mv-qt {\n  cursor: pointer;\n  padding: 20px;\n  border: none;\n  background: none;\n}\n.SiteHeaderIconButton_icon__mv-qt .material-icons {\n  color: #ffffff;\n}";
var style$l = {"icon":"SiteHeaderIconButton_icon__mv-qt"};
styleInject(css_248z$t);

const SiteHeaderIconButton = props => {
    return (React__default$4.createElement("button", { className: style$l.icon, onClick: props.onClick },
        React__default$4.createElement(Icon$1, { iconName: props.icon })));
};

var css_248z$s = ".SiteHeaderIconLink_icon__4zUeH {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 24px;\n  text-decoration: none;\n}\n.SiteHeaderIconLink_icon__4zUeH .material-icons {\n  color: #ffffff;\n}\n.SiteHeaderIconLink_icon__4zUeH .material-icons {\n  font-size: 32px;\n}";
var style$k = {"icon":"SiteHeaderIconLink_icon__4zUeH"};
styleInject(css_248z$s);

const SiteHeaderIconLink = props => {
    return (React__default$4.createElement(Link, { className: style$k.icon, href: props.href },
        React__default$4.createElement(Icon$1, { iconName: props.icon })));
};

var css_248z$r = ".SiteHeaderImageLink_icon__ZFi-5 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px 24px;\n  max-width: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.SiteHeaderImageLink_img__lkOXt {\n  width: 34px;\n  height: 34px;\n  object-fit: cover;\n  overflow: hidden;\n  border-radius: 17px;\n  border: solid 2px #ffffff;\n  box-sizing: border-box;\n}";
var style$j = {"icon":"SiteHeaderImageLink_icon__ZFi-5","img":"SiteHeaderImageLink_img__lkOXt"};
styleInject(css_248z$r);

const SiteHeaderImageLink = props => {
    return (React__default$4.createElement(Link, { className: style$j.icon, href: props.href },
        React__default$4.createElement("img", { src: props.src, className: style$j.img, alt: props.alt })));
};

var css_248z$q = ".StandardSiteHeader_logo__nuRvi {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  overflow: hidden;\n  padding: 20px 24px 20px 20px;\n  box-sizing: border-box;\n}\n\n.StandardSiteHeader_title__woRAy {\n  font-family: proxima-nova, Roboto, Georgia;\n  font-size: 36px;\n  line-height: 44px;\n  font-weight: 500;\n  color: #ffffff;\n  margin-right: 24px;\n  margin: 20px 24px 20px 20px;\n}\n\n.StandardSiteHeader_search__Qw2Wx {\n  margin-right: 24px;\n}\n\n.StandardSiteHeader_lang__eTMVD {\n  display: flex;\n  width: 112px;\n  margin-right: 24px;\n}";
var style$i = {"logo":"StandardSiteHeader_logo__nuRvi","title":"StandardSiteHeader_title__woRAy","search":"StandardSiteHeader_search__Qw2Wx","lang":"StandardSiteHeader_lang__eTMVD"};
styleInject(css_248z$q);

const StandardSiteHeader = () => {
    const [lang, setLang] = useState("en");
    const handleSearch = useCallback(() => {
    }, []);
    return (React__default$4.createElement(SiteHeader, null,
        React__default$4.createElement(Link, { href: "/" },
            React__default$4.createElement("img", { className: style$i.logo, src: "/img/xapp-logo-teal.svg", alt: "XAPP" })),
        React__default$4.createElement("div", { className: style$i.title }, "Optimal Conversation\u2122 Documentation"),
        React__default$4.createElement(Expander, null),
        React__default$4.createElement("div", { className: style$i.search },
            React__default$4.createElement(SearchBar, { onChange: handleSearch, value: "", expanded: false })),
        React__default$4.createElement("div", { className: style$i.lang },
            React__default$4.createElement(LanguagePicker, { value: lang, onChange: setLang })),
        React__default$4.createElement(SiteHeaderIconLink, { icon: "account_circle", href: "/settings" })));
};

var Autosuggest$1 = {};

function shallowEqualArrays(arrA, arrB) {
  if (arrA === arrB) {
    return true;
  }

  if (!arrA || !arrB) {
    return false;
  }

  var len = arrA.length;

  if (arrB.length !== len) {
    return false;
  }

  for (var i = 0; i < len; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
}

var arrays = shallowEqualArrays;

var Autowhatever$1 = {};

var _slicedToArray$1 = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var dist$3 = function (_ref) {
  var data = _ref.data;
  var multiSection = _ref.multiSection;

  function nextNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = 0;
    } else {
      sectionIndex++;
    }

    while (sectionIndex < data.length && data[sectionIndex] === 0) {
      sectionIndex++;
    }

    return sectionIndex === data.length ? null : sectionIndex;
  }

  function prevNonEmptySectionIndex(sectionIndex) {
    if (sectionIndex === null) {
      sectionIndex = data.length - 1;
    } else {
      sectionIndex--;
    }

    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
      sectionIndex--;
    }

    return sectionIndex === -1 ? null : sectionIndex;
  }

  function next(position) {
    var _position = _slicedToArray$1(position, 2);

    var sectionIndex = _position[0];
    var itemIndex = _position[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
        sectionIndex = nextNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, 0];
      }

      return [sectionIndex, itemIndex + 1];
    }

    if (data === 0 || itemIndex === data - 1) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, 0];
    }

    return [null, itemIndex + 1];
  }

  function prev(position) {
    var _position2 = _slicedToArray$1(position, 2);

    var sectionIndex = _position2[0];
    var itemIndex = _position2[1];


    if (multiSection) {
      if (itemIndex === null || itemIndex === 0) {
        sectionIndex = prevNonEmptySectionIndex(sectionIndex);

        if (sectionIndex === null) {
          return [null, null];
        }

        return [sectionIndex, data[sectionIndex] - 1];
      }

      return [sectionIndex, itemIndex - 1];
    }

    if (data === 0 || itemIndex === 0) {
      return [null, null];
    }

    if (itemIndex === null) {
      return [null, data - 1];
    }

    return [null, itemIndex - 1];
  }

  function isLast(position) {
    return next(position)[1] === null;
  }

  return {
    next: next,
    prev: prev,
    isLast: isLast
  };
};

var dist$2 = {exports: {}};

var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function ownEnumerableKeys(obj) {
	var keys = Object.getOwnPropertyNames(obj);

	if (Object.getOwnPropertySymbols) {
		keys = keys.concat(Object.getOwnPropertySymbols(obj));
	}

	return keys.filter(function (key) {
		return propIsEnumerable.call(obj, key);
	});
}

var objectAssign = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = ownEnumerableKeys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};

(function (module, exports) {

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _objectAssign = objectAssign;

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var truthy = function truthy(x) {
  return x;
};

exports['default'] = function (input) {
  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];

  var _ref2 = _slicedToArray(_ref, 2);

  var theme = _ref2[0];
  var classNameDecorator = _ref2[1];

  return function (key) {
    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      names[_key - 1] = arguments[_key];
    }

    var styles = names.map(function (name) {
      return theme[name];
    }).filter(truthy);

    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
  };
};

module.exports = exports['default'];
}(dist$2, dist$2.exports));

var SectionTitle$1 = {};

var compareObjects$1 = {};

Object.defineProperty(compareObjects$1, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

compareObjects$1.default = compareObjects;
function compareObjects(objA, objB) {
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (objA === objB) {
    return false;
  }

  var aKeys = Object.keys(objA);
  var bKeys = Object.keys(objB);

  if (aKeys.length !== bKeys.length) {
    return true;
  }

  var keysMap = {};
  var i = void 0,
      len = void 0;

  for (i = 0, len = keys.length; i < len; i++) {
    keysMap[keys[i]] = true;
  }

  for (i = 0, len = aKeys.length; i < len; i++) {
    var key = aKeys[i];
    var aValue = objA[key];
    var bValue = objB[key];

    if (aValue === bValue) {
      continue;
    }

    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
      return true;
    }

    var aValueKeys = Object.keys(aValue);
    var bValueKeys = Object.keys(bValue);

    if (aValueKeys.length !== bValueKeys.length) {
      return true;
    }

    for (var n = 0, length = aValueKeys.length; n < length; n++) {
      var aValueKey = aValueKeys[n];

      if (aValue[aValueKey] !== bValue[aValueKey]) {
        return true;
      }
    }
  }

  return false;
}

Object.defineProperty(SectionTitle$1, "__esModule", {
  value: true
});

var _createClass$5 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$6 = React__default$4;

var _react2$6 = _interopRequireDefault$9(_react$6);

var _propTypes$6 = propTypes.exports;

var _propTypes2$6 = _interopRequireDefault$9(_propTypes$6);

var _compareObjects$2 = compareObjects$1;

var _compareObjects2$2 = _interopRequireDefault$9(_compareObjects$2);

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SectionTitle = function (_Component) {
  _inherits$5(SectionTitle, _Component);

  function SectionTitle() {
    _classCallCheck$5(this, SectionTitle);

    return _possibleConstructorReturn$5(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
  }

  _createClass$5(SectionTitle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2$2.default)(nextProps, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          section = _props.section,
          renderSectionTitle = _props.renderSectionTitle,
          theme = _props.theme,
          sectionKeyPrefix = _props.sectionKeyPrefix;

      var sectionTitle = renderSectionTitle(section);

      if (!sectionTitle) {
        return null;
      }

      return _react2$6.default.createElement(
        'div',
        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
        sectionTitle
      );
    }
  }]);

  return SectionTitle;
}(_react$6.Component);

SectionTitle.propTypes = {
  section: _propTypes2$6.default.any.isRequired,
  renderSectionTitle: _propTypes2$6.default.func.isRequired,
  theme: _propTypes2$6.default.func.isRequired,
  sectionKeyPrefix: _propTypes2$6.default.string.isRequired
};
SectionTitle$1.default = SectionTitle;

var ItemsList$1 = {};

var Item$1 = {};

Object.defineProperty(Item$1, "__esModule", {
  value: true
});

var _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$5 = React__default$4;

var _react2$5 = _interopRequireDefault$8(_react$5);

var _propTypes$5 = propTypes.exports;

var _propTypes2$5 = _interopRequireDefault$8(_propTypes$5);

var _compareObjects$1 = compareObjects$1;

var _compareObjects2$1 = _interopRequireDefault$8(_compareObjects$1);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits$4(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$4(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$4(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
      if (item !== null) {
        _this.item = item;
      }
    }, _this.onMouseEnter = function (event) {
      var _this$props = _this.props,
          sectionIndex = _this$props.sectionIndex,
          itemIndex = _this$props.itemIndex;


      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseLeave = function (event) {
      var _this$props2 = _this.props,
          sectionIndex = _this$props2.sectionIndex,
          itemIndex = _this$props2.itemIndex;


      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onMouseDown = function (event) {
      var _this$props3 = _this.props,
          sectionIndex = _this$props3.sectionIndex,
          itemIndex = _this$props3.itemIndex;


      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _this.onClick = function (event) {
      var _this$props4 = _this.props,
          sectionIndex = _this$props4.sectionIndex,
          itemIndex = _this$props4.itemIndex;


      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
    }, _temp), _possibleConstructorReturn$4(_this, _ret);
  }

  _createClass$4(Item, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2$1.default)(nextProps, this.props, ['renderItemData']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isHighlighted = _props.isHighlighted,
          item = _props.item,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          restProps = _objectWithoutProperties$2(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);

      delete restProps.sectionIndex;
      delete restProps.itemIndex;

      if (typeof restProps.onMouseEnter === 'function') {
        restProps.onMouseEnter = this.onMouseEnter;
      }

      if (typeof restProps.onMouseLeave === 'function') {
        restProps.onMouseLeave = this.onMouseLeave;
      }

      if (typeof restProps.onMouseDown === 'function') {
        restProps.onMouseDown = this.onMouseDown;
      }

      if (typeof restProps.onClick === 'function') {
        restProps.onClick = this.onClick;
      }

      return _react2$5.default.createElement(
        'li',
        _extends$5({ role: 'option' }, restProps, { ref: this.storeItemReference }),
        renderItem(item, _extends$5({ isHighlighted: isHighlighted }, renderItemData))
      );
    }
  }]);

  return Item;
}(_react$5.Component);

Item.propTypes = {
  sectionIndex: _propTypes2$5.default.number,
  isHighlighted: _propTypes2$5.default.bool.isRequired,
  itemIndex: _propTypes2$5.default.number.isRequired,
  item: _propTypes2$5.default.any.isRequired,
  renderItem: _propTypes2$5.default.func.isRequired,
  renderItemData: _propTypes2$5.default.object.isRequired,
  onMouseEnter: _propTypes2$5.default.func,
  onMouseLeave: _propTypes2$5.default.func,
  onMouseDown: _propTypes2$5.default.func,
  onClick: _propTypes2$5.default.func
};
Item$1.default = Item;

Object.defineProperty(ItemsList$1, "__esModule", {
  value: true
});

var _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$4 = React__default$4;

var _react2$4 = _interopRequireDefault$7(_react$4);

var _propTypes$4 = propTypes.exports;

var _propTypes2$4 = _interopRequireDefault$7(_propTypes$4);

var _Item = Item$1;

var _Item2 = _interopRequireDefault$7(_Item);

var _compareObjects = compareObjects$1;

var _compareObjects2 = _interopRequireDefault$7(_compareObjects);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ItemsList = function (_Component) {
  _inherits$3(ItemsList, _Component);

  function ItemsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$3(this, ItemsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$3(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
    }, _temp), _possibleConstructorReturn$3(_this, _ret);
  }

  _createClass$3(ItemsList, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          itemProps = _props.itemProps,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          sectionIndex = _props.sectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          getItemId = _props.getItemId,
          theme = _props.theme,
          keyPrefix = _props.keyPrefix;

      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
      var isItemPropsFunction = typeof itemProps === 'function';

      return _react2$4.default.createElement(
        'ul',
        _extends$4({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
        items.map(function (item, itemIndex) {
          var isFirst = itemIndex === 0;
          var isHighlighted = itemIndex === highlightedItemIndex;
          var itemKey = sectionPrefix + 'item-' + itemIndex;
          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
          var allItemProps = _extends$4({
            id: getItemId(sectionIndex, itemIndex),
            'aria-selected': isHighlighted
          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);

          if (isHighlighted) {
            allItemProps.ref = _this2.storeHighlightedItemReference;
          }

          // `key` is provided by theme()
          /* eslint-disable react/jsx-key */
          return _react2$4.default.createElement(_Item2.default, _extends$4({}, allItemProps, {
            sectionIndex: sectionIndex,
            isHighlighted: isHighlighted,
            itemIndex: itemIndex,
            item: item,
            renderItem: renderItem,
            renderItemData: renderItemData
          }));
          /* eslint-enable react/jsx-key */
        })
      );
    }
  }]);

  return ItemsList;
}(_react$4.Component);

ItemsList.propTypes = {
  items: _propTypes2$4.default.array.isRequired,
  itemProps: _propTypes2$4.default.oneOfType([_propTypes2$4.default.object, _propTypes2$4.default.func]),
  renderItem: _propTypes2$4.default.func.isRequired,
  renderItemData: _propTypes2$4.default.object.isRequired,
  sectionIndex: _propTypes2$4.default.number,
  highlightedItemIndex: _propTypes2$4.default.number,
  onHighlightedItemChange: _propTypes2$4.default.func.isRequired,
  getItemId: _propTypes2$4.default.func.isRequired,
  theme: _propTypes2$4.default.func.isRequired,
  keyPrefix: _propTypes2$4.default.string.isRequired
};
ItemsList.defaultProps = {
  sectionIndex: null
};
ItemsList$1.default = ItemsList;

Object.defineProperty(Autowhatever$1, "__esModule", {
  value: true
});

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$3 = React__default$4;

var _react2$3 = _interopRequireDefault$6(_react$3);

var _propTypes$3 = propTypes.exports;

var _propTypes2$3 = _interopRequireDefault$6(_propTypes$3);

var _sectionIterator = dist$3;

var _sectionIterator2 = _interopRequireDefault$6(_sectionIterator);

var _reactThemeable = dist$2.exports;

var _reactThemeable2 = _interopRequireDefault$6(_reactThemeable);

var _SectionTitle = SectionTitle$1;

var _SectionTitle2 = _interopRequireDefault$6(_SectionTitle);

var _ItemsList = ItemsList$1;

var _ItemsList2 = _interopRequireDefault$6(_ItemsList);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyObject = {};
var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
  return _react2$3.default.createElement('input', props);
};
var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2$3.default.createElement(
    'div',
    containerProps,
    children
  );
};
var defaultTheme = {
  container: 'react-autowhatever__container',
  containerOpen: 'react-autowhatever__container--open',
  input: 'react-autowhatever__input',
  inputOpen: 'react-autowhatever__input--open',
  inputFocused: 'react-autowhatever__input--focused',
  itemsContainer: 'react-autowhatever__items-container',
  itemsContainerOpen: 'react-autowhatever__items-container--open',
  itemsList: 'react-autowhatever__items-list',
  item: 'react-autowhatever__item',
  itemFirst: 'react-autowhatever__item--first',
  itemHighlighted: 'react-autowhatever__item--highlighted',
  sectionContainer: 'react-autowhatever__section-container',
  sectionContainerFirst: 'react-autowhatever__section-container--first',
  sectionTitle: 'react-autowhatever__section-title'
};

var Autowhatever = function (_Component) {
  _inherits$2(Autowhatever, _Component);

  function Autowhatever(props) {
    _classCallCheck$2(this, Autowhatever);

    var _this = _possibleConstructorReturn$2(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));

    _this.storeInputReference = function (input) {
      if (input !== null) {
        _this.input = input;
      }
    };

    _this.storeItemsContainerReference = function (itemsContainer) {
      if (itemsContainer !== null) {
        _this.itemsContainer = itemsContainer;
      }
    };

    _this.onHighlightedItemChange = function (highlightedItem) {
      _this.highlightedItem = highlightedItem;
    };

    _this.getItemId = function (sectionIndex, itemIndex) {
      if (itemIndex === null) {
        return null;
      }

      var id = _this.props.id;

      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;

      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
    };

    _this.onFocus = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: true
      });

      inputProps.onFocus && inputProps.onFocus(event);
    };

    _this.onBlur = function (event) {
      var inputProps = _this.props.inputProps;


      _this.setState({
        isInputFocused: false
      });

      inputProps.onBlur && inputProps.onBlur(event);
    };

    _this.onKeyDown = function (event) {
      var _this$props = _this.props,
          inputProps = _this$props.inputProps,
          highlightedSectionIndex = _this$props.highlightedSectionIndex,
          highlightedItemIndex = _this$props.highlightedItemIndex;


      switch (event.key) {
        case 'ArrowDown':
        case 'ArrowUp':
          {
            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';

            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
                newHighlightedSectionIndex = _this$sectionIterator2[0],
                newHighlightedItemIndex = _this$sectionIterator2[1];

            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
            break;
          }

        default:
          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
      }
    };

    _this.highlightedItem = null;

    _this.state = {
      isInputFocused: false
    };

    _this.setSectionsItems(props);
    _this.setSectionIterator(props);
    _this.setTheme(props);
    return _this;
  }

  _createClass$2(Autowhatever, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.ensureHighlightedItemIsVisible();
    }

    // eslint-disable-next-line camelcase, react/sort-comp

  }, {
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.items !== this.props.items) {
        this.setSectionsItems(nextProps);
      }

      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
        this.setSectionIterator(nextProps);
      }

      if (nextProps.theme !== this.props.theme) {
        this.setTheme(nextProps);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.ensureHighlightedItemIsVisible();
    }
  }, {
    key: 'setSectionsItems',
    value: function setSectionsItems(props) {
      if (props.multiSection) {
        this.sectionsItems = props.items.map(function (section) {
          return props.getSectionItems(section);
        });
        this.sectionsLengths = this.sectionsItems.map(function (items) {
          return items.length;
        });
        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
          return itemsCount === 0;
        });
      }
    }
  }, {
    key: 'setSectionIterator',
    value: function setSectionIterator(props) {
      this.sectionIterator = (0, _sectionIterator2.default)({
        multiSection: props.multiSection,
        data: props.multiSection ? this.sectionsLengths : props.items.length
      });
    }
  }, {
    key: 'setTheme',
    value: function setTheme(props) {
      this.theme = (0, _reactThemeable2.default)(props.theme);
    }
  }, {
    key: 'renderSections',
    value: function renderSections() {
      var _this2 = this;

      if (this.allSectionsAreEmpty) {
        return null;
      }

      var theme = this.theme;
      var _props = this.props,
          id = _props.id,
          items = _props.items,
          renderItem = _props.renderItem,
          renderItemData = _props.renderItemData,
          renderSectionTitle = _props.renderSectionTitle,
          highlightedSectionIndex = _props.highlightedSectionIndex,
          highlightedItemIndex = _props.highlightedItemIndex,
          itemProps = _props.itemProps;


      return items.map(function (section, sectionIndex) {
        var keyPrefix = 'react-autowhatever-' + id + '-';
        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
        var isFirstSection = sectionIndex === 0;

        // `key` is provided by theme()
        /* eslint-disable react/jsx-key */
        return _react2$3.default.createElement(
          'div',
          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
          _react2$3.default.createElement(_SectionTitle2.default, {
            section: section,
            renderSectionTitle: renderSectionTitle,
            theme: theme,
            sectionKeyPrefix: sectionKeyPrefix
          }),
          _react2$3.default.createElement(_ItemsList2.default, {
            items: _this2.sectionsItems[sectionIndex],
            itemProps: itemProps,
            renderItem: renderItem,
            renderItemData: renderItemData,
            sectionIndex: sectionIndex,
            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
            onHighlightedItemChange: _this2.onHighlightedItemChange,
            getItemId: _this2.getItemId,
            theme: theme,
            keyPrefix: keyPrefix,
            ref: _this2.storeItemsListReference
          })
        );
        /* eslint-enable react/jsx-key */
      });
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var items = this.props.items;


      if (items.length === 0) {
        return null;
      }

      var theme = this.theme;
      var _props2 = this.props,
          id = _props2.id,
          renderItem = _props2.renderItem,
          renderItemData = _props2.renderItemData,
          highlightedSectionIndex = _props2.highlightedSectionIndex,
          highlightedItemIndex = _props2.highlightedItemIndex,
          itemProps = _props2.itemProps;


      return _react2$3.default.createElement(_ItemsList2.default, {
        items: items,
        itemProps: itemProps,
        renderItem: renderItem,
        renderItemData: renderItemData,
        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
        onHighlightedItemChange: this.onHighlightedItemChange,
        getItemId: this.getItemId,
        theme: theme,
        keyPrefix: 'react-autowhatever-' + id + '-'
      });
    }
  }, {
    key: 'ensureHighlightedItemIsVisible',
    value: function ensureHighlightedItemIsVisible() {
      var highlightedItem = this.highlightedItem;


      if (!highlightedItem) {
        return;
      }

      var itemsContainer = this.itemsContainer;

      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;

      var scrollTop = itemsContainer.scrollTop; // Top of the visible area

      if (itemOffsetRelativeToContainer < scrollTop) {
        // Item is off the top of the visible area
        scrollTop = itemOffsetRelativeToContainer;
      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
        // Item is off the bottom of the visible area
        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
      }

      if (scrollTop !== itemsContainer.scrollTop) {
        itemsContainer.scrollTop = scrollTop;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var theme = this.theme;
      var _props3 = this.props,
          id = _props3.id,
          multiSection = _props3.multiSection,
          renderInputComponent = _props3.renderInputComponent,
          renderItemsContainer = _props3.renderItemsContainer,
          highlightedSectionIndex = _props3.highlightedSectionIndex,
          highlightedItemIndex = _props3.highlightedItemIndex;
      var isInputFocused = this.state.isInputFocused;

      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
      var isOpen = renderedItems !== null;
      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
      var itemsContainerId = 'react-autowhatever-' + id;
      var containerProps = _extends$3({
        role: 'combobox',
        'aria-haspopup': 'listbox',
        'aria-owns': itemsContainerId,
        'aria-expanded': isOpen
      }, theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen'), this.props.containerProps);
      var inputComponent = renderInputComponent(_extends$3({
        type: 'text',
        value: '',
        autoComplete: 'off',
        'aria-autocomplete': 'list',
        'aria-controls': itemsContainerId,
        'aria-activedescendant': ariaActivedescendant
      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
        ref: this.storeInputReference
      }));
      var itemsContainer = renderItemsContainer({
        containerProps: _extends$3({
          id: itemsContainerId,
          role: 'listbox'
        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
          ref: this.storeItemsContainerReference
        }),
        children: renderedItems
      });

      return _react2$3.default.createElement(
        'div',
        containerProps,
        inputComponent,
        itemsContainer
      );
    }
  }]);

  return Autowhatever;
}(_react$3.Component);

Autowhatever.propTypes = {
  id: _propTypes2$3.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
  multiSection: _propTypes2$3.default.bool, // Indicates whether a multi section layout should be rendered.
  renderInputComponent: _propTypes2$3.default.func, // When specified, it is used to render the input element.
  renderItemsContainer: _propTypes2$3.default.func, // Renders the items container.
  items: _propTypes2$3.default.array.isRequired, // Array of items or sections to render.
  renderItem: _propTypes2$3.default.func, // This function renders a single item.
  renderItemData: _propTypes2$3.default.object, // Arbitrary data that will be passed to renderItem()
  renderSectionTitle: _propTypes2$3.default.func, // This function gets a section and renders its title.
  getSectionItems: _propTypes2$3.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
  containerProps: _propTypes2$3.default.object, // Arbitrary container props
  inputProps: _propTypes2$3.default.object, // Arbitrary input props
  itemProps: _propTypes2$3.default.oneOfType([// Arbitrary item props
  _propTypes2$3.default.object, _propTypes2$3.default.func]),
  highlightedSectionIndex: _propTypes2$3.default.number, // Section index of the highlighted item
  highlightedItemIndex: _propTypes2$3.default.number, // Highlighted item index (within a section)
  theme: _propTypes2$3.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
  _propTypes2$3.default.object, _propTypes2$3.default.array])
};
Autowhatever.defaultProps = {
  id: '1',
  multiSection: false,
  renderInputComponent: defaultRenderInputComponent,
  renderItemsContainer: defaultRenderItemsContainer,
  renderItem: function renderItem() {
    throw new Error('`renderItem` must be provided');
  },
  renderItemData: emptyObject,
  renderSectionTitle: function renderSectionTitle() {
    throw new Error('`renderSectionTitle` must be provided');
  },
  getSectionItems: function getSectionItems() {
    throw new Error('`getSectionItems` must be provided');
  },
  containerProps: emptyObject,
  inputProps: emptyObject,
  itemProps: emptyObject,
  highlightedSectionIndex: null,
  highlightedItemIndex: null,
  theme: defaultTheme
};
Autowhatever$1.default = Autowhatever;

var dist$1 = Autowhatever$1.default;

var theme$5 = {};

Object.defineProperty(theme$5, "__esModule", {
  value: true
});
theme$5.defaultTheme = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};

theme$5.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
  var result = {};

  for (var key in theme) {
    switch (key) {
      case 'suggestionsContainer':
        result['itemsContainer'] = theme[key];
        break;

      case 'suggestionsContainerOpen':
        result['itemsContainerOpen'] = theme[key];
        break;

      case 'suggestion':
        result['item'] = theme[key];
        break;

      case 'suggestionFirst':
        result['itemFirst'] = theme[key];
        break;

      case 'suggestionHighlighted':
        result['itemHighlighted'] = theme[key];
        break;

      case 'suggestionsList':
        result['itemsList'] = theme[key];
        break;

      default:
        result[key] = theme[key];
    }
  }

  return result;
};

Object.defineProperty(Autosuggest$1, "__esModule", {
  value: true
});

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$2 = React__default$4;

var _react2$2 = _interopRequireDefault$5(_react$2);

var _propTypes$2 = propTypes.exports;

var _propTypes2$2 = _interopRequireDefault$5(_propTypes$2);

var _arrays = arrays;

var _arrays2 = _interopRequireDefault$5(_arrays);

var _reactAutowhatever = dist$1;

var _reactAutowhatever2 = _interopRequireDefault$5(_reactAutowhatever);

var _theme$2 = theme$5;

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var alwaysTrue = function alwaysTrue() {
  return true;
};
var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
  return value.trim().length > 0;
};
var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children;
  return _react2$2.default.createElement(
    'div',
    containerProps,
    children
  );
};

var Autosuggest = function (_Component) {
  _inherits$1(Autosuggest, _Component);

  function Autosuggest(_ref2) {
    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;

    _classCallCheck$1(this, Autosuggest);

    var _this = _possibleConstructorReturn$1(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));

    _initialiseProps.call(_this);

    _this.state = {
      isFocused: false,
      isCollapsed: !alwaysRenderSuggestions,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null
    };

    _this.justPressedUpDown = false;
    _this.justMouseEntered = false;

    _this.pressedSuggestion = null;
    return _this;
  }

  _createClass$1(Autosuggest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onDocumentMouseDown);
      document.addEventListener('mouseup', this.onDocumentMouseUp);

      this.input = this.autowhatever.input;
      this.suggestionsContainer = this.autowhatever.itemsContainer;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) {
          this.highlightFirstSuggestion();
        }
      } else {
        if (this.willRenderSuggestions(nextProps)) {
          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
            this.revealSuggestions();
          }
        } else {
          this.resetHighlightedSuggestion();
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          suggestions = _props.suggestions,
          onSuggestionHighlighted = _props.onSuggestionHighlighted,
          highlightFirstSuggestion = _props.highlightFirstSuggestion;


      if (!(0, _arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
        this.highlightFirstSuggestion();
        return;
      }

      if (onSuggestionHighlighted) {
        var highlightedSuggestion = this.getHighlightedSuggestion();
        var prevHighlightedSuggestion = prevState.highlightedSuggestion;

        if (highlightedSuggestion != prevHighlightedSuggestion) {
          onSuggestionHighlighted({
            suggestion: highlightedSuggestion
          });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onDocumentMouseDown);
      document.removeEventListener('mouseup', this.onDocumentMouseUp);
    }
  }, {
    key: 'updateHighlightedSuggestion',
    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
      var _this2 = this;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        if (suggestionIndex === null) {
          valueBeforeUpDown = null;
        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
          valueBeforeUpDown = prevValue;
        }

        return {
          highlightedSectionIndex: sectionIndex,
          highlightedSuggestionIndex: suggestionIndex,
          highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
          valueBeforeUpDown: valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'resetHighlightedSuggestion',
    value: function resetHighlightedSuggestion() {
      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.setState(function (state) {
        var valueBeforeUpDown = state.valueBeforeUpDown;


        return {
          highlightedSectionIndex: null,
          highlightedSuggestionIndex: null,
          highlightedSuggestion: null,
          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
        };
      });
    }
  }, {
    key: 'revealSuggestions',
    value: function revealSuggestions() {
      this.setState({
        isCollapsed: false
      });
    }
  }, {
    key: 'closeSuggestions',
    value: function closeSuggestions() {
      this.setState({
        highlightedSectionIndex: null,
        highlightedSuggestionIndex: null,
        highlightedSuggestion: null,
        valueBeforeUpDown: null,
        isCollapsed: true
      });
    }
  }, {
    key: 'getSuggestion',
    value: function getSuggestion(sectionIndex, suggestionIndex) {
      var _props2 = this.props,
          suggestions = _props2.suggestions,
          multiSection = _props2.multiSection,
          getSectionSuggestions = _props2.getSectionSuggestions;


      if (multiSection) {
        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
      }

      return suggestions[suggestionIndex];
    }
  }, {
    key: 'getHighlightedSuggestion',
    value: function getHighlightedSuggestion() {
      var _state = this.state,
          highlightedSectionIndex = _state.highlightedSectionIndex,
          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;


      if (highlightedSuggestionIndex === null) {
        return null;
      }

      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
    }
  }, {
    key: 'getSuggestionValueByIndex',
    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
      var getSuggestionValue = this.props.getSuggestionValue;


      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
    }
  }, {
    key: 'getSuggestionIndices',
    value: function getSuggestionIndices(suggestionElement) {
      var sectionIndex = suggestionElement.getAttribute('data-section-index');
      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');

      return {
        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
        suggestionIndex: parseInt(suggestionIndex, 10)
      };
    }
  }, {
    key: 'findSuggestionElement',
    value: function findSuggestionElement(startNode) {
      var node = startNode;

      do {
        if (node.getAttribute('data-suggestion-index') !== null) {
          return node;
        }

        node = node.parentNode;
      } while (node !== null);

      console.error('Clicked element:', startNode); // eslint-disable-line no-console
      throw new Error("Couldn't find suggestion element");
    }
  }, {
    key: 'maybeCallOnChange',
    value: function maybeCallOnChange(event, newValue, method) {
      var _props$inputProps = this.props.inputProps,
          value = _props$inputProps.value,
          onChange = _props$inputProps.onChange;


      if (newValue !== value) {
        onChange(event, { newValue: newValue, method: method });
      }
    }
  }, {
    key: 'willRenderSuggestions',
    value: function willRenderSuggestions(props) {
      var suggestions = props.suggestions,
          inputProps = props.inputProps,
          shouldRenderSuggestions = props.shouldRenderSuggestions;
      var value = inputProps.value;


      return suggestions.length > 0 && shouldRenderSuggestions(value);
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var inputProps = this.props.inputProps;
      var value = inputProps.value;
      var valueBeforeUpDown = this.state.valueBeforeUpDown;


      return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          suggestions = _props3.suggestions,
          renderInputComponent = _props3.renderInputComponent,
          onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested,
          renderSuggestion = _props3.renderSuggestion,
          inputProps = _props3.inputProps,
          multiSection = _props3.multiSection,
          renderSectionTitle = _props3.renderSectionTitle,
          id = _props3.id,
          getSectionSuggestions = _props3.getSectionSuggestions,
          theme = _props3.theme,
          getSuggestionValue = _props3.getSuggestionValue,
          alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
          highlightFirstSuggestion = _props3.highlightFirstSuggestion;
      var _state2 = this.state,
          isFocused = _state2.isFocused,
          isCollapsed = _state2.isCollapsed,
          highlightedSectionIndex = _state2.highlightedSectionIndex,
          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex,
          valueBeforeUpDown = _state2.valueBeforeUpDown;

      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
      var value = inputProps.value,
          _onFocus = inputProps.onFocus,
          _onKeyDown = inputProps.onKeyDown;

      var willRenderSuggestions = this.willRenderSuggestions(this.props);
      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
      var items = isOpen ? suggestions : [];
      var autowhateverInputProps = _extends$2({}, inputProps, {
        onFocus: function onFocus(event) {
          if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
            var shouldRender = shouldRenderSuggestions(value);

            _this3.setState({
              isFocused: true,
              isCollapsed: !shouldRender
            });

            _onFocus && _onFocus(event);

            if (shouldRender) {
              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
            }
          }
        },
        onBlur: function onBlur(event) {
          if (_this3.justClickedOnSuggestionsContainer) {
            _this3.input.focus();
            return;
          }

          _this3.blurEvent = event;

          if (!_this3.justSelectedSuggestion) {
            _this3.onBlur();
            _this3.onSuggestionsClearRequested();
          }
        },
        onChange: function onChange(event) {
          var value = event.target.value;

          var shouldRender = shouldRenderSuggestions(value);

          _this3.maybeCallOnChange(event, value, 'type');

          if (_this3.suggestionsContainer) {
            _this3.suggestionsContainer.scrollTop = 0;
          }

          _this3.setState(_extends$2({}, highlightFirstSuggestion ? {} : {
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null
          }, {
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
          }));

          if (shouldRender) {
            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
          } else {
            _this3.onSuggestionsClearRequested();
          }
        },
        onKeyDown: function onKeyDown(event, data) {
          var keyCode = event.keyCode;


          switch (keyCode) {
            case 40: // ArrowDown
            case 38:
              // ArrowUp
              if (isCollapsed) {
                if (shouldRenderSuggestions(value)) {
                  onSuggestionsFetchRequested({
                    value: value,
                    reason: 'suggestions-revealed'
                  });
                  _this3.revealSuggestions();
                }
              } else if (suggestions.length > 0) {
                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
                    newHighlightedItemIndex = data.newHighlightedItemIndex;


                var newValue = void 0;

                if (newHighlightedItemIndex === null) {
                  // valueBeforeUpDown can be null if, for example, user
                  // hovers on the first suggestion and then pressed Up.
                  // If that happens, use the original input value.
                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                } else {
                  newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                }

                _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
              }

              event.preventDefault(); // Prevents the cursor from moving

              _this3.justPressedUpDown = true;

              setTimeout(function () {
                _this3.justPressedUpDown = false;
              });

              break;

            // Enter
            case 13:
              {
                // See #388
                if (event.keyCode === 229) {
                  break;
                }

                var highlightedSuggestion = _this3.getHighlightedSuggestion();

                if (isOpen && !alwaysRenderSuggestions) {
                  _this3.closeSuggestions();
                }

                if (highlightedSuggestion != null) {
                  var _newValue = getSuggestionValue(highlightedSuggestion);

                  _this3.maybeCallOnChange(event, _newValue, 'enter');

                  _this3.onSuggestionSelected(event, {
                    suggestion: highlightedSuggestion,
                    suggestionValue: _newValue,
                    suggestionIndex: highlightedSuggestionIndex,
                    sectionIndex: highlightedSectionIndex,
                    method: 'enter'
                  });

                  _this3.justSelectedSuggestion = true;

                  setTimeout(function () {
                    _this3.justSelectedSuggestion = false;
                  });
                }

                break;
              }

            // Escape
            case 27:
              {
                if (isOpen) {
                  // If input.type === 'search', the browser clears the input
                  // when Escape is pressed. We want to disable this default
                  // behaviour so that, when suggestions are shown, we just hide
                  // them, without clearing the input.
                  event.preventDefault();
                }

                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;

                if (valueBeforeUpDown === null) {
                  // Didn't interact with Up/Down
                  if (!willCloseSuggestions) {
                    var _newValue2 = '';

                    _this3.maybeCallOnChange(event, _newValue2, 'escape');

                    if (shouldRenderSuggestions(_newValue2)) {
                      onSuggestionsFetchRequested({
                        value: _newValue2,
                        reason: 'escape-pressed'
                      });
                    } else {
                      _this3.onSuggestionsClearRequested();
                    }
                  }
                } else {
                  // Interacted with Up/Down
                  _this3.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
                }

                if (willCloseSuggestions) {
                  _this3.onSuggestionsClearRequested();
                  _this3.closeSuggestions();
                } else {
                  _this3.resetHighlightedSuggestion();
                }

                break;
              }
          }

          _onKeyDown && _onKeyDown(event);
        }
      });
      var renderSuggestionData = {
        query: this.getQuery()
      };

      return _react2$2.default.createElement(_reactAutowhatever2.default, {
        multiSection: multiSection,
        items: items,
        renderInputComponent: renderInputComponent,
        renderItemsContainer: this.renderSuggestionsContainer,
        renderItem: renderSuggestion,
        renderItemData: renderSuggestionData,
        renderSectionTitle: renderSectionTitle,
        getSectionItems: getSectionSuggestions,
        highlightedSectionIndex: highlightedSectionIndex,
        highlightedItemIndex: highlightedSuggestionIndex,
        inputProps: autowhateverInputProps,
        itemProps: this.itemProps,
        theme: (0, _theme$2.mapToAutowhateverTheme)(theme),
        id: id,
        ref: this.storeAutowhateverRef
      });
    }
  }]);

  return Autosuggest;
}(_react$2.Component);

Autosuggest.propTypes = {
  suggestions: _propTypes2$2.default.array.isRequired,
  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
    var onSuggestionsFetchRequested = props[propName];

    if (typeof onSuggestionsFetchRequested !== 'function') {
      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    }
  },
  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
    var onSuggestionsClearRequested = props[propName];

    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    }
  },
  onSuggestionSelected: _propTypes2$2.default.func,
  onSuggestionHighlighted: _propTypes2$2.default.func,
  renderInputComponent: _propTypes2$2.default.func,
  renderSuggestionsContainer: _propTypes2$2.default.func,
  getSuggestionValue: _propTypes2$2.default.func.isRequired,
  renderSuggestion: _propTypes2$2.default.func.isRequired,
  inputProps: function inputProps(props, propName) {
    var inputProps = props[propName];

    if (!inputProps.hasOwnProperty('value')) {
      throw new Error("'inputProps' must have 'value'.");
    }

    if (!inputProps.hasOwnProperty('onChange')) {
      throw new Error("'inputProps' must have 'onChange'.");
    }
  },
  shouldRenderSuggestions: _propTypes2$2.default.func,
  alwaysRenderSuggestions: _propTypes2$2.default.bool,
  multiSection: _propTypes2$2.default.bool,
  renderSectionTitle: function renderSectionTitle(props, propName) {
    var renderSectionTitle = props[propName];

    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    }
  },
  getSectionSuggestions: function getSectionSuggestions(props, propName) {
    var getSectionSuggestions = props[propName];

    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    }
  },
  focusInputOnSuggestionClick: _propTypes2$2.default.bool,
  highlightFirstSuggestion: _propTypes2$2.default.bool,
  theme: _propTypes2$2.default.object,
  id: _propTypes2$2.default.string
};
Autosuggest.defaultProps = {
  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
  shouldRenderSuggestions: defaultShouldRenderSuggestions,
  alwaysRenderSuggestions: false,
  multiSection: false,
  focusInputOnSuggestionClick: true,
  highlightFirstSuggestion: false,
  theme: _theme$2.defaultTheme,
  id: '1'
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onDocumentMouseDown = function (event) {
    _this4.justClickedOnSuggestionsContainer = false;

    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
    event.target;

    while (node !== null && node !== document) {
      if (node.getAttribute('data-suggestion-index') !== null) {
        // Suggestion was clicked
        return;
      }

      if (node === _this4.suggestionsContainer) {
        // Something else inside suggestions container was clicked
        _this4.justClickedOnSuggestionsContainer = true;
        return;
      }

      node = node.parentNode;
    }
  };

  this.storeAutowhateverRef = function (autowhatever) {
    if (autowhatever !== null) {
      _this4.autowhatever = autowhatever;
    }
  };

  this.onSuggestionMouseEnter = function (event, _ref3) {
    var sectionIndex = _ref3.sectionIndex,
        itemIndex = _ref3.itemIndex;

    _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);

    if (event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = true;
    }

    _this4.justMouseEntered = true;

    setTimeout(function () {
      _this4.justMouseEntered = false;
    });
  };

  this.highlightFirstSuggestion = function () {
    _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
  };

  this.onDocumentMouseUp = function () {
    if (_this4.pressedSuggestion && !_this4.justSelectedSuggestion) {
      _this4.input.focus();
    }
    _this4.pressedSuggestion = null;
  };

  this.onSuggestionMouseDown = function (event) {
    // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
    // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
    if (!_this4.justSelectedSuggestion) {
      _this4.justSelectedSuggestion = true;
      _this4.pressedSuggestion = event.target;
    }
  };

  this.onSuggestionsClearRequested = function () {
    var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;


    onSuggestionsClearRequested && onSuggestionsClearRequested();
  };

  this.onSuggestionSelected = function (event, data) {
    var _props4 = _this4.props,
        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
        onSuggestionSelected = _props4.onSuggestionSelected,
        onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;


    onSuggestionSelected && onSuggestionSelected(event, data);

    if (alwaysRenderSuggestions) {
      onSuggestionsFetchRequested({
        value: data.suggestionValue,
        reason: 'suggestion-selected'
      });
    } else {
      _this4.onSuggestionsClearRequested();
    }

    _this4.resetHighlightedSuggestion();
  };

  this.onSuggestionClick = function (event) {
    var _props5 = _this4.props,
        alwaysRenderSuggestions = _props5.alwaysRenderSuggestions,
        focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;

    var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)),
        sectionIndex = _getSuggestionIndices.sectionIndex,
        suggestionIndex = _getSuggestionIndices.suggestionIndex;

    var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
    var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);

    _this4.maybeCallOnChange(event, clickedSuggestionValue, 'click');
    _this4.onSuggestionSelected(event, {
      suggestion: clickedSuggestion,
      suggestionValue: clickedSuggestionValue,
      suggestionIndex: suggestionIndex,
      sectionIndex: sectionIndex,
      method: 'click'
    });

    if (!alwaysRenderSuggestions) {
      _this4.closeSuggestions();
    }

    if (focusInputOnSuggestionClick === true) {
      _this4.input.focus();
    } else {
      _this4.onBlur();
    }

    setTimeout(function () {
      _this4.justSelectedSuggestion = false;
    });
  };

  this.onBlur = function () {
    var _props6 = _this4.props,
        inputProps = _props6.inputProps,
        shouldRenderSuggestions = _props6.shouldRenderSuggestions;
    var value = inputProps.value,
        onBlur = inputProps.onBlur;

    var highlightedSuggestion = _this4.getHighlightedSuggestion();
    var shouldRender = shouldRenderSuggestions(value);

    _this4.setState({
      isFocused: false,
      highlightedSectionIndex: null,
      highlightedSuggestionIndex: null,
      highlightedSuggestion: null,
      valueBeforeUpDown: null,
      isCollapsed: !shouldRender
    });

    onBlur && onBlur(_this4.blurEvent, { highlightedSuggestion: highlightedSuggestion });
  };

  this.onSuggestionMouseLeave = function (event) {
    _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown

    if (_this4.justSelectedSuggestion && event.target === _this4.pressedSuggestion) {
      _this4.justSelectedSuggestion = false;
    }
  };

  this.onSuggestionTouchStart = function () {
    _this4.justSelectedSuggestion = true;
    // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
    // todo: gets released so onSuggestionMouseDown won't fire in chrome
  };

  this.onSuggestionTouchMove = function () {
    _this4.justSelectedSuggestion = false;
    _this4.pressedSuggestion = null;
    _this4.input.focus();
  };

  this.itemProps = function (_ref4) {
    var sectionIndex = _ref4.sectionIndex,
        itemIndex = _ref4.itemIndex;

    return {
      'data-section-index': sectionIndex,
      'data-suggestion-index': itemIndex,
      onMouseEnter: _this4.onSuggestionMouseEnter,
      onMouseLeave: _this4.onSuggestionMouseLeave,
      onMouseDown: _this4.onSuggestionMouseDown,
      onTouchStart: _this4.onSuggestionTouchStart,
      onTouchMove: _this4.onSuggestionTouchMove,
      onClick: _this4.onSuggestionClick
    };
  };

  this.renderSuggestionsContainer = function (_ref5) {
    var containerProps = _ref5.containerProps,
        children = _ref5.children;
    var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;


    return renderSuggestionsContainer({
      containerProps: containerProps,
      children: children,
      query: _this4.getQuery()
    });
  };
};

Autosuggest$1.default = Autosuggest;

var dist = Autosuggest$1.default;

var font_icon = {};

Object.defineProperty(font_icon, "__esModule", {
  value: true
});
var FontIcon = font_icon.FontIcon = undefined;

var _FontIcon$4 = FontIcon$2;

font_icon.default = _FontIcon$4.FontIcon;
FontIcon = font_icon.FontIcon = _FontIcon$4.FontIcon;

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = {
  randomUUID
};

function v4(options, buf, offset) {
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

var css_248z$p = ".style_wrap__m14tX {\n  position: relative;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.style_modalContainer__MBg7w {\n  position: fixed;\n  top: 10%;\n  left: 50%;\n  width: 90%;\n  max-width: 400px;\n  transform: translateX(-50%);\n  background-color: #ffffff;\n  box-shadow: 0 4px 6px rgba(125.75, 125.75, 125.75, 0.5);\n  border: 1px solid #3e3e3e;\n  z-index: 300;\n  padding: 1em;\n  border-radius: 4px;\n}\n\n.style_disabledWrap__xOn4G {\n  opacity: 0.25;\n}\n.style_disabledWrap__xOn4G:focus {\n  outline: 0;\n}\n\n.style_header__2udZW {\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.style_headerText__S0F-l {\n  padding: 0.5em;\n  flex: 1 1 auto;\n}\n\n.style_footer__mXl8X {\n  padding: 0 1em 1em;\n  text-align: right;\n}\n\n.style_headerIcon__8Qfwg {\n  flex: 0 0 auto;\n}\n\n.style_container__NetKb {\n  background-color: #ffffff;\n  box-shadow: 0 2px 2px 0 rgba(125.75, 125.75, 125.75, 0.5);\n  border: 1px solid #3e3e3e;\n  position: absolute;\n  width: 100%;\n  z-index: 200;\n  top: 100%;\n  left: 0;\n  transform: translateY(-46px);\n}\n\n.style_slug__Y7mjS {\n  font-family: \"Roboto\", sans-serif;\n  border: 1px solid #3e3e3e;\n  border-bottom-width: 5px;\n  font-size: 16px;\n  display: flex;\n  width: 100%;\n  text-align: left;\n  padding: 0.5em;\n  align-items: center;\n  cursor: pointer;\n}\n\n.style_disabledSlug__ioihP {\n}\n.style_disabledSlug__ioihP:focus, .style_disabledSlug__ioihP:active {\n  outline: 0;\n}\n\n.style_slugLabel__YD-lN {\n  flex: 1 1 auto;\n}\n\n.style_slugIcon__mXCzX {\n  flex: 0 0 auto;\n}\n\n.style_multiSelectSuggestion__eyJ16 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.style_suggestionCheckbox__VfX5B {\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  accent-color: #007bff;\n  flex-shrink: 0;\n}\n\n.style_suggestionLabel__FxT9n {\n  flex: 1 1 auto;\n}\n\n.style_suggestionCount__tOSV4 {\n  flex-shrink: 0;\n  color: rgb(125.75, 125.75, 125.75);\n  font-size: 13px;\n}\n\n.style_slugChips__lizrK {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  flex: 1 1 auto;\n  align-items: center;\n}\n\n.style_chip__4gTga {\n  display: inline-flex;\n  align-items: center;\n  background-color: rgb(253.25, 253.25, 253.25);\n  border: 1px solid #3e3e3e;\n  border-radius: 16px;\n  padding: 2px 8px;\n  font-size: 14px;\n  gap: 4px;\n}\n\n.style_chipLabel__FkNPI {\n  white-space: nowrap;\n}\n\n.style_chipDelete__fVzUv {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n  font-size: 14px;\n  color: rgb(125.75, 125.75, 125.75);\n  border-radius: 50%;\n}\n.style_chipDelete__fVzUv:hover {\n  background-color: #3e3e3e;\n  color: #000000;\n}\n\n.style_chipOverflow__Vvz-1 {\n  display: inline-flex;\n  align-items: center;\n  color: rgb(125.75, 125.75, 125.75);\n  font-size: 14px;\n  padding: 2px 4px;\n  white-space: nowrap;\n}";
var style$h = {"wrap":"style_wrap__m14tX","modalContainer":"style_modalContainer__MBg7w","disabledWrap":"style_disabledWrap__xOn4G style_wrap__m14tX","header":"style_header__2udZW","headerText":"style_headerText__S0F-l","footer":"style_footer__mXl8X","headerIcon":"style_headerIcon__8Qfwg","container":"style_container__NetKb","slug":"style_slug__Y7mjS","disabledSlug":"style_disabledSlug__ioihP style_slug__Y7mjS","slugLabel":"style_slugLabel__YD-lN","slugIcon":"style_slugIcon__mXCzX","multiSelectSuggestion":"style_multiSelectSuggestion__eyJ16","suggestionCheckbox":"style_suggestionCheckbox__VfX5B","suggestionLabel":"style_suggestionLabel__FxT9n","suggestionCount":"style_suggestionCount__tOSV4","slugChips":"style_slugChips__lizrK","chip":"style_chip__4gTga","chipLabel":"style_chipLabel__FkNPI","chipDelete":"style_chipDelete__fVzUv","chipOverflow":"style_chipOverflow__Vvz-1"};
styleInject(css_248z$p);

var css_248z$o = ".theme_container__I1EZ2 {\n  padding: 1em;\n}\n\n.theme_input__M90FO {\n  width: 100%;\n  font-size: 16px;\n  padding: 0.5em;\n  border: 1px solid rgb(189.5, 189.5, 189.5);\n  box-sizing: border-box;\n}\n.theme_input__M90FO:focus {\n  border-color: #000000;\n  background-color: rgb(253.25, 253.25, 253.25);\n  outline: 0;\n}\n\n.theme_suggestionsContainer__KeEcC {\n  border: 1px solid rgb(189.5, 189.5, 189.5);\n  border-top: 0;\n  max-height: 200px;\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n}\n\n.theme_suggestionsList__Bfgox {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.theme_suggestion__yD1CD {\n  color: rgb(125.75, 125.75, 125.75);\n  cursor: pointer;\n  padding: 0.5em 1em;\n}\n.theme_suggestion__yD1CD:hover {\n  color: #000000;\n  background-color: rgb(253.25, 253.25, 253.25);\n}\n\n.theme_suggestionHighlighted__vAmRt {\n  color: #000000;\n  background-color: rgb(253.25, 253.25, 253.25);\n}";
var theme$4 = {"container":"theme_container__I1EZ2","input":"theme_input__M90FO","suggestionsContainer":"theme_suggestionsContainer__KeEcC","suggestionsList":"theme_suggestionsList__Bfgox","suggestion":"theme_suggestion__yD1CD","suggestionHighlighted":"theme_suggestionHighlighted__vAmRt"};
styleInject(css_248z$o);

const SmartDropdown = ({ actions = [], disabled, containerLabel, echo = false, inputLabel, options: initialOptions = [], noResultsFallback, slugLabel: initialSlugLabel, value: selectedValue, // externally controlled selected value
onChange, onSlugClick, multiple = false, selectedValues = [], onSelectedValuesChange, maxDisplayItems = 2, counts, }) => {
    // Generate an id for autosuggest (unique per instance)
    const id = useRef(v4());
    const wrapperRef = useRef(null);
    // Maintain a mutable copy of the options for filtering
    const [options, setOptions] = useState([...initialOptions]);
    // Suggestions shown in the autosuggest
    const [suggestions, setSuggestions] = useState([...initialOptions]);
    // Input text state for filtering suggestions
    const [inputValue, setInputValue] = useState("");
    // Show/hide the suggestions container
    const [showSuggestions, setShowSuggestions] = useState(false);
    // If in mobile modal mode
    const [modalMode, setModalMode] = useState(false);
    // Sync options when the initial options change
    useEffect(() => {
        setOptions([...initialOptions]);
        setSuggestions([...initialOptions]);
    }, [initialOptions]);
    // Build a lookup map for O(1) option lookups (fixes N+1 performance issue)
    const optionsMap = useMemo(() => options.reduce((acc, opt) => (Object.assign(Object.assign({}, acc), { [opt.id]: opt })), {}), [options]);
    // Close the suggestions and reset input text
    const handleCancelClick = useCallback(() => {
        setShowSuggestions(false);
        setInputValue("");
        setModalMode(false);
        document.body.style.overflow = "";
    }, []);
    // Outside click handler to close the dropdown (only attach when open to prevent memory leaks)
    useEffect(() => {
        if (!showSuggestions)
            return;
        const handleOutsideClick = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                handleCancelClick();
            }
        };
        document.addEventListener("mousedown", handleOutsideClick);
        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, [showSuggestions, handleCancelClick]);
    // Cleanup body overflow on unmount (in case component unmounts while modal is open)
    useEffect(() => {
        return () => {
            document.body.style.overflow = "";
        };
    }, []);
    // Returns the text to be displayed on the dropdown "slug"
    const getDisplayValue = () => {
        if (multiple) {
            if (selectedValues.length === 0) {
                return initialSlugLabel || "Choose...";
            }
            const selectedNames = selectedValues
                .map((id) => { var _a; return (_a = optionsMap[id]) === null || _a === void 0 ? void 0 : _a.name; })
                .filter(Boolean);
            if (selectedNames.length <= maxDisplayItems) {
                return selectedNames.join(", ");
            }
            return `${selectedNames.length} selected`;
        }
        if (selectedValue) {
            if (typeof selectedValue === "string") {
                const found = optionsMap[selectedValue];
                return found ? found.name : selectedValue;
            }
            else if (typeof selectedValue === "object" && selectedValue !== null && "name" in selectedValue) {
                return selectedValue.name;
            }
        }
        return initialSlugLabel || "Choose...";
    };
    // Filter the options based on the input text
    const getSuggestions = (text) => {
        const input = text.trim().toLowerCase();
        // if we have echo turned on, we want to show the input as a suggestion
        if (input.length === 0) {
            // show all options if no input
            return options;
        }
        else if (input.length > 0) {
            const startsWithInput = [];
            const remainingOptions = [];
            options.forEach((option) => {
                if (option.name.toLowerCase().startsWith(input)) {
                    startsWithInput.push(option);
                }
                else {
                    remainingOptions.push(option);
                }
            });
            const includesOptions = remainingOptions.filter((option) => option.name.toLowerCase().includes(input));
            let filteredOptions = [...startsWithInput, ...includesOptions];
            // if filteredOptions is empty, we do a word split and see if any of the input words match any of the options
            if (filteredOptions.length === 0) {
                const inputWords = input.split(" ");
                const wordFilteredOptions = options.filter((option) => inputWords.some((word) => option.name.toLowerCase().includes(word)));
                filteredOptions = [...wordFilteredOptions];
            }
            if (echo) {
                // first see if we have any that match the beginning of what the user is typing
                // if echo is true, we want to show the input as a suggestion, putting it directly at the top of the list
                const inputSuggestion = {
                    id: "input-suggestion",
                    name: text,
                };
                // see if we have any that match the beginning of what the user is typing
                if (startsWithInput.length === 0) {
                    // if we have any that match the beginning of what the user is typing, we want to show them first
                    return [inputSuggestion, ...filteredOptions];
                }
            }
            return filteredOptions;
        }
        return input.length === 0 ? options : options.filter((option) => option.name.toLowerCase().includes(input));
    };
    // Update the autosuggest input text (not the selected value)
    const handleChange = (_, params) => {
        setInputValue(params.newValue);
    };
    // Open the suggestions; on mobile, enable modal mode
    const handleSlugClick = () => {
        if (disabled)
            return;
        onSlugClick === null || onSlugClick === void 0 ? void 0 : onSlugClick();
        const isMobile = window.innerWidth <= 768;
        if (isMobile) {
            document.body.style.overflow = "hidden";
        }
        // ⬇️ Show all options immediately on open
        setSuggestions([...options]);
        setInputValue(""); // clear any old filter
        setModalMode(isMobile);
        setShowSuggestions(true);
    };
    // When an option is selected, call onChange with the selected suggestion
    const handleSelection = (_, suggestionData) => {
        if (multiple) {
            const optionId = suggestionData.suggestion.id;
            const isSelected = selectedValues.includes(optionId);
            const newValues = isSelected
                ? selectedValues.filter((id) => id !== optionId)
                : [...selectedValues, optionId];
            onSelectedValuesChange === null || onSelectedValuesChange === void 0 ? void 0 : onSelectedValuesChange(newValues);
            // Don't close the dropdown in multi-select mode
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(suggestionData.suggestion);
        setShowSuggestions(false);
        setInputValue("");
        setModalMode(false);
        document.body.style.overflow = "";
    };
    // Update suggestions based on the current input
    const handleSuggestionsFetchRequested = ({ value }) => {
        setSuggestions(getSuggestions(value));
    };
    // Clear suggestions when requested
    const handleSuggestionsClearRequested = () => {
        setSuggestions([]);
    };
    const renderFooter = () => actions.length > 0 && (React__default$4.createElement("footer", { className: style$h.footer }, actions.map((actionProps, i) => (React__default$4.createElement(Button_1, Object.assign({ key: i }, actionProps))))));
    const renderLabel = (label) => label && React__default$4.createElement("p", null, label);
    const renderSuggestion = (suggestion) => {
        const count = counts === null || counts === void 0 ? void 0 : counts[suggestion.id];
        const countDisplay = count !== undefined ? ` (${count.toLocaleString()})` : "";
        if (multiple) {
            const isSelected = selectedValues.includes(suggestion.id);
            return (React__default$4.createElement("div", { className: style$h.multiSelectSuggestion },
                React__default$4.createElement("input", { type: "checkbox", checked: isSelected, readOnly: true, className: style$h.suggestionCheckbox }),
                React__default$4.createElement("span", { className: style$h.suggestionLabel }, suggestion.name),
                count !== undefined && React__default$4.createElement("span", { className: style$h.suggestionCount }, count.toLocaleString())));
        }
        return suggestion.name + countDisplay;
    };
    const renderSuggestions = () => {
        if (!showSuggestions)
            return null;
        const inputProps = {
            onChange: handleChange,
            placeholder: inputLabel,
            value: inputValue,
        };
        const containerClass = modalMode ? style$h.modalContainer : style$h.container;
        return (React__default$4.createElement("div", { className: containerClass },
            React__default$4.createElement("header", { className: style$h.header },
                React__default$4.createElement("span", { className: style$h.headerText }, getDisplayValue()),
                React__default$4.createElement(IconButton_1$1, { className: style$h.headerIcon, icon: "close", onClick: handleCancelClick })),
            React__default$4.createElement(dist, { alwaysRenderSuggestions: true, getSuggestionValue: (s) => multiple ? inputValue : s.name, id: id.current, inputProps: inputProps, onSuggestionSelected: handleSelection, onSuggestionsFetchRequested: handleSuggestionsFetchRequested, onSuggestionsClearRequested: handleSuggestionsClearRequested, renderSuggestion: renderSuggestion, shouldRenderSuggestions: () => true, suggestions: suggestions.length === 0 && noResultsFallback ? [noResultsFallback] : suggestions, theme: theme$4 }),
            renderFooter()));
    };
    const wrapClassName = disabled ? style$h.disabledWrap : style$h.wrap;
    const slugClassName = disabled ? style$h.disabledSlug : style$h.slug;
    const handleChipDelete = (e, idToRemove) => {
        e.stopPropagation(); // Don't open dropdown when clicking delete
        const newValues = selectedValues.filter((id) => id !== idToRemove);
        onSelectedValuesChange === null || onSelectedValuesChange === void 0 ? void 0 : onSelectedValuesChange(newValues);
    };
    const renderSlugContent = () => {
        if (multiple && selectedValues.length > 0) {
            const displayCount = Math.min(selectedValues.length, maxDisplayItems);
            const remainingCount = selectedValues.length - displayCount;
            const displayedValues = selectedValues.slice(0, displayCount);
            return (React__default$4.createElement("span", { className: style$h.slugChips },
                displayedValues.map((id) => {
                    const option = optionsMap[id];
                    return (React__default$4.createElement("span", { key: id, className: style$h.chip },
                        React__default$4.createElement("span", { className: style$h.chipLabel }, (option === null || option === void 0 ? void 0 : option.name) || id),
                        React__default$4.createElement("button", { type: "button", className: style$h.chipDelete, onClick: (e) => handleChipDelete(e, id), "aria-label": `Remove ${(option === null || option === void 0 ? void 0 : option.name) || id}` }, "\u00D7")));
                }),
                remainingCount > 0 && (React__default$4.createElement("span", { className: style$h.chipOverflow },
                    "+",
                    remainingCount,
                    " more"))));
        }
        return React__default$4.createElement("span", { className: style$h.slugLabel }, getDisplayValue());
    };
    return (React__default$4.createElement("div", { className: wrapClassName, ref: wrapperRef },
        renderLabel(containerLabel),
        React__default$4.createElement("button", { className: slugClassName, onClick: handleSlugClick },
            renderSlugContent(),
            React__default$4.createElement(FontIcon, { className: style$h.slugIcon, value: "keyboard_arrow_down" })),
        renderSuggestions()));
};

/**
 * Converts any given data set into the necessary format for the SmartDropdown
 *
 * example:
 * const data: SomeDataModel[] = [
 *   {
 *       dataId: "data-id-1",
 *       dataName: "Data Name 1",
 *       dataApps: [...],
 *       ...otherProps
 *   },
 *   {
 *       dataId: "data-id-2",
 *       dataName: "Data Name 2",
 *       dataApps: [...],
 *       ...otherProps
 *    },
 * ];
 *
 * let options = mapDataToSuggestions({
 *    dataSet: data,
 *    idField: "dataId",
 *    nameField: "dataName"
 * });
 *
 * options => [{ id: "data-id-1", name: "Data Name 1" }, { id: "data-id-2", name: "Data Name 2" }];
 */
function mapDataToSuggestions(params) {
    const { dataSet, idField, nameField } = params;
    if (!dataSet) {
        throw new Error("dataSet was undefined when passed to mapDataToSuggestions.");
    }
    return dataSet.map(dataItem => {
        return {
            id: dataItem[idField],
            name: dataItem[nameField]
        };
    });
}

var css_248z$n = ".style_smartSelect__YUlHn {\n  width: 100%;\n  height: 40px;\n}\n.style_smartSelectInput__o5XGq {\n  width: 194px;\n  height: 36px;\n  padding-right: 60px;\n  padding-left: 16px;\n  font-size: 16px;\n  outline: none;\n  border: 1px dashed black;\n}\n.style_smartSelectInput__o5XGq:focus::placeholder {\n  color: transparent;\n}\n.style_smartSelectInputContainer__Xb7uJ {\n  position: relative;\n}\n.style_smartSelectInputBtn__xRN35 {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border-radius: 20px;\n  color: white;\n  background: #1aa7dc;\n  width: 44px;\n  height: 22px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n.style_smartSelectContainer__4Ugpl {\n  width: 200px;\n}";
var style$g = {"smartSelect":"style_smartSelect__YUlHn","smartSelectInput":"style_smartSelectInput__o5XGq","smartSelectInputContainer":"style_smartSelectInputContainer__Xb7uJ","smartSelectInputBtn":"style_smartSelectInputBtn__xRN35","smartSelectContainer":"style_smartSelectContainer__4Ugpl"};
styleInject(css_248z$n);

const SmartSelect = (props) => {
    const { label, value, inputValue, items, disabled, onChange, onInputValueChange, onAddValue, } = props;
    const [selectOpen, setSelectOpen] = useState(false);
    const handleChange = (event) => {
        const { target: { value }, } = event;
        onChange(value);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleInputValueChange = (event) => {
        onInputValueChange(event.target.value);
    };
    const handleOpenSelect = () => {
        setSelectOpen(true);
    };
    const handleCloseSelect = () => {
        setSelectOpen(false);
    };
    const handleAddValue = () => {
        onAddValue();
    };
    return (React__default$4.createElement("div", { className: style$g.smartSelectContainer },
        React__default$4.createElement(Select$1, { className: style$g.smartSelect, input: React__default$4.createElement(node.OutlinedInput, { value: value, placeholder: label !== null && label !== void 0 ? label : "" }), label: label, value: value, open: selectOpen, disabled: disabled, onChange: handleChange, onOpen: handleOpenSelect, onClose: handleCloseSelect },
            React__default$4.createElement(MenuItem, { onKeyDown: (e) => e.stopPropagation(), style: { padding: "none" } },
                React__default$4.createElement("div", { className: style$g.smartSelectInputContainer },
                    React__default$4.createElement("input", { type: "text", className: style$g.smartSelectInput, value: inputValue, placeholder: "Create new", onChange: handleInputValueChange }),
                    React__default$4.createElement("button", { className: style$g.smartSelectInputBtn, onClick: handleAddValue }, "Save"))),
            items.map((item) => (React__default$4.createElement(MenuItem, { key: item.value, value: item.value }, item.label))))));
};

var css_248z$m = ".Switch-module_switchWrapper__-W2AV {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.Switch-module_switch__PKzsW {\n  position: relative;\n  display: inline-block;\n  width: 34px;\n  height: 20px;\n  margin-right: 8px;\n}\n\n.Switch-module_switch__PKzsW input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.Switch-module_slider__p--Lz {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.2s;\n  border-radius: 10px;\n}\n\n.Switch-module_slider__p--Lz:before {\n  position: absolute;\n  content: \"\";\n  height: 14px;\n  width: 14px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.2s;\n  border-radius: 50%;\n}\n\ninput:checked + .Switch-module_slider__p--Lz {\n  background-color: #3f51b5;\n}\n\ninput:checked + .Switch-module_slider__p--Lz:before {\n  transform: translateX(14px);\n}\n\n.Switch-module_label__T-0Mn {\n  font-size: 14px;\n  color: #333;\n}";
var styles$2 = {"switchWrapper":"Switch-module_switchWrapper__-W2AV","switch":"Switch-module_switch__PKzsW","slider":"Switch-module_slider__p--Lz","label":"Switch-module_label__T-0Mn"};
styleInject(css_248z$m);

/**
 * A simple, material-like switch component with an optional label.
 *
 * @param {SwitchProps} props - The properties object for the switch.
 * @returns {JSX.Element} The switch component.
 */
const Switch = ({ checked, onChange, label }) => {
    return (React__default$4.createElement("label", { className: styles$2.switchWrapper },
        React__default$4.createElement("div", { className: styles$2.switch },
            React__default$4.createElement("input", { type: "checkbox", checked: checked, onChange: (e) => onChange(e.target.checked) }),
            React__default$4.createElement("span", { className: styles$2.slider })),
        label && React__default$4.createElement("span", { className: styles$2.label }, label)));
};

var input = {};

var Input$2 = {};

var utils = {};

var _curry1$3 = _curry1$6;
var _curry2$2 = _curry2$4;
var _isPlaceholder = _isPlaceholder$3;


/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
var _curry3$3 = function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3
             : _curry2$2(function(_b, _c) { return fn(a, _b, _c); });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3
             : _isPlaceholder(a) ? _curry2$2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) ? _curry2$2(function(_b, _c) { return fn(a, _b, _c); })
             : _curry1$3(function(_c) { return fn(a, b, _c); });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3
             : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2$2(function(_a, _b) { return fn(_a, _b, c); })
             : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2$2(function(_a, _c) { return fn(_a, b, _c); })
             : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2$2(function(_b, _c) { return fn(a, _b, _c); })
             : _isPlaceholder(a) ? _curry1$3(function(_a) { return fn(_a, b, c); })
             : _isPlaceholder(b) ? _curry1$3(function(_b) { return fn(a, _b, c); })
             : _isPlaceholder(c) ? _curry1$3(function(_c) { return fn(a, b, _c); })
             : fn(a, b, c);
    }
  };
};

var _curry3$2 = _curry3$3;


/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */
var assoc = _curry3$2(function assoc(prop, val, obj) {
  var result = {};
  for (var p in obj) {
    result[p] = obj[p];
  }
  result[prop] = val;
  return result;
});

var _arity$2 = function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0: return function() { return fn.apply(this, arguments); };
    case 1: return function(a0) { return fn.apply(this, arguments); };
    case 2: return function(a0, a1) { return fn.apply(this, arguments); };
    case 3: return function(a0, a1, a2) { return fn.apply(this, arguments); };
    case 4: return function(a0, a1, a2, a3) { return fn.apply(this, arguments); };
    case 5: return function(a0, a1, a2, a3, a4) { return fn.apply(this, arguments); };
    case 6: return function(a0, a1, a2, a3, a4, a5) { return fn.apply(this, arguments); };
    case 7: return function(a0, a1, a2, a3, a4, a5, a6) { return fn.apply(this, arguments); };
    case 8: return function(a0, a1, a2, a3, a4, a5, a6, a7) { return fn.apply(this, arguments); };
    case 9: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) { return fn.apply(this, arguments); };
    case 10: return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) { return fn.apply(this, arguments); };
    default: throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
};

var _pipe$1 = function _pipe(f, g) {
  return function() {
    return g.call(this, f.apply(this, arguments));
  };
};

var _xwrap$1 = (function() {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function() {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function(acc) { return acc; };
  XWrap.prototype['@@transducer/step'] = function(acc, x) {
    return this.f(acc, x);
  };

  return function _xwrap(fn) { return new XWrap(fn); };
}());

var _arity$1 = _arity$2;
var _curry2$1 = _curry2$4;


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */
var bind$1 = _curry2$1(function bind(fn, thisObj) {
  return _arity$1(fn.length, function() {
    return fn.apply(thisObj, arguments);
  });
});

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */

var _isArray$2 = Array.isArray || function _isArray(val) {
  return (val != null &&
          val.length >= 0 &&
          Object.prototype.toString.call(val) === '[object Array]');
};

var _isString$2 = function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
};

var _curry1$2 = _curry1$6;
var _isArray$1 = _isArray$2;
var _isString$1 = _isString$2;


/**
 * Tests whether or not an object is similar to an array.
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @deprecated since v0.23.0
 * @example
 *
 *      R.isArrayLike([]); //=> true
 *      R.isArrayLike(true); //=> false
 *      R.isArrayLike({}); //=> false
 *      R.isArrayLike({length: 10}); //=> false
 *      R.isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */
var isArrayLike$1 = _curry1$2(function isArrayLike(x) {
  if (_isArray$1(x)) { return true; }
  if (!x) { return false; }
  if (typeof x !== 'object') { return false; }
  if (_isString$1(x)) { return false; }
  if (x.nodeType === 1) { return !!x.length; }
  if (x.length === 0) { return true; }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});

var _xwrap = _xwrap$1;
var bind = bind$1;
var isArrayLike = isArrayLike$1;


var _reduce$2 = (function() {
  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      idx += 1;
    }
    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);
      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }
      step = iter.next();
    }
    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj) {
    return xf['@@transducer/result'](obj.reduce(bind(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = (typeof Symbol !== 'undefined') ? Symbol.iterator : '@@iterator';
  return function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }
    if (isArrayLike(list)) {
      return _arrayReduce(fn, acc, list);
    }
    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list);
    }
    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }
    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }
    throw new TypeError('reduce: list must be array or iterable');
  };
}());

var _curry3$1 = _curry3$3;
var _reduce$1 = _reduce$2;


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * `R.reduced` to shortcut the iteration.
 *
 * The arguments' order of `reduceRight`'s iterator function is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *                -               -10
 *               / \              / \
 *              -   4           -6   4
 *             / \              / \
 *            -   3   ==>     -3   3
 *           / \              / \
 *          -   2           -1   2
 *         / \              / \
 *        0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */
var reduce$1 = _curry3$1(_reduce$1);

var _isArray = _isArray$2;


/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implemtation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */
var _checkForMethod$2 = function _checkForMethod(methodname, fn) {
  return function() {
    var length = arguments.length;
    if (length === 0) {
      return fn();
    }
    var obj = arguments[length - 1];
    return (_isArray(obj) || typeof obj[methodname] !== 'function') ?
      fn.apply(this, arguments) :
      obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
};

var _checkForMethod$1 = _checkForMethod$2;
var _curry3 = _curry3$3;


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */
var slice$1 = _curry3(_checkForMethod$1('slice', function slice(fromIndex, toIndex, list) {
  return Array.prototype.slice.call(list, fromIndex, toIndex);
}));

var _checkForMethod = _checkForMethod$2;
var _curry1$1 = _curry1$6;
var slice = slice$1;


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */
var tail$1 = _curry1$1(_checkForMethod('tail', slice(1, Infinity)));

var _arity = _arity$2;
var _pipe = _pipe$1;
var reduce = reduce$1;
var tail = tail$1;


/**
 * Performs left-to-right function composition. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      var f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 */
var pipe$1 = function pipe() {
  if (arguments.length === 0) {
    throw new Error('pipe requires at least one argument');
  }
  return _arity(arguments[0].length,
                reduce(_pipe, arguments[0], tail(arguments)));
};

var _curry1 = _curry1$6;
var _isString = _isString$2;


/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */
var reverse$1 = _curry1(function reverse(list) {
  return _isString(list) ? list.split('').reverse().join('') :
                           Array.prototype.slice.call(list, 0).reverse();
});

var pipe = pipe$1;
var reverse = reverse$1;


/**
 * Performs right-to-left function composition. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.pipe
 * @example
 *
 *      var classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
 *      var yellGreeting = R.compose(R.toUpper, classyGreeting);
 *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
 *
 * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
 */
var compose = function compose() {
  if (arguments.length === 0) {
    throw new Error('compose requires at least one argument');
  }
  return pipe.apply(this, reverse(arguments));
};

var _curry2 = _curry2$4;


/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig (v, k -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */
var pickBy = _curry2(function pickBy(test, obj) {
  var result = {};
  for (var prop in obj) {
    if (test(obj[prop], prop, obj)) {
      result[prop] = obj[prop];
    }
  }
  return result;
});

Object.defineProperty(utils, "__esModule", {
  value: true
});
utils.isValuePresent = utils.getAnimationModule = utils.removeNamespace = utils.transformKeys = utils.prepareValueForInput = utils.inputTypeForPrototype = utils.cloneObject = utils.getViewport = utils.round = utils.range = utils.angle360FromPositions = utils.angleFromPositions = undefined;

var _assoc = assoc;

var _assoc2 = _interopRequireDefault$4(_assoc);

var _compose = compose;

var _compose2 = _interopRequireDefault$4(_compose);

var _keys = keys$8;

var _keys2 = _interopRequireDefault$4(_keys);

var _reduce = reduce$1;

var _reduce2 = _interopRequireDefault$4(_reduce);

var _pickBy = pickBy;

var _pickBy2 = _interopRequireDefault$4(_pickBy);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var angleFromPositions = utils.angleFromPositions = function angleFromPositions(cx, cy, ex, ey) {
  var theta = Math.atan2(ey - cy, ex - cx) + Math.PI / 2;
  return theta * 180 / Math.PI;
};

utils.angle360FromPositions = function angle360FromPositions(cx, cy, ex, ey) {
  var angle = angleFromPositions(cx, cy, ex, ey);
  return angle < 0 ? 360 + angle : angle;
};

utils.range = function range() {
  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var stop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var _start = 0,
      _stop = start;

  if (stop !== null) {
    _start = start;
    _stop = stop;
  }
  var length = Math.max(Math.ceil((_stop - _start) / step), 0);
  var _range = Array(length);

  for (var idx = 0; idx < length; idx += 1, _start += step) {
    _range[idx] = _start;
  }

  return _range;
};

utils.round = function round(number, decimals) {
  if (!isNaN(parseFloat(number)) && isFinite(number)) {
    var decimalPower = Math.pow(10, decimals);
    return Math.round(parseFloat(number) * decimalPower) / decimalPower;
  }
  return NaN;
};

utils.getViewport = function getViewport() {
  return {
    height: window.innerHeight || document.documentElement.offsetHeight,
    width: window.innerWidth || document.documentElement.offsetWidth
  };
};

utils.cloneObject = function cloneObject(object) {
  return JSON.parse(JSON.stringify(object));
};

utils.inputTypeForPrototype = function inputTypeForPrototype(prototype) {
  if (prototype === Date) return 'date';
  if (prototype === Number) return 'number';
  if (prototype === Boolean) return 'checkbox';
  return 'text';
};

utils.prepareValueForInput = function prepareValueForInput(value, type) {
  if (type === 'date') return new Date(value).toISOString().slice(0, 10);
  if (type === 'checkbox') {
    return value ? 'on' : '';
  }
  return value;
};

var transformKeys = utils.transformKeys = function transformKeys(fn) {
  return function (obj) {
    var addTransformedKey = function addTransformedKey(result, key) {
      return (0, _assoc2.default)(fn(key), obj[key], result);
    };
    return (0, _reduce2.default)(addTransformedKey, {}, (0, _keys2.default)(obj));
  };
};

var removeNamespace = utils.removeNamespace = function removeNamespace(namespace) {
  return function (key) {
    var capitalized = key.substr(namespace.length);
    return capitalized.slice(0, 1).toLowerCase() + capitalized.slice(1);
  };
};

utils.getAnimationModule = function getAnimationModule(animation, theme) {
  return (0, _compose2.default)(transformKeys(removeNamespace(animation)), (0, _pickBy2.default)(function (v, k) {
    return k.startsWith(animation);
  }))(theme);
};

utils.isValuePresent = function isValuePresent(value) {
  return value !== null && value !== undefined && value !== '' && !(typeof value === 'number' && isNaN(value));
};

Object.defineProperty(Input$2, "__esModule", {
  value: true
});
Input$2.Input = Input$2.inputFactory = undefined;

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1 = React__default$4;

var _react2$1 = _interopRequireDefault$3(_react$1);

var _propTypes$1 = propTypes.exports;

var _propTypes2$1 = _interopRequireDefault$3(_propTypes$1);

var _classnames4 = classnames$1.exports;

var _classnames5 = _interopRequireDefault$3(_classnames4);

var _reactCssThemr$3 = lib$7;

var _utils = utils;

var _identifiers$3 = identifiers;

var _FontIcon$3 = FontIcon$2;

var _FontIcon2$1 = _interopRequireDefault$3(_FontIcon$3);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var factory$1 = function factory(FontIcon) {
  var Input = function (_React$Component) {
    _inherits(Input, _React$Component);

    function Input() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Input);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            multiline = _this$props.multiline,
            maxLength = _this$props.maxLength;

        var valueFromEvent = event.target.value;

        // Trim value to maxLength if that exists (only on multiline inputs).
        // Note that this is still required even tho we have the onKeyPress filter
        // because the user could paste smt in the textarea.
        var haveToTrim = multiline && maxLength && event.target.value.length > maxLength;
        var value = haveToTrim ? valueFromEvent.substr(0, maxLength) : valueFromEvent;

        // propagate to to store and therefore to the input
        if (onChange) onChange(value, event);
      }, _this.handleAutoresize = function () {
        var element = _this.inputNode;
        var rows = _this.props.rows;

        if (typeof rows === 'number' && !isNaN(rows)) {
          element.style.height = null;
        } else {
          // compute the height difference between inner height and outer height
          var style = getComputedStyle(element, null);
          var heightOffset = style.boxSizing === 'content-box' ? -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom)) : parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);

          // resize the input to its content size
          element.style.height = 'auto';
          element.style.height = element.scrollHeight + heightOffset + 'px';
        }
      }, _this.handleKeyPress = function (event) {
        // prevent insertion of more characters if we're a multiline input
        // and maxLength exists
        var _this$props2 = _this.props,
            multiline = _this$props2.multiline,
            maxLength = _this$props2.maxLength,
            onKeyPress = _this$props2.onKeyPress;

        if (multiline && maxLength) {
          // check if smt is selected, in which case the newly added charcter would
          // replace the selected characters, so the length of value doesn't actually
          // increase.
          var isReplacing = event.target.selectionEnd - event.target.selectionStart;
          var value = event.target.value;

          if (!isReplacing && value.length === maxLength) {
            event.preventDefault();
            event.stopPropagation();
            return undefined;
          }
        }

        if (onKeyPress) onKeyPress(event);
        return undefined;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Input, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.multiline) {
          window.addEventListener('resize', this.handleAutoresize);
          this.handleAutoresize();
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!this.props.multiline && nextProps.multiline) {
          window.addEventListener('resize', this.handleAutoresize);
        } else if (this.props.multiline && !nextProps.multiline) {
          window.removeEventListener('resize', this.handleAutoresize);
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        // resize the textarea, if nessesary
        if (this.props.multiline) this.handleAutoresize();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.props.multiline) window.removeEventListener('resize', this.handleAutoresize);
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.inputNode.blur();
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.inputNode.focus();
      }
    }, {
      key: 'render',
      value: function render() {
        var _classnames2,
            _this2 = this;

        var _props = this.props,
            children = _props.children,
            defaultValue = _props.defaultValue,
            disabled = _props.disabled,
            error = _props.error,
            floating = _props.floating,
            hint = _props.hint,
            icon = _props.icon,
            name = _props.name,
            labelText = _props.label,
            maxLength = _props.maxLength,
            multiline = _props.multiline,
            required = _props.required,
            role = _props.role,
            theme = _props.theme,
            type = _props.type,
            value = _props.value,
            onKeyPress = _props.onKeyPress,
            _props$rows = _props.rows,
            rows = _props$rows === undefined ? 1 : _props$rows,
            others = _objectWithoutProperties$1(_props, ['children', 'defaultValue', 'disabled', 'error', 'floating', 'hint', 'icon', 'name', 'label', 'maxLength', 'multiline', 'required', 'role', 'theme', 'type', 'value', 'onKeyPress', 'rows']);

        var length = maxLength && value ? value.length : 0;
        var labelClassName = (0, _classnames5.default)(theme.label, _defineProperty({}, theme.fixed, !floating));

        var className = (0, _classnames5.default)(theme.input, (_classnames2 = {}, _defineProperty(_classnames2, theme.disabled, disabled), _defineProperty(_classnames2, theme.errored, error), _defineProperty(_classnames2, theme.hidden, type === 'hidden'), _defineProperty(_classnames2, theme.withIcon, icon), _classnames2), this.props.className);

        var valuePresent = (0, _utils.isValuePresent)(value) || (0, _utils.isValuePresent)(defaultValue);

        var inputElementProps = _extends$1({}, others, {
          className: (0, _classnames5.default)(theme.inputElement, _defineProperty({}, theme.filled, valuePresent)),
          onChange: this.handleChange,
          ref: function ref(node) {
            _this2.inputNode = node;
          },
          role: role,
          name: name,
          defaultValue: defaultValue,
          disabled: disabled,
          required: required,
          type: type,
          value: value
        });
        if (!multiline) {
          inputElementProps.maxLength = maxLength;
          inputElementProps.onKeyPress = onKeyPress;
        } else {
          inputElementProps.rows = rows;
          inputElementProps.onKeyPress = this.handleKeyPress;
        }

        return _react2$1.default.createElement(
          'div',
          { 'data-react-toolbox': 'input', className: className },
          _react2$1.default.createElement(multiline ? 'textarea' : 'input', inputElementProps),
          icon ? _react2$1.default.createElement(FontIcon, { className: theme.icon, value: icon }) : null,
          _react2$1.default.createElement('span', { className: theme.bar }),
          labelText ? _react2$1.default.createElement(
            'label',
            { className: labelClassName },
            labelText,
            required ? _react2$1.default.createElement(
              'span',
              { className: theme.required },
              ' * '
            ) : null
          ) : null,
          hint ? _react2$1.default.createElement(
            'span',
            { hidden: labelText, className: theme.hint },
            hint
          ) : null,
          error ? _react2$1.default.createElement(
            'span',
            { className: theme.error },
            error
          ) : null,
          maxLength ? _react2$1.default.createElement(
            'span',
            { className: theme.counter },
            length,
            '/',
            maxLength
          ) : null,
          children
        );
      }
    }]);

    return Input;
  }(_react2$1.default.Component);

  Input.propTypes = {
    children: _propTypes2$1.default.node,
    className: _propTypes2$1.default.string,
    defaultValue: _propTypes2$1.default.string,
    disabled: _propTypes2$1.default.bool,
    error: _propTypes2$1.default.oneOfType([_propTypes2$1.default.string, _propTypes2$1.default.node]),
    floating: _propTypes2$1.default.bool,
    hint: _propTypes2$1.default.oneOfType([_propTypes2$1.default.string, _propTypes2$1.default.node]),
    icon: _propTypes2$1.default.oneOfType([_propTypes2$1.default.string, _propTypes2$1.default.element]),
    label: _propTypes2$1.default.oneOfType([_propTypes2$1.default.string, _propTypes2$1.default.node]),
    maxLength: _propTypes2$1.default.number,
    multiline: _propTypes2$1.default.bool,
    name: _propTypes2$1.default.string,
    onBlur: _propTypes2$1.default.func,
    onChange: _propTypes2$1.default.func,
    onFocus: _propTypes2$1.default.func,
    onKeyPress: _propTypes2$1.default.func,
    required: _propTypes2$1.default.bool,
    role: _propTypes2$1.default.string,
    rows: _propTypes2$1.default.number,
    theme: _propTypes2$1.default.shape({
      bar: _propTypes2$1.default.string,
      counter: _propTypes2$1.default.string,
      disabled: _propTypes2$1.default.string,
      error: _propTypes2$1.default.string,
      errored: _propTypes2$1.default.string,
      hidden: _propTypes2$1.default.string,
      hint: _propTypes2$1.default.string,
      icon: _propTypes2$1.default.string,
      input: _propTypes2$1.default.string,
      inputElement: _propTypes2$1.default.string,
      required: _propTypes2$1.default.string,
      withIcon: _propTypes2$1.default.string
    }),
    type: _propTypes2$1.default.string,
    value: _propTypes2$1.default.oneOfType([_propTypes2$1.default.number, _propTypes2$1.default.object, _propTypes2$1.default.string])
  };
  Input.defaultProps = {
    className: '',
    hint: '',
    disabled: false,
    floating: true,
    multiline: false,
    required: false,
    role: 'input',
    type: 'text'
  };


  return Input;
};

var Input$1 = factory$1(_FontIcon2$1.default);
Input$2.default = (0, _reactCssThemr$3.themr)(_identifiers$3.INPUT)(Input$1);
Input$2.inputFactory = factory$1;
Input$2.Input = Input$1;

var css_248z$l = ":root {\n  --palette-red-50: rgb(255, 235, 238);\n  --palette-red-100: rgb(255, 205, 210);\n  --palette-red-200: rgb(239, 154, 154);\n  --palette-red-300: rgb(229, 115, 115);\n  --palette-red-400: rgb(239, 83, 80);\n  --palette-red-500: rgb(244, 67, 54);\n  --palette-red-600: rgb(229, 57, 53);\n  --palette-red-700: rgb(211, 47, 47);\n  --palette-red-800: rgb(198, 40, 40);\n  --palette-red-900: rgb(183, 28, 28);\n  --palette-red-a100: rgb(255, 138, 128);\n  --palette-red-a200: rgb(255, 82, 82);\n  --palette-red-a400: rgb(255, 23, 68);\n  --palette-red-a700: rgb(213, 0, 0);\n\n  --palette-pink-50: rgb(252, 228, 236);\n  --palette-pink-100: rgb(248, 187, 208);\n  --palette-pink-200: rgb(244, 143, 177);\n  --palette-pink-300: rgb(240, 98, 146);\n  --palette-pink-400: rgb(236, 64, 122);\n  --palette-pink-500: rgb(233, 30, 99);\n  --palette-pink-600: rgb(216, 27, 96);\n  --palette-pink-700: rgb(194, 24, 91);\n  --palette-pink-800: rgb(173, 20, 87);\n  --palette-pink-900: rgb(136, 14, 79);\n  --palette-pink-a100: rgb(255, 128, 171);\n  --palette-pink-a200: rgb(255, 64, 129);\n  --palette-pink-a400: rgb(245, 0, 87);\n  --palette-pink-a700: rgb(197, 17, 98);\n\n  --palette-purple-50: rgb(243, 229, 245);\n  --palette-purple-100: rgb(225, 190, 231);\n  --palette-purple-200: rgb(206, 147, 216);\n  --palette-purple-300: rgb(186, 104, 200);\n  --palette-purple-400: rgb(171, 71, 188);\n  --palette-purple-500: rgb(156, 39, 176);\n  --palette-purple-600: rgb(142, 36, 170);\n  --palette-purple-700: rgb(123, 31, 162);\n  --palette-purple-800: rgb(106, 27, 154);\n  --palette-purple-900: rgb(74, 20, 140);\n  --palette-purple-a100: rgb(234, 128, 252);\n  --palette-purple-a200: rgb(224, 64, 251);\n  --palette-purple-a400: rgb(213, 0, 249);\n  --palette-purple-a700: rgb(170, 0, 255);\n\n  --palette-deep-purple-50: rgb(237, 231, 246);\n  --palette-deep-purple-100: rgb(209, 196, 233);\n  --palette-deep-purple-200: rgb(179, 157, 219);\n  --palette-deep-purple-300: rgb(149, 117, 205);\n  --palette-deep-purple-400: rgb(126, 87, 194);\n  --palette-deep-purple-500: rgb(103, 58, 183);\n  --palette-deep-purple-600: rgb(94, 53, 177);\n  --palette-deep-purple-700: rgb(81, 45, 168);\n  --palette-deep-purple-800: rgb(69, 39, 160);\n  --palette-deep-purple-900: rgb(49, 27, 146);\n  --palette-deep-purple-a100: rgb(179, 136, 255);\n  --palette-deep-purple-a200: rgb(124, 77, 255);\n  --palette-deep-purple-a400: rgb(101, 31, 255);\n  --palette-deep-purple-a700: rgb(98, 0, 234);\n\n  --palette-indigo-50: rgb(232, 234, 246);\n  --palette-indigo-100: rgb(197, 202, 233);\n  --palette-indigo-200: rgb(159, 168, 218);\n  --palette-indigo-300: rgb(121, 134, 203);\n  --palette-indigo-400: rgb(92, 107, 192);\n  --palette-indigo-500: rgb(63, 81, 181);\n  --palette-indigo-600: rgb(57, 73, 171);\n  --palette-indigo-700: rgb(48, 63, 159);\n  --palette-indigo-800: rgb(40, 53, 147);\n  --palette-indigo-900: rgb(26, 35, 126);\n  --palette-indigo-a100: rgb(140, 158, 255);\n  --palette-indigo-a200: rgb(83, 109, 254);\n  --palette-indigo-a400: rgb(61, 90, 254);\n  --palette-indigo-a700: rgb(48, 79, 254);\n\n  --palette-blue-50: rgb(227, 242, 253);\n  --palette-blue-100: rgb(187, 222, 251);\n  --palette-blue-200: rgb(144, 202, 249);\n  --palette-blue-300: rgb(100, 181, 246);\n  --palette-blue-400: rgb(66, 165, 245);\n  --palette-blue-500: rgb(33, 150, 243);\n  --palette-blue-600: rgb(30, 136, 229);\n  --palette-blue-700: rgb(25, 118, 210);\n  --palette-blue-800: rgb(21, 101, 192);\n  --palette-blue-900: rgb(13, 71, 161);\n  --palette-blue-a100: rgb(130, 177, 255);\n  --palette-blue-a200: rgb(68, 138, 255);\n  --palette-blue-a400: rgb(41, 121, 255);\n  --palette-blue-a700: rgb(41, 98, 255);\n\n  --palette-light-blue-50: rgb(225, 245, 254);\n  --palette-light-blue-100: rgb(179, 229, 252);\n  --palette-light-blue-200: rgb(129, 212, 250);\n  --palette-light-blue-300: rgb(79, 195, 247);\n  --palette-light-blue-400: rgb(41, 182, 246);\n  --palette-light-blue-500: rgb(3, 169, 244);\n  --palette-light-blue-600: rgb(3, 155, 229);\n  --palette-light-blue-700: rgb(2, 136, 209);\n  --palette-light-blue-800: rgb(2, 119, 189);\n  --palette-light-blue-900: rgb(1, 87, 155);\n  --palette-light-blue-a100: rgb(128, 216, 255);\n  --palette-light-blue-a200: rgb(64, 196, 255);\n  --palette-light-blue-a400: rgb(0, 176, 255);\n  --palette-light-blue-a700: rgb(0, 145, 234);\n\n  --palette-cyan-50: rgb(224, 247, 250);\n  --palette-cyan-100: rgb(178, 235, 242);\n  --palette-cyan-200: rgb(128, 222, 234);\n  --palette-cyan-300: rgb(77, 208, 225);\n  --palette-cyan-400: rgb(38, 198, 218);\n  --palette-cyan-500: rgb(0, 188, 212);\n  --palette-cyan-600: rgb(0, 172, 193);\n  --palette-cyan-700: rgb(0, 151, 167);\n  --palette-cyan-800: rgb(0, 131, 143);\n  --palette-cyan-900: rgb(0, 96, 100);\n  --palette-cyan-a100: rgb(132, 255, 255);\n  --palette-cyan-a200: rgb(24, 255, 255);\n  --palette-cyan-a400: rgb(0, 229, 255);\n  --palette-cyan-a700: rgb(0, 184, 212);\n\n  --palette-teal-50: rgb(224, 242, 241);\n  --palette-teal-100: rgb(178, 223, 219);\n  --palette-teal-200: rgb(128, 203, 196);\n  --palette-teal-300: rgb(77, 182, 172);\n  --palette-teal-400: rgb(38, 166, 154);\n  --palette-teal-500: rgb(0, 150, 136);\n  --palette-teal-600: rgb(0, 137, 123);\n  --palette-teal-700: rgb(0, 121, 107);\n  --palette-teal-800: rgb(0, 105, 92);\n  --palette-teal-900: rgb(0, 77, 64);\n  --palette-teal-a100: rgb(167, 255, 235);\n  --palette-teal-a200: rgb(100, 255, 218);\n  --palette-teal-a400: rgb(29, 233, 182);\n  --palette-teal-a700: rgb(0, 191, 165);\n\n  --palette-green-50: rgb(232, 245, 233);\n  --palette-green-100: rgb(200, 230, 201);\n  --palette-green-200: rgb(165, 214, 167);\n  --palette-green-300: rgb(129, 199, 132);\n  --palette-green-400: rgb(102, 187, 106);\n  --palette-green-500: rgb(76, 175, 80);\n  --palette-green-600: rgb(67, 160, 71);\n  --palette-green-700: rgb(56, 142, 60);\n  --palette-green-800: rgb(46, 125, 50);\n  --palette-green-900: rgb(27, 94, 32);\n  --palette-green-a100: rgb(185, 246, 202);\n  --palette-green-a200: rgb(105, 240, 174);\n  --palette-green-a400: rgb(0, 230, 118);\n  --palette-green-a700: rgb(0, 200, 83);\n\n  --palette-light-green-50: rgb(241, 248, 233);\n  --palette-light-green-100: rgb(220, 237, 200);\n  --palette-light-green-200: rgb(197, 225, 165);\n  --palette-light-green-300: rgb(174, 213, 129);\n  --palette-light-green-400: rgb(156, 204, 101);\n  --palette-light-green-500: rgb(139, 195, 74);\n  --palette-light-green-600: rgb(124, 179, 66);\n  --palette-light-green-700: rgb(104, 159, 56);\n  --palette-light-green-800: rgb(85, 139, 47);\n  --palette-light-green-900: rgb(51, 105, 30);\n  --palette-light-green-a100: rgb(204, 255, 144);\n  --palette-light-green-a200: rgb(178, 255, 89);\n  --palette-light-green-a400: rgb(118, 255, 3);\n  --palette-light-green-a700: rgb(100, 221, 23);\n\n  --palette-lime-50: rgb(249, 251, 231);\n  --palette-lime-100: rgb(240, 244, 195);\n  --palette-lime-200: rgb(230, 238, 156);\n  --palette-lime-300: rgb(220, 231, 117);\n  --palette-lime-400: rgb(212, 225, 87);\n  --palette-lime-500: rgb(205, 220, 57);\n  --palette-lime-600: rgb(192, 202, 51);\n  --palette-lime-700: rgb(175, 180, 43);\n  --palette-lime-800: rgb(158, 157, 36);\n  --palette-lime-900: rgb(130, 119, 23);\n  --palette-lime-a100: rgb(244, 255, 129);\n  --palette-lime-a200: rgb(238, 255, 65);\n  --palette-lime-a400: rgb(198, 255, 0);\n  --palette-lime-a700: rgb(174, 234, 0);\n\n  --palette-yellow-50: rgb(255, 253, 231);\n  --palette-yellow-100: rgb(255, 249, 196);\n  --palette-yellow-200: rgb(255, 245, 157);\n  --palette-yellow-300: rgb(255, 241, 118);\n  --palette-yellow-400: rgb(255, 238, 88);\n  --palette-yellow-500: rgb(255, 235, 59);\n  --palette-yellow-600: rgb(253, 216, 53);\n  --palette-yellow-700: rgb(251, 192, 45);\n  --palette-yellow-800: rgb(249, 168, 37);\n  --palette-yellow-900: rgb(245, 127, 23);\n  --palette-yellow-a100: rgb(255, 255, 141);\n  --palette-yellow-a200: rgb(255, 255, 0);\n  --palette-yellow-a400: rgb(255, 234, 0);\n  --palette-yellow-a700: rgb(255, 214, 0);\n\n  --palette-amber-50: rgb(255, 248, 225);\n  --palette-amber-100: rgb(255, 236, 179);\n  --palette-amber-200: rgb(255, 224, 130);\n  --palette-amber-300: rgb(255, 213, 79);\n  --palette-amber-400: rgb(255, 202, 40);\n  --palette-amber-500: rgb(255, 193, 7);\n  --palette-amber-600: rgb(255, 179, 0);\n  --palette-amber-700: rgb(255, 160, 0);\n  --palette-amber-800: rgb(255, 143, 0);\n  --palette-amber-900: rgb(255, 111, 0);\n  --palette-amber-a100: rgb(255, 229, 127);\n  --palette-amber-a200: rgb(255, 215, 64);\n  --palette-amber-a400: rgb(255, 196, 0);\n  --palette-amber-a700: rgb(255, 171, 0);\n\n  --palette-orange-50: rgb(255, 243, 224);\n  --palette-orange-100: rgb(255, 224, 178);\n  --palette-orange-200: rgb(255, 204, 128);\n  --palette-orange-300: rgb(255, 183, 77);\n  --palette-orange-400: rgb(255, 167, 38);\n  --palette-orange-500: rgb(255, 152, 0);\n  --palette-orange-600: rgb(251, 140, 0);\n  --palette-orange-700: rgb(245, 124, 0);\n  --palette-orange-800: rgb(239, 108, 0);\n  --palette-orange-900: rgb(230, 81, 0);\n  --palette-orange-a100: rgb(255, 209, 128);\n  --palette-orange-a200: rgb(255, 171, 64);\n  --palette-orange-a400: rgb(255, 145, 0);\n  --palette-orange-a700: rgb(255, 109, 0);\n\n  --palette-deep-orange-50: rgb(251, 233, 231);\n  --palette-deep-orange-100: rgb(255, 204, 188);\n  --palette-deep-orange-200: rgb(255, 171, 145);\n  --palette-deep-orange-300: rgb(255, 138, 101);\n  --palette-deep-orange-400: rgb(255, 112, 67);\n  --palette-deep-orange-500: rgb(255, 87, 34);\n  --palette-deep-orange-600: rgb(244, 81, 30);\n  --palette-deep-orange-700: rgb(230, 74, 25);\n  --palette-deep-orange-800: rgb(216, 67, 21);\n  --palette-deep-orange-900: rgb(191, 54, 12);\n  --palette-deep-orange-a100: rgb(255, 158, 128);\n  --palette-deep-orange-a200: rgb(255, 110, 64);\n  --palette-deep-orange-a400: rgb(255, 61, 0);\n  --palette-deep-orange-a700: rgb(221, 44, 0);\n\n  --palette-brown-50: rgb(239, 235, 233);\n  --palette-brown-100: rgb(215, 204, 200);\n  --palette-brown-200: rgb(188, 170, 164);\n  --palette-brown-300: rgb(161, 136, 127);\n  --palette-brown-400: rgb(141, 110, 99);\n  --palette-brown-500: rgb(121, 85, 72);\n  --palette-brown-600: rgb(109, 76, 65);\n  --palette-brown-700: rgb(93, 64, 55);\n  --palette-brown-800: rgb(78, 52, 46);\n  --palette-brown-900: rgb(62, 39, 35);\n\n  --palette-grey-50: rgb(250, 250, 250);\n  --palette-grey-100: rgb(245, 245, 245);\n  --palette-grey-200: rgb(238, 238, 238);\n  --palette-grey-300: rgb(224, 224, 224);\n  --palette-grey-400: rgb(189, 189, 189);\n  --palette-grey-500: rgb(158, 158, 158);\n  --palette-grey-600: rgb(117, 117, 117);\n  --palette-grey-700: rgb(97, 97, 97);\n  --palette-grey-800: rgb(66, 66, 66);\n  --palette-grey-900: rgb(33, 33, 33);\n\n  --palette-blue-grey-50: rgb(236, 239, 241);\n  --palette-blue-grey-100: rgb(207, 216, 220);\n  --palette-blue-grey-200: rgb(176, 190, 197);\n  --palette-blue-grey-300: rgb(144, 164, 174);\n  --palette-blue-grey-400: rgb(120, 144, 156);\n  --palette-blue-grey-500: rgb(96, 125, 139);\n  --palette-blue-grey-600: rgb(84, 110, 122);\n  --palette-blue-grey-700: rgb(69, 90, 100);\n  --palette-blue-grey-800: rgb(55, 71, 79);\n  --palette-blue-grey-900: rgb(38, 50, 56);\n\n  --color-black: rgb(0, 0, 0);\n  --color-white: rgb(255, 255, 255);\n  --color-dark-contrast: var(--color-white);\n  --color-light-contrast: var(--color-black);\n}\n:root {\n  --color-divider: var(--palette-grey-200);\n  --color-background: var(--color-white);\n  --color-text: var(--palette-grey-900);\n  --color-text-secondary: var(--palette-grey-600);\n\n  --color-primary: var(--palette-indigo-500);\n  --color-primary-dark: var(--palette-indigo-700);\n  --color-accent: var(--palette-pink-a200);\n  --color-accent-dark: var(--palette-pink-700);\n  --color-primary-contrast: var(--color-dark-contrast);\n  --color-accent-contrast: var(--color-dark-contrast);\n\n  --unit: 10px;\n\n  --preferred-font: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  --font-size: calc(1.6 * var(--unit));\n  --font-size-tiny: calc(1.2 * var(--unit));\n  --font-size-small: calc(1.4 * var(--unit));\n  --font-size-normal: var(--font-size);\n  --font-size-big: calc(1.8 * var(--unit));\n  --font-weight-thin: 300;\n  --font-weight-normal: 400;\n  --font-weight-semi-bold: 500;\n  --font-weight-bold: 700;\n\n  --shadow-2p:\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-3p:\n    0 3px 4px 0 rgba(0, 0, 0, 0.14),\n    0 3px 3px -2px rgba(0, 0, 0, 0.2),\n    0 1px 8px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-4p:\n    0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12),\n    0 2px 4px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-6p:\n    0 6px 10px 0 rgba(0, 0, 0, 0.14),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-8p:\n    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12),\n    0 5px 5px -3px rgba(0, 0, 0, 0.2);\n\n  --shadow-16p:\n    0 16px 24px 2px rgba(0, 0, 0, 0.14),\n    0 6px 30px 5px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba(0, 0, 0, 0.2);\n\n  --shadow-key-umbra-opacity: 0.2;\n  --shadow-key-penumbra-opacity: 0.14;\n  --shadow-ambient-shadow-opacity: 0.12;\n\n  --zdepth-shadow-1: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);\n  --zdepth-shadow-2: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-3: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-4: 0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22);\n  --zdepth-shadow-5: 0 19px 60px rgba(0, 0, 0, 0.3), 0 15px 20px rgba(0, 0, 0, 0.22);\n\n  --animation-duration: 0.35s;\n  --animation-delay: calc(var(--animation-duration) / 5);\n  --animation-curve-fast-out-slow-in: cubic-bezier(0.4, 0, 0.2, 1);\n  --animation-curve-linear-out-slow-in: cubic-bezier(0, 0, 0.2, 1);\n  --animation-curve-fast-out-linear-in: cubic-bezier(0.4, 0, 1, 1);\n  --animation-curve-default: var(--animation-curve-fast-out-slow-in);\n\n  --z-index-highest: 300;\n  --z-index-higher: 200;\n  --z-index-high: 100;\n  --z-index-normal: 1;\n  --z-index-low: -100;\n  --z-index-lower: -200\n}\n:root {\n  --input-padding: calc(2 * var(--unit));\n  --input-field-padding: calc(0.8 * var(--unit));\n  --input-field-font-size: calc(1.6 * var(--unit));\n  --input-field-height: calc(var(--input-field-padding) * 2 + var(--input-field-font-size) * 1.4);\n  --input-label-font-size: calc(1.2 * var(--unit));\n  --input-focus-label-top: calc(0.6 * var(--unit));\n  --input-text-background-color: transparent;\n  --input-text-label-color: color(var(--color-text) a(26%));\n  --input-text-input-element-color: var(--color-text);\n  --input-text-bottom-border-color: color(var(--color-text) a(12%));\n  --input-text-highlight-color: var(--color-primary);\n  --input-text-disabled-color: var(--input-text-bottom-border-color);\n  --input-text-disabled-text-color: var(--input-text-label-color);\n  --input-text-error-color: rgb(222, 50, 38);\n  --input-text-required-color: rgb(222, 50, 38);\n  --input-underline-height: calc(2 * var(--unit));\n  --input-icon-font-size: calc(2.4 * var(--unit));\n  --input-icon-size: calc(2 * var(--input-icon-font-size));\n  --input-icon-offset: calc(1.6 * var(--unit));\n  --input-icon-right-space: calc(2 * var(--unit));\n  --input-chevron-offset: calc(0.8 * var(--unit));\n  --input-hint-opacity: 1;\n}\n.theme_input__LwMBM {\n  padding: var(--input-padding) 0;\n  position: relative;\n    box-sizing: border-box;\n    font-family: var(--preferred-font);\n    -webkit-font-smoothing: antialiased;\n    font-smoothing: antialiased;\n    text-size-adjust: 100%\n}\n.theme_input__LwMBM *,\n    .theme_input__LwMBM *::after,\n    .theme_input__LwMBM *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme_input__LwMBM.theme_withIcon__9KNcP {\n  margin-left: calc(var(--input-icon-size) + var(--input-icon-right-space));\n}\n.theme_icon__SbQl4 {\n  color: var(--input-text-label-color);\n  display: block;\n  font-size: var(--input-icon-font-size) !important;\n  height: var(--input-icon-size);\n  left: calc(-1 * (var(--input-icon-size) + var(--input-icon-right-space)));\n  line-height: var(--input-icon-size) !important;\n  position: absolute;\n  text-align: center;\n  top: var(--input-icon-offset);\n  transition: color var(--animation-duration) var(--animation-curve-default);\n  width: var(--input-icon-size);\n}\n.theme_inputElement__f6TU9 {\n  background-color: var(--input-text-background-color);\n  border-bottom: 1px solid var(--input-text-bottom-border-color);\n  border-left: 0;\n  border-radius: 0;\n  border-right: 0;\n  border-top: 0;\n  color: var(--input-text-input-element-color);\n  display: block;\n  font-size: var(--input-field-font-size);\n  outline: none;\n  padding: var(--input-field-padding) 0;\n  width: 100%\n}\n.theme_inputElement__f6TU9:required {\n  box-shadow: none;\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_bar__xHLPl::before,\n    .theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_bar__xHLPl::after {\n  width: 50%;\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y) {\n  color: var(--input-text-highlight-color);\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_label__g3fGA > .theme_required__m6dlI {\n  color: var(--input-text-required-color);\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_hint__VpHGn {\n  display: block;\n  opacity: var(--input-hint-opacity);\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_icon__SbQl4 {\n  color: var(--input-text-highlight-color);\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]).theme_filled__K5pf3 ~ .theme_hint__VpHGn {\n  opacity: 0;\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y), .theme_inputElement__f6TU9.theme_filled__K5pf3 ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y), .theme_inputElement__f6TU9[type='date'] ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y), .theme_inputElement__f6TU9[type='time'] ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y) {\n  font-size: var(--input-label-font-size);\n  top: var(--input-focus-label-top);\n}\n.theme_inputElement__f6TU9.theme_filled__K5pf3 ~ .theme_label__g3fGA.theme_fixed__RT21Y,\n  .theme_inputElement__f6TU9.theme_filled__K5pf3 ~ .theme_hint__VpHGn {\n  display: none;\n}\n.theme_label__g3fGA {\n  color: var(--input-text-label-color);\n  font-size: var(--input-field-font-size);\n  left: 0;\n  line-height: var(--input-field-font-size);\n  pointer-events: none;\n  position: absolute;\n  top: calc(var(--input-padding) + 1.5 * var(--input-field-padding));\n  transition-duration: var(--animation-duration);\n  transition-property: top, font-size, color;\n  transition-timing-function: var(--animation-curve-default)\n}\n.theme_label__g3fGA.theme_fixed__RT21Y ~ .theme_hint__VpHGn {\n  display: none;\n}\n.theme_hint__VpHGn {\n  color: var(--input-text-label-color);\n  font-size: var(--input-field-font-size);\n  left: 0;\n  line-height: var(--input-field-font-size);\n  opacity: var(--input-hint-opacity);\n  pointer-events: none;\n  position: absolute;\n  top: calc(var(--input-padding) + 1.5 * var(--input-field-padding));\n  transition-duration: var(--animation-duration);\n  transition-property: opacity;\n  transition-timing-function: var(--animation-curve-default);\n}\n.theme_bar__xHLPl {\n  display: block;\n  position: relative;\n  width: 100%\n}\n.theme_bar__xHLPl::before,\n  .theme_bar__xHLPl::after {\n  background-color: var(--input-text-highlight-color);\n  bottom: 0;\n  content: '';\n  height: 2px;\n  position: absolute;\n  transition-duration: 0.2s;\n  transition-property: width, background-color;\n  transition-timing-function: var(--animation-curve-default);\n  width: 0;\n}\n.theme_bar__xHLPl::before {\n  left: 50%;\n}\n.theme_bar__xHLPl::after {\n  right: 50%;\n}\n.theme_error__0UH88,\n.theme_counter__g9Qk2 {\n  color: var(--input-text-error-color);\n  font-size: var(--input-label-font-size);\n  line-height: var(--input-underline-height);\n  margin-bottom: calc(-1 * var(--input-underline-height));\n}\n.theme_counter__g9Qk2 {\n  color: var(--input-text-label-color);\n  position: absolute;\n  right: 0;\n}\n.theme_disabled__Gwuwj > .theme_inputElement__f6TU9 {\n  border-bottom-style: dashed;\n  color: var(--input-text-disabled-text-color);\n}\n.theme_errored__6QfYk {\n  padding-bottom: 0\n}\n.theme_errored__6QfYk > .theme_inputElement__f6TU9 {\n  border-bottom-color: var(--input-text-error-color);\n  margin-top: 1px;\n}\n.theme_errored__6QfYk > .theme_counter__g9Qk2,\n  .theme_errored__6QfYk > .theme_label__g3fGA {\n  color: var(--input-text-error-color);\n}\n.theme_errored__6QfYk > .theme_label__g3fGA > .theme_required__m6dlI {\n  color: var(--input-text-required-color);\n}\n.theme_hidden__3zJ6q {\n  display: none;\n}\n";
var theme$2 = {"input":"theme_input__LwMBM","withIcon":"theme_withIcon__9KNcP","icon":"theme_icon__SbQl4","inputElement":"theme_inputElement__f6TU9","bar":"theme_bar__xHLPl","label":"theme_label__g3fGA","fixed":"theme_fixed__RT21Y","required":"theme_required__m6dlI","hint":"theme_hint__VpHGn","filled":"theme_filled__K5pf3","error":"theme_error__0UH88","counter":"theme_counter__g9Qk2","disabled":"theme_disabled__Gwuwj","errored":"theme_errored__6QfYk","hidden":"theme_hidden__3zJ6q"};
var stylesheet$1=":root {\n  --palette-red-50: rgb(255, 235, 238);\n  --palette-red-100: rgb(255, 205, 210);\n  --palette-red-200: rgb(239, 154, 154);\n  --palette-red-300: rgb(229, 115, 115);\n  --palette-red-400: rgb(239, 83, 80);\n  --palette-red-500: rgb(244, 67, 54);\n  --palette-red-600: rgb(229, 57, 53);\n  --palette-red-700: rgb(211, 47, 47);\n  --palette-red-800: rgb(198, 40, 40);\n  --palette-red-900: rgb(183, 28, 28);\n  --palette-red-a100: rgb(255, 138, 128);\n  --palette-red-a200: rgb(255, 82, 82);\n  --palette-red-a400: rgb(255, 23, 68);\n  --palette-red-a700: rgb(213, 0, 0);\n\n  --palette-pink-50: rgb(252, 228, 236);\n  --palette-pink-100: rgb(248, 187, 208);\n  --palette-pink-200: rgb(244, 143, 177);\n  --palette-pink-300: rgb(240, 98, 146);\n  --palette-pink-400: rgb(236, 64, 122);\n  --palette-pink-500: rgb(233, 30, 99);\n  --palette-pink-600: rgb(216, 27, 96);\n  --palette-pink-700: rgb(194, 24, 91);\n  --palette-pink-800: rgb(173, 20, 87);\n  --palette-pink-900: rgb(136, 14, 79);\n  --palette-pink-a100: rgb(255, 128, 171);\n  --palette-pink-a200: rgb(255, 64, 129);\n  --palette-pink-a400: rgb(245, 0, 87);\n  --palette-pink-a700: rgb(197, 17, 98);\n\n  --palette-purple-50: rgb(243, 229, 245);\n  --palette-purple-100: rgb(225, 190, 231);\n  --palette-purple-200: rgb(206, 147, 216);\n  --palette-purple-300: rgb(186, 104, 200);\n  --palette-purple-400: rgb(171, 71, 188);\n  --palette-purple-500: rgb(156, 39, 176);\n  --palette-purple-600: rgb(142, 36, 170);\n  --palette-purple-700: rgb(123, 31, 162);\n  --palette-purple-800: rgb(106, 27, 154);\n  --palette-purple-900: rgb(74, 20, 140);\n  --palette-purple-a100: rgb(234, 128, 252);\n  --palette-purple-a200: rgb(224, 64, 251);\n  --palette-purple-a400: rgb(213, 0, 249);\n  --palette-purple-a700: rgb(170, 0, 255);\n\n  --palette-deep-purple-50: rgb(237, 231, 246);\n  --palette-deep-purple-100: rgb(209, 196, 233);\n  --palette-deep-purple-200: rgb(179, 157, 219);\n  --palette-deep-purple-300: rgb(149, 117, 205);\n  --palette-deep-purple-400: rgb(126, 87, 194);\n  --palette-deep-purple-500: rgb(103, 58, 183);\n  --palette-deep-purple-600: rgb(94, 53, 177);\n  --palette-deep-purple-700: rgb(81, 45, 168);\n  --palette-deep-purple-800: rgb(69, 39, 160);\n  --palette-deep-purple-900: rgb(49, 27, 146);\n  --palette-deep-purple-a100: rgb(179, 136, 255);\n  --palette-deep-purple-a200: rgb(124, 77, 255);\n  --palette-deep-purple-a400: rgb(101, 31, 255);\n  --palette-deep-purple-a700: rgb(98, 0, 234);\n\n  --palette-indigo-50: rgb(232, 234, 246);\n  --palette-indigo-100: rgb(197, 202, 233);\n  --palette-indigo-200: rgb(159, 168, 218);\n  --palette-indigo-300: rgb(121, 134, 203);\n  --palette-indigo-400: rgb(92, 107, 192);\n  --palette-indigo-500: rgb(63, 81, 181);\n  --palette-indigo-600: rgb(57, 73, 171);\n  --palette-indigo-700: rgb(48, 63, 159);\n  --palette-indigo-800: rgb(40, 53, 147);\n  --palette-indigo-900: rgb(26, 35, 126);\n  --palette-indigo-a100: rgb(140, 158, 255);\n  --palette-indigo-a200: rgb(83, 109, 254);\n  --palette-indigo-a400: rgb(61, 90, 254);\n  --palette-indigo-a700: rgb(48, 79, 254);\n\n  --palette-blue-50: rgb(227, 242, 253);\n  --palette-blue-100: rgb(187, 222, 251);\n  --palette-blue-200: rgb(144, 202, 249);\n  --palette-blue-300: rgb(100, 181, 246);\n  --palette-blue-400: rgb(66, 165, 245);\n  --palette-blue-500: rgb(33, 150, 243);\n  --palette-blue-600: rgb(30, 136, 229);\n  --palette-blue-700: rgb(25, 118, 210);\n  --palette-blue-800: rgb(21, 101, 192);\n  --palette-blue-900: rgb(13, 71, 161);\n  --palette-blue-a100: rgb(130, 177, 255);\n  --palette-blue-a200: rgb(68, 138, 255);\n  --palette-blue-a400: rgb(41, 121, 255);\n  --palette-blue-a700: rgb(41, 98, 255);\n\n  --palette-light-blue-50: rgb(225, 245, 254);\n  --palette-light-blue-100: rgb(179, 229, 252);\n  --palette-light-blue-200: rgb(129, 212, 250);\n  --palette-light-blue-300: rgb(79, 195, 247);\n  --palette-light-blue-400: rgb(41, 182, 246);\n  --palette-light-blue-500: rgb(3, 169, 244);\n  --palette-light-blue-600: rgb(3, 155, 229);\n  --palette-light-blue-700: rgb(2, 136, 209);\n  --palette-light-blue-800: rgb(2, 119, 189);\n  --palette-light-blue-900: rgb(1, 87, 155);\n  --palette-light-blue-a100: rgb(128, 216, 255);\n  --palette-light-blue-a200: rgb(64, 196, 255);\n  --palette-light-blue-a400: rgb(0, 176, 255);\n  --palette-light-blue-a700: rgb(0, 145, 234);\n\n  --palette-cyan-50: rgb(224, 247, 250);\n  --palette-cyan-100: rgb(178, 235, 242);\n  --palette-cyan-200: rgb(128, 222, 234);\n  --palette-cyan-300: rgb(77, 208, 225);\n  --palette-cyan-400: rgb(38, 198, 218);\n  --palette-cyan-500: rgb(0, 188, 212);\n  --palette-cyan-600: rgb(0, 172, 193);\n  --palette-cyan-700: rgb(0, 151, 167);\n  --palette-cyan-800: rgb(0, 131, 143);\n  --palette-cyan-900: rgb(0, 96, 100);\n  --palette-cyan-a100: rgb(132, 255, 255);\n  --palette-cyan-a200: rgb(24, 255, 255);\n  --palette-cyan-a400: rgb(0, 229, 255);\n  --palette-cyan-a700: rgb(0, 184, 212);\n\n  --palette-teal-50: rgb(224, 242, 241);\n  --palette-teal-100: rgb(178, 223, 219);\n  --palette-teal-200: rgb(128, 203, 196);\n  --palette-teal-300: rgb(77, 182, 172);\n  --palette-teal-400: rgb(38, 166, 154);\n  --palette-teal-500: rgb(0, 150, 136);\n  --palette-teal-600: rgb(0, 137, 123);\n  --palette-teal-700: rgb(0, 121, 107);\n  --palette-teal-800: rgb(0, 105, 92);\n  --palette-teal-900: rgb(0, 77, 64);\n  --palette-teal-a100: rgb(167, 255, 235);\n  --palette-teal-a200: rgb(100, 255, 218);\n  --palette-teal-a400: rgb(29, 233, 182);\n  --palette-teal-a700: rgb(0, 191, 165);\n\n  --palette-green-50: rgb(232, 245, 233);\n  --palette-green-100: rgb(200, 230, 201);\n  --palette-green-200: rgb(165, 214, 167);\n  --palette-green-300: rgb(129, 199, 132);\n  --palette-green-400: rgb(102, 187, 106);\n  --palette-green-500: rgb(76, 175, 80);\n  --palette-green-600: rgb(67, 160, 71);\n  --palette-green-700: rgb(56, 142, 60);\n  --palette-green-800: rgb(46, 125, 50);\n  --palette-green-900: rgb(27, 94, 32);\n  --palette-green-a100: rgb(185, 246, 202);\n  --palette-green-a200: rgb(105, 240, 174);\n  --palette-green-a400: rgb(0, 230, 118);\n  --palette-green-a700: rgb(0, 200, 83);\n\n  --palette-light-green-50: rgb(241, 248, 233);\n  --palette-light-green-100: rgb(220, 237, 200);\n  --palette-light-green-200: rgb(197, 225, 165);\n  --palette-light-green-300: rgb(174, 213, 129);\n  --palette-light-green-400: rgb(156, 204, 101);\n  --palette-light-green-500: rgb(139, 195, 74);\n  --palette-light-green-600: rgb(124, 179, 66);\n  --palette-light-green-700: rgb(104, 159, 56);\n  --palette-light-green-800: rgb(85, 139, 47);\n  --palette-light-green-900: rgb(51, 105, 30);\n  --palette-light-green-a100: rgb(204, 255, 144);\n  --palette-light-green-a200: rgb(178, 255, 89);\n  --palette-light-green-a400: rgb(118, 255, 3);\n  --palette-light-green-a700: rgb(100, 221, 23);\n\n  --palette-lime-50: rgb(249, 251, 231);\n  --palette-lime-100: rgb(240, 244, 195);\n  --palette-lime-200: rgb(230, 238, 156);\n  --palette-lime-300: rgb(220, 231, 117);\n  --palette-lime-400: rgb(212, 225, 87);\n  --palette-lime-500: rgb(205, 220, 57);\n  --palette-lime-600: rgb(192, 202, 51);\n  --palette-lime-700: rgb(175, 180, 43);\n  --palette-lime-800: rgb(158, 157, 36);\n  --palette-lime-900: rgb(130, 119, 23);\n  --palette-lime-a100: rgb(244, 255, 129);\n  --palette-lime-a200: rgb(238, 255, 65);\n  --palette-lime-a400: rgb(198, 255, 0);\n  --palette-lime-a700: rgb(174, 234, 0);\n\n  --palette-yellow-50: rgb(255, 253, 231);\n  --palette-yellow-100: rgb(255, 249, 196);\n  --palette-yellow-200: rgb(255, 245, 157);\n  --palette-yellow-300: rgb(255, 241, 118);\n  --palette-yellow-400: rgb(255, 238, 88);\n  --palette-yellow-500: rgb(255, 235, 59);\n  --palette-yellow-600: rgb(253, 216, 53);\n  --palette-yellow-700: rgb(251, 192, 45);\n  --palette-yellow-800: rgb(249, 168, 37);\n  --palette-yellow-900: rgb(245, 127, 23);\n  --palette-yellow-a100: rgb(255, 255, 141);\n  --palette-yellow-a200: rgb(255, 255, 0);\n  --palette-yellow-a400: rgb(255, 234, 0);\n  --palette-yellow-a700: rgb(255, 214, 0);\n\n  --palette-amber-50: rgb(255, 248, 225);\n  --palette-amber-100: rgb(255, 236, 179);\n  --palette-amber-200: rgb(255, 224, 130);\n  --palette-amber-300: rgb(255, 213, 79);\n  --palette-amber-400: rgb(255, 202, 40);\n  --palette-amber-500: rgb(255, 193, 7);\n  --palette-amber-600: rgb(255, 179, 0);\n  --palette-amber-700: rgb(255, 160, 0);\n  --palette-amber-800: rgb(255, 143, 0);\n  --palette-amber-900: rgb(255, 111, 0);\n  --palette-amber-a100: rgb(255, 229, 127);\n  --palette-amber-a200: rgb(255, 215, 64);\n  --palette-amber-a400: rgb(255, 196, 0);\n  --palette-amber-a700: rgb(255, 171, 0);\n\n  --palette-orange-50: rgb(255, 243, 224);\n  --palette-orange-100: rgb(255, 224, 178);\n  --palette-orange-200: rgb(255, 204, 128);\n  --palette-orange-300: rgb(255, 183, 77);\n  --palette-orange-400: rgb(255, 167, 38);\n  --palette-orange-500: rgb(255, 152, 0);\n  --palette-orange-600: rgb(251, 140, 0);\n  --palette-orange-700: rgb(245, 124, 0);\n  --palette-orange-800: rgb(239, 108, 0);\n  --palette-orange-900: rgb(230, 81, 0);\n  --palette-orange-a100: rgb(255, 209, 128);\n  --palette-orange-a200: rgb(255, 171, 64);\n  --palette-orange-a400: rgb(255, 145, 0);\n  --palette-orange-a700: rgb(255, 109, 0);\n\n  --palette-deep-orange-50: rgb(251, 233, 231);\n  --palette-deep-orange-100: rgb(255, 204, 188);\n  --palette-deep-orange-200: rgb(255, 171, 145);\n  --palette-deep-orange-300: rgb(255, 138, 101);\n  --palette-deep-orange-400: rgb(255, 112, 67);\n  --palette-deep-orange-500: rgb(255, 87, 34);\n  --palette-deep-orange-600: rgb(244, 81, 30);\n  --palette-deep-orange-700: rgb(230, 74, 25);\n  --palette-deep-orange-800: rgb(216, 67, 21);\n  --palette-deep-orange-900: rgb(191, 54, 12);\n  --palette-deep-orange-a100: rgb(255, 158, 128);\n  --palette-deep-orange-a200: rgb(255, 110, 64);\n  --palette-deep-orange-a400: rgb(255, 61, 0);\n  --palette-deep-orange-a700: rgb(221, 44, 0);\n\n  --palette-brown-50: rgb(239, 235, 233);\n  --palette-brown-100: rgb(215, 204, 200);\n  --palette-brown-200: rgb(188, 170, 164);\n  --palette-brown-300: rgb(161, 136, 127);\n  --palette-brown-400: rgb(141, 110, 99);\n  --palette-brown-500: rgb(121, 85, 72);\n  --palette-brown-600: rgb(109, 76, 65);\n  --palette-brown-700: rgb(93, 64, 55);\n  --palette-brown-800: rgb(78, 52, 46);\n  --palette-brown-900: rgb(62, 39, 35);\n\n  --palette-grey-50: rgb(250, 250, 250);\n  --palette-grey-100: rgb(245, 245, 245);\n  --palette-grey-200: rgb(238, 238, 238);\n  --palette-grey-300: rgb(224, 224, 224);\n  --palette-grey-400: rgb(189, 189, 189);\n  --palette-grey-500: rgb(158, 158, 158);\n  --palette-grey-600: rgb(117, 117, 117);\n  --palette-grey-700: rgb(97, 97, 97);\n  --palette-grey-800: rgb(66, 66, 66);\n  --palette-grey-900: rgb(33, 33, 33);\n\n  --palette-blue-grey-50: rgb(236, 239, 241);\n  --palette-blue-grey-100: rgb(207, 216, 220);\n  --palette-blue-grey-200: rgb(176, 190, 197);\n  --palette-blue-grey-300: rgb(144, 164, 174);\n  --palette-blue-grey-400: rgb(120, 144, 156);\n  --palette-blue-grey-500: rgb(96, 125, 139);\n  --palette-blue-grey-600: rgb(84, 110, 122);\n  --palette-blue-grey-700: rgb(69, 90, 100);\n  --palette-blue-grey-800: rgb(55, 71, 79);\n  --palette-blue-grey-900: rgb(38, 50, 56);\n\n  --color-black: rgb(0, 0, 0);\n  --color-white: rgb(255, 255, 255);\n  --color-dark-contrast: var(--color-white);\n  --color-light-contrast: var(--color-black);\n}\n:root {\n  --color-divider: var(--palette-grey-200);\n  --color-background: var(--color-white);\n  --color-text: var(--palette-grey-900);\n  --color-text-secondary: var(--palette-grey-600);\n\n  --color-primary: var(--palette-indigo-500);\n  --color-primary-dark: var(--palette-indigo-700);\n  --color-accent: var(--palette-pink-a200);\n  --color-accent-dark: var(--palette-pink-700);\n  --color-primary-contrast: var(--color-dark-contrast);\n  --color-accent-contrast: var(--color-dark-contrast);\n\n  --unit: 10px;\n\n  --preferred-font: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  --font-size: calc(1.6 * var(--unit));\n  --font-size-tiny: calc(1.2 * var(--unit));\n  --font-size-small: calc(1.4 * var(--unit));\n  --font-size-normal: var(--font-size);\n  --font-size-big: calc(1.8 * var(--unit));\n  --font-weight-thin: 300;\n  --font-weight-normal: 400;\n  --font-weight-semi-bold: 500;\n  --font-weight-bold: 700;\n\n  --shadow-2p:\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-3p:\n    0 3px 4px 0 rgba(0, 0, 0, 0.14),\n    0 3px 3px -2px rgba(0, 0, 0, 0.2),\n    0 1px 8px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-4p:\n    0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12),\n    0 2px 4px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-6p:\n    0 6px 10px 0 rgba(0, 0, 0, 0.14),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-8p:\n    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12),\n    0 5px 5px -3px rgba(0, 0, 0, 0.2);\n\n  --shadow-16p:\n    0 16px 24px 2px rgba(0, 0, 0, 0.14),\n    0 6px 30px 5px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba(0, 0, 0, 0.2);\n\n  --shadow-key-umbra-opacity: 0.2;\n  --shadow-key-penumbra-opacity: 0.14;\n  --shadow-ambient-shadow-opacity: 0.12;\n\n  --zdepth-shadow-1: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);\n  --zdepth-shadow-2: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-3: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-4: 0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22);\n  --zdepth-shadow-5: 0 19px 60px rgba(0, 0, 0, 0.3), 0 15px 20px rgba(0, 0, 0, 0.22);\n\n  --animation-duration: 0.35s;\n  --animation-delay: calc(var(--animation-duration) / 5);\n  --animation-curve-fast-out-slow-in: cubic-bezier(0.4, 0, 0.2, 1);\n  --animation-curve-linear-out-slow-in: cubic-bezier(0, 0, 0.2, 1);\n  --animation-curve-fast-out-linear-in: cubic-bezier(0.4, 0, 1, 1);\n  --animation-curve-default: var(--animation-curve-fast-out-slow-in);\n\n  --z-index-highest: 300;\n  --z-index-higher: 200;\n  --z-index-high: 100;\n  --z-index-normal: 1;\n  --z-index-low: -100;\n  --z-index-lower: -200\n}\n:root {\n  --input-padding: calc(2 * var(--unit));\n  --input-field-padding: calc(0.8 * var(--unit));\n  --input-field-font-size: calc(1.6 * var(--unit));\n  --input-field-height: calc(var(--input-field-padding) * 2 + var(--input-field-font-size) * 1.4);\n  --input-label-font-size: calc(1.2 * var(--unit));\n  --input-focus-label-top: calc(0.6 * var(--unit));\n  --input-text-background-color: transparent;\n  --input-text-label-color: color(var(--color-text) a(26%));\n  --input-text-input-element-color: var(--color-text);\n  --input-text-bottom-border-color: color(var(--color-text) a(12%));\n  --input-text-highlight-color: var(--color-primary);\n  --input-text-disabled-color: var(--input-text-bottom-border-color);\n  --input-text-disabled-text-color: var(--input-text-label-color);\n  --input-text-error-color: rgb(222, 50, 38);\n  --input-text-required-color: rgb(222, 50, 38);\n  --input-underline-height: calc(2 * var(--unit));\n  --input-icon-font-size: calc(2.4 * var(--unit));\n  --input-icon-size: calc(2 * var(--input-icon-font-size));\n  --input-icon-offset: calc(1.6 * var(--unit));\n  --input-icon-right-space: calc(2 * var(--unit));\n  --input-chevron-offset: calc(0.8 * var(--unit));\n  --input-hint-opacity: 1;\n}\n.theme_input__LwMBM {\n  padding: var(--input-padding) 0;\n  position: relative;\n    box-sizing: border-box;\n    font-family: var(--preferred-font);\n    -webkit-font-smoothing: antialiased;\n    font-smoothing: antialiased;\n    text-size-adjust: 100%\n}\n.theme_input__LwMBM *,\n    .theme_input__LwMBM *::after,\n    .theme_input__LwMBM *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme_input__LwMBM.theme_withIcon__9KNcP {\n  margin-left: calc(var(--input-icon-size) + var(--input-icon-right-space));\n}\n.theme_icon__SbQl4 {\n  color: var(--input-text-label-color);\n  display: block;\n  font-size: var(--input-icon-font-size) !important;\n  height: var(--input-icon-size);\n  left: calc(-1 * (var(--input-icon-size) + var(--input-icon-right-space)));\n  line-height: var(--input-icon-size) !important;\n  position: absolute;\n  text-align: center;\n  top: var(--input-icon-offset);\n  transition: color var(--animation-duration) var(--animation-curve-default);\n  width: var(--input-icon-size);\n}\n.theme_inputElement__f6TU9 {\n  background-color: var(--input-text-background-color);\n  border-bottom: 1px solid var(--input-text-bottom-border-color);\n  border-left: 0;\n  border-radius: 0;\n  border-right: 0;\n  border-top: 0;\n  color: var(--input-text-input-element-color);\n  display: block;\n  font-size: var(--input-field-font-size);\n  outline: none;\n  padding: var(--input-field-padding) 0;\n  width: 100%\n}\n.theme_inputElement__f6TU9:required {\n  box-shadow: none;\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_bar__xHLPl::before,\n    .theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_bar__xHLPl::after {\n  width: 50%;\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y) {\n  color: var(--input-text-highlight-color);\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_label__g3fGA > .theme_required__m6dlI {\n  color: var(--input-text-required-color);\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_hint__VpHGn {\n  display: block;\n  opacity: var(--input-hint-opacity);\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_icon__SbQl4 {\n  color: var(--input-text-highlight-color);\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]).theme_filled__K5pf3 ~ .theme_hint__VpHGn {\n  opacity: 0;\n}\n.theme_inputElement__f6TU9:focus:not([disabled]):not([readonly]) ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y), .theme_inputElement__f6TU9.theme_filled__K5pf3 ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y), .theme_inputElement__f6TU9[type='date'] ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y), .theme_inputElement__f6TU9[type='time'] ~ .theme_label__g3fGA:not(.theme_fixed__RT21Y) {\n  font-size: var(--input-label-font-size);\n  top: var(--input-focus-label-top);\n}\n.theme_inputElement__f6TU9.theme_filled__K5pf3 ~ .theme_label__g3fGA.theme_fixed__RT21Y,\n  .theme_inputElement__f6TU9.theme_filled__K5pf3 ~ .theme_hint__VpHGn {\n  display: none;\n}\n.theme_label__g3fGA {\n  color: var(--input-text-label-color);\n  font-size: var(--input-field-font-size);\n  left: 0;\n  line-height: var(--input-field-font-size);\n  pointer-events: none;\n  position: absolute;\n  top: calc(var(--input-padding) + 1.5 * var(--input-field-padding));\n  transition-duration: var(--animation-duration);\n  transition-property: top, font-size, color;\n  transition-timing-function: var(--animation-curve-default)\n}\n.theme_label__g3fGA.theme_fixed__RT21Y ~ .theme_hint__VpHGn {\n  display: none;\n}\n.theme_hint__VpHGn {\n  color: var(--input-text-label-color);\n  font-size: var(--input-field-font-size);\n  left: 0;\n  line-height: var(--input-field-font-size);\n  opacity: var(--input-hint-opacity);\n  pointer-events: none;\n  position: absolute;\n  top: calc(var(--input-padding) + 1.5 * var(--input-field-padding));\n  transition-duration: var(--animation-duration);\n  transition-property: opacity;\n  transition-timing-function: var(--animation-curve-default);\n}\n.theme_bar__xHLPl {\n  display: block;\n  position: relative;\n  width: 100%\n}\n.theme_bar__xHLPl::before,\n  .theme_bar__xHLPl::after {\n  background-color: var(--input-text-highlight-color);\n  bottom: 0;\n  content: '';\n  height: 2px;\n  position: absolute;\n  transition-duration: 0.2s;\n  transition-property: width, background-color;\n  transition-timing-function: var(--animation-curve-default);\n  width: 0;\n}\n.theme_bar__xHLPl::before {\n  left: 50%;\n}\n.theme_bar__xHLPl::after {\n  right: 50%;\n}\n.theme_error__0UH88,\n.theme_counter__g9Qk2 {\n  color: var(--input-text-error-color);\n  font-size: var(--input-label-font-size);\n  line-height: var(--input-underline-height);\n  margin-bottom: calc(-1 * var(--input-underline-height));\n}\n.theme_counter__g9Qk2 {\n  color: var(--input-text-label-color);\n  position: absolute;\n  right: 0;\n}\n.theme_disabled__Gwuwj > .theme_inputElement__f6TU9 {\n  border-bottom-style: dashed;\n  color: var(--input-text-disabled-text-color);\n}\n.theme_errored__6QfYk {\n  padding-bottom: 0\n}\n.theme_errored__6QfYk > .theme_inputElement__f6TU9 {\n  border-bottom-color: var(--input-text-error-color);\n  margin-top: 1px;\n}\n.theme_errored__6QfYk > .theme_counter__g9Qk2,\n  .theme_errored__6QfYk > .theme_label__g3fGA {\n  color: var(--input-text-error-color);\n}\n.theme_errored__6QfYk > .theme_label__g3fGA > .theme_required__m6dlI {\n  color: var(--input-text-required-color);\n}\n.theme_hidden__3zJ6q {\n  display: none;\n}\n";
styleInject(css_248z$l);

var theme$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': theme$2,
  stylesheet: stylesheet$1
});

var require$$4$1 = /*@__PURE__*/getAugmentedNamespace(theme$3);

Object.defineProperty(input, "__esModule", {
  value: true
});
var Input_1 = input.Input = undefined;

var _reactCssThemr$2 = lib$7;

var _identifiers$2 = identifiers;

var _Input = Input$2;

var _FontIcon$2 = FontIcon$2;

var _theme$1 = require$$4$1;

var _theme2$1 = _interopRequireDefault$2(_theme$1);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (0, _Input.inputFactory)(_FontIcon$2.FontIcon);
var ThemedInput = (0, _reactCssThemr$2.themr)(_identifiers$2.INPUT, _theme2$1.default, { withRef: true })(Input);

input.default = ThemedInput;
Input_1 = input.Input = ThemedInput;

var css_248z$k = ".buttonTheme_icon__jZL5Z {\n  color: #ffffff;\n}";
var buttonTheme = {"icon":"buttonTheme_icon__jZL5Z"};
styleInject(css_248z$k);

var avatar = {};

var Avatar$2 = {};

Object.defineProperty(Avatar$2, "__esModule", {
  value: true
});
Avatar$2.Avatar = Avatar$2.avatarFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = React__default$4;

var _react2 = _interopRequireDefault$1(_react);

var _propTypes = propTypes.exports;

var _propTypes2 = _interopRequireDefault$1(_propTypes);

var _classnames = classnames$1.exports;

var _classnames2 = _interopRequireDefault$1(_classnames);

var _reactCssThemr$1 = lib$7;

var _identifiers$1 = identifiers;

var _FontIcon$1 = FontIcon$2;

var _FontIcon2 = _interopRequireDefault$1(_FontIcon$1);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var factory = function factory(FontIcon) {
  var Avatar = function Avatar(_ref) {
    var alt = _ref.alt,
        children = _ref.children,
        className = _ref.className,
        cover = _ref.cover,
        icon = _ref.icon,
        image = _ref.image,
        theme = _ref.theme,
        title = _ref.title,
        other = _objectWithoutProperties(_ref, ['alt', 'children', 'className', 'cover', 'icon', 'image', 'theme', 'title']);

    return _react2.default.createElement(
      'div',
      _extends({ 'data-react-toolbox': 'avatar', className: (0, _classnames2.default)(theme.avatar, className) }, other),
      children,
      cover && typeof image === 'string' && _react2.default.createElement('span', { 'aria-label': alt, className: theme.image, style: { backgroundImage: 'url(' + image + ')' } }),
      !cover && (typeof image === 'string' ? _react2.default.createElement('img', { alt: alt, className: theme.image, src: image, title: title }) : image),
      typeof icon === 'string' ? _react2.default.createElement(FontIcon, { className: theme.letter, value: icon, alt: alt }) : icon,
      title ? _react2.default.createElement(
        'span',
        { className: theme.letter },
        title[0]
      ) : null
    );
  };

  Avatar.propTypes = {
    alt: _propTypes2.default.string,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    cover: _propTypes2.default.bool,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    image: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
    theme: _propTypes2.default.shape({
      avatar: _propTypes2.default.string,
      image: _propTypes2.default.string,
      letter: _propTypes2.default.string
    }),
    title: _propTypes2.default.string
  };

  Avatar.defaultProps = {
    alt: '',
    cover: false
  };

  return Avatar;
};

var Avatar$1 = factory(_FontIcon2.default);
Avatar$2.default = (0, _reactCssThemr$1.themr)(_identifiers$1.AVATAR)(Avatar$1);
Avatar$2.avatarFactory = factory;
Avatar$2.Avatar = Avatar$1;

var css_248z$j = ":root {\n  --palette-red-50: rgb(255, 235, 238);\n  --palette-red-100: rgb(255, 205, 210);\n  --palette-red-200: rgb(239, 154, 154);\n  --palette-red-300: rgb(229, 115, 115);\n  --palette-red-400: rgb(239, 83, 80);\n  --palette-red-500: rgb(244, 67, 54);\n  --palette-red-600: rgb(229, 57, 53);\n  --palette-red-700: rgb(211, 47, 47);\n  --palette-red-800: rgb(198, 40, 40);\n  --palette-red-900: rgb(183, 28, 28);\n  --palette-red-a100: rgb(255, 138, 128);\n  --palette-red-a200: rgb(255, 82, 82);\n  --palette-red-a400: rgb(255, 23, 68);\n  --palette-red-a700: rgb(213, 0, 0);\n\n  --palette-pink-50: rgb(252, 228, 236);\n  --palette-pink-100: rgb(248, 187, 208);\n  --palette-pink-200: rgb(244, 143, 177);\n  --palette-pink-300: rgb(240, 98, 146);\n  --palette-pink-400: rgb(236, 64, 122);\n  --palette-pink-500: rgb(233, 30, 99);\n  --palette-pink-600: rgb(216, 27, 96);\n  --palette-pink-700: rgb(194, 24, 91);\n  --palette-pink-800: rgb(173, 20, 87);\n  --palette-pink-900: rgb(136, 14, 79);\n  --palette-pink-a100: rgb(255, 128, 171);\n  --palette-pink-a200: rgb(255, 64, 129);\n  --palette-pink-a400: rgb(245, 0, 87);\n  --palette-pink-a700: rgb(197, 17, 98);\n\n  --palette-purple-50: rgb(243, 229, 245);\n  --palette-purple-100: rgb(225, 190, 231);\n  --palette-purple-200: rgb(206, 147, 216);\n  --palette-purple-300: rgb(186, 104, 200);\n  --palette-purple-400: rgb(171, 71, 188);\n  --palette-purple-500: rgb(156, 39, 176);\n  --palette-purple-600: rgb(142, 36, 170);\n  --palette-purple-700: rgb(123, 31, 162);\n  --palette-purple-800: rgb(106, 27, 154);\n  --palette-purple-900: rgb(74, 20, 140);\n  --palette-purple-a100: rgb(234, 128, 252);\n  --palette-purple-a200: rgb(224, 64, 251);\n  --palette-purple-a400: rgb(213, 0, 249);\n  --palette-purple-a700: rgb(170, 0, 255);\n\n  --palette-deep-purple-50: rgb(237, 231, 246);\n  --palette-deep-purple-100: rgb(209, 196, 233);\n  --palette-deep-purple-200: rgb(179, 157, 219);\n  --palette-deep-purple-300: rgb(149, 117, 205);\n  --palette-deep-purple-400: rgb(126, 87, 194);\n  --palette-deep-purple-500: rgb(103, 58, 183);\n  --palette-deep-purple-600: rgb(94, 53, 177);\n  --palette-deep-purple-700: rgb(81, 45, 168);\n  --palette-deep-purple-800: rgb(69, 39, 160);\n  --palette-deep-purple-900: rgb(49, 27, 146);\n  --palette-deep-purple-a100: rgb(179, 136, 255);\n  --palette-deep-purple-a200: rgb(124, 77, 255);\n  --palette-deep-purple-a400: rgb(101, 31, 255);\n  --palette-deep-purple-a700: rgb(98, 0, 234);\n\n  --palette-indigo-50: rgb(232, 234, 246);\n  --palette-indigo-100: rgb(197, 202, 233);\n  --palette-indigo-200: rgb(159, 168, 218);\n  --palette-indigo-300: rgb(121, 134, 203);\n  --palette-indigo-400: rgb(92, 107, 192);\n  --palette-indigo-500: rgb(63, 81, 181);\n  --palette-indigo-600: rgb(57, 73, 171);\n  --palette-indigo-700: rgb(48, 63, 159);\n  --palette-indigo-800: rgb(40, 53, 147);\n  --palette-indigo-900: rgb(26, 35, 126);\n  --palette-indigo-a100: rgb(140, 158, 255);\n  --palette-indigo-a200: rgb(83, 109, 254);\n  --palette-indigo-a400: rgb(61, 90, 254);\n  --palette-indigo-a700: rgb(48, 79, 254);\n\n  --palette-blue-50: rgb(227, 242, 253);\n  --palette-blue-100: rgb(187, 222, 251);\n  --palette-blue-200: rgb(144, 202, 249);\n  --palette-blue-300: rgb(100, 181, 246);\n  --palette-blue-400: rgb(66, 165, 245);\n  --palette-blue-500: rgb(33, 150, 243);\n  --palette-blue-600: rgb(30, 136, 229);\n  --palette-blue-700: rgb(25, 118, 210);\n  --palette-blue-800: rgb(21, 101, 192);\n  --palette-blue-900: rgb(13, 71, 161);\n  --palette-blue-a100: rgb(130, 177, 255);\n  --palette-blue-a200: rgb(68, 138, 255);\n  --palette-blue-a400: rgb(41, 121, 255);\n  --palette-blue-a700: rgb(41, 98, 255);\n\n  --palette-light-blue-50: rgb(225, 245, 254);\n  --palette-light-blue-100: rgb(179, 229, 252);\n  --palette-light-blue-200: rgb(129, 212, 250);\n  --palette-light-blue-300: rgb(79, 195, 247);\n  --palette-light-blue-400: rgb(41, 182, 246);\n  --palette-light-blue-500: rgb(3, 169, 244);\n  --palette-light-blue-600: rgb(3, 155, 229);\n  --palette-light-blue-700: rgb(2, 136, 209);\n  --palette-light-blue-800: rgb(2, 119, 189);\n  --palette-light-blue-900: rgb(1, 87, 155);\n  --palette-light-blue-a100: rgb(128, 216, 255);\n  --palette-light-blue-a200: rgb(64, 196, 255);\n  --palette-light-blue-a400: rgb(0, 176, 255);\n  --palette-light-blue-a700: rgb(0, 145, 234);\n\n  --palette-cyan-50: rgb(224, 247, 250);\n  --palette-cyan-100: rgb(178, 235, 242);\n  --palette-cyan-200: rgb(128, 222, 234);\n  --palette-cyan-300: rgb(77, 208, 225);\n  --palette-cyan-400: rgb(38, 198, 218);\n  --palette-cyan-500: rgb(0, 188, 212);\n  --palette-cyan-600: rgb(0, 172, 193);\n  --palette-cyan-700: rgb(0, 151, 167);\n  --palette-cyan-800: rgb(0, 131, 143);\n  --palette-cyan-900: rgb(0, 96, 100);\n  --palette-cyan-a100: rgb(132, 255, 255);\n  --palette-cyan-a200: rgb(24, 255, 255);\n  --palette-cyan-a400: rgb(0, 229, 255);\n  --palette-cyan-a700: rgb(0, 184, 212);\n\n  --palette-teal-50: rgb(224, 242, 241);\n  --palette-teal-100: rgb(178, 223, 219);\n  --palette-teal-200: rgb(128, 203, 196);\n  --palette-teal-300: rgb(77, 182, 172);\n  --palette-teal-400: rgb(38, 166, 154);\n  --palette-teal-500: rgb(0, 150, 136);\n  --palette-teal-600: rgb(0, 137, 123);\n  --palette-teal-700: rgb(0, 121, 107);\n  --palette-teal-800: rgb(0, 105, 92);\n  --palette-teal-900: rgb(0, 77, 64);\n  --palette-teal-a100: rgb(167, 255, 235);\n  --palette-teal-a200: rgb(100, 255, 218);\n  --palette-teal-a400: rgb(29, 233, 182);\n  --palette-teal-a700: rgb(0, 191, 165);\n\n  --palette-green-50: rgb(232, 245, 233);\n  --palette-green-100: rgb(200, 230, 201);\n  --palette-green-200: rgb(165, 214, 167);\n  --palette-green-300: rgb(129, 199, 132);\n  --palette-green-400: rgb(102, 187, 106);\n  --palette-green-500: rgb(76, 175, 80);\n  --palette-green-600: rgb(67, 160, 71);\n  --palette-green-700: rgb(56, 142, 60);\n  --palette-green-800: rgb(46, 125, 50);\n  --palette-green-900: rgb(27, 94, 32);\n  --palette-green-a100: rgb(185, 246, 202);\n  --palette-green-a200: rgb(105, 240, 174);\n  --palette-green-a400: rgb(0, 230, 118);\n  --palette-green-a700: rgb(0, 200, 83);\n\n  --palette-light-green-50: rgb(241, 248, 233);\n  --palette-light-green-100: rgb(220, 237, 200);\n  --palette-light-green-200: rgb(197, 225, 165);\n  --palette-light-green-300: rgb(174, 213, 129);\n  --palette-light-green-400: rgb(156, 204, 101);\n  --palette-light-green-500: rgb(139, 195, 74);\n  --palette-light-green-600: rgb(124, 179, 66);\n  --palette-light-green-700: rgb(104, 159, 56);\n  --palette-light-green-800: rgb(85, 139, 47);\n  --palette-light-green-900: rgb(51, 105, 30);\n  --palette-light-green-a100: rgb(204, 255, 144);\n  --palette-light-green-a200: rgb(178, 255, 89);\n  --palette-light-green-a400: rgb(118, 255, 3);\n  --palette-light-green-a700: rgb(100, 221, 23);\n\n  --palette-lime-50: rgb(249, 251, 231);\n  --palette-lime-100: rgb(240, 244, 195);\n  --palette-lime-200: rgb(230, 238, 156);\n  --palette-lime-300: rgb(220, 231, 117);\n  --palette-lime-400: rgb(212, 225, 87);\n  --palette-lime-500: rgb(205, 220, 57);\n  --palette-lime-600: rgb(192, 202, 51);\n  --palette-lime-700: rgb(175, 180, 43);\n  --palette-lime-800: rgb(158, 157, 36);\n  --palette-lime-900: rgb(130, 119, 23);\n  --palette-lime-a100: rgb(244, 255, 129);\n  --palette-lime-a200: rgb(238, 255, 65);\n  --palette-lime-a400: rgb(198, 255, 0);\n  --palette-lime-a700: rgb(174, 234, 0);\n\n  --palette-yellow-50: rgb(255, 253, 231);\n  --palette-yellow-100: rgb(255, 249, 196);\n  --palette-yellow-200: rgb(255, 245, 157);\n  --palette-yellow-300: rgb(255, 241, 118);\n  --palette-yellow-400: rgb(255, 238, 88);\n  --palette-yellow-500: rgb(255, 235, 59);\n  --palette-yellow-600: rgb(253, 216, 53);\n  --palette-yellow-700: rgb(251, 192, 45);\n  --palette-yellow-800: rgb(249, 168, 37);\n  --palette-yellow-900: rgb(245, 127, 23);\n  --palette-yellow-a100: rgb(255, 255, 141);\n  --palette-yellow-a200: rgb(255, 255, 0);\n  --palette-yellow-a400: rgb(255, 234, 0);\n  --palette-yellow-a700: rgb(255, 214, 0);\n\n  --palette-amber-50: rgb(255, 248, 225);\n  --palette-amber-100: rgb(255, 236, 179);\n  --palette-amber-200: rgb(255, 224, 130);\n  --palette-amber-300: rgb(255, 213, 79);\n  --palette-amber-400: rgb(255, 202, 40);\n  --palette-amber-500: rgb(255, 193, 7);\n  --palette-amber-600: rgb(255, 179, 0);\n  --palette-amber-700: rgb(255, 160, 0);\n  --palette-amber-800: rgb(255, 143, 0);\n  --palette-amber-900: rgb(255, 111, 0);\n  --palette-amber-a100: rgb(255, 229, 127);\n  --palette-amber-a200: rgb(255, 215, 64);\n  --palette-amber-a400: rgb(255, 196, 0);\n  --palette-amber-a700: rgb(255, 171, 0);\n\n  --palette-orange-50: rgb(255, 243, 224);\n  --palette-orange-100: rgb(255, 224, 178);\n  --palette-orange-200: rgb(255, 204, 128);\n  --palette-orange-300: rgb(255, 183, 77);\n  --palette-orange-400: rgb(255, 167, 38);\n  --palette-orange-500: rgb(255, 152, 0);\n  --palette-orange-600: rgb(251, 140, 0);\n  --palette-orange-700: rgb(245, 124, 0);\n  --palette-orange-800: rgb(239, 108, 0);\n  --palette-orange-900: rgb(230, 81, 0);\n  --palette-orange-a100: rgb(255, 209, 128);\n  --palette-orange-a200: rgb(255, 171, 64);\n  --palette-orange-a400: rgb(255, 145, 0);\n  --palette-orange-a700: rgb(255, 109, 0);\n\n  --palette-deep-orange-50: rgb(251, 233, 231);\n  --palette-deep-orange-100: rgb(255, 204, 188);\n  --palette-deep-orange-200: rgb(255, 171, 145);\n  --palette-deep-orange-300: rgb(255, 138, 101);\n  --palette-deep-orange-400: rgb(255, 112, 67);\n  --palette-deep-orange-500: rgb(255, 87, 34);\n  --palette-deep-orange-600: rgb(244, 81, 30);\n  --palette-deep-orange-700: rgb(230, 74, 25);\n  --palette-deep-orange-800: rgb(216, 67, 21);\n  --palette-deep-orange-900: rgb(191, 54, 12);\n  --palette-deep-orange-a100: rgb(255, 158, 128);\n  --palette-deep-orange-a200: rgb(255, 110, 64);\n  --palette-deep-orange-a400: rgb(255, 61, 0);\n  --palette-deep-orange-a700: rgb(221, 44, 0);\n\n  --palette-brown-50: rgb(239, 235, 233);\n  --palette-brown-100: rgb(215, 204, 200);\n  --palette-brown-200: rgb(188, 170, 164);\n  --palette-brown-300: rgb(161, 136, 127);\n  --palette-brown-400: rgb(141, 110, 99);\n  --palette-brown-500: rgb(121, 85, 72);\n  --palette-brown-600: rgb(109, 76, 65);\n  --palette-brown-700: rgb(93, 64, 55);\n  --palette-brown-800: rgb(78, 52, 46);\n  --palette-brown-900: rgb(62, 39, 35);\n\n  --palette-grey-50: rgb(250, 250, 250);\n  --palette-grey-100: rgb(245, 245, 245);\n  --palette-grey-200: rgb(238, 238, 238);\n  --palette-grey-300: rgb(224, 224, 224);\n  --palette-grey-400: rgb(189, 189, 189);\n  --palette-grey-500: rgb(158, 158, 158);\n  --palette-grey-600: rgb(117, 117, 117);\n  --palette-grey-700: rgb(97, 97, 97);\n  --palette-grey-800: rgb(66, 66, 66);\n  --palette-grey-900: rgb(33, 33, 33);\n\n  --palette-blue-grey-50: rgb(236, 239, 241);\n  --palette-blue-grey-100: rgb(207, 216, 220);\n  --palette-blue-grey-200: rgb(176, 190, 197);\n  --palette-blue-grey-300: rgb(144, 164, 174);\n  --palette-blue-grey-400: rgb(120, 144, 156);\n  --palette-blue-grey-500: rgb(96, 125, 139);\n  --palette-blue-grey-600: rgb(84, 110, 122);\n  --palette-blue-grey-700: rgb(69, 90, 100);\n  --palette-blue-grey-800: rgb(55, 71, 79);\n  --palette-blue-grey-900: rgb(38, 50, 56);\n\n  --color-black: rgb(0, 0, 0);\n  --color-white: rgb(255, 255, 255);\n  --color-dark-contrast: var(--color-white);\n  --color-light-contrast: var(--color-black);\n}\n:root {\n  --color-divider: var(--palette-grey-200);\n  --color-background: var(--color-white);\n  --color-text: var(--palette-grey-900);\n  --color-text-secondary: var(--palette-grey-600);\n\n  --color-primary: var(--palette-indigo-500);\n  --color-primary-dark: var(--palette-indigo-700);\n  --color-accent: var(--palette-pink-a200);\n  --color-accent-dark: var(--palette-pink-700);\n  --color-primary-contrast: var(--color-dark-contrast);\n  --color-accent-contrast: var(--color-dark-contrast);\n\n  --unit: 10px;\n\n  --preferred-font: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  --font-size: calc(1.6 * var(--unit));\n  --font-size-tiny: calc(1.2 * var(--unit));\n  --font-size-small: calc(1.4 * var(--unit));\n  --font-size-normal: var(--font-size);\n  --font-size-big: calc(1.8 * var(--unit));\n  --font-weight-thin: 300;\n  --font-weight-normal: 400;\n  --font-weight-semi-bold: 500;\n  --font-weight-bold: 700;\n\n  --shadow-2p:\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-3p:\n    0 3px 4px 0 rgba(0, 0, 0, 0.14),\n    0 3px 3px -2px rgba(0, 0, 0, 0.2),\n    0 1px 8px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-4p:\n    0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12),\n    0 2px 4px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-6p:\n    0 6px 10px 0 rgba(0, 0, 0, 0.14),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-8p:\n    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12),\n    0 5px 5px -3px rgba(0, 0, 0, 0.2);\n\n  --shadow-16p:\n    0 16px 24px 2px rgba(0, 0, 0, 0.14),\n    0 6px 30px 5px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba(0, 0, 0, 0.2);\n\n  --shadow-key-umbra-opacity: 0.2;\n  --shadow-key-penumbra-opacity: 0.14;\n  --shadow-ambient-shadow-opacity: 0.12;\n\n  --zdepth-shadow-1: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);\n  --zdepth-shadow-2: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-3: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-4: 0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22);\n  --zdepth-shadow-5: 0 19px 60px rgba(0, 0, 0, 0.3), 0 15px 20px rgba(0, 0, 0, 0.22);\n\n  --animation-duration: 0.35s;\n  --animation-delay: calc(var(--animation-duration) / 5);\n  --animation-curve-fast-out-slow-in: cubic-bezier(0.4, 0, 0.2, 1);\n  --animation-curve-linear-out-slow-in: cubic-bezier(0, 0, 0.2, 1);\n  --animation-curve-fast-out-linear-in: cubic-bezier(0.4, 0, 1, 1);\n  --animation-curve-default: var(--animation-curve-fast-out-slow-in);\n\n  --z-index-highest: 300;\n  --z-index-higher: 200;\n  --z-index-high: 100;\n  --z-index-normal: 1;\n  --z-index-low: -100;\n  --z-index-lower: -200\n}\n:root {\n  --avatar-color: var(--color-white);\n  --avatar-background: var(--palette-grey-500);\n  --avatar-size: calc(4 * var(--unit));\n  --avatar-font-size: calc(2.4 * var(--unit));\n}\n.theme_avatar__u-HKl {\n  background-color: var(--avatar-background);\n  border-radius: 50%;\n  color: var(--avatar-color);\n  display: inline-block;\n  font-size: var(--avatar-font-size);\n  height: var(--avatar-size);\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: var(--avatar-size);\n    box-sizing: border-box;\n    font-family: var(--preferred-font);\n    -webkit-font-smoothing: antialiased;\n    font-smoothing: antialiased;\n    text-size-adjust: 100%\n}\n.theme_avatar__u-HKl *,\n    .theme_avatar__u-HKl *::after,\n    .theme_avatar__u-HKl *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme_avatar__u-HKl > svg {\n  fill: currentColor;\n  height: var(--avatar-size);\n  width: 1em;\n}\n.theme_avatar__u-HKl > img {\n  height: auto;\n  max-width: 100%;\n}\n.theme_image__j1zpo {\n  background-color: transparent;\n  background-position: center;\n  background-size: cover;\n  border-radius: 50%;\n  display: block;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.theme_letter__1n0R- {\n  display: block;\n  line-height: var(--avatar-size);\n  width: 100%;\n}\n";
var theme = {"avatar":"theme_avatar__u-HKl","image":"theme_image__j1zpo","letter":"theme_letter__1n0R-"};
var stylesheet=":root {\n  --palette-red-50: rgb(255, 235, 238);\n  --palette-red-100: rgb(255, 205, 210);\n  --palette-red-200: rgb(239, 154, 154);\n  --palette-red-300: rgb(229, 115, 115);\n  --palette-red-400: rgb(239, 83, 80);\n  --palette-red-500: rgb(244, 67, 54);\n  --palette-red-600: rgb(229, 57, 53);\n  --palette-red-700: rgb(211, 47, 47);\n  --palette-red-800: rgb(198, 40, 40);\n  --palette-red-900: rgb(183, 28, 28);\n  --palette-red-a100: rgb(255, 138, 128);\n  --palette-red-a200: rgb(255, 82, 82);\n  --palette-red-a400: rgb(255, 23, 68);\n  --palette-red-a700: rgb(213, 0, 0);\n\n  --palette-pink-50: rgb(252, 228, 236);\n  --palette-pink-100: rgb(248, 187, 208);\n  --palette-pink-200: rgb(244, 143, 177);\n  --palette-pink-300: rgb(240, 98, 146);\n  --palette-pink-400: rgb(236, 64, 122);\n  --palette-pink-500: rgb(233, 30, 99);\n  --palette-pink-600: rgb(216, 27, 96);\n  --palette-pink-700: rgb(194, 24, 91);\n  --palette-pink-800: rgb(173, 20, 87);\n  --palette-pink-900: rgb(136, 14, 79);\n  --palette-pink-a100: rgb(255, 128, 171);\n  --palette-pink-a200: rgb(255, 64, 129);\n  --palette-pink-a400: rgb(245, 0, 87);\n  --palette-pink-a700: rgb(197, 17, 98);\n\n  --palette-purple-50: rgb(243, 229, 245);\n  --palette-purple-100: rgb(225, 190, 231);\n  --palette-purple-200: rgb(206, 147, 216);\n  --palette-purple-300: rgb(186, 104, 200);\n  --palette-purple-400: rgb(171, 71, 188);\n  --palette-purple-500: rgb(156, 39, 176);\n  --palette-purple-600: rgb(142, 36, 170);\n  --palette-purple-700: rgb(123, 31, 162);\n  --palette-purple-800: rgb(106, 27, 154);\n  --palette-purple-900: rgb(74, 20, 140);\n  --palette-purple-a100: rgb(234, 128, 252);\n  --palette-purple-a200: rgb(224, 64, 251);\n  --palette-purple-a400: rgb(213, 0, 249);\n  --palette-purple-a700: rgb(170, 0, 255);\n\n  --palette-deep-purple-50: rgb(237, 231, 246);\n  --palette-deep-purple-100: rgb(209, 196, 233);\n  --palette-deep-purple-200: rgb(179, 157, 219);\n  --palette-deep-purple-300: rgb(149, 117, 205);\n  --palette-deep-purple-400: rgb(126, 87, 194);\n  --palette-deep-purple-500: rgb(103, 58, 183);\n  --palette-deep-purple-600: rgb(94, 53, 177);\n  --palette-deep-purple-700: rgb(81, 45, 168);\n  --palette-deep-purple-800: rgb(69, 39, 160);\n  --palette-deep-purple-900: rgb(49, 27, 146);\n  --palette-deep-purple-a100: rgb(179, 136, 255);\n  --palette-deep-purple-a200: rgb(124, 77, 255);\n  --palette-deep-purple-a400: rgb(101, 31, 255);\n  --palette-deep-purple-a700: rgb(98, 0, 234);\n\n  --palette-indigo-50: rgb(232, 234, 246);\n  --palette-indigo-100: rgb(197, 202, 233);\n  --palette-indigo-200: rgb(159, 168, 218);\n  --palette-indigo-300: rgb(121, 134, 203);\n  --palette-indigo-400: rgb(92, 107, 192);\n  --palette-indigo-500: rgb(63, 81, 181);\n  --palette-indigo-600: rgb(57, 73, 171);\n  --palette-indigo-700: rgb(48, 63, 159);\n  --palette-indigo-800: rgb(40, 53, 147);\n  --palette-indigo-900: rgb(26, 35, 126);\n  --palette-indigo-a100: rgb(140, 158, 255);\n  --palette-indigo-a200: rgb(83, 109, 254);\n  --palette-indigo-a400: rgb(61, 90, 254);\n  --palette-indigo-a700: rgb(48, 79, 254);\n\n  --palette-blue-50: rgb(227, 242, 253);\n  --palette-blue-100: rgb(187, 222, 251);\n  --palette-blue-200: rgb(144, 202, 249);\n  --palette-blue-300: rgb(100, 181, 246);\n  --palette-blue-400: rgb(66, 165, 245);\n  --palette-blue-500: rgb(33, 150, 243);\n  --palette-blue-600: rgb(30, 136, 229);\n  --palette-blue-700: rgb(25, 118, 210);\n  --palette-blue-800: rgb(21, 101, 192);\n  --palette-blue-900: rgb(13, 71, 161);\n  --palette-blue-a100: rgb(130, 177, 255);\n  --palette-blue-a200: rgb(68, 138, 255);\n  --palette-blue-a400: rgb(41, 121, 255);\n  --palette-blue-a700: rgb(41, 98, 255);\n\n  --palette-light-blue-50: rgb(225, 245, 254);\n  --palette-light-blue-100: rgb(179, 229, 252);\n  --palette-light-blue-200: rgb(129, 212, 250);\n  --palette-light-blue-300: rgb(79, 195, 247);\n  --palette-light-blue-400: rgb(41, 182, 246);\n  --palette-light-blue-500: rgb(3, 169, 244);\n  --palette-light-blue-600: rgb(3, 155, 229);\n  --palette-light-blue-700: rgb(2, 136, 209);\n  --palette-light-blue-800: rgb(2, 119, 189);\n  --palette-light-blue-900: rgb(1, 87, 155);\n  --palette-light-blue-a100: rgb(128, 216, 255);\n  --palette-light-blue-a200: rgb(64, 196, 255);\n  --palette-light-blue-a400: rgb(0, 176, 255);\n  --palette-light-blue-a700: rgb(0, 145, 234);\n\n  --palette-cyan-50: rgb(224, 247, 250);\n  --palette-cyan-100: rgb(178, 235, 242);\n  --palette-cyan-200: rgb(128, 222, 234);\n  --palette-cyan-300: rgb(77, 208, 225);\n  --palette-cyan-400: rgb(38, 198, 218);\n  --palette-cyan-500: rgb(0, 188, 212);\n  --palette-cyan-600: rgb(0, 172, 193);\n  --palette-cyan-700: rgb(0, 151, 167);\n  --palette-cyan-800: rgb(0, 131, 143);\n  --palette-cyan-900: rgb(0, 96, 100);\n  --palette-cyan-a100: rgb(132, 255, 255);\n  --palette-cyan-a200: rgb(24, 255, 255);\n  --palette-cyan-a400: rgb(0, 229, 255);\n  --palette-cyan-a700: rgb(0, 184, 212);\n\n  --palette-teal-50: rgb(224, 242, 241);\n  --palette-teal-100: rgb(178, 223, 219);\n  --palette-teal-200: rgb(128, 203, 196);\n  --palette-teal-300: rgb(77, 182, 172);\n  --palette-teal-400: rgb(38, 166, 154);\n  --palette-teal-500: rgb(0, 150, 136);\n  --palette-teal-600: rgb(0, 137, 123);\n  --palette-teal-700: rgb(0, 121, 107);\n  --palette-teal-800: rgb(0, 105, 92);\n  --palette-teal-900: rgb(0, 77, 64);\n  --palette-teal-a100: rgb(167, 255, 235);\n  --palette-teal-a200: rgb(100, 255, 218);\n  --palette-teal-a400: rgb(29, 233, 182);\n  --palette-teal-a700: rgb(0, 191, 165);\n\n  --palette-green-50: rgb(232, 245, 233);\n  --palette-green-100: rgb(200, 230, 201);\n  --palette-green-200: rgb(165, 214, 167);\n  --palette-green-300: rgb(129, 199, 132);\n  --palette-green-400: rgb(102, 187, 106);\n  --palette-green-500: rgb(76, 175, 80);\n  --palette-green-600: rgb(67, 160, 71);\n  --palette-green-700: rgb(56, 142, 60);\n  --palette-green-800: rgb(46, 125, 50);\n  --palette-green-900: rgb(27, 94, 32);\n  --palette-green-a100: rgb(185, 246, 202);\n  --palette-green-a200: rgb(105, 240, 174);\n  --palette-green-a400: rgb(0, 230, 118);\n  --palette-green-a700: rgb(0, 200, 83);\n\n  --palette-light-green-50: rgb(241, 248, 233);\n  --palette-light-green-100: rgb(220, 237, 200);\n  --palette-light-green-200: rgb(197, 225, 165);\n  --palette-light-green-300: rgb(174, 213, 129);\n  --palette-light-green-400: rgb(156, 204, 101);\n  --palette-light-green-500: rgb(139, 195, 74);\n  --palette-light-green-600: rgb(124, 179, 66);\n  --palette-light-green-700: rgb(104, 159, 56);\n  --palette-light-green-800: rgb(85, 139, 47);\n  --palette-light-green-900: rgb(51, 105, 30);\n  --palette-light-green-a100: rgb(204, 255, 144);\n  --palette-light-green-a200: rgb(178, 255, 89);\n  --palette-light-green-a400: rgb(118, 255, 3);\n  --palette-light-green-a700: rgb(100, 221, 23);\n\n  --palette-lime-50: rgb(249, 251, 231);\n  --palette-lime-100: rgb(240, 244, 195);\n  --palette-lime-200: rgb(230, 238, 156);\n  --palette-lime-300: rgb(220, 231, 117);\n  --palette-lime-400: rgb(212, 225, 87);\n  --palette-lime-500: rgb(205, 220, 57);\n  --palette-lime-600: rgb(192, 202, 51);\n  --palette-lime-700: rgb(175, 180, 43);\n  --palette-lime-800: rgb(158, 157, 36);\n  --palette-lime-900: rgb(130, 119, 23);\n  --palette-lime-a100: rgb(244, 255, 129);\n  --palette-lime-a200: rgb(238, 255, 65);\n  --palette-lime-a400: rgb(198, 255, 0);\n  --palette-lime-a700: rgb(174, 234, 0);\n\n  --palette-yellow-50: rgb(255, 253, 231);\n  --palette-yellow-100: rgb(255, 249, 196);\n  --palette-yellow-200: rgb(255, 245, 157);\n  --palette-yellow-300: rgb(255, 241, 118);\n  --palette-yellow-400: rgb(255, 238, 88);\n  --palette-yellow-500: rgb(255, 235, 59);\n  --palette-yellow-600: rgb(253, 216, 53);\n  --palette-yellow-700: rgb(251, 192, 45);\n  --palette-yellow-800: rgb(249, 168, 37);\n  --palette-yellow-900: rgb(245, 127, 23);\n  --palette-yellow-a100: rgb(255, 255, 141);\n  --palette-yellow-a200: rgb(255, 255, 0);\n  --palette-yellow-a400: rgb(255, 234, 0);\n  --palette-yellow-a700: rgb(255, 214, 0);\n\n  --palette-amber-50: rgb(255, 248, 225);\n  --palette-amber-100: rgb(255, 236, 179);\n  --palette-amber-200: rgb(255, 224, 130);\n  --palette-amber-300: rgb(255, 213, 79);\n  --palette-amber-400: rgb(255, 202, 40);\n  --palette-amber-500: rgb(255, 193, 7);\n  --palette-amber-600: rgb(255, 179, 0);\n  --palette-amber-700: rgb(255, 160, 0);\n  --palette-amber-800: rgb(255, 143, 0);\n  --palette-amber-900: rgb(255, 111, 0);\n  --palette-amber-a100: rgb(255, 229, 127);\n  --palette-amber-a200: rgb(255, 215, 64);\n  --palette-amber-a400: rgb(255, 196, 0);\n  --palette-amber-a700: rgb(255, 171, 0);\n\n  --palette-orange-50: rgb(255, 243, 224);\n  --palette-orange-100: rgb(255, 224, 178);\n  --palette-orange-200: rgb(255, 204, 128);\n  --palette-orange-300: rgb(255, 183, 77);\n  --palette-orange-400: rgb(255, 167, 38);\n  --palette-orange-500: rgb(255, 152, 0);\n  --palette-orange-600: rgb(251, 140, 0);\n  --palette-orange-700: rgb(245, 124, 0);\n  --palette-orange-800: rgb(239, 108, 0);\n  --palette-orange-900: rgb(230, 81, 0);\n  --palette-orange-a100: rgb(255, 209, 128);\n  --palette-orange-a200: rgb(255, 171, 64);\n  --palette-orange-a400: rgb(255, 145, 0);\n  --palette-orange-a700: rgb(255, 109, 0);\n\n  --palette-deep-orange-50: rgb(251, 233, 231);\n  --palette-deep-orange-100: rgb(255, 204, 188);\n  --palette-deep-orange-200: rgb(255, 171, 145);\n  --palette-deep-orange-300: rgb(255, 138, 101);\n  --palette-deep-orange-400: rgb(255, 112, 67);\n  --palette-deep-orange-500: rgb(255, 87, 34);\n  --palette-deep-orange-600: rgb(244, 81, 30);\n  --palette-deep-orange-700: rgb(230, 74, 25);\n  --palette-deep-orange-800: rgb(216, 67, 21);\n  --palette-deep-orange-900: rgb(191, 54, 12);\n  --palette-deep-orange-a100: rgb(255, 158, 128);\n  --palette-deep-orange-a200: rgb(255, 110, 64);\n  --palette-deep-orange-a400: rgb(255, 61, 0);\n  --palette-deep-orange-a700: rgb(221, 44, 0);\n\n  --palette-brown-50: rgb(239, 235, 233);\n  --palette-brown-100: rgb(215, 204, 200);\n  --palette-brown-200: rgb(188, 170, 164);\n  --palette-brown-300: rgb(161, 136, 127);\n  --palette-brown-400: rgb(141, 110, 99);\n  --palette-brown-500: rgb(121, 85, 72);\n  --palette-brown-600: rgb(109, 76, 65);\n  --palette-brown-700: rgb(93, 64, 55);\n  --palette-brown-800: rgb(78, 52, 46);\n  --palette-brown-900: rgb(62, 39, 35);\n\n  --palette-grey-50: rgb(250, 250, 250);\n  --palette-grey-100: rgb(245, 245, 245);\n  --palette-grey-200: rgb(238, 238, 238);\n  --palette-grey-300: rgb(224, 224, 224);\n  --palette-grey-400: rgb(189, 189, 189);\n  --palette-grey-500: rgb(158, 158, 158);\n  --palette-grey-600: rgb(117, 117, 117);\n  --palette-grey-700: rgb(97, 97, 97);\n  --palette-grey-800: rgb(66, 66, 66);\n  --palette-grey-900: rgb(33, 33, 33);\n\n  --palette-blue-grey-50: rgb(236, 239, 241);\n  --palette-blue-grey-100: rgb(207, 216, 220);\n  --palette-blue-grey-200: rgb(176, 190, 197);\n  --palette-blue-grey-300: rgb(144, 164, 174);\n  --palette-blue-grey-400: rgb(120, 144, 156);\n  --palette-blue-grey-500: rgb(96, 125, 139);\n  --palette-blue-grey-600: rgb(84, 110, 122);\n  --palette-blue-grey-700: rgb(69, 90, 100);\n  --palette-blue-grey-800: rgb(55, 71, 79);\n  --palette-blue-grey-900: rgb(38, 50, 56);\n\n  --color-black: rgb(0, 0, 0);\n  --color-white: rgb(255, 255, 255);\n  --color-dark-contrast: var(--color-white);\n  --color-light-contrast: var(--color-black);\n}\n:root {\n  --color-divider: var(--palette-grey-200);\n  --color-background: var(--color-white);\n  --color-text: var(--palette-grey-900);\n  --color-text-secondary: var(--palette-grey-600);\n\n  --color-primary: var(--palette-indigo-500);\n  --color-primary-dark: var(--palette-indigo-700);\n  --color-accent: var(--palette-pink-a200);\n  --color-accent-dark: var(--palette-pink-700);\n  --color-primary-contrast: var(--color-dark-contrast);\n  --color-accent-contrast: var(--color-dark-contrast);\n\n  --unit: 10px;\n\n  --preferred-font: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  --font-size: calc(1.6 * var(--unit));\n  --font-size-tiny: calc(1.2 * var(--unit));\n  --font-size-small: calc(1.4 * var(--unit));\n  --font-size-normal: var(--font-size);\n  --font-size-big: calc(1.8 * var(--unit));\n  --font-weight-thin: 300;\n  --font-weight-normal: 400;\n  --font-weight-semi-bold: 500;\n  --font-weight-bold: 700;\n\n  --shadow-2p:\n    0 2px 2px 0 rgba(0, 0, 0, 0.14),\n    0 3px 1px -2px rgba(0, 0, 0, 0.2),\n    0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-3p:\n    0 3px 4px 0 rgba(0, 0, 0, 0.14),\n    0 3px 3px -2px rgba(0, 0, 0, 0.2),\n    0 1px 8px 0 rgba(0, 0, 0, 0.12);\n\n  --shadow-4p:\n    0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12),\n    0 2px 4px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-6p:\n    0 6px 10px 0 rgba(0, 0, 0, 0.14),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.2);\n\n  --shadow-8p:\n    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n    0 3px 14px 2px rgba(0, 0, 0, 0.12),\n    0 5px 5px -3px rgba(0, 0, 0, 0.2);\n\n  --shadow-16p:\n    0 16px 24px 2px rgba(0, 0, 0, 0.14),\n    0 6px 30px 5px rgba(0, 0, 0, 0.12),\n    0 8px 10px -5px rgba(0, 0, 0, 0.2);\n\n  --shadow-key-umbra-opacity: 0.2;\n  --shadow-key-penumbra-opacity: 0.14;\n  --shadow-ambient-shadow-opacity: 0.12;\n\n  --zdepth-shadow-1: 0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);\n  --zdepth-shadow-2: 0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-3: 0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23);\n  --zdepth-shadow-4: 0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22);\n  --zdepth-shadow-5: 0 19px 60px rgba(0, 0, 0, 0.3), 0 15px 20px rgba(0, 0, 0, 0.22);\n\n  --animation-duration: 0.35s;\n  --animation-delay: calc(var(--animation-duration) / 5);\n  --animation-curve-fast-out-slow-in: cubic-bezier(0.4, 0, 0.2, 1);\n  --animation-curve-linear-out-slow-in: cubic-bezier(0, 0, 0.2, 1);\n  --animation-curve-fast-out-linear-in: cubic-bezier(0.4, 0, 1, 1);\n  --animation-curve-default: var(--animation-curve-fast-out-slow-in);\n\n  --z-index-highest: 300;\n  --z-index-higher: 200;\n  --z-index-high: 100;\n  --z-index-normal: 1;\n  --z-index-low: -100;\n  --z-index-lower: -200\n}\n:root {\n  --avatar-color: var(--color-white);\n  --avatar-background: var(--palette-grey-500);\n  --avatar-size: calc(4 * var(--unit));\n  --avatar-font-size: calc(2.4 * var(--unit));\n}\n.theme_avatar__u-HKl {\n  background-color: var(--avatar-background);\n  border-radius: 50%;\n  color: var(--avatar-color);\n  display: inline-block;\n  font-size: var(--avatar-font-size);\n  height: var(--avatar-size);\n  overflow: hidden;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: var(--avatar-size);\n    box-sizing: border-box;\n    font-family: var(--preferred-font);\n    -webkit-font-smoothing: antialiased;\n    font-smoothing: antialiased;\n    text-size-adjust: 100%\n}\n.theme_avatar__u-HKl *,\n    .theme_avatar__u-HKl *::after,\n    .theme_avatar__u-HKl *::before {\n  box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  font-smoothing: antialiased;\n  text-size-adjust: 100%;\n  -webkit-touch-callout: none;\n}\n.theme_avatar__u-HKl > svg {\n  fill: currentColor;\n  height: var(--avatar-size);\n  width: 1em;\n}\n.theme_avatar__u-HKl > img {\n  height: auto;\n  max-width: 100%;\n}\n.theme_image__j1zpo {\n  background-color: transparent;\n  background-position: center;\n  background-size: cover;\n  border-radius: 50%;\n  display: block;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.theme_letter__1n0R- {\n  display: block;\n  line-height: var(--avatar-size);\n  width: 100%;\n}\n";
styleInject(css_248z$j);

var theme$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': theme,
  stylesheet: stylesheet
});

var require$$4 = /*@__PURE__*/getAugmentedNamespace(theme$1);

Object.defineProperty(avatar, "__esModule", {
  value: true
});
var Avatar_1 = avatar.Avatar = undefined;

var _reactCssThemr = lib$7;

var _identifiers = identifiers;

var _Avatar = Avatar$2;

var _FontIcon = FontIcon$2;

var _theme = require$$4;

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Avatar = (0, _Avatar.avatarFactory)(_FontIcon.FontIcon);
var ThemedAvatar = (0, _reactCssThemr.themr)(_identifiers.AVATAR, _theme2.default)(Avatar);

avatar.default = ThemedAvatar;
Avatar_1 = avatar.Avatar = ThemedAvatar;

var css_248z$i = ".Suggestion_suggestion__Q-CTg {\n  transition: 0.25s linear;\n  display: flex;\n  cursor: pointer;\n  opacity: 0.5;\n  padding: 0.6em 0;\n  align-items: center;\n}\n.Suggestion_suggestion__Q-CTg [class*=avatar] {\n  flex: 0 0 auto;\n}\n.Suggestion_suggestion__Q-CTg:hover {\n  opacity: 1;\n}\n\n.Suggestion_suggestionHighlighted__OaOD8 {\n  opacity: 1;\n}\n\n.Suggestion_name__UUaPm {\n  flex: 1 1 auto;\n  padding-left: 1.5em;\n}";
var style$f = {"suggestion":"Suggestion_suggestion__Q-CTg","suggestionHighlighted":"Suggestion_suggestionHighlighted__OaOD8","name":"Suggestion_name__UUaPm"};
styleInject(css_248z$i);

const Suggestion = (props) => {
    const { item } = props;
    const name = item === null || item === void 0 ? void 0 : item.name;
    return (React__default$4.createElement("div", { className: style$f.suggestion },
        item && React__default$4.createElement(React__default$4.Fragment, null,
            item.smallIcon && !item.logoUrl && React__default$4.createElement(Avatar_1, { image: item.smallIcon }),
            item.logoUrl && !item.smallIcon && React__default$4.createElement(Avatar_1, { image: item.logoUrl }),
            !item.smallIcon && !item.logoUrl && React__default$4.createElement(Avatar_1, { title: item.name })),
        !item && React__default$4.createElement(Avatar_1, { image: "/img/xapp-logo-teal.svg" }),
        React__default$4.createElement("span", { className: style$f.name }, name)));
};

var css_248z$h = ".Switcher_wrap__-SDie {\n  padding: 0 0.5em 0 2em;\n}\n\n.Switcher_overlay__pMlS2 {\n  background-color: rgba(255, 255, 255, 0.9);\n  display: flex;\n  flex-direction: column;\n  padding: 0 1em;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 82px;\n  z-index: 3000;\n}\n\n.Switcher_header__KKZHI {\n  width: 100%;\n  max-width: 1280px;\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n  flex: 0 0 auto;\n}\n\n.Switcher_body__K-yIC {\n  width: 100%;\n  max-width: 1280px;\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n  flex: 1 1 auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.Switcher_close__yo1oV {\n  position: fixed;\n  top: calc(64px + 1em);\n  right: 1em;\n}\n\n.Switcher_container__cDeE5 {\n  width: 100%;\n}\n.Switcher_container__cDeE5[aria-expanded=false] > [class*=suggestionsContainer] {\n  display: none;\n}\n\n.Switcher_orgName__NutVs {\n  flex: 1 1 auto;\n  color: #ffffff;\n  font-size: 1.25em;\n  font-weight: bold;\n  margin: 0;\n  position: relative;\n  display: flex;\n  align-items: baseline;\n  line-height: 36px;\n}\n\n.Switcher_orgNameHeader__6ETUf {\n  cursor: pointer;\n  color: #ffffff;\n  display: inline-block;\n  max-width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.Switcher_orgNameHeaderNotSelected__amDjW {\n  color: #899499;\n}\n\n.Switcher_input__A0SWC {\n  background-color: transparent;\n  border: 0;\n  color: #ffffff;\n  font-size: 1.25em;\n  font-weight: bold;\n  width: 100%;\n}\n.Switcher_input__A0SWC:focus {\n  background-color: #ffffff;\n  color: rgb(36.5, 36.5, 36.5);\n}\n.Switcher_input__A0SWC:focus::placeholder {\n  color: rgb(36.5, 36.5, 36.5);\n}\n.Switcher_input__A0SWC::placeholder {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.Switcher_suggestionsContainer__1hDVG {\n  color: #000000;\n}\n\n.Switcher_suggestionsList__nF5PB {\n  list-style: none;\n  padding-left: 0;\n  font-size: 1.25em;\n  font-weight: bold;\n  line-height: 1.5;\n}\n\n.Switcher_empty__21Kez {\n  text-align: center;\n  color: rgb(36.5, 36.5, 36.5);\n}\n\n@media screen and (max-width: 479px) {\n  .Switcher_chevron__ES1KY {\n    display: none;\n  }\n}";
var style$e = {"wrap":"Switcher_wrap__-SDie","overlay":"Switcher_overlay__pMlS2","header":"Switcher_header__KKZHI","body":"Switcher_body__K-yIC","close":"Switcher_close__yo1oV","container":"Switcher_container__cDeE5","orgName":"Switcher_orgName__NutVs","orgNameHeader":"Switcher_orgNameHeader__6ETUf","orgNameHeaderNotSelected":"Switcher_orgNameHeaderNotSelected__amDjW","input":"Switcher_input__A0SWC","suggestionsContainer":"Switcher_suggestionsContainer__1hDVG","suggestionsList":"Switcher_suggestionsList__nF5PB","empty":"Switcher_empty__21Kez","chevron":"Switcher_chevron__ES1KY"};
styleInject(css_248z$h);

function noop() { }
function getSuggestionValue(suggestion) {
    return suggestion.name;
}
/**
 * tricks the autocomplete component from rendering an input field
 * so we can use react-toolbox
 *
 * @returns {string}
 */
function renderInput() {
    return "";
}
function renderSuggestion(suggestion) {
    return React__default$4.createElement(Suggestion, { item: suggestion });
}
/**
 * always returns true so that even if the input value equals ""
 * the list of available orgs will be rendered
 *
 * @returns {boolean}
 */
function shouldRenderSuggestions() {
    return true;
}
const Switcher = ({ items, itemsTotal, value, isLoading, isLoadingItems, search, showItems, onChange, onSearchChange, onValueClick, onShowItemsChange, searchPlaceholder, emptyMessage, placeholder, label, finished }) => {
    const handleChange = useCallback((_, params) => {
        if (params && params.newValue) {
            onSearchChange(params.newValue);
        }
    }, [onSearchChange]);
    const handleCloseClick = useCallback(() => {
        onShowItemsChange(false);
        onSearchChange("");
    }, [onSearchChange, onShowItemsChange]);
    const handleSelectClick = useCallback((_, suggestionData) => {
        onShowItemsChange(false);
        onSearchChange("");
        onChange(suggestionData.suggestion);
    }, [onChange, onSearchChange, onShowItemsChange]);
    const toggleShowSwitcher = useCallback(() => {
        onShowItemsChange(!showItems);
    }, [showItems, onShowItemsChange]);
    const handleSuggestionsClearRequested = useCallback(() => {
        onSearchChange("");
    }, [onSearchChange]);
    function renderSuggestions() {
        if (finished === 0) {
            return renderEmptyState();
        }
        if (!finished) {
            return React__default$4.createElement(LoadingSpinner, null);
        }
        const inputProps = {
            onChange: handleChange,
            placeholder: searchPlaceholder,
            value: search,
        };
        return (React__default$4.createElement(dist, { alwaysRenderSuggestions: true, focusInputOnSuggestionClick: false, getSuggestionValue: getSuggestionValue, inputProps: inputProps, onSuggestionSelected: handleSelectClick, onSuggestionsFetchRequested: noop, onSuggestionsClearRequested: handleSuggestionsClearRequested, renderInputComponent: renderInput, renderSuggestion: renderSuggestion, shouldRenderSuggestions: shouldRenderSuggestions, suggestions: items, theme: style$e }));
    }
    function renderEmptyState() {
        return (React__default$4.createElement("div", { className: style$e.empty },
            React__default$4.createElement("h2", null,
                emptyMessage,
                " ",
                React__default$4.createElement("strong", null,
                    "\"",
                    search,
                    "\"")),
            React__default$4.createElement("p", null, "Please try a different search")));
    }
    if (!showItems && isLoading) {
        return React__default$4.createElement(LoadingProgressBar, null);
    }
    const classNames = classNames$1(style$e.orgNameHeader, {
        [style$e.orgNameHeaderNotSelected]: (value === null || value === void 0 ? void 0 : value.name) ? false : true,
    });
    return (React__default$4.createElement("div", { className: style$e.wrap },
        React__default$4.createElement("div", { className: style$e.orgName }, !!value ? (React__default$4.createElement(React__default$4.Fragment, null,
            React__default$4.createElement("p", { onClick: () => onValueClick(value), className: classNames, role: "button", id: "root-btn" }, (value === null || value === void 0 ? void 0 : value.name) || placeholder),
            (!value || items.length > 1 || (typeof itemsTotal === "number" && itemsTotal > 1)) && (React__default$4.createElement(IconButton_1$1, { className: style$e.chevron, icon: "keyboard_arrow_down", onClick: toggleShowSwitcher, theme: buttonTheme })))) : React__default$4.createElement(React__default$4.Fragment, null)),
        showItems ? (React__default$4.createElement("div", { className: style$e.overlay },
            React__default$4.createElement("div", { className: style$e.header },
                React__default$4.createElement(Input_1, { label: label, value: search, onChange: onSearchChange }),
                React__default$4.createElement(IconButton_1$1, { onClick: handleCloseClick, className: style$e.close, icon: "close", accent: true })),
            React__default$4.createElement("div", { className: style$e.body }, isLoadingItems ? React__default$4.createElement(LoadingSpinner, null) : renderSuggestions()))) : React__default$4.createElement(React__default$4.Fragment, null)));
};

var css_248z$g = ".style_wrap__jZAM0 table {\n  width: 100%;\n}\n.style_wrap__jZAM0 .rmwc-data-table__cell {\n  vertical-align: top;\n}\n.style_wrap__jZAM0 .rmwc-data-table {\n  width: 100%;\n}\n\n.style_row__kJC9B:nth-of-type(even) .rmwc-data-table__cell {\n  background-color: #ebebeb;\n}\n\n.style_rowPrioritize__u07vh .rmwc-data-table__cell {\n  background-color: #f07580;\n}\n\n.style_cell__sZlQz {\n  vertical-align: top;\n}";
var style$d = {"wrap":"style_wrap__jZAM0","row":"style_row__kJC9B","rowPrioritize":"style_rowPrioritize__u07vh","cell":"style_cell__sZlQz"};
styleInject(css_248z$g);

const Cell = (props) => {
    var _a, _b;
    const { cellContent, search } = props;
    const cellContentKey = cellContent;
    const filterValue = (_b = (_a = cellContentKey === null || cellContentKey === void 0 ? void 0 : cellContentKey.props) === null || _a === void 0 ? void 0 : _a.event) === null || _b === void 0 ? void 0 : _b.rawQuery;
    return (React__default$4.createElement(TableCell$1, { className: style$d.cell },
        cellContent,
        (cellContentKey.key === 'raw_query' && typeof search === "function") &&
            React__default$4.createElement("a", { href: `#filter=${filterValue}`, onClick: () => search && search(filterValue) },
                React__default$4.createElement("span", null, "Filter By Similar Query"))));
};

const RowInner = (props) => {
    const { cells, prioritize, search } = props, rowProps = __rest$2(props, ["cells", "prioritize", "search"]);
    return (React__default$4.createElement(TableRow$1, Object.assign({ className: `${prioritize ? style$d.rowPrioritize : style$d.row}` }, rowProps), cells.map((cellData, i) => {
        return React__default$4.createElement(Cell, Object.assign({ key: i }, cellData, { search: search }));
    })));
};
const Row = React__default$4.memo(RowInner);

var OrderByType;
(function (OrderByType) {
    OrderByType["DATE_DESC"] = "DATE_DESC";
    OrderByType["DATE_ASC"] = "DATE_ASC";
    OrderByType["NAME_DESC"] = "NAME_DESC";
    OrderByType["NAME_ASC"] = "NAME_ASC";
})(OrderByType || (OrderByType = {}));
/**
 * Generalized Table Component
 */
const XappTable = ({ dataColumns, dataRows, sortValue, children, search, onSortClick, loading }) => {
    const [currentSortValue, setCurrentSortValue] = useState(sortValue);
    useEffect(() => {
        if (onSortClick && currentSortValue !== undefined) {
            onSortClick(currentSortValue);
        }
    }, [currentSortValue, onSortClick]);
    const handleMenuItemClick = (column) => {
        switch (column) {
            case "Last modified":
                if (currentSortValue === OrderByType.DATE_ASC) {
                    setCurrentSortValue(OrderByType.DATE_DESC);
                }
                else {
                    setCurrentSortValue(OrderByType.DATE_ASC);
                }
                break;
            case "App Name":
                if (currentSortValue === OrderByType.NAME_ASC) {
                    setCurrentSortValue(OrderByType.NAME_DESC);
                }
                else {
                    setCurrentSortValue(OrderByType.NAME_ASC);
                }
                break;
            default:
                setCurrentSortValue(OrderByType.DATE_DESC);
        }
    };
    const trs = useMemo(() => {
        return dataRows === null || dataRows === void 0 ? void 0 : dataRows.map((row) => {
            var _a;
            let prioritize = false;
            if (row.cells.length > 0) {
                const content = row.cells[0].cellContent;
                const rowNotes = (_a = content === null || content === void 0 ? void 0 : content.props) === null || _a === void 0 ? void 0 : _a.notes;
                prioritize = rowNotes === null || rowNotes === void 0 ? void 0 : rowNotes.toLowerCase().includes("prioritize");
            }
            return React__default$4.createElement(Row, { key: row.key, cells: row.cells, search: search, prioritize: prioritize });
        });
    }, [dataRows, search]);
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement(TableContainer$1, { className: style$d.wrap },
            React__default$4.createElement(Table$1, null,
                React__default$4.createElement(TableHead$1, null,
                    React__default$4.createElement(TableRow$1, null, dataColumns === null || dataColumns === void 0 ? void 0 : dataColumns.map((column, i) => {
                        const { label, id } = column;
                        return (React__default$4.createElement(TableCell$1, { key: id, style: { color: "rgba(0, 0, 0, .54)", fontSize: "12px" } },
                            React__default$4.createElement("div", { style: { display: "flex", alignItems: "center" } },
                                column.children ? column.children : label,
                                (label === "Last modified") && (React__default$4.createElement(IconButton, { iconName: currentSortValue === OrderByType.DATE_ASC ? `arrow_upward` : `arrow_downward`, onClick: () => handleMenuItemClick(label) })),
                                (label === "App Name") && (React__default$4.createElement(IconButton, { iconName: currentSortValue === OrderByType.NAME_ASC ? `arrow_upward` : `arrow_downward`, onClick: () => handleMenuItemClick(label) }))),
                            column.label === "Match Confidence" && (children)));
                    }))),
                React__default$4.createElement(TableBody$1, null, !loading && trs))),
        loading && React__default$4.createElement(LoadingSpinner, null)));
};

const TabPanel = (props) => {
    const { children, value, index } = props, other = __rest$2(props, ["children", "value", "index"]);
    return (React__default$4.createElement("div", Object.assign({ role: "tabpanel", hidden: value !== index, id: `simple-tabpanel-${index}`, "aria-labelledby": `simple-tab-${index}` }, other), value === index && (React__default$4.createElement(Box, { sx: { p: 3 } },
        React__default$4.createElement(Typography, null, children)))));
};

var css_248z$f = ".SideTabs_container__W8pxw {\n  display: flex;\n  height: 100%;\n  width: 100%;\n}\n\n.SideTabs_sideMenu__e0fhb {\n  width: 60px;\n  background-color: #333;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: space-between;\n  padding-top: 10px;\n  transition: width 0.3s;\n  position: relative;\n}\n\n.SideTabs_expanded__hb8pq {\n  width: 200px;\n}\n\n.SideTabs_tabList__6FSmV {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n\n.SideTabs_tabItem__cgd6g {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.SideTabs_tabItem__cgd6g:hover {\n  background-color: #555;\n}\n\n.SideTabs_tabItem__cgd6g.SideTabs_active__ecDlP {\n  background-color: #555;\n}\n\n.SideTabs_icon__VUkG1 {\n  display: inline-block;\n  width: 40px;\n  text-align: center;\n}\n\n.SideTabs_text__jv6vL {\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.SideTabs_content__Jtc5u {\n  flex-grow: 1;\n  padding: 20px;\n  background-color: #ffffff;\n  overflow-y: auto;\n  position: relative;\n}\n\n.SideTabs_toggleButton__WO3Bc {\n  background-color: #444;\n  border: none;\n  color: white;\n  padding: 10px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.SideTabs_toggleButton__WO3Bc:hover {\n  background-color: #555;\n}";
var styles$1 = {"container":"SideTabs_container__W8pxw","sideMenu":"SideTabs_sideMenu__e0fhb","expanded":"SideTabs_expanded__hb8pq","tabList":"SideTabs_tabList__6FSmV","tabItem":"SideTabs_tabItem__cgd6g","active":"SideTabs_active__ecDlP","icon":"SideTabs_icon__VUkG1","text":"SideTabs_text__jv6vL","content":"SideTabs_content__Jtc5u","toggleButton":"SideTabs_toggleButton__WO3Bc"};
styleInject(css_248z$f);

/**
 * A side tabs component that changes content based on the selected tab
 *
 * @param {SideTabsProps} props - The props for the SideTabs component
 * @returns {JSX.Element} The SideTabs component
 */
const SideTabs = ({ tabs, onTabSelected, noActiveTabContent }) => {
    const [expanded, setExpanded] = useState(false);
    const toggleExpand = () => {
        setExpanded(!expanded);
    };
    const handleTabSelected = (index) => {
        if (onTabSelected && typeof onTabSelected === 'function') {
            onTabSelected(index);
        }
    };
    const activeTabIndex = tabs.findIndex(tab => tab.active);
    return (React__default$4.createElement("div", { className: styles$1.container },
        React__default$4.createElement("div", { className: `${styles$1.sideMenu} ${expanded ? styles$1.expanded : ''}` },
            React__default$4.createElement("ul", { className: styles$1.tabList }, tabs.map((tab, index) => {
                if (tab.hidden) {
                    return React__default$4.createElement(React__default$4.Fragment, null);
                }
                return (React__default$4.createElement("li", { key: index, className: `${styles$1.tabItem} ${tab.active ? styles$1.active : ''}`, onClick: () => handleTabSelected(index) },
                    React__default$4.createElement("span", { className: styles$1.icon }, tab.icon),
                    expanded && React__default$4.createElement("span", { className: styles$1.text }, tab.text)));
            })),
            React__default$4.createElement("button", { className: styles$1.toggleButton, onClick: toggleExpand }, expanded ? React__default$4.createElement(Icon$1, { iconName: 'arrow_back' }) : React__default$4.createElement(Icon$1, { iconName: 'arrow_forward' }))),
        React__default$4.createElement("div", { className: styles$1.content }, activeTabIndex >= 0 ? tabs[activeTabIndex].content : (noActiveTabContent || React__default$4.createElement("p", null, "Please select a menu item")))));
};

var css_248z$e = ".style_termsContainer__UTTyX {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.style_termsContainer__UTTyX label {\n  padding: 10px;\n}\n.style_termsContainer__UTTyX button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.style_termsContent__asLBD {\n  flex-grow: 1;\n  overflow-y: auto;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  padding: 10px;\n  max-height: 400px;\n}\n\n.style_scrollMessage__0EnBW {\n  color: red;\n  font-size: 12px;\n  margin-top: 5px;\n}";
var styles = {"termsContainer":"style_termsContainer__UTTyX","termsContent":"style_termsContent__asLBD","scrollMessage":"style_scrollMessage__0EnBW"};
styleInject(css_248z$e);

/**
 * Simple terms of service accepter.
 *
 * @note Written by ChatGPT
 */
const TermsOfService = ({ terms, onAccept }) => {
    const [accepted, setAccepted] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [requiresScroll, setRequiresScroll] = useState(false);
    const termsRef = useRef(null);
    const handleCheckboxChange = () => {
        setAccepted(!accepted);
    };
    const checkScroll = useCallback(() => {
        const element = termsRef.current;
        if (element) {
            setRequiresScroll(element.scrollHeight > element.clientHeight);
            // Only update scrolled state if it hasn't been triggered before
            if (!scrolled) {
                const scrollPosition = element.scrollTop + element.clientHeight;
                const scrollThreshold = element.scrollHeight * 0.75; // 75% of the scroll height
                const isScrolledEnough = scrollPosition >= scrollThreshold;
                setScrolled(isScrolledEnough);
            }
        }
    }, [scrolled]);
    const handleAcceptance = () => {
        if (!scrolled) {
            alert('Please read the entire Terms of Service before accepting.');
            return;
        }
        if (accepted) {
            onAccept();
        }
        else {
            alert('You must accept the terms and conditions to proceed.');
        }
    };
    useEffect(() => {
        checkScroll(); // Check scroll state on component mount or terms update
    }, [checkScroll, terms]);
    return (React__default$4.createElement("div", { className: styles.termsContainer },
        React__default$4.createElement("h3", null, "Terms of Service"),
        React__default$4.createElement("p", null, "Next, please read and accept our terms of service."),
        React__default$4.createElement("div", { className: styles.termsContent, ref: termsRef, onScroll: checkScroll, dangerouslySetInnerHTML: { __html: terms } }),
        React__default$4.createElement("label", null,
            React__default$4.createElement("input", { type: "checkbox", checked: accepted, onChange: handleCheckboxChange }),
            "I accept the Terms of Service"),
        React__default$4.createElement(Button, { onClick: handleAcceptance, disabled: !accepted || !scrolled, label: "Accept" }),
        accepted && requiresScroll && !scrolled && React__default$4.createElement("p", { className: styles.scrollMessage }, "You must scroll through the entire agreement to accept.")));
};

var css_248z$d = ".TextEditor_editorWrapper__-g-G8 {\n  min-height: 6em;\n  max-height: 100%;\n  overflow: auto;\n}";
var style$c = {"editorWrapper":"TextEditor_editorWrapper__-g-G8"};
styleInject(css_248z$d);

const TextEditor = props => {
    var _a;
    const defaultText = (_a = props.defaultText) !== null && _a !== void 0 ? _a : "";
    const [editorState, setEditorState] = useState(createEditorState(defaultText));
    useEffect(() => {
        setEditorState(createEditorState(defaultText));
    }, [defaultText]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const editor = React__default$4.useRef(null);
    const focusEditor = useCallback(() => {
        if (editor && editor.current) {
            editor.current.focus();
        }
    }, [editor]);
    const handleKeyCommand = useCallback((command, editorState) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            setEditorState(newState);
            return "handled";
        }
        return "not-handled";
    }, []);
    function handleEditorChange(editorState) {
        const content = editorState.getCurrentContent();
        const text = content.getPlainText();
        // We call this right here instead of the setState callback
        // so that when the new props come in, they still equal
        // the old in getDerivedStateFromProps
        props.onChange(text);
        setEditorState(editorState);
    }
    return (React__default$4.createElement("div", { className: style$c.editorWrapper, onClick: focusEditor },
        React__default$4.createElement(Editor$5, { ref: editor, editorState: editorState, handleKeyCommand: handleKeyCommand, onChange: handleEditorChange, readOnly: props.disabled })));
};
function createEditorState(value) {
    const block = new ContentBlock({ key: genKey(), text: value, type: "unstyled", depth: 0 });
    const content = ContentState.createFromBlockArray([block]);
    return EditorState.createWithContent(content);
}

var css_248z$c = ".style_wrapper__DLVbK {\n  width: 100%;\n  position: relative;\n  vertical-align: middle;\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n}\n\n.style_hover__iyPW6:hover .style_iconMenu__1v9Tj {\n  display: block;\n}\n\n.style_iconMenu__1v9Tj {\n  display: none;\n  position: absolute;\n  height: 100%;\n  top: 0;\n  right: 0;\n  background-color: rgba(22.7073170732, 55.1463414634, 110.2926829268, 0.9);\n}\n.style_iconMenu__1v9Tj .style_iconMenuItemsWrapper__645Yb {\n  display: flex;\n  align-items: center;\n  align-content: flex-end;\n  justify-content: center;\n  height: 100%;\n}\n.style_iconMenu__1v9Tj .style_iconMenuItemsWrapper__645Yb .style_iconMenuItem__Cc-bT {\n  padding: 6px;\n  align-self: center;\n  margin: auto;\n}\n\n.style_list__x3yj3 {\n  color: #000000;\n  list-style: none;\n  overflow: hidden;\n  transition: max-height 0.5s ease-in;\n  font-family: Roboto, sans-serif;\n}\n.style_list__x3yj3 > [class*=listItem]:nth-child(even) {\n  vertical-align: middle;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.style_list__x3yj3 > [class*=listItem]:nth-child(odd) {\n  background-color: rgb(240.5, 240.5, 240.5);\n  vertical-align: middle;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.style_active__OXgZc {\n  max-height: 600px;\n  overflow-y: scroll;\n}\n\n.style_drawer__B9nvY {\n  padding-top: 10px;\n}";
var style$b = {"wrapper":"style_wrapper__DLVbK","hover":"style_hover__iyPW6","iconMenu":"style_iconMenu__1v9Tj","iconMenuItemsWrapper":"style_iconMenuItemsWrapper__645Yb","iconMenuItem":"style_iconMenuItem__Cc-bT","list":"style_list__x3yj3","active":"style_active__OXgZc","drawer":"style_drawer__B9nvY"};
styleInject(css_248z$c);

/**
 * A list specifically designed for viewing and editing text based list items.
 *
 * It has an optional menu component that appears when hovering over each individual list item.
 *
 * @param props
 */
const TextList = (props) => {
    return (React__default$4.createElement("ul", { className: style$b.list, style: props.style }, props.children));
};

/**
 * A menu that is displayed when the user hovers on the list item.
 *
 *
 * @param props
 */
const TextListItemMenu = (props) => {
    const items = React__default$4.Children.map(props.children, (child, index) => {
        return React__default$4.createElement("div", { key: index, className: style$b.iconMenuItem }, child);
    });
    return (React__default$4.createElement("div", { className: style$b.iconMenu },
        React__default$4.createElement("div", { className: style$b.iconMenuItemsWrapper }, items)));
};
/**
 * An individual list item designed for text based lists.
 *
 * @param props
 */
const TextListItem = (props) => {
    return (React__default$4.createElement("li", { className: classNames$1("listItem", style$b.listItem) },
        React__default$4.createElement("span", { className: style$b.hover },
            React__default$4.createElement("div", Object.assign({}, props, { className: classNames$1(style$b.wrapper, props.className) }), props.children))));
};

var css_248z$b = ".style-module_inlineAlert__mWTOL {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: 4px;\n  border-left: 4px solid;\n  margin-bottom: 16px;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.style-module_icon__n4rmS {\n  flex-shrink: 0;\n  font-size: 18px;\n  line-height: 1.4;\n}\n\n.style-module_content__-WSb7 {\n  flex: 1;\n  min-width: 0;\n}\n\n.style-module_title__DzrtY {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.style-module_message__oZ6nh {\n  color: inherit;\n}\n\n.style-module_info__GOvp8 {\n  background-color: rgb(201.3414634146, 235.7317073171, 248.6585365854);\n  border-left-color: #1aa7dc;\n  color: rgb(15.2195121951, 97.756097561, 128.7804878049);\n}\n\n.style-module_warning__N-moH {\n  background-color: rgb(255, 197.7878787879, 159);\n  border-left-color: #FF8939;\n  color: rgb(184.5, 74.5454545455, 0);\n}\n\n.style-module_error__LDY5t {\n  background-color: rgb(249.5, 209.5, 209.5);\n  border-left-color: #e94949;\n  color: rgb(204.75, 24.75, 24.75);\n}\n\n.style-module_success__DpQf1 {\n  background-color: rgb(184.2857142857, 240.7142857143, 196.0714285714);\n  border-left-color: #39d75a;\n  color: rgb(24.2857142857, 120.2142857143, 44.3214285714);\n}";
var style$a = {"inlineAlert":"style-module_inlineAlert__mWTOL","icon":"style-module_icon__n4rmS","content":"style-module_content__-WSb7","title":"style-module_title__DzrtY","message":"style-module_message__oZ6nh","info":"style-module_info__GOvp8","warning":"style-module_warning__N-moH","error":"style-module_error__LDY5t","success":"style-module_success__DpQf1"};
styleInject(css_248z$b);

const SEVERITY_ICONS = {
    info: "ℹ",
    warning: "⚠",
    error: "✕",
    success: "✓"
};
const InlineAlert = ({ severity = "info", title, children, className }) => {
    const classes = [style$a.inlineAlert, style$a[severity], className].filter(Boolean).join(" ");
    return (React__default$4.createElement("div", { className: classes, role: "alert" },
        React__default$4.createElement("span", { className: style$a.icon }, SEVERITY_ICONS[severity]),
        React__default$4.createElement("div", { className: style$a.content },
            title && React__default$4.createElement("strong", { className: style$a.title }, title),
            React__default$4.createElement("div", { className: style$a.message }, children))));
};

var css_248z$a = ".style_wrap__53Zoa {\n  padding: 1em;\n  border-radius: 0.5em;\n  margin-bottom: 1em;\n}\n.style_wrap__53Zoa > *:first-child {\n  margin-top: 0;\n}\n.style_wrap__53Zoa > *:last-child {\n  margin-bottom: 0;\n}\n\n.style_blue__bojsH {\n  background-color: rgb(201.3414634146, 235.7317073171, 248.6585365854);\n}\n\n.style_green__G2kZO {\n  background-color: rgb(163.0714285714, 236.4285714286, 178.3928571429);\n}\n\n.style_orange__VWKFX {\n  background-color: rgb(255, 167.3939393939, 108);\n}\n\n.style_red__i5fMG {\n  background-color: rgb(246.75, 186.75, 186.75);\n}";
var style$9 = {"wrap":"style_wrap__53Zoa","blue":"style_blue__bojsH style_wrap__53Zoa","green":"style_green__G2kZO style_wrap__53Zoa","orange":"style_orange__VWKFX style_wrap__53Zoa","red":"style_red__i5fMG style_wrap__53Zoa"};
styleInject(css_248z$a);

/**
 * A simple wrapper that sets the background color of it's children
 *
 * @param props
 */
const PageAlert = (props) => {
    const wrapperClass = props.background || "blue";
    return React__default$4.createElement("div", { style: props.style, className: style$9[wrapperClass] }, props.children);
};

var css_248z$9 = ".style_button__vaJCO {\n  border-radius: 2px !important;\n  color: #1aa7dc !important;\n  padding: 0 12px !important;\n}\n.style_button__vaJCO:hover {\n  background-color: #eaf7fe !important;\n}";
var style$8 = {"button":"style_button__vaJCO"};
styleInject(css_248z$9);

const ThemeButton = props => {
    return (React__default$4.createElement(node.Button, Object.assign({ className: style$8.button }, props)));
};

var css_248z$8 = ".style_table__Cf-0h {\n  text-size-adjust: 100%;\n}\n\n.style_tableHead__fQWXT {\n  padding-bottom: 3px;\n  white-space: nowrap;\n}\n.style_tableHead__fQWXT th {\n  color: #969595;\n  font-size: 12px;\n  font-weight: 500;\n  height: 48px;\n  line-height: 24px;\n  padding: 0 18px 12px;\n  padding-bottom: 8px;\n  text-align: left;\n  text-overflow: ellipsis;\n  vertical-align: bottom;\n}\n.style_tableHead__fQWXT th:first-of-type {\n  padding-left: 24px;\n}\n.style_tableHead__fQWXT th:last-of-type {\n  padding-right: 24px;\n}\n\n.style_tableRow__OBPlx {\n  height: 48px;\n}\n.style_tableRow__OBPlx td {\n  border-bottom: 1px solid #fefefe;\n  border-top: 1px solid #fefefe;\n  box-sizing: border-box;\n  height: 48px;\n  padding: 12px 18px;\n  vertical-align: middle;\n}\n.style_tableRow__OBPlx td:first-of-type {\n  padding-left: 24px;\n}\n.style_tableRow__OBPlx td:last-of-type {\n  padding-right: 24px;\n}\n.style_tableRow__OBPlx td a {\n  color: #1aa7dc;\n  font-weight: 700;\n  text-decoration: none;\n}\n.style_tableRow__OBPlx td a:visited {\n  color: #1aa7dc;\n}";
var style$7 = {"table":"style_table__Cf-0h","tableHead":"style_tableHead__fQWXT","tableRow":"style_tableRow__OBPlx"};
styleInject(css_248z$8);

const Table = props => {
    return (React__default$4.createElement(node.Table, Object.assign({ className: style$7.table }, props)));
};

const TableBody = props => {
    return (React__default$4.createElement(node.TableBody, Object.assign({}, props)));
};

const TableCell = props => {
    return (React__default$4.createElement(node.TableCell, Object.assign({}, props)));
};

const TableContainer = props => {
    return (React__default$4.createElement(node.TableContainer, Object.assign({}, props)));
};

const TableHead = props => {
    return (React__default$4.createElement(node.TableHead, Object.assign({ className: style$7.tableHead }, props)));
};

const TableRow = props => {
    return (React__default$4.createElement(node.TableRow, Object.assign({ className: style$7.tableRow }, props)));
};

const ThemeInput = props => {
    return (React__default$4.createElement(node.Input, Object.assign({}, props)));
};

const InputAdornment = props => {
    return (React__default$4.createElement(node.InputAdornment, Object.assign({}, props)));
};

const InputBase = props => {
    return (React__default$4.createElement(node.InputBase, Object.assign({}, props)));
};

const InputLabel = props => {
    return (React__default$4.createElement(node.InputLabel, Object.assign({}, props)));
};

var css_248z$7 = ".style_textField__1JpXH {\n  margin-bottom: 20px !important;\n}";
var style$6 = {"textField":"style_textField__1JpXH"};
styleInject(css_248z$7);

const TextField = props => {
    return (React__default$4.createElement(node.TextField, Object.assign({ className: style$6.textField }, props)));
};

const IconMenuItem = (props) => {
    return (React__default$4.createElement(node.MenuItem, Object.assign({}, props),
        props.icon && React__default$4.createElement(node.Icon, null, props.icon),
        props.caption && React__default$4.createElement(node.ListItemText, null, props.caption)));
};

const IconMenu = (props) => {
    const { icon, vertical, horizontal } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = useMemo(() => Boolean(anchorEl), [anchorEl]);
    function handleOpenMenu(e) {
        setAnchorEl(e.currentTarget);
    }
    function handleCloseMenu() {
        setAnchorEl(null);
    }
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement(node.Button, { id: "positioned-button", "aria-controls": isOpen ? "positioned-menu" : undefined, "aria-haspopup": "true", "aria-expanded": isOpen ? "true" : undefined, onClick: handleOpenMenu, sx: {
                color: "#212121",
                height: "36px",
                width: "36px",
                minWidth: "36px",
                maxWidth: "36px",
                padding: "0px",
                borderRadius: "50%"
            } },
            React__default$4.createElement(node.Icon, { fontSize: "small" }, icon)),
        React__default$4.createElement(node.Menu, Object.assign({}, props, { id: "positioned-menu", "aria-labelledby": "positioned-button", anchorEl: anchorEl, anchorOrigin: {
                vertical: vertical || "top",
                horizontal: horizontal || "left",
            }, transformOrigin: {
                vertical: vertical || "top",
                horizontal: horizontal || "left",
            }, open: isOpen, onClick: handleCloseMenu, onClose: handleCloseMenu }))));
};

const WistiaVideo = ({ videoId, autoplay = false, muted = false }) => {
    useEffect(() => {
        // Function to dynamically load Wistia scripts
        const loadWistiaScript = (src) => {
            const script = document.createElement("script");
            script.src = src;
            script.async = true;
            document.body.appendChild(script);
        };
        loadWistiaScript(`https://fast.wistia.com/embed/medias/${videoId}.jsonp`);
        loadWistiaScript("https://fast.wistia.com/assets/external/E-v1.js");
    }, [videoId]);
    return (React__default$4.createElement("div", { className: "wistia_responsive_padding", style: { padding: "56.25% 0 0 0", position: "relative" } },
        React__default$4.createElement("div", { className: "wistia_responsive_wrapper", style: { height: "100%", left: 0, position: "absolute", top: 0, width: "100%" } },
            React__default$4.createElement("div", { className: `wistia_embed wistia_async_${videoId} seo=true videoFoam=true${autoplay ? ' autoPlay=true' : ''}${muted ? ' volume=0' : ''}`, style: { height: "100%", position: "relative", width: "100%" } },
                React__default$4.createElement("div", { className: "wistia_swatch", style: {
                        height: "100%",
                        left: 0,
                        opacity: 0,
                        overflow: "hidden",
                        position: "absolute",
                        top: 0,
                        transition: "opacity 200ms",
                        width: "100%",
                    } },
                    React__default$4.createElement("img", { src: `https://fast.wistia.com/embed/medias/${videoId}/swatch`, style: { filter: "blur(5px)", height: "100%", objectFit: "contain", width: "100%" }, alt: "", "aria-hidden": "true", onLoad: (e) => {
                            const parent = e.currentTarget.parentNode;
                            if (parent && "style" in parent) {
                                parent.style.opacity = "1";
                            }
                        } }))))));
};

var css_248z$6 = ".style_wrapper__HjV-p {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  height: 100vh;\n  width: 100vw;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  background-color: #fefefe;\n  font-family: \"PT Sans\", Sans-serif;\n}\n@media screen and (max-width: 1024px) {\n  .style_wrapper__HjV-p {\n    /* Styles specific to tablet screens */\n    padding: 10px;\n    max-width: 100%;\n    max-height: 100%;\n  }\n}\n@media screen and (max-width: 768px) {\n  .style_wrapper__HjV-p {\n    /* Styles specific to mobile and tablet screens */\n    padding: 0px;\n    max-width: 100%;\n    max-height: 100%;\n  }\n}\n.style_wrapper__HjV-p h1, .style_wrapper__HjV-p h2, .style_wrapper__HjV-p h3, .style_wrapper__HjV-p h4 {\n  font-family: \"Overpass\", Arial, Tahoma, sans-serif;\n}\n.style_wrapper__HjV-p .style_onboarding__HGnRz {\n  padding-left: 20px;\n  padding-right: 20px;\n  border-radius: 10px;\n  min-height: 620px;\n  max-height: 100%;\n  min-width: 400px;\n  max-width: 1300px;\n}\n@media screen and (max-width: 768px) {\n  .style_wrapper__HjV-p .style_onboarding__HGnRz {\n    /* Styles specific to mobile and tablet screens */\n    width: 100%;\n    min-width: 100%;\n    height: 100%;\n    min-height: 100%;\n    padding-left: 0px;\n    padding-right: 0px;\n    background-color: #fefefe;\n  }\n}";
var style$5 = {"wrapper":"style_wrapper__HjV-p","onboarding":"style_onboarding__HGnRz"};
styleInject(css_248z$6);

const OnboardingLayout = props => {
    const { widgetKey, className } = props; // <-- Destructure className from props
    // Merge custom class names with existing ones using the 'classnames' library
    const wrapperClasses = classNames$1(style$5.wrapper, className);
    return (React__default$4.createElement(React__default$4.Fragment, null,
        React__default$4.createElement("div", { className: wrapperClasses },
            React__default$4.createElement("div", { className: style$5.onboarding }, props.children)),
        widgetKey ? React__default$4.createElement(ChatWidget, { widgetKey: widgetKey }) : null));
};

var css_248z$5 = ".StandardLayout_layout__Bsvt- {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  padding: 5px 20px 20px 20px;\n  position: relative;\n  flex: 1 1 auto;\n  overflow: auto;\n}\n@media screen and (max-width: 1023px) {\n  .StandardLayout_layout__Bsvt- {\n    padding: 1em 2em;\n  }\n}\n\n.StandardLayout_contentLayout__ffu-X {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--content-background, #fff);\n  padding: 12px 49px;\n  box-sizing: border-box;\n  max-width: 1280px;\n  width: 100%;\n  margin: 0 auto;\n}\n@media screen and (max-width: 479px) {\n  .StandardLayout_contentLayout__ffu-X {\n    padding: 12px;\n  }\n}\n\n.StandardLayout_content__2WZcg {\n  flex: 1 1 auto;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}";
var style$4 = {"layout":"StandardLayout_layout__Bsvt-","contentLayout":"StandardLayout_contentLayout__ffu-X","content":"StandardLayout_content__2WZcg"};
styleInject(css_248z$5);

/**
 * Simple full page layout
 *
 * @param props
 */
const StandardLayout = props => {
    return React__default$4.createElement("div", { className: style$4.layout },
        React__default$4.createElement("div", { className: style$4.contentLayout },
            React__default$4.createElement("div", { className: style$4.content }, props.children)));
};

var css_248z$4 = ".style_wrapper__bS3kY {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100vw;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  background-color: #bfbfbf;\n}\n.style_wrapper__bS3kY .style_onboarding__asOLR {\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 20px;\n}";
var style$3 = {"wrapper":"style_wrapper__bS3kY","onboarding":"style_onboarding__asOLR"};
styleInject(css_248z$4);

/**
 * Simple layout for redirecting to an external site, such as the login.
 *
 * @param props
 * @returns
 */
const RedirectingLayout = props => {
    return (React__default$4.createElement("div", { className: style$3.wrapper },
        React__default$4.createElement("div", { className: style$3.onboarding }, props.children)));
};

var css_248z$3 = ".style_question__-fWzU {\n  vertical-align: middle;\n  padding-left: 5px;\n  padding-right: 5px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.style_question__-fWzU [contenteditable]:focus {\n  outline: 0 solid transparent;\n}\n\n.style_button__Zh3Uy {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n}";
var style$2 = {"question":"style_question__-fWzU","button":"style_button__Zh3Uy"};
styleInject(css_248z$3);

const SuggestionsDialog = ({ active, data, title, onAddSuggestions, onDismiss, fetching, }) => {
    const [cleanSuggestions, setCleanSuggestions] = useState([]);
    useEffect(() => {
        const cleaned = (data || []).map((val) => {
            const item = (val === null || val === void 0 ? void 0 : val.utterance) || (val === null || val === void 0 ? void 0 : val.question) || (val === null || val === void 0 ? void 0 : val.suggestion);
            const suggestion = item ? item.trim() : "UNKNOWN";
            return suggestion;
        }, []);
        const filtered = cleaned.filter((val) => {
            return !!val;
        });
        setCleanSuggestions([...filtered]);
    }, [data]);
    const handleEditSuggestion = useCallback((index, newValue) => {
        const newSuggestions = cleanSuggestions.map((existingValue, existingIndex) => {
            if (existingIndex === index) {
                return newValue;
            }
            else {
                return existingValue;
            }
        });
        setCleanSuggestions(newSuggestions);
    }, [cleanSuggestions, setCleanSuggestions]);
    const handleDeleteSuggestion = useCallback((index) => {
        const newSuggestions = cleanSuggestions.filter((value, existingIndex) => {
            return index !== existingIndex;
        });
        if (newSuggestions.length === 0) {
            onDismiss();
        }
        else {
            setCleanSuggestions(newSuggestions);
        }
    }, [cleanSuggestions, onDismiss]);
    const handleAddSuggestion = useCallback((index, value) => {
        // call the callback
        onAddSuggestions([value]);
        // remove it
        handleDeleteSuggestion(index);
    }, [onAddSuggestions, handleDeleteSuggestion]);
    const handleAddAllSuggestions = useCallback(() => {
        onAddSuggestions(cleanSuggestions);
        onDismiss();
    }, [cleanSuggestions, onAddSuggestions, onDismiss]);
    return (React__default$4.createElement(Dialog$1, { open: active, maxWidth: "md", onClose: onDismiss, fullWidth: true },
        React__default$4.createElement(DialogTitle, null, title || "Suggestions"),
        React__default$4.createElement(DialogContent, null,
            fetching ? (React__default$4.createElement(LoadingSpinner, { loadingText: `Loading Suggestions...` })) :
                ((cleanSuggestions === null || cleanSuggestions === void 0 ? void 0 : cleanSuggestions.length) === 0 ? (React__default$4.createElement("h3", null, "Suggestions Unavailable")) :
                    (React__default$4.createElement(TextList, { style: { minHeight: "200px" } }, cleanSuggestions.map((suggestion, i) => {
                        return (React__default$4.createElement(TextListItem, { key: i },
                            React__default$4.createElement("div", { className: style$2.question },
                                React__default$4.createElement(ContentEditable, { value: suggestion, onChange: handleEditSuggestion.bind(undefined, i) })),
                            React__default$4.createElement(TextListItemMenu, null,
                                React__default$4.createElement(Tooltip$5, { content: "Add" },
                                    React__default$4.createElement("button", { className: style$2.button, onClick: () => {
                                            handleAddSuggestion(i, suggestion);
                                        } },
                                        React__default$4.createElement(Icon$1, { iconName: "add_circle", sx: { color: colors$1.pink["A200"] } }))),
                                React__default$4.createElement(Tooltip$5, { content: "Remove" },
                                    React__default$4.createElement("button", { className: style$2.button, onClick: () => {
                                            handleDeleteSuggestion(i);
                                        } },
                                        React__default$4.createElement(Icon$1, { iconName: "cancel", sx: { color: colors$1.pink["A200"] } }))))));
                    })))),
            React__default$4.createElement(DialogActions, null,
                React__default$4.createElement(Button, { variation: "flat", disabled: (cleanSuggestions === null || cleanSuggestions === void 0 ? void 0 : cleanSuggestions.length) === 0, label: "Add All", onClick: handleAddAllSuggestions }),
                React__default$4.createElement(Button, { variation: "default", label: "Done", onClick: onDismiss })))));
};

var css_248z$2 = ".style_wrapper__iRhJ5 {\n  display: flex;\n  flex-direction: row-reverse;\n  flex: 1 1 auto;\n  overflow: hidden;\n  flex-wrap: nowrap;\n  height: 100%;\n  min-height: 0;\n  justify-items: stretch;\n}\n\n.style_left__-dQSs,\n.style_right__buOEx {\n  height: 100%;\n  min-height: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n}\n\n.style_left__-dQSs {\n  order: 1;\n  background: var(--content-background, #fff);\n  flex: 0 0 33.333%;\n  padding-top: 0.5em;\n  overflow: auto;\n  min-width: 240px;\n  max-width: 500px;\n}\n@media screen and (max-width: 767px) {\n  .style_left__-dQSs.style_primary__8dRUE {\n    flex: 1 1 100%;\n    max-width: 100%;\n    min-width: 100%;\n  }\n}\n\n.style_right__buOEx {\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n  flex: 1 1 auto;\n  background: var(--body-background, #fefefe);\n  border-left: 1px solid #3e3e3e;\n  padding: 0;\n  overflow: hidden;\n  min-width: 0;\n}\n@media screen and (max-width: 767px) {\n  .style_right__buOEx.style_primary__8dRUE {\n    flex: 1 1 100%;\n    max-width: 100%;\n    border-left: none;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .style_secondary__j1S7g {\n    display: none;\n  }\n}\n\n.style_viewWrap__BcQQb {\n  display: flex;\n  flex-direction: column;\n  background: var(--content-background, #fff);\n  box-sizing: border-box;\n  overflow: hidden;\n  flex: 1 1 auto;\n  height: 100%;\n  min-height: 0;\n}\n\n.style_detailContent__w1LmT {\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  min-height: 0;\n}\n\n.style_padded__jMjfa {\n  padding: 0 1em;\n}\n\n.style_item__uPNmX {\n  border: 2px solid #ffffff;\n}\n.style_item__uPNmX:nth-of-type(even) {\n  background: var(--content-alternative-background, rgb(253.25, 253.25, 253.25));\n  border-color: var(--content-alternative-background, rgb(253.25, 253.25, 253.25));\n}\n\n.style_activeItem__nZ0PH {\n  font-weight: 600;\n  border-color: #1aa7dc;\n}\n.style_activeItem__nZ0PH:nth-of-type(even) {\n  border-color: #1aa7dc;\n}";
var style$1 = {"wrapper":"style_wrapper__iRhJ5","left":"style_left__-dQSs","right":"style_right__buOEx","primary":"style_primary__8dRUE","secondary":"style_secondary__j1S7g","viewWrap":"style_viewWrap__BcQQb","detailContent":"style_detailContent__w1LmT","padded":"style_padded__jMjfa","item":"style_item__uPNmX","activeItem":"style_activeItem__nZ0PH style_item__uPNmX"};
styleInject(css_248z$2);

const Master = props => {
    return props.children;
};
// This is need to make sure we find it when sniffing the children
Master.displayName = `${Master.name}`;
const Detail = (props) => {
    return props.children;
};
// This is need to make sure we find it when sniffing the children
Detail.displayName = `${Detail.name}`;
/**
 * MasterDetail component inspired by {@link Martin Pritchard https://medium.com/@blewpri/react-responsive-master-detail-10b60b739879}
 */
const MasterDetail = (props) => {
    var _a;
    let { detailPath } = props;
    const primary = (_a = props.primary) !== null && _a !== void 0 ? _a : "master";
    const { path } = useRouteMatch();
    let master = undefined;
    let detail = undefined;
    React__default$4.Children.forEach(props.children, child => {
        if (typeof child.type === "function") {
            if (child.type.name === "Master") {
                master = child;
            }
            else if (child.type.name === "Detail") {
                detail = child;
            }
        }
    });
    if (!master) {
        throw new TypeError("Could not find child <Master /> in <MasterDetail />");
    }
    if (!detail) {
        throw new TypeError("Could not find child <Detail /> in <MasterDetail />");
    }
    // Clean the detail path if it starts with a /
    if (detailPath && detailPath.startsWith("/")) {
        detailPath = detailPath.substr(1);
    }
    return (React__default$4.createElement("section", { className: style$1.wrapper },
        React__default$4.createElement("section", { className: style$1.left + " " + (primary === "master" ? style$1.primary : style$1.secondary) },
            React__default$4.createElement(Route, { path: `${path}` }, master)),
        React__default$4.createElement("section", { className: style$1.right + " " + (primary === "detail" ? style$1.primary : style$1.secondary) },
            React__default$4.createElement("div", { className: style$1.viewWrap },
                React__default$4.createElement("div", { className: style$1.detailContent },
                    React__default$4.createElement(Switch$4, null,
                        React__default$4.createElement(Route, { exact: true, path: `${path}` }, detail),
                        React__default$4.createElement(Route, { path: `${path}/${detailPath}` }, detail)))))));
};

var css_248z$1 = ".MasterDetailSearch-module_input__96VqS {\n  margin-top: 0px;\n  padding-top: 0px;\n  padding-bottom: 10px;\n}\n\n.MasterDetailSearch-module_hint__XppIp {\n  top: 10px;\n}";
var compact = {"input":"MasterDetailSearch-module_input__96VqS","hint":"MasterDetailSearch-module_hint__XppIp"};
styleInject(css_248z$1);

const MasterDetailSearch = (props) => {
    const { placeholder, tooltip } = props, rest = __rest$2(props, ["placeholder", "tooltip"]);
    const inputProps = Object.assign({ placeholder: placeholder || "search", className: compact.input }, rest);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore string | number drives me crazy
    return tooltip ? React__default$4.createElement(Tooltip$5, { content: tooltip },
        React__default$4.createElement(Input$3, Object.assign({}, inputProps))) : React__default$4.createElement(Input$3, Object.assign({}, inputProps));
};

var css_248z = ".MasterTitleHeader_padded__sBxnI {\n  padding: 0 1em;\n}\n\n.MasterTitleHeader_itemnogrow__87MlO {\n  flex-grow: 0;\n}";
var style = {"padded":"MasterTitleHeader_padded__sBxnI","itemnogrow":"MasterTitleHeader_itemnogrow__87MlO"};
styleInject(css_248z);

const MasterTitleHeader = props => {
    return (React__default$4.createElement("header", { className: style.itemnogrow + " " + style.padded },
        React__default$4.createElement(TitleHeader, { value: props.value }, props.children)));
};

const SCOPE_DOMAIN = window.location.host.replace(/^([a-z0-9-]+)\./i, "");
const AUTH_TOKEN_KEY = `${SCOPE_DOMAIN}.bearerToken`;

// import { AUTH_ORIGIN } from "./auth-config";
// import { getAuthIFrame } from "./auth-frame-ref";
// Temporarily disabling as /sso isn't working right now and it loads a WSS connection
function sendToAuth(cmd) {
    return __awaiter$2(this, void 0, void 0, function* () {
        /*const frame = await getAuthIFrame();
         if (frame) {
             const wnd = frame.contentWindow;
             if (wnd) {
                 wnd.postMessage(JSON.stringify(cmd), AUTH_ORIGIN);
             }
         }*/
    });
}
function getAuthLocalStorage(key) {
    return __awaiter$2(this, void 0, void 0, function* () {
        sendToAuth();
    });
}
function setAuthLocalStorage(key, value) {
    return __awaiter$2(this, void 0, void 0, function* () {
        sendToAuth();
    });
}
function subscribeToAuthLocalStorage(key, handler) {
    getAuthLocalStorage();
    const msgHandler = (ev) => {
        try {
            const msg = JSON.parse(ev.data);
            if (msg.type === "local-storage-value" && msg.key === key) {
                handler(msg.value);
            }
        }
        catch (_a) {
        }
    };
    window.addEventListener("message", msgHandler);
    return () => {
        window.removeEventListener("message", msgHandler);
    };
}

const useIsMounted = () => {
    const ref = useRef(false);
    useEffect(() => {
        ref.current = true;
        return () => {
            ref.current = false;
        };
    }, []);
    return useCallback(() => ref.current, []);
};

const cache = {};
function useGlobalStorageString(key) {
    const cached = cache[key];
    const [globalState, setGlobalState] = useState({
        fetching: !cache.hasOwnProperty(key),
        value: cached
    });
    const isMounted = useIsMounted();
    useEffect(() => {
        return subscribeToAuthLocalStorage(key, value => {
            if (isMounted()) {
                setGlobalState(st => (Object.assign(Object.assign({}, st), { value, fetching: false })));
            }
            cache[key] = value;
        });
    }, [key, isMounted]);
    const setState = useCallback((value) => {
        setAuthLocalStorage();
        cache[key] = value;
    }, [key]);
    return useMemo(() => [
        globalState,
        setState,
    ], [setState, globalState]);
}
function tryParseJson(val) {
    if (!val) {
        return undefined;
    }
    try {
        return JSON.parse(val);
    }
    catch (_a) {
        return undefined;
    }
}
function useGlobalStorageJson(key) {
    const state = useGlobalStorageString(key);
    return useMemo(() => ([Object.assign(Object.assign({}, state[0]), { value: tryParseJson(state[0].value) }), newVal => state[1](newVal ? JSON.stringify(newVal) : undefined)]), [state]);
}

function useAuthToken() {
    return useGlobalStorageJson(AUTH_TOKEN_KEY);
}

export { Accordion, AddTextInput, AddressView, Alert, AlexaAppIcon, AlexaIcon, Card$1 as AppCard, AutoCompleteSuggestionsInput, Avatar$4 as Avatar, Breadcrumbs, Button, Card, CardActions, CardText, CardTitle, Carousel$1 as Carousel, ChatWidget, Checkbox, CheckmarkIcon, Chips, CircularProgress, ColorPicker, ColorSlider, ConditionCodeEditor, ConditionEditor, ContentEditable, Dashboard, DashboardRow, DatePicker, Detail, Dialog, DialogActions, DialogContent, Divider, DonutChart, Dropdown, EmailInput, Empty, ErrorIcon, ExpandableSearchBar, Expander, FeatureList, FeedbackCard, Field, FieldCheckbox, FieldDropdown, FieldInput, FieldTextArea, FilterChips, FireworksBackground, FireworksCanvas, Form, GMap, GoogleBusinessProfile, GoogleBusinessProfileContainer, Header, HorizontalBarChart, Icon$1 as Icon, IconButton, IconMenu, IconMenuItem, InitialIcon, InlineAlert, Input$3 as Input, InputAction, InputAdornment, InputBase, InputLabel, JSONEditor, JSONEditorDialog, LEAD_SOURCE_LABELS, LanguagePicker, LeadDetail, Link, LoadingProgressBar, LoadingSpinner, LoadingTrainer, LoginForm, LoginScreen, Master, MasterDetail, MasterDetailSearch, MasterTitleHeader, MenuBar, MenuBarItem, Metric, MockBrowserForm, MultiSelectCard, NextBackControl, NotFound, Onboarding, OnboardingAside, OnboardingContent, OnboardingLayout, OnboardingStep, OpportunityAlertsTable, PageAlert, PasswordInput, PhoneNumberInput, PlaceList, PlaceListItem, PlaceLoadingSpinner, PlacesAutocomplete, PlacesSearch, PlacesTable, PlacesTypeOne, PlacesTypeTwo, PlacesView, Pricing, PrimaryAlternateControl, ProgressBar, Rating, RedirectingLayout, SearchBar, Select, SideTabs, SimLoadingSpinner, SingleLineCodeEditor, SiteFooter, SiteHeader, SiteHeaderIconButton, SiteHeaderIconLink, SiteHeaderImageLink, SmartDropdown, SmartSelect, Sparkline, StackedBarChart, StandardLayout, StandardSiteHeader, Step, Stepper, Stoplight, SuggestionsDialog, Switch, Switcher, index$e as Tab, TabPanel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, index$d as Tabs, TermsOfService, TextArea, TextEditor, TextField, TextList, TextListItem, TextListItemMenu, ThemeButton, ThemeInput, TitleHeader, Tooltip$5 as Tooltip, URLInput, ViewHeader, WistiaVideo, WordCloud, XappTable, fetchDetails, fetchPlaces, fetchSuggestions, generateTagline, isMobileOrTablet, isMobileOrTabletImpl, isMobileWidth, mapDataToSuggestions, mobileWidthThreshold, onMutation, onResize, size, useAuthToken, useGlobalStorageJson, useGlobalStorageString, useIsMounted, validateEmail, validatePhoneNumber, validateURL };
//# sourceMappingURL=index.es.js.map
